(function () {
    "use strict";

    // override default tooltip settings
    window.UIkit.on('beforeready.uk.dom', function () {
        $.extend(UIkit.components.tooltip.prototype.defaults, {
            animation: true
        });

        $.extend(UIkit.components.dropdown.prototype.defaults, {
            remaintime: 150,
            delay: 50
        });

        (function () {
            var old_show_function = UIkit.components.dropdown.prototype.show;

            UIkit.components.dropdown.prototype.show = function () {

                this.dropdown
                    .css({
                        'min-width': this.dropdown.outerWidth(),
                        'z-index': '999999999'
                    })
                    .addClass('uk-dropdown-active uk-dropdown-shown');

                var show_function = old_show_function.apply(this, arguments);

                return show_function;
            }
        })();

        (function () {
            var old_hide_function = UIkit.components.dropdown.prototype.hide;

            UIkit.components.dropdown.prototype.hide = function () {

                var this_dropdown = this.dropdown;

                this_dropdown
                    .removeClass('uk-dropdown-shown');

                setTimeout(function () {
                    this_dropdown
                        .removeClass('uk-dropdown-active')
                }, 280);

                var hide_function = old_hide_function.apply(this, arguments);

                return hide_function;
            }
        })();
    });


    var app = angular.module('epbxManagerApp', [
        'ui.router',
        'oc.lazyLoad',
        'ngSanitize',
        'ngResource',
        'ngCookies',
        'ngAnimate',
        'ngRetina',
        'ODataResources',
        'pascalprecht.translate',
        'angularUtils.directives.dirPagination',
        'ConsoleLogger',
        'ncy-angular-breadcrumb',
        'angular.filter',
        'betsol.uiRouterStyles'
    ]);

    app.constant('appversion', '9.0.1-UraAvi')
    app.constant('variables', {
        header__main_height: 48,
        easing_swiftOut: [0.4, 0, 0.2, 1],
        bez_easing_swiftOut: $.bez([0.4, 0, 0.2, 1])
    });

    app.config(["$sceDelegateProvider", "$compileProvider", "$httpProvider", "ConfigProvider", "$breadcrumbProvider", "$translateProvider", "$translatePartialLoaderProvider", function ($sceDelegateProvider, $compileProvider, $httpProvider,
        ConfigProvider, $breadcrumbProvider, $translateProvider, $translatePartialLoaderProvider) {
        var Config = ConfigProvider.$get();

        $httpProvider.useApplyAsync(true);
        $httpProvider.useLegacyPromiseExtensions(false);
        // Ativa debugInfo (ng-scope/ng-binding, etc) apenas em desenvolvimento.
        // Em produção, mantém desligado para reduzir uso de memória/CPU em dashboards de longa duração.
        $compileProvider.debugInfoEnabled(Config.isDebug());

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|x-talkfone-client|x-epbxatendimento):/)

        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'http://manager.epbx.com.br/**',
            'x-talkfone-client://**',
            'x-epbxatendimento://**'
        ]);

        $breadcrumbProvider.setOptions({
            prefixStateName: 'main',
            templateUrl: 'app/shared/templates/breadcrumbs.tpl.html'
        });
        
        $translatePartialLoaderProvider.addPart('main', 0);
        $translateProvider.useLoader('$translatePartialLoader', { urlTemplate: '/assets/translation/{lang}/{part}.json' });

        var idiomaConfig = JSON.parse(window.localStorage.getItem('idiomaConfig'));
        let fallbackLanguage = idiomaConfig && idiomaConfig.idiomaPadrao ? idiomaConfig.idiomaPadrao : 'pt';

        $translateProvider
            .registerAvailableLanguageKeys(['pt', 'en', 'es'], {
                'pt_*': 'pt',
                'en_*': 'en',
                'es_*': 'es'
            })
            .useSanitizeValueStrategy('escapeParameters')
            .fallbackLanguage([fallbackLanguage])
            .determinePreferredLanguage();
    }]);

    /* Run Block */
    app.run(["$animate", "$rootScope", "$state", "$stateParams", "$location", "$window", "$timeout", "TranslateService", "PermissaoService", "AuthService", "appversion", "LocalStorageService", function ($animate, $rootScope, $state, $stateParams, $location, $window, $timeout,
        TranslateService, PermissaoService, AuthService, appversion, LocalStorageService) {
        $animate.enabled(true);
        $rootScope.$state = $state;
        $rootScope.$location = $location;
        $rootScope.$stateParams = $stateParams;
        $rootScope.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || $window.innerWidth < 480;

        TranslateService.inicializar();

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            // eslint-disable-next-line no-console
            console.error(error);
            $state.go('error500', {}, {
                location: false,
                reload: true
            });
        });

        $rootScope.$on('$stateNotFound', function stateNotFound() {
            $state.go('error404', {}, {
                location: false
            });
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
            if (toParams.redirLoginUrl) {
                LocalStorageService.setItem("redirLoginUrl", toParams.redirLoginUrl);
            } else {
                LocalStorageService.removeItem("redirLoginUrl");
            }

            $timeout(function () {
                $rootScope.pageLoading = false;
                $($window).resize();

                $("html, body").animate({
                    scrollTop: 0
                }, 200);
            }, 300);

            $timeout(function () {
                $rootScope.pageLoaded = true;
                altair_uikit.reinitialize_grid_margin();
            }, 600);
        });

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

            if (toState.name.toLowerCase() === "filavirtual") {
                $state.go(toState.name, toParams, {
                    notify: false
                }).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
                return;
            }

            if (toState.name.toLowerCase() === "esqueciminhasenha") {
                $state.go(toState.name, toParams, {
                    notify: false
                }).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
                return;
            }
            
            if (toState.name.toLowerCase() === "alterarsenha") {
                $state.go(toState.name, toParams, {
                    notify: false
                }).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
                return;
            }

            if (toState.name.toLowerCase() === "downloaddialogo") {
                $state.go(toState.name, toParams, {
                    notify: false
                }).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
                return;
            }

            // o angular chama o evento $stateChangeStart em loop quando usamos o event.preventDefault() e a url  http://localhost:4022
            // o workaround abaixo impede o loop infinito
            if (fromParams.$$redirectingLogin) {
                event.preventDefault();
                $state.go("login", {}, {
                    notify: false
                }).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
                return;
            }

            var checkSetup = $rootScope.$location.search().setup;
            if ((fromState.name.indexOf('.new') >= 0 || fromState.name.indexOf('.edit') >= 0 || fromState.name.indexOf('configuracao') >= 0) && checkSetup == "true" && toState.name != 'setup.view') {
                event.preventDefault();
                $state.go('setup.view', {}, {
                    notify: false
                }).then(function () {
                    $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                });
                return false;
            }

            // main search
            $rootScope.mainSearchActive = false;
            // single card
            $rootScope.headerDoubleHeightActive = false;
            // top bar
            $rootScope.topBarActive = false;
            // top 

            //var checkSetup = LocalStorageService.getItem("FazendoSetup");
            checkSetup = $rootScope.$location.search().setup;
            if (checkSetup == "true") {
                $rootScope.topMenuActive = true;
            } else {
                $rootScope.topMenuActive = false;
            }

            // full header
            $rootScope.fullHeaderActive = false;
            // full height
            $rootScope.hiddenLayout = $rootScope.page_full_height = toState.name.startsWith('dash.') || toState.name === 'crm_phone';
            // secondary sidebar
            $rootScope.sidebar_secondary = false;
            $rootScope.secondarySidebarHiddenLarge = false;

            if ($($window).width() < 1220) {
                $rootScope.primarySidebarActive = false;
                $rootScope.hide_content_sidebar = false;
            }

            // TODO: aqui controla a visibilidade do loading ao trocar de paginas.
            //      hoje o style esta sendo aplicado no <html> (index.html)
            $rootScope.pageLoading = true;
            $rootScope.pageLoaded = false;

            if (toState.name == "login" || toState.name == "crm_phone") return;

            var checkPermission = function () {


                if (!PermissaoService.checkPageAccess(toState, toParams)) {
                    event.preventDefault();
                    $state.go("error403");
                    return false;
                }
                return true;
            }

            if (AuthService.getUsuarioLogado()) {
                checkPermission();
                return;
            }

            event.preventDefault();
            fromParams.$$redirectingLogin = true;

            // ainda não sabemos quem é o usuário logado (page load)
            return AuthService.restore()
                .then(function () {
                    if (checkPermission()) {
                        // se após recuperar o usuario e identificarmos que ele tem acesso, redirecionar para o state original
                        $state.go(toState.name, toParams, {
                            notify: false
                        }).then(function () {
                            $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                        });
                    }
                })
                .catch(function (error) {
                    // não foi possível restaurar o usuario (provavelmente não está logado). Redirecionar para o login
                    $state.go("login", {}, {
                        notify: false
                    }).then(function () {
                        toParams.redirLoginUrl = window.location.hash;
                        $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                    });
                    return error;
                });
        });

        // fastclick (eliminate the 300ms delay between a physical tap and the firing of a click event on mobile browsers)
        $window.FastClick.attach($window.document.body);

        // get version from package.json
        // $http.get('./package.json').success(function(response) {
        $rootScope.appVer = appversion;
        // });

        // modernizr
        $rootScope.Modernizr = $window.Modernizr;

        // get window width
        var w = angular.element($window);
        $rootScope.largeScreen = w.width() >= 1220;

        w.on('resize', function () {
            return $rootScope.largeScreen = w.width() >= 1220;
        });

        // show/hide main menu on page load
        $rootScope.primarySidebarOpen = ($rootScope.largeScreen) ? true : false;

        $rootScope.pageLoading = true;
    }])
        .run(["Config", "PrintToConsole", function (Config, PrintToConsole) {
            // app debug
            PrintToConsole.active = Config.isDebug();
        }]);
})();
angular.module('epbxManagerApp')
    .config(["$ocLazyLoadProvider", "ConfigProvider", function ($ocLazyLoadProvider, ConfigProvider) {
        "use strict";

        /* ****  LEIA ME
            Este arquivo é processado por uma tarefa gulp.
            Ao alterar o arquivo, executar o comando "npm run gulp -- lazyLoadBuild"
            para verificar se a tarefa continua funcionando.
            A tarefa minifica todos os arquivos referenciados neste arquivo
        *** */

        var Config = ConfigProvider.$get();
        $ocLazyLoadProvider.config({
            debug: false,
            events: false,
            modules: [
                // ----------- SignalR -----------
                {
                    name: 'lazy_signalr',
                    files: [
                        /* ignore-minify */
                        Config.getWebApiScript('jquery.signalR.min.js'),
                        /* ignore-minify */
                        'js!' + Config.getUrlSignalR('hubs')
                    ],
                    serie: true
                },
                // ----------- FORM ELEMENTS -----------
                
                {
                    name: 'lazy_iCheck',
                    files: [
                        "bower_components/jquery-icheck/icheck.js",
                        'app/modules/angular-icheck.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_selectizeJS',
                    files: [
                        'bower_components/selectize/dist/js/standalone/selectize.min.js',
                        'app/modules/angular-selectize.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_uiSelect',
                    files: [
                        'bower_components/angular-ui-select/dist/select.css',
                        'bower_components/angular-ui-select/dist/select.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_switchery',
                    files: [
                        'bower_components/switchery/dist/switchery.js',
                        'app/modules/angular-switchery.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_dropify',
                    files: [
                        'assets/skins/dropify/css/dropify.css',
                        'assets/js/custom/dropify/dist/js/dropify.js'
                    ],
                    insertBefore: '#main_stylesheet'
                }, {
                    name: 'lazy_ionRangeSlider',
                    files: [
                        'bower_components/ion.rangeslider/js/ion.rangeSlider.min.js',
                        'app/modules/angular-ionRangeSlider.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_masked_inputs',
                    files: [
                        'bower_components/jquery.inputmask/dist/jquery.inputmask.bundle.js'
                    ]
                }, {
                    name: 'lazy_character_counter',
                    files: [
                        'app/modules/angular-character-counter.js'
                    ]
                }, {
                    name: 'lazy_parsleyjs',
                    files: [
                        'assets/js/custom/parsleyjs_config.js',
                        'bower_components/parsleyjs/dist/parsley.js',
                        'bower_components/parsleyjs/src/i18n/pt-br.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_wizard',
                    files: [
                        'assets/js/custom/parsleyjs_config.js',
                        'bower_components/parsleyjs/dist/parsley.js',
                        'bower_components/parsleyjs/src/i18n/pt-br.js',
                        'bower_components/lodash/lodash.min.js',
                        'bower_components/angular-wizard/dist/angular-wizard.min.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_fileUpload',
                    files: [
                        'bower_components/ng-file-upload/ng-file-upload.min.js',
                        'bower_components/ng-file-upload/ng-file-upload-all.min.js',
                        'bower_components/ng-file-upload/ng-file-upload-shim.min.js'
                    ],
                    serie: true
                },

                // ----------- CHARTS -----------
                {
                }, {
                    name: 'lazy_charts_c3',
                    files: [
                        'assets/js/custom/c3js-chart/c3.min.css',
                        'bower_components/d3/d3.js',
                        'assets/js/custom/c3js-chart/c3.min.js'
                    ],
                    insertBefore: '#main_stylesheet',
                    serie: true
                }, {
                    name: 'lazy_charts_peity',
                    files: [
                        'bower_components/peity/jquery.peity.min.js',
                        'app/modules/angular-peity.js'
                    ],
                    serie: true
                },

                // ----------- COMPONENTS -----------
                {
                    name: 'lazy_countUp',
                    files: [
                        'bower_components/countUp.js/dist/countUp.min.js'
                    ]
                }, {
                    name: 'lazy_moment',
                    files: [
                        'bower_components/angular-moment/angular-moment.js'
                    ]
                },{
                    name: 'lazy_angularTree',
                    files: [
                        'bower_components/angular-ui-tree/dist/angular-ui-tree.min.css',
                        'bower_components/angular-ui-tree/dist/angular-ui-tree.js'                        
                    ]
                }, {
                    name: 'lazy_dragula',
                    files: [
                        'bower_components/angular-dragula/dist/angular-dragula.min.js'
                    ]
                }, {
                    name: 'lazy_pagination',
                    files: [
                        'bower_components/angularUtils-pagination/dirPagination.js'
                    ]
                }, {
                    name: 'lazy_magnific',
                    files: [
                        'bower_components/magnific-popup/dist/jquery.magnific-popup.min.js',
                        'app/modules/angular-magnific-popup.js'
                    ],
                    serie: true
                },
                {
                    name: 'lazy_audio',
                    files: [
                        'bower_components/buzz/dist/buzz.min.js',
                        'app/modules/angular-sound.js'
                    ],
                    serie: true
                },
                {
                    name: 'lazy_word_cloud',
                    files: [
                        'bower_components/d3/d3.min.js',
                        'bower_components/d3-cloud/build/d3.layout.cloud.js',
                        'bower_components/angular-d3-word-cloud/dist/angular-word-cloud.min.js',
                    ],
                    serie: true
                },
                {
                    name: 'lazy_amCharts3',
                    files: [
                        // 'bower_components/amcharts3/amcharts/amcharts.js',
                        // 'bower_components/amcharts3/amcharts/plugins/export/export.min.js',
                        // 'bower_components/amcharts3/amcharts/plugins/export/libs/jszip/jszip.js',
                        // 'bower_components/amcharts3/amcharts/plugins/export/libs/FileSaver.js/FileSaver.js',
                        // 'bower_components/amcharts3/amcharts/plugins/export/libs/fabric.js/fabric.js',
                        // 'bower_components/amcharts3/amcharts/themes/light.js',
                        // 'bower_components/amcharts3/amcharts/plugins/export/export.css',
                        // 'bower_components/amcharts3/amcharts/pie.js',
                        // 'bower_components/amcharts3/amcharts/funnel.js',
                        // 'bower_components/amcharts3/amcharts/gauge.js',
                        // 'bower_components/amcharts3/amcharts/serial.js',
                        // 'bower_components/amcharts3/amcharts/xy.js',
                    ],
                    serie: true
                },
                {
                    name: 'lazy_amCharts',
                    files: [
                        'bower_components/amcharts3/amcharts/amcharts.js',
                        'bower_components/amcharts3/amcharts/plugins/export/export.min.js',
                        'bower_components/amcharts3/amcharts/plugins/export/libs/FileSaver.js/FileSaver.js',
                        'bower_components/amcharts3/amcharts/plugins/export/libs/jszip/jszip.js',
                        'bower_components/amcharts3/amcharts/plugins/export/libs/fabric.js/fabric.js',
                        'bower_components/amcharts3/amcharts/themes/light.js',
                        'bower_components/amcharts3/amcharts/plugins/export/export.css',
                        'bower_components/amcharts3/amcharts/pie.js',
                        'bower_components/amcharts3/amcharts/funnel.js',
                        'bower_components/amcharts3/amcharts/gauge.js',
                        'bower_components/amcharts3/amcharts/serial.js',
                        'bower_components/amcharts3/amcharts/xy.js',
                    ],
                    serie: true
                }, {
                    name: 'lazy_amChartWithMap',
                    files: [
                        'bower_components/amcharts3/amcharts/amcharts.js',
                        'bower_components/amcharts3/amcharts/plugins/export/export.min.js',
                        'bower_components/amcharts3/amcharts/plugins/export/libs/jszip/jszip.js',
                        'bower_components/amcharts3/amcharts/plugins/export/libs/FileSaver.js/FileSaver.js',
                        'bower_components/amcharts3/amcharts/plugins/export/libs/fabric.js/fabric.js',
                        'bower_components/amcharts3/amcharts/themes/light.js',
                        'bower_components/amcharts3/amcharts/plugins/export/export.css',
                        'bower_components/amcharts3/amcharts/pie.js',
                        'bower_components/amcharts3/amcharts/funnel.js',
                        'bower_components/amcharts3/amcharts/gauge.js',
                        'bower_components/amcharts3/amcharts/serial.js',
                        'bower_components/amcharts3/amcharts/xy.js',
                        'bower_components/ammap3/ammap/ammap.js',
                        'bower_components/ammap3/ammap/ammap.css',
                        'bower_components/ammap3/ammap/maps/js/brazilLow.js',
                    ],
                    serie: true
                },
                {
                    name: 'lazy_joint',
                    files: [
                        'bower_components/lodash/lodash.min.js',
                        'assets/js/custom/jquery.svg.min.js',
                        'assets/js/custom/jquery.svgdom.min.js',
                        'assets/js/custom/jointjs/joint.min.css',
                        'assets/js/custom/svg-pan-zoom/svg-pan-zoom.min.js',
                        'assets/js/custom/backbone/backbone.js',
                        'assets/js/custom/jointjs/joint.min.js'
                    ],
                    serie: true
                },
                // ----------- PLUGINS -----------
                {
                    name: 'lazy_datatables',
                    files: [
                        'bower_components/datatables/media/js/jquery.dataTables.min.js',
                        'bower_components/datatables-colvis/js/dataTables.colVis.js',
                        'bower_components/datatables-tabletools/js/dataTables.tableTools.js',
                        'bower_components/angular-datatables/dist/angular-datatables.js',
                        'assets/js/custom/jquery.dataTables.columnFilter.js',
                        'bower_components/angular-datatables/dist/plugins/columnfilter/angular-datatables.columnfilter.min.js',
                        'assets/js/custom/datatables_uikit.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_gantt_chart',
                    // <!-- jquery ui -->
                    files: [
                        'bower_components/jquery-ui/ui/minified/core.min.js',
                        'bower_components/jquery-ui/ui/minified/widget.min.js',
                        'bower_components/jquery-ui/ui/minified/mouse.min.js',
                        'bower_components/jquery-ui/ui/minified/resizable.min.js',
                        'bower_components/jquery-ui/ui/minified/draggable.min.js',
                        'assets/js/custom/gantt_chart.js'
                    ],
                    serie: true
                }, {
                    name: 'lazy_tablesorter',
                    files: [
                        'bower_components/tablesorter/dist/js/jquery.tablesorter.min.js',
                        'bower_components/tablesorter/dist/js/jquery.tablesorter.widgets.min.js',
                        'bower_components/tablesorter/dist/js/widgets/widget-alignChar.min.js',
                        'bower_components/tablesorter/addons/pager/jquery.tablesorter.pager.js'
                    ]
                },

                // ----------- KENDOUI COMPONENTS -----------
                {
                    name: 'lazy_Kendo_UI',
                    files: [
                        'bower_components/kendo-ui/js/kendo.core.min.js',
                        'bower_components/kendo-ui/js/kendo.data.min.js',
                        'bower_components/kendo-ui/js/kendo.calendar.min.js',
                        'bower_components/kendo-ui/js/kendo.popup.min.js',
                        'bower_components/kendo-ui/js/kendo.datepicker.min.js',
                        'bower_components/kendo-ui/js/kendo.timepicker.min.js',
                        'bower_components/kendo-ui/js/kendo.datetimepicker.min.js',
                        'bower_components/kendo-ui/js/kendo.fx.min.js',
                        'bower_components/kendo-ui/js/kendo.userevents.min.js',
                        'bower_components/kendo-ui/js/kendo.angular.min.js',
                        'bower_components/kendo-ui/js/cultures/kendo.culture.pt-BR.min.js',
                        'bower_components/kendo-ui/js/kendo.maskedtextbox.min.js',
                        'bower_components/kendo-ui/js/kendo.numerictextbox.min.js',
                        'bower_components/jquery.inputmask/dist/jquery.inputmask.bundle.js',
                        'bower_components/kendo-ui/styles/kendo.common-material.min.css',
                        'bower_components/kendo-ui/styles/kendo.material.min.css',
                        'bower_components/kendo-ui/styles/kendo.common-material.min.css',
                        'bower_components/kendo-ui/styles/kendo.material.min.css'
                    ],
                    insertBefore: '#main_stylesheet',
                    serie: true
                },
                // {
                //     name: 'lazy_Kendo_datetimePicker',
                //     files: [
                //         'bower_components/kendo-ui/js/kendo.core.min.js',
                //         'bower_components/kendo-ui/js/kendo.data.min.js',
                //         'bower_components/kendo-ui/js/kendo.calendar.min.js',
                //         'bower_components/kendo-ui/js/kendo.popup.min.js',
                //         'bower_components/kendo-ui/js/kendo.datepicker.min.js',
                //         'bower_components/kendo-ui/js/kendo.timepicker.min.js',
                //         'bower_components/kendo-ui/js/kendo.datetimepicker.min.js',
                //         'bower_components/kendo-ui/js/kendo.fx.min.js',
                //         'bower_components/kendo-ui/js/kendo.userevents.min.js',
                //         'bower_components/kendo-ui/js/kendo.angular.min.js',
                //         'bower_components/kendo-ui/js/cultures/kendo.culture.pt-BR.min.js',
                //         'bower_components/jquery.inputmask/dist/jquery.inputmask.bundle.js',
                //         'bower_components/kendo-ui/styles/kendo.common-material.min.css',
                //         'bower_components/kendo-ui/styles/kendo.material.min.css',
                //     ],
                //     insertBefore: '#main_stylesheet',
                //     serie: true
                // },
                // {
                //     name: 'lazy_KendoNumeric',
                //     files: [
                //         'bower_components/kendo-ui/js/kendo.core.min.js',
                //         'bower_components/kendo-ui/js/kendo.userevents.min.js',
                //         'bower_components/kendo-ui/js/kendo.maskedtextbox.min.js',
                //         'bower_components/kendo-ui/js/kendo.numerictextbox.min.js',
                //         'bower_components/kendo-ui/js/kendo.angular.min.js',
                //         'bower_components/kendo-ui/styles/kendo.common-material.min.css',
                //         'bower_components/kendo-ui/styles/kendo.material.min.css'
                //     ],
                //     insertBefore: '#main_stylesheet',
                //     serie: true
                // },

                // ----------- STYLE SWITCHER -----------
                {
                    name: 'lazy_style_switcher',
                    files: [
                        "app/shared/style_switcher.js"
                    ]
                },
                // ----------- LOCALE -----------
                {
                    name: 'lazy_locale',
                    files: [
                        "bower_components/angular-locale-pt-br/angular-locale_pt-br.js"
                    ]
                },
                {
                    name: 'lazy_clipboard',
                    files: [
                        "bower_components/clipboard/dist/clipboard.js"
                    ]
                },
                // ----------- ANGULAR-JSONEDITOR -----------
                {
                    name: 'lazy_jsoneditor',
                    files: [
                        "node_modules/angular-jsoneditor/dist/angular-jsoneditor.js"
                    ]
                }
            ]
        })
    }]);

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .constant('STATES', {
            defaultState: 'main.default.list'
        })

        .config(["$stateProvider", "$urlRouterProvider", "$injector", function ($stateProvider, $urlRouterProvider, $injector) {
            
            const dataResolver = $injector.get('StateResolverProvider').resolveData;
            $stateProvider.dataResolver = dataResolver;

            // Use $urlRouterProvider to configure any redirects (when) and invalid urls (otherwise).
            var defaultRouteHandler = function defaultRouteHandler($state, STATES) {
                $state.go(STATES.defaultState);
            }
            defaultRouteHandler.$inject = ["$state", "STATES"];

            $urlRouterProvider
                .when('', defaultRouteHandler)
                //.when('/', defaultRouteHandler)
                // .otherwise('/404'); // não usar desta forma pois causa loop infinito no angular (https://github.com/angular-ui/ui-router/issues/600)
                .otherwise(function ($injector) {
                    var $state = $injector.get("$state");
                    $state.go("error404", {}, {
                        location: false
                    });
                });

            var genericErrorController = function ($scope, $location, STATES, $timeout, $state) {
                var pendingRedirect = null;
                $scope.STATES = STATES;
                $scope.url = $location.url();

                $scope.$on('$locationChangeStart', function (event) {
                    if (pendingRedirect != null && event.targetScope.$location.$$url != '/403') {
                        $timeout.cancel(pendingRedirect);
                        pendingRedirect = null;
                    }
                });

                if ($scope.url == '/403') {
                    $scope.faltandoTempo = 3;
                    $scope.contarTempo = function () {
                        pendingRedirect = $timeout(function () {
                            if ($scope.faltandoTempo == 0) {
                                $state.go(STATES.defaultState);
                                return;
                            }
                            $scope.faltandoTempo--;
                            $scope.contarTempo();
                        }, 1000)
                    };
                    $scope.contarTempo();
                }
            }
            genericErrorController.$inject = ["$scope", "$location", "STATES", "$timeout", "$state"];

            $stateProvider
                // -- ERROR PAGES --
                .state("error", {
                    url: "/error",
                    templateUrl: 'app/views/error.html',
                    controller: genericErrorController,
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("error403", {
                    url: "/403",
                    templateUrl: 'app/pages/main/error_403View.html',
                    controller: genericErrorController,
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("error404", {
                    url: "/404",
                    templateUrl: 'app/pages/main/error_404View.html',
                    controller: genericErrorController,
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("error500", {
                    url: "/500",
                    templateUrl: 'app/pages/main/error_500View.html',
                    controller: genericErrorController,
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })

                // -- RESTRICTED --

                .state("setup", {
                    abstract: true,
                    url: "/setup",
                    views: {
                        'main_header': {
                            templateUrl: 'app/pages/main/headerView.html',
                            controller: 'mainHeaderCtrl'
                        },
                        '': {
                            templateUrl: 'app/pages/main/restricted.html'
                        }
                    },
                    resolve: {
                        deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                            return $ocLazyLoad.load([
                                'lazy_signalr',
                                'lazy_switchery',
                                'lazy_iCheck',
                            ], {
                                    serie: true
                                });
                        }]
                    }
                })

                .state("setup.view", {
                    url: "",
                    templateUrl: 'app/pages/setup/view.html',
                    controller: 'SistemaConfiguracaoViewController',
                    resolve: dataResolver("SistemaConfiguracao", "View"),
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })


                .state("dash", {
                    abstract: true,
                    url: "/dash",
                    templateUrl: 'app_dash/dash-index.html',
                    controller: 'DashIndexController',
                    resolve: {
                        deps: ["$ocLazyLoad", "MessageBus", function ($ocLazyLoad, MessageBus) {
                            return $ocLazyLoad.load([
                                'lazy_signalr'
                            ], {
                                    serie: true
                                }).then(function () {
                                    // inicia conexão com o Signalr quando o cliente entrar
                                    // em algum state que inicie com main.
                                    MessageBus.start();
                                });
                        }]
                    }
                })

                .state("dash.receptivo", {
                    url: "/receptivo",
                    templateUrl: 'app_dash/pages/dashReceptivo/view.html',
                    resolve: dataResolver("DashReceptivo", "View"),
                    controller: 'DashReceptivoViewController',
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    },
                    params: {
                        retorno: false,
                    },
                })

                .state("dash.compacto", {
                    url: "/compacto",
                    templateUrl: 'app_dash/pages/dashSupervisao/view.html',
                    resolve: dataResolver("DashSupervisao", "View"),
                    controller: 'DashSupervisaoViewController',
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })

                .state("dash.talkbot", {
                    url: "/talkbot",
                    templateUrl: 'app_dash/pages/dashTalkbot/view.html',
                    resolve: dataResolver("DashTalkbot", "View"),
                    controller: 'DashTalkbotViewController',
                    data: {
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })

                .state("dash.telecom", {
                    url: "/telecom",
                    templateUrl: 'app_dash/pages/dashTelecom/view.html',
                    resolve: dataResolver("DashTelecom", "View"),
                    controller: 'DashTelecomViewController',
                    data: {
                        proxy: 'dash.telecom.servico',
                        permissions: {
                            AllowAnonymous: true
                        }
                    },
                })

                .state("dash.telecom.financeiro", {
                    url: "/financeiro",
                    templateUrl: 'app_dash/pages/dashTelecom/view-financeiro.html'
                })

                .state("dash.telecom.ocupacao", {
                    url: "/ocupacao",
                    templateUrl: 'app_dash/pages/dashTelecom/view-ocupacao.html'
                })

                .state("dash.telecom.status", {
                    url: "/status",
                    templateUrl: 'app_dash/pages/dashTelecom/view-status.html'
                })

                .state("dash.telecom.servico", {
                    url: "/servico",
                    templateUrl: 'app_dash/pages/dashTelecom/view-servico.html'
                })

                .state("main", {
                    abstract: true,
                    url: "",
                    views: {
                        'main_header': {
                            templateUrl: 'app/pages/main/headerView.html',
                            controller: 'mainHeaderCtrl'
                        },
                        'main_sidebar': {
                            templateUrl: 'app/pages/main/main_sidebarView.html',
                            controller: 'mainSidebarCtrl'
                        },
                        '': {
                            templateUrl: 'app/pages/main/restricted.html'
                        }
                    }, 
                    resolve: {
                        deps: ["$ocLazyLoad", "MessageBus", function ($ocLazyLoad, MessageBus) {
                            return $ocLazyLoad.load([
                                'lazy_signalr',
                                'lazy_switchery',
                                'lazy_iCheck',
                                'lazy_locale'
                            ], {
                                    serie: true
                                }).then(function () {
                                    // inicia conexão com o Signalr quando o cliente entrar
                                    // em algum state que inicie com main.
                                    MessageBus.start();
                                });
                        }]
                    }
                })

                /* Dashboard Visão */
                .state("main.dashboardvisoes", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true
                })
                .state("main.dashboardvisoes.new", {
                    url: "/dashboardvisoes/new",
                    templateUrl: 'app/pages/dashboard/editVisao.html',
                    controller: 'DashboardVisaoEditController',
                    resolve: dataResolver("DashboardVisao", "Edit"),
                    data: {
                        pageTitle: 'Configuração de Visão - Incluir',
                        pageName: 'Adicionar Visão'
                    }
                })
                .state("main.dashboardvisoes.edit", {
                    url: "/dashboardvisoes/{DashboardVisaoId:[0-9]+}",
                    templateUrl: 'app/pages/dashboard/editVisao.html',
                    controller: 'DashboardVisaoEditController',
                    resolve: dataResolver("DashboardVisao", "Edit"),
                    data: {
                        pageTitle: 'Configuração de Visão - Editar',
                        pageName: 'Editar Visão'
                    }
                })
        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .filter('titlecase', function () {
            return function (input) {
                var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs|de|da|com?\.?|via)$/i;

                input = input.toLowerCase();
                return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
                    if (index > 0 && index + match.length !== title.length &&
                        match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                        title.charAt(index - 1).search(/[^\s-]/) < 0) {
                        return match.toLowerCase();
                    }

                    if (match.substr(1).search(/[A-Z]|\../) > -1) {
                        return match;
                    }

                    return match.charAt(0).toUpperCase() + match.substr(1);
                }).replace('-', ' ');
            }
        })

        .filter('multiSelectFilter', function () {
            return function (items, filterData) {
                if (angular.isUndefined(filterData))
                    return items;
                var keys = Object.keys(filterData);
                var filtered = [];
                var populate = true;

                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    populate = true;
                    for (var j = 0; j < keys.length; j++) {
                        if (angular.isDefined(filterData[keys[j]])) {
                            if (filterData[keys[j]].length == 0 || filterData[keys[j]].contains(item[keys[j]])) {
                                populate = true;
                            } else {
                                populate = false;
                                break;
                            }
                        }
                    }
                    if (populate) {
                        filtered.push(item);
                    }
                }
                return filtered;
            };
        })

        .filter("jsonDate", function () {
            return function (x) {
                if (x) return new Date(x);
                else return null;
            };
        })

        .filter('orderObjectBy', function () {
            return function (items, field, reverse) {
                var filtered = [];
                angular.forEach(items, function (item) {
                    filtered.push(item);
                });
                filtered.sort(function (a, b) {
                    return (a[field] > b[field] ? 1 : -1);
                });
                if (reverse) filtered.reverse();
                return filtered;
            };
        })

        .filter("initials", function () {
            return function (x) {
                if (x) {
                    return x.split(' ').map(function (s) {
                        return s.charAt(0);
                    }).join('');
                } else {
                    return null;
                }
            };
        })

        .filter("capitalize", function () {
            return function (input) {
                return input ? input.charAt(0).toUpperCase() + input.substr(1) : '';
            };
        })

        .filter("numberFixedLen", function () {
            return function (n, len) {
                var num = parseInt(n, 10);
                len = parseInt(len, 10);
                if (isNaN(num) || isNaN(len)) {
                    return n;
                }
                num = '' + num;
                while (num.length < len) {
                    num = '0' + num;
                }
                return num;
            };
        })

        .filter("indicador", ["$filter", function ($filter) {
            return function (val, formatacao) {
                if (formatacao == 'Value')
                    return val;
                else if (formatacao == 'Money')
                    return '$' + val;
                else if (formatacao == 'Time') {
                    var ValorData = new Date();
                    var hours = Math.floor(val / 3600);
                    var minutes = Math.floor((val / 60) - (hours * 60));
                    var seconds = Math.floor((val) - (hours * 3600) - (minutes * 60));
                    ValorData.setHours(hours);
                    ValorData.setMinutes(minutes);
                    ValorData.setSeconds(seconds);

                    return $filter('date')(ValorData, 'HH:mm:ss');
                } else
                    return val;
            };
        }])
        
        .filter("secondsAsTime", function () {
            return function (input) {
                var duration = moment.duration(parseInt(input), 'seconds');
                return moment(duration._data).format("HH:mm:ss");
            }
        })

        /* Filtros de formatação de data de acordo com a cultura utilizada */

        .filter("localeTime", ["$filter", "TranslateService", function ($filter, TranslateService) {
            return function (input) {
                var time = TranslateService.getAngularTimeFormat();
                return $filter('date')(input, time);
            }
        }])
        
        .filter("localeTimeWithSeconds", ["$filter", "TranslateService", function ($filter, TranslateService) {
            return function (input) {
                var time = TranslateService.getAngularTimeFormatWithSeconds();
                return $filter('date')(input, time);
            }
        }])

        .filter("localeDate", ["$filter", "TranslateService", function ($filter, TranslateService) {
            return function (input) {
                var date = TranslateService.getAngularDateFormat();
                return $filter('date')(input, date);
            }
        }])
        
        .filter("localeDateTime", ["$filter", "TranslateService", function ($filter, TranslateService) {
            return function (input) {
                var dateTime = TranslateService.getAngularDateTimeFormat();
                return $filter('date')(input, dateTime);
            }
        }])

        .filter("localeDateTimeWithSeconds", ["$filter", "TranslateService", function ($filter, TranslateService) {
            return function (input) {
                var dateTime = TranslateService.getAngularDateTimeFormatWithSeconds();
                return $filter('date')(input, dateTime);
            }
        }])
        
        /* Fim dos filtros de formatação de data*/

        .filter("intervaloTempo", function () {
            return function (now, then) {
                if (!now) return 'Indeterminado';

                var atual = moment(now);
                var inicial = moment(then).toDate();
                var diferenca = atual.diff(inicial, 'seconds');

                if (diferenca >= 86400)
                    return moment.duration(diferenca, 'seconds').humanize();
                else
                    return moment().startOf('day').seconds(diferenca).format('HH:mm:ss');
            };
        })

        .filter("elapsedTime", function () {
            return function (input) {
                if (input < 1000) return "Menos de 1 segundo";
                return Math.floor(moment.duration(input).asSeconds()) + " segundos";
            }
        })

        .filter("formatData", ["$filter", "$sce", function ($filter, $sce) {
            function isInt(n) {
                return Number(n) === n && n % 1 === 0;
            }

            function isFloat(n) {
                return Number(n) === n && n % 1 !== 0;
            }

            return function (input) {
                if (!input || input == '00:00:00') {
                    return '--';
                }

                var dataValidacao = moment(input);

                if (moment(input, ["HH:mm:ss", "HH:mm"], true).isValid()) {
                    return $filter('date')(input, 'HH:mm:ss');
                }
                if (moment(input, ["dd/MM/yyyy", "MM/dd/yyyy", "yyyy-MM-dd"], true).isValid() || dataValidacao.second() == 0 && dataValidacao.minute() == 0 && dataValidacao.hour() == 0) {
                    return $filter('date')(input, 'dd/MM/yyyy');
                }
                if (moment(input, moment.ISO_8601, true).isValid()) {
                    return $filter('date')(input, 'dd/MM/yyyy HH:mm');
                }
                if (!isNaN(input) && input !== false && input !== true) {

                    if (isInt(input)) {
                        return input;
                    }

                    if (isFloat(input)) {
                        return ($filter('number')(input, 2)).toString()
                            .split('.').join('@;')
                            .split(',').join('.')
                            .split('@;').join(',');
                    }
                }
                if (input === false || input == 'false') {
                    return $sce.trustAsHtml('<i class="material-icons md-24 uk-text-danger">&#xE14C;</i>');
                }
                if (input === true || input == 'true') {
                    return $sce.trustAsHtml('<i class="material-icons md-24 uk-text-success">&#xE86C;</i>');
                }
                return input;

            };
        }])

        .filter("formatDataOrText", ["$filter", "$sce", function ($filter, $sce) {
            function isInt(n) {
                return Number(n) === n && n % 1 === 0;
            }

            function isFloat(n) {
                return Number(n) === n && n % 1 !== 0;
            }

            return function (input) {
                
                if (moment(input, moment.ISO_8601, true).isValid()) {
                    return $filter('date')(input, 'dd/MM/yyyy HH:mm');
                }
                
                return input;

            };
        }])

        .filter('humanizeCustom', function () {
            return function (diferenca) {
                if (diferenca == undefined) {
                    return;
                }
                if (diferenca >= 86400) {
                    return moment.duration(diferenca, 'seconds').humanize();
                } else {
                    return moment().startOf('day').seconds(diferenca).format('HH:mm:ss');
                }
            };
        })

        .filter('firstWord', function () {
            return function (data) {
                if (!data) return data;
                data = data.split(' ');
                data = data[0].split('.');
                return data[0];
            };
        })
        .filter('thousandSeparator', function () {
            return function (data) {
                if (!data) return data;
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };
        })
        .filter('bytes', ["$filter", function($filter) {
            return function(bytes, precision) {
                if (bytes==0 || isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
                if (typeof precision === 'undefined') precision = 1;
                var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                    number = Math.floor(Math.log(bytes) / Math.log(1024));
                return $filter('number')((bytes / Math.pow(1024, Math.floor(number))).toFixed(precision)) +  ' ' + units[number];
            }
        }])       

        .filter('formatByType', ["$filter", function ($filter) {
            return function (valor, tipo) {
                if (tipo == null || tipo == 0) return valor;
                var pad = function (num) {
                    return ("0" + num).slice(-2);
                }
                var hhmmss = function (secs) {
                    var minutes = Math.floor(secs / 60);
                    secs = secs % 60;
                    var hours = Math.floor(minutes / 60)
                    minutes = minutes % 60;
                    return pad(hours) + ":" + pad(minutes) + ":" + pad(secs);
                }

                if (tipo == 1) { //Int
                    return $filter('thousandSeparator')(valor);
                } else if (tipo == 2) { //Decimal
                    return $filter('number')($filter('thousandSeparator')(valor), 2);
                } else if (tipo == 3) { //Time
                    return hhmmss(valor);
                } else if (tipo == 4) { //Percent
                    return valor + '%';
                } else if (tipo == 5) { //String
                    return valor;
                }
            };
        }])

    .filter('concatStringBy', function () {
        return function (list, field, separator) {
            return _.map(list, function (item) {
                return (item[field] || "").toString();
            }).join(separator || ", ");
        };
    });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        // page title
        .directive('pageTitle', [
            '$rootScope',
            '$timeout',
            '$translate',
            function ($rootScope, $timeout, $translate) {
                return {
                    restrict: 'A',
                    link: function () {
                        var listener = function (event, toState) {
                            var default_title = 'Epbx Manager';
                            $timeout(function () {
                                $rootScope.page_title = (toState.data && toState.data.pageTitle) ? $translate.instant(toState.data.pageTitle) + ' - ' + default_title : default_title;
                            });
                        };
                        $rootScope.$on('$stateChangeSuccess', listener);
                    }
                }
            }
        ])
        // add width/height properities to Image
        .directive('addImageProp', [
            '$timeout',
            'utils',
            function ($timeout, utils) {
                return {
                    restrict: 'A',
                    link: function (scope, elem) {
                        elem.on('load', function () {
                            $timeout(function () {
                                var w = !utils.isHighDensity() ? $(elem).width() : $(elem).width() / 2,
                                    h = !utils.isHighDensity() ? $(elem).height() : $(elem).height() / 2;
                                $(elem).attr('width', w).attr('height', h);
                            });
                        });
                    }
                };
            }
        ])
        // print page
        .directive('printPage', [
            function () {
                return {
                    restrict: 'A',
                    link: function (scope, elem, attrs) {
                        var message = attrs['printMessage'];
                        $(elem).on('click', function (e) {
                            e.preventDefault();
                            UIkit.modal.confirm(message ? message : 'Do you want to print this page?', function () {
                                // wait for dialog to fully hide
                                setTimeout(function () {
                                    window.print();
                                }, 300)
                            }, {
                                    labels: {
                                        'Ok': 'print'
                                    }
                                });
                        });
                    }
                };
            }
        ])
        // full screen
        .directive('fullScreenToggle', [
            function () {
                return {
                    restrict: 'A',
                    link: function (scope, elem) {
                        $(elem).on('click', function (e) {
                            e.preventDefault();
                            screenfull.toggle();
                        });
                    }
                };
            }
        ])
        // single card
        .directive('singleCard', [
            '$window',
            '$timeout',
            function ($window, $timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem) {

                        var $md_card_single = $(elem),
                            w = angular.element($window);

                        function md_card_content_height() {
                            var content_height = w.height() - ((48 * 2) + 12);
                            $md_card_single.find('.md-card-content').innerHeight(content_height);
                        }

                        $timeout(function () {
                            md_card_content_height();
                        }, 100);

                        w.on('resize', function () {
                            // Reset timeout
                            $timeout.cancel(scope.resizingTimer);
                            // Add a timeout to not call the resizing function every pixel
                            scope.resizingTimer = $timeout(function () {
                                md_card_content_height();
                                return scope.$apply();
                            }, 280);
                        });

                    }
                }
            }
        ])
        // outside list
        .directive('listOutside', [
            '$window',
            '$timeout',
            function ($window, $timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem) {

                        var $md_list_outside_wrapper = $(elem),
                            w = angular.element($window);

                        function md_list_outside_height() {
                            var content_height = w.height() - ((48 * 2) + 10);
                            $md_list_outside_wrapper.height(content_height);
                        }

                        md_list_outside_height();

                        w.on('resize', function () {
                            // Reset timeout
                            $timeout.cancel(scope.resizingTimer);
                            // Add a timeout to not call the resizing function every pixel
                            scope.resizingTimer = $timeout(function () {
                                md_list_outside_height();
                                return scope.$apply();
                            }, 280);
                        });

                    }
                }
            }
        ])
        // callback on last element in ng-repeat
        .directive('onLastRepeat', ["$timeout", function ($timeout) {
            return function (scope, element, attrs) {
                if (scope.$last) {
                    $timeout(function () {
                        scope.$emit('onLastRepeat', element, attrs);
                    })
                }
            };
        }])
        // content sidebar
        .directive('contentSidebar', [
            '$rootScope',
            function ($rootScope) {
                return {
                    restrict: 'A',
                    link: function () {

                        if (!$rootScope.header_double_height) {
                            $rootScope.$watch('hide_content_sidebar', function () {
                                if ($rootScope.hide_content_sidebar) {
                                    $('#page_content').css('max-height', $('html').height() - 40);
                                    $('html').css({
                                        'overflow': 'hidden'
                                    });
                                } else {
                                    $('#page_content').css('max-height', '');
                                    $('html').css({
                                        'paddingRight': '',
                                        'overflow': ''
                                    });
                                }
                            });

                        }
                    }
                }
            }
        ])
        // attach events to document
        .directive('documentEvents', [
            '$rootScope',
            '$window',
            '$timeout',
            'variables',
            function ($rootScope, $window, $timeout, variables) {
                return {
                    restrict: 'A',
                    link: function (scope) {

                        var hidePrimarySidebar = function () {
                            $rootScope.primarySidebarActive = false;
                            $rootScope.primarySidebarOpen = false;
                            $rootScope.hide_content_sidebar = false;
                            $rootScope.primarySidebarHiding = true;
                            $timeout(function () {
                                $rootScope.primarySidebarHiding = false;
                            }, 280);
                        };

                        var hideSecondarySidebar = function () {
                            $rootScope.secondarySidebarActive = false;
                        };

                        var hideMainSearch = function () {
                            var $header_main = $('#header_main');
                            $header_main
                                .children('.header_main_search_form')
                                .velocity("transition.slideUpBigOut", {
                                    duration: 280,
                                    easing: variables.easing_swiftOut,
                                    begin: function () {
                                        $header_main.velocity("reverse");
                                        $rootScope.mainSearchActive = false;
                                    },
                                    complete: function () {
                                        $header_main
                                            .children('.header_main_content')
                                            .velocity("transition.slideDownBigIn", {
                                                duration: 280,
                                                easing: variables.easing_swiftOut,
                                                complete: function () {
                                                    $('.header_main_search_input').blur().val('');
                                                }
                                            })
                                    }
                                });
                        };

                        // hide components on $document click
                        scope.onClick = function ($event) {
                            // primary sidebar
                            if ($rootScope.primarySidebarActive && !$($event.target).closest('#sidebar_main').length && !$($event.target).closest('#sSwitch_primary').length && !$rootScope.largeScreen) {
                                hidePrimarySidebar();
                            }
                            // secondary sidebar
                            if ($rootScope.secondarySidebarActive && !$($event.target).closest('#sidebar_secondary').length && !$($event.target).closest('#sSwitch_secondary').length) {
                                hideSecondarySidebar();
                            }
                            // main search form
                            if ($rootScope.mainSearchActive && !$($event.target).closest('.header_main_search_form').length && !$($event.target).closest('#main_search_btn').length) {
                                hideMainSearch();
                            }
                            // style switcher
                            if ($rootScope.styleSwitcherActive && !$($event.target).closest('#style_switcher').length) {
                                $rootScope.styleSwitcherActive = false;
                            }
                        };

                        // hide components on key press (esc)
                        scope.onKeyUp = function ($event) {
                            // primary sidebar
                            if ($rootScope.primarySidebarActive && !$rootScope.largeScreen && $event.keyCode == 27) {
                                hidePrimarySidebar();
                            }
                            // secondary sidebar
                            if ($rootScope.secondarySidebarActive && $event.keyCode == 27) {
                                hideSecondarySidebar();
                            }
                            // main search form
                            if ($rootScope.mainSearchActive && $event.keyCode == 27) {
                                hideMainSearch();
                            }
                            // style switcher
                            if ($rootScope.styleSwitcherActive && $event.keyCode == 27) {
                                $rootScope.styleSwitcherActive = false;
                            }

                        };

                    }
                };
            }
        ])
        // main search show
        .directive('mainSearchShow', [
            '$rootScope',
            '$window',
            '$timeout',
            function ($rootScope, $window, variables) {
                return {
                    restrict: 'E',
                    template: '<a href="#" id="main_search_btn" class="user-action-icon" ng-click="showSearch($event)"><i class="material-icons md-24 md-light">&#xE8B6;</i></a>',
                    replace: true,
                    scope: true,
                    link: function (scope) {
                        scope.showSearch = function ($event) {
                            $event.preventDefault();

                            $('#header_main')
                                .children('.header_main_content')
                                .velocity("transition.slideUpBigOut", {
                                    duration: 280,
                                    easing: variables.easing_swiftOut,
                                    begin: function () {
                                        $rootScope.mainSearchActive = true;
                                    },
                                    complete: function () {
                                        $('#header_main')
                                            .children('.header_main_search_form')
                                            .velocity("transition.slideDownBigIn", {
                                                duration: 280,
                                                easing: variables.easing_swiftOut,
                                                complete: function () {
                                                    $('.header_main_search_input').focus();
                                                }
                                            })
                                    }
                                });
                        };
                    }
                };
            }
        ])
        // main search hide
        .directive('mainSearchHide', [
            '$rootScope',
            '$window',
            'variables',
            function ($rootScope, $window, variables) {
                return {
                    restrict: 'E',
                    template: '<i class="md-icon header_main_search_close material-icons" ng-click="hideSearch($event)">&#xE5CD;</i>',
                    replace: true,
                    scope: true,
                    link: function (scope) {
                        scope.hideSearch = function ($event) {
                            $event.preventDefault();

                            var $header_main = $('#header_main');

                            $header_main
                                .children('.header_main_search_form')
                                .velocity("transition.slideUpBigOut", {
                                    duration: 280,
                                    easing: variables.easing_swiftOut,
                                    begin: function () {
                                        $header_main.velocity("reverse");
                                        $rootScope.mainSearchActive = false;
                                    },
                                    complete: function () {
                                        $header_main
                                            .children('.header_main_content')
                                            .velocity("transition.slideDownBigIn", {
                                                duration: 280,
                                                easing: variables.easing_swiftOut,
                                                complete: function () {
                                                    $('.header_main_search_input').blur().val('');
                                                }
                                            })
                                    }
                                });

                        };
                    }
                };
            }
        ])

        // primary sidebar
        .directive('sidebarPrimary', [
            '$rootScope',
            '$window',
            '$timeout',
            'variables',
            function ($rootScope, $window, $timeout, variables) {
                return {
                    restrict: 'A',
                    link: function (scope) {
                        scope.submenuToggle = function ($event) {
                            $event.preventDefault();

                            var $this = $($event.currentTarget),
                                $sidebar_main = $('#sidebar_main'),
                                slideToogle = $this.next('ul').is(':visible') ? 'slideUp' : 'slideDown';

                            $this.next('ul')
                                .velocity(slideToogle, {
                                    duration: 400,
                                    easing: variables.easing_swiftOut,
                                    begin: function () {
                                        if (slideToogle == 'slideUp') {
                                            $(this).closest('.submenu_trigger').removeClass('act_section')
                                        } else {
                                            $(this).closest('.submenu_trigger').addClass('act_section')
                                        }
                                    },
                                    complete: function () {
                                        if (slideToogle !== 'slideUp') {
                                            var scrollContainer = $sidebar_main.find(".scroll-content").length ? $sidebar_main.find(".scroll-content") : $sidebar_main.find(".scrollbar-inner");
                                            $this.closest('.act_section').velocity("scroll", {
                                                duration: 500,
                                                easing: variables.easing_swiftOut,
                                                container: scrollContainer
                                            });
                                        }
                                    }
                                });
                        };
                    }
                };
            }
        ])
        // toggle primary sidebar
        .directive('sidebarPrimaryToggle', [
            '$rootScope',
            '$window',
            '$timeout',
            function ($rootScope, $window, $timeout) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template: '<a id="sSwitch_primary" href="#" class=" sSwitch_left" ng-click="togglePrimarySidebar($event)" ng-hide="miniSidebarActive || topMenuActive"><i style="margin-top:13px;" class="material-icons md-24 md-light">&#xE8EE;</i></a>',
                    link: function (scope) {
                        scope.togglePrimarySidebar = function ($event) {

                            $event.preventDefault();

                            if ($rootScope.primarySidebarActive) {
                                $rootScope.primarySidebarHiding = true;
                                if ($rootScope.largeScreen) {
                                    $timeout(function () {
                                        $rootScope.primarySidebarHiding = false;
                                        $(window).resize();
                                    }, 280);
                                }
                            } else {
                                if ($rootScope.largeScreen) {
                                    $timeout(function () {
                                        $(window).resize();
                                    });
                                }
                            }

                            $rootScope.primarySidebarActive = !$rootScope.primarySidebarActive;

                            if (!$rootScope.largeScreen) {
                                $rootScope.hide_content_sidebar = $rootScope.primarySidebarActive ? true : false;
                            }

                            if ($rootScope.primarySidebarOpen) {
                                $rootScope.primarySidebarOpen = false;
                                $rootScope.primarySidebarActive = false;
                            }
                        };

                    }
                };
            }
        ])
        // secondary sidebar
        .directive('sidebarSecondary', [
            '$rootScope',
            '$timeout',
            function ($rootScope) {
                return {
                    restrict: 'A',
                    link: function (scope, el, attrs) {
                        $rootScope.sidebar_secondary = true;
                        if (attrs.toggleHidden == 'large') {
                            $rootScope.secondarySidebarHiddenLarge = true;
                        }
                    }
                };
            }
        ])
        // toggle secondary sidebar
        .directive('sidebarSecondaryToggle', [
            '$rootScope',
            '$window',
            '$timeout',
            function ($rootScope) {
                return {
                    restrict: 'E',
                    replace: true,
                    template: '<a href="#" id="sSwitch_secondary" class="sSwitch sSwitch_right" ng-show="sidebar_secondary" ng-click="toggleSecondarySidebar($event)"><span class="sSwitchIcon"></span></a>',
                    link: function (scope) {
                        scope.toggleSecondarySidebar = function ($event) {
                            $event.preventDefault();
                            $rootScope.secondarySidebarActive = !$rootScope.secondarySidebarActive;
                        };
                    }
                };
            }
        ])
        // activate card fullscreen
        .directive('cardFullscreenActivate', [
            '$rootScope',
            'variables',
            function ($rootScope, variables) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: {
                        setFn: '&',
                        onActivate: '&',
                        onFinish: '&'
                    },
                    template: '<i class="md-icon material-icons md-card-fullscreen-activate" ng-click="cardFullscreenActivate($event)">&#xE5D0;</i>',
                    link: function (scope, el) {
                        scope.cardFullscreenActivate = function ($event) {
                            // if (scope.onActivate && (!$event.detail || ($event.detail && !$event.detail.dontRunFunction)))
                            scope.onActivate();
                            var animating = function () {
                                $event.preventDefault();

                                var $thisCard = $(el).closest('.md-card'),
                                    mdCard_h = $thisCard.height(),
                                    mdCard_w = $thisCard.width();

                                // create placeholder for card
                                $thisCard.after('<div class="md-card-placeholder" style="width:' + mdCard_w + 'px;height:' + mdCard_h + 'px;"/>');
                                // add overflow hidden to #page_content (fix for ios)
                                //$body.addClass('md-card-fullscreen-active');
                                // add width/height to card (preserve original size)
                                $thisCard
                                    .addClass('md-card-fullscreen')
                                    .css({
                                        'width': mdCard_w,
                                        'height': mdCard_h
                                    })
                                    // animate card to top/left position
                                    .velocity({
                                        left: 0,
                                        top: 0
                                    }, {
                                        duration: 600,
                                        easing: variables.easing_swiftOut,
                                        begin: function () {
                                            $rootScope.card_fullscreen = true;
                                            $rootScope.hide_content_sidebar = true;
                                            // add back button
                                            //$thisCard.find('.md-card-toolbar').prepend('<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left">&#xE5C4;</span>');
                                            //altair_page_content.hide_content_sidebar();
                                        }
                                    })
                                    // resize card to full width/height
                                    .velocity({
                                        height: '100%',
                                        width: '100%'
                                    }, {
                                        duration: 600,
                                        easing: variables.easing_swiftOut,
                                        complete: function () {
                                            // activate onResize callback for some js plugins
                                            //$(window).resize();
                                            // show fullscreen content
                                            $thisCard.find('.md-card-fullscreen-content').velocity("transition.slideUpBigIn", {
                                                duration: 600,
                                                easing: variables.easing_swiftOut,
                                                complete: function () {
                                                    // activate onResize callback for some js plugins
                                                    $(window).resize();
                                                    scope.onFinish();
                                                }
                                            });
                                        }
                                    });
                            }
                            animating();


                            $rootScope.$broadcast('cardFullscreenActivate', {});

                        }

                        scope.setFn({
                            theDirFn: scope.cardFullscreenActivate
                        });
                    }

                }
            }
        ])
        // deactivate card fullscreen
        .directive('cardFullscreenDeactivate', [
            '$rootScope',
            '$window',
            'variables',
            function ($rootScope, $window, variables) {
                return {
                    restrict: 'E',
                    replace: true,
                    template: '<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left" ng-show="$root.card_fullscreen" ng-click="cardFullscreenDeactivate($event)">&#xE5C4;</span>',
                    link: function (scope, el, attrs) {
                        scope.cardFullscreenDeactivate = function ($event) {
                            $event.preventDefault();

                            // get card placeholder width/height and offset
                            var $thisPlaceholderCard = $('.md-card-placeholder'),
                                mdPlaceholderCard_h = $thisPlaceholderCard.height(),
                                mdPlaceholderCard_w = $thisPlaceholderCard.width(),
                                mdPlaceholderCard_offset_top = $thisPlaceholderCard.offset().top,
                                mdPlaceholderCard_offset_left = $thisPlaceholderCard.offset().left,
                                $thisCard = $('.md-card-fullscreen');

                            $thisCard
                                // resize card to original size
                                .velocity({
                                    height: mdPlaceholderCard_h,
                                    width: mdPlaceholderCard_w
                                }, {
                                    duration: 600,
                                    easing: variables.easing_swiftOut,
                                    begin: function () {
                                        // hide fullscreen content
                                        $thisCard.find('.md-card-fullscreen-content').velocity("transition.slideDownOut", {
                                            duration: 280,
                                            easing: variables.easing_swiftOut
                                        });
                                        $rootScope.card_fullscreen = false;
                                    },
                                    complete: function () {
                                        $rootScope.hide_content_sidebar = false;
                                    }
                                })
                                // move card to original position
                                .velocity({
                                    left: mdPlaceholderCard_offset_left,
                                    top: mdPlaceholderCard_offset_top
                                }, {
                                    duration: 600,
                                    easing: variables.easing_swiftOut,
                                    complete: function () {
                                        // remove some styles added by velocity.js
                                        $thisCard.removeClass('md-card-fullscreen').css({
                                            width: '',
                                            height: '',
                                            left: '',
                                            top: ''
                                        });
                                        // remove card placeholder
                                        $thisPlaceholderCard.remove();
                                        if (attrs.onDeactivate)
                                            scope.$eval(attrs.onDeactivate)();
                                        $(window).resize();
                                    }
                                })

                            $rootScope.$broadcast('cardFullscreenDeactivate', {});
                        }
                    }
                }
            }
        ])
        // card close
        .directive('cardClose', [
            'utils',
            function (utils) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardClose($event)">&#xE14C;</i>',
                    link: function (scope, el) {
                        scope.cardClose = function ($event) {
                            $event.preventDefault();

                            var $this = $(el),
                                thisCard = $this.closest('.md-card'),
                                removeCard = function () {
                                    $(thisCard).remove();
                                };

                            utils.card_show_hide(thisCard, undefined, removeCard)

                        }
                    }
                }
            }
        ])
        // card toggle
        .directive('cardToggle', [
            'variables',
            function (variables) {
                return {
                    restrict: 'E',
                    replace: true,
                    scope: true,
                    template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardToggle($event)">&#xE316;</i>',
                    link: function (scope, el) {
                        scope.cardToggle = function ($event) {
                            $event.preventDefault();

                            var $this = $(el),
                                thisCard = $this.closest('.md-card');

                            $(thisCard).toggleClass('md-card-collapsed').children('.md-card-content').slideToggle('280', variables.bez_easing_swiftOut);

                            $this.velocity({
                                scale: 0,
                                opacity: 0.2
                            }, {
                                    duration: 280,
                                    easing: variables.easing_swiftOut,
                                    complete: function () {
                                        $(thisCard).hasClass('md-card-collapsed') ? $this.html('&#xE313;') : $this.html('&#xE316;');
                                        $this.velocity('reverse');
                                    }
                                });


                        }
                    }
                }
            }
        ])
        // card overlay toggle
        .directive('cardOverlayToggle', [
            function () {
                return {
                    restrict: 'E',
                    template: '<i class="md-icon material-icons" ng-click="toggleOverlay($event)">&#xE5D4;</i>',
                    replace: true,
                    scope: true,
                    link: function (scope, el) {

                        if (el.closest('.md-card').hasClass('md-card-overlay-active')) {
                            el.html('&#xE5CD;')
                        }

                        scope.toggleOverlay = function ($event) {

                            $event.preventDefault();

                            if (!el.closest('.md-card').hasClass('md-card-overlay-active')) {
                                el
                                    .html('&#xE5CD;')
                                    .closest('.md-card').addClass('md-card-overlay-active');

                            } else {
                                el
                                    .html('&#xE5D4;')
                                    .closest('.md-card').removeClass('md-card-overlay-active');
                            }

                        }
                    }
                }
            }
        ])
        // custom scrollbar
        .directive('customScrollbar', [
            '$rootScope',
            function ($rootScope) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, el, attrs) {

                        // check if mini sidebar is enabled
                        if (attrs['id'] == 'sidebar_main' && $rootScope.miniSidebarActive) {
                            return;
                        }

                        $(el).wrapInner("<div class='scrollbar-inner'></div>");
                        if (Modernizr.touch) {
                            $(el).children('.scrollbar-inner').addClass('touchscroll');
                        } else {
                            $(el).children('.scrollbar-inner').scrollbar({
                                disableBodyScroll: true,
                                scrollx: false,
                                duration: 100
                            });
                        }

                    }
                }
            }
        ])
        // material design inputs
        .directive('mdInput',
        ["$timeout", "$parse", function ($timeout, $parse) {
            return {
                restrict: 'A',
                scope: {
                    ngModel: '='
                },
                controller: ["$scope", "$element", function ($scope, $element) {
                    var $elem = $($element);
                    $scope.updateInput = function () {
                        // clear wrapper classes
                        $elem.closest('.md-input-wrapper').removeClass('md-input-wrapper-danger md-input-wrapper-success md-input-wrapper-disabled');

                        if ($elem.hasClass('md-input-danger')) {
                            $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-danger')
                        }
                        if ($elem.hasClass('md-input-success')) {
                            $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-success')
                        }
                        if ($elem.prop('disabled')) {
                            $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-disabled')
                        }
                        if ($elem.val() != '' || $elem.data('forceStyleFilled')) {
                            $elem.closest('.md-input-wrapper').addClass('md-input-filled')
                        }
                    };
                }],
                link: function (scope, elem, attrs) {
                    var $elem = $(elem);

                    $timeout(function () {
                        if (!$elem.hasClass('md-input-processed')) {
                            if ($elem.prev('label').length) {
                                $elem.prev('label').andSelf().wrapAll('<div class="md-input-wrapper"/>');
                            } else if ($elem.siblings('[data-uk-form-password]').length) {
                                $elem.siblings('[data-uk-form-password]').andSelf().wrapAll('<div class="md-input-wrapper"/>');
                            } else {
                                $elem.wrap('<div class="md-input-wrapper"/>');
                            }
                            $elem
                                .addClass('md-input-processed')
                                .closest('.md-input-wrapper')
                                .append('<span class="md-input-bar"/>');
                        }

                        if (attrs.forcestylefilled) {
                            $timeout(function () {
                                // o atributo forceStyleFilled tenta resolver um problema de style quando um campo password
                                // � autopreenchido pelo navegador. O ngModel do password apenas atualiza ap�s uma intera��o
                                // do usu�rio na pagina. Usamos ent�o o campo do username para determinar se o Chrome fez o autofill, para aplicar o style.
                                // ver exemplo no loginView.html
                                $elem.data('forceStyleFilled', !!$parse(attrs.forcestylefilled)(scope.$parent));
                                scope.updateInput();
                            }, 200);
                        }

                        scope.updateInput();
                    });

                    scope.$watch(function () {
                        return elem.attr('class');
                    },
                        function (newValue, oldValue) {
                            if (newValue != oldValue) {
                                scope.updateInput();
                            }
                        }
                    );

                    $elem
                        .on('focus', function () {
                            $elem.closest('.md-input-wrapper').addClass('md-input-focus')
                        })
                        .on('blur', function () {
                            $(this).closest('.md-input-wrapper').removeClass('md-input-focus');
                            if ($(this).val() == '') {
                                $timeout(function () {
                                    $(this).closest('.md-input-wrapper').removeClass('md-input-filled')
                                })
                            } else {
                                $timeout(function () {
                                    $(this).closest('.md-input-wrapper').addClass('md-input-filled')
                                })
                            }
                        });

                }
            }
        }]
        )
        // material design fab speed dial
        .directive('mdFabSpeedDial', [
            'variables',
            function (variables) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem) {
                        $(elem)
                            .append('<i class="material-icons md-fab-action-close" style="display:none">&#xE5CD;</i>')
                            .on('click', function (e) {
                                e.preventDefault();

                                var $this = $(this),
                                    $this_wrapper = $this.closest('.md-fab-wrapper');

                                if (!$this_wrapper.hasClass('md-fab-active')) {
                                    $this_wrapper.addClass('md-fab-active');
                                } else {
                                    $this_wrapper.removeClass('md-fab-active');
                                }

                                $this.velocity({
                                    scale: 0
                                }, {
                                        duration: 140,
                                        easing: variables.easing_swiftOut,
                                        complete: function () {
                                            $this.children().toggle();
                                            $this.velocity({
                                                scale: 1
                                            }, {
                                                    duration: 140,
                                                    easing: variables.easing_swiftOut
                                                })
                                        }
                                    })
                            })
                            .closest('.md-fab-wrapper').find('.md-fab-small')
                            .on('click', function () {
                                $(this).closest('.md-fab-wrapper').removeClass('md-fab-active')
                            });
                    }
                }
            }
        ])
        // material design fab toolbar
        .directive('mdFabToolbar', [
            'variables',
            '$document',
            function (variables, $document) {
                return {
                    restrict: 'AE',
                    scope: {
                        closeManually: '@',
                        controlOpenClose: '='
                    },
                    link: function (scope, elem, attrs) {
                        var $fab_toolbar = $(elem);

                        $fab_toolbar
                            .children('i')
                            .on('click', function (e) {
                                e.preventDefault();

                                var toolbarItems = $fab_toolbar.children('.md-fab-toolbar-actions').children().length;

                                $fab_toolbar.addClass('md-fab-animated');

                                var FAB_padding = !$fab_toolbar.hasClass('md-fab-small') ? 16 : 24,
                                    FAB_size = !$fab_toolbar.hasClass('md-fab-small') ? 64 : 44;

                                setTimeout(function () {
                                    $fab_toolbar
                                        .width((toolbarItems * FAB_size + FAB_padding))
                                }, 140);

                                setTimeout(function () {
                                    $fab_toolbar.addClass('md-fab-active');
                                }, 420);

                            });

                        var closeFabToolbar = function () {

                            $fab_toolbar.css('width', '').removeClass('md-fab-active');

                            setTimeout(function () { $fab_toolbar.removeClass('md-fab-animated'); }, 140);
                        }

                        if (!scope.closeManually) {
                            $($document).on('click scroll', function (e) {
                                if ($fab_toolbar.hasClass('md-fab-active')) {
                                    if (!$(e.target).closest($fab_toolbar).length) {
                                        closeFabToolbar();
                                    }
                                }
                            });
                        }
                        else {
                            // procurar botoes dentro do toolbar que definam a fun��o para fechar o fab
                            $fab_toolbar.find('.md-fab-toolbar-close').on('click', closeFabToolbar);
                        }

                        if (attrs.controlOpenClose) {
                            scope.$watch('controlOpenClose', function (newValue, oldValue) {
                                if (newValue !== oldValue && !newValue) {
                                    setTimeout(function () { closeFabToolbar(); }, 500);
                                }
                            });
                        }
                    }
                }
            }
        ])
        // material design fab sheet
        .directive('mdFabSheet', [
            'variables',
            '$document',
            function (variables, $document) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem) {
                        var $fab_sheet = $(elem);

                        $fab_sheet
                            .children('i')
                            .on('click', function (e) {
                                e.preventDefault();

                                var sheetItems = $fab_sheet.children('.md-fab-sheet-actions').children('a').length;

                                $fab_sheet.addClass('md-fab-animated');

                                setTimeout(function () {
                                    $fab_sheet
                                        .width('240px')
                                        .height(sheetItems * 40 + 8);
                                }, 140);

                                setTimeout(function () {
                                    $fab_sheet.addClass('md-fab-active');
                                }, 280);

                            });

                        $($document).on('click scroll', function (e) {
                            if ($fab_sheet.hasClass('md-fab-active')) {
                                if (!$(e.target).closest($fab_sheet).length) {

                                    $fab_sheet.css({ 'height': '', 'width': '' }).removeClass('md-fab-active');

                                    setTimeout(function () { $fab_sheet.removeClass('md-fab-animated'); }, 140);
                                }
                            }
                        });
                    }
                }
            }
        ])
        // hierarchical show
        .directive('hierarchicalShow', [
            '$timeout',
            '$rootScope',
            function ($timeout, $rootScope) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem) {


                        var parent_el = $(elem),
                            baseDelay = 60;


                        var add_animation = function (children, length) {
                            children
                                .each(function (index) {
                                    $(this).css({
                                        '-webkit-animation-delay': (index * baseDelay) + "ms",
                                        'animation-delay': (index * baseDelay) + "ms"
                                    })
                                })
                                .end()
                                .waypoint({
                                    element: elem[0],
                                    handler: function () {
                                        parent_el.addClass('hierarchical_show_inView');
                                        setTimeout(function () {
                                            parent_el
                                                .removeClass('hierarchical_show hierarchical_show_inView fast_animation')
                                                .children()
                                                .css({
                                                    '-webkit-animation-delay': '',
                                                    'animation-delay': ''
                                                });
                                        }, (length * baseDelay) + 1200);
                                        this.destroy();
                                    },
                                    context: window,
                                    offset: '90%'
                                });
                        };

                        $rootScope.$watch('pageLoaded', function () {
                            if ($rootScope.pageLoaded) {
                                var children = parent_el.children(),
                                    children_length = children.length;

                                $timeout(function () {
                                    add_animation(children, children_length)
                                }, 560)

                            }
                        });

                    }
                }
            }
        ])
        // hierarchical slide in
        .directive('hierarchicalSlide', [
            '$timeout',
            '$rootScope',
            function ($timeout, $rootScope) {
                return {
                    restrict: 'A',
                    scope: true,
                    link: function (scope, elem, attrs) {

                        var $this = $(elem),
                            baseDelay = 100;

                        var add_animation = function (children, context, childrenLength) {
                            children.each(function (index) {
                                $(this).css({
                                    '-webkit-animation-delay': (index * baseDelay) + "ms",
                                    'animation-delay': (index * baseDelay) + "ms"
                                })
                            });
                            $this.waypoint({
                                handler: function () {
                                    $this.addClass('hierarchical_slide_inView');
                                    $timeout(function () {
                                        $this.removeClass('hierarchical_slide hierarchical_slide_inView');
                                        children.css({
                                            '-webkit-animation-delay': '',
                                            'animation-delay': ''
                                        });
                                    }, (childrenLength * baseDelay) + 1200);
                                    this.destroy();
                                },
                                context: context[0],
                                offset: '90%'
                            });
                        };

                        $rootScope.$watch('pageLoaded', function () {
                            if ($rootScope.pageLoaded) {
                                var thisChildren = attrs['slideChildren'] ? $this.children(attrs['slideChildren']) : $this.children(),
                                    thisContext = attrs['slideContext'] ? $this.closest(attrs['slideContext']) : 'window',
                                    thisChildrenLength = thisChildren.length;

                                if (thisChildrenLength >= 1) {
                                    $timeout(function () {
                                        add_animation(thisChildren, thisContext, thisChildrenLength)
                                    }, 560)
                                }
                            }
                        });

                    }
                }
            }
        ])
        // preloaders
        .directive('mdPreloader', [
            function () {
                return {
                    restrict: 'E',
                    scope: {
                        width: '=',
                        height: '=',
                        strokeWidth: '=',
                        style: '@?'
                    },
                    template: '<div class="md-preloader{{style}}"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" ng-attr-height="{{ height }}" ng-attr-width="{{ width }}" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" ng-attr-stroke-width="{{ strokeWidth }}"/></svg></div>',
                    link: function (scope, elem, attr) {

                        scope.width = scope.width ? scope.width : 48;
                        scope.height = scope.height ? scope.height : 48;
                        scope.strokeWidth = scope.strokeWidth ? scope.strokeWidth : 4;

                        attr.$observe('warning', function () {
                            scope.style = ' md-preloader-warning'
                        });

                        attr.$observe('success', function () {
                            scope.style = ' md-preloader-success'
                        });

                        attr.$observe('danger', function () {
                            scope.style = ' md-preloader-danger'
                        });

                    }
                }
            }
        ])
        .directive('preloader', [
            '$rootScope',
            'utils',
            function ($rootScope, utils) {
                return {
                    restrict: 'E',
                    scope: {
                        width: '=',
                        height: '=',
                        style: '@?'
                    },
                    template: '<img src="assets/img/spinners/{{style}}{{imgDensity}}.gif" alt="" ng-attr-width="{{width}}" ng-attr-height="{{height}}">',
                    link: function (scope, elem, attrs) {

                        scope.width = scope.width ? scope.width : 32;
                        scope.height = scope.height ? scope.height : 32;
                        scope.style = scope.style ? scope.style : 'spinner';
                        scope.imgDensity = utils.isHighDensity() ? '@2x' : '';

                        attrs.$observe('warning', function () {
                            scope.style = 'spinner_warning'
                        });

                        attrs.$observe('success', function () {
                            scope.style = 'spinner_success'
                        });

                        attrs.$observe('danger', function () {
                            scope.style = 'spinner_danger'
                        });

                        attrs.$observe('small', function () {
                            scope.style = 'spinner_small'
                        });

                        attrs.$observe('medium', function () {
                            scope.style = 'spinner_medium'
                        });

                        attrs.$observe('large', function () {
                            scope.style = 'spinner_large'
                        });

                    }
                }
            }
        ])
        // uikit components
        .directive('ukHtmlEditor', [
            '$timeout',
            function ($timeout) {
                return {
                    restrict: 'A',
                    link: function (scope, elem) {
                        $timeout(function () {
                            UIkit.htmleditor(elem[0], {
                                'toolbar': '',
                                'height': '240'
                            });
                        });
                    }
                }
            }
        ])
        .directive('ukNotification', [
            '$window',
            function ($window) {
                return {
                    restrict: 'A',
                    scope: {
                        message: '@',
                        status: '@?',
                        timeout: '@?',
                        group: '@?',
                        position: '@?',
                        callback: '&?'
                    },
                    link: function (scope, elem) {

                        var w = angular.element($window),
                            $element = $(elem);

                        scope.showNotify = function () {
                            var thisNotify = UIkit.notify({
                                message: scope.message,
                                status: scope.status ? scope.status : '',
                                timeout: scope.timeout ? scope.timeout : 5000,
                                group: scope.group ? scope.group : '',
                                pos: scope.position ? scope.position : 'top-center',
                                onClose: function () {
                                    $('body').find('.md-fab-wrapper').css('margin-bottom', '');
                                    clearTimeout(thisNotify.timeout);

                                    if (scope.callback) {
                                        if (angular.isFunction(scope.callback())) {
                                            scope.$apply(scope.callback());
                                        } else {
                                            console.log('Callback is not a function');
                                        }
                                    }

                                }
                            });
                            if (
                                ((w.width() < 768) && (
                                    (scope.position == 'bottom-right') || (scope.position == 'bottom-left') || (scope.position == 'bottom-center')
                                )) || (scope.position == 'bottom-right')
                            ) {
                                var thisNotify_height = $(thisNotify.element).outerHeight(),
                                    spacer = (w.width() < 768) ? -6 : 8;
                                $('body').find('.md-fab-wrapper').css('margin-bottom', thisNotify_height + spacer);
                            }
                        };

                        $element.on("click", function () {
                            if ($('body').find('.uk-notify-message').length) {
                                $('body').find('.uk-notify-message').click();
                                setTimeout(function () {
                                    scope.showNotify()
                                }, 450)
                            } else {
                                scope.showNotify()
                            }
                        });

                    }
                }
            }
        ])
        // magnific popup
        .directive('magnific-popup', [
            '$timeout',
            function () {
                return {
                    restrict: 'A',
                    link: function () {

                    }
                }
            }
        ])

        .constant("isIntRegEx", /^[0-9]+$/g)
        .constant("isFloatRegEx", /^[0-9.,]+$/g)

        .directive('numbersOnly', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, ngModelCtrl) {
                    function fromUser(text) {
                        if (text) {
                            var transformedInput = text.replace(/[^0-9]/g, '');

                            if (transformedInput !== text) {
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        }
                        return '';
                    }
                    ngModelCtrl.$parsers.push(fromUser);
                }
            };
        })

        .directive('parseInt', ["isIntRegEx", function (isIntRegEx) {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, ngModelCtrl) {
                    function fromUser(textOrNumber) {
                        var result
                        if (typeof textOrNumber === "string" && isIntRegEx.test(textOrNumber)) {
                            result = parseInt(textOrNumber, 10);
                            if (isNaN(result)) return textOrNumber // parseInt falhou
                            return result
                        }
                        return textOrNumber;
                    }
                    ngModelCtrl.$formatters.push(fromUser);
                }
            };
        }])


        .directive('breadcrumbs', ['$state', 'BreadCrumbService', function ($state, BreadCrumbService) {
            return {
                restrict: 'E',
                template: '<div id="top_bar" class="page_heading">' +
                '<a data-uk-tooltip title="Voltar" style="position:absolute; margin-top:8px; margin-left:-4px;" ng-click="back()"><i style="font-size:30px; " class="material-icons">&#xE317;</i></a>' +
                '<h1 style="margin-left: 30px;">{{pageTitle | translate}}</h1>' +
                '<div ncy-breadcrumb></div>' +
                '</div>',
                scope: {},
                replace: true,
                link: function (scope) {

                    scope.breadcrumbs = BreadCrumbService.breadcrumbs;
                    scope.pageTitle = '';

                    scope.updateTitle = function (title) {
                        scope.pageTitle = title;
                    }

                    scope.empty = function () {
                        BreadCrumbService.empty();
                    }

                    scope.create = function (toState, toParams, state) {

                        // Página de pesquisa
                        if (toState.name.indexOf('list') > -1
                            || (state.$current.data && state.$current.data.proxy && state.$current.data.proxy.indexOf('list') > -1)
                            || (state.$current.data && state.$current.data.startPage == true)) {

                            // Zera o BreadCrumb
                            scope.empty();

                        }

                        // Verifica se tem Rota "Pai"
                        if (($state.$current.parent.data && $state.$current.parent.data.proxy)
                            && $state.$current.parent.data.proxy != toState.name) {

                            // Cria o Breadcrumb Recursivo
                            scope.addRecursive($state.$current);

                        }

                        // Inverte a Ordem do Breadcrumb
                        BreadCrumbService.breadcrumbs.reverse();

                        // Exibe as Informações da Página
                        scope.addItem(toState, JSON.stringify(toParams));
                        scope.updateTitle(toState.data.pageTitle);

                    }

                    scope.createWithQueryString = function (toState, toParams) {

                        scope.addItem(toState, JSON.stringify(toParams));
                        scope.updateTitle(toState.data.pageTitle);

                    }

                    scope.addRecursive = function (state) {
                        if (state.parent && state.parent.data) {
                            // Adiciona a Rota Recursiva
                            scope.addRecursive(state.parent);
                        }

                        scope.addItem({ name: (state.data.proxy || "").toString(), data: { pageName: (state.data.pageName || "").toString() } }, '{}');
                    }

                    scope.addItem = function (toState, toParams) {
                        BreadCrumbService.addItem(toState, toParams);
                    }

                    scope.back = function () {
                        BreadCrumbService.back();
                    };

                    scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {

                        // Cria o breadcrumb ao abrir o sistema
                        if (!fromState || !fromState.name)
                            scope.create(toState, toParams, $state);

                        else { // Cria o breadcrumb pela navegação

                            // Verifica se foi passado uma querystring
                            if ((toParams && toParams.page) && toParams.page == fromState.name)
                                scope.createWithQueryString(toState, toParams);
                            else {

                                scope.create(toState, toParams, $state);

                            }

                        }

                    });

                }
            };
        }])

})();

angular.module('epbxManagerApp')

    .directive('emAccordionPeriodos', ["$translate", "NotifyService", "ModalService", function ($translate, NotifyService, ModalService) {
        return {
            templateUrl: 'app/directives/templates/emAccordionPeriodos.html',
            restrict: 'E',
            scope: {
                colecao: "=",
                dia: "=",
                adicionar: "&",
                excluir: "&",
                validate: "&",
                validarDia: "&",
                template: "="
            },
            link: function (scope, attrs) {
                let diaSemana = {
                    0: $translate.instant('dias.domingo'),
                    1: $translate.instant('dias.segunda'),
                    2: $translate.instant('dias.terca'),
                    3: $translate.instant('dias.quarta'),
                    4: $translate.instant('dias.quinta'),
                    5: $translate.instant('dias.sexta'),
                    6: $translate.instant('dias.sabado')
                };

                scope.permiteDiaSemPeriodo = attrs[0].attributes.hasOwnProperty('permite-dia-sem-periodo');
                scope.disableAtivo = attrs[0].attributes.hasOwnProperty('disable-ativo');
                scope.umPeriodoPorDia = attrs[0].attributes.hasOwnProperty('um-periodo-por-dia');
                scope.titulo = diaSemana[scope.dia];

                scope.delete = function (horario) {
                    let index = scope.colecao.indexOf(horario);
                    scope.excluir({ idx: index })
                }

                scope.onChangeHorario = function (horario) {
                    let horariosDia = scope.colecao.filter(x => x.Dia == horario.Dia);

                    if (horariosDia.length > 1) {
                        let erro = [];

                        horariosDia.forEach((e) => {
                            if (horario.HoraInicio > e.HoraInicio && horario.HoraTermino < e.HoraTermino) {
                                NotifyService.showError(null, $translate.instant('diretivas.jaExistePeriodoParaEsteHorario'));
                                erro.push('error');
                            } else if (horario.HoraInicio < e.HoraInicio && horario.HoraTermino > e.HoraInicio) {
                                NotifyService.showError(null, $translate.instant('diretivas.horarioFinalEstaExcedendo'));
                                erro.push('error');
                            } else if (horario.HoraInicio > e.HoraInicio && horario.HoraInicio < e.HoraTermino) {
                                NotifyService.showError(null, $translate.instant('diretivas.horarioInicialEstaAntecedendo'));
                                erro.push('error');
                            }
                        });

                        if (erro.length > 0) {
                            horario.Valido = false;
                        } else {
                            horario.Valido = true;
                        }
                    }

                    if (parseInt(horario.HoraTermino.split(':')[0], 10) > 20 || 
                    (parseInt(horario.HoraTermino.split(':')[0], 10) === 20 && parseInt(horario.HoraTermino.split(':')[1], 10) > 0)) {
                        ModalService.alert($translate.instant('diretivas.horarioFinalMaior'));
                    }

                    scope.validate();
                }

                scope.onChangeAtivo = function (horario) {
                    
                    scope.validarDia({horario:horario});
                }

            }
        }
    }]);


angular.module('epbxManagerApp')

.directive('allowPattern', function allowPatternDirective() {
    return {
        restrict: "A",
        compile: function () {
            return function (scope, element, attrs) {
                // I handle key events
                element.bind("keypress", function (event) {
                    var keyCode = event.which || event.keyCode; // I safely get the keyCode pressed from the event.
                    var keyCodeChar = String.fromCharCode(keyCode); // I determine the char from the keyCode.

                    if (keyCode == 8 || keyCode == 9 || keyCode == 13) {
                        return;
                    }

                    // If the keyCode char does not match the allowed Regex Pattern, then don't allow the input into the field.
                    if (!keyCodeChar.match(new RegExp(attrs.allowPattern, "i"))) {
                        event.preventDefault();
                        return false;
                    }

                });
            };
        }
    }
});

angular.module('epbxManagerApp')

    .directive('emAudioPlayer', ["$ocLazyLoad", function ($ocLazyLoad) {
        return {
            restrict: 'E',
            templateUrl: function () {
                return {
                    url: "app/directives/templates/emAudioPlayer.html",
                    resolve: $ocLazyLoad.load(['lazy_audio']) // yeah, podemos usar lazy load em diretivas agora!
                };
            },
            bindToController: {
                audio: '=',
                titulo: '=',
                onClose: '&'
            },
            controllerAs: 'audioPlayer',
            scope: {},

            controller: ["$scope", "SupervisaoService", "$interval", "$timeout", "SoundService", "FileDownloadService", "PrintToConsole", "SUPERVISAO_EVENTS", "NotifyService", "$translate", function ($scope, SupervisaoService, $interval, $timeout, SoundService, FileDownloadService, PrintToConsole, SUPERVISAO_EVENTS,
                NotifyService, $translate) {
                $scope.audioPlayer.volume = 100;
                this.secondTracking = 0;
                this.isPlaying = false;
                this.currentAudio = null;
                this.destinoAudio = 2;
                this.showDestination = false;
                this.showLoading = false;
                this.showControls = false;
                this.sliderChangeInProgress = false; // Não atualizar o valor do slider enquanto o usuario está interagindo com o controle
                this.accumulateSeconds = 0;
                this.helperModal = { show: false };

                this.destinoAudioList = [
                    { 'Id': 1, 'Descricao': $translate.instant('diretivas.reproduzirEmMeuRamal') },
                    { 'Id': 2, 'Descricao': $translate.instant('diretivas.reproduzirAqui') }
                ];

                this.isPlayLocal = function () {
                    return this.destinoAudio === 2;
                }

                $scope.$watch('audioPlayer.audio', angular.bind(this, (newValue, oldValue) => {
                    if (newValue && newValue !== oldValue) {
                        this.duracao = newValue.DuracaoDialogo || newValue.Duracao || 0;
                        this.audioid = (this.audio.titulo || this.titulo || "").replace(/ /g, "_");

                        if (this.duracao === 0) {
                            // Carregar arquivo para termos a sua duração
                            this.loadFile();
                        }

                        // Mostrar combo para tocar no ramal se o audio possuir um GlobalId (portanto, é um .vox do cti)
                        this.showDestination = !!this.audio.GlobalId;
                        this.helperModal.show = true;
                    }
                }));

                $scope.$on(SUPERVISAO_EVENTS.onFimEscutaDialogo, angular.bind(this, () => {
                    this.stop(true);
                }));

                this.clearTimeUpdateTimeout = angular.bind(this, () => {
                    if (this.timeoutTimeUpdate) {
                        this.timeoutTimeUpdate = null;
                    }
                })

                this.bindEvents = angular.bind(this, () => {
                    this.currentAudio.bind('loadedmetadata', angular.bind(this, () => {
                        $timeout(angular.bind(this, () => {
                            this.duracao = this.currentAudio.getDuration();
                        }));
                    }));

                    this.currentAudio.bind('error', angular.bind(this, () => {
                        PrintToConsole.error(this.currentAudio.getErrorMessage() + ' / ' + this.currentAudio.getNetworkStateMessage());

                        this.currentAudio = null;
                        this.isPlaying = false;

                        NotifyService.showError(null, 'notificacoes.erroAoReproduzirAudio')

                        // Esconder spinner
                        $timeout(angular.bind(this, () => {
                            this.showLoading = false;
                            this.showControls = false;
                        }));
                    }));

                    this.currentAudio.bind('playing', angular.bind(this, () => {
                        $timeout(angular.bind(this, function () {
                            this.isPlaying = true;
                        }))
                    }));

                    this.currentAudio.bind('canplay', angular.bind(this, () => {
                        // Esconder spinner
                        $timeout(angular.bind(this, function () {
                            this.showLoading = false;
                        }));
                    }));

                    this.currentAudio.bind('waiting', angular.bind(this, () => {
                        // Mostrar spinner
                        $timeout(angular.bind(this, () => {
                            this.showLoading = true;
                        }));
                    }));

                    this.currentAudio.bind('ended', angular.bind(this, () => {
                        $timeout(angular.bind(this, () => {
                            this.isPlaying = false;
                            this.showControls = false;
                            this.currentAudio.stop();
                            this.currentAudio.setTime(0);
                        }));
                    }));

                    this.currentAudio.bind('timeupdate', angular.bind(this, () => {
                        // Não atualizamos o valor do secondTracking enquanto o slider estiver sendo alterado, para não afetar o componente de slider
                        if (!this.sliderChangeInProgress) {
                            this.secondTracking = this.currentAudio.getTime();
                            this.showLoading = false;
                            if (this.timeoutTimeUpdate) {
                                $timeout.cancel(this.timeoutTimeUpdate)
                            }
                            this.timeoutTimeUpdate = $timeout(this.clearTimeUpdateTimeout, 50);
                        }
                    }));
                })

                this.sliderMouseEnter = function () {
                    this.sliderChangeInProgress = true;
                    this.clearTimeUpdateTimeout()
                }

                this.sliderMouseLeave = function () {
                    this.sliderChangeInProgress = false;
                }

                this.sliderMouseDown = function () {
                    this.sliderChangeInProgress = true;
                    this.clearTimeUpdateTimeout()
                }

                this.sliderFinished = function (value) {
                    this.sliderChangeInProgress = false;
                    if (this.isPlayLocal() && this.currentAudio) {
                        this.currentAudio.setTime(value);
                    } else if (!this.isPlayLocal() && this.isPlaying) {
                        this.pause().play();
                    }
                }

                this.setVolume = function setVolume(volume) {
                    if (this.currentAudio) {
                        this.currentAudio.setVolume(volume);
                    }
                }

                this.formatTimer = function (value) {
                    // Workaround enquanto a função format não é implementada na classe duration (https://github.com/moment/moment/issues/1048)
                    var duration = moment.duration(value, 'seconds');
                    return moment(duration._data).format("HH:mm:ss"); // Formato não muda, independente do idioma.
                }

                this.togglePlay = function () {
                    if (this.isPlayLocal() && this.currentAudio) {
                        this.currentAudio.togglePlay();
                        return this.isPlaying ? this.cancelTimer() : this.startTimer();
                    } else {
                        return this.isPlaying ? this.pause() : this.play();
                    }
                }

                this.startTimer = function () {
                    if (!this.isPlayLocal()) {
                        this.isPlaying = $interval(angular.bind(this, () => {
                            if (!this.sliderChangeInProgress) {
                                this.secondTracking = this.secondTracking + this.accumulateSeconds + 1;
                                this.accumulateSeconds = 0;
                                if (this.secondTracking >= this.duracao) {
                                    $interval.cancel(this.isPlaying);
                                }
                            } else {
                                this.accumulateSeconds++;
                            }

                        }), 1000);
                    } else {
                        this.isPlaying = true;
                    }

                    this.showControls = true;

                    return this;
                }

                this.cancelTimer = function () {
                    if (this.isPlaying) $interval.cancel(this.isPlaying);
                    this.isPlaying = false;
                    return this;
                }

                this.loadFile = function () {
                    // TODO: deixar generico para outros tipos de audios do CTI,
                    //       mas não aceitar qualquer nome de arquivo, pois pode abrir vetor de ataque

                    var fileUrl = this.audio.url || ("Ligacao/Download/" + this.audio.GlobalId);

                    if (this.audio.ArquivoDialogo) {
                        fileUrl = this.audio.url || ("Ligacao/Download/" + this.audio.GlobalId + "/" + this.audio.ArquivoDialogo.replace(".vox", ""));
                    }

                    if (this.audio.BilheteDetalheId != undefined) {
                        fileUrl = this.audio.url || ("Ligacao/DownloadDetalheId/" + this.audio.BilheteDetalheId);
                    }

                    if(this.audio.tts == undefined || this.audio.tts == false)
                        fileUrl = FileDownloadService.resolveUrl(fileUrl, this.audio.urlParams || {});

                    if (this.currentAudio == null || this.currentAudio.fileUrl !== fileUrl) {
                        this.currentAudio = SoundService.load(fileUrl);
                        this.currentAudio.fileUrl = fileUrl;
                        this.bindEvents();
                    }
                }

                this.play = function () {
                    // TODO: Não permitir que arquivos que não sejam diálogos toquem no ramal
                    if (!this.isPlayLocal()) {
                        // Reproduzir no ramal
                        this.showLoading = true;

                        SupervisaoService.ouvirDialogo(this.audio.GlobalId, this.secondTracking, this.audio.ArquivoDialogo.replace('.vox', '').replace('.VOX', ''))
                            .then(angular.bind(this, this.startTimer))
                            .catch(angular.bind(this, (err) => {
                                this.showControls = false;
                                NotifyService.showError(null, (err.message || $translate.instant('notificacoes.ocorreuErroInesperado')));
                                PrintToConsole.error(err);
                            }))
                            .finally(angular.bind(this, function () {
                                this.showLoading = false;
                            }));

                    } else {
                        // Reproduzir no browser
                        this.loadFile();
                        this.currentAudio.setTime(this.secondTracking).play();
                        this.showControls = true;
                    }

                    return this;
                }

                this.pause = function () {
                    if (this.isPlayLocal() && this.currentAudio && !this.currentAudio.isPaused()) {
                        this.currentAudio.pause();
                    } else if (!this.isPlayLocal() && this.isPlaying) {
                        SupervisaoService.pausarDialogo();
                    }
                    return this.cancelTimer();
                }

                this.stop = function (alreadyStopped) {
                    if (this.isPlayLocal() && this.currentAudio && !this.currentAudio.isPaused()) {
                        this.currentAudio.stop();
                    } else if (!this.isPlayLocal() && this.isPlaying && !alreadyStopped) {
                        SupervisaoService.pararDialogo();
                    }

                    this.secondTracking = 0;
                    this.showControls = false;
                    return this.cancelTimer();
                }

                this.onCloseModal = function () {
                    this.stop();
                    this.audio = null;
                    this.helperModal.show = false;

                    if (this.onClose) {
                        this.onClose();
                    }
                }

            }]
        };
    }]);
angular.module('epbxManagerApp')
    .directive('emAudioPlayerInLine', ["$ocLazyLoad", function ($ocLazyLoad) {
        return {
            restrict: 'E',
            templateUrl: function () {
                return {
                    url: "app/directives/templates/emAudioPlayerInLine.html",
                    resolve: $ocLazyLoad.load(['lazy_audio']) // yeah, podemos usar lazy load em diretivas agora!
                };
            },
            bindToController: {
                audio: '=',
                titulo: '=',
                onClose: '&'                
            },
            controllerAs: 'audioPlayerInLine',
            scope: { isAutoPlay: "@autoPlay", isDownload: "@downloadFile", isShowDestination: "@showDestination", isNaoExibiProgresso: "@naoExibiProgresso" },
            controller: ["$scope", "SupervisaoService", "$interval", "$timeout", "SoundService", "FileDownloadService", "PrintToConsole", "SUPERVISAO_EVENTS", "NotifyService", "$translate", function ($scope, SupervisaoService, $interval, $timeout, SoundService, FileDownloadService, PrintToConsole, SUPERVISAO_EVENTS,
                NotifyService, $translate) {
                this.secondTracking = 0;
                this.isPlaying = false;
                this.currentAudio = null;
                this.destinoAudio = 2;
                this.showDestination = false;
                this.showDownload = false;
                this.volume = 100;
                this.showLoading = false;
                this.showControls = false;
                this.showVolumeSlider = false;
                this.sliderChangeInProgress = false; // não atualizar o valor do slider enquanto o usuario está interagindo com o controle
                this.accumulateSeconds = 0;
                this.destinoAudioList = [
                    { 'Id': 1, 'Descricao': $translate.instant('diretivas.reproduzirEmMeuRamal') },
                    { 'Id': 2, 'Descricao': $translate.instant('diretivas.reproduzirAqui') }
                ];

                this.isPlayLocal = function () {
                    return this.destinoAudio === 2;
                }

                $scope.eventListener = $scope.$on('onStopPlay', function () {
                    this.stop(true);
                });

                $scope.$watch('audioPlayerInLine.audio', angular.bind(this, function (newValue, oldValue) {
                    if (newValue == null) {
                        this.stop();
                    }

                    if (newValue && newValue !== oldValue) {
                        this.stop();
                        this.duracao = newValue.DuracaoDialogo || newValue.Duracao || 0;
                        this.audioid = (this.audio.titulo || this.titulo || "").replace(/ /g, "_");

                        if (this.duracao === 0) {
                            this.loadFile(); // carregar arquivo para termos a sua duração
                        }

                        // mostrar combo para tocar no ramal se o audio possuir um GlobalId (portanto, é um .vox do cti)
                        if ($scope.isShowDestination === 'false') {
                            this.showDestination = false;
                        } else {
                            this.showDestination = !!this.audio.GlobalId;
                        }

                        if ($scope.isAutoPlay === 'true') {
                            this.play();
                        }
                        if ($scope.isDownload === 'true' && !!this.audio.GlobalId) {
                            this.showDownload = true;
                        }
                    }
                }));

                $scope.$on(SUPERVISAO_EVENTS.onFimEscutaDialogo, angular.bind(this, function () {
                    this.stop(true);
                }));

                $scope.$on("audioPlayerInlineStop", angular.bind(this, function () {
                    this.stop();
                }));

                this.clearTimeUpdateTimeout = angular.bind(this, function () {
                    if (this.timeoutTimeUpdate) {
                        this.timeoutTimeUpdate = null;
                    }
                })

                this.bindEvents = angular.bind(this, function () {
                    this.currentAudio.bind('loadedmetadata', angular.bind(this, function () {
                        $timeout(angular.bind(this, function () {
                            this.duracao = this.currentAudio.getDuration();
                        }));
                    }));

                    this.currentAudio.bind('error', angular.bind(this, function () {

                        PrintToConsole.error(this.currentAudio.getErrorMessage() + ' / ' + this.currentAudio.getNetworkStateMessage());
                        this.currentAudio = null;
                        this.isPlaying = false;

                        NotifyService.showError(null, 'notificacoes.erroAoReproduzirAudio')

                        // esconder spinner
                        $timeout(angular.bind(this, function () {
                            this.showLoading = false;
                            this.showControls = false;
                        }));
                    }));

                    this.currentAudio.bind('playing', angular.bind(this, function () {
                        $timeout(angular.bind(this, function () { this.isPlaying = true; }))
                    }));

                    // Esconder spinner
                    this.currentAudio.bind('canplay', angular.bind(this, function () {
                        $timeout(angular.bind(this, function () { this.showLoading = false; }));
                    }));

                    // Mostrar spinner
                    this.currentAudio.bind('waiting', angular.bind(this, function () {
                        $timeout(angular.bind(this, function () { this.showLoading = true; }));
                    }));

                    this.currentAudio.bind('ended', angular.bind(this, function () {
                        $timeout(angular.bind(this, function () {
                            this.isPlaying = false;
                            this.showControls = false;
                            this.currentAudio.stop();
                            this.currentAudio.setTime(0);
                        }));
                    }));

                    // Não atualizamos o valor do secondTracking enquanto o slider estiver sendo alterado, para não afetar o componente de slider
                    this.currentAudio.bind('timeupdate', angular.bind(this, function () {
                        if (!this.sliderChangeInProgress) {
                            this.secondTracking = this.currentAudio.getTime();
                            this.showLoading = false;
                            if (this.timeoutTimeUpdate) {
                                $timeout.cancel(this.timeoutTimeUpdate)
                            }
                            this.timeoutTimeUpdate = $timeout(this.clearTimeUpdateTimeout, 50);
                        }
                    }));
                })

                this.sliderMouseEnter = function () {
                    this.sliderChangeInProgress = true;
                    this.clearTimeUpdateTimeout()
                }

                this.sliderMouseLeave = function () {
                    this.sliderChangeInProgress = false;
                }

                this.sliderMouseDown = function () {
                    this.sliderChangeInProgress = true;
                    this.clearTimeUpdateTimeout()
                }

                this.sliderFinished = function (value) {
                    this.sliderChangeInProgress = false;
                    if (this.isPlayLocal() && this.currentAudio) {
                        this.currentAudio.setTime(value);
                    } else if (!this.isPlayLocal() && this.isPlaying) {
                        this.pause().play();
                    }
                }

                this.setVolume = function setVolume(volume) {
                    if (this.currentAudio)
                        this.currentAudio.setVolume(volume);
                }

                // Workaround enquanto a função format não é implementada na classe duration ( https://github.com/moment/moment/issues/1048 )
                this.formatTimer = function (value) {
                    var duration = moment.duration(value, 'seconds');
                    return moment(duration._data).format("HH:mm:ss"); // formato não muda, independente do idioma.
                }

                this.togglePlay = function () {
                    if (this.isPlayLocal() && this.currentAudio) {
                        this.currentAudio.togglePlay();
                        return this.isPlaying ? this.cancelTimer() : this.startTimer();
                    } else {
                        return this.isPlaying ? this.pause() : this.play();
                    }
                }

                this.downloadFile = function () {
                    var globalId = this.audio.GlobalId;

                    try {
                        FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId);
                    } catch (err) {
                        NotifyService.showError(err);
                    }
                };

                this.startTimer = function () {
                    if (!this.isPlayLocal()) {
                        this.isPlaying = $interval(angular.bind(this, function () {
                            if (!this.sliderChangeInProgress) {
                                this.secondTracking = this.secondTracking + this.accumulateSeconds + 1;
                                this.accumulateSeconds = 0;
                                if (this.secondTracking >= this.duracao) {
                                    $interval.cancel(this.isPlaying);
                                }
                            } else {
                                this.accumulateSeconds++;
                            }

                        }), 1000);
                    } else {
                        this.isPlaying = true;
                    }

                    this.showControls = true;
                    return this;
                }

                this.cancelTimer = function () {
                    if (this.isPlaying) $interval.cancel(this.isPlaying);
                    this.isPlaying = false;
                    return this;
                }

                this.loadFile = function () {
                    // TODO: deixar generico para outros tipos de audios do CTI,
                    //       mas não aceitar qualquer nome de arquivo, pois pode abrir vetor de ataque

                    var fileUrl = this.audio.url || ("Ligacao/Download/" + this.audio.GlobalId);

                    if (this.audio.ArquivoDialogo) {
                        fileUrl = this.audio.url || ("Ligacao/Download/" + this.audio.GlobalId + "/" + this.audio.ArquivoDialogo.replace(".vox", ""));
                    }

                    if(this.audio.tts == undefined || this.audio.tts == false)
                        fileUrl = FileDownloadService.resolveUrl(fileUrl, this.audio.urlParams || {});

                    if (this.currentAudio == null || this.currentAudio.fileUrl !== fileUrl) {
                        this.currentAudio = SoundService.load(fileUrl);
                        this.currentAudio.fileUrl = fileUrl;
                        this.currentAudio.setVolume(100);
                        this.volume = 100;
                        this.bindEvents();
                    }
                }

                this.play = function () {
                    //var fileUrl;

                    // TODO: não permitir que arquivos que não sejam diálogos toquem no ramal
                    if (!this.isPlayLocal()) {
                        // reproduzir no ramal
                        this.showLoading = true;
                        SupervisaoService
                            .ouvirDialogo(this.audio.GlobalId, this.secondTracking)
                            .then(angular.bind(this, this.startTimer))
                            .catch(angular.bind(this, function (err) {
                                this.showControls = false;
                                NotifyService.showError(null, (err.message || 'notificacoes.ocorreuErroInesperado'));
                                PrintToConsole.error(err);
                            }))
                            .finally(angular.bind(this, function () {
                                this.showLoading = false;
                            }));
                    } else {
                        // reproduzir no browser
                        this.loadFile();
                        this.currentAudio.setTime(this.secondTracking).play();
                        this.showControls = true;
                    }
                    return this;
                }

                this.pause = function () {
                    if (this.isPlayLocal() && this.currentAudio && !this.currentAudio.isPaused()) {
                        this.currentAudio.pause();
                    } else if (!this.isPlayLocal() && this.isPlaying) {
                        SupervisaoService.pausarDialogo();
                    }
                    return this.cancelTimer();
                }

                this.stop = function (alreadyStopped) {
                    if (this.isPlayLocal() && this.currentAudio && !this.currentAudio.isPaused()) {
                        this.currentAudio.stop();
                    } else if (!this.isPlayLocal() && this.isPlaying && !alreadyStopped) {
                        SupervisaoService.pararDialogo();
                    }
                    this.secondTracking = 0;
                    this.showControls = false;
                    return this.cancelTimer();
                }

                this.onCloseModal = function () {
                    this.stop();
                    this.audio = null;
                    if (this.onClose) {
                        this.onClose();
                    }
                }
            }]
        };
    }]);
angular.module('epbxManagerApp')

    .directive('emAutoScroll', ["$interval", "$timeout", function ($interval, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                tempo: '@',
                axis: '@',
                paradas: '@'
            },
            link: function (scope, element) {
                scope.intervalScroll = null;
                scope.start = true;
                scope.espera = 5000;
                scope.elemento = 1;
                scope.posicaoAtual = 0;

                scope.$watch('tempo', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.iniciarScroll();
                    }
                }, true);
                scope.$watch('paradas', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.iniciarScroll();
                    }
                }, true);

                scope.iniciarScroll = function () {
                    if (scope.intervalScroll != null) {
                        $interval.cancel(scope.intervalScroll);
                        $(element).scrollTo('0%', 0, {
                            axis: scope.axis,
                            interrupt: true
                        });
                        scope.intervalScroll = null;
                    }
                    $(document).idleTimer("destroy");
                    if (scope.tempo > 0) {
                        scope.posicaoAtual = 0;
                        scope.elemento = 1;
                        scope.start = true;
                        $.idleTimer(10000);
                        $(document).bind("idle.idleTimer", function () {
                            if (scope.intervalScroll != null) {
                                $interval.cancel(scope.intervalScroll);
                                scope.intervalScroll = null;
                            }
                            if (scope.proximaAnimacao != null) {
                                $timeout.cancel(scope.proximaAnimacao);
                                scope.proximaAnimacao = null;
                            }
                            scope.intervalScroll = $interval(scope.useScroll, parseInt(scope.tempo) + scope.espera);
                        });
                        $(document).bind("active.idleTimer", function () {
                            if (scope.intervalScroll != null) {
                                $interval.cancel(scope.intervalScroll);
                                scope.intervalScroll = null;
                            }
                            if (scope.proximaAnimacao != null) {
                                $timeout.cancel(scope.proximaAnimacao);
                                scope.proximaAnimacao = null;
                            }
                        });

                    }
                }

                scope.useScroll = function () {
                    scope.proximaAnimacao = $timeout(function () {
                        var tamanhoScroll, tamanhoContainer, novaPosicao;
                        if (scope.axis == 'x') {
                            tamanhoScroll = $(element)[0].scrollWidth;
                            tamanhoContainer = $(element).width();
                            novaPosicao = ($(element)[0].scrollWidth / scope.paradas) * scope.elemento;
                        } else {
                            tamanhoScroll = $(element)[0].scrollHeight;
                            tamanhoContainer = $(element).height();
                            novaPosicao = ($(element)[0].scrollHeight / scope.paradas) * scope.elemento;
                        }
                        $(element).scrollTo(novaPosicao + 'px', 3000, {
                            axis: scope.axis,
                            interrupt: true,
                            fail: function () {
                                if (scope.intervalScroll != null) $interval.cancel(scope.intervalScroll);
                                $timeout(scope.iniciarScroll, 60000);
                            }
                        });
                        scope.posicaoAtual = novaPosicao;
                        if (scope.start == true) {
                            if (scope.posicaoAtual + tamanhoContainer >= tamanhoScroll - 10) {
                                scope.start = false;
                                scope.elemento--;
                            } else {
                                scope.elemento++;
                            }
                        } else {
                            if (scope.posicaoAtual <= 10) {
                                scope.start = true;
                                scope.elemento++;
                            } else {
                                scope.elemento--;
                            }
                        }
                    }, scope.espera);
                }
                scope.iniciarScroll();
            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emAvatar', function () {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                emAvatar: "="
            },
            link: function (scope, element) {

                var imagemDefault = "assets/img/avatars/user.png";

                var setImage = function (url) {
                    $(element).css("background-image", 'url(' + url + ')');
                };

                element.attr("src", 'assets/img/blank.png');
                $(element).css("background-image", 'url(' + imagemDefault + ')');

                scope.$watch("emAvatar", function () {
                    if (scope.emAvatar) {
                        setImage(scope.emAvatar);
                    }
                    else {
                        setImage(imagemDefault);
                    }
                });
            }
        }
    });

//style="background-image: url('{{usuario.Avatar.ImagemReduzida}}')"
angular.module('epbxManagerApp')
	.directive('campanhaDrop', function () {
		return {
			restrict: 'E',
			scope: {
				campanha: '='
			},
			templateUrl: "app/directives/templates/emCampanhaDrop.html",
			link: function (scope) {
				scope.campanhaTipoId = scope.campanha.CampanhaTemplate != null ? scope.campanha.CampanhaTemplate.CampanhaTipoId : scope.campanha.CampanhaTipoId;
				scope.flutuante = scope.campanha.Flutuante;
				scope.discagemVertical = scope.campanha.DiscagemVertical;
				scope.bigTalk = scope.campanha.BigTalk;
				scope.discagemPreview = scope.campanha.DiscagemPreview;
			}
		}
	});

angular.module('epbxManagerApp')
	.directive('campanhaDropWatch', function () {
		return {
			restrict: 'E',
			scope: {
				campanha: '='
			},
			templateUrl: "app/directives/templates/emCampanhaDrop.html",
			link: function (scope) {
				
				scope.atualizarDados = function (){
					scope.campanhaTipoId = scope.campanha.CampanhaTemplate != null ? scope.campanha.CampanhaTemplate.CampanhaTipoId : scope.campanha.CampanhaTipoId;
					scope.flutuante = scope.campanha.Flutuante;
					scope.discagemVertical = scope.campanha.DiscagemVertical;
					scope.bigTalk = scope.campanha.BigTalk;
				}

				scope.atualizarDados();

                scope.$watch('campanha', function (newValue, oldValue) {
					scope.campanha = newValue;
					scope.atualizarDados();
				});
				
			}
		}
	});

angular.module('epbxManagerApp')

    .directive('emCampanhaIndicadorCard', function () {
        return {
            templateUrl: 'app/directives/templates/emCampanhaIndicadorCard.html',
            restrict: 'E',
            replace: true,
            scope: {
                indicador: '=',
                quantidade: '=',
                percentual: '=',
                viewQuantidade: '=',
                customClass: '@',
                click: '&'
            },
            controller: ["$scope", function ($scope) {
                $scope.chartOptions = {
                    height: 32,
                    width: 32,
                    fill: ["#8bc34a", "#ffebe6"]
                };

                $scope.clickIndicador = function () {
                    $scope.click({ indicador: $scope.indicador, quantidade: $scope.quantidade });
                }
            }]
        };
    });
angular.module('epbxManagerApp')
    .directive('campanhaProgresso', function () {
        return {
            restrict: 'E',
            scope: {
                livre: '=',
                rediscagem: '=',
                importado: '=',
                viewQuantidade: '=',
                exibirPrevisao: '=?',
                previsaoMinutosFim: '=?',
                visaoSelecionada: '='
            },
            templateUrl: "app/directives/templates/emCampanhaProgresso.html",
            link: function (scope) {
                if (scope.exibirPrevisao == null) scope.exibirPrevisao = true;

                scope.$watch('livre', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.livre = parseInt(newValue);
                        scope.calcularPercentualLivre();
                    }
                });
                scope.$watch('rediscagem', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.rediscagem = parseInt(newValue);
                        scope.calcularPercentualRediscagem();
                    }
                });
                scope.$watch('importado', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.importado = parseInt(newValue);
                        scope.calcularPercentualLivre();
                        scope.calcularPercentualRediscagem();
                    }
                });

                scope.calcularPercentualLivre = function () {
                    if (scope.importado != 0 && scope.importado != null && scope.livre != null)
                        scope.percentualLivre =  Math.round(((scope.livre * 100) / scope.importado));
                    else
                        scope.percentualLivre = 0;
                };
                scope.calcularPercentualRediscagem = function () {
                    if (scope.importado != 0 && scope.importado != null && scope.rediscagem != null)
                        scope.percentualRediscagem = Math.round(((scope.rediscagem * 100) / scope.importado));
                    else
                        scope.percentualRediscagem = 0;
                };

                scope.calcularPercentualLivre();
                scope.calcularPercentualRediscagem();
            }
        }
    });

angular.module('epbxManagerApp')

.directive('emCampoCti', function() {
	return {
		templateUrl: 'app/directives/templates/emCampoCTI.html',
		restrict:'E',
		replace:true,
		scope:{ campo:'=' },
		link: function ($scope, ModalService, $translate){
			$scope.campo.ValorInicial= $scope.campo.Valor;
			$scope.detalhe = function (descricao) {
				var msg = `<h4>${$translate.instant('campo.detalhe')}</h4></br>${descricao}`;
				ModalService.alert(msg);
			};
		}
	};
});
angular.module('epbxManagerApp')

    .directive('emCheckAll', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var valuesArray = attributes.emCheckAll;
                var modelProperty = attributes.checkProperty || "checked";

                scope.$watch(attributes.ngModel, function (newValue) {
                    var values = scope.$eval(valuesArray);
                    angular.forEach(values, function (value) {
                        value[modelProperty] = newValue;
                    });
                });
            }
        }
    });

angular.module('epbxManagerApp')


    .directive('emComboboxCategoriaTabulacao', ["$filter", "$compile", function ($filter, $compile) {
        return {
            restrict: 'AE',
            templateUrl: 'app/directives/templates/emComboboxCategoriaTabulacao.html',
            require: '?ngModel',
            scope: {
                categorias: '=',
                valor: '@',
                label: '=',
                req: '='                
            },
            link: function (scope, element, attrs, ngModel, ctrl) {
                if(ngModel == undefined) return

                if (localStorage.getItem('tabulacao_categoriaId')) 
                    localStorage.removeItem('tabulacao_categoriaId')

                if (localStorage.getItem('tabulacao_subCategoriaId')) 
                    localStorage.removeItem('tabulacao_subCategoriaId')

                scope.dados = scope.categorias;
                
                scope.pai = function () {
                    scope.list = [];
                    scope.nodes = [];

                    scope.dados.forEach(function (values) {
                        if(values.ParentId == null) {
                            let pai = {
                                AtendimentoAcaoId: values.AtendimentoAcaoId,
                                Ativo: values.Ativo,
                                Codigo: values.Codigo,
                                Descricao: values.Descricao,
                                Id: values.Id,
                                Itens: values.Itens,
                                ParentId: values.ParentId,
                                SmsTemplateId: values.SmsTemplateId,
                                StatusId: values.StatusId,
                                Tempo: values.Tempo,
                                CampanhaId: values.CampanhaId
                            }
                            scope.list.push(pai);
                        }
                    });

                    if(scope.tabulacao != undefined) {
                        scope.filhos(); 
                    }
                }
    
                scope.filhos = function () {
                    if (scope.tabulacao.CategoriaId) {

                        if(scope.valor == 'CategoriaId'){
                            localStorage.removeItem('tabulacao_categoriaId');
                            localStorage.setItem('tabulacao_categoriaId', scope.tabulacao.CategoriaId); 
                        } 
                        else if(scope.valor == 'SubCategoriaId')
                        {
                            localStorage.removeItem('tabulacao_subCategoriaId');
                            localStorage.setItem('tabulacao_subCategoriaId', scope.tabulacao.CategoriaId); 
                        }

                        let filho = [];
                        scope.dados.forEach(function (values) {
                            if (values.ParentId == scope.tabulacao.CategoriaId) {
                                filho.push({
                                    AtendimentoAcaoId: values.AtendimentoAcaoId,
                                    Ativo: values.Ativo,
                                    Codigo: values.Codigo,
                                    Descricao: values.Descricao,
                                    Id: values.Id,
                                    Itens: values.Itens,
                                    ParentId: values.ParentId,
                                    SmsTemplateId: values.SmsTemplateId,
                                    StatusId: values.StatusId,
                                    Tempo: values.Tempo,
                                    CampanhaId: values.CampanhaId
                                });
                            }
                        });

                        if(filho.length > 0) {                            

                            scope.nodes.push(filho);
                            
                            localStorage.removeItem('tabulacao_categoriaFilhoId');
                            localStorage.setItem('tabulacao_categoriaFilhoId', '0'); 

                            if(scope.nodes.length >= 2) {
                                let newNode = [];

                                scope.nodes[0].forEach(f => {
                                    if(f.Id == scope.tabulacao.CategoriaId) {
                                        newNode.push(scope.nodes[0]);
                                        newNode.push(scope.nodes[scope.nodes.length - 1]);
                                        scope.nodes = newNode;
                                    }
                                })
                            }
                        }
                        else
                        {
                            localStorage.removeItem('tabulacao_categoriaFilhoId');
                            localStorage.setItem('tabulacao_categoriaFilhoId', scope.tabulacao.CategoriaId); 
                        }    
                    } else {    
                        if(scope.valor == 'CategoriaId')
                            localStorage.removeItem('tabulacao_categoriaId'); 
                        
                        if(scope.valor == 'SubCategoriaId')                        
                            localStorage.removeItem('tabulacao_subCategoriaId');
                    }
                }

                scope.pai();

                scope.$watch('categorias', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.dados = newValue;
                        scope.pai();
                    }
                });
            }
        };
    }])

angular.module('epbxManagerApp')

    .directive('emCountdown', ["$interval", function ($interval) {
        return {
            restrict: 'EA',
            templateUrl: "app/directives/templates/emCountdown.html",
            link: function (scope, element, attributes) {
                let intervalUpdate = null;
                let valorAtual = null;
                scope.hora = 0
                scope.minuto = 0
                scope.segundo = 0

                scope.$watch(attributes.value, function (newValue) {
                    if (newValue) {
                        cancelarInterval();
                        valorAtual = newValue * 60;
                        calcularHora();

                        intervalUpdate = setTimeout(function () {
                            calcularHora();
                        }, 1000);
                    }
                });

                var calcularHora = function () {
                    valorAtual--;
                    if (valorAtual == 0) {
                        cancelarInterval();
                    }
                    scope.hora = Math.floor(valorAtual / 3600);
                    scope.minuto = Math.floor((valorAtual - (scope.hora * 3600)) / 60);
                    scope.segundo = Math.floor(valorAtual - (scope.hora * 3600) - (scope.minuto * 60));
                }

                var cancelarInterval = function () {
                    if (intervalUpdate != null) {
                        clearTimeout(intervalUpdate);
                        intervalUpdate = undefined;
                    }
                }
            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emCountUp', ["$timeout", function ($timeout) {
        return {
            restrict: 'EA',
            link: function (scope, element, attributes) {
                var isPercentual = attributes.percentual === "true";

                scope.$watch(attributes.emCountUp, function (newValue, oldValue) {
                    if (newValue !== oldValue && newValue) {
                        $timeout(function () {
                            var countUp = new CountUp(element[0], 0, 0, (isPercentual ? 2 : 0), 2, {
                                useEasing: true,
                                useGrouping: true,
                                prefix: '',
                                suffix: (isPercentual ? '%' : ''),
                            });
                            countUp.start();
                        }, 150);
                    }
                });

            }
        }
    }]);

angular.module('epbxManagerApp')

    .directive('emTimePicker', ["TranslateService", function (TranslateService) {
        return {
            restrict: 'AE',
            controllerAs: 'emTimePicker',
            scope: true,
            require: '^ngModel',
            bindToController: {
                ngModel: '=',
                format: '@',
                culture: '@',
                timeFormat: '@',
                interval: '@',
                change: '&',
                min: '@',
                max: '@',
                disabled: '='
            },
            template: `
                <div oc-lazy-load="'lazy_Kendo_UI'">
                    <input 
                        kendo-time-picker
                        ng-disabled="emTimePicker.disabled"
                        k-options="emTimePicker.formatOptions"
                        k-ng-model="emTimePicker.ngModel"
                        style="width:100%"
                    />
                </div>
            `,
            link: function ($scope, element, attrs, ngModel) {
                ngModel.$formatters.push(function (value) {
                    if (angular.isDate(value)) {
                        var format = TranslateService.getMomentTimeFormat() || "HH:mm";
                        ngModel.$setViewValue(new moment(value).format(attrs.format || format));
                    }
                    return value;
                });

            },
            controller: function () {
                if (this.disabled == 'undefined') {
                    this.disabled = false;
                }
                let format, timeFormat;
                if (this.culture != null) {
                    timeFormat = null;
                    format = null;
                } else {
                    this.culture = TranslateService.getCulture();
                    format = this.format || undefined;
                    timeFormat = this.timeFormat || undefined;
                }

                this.model = new Date();
                this.formatOptions = {
                    format: format,
                    culture: this.culture || 'pt-BR',
                    timeFormat: timeFormat,
                    interval: this.interval,
                    change: this.change,
                    min: this.min || new Date(1900, 0, 1),
                    max: this.max || new Date(2099, 11, 31)
                }
            }
        }
    }])

    .directive('emDatePicker', ["TranslateService", function (TranslateService) {
        return {
            restrict: 'AE',
            controllerAs: 'emDatePicker',
            scope: true,
            require: '^ngModel',
            bindToController: {
                ngModel: '=',
                format: '@',
                culture: '@',
                timeFormat: '@',
                change: '&',
                min: '=',
                max: '='
            },
            template: `
                <div oc-lazy-load="'lazy_Kendo_UI'">
                    <input 
                        kendo-date-time-picker 
                        k-options="emDatePicker.formatOptions" 
                        k-ng-model="emDatePicker.ngModel" 
                        style="width:100%"
                    />
                </div>
            `,
            controller: function () {
                let format, timeFormat;
                if (this.culture != null) {
                    timeFormat = null;
                    format = null;
                } else {
                    this.culture = TranslateService.getCulture();
                    format = this.format || undefined;
                    timeFormat = this.timeFormat || undefined;
                }
                this.formatOptions = {
                    format: format, // não é preciso especificar o formato, pois o componente respeita o formato da culture
                    culture: this.culture || 'pt-BR',
                    timeFormat: timeFormat,
                    change: this.change,
                    min: this.min || new Date(1900, 0, 1),
                    max: this.max || new Date(2099, 11, 31)
                }
            }
        }
    }])
    .directive('emDateOnlyPicker', ["TranslateService", function (TranslateService) {
        return {
            restrict: 'AE',
            controllerAs: 'emDateOnlyPicker',
            scope: true,
            require: '^ngModel',
            bindToController: {
                ngModel: '=',
                format: '@',
                culture: '@',
                timeFormat: '@',
                change: '&',
                min: '=',
                max: '=',
                disabled: '='
            },
            template: `
                <div oc-lazy-load="'lazy_Kendo_UI'">
                    <input 
                        kendo-date-picker 
                        ng-disabled="emDateOnlyPicker.disabled" 
                        k-options="emDateOnlyPicker.formatOptions" 
                        k-ng-model="emDateOnlyPicker.ngModel" 
                        style="width:100%"
                    />
                </div>
            `,
            controller: function () {
                if (this.disabled == 'undefined') {
                    this.disabled = false;
                }
                let format, timeFormat;
                if (this.culture != null) {
                    timeFormat = null;
                    format = null;
                } else {
                    this.culture = TranslateService.getCulture();
                    format = this.format || undefined; // não é preciso especificar o formato, pois o componente respeita o formato da culture
                    timeFormat = this.timeFormat || undefined;
                }

                this.formatOptions = {
                    format: format,
                    culture: this.culture || 'pt-BR',
                    timeFormat: timeFormat,
                    change: this.change,
                    min: this.min || new Date(1900, 0, 1),
                    max: this.max || new Date(2099, 11, 31)
                }
            }
        }
    }])
    
    .directive('emDatePickerRange', ["$timeout", "$parse", function ($timeout, $parse) {
        return {
            link: function ($scope, element, attrs) {
                if (!attrs.startDate || !attrs.endDate) {
                    throw new Error("attributos 'start-date' e 'end-date' são obrigatórios para a diretiva emDatePickerRange");
                }

                var setEndDate = $parse(attrs.endDate).assign;
                var endDateElement = element.find('em-date-picker[ng-model="' + attrs.endDate + '"]');
                var limitEndDate = function limitEndDate(newValue) {
                    var kendoWidget, widgetValue;

                    if (!endDateElement.getKendoDateTimePicker) {
                        // componentes de data não estão prontos ainda, fazer delay da execução
                        $timeout(limitEndDate, 500, true, newValue);
                        return;
                    }

                    kendoWidget = endDateElement.find('input[k-ng-model="emDatePicker.ngModel"]').getKendoDateTimePicker();
                    if (kendoWidget) {
                        kendoWidget.min(newValue);
                        widgetValue = kendoWidget.value();
                        if (angular.isDate(widgetValue) && widgetValue < newValue) {
                            // Ao reajustar a data final para a inicial, usa o FIM do dia (23:59:59)
                            // em vez de 00:00 — assim a faixa cobre o dia inteiro.
                            var fimDoDia = new Date(newValue);
                            fimDoDia.setHours(23, 59, 59, 0);
                            kendoWidget.value(fimDoDia);
                            // kendoWidget.value() não sincroniza o k-ng-model; atualiza o model
                            // Angular direto (search.DataFim) para a consulta usar a data certa.
                            if (setEndDate) {
                                setEndDate($scope, fimDoDia);
                            }
                        }
                    }
                }

                $scope.$watch(attrs.startDate, function (newValue) {
                    if (angular.isDate(newValue)) {
                        limitEndDate(newValue);
                    }
                });
            }
        }
    }])

    angular.module('epbxManagerApp')
        .directive('emDeleteIcon', ["ModalService", function (ModalService) {
            return {
                restrict: 'E',
                replace: true,
                template:   '<a ng-click="confirmDelete()" data-uk-tooltip title="{{::\'acoes.excluir\' | translate}}">' +
                            '<i class="md-icon uk-text-danger material-icons" >&#xE872;</i>' +
                            '</a>',
                scope: {
                    callback: '&',
                    message: '@'
                },
                link: function (scope) {
                    var message = scope.message || 'notificacoes.confirmarExclusao';
                    ModalService.confirmDelete(message,() => scope.callback(scope));
                }
            }
        }]);

angular.module('epbxManagerApp')
            .directive('emDynamicInput', ["$compile", function($compile) {
                return {
                    restrict: 'E',
                    require: 'ngModel',
                    scope: {
                        inputType: '=',
                        placeholder: '@',
                        ngModel: '='
                    },
                    template: '<div class="dynamic-input-container"></div>',
                    link: function(scope, element, attrs, ngModelCtrl) {
                        var container = element.find('.dynamic-input-container');
                        
                        function updateInput() {
                            container.empty();
                            
                            var template;
                            switch(scope.inputType) {
                                case 'String':
                                    template = '<input class="md-input uk-margin-small-top" md-input type="text" ng-model="ngModel" placeholder="{{placeholder}}">';
                                    break;
                                case 'Integer':
                                    template = '<input class="md-input uk-margin-small-top" md-input type="number" ng-model="ngModel" step="1" placeholder="{{placeholder}}">';
                                    break;
                                case 'Decimal':
                                    template = '<input class="md-input uk-margin-small-top" md-input type="number" ng-model="ngModel" step="0.01" placeholder="{{placeholder}}">';
                                    break;
                                case 'Date':
                                    scope.ngModel = scope.ngModel || new Date();
                                    template = '<em-date-picker ng-model="ngModel"></em-date-picker>';
                                    break;
                                default:
                                    template = '<input class="md-input uk-margin-small-top" md-input type="text" ng-model="ngModel" placeholder="{{placeholder}}">';
                            }
                            
                            container.append(template);
                            $compile(container.contents())(scope);
                        }
                        
                        scope.$watch('inputType', function(newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateInput();
                            }
                        });
                        
                        updateInput();
                        
                        if (scope.inputType === 'Decimal') {
                            ngModelCtrl.$formatters.push(function(value) {
                                return parseFloat(value) || 0;
                            });
                            
                            ngModelCtrl.$parsers.push(function(value) {
                                return parseFloat(value) || 0;
                            });
                        }
                    }
                };
            }]);
angular.module('epbxManagerApp')
    .directive('emFormValidate', ["$timeout", "$parse", function ($timeout, $parse) {
        return {
            restrict: 'A',
            controllerAs: 'ctrl',
            require: 'form',
            link: function (scope, element, attributes, formController) {
                var parsleyObject
                var getParsley = function () {
                    if (parsleyObject) return parsleyObject

                    return parsleyObject = element.parsley({
                        value: function (field) {
                            if (field.$element.is("em-select"))
                                return (angular.element(field.$element).controller("ngModel").$viewValue || "").toString()
                            return field.$element.val()
                        },
                        errorsContainer: function (field) {
                            var parent
                            var element = field.$element.closest('.parsley-row');
                            if (element.length === 0) {
                                if (field.$element.is("em-select")) {
                                    parent = field.$element
                                } else {
                                    parent = field.$element.parent()
                                }
                                parent.after('<div class="parsley-errors-list"></div>')
                                element = parent.siblings(".parsley-errors-list")
                            }
                            return element;
                        }
                    })
                }

                var fn = $parse(attributes.emFormValidate);
                var masterModel = angular.copy(fn(scope));

                if (fn.assign) {
                    element.bind("reset", function () {
                        scope.$apply(function () {
                            fn.assign(scope, angular.copy(masterModel));
                            formController.$setPristine();
                        });
                    });
                }

                var validate = function () { getParsley().validate() }

                scope.$on("destroy", function () {
                    if (parsleyObject) parsleyObject.destroy()
                })

                scope.$watch(
                    function () { return formController.$submitted },
                    function (newValue) {
                        if (newValue === true) $timeout(validate)
                    })

                scope.$watch(
                    function () { return formController.$valid },
                    function (newValue, oldValue) {
                        if (newValue === !oldValue && formController.$submitted) $timeout(validate)
                    })
            }
        }
    }])

"use strict";

angular.module('epbxManagerApp')

    .directive('emGauge', ["$timeout", function ($timeout) {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: 'app/directives/templates/emGauge.html',
            scope: {
                indicador: "=",
                campanha: "="
            },
            link: function (scope, attrs, element, attr) {
                scope.indicador = scope.indicador;
                scope.campanha = scope.campanha;

                scope.plotGauge = function (indicador) {
                    var bands = [];

                    if (indicador != null) {
                        bands = [{
                            "color": "#f35958",
                            "startValue": 0,
                            "endValue": 29,
                            "innerRadius": "105%",
                            "radius": "170%",
                            "gradientRatio": [0.5, 0, -0.5],
                        }, {
                            "color": "#f0ad4e",
                            "startValue": 30,
                            "endValue": 69,
                            "innerRadius": "105%",
                            "radius": "170%",
                            "gradientRatio": [0.5, 0, -0.5],
                        }, {
                            "color": "#90ee90",
                            "startValue": 70,
                            "endValue": 100,
                            "innerRadius": "105%",
                            "radius": "170%",
                            "gradientRatio": [0.5, 0, -0.5],
                        }]
                    }

                    if (bands.length > 0) {
                        AmCharts.makeChart("gauge" + scope.campanha, {
                            "theme": "light",
                            "type": "gauge",
                            "axes": [{
                                "axisAlpha": 0,
                                "tickAlpha": 0,
                                "endValue": 100,
                                "radius": "70%",
                                "startAngle": -90,
                                "endAngle": 90,
                                "unit": "%",
                                "labelsEnabled": false,
                                "bands": bands
                            }],
                            "arrows": [{
                                "alpha": 1,
                                "innerRadius": "30%",
                                "nailRadius": 0,
                                "radius": "180%",
                                "color": "black",
                                "startWidth": 3,
                                "value": indicador,
                            }]
                        });
                    }
                }

                scope.$watch('indicador', function (newValue, oldValue) {
                    if (newValue != oldValue) {                        
                        scope.plotGauge(newValue);                        
                    }
                });

               
                $timeout(function () {
                    scope.plotGauge(scope.indicador);
                }, 300);               
            }
        };
    }]);

angular.module('epbxManagerApp')

    .directive('emGrafico', ["$timeout", "$interval", "$window", "$q", "$filter", "utils", "DashboardResource", function ($timeout, $interval, $window, $q, $filter, utils, DashboardResource) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/directives/templates/emGrafico.html',
            scope: {
                useSize: '=',
                regenerate: '=',
                data: '=',
                hideFilter: '='
            },
            link: function (scope, element, attrs) {
                // Coleta os handles dos polling de visibilidade criados em bindC3 para que
                // possamos cancelá-los quando a diretiva for destruída (evita leak por instância de gráfico).
                var visibilityWatchers = [];
                scope.modelObject = scope.data;
                scope.chartGenerated = undefined;
                scope.ultimaSerie = null;
                scope.ultimoValor = null;
                scope.valorAntigo = null;
                scope.filtroAtivo = false;
                scope.countupDivs = null;
                scope.filtros = {};
                scope.countChart = 0;
                scope.valorAtual = [];
                scope.serieAtual = [];
                scope.detalhando = 0;
                scope.detalhandoCheck = false;
                scope.detalhes = [];
                scope.detalhesPartial = [];
                scope.chartsAnimated = [];
                scope.chartChoosen = {};
                scope.clickingData = undefined;
                scope.clickingDataDisplay = undefined;
                scope.isFullscreen = false;
                scope.detalheCount = 25;
                scope.detalheCountCurrent = 0;
                scope.window = $window;

                scope.render = function () {
                    if (scope.modelObject) {
                        var type = scope.modelObject.data.type;
                        if (scope.modelObject.chartId > 0) {
                            if (type.indexOf('peity') < 0) {
                                scope.bindC3();
                            } else {
                                scope.bindPeity();
                            }
                        }
                    }
                };

                scope.formatLabel = function (valor, formatter) {
                    var formatNumber = function (n) {
                        return n > 9 ? "" + n : "0" + n;
                    }
                    if (formatter != null) {
                        if (formatter == '%') {
                            return valor + '%';
                        } else if (formatter.indexOf('$') >= 0) {
                            return $filter('currency')(valor, formatter, 2);
                        } else if (formatter.indexOf('min') >= 0) {
                            var realmin = Math.floor(valor % 60);
                            var hours = Math.floor(valor / 60);
                            var valorFormatado = formatNumber(hours.toFixed()) + ':' + formatNumber(realmin.toFixed());
                            return valorFormatado;
                        } else if (formatter.length > 0) {
                            return $filter('date')(valor, formatter, 'UTC');
                        } else {
                            return valor;
                        }
                    }
                    return valor;
                };




                scope.$watch(function () {
                    return scope.$eval(attrs.useSize);
                }, function () {
                    scope.useSize = scope.$eval(attrs.useSize);
                });

                scope.$watch(function () {
                    return (typeof scope.data) == 'string' ? scope.$eval(scope.data) : scope.data;
                }, function (newValue) {
                    if (newValue && newValue.data) {
                        if (!scope.modelObject) {
                            scope.modelObject = newValue;
                        } else {
                            scope.modelObject.data = newValue.data;
                            scope.modelObject.dataAtualizado = newValue.dataAtualizado;
                            scope.modelObject.axis = newValue.axis;
                            scope.modelObject.filtros = newValue.filtros;
                        }
                    }
                    scope.render();
                });


                var resizedOnce = false;
                scope.resizeCharts = function () {
                    var height, width;
                    if (scope.chartGenerated != null && scope.modelObject.data.type.indexOf('peity') < 0) {
                        if (!scope.modelObject.grupo) {
                            height = element.find('.chartDiv').height();
                            width = element.find('.chartDiv').width();
                            scope.chartGenerated.resize({
                                height: height,
                                width: width
                            });
                        } else {
                            if (resizedOnce == false) {
                                for (var i = 0; i < scope.modelObject.data.json.length; i++) {
                                    height = element.find('.chartDiv-' + i).height();
                                    width = element.find('.chartDiv-' + i).width();
                                    scope.chartGenerated[i].resize({
                                        height: height,
                                        width: width
                                    });
                                }
                                resizedOnce = true;
                            }
                        }
                    }
                };

                scope.bindPeity = function () {
                    scope.countupPrefix = '';
                    scope.countupSuffix = '';
                    scope.peity = true;
                    if (scope.modelObject.tooltipValor) {
                        if (scope.modelObject.tooltipValor == '%') {
                            scope.countupSuffix = '%';
                        } else if (scope.modelObject.tooltipValor.indexOf('$') >= 0) {
                            scope.countupPrefix = scope.modelObject.tooltipValor;
                        }
                    }

                    var dataArr = [], jsonObject;

                    if (!scope.modelObject.grupo) {
                        scope.grupo = false;
                        jsonObject = scope.modelObject.data.json;
                        
                        if (jsonObject.length > 0) {
                            scope.serieAtual = jsonObject[jsonObject.length - 1][scope.modelObject.data.keys.x];
                            scope.valorAtual = jsonObject[jsonObject.length - 1][scope.modelObject.data.keys.value[0]];
                            if (scope.ultimaSerie != scope.serieAtual || scope.ultimoValor != scope.valorAtual) {
                                scope.ultimaSerie = scope.serieAtual;
                                scope.ultimoValor = scope.valorAtual;
                                for (var i = 0; i < jsonObject.length; i++) {
                                    dataArr.push(jsonObject[i][scope.modelObject.data.keys.value[0]]);
                                }
                                if (!scope.chartGenerated) {
                                    var type = scope.modelObject.data.type;
                                    type = type.replace('-peity', '');
                                    var chartOptions = {
                                        height: 28,
                                        width: 64,
                                        stroke: "#0288d1",
                                        max: scope.modelObject.axis.y.max,
                                    };
                                    scope.chartGenerated = element.find(".chartDiv").peity(type, chartOptions);
                                    scope.chartGenerated
                                        .text(dataArr.join(","))
                                        .change();
                                    $timeout(function () {
                                        scope.countChart = scope.valorAtual;
                                    }, 100);

                                } else {
                                    var values = scope.chartGenerated.text().split(",");
                                    if (scope.ultimaSerie != scope.serieAtual) {
                                        values.shift();
                                    } else {
                                        values.pop();
                                    }
                                    values.push(scope.valorAtual);
                                    scope.chartGenerated
                                        .text(values.join(","))
                                        .change();
                                    $timeout(function () {
                                        scope.countChart = scope.valorAtual;
                                    }, 100);
                                }
                            }
                        } else {
                            // eslint-disable-next-line no-console
                            console.log('[GRÁFICOS] Json passado é nulo');
                        }
                    } else {
                        scope.grupo = true;

                        if (!scope.chartGenerated) {
                            var container = element.find('.chartDiv');
                            var grid = $('<div></div>');
                            grid.addClass('uk-grid');
                            grid.css({
                                "margin-left": "0px"
                            });
                            grid.appendTo(container);
                            scope.chartGenerated = [];
                            scope.serieAtual = [];
                            scope.valorAtual = [];
                            scope.countChart = [];
                            scope.ultimoValor = [];
                            scope.ultimaSerie = [];
                            scope.countupDivs = [];
                            scope.valorAntigo = [];
                            var gridSize = 4;
                            var gridCount = 0;
                        }

                        for (i = 0; i < scope.modelObject.data.json.length; i++) {
                            var dataLength = scope.modelObject.data.json[i].data.length;
                            if (dataLength > 0) {
                                jsonObject = scope.modelObject.data.json[i].data[dataLength - 1];
                                dataArr = [];
                                scope.serieAtual[i] = jsonObject[scope.modelObject.data.keys.x];
                                scope.valorAtual[i] = jsonObject[scope.modelObject.data.keys.value[i]];
                                if (scope.ultimaSerie[i] != scope.serieAtual[i] || scope.ultimoValor[i] != scope.valorAtual[i]) {
                                    scope.ultimaSerie[i] = scope.serieAtual[i];
                                    scope.valorAntigo[i] = scope.ultimoValor[i];
                                    scope.ultimoValor[i] = scope.valorAtual[i];
                                    for (var key in jsonObject) {
                                        if (jsonObject.hasOwnProperty(key) && key != scope.modelObject.data.keys.x) {
                                            dataArr.push(jsonObject[key]);
                                        }
                                    }
                                    if (!scope.chartGenerated[i]) {
                                        var title = scope.modelObject.data.json[i][scope.modelObject.grupo];
                                        var chartDiv = $('<div></div>');
                                        var spanTitle = $("<span></span>");
                                        var h2Count = $("<h2></h2>");
                                        var spanCount = $("<span></span>");
                                        var SVGDiv = $('<div></div>');
                                        var chartSVG = $('<div></div>');

                                        chartDiv.css({
                                            'border-right': '1px solid #ccc',
                                            'border-left': '1px solid #ccc',
                                            'padding-left': '15px',
                                            'padding-right': '15px',
                                        });

                                        if (gridCount == 0 && i >= scope.modelObject.data.json.length - 3)
                                            gridSize = scope.modelObject.data.json.length % 4;

                                        gridCount++;

                                        if (gridCount == 4)
                                            gridCount = 0;

                                        chartDiv.addClass('uk-width-medium-1-' + gridSize);
                                        chartDiv.appendTo(grid);

                                        spanTitle.addClass('uk-text-muted uk-text-small');
                                        spanTitle.text(title);
                                        spanTitle.appendTo(chartDiv);

                                        SVGDiv.addClass('uk-float-right uk-margin-top uk-margin-small-right');
                                        SVGDiv.appendTo(chartDiv);

                                        chartSVG.addClass('chartDiv-' + scope.modelObject.chartid + '-' + i);
                                        chartSVG.appendTo(SVGDiv);

                                        h2Count.addClass('uk-margin-remove');
                                        h2Count.appendTo(chartDiv);

                                        scope.countChart[i] = 0;
                                        spanCount.attr('id', 'count-' + scope.modelObject.chartId + '-' + i);
                                        spanCount.text('0');
                                        scope.countupDivs[i] = spanCount;
                                        spanCount.appendTo(h2Count);

                                        var type = scope.modelObject.data.type;
                                        type = type.replace('-peity', '');
                                        var chartOptions = {
                                            height: 28,
                                            width: 64,
                                            stroke: "#0288d1",
                                            max: scope.modelObject.axis.y.max
                                        };
                                        scope.chartGenerated[i] = element.find(".chartDiv-" + scope.modelObject.chartid + '-' + i).peity(type, chartOptions);
                                        scope.chartGenerated[i]
                                            .text(dataArr.join(","))
                                            .change();

                                    } else {
                                        var values = scope.chartGenerated[i].text().split(",");
                                        if (scope.ultimaSerie[i] != scope.serieAtual[i]) {
                                            values.shift();
                                        } else {
                                            values.pop();
                                        }
                                        values.push(scope.valorAtual[i]);
                                        scope.chartGenerated[i]
                                            .text(values.join(","))
                                            .change();
                                    }
                                }
                            } else {
                                // eslint-disable-next-line no-console
                                console.log('[GRÁFICOS] Json passado é nulo');
                            }
                        }

                        $timeout(function () {
                            var options = {
                                useEasing: true,
                                prefix: scope.countupPrefix,
                                suffix: scope.countupSuffix,
                                separator: '.'
                            };

                            for (var i = 0; i < scope.modelObject.data.json.length; i++) {
                                scope.valorAntigo[i] = scope.valorAntigo[i] | scope.valorAtual[i];
                                if (!isNaN(scope.valorAntigo[i]) && !isNaN(scope.valorAtual[i]))
                                    new CountUp('count-' + scope.modelObject.chartId + '-' + i, scope.valorAntigo[i], scope.valorAtual[i], 0, 2, options).start();
                            }
                        }, 100);
                    }
                };

                scope.isVisible = false;
                scope.bindC3 = function () {
                    scope.modelObject.data.selection = {
                        enabled: true,
                        multiple: false,
                        grouped: scope.modelObject.data.type == 'bar',
                        draggable: false,
                        isselectable: function (d) {
                            return d.value != null;
                        }
                    };
                    if (scope.regenerate || scope.regenerateOnce) {
                        if (scope.chartGenerated) {
                            if (Array.isArray(scope.chartGenerated)) {
                                angular.forEach(scope.chartGenerated, function (value) {
                                    value.destroy();
                                });
                            } else scope.chartGenerated.destroy();
                        }
                        scope.chartGenerated = null;
                        scope.regenerateOnce = false;
                    }
                    if (!scope.chartGenerated) {
                        scope.peity = false;

                        scope.reconfigGrafico();
                        var graficoTmp = {};
                        angular.copy(scope.modelObject, graficoTmp);


                        if (!graficoTmp.grupo) { //GENERATE CHART WITHOUT GROUPING
                            graficoTmp.bindto = element.find(".chartDiv").get(0);
                            $(graficoTmp.bindto).addClass('c3chart chartSVG chart-size');

                            if (graficoTmp.data.type.indexOf('bar-horizontal') >= 0) {
                                graficoTmp.axis.rotated = true;
                                graficoTmp.data.type = 'bar';
                                graficoTmp.data.selection.enabled = false;
                            }

                            var xelems = [];
                            graficoTmp.data.json.forEach(function (element) {
                                var xelemAtual = element[graficoTmp.data.keys.x];
                                if (!_.contains(xelems, xelemAtual)) {
                                    xelems.push(xelemAtual);
                                }
                            }, this);

                            if (graficoTmp.axis.x.tick && xelems.length < graficoTmp.axis.x.tick.count) {
                                graficoTmp.axis.x.tick.count = xelems.length;
                                graficoTmp.axis.x.tick.culling.max = xelems.length;
                            } else {
                                graficoTmp.padding = {
                                    right: 5
                                };
                            }

                            scope.chartGenerated = c3.generate(graficoTmp);

                            visibilityWatchers.push($interval(function () {
                                if (element.find('.chartDiv').is(":visible") != scope.isVisible && scope.isVisible == false) {
                                    scope.isVisible = !scope.isVisible;
                                    scope.resizeCharts();
                                }
                            }, 500, 0, false));
                        } else { //GENERATE CHART GROUPING DATA
                            var container = element.find('.chartDiv');
                            container.empty();
                            var grid = $('<div></div>');
                            grid.addClass('uk-grid');
                            grid.css({
                                "margin-left": "0px"
                            });
                            grid.appendTo(container);

                            var gridSize = 3;
                            var gridCount = 0;

                            for (var i = 0; i < scope.modelObject.data.json.length; i++) {
                                var title = scope.modelObject.data.json[i][scope.modelObject.grupo];
                                var chartDiv = $('<div></div>');
                                var chartTitle = $("<h5></h5>");
                                var chartSVG = $('<div></div>');

                                chartDiv.css({
                                    'padding-left': '0px'
                                });
                                chartTitle.css({
                                    'font-size': '16px',
                                    'font-weight': '400',
                                    'color': '#5a5a5a',
                                    'margin-bottom': '0px'
                                });

                                if (gridCount == 0 && i >= scope.modelObject.data.json.length - 2)
                                    gridSize = scope.modelObject.data.json.length % 3;

                                gridCount++;


                                if (gridCount == 3)
                                    gridCount = 0;

                                chartDiv.addClass('uk-align-title uk-width-medium-1-' + gridSize);
                                chartDiv.appendTo(grid);

                                chartTitle.css({
                                    "text-align": "center"
                                });
                                chartTitle.text(title);
                                chartTitle.appendTo(chartDiv);

                                chartSVG.addClass('chartSVG chart-size chartDiv-' + i);
                                chartSVG.appendTo(chartDiv);


                                graficoTmp.bindto = element.find(".chartDiv-" + i).get(0);
                                graficoTmp.data.json = scope.modelObject.data.json[i].data;

                                var legends = [];

                                for (var key in graficoTmp.data.json) {
                                    if (graficoTmp.data.json.hasOwnProperty(key)) {
                                        var obj = graficoTmp.data.json[key];
                                        for (var prop in obj) {
                                            if (!_.contains(legends, prop))
                                                legends.push(prop);
                                        }
                                    }
                                }

                                graficoTmp.data.keys.value = _.intersection(legends, graficoTmp.data.keys.value);

                                if (graficoTmp.data.type.indexOf('bar-horizontal') >= 0) {
                                    graficoTmp.axis.rotated = true;
                                    graficoTmp.data.type = 'bar';
                                    graficoTmp.data.selection.enabled = false;
                                }

                                var xelems = [];
                                graficoTmp.data.json.forEach(function (element) {
                                    var xelemAtual = element[graficoTmp.data.keys.x];
                                    if (!_.contains(xelems, xelemAtual)) {
                                        xelems.push(xelemAtual);
                                    }
                                }, this);

                                if (graficoTmp.axis.x.tick && xelems.length < graficoTmp.axis.x.tick.count) {
                                    graficoTmp.axis.x.tick.count = xelems.length;
                                    graficoTmp.axis.x.tick.culling.max = xelems.length;
                                } else {
                                    var tickDefault = angular.copy(graficoTmp.axis.x.tick);
                                    graficoTmp.padding = {
                                        right: 10
                                    };
                                }

                                if (scope.chartGenerated == null) {
                                    scope.chartGenerated = [];
                                }
                                scope.chartGenerated[i] = c3.generate(graficoTmp);
                                graficoTmp.axis.x.tick = tickDefault;

                                visibilityWatchers.push($interval(function () {
                                    if (element.find('.chartDiv-0').is(":visible") != scope.isVisible && element.find('.chartDiv').is(":visible") != scope.isVisible && scope.isVisible == false) {
                                        scope.isVisible = !scope.isVisible;
                                        scope.resizeCharts();
                                    }
                                }, 500, 0, false));
                            }
                        }

                        graficoTmp.filtros.forEach(function (el) {
                            if (el.ValorPadrao == 'true')
                                scope.filtros[el.Nome] = true;
                            else if (el.Tipo == 'Date')
                                scope.filtros[el.Nome] = el.ValorPadrao;
                            else if (el.Tipo != undefined)
                                scope.filtros[el.Nome] = el.ValorPadrao;
                            else
                                scope.filtros[el.Nome] = '';
                        });
                        scope.graficoRenderizado = true;

                    } else {
                        if (!scope.modelObject.grupo) {
                            scope.modelObject.data.unload = true;

                            if (scope.modelObject.data.type.indexOf('bar-horizontal') >= 0) {
                                scope.modelObject.data.type = 'bar';
                            }

                            scope.chartGenerated.load(scope.modelObject.data);
                        } else {
                            var graficoTmp = {};
                            for (var i = 0; i < scope.modelObject.data.json.length; i++) {
                                graficoTmp[i] = {};
                                angular.copy(scope.modelObject, graficoTmp[i]);
                                graficoTmp[i].data.json = scope.modelObject.data.json[i].data;

                                var legends = [];
                                for (var key in graficoTmp[i].data.json) {
                                    if (graficoTmp[i].data.json.hasOwnProperty(key)) {
                                        var obj = graficoTmp[i].data.json[key];
                                        for (var prop in obj) {
                                            if (!_.contains(legends, prop))
                                                legends.push(prop);
                                        }
                                    }
                                }
                                graficoTmp[i].data.keys.value = _.intersection(legends, graficoTmp[i].data.keys.value);

                                if (graficoTmp[i].data.type.indexOf('bar-horizontal') >= 0) {
                                    graficoTmp[i].data.type = 'bar';
                                }

                                scope.chartGenerated[i].load(graficoTmp[i].data);
                            }
                        }
                    }
                };

                scope.mostrarFiltros = function ($event) {
                    $event.preventDefault();
                    scope.filtroAtivo = !scope.filtroAtivo;
                    $timeout(function () {
                        var card = angular.element(element[0].querySelector('.md-card'));
                        if (scope.filtroAtivo) {
                            card.addClass('md-card-overlay-active');
                        } else {
                            card.removeClass('md-card-overlay-active');
                        }
                    }, 100);
                };

                scope.atualizarGrafico = function () {
                    var filtroData = {
                        chartId: scope.modelObject.chartId,
                        filtros: scope.filtros
                    };

                    var filtrando = false;
                    for (var propt in scope.filtros) {
                        if (!filtrando)
                            filtrando = scope.filtros[propt] != null && scope.filtros[propt] != '' && (typeof scope.filtros[propt] == 'string' && scope.filtros[propt].toLowerCase() != 'false');
                    }
                    scope.modelObject.filtrando = filtrando;

                    DashboardResource.filtrarGrafico(filtroData).$promise
                        .then(function (result) {
                            result.data.unload = _.difference(scope.modelObject.data.keys.value, result.data.keys.value);

                            if (scope.modelObject) {
                                scope.modelObject.data = result.data;
                                scope.modelObject.dataAtualizado = result.dataAtualizado;
                                scope.modelObject.axis = result.axis;
                                scope.modelObject.filtros = result.filtros;
                            }

                            scope.regenerateOnce = true;
                            scope.modelObject.filtrando = filtrando;
                            scope.render();
                        });
                };

                scope.filtrar = function () {

                    $timeout(function () {
                        var filtroData = {
                            chartId: scope.modelObject.chartId,
                            filtros: scope.filtros
                        };

                        scope.filtroAtivo = !scope.filtroAtivo;
                        var filtrando = false;
                        for (var propt in scope.filtros) {
                            if (!filtrando)
                                filtrando = scope.filtros[propt] != null && scope.filtros[propt] != '' && (typeof scope.filtros[propt] == 'string' && scope.filtros[propt].toLowerCase() != 'false');
                        }

                        var chartScope = scope.data;
                        chartScope.filtrando = filtrando;

                        DashboardResource.filtrarGrafico(filtroData).$promise
                            .then(function (result) {
                                result.data.unload = _.difference(scope.modelObject.data.keys.value, result.data.keys.value);
                                result.filtrando = filtrando;

                                if (scope.modelObject) {
                                    scope.modelObject.data = result.data;
                                    scope.modelObject.dataAtualizado = result.dataAtualizado;
                                    scope.modelObject.axis = result.axis;
                                    scope.modelObject.filtros = result.filtros;
                                }

                                scope.regenerateOnce = true;
                                var chartScope = scope.data;
                                chartScope.filtrando = filtrando;
                                scope.modelObject.filtrando = filtrando;
                                scope.render();
                            });

                        scope.getDetalhes();
                    }, 0);
                };

                scope.reconfigGrafico = function () {
                    scope.modelObject.axis.y.tick = {
                        format: function (value) {
                            return scope.formatLabel(value, scope.modelObject.tooltipValor);
                        }
                    };

                    scope.modelObject.tooltip = {
                        contents: function (d) {
                            var contentTemplate = '<table class="c3-tooltip"><tbody>content</tbody></table>';
                            var categoriaTemplate = '<tr><th colspan="2">content</th></tr>';
                            var serieTemplate = '<tr class="c3-tooltip-name-content"><td class="name"><span style="background-color:colorContent"></span>content</td>';
                            var valorTemplate = '<td class="value">content</td></tr>';
                            var tr = '';
                            if ((d[0].index || d[0].index == 0) && !d[0].ratio)
                                if (!scope.modelObject.tooltipCategoria)
                                    tr += categoriaTemplate.replace(/content/g, this.api.categories()[d[0].index]);
                                else
                                    tr += categoriaTemplate.replace(/content/g, scope.formatLabel(this.api.categories()[d[0].index], scope.modelObject.tooltipCategoria));

                            for (var i = 0; i < d.length; i++) {
                                if (d[i].value != null) {
                                    if (!scope.modelObject.tooltipSerie)
                                        tr += serieTemplate.replace(/content/g, d[i].name);
                                    else
                                        tr += serieTemplate.replace(/content/g, scope.formatLabel(d[i].name, scope.modelObject.tooltipSerie));

                                    var colorName = d[i].name;
                                    if (d[i].name == '') colorName = '[object Object]';
                                    tr = tr.replace(/colorContent/g, this.api.data.colors()[colorName]);

                                    if (!scope.modelObject.tooltipValor)
                                        tr += valorTemplate.replace(/content/g, d[i].value);
                                    else
                                        tr += valorTemplate.replace(/content/g, scope.formatLabel(d[i].value, scope.modelObject.tooltipValor));
                                }
                            }

                            var content = contentTemplate.replace('content', tr);

                            return content;
                        }
                    };

                    scope.modelObject.data.onclick = function (d) {
                        if (d.value != null) {
                            if (scope.chartGenerated[0]) {
                                for (var key in scope.chartGenerated) {
                                    if (scope.chartGenerated.hasOwnProperty(key)) {
                                        if (scope.chartGenerated[key] != this) {
                                            scope.chartsAnimated.push(scope.chartGenerated[key]);
                                        }
                                    }
                                }
                            }
                            scope.chartChoosen = this;
                            scope.clickingData = {
                                serie: d.name,
                                categoria: d.x || d.x == 0 ? this.categories()[d.index] : null,
                                grupo: $(this.element).siblings().text()
                            };
                            scope.clickingData.categoria = this.categories().length == 1 ? this.categories()[0] : scope.clickingData.categoria;
                            if (!scope.detalhandoCheck) {
                                scope.clickingDataDisplay = {
                                    serie: d.name ? d.name : d.id,
                                    categoria: d.x || d.x == 0 ? this.categories()[d.index] : null
                                };
                                scope.clickingDataDisplay.categoria = this.categories().length == 1 ? this.categories()[0] : scope.clickingDataDisplay.categoria;
                            } else {
                                var serie = d.name ? d.name : d.id;
                                scope.clickingDataDisplay.serie = scope.clickingDataDisplay.serie + "/" + serie;
                            }

                            if (!scope.detalhandoCheck) {
                                scope.detalhes = [];
                            }
                            scope.makeDetalheRequest();

                            scope.detalhandoCheck = true;

                            if (scope.isFullscreen == false) {
                                scope.isFullscreen = true;
                                var myEvent = new CustomEvent('activateFullscreen', {
                                    'detail': {
                                        dontRunFunction: true
                                    }
                                });
                                scope.makeCardFullscreen(myEvent);
                                if (scope.chartGenerated[0]) {
                                    for (var i = 0; i < scope.chartsAnimated.length; i++) {
                                        var els = [];
                                        els.push($(scope.chartsAnimated[i].element).parent()[0]);
                                        els.push($(scope.chartsAnimated[i].element).parent().children()[1]);
                                        els.push($(scope.chartsAnimated[i].element.children[0])[0]);
                                        $(els)
                                            .css({
                                                'display': 'none'
                                            });
                                        els = [];
                                        els.push($(scope.chartChoosen.element).parent()[0]);
                                        els.push($(scope.chartChoosen.element).parent().children()[1]);
                                        // scope.resizeCharts();
                                    }
                                }
                            }
                        }
                    };
                };

                scope.getDetalhes = function (serie, categoria) {
                    var deferred = $q.defer();
                    var filtroData = {
                        chartId: scope.modelObject.chartId,
                        filtros: scope.filtros,
                        serie: serie ? serie : null,
                        categoria: categoria ? categoria : null
                    };

                    var filtrando = false;
                    for (var propt in scope.filtros) {
                        if (!filtrando)
                            filtrando = scope.filtros[propt] != null && scope.filtros[propt] != '' && (typeof scope.filtros[propt] == 'string' && scope.filtros[propt].toLowerCase() != 'false');
                    }
                    scope.modelObject.filtrando = filtrando;

                    scope.detalhando++;

                    scope.detalhandoCheck = true;
                    DashboardResource.detalhado(filtroData).$promise
                        .then(function (result) {
                            if (scope.clickingData && scope.clickingData.grupo != '') {
                                result = _.reject(result, function (elem) {
                                    return elem[scope.modelObject.grupo] != scope.clickingData.grupo;
                                });
                            }

                            scope.detalhes = [];
                            for (var i = 0; i < result.length; i++) {
                                scope.detalhes.push(result[i]);
                            }

                            if (scope.detalhando == 1) {
                                deferred.resolve();
                                scope.detalhesPartial = [];
                                scope.detalheCountCurrent = 0;
                                scope.loadMore();
                                scope.detalhandoCheck = false;
                            }
                            scope.detalhando--;
                        })
                        .catch(function () {
                            deferred.reject();
                        });

                    return deferred.promise;
                };

                scope.loadMore = function () {
                    scope.detalhesPartial = scope.detalhesPartial.concat(scope.detalhes.slice(scope.detalheCountCurrent, scope.detalheCountCurrent + scope.detalheCount));
                    scope.detalheCountCurrent += scope.detalheCount;
                };

                scope.setFullscreenFn = function (directiveFn) {
                    scope.makeCardFullscreen = directiveFn;
                };

                scope.finishAnimation = function () {
                    if (scope.clickingData == undefined)
                        scope.makeDetalheRequest();
                };

                scope.makeDetalheRequest = function () {
                    if (scope.clickingData == undefined)
                        scope.getDetalhes();
                    else {
                        scope.getDetalhes(scope.clickingData.serie, scope.clickingData.categoria);
                    }
                };

                scope.activateFullscreen = function () {
                    scope.detalhandoCheck = true;
                    scope.isFullscreen = true;
                    if (scope.clickingData == undefined && !scope.peity) {
                        if (scope.chartGenerated[0]) {
                            for (var index in scope.chartGenerated) {
                                scope.chartGenerated[index].unselect();
                            }
                        } else {
                            scope.chartGenerated.unselect();
                        }
                    }
                };

                scope.deactivateFullscreen = function () {
                    scope.detalhes = [];
                    scope.isFullscreen = false;
                    scope.clickingData = undefined;
                    scope.clickingDataDisplay = undefined;

                    if (scope.chartGenerated[0]) {
                        for (var i = 0; i < scope.chartsAnimated.length; i++) {
                            var els = [];
                            els.push($(scope.chartsAnimated[i].element).parent()[0]);
                            els.push($(scope.chartsAnimated[i].element).parent().children()[1]);
                            els.push($(scope.chartsAnimated[i].element.children[0])[0]);
                            $(els)
                                .css({
                                    'display': 'block'
                                });
                            els = [];
                            els.push($(scope.chartChoosen.element).parent()[0]);
                            els.push($(scope.chartChoosen.element).parent().children()[1]);
                            $(els).css({
                                'width': ''
                            });
                        }
                        // scope.resizeCharts();
                    }
                    scope.chartsAnimated = [];
                    scope.chartChoosen = {};
                    scope.$apply();
                }

                scope.render();

                scope.$on('$destroy', function () {
                    visibilityWatchers.forEach(function (handle) {
                        $interval.cancel(handle);
                    });
                    visibilityWatchers.length = 0;

                    if (scope.chartGenerated) {
                        if (Array.isArray(scope.chartGenerated)) {
                            scope.chartGenerated.forEach(function (chart) {
                                if (chart && typeof chart.destroy === 'function') chart.destroy();
                            });
                        } else if (typeof scope.chartGenerated.destroy === 'function') {
                            scope.chartGenerated.destroy();
                        }
                        scope.chartGenerated = null;
                    }
                });
            }
        }
    }]);

"use strict";

angular.module('epbxManagerApp')

.directive('emGraficoPizza', ["$timeout", function ($timeout) {
    return {
        restrict: 'E',
        transclude: true,
        templateUrl: 'app/directives/templates/emGraficoPizza.html',
        scope: {
            dados: '='
        },        
        link: function (scope, element, attrs) {

            scope.initCharts = function () {

                var chart = AmCharts.makeChart("graficoBigTalk", {
                    "type": "pie",
                    "theme": "light",
                    "language": "pt",
                    "dataProvider": scope.dados,
                    "valueField": "Quantidade",
                    "titleField": "Classificacao",
                    "colorField": "Color",
                    "plotAreaBorderAlpha": 0,
                    "marginTop": 10,
                    "marginLeft": 20,
                    "zoomOutText": "",
                    "mouseWheelZoomEnabled": false,
                    "marginBottom": 0,
                    "balloon": { "fixedPosition": true },
                    "export": { "enabled": false },
                    "legend": {
                        "equalWidths": false,
                        "periodValueText": "Ativo: [[value.sum]]",
                        "position": "bottom",
                        "align": "center",
                        "valueAlign": "center",
                        "marginRight": 0,
                        "horizontalGap": 0,
                        "color": "#333",
                        "markerSize": 10,
                    },
                });
            };

            scope.$watch('dados', function (newValue, oldValue) {
                if (newValue != oldValue) {                        
                    scope.initCharts();                        
                }
            });

           
            $timeout(function () {
                scope.initCharts();
            }, 300);             
        }
    };
}]);
angular.module('epbxManagerApp')
.directive('emHideMobile', ['$window', function ($window) {

    return {
        restrict: 'A',
        link: function ($scope, $element, $attr) {

            // Setup a match media query listener that triggers a ui change only when a change            
            var mq = $attr.emHideMobile == 'true' ? '(min-width:768px)' : 'large';
            var mql = $window.matchMedia(mq);
            mql.addListener(checkExpose);

            function checkExpose() {
                var matches = !$window.matchMedia(mq).matches;

                if (matches && $window.matchMedia(mq).media != 'large') {
                    $element.toggleClass('ng-hide', true);
                    $element.toggleClass('ng-show', false);
                }
                else {
                    $element.toggleClass('ng-show', true);
                    $element.toggleClass('ng-hide', false);
                }
            }

            $scope.$evalAsync(checkExpose);
        }
    };
}]);
angular.module('epbxManagerApp')
    .directive('emHistoricoAlteracao', ["$translate", function ($translate) {
        return {
            template: ` <div> 
            <span ng-if="!usuarioAlteracao"> {{::'diretivas.templateCadastro' | translate }}  {{cadastro  | formatData}} {{::'diretivas.peloUsuario' | translate }}  {{usuarioCadastro}}</span>
            <span ng-if="usuarioAlteracao">  {{::'diretivas.templateAlterado' | translate }}  {{alteracao | formatData}} {{::'diretivas.peloUsuario' | translate }}  {{usuarioAlteracao}}</span> 
            </div>`,
            restrict: 'E',
            scope: {                
                cadastro: '@',
                alteracao: '@',
                usuarioCadastro: '@',
                usuarioAlteracao: '@'
            },
            link: function (scope) {            

                scope.$watch('cadastro', function (newValue, oldValue) {
                    if (newValue != oldValue) {                        
                        scope.cadastro = newValue;             
                    }
                });

                
                scope.$watch('alteracao', function (newValue, oldValue) {
                    if (newValue != oldValue) {                        
                        scope.alteracao = newValue;             
                    }
                });

                
                scope.$watch('usuarioCadastro', function (newValue, oldValue) {
                    if (newValue != oldValue) {                        
                        scope.usuarioCadastro = newValue;             
                    }
                });

                
                scope.$watch('usuarioAlteracao', function (newValue, oldValue) {
                    if (newValue != oldValue) {                        
                        scope.usuarioAlteracao = newValue;             
                    }
                });
            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emInfiniteScroll', function () {
        return function (scope, elm, attr) {
            var raw = elm[0];

            scope.checkScroll = function () {
                if (raw.scrollTop + raw.offsetHeight + 100 >= raw.scrollHeight) {
                    scope.$apply(attr.emInfiniteScroll);
                }
            };

            elm.bind('scroll', scope.checkScroll);

        };
    })

    .directive('emInfiniteScrollFull', ['$window', '$document', function ($window, $document) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                var checkWhenEnabled, handler, scrollDistance, scrollEnabled;
                $window = angular.element($window);
                scrollDistance = 0;
                if (attrs.infiniteScrollDistance != null) {
                    scope.$watch(attrs.infiniteScrollDistance, function (value) {
                        return scrollDistance = parseInt(value, 10);
                    });
                }
                scrollEnabled = true;
                checkWhenEnabled = false;
                if (attrs.infiniteScrollDisabled != null) {
                    scope.$watch(attrs.infiniteScrollDisabled, function (value) {
                        scrollEnabled = !value;
                        if (scrollEnabled && checkWhenEnabled) {
                            checkWhenEnabled = false;
                            return handler();
                        }
                    });
                }
                handler = function () {
                    var elementBottom, remaining, shouldScroll, windowBottom;
                    windowBottom = $window.height() + $window.scrollTop();
                    elementBottom = elem.offset().top + elem.height();
                    remaining = elementBottom - windowBottom;
                    shouldScroll = remaining <= $window.height() * scrollDistance;
                    if (shouldScroll && scrollEnabled) {
                        if ($document[0].readyState === "complete") {
                            return scope.$apply(attrs.emInfiniteScrollFull);
                        } else {
                            return checkWhenEnabled = true;
                        }
                    }
                };
                $window.on('scroll', handler);
                scope.$on('$destroy', function () {
                    return $window.off('scroll', handler);
                });
                return handler();
            }
        };
    }]);


angular.module('epbxManagerApp')

    .directive('emInputDinamico', ["$timeout", "$http", "Config", function ($timeout, $http, Config) {
        return {
            restrict: 'E',
            scope: {
                Nome: '=nome',
                Alias: '=alias',
                Tipo: '=tipo',
                Origem: '=origem',
                PropriedadeNome: '=propriedadeNome',
                PropriedadeValor: '=propriedadeValor',
                Regex: '=regex',
                Id: '=id',
                NoLabel: '=noLabel',
                ngModel: '=ngModel',
                culture: '=culture'
            },
            replace: true,
            templateUrl: 'app/directives/templates/emInputDinamico.html',
            link: function (scope, element) {
                scope.bound = false;

                if (scope.Tipo == 'List') {
                    if (scope.Origem.indexOf('http') == -1) {
                        scope.Origem = Config.getUrl(scope.Origem);
                    }

                    $http.get(scope.Origem).then(function (response) {
                        $('#' + scope.Id).kendoDropDownList({
                            optionLabel: scope.Alias,
                            dataTextField: scope.PropriedadeNome,
                            dataValueField: scope.PropriedadeValor,
                            change: function () {
                                scope.ngModel = this.value() + '';
                            },
                            dataSource: {
                                data: response.data
                            },
                            index: response.data.map(function (item) {
                                return item[scope.PropriedadeValor];
                            }).indexOf(scope.ngModel),
                        }).data('kendoDropDownList');
                    });
                } else if (scope.Tipo == 'Date') {
                    scope.$on("kendoWidgetCreated", function () {
                        $timeout(function () {
                            if (element.find("#" + scope.Id).length > 0) {
                                scope.bindDate();
                            } else {
                                if ($(element).parents('.md-card-overlay-content').length > 0) {
                                    scope.$watch(function () {
                                        return $(element).parents('.md-card-overlay-content').css('display');
                                    }, function (newval) {
                                        if (newval == 'block') {
                                            scope.bindDate();
                                        }
                                    });
                                }

                                $(element.find('.datepicker-input').get(0)).bind("DOMSubtreeModified", function () {
                                    scope.bindDate();
                                });
                            }
                        }, 0);

                    });
                }

                scope.openDate = function () {
                    var datepicker = $('#' + scope.Id).data('kendoDateTimePicker');
                    if (datepicker)
                        datepicker.open();
                };

                scope.openTime = function () {
                    var datepicker = $('#' + scope.Id).data('kendoTimePicker');
                    if (datepicker)
                        datepicker.open();
                };

                scope.bindDate = function () {
                    if ($("#" + scope.Id).get(0) && !scope.bound) {
                        scope.bound = true;

                        var bindValue = function (newVal) {
                            if (newVal && typeof (newVal) != 'object') {
                                const datepicker = $('#' + scope.Id);
                                if (datepicker) {
                                    const newDate = moment(new Date()).add(parseInt(newVal), 'minutes').toDate();
                                    datepicker.val = newDate;
                                }
                            } else if (typeof (newVal) == 'object') {
                                const value = this.value();
                                const now = moment(new Date()); //todays date
                                const end = moment(value); // another date
                                const duration = moment.duration(now.diff(end));
                                const mins = -(duration.asMinutes());
                                scope.ngModel = mins;
                            }
                        };

                        bindValue(scope.ngModel);

                        const datepicker = $('#' + scope.Id);
                        if (datepicker)
                            datepicker.bind("change", scope.bindScope);
                    }
                }

                scope.bindScope = function (element) {
                    const value = element.target.value;
                    const now = moment(new Date()); //todays date
                    const end = moment(value); // another date
                    const duration = moment.duration(now.diff(end));
                    const mins = -(duration.asMinutes());
                    scope.ngModel = mins;
                };

            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emInputEye', ["$timeout", "$http", "Config", function ($timeout, $http, Config) {
        return {
            restrict: 'E',
            templateUrl: 'app/directives/templates/emInputEye.html',
            require: '?ngModel',
            scope: {
                id: '@',
                ngModel: '=ngModel',
                translates: '@',
                icon: '@'
            },

            link: function (scope, element, ngModel) {
                
                scope.eye = false;
                scope.verSenha = function () {
                    let tInput = document.getElementById("input-chave-" + scope.id);

                    if (tInput.getAttribute('type') == 'password'){
                        tInput.setAttribute('type', 'text');
                        scope.eye = true;
                    }
                    else{
                        scope.eye = false;
                        tInput.setAttribute('type', 'password');
                    }
                }
            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emInputFile', ["$timeout", "$http", "Config", "$window", "$translate", function ($timeout, $http, Config, $window, $translate) {
        return {
            restrict: 'EA',
            scope: {
                controller: '@',
                onStart: '=',
                onSuccess: '=',
                onError: '=',
                onRemove: '=',
                maxFiles: '=',
                tipoFile: '=',
                postData: '=',
                showRemove: '=',
                metodo: '@',
                changeupload: '='
            },
            link: function (scope, element, attrs) {

                var changeupload = true;

                if (attrs.changeupload == undefined) {
                    changeupload = true;
                } else {
                    changeupload = (attrs.changeupload === "true");
                }

                scope.progressBar = 0;
                var drop = $(element).dropify({
                    showRemove: scope.showRemove,
                    messages: {
                        'default': $translate.instant('diretivas.arrasteESolteUmArquivoAqui'),
                        'replace': $translate.instant('diretivas.arrasteESolteUmArquivoParaTrocar'),
                        'remove': $translate.instant('botao.remover'),
                        'error': $translate.instant('diretivas.opaAlgoErradoAconteceu')
                    }
                });

                drop.on('dropify.afterClear', function () {
                    if (scope.onRemove) {
                        scope.$apply(scope.onRemove());
                    }
                });
                drop.on('dropify.errors', function (event) {
                    if (scope.onError) {
                        scope.$apply(scope.onError(event));
                    }
                });
                
                element.bind("click", function () {
                    this.value = null;
                });

                element.bind("change", function (changeEvent) {
                    if (changeupload) {
                        scope.$apply(function () {
                            scope.progressBar = 0;

                            var controllerName = scope.controller;
                            var controllerApi = Config.getUrl(controllerName) + '/' + scope.metodo;

                            if (changeEvent.target.files.length > 0) {
                                var fileread = changeEvent.target.files[0];

                                var formData = new FormData();
                                formData.append('uploadfile', fileread, escape(fileread.name));
                                if (scope.tipoFile)
                                    formData.append('tipoId', scope.tipoFile);

                                if (scope.postData) {
                                    for (var key in scope.postData) {
                                        if (!scope.postData.hasOwnProperty(key)) continue;
                                        formData.append(key, scope.postData[key]);
                                    }
                                }

                                var onSuccess = function (data) {
                                    $(element).parent().children('.dropify-preview').children().remove('.dropify-loading');
                                    $(element).parent().find('.dropify-render').show();
                                    scope.result = data;
                                    if (scope.onSuccess)
                                        scope.$apply(scope.onSuccess(data));
                                };

                                var onError = function (data) {
                                    $(element).parent().children('.dropify-preview').children().remove('.dropify-loading');
                                    $(element).parent().find('.dropify-render').show();
                                    scope.progressBar = 0;
                                    if (scope.onError)
                                        scope.$apply(scope.onError(data));
                                };

                                var continueUpload = function () {
                                    var templateLoading = '<div class="dropify-loading" style="width: 100%;height: 100%;">' +
                                        '<div style=" width: 100%; height: 100%; z-index: 10; background-color: rgba(0, 0, 0, 0.7);"></div>' +
                                        '<div class="uk-progress uk-active" style="top: 50%; left: 50%; transform: translate(-50%, -50%); position: absolute; width: 50%; z-index: 5; margin-top: 0;">' +
                                        '<div class="uk-progress-bar" style="width: 0%;"></div> </div></div>';

                                    $(element).parent().children('.dropify-preview').append(templateLoading);
                                    $(element).parent().find('.dropify-render').hide();

                                    $.ajax({
                                        type: 'POST',
                                        beforeSend: function (request) {
                                            request.setRequestHeader("Authorization", 'Bearer ' + angular.fromJson($window.localStorage.getItem("Token") || "{}").access_token);
                                        },
                                        url: controllerApi,
                                        data: formData,
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (response) {
                                            onSuccess(response);
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            onError(errorThrown);
                                        },
                                        xhr: function () {
                                            var xhr = new window.XMLHttpRequest();
                                            xhr.upload.addEventListener("progress", function (evt) {
                                                if (evt.lengthComputable) {
                                                    var percentComplete = Math.round((evt.loaded / evt.total) * 100);
                                                    $(element).parent().find('.uk-progress-bar').css({
                                                        width: percentComplete + '%'
                                                    });
                                                    $(element).parent().find('.uk-progress-bar').text(percentComplete + '%');
                                                }
                                            }, false);
                                            return xhr;
                                        },
                                    });
                                };

                                var promise;
                                if (scope.onStart)
                                    promise = scope.onStart();
                                if (promise) {
                                    promise.then(continueUpload).catch(function () {
                                        drop.data().dropify.clearElement();
                                    });
                                } else {
                                    continueUpload();
                                }
                            }
                        });
                    }
                });
            }

        };
    }])


    .directive('emInputFileClassic', ["$timeout", "$http", "Config", "$window", function ($timeout, $http, Config, $window) {
        return {
            restrict: 'EA',
            scope: {
                controller: '@',
                onStart: '=',
                onSuccess: '=',
                onError: '=',
                onRemove: '=',
                onProgress: '=',
                maxFiles: '=',
                tipoFile: '=',
                postData: '=',
                metodo: '@',
                changeupload: '='
            },
            link: function (scope, element, attrs) {

                var changeupload = true;

                if (attrs.changeupload == undefined) {
                    changeupload = true;
                } else {
                    changeupload = (attrs.changeupload === "true");
                }

                scope.progressBar = 0;
                element.bind("click", function () {
                    this.value = null;
                });

                element.bind("change", function (changeEvent) {
                    if (changeupload) {
                        scope.$apply(function () {
                            scope.progressBar = 0;

                            var controllerName = scope.controller;
                            var controllerApi = Config.getUrl(controllerName) + '/' + scope.metodo;

                            if (changeEvent.target.files.length > 0) {
                                var fileread = changeEvent.target.files[0];

                                var formData = new FormData();
                                formData.append('uploadfile', fileread, escape(fileread.name));
                                if (scope.tipoFile)
                                    formData.append('tipoId', scope.tipoFile);

                                if (scope.postData) {
                                    for (var key in scope.postData) {
                                        if (!scope.postData.hasOwnProperty(key)) continue;
                                        formData.append(key, scope.postData[key]);
                                    }
                                }

                                var onSuccess = function (data) {
                                    scope.result = data;
                                    if (scope.onSuccess)
                                        scope.$apply(scope.onSuccess(data));
                                };

                                var onError = function (data, jqXHR) {
                                    scope.progressBar = 0;
                                    // eslint-disable-next-line no-console
                                    console.log(data);
                                    if (scope.onError)
                                        scope.$apply(scope.onError(data, jqXHR));
                                };

                                var continueUpload = function () {

                                    $.ajax({
                                        type: 'POST',
                                        beforeSend: function (request) {
                                            request.setRequestHeader("Authorization", 'Bearer ' + angular.fromJson($window.localStorage.getItem("Token") || "{}").access_token);
                                        },
                                        url: controllerApi,
                                        data: formData,
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (response) {
                                            onSuccess(response);
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {                                            
                                            onError(errorThrown, jqXHR);
                                        },
                                        xhr: function () {
                                            var xhr = new window.XMLHttpRequest();
                                            xhr.upload.addEventListener("progress", function (evt) {
                                                if (evt.lengthComputable) {
                                                    var percentComplete = Math.round((evt.loaded / evt.total) * 100);
                                                    if (scope.onProgress)
                                                        scope.$apply(scope.onProgress(percentComplete));
                                                }
                                            }, false);
                                            return xhr;
                                        },
                                    });
                                };

                                var promise;
                                if (scope.onStart)
                                    promise = scope.onStart();
                                if (promise) {
                                    promise.then(continueUpload).catch(function () {
                                        //drop.data().dropify.clearElement();
                                    });
                                } else {
                                    continueUpload();
                                }
                            }
                        });
                    }
                });
            }

        };
    }])

;
angular.module('epbxManagerApp')
    .directive('emInputFileTts', ["$timeout", "$http", "$rootScope", "ModalService", "Config", "$window", "$translate", "GeraAudioTtsResource", "LocalStorageService", "NotifyService", "TtsService", function ($timeout, $http, $rootScope, ModalService, Config, $window, $translate, GeraAudioTtsResource, LocalStorageService, NotifyService, TtsService) {
        return {
            restrict: 'EA',
            templateUrl: 'app/directives/templates/emInputFileTts.html',
            scope: {
                controller: '@',
                onStart: '=',
                onSuccess: '=',
                onError: '=',
                onRemove: '=',
                onProgress: '=',
                maxFiles: '=',
                tipoFile: '=',
                metodo: '@',
                changeupload: '=',
                btnPrimary: '@',
                audio: "=",
                name: '@',
                id: '@',
                descricaoAudio: '@',
                uraIdDiretiva: '@',
                vozIdDefault: "=",
                showVariaveisUraAvi: '@'
            },
            link: function (scope, element, attrs) {

                scope.uraArquivoAudio = {};
                scope.arquivoAudio = [];
                scope.arquivoAudioVoz = [];
                scope.configAudio = {};
                scope.progressBar = 0;
                scope.vozId = null;
                scope.vozProvedorId = null;
                scope.provedores = JSON.parse(TtsService.getProvedores());
                scope.permiteAlterarProvedor = LocalStorageService.getItem('PermiteAlterarProvedor');
                scope.vozes = null;
                
                function load() {
                    scope.vozProvedorId = 0;
                    scope.vozes = [];
                    if (scope.vozIdDefault) {
                        scope.vozId = scope.vozIdDefault;
                        scope.vozProvedorId = JSON.parse(TtsService.getVoz()).find(x => x.VozId == scope.vozIdDefault).ProvedorId;
                        scope.vozes = JSON.parse(TtsService.getVoz()).filter(x => x.ProvedorId == scope.vozProvedorId) || [];
                    }
                }

                scope.loadVozesProvedor = function () {
                    scope.vozes = JSON.parse(TtsService.getVoz()).filter(x => x.ProvedorId == scope.vozProvedorId) || [];
                    scope.vozId = 0;
                }

                scope.fecharModal = function () {
                    var modal = $.UIkit.modal('#modal_tts_' + scope.id);
                    if (modal)
                        modal.hide(true);
                }

                function carregarDadosAudio() {
                    if (scope.audio != undefined) {
                        if (scope.controller == "Ura") {
                            scope.uraArquivoAudio = scope.audio;
                            scope.uraArquivoAudio.Id = scope.audio.UraArquivoId;

                            if (scope.audio.VozId) {
                                scope.configAudio.Fraseologia = scope.audio.Texto;
                                if (scope.vozIdDefault)
                                    scope.vozId = scope.vozIdDefault;
                                else
                                    scope.vozId = scope.audio.VozId;
                            }
                        }
                        else if (scope.controller == "Campanha") {
                            scope.uraArquivoAudio = scope.audio;
                            scope.uraArquivoAudio.Nome = scope.audio.FileGuid;
                            scope.uraArquivoAudio.Id = scope.audio.CampanhaAudioId;

                            if (scope.audio.VozId) {
                                scope.configAudio.Fraseologia = scope.audio.Texto;
                                scope.vozId = scope.audio.VozId;
                            }
                        }
                        else if (scope.controller == "Grupo") {
                            scope.uraArquivoAudio = scope.audio;
                            scope.uraArquivoAudio.Nome = scope.audio.FileGuid;
                            scope.uraArquivoAudio.Id = scope.audio.GrupoAudioId;

                            if (scope.audio.VozId) {
                                scope.configAudio.Fraseologia = scope.audio.Texto;
                                scope.vozId = scope.audio.VozId;
                            }
                        }
                        else if (scope.controller == "Servico") {
                            if (scope.audio.Id == undefined) {
                                scope.uraArquivoAudio.Nome = scope.audio.Arquivo;
                                scope.uraArquivoAudio.Id = 1;

                                if (scope.audio.VozId) {
                                    scope.configAudio.Fraseologia = scope.audio.Texto;
                                    scope.vozId = scope.audio.VozId;
                                }
                            }
                            else {
                                scope.uraArquivoAudio = scope.audio;
                                scope.uraArquivoAudio.Nome = scope.audio.Arquivo;
                                scope.uraArquivoAudio.Id = scope.audio.Id;

                                if (scope.audio.VozId) {
                                    scope.configAudio.Fraseologia = scope.audio.Texto;
                                    scope.vozId = scope.audio.VozId;
                                }
                            }
                        }
                        scope.configAudio.FraseologiaAuxiliar = scope.configAudio.Fraseologia;
                        scope.vozIdAuxiliar = scope.vozId;
                        scope.vozProvedorIdAuxiliar = scope.vozProvedorId;
                        scope.ouvirAudioTts(scope.uraArquivoAudio.Id, scope.uraArquivoAudio.Nome);
                    }
                    else {
                        scope.uraArquivoAudio = {};
                        scope.configAudio = {};
                    }
                }

                scope.ouvirAudioTts = function (id, nome) {
                    if (scope.controller == "Ura") {
                        scope.arquivoAudioTts = {
                            url: "/Ura/Audio/" + id,
                            titulo: $translate.instant('diretivas.reproduzindo') + nome
                        }
                    }
                    else if (scope.controller == "Campanha") {
                        scope.arquivoAudioTts = {
                            url: "/Campanha/Audio/" + id,
                            titulo: $translate.instant('diretivas.reproduzindo') + nome
                        }
                    }
                    else if (scope.controller == "Grupo") {
                        scope.arquivoAudioTts = {
                            url: "/Grupo/Audio/" + id,
                            titulo: $translate.instant('diretivas.reproduzindo') + nome
                        }
                    }
                    else if (scope.controller == "Servico") {
                        scope.arquivoAudioTts = {
                            url:
                                "Servico/Audio/" +
                                encodeURI(nome.replace(".", "$dot")),
                            titulo:
                                $translate.instant("diretivas.reproduzindo") + nome,
                        };
                    }
                };

                scope.disabledComponent = function () {

                    if ((scope.vozProvedorId != scope.vozProvedorIdAuxiliar) || (scope.vozId != scope.vozIdAuxiliar) || (scope.configAudio.Fraseologia != scope.configAudio.FraseologiaAuxiliar))
                        return false;
                    else
                        return true;

                }

                scope.ouvirAudioVozTts = function () {

                    if (!scope.vozId) {
                        return;
                    }

                    var vozSelecionada = scope.vozes.find(x => x.VozId == scope.vozId);
                    if (vozSelecionada != undefined) {
                        scope.arquivoAudioVoz = {
                            url: vozSelecionada.Exemplo,
                            tts: true,
                            titulo: vozSelecionada.Nome
                        }
                    }
                }

                scope.ouvirAudioPlay = function () {
                    if (!scope.vozId) {
                        return;
                    }

                    if (scope.configAudio.Fraseologia != undefined) {
                        ModalService.showLoading();
                        GeraAudioTtsResource.gerarTTS({ Texto: scope.configAudio.Fraseologia, Pagina: scope.controller, VozId: scope.vozId, VozProvedorId: scope.vozProvedorId })
                            .$promise
                            .then((data) => {
                                onSuccessTts(data);
                                if (scope.uraArquivoAudio != undefined)
                                    scope.ouvirAudio(scope.uraArquivoAudio.Id, scope.uraArquivoAudio.Nome);
                            }).catch((ex) => {
                                onErrorTts(ex);
                            });
                    }
                }

                scope.ouvirAudio = function (id, nome) {
                    if (scope.controller == "Ura") {
                        scope.arquivoAudio = {
                            url: "/Ura/Audio/" + id,
                            titulo: $translate.instant('diretivas.reproduzindo') + nome
                        }
                    }
                    else if (scope.controller == "Campanha") {
                        scope.arquivoAudio = {
                            url: "/Campanha/Audio/" + id,
                            titulo: $translate.instant('diretivas.reproduzindo') + nome
                        }
                    }
                    else if (scope.controller == "Grupo") {
                        scope.arquivoAudio = {
                            url: "/Grupo/Audio/" + id,
                            titulo: $translate.instant('diretivas.reproduzindo') + nome
                        }
                    }
                    else if (scope.controller == "Servico") {
                        scope.arquivoAudio = {
                            url:
                                "Servico/Audio/" +
                                encodeURI(nome.replace(".", "$dot")),
                            titulo:
                                $translate.instant("diretivas.reproduzindo") + nome,
                        };
                    }
                };

                scope.fecharAudio = function () {
                    scope.arquivoAudio = null;
                };

                scope.Remove = function () {
                    if (scope.onRemove) {
                        scope.uraArquivoAudio.UraArquivoId = 0;
                        scope.uraArquivoAudio = {};
                        scope.configAudio = {};
                        if (scope.onRemove) {
                            scope.$applyAsync(scope.onRemove());
                        }
                    }
                };

                element.bind("change", function (changeEvent) {
                    var ele = element;

                    if (changeEvent.target.className == "irs-hidden-input") return;

                    if (changeEvent.target.files != undefined) {
                        scope.$applyAsync(function () {
                            scope.progressBar = 0;

                            //nodeName
                            var controllerName = scope.controller;
                            var controllerApi = Config.getUrl(controllerName) + '/' + scope.metodo;

                            if (changeEvent.target.files != undefined && changeEvent.target.files.length > 0) {
                                var fileread = changeEvent.target.files[0];

                                var formData = new FormData();
                                formData.append('uploadfile', fileread, escape(fileread.name));
                                if (scope.tipoFile)
                                    formData.append('tipoId', scope.tipoFile);

                                if (scope.postData) {
                                    for (var key in scope.postData) {
                                        if (!scope.postData.hasOwnProperty(key)) continue;
                                        formData.append(key, scope.postData[key]);
                                    }
                                }

                                var onSuccess = function (data) {

                                    let retornoServico = {};

                                    if (scope.controller == "Ura") {
                                        scope.uraArquivoAudio = data;
                                        scope.uraArquivoAudio.Id = data.UraArquivoId;
                                    }
                                    else if (scope.controller == "Campanha") {
                                        scope.uraArquivoAudio = data;
                                        scope.uraArquivoAudio.Nome = data.FileGuid;
                                        scope.uraArquivoAudio.Id = data.CampanhaAudioId;
                                    }
                                    else if (scope.controller == "Grupo") {
                                        scope.uraArquivoAudio = data;
                                        scope.uraArquivoAudio.Nome = data.FileGuid;
                                        scope.uraArquivoAudio.Id = data.GrupoAudioId;
                                    }
                                    else if (scope.controller == "Servico") {
                                        scope.uraArquivoAudio.Id = 1;
                                        scope.uraArquivoAudio.Nome = data;

                                        retornoServico.Nome = data;
                                    }

                                    data.UraIdDiretiva = scope.uraIdDiretiva;

                                    let btn = document.getElementById('div_input_' + scope.id);

                                    btn.classList.add('md-btn-primary');
                                    btn.classList.remove('md-btn-danger');

                                    if (scope.onSuccess)

                                        if (scope.controller == "Servico") {
                                            scope.$apply(scope.onSuccess(retornoServico));
                                        } else
                                            scope.$apply(scope.onSuccess(data));

                                };



                                var onError = function (data, jqXHR) {
                                    scope.progressBar = 0;
                                    // eslint-disable-next-line no-console
                                    console.log(data);
                                    if (scope.onError)
                                        scope.$apply(scope.onError(data, jqXHR));
                                };

                                var continueUpload = function () {

                                    $.ajax({
                                        type: 'POST',
                                        beforeSend: function (request) {
                                            request.setRequestHeader("Authorization", 'Bearer ' + angular.fromJson($window.localStorage.getItem("Token") || "{}").access_token);
                                        },
                                        url: controllerApi,
                                        data: formData,
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (response) {
                                            onSuccess(response);
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            onError(errorThrown, jqXHR);
                                        },
                                        xhr: function () {
                                            var xhr = new window.XMLHttpRequest();
                                            xhr.upload.addEventListener("progress", function (evt) {
                                                if (evt.lengthComputable) {
                                                    var percentComplete = Math.round((evt.loaded / evt.total) * 100);
                                                    if (scope.onProgress)
                                                        scope.$apply(scope.onProgress(percentComplete));
                                                }
                                            }, false);
                                            return xhr;
                                        },
                                    });
                                };

                                var promise;
                                if (scope.onStart)
                                    promise = scope.onStart();
                                if (promise) {
                                    promise.then(continueUpload).catch(function () {
                                        //drop.data().dropify.clearElement();
                                    });
                                } else {
                                    continueUpload();
                                }
                            }
                        });
                    }
                });

                scope.gerarTTS = function () {

                    if (!scope.vozId) {
                        return;
                    }

                    if (scope.configAudio.Fraseologia != undefined) {
                        ModalService.showLoading();
                        GeraAudioTtsResource.gerarTTS({ Texto: scope.configAudio.Fraseologia, Pagina: scope.controller, VozId: scope.vozId, VozProvedorId: scope.vozProvedorId })
                            .$promise
                            .then((data) => {
                                onSuccessTts(data);
                                scope.configAudio.FraseologiaAuxiliar = scope.configAudio.Fraseologia;
                            }).catch((ex) => {
                                scope.onErrorTts(ex);
                            });
                    }
                }

                var onSuccessTts = function (data) {
                    scope.result = data;
                    scope.vozIdAuxiliar = scope.vozId;
                    scope.uraArquivoAudio.VozId = scope.vozId;
                    scope.vozProvedorIdAuxiliar = scope.vozProvedorId;

                    if (scope.controller == "Ura") {
                        scope.uraArquivoAudio = data;
                        scope.uraArquivoAudio.Id = data.UraArquivoId;
                    }
                    else if (scope.controller == "Campanha") {
                        scope.uraArquivoAudio = data;
                        scope.uraArquivoAudio.Nome = data.FileGuid;
                        scope.uraArquivoAudio.Id = data.CampanhaAudioId;
                    }
                    else if (scope.controller == "Grupo") {
                        scope.uraArquivoAudio = data;
                        scope.uraArquivoAudio.Nome = data.FileGuid;
                        scope.uraArquivoAudio.Id = data.GrupoAudioId;
                    }
                    else if (scope.controller == "Servico") {
                        scope.uraArquivoAudio.Id = 1;
                        scope.uraArquivoAudio.Nome = data.Nome;
                    }

                    data.UraIdDiretiva = scope.uraIdDiretiva;

                    let btn = document.getElementById('div_input_' + scope.id);

                    btn.classList.add('md-btn-primary');
                    btn.classList.remove('md-btn-danger');

                    if (scope.onSuccess) {
                        ModalService.hideLoading();
                        scope.$applyAsync(scope.onSuccess(data));
                    }
                    scope.ouvirAudioTts(scope.uraArquivoAudio.Id, scope.uraArquivoAudio.Nome);
                };

                scope.exibirDetalhe = function (titulo, descricao) {
                    ModalService.alert(`<h3>${titulo}</h3>${descricao}`);
                };

                scope.$watch('btnPrimary', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.btnPrimary = newValue;

                        if (scope.btnPrimary == "false") {
                            let btn = document.getElementById('div_input_' + scope.id);

                            btn.classList.remove('md-btn-primary');
                            btn.classList.add('md-btn-danger');
                        }
                    }
                });

                scope.$watch('audio', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (oldValue != undefined && scope.uraIdDiretiva == oldValue.UraIdDiretiva)
                            scope.audio = newValue;
                        else if (newValue != undefined && scope.uraIdDiretiva == newValue.UraIdDiretiva)
                            scope.audio = newValue;
                    }

                    carregarDadosAudio();
                });


                scope.$watch('vozIdDefault', function (newValue, oldValue) {
                    if (newValue != oldValue) {                        
                        scope.vozIdDefault = newValue;
                        scope.vozId = null;
                    }
                    carregarDadosAudio();
                    load();
                });

                // scope.disabledSelectVoz = function () {

                //     let retorno = false;
                //     if (scope.controller == "Ura" && scope.vozId) {
                //         retorno = true;
                //     }
                //     return retorno;
                // }

                scope.onErrorTts = function (ex) {
                    if (scope.controller == "Ura") {

                        // Possivelmente uma nova ura
                        // em caso de erro, reiniciamos
                        // a variavel scope.vozId para o
                        // usuário tentar uma outra vozId
                        if (!scope.vozIdDefault) {
                            scope.vozId = null;
                        }
                    }
                    ModalService.hideLoading();
                    NotifyService.showError(ex, 'notificacoes.erroAoFazerUpload');
                }

                carregarDadosAudio();
                load();
                scope.ouvirAudioVozTts();
            }
        };
    }]);
angular.module('epbxManagerApp').directive('emListSelect', function () {
    return {
        templateUrl: 'app/directives/templates/emListSelect.html',
        restrict: 'E',
        replace: true,
        scope: {
            itens: '=?',
            itensAdicionados: '=',
            itensNaoAdicionados: '=?',
            valor: '=',
            descricoes: '=',
            // <em-list-select confirmar-adicionar="confirmarAdicionar(callback)"></em-list-select>
            adicionar: '&?confirmarAdicionar',
            // <em-list-select confirmar-remover="confirmarRemover(callback)"></em-list-select>
            remover: '&?confirmarRemover',
            // <em-list-select on-adicionado="onAdicionado(itens)"></em-list-select>
            adicionado: '&onAdicionado',
            // <em-list-select on-removido="onRemovido(itens)"></em-list-select>
            removido: '&onRemovido'
        },
        link: function ($scope) {
            $scope.formsSelect = {};
            $scope.colunasQuantidade = 0;
            $scope.search = {
                naoSelecionado: '',
                selecionado: ''
            };

            $scope.formatarItens = function () {
                if ($scope.itensSelecionados != null) {
                    $scope.itensNaoSelecionados = $scope.itens.filter(el =>
                        !$scope.itensSelecionados.some(el2 => el[$scope.valor] == el2[$scope.valor])
                    );
                } else {
                    $scope.bindAdicionados = true;
                }
            }
            $scope.formatarAdicionados = function () {
                $scope.itensSelecionados = $scope.itensAdicionados.slice();
                if ($scope.bindAdicionados) {
                    $scope.itensNaoSelecionados = $scope.itens.filter(el =>
                        !$scope.itensSelecionados.some(el2 => el[$scope.valor] == el2[$scope.valor])
                    );
                }
            }
            $scope.formatarNaoAdicionados = function () {
                $scope.itensNaoSelecionados = $scope.itensNaoAdicionados.slice();
            }

            if (Array.isArray($scope.itens)) {
                $scope.formatarItens();
            } else {
                $scope.itensSelecionados = [];
                $scope.itensNaoSelecionados = [];
            }

            if (Array.isArray($scope.itensAdicionados)) {
                $scope.formatarAdicionados();
            } else {
                $scope.itensSelecionados = [];
            }

            if (Array.isArray($scope.itensNaoAdicionados)) {
                $scope.formatarNaoAdicionados();
            } else {
                $scope.itensNaoSelecionados = [];
            }

            $scope.$watch('itensNaoAdicionados', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    $scope.formatarNaoAdicionados();
                }
            });

            $scope.$watch('itensAdicionados', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    $scope.formatarAdicionados();
                }
            });

            $scope.$watch('itens', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    $scope.formatarItens();
                }
            });

            $scope.$watch('descricoes', function () {
                $scope.colunasQuantidade = 0;

                for (const key in $scope.descricoes) {
                    if ($scope.descricoes.hasOwnProperty(key)) {
                        $scope.colunasQuantidade++;
                    }
                }
            });

            $scope.filtrarListaNaoSelecionado = function (item) {
                const pesquisaVazia = $scope.search.naoSelecionado == null || $scope.search.naoSelecionado == '';
                const checkPesquisa = [];
                if (pesquisaVazia == false) {
                    // verifica id
                    checkPesquisa.push(item[$scope.valor] == $scope.search.naoSelecionado);

                    // verifica descricoes
                    for (const key in $scope.descricoes) {
                        if ($scope.descricoes.hasOwnProperty(key)) {
                            checkPesquisa.push(item[key].toString().toLowerCase().indexOf($scope.search.naoSelecionado.toLowerCase()) >= 0);
                        }
                    }
                }

                return pesquisaVazia || checkPesquisa.some(el => el == true);
            }

            $scope.filtrarListaSelecionado = function (item) {
                const pesquisaVazia = $scope.search.selecionado == null || $scope.search.selecionado == '';
                const checkPesquisa = [];
                if (pesquisaVazia == false) {
                    // verifica id
                    checkPesquisa.push(item[$scope.valor] == $scope.search.selecionado);

                    // verifica descricoes
                    for (const key in $scope.descricoes) {
                        if ($scope.descricoes.hasOwnProperty(key)) {
                            checkPesquisa.push(item[key].toString().toLowerCase().indexOf($scope.search.selecionado.toLowerCase()) >= 0);
                        }
                    }
                }

                return pesquisaVazia || checkPesquisa.some(el => el == true);
            }

            $scope.adicionarItem = function () {
                const callback = () => {
                    const itensSelecionados = _.where($scope.itensNaoSelecionados, {
                        Selecionada: true
                    });

                    itensSelecionados.forEach(item => {
                        item.Selecionada = false;
                        $scope.itensSelecionados.push(item);
                        $scope.itensAdicionados.push(item);
                        $scope.itensNaoSelecionados.splice($scope.itensNaoSelecionados.indexOf(item), 1);
                        $scope.itensNaoAdicionados.splice($scope.itensNaoAdicionados.indexOf(item), 1);
                    });

                    $scope.todosItemsAdicionadas = false;
                    $scope.todosItemsNaoAdicionadas = false;

                    $scope.adicionado({ itens: itensSelecionados });
                }

                if ($scope.adicionar) {
                    $scope.adicionar({ callback: callback })
                } else {
                    callback();
                }
            }

            $scope.removerItem = function () {
                const callback = () => {
                    const itensSelecionados = _.where($scope.itensSelecionados, {
                        Selecionada: true
                    });

                    itensSelecionados.forEach(item => {
                        item.Selecionada = false;
                        $scope.itensNaoSelecionados.push(item);
                        $scope.itensNaoAdicionados.push(item);
                        $scope.itensSelecionados.splice($scope.itensSelecionados.indexOf(item), 1);
                        $scope.itensAdicionados.splice($scope.itensAdicionados.indexOf(item), 1);
                    });

                    $scope.todosItemsAdicionadas = false;
                    $scope.todosItemsNaoAdicionadas = false;

                    $scope.removido({ itens: itensSelecionados });
                }
                if ($scope.remover) {
                    $scope.remover({ callback: callback })
                } else {
                    callback();
                }
            };

            $scope.selecionarTodasAdicionadas = function (todosAdicionadas) {
                if ($scope.search.selecionado == null || $scope.search.selecionado == '') {
                    $scope.itensSelecionados.forEach(item => {
                        if (todosAdicionadas) {
                            item.Selecionada = true;
                        } else {
                            item.Selecionada = false;
                        }
                    });
                } else {
                    $scope.itensSelecionados.filter(item => {
                        return $scope.filtrarListaSelecionado(item);
                    }).forEach(item => {
                        if (todosAdicionadas) {
                            item.Selecionada = true;
                        } else {
                            item.Selecionada = false;
                        }
                    });
                }
            };

            $scope.selecionarTodasNaoAdicionadas = function (todosNaoAdicionadas) {
                if ($scope.search.naoSelecionado == null || $scope.search.naoSelecionado == '') {
                    $scope.itensNaoSelecionados.forEach(item => {
                        if (todosNaoAdicionadas) {
                            item.Selecionada = true;
                        } else {
                            item.Selecionada = false;
                        }
                    });
                } else {
                    $scope.itensNaoAdicionados.filter(item => {
                        return $scope.filtrarListaNaoSelecionado(item);
                    }).forEach(item => {
                        if (todosNaoAdicionadas) {
                            item.Selecionada = true;
                        } else {
                            item.Selecionada = false;
                        }
                    });
                }
            };

        }
    }
});
angular.module('epbxManagerApp')
    .directive('emLoadingButton', function () {
        return {
            templateUrl: 'app/directives/templates/emLoadingButton.html',
            restrict: 'E',
            scope: {
                isLoading: "=",
                texto: "@",
                type: "@",
                icone: "@",
                color: "@",
                disabled: "="
            },
            link: function ($scope) {
                if (!$scope.color) {
                    $scope.color = 'primary'
                }
                
                $scope.classColor = {
                    'uk-text-primary': $scope.color == 'primary',
                    'uk-text-danger': $scope.color == 'danger',
                    'uk-text-warning': $scope.color == 'warning',
                    'uk-text-success': $scope.color == 'success'
                };

                if (!$scope.texto) {
                    $scope.texto = 'botao.pesquisar'
				}
				
				if(!$scope.type) {
					$scope.type = 'button'
				}
            }
        }
    });
angular.module('epbxManagerApp')
    .directive('emMarkAsValid', ["$translate", function ($translate) {
        return {
            template: `<i class="uk-icon-check-square" style="color: #02b502;font-size: 1.13em;font-weight: 100;" data-uk-tooltip 
            title="{{validMessage}}" ng-if="isValid"></i>
            <i class="uk-icon-exclamation-triangle" style="color: #ff9649;font-size: 1.13em;font-weight: 100;" data-uk-tooltip 
            title="{{invalidMessage}}" ng-if="!isValid"></i>`,
            restrict: 'E',
            scope: {
                validMessage: "@",
                invalidMessage: "@",
                isValid: "="
            },
            link: function ($scope) {
                if (!$scope.validMessage) {
                    $scope.validMessage = false;
                }

                if (!$scope.validMessage) {
                    $scope.validMessage = $translate.instant('status.valido');
                }

                if (!$scope.invalidMessage) {
                    $scope.invalidMessage = $translate.instant('status.invalido');
                }

                if (!$scope.isValid) {
                    $scope.isValid = false;
                }
            }
        }
    }]);
angular.module('epbxManagerApp')
	.directive('maskedInput', function () {
		return {
			restrict: 'AC',
			link: function (scope, element) {
				var $maskedInput = $(element);
				if ($maskedInput) {
					$maskedInput.inputmask();
				}
			}
		}
	});

angular.module('epbxManagerApp')

    .directive('emMinuteMask', function () {
        var removeNonNumeric = /[^0-9]*/g;
        var formatMinute = /([0-0])([0-9])([0-5])([0-9])([0-5])([0-9])/g;
        var keys = [37, 38, 39, 40, 8, 13, 46];
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (domValue) {
                    return domValue ? domValue.toString().replace(removeNonNumeric, "") : domValue;
                });

                element.on('blur keyup change', function (event) {
                    var val = event.keyCode;
                    if (!_.contains(keys, val)) {
                        scope.$evalAsync(ngModel.$render(event));
                    }
                });

                ngModel.$render = function (event) {

                    if (event) {
                        if (event.type == 'blur') {
                            if (event.currentTarget.value.length < 8) {
                                event.currentTarget.value = '';
                                ngModel.$modelValue = '';
                            }
                        }
                    } 

                    if (ngModel.$modelValue) {
                        var text = ngModel.$modelValue;
                        text = text ? text.toString().replace(removeNonNumeric, "") : text;
                        element.val(scope.formatText(text));
                        ngModel.$modelValue = scope.formatText(text);
                    } else {
                        element.val(ngModel.$modelValue);
                    }
                };

                scope.formatText = function (text) {
                    text = text ? text.toString().replace(removeNonNumeric, "").replace(/^0+/, '') : text.replace(/^0+/, '');

                    if (text.length > 0 && text.length <= 6) {
                        text = ("00000" + text).slice(-6).replace(formatMinute, "$1$2:$3$4:$5$6");
                    }
                    else if(text.length > 6){
                        text = ("00000" + text.substring(0, 6)).slice(-6).replace(formatMinute, "$1$2:$3$4:$5$6");
                    }

                    return text;
                }

                ngModel.$formatters.push(function (domValue) {
                    if (domValue) {
                        domValue = domValue.toString().replace(removeNonNumeric, "");
                        return scope.formatText(domValue);
                    }
                    return domValue;
                });
            }
        };
    });
angular.module('epbxManagerApp')
    .directive('emModalShowOn', ["$window", function ($window) {
        return {
            restrict: 'A',
            scope: {
                emModalShowOn: '=',
                onModalHide: '&',
                onModalShow: '&',
                modalCenter: '@',
                bgclose: '@',
                modalExclusive: '@' // mostrar apenas esse modal, removendo outros da tela
            },
            link: function (scope, element) {
                "use strict";

                var modal = $window.UIkit.modal(element);
                modal.options.center = angular.isDefined(scope.modalCenter) ? !!scope.modalCenter : true;
                modal.options.modal = angular.isDefined(scope.modalExclusive) ? !!scope.modalExclusive : false;
                modal.options.bgclose = angular.isDefined(scope.bgclose) ? scope.bgclose == 'true' : true;

                var clearActiveProperty = function () {
                    scope.emModalShowOn = false;
                    scope.$apply(function () {
                        if (scope.onModalHide) {
                            scope.onModalHide(scope);
                        }
                    });
                };

                modal.on('hide.uk.modal', clearActiveProperty);
                modal.on('show.uk.modal', function () {
                    if (scope.onModalShow) {
                        scope.onModalShow(scope);
                    }
                });

                scope.$watch('emModalShowOn', function (newValue) {
                    if (newValue) {
                        modal.show();
                    }
                });

                scope.$on('$destroy', function () {
                    modal.off('hide.uk.modal', clearActiveProperty);
                });
            }
        }
    }])

    .directive('ukModalCloseOne', ["$window", function ($window) {
        return {
            restrict: 'C', // apenas como nome de class css
            link: function (scope, element) {
                angular.element(element).on('click', function (event) {
                    $window.UIkit.modal(angular.element(event.target).closest(".uk-modal")).hide();
                });
            }
        }
    }])
;
angular.module('epbxManagerApp')

    .directive('emMultiCategoria', ["$interval", "$timeout", function ($interval, $timeout) {
        return {
            restrict: 'EA',
            templateUrl: 'app/directives/templates/emMultiCategoria.html',
            require: '?ngModel',
            scope: {
                categorias: '='
            },
            link: function ($scope, element, attrs, ctrl) {

                var categoriaElement = $(element).find('div > div')

                function Gerar() {

                    $scope.categorias.forEach(function (value) {
                        if (!value.ParentId) {

                            var filhos = $scope.categorias.filter(x => x.ParentId == value.Id).length;

                            var a = document.createElement("a");
                            a.setAttribute('class', 'onClickCategoria');
                            a.setAttribute('data-categoria', JSON.stringify(value));
                            a.innerText = value.Descricao;

                            var ul = document.createElement("ul");
                            ul.setAttribute('id', 'id_' + value.Id)

                            var li = document.createElement("li");

                            if (filhos > 0) {
                                li.setAttribute('class', 'uk-parent');
                                a.href = "#";
                                ul.setAttribute("class", "uk-nav uk-nav-dropdown uk-nav-parent-icon");
                                ul.setAttribute("data-uk-nav", "{multiple:true}");
                            }

                            li.appendChild(a);
                            li.appendChild(ul);
                            angular.element($(categoriaElement).children()).append(li);

                            if (filhos > 0)
                                CriarUlLi(value);
                        }
                    });                   
                }

                categoriaElement.on("click", ".onClickCategoria", function () {
                    $scope.nomeSelecionado = $(this).data('categoria').Descricao;
                    ctrl.$setViewValue($(this).data('categoria').Id);                    
                });

                function CriarUlLi(obj) {

                    $scope.categorias.forEach(function (value) {

                        if (value.ParentId == obj.Id) {

                            var filhos = $scope.categorias.filter(x => x.ParentId == value.Id).length;

                            var a = document.createElement("a");

                            a.setAttribute('class', 'onClickCategoria');
                            a.setAttribute('data-categoria', JSON.stringify(value));
                            a.innerText = value.Descricao;

                            var ul = document.createElement("ul");
                            ul.setAttribute('id', 'id_' + value.Id);

                            var li = document.createElement("li");
                            if (filhos > 0) {
                                li.setAttribute('class', 'uk-parent');
                                a.href = "#";
                                ul.setAttribute("class", "uk-nav uk-nav-dropdown uk-nav-parent-icon");
                                ul.setAttribute("data-uk-nav", "{multiple:true}");
                            }

                            li.appendChild(a)
                            li.appendChild(ul);

                            angular.element(document.querySelector('#id_' + obj.Id).append(li));


                            if (filhos > 0)
                                CriarUlLi(value);
                        }
                    });
                }
                Gerar();

            }
        }
    }]);
angular.module('epbxManagerApp')


    .directive('emMultiselect', ["$rootScope", "$translate", function ($rootScope, $translate) {
        return {
            restrict: 'AE',
            templateUrl: 'app/directives/templates/emMultiselect.html',
            require: '?ngModel',
            scope: {
                colecao: '=',
                nome: '@',
                valor: '@',
                textoPlaceholder: '@',
            },
            link: function (scope, element, attrs, ngModel) {

                if (!ngModel)
                    return; // do nothing if no ng-model

                scope.searchText = "";
                scope.label = scope.textoPlaceholder || $translate.instant('form.placeholderSelect');
                scope.colecaoFinal = scope.colecao || [];

                scope.getClass = function (item) {

                    if (item.checked != undefined && item.checked)
                        return "uk-text-truncate uk-text-primary";

                    return "uk-text-truncate";
                };

                function getLabelText() {

                    let itens = scope.colecao.filter(item => item.checked);

                    if (itens.length == 1) {
                        scope.label = itens.length + ' ' + $translate.instant('diretivas.selecionado');
                    }

                    if (itens.length > 1) {
                        scope.label = itens.length + ' ' + $translate.instant('diretivas.selecionados');
                    }

                    if (itens.length == 0) {
                        scope.label = scope.textoPlaceholder || $translate.instant('form.placeholderSelect');
                    }
                }

                function setViewModelValue() {


                    let itens = scope.colecao.filter(item => item.checked).map(item => item[scope.valor]);

                    //console.log(itensSelecionados);

                    //let itens = [];
                    //angular.forEach(scope.colecao, function (item) {
                    //    if (item.checked) {
                    //        itens.push(item[scope.valor]);
                    //    }
                    //})

                    if (itens.length > 0) {
                        ngModel.$setViewValue(itens);
                    }
                    else {
                        ngModel.$setViewValue(null);
                    }
                }

                scope.checkAll = function () {
         
                    scope.colecao.map(item => {
                        item.checked = true;
                    });

                    getLabelText();
                    setViewModelValue();
                };
                scope.uncheckAll = function () {

                    scope.colecao.map(item => {
                        item.checked = false;
                    });

                   
                    getLabelText();
                    setViewModelValue();
                };

                $rootScope.$on('onLimparAvaliacoes', function () {
                    scope.uncheckAll();
                });

                $rootScope.$on('onLimpar', function (event, items) {
                    if (items == undefined || items.includes(scope.valor)) {
                        scope.uncheckAll();
                    }
                });

                scope.select = function (item) {
                    item.checked = !item.checked;
                    getLabelText();
                    setViewModelValue();
                };

                scope.toggleSelect = function () {
                    if (element.hasClass('uk-open')) {
                        element.removeClass('uk-open');
                    } else {
                        element.addClass('uk-open');
                    }

                    getLabelText();
                };

                function mudarValorModel() {
                    if (ngModel.$viewValue) {

                        if (ngModel.$viewValue.length == 1 && parseInt(ngModel.$viewValue[0][scope.valor]) == 0)
                            ngModel.$setViewValue(null);
                        else {
                            scope.selectModel = _.filter(scope.colecaoFinal, function (el) {
                                return _.find(ngModel.$viewValue, function (el2) {
                                    return el[scope.valor] == el2;
                                });
                            });

                            angular.forEach(scope.colecao, function (item) {
                                if (scope.selectModel.length) {
                                    item.checked = false;

                                    var itemModel = _.find(scope.selectModel, function (el2) {
                                        return el2[scope.valor] === item[scope.valor];
                                    });

                                    if (itemModel)
                                        item.checked = itemModel[scope.valor] > 0;

                                }
                            });
                        }

                        getLabelText();
                    }
                };

                scope.$watch(function () {
                    return scope.colecao;
                }, function (newVal) {
                    if (newVal) {
                        if (newVal.length) {
                            scope.colecaoFinal = newVal;
                            mudarValorModel();
                        }
                    }
                });

                scope.$watch(function () {
                    return ngModel.$modelValue;
                }, function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        mudarValorModel();
                    }
                });
            }
        };
    }])

angular.module('epbxManagerApp')

  .directive('multiSelectTree', function () {
    return {
      restrict: 'E',
      templateUrl: 'app/directives/templates/emMultiSelectTree.html',
      scope: {
        inputModel: '=',
        outputModel: '=?',
        multiSelect: '=?',
        switchView: '=?',
        switchViewLabel: '@',
        switchViewCallback: '&',
        selectOnlyLeafs: '=?',
        callback: '&',
        defaultLabel: '@'
      },
      link: function (scope, element, attrs) {
        if (attrs.callback) {
          scope.useCallback = true;
        }
        // watch for changes in input model as a whole
        // this on updates the multi-select when a user load a whole new input-model.
        scope.$watch('inputModel', function (newVal) {
          if (newVal) {
            scope.refreshSelectedItems();
            scope.refreshOutputModel();
          }
        });
        /**
           * Checks whether any of children match the keyword.
           *
           * @param item the parent item
           * @param keyword the filter keyword
           * @returns {boolean} false if matches.
           */
        function isChildrenFiltered(item, keyword) {
          var childNodes = getAllChildNodesFromNode(item, []);
          for (var i = 0, len = childNodes.length; i < len; i++) {
            if (childNodes[i].name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
              return false;
            }
          }
          return true;
        }
        /**
           * Return all childNodes of a given node (as Array of Nodes)
           */
        function getAllChildNodesFromNode(node, childNodes) {
          for (var i = 0; i < node.children.length; i++) {
            childNodes.push(node.children[i]);
            // add the childNodes from the children if available
            getAllChildNodesFromNode(node.children[i], childNodes);
          }
          return childNodes;
        }
        scope.$watch('filterKeyword', function () {
          if (scope.filterKeyword !== undefined) {
            angular.forEach(scope.inputModel, function (item) {
              if (item.name.toLowerCase().indexOf(scope.filterKeyword.toLowerCase()) !== -1) {
                item.isFiltered = false;
              } else if (!isChildrenFiltered(item, scope.filterKeyword)) {
                item.isFiltered = false;
              } else {
                item.isFiltered = true;
              }
            });
          }
        });
      },
      controller: ["$scope", "$rootScope", "$document", function ($scope, $rootScope, $document) {
        var activeItem;
        $scope.showTree = false;
        $scope.selectedItems = [];
        $scope.multiSelect = $scope.multiSelect || false;
        /**
       * Clicking on document will hide the tree.
       */
        function docClickHide() {
          closePopup();
          $scope.$apply();
        }
        /**
       * Closes the tree popup.
       */
        function closePopup() {
          $scope.showTree = false;
          if (activeItem) {
            activeItem.isActive = false;
            activeItem = undefined;
          }
          $document.off('click', docClickHide);
        }
        /**
       * Sets the active item.
       *
       * @param item the item element.
       */
        $scope.onActiveItem = function (item) {
          if (activeItem !== item) {
            if (activeItem) {
              activeItem.isActive = false;
            }
            activeItem = item;
            activeItem.isActive = true;
          }
        };
        /**
       * Copies the selectedItems in to output model.
       */
        $scope.refreshOutputModel = function () {
          $scope.outputModel = angular.copy($scope.selectedItems);
        };
        /**
       * Refreshes the selected Items model.
       */
        $scope.refreshSelectedItems = function () {
          $scope.selectedItems = [];
          if ($scope.inputModel) {
            setSelectedChildren($scope.inputModel);
          }
        };
        /**
       * Iterates over children and sets the selected items.
       *
       * @param children the children element.
       */
        function setSelectedChildren(children) {
          for (var i = 0, len = children.length; i < len; i++) {
            if (!isItemSelected(children[i]) && children[i].selected === true) {
              $scope.selectedItems.push(children[i]);
            } else if (isItemSelected(children[i]) && children[i].selected === false) {
              children[i].selected = true;
            }
            if (children[i] && children[i].children) {
              setSelectedChildren(children[i].children);
            }
          }
        }
        /**
       * Checks of the item is already selected.
       *
       * @param item the item to be checked.
       * @return {boolean} if the item is already selected.
       */
        function isItemSelected(item) {
          var isSelected = false;
          if ($scope.selectedItems) {
            for (var i = 0; i < $scope.selectedItems.length; i++) {
              if ($scope.selectedItems[i].id === item.id) {
                isSelected = true;
                break;
              }
            }
          }
          return isSelected;
        }
        /**
       * Deselect the item.
       *
       * @param item the item element
       * @param $event
       */
        $scope.deselectItem = function (item, $event) {
          $event.stopPropagation();
          $scope.selectedItems.splice($scope.selectedItems.indexOf(item), 1);
          item.selected = false;
          this.refreshOutputModel();
        };
        /**
       * Swap the tree popup on control click event.
       *
       * @param $event the click event.
       */
        $scope.onControlClicked = function ($event) {
          $event.stopPropagation();
          $scope.showTree = !$scope.showTree;
          if ($scope.showTree) {
            $document.on('click', docClickHide);
          }
        };
        /**
       * Stop the event on filter clicked.
       *
       * @param $event the click event
       */
        $scope.onFilterClicked = function ($event) {
          $event.stopPropagation();
        };
        /**
       * Clears the filter text.
       *
       * @param $event the click event
       */
        $scope.clearFilter = function ($event) {
          $event.stopPropagation();
          $scope.filterKeyword = '';
        };
        /**
       * Wrapper function for can select item callback.
       *
       * @param item the item
       */
        $scope.canSelectItem = function (item) {
          return $scope.callback({
            item: item,
            selectedItems: $scope.selectedItems
          });
        };
        /**
       * The callback is used to switch the views.
       * based on the view type.
       *
       * @param $event the event object.
       */
        $scope.switchCurrentView = function ($event) {
          $event.stopPropagation();
          $scope.switchViewCallback({ scopeObj: $scope });
        };
        /**
       * Handles the item select event.
       *
       * @param item the selected item.
       */
        $scope.itemSelected = function (item) {
          if ($scope.useCallback && $scope.canSelectItem(item) === false || $scope.selectOnlyLeafs && item.children && item.children.length > 0) {
            return;
          }
          if (!$scope.multiSelect) {
            closePopup();
            for (var i = 0; i < $scope.selectedItems.length; i++) {
              $scope.selectedItems[i].selected = false;
            }
            item.selected = true;
            $scope.selectedItems = [];
            $scope.selectedItems.push(item);
          } else {
            item.selected = true;
            var indexOfItem = $scope.selectedItems.indexOf(item);
            if (isItemSelected(item)) {
              item.selected = false;
              $scope.selectedItems.splice(indexOfItem, 1);
            } else {
              $scope.selectedItems.push(item);
            }
          }
          this.refreshOutputModel();
        };

        $scope.checkAll = function () {
          // Limpar seleções existentes antes de selecionar todas
          $scope.selectedItems = [];
          angular.forEach($scope.inputModel, function (item) {
            callItens(item, false);
          });
          
          // Selecionar todas as categorias
          angular.forEach($scope.inputModel, function (item) {
            callItens(item, true);
          });
          this.refreshOutputModel();
        }

        $scope.uncheckAll = function () {
          $scope.selectedItems = [];
          angular.forEach($scope.inputModel, function (item) {
            callItens(item, false);
          });
          this.refreshOutputModel();
        }

        function callItens(item, flag) {

          if (item.children.length > 0) {
            item.children.forEach(element => {
              callItens(element, flag);
            });
          } else {
            item.selected = flag;

            if (flag)
              $scope.selectedItems.push(item);
          }

        }
      }]
    };
  });


angular.module('epbxManagerApp')
	.directive('emNumberOnly', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				var negativo = /\-/.test(attrs.numberOnly);
				var decimal = /\.|\,/.test(attrs.numberOnly) ? /\.|\,/.exec(attrs.numberOnly)[0] : null;

				var regExp = '^';
				regExp += negativo ? '[\\-]{0,1}' : '';
				regExp += '[\\d]+';
				if (decimal != null) {
					regExp += '[\\' + decimal + '][\\d]+|';
					if (negativo) {
						regExp += '[\\-]{0,1}'
					}
					regExp += '[\\d]+'
				}
				regExp += '';
				regExp = new RegExp(regExp);

				ngModel.$parsers.unshift(function (input) {
					if (input === undefined) return null;
					if (input === null) return;

					input = input.toString().replace(/\./, decimal);
					if (input == '-') return input;
					if (decimal !== null && input.charAt(input.length - 1) == decimal) return input;

					input = regExp.test(input) ? regExp.exec(input)[0] : null;

					var viewVal = null;

					if (input !== null) {
						input = decimal != null ? parseFloat(input.replace(/\,/, '.')) : parseInt(input);
					}

					viewVal = isNaN(input) || input === null ? '' : input;

					ngModel.$setViewValue(decimal != null ? viewVal.toString().replace(/\./, decimal) : viewVal.toString());
					ngModel.$render();

					return isNaN(input) ? null : input;
				});

				ngModel.$formatters.unshift(function (value) {
					if (value !== undefined && value !== null) {
						return decimal != null ? value.toString().replace(/\./, decimal) : value.toString();
					}
				});
			}
		}
	});
angular.module('epbxManagerApp')

    .directive('emNumericTextBox', function () {
        return {
            restrict: 'AE',
            controllerAs: 'emNumericTextBox',
            scope: true,
            require: ['^ngModel', '^options'],
            bindToController: {
                ngModel: '=',
                options: '=',
                maxLength: '=',
                disabled: '=',
                change: '&',
                init: '&',
                max: '@',
                min: '@'
            },
            template: `
                <div oc-lazy-load="'lazy_Kendo_UI'">
                    <input 
                        kendo-numeric-text-box 
                        ng-disabled="emNumericTextBox.disabled"
                        k-options="emNumericTextBox.options" 
                        k-ng-model="emNumericTextBox.ngModel"
                        k-on-change="emNumericTextBox.change()"
                        class="full-width" 
                        k-min="min"
                        maxlength="emNumericTextBox.max"
                        ng-init="init"
                    />
                </div>`,
            controller: ["$scope", function ($scope) {
                if ($scope.disabled == 'undefined') {
                    $scope.disabled = false;
                }

                if (!$scope.min || $scope.min === 'undefined') {
                    $scope.min = 0;
                }
            }]
        }
    })




angular.module('epbxManagerApp')

    .directive('emPermissao', ["PermissaoService", function (PermissaoService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                if (!attrs.emPermissao) throw new Error("Para usar a diretiva emPermissao deve especificar a permissao que deve ser checada no formato Recurso.Acao");

                var args = attrs.emPermissao.indexOf(".") > -1 ? attrs.emPermissao.split(".") : attrs.emPermissao.split(":");

                var recurso = args[0];
                var acao = null;
                if (args.length > 1) {
                    acao = args[1];
                }

                if (recurso && !PermissaoService.checkAccess(recurso, acao)) {
                    //remove o elemento da tela se o usuário não tiver permissão de acesso
                    element.remove();
                }
            }
        }
    }]);
angular.module('epbxManagerApp')
    .directive('emRetornoPesquisaCount', ["$translate", function($translate) {
        return {
            templateUrl: 'app/directives/templates/emRetornoPesquisaCount.html',
            restrict: 'E',
            scope: {
                countPesquisa: '@'
            },
            link: function(scope) {
                scope.$watch('countPesquisa', function(newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.countPesquisa = newValue;
                    }
                });
            }
        }
    }]);
angular.module('epbxManagerApp')
    .directive('emRetornoPesquisaCountPlus', ["$translate", function($translate) {
        return {
            templateUrl: 'app/directives/templates/emRetornoPesquisaCountPlus.html',
            restrict: 'E',
            scope: {
                countPesquisa: '@'
            },
            link: function(scope) {
                scope.$watch('countPesquisa', function(newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.countPesquisa = newValue;
                    }
                });
            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emSelect', ["$translate", "$timeout", "$injector", function ($translate, $timeout, $injector) {
        return {
            restrict: 'E',
            templateUrl: 'app/directives/templates/emSelect.html',
            require: '?ngModel',
            scope: {
                colecao: '=',
                nome: '@',
                valor: '@',
                // É um select multiplo
                multiplo: '@',
                // Retorna o ngModel como string (funciona em conjunto com o atributo multiplo) 
                modelString: '@',
                // Permite definir qual será o separador quando a propriedade modelString for configurada
                separador: '@',
                // Valor da ng model pode ser 0
                permitirZero: '@',
                // Quando select é multiplo, pode permitir selecionar ids ou objetos
                // Model Tipo
                // 0 - Não inicializado
                // 1 - Objetos
                // 2 - Ids
                modelTipo: '@',
                // Usar select com item colorido
                colorirItem: '@',
                // O valor pode ser digitado pelo usuário
                valorCustom: '@',
                // O select fica com aparência de campo de texto
                textLike: '@',
                // Permite definir um objeto como filtro para definir o que sera mostrado no combo
                filtro: '=',
                // Permite definir uma função como filtro para definir o que sera mostrado no combo
                filtroFuncao: '&',
                // Mudar o texto do placeholder
                textoPlaceholder: '@',
                // Alterar o disabled dinamicamente
                ngDisabled: '=',
                // Alterar o required dinamicamente
                ngRequired: '=',
                // Permite usar uma função que avisa quando o combo muda o valor
                change: '&',
                // Esconder botão de limpar
                escondeLimpar: '@',
                // resource
                resource: '@',
                // Caso verdadeiro envia null ao invés de undefined para o ng-change (botão de limpar)
                setViewValueNull: '@',
            },
            link: function (scope, element, attrs, ngModel) {
                scope.modelTipo = 0;
                scope.elementoVisivel = false;
                scope.iniciado = false;
                scope.selectDirective = null;
                scope.escondeLimpar = attrs.escondelimpar === "true" || attrs.escondelimpar === true;
                scope.colecaoFinal = scope.colecao || [];
                scope.separador = attrs.separador ? attrs.separador : ',';
                scope.setViewValueNull = attrs.setviewvaluenull === "true" || attrs.setviewvaluenull === true;
                scope.permitirZero = attrs.permitirzero === "true" || attrs.permitirzero === true;

                $translate(scope.textoPlaceholder || 'form.placeholderSelect').then(res => scope.textoPlaceholder = res);

                if (!attrs.filtroFuncao) scope.filtroFuncao = function () {
                    return true;
                }
                else {
                    const originalFn = scope.filtroFuncao;
                    scope.filtroFuncao = function (value, index, array) {
                        return originalFn({
                            value: value,
                            index: index,
                            array: array
                        });
                    }
                }

                if (ngModel == null) return;

                if (angular.isDefined(scope.resource)) {
                    // podemos usar um Resource para fazer a query dos itens da lista
                    scope.resource = $injector.get(scope.resource);
                    scope.resource.odata().orderBy(scope.nome, 'asc').query().then(function (data) {
                        scope.colecaoFinal = data;
                    });
                }


                if (scope.multiplo) {
                    scope.elementoVisivel = (element.find('.select-container')[0].clientWidth > 0);

                    scope.$watch(function () {
                        return element.find('.select-container')[0].clientWidth;
                    }, function () {
                        scope.elementoVisivel = (element.find('.select-container')[0].clientWidth > 0);
                    });
                }

                function mudarValorModel () {
                    if (!scope.multiplo) {
                        if (ngModel.$viewValue || (scope.permitirZero && (ngModel.$viewValue == 0 || ngModel.$viewValue == null))) {
                            scope.selectModel = _.find(scope.colecaoFinal, function (el) {
                                return el[scope.valor] == ngModel.$viewValue;
                            });
                            if (!scope.selectModel && scope.valorCustom === 'true') {
                                selectCustom(ngModel.$viewValue);
                            }
                        } else {
                            scope.selectModel = null;
                            if (scope.selectDirective) {
                                scope.selectDirective.selected = null;
                            }
                        }
                    } else {
                        if (ngModel.$viewValue) {
                            if (scope.modelTipo == 'object') {
                                scope.selectModel = _.filter(scope.colecaoFinal, function (el) {
                                    return _.find(ngModel.$viewValue, function (el2) {
                                        return el[scope.valor] == el2[scope.valor];
                                    });
                                });
                            } else {
                                scope.selectModel = _.filter(scope.colecaoFinal, function (el) {
                                    return _.find(ngModel.$viewValue, function (el2) {
                                        return el[scope.valor] == el2;
                                    });
                                });
                            }
                        } else {
                            scope.selectModel = [];
                            if (scope.selectDirective) {
                                scope.selectDirective.selected = [];
                                scope.selectDirective.setItemsFn(scope.colecaoFinal);
                            }
                        }
                    }
                    if (scope.selectDirective && scope.selectModel && !scope.multiplo)
                        scope.selectDirective.select(scope.selectModel);
                    element.trigger("change")
                }

                //Infinite Scroll Magic
                scope.infiniteScroll = {};
                scope.infiniteScroll.numToAdd = 20;
                scope.infiniteScroll.currentItems = 20;

                scope.limpar = function (select, event) {
                    select.clear(event);
                    let valor = undefined;
                    if (scope.setViewValueNull) {
                        valor = null;
                    }
                    ngModel.$setViewValue(valor);
                    ngModel.$setTouched();
                }

                scope.resetInfScroll = function () {
                    scope.infiniteScroll.currentItems = scope.infiniteScroll.numToAdd;
                };

                scope.addMoreItems = function () {
                    scope.infiniteScroll.currentItems += scope.infiniteScroll.numToAdd;
                };

                scope.mudarTamanho = function () {
                    element.find('.selectize-input');
                }

                // permite definir um objeto como filtro para o que vai mostrar no combo
                scope.filterObject = scope.filtro || {};
                scope.filterObject[scope.nome] = '';

                if (scope.textLike === 'true') {
                    $timeout(function () {
                        const comboInput = element.find('.selectize-input');
                        $(comboInput).addClass('text-like');
                    });
                }
                if (scope.valorCustom === 'true') {
                    $timeout(function () {
                        const comboInput = element.find('.selectize-input');
                        $(comboInput).addClass('custom-value');
                    });
                    scope.$watch(function () {
                        return scope.filterObject[scope.nome];
                    }, function (newVal) {
                        if (newVal) {
                            if (!isNaN(newVal)) {
                                newVal = parseFloat(newVal);
                            }
                            ngModel.$setViewValue(newVal);
                            selectCustom(newVal);
                        }
                    });
                }

                function selectCustom(newVal) {
                    scope.selectModel = {};
                    scope.selectModel[scope.nome] = newVal;
                    scope.selectModel[scope.valor] = newVal;
                    if (scope.selectDirective != null)
                        scope.selectDirective.selected = scope.selectModel;
                }

                mudarValorModel();

                scope.onSelectInit = function ($select) {
                    scope.selectDirective = $select;
                    setItems();

                    scope.$watch(function () {
                        return scope.selectDirective ? (scope.selectDirective.ngModel ? scope.selectDirective.ngModel.$touched : null) : null;
                    }, function (newVal) {
                        if (newVal) {
                            ngModel.$setTouched();
                        } else {
                            ngModel.$setUntouched();
                        }
                    });

                    scope.selectedIndex = -1;
                    $timeout(function () {
                        function selectKeyDownHandler (event) {
                            if (event.which == 38 || event.which == 40 || event.which == 13 || event.which == 27 || event.which == 9) {
                                let choices;
                                if ($(event.currentTarget).siblings('.ui-select-choices').length > 0) {
                                    choices = $(event.currentTarget).siblings('.ui-select-choices').find('.ui-select-choices-row');
                                } else {
                                    choices = $(event.currentTarget).find('.ui-select-choices-row');
                                }

                                //VERIFICAR BOTÃO
                                if (event.which == 38) {
                                    if (scope.selectedIndex > 0) { //UP ARROW
                                        scope.selectedIndex--;
                                    }
                                } else if (event.which == 40) { //DOWN ARROW
                                    if (scope.selectedIndex < choices.length - 1) {
                                        scope.selectedIndex++;
                                    }
                                } else if (event.which == 13) { //ENTER
                                    if (scope.selectedIndex >= 0) {
                                        scope.onSelect(scope.colecaoFinal[scope.selectedIndex]);
                                        scope.selectDirective.close();
                                    }
                                } else if (event.which == 27) { //ESC
                                    scope.selectDirective.close();
                                } else if (event.which == 9) { //TAB
                                    scope.selectDirective.close();
                                }

                                if (event.which == 38 || event.which == 40) { //SELECIONAR ITEM E REALIZAR SCROLL
                                    choices.removeClass('manual-hover');
                                    choices.eq(scope.selectedIndex).addClass('manual-hover');

                                    const $s = choices.parents('.ui-select-choices-content');
                                    const optionTop = choices.eq(scope.selectedIndex).offset().top;
                                    const selectTop = $s.offset().top;
                                    $s.scrollTop($s.scrollTop() + (optionTop - selectTop));
                                }

                                if (event.which != 27 && event.which != 9) { //FOCAR NOVAMENTE NO SELECT SE NÃO FOR ESC                           
                                    if ($(event.currentTarget).children('.ui-select-search').get(0)) {
                                        $(event.currentTarget).children('.ui-select-search').get(0).focus();
                                    }
                                    if ($(event.currentTarget).siblings('.selectize-input').get(0)) {
                                        $(event.currentTarget).siblings('.selectize-input').children('.ui-select-search').get(0).focus();
                                    } else {
                                        event.currentTarget.focus();
                                    }
                                }
                            }
                        }

                        const focusser = $(element).find('.ui-select-focusser');
                        const divChoices = focusser.siblings('.selectize-input');
                        const selectMatch = $(element).find('.ui-select-match');

                        focusser.keydown(selectKeyDownHandler);
                        divChoices.keydown(selectKeyDownHandler);
                        selectMatch.click(function (event) {
                            $timeout(function () {
                                $(event.currentTarget).siblings('.ui-select-search').get(0).focus();
                            });
                        });
                    });

                    scope.$watch(function () {
                        return scope.selectDirective.open;
                    }, function (newVal, oldVal) {
                        $timeout(function () {
                            if (scope.selectDirective.open == true) {
                                scope.selectedIndex = 0;
                                const choices = $(element).find('.ui-select-choices-row');
                                choices.removeClass('manual-hover');
                                choices.eq(scope.selectedIndex).addClass('manual-hover');
                            } else {
                                scope.selectedIndex = -1;
                            }

                            $(element).find('.ui-select-choices').focus();
                        });
                        if (oldVal != newVal && newVal == false) {
                            ngModel.$setDirty();
                        }
                    });
                }

                scope.onSelect = function ($item) {
                    if ($item) {
                        if (!scope.multiplo) {
                            ngModel.$setViewValue($item[scope.valor]);
                        } else {
                            let model = ngModel.$viewValue;
                            if (scope.modelString && typeof model === 'string') {
                                model = model.split(scope.separator);
                                const idxEmptyString = model.indexOf("");
                                if (idxEmptyString > -1) model.splice(idxEmptyString, 1);
                            }
                            if (!model) model = [];
                            if (scope.modelTipo == 'object') {
                                model.push($item);
                                if (scope.modelString) {
                                    model = model.join(scope.separador);
                                }
                                ngModel.$setViewValue(model);
                            } else if ($item.constructor == Array) {
                                ngModel.$setViewValue($item);
                            } else {
                                model.push($item[scope.valor]);
                                if (scope.modelString) {
                                    model = model.join(scope.separador);
                                }
                                ngModel.$setViewValue(model);
                            }
                        }
                    } else {
                        if (ngModel.$viewValue) {
                            let valor = undefined;
                            if (scope.setViewValueNull) {
                                valor = null;
                            }
                            ngModel.$setViewValue(valor);
                        }
                    }
                    scope.change();
                }

                scope.onRemove = function ($item) {
                    if (scope.multiplo) {
                        let model = ngModel.$viewValue;
                        if (scope.modelString && typeof model === 'string') {
                            model = model.split(scope.separador);
                        }

                        const objectSelected = model.find((el) => {
                            if (scope.modelTipo == 'object') {
                                return el[scope.valor] == $item[scope.valor];
                            } else {
                                return el == $item[scope.valor];
                            }
                        });
                        const index = model.indexOf(objectSelected);
                        model.splice(index, 1);

                        if (scope.modelString) {
                            model = model.join(scope.separador);
                        }

                        ngModel.$setViewValue(model);

                    }
                }

                scope.$watch(function () {
                    return ngModel.$viewValue;
                }, function (newVal) {
                    if (newVal != null && newVal != undefined) {
                        newVal = newVal.toString();
                    }
                    if (scope.filterObject[scope.nome] !== newVal || scope.multiplo) {
                        mudarValorModel();
                        if (!newVal && (!scope.permitirZero || scope.permitirZero == 'false' || (scope.permitirZero == 'true' && (newVal != 0 && newVal != null)))) {
                            $timeout(function () {
                                if (scope.iniciado) {
                                    element.find('input[type="button"]').click();
                                } else {
                                    scope.iniciado = true;
                                }
                            }, 0);
                        }
                    }
                });

                scope.$watch(function () {
                    return scope.colecao;
                }, function (newVal) {
                    if (newVal) {
                        scope.colecaoFinal = newVal;
                        setItems();
                    }
                });

                scope.$watch(function () {
                    if (attrs['disabled'])
                        return attrs['disabled'];
                    else if (scope.ngDisabled)
                        return scope.ngDisabled;
                    else
                        return false;
                }, function () {
                    scope.disabled = (attrs['disabled'] != undefined && attrs['disabled'] != false) || scope.ngDisabled == true;
                });

                scope.$watch(function () {
                    if (attrs['required'])
                        return attrs['required'];
                    else if (scope.ngRequired)
                        return scope.ngRequired;
                    else
                        return false;
                }, function () {
                    scope.required = (attrs['required'] != undefined && attrs['required'] != false) || scope.ngRequired == true;
                });

                function setItems () {
                    if (scope.selectDirective && scope.selectDirective.setItemsFn) {
                        scope.selectDirective.setItemsFn(scope.colecaoFinal);
                        mudarValorModel();
                    }
                }

                scope.getColor = function (classe) {
                    if (classe) {
                        const num = classe.substring(classe.length - 3);
                        if (parseInt(num) >= 400) {
                            return {
                                'color': '#ffffff',
                                'font-weight': 'bold'
                            };
                        } else {
                            return {
                                'color': '#000000',
                                'font-weight': 'bold'
                            };
                        }
                    }
                }
            }
        }
    }])

    .directive('filterSelect', function () {
        return {
            restrict: 'A',
            require: 'uiSelect',
            link: function (scope, $element, attrs, $select) {
                scope.$watch(function () {
                    return $select.search;
                }, function (newVal) {
                    const filter = scope.$eval(attrs.filterObject);
                    const attrName = scope.$eval(attrs.filterAttr);
                    if (filter && attrName)
                        filter[attrName] = newVal;
                });

                scope.$watch(function () {
                    return $select.open;
                }, function (newVal) {

                    if (newVal == false) {
                        if (scope.$parent.resetInfScroll) {
                            scope.$parent.resetInfScroll();
                            scope.$select.refreshItems();
                        }
                    } else {
                        scope.$select.$element.find('.ui-select-choices-content').animate({
                            scrollTop: "0"
                        });
                    }
                });
            }
        }
    })

    .directive('infiniteSelect', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
        return {
            link: function (scope, elem, attrs) {
                let checkWhenEnabled, handler, scrollDistance, scrollEnabled;
                elem = $(elem.children()[0]);
                $window = angular.element($window);
                scrollDistance = 0;
                if (attrs.infiniteSelectDistance != null) {
                    scope.$watch(attrs.infiniteSelectDistance, function (value) {
                        return (scrollDistance = parseInt(value, 10));
                    });
                }
                scrollEnabled = true;
                checkWhenEnabled = false;
                if (attrs.infiniteSelectDisabled != null) {
                    scope.$watch(attrs.infiniteSelectDisabled, function (value) {
                        scrollEnabled = !value;
                        if (scrollEnabled && checkWhenEnabled) {
                            checkWhenEnabled = false;
                            return handler();
                        }
                    });
                }
                $rootScope.$on('refreshStart', function () {
                    elem.animate({
                        scrollTop: "0"
                    });
                });
                handler = function () {
                    let container, elementBottom, remaining, shouldScroll, containerBottom;
                    container = $(elem.children()[0]);
                    elementBottom = elem.offset() ? elem.offset().top + elem.height() : 0;
                    containerBottom = container.offset() ? container.offset().top + container.height() : 0;
                    remaining = containerBottom - elementBottom;
                    shouldScroll = remaining <= elem.height() * scrollDistance;
                    if (shouldScroll && scrollEnabled) {
                        if ($rootScope.$$phase) {
                            return scope.$eval(attrs.infiniteSelect);
                        } else {
                            return scope.$apply(attrs.infiniteSelect);
                        }
                    } else if (shouldScroll) {
                        return (checkWhenEnabled = true);
                    }
                };
                elem.on('scroll', handler);
                scope.$on('$destroy', function () {
                    return $window.off('scroll', handler);
                });
                return $timeout((function () {
                    if (attrs.infiniteSelectImmediateCheck) {
                        if (scope.$eval(attrs.infiniteSelectImmediateCheck)) {
                            return handler();
                        }
                    } else {
                        return handler();
                    }
                }), 0);
            }
        };
    }]);
angular.module('epbxManagerApp')

// combos para selecionar usuários são frequentes na aplicação
// TODO: paginação/infinite scroll através de ajax.get e/ou Caching.
.directive('emSelectUsuario', ["UsuarioResource", function (UsuarioResource) {
    return {
        restrict: 'E',
        controllerAs: 'selectUsuario',
        bindToController: {
            ngModel: '='
        },
        template: '<em-select valor="UsuarioId" nome="Nome" colecao="selectUsuario.usuarioList" ng-model="selectUsuario.ngModel"></em-select>',
        controller: function () {
            this.usuarioList = [];
            UsuarioResource.odata().select(["UsuarioId", "Nome"]).orderBy("Nome").query().then(angular.bind(this, function (list) {
                this.usuarioList = list;
            }));
        }
    }
}])

.directive('emSelectRamal', ["RamalResource", function (RamalResource) {
    return {
        restrict: 'E',
        controllerAs: 'selectRamal',
        bindToController: {
            ngModel: '='
        },
        template: '<em-select valor="Ramal" nome="Descricao" colecao="selectRamal.list" ng-model="selectRamal.ngModel"></em-select>',
        controller: function () {
            this.list = undefined;
            RamalResource.getSimples({ RamalTipoId: "1,6" }).$promise.then(angular.bind(this, function (list) {
                this.list = [];
                angular.forEach(list, function (item) {
                    this.list.push({
                        Descricao: item.Descricao,
                        Ramal: item
                    });
                }, this);
            }));
        }
    }
}])

.directive('emSelectGrupo', ["GrupoResource", function (GrupoResource) {
    return {
        restrict: 'E',
        controllerAs: 'selectGrupo',
        bindToController: {
            ngModel: '='
        },
        template: '<em-select valor="Grupo" nome="Descricao" colecao="selectGrupo.list" ng-model="selectGrupo.ngModel"></em-select>',
        controller: function () {
            this.list = undefined;
            GrupoResource.getGrupoSimples().$promise
                .then(angular.bind(this, function (list) {
                    this.list = [];
                    angular.forEach(list, function (item) {
                        this.list.push({
                            Descricao: item.Numero + " - " + item.Descricao,
                            Grupo: item
                        });
                    }, this);
            }));
        }
    }
}])
angular.module('epbxManagerApp')
    .directive('emSemRegistro', function () {
        return {
            templateUrl: 'app/directives/templates/emSemRegistro.html',
            restrict: 'E',
            scope: {
                isCard: "@",
                colecao: "=",
                semSubtitulo: "@",
                titulo: "@",
                subtitulo: "@",
                semPadding: "@"
            },
            link: function($scope){
                if(!$scope.titulo){
                    $scope.titulo = 'lista.semRegistroTitulo';
                }
                if(!$scope.subtitulo){
                    $scope.subtitulo = 'lista.semRegistroSubtitulo';
                }
            }
        }
    });
angular.module('epbxManagerApp')

    .filter('moment', function () {
        return function (dateString, format) {
            return moment(dateString).format(format);
        };
    })

    .directive('emSupervisaoPopUp', ["SupervisaoService", "$interval", "SUPERVISAO_EVENTS", "$window", "$translate", "NotifyService", function (SupervisaoService, $interval, SUPERVISAO_EVENTS, $window, $translate, NotifyService) {
        return {
            restrict: 'EA',
            templateUrl: "app/directives/templates/emSupervisaoPopUp.html",
            scope: {},
            link: function (scope) {
                scope.SupervisaoService = SupervisaoService;
                scope.open = false;
                scope.eventDisplay = { Titulo: 'Monitora Chamada', Ramal: '' };

                let timerInterval;

                function startTimer() {
                    stopTimer();

                    let duration = moment.duration(0, 'milliseconds');
                    let interval = 1000;

                    timerInterval = $interval(function () {
                        duration = moment.duration(duration.asMilliseconds() + interval, 'milliseconds');
                        scope.eventDisplay.Timer = duration.asMilliseconds();
                    }, interval);
                }

                function stopTimer() {
                    $interval.cancel(timerInterval);
                    delete scope.eventDisplay.Timer;
                }

                function onMonitoraChamada(event, dados) {
                    startTimer();
                    scope.open = true;
                    scope.eventDisplay.Ramal = dados.Ramal;
                }

                function onFimMonitoracao() {
                    stopTimer();
                    scope.open = false;
                }

                function onMonitoraChamadaErro(error) {
                    stopTimer();
                    scope.open = false;

                    NotifyService.showError(null, (error.message || $translate.instant('diretivas.naoFoiPossivelMonitorarORamal')))
                }

                scope.$on(SUPERVISAO_EVENTS.onMonitoraChamada, onMonitoraChamada);
                scope.$on(SUPERVISAO_EVENTS.onFimMonitoracao, onFimMonitoracao);
                scope.$on(SUPERVISAO_EVENTS.onMonitoraChamadaErro, onMonitoraChamadaErro);
            }
        }
    }]);
angular.module('epbxManagerApp')

.directive('tablesorter', ["$timeout", function ($timeout) {
    return {
        restrict: 'C',
        scope: {
            onSortColumn: '&',
            sortOptions: '=',
        },
        link: function (scope, element) {
            $timeout(function () {
                element.addClass("tablesorter-altair");
                let allThs = element.find("th");
                let ths = [];
                $.each(allThs, function (index, elem) {
                    if (elem.attributes['column-name']) {
                        ths.push(elem);
                    }
                });
                ths = $(ths);
                ths.addClass("tablesorter-header tablesorter-headerUnSorted");
                ths.contents().wrap("<div class='tablesorter-header-inner'><div>");

                ths.click(function () {
                    if (this.attributes['column-name']) {
                        var sortedColumn = this.attributes['column-name'].value;

                        var sortOrder = 'asc';
                        if ($(this).hasClass('tablesorter-headerDesc') == true) {
                            sortOrder = 'asc'
                        }
                        if ($(this).hasClass('tablesorter-headerAsc') == true) {
                            sortOrder = 'desc'
                        }

                        ths.addClass("tablesorter-header tablesorter-headerUnSorted");
                        ths.removeClass("tablesorter-headerDesc tablesorter-headerAsc");
                        if (sortOrder == 'asc')
                            $(this).addClass('tablesorter-headerAsc');
                        else if (sortOrder == 'desc')
                            $(this).addClass('tablesorter-headerDesc');

                        if (scope.sortOptions) {
                            scope.sortOptions.column = sortedColumn;
                            scope.sortOptions.order = sortOrder;
                        }
                        scope.onSortColumn({});
                    }
                });
            }, 10);
        }
    }
}]);

angular.module('epbxManagerApp')

    .directive('emTelephoneMask', function () {
        var removeNonNumeric = /[^0-9]*/g;
        var formatTelephone = /^(\d{0,2})(\d{0,9}).*/;
        var keys = [37, 38, 39, 40, 8, 13, 46];
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                scope.aplicarDepois = attrs.emTelephoneMask;

                scope.formatText = function (text) {
                    text = text ? text.toString().replace(removeNonNumeric, "").substring(0, 11) : text;
                    if (scope.aplicarDepois == 'true' && text.length < 11) {
                        text = text.replace(formatTelephone, "$1$2");
                    } else {
                        text = text.replace(formatTelephone, "($1) $2");
                    }
                    return text;
                }

                ngModel.$formatters.push(function (domValue) {
                    if (domValue) {
                        domValue = domValue.toString().replace(removeNonNumeric, "");
                        return scope.formatText(domValue);
                    }
                    return domValue;
                });

                ngModel.$parsers.push(function (domValue) {
                    return domValue ? domValue.toString().replace(removeNonNumeric, "") : domValue;
                });

                element.on('blur keyup change', function (event) {
                    let val = event.keyCode;
                    if (!_.contains(keys, val)) {
                        scope.$evalAsync(ngModel.$render);
                    }
                });

                ngModel.$render = function () {
                    if (ngModel.$modelValue) {
                        let text = ngModel.$modelValue;
                        text = text ? text.toString().replace(removeNonNumeric, "").substring(0, 11) : text;
                        element.val(scope.formatText(text));
                    }else{
                        element.val(ngModel.$modelValue);
					}
                };

            }
        };
    });
    (function () {
        "use strict";

        angular.module("epbxManagerApp")
            .directive('emTextarea', ["$translate", function ($translate) {
                return {
                    restrict: 'E',
                    templateUrl: 'app/directives/templates/emTextarea.html',
                    require: '?ngModel',
                    scope: {
                        // Mudar o texto do placeholder
                        textoPlaceholder: '@',
                        // Alterar o disabled dinamicamente
                        ngDisabled: '=',
                        // Alterar o required dinamicamente
                        ngRequired: '=',
                        // Permite usar uma função que avisa quando o combo muda o valor
                        change: '&',
                        // Quantidade de linhas de ocupação do textarea
                        rows: '@',
                        // Máximo de caracteres do campo
                        maxLength: '@',
                        ngModel: '=ngModel'
                    },
                    link: function (scope, element, attrs, ngModel) {
                        $translate(scope.textoPlaceholder || 'form.placeholderTextarea').then(res => scope.textoPlaceholder = res);
                        scope.currentLength = 0;

                        if (ngModel == null) return;

                        scope.$watch(function () {
                            if (attrs['disabled'])
                                return attrs['disabled'];
                            else if (scope.ngDisabled)
                                return scope.ngDisabled;
                            else
                                return false;
                        }, function () {
                            scope.disabled = (attrs['disabled'] != undefined && attrs['disabled'] != false) || scope.ngDisabled == true;
                        });

                        scope.$watch(function () {
                            if (attrs['required'])
                                return attrs['required'];
                            else if (scope.ngRequired)
                                return scope.ngRequired;
                            else
                                return false;
                        }, function () {
                            scope.required = (attrs['required'] != undefined && attrs['required'] != false) || scope.ngRequired == true;
                        });

                        scope.$watch('ngModel', function (newVal) {
                            if (newVal !== null && newVal !== undefined) {
                                scope.currentLength = newVal.length;
                                if (newVal.length > scope.maxLength) {
                                    scope.ngModel = newVal.substring(0, scope.maxLength);
                                }
                            }
                            //ngModel.$setViewValue(scope.ngModel);
                        });
                    }
                }
            }])
    })();

angular.module('epbxManagerApp')
  .directive('treeItem', ['$compile',
    function ($compile) {
      return {
        restrict: 'E',
        templateUrl: 'app/directives/templates/emTreeItem.html',
        scope: {
          item: '=',
          itemSelected: '&',
          onActiveItem: '&',
          multiSelect: '=?',
          selectOnlyLeafs: '=?',
          isActive: '=', // the item is active - means it is highlighted but not selected
          useCallback: '=',
          canSelectItem: '=' // reference from the parent control
        },
        controller: ["$scope", "$rootScope", function ($scope, $rootScope) {

          $scope.item.isExpanded = false;

          $scope.$on("checkAll", function (e, data) {

            $scope.itemSelected({ item: data });
            data.children.forEach(element => {
              $scope.itemSelected({ item: element });
            });

          });

          /**
           * Shows the expand option.
           *
           * @param item the item
           * @returns {*|boolean}
           */
          $scope.showExpand = function (item) {
            return item.children && item.children.length > 0;
          };

          /**
           * On expand clicked toggle the option.
           *
           * @param item the item
           * @param $event
           */
          $scope.onExpandClicked = function (item, $event) {
            $event.stopPropagation();
            item.isExpanded = !item.isExpanded;
          };

          /**
           * Event on click of select item.
           *
           * @param item the item
           * @param $event
           */
          $scope.clickSelectItem = function (item, $event) {
            $event.stopPropagation();
            if ($scope.itemSelected) {
              $scope.itemSelected({ item: item });
              item.children.forEach(element => {
                $scope.itemSelected({ item: element });
              });
            }
          };

          /**
           * Is leaf selected.
           *
           * @param item the item
           * @param $event
           */
          $scope.subItemSelected = function (item, $event) {
            if ($scope.itemSelected) {
              $scope.itemSelected({ item: item });
            }
          };

          /**
           * Active sub item.
           *
           * @param item the item
           * @param $event
           */
          $scope.activeSubItem = function (item, $event) {
            if ($scope.onActiveItem) {
              $scope.onActiveItem({ item: item });
            }
          };

          /**
           * On mouse over event.
           *
           * @param item the item
           * @param $event
           */
          $scope.onMouseOver = function (item, $event) {
            $event.stopPropagation();
            if ($scope.onActiveItem) {
              $scope.onActiveItem({ item: item });
            }
          };

          /**
           * Can select item.
           *
           * @returns {*}
           */
          $scope.showCheckbox = function (item) {
            if (!$scope.multiSelect) {
              return false;
            }

            if (item.children.length == 0)
              return true;

            if ($scope.selectOnlyLeafs) {
              return false;
            }

            if ($scope.useCallback) {
              return $scope.canSelectItem($scope.item);
            }
          };

        }],
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function (element, attrs, link) {
          // Normalize the link parameter
          if (angular.isFunction(link)) {
            link = { post: link };
          }

          // Break the recursion loop by removing the contents
          var contents = element.contents().remove();
          var compiledContents;
          return {
            pre: (link && link.pre) ? link.pre : null,
            /**
             * Compiles and re-adds the contents
             */
            post: function (scope, element, attrs) {
              // Compile the contents
              if (!compiledContents) {
                compiledContents = $compile(contents);
              }
              // Re-add the compiled contents to the element
              compiledContents(scope, function (clone) {
                element.append(clone);
              });

              // Call the post-linking function, if any
              if (link && link.post) {
                link.post.apply(null, arguments);
              }
            }
          };
        }
      };
    }]);
angular.module('epbxManagerApp')

    .directive('emTts', ["$timeout", "ModalService", "UraResource", function ($timeout, ModalService, UraResource) {
        return {
            restrict: 'EA',
            scope: {
                onSuccess: '='
                ,onSuccessTermino: '='
                ,onSuccessInvalido: '='
                ,onSuccessMaxError: '='
                ,nome: '@'
            },
            templateUrl: 'app/directives/templates/emTts.html',
            link: function (scope, element, attrs) {

                scope.modal = null;           

                scope.open = function () {
                    scope.modal = $.UIkit.modal('#modal-tts');
                    scope.modal.show();
                }

                scope.gerarTTSDiretiva = function () {
                    ModalService.showLoading();
                    UraResource.geraTTS({ Texto: scope.configAudio.Fraseologia })
                        .$promise
                        .then((data) => {
                            ModalService.hideLoading();

                            scope.configAudio.ArquivoId = data.UraArquivoId;
                            scope.configAudio.Arquivo = data;

                            //enviar eventos 
                            scope.modal = $.UIkit.modal('#modal-tts');
                            scope.modal.hide();
                            scope.configAudio = {};

                           

                        }).catch((ex) => {
                            ModalService.hideLoading();
                            scope.configAudio = {};
                        });
                }

                var onSuccess = function (data) {
                    $timeout(function () {
                    if (scope.onSuccess)
                        scope.$apply(scope.onSuccess(data));
                    })
                };

                var onSuccessTermino = function (data) {
                    $timeout(function () {
                    if (scope.onSuccess)
                        scope.$apply(scope.onSuccessTermino(data));
                    })
                };

                var onSuccessInvalido = function (data) {
                    $timeout(function () {
                    if (scope.onSuccess)
                        scope.$apply(scope.onSuccessInvalido(data));
                    })
                };

                var onSuccessMaxError = function (data) {
                    $timeout(function () {
                    if (scope.onSuccess)
                        scope.$apply(scope.onSuccessMaxError(data));
                    })
                };
            }
        }
    }]);

angular.module('epbxManagerApp')
    .directive('ukTab', function () {
        return {
            restrict: 'C',
            scope: {},
            link: function ($scope, $element) {
             
            }
        };
    });
(function () {
    "use strict"

    function validateJson(value) {
        try {
            return angular.isObject(angular.fromJson(value))
        }
        catch (_) {
            return false
        }
    }

    angular.module('epbxManagerApp')
        .directive('emValidJson', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, element, attrs, ctrl) {

                    if (!ctrl) return;

                    if (!window.ParsleyValidator.validators.validjson) {
                        window.ParsleyValidator.addValidator("validjson", validateJson)
                        window.ParsleyValidator.addMessage("pt-br", "validjson", "JSON inválido")
                    }

                    ctrl.$validators.emValidJson = function (modelValue, viewValue) {
                        return validateJson(viewValue)
                    }

                    $(element).attr("data-parsley-validjson", "")

                    ctrl.$formatters.push(function (value) {
                        if (angular.isObject(value)) {
                            return angular.toJson(value, true)
                        }
                        return value
                    })

                    ctrl.$parsers.push(function (value) {
                        if (!angular.isObject(value)) {
                            try {
                                return angular.fromJson(value)
                            } catch (_) {
                                return value
                            }
                        }
                        return value
                    })
                }
            }
        });
})();
(function () {

    function defaultValidateStep(form) {
        form.$setSubmitted();
        return form.$valid || false;
    }

    function getController(form) {
        return angular.element(form).controller("form")
    }

    function defaultValidateWizard(element) {
        let forms = element.find("form")
        for (var i = 0; i < forms.length; i++) {
            if (!getController(forms[i]).$valid) return false
        }
        return true
    }

    angular.module('epbxManagerApp')
        .directive('emWizard', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {
                    onFinish: "&",
                    onCancel: "&"
                },
                template: '<wizard template="app/shared/templates/wizard.tpl.html" style="overflow: visible" on-cancel="onCancel()" on-finish="validateAndFinish()"><div ng-transclude></div></wizard>',
                link: function ($scope, $element) {

                    $scope.validateAndFinish = function validateAndFinish() {
                        if (defaultValidateWizard($element)) {
                            $scope.onFinish($scope)
                        }
                    }
                }
            };
        })
        .directive('emWzStep', function () {
            return {
                restrict: 'EA',
                replace: true,
                transclude: true,
                scope: {
                    wzTitle: '@',
                    validateExit: '&',
                    disabled: '@?wzDisabled',
                    description: '@',
                    name: '@',
                    wzData: '='
                },
                require: '^wizard',
                templateUrl: function ($element, $attrs) {
                    return $attrs.template || "app/shared/templates/wizard.step.form.tpl.html";
                },
                link: function ($scope, $element, $attrs, wizard) {
                    $scope.title = $scope.wzTitle;
                    $scope.name = $scope.name || "stepForm"

                    if ($attrs.validateExit) {
                        $scope.canexit = function () {
                            return defaultValidateStep(getController($element)) && $scope.validateExit($scope);
                        }
                    } else {
                        $scope.canexit = function () {
                            return defaultValidateStep(getController($element))
                        }
                    }

                    wizard.addStep($scope);
                }
            };
        });
})();
;'use strict';
(function($){"use strict";$.fn.extend({counter:function(options){var defaults={type:"char",count:"down",goal:140,text:true,target:false,append:true,translation:"",msg:"",container_class:""};var $countObj="",countIndex="",noLimit=false,options=$.extend({},defaults,options);var methods={init:function($obj){var objID=$obj.attr("id"),counterID=objID+"_count";methods.isLimitless();$countObj=$("<span id="+counterID+"/>");var counterDiv=$("<div/>").attr("id",objID+"_counter").append($countObj).append(" "+methods.setMsg());if(options.container_class&&options.container_class.length){counterDiv.addClass(options.container_class)}if(!options.target||!$(options.target).length){options.append?counterDiv.insertAfter($obj):counterDiv.insertBefore($obj)}else{options.append?$(options.target).append(counterDiv):$(options.target).prepend(counterDiv)}methods.bind($obj)},bind:function($obj){$obj.bind("keypress.counter keydown.counter keyup.counter blur.counter focus.counter change.counter paste.counter",methods.updateCounter);$obj.bind("keydown.counter",methods.doStopTyping);$obj.trigger("keydown")},isLimitless:function(){if(options.goal==="sky"){options.count="up";noLimit=true;return noLimit}},setMsg:function(){if(options.msg!==""){return options.msg}if(options.text===false){return""}if(noLimit){if(options.msg!==""){return options.msg}else{return""}}this.text=options.translation||"character word left max";this.text=this.text.split(" ");this.chars="s ( )".split(" ");this.msg=null;switch(options.type){case"char":if(options.count===defaults.count&&options.text){this.msg=this.text[0]+this.chars[1]+this.chars[0]+this.chars[2]+" "+this.text[2]}else if(options.count==="up"&&options.text){this.msg=this.text[0]+this.chars[0]+" "+this.chars[1]+options.goal+" "+this.text[3]+this.chars[2]}break;case"word":if(options.count===defaults.count&&options.text){this.msg=this.text[1]+this.chars[1]+this.chars[0]+this.chars[2]+" "+this.text[2]}else if(options.count==="up"&&options.text){this.msg=this.text[1]+this.chars[1]+this.chars[0]+this.chars[2]+" "+this.chars[1]+options.goal+" "+this.text[3]+this.chars[2]}break;default:}return this.msg},getWords:function(val){if(val!==""){return $.trim(val).replace(/\s+/g," ").split(" ").length}else{return 0}},updateCounter:function(e){var $this=$(this);if(countIndex<0||countIndex>options.goal){methods.passedGoal($this)}if(options.type===defaults.type){if(options.count===defaults.count){countIndex=options.goal-$this.val().length;if(countIndex<=0){$countObj.text("0")}else{$countObj.text(countIndex)}}else if(options.count==="up"){countIndex=$this.val().length;$countObj.text(countIndex)}}else if(options.type==="word"){if(options.count===defaults.count){countIndex=methods.getWords($this.val());if(countIndex<=options.goal){countIndex=options.goal-countIndex;$countObj.text(countIndex)}else{$countObj.text("0")}}else if(options.count==="up"){countIndex=methods.getWords($this.val());$countObj.text(countIndex)}}return},doStopTyping:function(e){var keys=[46,8,9,35,36,37,38,39,40,32];if(methods.isGoalReached(e)){if(e.keyCode!==keys[0]&&e.keyCode!==keys[1]&&e.keyCode!==keys[2]&&e.keyCode!==keys[3]&&e.keyCode!==keys[4]&&e.keyCode!==keys[5]&&e.keyCode!==keys[6]&&e.keyCode!==keys[7]&&e.keyCode!==keys[8]){if(options.type===defaults.type){return false}else if(e.keyCode!==keys[9]&&e.keyCode!==keys[1]&&options.type!=defaults.type){return true}else{return false}}}},isGoalReached:function(e,_goal){if(noLimit){return false}if(options.count===defaults.count){_goal=0;return countIndex<=_goal?true:false}else{_goal=options.goal;return countIndex>=_goal?true:false}},wordStrip:function(numOfWords,text){var wordCount=text.replace(/\s+/g," ").split(" ").length;text=$.trim(text);if(numOfWords<=0||numOfWords===wordCount){return text}else{text=$.trim(text).split(" ");text.splice(numOfWords,wordCount,"");return $.trim(text.join(" "))}},passedGoal:function($obj){var userInput=$obj.val();if(options.type==="word"){$obj.val(methods.wordStrip(options.goal,userInput))}if(options.type==="char"){$obj.val(userInput.substring(0,options.goal))}if(options.type==="down"){$countObj.val("0")}if(options.type==="up"){$countObj.val(options.goal)}}};return this.each(function(){methods.init($(this))})}})})(jQuery);

angular
    .module('char-counter', [])
    .directive('charCounter', [
        '$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, elem, attrs) {

                    var $this = $(elem),
                        thisGoal = attrs['maxlength'] ? attrs['maxlength'] : 80;

                    $timeout(function() {
                        $this.counter({
                            container_class: 'text-count-wrapper',
                            msg: ' / '+ thisGoal,
                            goal: thisGoal,
                            count: 'up'
                        });

                        if($this.closest('.md-input-wrapper').length) {
                            $this.closest('.md-input-wrapper').addClass('md-input-wrapper-count')
                        }
                    })

                }
            }
        }
    ]);
(function (root, factory) {
    // AMD
    if (typeof define === 'function' && define.amd) define(['angular'], factory);
    // Global
    else factory(angular);
}(this, function (angular) {

    angular
        .module('ckeditor', [])
        .directive('ckeditor', ['$parse', ckeditorDirective]);

    // Polyfill setImmediate function.
    var setImmediate = window && window.setImmediate ? window.setImmediate : function (fn) {
        setTimeout(fn, 0);
    };

    /**
     * CKEditor directive.
     *
     * @example
     * <div ckeditor="options" ng-model="content" ready="onReady()"></div>
     */

    function ckeditorDirective($parse) {
        return {
            restrict: 'A',
            require: ['ckeditor', 'ngModel'],
            controller: [
                '$scope',
                '$element',
                '$attrs',
                '$parse',
                '$q',
                ckeditorController
            ],
            link: function (scope, element, attrs, ctrls) {
                // get needed controllers
                var controller = ctrls[0]; // our own, see below
                var ngModelController = ctrls[1];

                // Initialize the editor content when it is ready.
                controller.ready().then(function initialize() {
                    // Sync view on specific events.
                    ['dataReady', 'change', 'blur', 'saveSnapshot'].forEach(function (event) {
                        controller.onCKEvent(event, function syncView() {
                            ngModelController.$setViewValue(controller.instance.getData() || '');
                        });
                    });

                    controller.instance.setReadOnly(!! attrs.readonly);
                    attrs.$observe('readonly', function (readonly) {
                        controller.instance.setReadOnly(!! readonly);
                    });

                    // Defer the ready handler calling to ensure that the editor is
                    // completely ready and populated with data.
                    setImmediate(function () {
                        $parse(attrs.ready)(scope);
                    });
                });

                // Set editor data when view data change.
                ngModelController.$render = function syncEditor() {
                    controller.ready().then(function () {
                        controller.instance.setData(ngModelController.$viewValue || '');
                    });
                };
            }
        };
    }

    /**
     * CKEditor controller.
     */

    function ckeditorController($scope, $element, $attrs, $parse, $q) {
        var config = $parse($attrs.ckeditor)($scope) || {};
        var editorElement = $element[0];
        var instance;
        var readyDeferred = $q.defer(); // a deferred to be resolved when the editor is ready

        // Create editor instance.
        if (editorElement.hasAttribute('contenteditable') &&
            editorElement.getAttribute('contenteditable').toLowerCase() == 'true') {
            instance = this.instance = CKEDITOR.inline(editorElement, config);
        }
        else {
            instance = this.instance = CKEDITOR.replace(editorElement, config);
        }

        /**
         * Listen on events of a given type.
         * This make all event asynchronous and wrapped in $scope.$apply.
         *
         * @param {String} event
         * @param {Function} listener
         * @returns {Function} Deregistration function for this listener.
         */

        this.onCKEvent = function (event, listener) {
            instance.on(event, asyncListener);

            function asyncListener() {
                var args = arguments;
                setImmediate(function () {
                    applyListener.apply(null, args);
                });
            }

            function applyListener() {
                var args = arguments;
                $scope.$apply(function () {
                    listener.apply(null, args);
                });
            }

            // Return the deregistration function
            return function $off() {
                instance.removeListener(event, applyListener);
            };
        };

        this.onCKEvent('instanceReady', function() {
            readyDeferred.resolve(true);
        });

        /**
         * Check if the editor if ready.
         *
         * @returns {Promise}
         */
        this.ready = function ready() {
            return readyDeferred.promise;
        };

        // Destroy editor when the scope is destroyed.
        $scope.$on('$destroy', function onDestroy() {
            // do not delete too fast or pending events will throw errors
            readyDeferred.promise.then(function() {
                instance.destroy(false);
            });
        });
    }
}));
(function() {
	'use strict';
	angular
		.module('ngCountup', [])
		.directive('countUp', function() {
			return {
				restrict: 'A',
				require: 'ngModel',
				scope: {
					ngModel: '=',
					prefix: '=',
					suffix: '='
				},
				link: function(scope, element, attrs) {
					var curValue = 0;
					var curPrefix = null;
					var curSuffix = null;
					scope.$parent.$watch(scope.prefix, function(newVal, oldVal) {
						var numDecimals, opts;

						numDecimals = 0;
						if ((attrs.numDecimals != null) && attrs.numDecimals >= 0) {
							numDecimals = attrs.numDecimals;
						}

						curPrefix = newVal;
						opts = {};
						opts.prefix = curPrefix;
						opts.suffix = curSuffix;
						opts.separator = '.';

						return new CountUp(attrs.id, curValue, curValue, numDecimals, 2, opts).start();
					});
					scope.$parent.$watch(scope.suffix, function(newVal, oldVal) {
						var numDecimals, opts;

						numDecimals = 0;
						if ((attrs.numDecimals != null) && attrs.numDecimals >= 0) {
							numDecimals = attrs.numDecimals;
						}

						curSuffix = newVal;
						opts = {};
						opts.prefix = curPrefix;
						opts.suffix = curSuffix;
						opts.separator = '.';

						return new CountUp(attrs.id, curValue, curValue, numDecimals, 2, opts).start();
					});

					return scope.$parent.$watch(attrs.ngModel, function(newVal, oldVal) {
						var numDecimals, opts;
						curValue = newVal;
						if ((newVal != null) && newVal !== oldVal) {
							opts = {};
							curPrefix = scope.prefix;
							curSuffix = scope.suffix;
							opts.prefix = scope.prefix;
							opts.suffix = scope.suffix;
							opts.separator = '.';

							numDecimals = 0;
							if ((attrs.numDecimals != null) && attrs.numDecimals >= 0) {
								numDecimals = attrs.numDecimals;
							}
							if (newVal == null) {
								newVal = 0;
							}
							if (oldVal == null) {
								oldVal = 0;
							}
							return new CountUp(attrs.id, oldVal, newVal, numDecimals, 2, opts).start();
						}
					});
				}
			};
		});

}).call(this);

; 'use strict';
angular
    .module('icheck', [])
    .directive('icheck', ["$timeout", "$parse", function ($timeout, $parse) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function ($scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value;
                    value = $attrs['value'];

                    $scope.$watch($attrs['ngModel'], function (newValue) {
                        $(element).iCheck('update');

                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            $timeout(function () {
                                //set up for radio buttons to be de-selectable
                                if (ngModel.$viewValue != newValue)
                                    return ngModel.$setViewValue(newValue);
                            });
                        }
                    });

                    $scope.$watch($attrs['ngDisabled'], function (newValue) {
                        $(element).iCheck(newValue ? 'disable' : 'enable');
                        $(element).iCheck('update');
                    });

                    return $(element).iCheck({
                        checkboxClass: 'icheckbox_md',
                        radioClass: 'iradio_md',
                        increaseArea: '20%'
                    }).on('ifChanged', function (event) {
                        if (!!$(element).data('parsley-multiple')) {
                            $(element).parsley().validate();
                        }
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function () {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                    }).on('ifClicked', function (event) {
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function () {
                                //set up for radio buttons to be de-selectable
                                if (ngModel.$viewValue != value)
                                    return ngModel.$setViewValue(value);
                                else
                                    ngModel.$setViewValue(null);
                                ngModel.$render();
                            });
                        }
                    });
                });
            }
        };
    }]);
angular
    .module('directive.ionSlider', [])
    .directive('ionSlider', [
        '$document',
        function($document) {
            "use strict";
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: {
                    prettify: '&',
                    min: '=',
                    max: '=',
                    onStart: '&',
                    onChange: '&',
                    onFinish: '&',
                    onUpdate: '&'
                },
                template: '<input type="text" />',
                link: function(scope, element, attrs, ngModel) {

                    var input = element.find('input'),
                        isDouble = attrs.type === 'double';

                    var prettify = undefined;
                    if(attrs.prettify) {
                        prettify = function(value) {
                            return scope.prettify({value: value});
                        }
                    }

                    var onSlideStarted = function () {
                        if (!scope.$eval(attrs.ngDisabled)) {
                            if (scope.onStart) scope.onStart();
                        }
                    }

                    var onSlideChanged = function (value) {
                        if (!scope.$eval(attrs.ngDisabled)) {
                            if (scope.onChange) scope.onChange( { value: value.from } );
                        }
                    }

                    var onSlideUpdated = function (value) {
                        if (!scope.$eval(attrs.ngDisabled)) {
                            if (scope.onUpdate) scope.onUpdate( { value: value.from } );
                        }
                    }

                    var onSlideFinished = function (value) {
                        // atualizamos o model apenas depois de terminar de clicar e arratar o slider
                        ngModel.$setViewValue(isDouble ? { from: input.data("from"), to: input.data("to") } : input.data("from"));
                        if (!scope.$eval(attrs.ngDisabled)) {
                            if (scope.onFinish) scope.onFinish( { value: value.from } );
                        }
                    }

                    input.ionRangeSlider({
                        grid: attrs.grid,
                        hide_min_max: attrs.hide_min_max,
                        values: scope.$eval(attrs.values),
                        min_prefix: attrs.minPrefix,
                        max_prefix: attrs.maxPrefix,
                        min_postfix: attrs.minPostfix,
                        max_postfix: attrs.maxPostfix,
                        min: +scope.min,
                        max: +scope.max,
                        type: attrs.type,
                        prefix: attrs.prefix,
                        from_min: attrs.fromMin,
                        from_max: attrs.fromMax,
                        from_shadow: attrs.fromShadow,
                        to_min: attrs.toMin,
                        to_max: attrs.toMax,
                        to_shadow: attrs.toShadow,
                        grid_num: attrs.gridNum,
                        force_edges: attrs.forceEdges,
                        prettify: prettify,
                        onStart: onSlideStarted,
                        onChange: onSlideChanged,
                        onFinish: onSlideFinished,
                        onUpdate: onSlideUpdated,
                        step: (attrs.step == undefined || attrs.step == 0) ? 1 : attrs.step,
                    });

                    var slider = input.data("ionRangeSlider");

                    ngModel.$render = function() {
                        var options;
                        if(isDouble) {
                            options = ngModel.$viewValue || {};
                        } else {
                            options = {
                                from: ngModel.$viewValue
                            };
                        }
                        slider.update(options);
                    };

                    scope.$watch('min', function (newValue) {
                        slider.update({ min: +newValue });
                    });

                    scope.$watch('max', function (newValue) {
                        slider.update({ max: +newValue });
                    });

                    scope.$watch(attrs.ngDisabled, function (disabled) {
                        slider.update({ disable: disabled });
                    });

                    scope.$on('$destroy', function() {
                        slider.destroy();
                    });
                }
            };
        }
    ]);
"use strict";
angular
    .module('magnificPopup',[])
    .directive('magnificPopup',
    [
        "$compile",
        function($compile) {
            return {
                restrict: 'A',
                scope: {},
                link: function($scope, element, attr) {
                    attr.callbacks = {
                        ajaxContentAdded: function() {
                            var content = this.content;

                            var scope =  content.scope();
                            $compile(content)(scope);
                            scope.$digest();
                        }
                    };
                    element.magnificPopup(attr);
                }
            }
        }
    ]
);
var buildChartDirective = function (chartType) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            data: "=",
            options: "="
        },
        link: function (scope, element, attrs) {

            var options = {};
            if (scope.options) {
                options = scope.options;
            }

            var span = document.createElement('span');
            span.textContent = scope.data.join();

            if (!attrs.class) {
                span.className = "peity";
            } else {
                span.className = attrs.class;
            }

            if (element[0].nodeType === 8) {
                element.replaceWith(span);
            } else {
                element[0].appendChild(span);
            }

            if (options.height) {
                element.height(options.height);
            }

            var chart = jQuery(span) ? jQuery(span).peity(chartType, options) : null;

            return scope.$watch('data', function () {
                return chart
                    .text(scope.data)
                    .change();
            });

        }
    };
};

angular
    .module('angular-peity', [])
    .directive('peityPieChart', function () {
        return buildChartDirective("pie");
    })
    .directive('peityDonutChart', function () {
        return buildChartDirective("donut");
    })

    .directive('peityBarChart', function () {
        return buildChartDirective("bar");
    })
    .directive('peityLineChart', function () {
        return buildChartDirective("line");
    });



/*
* Angular Selectize
* v 1.2.3
* https://github.com/machineboy2045/angular-selectize
*/

/*global $:Selectize */

angular
    .module('selectize', [])
    .value('selectizeConfig', {})
    .directive("selectize", [
        'selectizeConfig',
        function (selectizeConfig) {
            return {
                restrict: 'EA',
                require: '^ngModel',
                scope: {
                    ngModel: '=',
                    config: '=?',
                    options: '=?',
                    ngDisabled: '=',
                    ngRequired: '&'
                },
                link: function (scope, element, attrs, modelCtrl) {
                    if (!Selectize) {
                        throw new Error("Selectize JavaScript library should be loaded before using this angular module.");
                    }

                    Selectize.defaults.maxItems = null; //default to tag editor
                    Selectize.defaults.hideSelected = true;

                    if(attrs.position) {
                        scope.posBottom = attrs.position;
                    }

                    Selectize.defaults.onDropdownOpen = function($dropdown) {
                        $dropdown
                            .hide()
                            .velocity('slideDown', {
                                begin: function() {
                                    if (typeof scope.posBottom !== 'undefined') {
                                        $dropdown.css({'margin-top':'0'})
                                    }
                                },
                                duration: 200,
                                easing: [ 0.4,0,0.2,1 ]
                            })
                    };
                    Selectize.defaults.onDropdownClose = function($dropdown) {
                        $dropdown
                            .show()
                            .velocity('slideUp', {
                                complete: function() {
                                    if (typeof posBottom !== 'undefined') {
                                        $dropdown.css({'margin-top': ''})
                                    }
                                },
                                duration: 200,
                                easing: [ 0.4,0,0.2,1 ]
                            });
                    };

                    var selectize,
                        config = angular.extend({}, Selectize.defaults, selectizeConfig, scope.config);

                    modelCtrl.$isEmpty = function (val) {
                        return (val === undefined || val === null || !val.length); //override to support checking empty arrays
                    };

                    function createItem(input) {
                        var data = {};
                        data[config.labelField] = input;
                        data[config.valueField] = input;
                        return data;
                    }

                    function toggle(disabled) {
                        disabled ? selectize.disable() : selectize.enable();
                    }

                    var validate = function () {
                        var isInvalid = (scope.ngRequired() || attrs.required || config.required) && modelCtrl.$isEmpty(scope.ngModel);
                        modelCtrl.$setValidity('required', !isInvalid);
                    };

                    function generateOptions(data) {
                        if (!data)
                            return [];

                        data = angular.isArray(data) ? data : [data];

                        return $.map(data, function (opt) {
                            return typeof opt === 'string' ? createItem(opt) : opt;
                        });
                    }

                    function updateSelectize() {
                        validate();

                        selectize.$control.toggleClass('ng-valid', modelCtrl.$valid);
                        selectize.$control.toggleClass('ng-invalid', modelCtrl.$invalid);
                        selectize.$control.toggleClass('ng-dirty', modelCtrl.$dirty);
                        selectize.$control.toggleClass('ng-pristine', modelCtrl.$pristine);

                        var value = selectize.items.slice();
                        if (config.maxItems === 1) {
                            value = value[0];
                        }
                        if (!angular.equals(value, scope.ngModel)) {
                            selectize.addOption(generateOptions(scope.ngModel));
                            selectize.setValue(scope.ngModel);
                        }
                    }

                    var onChange = config.onChange,
                        onOptionAdd = config.onOptionAdd;

                    config.onChange = function () {
                        var args = arguments;
                        scope.$evalAsync(function () {
                            var value = selectize.items.slice();
                            if (config.maxItems === 1) {
                                value = value[0];
                            }
                            if (!angular.equals(value, scope.ngModel)) {
                                modelCtrl.$setViewValue(value);
                                if (onChange) {
                                    onChange.apply(this, args);
                                }
                            }
                        });
                    };

                    config.onOptionAdd = function (value, data) {
                        if (scope.options.indexOf(data) === -1)
                            scope.options.push(data);

                        if (onOptionAdd) {
                            onOptionAdd.apply(this, arguments);
                        }
                    };

                    // ngModel (ie selected items) is included in this because if no options are specified, we
                    // need to create the corresponding options for the items to be visible
                    //scope.options = generateOptions((scope.options || config.options || scope.ngModel).slice());

                    scope.generatedOptions = generateOptions( (scope.options || config.options || scope.ngModel).slice() );
                    scope.options.length = 0;
                    scope.generatedOptions.forEach(function (item) {
                        scope.options.push(item);
                    });


                    var angularCallback = config.onInitialize;

                    config.onInitialize = function () {
                        selectize = element[0].selectize;
                        //selectize.addOption(scope.options);
                        selectize.addOption(scope.generatedOptions);
                        selectize.setValue(scope.ngModel);

                        //provides a way to access the selectize element from an
                        //angular controller
                        if (angularCallback) {
                            angularCallback(selectize);
                        }

                        scope.$watch('options', function () {
                            scope.generatedOptions = generateOptions( (scope.options || config.options || scope.ngModel).slice() );
                            scope.options.length = 0;
                            scope.generatedOptions.forEach(function (item) {
                                scope.options.push(item);
                            });
                            selectize.clearOptions();
                            selectize.addOption(scope.generatedOptions);
                            selectize.setValue(scope.ngModel);
                            //selectize.clearOptions();
                            //selectize.addOption(scope.options);
                            //selectize.setValue(scope.ngModel);
                        }, true);

                        scope.$watchCollection('ngModel', updateSelectize);
                        scope.$watch('ngDisabled', toggle);
                    };

                    element.after('<div class="selectize_fix"></div>');

                    element.selectize(config);

                    element.on('$destroy', function () {
                        if (selectize) {
                            selectize.destroy();
                            element = null;
                        }
                    });
                }
            };
        }
    ]);
(function() {
    'use strict';

    angular.module('EmSoundModule', [])
        .service('SoundService', ["$window", function ($window) {

            this.load = function (url, opts) {
                return new buzz.sound(url).load();
            };

            this.play = function (url, opts) {
                return new buzz.sound(url).play();
            };

            return this;
        }]);
})();
'use strict';

/**
 * Module to use Switchery as a directive for angular.
 * @TODO implement Switchery as a service, https://github.com/abpetkov/switchery/pull/11
 */
angular.module('NgSwitchery', [])
   
    .directive('uiSwitch', ['$window', '$timeout', '$log', '$parse', function ($window, $timeout, $log, $parse) {

        /**
         * Initializes the HTML element as a Switchery switch.
         *
         * $timeout is in place as a workaround to work within angular-ui tabs.
         *
         * @param scope
         * @param elem
         * @param attrs
         * @param ngModel
         */

        function hex2rgba(hex, opacity) {
            hex = hex.replace('#', '');
            var r = parseInt(hex.substring(0, 2), 16),
                g = parseInt(hex.substring(2, 4), 16),
                b = parseInt(hex.substring(4, 6), 16);

            return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
        }

        function linkSwitchery(scope, elem, attrs, ngModel) {
            if (!ngModel) return false;

            var options = {
                color: attrs.color ? hex2rgba(attrs.color, 50) : hex2rgba('#009688', 50),
                jackColor: attrs.color ? hex2rgba(attrs.color, 100) : hex2rgba('#009688', 100),
                secondaryColor: attrs.secondaryColor ? hex2rgba(attrs.secondaryColor, 50) : 'rgba(0, 0, 0,0.26)',
                jackSecondaryColor: attrs.secondaryColor ? hex2rgba(attrs.secondaryColor, 100) : '#fafafa',
                className: attrs.class
            };

            var switcher;
            var previousDisabledValue = attrs.disabled;
            // Watch for attribute changes to recreate the switch if the 'disabled' attribute changes
            attrs.$observe('disabled', function (value) {
                if (value == undefined || value == previousDisabledValue) {
                    return;
                } else {
                    previousDisabledValue = value;
                }
                options.disabled = previousDisabledValue;
                initializeSwitch();
            });

            scope.$watch(function () {
                return ngModel.$modelValue;
            }, function (newValue) {
                if (newValue === true || newValue === false) {
                    initializeSwitch();
                }
            });

            function initializeSwitch() {
                $timeout(function () {
                    // Remove any old switcher
                    if (switcher) {
                        angular.element(switcher.switcher).remove();
                    }
                    // (re)create switcher to reflect latest state of the checkbox element
                    switcher = new $window.Switchery(elem[0], options);
                    if(!previousDisabledValue && options.disabled == true){
                        switcher.enable();
                    }
                    // else{
                    //     switcher.disable();
                    // }
                    var element = switcher.element;
                    element.checked = scope.initValue;
                    switcher.setPosition(false);
                    element.addEventListener('change', function (evt) {
                        scope.$apply(function () {
                            ngModel.$setViewValue(element.checked);
                        })
                    })
                }, 0);
            }
            initializeSwitch();
        }

        return {
            require: 'ngModel',
            restrict: 'AE',
            scope: {
                initValue: '=ngModel'
            },
            link: linkSwitchery
        }
    }]);
(function () {
    "use strict";

    /***
        Serviço que altera o request de templates para incluir o numero da versao 
        da aplicação, afim de evitar cache de arquivos desatualizados
    */

    angular.module("epbxManagerApp")
        .config(["$httpProvider", function ($httpProvider) {
            $httpProvider.interceptors.push(["$q", "Config", function ($q, Config) {
                return {
                    request: function requestInterceptor(request) {
                        var version = Config.getVersion();
                        if (version && request.method === 'GET' && request.url.indexOf("app/") > -1) {
                            var suffix = request.url.indexOf('?') === -1 ? '?' : '&';
                            request.url = request.url + suffix + 'v=' + version;
                        }

                        return request;
                    }
                }
            }]);
        }])
})();

(function () {
    "use strict";

    //Serviço que altera requests ajax com erros 401, tenta revalidar o token de acesso e reenviar a requisição

    angular.module("epbxManagerApp")
        .config(["$httpProvider", function ($httpProvider) {
            $httpProvider.interceptors.push(["$q", "$injector", function ($q, $injector) {
                var doLogin = function (originalRequest) {
                    var authService = $injector.get("AuthService");
                    return authService.updateRefreshToken().then(function (tokenData) {
                        // refresh token realizado com sucesso, alterar o token da requisição original e reenviar
                        originalRequest.headers.Authorization = "Bearer " + tokenData.access_token;
                        return $injector.get("$http")(originalRequest);
                    }).catch(function (error) {
                        // se não foi possível refazer a requisição com um novo token, redirecionar para a tela de login
                        $injector.get("$state").go("login");
                        // eslint-disable-next-line no-console
                        console.log(error);
                    });
                }

                return {
                    request: function (config) {
                        return config;
                    },
                    response: function (response) {
                        return response;
                    },
                    responseError: function responseErrorInterceptor(response) {
                        var data, exception, message, $interpolate;
                        var testSpecialUrl = /(\/oauth2\/|\/LogSistema(?!\/))/i;
                        // se ocorrer erro de não autorizado, tenta refazer a requisição com um novo token
                        // (mas apenas em rotas não especiais (ex: logs, refresh token, etc))
                        if (response.status === 401) {
                            if (!testSpecialUrl.test(response.config.url) || response.config.method !== "POST") {
                                return doLogin(response.config);
                            }
                        }
                        if (response.config.url.indexOf('/assets') == 0 || response.config.url.indexOf('/translation') >= 0) {
                            return $q.resolve(response);
                        }

                        $interpolate = $injector.get("$interpolate");
                        data = {};
                        data.Message = (response.data || {}).Message || (response.data || {}).error_description || response.statusText;
                        data.Status = response.status;
                        data.Url = response.config.url;
                        data.Method = response.config.method;

                        message = $interpolate("{{Message}} ({{Method}} {{Status}}- {{Url}})\n{{MessageDetail}}")(data);

                        exception = new Error(message);
                        exception.config = response.config;
                        // eslint-disable-next-line no-console
                        console.error(exception);

                        return $q.reject(response);
                    }
                }
            }]);
        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .provider('StateResolver', ["$injector", function ($injector) {

            this.$get = function () {
                return this;
            };

            this.resolveData = function (page, action, controllerName) {
                const languageDependencyResolver = ["$translatePartialLoader", "$translate",
                    function ($translatePartialLoader, $translate) {
                        const part = page + action;
                        const urlTemplate = '/app/pages/' + page + '/translation/{lang}/' + action + '.json';
                        $translatePartialLoader.addPart(part, 1, urlTemplate);
                        return $translate.refresh();
                    }];
                // descobrir se o controller possui um Data Service associado:
                var dataServiceName = (controllerName || page + action + "Controller").replace(/Controller$/, 'Data');
                if ($injector.has(dataServiceName)) {
                    var dataService = $injector.get(dataServiceName + 'Provider').$get();
                    let dataServiceObject = dataService();
                    dataServiceObject.languageDeps = languageDependencyResolver;
                    return dataServiceObject;
                }

                return { languageDeps: languageDependencyResolver };
            };

            this.resolveDataByControllerName = (controllerName) => this.resolveData(null, null, controllerName);

            this.configAbstract = function (url, template, data) {
                return {
                    url: url || "",
                    template: template || '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: data
                };
            }

            this.configAbstractInnerPage = function (data, resolve, url, template) {
                return {
                    url: url || "",
                    template: template || '<div id="page_content"><breadcrumbs></breadcrumbs><div id="page_content_inner"><ui-view autoscroll="true"/></div></div>',
                    abstract: true,
                    data: data
                };
            }

            this.configState = function (url, model, actionType, data, lazyLoadDeps, others) {
                others = others || {};
                var dependencies = this.resolveData(model, actionType) || {};
                data = data || {};
                if (lazyLoadDeps) {
                    angular.merge(dependencies, lazyLoadDeps);
                }

                if (url.indexOf('?') >= 0) {
                    url += '&{search:json}';
                } else {
                    url += '?{search:json}';
                }

                if (data.css) {
                    if (data.cssFiles == null) {
                        data.css = data.cssPath || ('app/pages/' + (data.path || model) + '/style/' + (data.cssFile || actionType) + '.css');
                    } else {
                        data.css = data.cssFiles;
                    }
                }

                return angular.merge({}, {
                    url: url,
                    templateUrl: 'app/pages/' + (data.path || model) + '/' + (data.view || actionType) + '.html',
                    controller: model + actionType + 'Controller',
                    resolve: dependencies,
                    data: data,
                    params: data != null ? data.params : null
                }, others);
            }
        }]);
})();
(function () {
    "use strict";

    /***
        Serviço que altera o request de templates de diretivas que aceita uma Promise além da url do template, 
        permitindo que diretivas usem o module ocLazyLoad para carregar dependencias de forma assincrona.
        Se for passado apenas a string com a url do template, continua para a implementação padrão, sem modificações

        ex:

            angular.module('epbxManagerApp')
                .directive('emMinhaDiretiva', function ($ocLazyLoad) {
                    return {
                        restrict: 'AE',
                        templateUrl: function (element, attrs) {
                            return { 
                                url: "app/directives/templates/emMinhaDiretiva.html",
                                resolve: $ocLazyLoad.load(['lazy_ionRangeSlider'])
                            };
                        }...
    */

angular.module('epbxManagerApp')
    .config(["$provide", function ($provide) {
        // 
        $provide.decorator('$templateRequest', ["$delegate", "$injector", function ($delegate, $injector) {
            return function templateRequestHandler(tpl, ignoreRequestError) {
                if (angular.isObject(tpl) && angular.isDefined(tpl.url) && angular.isDefined(tpl.resolve)) {
                    return tpl.resolve.then(function () {
                        return $delegate(tpl.url, ignoreRequestError);
                    });
                    // TODO: fazer com que as duas promises executem em paralelo
                    // var $q = $injector.get('$q');
                    // return $q.all($delegate(tpl.url, ignoreRequestError), $q.resolve(tpl.resolve));
                }

                // continua para a implementação padrão
                return $delegate(tpl, ignoreRequestError);
            };
        }]);
    }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ConfiguracaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Configuracao/:ConfiguracaoId", {
                "ConfiguracaoId": "@ConfiguracaoId"
            },
                {
                    atualizatLote: {
                        url: "Configuracao/AtualizarLote",
                        method: "PUT"
                    },
                    getI18N: {
                        url: "Configuracao/i18n",
                        method: "GET",
                        isArray: false
                    },
                    getDownloadUrl: {
                        url: "Configuracao/Download",
                        method: "GET",
                        isArray: false
                    },
                    getBuffer: {
                        url: "Configuracao/Buffer",
                        method: 'GET',
                        isArray: false
                    },
                    getSoftphone: {
                        url: "Configuracao/Softphone",
                        method: 'GET',
                        isArray: false
                    },
                    getConfiguracaoMaxFiltroBilhete: {
                        url: "Configuracao/MaxFiltroBilhete",
                        method: 'GET',
                        isArray: false
                    },
                    getBaseHistorico: {
                        url: "Configuracao/GetBaseHistorico",
                        method: 'GET',
                        isArray: false
                    },
                    getUraTranscription: {
                        url: "Configuracao/GetUraTranscription",
                        method: 'GET',
                        isArray: false
                    },
                    getConfiguracaoTarefa: {
                        method: "GET",
                        url: "Configuracao/ConfiguracaoTarefa"
                    }
                }
            );
        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("SessaoUsuarioResource", ["$odataresource", function ($odataresource) {
            return $odataresource("SessaoUsuario", {},
                {
                    getIp: {
                        url: "SessaoUsuario/Ip",
                        method: "GET",
                        isArray: false
                    }
                });
        }]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("SistemaMenuResource", ["$odataresource", function ($odataresource) {
            return $odataresource("SistemaMenu/:SistemaMenuId", { "SistemaMenuId": "@SistemaMenuId" },
            {
                GetMenus: {
                    url: "SistemaMenu/GetMenus",
                    method: "GET",
                    isArray: true
                }
            });
            
        }]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("SmsCampanhaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("SmsCampanha/:SmsCampanhaId", {
                "SmsCampanhaId": "@SmsCampanhaId"
            }, {
                    GetAtivas: {
                        url: "SmsCampanha/GetAtivas",
                        method: "GET",
                        isArray: true
                    },
                    GetCampanhasTalkSms: {
                        url: "SmsCampanha/GetCampanhasTalkSms",
                        method: "GET",
                        isArray: true
                    },
                    Reativar: {
                        method: "PUT",
                        url: "SmsCampanha/:SmsCampanhaId/Ativar"
                    },
                    Inativar: {
                        method: "PUT",
                        url: "SmsCampanha/:SmsCampanhaId/Inativar"
                    },
                    GetSmsCampanhaDetalhe: {
                        method: "GET",
                        url: "SmsCampanha/GetSmsCampanhaDetalhe"
                    },
                    EnvioTeste: {
                        method: "POST",
                        url: "SmsCampanha/EnvioTeste"
                    },
                });
        }])
})();
(function (window) {
    "use strict";

    angular.module('epbxManagerApp')

        .provider('Config', ["appversion", function (appversion) {

            var isDebug = function isDebug() {
                return window.location.href.indexOf("//localhost") > -1 || window.location.href.toLowerCase().indexOf("debug=1") > -1;
            };

            var baseUrl = _.memoize(function () {
                var location = window.location;
                if (window.location.href.indexOf("//localhost") > -1) {
                    return location.protocol + "//localhost:62745/";
                } else {
                    return location.origin + "/Service/";
                }
            });

            this.getUrlReport = function () {
                var location = window.location;
                if (window.location.href.indexOf("//localhost") > -1) {
                    return location.protocol + "//localhost:62745/";
                } else {
                    return location.origin + "/Reports/";
                }
            };

            this.$get = function () {
                return this;
            };

            this.oauthClientId = "abc";

            this.getVersion = function getVersion() {
                return appversion;
            }

            this.getUrlService = function (path) {
                return baseUrl() + (path || "");
            }

            this.getUrl = function (path) {
                return baseUrl() + "api/" + (path || "");
            }

            this.getUrlToken = function (path) {
                return baseUrl() + "oauth2/Token" + (path || "");
            }

            this.getUrlSignalR = function (path) {
                return baseUrl() + "signalr/" + (path || "");
            }

            this.getWebApiScript = function (path) {
                return baseUrl() + "scripts/" + (path || "");
            }

            this.getUrlSwagger = function (path) {
                return baseUrl() + "swagger/" + (path || "");
            }

            this.isDebug = isDebug;
        }])

        .factory('BreadCrumbService', ['$window', '$state', '$stateParams', function ($window, $state, $stateParams) {
            var service = {};
            service.breadcrumbs = [];

            service.empty = function () {
                service.breadcrumbs.splice(0, service.breadcrumbs.length);
            }

            service.addItem = function (state, params) {

                var breadCumb = _.findWhere(service.breadcrumbs, {
                    route: params != '{}' ? state.name + '(' + params + ')' : state.name
                });

                if (!breadCumb) {
                    service.breadcrumbs.push({
                        pageName: state.data.pageName,
                        route: params != '{}' ? state.name + '(' + params + ')' : state.name
                    });
                }

            };

            var addItemParent = function (state) {
                var breadCumb = _.findWhere(service.breadcrumbs, {
                    route: state.data.proxy
                });
                if (!breadCumb) {
                    service.breadcrumbs.push({
                        pageName: state.data.pageName,
                        route: state.data.proxy
                    });
                }
            };

            service.setTitle = function (title) {
                service.pageTitle = title;
            };

            service.add = function (to, from) {

                var currentState, parentState, checkExist = null;
                if (!from.name || to.name.indexOf("list") > -1) {

                    service.breadcrumbs = [];
                    service.pageTitle = "";

                    currentState = $state.$current;
                    parentState = currentState.parent;
                    if (parentState != null && parentState.data != null && parentState.data.proxy != null) {
                        checkExist = _.find(service.breadcrumbs, function (el) {
                            return el.route.substring(0, el.route.indexOf('(')) == parentState.data.proxy;
                        });
                    }

                    if (parentState.data && currentState.name != parentState.data.proxy && checkExist == null) {
                        addItemParent(parentState);
                    }

                    service.addItem(currentState, JSON.stringify($stateParams));
                    service.setTitle(currentState.data.pageTitle);

                } else {

                    if ($stateParams.page)
                        service.addItem(to);
                    else if (from.name.indexOf("list") > -1) {

                        currentState = $state.$current;
                        parentState = currentState.parent;
                        if (parentState != null && parentState.data != null && parentState.data.proxy != null) {
                            checkExist = _.find(service.breadcrumbs, function (el) {
                                return el.route.substring(0, el.route.indexOf('(')) == parentState.data.proxy;
                            });
                        }

                        if (parentState.data && currentState.name != parentState.data.proxy && checkExist == null) {
                            addItemParent(parentState);
                        }

                        service.addItem(currentState, JSON.stringify($stateParams));
                    } else {

                        service.breadcrumbs = _.without(service.breadcrumbs, _.findWhere(service.breadcrumbs, {
                            route: from.name
                        }));
                    }

                    service.setTitle(to.data.pageTitle);
                }
            };

            service.delete = function (routeName) {

                var breadcrumbs = [];

                angular.forEach(service.breadcrumbs, function (item, index) {
                    if (item.route == routeName) {
                        var currentIndex = index;

                        while (currentIndex < service.breadcrumbs.length - 1) {
                            currentIndex++;
                            breadcrumbs.push(service.breadcrumbs[currentIndex]);
                        }
                    }
                });

                angular.forEach(breadcrumbs, function (item) {
                    service.breadcrumbs = _.without(service.breadcrumbs, _.findWhere(service.breadcrumbs, {
                        route: item.route
                    }));
                });
            };

            service.back = function () {

                window.history.go(-1);

                //var item = service.breadcrumbs[service.breadcrumbs.length - 2];
                //if (item) {

                //    service.delete(item.route);

                //    if (item.route.indexOf('storage') >= 0) {
                //        item.route = item.route.substring(0, item.route.indexOf('({"storage'));
                //    }
                //    $state.go(item.route, {
                //        storage: true
                //    });

                //} else {
                //    window.history.go(-1);
                //}

            };


            return service;
        }])

        .config(["$provide", function ($provide) {

            $provide.decorator('$odataProvider', ["$delegate", "$injector", function ($delegate, $injector) {
                $delegate.prototype.page = function odataPage(pageSize, page) {
                    this.pageSize = pageSize;
                    this.page = page;
                    return this;
                }

                var originalExecute = $delegate.prototype.execute;
                $delegate.prototype.execute = function executeOdataCustom() {
                    var queryString = originalExecute.call(this);
                    if (this.pageSize) {
                        if (queryString !== "") queryString += "&"; {
                            queryString += "$pagesize=" + this.pageSize + "&$page=" + (this.page || 1);
                        }
                    }
                    return queryString;
                }

                $delegate.prototype.between = function (fieldName, start, end) {
                    if (start)
                        this.filter(fieldName, '>=', start);

                    if (end)
                        this.filter(fieldName, '<=', end);

                    return this;
                }

                $delegate.prototype.whereIn = function (collection, fieldName, value, compareTo) {
                    var $odata, predicate;

                    if (compareTo === undefined) compareTo = true;

                    // criar função odata e predicate
                    $odata = $injector.get('$odata');

                    predicate = new $odata.Predicate("x:x/" + fieldName, value).execute(false, true);

                    return this.filter(new $odata.Func(collection + "/any", new $odata.Property(predicate)), compareTo);
                }

                /**
                 * Quando só for informado 2 argumentos, o where usa a função de igualdade. 
                 * Caso contrário usa a função do argumento functionName
                 *
                 * functionName => valores válidos são:
                 *   substringof
                 *   endswith
                 *   startswith
                 */
                $delegate.prototype.where = function (fieldName, functionName, value, compareTo) {
                    var $odata;

                    // comportamento normal, igual a funcao filter
                    if (arguments.length === 2) {
                        return this.filter.apply(this, arguments);
                    }

                    // criar função odata
                    $odata = $injector.get('$odata');

                    if (compareTo === undefined) compareTo = true;

                    return this.filter(new $odata.Func(functionName, fieldName, value), compareTo);
                }

                var originalQuery = $delegate.prototype.query;
                $delegate.prototype.query = function (data, success, error) {
                    var $q = $injector.get('$q');
                    var result = originalQuery.call(this, data, success, error);
                    var deferred = $q.defer();

                    result.$promise.then(function (data) {
                        if (data.Results != null) {
                            data.Results.$pageCount = data.PageCount;
                            data.Results.$currentPage = data.CurrentPage;
                            data.Results.$recordCount = data.RecordCount;
                            data.Results.$pageSize = data.PageSize;
                            deferred.resolve(data.Results);
                            return data.Results;
                        }
                        deferred.resolve(data);
                        return data;

                    }).catch(deferred.reject);

                    return deferred.promise;
                };

                return $delegate;
            }]);

            var configureResource = function ($delegate, $injector) {
                return function resource(url, paramDefaults, actions, options) {

                    var Config = $injector.get('Config');

                    actions = actions || {};
                    options = angular.extend({}, {
                        isodatav4: true
                    }, options || {});

                    // fazer append do endereco do webservice, se não estiver setado
                    if (url && url.indexOf('http') !== 0) {
                        url = Config.getUrl(url);
                    }

                    // se a url foi definida nos actions, também fazer append do endereco do webservice
                    angular.forEach(actions, function (value) {
                        if (value.url && value.url.indexOf('http') !== 0) {
                            value.url = Config.getUrl(value.url);
                        }
                    });

                    // criar metodo update se não foi definido
                    if (!actions.update) {
                        actions.update = {
                            method: 'PUT'
                        };
                    }

                    // criar metodo de paginação
                    actions.odata = {
                        method: 'GET',
                        isArray: false,
                        transformResponse: function (data) {
                            var response = angular.fromJson(data);
                            if (angular.isArray(response)) {
                                return {
                                    Results: response
                                };
                            }
                            return response;
                        }
                    };

                    return $delegate.call(this, url, paramDefaults, actions, options);
                };
            }
            configureResource.$inject = ["$delegate", "$injector"];
            $provide.decorator('$resource', configureResource);
            $provide.decorator('$odataresource', configureResource);

            // $exceptionHandler decorator: REMOVIDO o envio a LogSistemaResource.
            // Motivo: cada excecao JS gerava um POST a API, o que vira flood/loop
            // em cenarios onde o proprio handler do erro recursa (digest cycle
            // quebrado, setInterval com erro recorrente etc) — capaz de derrubar
            // o backend. Mantemos so o delegate padrao do Angular, que ja faz
            // console.error no DevTools. Para reinstrumentar o log no servidor,
            // adicionar throttle/dedup antes do .save() — nunca enviar direto.
            $provide.decorator('$exceptionHandler', ['$delegate', function ($delegate) {
                return function exceptionHandler(exception, cause) {
                    return $delegate(exception, cause);
                };
            }]);
        }])

        .factory('windowDimensions',
            ["$window", function ($window) {
                return {
                    height: function () {
                        return $window.innerHeight || $window.document.documentElement.clientHeight || $window.document.body.clientHeight;
                    },
                    width: function () {
                        return $window.innerWidth || $window.document.documentElement.clientWidth || $window.document.body.clientWidth;
                    }
                }
            }]
        )

        .factory('utils', ["$window", function ($window) {
            return {
                // Util for finding an object by its 'id' property among an array
                findByItemId: function findById(a, id) {
                    for (var i = 0; i < a.length; i++) {
                        if (a[i].item_id == id) return a[i];
                    }
                    return null;
                },
                // serialize form
                serializeObject: function (form) {
                    var o = {};
                    var a = form.serializeArray();
                    $.each(a, function () {
                        if (o[this.name] !== undefined) {
                            if (!o[this.name].push) {
                                o[this.name] = [o[this.name]];
                            }
                            o[this.name].push(this.value || '');
                        } else {
                            o[this.name] = this.value || '';
                        }
                    });
                    return o;
                },
                // high density test
                isHighDensity: function () {
                    return (($window.matchMedia && ($window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || $window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || ($window.devicePixelRatio && $window.devicePixelRatio > 1.3));
                },
                // touch device test
                isTouchDevice: function () {
                    return !!('ontouchstart' in $window);
                },
                // local storage test
                lsTest: function () {
                    var test = 'test';
                    try {
                        $window.localStorage.setItem(test, test);
                        $window.localStorage.removeItem(test);
                        return true;
                    } catch (e) {
                        return false;
                    }
                },
                // show/hide card
                card_show_hide: function (card, begin_callback, complete_callback, callback_element) {
                    $(card).velocity({
                        scale: 0,
                        opacity: 0.2
                    }, {
                            duration: 400,
                            easing: [0.4, 0, 0.2, 1],
                            // on begin callback
                            begin: function () {
                                if (typeof begin_callback !== 'undefined') {
                                    begin_callback(callback_element);
                                }
                            },
                            // on complete callback
                            complete: function () {
                                if (typeof complete_callback !== 'undefined') {
                                    complete_callback(callback_element);
                                }
                            }
                        })
                        .velocity('reverse');
                },

                /*
				Limpa os filtros de uma página.
				searchFilters (object): Objeto com filtros da página
				shouldBeInt (string[]): Diz as variáveis do filtro que deveriam ser inteiros e não strings
			*/
                resetFilters: function resetFilters(searchFilters, shouldBeInt) {
                    for (var prop in searchFilters) {
                        if (searchFilters[prop] === null || searchFilters[prop] === undefined || searchFilters[prop] === '') {
                            delete searchFilters[prop];
                        } else {
                            //Verifica se propriedade é uma string que deveria ser convertida em inteiro
                            if (shouldBeInt && shouldBeInt.indexOf(prop) >= 0) {
                                var isnum = /^\d+$/.test(searchFilters[prop]);
                                if (isnum) {
                                    searchFilters[prop] = parseInt(searchFilters[prop]);
                                }
                            }
                        }
                    }

                    return searchFilters;
                },
                stringFormat: function resetFilters() {
                    var s = arguments[0];
                    for (var i = 0; i < arguments.length - 1; i++) {
                        var reg = new RegExp("\\{" + i + "\\}", "gm");
                        s = s.replace(reg, arguments[i + 1]);
                    }
                    return s;
                }
            };
        }]);

    angular.module("ConsoleLogger", [])
        // router.ui debug
        // app.js (run section "PrintToConsole")

        .factory("PrintToConsole",
            ["$rootScope", "$state", "$stateParams", function ($rootScope, $state, $stateParams) {
                function log(text, fn, fontColor, level) {
                    fn = fn || console.debug;
                    fontColor = fontColor || '#2A7B96';
                    level = level || "INFO";
                    if (typeof text !== 'object')
                        text = "[" + level + "] " + text;
                    if (handler.active) {
                        if (fontColor && typeof text !== 'object') {
                            //fn('%c' + (log.caller ? log.caller.toString() + ' - ' : '') + text, 'color:' + fontColor);
                            fn('%c' + text, 'color:' + fontColor);
                        } else {
                            fn(text);
                        }
                    }
                }

                var handler = {
                    active: false,
                    log: log,
                    debug: function (text) {
                        log(text, console.debug, undefined, "DEBUG");
                    },
                    error: function (text) {
                        console.error(text);
                    }
                };

                handler.toggle = function () {
                    handler.active = !handler.active;
                };

                if (handler.active) {
                    console.debug($state + ' = ' + $state.current.name);
                    console.debug($stateParams + '=' + $stateParams);
                }

                $rootScope.$on('$stateChangeStart', function () {
                    if (handler.active) {
                        console.debug("$stateChangeStart --- event, toState, toParams, fromState, fromParams");
                        console.debug(arguments);
                    }
                });
                $rootScope.$on('$stateChangeError', function () {
                    if (handler.active) {
                        console.debug("$stateChangeError --- event, toState, toParams, fromState, fromParams, error");
                        console.debug(arguments);
                    }
                });
                $rootScope.$on('$stateChangeSuccess', function () {
                    if (handler.active) {
                        console.debug("$stateChangeSuccess --- event, toState, toParams, fromState, fromParams");
                        console.debug(arguments);
                    }
                });
                $rootScope.$on('$viewContentLoaded', function () {
                    if (handler.active) {
                        console.debug("$viewContentLoaded --- event");
                        console.debug(arguments);
                    }

                    angular.element('html').removeClass('uk-modal-page');

                });
                $rootScope.$on('$stateNotFound', function () {
                    if (handler.active) {
                        console.debug("$stateNotFound --- event, unfoundState, fromState, fromParams");
                        console.debug(arguments);
                    }
                });
                return handler;
            }]
        );
})(window);
(function() {
  "use strict";

  angular.module('epbxManagerApp')
    .service('detectBrowser', [
      '$window',
      function($window) {
        // http://stackoverflow.com/questions/22947535/how-to-detect-browser-using-angular
        return function() {
          var userAgent = $window.navigator.userAgent,
            browsers = {
              chrome: /chrome/i,
              safari: /safari/i,
              firefox: /firefox/i,
              ie: /internet explorer/i
            };

          for (var key in browsers) {
            if (browsers[key].test(userAgent)) {
              return key;
            }
          }
          return 'unknown';
        }
      }
    ])
    .service('preloaders', [
      '$rootScope',
      '$timeout',
      'utils',
      function($rootScope, $timeout, utils) {
        $rootScope.content_preloader_show = function(style, container) {
          var $body = $('#page_content');
          if (!$body.find('.content-preloader').length) {
            var image_density = utils.isHighDensity() ? '@2x' : '';

            var preloader_content = (typeof style !== 'undefined' && style == 'regular') ? '<img src="assets/img/spinners/spinner' + image_density + '.gif" alt="" width="32" height="32">' : '<div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="32" width="32" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg></div>';

            var thisContainer = (typeof container !== 'undefined') ? container : $body;

            thisContainer.append('<div class="content-preloader">' + preloader_content + '</div>');
            $timeout(function() {
              $('.content-preloader').addClass('preloader-active');
            });
          }
        };
        $rootScope.content_preloader_hide = function() {
          var $body = $('#page_content');
          if ($body.find('.content-preloader').length) {
            // hide preloader
            $('.content-preloader').removeClass('preloader-active');
            // remove preloader
            $timeout(function() {
              $('.content-preloader').remove();
            }, 500);
          }
        };

      }
    ]);
})();


(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .constant('ATENDIMENTO_EVENTS', {
            onLogado: "onLogado",
            onLogadoErro: "onLogadoErro",
            onConexaoErro: "onConexaoErro",
            onDeslogado: "onDeslogado",
            onDisca: "onDisca",
            onDiscaStatus: "onDiscaStatus",
            onDiscaErro: "onDiscaErro",
            onChamada: "onChamada",
            onChamadaLigacaoId: "onChamadaLigacaoId",
            onChamadaPerdida: "onChamadaPerdida",
            onAtendido: "onAtendido",
            onAtendidoDiscador: "onAtendidoDiscador",
            onDesliga: "onDesliga",
            onChamadaTransferida: "onChamadaTransferida",
            onChamadaEntrouNaFila: "onChamadaEntrouNaFila",
            onChamadaSaiuDaFila: "onChamadaSaiuDaFila",
            onInfoIntervaloRamal: "onInfoIntervaloRamal",
            onInfoIntervaloRamalErro: "onInfoIntervaloRamalErro",
            onInfoCliente: "onInfoCliente",
            onParametrosRamal: "onParametrosRamal",
            onRecebendoMensagem: "onRecebendoMensagem",
            onChamadaGlobalId: "onChamadaGlobalId",
            onChamadaDesligouNaEspera: "onChamadaDesligouNaEspera",
            onRingSip: "onRingSip",
            onDiscaStatusInterno: "onDiscaStatusInterno",

            // SigaMe
            onNumerosSigaMeMultiplo: "onNumerosSigaMeMultiplo",

            // intervalos
            onInicioIntervalo: "onInicioIntervalo",
            onTerminoIntervalo: "onTerminoIntervalo",
            onInicioNaoDisponivel: "onInicioNaoDisponivel",
            onTerminoNaoDisponivel: "onTerminoNaoDisponivel",
            onInicioEspera: "onInicioEspera",
            onTerminoEspera: "onTerminoEspera",

            // conferencia
            onEntrouEmConferencia: "onEntrouEmConferencia",
            onConferenciaInicio: "onConferenciaInicio",
            onConferenciaTermino: "onConferenciaTermino",
            Conferencia_OnDisca: "Conferencia_OnDisca",
            onConferenciaDiscaErro: "onConferenciaDiscaErro",
            Conferencia_OnAtendido: "Conferencia_OnAtendido",
            onConferenciaChamadaEncerrada: "onConferenciaChamadaEncerrada",
            onConferenciaErro: "onConferenciaErro",
            onSetIntervaloRamal: "onSetIntervaloRamal",
            onAlterarIntervaloTipoErro: "onAlterarIntervaloTipoErro"
        })

        .service('AtendimentoService', ["$rootScope", "$q", "$timeout", "SignalrConnection", "Config", "ATENDIMENTO_EVENTS", "PrintToConsole", function ($rootScope, $q, $timeout, SignalrConnection, Config, ATENDIMENTO_EVENTS, PrintToConsole) {
            var service = {},
                atendimentoProxy, initExecuted = false;

            var raiseEvent = function (eventName) {
                var eventNameArray = [eventName];
                return function (ramal) {
                    var args = arguments; // arguments recebidos do AtendimentoHub
                    service.intervaloAtivo = ramal.IntervaloAtivo;
                    service.sigaMeAtivo = ramal.SigaMeAtivo;
                    $timeout(function () {
                        PrintToConsole.debug("evento telefonia: " + eventNameArray[0]);
                        PrintToConsole.debug(args);
                        var argsArray = [eventName];
                        angular.forEach(args, function (value) {
                            argsArray.push(value);
                        });
                        $rootScope.$broadcast.apply($rootScope, argsArray);
                    })
                };
            }

            var raiseChamadaEvent = function (eventName) {
                var raiseEventFunction = raiseEvent(eventName);
                PrintToConsole.debug("Evento Chamada: " + eventName);
                return function (ramal, chamada) {
                    service.chamadaAtiva = chamada;
                    raiseEventFunction.apply(service, arguments);
                };
            }

            var raiseEventLogado = function (eventName) {
                var raiseEventFunction = raiseEvent(eventName);
                PrintToConsole.debug("Evento Logado: " + eventName);
                return function () {
                    service.ramalLogado = true;
                    raiseEventFunction.apply(service, arguments);
                };
            }

            var raiseEventLogadoErro = function (eventName) {
                var raiseEventFunction = raiseEvent(eventName);
                PrintToConsole.debug("Evento Logado Erro: " + eventName);
                return function () {
                    if (service.deveConectar == true) {
                        // agendar reconexão em 10 segundos
                        $timeout.apply(this, [service.iniciar, 10000, false].concat(service.loginOpts));
                    }
                    service.ramalLogado = false;
                    service.chamadaAtiva = null;
                    raiseEventFunction.apply(service, arguments);
                };
            }

            var raiseRemoveChamadaEvent = function (eventName) {
                var raiseEventFunction = raiseEvent(eventName);
                return function () {
                    service.chamadaAtiva = null;
                    raiseEventFunction.apply(service, arguments);
                };
            }

            var callHubMethod = function (hubMethod) {
                return function () {
                    var deferred = $q.defer(),
                        args = arguments;
                    var methodCall = function () {
                        atendimentoProxy.server[hubMethod]
                            .apply(atendimentoProxy.server, args)
                            .done(deferred.resolve)
                            .fail(deferred.reject);
                        return deferred.promise;
                    }

                    // antes de chamar um metodo no hub, é necessário conectar no signalr
                    if (SignalrConnection.connected) {
                        if (!initExecuted) service.init();
                        return methodCall();
                    }

                    return service.start().then(methodCall);
                }
            }

            // disponibilizar todas as funcoes do hub na api do service javascript (discar, intervalo, desligar, etc)
            service.iniciar = function (idOrIpOrRamal, tipoLogon, reconectar) {
                service.loginOpts = [idOrIpOrRamal, tipoLogon];
                service.deveConectar = reconectar == undefined ? true : reconectar;
                return callHubMethod("iniciar")(idOrIpOrRamal, tipoLogon);
            };
            service.terminar = function () {
                service.deveConectar = false;
                return callHubMethod("terminar")();
            };
            service.discar = callHubMethod("discar");
            service.discarRota = callHubMethod("discarRota");
            service.discarPreview = callHubMethod("discarPreview");
            service.desligar = callHubMethod("desligar");
            service.desligarChamada = callHubMethod("desligarChamada");
            service.transferir = callHubMethod("transferir");
            service.consultar = callHubMethod("consultar");
            service.atendeChamadaNaFila = callHubMethod("atendeChamadaNaFila");
            service.capturaDirigida = callHubMethod("capturaDirigida");
            service.liberarConsulta = callHubMethod("liberarConsulta");
            service.transfereVoiceMail = callHubMethod("transfereVoiceMail");
            service.iniciarIntervalo = callHubMethod("iniciarIntervalo");
            service.terminarIntervalo = callHubMethod("terminarIntervalo");
            service.iniciarNaoDisponivel = callHubMethod("iniciarNaoDisponivel");
            service.terminarNaoDisponivel = callHubMethod("terminarNaoDisponivel");
            service.iniciarEspera = callHubMethod("iniciarEspera");
            service.terminarEspera = callHubMethod("terminarEspera");
            service.conferenciaAdicionar = callHubMethod("conferenciaAdicionar");
            service.conferenciaRemover = callHubMethod("conferenciaRemover");
            service.conferenciaIniciar = callHubMethod("conferenciaIniciar");
            service.conferenciaTerminar = callHubMethod("conferenciaTerminar");
            service.conferenciaSair = callHubMethod("conferenciaSair");
            service.sigaMe = callHubMethod("sigaMe");
            service.sigaMeMultiplo = callHubMethod("sigaMeMultiplo");
            service.cancelaSigaMe = callHubMethod("cancelaSigaMe");
            service.alterarIntervaloTipo = callHubMethod("alterarIntervaloTipo");
            service.atendeChamada = callHubMethod("atendeChamada");
            service.enviaDigitosDtmf = callHubMethod("enviaDigitosDtmf");

            service.init = function () {

                atendimentoProxy = SignalrConnection.atendimentoProxy;

                // usando a notação proxy.on(event, function) , ao invés de proxy.client.event,
                // pois o signalR ignora eventos inseridos da segunda forma, após a conexão ter sido estabelecida.
                // Como a conexão poderá ser estabelecida antes, pelo MessageBus, precisamos usar a primeira forma,
                // que atualizará corretamente o listener de eventos

                //service.atendimentoHub.client.onLogado = raiseEvent(ATENDIMENTO_EVENTS.onLogado);

                atendimentoProxy.on("onLogado", raiseEventLogado(ATENDIMENTO_EVENTS.onLogado));
                atendimentoProxy.on("onLogadoErro", raiseEventLogadoErro(ATENDIMENTO_EVENTS.onLogadoErro));
                atendimentoProxy.on("onConexaoErro", raiseEventLogadoErro(ATENDIMENTO_EVENTS.onConexaoErro));
                atendimentoProxy.on("onDeslogado", raiseEventLogadoErro(ATENDIMENTO_EVENTS.onDeslogado));
                atendimentoProxy.on("onDisca", raiseChamadaEvent(ATENDIMENTO_EVENTS.onDisca));
                atendimentoProxy.on("onDiscaStatus", raiseChamadaEvent(ATENDIMENTO_EVENTS.onDiscaStatus));
                atendimentoProxy.on("onDiscaErro", raiseRemoveChamadaEvent(ATENDIMENTO_EVENTS.onDiscaErro));
                atendimentoProxy.on("onChamada", raiseChamadaEvent(ATENDIMENTO_EVENTS.onChamada));
                atendimentoProxy.on("onRingSip", raiseChamadaEvent(ATENDIMENTO_EVENTS.onRingSip));
                atendimentoProxy.on("onChamadaLigacaoId", raiseChamadaEvent(ATENDIMENTO_EVENTS.onChamadaLigacaoId));
                atendimentoProxy.on("onChamadaPerdida", raiseChamadaEvent(ATENDIMENTO_EVENTS.onChamadaPerdida));
                atendimentoProxy.on("onAtendido", raiseChamadaEvent(ATENDIMENTO_EVENTS.onAtendido));
                atendimentoProxy.on("onAtendidoDiscador", raiseChamadaEvent(ATENDIMENTO_EVENTS.onAtendidoDiscador));
                atendimentoProxy.on("onDesliga", raiseRemoveChamadaEvent(ATENDIMENTO_EVENTS.onDesliga));
                atendimentoProxy.on("onChamadaTransferida", raiseRemoveChamadaEvent(ATENDIMENTO_EVENTS.onChamadaTransferida));
                atendimentoProxy.on("onChamadaEntrouNaFila", raiseEvent(ATENDIMENTO_EVENTS.onChamadaEntrouNaFila));
                atendimentoProxy.on("onChamadaSaiuDaFila", raiseEvent(ATENDIMENTO_EVENTS.onChamadaSaiuDaFila));
                atendimentoProxy.on("onNumerosSigaMeMultiplo", raiseEvent(ATENDIMENTO_EVENTS.onNumerosSigaMeMultiplo));
                atendimentoProxy.on("onInicioIntervalo", raiseEvent(ATENDIMENTO_EVENTS.onInicioIntervalo));
                atendimentoProxy.on("onTerminoIntervalo", raiseEvent(ATENDIMENTO_EVENTS.onTerminoIntervalo));
                atendimentoProxy.on("onInicioNaoDisponivel", raiseEvent(ATENDIMENTO_EVENTS.onInicioNaoDisponivel));
                atendimentoProxy.on("onTerminoNaoDisponivel", raiseEvent(ATENDIMENTO_EVENTS.onTerminoNaoDisponivel));
                atendimentoProxy.on("onInicioEspera", raiseEvent(ATENDIMENTO_EVENTS.onInicioEspera));
                atendimentoProxy.on("onTerminoEspera", raiseEvent(ATENDIMENTO_EVENTS.onTerminoEspera));
                atendimentoProxy.on("onEntrouEmConferencia", raiseEvent(ATENDIMENTO_EVENTS.onEntrouEmConferencia));
                atendimentoProxy.on("onConferenciaInicio", raiseEvent(ATENDIMENTO_EVENTS.onConferenciaInicio));
                atendimentoProxy.on("onConferenciaTermino", raiseEvent(ATENDIMENTO_EVENTS.onConferenciaTermino));
                atendimentoProxy.on("Conferencia_OnDisca", raiseEvent(ATENDIMENTO_EVENTS.Conferencia_OnDisca));
                atendimentoProxy.on("onConferenciaDiscaErro", raiseEvent(ATENDIMENTO_EVENTS.onConferenciaDiscaErro));
                atendimentoProxy.on("Conferencia_OnAtendido", raiseEvent(ATENDIMENTO_EVENTS.Conferencia_OnAtendido));
                atendimentoProxy.on("onConferenciaChamadaEncerrada", raiseEvent(ATENDIMENTO_EVENTS.onConferenciaChamadaEncerrada));
                atendimentoProxy.on("onConferenciaErro", raiseEvent(ATENDIMENTO_EVENTS.onConferenciaErro));
                atendimentoProxy.on("onInfoIntervaloRamal", raiseEvent(ATENDIMENTO_EVENTS.onInfoIntervaloRamal));
                atendimentoProxy.on("onAlterarIntervaloTipoErro", raiseEvent(ATENDIMENTO_EVENTS.onAlterarIntervaloTipoErro));
                atendimentoProxy.on("onSetIntervaloRamal", raiseEvent(ATENDIMENTO_EVENTS.onSetIntervaloRamal));
                atendimentoProxy.on("onInfoCliente", raiseEvent(ATENDIMENTO_EVENTS.onInfoCliente));
                atendimentoProxy.on("onParametrosRamal", raiseEvent(ATENDIMENTO_EVENTS.onParametrosRamal));
                atendimentoProxy.on("onRecebendoMensagem", raiseEvent(ATENDIMENTO_EVENTS.onRecebendoMensagem));
                atendimentoProxy.on("onChamadaGlobalId", raiseEvent(ATENDIMENTO_EVENTS.onChamadaGlobalId));
                atendimentoProxy.on("onChamadaDesligouNaEspera", raiseEvent(ATENDIMENTO_EVENTS.onChamadaDesligouNaEspera));
                atendimentoProxy.on("onDiscaStatusInterno", raiseChamadaEvent(ATENDIMENTO_EVENTS.onDiscaStatusInterno));                

                service.TipoLogon = atendimentoProxy.TipoLogon;
                service.TipoDiscagem = atendimentoProxy.TipoDiscagem;
                service.StatusDiscagemExterno = atendimentoProxy.StatusDiscagemExterno;

                initExecuted = true;
            }

            service.start = function start() {
                SignalrConnection.init();
                service.init();
                return SignalrConnection.start();
            }

            service.stop = function stop() {
                return SignalrConnection.stop();
            }

            return service;
        }])
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .constant('AUTH_EVENTS', {
            tokenChanged: 'on-auth-token-changed',
            userAuthenticated: "on-auth-user-authenticated",
            userLogout: "on-auth-user-logout",
            userLogoutRamal: "on-auth-user-logout-ramal"
        })
        .service('AuthService', ["$rootScope", "$q", "$http", "$window", "$timeout", "$interval", "$cookies", "Config", "LocalStorageService", "AUTH_EVENTS", function ($rootScope, $q, $http, $window, $timeout, $interval, $cookies, Config, LocalStorageService, AUTH_EVENTS) {
            var service = {};
            var usuarioLogado = null;
            var usuarioLogin = null;
            var urlTokenEndpoint = Config.getUrlToken();
            var urlUserInfo = Config.getUrl("SessaoUsuario");
            var oauthClientId = Config.oauthClientId;
            var tokenRequestInProgress = null;

            var sendUrlEncodedPost = function sendUrlEncodedPost(data) {

                var urlEncodedData = [];
                for (var item in data) {
                    urlEncodedData.push(encodeURIComponent(item) + "=" + encodeURIComponent(data[item].toString()));
                }

                return $http({
                    method: 'POST',
                    url: urlTokenEndpoint,
                    withCredentials: true, // permite que a api grave o cookie de autenticação para requests de arquivos estaticos
                    data: urlEncodedData.join("&"),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Platform': data.platform,
                        'Method': data.method
                    }
                });
            };

            // detectar login com outro usuário em outra janela
            $window.addEventListener("storage", function (event) {
                if (event.key === "Token" || event.key === null) {
                    var newToken = angular.fromJson(event.newValue || "{}");

                    if (!newToken.username && usuarioLogin) {
                        // usuário deslogou em outra aba, redireciona-lo para o login
                        service.logout();
                        $window.document.location.reload();
                    }
                    else if (newToken.username && !usuarioLogin) {
                        // o cliente logou em outra aba, enquanto esta aba estava deslogada, então redirecionamos o cliente para a Dash
                        $window.document.location.reload();
                    }
                    else if (usuarioLogado && newToken.username !== usuarioLogin) {
                        // reload do browser para Dash principal, para capturar o novo usuario
                        service.logout();
                        $window.document.location.reload();
                    }
                    else if (newToken.access_token) {
                        processAccessToken(newToken);
                    }
                }
            });

            var getToken = function getToken() {
                return angular.fromJson($window.localStorage.getItem("Token") || "{}");
            }

            var useStorageAuthentication = function useStorageAuthentication() {
                return $cookies.get("SessionInitiate") == "1" || $window.localStorage.getItem("PersistAuth") == "1";
            }

            var processAccessToken = function processAccessToken(tokenData) {
                if (service._timeoutRefreshToken) $timeout.cancel(service._timeoutRefreshToken);

                if (tokenData.data) tokenData = tokenData.data;

                if (tokenData && tokenData.access_token) {
                    usuarioLogin = tokenData.username;
                    var json = angular.toJson(tokenData);
                    $window.localStorage.setItem("Token", json);
                    $cookies.put("SessionInitiate", "1");
                    $http.defaults.headers.common.Authorization = "Bearer " + tokenData.access_token;
                    $rootScope.$broadcast(AUTH_EVENTS.tokenChanged, tokenData);
                } else {
                    cleanTokenCache();
                    return $q.reject();
                }

                if (tokenData.expires_in) {
                    // agendar para buscar um novo token com o refresh token, antes do token atual expirar
                    // (quando já tiver passado da metade do tempo para expirar)
                    // Math.random => permite que abas diferentes tenham tempos diferente para buscar um novo token, 
                    // dessa forma diminue a concorrência para realizar o refresh do token.
                    var timeout = Math.floor(tokenData.expires_in * Math.random()) * 1000;
                    service._timeoutRefreshToken = $timeout(service.updateRefreshToken, timeout);
                }

                tokenRequestInProgress = null;

                return $q.resolve(tokenData);
            }

            var setUsuario = function setUsuario(response) {
                if (response && response.data) {
                    usuarioLogado = response.data;
                    $rootScope.$broadcast(AUTH_EVENTS.userAuthenticated, usuarioLogado);
                    return usuarioLogado;
                } else {
                    service.logout();
                    return null;
                }
            }

            var getUsuario = function getUsuario() {
                if (usuarioLogado) return $q.resolve(usuarioLogado);
                return $http.get(urlUserInfo).then(setUsuario);
            }

            service.refreshUsuario = function refreshUsuario() {
                return $http.get(urlUserInfo).then(setUsuario);
            }

            var cleanTokenCache = function cleanTokenCache(error) {
                $window.localStorage.removeItem("Token");
                return $q.reject(error);
            }

            service.login = function login(user, password, persist, platform) {
                var authData = {
                    grant_type: "password",
                    username: user,
                    password: password,
                    client_id: oauthClientId,
                    platform: platform
                };

                if (persist) {
                    $window.localStorage.setItem("PersistAuth", "1");
                }
                else {
                    $window.localStorage.removeItem("PersistAuth");
                }

                return sendUrlEncodedPost(authData)
                    .then(processAccessToken)
                    .then(getUsuario)
                    .catch(cleanTokenCache);
            }

            service.loginOkta = function login(hash) {
                var authData = {
                    grant_type: "password",
                    username: hash,
                    password: '',
                    client_id: oauthClientId,
                    method: 'okta'
                };

                $window.localStorage.setItem("PersistAuth", "1");

                return sendUrlEncodedPost(authData)
                    .then(processAccessToken)
                    .then(getUsuario)
                    .catch(cleanTokenCache);
            }

            var removerCookies = function () {
                $cookies.remove("SessionInitiate");
                $http({
                    method: 'POST',
                    url: Config.getUrl("SessaoUsuario/Logout"),
                    withCredentials: true
                });
            }

            service.logout = function logout() {

                $rootScope.$broadcast(AUTH_EVENTS.userLogoutRamal, {});

                setTimeout(function () {
                    $rootScope.$broadcast(AUTH_EVENTS.userLogout, {});
                    if (service._timeoutRefreshToken) $timeout.cancel(service._timeoutRefreshToken);
                    LocalStorageService.clear();
                    $window.sessionStorage.clear();
                    usuarioLogado = null;
                    tokenRequestInProgress = null;
                    removerCookies();
                }, 200);
            }

            service.updateRefreshToken = function updateRefreshToken() {

                // verifica se aba já está em progresso
                if (tokenRequestInProgress) return tokenRequestInProgress;

                // verifica se tem refreshtoken
                const tokenData = getToken();
                if (!tokenData.refresh_token) return $q.reject();

                const verifyNewToken = () => {
                    var newTokenData = getToken();
                    if (newTokenData && newTokenData.refresh_token && newTokenData.refresh_token !== tokenData.refresh_token) {
                        // se o refresh foi feito em outra aba, retornamos o novo accessToken
                        return newTokenData;
                    }
                    // senão limpamos a autenticação e devolvemos o erro
                    cleanTokenCache();
                    return null;
                };

                // verifica se outra aba está autenticando
                let lockRefreshToken = LocalStorageService.getItem('lockRefreshToken');
                if (lockRefreshToken != null && !lockRefreshToken.ativo) {
                    LocalStorageService.setItem('lockRefreshToken', { ativo: true, data: new Date() });

                    var authData = {
                        grant_type: "refresh_token",
                        refresh_token: tokenData.refresh_token,
                        client_id: oauthClientId
                    };

                    tokenRequestInProgress = sendUrlEncodedPost(authData)
                        .then((res) => {
                            return processAccessToken(res);
                        })
                        .catch(function (err) {
                            tokenRequestInProgress = null;
                            if (err && (err.status === 401 || err.status === 400)) {
                                // antes limpar o cache do token, // verificar se o refresh não foi feito por outra aba
                                return $timeout(function () {
                                    const res = verifyNewToken();
                                    if (res == null || res.access_token == null) {
                                        throw err;
                                    } else {
                                        return res;
                                    }
                                }, 5000);
                            }
                            throw err;
                        })
                        .finally(() => {
                            LocalStorageService.setItem('lockRefreshToken', { ativo: false });
                        });

                    return tokenRequestInProgress;
                } else {
                    // se outra aba está autenticando
                    return $q(function (resolve, reject) {
                        let intervalLock = $interval(() => {
                            lockRefreshToken = LocalStorageService.getItem('lockRefreshToken');
                            if (lockRefreshToken != null && (new Date().getTime() - new Date(lockRefreshToken.data).getTime() > 20 || !lockRefreshToken.ativo)) {
                                LocalStorageService.setItem('lockRefreshToken', { ativo: false });
                                $interval.cancel(intervalLock);
                                const res = verifyNewToken();
                                if (res == null || res.access_token == null) {
                                    reject();
                                } else {
                                    resolve(res);
                                }
                            }
                        }, 1000);
                    });
                }
            }

            service.getAccessToken = function getAccessToken() {
                var tokenData = getToken();
                return tokenData.access_token;
            }

            service.restore = function restore() {
                if (usuarioLogado) return $q.resolve(usuarioLogado);

                if (!useStorageAuthentication()) {
                    LocalStorageService.clear();
                }

                return processAccessToken(getToken()).then(getUsuario);
            }

            service.getUsuarioLogado = function getUsuarioLogado() { return usuarioLogado; }

            // Indica se o tipo do usuario logado esta em "modo EPS" (UsuarioTipo.DashModoEPS).
            // Espelha a flag usada no backend (UsuarioManager / BilheteIndexacaoRepository).
            // O caminho de dados depende de GetByIdComPermissao incluir UsuarioTipo no
            // endpoint SessaoUsuario (UsuarioDetalheDto.UsuarioTipo).
            service.isDashModoEps = function isDashModoEps() {
                return !!(usuarioLogado && usuarioLogado.UsuarioTipo && usuarioLogado.UsuarioTipo.DashModoEPS);
            }

            return service;
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .service('ConferenciaService', ["AtendimentoService", "ATENDIMENTO_EVENTS", "$rootScope", "$interval", function ConferenciaService(AtendimentoService, ATENDIMENTO_EVENTS, $rootScope, $interval) {

            var service = {
                Timer: null,
                Participantes: [],
                isConferenciaEmAndamento: false,
                isChamadaAtiva: isChamadaAtiva,
                addParticipante: addParticipante,
                removeParticipante: removeParticipante,
                iniciar: iniciar,
                terminar: terminar,
                sair: sair
            };

            var timerInterval = null;

            function startTimer() {
                stopTimer();

                var duration = moment.duration(0, 'milliseconds');
                var interval = 1000;

                timerInterval = $interval(function () {
                    duration = moment.duration(duration.asMilliseconds() + interval, 'milliseconds');
                    service.Timer = duration.asMilliseconds();
                }, interval);
            }

            function stopTimer() {
                $interval.cancel(timerInterval);
                delete service.Timer;
            }

            function isChamadaAtiva() {
                return AtendimentoService.chamadaAtiva;
            }

            function addParticipante(numero) {
                if (!numero) return false;

                var participante = { Numero: numero, Status: 'Aguardando para discar' };

                service.Participantes.push(participante);

                if (service.isConferenciaEmAndamento) {
                    var tipoDiscagem = numero.length <= 5 ? 2 : 1;
                    AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                }

                return true;
            }

            function removeParticipante(numero) {
                if (!numero) return;

                if (service.isConferenciaEmAndamento) {
                    AtendimentoService.conferenciaRemover(numero);
                }

                service.Participantes = _.without(service.Participantes, _.findWhere(service.Participantes, { Numero: numero }));
            }

            function iniciar() {
                service.Participantes.forEach(function (item) {
                    var tipoDiscagem = item.Numero.length <= 5 ? 2 : 1;
                    AtendimentoService.conferenciaAdicionar(item.Numero, tipoDiscagem);
                });

                service.isConferenciaEmAndamento = true;

                AtendimentoService.conferenciaIniciar().then(function () {
                    service.isConferenciaEmAndamento = true;
                    startTimer();
                }).catch(function () {
                    service.isConferenciaEmAndamento = false;
                    stopTimer();
                });
            }

            function terminar() {
                AtendimentoService.conferenciaTerminar();
            }

            function sair() {
                AtendimentoService.conferenciaSair();
            }

            /* Callback */
            function onConferenciaDisca(event, ramal, chamada) {
                var participante = _.findWhere(service.Participantes, { Numero: chamada.Telefone });
                participante.CanalId = chamada.CanalId;
                participante.Status = "Discando";
            }

            function onConferenciaAtendido(event, ramal, chamada) {
                if (!chamada.Telefone) {
                    // eslint-disable-next-line no-console
                    console.log("Número inválido.");
                    return;
                }

                var participante = _.findWhere(service.Participantes, { Numero: chamada.Telefone });
                participante.CanalId = chamada.CanalId;
                participante.Status = "Atendido";
            }

            function onConferenciaChamadaEncerrada(event, ramal, chamada) {
                var participante = _.findWhere(service.Participantes, { Numero: chamada.Telefone });
                participante.CanalId = chamada.CanalId;
                participante.Status = "Chamada Encerrada";
            }

            function onConferenciaTermino() {
                service.isConferenciaEmAndamento = false;
                service.Participantes = [];
            }

            function onConferenciaErro() {
                service.isConferenciaEmAndamento = false;
                service.Participantes = [];
            }

            $rootScope.$on(ATENDIMENTO_EVENTS.onConferenciaChamadaEncerrada, onConferenciaChamadaEncerrada);
            $rootScope.$on(ATENDIMENTO_EVENTS.onConferenciaAtendido, onConferenciaAtendido);
            $rootScope.$on(ATENDIMENTO_EVENTS.onConferenciaDisca, onConferenciaDisca);
            $rootScope.$on(ATENDIMENTO_EVENTS.onConferenciaTermino, onConferenciaTermino);
            $rootScope.$on(ATENDIMENTO_EVENTS.onConferenciaErro, onConferenciaErro);

            return service;
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('EventoAcaoService', ["AtendimentoConfiguracaoResource", "ATENDIMENTO_EVENTS", "$http", "AuthService", function EventoAcaoService(AtendimentoConfiguracaoResource, ATENDIMENTO_EVENTS, $http, AuthService) {
            let service = {};
            let listeners = [];
            let acoes = null;

            let abrirWebsite = function (acao, eventArgs) {
                const newWebsite = replaceParamsConf(acao.Website, eventArgs);
                window.open(newWebsite);
            }

            let chamarWebservice = function (acao, eventArgs) {
                let newUrl = replaceParamsConf(acao.Url, eventArgs);
                let newBodyTemplate = JSON.parse(replaceParamsConf(acao.BodyTemplate, eventArgs, true));
                let newHeader = JSON.parse(replaceParamsConf(acao.Headers, eventArgs, true));

                if (!newHeader.Authorization)
                    newHeader.Authorization = undefined;

                const req = {
                    method: acao.Method,
                    url: newUrl,
                    headers: newHeader,
                    data: newBodyTemplate
                }
                $http(req);
            }

            let acoesDict = {
                AbrirWebsite: abrirWebsite,
                WebService: chamarWebservice
            }

            let createListener = function (scope, eventName) {
                return scope.$on(decapitalizeEventName(eventName), function () {
                    if (acoes[eventName] != null) {
                        const eventArgs = arguments;
                        acoes[eventName].Actions.forEach(function (element) {
                            acoesDict[element.ActionName](element, eventArgs);
                        });
                    }
                })
            }

            service.init = function init(scope) {

                listeners = [];
                acoes = null;

                AtendimentoConfiguracaoResource.get({ Id: scope.usuario.AtendimentoConfiguracaoId }).$promise.then(configuracao => {
                    acoes = configuracao.Json.Events;
                    for (let key in acoes) {
                        if (ATENDIMENTO_EVENTS[decapitalizeEventName(key)] != null)
                            listeners.push(createListener(scope, key));
                    }
                });

                scope.$on('$destroy', function () {
                    listeners.forEach(function (element) {
                        element();
                    });
                });
            }


            // HELPERS
            let replaceParamsConf = function (conf, eventArgs, jsonObject) {
                if (jsonObject) {
                    conf = conf.substring(conf.indexOf('{') + 1, conf.lastIndexOf('}'));
                }
                // get params
                let startindexes = getIndicesOf("{{", conf);
                let endindexes = getIndicesOf("}}", conf);
                let params = [];
                for (let i = 0; i < startindexes.length; i++) {
                    params.push(conf.substring(startindexes[i], endindexes[i] + 2));
                }

                // replace params 
                for (let keyArg in eventArgs) {
                    let arg = eventArgs[keyArg];
                    if(arg.length > 0){
                        angular.forEach(arg, function (value) {
                            const formattedKey = '{{' + value.Campo + '}}';
                            
                            if (conf.indexOf(formattedKey) >= 0) {
                                conf = conf.replace(formattedKey, value.Valor);
                            }
                        });
                    } else {
                        for (let key in arg) {
                            const formattedKey = '{{' + key + '}}';
                            if (arg.hasOwnProperty(key) && params.indexOf(formattedKey) >= 0) {
                                conf = conf.replace(formattedKey, arg[key]);
                            }
                        }
                    }
                }

                if (conf.contains("{{UsuarioId}}"))
                    conf = conf.replace("{{UsuarioId}}", AuthService.getUsuarioLogado().UsuarioId);

                if (jsonObject) {
                    conf = '{' + conf + '}';
                }
                return conf;
            }

            let getIndicesOf = function (searchStr, str) {
                let searchStrLen = searchStr.length;
                if (searchStrLen == 0) {
                    return [];
                }
                let startIndex = 0, index, indices = [];

                str = str.toLowerCase();
                searchStr = searchStr.toLowerCase();

                while ((index = str.indexOf(searchStr, startIndex)) > -1) {
                    indices.push(index);
                    startIndex = index + searchStrLen;
                }
                return indices;
            }

            let decapitalizeEventName = function (string) {
                return string.charAt(0).toLowerCase() + string.slice(1);
            }

            return service;
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('FileDownloadService', ["AuthService", "Config", function FileDownloadService(AuthService, Config) {
            var service = {};

            service.resolveUrl = function resolveUrl(relativeUrl, params) {
                var url = Config.getUrl(relativeUrl);
                var accessToken = AuthService.getAccessToken();

                params = angular.extend({ access_token: accessToken, token_type: 'bearer' }, params);

                return [url, $.param(params)].join('?');
            }

            service.downloadWebApiFile = function (relativeUrl, params) {
                $("<iframe src='" + service.resolveUrl(relativeUrl, angular.extend({}, params, { 'forceDownload': true })) + "' style='display:none;' />").appendTo("body");
            }

            return service;
        }]
    );
})();


(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory('LocalStorageService', ['$window', function ($window) {
            var service = {};

            var getPersisted = () => angular.fromJson($window.localStorage.getItem('persistedItens') || "[]");
            var setPersisted = (persistedItens) => $window.localStorage.setItem('persistedItens', angular.toJson(persistedItens));

            service.setItem = function (name, obj, persist) {
                const json = angular.toJson(obj);
                $window.localStorage.setItem(name, json);

                if (persist === true) {
                    const persistedItens = getPersisted();
                    if (persistedItens.indexOf(name) == -1) {
                        persistedItens.push(name);
                        setPersisted(persistedItens);
                    }
                }
            };

            service.getItem = function (name) {
                return angular.fromJson($window.localStorage.getItem(name) || "{}");
            };

            service.removeItem = function (name) {
                $window.localStorage.removeItem(name);

                const persistedItens = getPersisted();
                if (persistedItens.indexOf(name) >= 0) {
                    persistedItens.splice(persistedItens.indexOf(name), 1);
                    setPersisted(persistedItens);
                }
            };

            service.clear = function () {
                const itens = Object.keys($window.localStorage);
                const persistedItens = getPersisted();
                itens.forEach(item => {
                    if (persistedItens.indexOf(item) == -1 && item != 'persistedItens') {
                        $window.localStorage.removeItem(item);
                    }
                });
            }

            return service;
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .config(["$provide", function ($provide) {
            // extender metodo $on do objeto $scope/$rootScope
            $provide.decorator('$rootScope', ["$delegate", "$injector", function ($delegate, $injector) {
                var proto, originalFn;
                if (window.Object && window.Object.getPrototypeOf) {
                    proto = Object.getPrototypeOf($delegate);
                } else {
                    proto = $delegate.__proto__;
                }
                originalFn = proto.$on;

                // alteramos o metodo $on do $scope para identificar automaticamente quando 
                // um $scope quer subscrever em um evento do SignalR ( quando o nome do evento for onXXXChanged )
                proto.$on = function customOn(eventName, listener, filter) {
                    var eventNameString = eventName.toString();

                    if (eventNameString.startsWith("on") && eventName.endsWith("Changed")) {

                        var messageBusService = $injector.get("MessageBus");

                        eventNameString = messageBusService.subscribe(eventNameString, filter);
                        this.$on('$destroy', function () {
                            messageBusService.unsubscribe(eventNameString, filter);
                        });
                        return originalFn.apply(this, [eventNameString, listener]);
                    }

                    return originalFn.apply(this, arguments);
                }

                return $delegate;
            }])
        }])

        .service('MessageBus',
        ["$rootScope", "SignalrConnection", "$timeout", "PrintToConsole", "SIGNALR_EVENTS", function ($rootScope, SignalrConnection, $timeout, PrintToConsole, SIGNALR_EVENTS) {

            var service = {}, allSubscriptions = {}, messageBusProxy, SUB_STATUS = { PENDING_SUB: -1, PENDING_UNSUB: 0, SUBOK: 1 };

            service.subscribe = function subscribe(modelName, filter) {
                
                updateSubscription(modelName, filter, SUB_STATUS.PENDING_SUB);

                if (SignalrConnection.connected) {
                    internalSubscribe(modelName, filter);
                }

                return getKeyName(modelName, filter);
            }

            service.unsubscribe = function unsubscribe(modelName, filter) {

                updateSubscription(modelName, filter, SUB_STATUS.PENDING_UNSUB);

                if (SignalrConnection.connected) {
                    internalUnsubscribe(modelName, filter);
                }

                return getKeyName(modelName, filter);
            }

            service.init = function () {
                messageBusProxy = SignalrConnection.messageBusProxy;

                messageBusProxy.on("onModelChanged", function onModelChanged(modelName, model, filter) {
                    var eventName = 'on' + modelName + 'Changed';
                    if (filter) {
                        eventName = getKeyName(eventName, filter);
                    }
                    $timeout(function () {
                        PrintToConsole.debug("MessageBus message: " + modelName + " changed");
                        $rootScope.$broadcast(eventName, model);
                    });
                });
            }

            service.start = function start() {
                SignalrConnection.init();
                service.init();
                return SignalrConnection.start();
            }

            service.stop = function stop() {
                return SignalrConnection.stop();
            }

            function postConnection() {
                angular.forEach(allSubscriptions, function (subscription) {
                    var status = subscription.status;
                    if (status === SUB_STATUS.PENDING_SUB) {
                        internalSubscribe(subscription.model, subscription.filter);
                    }
                    else if (status === SUB_STATUS.PENDING_UNSUB) {
                        internalUnsubscribe(subscription.model, subscription.filter);
                    }
                });
            }

            function internalSubscribe(modelName, filter) {
                var promise;

                if (filter && angular.isObject(filter)) {
                    promise = messageBusProxy.server.subscribeWithFilter(modelName, filter);
                }
                else {
                    promise = messageBusProxy.server.subscribe(modelName);
                }

                promise.then(function () {
                    updateSubscription(modelName, filter, SUB_STATUS.SUBOK);
                    PrintToConsole.debug("subscribed to " + modelName)
                }).fail(PrintToConsole.error);
            }

            function internalUnsubscribe(modelName, filter) {
                var promise;

                if (filter && angular.isObject(filter)) {
                    promise = messageBusProxy.server.unsubscribeWithFilter(modelName, filter);
                }
                else {
                    promise = messageBusProxy.server.unsubscribe(modelName);
                }

                promise.then(function () {
                    delete allSubscriptions[getKeyName(modelName, filter)];
                    PrintToConsole.debug("unsubscribe from " + modelName);
                }).fail(PrintToConsole.error);
            }

            function updateSubscription(modelName, filter, status) {
                validateFilter(filter);
                return allSubscriptions[getKeyName(modelName, filter)] = {
                    status: status || SUB_STATUS.PENDING_SUB, model: modelName, filter: filter
                };
            }

            function getKeyName(modelName, filter) {
                if (filter && angular.isObject(filter)) {
                    return modelName + ":" + angular.toJson(filter);
                }
                return modelName;
            }

            function validateFilter(filter) {
                if (!filter || !angular.isObject(filter)) return "";

                var keys = Object.keys(filter);

                if (keys.length !== 1) {
                    throw new Error("Usar apenas um propriedade para o filtro para o MessageBus");
                }

                var value = filter[keys[0]];
                if (!angular.isArray(value)) {
                    value = [value];
                }

                return filter[keys[0]] = _.map(value, validateFilterValue);
            }

            function validateFilterValue(value) {
                return value !== null ? value.toString() : "";
            }

            $rootScope.$on(SIGNALR_EVENTS.connected, postConnection);

            $rootScope.$on(SIGNALR_EVENTS.disconnected, function () {
                // quando desconectar do signalr, marcar todas as subscrições como pendente, 
                // para que ao reconectar este servico possa refazer as subscrições
                angular.forEach(allSubscriptions, function (subscription, key) {
                    if (subscription.status === SUB_STATUS.SUBOK) {
                        subscription.status = SUB_STATUS.PENDING_SUB;
                    }
                    else if (value === SUB_STATUS.PENDING_UNSUB) {
                        // quando desconectamos, o signalr remove as subscrições automaticamente
                        delete allSubscriptions[key];
                    }
                });
            });

            return service;
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('ModalService', ["$window", "$translate", function ModalService($window, $translate) {
            const service = {};
            let modalLoading = null;
            let modalUploading = null;

            service.confirmDelete = function (callback) {
                return service.confirmMessage('notificacoes.confirmarExclusao', null, callback);
            };

            service.confirmDescartar = function (callback) {
                return service.confirmMessage('notificacoes.confirmarDescartar', null, callback);
            };

            service.confirmSalvar = function (callback) {
                return service.confirmMessage('notificacoes.confirmarSalvar', null, callback);
            };

            service.confirmInativar = function (callback) {
                return service.confirmMessage('notificacoes.confirmarInativar', null, callback);
            };

            service.confirmReativar = function (callback) {
                return service.confirmMessage('notificacoes.confirmarReativar', null, callback);
            }
            
            service.confirmNovaCategoria = function (callback) {
                return service.confirmMessage('notificacoes.confirmarNovaCategoria', null, callback);
            };

            service.confirmDeleteCategoria = function (callback) {
                return service.confirmMessage('notificacoes.confirmarDeleteCategoria', null, callback);
            };

            service.confirmMessage = function (mensagem, params, callback, labels, oncancel) {
                return $window.UIkit.modal.confirm($translate.instant(mensagem, params), callback, oncancel, labels);
            };

            service.confirmImportacao = function (callback) {
                return service.confirmMessage('notificacoes.confirmImportacao', null, callback);
            };

            service.openModal = function (modalId, showEvent, hideEvent, paramsModal) {
                if (!paramsModal) {
                    paramsModal = { center: false };
                }

                var modal = $.UIkit.modal('#' + modalId, paramsModal);
                if (showEvent) {
                    $(modalId).on({
                        'show.uk.modal': showEvent()
                    });
                }

                if (hideEvent) {
                    $(modalId).on({
                        'hide.uk.modal': hideEvent()
                    });
                }

                if (!modal.isActive()) {
                    modal.show();
                }
            };

            service.closeModal = function (modalId, callback) {
                var modal = $.UIkit.modal('#' + modalId);
                if (modal.isActive()) {
                    modal.hide();
                    if (callback) {
                        callback();
                    }
                }
            };

            service.isActive = function (modalId, callback) {
                var modal = $.UIkit.modal('#' + modalId);
                if (modal.isActive()) {
                    if (callback) {
                        callback();
                    }
                    modal.hide();
                }
            }

            service.isHidden = function (modalId, callback, params, showModal) {
                if (!showModal) {
                    showModal = true
                }

                var modal = $.UIkit.modal('#' + modalId, params);
                if (!modal.isActive()) {
                    if (callback) {
                        callback();
                    }
                    if (showModal) {
                        modal.show();
                    }
                }
            }

            service.alert = function (mensagem, params, callback) {
                var modal = UIkit.modal.alert($translate.instant(mensagem, params));
                if (callback) {
                    modal.on('hide.uk.modal', function () {
                        callback();
                    });
                }
            }

            service.showLoading = function () {
                modalLoading = UIkit.modal.blockUI(`<div id="modalBlock" class='uk-text-center'>${$translate.instant('notificacoes.aguarde')}...<br/><img class='uk-margin-top' src='assets/img/spinners/spinner.gif' alt=''>`);
            }

            service.showUploading = function () {
                modalUploading = UIkit.modal.blockUI(`<div id="modalBlock" class='uk-text-center'>${$translate.instant('diretivas.fazendoUpload')}...<br/><div class="uk-progress uk-progress-striped uk-active"><div class="uk-progress-bar" style="width: 0%;"></div></div></div>`);
            }

            service.hideLoading = function () {
                if (modalLoading != null) {
                    modalLoading.hide();
                    modalLoading = null;
                }
            }

            service.hideUploading = function () {
                if (modalUploading != null) {
                    modalUploading.hide();
                    modalUploading = null;
                }
            }

            return service;
        }]
        );
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('NotifyService', ["$window", "$translate", function NotifyService($window, $translate) {
            const service = {};
            let notifyLoading = null;
            let currentNotification = null;

            service.showSuccess = function (mensagem) {
                if (mensagem == null) {
                    mensagem = 'notificacoes.operacaoRealizada';
                }
                service.showMessage(mensagem, 'success');
            };

            service.showError = function (error, mensagem, params) {
                if (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
                if (mensagem == null) {
                    mensagem = 'notificacoes.erroAoRealizarOperacao';
                }
                if (error && error.status === 400) {
                    if (error.data) {
                        if (Array.isArray(error.data)) {
                            mensagem = error.data.map(function (er) {
                                return er.Message;
                            }).join("<br>");
                        } else {
                            mensagem = error.data.Message;
                        }
                    }
                }
                service.showMessage(mensagem, 'danger', params);
            };

            service.showMessage = function (mensagem, cor, params) {

                // Fecha notificação anterior se existir
                if (currentNotification) {
                    currentNotification.close();
                }
                currentNotification = $window.UIkit.notify($translate.instant(mensagem, params), {
                    status: cor,
                    pos: "top-center"
                });
            };

            service.showMessageExt = function (mensagem, status, params, timeout) {
                return new Promise(function (resolve) {
                    // Fecha notificação anterior se existir
                    if (currentNotification) {
                        currentNotification.close();
                    }

                    status = status || "info";
                    timeout = timeout || 3000;

                    const timestamp = new Date().toLocaleTimeString();
                    console.log(`[${timestamp}] showMessageExt : ${mensagem}`);

                    // Exibe a nova notificação
                    currentNotification = $window.UIkit.notify(
                        $translate.instant(mensagem, params),
                        {
                            status: status,
                            pos: "top-center",
                            timeout: timeout,
                            onClose: resolve
                        }
                    );
                });
            };

            service.showLoading = function (titulo) {
                // Fecha loading anterior se existir
                service.hideLoading();

                const svg = '<svg class="circular"><circle class="path" cx="12" cy="12" r="10" fill="none" stroke-width="3" stroke-miterlimit="10"/></svg>';
                let message = `${svg}<span class="row-align-center">${$translate.instant(titulo)}...</span>`;

                notifyLoading = $window.UIkit.notify(message, {
                    timeout: 0,
                    status: "info",
                    pos: "top-center"
                });
            };

            service.hideLoading = function () {
                if (notifyLoading) {
                    notifyLoading.close(); // Fecha apenas esta notificação
                    notifyLoading = null;
                }
            };

            service.showInvalid = function () {
                // Fecha janelas abertas!
                if (notifyLoading != null) {
                    UIkit.notify.closeAll()
                    notifyLoading = null;
                }
                notifyLoading = $window.UIkit.notify($translate.instant('notificacoes.preenchaCorretamente'), {
                    status: "danger",
                    pos: "top-center"
                });
                return;
            }

            service.showRegistroSalvo = function () {
                $window.UIkit.notify($translate.instant('notificacoes.registroSalvo'), {
                    status: "success",
                    pos: "top-center"
                });
            }

            service.showRegistroAlterado = function () {
                $window.UIkit.notify($translate.instant('notificacoes.registroAlterado'), {
                    status: "success",
                    pos: "top-center"
                });
            }

            // Novo método para fechar a notificação atual
            service.closeCurrent = function () {
                if (currentNotification) {
                    try {
                        // Tenta fechar a notificação usando a API do UIkit
                        if (typeof currentNotification.close === 'function') {
                            currentNotification.close();
                        } else if (currentNotification.$element) {
                            // Alternativa: fechar via elemento DOM
                            currentNotification.$element.remove();
                        }
                    } catch (error) {
                        console.warn('Erro ao fechar notificação:', error);
                    } finally {
                        currentNotification = null;
                    }
                }
            };

            // Método para fechar todas as notificações do UIkit (opcional)
            service.closeAll = function () {
                try {
                    // Fecha todas as notificações do UIkit
                    if ($window.UIkit.notify && typeof $window.UIkit.notify.closeAll === 'function') {
                        $window.UIkit.notify.closeAll();
                    }
                } catch (error) {
                    console.warn('Erro ao fechar todas as notificações:', error);
                } finally {
                    currentNotification = null;
                }
            };

            return service;
        }]
        );
})();

angular.module('ODataResources', ['ng']);;

angular.module('ODataResources').
  factory('$odataOperators', [function() {

      var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      trim = function(value) {
        return value.replace(rtrim, '');
      };


  		var filterOperators =  {
  			'eq':['=','==','==='],
			'ne':['!=','!==','<>'],
			'gt':['>'],
			'ge':['>=','>=='],
			'lt':['<'],
			'le':['<=','<=='],
			'and':['&&'],
			'or':['||'],
			'not':['!'],
			'add':['+'],
			'sub':['-'],
			'mul':['*'],
			'div':['/'],
			'mod':['%'],
  		};

  		var convertOperator = function(from){
  			var input = trim(from).toLowerCase();
  			var key;
  			for(key in filterOperators)
  			{
  				if(input === key) return key;

  				var possibleValues = filterOperators[key];
  				for (var i = 0; i < possibleValues.length; i++) {
  					if(input === possibleValues[i]){
  						return key;
  					}
  				}
  			}

  			throw "Operator "+ from+" not found";
  		};

  		return {
  			operators : filterOperators,
  			convert:convertOperator,
  		};
  	}]);
;angular.module('ODataResources').
factory('$odataValue', [

    function() {
        var illegalChars = {
            '%': '%25',
            '+': '%2B',
            '/': '%2F',
            '?': '%3F',
            '#': '%23',
            '&': '%26'
        };
        var escapeIllegalChars = function(string) {
            for (var key in illegalChars) {
                string = string.replace(key, illegalChars[key]);
            }
            string = string.replace("'", "''");
            return string;
        };
        var ODataValue = function(input, type) {
            this.value = input;
            this.type = type;
        };

        var generateDate = function(date,isOdataV4){
        	if(!isOdataV4){
        		return "datetime'" + date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T" + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2)+':'+("0" + date.getSeconds()).slice(-2) + "'";
        	}else{
        		//return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T" + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2)+':'+("0" + date.getSeconds()).slice(-2) + "Z";
            return date.toISOString();
        	}
        };

        var generateGuid = function(guidValue, isOdataV4){
            if(!isOdataV4){
                return "guid'"+guidValue+"'";
            }else{
                return guidValue;
            }
        };

		var generateDateOffset = function (date, isOdataV4) {
            if (!isOdataV4) {
                return "datetimeoffset'" + date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T" + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ':' + ("0" + date.getSeconds()).slice(-2) + "'";
            } else {
                //return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T" + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ':' + ("0" + date.getSeconds()).slice(-2) + "Z";
                return date.toISOString();
            }
        };

        ODataValue.prototype.executeWithUndefinedType = function(isOdataV4) {
            if (angular.isString(this.value)) {
                return "'" + escapeIllegalChars(this.value) + "'";
            } else if (this.value === false) {
                return "false";
            } else if (this.value === true) {
                return "true";
            } else if (angular.isDate(this.value)) {
                return generateDate(this.value,isOdataV4);
            } else if (!isNaN(this.value)) {
                return this.value;
            } else {
                throw "Unrecognized type of " + this.value;
            }
        };

        ODataValue.prototype.executeWithType = function(isOdataV4){
        	if(this.value === true || this.value === false){
	        	if(this.type.toLowerCase() === "boolean"){
	        		return !!this.value+"";
	        	}else if(this.type.toLowerCase() === "string"){
	        		return "'"+!!this.value+"'";
	        	}else {
	        		throw "Cannot convert bool ("+this.value+") into "+this.type;
	        	}
	        }
	        if(angular.isDate(this.value)){
	        	if(this.type.toLowerCase() === "decimal"){
	        		return this.value.getTime()+"M";
	        	}else if(this.type.toLowerCase() === "int32"){
	        		return this.value.getTime()+"";
	        	}else if(this.type.toLowerCase() === "single"){
	        		return this.value.getTime()+"f";
	        	}else if(this.type.toLowerCase() === "double"){
	        		return this.value.getTime()+"d";
	        	}else if(this.type.toLowerCase() === "datetime"){
	        		return generateDate(this.value,isOdataV4);
	        	} else if (this.type.toLowerCase() === "datetimeoffset") {
	        	    return generateDateOffset(new Date(this.value), isOdataV4);
	        	}else if(this.type.toLowerCase()==="string"){
	        		return "'"+this.value.toISOString()+"'";
	        	}else {
	        		throw "Cannot convert date ("+this.value+") into "+this.type;
	        	}
	        }
	        if(angular.isString(this.value)){
	        	if(this.type.toLowerCase() === "guid"){
                    return generateGuid(this.value,isOdataV4);
	        	}else if(this.type.toLowerCase() === "datetime"){
	        		return generateDate(new Date(this.value),isOdataV4);
	        	} else if (this.type.toLowerCase() === "datetimeoffset") {
	        	    return generateDateOffset(new Date(this.value), isOdataV4);
	        	}else if(this.type.toLowerCase() === "single"){
	        		return parseFloat(this.value)+"f";
	        	}else if(this.type.toLowerCase() === "double"){
	        		return parseFloat(this.value)+"d";
	        	}else if(this.type.toLowerCase() === "decimal"){
	        		return parseFloat(this.value)+"M";
	        	}else if(this.type.toLowerCase() === "boolean"){
	        		return this.value;
	        	}else if(this.type.toLowerCase() === "int32"){
	        		return parseInt(this.value)+"";
	        	}else {
	        		throw "Cannot convert "+this.value+" into "+this.type;
	        	}
        	}else if(!isNaN(this.value)){
	        	if(this.type.toLowerCase() === "boolean"){
	        		return !!this.value+"";
	        	}else if(this.type.toLowerCase() === "decimal"){
	        		return this.value+"M";
	        	}else if(this.type.toLowerCase() === "double"){
	        		return this.value+"d";
	        	}else if(this.type.toLowerCase() === "single"){
	        		return this.value+"f";
	        	}else if(this.type.toLowerCase() === "byte"){
	        		return (this.value%255).toString(16);
	        	}else if(this.type.toLowerCase() === "datetime"){
	        		return generateDate(new Date(this.value),isOdataV4);
	        	}else if(this.type.toLowerCase() === "string"){
	        		return "'"+this.value+"'";
	        	}else {
	        		throw "Cannot convert number ("+this.value+") into "+this.type;
	        	}
        	}
        	else{
        		throw "Source type of "+this.value+" to be conververted into "+this.type+"is not supported";
        	}
        };

        ODataValue.prototype.execute = function(isOdataV4) {
            if(this.value === null){
                return 'null';
            }

            if (this.type === undefined) {
            	return this.executeWithUndefinedType(isOdataV4);
            } else {
            	return this.executeWithType(isOdataV4);
            }
        };
        return ODataValue;

    }
]);;angular.module('ODataResources').
factory('$odataProperty', [function() {

var ODataProperty = function(input){
		this.value = input;
	};

	ODataProperty.prototype.execute = function(){
		return this.value;
	};
	return ODataProperty;
}]);
	;angular.module('ODataResources').
factory('$odataBinaryOperation', ['$odataOperators','$odataProperty','$odataValue',function($odataOperators,ODataProperty,ODataValue) {

	var ODataBinaryOperation = function(a1,a2,a3){
		if(a1===undefined){
			throw "The property of a filter cannot be undefined";
		}

		if(a2 === undefined){
			throw "The value of a filter cannot be undefined";
		}

		if(a3 === undefined){
			//If strings are specified, we assume that the first one is the object property and the second one its value

			if(angular.isFunction(a1.execute)){
				this.operandA = a1;
			}else{
				this.operandA = new ODataProperty(a1);
			}
			if(a2!==null && angular.isFunction(a2.execute)){
				this.operandB = a2;
			}else{
				this.operandB = new ODataValue(a2);
			}

			this.filterOperator = 'eq';
		}
		else{
			if(angular.isFunction(a1.execute)){
				this.operandA = a1;
			}else{
				this.operandA = new ODataProperty(a1);
			}
			if(a3!==null && angular.isFunction(a3.execute)){
				this.operandB = a3;
			}else{
				this.operandB = new ODataValue(a3);
			}

			this.filterOperator = $odataOperators.convert(a2);
		}
	};


	ODataBinaryOperation.prototype.execute = function(isODatav4,noParenthesis){
		var result = this.operandA.execute(isODatav4)+" "+this.filterOperator+" " +this.operandB.execute(isODatav4);
		if(!noParenthesis)
			result = "("+result+")";

		return result;
	};

	ODataBinaryOperation.prototype.or = function(a1,a2,a3){
		var other;
		if(a2!==undefined){
			other = new ODataBinaryOperation(a1,a2,a3);
		}
		else if(angular.isFunction(a1.execute)){
			other = a1;
		}
		else{
			throw "The object " +a1 +" passed as a parameter of the or method is not valid";
		}
		return new ODataBinaryOperation(this,"or",other);
	};

	ODataBinaryOperation.prototype.and = function(a1,a2,a3){
		var other;
		if(a2!==undefined){
			other = new ODataBinaryOperation(a1,a2,a3);
		}
		else if(angular.isFunction(a1.execute)){
			other = a1;
		}
		else{
			throw "The object " +a1 +" passed as a parameter of the and method is not valid";
		}
		return new ODataBinaryOperation(this,"and",other);
	};

	return ODataBinaryOperation;
}

]);;angular.module('ODataResources').
factory('$odataMethodCall', ['$odataProperty', '$odataValue',
    function(ODataProperty, ODataValue) {

        var ODataMethodCall = function(methodName) {
            if (methodName === undefined || methodName === "")
                throw "Method name should be defined";

            this.params = [];

            if (arguments.length < 2)
                throw "Method should be invoked with arguments";

            for (var i = 1; i < arguments.length; i++) {
                var value = arguments[i];
                if (angular.isFunction(value.execute)) {
                    this.params.push(value);
                } else {
                    //We assume the first one is the object property;
                    if (i == 1) {
                        this.params.push(new ODataProperty(value));
                    } else {
                        this.params.push(new ODataValue(value));
                    }
                }
            }

            this.methodName = methodName;
        };

        ODataMethodCall.prototype.execute = function() {
            var invocation = this.methodName + "(";
            for (var i = 0; i < this.params.length; i++) {
                if (i > 0)
                    invocation += ",";

                invocation += this.params[i].execute();
            }
            invocation += ")";
            return invocation;
        };

        return ODataMethodCall;
    }
]);;angular.module('ODataResources').
factory('$odataOrderByStatement', [function($odataOperators,ODataBinaryOperation,ODataPredicate) {

	var ODataOrderByStatement = function(propertyName, sortOrder){
		if(propertyName===undefined){
			throw "Orderby should be passed a property name but got undefined";
		}

		this.propertyName = propertyName;

		this.direction = sortOrder || "asc";
	};

	ODataOrderByStatement.prototype.execute = function() {
		return this.propertyName+" "+this.direction;
	};

	return ODataOrderByStatement;
}]);;angular.module('ODataResources').
factory('$odataPredicate', ['$odataBinaryOperation',function(ODataBinaryOperation) {



	var ODataPredicate = function(a1,a2,a3){
		if(angular.isFunction(a1.execute) && a2 === undefined){
			return a1;
		}
		else{
			return new ODataBinaryOperation(a1,a2,a3);
		}
	};

	ODataPredicate.and = function(andStatements){
		if(andStatements.length>0){
			var finalOperation = andStatements[0];

			for (var i = 1; i < andStatements.length; i++) {
				finalOperation = new ODataBinaryOperation(finalOperation,'and',andStatements[i]);
			}
			return finalOperation;
		}
		throw "No statements specified";
	};

	ODataPredicate.or = function(orStatements){
		if(orStatements.length>0){
			var finalOperation = orStatements[0];

			for (var i = 1; i < orStatements.length; i++) {
				finalOperation = new ODataBinaryOperation(finalOperation,'or',orStatements[i]);
			}
			return finalOperation;
		}
		throw "No statements specified for OR predicate";
	};


	ODataPredicate.create = function(a1,a2,a3){
		if(angular.isFunction(a1.execute) && a2 === undefined){
			return a1;
		}
		else{
			return new ODataBinaryOperation(a1,a2,a3);
		}
	};

	return ODataPredicate;

}]);
;angular.module('ODataResources').
factory('$odataProvider', ['$odataOperators', '$odataBinaryOperation', '$odataPredicate', '$odataOrderByStatement',
    function($odataOperators, ODataBinaryOperation, ODataPredicate, ODataOrderByStatement) {
        var ODataProvider = function(callback, isv4) {
            this.callback = callback;
            this.filters = [];
            this.sortOrders = [];
            this.takeAmount = undefined;
            this.skipAmount = undefined;
            this.expandables = [];
            this.isv4 = isv4;
            this.hasInlineCount = false;
            this.selectables = [];
        };
        ODataProvider.prototype.filter = function(operand1, operand2, operand3) {
            if (operand1 === undefined) throw "The first parameted is undefined. Did you forget to invoke the method as a constructor by adding the 'new' keyword?";
            var predicate;
            if (angular.isFunction(operand1.execute) && operand2 === undefined) {
                predicate = operand1;
            } else {
                predicate = new ODataBinaryOperation(operand1, operand2, operand3);
            }
            this.filters.push(predicate);
            return this;
        };
        ODataProvider.prototype.orderBy = function(arg1, arg2) {
            this.sortOrders.push(new ODataOrderByStatement(arg1, arg2));
            return this;
        };
        ODataProvider.prototype.take = function(amount) {
            this.takeAmount = amount;
            return this;
        };
        ODataProvider.prototype.skip = function(amount) {
            this.skipAmount = amount;
            return this;
        };
        ODataProvider.prototype.execute = function() {
            var queryString = '';
            var i;
            if (this.filters.length > 0) {
                queryString = "$filter=" + ODataPredicate.and(this.filters).execute(this.isv4,true);
            }
            if (this.sortOrders.length > 0) {
                if (queryString !== "") queryString += "&";
                queryString += "$orderby=";
                for (i = 0; i < this.sortOrders.length; i++) {
                    if (i > 0) {
                        queryString += ",";
                    }
                    queryString += this.sortOrders[i].execute();
                }
            }
            if (this.takeAmount) {
                if (queryString !== "") queryString += "&";
                queryString += "$top=" + this.takeAmount;
            }
            if (this.skipAmount) {
                if (queryString !== "") queryString += "&";
                queryString += "$skip=" + this.skipAmount;
            }
            if (this.expandables.length > 0) {
                if (queryString !== "") queryString += "&";
                queryString += "$expand="+ this.expandables.join(',');
            }
            if(this.selectables.length>0){
                if (queryString !== "") queryString += "&";
                queryString += "$select=" + this.selectables.join(',');
            }


            if (this.hasInlineCount > 0) {
                if (queryString !== "") queryString += "&";
                queryString += this.isv4 ? "$count=true" : "$inlinecount=allpages";
            }

            return queryString;
        };
        ODataProvider.prototype.query = function(data, success, error) {
            if (!angular.isFunction(this.callback)) throw "Cannot execute query, no callback was specified";
            success = success || angular.noop;
            error = error || angular.noop;
            return this.callback(this.execute(), data, success, error);
        };
        ODataProvider.prototype.single = function(data, success, error) {
            if (!angular.isFunction(this.callback)) throw "Cannot execute get, no callback was specified";
            success = success || angular.noop;
            error = error || angular.noop;
            return this.callback(this.execute(), success, error, true, true);
        };
        ODataProvider.prototype.get = function(data, success, error) {
            if (!angular.isFunction(this.callback)) throw "Cannot execute count, no callback was specified";
            success = success || angular.noop;
            error = error || angular.noop;
            // The query string from this.execute() should be included even
            //  when fetching just a single element.
            var queryString = this.execute();
            if (queryString.length > 0) {
                queryString = "?" + queryString;
            }
            return this.callback("(" + data + ")" + queryString, success, error, true);
        };

        ODataProvider.prototype.count = function(success, error) {
            if (!angular.isFunction(this.callback)) throw "Cannot execute get, no callback was specified";
            success = success || angular.noop;
            error = error || angular.noop;
            // The query string from this.execute() should be included even
            //  when fetching just a single element.
            var queryString = this.execute();
            if (queryString.length > 0) {
                queryString = "/?" + queryString;
            }

            return this.callback("/$count"+queryString, success, error, true);
        };

        ODataProvider.prototype.withInlineCount = function() {
            this.hasInlineCount = true;
            return this;
        };

        var expandOdatav4 = function(navigationProperties){
        	var first = navigationProperties.shift();
        	var current = first;
        	if(navigationProperties.length>0){
        		current = current + "($expand="+expandOdatav4(navigationProperties)+")";
        	}
        	return current;
        };

        ODataProvider.prototype.expand = function(params) {
            if (!angular.isString(params) && !angular.isArray(params)) {
                throw "Invalid parameter passed to expand method (" + params + ")";
            }
            if (params === "") {
                return;
            }
            var expandQuery = params;
            if (this.isv4) {
            	//Make it an array
            	if (!angular.isArray(params)) {
                    params = Array.prototype.slice.call(arguments);
                }
                expandQuery = expandOdatav4(params);


            } else {
                if (angular.isArray(params)) {
                    expandQuery = params.join('/');
                } else {
                    expandQuery = Array.prototype.slice.call(arguments).join('/');
                }
                for (var i = 0; i < this.expandables.length; i++) {
                    if (this.expandables[i] === expandQuery) return this;
                }
            }

            this.expandables.push(expandQuery);
            return this;
        };


        ODataProvider.prototype.select = function(params) {
            if (!angular.isString(params) && !angular.isArray(params)) {
                throw "Invalid parameter passed to select method (" + params + ")";
            }

            if (params === "") {
                return;
            }

            var selectQuery = params;

            if (!angular.isArray(params)) {
                params = Array.prototype.slice.call(arguments);
            }

            for (var i = params.length - 1; i >= 0; i--) {
                    this.selectables.push(params[i]);
            }

            return this;
        };

        return ODataProvider;
    }
]);;/**
 * @license AngularJS v1.3.15
 * (c) 2010-2014 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {
  'use strict';

  var $resourceMinErr = angular.$$minErr('$resource');

  // Helper functions and regex to lookup a dotted path on an object
  // stopping at undefined/null.  The path must be composed of ASCII
  // identifiers (just like $parse)
  var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;

  function isValidDottedPath(path) {
    return (path !== null && path !== '' && path !== 'hasOwnProperty' &&
      MEMBER_NAME_REGEX.test('.' + path));
  }

  function lookupDottedPath(obj, path) {
    if (!isValidDottedPath(path)) {
      throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
    }
    var keys = path.split('.');
    for (var i = 0, ii = keys.length; i < ii && obj !== undefined; i++) {
      var key = keys[i];
      obj = (obj !== null) ? obj[key] : undefined;
    }
    return obj;
  }

  /**
   * Create a shallow copy of an object and clear other fields from the destination
   */
  function shallowClearAndCopy(src, dst) {
    dst = dst || {};

    angular.forEach(dst, function(value, key) {
      delete dst[key];
    });

    for (var key in src) {
      if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }

    return dst;
  }


  angular.module('ODataResources').
  provider('$odataresource', function() {
    var provider = this;

    this.defaults = {
      // Strip slashes by default
      stripTrailingSlashes: true,

      // Default actions configuration
      actions: {
        'get': {
          method: 'GET'
        },
        'save': {
          method: 'POST'
        },
        'query': {
          method: 'GET',
          isArray: true
        },
        'remove': {
          method: 'DELETE'
        },
        'delete': {
          method: 'DELETE'
        },
        'update': {
          method: 'PUT'
        },
        'odata': {
          method: 'GET',
          isArray: true
        }
      }
    };

    this.$get = ['$http', '$q', '$odata',
      function($http, $q, $odata) {

        var noop = angular.noop,
          forEach = angular.forEach,
          extend = angular.extend,
          copy = angular.copy,
          isFunction = angular.isFunction;

        /**
         * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
         * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
         * (pchar) allowed in path segments:
         *    segment       = *pchar
         *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
         *    pct-encoded   = "%" HEXDIG HEXDIG
         *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
         *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
         *                     / "*" / "+" / "," / ";" / "="
         */
        function encodeUriSegment(val) {
          return encodeUriQuery(val, true).
          replace(/%26/gi, '&').
          replace(/%3D/gi, '=').
          replace(/%2B/gi, '+');
        }


        /**
         * This method is intended for encoding *key* or *value* parts of query component. We need a
         * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
         * have to be encoded per http://tools.ietf.org/html/rfc3986:
         *    query       = *( pchar / "/" / "?" )
         *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
         *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
         *    pct-encoded   = "%" HEXDIG HEXDIG
         *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
         *                     / "*" / "+" / "," / ";" / "="
         */
        function encodeUriQuery(val, pctEncodeSpaces) {
          return encodeURIComponent(val).
          replace(/%40/gi, '@').
          replace(/%3A/gi, ':').
          replace(/%24/g, '$').
          replace(/%2C/gi, ',').
          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
        }

        function Route(template, defaults) {
          this.template = template;
          this.defaults = extend({}, provider.defaults, defaults);
          this.urlParams = {};
        }

        Route.prototype = {
          setUrlParams: function(config, params, actionUrl, data, isOData) {
            var self = this,
              url = actionUrl || self.template,
              val,
              encodedVal;



            if (url === self.template &&
              (config.method === 'PUT' ||
              config.method === 'DELETE' ||
              (config.method == 'GET' && !isOData) ||
              config.method == 'PATCH') && angular.isString(self.defaults.odatakey)) {

            // strip trailing slashes and set the url (unless this behavior is specifically disabled)
            if (self.defaults.stripTrailingSlashes) {
              url = url.replace(/\/+$/, '') || '/';
            }

              url = url + '(:' + self.defaults.odatakey + ')';

              if (data) {
                params[self.defaults.odatakey] = data[self.defaults.odatakey];
              }
            }

            var urlParams = self.urlParams = {};
            forEach(url.split(/\W/), function(param) {
              if (param === 'hasOwnProperty') {
                throw $resourceMinErr('badname', "hasOwnProperty is not a valid parameter name.");
              }
              if (!(new RegExp("^\\d+$").test(param)) && param &&
                (new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url))) {
                urlParams[param] = true;
              }
            });
            url = url.replace(/\\:/g, ':');

            params = params || {};
            forEach(self.urlParams, function(_, urlParam) {
              val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
              if (angular.isDefined(val) && val !== null) {
                encodedVal = encodeUriSegment(val);
                url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function(match, p1) {
                  return encodedVal + p1;
                });
              } else {
                url = url.replace(new RegExp("(\/?):" + urlParam + "(\\W|$)", "g"), function(match,
                  leadingSlashes, tail) {
                  if (tail.charAt(0) == '/') {
                    return tail;
                  } else {
                    return leadingSlashes + tail;
                  }
                });
              }
            });

            // strip trailing slashes and set the url (unless this behavior is specifically disabled)
            if (self.defaults.stripTrailingSlashes) {
              url = url.replace(/\/+$/, '') || '/';
            }


            // then replace collapse `/.` if found in the last URL path segment before the query
            // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
            url = url.replace(/\/\.(?=\w+($|\?))/, '.');
            // replace escaped `/\.` with `/.`
            config.url = url.replace(/\/\\\./, '/.');


            // set params - delegate param encoding to $http
            forEach(params, function(value, key) {
              if (!self.urlParams[key]) {
                config.params = config.params || {};
                config.params[key] = value;
              }
            });
          }
        };


        function resourceFactory(url, paramDefaults, actions, options) {
          options = options || {};

          if (angular.isString(paramDefaults)) {
            options.odatakey = paramDefaults;
            paramDefaults = {};
          }

          var route = new Route(url, options);

          actions = extend({}, provider.defaults.actions, actions);

          function extractParams(data, actionParams) {
            var ids = {};
            actionParams = extend({}, paramDefaults, actionParams);
            forEach(actionParams, function(value, key) {
              if (isFunction(value)) {
                value = value();
              }
              ids[key] = value && value.charAt && value.charAt(0) == '@' ?
                lookupDottedPath(data, value.substr(1)) : value;
            });
            return ids;
          }

          function defaultResponseInterceptor(response) {
            return response.resource;
          }

          function Resource(value) {
            shallowClearAndCopy(value || {}, this);
          }

          Resource.prototype.toJSON = function() {
            var data = extend({}, this);
            delete data.$promise;
            delete data.$resolved;
            return data;
          };

          forEach(actions, function(action, name) {

            var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);

            Resource[name] = function(a1, a2, a3, a4, isOdata, odataQueryString, isSingleElement,forceSingleElement) {
              var params = {}, data, success, error;

              /* jshint -W086 */
              /* (purposefully fall through case statements) */
              switch (arguments.length) {
                case 8:
                case 7:
                case 6:
                case 4:
                  error = a4;
                  success = a3;
                  //fallthrough
                case 3:
                case 2:
                  if (isFunction(a2)) {
                    if (isFunction(a1)) {
                      success = a1;
                      error = a2;
                      break;
                    }

                    success = a2;
                    error = a3;
                    //fallthrough
                  } else {
                    params = a1;
                    data = a2;
                    success = a3;
                    break;
                  }
                case 1:
                  if (isFunction(a1)) success = a1;
                  else if (hasBody) data = a1;
                  else params = a1;
                  break;
                case 0:
                  break;
                default:
                  throw $resourceMinErr('badargs',
                    "Expected up to 4 arguments [params, data, success, error], got {0} arguments",
                    arguments.length);
              }
              /* jshint +W086 */
              /* (purposefully fall through case statements) */

              var isInstanceCall = this instanceof Resource;
              var value = isInstanceCall ? data : ((!isSingleElement && action.isArray) ? [] : new Resource(data));
              var httpConfig = {};
              var responseInterceptor = action.interceptor && action.interceptor.response ||
                defaultResponseInterceptor;
              var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
                undefined;

              forEach(action, function(value, key) {
                if (key != 'params' && key != 'isArray' && key != 'interceptor') {
                  httpConfig[key] = copy(value);
                }
              });

              if (hasBody) httpConfig.data = data;


              route.setUrlParams(httpConfig,
                extend({}, extractParams(data, action.params || {}), params),
                action.url,
                data,
                isOdata);

              if (isOdata && odataQueryString !== "" && (!isSingleElement || forceSingleElement)) {
                httpConfig.url += "?" + odataQueryString;
              } else if (isOdata && odataQueryString !== "" && isSingleElement) {
                httpConfig.url += odataQueryString;
              }

              var promise = $http(httpConfig).then(function(response) {
                var data = response.data,
                  promise = value.$promise;

                if(data && angular.isNumber(data['@odata.count'])) {
                    data.count = data['@odata.count'];
                }

                if (data && angular.isString(data['@odata.context']) && data.value && angular.isArray(data.value)) {
                  var fullObject = data;
                  data = data.value;
                  for (var property in fullObject) {
                    if (property !== "value") {
                      value[property] = fullObject[property];

                    }
                  }
                }


                if (data) {
                  // Need to convert action.isArray to boolean in case it is undefined
                  // jshint -W018
                  if (angular.isArray(data) !== (!isSingleElement && !! action.isArray) && !forceSingleElement) {
                    throw $resourceMinErr('badcfg',
                      'Error in resource configuration for action `{0}`. Expected response to ' +
                      'contain an {1} but got an {2} (Request: {3} {4})', name, (!isSingleElement && action.isArray) ? 'array' : 'object',
                      angular.isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
                  }

                  if(angular.isArray(data) && forceSingleElement){
                    if(data.length>0){
                      data = data[0];
                    }else{
                      throw "The response returned no result";
                    }
                  }

                  // jshint +W018
                  if (!isSingleElement && action.isArray && isNaN(parseInt(data))) {
                    value.length = 0;
                    forEach(data, function(item) {
                      if (typeof item === "object") {
                        value.push(new Resource(item));
                      } else {
                        // Valid JSON values may be string literals, and these should not be converted
                        // into objects. These items will not have access to the Resource prototype
                        // methods, but unfortunately there
                        value.push(item);
                      }
                    });
                  } else {
                    shallowClearAndCopy(data, value);
                    value.$promise = promise;
                  }
                }

                if(angular.isNumber(data) && isSingleElement){
                  value.result = data;
                }
                else if(!isNaN(parseInt(data)) && isSingleElement){
                  value.result = parseInt(data);
                }

                value.$resolved = true;

                response.resource = value;

                return response;
              }, function(response) {
                value.$resolved = true;

                (error || noop)(response);

                return $q.reject(response);
              });

              promise = promise.then(
                function(response) {
                  var value = responseInterceptor(response);
                  (success || noop)(value, response.headers);
                  return value;
                },
                responseErrorInterceptor);

              if (!isInstanceCall) {
                // we are creating instance / collection
                // - set the initial promise
                // - return the instance / collection
                value.$promise = promise;
                value.$resolved = false;

                return value;
              }

              // instance call
              return promise;
            };


            Resource.prototype['$' + name] = function(params, success, error) {
              if (isFunction(params)) {
                error = success;
                success = params;
                params = {};
              }
              var result = Resource[name].call(this, params, this, success, error);
              return result.$promise || result;
            };
          });

          var oldOdataResource = Resource.odata;
          Resource.odata = function() {
            var onQuery = function(queryString, data, success, error, isSingleElement,forceSingleElement) {
              return oldOdataResource(data || {}, {}, success, error, true, queryString, isSingleElement,forceSingleElement);
            };


            return new $odata.Provider(onQuery,options.isodatav4);
          };

          Resource.bind = function(additionalParamDefaults) {
            return resourceFactory(url, extend({}, paramDefaults, additionalParamDefaults), actions);
          };

          return Resource;
        }

        return resourceFactory;
      }
    ];
  });


})(window, window.angular);;angular.module('ODataResources').
factory('$odata', ['$odataBinaryOperation','$odataProvider','$odataValue',
	'$odataProperty','$odataMethodCall','$odataPredicate','$odataOrderByStatement',
	function(ODataBinaryOperation,ODataProvider,ODataValue,ODataProperty,ODataMethodCall,ODataPredicate,ODataOrderByStatement) {

		return {
			Provider : ODataProvider,
			BinaryOperation : ODataBinaryOperation,
			Value : ODataValue,
			Property : ODataProperty,
			Func : ODataMethodCall,
			Predicate : ODataPredicate,
			OrderBy : ODataOrderByStatement,
		};

	}]);

(function () {
	"use strict";

	function formatRecursoAcao(recurso, acao) {
		return (recurso + "." + acao).toUpperCase();
	}

	angular.module('epbxManagerApp')
		.service('PermissaoService', ["$rootScope", "AuthService", "AUTH_EVENTS", "$filter", function PermissaoService($rootScope, AuthService, AUTH_EVENTS, $filter) {
			var service = {};
			var isLogado = false;
			var permissoes = {};

			var fillPermissoes = function () {
				var usuario = AuthService.getUsuarioLogado();
				if (usuario) {
					isLogado = true;
					permissoes = {};
					angular.forEach(usuario.Permissoes || [], function (value) {
						permissoes[formatRecursoAcao(value.Recurso, value.Acao)] = true;
					});
				}
			}

			$rootScope.$on(AUTH_EVENTS.userAuthenticated, function () {
				isLogado = true;
				fillPermissoes();
			});

			$rootScope.$on(AUTH_EVENTS.userLogout, function () {
				isLogado = false;
				permissoes = {};
			});

			fillPermissoes();

			service.checkAccess = function checkAccess(recurso, acao) {
				return angular.isDefined(permissoes[formatRecursoAcao(recurso, acao)]);
			};

			service.checkPageAccess = function (toState) {
				var permissions, recurso, acao, split;

				if (toState.data && toState.data.permissions) {
					// configuração da rota/state possui configuração de permissão
					permissions = toState.data.permissions;

					// se a rota permitir AllowAnonymous, permitir qualquer acesso
					if (permissions.AllowAnonymous) return true;

					// se a rota permitir AllowAll, permitir qualquer acesso autenticado
					if (permissions.AllowAll) return isLogado;

					// identificar se o usuário possui permissão a algum recurso/acao configurado na rota
					for (recurso in permissions) {
						if (service.checkAccess(recurso, permissions[recurso])) return true;
					}

					return false;
				} else {
					// a rota/state não possui configuração de acesso. Inferir recurso e acao pelo nome do state
					split = toState.name.split(".");
					if (split.length == 2) {
						recurso = $filter('capitalize')(split[0]);
						acao = $filter('capitalize')(split[1]);
					}
					if (split.length == 3) {
						recurso = $filter('capitalize')(split[1]);
						acao = $filter('capitalize')(split[2]);
					}

					if (acao === "List") acao = "Visualizar";
					else if (acao === "Edit" || acao === "New") acao = "Cadastrar";

					return service.checkAccess(recurso, acao);
				}
			}
			return service;
		}]);
	})
();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .constant('SIGNALR_EVENTS', {
            reconnected: "onSignalrReconnected",
            disconnected: "onSignalrDisconnected",
            connected: "onSignalrConnected",
            connectionSlow: "onSignalrConnectionSlow",
            reconnecting: "onSignalrReconnecting"
        })
        .service('SignalrConnection', ["$rootScope", "$q", "$timeout", "Config", "AuthService", "AUTH_EVENTS", "SIGNALR_EVENTS", "PrintToConsole", function ($rootScope, $q, $timeout, Config, AuthService, AUTH_EVENTS, SIGNALR_EVENTS, PrintToConsole) {
            var initPromise, initExecuted = false;

            var service = {
                reconnectTimer: 5000, // 5 segundos
                connected: false,
                stopRequested: false,
                atendimentoHubClient: {},
                messageBusHubClient: {},
                supervisaoHubClient: {}
            }

            var autoReconnect = function autoReconnect() {
                PrintToConsole.debug("SignalrConnection: autoReconnect");
                initPromise = null;

                if (service.stopRequested) return $q.reject("Logoff solicitado");

                var lastError = service.connection.hub.lastError;
                var startFunction = service.start;
                var delayedStartFunction = function () {
                    $timeout(startFunction, service.reconnectTimer);
                }

                if (lastError) {
                    // eslint-disable-next-line no-console
                    console.log(service.connection.hub.lastError);
                    if (lastError.message && lastError.message.indexOf('Error during negotiation request') > -1) {
                        startFunction = function () {
                            return AuthService.updateRefreshToken().then(service.start).catch(delayedStartFunction);
                        }
                    }
                }

                delayedStartFunction();

                // retorna uma promise rejeitada, mesmo fazendo a reconexão automatica, 
                // para que não entre em loop de erro ao conectar no signalr indisponivel
                return $q.reject(service.connection.hub.lastError);
            }

            var broadcastEvent = function (eventName) {
                if (!service.stopRequested) {
                    $timeout(function () {
                        PrintToConsole.debug("SignalrConnection: " + eventName);
                        $rootScope.$broadcast(eventName, {});
                    });
                }
            };

            service.init = function init() {
                if (initExecuted) return;

                service.connection = $.connection;
                service.connection.hub.url = Config.getUrlSignalR();
                service.connection.hub.logging = Config.isDebug();
                service.connection.hub.qs = { 'access_token': AuthService.getAccessToken() };
                service.messageBusProxy = service.connection.messageBusHub;
                service.atendimentoProxy = service.connection.atendimentoHub;
                service.supervisaoProxy = service.connection.supervisaoHub;

                // 
                service.connection.messageBusHub.client.noop = angular.noop;
                service.connection.atendimentoHub.client.noop = angular.noop;
                service.connection.supervisaoHub.client.noop = angular.noop;

                service.connection.hub.disconnected(function () {
                    if (!service.stopRequested) {
                        service.connected = false;
                        broadcastEvent(SIGNALR_EVENTS.disconnected);
                        autoReconnect();
                    }
                });
                service.connection.hub.reconnected(function () {  broadcastEvent(SIGNALR_EVENTS.reconnected);  });
                service.connection.hub.connectionSlow(function () { broadcastEvent(SIGNALR_EVENTS.connectionSlow);  });
                service.connection.hub.reconnecting(function () { broadcastEvent(SIGNALR_EVENTS.reconnecting); });

                $rootScope.$on(AUTH_EVENTS.userLogout, service.stop);

                $rootScope.$on(AUTH_EVENTS.tokenChanged, function () {
                    // Alterar autenticação do signalr quando o token de acesso for alterado (apos o refresh token por exemplo)
                    if (service.connection) service.connection.hub.qs = { 'access_token': AuthService.getAccessToken() };
                });

                initExecuted = true;
            }

            service.start = function start() {
                if (initPromise) return initPromise;

                var deferred = $q.defer();

                service.stopRequested = false;
                service.init();
                service.connection.hub.start(deferred.resolve, deferred.reject);

                deferred.promise.then(service.postConnection).catch(autoReconnect);

                initPromise = deferred.promise;

                return deferred.promise;
            }

            service.postConnection = function postConnection() {
                service.connected = true;
                PrintToConsole.debug("SignalrConnection: postConnection");
                broadcastEvent(SIGNALR_EVENTS.connected);
            }

            service.stop = function stop() {
                service.stopRequested = true;
                if (service.connected) {
                    service.connection.hub.stop();
                    service.connection.hub.qs = {};
                    service.connected = false;
                }
            }
            return service;
        }]);
    })
();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('SoftphoneService', ["$rootScope", "$window", "$location", function FileDownloadService($rootScope, $window, $location) {
            let service = {};
            let ramallogado = false;
            let urlBaseWebFone = null;
            let urlAtendimento = $location.absUrl();

            // Lista de origens permitidas
            let allowedOrigins = [
                'http://localhost:4200' // para desenvolvimento
            ];


            // Ouvir mensagens do iframe id='softphone'
            // Na verdade o meu projeto Talk.WebFone
            // envia as mensagens para o pai (parent)
            // via window.parent.postMessage(...)
            function receicedMessageFromWebFone(event) {

                // 🔐 Validação de origem
                if (!allowedOrigins.includes(event.origin)) return;

                const message = event.data;

                if (!message || !message.type || !message.data) {
                    consoleLog('receicedMessageFromWebFone() - Message is invalid!');
                    return;
                }

                consoleLog('📥 receicedMessageFromWebFone');
                consoleLog(`🔸 Tipo: ${message.type ? message.type : 'DESCONHECIDO'}`);

                switch (message.type) {

                    case 'RegistererState':
                    case 'WebrtcState':
                        consoleLog(`🔸 State: ${message.data.state}`);
                        consoleLog(`🔸 Reason: ${message.data.reason}`);

                        $rootScope.$broadcast(
                            `softphone:${message.type}`,
                            message.data
                        );
                        break;

                    default:
                        consoleLog(`⚠️ Tipo de mensagem não tratado: ${message.type}`);
                }
            }

            function consoleLog(message) {

                let timestamp = new Date().toLocaleTimeString();
                console.log(`[${timestamp}] ${message}`);
            }

            service.registrar = function (urlBase, websocketUrl, ctiServer, ramal, senha, debug) {

                if (!urlBase) {
                    urlBase = "https://talkfone.vercel.app";
                }

                let existe = allowedOrigins.filter(item => item == urlBase);
                if (!existe) {
                    allowedOrigins.push(urlBase);
                }

                urlBaseWebFone = new URL(urlBase).origin;
                if (urlBaseWebFone) {
                    allowedOrigins.push(urlBaseWebFone);
                }

                if (!websocketUrl) {
                    websocketUrl = "wss2.talkcomm.com.br:10081";
                }

                // Codificar caracteres especiais na senha
                const senhaCodificada = encodeURIComponent(senha);
                const ramalCodificado = encodeURIComponent(ramal);
                const ctiServerCodificado = encodeURIComponent(ctiServer);

                const urlSoftphone = `${urlBase}?webServer=${websocketUrl}&ctiServer=${ctiServerCodificado}&usuarioSip=${ramalCodificado}&senhaSip=${senhaCodificada}&autoAtendimento=true&urlAtendimento=${urlAtendimento}&maxconnectionAttemptListServer=2`;

                const timestamp = new Date().toLocaleTimeString();
                console.log(`[${timestamp}] urlSoftphone : ${urlSoftphone}`);

                // Remover iframe existente
                if (this.ramallogado) {
                    $("#softphone").remove();
                    this.ramallogado = false;
                }

                if (!this.ramallogado) {
                    // Adicionar listener para aguardar o registro TalkFone
                    $window.addEventListener('message', receicedMessageFromWebFone);

                    if (debug) {
                        window.open(urlSoftphone, "_blank", "allow='microphone'");
                    } else {
                        // Aguardar o DOM estar pronto
                        angular.element(document).ready(function () {
                            // Verificar se o elemento #divSoftphone existe
                            const divSoftphone = document.getElementById('divSoftphone');
                            if (!divSoftphone) {
                                console.error('Elemento #divSoftphone não encontrado no DOM');
                                return;
                            }

                            // Criar iframe corretamente
                            const iframe = document.createElement('iframe');
                            iframe.id = 'softphone';
                            iframe.src = urlSoftphone;
                            iframe.setAttribute('allow', 'microphone');
                            iframe.style.display = 'none';

                            // Adicionar ao DOM
                            divSoftphone.appendChild(iframe);

                            // Adicionar event listener para debug
                            iframe.onload = function () {
                            };

                            iframe.onerror = function (error) {
                                console.error('❌ Erro ao carregar iframe:', error);
                            };
                        });
                    }

                    this.ramallogado = true;
                }
            }

            service.desconectar = function () {
                if (this.ramallogado) {
                    $("#softphone").remove();
                    this.ramallogado = false;
                }
            }

            // Enviar mensagem para o iframe id='softphone'
            service.sendMessageToIframe = function (message) {
                const iframe = document.getElementById('softphone');
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage(message, '*');
                }
            }

            // Remova quando não for mais necessário (importante!)
            // Esquecer de remover listeners → Vazamento de memória
            service.removereceicedMessageFromWebFone = function () {
                $window.removeEventListener('message', receicedMessageFromWebFone);
            }

            return service;
        }]
        );
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .constant('SUPERVISAO_EVENTS', {
            onMonitoraChamada: "onSupervisaoMonitoraChamada",
            onMonitoraChamadaErro: "onSupervisaoMonitoraChamadaErro",
            onFimMonitoracao: "onSupervisaoFimMonitoracao",
            onDesligaChamada: "onSupervisaoDesligaChamada",
            onChamadaEntrouNaFilaRamal: "onChamadaEntrouNaFilaRamal",
            onChamadaSaiuDaFilaRamal: "onChamadaSaiuDaFilaRamal",
            onChamadaEntrouNaFilaGrupo: "onChamadaEntrouNaFilaGrupo",
            onChamadaSaiuDaFilaGrupo: "onChamadaSaiuDaFilaGrupo",
            onSupervisaoDesconectado: "onSupervisaoDesconectado",
            onSupervisaoConectado: "onSupervisaoConectado",
            onFimEscutaDialogo: "onFimEscutaDialogo",
            onRamalEmSilencio: "onRamalEmSilencio"
        })

        .service('SupervisaoService', ["$rootScope", "$q", "$timeout", "SignalrConnection", "Config", "SUPERVISAO_EVENTS", "PrintToConsole", function ($rootScope, $q, $timeout, SignalrConnection, Config, SUPERVISAO_EVENTS, PrintToConsole) {
            var supervisaoProxy, initExecuted = false,
                fnOnMonitoraChamadaErroEvent = function (err) {
                    raiseEventCancelChamada(SUPERVISAO_EVENTS.onMonitoraChamadaErro)(err);
                    return err;
                },
                service = {
                    isChamadaAtiva: false,
                    ramalMonitoria: 0,
                    conferencia: function (ramal) {
                        service.isChamadaAtiva = true;
                        service.ramalMonitoria = ramal;
                        return service.monitorarChamada(ramal, SignalrConnection.supervisaoProxy.TipoMonitoracao.Conferencia).catch(fnOnMonitoraChamadaErroEvent);
                    },
                    ouvirChamada: function (ramal) {
                        service.isChamadaAtiva = true;
                        service.ramalMonitoria = ramal;
                        return service.monitorarChamada(ramal, SignalrConnection.supervisaoProxy.TipoMonitoracao.MonitorarConferencia).catch(fnOnMonitoraChamadaErroEvent);
                    },
                    sopro: function (ramal) {
                        service.isChamadaAtiva = true;
                        service.ramalMonitoria = ramal;
                        return service.monitorarChamada(ramal, SignalrConnection.supervisaoProxy.TipoMonitoracao.Sopro).catch(fnOnMonitoraChamadaErroEvent);
                    }
                };

            var raiseEventCancelChamada = function (eventName) {
                var raiseEventFunction = raiseEvent(eventName);
                return function () {
                    service.isChamadaAtiva = false;
                    raiseEventFunction.apply(service, arguments);
                }
            }

            var raiseEvent = function (eventName) {
                return function () {
                    var args = arguments; // arguments recebidos do SupervisaoHub
                    $timeout(function () {
                        PrintToConsole.debug("evento supervisao: " + eventName);
                        PrintToConsole.debug(args);
                        var argsArray = [eventName];
                        angular.forEach(args, function (value) {
                            argsArray.push(value);
                        });
                        $rootScope.$broadcast.apply($rootScope, argsArray);
                    })
                };
            }

            var callHubMethod = function (hubMethod) {
                return function () {
                    var deferred = $q.defer(), args = arguments;
                    var methodCall = function () {
                        supervisaoProxy.server[hubMethod]
                            .apply(supervisaoProxy.server, args)
                            .done(deferred.resolve)
                            .fail(deferred.reject);
                        return deferred.promise;
                    }

                    // antes de chamar um metodo no hub, é necessário conectar no signalr
                    if (SignalrConnection.connected) {
                        if (!initExecuted) service.init();

                        return methodCall().catch(function (err) {
                            // eslint-disable-next-line no-console
                            console.error(err);

                            var errorMessage = (err && err.message) || '';
                            if (errorMessage.indexOf('Connection must be started before') > -1
                                || errorMessage.indexOf('disconnected before invocation') > -1) {
                                SignalrConnection.connected = false;
                                // eslint-disable-next-line no-console
                                console.log('reconectando...')
                                return service.start().then(service.init).then(methodCall)
                            }

                            throw err;
                        });
                    }
                    return service.start().then(service.init).then(methodCall);
                }
            }

            // disponibilizar todas as funcoes do hub na api do service javascript (discar, intervalo, desligar, etc)
            service.iniciar = callHubMethod("iniciar");
            service.parar = callHubMethod("parar");
            service.monitorarChamada = callHubMethod("monitorarChamada");
            service.encerrarMonitoracao = callHubMethod("encerrarMonitoracao");
            service.discarExterno = callHubMethod("discarExterno");

            // desligar chamada em andamento em um Ramal
            service.desligarChamada = callHubMethod("desligarChamada");
            service.enviarMensagem = callHubMethod("enviarMensagem");
            service.listarRamalStatus = callHubMethod("listarRamalStatus");
            service.iniciarIntervalo = callHubMethod("iniciarIntervalo");
            service.dataAtual = callHubMethod("dataAtual");
            service.transferirChamadaEmFila = callHubMethod("transferirChamadaEmFila");
            service.desligarChamadaEmFila = callHubMethod("desligarChamadaEmFila");
            service.listarStatusRamais = callHubMethod("listarStatusRamais");
            service.getInfoCanais = callHubMethod("getInfoCanais");
            service.ouvirDialogo = callHubMethod("ouvirDialogo");
            service.pausarDialogo = callHubMethod("pausarDialogo");
            service.pararDialogo = callHubMethod("pararDialogo");
            service.cancelarAlarme = callHubMethod("cancelarAlarme");
            service.deslogarRamal = callHubMethod("deslogarRamal");

            service.init = function () {
                supervisaoProxy = SignalrConnection.supervisaoProxy;
                // usando a notação proxy.on(event, function) , ao invés de proxy.client.event, 
                // pois o signalR ignora eventos inseridos da segunda forma, após a conexão ter sido estabelecida.
                // Como a conexão poderá ser estabelecida antes, pelo MessageBus, precisamos usar a primeira forma,
                // que atualizará corretamente o listener de eventos
                supervisaoProxy.on("onMonitoraChamada", raiseEvent(SUPERVISAO_EVENTS.onMonitoraChamada));
                supervisaoProxy.on("onMonitoraChamadaErro", raiseEventCancelChamada(SUPERVISAO_EVENTS.onMonitoraChamadaErro));
                supervisaoProxy.on("onFimMonitoracao", raiseEvent(SUPERVISAO_EVENTS.onFimMonitoracao));
                supervisaoProxy.on("onDesligaChamada", raiseEvent(SUPERVISAO_EVENTS.onDesligaChamada));
                supervisaoProxy.on("onSupervisaoDesconectado", raiseEvent(SUPERVISAO_EVENTS.onSupervisaoDesconectado));
                supervisaoProxy.on("onSupervisaoConectado", raiseEvent(SUPERVISAO_EVENTS.onSupervisaoConectado));
                supervisaoProxy.on("onChamadaEntrouNaFilaRamal", raiseEventCancelChamada(SUPERVISAO_EVENTS.onChamadaEntrouNaFilaRamal));
                supervisaoProxy.on("onChamadaSaiuDaFilaRamal", raiseEvent(SUPERVISAO_EVENTS.onChamadaSaiuDaFilaRamal));
                supervisaoProxy.on("onChamadaEntrouNaFilaGrupo", raiseEventCancelChamada(SUPERVISAO_EVENTS.onChamadaEntrouNaFilaGrupo));
                supervisaoProxy.on("onChamadaSaiuDaFilaGrupo", raiseEventCancelChamada(SUPERVISAO_EVENTS.onChamadaSaiuDaFilaGrupo));
                supervisaoProxy.on("onFimEscutaDialogo", raiseEvent(SUPERVISAO_EVENTS.onFimEscutaDialogo));
                supervisaoProxy.on("onRamalEmSilencio", raiseEvent(SUPERVISAO_EVENTS.onRamalEmSilencio));

                service.TipoDiscagem = SignalrConnection.atendimentoProxy.TipoDiscagem;

                initExecuted = true;
            }

            service.start = function start() {
                SignalrConnection.init();
                service.init();
                return SignalrConnection.start();
            }

            service.stop = function stop() {
                return SignalrConnection.stop();
            }

            return service;
        }])
})();


(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service("TranslateService", ["$rootScope", "$translate", "$state", "$http", "LocalStorageService", "ConfiguracaoResource", "TtsService", function ($rootScope, $translate, $state, $http, LocalStorageService, ConfiguracaoResource, TtsService) {
            const service = {};
            let configuracaoFinalizada = false;

            const defaultLanguage = 'pt';

            const configurar = (configServidor) => {
                LocalStorageService.setItem('oktaHabilitado', configServidor.OktaHabilitado, true);
                LocalStorageService.setItem('lgpdHabilitado', configServidor.LGPDHabilitado, true);

                LocalStorageService.setItem('PermiteAlterarProvedor', configServidor.PermiteAlterarProvedor, true);
                LocalStorageService.setItem('ProvedorDefault', configServidor.ProvedorDefault, true);
                LocalStorageService.setItem('VozDefault', configServidor.VozDefault, true);

                if (!configServidor.Ativo) {
                    LocalStorageService.setItem('idiomaConfig', { ativo: false }, true);
                    $translate.use(defaultLanguage);
                } else {
                    const idiomaConfig = LocalStorageService.getItem('idiomaConfig');
                    const idiomaPreferido = $translate.preferredLanguage();
                    const newConfig = { ativo: true };

                    if (idiomaConfig.idioma == null) {
                        $translate.use(idiomaPreferido);
                        newConfig.idioma = idiomaPreferido;
                    } else if (idiomaConfig.idioma != idiomaPreferido) {
                        $translate.use(idiomaConfig.idioma);
                        newConfig.idioma = idiomaConfig.idioma;
                    }

                    newConfig.idiomaPadrao = configServidor.Idioma;
                    LocalStorageService.setItem('idiomaConfig', newConfig, true);
                    LocalStorageService.setItem('idioma', newConfig.idiomaPadrao);
                }
                configuracaoFinalizada = true;
                $http.defaults.headers.common['Accept-Language'] = service.getCulture();
                $rootScope.$broadcast('idiomaConfigurado');
            };

            service.verificarConfiguracao = () => configuracaoFinalizada;

            service.inicializar = () => {
                ConfiguracaoResource.getI18N().$promise.then(configurar);
            };

            service.alterarIdioma = (idioma) => {
                const idiomaConfig = LocalStorageService.getItem('idiomaConfig');
                idiomaConfig.idioma = idioma;
                LocalStorageService.setItem('idiomaConfig', idiomaConfig, true);
                LocalStorageService.setItem('idioma', idioma);
                $translate.use(idioma).then(() => {
                    $http.defaults.headers.common['Accept-Language'] = service.getCulture();
                    $state.reload().then(() => $translate.refresh);
                });

                recarregarVoztts();
                
            };

            function recarregarVoztts()
            {
                TtsService.getVozes();
                TtsService.setProvedores()
            };

            service.getIdiomaIdAtual = () => {
                let idiomaAtual = service.getIdiomaAtual();
                switch (idiomaAtual) {
                    case 'pt': return 1;
                    case 'es': return 2;
                    case 'en': return 3;
                }
            };

            service.getI18NAtivo = () => {
                const idiomaConfig = LocalStorageService.getItem('idiomaConfig');
                return idiomaConfig.ativo;
            };

            service.getIdiomaAtual = () => {
                var idiomaConfig = LocalStorageService.getItem('idiomaConfig');
                var idiomaAtual = idiomaConfig.idioma? idiomaConfig.idioma : defaultLanguage;
                return idiomaAtual;
            };

            service.getCulture = () => { 
                let idiomaId = service.getIdiomaAtual();
                switch (idiomaId) {
                    case 'pt': return 'pt-BR';
                    case 'es': return 'es-MX';
                    case 'en': return 'en-US';
                }
            }

            service.getOktaHabilitado = () => {
                return LocalStorageService.getItem('oktaHabilitado');
            };

            service.getLGPDHabilitado = ()=> {
                return LocalStorageService.getItem('lgpdHabilitado');
            };

            service.getMomentDateFormat = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'DD/MM/YYYY';
                    case 'es': return 'DD/MM/YYYY';
                    case 'en': return 'MM/DD/YYYY';
                }
            }

            service.getMomentTimeFormat = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'HH:mm';
                    case 'es': return 'hh:mm A';
                    case 'en': return 'hh:mm A';
                }
            }

            service.getMomentDateTimeFormatWithSeconds = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'DD/MM/YYYY HH:mm:ss';
                    case 'es': return 'DD/MM/YYYY hh:mm:ss A';
                    case 'en': return 'MM/DD/YYYY hh:mm:ss A';
                }
            }

            service.getAngularDateTimeFormatWithSeconds = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'dd/MM/yyyy HH:mm:ss';
                    case 'es': return 'dd/MM/yyyy hh:mm:ss a';
                    case 'en': return 'MM/dd/yyyy hh:mm:ss a';
                }
            }

            service.getAngularDateTimeFormat = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'dd/MM/yyyy HH:mm';
                    case 'es': return 'dd/MM/yyyy hh:mm a';
                    case 'en': return 'MM/dd/yyyy hh:mm a';
                }
            }

            service.getAngularDateFormat = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'dd/MM/yyyy';
                    case 'es': return 'dd/MM/yyyy';
                    case 'en': return 'MM/dd/yyyy';
                }
            }

            service.getAngularTimeFormat = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'HH:mm';
                    case 'es': return 'hh:mm a';
                    case 'en': return 'hh:mm a';
                }
            }

            service.getAngularTimeFormatWithSeconds = () => {
                let idioma = service.getIdiomaAtual();
                switch (idioma) {
                    case 'pt': return 'HH:mm:ss';
                    case 'es': return 'hh:mm:ss a';
                    case 'en': return 'hh:mm:ss a';
                }
            }

            return service;
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('TtsService', ["GeraAudioTtsResource", "LocalStorageService", "$rootScope", function FileDownloadService(GeraAudioTtsResource, LocalStorageService, $rootScope) {
            let service = {};
            var vozes = [];

            service.setProvedores = function () {
                GeraAudioTtsResource.getProvedores().$promise
                    .then((result) => {
                        localStorage.removeItem('tts_provedor');
                        localStorage.setItem('tts_provedor', JSON.stringify(result));
                    }).catch(erro => { console.error(erro); });
            }

            service.getVozes = function (provedor) {
                let idiomaConfig = LocalStorageService.getItem('idiomaConfig');
                let idioma = 'pt';

                if (idiomaConfig != null && idiomaConfig.idioma != undefined)
                    idioma = idiomaConfig.idioma;

                GeraAudioTtsResource.getAllVozes({ idioma: idioma }).$promise
                    .then((result) => {
                        
                        localStorage.removeItem('tts_Vozes');
                        localStorage.setItem('tts_Vozes', JSON.stringify(result));

                    }).catch(vozes = []);
            }

            service.getVoz = function() {
                return localStorage.getItem('tts_Vozes');
            }

            service.getProvedores = function() {
                return localStorage.getItem('tts_provedor');
            }

            return service;
        }]
        );
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UraHelper", ["$translate", function ($translate) {
            var service = {};

            service.buscarNoemUra = function (ura, no) {
                if (ura == null || ura.DadosPlot == no) {
                    return ura;
                } else {
                    if (ura.ChildUra) {
                        for (var i = 0; i < ura.ChildUra.length; i++) {
                            var retornoBusca = service.buscarNoemUra(ura.ChildUra[i], no);
                            if (retornoBusca != null) {
                                return retornoBusca;
                            }
                        }
                    }
                    return null;
                }
            }

            service.buscarIdemUra = function (ura, id) {
                if (ura == null || ura.UraId == id) {
                    return ura;
                } else {
                    if (ura.ChildUra) {
                        for (var i = 0; i < ura.ChildUra.length; i++) {
                            var retornoBusca = service.buscarIdemUra(ura.ChildUra[i], id);
                            if (retornoBusca != null) {
                                return retornoBusca;
                            }
                        }
                    }
                    return null;
                }
            }

            service.tiposUra = [
                { TipoId: 1, Descricao: 'grupo', Alias: $translate.instant('model.grupo') }, 
                { TipoId: 2, Descricao: 'ramal', Alias: $translate.instant('model.ramal') }, 
                { TipoId: 3, Descricao: 'ura', Alias: $translate.instant('model.ura') }, 
                { TipoId: 4, Descricao: 'servico', Alias: $translate.instant('model.servico') }, 
                { TipoId: 5, Descricao: 'menu', Alias: $translate.instant('diretivas.menu') }, 
                { TipoId: 6, Descricao: 'desliga', Alias: $translate.instant('diretivas.desliga') }, 
                { TipoId: 7, Descricao: 'avancado', Alias: $translate.instant('campo.grupo') }, 
                { TipoId: 8, Descricao: 'integracao', Alias: $translate.instant('campo.integracao') }, 
                { TipoId: 9, Descricao: 'higienizacao', Alias: $translate.instant('diretivas.higienizacao') }, 
                { TipoId: 10, Descricao: 'satisfacao', Alias: $translate.instant('pageTitle.satisfacao') }, 
                { TipoId: 11, Descricao: 'pergunta', Alias: $translate.instant('diretivas.pergunta') }, 
                { TipoId: 12, Descricao: 'pabx', Alias: $translate.instant('diretivas.uraPabx') }, 
                { TipoId: 99, Descricao: 'transferencia', Alias: $translate.instant('campo.transferencia') }
            ];

            service.tiposUraRedireciona = [
                { TipoId: 99, Descricao: 'transferencia', Alias: $translate.instant('campo.transferencia') }, 
                { TipoId: 8, Descricao: 'integracao', Alias: $translate.instant('campo.integracao') }, 
                { TipoId: 6, Descricao: 'desliga', Alias: $translate.instant('diretivas.desliga') }, 
                { TipoId: 5, Descricao: 'menu', Alias: $translate.instant('diretivas.menu') }, 
                { TipoId: 98, Descricao: 'repetir', Alias: $translate.instant('diretivas.repetirMenu') }
            ];

            var iconeCor = '#dedede'

            service.iconeTransferencia = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/>    <path d="M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/></svg>';
            service.iconeRamal = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>    <path d="M0 0h24v24H0z" fill="none"/></svg>';
            service.iconeGrupo = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z" /></svg>';
            service.iconeServico = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" /></svg>'
            service.iconeMenu = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z"/></svg>'
            service.iconeUra = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M18,22H6A2,2 0 0,1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22M13,15A2,2 0 0,0 11,17A2,2 0 0,0 13,19A2,2 0 0,0 15,17V12H18V10H14V15.27C13.71,15.1 13.36,15 13,15Z" /></svg>';
            service.iconeDesliga = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13" /></svg>';
            service.iconeIntegracao = '<svg fill="' + iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">    <path d="M0 0h24v24H0z" fill="none"/>    <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"/></svg>';
            service.iconePergunta = '<svg fill="' + iconeCor + '" width="24" height="24" viewBox="0 0 24 24"><path d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"/><path fill="none" d="M0 0h24v24H0z"/></svg>';
            service.iconeFila = '<svg fill="' + iconeCor + '" height="14" viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <defs>        <path d="M0 0h24v24H0V0z" id="a"/>    </defs>    <clipPath id="b">        <use overflow="visible" xlink:href="#a"/>    </clipPath>    <path clip-path="url(#b)" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"/></svg>';
            service.iconeLivre = '<svg fill="' + iconeCor + '" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>    <path d="M0 0h24v24H0z" fill="none"/></svg>';
            service.iconeErro = '<svg fill="' + iconeCor + '" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">    <path d="M0 0h24v24H0z" fill="none"/>    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>';

            // Verifica se os objetos são iguais
            // ATENCAO PARA O NOME DO OBJETO
            // PODE CONTER $ E $$
            // key.indexOf("$")
            service.objectsIsEqual = function (original, edited) {

                if ((!original || !edited) ||
                    (typeof original != typeof edited) ||
                    (original.length && original.length != edited.length)) {
                    return false;
                }
                let isEqual = true;
                let isTruthy = true;

                let isTypeValid = function (param) {
                    let isValid = false;

                    switch (typeof param) {
                        case "object":
                        case "array":
                        case "map":
                            isValid = true;
                            break;
                    }
                    return isValid;
                }

                Object.keys(original).every(key => {
                    // Verificamos se a é null ou undefined
                    if ((edited[key] == null || edited[key] == undefined || !isTypeValid(edited[key])) && key.indexOf("$$") == -1) {
                        if (original[key] != edited[key]) {
                            isEqual = false;
                        }
                    }
                    else if (isTypeValid(edited[key]) && key.indexOf("$") == -1) {
                        isEqual = service.objectsIsEqual(original[key], edited[key]);
                    }
                    if (!isEqual) {
                        isTruthy = false;
                    }
                    return isTruthy;
                });
                return isEqual;
            }

            // Realiza a comparação considerendo a 
            // propriedade diferente de null ou undefined
            // obj2[key] deve ser válido
            service.compareObjExt = function (obj1, obj2) {
                if (!obj1 || !obj2) return false;
                if (typeof obj1 != typeof obj2) return false;
                if (typeof obj1 == 'array' && obj1.length != obj2.length) return false;
                let result = true;
                Object.keys(obj1).forEach(key => {
                    // Em caso do primeiro obj diferente encerramos a recursividade
                    if (!result) {
                        return;
                    }
                    if (obj2[key] && typeof obj2[key] != 'object' && key.indexOf("$$") == -1) {
                        if (obj2[key] && obj1[key] != obj2[key])
                            result = false;
                    }
                    else if (obj2[key] && typeof obj2[key] == 'object') {
                        result = service.compareObjExt(obj1[key], obj2[key]);
                    };
                });
                return result;
            }

            // Realiza a comparação desconsiderendo a 
            // propriedade diferente de null ou undefined
            // obj2[key] deve ser válido
            service.compareObjFull = function (obj1, obj2) {
                if (!obj1 || !obj2) return false;
                if (obj1.length != obj2.length) return false;
                let result = true;
                Object.keys(obj1).forEach(key => {
                    // Em caso do primeiro obj diferente encerramos a recursividade
                    if (!result) {
                        return;
                    }
                    if (obj2[key] === null || (typeof obj2[key] != 'object' && typeof obj2[key] != 'undefined' && key.indexOf("$$") == -1)) {
                        if (obj1[key] != obj2[key])
                            result = false;
                    }
                    else if (obj2[key] && typeof obj2[key] == 'object') {
                        result = service.compareObjFull(obj1[key], obj2[key]);
                    };
                });
                return result;
            }

            service.compareObjExt2 = function (obj1, obj2) {
                if (!obj1 || !obj2) return false;
                if (typeof obj1 != typeof obj2) return false;
                if (typeof obj1 == 'array' && obj1.length != obj2.length) return false;
                let result = true;
                Object.keys(obj1).forEach(key => {
                    // Em caso do primeiro obj diferente encerramos a recursividade
                    if (!result) {
                        return;
                    }
                    if (obj2[key] && typeof obj2[key] != 'object' && key.indexOf("$$") == -1) {
                        if (obj2[key] && obj1[key] != obj2[key])
                            result = false;
                    }
                    else if (obj2[key] && typeof obj2[key] == 'object') {
                        result = service.compareObjExt(obj1[key], obj2[key]);
                    };
                });
                return result;
            }

            service.uuidv4 = function () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }

            service.isPropValid = function (prop) {
                return !(prop == null || prop == undefined);
            }

            return service;
        }])
    })
();

(function() {

    'use strict';

    angular.module('epbxManagerApp')
        .directive('styleSwitcher', ["$rootScope", "$document", "$state", "$timeout", function($rootScope, $document, $state, $timeout) {
            return {
                restrict: 'E',
                templateUrl: 'app/directives/templates/style_switcher.html',
                controller: ["$scope", function($scope) {

                    $scope.themes = [{
                        name: "app_style_default",
                        class: "default_theme"
                    }, {
                        name: "switcher_theme_a",
                        class: "app_theme_a"
                    }, {
                        name: "switcher_theme_b",
                        class: "app_theme_b"
                    }, {
                        name: "switcher_theme_c",
                        class: "app_theme_c"
                    }, {
                        name: "switcher_theme_d",
                        class: "app_theme_d"
                    }, {
                        name: "switcher_theme_e",
                        class: "app_theme_e"
                    }, {
                        name: "switcher_theme_f",
                        class: "app_theme_f"
                    }, {
                        name: "switcher_theme_h",
                        class: "app_theme_h"
                    }];

                }],
                link: function(scope, elem, attr) {

                    scope.toggleStyleSwitcher = function($event) {
                        $event.preventDefault();
                        $rootScope.styleSwitcherActive = !$rootScope.styleSwitcherActive;
                    };

                    scope.changeTheme = function($event, theme) {
                        $event.preventDefault();
                        var $this = $($event.currentTarget);

                        $this
                            .addClass('active_theme')
                            .siblings().removeClass('active_theme');

                        $rootScope.main_theme = theme.class;

                        if (theme.class == '') {
                            window.localStorage.removeItem('altair_theme');
                        } else {
                            window.localStorage.setItem("altair_theme", theme.class);
                        }
                    };

                    scope.mini_sidebar_toggle = false;

                    // change input's state to checked if mini sidebar is active
                    if ((window.localStorage.getItem("altair_sidebar_mini") !== null && window.localStorage.getItem("altair_sidebar_mini") == '1')) {
                        $rootScope.miniSidebarActive = true;
                        scope.mini_sidebar_toggle = true;
                    }

                    // toggle mini sidebar
                    $('#style_sidebar_mini')
                        .on('ifChecked', function(event) {
                            window.localStorage.setItem("altair_sidebar_mini", '1');
                            $rootScope.styleSwitcherActive = false;
                            $timeout(function() {
                                $rootScope.miniSidebarActive = true;
                                $state.go($state.current, {}, {
                                    reload: true
                                });
                            })
                        })
                        .on('ifUnchecked', function(event) {
                            window.localStorage.removeItem('altair_sidebar_mini');
                            $rootScope.styleSwitcherActive = false;
                            $timeout(function() {
                                $rootScope.miniSidebarActive = false;
                                $state.go($state.current, {}, {
                                    reload: true
                                });
                            })
                        });

                    scope.boxed_layout_toggle = false;

                    // change input's state to checked if mini sidebar is active
                    if ((window.localStorage.getItem("altair_boxed_layout") !== null && window.localStorage.getItem("altair_boxed_layout") == '1')) {
                        $rootScope.boxedLayoutActive = true;
                        scope.boxed_layout_toggle = true;
                    }

                    // toggle mini sidebar
                    $('#style_layout_boxed')
                        .on('ifChecked', function(event) {
                            window.localStorage.setItem("altair_boxed_layout", '1');
                            $rootScope.styleSwitcherActive = false;
                            $timeout(function() {
                                $rootScope.boxedLayoutActive = true;
                                $state.go($state.current, {}, {
                                    reload: true
                                });
                            })
                        })
                        .on('ifUnchecked', function(event) {
                            window.localStorage.removeItem('altair_boxed_layout');
                            $rootScope.styleSwitcherActive = false;
                            $timeout(function() {
                                $rootScope.boxedLayoutActive = false;
                                $state.go($state.current, {}, {
                                    reload: true
                                });
                            })
                        });



                    // check which theme is active
                    if (window.localStorage.getItem("altair_theme") !== null) {
                        $rootScope.main_theme = window.localStorage.getItem("altair_theme");
                    } else {
                        $rootScope.main_theme = "default_theme"
                    }

                }
            };
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.agendaIntervalo.new", StateResolverProvider.configState("/agendamento/intervalo/new", "AgendaIntervalo", "Edit", {
                    pageTitle: 'pageTitle.agendamentoDeIntervalos',
                    pageName: 'acoes.cadastrar',
                    permissions: { AllowAll: true },
                    css: true
                }))
                .state("main.agendaIntervalo.edit", StateResolverProvider.configState("/agendamento/intervalo/{AgendaIntervaloId:[0-9]+}", "AgendaIntervalo", "Edit", {
                    pageTitle: 'pageTitle.agendamentoDeIntervalos',
                    pageName: 'acoes.editar',
                    permissions: { AllowAll: true },
                    css: true
                }));
        }])

        .service('AgendaIntervaloEditData', ["AgendaIntervaloResource", function AgendaIntervaloEditData(AgendaIntervaloResource) {
            return function () {
                return {
                    registro: ["$stateParams", function ($stateParams) {
                        if ($stateParams.AgendaIntervaloId) {
                            return AgendaIntervaloResource.get({ AgendaIntervaloId: $stateParams.AgendaIntervaloId }).$promise;
                        } else {
                            return {
                                Descricao: '', Recorrente: true,
                                AgendaIntervaloHorario: [{
                                    Horario: '09:00',
                                    Domingo: false,
                                    Segunda: true,
                                    Terca: true,
                                    Quarta: true,
                                    Quinta: true,
                                    Sexta: true,
                                    Sabado: false
                                }],
                                Ramal: []
                            };
                        }
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }]
                }
            }
        }])

        .controller("AgendaIntervaloEditController", ["$scope", "$state", "registro", "grupos", "AgendaIntervaloResource", "RamalStatusResourceDetalhe", "GrupoResource", "NotifyService", function ($scope, $state, registro, grupos, AgendaIntervaloResource, RamalStatusResourceDetalhe, GrupoResource,
            NotifyService) {
            var ramalIdSelecionadosArray;
            $scope.isNew = !registro.AgendaIntervaloId;
            $scope.ramalStatusDetalheList = [];
            $scope.helper = {};
            $scope.grupoList = grupos;
            $scope.grupoChanged = grupoChanged;

            updateRegistro(registro);

            function updateRegistro(novoRegistro) {
                $scope.registro = novoRegistro;
                $scope.registro.RamalStatusDetalheId = novoRegistro.RamalStatusDetalhe ? novoRegistro.RamalStatusDetalhe.RamalStatusDetalheId : undefined;
                $scope.registro.GrupoId = novoRegistro.Grupo ? novoRegistro.Grupo.GrupoId : undefined;
                $scope.helper.ramaisChanged = false;

                if (!novoRegistro.Recorrente && novoRegistro.AgendaIntervaloHorario[0]) {
                    novoRegistro.Data = new Date(novoRegistro.AgendaIntervaloHorario[0].Data);
                }

                grupoChanged();

                return novoRegistro;
            }

            function grupoChanged() {
                if ($scope.registro.GrupoId > 0) {
                    updateStatusDetalhe();
                    updateRamalGrupo();
                }
            }

            function updateStatusDetalhe() {
                $scope.ramalStatusDetalheList = [];
                RamalStatusResourceDetalhe.getStatusDetalhePorGrupo({ GrupoId: $scope.registro.GrupoId }).$promise
                    .then((list) => $scope.ramalStatusDetalheList = _.sortBy(list, 'Descricao'));
            }

            function updateRamalGrupo() {
                $scope.helper.ramaisAdicionados = [];
                $scope.ramaisDisponiveis = [];
                GrupoResource.getRamaisAssociados({ GrupoId: $scope.registro.GrupoId, CarteiraId: 0 }).$promise
                    .then((ramais) => {
                        ramalIdSelecionadosArray = _.pluck($scope.registro.AgendaIntervaloRamal, 'RamalId').sort();
                        $scope.helper.ramaisAdicionados = _.filter(ramais, isRamalAdicionado);
                        $scope.ramaisDisponiveis = _.filter(ramais, isRamalDisponivel);
                    });
            }

            function isRamalAdicionado(value) {
                return ramalIdSelecionadosArray.indexOf(value.RamalId) > -1;
            }

            function isRamalDisponivel(value) {
                return ramalIdSelecionadosArray.indexOf(value.RamalId) === -1;
            }

            $scope.novoHorario = function () {
                $scope.registro.AgendaIntervaloHorario.push({
                    Hora: '09:00',
                    Domingo: false,
                    Segunda: true,
                    Terca: true,
                    Quarta: true,
                    Quinta: true,
                    Sexta: true,
                    Sabado: false
                });
            }

            $scope.confirmDelete = function (value) {
                var i = $scope.registro.AgendaIntervaloHorario.indexOf(value);
                if (i > -1) {
                    $scope.registro.AgendaIntervaloHorario.splice(i, 1);
                }
            }

            $scope.validateStep = function (form) {
                var valid = form.$valid || false;
                form.$setSubmitted();
                return valid;
            }

            $scope.salvar = function (form, redirecionar) {
                var promise;

                if (!$scope.registro.Recorrente) {
                    $scope.registro.AgendaIntervaloHorario = [{ Data: $scope.registro.Data }];
                } else {
                    if ($scope.registro.AgendaIntervaloHorario.length == 0) {
                        return NotifyService.showError(null, 'telaAgendamentoIntervaloEdit.necessarioAgendamentoComHorarioValido');
                    }
                }

                $scope.registro.AgendaIntervaloRamal = _.map($scope.helper.ramaisAdicionados, (value) => { return { RamalId: value.RamalId }; });

                if ($scope.registro.AgendaIntervaloRamal.length == 0) {
                    return NotifyService.showError(null, 'telaAgendamentoIntervaloEdit.necessarioInformarAoMenosUmRamal');
                }
                if ($scope.registro.AgendaIntervaloId > 0) {
                    promise = AgendaIntervaloResource.update($scope.registro).$promise;
                } else {
                    promise = AgendaIntervaloResource.save($scope.registro).$promise;
                }

                promise.then((value) => {
                    NotifyService.showSuccess()
                    form.$setPristine();
                    return value;
                }).catch(NotifyService.showError);

                if (redirecionar) {
                    promise.then(() => $state.go('main.agendaIntervalo.list'));
                }

                return promise;
            };

            $scope.moverRamais = function (from, to) {
                _.each(_.where(from, { checked: true }), (value) => { $scope.moverRamal(value, from, to); });
            }

            $scope.moverRamal = function (value, from, to) {
                value.checked = false;
                $scope.helper.ramaisChanged = true;
                to.push(value);
                from.splice(from.indexOf(value), 1);
            }

        }]);
})();
(function () {
    "use strict";

    var defaultPageSize = 10;
    var defaultOrderBy = { column: 'AgendaIntervaloId', order: 'desc' };

    var getOdataSearchShared = function (AgendaIntervaloResource, search, orderBy) {
        search = search || {};
        var odata = AgendaIntervaloResource.odata();

        if (search.Descricao) {
            odata.where('Descricao', 'contains', search.Descricao);
        }

        if (search.RamalStatusDetalheId) {
            odata.filter('RamalStatusDetalhe/RamalStatusDetalheId', search.RamalStatusDetalheId);
        }

        if (search.Grupo) {
            odata.filter('Grupo/GrupoId', search.Grupo.GrupoId);
        }

        orderBy = orderBy || defaultOrderBy;

        odata.orderBy(orderBy.column, orderBy.order);

        return odata;
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.agendaIntervalo", StateResolverProvider.configAbstractInnerPage({
                    proxy: 'main.agendaIntervalo.list',
                    pageTitle: 'pageTitle.agendamentoDeIntervalos',
                    pageName: 'pageTitle.pesquisar',
                    permissions: {
                        AllowAll: true
                    }
                }))
                .state("main.agendaIntervalo.list", StateResolverProvider.configState("/agendamento/intervalo", "AgendaIntervalo", "List", {
                    pageTitle: 'pageTitle.agendamentoDeIntervalos',
                    pageName: 'pageTitle.pesquisar',
                    permissions: {
                        AllowAll: true
                    }
                }));
        }])

        .service("AgendaIntervaloListData", function AgendaIntervaloListData() {
            return function () {
                return {
                    list: ["AgendaIntervaloResource", function (AgendaIntervaloResource) {
                        return getOdataSearchShared(AgendaIntervaloResource).page(defaultPageSize, 1).query();
                    }],
                    ramalStatusDetalheList: ["RamalStatusResourceDetalhe", function (RamalStatusResourceDetalhe) {
                        return RamalStatusResourceDetalhe.odata().select('RamalStatusDetalheId', 'Descricao').orderBy('Descricao').query();
                    }]
                }
            }
        })

        .filter('emHoraSegundo', function () {
            return function (x) {
                if (x) return moment(moment.duration(x)._data).format("HH:mm");
                return x;
            };
        })

        .controller("AgendaIntervaloListController", ["$scope", "list", "AgendaIntervaloResource", "ramalStatusDetalheList", "NotifyService", "ModalService", function ($scope, list, AgendaIntervaloResource, ramalStatusDetalheList, NotifyService, ModalService) {
            $scope.searching = false;
            $scope.ramalStatusDetalheList = ramalStatusDetalheList;
            $scope.search = { 
                pageSize: defaultPageSize 
            };

            $scope.limparFiltro = function () {
                $scope.search = { 
                    pageSize: defaultPageSize 
                };
                $scope.executeSearch();
            }

            var updateList = function (newList) {
                $scope.list = newList;
                $scope.searching = false;
            }

            updateList(list);

            var deleteRecord = function (item) {
                return AgendaIntervaloResource.delete({ AgendaIntervaloId: item.AgendaIntervaloId }).$promise
                    .then(() => {
                        $scope.pageChanged($scope.list.CurrentPage, $scope.search);
                        NotifyService.showSuccess('telaAgendamentoIntervalo.exclusaoRealizadaComSucesso');
                    }).catch(NotifyService.showError);
            }

            $scope.executeSearch = function (search, pageNumber) {
                $scope.searching = true;
                var queryParam = {};
                search = search || $scope.search || {};
                // o ramalId deve ser passado na querystring, já que o Ramal não faz parte do objeto de retorno e portando não é suportado no odata
                if (search.Ramal && search.Ramal.RamalId) {
                    queryParam.RamalId = search.Ramal.RamalId;
                }

                return getOdataSearchShared(AgendaIntervaloResource, search).page(defaultPageSize, pageNumber || 1).query(queryParam)
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            }

            $scope.pageChanged = function (newPage, search) {
                return $scope.executeSearch(search, newPage);
            };

            $scope.confirmDelete = function (item) {
                ModalService.confirmDelete(() => deleteRecord(item));
            };
        }]);
    })
();

(function () {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("AgendaIntervaloResource", ["$odataresource", function ($odataresource) {
      return $odataresource("Agenda/Intervalo/:AgendaIntervaloId", { "AgendaIntervaloId": "@AgendaIntervaloId" },
        {
         
        });
    }]);

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.agendamentoCDR.edit", StateResolverProvider.configState("/agendamentoCDR/{Id:[0-9]+}", "AgendamentoCDR", "Edit", {
                    pageTitle: 'pageTitle.agendamentoCDR',
                    pageName: 'acoes.editar',
                }))
                .state("main.agendamentoCDR.new", StateResolverProvider.configState("/agendamentoCDR/new", "AgendamentoCDR", "Edit", {
                    pageTitle: 'pageTitle.agendamentoCDR',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("AgendamentoCDREditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    bilheteCDRAgendamento: ["AgendamentoCDRResource", "$stateParams", function (AgendamentoCDRResource, $stateParams) {
                        if ($stateParams.Id) {
                            return AgendamentoCDRResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    statusList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatus().$promise;
                    }],
                    statusDetalheList: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.odata().filter('Discagem', true).query();
                    }],
                    cenariosList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.cenario().$promise;
                    }],
                    carteiraList: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    grupoList: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getTodosGrupos();
                    }],
                    rotaList: ["RotaResource", function (RotaResource) {
                        return RotaResource.odata().select(["RotaId", "Nome"]).query();
                    }],
                    usuariosList: ["UsuarioResource", function (UsuarioResource) {
                        return UsuarioResource.GetTodosUsuario().$promise;
                    }],
                    campanhaTipoList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetCampanhasTipo();
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetTodasCampanhas();
                    }],
                    eventoList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.evento().$promise;
                    }],
                    bilheteCDROrigemList: ["AgendamentoCDRResource", function (AgendamentoCDRResource) {
                        return AgendamentoCDRResource.getBilheteCDROrigem().$promise;
                    }],
                    uraList: ["UraResource", "$odata", function (UraResource, $odata) {
                        var predicate1 = new $odata.Predicate('UraTipo/UraTipoId', 5);
                        var predicate2 = new $odata.Predicate('UraTipo/UraTipoId', 10);
                        var combination1 = $odata.Predicate.or([predicate1, predicate2]);
                        var odata = UraResource.odata();
                        return odata.filter(combination1).query();
                    }]
                };
            };
        })

        .controller("AgendamentoCDREditController", ["$scope", "$rootScope", "$http", "$odata", "ModalService", "AuthService", "NotifyService", "Config", "$state", "$translate", "AgendamentoCDRResource", "UraResource", "bilheteCDRAgendamento", "statusList", "statusDetalheList", "cenariosList", "carteiraList", "grupoList", "rotaList", "usuariosList", "campanhaTipoList", "campanhasList", "eventoList", "bilheteCDROrigemList", "uraList", function ($scope, $rootScope, $http, $odata, ModalService, AuthService, NotifyService, Config, $state, $translate,
            AgendamentoCDRResource, UraResource, bilheteCDRAgendamento, statusList, statusDetalheList, cenariosList, carteiraList, grupoList, rotaList, usuariosList,
            campanhaTipoList, campanhasList, eventoList, bilheteCDROrigemList, uraList) {

            $scope.bilheteCDRAgendamento = bilheteCDRAgendamento; 
            $scope.isNew = (bilheteCDRAgendamento.Id > 0 ? false : true);           
            $scope.forms = {};
            $scope.proximoStep = false;

            if ($scope.bilheteCDRAgendamento.Filtros != null && $scope.bilheteCDRAgendamento.BilheteCDROrigemId == 1) {
                $scope.bilheteCDRAgendamento.Filtros.CampanhaId = $scope.bilheteCDRAgendamento.Filtros.CampanhaId != null ? $scope.bilheteCDRAgendamento.Filtros.CampanhaId.split(',') : null;
                $scope.bilheteCDRAgendamento.Filtros.GrupoId = $scope.bilheteCDRAgendamento.Filtros.GrupoId != null ? $scope.bilheteCDRAgendamento.Filtros.GrupoId.split(',') : null;
            }
            $scope.bilheteCDRAgendamentoFiltros = $scope.bilheteCDRAgendamento.Filtros != null ? $scope.bilheteCDRAgendamento.Filtros : {};

            $scope.tipoAgendamento = [
                {Id: 1, Descricao: 'Diário'},
                {Id: 2, Descricao: 'Semanal'},
                {Id: 3, Descricao: 'Mensal'}
            ];

            $scope.diasDaSemana = [
                {Dia: 'Domingo'},
                {Dia: 'Segunda-Feira'},
                {Dia: 'Terça-Feira'},
                {Dia: 'Quarta-Feira'},
                {Dia: 'Quinta-Feira'},
                {Dia: 'Sexta-Feira'},
                {Dia: 'Sábado'}
            ];

            $scope.destinoList = [
                { Id: 1, Nome: 'Diretório' },
                { Id: 2, Nome: 'FTP' }
            ];

            $scope.direcaoList = [
                { DirecaoId: 2, Descricao: $translate.instant('campo.efetuada') },
                { DirecaoId: 1, Descricao: $translate.instant('campo.recebida') }
            ];

            $scope.discagemTipoList = [
                { DiscagemTipoId: 1, Descricao: $translate.instant('telaEditAgendamento.manual') },
                { DiscagemTipoId: 2, Descricao: $translate.instant('telaEditAgendamento.discador') },
                { DiscagemTipoId: 3, Descricao: $translate.instant('campo.integracao') }
            ];

            $scope.usuarioIsAdmin = AuthService.getUsuarioLogado() ? (AuthService.getUsuarioLogado().UsuarioTipoId == 1 ? true : false) : false;
            $scope.usuarioIsOperador = AuthService.getUsuarioLogado() ? (AuthService.getUsuarioLogado().UsuarioTipoId == 3 ? true : false) : false;

            $scope.statusList = statusList;
            $scope.statusDetalheList = statusDetalheList;
            $scope.cenariosList = cenariosList;
            $scope.carteiraList = carteiraList;
            $scope.rotaList = rotaList;
            $scope.campanhaTipoList = campanhaTipoList;
            $scope.eventoList = eventoList;
            $scope.bilheteCDROrigemList = bilheteCDROrigemList;
            $scope.uraList = uraList;
            $scope.carregandoUrasTipo = false;
            $scope.uraTipoList = [
                { UraTipoId: 5, Descricao: $translate.instant('telaBilheteUra.atendimento') },
                { UraTipoId: 10, Descricao: $translate.instant('telaBilheteUra.satisfacao') }
            ];
            $scope.origemDesconexaoLista = [];
            
            $scope.grupoListComInativos = grupoList;
            $scope.grupoListSemInativos = _.filter($scope.grupoListComInativos, function (item) {
                return item.Ativo == 1;
            });
            $scope.grupos = $scope.grupoListSemInativos;

            $scope.usuariosListComInativos = usuariosList;
            $scope.usuariosListSemInativos = _.filter($scope.usuariosListComInativos, function (item) {
                return item.UsuarioStatusId == 1;
            });
            $scope.usuarios = $scope.usuariosListSemInativos;

            $scope.campanhasListComInativas = campanhasList;
            $scope.campanhasListSemInativas = _.filter($scope.campanhasListComInativas, function (item) {
                return item.CampanhaStatusId !== 1;
            });
            $scope.campanhas = $scope.campanhasListSemInativas;

            if ($scope.bilheteCDRAgendamento.Diario) {
                $scope.tipoAgendamento.Id = 1;
            }

            if ($scope.bilheteCDRAgendamento.Semanal) {
                $scope.tipoAgendamento.Id = 2;
            }

            if ($scope.bilheteCDRAgendamento.Mensal) {
                $scope.tipoAgendamento.Id = 3;
            }

            $scope.validateAgendamentoCDR = function () {
                $scope.proximoStep = $scope.forms.formAgendamento.$valid ? true : false;
                return $scope.proximoStep;
            };

            $scope.onTipoAgendamentoSelecionado = function (id) {
                switch (id) {
                    case 1:
                        $scope.bilheteCDRAgendamento.Diario = true;
                        $scope.bilheteCDRAgendamento.Semanal = false;
                        $scope.bilheteCDRAgendamento.Mensal = false;
                        $scope.bilheteCDRAgendamento.DiaDoMes = 0;
                        $scope.bilheteCDRAgendamento.DiaDaSemana = null;
                        break;
                    case 2:
                        $scope.bilheteCDRAgendamento.Diario = false;
                        $scope.bilheteCDRAgendamento.Semanal = true;
                        $scope.bilheteCDRAgendamento.Mensal = false;
                        $scope.bilheteCDRAgendamento.DiaDoMes = 0;
                        break;
                    case 3:
                        $scope.bilheteCDRAgendamento.Diario = false;
                        $scope.bilheteCDRAgendamento.Semanal = false;
                        $scope.bilheteCDRAgendamento.Mensal = true;
                        $scope.bilheteCDRAgendamento.DiaDaSemana = null;
                      break;
                }
            };

            $scope.onChangeCarteira = function () {
                if ($scope.bilheteCDRAgendamentoFiltros.CarteiraId == undefined) {
                    $scope.bilheteCDRAgendamentoFiltros.CarteiraId = 0;
                    $scope.grupos = $scope.grupoList;
                    if ($scope.viewInativos)
                        $scope.usuarios = $scope.usuariosListComInativos
                    else
                        $scope.usuarios = $scope.usuariosListSemInativos
                } else {
                    getCarteiraPorGrupo($scope.bilheteCDRAgendamentoFiltros.CarteiraId);
                    getCarteiraPorUsuario($scope.bilheteCDRAgendamentoFiltros.CarteiraId);
                }
            };

            let getCarteiraPorGrupo = function (id) {
                if(id > 0)
                {
                    if($scope.viewInativos)
                        $scope.grupos = _.filter($scope.grupoListComInativos, function (item) {
                            return item.CarteiraId == id;
                        });
                    else
                        $scope.grupos = _.filter($scope.grupoListSemInativos, function (item) {
                            return item.CarteiraId == id;
                        });
                }
                else 
                {
                    if($scope.viewInativos)
                        $scope.grupos = $scope.grupoListComInativos;
                    else
                        $scope.grupos = $scope.grupoListSemInativos;
                }
            };

            let getCarteiraPorUsuario = function (id) {
                if(id > 0)
                {
                    if($scope.viewInativos)
                        $scope.usuarios = _.filter($scope.usuariosListComInativos, function (item) {
                            return item.CarteiraId == id;
                        });
                    else
                        $scope.usuarios = _.filter($scope.usuariosListSemInativos, function (item) {
                            return item.CarteiraId == id;
                        });
                }
                else 
                {
                    if($scope.viewInativos)
                        $scope.usuarios = $scope.usuariosListComInativos;
                    else
                        $scope.usuarios = $scope.usuariosListSemInativos;
                }
            };

            let getUsuarioPorGrupo = function () {
                // Se não for Informado um Grupo exibe Todos os Ramais
                if (!$scope.bilheteCDRAgendamentoFiltros.GrupoId || $scope.bilheteCDRAgendamentoFiltros.GrupoId.length <= 0) {
                    return $scope.usuarios = usuariosList;
                }

                $http({ url: Config.getUrl('ramal/tipo/1/grupos/' + $scope.bilheteCDRAgendamentoFiltros.GrupoId.join(',')), method: 'GET' })
                    .then(updateUsuarioList)
                    .catch(NotifyService.showError);
            };

            let updateUsuarioList = function (response) {
                if (!response.data || response.data.length <= 0) {
                    return $scope.usuarios = [];
                }

                let users = [];
                response.data.forEach(function (item) {

                    const newItem = {
                        UsuarioId: item.UsuarioId,
                        Nome: item.Descricao
                    }
                    users.push(newItem)
                });
                $scope.usuarios = users;
            };

            $scope.onChangeGrupoUsuario = function () {
                getUsuarioPorGrupo();
            };

            $scope.onChangeUsuario = function () {

                if ($scope.bilheteCDRAgendamentoFiltros.UsuarioId > 0) {
                    $scope.bilheteCDRAgendamentoFiltros.DownloadDetalhe = true;

                    var cenario = _.find($scope.cenariosList, function (item) {
                        return item.Descricao == "Ramal"
                    });
                    if (cenario != null)
                        $scope.bilheteCDRAgendamentoFiltros.BilheteCenarioId = cenario.BilheteCenarioId;


                    var evento = _.find($scope.eventoList, function (item) {
                        return item.Descricao == "Em Atendimento"
                    });

                    if (evento != null)
                        $scope.bilheteCDRAgendamentoFiltros.BilheteEventoId = evento.BilheteEventoId;
                } else {
                    $scope.bilheteCDRAgendamentoFiltros.DownloadDetalhe = false;
                    $scope.bilheteCDRAgendamentoFiltros.BilheteCenarioId = 0;
                    $scope.bilheteCDRAgendamentoFiltros.BilheteEventoId = 0;
                }

            };

            $scope.changeCampanhaTipoId = function () {
                $rootScope.$broadcast('onLimpar', ['CampanhaId']);

                if ($scope.bilheteCDRAgendamentoFiltros.CampanhaTipoId === undefined)
                    $scope.bilheteCDRAgendamentoFiltros.CampanhaTipoId = 0;

                $scope.campanhas = $scope.viewInativos ? $scope.campanhasListComInativas : $scope.campanhasListSemInativas;

                if ($scope.bilheteCDRAgendamentoFiltros.CampanhaTipoId > 0) {
                    $scope.campanhas = _.filter($scope.campanhas, (item) => {
                        return item.CampanhaTemplateId == $scope.bilheteCDRAgendamentoFiltros.CampanhaTipoId;
                    });
                }

                return $scope.campanhas;
            }

            $scope.onUraTipoSelected = function () {
                $scope.carregandoUrasTipo = true;
                if ($scope.bilheteCDRAgendamentoFiltros.UraTipoId > 0) {
                    $scope.bilheteCDRAgendamentoFiltros.UraId = null;
                    var odata = UraResource.odata();
                    odata.where('UraTipo/UraTipoId', $scope.bilheteCDRAgendamentoFiltros.UraTipoId).query().then(function (data) {
                        $scope.uraList = data;
                        $scope.carregandoUrasTipo = false;
                    });
                } else {
                    var predicate1 = new $odata.Predicate('UraTipo/UraTipoId', 5);
                    var predicate2 = new $odata.Predicate('UraTipo/UraTipoId', 10);
                    var combination1 = $odata.Predicate.or([predicate1, predicate2]);
                    var odata = UraResource.odata();
                    odata.filter(combination1).query().then(function (data) {
                        $scope.uraList = data;
                        $scope.carregandoUrasTipo = false;
                    });
                }
            };

            $scope.onChangeBilheteCDROrigem = function () {
                $scope.bilheteCDRAgendamentoFiltros.GrupoId = null;
                $scope.bilheteCDRAgendamentoFiltros.CampanhaId = null;
            }

            function tratarOrigemDesconexao () {
                var cliente = $scope.bilheteCDRAgendamentoFiltros.origemDesconexaoCliente ? 'Cliente' : null;
                var ramal = $scope.bilheteCDRAgendamentoFiltros.origemDesconexaoRamal ? 'Ramal' : null;
                $scope.origemDesconexaoLista = [];
    
                if (cliente != null) {
                    $scope.origemDesconexaoLista.push(cliente);
                }
    
                if (ramal != null) {
                    $scope.origemDesconexaoLista.push(ramal);
                }
            }

            function CarregarOrigemDesconexao () {

                $scope.origemDesconexaoLista = ($scope.bilheteCDRAgendamentoFiltros.DirecaoOrdenacao || "").split(',');

                $scope.bilheteCDRAgendamentoFiltros.origemDesconexaoCliente = $scope.origemDesconexaoLista.find(x => x == 'Cliente') != undefined;
                $scope.bilheteCDRAgendamentoFiltros.origemDesconexaoRamal = $scope.origemDesconexaoLista.find(x => x == 'Ramal') != undefined;
                
            }

            CarregarOrigemDesconexao();

            $scope.salvar = function (form) {
                var lastStep = form.$name == "forms.formFiltros" ? true : false;

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                if ($scope.bilheteCDRAgendamento.BilheteCDROrigemId == 1) {
                    if(typeof $scope.bilheteCDRAgendamentoFiltros.CampanhaId != "string") {
                        $scope.bilheteCDRAgendamentoFiltros.CampanhaId = ($scope.bilheteCDRAgendamentoFiltros.CampanhaId == null || $scope.bilheteCDRAgendamentoFiltros.CampanhaId == 0) ? null : $scope.bilheteCDRAgendamentoFiltros.CampanhaId.join();
                    }

                    if(typeof $scope.bilheteCDRAgendamentoFiltros.GrupoId != "string") {
                        $scope.bilheteCDRAgendamentoFiltros.GrupoId = ($scope.bilheteCDRAgendamentoFiltros.GrupoId == null || $scope.bilheteCDRAgendamentoFiltros.GrupoId == 0) ? null : $scope.bilheteCDRAgendamentoFiltros.GrupoId.join();
                    }
                }
                
                tratarOrigemDesconexao();

                $scope.bilheteCDRAgendamentoFiltros.DirecaoOrdenacao = $scope.origemDesconexaoLista.length > 1 ? $scope.origemDesconexaoLista.join() : $scope.origemDesconexaoLista[0];

                $scope.bilheteCDRAgendamentoFiltros.BilheteEventoId = $scope.bilheteCDRAgendamentoFiltros.DownloadDetalhe ? $scope.bilheteCDRAgendamentoFiltros.BilheteEventoId : 0

                var data = {
                    Id: $scope.bilheteCDRAgendamento.Id,
                    Nome: $scope.bilheteCDRAgendamento.Nome,
                    Diario: $scope.bilheteCDRAgendamento.Diario,
                    Semanal: $scope.bilheteCDRAgendamento.Semanal,
                    Mensal: $scope.bilheteCDRAgendamento.Mensal,
                    HorarioExecucao: $scope.bilheteCDRAgendamento.HorarioExecucao,
                    DiaDaSemana: $scope.bilheteCDRAgendamento.DiaDaSemana,
                    DiaDoMes: $scope.bilheteCDRAgendamento.DiaDoMes,
                    BilheteCDROrigemId: $scope.bilheteCDRAgendamento.BilheteCDROrigemId,
                    Filtros: $scope.bilheteCDRAgendamentoFiltros
                };

                if(lastStep) {
                    $scope.salvarAgendamentoCDR(data);
                }
            };

            $scope.salvarAgendamentoCDR = function (data) {
                var promise;
                if ($scope.bilheteCDRAgendamento.Id > 0) {
                    promise = AgendamentoCDRResource.update(data.Id, data).$promise;
                }
                else {
                    promise = AgendamentoCDRResource.save(data).$promise;
                }

                promise.then(() => {
                    let message = $scope.isNew ? 'telaEditAgendamento.agendamentoCadastradoComSucesso' : 'telaEditAgendamento.agendamentoAlteradoComSucesso';

                    NotifyService.showSuccess($translate.instant(message));
                    $state.go('main.agendamentoCDR.list');
                })
                .catch(NotifyService.showError);
            };
        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (AgendamentoCDRResource, search, orderBy, $odata) {
        var odata = AgendamentoCDRResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }
        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.agendamentoCDR", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.agendamentoCDR.list',
                    pageTitle: 'pageTitle.cardTitle',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.agendamentoCDR.list", StateResolverProvider.configState("/agendamentoCDR", "AgendamentoCDR", "List", {
                pageTitle: 'pageTitle.agendamentoCDR',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("AgendamentoCDRListData", function AgendamentoCDRListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                agendamentoCDRList: ["AgendamentoCDRResource", "LocalStorageService", "$odata", "$stateParams", function (AgendamentoCDRResource, LocalStorageService, $odata, $stateParams) {
                    var filtro = {};

                    if ($stateParams.storage) {
                        filtro = LocalStorageService.getItem("FiltroAgendamentoCDR");
                    }

                    var orderBy = {
                       column: "Id",
                       order: "desc"
                    };

                    return getOdataSearchShared(AgendamentoCDRResource, filtro, orderBy, $odata).page(10, 1).query();
                }],
            }
        }
    })

    .controller("AgendamentoCDRListController", ["$scope", "$odata", "AgendamentoCDRResource", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "agendamentoCDRList", function ($scope, $odata, AgendamentoCDRResource, LocalStorageService,
        $stateParams, NotifyService, ModalService, agendamentoCDRList) {
            $scope.agendamentoCDRList = agendamentoCDRList;
            $scope.bilheteCDRConfiguracao = {};
            $scope.isCaminhoValido = true;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroAgendamentoCDR") : {
                Nome: ''
            };

            $scope.orderBy = {
                column: "Id",
                order: "desc"
            };

            $scope.destinoList = [
                { Id: 1, Nome: 'Diretório' },
                { Id: 2, Nome: 'FTP' },
                { Id: 3, Nome: 'SFTP' }
            ];

            $scope.errorObject = {};

            var updateList = function (list) {
                $scope.agendamentoCDRList = list;
                $scope.agendamentoCDRList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.agendamentoCDRList.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(AgendamentoCDRResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.agendamentoCDRList.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroAgendamentoCDR', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroAgendamentoCDR');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteAgendamentoCDR = function (data) {
                return AgendamentoCDRResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmMessage('telaAgendamentoCDR.confirmDeleteAgendamento', null, () => deleteAgendamentoCDR(data));
            };

            $scope.abrirModalConfiguracao = function () {
                ModalService.openModal("modal_configuracao", () => {
                    getBilheteCDRConfiguracao();
                });
            };

            var getBilheteCDRConfiguracao = function () {
                AgendamentoCDRResource.getBilheteCDRConfiguracao()
                .$promise
                .then((dados) => {
                    if (dados != null && dados.Id != undefined) {
                        $scope.bilheteCDRConfiguracao = dados;

                        if ($scope.bilheteCDRConfiguracao.Diretorio) {
                            $scope.destinoList.Id = 1;
                        } else {
                            if($scope.bilheteCDRConfiguracao.FTP)
                                $scope.destinoList.Id = 2;
                            else
                                $scope.destinoList.Id = 3;
                        }
                        if($scope.bilheteCDRConfiguracao.FTP == true || $scope.bilheteCDRConfiguracao.SFTP == true){
                            $scope.validarConexao();
                        }
                    }
                    else
                    {
                        $scope.destinoList.Id = 1;
                    }
                }).catch(() => {
                    NotifyService.showError();
                });
            };

            $scope.validarConexao = function () {
                if($scope.bilheteCDRConfiguracao.FTP)
                    validarConexaoFTP($scope.bilheteCDRConfiguracao);
                else if($scope.bilheteCDRConfiguracao.SFTP)
                    validarConexaoSFTP($scope.bilheteCDRConfiguracao);
            };

            var validarConexaoFTP = function (configuracao) {
                AgendamentoCDRResource.validarConexaoFTP({ 'url': configuracao.UrlFTP, 'user': configuracao.UsuarioFTP, 'password': configuracao.SenhaFTP}).$promise
               .then((response) => {
                 $scope.conexaoFTPValida = response.Retorno;
                 if(response.Retorno){
                    NotifyService.showSuccess('telaAgendamentoCDR.conexaoValidaFtp');
                 }else{
                    NotifyService.showMessage('telaAgendamentoCDR.conexaoInvalidaFtp', "danger");
                 }
               });
            };

            var validarConexaoSFTP = function (configuracao) {
                AgendamentoCDRResource.validarConexaoSFTP({ 'url': configuracao.UrlFTP, 'port' : configuracao.PortaSFTP, 'user': configuracao.UsuarioFTP, 'password': configuracao.SenhaFTP}).$promise
               .then((response) => {
                 $scope.conexaoFTPValida = response.Retorno;
                 if(response.Retorno){
                    NotifyService.showSuccess('telaAgendamentoCDR.conexaoValidaSftp');
                 }else{
                    NotifyService.showMessage('telaAgendamentoCDR.conexaoInvalidaSftp', "danger");
                 }
               });
            };

            $scope.onValidarDiretorio = function (diretorio) {
                return AgendamentoCDRResource.ValidarDiretorio({ diretorio: diretorio }).$promise
                .then(function (response) {
                    $scope.isCaminhoValido = response.Value;
                })
                .catch(function (response) {
                    $scope.isCaminhoValido = false;
                });
            }

            $scope.onConfiguracaoSelecionado = function (id) {
                if (id == 1) {
                    $scope.bilheteCDRConfiguracao.Diretorio = true;
                    $scope.bilheteCDRConfiguracao.FTP = false;
                    $scope.bilheteCDRConfiguracao.UrlFTP = null;
                    $scope.bilheteCDRConfiguracao.SenhaFTP = null;
                    $scope.bilheteCDRConfiguracao.UsuarioFTP = null;
                    $scope.bilheteCDRConfiguracao.PortaSFTP = null;
                    $scope.bilheteCDRConfiguracao.PastaSFTP = null;
                } else {
                    if(id == 2)
                    {
                        $scope.bilheteCDRConfiguracao.FTP = true;
                        $scope.bilheteCDRConfiguracao.SFTP = false;
                    }
                    else
                    {
                        $scope.bilheteCDRConfiguracao.SFTP = true;
                        $scope.bilheteCDRConfiguracao.FTP = false;
                        $scope.bilheteCDRConfiguracao.PastaSFTP = '/CDR/';
                    }

                    $scope.bilheteCDRConfiguracao.Diretorio = false;
                    $scope.bilheteCDRConfiguracao.NomeDiretorio = null;
                }
            }

            $scope.createOrUpdateBilheteCDRConfiguracao = function () {
                AgendamentoCDRResource.createOrUpdateBilheteCDRConfiguracao($scope.bilheteCDRConfiguracao).$promise
                .then(() => {
                    NotifyService.showSuccess();
                    getBilheteCDRConfiguracao();
                }).catch((response) => {
                    NotifyService.showError(response);
                });
            }

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("AgendamentoCDRResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BilheteCDRAgendamento/:Id", { "Id": "@Id" },
                {
                    ValidarDiretorio: {
                        url: "BilheteCDRAgendamento/ValidarDiretorio",
                        method: "GET",
                        isArray: false,
                        params: {
                            "diretorio": "@diretorio"
                        }
                    },
                    validarConexaoFTP: {
                        url: "BilheteCDRAgendamento/ValidarConexaoFTP",
                        method: "GET",
                        params: {
                            "url": "@url",
                            "user": "@user",
                            "password": "@password",
                        },
                        isArray: false, 
                    },
                    validarConexaoSFTP: {
                        url: "BilheteCDRAgendamento/ValidarConexaoSFTP",
                        method: "GET",
                        params: {
                            "url": "@url",
                            "port": "@port",
                            "user": "@user",
                            "password": "@password",
                        },
                        isArray: false, 
                    },
                    getBilheteCDRConfiguracao: {
                        url: "BilheteCDRAgendamento/GetBilheteCDRConfiguracao",
                        method: "GET",
                        isArray: false
                    },
                    createOrUpdateBilheteCDRConfiguracao: {
                        url: "BilheteCDRAgendamento/CreateOrUpdateBilheteCDRConfiguracao",
                        method: "POST",
                        isArray: false
                    },
                    getBilheteCDROrigem: {
                        url: "BilheteCDRAgendamento/GetBilheteCDROrigem",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();
(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("alterarsenha", StateResolverProvider.configState("/alterarsenha", "AlterarSenha", 'View'))
        }])
        .service("AlterarSenhaViewData", function AlterarSenhaData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_iCheck'
                        ]);
                    }]
                }
            }
        })

        .controller('AlterarSenhaViewController', ["$scope", "$state", "$location", "NotifyService", "Config", "TranslateService", "STATES", "LocalStorageService", "UsuarioResource", function ($scope, $state, $location, NotifyService, Config, TranslateService, STATES, LocalStorageService, UsuarioResource) {

            $scope.idiomaConfig = {
                ativo: false
            };

            $scope.formSenhaExpirada = {
                UserName: '',
                SenhaAtual: '',
                NovaSenha: '',
                ConfirmarNovaSenha: ''
            };

            $scope.senhaForteLength = false;
            $scope.senhaForteCaractereMinusculo = false;
            $scope.senhaForteCaractereMaiusculo = false;
            $scope.senhaForteCaractereNumerico = false;
            $scope.senhaForteCaractereEspecial = false;
            $scope.naoReutilizeSenha = false;
            $scope.primeiroLogin = false;
            $scope.senhaValida = false;


            $scope.primeiroLogin = localStorage.getItem('primeiro_login');

            if (localStorage.getItem('alterar_senha'));
            $scope.formSenhaExpirada.UserName = localStorage.getItem('alterar_senha');

            const exibirIdiomas = () => {
                $scope.idiomaConfig.ativo = TranslateService.getI18NAtivo();
                if ($scope.idiomaConfig.ativo) {
                    $scope.idiomaConfig.idiomaAtual = TranslateService.getIdiomaAtual();
                    $scope.idiomas = [
                        { id: 'pt', descricao: 'Português' },
                        { id: 'en', descricao: 'English' },
                        { id: 'es', descricao: 'Español' }
                    ];

                    $scope.alterarIdioma = function (idioma) {
                        $scope.idiomaConfig.idiomaAtual = idioma.id;
                        TranslateService.alterarIdioma(idioma.id);
                    }
                }
            };

            if (TranslateService.verificarConfiguracao()) {
                exibirIdiomas();
            } else {
                $scope.$on('idiomaConfigurado', exibirIdiomas);
            }

            $scope.onAlterarSenhaExpirada = function (event) {
                event.preventDefault();

                if (!$scope.primeiroLogin) {

                    if (!$scope.formSenhaExpirada.SenhaAtual || !$scope.formSenhaExpirada.NovaSenha) {
                        return NotifyService.showMessage('telaAlterarSenha.naoFoiPossivelAtualizarASenha', "danger");
                    }
                    if ($scope.formSenhaExpirada.SenhaAtual === $scope.formSenhaExpirada.NovaSenha) {
                        return NotifyService.showMessage('telaAlterarSenha.aNovaSenhaDeveSerDiferenteDaAtual', "danger");
                    }

                }
                if ($scope.formSenhaExpirada.NovaSenha != $scope.formSenhaExpirada.ConfirmarNovaSenha) {
                    return NotifyService.showMessage('telaAlterarSenha.osCamposDevemSerIguais', "danger");
                }

                if (!$scope.primeiroLogin) {

                    UsuarioResource.AlterarSenhaExpirada($scope.formSenhaExpirada).$promise
                        .then(() => {
                            NotifyService.showMessage('telaAlterarSenha.senhaAtualizadaComSucesso', "success");
                            $state.go("login");
                        }).catch(function (error) {
                            if (error && error.data) {
                                NotifyService.showMessage(error.data.Message, "danger");
                            }
                        });
                } else {

                    UsuarioResource.AlterarSenhaPrimeiroLogin($scope.formSenhaExpirada).$promise
                        .then(() => {
                            NotifyService.showMessage('telaAlterarSenha.senhaAtualizadaComSucesso', "success");
                            $state.go("login");
                        }).catch(function (error) {
                            if (error && error.data) {
                                NotifyService.showMessage(error.data.Message, "danger");
                            }
                        });

                }


            }

            $scope.validateSenhaForte = function () {
                let novaSenha = $scope.formSenhaExpirada.NovaSenha || '';

                if (novaSenha.length >= 8 && novaSenha.length <= 16) {
                    $scope.senhaForteLength = true;
                } else {
                    $scope.senhaForteLength = false;
                }

                if(novaSenha.match(/[a-z]+/)) { 
                    $scope.senhaForteCaractereMinusculo = true;
                } else {
                    $scope.senhaForteCaractereMinusculo = false;
                }

                if(novaSenha.match(/[A-Z]+/)) {
                    $scope.senhaForteCaractereMaiusculo = true;
                } else {
                    $scope.senhaForteCaractereMaiusculo = false;
                }

                if(novaSenha.match(/[0-9]+/)) {
                    $scope.senhaForteCaractereNumerico = true;
                } else {
                    $scope.senhaForteCaractereNumerico = false;
                }

                if(novaSenha.match(/[\W|_]+/)) { 
                    $scope.senhaForteCaractereEspecial = true;
                } else {
                    $scope.senhaForteCaractereEspecial = false;
                }

                if($scope.senhaForteLength && $scope.senhaForteCaractereMinusculo &&
                    $scope.senhaForteCaractereMaiusculo && $scope.senhaForteCaractereNumerico &&
                    $scope.senhaForteCaractereEspecial){
                        $scope.senhaValida = true;
                }
			};


        }]);
})();
(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("AtendimentoAgendaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("AtendimentoAgenda/:Id", {
                "Id": "@Id"
            }, {
                    adicionarContato: {
                        method: "POST",
                        url: "AtendimentoAgenda"
                    },
                    atualizarContato: {
                        method: "PUT",
                        url: "AtendimentoAgenda"
                    },
                    removerContato: {
                        method: "DELETE",
                        url: "AtendimentoAgenda/:atendimentoAgendaId",
                        params: {
                            "atendimentoAgendaId": "@atendimentoAgendaId"
                        }
                    }
                });
        }]);
})();
(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("TabulacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Atendimento/:Id", {
                "Id": "@Id"
            }, {
                    ContatoNegativo: {
                        method: "POST",
                        url: "Atendimento/ContatoNegativo"
                    },
                    CaixaPostal: {
                        method: "POST",
                        url: "Atendimento/CaixaPostal",
                    },
                    Agendamento: {
                        method: "POST",
                        url: "Atendimento/Agendamento",
                    },
                    GetStatusDetalhePorUsuario: {
                        method: "GET",
                        url: "RamalStatusDetalhe/StatusDetalhePorUsuario",
                    },
                    UpdateStatus: {
                        method: "POST",
                        url: "RamalStatusDetalhe/UpdateStatus"
                    },
                    EnviarEmail: {
                        method: "POST",
                        url: "Atendimento/EnviarEmail"
                    },
                    GetConfiguracao: {
                        method: "GET",
                        url: "Atendimento/Configuracao",
                    },
                    Exportar: {
                        method: "POST",
                        url: "Atendimento/Exportar"
                    },
                    DownloadHistorico: {
                        url: "Atendimento/DownloadHistorico",
                        method: "GET"
                    },
                    GetCampos: {
                        method: "GET",
                        url: "AtendimentoLayouts/Campos",
                        isArray: true
                    },
                    GetCategorias: {
                        method: "GET",
                        url: "Atendimento/Categorias",
                        isArray: true
                    },
                    GetCategoriasPorTipo: {
                        method: "GET",
                        url: "Atendimento/Categorias",
                        isArray: true
                    },
                    GetTipos: {
                        method: "GET",
                        url: "Atendimento/Tipos",
                        isArray: true
                    },
                    GetTabulacoes: {
                        method: "GET",
                        url: "Atendimento/TabulacoesPorTelefone",
                        isArray: true
                    },
                    GetLigacoes: {
                        method: "GET",
                        url: "Atendimento/LigacoesPorTelefone",
                        isArray: true
                    },
                    GetCampanhas: {
                        method: "GET",
                        url: "Atendimento/Campanhas",
                        isArray: true
                    },
                    GetRotasDiscador: {
                        method: "GET",
                        url: "Rota/RotasDiscador",
                        isArray: true
                    },
                });
        }]);
})();
(function () {
    "use strict";

    var getOdataAtendimentoResouceShared = function (AtendimentoAgendaResource, search, orderBy, $odata) {
        var odata = AtendimentoAgendaResource.odata();

        if (search.filtro) {
            var predicate1 = new $odata.Predicate(new $odata.Func('contains', 'Contato', search.filtro), true);
            var predicate2 = new $odata.Predicate(new $odata.Func('contains', 'Telefone', search.filtro), true);
            var predicate3 = new $odata.Predicate(new $odata.Func('contains', 'Celular', search.filtro), true);
            var combination = $odata.Predicate.or([predicate1, predicate2, predicate3]);
            odata.filter(combination);
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.atendimento", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true
                })
                .state("main.atendimento.view", StateResolverProvider.configState("/atendimento", "Atendimento", "View", {
                    pageTitle: 'pageTitle.atendimento',
                    pageName: 'campo.visualizacao',
                    permissions: {
                        Atendimento: "Visualizar"
                    },
                    css: true,
                    startPage: true
                }))
        }])

        .service("AtendimentoViewData", function AtendimentoViewData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_clipboard'
                        ]);
                    }],
                    grupos: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getGrupos().$promise;
                    }],
                    rotasDiscadorList: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetRotasDiscador().$promise;
                    }],
                    contatos: ["AtendimentoAgendaResource", "$odata", "utils", function (AtendimentoAgendaResource, $odata, utils) {
                        let filtro = {};
                        let orderBy = {
                            column: "Contato",
                            order: "asc"
                        };

                        let odata = getOdataAtendimentoResouceShared(AtendimentoAgendaResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    configuracao: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetConfiguracao().$promise;
                    }],
                    sessao: ["SessaoUsuarioResource", function (SessaoUsuarioResource) {
                        return SessaoUsuarioResource.getIp().$promise;
                    }],
                    maquina: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }],
                    atendimentoConfiguracao: ["AtendimentoConfiguracaoResource", "AuthService", function (AtendimentoConfiguracaoResource, AuthService) {
                        let usuario = AuthService.getUsuarioLogado();
                        return AtendimentoConfiguracaoResource.GetConfiguracaoAtendimentoSimples({
                            Id: usuario.AtendimentoConfiguracaoId
                        }).$promise;
                    }],
                    softphone: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getSoftphone().$promise;
                    }],
                    infoRamal: ["RamalResource", "AuthService", function (RamalResource, AuthService) {
                        let ramalId = AuthService.getUsuarioLogado().RamalId;
                        return RamalResource.getInfo(ramalId).$promise;
                    }]
                };
            };
        })

        .filter('filtroRamalTabulacao', function () {
            return function (items, search) {
                let ramais = items;
                if (search) {
                    ramais = _.filter(ramais, function (item) {
                        return item.UsuarioNome.toLowerCase().indexOf(search.toLowerCase()) >= 0 || item.Numero.toString().indexOf(search) >= 0;
                    });
                }
                return ramais;
            }
        })
        .controller("AtendimentoViewController",
            ["$scope", "$rootScope", "AuthService", "AtendimentoService", "$http", "EventoAcaoService", "ATENDIMENTO_EVENTS", "AtendimentoAgendaResource", "RamalSupervisaoResource", "LigacaoResource", "sessao", "Config", "contatos", "grupos", "configuracao", "rotasDiscadorList", "$interval", "$odata", "utils", "NotifyService", "maquina", "infoRamal", "$translate", "ModalService", "AUTH_EVENTS", "atendimentoConfiguracao", "softphone", "SoftphoneService", "RamalResource", function (
                $scope,
                $rootScope,
                AuthService,
                AtendimentoService,
                $http,
                EventoAcaoService,
                ATENDIMENTO_EVENTS,
                AtendimentoAgendaResource,
                RamalSupervisaoResource,
                LigacaoResource,
                sessao,
                Config,
                contatos,
                grupos,
                configuracao,
                rotasDiscadorList,
                $interval,
                $odata,
                utils,
                NotifyService,
                maquina,
                infoRamal,
                $translate,
                ModalService,
                AUTH_EVENTS,
                atendimentoConfiguracao,
                softphone,
                SoftphoneService,
                RamalResource) {

                $rootScope.page_full_height = true;
                $scope.configurado = false;
                $scope.configuracao = configuracao;
                $scope.abrirTelaDiscando = false;
                $scope.statusLigacao = '';
                $scope.statusDiscagemErro = '';
                $scope.abaSelecionado = 3;
                $scope.ramalByGrupo = [];
                $scope.participantes = [];
                $scope.contatos = contatos;
                $scope.rotasDiscadorList = rotasDiscadorList;
                $scope.rotaDiscador = null;
                $scope.numeroDiscador = '';
                $scope.intervaloOptions = {};
                $scope.search = {};
                $scope.contato = {};
                $scope.tempoStatus = 0;
                $scope.tipoTransferencia = 0;
                $scope.emConsulta = false;
                $scope.exibindoMensagem = false;
                $scope.mensagemErroConsulta = null;
                $scope.erroConsulta = false;
                $scope.chamadaAtiva = false;
                $scope.IntervaloAtual = undefined;
                $scope.emEspera = false;
                $scope.isConferenciaEmAndamento = false;
                $scope.telefoneChamada = '';
                $scope.origemChamada = '';
                $scope.pesquisaHistorico = '';
                $scope.isRamal = false;
                $scope.isConferencia = false;
                $scope.historico = [];
                $scope.historicoCopy = [];
                $scope.configuracoesRamal = [];
                $scope.currentPage = 1;
                $scope.sigame = {
                    habilitado: false,
                    configurado: false,
                    externo: false,
                    telefone: ''
                };
                $scope.multiSigame = {
                    habilitado: false,
                    configurado: false,
                    externo: false,
                    telefone: ''
                };
                $scope.conexao = {
                    ValorTelefonia: ' '
                };
                $scope.transferencia = {
                    Telefone: '',
                    Ramal: ''
                };

                $scope.infoRing = {
                    ativo: false,
                    servico: null,
                    telefone: null,
                    atendido: false
                };

                $scope.TelefoniaTipos = [
                    { TelefoniaTipoId: 1, Descricao: $translate.instant('telaAtendimento.analogico') },
                    { TelefoniaTipoId: 2, Descricao: $translate.instant('telaAtendimento.telefoneIp') },
                    { TelefoniaTipoId: 3, Descricao: $translate.instant('telaAtendimento.softphone') }
                ];

                $scope.atendimentoConfiguracao = atendimentoConfiguracao;
                $scope.softphone = softphone;
                $scope.infoRamal = infoRamal;

                $scope.usuario = AuthService.getUsuarioLogado();
                $scope.RAMAIS_PA = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "ListarRamais") ? 0 : 1;
                $scope.permissaoTransferenciaRamal = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "ListarRamaisTransferencia") ? true : false;

                /// Variáveis globais para 
                /// controle da reconexão TalkFone
                $scope.retryCount = 0;
                $scope.maxRetries = 3;
                $scope.registerTimeout = null;
                $scope.EnderecoSipWebRTC = null;
                $scope.conectandoSoftphone = false;

                EventoAcaoService.init($scope);

                $('#modal_transferencia').on({
                    'show.uk.modal': function () { },
                    'hide.uk.modal': function () {
                        $scope.isRamal = false;
                        $scope.isConferencia = false;
                    }
                });


                $scope.atenderLigacao = function () {
                    $scope.infoRing.atendido = true;

                    AtendimentoService.atendeChamada().then(function () {
                        $scope.hideModalRing();
                    });
                }

                $scope.showModalConexao = function () {
                    ModalService.openModal('modal_conectar');
                };

                /**
                 * Valores possíveis para status:
                 * 
                 * status: 'primary',     // Azul padrão
                 * status: 'success',     // Verde
                 * status: 'warning',     // Amarelo/Laranja
                 * status: 'danger',      // Vermelho
                 * status: 'info',        // Azul claro
                 * status: 'secondary',   // Cinza
                 * status: 'contrast',    // Branco/Preto (depende do tema)
                 * 
                 */
                $scope.exibirMensagem = function (mensagem, status, params) {
                    NotifyService.showMessage(mensagem, status, params);
                };

                $scope.grupos = _.sortBy(grupos, function (grupo) { return grupo.Descricao });
                $scope.grupos.splice(0, 0, { GrupoId: 0, Descricao: $translate.instant('campo.todos') });

                $scope.getIp = function () {
                    var isIp = $scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3 ? $scope.conexao.isRamal == 'true' ? false : true : false;
                    var isRamal = $scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3 ? $scope.conexao.isRamal == 'true' ? true : false : false;
                    if (isIp) {
                        $scope.conexao.ValorTelefonia = sessao.Ip;
                    } else if (isRamal) {
                        var user = AuthService.getUsuarioLogado();
                        $scope.conexao.ValorTelefonia = user.RamalNumero;
                    } else {
                        $scope.conexao.ValorTelefonia = '';
                    }

                };

                $scope.testeIPRAMAL = function () {
                    console.log($scope.conexao)
                    console.log($scope.TelefoniaTipos)
                }


                $scope.conexao.TelefoniaTipoId = maquina[0].PlataformaId;

                if ($scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3) {
                    if ($scope.atendimentoConfiguracao.ConexaoAutomatica) {
                        if ($scope.atendimentoConfiguracao.TipoConexao == 1) {
                            $scope.conexao.isRamal = 'true';
                        } else {
                            $scope.conexao.isRamal = 'false';
                        }
                        $scope.conexao.TelefoniaTipoId = $scope.atendimentoConfiguracao.TipoTelefonia;

                    } else {
                        $scope.conexao.isRamal = 'false';
                    }
                    $scope.getIp();
                }

                $scope.abrirTransferencia = function () {
                    ModalService.isHidden('modal_transferencia', function () {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;
                        $scope.transferencia = { Telefone: '', Ramal: '' };
                        $scope.tipoTransferencia = 2;
                        $scope.grupoSelecionado = 0;
                        $scope.erroTelefone = false;
                        $scope.listarRamais(false);
                    });
                };

                $scope.showModalRing = function () {
                    $scope.infoRing.ativo = true;
                    let modal = UIkit.modal("#modalLigacaoRing");
                    modal.options.bgclose = false;
                    modal.options.keyboard = false;
                    modal.show();
                    let audioElem = $("#phoneRingAudio")[0];
                    audioElem.play();
                };

                $scope.hideModalRing = function () {
                    $scope.infoRing.ativo = false;
                    let modal = UIkit.modal("#modalLigacaoRing");
                    modal.hide();
                    let audioElem = $("#phoneRingAudio")[0];
                    audioElem.pause();
                };

                $scope.onChangeTipoTransferencia = function (tipo) {
                    try {
                        if ($scope.emConsulta) {
                            return;
                        }

                        $scope.tipoTransferencia = tipo;

                        switch (tipo) {
                            case 2: // Ramal
                                $scope.filtroTransferencia = '';
                                $scope.transferencia.Ramal = '';
                                $scope.filtrarRamais({ GrupoId: 0 });
                                break;
                            case 1: // Externo
                                $scope.transferencia.Telefone = '';
                                $scope.transferencia.Ramal = '';
                                break;
                        }
                    } catch (ex) {
                        NotifyService.showError(ex);
                    }
                }

                $scope.getHistorico = function () {
                    let user = AuthService.getUsuarioLogado();
                    let promise = LigacaoResource.getHistorico({ ramalId: user.RamalId }).$promise;
                    if (promise) {
                        promise.then(function (response) {
                            $scope.historico = response;
                            $scope.historicoCopy = $scope.historico;
                        }).catch(function () {
                            $scope.exibirMensagem('telaAtendimento.erroAoObterHistorico', "danger")
                        });
                    }
                }

                $scope.pageChanged = function (newPage) {
                    $scope.currentPage = newPage;
                    if (newPage > 0) {
                        newPage = (newPage - 1) * 10;
                    }

                    let final = newPage + 10;

                    $scope.historicoCopy = [];
                    angular.copy($scope.historico, $scope.historicoCopy);

                    if ($scope.search.pesquisaHistorico != '' && $scope.search.pesquisaHistorico != undefined) {
                        $scope.historicoCopy = _.filter($scope.historicoCopy, function (el) {
                            return el.NB.includes($scope.search.pesquisaHistorico)
                        });

                        if (final > $scope.historicoCopy.length) {
                            final = $scope.historicoCopy.length;
                        }
                    }
                    else {
                        if (final > $scope.historico.length) {
                            final = $scope.historico.length;
                        }
                    }

                    $scope.historicoCopy = $scope.historicoCopy.splice(newPage, final);
                    return $scope.historicoCopy;
                };

                $scope.onChangeFiltroContato = function () {
                    return getOdataAtendimentoSearch()
                        .query().then(updateList).catch(NotifyService.showError);
                }

                $scope.onChangeFiltroHistorico = function () {
                    $scope.pageChanged(1);
                }

                let getOdataAtendimentoSearch = function getOdataAtendimentoSearch() {
                    return getOdataAtendimentoResouceShared(AtendimentoAgendaResource, $scope.search, $scope.orderBy, $odata, utils);
                };

                $scope.pageChangedContatos = function (newPage) {
                    return getOdataAtendimentoSearch()
                        .page($scope.contatos.pageSize, newPage)
                        .query().then(updateList).catch(NotifyService.showError);
                };

                let updateList = function (list) {
                    $scope.contatos = list;
                    $scope.contatos.recordCount = list.$recordCount || list.length;
                    $scope.contatos.currentPage = list.$currentPage || 1;
                    $scope.contatos.pageSize = list.$pageSize || 10;
                    $scope.searching = false;
                };

                updateList(contatos);

                $scope.removerContato = function (contato) {
                    ModalService.confirmDelete(function () {
                        var promise = AtendimentoAgendaResource.removerContato({ atendimentoAgendaId: contato.Id }).$promise;
                        if (promise) {
                            promise.then(function () {
                                $scope.exibirMensagem('telaAtendimento.contatoRemovidoComSucesso', "success");
                                $scope.onChangeFiltroContato();
                            }).catch(function () {
                                $scope.exibirMensagem('telaAtendimento.ocorreuUmErroAoRemoverContato', "danger");
                            });
                        }
                    });
                }

                $scope.onLigarHistorico = function (telefone) {
                    ModalService.closeModal('modal_transferencia');
                    $scope.numeroDiscador = telefone;
                    $scope.discadorInterno = ($scope.numeroDiscador.length <= 5);
                    $scope.onCallNumeroDiscador();
                }

                $scope.onAdicionarConferenciaHistorico = function (telefone) {
                    if (!telefone) {
                        return false;
                    }

                    let existe = _.filter($scope.participantes, function (el) {
                        return el.Numero == telefone;
                    });

                    if (existe.length == 1) {
                        $scope.exibirMensagem('telaAtendimento.numeroJaAdicionadoNaConferencia', 'danger');
                        return;
                    }

                    let participante = { Numero: telefone, Status: $translate.instant('telaAtendimento.aguardando'), TempoIniciado: $scope.tempoStatus };
                    var tipoDiscagem = telefone.length <= 5 ? 2 : 1;

                    $scope.participantes.push(participante);

                    AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);

                    setTimeout(function () {
                        $scope.mudarAba(2);
                        $("#conferencia").click();
                    }, 200);

                    return true;
                }

                $scope.listarRamais = function (isRefresh) {
                    $scope.isRamalLoading = true;
                    RamalSupervisaoResource.getSimples().$promise
                        .then((response) => {
                            $scope.isRamalLoading = false;
                            $scope.ramais = response;

                            if (!isRefresh) {
                                $scope.transferencia.Telefone = '';
                                $scope.filtrarRamais({ GrupoId: 0 });
                            }

                        }).catch(() => {
                            $scope.isRamalLoading = false;
                        });
                }

                $scope.filtrarRamais = function (grupo) {
                    if ($scope.emConsulta || $scope.isRamalLoading) {
                        return;
                    }

                    $scope.grupoSelecionado = grupo.GrupoId;

                    if ($scope.isRamal) {
                        $scope.transferencia.Ramal = grupo.RamalNumero;
                    }

                    if (!$scope.permissaoTransferenciaRamal) {
                        $scope.ramalByGrupo = [];
                    } else {
                        $scope.ramalByGrupo = (grupo.GrupoId == 0) ? $scope.ramais : _.filter($scope.ramais, function (item) { return item.Grupos.indexOf(grupo.GrupoId) >= 0 });
                    }

                    grupo.RamalNumero ? $scope.transferencia.Telefone = grupo.RamalNumero : $scope.transferencia.Telefone = '';
                }

                $scope.onSelectRamal = function (ramal) {
                    try {
                        if ($scope.emConsulta) {
                            return;
                        }

                        if ($scope.transferencia.Telefone == ramal) {
                            $scope.transferencia.Telefone = '';
                            return;
                        }

                        $scope.transferencia.Telefone = ramal;
                        $scope.transferencia.Ramal = '';

                    } catch (ex) {
                        NotifyService.showError(ex);
                    }
                }

                $scope.enviarConsulta = function () {
                    try {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;

                        let telefone = ($scope.transferencia.Ramal == '' || $scope.transferencia.Ramal == undefined) ? $scope.transferencia.Telefone :
                            $scope.transferencia.Ramal;

                        let erroTelefone = !telefone || (telefone.length < 7 && $scope.tipoTransferencia == 1);
                        if (erroTelefone)
                            return;

                        AtendimentoService.consultar(telefone, $scope.tipoTransferencia)
                            .then(function () {
                                $scope.emConsulta = true;
                                $scope.exibirMensagem('telaAtendimento.consultandoOutroRamal', 'success');
                            })
                            .catch(function () {
                                $scope.emConsulta = false;
                                var mensagem = $scope.tipoTransferencia == 2 ? $translate.instant('telaAtendimento.naoFoiPossivelConsultarORamal') :
                                    $translate.instant('telaAtendimento.naoFoiPossivelConsultarOTelefone');
                                $scope.mostrarErroConsulta(mensagem);
                            });

                    } catch (ex) {
                        var mensagem = $scope.tipoTransferencia == 2 ? $translate.instant('telaAtendimento.naoFoiPossivelConsultarORamal') :
                            $translate.instant('telaAtendimento.naoFoiPossivelConsultarOTelefone');
                        $scope.mostrarErroConsulta(mensagem);
                    }
                };

                $scope.sairConsulta = function (esconderMensagem) {
                    try {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;
                        $scope.emConsulta = false;
                        AtendimentoService.liberarConsulta()
                            .then(function () {
                                if (esconderMensagem) {
                                    $scope.esconderMensagem();
                                }
                            });
                    } catch (ex) {
                        $scope.emConsulta = true;
                        $scope.mostrarErroConsulta($translate.instant('telaAtendimento.naoFoiPossivelSairDaConsulta'));
                    }
                };

                $scope.mostrarErroConsulta = function (mensagem) {
                    $scope.mensagemErroConsulta = mensagem;
                    $scope.erroConsulta = true;
                }

                $scope.esconderMensagem = function () {
                    $scope.exibindoMensagem = false;
                };

                $scope.enviarTransferencia = function () {
                    $scope.mensagemErroConsulta = null;
                    $scope.erroConsulta = false;

                    let telefone = ($scope.transferencia.Ramal == '' || $scope.transferencia.Ramal == undefined) ? $scope.transferencia.Telefone : $scope.transferencia.Ramal;
                    $scope.transferidoAcaoId = 6;
                    $scope.erroTelefone = !telefone || (telefone.length < 7 && $scope.tipoTransferencia == 1);

                    if ($scope.erroTelefone) {
                        return;
                    }

                    try {
                        AtendimentoService.transferir(telefone, $scope.tipoTransferencia)
                            .then(function () {
                                $scope.emConsulta = false;
                                ModalService.closeModal('modal_transferencia');
                            })
                            .catch(function () {
                                $scope.mostrarErroConsulta($translate.instant('telaAtendimento.naoFoiPossivelTransferirALigacao'));
                            });
                    }
                    catch (ex) {
                        $scope.mostrarErroConsulta($translate.instant('telaAtendimento.naoFoiPossivelTransferirALigacao'));
                    }
                };

                $scope.mudarAba = function (abaIndex) {
                    $scope.abaSelecionado = abaIndex;

                    if (abaIndex == 1) {
                        $scope.getHistorico();
                    }
                }

                $scope.iniciarConexao = function (form) {
                    if (form != null && !form.$valid) {
                        NotifyService.showInvalid();
                        return;
                    }

                    localStorage.setItem("config_ramal", JSON.stringify($scope.conexao));

                    if ($scope.conexao.ValorTelefonia && $scope.conexao.ValorTelefonia != '') {
                        ModalService.closeModal('modal_conectar');
                        $scope.erroConexaoValor = false;

                        if (maquina.length > 0) $scope.dddPadrao = maquina[0].DDD + '';
                        else $scope.dddPadrao = null;

                        if ($scope.softphone != null && $scope.softphone.Ativo) {
                            if ($scope.infoRamal != null && $scope.infoRamal.IsWebRTC == true) {

                                let result = $scope.getEnderecoSipWebRTC();
                                if (!result || result.enderecoSipWebRTC == null || result.enderecoSipWebRTC == "") {

                                    if (result.errorMsg) {

                                        let timestamp = new Date().toLocaleTimeString();
                                        console.log(`[${timestamp}] ${result.errorMsg}`);
                                    }
                                    $scope.exibirMensagem('telaAtendimento.erroNaoExisteEnderecoSipWebRTC', 'danger');
                                }
                                else {
                                    $scope.EnderecoSipWebRTC = result.enderecoSipWebRTC;
                                    $scope.conectandoSoftphone = true;
                                    $scope.iniciaRegistroTalkfone();
                                }
                            }
                            else {
                                $scope.logarRamal();
                            }
                        }
                        else {
                            $scope.logarRamal();
                        }
                    } else {
                        $scope.erroConexaoValor = true;
                    }
                };

                let filtroConfig = JSON.parse(localStorage.getItem("config_ramal"));
                if (filtroConfig != null && !$scope.atendimentoConfiguracao.ConexaoAutomatica) {
                    $scope.conexao = filtroConfig;
                }

                $scope.onClearNumeroDiscador = function () {
                    $scope.numeroDiscador = '';
                    $scope.rotaDiscador = null;
                    $scope.discadorInterno = false;
                    document.querySelector('#numeroDiscador').focus();
                }

                $scope.desligarLigacao = function () {
                    if ($scope.abrirTelaDiscando && ($scope.chamadaAtiva || $scope.discando)) {
                        AtendimentoService.desligar();
                    }
                };

                $scope.iniciarTerminarEspera = function () {
                    if ($scope.emEspera) {
                        AtendimentoService.terminarEspera();
                        $scope.emEspera = false;
                    }
                    else {
                        AtendimentoService.iniciarEspera();
                        $scope.emEspera = true;
                    }
                }

                $scope.onKeyUpDiscarNumero = function (event) {
                    if (event.keyCode === 13) {
                        $scope.onCallNumeroDiscador();
                        return true;
                    } else {
                        $scope.discadorInterno = ($scope.numeroDiscador.length <= 5);
                        return false;
                    }
                }

                $scope.onCallNumeroDiscador = function () {
                    if ($scope.numeroDiscador && $scope.numeroDiscador != '') {
                        var tipo = $scope.discadorInterno ? 2 : 1;

                        if ($scope.rotaDiscador) {
                            AtendimentoService.discarRota($scope.numeroDiscador, $scope.rotaDiscador).catch(function (erro) {
                                $scope.exibirMensagem(erro.message, "danger");
                            });
                        } else {
                            AtendimentoService.discar($scope.numeroDiscador, tipo).catch(function (erro) {
                                $scope.exibirMensagem(erro.message, "danger");
                            });
                        }
                    }
                }

                $scope.onSelectNumeroDiscador = function (numero) {
                    let numDiscador = document.querySelector('#numeroDiscador');

                    if (numero != '') {
                        var str = ($scope.numeroDiscador !== undefined) ? $scope.numeroDiscador : numDiscador.val();
                        $scope.numeroDiscador = str.substring(0, numDiscador.selectionStart) + numero + str.substring(numDiscador.selectionEnd);
                        numDiscador.focus();

                        if ($scope.chamadaAtiva) {
                            AtendimentoService.enviaDigitosDtmf(numero).catch(function (erro) {
                                $scope.exibirMensagem(erro.message, "danger");
                            });
                        }
                    }

                    $scope.discadorInterno = ($scope.numeroDiscador.length <= 5);
                }

                $scope.exibirIntervaloMensagem = function () {
                    if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloLivre) {
                        $scope.exibirMensagem('telaAtendimento.aguardandoLigacao', 'success');
                    } else if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloNaoDisponivel) {
                        $scope.exibirMensagem('telaAtendimento.naoDisponivelParaLigacao', 'warning');
                    } else {
                        $scope.esconderMensagem();
                    }
                }

                $scope.alterarIntervaloHub = function (intervaloId) {
                    AtendimentoService.alterarIntervaloTipo(intervaloId).catch(function () {
                        $scope.exibirMensagem('telaAtendimento.erroAoAlterarIntervalo', 'danger');
                    });
                };

                $scope.trataIntervaloAtual = function () {
                    if ($scope.intervaloOptions && $scope.intervaloSelecionado > 0) {
                        var intervaloSelecionado = $scope.intervaloOptions[$scope.intervaloSelecionado];
                        if (intervaloSelecionado) {
                            $scope.IntervaloAtual = intervaloSelecionado;
                        }
                    }
                };

                $scope.mudarIntervaloMenu = function (intervalo) {
                    if ($scope.intervaloSelecionado != intervalo.RamalStatusDetalheId) {
                        $scope.alterarIntervaloHub(intervalo.RamalStatusDetalheId);
                    }
                };

                $scope.$on(ATENDIMENTO_EVENTS.onSetIntervaloRamal, function (event, ramal, status) {

                    if (status.Status == 1) return;

                    $scope.intervaloSelecionado = parseInt(status.RamalStatusDetalheId);

                    if ($scope.infoRing.ativo && !$scope.infoRing.atendido) {
                        $scope.hideModalRing();
                    }

                    $scope.trataIntervaloAtual();
                    $scope.reiniciarTimerStatus(ramal.Propriedades.DataHoraInicioIntervalo);
                });


                $scope.$on(ATENDIMENTO_EVENTS.onInfoIntervaloRamal, function (event, ramal, infoIntervalo) {
                    $scope.intervaloOptions[infoIntervalo.RamalStatusDetalheId] = {
                        Descricao: infoIntervalo.Descricao,
                        Produtivo: infoIntervalo.Produtivo,
                        RamalStatusDetalheId: infoIntervalo.RamalStatusDetalheId
                    };

                    $scope.trataIntervaloAtual();
                });

                $scope.onAdicionarConferencia = function () {
                    let telefone = $scope.numeroDiscador == '' ? $scope.telefoneChamada : $scope.numeroDiscador;

                    if (!telefone) return false;

                    let existe = _.filter($scope.participantes, function (el) {
                        return el.Numero == telefone;
                    });

                    if (existe.length == 1) {
                        $scope.exibirMensagem('telaAtendimento.numeroJaAdicionadoNaConferencia', 'danger');
                        return;
                    }

                    var participante = { Numero: telefone, Status: $translate.instant('telaAtendimento.aguardando'), TempoIniciado: $scope.tempoStatus };

                    $scope.participantes.push(participante);

                    var tipoDiscagem = telefone.length <= 5 ? 2 : 1;

                    if (!$scope.isConferenciaEmAndamento && $scope.abaSelecionado != 2) {
                        $scope.iniciarTimerStatus();
                        AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                        AtendimentoService.conferenciaIniciar();
                        $scope.isConferenciaEmAndamento = true;
                    } else {
                        AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                    }

                    return true;
                }

                $scope.onRemoverConferencia = function (numero) {
                    if (!numero) return;

                    if ($scope.isConferenciaEmAndamento) {
                        AtendimentoService.conferenciaRemover(numero);
                    }

                    $scope.participantes = _.without($scope.participantes, _.findWhere($scope.participantes, { Numero: numero }));
                }

                $scope.onOpenConferencialRamallModal = function () {
                    $scope.isConferencia = true;
                    $scope.abrirTransferencia();
                }

                $scope.onOpenRamalModal = function () {
                    $scope.isRamal = true;
                    $scope.abrirTransferencia();
                }

                $scope.onLigarRamal = function () {
                    var telefone = $scope.transferencia.Telefone == '' ? $scope.transferencia.Ramal : $scope.transferencia.Telefone;
                    ModalService.closeModal('modal_transferencia');
                    $scope.isRamal = false;
                    $scope.numeroDiscador = telefone;
                    $scope.discadorInterno = true;
                    $scope.onCallNumeroDiscador();
                }

                $scope.onAdicionarParticipante = function () {
                    let telefone = $scope.transferencia.Telefone == '' ? $scope.transferencia.Ramal : $scope.transferencia.Telefone;

                    if (!telefone) return false;

                    telefone = telefone.toString();

                    let existe = _.filter($scope.participantes, function (el) {
                        return el.Numero == telefone;
                    });

                    if (existe.length == 1) {
                        $scope.exibirMensagem('telaAtendimento.numeroJaAdicionadoNaConferencia', 'danger');
                        return;
                    }

                    $scope.isConferencia = false;
                    $scope.isRamal = false;
                    ModalService.closeModal('modal_transferencia');

                    let participante = { Numero: telefone, Status: $translate.instant('telaAtendimento.aguardando'), TempoIniciado: $scope.tempoStatus };
                    var tipoDiscagem = telefone.length <= 5 ? 2 : 1;

                    $scope.participantes.push(participante);

                    AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                }

                $scope.iniciarConferencia = function () {
                    $scope.abrirTelaDiscando = false;
                    setTimeout(function () {
                        $scope.mudarAba(2);
                        $("#conferencia").click();
                    }, 200);

                    $scope.iniciarTimerStatus();
                    $scope.isConferenciaEmAndamento = true;
                    AtendimentoService.conferenciaIniciar();
                }

                $scope.finalizarConferencia = function () {
                    $scope.participantes = [];
                    $scope.isConferenciaEmAndamento = false;
                    $scope.pararTimerStatus();
                    AtendimentoService.conferenciaTerminar();
                }

                $scope.adicionarContato = function () {
                    $scope.contato = {};
                    ModalService.openModal('modal_contato');
                }

                $scope.editarContato = function (contato) {
                    $scope.contato = contato;
                    ModalService.openModal('modal_contato');
                }

                $scope.gravarContato = function (form) {
                    if (form != null && !form.$valid) {
                        NotifyService.showInvalid();
                        return;
                    }

                    if ($scope.contato.Telefone == undefined && $scope.contato.Celular == undefined) {
                        NotifyService.showError(null, 'telaAtendimento.necessarioInformarTelefone');
                        return;
                    }
                    let promise = null;
                    if ($scope.contato.Id == undefined) {
                        promise = AtendimentoAgendaResource.adicionarContato($scope.contato).$promise;
                    } else {
                        promise = AtendimentoAgendaResource.atualizarContato($scope.contato).$promise;
                    }

                    if (promise != null) {
                        promise.then(function () {
                            $scope.exibirMensagem('telaAtendimento.contatoGravadoComSucesso', "success");
                            $scope.onChangeFiltroContato();
                            $scope.contato = {};
                            ModalService.closeModal('modal_contato');
                        }).catch(function () {
                            $scope.exibirMensagem('telaAtendimento.erroAoGravarContato', "danger");
                        });
                    }
                }

                $scope.gravarSigame = function (form) {
                    if (form != null && !form.$valid) {
                        NotifyService.showInvalid();
                        return;
                    }

                    let data = {};

                    var configuracoes = _.find($scope.configuracoesRamal, function (conf) {
                        return conf.Descricao == "Ramal";
                    });

                    var configuracaoSigaMe = _.find(configuracoes.Campos, function (conf) {
                        return conf.Campo == "siga_me_externo";
                    });

                    var configuracaoFlagMultiSigaMe = _.find(configuracoes.Campos, function (conf) {
                        return conf.Campo == "flag_multi_siga_me";
                    });

                    var configuracaoMultiSigaMe = _.find(configuracoes.Campos, function (conf) {
                        return conf.Campo == "multi_siga_me";
                    });

                    if ($scope.sigame.configurado) {
                        if (configuracaoSigaMe != null)
                            data[configuracaoSigaMe.TemplateCampoId] = $scope.sigame.telefone;

                        if (configuracaoFlagMultiSigaMe != null)
                            data[configuracaoFlagMultiSigaMe.TemplateCampoId] = "0";

                        if (configuracaoMultiSigaMe != null)
                            data[configuracaoMultiSigaMe.TemplateCampoId] = "";
                    }
                    else {
                        data[configuracaoSigaMe.TemplateCampoId] = "";
                    }


                    if ($scope.multiSigame.configurado) {

                        if (configuracaoMultiSigaMe != null)
                            data[configuracaoMultiSigaMe.TemplateCampoId] = $scope.multiSigame.telefone;

                        if (configuracaoFlagMultiSigaMe != null)
                            data[configuracaoFlagMultiSigaMe.TemplateCampoId] = "1";

                        if (configuracaoSigaMe != null)
                            data[configuracaoSigaMe.TemplateCampoId] = "";
                    } else {
                        data[configuracaoMultiSigaMe.TemplateCampoId] = "";
                        data[configuracaoFlagMultiSigaMe.TemplateCampoId] = "0";
                    }

                    $http.put(Config.getUrl("Ramal/Update?id=" + $scope.usuario.RamalId), data).then(() => {
                        $scope.exibirMensagem('telaAtendimento.sigaMeConfiguradoComSucesso', 'success')
                    }, function () {
                        $scope.exibirMensagem('telaAtendimento.erroAoTentarConfigurarSigaMe', 'danger');
                    });


                    // if ($scope.sigame.configurado) {
                    //     AtendimentoService.sigaMe($scope.sigame.telefone, $scope.sigame.externo ? 1 : 2).then(function () {
                    //         $scope.exibirMensagem('telaAtendimento.sigaMeConfiguradoComSucesso', "success")
                    //         $scope.sigame.habilitado = true;

                    //     })
                    //         .catch(function () {
                    //             $scope.exibirMensagem('telaAtendimento.erroAoTentarConfigurarSigaMe', 'danger');
                    //         });
                    // }

                    // else {
                    //     AtendimentoService.cancelaSigaMe().then(function () {
                    //         $scope.exibirMensagem('telaAtendimento.sigaMeCanceladoComSucesso', "success")
                    //         $scope.iniciarConexao();
                    //     })
                    //         .catch(function () {
                    //             $scope.exibirMensagem('telaAtendimento.erroAoTentarCancelarSigaMe', 'danger');
                    //         });
                    // }

                    // //////////////////////////////////MULTI SIGAME//////////////////////////////////
                    // //////////////////////////////////MULTI SIGAME//////////////////////////////////
                    // //////////////////////////////////MULTI SIGAME//////////////////////////////////
                    // //////////////////////////////////MULTI SIGAME//////////////////////////////////
                    // //////////////////////////////////MULTI SIGAME//////////////////////////////////

                    // if ($scope.multiSigame.configurado) {
                    //     AtendimentoService.multiSigame($scope.multiSigame.telefone, $scope.multiSigame.externo ? 1 : 2).then(function () {
                    //         $scope.exibirMensagem('telaAtendimento.sigaMeConfiguradoComSucesso', "success")
                    //         $scope.multiSigame.habilitado = true;

                    //     })
                    //         .catch(function () {
                    //             $scope.exibirMensagem('telaAtendimento.erroAoTentarConfigurarSigaMe', 'danger');
                    //         });
                    // }

                    // else {
                    //     AtendimentoService.cancelaMultiSigaMe().then(function () {
                    //         $scope.exibirMensagem('telaAtendimento.sigaMeCanceladoComSucesso', "success")
                    //         $scope.iniciarConexao();
                    //     })
                    //         .catch(function () {
                    //             $scope.exibirMensagem('telaAtendimento.erroAoTentarCancelarSigaMe', 'danger');
                    //         });
                    // }
                }

                $scope.onChangeTipoDiscagem = function () {
                    $scope.sigame.telefone = '';
                }

                //numeroDiscador é o numero do ramal que está tocando
                $scope.efetuarCaptura = function () {
                    if ($scope.numeroDiscador == '')
                        return;

                    AtendimentoService.capturaDirigida($scope.numeroDiscador);
                }

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaTermino, function () {
                    $scope.isConferenciaEmAndamento = false;
                    $scope.pararTimerStatus();
                });

                $scope.$on(ATENDIMENTO_EVENTS.onDiscaStatus, function (event, ramal, chamada, status) {
                    switch (status.StatusDiscagem) {
                        case -2:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.desconhecido');
                            break;
                        case -1:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.naoAtende');
                            break;
                        case 0:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.ocupado');
                            break;
                        case 1:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.congestionamento');
                            break;
                        case 2:
                            $scope.statusDiscagemErro = $translate.instant('model.servico');
                            break;
                        case 3:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.ramalDesligou');
                            break;
                        case 4:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.canaisBloqueados');
                            break;
                        case 5:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.rotaInvalida');
                            break;
                        case 6:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.canaisOcupados');
                            break;
                        case 7:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.prefixoBloqueado');
                            break;
                    }
                    $scope.exibirMensagem($scope.statusDiscagemErro, 'danger');
                });

                $scope.$on(ATENDIMENTO_EVENTS.onDiscaStatusInterno, function (event, ramal, chamada, status) {

                    switch (status) {
                        case -1:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.desconhecido');
                            break;
                        case 3:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.erroDiscagem');
                            break;
                        case 4:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.ramalInvalido');
                            break;
                        case 5:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.ocupado');
                            break;
                        case 6:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.ramalNaoLogado');
                            break;
                        case 7:
                            $scope.statusDiscagemErro = $translate.instant('telaAtendimento.ramalEntrouFila');
                            $scope.abrirTelaDiscando = true;
                            break;
                    }

                    if (status != 2) {
                        $scope.ischamadaInterna = true;
                        $scope.exibirMensagem($scope.statusDiscagemErro, 'danger');
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.onLogado, function (event, data) {

                    NotifyService.hideLoading();

                    $scope.configurado = true;
                    setTimeout(function () {
                        $scope.mudarAba(0);
                        $("#contatos").click();
                    }, 200);

                    if (data.ChamadaAtiva && !data.Conferencia.ConferenciaIniciada) {
                        $scope.chamadaAtiva = true;
                        $scope.abrirTelaDiscando = true;
                        $scope.telefoneChamada = data.ChamadaAtiva.Telefone;
                        $scope.origemChamada = '';
                        if (data.ChamadaAtiva.NomeRamal != undefined && data.ChamadaAtiva.NomeRamal != null) {
                            $scope.origemChamada = data.ChamadaAtiva.NomeRamal;
                        }
                        if (data.ChamadaAtiva.Destinatario != undefined && data.ChamadaAtiva.Destinatario != null) {
                            $scope.origemChamada = "Serviço " + data.ChamadaAtiva.Destinatario;
                        }
                        $scope.pararTimerStatus();
                        $scope.reiniciarTimerStatus(data.DataSetIntervalo);
                    } else if (data.Conferencia.ConferenciaIniciada) {
                        $scope.isConferenciaEmAndamento = true;
                        setTimeout(function () {
                            $scope.mudarAba(2);
                            $("#conferencia").click();
                        }, 200);

                        $scope.preencheParticipantes(data.Conferencia.Chamadas);
                    }
                    else {
                        $scope.chamadaAtiva = false;
                        $scope.isConferenciaEmAndamento = false;
                    }

                    $scope.sigame.habilitado = data.SigaMeAtivo;
                    $scope.sigame.configurado = data.SigaMeAtivo;
                    $scope.sigame.externo = data.NumeroSigaMe != null && data.NumeroSigaMe.length > 6;
                    $scope.multiSigame.habilitado = data.SigaMeMultiAtivo;
                    $scope.multiSigame.configurado = data.SigaMeMultiAtivo;
                    // $scope.multiSigame.externo = data.NumeroSigaMe != null && data.NumeroSigaMe.length > 6;

                    if (data.SigaMeAtivo)
                        $scope.sigame.telefone = data.NumeroSigaMe;
                    else
                        $scope.sigame.telefone = '';

                    if (data.SigaMeMultiAtivo)
                        $scope.multiSigame.telefone = data.NumeroSigaMe;
                    else
                        $scope.multiSigame.telefone = '';
                    $scope.trataIntervaloAtual();
                });

                $scope.preencheParticipantes = function preencheParticipantes(lista) {
                    $scope.participantes = [];
                    var user = AuthService.getUsuarioLogado();
                    var chamadas = _.filter(lista, function (chamada) {
                        return chamada.Telefone != user.RamalNumero;
                    });

                    chamadas.forEach(function (chamada) {
                        var participante = { Numero: chamada.Telefone, Status: $translate.instant('telaAtendimento.ligacao'), TempoIniciado: 0 };
                        $scope.participantes.push(participante);
                    });
                }
                /**
                 *  IdEmUso = 3,
                 *  RamalInvalido = 4,
                 *  RamalEmUso = 5,
                 *  SenhaInvalida = 6,
                 *  ParametroInvalido = 7,
                 *  RamalNaoCadastrado = 8,
                 *  /// <summary>
                 *  /// Ocorre quando o softphone ou telefone sip está desconectado 
                 *  /// </summary>
                 *  ContaSipNaoLogadaNoTelefone = 9,
                 *  SemRecursoVozDisponivel = 10,
                 *  ForaDaJornadaTrabalho = 11,
                 *  NotDocumented = 12,
                 *  ErroSistema = 13,
                 *  /// <summary>
                 *  /// Quando o arquivo com o intervalo é inválido
                 *  /// </summary>
                 *  IntervaloInvalido = 14,
                 *  ParametrosIncompletos = 15,
                 *  RamalGrupoInvalido = 16,
                 *  StatusGrupoInvalido = 17
                 * 
                 */
                $scope.$on(ATENDIMENTO_EVENTS.onLogadoErro, function (event, data, erro) {

                    NotifyService.hideLoading();
                    $scope.configurado = false;

                    if (!erro) {

                        NotifyService.showMessageExt(
                            'telaAtendimento.statusLogonDesconhecido',
                            'danger',
                            null,
                            2000
                        ).then(function () {
                            $scope.showModalConexao();
                        });
                        return;
                    }

                    let mensagem = erro.Message;
                    let statusLogonRetorno = $scope.getStatusLogonRetornoObject(erro.StatusCode);
                    if (statusLogonRetorno) {
                        mensagem = statusLogonRetorno.Descricao;
                    }

                    NotifyService.showMessageExt(
                        mensagem,
                        'danger',
                        null,
                        2000
                    ).then(function () {
                        if (typeof statusLogonRetorno.callback === 'function') {
                            statusLogonRetorno.callback();
                        }
                        else {
                            $scope.showModalConexao();
                        }
                   });
                });

                $scope.$on(ATENDIMENTO_EVENTS.onConexaoErro, function () {
                    $scope.configurado = false;
                    setTimeout(function () {
                        $scope.showModalConexao();
                    }, 200);
                });

                $scope.$on(ATENDIMENTO_EVENTS.onDiscaErro, function () {
                    $scope.discando = false;
                    $scope.abrirTelaDiscando = false;
                    $scope.pararTimerStatus();
                });

                $scope.discando = false;
                $scope.$on(ATENDIMENTO_EVENTS.onDisca, function () {
                    $scope.discando = true;
                    $scope.abrirTelaDiscando = true;
                    $scope.telefoneChamada = $scope.numeroDiscador;
                    $scope.origemChamada = '';
                    $scope.statusLigacao = `${$translate.instant('telaAtendimento.discando')}...`;
                });

                $scope.trataIntervaloAtualEmLigacao = function () {

                    $scope.reiniciarTimerStatus(null);

                    $scope.intervaloSelecionado = 5;

                    if ($scope.intervaloOptions && $scope.intervaloSelecionado > 0) {
                        var intervaloSelecionado = $scope.intervaloOptions[$scope.intervaloSelecionado];
                        if (intervaloSelecionado) {
                            $scope.IntervaloAtual = intervaloSelecionado;
                        }
                    }
                };

                $scope.$on(ATENDIMENTO_EVENTS.onAtendido, function (event, data) {
                    $scope.statusLigacao = $translate.instant('telaAtendimento.emLigacao');
                    $scope.trataIntervaloAtualEmLigacao();

                    if ($scope.infoRing.ativo) {
                        $scope.hideModalRing();
                    }

                    if (!$scope.chamadaAtiva || data.ChamadaAtiva) {
                        if (!$scope.discando) {
                            $scope.abrirTelaDiscando = true;
                        }
                        $scope.chamadaAtiva = true;
                        $scope.telefoneChamada = data.ChamadaAtiva.Telefone;
                        $scope.origemChamada = '';
                        if (data.ChamadaAtiva.NomeRamal != undefined && data.ChamadaAtiva.NomeRamal != null) {
                            $scope.origemChamada = data.ChamadaAtiva.NomeRamal;
                        }
                        if (data.ChamadaAtiva.Destinatario != undefined && data.ChamadaAtiva.Destinatario != null) {
                            $scope.origemChamada = "Serviço " + data.ChamadaAtiva.Destinatario;
                        }
                        $scope.pararTimerStatus();
                    }

                    $scope.iniciarTimerStatus();
                    $scope.discando = false;
                });

                $scope.$on(ATENDIMENTO_EVENTS.onRingSip, function (event, ramal, chamada) {
                    $scope.showModalRing();
                });

                $scope.showModalConexao();

                $scope.$on(ATENDIMENTO_EVENTS.onDesliga, function () {
                    $scope.infoRing.atendido = false;
                    $scope.chamadaAtiva = false;
                    $scope.pararTimerStatus();
                    $scope.statusLigacao = $translate.instant('telaAtendimento.desligando')
                    setTimeout(function () {
                        if (!$scope.chamadaAtiva)
                            $scope.abrirTelaDiscando = false;
                        $scope.$apply();
                    }, 1000);
                });

                $scope.$on(ATENDIMENTO_EVENTS.onChamadaPerdida, function () {
                    $scope.statusLigacao = $translate.instant('telaAtendimento.chamadaPerdida')
                    $scope.pararTimerStatus();
                    setTimeout(function () {
                        if (!$scope.chamadaAtiva)
                            $scope.abrirTelaDiscando = false;
                        $scope.$apply();
                    }, 1000);
                });

                $scope.$on(ATENDIMENTO_EVENTS.onInicioEspera, function () {
                    $scope.emEspera = true;
                });

                $scope.$on(ATENDIMENTO_EVENTS.onTerminoEspera, function () {
                    $scope.emEspera = false;
                });

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaChamadaEncerrada, function (event, data, error) {
                    $scope.participantes.forEach(function (participante) {
                        if (participante.Numero.includes(error.Telefone)) {
                            participante.TempoIniciado = $scope.tempoStatus;
                            participante.Status = $translate.instant('telaAtendimento.encerrado');
                        }
                    });

                    var encerrado = _.filter($scope.participantes, function (chamada) {
                        return chamada.Status == $translate.instant('telaAtendimento.encerrado');
                    });

                    if (encerrado.length == $scope.participantes.length) {
                        $scope.finalizarConferencia();
                    }

                });

                $scope.$on(ATENDIMENTO_EVENTS.Conferencia_OnAtendido, function (event, data, error) {
                    var participante = _.filter($scope.participantes, function (chamada) {
                        return chamada.Numero.includes(error.Telefone);
                    });

                    if (participante.length == 1) {
                        participante[0].TempoIniciado = $scope.tempoStatus;
                        participante[0].Status = $translate.instant('telaAtendimento.atendido');
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.Conferencia_OnDisca, function (event, data, error) {
                    var participante = _.filter($scope.participantes, function (chamada) {
                        return chamada.Numero.includes(error.Telefone);
                    });

                    if (participante.length == 1)
                        participante[0].Status = $translate.instant('telaAtendimento.discando');
                });

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaTermino, function () {
                    $scope.isConferenciaEmAndamento = false;
                    $scope.pararTimerStatus();
                });

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaErro, function () {
                    $scope.exibirMensagem('telaAtendimento.erroNaConferencia', "danger");
                });

                $scope.chamadasFila = {};
                $scope.existeFila = false;

                $scope.$on(ATENDIMENTO_EVENTS.onChamadaEntrouNaFila, function (event, ramal, chamada) {
                    $scope.chamadasFila[chamada.CanalId] = chamada;

                    $scope.exibirMensagem('telaAtendimento.recebendoChamada', 'warning', { 'Numero': chamada.Telefone });

                    $scope.abrirTelaDiscando = true;
                    $scope.existeFila = true;
                });

                $scope.$on(ATENDIMENTO_EVENTS.onChamadaSaiuDaFila, function (event, ramal, chamada) {
                    delete $scope.chamadasFila[chamada.CanalId];

                    if (!$scope.chamadasFila.length > 0)
                        $scope.existeFila = false;
                });

                // $scope.setTimerStatus = function (dataDiffIntervalo) {
                //     if (dataDiffIntervalo == null || Number.isNaN(dataDiffIntervalo)) {
                //         $scope.tempoStatus = 0;
                //     } else {                 
                //         $scope.tempoStatus = parseInt(dataDiffIntervalo);
                //     }
                // };

                // $scope.reiniciarTimerStatus = function (dataDiffIntervalo) {
                //     $scope.podeRealizarTimeout = false;
                //     $interval.cancel($scope.timer);
                //     $scope.setTimerStatus(dataDiffIntervalo);
                //     $scope.podeRealizarTimeout = true;
                //     $scope.iniciarTimerStatus();
                // };

                $scope.setTimerStatus = function (dataHoraInicioIntervalo) {
                    if (dataHoraInicioIntervalo) {
                        // Verificar se é uma string e converter para formato ISO
                        if (typeof dataHoraInicioIntervalo === 'string') {
                            // Converter para objeto Date primeiro
                            let dataObj = new Date(dataHoraInicioIntervalo);
                            var now = moment();
                            var data = moment(dataObj); // Agora é um objeto Date válido
                            var duration = moment.duration(now.diff(data));
                            $scope.tempoStatus = Math.floor(duration.asSeconds()); // Usar Math.floor para inteiro
                        } else {
                            // Se já for um objeto Date
                            var now = moment();
                            var data = moment(dataHoraInicioIntervalo);
                            var duration = moment.duration(now.diff(data));
                            $scope.tempoStatus = Math.floor(duration.asSeconds());
                        }
                    }
                    else {
                        $scope.tempoStatus = 0;
                    }
                };

                $scope.iniciarTimerStatus = function () {
                    $scope.timer = $interval(function () {
                        $scope.tempoStatus += 1;
                    }, 1000);
                };

                $scope.pararTimerStatus = function () {
                    $scope.tempoStatus = 0;
                    $interval.cancel($scope.timer);
                };

                $scope.reiniciarTimerStatus = function (dataHoraInicioIntervalo) {
                    $interval.cancel($scope.timer);
                    $scope.setTimerStatus(dataHoraInicioIntervalo);
                    $scope.iniciarTimerStatus();
                };

                $scope.$on('$destroy', function () {
                    // Cancela as tentativas de reconexão
                    if ($scope.registerTimeout) {
                        clearTimeout($scope.registerTimeout);
                        $scope.registerTimeout = null;
                    }
                    AtendimentoService.terminar();
                    $scope.pararTimerStatus();
                });

                $rootScope.$on(AUTH_EVENTS.userLogout, function () {
                    AtendimentoService.terminar();
                });

                var carregarConfiguracoesRamal = function () {
                    RamalResource.getRamalCampos({ Id: $scope.usuario.RamalId }).$promise
                        .then(function (response) {
                            $scope.configuracoesRamal = response;
                        }).catch(NotifyService.showError);
                }

                $scope.getTipoLogon = function () {
                    let tipoLogon = 0;

                    if ($scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3) {
                        if ($scope.conexao.isRamal == 'true') {
                            tipoLogon = 3;
                        } else {
                            tipoLogon = 2;
                        }
                    } else {
                        tipoLogon = 1;
                    }
                    return tipoLogon;
                }

                 // Função auxiliar para criar os itens
                $scope.createStatus = function (id, nome, descricao, callback) {
                    return {
                        id: id,
                        callback: callback || $scope.finalizaLogon,
                        nome: nome,
                        Descricao: descricao
                    };
                }

                // Array completo com callback para tratar os erros
                // e descrições para tradução
                $scope.RamalStatusLogonArray = [
                    $scope.createStatus(3, 'IdEmUso', 'telaAtendimento.idEmUso'),
                    $scope.createStatus(4, 'RamalInvalido', 'telaAtendimento.ramalInvalido'),
                    $scope.createStatus(5, 'RamalEmUso', 'telaAtendimento.ramalEmUso', $scope.tentativaRamalEmUsoLogon),
                    $scope.createStatus(6, 'SenhaInvalida', 'telaAtendimento.senhaInvalida'),
                    $scope.createStatus(7, 'ParametroInvalido', 'telaAtendimento.parametroInvalido'),
                    $scope.createStatus(8, 'RamalNaoCadastrado', 'telaAtendimento.ramalNaoCadastrado'),
                    $scope.createStatus(9, 'ContaSipNaoLogadaNoTelefone', 'telaAtendimento.contaSipNaoLogadaNoTelefone'),
                    $scope.createStatus(10, 'SemRecursoVozDisponivel', 'telaAtendimento.semRecursoVozDisponivel'),
                    $scope.createStatus(11, 'ForaDaJornadaTrabalho', 'telaAtendimento.foraDaJornadaTrabalho'),
                    $scope.createStatus(12, 'NotDocumented', 'telaAtendimento.notDocumented'),
                    $scope.createStatus(13, 'ErroSistema', 'telaAtendimento.erroSistema'),
                    $scope.createStatus(14, 'IntervaloInvalido', 'telaAtendimento.intervaloInvalido'),
                    $scope.createStatus(15, 'ParametrosIncompletos', 'telaAtendimento.parametrosIncompletos'),
                    $scope.createStatus(16, 'RamalGrupoInvalido', 'telaAtendimento.ramalGrupoInvalido'),
                    $scope.createStatus(17, 'StatusGrupoInvalido', 'telaAtendimento.GrupoInvalido')
                ];

                $scope.getStatusLogonRetornoObject = function (value) {
                    let status = $scope.RamalStatusLogonArray.find(item => item.id === value);
                    return status;
                }

                $scope.logarRamal = function () {
                    NotifyService.showLoading('telaAtendimento.realizandoLogin')
                    let tipoLogon = $scope.getTipoLogon();
                    AtendimentoService.iniciar($scope.conexao.ValorTelefonia, tipoLogon, false)
                        .catch(data => {
                            NotifyService.hideLoading();
                            let user = AuthService.getUsuarioLogado();
                            if (!user.RamalNumero || user.RamalNumero == '') {
                                NotifyService.showMessageExt(
                                    'telaAtendimento.usuarioNaoPossuiRamal',
                                    'danger',
                                    null,
                                    2000
                                ).then(function () {
                                    $scope.showModalConexao();
                                });
                            } else {
                                NotifyService.showMessageExt(
                                    'telaAtendimento.erroAoConectarComOAtendimento',
                                    'danger',
                                    { 'Message': data.message },
                                    2000
                                ).then(function () {
                                    $scope.showModalConexao();
                                });
                            }
                        });
                }

                // Apenas uma nova tentativa em caso de ramal em uso
                $scope.callbacklogonRamalEmUso = true;
                $scope.tentativaRamalEmUsoLogon = function () {

                    if ($scope.callbacklogonRamalEmUso) {
                        // Apenas uma nova tentativa
                        $scope.callbacklogonRamalEmUso = false;
                        $scope.logarRamal();
                    }
                    else {
                        $scope.showModalConexao();
                    }
                }

                $scope.finalizaLogon = function () {
                    $scope.showModalConexao();
                }

                // Função auxiliar para criar os itens
                $scope.createStatus = function (id, nome, descricao, callback) {
                    return {
                        id: id,
                        callback: callback || $scope.finalizaLogon,
                        nome: nome,
                        Descricao: descricao
                    };
                }

                // #region [Conexão Talkfone]


                /**
                 * Valida se a variável maquina é valida
                 */
                $scope.getEnderecoSipWebRTC = function () {

                    let enderecoSipWebRTC = null;
                    let errorMsg = null;
                    let result = {};

                    // Verificação simplificada mas eficaz
                    if (!maquina || !Array.isArray(maquina) || maquina.length === 0 ||
                        !maquina[0] || !maquina[0].EnderecoSipWebRTC) {

                        errorMsg = !maquina ? 'maquina é null/undefined' :
                            !Array.isArray(maquina) ? 'maquina não é array' :
                                maquina.length === 0 ? 'maquina está vazio' :
                                    !maquina[0] ? 'primeiro elemento inválido' :
                                        'EnderecoSipWebRTC não configurado';
                    }
                    else {
                        enderecoSipWebRTC = maquina[0].EnderecoSipWebRTC;
                    }
                    result.errorMsg = errorMsg;
                    result.enderecoSipWebRTC = enderecoSipWebRTC;
                    return result;
                }

                /**
                 * Gerencia timeouts no registro do softphone com integração com SoftphoneService
                 * @description Notifica o usuário sobre falha na conexão e attempt reconexão automática
                 */
                $scope.timeoutRegisterSoftphone = function () {

                    // Reseta registerTimeout
                    $scope.registerTimeout = null;

                    // Realiza a tentativa de reconexão
                    // até exceder o número máximo de tentativas
                    $scope.attemptSoftphoneReconnection();
                }

                /**
                 * Função interna para realizar a reconexão do softphone
                 */
                $scope.attemptSoftphoneReconnection = function () {

                    NotifyService.hideLoading();

                    // Agenda próxima tentativa se não houver sucesso
                    $scope.retryCount = $scope.retryCount + 1;
                    if ($scope.retryCount <= $scope.maxRetries) {

                        NotifyService.showMessageExt(
                            'talkFone.tentativaRegistroTalkfone',
                            'info',
                            { 'retryCount': $scope.retryCount },
                            2000
                        ).then(function () {
                            $scope.iniciaRegistroTalkfone();
                        });

                    } else {
                        // Esgotou as tentativas
                        $scope.handleFinalFailure();
                    }
                }

                /**
                 * Manipula a falha definitiva após todas as tentativas
                 */
                $scope.handleFinalFailure = function () {

                    // Reseta contadores para futuras tentativas
                    $scope.resetReconnectionCounters();

                    console.error('Falha definitiva na reconexão do softphone');

                    NotifyService.showMessageExt(
                        'talkFone.excedeuTentativaRegistroTalkfone',
                        'danger',
                        { 'maxRetries': $scope.maxRetries },
                        2000
                    ).then(function () {
                        $scope.showModalConexao();
                    });
                }

                /**
                 * Reseta os contadores de reconexão
                 */
                $scope.resetReconnectionCounters = function () {
                    $scope.retryCount = 0;
                }

                /**
                 * Evento disparado quando o status do Register do softphone muda
                 */
                $scope.$on('softphone:RegistererState', function (event, infoRegister) {

                    // Cancela as tentativas de reconexão
                    if ($scope.registerTimeout) {
                        clearTimeout($scope.registerTimeout);
                        $scope.registerTimeout = null;
                    }

                    $scope.resetReconnectionCounters();

                    NotifyService.hideLoading();

                    /// Initial:
                    /// Registered:
                    /// Unregistered:
                    /// Terminated:
                    switch (infoRegister.state) {

                        case 'Initial':
                            break;

                        case 'Registered':
                            if (!$scope.conectandoSoftphone) {
                                return;
                            }
                            $scope.conectandoSoftphone = false;
                            $scope.logarRamal();
                            break;

                        /// TODO: Tratar Unregistered e Terminated
                        default:
                            //$scope.attemptSoftphoneReconnection();
                            break;
                    }
                })

                $scope.$on('softphone:WebrtcState', function (event, infoConnectWss) {

                    /// Connecting
                    /// Connected
                    /// Failed
                    /// AllServersFailed
                    /// Disconnected
                    /// Abortted
                    /// LastServersFailed
                    switch (infoConnectWss.state) {

                        case 'Abortted':
                            NotifyService.showMessageExt(
                                'talkFone.conexaoWssAbortada',
                                'danger',
                                { 'Detalhe': infoConnectWss.reason },
                                3000
                            ).then(function () {
                                $scope.showModalConexao();
                            });
                            break;

                        case 'Failed':
                        case 'LastServersFailed':
                            NotifyService.showMessage(
                                'talkFone.conexaoWssFalha',
                                'info',
                                { 'Detalhe': infoConnectWss.reason });
                            break;

                    }
                })

                $scope.iniciaRegistroTalkfone = function () {

                    let message = $translate.instant('talkFone.conectandoTalkfone', { retryCount: $scope.retryCount, maxRetries: $scope.maxRetries });
                    NotifyService.showLoading(message)

                    SoftphoneService.registrar(
                        $scope.softphone.UrlBase,
                        $scope.softphone.WebsocketUrl,
                        $scope.EnderecoSipWebRTC,
                        $scope.usuario.Ramal.Numero,
                        $scope.usuario.Ramal.Senha,
                        $scope.softphone.Debug
                    );

                    // Aguarda 7 segundos para verificar se houve resposta do registro ou erro
                    $scope.registerTimeout = setTimeout($scope.timeoutRegisterSoftphone, 7000);
                }

                // #endregion

                carregarConfiguracoesRamal();

            }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("AtendimentoCategoriaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CategoriaDiscagem/:CategoriaDiscagemId", { "CategoriaDiscagemId": "@CategoriaDiscagemId" },
                {
                    getAll: {
                        url: "CategoriaDiscagem",
                        method: "GET",
                        isArray: true
                    }
                }
            );
        }]);

})();


(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

            $stateProvider
                .state("main.atendimentoconfiguracoes.edit", StateResolverProvider.configState("/atendimentoconfiguracoes/{Id:[0-9]+}", "AtendimentoConfiguracao", "Edit", {
                    pageTitle: 'model.configuracaoDeAtendimento',
                    pageName: 'acoes.editar'
                }))
                .state("main.atendimentoconfiguracoes.new", StateResolverProvider.configState("/atendimentoconfiguracoes/new", "AtendimentoConfiguracao", "Edit", {
                    pageTitle: 'model.configuracaoDeAtendimento',
                    pageName: 'acoes.cadastrar'
                }));
        }])

        .service('AtendimentoConfiguracaoEditData', function AtendimentoConfiguracaoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    atendimentoConfiguracao: ["AtendimentoConfiguracaoResource", "$stateParams", function (AtendimentoConfiguracaoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return AtendimentoConfiguracaoResource.get({
                                Id: $stateParams.Id
                            }).$promise;
                        } else {
                            return {
                                Descricao: '',
                                Json: {
                                    Properties: {
                                        SystemTray: false,
                                        System: 1
                                    },
                                    Events: {
                                        OnAtendidoDiscador: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnAtendido: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnChamada: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnChamadaPerdida: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnChamadaLigacaoId: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnDesliga: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnLogado: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnLogadoErro: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnInicioIntervalo: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnInicioEspera: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnDisca: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnInicioNaoDisponivel: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnLoad: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnUnload: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        },
                                        OnInfoCliente: {
                                            ContinueOnFail: true,
                                            Actions: []
                                        }
                                    }
                                }
                            };
                        }
                    }]
                }
            }
        })

        .controller("AtendimentoConfiguracaoEditController", ["$scope", "atendimentoConfiguracao", "AtendimentoConfiguracaoResource", "UsuarioResource", "$odata", "$http", "$state", "NotifyService", "ModalService", "$translate", function ($scope, atendimentoConfiguracao, AtendimentoConfiguracaoResource,
            UsuarioResource, $odata, $http, $state, NotifyService, ModalService, $translate) {
            $scope.isEdit = atendimentoConfiguracao && atendimentoConfiguracao.Id ? true : false;
            $scope.isNew = atendimentoConfiguracao.Id > 0 ? false : true;
            $scope.atendimentoConfiguracao = atendimentoConfiguracao;
            $scope.tipoAtendimento = 1;
            $scope.methods = [
                { id: 'GET', descricao: 'GET' },
                { id: 'POST', descricao: 'POST' },
                { id: 'PUT', descricao: 'PUT' },
                { id: 'DELETE', descricao: 'DELETE' }
            ];
            $scope.PropriedadesStepData = {
                order: 1
            };
            $scope.EventosStepData = {
                order: 2
            };
            $scope.AcaoStepData = {
                order: 2,
                inside: 1,
                notVisible: true
            };
            $scope.UsuarioStepData = {
                order: 3
            };
            $scope.tiposAtendimento = [
                { id: 1, descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.dialPad') },
                { id: 2, descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.tabulador') }
            ];
            $scope.formaAtendimentos = [
                { id: 1, descricao: "Web" },
                { id: 2, descricao: "Desktop" }
            ];
            $scope.tiposRamal = [
                { id: 1, descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.aparelho') },
                { id: 2, descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.softphone') }
            ];
            $scope.TelefoniaTipos = [
                { TelefoniaTipoId: 2, Descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.telefoneIp') },
                { TelefoniaTipoId: 3, Descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.softphone') }
            ];
            $scope.ConexaoTipos = [
                { ConexaoTipoId: 1, Descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.ramal') },
                { ConexaoTipoId: 2, Descricao: $translate.instant('telaAtendimentoConfiguracaoEdit.ip') }
            ];
            $scope.addUsuario = function () {
                $scope.adicionandoUsuario = true;
            };
            var addUser = function () {
                $scope.usuarioSelected.Id = $scope.atendimentoConfiguracao.Id;
                $scope.atendimentoConfiguracao.Usuarios.push($scope.usuarioSelected);
                $scope.usuarioSelected = undefined;
                ModalService.closeModal('modalUsuario');
            };

            $scope.concluirAddUsuario = function () {
                if ($scope.usuarioSelected.UsuarioId != 0 && $scope.usuarioSelected.AtendimentoConfiguracaoId != $scope.atendimentoConfiguracao.Id) {
                    ModalService.confirmMessage('telaAtendimentoConfiguracaoEdit.usuarioJaAssociadoAoPerfil',
                        { 'Perfil': $scope.usuarioSelected.AtendimentoConfiguracao.Descricao }, () => addUser());
                } else if (!_.find($scope.atendimentoConfiguracao.Usuario, el => {
                    return el.UsuarioId == $scope.usuarioSelected.UsuarioId;
                })) {
                    addUser();
                } else {
                    $scope.messageError = $translate.instant('telaAtendimentoConfiguracaoEdit.usuarioJaAdicionadoAoPerfil');
                    $scope.usuarioSelected = undefined;
                }
            };

            $scope.cancelarAddUsuario = function () {
                $scope.adicionandoUsuario = false;
                $scope.usuarioSelected = undefined;
                ModalService.closeModal('modalUsuario');
            };

            $scope.removeUsuario = function (usuario) {
                ModalService.confirmDelete(() => {
                    $scope.atendimentoConfiguracao.Usuario = _.without($scope.atendimentoConfiguracao.Usuario, usuario);
                    $scope.saveProgress();
                });
            };

            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert("<h3>Detalhe</h3>" + descricao);
            };

            var mensagemSucesso = function (data) {
                if (data) $scope.atendimentoConfiguracao = data;
                NotifyService.showRegistroSalvo();
            }

            $scope.adicionar = function () {
                $scope.configuracao.Parameters.push({});
            };

            $scope.deleteParameters = function (item) {
                $scope.configuracao.Parameters.splice($scope.configuracao.Parameters.indexOf(item), 1);
            }

            $scope.extrairParametros = function () {
                $scope.configuracao.Parameters = [];
                $scope.configuracao.Url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (match, key, value) => {
                    $scope.configuracao.Parameters.push({
                        Key: key,
                        Value: value
                    });
                });

                setTimeout(() => {
                    $scope.configuracao.Url = $scope.configuracao.Url.split('&')[0];
                }, 100);
            };

            function addParam(url, param, value) {
                let a = document.createElement('a'),
                    regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
                let match, str = [];
                a.href = url;
                param = encodeURIComponent(param);
                while (match == regex.exec(a.search))
                    if (param != match[1]) str.push(match[1] + (match[2] ? "=" + match[2] : ""));
                str.push(param + (value ? "=" + encodeURIComponent(value) : ""));
                a.search = str.join("&");
                return a.href;
            }

            $scope.testar = function () {
                let parameters = {};
                angular.forEach($scope.configuracao.Parameters, item => {
                    addParam($scope.configuracao.Url, item.Key, item.Value);
                    parameters[item.Key] = item.value;
                });

                let headers = {};
                angular.forEach($scope.configuracao.Headers, item => {
                    headers[item.Key] = item.value;
                });

                $http({
                    method: $scope.configuracao.Method,
                    url: $scope.configuracao.Url,
                    params: parameters,
                    headers: headers
                }).then(data => {
                    // eslint-disable-next-line no-console
                    console.log(data);
                });
            }

            $scope.deleteHeaders = function (value) {
                $scope.configuracao.Headers.splice($scope.configuracao.Headers.indexOf(value), 1);
            };

            $scope.adicionarHeaders = function () {
                $scope.configuracao.Headers.push({});
            };

            $scope.isEditAction = false;
            $scope.isNewAction = false;
            $scope.eventKey = '';
            $scope.action = {};
            $scope.actionEdit = {};
            $scope.actions = [
                { Label: $translate.instant('telaAtendimentoConfiguracaoEdit.webService'), ActionName: 'WebService' },
                { Label: $translate.instant('telaAtendimentoConfiguracaoEdit.criarArquivo'), ActionName: 'EscreveArquivo' },
                { Label: $translate.instant('telaAtendimentoConfiguracaoEdit.executarPrograma'), ActionName: 'ExecutaPrograma' },
                { Label: $translate.instant('telaAtendimentoConfiguracaoEdit.abrirWebsite'), ActionName: 'AbrirWebsite' }
            ];

            $scope.newAction = function (actionName) {
                $scope.isNewAction = true;
                $scope.json.Events[$scope.eventKey].Actions.push({
                    ActionName: actionName
                });
            };

            $scope.cancelAction = function () {
                $scope.isEditAction = false;
                $scope.isNewAction = false;
                $scope.action = {};
            };

            $scope.editEvent = function (key) {
                $scope.eventKey = key;
                setTimeout(() => { }, 100)
            };

            $scope.download = function () {
                let obj = $scope.json;
                let data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(obj));
                let iframe = $("<iframe name='download' src=data:'" + data + "' style='display:none;' />");
                iframe.appendTo("body");
            };

            $scope.saveAction = function () {
                if (!$scope.action['ActionName']) {
                    return NotifyService.showInvalid();
                }

                if ($scope.action['ActionName'] == 'WebService' && (!$scope.action['Method'] || !$scope.action['Url'])) {
                    return NotifyService.showInvalid();
                }

                if ($scope.action['ActionName'] == 'AbrirWebsite' && !$scope.action['Website']) {
                    return NotifyService.showInvalid();
                }

                if ($scope.action['ActionName'] == 'ExecutaPrograma' && !$scope.action['Command']) {
                    return NotifyService.showInvalid();
                }

                $scope.atendimentoConfiguracao.Json.Events[$scope.eventKey].Actions.push($scope.action);
                $scope.action = {};
                $scope.forms.formEventos.$dirty = true;
                ModalService.closeModal('modalNewAction')
            };

            $scope.editado = false;
            $scope.onEditado = function () {
                $scope.editado = true;
            }

            $scope.editAction = function (modalId) {
                if ($scope.editado == true) {
                    $scope.forms.formEventos.$dirty = true;
                }

                ModalService.closeModal(modalId)
            };

            $scope.forms = {};
            $scope.exitValidationPropriedades = true;
            $scope.exitValidationEventos = true;
            $scope.exitValidationAcoes = true;

            $scope.salvar = function (form) {
                if (!form.$valid) return;

                let lastStep = form.$name == "forms.formEventos" ? true : false;

                if (form.$dirty) {
                    $scope.eventKey = '';
                    var promise;
                    if ($scope.atendimentoConfiguracao.Id > 0) {
                        promise = AtendimentoConfiguracaoResource.update($scope.atendimentoConfiguracao).$promise;
                    }
                    else {
                        promise = AtendimentoConfiguracaoResource.save($scope.atendimentoConfiguracao).$promise;
                    }

                    return promise.then(data => {
                        mensagemSucesso(data);
                        if (lastStep) {
                            $state.go('main.atendimentoconfiguracoes.list');
                        }
                    }).catch(NotifyService.showError);
                } else {
                    if (lastStep) {
                        $state.go('main.atendimentoconfiguracoes.list');
                    }
                }
            };

            $scope.deleteAction = function (obj, eventKey) {
                ModalService.confirmDelete(() => {
                    $scope.atendimentoConfiguracao.Json.Events[eventKey].Actions.splice($scope.atendimentoConfiguracao.Json.Events[eventKey].Actions.indexOf(obj), 1);
                    $scope.forms.formEventos.$dirty = true;
                    $scope.forms.formAcoes.$dirty = true;
                });
            };

            $scope.setFormPristine = function (form) {
                form.$setPristine();
            }

            $scope.clearAcao = function () {
                $scope.action = {};
            }

            $scope.adicionarParametroUrl = function (actionEdit, tipoAtendimento, tipoParametro) {
                if (!actionEdit.Url.includes('?')) actionEdit.Url += '?';
                else actionEdit.Url += '&';
                
                switch (tipoParametro) {
                    case "ramal":
                        if (tipoAtendimento == 1) actionEdit.Url += "Ramal={{Ramal}}"
                        else actionEdit.Url += "Ramal={{Sender.Ramal}}"
                        break;
                    case "telefone":
                        if (tipoAtendimento == 1) actionEdit.Url += "Telefone={{Telefone}}"
                        else actionEdit.Url += "Telefone={{ChamadaDiscador.Telefone}}"
                        break;
                    case "codigoCliente":
                        if (tipoAtendimento == 1) actionEdit.Url += "CodigoCliente={{CodigoCliente}}"
                        else actionEdit.Url += "Telefone={{ChamadaDiscador.CodigoCliente}}"
                        break;
                    case "globalId":
                        if (tipoAtendimento == 1) actionEdit.Url += "GlobalId={{GlobalId}}"
                        else actionEdit.Url += "Telefone={{ChamadaDiscador.GlobalId}}"
                        break;
                    default:
                        break;
                }
            }

        }]);
})
    ();

(function () {
	"use strict";

	var getOdataSearchShared = function (AtendimentoConfiguracaoResource, search, orderBy, $odata) {
		var odata = AtendimentoConfiguracaoResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.Descricao) {
			odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
		}

		return odata;
	};

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.atendimentoconfiguracoes", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.atendimentoconfiguracoes.list',
						pageTitle: 'model.configuracaoDeAtendimento',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.atendimentoconfiguracoes.list", StateResolverProvider.configState("/atendimentoconfiguracoes", "AtendimentoConfiguracao", "List", {
					pageTitle: 'model.configuracaoDeAtendimento',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service('AtendimentoConfiguracaoListData', function AtendimentoConfiguracaoListData() {
			return function () {
				return {
					configuracoes: ["AtendimentoConfiguracaoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (AtendimentoConfiguracaoResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};

						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroConfiguracaoJson");
						}

						var orderBy = {
							column: "Descricao",
							order: "asc"
						};

						var odata = getOdataSearchShared(AtendimentoConfiguracaoResource, filtro, orderBy, $odata);
						return odata.page(10, 1).query();
					}]
				}
			}
		})

		.controller("AtendimentoConfiguracaoListController",
			["$scope", "configuracoes", "AtendimentoConfiguracaoResource", "$odata", "LocalStorageService", "$stateParams", "Config", "NotifyService", "ModalService", function ($scope, configuracoes, AtendimentoConfiguracaoResource, $odata, LocalStorageService, $stateParams, Config, NotifyService, ModalService) {
				$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroConfiguracaoJson") : {};
				$scope.orderBy = {
					column: "Descricao",
					order: "asc"
				};

				var updateList = function (list) {
					$scope.configuracoes = list;
					$scope.configuracoes.recordCount = list.$recordCount || list.length;
					$scope.currentPage = list.$currentPage || 1;
					$scope.configuracoes.pageSize = list.$pageSize || 10;
				}

				var getOdataSearch = function () {
					return getOdataSearchShared(AtendimentoConfiguracaoResource, $scope.search, $scope.orderBy, $odata);
				}

				$scope.executeSearch = function executeSearch() {
					LocalStorageService.setItem('FiltroConfiguracaoJson', $scope.search);
					getOdataSearch()
						.page($scope.search.pageSize, 1)
						.query().then(updateList).catch(NotifyService.showError);
				}

				$scope.confirmDelete = function (value) {
					ModalService.confirmDelete(function () {
						AtendimentoConfiguracaoResource.delete(value).$promise
							.then(function () {
								$scope.pageChanged($scope.currentPage)
							}).catch(NotifyService.showError);
					});
				};

				$scope.pageChanged = function (newPage) {
					return getOdataSearch().page($scope.configuracoes.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
				};

				updateList(configuracoes);

				$scope.limparFiltro = function () {
					LocalStorageService.removeItem('FiltroConfiguracaoJson');
					$scope.search = { pageSize: 10 };
				};

				$scope.download = function (configuracao) {
					var url = Config.getUrl('AtendimentoConfiguracao/Download') + '/' + configuracao.AtendimentoConfiguracaoId;
					var iframe = $("<iframe src='" + url + "' style='display:none;' />");
					iframe.appendTo("body");
				};
			}]
		);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("AtendimentoConfiguracaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("AtendimentoConfiguracao/:Id", { "Id": "@Id" }, {
                GetConfiguracaoAtendimento: {
                    method: "GET",
                    url: "AtendimentoConfiguracao/ConfiguracaoAtendimento",
                },
                GetConfiguracaoAtendimentoSimples: {
                    method: "GET",
                    url: "AtendimentoConfiguracao/ConfiguracaoAtendimentoSimples",
                },
            });
        }]);

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.atendimentoIntegracao.new", StateResolverProvider.configState("/AtendimentoIntegracao/new?page", "AtendimentoIntegracao", "Edit", {
                    pageTitle: 'integracaoEditTranslation.Titulo',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.atendimentoIntegracao.edit", StateResolverProvider.configState("/AtendimentoIntegracao/{AtendimentoIntegracaoTemplateId:[0-9]+}", "AtendimentoIntegracao", "Edit", {
                    pageTitle: 'integracaoEditTranslation.Titulo',
                    pageName: 'acoes.editar'
                }))
        }])
        .service('AtendimentoIntegracaoEditData', function PesquisaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    integracao: ["IntegracaoResource", "$stateParams", function (IntegracaoResource, $stateParams) {
                        if ($stateParams.AtendimentoIntegracaoTemplateId) {
                            return IntegracaoResource.GetId({ Id: $stateParams.AtendimentoIntegracaoTemplateId }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    templateMiner: ["IntegracaoResource", function (IntegracaoResource) {                   
                        return IntegracaoResource.GetTemplateMiner().$promise;
                    }],
                    atendimentoIntegracaoTemplateTipo: ["IntegracaoResource", function (IntegracaoResource) {                   
                        return IntegracaoResource.GetAtendimentoIntegracaoTemplateTipo().$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }]
                }
            }
        })
        .controller("AtendimentoIntegracaoEditController", ["$scope", "$window", "$state", "$q", "$stateParams", "WizardHandler", "IntegracaoResource", "integracao", "AtendimentoIntegracaoResource", "NotifyService", "ModalService", "$translate", "templateMiner", "atendimentoIntegracaoTemplateTipo", "carteiras", function AtendimentoIntegracaoEditController($scope, $window, $state, $q, $stateParams, WizardHandler, IntegracaoResource, integracao, AtendimentoIntegracaoResource,
            NotifyService, ModalService, $translate, templateMiner, atendimentoIntegracaoTemplateTipo, carteiras) {

            $scope.isEdit = integracao && integracao.AtendimentoIntegracaoTemplateId ? true : false;
            $scope.isNew = integracao.AtendimentoIntegracaoTemplateId > 0 ? false : true;
            $scope.forms = [];
            $scope.Parameters = {};
            $scope.Headers = {};
            $scope.Campo = {};
            $scope.Integracao = {};

            $scope.listParameters = [];
            $scope.listHeaders = [];
            $scope.ListCampos = [];
            $scope.miner = false;
            $scope.templateMiner = templateMiner;
            $scope.templateMinerCampos = [];
            $scope.atendimentoIntegracaoTemplateTipo = atendimentoIntegracaoTemplateTipo;
            $scope.proximoStep = false;
            $scope.carteiras = carteiras;
            $scope.campoAgrupamento = '';
            $scope.apiParametrosTeste = {}

            $scope.methods = [{ id: 1, value: 'GET' }, { id: 2, value: 'POST' }]
            $scope.tiposParametros = [{ id: 0, value: 'Livre' },
            { id: 1, value: 'GlobalId' },
            { id: 2, value: 'Telefone' },
            { id: 3, value: 'Cliente' },
            { id: 4, value: 'InfoAdicional1' },
            { id: 5, value: 'InfoAdicional2' },
            { id: 6, value: 'InfoAdicional3' },
            { id: 7, value: 'InfoAdicional4' },
            { id: 8, value: 'InfoAdicional5' }
            ]

            $scope.listaCamposManager = [
                { id: 1, value: 'CodigoCliente', consultar: true },
                { id: 2, value: 'Nome' , consultar: false },
                { id: 3, value: 'Telefone' , consultar: true},
                { id: 4, value: 'InfoAdicional1' , consultar: false},
                { id: 5, value: 'InfoAdicional2' ,consultar: false},
                { id: 6, value: 'InfoAdicional3' ,consultar: false},
                { id: 7, value: 'InfoAdicional4' ,consultar: false},
                { id: 8, value: 'InfoAdicional5' ,consultar: false}
            ]

            function load(value) {
                if ($scope.isNew) return;

                $scope.Integracao = value;

                if ($scope.Integracao.TemplateMinerId) {
                    IntegracaoResource.GetTemplateMinerCampos({ templateMinerId: $scope.Integracao.TemplateMinerId }).$promise.then((data) => {
                        if (data) {
                            angular.copy(data, $scope.templateMinerCampos);
                        }
                    }).catch(NotifyService.showError);
                } else {
                    $scope.templateMinerCampos = [];
                }

                $scope.listParameters = JSON.parse(value.Parameters) || [];
                $scope.listHeaders = JSON.parse(value.Headers) || [];
                $scope.ListCampos = value.AtendimentoIntegracaoTemplateCampo.sort();
            }

            $scope.onChangeTipoParametro = function () {
                if ($scope.Integracao.tipoParametro > 0)
                    $scope.Parameters.Key = $scope.tiposParametros[$scope.Integracao.tipoParametro].value;

                var id = document.querySelector("#keyParameters");
                angular.element(id).focus();
            }

            $scope.AdicionarParameters = function () {

                if ($scope.Integracao.tipoParametro != 0)
                    $scope.Parameters.Value = "@" + $scope.tiposParametros[$scope.Integracao.tipoParametro].value;

                if (!$scope.Parameters.Key || !$scope.Parameters.Value) {
                    NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgAddCampo'));
                    return;
                }

                var retorno = $scope.listParameters.filter(function (model) {
                    return model.key == $scope.Parameters.Key && model.value == $scope.Parameters.Value;
                });

                if (retorno.length > 0)
                    NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgExisteCampo'));
                else
                    $scope.listParameters.push({ key: $scope.Parameters.Key, value: $scope.Parameters.Value });

                $scope.forms.formProvedor.$setDirty();
                $scope.forms.formTemplate.$setDirty();
            }

            $scope.RemoverParameters = function (item) {
                $scope.listParameters.splice($scope.listParameters.indexOf(item), 1);

                $scope.forms.formProvedor.$setDirty();
                $scope.forms.formTemplate.$setDirty();
            }

            $scope.AdicionarHeaders = function () {

                if (!$scope.Headers.Key || !$scope.Headers.Value) {
                    NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgAddCampo'));
                    return;
                }

                var retorno = $scope.listHeaders.filter(function (model) {
                    return model.key == $scope.Headers.Key && model.value == $scope.Headers.Value;
                });

                if (retorno.length > 0)
                    NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgExisteCampo'));
                else
                    $scope.listHeaders.push({ key: $scope.Headers.Key, value: $scope.Headers.Value });


                $scope.forms.formProvedor.$setDirty();
                $scope.forms.formTemplate.$setDirty();
            }

            $scope.RemoverHeaders = function (item) {
                $scope.listHeaders.splice($scope.listHeaders.indexOf(item), 1);

                $scope.forms.formProvedor.$setDirty();
                $scope.forms.formTemplate.$setDirty();
            }

            $scope.AdicionarCampo = function () {

                if ($scope.Integracao.AtendimentoIntegracaoTemplateTipoId == 2) {
                    if (!$scope.Campo.nome || !$scope.Campo.label) {
                        NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgAddCampo'));
                        return;
                    }
                } else {
                    if (!$scope.Campo.nome || !$scope.Campo.label || !$scope.Campo.seletor) {
                        NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgAddCampo'));
                        return;
                    }
                }
                

                if (!$scope.Campo.$$hashKey) {

                    var retorno = $scope.ListCampos.filter(function (model) {
                        return model.Campo == $scope.Campo.nome &&
                            model.Label == $scope.Campo.label &&
                            model.Visivel == $scope.Campo.visivel &&
                            model.Seletor == $scope.Campo.seletor &&
                            model.Ativo;
                    });

                    if (retorno.length > 0) {
                        NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgExisteCampo'));
                    }
                    else{
                        
                        const campoManager = $scope.listaCamposManager.find(x => x.value == $scope.Campo.nome);

                        $scope.ListCampos.push({
                            Campo: $scope.Campo.nome,
                            Label: $scope.Campo.label,
                            Visivel: $scope.Campo.visivel,
                            Seletor: $scope.Integracao.AtendimentoIntegracaoTemplateTipoId == 2 ? $scope.Campo.label : $scope.Campo.seletor,
                            Ativo: true,
                            Ordem: $scope.ListCampos.length + 1,
                            Consultar: $scope.Integracao.AtendimentoIntegracaoTemplateTipoId == 2 ? campoManager.consultar : false,
                            Identificador: $scope.Campo.identificador
                        });
                        $scope.CamposNovo();
                    }

                } else {
                    var retorno = false;

                    $scope.ListCampos.forEach(function (model) {
                        if (model.Campo == $scope.Campo.nome &&
                            model.Label == $scope.Campo.label &&
                            model.Visivel == $scope.Campo.visivel &&
                            model.Seletor == $scope.Campo.seletor &&
                            model.$$hashKey != $scope.Campo.$$hashKey)
                            retorno = true;
                    });

                    if (retorno) {
                        NotifyService.showError(null, $translate.instant('integracaoEditTranslation.MsgExisteCampo'));
                    }
                    else
                        ModalService.confirmMessage($translate.instant('integracaoEditTranslation.MsgConfirmarAlteracao'),
                            null,
                            () => {

                                $scope.ListCampos.forEach(function (value, element) {
                                    if (value.$$hashKey == $scope.Campo.$$hashKey) {
                                        const campoManager = $scope.listaCamposManager.find(x => x.value == $scope.Campo.nome);
                                        $scope.ListCampos[element].Campo = $scope.Campo.nome;
                                        $scope.ListCampos[element].Label = $scope.Campo.label;
                                        $scope.ListCampos[element].Visivel = $scope.Campo.visivel;
                                        $scope.ListCampos[element].Seletor = $scope.Integracao.AtendimentoIntegracaoTemplateTipoId == 2 ? $scope.Campo.label : $scope.Campo.seletor;
                                        $scope.ListCampos[element].Consultar = $scope.Integracao.AtendimentoIntegracaoTemplateTipoId == 2 ? campoManager.consultar : false ;
                                        $scope.ListCampos[element].Identificador = $scope.Campo.identificador;
                                        $scope.CamposNovo();
                                    }

                                });
                            },
                            { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });
                }

                $scope.forms.formProvedor.$setDirty();
                $scope.forms.formTemplate.$setDirty();

            }
            function focusElementCampos() {
                document.querySelector('#seletor').focus();
                document.querySelector('#label').focus();
                document.querySelector('#nome').focus();
            }

            $scope.RemoverCampo = function (item) {
                $scope.ListCampos.forEach(function (value, element) {
                    if (value == item)
                        $scope.ListCampos[element].Ativo = false;
                });

                $scope.forms.formProvedor.$setDirty();
                $scope.forms.formTemplate.$setDirty();                
            }

            $scope.EditCampo = function (item) {

                $scope.Campo.$$hashKey = item.$$hashKey;
                $scope.Campo.nome = item.Campo;
                $scope.Campo.label = item.Label;
                $scope.Campo.visivel = item.Visivel;
                $scope.Campo.seletor = item.Seletor;
                $scope.Campo.Ativo = item.Ativo;
                $scope.Campo.identificador = item.Identificador;

                focusElementCampos();
            }

            $scope.CamposNovo = function () {
                $scope.Campo.$$hashKey = "";
                $scope.Campo.nome = "";
                $scope.Campo.label = "";
                $scope.Campo.visivel = "";
                $scope.Campo.seletor = "";
                $scope.Campo.identificador = "";
                focusElementCampos();
            }

            $scope.salvar = function () {
                if ($scope.forms.formProvedor.$dirty || $scope.forms.formTemplate.$dirty) {

                    if ($scope.isNew) {

                        ModalService.showLoading();
                        organizarLista();

                        IntegracaoResource.CadastrarTemplate({
                            Descricao: $scope.Integracao.Descricao,
                            TemplateMinerId: $scope.Integracao.TemplateMinerId,
                            AtendimentoIntegracaoTemplateTipoId: $scope.Integracao.AtendimentoIntegracaoTemplateTipoId,
                            CarteiraId: $scope.Integracao.CarteiraId,
                            SalvarDados: $scope.Integracao.SalvarDados,
                            Headers: JSON.stringify($scope.listHeaders),
                            Parameters: JSON.stringify($scope.listParameters),
                            AtendimentoIntegracaoProvedor: $scope.Integracao.AtendimentoIntegracaoProvedor,
                            AtendimentoIntegracaoTemplateCampo: $scope.ListCampos
                        })
                            .$promise
                            .then((data) => {

                                ModalService.hideLoading();
                                $scope.salvando = false;
                                NotifyService.showSuccess($translate.instant('notificacoes.registroSalvo'));
                                $state.go('main.atendimentoIntegracao.list');

                            }).catch(e => {
                                ModalService.hideLoading();
                                NotifyService.showError(e);
                                $scope.salvando = false;
                            });

                    } else {
                        ModalService.showLoading();
                        organizarLista();

                        $scope.Integracao.Headers = JSON.stringify($scope.listHeaders);
                        $scope.Integracao.Parameters = JSON.stringify($scope.listParameters);
                        $scope.Integracao.AtendimentoIntegracaoProvedor = $scope.Integracao.AtendimentoIntegracaoProvedor;
                        $scope.Integracao.AtendimentoIntegracaoTemplateCampo = $scope.ListCampos;

                        IntegracaoResource.EditarTemplate($scope.Integracao)
                            .$promise
                            .then((data) => {

                                ModalService.hideLoading();
                                $scope.salvando = false;
                                NotifyService.showSuccess($translate.instant('notificacoes.registroSalvo'));
                                $state.go('main.atendimentoIntegracao.list');

                            }).catch(e => {
                                ModalService.hideLoading();
                                NotifyService.showError(e);
                                $scope.salvando = false;
                            });
                    }

                } else
                    $state.go('main.atendimentoIntegracao.list');
            }

            function organizarLista() {
                var $nestable = $('#nestable');
                var regra_nova = $nestable.data("nestable").serialize();


                regra_nova.forEach(function (value, index) {

                    $scope.ListCampos.forEach(function (element, i) {
                        if (element.Campo == value.id.Campo &&
                            element.Label == value.id.Label &&
                            element.Visivel == value.id.Visivel &&
                            element.Seletor == value.id.Seletor &&
                            element.Ativo == value.id.Ativo) {

                            $scope.ListCampos[i].Ordem = index + 1;
                        }

                    });

                });
            }

            $scope.onSelectTemplateMiner = function (templateMinerId) {
                if (templateMinerId) {
                    IntegracaoResource.GetTemplateMinerCampos({ templateMinerId: templateMinerId }).$promise.then((data) => {
                        if (data) {
                            angular.copy(data, $scope.templateMinerCampos);
                        }
                    }).catch(NotifyService.showError);
                } else {
                    $scope.templateMinerCampos = [];
                }
            }

            $scope.validateTemplate = function () {
                $scope.proximoStep = $scope.forms.formTemplate.$valid ? true : false;
                return $scope.proximoStep;
            };

            $scope.validateProvedor = function () {
                $scope.proximoStep = $scope.forms.formProvedor.$valid ? true : false;
                return $scope.proximoStep;
            };

            $scope.ShowTestAPI = function () {
                var model = UIkit.modal("#TestAPI");
                model.show();
            }

            $scope.executarTeste = function () {
                ModalService.showLoading();
                AtendimentoIntegracaoResource.consultarByGlobalId({
                    globalId: $scope.apiParametrosTeste.GlobalId,
                    Telefone: $scope.apiParametrosTeste.Telefone,
                    InfoAdicional1: $scope.apiParametrosTeste.InfoAdicional1,
                    InfoAdicional2: $scope.apiParametrosTeste.InfoAdicional2,
                    InfoAdicional3: $scope.apiParametrosTeste.InfoAdicional3,
                    InfoAdicional4: $scope.apiParametrosTeste.InfoAdicional4,
                    InfoAdicional5: $scope.apiParametrosTeste.InfoAdicional5,
                    Cliente: $scope.apiParametrosTeste.Cliente,
                    templateId: integracao.AtendimentoIntegracaoTemplateId
                }).$promise.then(function (result) {
                    if (result) {
                        ModalService.hideLoading();

                        let seletor = $scope.ListCampos[0].Seletor.split("[0].");

                        if(seletor.length > 0)
                            $scope.detalhamentoUra = result[seletor[0]]
                        else
                            $scope.detalhamentoUra = result

                        
                        let campo = $scope.ListCampos.find(x => x.Identificador);

                        if(campo){
                            $scope.campoAgrupamento = campo.Seletor.split("[0].")[1]
                        }else{
                            $scope.campoAgrupamento = seletor[1]
                        }
                            

                        $scope.detalhamentoUra.forEach(function (values) {
                            if(values.hasOwnProperty($scope.campoAgrupamento))
                            {
                                var agrupamento = values[$scope.campoAgrupamento];

                                if(agrupamento != undefined)
                                    values.Agrupamento = agrupamento;
                            }
                        });
                        if (result.total == 0)
                            NotifyService.showError(null,'integracaoEditTranslation.dadosApiNaoEncontrado');                        
                    }
                }).catch(function(error){
                    ModalService.hideLoading();
                    NotifyService.showError(error);
                });
            }

            $scope.copyToClipboard = function (element) {
                let $temp = $("<input>");
                $("body").append($temp);
                $temp.val($(element).text()).select();
                document.execCommand("copy");
                $temp.remove();
            }

            load(integracao);

            $scope.getSeletor = function(item, seletor){
                
                if(seletor == undefined || item == undefined)
                return "";

                return item[seletor] || "0"

            }

            $scope.onChangeIdentificador = function (){
                
                $scope.ListCampos.forEach(function (model) {                    
                    model.Identificador = false;
                });

            }
        }])
})();
(function() {
    "use strict";

    var defaultPageIndex = 1;

    var getOdataSearchShared = function(IntegracaoResource, search, orderBy, $odata, utils, $stateParams) {
        var odata = IntegracaoResource.odata();
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.atendimentoIntegracao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.atendimentoIntegracao.list',
                        pageName: 'pageTitle.pesquisar'
                    },
                })
                .state("main.atendimentoIntegracao.list", StateResolverProvider.configState("/AtendimentoIntegracao", "AtendimentoIntegracao", "List", {
                    pageTitle: 'integracaoTranslation.Titulo',
                    pageName: 'pageTitle.pesquisar',
                }))
        }])
        .service('AtendimentoIntegracaoListData', function atendimentoIntegracaoListData() {
            return function() {
                return {
                    deps: ["$ocLazyLoad", function($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    atendimentoIntegracaoTemplateTipo: ["IntegracaoResource", function (IntegracaoResource) {                   
                        return IntegracaoResource.GetAtendimentoIntegracaoTemplateTipo().$promise;
                    }],
                    
					carteiras: ["AtendimentoTipoResource", "AuthService", function (AtendimentoTipoResource, AuthService) { 
						let usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;                   
                        return AtendimentoTipoResource.getCarteiraPorUsuario({
							usuarioId: usuarioLogado
						}).$promise;
                    }]
                }
            }
        })
        .controller("AtendimentoIntegracaoListController", ["$scope", "$odata", "$http", "$state", "Config", "atendimentoIntegracaoTemplateTipo", "carteiras", "IntegracaoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", function($scope, $odata, $http, $state, Config, atendimentoIntegracaoTemplateTipo,
            carteiras, IntegracaoResource, utils, LocalStorageService, $stateParams, NotifyService, ModalService) {

            $scope.carteiras = carteiras;
            $scope.lista = [];
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("Filtro") : {
                pageSize: 10
            };
            $scope.orderBy = {
                column: "Descricao",
                order: "desc"
            };

            $scope.atendimentoIntegracaoTemplateTipo = atendimentoIntegracaoTemplateTipo;

            var updateList = function(list) {
                $scope.lista = list;
                $scope.lista.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.lista.pageSize = list.$pageSize || 10;
                $scope.searching = false;
                ModalService.hideLoading();
            };

            var getOdataSearch = function() {
                return getOdataSearchShared(IntegracaoResource, $scope.search, $scope.orderBy, $odata, utils, $stateParams);
            };

            $scope.pageChanged = function(newPage) {
                if (defaultPageIndex != newPage) {

                    defaultPageIndex = newPage;
                    $scope.searching = true;
                    ModalService.showLoading();

                    return getOdataSearch()
                        .page($scope.lista.pageSize, newPage)
                        .query({
                            Descricao: $scope.search.Descricao,
                        }).then(updateList).catch((error) => {
                            NotifyService.showError;
                            ModalService.hideLoading();
                        });
                }
            };

            $scope.executeSearch = function() {

                LocalStorageService.setItem('Filtro', $scope.search);

                $scope.searching = true;
                defaultPageIndex = 1;
                ModalService.showLoading();

                getOdataSearch()
                    .page($scope.search.pageSize, 1)
                    .query({
                        Descricao: $scope.search.Descricao,
                        AtendimentoIntegracaoTemplateTipoId: $scope.search.AtendimentoIntegracaoTemplateTipoId,
                        CarteiraId: $scope.search.CarteiraId
                    }).then(updateList).catch((error) => {
                        NotifyService.showError;
                        ModalService.hideLoading();
                    });
            };

            $scope.limparFiltro = function() {
                LocalStorageService.removeItem('Filtro');
                $scope.search = {
                    pageSize: 10
                };
                $scope.lista = [];
            };

            $scope.executeSearch();

            $scope.confirmDelete = function(data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            var deleteRecord = function(data) {
                return IntegracaoResource
                    .InativarTemplate({ id: data.AtendimentoIntegracaoTemplateId })
                    .$promise
                    .then((data) => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch((error) => {
                        NotifyService.showError;
                        ModalService.hideLoading();
                    });
            };
        }]);
})();
(function() {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("IntegracaoResource", ["$odataresource", function($odataresource) {
            return $odataresource("AtendimentoIntegracao/GetIntegracao", null, {
                InativarTemplate: {
                    method: "Delete",
                    url: "AtendimentoIntegracao/Delete",
                },
                EditarTemplate: {
                    method: "Put",
                    url: "AtendimentoIntegracao/Put",
                },
                CadastrarTemplate: {
                    method: "Post",
                    url: "AtendimentoIntegracao/Post",
                },
                GetId: {
                    method: "Get",
                    url: "AtendimentoIntegracao/Get",
                },
                GetTemplateMiner: {
                    url: "AtendimentoIntegracao/TemplateMiner",
                    method: "GET",
                    isArray: true
                },
                GetTemplateMinerCampos: {
                    url: "AtendimentoIntegracao/TemplateMinerCampos",
                    method: "GET",
                    params: {
                        "templateMinerId": "@templateMinerId"
                    },
                    isArray: true
                },
                GetAtendimentoIntegracaoTemplateTipo: {
                    url: "AtendimentoIntegracao/AtendimentoIntegracaoTemplateTipo",
                    method: "GET",
                    isArray: true
                }
            });
        }]);
})();
(function () {
    "use strict";

    angular
        .module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state(
                    "main.atendimentolayouts.edit",
                    StateResolverProvider.configState(
                        "/atendimentolayouts/{Id:[0-9]+}",
                        "AtendimentoLayouts",
                        "Edit", {
                        pageTitle: "model.layoutDeTabulacao",
                        pageName: "acoes.editar",
                    }
                    )
                )
                .state(
                    "main.atendimentolayouts.new",
                    StateResolverProvider.configState(
                        "/atendimentolayouts/new",
                        "AtendimentoLayouts",
                        "Edit", {
                        pageTitle: "model.layoutDeTabulacao",
                        pageName: "acoes.cadastrar",
                    }
                    )
                );
        }])

        .service("AtendimentoLayoutsEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                            "lazy_parsleyjs",
                            "lazy_masked_inputs",
                            "lazy_uiSelect",
                        ]);
                    }],
                    layout: ["AtendimentoLayoutsResource", "$stateParams", function (
                        AtendimentoLayoutsResource,
                        $stateParams
                    ) {
                        if ($stateParams.Id) {
                            return AtendimentoLayoutsResource.get({
                                Id: parseInt($stateParams.Id),
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    tipos: ["AtendimentoTipoResource", function (AtendimentoTipoResource) {
                        return AtendimentoTipoResource.getComCategoria()
                            .$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }],
                    campanhas: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.odata()
                            .orderBy("Nome", "asc")
                            .query();
                    }],
                    campos: ["AtendimentoLayoutsResource", "$stateParams", function (
                        AtendimentoLayoutsResource,
                        $stateParams
                    ) {
                        let id = parseInt($stateParams.Id);
                        return AtendimentoLayoutsResource.getPermissoesById({
                            Id: id > 0 ? id : 0,
                        }).$promise;
                    }],
                    smsTemplate: ["SmsTemplateResource", function (SmsTemplateResource) {
                        return SmsTemplateResource.odata()
                            .orderBy("Descricao", "asc")
                            .query();
                    }],
                    servicos: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.GetServicoPadrao().$promise;
                    }],
                    integracaoTemplate: ["IntegracaoResource", function (IntegracaoResource) {
                        return IntegracaoResource.query({ Descricao: "" }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                };
            };
        })

        .controller(
            "AtendimentoLayoutsEditController",
            ["$scope", "$state", "$stateParams", "AtendimentoLayoutsResource", "layout", "tipos", "grupos", "campanhas", "servicos", "NotifyService", "ModalService", "campos", "WizardHandler", "smsTemplate", "integracaoTemplate", "carteiras", "$compile", "$translate", function ($scope, $state, $stateParams,AtendimentoLayoutsResource, layout, tipos, grupos,campanhas, servicos,
                    NotifyService, ModalService, campos, WizardHandler, smsTemplate,integracaoTemplate,carteiras, $compile, $translate) {

                layout.Id = layout.Id > 0 ? layout.Id : isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id);
                $scope.layout = layout;
                $scope.configuracoes = layout.Configuracoes;
                $scope.tiposOriginal = tipos;
                $scope.tiposCampo1 = angular.copy($scope.tiposOriginal);
                $scope.tiposCampo2 = angular.copy($scope.tiposOriginal);
                $scope.forms = {};
                $scope.exitValidationLayout = true;
                $scope.exitValidationConfiguracao = true;
                $scope.exitValidationPermissao = true;
                $scope.isNew = layout.Id > 0 ? false : true;
                $scope.campos = campos;
                $scope.smsTemplate = smsTemplate;
                $scope.habilitaTabulacao = true;
                $scope.integracaoTemplate = integracaoTemplate;
                $scope.servicosOriginal = servicos;
                $scope.campanhasOriginal = campanhas;
                $scope.gruposOriginal = grupos;
                $scope.carteiras = carteiras;
                $scope.grupos = [];
                $scope.campanhas = [];
                $scope.servicos = [];
                $scope.TipoCampo = [{
                    Descricao: "Integer",
                },
                {
                    Descricao: "Decimal",
                },
                {
                    Descricao: "Date",
                },
                {
                    Descricao: "String",
                }];

                var carregarDadosByCarteiraId = function(carteiraId)
                {
                    if($scope.gruposOriginal != null)
                    {
                        $scope.grupos = _.filter($scope.gruposOriginal, function(grupo){
                            return grupo.CarteiraId == carteiraId;
                        });
                    }
                    if($scope.campanhasOriginal != null)
                    {
                        $scope.campanhas = _.filter($scope.campanhasOriginal, function (campanha) {
                            return campanha.CarteiraId == carteiraId;
                        });
                    }                
                    if($scope.servicosOriginal != null)
                    {
                        $scope.servicos = _.filter($scope.servicosOriginal, function (servico) {
                            return servico.CarteiraId == carteiraId;
                        });
                    }              
                }

                if ($scope.isNew) {
                    $scope.layout.Configuracoes = [];
                    $scope.layout.Permissoes = [];
                    $scope.layout.TabulacaoAutomaticaManual = true;
                    $scope.layout.TabulacaoAutomaticaDiscador = true;
                    $scope.layout.TabulacaoAutomaticaReceptiva = true;
                    $scope.layout.HabilitarConsultaNavegacaoUra = true;

                } else {
                    $scope.layout.Permissoes = layout.Permissoes.filter(x => x.Ativo == true);
                    if (
                        $scope.layout.TabulacaoAutomaticaManual ||
                        $scope.layout.TabulacaoAutomaticaDiscador ||
                        $scope.layout.TabulacaoAutomaticaReceptiva
                    )
                        $scope.habilitaTabulacao = true;

                    if($scope.layout.CarteiraId > 0)
                        carregarDadosByCarteiraId($scope.layout.CarteiraId);   
                }

                $scope.adicionarPermissao = function () {
                    $scope.layout.Permissoes.push({
                        Ativo: true,
                        LigacaoDiscador: true,
                        LigacaoManual: true,
                        LigacaoReceptiva: true,
                    });
                };

                $scope.categorias = {
                    campo1: [],
                    campo2: [],
                    model1: null,
                    model2: null,
                };

                if (!$scope.configuracoes) {
                    $scope.configuracoes = [];
                }

                $scope.atualizaConfiguracoes = function () {
                    $scope.configuracao1 = _.find(
                        $scope.configuracoes,
                        function (el) {
                            return el.Ordem == 1;
                        }
                    );
                    $scope.configuracao2 = _.find(
                        $scope.configuracoes,
                        function (el) {
                            return el.Ordem == 2;
                        }
                    );
                    $scope.configuracao3 = _.find(
                        $scope.configuracoes,
                        function (el) {
                            return el.Ordem == 3;
                        }
                    );
                    $scope.configuracao4 = _.find(
                        $scope.configuracoes,
                        function (el) {
                            return el.Ordem == 4;
                        }
                    );
                    $scope.configuracao5 = _.find(
                        $scope.configuracoes,
                        function (el) {
                            return el.Ordem == 5;
                        }
                    );
                    if ($scope.configuracao1 == null) {
                        $scope.configuracao1 = {
                            Ordem: 1,
                            TipoId: null,
                            Label: null,
                        };
                        $scope.configuracoes.push($scope.configuracao1);
                    }

                    if ($scope.configuracao1.AtendimentoTipoId == null) {
                        var tp = $scope.tiposCampo1.filter(function (item) {
                            return item.Categorias.length > 0;
                        });
                        if (tp.length > 0) {
                            $scope.configuracao1.AtendimentoTipoId = tp[0].Id;
                            $scope.mudarTipo(1);
                        }
                    }

                    if ($scope.configuracao2 == null) {
                        $scope.configuracao2 = {
                            Ordem: 2,
                            TipoId: null,
                            Label: null,
                        };
                        $scope.configuracoes.push($scope.configuracao2);
                    }

                    if ($scope.configuracao3 == null) {
                        $scope.configuracao3 = {
                            Ordem: 3,
                            TipoId: null,
                            Label: null,
                        };
                        $scope.configuracoes.push($scope.configuracao3);
                    }

                    if ($scope.configuracao4 == null) {
                        $scope.configuracao4 = {
                            Ordem: 4,
                            TipoId: null,
                            Label: null,
                        };
                        $scope.configuracoes.push($scope.configuracao4);
                    }

                    if ($scope.configuracao5 == null) {
                        $scope.configuracao5 = {
                            Ordem: 5,
                            TipoId: null,
                            Label: null,
                        };
                        $scope.configuracoes.push($scope.configuracao5);
                    }
                };

                $scope.tiposCampoCarteira = function (carteiraId, campoId) {
                    if (campoId == 1) {
                        $scope.tiposCampo2 = $scope.tiposOriginal.filter(function (item) {
                            return (item.Id != $scope.configuracao1.AtendimentoTipoId && item.CarteiraId == carteiraId);
                        }
                        );
                    }

                    if (campoId == 2) {
                        $scope.tiposCampo1 = $scope.tiposOriginal.filter(function (item) {
                            return (item.Id != $scope.configuracao2.AtendimentoTipoId && item.CarteiraId == carteiraId);
                        }
                        );
                    }
                }

                $scope.tiposCampoPadrao = function(campoId) {
                    if (campoId == 1) {
                        $scope.tiposCampo2 = $scope.tiposOriginal.filter(function (item) {
                            return (item.Id != $scope.configuracao1.AtendimentoTipoId);
                            }
                        );
                    }

                    if (campoId == 2) {
                        $scope.tiposCampo1 = $scope.tiposOriginal.filter(function (item) {
                            return (item.Id != $scope.configuracao2.AtendimentoTipoId);
                            }
                        );
                    }
                }

                $scope.mudarTipo = function (campoId) {
                    var tipoId =
                        $scope["configuracao" + campoId].AtendimentoTipoId;
                    if (tipoId > 0) {
                        var categorias = _.find(tipos, function (el) {
                            return el.Id == tipoId;
                        });

                        if(categorias != null)
                        {
                            categorias = categorias.Categorias;

                            if (categorias.length <= 0) {
                                NotifyService.showError(
                                    null,
                                    "telaAtendimentoLayoutsEdit.esteTipoNaoPossuiCategorias"
                                );
                            } else {
                                $scope.categorias["campo" + campoId] = categorias;
                            }
                        }
                    }

                    if (campoId == 1) {
                        $scope.layout.CarteiraId ? $scope.tiposCampoCarteira($scope.layout.CarteiraId, campoId) : $scope.tiposCampoPadrao(campoId)
                    } else if (campoId == 2) {
                        $scope.layout.CarteiraId ? $scope.tiposCampoCarteira($scope.layout.CarteiraId, campoId) : $scope.tiposCampoPadrao(campoId)
                    }
                };

                $scope.validaConfiguracao = function (label, tipoId) {
                    if (
                        (label != undefined &&
                            label != null &&
                            label != "" &&
                            (tipoId == undefined || tipoId == null)) ||
                        ((label == undefined || label == null || label == "") &&
                            tipoId != undefined &&
                            tipoId != null)
                    ) {
                        return true;
                    }
                    return false;
                };

                $scope.validaLayout = function () {
                    var result = false;
                    if ($scope.habilitaTabulacao) {
                        if (!$scope.layout.TabulacaoAutomaticaManual &&
                            !$scope.layout.TabulacaoAutomaticaDiscador &&
                            !$scope.layout.TabulacaoAutomaticaReceptiva
                        ) {
                            result = true;
                        }
                    }
                    return result;
                };

                $scope.isConfiguracaoInvalida = function(carteiraId) {
                    if (!$scope.tiposOriginal.some(f => f.CarteiraId == carteiraId)){
                        $scope.layout.CarteiraId = undefined;
                        NotifyService.showError(null, "telaAtendimentoLayoutsEdit.validacaoCategoria");
                        return true;
                    }
                    $scope.carteiras.find(function (f){
                        if(f.Id == carteiraId)
                            $scope.layout.CarteiraNome = f.Nome
                    })
                    $scope.tiposCampoCarteira($scope.layout.CarteiraId, 1);
                    $scope.tiposCampoCarteira($scope.layout.CarteiraId, 2);
                    carregarDadosByCarteiraId($scope.layout.CarteiraId);
                    return false;
                }

                $scope.salvar = function salvar(form) {
                    if (!form.$valid) return NotifyService.showInvalid();

                    var lastStep = form.$name == "forms.formCampos" ? true : false;
                    var lastStepConf = form.$name == "forms.formConfiguracao" ? true : false;
                    var promise;
                    
                    if (form.$name == "forms.formLayout") {
                        if ($scope.isConfiguracaoInvalida($scope.layout.CarteiraId))
                            return
                        if ($scope.validaLayout()) 
                            return
                    }

                    if (form.$name == "forms.formConfiguracao") {
                        if (
                            $scope.validaConfiguracao(
                                $scope.configuracao2.Label,
                                $scope.configuracao2.AtendimentoTipoId
                            )
                        ) {
                            return;
                        }
                    }

                    if (form.$name == "forms.formPermissao") {
                        if ($scope.validaPermissaoDuplicada()) {
                            return NotifyService.showError(
                                null,
                                "telaAtendimentoLayoutsEdit.existemPermissoesDuplicadas"
                            );
                        }
                        WizardHandler.wizard().next();
                    }

                    if (form.$dirty) {
                        if (!$scope.layout.HabilitarEnvioSms)
                            $scope.layout.SmsTemplateId = null;

                        $scope.layout.PermissoesCampo = $scope.campos;

                        if (lastStepConf) {
                            $scope.layout.Configuracoes = $scope.configuracoes;
                        }
                        if ($scope.layout.Id > 0) {
                            promise = AtendimentoLayoutsResource.update(
                                $scope.layout.Id,
                                $scope.layout
                            ).$promise;
                        } else {
                            promise = AtendimentoLayoutsResource.save(
                                $scope.layout
                            ).$promise;
                        }

                        promise
                            .then((data) => {
                                $scope.layout = data;
                                NotifyService.showSuccess();
                            })
                            .catch(NotifyService.showError);
                    }

                    if (
                        (($scope.isNew && lastStep) || lastStep) &&
                        !form.$dirty
                    ) {
                        $state.go("main.atendimentolayouts.list", {
                            page: "main.atendimentolayouts.list",
                        });
                    }

                    form.$setPristine();
                };

                $scope.atualizaConfiguracoes();
                $scope.mudarTipo(1);
                $scope.mudarTipo(2);

                $scope.exitValidationLayout = function () {
                    var tabAut = true;
                    if ($scope.validaLayout()) {
                        NotifyService.showError(
                            null,
                            "telaAtendimentoLayoutsEdit.escolhaNoMinimoUmTipoDeTabulacaoAutomatica"
                        );
                        tabAut = false;
                    }
                    var alterado = $scope.isNew ?
                        false :
                        $scope.forms.formLayout.$dirty;
                    var proximoStep = false;
                    if (alterado) {
                        if (tabAut) {
                            ModalService.confirmDescartar(function () {
                                $scope.forms.formLayout.$dirty = false;
                                $scope.forms.formLayout.$setPristine();
                            });
                        }
                    } else {
                        if ($scope.forms.formLayout.$valid) {
                            proximoStep = true;
                        }
                    }
                    return proximoStep;
                };

                $scope.exitValidationConfiguracao = function () {
                    var alterado = $scope.isNew ?
                        false :
                        $scope.forms.formConfiguracao.$dirty;
                    var proximoStep = false;
                    var cf2Valid = true;

                    if (
                        $scope.validaConfiguracao(
                            $scope.configuracao2.Label,
                            $scope.configuracao2.AtendimentoTipoId
                        )
                    ) {
                        NotifyService.showError(
                            null,
                            "telaAtendimentoLayoutsEdit.aOpcaoDeConfiguracaoNumero3DeveSerPreenchida"
                        );
                        cf2Valid = false;
                    }

                    if (alterado) {
                        if (cf2Valid) {
                            ModalService.confirmDescartar(function () {
                                $scope.forms.formConfiguracao.$dirty = false;
                                $scope.forms.formConfiguracao.$setPristine();
                            });
                        }
                    } else {
                        if ($scope.forms.formConfiguracao.$valid && cf2Valid) {
                            proximoStep = true;
                        }
                    }

                    return proximoStep;
                };

                $scope.tabulacaoAutomaticaChanged = function (value) {
                    $scope.habilitaTabulacao = value;
                    if (!value) {
                        $scope.layout.TabulacaoAutomaticaManual = false;
                        $scope.layout.TabulacaoAutomaticaDiscador = false;
                        $scope.layout.TabulacaoAutomaticaReceptiva = false;
                    }
                };

                $scope.exitValidationPermissao = function () {
                    var alterado = $scope.isNew ?
                        false :
                        $scope.forms.formPermissao.$dirty;
                    var proximoStep = false;
                    var valid = true;

                    if ($scope.validaPermissaoDuplicada()) {
                        NotifyService.showError(
                            null,
                            "telaAtendimentoLayoutsEdit.existemPermissoesDuplicadas"
                        );
                        valid = false;
                    }
                    if (alterado) {
                        if (valid) {
                            ModalService.confirmDescartar(function () {
                                $scope.forms.formPermissao.$dirty = false;
                                $scope.forms.formPermissao.$setPristine();
                            });
                        }
                    } else {
                        if ($scope.forms.formPermissao.$valid && valid) {
                            proximoStep = true;
                        }
                    }

                    return proximoStep;
                };

                $scope.inativarPermissao = function (permissao, index) {
                    if (permissao.Id > 0) {
                        ModalService.confirmInativar(() => {
                            permissao.Ativo = false;
                            $scope.forms.formPermissao.$dirty = true;
                        });
                    } else {
                        $scope.layout.Permissoes.splice(index, 1);
                    }
                };

                $scope.onCampanhaAlterada = function (index, item) {
                    index = $scope.layout.Permissoes.indexOf(item);
                    if (item) {
                        if (item.CampanhaId > 0) {
                            if (!item.LigacaoDiscador) {
                                item.LigacaoDiscador = true;
                            }
                        }

                        if ($scope.validaPermissaoRepetida(index, item)) 
                            NotifyService.showError(null, "telaAtendimentoLayoutsEdit.jaExisteUmaPermissaoConfigurada");
                    }
                };

                $scope.onServicoAlterado = function (index, item) {
                    index = $scope.layout.Permissoes.indexOf(item);
                    if (item) {
                        if (item.ServicoId > 0) {
                            if (item.LigacaoDiscador)
                                item.LigacaoDiscador = false;
                            if (item.LigacaoManual)
                                item.LigacaoManual = false;
                        } else {
                            item.LigacaoDiscador = true;
                            item.LigacaoManual = true;
                        }
                    }
                };

                $scope.onGrupoAlterado = function (index, item) {
                    index = $scope.layout.Permissoes.indexOf(item);
                    if (item) {
                        if ($scope.validaPermissaoRepetida(index, item)) {
                            NotifyService.showError( null, "telaAtendimentoLayoutsEdit.jaExisteUmaPermissaoConfigurada");
                        }
                    }
                };

                $scope.validaPermissaoRepetida = function (index, permissao) {
                    let existe = false;
                    angular.forEach(
                        $scope.layout.Permissoes,
                        function (item, i) {
                            if (
                                i != index &&
                                item.GrupoId == permissao.GrupoId &&
                                item.CampanhaId == permissao.CampanhaId &&
                                item.Ativo == true
                            ) {
                                existe = true;
                            }
                        }
                    );
                    return existe;
                };

                $scope.validaPermissaoDuplicada = function () {
                    var object = {};
                    var result = [];
                    var array1 = $scope.layout.Permissoes.map(function (item) {
                        if (item.Ativo)
                            return {
                                GrupoId: item.GrupoId,
                                CampanhaId: item.CampanhaId,
                                ServicoId: item.ServicoId,
                                Ativo: item.Ativo,
                            };
                        else return;
                    });

                    array1.forEach(function (item) {
                        if (item != undefined) {
                            var i =
                                "g" +
                                (item.GrupoId == null ||
                                    item.GrupoId == undefined ?
                                    "null" :
                                    item.GrupoId) +
                                "c" +
                                (item.CampanhaId == null ||
                                    item.CampanhaId == undefined ?
                                    "null" :
                                    item.CampanhaId) +
                                "s" +
                                (item.ServicoId == null ||
                                    item.ServicoId == undefined ?
                                    "null" :
                                    item.ServicoId) +
                                "a" +
                                (item.Ativo == null || item.Ativo == undefined ?
                                    "null" :
                                    item.Ativo);

                            if (!object[i]) object[i] = 0;
                            object[i] += 1;
                        }
                    });

                    for (let prop in object) {
                        if (object[prop] >= 2) {
                            result.push(prop);
                        }
                    }

                    return result.length > 0;
                };        
            }]
        );
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (AtendimentoLayoutResource, search, orderBy, $odata) {
        var odata = AtendimentoLayoutResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }

        if (search.CarteiraId) {
            odata.filter("CarteiraId", "=", parseInt(search.CarteiraId));
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.atendimentolayouts", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.atendimentolayouts.list',
                        pageTitle: 'model.tipoDeLayout',
                        pageName: 'pageTitle.pesquisar',
                        permissions: {
                            AllowAll: true
                        }
                    }
                })
                .state("main.atendimentolayouts.list", StateResolverProvider.configState("/atendimentolayouts", "AtendimentoLayouts", "List", {
                    pageTitle: 'model.tipoDeLayout',
                    pageName: 'pageTitle.pesquisar',
                    permissions: {
                        AllowAll: true
                    }
                }));
        }])

        .service("AtendimentoLayoutsListData", function AtendimentoLayoutsListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    layouts: ["AtendimentoLayoutsResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (AtendimentoLayoutsResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroAtendimentoLayout");
                        }

                        var orderBy = {
                            column: "Nome",
                            order: "asc"
                        };

                        var odata = getOdataSearchShared(AtendimentoLayoutsResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }],
                    campanhas: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.odata().orderBy("Nome", "asc").query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })

        .controller("AtendimentoLayoutsListController", ["$scope", "$odata", "layouts", "LocalStorageService", "AtendimentoLayoutsResource", "utils", "$stateParams", "NotifyService", "ModalService", "grupos", "campanhas", "carteiras", "$translate", function ($scope, $odata, layouts, LocalStorageService,
            AtendimentoLayoutsResource, utils, $stateParams, NotifyService, ModalService, grupos, campanhas, carteiras,
            $translate) {

            $scope.searching = false;
            $scope.layouts = layouts;
            $scope.grupos = grupos;
            $scope.campanhas = campanhas;
            $scope.carteiras = carteiras;
            $scope.simular = {};
            $scope.layout = {};
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroAtendimentoLayout") : {};
            $scope.orderBy = {
                column: "Nome",
                order: "asc"
            };

            $scope.tiposLigacao = [
                { Id: 1, Descricao: "Discador" },
                { Id: 2, Descricao: "Manual" },
                { Id: 3, Descricao: "Receptiva" }
            ]

            var updateList = function (list) {
                $scope.layouts = list;
                $scope.layouts.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.layouts.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(AtendimentoLayoutsResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.layouts.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroAtendimentoLayout', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroAtendimentoLayout');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteLayout = function (data) {
                return AtendimentoLayoutsResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        if ($scope.Novo) {
                            $scope.grupo = {};
                        }
                        $scope.executeSearch();
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteLayout(data));
            };

            $scope.abrirModalSimular = function () {
                ModalService.openModal("modal_simular", () => {
                    $scope.simular = {};
                    $scope.layout = {};
                });
            };

            $scope.simularAtendimento = function () {
                let grupoId = $scope.simular.GrupoId;
                let campanhaId = $scope.simular.CampanhaId;
                let tipoLigacaoId = $scope.simular.TipoLigacaoId;

                if (!(grupoId > 0)) {
                    return NotifyService.showInvalid();
                }

                if (!(tipoLigacaoId > 0)) {
                    return NotifyService.showInvalid();
                }

                if (tipoLigacaoId == 1 && !(campanhaId > 0)) {
                    return NotifyService.showError(null, $translate.instant('telaAtendimentoLayouts.obrigatorioInformarCampanha'))
                }

                AtendimentoLayoutsResource.simular({
                    campanhaId: campanhaId > 0 ? campanhaId : 0,
                    grupoId: grupoId,
                    tipoLigacaoId: tipoLigacaoId
                }).$promise.then(r => { $scope.layout = r }).catch(NotifyService.showError);
            }

            updateList($scope.layouts);

        }]);
})
    ();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("AtendimentoLayoutsResource", ["$odataresource", function ($odataresource) {
            return $odataresource("AtendimentoLayouts/:Id", { "Id": "@Id" }, {
                permissoes: {
                    method: "GET",
                    url: "AtendimentoLayouts/Permissoes",
                    isArray: true
                },
                getPermissoesById: {
                    method: "GET",
                    url: "AtendimentoLayouts/Permissoes/:Id",
                    isArray: false,
                    params: {
                        "Id": "@Id"
                    }
                },
                simular: {
                    method: "GET",
                    url: "AtendimentoLayouts/Simular",
                    isArray: false,
                    params: {
                        "campanhaId": "@campanhaId",
                        "grupoId": "@grupoId",
                        "tipoLigacaoId": "@tipoLigacaoId"
                    }
                },
                getLayoutById: {
                    method: "GET",
                    url: "AtendimentoLayouts",
                    isArray: false,
                    params: {
                        "Id": "@Id"
                    }
                }
            });
        }]);
})();
(function () {
    "use strict";    
    angular.module('epbxManagerApp')

    //http://localhost:4022/#/atendimentominer?MsgIn=&MsgOut=&Agendar=1&CodigoCliente=123456&Telefone=11976798416&Nome=Gislaine&CampanhaId=750

    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.atendimentominer", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.atendimentominer.list',
                    pageTitle: 'Atendimento Miner',
                    pageName: 'Atendimento Miner',
                    permissions: { AllowAnonymous: true }
                },
                
            })
            .state("main.atendimentominer.list", StateResolverProvider.configState("/atendimentominer?MsgIn&MsgOut&Agendar&CodigoCliente&Telefone&Nome&CampanhaId", "AtendimentoMiner", "List", {
                pageTitle: 'Atendimento Miner',
                pageName: 'Atendimento Miner',
                permissions: { AllowAnonymous: true }
            }))
    }])
    
    .controller('AtendimentoMinerListController', ["$scope", "$stateParams", "CampanhaArquivoResource", "TabulacaoResource", "NotifyService", "ModalService", function ($scope, $stateParams, CampanhaArquivoResource,
        TabulacaoResource, NotifyService, ModalService){ 

        $scope.agendamento = {
            Telefone: ' ',
            DDD: '',
            DataHora: ''
        };
        $scope.msgIn = $stateParams.MsgIn || "Registrar Atendimento";
        $scope.msgOut = $stateParams.MsgOut || "Atendimento registrado com sucesso.";
        $scope.agendar = $stateParams.Agendar == 1 ? true : false;
        $scope.codigoCliente = $stateParams.CodigoCliente || '';
        $scope.telefone = $stateParams.Telefone || '';
        $scope.nomeCliente = $stateParams.Nome || '';
        $scope.campanhaId = $stateParams.CampanhaId || '';
        $scope.dataAgendamento = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
        $scope.invalid = false;

        if($scope.telefone == '' || $scope.nomeCliente == '' || $scope.codigoCliente == '')
        {
            $scope.invalid = true;
        }

        $scope.enviarAgendamento = function(valid){  

            if(!$scope.agendar)
            {
                $scope.enviarTeste();
                return;
            }

            if (!valid) {
                return NotifyService.showInvalid();
            }

            ModalService.showLoading();

            $scope.agendamento.Campanha = $scope.campanhaId;
            $scope.agendamento.CodCliente = $scope.codigoCliente;
            let telefone = $scope.telefone;
            $scope.agendamento.DDD = telefone.substring(0, 2);
            $scope.agendamento.Telefone = telefone.substring(2, (telefone.length ));
            $scope.agendamento.NomeCliente = $scope.nomeCliente;             
            $scope.agendamento.DataHora = moment($scope.dataAgendamento).format('YYYY-MM-DDTHH:mm:ss');

            TabulacaoResource.Agendamento($scope.agendamento).$promise
            .then(() => {
                ModalService.alert($scope.msgOut);  
                ModalService.hideLoading();    
            }).catch(() => {
                NotifyService.showError('Erro ao Redistrar Antendimento.');   
                ModalService.hideLoading();             
            });            
            
        };

        $scope.enviarTeste = function(){   

            ModalService.showLoading();

            let telefone = $scope.telefone;

            if($scope.telefone == '' || $scope.nomeCliente == '' || $scope.codigoCliente == '')
            {
                NotifyService.showError(null,'Preencha os campos corretamente.');
                ModalService.hideLoading();
                return;
            }           

            if($scope.campanhaId == '')
            {
               NotifyService.showError(null,'O código da campanha é obrigatório');
               ModalService.hideLoading();
               return;   
            }

            $scope.CodigoCliente = { Nome: "CodigoCliente", Alias: "Cod. Cliente", Valor: $scope.codigoCliente }
            $scope.DDD = { Nome: "DDD", Alias: "DDD", Valor: telefone.substring(0, 2) }
            $scope.Telefone = { Nome: "Telefone", Alias: "Telefone", Valor: telefone.substring(2, (telefone.length )) }
            $scope.NomeCliente = { Nome: "NomeCliente", Alias: "Cliente", Valor: $scope.nomeCliente }
            $scope.Detalhe = { Nome: "Detalhe", Alias: "Detalhe", Valor: undefined }
                
            $scope.layoutCampanhaEPBX = [];
            $scope.layoutCampanhaEPBX.push($scope.CodigoCliente);
            $scope.layoutCampanhaEPBX.push($scope.DDD);
            $scope.layoutCampanhaEPBX.push($scope.Telefone);
            $scope.layoutCampanhaEPBX.push($scope.NomeCliente);
            $scope.layoutCampanhaEPBX.push($scope.Detalhe);

            CampanhaArquivoResource.envioTeste({ CampanhaId: $scope.campanhaId }, $scope.layoutCampanhaEPBX).$promise
                .then(() => {
                    ModalService.alert($scope.msgOut);
                    ModalService.hideLoading();
                }).catch(() => {
                    NotifyService.showError('Erro ao Redistrar Antendimento.');
                    ModalService.hideLoading();             
                });            
        };  

        if(!$scope.agendar)
        {
            $scope.enviarTeste();
        }
    }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("AtendimentoDirecaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Crm/AtendimentoDirecao/:DirecaoId", { "DirecaoId": "@DirecaoId" });
        }]);

})();


(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.atendimentotipos.edit", StateResolverProvider.configState("/atendimentotipos/{Id:[0-9]+}", "AtendimentoTipo", "Edit", {
                    pageTitle: 'model.tipoAtendimento',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.atendimentotipos.new", StateResolverProvider.configState("/atendimentotipos/new", "AtendimentoTipo", "Edit", {
                    pageTitle: 'model.tipoAtendimento',
                    pageName: 'acoes.cadastrar',
                    css: true
                }));
        }])

        .service('AtendimentoTipoEditData', function AtendimentoTipoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_angularTree',
                            'lazy_dropify'
                        ]);
                    }],
                    tipo: ["AtendimentoTipoResource", "$stateParams", function (AtendimentoTipoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return AtendimentoTipoResource.get({
                                Id: $stateParams.Id
                            }).$promise;
                        } else {
                            return { Categorias: [] };
                        }
                    }],
                    carteiras: ["AtendimentoTipoResource", function (AtendimentoTipoResource) {
                        return AtendimentoTipoResource.getCarteira().$promise;
                    }],
                    atendimentoAcaoList: ["AtendimentoTipoResource", function (AtendimentoTipoResource) {
                        return AtendimentoTipoResource.getAtendimentoAcao().$promise;
                    }],
                    smsTemplateList: ["SmsTemplateResource", function (SmsTemplateResource) {
                        return SmsTemplateResource.getAll().$promise;
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetTodasCampanhas().$promise;
                    }]
                }
            }
        })

        .controller("AtendimentoTipoEditController",
            ["$filter", "$scope", "tipo", "carteiras", "atendimentoAcaoList", "smsTemplateList", "Config", "$http", "$stateParams", "$state", "NotifyService", "ModalService", "AtendimentoTipoResource", "campanhasList", "FileDownloadService", function ($filter, $scope, tipo, carteiras, atendimentoAcaoList, smsTemplateList, Config, $http,
                $stateParams, $state, NotifyService, ModalService, AtendimentoTipoResource, campanhasList, FileDownloadService) {
                tipo.Id = (tipo.Id > 0 ? tipo.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
                $scope.tipo = tipo;
                $scope.carteiras = carteiras;
                $scope.atendimentoAcaoList = atendimentoAcaoList;
                $scope.smsTemplateList = smsTemplateList;
                $scope.forms = {};
                $scope.exitvalidationCadastro = true;
                $scope.exitValidationCategoria = true;
                $scope.isNew = tipo.Id > 0 ? false : true;
                $scope.descricaoAcao = "";
                $scope.campanhasList = campanhasList;
                $scope.campanhas = $scope.campanhasList.filter(function (value) { return value.CampanhaTemplateId == 2 && value.CampanhaStatusId != 1 });
                $scope.needDisable = false;
                $scope.tipoId ={TipoId: tipo.Id};

                $scope.loadedData = [];
                $scope.currentPage = 0;
                $scope.itemsPerPage = 20; 

                $scope.salvar = function salvar(form) {
                    let lastStep = form.$name == "forms.formCategoria" ? true : false;
                    if (form.$dirty) {
                        if ($scope.tipo.Id > 0) {
                            putCategoria();
                            NotifyService.showRegistroSalvo();
                        } else {
                            $http.post(Config.getUrl("AtendimentoTipo"), $scope.tipo).then(function (response) {
                                NotifyService.showRegistroSalvo();
                                $scope.tipo = response.data;
                                $scope.tipoId ={TipoId: $scope.tipo.Id};
                            }).catch(NotifyService.showError);
                        }
                    }

                    if ((($scope.isNew && lastStep) || lastStep) && !form.$dirty)
                        $state.go("main.atendimentotipos.list", {
                            page: 'main.atendimentotipos.list'
                        });

                    form.$setPristine();
                    $scope.reordenarCategoria();

                };

                $scope.reverse = false;
                $scope.ordenarDescricao = function () {
                    $scope.reverse = !$scope.reverse;
                    $scope.reordenarCategoria();

                };

                $scope.reordenarCategoria = function () {
                    let lista = $filter('orderBy')($scope.tipo.Categorias, 'Descricao', $scope.reverse);
                    $scope.tipo.Categorias = lista;
                }

                $scope.adicionarCategoria = function () {
                    ModalService.confirmNovaCategoria(function () {
                        $scope.tipo.Categorias.push({ Ativo: true, Descricao: 'Texto Padrão', StatusId: 1 });
                        putCategoria();
                    });
                };

                $scope.inativarCategoria = function (categoria) {
                    ModalService.confirmDeleteCategoria(() => ConfirmarInativarCategoria(categoria));
                };

                function ConfirmarInativarCategoria(categoria) {
                    $scope.forms.formCategoria.$dirty = true;

                    $scope.tipo.Categorias.forEach(function (value, index) {
                        if (value.Id == categoria.Id || value.ParentId == categoria.Id) {
                            $scope.tipo.Categorias[index].Ativo = false;
                            categoria.Ativo = false;
                            $scope.tipo.Categorias[index].PermiteTempo = false;
                            categoria.PermiteTempo = false;
                        }

                    });

                    putCategoria();
                }

                $scope.exitvalidationCadastro = function () {
                    let alterado = $scope.isNew ? false : $scope.forms.formAtendimentoTipo.$dirty;
                    let proximoStep = false;

                    if (alterado) {
                        ModalService.confirmDescartar(function () {
                            $scope.forms.formAtendimentoTipo.$dirty = false;
                            $scope.forms.formAtendimentoTipo.$setPristine();
                        });
                    } else {
                        if ($scope.forms.formAtendimentoTipo.$valid) {
                            proximoStep = true;
                        }
                    }
                    return proximoStep;
                }

                $scope.exitValidationCategoria = function () {
                    let alterado = $scope.isNew ? false : $scope.forms.formCategoria.$dirty;
                    let proximoStep = false;

                    if (alterado) {
                        ModalService.confirmDescartar(function () {
                            $scope.forms.formCategoria.$dirty = false;
                            $scope.forms.formCategoria.$setPristine();
                        });
                    } else {
                        if ($scope.forms.formCategoria.$valid) {
                            proximoStep = true;
                        }
                    }

                    return proximoStep;
                }

                $scope.AdicionarItensCategoria = function (e) {
                    ModalService.confirmNovaCategoria(function () {
                        $scope.forms.formCategoria.$dirty = true;
                        $scope.tipo.Categorias.push({
                            Id: 0,
                            Ativo: true,
                            Descricao: 'Texto Padrão',
                            StatusId: 1,
                            ParentId: e.Id,
                            AtendimentoAcaoId: e.AtendimentoAcaoId,
                            TempoFormatado: e.Tempo,
                            PermiteTempo: e.PermiteTempo,
                            SmsTemplateId: e.SmsTemplateId,
                            CampanhaId: e.CampanhaId
                        });

                        putCategoria();
                    });
                }

                $scope.onChangeAtendimentoAcao = function (categoria) {
                    $scope.forms.formCategoria.$dirty = true;

                    if (categoria.AtendimentoAcaoId != null) {
                        categoria.TempoFormatado = atendimentoAcaoList.find(a => a.AtendimentoAcaoId == categoria.AtendimentoAcaoId).TempoFormatado;
                        categoria.PermiteTempo = atendimentoAcaoList.find(a => a.AtendimentoAcaoId == categoria.AtendimentoAcaoId).PermiteTempo;
                    }

                    $scope.tipo.Categorias.forEach(function (value, index) {
                        if (value.Id == categoria.Id) {
                            $scope.tipo.Categorias[index].AtendimentoAcaoId = categoria.AtendimentoAcaoId;
                            $scope.tipo.Categorias[index].TempoFormatado = categoria.TempoFormatado;
                            $scope.tipo.Categorias[index].Tempo = hmsToSecondsOnly(categoria.TempoFormatado);
                            $scope.tipo.Categorias[index].SmsTemplateId = categoria.SmsTemplateId;
                            $scope.tipo.Categorias[index].CampanhaId = categoria.CampanhaId;
                        }
                    });
                };

                $scope.onBlurText = function (categoria) {
                    $scope.forms.formCategoria.$dirty = true;

                    $scope.tipo.Categorias.forEach(function (value, index) {
                        if (value.Id == categoria.Id) {
                            $scope.tipo.Categorias[index].Descricao = categoria.title;
                            $scope.tipo.Categorias[index].Codigo = categoria.Codigo;
                            $scope.tipo.Categorias[index].Tempo = hmsToSecondsOnly(categoria.TempoFormatado);
                        }
                    });
                };

                function putCategoria() {
                    $http.put(Config.getUrl("AtendimentoTipo") + '/' + $scope.tipo.Id, $scope.tipo)
                        .then(function (response) {
                            let tipo = response.data;

                            // Filtra as categorias ativas:
                            tipo.Categorias = _.filter(response.data.Categorias, function (item) { return item.Ativo == true; });
                            $scope.tipo = tipo;
                            $("#tabTipo").removeClass("uk-active");
                            $("#tabCategorias").removeClass("uk-uk-disabled");
                            $("#tabCategorias").addClass("uk-active");
                            $("#tabConteudoTipo").removeClass("uk-active");
                            $("#tabConteudoCategorias").addClass("uk-active");
                            $scope.currentPage = 0;
                            $scope.itemsPerPage = 20; 
                            Gerar();
                        })
                        .catch(NotifyService.showError);
                }

                $scope.onChangeStatusCategoria = function (categoria) {

                    $scope.forms.formCategoria.$dirty = true;

                    $scope.tipo.Categorias.forEach(function (value, index) {
                        if (value.Id == categoria.Id) {
                            if (categoria.StatusChecked) {
                                $scope.tipo.Categorias[index].StatusId = 1;
                            } else {
                                $scope.tipo.Categorias[index].StatusId = 2;
                            }
                        }
                    });
                }

                $scope.filtroCategoriaChildren = function (item) {
                    return $scope.tipo.Categorias.filter(function (value) { return value.ParentId && value.ParentId == item.Id && value.Ativo });
                }

                $scope.filtroCategoria = function (item) {
                    return !item.ParentId && item.Ativo;
                }

                $scope.exibirModalDescricaoAcao = function (atendimentoAcao) {

                    let atendimentoAcaoId = parseInt(atendimentoAcao);

                    if (atendimentoAcaoId > 0) {
                        AtendimentoTipoResource.GetDescricaoAcao({
                            atendimentoAcaoId: atendimentoAcaoId
                        }).$promise
                            .then((data) => {
                                $scope.descricaoAcao = data.DescricaoAcao;
                            })
                            .catch(NotifyService.showError);
                        ModalService.openModal('modal_descricaoAcao', null, () => {
                        }, { center: false, bgclose: false })
                    } else {
                        return NotifyService.showError(null, 'Por favor selecione uma ação.');
                    }
                }

                $scope.loadMoreNodes = function() {
                    let start = $scope.currentPage * $scope.itemsPerPage;
                    let end = start + $scope.itemsPerPage;
                
                    // Carregar próximo lote de dados
                    let newNodes = $scope.loadedData.slice(start, end);
                    
                    // Adicionar novos nós à lista principal
                    $scope.list = $scope.list.concat(newNodes);
                
                    // Atualizar a página atual
                    $scope.currentPage++;
                };

                function Gerar() {
                    $scope.list = [];
                    let map = new Map();
                
                    // Primeiro, criar um mapa de Id para seus filhos
                    $scope.tipo.Categorias.forEach(function (values) {
                        if (!map.has(values.ParentId)) {
                            map.set(values.ParentId, []);
                        }
                        map.get(values.ParentId).push(values);
                    });
                
                    // Função para criar um objeto de categoria
                    function criarObjetoCategoria(values) {
                        let tempoAcao = atendimentoAcaoList.find(a => a.AtendimentoAcaoId == values.AtendimentoAcaoId) || false;
                        return {
                            "Id": values.Id,
                            "title": values.Descricao,
                            'StatusChecked': values.StatusChecked,
                            'StatusId': values.StatusId,
                            'Codigo': values.Codigo,
                            'Ativo': values.Ativo,
                            'PermiteTempo': values.PermiteTempo,
                            'AtendimentoAcaoId': values.AtendimentoAcaoId,
                            'Tempo': values.Tempo,
                            'TempoFormatado': values.TempoFormatado,
                            'PermiteTempo': (!tempoAcao ? false : tempoAcao.PermiteTempo),
                            'SmsTemplateId': values.SmsTemplateId,
                            'CampanhaId': values.CampanhaId,
                            "nodes": []
                        };
                    }
                
                    // Função recursiva para construir a árvore
                    function construirArvore(parentId) {
                        let children = map.get(parentId) || [];
                        return children.map(child => {
                            let obj = criarObjetoCategoria(child);
                            obj.nodes = construirArvore(child.Id);
                            return obj;
                        });
                    }
                
                    // Construir a árvore a partir dos nós de nível superior (ParentId null ou undefined)
                    $scope.loadedData = construirArvore(null);

                    // Carregar a primeira página
                    $scope.loadMoreNodes();
                }

                Gerar();

                var generateUUID = function () {
                    var d = new Date().getTime();
                    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
                    });
                    return uuid;
                }

                $scope.export = function () {
                    var fileName = generateUUID();
                    var url = Config.getUrl('AtendimentoTipo/ExportarCategoria/'+ $scope.tipo.Id + '/' + fileName);
                    return $http({
                        method: 'POST',
                        url: url,
                        contentType: 'application/json; charset=utf-8'
                    }).then(() => FileDownloadService.downloadWebApiFile('AtendimentoTipo/ExportarCategoria/' + fileName + '/download/')).catch(NotifyService.showError);
                };

                function hmsToSecondsOnly(str) {
                    let p = str.split(':'),
                        s = 0, m = 1;
                    while (p.length > 0) {
                        s += m * parseInt(p.pop(), 10);
                        m *= 60;
                    }
                    return s;
                }

                $scope.modalUploadFile = function(){
                    ModalService.openModal('modal_uploadFile', null, () => {
                    }, { center: false, bgclose: false })
                }

                $scope.startFileUpload = function () {
                    ModalService.showLoading();
                }

                $scope.loadFileCompleted = function (result) {
                    if (Array.isArray(result.Revisao) && result.Revisao[0].Numero == "") {
                        return $scope.loadFileError();
                    }
                    $scope.preview = result;
                    $scope.needDisable = true;
                    $('.dropify-wrapper').hide();
                    ModalService.hideLoading();

                    AtendimentoTipoResource.get({
                        Id: $stateParams.Id || $scope.tipo.Id
                    }).$promise.then((data) => {
                        $scope.tipo = data;
                        Gerar();
                    })
                };

                $scope.loadFileError = function () {
                    $scope.preview = null;
                    ModalService.hideLoading();
                    NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                };
    
                $scope.removeFile = function () {
                    $scope.PreviewStepData.notVisible = true;
                    $scope.preview = null;
                };
            }]);
})();

(function () {
	"use strict";

	var getOdataSearchShared = function (AtendimentoTipoResource, search, orderBy, $odata) {
		var odata = AtendimentoTipoResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);
		if (search.Descricao) {
			odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
		}
		if (search.Id) {
            odata.filter('CarteiraId', parseInt(search.Id));
        }

		return odata;
	};

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.atendimentotipos", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.atendimentotipos.list',
						pageTitle: 'model.tipoAtendimento',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.atendimentotipos.list", StateResolverProvider.configState("/atendimentotipos", "AtendimentoTipo", "List", {
					pageTitle: 'model.tipoAtendimento',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service('AtendimentoTipoListData', function AtendimentoTipoListData() {
			return function () {
				return {
					tipos: ["AtendimentoTipoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (AtendimentoTipoResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroAtendimentoTipo");
						}

						var orderBy = {
							column: "Descricao",
							order: "asc"
						};

						var odata = getOdataSearchShared(AtendimentoTipoResource, filtro, orderBy, $odata);
						return odata.page(10, 1).query();
					}],
					carteiras: ["AtendimentoTipoResource", "AuthService", function (AtendimentoTipoResource, AuthService) { 
						let usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;                   
                        return AtendimentoTipoResource.getCarteiraPorUsuario({
							usuarioId: usuarioLogado
						}).$promise;
                    }]
				}
			}
		})

		.controller("AtendimentoTipoListController", ["$scope", "tipos", "carteiras", "AtendimentoTipoResource", "$odata", "LocalStorageService", "$stateParams", "$http", "Config", "NotifyService", "ModalService", function ($scope, tipos, carteiras, AtendimentoTipoResource, $odata, LocalStorageService, $stateParams, $http, Config, 
			NotifyService, ModalService) {
				$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroAtendimentoTipo") : {};
				$scope.orderBy = {
					column: "Descricao",
					order: "asc"
				};

				$scope.carteiras = carteiras;

				var updateList = function (list) {
					$scope.tipos = list;
					$scope.tipos.recordCount = list.$recordCount || list.length;
					$scope.currentPage = list.$currentPage || 1;
					$scope.tipos.pageSize = list.$pageSize || 10;
				}

				var getOdataSearch = function () {
					return getOdataSearchShared(AtendimentoTipoResource, $scope.search, $scope.orderBy, $odata);
				}

				$scope.executeSearch = function executeSearch() {
					LocalStorageService.setItem('FiltroAtendimentoTipo', $scope.search);
					getOdataSearch().page($scope.search.pageSize, 1).query().then(updateList).catch(NotifyService.showError);
				}

				$scope.confirmDelete = function confirmDelete(configuracao) {
					ModalService.confirmDelete(function () {
						var url = Config.getUrl("AtendimentoTipo") + '/' + configuracao.Id;
						$http.delete(url).then(function () {
							$scope.pageChanged($scope.currentPage)
						}).catch(NotifyService.showError);
					});
				};

				$scope.pageChanged = function (newPage) {
					return getOdataSearch().page($scope.tipos.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
				};

				updateList(tipos);

				$scope.limparFiltro = function () {
					LocalStorageService.removeItem('FiltroAtendimentoTipo');
					$scope.search = { pageSize: 10 };
				};				
				$scope.duplicarAtendimentoTipo = function (atendimentoTipo) {
					if (atendimentoTipo) {
						ModalService.confirmMessage('telaAtendimentoTipo.confirmarDuplicar', null, () => {
							AtendimentoTipoResource.duplicarAtendimentoTipo({
								AtendimentoTipoId : atendimentoTipo.Id
							}).$promise.then((res) => {
								$scope.executeSearch();
							}).catch(NotifyService.showError);
						});
					}
				}
			}]
			
		);
		
	

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("AtendimentoTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("AtendimentoTipo/:TipoId",
                {
                    "TipoId": "@TipoId"
                },
                {
                    getComCategoria: {
                        url: "AtendimentoTipo/ComCategoria",
                        method: "GET",
                        isArray: true
                    },
                    getCarteiraPorUsuario: { 
                        method: "GET", 
                        url: "Carteira/CarteiraPorUsuario",
                        params: {
                            "usuarioId": "@usuarioId"
                        }, 
                        isArray: true 
                    },
                    getCarteira: { 
                        method: "GET", 
                        url: "Carteira",
                        isArray: true 
                    },
                    getAtendimentoAcao: {
                        url: "AtendimentoTipo/AtendimentoAcao",
                        method: "GET",
                        isArray: true
                    },
                    GetDescricaoAcao: {
                        url: "AtendimentoTipo/DescricaoAcao",
                        method: "GET",
                        params: {
                            "atendimentoAcaoId": "@atendimentoAcaoId"
                        }, 
                    },
                    duplicarAtendimentoTipo: {
                        url: "AtendimentoTipo/Duplicar",
                        method: "POST",
                        params: {
                            "AtendimentoTipoId": "@AtendimentoTipoId"
                        }
                    },
                    getCategorias: {
                        url: "AtendimentoTipo/Categorias",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 10;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.basehigienizacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.basehigienizacao.list',
                        pageTitle: 'pageTitle.baseHigienizacao',
                        pageName: 'model.baseHigienizacao'
                    }
                })
                .state("main.basehigienizacao.list", StateResolverProvider.configState("/basehigienizacao", "BaseHigienizacao", "List", {
                    pageTitle: 'pageTitle.baseHigienizacao',
                    pageName: 'pageTitle.pesquisar'
                }))
        }])

        .service("BaseHigienizacaoListData", function ReportListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_masked_inputs'
                        ]);
                    }],
                    causaList: ["BilheteCausaResource", function (BilheteCausaResource) {
                        return BilheteCausaResource.get().$promise;
                    }]
                }
            }
        })

        .controller("BaseHigienizacaoListController", ["$scope", "$rootScope", "$http", "$filter", "$stateParams", "MailingHistoricoResource", "Config", "causaList", "AuthService", "NotifyService", "$translate", "ModalService", function ($scope, $rootScope, $http, $filter, $stateParams, MailingHistoricoResource, Config, causaList,
            AuthService, NotifyService, $translate, ModalService) {
            $scope.filtro = {};
            $scope.causa = angular.forEach(causaList.Results, function (item) { item.Alias = item.CausaCodigo + ' - ' + item.Alias; });

            var dataFim = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            var dataInicio = moment().subtract(1, 'days').toDate();

            $scope.sucessos = [];
            $scope.insucessos = [];
            $scope.sucessosFull = [];
            $scope.insucessosFull = [];
            $scope.totalSucesso = 0;
            $scope.totalInsucesso = 0;

            $scope.search = {
                DataInicio: dataInicio,
                DataFim: dataFim
            };

            $scope.submitted = false;

            $scope.executeSearch = function () {
                ModalService.showLoading();

                $scope.getData()
                    .then((data) =>
                    {
                        $scope.sucessos = data.filter((item) => { return item.Sucesso == true; });
                        $scope.insucessos = data.filter((item) => { return item.Sucesso == false; });
                        $scope.totalSucesso = $scope.sucessos.length;
                        $scope.totalInsucesso = $scope.insucessos.length;
                        $scope.sucessosFull = angular.copy($scope.sucessos);
                        $scope.insucessosFull = angular.copy($scope.insucessos);
                        ModalService.hideLoading();
                        $scope.submitted = false;
                    })
                    .catch((error) => {
                        $scope.sucessos = [];
                        $scope.insucessos = [];
                        $scope.sucessosFull = [];
                        $scope.insucessosFull = [];
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                        $scope.submitted = false;
                    });
            };

            $scope.getData = function () {
                $scope.submitted = true;
                var url = Config.getUrl("MailingHistorico/HistoricoPorFiltro/");

                $scope.filtro = {
                    DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                    DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                    Telefone: $scope.search.Telefone,
                    CausaCodigo: ($scope.search.CausaCodigo == null || $scope.search.CausaCodigo == 0) ? [] : $scope.search.CausaCodigo.join()
                };

                return $http({ method: 'GET', url: url, params: $scope.filtro })
                    .then((response) => {
                        return response.data;
                    });
            };

            $scope.confirmaExclusao = function (causaCodigo) {
                $scope.filtro.CausaCodigo = causaCodigo;
                ModalService.confirmMessage($translate.instant('telaBaseHigienizacao.confirmarExclusao'), null, () => {
                    ModalService.showLoading();

                    return MailingHistoricoResource.delete($scope.filtro).$promise
                        .then(() => {
                            ModalService.hideLoading();
                            NotifyService.showSuccess();
                        }).catch(() => {
                            ModalService.hideLoading();
                            NotifyService.showError;
                        })
                });
            };

            $scope.limparFiltro = function () {
                $scope.search = {
                    Telefone: '',
                    DataInicio: '',
                    DataFim: ''
                }

                $rootScope.$broadcast('onLimpar');
                $scope.sucessos = [];
                $scope.insucessos = [];
                $scope.sucessosFull = [];
                $scope.insucessosFull = [];
                $scope.totalSucesso = 0;
                $scope.totalInsucesso = 0;
                $scope.submitted = false;
            }

            $scope.reversesucesso = false;
            $scope.reverseinsucesso = false;
            $scope.predicatesucesso = '';
            $scope.predicateinsucesso = '';

            var updateGroupList = function (list, listName) {
                $scope[listName] = list;
                $scope[listName].recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope[listName].pageSize = list.$pageSize || defaultPageSize;
                $scope.submitted = false;
            };

            $scope.pageGroupChanged = function (newPage, listName) {
                $scope['currentPage' + listName] = newPage;
                $scope[listName].$currentPage = newPage;
                var itensPerPage = ($scope[listName + 'Full'].pageSize || defaultPageSize);
                var begin = ((newPage - 1) * itensPerPage)
                var end = begin + itensPerPage;
                var currentList = $scope[listName + 'Full'].slice(begin, end);
                currentList.$currentPage = newPage;

                updateGroupList(currentList, listName);
            };

            $scope.orderGroup = function (predicate, listName) {
                var itensPerPage = ($scope[listName].pageSize || defaultPageSize),
                    page = $scope[listName].$currentPage ? $scope[listName].$currentPage : 1,
                    begin = ((page - 1) * itensPerPage),
                    end = begin + itensPerPage;

                $scope['reverse' + listName] = ($scope['predicate' + listName] === predicate) ? !$scope['reverse' + listName] : false;
                $scope['predicate' + listName] = predicate;
                $scope[listName + 'Full'] = $filter('orderBy')($scope[listName + 'Full'], predicate, $scope['reverse' + listName]);
                $scope[listName + 'Full'].$currentPage = page;
                var currentList = $scope[listName + 'Full'].slice(begin, end);
                currentList.$currentPage = page;
                updateGroupList(currentList, listName);
            }

            //Modal de Detalhe - Início

            $scope.order = function (predicate) {
                ModalService.showLoading();
                $scope.predicate = predicate;
                $scope.reverse = $scope.predicate ? !$scope.reverse : false;

                $scope.orderBy = {
                    column: predicate,
                    order: !$scope.reverse ? "Desc" : "Asc",
                };

                return $scope.getOdataSearch().then(updateList).catch(NotifyService.showError);
            };

            var updateList = function (pagination) {
                $scope.detalheList = pagination.Data;
                $scope.detalheList.recordCount = pagination.RecordCount;
                $scope.detalheList.currentPage = pagination.PageIndex || 1;
                $scope.detalheList.pageSize = pagination.PageSize || defaultPageSize;
                $scope.submitted = false;
                ModalService.hideLoading();
            };

            $scope.exibirDetalhe = function (causaCodigo, causaDescricao) {
                $scope.detalheList = [];
                defaultPageIndex = 1;

                $scope.orderBy = {
                    column: "MailingHistoricoId",
                    order: "Desc"
                };

                $scope.causaCodigo = causaCodigo;
                $scope.descricaoCausa = causaCodigo + ' - ' + causaDescricao;

                $scope.getOdataSearch()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                    });

                ModalService.openModal('modal_detalhe', null, null, { center: false, modal: false });                
            }

            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {
                    ModalService.showLoading();
                    $scope.isPageChanged = true;
                    defaultPageIndex = newPage;
                    $scope.getOdataSearch()
                        .then((list) => {
                            updateList(list);
                            $scope.isPageChanged = false;
                        }).catch((error) => {
                            NotifyService.showError(error);
                            $scope.isPageChanged = false;
                            ModalService.hideLoading();
                        });
                }
            };

            $scope.getOdataSearch = function () {
                var url = Config.getUrl("MailingHistorico/HistoricoPaginado/") + defaultPageIndex + "/" + defaultPageSize;

                $scope.filtro.causaCodigo = $scope.causaCodigo;

                if ($scope.orderBy.column == 'Telefone')
                    $scope.filtro.OrderBy = 'DDD ' + $scope.orderBy.order + ', Numero ' + $scope.orderBy.order;
                else
                    $scope.filtro.OrderBy = $scope.orderBy.column + " " + $scope.orderBy.order;

                if (!$scope.isPageChanged) {
                    $scope.countFinalizado = false;
                    $scope.countInternoFinalizado = false;
                    $scope.detalheQuantidade = -1;

                    MailingHistoricoResource.getHistoricoPaginadoCount($scope.filtro).$promise
                        .then((data) => {
                            if ($scope.countFinalizado == false) {
                                $scope.detalheQuantidade = data.Quantidade;
                                $scope.countInternoFinalizado = true;
                            }
                        });
                }

                return $http({ method: 'GET', url: url, params: $scope.filtro })
                    .then((response) => {
                        return response.data;
                    });
            }
        }])
})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.bigtalk", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.bigtalk.list',
						pageTitle: 'pageTitle.bigTalk',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.bigtalk.list", StateResolverProvider.configState("/bigtalk", "BigTalk", "List", {
					pageTitle: 'pageTitle.bigTalk',
					pageName: 'pageTitle.pesquisar',
					css: true
				}));
		}])

		.service("BigTalkListData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_masked_inputs'
                        ]);
					}],
					campanhas: ["CampanhaResource", function (CampanhaResource) {
						let odata = CampanhaResource.odata().orderBy('Descricao', 'asc');
						return odata.query();
					}]
				}
			}
		})

		.controller("BigTalkListController", ["$scope", "campanhas", "BigTalkResource", "NotifyService", "ModalService", "$translate", function ($scope, campanhas, BigTalkResource, NotifyService, ModalService, $translate) {
			campanhas.forEach(campanha => {
				campanha.Nome = `${campanha.CampanhaId} - ${campanha.Nome}`
			});

			// Listas
			$scope.campanhas = campanhas;
						
			// Objetos
			$scope.resumoScore = {};
			$scope.search = {};
			$scope.forms = {};
			$scope.envioTeste = {};

			// Booleanos
			$scope.searching = false;
			$scope.atualizandoResumo = false;

			// Numerais
			$scope.retornoPesquisaCount = -1;
			
			$scope.executeSearch = function () {
				$scope.searching = true;

				getOdataSearch($scope.search).finally(() => {
                    $scope.searching = false;
                }).catch(NotifyService.showError)
			};

			$scope.limparFiltro = function () {
				$scope.search = {};
				$scope.executeSearch();
			};

			$scope.atualizarResumo = function () {
				$scope.atualizandoResumo = true;
				BigTalkResource.getResumo().$promise.then((result) => {
					$scope.resumoScore = result;
				}).catch(NotifyService.showError).finally(() => { $scope.atualizandoResumo = false; })
			}

			$scope.abrirModalEnvioTeste = function () {
				ModalService.openModal('modal_envio_teste', null, () => {
					$scope.envioTeste = { CampanhaId: 316 };
					$scope.forms.formEnvioTeste.$setUntouched();
					$scope.forms.formEnvioTeste.$setPristine();
				});
			}

			$scope.enviarTeste = function (form) {
				if (form.$valid) {
					BigTalkResource.envioTeste({
						CampanhaId: $scope.envioTeste.CampanhaId,
						CodigoCliente: $scope.envioTeste.CodigoCliente,
						DDD: $scope.envioTeste.DDD,
						Numero: $scope.envioTeste.Numero,
						Nome: $scope.envioTeste.NomeCliente,
						Detalhe: $scope.envioTeste.Detalhe,
						EnvioTeste: true
					}).$promise.then(() => {
						ModalService.alert('notificacoes.testeEnviadoComSucesso');
						ModalService.closeModal('modal_envio_teste');
					});
				}
			};

			$scope.verDescricaoPeriodos = function (periodo) {
				let descricao = '';
				switch (periodo) {
					case $translate.instant('telaBigTalk.manha'):
						descricao = $translate.instant('telaBigTalk.descricaoManha');
						break;
					case $translate.instant('telaBigTalk.tarde'):
						descricao = $translate.instant('telaBigTalk.descricaoTarde');
						break;
					case $translate.instant('telaBigTalk.noite'):
						descricao = $translate.instant('telaBigTalk.descricaoNoite');
						break;
				}

				let msg = `<h3>${$translate.instant('telaBigTalk.descricaoDoPeriodo')}</h3>${descricao}`

				ModalService.alert(msg);
			}

			var getOdataSearch = function (search) {
				$scope.retornoPesquisaCount = -1;

				if (search.Telefone) {
					return BigTalkResource.consultarTelefone({ Telefone: search.Telefone}).$promise.then((result) => {
						if (result.DataUltimaDiscagem) {
							let periodo = result.DataUltimaDiscagem.substring(11) > '12:00:00' ? (result.DataUltimaDiscagem.substring(11) > '18:00:00' ? 'telaBigTalk.noite' : 'telaBigTalk.tarde') : 'telaBigTalk.manha';
							result.MelhorPeriodoDiscagem = $translate.instant(periodo);
						}
						$scope.scoreList = [];
						$scope.retornoPesquisaCount = result.Telefone ? 1 : 0;

						if (result.Telefone) {
							$scope.scoreList.push(result);
						}
					});
				} else {
					return BigTalkResource.get().$promise.then((result) => {
						result.forEach(element => {
							if (element.DataUltimaDiscagem) {
								let periodo = element.DataUltimaDiscagem.substring(11) > '12:00:00' ? (element.DataUltimaDiscagem.substring(11) > '18:00:00' ? 'telaBigTalk.noite' : 'telaBigTalk.tarde') : 'telaBigTalk.manha';
								element.MelhorPeriodoDiscagem = $translate.instant(periodo);
							}
						})
						$scope.scoreList = result;
						BigTalkResource.getCount().$promise.then((result) => {
							$scope.retornoPesquisaCount = result.Quantidade;
						});
					});
				}
			};

			$scope.executeSearch();
			$scope.atualizarResumo();

		}]);
		
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
        .factory("BigTalkResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BigTalk", { },
                {
                    get: {
                        url: "BigTalk",
                        method: "GET",
                        isArray: true
                    },
                    consultarTelefone: {
                        url: "BigTalk/ConsultarTelefone",
                        method: "GET",
                        isArray: false
                    },
                    getCount: {
                        url: "BigTalk/Count",
                        method: "GET",
                        isArray: false
                    },
                    getResumo: {
                        url: "BigTalk/GetResumo",
                        method: "GET",
                        isArray: false
                    },
                    envioTeste: {
                        url: "BigTalk/EnvioTeste",
                        method: "POST"
                    }
                });
        }]);
})();

(function() {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bilhete", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bilhete.list',
                        pageTitle: 'pageTitle.relatorioDeBilhetes',
                        pageName: 'model.bilhete'
                    }
                })
                .state("main.bilhete.list", StateResolverProvider.configState("/bilhete?GrupoId&BilheteStatusId&CampanhaDiscagemStatusId&BilheteDirecaoId&CausaCodigo&BilheteCenarioId&DiscagemTipoId&UsuarioId&Tempo&CampanhaId&OrigemDesconexaoId&BilheteStatusDetalheId&codigoCliente&telefone", "Bilhete", "List", {
                    pageTitle: 'pageTitle.relatorioDeBilhetes',
                    pageName: 'pageTitle.pesquisar',
                    css: true,
                    cssFiles: ['app/pages/bilhete/style/list.css', 'app/pages/bilhete/style/listBilheteDetalhe.css']
                }))
        }])

    .service("BilheteListData", function ReportListData() {
        return function() {
            return {
                grupoList: ["GrupoResource", function(GrupoResource) {
                    return GrupoResource.getTodosGrupos();
                }],
                statusList: ["BilheteResource", function(BilheteResource) {
                    return BilheteResource.bilheteStatus().$promise;
                }],
                rotaList: ["RotaResource", function(RotaResource) {
                    return RotaResource.odata().select(["RotaId", "Nome", "CarteiraId"]).query();
                }],
                servicoList: ["ServicoResource", function(ServicoResource) {
                    return ServicoResource.odata().select(["ServicoId", "Numero"]).query();
                }],
                statusBilheteDetalheList: ["BilheteResource", function (BilheteResource) {
                    return BilheteResource.bilheteStatusDetalhe().$promise;
                }],
                statusDetalheList: ["CampanhaDiscagemStatusResource", function(CampanhaDiscagemStatusResource) {
                    return CampanhaDiscagemStatusResource.odata().filter('Discagem', true).query();
                }],
                usuariosList: ["UsuarioResource", function(UsuarioResource) {
                    return UsuarioResource.GetTodosUsuario().$promise;
                }],
                cenariosList: ["BilheteResource", function(BilheteResource) {
                    return BilheteResource.cenario().$promise;
                }],
                eventoList: ["BilheteResource", function(BilheteResource) {
                    return BilheteResource.evento().$promise;
                }],
                campanhasList: ["CampanhaResource", function(CampanhaResource) {
                    return CampanhaResource.GetTodasCampanhas();
                }],
                campanhaTipoList: ["CampanhaResource", function(CampanhaResource) {
                    return CampanhaResource.GetCampanhasTipo();
                }],
                carteiraList: ["CarteiraResource", function(CarteiraResource) {
                    return CarteiraResource.query().$promise;
                }],
                maxFiltroBilhete: ["ConfiguracaoResource", function(ConfiguracaoResource) {
                    return ConfiguracaoResource.getConfiguracaoMaxFiltroBilhete();
                }],
                emailsAutorizados: ["EmailDestinatarioResource", function(EmailDestinatarioResource) {
                    return EmailDestinatarioResource.GetEmailsAutorizados().$promise;
                }]
            }
        }
    })

    .controller("BilheteListController", ["$scope", "$rootScope", "$http", "$location", "$stateParams", "BilheteResource", "Config", "usuariosList", "cenariosList", "campanhaTipoList", "campanhasList", "rotaList", "servicoList", "statusList", "statusDetalheList", "grupoList", "AuthService", "FileDownloadService", "NotifyService", "$translate", "ModalService", "eventoList", "carteiraList", "GrupoResource", "UsuarioResource", "EmailDestinatarioResource", "maxFiltroBilhete", "emailsAutorizados", "statusBilheteDetalheList", function($scope, $rootScope, $http, $location, $stateParams, BilheteResource, Config, usuariosList, cenariosList,
        campanhaTipoList, campanhasList, rotaList, servicoList, statusList, statusDetalheList, grupoList, AuthService, FileDownloadService,
        NotifyService, $translate, ModalService, eventoList, carteiraList, GrupoResource, UsuarioResource, EmailDestinatarioResource, maxFiltroBilhete, emailsAutorizados,statusBilheteDetalheList) {
        $scope.isPageChanged = false;
        $scope.rotaList = rotaList;
        $scope.rotas = rotaList;
        $scope.maxFiltroBilhete = maxFiltroBilhete.Quantidade;
        $scope.emailsAutorizados = emailsAutorizados;

        $scope.periodoConsulta = [
            { Descricao: $translate.instant('telaBilhete.ultimaHora'), Valor: 1 },
            { Descricao: $translate.instant('telaBilhete.ultimas4Horas'), Valor: 2 },
            { Descricao: $translate.instant('telaBilhete.hoje'), Valor: 3 },
            { Descricao: $translate.instant('telaBilhete.umaSemana'), Valor: 4 },
            { Descricao: $translate.instant('telaBilhete.15Dias'), Valor: 5 },
            { Descricao: $translate.instant('telaBilhete.30Dias'), Valor: 6 }
        ];

        $scope.visaoConsulta = [
            { Descricao: $translate.instant('telaBilhete.mailing'), Valor: 1 },
            { Descricao: $translate.instant('telaBilhete.cliente'), Valor: 2 }
        ];

        var calculaPeriodoSelecionado = function(periodoSelecionado) {
            var hoje = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
            var tempo = 60,
                dataI;
            switch (periodoSelecionado) {
                case 1: //1H
                    tempo = 60;
                    break;
                case 2: //4h
                    tempo = 60 * 4;
                    break;
                case 3: //Hoje
                    dataI = moment(hoje).toDate();
                    tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                    break;
                case 4: //1 semana
                    dataI = moment(new Date(hoje.setDate(hoje.getDate() - 7))).toDate();
                    tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                    break;
                case 5: //15 dias
                    dataI = moment(new Date(hoje.setDate(hoje.getDate() - 15))).toDate();
                    tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                    break;
                case 6: //30 dias
                    dataI = moment(new Date(hoje.setDate(hoje.getDate() - 30))).toDate();
                    tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                    break;
                default:
                    tempo = 60;
                    break;
            }
            return tempo;
        }
        var tempoCalculado = calculaPeriodoSelecionado(parseInt($stateParams.Tempo)) || 60;
        var dataInicio = moment().subtract(tempoCalculado, 'minutes').seconds(0).milliseconds(0).toDate();
        var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();
        $scope.search = {
            DataInicio: dataInicio,
            DataFim: dataFim,
            GrupoId: $stateParams.GrupoId || 0,
            CarteiraId: $stateParams.CarteiraId || 0,
            BilheteDirecaoId: $stateParams.BilheteDirecaoId || 0,
            BilheteStatusId: $stateParams.BilheteStatusId || 0,
            CampanhaDiscagemStatusId: $stateParams.CampanhaDiscagemStatusId || 0,
            BilheteCenarioId: $stateParams.BilheteCenarioId || 0,
            DiscagemTipoId: $stateParams.DiscagemTipoId || 0,
            CausaCodigo: $stateParams.CausaCodigo || '',
            UsuarioId: $stateParams.UsuarioId || 0,
            CampanhaId: $stateParams.CampanhaId == undefined ? [] : $stateParams.CampanhaId.split(','),
            DownloadDetalhe: false,
            AbrirPaginaDetalhe: false,
            origemDesconexaoRamal: false,
            origemDesconexaoCliente: false,
            BilheteDetalhado: false,
            BilheteEventoId: $stateParams.BilheteEventoId || 0,
            AgendarExportacao: false,
            BilheteCDRAgendamentoId: 0,
            BilheteStatusDetalheId: $stateParams.BilheteStatusDetalheId || 0,
            NB: $stateParams.telefone,
            CodigoCliente: $stateParams.codigoCliente
        };
        $scope.abrirDetalhesExportar = false;
        $scope.viewInativos = false;

        $scope.orderBy = {
            column: "BilheteId",
            order: "Desc"
        };

        $scope.enviarEmail = {
            GlobalId: '',
            BilheteId: 0,
            EmailId: 0,
            Link: ''
        };

        $scope.cenariosList = cenariosList;
        $scope.eventoList = eventoList;
        $scope.statusList = statusList;
        $scope.statusDetalheList = statusDetalheList;
        $scope.statusBilheteDetalheList = statusBilheteDetalheList;
        $scope.servicoList = servicoList;
        $scope.rotaList = rotaList;
        $scope.detalheList = [];
        $scope.detalheUra = [];

        $scope.direcaoList = [
            { DirecaoId: 2, Descricao: $translate.instant('campo.efetuada') },
            { DirecaoId: 1, Descricao: $translate.instant('campo.recebida') }
        ];

        $scope.discagemTipoList = [
            { DiscagemTipoId: 1, Descricao: $translate.instant('telaBilhete.manual') },
            { DiscagemTipoId: 2, Descricao: $translate.instant('telaBilhete.discador') }
        ];

        $scope.campanhaTipoList = campanhaTipoList;
        $scope.carteiraList = carteiraList;
        $scope.grupoList = grupoList;
        $scope.expanded = false;
        $scope.submitted = false;
        $scope.countInternoFinalizado = false;
        $scope.predicate = '';
        $scope.reverse = false;
        $scope.bilheteList = [];
        $scope.usuarioIsAdmin = AuthService.getUsuarioLogado() ? (AuthService.getUsuarioLogado().UsuarioTipoId == 1 ? true : false) : false;
        $scope.usuarioIsOperador = AuthService.getUsuarioLogado() ? (AuthService.getUsuarioLogado().UsuarioTipoId == 3 ? true : false) : false;
        $scope.campanhasListComInativas = campanhasList;

        $scope.campanhasListSemInativas = _.filter($scope.campanhasListComInativas, function(item) {
            return item.CampanhaStatusId !== 1;
        });

        $scope.campanhas = $scope.campanhasListSemInativas;
        $scope.grupoListComInativos = grupoList;

        $scope.grupoListSemInativos = _.filter($scope.grupoListComInativos, function(item) {
            return item.Ativo == 1;
        });

        $scope.grupos = $scope.grupoListSemInativos;
        $scope.usuariosListComInativos = usuariosList;

        $scope.usuariosListSemInativos = _.filter($scope.usuariosListComInativos, function(item) {
            return item.UsuarioStatusId == 1;
        });

        $scope.usuarios = $scope.usuariosListSemInativos;

        //Usuario Operador so pode listar ele mesmo na lista de usuario.
        if ($scope.usuarioIsOperador) {
            $scope.search.UsuarioId = AuthService.getUsuarioLogado().UsuarioId;
        }

        $scope.changeViewInativos = function(viewInativos) {
            $rootScope.$broadcast('onLimpar');
            $scope.viewInativos = viewInativos;

            if (!viewInativos) {
                $scope.campanhas = $scope.campanhasListSemInativas;
                $scope.grupos = $scope.grupoListSemInativos;
                $scope.usuarios = $scope.usuariosListSemInativos;
            } else {
                $scope.campanhas = $scope.campanhasListComInativas;
                $scope.grupos = $scope.grupoListComInativos;
                $scope.usuarios = $scope.usuariosListComInativos;
            }

            $scope.changeCampanhaTipoId();
        }

        $scope.order = function(predicate) {
            ModalService.showLoading();
            $scope.predicate = predicate;
            $scope.reverse = $scope.predicate ? !$scope.reverse : false;

            $scope.orderBy = {
                column: predicate,
                order: !$scope.reverse ? "Desc" : "Asc",
            };

            return $scope.getOdataSearch().then(updateList).catch(NotifyService.showError);
        };

        $scope.parJson = function(json) {
            if (json == null || json == '') return json;
            return JSON ? JSON.parse(json, null) : json;
        }

        var updateList = function(pagination) {
            $scope.bilheteList = pagination.Data;
            $scope.bilheteList.recordCount = pagination.RecordCount;
            $scope.currentPage = pagination.PageIndex || 1;
            $scope.bilheteList.pageSize = pagination.PageSize || defaultPageSize;
            $scope.submitted = false;
            ModalService.hideLoading();
        };

        var tratarOrigemDesconexao = function() {
            var cliente = $scope.search.origemDesconexaoCliente ? 'Cliente' : null;
            var ramal = $scope.search.origemDesconexaoRamal ? 'Ramal' : null;
            $scope.origemDesconexaoLista = [];

            if (cliente != null) {
                $scope.origemDesconexaoLista.push(cliente);
            }

            if (ramal != null) {
                $scope.origemDesconexaoLista.push(ramal);
            }
        }
        $scope.executeSearch = function() {
            var dataI = moment($scope.search.DataInicio);
            var dataF = moment($scope.search.DataFim);
            var dateDiff = dataF.diff(dataI, 'days');
            if (dateDiff > $scope.maxFiltroBilhete) {
                $scope.bilheteList = [];
                NotifyService.showMessage('telaBilhete.limitePesquisarExportar', "warning");
                return;
            }
            ModalService.showLoading();
            $scope.reverse = false;

            $scope.orderBy = {
                column: "BilheteId",
                order: "Desc"
            };

            defaultPageIndex = 1;
            $scope.getOdataSearch()
                .then(updateList)
                .catch((error) => {
                    NotifyService.showError(error);
                    ModalService.hideLoading();
                    $scope.submitted = false;
                });
        };

        $scope.pageChanged = function(newPage) {
            if (defaultPageIndex != newPage) {
                ModalService.showLoading();
                $scope.isPageChanged = true;
                defaultPageIndex = newPage;
                $scope.getOdataSearch()
                    .then((list) => {
                        updateList(list);
                        $scope.isPageChanged = false;
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.isPageChanged = false;
                        ModalService.hideLoading();
                    });
            }
        };

        $scope.getOdataSearch = function() {
            $scope.submitted = true;
            let url = Config.getUrl("Bilhete/") + defaultPageIndex + "/" + defaultPageSize;

            tratarOrigemDesconexao();

            let filtro = {
                BilheteStatusId: $scope.search.BilheteStatusId,
                CampanhaDiscagemStatusId: $scope.search.CampanhaDiscagemStatusId,
                GrupoId: ($scope.search.GrupoId == null || $scope.search.GrupoId == 0) ? [] : $scope.search.GrupoId.join(),
                RotaId: $scope.search.RotaId,
                NA: $scope.search.NA,
                NAContem: $scope.search.NAContem,
                DirecaoId: $scope.search.BilheteDirecaoId,
                UsuarioId: $scope.search.UsuarioId,
                DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                GlobalId: $scope.search.GlobalId,
                Duracao: $scope.search.DuracaoMaiorQue,
                NB: $scope.search.NB,
                NBContem: $scope.search.NBContem,
                BilheteCenarioId: $scope.search.BilheteCenarioId,
                CausaCodigo: $scope.search.CausaCodigo,
                CampanhaId: ($scope.search.CampanhaId == null || $scope.search.CampanhaId == 0) ? [] : $scope.search.CampanhaId.join(),
                DiscagemTipoId: $scope.search.DiscagemTipoId,
                CampanhaTipoId: $scope.search.CampanhaTipoId,
                CodigoCliente: $scope.search.CodigoCliente,
                OrigemDesconexaoId: $scope.origemDesconexaoLista.length > 1 ? $scope.origemDesconexaoLista.join() : $scope.origemDesconexaoLista[0],
                LigacaoInterna: $scope.search.LigacaoInterna,
                Atendido: $scope.search.Atendido,
                RotaFallback: $scope.search.RotaFallback,
                BilheteDetalhado: $scope.search.BilheteDetalhado,
                BilheteEventoId: $scope.search.BilheteEventoId,
                OrderBy: $scope.orderBy.column + " " + $scope.orderBy.order,
                CarteiraId: $scope.search.CarteiraId,
                BilheteStatusDetalheId: $scope.search.BilheteStatusDetalheId
            };

            if (!$scope.isPageChanged) {
                $scope.countFinalizado = false;
                $scope.countInternoFinalizado = false;
                $scope.bilheteQuantidade = -1;

                BilheteResource.getCount(filtro).$promise
                    .then((data) => {
                        if ($scope.countInternoFinalizado == false) {
                            $scope.bilheteQuantidade = data.Quantidade;
                            $scope.countInternoFinalizado = true;
                        }
                    });
            }

            return $http({ method: 'GET', url: url, params: filtro })
                .then((response) => {
                    return response.data;
                });
        };

        $scope.registroPorPaginaArray = [
            { label: 15, valor: 15 },
            { label: 30, valor: 30 },
            { label: 50, valor: 50 },
            { label: 100, valor: 100 }
        ];

        $scope.filterPageSize = { Size: 15 };

        $scope.changePageSize = function() {
            defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
            $scope.executeSearch();
        }

        $scope.viewBilheteDetalhe = function(bilhete) {
            if (bilhete) {

                $scope.bilheteView = {};

                BilheteResource.getBilheteDetalhe({ GlobalId: bilhete.GlobalId, BilheteDetalhado: true }).$promise
                    .then(data => {

                        if (data) {
                            // O cabeçalho usa o registro de EventoFinal. Mas quando esse registro
                            // pertence a um grupo que o usuário não enxerga (modo EPS), ele é removido
                            // no controller e o find retornaria undefined, deixando o detalhe vazio.
                            // Fallback: usa o detalhe com áudio (maior ArquivoDialogoDuracao) ou o primeiro.
                            const header = data.find(x => x.EventoFinal)
                                || data.slice().sort((a, b) => (b.ArquivoDialogoDuracao || 0) - (a.ArquivoDialogoDuracao || 0))[0];
                            angular.copy(header, $scope.bilheteView);
                            angular.copy(data, $scope.detalheList);

                            BilheteResource.bilheteUra({ globalid: bilhete.GlobalId }).$promise
                                .then((dataUra) => {
                                    angular.copy(dataUra, $scope.detalheUra);
                                }).catch((error) => {
                                    NotifyService.showError(error)
                                });

                            ModalService.openModal('modal_detalhe', null, null, { center: false, modal: false });
                        }

                    })

            }
        }

        $scope.changeCampanhaTipoId = function() {
            $rootScope.$broadcast('onLimpar', ['CampanhaId']);

            if ($scope.search.CampanhaTipoId === undefined)
                $scope.search.CampanhaTipoId = 0;

            $scope.campanhas = $scope.viewInativos ? $scope.campanhasListComInativas : $scope.campanhasListSemInativas;

            if ($scope.search.CampanhaTipoId > 0) {
                $scope.campanhas = _.filter($scope.campanhas, (item) => {
                    return item.CampanhaTemplateId == $scope.search.CampanhaTipoId;
                });
            }

            return $scope.campanhas;
        }

        $scope.viewBilheteTalkbot = function(bilhete) {
            if (bilhete) {
                $scope.bilheteGlobalId = bilhete.GlobalId;
                $scope.bilheteView = {};

                BilheteResource.bilheteTalkbot({ globalid: bilhete.GlobalId }).$promise.then((data) => {
                    if (data) {
                        angular.copy(data, $scope.bilheteView);
                    }
                }).catch(NotifyService.showError);
            }
        }


        $scope.viewModalEnviarEmail = function(bilhete) {
            if (bilhete) {
                var absUrl = $location.absUrl();
                absUrl = absUrl.replace("bilhete", "downloaddialogo/#arquivodialogo/#globalId/#codigoAcesso/#dataExpiracao/#id");
                $scope.enviarEmail.GlobalId = bilhete.GlobalId;
                $scope.enviarEmail.BilheteId = bilhete.BilheteId;
                $scope.enviarEmail.Link = '<a href="' + absUrl + '" style="text-decoration: none;"> Download </a>';
            }
        }

        $scope.enviarDialogoPorEmail = function() {
            if ($scope.enviarEmail) {
                var dto = $scope.enviarEmail;
                EmailDestinatarioResource.EnviarDialogoPorEmail(dto).$promise.then(() => {
                    NotifyService.showSuccess('telaBilhete.dialogoEnviadoComSucesso')
                }).catch(NotifyService.showError);

                $scope.enviarEmail = {};

                ModalService.closeModal('modal_Email');
            }
        }

        $scope.onEmailChange = function(emailId) {
            if (emailId) {
                $scope.emailSelecionado = $scope.emailsAutorizados.filter(x => x.Id == emailId)[0].Email;
            }
        }

        $scope.downloadFile = function(bilhete) {
            try {
                FileDownloadService.downloadWebApiFile("Ligacao/Download/" + bilhete.GlobalId + "/" + bilhete.ArquivoDialogo.replace('.vox', '').replace('.mp3', ''));
            } catch (err) {
                NotifyService.showError(err);
            }
        };

        $scope.downloadVideo = function(bilhete) {
            try {
                FileDownloadService.downloadWebApiFile("Ligacao/DownloadVideo/" + bilhete.GlobalId);
            } catch (err) {
                NotifyService.showError(err);
            }
        };

        $scope.reproduzirDialogo = function(bilhete) {
            $scope.search.bilheteDialogoAtivo = bilhete;
        }

        $scope.showFileDownloadButton = function(detalhe) {

            // mostrar o botao de download se houver o nome do arquivo e 
            // se o cenário não for um dos listados abaixo
            return (detalhe.ArquivoDialogo !== '' &&
                    detalhe.ArquivoDialogo !== null &&
                    detalhe.BilheteCenarioId !== 2 // Grupo
                    &&
                    detalhe.BilheteCenarioId !== 6 // Espera
                    &&
                    detalhe.BilheteCenarioId !== 7 // Fila
                    &&
                    detalhe.BilheteCenarioId !== 13 // CallProgress
                    &&
                    detalhe.BilheteCenarioId !== 11) ||
                (
                    detalhe.ArquivoDialogoCallProgress !== '' &&
                    detalhe.ArquivoDialogoCallProgress !== null
                ); // Discador
        }
        $scope.downloadFileDetail = function(detalhe) {
            try {
                var path = "Ligacao/DownloadDetalheId/" + detalhe.BilheteDetalheId;
                FileDownloadService.downloadWebApiFile(path);
            } catch (err) {
                NotifyService.showError(err);
            }
        };

        $scope.reproduzirDialogoDetalhe = function(detalhe) {
            $scope.search.bilheteDialogoAtivo = detalhe;
        };

        var generateUUID = function() {
            let d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }


        var exportarArquivoCDR = function(filtro) {
            let url = Config.getUrl("BilheteCdr/GenerateCDRBilhete")
            return $http({
                method: 'GET',
                url: url,
                params: filtro
            }).then((response) => {
                return response.data;
            });
        };

        $scope.confirma = function() {
            ModalService.showMessage('telaBilhete.confirmaCDR', null, () => $scope.downloadCDR());
        };

        $scope.downloadCDR = function() {
            let search = $scope.search;
            ModalService.showLoading();
            let fileName = generateUUID();
            tratarOrigemDesconexao();
            
            let filtro = {
                BilheteStatusId: search.BilheteStatusId,
                CampanhaDiscagemStatusId: search.CampanhaDiscagemStatusId,
                GrupoId: (search.GrupoId == undefined || search.GrupoId == 0) ? [] : search.GrupoId.join(),
                RotaId: search.RotaId,
                NA: search.NA,
                NAContem: search.NAContem,
                DirecaoId: search.BilheteDirecaoId,
                UsuarioId: search.UsuarioId,
                DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                GlobalId: search.GlobalId,
                Duracao: search.DuracaoMaiorQue,
                NB: search.NB,
                NBContem: search.NBContem,
                BilheteCenarioId: search.BilheteCenarioId,
                CausaCodigo: search.CausaCodigo,
                CampanhaId: (search.CampanhaId == undefined || search.CampanhaId == 0) ? [] : search.CampanhaId.join(),
                CampanhaTipoId: search.CampanhaTipoId,
                DiscagemTipoId: search.DiscagemTipoId,
                CodigoCliente: search.CodigoCliente,
                OrigemDesconexaoId: $scope.origemDesconexaoLista.length > 1 ? $scope.origemDesconexaoLista.join() : $scope.origemDesconexaoLista[0],
                ColunaOrdenacao: $scope.orderBy.column,
                DirecaoOrdenacao: $scope.orderBy.order,
                LigacaoInterna: search.LigacaoInterna,
                Atendido: search.Atendido,
                FileName: fileName,
                RotaFallback: $scope.search.RotaFallback,
                BilheteDetalhado: $scope.search.BilheteDetalhado,
                DownloadDetalhe: search.DownloadDetalhe,
                OrigemDesconexao: $scope.origemDesconexaoLista.length > 1 ? $scope.origemDesconexaoLista.join() : $scope.origemDesconexaoLista[0],
                BilheteEventoId: search.BilheteEventoId,
                OrigemId: 1,
                AbrirPaginaDetalhe: search.AbrirPaginaDetalhe,
                CarteiraId: search.CarteiraId,
                BilheteCDRAgendamentoId: $scope.search.BilheteCDRAgendamentoId,
                BilheteStatusDetalheId: search.BilheteStatusDetalheId
            };

            exportarArquivoCDR(filtro).then(() => {
                ModalService.hideLoading();
                $scope.fecharModalExportacao();
                setTimeout(() => {
                    if (filtro.AbrirPaginaDetalhe) {
                        $scope.search.AbrirPaginaDetalhe = false;
                        window.open('/#/bilheteCdr/detalheExportar', '_blank');
                    }
                }, 600);
            }).catch((data) => {
                ModalService.hideLoading();
                NotifyService.showError(data.error);
            });
        }

        $scope.fecharModalExportacao = function() {
            ModalService.closeModal('modal_cdr')
        };

        $scope.abrirModalExportacao = function() {
            ModalService.openModal('modal_cdr')
        };

        $scope.limparFiltro = function() {

            const dataI = new Date();
            const dataF = new Date();
            dataF.setDate(dataF.getDate() + 1);

            $scope.search = {
                BilheteStatusId: 0,
                CampanhaDiscagemStatusId: 0,
                GrupoId: '',
                CarteiraId: '',
                RotaId: '',
                GlobalId: '',
                NA: '',
                NAContem: '',
                UsuarioId: 0,
                DataInicio: dataI,
                DataFim: dataF,
                NB: '',
                NBContem: '',
                BilheteDirecaoId: 0,
                DiscagemTipoId: 0,
                CampanhaTipoId: 0,
                CodigoCliente: '',
                OrigemDesconexao: '',
                BilheteStatusDetalheId: 0,
                CausaCodigo: ''
            }

            $rootScope.$broadcast('onLimpar');
            $scope.changeCampanhaTipoId();
            $scope.bilheteList = [];
            $scope.submitted = false;
            $scope.reverse = false;

            $scope.orderBy = {
                column: "BilheteId",
                order: "Desc"
            };
        }

        $scope.viewCausaCodigo = function(codigo) {
            var promise = BilheteResource.causaCodigoById({
                causaCodigo: codigo
            }).$promise;

            promise.then((result) => {
                if (result) {
                    var msg = `<h4>${$translate.instant('telaBilhete.detalheDaCausa')} - ${codigo}</h4></br>${$translate.instant('campo.nome')}: ${result.Alias}</br> 
                        ${$translate.instant('telaBilhete.termoTecnico')}: ${result.Descricao} </br>`
                    ModalService.alert(msg);
                }
            });
        }

        let updateUsuarioList = function(response) {
            if (!response.data || response.data.length <= 0) {
                return $scope.usuarios = [];
            }

            let users = [];
            response.data.forEach(function(item) {

                const newItem = {
                    UsuarioId: item.UsuarioId,
                    Nome: item.Descricao
                }
                users.push(newItem)
            });
            $scope.usuarios = users;
        };


        let getUsuarioPorGrupo = function() {
            // Se não for Informado um Grupo exibe Todos os Ramais
            if (!$scope.search.GrupoId || $scope.search.GrupoId.length <= 0) {
                return $scope.usuarios = usuariosList;
            }

            $http({ url: Config.getUrl('ramal/tipo/1/grupos/' + $scope.search.GrupoId.join(',')), method: 'GET' })
                .then(updateUsuarioList)
                .catch(NotifyService.showError);
        }

        $scope.onChangeGrupoUsuario = function() {
            getUsuarioPorGrupo();
        };

        let getCarteiraPorGrupo = function(id) {
            if ($scope.viewInativos)
                $scope.grupos = _.filter($scope.grupoListComInativos, function(item) {
                    return item.CarteiraId == id;
                });
            else
                $scope.grupos = _.filter($scope.grupoListSemInativos, function(item) {
                    return item.CarteiraId == id;
                });
        }

        let getCarteiraPorUsuario = function(id) {
            if ($scope.viewInativos)
                $scope.usuarios = _.filter($scope.usuariosListComInativos, function(item) {
                    return item.CarteiraId == id;
                });
            else
                $scope.usuarios = _.filter($scope.usuariosListSemInativos, function(item) {
                    return item.CarteiraId == id;
                });
        }


        let getCarteiraPorRota = function(id) {
            $scope.rotaList = _.filter($scope.rotas, function(item) {
                return item.CarteiraId == id;
            });

        }

        let getCarteiraPorCampanha = function(id) {
            if ($scope.viewInativos)
                $scope.campanhas = _.filter($scope.campanhasListComInativas, function(item) {
                    return item.CarteiraId == id;
                });
            else
                $scope.campanhas = _.filter($scope.campanhasListSemInativas, function(item) {
                    return item.CarteiraId == id;
                });
        }

        $scope.onChangeCarteira = function() {
            if ($scope.search.CarteiraId == undefined) {
                $scope.search.CarteiraId = 0;
                $scope.rotaList = $scope.rotas;

                if (!$scope.viewInativos) {
                    $scope.campanhas = $scope.campanhasListSemInativas;
                    $scope.grupos = $scope.grupoListSemInativos;
                    $scope.usuarios = $scope.usuariosListSemInativos;
                } else {
                    $scope.campanhas = $scope.campanhasListComInativas;
                    $scope.grupos = $scope.grupoListComInativos;
                    $scope.usuarios = $scope.usuariosListComInativos;
                }
            } else {
                getCarteiraPorGrupo($scope.search.CarteiraId);
                getCarteiraPorUsuario($scope.search.CarteiraId);
                getCarteiraPorCampanha($scope.search.CarteiraId);
                getCarteiraPorRota($scope.search.CarteiraId);
            }
        };

        if ($stateParams.Tempo) {
            $scope.executeSearch()
        }

        $scope.onChangeUsuario = function() {

            if ($scope.search.UsuarioId > 0) {
                $scope.search.BilheteDetalhado = true;

                var cenario = _.find($scope.cenariosList, function(item) {
                    return item.Descricao == "Ramal"
                });
                if (cenario != null)
                    $scope.search.BilheteCenarioId = cenario.BilheteCenarioId;


                var evento = _.find($scope.eventoList, function(item) {
                    return item.Descricao == "Em Atendimento"
                });

                if (evento != null)
                    $scope.search.BilheteEventoId = evento.BilheteEventoId;
            } else {
                $scope.search.BilheteDetalhado = false;
                $scope.search.BilheteCenarioId = 0;
                $scope.search.BilheteEventoId = 0;
            }

        };
    }])

})();
(function() {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteResource", ["$odataresource", function($odataresource) {
            return $odataresource("Bilhete/:BilheteId", {
                "BilheteId": "@BilheteId"
            }, {
                bilheteStatus: {
                    url: "Bilhete/BilheteStatus",
                    method: "GET",
                    isArray: true
                },
                bilheteStatusDetalhe: {
                    url: "Bilhete/BilheteStatusDetalhe",
                    method: "GET",
                    isArray: true
                },
                bilheteDetalhe: {
                    url: "Bilhete/BilheteDetalhe",
                    method: "GET",
                    isArray: true
                },
                bilheteDetalheTarifacao: {
                    url: "Bilhete/BilheteDetalheTarifacao",
                    method: "GET",
                    isArray: true
                },
                bilheteUra: {
                    url: "Bilhete/BilheteUra",
                    method: "GET",
                    isArray: true
                },
                bilheteById: {
                    url: "Bilhete/BilheteById",
                    method: "GET",
                    isArray: true
                },
                getBilheteDetalhe: {
                    url: "Bilhete/GetBilheteDetalhe",
                    method: "GET",
                    isArray: true
                },
                generateCDR: {
                    url: "Bilhete/GenerateCDR",
                    method: "POST"
                },
                downloadCDR: {
                    url: "Bilhete/DownloadCDR",
                    method: "GET"
                },
                causaCodigoById: {
                    url: "Bilhete/CausaCodigoById",
                    method: "GET",
                    isArray: false
                },
                getCount: {
                    url: "Bilhete/Count",
                    method: "GET"
                },
                cenario: {
                    url: "Bilhete/Cenario",
                    method: "GET",
                    isArray: true
                },
                evento: {
                    url: "Bilhete/Evento",
                    method: "GET",
                    isArray: true
                },
                bilheteTalkbot: {
                    url: "Bilhete/BilheteTalkbot",
                    method: "GET",
                    isArray: false
                },
                GetBaseHistorico: {
                    url: "Bilhete/GetBaseHistorico",
                    method: "GET",
                    isArray: true
                }
            });
        }]);
})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('BilheteCausaEditData', function BilheteCausaEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_uiSelect'
						]);
					}],
					status: ["BilheteCausaResource", "$stateParams", function (BilheteCausaResource, $stateParams) {
						if ($stateParams.StatusCausaId) {
							return BilheteCausaResource.get({
								StatusCausaId: $stateParams.StatusCausaId
							}).$promise;
						} else {
							return {};
						}
					}],
				}
			}
		})

		.controller("BilheteCausaEditController",
			["$scope", "$state", "status", "BilheteCausaResource", "NotifyService", "$translate", function ($scope, $state, status, BilheteCausaResource, NotifyService, $translate) {
				$scope.isNovo = !(status && status.StatusCausaId);
				$scope.inserirOuEditar = status && status.StatusCausaId ? $translate.instant('telaEditBilhete.editarBilheteCausa') : 
					$translate.instant('telaEditBilhete.cadastrarBilheteCausa');
				$scope.status = status;

				var mensagemSucesso = function (status) {
					NotifyService.showRegistroSalvo();
					if ($scope.Novo) {
						$scope.status = {};
					} else {
						$scope.status = status;
					}
					$state.go('main.bilhetecausa.list');
				};

				$scope.salvar = function salvar(valid) {
					var promise;

					if (!valid) {
						NotifyService.showInvalid();
						return;
					}

					if ($scope.status.StatusCausaId > 0) {
						promise = BilheteCausaResource.update($scope.status).$promise;
					}
					else {
						promise = BilheteCausaResource.save($scope.status).$promise;
					}

					promise.then(mensagemSucesso).catch(NotifyService.showError);
				};

				$scope.voltar = function () {
					$state.go('main.bilhetecausa.list');
				};
			}]
		);
})();

(function () {
	"use strict";

	var defaultPageSize = 300;

	var getOdataSearchShared = function (BilheteCausaResource, search, orderBy, $odata) {
		var odata = BilheteCausaResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.Descricao) {
			odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
		}
		if (search.Alias) {
			odata.filter(new $odata.Func("startswith", "Alias", search.Alias), true);
		}
		if (search.CausaCodigo) {
			odata.filter("CausaCodigo", "=", parseInt(search.CausaCodigo));
		}

		return odata;
	};

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.bilhetecausa", StateResolverProvider.configAbstract())
				.state("main.bilhetecausa.list", StateResolverProvider.configState("/bilhetecausa", "BilheteCausa", "List", {
					pageTitle: 'model.bilheteCausa',
					pageName: 'pageTitle.pesquisar'
				}))
				.state("main.bilhetecausa.new", StateResolverProvider.configState("/bilhetecausa/new", "BilheteCausa", "Edit", {
					pageTitle: 'model.bilheteCausa',
					pageName: 'acoes.cadastrar'
				}))
				.state("main.bilhetecausa.edit", StateResolverProvider.configState("/bilhetecausa/{StatusCausaId:[0-9]+}", "BilheteCausa", "Edit", {
					pageTitle: 'model.bilheteCausa',
					pageName: 'acoes.editar'
				}));
		}])

		.service("BilheteCausaListData", function BilheteCausaListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					statusList: ["BilheteCausaResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (BilheteCausaResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};
						if ($stateParams.storage)
							filtro = LocalStorageService.getItem("FiltroBilheteCausa");

						var orderBy = {
							column: "CausaCodigo",
							order: "asc"
						};
						var odata = getOdataSearchShared(BilheteCausaResource, filtro, orderBy, $odata, utils);
						return odata.page(defaultPageSize, 1).query();
					}],
				}
			}
		})

		.controller("BilheteCausaListController", ["$scope", "$state", "$odata", "statusList", "BilheteCausaResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", function ($scope, $state, $odata, statusList, BilheteCausaResource, utils, LocalStorageService, $stateParams,
			NotifyService) {
			$scope.searching = false;
			$scope.statusList = statusList;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroBilheteCausa") : {};

			$scope.orderBy = {
				column: "CausaCodigo",
				order: "asc"
			};

			var updateList = function (list) {
				$scope.statusList = list;
				$scope.statusList.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.statusList.pageSize = list.$pageSize || defaultPageSize;
				$scope.searching = false;
			};

			var getOdataSearch = function () {
				return getOdataSearchShared(BilheteCausaResource, $scope.search, $scope.orderBy, $odata, utils);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroBilheteCausa', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.status.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
			};

			updateList(statusList);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroBilheteCausa');
				$scope.search = {};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, {
						storage: true
					});
				}
				else {
					$state.go('main.bilhetecausa.list', {
						storage: true
					});
				}
			};

			$scope.editar = function (status) {
				status.IsEdit = true;
			};

			$scope.salvar = function (status) {
				if (!status.Alias) {
					return NotifyService.showInvalid();
				}
				var promise = BilheteCausaResource.update(status).$promise;
				promise.then(() => {
					NotifyService.showSuccess();
					status.IsEdit = false;
				}).catch(NotifyService.showError);
			};

		}]);
	})
();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteCausaResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "BilheteCausa/:StatusCausaId",
                { 
                    "StatusCausaId": "@StatusCausaId"
                 }, {
                    getPorPlataforma: {
                        url: "BilheteCausa/Plataforma",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteCDRResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BilheteCDR/:BilheteCDRId", { "BilheteCDRId": "@BilheteCDRId" },
                {
                    getBilheteCdrStatus: {
                        url: "BilheteCDR/Status",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    'use strict';

    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    var oDataSearchShared = function (search, orderBy, $http, Config) {
        var filtro = {
            DataCadastro: search.DataCadastro,
            BilheteStatusId: search.StatusId,
            SortColumn: orderBy.column,
            SortDirection: orderBy.order
        };
        return $http({
            method: 'GET',
            url: Config.getUrl("BilheteCDR/") + defaultPageIndex + "/" + defaultPageSize,
            params: filtro
        }).then(function (response) {
            return response.data;
        });

    }

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state('main.bilhetecdr', {
                    url: '',
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bilhetecdr.list',
                        pageTitle: 'pageTitle.relatorioDeBilhetes',
                        pageName: 'acoes.exportar',
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("main.bilhetecdr.list", StateResolverProvider.configState("/bilheteCdr/detalheExportar", "BilheteCdr", "DetalheExportar", {
                    pageTitle: 'pageTitle.relatorioDeBilhetes',
                    pageName: 'pageTitle.pesquisar'
                }))

        }])

        .service("BilheteCdrDetalheExportarData", function () {
            return function () {
                return {
                    statusList: ["BilheteCDRResource", function (BilheteCDRResource) {
                        return BilheteCDRResource.getBilheteCdrStatus().$promise;
                    }]
                }
            }
        })

        .controller("BilheteCdrDetalheExportarController", ["$scope", "$http", "Config", "FileDownloadService", "statusList", "NotifyService", "ModalService", "TranslateService", "BilheteCDRResource", function ($scope, $http, Config, FileDownloadService, statusList, NotifyService, ModalService, TranslateService, BilheteCDRResource) {
            $scope.formatDateTime = TranslateService.getAngularDateTimeFormatWithSeconds();
            
            $scope.search = {
                DataCadastro: moment().subtract(60, 'minutes').seconds(0).milliseconds(0).toDate(),
                StatusId: 0
            }

            $scope.orderBy = {
                column: "DataCadastro",
                order: "Desc"
            }

            $scope.list = [];
            $scope.submitted = false;
            $scope.registroPorPagina = [{ label: 15, valor: 15 }, { label: 30, valor: 30 }, { label: 50, valor: 50 }, { label: 100, valor: 100 }];
            $scope.filterPageSize = { Size: 15 };
            $scope.predicate = '';
            $scope.reverse = false;
            $scope.statusList = statusList;
            $scope.detalheFiltro = {};

            function oDataSearch() {
                if ($scope.search.DataCadastro == null) {
                    return NotifyService.showError(null, 'telaDetalheExportar.informeUmaDataDeCadastroValida')
                }
                return oDataSearchShared($scope.search, $scope.orderBy, $http, Config);
            }

            function updateList(pagination) {
                $scope.list = pagination.Data;
                $scope.list.recordCount = pagination.RecordCount;
                $scope.currentPage = pagination.PageIndex || 1;
                $scope.list.pageSize = pagination.PageSize || defaultPageSize;
                $scope.submitted = true;
                ModalService.hideLoading();
            }

            $scope.onSubmit = function () {
                try {
                    ModalService.showLoading();
                    $scope.list = [];
                    $scope.reverse = false;
                    $scope.orderBy = {
                        column: "DataCadastro",
                        order: "Desc"
                    };
                    $scope.submitted = false;
                    defaultPageIndex = 1;
                    oDataSearch().then(updateList).catch(NotifyService.showError, ModalService.hideLoading);

                } catch (ex) {
                    NotifyService.showError(ex);
                    ModalService.hideLoading();
                }
            }

            $scope.limparFiltro = function () {
                $scope.search = {
                    DataCadastro: '',
                    StatusId: 0
                }
            }

            $scope.pageChanged = function (newPage) {
                try {
                    if (defaultPageIndex != newPage) {
                        defaultPageIndex = newPage;
                        oDataSearch().then(updateList).catch(NotifyService.showError, ModalService.hideLoading);
                    }
                } catch (ex) {
                    NotifyService.showError(ex);
                    ModalService.hideLoading();
                }
            }

            $scope.changePageSize = function () {
                defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
                $scope.onSubmit();
            }

            $scope.order = function (predicate) {
                try {
                    ModalService.showLoading();
                    $scope.predicate = predicate;
                    $scope.reverse = $scope.predicate ? !$scope.reverse : false;
                    $scope.orderBy = {
                        column: predicate,
                        order: !$scope.reverse ? "Desc" : "Asc",
                    };

                    oDataSearch().then(updateList).catch(NotifyService.showError, ModalService.hideLoading);
                } catch (ex) {
                    NotifyService.showError(ex);
                    ModalService.hideLoading();
                }
            }

            $scope.exibirFiltro = function (bilhete) {
                return $http({
                    method: 'GET',
                    url: Config.getUrl("BilheteCDR/DetalheFiltro/") + bilhete.BilheteCDRId,
                    params: bilhete.BilheteCDRId
                }).then((response) => $scope.detalheFiltro = response.data);
            }

            $scope.baixarArquivo = function (arquivo) {
                try {
                    ModalService.showLoading();
                    FileDownloadService.downloadWebApiFile("BilheteCdr/DownloadCDR/" + arquivo);
                    ModalService.hideLoading();
                } catch (ex) {
                    ModalService.hideLoading();
                    NotifyService.showError(ex);
                }
            }



            $scope.reprocessarArquivo = function (id) {
                try {
                    ModalService.showLoading();
                    $http({
                        method: 'POST',
                        url: Config.getUrl("BilheteCDR/ReprocessarCdr"),
                        data: { BilheteCDRId: id },
                        cache: false
                    }).then(() => {
                        ModalService.hideLoading();
                        NotifyService.showSuccess('telaDetalheExportar.aExportacaoDoBilheteFoiIniciada')
                        $scope.onSubmit();

                    }).catch((response) => {
                        NotifyService.showError(response);
                    });
                } catch (ex) {
                    NotifyService.showError(ex);
                    ModalService.hideLoading();
                }
            }

            $scope.onSubmit();

        }]);

})();
(function () {
    "use strict";
    const defaultPageSize = 15;

    function getOdataSearchShared(BilheteDownloadResource, orderBy) {
        const odata = BilheteDownloadResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);
        return odata;
    }

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bilhetedownload", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bilhetedownload.list',
                        pageTitle: 'pageTitle.downloadDeMp3',
                        pageName: 'pageTitle.downloadDeMp3'
                    }
                })
                .state("main.bilhetedownload.list", StateResolverProvider.configState("/bilhetedownload", "BilheteDownload", "List", {
                    pageTitle: 'pageTitle.downloadDeMp3',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("BilheteDownloadListData", function BilheteDownloadListData() {
            return function () {
                return {
                    downloadList: ["BilheteDownloadResource", function (BilheteDownloadResource) {
                        return BilheteDownloadResource.odata().orderBy("BilheteDownloadId", "desc").page(defaultPageSize, 1).query();
                    }],
                    grupoList: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getTodosGrupos();
                    }],
                    statusList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatus().$promise;
                    }],
                    rotaList: ["RotaResource", function (RotaResource) {
                        return RotaResource.odata().select(["RotaId", "Nome"]).query();
                    }],
                    servicoList: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.odata().select(["ServicoId", "Numero"]).query();
                    }],
                    statusDetalheList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatusDetalhe().$promise;
                    }],
                    ramaisList: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({
                            RamalTipoId: "1,6"
                        }).$promise;
                    }],
                    carteiraList: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    campanhaList: ["CampanhaResource", function(CampanhaResource) {
                        return CampanhaResource.GetTodasCampanhas();
                    }],
                    lazy: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                }
            }
        })

        .controller("BilheteDownloadListController", ["$scope", "$filter", "$odata", "BilheteDownloadResource", "downloadList", "ramaisList", "rotaList", "servicoList", "statusList", "campanhaList", "statusDetalheList", "grupoList", "NotifyService", "$translate", "ModalService", "Config", "$window", "carteiraList", "BilheteResource", function ($scope, $filter, $odata, BilheteDownloadResource, downloadList, ramaisList, rotaList, servicoList,
            statusList, campanhaList, statusDetalheList, grupoList, NotifyService, $translate, ModalService, Config, $window, carteiraList, BilheteResource) {
            const dataInicio = moment().subtract(60, 'minutes').seconds(0).milliseconds(0).toDate();
            const dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();

            $scope.search = {
                DataInicio: dataInicio,
                DataFim: dataFim
            };

            $scope.filtro = {};
            $scope.orderBy = {
                column: "BilheteDownloadId",
                order: "desc"
            };
            $scope.statusList = statusList;
            $scope.statusDetalheList = statusDetalheList;
            $scope.todosGrupos = grupoList;
            $scope.grupoList = _.filter($scope.todosGrupos, function (item) {
                return item.Ativo == true;
            });
            $scope.grupos = $scope.grupoList;
            $scope.rotaList = rotaList;
            $scope.servicoList = servicoList;
            $scope.ramaisList = ramaisList;
            $scope.carteiraList = carteiraList;
            $scope.campanhaList = campanhaList;
            $scope.campanhas = campanhaList;

            $scope.detalheList = [];
            $scope.direcaoList = [
                { DirecaoId: 2, Descricao: $translate.instant('campo.efetuada') },
                { DirecaoId: 1, Descricao: $translate.instant('campo.recebida') }
            ];
            $scope.expanded = false;
            $scope.submitted = false;
            $scope.EnableDownload = false;
            $scope.splitArquivos = true;

            function updateList(list) {
                $scope.downloadList = list;
                $scope.downloadList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.downloadList.pageSize = list.$pageSize || defaultPageSize;
                $scope.submitted = false;
            };

            $scope.executeSearch = function () {
                $scope.submitted = true;
                getOdataSearch().page($scope.downloadList.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.downloadList.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
            };

            function getOdataSearch() {
                return getOdataSearchShared(BilheteDownloadResource, $scope.orderBy, $odata);
            };

            updateList(downloadList);

            $scope.mostrarDescricao = function (json) {
                let msg = `<h4>${$translate.instant('telaBilheteDownload.detalhesDoDownload')}</h4>`;
                const objeto = JSON.parse(json);
                const isInvalid = (valor) => {
                    return !valor || valor === 0;
                };

                function addProp(objeto, propriedade, translatePropriedade, nomeLista, nomeElemento, valorElemento) {
                    const value = objeto[propriedade];
                    if (!isInvalid(value)) {
                        msg += `<p>
                            ${$translate.instant(translatePropriedade)} : 
                            ${$scope[nomeLista].find((el) => el[nomeElemento] == value)[valorElemento]}
                        </p>`;
                    }
                }

                for (let propriedade in objeto) {
                    if (propriedade == 'DirecaoId') {
                        addProp(objeto, propriedade, 'telaBilheteDownload.direcao', 'direcaoList', 'DirecaoId', 'Descricao')
                    } else if (propriedade == 'BilheteStatusId') {
                        addProp(objeto, propriedade, 'telaBilheteDownload.statusDoBilhete', 'statusList', 'BilheteStatusId', 'Descricao')
                    } else if (propriedade == 'BilheteStatusDetalheId') {
                        addProp(objeto, propriedade, 'telaBilheteDownload.detalheDoStatus', 'statusDetalheList', 'BilheteStatusDetalheId', 'Descricao')
                    } else if (propriedade == 'GrupoId') {
                        addProp(objeto, propriedade, 'model.grupo', 'grupoList', 'GrupoId', 'Descricao')
                    } else if (propriedade == 'RotaId') {
                        addProp(objeto, propriedade, 'model.rota', 'rotaList', 'RotaId', 'Nome')
                    } else if (propriedade == 'ServicoId') {
                        addProp(objeto, propriedade, 'model.servico', 'servicoList', 'ServicoId', 'Numero')
                    } else if (propriedade == 'RamalId') {
                        addProp(objeto, propriedade, 'model.ramal', 'ramaisList', 'RamalId', 'Numero')
                    } else if (propriedade == 'DuracaoMaiorQue') {
                        const value = objeto[propriedade];
                        if (!isInvalid(value)) {
                            msg += `<p>
                                ${$translate.instant('telaBilheteDownload.duracaoMaiorQue')} : 
                                ${value}
                            </p>`;
                        };

                    } else if (propriedade == 'DataFim') {
                        const value = objeto[propriedade];
                        if (!isInvalid(value)) {
                            msg += `<p>
                                ${$translate.instant('telaBilheteDownload.dataDeTermino')} : 
                                ${$filter('date')(moment(value).toDate(), 'dd/MM/yyyy HH:mm:ss')}
                            </p>`;
                        }
                    } else if (propriedade == 'DataInicio') {
                        const value = objeto[propriedade];
                        if (!isInvalid(value)) {
                            msg += `<p>
                                ${$translate.instant('telaBilheteDownload.dataDeInicio')} : 
                                ${$filter('date')(moment(value).toDate(), 'dd/MM/yyyy HH:mm:ss')}
                            </p>`;
                        }
                    } else if (propriedade == 'CausaCodigo') {
                        const value = objeto[propriedade];
                        if (!isInvalid(value)) {
                            msg += `<p>
                                ${$translate.instant('telaBilheteDownload.codigoDeCausa')} : 
                                ${value}
                            </p>`;
                        }
                    }
                }

                ModalService.alert(msg);
            };

            function getToken() {
                return angular.fromJson($window.localStorage.getItem("Token") || "{}");
            };

            $scope.onChangeCarteira = function () {
                if ($scope.search.CarteiraId == undefined)
                    $scope.search.CarteiraId = null;
                else
                    $scope.search.CampanhaId = null;
                
                if ($scope.search.CarteiraId == 0){
                    $scope.grupos = $scope.grupoList;
                    $scope.campanhaList = $scope.campanhas;
                } 
                else{
                    $scope.grupos = _.filter($scope.grupoList, (item) => {
                        return item.CarteiraId == $scope.search.CarteiraId;
                });
                    $scope.campanhaList = _.filter($scope.campanhas, function(item) {
                    return item.CarteiraId == $scope.search.CarteiraId;
                });
                }
            };

            $scope.downloadFile = function (id) {

                BilheteDownloadResource.bilheteStatus({ id: id }).$promise.then(retorno => {

                    retorno.forEach(x => {

                        try {
                            const path = Config.getUrl("BilheteDownload/Arquivo/" + id + '/' + x.Name);
                            const token = getToken();
                            const params = {
                                access_token: token.access_token,
                                token_type: 'bearer'
                            };
                            const url = [path, $.param(params)].join('?');
                            const iframe = $("<iframe src='" + url + "' style='display:none;' />");
                            iframe.appendTo("body");
                        } catch (err) {
                            NotifyService.showError(err);
                        }

                    });

                })
            }

            $scope.buscarDownload = function () {

                ModalService.showLoading();

                $scope.EnableDownload = false;

                var dataI = moment($scope.search.DataInicio);
                var dataF = moment($scope.search.DataFim);

                let filtro = {
                    DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                    DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                    DirecaoId: $scope.search.DirecaoId,
                    CarteiraId: $scope.search.CarteiraId,
                    GrupoId: $scope.search.GrupoId,
                    RotaId: $scope.search.RotaId,
                    ServicoId: $scope.search.ServicoId,
                    RamalId: $scope.search.RamalId,
                    GlobalId: $scope.search.GlobalId,
                    NB: $scope.search.NB,
                    CausaCodigo: $scope.search.CausaCodigo,
                    Duracao: $scope.search.DuracaoMaiorQue,
                    BilheteDetalhado: true,
                    ExisteAudio: true,
                    CampanhaId: $scope.search.CampanhaId
                };

                var qtdDias = dataF.diff(dataI, 'days')
                if (qtdDias <= 7) {
                    BilheteResource.getCount(filtro).$promise
                        .then((data) => {

                            if (data.Quantidade > 0) {
                                $scope.executeSearch();
                                $scope.EnableDownload = data.Quantidade > 0;

                                ModalService.alert("telaBilheteDownload.quantidadeConsulta", { Quantidade: data.Quantidade })
                            }
                            else
                            {
                                ModalService.alert("telaBilheteDownload.consultaSemRetorno")
                            }                            
                            ModalService.hideLoading();
                        });
                } else {
                    ModalService.hideLoading();
                    NotifyService.showError(null, 'telaBilheteDownload.oIntervaloMaximoParaDownload');
                }
            }

            $scope.requestDownload = function () {

                ModalService.confirmMessage("telaBilheteDownload.perguntaDownload", null, () => {
                    var dataI = moment($scope.search.DataInicio);
                    var dataF = moment($scope.search.DataFim);

                    let filtro = {
                        BilhetePaginadoDto: {
                            DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                            DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                            DirecaoId: $scope.search.DirecaoId,
                            CarteiraId: $scope.search.CarteiraId,
                            GrupoId: $scope.search.GrupoId,
                            RotaId: $scope.search.RotaId,
                            ServicoId: $scope.search.ServicoId,
                            RamalId: $scope.search.RamalId,
                            GlobalId: $scope.search.GlobalId,
                            NB: $scope.search.NB,
                            CausaCodigo: $scope.search.CausaCodigo,
                            Duracao: $scope.search.DuracaoMaiorQue,
                            BilheteDetalhado: true,
                            ExisteAudio: true,
                            CampanhaId: $scope.search.CampanhaId
                        },
                        SplitArquivo: $scope.splitArquivos
                    };

                    var qtdDias = dataF.diff(dataI, 'days')
                    if (qtdDias <= 7) {
                        BilheteDownloadResource.save(filtro).$promise
                            .then((res) => {
                                if (res.Quantidade > 0) {
                                    $scope.executeSearch();
                                    NotifyService.showSuccess('telaBilheteDownload.processoDeCriacaoDoArquivoIniciado');
                                } else {
                                    NotifyService.showError(null, 'telaBilheteDownload.aPesquisaNaoRetornouBilhetes');
                                }
                                $scope.limparFiltro();
                            })
                            .catch(NotifyService.showError);
                    } else {
                        NotifyService.showError(null, 'telaBilheteDownload.oIntervaloMaximoParaDownload');
                    }
                });

            }

            $scope.atualizarLista = function () {
                $scope.executeSearch();
                NotifyService.showSuccess('telaBilheteDownload.listaAtualizadaComSucesso')
            }

            $scope.limparFiltro = function () {
                $scope.search = {
                    BilheteStatusId: null,
                    BilheteStatusDetalheId: null,
                    GrupoId: null,
                    RotaId: null,
                    GlobalId: null,
                    ServicoId: null,
                    RamalId: null,
                    CarteiraId: null,
                    DataInicio: moment().subtract(60, 'minutes').seconds(0).milliseconds(0).toDate(),
                    DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                    NB: null,
                    DirecaoId: null,
                    CampanhaId: null
                }
                $scope.downloadList = [];
                $scope.submitted = false;
                $scope.EnableDownload = false;
                updateList($scope.downloadList);
            }
        }])
})();
(function () {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("BilheteDownloadResource", ["$odataresource", function ($odataresource) {
      return $odataresource("BilheteDownload/:BilheteDownloadId", { "BilheteDownloadId": "@BilheteDownloadId" },
        {
          bilheteStatus: {
            url: "BilheteDownload/Files/:id",
            method: "GET",
            isArray: true
          }
        });
    }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BaseHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BaseHistorico/:Id", { "Id": "@Id" },
                {
                    
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bilheteHistorico", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bilheteHistorico.list',
                        pageTitle: 'pageTitle.cardTitle',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.bilheteHistorico.list", StateResolverProvider.configState("/bilheteHistorico", "BilheteHistorico", "List", {
                    pageTitle: 'pageTitle.bilheteHistorico',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service('BilheteHistoricoListData', function BilheteHistoricoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    baseHistoricoList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.GetBaseHistorico().$promise;
                    }]
                }
            }
        })

        .controller("BilheteHistoricoListController", ["$scope", "$http", "NotifyService", "ModalService", "Config", "BilheteHistoricoResource", "baseHistoricoList", "BaseHistoricoResource", "BilheteResource", "$translate", "FileDownloadService", function ($scope, $http, NotifyService, ModalService, Config,
            BilheteHistoricoResource, baseHistoricoList, BaseHistoricoResource, BilheteResource, $translate, FileDownloadService) {
            $scope.forms = [];
            $scope.searching = false;

            var pageIndex = 1;
            var pageSize = 10;

            $scope.search = {
                DataInicio: moment().subtract(1, 'days').seconds(0).milliseconds(0).toDate(),
                DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate()
            };

            $scope.bilheteHistoricoList = [];
            $scope.baseHistoricoList = baseHistoricoList;
            $scope.baseHistorico = {};
            $scope.detalheHistoricoList = [];
            $scope.bilheteGlobalId = '';
            $scope.isPageChanged = false;
            $scope.isNew = true;
            $scope.minMaxBilhete = {};

            var updateList = function (list) {
                $scope.bilheteHistoricoList = list;
                $scope.bilheteHistoricoList.recordCount = list.recordCount || list.length;
                $scope.currentPage = list.currentPage || 1;
                $scope.bilheteHistoricoList.pageSize = list.pageSize || 10;
            };

            $scope.viewBilheteDetalhe = function (bilhete) {
                if (bilhete) {
                    $scope.bilheteGlobalId = bilhete.GlobalId;
                    BilheteHistoricoResource.getBilheteDetalheHistorico({ globalid: bilhete.GlobalId, bilheteId: bilhete.BilheteId, baseHistoricoId: $scope.search.Id }).$promise
                        .then((data) => {
                            angular.copy(data, $scope.detalheHistoricoList);
                            ModalService.openModal('modal_detalhe_Historico', null, null, { center: false, modal: false });
                        }).catch((error) => {
                            NotifyService.showError(error)
                        });
                }
            }

            $scope.getOdataSearch = function () {

                var filtro = {
                    BaseHistoricoId: $scope.search.Id,
                    GlobalId: $scope.search.GlobalId,
                    RamalNumero: $scope.search.RamalNumero,
                    Duracao: $scope.search.DuracaoMaiorQue,
                    CodigoCliente: $scope.search.CodigoCliente,
                    NB: $scope.search.NB,
                    DataI: $scope.search.DataInicio,
                    DataF: $scope.search.DataFim,
                    PageIndex: pageIndex,
                    PageSize: pageSize
                };

                if (!$scope.isPageChanged) {
                    $scope.bilheteQuantidade = -1;

                    BilheteHistoricoResource.getBilheteHistoricoPaginadoCount(filtro).$promise
                        .then((data) => {
                            $scope.bilheteQuantidade = data.Quantidade;
                        });
                };

                return BilheteHistoricoResource.getBilheteHistorico(filtro).$promise
                    .then(response => {
                        $scope.bilheteHistoricoList = response.Data;
                        $scope.bilheteHistoricoList.recordCount = response.RecordCount;
                        $scope.bilheteHistoricoList.currentPage = response.PageIndex || 1;
                        $scope.bilheteHistoricoList.pageSize = response.PageSize || 10;
                        $scope.searching = false;

                        return $scope.bilheteHistoricoList;
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.pageChanged = function (newPage) {
                if (pageIndex != newPage) {
                    $scope.searching = true;
                    $scope.isPageChanged = true;
                    pageIndex = newPage;
                    $scope.getOdataSearch()
                        .then((list) => {
                            updateList(list);
                            $scope.isPageChanged = false;
                            $scope.searching = false;
                        }).catch((error) => {
                            NotifyService.showError(error);
                            $scope.isPageChanged = false;
                            $scope.searching = false;
                        });
                }
            };


            $scope.executeSearch = function () {
                if (!$scope.forms.bilheteHistoricoForm.$valid) {
                    return;
                }

                if(!$scope.search.RamalNumero 
                    && !$scope.search.NB 
                    && !$scope.search.GlobalId 
                    && !$scope.search.CodigoCliente 
                    && !$scope.search.DuracaoMaiorQue){
                    ModalService.alert($translate.instant('telaBilhete.camposRequeridos'));
                    return;
                }

                $scope.searching = true;
                $scope.forms.bilheteHistoricoForm.$setDirty();

                $scope.getOdataSearch();
            };

            $scope.downloadCDR = function () {
                ModalService.showLoading();
                var fileName = generateUUID();

                var filtro = {
                    BaseHistoricoId: $scope.search.Id,
                    GlobalId: $scope.search.GlobalId,
                    RamalNumero: $scope.search.RamalNumero,
                    Duracao: $scope.search.DuracaoMaiorQue,
                    CodigoCliente: $scope.search.CodigoCliente,
                    NB: $scope.search.NB,
                    DataI: $scope.search.DataInicio,
                    DataF: $scope.search.DataFim,
                    DownloadDetalhe: false,
                    FileName: fileName,
                    OrigemId: 4,
                    AbrirPaginaDetalhe: $scope.search.AbrirPaginaDetalhe
                };

                exportarArquivoCDR(filtro)
                    .then(() => {
                        if (filtro.AbrirPaginaDetalhe) {
                            window.open('/#/bilheteCdr/detalheExportar', '_blank');
                        }
                        $scope.search.AbrirPaginaDetalhe = false;
                        ModalService.hideLoading();
                        ModalService.closeModal('modal_cdr_Historico')
                    }).catch((error) => {
                        ModalService.hideLoading();
                        NotifyService.showError(error);
                    });
            };

            var generateUUID = function () {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
                });
                return uuid;
            }


            var exportarArquivoCDR = function (filtro) {
                var url = Config.getUrl("BilheteCdr/GenerateCDR")
                return $http({
                    method: 'GET',
                    url: url,
                    params: filtro
                }).then((response) => { return response.data; });
            };

            $scope.limparFiltro = function () {
                $scope.search = {
                    BaseHistoricoId: null,
                    GlobalId: null,
                    DataInicio: moment().subtract(1, 'days').seconds(0).milliseconds(0).toDate(),
                    DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                    PageIndex: pageIndex,
                    PageSize: pageSize
                };
                $scope.executeSearch();
            };

            $scope.onEditar = function (item) {
                item.Senha = null;
                $scope.baseHistorico = item;
                $scope.isNew = false;
            }

            $scope.onSalvar = function () {

                if ($scope.isNew) {
                    BaseHistoricoResource.save($scope.baseHistorico).$promise.then(result => {
                        NotifyService.showSuccess();
                        ReloadBaseHistorico()
                    }).catch(error => {
                        NotifyService.showError(error);
                    });
                } else {
                    BaseHistoricoResource.update($scope.baseHistorico).$promise.then(result => {
                        NotifyService.showSuccess();
                        ReloadBaseHistorico();
                    }).catch(error => {
                        NotifyService.showError(error);
                    });
                }

                $scope.onNovo();
            }

            $scope.onExcluir = function (item) {
                item.Ativo = false;
                BaseHistoricoResource.update(item).$promise.then(result => {
                    NotifyService.showSuccess();
                    ReloadBaseHistorico();
                }).catch(error => {
                    NotifyService.showError(error);
                });

            }

            $scope.onNovo = function () {
                $scope.baseHistorico = {};
                $scope.isNew = true;
            }

            function ReloadBaseHistorico() {
                BilheteResource.GetBaseHistorico().$promise.then(result => {
                    $scope.baseHistoricoList = result;
                }).catch(error => {
                    NotifyService.showError(error);
                });;
            }

            $scope.onChangeBaseHistorico = function(){

                $scope.minMaxBilhete = {};

                if(!$scope.search.Id)
                    return;

                BilheteHistoricoResource.getMinMaxBilhete({baseHistoricoId: $scope.search.Id}).$promise.then(result => {
                    $scope.minMaxBilhete = result[0];
                }).catch(error => {
                    NotifyService.showError(error);
                });
            }

            $scope.downloadFile = function (bilhete) {
                try {
                    FileDownloadService.downloadWebApiFile("BilheteHistorico/Download/" + (bilhete.GlobalId || $scope.bilheteGlobalId) + "/" + bilhete.ArquivoDialogo + "/" + $scope.search.Id);
                } catch (err) {
                    NotifyService.showError(err);
                }
            };
        }]
        );
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BilheteHistorico/:BilheteId", { "BilheteId": "@BilheteId" },
                {
                    getBilheteHistorico: {
                        url: "BilheteHistorico/GetBilheteHistorico",
                        method: "GET",
                        isArray: false
                    },
                    getBilheteDetalheHistorico: {
                        url: "BilheteHistorico/GetBilheteDetalheHistorico",
                        method: "GET",
                        params: {
                            "bilheteId": "@bilheteId",
                            "globalId": "@globalId",
                            "baseHistoricoId": "@baseHistoricoId"
                        },
                        isArray: true
                    },                    
                    getMinMaxBilhete: {
                        url: "BilheteHistorico/GetMinMaxBilhete",
                        method: "GET",
                        params: {
                            "baseHistoricoId": "@baseHistoricoId"
                        },
                        isArray: true
                    },
                    getBilheteHistoricoPaginadoCount: {
                        url: "BilheteHistorico/GetBilheteHistoricoPaginadoCount",
                        method: "GET"
                    }
                });
        }]);
})();
(function () {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bilheteTalkbot", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bilheteTalkbot.list',
                        pageTitle: 'pageTitle.relatorioDeBilhetesTalkbot',
                        pageName: 'model.bilheteTalkbot'
                    }
                })
                .state("main.bilheteTalkbot.list", StateResolverProvider.configState("/bilheteTalkbot", "BilheteTalkbot", "List", {
                    pageTitle: 'pageTitle.relatorioDeBilhetesTalkbot',
                    pageName: 'pageTitle.pesquisar',
                    css: true,
                    cssFiles: ['app/pages/bilhete/style/list.css']
                }))
        }])

        .service("BilheteTalkbotListData", function ReportListData() {
            return function () {
                return {
                    campanhasList: ["UraTalkbotResource", function (UraTalkbotResource) {
                        return UraTalkbotResource.GetCampanhaScripts().$promise;
                    }],
                    scriptsList: ["UraTalkbotResource", function (UraTalkbotResource) {
                        return UraTalkbotResource.GetScripts().$promise;
                    }],
                    acionamentoList: ["BilheteTalkbotResource", function (BilheteTalkbotResource) {
                        return BilheteTalkbotResource.acionamento().$promise;
                    }],
                    fluxoList: ["BilheteTalkbotResource", function (BilheteTalkbotResource) {
                        return BilheteTalkbotResource.fluxofluxoOut().$promise;
                    }],
                }
            }
        })

        .controller("BilheteTalkbotListController", ["$scope", "$rootScope", "$http", "$location", "$stateParams", "Config", "UraTalkbotResource", "BilheteTalkbotResource", "scriptsList", "campanhasList", "NotifyService", "$translate", "ModalService", "acionamentoList", "fluxoList", "FileDownloadService", function ($scope, $rootScope, $http, $location, $stateParams, Config, UraTalkbotResource, BilheteTalkbotResource,
            scriptsList, campanhasList, NotifyService, $translate, ModalService, acionamentoList, fluxoList, FileDownloadService) {

            var dataInicio = moment().seconds(0).milliseconds(0).toDate();
            var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();

            $scope.search = {
                DataI: dataInicio,
                DataF: dataFim,
                CampanhaId: null,
                IntegracaoId: null,
                AcionamentoId: null,
                FluxoId: null
            };
            $scope.campanhas = campanhasList;
            $scope.scriptsList = scriptsList;
            $scope.acionamentoList = acionamentoList.map(x => {
                x.Nome = (x.Ura || '') + " - " + x.Nome;
                return x;
            });
            $scope.fluxos = fluxoList.map(x => {
                x.Nome = (x.Ura || '')  + " - " +  x.Nome;
                return x;
            });
            $scope.bilheteTalkbotList = [];
            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
                });
                return uuid;
            }

            $scope.export = function () {

                var dataI = moment($scope.search.DataI);
                var dataF = moment($scope.search.DataF);
                var dateDiff = dataF.diff(dataI, 'days');
                if (dateDiff > 7) {
                    NotifyService.showMessage('bilheteTalkbotList.limitePesquisarExportar', "warning");
                    return;
                }

                var fileName = generateUUID();

                $scope.search.FileName = fileName;

                var url = Config.getUrl('BilheteTalkbot/Exportar');
                return $http({
                    method: 'GET',
                    url: url,
                    params: $scope.search
                }).then(() => {
                    FileDownloadService.downloadWebApiFile('BilheteTalkbot/' + fileName + '/download/');
                }).catch(NotifyService.showError);
            };


            $scope.executeSearch = function () {

                ModalService.showLoading();
                $scope.reverse = false;

                $scope.orderBy = {
                    column: "BilheteTalkbotId",
                    order: "Desc"
                };

                defaultPageIndex = 1;
                $scope.getOdataSearch()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                        $scope.submitted = false;
                    });
            };

            function updateList(pagination) {
                $scope.bilheteTalkbotList = pagination.Data;
                $scope.bilheteTalkbotList.recordCount = pagination.RecordCount;
                $scope.currentPage = pagination.PageIndex || 1;
                $scope.bilheteTalkbotList.pageSize = pagination.PageSize || defaultPageSize;
                $scope.submitted = false;
                ModalService.hideLoading();
            };

            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {
                    ModalService.showLoading();
                    $scope.isPageChanged = true;
                    defaultPageIndex = newPage;
                    $scope.getOdataSearch()
                        .then((list) => {
                            updateList(list);
                            $scope.isPageChanged = false;
                        }).catch((error) => {
                            NotifyService.showError(error);
                            $scope.isPageChanged = false;
                            ModalService.hideLoading();
                        });
                }
            };

            $scope.getOdataSearch = function () {
                $scope.submitted = true;
                let url = Config.getUrl("BilheteTalkbot/") + defaultPageIndex + "/" + defaultPageSize;

                $scope.search.OrderBy = $scope.orderBy.column + " " + $scope.orderBy.order
               
                if (!$scope.isPageChanged) {
                    $scope.countFinalizado = false;
                    $scope.countInternoFinalizado = false;
                    $scope.bilheteTalkbotQuantidade = -1;

                    BilheteTalkbotResource.getCount($scope.search).$promise
                        .then((data) => {
                            if ($scope.countInternoFinalizado == false) {
                                $scope.bilheteQuantidade = data.Quantidade;
                                $scope.countInternoFinalizado = true;
                            }
                        });
                }

                return $http({ method: 'GET', url: url, params: $scope.search })
                    .then((response) => {
                        return response.data;
                    });
            };

            $scope.order = function(predicate) {
                ModalService.showLoading();
                $scope.predicate = predicate;
                $scope.reverse = $scope.predicate ? !$scope.reverse : false;
    
                $scope.orderBy = {
                    column: predicate,
                    order: !$scope.reverse ? "Desc" : "Asc",
                };
    
                return $scope.getOdataSearch().then(updateList).catch(NotifyService.showError);
            };

            $scope.registroPorPaginaArray = [
                { label: 15, valor: 15 },
                { label: 30, valor: 30 },
                { label: 50, valor: 50 },
                { label: 100, valor: 100 }
            ];

            $scope.filterPageSize = { Size: 15 };

            $scope.changePageSize = function () {
                defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
                $scope.executeSearch();
            }

            $scope.limparFiltro = function () {
                $scope.search = {
                    DataI: dataInicio,
                    DataF: dataFim,
                    CampanhaId: null,
                    IntegracaoId: null,
                    AcionamentoId: null,
                    FluxoId: null
                }

                $scope.changeCampanhaTipoId();
                $scope.bilheteTalkbotList = [];

                $scope.orderBy = {
                    column: "BilheteTalkbotId",
                    order: "Desc"
                };
            }

            $scope.onChangeScripts = function () {

                UraTalkbotResource.GetCampanhaScripts({ura: $scope.search.IntegracaoId}).$promise
                    .then((data) => {
                        $scope.campanhas = data;
                    });
                
                BilheteTalkbotResource.acionamento({ura: $scope.search.IntegracaoId}).$promise
                    .then((data) => {
                        $scope.acionamentoList = data.map(x => {
                            x.Nome = (x.Ura || '')  + " - " +  x.Nome;
                            return x;
                        });
                    });

                BilheteTalkbotResource.fluxofluxoOut({ura: $scope.search.IntegracaoId}).$promise
                    .then((data) => {
                        $scope.fluxos = data.map(x => {
                            x.Nome = (x.Ura || '')  + " - " +  x.Nome;
                            return x;
                        });
                    });
            }

        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteTalkbotResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BilheteTalkBot/:BilheteTalkBotId", { "BilheteTalkBotId": "@BilheteTalkBotId" },
                {
                    fluxo: {
                        url: "BilheteTalkbot/Fluxo",
                        method: "GET",
                        isArray: true
                    },
                    fluxofluxoOut: {
                        url: "BilheteTalkbot/GetFluxoFluxoOut/:ura",
                        method: "GET",
                        isArray: true,
                        params: {
                            "ura": "@ura" 
                        }
                    },
                    fluxoOut: {
                        url: "BilheteTalkbot/FluxoOut",
                        method: "GET",
                        isArray: true
                    },
                    acionamento: {
                        url: "BilheteTalkbot/Acionamento/:ura",
                        method: "GET",
                        isArray: true,
                        params: {
                            "ura": "@ura" 
                        }
                    },getCount: {
                        url: "BilheteTalkbot/Count",
                        method: "GET",
                        isArray: false
                    },
                });
        }])
})();
(function() {
    "use strict";
    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    angular.module("epbxManagerApp")

    .config(["$stateProvider", "StateResolverProvider", function($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.bilheteTarifacao", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.bilheteTarifacao.list',
                    pageTitle: 'pageTitle.bilhetesTarifados',
                    pageName: 'pageTitle.bilhetesTarifados',
                    permissions: {
                        AllowAnonymous: true
                    }
                }
            })
            .state("main.bilheteTarifacao.list", StateResolverProvider.configState("/bilheteTarifacao?GrupoId&BilheteStatusId&BilheteStatusDetalheId&BilheteDirecaoId&BilheteCenarioId&DiscagemTipoId&RamalId&Tempo", "BilheteTarifacao", "List", {
                pageTitle: 'pageTitle.bilhetesTarifados',
                pageName: 'pageTitle.pesquisar'
            }));

    }])

    .service("BilheteTarifacaoListData", function ReportListData() {
        return function() {
            return {
                grupoList: ["GrupoResource", function(GrupoResource) {
                    return GrupoResource.getGrupoSimples().$promise;
                }],
                operadoraList: ["OperadoraResource", function(OperadoraResource) {
                    return OperadoraResource.query().$promise;
                }],
                rotaList: ["RotaResource", function(RotaResource) {
                    return RotaResource.odata().select(["RotaId", "Nome", "FornecedorId", "CarteiraId"]).query();
                }],
                servicoList: ["ServicoResource", function(ServicoResource) {
                    return ServicoResource.odata().select(["ServicoId", "Numero"]).query();
                }],
                usuarioList: ["UsuarioResource", function(UsuarioResource) {
                    return UsuarioResource.GetTodosUsuario().$promise;
                }],
                carteiraList: ["CarteiraResource", function(CarteiraResource) {
                    return CarteiraResource.query().$promise;
                }],
                campanhasList: ["CampanhaResource", function(CampanhaResource) {
                    var odata = CampanhaResource.odata();
                    return odata.select(["CampanhaId", "Nome", "CarteiraId"]).query();
                }],
                classes: ["RotaResource", function(RotaResource) {
                    return RotaResource.getClasses().$promise;
                }],
                fornecedores: ["FornecedorResource", function(FornecedorResource) {
                    return FornecedorResource.query().$promise;
                }],
                maxFiltroBilhete: ["ConfiguracaoResource", function(ConfiguracaoResource) {
                    return ConfiguracaoResource.getConfiguracaoMaxFiltroBilhete();
                }]
            };
        };
    })

    .controller("BilheteTarifacaoListController", ["$scope", "$http", "$stateParams", "Config", "usuarioList", "operadoraList", "campanhasList", "rotaList", "servicoList", "grupoList", "classes", "RotaResource", "BilheteResource", "AuthService", "FileDownloadService", "NotifyService", "ModalService", "$translate", "BilheteTarifacaoResource", "fornecedores", "maxFiltroBilhete", "carteiraList", function($scope, $http, $stateParams, Config, usuarioList, operadoraList, campanhasList, rotaList,
        servicoList, grupoList, classes, RotaResource, BilheteResource, AuthService, FileDownloadService, NotifyService, ModalService, $translate,
        BilheteTarifacaoResource, fornecedores, maxFiltroBilhete, carteiraList) {
        var dataInicio = moment().subtract(60, 'minutes').seconds(0).milliseconds(0).toDate();
        var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();
        $scope.reprocessamentos = [];

        $scope.fornecedores = fornecedores;
        $scope.maxFiltroBilhete = maxFiltroBilhete.Quantidade;
        $scope.search = {
            DataInicio: dataInicio,
            DataFim: $stateParams.DataFim || dataFim,
            GrupoId: $stateParams.GrupoId || 0,
            BilheteDirecaoId: $stateParams.BilheteDirecaoId || 0,
            BilheteStatusId: $stateParams.BilheteStatusId || 0,
            BilheteStatusDetalheId: $stateParams.BilheteStatusDetalheId || 0,
            BilheteCenarioId: $stateParams.BilheteCenarioId || 0,
            DiscagemTipoId: $stateParams.DiscagemTipoId || 0,
            RamalId: $stateParams.RamalId || 0,
            CarteiraId: $stateParams.CarteiraId || 0,
            CampanhaId: 0,
            ClasseId: 0,
            DownloadDetalhe: false,
            FileName: '',
            FornecedorId: 0,
            AgendarExportacao: false
        };

        $scope.registroPorPaginaArray = [
            { label: 15, valor: 15 },
            { label: 30, valor: 30 },
            { label: 50, valor: 50 },
            { label: 100, valor: 100 }
        ];

        $scope.filterPageSize = {
            Size: 15
        };

        $scope.orderBy = {
            column: "DataI",
            order: "Desc"
        };

        $scope.reprocessa = {
            DataI: '',
            DataF: '',
            RotaId: 0,
            IsEdit: false
        };

        if ($stateParams.Tempo) {
            $scope.search.DataInicio = moment().subtract($stateParams.Tempo, 'minutes').seconds(0).milliseconds(0).toDate();
        }

        $scope.rotasReprocessamento = rotaList;
        $scope.campanhasList = campanhasList;
        $scope.campanhasListTodos = campanhasList;
        $scope.grupoList = grupoList;
        $scope.grupoListTodos = grupoList;
        $scope.rotaList = rotaList;
        $scope.rotas = rotaList;
        $scope.servicoList = servicoList;
        $scope.usuariosAtivos = _.filter(usuarioList, function(item) {
            return item.UsuarioStatusId == 1;
        });
        $scope.usuarioList = $scope.usuariosAtivos;
        $scope.usuarioListTodos = $scope.usuariosAtivos;
        $scope.operadoraList = operadoraList;
        $scope.detalheList = [];
        $scope.detalheUra = [];
        $scope.carteiraList = carteiraList;

        $scope.direcaoList = [
            { DirecaoId: 2, Descricao: $translate.instant('campo.efetuada') },
            { DirecaoId: 1, Descricao: $translate.instant('campo.recebida') }
        ];

        $scope.discagemTipoList = [
            { DiscagemTipoId: 1, Descricao: $translate.instant('telaBilheteTarifacao.manual') },
            { DiscagemTipoId: 2, Descricao: $translate.instant('telaBilheteTarifacao.discador') },
            { DiscagemTipoId: 3, Descricao: $translate.instant('campo.integracao') }
        ];

        $scope.expanded = false;
        $scope.isPageChanged = false;
        $scope.predicate = '';
        $scope.reverse = false;
        $scope.bilheteList = [];
        $scope.usuarioIsAdmin = AuthService.getUsuarioLogado() ? AuthService.getUsuarioLogado().UsuarioTipoId === 1 ? true : false : false;
        $scope.classes = _.sortBy(classes, (classe) => { return classe.Nome; });

        $scope.changePageSize = function() {
            defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
            $scope.executeSearch();
        };

        $scope.pageChanged = function(newPage) {
            if (defaultPageIndex != newPage) {
                ModalService.showLoading();
                $scope.isPageChanged = true;
                defaultPageIndex = newPage;
                getOdataSearch().finally(() => {
                    $scope.isPageChanged = false;
                })
            }
        };

        $scope.limparFiltro = function() {
            $scope.search = {
                BilheteStatusId: 0,
                BilheteStatusDetalheId: 0,
                GrupoId: 0,
                RotaId: '',
                GlobalId: '',
                NA: '',
                RamalId: 0,
                DataInicio: dataInicio,
                DataFim: dataFim,
                NB: '',
                BilheteDirecaoId: 0,
                DiscagemTipoId: 0,
                ClasseId: 0,
                CodigoCliente: '',
                FornecedorId: 0,
                AgendarExportacao: false,
                BilheteCDRAgendamentoId: 0,
                CarteiraId: ''
            };

            $scope.bilheteList = [];
            $scope.reverse = false;

            $scope.orderBy = {
                column: "DataI",
                order: "Desc"
            };
        };

        $scope.limparDataFiltroReprocessamento = function() {
            $scope.reprocessa.DataI = '';
            $scope.reprocessa.DataF = '';
        };

        $scope.openReprocessaTarifa = function() {
            $scope.limparDataFiltroReprocessamento();
            ModalService.openModal('modal_reprocessa_tarifa_list');
        };

        $scope.order = function(predicate) {
            ModalService.showLoading();
            $scope.predicate = predicate;
            $scope.reverse = $scope.predicate ? !$scope.reverse : false;
            $scope.orderBy = {
                column: predicate,
                order: !$scope.reverse ? "Desc" : "Asc"
            };
            getOdataSearch();
        };

        $scope.executeSearch = function() {
            var dataI = moment($scope.search.DataInicio);
            var dataF = moment($scope.search.DataFim);
            var dateDiff = dataF.diff(dataI, 'days');
            if (dateDiff > $scope.maxFiltroBilhete) {
                $scope.bilheteList = [];
                NotifyService.showMessage('telaBilheteTarifacao.limitePesquisarExportar', "warning");
                return;
            }
            ModalService.showLoading();
            $scope.reverse = false;
            $scope.orderBy = {
                column: "DataI",
                order: "Desc"
            };
            defaultPageIndex = 1;
            getOdataSearch();
        };

        $scope.getHistoricoReprocessamento = function(rotaId) {
            $scope.reprocessamentos = [];
            RotaResource.getHistoricoReprocessamento({ rotaId }).$promise.then((response) => {
                $scope.reprocessamentos = response;
            });
        };

        $scope.reprocessaTarifa = function(form) {
            if (!form.$valid) {
                return NotifyService.showInvalid();
            }

            var dataI = moment($scope.reprocessa.DataI);
            var dataF = moment($scope.reprocessa.DataF);
            var dateDiff = dataI.diff(dataF, 'days');

            if (dataI > dataF) {
                return NotifyService.showError(null, 'telaBilheteTarifacao.dataINaoPodeSerMaiorQueDataF');
            }

            if (dateDiff > 30) {
                return NotifyService.showError(null, 'telaBilheteTarifacao.periodoNaoPodeSerMaiorQue30');
            }

            var processamento = _.findWhere($scope.reprocessamentos, { Processado: false });

            if (processamento) {
                return NotifyService.showError(null, 'telaBilheteTarifacao.existeUmReprocessamentoEmAndamento');
            }

            ModalService.confirmMessage('modalReprocessaTarifa.alertaReprocessamento', null, () => {
                RotaResource.reprocessaTarifa($scope.reprocessa).$promise
                    .then(() => {
                        $scope.getHistoricoReprocessamento($scope.reprocessa.RotaId);
                        $scope.reprocessa = { DataI: '', DataF: '', RotaId: 0 };
                        NotifyService.showSuccess('telaBilheteTarifacao.reprocessamentoCriadoComSucesso');
                        ModalService.closeModal('modal_reprocessa_tarifa_list');
                    }).catch(NotifyService.showError);
            });
        };

        $scope.viewBilheteDetalhe = function(bilhete) {
            if (bilhete) {
                $scope.bilheteGlobalId = bilhete.GlobalId;
                $scope.bilheteView = {};

                BilheteResource.bilheteById({ bilheteid: bilhete.BilheteId }).$promise
                    .then((data) => {
                        if (data) {
                            angular.copy(data[0], $scope.bilheteView);
                        }

                        BilheteResource.bilheteDetalheTarifacao({ globalid: bilhete.GlobalId }).$promise
                            .then((data) => {
                                if (Array.isArray(data) && data.length > 0) {
                                    $scope.detalheList = angular.copy(data)
                                }
                            }).catch(NotifyService.showError);

                        BilheteResource.bilheteUra({ globalid: bilhete.GlobalId }).$promise
                            .then((dataUra) => {
                                if (Array.isArray(dataUra) && data.length > 0) {
                                    $scope.detalheUra = angular.copy(dataUra)
                                }
                            }).catch(NotifyService.showError);

                    }).catch(NotifyService.showError);
            }
        };

        $scope.downloadFile = function(globalId) {
            try {
                FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId);
            } catch (e) {
                NotifyService.showError(e);
            }
        };

        $scope.reproduzirDialogo = function(bilhete) {
            $scope.search.bilheteDialogoAtivo = bilhete;
        };

        $scope.downloadFileDetail = function(detalhe) {
            try {
                var path = "Ligacao/Download/" + detalhe.GlobalId + "/" + detalhe.ArquivoDialogo.replace('.vox', '');
                FileDownloadService.downloadWebApiFile(path);
            } catch (e) {
                NotifyService.showError(e);
            }
        };

        $scope.downloadCDR = function() {
            var search = $scope.search;
            ModalService.showLoading();
            var fileName = generateUUID();
            var filtro = {
                GlobalId: search.GlobalId,
                RamalId: search.RamalId,
                DataI: search.DataInicio,
                DataF: search.DataFim,
                RotaId: search.RotaId,
                CampanhaId: search.CampanhaId,
                NA: search.NA,
                NB: search.NB,
                GrupoId: search.GrupoId,
                ClasseId: search.ClasseId | 0,
                DuracaoI: search.DuracaoI,
                DuracaoF: search.DuracaoF,
                DuracaoTarifacaoI: search.DuracaoTarifacaoI,
                DuracaoTarifacaoF: search.DuracaoTarifacaoF,
                OperadoraId: search.OperadoraId,
                DiscagemTipoId: search.DiscagemTipoId,
                DirecaoId: search.BilheteDirecaoId,
                ColunaOrdenacao: $scope.orderBy.column,
                DirecaoOrdenacao: $scope.orderBy.order.toUpperCase(),
                DownloadDetalhe: false,
                FileName: fileName,
                OrigemId: 2,
                AbrirPaginaDetalhe: search.AbrirPaginaDetalhe,
                FornecedorId: $scope.search.FornecedorId,
                BilheteCDRAgendamentoId: $scope.search.BilheteCDRAgendamentoId
            };

            exportarArquivoCDR(filtro)
                .then(() => {
                    if (filtro.AbrirPaginaDetalhe) {
                        window.open('/#/bilheteCdr/detalheExportar', '_blank');
                    }
                    $scope.search.AbrirPaginaDetalhe = false;
                    ModalService.hideLoading();
                    ModalService.closeModal('modal_cdr')
                }).catch((error) => {
                    ModalService.hideLoading();
                    NotifyService.showError(error);
                });
        };

        $scope.viewCausaCodigo = function(codigo) {
            BilheteResource.causaCodigoById({ causaCodigo: codigo }).$promise
                .then((result) => {
                    if (result) {
                        var msg = `<h4>${$translate.instant('telaBilheteTarifacao.detalheDaCausa')} - ${codigo}</h4></br>
                            ${$translate.instant('campo.nome')}: ${result.Alias}</br>${$translate.instant('telaBilheteTarifacao.termoTecnico')}:
                            ${result.Descricao}</br>`;
                        ModalService.alert(msg);
                    }
                }).catch(NotifyService.showError);
        };

        var getOdataSearch = function() {
            var url = Config.getUrl("BilheteTarifacao/") + defaultPageIndex + "/" + defaultPageSize;

            var filtro = {
                GlobalId: $scope.search.GlobalId,
                RamalId: $scope.search.RamalId,
                DataI: $scope.search.DataInicio,
                DataF: $scope.search.DataFim,
                RotaId: $scope.search.RotaId,
                CampanhaId: $scope.search.CampanhaId,
                NA: $scope.search.NA,
                NB: $scope.search.NB,
                GrupoId: $scope.search.GrupoId,
                ClasseId: $scope.search.ClasseId | 0,
                DuracaoI: $scope.search.DuracaoI,
                DuracaoF: $scope.search.DuracaoF,
                DuracaoTarifacaoI: $scope.search.DuracaoTarifacaoI,
                DuracaoTarifacaoF: $scope.search.DuracaoTarifacaoF,
                DiscagemTipoId: $scope.search.DiscagemTipoId,
                DirecaoId: $scope.search.BilheteDirecaoId,
                FornecedorId: $scope.search.FornecedorId,
                OperadoraId: $scope.search.OperadoraId,
                SortColumn: $scope.orderBy.column,
                SortDirection: $scope.orderBy.order.toUpperCase(),
                CarteiraId: $scope.search.CarteiraId
            };

            return $http({ method: 'GET', url: url, params: filtro })
                .then((response) => {
                    updateList(response.data);
                    if (!$scope.isPageChanged) {
                        getCount(filtro);
                    }
                }).catch((error) => {
                    ModalService.hideLoading();
                    NotifyService.showError(error);
                });
        }

        var generateUUID = function() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
            });
            return uuid;
        }

        var updateList = function(pagination) {
            $scope.bilheteList = pagination.Data;
            $scope.bilheteList.recordCount = pagination.RecordCount;
            $scope.currentPage = pagination.PageIndex || 1;
            $scope.bilheteList.pageSize = pagination.PageSize || defaultPageSize;
            ModalService.hideLoading();
        }

        var exportarArquivoCDR = function(filtro) {
            var url = Config.getUrl("BilheteCdr/GenerateCDRTarifacao")
            return $http({
                method: 'GET',
                url: url,
                params: filtro
            }).then((response) => { return response.data; });
        };

        var getCount = function(filtro) {
            BilheteTarifacaoResource.getCount(filtro).$promise
                .then((data) => { $scope.bilheteQuantidade = data.Quantidade; })
                .catch(() => { $scope.bilheteQuantidade = 0; });
        }

        $scope.onchangeFornecedor = function() {
            if ($scope.search.FornecedorId > 0) {
                $scope.rotaList = _.filter($scope.rotas, (item) => {
                    return item.FornecedorId == $scope.search.FornecedorId;
                })
            }
            return $scope.rotaList;
        }

        let getCarteiraPorGrupo = function(id) {
            if (id > 0) {
                $scope.grupoList = _.filter($scope.grupoListTodos, function(item) {
                    return item.CarteiraId == id;
                });
            } else {
                $scope.grupoList = $scope.grupoListTodos;
            }
        }

        let getCarteiraPorUsuario = function(id) {
            if (id > 0) {
                $scope.usuarioList = _.filter($scope.usuarioListTodos, function(item) {
                    return item.CarteiraId == id;
                });
            } else {
                $scope.usuariosList = $scope.usuarioListTodos;
            }
        }

        let getCarteiraPorCampanha = function(id) {
            if (id > 0) {
                $scope.campanhasList = _.filter($scope.campanhasListTodos, function(item) {
                    return item.CarteiraId == id;
                });
            } else {
                $scope.campanhasList = $scope.campanhasListTodos;
            }
        }

        let getCarteiraPorRota = function(id) {
            if (id > 0) {
                $scope.rotaList = _.filter($scope.rotas, function(item) {
                    return item.CarteiraId == id;
                });
            } else {
                $scope.rotaList = $scope.rotas;
            }
        }

        $scope.onChangeCarteira = function() {
            if ($scope.search.CarteiraId == undefined) {
                $scope.search.CarteiraId = 0;
            }
            getCarteiraPorGrupo($scope.search.CarteiraId);
            getCarteiraPorUsuario($scope.search.CarteiraId);
            getCarteiraPorCampanha($scope.search.CarteiraId);
            getCarteiraPorRota($scope.search.CarteiraId);
        };

        if ($stateParams.Tempo) {
            $scope.executeSearch();
        }

    }]);
})
();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteTarifacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BilheteTarifacao/:BilheteId", { "BilheteId": "@BilheteId" },
                {
                    getCount: {
                        url: "BilheteTarifacao/Count",
                        method: "GET"
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bilheteura", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bilheteura.list',
                        pageTitle: 'pageTitle.pesquisaUra',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.bilheteura.list", StateResolverProvider.configState("/bilheteura", "BilheteUra", "List", {
                    pageTitle: 'pageTitle.pesquisaUra',
                    pageName: 'pageTitle.pesquisar'
                }))
        }])

        .service("BilheteUraListData", function ReportListData() {
            return function () {
                return {
                    uraList: ["UraResource", "$odata", function (UraResource, $odata) {
                        var predicate1 = new $odata.Predicate('UraTipo/UraTipoId', 5);
                        var predicate2 = new $odata.Predicate('UraTipo/UraTipoId', 10);
                        var combination1 = $odata.Predicate.or([predicate1, predicate2]);
                        var odata = UraResource.odata();
                        return odata.filter(combination1).query();
                    }]
                }
            }
        })

        .controller("BilheteUraListController", ["$scope", "$http", "$odata", "Config", "uraList", "UraResource", "BilheteResource", "ModalService", "FileDownloadService", "NotifyService", "$translate", "BilheteUraResource", function ($scope, $http, $odata, Config, uraList, UraResource, BilheteResource, ModalService,
            FileDownloadService, NotifyService, $translate, BilheteUraResource) {
            var dataInicio = moment().subtract(60, 'minutes').seconds(0).milliseconds(0).toDate();
            var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();
            var defaultPageIndex = 1;
            var defaultPageSize = 15;
            $scope.uraList = uraList;
            $scope.perguntasList = [];
            $scope.countPesquisa = 0;
            $scope.carregandoUrasTipo = false;

            $scope.uraTipoList = [
                { UraTipoId: 5, Descricao: $translate.instant('telaBilheteUra.atendimento') },
                { UraTipoId: 10, Descricao: $translate.instant('telaBilheteUra.satisfacao') }
            ];

            $scope.onUraTipoSelected = function () {
                $scope.carregandoUrasTipo = true;
                if ($scope.search.UraTipoId > 0) {
                    $scope.search.UraId = null;
                    var odata = UraResource.odata();
                    odata.where('UraTipo/UraTipoId', $scope.search.UraTipoId).query().then((data) => { 
                        $scope.uraList = data;
                        $scope.carregandoUrasTipo = false;
                    });
                } else {
                    var predicate1 = new $odata.Predicate('UraTipo/UraTipoId', 5);
                    var predicate2 = new $odata.Predicate('UraTipo/UraTipoId', 10);
                    var combination1 = $odata.Predicate.or([predicate1, predicate2]);
                    odata = UraResource.odata();
                    odata.filter(combination1).query().then((data) => { 
                        $scope.uraList = data;
                        $scope.carregandoUrasTipo = false;
                    });
                }
            }

            $scope.contarGlobalsSeguidos = function (index) {
                if ((index == 0 || $scope.bilheteList[index].GlobalId != $scope.bilheteList[index - 1].GlobalId) && index != $scope.bilheteList.length)
                    var lista = _.filter($scope.bilheteList.slice(index + 1), (el) => {
                        return el.GlobalId == $scope.bilheteList[index].GlobalId;
                    })
                if (lista != null) {
                    $scope.bilheteList[index].qtdRegistros = lista.length + 1;
                    return lista.length + 1;
                }
                else {
                    $scope.bilheteList[index].qtdRegistros = 1;
                    return 1;
                }
            }

            $scope.onUraSelected = function () {
                if ($scope.search.UraId > 0) {
                    $scope.search.MenuId = null;
                    UraResource.getPerguntas({ id: $scope.search.UraId }).$promise.then((data) => { $scope.perguntasList = data; });
                }
            }

            $scope.order = function (predicate) {
                ModalService.showLoading();
                $scope.predicate = predicate;
                $scope.reverse = $scope.predicate ? !$scope.reverse : false;
                $scope.orderBy = {
                    column: predicate,
                    order: !$scope.reverse ? "Desc" : "Asc",
                };
                return getOdataSearch();
            };

            var updateList = function (pagination) {
                $scope.bilheteList = pagination.Data;
                $scope.bilheteList.recordCount = pagination.RecordCount;
                $scope.currentPage = pagination.PageIndex || 1;
                $scope.bilheteList.pageSize = pagination.PageSize || defaultPageSize;
                ModalService.hideLoading();
            };

            $scope.executeSearch = function () {
                ModalService.showLoading();
                $scope.countPesquisa = -1;
                $scope.reverse = false;
                $scope.orderBy = {
                    column: "GlobalId",
                    order: "Desc"
                };
                defaultPageIndex = 1;
                getOdataSearch();
            };

            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {
                    defaultPageIndex = newPage;
                    getOdataSearch();
                }
            };

            var getOdataSearch = function () {
                var url = Config.getUrl("BilheteUra/") + defaultPageIndex + "/" + defaultPageSize

                var filtro = {
                    NB: $scope.search.NB,
                    UraId: $scope.search.UraId,
                    DataI: $scope.search.DataInicio,
                    DataF: $scope.search.DataFim,
                    GlobalId: $scope.search.GlobalId,
                    MenuId: $scope.search.MenuId,
                    UraTipoId: $scope.search.UraTipoId,
                    SortColumn: $scope.orderBy.column,
                    SortDirection: $scope.orderBy.order,
                };

                return $http({ method: 'GET', url: url, params: filtro })
                    .then((response) => {
                        updateList(response.data);
                        if ($scope.countPesquisa == -1) {
                            getCount(filtro);
                        }
                    }).catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                    });
            };

            var getCount = function (filtro) {
                var url = Config.getUrl("BilheteUra/") + "Count";
                return $http({
                    method: 'GET',
                    url: url,
                    params: filtro
                }).then((retorno) => {
                    $scope.countPesquisa = retorno.data.Quantidade;
                });
            }

            $scope.registroPorPaginaArray = [
                { label: 15, valor: 15 },
                { label: 30, valor: 30 },
                { label: 50, valor: 50 },
                { label: 100, valor: 100 }
            ];

            $scope.filterPageSize = { Size: 15 };

            $scope.changePageSize = function () {
                defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
                $scope.executeSearch();
            }

            $scope.viewBilheteDetalhe = function (bilhete) {
                if (bilhete) {
                    $scope.bilheteGlobalId = bilhete.GlobalId;
                    $scope.bilheteView = {};
                    BilheteResource.bilheteById({ bilheteid: bilhete.BilheteId }).$promise
                        .then((data) => {
                            if (data) {
                                angular.copy(data[0], $scope.bilheteView);
                            }
                            BilheteResource.bilheteDetalhe({ bilheteid: bilhete.BilheteId, globalid: bilhete.GlobalId }).$promise
                                .then((data) => {
                                    if (Array.isArray(data) && data.length > 0) {
                                        $scope.detalheList = angular.copy(data)
                                    }
                                }).catch(NotifyService.showError);
                            BilheteResource.bilheteUra({ globalid: bilhete.GlobalId }).$promise
                                .then((dataUra) => {
                                    if (Array.isArray(dataUra) && data.length > 0) {
                                        $scope.detalheUra = angular.copy(dataUra)
                                    }
                                }).catch(NotifyService.showError);
                        }).catch(NotifyService.showError);
                }
            };


            $scope.viewBilheteUraDetalhe = function (bilhete) {
                $scope.bilheteView = {};
                $scope.detalheUra = [];
                if (bilhete) {
                    BilheteResource.getBilheteDetalhe({ GlobalId: bilhete.GlobalId, BilheteDetalhado: false }).$promise
                    .then(data => {

                        if (data) {
                            angular.copy(data.find(x => x.EventoFinal), $scope.bilheteView);
                                BilheteUraResource.getBilheteUraByGlobalId({ globalid: bilhete.GlobalId }).$promise
                                    .then((dataUra) => {
                                        if (Array.isArray(dataUra) && data.length > 0) {
                                            $scope.detalheUra = angular.copy(dataUra)
                                        }
                                    }).catch(NotifyService.showError);
                        }

                    })
                }
            };

            // $scope.viewBilheteUraDetalhe = function (bilhete) {
            //     if (bilhete) {
            //         $scope.bilheteGlobalId = bilhete.GlobalId;
            //         $scope.bilheteView = {};
            //         BilheteResource.bilheteById({ bilheteid: bilhete.BilheteId }).$promise
            //             .then((data) => {
            //                 if (data) {
            //                     angular.copy(data[0], $scope.bilheteView);
            //                 }                           
            //                 BilheteUraResource.getBilheteUraByGlobalId({ globalid: bilhete.GlobalId }).$promise
            //                     .then((dataUra) => {
            //                         if (Array.isArray(dataUra) && data.length > 0) {
            //                             $scope.detalheUra = angular.copy(dataUra)
            //                         }
            //                     }).catch(NotifyService.showError);
            //             }).catch(NotifyService.showError);
            //     }
            // };

            $scope.downloadFile = function (globalId) {
                try {
                    FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId);
                } catch (err) {
                    NotifyService.showError(err);
                }
            };

            $scope.reproduzirDialogo = function (bilhete) {
                $scope.search.bilheteDialogoAtivo = bilhete;
            };

            $scope.reproduzirDialogoUra = function (bilhete) {                
                $scope.search.bilheteDialogoAtivo = {
                    url: "/BilheteUra/PlayAudioUra/" + bilhete.BilheteUraId,
                    titulo: $translate.instant('diretivas.reproduzindo')
                };
            };

            $scope.downloadFileDetail = function (detalhe) {
                try {
                    var path = "Ligacao/Download/" + detalhe.GlobalId + "/" + detalhe.ArquivoDialogo.replace('.vox', '');
                    FileDownloadService.downloadWebApiFile(path);
                } catch (err) {
                    NotifyService.showError(err);
                }
            };

            $scope.downloadFileDetailUra = function (detalhe) {
                try {
                    var path = "BilheteUra/Download/" + detalhe.BilheteUraId
                    FileDownloadService.downloadWebApiFile(path);
                } catch (err) {
                    NotifyService.showError(err);
                }
            };

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
                });
                return uuid;
            }

            var exportarArquivoCDR = function (filtro) {
                var url = Config.getUrl('BilheteCdr/GenerateCDRUra');
                return $http({
                    method: 'GET',
                    url: url,
                    params: filtro
                }).then(function (response) {
                    return response.data;
                });
            };

            $scope.abrirModalExportacao = function () {
                ModalService.openModal('modal_cdr');
            };

            $scope.fecharModalExportacao = function () {
                ModalService.closeModal('modal_cdr');
            };

            $scope.downloadCDR = function () {
                ModalService.showLoading();
                var fileName = generateUUID();

                var filtro = {
                    NB: $scope.search.NB,
                    UraId: $scope.search.UraId,
                    DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                    DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                    GlobalId: $scope.search.GlobalId,
                    MenuId: $scope.search.MenuId,
                    UraTipoId: $scope.search.UraTipoId,
                    EventoFinal: $scope.search.EventoFinal,
                    PossuiDialogo: $scope.search.PossuiDialogo,
                    SortColumn: $scope.orderBy.column,
                    SortDirection: $scope.orderBy.order,
                    FileName: fileName
                };

                exportarArquivoCDR(filtro).then(function () {
                    ModalService.hideLoading();
                    $scope.fecharModalExportacao();
                    setTimeout(function () {
                        if ($scope.search.AbrirPaginaDetalhe) {
                            $scope.search.AbrirPaginaDetalhe = false;
                        }
                        window.open('/#/bilheteCdr/detalheExportar', '_blank');
                    }, 600);
                }).catch(function (data) {
                    ModalService.hideLoading();
                    NotifyService.showError(data.error);
                });
            };

            $scope.limparFiltro = function () {
                $scope.search = {
                    DataInicio: dataInicio,
                    DataFim: dataFim,
                    NB: null,
                    UraId: null,
                    GlobalId: null,
                    MenuId: null,
                    UraTipoId: null
                };
                $scope.bilheteList = [];
                $scope.reverse = false;
                $scope.orderBy = {
                    column: "GlobalId",
                    order: "Desc"
                };
            }
            $scope.limparFiltro();
            //$scope.executeSearch();
        }])

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BilheteUraResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BilheteUra/:BilheteUraId",
                {
                    "BilheteUraId": "@BilheteUraId"
                },
                {
                    getBilheteUraByGlobalId: {
                        url: "BilheteUra/GetBilheteUraByGlobalId",
                        method: "GET",
                        isArray: true
                    }
                }
            );
        }]);
})();

(function () {
	"use strict";

	let defaultPageSize = 10;

	angular.module("epbxManagerApp")

		.service("BlocklistArquivoData", function () {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect',
							'lazy_masked_inputs'
						]);
                    }],
                    statusList: ["BlacklistArquivoResource", function (BlacklistArquivoResource) {
                        return BlacklistArquivoResource.BlacklistArquivoStatus().$promise;
                    }],
					blacklist: ["BlacklistResource", "$stateParams", function (BlacklistResource, $stateParams) {
						if ($stateParams.BlacklistId) {
                            return BlacklistResource.GetArquivos({
								BlacklistId: $stateParams.BlacklistId
							}).$promise;
						}
                    }]
				}
			}
		})

        .controller("BlocklistArquivoController", ["$scope", "$stateParams", "$filter", "blacklist", "statusList", "BlacklistResource", "BlacklistArquivoResource", "BlacklistItemResource", "NotifyService", "ModalService", function ($scope, $stateParams, $filter, blacklist, statusList, BlacklistResource,
			BlacklistArquivoResource, BlacklistItemResource, NotifyService, ModalService) {
			$scope.detalheCount = 25;
            $scope.detalheCountCurrent = 0;
            $scope.statusList = statusList;
            $scope.search = {};
            $scope.searching = false;
            $scope.blacklist = blacklist;
			$scope.blacklistArquivoFull = blacklist ? blacklist.BlacklistArquivo : [];
			$scope.blacklistArquivos = blacklist ? blacklist.BlacklistArquivo : [];
			$scope.totalArquivos = blacklist.BlacklistArquivo ? blacklist.BlacklistArquivo.length : 0;
			$scope.ArquivosItem = [];
			$scope.blacklistId = $stateParams.BlacklistId > 0 ? $stateParams.BlacklistId : blacklist.BlacklistId;
			$scope.processaPesquisa = false;

			//Ordenar Grid
			$scope.predicate = '';
			$scope.reverse = false;
			$scope.order = function (predicate) {
				$scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
				$scope.predicate = predicate;
				let page = $scope.blacklistArquivos.$currentPage ? $scope.blacklistArquivos.$currentPage : 1;
				$scope.blacklistArquivoFull = $filter('orderBy')($scope.blacklistArquivoFull, predicate, $scope.reverse);
				$scope.blacklistArquivoFull.$currentPage = page;
				let itensPerPage = ($scope.blacklistArquivos.pageSize || defaultPageSize);
				let begin = ((page - 1) * itensPerPage)
				let end = begin + itensPerPage;
				let currentList = $scope.blacklistArquivoFull.slice(begin, end);
				currentList.$currentPage = page;
				updateList(currentList);
			};
			
			// Funções usadas apenas no controller
            var getOdataSearch = function () {
                return BlacklistResource.GetArquivos({
                    BlacklistId: $scope.blacklistId,
                    Descricao: $scope.search.Nome,
                    Numero: $scope.search.Numero,
                    BlacklistArquivoStatusId: $scope.search.ArquivoStatusId
                }).$promise;
            };

            var showError = function (error) {
                NotifyService.showError(error);
                $scope.searching = false;
            }

			var deleteRecord = function (data) {
				return BlacklistArquivoResource.delete({ BlacklistArquivoId: data.BlacklistArquivoId }).$promise
					.then(() => {
						$scope.reloadBlacklist();
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
			};

			var deleteRecordItem = function (data) {
				return BlacklistItemResource.delete({ BlacklistItemId: data.BlacklistItemId }).$promise
					.then(() => {
						$scope.reloadItems($scope.ArquivoSelecionado)
							.then((res) => {
								$scope.ItemsArquivo = res;
								$scope.ItemsArquivoPartial = [];
								$scope.detalheCount = 25;
								$scope.detalheCountCurrent = 0;
								$scope.loadMore();
								$scope.reloadBlacklist();
							}).catch(NotifyService.showError);
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
			};

			var updateList = function (list) {
				if ($scope.blacklistArquivos) {
					$scope.blacklistArquivos = list;
					$scope.currentPage = list.$currentPage || 1;
                    $scope.blacklistArquivos.pageSize = list.$pageSize || defaultPageSize;
                    $scope.searching = false;
				}
			};

			var limparNumeroManual = function () {
				$scope.individual = {
					Numero: '',
				};
				let $maskedInput = $('.masked_input');
				if ($maskedInput) {
					$maskedInput.val('');
					$maskedInput.inputmask();
				}
				$scope.ArquivosItem = [];
				$scope.ArquivosItemPartial = [];
				$scope.detalheCount = 25;
				$scope.detalheCountCurrent = 0;
				$scope.processaPesquisa = false;
			}

			// Funções do escopo

			$scope.processarArquivo = function (arquivo) {
				BlacklistArquivoResource.Confirmar(arquivo).$promise
					.then(() => {
						$scope.reloadBlacklist();
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
            };

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

            $scope.executeSearch = function () {
                $scope.searching = true;
                getOdataSearch().then((result) => {
                    $scope.blacklistArquivos = result.BlacklistArquivo;
                    $scope.blacklistArquivoFull = result.BlacklistArquivo;
                    $scope.totalArquivos = $scope.blacklistArquivos.length;
                    updateList($scope.blacklistArquivos);
                }).catch(showError);
            };

			$scope.confirmDeleteItem = function (data) {
				ModalService.confirmDelete(() => deleteRecordItem(data));
			};			

			$scope.pageChanged = function (newPage) {
				$scope.currentPage = newPage;
				$scope.blacklistArquivos.$currentPage = newPage;
				let itensPerPage = ($scope.blacklistArquivoFull.pageSize || defaultPageSize);
				let begin = ((newPage - 1) * itensPerPage), end = begin + itensPerPage;
				let currentList = $scope.blacklistArquivoFull.slice(begin, end);
				currentList.$currentPage = newPage;
				updateList(currentList);
			};

			updateList($scope.blacklistArquivoFull);

			$scope.reloadBlacklist = function () {
                return BlacklistResource.GetArquivos({
					BlacklistId: $stateParams.BlacklistId > 0 ? $stateParams.BlacklistId : $scope.blacklist.BlacklistId
				}).$promise.then((res) => {
					angular.copy(res, $scope.blacklist);
					updateList($scope.blacklist.BlacklistArquivo);
				});
			}

			$scope.reloadItems = function (arquivo) {
				let data = BlacklistItemResource.odata().filter('BlacklistArquivoId', arquivo.BlacklistArquivoId)
				if ($scope.search.Numero && $scope.search.Numero != '') {
					data.filter("Numero", $scope.search.Numero.toString());
				}
				return data.query();
			}

			$scope.searchMore = function () {
				$scope.ItemsArquivo = [];
				$scope.reloadItems($scope.ArquivoSelecionado)
					.then((res) => {
						$scope.ItemsArquivo = res;
						$scope.ItemsArquivoPartial = [];
						$scope.detalheCount = 25;
						$scope.detalheCountCurrent = 0;
						$scope.loadMore();
					}).catch(NotifyService.showError);
			}

			$scope.loadMore = function () {
				$scope.ItemsArquivoPartial = $scope.ItemsArquivoPartial.concat($scope.ItemsArquivo.slice($scope.detalheCountCurrent, $scope.detalheCountCurrent + $scope.detalheCount));
				$scope.detalheCountCurrent += $scope.detalheCount;
			};

			$scope.openModal = function (arquivo) {
				$scope.ItemsArquivo = [];
				$scope.ArquivoSelecionado = arquivo;
				$scope.reloadItems($scope.ArquivoSelecionado)
					.then((res) => {
						$scope.ItemsArquivo = res;
						$scope.ItemsArquivoPartial = [];
						$scope.detalheCount = 25;
						$scope.detalheCountCurrent = 0;
						$scope.loadMore();
						ModalService.openModal('modal_numeros');
					}).catch(NotifyService.showError);
			}

            $scope.limparFiltro = function () {
                $scope.search = {
                    pageSize: 10,
                    Nome: '',
                    Numero: '',
                    ArquivoStatusId: 0,
                };
                $scope.executeSearch();
            };

			$scope.gerenciarNumero = function () {
				limparNumeroManual();
				ModalService.openModal('modal_numero_pesquisa');
			}

			$scope.processaNumeroIndividual = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();	
				}

				let numeroDestino = $scope.individual.Numero.replace(/[^\w]/gi, '');
				
				BlacklistArquivoResource.BlacklistTelefone({
					Numero: numeroDestino,
				}).$promise.then((data) => {
					angular.copy(data, $scope.ArquivosItem);
					$scope.ArquivosItemPartial = [];
					$scope.detalheCount = 25;
					$scope.detalheCountCurrent = 0;
					if ($scope.ArquivosItem.length) {
						$scope.loadMoreArquivo();
					}
					$scope.processaPesquisa = true;
				});
			}

			$scope.refazerPesquisa = function () {
				limparNumeroManual();
			}

			$scope.loadMoreArquivo = function () {
				$scope.ArquivosItemPartial = $scope.ArquivosItemPartial.concat($scope.ArquivosItem.slice($scope.detalheCountCurrent, $scope.detalheCountCurrent + $scope.detalheCount));
				$scope.detalheCountCurrent += $scope.detalheCount;
			}

			$scope.closeModalNumero = function () {
				ModalService.closeModal('modal_numero_pesquisa');
			}

			$scope.processaNumero = function (adiciona) {
				let numeroDestino = $scope.individual.Numero.replace(/[^\w]/gi, '');
				if (numeroDestino) {
					BlacklistItemResource.InsereManual({
						Numero: numeroDestino,
						BlacklistId: $stateParams.BlacklistId > 0 ? $stateParams.BlacklistId : $scope.blacklist.BlacklistId,
						Adicionar: adiciona == 1 ? true : false,
						BlacklistArquivoId: 0,
					}).$promise.then(() => {
						limparNumeroManual();
						NotifyService.showSuccess();
						$scope.reloadBlacklist();
					});
				} else {
					NotifyService.showError(null, 'telaBlacklistEdit.informeONumeroASerRealizadaAcao');
				}
			}

		}]
	);

})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('BlacklistCrmEditData', function BlacklistCrmEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs'
						]);
					}],
					blacklistCrm: ["BlacklistCrmResource", "$stateParams", function (BlacklistCrmResource, $stateParams) {
						if ($stateParams.BlacklistCrmId) {
							return BlacklistCrmResource.get({
								BlacklistCrmId: $stateParams.BlacklistCrmId
							}).$promise;
						} else {
							return {};
						}
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("BlacklistCrmEditController",
			["$scope", "$state", "blacklistCrm", "BlacklistCrmResource", "NotifyService", "carteiras", function ($scope, $state, blacklistCrm, BlacklistCrmResource, NotifyService, carteiras) {
				$scope.Novo = !(blacklistCrm && blacklistCrm.BlacklistCrmId);
				$scope.blacklistCrm = blacklistCrm;
                $scope.carteiras = carteiras;

				var mensagemSucesso = function (resposta) {
					NotifyService.showRegistroSalvo();
					if ($scope.Novo) {
						$scope.resposta = {};
					} else {
						$scope.blacklistCrm = resposta;
					}

					$state.go('main.blacklist.list');
				};

				$scope.salvar = function (valid) {
					if (!valid) {
						return NotifyService.showInvalid();
					}

					if ($scope.blacklistCrm.BlacklistCrmId > 0) {
						BlacklistCrmResource.update($scope.blacklistCrm).$promise.then(mensagemSucesso).catch(NotifyService.showError);
					} else {
						BlacklistCrmResource.save($scope.blacklistCrm).$promise.then(mensagemSucesso).catch(NotifyService.showError);
					}
					
				};

				$scope.voltar = function () {
					$state.go('main.blacklist.list');
				};
			}]
		);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('BlocklistEditData', function BlacklistEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_uiSelect'
                        ]);
                    }],
                    blacklist: ["BlacklistResource", "$stateParams", function (BlacklistResource, $stateParams) {
                        if ($stateParams.BlacklistId) {
                            return BlacklistResource.get({
                                BlacklistId: $stateParams.BlacklistId
                            }).$promise;
                        }
                        else {
                            return {};
                        }
                    }],
                    blacklistDirecaoList: ["BlacklistDirecaoResource", function (BlacklistDirecaoResource) {
                        return BlacklistDirecaoResource.query().$promise;
                    }],
                    layoutList: ["BlacklistResource", function (BlacklistResource) {
                        return BlacklistResource.BlacklistLayout().$promise;
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.odata().orderBy('Nome', 'asc').query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    blacklistTipoList: ["BlacklistResource", function (BlacklistResource) {
                        return BlacklistResource.GetBlacklistTipo().$promise;
                    }]
                }
            }
        })

        .controller("BlocklistEditController", ["$scope", "$stateParams", "blacklist", "campanhasList", "layoutList", "BlacklistResource", "BlacklistArquivoResource", "WizardHandler", "$state", "blacklistDirecaoList", "NotifyService", "$translate", "ModalService", "carteiras", "blacklistTipoList", function ($scope, $stateParams, blacklist, campanhasList, layoutList, BlacklistResource, BlacklistArquivoResource, 
            WizardHandler, $state, blacklistDirecaoList, NotifyService, $translate, ModalService, carteiras, blacklistTipoList) {
            blacklist.BlacklistId = (blacklist.BlacklistId > 0 ? blacklist.BlacklistId : (isNaN(parseInt($stateParams.BlacklistId)) ? 0 : parseInt($stateParams.BlacklistId)));
            $scope.isNew = blacklist.BlacklistId > 0 ? false : true;
            $scope.blacklist = blacklist;
            $scope.forms = {};
            $scope.needDisable = false;
            $scope.blacklistDirecaoList = blacklistDirecaoList;
            $scope.layoutList = layoutList;
            $scope.campanhaList = campanhasList;
            $scope.salvando = false;
            $scope.carteiras = carteiras;
            $scope.blacklistTipoList = blacklistTipoList;
            $scope.direcaoEnable = false;

            if (blacklist.BlacklistLayoutId == 3) {
                $scope.layoutList.push({
                    BlacklistLayoutId: 3, 
                    Descricao: $translate.instant('telaBlacklist.manual')
                })
            }

            $scope.exitValidationDetalhes = function () {
                var alterado = $scope.isNew ? false : $scope.forms.formDetalhes.$dirty;
                var proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formDetalhes.$dirty = false;
                        $scope.forms.formDetalhes.$setPristine();
                    });
                } else {
                    if ($scope.forms.formDetalhes.$valid) {
                        proximoStep = true;
                    }
                }
                return proximoStep;
            }


            $scope.exitValidationCampanhas = function () {
                var alterado = $scope.isNew ? false : $scope.forms.formCampanhas.$dirty;
                var proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formCampanhas.$dirty = false;
                        $scope.forms.formCampanhas.$setPristine();
                    });
                } else {
                    if ($scope.forms.formCampanhas.$valid) {
                        proximoStep = true;
                    }
                }

                return proximoStep;
            }

            $scope.onChangeCarteira = function () {
                if($scope.blacklist.CarteiraId == 0 || $scope.blacklist.CarteiraId == undefined)
                {
                    $scope.blacklist.CampanhasAdicionadas = $scope.blacklist.CampanhasAdicionadas;
                    $scope.blacklist.CampanhasNaoAdicionadas = $scope.blacklist.CampanhasNaoAdicionadas;
                }else{
                    $scope.blacklist.CampanhasAdicionadas = _.filter($scope.blacklist.CampanhasAdicionadas, function (el) {
                        return el.CarteiraId == $scope.blacklist.CarteiraId;
                    });
                    $scope.blacklist.CampanhasNaoAdicionadas = _.filter($scope.blacklist.CampanhasNaoAdicionadas, function (el) {
                        return el.CarteiraId == $scope.blacklist.CarteiraId;
                    });
                }       
            };

            $scope.salvar = function (form) {
                var lastStep = form.$name == "forms.formCampanhas" ? true : false;

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                if (!form.$dirty && lastStep) {
                    $state.go("main.blocklist.list", {
                        page: 'main.blocklist.list'
                    });
                }

                if ($scope.blacklist.BlacklistTipoId == 3 && ($scope.blacklist.DataInicio == null || $scope.blacklist.DataTermino == null)) {
                    return NotifyService.showInvalid();
                }

                $scope.salvando = true;

                var promise;

                if (form.$dirty) {
                    if ($scope.blacklist.BlacklistId > 0) {
                        promise = BlacklistResource.update($scope.blacklist).$promise;
                    }
                    else {
                        promise = BlacklistResource.save($scope.blacklist).$promise;
                    }
                    promise.then((res) => {
                        $scope.blacklist = res;
                        $scope.onChangeCarteira();
                        NotifyService.showRegistroSalvo();
                        $scope.salvando = false;

                        // if ($scope.isNew && form.$name == "forms.formDetalhes") {
                        //     WizardHandler.wizard().next();
                        // }
                        WizardHandler.wizard().next();

                        form.$setPristine();
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.salvando = false
                    });
                }
                else {
                    WizardHandler.wizard().next();
                    $scope.salvando = false;
                    $scope.onChangeCarteira();
                }

                if ((($scope.isNew && lastStep) || lastStep) && !form.$dirty) {
                    $state.go("main.blocklist.list", {
                        page: 'main.blocklist.list'
                    });
                   
                }
                form.$setPristine();
            };

            $scope.onChangeBlacklistTipo = function (blacklistTipoId) {
                $scope.direcaoEnable = false;
                if (blacklistTipoId != 3) {
                    $scope.blacklist.DataInicio == null; 
                    $scope.blacklist.DataTermino == null;
                }
                if (blacklistTipoId == 2)
                {
                    $scope.blacklist.BlacklistDirecaoId  = 2;
                    $scope.direcaoEnable = true;
                }
            }

            $scope.adicionarCampanha = function () {
                var CampanhasSelecionadas = _.where($scope.blacklist.CampanhasNaoAdicionadas, {
                    Selecionada: true
                });

                angular.forEach(CampanhasSelecionadas, (item) => {
                    item.Selecionada = false;
                    $scope.blacklist.CampanhasAdicionadas.push(item);
                    $scope.blacklist.CampanhasNaoAdicionadas.splice($scope.blacklist.CampanhasNaoAdicionadas.indexOf(item), 1);
                });

                if ($scope.forms.formCampanhas) {
                    $scope.forms.formCampanhas.$dirty = true;
                }
            };

            $scope.removerCampanha = function () {
                var CampanhasSelecionadas = _.where($scope.blacklist.CampanhasAdicionadas, {
                    Selecionada: true
                });

                angular.forEach(CampanhasSelecionadas, function (item) {
                    item.Selecionada = false;
                    $scope.blacklist.CampanhasNaoAdicionadas.push(item);
                    $scope.blacklist.CampanhasAdicionadas.splice($scope.blacklist.CampanhasAdicionadas.indexOf(item), 1);
                });

                if ($scope.forms.formCampanhas)
                    $scope.forms.formCampanhas.$dirty = true;
            };

            $scope.selecionarTodasAdicionadas = function (todosAdicionadas) {
                angular.forEach($scope.blacklist.CampanhasAdicionadas, (item) => {
                    if (todosAdicionadas) {
                        item.Selecionada = true;
                    } else {
                        item.Selecionada = false;
                    }
                });
            };

            $scope.selecionarTodasNaoAdicionadas = function (todosNaoAdicionadas) {
                angular.forEach($scope.blacklist.CampanhasNaoAdicionadas, (item) => {
                    if (todosNaoAdicionadas) {
                        item.Selecionada = true;
                    } else {
                        item.Selecionada = false;
                    }
                });
            };

            $scope.pesquisaCampanhas = function (searchCampanhas, length, lengthAdicionadas) {
                var lengthTotal = $scope.blacklist.CampanhasNaoAdicionadas.length;
                var lengthAdicionadasTotal = $scope.blacklist.CampanhasAdicionadas.length;
                if (searchCampanhas.length > 0) {
                    if (lengthTotal != length) {
                        $scope.limitCampanhas = lengthTotal;
                    }

                    if (lengthAdicionadasTotal != lengthAdicionadas) {
                        $scope.limitCampanhasAdicionadas = lengthAdicionadasTotal;
                    }
                }
                else {
                    $scope.limitCampanhas = 5;
                    $scope.limitCampanhasAdicionadas = 5;
                }
            };

            if(!$scope.isNew) 
            {
                $scope.onChangeCarteira();
            } 
            
            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3>${descricao}`);
            };
        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('BlocklistImportData', function BlacklistImportData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_dropify'
                        ]);
                    }],
                    blacklist: ["BlacklistResource", "$stateParams", function (BlacklistResource, $stateParams) {
                        if ($stateParams.BlacklistId) {
                            return BlacklistResource.get({
                                BlacklistId: $stateParams.BlacklistId
                            }).$promise;
                        }
                    }]
                }
            }
        })

        .controller("BlocklistImportController", ["$scope", "$stateParams", "blacklist", "BlacklistArquivoResource", "WizardHandler", "$state", "NotifyService", "ModalService", function ($scope, $stateParams, blacklist, BlacklistArquivoResource, WizardHandler, $state,
            NotifyService, ModalService) {
            $scope.bloqueioLista = {};
            $scope.blacklist = blacklist;
            $scope.needDisable = false;

            $scope.finishedWizard = function () {
                $state.go('main.blocklist.arquivo', {
                    BlacklistId: $stateParams.BlacklistId
                });
            };

            $scope.startFileUpload = function () {
                ModalService.showLoading();
            }

            $scope.loadFileCompleted = function (result) {
                if (Array.isArray(result.Revisao) && result.Revisao[0].Numero == "") {
                    return $scope.loadFileError();
                }
                $scope.preview = result;
                $scope.needDisable = true;
                $('.dropify-wrapper').hide();
                $scope.bloqueioLista.BlacklistId = result.BlacklistId;
                $scope.bloqueioLista.BlacklistArquivoId = result.BlacklistArquivoId;
                ModalService.hideLoading();
            };

            $scope.loadFileError = function () {
                $scope.preview = null;
                $scope.PreviewStepData.notVisible = true;
                ModalService.hideLoading();
                NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
            };

            $scope.removeFile = function () {
                $scope.PreviewStepData.notVisible = true;
                $scope.preview = null;
            };

            $scope.voltarAba = function (index) {
                if (index == 0) {
                    $state.go('main.blocklist.arquivo', {
                        BlacklistId: $stateParams.BlacklistId
                    });
                } else {
                    WizardHandler.wizard('blacklistWizard').goTo(index - 1);
                }
            };

            $scope.iniciarProgresso = function (form) {
                if (!form.$valid || !$scope.preview || !$scope.preview.length == 0) {
                    if (!$scope.preview || !$scope.preview.length == 0) {
                        $('.dropify-wrapper').css('border-color', '#e53935');
                    }
                    return form.$submitted = true;
                }
                $scope.canExit = true;
                $scope.PreviewStepData.notVisible = false;
                WizardHandler.wizard('blacklistWizard').goTo(1);
            }

            $scope.checkExit = function () {
                if ($scope.bloqueioLista && $scope.preview && $scope.canExit) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.UploadStepData = {
                order: 1,
            };

            $scope.PreviewStepData = {
                order: 2,
                notVisible: true
            };
        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.blocklist", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.blocklist.list',
                        pageTitle: 'pageTitle.blacklist',
                        pageName: 'pageTitle.blacklist'
                    }
                })
                .state("main.blocklist.list", StateResolverProvider.configState("/blocklist", "Blocklist", "List", {
                    pageTitle: 'pageTitle.blacklist',
                    pageName: 'pageTitle.pesquisar',
                    permissions: {
                        Blocklist: "Visualizar"
                    }
                }))
                .state("main.blocklist.new", StateResolverProvider.configState("/blocklist/new", "Blocklist", "Edit", {
                    pageTitle: 'pageTitle.blacklist',
                    pageName: 'acoes.cadastrar',
                    permissions: {
                        Blocklist: "Cadastrar"
                    }
                }))
                .state("main.blocklist.edit", StateResolverProvider.configState("/blocklist/{BlacklistId:[0-9]+}", "Blocklist", "Edit", {
                    pageTitle: 'pageTitle.blacklist',
                    pageName: 'acoes.editar',
                    permissions: {
                        Blocklist: "Cadastrar"
                    }
                }))
                .state("main.blocklist.arquivo", StateResolverProvider.configState("/blocklist/{BlacklistId:[0-9]+}/arquivos", "Blocklist", "Arquivo", {
                    pageTitle: 'pageTitle.blacklist',
                    pageName: 'campo.arquivo',
                    permissions: {
                        Blocklist: "Cadastrar"
                    }
                }))
                .state("main.blocklist.importar", StateResolverProvider.configState("/blocklist/{BlacklistId:[0-9]+}/importar", "Blocklist", "Import", {
                    pageTitle: 'acoes.importar',
                    pageName: 'acoes.importar',
                    permissions: {
                        Blocklist: "Cadastrar"
                    }
                }))
                .state("main.blocklist.remove", StateResolverProvider.configState("/blocklist/{BlacklistId:[0-9]+}/remove", "Blocklist", "Remove", {
                    pageTitle: 'pageTitle.blacklist',
                    pageName: 'pageTitle.removerEmLote',
                    permissions: {
                        Blocklist: "Cadastrar"
                    }
                }))
        }])

        .service("BlocklistListData", function BlacklistListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_masked_inputs'
                        ]);
                    }],
                    blacklists: ["BlacklistResource", function (BlacklistResource) {
                        return BlacklistResource.Contagem({
                            Descricao: '',
                            Id: 0,
                            Numero: '',
                        }).$promise;
                    }],
                    layoutList: ["BlacklistResource", function (BlacklistResource) {
                        return BlacklistResource.BlacklistLayout().$promise;
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.odata().orderBy('Nome', 'asc').query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    blacklistTipoList: ["BlacklistResource", function (BlacklistResource) {
                        return BlacklistResource.GetBlacklistTipo().$promise;
                    }]
                }
            }
        })

        .controller("BlocklistListController", ["$scope", "$odata", "blacklists", "campanhasList", "layoutList", "BlacklistResource", "BlacklistArquivoResource", "BlacklistItemResource", "utils", "$filter", "$state", "NotifyService", "$translate", "ModalService", "carteiras", "blacklistTipoList", function ($scope, $odata, blacklists, campanhasList, layoutList,
            BlacklistResource, BlacklistArquivoResource, BlacklistItemResource, utils, $filter, 
            $state, NotifyService, $translate, ModalService, carteiras, blacklistTipoList) {
            var defaultPageSize = 10;
            $scope.blacklistsFull = blacklists;
            $scope.blacklistsList = blacklists;
            $scope.blacklistsListBkp = blacklists;
            $scope.campanhaList = campanhasList;
            $scope.layoutList = layoutList;
            $scope.blacklistTipoList = blacklistTipoList;
            $scope.totalBlacklists = $scope.blacklistsFull.length;
            $scope.search = {};
            $scope.searching = false;
            $scope.blacklistId = 0;
            $scope.ArquivosItem = [];
            $scope.layoutList.push({
                BlacklistLayoutId: 3,
                Descricao: $translate.instant('telaBlacklist.manual')
            });
            $scope.processaPesquisa = false;
            $scope.carteiras = carteiras;
            $scope.individual = {};
            $scope.disableSalvar = true;
            $scope.habilitarCodigo = true;

            var updateList = function (list) {
                $scope.blacklists = list;
                $scope.blacklists.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.blacklists.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearchCustom = function () {
                return BlacklistResource.Contagem({
                    Id: 0,
                    BlackListLayoutId: $scope.search.BlacklistLayoutId,
                    Numero: $scope.search.Numero,
                    CampanhaId: $scope.search.CampanhaId,
                    CarteiraId : $scope.search.CarteiraId,
                    BlacklistTipoId: $scope.search.BlacklistTipoId
                }).$promise;
            };

            var showSuccess = function () {
                NotifyService.showSuccess();
                if ($scope.Novo) {
                    $scope.grupo = {};
                }
                $scope.submitted = false;
            };

            var showError = function (error) {
                NotifyService.showError(error);
                $scope.searching = false;
            }

            $scope.executeSearch = function () {
                $scope.searching = true;
                $scope.executeSearchCustom();
            };

            $scope.executeSearchCustom = function () {
                getOdataSearchCustom().then((result) => {
                    $scope.blacklistsFull = result;
                    $scope.totalBlacklists = $scope.blacklistsFull.length;
                    updateList(result);
                }).catch(showError);
            };

            var deleteRecord = function (data) {
                BlacklistResource.delete({BlacklistId: data.BlacklistId}).$promise
                    .then(() => {
                        $scope.executeSearchCustom();
                        NotifyService.showSuccess();
                    })
                    .catch(NotifyService.showError);
            };


            $scope.confirmDeleteCustom = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            //Ordenar Grid
            $scope.predicate = '';
            $scope.reverse = false;
            $scope.order = function (predicate) {
                $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
                $scope.predicate = predicate;
                var page = $scope.blacklists.$currentPage || 1;
                $scope.blacklistsFull = $filter('orderBy')($scope.blacklistsFull, predicate, $scope.reverse);
                $scope.blacklistsFull.$currentPage = page;
                var itensPerPage = ($scope.blacklists.pageSize || defaultPageSize);
                var begin = ((page - 1) * itensPerPage), end = begin + itensPerPage;
                var currentList = $scope.blacklistsFull.slice(begin, end);
                currentList.$currentPage = page;
                updateList(currentList);
            };

            $scope.pageChangedCustom = function (newPage) {
                $scope.currentPage = newPage;
                $scope.blacklists.$currentPage = newPage;
                var itensPerPage = ($scope.blacklistsFull.pageSize || defaultPageSize);
                var begin = ((newPage - 1) * itensPerPage), end = begin + itensPerPage;
                var currentList = $scope.blacklistsFull.slice(begin, end);
                currentList.$currentPage = newPage;
                updateList(currentList);
            };

            updateList($scope.blacklistsFull);

            $scope.limparFiltro = function () {
                $scope.search = {
                    pageSize: 10,
                    Numero: '',
                };
                $scope.executeSearch();
            };

            $scope.gerenciarNumero = function () {
                limparNumeroManual();
                ModalService.openModal('modal_numero_pesquisa');
            }

            $scope.processaNumeroIndividual = function (valid) {
                if (!valid) {
                    NotifyService.showInvalid();
                    return;
                }
                if (($scope.individual.CodigoCliente || 0).length > 0)
                    $scope.habilitarCodigo = true;
                else
                    $scope.habilitarCodigo = false;

                var numeroDestino = $scope.individual.Numero.replace(/[^\w]/gi, '');
                var promise = BlacklistArquivoResource.BlacklistTelefone({
                    BlacklistId: $scope.individual.BlacklistId,
                    Numero: numeroDestino,
                    CodigoCliente: $scope.individual.CodigoCliente,
                }).$promise;

                if (promise) {
                    promise.then(function (data) {
                        angular.copy(data, $scope.ArquivosItem);
                        $scope.ArquivosItemPartial = [];
                        $scope.detalheCount = 25;
                        $scope.detalheCountCurrent = 0;
                        if ($scope.ArquivosItem.length) {
                            $scope.loadMoreArquivo();
                        }
                        $scope.processaPesquisa = true;
                        $scope.disableSalvar = true;
                    });
                }
            }
            $scope.onChangeBlacklist = function (blacklistId) {
                if (blacklistId) {
                    $scope.disableSalvar = false;
                } else {
                    $scope.disableSalvar = true;
                }
            };

            $scope.loadMoreArquivo = function () {
                $scope.ArquivosItemPartial = $scope.ArquivosItemPartial.concat($scope.ArquivosItem
                    .slice($scope.detalheCountCurrent, $scope.detalheCountCurrent + $scope.detalheCount));
                $scope.detalheCountCurrent += $scope.detalheCount;
            }

            $scope.closeModalNumero = function () {
                ModalService.closeModal('modal_numero_pesquisa');
            }

            $scope.processaNumero = function (adiciona) {
                var numeroDestino = $scope.individual.Numero.replace(/[^\w]/gi, '');
                if (numeroDestino) {
                    var promise = BlacklistItemResource.InsereManual({
                        Numero: numeroDestino,
                        BlacklistId: $scope.individual.BlacklistId,
                        CodigoCliente: $scope.individual.CodigoCliente,
                        Adicionar: adiciona == 1 ? true : false,
                        BlacklistArquivoId: 0,
                    }).$promise;
                
                    if (promise) {
                        promise.then(() => {
                            limparNumeroManual();
                            showSuccess();
                            $scope.executeSearchCustom();
                            $scope.disableSalvar = true;
                        });
                    }
                } else {
                    NotifyService.showError(null, 'telaBlackList.informeONumeroASerRealizadoAcao');
                }
            }

            var limparNumeroManual = function () {
                $scope.individual = {
                    Adicionar: 1,
                    Numero: '',
                    BlacklistId: null,
                    CodigoCliente: null
                };
                var $maskedInput = $('.masked_input');
                if ($maskedInput) {
                    $maskedInput.val('');
                    $maskedInput.inputmask();
                }
                $scope.ArquivosItem = [];
                $scope.ArquivosItemPartial = [];
                $scope.detalheCount = 25;
                $scope.detalheCountCurrent = 0;
                $scope.processaPesquisa = false;
            }

            $scope.deleteBlacklistTelefone = function (item) {
				BlacklistArquivoResource.DeleteBlacklistTelefone(item).$promise
					.then(() => {
						NotifyService.showSuccess();
                        $scope.refazerPesquisa(); 
					}).catch(NotifyService.showError);
            };

            $scope.refazerPesquisa = function () {
                limparNumeroManual();
            }

            $scope.onChangeBlacklistTipo = function (blacklistTipoId) 
            {
                if(blacklistTipoId == 0 || blacklistTipoId == undefined)
                {
                    $scope.blacklistsList = $scope.blacklistsListBkp;
                }else{                    
                    $scope.blacklistsList = _.filter($scope.blacklistsListBkp, function (el) {
                        return el.BlacklistTipoId == blacklistTipoId;
                    });
                }
            }
            $scope.validaPesquisa = function(){
                if (($scope.individual.Numero || 0).length > 9 || ($scope.individual.CodigoCliente ||0).length > 0)
                    return true;
                else
                    return false;
            }
        }]);
    })
();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('BlacklistRemoveData', function BlacklistRemoveData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_wizard',
							'lazy_dropify'
						]);
					}],
					blacklist: ["BlacklistResource", "$stateParams", function (BlacklistResource, $stateParams) {
						if ($stateParams.BlacklistId) {
							return BlacklistResource.get({
								BlacklistId: $stateParams.BlacklistId
							}).$promise;
						}
					}]
				}
			}
		})

		.controller("BlacklistRemoveController", ["$scope", "$q", "$stateParams", "blacklist", "$state", "ModalService", function ($scope, $q, $stateParams, blacklist, $state, ModalService) {
			$scope.bloqueioLista = {};
			$scope.blacklist = blacklist;
			$scope.needDisable = false;
			$scope.startFileUpload = function () {
				var deferred = $q.defer();
				var check = false;
				var modal = ModalService.confirmDelete(() => {
					check = true;
					deferred.resolve();
				});
				modal.on({
					'hide.uk.modal': function () {
						if (check == false) {
							deferred.reject();
						}
					}
				});
				return deferred.promise;
			};

			$scope.loadFileCompleted = function () {
				$scope.needDisable = true;
				$('.dropify-wrapper').hide();
			};

			$scope.voltarTela = function () {
                $state.go('main.blacklist.arquivo', {
					BlacklistId: $stateParams.BlacklistId
				});
			};

			$scope.checkExit = function () {
				if ($scope.bloqueioLista && $scope.preview && $scope.canExit) {
					return true;
				} else {
					return false;
				}
			};
		}]);

})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("BlacklistResource", ["$odataresource", function ($odataresource) {
			return $odataresource("Blacklist/:BlacklistId", { "BlacklistId": "@BlacklistId" }, {
				Importar: {
					url: "Blacklist/Importar",
					method: "POST"
				},
				Contagem: {
					url: "Blacklist/Contagem",
					method: "GET",
					isArray: true
				},
				ContagemById: {
					url: "Blacklist/Contagem",
					method: "GET"
				},
				BlacklistLayout: {
					url: "Blacklist/BlacklistLayout",
					method: "GET",
					isArray: true
                },
                GetArquivos: {
                    url: "Blacklist/GetArquivos",
                    method: "GET"
                },
                GetBlacklistTipo: {
                    url: "Blacklist/GetBlacklistTipo",
                    method: "GET",
					isArray: true
                }
			})
		}])

		.factory("BlacklistCrmResource", ["$odataresource", function ($odataresource) {
			return $odataresource("BlacklistCrm/:BlacklistCrmId", {
				"BlacklistCrmId": "@BlacklistCrmId"
			})
		}])
		
		.factory("BlacklistTemporariaResource", ["$odataresource", function ($odataresource) {
			return $odataresource("BlacklistTemporaria/:BlacklistTemporariaId", {
				"BlacklistTemporariaId": "@BlacklistTemporariaId"
			})
		}])

		.factory("BlacklistArquivoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("BlacklistArquivo/:BlacklistArquivoId", { "BlacklistArquivoId": "@BlacklistArquivoId" }, {
				Confirmar: {
					url: "BlacklistArquivo/Confirmar/:BlacklistArquivoId",
					method: "PUT"
				},
				DeleteBlacklistTelefone: {
					url: "BlacklistArquivo/DeleteBlacklistTelefone",
					method: "PUT",
				},
				Importar: {
					url: "BlacklistArquivo/Importar/:BlacklistId",
					method: "POST"
				},
				BlacklistArquivoItem: {
					url: "BlacklistArquivo/ArquivoItem",
					method: "GET",
					isArray: true
                },
				BlacklistTelefone: {
					url: "BlacklistArquivo/BlacklistTelefone",
					method: "GET",
					isArray: true
                },
                BlacklistArquivoStatus: {
                    url: "BlacklistArquivo/BlacklistArquivoStatus",
                    method: "GET",
                    isArray: true
                },
			});
		}])

		.factory("BlacklistItemResource", ["$odataresource", function ($odataresource) {
			return $odataresource("BlacklistItem/:BlacklistItemId", { "BlacklistItemId": "@BlacklistItemId" }, {
				InsereManual: {
					url: "BlacklistItem/NumeroManual",
					method: "POST"
				},
				VerificaNumeroExisteBlacklist: {
					url: "BlacklistItem/VerificaNumeroExisteBlacklist",
					method: "GET",
					isArray: false
				},
			});
		}])

		.factory("BlacklistDirecaoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("BlacklistDirecao/:BlacklistDirecaoId", {
				"BlacklistDirecaoId": "@BlacklistDirecaoId"
			});
		}]);

})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('BlacklistTemporariaEditData', function BlacklistTemporariaEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs'
						]);
					}],
					blacklistTemporaria: ["BlacklistTemporariaResource", "$stateParams", function (BlacklistTemporariaResource, $stateParams) {
						if ($stateParams.BlacklistTemporariaId) {
							return BlacklistTemporariaResource.get({
								BlacklistTemporariaId: $stateParams.BlacklistTemporariaId
							}).$promise;
						} else {
							return {};
						}
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("BlacklistTemporariaEditController", ["$scope", "$state", "blacklistTemporaria", "BlacklistTemporariaResource", "$timeout", "NotifyService", "carteiras", function ($scope, $state, blacklistTemporaria, BlacklistTemporariaResource, $timeout, NotifyService, carteiras) {
			$timeout(function () {
				$scope.Novo = !(blacklistTemporaria && blacklistTemporaria.BlacklistTemporariaId);
				$scope.blacklistTemporaria = blacklistTemporaria;
                $scope.carteiras = carteiras;
				
			});
			

			var mensagemSucesso = function (resposta) {
				NotifyService.showRegistroSalvo();
				if ($scope.Novo) {
					$scope.resposta = {};
				} 
				else {
					$scope.blacklistTemporaria = resposta;
				}
				$state.go('main.blacklist.list');
			};

			$scope.salvar = function () {
				if (!$scope.blacklistTemporaria || !$scope.blacklistTemporaria.Numero || $scope.blacklistTemporaria.Numero == '' ||
					!$scope.blacklistTemporaria.DataInicio || !$scope.blacklistTemporaria.DataTermino) {
					return NotifyService.showInvalid();
				}

				var promise;

				if ($scope.blacklistTemporaria.BlacklistTemporariaId > 0) {
					promise = BlacklistTemporariaResource.update($scope.blacklistTemporaria).$promise;
				}
				else {
					promise = BlacklistTemporariaResource.save($scope.blacklistTemporaria).$promise;
				}

				promise.then(mensagemSucesso).catch(NotifyService.showError);
			};

			$scope.voltar = function () {
				$state.go('main.blacklist.list');
			};

		}]);
})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('BloqueioCategoriaEditData', function BloqueioCategoriaEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					planoDiscagem: ["PlanoDiscagemResource", "$stateParams", function (PlanoDiscagemResource, $stateParams) {
						if ($stateParams.PlanoDiscagemId) {
							return PlanoDiscagemResource.get({
								PlanoDiscagemId: $stateParams.PlanoDiscagemId
							}).$promise;
						} else {
							return {};
						}
					}],
					categorias: ["CategoriaDiscagemResource", function (CategoriaDiscagemResource) {
						return CategoriaDiscagemResource.odata().orderBy("Descricao", "asc").query();
					}],
					grupos: ["GrupoResource", function (GrupoResource) {
						var odata = GrupoResource.odata().orderBy('Descricao', 'asc');
						odata.filter("GrupoTipoId", "=", 1);
						return odata.query();
					}],
					ramais: ["RamalResource", function (RamalResource) {
						return RamalResource.odata().select("RamalId", "Numero", "Usuarios").expand("Usuarios").orderBy("Numero", "asc").query();
					}]
				}
			}
		})

		.controller("BloqueioCategoriaEditController", ["$scope", "$state", "planoDiscagem", "grupos", "categorias", "ramais", "PlanoDiscagemResource", "NotifyService", "$translate", function ($scope, $state, planoDiscagem, grupos, categorias, ramais, PlanoDiscagemResource, NotifyService,
			$translate) {
			$scope.Novo = !(planoDiscagem && planoDiscagem.PlanoDiscagemId);
			$scope.planoDiscagem = planoDiscagem;
			$scope.grupos = grupos;
			$scope.ramais = ramais;
			$scope.categorias = categorias;
			if ($scope.planoDiscagem.CategoriaDiscagemId) {
				$scope.tipoBloqueio = 1;
			}
			if ($scope.planoDiscagem.NB) {
				$scope.tipoBloqueio = 2;
			}
			if ($scope.planoDiscagem.GrupoId) {
				$scope.tipoOrigem = 1;
			}
			if ($scope.planoDiscagem.RamalId) {
				$scope.tipoOrigem = 2;
			}

			$scope.tipoBloqueios = [
				{ id: 1, descricao: $translate.instant('campo.categoria') },
				{ id: 2, descricao: $translate.instant('telaEditBloqueio.numeroExterno') }
			];

			$scope.tipoOrigems = [
				{ id: 1, descricao: $translate.instant('model.grupo') },
				{ id: 2, descricao: $translate.instant('model.ramal') }
			];

			$scope.ramais.forEach(function (el) {
				if (el.Usuarios.length > 0) {
					el.RamalNome = el.Numero + ' - ' + el.Usuarios[0].Nome;
				}
				else {
					el.RamalNome = el.Numero;
				}
			});

			var mensagemSucesso = function (planoDiscagem) {
				NotifyService.showRegistroSalvo()
				if ($scope.Novo) {
					$scope.planoDiscagem = {};
				} else {
					$scope.planoDiscagem = planoDiscagem;
				}
				$state.go('main.bloqueiocategoria.list');
			};

			$scope.salvar = function salvar(form) {
				if (!form.$valid) {
					return NotifyService.showInvalid();
				}
				if ($scope.tipoOrigem == 1) {
					$scope.planoDiscagem.RamalId = null;
				} else if ($scope.tipoOrigem == 2) {
					$scope.planoDiscagem.GrupoId = null;
				}

				var promise;
				if ($scope.planoDiscagem.PlanoDiscagemId > 0) {
					promise = PlanoDiscagemResource.update($scope.planoDiscagem).$promise;
				}
				else {
					delete $scope.planoDiscagem.Ramal;
					promise = PlanoDiscagemResource.save($scope.planoDiscagem).$promise;
				}
				promise.then(mensagemSucesso).catch(NotifyService.showError);
			};

			$scope.voltar = function () {
				$state.go('main.bloqueiocategoria.list');
			};

            $scope.grupos.forEach(function (grupo) {
                grupo.GrupoFormatado = grupo.RamalNumero + " - " + grupo.Descricao;
            });
			
		}]);
})();
(function () {
	"use strict";

	var getOdataSearchShared = function (PlanoDiscagemResource, search, orderBy, $odata, utils) {
		utils.resetFilters(search, ['GrupoId', 'CategoriaDiscagemId']);
		var odata = PlanoDiscagemResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.RamalNumero) {
			odata.filter('Ramal/Numero', parseInt(search.RamalNumero));
		}

		angular.forEach(search, function (value, key) {
			if (key !== "pageSize" && key !== "RamalNumero" && value != null && value != '') {
				odata.filter(key, value);
			}
		});

		return odata;
	};

	angular.module("epbxManagerApp")

		.service("BloqueioCategoriaListData", function BloqueioCategoriaListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					planoDiscagems: ["PlanoDiscagemResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (PlanoDiscagemResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};
						if ($stateParams.storage)
							filtro = LocalStorageService.getItem("FiltroPlanoDiscagem");

						var orderBy = {
							column: "PlanoDiscagemId",
							order: "asc"
						};

						var odata = getOdataSearchShared(PlanoDiscagemResource, filtro, orderBy, $odata, utils);
						return odata.page(10, 1).query();
					}],
					grupos: ["GrupoResource", function (GrupoResource) {
						var odata = GrupoResource.odata().orderBy('Descricao', 'asc');
						odata.filter("GrupoTipoId", "=", 1);
						return odata.query();
					}],
					categorias: ["CategoriaDiscagemResource", function (CategoriaDiscagemResource) {
						return CategoriaDiscagemResource.odata().orderBy("Descricao", "asc").query();
					}],
					ramais: ["RamalResource", function (RamalResource) {
						return RamalResource.odata().select("RamalId", "Numero", "Usuarios").expand("Usuarios").orderBy("Numero", "asc").query();
					}]
				}
			}
		})

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.bloqueiocategoria", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.bloqueiocategoria.list',
						pageTitle: 'pageTitle.categoriaDeBloqueio',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.bloqueiocategoria.list", StateResolverProvider.configState("/bloqueiocategoria", "BloqueioCategoria", "List", {
					pageTitle: 'pageTitle.categoriaDeBloqueio',
					pageName: 'pageTitle.pesquisar'
				}))
				.state("main.bloqueiocategoria.edit", StateResolverProvider.configState("/bloqueiocategoria/{PlanoDiscagemId:[0-9]+}", "BloqueioCategoria", "Edit", {
					pageTitle: 'pageTitle.categoriaDeBloqueio',
					pageName: 'acoes.editar'
				}))
				.state("main.bloqueiocategoria.new", StateResolverProvider.configState("/bloqueiocategoria/new", "BloqueioCategoria", "Edit", {
					pageTitle: 'pageTitle.categoriaDeBloqueio',
					pageName: 'acoes.cadastrar'
				}))
		}])

		.controller("BloqueioCategoriaListController", ["$scope", "$state", "$odata", "planoDiscagems", "grupos", "categorias", "ramais", "PlanoDiscagemResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", function ($scope, $state, $odata, planoDiscagems, grupos, categorias,ramais, PlanoDiscagemResource, utils,
			LocalStorageService, $stateParams, NotifyService, ModalService) {
			$scope.searching = false;
			$scope.forms = {};
			$scope.planoDiscagems = planoDiscagems;
			$scope.grupos = grupos;
			$scope.categorias = categorias;
			$scope.ramais = ramais;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPlanoDiscagem") : {};

			$scope.orderBy = {
				column: "PlanoDiscagemId",
				order: "asc"
			};

			var updateList = function (list) {
				$scope.planoDiscagems = list;
				$scope.planoDiscagems.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.planoDiscagems.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			var getOdataSearch = function () {
				return getOdataSearchShared(PlanoDiscagemResource, $scope.search, $scope.orderBy, $odata, utils);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroPlanoDiscagem', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			var deleteRecord = function (data) {
				return PlanoDiscagemResource.delete({ PlanoDiscagemId: data.PlanoDiscagemId }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				ModalService.showLoading();
				return getOdataSearch().page($scope.planoDiscagems.pageSize, newPage).query()
					.then((list) => {
						updateList(list);
						ModalService.hideLoading();
					}).catch((error) => {
						NotifyService.showError(error);
						ModalService.hideLoading();
					});
			};

			updateList(planoDiscagems);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroPlanoDiscagem');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page)
					$state.go($stateParams.page, {
						storage: true
					});
				else
					$state.go('main.planoDiscagems.list', {
						storage: true
					});
			};

			$scope.viewSimulador = function () {
				$scope.forms.formSimular.$setPristine();
				ModalService.openModal('modalSimulador');
				$scope.$broadcast('carrega_simulador_categoria', null);
			};

            $scope.grupos.forEach(function (grupo) {
                grupo.GrupoFormatado = grupo.RamalNumero + " - " + grupo.Descricao;
            });

			$scope.ramais.forEach(function (el) {
				if (el.Usuarios.length > 0) {
					el.RamalNome = el.Numero + ' - ' + el.Usuarios[0].Nome;
				}
				else {
					el.RamalNome = el.Numero;
				}
			});

		}]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')

		.factory("PlanoDiscagemResource", ["$odataresource", function ($odataresource) {
			return $odataresource(
				"PlanoDiscagem/:PlanoDiscagemId", {
					"PlanoDiscagemId": "@PlanoDiscagemId"
				}, {
					Simular: {
						url: "PlanoDiscagem/Simular",
						method: "POST"
					}
				});
		}])
		.factory("CategoriaDiscagemResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CategoriaDiscagem/:CategoriaDiscagemId", {
				"CategoriaDiscagemId": "@CategoriaDiscagemId"
			});
		}]);

})();


(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.controller("SimularController", ["$scope", "RamalResource", "PlanoDiscagemResource", "GrupoResource", "NotifyService", "ModalService", function ($scope, RamalResource, PlanoDiscagemResource, GrupoResource, NotifyService, ModalService) {
			$scope.simulando = false;

			$scope.testeSimular = {
				GrupoId: null,
				NumeroRamal: null,
				NumeroDestino: ''
			};

			$scope.$on("carrega_simulador_categoria", function () {
				$scope.regraVigente = null;
				$scope.getRamal();
				$scope.getGrupo();
				$scope.testeSimular = {
					GrupoId: null,
					NumeroRamal: null,
					NumeroDestino: ''
				};

				var $maskedInput = $('.masked_input');

				if ($maskedInput.length) {
					$maskedInput.val('');
					$maskedInput.inputmask();
				}

				$scope.forms.formSimular.$setPristine();
			});

			$scope.getGrupo = function () {
				GrupoResource.odata().orderBy('Descricao', 'asc').filter("GrupoTipoId", "=", 1).query().then(function (result) {
					$scope.grupos = result;
				});
			}

			$scope.getRamal = function () {
				var data = RamalResource.odata().select("Numero", "Usuarios").expand("Usuarios").orderBy("Numero", "asc");
				if ($scope.testeSimular) {

					if ($scope.testeSimular.GrupoId > 0) {
						data.filter("GrupoId", parseInt($scope.testeSimular.GrupoId));
					}

					data.query().then(function (result) {
						$scope.ramais = result;
						$scope.ramais.forEach(function (el) {
							if (el.Usuarios.length > 0) {
								el.RamalNome = el.Numero + ' - ' + el.Usuarios[0].Nome;
							}
							else {
								el.RamalNome = el.Numero;
							}
						});
					});
				}

				else $scope.ramais = [];
			}

			var verificarResultado = function (result) {
				$scope.regraVigente = result;
				$scope.simulando = false;
			};

			$scope.simular = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}

				var numeroDestino = $scope.testeSimular.NumeroDestino.replace(/[^\w]/gi, '');

				if (numeroDestino.length < 10) {
					return ModalService.alert('modalTestarRegra.oNumeroNaoPodeTerMenosDe10Digitos')
				}
				
				$scope.simulando = true;
				$scope.testeSimular.NumeroDestino = $scope.testeSimular ? ($scope.testeSimular.NumeroDestino = numeroDestino) : '';

				PlanoDiscagemResource.Simular($scope.testeSimular).$promise
					.then(verificarResultado)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.simulando = false;
					});
			};
		
		}]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bloqueioligacao.new", StateResolverProvider.configState("/bloqueioligacao/new", "BloqueioLigacao", "Edit", {
                    pageTitle: 'pageTitle.bloqueioLigacao',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.bloqueioligacao.edit", StateResolverProvider.configState("/bloqueioligacao/{Id:[0-9]+}", "BloqueioLigacao", "Edit", {
                    pageTitle: 'pageTitle.bloqueioLigacao',
                    pageName: 'acoes.editar'
                }));

        }])

        .service('BloqueioLigacaoEditData', ["BloqueioLigacaoResource", function BloqueioLigacaoEditData(BloqueioLigacaoResource) {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    registro: ["$stateParams", function ($stateParams) {
                        if ($stateParams.Id) {
                            return BloqueioLigacaoResource.get({ Id: $stateParams.Id }).$promise;
                        } else {
                            return {
                                Descricao: '',
                                Horarios: [{
                                    HorarioInicio: '21:00',
                                    HorarioFim: '05:00',
                                    Domingo: false,
                                    Segunda: true,
                                    Terca: true,
                                    Quarta: true,
                                    Quinta: true,
                                    Sexta: true,
                                    Sabado: false
                                }],
                                Localidades: []
                            };
                        }
                    }],
                    localidades: ["RotaResource", function (RotaResource) {
                        return RotaResource.getLocalidades().$promise;
                    }],
                    bloqueioLigacaoTipo: ["BloqueioLigacaoResource", function (BloqueioLigacaoResource) {
                        return BloqueioLigacaoResource.GetBloqueioLigacaoTipo().$promise;
                    }],
                    campanhaAssociada: ["BloqueioLigacaoResource", "$stateParams", function (BloqueioLigacaoResource, $stateParams) {
                        var id = parseInt($stateParams.Id);
                        if (!id)
                            id = 0;
                        return BloqueioLigacaoResource.GetCampanhaAssociada({
                            bloqueioLigacaoId: id
                        }).$promise;
                    }],
                    campanhaNaoAssociada: ["BloqueioLigacaoResource", "$stateParams", function (BloqueioLigacaoResource, $stateParams) {
                        var id = parseInt($stateParams.Id);
                        if (!id)
                            id = 0;
                        return BloqueioLigacaoResource.GetCampanhaNaoAssociada({
                            bloqueioLigacaoId: id
                        }).$promise;
                    }]
                }
            }
        }])

        .controller("BloqueioLigacaoEditController", ["$scope", "$state", "registro", "localidades", "BloqueioLigacaoResource", "NotifyService", "campanhaAssociada", "campanhaNaoAssociada", "bloqueioLigacaoTipo", "WizardHandler", "ModalService", "$window", "$translate", "CampanhaResource", function ($scope, $state, registro, localidades, BloqueioLigacaoResource, NotifyService,
            campanhaAssociada, campanhaNaoAssociada, bloqueioLigacaoTipo, WizardHandler, ModalService, $window, $translate, CampanhaResource) {
            $scope.isNew = !registro.Id;
            $scope.helper = { localidades: [] };
            $scope.localidades = localidades;
            $scope.forms = [];

            $scope.campanhaAssociada = campanhaAssociada;
            $scope.campanhaNaoAssociada = campanhaNaoAssociada;

            $scope.bloqueioLigacaoTipo = bloqueioLigacaoTipo;

            $scope.descricoesColunasCampanha = {
                CampanhaId: 'telaEditBloqueio.codigoCampanha',
                Nome: 'telaEditBloqueio.nomeCampanha'
            }

            $scope.campanhaStepData = {
                notVisible: true
            };

            updateRegistro(registro);

            function updateRegistro(novoRegistro) {
                $scope.registro = novoRegistro;
                $scope.helper.localidades = _.map(novoRegistro.Localidades, function (l) { return l.DDD });
                return novoRegistro;
            }

            $scope.addLocalidade = function addLocalidade(value) {
                var localidade = _.findWhere(localidades, { LocalidadeId: value });
                $scope.registro.Localidades.push({
                    LocalidadeId: localidade.LocalidadeId,
                    DDD: localidade.DDD
                });
                $scope.helper.LocalidadeId = undefined;
            }

            $scope.changeTipo = function () {
                $scope.campanhaStepData.notVisible = true;
                if ($scope.registro.BloqueioLigacaoTipoId == 2) {
                    $scope.campanhaStepData.notVisible = false;
                }
            }

            $scope.changeTipo();

            $scope.removeLocalidade = function removeLocalidade(value) {
                var i = $scope.registro.Localidades.indexOf(value);
                if (i > -1) {
                    $scope.registro.Localidades.splice(i, 1);
                }
            }

            $scope.addHorario = function addHorario() {
                $scope.registro.Horarios.push({
                    HorarioInicio: '21:00',
                    HorarioFim: '05:00',
                    Domingo: false,
                    Segunda: true,
                    Terca: true,
                    Quarta: true,
                    Quinta: true,
                    Sexta: true,
                    Sabado: false
                });
                $scope.formCadastro.$pristine = false;
            }

            $scope.removeHorario = function (value) {
                var i = $scope.registro.Horarios.indexOf(value);
                if (i > -1) {
                    $scope.registro.Horarios.splice(i, 1);
                }

                $scope.formCadastro.$pristine = false;
            }

            $scope.validateStep = function validateStep(form) {
                var valid = form.$valid || false;
                form.$setSubmitted();
                return valid;
            }

            $scope.salvar = function (form, redirecionar) {
               

                if ($scope.registro.BloqueioLigacaoTipoId == 2 && form.$name == "forms.formCadastro") {
                    WizardHandler.wizard().goTo(1);
                    return;
                }

                if (!($scope.forms.formCadastro.$dirty || $scope.forms.formCampanha.$dirty)) {
                    $state.go('main.bloqueioligacao.list');
                    return;
                }

                $scope.registro.Localidades = _.map($scope.helper.localidades, function (id) { return _.findWhere(localidades, { DDD: id }) });

                if ($scope.registro.Horarios.length === 0) {
                    NotifyService.showError(null, 'telaEditBloqueio.necessarioAgendamentoComHorarioValido');
                    return false;
                }

                if ($scope.registro.Localidades.length === 0) {
                    NotifyService.showError(null, 'telaEditBloqueio.necessarioInformarAoMenosUmaLocalidade');
                    return false;
                }

                var campanhaString = _.pluck(_.where($scope.campanhaAssociada), 'CampanhaId').join(",");

                $scope.registro.CampanhaIds = campanhaString;

                ModalService.showLoading();

                if ($scope.registro.BloqueioLigacaoTipoId == 2) {
                    modalConfirm($translate.instant('telaEditBloqueio.questionBloqueio'), {
                        bgclose: false,
                        keyboard: false,
                        modal: false,
                        labels: {
                            Ok: $translate.instant('campo.sim'),
                            Cancel: $translate.instant('campo.nao')
                        },
                        stack: true
                    });
                } else {
                    $scope.registro.Reinicia = false;
                    salvarConfirm();                    
                    
                }
            };

            function modalConfirm(content, options) {

                var modal = $window.UIkit.modal.dialog(([
                    '<div class="uk-margin uk-modal-content">' + String(content) + '</div>',
                    '<div class="uk-modal-footer uk-text-right"><button class="uk-button uk-modal-close js-modal-cancel">' + options.labels.Cancel + '</button> <button class="uk-button uk-button-primary js-modal-confirm">' + options.labels.Ok + '</button></div>'
                ]).join(""), options);

                modal.element.find(".js-modal-confirm").on("click", () => {
                    $scope.registro.Reinicia = true;
                    salvarConfirm();                    
                    modal.hide();
                });

                modal.element.find(".js-modal-cancel").on("click", () => {

                    $scope.registro.Reinicia = false;
                    salvarConfirm();
                    modal.hide();
                });

                modal.on('show.uk.modal', () => {
                    setTimeout(() => {
                        modal.element.find('.js-modal-confirm').focus();
                    }, 50);
                });

                return modal.show();
            }

            function salvarConfirm(){

                var promise;

                if ($scope.registro.Id > 0) {
                    promise = BloqueioLigacaoResource.update($scope.registro).$promise;
                }
                else {
                    promise = BloqueioLigacaoResource.save($scope.registro).$promise;
                }

                promise.then(function (value) {
                    return value;
                }).then(function (registroNovo) {
                    updateRegistro(registroNovo)
                    ModalService.hideLoading();
                    NotifyService.showRegistroSalvo()
                    $state.go('main.bloqueioligacao.list');
                }).catch((er) => {
                    NotifyService.showError(er);
                });
            }
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (BloqueioLigacaoResource, search, orderBy) {
        var odata = BloqueioLigacaoResource.odata();

        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.where('Descricao', 'contains', search.Descricao);
        }

        if (search.DDD) {
            odata.whereIn('BloqueioLigacaoLocalidade', 'DDD', parseInt(search.DDD));
        }

        return odata;
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.bloqueioligacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.bloqueioligacao.list',
                        pageTitle: 'pageTitle.bloqueioLigacao',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.bloqueioligacao.list", StateResolverProvider.configState("/bloqueioligacao", "BloqueioLigacao", "List", {
                    pageTitle: 'pageTitle.bloqueioLigacao',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("BloqueioLigacaoListData", function BloqueioLigacaoListData() {
            return function () {
                return {
                    bloqueios: ["BloqueioLigacaoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (BloqueioLigacaoResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroBloqueio");
                        }
                        var orderBy = {
                            column: "Descricao",
                            order: "asc"
                        };
                        var odata = getOdataSearchShared(BloqueioLigacaoResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    localidades: ["RotaResource", function (RotaResource) {
                        return RotaResource.getLocalidades().$promise;
                    }]
                }
            }
        })

        .controller("BloqueioLigacaoListController", ["$scope", "$odata", "utils", "LocalStorageService", "$stateParams", "BloqueioLigacaoResource", "bloqueios", "localidades", "NotifyService", "ModalService", function ($scope, $odata, utils, LocalStorageService, $stateParams, BloqueioLigacaoResource, bloqueios, 
            localidades, NotifyService, ModalService) {
            $scope.searching = false;
            $scope.bloqueios = bloqueios;
            $scope.localidadeList = localidades;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroServico") : {};

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.bloqueios = list;
                $scope.bloqueios.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.bloqueios.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroBloqueio', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(BloqueioLigacaoResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.deleteRecord = function (data) {
                return BloqueioLigacaoResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    }).catch(NotifyService.showError);
            };

            $scope.pageChanged = function (newPage) {
                ModalService.showLoading();
                return getOdataSearch().page($scope.bloqueios.pageSize, newPage).query()
                    .then((list) => {
                        updateList(list);
                        ModalService.hideLoading();
                    })
                    .catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                    });
            };

            updateList(bloqueios);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroBloqueio');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };
        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("BloqueioLigacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BloqueioLigacao/:Id", { "Id": "@Id" },
            {
                GetCampanhaAssociada: {
                    url: "BloqueioLigacao/CampanhaAssociada",
                    method: "GET",
                    isArray: true
                },
                GetCampanhaNaoAssociada: {
                    url: "BloqueioLigacao/CampanhaNaoAssociada",
                    method: "GET",
                    isArray: true
                },
                GetBloqueioLigacaoTipo: {
                    url: "BloqueioLigacao/BloqueioLigacaoTipo",
                    method: "GET",
                    isArray: true
                },
            });
        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('CampanhaAvancadoData', function CampanhaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    grupo: ["GrupoResource", "$stateParams", function (GrupoResource, $stateParams) {
                        return GrupoResource.get({
                            GrupoId: $stateParams.GrupoId
                        }).$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }],
                    campanhas: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        return CampanhaResource.GetCampanhasPorGrupoComConfiguracao({
                            grupoId: $stateParams.GrupoId
                        }).$promise;
                    }],
                    campanhasSemConfiguracaoAvancada: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.getCampanhasSemConfiguracaoAvancada().$promise;
                    }],
                }
            }
        })

        .controller("CampanhaAvancadoController", ["$scope", "$filter", "$state", "grupo", "grupos", "campanhas", "campanhasSemConfiguracaoAvancada", "CampanhaResource", "NotifyService", "ModalService", function ($scope, $filter, $state, grupo, grupos, campanhas, campanhasSemConfiguracaoAvancada, CampanhaResource, 
        NotifyService, ModalService) {
            $scope.grupo = grupo;
            $scope.grupo.habilitarConfiguracaoAvancada = grupo.ConfiguracaoAvancada == 2;
            $scope.grupos = _.filter(grupos, function (el) {
                return el.ConfiguracaoAvancada != true;
            });
            $scope.campanhas = campanhas;
            $scope.campanhasSemConfiguracaoAvancada = campanhasSemConfiguracaoAvancada;
            $scope.quantidadeLivre = 0;
            $scope.desvincularGrupoId = 0;
            $scope.campanhaIdSelecionada = 0;
            $scope.tipoAcao = 1;
            $scope.calculaQuantidadeCampanhas = function () {
                $scope.grupo.QuantidadeMaxima = 0;
                $scope.campanhas.forEach(campanha => {
                    var config = _.filter(campanha.CampanhaConfiguracao, function (el) {
                        return el.CampanhaCampoId == 5;
                    });

                    $scope.grupo.QuantidadeMaxima += parseInt(config[0].Valor);

                    setTimeout(function () {
                        $scope.calculaQuantidadeLivre();
                        campanha.Quantidade = config[0].Valor;
                        $scope.campanhas = $filter('orderBy')($scope.campanhas, 'Quantidade', true);
                        $scope.$apply();
                    }, 10)
                });
            }

            $scope.getQuantidade = function () {
                return $scope.quantidadeLivre < 0 ? $scope.quantidadeLivre * (-1) : 0;
            }

            $scope.calculaQuantidadeCampanhas();
            $scope.calculaQuantidade = function (event) {
                if (event !== undefined) {
                    $scope.grupo.QuantidadeMaxima = event.target.value;
                    if ($scope.grupo.QuantidadeMaxima < 0) {
                        $scope.grupo.QuantidadeMaxima = 2;
                        event.target.value = 2;
                    }
                }

                if ($scope.grupo.QuantidadeMaxima > 0) {
                    $scope.campanhas.forEach(() => {
                        setTimeout(function () {                            
                            $scope.$apply();
                        }, 10)
                    });
                    $scope.calculaQuantidadeLivre();
                }
                else {
                    $scope.campanhas.forEach(campanha => {
                        campanha.Quantidade = 0;
                    });
                }
            }

            $scope.calculaQuantidadeLivre = function () {
                setTimeout(function () {
                    $scope.quantidadeLivre = $scope.grupo.QuantidadeMaxima;
                    $scope.campanhas.forEach(campanha => {
                        if (!campanha.Flutuante) {
                            $scope.quantidadeLivre -= campanha.Quantidade;
                        }
                    });
                    $scope.$apply();
                }, 10)
            }

            $scope.salvar = function () {
                if ($scope.grupo.habilitarConfiguracaoAvancada) {
                    $scope.grupo.ConfiguracaoAvancada = 2;
                } else {
                    $scope.grupo.ConfiguracaoAvancada = 1;
                }

                var dados = [];
                $scope.campanhas.forEach(campanha => {
                    dados.push({ "CampanhaId": campanha.CampanhaId, "Quantidade": campanha.Quantidade })
                });

                var promise = CampanhaResource.gravarAvancado({
                    grupoId: $scope.grupo.GrupoId,
                    configuracaoAvancada: $scope.grupo.ConfiguracaoAvancada,
                    quantidadeMaxima: $scope.grupo.QuantidadeMaxima,
                    campanhas: dados
                }).$promise;

                if (promise) {
                    promise.then(function () {
                        NotifyService.showRegistroSalvo();
                        if ($scope.grupo.ConfiguracaoAvancada == 2) {
                            $state.go('main.monitorcampanha.list', { grupoId: $scope.grupo.GrupoId });
                        }
                        else {
                            $state.go('main.campanha.list', { tab: 2 });
                        }
                    });
                }
            }

            $scope.desvincular = function (form) {
                var promise = CampanhaResource.desvincular({
                    campanhaId: $scope.campanhaIdSelecionada,
                    grupoId: form.grupos.$viewValue
                }).$promise;
                
                if (promise) {
                    promise.then(function () {
                        NotifyService.showRegistroSalvo();
                        ModalService.closeModal('modal_desvincular', function () {
                            $state.reload();
                            $scope.calculaQuantidadeCampanhas();
                        })
                    });
                }
            }

            $scope.associar = function (form) {
                var promise = CampanhaResource.desvincular({
                    campanhaId: form.campanhas.$viewValue,
                    grupoId: $scope.grupo.GrupoId
                }).$promise;

                if (promise) {
                    promise.then(function () {
                        NotifyService.showRegistroSalvo();
                        ModalService.closeModal('modal_desvincular', function () {
                            $state.reload();
                            $scope.calculaQuantidadeCampanhas();
                        })
                    });
                }
            }

            $scope.openModal = function (modalId, campanhaId, tipoAcao) {
                $scope.tipoAcao = tipoAcao;
                $scope.desvincularGrupoId = 0;
                $scope.forms.formDesvincular.$setPristine()
                $scope.campanhaIdSelecionada = campanhaId
                ModalService.openModal(modalId);
            };

            if ($scope.grupo.QuantidadeMaxima === undefined || $scope.grupo.QuantidadeMaxima == 0) {
                $scope.campanhas.forEach(campanha => {
                    var config = _.filter(campanha.CampanhaConfiguracao, function (el) {
                        return el.CampanhaCampoId == 5;
                    });
                    $scope.grupo.QuantidadeMaxima += parseInt(config[0].Valor);
                });
            }

        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .service('CampanhaDetalheData', function CampanhaDetalheData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_charts_peity',
                            'lazy_ionRangeSlider',
                            'lazy_countUp'
                        ]);
                    }],
                    campanha: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        if ($stateParams.CampanhaId) {
                            return CampanhaResource.get({
                                CampanhaId: $stateParams.CampanhaId
                            }).$promise;
                        }
                    }],
                    perfilDiscagem: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        const campanhaId = $stateParams.CampanhaId;
                        if (campanhaId) {
                            return CampanhaResource.GetPerfilDiscagem({
                                campanhaId
                            }).$promise;
                        }
                    }],
                    indicadoresCliente: ["MonitorCampanhaResource", "$stateParams", function (MonitorCampanhaResource, $stateParams) {
                        const CampanhaId = $stateParams.CampanhaId;
                        if (CampanhaId) {
                            return MonitorCampanhaResource.GetIndicador({
                                Visao: 1,
                                CampanhaId,
                                Data: moment(new Date()).format('YYYY-MM-DD')
                            }).$promise;
                        }
                    }],
                    indicadoresMailing: ["MonitorCampanhaResource", "$stateParams", function (MonitorCampanhaResource, $stateParams) {
                        if ($stateParams.CampanhaId) {
                            return MonitorCampanhaResource.GetIndicador({
                                Visao: 2,
                                CampanhaId: $stateParams.CampanhaId,
                                Tempo: localStorage.getItem('campanha_detalhe_periodo') === null ? 60 : parseInt(localStorage.getItem('campanha_detalhe_periodo'))
                            }).$promise;
                        }
                    }]
                }
            }
        })

        .controller("CampanhaDetalheController", ["$scope", "$timeout", "$translate", "$state", "campanha", "perfilDiscagem", "indicadoresMailing", "indicadoresCliente", "MonitorCampanhaResource", "CampanhaResource", "ModalService", "NotifyService", "$http", "Config", "$interval", function ($scope, $timeout, $translate, $state, campanha, perfilDiscagem, 
            indicadoresMailing, indicadoresCliente, MonitorCampanhaResource, CampanhaResource,
            ModalService, NotifyService, $http, Config, $interval) {

            const timeoutRefresh = 5000;
            const timeoutIndicadorRefresh = 15000;

            const queues = {};
            let timerIndicador, timerOnLine, timerAcao;

            const permiteAcao = campanha => !campanha.PendenteAcao && (campanha.CampanhaStatusId == 2 || campanha.CampanhaStatusId == 3 || campanha.CampanhaStatusId == 4 || campanha.CampanhaStatusId == 6);

            $scope.indicadores = {};
            if (indicadoresMailing.length == 1) {
                $scope.indicadoresMailing = indicadoresMailing[0];
            }
            if (indicadoresCliente.length == 1) {
                $scope.indicadoresCliente = indicadoresCliente[0];
            }
            $scope.descartadoTotal = 0;
            $scope.descartadoTotalImportacao = 0;
            $scope.previsaoMinutosFim = 0;
            $scope.campanha = campanha;
            $scope.permiteAcao = permiteAcao(campanha);
            $scope.perfilDiscagem = perfilDiscagem.qtdePerfilCampanha;
            $scope.isConsumerMessageria = false;
            $scope.expandedMeessageria = false;
            $scope.resumoTopTelefone = [];
            $scope.searchDiscado = {};
            $scope.grupoStatus = [];
            $scope.canais = [];


            $scope.AtualizaCanais = function () {
                let promise = MonitorCampanhaResource.GetMonitorCanaisAgrupadosCampanha().$promise;
                promise.then(function (data) {
                    $scope.canais = data;
                });
            };

            $scope.AtualizaGruposStatus = function () {
                let promise = MonitorCampanhaResource.GetGruposStatusAgrupados().$promise;
                promise.then(function (data) {
                    $scope.grupoStatus = data;
                });
            };

            timerOnLine = $interval(function () {
                $scope.AtualizaCanais();
                $scope.AtualizaGruposStatus();
            }, timeoutRefresh);



            $scope.indicadoresInfo = {
                atendido: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.atendido'),
                    DiscagemStatusId: 11,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.atendidoInfo')
                },
                naoAtende: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.naoAtende'),
                    DiscagemStatusId: 2,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.naoAtendeInfo')
                },
                servico: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.servico'),
                    DiscagemStatusId: 4,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.servicoInfo')
                },
                congestionamento: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.congestionamento'),
                    DiscagemStatusId: 8,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.congestionamentoInfo')
                },
                ocupado: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.ocupado'),
                    DiscagemStatusId: 3,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.ocupadoInfo')
                },
                semAgenteAtendido: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.semAgenteAtendido'),
                    DiscagemStatusId: 19,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.semAgenteAtendidoInfo')
                },
                semAgenteDisponivel: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.semAgenteDisponivel'),
                    DiscagemStatusId: 7,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.semAgenteDisponivelInfo')
                },
                maquina: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.maquina'),
                    DiscagemStatusId: 18,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.maquinaInfo')
                },
                maquinaTimeout: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.maquinaTimeout'),
                    DiscagemStatusId: 22,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.maquinaTimeoutInfo')
                },
                caixaPostal: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.caixaPostal'),
                    DiscagemStatusId: 27,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.caixaPostalInfo')
                },
                agendamentoIndisponivel: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.agendamentoIndisponivel'),
                    DiscagemStatusId: 21,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.agendamentoIndisponivelInfo')
                },
                blacklist: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.blacklist'),
                    DiscagemStatusId: 13,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.blacklistInfo')
                },
                agendamento: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.agendamento'),
                    DiscagemStatusId: 10,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.agendamentoInfo')
                },
                descartado: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.descartado'),
                    DiscagemStatusId: 17,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.descartadoInfo')
                },
                contatoNegativo: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.contatoNegativo'),
                    DiscagemStatusId: 14,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.contatoNegativoInfo')
                },
                duplicadoImportacao: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.duplicadoImportacao'),
                    DiscagemStatusId: 20,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.duplicadoImportacaoInfo')
                },
                numeroInexistente: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.numeroInexistente'),
                    DiscagemStatusId: 12,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.numeroInexistenteInfo')
                },
                numeroInvalido: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.numeroInvalido'),
                    DiscagemStatusId: 5,
                    PermiteRediscagem: false,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.numeroInvalidoInfo')
                },
                hungupCallanalysis: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.hungupCallanalysis'),
                    DiscagemStatusId: 29,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.hungupCallanalysisInfo')
                },
                bloqueadoLeiDiscado: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.bloqueadoLeiDiscado'),
                    DiscagemStatusId: 28,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.bloqueadoLeiDiscadoInfo')
                },
                atendidoDesligou: {
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.atendidoDesligou'),
                    DiscagemStatusId: 32,
                    PermiteRediscagem: true,
                    TextoInformativo: $translate.instant('telaDetalheCampanha.atendidoDesligouInfo')
                }

            }

            $scope.viewQuantidade = localStorage.getItem('campanha_detalhe_visao_quantidade') == "true";

            const periodoStorage = localStorage.getItem('campanha_detalhe_periodo');
            $scope.periodoSelecionado = periodoStorage === "null" || !periodoStorage ? 60 : parseInt(periodoStorage);

            const visaoStorage = localStorage.getItem('campanha_detalhe_visao');
            $scope.visaoSelecionada = visaoStorage === "null" || !visaoStorage ? 1 : parseInt(visaoStorage);

            $scope.rediscagem = {
                DiscagemStatus: '',
                DiscagemStatusId: 0,
                QuantidadeTotal: 0,
                Quantidade: 0,
                PeriodoDescricao: '',
            };

          

            $scope.detalheFila = {
                CampanhaId: campanha.CampanhaId,
                Nome: campanha.Nome,
                DiscagemVertical: campanha.DiscagemVertical,
                NomeFila: '',
                QuantidadeFila: 0,
                QuantidadeProcessamento: 0,
                TaxaProcessadas: 0.0,
                TaxaPublicadas: 0.0,
                TotalBytes: 0,
                Conexoes: [],
                QuantidadeConexoes: 0,
            };

            $scope.visaoConsulta = [
                { Descricao: $translate.instant('telaDetalheCampanha.visaoCliente'), Valor: 1 },
                { Descricao: $translate.instant('telaDetalheCampanha.visaoMailing'), Valor: 2 }
            ];

            $scope.periodoConsulta = [
                { Descricao: $translate.instant('telaDetalheCampanha.todos'), Valor: null },
                { Descricao: $translate.instant('telaDetalheCampanha.ultimaHora'), Valor: 60 },
                { Descricao: $translate.instant('telaDetalheCampanha.ultimas4Horas'), Valor: 240 },
                { Descricao: $translate.instant('telaDetalheCampanha.ultimas8Horas'), Valor: 480 },
                { Descricao: $translate.instant('telaDetalheCampanha.hoje'), Valor: moment().hours() * 60 + moment().minutes() },
                { Descricao: $translate.instant('telaDetalheCampanha.umaSemana'), Valor: 10080 },
                { Descricao: $translate.instant('telaDetalheCampanha.15Dias'), Valor: 43200 },
                { Descricao: $translate.instant('telaDetalheCampanha.30Dias'), Valor: 86400 }
            ];

            $scope.recontarValores = function () {
                if ($scope.indicadores) {
                    $scope.campanha.CicloDiscagem = $scope.indicadores.CicloDiscagem;
                    $scope.campanha.CicloQuantidade = $scope.indicadores.CicloQuantidade;

                    $scope.descartadoTotal = $scope.indicadores.QtdBlackList + $scope.indicadores.QtdAgendamento +
                        $scope.indicadores.QtdDescartado + $scope.indicadores.QtdContatoNegativo;

                    $scope.descartadoTotalImportacao = $scope.indicadores.QtdDuplicadoImportacao +
                        $scope.indicadores.QtdNumeroInexistente + $scope.indicadores.QtdNumeroInvalido;

                    $scope.quantidadeTotal = $scope.indicadores.QtdAtendida + $scope.indicadores.QtdNaoAtende +
                        $scope.indicadores.QtdServico + $scope.indicadores.QtdCongestionamento + $scope.indicadores.QtdOcupado +
                        $scope.indicadores.QtdSemAgente + $scope.indicadores.QtdSemAgenteAtendido + $scope.indicadores.QtdAteMaquina +
                        $scope.indicadores.QtdCallProgress + $scope.indicadores.QtdCaixaPostal + $scope.indicadores.QtdAgendamentoIndisponivel +
                        $scope.indicadores.QtdHungupCallanalysis + $scope.indicadores.QtdBloqueadoLeiDiscado;

                    if ($scope.indicadores.PrevisaoMinutosFim > 0) {
                        const agora = moment();
                        const dataPrevisao = moment($scope.indicadores.DataPrevisao);
                        if (dataPrevisao.year() > 1900) {
                            $scope.previsaoMinutosFim = $scope.indicadores.PrevisaoMinutosFim - agora.diff(dataPrevisao, 'minutes');
                        }
                    }

                    for (const key in $scope.indicadores) {
                        if ($scope.indicadores.hasOwnProperty(key)) {
                            if ($scope.quantidadeTotal > 0) {
                                $scope.indicadores[key + 'Percentual'] = $scope.indicadores[key] * 100 / $scope.quantidadeTotal;
                            } else {
                                $scope.indicadores[key + 'Percentual'] = 0;
                            }
                        }
                    }
                }
            }

            $scope.atualizandoIndicadorContador = 0;

            $scope.atualizarIndicadores = function () {
                $scope.atualizandoIndicadorContador++;
                const indicadorAtualContador = $scope.atualizandoIndicadorContador;
                if (timerIndicador) {
                    $timeout.cancel(timerIndicador);
                }

                const filtro = {
                    Visao: $scope.visaoSelecionada,
                    CampanhaId: $scope.campanha.CampanhaId
                };

                if (filtro.Visao == 2) {
                    filtro.Tempo = $scope.periodoSelecionado;
                }

                MonitorCampanhaResource.GetIndicador(filtro).$promise
                    .then((data) => {
                        if (indicadorAtualContador == $scope.atualizandoIndicadorContador) {
                            if (data.length == 1) {
                                data = data[0];
                                if (filtro.Visao == 1) {
                                    $scope.indicadoresCliente = data;
                                } else {
                                    $scope.indicadoresMailing = data;
                                }
                                $scope.indicadores = data;
                                $scope.recontarValores();
                            }
                        }
                    }).finally(() => {
                        $timeout.cancel(timerIndicador);
                        if (!$scope.destroyed) {
                            timerIndicador = $timeout($scope.atualizarIndicadores, timeoutIndicadorRefresh);
                        }
                    });
            };

            $scope.destroyed = false;
            $scope.$on("$destroy", function () {
                $scope.destroyed = true;
                if (timerIndicador) {
                    $timeout.cancel(timerIndicador);
                }
                if (timerOnLine) {
                    $interval.cancel(timerOnLine);
                }
                if (timerAcao) {
                    $timeout.cancel(timerAcao);
                }
            });

            $scope.changePeriodo = function () {
                localStorage.removeItem('campanha_detalhe_periodo');
                localStorage.setItem('campanha_detalhe_periodo', $scope.periodoSelecionado);
                $scope.carregarVisaoSelecionada();
            }

            $scope.changeMaillingVisao = function (visao) {
                $scope.visaoSelecionada = visao;
                localStorage.removeItem('campanha_detalhe_visao');
                localStorage.setItem('campanha_detalhe_visao', $scope.visaoSelecionada);
                $scope.carregarVisaoSelecionada();
            }

            $scope.edicaoCampanhas = function (campanha) {
                if (campanha.CampanhaTipoId == 1) {
                    $state.go('main.campanha.padrao.edit', campanha);
                }
                if (campanha.CampanhaTipoId == 2) {
                    $state.go('main.campanha.callback.edit', campanha);
                }
                if (campanha.CampanhaTipoId == 3) {
                    $state.go('main.campanha.higienizacao.edit', campanha);
                }
                if (campanha.CampanhaTipoId == 4) {
                    $state.go('main.campanha.talkbot.edit', campanha);
                }
            }

            $scope.changeVisaoQuantidade = function (visaoQuantidade) {
                $scope.viewQuantidade = visaoQuantidade;
                localStorage.removeItem('campanha_detalhe_visao_quantidade');
                localStorage.setItem('campanha_detalhe_visao_quantidade', $scope.viewQuantidade);
                $scope.carregarVisaoSelecionada();
            }

            $scope.carregarVisaoSelecionada = function () {
                if ($scope.visaoSelecionada == 1) {
                    $scope.indicadores = $scope.indicadoresCliente;
                } else {
                    $scope.indicadores = $scope.indicadoresMailing;
                }
                $scope.recontarValores();
                $scope.atualizarIndicadores();
            }

            function acaoEnviada() {
                ModalService.hideLoading();
                NotifyService.showSuccess();

                $scope.campanha.PendenteAcao = true;
                $scope.permiteAcao = permiteAcao($scope.campanha);

                timerAcao = $timeout(() => {
                    CampanhaResource.get({
                        CampanhaId: $scope.campanha.CampanhaId
                    }).$promise.then(campanha => {
                        if ($scope.destroyed) {
                            return;
                        }
                        $scope.permiteAcao = permiteAcao(campanha);
                        $scope.campanha.CampanhaStatusId = campanha.CampanhaStatusId;
                        $scope.campanha.PendenteAcao = campanha.PendenteAcao;
                    });
                }, 5000);
            }

            $scope.pausarCampanha = function () {
                ModalService.showLoading();

                CampanhaResource.processaCampanhaConfiguracao({
                    CampanhaId: $scope.campanha.CampanhaId,
                    CampanhaAcaoId: 3
                }).$promise.then(() => acaoEnviada()).catch((e) => {
                    NotifyService.showError(e);
                    ModalService.hideLoading();
                });
            };

            $scope.iniciarCampanha = function () {
                ModalService.showLoading();

                CampanhaResource.processaCampanhaConfiguracao({
                    CampanhaId: $scope.campanha.CampanhaId,
                    CampanhaAcaoId: 2
                }).$promise.then(() => acaoEnviada()).catch((e) => {
                    NotifyService.showError(e);
                    ModalService.hideLoading();
                });
            };

            $scope.carregarVisaoSelecionada();

            $scope.$on("onCampanhaFilaStatusChanged", function (event, data) {
                if (data.Nome) {
                    if (angular.isDefined(queues[data.Nome])) {
                        angular.copy(data, queues[data.Nome]);
                    }
                    else {
                        queues[data.Nome] = data;
                    }

                    const item = queues[data.Nome];

                    if (item.CampanhaId == $scope.campanha.CampanhaId) {
                        $scope.detalheFila.NomeFila = item.NomeFila;
                        $scope.detalheFila.QuantidadeFila = item.QuantidadeFila;
                        $scope.detalheFila.QuantidadeProcessamento = item.QuantidadeProcessamento;
                        $scope.detalheFila.TaxaProcessadas = item.TaxaProcessadas;
                        $scope.detalheFila.TaxaPublicadas = item.TaxaPublicadas;
                        $scope.detalheFila.Conexoes = item.Conexoes;
                        $scope.detalheFila.QuantidadeConexoes = item.Conexoes.length;
                        $scope.isConsumerMessageria = item.Conexoes.length > 0;
                    }

                }
            });

            $scope.viewIndicador = function (detalhe, valor) {
                detalhe.Quantidade = valor;
                detalhe.QuantidadeTotal = $scope.quantidadeTotal;
                detalhe.Visao = $scope.visaoSelecionada;
                if ($scope.visaoSelecionada != 1) {
                    const exists = _.find($scope.periodoConsulta, function (periodo) {
                        return periodo.Valor == $scope.periodoSelecionado;
                    });

                    if (exists)
                        detalhe.PeriodoDescricao = exists.Descricao;
                    else
                        detalhe.PeriodoDescricao = $translate.instant('telaDetalheCampanha.hoje');
                }
                else {
                    detalhe.PeriodoDescricao = null;
                }

                $scope.$broadcast('carrega_campanha_redisagem', detalhe);
                ModalService.openModal('modal_rediscagem');
            };

            $scope.viewRediscagem = function () {
                const detalhe = {
                    DiscagemStatusId: 9,
                    DiscagemStatus: $translate.instant('telaDetalheCampanha.rediscagem')
                };
                $scope.viewIndicador(detalhe, $scope.indicadores.QtdRediscagem);
            };

            $scope.viewDiscado = function () {
                $scope.searchTelefoneDiscado().finally(() => {
                    ModalService.openModal('modal_discados');
                });                
            }

            $scope.searchTelefoneDiscado = function() {
                return $http({
                    url: Config.getUrl('IndicadorCampanha/ResumoTopTelefone'),
                    method: "GET",
                    params: {
                        CampanhaId: $scope.campanha.CampanhaId,
                        Numero: $scope.searchDiscado.numero
                    }
                }).then(response => {
                    $scope.resumoTopTelefone = response.data;
                    console.log(response.data, 'ResumoTopTelefone');
                });
            }

            $scope.openCampanhaDetalheAcao = function () {
                ModalService.openModal('modal_detalhe_acao');
            };
        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service("CampanhaEditData", function CampanhaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_uiSelect",
                            "lazy_wizard",
                            "lazy_dropify",
                            "lazy_masked_inputs",
                            "lazy_ionRangeSlider"
                        ]);
                    }],
                    campanha: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        if ($stateParams.CampanhaId) {
                            return CampanhaResource.get({ CampanhaId: $stateParams.CampanhaId }).$promise;
                        } else {
                            return {
                                AgendamentoParalelo: false,
                                DiscagemVertical: false
                            };
                        }
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        let odata = GrupoResource.odata().orderBy("Descricao", "asc");
                        return odata.query();
                    }],
                    ramais: ["RamalResource", function (RamalResource) {
                        return RamalResource.lookup().$promise;
                    }],
                    campanhatipos: ["CampanhaTipoResource", function (CampanhaTipoResource) {
                        return CampanhaTipoResource.query().$promise;
                    }],
                    campanhatemplates: ["CampanhaTemplateResource", function (CampanhaTemplateResource) {
                        return CampanhaTemplateResource.query().$promise;
                    }],
                    regradiscagens: ["RegraRoteamentoResource", function (RegraRoteamentoResource) {
                        return RegraRoteamentoResource.query().$promise;
                    }],
                    rotas: ["RotaResource", function (RotaResource) {
                        let odata = RotaResource.odata().orderBy("Nome", "asc");
                        odata.filter("Ativo", true);
                        return odata.query();
                    }],
                    layouts: ["CampanhaLayoutResource", function (CampanhaLayoutResource) {
                        let odata = CampanhaLayoutResource.odata().orderBy("Nome", "asc");
                        odata.filter("Ativo", true);
                        return odata.query();
                    }],
                    campanhaDiscagemStatus: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.query().$promise;
                    }],
                    classes: ["$translate", function ($translate) {
                        return [
                            { ClasseId: 5, Nome: $translate.instant('campo.local') },
                            { ClasseId: 7, Nome: $translate.instant('campo.ldi') },
                            { ClasseId: 12, Nome: $translate.instant('campo.vc1') },
                            { ClasseId: 13, Nome: $translate.instant('campo.vc2') },
                            { ClasseId: 14, Nome: $translate.instant('campo.vc3') },
                            { ClasseId: 16, Nome: $translate.instant('campo.ldn') }
                        ];
                    }],
                    ramaltipos: ["$translate", function ($translate) {
                        return [
                            { TipoId: 1, Descricao: $translate.instant('model.ramal') },
                            { TipoId: 2, Descricao: $translate.instant('model.grupo') },
                            { TipoId: 3, Descricao: $translate.instant('model.ura') },
                            { TipoId: 4, Descricao: $translate.instant('model.ramalPabx') }
                        ];
                    }],
                    diaSemana: ["$translate", function ($translate) {
                        return {
                            0: $translate.instant('dias.domingo'),
                            1: $translate.instant('dias.segunda'),
                            2: $translate.instant('dias.terca'),
                            3: $translate.instant('dias.quarta'),
                            4: $translate.instant('dias.quinta'),
                            5: $translate.instant('dias.sexta'),
                            6: $translate.instant('dias.sabado')
                        };
                    }],
                    tiposDiscagem: ["$translate", function ($translate) {
                        return [
                            { TipoDiscagemId: 1, Descricao: $translate.instant('campo.fixo') },
                            { TipoDiscagemId: 2, Descricao: $translate.instant('campo.dinamico') }
                        ];
                    }],
                    maquina: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }],
                    campanhaBlacklist: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        return CampanhaResource.GetBlacklist({
                            campanhaId: $stateParams.CampanhaId ? $stateParams.CampanhaId : 0
                        }).$promise;
                    }],
                    servicoBigTalk: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.BigTalkServicoStatus().$promise;
                    }],
                    templateLimpeza: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        return CampanhaResource.GetTemplateLimpezaPorCampanha({
                            CampanhaId: $stateParams.CampanhaId ? $stateParams.CampanhaId : 0
                        }).$promise;
                    }],
                    campanhaTemplateRegra: ["CampanhaTemplateRegraResource", function (CampanhaTemplateRegraResource) {
                        return CampanhaTemplateRegraResource.query().$promise;
                    }],
                    templatePeriodo: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        return CampanhaResource.getTemplatePeriodo({
                            campanhaId: $stateParams.CampanhaId ? $stateParams.CampanhaId : 0
                        }).$promise
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    buffer: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getBuffer().$promise;
                    }],
                    discagemIgnoraStatusAssociado: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        var id = parseInt($stateParams.CampanhaId);
                        if (!id)
                            id = 0;
                        return CampanhaResource.GetDiscagemIgnoraStatusAssociado({
                            campanhaId: id
                        }).$promise;
                    }],
                    discagemIgnoraStatusNaoAssociado: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        var id = parseInt($stateParams.CampanhaId);
                        if (!id)
                            id = 0;
                        return CampanhaResource.GetDiscagemIgnoraStatusNaoAssociado({
                            campanhaId: id
                        }).$promise;
                    }],
                    templateFeriado : ["TemplateFeriadoResource", function(TemplateFeriadoResource)
                    {
                        return TemplateFeriadoResource.query().$promise;
                    }]
                };
            };
        })

        .controller("CampanhaEditController", ["$scope", "$state", "campanha", "CampanhaResource", "CampanhaDiscagemStatusResource", "CampanhaTemplateResource", "$timeout", "$location", "$http", "$stateParams", "Config", "WizardHandler", "PermissaoService", "GrupoResource", "CampanhaCampoResource", "maquina", "grupos", "ramais", "campanhatipos", "tiposDiscagem", "ramaltipos", "classes", "diaSemana", "regradiscagens", "campanhatemplates", "campanhaDiscagemStatus", "rotas", "layouts", "AuthService", "CampanhaHigienizacaoResource", "NotifyService", "$translate", "ModalService", "UraResource", "campanhaTemplateRegra", "buffer", "CampanhaTemplateRegraResource", "campanhaBlacklist", "RamalResource", "UsuarioResource", "servicoBigTalk", "templateLimpeza", "templatePeriodo", "carteiras", "discagemIgnoraStatusAssociado", "discagemIgnoraStatusNaoAssociado", "templateFeriado", function ($scope, $state, campanha, CampanhaResource, CampanhaDiscagemStatusResource, CampanhaTemplateResource,
            $timeout, $location, $http, $stateParams, Config, WizardHandler, PermissaoService, GrupoResource, CampanhaCampoResource, maquina, grupos, ramais,
            campanhatipos, tiposDiscagem, ramaltipos, classes, diaSemana, regradiscagens, campanhatemplates, campanhaDiscagemStatus, rotas, layouts,
            AuthService, CampanhaHigienizacaoResource, NotifyService, $translate, ModalService, UraResource, campanhaTemplateRegra, buffer,
            CampanhaTemplateRegraResource, campanhaBlacklist, RamalResource, UsuarioResource, servicoBigTalk, templateLimpeza, templatePeriodo,
            carteiras, discagemIgnoraStatusAssociado, discagemIgnoraStatusNaoAssociado, templateFeriado) {

            if (!$stateParams.CampanhaId) {
                CampanhaResource.validarLimiteCampanha().$promise.then(function (result) {
                    if (!result.PodeCriar) {
                        ModalService.alert('telaCampanhaEdit.limiteCampanhaAtingido', null, function () {
                            $scope.$apply(function () {
                                $state.go('main.campanha.list');
                            });
                        });
                    }
                });
            }

            // Alteração nos objetos recebidos pelo service
            grupos.forEach(el => { if (el.Ramal) { el.Numero = el.Ramal.Numero; } });

            // Listas
            $scope.servicoBigTalk = servicoBigTalk;
            $scope.grupos = grupos;
            $scope.todosGrupos = grupos;
            $scope.ramais = ramais;
            $scope.ramaltipos = ramaltipos;
            $scope.campanhatipos = campanhatipos;
            $scope.tiposDiscagem = tiposDiscagem;
            $scope.classes = classes;
            $scope.diaSemana = diaSemana;
            $scope.regradiscagens = regradiscagens;
            $scope.rotas = rotas;
            $scope.layouts = layouts;
            $scope.campanhaDiscagemStatus = _.where(campanhaDiscagemStatus, { PermiteRegra: true });
            $scope.BlacklistsAdicionadas = [];
            $scope.BlacklistsAdicionadasCopia = [];
            $scope.BlacklistsNaoAdicionadas = [];
            $scope.BlacklistsNaoAdicionadasCopia = [];
            $scope.editandoJornadaMenu = [];
            $scope.jornadasAnteriores = [];
            $scope.rotasAntigas = [];
            $scope.campanhasVisualSMS = [];
            $scope.diasDisabled = [];
            $scope.campanhaCampoPreditivo = [];
            $scope.layoutCampanhaEPBX = [];
            $scope.camposCampanhaVisualSMS = [];
            $scope.campanhasHigienizacaoList = [];
            $scope.uras = [];
            $scope.urasPesquisa = [];
            $scope.ramaispabx = [];
            $scope.ramaisList = [];
            $scope.habilitarTemplateRegra = false;
            $scope.campanhaTemplateRegra = campanhaTemplateRegra;
            $scope.discagemIgnoraStatusAssociado = discagemIgnoraStatusAssociado;
            $scope.discagemIgnoraStatusNaoAssociado = discagemIgnoraStatusNaoAssociado;
            $scope.templateFeriado = templateFeriado;

            $scope.tipoDiscagemId = 1;

            $scope.regraPrioridades = [
                { Valor: 2, Descricao: $translate.instant('telaCampanhaEdit.baixa') },
                { Valor: 3, Descricao: $translate.instant('telaCampanhaEdit.media') },
                { Valor: 4, Descricao: $translate.instant('telaCampanhaEdit.alta') }
            ];

            $scope.tipoDeLimite = [
                { TipoId: 1, Descricao: $translate.instant('telaCampanhaEdit.rediscagemPorTelefone')},
                { TipoId: 2, Descricao: $translate.instant('telaCampanhaEdit.rediscagemPorCliente')},
                { TipoId: 3, Descricao: $translate.instant('status.desabilitado')}
            ];

            $scope.carteiras = carteiras;

            // Objetos 
            $scope.forms = {};
            $scope.regraEditada = {};
            $scope.ultimoArquivoId = {};

            $scope.LimpezaMailing = {
                UsuarioCadastro: $scope.usuarioLogadoId
            };
            $scope.templateLimpeza = templateLimpeza;
            $scope.associadoTemplateLimpeza = templateLimpeza.CampanhaId ? true : false;

            $scope.templatePeriodo = templatePeriodo;
            $scope.associadoTemplatePeriodo = templatePeriodo.length > 0 ? true : false

            // Objeto Campanha
            $scope.campanha = campanha;
            $scope.campanha.BlacklistsAdicionadas = campanhaBlacklist.BlacklistsAdicionadas;
            $scope.campanha.BlacklistsAdicionadasCopia = campanhaBlacklist.BlacklistsAdicionadas;
            $scope.campanha.BlacklistsNaoAdicionadasCopia = campanhaBlacklist.BlacklistsNaoAdicionadas;
            $scope.campanha.BlacklistsNaoAdicionadas = campanhaBlacklist.BlacklistsNaoAdicionadas;
            $scope.campanha.HabilitarHigienizacao = $scope.campanha.CampanhaHigienizacaoId != null && $scope.campanha.CampanhaHigienizacaoId != undefined;
            $scope.campanha.DiscagemInternacional = campanha.CampanhaId > 0 ? campanha.DiscagemInternacional : 0;
            $scope.campanha.RotaInteligente = campanha.DiscagemInternacional ? false : campanha.RotaInteligente;

            // Permissões
            $scope.detalhesPermissao = PermissaoService.checkAccess("Campanha", "Detalhe");
            $scope.periodoPermissao = PermissaoService.checkAccess("Campanha", "Periodo");
            $scope.roteamentoPermissao = PermissaoService.checkAccess("Campanha", "Roteamento");
            $scope.propriedadePermissao = PermissaoService.checkAccess("Campanha", "Propriedade");
            $scope.regraPermissao = PermissaoService.checkAccess("Campanha", "Regras");
            $scope.cadastrarPermissao = PermissaoService.checkAccess("Campanha", "Cadastrar");
            $scope.avancadoPermissao = PermissaoService.checkAccess("Campanha", "Avançado");

            // Definindo variáveis da controller
            let accordion = null;
            let wrapperStatus = null;
            const limiteDiscagemClientePadrao = [
                { ControleDiscagemTipoId: 1, ControleDiscagemTipo: { ControleDiscagemTipoId: 1, Descricao: $translate.instant('telaCampanhaEdit.diario') }, Quantidade: 3, Ativo: true },
                { ControleDiscagemTipoId: 2, ControleDiscagemTipo: { ControleDiscagemTipoId: 2, Descricao: $translate.instant('telaCampanhaEdit.mensal') }, Quantidade: 44, Ativo: true }
            ];

            const limiteDiscagemTelefonePadrao = [
                { ControleDiscagemTipoId: 1, ControleDiscagemTipo: { ControleDiscagemTipoId: 1, Descricao: $translate.instant('telaCampanhaEdit.diario') }, Quantidade: 3, Ativo: true },
                { ControleDiscagemTipoId: 2, ControleDiscagemTipo: { ControleDiscagemTipoId: 2, Descricao: $translate.instant('telaCampanhaEdit.mensal') }, Quantidade: 44, Ativo: true }
            ];
            let regraPadrao = _.findWhere(regradiscagens, {
                Padrao: true,
                Ativo: true
            });

            $scope.descricoesColunasStatus = {
                Descricao: 'modalIgnoraStatus.status'
            }

            // Definindo variáveis do $scope
            $scope.isNew = campanha.CampanhaId > 0 ? false : true;
            $scope.isHorariosInvalidos = false;
            $scope.perfilDiscagemAnterior = 0;
            $scope.jornadaEditadaId = -1;
            $scope.CampanhaIntegracaoVisualSMSId = null;
            $scope.RamalAnterior = null;
            $scope.regrasAntigas = null;
            $scope.editandoJornada = false;
            $scope.limparMenuFile = false;
            $scope.todosHorariosAtivos = false;
            $scope.modalBlacklistAlterada = false;
            $scope.salvando = false;
            $scope.todosItemsAdicionadas = false;
            $scope.todosItemsNaoAdicionadas = false;
            $scope.abertoModal = false;
            $scope.regraAdicionada = false;
            $scope.ativarTodos = false;
            $scope.usuarioLogadoId = AuthService.getUsuarioLogado() ? AuthService.getUsuarioLogado().UsuarioId : 0;
            $scope.tipoDiscagemDescricao = $translate.instant("telaCampanhaEdit.tipoDiscagemDescricao");
            $scope.campanhaEmAndamento = (!$scope.isNew && (campanha.CampanhaStatusId === 3 || campanha.CampanhaStatusId === 6))
            $scope.buffer = buffer;
            $scope.validacaoBuffer = $translate.instant('telaCampanhaEdit.validacaoBuffer', { Min: $scope.buffer.BufferMin, Max: $scope.buffer.BufferMax });
            $scope.tipoDiscagemTalkBot = $scope.campanha.DiscagemVertical ? true : false;

            $scope.onChangeCarteira = function () {
                if ($scope.campanha.CarteiraId == 0 || $scope.campanha.CarteiraId == undefined) {
                    $scope.campanha.BlacklistsAdicionadas = $scope.campanha.BlacklistsAdicionadasCopia;
                    $scope.campanha.BlacklistsNaoAdicionadas = $scope.campanha.BlacklistsNaoAdicionadasCopia;

                } else {
                    $scope.campanha.BlacklistsAdicionadas = _.filter($scope.campanha.BlacklistsAdicionadasCopia, function (el) {
                        return el.CarteiraId == $scope.campanha.CarteiraId || el.CarteiraId == null;
                    });
                    $scope.campanha.BlacklistsNaoAdicionadas = _.filter($scope.campanha.BlacklistsNaoAdicionadasCopia, function (el) {
                        return el.CarteiraId == $scope.campanha.CarteiraId || el.CarteiraId == null;
                    });
                }
            };

            //Configurações de discagem selecionadas ao criar uma nova campanha
            if ($scope.isNew) {

                $scope.campanha.IgnorarContactados = true;
                $scope.campanha.IgnorarClienteDuplicado = true;
                $scope.campanha.CallAnnounce = true;
                $scope.campanha.CallAnnounceRondomico = true;
                $scope.campanha.Visivel = true;

                if (!$scope.campanha.DiscagemVertical) {

                    $scope.campanha.AgendamentoParalelo = true;
                    $scope.habilitarTemplateRegra = true;
                    $scope.campanha.CampanhaTemplateRegraId = 1;
                }
            }

            // Funções que serão usadas na controller apenas
            function popularControleDiscagem(tipoDiscagemId) {

                if ($scope.isNew) {
                    if (tipoDiscagemId == 1) {

                        $scope.campanha.CampanhaControleDiscagemTelefone = limiteDiscagemTelefonePadrao;

                        if (!$scope.campanha.DiscagemVertical) 
                            $scope.campanha.MaximoDiscagem = 1
                        
                    } else if (tipoDiscagemId == 2) {
                        $scope.campanha.CampanhaControleDiscagemCliente = limiteDiscagemClientePadrao;
                    }
                } else {

                    if (tipoDiscagemId == 1) {

                        if ($scope.campanha.CampanhaControleDiscagemTelefone.length <= 0 || $scope.campanha.CampanhaControleDiscagemTelefone == undefined) {
                            $scope.campanha.CampanhaControleDiscagemTelefone = limiteDiscagemTelefonePadrao;
                        } else {
                            $scope.campanha.CampanhaControleDiscagemTelefone.forEach(controle => {
                                controle.Ativo = true;
                            });
                        }

                    } else if (tipoDiscagemId == 2) {

                        if ($scope.campanha.CampanhaControleDiscagemCliente.length <= 0 || $scope.campanha.CampanhaControleDiscagemCliente == undefined) {
                            $scope.campanha.CampanhaControleDiscagemCliente = limiteDiscagemClientePadrao;
                        } else {
                            $scope.campanha.CampanhaControleDiscagemCliente.forEach(controle => {
                                controle.Ativo = true;
                            });
                        }
                    }
                }
            }

            function desabilitarControleDiscagemCliente() {
                //$scope.campanha.PermiteControleDiscagem = false;
                if (($scope.campanha.CampanhaControleDiscagemCliente || []).length > 0) {
                    $scope.campanha.CampanhaControleDiscagemCliente.forEach(controle => {
                        controle.Ativo = false;
                    });
                }
            }

            function desabilitarControleDiscagemTelefone() {
                // $scope.campanha.PermiteControleDiscagem = false;
                if (($scope.campanha.CampanhaControleDiscagemTelefone || []).length > 0) {
                    $scope.campanha.CampanhaControleDiscagemTelefone.forEach(controle => {
                        controle.Ativo = false;
                    });
                }
            }

            function ativarControleDiscagemCliente() {
                //$scope.campanha.PermiteControleDiscagem = false;
                if (($scope.campanha.CampanhaControleDiscagemCliente || []).length > 0) {
                    $scope.campanha.CampanhaControleDiscagemCliente.forEach(controle => {
                        controle.Ativo = true;
                    });
                }
            }

            function ativarControleDiscagemTelefone() {
                // $scope.campanha.PermiteControleDiscagem = false;
                if (($scope.campanha.CampanhaControleDiscagemTelefone || []).length > 0) {
                    $scope.campanha.CampanhaControleDiscagemTelefone.forEach(controle => {
                        controle.Ativo = true;
                    });
                }
            }

            function desabilitarLimiteRediscagem() {
                $scope.campanha.LimiteAtivo = 0;
                $scope.campanha.MaximoDiscagem = null;
                $scope.campanha.MaximoDiscagemAcaoId = null;
                //$scope.campanha.PermiteControleDiscagem = false;
            }

            function getCampanhasHigienizacao() {
                CampanhaResource.GetCampanhasPorTipo({ campanhaTipoId: 3 }).$promise
                    .then(r => {
                        $scope.campanhasHigienizacaoList = r;
                    }).catch(NotifyService.showError);
            }

            function getRamalPabx() {
                UsuarioResource.GetTodosUsuarioAtivo({ CarteiraId: $scope.campanha.CarteiraId, RamalTipoId: "4" })
                    .$promise
                    .then(r => {
                        $scope.ramaispabx = r.filter(x => x.CarteiraId == $scope.campanha.CarteiraId)
                    }).catch(NotifyService.showError)
            }

            function getRamaisList() {
                /*RamalResource.getSimples({ RamalTipoId: "1,6" })
                    .$promise
                    .then(r => {
                        $scope.ramaisList = r.filter(x => x.CarteiraId == $scope.campanha.CarteiraId)
                    }).catch(NotifyService.showError)*/

                UsuarioResource.GetTodosUsuarioAtivo({ CarteiraId: $scope.campanha.CarteiraId, RamalTipoId: "1,6" })
                    .$promise
                    .then(r => {
                        $scope.ramaisList = r
                    }).catch(NotifyService.showError)
            }

            function getUras() {
                UraResource.getComRamalUra()
                    .$promise
                    .then(r => {
                        $scope.uras = r.filter(x => x.CarteiraId == $scope.campanha.CarteiraId)
                    }).catch(NotifyService.showError);
            }

            function getUrasPesquisa() {
                UraResource.getComRamalUraPesquisa()
                    .$promise
                    .then(r => {
                        $scope.urasPesquisa = r.filter(x => x.CarteiraId == $scope.campanha.CarteiraId)
                    }).catch(NotifyService.showError);
            }



            if (!$scope.isNew) {
                $scope.onChangeCarteira();
                getRamaisList();
                if ($scope.campanha.RamalId) {
                    $scope.campanha.RedirecionaTipoId = $scope.campanha.RamalTipoId;
                    if ($scope.campanha.RamalTipoId == 3) getUras();
                    if ($scope.campanha.RamalTipoId == 4) getRamalPabx();
                    if ($scope.campanha.RamalTipoId == 5) getUrasPesquisa();
                } else {
                    $scope.campanha.RedirecionaTipoId = 2;
                }

                if ($scope.campanha.HabilitarHigienizacao) {
                    getCampanhasHigienizacao();
                }

                $scope.campanha.CampanhaHorario.forEach(element => {
                    element.DiaSemana = $scope.diaSemana[element.Dia];
                });

                if ($scope.campanha.CampanhaRota && $scope.campanha.CampanhaRota.length > 0) {
                    if ($scope.campanha.CampanhaRota[0].RegraDiscagemId > 0) {
                        $scope.campanha.RotaInteligente = true;
                    } else {
                        $scope.campanha.RotaInteligente = false;
                    }
                }
                if ($scope.campanha.MaximoDiscagem > 0) {
                    $scope.campanha.LimiteAtivo = true;
                } else {
                    $scope.campanha.MaximoDiscagem = 0;
                }
                if ($scope.campanha.CallAnnounceAudioId > 0) {
                    $scope.campanha.CallAnnounce = true;
                }
                if ($scope.campanha.CallAnnounceClienteId > 0) {
                    $scope.campanha.CallAnnounce = true;
                }
                if ($scope.campanha.AudioEsperaId > 0) {
                    $scope.campanha.habilitaAudioEspera = true;
                }

                if (campanha.GoogleVC) {
                    if (campanha.GoogleAgentId > 0)
                        $scope.OnChangeGoogleAgent(campanha.GoogleAgentId);
                }

                if ($scope.campanha.RedirecionaTipoId == 3 && $scope.campanha.CampanhaTemplateId == 1) {
                    const campoConfiguracao = $scope.campanha.CampanhaConfiguracao.find(x => x.Campo == "RamalOperacao");

                    if (campoConfiguracao != null)
                        campoConfiguracao.Obrigatorio = false;
                }

                if (campanha.DiscagemVertical)
                    $scope.tipoDiscagemId = 2
                else if (campanha.DiscagemPreview)
                    $scope.tipoDiscagemId = 3
                else
                    $scope.tipoDiscagemId = 1

            } else {
                $scope.campanha.RotaInteligente = true;

                $scope.campanha.CampanhaRota = [];

                if (regraPadrao) {
                    $scope.campanha.CampanhaRota.push({ RegraDiscagemId: regraPadrao.RegraDiscagemId });
                } else {
                    if (regradiscagens[0]) {
                        $scope.campanha.CampanhaRota.push({ RegraDiscagemId: regradiscagens[0].RegraDiscagemId });
                    }
                }

                $scope.campanha.QtdMaxBuffer = $scope.buffer.BufferMin;
            }

            if ($scope.layouts.length == 1) {
                $scope.campanha.CampanhaLayoutId = $scope.layouts[0].Id;
            }

            if ($scope.campanha.CampanhaTemplateRegraId > 0) {
                $scope.habilitarTemplateRegra = true;
                CampanhaTemplateRegraResource.get({ Id: $scope.campanha.CampanhaTemplateRegraId }).$promise.then(res => {
                    $scope.campanhaTemplateRegraAtual = res;
                });
            }

            if ($scope.campanha.DiscagemVertical == true) {
                $scope.campanha.AdiantarRediscagem = false;
                $scope.campanha.AgendamentoParalelo = false;
            }


            if ($scope.campanha.CampanhaControleDiscagemTelefone) {
                $scope.campanha.CampanhaControleDiscagemTelefone = $scope.campanha.CampanhaControleDiscagemTelefone.filter(t => t.Ativo);
            }

            if ($scope.campanha.CampanhaControleDiscagemCliente) {
                $scope.campanha.CampanhaControleDiscagemCliente = $scope.campanha.CampanhaControleDiscagemCliente.filter(t => t.Ativo);
            }

            if ($scope.campanha.PermiteControleDiscagem == true) {
                if ($scope.campanha.MaximoDiscagem > 0 || $scope.campanha.CampanhaControleDiscagemTelefone.filter(t => t.Ativo).length > 0) {
                    $scope.campanha.LimiteAtivo = true;
                    $scope.campanha.TipoDeLimiteId = 1;

                } else if ($scope.campanha.CampanhaControleDiscagemCliente.filter(t => t.Ativo).length > 0) {
                    $scope.campanha.TipoDeLimiteId = 2;

                }
                else {
                    $scope.campanha.TipoDeLimiteId = 3;
                }
            } else {
                $scope.campanha.TipoDeLimiteId = 3;
            }

            if (maquina[0].PlataformaId == 1) {
                $scope.campanhatipos = _.filter($scope.campanhatipos, el => {
                    return el.CampanhaTipoId != 4;
                });
            }

            $timeout(() => {
                accordion = UIkit.accordion($("#accordion-regras"), {
                    collapse: false
                });
                wrapperStatus = accordion.find("[data-wrapper]").get(1);
                accordion.toggleItem(UIkit.$(wrapperStatus), false, false);
            }, 500);

            $scope.exibirRegras = function () {
                ModalService.openModal("modal_templateregra");
            };

            $scope.exibirIgnararStatusDiscagem = function () {
                ModalService.openModal("modal_ignorar_status");
            };

            $scope.onChangeIgnoraStatus = function (campanhaId) {
                if (campanhaId > 0) {
                    CampanhaResource.InativarDiscagemIgnoraStatus(
                        { campanhaId: campanhaId }
                    ).$promise.then(() => {
                        $scope.getDiscagemIgnoraStatusAssociado(campanhaId);
                        $scope.getDiscagemIgnoraStatusNaoAssociado(campanhaId);
                    });
                }
            };

            $scope.getDiscagemIgnoraStatusAssociado = function (campanhaId) {
                if (campanhaId > 0) {
                    CampanhaResource.GetDiscagemIgnoraStatusAssociado(
                        { campanhaId: campanhaId }
                    ).$promise.then(data => {
                        $scope.discagemIgnoraStatusAssociado = data;
                    });
                }
            };

            $scope.getDiscagemIgnoraStatusNaoAssociado = function (campanhaId) {
                if (campanhaId > 0) {
                    CampanhaResource.GetDiscagemIgnoraStatusNaoAssociado(
                        { campanhaId: campanhaId }
                    ).$promise.then(data => {
                        $scope.discagemIgnoraStatusNaoAssociado = data;
                    });
                }
            };

            $scope.fecharIgnorarStatusDiscagem = function () {
                ModalService.closeModal("modal_ignorar_status");
            };

            $scope.salvarIgnorarStatusDiscagem = function () {

                if ($scope.campanha.CampanhaId) {
                    var discagemIgnoraStatus = $scope.discagemIgnoraStatusAssociado;

                    var dto = {
                        CampanhaId: $scope.campanha.CampanhaId,
                        DiscagemIgnoraStatus: discagemIgnoraStatus
                    };

                    CampanhaResource.AddDiscagemIgnoraStatus(dto).$promise.then(() => {
                        NotifyService.showRegistroSalvo();
                        $scope.fecharIgnorarStatusDiscagem();
                        $scope.getDiscagemIgnoraStatusAssociado($scope.campanha.CampanhaId);
                        $scope.getDiscagemIgnoraStatusNaoAssociado($scope.campanha.CampanhaId);
                    }).catch(() => {
                        NotifyService.showError('modalIgnoraStatus.erroAoSalvarStatus');
                    });
                }
            };

            $scope.onAgendamentoParaleloAlterado = function () {
                if ($scope.campanha.AgendamentoParalelo == true) {
                    $scope.campanha.DiscagemVertical = false;
                }
            };



            $scope.onDiscagemVerticalAlterado = function (tipoDiscagemId) {
                if ($scope.campanha.CampanhaStatusId == 3 || $scope.campanha.CampanhaStatusId == 6) {

                    $scope.exibirDetalhe($translate.instant('telaCampanhaEdit.campanhaDeveSerPausada'));
                    return;
                }

                if (tipoDiscagemId == 2)
                    $scope.campanha.DiscagemVertical = true;
                else
                    $scope.campanha.DiscagemVertical = false;

                if (tipoDiscagemId == 3)
                    $scope.campanha.DiscagemPreview = true;
                else
                    $scope.campanha.DiscagemPreview = false;


                if ($scope.campanha.DiscagemVertical == true) {
                    $scope.campanha.LimiteAtivo = false;
                    $scope.campanha.AgendamentoParalelo = false;
                    $scope.campanha.MaximoDiscagem = 0;
                    $scope.campanha.AdiantarRediscagem = false;
                    $scope.campanha.PercentualRediscagem = 50;
                    $scope.campanha.CicloQuantidade = 1;
                }

                if ($scope.campanha.DiscagemVertical) {
                    $scope.regrasAntigas = $scope.campanha.CampanhaRegra;
                    $scope.campanha.CampanhaRegra = [];
                } else {
                    $scope.campanha.CampanhaRegra = $scope.regrasAntigas || [];
                    $scope.regrasAntigas = null;
                }
            };

            $scope.onDiscagemVerticalTalkBotAlterado = function (tipoDiscagemTalkBot) {

                $scope.campanha.DiscagemPreview = false;

                if (tipoDiscagemTalkBot)
                    $scope.campanha.DiscagemVertical = true;
                else
                    $scope.campanha.DiscagemVertical = false;


                if ($scope.campanha.DiscagemVertical == true) {
                    $scope.campanha.LimiteAtivo = false;
                    $scope.campanha.AgendamentoParalelo = false;
                    $scope.campanha.MaximoDiscagem = 0;
                    $scope.campanha.AdiantarRediscagem = false;
                    $scope.campanha.PercentualRediscagem = 50;
                    $scope.campanha.CicloQuantidade = 1;
                }

                if ($scope.campanha.DiscagemVertical) {
                    $scope.regrasAntigas = $scope.campanha.CampanhaRegra;
                    $scope.campanha.CampanhaRegra = [];
                } else {
                    $scope.campanha.CampanhaRegra = $scope.regrasAntigas || [];
                    $scope.regrasAntigas = null;
                }

            };

            $scope.onHorarioAlterado = function () {
                $scope.forms.formHorarios.$setDirty();
            };

            $scope.onFlutuanteAlterado = function () {
                let campoPerfilDiscagem = _.find(
                    $scope.campanha.CampanhaConfiguracao,
                    el => {
                        return el.CampanhaCampoId == 5;
                    }
                );
                if ($scope.campanha.Flutuante) {
                    $scope.perfilDiscagemAnterior = campoPerfilDiscagem.Valor;
                    campoPerfilDiscagem.Valor = 1;
                } else {
                    if ($scope.perfilDiscagemAnterior > 0) {
                        campoPerfilDiscagem.Valor = $scope.perfilDiscagemAnterior;
                    }
                    $scope.perfilDiscagemAnterior = 0;
                }
            };

            $scope.alterarArquivo = function (nome) {
                let upperCase = nome.charAt(0).toUpperCase() + nome.slice(1);
                $scope.ultimoArquivoId = {};
                $scope.ultimoArquivoId[nome] = $scope.campanha[upperCase + "ArquivoId"];
                $scope.campanha[upperCase + "ArquivoId"] = null;
            };

            $scope.cancelarAlterarArquivo = function (nome) {
                let upperCase = nome.charAt(0).toUpperCase() + nome.slice(1);
                $scope.campanha[upperCase + "ArquivoId"] = $scope.ultimoArquivoId[nome];
                $scope.ultimoArquivoId[nome] = null;
            };

            $scope.showProgress = function (percentComplete) {
                $("#modalBlock").find(".uk-progress-bar").css({ width: percentComplete + "%" });
                $("#modalBlock").find(".uk-progress-bar").text(percentComplete + "%");
            };

            $scope.loadArquivoError = function (result) {
                $scope.preview = null;
                ModalService.hideUploading();
                if (result == "Bad Request") {
                    NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                }
            };

            $scope.startArquivoUpload = function () {
                ModalService.showUploading();
            };

            $scope.ouvirAudio = function (id, nome) {
                $scope.arquivoAudio = {
                    url: "/Campanha/Audio/" + id,
                    titulo: $translate.instant("diretivas.reproduzindo") + nome
                };
            };

            $scope.ouvirAudioGrupo = function (id, nome) {
                $scope.arquivoAudio = {
                    url: "/Grupo/Audio/" + id,
                    titulo: $translate.instant("diretivas.reproduzindo") + nome
                };
            };

            $scope.fecharAudio = function () {
                $scope.arquivoAudio = null;
            };

            $scope.loadAnnounceCompleted = function (result) {
                $scope.erroCallAnnounce = false;
                $scope.preview = result;
                $scope.ultimoArquivoId["announce"] = null;
                $scope.campanha.CallAnnounceAudioId = result.CampanhaAudioId;
                $scope.campanha.CallAnnounceAudio = result;
                $scope.forms.formPropriedade.$setDirty();
                ModalService.hideUploading();
            };

            $scope.removeAnnounce = function () {
                $scope.ultimoArquivoId["announce"] = null;
                $scope.campanha.CallAnnounceAudioId = null;
                $scope.campanha.CallAnnounceAudio = null;
                $("#file-callannounce").val("");
                $scope.forms.formPropriedade.$setDirty();
            };


            $scope.loadAnnounceClienteCompleted = function (result) {
                $scope.erroCallAnnounce = false;
                $scope.preview = result;
                $scope.ultimoArquivoId['announceCliente'] = null;
                $scope.campanha.CallAnnounceClienteId = result.CampanhaAudioId;
                $scope.campanha.CallAnnounceCliente = result;
                $scope.forms.formPropriedade.$setDirty();
                ModalService.hideUploading();
            };

            $scope.removeAnnounceCliente = function () {
                $scope.ultimoArquivoId['announceCliente'] = null;
                $scope.campanha.CallAnnounceClienteId = null;
                $scope.campanha.CallAnnounceCliente = null;
                $('#file-callannounceCliente').val('');
                $scope.forms.formPropriedade.$setDirty();
            };


            $scope.loadAudioEsperaCompleted = function (result) {
                $scope.erroAudioEspera = false;
                $scope.preview = result;
                $scope.ultimoArquivoId['audioEspera'] = null;
                $scope.campanha.AudioEsperaId = result.CampanhaAudioId;
                $scope.campanha.AudioEspera = result;
                $scope.forms.formPropriedade.$setDirty();
                ModalService.hideUploading();
            };

            $scope.removeAudioEspera = function () {
                $scope.ultimoArquivoId['audioEspera'] = null;
                $scope.campanha.AudioEsperaId = null;
                $scope.campanha.AudioEspera = null;
                $('#file-audioEspera').val('');
                $scope.forms.formPropriedade.$setDirty();
            };

            $scope.onCallAnnounceAlterado = function () {
                if ($scope.campanha.CallAnnounce == false) {
                    $scope.callAnnounceAnterior = $scope.campanha.CallAnnounceAudio;
                    $scope.callAnnounceIdAnterior = $scope.campanha.CallAnnounceAudioId;
                    $scope.campanha.CallAnnounceAudio = null;
                    $scope.campanha.CallAnnounceAudioId = null;
                    $scope.callAnnounceClienteAnterior = $scope.campanha.CallAnnounceCliente;
                    $scope.callAnnounceClienteIdAnterior = $scope.campanha.CallAnnounceClienteId;
                    $scope.campanha.CallAnnounceCliente = null;
                    $scope.campanha.CallAnnounceClienteId = null;
                    $scope.campanha.CallAnnounceRondomico = false;
                } else {
                    if ($scope.callAnnounceIdAnterior > 0) {
                        $scope.campanha.CallAnnounceAudio = $scope.callAnnounceAnterior;
                        $scope.campanha.CallAnnounceAudioId = $scope.callAnnounceIdAnterior;
                    }
                    if ($scope.callAnnounceClienteIdAnterior > 0) {
                        $scope.campanha.CallAnnounceCliente = $scope.callAnnounceClienteAnterior;
                        $scope.campanha.CallAnnounceClienteId = $scope.callAnnounceClienteIdAnterior;
                    }

                    $scope.campanha.CallAnnounceRondomico = true;
                }
            }

            $scope.onAudioEsperaAlterado = function () {
                if ($scope.campanha.habilitaAudioEspera == false) {
                    $scope.audioEsperaAnterior = $scope.campanha.AudioEspera;
                    $scope.audioEsperaIdAnterior = $scope.campanha.AudioEsperaId;
                    $scope.campanha.AudioEspera = null;
                    $scope.campanha.AudioEsperaId = null;
                } else {
                    if ($scope.audioEsperaIdAnterior > 0) {
                        $scope.campanha.AudioEspera = $scope.audioEsperaAnterior;
                        $scope.campanha.AudioEsperaId = $scope.audioEsperaIdAnterior;
                    }
                }
            };

            $scope.onDiscagemStatusAlterado = function () {
                if ($scope.regraEditada.CampanhaDiscagemStatusId > 0) {
                    $scope.acoes = _.map(
                        _.find($scope.campanhaDiscagemStatus, (el) => {
                            return (el.CampanhaDiscagemStatusId == $scope.regraEditada.CampanhaDiscagemStatusId);
                        }).CampanhaRegraStatusAcao, (el2) => {
                            return el2.CampanhaRegraAcao;
                        }
                    );
                } else {
                    $scope.acoes = [];
                    $scope.regraEditada.CampanhaIntegracaoVisualSMSId = null;
                    $scope.regraEditada.CampanhaRegraVisualSMS = null;
                }
                $scope.regraEditada.CampanhaRegraAcaoId = 0;
            };

            $scope.onAcaoAlterado = function () {
                let selecao = $scope.acoes.filter(acao => {
                    return (acao.CampanhaRegraAcaoId == $scope.regraEditada.CampanhaRegraAcaoId);
                });

                if (selecao.length > 0 && selecao[0].Descricao == "Visual SMS") {
                    CampanhaDiscagemStatusResource.GetCampanhas().$promise.then(data => {
                        $scope.campanhasVisualSMS = data;
                    });
                } else {
                    $scope.regraEditada.CampanhaIntegracaoVisualSMSId = null;
                    $scope.regraEditada.CampanhaRegraVisualSMS = null;
                }
            };

            $scope.onCampanhaVisualSMSAlterado = function (abrir) {
                if ($scope.regraEditada.CampanhaIntegracaoVisualSMSId) {
                    CampanhaDiscagemStatusResource.GetLayoutCampanha({ campanhaId: $scope.regraEditada.CampanhaIntegracaoVisualSMSId }).$promise.then(data => {
                        if (!$scope.abertoModal || abrir) {
                            data.forEach(element => {
                                element.CampoLayoutVisualSMS = element.Nome;
                                element.CampoLayoutEPBX = "";
                            });
                            $scope.regraEditada.CampanhaRegraVisualSMS = {
                                CampanhaVisualSMSId: $scope.regraEditada.CampanhaIntegracaoVisualSMSId, CampanhaRegraVisualSMSItems: data
                            };
                            $scope.getLayoutCampanhaEPBX();

                            if (!$scope.layoutCampanhaEPBX.length > 0) {
                                $scope.regraEditada.CampanhaRegraVisualSMS.CampanhaRegraVisualSMSItems.forEach(campo => {
                                    campo.IsTextoFixo = true;
                                });
                            }

                            $scope.campanhasVisualSMS = data;
                            $scope.abertoModal = true;
                        }
                    });
                }
            };

            $scope.getLayoutCampanhaEPBX = function () {
                if (!$scope.isNew) {
                    CampanhaResource.GetLayoutItems({
                        campanhaId: campanha.CampanhaId
                    }).$promise.then(data => {
                        $scope.layoutCampanhaEPBX = data;
                    });
                }
            };

            $scope.isVisibleCampo = function (campo) {
                let isVisible = true;
                switch (campo) {
                    case "ArquivoCallBack":
                    case "VOX_URA_CALLBACK":
                    case "PercentRetenPre":
                    case "FLAG_PREDECTIVE_ON":
                    case "FLAG_RETER_CALL_TMA_ON":
                    case "FLAG_PREDECTIVE_TMA_ON":
                        isVisible = false;
                        break;
                    case "QtasLigRamal":
                        isVisible = campanha.TipoDiscagemId == 2 || campanha.CampanhaTemplateId != 4;
                        break;
                    case "LigPorCp":
                        isVisible = campanha.TipoDiscagemId == 1 || campanha.CampanhaTemplateId != 4;
                        break;
                    default:
                        isVisible = true;
                }
                return isVisible;
            };
            $scope.isEnablePreditivo = function (campo) {
                let isEnable = false;
                if (campo.CampanhaCampoId == 16) {
                    isEnable = true;
                } else {
                    if ($scope.campanhaCampoPreditivo) {
                        let element = _.find($scope.campanhaCampoPreditivo, (el) => {
                            return el.CampanhaCampoId == 16;
                        });

                        element ? isEnable = element.Checked || element.Valor == "1" : isEnable = false;
                    }
                }

                if (!isEnable) {
                    if ($scope.campanhaCampoPreditivo) {
                        angular.forEach($scope.campanhaCampoPreditivo, (campo) => {
                            campo.Valor = null;
                            campo.Alterado = true;
                        });
                    }
                }
                return isEnable;
            };

            $scope.onCarteiraAlterado = function (carteiraId) {
                if (carteiraId) {
                    $scope.grupos = $scope.todosGrupos.filter(x => x.CarteiraId == carteiraId);
                    getUras();
                    getUrasPesquisa();
                    getRamaisList();
                }
            }

            function loadTipoDiscagem(id) {

                if (id == 3) {
                    $scope.tipoDiscagem = [
                        { Id: 1, Descricao: $translate.instant('telaCampanhaEdit.horizontal') },
                        { Id: 2, Descricao: $translate.instant('telaCampanhaEdit.vertical') }
                    ];
                }
                else {
                    $scope.tipoDiscagem = [
                        { Id: 1, Descricao: $translate.instant('telaCampanhaEdit.horizontal') },
                        { Id: 2, Descricao: $translate.instant('telaCampanhaEdit.vertical') },
                        { Id: 3, Descricao: $translate.instant('telaCampanhaEdit.preview') }
                    ];
                }

            }
            loadTipoDiscagem($scope.campanha.RedirecionaTipoId);

            function limparCamposTransferencia(){
                $scope.campanha.RamalId = null;
                $scope.campanha.GrupoId = null;
            }

            $scope.onRedirecionaTipoAlterado = function () {
                limparCamposTransferencia();
                loadTipoDiscagem($scope.campanha.RedirecionaTipoId);

                if ($scope.campanha.CampanhaTemplateId == 1) {
                    if ($scope.campanha.RedirecionaTipoId != 3) {
                        $scope.campanha.CampanhaConfiguracao = $scope.campanha.CampanhaConfiguracao.filter(x => x.Campo != "RamalOperacao");
                    } else {
                        const campoConfiguracao = $scope.campanha.CampanhaConfiguracao.find(x => x.Campo == "RamalOperacao");
                        if (!campoConfiguracao) {
                            CampanhaTemplateResource.campanhaTemplateCampo({
                                campanhaTemplateId: 1
                            }).$promise.then(data => {
                                const campo = _.findWhere(data, { Campo: 'RamalOperacao' });
                                if (campo) {
                                    campo.Editavel = true;
                                    campo.Obrigatorio = false;
                                    $scope.campanha.CampanhaConfiguracao.push(campo);
                                }

                                $scope.carregarItensDosCampos();
                            });
                        }
                    }
                }

                switch ($scope.campanha.RedirecionaTipoId) {
                    case 2:
                        if ($scope.RamalAnterior) {
                            $scope.campanha.GrupoId = $scope.RamalAnterior;
                        }
                        if ($scope.campanha.RamalId) {
                            $scope.RamalAnterior = $scope.campanha.RamalId;
                        }
                        $scope.campanha.RamalId = null;
                        break;
                    case 3:
                        getUras();
                        break;
                    case 5:
                        getUrasPesquisa();
                        break;
                }
            };

            $scope.onRotaInteligenteAlterado = function () {
                if ($scope.rotasAntigas.length > 0) {
                    $scope.campanha.CampanhaRota = $scope.rotasAntigas;
                    $scope.rotasAntigas = [];
                } else {
                    $scope.rotasAntigas = angular.copy(
                        $scope.campanha.CampanhaRota
                    );
                    if ($scope.campanha.RotaInteligente) {
                        $scope.campanha.CampanhaRota = [];
                        $scope.campanha.CampanhaRota.push({ RegraDiscagemId: 0 });
                    } else {
                        $scope.campanha.CampanhaRota = [];
                        let rotaSelecionadaId = 0;
                        if ($scope.rotas.length >= 1) {
                            rotaSelecionadaId = $scope.rotas[0].RotaId;
                        }
                        $scope.classes.forEach((element) => {
                            $scope.campanha.CampanhaRota.push({
                                ClasseNome: element.Nome,
                                ClasseId: element.ClasseId,
                                RotaId: rotaSelecionadaId
                            });
                        });
                    }
                }
            };

            $scope.getCamposConfiguracao = function () {
                return $scope.campanha.CampanhaConfiguracao;
            };

            $scope.setCamposHigienizacao = function () {
                CampanhaTemplateResource.campanhaTemplateCampo({
                    campanhaTemplateId: 3
                }).$promise.then(data => {
                    _.each(data, item => {
                        item.Higienizacao = true;
                        $scope.campanha.CampanhaConfiguracao.push(item);
                    });
                    $scope.carregarItensDosCampos();
                });
            };

            $scope.onHigienizacao = function () {
                let campos;
                if ($scope.campanha.CampanhaTipoId == 3) {
                    campos = _.filter($scope.campanha.CampanhaConfiguracao, (el) => {
                        return (el.Higienizacao == true && el.Alias != "Tipo de Higienização");
                    });
                } else {
                    campos = _.where($scope.campanha.CampanhaConfiguracao, { Higienizacao: true });
                }

                if ($scope.campanha.PreMetralhadora && campos.length == 0) {
                    $scope.setCamposHigienizacao();
                }
            };

            $scope.onHabilitarHigienizacao = function () {
                if (!$scope.campanha.HabilitarHigienizacao) {
                    $scope.campanha.HabilitarHigienizacao = true;
                    ModalService.confirmMessage('telaCampanhaEdit.desejaVoltarOMailing', null, () => {
                        $scope.campanha.CampanhaHigienizacaoId = null;
                        $scope.campanha.HabilitarHigienizacao = false;
                    });
                } else {
                    getCampanhasHigienizacao();
                }
                $scope.forms.formPropriedade.$setDirty();
            };

            $scope.carregarItensDosCampos = function () {
                let CAMPO_TIPO_LISTA = 1;
                //Atribui o valor padrao
                angular.forEach($scope.campanha.CampanhaConfiguracao, value => {
                    let isFonte = false;
                    let comando, nome, valor;

                    if ($scope.isNew) {
                        value.Valor = value.ValorPadrao;
                    }
                    if (value.CampanhaConfiguracaoId) {
                        isFonte = value.FonteId ? true : false;
                        if (isFonte) {
                            comando = value.FonteComando;
                            nome = value.FonteNome;
                            valor = value.FonteValor;
                        }
                    } else {
                        isFonte = value.Fonte ? true : false;
                        if (isFonte) {
                            comando = value.Fonte.Comando;
                            nome = value.Fonte.Nome;
                            valor = value.Fonte.Valor;
                        }
                    }

                    if (isFonte) {
                        $http.get(Config.getUrl(comando)).then(response => {
                            value.Items = [];
                            angular.forEach(response.data, f => {
                                value.Items.push({
                                    Alias: f[nome],
                                    Valor: f[valor]
                                });
                            });
                        });
                    } else {
                        if (value.CampanhaCampoTipoId == CAMPO_TIPO_LISTA) {
                            CampanhaCampoResource.getItens({
                                CampanhaCampoId: value.CampanhaCampoId
                            }).$promise.then(data => {
                                value.Items = data;
                            });
                        }
                    }
                });
            };

            $scope.carregarCamposPreditivo = function () {
                $scope.campanhaCampoPreditivo = [];
                if ($scope.campanha.CampanhaConfiguracao.length) {
                    $scope.campanha.CampanhaConfiguracao.forEach(element => {
                        switch (element.CampanhaCampoId) {
                            case 13:
                            case 16:
                            case 17:
                            case 18:
                                $scope.campanhaCampoPreditivo.push(element);
                                break;
                            default:
                                break;
                        }
                    });
                }
            };

            $scope.onTemplateCampanhaAlterado = function () {
                $scope.campanhaCampoPreditivo = [];
                if ($scope.campanha.CampanhaTemplateId) {
                    let campanhaTemplateId = $scope.campanha ? $scope.campanha.CampanhaTemplateId : 0;

                    CampanhaTemplateResource.campanhaTemplateCampo({
                        campanhaTemplateId: campanhaTemplateId
                    }).$promise.then(data => {
                        if ($scope.isNew) {
                            if ($scope.campanha.CampanhaTemplateId == 1) {
                                angular.forEach(data, function (item, i) {
                                    if (item.Campo == "RamalOperacao") {
                                        item.Obrigatorio = false;
                                    }
                                }
                                );
                            }
                            angular.copy(data, $scope.campanha.CampanhaConfiguracao);
                            $scope.changeCampanhaCampoList(false, '', true);
                            $scope.changeCampanhaCampoBoolean(false, '', true);
                        }
                        $scope.carregarItensDosCampos();
                        $scope.carregarCamposPreditivo();
                    });
                } else {
                    $scope.campanha.CampanhaConfiguracao = [];
                }
            };

            $scope.onTipoCampanhaAlterado = function () {
                if ($scope.campanha && $scope.campanha.CampanhaTipoId > 0) {
                    $scope.templates = _.where(campanhatemplates, {
                        CampanhaTipoId: $scope.campanha.CampanhaTipoId
                    });
                    if ($scope.campanhatipos) {
                        $scope.campanha.CampanhaTipo = $scope.campanhatipos.find(tipos => tipos.Id == $scope.campanha.CampanhaTipoId);
                    }
                    $scope.grupos = _.filter(grupos, el => {
                        return el.GrupoTipoId == 1;
                    });
                    $scope.tiposDiscagem = tiposDiscagem;

                    $scope.listRamalTipo = [{ TipoId: 2, Descricao: $translate.instant('model.grupo') }];

                    if ($scope.campanha.CampanhaTipoId == 1) {
                        $scope.listRamalTipo.push({ TipoId: 3, Descricao: $translate.instant('model.ura') });
                        $scope.listRamalTipo.push({ TipoId: 5, Descricao: $translate.instant('model.uraPesquisa') });;
                    } else if ($scope.campanha.CampanhaTipoId == 2) {
                        $scope.listRamalTipo.push({ TipoId: 3, Descricao: $translate.instant('model.ura') });
                    }
                    else if ($scope.campanha.CampanhaTipoId == 3) {
                        $scope.campanha.PreMetralhadora = true;
                        $scope.campanha.TipoDiscagemId = null;
                        $scope.rotasList = _.filter(rotas, el => {
                            return el.RotaTipoId == 3
                        });
                    } else if ($scope.campanha.CampanhaTipoId == 4) {
                        $scope.campanha.PreMetralhadora = false;
                        $scope.rotasList = _.filter(rotas, el => {
                            return el.RotaTipoId == 4
                        });
                        if (!$scope.isNew && $scope.campanha.CampanhaConfiguracao != null) {
                            let confRamal = _.find($scope.campanha.CampanhaConfiguracao, conf => {
                                return (conf.CampanhaCampoId == 43 && conf.Valor != null && conf.Valor != "");
                            });
                            confRamal != null ? $scope.campanha.TipoDiscagemId = 1 : $scope.campanha.TipoDiscagemId = 2;
                        } else {
                            $scope.campanha.TipoDiscagemId = 1;
                        }

                        $scope.grupos = _.filter(grupos, el => {
                            return el.GrupoTipoId == 3;
                        });

                        $scope.ramais = _.filter(ramais, el => {
                            return el.RamalTipoId == 6;
                        });

                        $scope.tiposDiscagem = _.filter($scope.tiposDiscagem, el => {
                            return el.TipoDiscagemId != 1;
                        });

                        if ($scope.isNew) {
                            campanha.CallAnnounce = true;
                            campanha.habilitaAudioEspera = true;
                        }
                    } else {
                        if (!$scope.campanha.PreMetralhadora) {
                            $scope.campanha.PreMetralhadora = false;
                        }
                    }
                } else {
                    $scope.templates = [];
                    $scope.campanha.GrupoId = null;
                    $scope.grupos = _.filter(grupos, el => {
                        return el.GrupoTipoId == 1;
                    });
                }

                if ($scope.templates.length == 1) {
                    $scope.campanha.CampanhaTemplateId = $scope.templates[0].CampanhaTemplateId;
                }
                $scope.onTemplateCampanhaAlterado();
            };

            $scope.setTipo = function () {
                if ($location.path().indexOf("padrao") >= 0) {
                    if (!$scope.isNew && $scope.campanha.CampanhaTipoId != 1) {
                        NotifyService.showError(null, 'telaCampanhaEdit.campanhaNaoEPadrao');
                        $state.go("main.campanha.list");
                    }
                    $scope.campanha.CampanhaTipoId = 1;
                } else if ($location.path().indexOf("callback") >= 0) {
                    if (!$scope.isNew && $scope.campanha.CampanhaTipoId != 2) {
                        NotifyService.showError(null, 'telaCampanhaEdit.campanhaNaoECallback');
                        $state.go("main.campanha.list");
                    }
                    $scope.campanha.CampanhaTipoId = 2;
                } else if ($location.path().indexOf("higienizacao") >= 0) {
                    if (!$scope.isNew && $scope.campanha.CampanhaTipoId != 3) {
                        NotifyService.showError(null, 'telaCampanhaEdit.campanhaNaoEHigienizacao');
                        $state.go("main.campanha.list");
                    }
                    $scope.campanha.CampanhaTipoId = 3;
                } else if ($location.path().indexOf("talkbot") >= 0) {
                    if (!$scope.isNew && $scope.campanha.CampanhaTipoId != 4) {
                        NotifyService.showError(null, 'telaCampanhaEdit.campanhaNaoETalkbot');
                        $state.go("main.campanha.list");
                    }
                    $scope.campanha.CampanhaTipoId = 4;
                }
                $scope.onTipoCampanhaAlterado();
            };

            $scope.onTipoDiscagemTalkbotAlterado = function () {
                if ($scope.campanha.TipoDiscagemId != 1) {
                    let confFixo = _.find($scope.campanha.CampanhaConfiguracao, conf => {
                        return conf.CampanhaCampoId == 43;
                    });
                    if (confFixo != null) {
                        confFixo.Valor = null;
                    }
                }

                if ($scope.campanha.TipoDiscagemId != 2) {
                    let confRamal = _.find($scope.campanha.CampanhaConfiguracao, conf => {
                        return conf.CampanhaCampoId == 5;
                    });
                    if (confRamal != null) {
                        confRamal.Valor = null;
                    }
                }
            };

            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3>${descricao}`);
            };

            $scope.abrirRegraModal = function () {
                if ($scope.campanha.CampanhaTipoId == 3) {
                    $scope.campanhaDiscagemStatus = _.where(campanhaDiscagemStatus, { PermiteRediscagemHigienizacao: true });
                } else {
                    $scope.campanhaDiscagemStatus = _.where(campanhaDiscagemStatus, { PermiteRegra: true });
                }

                $scope.forms.formNovaRegra.$submitted == false;
                $scope.regraEditada = { Prioridade: 2 };

                if (!$scope.isNew) {
                    $scope.regraEditada.CampanhaId = $scope.campanha ? $scope.campanha.CampanhaId : 0;
                }

                $scope.acoes = [];
                $scope.regraAdicionada = false;

                ModalService.isHidden("modal_regra", () => {
                    $timeout(() => {
                        $scope.forms.formNovaRegra.$setPristine();
                        $scope.forms.formNovaRegra.$setUntouched();
                    });
                });
            };

            $scope.esconderRegraModal = function () {
                ModalService.isActive("modal_regra", () => {
                    $scope.abertoModal = false;
                });
            };

            $scope.editarRegra = function (regra, index) {
                $scope.regraEditada = regra;
                $scope.abertoModal = true;
                $scope.onDiscagemStatusAlterado();
                $scope.regraEditada.CampanhaRegraAcaoId = regra.CampanhaRegraAcaoId;
                if (regra.CampanhaRegraVisualSMS) {
                    $scope.onAcaoAlterado();
                    $scope.regraEditada.CampanhaIntegracaoVisualSMSId = regra.CampanhaRegraVisualSMS.CampanhaVisualSMSId;
                    $scope.regraEditada.CampanhaRegraVisualSMS = regra.CampanhaRegraVisualSMS;
                    $scope.onCampanhaVisualSMSAlterado(false);
                    $scope.getLayoutCampanhaEPBX();
                }
                $scope.regraAdicionada = true;
                $scope.regraIndex = index;

                ModalService.isHidden("modal_regra", () => {
                    $timeout(() => {
                        $scope.forms.formNovaRegra.$setPristine();
                        $scope.forms.formNovaRegra.$setUntouched();
                    });
                });
            };

            $scope.removerRegra = function (regra) {
                ModalService.confirmDelete(() => {
                    $scope.campanha.CampanhaRegra = _.without($scope.campanha.CampanhaRegra, regra);
                    $scope.forms.formRegra.$setDirty();
                });
            };

            $scope.exibirDetalheQuantidade = function () {
                if ($scope.campanha.CampanhaHigienizacaoId) {
                    $scope.campanhasVinculadasHigienizacaoVisivel = false;

                    CampanhaHigienizacaoResource.getQuantidadeCampanhasVinculadasHigienizacao({
                        campanhaHigienizacaoId: $scope.campanha.CampanhaHigienizacaoId
                    }).$promise.then(data => {
                        $scope.campanhasVinculadasHigienizacaoVisivel = false;
                        if (data.length > 0) {
                            $scope.qtdCampanhasVinculadasHigienizacao = data.length;
                            $scope.campanhasVinculadasHigienizacao = data;
                        } else {
                            $scope.qtdCampanhasVinculadasHigienizacao = undefined;
                            $scope.campanhasVinculadasHigienizacao = [];
                        }
                    }).catch(error => {
                        $scope.configuracaoList = [];
                        NotifyService.showError(error);
                    });
                }
            };

            $scope.campanhasVinculadasHigienizacaoToggle = function () {
                if ($scope.campanhasVinculadasHigienizacaoVisivel == true) {
                    $scope.campanhasVinculadasHigienizacaoVisivel = false;
                } else {
                    $scope.campanhasVinculadasHigienizacaoVisivel = true;
                }
            };

            $scope.adicionarRegra = function (form) {
                if (form.$invalid) {
                    return NotifyService.showError(null, 'telaCampanhaEdit.osDadosDeRegraNaoForamInformados');
                }

                $scope.regraEditada.CampanhaRegraAcaoDescricao = "";
                $scope.regraEditada.CampanhaDiscagemStatusDescricao = "";
                $scope.regraEditada.CampanhaTelefoneTipoDescricao = "";

                if ($scope.regraEditada.CampanhaRegraAcaoId) {
                    let acao = _.find($scope.acoes, el => {
                        return (el.CampanhaRegraAcaoId == $scope.regraEditada.CampanhaRegraAcaoId);
                    });
                    $scope.regraEditada.CampanhaRegraAcaoDescricao = acao.Descricao;
                }
                let status = _.find($scope.campanhaDiscagemStatus, el => {
                    return (el.CampanhaDiscagemStatusId == $scope.regraEditada.CampanhaDiscagemStatusId);
                });
                $scope.regraEditada.CampanhaDiscagemStatusDescricao =
                    status.Descricao;

                if (!$scope.campanha.CampanhaRegra)
                    $scope.campanha.CampanhaRegra = [];
                if ($scope.regraAdicionada == false) {
                    let objStatus = _.find($scope.campanha.CampanhaRegra, el => {
                        return (el.CampanhaDiscagemStatusId == $scope.regraEditada.CampanhaDiscagemStatusId);
                    });

                    if (objStatus === undefined || objStatus === null) {
                        if ($scope.regraEditada.CampanhaRegraAcaoId == 0) {
                            $scope.regraEditada.CampanhaRegraAcaoId = null;
                        }
                        $scope.campanha.CampanhaRegra.push($scope.regraEditada);
                    } else {
                        return NotifyService.showError(null, 'telaCampanhaEdit.statusJaConfigurado');
                    }
                } else {
                    if ($scope.regraIndex) {
                        $scope.campanha.CampanhaRegra[$scope.regraIndex] = $scope.regraEditada;
                    }
                }
                $scope.regraIndex = null;
                $scope.regraEditada = {};
                $scope.esconderRegraModal();
                $scope.forms.formRegra.$setDirty();
            };

            $scope.checkTodosHorarios = function (event) {
                angular.forEach($scope.campanha.CampanhaHorario, horario => {
                    horario.Ativo = event;
                });
            };

            $scope.configuraPreditivo = function () {
                if ($scope.campanha.CampanhaConfiguracao) {
                    angular.forEach($scope.campanha.CampanhaConfiguracao, value => {
                        switch (value.CampanhaCampoId) {
                            case 13:
                            case 16:
                            case 17:
                            case 18:
                                value.Valor = _.find($scope.campanhaCampoPreditivo, el => {
                                    return (el.CampanhaCampoId == value.CampanhaCampoId);
                                }).Valor;
                                value.Alterado = true;
                                break;
                            default:
                                break;
                        }
                    });
                }
            };

            $scope.onPreditivoAlterado = function (campo) {
                campo.Valor = campo.Checked ? '1' : '0';
                campo.Alterado = true;
                // Se for "habilitar preditivo" e espera estiver habilidado
                if (campo.CampanhaCampoId == 16 && !campo.Checked && $scope.campanha.habilitaAudioEspera == true) {
                    ModalService.alert('telaCampanhaEdit.audioDeEsperaNaoFunciona');
                }
            }

            $scope.salvar = function (form) {
                if (!$scope.campanha.IgnorarContactados)
                    $scope.campanha.IgnorarContactadosGeral = false;

                if (!$scope.campanha.IgnorarClienteDuplicado)
                    $scope.campanha.IgnorarClienteDuplicadoGeral = false;

                let quantidadeInvalidos;
                let lastStep = false;
                if ($scope.campanha.AgendamentoLimpeza != undefined && !$scope.campanha.AgendamentoLimpeza && $scope.campanha.CampanhaLimpezaPersonalizada.length > 0) {
                    $scope.campanha.CampanhaLimpezaPersonalizada[0].Ativo = false;
                }
                if ($scope.campanha.CampanhaTipoId == 3) {
                    lastStep = form.$name == "forms.formPropriedade" ? true : false;
                } else {
                    lastStep = form.$name == "forms.formRegra" ? true : false;
                }
                if (lastStep && $scope.isNew) {
                    $scope.forms.formRegra.$setDirty();
                }

                if (!form.$dirty && lastStep) {
                    $state.go("main.campanha.list");
                }

                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();
                }

                $scope.erroCallAnnounce = false;
                $scope.erroAudioEspera = false;

                if (form.$name == "forms.formPropriedade" && $scope.campanha.CallAnnounce == true && !($scope.campanha.CallAnnounceAudioId > 0 || $scope.campanha.CallAnnounceClienteId > 0)) {
                    if (!$scope.campanha.CallAnnounceRondomico) {
                        form.$setSubmitted();
                        $scope.erroCallAnnounce = true;
                        return NotifyService.showInvalid();
                    }
                }
                if (form.$name == "forms.formPropriedade" && $scope.campanha.habilitaAudioEspera == true && !($scope.campanha.AudioEsperaId > 0)) {
                    form.$setSubmitted();
                    $scope.erroAudioEspera = true;
                    return NotifyService.showInvalid();
                }
                if ($scope.campanha.AgendamentoParalelo == true) {
                    $scope.campanha.DiscagemVertical = false;
                }
                if ($scope.campanha.PermiteControleDiscagem == true) {

                    const bloqueioCliente = ($scope.campanha.CampanhaControleDiscagemCliente || []).filter(c => c.Ativo).length > 0 ? true : false;
                    const bloqueioTelefone = ($scope.campanha.CampanhaControleDiscagemTelefone || []).filter(c => c.Ativo).length > 0 ? true : false;

                    if (!bloqueioCliente && !bloqueioTelefone) {
                        $scope.forms.formRegra.$setDirty();
                        campanha.PermiteControleDiscagem = false;
                    }
                }

                if ($scope.campanha.RedirecionaTipoId == 3 && $scope.campanha.CampanhaTemplateId == 1) {

                    const campoConfiguracao = $scope.campanha.CampanhaConfiguracao.find(x => x.Campo == "RamalOperacao");

                    if (campoConfiguracao != null) {
                        var grupo = _.filter($scope.todosGrupos, (item) => {
                            return item.RamalNumero == campoConfiguracao.Valor;
                        });

                        if (grupo.length > 0) {
                            $scope.campanha.GrupoId = grupo[0].GrupoId;
                        }
                    }
                }

                if ($scope.isNew) {
                    if (lastStep) {
                        $scope.configuraPreditivo();

                        quantidadeInvalidos = $scope.campanha.CampanhaHorario.filter((element) => (!element.HoraInicio || !element.HoraTermino)).length;

                        if (quantidadeInvalidos > 0) {
                            return NotifyService.showError(null, 'validacao.existemHorariosInvalidos', { Quantidade: quantidadeInvalidos })
                        }



                        if ($scope.salvando != true) {
                            $scope.salvando = true;
                            CampanhaResource.save($scope.campanha)
                                .$promise.then(() => {
                                    NotifyService.showRegistroSalvo();
                                    $state.go("main.campanha.list");
                                    $scope.salvando = false;
                                })
                                .catch(error => {
                                    var mensagem = error && error.data ? (error.data.Message || error.data.message || '') : '';
                                    if (error && error.status === 400 && mensagem.indexOf('limite de quantidade') > -1) {
                                        ModalService.alert('telaCampanhaEdit.limiteCampanhaAtingido');
                                    } else {
                                        NotifyService.showError(error);
                                    }
                                    $scope.salvando = false;
                                });
                        }
                    }
                } else if (form.$dirty) {
                    if ($scope.campanha.CampanhaStatusId == 3) {
                        $scope.campanha.PendenteAcao = true;
                    }

                    if (form.$name == "forms.formHorarios") {
                        $scope.campanha.PendenteAcao = false;
                    } else if (form.$name == "forms.formPropriedade") {
                        $scope.configuraPreditivo();
                    }

                    // Verificar se todos os horários são validos antes de salvar
                    quantidadeInvalidos = $scope.campanha.CampanhaHorario.filter((element) => (!element.HoraInicio || !element.HoraTermino)).length;

                    if (quantidadeInvalidos > 0) {
                        return NotifyService.showError(null, 'validacao.existemHorariosInvalidos', { Quantidade: quantidadeInvalidos })
                    }

                    if (!$scope.validarJornada()) {
                        return false;
                    }

                    if ($scope.salvando != true) {

                        $scope.salvando = true;

                        CampanhaResource.update($scope.campanha)
                            .$promise.then((data) => {
                                NotifyService.showRegistroSalvo();
                                form.$setPristine();
                                $scope.rotasAntigas = [];
                                $scope.campanha.CampanhaControleDiscagemCliente = data.CampanhaControleDiscagemCliente;
                            })
                            .catch(NotifyService.showError)
                            .finally(() => $scope.salvando = false);
                    }
                }
            };

            $scope.onGrupoAlterado = function () {
                if ($scope.campanha.GrupoId > 0) {
                    $scope.grupoSelecionado = _.find($scope.grupos, el => {
                        return el.GrupoId == $scope.campanha.GrupoId;
                    });
                    GrupoResource.get({ GrupoId: $scope.campanha.GrupoId }).$promise.then(res => {
                        $scope.audioRetencao = res.RetencaoAudio;
                    });

                    $scope.verificaBloqueioLeiGrupo();
                }
            };

            $scope.popularLimpezaPersonalizada = function () {
                if ($scope.campanha.CampanhaLimpezaPersonalizada != null) {
                    if ($scope.campanha.CampanhaLimpezaPersonalizada.length == 1) {
                        $scope.LimpezaMailing = {};
                        angular.copy($scope.campanha.CampanhaLimpezaPersonalizada[0], $scope.LimpezaMailing);
                    }
                } else {
                    $scope.LimpezaMailing.ApagarRediscagem = true;
                    $scope.LimpezaMailing.ApagarMailingLivre = true;
                    $scope.LimpezaMailing.ApagarAgendamento = true;
                    $scope.LimpezaMailing.Segunda = true;
                    $scope.LimpezaMailing.Terca = true;
                    $scope.LimpezaMailing.Quarta = true;
                    $scope.LimpezaMailing.Quinta = true;
                    $scope.LimpezaMailing.Sexta = true;
                    $scope.LimpezaMailing.Sabado = false;
                    $scope.LimpezaMailing.Domingo = false;
                    $scope.LimpezaMailing.Horario = "23:00";
                }
            };

            $scope.exibirLimpezaPersonalizada = function (ativo) {
                if (ativo) {
                    $scope.popularLimpezaPersonalizada();
                    $scope.exibirMensagemDiaSemana = false;
                    ModalService.openModal("modal_limpezamailing");
                } else {
                    if ($scope.associadoTemplateLimpeza) {
                        ModalService.alert(
                            `<h3>${$translate.instant('telaCampanhaEdit.aviso')}</h3>
                            ${$translate.instant('telaCampanhaEdit.avisoTemplateLimpeza', { template: $scope.templateLimpeza.CampanhaTemplateLimpeza.Nome, templateLimpezaId: $scope.templateLimpeza.CampanhaTemplateLimpeza.Id })}`
                        );
                        $scope.campanha.AgendamentoLimpeza = true;
                    }
                }
            };

            $scope.getAvisoAssociacaoTemplateLimpeza = function () {
                var msg = '';
                if ($scope.associadoTemplateLimpeza) {
                    msg = `${$translate.instant('telaCampanhaEdit.avisoTemplateLimpezaModal', { template: $scope.templateLimpeza.CampanhaTemplateLimpeza.Nome, templateLimpezaId: $scope.templateLimpeza.CampanhaTemplateLimpeza.Id })}`;
                }
                return msg;
            }

            $scope.confirmarCampanhaLimpeza = function () {
                if($scope.exibirMensagemDiaSemana || $scope.exibirMensagemTipoLimpeza){
                    NotifyService.showError(null, 'modalLimpezaMailing.validacaoFalhou');
                    ModalService.closeModal("modal_limpezamailing");
                    return;
                }

                $scope.exibirMensagemDiaSemana = false;
                $scope.exibirMensagemTipoLimpeza = false;
                $scope.forms.formDetalhes.$dirty = true;
                $scope.forms.formRegraLimpezaCampanha.$dirty = false;

                if ($scope.LimpezaMailing.Horario && typeof $scope.LimpezaMailing.Horario != "string") {
                    $scope.LimpezaMailing.Horario = new moment($scope.LimpezaMailing.Horario).format("HH:mm");
                }

                if ($scope.campanha.CampanhaLimpezaPersonalizada == null) {
                    $scope.campanha.CampanhaLimpezaPersonalizada = [];
                    $scope.campanha.CampanhaLimpezaPersonalizada.push({
                        CampanhaId: $scope.campanha.CampanhaId,
                        ApagarRediscagem: $scope.LimpezaMailing.ApagarRediscagem,
                        ApagarMailingLivre: $scope.LimpezaMailing.ApagarMailingLivre,
                        ApagarAgendamento: $scope.LimpezaMailing.ApagarAgendamento,
                        Segunda: $scope.LimpezaMailing.Segunda,
                        Terca: $scope.LimpezaMailing.Terca,
                        Quarta: $scope.LimpezaMailing.Quarta,
                        Quinta: $scope.LimpezaMailing.Quinta,
                        Sexta: $scope.LimpezaMailing.Sexta,
                        Sabado: $scope.LimpezaMailing.Sabado,
                        Domingo: $scope.LimpezaMailing.Domingo,
                        Horario: $scope.LimpezaMailing.Horario,
                        DataCadastro: moment().format(),
                        UsuarioCadastro: $scope.LimpezaMailing.UsuarioCadastro,
                        Ativo: true
                    });
                } else {
                    $scope.campanha.CampanhaLimpezaPersonalizada[0] = $scope.LimpezaMailing;
                    $scope.campanha.CampanhaLimpezaPersonalizada[0].UsuarioAlteracao = $scope.LimpezaMailing.UsuarioCadastro;
                    $scope.campanha.CampanhaLimpezaPersonalizada[0].DataAlteracao = moment().format();
                    $scope.campanha.CampanhaLimpezaPersonalizada[0].Ativo = true;
                }
                $scope.forms.formRegraLimpezaCampanha.$setPristine();
                ModalService.closeModal("modal_limpezamailing");
            };

            $scope.varificaTipoLimpeza = function(){
                if(!$scope.LimpezaMailing.ApagarRediscagem && !$scope.LimpezaMailing.ApagarMailingLivre && !$scope.LimpezaMailing.ApagarAgendamento)
                    return($scope.exibirMensagemTipoLimpeza = true)

                return($scope.exibirMensagemTipoLimpeza = false)
            }

            $scope.verificaDias = function () {
                if (!$scope.LimpezaMailing.Segunda && !$scope.LimpezaMailing.Terca && !$scope.LimpezaMailing.Quarta && !$scope.LimpezaMailing.Quinta &&
                    !$scope.LimpezaMailing.Sexta && !$scope.LimpezaMailing.Sabado && !$scope.LimpezaMailing.Domingo) {
                    return ($scope.exibirMensagemDiaSemana = true);
                }

                return ($scope.exibirMensagemDiaSemana = false);
            };

            $scope.fecharModalLimpeza = function () {
                if ($scope.forms.formRegraLimpezaCampanha.$dirty || $scope.campanha.CampanhaLimpezaPersonalizada.length <= 0) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formRegraLimpezaCampanha.$setPristine();
                        ModalService.closeModal("modal_limpezamailing");
                        if ($scope.campanha.CampanhaLimpezaPersonalizada.length <= 0) {
                            campanha.AgendamentoLimpeza = false;
                        }
                    });
                } else {
                    ModalService.closeModal("modal_limpezamailing");
                }
            };

            $scope.abrirBlacklistModal = function () {
                ModalService.isHidden("modal_blacklist", () => {
                    $scope.onChangeCarteira();
                    angular.copy($scope.campanha.BlacklistsAdicionadas, $scope.BlacklistsAdicionadas);
                    angular.copy($scope.campanha.BlacklistsAdicionadas, $scope.BlacklistsAdicionadasCopia);
                    angular.copy($scope.campanha.BlacklistsNaoAdicionadas, $scope.BlacklistsNaoAdicionadas);
                    angular.copy($scope.campanha.BlacklistsNaoAdicionadas, $scope.BlacklistsNaoAdicionadasCopia);
                });
            };

            $scope.fecharBlacklistModal = function () {
                if ($scope.modalBlacklistAlterada) {
                    ModalService.confirmDescartar(() => {
                        ModalService.closeModal("modal_blacklist");
                        $scope.modalBlacklistAlterada = false;
                    });
                } else {
                    ModalService.closeModal("modal_blacklist");
                    $scope.modalBlacklistAlterada = false;
                }
            };

            $scope.adicionarBlacklist = function () {
                let BlacklistsSelecionadas = _.where($scope.BlacklistsNaoAdicionadas, { Selecionada: true });
                angular.forEach(BlacklistsSelecionadas, item => {
                    item.Selecionada = false;
                    $scope.BlacklistsAdicionadas.push(item);
                    $scope.BlacklistsNaoAdicionadas.splice($scope.BlacklistsNaoAdicionadas.indexOf(item), 1);
                });

                if (BlacklistsSelecionadas.length > 0) {
                    $scope.modalBlacklistAlterada = true;
                }
            };

            $scope.removerBlacklist = function () {
                let BlacklistsSelecionadas = _.where($scope.BlacklistsAdicionadas, { Selecionada: true });
                angular.forEach(BlacklistsSelecionadas, (item) => {
                    item.Selecionada = false;
                    $scope.BlacklistsNaoAdicionadas.push(item);
                    $scope.BlacklistsAdicionadas.splice($scope.BlacklistsAdicionadas.indexOf(item), 1);
                });

                if (BlacklistsSelecionadas.length > 0) {
                    $scope.modalBlacklistAlterada = true;
                }
            };

            $scope.selecionarTodasAdicionadas = function (todosAdicionadas) {
                angular.forEach($scope.BlacklistsAdicionadas, item => {
                    todosAdicionadas ? item.Selecionada = true : item.Selecionada = false;
                });
            };

            $scope.selecionarTodasNaoAdicionadas = function (todosNaoAdicionadas) {
                angular.forEach($scope.BlacklistsNaoAdicionadas, item => {
                    todosNaoAdicionadas ? item.Selecionada = true : item.Selecionada = false;
                });
            };

            $scope.pesquisaBlacklists = function (searchBlacklists, length, lengthAdicionadas) {
                let lengthTotal = $scope.BlacklistsNaoAdicionadas.length;
                let lengthAdicionadasTotal = $scope.BlacklistsAdicionadas.length;
                if (searchBlacklists.length > 0) {
                    if (lengthTotal != length) {
                        $scope.limitBlacklists = lengthTotal;
                    }
                    if (lengthAdicionadasTotal != lengthAdicionadas) {
                        $scope.limitBlacklistsAdicionadas = lengthAdicionadasTotal;
                    }
                } else {
                    $scope.limitBlacklists = 5;
                    $scope.limitBlacklistsAdicionadas = 5;
                }
            };

            $scope.confirmarBlacklist = function () {
                angular.copy($scope.BlacklistsAdicionadas, $scope.campanha.BlacklistsAdicionadas);
                angular.copy($scope.BlacklistsAdicionadas, $scope.campanha.BlacklistsAdicionadasCopia);
                angular.copy($scope.BlacklistsNaoAdicionadas, $scope.campanha.BlacklistsNaoAdicionadas);
                angular.copy($scope.BlacklistsNaoAdicionadas, $scope.campanha.BlacklistsNaoAdicionadasCopia);
                ModalService.closeModal("modal_blacklist");
                $scope.modalBlacklistAlterada = false;
                $scope.forms.formRegra.$setDirty();
                $scope.onChangeCarteira();
            };

            $scope.alterarConsultaBlacklist = function () {
                if ($scope.campanha.ConsultaBlacklist) {
                    $scope.abrirBlacklistModal();
                }
            };

            $scope.tipoDeLimiteChange = function () {
                switch ($scope.campanha.TipoDeLimiteId) {
                    case 1: ///Telefone
                        $scope.campanha.MaximoDiscagem = 1;
                        $scope.campanha.PermiteControleDiscagem = true;
                        desabilitarControleDiscagemCliente();
                        ativarControleDiscagemTelefone();
                        popularControleDiscagem($scope.campanha.TipoDeLimiteId);
                        break;
                    case 2: ///Cliente
                        $scope.campanha.PermiteControleDiscagem = true;
                        desabilitarLimiteRediscagem();
                        desabilitarControleDiscagemTelefone();
                        ativarControleDiscagemCliente();
                        popularControleDiscagem($scope.campanha.TipoDeLimiteId);
                        break;
                    default:
                        $scope.campanha.PermiteControleDiscagem = false;
                        desabilitarLimiteRediscagem();
                        desabilitarControleDiscagemCliente();
                        desabilitarControleDiscagemTelefone();
                        break;
                }

                $scope.onChangeIgnoraStatus($scope.campanha.CampanhaId);
            }

            $scope.onDiscagemInternacionalAlterado = function () {
                if ($scope.campanha.DiscagemInternacional == true) {
                    $scope.campanha.RotaInteligente = false;
                    $scope.onRotaInteligenteAlterado();
                }
            }

            $scope.editarTemplateOrdenacao = function () {
                $state.go("main.templateOrdenacao.edit", { Id: $scope.campanha.CampanhaOrdemTemplate.Id })
            }

            $scope.verificaBloqueioLeiGrupo = function () {
                if ($scope.campanha.GrupoId > 0 && $scope.campanha.RamalId == null) {
                    GrupoResource.get({ GrupoId: $scope.campanha.GrupoId }).$promise.then((grupo) => {
                        if (grupo) {
                            if (!grupo.ConsultaBloqueioLei) {
                                $scope.infoBloqueioLei = $translate.instant('telaCampanhaEdit.bloqueioLeiDesabilitado');
                            }
                            else {
                                $scope.infoBloqueioLei = $translate.instant('telaCampanhaEdit.bloqueioLeiHabilitado');
                            }
                        }
                    });
                }
            }
            $scope.adicionarPeriodo = function (dia) {
                $scope.campanha.CampanhaHorario.push({
                    Dia: dia,
                    DiaSemana: $scope.diaSemana[dia],
                    Ativo: true
                });

                $scope.forms.formHorarios.$setDirty();
            }

            $scope.removerPeriodo = function (index) {
                ModalService.confirmDelete(() => {
                    delete $scope.campanha.CampanhaHorario[index];
                    $scope.campanha.CampanhaHorario.splice(index, 1);
                });

                $scope.forms.formHorarios.$setDirty();
            }

            $scope.existeHorarioInvalido = function () {
                let invalid = $scope.campanha.CampanhaHorario.find(horario => horario.Valido == false);
                $scope.isHorariosInvalidos = (invalid != null ? true : false);
            }

            $scope.ativarTodosPeriodos = function () {
                $scope.ativarTodos = !$scope.ativarTodos;

                $scope.campanha.CampanhaHorario.forEach(horario => {
                    if(horario.Dia != 0)
                        horario.Ativo = ($scope.ativarTodos ? true : false);
                });
            }

            $scope.onGrupoAlterado();
            $scope.onTipoCampanhaAlterado();
            $scope.setTipo();

            if ($scope.isNew) {
                $scope.campanha.CampanhaHorario = [];

                for (let name in $scope.diaSemana) {
                    if ($scope.diaSemana.hasOwnProperty(name)) {
                        if ($scope.campanha.CampanhaTipo) {
                            $scope.campanha.CampanhaHorario.push({
                                Dia: name,
                                DiaSemana: $scope.diaSemana[name],
                                HoraInicio: $scope.campanha.CampanhaTipo.JornadaInicio,
                                HoraTermino: $scope.campanha.CampanhaTipo.JornadaFim,
                                Ativo: false
                            });
                        } else {
                            $scope.campanha.CampanhaHorario.push({
                                Dia: name,
                                DiaSemana: $scope.diaSemana[name],
                                HoraInicio: new Date(16, 1, 1, 9, 0, 0, 0),
                                HoraTermino: new Date(16, 1, 1, 18, 0, 0, 0),
                                Ativo: false
                            });
                        }
                    }
                }

                if ($scope.campanha.CampanhaTipo) {
                    if ($scope.campanha.CampanhaTipo.JornadaObrigatoria) {
                        $scope.ativarTodosPeriodos();
                    }
                }
            }

            $scope.validarJornada = function () {
                if ($scope.campanha.CampanhaTipo) {
                    if ($scope.campanha.CampanhaTipo.JornadaObrigatoria) {
                        let exists = $scope.campanha.CampanhaHorario.find(horario => horario.Ativo);
                        if (exists == null) {
                            NotifyService.showError(null, 'telaCampanhaEdit.jornadaObrigatoria')
                            return false;
                        } else return true;
                    } else return true;
                } else return true;
            };

            $scope.onTemplateRegra = function () {
                if ($scope.campanha.CampanhaTemplateRegraId > 0) {
                    CampanhaTemplateRegraResource.get({ Id: $scope.campanha.CampanhaTemplateRegraId }).$promise.then(res => {
                        $scope.campanhaTemplateRegraAtual = res;
                    });
                }
            };

            $scope.onHabilitarTemplateRegra = function (habilitar) {
                if (!habilitar) {
                    $scope.habilitarTemplateRegra = false;
                    $scope.campanha.CampanhaTemplateRegraId = null;
                    $scope.campanha.CampanhaRegra = [];
                }
                else $scope.habilitarTemplateRegra = true;
            };

            $scope.getExibirTemplatePersonalizado = function () {
                var msg = '';
                if ($scope.associadoTemplatePeriodo) {
                    msg = `${$translate.instant('telaCampanhaEdit.avisoTemplatePeriodo', { TemplateCampanhaPeriodoId: $scope.templatePeriodo[0].TemplateCampanhaPeriodoId })}`;
                }
                return msg;
            }

            $scope.onExibirTemplatePersonalizado = function (ativo) {
                if (ativo) {
                    let list = []
                    $scope.templatePeriodo.forEach(periodo => {
                        $scope.campanha.CampanhaHorario.forEach((horario, index) => {
                            if (periodo.Dia == horario.Dia) {
                                list.push({
                                    Ativo: horario.ativo,
                                    CampanhaHorarioId: horario.CampanhaHorarioId,
                                    CampanhaId: horario.CampanhaId,
                                    Dia: periodo.Dia,
                                    HoraInicio: periodo.HoraInicio,
                                    HoraTermino: periodo.HoraTermino
                                })
                            }
                        })
                    });
                    $scope.campanha.CampanhaHorario.splice(0, $scope.campanha.CampanhaHorario.length);
                    list.forEach(item => $scope.campanha.CampanhaHorario.push(item))
                    $scope.infoTemplatePeriodo = $translate.instant('telaCampanhaEdit.infoTemplatePeriodo');
                }
            }

            $scope.onExibirTemplatePersonalizado($scope.associadoTemplatePeriodo);

            $scope.changeCampanhaCampoList = function (ALTERADO, CAMPO, LOADING) {
                if (LOADING && !$scope.isNew) {
                    $scope.campanha.CampanhaConfiguracao.find(f => f.Campo == "CampanhaHumana" && f.Valor)
                        ? _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                            if (find.Campo == "ramal_ura_desliga") {
                                find.Disabled = true;
                            }
                        })
                        : null;
                } else if (LOADING && $scope.isNew) {
                    _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                        if (find.Campo == "ramal_ura_desliga") {
                            find.Disabled = false
                        }
                    });
                }
                else {
                    let alterados = $scope.campanha.CampanhaConfiguracao.filter(f => f.Alterado == ALTERADO && f.Campo == CAMPO);

                    if (alterados.find(f => f.Campo == "CampanhaHumana")) {
                        if (alterados.find(f => f.Campo == "CampanhaHumana" && f.Valor)) {
                            _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "ramal_ura_desliga") {
                                    find.Disabled = true;
                                }
                            });
                        } else {
                            _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "ramal_ura_desliga") {
                                    find.Disabled = false;
                                }
                            });
                        }
                    } else if (alterados.find(f => f.Campo == "ramal_ura_desliga")) {
                        if (alterados.find(f => f.Campo == "ramal_ura_desliga" && f.Valor)) {
                            _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "CampanhaHumana") {
                                    find.Disabled = true;
                                }
                            });
                        } else {
                            _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "CampanhaHumana") {
                                    find.Disabled = false;
                                }
                            });
                        }
                    }
                }
            }

            $scope.changeCampanhaCampoBoolean = function (ALTERADO, CAMPO, LOADING) {
                if (LOADING && !$scope.isNew) {
                    if ($scope.avancadoPermissao) {
                        $scope.campanha.CampanhaConfiguracao.find(f => f.Campo == "CALL_PROGRESS" && f.Valor != '1')
                            ? _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "FlagGravaCallP") {
                                    find.Editavel = false;
                                    find.Valor = '0';
                                }
                            })
                            : null;
                    } else {
                        _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                            if (find.Campo == "FlagGravaCallP") {
                                find.Editavel = false;
                                find.Valor = '0';
                            }
                        });
                    }
                } else if (LOADING && $scope.isNew) {
                    _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                        if (find.Campo == "FlagGravaCallP") {
                            find.Editavel = false;
                        }
                    });
                }
                else {
                    let alterados = $scope.campanha.CampanhaConfiguracao.filter(f => f.Alterado == ALTERADO && f.Campo == CAMPO);

                    if (alterados.find(f => f.Campo == "CALL_PROGRESS")) {
                        if (alterados.find(f => f.Campo == "CALL_PROGRESS" && f.Checked) && $scope.avancadoPermissao) {
                            _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "FlagGravaCallP") {
                                    find.Editavel = true;
                                }
                            });
                        } else {
                            _.find($scope.campanha.CampanhaConfiguracao, function (find) {
                                if (find.Campo == "FlagGravaCallP") {
                                    find.Editavel = false;
                                    find.Valor = '0';
                                    find.Checked = false;
                                }
                            });
                        }
                    }
                }
            }

            $scope.onChangeZerarCampanha = function (value) {
                if (!value) {
                    $scope.campanha.ManterAgendamentoImportacaoArquivo = false;
                }
            }

            $scope.changeCampanhaCampoList(false, '', true);
            $scope.changeCampanhaCampoBoolean(false, '', true);

            $scope.bigTalkChanged = () => { $scope.campanha.bigTalk ? null : $scope.campanha.BigTalkTaxaAtendida = false; }

            $scope.onReciclagemAutomatica = function()
            {
                $scope.campanha.PercentualReciclagem = null;
                $scope.campanha.PercentualReciclagemRediscagem = null;

                if($scope.campanha.ReciclagemAutomatica)
                {
                    $scope.campanha.PercentualReciclagem = 0;

                    if(!$scope.campanha.DiscagemVertical)
                        $scope.campanha.PercentualReciclagemRediscagem = 0;
                }                
            };

            $scope.onChangeAtivo = function (item) {

                if (item.Dia == 0 && item.Ativo) {
                    ModalService.alert($translate.instant('telaCampanhaEdit.alertDomingo'));
                }

            }
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .service("CampanhaFlutuanteListData", function CampanhaFlutuanteListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_ionRangeSlider',
                            'lazy_amCharts'
                        ]);
                    }],
                }
            }
        })

        .controller("CampanhaFlutuanteListController", ["$scope", "$odata", "$timeout", "GrupoResource", "CampanhaResource", "CampanhaFlutuanteTrackingResource", "NotifyService", "ModalService", "$translate", function ($scope, $odata, $timeout, GrupoResource, CampanhaResource, CampanhaFlutuanteTrackingResource,
            NotifyService, ModalService, $translate) {
            $scope.logFlutuanteList = [];
            $scope.logFlutuanteListGrouped = [];
            $scope.campanhasSelecionadas = [];
            $scope.campanhasPadrao = [];
            $scope.campanhaFlutuanteList = [];
            $scope.editPrioridade = -1;
            $scope.currentPage = 1;

            GrupoResource.getGrupoFlutuante().$promise.then(function (data) {
                $scope.gruposComFlutuante = data;
            });

            $scope.getFlutuante = function () {
                $scope.carregandoLista = true;
                CampanhaResource.getFlutuante().$promise.then(function (data) {
                    $scope.carregandoLista = false;
                    $scope.campanhaFlutuanteList = data;
                });
            }
            $scope.getFlutuante();

            $scope.getNaoFlutuante = function () {
                CampanhaResource.odata().filter("Flutuante", false).orderBy("Nome").query().then(function (data) {
                    $scope.campanhaNaoFlutuanteList = data;
                    $scope.campanhaNaoFlutuanteListSearched = data;
                });
            }
            $scope.getNaoFlutuante();

            $scope.obj = {
                todosServicosAdicionados: false,
                todosServicosNaoAdicionados: false,
                pesquisa: '',
                showSearch: false,
                campanhaTipoId: undefined
            }

            $scope.searchLog = {
                campanhaId: null,
                dataInicio: moment(new Date()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss'),
                dataFim: moment(new Date()).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss')
            }

            $scope.searchMonitor = {
                grupoId: null
            }

            $scope.mostrarInput = function (index) {
                $scope.editPrioridade = index;
                $timeout(function () {
                    $("#input-prioridade-" + index).focus();
                });
            }

            $scope.desativarInput = function (index) {
                if ($scope.editPrioridade == index)
                    $scope.editPrioridade = -1;
            }

            $scope.reodernarLista = function (campanha, oldValue) {
                campanha.PrioridadeFlutuante = parseInt(campanha.PrioridadeFlutuante);
                $scope.campanhaFlutuanteList.forEach(el => {
                    if (campanha != el) {
                        if (campanha.PrioridadeFlutuante > oldValue) {
                            if (el.PrioridadeFlutuante > oldValue && el.PrioridadeFlutuante <= campanha.PrioridadeFlutuante) {
                                el.PrioridadeFlutuante--;
                            }
                        } else {
                            if (el.PrioridadeFlutuante < oldValue && el.PrioridadeFlutuante >= campanha.PrioridadeFlutuante) {
                                el.PrioridadeFlutuante++;
                            }
                        }
                    }
                });
                $timeout(function () {
                    reordenaFlutuantes();
                });
            }

            $scope.onEnterPrioridade = function ($event, index) {
                if ($event.keyCode == 13 || $event.keyCode == 9) {
                    $timeout(function () {
                        $("#input-prioridade-" + index).blur();
                    });
                }
            }

            $scope.limparFiltroMonitor = function () {
                $scope.searchMonitor = {};
            };

            $scope.limparFiltroLog = function () {
                $scope.searchLog = {
                    pageSize: 10
                };
                $scope.getLogFlutuante();
            };

            var getOdataSearchSharedTrackingFlutuante = function (CampanhaFlutuanteTrackingResource, search) {
                var odata = CampanhaFlutuanteTrackingResource.odata();

                if (search.campanhaId)
                    odata.filter("CampanhaId", "=", parseInt(search.campanhaId));

                if (search.grupoId)
                    odata.filter("GrupoId", "=", parseInt(search.grupoId));

                odata.filter("DataCadastro", ">=", new Date(Date.parse(search.dataInicio)));
                odata.filter("DataCadastro", "<=", new Date(Date.parse(search.dataFim)));
                return odata.orderBy("Id", "desc");
            }

            var getOdataSearchTrackingFlutuante = function getOdataSearchTrackingFlutuante() {
                return getOdataSearchSharedTrackingFlutuante(CampanhaFlutuanteTrackingResource, $scope.searchLog, $scope.orderByGrupo, $odata);
            };

            $scope.pageChangedFlutuante = function (newPage) {
                return getOdataSearchTrackingFlutuante()
                    .page(10, newPage)
                    .query()
                    .then(function (list) {
                        $scope.currentPage = list.$currentPage;
                        $scope.logFlutuanteList = list;
                    }).catch(NotifyService.showError);
            };

            $scope.tornarFlutuante = function (campanha) {
                ModalService.confirmMessage('abaFlutuante.desejaRealmenteTornarACampanhaFlutuante', null, function () {
                    campanha.Flutuante = true;
                    $scope.atualizaCampanhaFlutuante(campanha.CampanhaId, true, 0);
                });
            }

            $scope.tornarPadrao = function (campanha) {
                if (!campanha.Novo) {
                    ModalService.confirmMessage('abaFlutuante.desejaRealmenteTornarACampanhaPadrao', null, function () {
                        campanha.Flutuante = false;
                        $scope.removerCampanhaFlutuante(campanha.CampanhaId);
                    });
                } else {
                    var indexCampanha = $scope.campanhaFlutuanteList.indexOf(campanha);
                    if (indexCampanha > -1) {
                        $scope.campanhaFlutuanteList.splice(indexCampanha, 1);
                    }
                }
            }
            $scope.logSearched = false;
            $scope.getLogFlutuante = function () {
                getOdataSearchTrackingFlutuante().page(10, 1).query()
                    .then(function (list) {
                        $scope.logSearched = true;
                        $scope.currentPage = list.$currentPage;
                        $scope.logFlutuanteList = list;
                    }).catch(NotifyService.showError);
            }

            $scope.monitorFlutuanteSearched = false;
            $scope.getFlutuanteMonitor = function () {
                $scope.logFlutuanteListGrouped = null;
                return CampanhaResource.getIndicadorFlutuante($scope.searchMonitor).$promise
                    .then(function (list) {
                        if (list.length > 0) {
                            $scope.logFlutuanteListGrouped = _.groupBy(list, 'CampanhaId');
                            Object.keys($scope.logFlutuanteListGrouped).forEach(element => {
                                $timeout(() => {
                                    $scope.criarGraficoPerfilDiscagem("chartDescartado_", element);
                                }, 0);
                            });
                            $timeout(() => {
                                var listaAgregada = $scope.somarPorData(list);
                                $scope.criarGraficoTmoAgregado(listaAgregada);
                                $scope.criarGraficoDescartadoAgregado(listaAgregada);
                            }, 0);
                        }
                        $scope.monitorFlutuanteSearched = true;
                    }).catch(NotifyService.showError);
            }

            $scope.somarPorData = function (data) {
                var result = data.reduce(function (map, el) {
                    var id = map[el.DataI]
                    if (id) {
                        id.Descartado += el.Descartado;
                        id.PerfilDiscagem += el.PerfilDiscagem;
                        id.ValorTMO = el.ValorTMO;
                    } else {
                        map[el.DataI] = el
                    }
                    return map;
                }, {});

                return Object.keys(result)
                    .sort(function (x, y) { return new Date(x).getTime() - new Date(y).getTime() })
                    .map(function (k) { return result[k] })
            }

            $scope.criarGraficoPerfilDiscagem = function (div, dados) {
                AmCharts.makeChart(div + $scope.logFlutuanteListGrouped[dados][0].CampanhaNome, {
                    "type": "serial",
                    "theme": "light",
                    "marginRight": 0,
                    "language": "pt",
                    "autoMarginOffset": 0,
                    "numberFormatter": {
                        precision: -1,
                        decimalSeparator: ",",
                        thousandsSeparator: "."
                    },
                    "dataProvider": $scope.logFlutuanteListGrouped[dados],
                    "graphs": [{
                        "balloonText": `${$translate.instant('abaFlutuante.descartados')}: <b>[[value]]</b>`,
                        "fillAlphas": 0.4,
                        "lineAlpha": 0.4,
                        "valueAxis": "v1",
                        "title": "Descartados",
                        "valueField": "Descartado"
                    }, {
                        "balloonText": `${$translate.instant('campo.perfilDeDiscagem')}: <b>[[value]]</b>`,
                        "lineThickness": 2,
                        "valueAxis": "v2",
                        "title": $translate.instant('campo.perfilDeDiscagem'),
                        "valueField": "PerfilDiscagem"
                    }],
                    "valueAxes": [{
                        "id": "v1",
                        "stackType": "regular",
                        "gridAlpha": 0.07,
                        "position": "left",
                        "title": $translate.instant('abaFlutuante.descartados'),
                        "axisColor": "#000",
                        "color": "#000",
                        "titleColor": "#000",
                        "titleBold": false
                    }, {
                        "id": "v2",
                        "stackType": "regular",
                        "gridAlpha": 0.07,
                        "position": "right",
                        "title": $translate.instant('campo.perfilDeDiscagem'),
                        "axisColor": "#000",
                        "color": "#000",
                        "titleColor": "#000",
                        "titleBold": false
                    }],
                    "plotAreaBorderAlpha": 0,
                    "marginTop": 10,
                    "marginLeft": 0,
                    "zoomOutText": "",
                    "marginBottom": 0,
                    "chartCursor": {
                        "valueLineEnabled": true,
                        "valueLineBalloonEnabled": true,
                        "cursorAlpha": 1,
                        "cursorColor": "#258cbb",
                        "valueLineAlpha": 0.2,
                        "selectWithoutZooming": false
                    },
                    "categoryField": "DataI",
                    "categoryAxis": {
                        "parseDates": false,
                        "gridAlpha": 0.07,
                        "axisColor": "#000",
                        "color": "#000",
                        "categoryFunction": function (valueText) {
                            return moment(valueText).format('HH:mm').toString();
                        },
                        "labelRotation": 45
                    },
                    "export": {
                        "enabled": false
                    }
                });
            }

            $scope.criarGraficoDescartadoAgregado = function (dados) {
                AmCharts.makeChart("chartDescartadoGeral", {
                    "type": "serial",
                    "theme": "light",
                    "marginRight": 0,
                    "language": "pt",
                    "autoMarginOffset": 0,
                    "numberFormatter": {
                        precision: -1,
                        decimalSeparator: ",",
                        thousandsSeparator: "."
                    },
                    "dataProvider": dados,
                    "graphs": [{
                        "balloonText": `${$translate.instant('abaFlutuante.descartados')}: <b>[[value]]</b>`,
                        "fillAlphas": 1,
                        "lineAlpha": 0.4,
                        "valueAxis": "v1",
                        "title": $translate.instant('abaFlutuante.descartados'),
                        "valueField": "Descartado"
                    }, {
                        "balloonText": `${$translate.instant('campo.perfilDeDiscagem')}: <b>[[value]]</b>`,
                        "lineThickness": 2,
                        "valueAxis": "v2",
                        "title": $translate.instant('campo.perfilDeDiscagem'),
                        "valueField": "PerfilDiscagem"
                    }],
                    "valueAxes": [{
                        "id": "v1",
                        "stackType": "regular",
                        "gridAlpha": 0.07,
                        "position": "left",
                        "title": $translate.instant('abaFlutuante.descartados'),
                        "axisColor": "#000",
                        "color": "#000",
                        "titleColor": "#000",
                        "titleBold": false
                    }, {
                        "id": "v2",
                        "stackType": "regular",
                        "gridAlpha": 0.07,
                        "position": "right",
                        "title": $translate.instant('campo.perfilDeDiscagem'),
                        "axisColor": "#000",
                        "color": "#000",
                        "titleColor": "#000",
                        "titleBold": false
                    }],
                    "plotAreaBorderAlpha": 0,
                    "marginTop": 10,
                    "marginLeft": 0,
                    "zoomOutText": "",
                    "marginBottom": 0,
                    "chartCursor": {
                        "valueLineEnabled": true,
                        "valueLineBalloonEnabled": true,
                        "cursorAlpha": 1,
                        "cursorColor": "#258cbb",
                        "valueLineAlpha": 0.2,
                        "selectWithoutZooming": false
                    },
                    "categoryField": "DataI",
                    "categoryAxis": {
                        "parseDates": false,
                        "gridAlpha": 0.07,
                        "axisColor": "#000",
                        "color": "#000",
                        "categoryFunction": function (valueText) {
                            return moment(valueText).format('HH:mm').toString();
                        },
                        "labelRotation": 45
                    },
                    "export": {
                        "enabled": false
                    }
                });
            }

            $scope.criarGraficoTmoAgregado = function (dados) {
                AmCharts.makeChart("chartTMOGeral", {
                    "type": "serial",
                    "theme": "light",
                    "marginRight": 0,
                    "language": "pt",
                    "autoMarginOffset": 0,
                    "numberFormatter": {
                        precision: -1,
                        decimalSeparator: ",",
                        thousandsSeparator: "."
                    },
                    "dataProvider": dados,
                    "graphs": [{
                        "balloonText": `${$translate.instant('campo.tmo')}: <b>[[value]]</b>`,
                        "fillAlphas": 1,
                        "lineAlpha": 0.4,
                        "valueAxis": "v1",
                        "title": $translate.instant('abaFlutuante.tempoMedioOcioso'),
                        "valueField": "ValorTMO"
                    }, {
                        "balloonText": `${$translate.instant('campo.perfilDeDiscagem')}: <b>[[value]]</b>`,
                        "lineThickness": 2,
                        "valueAxis": "v2",
                        "title": $translate.instant('campo.perfilDeDiscagem'),
                        "valueField": "PerfilDiscagem"
                    }],
                    "valueAxes": [{
                        "id": "v1",
                        "stackType": "regular",
                        "gridAlpha": 0.07,
                        "position": "left",
                        "title": $translate.instant('abaFlutuante.tempoMedioOcioso'),
                        "axisColor": "#000",
                        "color": "#000",
                        "titleColor": "#000",
                        "titleBold": false
                    }, {
                        "id": "v2",
                        "stackType": "regular",
                        "gridAlpha": 0.07,
                        "position": "right",
                        "title": $translate.instant('campo.perfilDeDiscagem'),
                        "axisColor": "#000",
                        "color": "#000",
                        "titleColor": "#000",
                        "titleBold": false
                    }],
                    "plotAreaBorderAlpha": 0,
                    "marginTop": 10,
                    "marginLeft": 0,
                    "zoomOutText": "",
                    "marginBottom": 0,
                    "chartCursor": {
                        "valueLineEnabled": true,
                        "valueLineBalloonEnabled": true,
                        "cursorAlpha": 1,
                        "cursorColor": "#258cbb",
                        "valueLineAlpha": 0.2,
                        "selectWithoutZooming": false
                    },
                    "categoryField": "DataI",
                    "categoryAxis": {
                        "parseDates": false,
                        "gridAlpha": 0.07,
                        "axisColor": "#000",
                        "color": "#000",
                        "categoryFunction": function (valueText) {
                            return moment(valueText).format('HH:mm').toString();
                        },
                        "labelRotation": 45
                    },
                    "export": {
                        "enabled": false
                    }
                });
            }

            $scope.abrirDetalhe = function (detalhe) {
                $scope.itemSelecionado = detalhe;
                ModalService.openModal('modal_detalhes');
            }

            $scope.mostrarPesquisa = function () {
                $scope.obj.showSearch = !$scope.obj.showSearch;
                if ($scope.obj.showSearch == false) {
                    $scope.obj.pesquisa = '';
                    $scope.obj.campanhaTipoId = undefined;
                } else
                    $('#pesquisa').focus();
            }

            $scope.pesquisar = function () {
                $scope.campanhaNaoFlutuanteListSearched = _.filter($scope.campanhaNaoFlutuanteList, function (el) {
                    let containsDescricao = el.Descricao.toLowerCase().indexOf($scope.obj.pesquisa.toLowerCase()) > -1;
                    let containsGrupo = el.Grupo.Descricao.toLowerCase().indexOf($scope.obj.pesquisa.toLowerCase()) > -1;
                    let equalsCampanhaTipo = $scope.obj.campanhaTipoId == null || el.CampanhaTipoId == $scope.obj.campanhaTipoId;
                    return (containsDescricao || containsGrupo) && equalsCampanhaTipo;
                });
            }

            $scope.removerCampanhaFlutuante = function (campanhaId) {
                var promiseRemoverFlutuante = CampanhaResource.removerCampanhaFlutuante({ "campanhaId": campanhaId }).$promise;
                promiseRemoverFlutuante.then(function () {
                    NotifyService.showRegistroSalvo();
                    $scope.getFlutuante();
                    $scope.getNaoFlutuante();
                });
            }

            $scope.atualizaCampanhaFlutuante = function (lista) {
                var promiseFlutuante = CampanhaResource.atualizarCampanhaFlutuantePrioridade(lista).$promise;
                $scope.salvandoPrioridade = true
                promiseFlutuante.then(function () {
                    NotifyService.showRegistroSalvo();
                    $scope.salvandoPrioridade = false;
                    $scope.getFlutuante();
                    $scope.getNaoFlutuante();
                });
            }

            $scope.adicionarCampanhasFlutuantes = function () {
                $scope.obj.todosServicosAdicionados = false;
                $scope.obj.todosServicosNaoAdicionados = false;
                ModalService.openModal('modal_campanha_flutuante', null, function () {
                    $scope.obj.todosServicosAdicionados = false;
                    $scope.obj.todosServicosNaoAdicionados = false;
                    $scope.obj.showSearch = false;
                    $scope.obj.pesquisa = '';
                    $scope.obj.campanhaTipoId = undefined;
                    $scope.campanhasSelecionadas = [];
                });
            }

            $scope.selectionarTodosNaoAdicionados = function (selecionado) {
                angular.forEach($scope.campanhaNaoFlutuanteList, function (item) {
                    item.Selecionado = selecionado;
                });
            };

            $scope.selectionarTodosAdicionados = function (selecionado) {
                angular.forEach($scope.campanhasSelecionadas, function (item) {
                    item.Selecionado = selecionado;
                });
            };

            $scope.adicionarCampanhaNosFlutuantes = function () {
                $scope.obj.todosServicosNaoAdicionados = false;

                const itensSelecionados = _.where($scope.campanhaNaoFlutuanteList, {
                    Selecionado: true
                });

                itensSelecionados.forEach(item => {
                    item.Selecionado = false;
                    $scope.campanhasSelecionadas.push(item);
                    $scope.campanhaNaoFlutuanteList.splice($scope.campanhaNaoFlutuanteList.indexOf(item), 1);
                });

                $scope.pesquisar();
            }

            $scope.removerCampanhaDosFlutuantes = function () {
                const itensSelecionados = _.where($scope.campanhasSelecionadas, {
                    Selecionado: true
                });

                itensSelecionados.forEach(item => {
                    item.Selecionado = false;
                    $scope.campanhaNaoFlutuanteList.push(item);
                    $scope.campanhasSelecionadas.splice($scope.campanhasSelecionadas.indexOf(item), 1);
                });

                $scope.pesquisar();
            }

            $scope.adicionarSelecionadosAosFlutuantes = function () {
                $scope.obj.todosServicosAdicionados = false;
                $scope.obj.todosServicosNaoAdicionados = false;

                $scope.campanhasSelecionadas.forEach(campanha => {
                    campanha.Novo = true;
                    campanha.PrioridadeFlutuante = $scope.campanhaFlutuanteList.length + 1;
                    $scope.campanhaFlutuanteList.push(campanha);
                });
                $scope.campanhasSelecionadas = [];

                ModalService.closeModal('modal_campanha_flutuante');
            }

            $scope.gravarFlutuantes = function () {
                var $nestable = $('#nestable-flutuante');
                var flutuantes = $nestable.data("nestable").serialize();
                var listaCampanhasId = flutuantes.map(item => item.id);
                $scope.atualizaCampanhaFlutuante(listaCampanhasId);
            }

            $scope.initFlutuante = function () {
                var $nestable = $('#nestable-flutuante');
                if ($nestable.length) {
                    $.UIkit.nestable($nestable, {});
                    $nestable.on('change.uk.nestable', function () {
                        reordenaFlutuantes();
                    });
                }
            }

            var reordenaFlutuantes = function () {
                var $nestable = $('#nestable-flutuante');
                var flutuantes = $nestable.data("nestable").serialize();

                for (var i = 0; i < flutuantes.length; i++) {
                    var campanha = _.find($scope.campanhaFlutuanteList, function (el) {
                        return el.CampanhaId == flutuantes[i].id;
                    });

                    campanha.PrioridadeFlutuante = i + 1;
                }
                $scope.$apply();
            };
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (CampanhaResource, search, orderBy) {
        var odata = CampanhaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);
        odata.filter('CampanhaStatus/Visivel', true);

        if (search.CampanhaId) {
            odata.filter('CampanhaId', search.CampanhaId);
        } else {
            if (search.Nome) {
                odata.where('Nome', 'contains', search.Nome);
            }
            if (search.TipoId) {
                odata.filter('CampanhaTemplate/CampanhaTipoId', search.TipoId);
            }
            if (search.GrupoId) {
                odata.filter('GrupoId', search.GrupoId);
            }
            if (search.RamalId) {
                odata.filter('RamalId', search.RamalId);
            }
            if (search.CampanhaStatusId) {
                odata.filter('CampanhaStatusId', search.CampanhaStatusId);
            }
            if (search.CampanhaId) {
                odata.filter('CampanhaId', search.CampanhaId);
            }
            if (search.DiscagemVertical) {
                odata.filter('DiscagemVertical', search.DiscagemVertical);
            }
            if (search.CarteiraId) {
                odata.filter('CarteiraId', search.CarteiraId);
            }
        }

        return odata;
    };

    var getOdataSearchSharedGrupo = function (GrupoResource, search, orderBy, $odata) {
        var odata = GrupoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);
        if (search.GrupoTipoId) {
            odata.filter("GrupoTipoId", "=", parseInt(search.GrupoTipoId));
        }
        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }
        return odata;
    }

    angular.module("epbxManagerApp")

        .filter('secondsToDateTime', function () {
            return function (seconds) {
                var d = new Date(0, 0, 0, 0, 0, 0, 0);
                d.setSeconds(seconds);
                return d;
            };
        })

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanha", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.campanha.list',
                        pageTitle: 'model.campanha',
                        pageName: 'model.campanha'
                    }
                })
                .state("main.campanha.list", StateResolverProvider.configState("/campanha", "Campanha", "List", {
                    pageTitle: 'model.campanha',
                    pageName: 'pageTitle.pesquisar',
                    params: { tab: 1 },
                    css: true
                }))
                .state("main.campanha.detalhe", StateResolverProvider.configState("/campanha/{CampanhaId:[0-9]+}/detalhe", "Campanha", "Detalhe", {
                    pageTitle: 'pageTitle.campanhaDetalhes',
                    pageName: 'campo.detalhe',
                    css: true,
                    cssFiles: [
                        'app/pages/bilhete/style/listBilheteDetalhe.css',
                        'app/pages/campanha/style/detalhe.css',
                        'app/pages/monitorCampanha/style/filtros.css'
                    ]
                }))
                .state("main.campanha.padrao", {
                    url: "/campanha/padrao",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        pageTitle: 'model.campanha',
                        pageName: 'model.campanha',
                        permissions: { AllowAnonymous: true }
                    }
                })
                .state("main.campanha.padrao.new", StateResolverProvider.configState("/new", "Campanha", "Edit", {
                    pageTitle: 'pageTitle.campanhaPadrao',
                    pageName: 'acoes.cadastrar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/edit.css', 'app/pages/campanha/style/regra.css']
                }))
                .state("main.campanha.padrao.edit", StateResolverProvider.configState("/{CampanhaId:[0-9]+}", "Campanha", "Edit", {
                    pageTitle: 'pageTitle.campanhaPadrao',
                    pageName: 'acoes.editar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/edit.css', 'app/pages/campanha/style/regra.css']
                }))
                .state("main.campanha.callback", {
                    url: "/campanha/callback",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        pageTitle: 'model.campanha',
                        pageName: 'model.campanha',
                        permissions: { AllowAnonymous: true }
                    }
                })
                .state("main.campanha.callback.edit", StateResolverProvider.configState("/{CampanhaId:[0-9]+}", "Campanha", "Edit", {
                    pageTitle: 'pageTitle.campanhaCallback',
                    pageName: 'acoes.editar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/edit.css', 'app/pages/campanha/style/regra.css']
                }))
                .state("main.campanha.callback.new", StateResolverProvider.configState("/new", "Campanha", "Edit", {
                    pageTitle: 'pageTitle.campanhaCallback',
                    pageName: 'acoes.cadastrar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/edit.css', 'app/pages/campanha/style/regra.css']
                }))
                .state("main.campanha.higienizacao", {
                    url: "/campanha/higienizacao",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        pageTitle: 'pageTitle.campanhaDeHigienizacao',
                        pageName: 'acoes.cadastrar',
                        permissions: { AllowAnonymous: true }
                    }
                })
                .state("main.campanha.higienizacao.edit", StateResolverProvider.configState("/{CampanhaId:[0-9]+}", "CampanhaHigienizacao", "Edit", {
                    pageTitle: 'pageTitle.campanhaDeHigienizacao',
                    pageName: 'acoes.editar'
                }))
                .state("main.campanha.higienizacao.new", StateResolverProvider.configState("/new", "CampanhaHigienizacao", "Edit", {
                    pageTitle: 'pageTitle.campanhaDeHigienizacao',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.campanha.higienizacao.detalhe", StateResolverProvider.configState("/{CampanhaId:[0-9]+}/detalhe", "CampanhaHigienizacao", "Detalhe", {
                    pageTitle: 'pageTitle.campanhaDeHigienizacao',
                    pageName: 'campo.detalhe',
                    css: true
                }))
                .state("main.campanha.higienizacao.configuracao", StateResolverProvider.configState("/{CampanhaId:[0-9]+}/configuracao", "CampanhaHigienizacao", "Configuracao", {
                    pageTitle: 'pageTitle.campanhaDeHigienizacao',
                    pageName: 'campo.configuracao'
                }))
                .state("main.campanha.talkbot", {
                    url: "/campanha/talkbot",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        pageTitle: 'model.campanha',
                        pageName: 'model.campanha',
                        permissions: { AllowAnonymous: true }
                    }
                })
                .state("main.campanha.talkbot.edit", StateResolverProvider.configState("/{CampanhaId:[0-9]+}", "Campanha", "Edit", {
                    pageTitle: 'pageTitle.campanhaTalkbot',
                    pageName: 'acoes.editar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/edit.css', 'app/pages/campanha/style/regra.css']
                }))
                .state("main.campanha.talkbot.new", StateResolverProvider.configState("/new", "Campanha", "Edit", {
                    pageTitle: 'pageTitle.campanhaTalkbot',
                    pageName: 'acoes.cadastrar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/edit.css', 'app/pages/campanha/style/regra.css']
                }))
                .state("main.campanha.avancado", StateResolverProvider.configState("/campanha/{GrupoId:[0-9]+}/avancado", "Campanha", "Avancado", {
                    pageTitle: 'pageTitle.campanhaAvancado',
                    pageName: 'campo.avancado'
                }))
        }])

        .service("CampanhaListData", function CampanhaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_ionRangeSlider',
                            'lazy_wizard',
                            'lazy_amCharts'
                        ]);
                    }],
                    campanhas: ["CampanhaResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (CampanhaResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = $stateParams.storage ? LocalStorageService.getItem("FiltroCampanha") : {

                        };
                        var orderBy = {
                            column: "CampanhaId",
                            order: "desc"
                        };

                        return getOdataSearchShared(CampanhaResource, filtro, orderBy, $odata, utils).page(10, 1).query();
                    }],
                    gruposList: ["GrupoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (GrupoResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = $stateParams.storage ? LocalStorageService.getItem("FiltroGrupo") : {};
                        var orderBy = {
                            column: "GrupoId",
                            order: "desc"
                        };

                        return getOdataSearchSharedGrupo(GrupoResource, filtro, orderBy, $odata, utils).page(10, 1).query();
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }],
                    ramais: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "1" }).$promise;
                    }],
                    uras: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "3" }).$promise;
                    }],
                    ramaispabx: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "4" }).$promise;
                    }],
                    tipos: ["CampanhaTipoResource", function (CampanhaTipoResource) {
                        return CampanhaTipoResource.query().$promise;
                    }],
                    tiposGrupo: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getTipos().$promise;
                    }],
                    ramaisList: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "1" }).$promise;
                    }],
                    discagemStatus: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.query().$promise;
                    }],
                    perfilDiscagemAlerta: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetPerfilDiscagemAlerta().$promise;
                    }],
                    statuses: ["CampanhaStatusResource", function (CampanhaStatusResource) {
                        var odata = CampanhaStatusResource.odata();
                        odata.filter('Visivel', true);
                        return odata.query();
                    }],
                    ramaltipos: ["$translate", function ($translate) {
                        return [
                            { TipoId: 1, Descricao: $translate.instant('model.ramal') },
                            { TipoId: 2, Descricao: $translate.instant('model.grupo') },
                            { TipoId: 3, Descricao: $translate.instant('model.ramalUra') },
                            { TipoId: 4, Descricao: $translate.instant('model.ramalPabx') }
                        ];
                    }],
                    campanhasPadrao: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetCampanhasPorTipo({ campanhaTipoId: 1 }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    campanhaDiscagemStatus: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        var odata = CampanhaDiscagemStatusResource.odata().orderBy("Descricao");
                        odata.filter('Ativo', true);
                        odata.filter('Discagem', true);
                        odata.filter('PermiteRegra', true);
                        return odata.query();
                    }],
                    ttsService : ["TtsService", function(TtsService){
                        TtsService.getVozes();
                        TtsService.setProvedores();
                        return;
                    }]
                }
            }
        })

        .controller("CampanhaListController", ["$scope", "$window", "$odata", "$state", "$stateParams", "FileDownloadService", "LocalStorageService", "utils", "CampanhaDiscagemResource", "CampanhaResource", "GrupoResource", "tiposGrupo", "gruposList", "NotifyService", "campanhas", "grupos", "ramais", "tipos", "discagemStatus", "ramaisList", "uras", "ramaispabx", "ramaltipos", "statuses", "campanhasPadrao", "perfilDiscagemAlerta", "$translate", "ModalService", "carteiras", "campanhaDiscagemStatus", "CampanhaReciclagemResource", "WizardHandler", function ($scope, $window, $odata, $state, $stateParams, FileDownloadService, LocalStorageService, utils,
            CampanhaDiscagemResource, CampanhaResource, GrupoResource, tiposGrupo, gruposList, NotifyService, campanhas, grupos, ramais, tipos, discagemStatus,
            ramaisList, uras, ramaispabx, ramaltipos, statuses, campanhasPadrao, perfilDiscagemAlerta, $translate, ModalService, carteiras, campanhaDiscagemStatus,
            CampanhaReciclagemResource, WizardHandler ) {
            $scope.campanhas = campanhas;
            $scope.grupos = grupos;
            $scope.tiposGrupo = tiposGrupo;
            $scope.gruposList = gruposList;
            $scope.campanhasPadrao = campanhasPadrao;
            $scope.ramais = ramais;
            $scope.carteiras = carteiras;
            $scope.uras = uras;
            $scope.ramaispabx = ramaispabx;
            $scope.tipos = tipos;
            $scope.ramaisList = ramaisList;
            $scope.discagemStatus = discagemStatus;
            $scope.discagemStatusHigienizacao = discagemStatus.filter(x => x.CampanhaDiscagemStatusId == 24 || x.CampanhaDiscagemStatusId == 25);
            $scope.possuiPerfilDiscagemAlerta = perfilDiscagemAlerta != null && perfilDiscagemAlerta.length > 0;
            $scope.exibirPerfilDiscagemAlerta = false;
            $scope.perfilDiscagemAlerta = perfilDiscagemAlerta;
            $scope.searching = false;
            $scope.searchingBloqueado = false;
            $scope.consultandoBloqueado = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroCampanha") : {};
            $scope.searchGrupo = $stateParams.storage ? LocalStorageService.getItem('FiltroGrupo') : {};
            $scope.ramaltipos = ramaltipos;
            $scope.statuses = statuses;
            $scope.campanhaHistoricoLimpeza = [];
            $scope.campanhaSelecionada;
            $scope.abaSelecionada = 1;
            $scope.habilitarConfiguracaoFlutuante = true;
            $scope.itemSelecionado = {};
            $scope.clienteBloqueado = {};
            $scope.campanhaLote = {};
            $scope.campanhaDiscagemStatus = campanhaDiscagemStatus;
            $scope.historicoReciclagem = [];
            $scope.ExcluirAnterior = false;
            $scope.campanhaDiscagemStatus.forEach(s => { s.Recicla = true; });
            $scope.reciclagemTodos = false;

            var dataFim = moment().toDate();

            if ($stateParams.tab) {
                $scope.abaSelecionada = $stateParams.tab;
            }

            $scope.searchHistorico = {
                datacadastro: dataFim
            };

            $scope.campanhaDelete = {
                Validacao: false,
                CampanhaId: 0
            };
            $scope.orderBy = {
                column: "CampanhaId",
                order: "desc"
            };

            $scope.orderByGrupo = {
                column: "GrupoId",
                order: "desc"
            };

            $scope.campanhaModal = {
                CampanhaId: '',
                Status: '',
                PendenteAcao: false,
                Nome: '',
            };

            $scope.selecionarAba = function (aba) {
                $scope.abaSelecionada = aba;
            };

            $scope.novaCampanha = function (state, params) {
                CampanhaResource.validarLimiteCampanha().$promise.then(function (result) {
                    if (result.PodeCriar) {
                        $state.go(state, params);
                    } else {
                        ModalService.alert('telaCampanha.limiteCampanhaAtingido');
                    }
                }).catch(NotifyService.showError);
            };

            var updateList = function (list) {
                $scope.campanhas = list;
                $scope.campanhas.recordCount = list.$recordCount || list.length;
                $scope.campanhas.currentPage = list.$currentPage || 1;
                $scope.campanhas.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var updateListGrupo = function (list) {
                $scope.gruposList = list;
                $scope.gruposList.recordCount = list.$recordCount || list.length;
                $scope.gruposList.currentPage = list.$currentPage || 1;
                $scope.gruposList.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(CampanhaResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            var getOdataSearchGrupo = function () {
                return getOdataSearchSharedGrupo(GrupoResource, $scope.searchGrupo, $scope.orderByGrupo, $odata, utils);
            };

            $scope.$on("onCampanhaChanged", function (event, campanhaChanged) {
                if (campanhaChanged) {
                    var campanhaRetorno = campanhaChanged;
                    var index = _.findIndex($scope.campanhas, function (el) {
                        return el.CampanhaId == campanhaRetorno.CampanhaId;
                    });
                    if (index >= 0) {
                        if (campanhaRetorno.CampanhaId > 0) {
                            var campanhaNew = {};
                            $scope.campanhas.forEach((value) => {
                                if (value.CampanhaId == campanhaRetorno.CampanhaId) {
                                    value.PendenteAcao = false;
                                    value.CampanhaStatus.Descricao = campanhaRetorno.CampanhaStatus.Descricao;
                                    value.CampanhaStatusId = campanhaRetorno.CampanhaStatusId;
                                    value.UltimoRetorno = campanhaRetorno.UltimoRetorno;
                                    campanhaNew = value;
                                    reloadStatusAcao(campanhaRetorno.CampanhaId);

                                    if ($scope.campanhaModal.CampanhaId == campanhaRetorno.CampanhaId) {
                                        reloadHistorico(campanhaRetorno.CampanhaId);
                                        $scope.campanhaModal = {
                                            Status: campanhaRetorno.CampanhaStatus.Descricao,
                                            PendenteAcao: false,
                                            Nome: campanhaRetorno.Nome,
                                        };
                                    }
                                    return;
                                }
                            });
                            $scope.campanhas[index] = campanhaNew;
                        }
                    }
                }
            });

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroCampanha', $scope.search);
                $scope.searching = true;
                getOdataSearch().page($scope.search.pageSize, 1).query().then((list) => updateList(list)).catch(NotifyService.showError);
            };

            $scope.toggleSelection = function toggleSelection(campanha) {
                campanha.Alterado = !campanha.Alterado;
            };


            $scope.selectAllCampanhas = false;

            $scope.selectAll = function() {           
                $scope.campanhas.forEach(campanha => {
                    campanha.Alterado = $scope.selectAllCampanhas;
                });
            }

            $scope.executeSearchGrupo = function () {
                LocalStorageService.setItem('FiltroGrupo', $scope.searchGrupo);
                $scope.searching = true;
                getOdataSearchGrupo().page($scope.searchGrupo.pageSize, 1).query().then((list) => updateListGrupo(list)).catch(NotifyService.showError);
            };

            var deleteRecord = function (campanhaId) {
                ModalService.showLoading();
                return CampanhaResource.delete({
                    CampanhaId: campanhaId
                }).$promise.then(() => {
                    ModalService.hideLoading();
                    NotifyService.showSuccess();
                    $scope.pageChanged($scope.campanhas.currentPage);
                    ModalService.closeModal('modal_delete');
                }).catch((err) => {
                    NotifyService.showError(err);
                    ModalService.hideLoading();
                });
            };

            $scope.confirmDelete = function () {
                var campanhaId = $scope.campanhaDelete.CampanhaId;
                var statusId = $scope.campanhaDelete.CampanhaStatusId;
                var pendenteAcao = $scope.campanhaDelete.PendenteAcao;
                // Não está em Pausa
                if (statusId != 2 || pendenteAcao == true) {
                    NotifyService.showError(null, 'telaCampanha.necessarioPausarCampanha');
                }
                else {
                    if (campanhaId > 0) {
                        ModalService.confirmDelete(() => deleteRecord(campanhaId));
                    } else {
                        NotifyService.showError(null, 'telaCampanha.naoFoiPossivelExcluirCampanha');
                    }
                }
            };

            $scope.confirmReciclar = function () {
                let campanhaId = $scope.campanhaDelete.CampanhaId;
                let campanha = $scope.campanhas.find(c => c.CampanhaId == campanhaId)

                // Não está em pausa
                if (($scope.campanhaDelete.CampanhaStatusId !== 2 && $scope.campanhaDelete.CampanhaStatusId !== 4) || $scope.campanhaDelete.pendenteAcao == true) {
                    return NotifyService.showError(null, 'telaCampanha.necessarioPausarParaReciclar');
                }
                
                // Não terminou todos os ciclos
                if((campanha.DiscagemVertical === true) && campanha.CicloDiscagem < campanha.CicloQuantidade) {
                    return NotifyService.showError(null, 'telaCampanha.necessarioTerminarCiclosParaReciclar');
                }

                if (campanhaId > 0) {
                    ModalService.confirmMessage($translate.instant('modalDelete.confirmReciclagemCampanha'), null, () => {

                        CampanhaResource.reciclarCampanha({
                            CampanhaId: campanhaId,
                        }).$promise.then(() => {
                            NotifyService.showSuccess('modalDelete.campanhaRecicladaComSucesso');
                            ModalService.closeModal('modal_delete');
                        }).catch(NotifyService.showError); 
                    });
                } 
            };

            var reloadHistorico = function (campanhaId) {
                if (campanhaId > 0) {
                    CampanhaResource.campanhaHistorico({
                        CampanhaId: campanhaId
                    }).$promise.then((data) => {
                        $scope.historicoList = [];
                        angular.copy(data, $scope.historicoList);
                    });
                }
            }

            $scope.processaCampanha = function (acao) {
                if (acao.CampanhaId > 0 && acao.CampanhaAcaoId > 0 && !acao.Reiniciar) {
                    var index = _.findIndex($scope.campanhas, function (el) {
                        return el.CampanhaId == acao.CampanhaId;
                    });

                    if (index >= 0) {
                        $scope.campanhas[index].PendenteAcao = true;
                    }

                    if ($scope.campanhas[index].DiscagemVertical == true && acao.CampanhaAcaoId == 2) {
                        ModalService.confirmMessage($translate.instant('telaCampanha.confirmCampanhaVertical'), null, () => {
                            $scope.processaCampanhaFnc(acao, index);
                        });
                    } else {
                        $scope.processaCampanhaFnc(acao, index);
                    }
                } else {
                    ModalService.showLoading();
                    CampanhaResource.processaReiniciaCampanha([acao.CampanhaId]).$promise
                    .then(() => {
                        ModalService.hideLoading();
                        $scope.executeSearch();
                    }).catch(error => { NotifyService.showError() ;});
                }
            };

            $scope.botoesGeraisDesabilitado = function(){
                let campanha = $scope.campanhas.find(x => x.Alterado);
                if(campanha)
                    return false
                else
                    return true
            }

            $scope.processaCampanhaLote = function(acaoId) {
                var campanhastring = _.pluck(_.where($scope.campanhas, { Alterado: true }), 'CampanhaId').join(",");
                ModalService.showLoading();
                CampanhaResource.processaCampanhaLote({
                    CampanhasIds: campanhastring,
                    CampanhaAcaoId: acaoId,
                }).$promise.then(() => {
                    ModalService.hideLoading();
                    $scope.campanhas.forEach(el => {
                        el.Alterado= false;
                    });
                    $scope.selectAllCampanhas = false;
                    $scope.executeSearch();
                }).catch(() => {
                    NotifyService.showError(null, $translate.instant('telaCampanha.erroAcaoEmLote'));
                    ModalService.hideLoading();
                });
            };

            $scope.processaCampanhaFnc = function (acao, index) {
                CampanhaResource.processaCampanhaConfiguracao({
                    CampanhaId: acao.CampanhaId,
                    CampanhaAcaoId: acao.CampanhaAcaoId,
                }).$promise.then((acaoResult) => {
                    var pendenteAcaoProcesso = (acaoResult ? acaoResult.PendenteAcao : true);

                    if ($scope.campanhaModal) {
                        $scope.campanhaModal.PendenteAcao = pendenteAcaoProcesso;
                    }

                    if (!pendenteAcaoProcesso) {
                        if ($scope.campanhas[index]) {
                            $scope.campanhas[index].CampanhaStatus.Descricao = $translate.instant('telaCampanha.cancelada');
                            $scope.campanhas[index].CampanhaStatusId = 7
                            $scope.campanhas[index].PendenteAcao = pendenteAcaoProcesso;
                            $scope.campanhaModal.Status = $translate.instant('telaCampanha.cancelada');
                        }
                    }

                    CampanhaResource.campanhaHistorico({
                        CampanhaId: acao.CampanhaId
                    }).$promise.then((data) => {
                        $scope.historicoList = [];
                        angular.copy(data, $scope.historicoList);
                        reloadStatusAcao(acao.CampanhaId).then(() => NotifyService.showSuccess());
                    });
                }).catch(NotifyService.showError);
            }

            $scope.ImportarArquivos = function (campanha) {
                var index = _.findIndex($scope.campanhas, (el) => {
                    return el.CampanhaId == campanha.CampanhaId;
                });

                if (index >= 0) {
                    campanha = $scope.campanhas[index]
                }

                if (campanha.DiscagemVertical && campanha.CampanhaStatusId == 6) {
                    NotifyService.showError(null, 'telaCampanha.naoEPossivelImportarComCampanhaEmAndamento');
                } else {
                    $state.go('main.campanha.arquivos.list', campanha);
                }
            };

            var reloadStatusAcao = function (campanhaId) {
                const campanha = $scope.campanhas.find(el => el.CampanhaId == campanhaId)

                return CampanhaResource.campanhaAcao({
                    CampanhaId: campanhaId
                }).$promise.then((data) => {
                    $scope.statusAcaoList = [];
                    angular.copy(data, $scope.statusAcaoList);
                    if (campanha) {
                        angular.copy(data, campanha.CampanhaStatus.CampanhaStatusAcao);
                    }
                });
            }

            $scope.viewAcao = function (campanha) {
                if (campanha.CampanhaId > 0) {
                    CampanhaResource.campanhaHistorico({
                        CampanhaId: campanha.CampanhaId
                    }).$promise.then((data) => {
                        $scope.historicoList = [];
                        angular.copy(data, $scope.historicoList);

                        reloadStatusAcao(campanha.CampanhaId).then(() => {
                            $scope.campanhaModal = {
                                CampanhaId: campanha.CampanhaId,
                                Status: campanha.CampanhaStatus.Descricao,
                                PendenteAcao: campanha.PendenteAcao,
                                Nome: campanha.Nome,
                            };

                            ModalService.openModal('modal_acao');
                        });
                    });
                } else {
                    NotifyService.showError(null, 'telaCampanha.acaoNaoRealizada');
                }
            };

            $scope.pageChanged = function (newPage) {
                ModalService.showLoading();
                return getOdataSearch().page($scope.campanhas.pageSize, newPage).query()
                    .then((list) => {
                        updateList(list);
                        ModalService.hideLoading();
                    }).catch((error) => {
                        ModalService.hideLoading();
                        NotifyService.showError(error);
                    });
            };

            $scope.pageChangedGrupo = function (newPage) {
                return getOdataSearchGrupo().page($scope.gruposList.pageSize, newPage).query().then(updateListGrupo).catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroCampanha');
                $scope.search = { pageSize: 10 };
                $scope.RamalAnterior = null;
                $scope.RedirecionaTipoId = null;
                $scope.executeSearch();
            };

            $scope.limparFiltroGrupo = function () {
                LocalStorageService.removeItem('FiltroGrupo');
                $scope.searchGrupo = { pageSize: 10 };
                $scope.executeSearchGrupo();
            };

            updateList(campanhas);
            updateListGrupo(gruposList);

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, {
                        storage: true
                    });
                } else {
                    $state.go('main.campanha.list', {
                        storage: true
                    });
                }
            };

            $scope.viewDeleteCampanha = function (campanha) {
                if (campanha.CampanhaId > 0) {
                    let tempoCampanhaLimpa = "";
                    let qtdReciclagem  = "";

                    if (campanha.DataValidacao !== null) {
                        let diff = "";
                        let dataValidacao = moment(campanha.DataValidacao);
                        let diferenca = moment.duration(moment().diff(dataValidacao))._data;

                        if (diferenca.years > 0) {
                            diff += `${diferenca.years} ${$translate.instant('modalDelete.anos')}`;
                        }
                        if (diferenca.months > 0) {
                            if (diff !== "") diff += ", ";
                            diff += `${diferenca.months} ${$translate.instant('modalDelete.meses')}`;
                        }
                        if (diferenca.days > 0) {
                            if (diff !== "") diff += ", ";
                            diff += `${diferenca.days} ${$translate.instant('modalDelete.dias')}`;
                        }
                        if (diferenca.hours > 0) {
                            if (diff !== "") diff += ", ";
                            diff += `${diferenca.hours} ${$translate.instant('modalDelete.horas')}`;
                        }
                        if (diferenca.minutes > 0) {
                            if (diff !== "") diff += ", ";
                            diff += `${diferenca.minutes} ${$translate.instant('modalDelete.minutos')}`;
                        }

                        if (diff != "") diff += ` ${$translate.instant('modalDelete.e')} `
                        diff += ` ${diferenca.seconds} ${$translate.instant('modalDelete.segundos')}`;

                        tempoCampanhaLimpa = $translate.instant('modalDelete.tempoCampanhaLimpa', { TempoCampanhaLimpa: diff });
                    }

                    // if(campanha.QtdReciclagem > 0)
                    //     qtdReciclagem = $translate.instant('modalDelete.quantidadeReciclagem', {QtdReciclagem : campanha.QtdReciclagem });
                    
                    if(campanha.QtdReciclagem > 0)
                    {
                        if(campanha.QtdReciclagem == 1)
                            qtdReciclagem = $translate.instant('modalDelete.quantidadeReciclagem', {QtdReciclagem : campanha.QtdReciclagem });
                        else
                            qtdReciclagem = $translate.instant('modalDelete.qtdReciclagem', {QtdReciclagem : campanha.QtdReciclagem });
                    }
                    $scope.campanhaDelete.CampanhaId = campanha.CampanhaId;
                    $scope.campanhaDelete.CampanhaStatusId = campanha.CampanhaStatusId;
                    $scope.campanhaDelete.PendenteAcao = campanha.PendenteAcao;
                    $scope.campanhaDelete.DiscagemVertical = campanha.DiscagemVertical;
                    $scope.campanhaDelete.TempoCampanhaLimpa = tempoCampanhaLimpa;
                    $scope.campanhaDelete.CampanhaTemplateId = campanha.CampanhaTemplateId;
                    $scope.campanhaDelete.QtdReciclagem = qtdReciclagem;
                    $scope.campanhaDelete.CicloDiscagem = campanha.CicloDiscagem;
                    $scope.campanhaDelete.CicloQuantidade = campanha.CicloQuantidade;

                    $scope.campanhaDelete.Validacao = false;
                    ModalService.openModal("modal_delete");
                }
            };

            var pesquisaHistoricoLimpeza = function () {
                CampanhaResource.GetHistoricoLimpeza({
                    campanhaId: $scope.campanhaSelecionada.CampanhaId,
                    dataCadastro: moment($scope.searchHistorico.datacadastro).format('YYYY-MM-DD')
                }).$promise.then((data) => {
                    $scope.campanhaHistoricoLimpeza = data;
                });
            };

            $scope.viewHistoricoLimpeza = function (campanha) {
                if (campanha.CampanhaId > 0) {
                    $scope.campanhaSelecionada = campanha;
                    var data = moment().subtract(1, 'd').toDate();
                    $scope.searchHistorico.datacadastro = data;
                    pesquisaHistoricoLimpeza();
                    ModalService.openModal('modal_historicoLimpeza');
                }
            };

            $scope.executeSearchHistorico = function (source, campanha) {
                if (campanha.CampanhaId > 0) {
                    pesquisaHistoricoLimpeza();
                }
            };

            $scope.zerarCampanha = function () {
                var campanhaId = $scope.campanhaDelete.CampanhaId;

                // Não está em pausa
                if (($scope.campanhaDelete.CampanhaStatusId !== 2 && $scope.campanhaDelete.CampanhaStatusId !== 4) || $scope.campanhaDelete.pendenteAcao == true) {
                    return NotifyService.showError(null, 'telaCampanha.necessarioPausarParaZerar');
                }

                if (campanhaId > 0) {
                    modalConfirm($translate.instant('telaCampanha.desejaManterAgendamentos'), campanhaId, {
                        bgclose: false,
                        keyboard: false,
                        modal: false,
                        labels: {
                            Ok: $translate.instant('campo.sim'),
                            Cancel: $translate.instant('campo.nao')
                        },
                        stack: true
                    });
                }
            }

            var modalConfirm = function (content, campanhaId, options) {
                var modal = $window.UIkit.modal.dialog(([
                    '<div class="uk-margin uk-modal-content">' + String(content) + '</div>',
                    '<div class="uk-modal-footer uk-text-right"><button class="uk-button uk-modal-close js-modal-cancel">' + options.labels.Cancel + '</button> <button class="uk-button uk-button-primary js-modal-confirm">' + options.labels.Ok + '</button></div>'
                ]).join(""), options);

                modal.element.find(".js-modal-confirm").on("click", () => {
                    confirmaAgendamento(campanhaId, true);
                    modal.hide();
                });

                modal.element.find(".js-modal-cancel").on("click", () => {
                    confirmaAgendamento(campanhaId, false);
                    modal.hide();
                });

                modal.on('show.uk.modal', () => {
                    setTimeout(() => {
                        modal.element.find('.js-modal-confirm').focus();
                    }, 50);
                });

                return modal.show();
            }

            var confirmaAgendamento = function (campanhaId, mantemAgendamento) {
                if (campanhaId > 0) {
                    CampanhaResource.zerarCampanha({
                        CampanhaId: campanhaId,
                        MantemAgendamento: mantemAgendamento,
                    }).$promise.then(() => {
                        var index = _.findIndex($scope.campanhas, (el) => { return el.CampanhaId == campanhaId; });
                        if (index >= 0) {
                            if ($scope.campanhas[index].DiscagemVertical == true) {
                                $scope.campanhas[index].PendenteAcao = true;
                            }
                        }
                        NotifyService.showSuccess('telaCampanha.campanhaZeradaComSucesso');
                        ModalService.closeModal('modal_delete');
                    }).catch(NotifyService.showError);
                }
            }

            $scope.exibirDetalhe = function (historico) {
                var msg = `<ul class="md-list"><li><div class="md-list-content"><span class="md-list-heading">${$translate.instant('campo.detalhe')}</span>
                <span class="uk-text-small uk-text-muted">${historico.Descricao}</span></div></li><li><div class="md-list-content">
                <span class="md-list-heading">${$translate.instant('telaCampanha.dtHora')}</span><span class="uk-text-small uk-text-muted">
                ${moment(historico.DataHora).format("DD/MM/YYYY HH:mm")}</span></div></li><li><div class="md-list-content"><span class="md-list-heading">
                ${$translate.instant('telaCampanha.retorno')}</span><span class="uk-text-small uk-text-muted">${historico.MensagemRetorno}</span></div>
                </li><li><div class="md-list-content"><span class="md-list-heading">Json</span><span class="uk-text-small uk-text-muted">
                <pre>${historico.Configuracao}</pre></span></div></li></ul></div>`;

                ModalService.alert(msg);
            }

            $scope.duplicarCampanha = function (campanha) {
                if (campanha) {
                    var tipo = campanha.CampanhaTemplate.CampanhaTipoId;
                    ModalService.confirmMessage('telaCampanha.desejaDuplicarCampanha', null, () => {
                        CampanhaResource.duplicarCampanha({
                            CampanhaId: campanha.CampanhaId
                        }).$promise.then((res) => {
                            var local = '';
                            switch (tipo) {
                                case 1:
                                    local = 'main.campanha.padrao.edit';
                                    break;
                                case 2:
                                    local = 'main.campanha.callback.edit';
                                    break;
                                case 3:
                                    local = 'main.campanha.higienizacao.edit';
                                    break;
                                case 4:
                                    local = 'main.campanha.talkbot.edit';
                                    break;
                            }
                            $state.go(local, { CampanhaId: res.CampanhaId })
                        }).catch(NotifyService.showError);
                    });
                }
            }

            $scope.downloadFileDetail = function (detalhe) {
                try {
                    var path = "Ligacao/Download/" + detalhe.GlobalId + "/" + detalhe.ArquivoDialogo.replace('.vox', '');
                    FileDownloadService.downloadWebApiFile(path);
                } catch (err) {
                    NotifyService.showError(err);
                }
            };

            $scope.abrirPopupRetorno = function (campanha) {
                $scope.campanhaRetornoSelecionado = campanha.CampanhaId;
                $scope.campanhaRetornoTemplateSelecionado = campanha.CampanhaTemplateId;
            }

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }

            $scope.limparFiltroRetorno = function () {
                $scope.filtro = {
                    DataI: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
                    DataF: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                    NB: ''
                };
            }

            $scope.limparFiltroRetorno();

            $scope.exportarRetorno = function (filtro) {
                try {
                    ModalService.showLoading();
                    var fileName = generateUUID();
                    if (filtro == null) filtro = {};
                    CampanhaDiscagemResource.gerarRetorno({
                        CodigoCliente: parseInt(filtro.CodigoCliente || null),
                        CampanhaPadraoId: filtro.CampanhaPadraoId || null,
                        CampanhaDIscagemStatusId: parseInt(filtro.CampanhaDiscagemStatusId || 0),
                        NB: filtro.NB || null,
                        RamalId: parseInt(filtro.RamalId || 0),
                        DataI: filtro.DataI != null ? new moment(filtro.DataI).format("MM/DD/YYYY HH:mm") : null,
                        DataF: filtro.DataF != null ? new moment(filtro.DataF).format("MM/DD/YYYY HH:mm") : null,
                        CampanhaId: $scope.campanhaRetornoSelecionado,
                        CampanhaTemplateId: $scope.campanhaRetornoTemplateSelecionado,
                        FileName: fileName,
                    }).$promise.then(() => {
                        FileDownloadService.downloadWebApiFile("CampanhaDiscagem/Download/" + fileName);
                        ModalService.hideLoading();
                    }).catch((data) => {
                        ModalService.hideLoading();
                        NotifyService.showError(data.error);
                    });
                } catch (err) {
                    NotifyService.showError(err);
                }
            }

            $scope.RamalAnterior = null;
            $scope.RedirecionaTipoId = null;
            $scope.onRedirecionaTipoAlterado = function () {
                $scope.search.RamalId = null;
                $scope.search.GrupoId = null;
                switch ($scope.RedirecionaTipoId) {
                    case 1:
                    case 3:
                    case 4:
                        if ($scope.RamalAnterior) {
                            $scope.search.RamalId = $scope.RamalAnterior;
                        }
                        if ($scope.search.GrupoId) {
                            $scope.RamalAnterior = $scope.search.GrupoId;
                        }
                        break;
                    case 2:
                        if ($scope.RamalAnterior) {
                            $scope.search.GrupoId = $scope.RamalAnterior;
                        }
                        if ($scope.search.RamalId) {
                            $scope.RamalAnterior = $scope.search.RamalId;
                        }
                        break;
                }
            }

            $scope.onGrupoAlterado = function () {
                if ($scope.search.GrupoId > 0) {
                    $scope.grupoSelecionado = _.find($scope.grupos, (el) => {
                        return el.GrupoId == $scope.search.GrupoId;
                    })
                    GrupoResource.get({
                        GrupoId: $scope.search.GrupoId
                    }).$promise.then((res) => {
                        $scope.audioRetencao = res.RetencaoAudio;
                    });
                }
            }

            $scope.exibirAlertas = function () {
                $scope.exibirPerfilDiscagemAlerta = true;
            }

            $scope.onGrupoAlterado();

            $scope.abrirModalBloqueio = function () {
                ModalService.openModal('modal_discagem_bloqueio', null, () => {
                    $scope.consultandoBloqueado = false;
                }, { center: false, bgclose: false })
            }
            
            $scope.pesquisarClienteBloquado = function (codigoCliente) {
                if (codigoCliente != '' && codigoCliente != undefined) {
                    $scope.searchingBloqueado = true;
                    CampanhaResource.GetDiscagemClienteBloqueio({ CodigoCliente: codigoCliente }).$promise.then((data) => {
                        $scope.consultandoBloqueado = true;
                        if (data.CodigoCliente != undefined) {
                            $scope.clienteBloqueado = data;
                        } else {
                            $scope.clienteBloqueado = null;
                        }
                        $scope.searchingBloqueado = false;
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.searchingBloqueado = false;
                    })
                }
            }

            $scope.abrirModalReciclagem = function (campanhaId) {
                ModalService.openModal('modal_reciclagem', null, () => {
                    WizardHandler.wizard().goTo(0);

                    $scope.removerTodosStatus();
                    $scope.campanhaSelecionada = campanhaId;

                    $scope.qtdReciclagem  = "";
 
           
                    if($scope.campanhaSelecionada.QtdReciclagem > 0)
                    {
                     
                        if($scope.campanhaSelecionada.QtdReciclagem == 1)
                            $scope.qtdReciclagem = $translate.instant('modalDelete.quantidadeReciclagem', {QtdReciclagem : $scope.campanhaSelecionada.QtdReciclagem });
                        else
                            $scope.qtdReciclagem = $translate.instant('modalDelete.qtdReciclagem', {QtdReciclagem : $scope.campanhaSelecionada.QtdReciclagem });
                    }
                    CampanhaReciclagemResource.getAllByCampanhaId(campanhaId)
                    .$promise.then((data) => {
                        $scope.historicoReciclagem = data; 
                    });
                }, { center: false, bgclose: false })
            }

			 $scope.removerTodosStatus = function () {
                 $scope.reciclagemTodos = false;
                $scope.campanhaDiscagemStatus.forEach(function(value,index){

                    $scope.campanhaDiscagemStatus[index].Recicla = false;
                })
			};

            $scope.addTodosStatus = function () {
                $scope.reciclagemTodos = true;
                $scope.campanhaDiscagemStatus.forEach(function (value, index) {

                    $scope.campanhaDiscagemStatus[index].Recicla = true;
                })
            };

            $scope.salvarReciclagem = function(){
                let reciclagem = {};                
                let listStatus = [];
                reciclagem.Id = 0;
                reciclagem.CampanhaId = $scope.campanhaSelecionada.CampanhaId;

                $scope.campanhaDiscagemStatus.forEach(s => {
                    if(s.Recicla)
                    {
                        listStatus.push({CampanhaDiscagemStatusId: s.CampanhaDiscagemStatusId});
                    }
                });

                reciclagem.CampanhaReciclagemStatus = listStatus;

                if(listStatus.length > 0){
                    CampanhaReciclagemResource.save(reciclagem)
                    .$promise.then(() => {
                        NotifyService.showRegistroSalvo();
                        ModalService.closeModal('modal_reciclagem');
                    })
                    .catch(error => {
                        NotifyService.showError(error);
                        ModalService.closeModal('modal_reciclagem');
                    }); 
                }  
                else{
                    NotifyService.showError(null, 'modalDelete.statusSelecionado');
                }             
            }


            $scope.AuxStatus = 0;
			$scope.onClickShowModalReciclagemStatus = function (item) {
				if (item.CampanhaReciclagemStatus.CampanhaDiscagemStatus != undefined)
					$scope.AuxStatus = item.CampanhaReciclagemStatus.CampanhaDiscagemStatus;
			}
            
            $scope.StatusDetalhado = [];
            $scope.showModalDetalhado  = false;
            $scope.onModalDetalhado = function(item){
                $scope.showModalDetalhado  = true;
                $scope.StatusDetalhado = item.CampanhaReciclagemStatus;
            }

            $scope.onHideModalDetalhado = function(){
                $scope.showModalDetalhado  = false;
            }

            $scope.onCloseModal = function () {
				var model = UIkit.modal("#modalDetalhado" )
				model.hide();
			}
        }]);
})();
(function () {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 5;

    angular.module("epbxManagerApp")

    .controller("CampanhaRediscagemController", ["$scope", "Config", "$http", "$rootScope", "CampanhaDiscagemRetornoResource", "NotifyService", "$stateParams", "CampanhaResource", "$translate", "CampanhaDiscagemResource", "ModalService", function ($scope, Config, $http , $rootScope, CampanhaDiscagemRetornoResource, NotifyService, $stateParams, CampanhaResource, $translate,
        CampanhaDiscagemResource, ModalService) {
        $scope.campanhaDiscagemRetorno = [];        
        window.moment.locale('pt-BR');
        $scope.campanhaList = [];       
        $scope.permiteRediscagem = false;
        $scope.discagemAcaoClicked = false;
        $scope.statusAnteriorList = [];
        $scope.discagemAgendamentoList = [];
        $scope.search = {};
        $scope.countInternoFinalizado = false;
        $scope.isPageChanged = false;
        $scope.rediscagemCliente = {
            Quantidade: 0,
            QuantidadeCliente: 0
        };

        const periodoStorage = localStorage.getItem('campanha_rediscagem_periodo');
        $scope.periodoSelecionado = periodoStorage === "null" || !periodoStorage ? 60 : parseInt(periodoStorage);

        $scope.periodoConsulta = [
            { Descricao: $translate.instant('telaDetalheCampanha.todos'), Valor: null },
            { Descricao: $translate.instant('telaDetalheCampanha.ultimaHora'), Valor: 60 },
            { Descricao: $translate.instant('telaDetalheCampanha.ultimas4Horas'), Valor: 240 }, 
            { Descricao: $translate.instant('telaDetalheCampanha.ultimas8Horas'), Valor: 480 },
            { Descricao: $translate.instant('telaDetalheCampanha.hoje'), Valor: moment().hours() * 60 + moment().minutes() },
            { Descricao: $translate.instant('telaDetalheCampanha.umaSemana'), Valor: 10080 },
            { Descricao: $translate.instant('telaDetalheCampanha.15Dias'), Valor: 43200 },
            { Descricao: $translate.instant('telaDetalheCampanha.30Dias'), Valor: 86400 }
        ];

        var setTab = function (tabId) {
            var tabMenu = $('#tabMenu');
            if (tabMenu.length) {
                if (tabMenu.children(':not(.ng-hide)').length > 0) {
                    $(tabMenu.children(':not(.ng-hide)')).removeClass('uk-active');
                    $(tabMenu.children(':not(.ng-hide)')[tabId - 1]).addClass('uk-active');

                    var dataUkTab = tabMenu.attr('data-uk-tab');
                    dataUkTab = dataUkTab.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": ');
                    dataUkTab = dataUkTab.replace(/'/g, '"')
                    var tabObject = JSON.parse(dataUkTab);

                    $($(tabObject.connect).children(':not(.ng-hide)')).removeClass('uk-active');
                    $($(tabObject.connect).children(':not(.ng-hide)')[0]).addClass('uk-active');
                }
            }
        };  

        var updateList = function (pagination) {            
            $scope.campanhaDiscagemRetorno = pagination.Data;
            $scope.campanhaDiscagemRetorno.recordCount = pagination.RecordCount;
            $scope.campanhaDiscagemRetorno.currentPage = pagination.PageIndex || 1;
            $scope.campanhaDiscagemRetorno.pageSize = pagination.PageSize || defaultPageSize;          
            
        };

        $scope.getOdataSearch = function () {
            $scope.submitted = true;
            var url = Config.getUrl("CampanhaDiscagemRetorno/") + defaultPageIndex + "/" + defaultPageSize;

            
            var filtro = {
                CampanhaId: $scope.search.CampanhaId,
                CampanhaDiscagemStatusId: $scope.search.CampanhaDiscagemStatusId,
                CodigoCliente: $scope.search.CodigoCliente,                
                Telefone: $scope.search.Telefone,
                Periodo: $scope.periodoSelecionado,
                Visao: $scope.search.Visao,
                OrderBy: $scope.orderBy.column + " " + $scope.orderBy.order
            };

            if (!$scope.isPageChanged) {
                $scope.countFinalizado = false;
                $scope.countInternoFinalizado = false;
                $scope.retornoQuantidade = -1;

                CampanhaDiscagemRetornoResource.getCount(filtro).$promise
                    .then((data) => {
                        if ($scope.countInternoFinalizado == false) {
                            $scope.retornoQuantidade = data.Quantidade;
                            $scope.countInternoFinalizado = true;
                        }
                    });
            }

            return $http({ method: 'GET', url: url, params: filtro })
                .then((response) => {
                    return response.data;
                });
        };

        $scope.pageChanged = function (newPage) {
            if (defaultPageIndex != newPage) {                
                defaultPageIndex = newPage;
                $scope.isPageChanged = true;
                $scope.getOdataSearch()
                .then((list) => {
                    updateList(list);  
                    $scope.isPageChanged = false;                    
                }).catch((error) => {
                    NotifyService.showError(error); 
                    $scope.isPageChanged = false;                      
                });
            }
        };

        $scope.changePageSize = function () {
            defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
            $scope.executeSearch();
        }

        $scope.viewChamadaDetalhe = function (chamada) {
            if (chamada) {
                var dadosHistorico = {
                    filtro: null,
                    chamada: chamada
                };
                ModalService.openModal('modal_detalhe');
                $rootScope.$broadcast('onDetalheHistorico', dadosHistorico);
            }
        }

        $scope.limparFiltroRediscagem = function () {
            $scope.search = {};
            setTab(1);
            $scope.campanhaDiscagemRetorno = [];
            $scope.rediscagemCliente = {
                Quantidade: 0,
                QuantidadeCliente: 0
            };

            $scope.discagemAcao = {
                ReutilizaCampanha: true,
                Quantidade: $scope.rediscagemCliente.Quantidade,
                DataAgendamento: moment().add(1, 'm').seconds(0).milliseconds(0).toDate(),
                DataI: $scope.dataI,
                DataF: $scope.dataF,
                CampanhaId: parseInt($stateParams.CampanhaId),
                CampanhaDestino: 0,
                CampanhaDiscagemStatusId: ($scope.rediscagem ? $scope.rediscagem.DiscagemStatusId : 0),
                Tempo: 0,
            };
        }

        $scope.$on("carrega_campanha_redisagem", function (event, data) {
            $scope.rediscagem.DiscagemStatus = data.DiscagemStatus;
            $scope.rediscagem.QuantidadeTotal = data.QuantidadeTotal;
            $scope.rediscagem.Quantidade = data.Quantidade;
            $scope.rediscagem.QuantidadeDisponivel = data.QuantidadeDisponivel;
            $scope.rediscagem.DiscagemStatusId = data.DiscagemStatusId;
            $scope.rediscagem.PeriodoDescricao = data.PeriodoDescricao;
            $scope.permiteRediscagem = data.PermiteRediscagem;
            $scope.discagemAcaoClicked = false;

            $scope.carregaDiscagemAnterior();

            if ($scope.permiteRediscagem) {
                $scope.carregaStatusRediscagem();
            }
            $scope.limparFiltroRediscagem();
            $scope.limparFiltroAgendamento();

            if(data.Visao == 2) {
                $scope.periodoSelecionado = _.find($scope.periodoConsulta, function (periodo) {
                    return periodo.Descricao == data.PeriodoDescricao;
                }).Valor;        
            } else {
                $scope.periodoSelecionado = 0;
            }

            $scope.search = {            
                CampanhaId: $stateParams.CampanhaId || 0,            
                CampanhaDiscagemStatusId: $scope.rediscagem.DiscagemStatusId || 0,
                Periodo: $scope.periodoSelecionado || 0,
                Visao: data.Visao
            };

        });

        $scope.carregaStatusRediscagem = function () {
            var campanhaId = parseInt($stateParams.CampanhaId);
            var campanhaStatusDetalheId = $scope.rediscagem.DiscagemStatusId;
            var tempo = $scope.tempo;
            if (campanhaId > 0 && campanhaStatusDetalheId > 0) {
                var promise = CampanhaDiscagemRetornoResource.detalheRediscagem({
                    CampanhaId: campanhaId,
                    CampanhaDiscagemStatusId: campanhaStatusDetalheId,
                    Tempo: tempo,
                }).$promise;

                if (promise) {
                    promise.then(function (data) {
                        angular.copy(data, $scope.rediscagemCliente);
                    });
                }
            }
        }

        $scope.carregaDiscagemAnterior = function () {
            var campanhaId = parseInt($stateParams.CampanhaId);
            var campanhaStatusDetalheId = $scope.rediscagem.DiscagemStatusId;
            if (campanhaId > 0 && campanhaStatusDetalheId > 0) {
                var promise = CampanhaDiscagemRetornoResource.discagemStatusAnterior({
                    CampanhaId: campanhaId,
                    CampanhaDiscagemStatusId: campanhaStatusDetalheId,
                    Tempo: $scope.tempo,
                }).$promise;

                if (promise) {
                    promise.then(function (data) {
                        angular.copy(data, $scope.statusAnteriorList);
                    });
                }
            }
        };

        $scope.carregaCampanha = function () {
            if ($scope.discagemAcao) {
                if (!$scope.discagemAcao.ReutilizaCampanha) {
                    var odata = CampanhaResource.odata().orderBy('Nome', 'asc');
                    odata.filter("CampanhaId", "!=", parseInt($stateParams.CampanhaId));
                    var promise = odata.query();

                    if (promise) {
                        promise.then(function (data) {
                            angular.copy(data, $scope.campanhaList);
                        }).catch(NotifyService.showError);
                    }
                }
            }
        }

        $scope.changePeriodo = function (periodo) {
            localStorage.removeItem('campanha_rediscagem_periodo');
            localStorage.setItem('campanha_rediscagem_periodo', periodo);            
            $scope.periodoSelecionado = periodo;
        }
        
        $scope.executeSearch = function () {
           
            $scope.orderBy = {
                column: "DataRetorno",
                order: "Desc"
            };

            defaultPageIndex = 1;
            $scope.getOdataSearch()
                .then(updateList)
                .catch((error) => {
                    NotifyService.showError(error);                    
                });
        };

        $scope.processaCampanhaAcao = function (discagemAcao) {
            $scope.discagemAcaoClicked = true;
            if ($scope.permiteRediscagem) {
                if (discagemAcao.Quantidade > 0 && discagemAcao.Quantidade <= $scope.rediscagemCliente.Quantidade) {
                    var dtAgendamento = discagemAcao.DataAgendamento ? new moment(discagemAcao.DataAgendamento) : null;
                    discagemAcao.DataAgendamento = new moment(dtAgendamento).format("YYYY/MM/DD HH:mm");
                    if ($scope.tempo) {
                        discagemAcao.Tempo = $scope.tempo;
                    }
                    var promise = CampanhaDiscagemResource.processaCampanhaDiscagemAcao(discagemAcao).$promise;

                    if (promise)
                        promise.then(function () {
                            $scope.discagemAcaoClicked = false;
                            NotifyService.showSuccess();
                            var modal = $.UIkit.modal('#modal_rediscagem');
                            if (modal)
                                modal.hide();
                        }).catch(function () {
                            $scope.discagemAcaoClicked = false;
                            NotifyService.showError();
                        });
                } else {
                    $scope.discagemAcaoClicked = false;
                    NotifyService.showError(null, 'modalRediscagem.quantidadeDeRegistrosInvalida');
                }
            } else {
                $scope.discagemAcaoClicked = false;
                NotifyService.showError(null, 'modalRediscagem.paraEsseStatusNaoEPermitidaRediscagem');
            }
        };

        $scope.limparFiltroAgendamento = function () {
            $scope.searchAgendamento = {
                Intervalo: 15,
                Periodo: 4,
            };
            $scope.discagemAgendamentoList = [];
        };

        $scope.isAgendamento = function () {
            var statusAgendamento = [9, 10];
            return statusAgendamento.includes($scope.rediscagem.DiscagemStatusId);
        }

        $scope.viewAmostragemStatusAnterior = function (statusAnteriorId) {
            $scope.search.DiscagemStatusAnteriorId = statusAnteriorId;
            $scope.executeSearch();
            setTab(1);
        }

        $scope.executeSearchAgendamento = function () {
            var campanhaId = $scope.campanha.CampanhaId;
            if (campanhaId > 0 && $scope.rediscagem.DiscagemStatusId > 0) {
                var promise = CampanhaDiscagemRetornoResource.discagemAgendamento({
                    Periodo: $scope.searchAgendamento.Periodo,
                    Intervalo: $scope.searchAgendamento.Intervalo,
                    CampanhaId: campanhaId,
                    CampanhaDiscagemStatusId: $scope.rediscagem.DiscagemStatusId,
                }).$promise;

                if (promise) {
                    promise.then(function (result) {
                        angular.copy(result, $scope.discagemAgendamentoList);
                    });
                } else $scope.discagemAgendamentoList = [];
            }
        };
    }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CampanhaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Campanha/:CampanhaId", { "CampanhaId": "@CampanhaId" }, {
                duplicarCampanha: {
                    url: "Campanha/Duplicar",
                    method: "POST",
                    params: {
                        "CampanhaId": "@CampanhaId"
                    }
                },
                processaCampanhaConfiguracao: {
                    url: "Campanha/ProcessaCampanhaConfiguracao",
                    method: "POST"
                },
                processaCampanhaLote: {
                    url: "Campanha/ProcessaCampanhaLote",
                    method: "POST"
                },
                processaReiniciaCampanha: {
                    url: "Campanha/ProcessaReiniciaCampanha",
                    method: "POST"
                },
                setReiniciaCampanha: {
                    url: "Campanha/SetReiniciaCampanha",
                    method: "POST"
                },
                campanhaHistorico: {
                    url: "Campanha/Historico",
                    method: "GET",
                    isArray: true
                },
                alarmes: {
                    url: "AlarmeCampanha/Alarmes",
                    method: "GET",
                    isArray: true
                },
                campanhaAcao: {
                    url: "Campanha/StatusAcao",
                    method: "GET",
                    isArray: true
                },
                campanhaDetalhe: {
                    url: "Campanha/Detalhe",
                    method: "GET",
                    isArray: true
                },
                campanhaDetalheCliente: {
                    url: "Campanha/DetalheCliente",
                    method: "GET",
                    isArray: true
                },
                campanhaResumo: {
                    url: "Campanha/Resumo",
                    method: "GET",
                    isArray: true
                },
                campanhaResumoCliente: {
                    url: "Campanha/ResumoCliente",
                    method: "GET",
                    isArray: true
                },
                canaisDiscando: {
                    url: "MonitorCanal/CanaisDiscando/:campanhaId",
                    method: "GET",
                    isArray: false,
                    params: {
                        "campanhaId": "@campanhaId"
                    }
                },
                canaisFalando: {
                    url: "MonitorCanal/CanaisFalando/:campanhaId",
                    method: "GET",
                    isArray: false,
                    params: {
                        "campanhaId": "@campanhaId"
                    }
                },
                campanhaDashboardIndicadores: {
                    url: "RelatorioVisualSMS/GetDashboardIndicadores",
                    method: "GET",
                    isArray: false
                },
                zerarCampanha: {
                    url: "Campanha/ZerarCampanha",
                    method: "POST",
                    params: {
                        "CampanhaId": "@CampanhaId"
                    }
                },
                reciclarCampanha: {
                    url: "Campanha/ReciclarCampanha",
                    method: "POST",
                    params: {
                        "CampanhaId": "@CampanhaId"
                    }
                },
                GetLayoutItems: {
                    url: "Campanha/:campanhaId/LayoutItem",
                    method: "GET",
                    isArray: true
                },
                GetHistoricoLimpeza: {
                    url: "Campanha/:campanhaId/HistoricoLimpeza",
                    method: "GET",
                    isArray: true
                },
                GetPerfilDiscagem: {
                    url: "Campanha/:campanhaId/PerfilDiscagem",
                    method: "GET",
                    isArray: false
                },
                PutPerfilDiscagem: {
                    url: "Campanha/:CampanhaId/PerfilDiscagem",
                    method: "PUT",
                    isArray: false
                },
                GetPerfilDiscagemAlerta: {
                    url: "Campanha/PerfilDiscagem/Alerta",
                    method: "GET",
                    isArray: true
                },
                GetTodasCampanhas: {
                    url: "Campanha/GetTodasCampanhas",
                    method: "GET",
                    isArray: true
                },
                GetCampanhasPorTipo: {
                    url: "Campanha/GetCampanhasPorTipo/:campanhaTipoId",
                    method: "GET",
                    isArray: true,
                    params: {
                        "campanhaTipoId": "@campanhaTipoId"
                    }
                },
                GetCampanhasPorGrupo: {
                    url: "Campanha/CampanhasPorGrupo/:grupoId",
                    method: "GET",
                    isArray: true,
                    params: {
                        "grupoId": "@grupoId"
                    }
                },
                GetCampanhasPorGrupoComConfiguracao: {
                    url: "Campanha/CampanhasPorGrupoComConfiguracao/:grupoId",
                    method: "GET",
                    isArray: true,
                    params: {
                        "grupoId": "@grupoId"
                    }
                },
                GetTemplateLimpezaPorCampanha: {
                    url: "CampanhaTemplateLimpeza/GetPorCampanhaId",
                    method: "GET",
                    isArray: false,
                    params: {
                        "CampanhaId": "@CampanhaId"
                    }
                },
                GetCampanhasTipo: {
                    url: "CampanhaTipo",
                    method: "GET",
                    isArray: true
                },               
                telefoneTipos: {
                    url: "TelefoneTipo/GetByIds",
                    method: "GET",
                    isArray: true
                },
                gravarAvancado: {
                    method: "PUT",
                    url: "Campanha/:grupoId/Avancado",
                    params: {
                        "grupoId": "@grupoId"
                    },
                    isArray: false
                },
                desvincular: {
                    method: "PUT",
                    url: "Campanha/:campanhaId/:grupoId",
                    params: {
                        "campanhaId": "@campanhaId",
                        "grupoId": "@grupoId"
                    },
                    isArray: true
                },
                getCampanhasSemConfiguracaoAvancada: {
                    url: "Campanha/CampanhasSemConfiguracaoAvancada",
                    method: "GET",
                    isArray: true
                },
                getIndicadorFlutuante: {
                    url: "Campanha/IndicadorFlutuante",
                    method: "GET",
                    isArray: true,
                    params: {
                        "grupoId": "@grupoId",
                    }
                },
                getFlutuante: {
                    url: "Campanha/Flutuante",
                    method: "GET",
                    isArray: true,
                },
                atualizarCampanhaFlutuantePrioridade: {
                    method: "PUT",
                    url: "Campanha/FlutuantePrioridade",
                    params: {
                        "campanhaId": "@campanhaId",
                        "flutuante": "@flutuante",
                        "prioridade": "@prioridade"
                    }
                },
                removerCampanhaFlutuante: {
                    method: "Delete",
                    url: "Campanha/Flutuante/:campanhaId",
                    params: {
                        "campanhaId": "@campanhaId"
                    }
                },
                GetBlacklist: {
                    url: "Campanha/Blacklist",
                    method: "GET"
                },
                GetDiscagemClienteBloqueio: {
                    url: "Campanha/GetDiscagemClienteBloqueio",
                    method: "GET"
                },
                CampanhasComPreMetra: {
                    url: "Campanha/CampanhasComPreMetra",
                    method: "GET",
                    isArray: true
                },
                BigTalkServicoStatus: {
                    url: "BigTalk/ServicoStatus",
                    method: "GET",
                    isArray: false
                },
                GetLimpezaTipo: {
                    url: "Campanha/LimpezaTipo",
                    method: "GET",
                    isArray: true
                },
                getTemplatePeriodo: {
                    url: "TemplateCampanhaPeriodo/PeriodoPorCampanha",
                    method: "GET",
                    params: {
                        "campanhaId": "@campanhaId"
                    },
                    isArray: true
                },
                GetDiscagemIgnoraStatusAssociado: {
                    url: "DiscagemIgnoraStatus/DiscagemIgnoraStatusAssociado",
                    method: "GET",
                    isArray: true,
                    params: {
                        "campanhaId": "@campanhaId"
                    }
                },
                GetDiscagemIgnoraStatusNaoAssociado: {
                    url: "DiscagemIgnoraStatus/DiscagemIgnoraStatusNaoAssociado",
                    method: "GET",
                    isArray: true,
                    params: {
                        "campanhaId": "@campanhaId"
                    }
                },
                AddDiscagemIgnoraStatus: {
                    method: "POST",
                    url: "DiscagemIgnoraStatus/AddDiscagemIgnoraStatus"
                },
                InativarDiscagemIgnoraStatus: {
                    method: "PUT",
                    url: "DiscagemIgnoraStatus/InativarDiscagemIgnoraStatus",
                    isArray: true,
                    params: {
                        "campanhaId": "@campanhaId"
                    }
                },
                validarLimiteCampanha: {
                    url: "Campanha/ValidarLimiteCampanha",
                    method: "GET",
                    isArray: false
                }
            });
        }])
        .factory("CampanhaFlutuanteTrackingResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Campanha/FlutuanteTracking");
        }])        
        .factory("CampanhaDiscagemRetornoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaDiscagemRetorno/:CampanhaDiscagemRetornoId", { "CampanhaDiscagemRetornoId": "@CampanhaDiscagemRetornoId" },
                {
                    discagemStatusAnterior: {
                        url: "CampanhaDiscagemRetorno/StatusAnterior",
                        method: "GET",
                        isArray: true
                    },
                    discagemAgendamento: {
                        url: "CampanhaDiscagemRetorno/Agendamento",
                        method: "GET",
                        isArray: true
                    },
                    detalheRediscagem: {
                        url: "CampanhaDiscagemRetorno/Rediscagem",
                        method: "GET",
                        isArray: false
                    },
                    getCount: {
                        url: "CampanhaDiscagemRetorno/Count",
                        method: "GET"
                    },
                });
        }])
        .factory("CampanhaDiscagemResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaDiscagem/:CampanhaDiscagemId", { "CampanhaDiscagemId": "@CampanhaDiscagemId" }, {
                processaCampanhaDiscagemAcao: {
                    url: "CampanhaDiscagem/ProcessaCampanhaDiscagemAcao",
                    method: "POST"
                },
                gerarRetorno: {
                    url: "CampanhaDiscagem/Exportar",
                    method: "POST"
                },
                downloadRetorno: {
                    url: "CampanhaDiscagem/Download",
                    method: "GET"
                },
                getCampanhaDiscagemPreview:{
                    url: "CampanhaDiscagem/GetCampanhaDiscagemPreview",
                    method: "GET",
                    isArray: true
                },
                getContatoPreviewByCodCliente:{
                    url: "CampanhaDiscagem/GetContatoPreviewByCodCliente",
                    method: "GET",
                    isArray: true,
                    params: {
                        campanhaId: "@campanhaId",
                        codigoCliente: "@codigoCliente",
                        campanhaDiscagemId: "@campanhaDiscagemId"
                    }
                },
                setCampanhaDiscagemRetornoPreview:{
                    url: "CampanhaDiscagem/SetCampanhaDiscagemRetornoPreview",
                    method: "POST",
                    isArray: false                  
                },
                getDiscagemPreviewContato:{
                    url: "CampanhaDiscagem/GetDiscagemPreviewContato",
                    method: "GET",
                    isArray: true,
                    params: {
                        nome: "@nome",
                        codigoCliente: "@codigoCliente",
                        telefone: "@telefone"
                    }
                },
                setCampanhaDiscagemRediscagem:{
                    url: "CampanhaDiscagem/SetCampanhaDiscagemRediscagem",
                    method: "POST",
                    isArray: false                  
                },
            });
        }])
        .factory("CampanhaTemplateResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaTemplate/:CampanhaTemplateId", { "CampanhaTemplateId": "@CampanhaTemplateId" }, {
                campanhaTemplateCampo: {
                    url: "CampanhaTemplate/Campos",
                    method: "GET",
                    isArray: true
                },
            });
        }])
        .factory("CampanhaDiscagemStatusResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaDiscagemStatus/:CampanhaDiscagemStatusId", { "CampanhaDiscagemStatusId": "@CampanhaDiscagemStatusId" }, {
                GetCampanhas: {
                    url: "IntegracaoVisualSMS/GetCampanhas",
                    method: "GET",
                    isArray: false
                },
                GetLayoutCampanha: {
                    url: "IntegracaoVisualSMS/GetLayoutCampanha/:campanhaId",
                    method: "GET",
                    isArray: true
                },
            });
        }])
        .factory("CampanhaLayoutResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaLayout/:CampanhaLayoutId", { "CampanhaLayoutId": "@CampanhaLayoutId" });
        }])
        .factory("CampanhaStatusResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaStatus/:CampanhaStatusId", { "CampanhaStatusId": "@CampanhaStatusId" });
        }])
        .factory("CampanhaHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaHistorico/:CampanhaId", { "CampanhaId": "@CampanhaId" }, {
                campanhaHistoricoDetalhe: {
                    url: "CampanhaHistorico/CampanhaHistoricoDetalhe",
                    method: "GET",
                    isArray: true
                },
                exportar: {
                    url: "CampanhaHistorico/Exportar",
                    method: "POST",
                }, 
                download: {
                    url: "CampanhaHistorico/Download",
                    method: "GET",  
                }, 
            });
        }])
        .factory("CampanhaCampoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaCampo/:CampanhaId", { "CampanhaId": "@CampanhaId" }, {
                getItens: {
                    url: "CampanhaCampo/Itens",
                    method: "GET",
                    isArray: true
                },
            });
        }])       
        .factory("CampanhaReciclagemResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaReciclagem/:Id", { "Id": "@Id" }, {
                getAllByCampanhaId: {
                    url: "CampanhaReciclagem/GetAllByCampanhaId",
                    method: "GET",
                    isArray: true
                }
            });
        }])
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .service('CampanhaArquivoEditData', function CampanhaArquivoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_fileUpload',
                            'lazy_dropify',
                            'lazy_wizard'
                        ]);
                    }],
                    campanha: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        return CampanhaResource.get({
                            CampanhaId: $stateParams.CampanhaId
                        }).$promise;
                    }],
                    limiteImportacao : ["CampanhaArquivoResource", "$stateParams", function(CampanhaArquivoResource, $stateParams){
                        return CampanhaArquivoResource.getIndicadorImportacaoCampanha({
                            CampanhaId: $stateParams.CampanhaId
                        }).$promise;
                    }]
                }
            }
        })

        .filter('cut', function () {
            return function (value, wordwise, max, tail) {
                if (!value) return '';

                max = parseInt(max, 10);
                if (!max) return value;
                if (value.length <= max) return value;

                value = value.substr(0, max);
                if (wordwise) {
                    let lastspace = value.lastIndexOf(' ');
                    if (lastspace != -1) {
                        //Also remove . and , so its gives a cleaner result.
                        if (value.charAt(lastspace - 1) == '.' || value.charAt(lastspace - 1) == ',') {
                            lastspace = lastspace - 1;
                        }
                        value = value.substr(0, lastspace);
                    }
                }
                return value + (tail || ' …');
            };
        })

        // Não remover dependencia "preloaders"
        .controller("CampanhaArquivoEditController", ["preloaders", "$rootScope", "$scope", "$state", "Upload", "$timeout", "$window", "$http", "Config", "CampanhaArquivoResource", "campanha", "FileDownloadService", "NotifyService", "ModalService", "WizardHandler", "limiteImportacao", function (preloaders, $rootScope, $scope, $state, Upload, $timeout, $window, $http, Config, CampanhaArquivoResource, campanha,
            FileDownloadService, NotifyService, ModalService, WizardHandler, limiteImportacao) {
            let urlUpload = Config.getUrl("CampanhaArquivo/Importar");
            let STATUS_AGCONFIRMACAO = 7;
            let STATUS_SUCESSO = 5;
            let STATUS_CANCELADO = 4;
            let STATUS_ERRO = 3;

            $scope.campanha = campanha;
            $scope.limiteImportacao = limiteImportacao;
            $scope.CampanhaArquivo = {
                CampanhaArquivoId: 0,
                CampanhaId: campanha.CampanhaId,
                Nome: '',
                Descricao: ''
            };
            $scope.ImportacaoStepData = {
                order: 1
            };
            $scope.ResumoStepData = {
                order: 2,
                notVisible: true
            };
            $scope.ResultadoStepData = {
                order: 3,
                notVisible: true
            };
            $scope.Arquivos = [];
            $scope.ArquivoProgresso = [];
            $scope.files = [];
            $scope.filtros = [{}];
            $scope.arquivosProcessados = 0;
            $scope.ZerarCampanhaImportacaoArquivo = false;
            $scope.bloquearZerarCampanha = false;
            let timeoutMap = {};

            function agendarVerificacao(arquivo, delay) {
                let id = arquivo.CampanhaArquivoId;
                $timeout.cancel(timeoutMap[id]);
                timeoutMap[id] = $timeout(() => verificaProgresso(arquivo), delay, true);
            }

            $scope.$on('$destroy', function () {
                Object.keys(timeoutMap).forEach(function (id) { $timeout.cancel(timeoutMap[id]); });
                timeoutMap = {};
            });

            $scope.uploadFiles = function (files, errFiles, ZeraCampanha) {

                $scope.bloquearZerarCampanha = true;

                if (files.length == 0 && errFiles.length == 0) return;
                $scope.errFiles = errFiles;
                angular.forEach(files, function (f) {
                    $scope.files.push(f);
                });

                angular.forEach(files, function (file) {
                    file.upload = Upload.upload({
                        url: urlUpload,
                        data: {
                            file: file,
                            nome: file.name,
                            campanhaId: $scope.CampanhaArquivo.CampanhaId,
                            ZeraCampanha: ZeraCampanha
                        }
                    });

                    file.upload.then(function (response) {
                        let arquivo = {
                            CampanhaArquivoId: response ? response.data : 0,
                            CampanhaArquivoStatusId: 1,
                            ArquivoNome: file.name
                        };

                        $scope.Arquivos.push(arquivo);

                        file.ArquivoId = arquivo.CampanhaArquivoId;

                        agendarVerificacao(arquivo, 1000);

                        let drEvent = $('.dropify').dropify();
                        drEvent = drEvent.data('dropify');
                        drEvent.resetPreview();
                        drEvent.clearElement();

                    }, function (response) {
                        if (response.status > 0)
                            $scope.errorMsg = response.status + ': ' + response.data;
                    }, function (evt) {
                        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                    });
                });
            }

            function verificaProgresso(arquivo) {
                if (arquivo.CampanhaArquivoId > 0 &&
                    arquivo.CampanhaArquivoStatusId != STATUS_SUCESSO &&
                    arquivo.CampanhaArquivoStatusId != STATUS_ERRO) {

                    let promise = CampanhaArquivoResource.ConsultaProgresso({
                        campanhaArquivoId: arquivo.CampanhaArquivoId
                    }).$promise;

                    promise.then(function (data) {
                        if (data.CampanhaArquivoId > 0) {

                            let arquivoProgresso = _.findWhere($scope.ArquivoProgresso, {
                                CampanhaArquivoId: data.CampanhaArquivoId
                            });

                            if (arquivoProgresso)
                                angular.copy(data, arquivoProgresso);
                            else
                                $scope.ArquivoProgresso.push(data);

                            const arquivoAtual = _.findWhere($scope.Arquivos, {
                                CampanhaArquivoId: data.CampanhaArquivoId
                            });
                            if (arquivoAtual != null) {
                                arquivoAtual.CampanhaArquivoStatusId = data.CampanhaArquivoStatusId;

                                if (data.CampanhaArquivoStatusId == 1 || data.CampanhaArquivoStatusId == 2) {
                                    agendarVerificacao(arquivo, 3000);
                                } else {
                                    $scope.arquivosProcessados++;
                                }
                            }
                        }
                    }).catch(NotifyService.showError);
                }
            }

            $scope.isUploadConcluido = function () {
                let arquivos = _.filter($scope.files, function (arquivo) {
                    return arquivo.progress == 100
                });

                return $scope.files.length > 0 && arquivos.length == $scope.files.length ? true : false;
            };

            $scope.isImportacaoConcluida = function () {
                let arquivos = _.filter($scope.ArquivoProgresso, function (arquivo) {
                    return arquivo.CampanhaArquivoStatusId == STATUS_SUCESSO || arquivo.CampanhaArquivoStatusId == STATUS_AGCONFIRMACAO || arquivo.Progresso >= 100;
                });

                return arquivos.length > 0 && $scope.files.length > 0;
            };

            $scope.formatSizeUnits = function (bytes) {
                if (bytes >= 1000000000) {
                    bytes = (bytes / 1000000000).toFixed(2) + ' GB';
                } else if (bytes >= 1000000) {
                    bytes = (bytes / 1000000).toFixed(2) + ' MB';
                } else if (bytes >= 1000) {
                    bytes = (bytes / 1000).toFixed(2) + ' KB';
                } else if (bytes > 1) {
                    bytes = bytes + ' bytes';
                } else if (bytes == 1) {
                    bytes = bytes + ' byte';
                } else {
                    bytes = '0 byte';
                }
                return bytes;
            };

            $scope.adicionarFiltro = function () {
                $scope.filtros.push({});
            };

            $scope.limparFiltro = function (obj) {
                $scope.filtros.splice($scope.filtros.indexOf(obj), 1);
            };

            $scope.getArquivosImportados = function () {
                return _.where($scope.Arquivos, {
                    CampanhaArquivoStatusId: STATUS_SUCESSO
                });
            };

            $scope.confirmaImportacao = function () {
                let qtdImportacao = 0;

                angular.forEach($scope.ArquivoProgresso, function (arquivo) {
                    qtdImportacao += arquivo.QuantidadeTotal;
                });

                if($scope.limiteImportacao.ExcedeuMaxImportacao)
                {
                    NotifyService.showError(null, 'telaCampanhaArquivoEdit.excedeuLimiteImportacao');
                } 
                else 
                {
                    if(qtdImportacao > $scope.limiteImportacao.QtdDisponivelImportacao)
                    {
                        ModalService.confirmImportacao(() => processar());
                    }
                    else
                    {
                        processar()
                    }
                }
            };


            let postProcessaCampanhaArquivo = function (callbackSuccess, callbackError) {               
                $http.post(Config.getUrl('CampanhaArquivo/ProcessaArquivos'), $scope.Arquivos).then(callbackSuccess).catch(callbackError);
            };

            let processar = function () {
                $scope.isStepFinal = true;
                ModalService.showLoading();

                postProcessaCampanhaArquivo(() => {
                    ModalService.hideLoading();
                    $state.go("main.campanha.arquivos.list", $scope.campanha);
                }, (error) => { NotifyService.showError(null, error); });
            };

            let deleteArquivo = function (data) {
                return CampanhaArquivoResource.delete({
                    CampanhaArquivoId: data.CampanhaArquivoId
                }).$promise
                    .then(function () {
                        NotifyService.showSuccess();
                        if (data.CampanhaArquivoStatusId == 3 || data.Progresso >= 100) {
                            $scope.arquivosProcessados--;
                        }
                        if (data.CampanhaArquivoId > 0) {
                            $scope.files.splice(_.indexOf($scope.files, _.findWhere($scope.files, {
                                ArquivoId: data.CampanhaArquivoId
                            })), 1);
                            $scope.ArquivoProgresso.splice(_.indexOf($scope.ArquivoProgresso, _.findWhere($scope.ArquivoProgresso, {
                                CampanhaArquivoId: data.CampanhaArquivoId
                            })), 1);
                            $scope.Arquivos.splice(_.indexOf($scope.Arquivos, _.findWhere($scope.Arquivos, {
                                CampanhaArquivoId: data.CampanhaArquivoId
                            })), 1);
                        }
                    })
                    .catch(NotifyService.showError);
            };

            $scope.baixarArquivo = function () {
                try {
                    FileDownloadService.downloadWebApiFile("CampanhaLayout/DownloadModelo/" + $scope.campanha.CampanhaLayoutId);
                } catch (ex) {
                    NotifyService.showError(null, 'telaCampanhaArquivoEdit.naoFoiPossivelConcluirODownload');
                }
            };

            let deleteArquivoUpload = function (data) {
                return CampanhaArquivoResource.delete({ CampanhaArquivoId: data.ArquivoId }).$promise
                    .then(function () {
                        NotifyService.showSuccess();
                        if (data.ArquivoId > 0) {
                            $scope.files.splice(_.indexOf($scope.files, _.findWhere($scope.files, {
                                ArquivoId: data.ArquivoId
                            })), 1);

                            $scope.ArquivoProgresso.splice(_.indexOf($scope.ArquivoProgresso, _.findWhere($scope.ArquivoProgresso, {
                                CampanhaArquivoId: data.ArquivoId
                            })), 1);

                            $scope.Arquivos.splice(_.indexOf($scope.Arquivos, _.findWhere($scope.Arquivos, {
                                CampanhaArquivoId: data.ArquivoId
                            })), 1);
                        }
                    })
                    .catch(NotifyService.showError);
            };

            let deleteArquivoProcessado = function (arquivo) {
                return CampanhaArquivoResource.delete({
                    CampanhaArquivoId: arquivo.CampanhaArquivoId
                }).$promise
                    .then(function () {
                        NotifyService.showSuccess();
                        if (arquivo.CampanhaArquivoId > 0) {
                            angular.forEach($scope.Arquivos, function (value) {
                                if (value.CampanhaArquivoId == arquivo.CampanhaArquivoId) {
                                    value.CampanhaArquivoStatusId = STATUS_CANCELADO;
                                }
                            });
                        }
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(function () {
                    deleteArquivo(data);
                    if ($scope.ArquivoProgresso.length == 1) {
                        WizardHandler.wizard().previous();
                    }
                });
            };

            $scope.confirmDeleteUpload = function (data) {
                ModalService.confirmDelete(() => deleteArquivoUpload(data));
            };

            $scope.confirmDeleteProcessado = function (data) {
                ModalService.confirmDelete(() => deleteArquivoProcessado(data).then(() => verificaProgresso(data)));
            };

            $scope.ArquivosItem = [];

            $scope.viewAmostraHigienizado = function (arquivo) {
                $scope.ArquivosItem = [];
                $scope.ArquivosItemPartial = [];
                $scope.motivos = [];
                if (arquivo.CampanhaArquivoId) {
                    $scope.ArquivoHiginizadoNome = arquivo.Nome;
                    $scope.ArquivoHiginizadoId = arquivo.CampanhaArquivoId;
                    let promise = CampanhaArquivoResource.ResumoMotivo({
                        campanhaArquivoId: arquivo.CampanhaArquivoId
                    }).$promise;

                    if (promise) {
                        $rootScope.content_preloader_show();
                        promise.then(function (data) {
                            angular.copy(data, $scope.motivos);
                            ModalService.openModal('modal_arquivo_higienizado');
                            $rootScope.content_preloader_hide();
                        })
                            .catch(function () {
                                NotifyService.showError();
                                $rootScope.content_preloader_hide();
                            });
                    }
                }
            };

            $scope.quantidadeArquivo = 10;
            $scope.loadMoreArquivo = function (motivo) {
                if (motivo.aberto == true && motivo.loading != true) {
                    if (!motivo.Pagina) {
                        motivo.Total = motivo.Pagina = 0;
                        motivo.ArquivosItem = [];
                    }
                    if (motivo.Total > (motivo.Pagina * $scope.quantidadeArquivo) || motivo.Pagina == 0) {
                        motivo.Pagina++;
                        let promise = CampanhaArquivoResource.ArquivoHigienizado({
                            campanhaArquivoId: $scope.ArquivoHiginizadoId,
                            motivoId: motivo.CampanhaImportacaoMotivoId,
                            Pagina: motivo.Pagina,
                            quantidade: $scope.quantidadeArquivo
                        }).$promise;

                        if (promise) {
                            motivo.loading = true;
                            promise
                                .then(function (data) {
                                    motivo.Total = data[0].Total;
                                    motivo.ArquivosItem = motivo.ArquivosItem.concat(data);
                                })
                                .finally(function () {
                                    motivo.loading = false;
                                });
                        }
                    }
                }
            };

            function generateUUID() {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }

            $scope.exportarHigienizado = function (arquivoId, motivoId) {
                ModalService.showLoading();
                let fileName = generateUUID();
                CampanhaArquivoResource.gerarHigienizado({
                    CampanhaArquivoId: arquivoId,
                    MotivoId: motivoId,
                    FileName: fileName,
                }).$promise
                    .then(() => {
                        FileDownloadService.downloadWebApiFile("CampanhaArquivo/Download/" + fileName);
                        ModalService.hideLoading();
                    }).catch((data) => {
                        ModalService.hideLoading();
                        NotifyService.showError(data.error);
                    });
            }

            $scope.exportarProcessado = function (arquivoId) {
                ModalService.showLoading();
                let fileName = generateUUID();
                CampanhaArquivoResource.gerarProcessado({
                    CampanhaArquivoId: arquivoId,
                    FileName: fileName,
                }).$promise
                    .then(() => {
                        FileDownloadService.downloadWebApiFile("CampanhaArquivo/Download/" + fileName);
                        ModalService.hideLoading();
                    }).catch((data) => {
                        ModalService.hideLoading();
                        NotifyService.showError(data.error);
                    });
            }

            $scope.exibirDetalhe = function (msg) {                
                ModalService.alert(msg);
            }

            $scope.onChangeZerarCampanha = function (item) {                
             
                if(item)
                    ModalService.alert("telaCampanhaArquivoEdit.alertZerarCampanha");
            }
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (CampanhaArquivoResource, search, orderBy, $odata, utils, $stateParams) {
        var odata = CampanhaArquivoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if ($stateParams.CampanhaId)
            odata.filter('CampanhaId', '=', parseInt($stateParams.CampanhaId));

        if (search.Nome)
            odata.filter(new $odata.Func("contains", "Nome", search.Nome), true);

        angular.forEach(search, function (value, key) {
            if (key !== "pageSize" && key !== "Nome" && value != null && value != '')
                odata.filter(key, value);
        });

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanha.arquivos", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    permissions: {
                        'Campanha': 'Arquivo'
                    }
                })
                .state("main.campanha.arquivos.list", StateResolverProvider.configState("/campanha/{CampanhaId:[0-9]+}/arquivos", "CampanhaArquivo", "List", {
                    pageTitle: 'model.campanha',
                    pageName: 'campo.arquivo',
                    permissions: {
                        'Campanha': 'Arquivo'
                    }
                }))
                .state("main.campanha.arquivos.importar", StateResolverProvider.configState("/campanha/{CampanhaId:[0-9]+}/importar", "CampanhaArquivo", "Edit", {
                    pageTitle: 'acoes.importar',
                    pageName: 'acoes.importar',
                    permissions: {
                        'Campanha': 'Arquivo'
                    }
                }));
        }])

        .service('CampanhaArquivoListData', function CampanhaArquivoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    arquivos: ["CampanhaArquivoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (CampanhaArquivoResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {}
                        if ($stateParams.CampanhaId) {
                            filtro = {
                                CampanhaId: parseInt($stateParams.CampanhaId)
                            };
                        }

                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroCampanhaArquivo");
                        }

                        var orderBy = {
                            column: "CampanhaArquivoId",
                            order: "desc"
                        };

                        var odata = getOdataSearchShared(CampanhaArquivoResource, filtro, orderBy, $odata, utils, $stateParams);
                        return odata.page(10, 1).query();
                    }],
                    campanha: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        if ($stateParams.CampanhaId) {
                            return CampanhaResource.get({
                                CampanhaId: $stateParams.CampanhaId
                            }).$promise;
                        }
                    }],
                    arquivoStatus: ["$translate", function ($translate) {
                        return [
                            { CampanhaArquivoStatusId: 3, Nome: $translate.instant('campo.erro') },
                            { CampanhaArquivoStatusId: 4, Nome: $translate.instant('campo.cancelado') },
                            { CampanhaArquivoStatusId: 5, Nome: $translate.instant('campo.concluido') },
                            { CampanhaArquivoStatusId: 6, Nome: $translate.instant('campo.erroProcessamento') },
                            { CampanhaArquivoStatusId: 7, Nome: $translate.instant('campo.agConfirmacao') },
                            { CampanhaArquivoStatusId: 9, Nome: $translate.instant('campo.emPausa') }
                        ];
                    }],
                    limiteImportacao : ["CampanhaArquivoResource", "$stateParams", function(CampanhaArquivoResource, $stateParams){
                        return CampanhaArquivoResource.getIndicadorImportacaoCampanha({
                            CampanhaId: $stateParams.CampanhaId
                        }).$promise;
                    }]
                }
            }
        })

        .controller("CampanhaArquivoListController", ["$scope", "$odata", "$http", "$state", "Config", "arquivos", "arquivoStatus", "campanha", "CampanhaArquivoResource", "utils", "LocalStorageService", "$stateParams", "FileDownloadService", "NotifyService", "ModalService", "limiteImportacao", function ($scope, $odata, $http, $state, Config, arquivos, arquivoStatus, campanha,
            CampanhaArquivoResource, utils, LocalStorageService, $stateParams, FileDownloadService, NotifyService, ModalService, limiteImportacao) {
            $scope.campanha = campanha;
            $scope.arquivos = [];
            $scope.forms = [];
            $scope.arquivoStatus = arquivoStatus;
            $scope.searching = false;
            $scope.limiteImportacao = limiteImportacao;

            var STATUS_AGCONFIRMACAO = 7;

            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroCampanhaArquivo") : {};

            $scope.orderBy = {
                column: "CampanhaArquivoId",
                order: "desc"
            };

            $('#modal_envio_teste').on({
                'hide.uk.modal': function () {
                    $scope.forms.formEnvioTeste.$setPristine();
                }
            });

            if ($scope.campanha.CampanhaTipoId == 3)
                $state.go('main.campanha.list');

            var updateList = function (list) {
                $scope.arquivos = list;
                $scope.arquivos.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.arquivos.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(CampanhaArquivoResource, $scope.search, $scope.orderBy, $odata, utils, $stateParams);
            };

            $scope.popUpResumo = function (arquivo) {
                if (arquivo) {
                    $scope.arquivo = arquivo;
                    var campanhaArquivoId = $scope.arquivo.CampanhaArquivoId

                    $scope.arquivo.ResumoImportacaoClasse = [];
                    $scope.arquivo.ResumoImportacaoDDD = [];
                    $scope.arquivo.ResumoImportacaoLocalidade = [];
                    $scope.arquivo.ResumoImportacaoOperadora = [];
                    $scope.arquivo.CampanhaImportacaoScoreBigTalk = [];
                    $scope.arquivo.CampanhaImportacaoScoreBigTalkGrafico = [];

                    $http.get(Config.getUrl('CampanhaArquivo/ResumoImportacaoClasse?CampanhaArquivoId=' + campanhaArquivoId)).then((response) => {
                        $scope.arquivo.ResumoImportacaoClasse = response.data;
                    });
                    $http.get(Config.getUrl('CampanhaArquivo/ResumoImportacaoDDD?CampanhaArquivoId=' + campanhaArquivoId)).then((response) => {
                        $scope.arquivo.ResumoImportacaoDDD = response.data;
                    });
                    $http.get(Config.getUrl('CampanhaArquivo/ResumoImportacaoLocalidade?CampanhaArquivoId=' + campanhaArquivoId)).then((response) => {
                        $scope.arquivo.ResumoImportacaoLocalidade = response.data;
                    });
                    $http.get(Config.getUrl('CampanhaArquivo/ResumoImportacaoOperadora?CampanhaArquivoId=' + campanhaArquivoId)).then((response) => {
                        $scope.arquivo.ResumoImportacaoOperadora = response.data;
                    });
                    
                    CampanhaArquivoResource.resumoBigTalk({
                        campanhaArquivoId: campanhaArquivoId,                        
                        CampanhaId: 0
                    }).$promise
                        .then((data) => {
                            $scope.arquivo.CampanhaImportacaoScoreBigTalk = data;
                        })

                    CampanhaArquivoResource.graficoBigTalk({
                        campanhaArquivoId: campanhaArquivoId,                        
                        CampanhaId: 0
                    }).$promise
                        .then((data) => {
                            $scope.arquivo.CampanhaImportacaoScoreBigTalkGrafico = data;
                        })

                    $scope.ArquivosItem = [];
                    $scope.ArquivosItemPartial = [];
                    $scope.motivos = [];
                    if (arquivo.CampanhaArquivoId) {
                        $scope.ArquivoHiginizadoNome = arquivo.Nome;
                        $scope.ArquivoHiginizadoId = arquivo.CampanhaArquivoId;
                        CampanhaArquivoResource.ResumoMotivo({ campanhaArquivoId: arquivo.CampanhaArquivoId }).$promise
                        .then((data) => { angular.copy(data, $scope.motivos); })
                        .catch((ex) => { NotifyService.showError(ex); });
    
                    }

                    $scope.arquivo.QuantidadeProcessado = $scope.arquivo.QuantidadeInvalido > 0 ? $scope.arquivo.QuantidadeTotal - $scope.arquivo.QuantidadeInvalido :
                        $scope.arquivo.QuantidadeTotal;

                    ModalService.openModal('modal_resumoArquivo')
                } else {
                    ModalService.closeModal('modal_resumoArquivo')
                }
            };

            $scope.viewAmostraHigienizado = function (arquivo) {
                $scope.ArquivosItem = [];
                $scope.ArquivosItemPartial = [];
                $scope.motivos = [];
                if (arquivo.CampanhaArquivoId) {
                    $scope.ArquivoHiginizadoNome = arquivo.Nome;
                    $scope.ArquivoHiginizadoId = arquivo.CampanhaArquivoId;
                    CampanhaArquivoResource.ResumoMotivo({
                        campanhaArquivoId: arquivo.CampanhaArquivoId
                    }).$promise.then((data) => {
                        angular.copy(data, $scope.motivos);
                        ModalService.openModal('modal_arquivo_higienizado')
                    }).catch((ex) => {
                        NotifyService.showError(ex);
                        ModalService.closeModal('modal_arquivo_higienizado')
                    });

                }
            };

            $scope.quantidadeArquivo = 10;

            $scope.loadMoreArquivo = function (motivo) {
                if (motivo.aberto == true && motivo.loading != true) {
                    if (!motivo.Pagina) {
                        motivo.Total = motivo.Pagina = 0;
                        motivo.ArquivosItem = [];
                    }
                    if (motivo.Total > (motivo.Pagina * $scope.quantidadeArquivo) || motivo.Pagina == 0) {
                        motivo.Pagina++;
                        motivo.loading = true;
                        CampanhaArquivoResource.ArquivoHigienizado({
                            campanhaArquivoId: $scope.ArquivoHiginizadoId,
                            motivoId: motivo.CampanhaImportacaoMotivoId,
                            Pagina: motivo.Pagina,
                            quantidade: $scope.quantidadeArquivo
                        }).$promise
                            .then((data) => {
                                motivo.Total = data[0].Total;
                                motivo.ArquivosItem = motivo.ArquivosItem.concat(data);
                                motivo.loading = false;
                            })
                    }

                }
            };

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }

            $scope.exportarHigienizado = function (arquivoId, motivoId) {
                ModalService.showLoading();
                let fileName = generateUUID();
                CampanhaArquivoResource.gerarHigienizado({
                    CampanhaArquivoId: arquivoId,
                    MotivoId: motivoId,
                    FileName: fileName,
                }).$promise.then(() => {
                    FileDownloadService.downloadWebApiFile("CampanhaArquivo/Download/" + fileName);
                    ModalService.hideLoading();
                }).catch((data) => {
                    ModalService.hideLoading();
                    NotifyService.showError(data.error);
                });
            }

            $scope.exportarProcessado = function (arquivoId) {
                ModalService.showLoading();
                let fileName = generateUUID();
                CampanhaArquivoResource.gerarProcessado({
                    CampanhaArquivoId: arquivoId,
                    FileName: fileName,
                }).$promise.then(() => {
                    FileDownloadService.downloadWebApiFile("CampanhaArquivo/Download/" + fileName);
                    ModalService.hideLoading();
                }).catch((data) => {
                    ModalService.hideLoading();
                    NotifyService.showError(data.error);
                });
            }

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroCampanhaArquivo', $scope.search);
                $scope.searching = true;
                getOdataSearch()
                    .page($scope.search.pageSize, 1)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            var deleteRecord = function (data) {
                return CampanhaArquivoResource.delete({
                    CampanhaArquivoId: data.CampanhaArquivoId
                }).$promise.then(() => {
                    NotifyService.showSuccess();
                    $scope.pageChanged($scope.currentPage)
                }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.arquivos.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            updateList(arquivos);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroCampanhaArquivo');
                $scope.search = {
                    pageSize: 10
                };
            };

            $scope.confirmaImportacao = function (arquivo) {
                let qtdImportacao = arquivo.QuantidadeTotal;

                if($scope.limiteImportacao.ExcedeuMaxImportacao)
                {
                    NotifyService.showError(null, 'telaCampanhaArquivo.excedeuLimiteImportacao');
                } 
                else 
                {
                    if(qtdImportacao > $scope.limiteImportacao.QtdDisponivelImportacao)
                    {
                        ModalService.confirmImportacao(() => confirmarArquivo(arquivo));
                    }
                    else
                    {
                        confirmarArquivo(arquivo)
                    }
                }
            };

            let confirmarArquivo = function (arquivo) {
                if (arquivo.CampanhaArquivoId > 0) {
                    if (arquivo.CampanhaArquivoStatusId == STATUS_AGCONFIRMACAO) {
                        ModalService.showLoading();
                        CampanhaArquivoResource.get({
                            CampanhaArquivoId: arquivo.CampanhaArquivoId
                        }).$promise.then((arquivoAtual) => {
                            var arquivoNew = {};
                            var arquivosProcessamento = [];
                            angular.copy(arquivoAtual, arquivoNew);
                            arquivosProcessamento.push(arquivoNew);
                            $http.post(Config.getUrl('CampanhaArquivo/ProcessaArquivos'), arquivosProcessamento).then(() => {
                                getOdataSearch().page($scope.search.pageSize, 1).query().then(updateList);
                                NotifyService.showSuccess();
                            }).catch(NotifyService.showError);
                        }).catch(NotifyService.showError)
                            .finally(() => {
                                ModalService.hideLoading();
                            });
                    }

                }
            };
            
            $scope.campanhaArquivoPausar = function (arquivo) {
                CampanhaArquivoResource.IniciarArquivo({ CampanhaArquivoId: arquivo.CampanhaArquivoId }).$promise
                    .then(() => {
                        $scope.executeSearch();
                        NotifyService.showSuccess();
                    }).catch(NotifyService.showError);
            }
            $scope.campanhaArquivoIniciar = function (arquivo) {
                CampanhaArquivoResource.PausarArquivo({ CampanhaArquivoId: arquivo.CampanhaArquivoId }).$promise
                    .then(() => {
                        $scope.executeSearch();
                        NotifyService.showSuccess();
                    }).catch(NotifyService.showError);
            }

            $scope.abrirModalEnvioTeste = function () {
                $scope.CodigoCliente = { Nome: "CodigoCliente", Alias: "Cod. Cliente", Valor: undefined }
                $scope.DDD = { Nome: "DDD", Alias: "DDD", Valor: undefined }
                $scope.Telefone = { Nome: "Telefone", Alias: "Telefone", Valor: undefined }
                $scope.NomeCliente = { Nome: "NomeCliente", Alias: "Cliente", Valor: undefined }
                $scope.Detalhe = { Nome: "Detalhe", Alias: "Detalhe", Valor: undefined }
            };

            $scope.enviarTeste = function (form) {
                if (form.$valid) {
                    $scope.layoutCampanhaEPBX = [];
                    $scope.layoutCampanhaEPBX.push($scope.CodigoCliente);
                    $scope.layoutCampanhaEPBX.push($scope.DDD);
                    $scope.layoutCampanhaEPBX.push($scope.Telefone);
                    $scope.layoutCampanhaEPBX.push($scope.NomeCliente);
                    $scope.layoutCampanhaEPBX.push($scope.Detalhe);

                    CampanhaArquivoResource.envioTeste({ CampanhaId: campanha.CampanhaId }, $scope.layoutCampanhaEPBX).$promise
                        .then(() => {
                            ModalService.alert('notificacoes.testeEnviadoComSucesso');
                            ModalService.closeModal('modal_envio_teste');
                        });
                }
            };
        }]
        );
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("CampanhaArquivoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CampanhaArquivo/:CampanhaArquivoId", { "CampanhaArquivoId": "@CampanhaArquivoId" }, {
				Importar: {
					url: "CampanhaArquivo/Importar",
					method: "POST"
				},
				ConsultaProgresso: {
					url: "CampanhaArquivo/ArquivoProgresso",
					method: "GET",
					isArray: false
				},
				ArquivoHigienizado: {
					url: "CampanhaArquivo/ArquivoHigienizado",
					method: "GET",
					isArray: true
				},
				ResumoMotivo: {
					url: "CampanhaArquivo/ResumoMotivo",
					method: "GET",
					isArray: true
				},
				gerarHigienizado: {
					url: "CampanhaArquivo/ExportarHigienizado",
					method: "POST"
				},
				gerarProcessado: {
					url: "CampanhaArquivo/ExportarProcessado",
					method: "POST"
				},
				envioTeste: {
					url: "CampanhaArquivo/EnvioTeste",
					method: "POST",
					params: {
						"CampanhaId": "@CampanhaId"
					}
				},
				novoContato: {
					url: "CampanhaArquivo/NovoContato",
					method: "POST",
					params: {
						"CampanhaId": "@CampanhaId",
						"AtendimentoIntegracaoId": "@AtendimentoIntegracaoId",
						"ListaMinerId": "@ListaMinerId"
					}
				},
				resumoBigTalk: {
					url: "CampanhaArquivo/CampanhaImportacaoScoreBigTalk",
					method: "GET",
					isArray: true
				},
				graficoBigTalk: {
					url: "CampanhaArquivo/CampanhaImportacaoScoreBigTalkGrafico",
					method: "GET",
					isArray: true
				},
				IniciarArquivo: {
					url: "CampanhaArquivo/IniciarArquivo",
					method: "PUT",
					params: {
						"CampanhaArquivoId": "@CampanhaArquivoId"
					}
				},
				PausarArquivo: {
					url: "CampanhaArquivo/PausarArquivo",
					method: "PUT",
					params: {
						"CampanhaArquivoId": "@CampanhaArquivoId"
					}
				},
				getIndicadorImportacaoCampanha: {
					url: "CampanhaArquivo/GetIndicadorImportacaoCampanha",
					method: "GET",
					isArray: false,
					params: {
						"CampanhaId": "@CampanhaId"
					}
				},
			})
		}])
		.factory("CampanhaImportacaoMotivoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CampanhaImportacaoMotivo");
		}])
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("CampanhaLayoutItemResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CampanhaLayoutItem/:CampanhaLayoutItemId", {
				"CampanhaLayoutItemId": "@CampanhaLayoutItemId"
			});
		}]);
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("CampanhaLayoutResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CampanhaLayout/:CampanhaLayoutId", {
				"CampanhaLayoutId": "@CampanhaLayoutId"
			});
		}]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.campanha.arquivosConfig",
                StateResolverProvider.configState("/campanha/arquivos/configuracao", "CampanhaArquivoConfiguracao", "Edit", {
                    pageTitle: 'pageTitle.campanhaArquivoConfiguracao',
                    pageName: 'pageTitle.arquivos',
                    permissions: { 'Campanha': 'Arquivo' }
                }))
        }])

        .service('CampanhaArquivoConfiguracaoEditData',
            ["CampanhaArquivoConfiguracaoResource", "CampanhaLayoutResource", "ConfiguracaoResource", function CampanhaArquivoConfiguracaoEditData(CampanhaArquivoConfiguracaoResource,
                CampanhaLayoutResource, ConfiguracaoResource) {
                return function () {
                    return {
                        registro: function () {
                            return CampanhaArquivoConfiguracaoResource.get().$promise;
                        },
                        layoutList: function () {
                            return CampanhaLayoutResource.odata().orderBy('Id').query();
                        },
                        configuracaoTarefa: function () {
                            return ConfiguracaoResource.getConfiguracaoTarefa().$promise;
                        }
                    }
                }
            }])

        .controller("CampanhaArquivoConfiguracaoEditController", ["$scope", "registro", "layoutList", "NotifyService", "$state", "CampanhaArquivoConfiguracaoResource", "configuracaoTarefa", "ModalService", "ConfiguracaoResource", "$translate", function ($scope, registro, layoutList,
            NotifyService, $state, CampanhaArquivoConfiguracaoResource, configuracaoTarefa, ModalService, ConfiguracaoResource, $translate) {
            $scope.configuracaoTarefa = configuracaoTarefa;
            $scope.isConfiguracaoAtiva = configuracaoTarefa.Valor;
            $scope.layoutList = layoutList;
            $scope.registro = registro || {};

            $scope.save = function (form) {
                if (!form.$valid) return NotifyService.showInvalid();

                CampanhaArquivoConfiguracaoResource
                    .update($scope.registro)
                    .$promise.then(() => {
                        NotifyService.showRegistroSalvo();
                        $state.go('main.campanha.list');
                    }).catch(NotifyService.showError);
            };

            $scope.onChangeAtivacao = function () {
                let labels = {
                    labels: {
                        'Ok': $translate.instant('campo.sim'),
                        'Cancel': $translate.instant('campo.nao')
                    }
                };
            
                let valorConfiguracao = $scope.isConfiguracaoAtiva ? 'true' : 'false';
                let mensagemConfirmacao = $scope.isConfiguracaoAtiva 
                    ? 'telaCampanhaArquivoConfiguracao.confirmAtivacao' 
                    : 'telaCampanhaArquivoConfiguracao.confirmDesativacao';
            
                let atendimentoConfiguracao = {
                    ConfiguracaoId: $scope.configuracaoTarefa.ConfiguracaoId,
                    Valor: valorConfiguracao,
                    Chave: $scope.configuracaoTarefa.Chave,
                    Contexto: $scope.configuracaoTarefa.Contexto,
                    Descricao: $scope.configuracaoTarefa.Descricao,
                    Editavel: $scope.configuracaoTarefa.Editavel
                };
            
                ModalService.confirmMessage(mensagemConfirmacao, null, () => {
                    ConfiguracaoResource.update(atendimentoConfiguracao).$promise
                        .then(() => NotifyService.showSuccess())
                        .catch((e) => {
                            NotifyService.showError(e);
                            $scope.isTarefaAtiva = false;
                        });
                }, labels, () => {
                    $scope.isTarefaAtiva = !$scope.isConfiguracaoAtiva;
                });
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CampanhaArquivoConfiguracaoResource", ["$resource", function ($resource) {
            return $resource("CampanhaArquivo/Configuracao");
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanhaDiagnostico", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.campanhaDiagnostico.list',
                        pageTitle: 'pageTitle.cardTitle',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.campanhaDiagnostico.list", StateResolverProvider.configState("/campanhaDiagnostico", "CampanhaDiagnostico", "List", {
                    pageTitle: 'pageTitle.campanhaDiagnostico',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("CampanhaDiagnosticoListData", function CampanhaDiagnosticoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetTodasCampanhas().$promise;
                    }],
                }
            }
        })

        .controller("CampanhaDiagnosticoListController", ["$scope", "$http", "$q", "Config", "CampanhaDiagnosticoResource", "MonitorCampanhaResource", "CampanhaResource", "ModalService", "NotifyService", "campanhasList", function ($scope, $http, $q, Config, CampanhaDiagnosticoResource, 
            MonitorCampanhaResource, CampanhaResource, ModalService, NotifyService, campanhasList) {

            $scope.errorObject = {};
            $scope.campanhaDiagnosticoList = [];
            $scope.campanhasList = campanhasList;
            $scope.campanhas = _.filter(campanhasList, function (item) {
                return item.CampanhaStatusId !== 1;
            });
            $scope.search = {};
            $scope.naoConsulta = true;
            $scope.indicadores = {};
            $scope.showCards = false;
            $scope.canais = [];
            $scope.grupoStatus = [];
            $scope.campanha = {};


            $scope.executeSearch = function () {
                let campanhaId = $scope.search.CampanhaId;

                if (campanhaId > 0) {
                    getCampanhaDiagnostico(campanhaId);
                }
            };

            var getCampanhaDiagnostico = function (campanhaId) {

                CampanhaDiagnosticoResource.getCampanhaDiagnostico({ campanhaId: campanhaId }).$promise
                    .then(data => {
                        $scope.campanhaDiagnosticoList = data;
                        atualizarIndicadores(campanhaId);
                        atualizaCanais();
                        atualizaGruposStatus();
                        for (let item of data) {

                            var url = Config.getUrl(item.Evento) + '/' + item.CampanhaId + '/' + item.CampanhaDiagnosticoId;
                            $http({
                                method: 'GET',
                                url: url
                            }).then(response => {
                                const idx = $scope.campanhaDiagnosticoList.findIndex(i => i.CampanhaDiagnosticoId === response.data.CampanhaDiagnosticoId);
                                if (idx > -1)
                                    $scope.campanhaDiagnosticoList[idx].Status = response.data.Status;

                                $scope.campanhaDiagnosticoList = $scope.campanhaDiagnosticoList;
                            });
                        }
                    });
            };

            $scope.reprocessarCampanhaDiagnostico = function (campanhaDiagnostico) {
                campanhaDiagnostico.Status = null;
                var url = Config.getUrl(campanhaDiagnostico.Evento) + '/' + campanhaDiagnostico.CampanhaId + '/' + campanhaDiagnostico.CampanhaDiagnosticoId;
                $http({
                    method: 'GET',
                    url: url
                }).then(response => {
                    const idx = $scope.campanhaDiagnosticoList.findIndex(i => i.CampanhaDiagnosticoId === response.data.CampanhaDiagnosticoId);
                    if (idx > -1)
                        $scope.campanhaDiagnosticoList[idx].Status = response.data.Status;
                });
            }

            $scope.onChangeCampanha = function (campanhaId) {
                if (campanhaId > 0) {
                    $scope.naoConsulta = false;
                    $scope.campanha = $scope.campanhas.find(x => x.CampanhaId == campanhaId);
                } else {
                    $scope.naoConsulta = true;
                    $scope.showCards = false;
                    $scope.campanha = {};
                }
            }

            $scope.validaPendentes = function(campanhaDiagnostico) {
             if (campanhaDiagnostico.Nome === 'Pendente Reciclagem' ||
                 campanhaDiagnostico.Nome === 'Pendente Ordenação' ||
                 campanhaDiagnostico.Nome === 'Pendente Filtro') {
                return true;
                }
            };

            $scope.limparFiltro = function () {
                $scope.search.CampanhaId = 0;
                $scope.onChangeCampanha($scope.search.CampanhaId);
                $scope.campanhaDiagnosticoList = [];
                $scope.showCards = false;
            };


            var atualizarIndicadores = function (campanhaId) {

                const filtro = {
                    Visao: 2,
                    CampanhaId: campanhaId
                };

                MonitorCampanhaResource.GetIndicador(filtro).$promise
                    .then((data) => {
                        $scope.indicadores = data[0];
                        $scope.showCards = true;
                    });
            };

            var atualizaCanais = function () {
                let promise = MonitorCampanhaResource.GetMonitorCanaisAgrupadosCampanha().$promise;
                promise.then(function (data) {
                    $scope.canais = data;
                });
            };

            var atualizaGruposStatus = function () {
                let promise = MonitorCampanhaResource.GetGruposStatusAgrupados().$promise;
                promise.then(function (data) {
                    $scope.grupoStatus = data;
                });
            };
            

            $scope.iniciarCampanha = function () {
                ModalService.showLoading();

                CampanhaResource.processaCampanhaConfiguracao({
                    CampanhaId: $scope.campanha.CampanhaId,
                    CampanhaAcaoId: 2
                }).$promise.then(() => acaoEnviada()).catch((e) => {
                    NotifyService.showError(e);
                    ModalService.hideLoading();
                });
            };

            $scope.pausarCampanha = function () {
                ModalService.showLoading();
    
                CampanhaResource.processaCampanhaConfiguracao({
                    CampanhaId: $scope.campanha.CampanhaId,
                    CampanhaAcaoId: 3
                }).$promise.then(() => acaoEnviada()).catch((e) => {
                    NotifyService.showError(e);
                    ModalService.hideLoading();
                });
            };
    
            function acaoEnviada() {
                ModalService.hideLoading();
                NotifyService.showSuccess();
    
                $scope.campanha.PendenteAcao = true;
    
                setTimeout(() => {
                    CampanhaResource.get({
                        CampanhaId: $scope.campanha.CampanhaId
                    }).$promise.then(campanha => {
                        $scope.campanha.CampanhaStatusId = campanha.CampanhaStatusId;
                        $scope.campanha.PendenteAcao = campanha.PendenteAcao;
                    });
                }, 5000);
            };
    
            $scope.printCampanhaDiagnostico = function() {
                let campanhaNome = $scope.campanha.Nome;
                var innerContents = document.getElementById('printSectionId').innerHTML;
                var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                popupWinindow.document.open();
                popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body style="font-family: Arial, Helvetica, sans-serif;" onload="window.print()"> <div> <h3>' + campanhaNome + '</h3></div> <div>' + innerContents + '</div></body></html>');
                popupWinindow.document.close();
            };

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CampanhaDiagnosticoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaDiagnostico/:Id", { "Id": "@Id" },
                {
                    getCampanhaDiagnostico: {
                        url: "CampanhaDiagnostico/GetCampanhaDiagnostico",
                        method: "GET",
                        params: {
                            "campanhaId": "@campanhaId"
                        },
                        isArray: true
                    },
                });
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function ($odataresource, queryString) {
        var resource = $odataresource(queryString);

        return resource.odata().orderBy('Peso', 'asc');
    }

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanha.filtro", StateResolverProvider.configState("/campanha/{CampanhaId:[0-9]+}/filtro", "CampanhaFiltro", "Edit", {
                    pageTitle: 'model.campanha',
                    pageName: 'campo.filtros',
                    permissions: {
                        Campanha: 'Filtro'
                    }
                }));

        }])
        .service('CampanhaFiltroEditData', function CampanhaArquivoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard'
                        ]);
                    }],
                    campanha: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        return CampanhaResource.get({
                            CampanhaId: $stateParams.CampanhaId
                        }).$promise;
                    }],
                    operadores: ["OperadorLogicoResource", function (OperadorLogicoResource) {
                        return OperadorLogicoResource.query().$promise;
                    }],
                    filtros: ["Config", "$http", "$stateParams", function (Config, $http, $stateParams) {
                        return $http({
                            method: 'GET',
                            url: Config.getUrl("Campanha/" + $stateParams.CampanhaId + "/Filtro")
                        }).then(function (response) {
                            return response.data;
                        });
                    }],
                    ordens: ["$odataresource", "$stateParams", function ($odataresource, $stateParams) {
                        var url = "Campanha/" + $stateParams.CampanhaId + "/Ordem"
                        return getOdataSearchShared($odataresource, url).page(10, 1).query();
                    }],
                    layoutItems: ["Config", "$http", "$stateParams", function (Config, $http, $stateParams) {
                        return $http({
                            method: 'GET',
                            url: Config.getUrl("Campanha/" + $stateParams.CampanhaId + "/LayoutItem")
                        }).then(function (response) {
                            return response.data;
                        });
                    }],
                    ordemTemplate: ["Config", "$http", function (Config, $http) {
                        return $http({
                            method: 'GET',
                            url: Config.getUrl("CampanhaOrdemTemplate/")
                        }).then(function (response) {
                            return response.data;
                        });
                    }]
                }
            }
        })

        .controller("CampanhaFiltroEditController", ["$scope", "$state", "$timeout", "$http", "Config", "$stateParams", "campanha", "operadores", "filtros", "ordens", "layoutItems", "ordemTemplate", "CampanhaResource", "$odataresource", "NotifyService", "$translate", "ModalService", "TemplateOrdenacaoResource", function ($scope, $state, $timeout, $http, Config, $stateParams, campanha, operadores, filtros,
            ordens, layoutItems, ordemTemplate, CampanhaResource, $odataresource, NotifyService, $translate, ModalService, TemplateOrdenacaoResource) {
            $scope.campanhaId = $stateParams.CampanhaId;
            $scope.campanha = campanha;
            $scope.operadores = operadores;
            $scope.operadoresIgualdade = _.filter(operadores, function (el) {
                return el.Operador == 'In' || el.Operador == 'Not In' || el.Operador == '=' || el.Operador == "<>";
            });
            $scope.layoutItems = layoutItems;
            $scope.filtros = filtros;
            $scope.ordens = ordens;
            $scope.campanhaQuantidadeFiltro = 0;
            $scope.ordemTemplate = ordemTemplate;
            $scope.diasSemana = [{
                Nome: $translate.instant('campo.todos'),
                Valor: 8
            }, {
                Nome: $translate.instant('dias.domingo'),
                Valor: 1
            }, {
                Nome: $translate.instant('dias.segunda'),
                Valor: 2
            }, {
                Nome: $translate.instant('dias.terca'),
                Valor: 3
            }, {
                Nome: $translate.instant('dias.quarta'),
                Valor: 4
            }, {
                Nome: $translate.instant('dias.quinta'),
                Valor: 5
            }, {
                Nome: $translate.instant('dias.sexta'),
                Valor: 6
            }, {
                Nome: $translate.instant('dias.sabado'),
                Valor: 7
            }];
            $scope.filtro = {};
            $scope.ordem = {
                CampanhaOrdemTipoId: 1
            };
            $scope.ordemTemplateModel = {
                Id: $scope.campanha.CampanhaOrdemTemplateId
            };

            var postCampanhaFiltro = function (filtro, callbackSuccess, callbackError) {
                var url = Config.getUrl('Campanha/' + $scope.campanhaId + '/Filtro');
                var valorID = "";
                var valorAlias = "";
                if (angular.isArray(filtro.Valor)) {
                    angular.forEach(filtro.Valor, function (item, index) {
                        valorID += filtro.Valor[index];
                        var fonte = _.findWhere(filtro.FonteItens, {
                            Valor: parseInt(filtro.Valor[index])
                        });

                        if (fonte) {
                            valorAlias += fonte.Nome;
                        }

                        if (index < filtro.Valor.length - 1) {
                            valorID += ", ";
                            valorAlias += ", ";
                        }
                    });
                } else {
                    valorID = filtro.Valor;
                    if (filtro.FonteItens) {
                        var fonte = _.findWhere(filtro.FonteItens, {
                            Valor: parseInt(filtro.Valor)
                        });
                        valorAlias += fonte.Nome;
                    } else {
                        valorAlias = filtro.Valor;
                    }
                }

                var data = {
                    CampanhaId: $scope.campanhaId,
                    CampanhaLayoutItemId: filtro.CampanhaLayoutItemId,
                    CampanhaOperadorId: filtro.CampanhaOperadorId,
                    Valor: valorID,
                    ValorAlias: valorAlias,
                    DiaSemana: filtro.DiaSemana,
                    HoraInicial: filtro.HoraInicial,
                    HoraFinal: filtro.HoraFinal
                };

                $http.post(url, data).then(callbackSuccess).catch(callbackError);
            };

            var getCampanhaFiltro = function (callbackSuccess, callbackError) {
                var campanhaId = $scope.campanhaId;
                var url = Config.getUrl('Campanha/' + campanhaId + '/Filtro');
                $http.get(url).then(callbackSuccess).catch(callbackError);
            };

            var postCampanhaOrdem = function (ordem, callbackSuccess, callbackError) {
                var url = Config.getUrl('Campanha/' + $scope.campanhaId + '/Ordem');
                var valorID = "";
                var valorAlias = "";
                if (angular.isArray(ordem.Valor)) {
                    angular.forEach(ordem.Valor, function (item, index) {
                        valorID += ordem.Valor[index];

                        var fonte = _.findWhere(ordem.FonteItens, {
                            Valor: parseInt(ordem.Valor[index])
                        });

                        if (fonte) {
                            valorAlias += fonte.Nome;
                        }

                        if (index < ordem.Valor.length - 1) {
                            valorID += ",";
                            valorAlias += ",";
                        }
                    });
                } else {
                    valorID = ordem.Valor;
                    if (ordem.FonteItens) {
                        var fonte = _.findWhere(ordem.FonteItens, {
                            Valor: parseInt(ordem.Valor)
                        });
                        if (fonte) {
                            valorAlias += fonte.Nome;
                        }
                    } else {
                        valorAlias = ordem.Valor;
                    }
                }

                var data = {
                    CampanhaId: $scope.campanhaId,
                    CampanhaLayoutItemId: ordem.CampanhaLayoutItemId,
                    CampanhaOrdemTipoId: ordem.CampanhaOrdemTipoId,
                    Valor: valorID,
                    ValorAlias: valorAlias,
                    HoraInicial: ordem.HoraInicialString,
                    HoraFinal: ordem.HoraFinalString
                };

                $http.post(url, data).then(callbackSuccess).catch(callbackError);
            };

            var putCampanhaOrdem = function (ordem, callbackSuccess, callbackError) {
                var url = Config.getUrl('Campanha/' + $scope.campanhaId + '/Ordem');
                $http.put(url, ordem).then(callbackSuccess).catch(callbackError);
            };

            var getCampanhaOrdem = function (callbackSuccess, callbackError) {
                var campanhaId = $scope.campanhaId;
                var url = Config.getUrl('Campanha/' + campanhaId + '/Ordem');
                $http.get(url).then(callbackSuccess).catch(callbackError);
            };

            var getFonteDados = function (comando, callbackSuccess, callbackError) {
                $http.get(Config.getUrl(comando)).then(callbackSuccess).catch(callbackError);
            };

            var deleteCampanhaFiltro = function (filtros, callbackSuccess, callbackError) {
                var campanhaId = $scope.campanhaId;
                var url = Config.getUrl('Campanha/' + campanhaId + '/Filtro');
                $http({
                    method: 'DELETE',
                    url: url,
                    data: {
                        Filtros: filtros
                    },
                    headers: {
                        'Content-type': 'application/json;charset=utf-8'
                    }
                }).then(callbackSuccess).catch(callbackError);
            };

            var deleteCampanhaOrdem = function (ordens, callbackSuccess, callbackError) {
                var campanhaId = $scope.campanhaId;
                var url = Config.getUrl('Campanha/' + campanhaId + '/Ordem');
                $http({
                    method: 'DELETE',
                    url: url,
                    data: {
                        Ordens: ordens
                    },
                    headers: {
                        'Content-type': 'application/json;charset=utf-8'
                    }
                }).then(callbackSuccess).catch(callbackError);
            };

            var getTemplateCampoItem = function (campanhaLayoutItemId) {
                return _.findWhere($scope.layoutItems, {
                    Id: campanhaLayoutItemId
                });
            }

            $scope.filtroOperador = null;
            $scope.onFiltroOperadorAlterado = function () {
                if ($scope.filtro.CampanhaOperadorId > 0) {
                    $scope.filtroOperador = _.find($scope.operadores, function (el) {
                        return el.OperadorLogicoId == $scope.filtro.CampanhaOperadorId;
                    });
                } else {
                    $scope.filtroOperador = null;
                }
            }

            $scope.deleteFiltro = function (item) {
                ModalService.confirmDelete(function () {
                    var filtros = [{
                        CampanhaFiltroId: item.CampanhaFiltroId
                    }];

                    deleteCampanhaFiltro(filtros, function () {
                        NotifyService.showSuccess();
                        getCampanhaFiltro(function (response) {
                            $scope.filtros = response.data;
                        });
                        calculaQuantidadeFiltro();
                    }, NotifyService.showError);
                });
            };

            var calculaQuantidadeFiltro = function () {
                var campanhaId = $scope.campanhaId;

                if (campanhaId > 0) {
                    var url = Config.getUrl('Campanha/' + campanhaId + '/CampanhaQuantidadeFiltro');
                    $http.get(url).then(function (result) {
                        var campanhaFiltro = [];
                        angular.copy(result.data, campanhaFiltro);

                        if (campanhaFiltro) {
                            $scope.campanhaQuantidadeFiltro = campanhaFiltro[0].Quantidade;
                        }
                        //$scope.campanhaQuantidadeFiltro = _.reduce(campanhaFiltro, function (memo, num) {
                        //    return memo + num.Quantidade;
                        //}, 0);

                    }).catch(NotifyService.showError);
                }
            };

            $scope.validarFiltro = function(){
                if($scope.filtros){
                    var exists = $scope.filtros.find(filtro => filtro.CampanhaLayoutItemId == $scope.filtro.CampanhaLayoutItemId)
                    if(exists)
                    {
                        NotifyService.showError(null, 'telaCampanhaFiltro.jaExists')
                        return false;
                    } else return true;
                } else return true;
            }

            $scope.isDD = function(value){
                 return /^([\d+(?:\.\d+)]){2,2}$/g.test(value);
            }
            $scope.isDDArray = function(value){
                return /^(\d+,)+\d+$/g.test(value);
            }
            $scope.isNumero = function(value){
                return /^([0-9]{0})([0-9]{4,5})([0-9]{4})$/g.test(value);
            }
            $scope.isNumeroArray = function(value){
                return /([0-9]{0})([0-9]{4,5})([0-9]{4})+\d/g.test(value);
            }
            $scope.isTelefone = function(value){
                 return /^([0-9]{2,3})?([0-9]{2})([0-9]{4,5})([0-9]{4})$/g.test(value);
            }
            $scope.isTelefoneArray = function(value){
                return /([0-9]{2,3})([0-9]{2})([0-9]{4,5})([0-9])+\d/g.test(value);
            }
            $scope.isUF = function(value){
                return /^[A-Z]{2,2}$/g.test(value);
            }
            $scope.isUFArray = function(value){
                return /^([A-Z+,]{2,2})+\,([A-Z+,]{2,2})/g.test(value);
            }
           
            $scope.salvarFiltro = function (form) {
                if($scope.campanhaLayoutItem.Nome == "DDD" && $scope.isDD($scope.filtro.Valor) == false && ($scope.filtro.CampanhaOperadorId == 3 || $scope.filtro.CampanhaOperadorId == 5)){
                    return NotifyService.showMessage('telaCampanhaFiltro.dd',"info");
                }else if ($scope.campanhaLayoutItem.Nome == "DDD" && $scope.isDDArray($scope.filtro.Valor) == false && ($scope.filtro.CampanhaOperadorId == 4 || $scope.filtro.CampanhaOperadorId == 6)){
                    return NotifyService.showMessage('telaCampanhaFiltro.ddIsArray',"info");
                }
                if($scope.campanhaLayoutItem.Nome == "Numero" && $scope.isNumero($scope.filtro.Valor) == false && ($scope.filtro.CampanhaOperadorId == 3 || $scope.filtro.CampanhaOperadorId == 5) ){
                    return NotifyService.showMessage('telaCampanhaFiltro.numero', "info");
                }else if($scope.campanhaLayoutItem.Nome == "Numero" && $scope.isNumeroArray($scope.filtro.Valor) == false && ($scope.filtro.CampanhaOperadorId == 4 || $scope.filtro.CampanhaOperadorId == 6)){
                    return NotifyService.showMessage('telaCampanhaFiltro.numeroIsArray',"info");
                }
                if($scope.campanhaLayoutItem.Nome == "Telefone" && $scope.isTelefone($scope.filtro.Valor) == false && ($scope.filtro.CampanhaOperadorId == 3 || $scope.filtro.CampanhaOperadorId == 5)){
                    return NotifyService.showMessage('telaCampanhaFiltro.telefone', "info");
                }else if($scope.campanhaLayoutItem.Nome == "Telefone" && $scope.isTelefoneArray($scope.filtro.Valor) == false && ($scope.filtro.CampanhaOperadorId == 4 || $scope.filtro.CampanhaOperadorId == 6)){
                    return NotifyService.showMessage('telaCampanhaFiltro.telefoneIsArray', "info");
                }
                if($scope.campanhaLayoutItem.Nome == "UF" && $scope.isUF($scope.filtro.Valor.toUpperCase()) == false && ($scope.filtro.CampanhaOperadorId == 3 || $scope.filtro.CampanhaOperadorId == 5)){
                    return NotifyService.showMessage('telaCampanhaFiltro.uf', "info");
                }else if($scope.campanhaLayoutItem.Nome == "UF" && $scope.isUFArray($scope.filtro.Valor.toUpperCase()) == false && ($scope.filtro.CampanhaOperadorId == 4 || $scope.filtro.CampanhaOperadorId == 6)){
                    return NotifyService.showMessage('telaCampanhaFiltro.ufIsArray', "info");
                }
                if($scope.validarFiltro()){
                    var valid = form.$valid;
                    if (valid) {
                        postCampanhaFiltro($scope.filtro, function () {
                            $scope.filtro = {};

                            getCampanhaFiltro(function (response) {
                                $scope.filtros = response.data;
                                calculaQuantidadeFiltro();
                                form.$setPristine();
                            });
                        }, NotifyService.showError);
                    }
                }
            };

            $scope.salvarTemplateOrdenacao = function (form) {
                var valid = form.$valid;
                if (valid) {
                    var url = Config.getUrl('CampanhaOrdemTemplate/ProcessaAssociacaoTemplate');

                    var data = {
                        CampanhaId: $scope.campanhaId,
                        CampanhaOrdenacaoTemplateId: $scope.ordemTemplateModel.Id
                    };

                    $http.post(url, data).then(() => {
                        NotifyService.showSuccess();
                        getCampanhaOrdem((response) => {
                            $scope.ordens = response.data;
                            form.$setPristine();
                            $scope.initNestableOrdem();
                        });
                    }).catch(NotifyService.showError);
                }
            };



            $scope.salvarOrdem = function (form) {
                var valid = form.$valid;

                if (valid) {
                    postCampanhaOrdem($scope.ordem, function () {
                        $scope.ordem = {
                            CampanhaOrdemTipoId: 1
                        };

                        getCampanhaOrdem(function (response) {
                            $scope.ordens = response.data;
                            form.$setPristine();
                            $scope.initNestableOrdem();
                        });
                    }, NotifyService.showError);
                }

            };

            $scope.deleteOrdem = function (item) {
                ModalService.confirmDelete(function () {
                    var ordens = [{
                        CampanhaOrdemId: item.CampanhaOrdemId
                    }]
                    deleteCampanhaOrdem(ordens, function () {
                        getCampanhaOrdem(function (response) {
                            $scope.ordens = response.data;
                        });
                    }, NotifyService.showError);
                });
            };
            
            $scope.campanhaLayoutItem = {
                ApenasIgualdade: false
            };

            $scope.getFonteDadosItens = function (campoItem) {
                if (campoItem) {
                    var campanhaLayoutItem = getTemplateCampoItem(campoItem.CampanhaLayoutItemId);
                    $scope.campanhaLayoutItem = campanhaLayoutItem;
                    if (campanhaLayoutItem && campanhaLayoutItem.FonteId) {
                        if (campanhaLayoutItem.Fonte.Comando == "TelefoneTipo/TelefoneTipo") {
                            campanhaLayoutItem.Fonte.Comando += '/' + $scope.campanhaId;
                        }
                        getFonteDados(campanhaLayoutItem.Fonte.Comando, function (response) {
                            campoItem.FonteItens = [];
                            campoItem.CampanhaOperadorId = 4;
                            $scope.onFiltroOperadorAlterado();
                            angular.forEach(response.data, function (item) {
                                campoItem.FonteItens.push({
                                    Nome: item[campanhaLayoutItem.Fonte.Nome],
                                    Valor: item[campanhaLayoutItem.Fonte.Valor]
                                });
                            });
                        });
                    } else {
                        campoItem.CampanhaOperadorId = 3;
                    }
                }
            };

            $scope.getOrdemTemplates = function (ordemTemplate) {
                if (ordemTemplate == undefined || ordemTemplate.Id == undefined) {
                    $scope.ordens = ordens;
                    return;
                }
                getCampanhaOrdemTemplateItem();
            };

            var criarOrdem = function (dados) {
                $scope.ordens = [];
                var ordensTemplate = [];

                var fncItens = function (dados, campanhaTelefoneTipo) {
                    var ctt = campanhaTelefoneTipo;

                    angular.forEach(dados, function (item) {
                        var valorCodigo = '';

                        if ($scope.isFonteDados(item.Id) && item.Id) {
                            var layoutItem = getTemplateCampoItem(item.Id);
                            if (layoutItem && layoutItem.FonteId) {
                                if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                                    var v = _.findWhere(ctt, { Id: parseInt(item.Valor) });
                                    if (v != undefined) valorCodigo = ' - ' + v.Descricao;
                                }
                            }
                        }

                        var ordemObj = {
                            'CampanhaId': $scope.campanhaId,
                            'CampanhaLayoutItem': item.CampanhaLayoutItem,
                            'CampanhaLayoutItemId': item.Id,
                            'CampanhaOrdemTemplateId': item.CampanhaOrdemTemplateId,
                            'CampanhaOrdemTipo': item.CampanhaOrdemTipo,
                            'CampanhaOrdemTipoId': item.CampanhaOrdemTipoId,
                            'HoraFinal': item.HoraFinal,
                            'HoraInicial': item.HoraInicial,
                            'Peso': item.Peso,
                            'Valor': item.Valor,
                            'ValorAlias': item.ValorAlias,
                            'ValorCodigo': valorCodigo
                        };

                        ordensTemplate.push(ordemObj);
                    });
                }

                var campanhaLayoutItemId = _.where(dados, { id: 13 });

                if (campanhaLayoutItemId.length > 0) {
                    CampanhaResource.telefoneTipos({ 'Ids': campanhaLayoutItemId.map(function (i) { return i.Valor; }).join() })
                        .$promise
                        .then(function (data) {
                            fncItens(dados, data);
                        }).catch(NotifyService.showError);
                } else {
                    fncItens(dados, []);
                }

                ordensTemplate.$recordCount = dados.$recordCount || dados.length;
                $scope.$currentPage = dados.$currentPage || 1;
                ordensTemplate.$pageSize = dados.$pageSize || 10;
                $scope.submitted = false;

                $scope.ordens = ordensTemplate;
                ordens = ordensTemplate;
            }

            $scope.criarTemplate = function () {
                $state.go('main.templateOrdenacao.new', { CampanhaId: $scope.campanhaId });
            }

            $scope.duplicarTemplate = function (id) {
                return TemplateOrdenacaoResource.duplicarTemplate({ 'id': id }).$promise
                    .then((data) => {
                        NotifyService.showSuccess();
                        $state.go('main.templateOrdenacao.edit', { Id: data.Id, storage: true });
                    }).catch(NotifyService.showError);
            }

            $scope.EditarTemplate = function (id) {
                var template = ordemTemplate.filter(function (item) { return item.Id == id }).shift();
                ModalService.confirmMessage('telaCampanhaFiltro.confirmEditarTemplate', { 'Nome': template.Nome }, function () {
                    $state.go('main.templateOrdenacao.edit', { Id: id, storage: true });
                });
            }

            var getOdataSearch = function (url) {
                return getOdataSearchShared($odataresource, url);
            };

            $scope.url = "Campanha/" + $stateParams.CampanhaId + "/Ordem";
            $scope.pageChanged = function (newPage) {
                return getOdataSearch($scope.url).page($scope.ordens.$pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
            };

            var updateList = function (list) {
                $scope.ordens = list;
                $scope.ordens.$recordCount = list.$recordCount || list.length;
                $scope.$currentPage = list.$currentPage || 1;
                $scope.ordens.$pageSize = list.$pageSize || 10;
                $scope.submitted = false;
            }

            var getCampanhaOrdemTemplateItem = function () {
                var campanhaOrdemTemplateItemId = $scope.ordemTemplateModel.Id;
                var url = Config.getUrl('CampanhaOrdemTemplate/' + campanhaOrdemTemplateItemId + '/OrdemTemplateItens');

                $scope.url = url;
                return getOdataSearchShared($odataresource, url).page(10, 1).query().then(criarOrdem);
            };

            $scope.isFonteDados = function (campanhaLayoutItemId) {
                var isFonteDados = false;
                var campanhaLayoutItem = getTemplateCampoItem(campanhaLayoutItemId);

                if (campanhaLayoutItem && campanhaLayoutItem.FonteId) {
                    isFonteDados = true;
                }

                return isFonteDados;
            };

            $scope.getDiaSemanaFiltro = function (diaSemana) {
                var descricao = $translate.instant('campo.todos');

                var dia = parseInt(diaSemana);

                switch (dia) {
                    case 1:
                        descricao = $translate.instant('dias.domingo');
                        break;
                    case 2:
                        descricao = $translate.instant('dias.segunda');
                        break;
                    case 3:
                        descricao = $translate.instant('dias.terca');
                        break;
                    case 4:
                        descricao = $translate.instant('dias.quarta');
                        break;
                    case 5:
                        descricao = $translate.instant('dias.quinta');
                        break;
                    case 6:
                        descricao = $translate.instant('dias.sexta');
                        break;
                    case 7:
                        descricao = $translate.instant('dias.sabado');
                        break;
                }

                return descricao;
            };

            $scope.deleteFiltroList = function () {
                ModalService.confirmDelete(function () {
                    var itens = _.filter($scope.filtros, function (item) {
                        return item.Selecionado;
                    });

                    if (itens.length > 0) {
                        deleteCampanhaFiltro(itens, function () {
                            NotifyService.showSuccess();
                            getCampanhaFiltro(function (response) {
                                $scope.filtros = response.data;
                            });
                            calculaQuantidadeFiltro();
                        }, NotifyService.showError);
                    }
                });
            };

            $scope.selecionarTodosFiltros = function (selecionado) {
                angular.forEach($scope.filtros, function (item) {
                    item.Selecionado = selecionado;
                });
            };

            $scope.initNestableOrdem = function () {
                $timeout(function () {
                    var $nestable = $('#nestableOrdem');
                    $nestable.on('change.uk.nestable', function () {
                        var $nestable = $('#nestableOrdem');
                        var itensOrdenados = $nestable.data("nestable").serialize();

                        if (itensOrdenados) {
                            angular.forEach(itensOrdenados, function (val, index) {
                                var campanhaOrdem = _.findWhere($scope.ordens, {
                                    CampanhaOrdemId: val.id
                                });
                                campanhaOrdem.Peso = index + 1;
                                $scope.$apply();
                            });

                            angular.forEach($scope.ordens, function (ordem) {
                                putCampanhaOrdem(ordem, null, NotifyService.showError);
                            });
                        }
                    });

                    calculaQuantidadeFiltro();
                }, 150);
            };

            $scope.initNestableOrdem();

            $scope.fixItens = function () {
                var fncItens = function (campanhaTelefoneTipo) {
                    var ctt = campanhaTelefoneTipo;
                    angular.forEach(ordens, function (item) {
                        if ($scope.isFonteDados(item.Id) && item.Id) {
                            var layoutItem = getTemplateCampoItem(item.Id);
                            if (layoutItem && layoutItem.FonteId) {
                                if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                                    var v = _.findWhere(ctt, { CampanhaTelefoneTipoId: parseInt(item.Valor) });
                                    if (v != undefined) item.ValorCodigo = ' - ' + v.Descricao;
                                }
                            }
                        }
                    });
                }

                var campanhaLayoutItemId = _.where(ordens, { CampanhaLayoutItemId: 13 });

                if (campanhaLayoutItemId.length > 0) {
                    CampanhaResource.telefoneTipos({ 'Ids': campanhaLayoutItemId.map(function (i) { return i.Valor; }).join() })
                        .$promise
                        .then(function (data) {
                            fncItens(data);
                        }).catch(NotifyService.showError);
                } else {
                    fncItens([]);
                }
            };

            $scope.fixItens();
        }]);
})();
(function () {
    "use strict";
    var defaultPageIndex = 1;
    var getOdataSearchShared = function (CampanhaArquivoResource, search, orderBy, $odata, utils, $stateParams) {
        var odata = CampanhaArquivoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanhaGerenciarArquivo", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.campanhaGerenciarArquivo.list',
                    }
                })
                .state("main.campanhaGerenciarArquivo.list", StateResolverProvider.configState("/campanhaGerenciarArquivo", "CampanhaGerenciarArquivo", "List", {
                    pageTitle: 'telaCampanhaArquivo.tituloPesquisa',
                    pageName: 'pageTitle.pesquisar',
                }))
        }])
        .service('CampanhaGerenciarArquivoListData', function CampanhaGerenciarArquivoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    arquivos: ["CampanhaGerenciarArquivoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (CampanhaGerenciarArquivoResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {}
                        var orderBy = {
                            column: "CampanhaArquivoId",
                            order: "desc"
                        };

                        var odata = getOdataSearchShared(CampanhaGerenciarArquivoResource, filtro, orderBy, $odata, utils, $stateParams);
                        return odata.page(10, 1).query();
                    }],
                    campanha: ["TabulacaoResource", "$stateParams", function (TabulacaoResource, $stateParams) {
                        return TabulacaoResource.GetCampanhas().$promise;
                    }],
                    arquivoStatus: ["$translate", function ($translate) {
                        return [
                            { CampanhaArquivoStatusId: 3, Nome: $translate.instant('campo.erro') },
                            { CampanhaArquivoStatusId: 4, Nome: $translate.instant('campo.cancelado') },
                            { CampanhaArquivoStatusId: 5, Nome: $translate.instant('campo.concluido') },
                            { CampanhaArquivoStatusId: 6, Nome: $translate.instant('campo.erroProcessamento') },
                            { CampanhaArquivoStatusId: 7, Nome: $translate.instant('campo.agConfirmacao') },
                            { CampanhaArquivoStatusId: 9, Nome: $translate.instant('campo.emPausa') }
                        ];
                    }],
                }
            }
        })

        .controller("CampanhaGerenciarArquivoListController", ["$scope", "$odata", "$http", "$state", "Config", "arquivos", "arquivoStatus", "campanha", "CampanhaGerenciarArquivoResource", "utils", "LocalStorageService", "$stateParams", "FileDownloadService", "NotifyService", "ModalService", "CampanhaArquivoResource", function ($scope, $odata, $http, $state, Config, arquivos, arquivoStatus, campanha,
            CampanhaGerenciarArquivoResource, utils, LocalStorageService, $stateParams, FileDownloadService, NotifyService, ModalService, CampanhaArquivoResource) {
            $scope.campanha = campanha;
            $scope.arquivos = [];
            $scope.forms = [];
            $scope.arquivoStatus = arquivoStatus;
            $scope.listCampanha = campanha;
            $scope.searching = false;

            $scope.TotalImportados = 0;
            $scope.TotalErros = 0;
            $scope.TotalProcessado = 0;
            $scope.TotalPendente = 0;

            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroCampanhaArquivo") : {};

            $scope.search.DataI = moment().subtract(1, 'days').format('DD/MM/YYYY');
            $scope.search.DataF = moment().format('DD/MM/YYYY');

            $scope.orderBy = {
                column: "CampanhaArquivoId",
                order: "desc"
            };

            var updateList = function (list) {
                $scope.arquivos = list;
                $scope.arquivos.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.arquivos.pageSize = list.$pageSize || 10;
                $scope.searching = false;

                CampanhaGerenciarArquivoResource.query({
                    Nome: $scope.search.Nome,
                    CampanhaArquivoStatusId: $scope.search.CampanhaArquivoStatusId,
                    CampanhaId: $scope.search.CampanhaId,
                    DataI: (!dataI ? '' : moment(dataI).format()),
                    DataF: (!dataF ? '' : moment(dataF).format())
                }).$promise.then(d => {
                    $scope.TotalImportados = d.filter(function (item) { return item.CampanhaArquivoStatusId == 5 }).length;
                    $scope.TotalErros = d.filter(function (item) { return item.CampanhaArquivoStatusId == 3 || item.CampanhaArquivoStatusId == 6 }).length;
                    $scope.TotalProcessadoCancelado = d.filter(function (item) { return item.CampanhaArquivoStatusId == 4 }).length;
                    $scope.TotalPendente = d.filter(function (item) { return item.CampanhaArquivoStatusId == 7 }).length;
                }).catch(NotifyService.showError);
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(CampanhaGerenciarArquivoResource, $scope.search, $scope.orderBy, $odata, utils, $stateParams);
            };

            $scope.pageChanged = function (newPage) {

                if (!validarForm()) return false;

                if (defaultPageIndex != newPage) {

                    defaultPageIndex = newPage;

                    return getOdataSearch()
                        .page($scope.arquivos.pageSize, newPage)
                        .query({
                            Nome: $scope.search.Nome,
                            CampanhaArquivoStatusId: $scope.search.CampanhaArquivoStatusId,
                            CampanhaId: $scope.search.CampanhaId,
                            DataI: !dataI ? '' : moment(dataI).format(),
                            DataF: !dataF ? '' : moment(dataF).format()
                        }).then(updateList).catch(NotifyService.showError);
                }
            };

            updateList(arquivos);

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroCampanhaArquivo', $scope.search);
                $scope.searching = true;

                if (!validarForm()) return false;

                defaultPageIndex = 1;
                getOdataSearch()
                    .page($scope.search.pageSize, 1)
                    .query({
                        Nome: $scope.search.Nome,
                        CampanhaArquivoStatusId: $scope.search.CampanhaArquivoStatusId,
                        CampanhaId: $scope.search.CampanhaId,
                        DataI: !dataI ? '' : moment(dataI).format(),
                        DataF: !dataF ? '' : moment(dataF).format()
                    }).then(updateList).catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                dataI = null;
                dataF = null;
                LocalStorageService.removeItem('FiltroCampanhaArquivo');
                $scope.search = {
                    pageSize: 10
                };
            };

            $scope.confirmarArquivo = function (arquivo) {

                if (arquivo.CampanhaArquivoId > 0 && (arquivo.CampanhaArquivoStatusId == 3
                    || arquivo.CampanhaArquivoStatusId == 6
                    || arquivo.CampanhaArquivoStatusId == 7)) {

                    ModalService.showLoading();

                    var list = [];
                    list.push(arquivo);

                    $http.post(Config.getUrl('CampanhaArquivo/ProcessaArquivos'), list)
                        .then(() => {
                            $scope.executeSearch();
                            NotifyService.showSuccess();
                        }).catch(NotifyService.showError).finally(() => {
                            ModalService.hideLoading();
                        });
                }
            };

            var dataI;
            var dataF;

            function validarForm() {

                if (typeof $scope.search.DataF == 'string')
                    dataF = moment($scope.search.DataF, 'DD/MM/YYYY');
                else
                    dataF = $scope.search.DataF;
                if (typeof $scope.search.DataI == 'string')
                    dataI = moment($scope.search.DataI, 'DD/MM/YYYY');
                else
                    dataI = $scope.search.DataI;

                if (dataI && !dataF) {
                    NotifyService.showError(null, 'telaCampanhaArquivo.validarDataFinalVazia');
                    return false;
                }

                if (!dataI && dataF) {
                    NotifyService.showError(null, 'telaCampanhaArquivo.validarDataInicioVazia');
                    return false;
                }

                if (dataI > dataF) {
                    NotifyService.showError(null, 'telaCampanhaArquivo.validarData');
                    return false;
                }

                return true;
            }

            $scope.DownloadArquivo = function (arquivo) {
                FileDownloadService.downloadWebApiFile("CampanhaGerenciarArquivo/Download/" + arquivo.CampanhaArquivoId);
            }

            $scope.campanhaArquivoPausar = function (arquivo) {
                CampanhaArquivoResource.IniciarArquivo({ CampanhaArquivoId: arquivo.CampanhaArquivoId }).$promise
                    .then(() => {
                        $scope.executeSearch();
                        NotifyService.showSuccess();
                    }).catch(NotifyService.showError);
            }
            $scope.campanhaArquivoIniciar = function (arquivo) {
                CampanhaArquivoResource.PausarArquivo({ CampanhaArquivoId: arquivo.CampanhaArquivoId }).$promise
                    .then(() => {
                        $scope.executeSearch();
                        NotifyService.showSuccess();
                    }).catch(NotifyService.showError);
            }


        }]);
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("CampanhaGerenciarArquivoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CampanhaGerenciarArquivo/GetArquivos");
		}]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('CampanhaHigienizacaoConfiguracaoData', function CampanhaHigienizacaoConfiguracaoData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_charts_c3',
                            'lazy_charts_peity',
                            'lazy_ionRangeSlider',
                            'lazy_countUp'
                        ]);
                    }],
                    causas: ["BilheteCausaResource", function (BilheteCausaResource) {
                        var odata = BilheteCausaResource.odata().orderBy('CausaCodigo', 'asc');
                        return odata.query();
                    }]
                }
            }
        })

        .controller("CampanhaHigienizacaoConfiguracaoController", ["$scope", "CampanhaHigienizacaoResource", "causas", "NotifyService", "ModalService", "$translate", function ($scope, CampanhaHigienizacaoResource, causas, NotifyService, ModalService, $translate) {
            $scope.forms = {};
            $scope.causacodigo = {};

            $scope.configuracaoList = [];
            $scope.statusFiltroList = [
                { 'CampanhaDiscagemStatusId': 24, 'Descricao': $translate.instant('status.sucesso') },
                { 'CampanhaDiscagemStatusId': 25, 'Descricao': $translate.instant('status.insucesso') },
            ];

            $scope.statusFiltro = 24;
            $scope.causasList = causas.map((item) => {
                return { 'CausaCodigo': item.CausaCodigo, 'Descricao': item.CausaCodigo + ' - ' + item.Descricao };
            });

            $scope.getConfiguracoes = function () {
                if ($scope.statusFiltro != null) {
                    CampanhaHigienizacaoResource.getConfiguracoes({ 'statusId': parseInt($scope.statusFiltro) }).$promise
                        .then((data) => {
                            $scope.configuracaoList = data;
                        }).catch((error) => {
                            $scope.configuracaoList = [];
                            NotifyService.showError(error);
                        });
                } else {
                    $scope.configuracaoList = [];
                }
            };

            $scope.onStatusFiltroChange = function () {
                $scope.getConfiguracoes();
            };

            $scope.modalCausaCodigo = function () {
                $scope.causacodigo = { 'CampanhaDiscagemStatusId': $scope.statusFiltro };
                ModalService.openModal('modalCausaCodigo');
                $scope.forms.formCausaCodigo.$dirty = false;
                $scope.forms.formCausaCodigo.$setPristine();
                $scope.forms.formCausaCodigo.CausaCodigo.$touched = false;
            };

            $scope.salvarConfiguracao = function (form) {
                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();
                }

                if (!$scope.salvando) {
                    $scope.salvando = true;
                    $scope.causacodigo.CampanhaDiscagemStatusId = 24;
                    CampanhaHigienizacaoResource.incluirConfiguracao($scope.causacodigo).$promise
                        .then(() => {
                            ModalService.closeModal('modalCausaCodigo');
                            NotifyService.showRegistroSalvo();
                            $scope.getConfiguracoes();
                        }).catch(NotifyService.showError).finally(() => $scope.salvando = false);
                }
            };

            $scope.confirmDelete = function (item) {
                ModalService.confirmDelete(() => {
                    return CampanhaHigienizacaoResource.deletarConfiguracao({ 'CampanhaDiscagemConfiguracaoId': item.CampanhaDiscagemConfiguracaoId }).$promise
                        .then(() => {
                            NotifyService.showSuccess('telaConfiguracaoCampanhaHigienizacao.registroExcluido');
                            $scope.getConfiguracoes();
                        }).catch(NotifyService.showError);
                });
            };

            $scope.getConfiguracoes();

        }])
})();
(function () {
    "use strict";

    var getOdataSearchHistoricoShared = function (MailingHistoricoResource, search, orderBy, $odata) {
        var odata = MailingHistoricoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Ddd) {
            odata.filter('Ddd', parseInt(search.Ddd));
        }

        if (search.Numero) {
            odata.filter(new $odata.Func("contains", "Numero", search.Numero), true);
        }

        return odata;
    };

    angular.module("epbxManagerApp")

        .service('CampanhaHigienizacaoDetalheData', function CampanhaHigienizacaoDetalheData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_charts_c3',
                            'lazy_charts_peity',
                            'lazy_ionRangeSlider',
                            'lazy_countUp'
                        ]);
                    }],
                    campanhasHigienizadas: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        var query = CampanhaResource.CampanhasComPreMetra({ campanhaId: $stateParams.CampanhaId});
                        return query.$promise;
                    }],
                    visao: ["DashboardVisaoResource", function (DashboardVisaoResource) {
                        return DashboardVisaoResource.get({ DashboardVisaoId: parseInt(7) }).$promise;
                    }],
                    historicoList: ["MailingHistoricoResource", "$odata", function (MailingHistoricoResource, $odata) {
                        var orderBy = { column: "Id", order: "desc" };
                        var filtro = {};
                        var odata = getOdataSearchHistoricoShared(MailingHistoricoResource, filtro, orderBy, $odata);
                        return odata.page(1, 1).query();
                    }]
                }
            }
        })

        .controller("CampanhaHigienizacaoDetalheController", ["$scope", "$odata", "$window", "$stateParams", "utils", "MailingHistoricoResource", "CampanhaHigienizacaoResource", "campanhasHigienizadas", "LocalStorageService", "NotifyService", "$translate", "ModalService", "TranslateService", function ($scope, $odata, $window, $stateParams, utils, MailingHistoricoResource, 
            CampanhaHigienizacaoResource, campanhasHigienizadas, LocalStorageService, NotifyService, $translate, ModalService, TranslateService) {
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroMailingHistorico") : {};
            $scope.dateFormat = TranslateService.getAngularDateFormat();
            $scope.search.pageSize = 1;

            $scope.orderBy = {
                column: "Id",
                order: "asc"
            };

            var quantidadesInicial = [
                { 'label': 'Importado','status': $translate.instant('telaDetalheCampanhaHigienizacao.importado'), 'color': '#2196f3', 'quantidade': 0, 'porcentagem': null, 'visivel': true },
                { 'label': 'Livre', 'status': $translate.instant('telaDetalheCampanhaHigienizacao.livre'), 'color': '#7CB342', 'quantidade': 0, 'porcentagem': null, 'visivel': true },
                { 'label': 'Pendente', 'status': $translate.instant('telaDetalheCampanhaHigienizacao.pendente'), 'color': '#FFA000', 'quantidade': 0, 'porcentagem': null, 'visivel': true },
                { 'label': 'Cancelado', 'status': $translate.instant('campo.cancelado'), 'color': '#FF8738', 'quantidade': 0, 'porcentagem': null, 'visivel': true },
                { 'label': 'Sucesso', 'status': $translate.instant('status.sucesso'), 'color': '#1976D2', 'quantidade': 0, 'porcentagem': null, 'visivel': true },
                { 'label': 'Insucesso', 'status': $translate.instant('status.insucesso'), 'color': '#E53935', 'quantidade': 0, 'porcentagem': null, 'visivel': true },
                { 'label': 'BloqueadoLei', 'status': $translate.instant('telaDetalheCampanhaHigienizacao.bloqueadoLei'), 'color': '#E53935', 'quantidade': 0, 'porcentagem': null, 'visivel': true }
            ];

            $scope.campanhaId = $stateParams.CampanhaId;
            var campanhasTodas = [{ 'CampanhaId': 0, 'Nome': $translate.instant('campo.todas') }];

            if (campanhasHigienizadas.length > 0) {
                var c = campanhasHigienizadas.map((item) => {
                    return { 'CampanhaId': item.CampanhaId, 'Nome': item.CampanhaId + " - " + item.Nome };
                });
                $scope.campanhasList = campanhasTodas.concat(c);
            }

            $scope.campanhaFiltro = 0;
            $scope.quantidades = quantidadesInicial;
            $scope.sucessoList = [];
            $scope.insucessoList = [];

            $scope.getHigienizacaoDetalheQuantidades = function () {
                if ($scope.campanhaFiltro != null) {
                    CampanhaHigienizacaoResource.getHigienizacaoDetalheQuantidades({ 
                        'campanhaHigienizacaoId': parseInt($stateParams.CampanhaId), 
                        'campanhaId': $scope.campanhaFiltro 
                    }).$promise
                        .then((data) => {
                            $scope.quantidades = angular.copy(quantidadesInicial);
                            $scope.quantidades.forEach((item) => {
                                item.quantidade = data[item.label];
                                if (item.label == $translate.instant('status.sucesso') || item.label == $translate.instant('status.insucesso')) {
                                    item.porcentagem = (data["Importado"] <= 0 || data[item.label] <= 0) ? 0 :
                                    (parseFloat(data[item.label] / data["Importado"]) * 100).toFixed(2);
                                }
                            });
                        }).catch((error) => {
                            $scope.quantidades = quantidadesInicial;
                            NotifyService.showError(error);
                        });
                } else {
                    $scope.quantidades = quantidadesInicial;
                }
            };

            $scope.getHigienizacaoDetalhe = function () {
                if ($scope.campanhaFiltro != null) {
                    CampanhaHigienizacaoResource.getHigienizacaoDetalhe({ 
                        'campanhaHigienizacaoId': parseInt($stateParams.CampanhaId), 
                        'campanhaId': $scope.campanhaFiltro 
                    }).$promise
                        .then((data) => {
                            $scope.sucessoList = data.filter((item) => { return item.CampanhaDiscagemStatusId == 24; });
                            $scope.insucessoList = data.filter((item) => { return item.CampanhaDiscagemStatusId == 25; });
                        }).catch((error) => {
                            $scope.sucessoList = [];
                            $scope.insucessoList = [];
                            NotifyService.showError(error);
                        });
                } else {
                    $scope.sucessoList = [];
                    $scope.insucessoList = [];
                }
            };

            $scope.onCampanhaChange = function () {
                $scope.getHigienizacaoDetalheQuantidades();
                $scope.getHigienizacaoDetalhe();
            };

            $scope.confirmaRediscar = function (item) {
                var release = item.CausaCodigo + ' - ' + item.CausaDescricao;
                ModalService.confirmMessage('telaDetalheCampanhaHigienizacao.desejaRealmenteRediscarORelease', {'Release': release}, function () {
                    ModalService.showLoading();
                    CampanhaHigienizacaoResource.deleteHigienizacaoDetalheInsucesso({
                        CampanhaId: $scope.campanhaFiltro,
                        CampanhaHigienizacaoId: parseInt($stateParams.CampanhaId),
                        CausaCodigo: item.CausaCodigo
                    }).$promise
                        .then(() => {
                            ModalService.hideLoading();
                            NotifyService.showSuccess();
                            $scope.atualizarDados();
                        }).catch((error) => {
                            ModalService.hideLoading();
                            NotifyService.showError(error);
                        })
                });
            };

            $scope.exibirRediscar = function () {
                return ($scope.campanhaFiltro != null && $scope.campanhaFiltro != undefined && $scope.campanhaFiltro != 0);
            };

            $scope.atualizarDados = function () {
                $scope.getHigienizacaoDetalheQuantidades();
                $scope.getHigienizacaoDetalhe();
            }

            $scope.getHigienizacaoDetalheQuantidades();
            $scope.getHigienizacaoDetalhe();

            $scope.abrirModalHistoricoDados = function () {
                ModalService.openModal('modal_historico', $scope.limparFiltroHistorico);
            };

            var getOdataSearch = function () {
                return getOdataSearchHistoricoShared(MailingHistoricoResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            var updateList = function (list) {
                $scope.historicoList = list;
                $scope.historicoList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.historicoList.pageSize = list.$pageSize || 1;
            };

            $scope.executeSearchHistorico = function () {
                LocalStorageService.setItem('FiltroMailingHistorico', $scope.search);
                $scope.search.pageSize = 1;

                var form = $scope.forms.formHistorico;

                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();
                }

                MailingHistoricoResource.getHistoricoByTelefone({ 'ddd': $scope.search.Ddd, 'numero': $scope.search.Numero }).$promise
                    .then((data) => {
                        $scope.historicoList = [];
                        if (data.Id > 0) {
                            $scope.historicoList.push(data);
                        }
                    }).catch(NotifyService.showError);
            };

            $scope.limparFiltroHistorico = function () {
                LocalStorageService.removeItem('FiltroMailingHistorico');
                $scope.search = { pageSize: 1 };
                $scope.historicoList = [];
                var form = $scope.forms.formHistorico;
                form.$dirty = false;
                form.$setUntouched();
                form.$setPristine();
            };

            $scope.pageHistoricoChanged = function (newPage) {
                return getOdataSearch().page($scope.historicoList.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .service('CampanhaHigienizacaoEditData', function CampanhaHigienizacaoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    campanha: ["CampanhaResource", "$stateParams", function (CampanhaResource, $stateParams) {
                        if ($stateParams.CampanhaId) {
                            return CampanhaResource.get({
                                CampanhaId: $stateParams.CampanhaId
                            }).$promise;
                        } else {
                            return {
                                AgendamentoParalelo: false,
                                DiscagemVertical: false
                            };
                        }
                    }],
                    layouts: ["CampanhaLayoutResource", function (CampanhaLayoutResource) {
                        var odata = CampanhaLayoutResource.odata().orderBy('Nome', 'asc');
                        odata.filter('Ativo', true);
                        return odata.query();
                    }],
                    rotas: ["RotaResource", function (RotaResource) {
                        var odata = RotaResource.odata().orderBy('Nome', 'asc');
                        odata.filter('Ativo', true);
                        odata.filter('RotaTipoId', 5);
                        return odata.query();
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        var odata = GrupoResource.odata().orderBy('Descricao', 'asc');
                        return odata.query();
                    }],
                    campanhatipos: ["CampanhaTipoResource", function (CampanhaTipoResource) {
                        return CampanhaTipoResource.query().$promise;
                    }],
                    campanhatemplates: ["CampanhaTemplateResource", function (CampanhaTemplateResource) {
                        return CampanhaTemplateResource.query().$promise;
                    }],
                    campanhaTemplateCampo: ["CampanhaTemplateResource", function (CampanhaTemplateResource) {
                        return CampanhaTemplateResource.campanhaTemplateCampo({ campanhaTemplateId: 3 }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    diaSemana: ["$translate", function ($translate) {
                        return {
                            0: $translate.instant('dias.domingo'),
                            1: $translate.instant('dias.segunda'),
                            2: $translate.instant('dias.terca'),
                            3: $translate.instant('dias.quarta'),
                            4: $translate.instant('dias.quinta'),
                            5: $translate.instant('dias.sexta'),
                            6: $translate.instant('dias.sabado')
                        };
                    }]
                }
            }
        })
        .controller("CampanhaHigienizacaoEditController", ["$scope", "$state", "AuthService", "WizardHandler", "CampanhaResource", "PermissaoService", "campanha", "layouts", "rotas", "grupos", "campanhatipos", "campanhatemplates", "campanhaTemplateCampo", "diaSemana", "NotifyService", "$translate", "ModalService", "TranslateService", "carteiras", function ($scope, $state, AuthService, WizardHandler, CampanhaResource, PermissaoService,
            campanha, layouts, rotas, grupos, campanhatipos, campanhatemplates, campanhaTemplateCampo, diaSemana, NotifyService, $translate, ModalService, 
            TranslateService, carteiras) {
            $scope.usuarioLogadoId = AuthService.getUsuarioLogado() ? AuthService.getUsuarioLogado().UsuarioId : 0;
            $scope.isNew = campanha.CampanhaId > 0 ? false : true;
            $scope.campanha = campanha;
            $scope.campanha.Visivel = $scope.isNew ? true : campanha.Visivel;
            $scope.forms = {};
            $scope.detalhesPermissao = PermissaoService.checkAccess('Campanha', 'Detalhe');
            $scope.periodoPermissao = PermissaoService.checkAccess('Campanha', 'Periodo');
            $scope.layouts = layouts;
            $scope.rotasHigienizadas = rotas;
            $scope.diaSemana = diaSemana;
            $scope.salvando = false;
            $scope.carteiras = carteiras;
            $scope.campanhaEmAndamento = (!$scope.isNew && (campanha.CampanhaStatusId === 3 || campanha.CampanhaStatusId === 6))
            let timeFormat = TranslateService.getMomentTimeFormat();

            $scope.grupos = grupos.filter((item) => {
                item.Numero = (item.Ramal) ? item.Ramal.Numero : item.Numero;
                return item.GrupoTipoId == 1
            });

            $scope.campanha.RedirecionaTipoId = 2;

            // Lista Campanha Campo 
            var camposCampanha = (!$scope.isNew) ? $scope.campanha.CampanhaConfiguracao : campanhaTemplateCampo;
            var t = _.findWhere(camposCampanha, { Campo: 'QtasLigRamal' });
            $scope.campanha.PerfilDiscagem = t.Valor;

            // TipoId e CampanhaTemplateId
            var tipos = _.findWhere(campanhatipos, { Descricao: 'Higienização' });
            var templates = _.findWhere(campanhatemplates, { CampanhaTipoId: tipos.Id });
            $scope.campanha.CampanhaTipoId = tipos.Id;
            $scope.campanha.CampanhaTemplateId = templates.CampanhaTemplateId;
            $scope.campanha.CampanhaTipo = tipos;

            // #endregion [ Variaveis de inicialização ] 

            // #region [ Métodos dos períodos da campanha ]

            $scope.onHorarioAlterado = function () {
                $scope.forms.formHorarios.$setDirty();
            };

            $scope.configurarHorarios = function () {
                $scope.campanha.CampanhaHorario.forEach((element) => {
                    element.HoraInicio = moment(element.HoraInicio, timeFormat).format("HH:mm");
                    element.HoraTermino = moment(element.HoraTermino, timeFormat).format("HH:mm");
                })
            }

            // #endregion [ Métodos dos períodos da campanha ]

            // #region [ Métodos de salvar a campanha ]

            $scope.redirecionaListaCampanha = function () {
                $state.go('main.campanha.list');
            };

            $scope.salvar = function (form) {
                var lastStep = (form.$name == "forms.formHorarios") ? true : false;

                if (!form.$dirty && lastStep && !$scope.isNew) {
                    $state.go('main.campanha.list');
                }

                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();

                }

                _.each(camposCampanha, (item) => {
                    if (item.Campo == "QtasLigRamal") {
                        item.Valor = $scope.campanha.PerfilDiscagem;
                    }

                    if (item.Campo == "TempoRingCliente") {
                        item.Valor = '1';
                    }
                });

                $scope.campanha.CampanhaConfiguracao = camposCampanha; 

                if(lastStep)
                {
                    if(!$scope.validarJornada())
                    {
                        return false;
                    }
                }

                if ($scope.isNew) {                    
                    if (lastStep) {
                        ModalService.showLoading();
                        $scope.configurarHorarios();
                        $scope.campanha.CampanhaRota = [{
                            'CampanhaId': 0,
                            'CampanhaRotaId': 0,
                            'ClasseId': null,
                            'ClasseNome': null,
                            'RegraDiscagemId': null,
                            'RotaId': $scope.campanha.RotaHigienizacaoId
                        }];

                        $scope.salvando = true;
                        var promise = CampanhaResource.save($scope.campanha).$promise;
                        promise.then(() => {
                            ModalService.hideLoading();
                            $scope.salvando = false;
                            NotifyService.showRegistroSalvo();
                            $scope.redirecionaListaCampanha();
                        }).catch((error) => {
                            ModalService.hideLoading();
                            NotifyService.showError(error);
                            $scope.salvando = false;
                        });
                    }
                } else if (form.$dirty) {
                    if ($scope.campanha.CampanhaStatusId == 3) {
                        $scope.campanha.PendenteAcao = true;
                    }

                    $scope.configurarHorarios();
                    
                    if(lastStep) {
                        ModalService.showLoading();
                    }


                    if ($scope.campanha.CampanhaRota.length > 0) {
                        $scope.campanha.CampanhaRota[0].RotaId = $scope.campanha.RotaHigienizacaoId;
                    } else {
                        $scope.campanha.CampanhaRota = [{
                            'CampanhaId': 0,
                            'CampanhaRotaId': 0,
                            'ClasseId': null,
                            'ClasseNome': null,
                            'RegraDiscagemId': null,
                            'RotaId': $scope.campanha.RotaHigienizacaoId
                        }];
                    }

                    $scope.salvando = true;

                    CampanhaResource.update($scope.campanha).$promise
                        .then(() => {
                            ModalService.hideLoading();
                            $scope.salvando = false;
                            NotifyService.showRegistroSalvo();
                            form.$setPristine();
                            $scope.rotasAntigas = [];
                            if (lastStep) {
                                $scope.redirecionaListaCampanha();
                            } else {
                                configurarHorariosInicial();
                            }
                        }).catch((error) => {
                            ModalService.hideLoading();
                            NotifyService.showError(error);
                            $scope.salvando = false;
                        });
                }
            };

            // #endregion [ Métodos de salvar a campanha ]

            // #region [ Métodos uteis ] 

            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3>${descricao}`);
            }

            $scope.formDetalhesDirty = function () {
                $scope.forms.formDetalhes.$setDirty();
            }

            $scope.validaQuantidadeCanais = function () {
                var rota = _.first(_.where($scope.rotasHigienizadas, { RotaId: $scope.campanha.RotaHigienizacaoId }));
                if (rota && $scope.campanha.PerfilDiscagem) {
                    if (parseInt($scope.campanha.PerfilDiscagem) > (rota.CanalF - rota.CanalI)) {
                        NotifyService.showError(null, 'telaCampanhaHigienizacaoEdit.aQtdDeCanaisUltrapassaQtdDaRota');
                        $scope.campanha.PerfilDiscagem = '';
                        return false;
                    }
                }
                return true;
            };

            // #endregion [ Métodos uteis ] 

            // #region [ Inicialização da página ]

            var configurarHorariosInicial = function () {
                $scope.campanha.CampanhaHorario.forEach((element) => {
                    element.HoraInicio = moment(element.HoraInicio, "HH:mm").format(timeFormat);
                    element.HoraTermino = moment(element.HoraTermino, "HH:mm").format(timeFormat);
                    element.DiaSemana = $scope.diaSemana[element.Dia];
                });
            }

            if (!$scope.isNew) {
                if ($scope.campanha.RamalId) {
                    $scope.campanha.RedirecionaTipoId = $scope.campanha.RamalTipoId;
                }
                else {
                    $scope.campanha.RedirecionaTipoId = 2;
                }
                
                configurarHorariosInicial();

                if ($scope.campanha.CampanhaRota.length > 0) {
                    $scope.campanha.RotaHigienizacaoId = $scope.campanha.CampanhaRota[0].RotaId;
                }
            }  else {
                $scope.campanha.CampanhaHorario = [];                
                $scope.campanha.DiasRetencao = 5;

                for (var name in $scope.diaSemana) {
                    if ($scope.diaSemana.hasOwnProperty(name)) {
                        if($scope.campanha.CampanhaTipo)
                        {
                            var novoHorario = {
                                Dia: name,
                                DiaSemana: $scope.diaSemana[name],
                                HoraInicio: $scope.campanha.CampanhaTipo.JornadaInicio,
                                HoraTermino: $scope.campanha.CampanhaTipo.JornadaFim,
                                Ativo: false
                            };
                            $scope.campanha.CampanhaHorario.push(novoHorario);
                        } else {
                            var novoHorario = {
                                Dia: name,
                                DiaSemana: $scope.diaSemana[name],
                                HoraInicio: new Date(16, 1, 1, 9, 0, 0, 0),
                                HoraTermino: new Date(16, 1, 1, 18, 0, 0, 0),
                                Ativo: false
                            };
                            $scope.campanha.CampanhaHorario.push(novoHorario);
                        }
                    }
                }
                $scope.campanha.CampanhaRota = [];
                $scope.campanha.CampanhaRota.push({});
            }

            $scope.validarJornada = function () {
                if($scope.campanha.CampanhaTipo){
                    if($scope.campanha.CampanhaTipo.JornadaObrigatoria){
                        let exists = $scope.campanha.CampanhaHorario.find(horario => horario.Ativo);
                        if(exists == null)
                        {
                            NotifyService.showError(null, 'telaCampanhaHigienizacaoEdit.jornadaObrigatoria')
                            return false;
                        } else return true;
                    } else return true;
                }                
            }

            // #endregion [ Inicialização da página ]
            $scope.onChangeAtivo = function (item) {

                if (item.Dia == 0 && item.Ativo) {
                    ModalService.alert($translate.instant('telaCampanhaHigienizacaoEdit.alertDomingo'));
                }

            }
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CampanhaHigienizacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Campanha/:CampanhaId",
                { "Id": "@Id" },
                {
                    getHigienizacaoDetalheQuantidades: { 
                        method: "GET", 
                        url: "Campanha/HigienizacaoDetalheQuantidades", 
                        isArray: false 
                    },
                    getHigienizacaoDetalhe: { 
                        method: "GET", 
                        url: "Campanha/HigienizacaoDetalhe", 
                        isArray: true 
                    },
                    getConfiguracoes: { 
                        method: "GET", 
                        url: "CampanhaDiscagemConfiguracao/GetByStatusId", 
                        isArray: true 
                    },
                    getCausas: { 
                        method: "GET", 
                        url: "BilheteCausa/GetBilheteCausas", 
                        isArray: true 
                    },
                    getQuantidadeCampanhasVinculadasHigienizacao: { 
                        method: "GET", 
                        url: "Campanha/QuantidadeCampanhasVinculadasHigienizacao", 
                        isArray: true 
                    },
                    incluirConfiguracao: { 
                        method: "POST", 
                        url: "CampanhaDiscagemConfiguracao/Post" 
                    },
                    deletarConfiguracao: { 
                        method: "DELETE", 
                        url: "CampanhaDiscagemConfiguracao/:CampanhaDiscagemConfiguracaoId/Delete" 
                    },
                    deleteHigienizacaoDetalheInsucesso: { 
                        method: "DELETE", 
                        url: "Campanha/DeleteHigienizacaoDetalhe"
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("MailingHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MailingHistorico/:Id", {
                "Id": "@Id"
            },
                {
                    getHistoricoByTelefone: {
                        url: "MailingHistorico/HistoricoByTelefone",
                        method: "GET",
                        isArray: false
                    },

                    getHistoricoPaginado: {
                        url: "MailingHistorico/HistoricoPaginado",
                        method: "GET"
                    },
                    getHistoricoPaginadoCount: {
                        url: "MailingHistorico/HistoricoPaginadoCount",
                        method: "GET"
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .controller("CampanhaHistoricoDetalheController",
            ["$rootScope", "$scope", "CampanhaHistoricoResource", "BilheteResource", "FileDownloadService", "$q", "NotifyService", "ModalService", function ($rootScope, $scope, CampanhaHistoricoResource, BilheteResource, FileDownloadService, $q, NotifyService, ModalService) {

                $rootScope.$on('onDetalheHistorico', function (event, dados) {
                    $scope.viewChamadaDetalhe(dados);
                });

                $scope.bilheteDialogoAtivo = {};

                $scope.secondsToHms = function (d) {
                    var hours = Math.floor(d / 3600);
                    var minutes = Math.floor((d - (hours * 3600)) / 60);
                    var seconds = d - (hours * 3600) - (minutes * 60);
                    // round seconds
                    seconds = Math.round(seconds * 100) / 100
                    var result = (hours < 10 ? "0" + hours : hours);
                    result += ":" + (minutes < 10 ? "0" + minutes : minutes);
                    result += ":" + (seconds < 10 ? "0" + seconds : seconds);
                    return result;
                }

                $scope.maxLenViewString = function (str, max) {
                    if (str) {
                        var len = str.length;
                        var retorno = str;
                        if (len > max) retorno = str.substring(0, max) + "...";
                        return retorno;
                    }
                }

                $scope.viewChamadaDetalhe = function (dados) {
                    if (dados) {
                        $scope.chamadaDetalheList = [];
                        $scope.telefonesFiltroList = [];
                        $scope.atendentesFiltroList = [];
                        $scope.grupoFiltroList = [];
                        var filtro = {}

                        if (dados.filtro) {
                            filtro = dados.filtro;
                        }

                        var chamada = dados.chamada;
                        $scope.campanhaId = chamada.CampanhaId;
                        $scope.nomeCampanha = chamada.Campanha || chamada.CampanhaNome;
                        $scope.codigoCliente = chamada.CodigoCliente;
                        $scope.nomeCliente = chamada.NomeCliente;
                        $scope.expanded = false;

                        var pesquisa = {
                            DataInicio: filtro.DataInicio != null ? filtro.DataInicio : null,
                            DataFim: filtro.DataFim != null ? filtro.DataFim : null,
                            CampanhaId: $scope.campanhaId,
                            CodigoCliente: $scope.codigoCliente,
                            CampanhaDiscagemStatusId: filtro.CampanhaDiscagemStatusId != null ? filtro.CampanhaDiscagemStatusId : null
                        }

                        var promise = CampanhaHistoricoResource.campanhaHistoricoDetalhe(pesquisa).$promise;
                        promise.then(function (data) {
                            var filter = function (nomeCampo) {
                                return function (item) {
                                    return item[nomeCampo] !== null;
                                }
                            }

                            $scope.telefonesFiltroList = _.filter(_.map(_.uniq(_.pluck(data, 'Telefone')), function (item) {
                                return {
                                    Telefone: item
                                }
                            }), filter('Telefone'));
                            $scope.atendentesFiltroList = _.filter(_.map(_.uniq(_.pluck(data, 'NomeAtendente')), function (item) {
                                return {
                                    NomeAtendente: item
                                }
                            }), filter('NomeAtendente'));
                            $scope.grupoFiltroList = _.filter(_.map(_.uniq(_.pluck(data, 'NomeGrupo')), function (item) {
                                return {
                                    NomeGrupo: item
                                }
                            }), filter('NomeGrupo'));

                            $scope.chamadaDetalheList = data;
                        });

                    }
                }

                $scope.viewBilheteDetalhe = function (bilhete) {
                    if (bilhete) {
                        $scope.$parent.bilheteView = {};
                        $scope.$parent.bilheteGlobalId = bilhete.GlobalId;
                        var bilheteId = bilhete.BilheteId;
                        $scope.$parent.detalheList = [];

                        var promises = [];
                        promises.push(BilheteResource.bilheteById({
                            bilheteid: bilheteId
                        }).$promise);

                        promises.push(BilheteResource.bilheteDetalhe({
                            globalid: $scope.bilheteGlobalId,
                            bilheteId: bilheteId
                        }).$promise);

                        $q.all(promises).then(function (data) {
                            var res1 = data[0];
                            var res2 = data[1];
                            if (res1) {
                                angular.copy(res1[0], $scope.$parent.bilheteView);
                            }
                            angular.copy(res2, $scope.$parent.detalheList);
                            ModalService.openModal('modal_detalhe_bilhete');
                        }).catch(NotifyService.showError);
                    }
                }

                $scope.downloadFile = function (globalId) {
                    if (globalId != null) {
                        try {
                            FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId);
                        } catch (err) {
                            NotifyService.showError(err);
                        }
                    }
                }

                $scope.reproduzirDialogo = function (bilhete) {
                    if (bilhete != null) {
                        if($scope.search == null) $scope.search = {};
                        $scope.search.bilheteDialogoAtivo = bilhete;
                    }
                }

            }]
        );

})();
(function () {
    "use strict";
    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    var getOdataSearchShared = function (search, $http, Config) {
        var filtro = {
            DataInicio: search.DataInicio,
            DataFim: search.DataFim,
            CampanhaId: search.CampanhaId,
            CampanhaDiscagemStatusId: search.CampanhaDiscagemStatusId,
            CodigoCliente: search.CodigoCliente,
            Telefone: search.NB,
            Duracao: search.Duracao,
            Tentativas: search.Tentativas,
            CarteiraId: search.Id
        };

        var url = Config.getUrl("CampanhaHistorico/") + defaultPageIndex + "/" + defaultPageSize
        return $http({
            method: 'GET',
            url: url,
            params: filtro
        }).then(function (response) {
            return response.data;
        });
    }

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanhahistorico", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.campanhahistorico.list',
                        pageTitle: 'pageTitle.historicoDeChamadas',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.campanhahistorico.list", StateResolverProvider.configState("/campanhahistorico", "CampanhaHistorico", "List", {
                    pageTitle: 'pageTitle.historicoDeChamadas',
                    pageName: 'pageTitle.pesquisar',
                    css: true,
                    cssFiles: ['app/pages/bilhete/style/listBilheteDetalhe.css']
                }))
        }])

        .service("CampanhaHistoricoListData", function ReportListData() {
            return function () {
                return {
                    campanhaDiscagemStatusIdList: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.odata().select("CampanhaDiscagemStatusId", "Descricao").orderBy("Descricao").query();
                    }],
                    campanhaList: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.GetTodasCampanhas().$promise;
                    }],
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })

        .controller("CampanhaHistoricoListController", ["$rootScope", "$scope", "$http", "Config", "campanhaDiscagemStatusIdList", "campanhaList", "$stateParams", "ModalService", "NotifyService", "$filter", "TranslateService", "CampanhaHistoricoResource", "FileDownloadService", "carteiras", function ($rootScope, $scope, $http, Config, campanhaDiscagemStatusIdList, campanhaList, $stateParams,
            ModalService, NotifyService, $filter, TranslateService, CampanhaHistoricoResource, FileDownloadService, carteiras ) {
            var dataInicio = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).subtract(1, 'days').seconds(0).milliseconds(0).toDate();
            var dataFim = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).add(1, 'days').seconds(0).milliseconds(0).toDate();
            $scope.pageSize = 15;
            $scope.search = {};
            $scope.bilheteDialogoAtivo = {};
            $scope.searching = false;
            $scope.dateTimeFormat = TranslateService.getAngularDateTimeFormatWithSeconds();
            $scope.carteiras = carteiras;
            $scope.naoConsulta = true;
            
            if ($stateParams.search) {
                $scope.search = $stateParams.search;
            }
            else {
                $scope.search = {
                    DataInicio: dataInicio,
                    DataFim: $stateParams.DataFim || dataFim,
                    PageSize: 15
                };
            }

            $scope.campanhaDiscagemStatusIdList = [];
            $scope.campanhaList = campanhaList;
            $scope.campanhaListCopia = campanhaList;
            $scope.chamadaList = [];

            angular.forEach(campanhaDiscagemStatusIdList, function (value) {
                switch (value.CampanhaDiscagemStatusId) {
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 18:
                        $scope.campanhaDiscagemStatusIdList.push(value);
                        break;
                }
            });

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            $scope.registroPorPaginaArray = [
                { label: 15, valor: 15 },
                { label: 30, valor: 30 },
                { label: 50, valor: 50 },
                { label: 100, valor: 100 }
            ];

            $scope.order = function (predicate) {
                $scope.predicate = predicate;
                $scope.reverse = $scope.predicate ? !$scope.reverse : false;
                var list = $filter('orderBy')($scope.chamadaList, $scope.predicate, $scope.reverse);
                angular.copy(list, $scope.chamadaList);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                defaultPageIndex = 1;
                getOdataSearch().then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.pageChanged = function (newPage) {
                if (newPage != defaultPageIndex) {
                    ModalService.showLoading();
                    defaultPageIndex = newPage;
                    return getOdataSearch().then((list) => {
                        updateList(list);
                        ModalService.hideLoading();
                    }).catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                    });
                }
            };

            $scope.$watch('search.PageSize', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    defaultPageSize = newValue ? newValue : 15;
                    $scope.executeSearch();
                }
            });

            $scope.limparFiltro = function () {
                $scope.search = {
                    DataInicio: dataInicio,
                    DataFim: $stateParams.DataFim || dataFim,
                };
                $scope.chamadaList = [];
                $scope.chamadaDetalheList = [];
                $scope.telefonesFiltroList = [];
                $scope.atendentesFiltroList = [];
                $scope.grupoFiltroList = [];
                $scope.executeSearch();
            }

            $scope.viewChamadaDetalhe = function (chamada) {
                var dadosHistorico = {
                    filtro: $scope.search,
                    chamada: chamada
                };
                $rootScope.$broadcast('onDetalheHistorico', dadosHistorico);
                ModalService.openModal('modal_detalhe');
            }

            var updateList = function (pagination) {
                $scope.chamadaList = pagination.Data;
                $scope.chamadaList.recordCount = pagination.RecordCount;
                $scope.currentPage = pagination.PageIndex || 1;
                $scope.chamadaList.pageSize = pagination.PageSize || defaultPageSize;
                $scope.searching = false;
                $scope.naoConsulta = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared($scope.search, $http, Config);
            };
            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }
            
            $scope.exportarHistorico = function () {
                try {
                    ModalService.showLoading();
                    var fileName = generateUUID();
                    CampanhaHistoricoResource.exportar({
                        DataInicio: $scope.search.DataInicio != null ? new moment($scope.search.DataInicio).format("MM/DD/YYYY HH:mm") : null,
                        DataFim: $scope.search.DataFim != null ? new moment($scope.search.DataFim).format("MM/DD/YYYY HH:mm") : null,
                        CampanhaId: $scope.search.CampanhaId,       
                        CampanhaDiscagemStatusId: $scope.search.CampanhaDiscagemStatusId,                 
                        CodigoCliente: parseInt($scope.search.CodigoCliente || null),                        
                        Telefone: $scope.search.NB,
                        Duracao: $scope.search.Duracao,
                        Tentativas: $scope.search.Tentativas,
                        FileName: fileName
                    }).$promise.then(() => {
                        FileDownloadService.downloadWebApiFile("CampanhaHistorico/Download/" + fileName);
                        ModalService.hideLoading();
                    }).catch((data) => {
                        ModalService.hideLoading();
                        NotifyService.showError(data.error);
                    });
                } catch (err) {
                    NotifyService.showError(err);
                }
            }

            $scope.onChangeCarteira = function () {
                if($scope.search.Id == 0 || $scope.search.Id == undefined)
                {
                    $scope.campanhaList = $scope.campanhaListCopia;
                }else{
                    $scope.campanhaList = $scope.campanhaListCopia;
                    $scope.campanhaList = _.filter($scope.campanhaList, function (el) {
                        return el.CarteiraId == $scope.search.Id;
                    });
                }
            }

            $scope.onChangeCampanha = function () {
                if ($scope.search.CampanhaId > 0) {
                    $scope.naoConsulta = false;
                }else {
                    $scope.naoConsulta = true;
                }
            } 
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

            $stateProvider
                .state("main.campanhaTemplateRegra.edit", StateResolverProvider.configState("/campanhaTemplateRegra/{Id:[0-9]+}", "CampanhaTemplateRegra", "Edit", {
                    pageTitle: 'pageTitle.templateRegraDiscagem',
                    pageName: 'acoes.editar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/regra.css']
                }))
                .state("main.campanhaTemplateRegra.new", StateResolverProvider.configState("/campanhaTemplateRegra/new", "CampanhaTemplateRegra", "Edit", {
                    pageTitle: 'pageTitle.templateRegraDiscagem',
                    pageName: 'acoes.cadastrar',
                    css: true,
                    cssFiles: ['app/pages/campanha/style/regra.css']
                }));
        }])

        .service("CampanhaTemplateRegraEditData", function CampanhaTemplateRegraEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_parsleyjs',
                            'lazy_masked_inputs',
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhaTemplateRegra: ["CampanhaTemplateRegraResource", "$stateParams", function (CampanhaTemplateRegraResource, $stateParams) {
                        if ($stateParams.Id) {
                            return CampanhaTemplateRegraResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    campanhaDiscagemStatus: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        var odata = CampanhaDiscagemStatusResource.odata().orderBy("Descricao");
                        odata.filter('Ativo', true);
                        odata.filter('PermiteRegra', true);
                        return odata.query();
                    }],
                    retornoStatus: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.query().$promise;
                    }],
                    layouts: ["CampanhaLayoutResource", function (CampanhaLayoutResource) {
                        var odata = CampanhaLayoutResource.odata().orderBy('Nome', 'asc');
                        odata.filter('Ativo', true);
                        return odata.query();
                    }],
                    fluxo: ["BilheteTalkbotResource", function(BilheteTalkbotResource)
                    {
                        return BilheteTalkbotResource.fluxo();
                    }],
                    fluxoOut: ["BilheteTalkbotResource", function(BilheteTalkbotResource)
                    {
                        return BilheteTalkbotResource.fluxoOut();
                    }],
                    acionamentoStatus: ["BilheteTalkbotResource", function(BilheteTalkbotResource)
                    {
                        return BilheteTalkbotResource.acionamento();
                    }],
                }
            }
        })

        .controller("CampanhaTemplateRegraEditController", ["$scope", "$window", "$state", "$stateParams", "CampanhaTemplateRegraResource", "campanhaTemplateRegra", "campanhaDiscagemStatus", "CampanhaDiscagemStatusResource", "retornoStatus", "$timeout", "layouts", "NotifyService", "ModalService", "fluxo", "fluxoOut", "acionamentoStatus", function ($scope, $window, $state, $stateParams, CampanhaTemplateRegraResource,
            campanhaTemplateRegra, campanhaDiscagemStatus, CampanhaDiscagemStatusResource, retornoStatus, $timeout, layouts, NotifyService, ModalService,
            fluxo, fluxoOut, acionamentoStatus) {

            $scope.campanhaTemplateRegra = campanhaTemplateRegra;
            $scope.campanhaTemplateRegra.Id = (campanhaTemplateRegra.Id > 0 ? campanhaTemplateRegra.Id :
                (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.campanhaDiscagemStatusOriginal = campanhaDiscagemStatus;
            $scope.campanhaDiscagemStatus = campanhaDiscagemStatus;
            $scope.regraEditada = {};
            $scope.regraTalkBotEditada = {};
            $scope.isNew = campanhaTemplateRegra.Id > 0 ? false : true;
            $scope.forms = {};
            $scope.exitValidationTemplateRegra = true;
            $scope.exitValidationTemplateRegraItens = true;
            $scope.exitValidationCampanha = true;
            $scope.campanhasAdicionadas = [];
            $scope.acoes = [];
            $scope.retornoStatus = _.where(retornoStatus, { PermiteRegra: true });
            $scope.layoutCampanhaEPBX = [];
            $scope.abertoModal = false;
            $scope.abertoTalkBotModal = false;
            $scope.layouts = layouts;
            $scope.editarLayoutModal = true;
            $scope.limitCampanhaNaoAdicionadas = 5;
            $scope.limitCampanhasAdicionadas = 5; 
            $scope.fluxo = fluxo;
            $scope.fluxoOut = fluxoOut;
            $scope.acionamentoStatus = acionamentoStatus;
            $scope.campanhaTemplateRegraItem = []
            $scope.campanhaTemplateRegraTalkBot = []

            $scope.descricoesColunas = {
                CampanhaId: 'campo.codigoDaCampanha',
                Nome: 'telaTemplateRegraEdit.nomeDaCampanha'
            }

            $scope.onDiscagemStatusAlterado = function () {
                if ($scope.regraEditada.CampanhaDiscagemStatusId > 0) {
                    $scope.acoes = _.map(_.find($scope.retornoStatus, function (el) {
                        return el.CampanhaDiscagemStatusId == $scope.regraEditada.CampanhaDiscagemStatusId;
                    }).CampanhaRegraStatusAcao, function (el2) {
                        return el2.CampanhaRegraAcao;
                    });
                } else {
                    $scope.acoes = [];
                    $scope.regraEditada.CampanhaIntegracaoVisualSMSId = null;
                    $scope.regraEditada.CampanhaRegraVisualSMS = null;
                }
                $scope.regraEditada.CampanhaRegraAcaoId = 0;

            }

            $scope.onAcaoAlterado = function () {
                var selecao = $scope.acoes.filter((acao) => {
                    return (acao.CampanhaRegraAcaoId == $scope.regraEditada.CampanhaRegraAcaoId);
                });

                if (selecao.length > 0 && selecao[0].Descricao == "Visual SMS") {
                    CampanhaDiscagemStatusResource.GetCampanhas().$promise
                        .then((data) => {
                            $scope.campanhasVisualSMS = data;
                        });
                } else {
                    $scope.regraEditada.CampanhaIntegracaoVisualSMSId = null;
                    $scope.regraEditada.CampanhaRegraVisualSMS = null;
                }
            }

            $scope.getLayoutCampanhaEPBX = function () {
                $scope.layoutCampanhaEPBX = null;
                var layout = _.find($scope.layouts, (el) => {
                    return el.Id == $scope.regraEditada.CampanhaLayoutId;
                });
                if (layout != null) $scope.layoutCampanhaEPBX = layout.CampanhaLayoutItem;
            }

            $scope.onCampanhaLayout = function () {
                $scope.getLayoutCampanhaEPBX();
            }

            $scope.onCampanhaVisualSMSAlterado = function (abrir) {
                if ($scope.regraEditada.CampanhaIntegracaoVisualSMSId) {
                    CampanhaDiscagemStatusResource.GetLayoutCampanha({ campanhaId: $scope.regraEditada.CampanhaIntegracaoVisualSMSId }).$promise
                        .then((data) => {
                            if (!$scope.abertoModal || abrir) {
                                data.forEach((element) => {
                                    element.CampoLayoutVisualSMS = element.Nome;
                                    element.CampoLayoutEPBX = "";
                                }, this);

                                $scope.regraEditada.CampanhaRegraVisualSMS = {
                                    CampanhaVisualSMSId: $scope.regraEditada.CampanhaIntegracaoVisualSMSId,
                                    CampanhaRegraVisualSMSItems: data
                                };

                                $scope.campanhasVisualSMS = data;
                                $scope.abertoModal = true;
                            }
                        });
                }
            }

            $scope.abrirRegraModal = function () {
                $scope.retornoStatus = _.where(retornoStatus, { PermiteRegra: true });
                $scope.forms.formNovaRegra.$submitted == false;

                $scope.regraEditada = {
                    Prioridade: 2
                };

                if (!$scope.isNew) {
                    $scope.regraEditada.CampanhaId = $scope.campanha ? $scope.campanha.CampanhaId : 0;                   
                } 

                $scope.acoes = [];
                $scope.regraAdicionada = false;

                ModalService.isHidden('modal_regra', () => {
                    $timeout(function () {
                        $scope.forms.formNovaRegra.$setPristine();
                        $scope.forms.formNovaRegra.$setUntouched();
                    });
                })
            }

            $scope.abrirRegraTalkBotModal = function () {               
                $scope.forms.formTemplateRegraTalkBotItens.$submitted == false;

                // if (!$scope.isNew) {
                //     $scope.regraTalkBotEditada.CampanhaId = $scope.campanha ? $scope.campanha.CampanhaId : 0;
                // }

                $scope.regraTalkBotAdicionada = false;

                ModalService.isHidden('modal_regraTalkBot', () => {
                    $timeout(function () {
                        $scope.forms.formNovaRegraTalkBot.$setPristine();
                        $scope.forms.formNovaRegraTalkBot.$setUntouched();
                    });
                })
            }

            $scope.esconderRegraModal = function () {
                ModalService.isActive('modal_regra', () => {
                    $scope.abertoModal = false;
                    $scope.excluirStatus();
                })
            }

            $scope.esconderRegraTalkBotModal = function () {
                ModalService.isActive('modal_regraTalkBot', () => {
                    $scope.abertoTalkBotModal = false;                    
                })
            }

            $scope.editarRegraItem = function (regra, index) {
                var CampanhaRegraAcaoId = regra.CampanhaRegraAcaoId;
                $scope.regraEditada = regra;
                $scope.abertoModal = true;

                var statusAdd = _.find($scope.campanhaDiscagemStatusOriginal, (el) => {
                    return el.CampanhaDiscagemStatusId == regra.CampanhaDiscagemStatusId;
                });

                $scope.campanhaDiscagemStatus.push(statusAdd);

                $scope.onDiscagemStatusAlterado();
                $scope.regraEditada.CampanhaRegraAcaoId = CampanhaRegraAcaoId;

                if (regra.CampanhaRegraVisualSMS) {
                    $scope.onAcaoAlterado();
                    $scope.regraEditada.CampanhaIntegracaoVisualSMSId = regra.CampanhaRegraVisualSMS.CampanhaVisualSMSId
                    $scope.regraEditada.CampanhaRegraVisualSMS = regra.CampanhaRegraVisualSMS;
                    $scope.onCampanhaVisualSMSAlterado(false);
                    $scope.getLayoutCampanhaEPBX();
                }

                $scope.regraAdicionada = true;
                $scope.regraIndex = index;
                ModalService.isHidden('modal_regra', () => {
                    $timeout(function () {
                        $scope.forms.formNovaRegra.$setPristine();
                        $scope.forms.formNovaRegra.$setUntouched();
                    });
                })
            }

            $scope.editarRegratalkBotItem = function (talkbot, index) {                
                $scope.regraTalkBotEditada = talkbot;
                $scope.abertoModal = true;

                $scope.regraTalkBotAdicionada = true;
                $scope.regraTalkBotIndex = index;
                ModalService.isHidden('modal_regraTalkBot', () => {
                    $timeout(function () {
                        $scope.forms.formNovaRegraTalkBot.$setPristine();
                        $scope.forms.formNovaRegraTalkBot.$setUntouched();
                    });
                })
            }

            $scope.removerRegraItem = function (item, index) {
                ModalService.confirmDelete(() => {
                    $scope.campanhaTemplateRegra.Itens[index].Ativo = false;
                    $scope.campanhaTemplateRegraItem = _.where($scope.campanhaTemplateRegra.Itens, { Ativo: true })                
                    $scope.forms.formNovaRegra.$setDirty();
                });
            }

            $scope.removerRegratalkBotItem = function (index) {
                ModalService.confirmDelete(() => {
                    $scope.campanhaTemplateRegra.CampanhaRegraTalkbot[index].Ativo = false;
                    $scope.campanhaTemplateRegraTalkBot = _.where($scope.campanhaTemplateRegra.CampanhaRegraTalkbot, { Ativo: true })
                    $scope.forms.formTemplateRegraTalkBotItens.$setDirty();
                });
            }

            $scope.excluirStatus = function () {
                $scope.campanhaDiscagemStatus = []
                _.each($scope.campanhaDiscagemStatusOriginal, (status) => {
                    var existeStatus = _.findWhere($scope.campanhaTemplateRegra.Itens, { CampanhaDiscagemStatusId: status.CampanhaDiscagemStatusId });
                    if (!existeStatus) {
                        $scope.campanhaDiscagemStatus.push(status)
                    }
                });
            };

            if (!$scope.isNew) {
                $scope.excluirStatus();
                $scope.campanhaTemplateRegraItem = _.where($scope.campanhaTemplateRegra.Itens, { Ativo: true })
                $scope.campanhaTemplateRegraTalkBot = _.where($scope.campanhaTemplateRegra.CampanhaRegraTalkbot, { Ativo: true })
            }



            $scope.adicionarRegra = function (form) {
                if (form.$invalid) {
                    return NotifyService.showInvalid();
                }

                $scope.regraEditada.CampanhaRegraAcaoDescricao = '';
                $scope.regraEditada.CampanhaDiscagemStatusDescricao = '';
                $scope.regraEditada.Ativo = true;

                if ($scope.regraEditada.CampanhaRegraAcaoId) {
                    var acao = _.find($scope.acoes, function (el) {
                        return el.CampanhaRegraAcaoId == $scope.regraEditada.CampanhaRegraAcaoId;
                    });
                    $scope.regraEditada.CampanhaRegraAcaoDescricao = acao.Descricao;
                } else {
                    $scope.regraEditada.CampanhaRegraAcaoId = null;
                }

                var status = _.find($scope.retornoStatus, function (el) {
                    return el.CampanhaDiscagemStatusId == $scope.regraEditada.CampanhaDiscagemStatusId;
                });
                $scope.regraEditada.CampanhaDiscagemStatusDescricao = status.Descricao;

                if (!$scope.campanhaTemplateRegra.Itens) $scope.campanhaTemplateRegra.Itens = [];

                if ($scope.regraAdicionada == false) {
                    $scope.campanhaTemplateRegra.Itens.push($scope.regraEditada);

                    $scope.excluirStatus();

                } else {
                    if ($scope.regraIndex != null) {
                        $scope.campanhaTemplateRegra.Itens[$scope.regraIndex] = $scope.regraEditada;
                        $scope.campanhaDiscagemStatus = []

                        _.each($scope.campanhaDiscagemStatusOriginal, function (status) {
                            var existeStatus = _.findWhere($scope.campanhaTemplateRegra.Itens, {
                                CampanhaDiscagemStatusId: status.CampanhaDiscagemStatusId
                            });

                            if (!existeStatus) {
                                $scope.campanhaDiscagemStatus.push(status)
                            }
                        });
                    }
                }

                $scope.campanhaTemplateRegraItem = _.where($scope.campanhaTemplateRegra.Itens, { Ativo: true })                
                $scope.regraIndex = null;
                $scope.regraEditada = {};
                $scope.esconderRegraModal();
                $scope.forms.formTemplateRegraItens.$setDirty();
            }

            $scope.adicionarRegraTalkBot = function (form) {
                if (form.$invalid) {
                    return NotifyService.showInvalid();
                }

                $scope.regraTalkBotEditada.Ativo = true;               

                var fluxo = _.find($scope.fluxo, function (el) {
                    return el.Id == $scope.regraTalkBotEditada.TalkBotFluxoId;
                });
                $scope.regraTalkBotEditada.FluxoNome = fluxo.Nome;
                
                var fluxoOut = _.where($scope.fluxoOut, function (el) {
                    return el.Id == $scope.regraTalkBotEditada.TalkBotFluxoOutId;   
                });
                $scope.regraTalkBotEditada.FluxoOutNome = fluxoOut.Nome;

                var acionamento = _.where($scope.acionamentoStatus, function (el) {
                    return el.Id == $scope.regraTalkBotEditada.TalkBotAcionamentoId;
                });
                $scope.regraTalkBotEditada.AcionamentoStatusNome = acionamento.Nome;

                if (!$scope.campanhaTemplateRegra.CampanhaRegraTalkbot) $scope.campanhaTemplateRegra.CampanhaRegraTalkbot = [];

                if ($scope.regraTalkBotAdicionada == false) {
                    $scope.campanhaTemplateRegra.CampanhaRegraTalkbot.push($scope.regraTalkBotEditada);
                } else {
                    if ($scope.regraTalkBotIndex != null) {
                        $scope.campanhaTemplateRegra.CampanhaRegraTalkbot[$scope.regraTalkBotIndex] = $scope.regraTalkBotEditada;                       
                    }
                }

                $scope.campanhaTemplateRegraTalkBot = _.where($scope.campanhaTemplateRegra.CampanhaRegraTalkbot, { Ativo: true })
                $scope.regraTalkBotIndex = null;
                $scope.regraTalkBotEditada = {};
                $scope.esconderRegraTalkBotModal();
                $scope.forms.formTemplateRegraTalkBotItens.$setDirty();
            }

            $scope.salvar = function (form) {
                var lastStep = form.$name == "forms.formCampanha" ? true : false;
                var promise;

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                if (lastStep) {
                    var campanhasAtivasString = '';
                    
                    _.each($scope.campanhasAdicionadas, (item) => {
                        item.Ativo = true;
                    });
                    var campanhasAtivas = $scope.campanhasAdicionadas;

                    if (campanhasAtivas.length > 0) {
                        campanhasAtivasString = _.pluck(campanhasAtivas, 'CampanhaId').join(",");
                    }

                    var data = {
                        Id: $scope.campanhaTemplateRegra.Id,
                        Descricao: $scope.campanhaTemplateRegra.Descricao,
                        Itens: $scope.campanhaTemplateRegra.Itens,
                        CampanhasAdicionar: campanhasAtivasString,
                        CampanhaRegraTalkbot : $scope.campanhaTemplateRegra.CampanhaRegraTalkbot
                    };

                    if ($scope.campanhaTemplateRegra.Id > 0) {
                        promise = CampanhaTemplateRegraResource.update(data.Id, data).$promise;
                    }
                    else {
                        promise = CampanhaTemplateRegraResource.save(data).$promise;
                    }

                    promise.then((data) => {
                        $scope.campanhaTemplateRegra = data;
                        NotifyService.showRegistroSalvo();
                        form.$setPristine();
                        $state.go("main.campanhaTemplateRegra.list", {
                            page: 'main.campanhaTemplateRegra.list'
                        });

                    }).catch(NotifyService.showError);
                }
            };

            $scope.valorOptions = {
                decimals: 0,
                format: '#'
            };

            $scope.exitValidationTemplateRegra = function () {
                return $scope.forms.formTemplateRegra.$valid;
            }

            $scope.exitValidationTemplateRegraItens = function () {
                return $scope.forms.formTemplateRegraItens.$valid;
            }

            $scope.exitValidationCampanha = function () {
                return $scope.forms.formCampanha.$valid;
            }

            $scope.exitValidationTemplateRegraTalkBotItens = function () {
                return $scope.forms.formTemplateRegraTalkBotItens.$valid;
            }

            $scope.carregarCampanhas = function () {
                CampanhaTemplateRegraResource.getCampanhaAdicionados({
                    campanhaTemplateRegraId: $scope.campanhaTemplateRegra.Id
                }).$promise
                    .then((data) => {
                        $scope.campanhasAdicionadas = data;
                        _.each($scope.campanhasAdicionadas, (item) => {
                            item.Ativo = true;
                            item.Selecionado = false;
                        });
                    });

                CampanhaTemplateRegraResource.getCampanhaNaoAdicionada({
                    campanhaTemplateRegraId: $scope.campanhaTemplateRegra.Id
                }).$promise
                    .then((data) => {
                        $scope.campanhasNaoAdicionadas = data;
                        _.each($scope.campanhasNaoAdicionadas, (item) => {
                            item.Ativo = false;
                            item.Selecionado = false;
                        });
                    });

            }

            $scope.carregarCampanhas();
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (CampanhaTemplateRegraResource, search, orderBy, $odata) {
        var odata = CampanhaTemplateRegraResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanhaTemplateRegra", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.campanhaTemplateRegra.list',
                        pageTitle: 'pageTitle.templateRegraDiscagem',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.campanhaTemplateRegra.list", StateResolverProvider.configState("/campanhaTemplateRegra", "CampanhaTemplateRegra", "List", {
                    pageTitle: 'pageTitle.templateRegraDiscagem',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("CampanhaTemplateRegraListData", function CampanhaTemplateRegraListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhaTemplareRegras: ["CampanhaTemplateRegraResource", "LocalStorageService", "$odata", "$stateParams", function (CampanhaTemplateRegraResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = {};

                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroCampanhaTemplareRegra");
                        }

                        var orderBy = {
                            column: "Descricao",
                            order: "asc"
                        };

                        return getOdataSearchShared(CampanhaTemplateRegraResource, filtro, orderBy, $odata).page(10, 1).query();
                    }],
                }
            }
        })

        .controller("CampanhaTemplateRegraListController", ["$scope", "$odata", "campanhaTemplareRegras", "CampanhaTemplateRegraResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", function ($scope, $odata, campanhaTemplareRegras, CampanhaTemplateRegraResource, utils, LocalStorageService,
            $stateParams, NotifyService, ModalService) {
            $scope.campanhaTemplareRegras = campanhaTemplareRegras;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroCampanhaTemplareRegra") : {};

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.campanhaTemplareRegras = list;
                $scope.campanhaTemplareRegras.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.campanhaTemplareRegras.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(CampanhaTemplateRegraResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.campanhaTemplareRegras.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroCampanhaTemplareRegra', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroCampanhaTemplareRegra');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteRegra = function (data) {
                return CampanhaTemplateRegraResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRegra(data));
            };

            updateList(campanhaTemplareRegras);
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CampanhaTemplateRegraResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaTemplateRegra/:Id", {
                "Id": "@Id"
            }, {
                    getCampanhaAdicionados: {
                        url: "CampanhaTemplateRegra/CampanhaAdicionadas/:campanhaTemplateRegraId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "campanhaTemplateRegraId": "@campanhaTemplateRegraId"
                        }
                    },
                    getCampanhaNaoAdicionada: {
                        url: "CampanhaTemplateRegra/CampanhaNaoAdicionadas/:campanhaTemplateRegraId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "campanhaTemplateRegraId": "@campanhaTemplateRegraId"
                        }
                    }
                });
        }])
})();
(function () {
    "use strict";  

    angular.module("epbxManagerApp")
       
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

        $stateProvider
            .state("main.campanhaTipo.edit", StateResolverProvider.configState("/campanhaTipo/{Id:[0-9]+}", "CampanhaTipo", "Edit", {
                pageTitle: 'pageTitle.campanhaTipo',
                pageName: 'acoes.editar',
                css: true,
                cssFiles: ['app/pages/campanha/style/regra.css']
            }));
    }])

        .service("CampanhaTipoEditData", function CampanhaTipoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_parsleyjs',
                            'lazy_masked_inputs',
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhaTipo: ["CampanhaTipoResource", "$stateParams", function (CampanhaTipoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return CampanhaTipoResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }]                   
                }
            }
        })

        .controller("CampanhaTipoEditController", ["$state", "$scope", "$odata", "campanhaTipo", "CampanhaTipoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "$translate", function ($state, $scope, $odata, campanhaTipo, CampanhaTipoResource, utils, LocalStorageService, $stateParams, NotifyService, ModalService,  $translate) {

            $scope.campanhaTipo = campanhaTipo;
            $scope.campanhaTipo.Id = (campanhaTipo.Id > 0 ? campanhaTipo.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.inserirOuEditar = campanhaTipo && campanhaTipo.Id ? $translate.instant('telaCampanhaTipoEdit.editarCampanhaTipo') :
                $translate.instant('telaCampanhaTipoEdit.cadastrarCampanhaTipo');
                

                var mensagemSucesso = function (maquina) {
                    NotifyService.showRegistroSalvo();
                    if ($scope.Novo) {
                        $scope.campanhaTipo = {};
                    } else {
                        $scope.campanhaTipo = campanhaTipo;
                    }
                    $state.go("main.campanhaTipo.list", {
                        page: 'main.campanhaTipo.list'
                    });
                };

                $scope.salvar = function (valid) {
                    if (!valid) {
                        return NotifyService.showInvalid();
                    }
    
                    var promise;
    
                    if ($scope.campanhaTipo.Id > 0) {
                        promise = CampanhaTipoResource.update($scope.campanhaTipo).$promise;
                    } else {
                        promise = CampanhaTipoResource.save($scope.campanhaTipo).$promise;
                    }
    
                    promise.then(mensagemSucesso).catch(NotifyService.showError);
                };
    

        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (CampanhaTipoResource, search, orderBy, $odata) {
        var odata = CampanhaTipoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Descricao"), search.Descricao.toLowerCase()), true);
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.campanhaTipo", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.campanhaTipo.list',
                        pageTitle: 'pageTitle.campanhaTipo',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.campanhaTipo.list", StateResolverProvider.configState("/campanhaTipo", "CampanhaTipo", "List", {
                    pageTitle: 'pageTitle.campanhaTipo',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("CampanhaTipoListData", function CampanhaTipoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhaTipos: ["CampanhaTipoResource", "LocalStorageService", "$odata", "$stateParams", function (CampanhaTipoResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = {};

                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroCampanhaTipo");
                        }

                        var orderBy = {
                            column: "Descricao",
                            order: "asc"
                        };

                        return getOdataSearchShared(CampanhaTipoResource, filtro, orderBy, $odata).page(10, 1).query();
                    }],
                }
            }
        })

        .controller("CampanhaTipoListController", ["$scope", "$odata", "campanhaTipos", "CampanhaTipoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", function ($scope, $odata, campanhaTipos, CampanhaTipoResource, utils, LocalStorageService, $stateParams, NotifyService, ModalService) {

            $scope.campanhaTipos = campanhaTipos;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroCampanhaTipo") : {};

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.campanhaTipos = list;
                $scope.campanhaTipos.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.campanhaTipos.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(CampanhaTipoResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.campanhaTipos.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroCampanhaTipo', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroCampanhaTipo');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };
            updateList(campanhaTipos);
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CampanhaTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaTipo/:Id", { "Id": "@Id" });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.carteira.edit", StateResolverProvider.configState("/carteira/{Id:[0-9]+}", "Carteira", "Edit", {
                    pageTitle: 'pageTitle.carteira',
                    pageName: 'acoes.editar',
                }))
                .state("main.carteira.new", StateResolverProvider.configState("/carteira/new", "Carteira", "Edit", {
                    pageTitle: 'pageTitle.carteira',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("CarteiraEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    carteira: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) {
                        if ($stateParams.Id) {
                            return CarteiraResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    grupoNaoAssociado: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetGrupoNaoAssociado({
                            carteiraId: id
                        }).$promise;
                    }],
                    grupoAssociado: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetGrupoAssociado({
                            carteiraId: id
                        }).$promise;
                    }],
                    servicoNaoAssociado: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetServicoNaoAssociado({
                            carteiraId: id
                        }).$promise;
                    }],
                    servicoAssociado: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetServicoAssociado({
                            carteiraId: id
                        }).$promise;
                    }],
                    rotaAssociada: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetRotaAssociada({
                            carteiraId: id
                        }).$promise;
                    }],
                    rotaNaoAssociada: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetRotaNaoAssociada({
                            carteiraId: id
                        }).$promise;
                    }],
                    usuarioAssociado: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetUsuarioAssociado({
                            carteiraId: id
                        }).$promise;
                    }],
                    usuarioNaoAssociado: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetUsuarioNaoAssociado({
                            carteiraId: id
                        }).$promise;
                    }],
                    campanhaAssociada: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetCampanhaAssociada({
                            carteiraId: id
                        }).$promise;
                    }],
                    campanhaNaoAssociada: ["CarteiraResource", "$stateParams", function (CarteiraResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return CarteiraResource.GetCampanhaNaoAssociada({
                            carteiraId: id
                        }).$promise;
                    }]
                };
            };
        })

        .controller("CarteiraEditController", ["$scope", "ModalService", "NotifyService", "CarteiraResource", "$state", "$translate", "carteira", "grupoNaoAssociado", "grupoAssociado", "servicoNaoAssociado", "servicoAssociado", "rotaAssociada", "rotaNaoAssociada", "usuarioAssociado", "usuarioNaoAssociado", "campanhaAssociada", "campanhaNaoAssociada", function ($scope, ModalService, NotifyService,
            CarteiraResource, $state, $translate, carteira, grupoNaoAssociado, grupoAssociado, 
            servicoNaoAssociado, servicoAssociado, rotaAssociada, rotaNaoAssociada, usuarioAssociado, usuarioNaoAssociado,
            campanhaAssociada, campanhaNaoAssociada) {
            $scope.isNew = (carteira.Id > 0 ? false : true);
            $scope.carteira = carteira;            
            $scope.forms = {};
            $scope.grupoNaoAssociado = grupoNaoAssociado;
            $scope.grupoAssociado = grupoAssociado;
            $scope.servicoNaoAssociado = servicoNaoAssociado;
            $scope.servicoAssociado = servicoAssociado;
            $scope.rotaAssociada = rotaAssociada;
            $scope.rotaNaoAssociada = rotaNaoAssociada;
            $scope.usuarioAssociado = usuarioAssociado;
            $scope.usuarioNaoAssociado = usuarioNaoAssociado;
            $scope.campanhaAssociada = campanhaAssociada;
            $scope.campanhaNaoAssociada = campanhaNaoAssociada;
            $scope.proximoStep = false;
            $scope.principalBase = carteira.Principal;


            $scope.descricoesColunasGrupos = {
                GrupoId: 'telaEditCarteira.codigoGrupo',
                Descricao: 'telaEditCarteira.nomeGrupo'
            }

            $scope.descricoesColunasServicos = {
                ServicoId: 'telaEditCarteira.codigoServico',
                Descricao: 'telaEditCarteira.nomeServico'
            }

            $scope.descricoesColunasRotas = {
                RotaId: 'telaEditCarteira.codigoRota',
                Nome: 'telaEditCarteira.nomeRota'
            }

            $scope.descricoesColunasUsuario = {
                UsuarioId: 'telaEditCarteira.codigoUsuario',
                Nome: 'telaEditCarteira.nomeUsuario'
            }

            $scope.descricoesColunasCampanha = {
                CampanhaId: 'telaEditCarteira.codigoCampanha',
                Nome: 'telaEditCarteira.nomeCampanha'
            }

            $scope.adicionar = function () {
                var usuarioSelecionados = _.where($scope.usuarioNaoAssociado, { Selecionado: true });
                angular.forEach(usuarioSelecionados, (value) => {
                    $scope.usuarioNaoAssociado.splice($scope.usuarioNaoAssociado.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Adicionado = true;

                    if (value.Removido && value.Alterado) {
                        value.Removido = false;
                        value.Alterado = false;
                        value.OrdemAlterado = true;
                    } else {
                        value.Alterado = true;
                        value.OrdemAlterado = false;
                    }

                    if ($scope.carteira.FilaLinear) {
                        if ($scope.usuarioAssociado.length > 0) {

                            let ultimaOrdem = Math.max.apply(Math, $scope.usuarioAssociado.map(function (o) { return o.Ordem; }))

                            if (ultimaOrdem) {
                                value.Ordem = ultimaOrdem + 1;
                            } else {
                                value.Ordem = 1;
                            }
                        } else {
                            value.Ordem = 1;
                        }
                    } else {
                        value.Ordem = 0;
                    }


                    $scope.usuarioAssociado.push(value);
                });

                $scope.usuarioAlterado = true;
            };

            $scope.remover = function () {
                var usuarioSelecionados = _.where($scope.usuarioAssociado, {
                    Selecionado: true
                });
                angular.forEach(usuarioSelecionados, (value) => {
                    $scope.usuarioAssociado.splice($scope.usuarioAssociado.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Removido = true;

                    if (value.Adicionado && value.Alterado) {
                        value.Adicionado = false;
                        value.Alterado = false;
                    } else value.Alterado = true;

                    value.OrdemAlterado = false;
                    $scope.usuarioNaoAssociado.push(value);
                });

                $scope.usuarioAlterado = true;
            };

            $scope.selectionarTodosAdicionados = function (selecionado) {
                angular.forEach($scope.usuarioAssociado, (item) => {
                    if (selecionado) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.selectionarTodosNaoAdicionados = function (selecionado) {
                angular.forEach($scope.usuarioNaoAssociado, (item) => {
                    if (selecionado) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.validateCarteira = function () {
                $scope.proximoStep = $scope.forms.formCarteira.$valid ? true : false;
                return $scope.proximoStep;
            };

            $scope.salvar = function (form) {
                var lastStep = form.$name == "forms.formRota" ? true : false;
                var grupostring = _.pluck(_.where($scope.grupoAssociado), 'GrupoId').join(",");
                var servicoString = _.pluck(_.where($scope.servicoAssociado), 'ServicoId').join(",");
                var rotaString = _.pluck(_.where($scope.rotaAssociada), 'RotaId').join(",");
                var usuarioString = _.pluck(_.where($scope.usuarioAssociado), 'UsuarioId').join(",");
                var campanhaString = _.pluck(_.where($scope.campanhaAssociada), 'CampanhaId').join(",");

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }  
                
                var data = {
                    Id: $scope.carteira.Id,
                    Codigo: $scope.carteira.Codigo,                                            
                    Nome: $scope.carteira.Nome,
                    Principal: $scope.carteira.Principal,
                    GrupoIds: grupostring,
                    ServicoIds: servicoString,
                    RotaIds: rotaString,
                    UsuarioIds: usuarioString,
                    CampanhaIds: campanhaString
                };

                if(lastStep) {
                    if(!$scope.principalBase && data.Principal){
                        ModalService.confirmMessage('Tornar esta carteira a principal ?', null, () => {
                            $scope.salvarCarteira(data);
                        });
                    }else{
                        $scope.salvarCarteira(data);
                    }
                }
            };

            $scope.salvarCarteira = function (data) {
                var promise;
                if ($scope.carteira.Id > 0) {
                    promise = CarteiraResource.update(data.Id, data).$promise;
                }
                else {
                    promise = CarteiraResource.save(data).$promise;
                }

                promise.then(() => {
                    let message = $scope.isNew ? 'telaEditCarteira.carteiraAdicionadoComSucesso' : 'telaEditCarteira.carteiraAlteradoComSucesso';

                    NotifyService.showSuccess($translate.instant(message));
                    $state.go('main.carteira.list');
                })
                .catch(NotifyService.showError);
            };
        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (CarteiraResource, search, orderBy, $odata) {
        var odata = CarteiraResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }
        
        if (search.Codigo) {
            odata.filter(new $odata.Func("startswith", "Codigo", search.Codigo), true);
        }

        if (search.Principal) {            
            odata.filter('Principal', search.Principal);
        }
        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.carteira", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.carteira.list',
                    pageTitle: 'pageTitle.cardTitle',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.carteira.list", StateResolverProvider.configState("/carteira", "Carteira", "List", {
                pageTitle: 'pageTitle.carteira',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("CarteiraListData", function CarteiraListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                carteiras: ["CarteiraResource", "LocalStorageService", "$odata", "$stateParams", function (CarteiraResource, LocalStorageService, $odata, $stateParams) {
                     var filtro = {};

                     if ($stateParams.storage) {
                         filtro = LocalStorageService.getItem("FiltroCarteira");
                     }

                     var orderBy = {
                         column: "Nome",
                         order: "asc"
                     };

                     return getOdataSearchShared(CarteiraResource, filtro, orderBy, $odata).page(10, 1).query();
                 }],
            }
        }
    })

    .controller("CarteiraListController", ["$scope", "$odata", "CarteiraResource", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "carteiras", function ($scope, $odata, CarteiraResource, LocalStorageService,
        $stateParams, NotifyService, ModalService, carteiras) {
            $scope.carteiras = carteiras;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroCarteira") : {
                Nome: '',
                Codigo: '',
                Principal: false
            };

            $scope.orderBy = {
                column: "Principal",
                order: "desc"
            };

            $scope.errorObject = {};

            var updateList = function (list) {
                $scope.carteiras = list;
                $scope.carteiras.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.carteiras.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(CarteiraResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.carteiras.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroCarteira', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroCarteira');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteCarteira = function (data) {
                return CarteiraResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmMessage('telaCarteira.confirmDeleteCarteira', null, () => deleteCarteira(data));
            };

            $scope.exibirErro = function (data){
                $scope.errorObject = data.ErrorObject;
                ModalService.openModal('modalErrorMessage');
            }

            $scope.executeSearch();

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CarteiraResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Carteira/:Id", { "Id": "@Id" },
                {
                    GetGrupoNaoAssociado: {
                        url: "Carteira/GrupoNaoAssociado",
                        method: "GET",
                        isArray: true
                    },
                    GetGrupoAssociado: {
                        url: "Carteira/GrupoAssociado",
                        method: "GET",
                        isArray: true
                    },
                    GetServicoNaoAssociado: {
                        url: "Carteira/ServicoNaoAssociado",
                        method: "GET",
                        isArray: true
                    },
                    GetServicoAssociado: {
                        url: "Carteira/ServicoAssociado",
                        method: "GET",
                        isArray: true
                    },
                    GetRotaAssociada: {
                        url: "Carteira/RotaAssociada",
                        method: "GET",
                        isArray: true
                    },
                    GetRotaNaoAssociada: {
                        url: "Carteira/RotaNaoAssociada",
                        method: "GET",
                        isArray: true
                    },
                    GetUsuarioAssociado: {
                        url: "Carteira/UsuarioAssociado",
                        method: "GET",
                        isArray: true
                    },
                    GetUsuarioNaoAssociado: {
                        url: "Carteira/UsuarioNaoAssociado",
                        method: "GET",
                        isArray: true
                    },
                    GetCarteirasPorUsuario: {
                        url: "Carteira/CarteiraPorUsuario",
                        method: "GET",
                        params: {
                            "usuarioId": "@usuarioId"
                        },
                        isArray: true
                    },
                    GetCampanhaNaoAssociada: {
                        url: "Carteira/CampanhaNaoAssociada",
                        method: "GET",
                        isArray: true
                    },
                    GetCampanhaAssociada: {
                        url: "Carteira/CampanhaAssociada",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();
(function () {
	"use strict";

	var getOdataSearchSharedPlanum = function (PlanumHistoricoResource, orderBy) {
        var odata = PlanumHistoricoResource.odata();
        if (orderBy) {
            odata.orderBy(orderBy.column, orderBy.order);
        }
        return odata;
    };

    var getOdataSearchSharedPortabilidade = function (PortabilidadeHistoricoResource, orderBy) {
        var odata = PortabilidadeHistoricoResource.odata();
        if (orderBy) {
            odata.orderBy(orderBy.column, orderBy.order);
        }
        return odata;
    };

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.cliente", StateResolverProvider.configAbstract())
				.state("main.cliente.list", StateResolverProvider.configState("/cliente", "Cliente", "List", {
					pageTitle: 'pageTitle.cadastroDeCliente',
                    pageName: 'step.detalhes',
                    css: true,
                    cssFiles: ['app/pages/cliente/style/list.css']
				}))
		}])
		.service('ClienteListData', function () {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_wizard'
						]);
					}],
					cliente: ["ClienteResource", function (ClienteResource) {
						return ClienteResource.get({
							ClienteId: 1
						}).$promise;
					}],
					grupos: ["GrupoResource", function (GrupoResource) {
						var odata = GrupoResource.odata().orderBy('Descricao', 'asc');
						odata.filter("GrupoTipoId", "!=", 2);
						return odata.query();
					}],
					produtoList: ["ProdutoResource", function (ProdutoResource) {
                        return ProdutoResource.query().$promise;
                    }],
                    planumHistorico: ["PlanumHistoricoResource", "$odata", function (PlanumHistoricoResource, $odata) {
                        var orderBy = {
                            column: "DataInicial",
                            order: "desc"
                        };

                        var odata = getOdataSearchSharedPlanum(PlanumHistoricoResource, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }],
                    portabilidadeHistorico: ["PortabilidadeHistoricoResource", "$odata", function (PortabilidadeHistoricoResource, $odata) {

                        var orderBy = {
                            column: "DataInicial",
                            order: "desc"
                        };

                        var odata = getOdataSearchSharedPortabilidade(PortabilidadeHistoricoResource, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }],
                    chatCanalList: ["ChatCanalResource", function (ChatCanalResource) {
                        return ChatCanalResource.getChatCanal().$promise;
                    }],
				}
			}
		})
		.controller("ClienteListController", ["$scope", "cliente", "ClienteResource", "NotifyService", "$translate", "grupos", "WizardHandler", "produtoList", "planumHistorico", "portabilidadeHistorico", "PlanumHistoricoResource", "PortabilidadeHistoricoResource", "$odata", "ModalService", "chatCanalList", "ChatCanalResource", function ($scope, cliente, ClienteResource, NotifyService, $translate, grupos, WizardHandler, produtoList, planumHistorico, portabilidadeHistorico,
			PlanumHistoricoResource, PortabilidadeHistoricoResource, $odata, ModalService, chatCanalList, ChatCanalResource ) {
			$scope.forms = {};
			$scope.isChaveAcesso = cliente.Token ? true : false;
			$scope.isNovo = !(cliente && cliente.ClienteId);
			$scope.cliente = cliente;
			$scope.inserirOuEditar = cliente && cliente.ClienteId ? $translate.instant('telaCadastroCliente.dadosDoCliente') : $translate.instant('telaCadastroCliente.cadastrarCliente');
		
			grupos.forEach((el) => {
				if (el.Ramal != null) {
					el.Numero = el.Ramal.Numero;
				}
			});

			$scope.grupos = grupos;

            $scope.grupos.forEach(function (grupo) {
                grupo.GrupoFormatado = grupo.RamalNumero + " - " + grupo.Descricao;
            });

			// Inicializar dados de chat canal
			$scope.chatCanalList = (chatCanalList || []).filter(function(canal) {
				return canal.Ativo === true;
			});
			$scope.cliente.Chats = $scope.cliente.Chats || [];
			$scope.novoCanal = {};


			// Funções para gerenciar canais de chat
			$scope.adicionarCanal = function() {
				if ($scope.novoCanal.Descricao && $scope.novoCanal.Descricao.trim() && $scope.novoCanal.Telefone && $scope.novoCanal.Telefone.trim()) {
					var canal = {
						Descricao: $scope.novoCanal.Descricao.trim(),
						Telefone: $scope.novoCanal.Telefone.trim(),
						Ativo: true,
						IntegradoDeltaChat: false,
						Pendente: true,
						Id: 0
					};
					$scope.chatCanalList.push(canal);
					$scope.cliente.Chats.push(canal);
					$scope.novoCanal = {};
				}
			};

			$scope.removerCanal = function(index) {
				var canal = $scope.chatCanalList[index];
				
				if (canal.Pendente) {
					// Canal pendente: remove diretamente da lista
					$scope.chatCanalList.splice(index, 1);
					$scope.cliente.Chats.splice(index, 1);
				} else {
					// Canal existente: confirma antes de marcar como inativo
					ModalService.confirmMessage('telaCadastroCliente.confirmarRemocaoCanal', null, function() {
						canal.Ativo = false;
						// Chamar o backend para atualizar
						ChatCanalResource.atualizarCanalChat({ id: canal.Id }, canal).$promise
							.then(function() {
								// Remover da lista após sucesso
								$scope.chatCanalList.splice(index, 1);
								NotifyService.showSuccess($translate.instant('telaCadastroCliente.canalRemovido'));
							})
							.catch(function() {
								// Reverter o estado se houver erro
								canal.Ativo = true;
								NotifyService.showError($translate.instant('telaCadastroCliente.erroRemoverCanal'));
							});
					});
				}
			};

			$scope.toggleCanalAtivo = function(canal) {
				canal.Ativo = !canal.Ativo;
			};

			$scope.integrarCanal = function(canal) {
				ChatCanalResource.atualizarCanalChatIntegracao({ chatCanalId: canal.Id }).$promise
					.then(function() {
						NotifyService.showSuccess($translate.instant('telaCadastroCliente.integracaoIniciada'));
					})
					.catch(NotifyService.showError);
			};

			$scope.atualizarCanais = function() {
				ChatCanalResource.getChatCanal().$promise
					.then(function(canais) {
						// Filtrar apenas canais ativos
						$scope.chatCanalList = canais.filter(function(canal) {
							return canal.Ativo === true;
						});
						NotifyService.showSuccess($translate.instant('telaCadastroCliente.canaisAtualizados'));
					})
					.catch(NotifyService.showError);
			};

			var mensagemSucesso = function (cliente) {
				NotifyService.showRegistroSalvo();

				$scope.cliente = cliente;
				$scope.isChaveAcesso = cliente.Token ? true : false;
			};

			$scope.salvar = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}

				let data = $scope.cliente;

				if (data.Cnpj && typeof data.Cnpj === 'string') {
					data.Cnpj = data.Cnpj.replace(".", "").replace(".", "").replace("/", "").replace("-", "");
				}

				if(!data.LGPD)
					data.QuantidadeDias = null;

				// Enviar apenas canais novos (pendentes) - não enviar canais já existentes
				data.Chats = ($scope.chatCanalList || []).filter(function(canal) {
					// Enviar apenas canais pendentes (novos)
					return canal.Pendente;
				}).map(function(canal) {
					return {
						Id: canal.Id,
						Descricao: canal.Descricao,
						Telefone: canal.Telefone,
						Ativo: canal.Ativo,
						IntegradoDeltaChat: canal.IntegradoDeltaChat,
						CanalIntegracao: canal.CanalIntegracao || null
					};
				});

				ClienteResource.update(data).$promise.then(r => {
					valid.$setPristine();
					mensagemSucesso(r);
				}).catch(NotifyService.showError);
			};

			$scope.salvarChaveAcesso = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}

				ClienteResource.update({
					ClienteId: $scope.cliente.ClienteId,
					RazaoSocial: $scope.cliente.RazaoSocial,
					NomeFantasia: $scope.cliente.NomeFantasia,
					CodigoIntegracao: $scope.cliente.CodigoIntegracao,
					Cnpj: $scope.cliente.Cnpj,
					StatusId: $scope.cliente.StatusId,
					Token: $scope.cliente.Token,
					ValidaChaveAcesso: true
				}).$promise.then(r => {
					mensagemSucesso(r);
					WizardHandler.wizard().next();
				}).catch(NotifyService.showError);
			};

			$scope.validarAd = function () {
				if (!$scope.cliente.DomainActiveDirectory || !$scope.cliente.UserActiveDirectory || !$scope.cliente.PasswordActiveDirectory) {
					return NotifyService.showInvalid();
				}

				ClienteResource.validarActiveDirectory({
					Domain: $scope.cliente.DomainActiveDirectory,
					User: $scope.cliente.UserActiveDirectory,
					Password: $scope.cliente.PasswordActiveDirectory
				}).$promise.then(r => {
					var botao = document.getElementById('validar-ad');
					if (r.IsValid) {
						NotifyService.showSuccess('Usuário autenticado com sucesso!');
						botao.classList.remove('md-btn-warning', 'md-btn-danger')
						botao.classList.add('md-btn-success')
					} else {
						NotifyService.showError(null, 'Usuário não autenticado. Revise os dados.');
						botao.classList.remove('md-btn-warning', 'md-btn-success')
						botao.classList.add('md-btn-danger')
					}
				}).catch(NotifyService.showError)
			}

			$scope.changeLGPD = function()
			{
				if($scope.cliente.LGPD && $scope.cliente.QuantidadeDias == null)
				{
					$scope.cliente.QuantidadeDias = 180;
				}
			}

			$scope.produtoList = produtoList;
            $scope.planumHistorico = planumHistorico;
            $scope.portabilidadeHistorico = portabilidadeHistorico;
            $scope.produtoId = $scope.produtoList[0].ProdutoId;
            $scope.orderBy = {
                column: "DataInicial",
                order: "desc"
            };
            
            var updateListPlanum = function (list) {
                $scope.planumHistorico = list;
                $scope.planumHistorico.recordCount = list.$recordCount || list.length;
                $scope.planumHistorico.currentPage = list.$currentPage || 1;
                $scope.planumHistorico.pageSize = list.$pageSize || 10;                
            };

            var updateListPortabilodade = function (list) {
                $scope.portabilidadeHistorico = list;
                $scope.portabilidadeHistorico.recordCount = list.$recordCount || list.length;
                $scope.portabilidadeHistorico.currentPage = list.$currentPage || 1;
                $scope.portabilidadeHistorico.pageSize = list.$pageSize || 10;
            };            

            var getOdataSearchPlanum = function getOdataSearch() {
                return getOdataSearchSharedPlanum(PlanumHistoricoResource, $scope.orderBy, $odata);
            };

            var getOdataSearchPortabilidade = function getOdataSearch() {
                return getOdataSearchSharedPortabilidade(PortabilidadeHistoricoResource, $scope.orderBy, $odata);
            };

            $scope.pageChangedPlanum = function (newPage) {
                return getOdataSearchPlanum()
                    .page($scope.planumHistorico.pageSize, newPage)
                    .query().then(updateListPlanum).catch(NotifyService.showError);
            };

            $scope.pageChangedPortabilidade = function (newPage) {
                return getOdataSearchPortabilidade()
                    .page($scope.portabilidadeHistorico.pageSize, newPage)
                    .query().then(updateListPortabilodade).catch(NotifyService.showError);
            };

            $scope.changeTab = function (produto) {
                $scope.produtoId = produto.ProdutoId;
            }

            updateListPlanum(planumHistorico);
            updateListPortabilodade(portabilidadeHistorico);

			$scope.exibirDetalhe = function (descricao) {
				ModalService.alert("<h3>Detalhe</h3>" + descricao);
			};
		}]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ClienteResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Cliente/:ClienteId", { "ClienteId": "@ClienteId" }, {
                validarActiveDirectory: {
                    url: "Cliente/ValidarActiveDirectory",
                    method: "POST"
                }
            });
        }])
        .factory("ProdutoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "Produto/:ProdutoId", {
                    "ProdutoId": "@ProdutoId"
                });
        }])
        .factory("PlanumHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "PlanumHistorico/:PlanumHistoricoId", {
                    "PlanumHistoricoId": "@PlanumHistoricoId"
                });
        }])
        .factory("PortabilidadeHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "PortabilidadeHistorico/:PortabilidadeHistoricoId", {
                    "PortabilidadeHistoricoId": "@PortabilidadeHistoricoId"
                });
        }])
        .factory("ChatCanalResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "ChatCanal/:ChatCanalId", {
                    "ChatCanalId": "@ChatCanalId"
                }, {
                    getChatCanal: {
                        url: "Cliente/GetChatCanal",
                        method: "GET",
                        isArray: true
                    },
                    atualizarCanalChatIntegracao: {
                        url: "Cliente/AtualizarCanalChatIntegracao",
                        method: "GET"
                    },
                    atualizarCanalChat: {
                        url: "Cliente/AtualizarCanalChat/:id",
                        method: "PUT"
                    }
                });
        }]) 

})();
(function () {
    "use strict";

    var getOdataSearchShared = function (ConfiguracaoResource, search, orderBy, $odata) {
        var odata = ConfiguracaoResource.odata().filter('Editavel', true);
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Chave) {
            odata.filter(new $odata.Func("startswith", "Chave", search.Chave), true);
        }
        if (search.Valor) {
            odata.filter("Valor", search.Valor);
        }
        if (search.Contextos) {
            odata.filter("Contexto", search.Contextos);
        }

        return odata;
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.configuracao", StateResolverProvider.configAbstract())
                .state("main.configuracao.list", StateResolverProvider.configState("/configuracao", "Configuracao", "List", {
                    pageTitle: 'step.configuracoes',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service('ConfiguracaoListData', function ConfiguracaoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    configuracoes: ["ConfiguracaoResource", "$stateParams", "$odata", "utils", "LocalStorageService", function (ConfiguracaoResource, $stateParams, $odata, utils, LocalStorageService) {
                        var filtro = {};
                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroConfiguracao");

                        var orderBy = {
                            column: "Chave",
                            order: "asc"
                        };
                        var odata = getOdataSearchShared(ConfiguracaoResource, filtro, orderBy, $odata, utils);
                        return odata.query();
                    }]
                }
            }
        })

        .controller("ConfiguracaoListController", ["$scope", "$state", "configuracoes", "ConfiguracaoResource", "$odata", "LocalStorageService", "utils", "SistemaValidacaoResource", "NotifyService", "ModalService", function ($scope, $state, configuracoes, ConfiguracaoResource, $odata, LocalStorageService, utils,
            SistemaValidacaoResource, NotifyService, ModalService) {
            $scope.forms = {};
            $scope.checkSetup = $scope.$root.$location.search().setup;
            $scope.contextos = [];

            $scope.orderBy = {
                column: "Chave",
                order: "asc"
            };

            $scope.search = {
                Contextos: 'DEFAULT'
            };

            SistemaValidacaoResource.getConfiguracao().$promise
                .then((data) => {
                    if (data.StatusId == 0) {
                        $scope.checkSetup = 'true';
                    }
                });

            // criar uma lista de contextos para o campo de filtro
            // TODO: buscar de um webservice

            var uniqsContextos = _.uniq(configuracoes, false, (el) => {
                return el.Contexto;
            });
            angular.forEach(uniqsContextos, (value) => {
                $scope.contextos.push({
                    id: value.Contexto,
                    descricao: value.Contexto
                });
            });

            var updateList = function (list) {
                $scope.configuracoes = list;
                $scope.configuracoes.forEach((el) => {
                    el.ValorInicial = el.Valor;
                });
                $scope.searching = false;
            }

            var getOdataSearch = function () {
                return getOdataSearchShared(ConfiguracaoResource, $scope.search, $scope.orderBy, $odata, utils);
            }

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroConfiguracao', $scope.search);
                getOdataSearch().query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            }

            $scope.confirmDelete = function (configuracao) {
                ModalService.confirmDelete(function () {
                    ConfiguracaoResource.delete(configuracao).$promise
                        .then(function () {
                            $scope.pageChanged()
                        }).catch(NotifyService.showError);
                });
            }

            $scope.pageChanged = function () {
                return getOdataSearch().query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.executeSearch();

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroConfiguracao');
                $scope.search = {};
                $scope.executeSearch();
            };

            $scope.salvarTodos = function (valid) {
                var promise;

                if (!valid) {
                    return NotifyService.showError();
                }

                var configAlterada = _.filter($scope.configuracoes, function (el) {
                    return el.Valor != el.ValorInicial;
                });

                if ((configAlterada && configAlterada.length > 0) || $scope.checkSetup) {
                    promise = ConfiguracaoResource.atualizatLote(configAlterada).$promise;
                }

                if ($scope.checkSetup) {
                    promise.then(() => {
                        $state.go('setup.view');
                    }).catch(NotifyService.showError);
                } else {
                    promise.then(() => {
                        updateList($scope.configuracoes);
                        $scope.forms.formConf.$setPristine();
                        NotifyService.showSuccess();
                        $scope.configuracao = {};
                    }).catch(NotifyService.showError);
                }
            };
        }]);
    })
();
(function () {
    "use strict";

    var _promise = null;
    var _timeout = null;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.configuracaomp3.new", StateResolverProvider.configState("/configuracaoMp3/new", "ConfiguracaoMp3", "Edit", {
                    pageTitle: 'pageTitle.configuracaoMp3', 
                    pageName: 'acoes.cadastrar' }))
                .state("main.configuracaomp3.edit", StateResolverProvider.configState("/configuracaoMp3/{ConfiguracaoId:[0-9]+}", "ConfiguracaoMp3", "Edit", {
                    pageTitle: 'pageTitle.configuracaoMp3', 
                    pageName: 'acoes.editar' }))
        }])

        .service("ConfiguracaoMp3EditData", function () {
            return function () {
                return {
                    tipos: ["ConfiguracaoMp3TipoResource", function (ConfiguracaoMp3TipoResource) {
                        return ConfiguracaoMp3TipoResource.getAll().$promise;
                    }],
                    registro: ["$stateParams", "ConfiguracaoMp3Resource", function ($stateParams, ConfiguracaoMp3Resource) {
                        if ($stateParams.ConfiguracaoId) {
                            return ConfiguracaoMp3Resource.get({ ConfiguracaoId: $stateParams.ConfiguracaoId }).$promise;
                        } else {
                            return { TipoId: 1, Padrao: 0 };
                        }
                    }]
                }
            }
        })

        .controller("ConfiguracaoMp3EditController", ["$scope", "$state", "$http", "$q", "tipos", "registro", "ConfiguracaoMp3Resource", "Config", "NotifyService", function ($scope, $state, $http, $q, tipos, registro, ConfiguracaoMp3Resource, Config, NotifyService) {
            $scope.debounceOptions = { debounce: 1000 }
            $scope.tipos = tipos;
            $scope.registro = registro || { TipoId: 1 };
            $scope.pathExpression = null;
            $scope.isNew = registro.ConfiguracaoId > 0 ? false : true;

            $scope.regex = [
                { tipo: 'LOCAL', expression: /^([a-zA-Z]{1}:\\|\\)([a-zA-Z0-9\W]*\\)+$/ig },
                { tipo: 'REMOTO', expression: /^(\\{2})((\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3})|([a-zA-Z0-9]+))\\([a-zA-Z0-9+-_.$\s]+\\)$/ig }
            ];

            $scope.estrutura = [
                {nome : 'Default CTI', valor: "@numero/dialogos"},
                {nome : 'Ano/Mes/Dia', valor: "@Ano/Mes/dia/@numero"},
                {nome : 'AnoMesDia', valor: "@AnoMesdia/@numero"},
                {nome : 'Ano/Mes', valor: "@Ano/Mes/@numero"}
            ]

            $scope.onInit = function () {
                try {
                    var caminho = $scope.formConfiguracaoMp3.Caminho;
                    if (!$scope.validarCaminho(caminho)) {
                        caminho.$setDirty();
                        caminho.$validate();
                    }

                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.isRemoto = function () {
                return $scope.registro.TipoId === 2;
            }

            $scope.onChangeTipo = function () {
                try {
                    var caminho = $scope.formConfiguracaoMp3.Caminho;
                    $scope.validarCaminho(caminho);
                    caminho.$setDirty();
                    caminho.$validate();

                } catch (ex) { 
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.onChangeServerInfo = function () {
                try {

                    if (_timeout != null)
                        clearTimeout(_timeout);

                    if (_promise != null)
                        $scope.abortPromise(_promise);

                    // Oculta o "Alerta" de Caminho válido
                    $scope.registro.IsCaminhoValido = true; //null;

                    var caminho = $scope.formConfiguracaoMp3.Caminho;
                    var isValid = $scope.validarCaminho(caminho);
                    if (!isValid) {
                        return;
                    }

                    // Valida se Todas Informações do Servidor foram Preenchidas
                    if ($scope.registro.TipoId == 2 && (!$scope.registro.Caminho || !$scope.registro.Usuario || !$scope.registro.Senha)) {
                        return;
                    }

                    _timeout = setTimeout(function () {
                        // Valida se o Path existe no Servidor
                        _promise = $scope.validarDiretorio(caminho.$viewValue);
                        if (_promise) {
                            _promise
                                .then(function (response) {
                                    $scope.registro.IsCaminhoValido = response.CaminhoValido;
                                })
                                .catch(function (response) {
                                    NotifyService.showError(response, "Caminho inválido")
                                    $scope.registro.IsCaminhoValido = false;
                                });
                        }

                    }, 500);

                } catch (ex) { 
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.obterRegex = function () {
                try {
                    var tipo = _.first(_.where($scope.tipos, { ConfiguracaoTipoId: $scope.registro.TipoId }));
                    if (tipo) {
                        return _.first(_.where($scope.regex, { tipo: tipo.Descricao.toUpperCase() })).expression;
                    }
                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.validarCaminho = function (element) {
                try {
                    var value = element.$viewValue;
                    if (value) {
                        var regex = new RegExp($scope.obterRegex());
                        var isValid = value ? regex.test(value) : true;
                        element.$setValidity('pattern', isValid);
                        return isValid && (value || value.length > 0);
                    }
                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.validarDiretorio = function () {
                var httpTimeout = $q.defer();
                $scope.registro.IsCaminhoValido = true;
                var request = $http({
                    method: 'POST',
                    url: Config.getUrl("ConfiguracaoMp3/ValidarDiretorio"),
                    data: $scope.registro,
                    timeout: httpTimeout.promise
                });

                var promise = request.then(function (response) { return response.data; });
                promise._httpTimeout = httpTimeout;
                return (promise);
            }

            $scope.onUpdate = function () {
                var promise;
                if ($scope.registro.ConfiguracaoId > 0) {
                    promise = ConfiguracaoMp3Resource.update($scope.registro).$promise;
                }
                else {
                    promise = ConfiguracaoMp3Resource.save($scope.registro).$promise;
                }
                return promise.then(function () {
                    $scope.formConfiguracaoMp3.$setPristine();
                    NotifyService.showSuccess('telaEditConfiguracao.configuracaoSalvaComSucesso');
                    $state.go('main.configuracaomp3.list')
                })
                .catch(function (response) {
                    $scope.showError(response, 'telaEditConfiguracao.naoFoiPossivelSalvarConfiguracao');
                });
            }

            $scope.abortPromise = function (promise) {
                if (promise && promise._httpTimeout && promise._httpTimeout.resolve) {
                    promise._httpTimeout.resolve();
                }
            }

            setTimeout(function () {
                $scope.onInit();
            }, 400);

        }]);

})();
(function () {
    "use strict";

    var _promise = null;
    var _timeout = null;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.configuracaomp3", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.configuracaomp3.list',
                        pageTitle: 'pageTitle.configuracaoMp3',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.configuracaomp3.list", StateResolverProvider.configState("/configuracaoMp3", "ConfiguracaoMp3", "List", {
                    pageTitle: 'pageTitle.configuracaoMp3',
                    pageName: 'step.detalhes',
                    css: true
                }));
        }])

        .service("ConfiguracaoMp3ListData", function () {
            return function () {
                return {
                    tipos: ["ConfiguracaoMp3TipoResource", function (ConfiguracaoMp3TipoResource) {
                        return ConfiguracaoMp3TipoResource.getAll().$promise;
                    }],
                    configuracoes: ["ConfiguracaoMp3Resource", function (ConfiguracaoMp3Resource) {
                        return ConfiguracaoMp3Resource.odata().orderBy('Caminho').query();
                    }],
                    copiaConfiguracoes: ["CopiaMp3ConfiguracaoResource", function (CopiaMp3ConfiguracaoResource) {
                        return CopiaMp3ConfiguracaoResource.odata().query();
                    }],
                    destinos: ["ConfiguracaoMp3Resource", function (ConfiguracaoMp3Resource) {
                        return ConfiguracaoMp3Resource.odata().orderBy('Caminho').query();
                    }]
                }
            }
        })

        .controller("ConfiguracaoMp3ListController", ["$scope", "$http", "$q", "tipos", "configuracoes", "copiaConfiguracoes", "CopiaMp3ConfiguracaoResource", "ConfiguracaoMp3Resource", "Config", "NotifyService", "ModalService", "destinos", function ($scope, $http, $q, tipos, configuracoes, copiaConfiguracoes, CopiaMp3ConfiguracaoResource,
            ConfiguracaoMp3Resource, Config, NotifyService, ModalService, destinos) {
            $scope.debounceOptions = { debounce: 1000 }
            $scope.list = configuracoes;
            $scope.listCopiaArquivos = copiaConfiguracoes;
            $scope.tipos = tipos;
            $scope.configuracoes = configuracoes || { TipoId: 1 };
            $scope.pathExpression = null;
            $scope.search = {};
            $scope.listCopiaArquivosHistorico = [];
            $scope.primeiraAba = true;
            $scope.registro = [];
            $scope.destinos = destinos;

            $scope.regex = [
                { tipo: 'LOCAL', expression: /^([a-zA-Z]{1}:\\|\\)([a-zA-Z0-9\W]*\\)+$/ig },
                { tipo: 'REMOTO', expression: /^(\\{2})((\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3})|([a-zA-Z0-9]+))\\([a-zA-Z0-9+-_.$\s]+\\)$/ig }
            ];

            _.forEach(copiaConfiguracoes, (item) => {
                item.ConfiguracaoMp3 = _.find(configuracoes, (c) => { return c.ConfiguracaoId === item.ConfiguracaoMp3Id })
            });

            $scope.onInit = function () {
                try {
                    var caminho = $scope.formConfiguracaoMp3.Caminho;
                    if (!$scope.validarCaminho(caminho)) {
                        caminho.$setDirty();
                        caminho.$validate();
                    }
                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.isRemoto = function () {
                return $scope.configuracoes.TipoId === 2;
            }

            $scope.onChangeTipo = function () {
                try {
                    var caminho = $scope.formConfiguracaoMp3.Caminho;
                    $scope.validarCaminho(caminho);
                    caminho.$setDirty();
                    caminho.$validate();
                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.onChangeServerInfo = function () {
                try {
                    if (_timeout != null)
                        clearTimeout(_timeout);
                    if (_promise != null)
                        $scope.abortPromise(_promise);
                    // Oculta o "Alerta" de Caminho válido
                    $scope.configuracoes.IsCaminhoValido = true; //null;
                    var caminho = $scope.formConfiguracaoMp3.Caminho;
                    var isValid = $scope.validarCaminho(caminho);
                    if (!isValid) {
                        return;
                    }
                    // Valida se Todas Informações do Servidor foram Preenchidas
                    if ($scope.configuracoes.TipoId == 2 && (!$scope.configuracoes.Caminho || !$scope.configuracoes.Usuario || !$scope.configuracoes.Senha))
                        return;
                    _timeout = setTimeout(function () {
                        // Valida se o Path existe no Servidor
                        _promise = $scope.validarDiretorio(caminho.$viewValue);
                        if (_promise) {
                            _promise
                                .then((response) => {
                                    $scope.configuracoes.IsCaminhoValido = response.CaminhoValido;
                                }).catch((response) => {
                                    NotifyService.showError(response, 'telaConfiguracaoMp3.caminhoInvalido')
                                    $scope.configuracoes.IsCaminhoValido = false;
                                });
                        }
                    }, 500);

                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.obterRegex = function () {
                try {
                    var tipo = _.first(_.where($scope.tipos, { ConfiguracaoTipoId: configuracoes.TipoId }));
                    if (tipo) {
                        return _.first(_.where($scope.regex, { tipo: tipo.Descricao.toUpperCase() })).expression;
                    }
                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro: " + ex)
                }
            }

            $scope.validarCaminho = function (element) {
                try {
                    var value = element.$viewValue;
                    if (value) {
                        var regex = new RegExp($scope.obterRegex());
                        var isValid = value ? regex.test(value) : true;
                        element.$setValidity('pattern', isValid);
                        return isValid && (value || value.length > 0);
                    }
                } catch (ex) {
                    // eslint-disable-next-line no-console
                    console.log("Erro :" + ex)
                }
            }

            $scope.validarDiretorio = function () {
                var httpTimeout = $q.defer();
                $scope.configuracoes.IsCaminhoValido = true;
                var request = $http({
                    method: 'POST',
                    url: Config.getUrl("ConfiguracaoMp3/ValidarDiretorio"),
                    data: $scope.configuracoes,
                    timeout: httpTimeout.promise
                });
                var promise = request.then((response) => { return response.data; });
                promise._httpTimeout = httpTimeout;
                return (promise);
            }

            $scope.onUpdate = function () {
                $http.put(Config.getUrl("ConfiguracaoMp3"), $scope.configuracoes)
                    .then(() => {
                        $scope.formConfiguracaoMp3.$setPristine();
                        NotifyService.showSuccess('telaConfiguracaoMp3.configuracaoSalvaComSucesso');
                    }).catch(NotifyService.showError);
            }

            $scope.deleteConfiguracaoMp3 = function (item) {
                ModalService.confirmDelete(() => {
                    return ConfiguracaoMp3Resource.delete({ ConfiguracaoId: item.ConfiguracaoId }).$promise
                        .then(() => {
                            NotifyService.showSuccess('telaConfiguracaoMp3.registroRemovidoComSucesso');
                            ConfiguracaoMp3Resource.odata().query().then((data) => { $scope.list = data; })
                        }).catch((error) => {
                            NotifyService(error, 'telaConfiguracaoMp3.houveUmErroAoExcluirORegistro');
                        })
                })
            }

            $scope.getHistoricoCopiaMp3 = function (item) {
                $scope.search.copiaArquivoAtivo = item;
                CopiaMp3ConfiguracaoResource.historico({ CopiaMp3ConfiguracaoId: item.CopiaMp3ConfiguracaoId }).$promise
                    .then((data) => { $scope.listCopiaArquivosHistorico = data });
            }

            $scope.deleteCopiaMp3 = function (item) {
                ModalService.confirmDelete(() => {
                    CopiaMp3ConfiguracaoResource.delete({ CopiaMp3ConfiguracaoId: item.CopiaMp3ConfiguracaoId }).$promise
                        .then(() => {
                            NotifyService.showSuccess('telaConfiguracaoMp3.registroRemovidoComSucesso');
                            updateCopiaArquivosList();
                        }).catch((ex) => {
                            NotifyService.showError(ex, 'telaConfiguracaoMp3.houveUmErroAoExcluirORegistro');
                        })
                })
            }

            $scope.abortPromise = function (promise) {
                if (promise && promise._httpTimeout && promise._httpTimeout.resolve) {
                    promise._httpTimeout.resolve();
                }
            }

            $scope.$on("onTarefaProgressoChanged", function (event, data) {
                // eslint-disable-next-line no-console
                console.log("onTarefaProgressoChanged:filter")

                var registro = _.findWhere($scope.listCopiaArquivos, { CopiaMp3ConfiguracaoId: data.CopiaMp3ConfiguracaoId });

                if (registro) {
                    registro.Progresso = data.Progresso < 100 ? data.Progresso : 0;
                }

            });

            setTimeout(() => {
                $scope.onInit();
            }, 400);

            function updateCopiaArquivosList() {
                CopiaMp3ConfiguracaoResource.odata().query()
                    .then((data) => { angular.copy(data, $scope.listCopiaArquivos); });
            }

            function parseCronExpression(cronExpression) {
                // Exemplo:
                // "0 30 11 ? * 2,3,4 *" = { HoraInicio: "11:30", DiasSemana: [false,true,true,true,false,false,false] }
                // "0 30 11 20 8 ? 2018" = { DataExecucao: new Date(2018,8,20,11,30,0) }
                var parts = (cronExpression || "").split(" ");
                if (parts.length < 7) return null;
                if (parts[6] !== "*") {
                    // Se o ano foi preenchido, é uma expressão cron com execução unica. 
                    // Preenchemos apenas a data de execução
                    parts = _.map(parts, (part) => { return parseInt(part) });
                    return {
                        DataExecucao: new Date(parts[6], parts[4] - 1, parts[3], parts[2], parts[1], 0)
                    }
                }

                var diasSelecionados = {}; // { "Segunda": true, "Terça": true, "Quarta": true }
                _.forEach(parts[5].split(","), (dia) => {
                    diasSelecionados[diasSemana[parseInt(dia) - 1]] = true;
                })

                return {
                    HoraInicio: parts[2] + ":" + parts[1], DiasSemana: diasSelecionados
                }
            }

            $scope.abrirPopupResumo = function(item){
                $scope.registro = item;
                $scope.registro.Cron = parseCronExpression($scope.registro.ExpressaoCron);
            }

        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ConfiguracaoMp3Resource", ["$odataresource", function ($odataresource) {
            return $odataresource("ConfiguracaoMp3/:ConfiguracaoId", {
                "ConfiguracaoId": "@ConfiguracaoId"
            });
        }]);
        
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ConfiguracaoMp3TipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("ConfiguracaoMp3Tipo/:ConfiguracaoTipoId", {
                "ConfiguracaoTipoId": "@ConfiguracaoTipoId"
            },
            {
                getAll: {
                    url: "ConfiguracaoMp3Tipo",
                    method: "GET",
                    isArray: true
                }
            });
        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('ConfiguracaoProvedorEditData', function ProvedorEditData() {
            return function () {
                return {
                    integracao: ["ConfiguracaoProvedorResource", "$stateParams", function (ConfiguracaoProvedorResource, $stateParams) {
                        if ($stateParams.DiscagemIntegracaoServicoId) {
                            return ConfiguracaoProvedorResource.get({ DiscagemIntegracaoServicoId: $stateParams.DiscagemIntegracaoServicoId }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    tipos: ["ConfiguracaoProvedorResource", function (ConfiguracaoProvedorResource) {
                        return ConfiguracaoProvedorResource.getTipos().$promise;
                    }],
                    produtos: ["ConfiguracaoProvedorResource", function (ConfiguracaoProvedorResource) {
                        return ConfiguracaoProvedorResource.getProdutos().$promise;
                    }]
                }
            }
        })

        .controller("ConfiguracaoProvedorEditController", ["$scope", "$state", "integracao", "tipos", "produtos", "ConfiguracaoProvedorResource", "NotifyService", function ($scope, $state, integracao, tipos, produtos, ConfiguracaoProvedorResource, NotifyService) {
            $scope.submitted = false;
            $scope.integracao = integracao;
            $scope.isNew = integracao.DiscagemIntegracaoServicoId > 0 ? false : true;
            $scope.tipos = tipos;
            $scope.produtos = produtos;

            var mensagemSucesso = function (result) {
                NotifyService.showRegistroSalvo();
                $scope.submitted = false;
                $scope.integracao = result;
            }

            $scope.salvar = function salvar(form) {
                if (!form.$valid) {
                    NotifyService.showInvalid();
                    form.$setSubmitted();
                    return;
                }

                $('#page_preloader').show();

                $scope.submitted = true;
                var promise;
                if ($scope.integracao.DiscagemIntegracaoServicoId > 0)
                    promise = ConfiguracaoProvedorResource.update($scope.integracao).$promise;
                else
                    promise = ConfiguracaoProvedorResource.save($scope.integracao).$promise;

                promise.then(function () {
                    $('#page_preloader').hide();
                    mensagemSucesso();
                    $state.go('main.configuracaoprovedor.list', { storage: true });
                }).catch(NotifyService.showError);
            };

            var retornoValidarConexao = function (result) {
                $scope.integracao.ConexaoValida = result.Valido;
                if ($scope.integracao.ConexaoValida) {
                    NotifyService.showSuccess('telaEditProvedor.conexaoEstaValida')
                }
                else {
                    NotifyService.showError(null, 'telaEditProvedor.conexaoEstaInvalida');
                }
            }

            $scope.validarConexao = function () {
                var promise = ConfiguracaoProvedorResource.validarConexao({ 'DiscagemIntegracaoServicoId': $scope.integracao.DiscagemIntegracaoServicoId }).$promise;
                promise.then(retornoValidarConexao).catch(NotifyService.showError);
            }

            $scope.validarConexaoInicio = function () {
                if ($scope.integracao.DiscagemIntegracaoServicoId > 0) {
                    $scope.validarConexao();
                }
                else {
                    return null;
                }
            }
        }]);

})();

(function () {
    "use strict";

    var getOdataSearchShared = function (ConfiguracaoProvedorResource, search, orderBy, $odata) {
        var odata = ConfiguracaoProvedorResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("contains", "Descricao", search.Descricao), true);
        }

        if (search.Ativo) {
            odata.filter("Ativo", "=", (search.Ativo == '1'));
        }

        return odata;
    }

    angular.module("epbxManagerApp")

        .service("ConfiguracaoProvedorListData", function ConfiguracaoProvedorListData() {
            return function () {
                return {
                    configuracoes: ["ConfiguracaoProvedorResource", "LocalStorageService", "$odata", "$stateParams", function (ConfiguracaoProvedorResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = { 'Ativo': 1 };

                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroPesquisa");
                        }

                        var orderBy = { column: "DiscagemIntegracaoServicoId", order: "desc" }
                        var odata = getOdataSearchShared(ConfiguracaoProvedorResource, filtro, orderBy, $odata);

                        return odata.page(10, 1).query();
                    }]
                }
            }
        })

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.configuracaoprovedor", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.configuracaoprovedor.list',
                        pageTitle: 'pageTitle.provedor',
                        pageName: 'pageTitle.provedor'
                    }
                })
                .state("main.configuracaoprovedor.list", StateResolverProvider.configState("/configuracaoprovedor", "ConfiguracaoProvedor", "List", {
                    pageTitle: 'pageTitle.provedor',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.configuracaoprovedor.edit", StateResolverProvider.configState("/configuracaoprovedor/{DiscagemIntegracaoServicoId:[0-9]+}", "ConfiguracaoProvedor", "Edit", {
                    pageTitle: 'pageTitle.provedor',
                    pageName: 'acoes.editar'
                }))
                .state("main.configuracaoprovedor.new", StateResolverProvider.configState("/configuracaoprovedor/new", "ConfiguracaoProvedor", "Edit", {
                    pageTitle: 'pageTitle.provedor',
                    pageName: 'acoes.cadastrar'
                }));
        }])

        .controller("ConfiguracaoProvedorListController", ["$scope", "configuracoes", "ConfiguracaoProvedorResource", "$odata", "$stateParams", "LocalStorageService", "NotifyService", "$translate", "ModalService", function ($scope, configuracoes, ConfiguracaoProvedorResource, $odata, $stateParams, LocalStorageService,
            NotifyService, $translate, ModalService) {
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPesquisa") : { Ativo: 1, pageSize: 10 };
            $scope.searching = false;

            $scope.orderBy = { 
                column: "DiscagemIntegracaoServicoId", 
                order: "desc" 
            };

            $scope.ativoList = [
                { 'Valor': '1', 'Nome': $translate.instant('status.ativo') },
                { 'Valor': '0', 'Nome': $translate.instant('status.inativo') }
            ];

            $scope.limparFiltro = function () {
                $scope.search = { pageSize: 10 };
                $scope.reverse = false;
                $scope.orderBy = { column: "DiscagemIntegracaoServicoId", order: "desc" };
                $scope.executeSearch();
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(ConfiguracaoProvedorResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroPesquisa', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.configuracoes.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            var updateList = function (list) {
                $scope.configuracoes = list;
                $scope.configuracoes.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.configuracoes.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            updateList(configuracoes)

            $scope.confirmDelete = function (id) {
                ModalService.confirmInativar(() => {
                    return ConfiguracaoProvedorResource.Inativar({ 'DiscagemIntegracaoServicoId': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage)
                        }).catch(NotifyService.showError);
                });
            };

            $scope.confirmReativar = function (id) {
                ModalService.confirmReativar(() => {
                    ConfiguracaoProvedorResource.Reativar({ 'DiscagemIntegracaoServicoId': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage);
                        }).catch(NotifyService.showError);
                });
            };

        }]);
    })
();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ConfiguracaoProvedorResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "DiscagemIntegracaoServico/:DiscagemIntegracaoServicoId",
                {
                    "DiscagemIntegracaoServicoId": "@DiscagemIntegracaoServicoId"
                },
                {
                    getTipos: {
                        url: "DiscagemIntegracaoTipo",
                        method: "GET",
                        isArray: true
                    },
                    getProdutos: {
                        url: "DiscagemIntegracaoServico/GetProduto",
                        method: "GET",
                        isArray: true
                    },
                    validarConexao: {
                        url: "DiscagemIntegracaoServico/:DiscagemIntegracaoServicoId/validarConexao",
                        method: "GET"
                    },
                    Reativar: {
                        method: "PUT",
                        url: "DiscagemIntegracaoServico/:DiscagemIntegracaoServicoId/Ativar"
                    },
                    Inativar: {
                        method: "PUT",
                        url: "DiscagemIntegracaoServico/:DiscagemIntegracaoServicoId/Inativar"
                    },
                    getByDescricao: {
                        url: "DiscagemIntegracaoServico/GetByDescricao",
                        method: "GET"
                    },
                    getByProduto: {
                        url: "DiscagemIntegracaoServico/GetByProduto",
                        method: "GET"
                    },
                    getProvedorUraNPS: {
                        url: "DiscagemIntegracaoServico/GetProvedorUraNPS",
                        isArray: true,
                        method: "GET"
                    }
                });
        }]);

})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
                .state("main.contasip.edit", StateResolverProvider.configState("/contasip/{Id:[0-9]+}", "ContaSip", "Edit", {
					pageTitle: 'pageTitle.contasSip',
					pageName: 'acoes.editar'
				}))
                .state("main.contasip.new", StateResolverProvider.configState("/contasip/new", "ContaSip", "Edit", {
					pageTitle: 'pageTitle.contasSip',
					pageName: 'acoes.adicionar'
				}));
		}])
        .service('ContaSipEditData', function ContaSipEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_uiSelect'
						]);
					}],
					contasip: ["ContaSipResource", "$stateParams", function (ContaSipResource, $stateParams) {						
						if ($stateParams.Id) {
                            return ContaSipResource.get({
                                Id: $stateParams.Id
							}).$promise;
						} else {
							return {};
						}
					}],
					maquinas: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }],
				}
			}
		})

		.controller("ContaSipEditController", ["$scope", "$state", "contasip", "ContaSipResource", "NotifyService", "ModalService", "$translate", "maquinas", function ($scope, $state, contasip, ContaSipResource, NotifyService, ModalService, $translate,maquinas) {
            $scope.Novo = !(contasip && contasip.Id);
            $scope.inserirOuEditar = contasip && contasip.Id ? $translate.instant('telaEditConta.editarContaSip') : $translate.instant('telaEditConta.inserirContaSip');
            $scope.contasip = contasip;
			$scope.maquinas = maquinas;

			var mensagemSucesso = function (resposta) {
				NotifyService.showRegistroSalvo();
				if ($scope.Novo) {
					$scope.resposta = {};
				} else {
                    $scope.contasip = resposta;
				}

				$state.go('main.contasip.list');
			};

			$scope.salvar = function salvar(valid) {
				if (!valid) {
					NotifyService.showInvalid();
					return;
				}

				var promise;

                if ($scope.contasip.Id > 0)
                    promise = ContaSipResource.update($scope.contasip).$promise;
				else {
                    promise = ContaSipResource.save($scope.contasip).$promise;
				}

				promise.then(mensagemSucesso).catch(NotifyService.showError);
			};
			
			$scope.voltar = function () {
				$state.go('main.contasip.list');
            };

            $scope.realm = {
                IpOrigem: ' ',
                IpDestino: ' ',
                Usuario: ' ',
                Senha: ' ',
            };

            $scope.openModalRealm = function (formConfiguracaoAvancada) {
                formConfiguracaoAvancada.$setDirty();
                $scope.realm = {
                    IpOrigem: $scope.contasip.Dominio || '',
                    IpDestino: $scope.contasip.Dominio || '',
                    Usuario: $scope.contasip.Usuario || '',
                    Senha: $scope.contasip.Senha || '',
                };

				ModalService.openModal('modal_configura_realm');
            };

            $scope.consultandoRealme = false;

            $scope.getRealm = function () {
                $scope.consultandoRealme = true;
                ContaSipResource.GetRealm($scope.realm).$promise.then(function (response) {
                    if (response.Realm) {
                        $scope.contasip.Realm = ' ';
                        $("#SipRealm").val(response.Realm);
                        $scope.contasip.Realm = response.Realm;
						ModalService.closeModal('modal_configura_realm');
                    }
                    $scope.consultandoRealme = false;
                }).catch(function(error) {
					$scope.consultandoRealme = false;
					NotifyService.showError(error);
				});
            };

		}]);

})();
(function () {
    "use strict";

    var getOdataSearchShared = function (ContaSipResource, search, orderBy, $odata) {
        var odata = ContaSipResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }

        return odata;
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.contasip", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.contasip.list',
                        pageTitle: 'pageTitle.contasSip',
                        pageName: 'pageTitle.pesquisar',
                        permissions: { AllowAnonymous: true }
                    }
                })
                .state("main.contasip.list", StateResolverProvider.configState("/contasip", "ContaSip", "List", {
                    pageTitle: 'pageTitle.contasSip',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("ContaSipListData", function ContaSipListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    contas: ["ContaSipResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (ContaSipResource, LocalStorageService, $odata, utils, $stateParams) {

                        var filtro = {};
                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroContaSip");

                        var orderBy = {
                            column: "Nome",
                            order: "asc"
                        };

                        var odata = getOdataSearchShared(ContaSipResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }]
                }
            }
        })

        .controller("ContaSipListController", ["$scope", "$odata", "contas", "ContaSipResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", function ($scope, $odata, contas, ContaSipResource, utils, LocalStorageService, $stateParams, NotifyService, $state,
            ModalService) {
            $scope.contas = [];
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroContaSip") : {};

            $scope.orderBy = {
                column: "Nome",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.contas = list;
                $scope.contas.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.contas.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(ContaSipResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.contas.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroContaSip', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var deleteRecord = function (data) {
                return ContaSipResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            updateList(contas);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroContaSip');
                $scope.search = { pageSize: 10 };
                $scope.executeSearch()
            };

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, {
                        storage: true
                    });
                }
                else {
                    $state.go('main.contasip.list', {
                        storage: true
                    });
                }
            };

            $scope.confirmRegistrar = function (data) {
                ModalService.confirmMessage('telaContaSip.desejaRealmenteRegistrar', null, () => {
                    ContaSipResource.Registrar({ Id: data.Id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged(0);
                        }).catch(NotifyService.showError);
                });
            };

            $scope.confirmDesregistrar = function (data) {
                ModalService.confirmMessage('telaContaSip.desejaRealmenteRemoverRegistro', null, () => {
                    ContaSipResource.Desregistrar({ Id: data.Id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged(0);
                        })
                        .catch(NotifyService.showError);
                });
            };
        
        }]);
    })
();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ContaSipResource", ["$odataresource", function ($odataresource) {
            return $odataresource("ContaSip/:Id", {
                "Id": "@Id"
            }, {
                    Registrar: {
                        url: "ContaSip/Registrar/:Id",
                        method: "PUT"
                    },
                    Desregistrar: {
                        url: "ContaSip/Desregistrar/:Id",
                        method: "PUT"
                    },
                    GetRealm: {
                        url: "ContaSip/Realm",
                        method: "POST",
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
                $stateProvider
                    .state("main.copiamp3", {
                        url: "",
                        template: '<ui-view autoscroll="true"/>',
                        abstract: true,
                        data: {
                            proxy: 'main.configuracaomp3.list',
                            pageTitle: 'pageTitle.copiaDeArquivos',
                            pageName: 'pageTitle.pesquisar'
                        }
                    })
                .state("main.copiamp3.new", StateResolverProvider.configState("/configuracaoMp3/copia/new", "CopiaMp3", "Edit",
                    {
                        pageTitle: 'pageTitle.copiaDeArquivos', 
                        pageName: 'acoes.cadastrar',
                        path: "copiaMp3", view: "edit",
                        permissions: { 'ConfiguracaoMp3': 'Cadastrar' }
                    }))

                .state("main.copiamp3.edit", StateResolverProvider.configState("/configuracaoMp3/copia/{CopiaMp3ConfiguracaoId:[0-9]+}", "CopiaMp3", "Edit",
                    {
                        pageTitle: 'pageTitle.copiaDeArquivos', 
                        pageName: 'acoes.editar',
                        path: "copiaMp3", view: "edit",
                        permissions: { 'ConfiguracaoMp3': 'Cadastrar' }
                    }))
        }])

        .service("CopiaMp3EditData", function () {
            return function () {
                return {
                    registro: ["$stateParams", "CopiaMp3ConfiguracaoResource", function ($stateParams, CopiaMp3ConfiguracaoResource) {
                        if ($stateParams.CopiaMp3ConfiguracaoId) {
                            return CopiaMp3ConfiguracaoResource.get({ CopiaMp3ConfiguracaoId: $stateParams.CopiaMp3ConfiguracaoId }).$promise;
                        } else {
                            return {
                                Recorrente: false,
                                Mover: false,
                                PeriodoDias: 10
                            };
                        }
                    }],
                    destinos: ["ConfiguracaoMp3Resource", function (ConfiguracaoMp3Resource) {
                        return ConfiguracaoMp3Resource.odata().orderBy('Caminho').query();
                    }]
                }
            }
        })

        .controller("CopiaMp3EditController", ["$scope", "$state", "registro", "destinos", "CopiaMp3ConfiguracaoResource", "NotifyService", function ($scope, $state, registro, destinos, CopiaMp3ConfiguracaoResource, NotifyService) {
            var diasSemana = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
            $scope.pathExpression = null;
            $scope.today = new Date();
            $scope.helpers = { DiasSemana: diasSemana };
            $scope.destinos = destinos;
            $scope.registro = updateRegistro(registro || {
                Recorrente: false,
                Mover: false,
                PeriodoDias: 10
            });

            $scope.save = function () {
                var promise, tmp;

                if ($scope.registro.OrigemId == $scope.registro.DestinoId) {
                    return NotifyService.showError(null, 'telaEditCopiaMp3.aOrigemEDestinoDeverSerDiferentes')
                }

                // montar expressao Cron:
                // {Segundo} {Minuto} {Hora} {Dia} {Mes} {DiasSemana} {Ano}
                if ($scope.registro.Recorrente) {
                    tmp = $scope.registro.Cron.HoraInicio.split(":")
                    $scope.registro.ExpressaoCron = "0 " + tmp[1] + " " + tmp[0] + " ? * ";

                    tmp = [];
                    angular.forEach($scope.registro.Cron.DiasSemana, (selected, dia) => {
                        if (selected) {
                            tmp.push((diasSemana.indexOf(dia) + 1).toString());
                        }
                    });
                    $scope.registro.ExpressaoCron += tmp.join(",") + " *"; // dias da semana e ano ( *)
                } else {
                    $scope.registro.ExpressaoCron = moment($scope.registro.Cron.DataExecucao).format('[0] m H D M [?] YYYY');
                }

                if ($scope.registro.CopiaMp3ConfiguracaoId > 0) {
                    promise = CopiaMp3ConfiguracaoResource.update($scope.registro).$promise;
                }
                else {
                    promise = CopiaMp3ConfiguracaoResource.save($scope.registro).$promise;
                }

                return promise.then((registroNovo) => {
                    NotifyService.showRegistroSalvo();
                    $state.go('main.configuracaomp3.list')
                    updateRegistro(registroNovo);
                }).catch(NotifyService.showError);
            }

            function updateRegistro(r) {
                $scope.registro = r;
                $scope.registro.Cron = parseCronExpression($scope.registro.ExpressaoCron) || {
                    HoraInicio: "23:00",
                    DiasSemana: { "Segunda": true, "Terça": true, "Quarta": true, "Quinta": true, "Sexta": true }
                };
                return r;
            }

            function parseCronExpression(cronExpression) {
                // Exemplo:
                // "0 30 11 ? * 2,3,4 *" = { HoraInicio: "11:30", DiasSemana: [false,true,true,true,false,false,false] }
                // "0 30 11 20 8 ? 2018" = { DataExecucao: new Date(2018,8,20,11,30,0) }
                var parts = (cronExpression || "").split(" ");
                if (parts.length < 7) return null;
                if (parts[6] !== "*") {
                    // Se o ano foi preenchido, é uma expressão cron com execução unica. 
                    // Preenchemos apenas a data de execução
                    parts = _.map(parts, (part) => { return parseInt(part) });
                    return {
                        DataExecucao: new Date(parts[6], parts[4] - 1, parts[3], parts[2], parts[1], 0)
                    }
                }

                var diasSelecionados = {}; // { "Segunda": true, "Terça": true, "Quarta": true }
                _.forEach(parts[5].split(","), (dia) => {
                    diasSelecionados[diasSemana[parseInt(dia) - 1]] = true;
                })

                return {
                    HoraInicio: parts[2] + ":" + parts[1], DiasSemana: diasSelecionados
                }
            }
        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CopiaMp3ConfiguracaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("ConfiguracaoMp3/copia/:CopiaMp3ConfiguracaoId", { "CopiaMp3ConfiguracaoId": "@CopiaMp3ConfiguracaoId" },
                {
                    historico: { method: "GET", url: "ConfiguracaoMp3/copia/:CopiaMp3ConfiguracaoId/Historico", isArray: true }
                });
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        // Fecha o elemento quando o usuário clica fora dele.
        // Uso: <div cti-click-outside="intervaloOpen = false">
        .directive('ctiClickOutside', ["$document", function ($document) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var onClick = function (event) {
                        if (!element[0].contains(event.target)) {
                            scope.$apply(function () { scope.$eval(attrs.ctiClickOutside); });
                        }
                    };
                    $document.on('mousedown', onClick);
                    scope.$on('$destroy', function () {
                        $document.off('mousedown', onClick);
                    });
                }
            };
        }])
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("crm_phone", StateResolverProvider.configState("/crm_phone", "Cti", "View", {
                path: "cti",
                permissions: {
                    AllowAnonymous: true
                },
                css: true
            }));
        }])

        .service("CtiViewData", function CtiViewData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_signalr'
                        ]);
                    }],
                    usuarioLogado: ["AuthService", function (AuthService) {
                        return AuthService.restore().catch(function () { return null; });
                    }]
                };
            };
        })

        .controller('CtiViewController', ["$scope", "$rootScope", "$location", "$timeout", "$q", "$window", "$state", "$http", "AuthService", "Config", "ConfiguracaoResource", "RamalResource", "MaquinaResource", "TabulacaoResource", "SoftphoneService", "AtendimentoService", "SignalrConnection", "ATENDIMENTO_EVENTS", "SIGNALR_EVENTS", "NotifyService", "usuarioLogado", function (
            $scope, $rootScope, $location, $timeout, $q, $window, $state, $http,
            AuthService, Config, ConfiguracaoResource, RamalResource, MaquinaResource,
            TabulacaoResource,
            SoftphoneService, AtendimentoService, SignalrConnection,
            ATENDIMENTO_EVENTS, SIGNALR_EVENTS, NotifyService, usuarioLogado
        ) {

            // Versão do app (rodapé do login)
            $scope.appVersion = Config.getVersion();

            // Link "Esqueci minha senha" — abre o fluxo padrão do EpbxManager.
            $scope.esqueciSenha = function () {
                var absUrl = $window.location.origin + $window.location.pathname +
                             '#/esqueciminhasenha';
                $window.open(absUrl, '_blank');
            };

            // Esconde header/sidebar do app principal (mesma flag que o dash usa).
            $rootScope.hiddenLayout = true;
            $rootScope.primarySidebarActive = false;
            $rootScope.topBarActive = false;
            $rootScope.page_full_height = true;

            // Salesforce Open CTI: o sfdomain vem do adapter URL (?sfdomain=...) OU
            // é detectado automaticamente pelo document.referrer/window.parent quando
            // a página roda dentro de um iframe do Salesforce.
            var sfDomain = $location.search().sfdomain || detectarSfDomainAutomatico();
            var sfReady = false;
            $scope.sfMode = !!sfDomain;
            if (sfDomain) console.log('[CTI/SF] sfdomain ativo:', sfDomain);

            function detectarSfDomainAutomatico() {
                var sfRegex = /\.(lightning\.force|my\.salesforce|visualforce)\.com$/;
                try {
                    var ref = $window.document.referrer;
                    if (ref) {
                        var host = new URL(ref).host;
                        if (sfRegex.test(host)) {
                            console.log('[CTI/SF] sfdomain detectado via referrer:', host);
                            return host;
                        }
                    }
                } catch (e) {}
                try {
                    if ($window.parent && $window.parent !== $window) {
                        var parentHost = $window.parent.location.host;
                        if (sfRegex.test(parentHost)) {
                            console.log('[CTI/SF] sfdomain detectado via window.parent:', parentHost);
                            return parentHost;
                        }
                    }
                } catch (e) { /* cross-origin: esperado */ }
                return null;
            }

            // ===== Protocolo postMessage do Talk.WebFone (novo) =====
            // A versão atual do webphone ignora os parâmetros que vêm na URL
            // e exige um postMessage({ command: "Init", ... }) em resposta ao
            // evento { type: "Ready" } emitido pelo iframe.
            var webphoneOrigin = null;
            var webphoneInitParams = null;

            function handleWebphoneMessage(event) {
                if (webphoneOrigin && event.origin !== webphoneOrigin) return;
                var msg = event.data;
                if (!msg || !msg.type) return;

                if (msg.type === 'Ready' && webphoneInitParams) {
                    var iframe = document.getElementById('softphone');
                    if (!iframe || !iframe.contentWindow) return;
                    iframe.contentWindow.postMessage({
                        command: 'Init',
                        webServer: webphoneInitParams.webServer,
                        ctiServer: webphoneInitParams.ctiServer,
                        usuarioSip: webphoneInitParams.usuarioSip,
                        senhaSip: webphoneInitParams.senhaSip,
                        autoAtendimento: true,
                        urlAtendimento: $location.absUrl()
                    }, webphoneOrigin || '*');
                }
            }

            $window.addEventListener('message', handleWebphoneMessage);

            // ---- view state ----
            $scope.step = 'login'; // login | connecting | ready
            $scope.credentials = { username: '', password: '', persist: true };
            $scope.discagem = { numero: '', rotaId: null };

            $scope.status = {
                ramalRegistrado: false,
                ramalLogado: false,
                emChamada: false,
                ringing: false,
                emEspera: false,
                emIntervalo: false,
                ramalNumero: null,
                userName: null,
                chamada: null,
                erro: null
            };

            // ===== TABS =====
            $scope.tab = 'discador'; // 'discador' | 'historico' | 'tabulacao'
            $scope.setTab = function (t) {
                // Quando há tabulação pendente, só pode sair pra a aba tabulacao
                if ($scope.tabulacaoPendente && t !== 'tabulacao') return;
                $scope.tab = t;
            };

            // ===== TABULAÇÃO =====
            // Campos do layout (Categoria, SubCategoria, Genérico1, Genérico2)
            $scope.campos = null;
            $scope.layoutId = null;
            $scope.tabulacaoPendente = false; // bloqueia discar quando há tabulação a finalizar
            $scope.tabulacao = null;          // payload em montagem
            $scope.tabulacaoSalvando = false;
            $scope.tabulacaoErro = null;
            // Snapshot da última chamada atendida (alimenta a tabulação)
            var ultimaChamada = null;
            var chamadaFoiAtendida = false;
            var callStart = null;

            // ===== AUTH =====
            $scope.login = function () {
                $scope.status.erro = null;
                $scope.loggingIn = true;
                return AuthService
                    .login($scope.credentials.username, $scope.credentials.password,
                           $scope.credentials.persist, 'local')
                    .then(function () {
                        $scope.loggingIn = false;
                        iniciar();
                    })
                    .catch(function (err) {
                        $scope.loggingIn = false;
                        var msg = (err && err.data && err.data.error_description) ||
                                  'telaCti.erroLogin';
                        if (msg.indexOf('password expired') >= 0) msg = 'telaCti.senhaExpirada';
                        else if (msg.indexOf('host is invalid') >= 0) msg = 'telaCti.hostInvalido';
                        else if (err && err.status === 400) msg = 'telaCti.usuarioOuSenhaInvalido';
                        $scope.status.erro = msg;
                    });
            };

            $scope.logout = function () {
                desconectar();
                AuthService.logout();
                $scope.status = {
                    ramalRegistrado: false, ramalLogado: false, emChamada: false,
                    ringing: false, emEspera: false, emIntervalo: false,
                    ramalNumero: null, userName: null, chamada: null, erro: null
                };
                $scope.campos = null;
                $scope.layoutId = null;
                $scope.tabulacao = null;
                $scope.tabulacaoPendente = false;
                $scope.tab = 'discador';
                $scope.step = 'login';
            };

            // ===== INICIAR (após login) =====
            function iniciar() {
                $scope.step = 'connecting';
                $scope.status.erro = null;

                var user = AuthService.getUsuarioLogado();
                if (!user) {
                    $scope.status.erro = 'telaCti.usuarioNaoEncontrado';
                    $scope.step = 'login';
                    return;
                }
                $scope.status.userName = user.Login || user.Nome || user.UsuarioNome;

                if (!user.RamalId) {
                    $scope.status.erro = 'telaCti.usuarioSemRamal';
                    $scope.step = 'login';
                    return;
                }

                $q.all({
                    softphone: ConfiguracaoResource.getSoftphone({}).$promise,
                    ramal: RamalResource.getInfo(user.RamalId).$promise,
                    maquinas: MaquinaResource.query().$promise
                }).then(function (data) {
                    if (!data.softphone || data.softphone.Ativo === false) {
                        throw { msg: 'telaCti.softphoneInativo' };
                    }
                    if (!data.ramal || !data.ramal.Numero) {
                        throw { msg: 'telaCti.ramalNaoEncontrado' };
                    }
                    var enderecoSipWebRTC = pickEnderecoSipWebRTC(data.maquinas, data.ramal);
                    if (!enderecoSipWebRTC) {
                        throw { msg: 'telaCti.semEnderecoSipWebRTC' };
                    }

                    $scope.status.ramalNumero = data.ramal.Numero;

                    // Guarda os parâmetros para responder ao evento "Ready" do iframe
                    // (novo protocolo postMessage do webphone).
                    var urlBase = data.softphone.UrlBase || 'https://talkfone.vercel.app';
                    var wsUrl = data.softphone.WebsocketUrl || 'wss2.talkcomm.com.br:10081';
                    try {
                        webphoneOrigin = new URL(urlBase).origin;
                    } catch (e) {
                        webphoneOrigin = null;
                    }
                    webphoneInitParams = {
                        webServer: 'wss://' + wsUrl,
                        ctiServer: enderecoSipWebRTC,
                        usuarioSip: data.ramal.Numero,
                        senhaSip: data.ramal.Senha
                    };

                    SoftphoneService.registrar(
                        data.softphone.UrlBase,
                        data.softphone.WebsocketUrl,
                        enderecoSipWebRTC,
                        data.ramal.Numero,
                        data.ramal.Senha,
                        data.softphone.Debug
                    );

                    // Timeout de segurança caso o iframe não responda.
                    $scope.registerTimer = $timeout(function () {
                        if (!$scope.status.ramalRegistrado) {
                            $scope.status.erro = 'telaCti.timeoutRegistro';
                        }
                    }, 15000);
                }).catch(function (err) {
                    var msg = (err && err.msg) || 'telaCti.erroCarregarConfig';
                    $scope.status.erro = msg;
                    $scope.step = 'login';
                });
            }

            function pickEnderecoSipWebRTC(maquinas, ramal) {
                if (!maquinas || !maquinas.length) return null;
                if (ramal && ramal.MaquinaId) {
                    for (var i = 0; i < maquinas.length; i++) {
                        if (maquinas[i].MaquinaId === ramal.MaquinaId &&
                            maquinas[i].EnderecoSipWebRTC) {
                            return maquinas[i].EnderecoSipWebRTC;
                        }
                    }
                }
                return maquinas[0].EnderecoSipWebRTC || null;
            }

            // ===== SOFTPHONE registration status =====
            $scope.$on('softphone:registrationStatus', function (_e, data) {
                if (!data) return;
                console.log('[CTI] softphone state ->', data.state);
                if (data.state === 'Registered') {
                    if ($scope.registerTimer) $timeout.cancel($scope.registerTimer);
                    $scope.status.ramalRegistrado = true;
                    // Loga ramal no PABX (tipoLogon=3 = ramal) e sobe SignalR.
                    console.log('[CTI] chamando AtendimentoService.iniciar(', $scope.status.ramalNumero, ', tipoLogon=3 )');
                    AtendimentoService
                        .iniciar($scope.status.ramalNumero, 3, true)
                        .then(function (r) {
                            console.log('[CTI] hub.iniciar resolveu:', r);
                        })
                        .catch(function (err) {
                            console.error('[CTI] hub.iniciar rejeitou:', err);
                            $scope.status.erro = (err && err.message) || 'telaCti.erroLogarHub';
                        });
                } else if (data.state === 'Unregistered' || data.state === 'Terminated') {
                    $scope.status.ramalRegistrado = false;
                    $scope.status.ramalLogado = false;
                }
            });

            // ===== EVENTOS DE ATENDIMENTO =====
            $scope.$on(ATENDIMENTO_EVENTS.onLogado, function (_e, ramal) {
                console.log('[CTI] onLogado recebido. ramal=', ramal);
                $scope.status.ramalLogado = true;
                $scope.status.erro = null;
                $scope.step = 'ready';
            });
            $scope.$on(ATENDIMENTO_EVENTS.onLogadoErro, function (_e, ramal, info) {
                console.error('[CTI] onLogadoErro:', info);
                $scope.status.erro = (info && info.Descricao) || 'telaCti.erroLogarHub';
            });
            $scope.$on(ATENDIMENTO_EVENTS.onConexaoErro, function (_e, ramal, info) {
                console.error('[CTI] onConexaoErro:', info);
                $scope.status.erro = (info && info.Descricao) || 'telaCti.erroConexaoHub';
            });
            $scope.$on(ATENDIMENTO_EVENTS.onDeslogado, function (_e, ramal, info) {
                console.warn('[CTI] onDeslogado:', info);
                $scope.status.ramalLogado = false;
            });

            // ===== SIGNALR reconectou: precisa re-logar o ramal (novo connection_id) =====
            $scope.$on(SIGNALR_EVENTS.reconnected, function () {
                console.warn('[CTI] SignalR reconectou — re-logando ramal no Atendimento');
                if ($scope.status.ramalRegistrado && $scope.status.ramalNumero) {
                    AtendimentoService.iniciar($scope.status.ramalNumero, 3, true)
                        .then(function () { console.log('[CTI] re-iniciar OK'); })
                        .catch(function (err) { console.error('[CTI] re-iniciar falhou:', err); });
                }
            });
            $scope.$on(SIGNALR_EVENTS.disconnected, function () {
                console.warn('[CTI] SignalR desconectou');
                $scope.status.ramalLogado = false;
            });
            $scope.$on(SIGNALR_EVENTS.connected, function () {
                console.log('[CTI] SignalR conectado');
            });
            $scope.$on(SIGNALR_EVENTS.reconnecting, function () {
                console.log('[CTI] SignalR reconectando…');
            });

            $scope.$on(ATENDIMENTO_EVENTS.onRingSip, function (_e, ramal, chamada) {
                $scope.status.ringing = true;
                $scope.status.chamada = chamada;
                tocarRingtone(true);
                // busca histórico do chamador antes de atender
                var origem = chamada && (chamada.Telefone || chamada.NumeroOrigem);
                if (origem) carregarHistorico(String(origem).replace(/\D/g, ''));
            });
            $scope.$on(ATENDIMENTO_EVENTS.onChamada, function (_e, ramal, chamada) {
                $scope.status.chamada = chamada;
            });
            function aoAtender(origem) {
                return function (_e, ramal, chamada) {
                    console.log('[CTI] ' + origem + ' recebido. chamada=', chamada);
                    $scope.status.ringing = false;
                    $scope.status.emChamada = true;
                    $scope.status.chamada = chamada;
                    callStart = Date.now();
                    chamadaFoiAtendida = true;
                    ultimaChamada = chamada;
                    tocarRingtone(false);
                    carregarCamposEMontarTabulacao(chamada);
                };
            }
            $scope.$on(ATENDIMENTO_EVENTS.onAtendido, aoAtender('onAtendido'));
            $scope.$on(ATENDIMENTO_EVENTS.onAtendidoDiscador, aoAtender('onAtendidoDiscador'));
            $scope.$on(ATENDIMENTO_EVENTS.onDisca, function (_e, ramal, chamada) {
                $scope.status.emChamada = true;
                $scope.status.chamada = chamada;
                ultimaChamada = chamada;
                callStart = callStart || Date.now();
            });
            $scope.$on(ATENDIMENTO_EVENTS.onDiscaErro, function () {
                $scope.status.emChamada = false;
                $scope.status.chamada = null;
                NotifyService.showError(null, 'telaCti.erroDiscar');
            });
            $scope.$on(ATENDIMENTO_EVENTS.onDesliga, function () {
                var duracao = callStart ? Math.round((Date.now() - callStart) / 1000) : 0;
                var chamada = ultimaChamada || $scope.status.chamada;
                $scope.status.emChamada = false;
                $scope.status.ringing = false;
                $scope.status.chamada = null;
                tocarRingtone(false);
                if (sfReady && chamada) salesforceSaveLog(chamada, duracao);

                // Se a chamada foi atendida e há campos carregados, completa a duração
                // e marca como pendente — bloqueia o discador até salvar/pular.
                if (chamadaFoiAtendida && $scope.tabulacao) {
                    $scope.tabulacao.Duracao = duracao;
                    $scope.tabulacaoPendente = true;
                    $scope.tab = 'tabulacao';
                }
                callStart = null;
                chamadaFoiAtendida = false;
            });

            $scope.$on(ATENDIMENTO_EVENTS.onInicioIntervalo, function () {
                $scope.status.emIntervalo = true;
            });
            $scope.$on(ATENDIMENTO_EVENTS.onTerminoIntervalo, function () {
                $scope.status.emIntervalo = false;
            });
            // Cada tipo de intervalo configurado pra esse ramal/atendimento chega aqui
            $scope.$on(ATENDIMENTO_EVENTS.onInfoIntervaloRamal, function (_e, ramal, info) {
                console.log('[CTI] onInfoIntervaloRamal:', info);
                if (!info || info.RamalStatusDetalheId == null) return;
                $scope.intervalos[info.RamalStatusDetalheId] = {
                    Descricao: info.Descricao,
                    Produtivo: info.Produtivo,
                    RamalStatusDetalheId: info.RamalStatusDetalheId
                };
            });
            // Backend confirma a mudança de status (também é a confirmação de qual está ativo)
            $scope.$on(ATENDIMENTO_EVENTS.onSetIntervaloRamal, function (_e, ramal, status) {
                console.log('[CTI] onSetIntervaloRamal:', status);
                if (!status || status.Status === 1) return; // Status 1 = erro
                $scope.intervaloAtual = parseInt(status.RamalStatusDetalheId);
            });
            $scope.$on(ATENDIMENTO_EVENTS.onAlterarIntervaloTipoErro, function (_e, ramal, info) {
                console.error('[CTI] onAlterarIntervaloTipoErro:', info);
                NotifyService.showError(null,
                    (info && info.Descricao) || 'telaCti.erroAlterarIntervalo');
            });
            $scope.$on(ATENDIMENTO_EVENTS.onInicioEspera, function () {
                $scope.status.emEspera = true;
            });
            $scope.$on(ATENDIMENTO_EVENTS.onTerminoEspera, function () {
                $scope.status.emEspera = false;
            });

            // ===== AÇÕES DO OPERADOR =====
            $scope.discar = function () {
                var numero = ($scope.discagem.numero || '').replace(/\D/g, '');
                if (!numero || !$scope.status.ramalLogado) return;
                if ($scope.tabulacaoPendente) {
                    $scope.tab = 'tabulacao';
                    return;
                }
                executarDiscar(numero, 1); // 1 retry quando der "Ramal não logado"
            };

            function executarDiscar(numero, tentativasRestantes) {
                // Sem rotaId -> discar(numero, tipo). Com rotaId -> discarRota.
                var promessa = $scope.discagem.rotaId
                    ? AtendimentoService.discarRota(numero, $scope.discagem.rotaId)
                    : AtendimentoService.discar(numero, 1);

                promessa.catch(function (erro) {
                    var msg = (erro && erro.message) || (erro && erro.Description) ||
                              (typeof erro === 'string' ? erro : null);
                    console.warn('[CTI] erro ao discar:', erro);

                    // Race do login: o hub às vezes ainda não fez o ramal entrar no
                    // pool da integração quando o usuário clica em discar logo após
                    // o onLogado. Retry curto cobre o gap.
                    if (msg && msg.indexOf('Ramal não logado') >= 0 && tentativasRestantes > 0) {
                        console.warn('[CTI] retry do discar em 700ms (race do login do ramal)');
                        $timeout(function () {
                            executarDiscar(numero, tentativasRestantes - 1);
                        }, 700);
                        return;
                    }

                    if (msg) NotifyService.showError(null, msg);
                    else NotifyService.showError(null, 'telaCti.erroDiscar');
                });
            }
            $scope.atender = function () {
                // O auto-answer já está habilitado no SoftphoneService (autoAtendimento=true).
                // A UI apenas reflete o estado; a chamada deve ser atendida pelo iframe.
                $scope.status.ringing = false;
            };
            $scope.desligar = function () {
                // UI otimista: limpa o estado imediatamente para o botão dar feedback instantâneo.
                // O onDesliga do servidor pode demorar (round-trip SignalR -> CTI -> SIP BYE).
                $scope.status.emChamada = false;
                $scope.status.ringing = false;
                $scope.status.chamada = null;
                tocarRingtone(false);
                AtendimentoService.desligar().catch(function (err) {
                    console.error('[CTI] desligar falhou:', err);
                });
            };
            $scope.iniciarEspera = function () { AtendimentoService.iniciarEspera(); };
            $scope.terminarEspera = function () { AtendimentoService.terminarEspera(); };

            // ===== INTERVALOS (status do operador) =====
            // O backend empurra os tipos disponíveis via onInfoIntervaloRamal (1 evento por tipo),
            // e onSetIntervaloRamal informa o estado atual. alterarIntervaloTipo troca o estado.
            $scope.intervalos = {};         // map RamalStatusDetalheId -> {Descricao, Produtivo, ...}
            $scope.intervaloAtual = null;   // RamalStatusDetalheId atual

            $scope.intervalosArray = function () {
                var arr = [];
                for (var k in $scope.intervalos) { arr.push($scope.intervalos[k]); }
                return arr;
            };

            $scope.alterarIntervalo = function (id) {
                console.log('[CTI] alterarIntervalo solicitado. id=', id,
                            ' atual=', $scope.intervaloAtual);
                if (id == null) {
                    console.warn('[CTI] alterarIntervalo: id nulo, abortando');
                    return;
                }
                if (id === $scope.intervaloAtual) {
                    console.log('[CTI] alterarIntervalo: id == atual, nada a fazer');
                    return;
                }
                var idInt = parseInt(id);
                AtendimentoService.alterarIntervaloTipo(idInt)
                    .then(function (r) {
                        console.log('[CTI] hub.alterarIntervaloTipo resolveu:', r);
                    })
                    .catch(function (err) {
                        console.error('[CTI] hub.alterarIntervaloTipo rejeitou:', err);
                        NotifyService.showError(null,
                            (err && err.message) || 'telaCti.erroAlterarIntervalo');
                    });
            };

            $scope.intervaloOpen = false;
            $scope.intervaloAtualLabel = function () {
                var i = $scope.intervalos && $scope.intervalos[$scope.intervaloAtual];
                return (i && i.Descricao) || '—';
            };

            // Regras de seleção (mesmas do tabulador / atendimento):
            //  - id 5 ("Em Atendimento") é sistema-only, não pode ser selecionado manualmente
            //  - o intervalo já ativo não tem por que ser reselecionado
            //  - se uma tabulação está pendente, não pode mudar pra Livre (o produtivo)
            var INTERVALO_SISTEMA = [5];
            $scope.podeSelecionarIntervalo = function (intervalo) {
                if (!intervalo) return false;
                if (INTERVALO_SISTEMA.indexOf(intervalo.RamalStatusDetalheId) >= 0) return false;
                if (intervalo.RamalStatusDetalheId === $scope.intervaloAtual) return false;
                if ($scope.tabulacaoPendente && intervalo.Produtivo) return false;
                return true;
            };
            $scope.motivoBloqueio = function (intervalo) {
                if (!intervalo) return '';
                if (INTERVALO_SISTEMA.indexOf(intervalo.RamalStatusDetalheId) >= 0) {
                    return 'telaCti.intervaloSistema';
                }
                if ($scope.tabulacaoPendente && intervalo.Produtivo) {
                    return 'telaCti.intervaloBloqueadoTabulacao';
                }
                return '';
            };

            $scope.selecionarIntervalo = function (intervalo) {
                console.log('[CTI] selecionarIntervalo', intervalo);
                if (!$scope.podeSelecionarIntervalo(intervalo)) {
                    console.warn('[CTI] intervalo bloqueado:', $scope.motivoBloqueio(intervalo));
                    return;
                }
                $scope.intervaloOpen = false;
                $scope.alterarIntervalo(intervalo.RamalStatusDetalheId);
            };

            $scope.appendDigit = function (d) {
                $scope.discagem.numero = ($scope.discagem.numero || '') + d;
            };

            // ===== HISTÓRICO DE CHAMADAS (últimos 7 dias por número) =====
            $scope.historico = {
                loading: false,
                numero: null,
                items: [],
                expanded: false
            };

            var historicoCache = {};
            var historicoTimer = null;
            var historicoSeq = 0;

            function carregarHistorico(numero) {
                if (!numero) {
                    $scope.historico.items = [];
                    $scope.historico.numero = null;
                    return;
                }
                if (historicoCache[numero]) {
                    $scope.historico.numero = numero;
                    $scope.historico.items = historicoCache[numero];
                    $scope.historico.loading = false;
                    return;
                }
                var seq = ++historicoSeq;
                $scope.historico.loading = true;
                $scope.historico.numero = numero;
                TabulacaoResource.GetLigacoes({ telefone: numero }).$promise
                    .then(function (lista) {
                        if (seq !== historicoSeq) return; // outra busca já saiu
                        historicoCache[numero] = lista || [];
                        $scope.historico.items = historicoCache[numero];
                        $scope.historico.loading = false;
                    })
                    .catch(function (err) {
                        if (seq !== historicoSeq) return;
                        console.error('[CTI] erro ao buscar histórico:', err);
                        $scope.historico.items = [];
                        $scope.historico.loading = false;
                    });
            }

            $scope.$watch('discagem.numero', function (newVal) {
                if (historicoTimer) $timeout.cancel(historicoTimer);
                var digits = (newVal || '').replace(/\D/g, '');
                if (digits.length < 4) {
                    $scope.historico.items = [];
                    $scope.historico.numero = null;
                    $scope.historico.loading = false;
                    return;
                }
                historicoTimer = $timeout(function () {
                    carregarHistorico(digits);
                }, 500);
            });

            $scope.discarHistorico = function (item) {
                var n = (item.NA && item.DirecaoDescricao === 'Entrada') ? item.NA : item.NB;
                $scope.discagem.numero = (n || '').replace(/\D/g, '');
                $scope.discar();
            };

            // ===== TABULAÇÃO — montagem, subcategorias, submit =====
            // Carrega os campos do layout para a chamada atual e monta o objeto tabulacao.
            // Chamado no onAtendido (chamada ativa, pode preencher durante a ligação).
            // Constantes consistentes com o tabulador:
            //   chamada.Direcao: 2 = Recebida, 1 = Efetuada (DirecaoChamada enum)
            //   tabulacao.DirecaoId (payload): 1 = Recebida, 2 = Efetuada
            var DIRECAO_CHAMADA_RECEBIDA = 2;
            var DIRECAO_TABULACAO_RECEBIDA = 1;
            var DIRECAO_TABULACAO_EFETUADA = 2;

            function carregarCamposEMontarTabulacao(chamada) {
                if (!chamada) {
                    console.warn('[CTI] carregarCampos: chamada vazia, abortando');
                    return;
                }

                var recebida = chamada.Direcao === DIRECAO_CHAMADA_RECEBIDA;
                var na = recebida ? (chamada.DDRLocal || '') : '';
                var params = {
                    CampanhaId: chamada.CodigoCampanha || 0,
                    Direcao: chamada.Direcao,
                    NA: na
                };
                console.log('[CTI] chamando GetCampos com params=', params);

                TabulacaoResource.GetCampos(params).$promise
                    .then(function (campos) {
                        console.log('[CTI] GetCampos retornou', campos);
                        if (!campos || !campos.length) {
                            console.warn('[CTI] GetCampos retornou vazio — provavelmente sem AtendimentoLayout configurado para esse caminho (campanha/DDR)');
                            return;
                        }
                        $scope.campos = campos;
                        $scope.layoutId = campos[0].AtendimentoLayoutId;
                        $scope.tabulacao = montarTabulacao(chamada, recebida);
                        $scope.tabulacaoErro = null;
                        console.log('[CTI] tabulação preparada:', $scope.tabulacao);
                    })
                    .catch(function (err) {
                        console.error('[CTI] erro ao buscar campos do layout:', err);
                    });
            }

            function montarTabulacao(chamada, recebida) {
                var direcaoId = chamada.CodigoCampanha > 0
                    ? DIRECAO_TABULACAO_EFETUADA
                    : recebida ? DIRECAO_TABULACAO_RECEBIDA : DIRECAO_TABULACAO_EFETUADA;
                return {
                    LayoutId: $scope.layoutId,
                    DirecaoId: direcaoId,
                    GlobalId: chamada.GlobalId || null,
                    Protocolo: chamada.Protocolo || null,
                    ClienteId: chamada.CodigoCliente || null,
                    CampanhaId: chamada.CodigoCampanha || null,
                    NA: recebida ? (chamada.DDRLocal || '999999999')
                                 : ($scope.status.ramalNumero || '999999999'),
                    NB: chamada.Telefone || chamada.NB || '',
                    Nome: chamada.NomeCliente || chamada.NomeContato || null,
                    NumeroGrupo: chamada.NumeroGrupo || null,
                    Duracao: 0,
                    AcaoId: 0,
                    AtendimentoStatusId: 2,
                    CategoriaId: null,
                    SubCategoriaId: null,
                    CampoGenerico1: null,
                    CampoGenerico2: null,
                    Historico: ''
                };
            }

            $scope.subcategoriasFiltradas = function () {
                var camposSub = $scope.campos && $scope.campos[1];
                if (!camposSub || !camposSub.Categorias) return [];
                var parent = $scope.tabulacao && $scope.tabulacao.CategoriaId;
                if (!parent) return camposSub.Categorias;
                return camposSub.Categorias.filter(function (c) {
                    return !c.ParentId || c.ParentId === parent;
                });
            };

            $scope.tabulacaoCategoriaObrigatoria = function () {
                return !!($scope.campos && $scope.campos[0] && $scope.campos[0].Tabular);
            };

            $scope.salvarTabulacao = function () {
                if (!$scope.tabulacao) return;
                if ($scope.tabulacaoCategoriaObrigatoria() && !$scope.tabulacao.CategoriaId) {
                    $scope.tabulacaoErro = 'telaCti.tabulacaoCategoriaObrigatoria';
                    return;
                }
                // Status: 1 = completa (categoria+sub), 2 = incompleta
                $scope.tabulacao.AtendimentoStatusId =
                    ($scope.tabulacao.CategoriaId && $scope.tabulacao.SubCategoriaId) ? 1 : 2;

                // AcaoId é obrigatório. Default = 1 (EnumAtendimentoAcao.SemAcao).
                // Se a categoria selecionada definir um AtendimentoAcaoId próprio, ele prevalece.
                var acaoFromCategoria = null;
                if ($scope.tabulacao.CategoriaId && $scope.campos && $scope.campos[0] &&
                    $scope.campos[0].Categorias) {
                    var sel = $scope.campos[0].Categorias.find(function (c) {
                        return c.Id === $scope.tabulacao.CategoriaId;
                    });
                    if (sel && sel.AtendimentoAcaoId) acaoFromCategoria = sel.AtendimentoAcaoId;
                }
                $scope.tabulacao.AcaoId = acaoFromCategoria || 1;

                $scope.tabulacaoSalvando = true;
                $scope.tabulacaoErro = null;
                console.log('[CTI] enviando tabulação payload=', $scope.tabulacao);
                // snapshot dos dados antes do reset, pra enviar pra Salesforce
                var snapshot = angular.copy($scope.tabulacao);
                TabulacaoResource.save($scope.tabulacao).$promise
                    .then(function () {
                        $scope.tabulacaoSalvando = false;
                        $scope.tabulacaoPendente = false;
                        $scope.tabulacao = null;
                        $scope.tab = 'discador';
                        // Atualiza o Task no Salesforce com a tabulação salva (não bloqueia o fluxo)
                        try { salesforceAtualizarComTabulacao(snapshot); } catch (e) {
                            console.warn('[CTI/SF] erro ao atualizar Task com tabulação:', e);
                        }
                    })
                    .catch(function (err) {
                        console.error('[CTI] erro ao salvar tabulação. status=',
                                      err && err.status, ' data=', err && err.data);
                        if (err && err.data && angular.isArray(err.data)) {
                            err.data.forEach(function (e, i) {
                                console.error('[CTI] erro[' + i + ']:', e);
                            });
                        }
                        $scope.tabulacaoSalvando = false;
                        var msg = null;
                        if (err && err.data) {
                            if (angular.isArray(err.data) && err.data.length) {
                                msg = err.data[0].Message || err.data[0].ErrorMessage ||
                                      err.data[0].Mensagem || JSON.stringify(err.data[0]);
                            } else if (err.data.Message) {
                                msg = err.data.Message;
                            }
                        }
                        $scope.tabulacaoErro = msg || 'telaCti.tabulacaoErroSalvar';
                    });
            };

            $scope.cancelarTabulacao = function () {
                // libera mas mantém AtendimentoStatusId=2 (incompleta) — o agente pode voltar depois
                $scope.tabulacaoPendente = false;
                $scope.tabulacao = null;
                $scope.tab = 'discador';
            };

            $scope.backspace = function () {
                var n = $scope.discagem.numero || '';
                $scope.discagem.numero = n.substring(0, n.length - 1);
            };
            $scope.limparNumero = function () {
                $scope.discagem.numero = '';
            };

            // ===== RINGTONE =====
            function tocarRingtone(play) {
                var audio = document.getElementById('ctiRingAudio');
                if (!audio) return;
                if (play) {
                    try { audio.currentTime = 0; audio.play(); } catch (e) {}
                } else {
                    try { audio.pause(); } catch (e) {}
                }
            }

            // ===== SALESFORCE OPEN CTI (opcional) =====
            function carregarOpenCti() {
                if (!sfDomain) {
                    console.log('[CTI/SF] sfdomain não definido — Open CTI desativado');
                    return;
                }
                var url = 'https://' + sfDomain + '/support/api/63.0/lightning/opencti_min.js';
                console.log('[CTI/SF] carregando SDK:', url);
                var s = document.createElement('script');
                s.src = url;
                s.onload = function () {
                    sfReady = typeof $window.sforce !== 'undefined' &&
                              !!$window.sforce.opencti;
                    console.log('[CTI/SF] script onload. sforce.opencti existe?', sfReady);
                    if (sfReady) wireOpenCti();
                    else console.error('[CTI/SF] script carregou mas sforce.opencti não foi exposto');
                };
                s.onerror = function (ev) {
                    console.error('[CTI/SF] erro ao carregar SDK:', url, ev);
                };
                document.head.appendChild(s);
            }
            function wireOpenCti() {
                console.log('[CTI/SF] wireOpenCti()');
                try {
                    $window.sforce.opencti.enableClickToDial({
                        callback: function (result) {
                            console.log('[CTI/SF] enableClickToDial callback:', result);
                            if (result && result.success === false) {
                                console.error('[CTI/SF] enableClickToDial FALHOU:',
                                              result.errors || result.message);
                            }
                        }
                    });
                    $window.sforce.opencti.onClickToDial({
                        listener: function (payload) {
                            console.log('[CTI/SF] onClickToDial disparado:', payload);

                            // Abre a utility bar do discador pra o operador ver a chamada saindo
                            $window.sforce.opencti.setSoftphonePanelVisibility({
                                visible: true,
                                callback: function (resp) {
                                    console.log('[CTI/SF] setSoftphonePanelVisibility:', resp);
                                }
                            });

                            $scope.$applyAsync(function () {
                                $scope.discagem.numero = payload.number || '';
                                $scope.sfRecordId = payload.recordId || null;
                                // Garante que está na aba do Discador (não Tabulação/Histórico)
                                if ($scope.step === 'ready') $scope.tab = 'discador';
                                if ($scope.status.ramalLogado) $scope.discar();
                            });
                        }
                    });
                    $window.sforce.opencti.notifyInitializationComplete();
                    console.log('[CTI/SF] notifyInitializationComplete() chamado');
                } catch (e) {
                    console.error('[CTI/SF] exceção ao ligar Open CTI:', e);
                }
            }
            // Guarda contexto da última chamada gravada no Salesforce, pra
            // poder atualizar o mesmo Task quando o operador salvar a tabulação.
            var ultimoTaskInfo = null;

            // Quebra um telefone em DDD + número.
            // 11976798416 -> {ddd:'11', phone:'976798416'}
            // 5511976798416 -> remove o 55 (país), retorna {ddd:'11', ...}
            function parsePhone(numero) {
                var digits = String(numero || '').replace(/\D/g, '');
                if (digits.length > 11 && digits.indexOf('55') === 0) {
                    digits = digits.substring(2);
                }
                if (digits.length >= 10) {
                    return { ddd: digits.substring(0, 2), phone: digits.substring(2) };
                }
                return { ddd: '', phone: digits };
            }

            // Salesforce DateTime aceita ISO 8601 (UTC). new Date().toISOString() já dá o formato certo.
            function isoDateTime(ms) {
                return ms ? new Date(ms).toISOString() : null;
            }

            // Solicita ao backend um token assinado (HMAC) pra acessar o áudio da ligação.
            // Retorna uma URL temporária (Listen/{token}) ou null em caso de falha
            // (nesse caso, o saveLog segue sem CallUrl__c).
            function obterUrlGravacaoAssinada(globalId) {
                if (!globalId) return $q.resolve(null);
                var endpoint = Config.getUrl('Ligacao/AudioToken/' + encodeURIComponent(globalId));
                return $http.get(endpoint).then(function (resp) {
                    var token = resp && resp.data && resp.data.token;
                    if (!token) {
                        console.warn('[CTI/SF] backend retornou token vazio');
                        return null;
                    }
                    return Config.getUrl('Ligacao/Listen/' + encodeURIComponent(token));
                }).catch(function (err) {
                    console.warn('[CTI/SF] falha ao gerar token de áudio:', err);
                    return null;
                });
            }

            function salesforceSaveLog(chamada, duracao) {
                if (!sfReady || !$window.sforce || !$window.sforce.opencti) {
                    console.log('[CTI/SF] saveLog: SDK não disponível');
                    return;
                }
                if (!chamada) return;

                // Busca a URL assinada primeiro, depois faz o saveLog com ela.
                obterUrlGravacaoAssinada(chamada.GlobalId).then(function (urlGravacao) {
                    executarSaveLog(chamada, duracao, urlGravacao);
                });
            }

            function executarSaveLog(chamada, duracao, urlGravacao) {
                if (!sfReady || !$window.sforce || !$window.sforce.opencti) return;

                var recebida = chamada.Direcao === DIRECAO_CHAMADA_RECEBIDA;
                var numero   = chamada.Telefone || chamada.NB || chamada.NumeroDiscado || '';
                var ramal    = $scope.status.ramalNumero || '';
                var origem   = recebida ? numero : ramal;
                var destino  = recebida ? ramal  : numero;

                var pad2 = function (n) { return n < 10 ? '0' + n : '' + n; };
                var fmtData = function (ms) {
                    var d = new Date(ms);
                    return pad2(d.getDate()) + '/' + pad2(d.getMonth() + 1) + '/' +
                           d.getFullYear() + ' ' +
                           pad2(d.getHours()) + ':' + pad2(d.getMinutes()) + ':' + pad2(d.getSeconds());
                };

                var dataInicialMs = callStart || Date.now();
                var dataFinalMs   = Date.now();
                var dataInicial   = fmtData(dataInicialMs);
                var dataFinal     = fmtData(dataFinalMs);

                // Subject mantém só data + hora (sem segundos)
                var dataChamada = new Date(dataInicialMs);
                var dataFmt = pad2(dataChamada.getDate()) + '/' +
                              pad2(dataChamada.getMonth() + 1) + '/' +
                              dataChamada.getFullYear() + ' ' +
                              pad2(dataChamada.getHours()) + ':' +
                              pad2(dataChamada.getMinutes());
                var subject = 'Ligação TalkComm ' + dataFmt;

                var operador = $scope.status.userName || 'n/a';

                var descLinhas = [
                    'Registrado via EpbxManager CTI',
                    'Operador: '      + operador,
                    'Direção: '       + (recebida ? 'Recebida' : 'Efetuada'),
                    'Origem: '        + origem,
                    'Destino: '       + destino,
                    'Data inicial: '  + dataInicial,
                    'Data final: '    + dataFinal,
                    'Duração: '       + duracao + 's',
                    'GlobalId: '      + (chamada.GlobalId || 'n/a')
                ];
                if (chamada.Protocolo)      descLinhas.push('Protocolo: ' + chamada.Protocolo);
                if (chamada.CodigoCampanha) descLinhas.push('Campanha: '  + chamada.CodigoCampanha);
                if (chamada.NomeCliente)    descLinhas.push('Cliente: '   + chamada.NomeCliente);

                // URL da gravação (assinada via HMAC, expira no TTL configurado no backend).
                // Mesmo que o arquivo ainda esteja sendo processado, o link já é válido —
                // ao clicar, o backend faz o lookup. Se o arquivo ainda não existe, retorna 404.
                if (urlGravacao) {
                    descLinhas.push('');
                    descLinhas.push('🎧 Gravação: ' + urlGravacao);
                }

                var fields = {
                    entityApiName:         'Task',
                    Subject:               subject,
                    TaskSubtype:           'Call',
                    CallType:              recebida ? 'Inbound' : 'Outbound',
                    CallDurationInSeconds: duracao,
                    CallObject:            chamada.GlobalId || '',
                    Status:                'Completed',
                    Description:           descLinhas.join('\n'),
                    ActivityDate:          new Date(dataInicialMs).toISOString().slice(0, 10)
                };

                // ============================================================
                // Custom fields configurados no Salesforce (sufixo __c por ser padrão).
                // Helpers defensivos:
                //  - setStr: só seta o campo se o valor tiver conteúdo (evita "" em campos
                //    que poderiam ter validation rules), e força String pra evitar rejeição
                //    de campos Phone/Text que esperam string mas recebem number.
                //  - setNum: idem pra numéricos.
                // ============================================================
                var setStr = function (chave, valor) {
                    if (valor == null) return;
                    var s = String(valor).trim();
                    if (s.length === 0) return;
                    fields[chave] = s;
                };
                var setNum = function (chave, valor) {
                    if (valor == null) return;
                    var n = Number(valor);
                    if (isNaN(n)) return;
                    fields[chave] = n;
                };

                var fone     = parsePhone(numero);
                var user     = AuthService.getUsuarioLogado() || {};
                var nomeUra  = chamada.NomeUra || chamada.UraNome || '';
                var nomeFila = chamada.NomeCampanha || chamada.NomeFila || '';

                setStr('CallCustomerId__c',    chamada.CodigoCliente || chamada.Cpf || chamada.Cnpj);
                setStr('CallType__c',          recebida ? 'Recebida' : 'Efetuada');
                setStr('CallBranch__c',        $scope.status.ramalNumero);
                setStr('CallPhoneAreaCode__c', fone.ddd);
                setStr('CallPhone__c',         fone.phone);
                setStr('CallStartDate__c',     isoDateTime(dataInicialMs));
                setStr('CallEndDate__c',       isoDateTime(dataFinalMs));
                setNum('CallDuration__c',      duracao);
                setStr('CallId__c',            chamada.GlobalId);
                setStr('CallIVR__c',           nomeUra);
                setStr('CallQueue__c',         nomeFila);
                setStr('CallOrderNumber__c',   chamada.NumeroPedido);
                // CallCost (Moeda): não temos custo da ligação no front; admin pode preencher
                // posteriormente via backend/Apex se necessário.
                setStr('CallUrl__c',           urlGravacao);
                setStr('CallAgentName__c',     $scope.status.userName);
                setStr('CallAgentEmail__c',    user.Email || user.email);

                // Fonte da ligação — picklist no Task. Valor fixo "Telefone Fixo - Talkcomm".
                // Se o admin nomeou o campo diferente, trocar o nome aqui (ex.: CallFonte__c).
                setStr('CallSource__c',        'Telefone Fixo - Talkcomm');

                // CallCategory e CallObservation entram no update pós-tabulação.

                // Vincula ao registro que originou o click-to-dial (se houver)
                if ($scope.sfRecordId) {
                    var prefix = String($scope.sfRecordId).substring(0, 3);
                    if (prefix === '003' || prefix === '00Q') fields.WhoId  = $scope.sfRecordId;
                    else                                       fields.WhatId = $scope.sfRecordId;
                }

                console.log('[CTI/SF] saveLog payload:', fields);
                $window.sforce.opencti.saveLog({
                    value: fields,
                    callback: function (resp) {
                        console.log('[CTI/SF] saveLog resposta:', resp);
                        if (resp && resp.success) {
                            var taskId = resp.returnValue && (
                                resp.returnValue.recordId ||
                                (resp.returnValue.entity && resp.returnValue.entity.Id)
                            );
                            ultimoTaskInfo = {
                                taskId: taskId,
                                chamada: chamada,
                                duracao: duracao,
                                descBase: descLinhas
                            };
                            try { $window.sforce.opencti.refreshView(); } catch (e) {}
                            return;
                        }

                        // Erro: dumpar tudo de forma legível
                        console.warn('[CTI/SF] saveLog FALHOU. Resposta completa abaixo:');
                        console.warn(JSON.stringify(resp, null, 2));

                        // Extrai os fieldErrors pra mostrar destacado
                        var errs = (resp && resp.errors) || [];
                        for (var i = 0; i < errs.length; i++) {
                            var err = errs[i];
                            console.warn('[CTI/SF] erro[' + i + ']: code=' + err.code +
                                         ' description=' + err.description);
                            var fe = err.details && err.details.fieldErrors;
                            if (fe) {
                                for (var campo in fe) {
                                    console.warn('  → campo: ' + campo,
                                                 JSON.stringify(fe[campo]));
                                }
                            }
                            var pe = err.details && err.details.pageErrors;
                            if (pe && pe.length) {
                                console.warn('  → pageErrors:', JSON.stringify(pe));
                            }
                        }
                    }
                });
            }

            // Atualiza o Task no Salesforce com os dados da tabulação preenchida pelo agente.
            function salesforceAtualizarComTabulacao(tabulacao) {
                if (!ultimoTaskInfo || !ultimoTaskInfo.taskId) {
                    console.log('[CTI/SF] sem Task pra atualizar com tabulação');
                    return;
                }
                if (!sfReady || !$window.sforce || !$window.sforce.opencti) return;

                // Resolve descrições humanas das categorias/subcategorias (não só IDs)
                var catLabel = '';
                var subLabel = '';
                if ($scope.campos && $scope.campos[0] && $scope.campos[0].Categorias) {
                    var cat = $scope.campos[0].Categorias.find(function (c) {
                        return c.Id === tabulacao.CategoriaId;
                    });
                    catLabel = cat ? cat.Descricao : '';
                }
                if ($scope.campos && $scope.campos[1] && $scope.campos[1].Categorias) {
                    var sub = $scope.campos[1].Categorias.find(function (c) {
                        return c.Id === tabulacao.SubCategoriaId;
                    });
                    subLabel = sub ? sub.Descricao : '';
                }

                var extras = ['', '--- Tabulação ---'];
                if (catLabel)                  extras.push('Categoria: '    + catLabel);
                if (subLabel)                  extras.push('Subcategoria: ' + subLabel);
                if (tabulacao.CampoGenerico1)  extras.push('Campo 1: '      + tabulacao.CampoGenerico1);
                if (tabulacao.CampoGenerico2)  extras.push('Campo 2: '      + tabulacao.CampoGenerico2);
                if (tabulacao.Historico)       extras.push('Observação: '   + tabulacao.Historico);

                var descAtualizada = ultimoTaskInfo.descBase.concat(extras).join('\n');

                var payload = {
                    entityApiName: 'Task',
                    Id: ultimoTaskInfo.taskId,
                    Description: descAtualizada
                };
                // CallDisposition é o campo nativo do Task pra "resultado da chamada"
                if (catLabel) payload.CallDisposition = catLabel;

                // Custom fields da tabulação
                payload.CallCategory__c    = catLabel ||
                                             (subLabel ? subLabel : '') ||
                                             '';
                payload.CallObservation__c = tabulacao.Historico || '';

                console.log('[CTI/SF] saveLog tabulação payload:', payload);
                $window.sforce.opencti.saveLog({
                    value: payload,
                    callback: function (resp) {
                        console.log('[CTI/SF] saveLog tabulação resposta:', resp);
                        if (resp && resp.success) {
                            try { $window.sforce.opencti.refreshView(); } catch (e) {}
                        }
                    }
                });
            }

            // ===== CLEANUP =====
            function desconectar() {
                try { AtendimentoService.terminar(); } catch (e) {}
                try { SoftphoneService.desconectar(); } catch (e) {}
                if ($scope.registerTimer) $timeout.cancel($scope.registerTimer);
            }

            $scope.$on('$destroy', function () {
                desconectar();
                $window.removeEventListener('message', handleWebphoneMessage);
                $rootScope.hiddenLayout = false;
            });

            // ===== BOOTSTRAP =====
            if (sfDomain) carregarOpenCti();
            if (usuarioLogado) {
                iniciar();
            }
        }]);
})();

(function() {
	"use strict";

	angular.module("epbxManagerApp")

	// dependencias para o controller
	.service('DashboardConfiguracaoEditData', function DashboardConfiguracaoEditData() {
		return function() {
			return {
				deps: ["$ocLazyLoad", function($ocLazyLoad) {
					return $ocLazyLoad.load([
						'lazy_ionRangeSlider',
						'lazy_uiSelect'
					]);
				}],
				dashboard: ["DashboardResource", "$stateParams", function(DashboardResource, $stateParams) {
					if ($stateParams.DashboardConfiguracaoId) {
						return DashboardResource.get({
							DashboardConfiguracaoId: $stateParams.DashboardConfiguracaoId
						}).$promise;
					} else {
						return {};
					}
				}],
				visoes: ["DashboardVisaoResource", function(DashboardVisaoResource) {
					return DashboardVisaoResource.odata().orderBy("Descricao", "asc").query();
				}],
				fontes: ["DashboardFonteResource", function(DashboardFonteResource) {
					return DashboardFonteResource.odata().orderBy("Descricao", "asc").query();
				}],
				operadores: ["DashboardOperadorResource", function(DashboardOperadorResource) {
					return DashboardOperadorResource.odata().orderBy("Descricao", "asc").query();
				}],
				tipos: ["DashboardTipoResource", function(DashboardTipoResource) {
					return DashboardTipoResource.odata().orderBy("Descricao", "asc").query();
				}],
				filtroTipos: ["DashboardFiltroTipoResource", function(DashboardFiltroTipoResource) {
					return DashboardFiltroTipoResource.odata().orderBy("Descricao", "asc").query();
				}]
			}
		}
	})

	.controller("DashboardConfiguracaoEditController",
		["$scope", "$window", "$state", "$stateParams", "$filter", "dashboard", "visoes", "tipos", "filtroTipos", "fontes", "operadores", "DashboardResource", "DashboardFiltroResource", "NotifyService", function($scope, $window, $state, $stateParams, $filter, dashboard, visoes, tipos, filtroTipos, fontes, operadores, DashboardResource, 
			DashboardFiltroResource, NotifyService) {
			$scope.Novo = !(dashboard && dashboard.DashboardConfiguracaoId);
			$scope.dashboard = dashboard;
			$scope.visoes = visoes;
			$scope.tipos = tipos;
			$scope.fontes = fontes;
			$scope.operadores = operadores;
			$scope.filtroTipos = filtroTipos;
			$scope.visaoPadrao = $scope.dashboard.DashboardVisaoId;
			if ($scope.Novo && $stateParams.DashboardVisaoId)
				$scope.dashboard.DashboardVisaoId = $stateParams.DashboardVisaoId;
			if (!$scope.dashboard.DashboardFiltro) $scope.dashboard.DashboardFiltro = [];
			$scope.filtroEditado = {
				"Nome": 'a',
				"Alias": 'a',
				"Origem": 'a',
				"PropriedadeNome": 'a',
				"PropriedadeValor": 'a',
				"RegexPattern": 'a',
				"ValorPadrao": 'a'
			};
			$scope.indexFiltro = -1;
			$scope.exibirNovoFiltro = false;

			if ($scope.Novo) {
				$scope.dashboard.IntervaloEmSegundo = 60;
				$scope.dashboard.Ordem = 1;
			}

			tipos.forEach(function(el) {
				el.Descricao = ($filter('titlecase')(el.Descricao));
			});

			$scope.VisaoOptions = {
				dataSource: {
					data: visoes
				},
				optionLabel: "Selecione a Visão",
				dataTextField: "Descricao",
				dataValueField: "DashboardVisaoId",
				index: visoes.map(function(item) {
					return item.DashboardVisaoId;
				}).indexOf($scope.dashboard.DashboardVisaoId) + 1
			};

			$scope.FonteOptions = {
				dataSource: {
					data: fontes
				},
				optionLabel: "Selecione a Fonte",
				dataTextField: "Descricao",
				dataValueField: "DashboardFonteId",
				index: fontes.map(function(item) {
					return item.DashboardFonteId;
				}).indexOf($scope.dashboard.DashboardFonteId) + 1
			};

			$scope.TipoOptions = {
				dataSource: {
					data: tipos
				},
				optionLabel: "Selecione o Tipo",
				dataTextField: "Descricao",
				dataValueField: "DashboardTipoId",
				index: tipos.map(function(item) {
					return item.DashboardTipoId;
				}).indexOf($scope.dashboard.DashboardTipoId) + 1
			};

			$scope.OperadorOptions = {
				dataSource: {
					data: operadores
				},
				optionLabel: "Selecione o Operador",
				dataTextField: "Descricao",
				dataValueField: "DashboardOperadorId",
				index: operadores.map(function(item) {
					return item.DashboardOperadorId;
				}).indexOf($scope.dashboard.DashboardOperadorId) + 1
			};

			$scope.verboArr = [{
				Descricao: 'Get',
				Nome: 'Get'
			}, {
				Descricao: 'Post',
				Nome: 'Post'
			}, {
				Descricao: 'Put',
				Nome: 'Put'
			}, {
				Descricao: 'Delete',
				Nome: 'Delete'
			}]
			$scope.VerboOptions = {
				dataSource: {
					data: $scope.verboArr
				},
				optionLabel: "Selecione",
				dataTextField: "Descricao",
				dataValueField: "Nome",
				index: $scope.verboArr.map(function(item) {
					return item.Nome;
				}).indexOf($scope.dashboard.Verbo) + 1
			};
			$scope.tamanhoGridArr = [{
				Descricao: '25%',
				Nome: '1-4'
			}, {
				Descricao: '33%',
				Nome: '1-3'
			}, {
				Descricao: '50%',
				Nome: '1-2'
			}, {
				Descricao: '66%',
				Nome: '2-3'
			}, {
				Descricao: '100%',
				Nome: '1-1'
			}];
			$scope.TamanhoGridOptions = {
				dataSource: {
					data: $scope.tamanhoGridArr
				},
				optionLabel: "Selecione",
				dataTextField: "Descricao",
				dataValueField: "Nome",
				index: $scope.tamanhoGridArr.map(function(item) {
					return item.Nome;
				}).indexOf($scope.dashboard.TamanhoGrid) + 1
			};

			let mensagemSucesso = function(result) {
				NotifyService.showSuccess();
				if (!$scope.editandoFiltro) {
					$scope.dashboard = result;
					if ($stateParams.page)
						$state.go($stateParams.page, {
							DashboardVisaoId: $scope.dashboard.DashboardVisaoId
						});
					else
						$state.go('main.dashboardconfiguracoes.list');

				} else {
					$scope.editandoFiltro = false;
				}

			};

			$scope.salvar = function salvar(valid) {
				if (!valid) {
					NotifyService.showInvalid();
					return;
				}

				let promise;
				if ($scope.dashboard.DashboardConfiguracaoId > 0)
					promise = DashboardResource.update($scope.dashboard).$promise;
				else {
					promise = DashboardResource.save($scope.dashboard).$promise;
				}

				promise.then(mensagemSucesso).catch(NotifyService.showError);
			};

			$scope.voltar = function() {
				if ($stateParams.page)
					$state.go($stateParams.page, {
						DashboardVisaoId: $scope.visaoPadrao
					});
				else
					$state.go('main.dashboardconfiguracoes.list');
			};

			$scope.novoFiltro = function(filtro) {
				filtro = {};
				$scope.erroFiltroNome = false;
				$scope.erroFiltroAlias = false;
				$scope.erroFiltroTipo = false;

				$scope.filtroEditado = {
					DashboardConfiguracaoId: $scope.dashboard.DashboardConfiguracaoId
				};
				_.each($scope.dashboard.DashboardFiltro, function(el) {
					el.Editando = false;
				});
				$scope.exibirNovoFiltro = true;
				angular.extend($scope.filtroEditado, filtro);

				let combo = $('#filtroTipoDropdown').kendoDropDownList({
					optionLabel: "Selecione o Tipo",
					dataTextField: "Descricao",
					dataValueField: "DashboardFiltroTipoId",
					dataSource: {
						data: filtroTipos
					},
					index: filtroTipos.map(function(item) {
						return item.DashboardFiltroTipoId;
					}).indexOf($scope.filtroEditado.DashboardFiltroTipoId) + 1,
				}).data('kendoDropDownList');

				const modal = UIkit.modal("#modal_filtro");
				modal.show();
			};

			$scope.voltarFiltro = function(filtro) {
				$scope.filtroEditado = {};
				if (filtro)
					filtro.Editando = false;
				else
					$scope.exibirNovoFiltro = false;

				const modal = UIkit.modal("#modal_filtro");
				modal.hide();
			};

			$scope.editarFiltro = function(filtro) {
				$scope.exibirNovoFiltro = false;
				$scope.erroFiltroNome = false;
				$scope.erroFiltroAlias = false;
				$scope.erroFiltroTipo = false;
				$scope.indexFiltro = filtro.DashboardFiltroId;

				_.each($scope.dashboard.DashboardFiltro, function(el) {
					if (filtro == el) el.Editando = !el.Editando;
					else el.Editando = false;
				});
				angular.extend($scope.filtroEditado, filtro);

				let combo = $('#filtroTipoDropdown').kendoDropDownList({
					optionLabel: "Selecione o Tipo",
					dataTextField: "Descricao",
					dataValueField: "DashboardFiltroTipoId",
					dataSource: {
						data: filtroTipos
					},
					change: function(a, b, c) {
						$scope.filtroEditado.DashboardFiltroTipoId = this.value();
					},
					index: filtroTipos.map(function(item) {
						return item.DashboardFiltroTipoId;
					}).indexOf($scope.filtroEditado.DashboardFiltroTipoId) + 1,
				}).data('kendoDropDownList');

				const modal = UIkit.modal("#modal_filtro");
				modal.show();
			};

			$scope.deletarFiltro = function(filtro) {
				$window.UIkit.modal.confirm("Deseja realmente excluir? Esta alteração não poderá ser desfeita.", function() {
					deleteRecord(filtro);
				});

				let deleteRecord = function(data) {
					if (!data.DashboardFiltroId) {
						$scope.dashboard.DashboardFiltro = _.without($scope.dashboard.DashboardFiltro, data);
						return;
					} else {
						return DashboardFiltroResource.delete({
								DashboardFiltroId: data.DashboardFiltroId
							}).$promise
							.then(function() {
								NotifyService.showSuccess();
								$scope.dashboard.DashboardFiltro = _.without($scope.dashboard.DashboardFiltro, data);
							})
							.catch(NotifyService.showError);
					}
				};
			};

			$scope.salvarFiltro = function() {
				$scope.editandoFiltro = true;
				$scope.erroFiltroNome = false;
				$scope.erroFiltroAlias = false;
				$scope.erroFiltroTipo = false;

				if (!$scope.filtroEditado.Alias)
					$scope.erroFiltroAlias = true;

				if (!$scope.filtroEditado.Nome)
					$scope.erroFiltroNome = true;

				if (!$scope.filtroEditado.DashboardFiltroTipoId)
					$scope.erroFiltroTipo = true;

				if ($scope.erroFiltroNome || $scope.erroFiltroAlias || $scope.erroFiltroTipo) return;

				let filtro = null;

				if ($scope.filtroEditado.DashboardConfiguracaoId) {
					filtro = _.filter($scope.dashboard.DashboardFiltro, function(el) {
						return el.DashboardFiltroId == $scope.indexFiltro;
					})[0];
					let promise;
					if ($scope.filtroEditado.DashboardFiltroId > 0) {
						promise = DashboardFiltroResource.update($scope.filtroEditado).$promise;
					} else {
						promise = DashboardFiltroResource.save($scope.filtroEditado).$promise;
					}

					let sucesso = function(result) {
						if (!$scope.exibirNovoFiltro) {
							angular.extend(filtro, result);
							filtro.Editando = false;
						} else {
							$scope.dashboard.DashboardFiltro.push(result);
						}
						$scope.exibirNovoFiltro = false;
						mensagemSucesso(result);

						const modal = UIkit.modal("#modal_filtro");
						modal.hide();
					}

					promise.then(sucesso).catch(NotifyService.showError);
				} else {
					let tipo = _.find(filtroTipos, function(el) {
						return el.DashboardFiltroTipoId == $scope.filtroEditado.DashboardFiltroTipoId
					});
					$scope.filtroEditado.DashboardFiltroTipo = tipo;
					if ($scope.exibirNovoFiltro) {
						filtro = {};
						angular.extend(filtro, $scope.filtroEditado);
						$scope.dashboard.DashboardFiltro.push(filtro);
						$scope.exibirNovoFiltro = false;
					} else {
						$scope.filtroEditado.Editando = false;
						angular.extend(filtro, $scope.filtroEditado);
					}
				}
			};
		}]
	);

})();

(function () {
    "use strict";

    var getOdataSearchSharedVisao = function (DashboardVisaoResource, search, orderBy, $odata) {
        var odata = DashboardVisaoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }

        angular.forEach(search, function (value, key) {
            if (key !== "pageSize" && key !== "Descricao")
                odata.filter(key, value);
        });

        return odata;
    };

    var getOdataSearchSharedDashboard = function (DashboardResource, search, orderBy, $odata, utils) {
        utils.resetFilters(search, ['DashboardVisaoId', 'DashboardTipoId']);
        var odata = DashboardResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Titulo) {
            odata.filter(new $odata.Func("startswith", "Titulo", search.Titulo), true);
        }

        angular.forEach(search, function (value, key) {
            if (key !== "pageSize" && key !== "Titulo")
                odata.filter(key, value);
        });

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("main.dashboardconfiguracoes", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true
                })
                .state("main.dashboardconfiguracoes.list", {
                    url: "/dashboardconfiguracoes",
                    templateUrl: 'app/pages/dashboard/list.html',
                    controller: 'DashboardConfiguracaoListController',
                    resolve: $stateProvider.dataResolver("DashboardConfiguracao", "List"),
                    data: {
                        pageTitle: 'pageTitle.configuracoesDeDashboard',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.dashboardconfiguracoes.new", {
                    url: "/dashboardconfiguracoes/new/{DashboardVisaoId:.*}?page",
                    templateUrl: 'app/pages/dashboard/edit.html',
                    controller: 'DashboardConfiguracaoEditController',
                    resolve: $stateProvider.dataResolver("DashboardConfiguracao", "Edit"),
                    data: {
                        pageTitle: 'pageTitle.configuracoesDeDashboard',
                        pageName: 'acoes.cadastrar'
                    }
                })
                .state("main.dashboardconfiguracoes.edit", {
                    url: "/dashboardconfiguracoes/{DashboardConfiguracaoId:[0-9]+}?page",
                    templateUrl: 'app/pages/dashboard/edit.html',
                    controller: 'DashboardConfiguracaoEditController',
                    resolve: $stateProvider.dataResolver("DashboardConfiguracao", "Edit"),
                    data: {
                        pageTitle: 'pageTitle.configuracoesDeDashboard',
                        pageName: 'acoes.editar'
                    }
                })
        }])

        .service("DashboardConfiguracaoListData", function DashboardConfiguracaoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    dashboards: ["DashboardResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (DashboardResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroDashboard");

                        var orderBy = {
                            column: "DashboardConfiguracaoId",
                            order: "asc"
                        };

                        var odata = getOdataSearchSharedDashboard(DashboardResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    visoes: ["DashboardVisaoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (DashboardVisaoResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroVisao");

                        var orderBy = {
                            column: "DashboardVisaoId",
                            order: "asc"
                        };

                        var odata = getOdataSearchSharedVisao(DashboardVisaoResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    tipos: ["DashboardTipoResource", function (DashboardTipoResource) {
                        return DashboardTipoResource.odata().orderBy("Descricao", "asc").query();
                    }]
                }
            }
        })

        .controller("DashboardConfiguracaoListController",
            ["$scope", "$window", "$odata", "$filter", "dashboards", "visoes", "tipos", "DashboardResource", "DashboardVisaoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", function ($scope, $window, $odata, $filter, dashboards, visoes, tipos, DashboardResource, DashboardVisaoResource, utils, LocalStorageService,
                $stateParams, NotifyService, $state) {
                $scope.dashboards = dashboards;
                $scope.visoes = visoes;
                $scope.tipos = tipos;
                $scope.searchDashboard = $stateParams.storage ? LocalStorageService.getItem("FiltroDashboard") : {};
                $scope.searchVisao = $stateParams.storage ? LocalStorageService.getItem("FiltroVisao") : {};
                $scope.orderByVisao = {
                    column: "DashboardVisaoId",
                    order: "asc"
                };
                $scope.orderByDashboard = {
                    column: "DashboardConfiguracaoId",
                    order: "asc"
                };

                tipos.forEach(function (el) {
                    el.Descricao = ($filter('titlecase')(el.Descricao));
                });

                $scope.VisaoOptions = {
                    dataSource: {
                        data: visoes
                    },
                    dataTextField: "Descricao",
                    dataValueField: "DashboardVisaoId",
                    optionLabel: "Todos",
                };

                $scope.TipoOptions = {
                    dataSource: {
                        data: tipos
                    },
                    optionLabel: "Todos",
                    dataTextField: "Descricao",
                    dataValueField: "DashboardTipoId"
                };

                var updateListVisao = function (list) {
                    $scope.visoes = list;
                    $scope.visoes.recordCount = list.$recordCount || list.length;
                    $scope.currentPageVisao = list.$currentPage || 1;
                    $scope.visoes.pageSize = list.$pageSize || 10;
                };

                var updateListDashboard = function (list) {
                    $scope.dashboards = list;
                    $scope.dashboards.recordCount = list.$recordCount || list.length;
                    $scope.currentPageDashboard = list.$currentPage || 1;
                    $scope.dashboards.pageSize = list.$pageSize || 10;
                };

                var getOdataSearchVisao = function getOdataSearchVisao() {
                    return getOdataSearchSharedVisao(DashboardVisaoResource, $scope.searchVisao, $scope.orderByVisao, $odata, utils);
                };

                var getOdataSearchDashboard = function getOdataSearchDashboard() {
                    return getOdataSearchSharedDashboard(DashboardResource, $scope.searchDashboard, $scope.orderByDashboard, $odata, utils);
                };

                $scope.executeSearchVisao = function executeSearchVisao() {
                    LocalStorageService.setItem('FiltroVisao', $scope.searchVisao);
                    getOdataSearchVisao()
                        .page($scope.searchVisao.pageSize, 1)
                        .query().then(updateListVisao).catch(NotifyService.showError);
                };

                $scope.executeSearchDashboard = function executeSearchDashboard() {
                    LocalStorageService.setItem('FiltroDashboard', $scope.searchDashboard);
                    getOdataSearchDashboard()
                        .page($scope.searchDashboard.pageSize, 1)
                        .query().then(updateListDashboard).catch(NotifyService.showError);
                };

                var deleteRecordVisao = function (data) {
                    return DashboardVisaoResource.delete({
                            DashboardVisaoId: data.DashboardVisaoId
                        }).$promise
                        .then(function () {
                            NotifyService.showSuccess();
                            if ($scope.Novo)
                            $scope.dashboard = {};                            
                            $scope.submitted = false;
                            $scope.pageChangedVisao($scope.currentPageVisao)
                        })
                        .catch(NotifyService.showError);
                };

                var deleteRecordDashboard = function (data) {
                    return DashboardResource.delete({
                            DashboardConfiguracaoId: data.DashboardConfiguracaoId
                        }).$promise
                        .then(function () {
                            NotifyService.showSuccess();
                            $scope.dashboard = {};                            
                            $scope.submitted = false;
                            $scope.pageChangedDashboard($scope.currentPageDashboard)
                        })
                        .catch(NotifyService.showError);
                };

                $scope.confirmDeleteVisao = function confirmDeleteVisao(data) {
                    $window.UIkit.modal.confirm("Deseja realmente excluir? Esta alteração não poderá ser desfeita.", function () {
                        deleteRecordVisao(data);
                    });
                };

                $scope.confirmDeleteDashboard = function confirmDeleteDashboard(data) {
                    $window.UIkit.modal.confirm("Deseja realmente excluir? Esta alteração não poderá ser desfeita.", function () {
                        deleteRecordDashboard(data);
                    });
                };

                $scope.pageChangedVisao = function (newPage) {
                    return getOdataSearchVisao()
                        .page($scope.visoes.pageSize, newPage)
                        .query().then(updateListVisao).catch(NotifyService.showError);
                };

                $scope.pageChangedDashboard = function (newPage) {
                    return getOdataSearchDashboard()
                        .page($scope.dashboards.pageSize, newPage)
                        .query().then(updateListDashboard).catch(NotifyService.showError);
                };

                updateListVisao(visoes);
                updateListDashboard(dashboards);

                $scope.limparFiltroVisao = function () {
                    LocalStorageService.removeItem('FiltroVisao');
                    $scope.searchVisao = {
                        pageSize: 10
                    };
                };

                $scope.limparFiltroDashboard = function () {
                    LocalStorageService.removeItem('FiltroDashboard');
                    $scope.searchDashboard = {
                        pageSize: 10
                    };
                };

                $scope.voltar = function () {
                    if ($stateParams.page)
                        $state.go($stateParams.page, {
                            storage: true
                        });
                    else
                        $state.go('main.dashboard.list', {
                            storage: true
                        });
                };
            }]
        );

})();
(function() {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("DashboardResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"Dashboard/:DashboardConfiguracaoId", {
					"DashboardConfiguracaoId": "@DashboardConfiguracaoId"
				}, {
					graficos: {
						url: "Dashboard/Graficos",
						method: "GET",
						isArray: true
					},
					grafico: {
						url: "Dashboard/Grafico",
						method: "GET",
						isArray: false
					},
					filtrarGrafico: {
						url: "Dashboard/FiltrarGrafico",
						method: "POST",
						isArray: false
					},
					filtrarVisao: {
						url: "Dashboard/FiltrarGrafico",
						method: "POST",
						isArray: true
					},
					detalhado: {
						url: "Dashboard/Detalhado",
						method: "POST",
						isArray: true
					}
				});
		}])
		.factory("DashboardVisaoResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"DashboardVisao/:DashboardVisaoId", {
					"DashboardVisaoId": "@DashboardVisaoId"
				});
		}])
		.factory("DashboardOperadorResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"DashboardOperador/:DashboardOperadorId", {
					"DashboardOperadorId": "@DashboardOperadorId"
				});
		}])
		.factory("DashboardTipoResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"DashboardTipo/:DashboardTipoId", {
					"DashboardTipoId": "@DashboardTipoId"
				});
		}])
		.factory("DashboardFiltroResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"DashboardFiltro/:DashboardFiltroId", {
					"DashboardFiltroId": "@DashboardFiltroId"
				});
		}])
		.factory("DashboardFiltroTipoResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"DashboardFiltroTipo/:DashboardFiltroTipoId", {
					"DashboardFiltroTipoId": "@DashboardFiltroTipoId"
				});
		}])
		.factory("DashboardFonteResource", ["$odataresource", function($odataresource) {
			return $odataresource(
				"DashboardFonte/:DashboardFonteId", {
					"DashboardFonteId": "@DashboardFonteId"
				});
		}]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .config(["$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("main.dashboard", {
                    url: "/dashboard/:VisaoId",
                    templateUrl: 'app/pages/dashboard/view.html',
                    controller: 'DashboardViewController',
                    resolve: $stateProvider.dataResolver("Dashboard", "View"),
                    data: {
                        proxy: 'main.dashboard',
                        pageTitle: 'Dashboard',
                        permissions: {
                            //AllowAll: true,
                            Dashboard: "Visualizar"
                        }
                    }
                })
        }])

        .service("DashboardViewData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_charts_c3',
                            'lazy_charts_peity',
                            'lazy_countUp',
                        ]);
                    }],
                    graficos: ["DashboardResource", "$stateParams", function (DashboardResource, $stateParams) {
                        var visaoId = $stateParams.VisaoId;
                        return DashboardResource.graficos({
                            VisaoId: parseInt(visaoId)
                        }).$promise;
                    }],
                    visao: ["DashboardVisaoResource", "$stateParams", function (DashboardVisaoResource, $stateParams) {
                        var visaoId = $stateParams.VisaoId;
                        return DashboardVisaoResource.get({
                            DashboardVisaoId: parseInt(visaoId)
                        }).$promise;
                    }]
                }
            }
        })

        .controller('DashboardViewController',
            ["$scope", "$timeout", "$window", "$stateParams", "graficos", "visao", "DashboardResource", function ($scope, $timeout, $window, $stateParams, graficos, visao, DashboardResource) {
                var visaoId = $stateParams.VisaoId || graficos[0].visaoId;
                $scope.visao = visao;
                $scope.filtros = {};
                $scope.filtrandoVisao = false;


                $scope.visao.DashboardFiltro.forEach(function (el) {
                    if (el.ValorPadrao == 'true')
                        $scope.filtros[el.Nome] = true;
                    else if (el.DashboardFiltroTipo.Descricao == 'Date')
                        $scope.filtros[el.Nome] = el.ValorPadrao;
                    else if (el.DashboardFiltroTipo.Descricao != undefined)
                        $scope.filtros[el.Nome] = el.ValorPadrao;
                    else
                        $scope.filtros[el.Nome] = '';
                });

                graficos = _.reject(graficos, function (el) {
                    return el.chartId == 0 || el.visaoId != visaoId;
                });
                $scope.VisaoNome = $scope.visao.Descricao;
                $scope.graficos = graficos;

                $scope.$on("onDashboardChanged", function (event, res) {
                    if (res.visaoId == visaoId) {
                        var index = _.findIndex($scope.graficos, function (el) {
                            return el.chartId == res.chartId;
                        });
                        if (index == -1) {
                            $scope.graficos.push(res);
                        } else {
                            res.data.unload = _.difference($scope.graficos[index].data.keys.value, res.data.keys.value);
                            if ($scope.graficos[index].filtrando == res.filtrando)
                                $scope.graficos[index] = res;
                        }
                    }
                });

                $scope.filtrarVisao = function () {
                    var filtroData = {
                        visaoId: $scope.visao.DashboardVisaoId,
                        filtros: $scope.filtros
                    };

                    var filtrando = false;
                    for (var propt in $scope.filtros) {
                        if (!filtrando)
                            filtrando = $scope.filtros[propt] != null && $scope.filtros[propt] != '' && (typeof $scope.filtros[propt] == 'string' && $scope.filtros[propt].toLowerCase() != 'false');
                    }
                    $scope.graficos.forEach(function (el) {
                        el.filtrando = filtrando;
                    });

                    $scope.filtrandoVisao = true;

                    DashboardResource.filtrarVisao(filtroData).$promise
                        .then(function (data) {
                            data.forEach(function (res) {
                                var index = _.findIndex($scope.graficos, function (el) {
                                    return el.chartId == res.chartId;
                                });
                                $scope.graficos[index] = res;
                                $scope.graficos[index].filtrando = filtrando;
                                $scope.filtrandoVisao = false;
                            });
                        });
                }

            }]
        );
})
();
(function() {
	"use strict";

	angular.module('epbxManagerApp')

	// dependencias para o controller
	.service('DashboardVisaoEditData', function DashboardVisaoEditData() {
		return function() {
			return {
				deps: ["$ocLazyLoad", function($ocLazyLoad) {
					return $ocLazyLoad.load([
						'lazy_dragula'
					]);
				}],
				visao: ["DashboardVisaoResource", "$stateParams", function(DashboardVisaoResource, $stateParams) {
					if ($stateParams.DashboardVisaoId) {
						return DashboardVisaoResource.get({
							DashboardVisaoId: $stateParams.DashboardVisaoId
						}).$promise;
					} else {
						return {};
					}
				}],
				graficos: ["DashboardResource", "$stateParams", function(DashboardResource, $stateParams) {
					if ($stateParams.DashboardVisaoId)
						return DashboardResource.odata().filter('DashboardVisaoId', parseInt($stateParams.DashboardVisaoId)).orderBy("Ordem", "asc").query();
					else {
						return {};
					}
				}]
			}
		}
	})

	.controller("DashboardVisaoEditController",
		["$scope", "$window", "$state", "visao", "graficos", "DashboardVisaoResource", "DashboardResource", "NotifyService", function DashboardVisaoEditController($scope, $window, $state, visao, graficos, DashboardVisaoResource, DashboardResource, NotifyService) {
			$scope.Novo = !(visao && visao.DashboardVisaoId);
			$scope.visao = visao;
			$scope.graficos = graficos;

			$scope.updateListGrafico = function() {
				var query = DashboardResource.odata().filter('DashboardVisaoId', parseInt($scope.visao.DashboardVisaoId)).orderBy("Ordem", "asc").query();
				return query.then(function(response) {
					$scope.graficos = response;
				}).catch(NotifyService.showError);
			};

			var showSuccess = function(visao) {
				NotifyService.showSuccess();
				if (visao)
					$scope.visao = visao;
				$scope.Novo = !($scope.visao && $scope.visao.DashboardVisaoId);

				$scope.updateListGrafico();
			};


			var deleteRecordDashboard = function(data) {
				return DashboardResource.delete({
						DashboardConfiguracaoId: data.DashboardConfiguracaoId
					}).$promise
					.then(function() {
						showSuccess();
						$scope.updateListGrafico();
					})
					.catch(NotifyService.showError);
			};

			$scope.confirmDeleteDashboard = function confirmDeleteDashboard(data) {
				$window.UIkit.modal.confirm("Deseja realmente excluir? Esta alteração não poderá ser desfeita.", function() {
					deleteRecordDashboard(data);
				});
			};

			$scope.salvar = function salvar(valid) {
				if (!valid) {
					NotifyService.showInvalid();
					return;
				}

				var promise;
				if ($scope.visao.DashboardVisaoId > 0)
					promise = DashboardVisaoResource.update($scope.visao).$promise;
				else {
					promise = DashboardVisaoResource.save($scope.visao).$promise;
				}

				promise.then(showSuccess).catch(NotifyService.showError);
			};

			$scope.voltar = function() {
				$state.go('main.dashboardconfiguracoes.list');
			};

		}]
	);

})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.dashboardexterna.edit", StateResolverProvider.configState("/dashboardexterna/{Id:[0-9]+}", "DashboardExterna", "Edit", {
					pageTitle: 'pageTitle.dashboardExterna',
					pageName: 'acoes.editar',
				}))
				.state("main.dashboardexterna.new", StateResolverProvider.configState("/dashboardexterna/new", "DashboardExterna", "Edit", {
					pageTitle: 'pageTitle.dashboardExterna',
					pageName: 'acoes.cadastrar',
				}));
		}])

		.service('DashboardExternaEditData', function DashboardExternaEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_uiSelect',
							'lazy_dropify'
						]);
					}],
					dashboardExterna: ["DashboardExternaResource", "$stateParams", function (DashboardExternaResource, $stateParams) {
                        if ($stateParams.Id) {
                            return DashboardExternaResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("DashboardExternaEditController", ["$scope", "NotifyService", "carteiras", "dashboardExterna", "DashboardExternaResource", "$state", "$translate", function ($scope, NotifyService,  carteiras, dashboardExterna, DashboardExternaResource, $state, $translate) {			
			$scope.dashboardExterna = dashboardExterna;
			$scope.isNew = (dashboardExterna.Id > 0 ? false : true);
			$scope.inserirOuEditar = !$scope.isNew ? $translate.instant('telaCadastroDashboardExterna.editarDashboardExterna') :
			$translate.instant('telaCadastroDashboardExterna.novaDashboardExterna');
			
            $scope.carteiras = carteiras;


			$scope.salvar = function () {

				var data = {
                    Id: $scope.dashboardExterna.Id,
                    CarteiraId: $scope.dashboardExterna.CarteiraId,                    
                    Descricao: $scope.dashboardExterna.Descricao,
                    Url: $scope.dashboardExterna.URL, 					
                };

                var promise;
                if ($scope.dashboardExterna.Id > 0) {
                    promise = DashboardExternaResource.update(data.Id, data).$promise;
                }
                else {
                    promise = DashboardExternaResource.save(data).$promise;
                }

                promise
				.then(() => {
                    NotifyService.showSuccess();
                    $state.go('main.dashboardexterna.list');
                })
                .catch(NotifyService.showError);
            };

			$scope.voltar = function () {
				$state.go('main.dashboardexterna.list');
			};
		}]);
})();
(function () {
	"use strict";

	var getOdataSearchShared = function (DashboardExternaResource, search, orderBy, $odata) {
        var odata = DashboardExternaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }

        if (search.CarteiraId) {
            odata.filter('CarteiraId', search.CarteiraId);        }


        return odata;
    };

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.dashboardexterna", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.dashboardexterna.list',
						pageTitle: 'pageTitle.dashboardExterna',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.dashboardexterna.list", StateResolverProvider.configState("/dashboardExterna", "DashboardExterna", "List", {
					pageTitle: 'pageTitle.dashboardExterna',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("DashboardExternaListData", function ServicoListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
					dashboardExterna: ["DashboardExternaResource", "LocalStorageService", "$odata", "$stateParams", function (DashboardExternaResource, LocalStorageService, $odata, $stateParams) {
						var filtro = {};
	
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroDashboardExterna");
						}
	
						var orderBy = {
							column: "Descricao",
							order: "desc"
						};
	
						return getOdataSearchShared(DashboardExternaResource, filtro, orderBy, $odata).page(10, 1).query();
					}],
				}
			}
		})

		.controller("DashboardExternaListController", ["$scope", "carteiras", "dashboardExterna", "DashboardExternaResource", "LocalStorageService", "$odata", "NotifyService", "ModalService", function ($scope, carteiras, dashboardExterna, DashboardExternaResource, LocalStorageService ,$odata, NotifyService
					,ModalService ) {
			
			$scope.carteiras = carteiras;
			$scope.search =
			{
				Descricao: '',
				CarteiraId: 0
			};
	
			$scope.orderBy = {
				column: "Descricao",
				order: "desc"
			};

			$scope.dashboardExternaList = dashboardExterna;

			var updateList = function (list) {
				$scope.dashboardExternaList = list;
				$scope.dashboardExternaList.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.dashboardExternaList.pageSize = list.$pageSize || 10;
			};
	
			var getOdataSearch = function () {
				return getOdataSearchShared(DashboardExternaResource, $scope.search, $scope.orderBy, $odata);
			};
	
			$scope.pageChanged = function (newPage) {
				return getOdataSearch()
					.page($scope.dashboardExternaList.pageSize, newPage)
					.query().then(updateList).catch(NotifyService.showError);
			};
	
			$scope.executeSearch = function () {
				LocalStorageService.setItem('FiltroDashboardExterna', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};
	
			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroDashboardExterna');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};
	
			var deleteDash = function (data) {
				return DashboardExternaResource.delete({ Id: data.Id }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.executeSearch();
					})
					.catch(NotifyService.showError);
			};
	
			$scope.confirmDelete = function (data) {
				ModalService.confirmMessage('telaDashboardExterna.confirmDeleteDashboardExterna', null, () => deleteDash(data));
			};
		}]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("DashboardExternaResource", ["$odataresource", function ($odataresource) {
			return $odataresource("DashboardExterna/:DashboardExternaId",  { "Id": "@Id" });
		}]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ClienteContatoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("ClienteContato/:ClienteContatoId",
                {
                    "ClienteContatoId": "@ClienteContatoId"
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.default", StateResolverProvider.configAbstract())
                .state("main.default.list", StateResolverProvider.configState("/", "default", "List", {
                    pageTitle: 'Home Page',
                    css: true,
                    permissions: {
                        AllowAll: true
                    }
                }))
        }])

        .service("defaultListData", function DefaultListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_countUp',
                            'lazy_moment'
                        ]);
                    }],
                    contatoList: ["ClienteContatoResource", function (ClienteContatoResource) {
                        return ClienteContatoResource.odata().query();
                    }],
                    objValido: ["SistemaValidacaoResource", "LocalStorageService", function (SistemaValidacaoResource, LocalStorageService) {
                        if (LocalStorageService.getItem('SetupRealizado') == true)
                            return {
                                Valido: true
                            };
                        return SistemaValidacaoResource.getCheck();
                    }]
                }
            }
        })
        .controller("defaultListController", ["$scope", "$window", "contatoList", "LocalStorageService", "DefaultResource", "objValido", "$state", "$rootScope", "NotifyService", "ModalService", "$translate", "$timeout", "MonitoriaMaquinaResource", "TranslateService", function ($scope, $window, contatoList, LocalStorageService, DefaultResource, objValido, $state,
            $rootScope, NotifyService, ModalService, $translate, $timeout, MonitoriaMaquinaResource, TranslateService) {

            // Intervalo de revalidacao do erro de monitoria das maquinas (1 min)
            const TEMPO_REVALIDACAO_MS = 60000;
            // Espera antes do reload apos solicitar processamento de monitoria (10s)
            const ESPERA_RELOAD_MS = 10000;

            let timerValidacaoData = null;
            let timerReload = null;

            $scope.listVideos = [
                { Id: 1, Nome: 'Treinamento Epbx Manager - Aula 1 - Criando uma URA', Descricao: 'Epbx Manager', Url: 'https://www.youtube.com/embed/OnrZo_L-qYg?list=PL6zUsoAgrxWgAyR1F-x95H4tRnEO_s_n9' },
                { Id: 2, Nome: 'Treinamento Epbx Manager - Aula 2 - Criando um Ramal', Descricao: 'Epbx Manager', Url: 'https://www.youtube.com/embed/nQCtslIzmc4?list=PL6zUsoAgrxWgAyR1F-x95H4tRnEO_s_n9' }
            ];

            $scope.discoList = [];
            $scope.processoList = [];
            $scope.contatoList = contatoList;
            $scope.servidorList = [];
            // Antes: chamava localStorage.getItem 2x e comparava string com booleano.
            $scope.processadaMonitoria = LocalStorageService.getItem('monitoria_processada') === 'true';

            $scope.epc_orders = {
                barColor: '#009688',
                scaleColor: false,
                trackColor: '#f5f5f5',
                lineWidth: 5,
                size: 110,
            };

            if (!objValido.Valido) {
                return $state.go('setup.view', { setup: true });
            } else {
                LocalStorageService.setItem('SetupRealizado', true);
                $rootScope.topMenuActive = false;
            }

            DefaultResource.odata().query()
                .then((data) => {
                    $scope.servidorList = data || [];
                    if ($scope.servidorList.length) {
                        LocalStorageService.removeItem('monitoria_processada');
                    }
                    validaErroAtualizacao();
                })
                .catch(NotifyService.showError);

            function validaErroAtualizacao() {
                if (!$scope.servidorList || $scope.servidorList.length === 0) return;

                const maquinasId = $scope.servidorList.map(m => m.MonitoriaMaquinaId);

                MonitoriaMaquinaResource.getErroAtualizacao({ maquinasId: maquinasId }).$promise
                    .then((data) => {
                        (data || []).forEach((m) => {
                            const maquina = $scope.servidorList.find(x => x.MonitoriaMaquinaId == m.MonitoriaMaquinaId);
                            // Antes: sem guard — TypeError se o backend retornasse Id que nao esta na lista atual
                            if (!maquina) return;
                            maquina.TemErro = m.TemErro;
                            maquina.CpuDataAlteracao = m.DataAlteracao;
                        });
                    })
                    .catch(NotifyService.showError)
                    .finally(() => {
                        agendarProximaRevalidacao();
                    });
            }

            function agendarProximaRevalidacao() {
                if (timerValidacaoData) $timeout.cancel(timerValidacaoData);
                timerValidacaoData = $timeout(validaErroAtualizacao, TEMPO_REVALIDACAO_MS);
            }

            $scope.viewServidorDisco = function (servidor) {
                $scope.servidorSelecionado = servidor;
                DefaultResource.getServidorDisco({ MonitoriaMaquinaId: servidor.MonitoriaMaquinaId }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.discoList);
                        ModalService.openModal('modal_disco');
                    })
                    .catch(NotifyService.showError);
            };

            $scope.viewServidorProcesso = function (servidor) {
                DefaultResource.getServidorProcesso({ MonitoriaMaquinaId: servidor.MonitoriaMaquinaId }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.processoList);
                        ModalService.openModal('modal_processo');
                        $scope.$broadcast('carrega_processo_default', $scope.processoList);
                    })
                    .catch(NotifyService.showError);
            };

            $scope.viewServidorInterface = function (servidor) {
                $scope.maquinaNome = servidor.MaquinaNome;
                $scope.monitoriaMaquinaId = servidor.MonitoriaMaquinaId;

                DefaultResource.getMonitoriaInterface({ MonitoriaMaquinaId: servidor.MonitoriaMaquinaId }).$promise
                    .then((data) => {
                        ModalService.openModal('modal_interface');
                        $scope.$broadcast('carrega_interface_default', data);
                    })
                    .catch(NotifyService.showError);
            }

            $scope.detalhe = function (servidor) {
                // Corrigido typo 'telaDefalut' -> 'telaDefault' na chave do tradutor.
                const msg = `<h4>${$translate.instant('telaDefault.detalheProcessamento')} - ${servidor.MaquinaNome}</h4></br>
                    ${$translate.instant('telaDefault.ultimaAtualizacaoServidor')}: ${new moment(servidor.DataAtualizacao).format("DD/MM/YYYY HH:mm")}</br>
                    ${$translate.instant('telaDefault.ultimaAtualizacaoDisco')}: ${new moment(servidor.DiscoAtualizacao).format("DD/MM/YYYY HH:mm")}</br>
                    ${$translate.instant('telaDefault.ultimaAtualizacaoProcessador')}: ${new moment(servidor.ProcessamentoAtualizacao).format("DD/MM/YYYY HH:mm")}</br>
                    ${$translate.instant('telaDefault.ultimaAtualizacaoMemoria')}: ${new moment(servidor.MemoriaAtualizacao).format("DD/MM/YYYY HH:mm")}`;

                ModalService.alert(msg);
            }

            $scope.processaServidorMonitoria = function () {
                DefaultResource.processaMonitoriaServidor().$promise
                    .then(() => {
                        NotifyService.showSuccess('telaDefault.processamentoSolicitadoComSucesso');
                        $scope.processadaMonitoria = true;
                        // BUG ORIGINAL: a linha "adicionaLocalStorage('monitoria_processada', true)"
                        // era chamada APOS $window.location.reload() — nunca executava, e a flag
                        // ficava sempre vazia no proximo carregamento. Agora gravamos ANTES do reload.
                        LocalStorageService.setItem('monitoria_processada', 'true');
                        timerReload = $timeout(() => {
                            $window.location.reload();
                        }, ESPERA_RELOAD_MS);
                    })
                    .catch(NotifyService.showError);
            }

            $scope.mostrarAviso = function (servidor) {
                const formatoDataHora = TranslateService.getMomentDateTimeFormatWithSeconds();
                const ultimaAtualizacao = moment(servidor.CpuDataAlteracao, 'YYYY-MM-DD HH:mm:ss').format(formatoDataHora);

                ModalService.alert(`<h3>${$translate.instant('telaDefault.detalheMonitoriaMaquinaTitulo')}</h3>
                    ${$translate.instant('telaDefault.detalheMonitoriaMaquina', { Nome: servidor.Nome, UltimaAtualizacao: ultimaAtualizacao })}`)
            }

            $scope.alterarVideo = function (event) {
                const videoPlaylistElement = document.getElementById('video_player_playlist');
                const videoPlayerElement = document.getElementById('video_player_frame');

                const video = $scope.listVideos.find(f => f.Id == event.Id);
                // Guards adicionados: protege contra DOM ainda nao renderizado ou video nao encontrado.
                if (!video || !videoPlayerElement || !videoPlaylistElement) return;

                videoPlayerElement.src = video.Url;

                for (let i = 0; i < videoPlaylistElement.children.length; i++) {
                    const child = videoPlaylistElement.children[i];
                    if (child.id == event.Id) child.classList.add('md-list-item-active');
                    else child.classList.remove('md-list-item-active');
                }
            }

            $scope.$on("$destroy", () => {
                // Cleanup: cancela ambos os timers para evitar
                // - $timeout reagendado disparar apos a tela ser destruida
                // - location.reload() inesperado se o usuario sair antes dos 10s
                if (timerValidacaoData) $timeout.cancel(timerValidacaoData);
                if (timerReload) $timeout.cancel(timerReload);
            });
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("DefaultResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MonitoriaServidor/", {},
                {
                    getServidorDisco: {
                        url: "MonitoriaServidor/MonitoriaServidorDisco",
                        method: "GET",
                        isArray: true
                    },
                    getServidorProcesso: {
                        url: "MonitoriaServidor/MonitoriaServidorProcesso",
                        method: "GET",
                        isArray: true
                    },
                    processaMonitoriaServidor: {
                        method: "POST",
                        url: "MonitoriaServidor/ProcessaMonitoriaServidor"
                    },
                    getMonitoriaInterface: {
                        url: "MonitoriaServidor/MonitoriaInterface",
                        method: "GET",
                        isArray: true
                    },
                    setMonitoriaInterface: {
                        method: "POST",
                        url: "MonitoriaServidor/SetMonitoriaInterface"
                    },
                });
        }]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")
		.controller("InterfaceController", ["$scope", "DefaultResource", function ($scope, DefaultResource) {
			$scope.$on("carrega_interface_default", function (event, interfaceList) {
				$scope.interfaceList = [];
				angular.copy(interfaceList, $scope.interfaceList);
			});

			$scope.alteraInterfacePadrao = function (monitoriaInterface) {
				DefaultResource.setMonitoriaInterface({
					InterfaceId: monitoriaInterface.InterfaceId
				}).$promise.then(() => {
					if ($scope.monitoriaMaquinaId > 0) {
						DefaultResource.getMonitoriaInterface({
							MonitoriaMaquinaId: $scope.monitoriaMaquinaId
						}).$promise.then((dataInterface) => {
							angular.copy(dataInterface, $scope.interfaceList);
						});
					}
				});
			}
		}]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")
		.controller("ProcessoController", ["$scope", function ($scope) {
			//Ordenar Grid
			$scope.predicate = '';
			$scope.reverse = false;
			$scope.order = function (predicate) {
				$scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
				$scope.predicate = predicate;
			};

			$scope.$on("carrega_processo_default", function (event, processoList) {
				$scope.processos = [];
				$scope.processos = processoList;
			});
		}]);
})();



(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

            $stateProvider
                .state("main.download", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.download.list',
                        pageTitle: 'pageTitle.download',
                        pageName: 'campo.visualizacao'
                    }
                })
                .state("main.download.list", StateResolverProvider.configState("/download", "Download", "List", {
                    pageTitle: 'pageTitle.download',
                }))
        }])

        .service("DownloadListData", function () {
            return function () {
                return {
                    configuracaoDownload: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getDownloadUrl().$promise;
                    }]
                }
            }
        })

        .controller("DownloadListController", ["$scope", "$sce", "Config", "configuracaoDownload", function ($scope, $sce, Config, configuracaoDownload) {
            $scope.configureTabuladorUrl = $sce.trustAsUrl("x-epbxatendimento://configure?url=" + encodeURIComponent(Config.getUrlService()))
            $scope.urlDownloadAppImage = configuracaoDownload.TabuladorUrl + 'EpbxManager Atendimento.AppImage';
            $scope.urlDownloadPacman = configuracaoDownload.TabuladorUrl + 'EpbxManager Atendimento.pacman';
            $scope.desktop = false;

            if (configuracaoDownload.TabuladorNovo) {
                $scope.urlDownloadWindows = configuracaoDownload.TabuladorUrl + 'EpbxManager Atendimento.exe';
            } else {
                $scope.urlDownloadWindows = window.location.origin + '/tabulador/atendimento.exe';
            }

            $scope.ativarDesktop = function(){
                if($scope.desktop)
                    $scope.configureTalkfoneUrl = $sce.trustAsUrl("x-talkfone-client://configure?desktop=1&url=" + encodeURIComponent(Config.getUrlService()))
                else
                $scope.configureTalkfoneUrl = $sce.trustAsUrl("x-talkfone-client://configure?desktop=0&url=" + encodeURIComponent(Config.getUrlService()))
            };

            $scope.downloadTalkfone = window.location.origin + '/tabulador/talkfone.exe'
            $scope.downloadTalkfoneLinux = window.location.origin + '/tabulador/setuptalkfone.tar.gz'
            $scope.configureTalkfoneUrl = $sce.trustAsUrl("x-talkfone-client://configure?desktop=0&url=" + encodeURIComponent(Config.getUrlService()))
            
        }]);
})();
(function () {
    "use strict";  
    angular.module('epbxManagerApp') 
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("downloaddialogo", StateResolverProvider.configState("/downloaddialogo/{Arquivodialogo:[a-z, A-Z, 0-9, !@#$%&*_+=]+}/{GlobalId:[a-z, A-Z, 0-9, !@#$%&*_+=]+}/{CodigoAcesso:[a-z, A-Z, 0-9, !@#$%&*_+=]+}/{DataExpiracao:[a-z, A-Z, 0-9, !@#$%&*_+=]+}/{Id:[a-z, A-Z, 0-9, !@#$%&*_+=]+}", "DownloadDialogo", 'View'))
        }])
        .service("DownloadDialogoData", function DownloadDialogoData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_iCheck'
                        ]);
                    }]
                }
            }
        })

        .controller('DownloadDialogoViewController', ["$scope", "$state", "$location", "NotifyService", "Config", "TranslateService", "STATES", "LocalStorageService", "EmailDestinatarioResource", "FileDownloadService", function ($scope, $state, $location, NotifyService, Config, TranslateService, STATES, LocalStorageService, EmailDestinatarioResource, FileDownloadService) {


            $scope.getDownloadDialogoEmail = function() {
                let arquivoDialogo = window.location.hash.split("/")[2];
                let globalId = window.location.hash.split("/")[3];
                let id = window.location.hash.split("/")[6];

                try {
                    FileDownloadService.downloadWebApiFile("EmailDestinatario/DownloadDialogoEmail/" + arquivoDialogo + "/" + globalId + "/" + id);
                } catch (err) {                                                                                   
                    NotifyService.showError(err);
                }
            }

            $scope.validaCodigoDeAcesso = function() {
                let codigoAcesso = window.location.hash.split("/")[4];
                EmailDestinatarioResource.ValidaCodigoDeAcesso({
                    codigoAcesso: codigoAcesso
                }).$promise.then(data => {
                    if(data != null && data.isValid == true) {
                        $scope.getDownloadDialogoEmail();
                    } else {
                        NotifyService.showMessage('telaDownload.codigoDeAcessoInvalido', "danger");
                    }
                });
            }

            $scope.validaLinkDataExpiracao = function() {
                let dataExpiracao = window.location.hash.split("/")[5];
                EmailDestinatarioResource.ValidaLinkDataExpiracao({
                    dataExpiracao: dataExpiracao
                }).$promise.then(data => {
                    if(data != null && data.linkExpirou == false) {
                        $scope.validaCodigoDeAcesso();
                    } else {
                        NotifyService.showMessage('telaDownload.oSeuLinkExpirou', "danger");
                    }
                });
            }

            $scope.validaLinkDataExpiracao();
 
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.emailDestinatario.edit", StateResolverProvider.configState("/emailDestinatario/{Id:[0-9]+}", "EmailDestinatario", "Edit", {
                    pageTitle: 'pageTitle.emailDestinatario',
                    pageName: 'acoes.editar',
                }))
                .state("main.emailDestinatario.new", StateResolverProvider.configState("/emailDestinatario/new", "EmailDestinatario", "Edit", {
                    pageTitle: 'pageTitle.emailDestinatario',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("EmailDestinatarioEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    emailDestinatario: ["EmailDestinatarioResource", "$stateParams", function (EmailDestinatarioResource, $stateParams) {
                        if ($stateParams.Id) {
                            return EmailDestinatarioResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }]
                };
            };
        })

        .controller("EmailDestinatarioEditController", ["$scope", "ModalService", "NotifyService", "EmailDestinatarioResource", "$state", "$translate", "emailDestinatario", function ($scope, ModalService, NotifyService, EmailDestinatarioResource, $state, $translate, emailDestinatario) {
            $scope.isNew = (emailDestinatario.Id > 0 ? false : true);
            $scope.emailDestinatario = emailDestinatario; 
            $scope.inserirOuEditar = !$scope.isNew ? $translate.instant('telaEditEmailDestinatario.editarEmailDestinatario') : $translate.instant('telaEditEmailDestinatario.cadastrarEmailDestinatario');           

            $scope.salvar = function (form) {

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }  
                
                var data = {
                    Id: $scope.emailDestinatario.Id,                                          
                    Nome: $scope.emailDestinatario.Nome,
                    Email: $scope.emailDestinatario.Email,
                    Autorizado: $scope.emailDestinatario.Autorizado
                };

                $scope.salvarEmailDestinatario(data);
            };

            $scope.salvarEmailDestinatario = function (data) {
                var promise;
                if ($scope.emailDestinatario.Id > 0) {
                    promise = EmailDestinatarioResource.update(data.Id, data).$promise;
                }
                else {
                    promise = EmailDestinatarioResource.save(data).$promise;
                }

                promise.then(() => {
                    let message = $scope.isNew ? 'telaEditEmailDestinatario.emailAdicionadoComSucesso' : 'telaEditEmailDestinatario.emailAlteradoComSucesso';

                    NotifyService.showSuccess($translate.instant(message));
                    $state.go('main.emailDestinatario.list');
                })
                .catch(NotifyService.showError);
            };

            $scope.voltar = function () {
                $state.go('main.emailDestinatario.list');
            };

        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (EmailDestinatarioResource, search, orderBy, $odata) {
        var odata = EmailDestinatarioResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }

        if (search.Email) {
            odata.filter(new $odata.Func("startswith", "Email", search.Email), true);
        }

        if (search.Autorizado) {            
            odata.filter('Autorizado', search.Autorizado);
        }
        
        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.emailDestinatario", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.emailDestinatario.list',
                    pageTitle: 'pageTitle.cardTitle',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.emailDestinatario.list", StateResolverProvider.configState("/emailDestinatario", "EmailDestinatario", "List", {
                pageTitle: 'pageTitle.emailDestinatario',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("EmailDestinatarioListData", function EmailDestinatarioListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                emailDestinatarioList: ["EmailDestinatarioResource", "LocalStorageService", "$odata", "$stateParams", function (EmailDestinatarioResource, LocalStorageService, $odata, $stateParams) {
                    var filtro = {};
                    if ($stateParams.storage) {
                        filtro = LocalStorageService.getItem("FiltroEmailDestinatario");
                    }
                    var orderBy = {
                        column: "Id",
                        order: "desc"
                    };

                    return getOdataSearchShared(EmailDestinatarioResource, filtro, orderBy, $odata).page(10, 1).query();
                }],
            }
        }
    })

    .controller("EmailDestinatarioListController", ["$scope", "$odata", "EmailDestinatarioResource", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "emailDestinatarioList", function ($scope, $odata, EmailDestinatarioResource, LocalStorageService, $stateParams, NotifyService, ModalService, emailDestinatarioList) {

            $scope.emailDestinatarioList = emailDestinatarioList;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroEmailDestinatario") : {
                Nome: '',
                Email: '',
                Autorizado: false
            };

            $scope.orderBy = {
                column: "Id",
                order: "desc"
            };

            $scope.errorObject = {};

            var updateList = function (list) {
                $scope.emailDestinatarioList = list;
                $scope.emailDestinatarioList.$recordCount = list.$recordCount || list.length;
                $scope.$currentPage = list.$currentPage || 1;
                $scope.emailDestinatarioList.$pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(EmailDestinatarioResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.emailDestinatarioList.$pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroEmailDestinatario', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroEmailDestinatario');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteEmailDestinatario = function (data) {
                return EmailDestinatarioResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmMessage('telaEmailDestinatario.confirmDeleteEmailDestinatario', null, () => deleteEmailDestinatario(data));
            };

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("EmailDestinatarioResource", ["$odataresource", function ($odataresource) {
            return $odataresource("EmailDestinatario/:Id", { "Id": "@Id" },
                {
                    GetEmailsAutorizados: {
                        url: "EmailDestinatario/GetEmailsAutorizados",
                        method: "GET",
                        isArray: true
                    },
                    EnviarDialogoPorEmail: {
                        url: "EmailDestinatario/EnviarDialogoPorEmail",
                        method: "POST"
                    },
                    ValidaLinkDataExpiracao: {
                        url: "EmailDestinatario/ValidaLinkDataExpiracao",
                        method: "GET",
                        params: {
                            "dataExpiracao": "@dataExpiracao"
                        }
                    },
                    ValidaCodigoDeAcesso: {
                        url: "EmailDestinatario/ValidaCodigoDeAcesso",
                        method: "GET",
                        params: {
                            "codigoAcesso": "@codigoAcesso"
                        }
                    }
                });
        }]);
})();
(function () {
    "use strict";  
    angular.module('epbxManagerApp') 
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("esqueciminhasenha", StateResolverProvider.configState("/esqueciminhasenha/{Id:[a-z, A-Z, 0-9, !@#$%&*+=]+}/{Hash:[a-z, A-Z, 0-9, !@#$%&*+=]+}", "EsqueciMinhaSenha", 'View'))
        }])
        .service("EsqueciMinhaSenhaData", function EsqueciMinhaSenhaData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_iCheck'
                        ]);
                    }]
                }
            }
        })

        .controller('EsqueciMinhaSenhaViewController', ["$scope", "$state", "$location", "NotifyService", "Config", "TranslateService", "STATES", "LocalStorageService", "UsuarioResource", function ($scope, $state, $location, NotifyService, Config, TranslateService, STATES, LocalStorageService, UsuarioResource) {

            $scope.idiomaConfig = {
                ativo: false            };
            
            $scope.esqueciSenha = {
                NovaSenha: '',
                ConfirmarNovaSenha: ''
            };

            $scope.isValidLink = false;

            const exibirIdiomas = () => {
                $scope.idiomaConfig.ativo = TranslateService.getI18NAtivo();
                if ($scope.idiomaConfig.ativo) {
                    $scope.idiomaConfig.idiomaAtual = TranslateService.getIdiomaAtual();
                    $scope.idiomas = [
                        { id: 'pt', descricao: 'Português' },
                        { id: 'en', descricao: 'English' },
                        { id: 'es', descricao: 'Español' }
                    ];

                    $scope.alterarIdioma = function (idioma) {
                        $scope.idiomaConfig.idiomaAtual = idioma.id;
                        TranslateService.alterarIdioma(idioma.id);
                    }
                }
            };

            if (TranslateService.verificarConfiguracao()) {
                exibirIdiomas();
            } else {
                $scope.$on('idiomaConfigurado', exibirIdiomas);
            }

            $scope.validaDataLink = function() {
                let hashCode =  window.location.hash.split("/")[3];
                UsuarioResource.ValidaDataLink({
                    hashCode: hashCode
                }).$promise.then(data => {
                    if(data != null && data.dataLink == true) {
                        $scope.isValidLink = true;
                    } else {
                        NotifyService.showMessage('telaEsqueciSenha.oSeuLinkExpirou', "danger");
                        $state.go("login");
                    }
                });
            }

            $scope.validaDataLink();

            $scope.onAlterarSenhaExpirada = function (event) {
                event.preventDefault();
                if (!$scope.esqueciSenha.NovaSenha) {
                    return NotifyService.showMessage('telaEsqueciSenha.naoFoiPossivelAtualizarASenha', "danger");
                }
                if ($scope.esqueciSenha.NovaSenha != $scope.esqueciSenha.ConfirmarNovaSenha) {
                    return NotifyService.showMessage('telaEsqueciSenha.osCamposDevemSerIguais', "danger");
                }
                let  id =  window.location.hash.split("/")[2];
                UsuarioResource.AlterarEsqueciSenha({UsuarioId: id}, $scope.esqueciSenha).$promise
                .then(() => {
                    NotifyService.showMessage('telaEsqueciSenha.senhaAtualizadaComSucesso', "success");
                    $state.go("login");
                }).catch(function (error) {
                    if (error && error.data) {
                        NotifyService.showMessage(error.data.Message, "danger");
                    }
                });

            }

            
        }]);
})();
(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("FilaVirtualResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Atendimento/:Id", {
                "Id": "@Id"
            }, {                  
                    GetBuscarFilaAtendimentoPorGlobalId:{
                        method: 'GET',
                        url: "Atendimento/BuscarFilaAtendimentoPorGlobalId/:GlobalId",
                        params: {
                            "GlobalId": "@GlobalId"
                        },
                    },
                    SairFilaVirtual:{
                        method: 'POST',
                        url: 'Atendimento/SairFilaVirtual',
                        params: {
                            "GlobalId": "@GlobalId",
                            "Tipo": "@Tipo"
                        },
                    }
                });
        }]);
})();
(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("filavirtual", StateResolverProvider.configState("/filavirtual/{Id:[a-z, A-Z, 0-9, !@#$%&*+=]+}", "FilaVirtual", 'View'))
        }])
        .service("FilaVirtualData", function FilaVirtualData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_iCheck'
                        ]);
                    }],
                }
            }
        })

        .controller("FilaVirtualViewController", ["$state", "$scope", "$odata", "utils", "$location", "NotifyService", "TabulacaoResource", "Config", "$translate", "STATES", "LocalStorageService", "FilaVirtualResource", "$stateParams", "ModalService", "GrupoFilaVirtualResource", "$interval", function ($state, $scope, $odata, utils, $location, NotifyService, TabulacaoResource,
            Config, $translate, STATES, LocalStorageService, FilaVirtualResource, $stateParams, ModalService, GrupoFilaVirtualResource, $interval) {

            $scope.Atendimento = "";
            $scope.SairFila = "";
            $scope.exibirSairFila = false;
            $scope.btnWhatsapp = false;
            $scope.NumeroWhatsapp = "";
            $scope.bloquearBotaoAgendamento = false;
            $scope.horaParcial = true;
            $scope.horaCompleta = false;
            $scope.agendamento = { Telefone: ' ', DDD: '' };
            $scope.callback = false;
            $scope.campanhaId = 0;
            $scope.today = new Date();

            function onLoadFilaAtendimento() {
                if ($stateParams.Id) {
                    return FilaVirtualResource.GetBuscarFilaAtendimentoPorGlobalId({
                        GlobalId: $stateParams.Id
                    }).$promise
                        .then((data) => {

                            if (data.Posicao == undefined) {
                                $scope.Atendimento = "Fila não encontrada";
                                $scope.exibirSairFila = false;
                            }
                            else if (data.FilaAtendimentoStatusId == 2) {
                                $scope.SairFila = "Você não está mais na fila, entre em contato novamente";
                                $scope.Atendimento = "";
                                $scope.exibirSairFila = false;
                            }
                            else {
                                $scope.Atendimento = data.Posicao + "°";
                                $scope.SairFila = "";
                                $scope.exibirSairFila = true;
                            }

                            if (data.Posicao != undefined) {
                                getGrupo(data.GrupoId)
                                $scope.agendamento.Telefone = $scope.retirarNumero(data.Telefone)
                                $scope.agendamento.DDD = $scope.retirarDDD(data.Telefone)
                            }

                        }).catch(NotifyService.showError);;
                } else {
                    return {};
                }
            }

            onLoadFilaAtendimento();

            // Usa $interval para que o polling seja cancelado automaticamente quando o controller for destruído.
            // Sem isso, cada visita à fila virtual deixava um setInterval rodando indefinidamente.
            var pollingFila = $interval(function () {
                onLoadFilaAtendimento();
            }, 5000);

            $scope.$on('$destroy', function () {
                if (pollingFila) {
                    $interval.cancel(pollingFila);
                    pollingFila = null;
                }
            });

            $scope.clickSairFilaVirtual = function () {

                ModalService.confirmMessage("Você será removido da fila, deseja realmente sair?", null, () => {
                    FilaVirtualResource.SairFilaVirtual({
                        GlobalId: $stateParams.Id,
                        Tipo: 2
                    }).$promise
                        .then((data) => {
                            inativarBotoes();
                            NotifyService.showSuccess();
                        }).catch(NotifyService.showError);
                });
            }

            $scope.clickSairFilaVirtualWhatsapp = function () {
                
                ModalService.confirmMessage("Você será removido da fila, deseja realmente sair?", null, () => {
                    FilaVirtualResource.SairFilaVirtual({
                        GlobalId: $stateParams.Id,
                        Tipo: 3
                    }).$promise
                        .then((data) => {      
                                inativarBotoes();             
                                window.open('https://wa.me/' + $scope.NumeroWhatsapp, "_blank")                   
                            NotifyService.showSuccess();
                        }).catch(NotifyService.showError);
                });
            }


            function getGrupo(grupoId) {
                GrupoFilaVirtualResource.GetFilaVirtualPorGrupoId({
                    grupoId: grupoId
                }).$promise
                    .then((data) => {
                        if (data.length > 0) {

                            if (data[0].Whatsapp) {
                                $scope.btnWhatsapp = true;
                                $scope.NumeroWhatsapp = data[0].NumeroWhatsapp;
                            } else
                                $scope.btnWhatsapp = false;


                            if (data[0].Callback) {
                                $scope.callback = true;
                                $scope.campanhaId = data[0].CampanhaId

                            } else
                                $scope.callback = false;

                        }
                    }).catch(NotifyService.showError);;
            }

            function inativarBotoes(){
                $scope.SairFila = "Você não está mais na fila, entre em contato novamente";
                $scope.Atendimento = "";
                $scope.btnWhatsapp = false;
                $scope.callback = false;
                $scope.exibirSairFila = false;
            }

            $scope.enviarAgendamento = function () {

                let dataFormatada = moment($scope.agendamento.Data).format('YYYY-MM-DD')
                if(moment(dataFormatada + ' ' + $scope.agendamento.HoraCompleta).format() < moment().format()){                    
                    return NotifyService.showError(null, 'Não é possível realizar um agendamento para um horário menor que o atual')
                }

                ModalService.confirmMessage("Você será removido da fila, deseja realmente sair?", null, () => {
                    FilaVirtualResource.SairFilaVirtual({
                        GlobalId: $stateParams.Id,
                        Tipo: 4
                    }).$promise
                        .then((data) => {
                            
                            setAgendamento();
                            inativarBotoes();
                            NotifyService.showSuccess();
                        }).catch(NotifyService.showError);
                });                
            };

            function setAgendamento() {
                $scope.bloquearBotaoAgendamento = true;
                $scope.erroTelefone = !$scope.agendamento.Telefone || $scope.agendamento.Telefone.length < 7;
                $scope.erroData = !$scope.agendamento.Data;
                $scope.erroHora = !$scope.agendamento.HoraCompleta && !$scope.agendamento.HoraParcial;
                $scope.erroDDD = !$scope.agendamento.DDD;

                if ($scope.erroData || $scope.erroHora || $scope.erroTelefone || $scope.erroDDD) return;

                let dataFormatada = moment($scope.agendamento.Data).format('YYYY-MM-DD')
                $scope.agendamento.DataHora = moment.utc(dataFormatada + ' ' + $scope.agendamento.HoraCompleta).toDate();

                $scope.agendamento.Campanha = $scope.campanhaId;
                $scope.agendamento.CodCliente = $scope.agendamento.Telefone;
                $scope.agendamento.NomeCliente = $scope.agendamento.Nome;

                TabulacaoResource
                    .Agendamento($scope.agendamento)
                    .$promise
                    .then(() => {
                        inativarBotoes();

                    }).catch(() => {
                        NotifyService.showError;
                    });

                ModalService.closeModal('modal_agendamento');
            }

            $scope.abrirModalCallback = function () {
                ModalService.openModal('modal_agendamento');
            }

            $scope.retirarDDD = function (telefone) {
                let ddd = $scope.dddPadrao;
                if (!(telefone.length == 8 || telefone.length == 9)) {
                    if (telefone[0] != '0') {
                        ddd = telefone.substring(0, 2);
                    } else {
                        if (telefone[1] != '0') {
                            ddd = telefone.substring(1, 3);
                        } else {
                            ddd = telefone.substring(2, 4);
                        }
                    }
                }
                return ddd;
            }

            $scope.retirarNumero = function (telefoneComDDD) {
                let telefone = telefoneComDDD;
                if (!(telefoneComDDD.length == 8 || telefoneComDDD.length == 9)) {
                    if (telefoneComDDD[0] != '0') {
                        telefone = telefoneComDDD.substring(2, telefoneComDDD.length);
                    } else {
                        if (telefoneComDDD[1] != '0') {
                            telefone = telefone.substring(3, telefoneComDDD.length);
                        } else {
                            telefone = telefone.substring(4, telefoneComDDD.length);
                        }
                    }
                }
                return telefone;
            }
        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.forecast.new", StateResolverProvider.configState("/forecast/new?page", "forecast", "Edit", {
                    pageTitle: 'forecastEditTranslation.Titulo',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.forecast.edit", StateResolverProvider.configState("/forecast/{ForecastId:[0-9]+}", "forecast", "Edit", {
                    pageTitle: 'forecastEditTranslation.Titulo',
                    pageName: 'acoes.editar'
                }))
        }])
        .service('forecastEditData', function PesquisaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider',
                            'lazy_fileUpload',
                            'lazy_dropify'
                        ]);
                    }],
                    forecast: ["ForecastResource", "$stateParams", function (ForecastResource, $stateParams) {
                        if ($stateParams.ForecastId) {
                            return ForecastResource.GetId({ Id: $stateParams.ForecastId }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    carteiras: ["AtendimentoTipoResource", function (AtendimentoTipoResource) {
                        return AtendimentoTipoResource.getCarteira().$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }]
                }
            }
        })
        .controller("forecastEditController", ["$scope", "$window", "$state", "Config", "$q", "$stateParams", "WizardHandler", "forecast", "ForecastResource", "carteiras", "grupos", "NotifyService", "ModalService", "$translate", function forecastEditController($scope, $window, $state, Config,
            $q, $stateParams, WizardHandler, forecast, ForecastResource, carteiras, grupos,
            NotifyService, ModalService, $translate) {

            $scope.isEdit = forecast && forecast.ForecastId ? true : false;
            $scope.isNew = forecast.ForecastId > 0 ? false : true;
            $scope.carteiras = carteiras;
            $scope.grupos = grupos;
            $scope.model = forecast;
            $scope.forms = [];

            $scope.salvar = function () {
                if ($scope.forms.formForecast.$dirty || $scope.forms.formForecast.$dirty) {

                    if ($scope.isNew) {

                        ModalService.showLoading();
                        ForecastResource.Cadastrar($scope.model)
                            .$promise
                            .then((data) => {

                                ModalService.hideLoading();
                                $scope.salvando = false;
                                NotifyService.showSuccess($translate.instant('notificacoes.registroSalvo'));
                                $state.go('main.forecast.list');

                            }).catch(e => {
                                ModalService.hideLoading();
                                NotifyService.showError(e);
                                $scope.salvando = false;
                            });

                    } else {
                        ModalService.showLoading();
                        ForecastResource.Editar($scope.model)
                            .$promise
                            .then((data) => {

                                ModalService.hideLoading();
                                $scope.salvando = false;
                                NotifyService.showSuccess($translate.instant('notificacoes.registroSalvo'));
                                $state.go('main.forecast.list');

                            }).catch(e => {
                                ModalService.hideLoading();
                                NotifyService.showError(e);
                                $scope.salvando = false;
                            });
                    }

                } else
                    $state.go('main.forecast.list');
            }

            $scope.confirmDeleteUpload = function (data) {
                ModalService.confirmDelete(() => deleteArquivoUpload(data));
            };

            let deleteArquivoUpload = function (data) {
                return CampanhaArquivoResource.delete({ CampanhaArquivoId: data.ArquivoId }).$promise
                    .then(function () {
                        NotifyService.showSuccess();
                        if (data.ArquivoId > 0) {
                            $scope.files.splice(_.indexOf($scope.files, _.findWhere($scope.files, {
                                ArquivoId: data.ArquivoId
                            })), 1);

                            $scope.ArquivoProgresso.splice(_.indexOf($scope.ArquivoProgresso, _.findWhere($scope.ArquivoProgresso, {
                                CampanhaArquivoId: data.ArquivoId
                            })), 1);

                            $scope.Arquivos.splice(_.indexOf($scope.Arquivos, _.findWhere($scope.Arquivos, {
                                CampanhaArquivoId: data.ArquivoId
                            })), 1);
                        }
                    })
                    .catch(NotifyService.showError);
            };

        }])
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.forecast.import", StateResolverProvider.configState("/forecast/{ForecastId:[0-9]+}/Import", "forecast", "Import", {
                    pageTitle: 'forecastImportTranslation.Titulo',
                    pageName: 'botao.importar'
                }))
        }])
        .service('forecastImportData', function ForecastImportData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_fileUpload',
                            'lazy_dropify',
                            'lazy_wizard'
                        ]);
                    }],
                    forecast: ["ForecastResource", "$stateParams", function (ForecastResource, $stateParams) {
                        if ($stateParams.ForecastId) {
                            return ForecastResource.GetId({ Id: $stateParams.ForecastId }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    arquivosImportados: ["ForecastResource", "$stateParams", function (ForecastResource, $stateParams) {
                        if ($stateParams.ForecastId) {
                            return ForecastResource.Arquivos({ id: $stateParams.ForecastId }).$promise;
                        } else {
                            return {};
                        }
                    }],
                }
            }
        })
        .controller("forecastImportController", ["$scope", "$state", "Upload", "$timeout", "$window", "$http", "Config", "ForecastResource", "forecast", "arquivosImportados", "FileDownloadService", "NotifyService", "ModalService", "WizardHandler", "$translate", function ($scope, $state, Upload, $timeout, $window, $http, Config, ForecastResource, forecast, arquivosImportados,
            FileDownloadService, NotifyService, ModalService, WizardHandler, $translate) {
            let urlUpload = Config.getUrl("Forecast/Importar");
           

            $scope.forecast = forecast;
            $scope.files = arquivosImportados;
            $scope.uploadFiles = function (files, errFiles) {
                if (files.length == 0 && errFiles.length == 0) return;
                $scope.errFiles = errFiles;
                angular.forEach(files, function (f) {
                    $scope.files.push({
                        Arquivo: f.name,
                        ForecastId: $scope.forecast.ForecastId,
                        DataCadastro: moment().format()
                    });
                });

                angular.forEach(files, function (file) {
                    file.upload = Upload.upload({
                        url: urlUpload,
                        data: {
                            file: file,
                            nome: file.name,
                            ForecastId: $scope.forecast.ForecastId
                        }
                    });

                    file.upload.then(function (response) {
                        $(".dropify-clear").trigger("click");
                        NotifyService.showSuccess($translate.instant('notificacoes.registroSalvo'));
                        $scope.reload();

                    }, function (response) {
                        if (response.status > 0)
                            $scope.errorMsg = response.status + ': ' + response.data;
                    }, function (evt) {
                        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                    });
                });
            }

            $scope.reload = function () {
                ModalService.showLoading();
                ForecastResource.Arquivos({ id: $scope.forecast.ForecastId }).$promise.then((data) => {
                    $scope.files = data;
                    ModalService.hideLoading();
                }).catch(ModalService.hideLoading());
            }

            $scope.getForeCastArquivoStatus = function (item) {
                switch (item.ForeCastArquivoStatusId) {
                    case 1:
                        return "Aguardando Importação";
                    case 2:
                        return "Importando";
                    case 3:
                        return "Erro";
                    case 4:
                        return "Cancelado";
                    case 5:
                        return "Concluído";
                    case 6:
                        return "Erro Processamento";
                    case 7:
                        return "Aguardando Confirmação";
                    default:
                        return "Importando";

                }
            }

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            var deleteRecord = function (data) {
                return ForecastResource
                    .InativarArquivo({ id: data.ForecastArquivoId })
                    .$promise
                    .then((data) => {
                        NotifyService.showSuccess();
                        $scope.reload();
                    })
                    .catch((error) => {
                        NotifyService.showError;
                        ModalService.hideLoading();
                    });
            };

        }]);
})();
(function () {
    "use strict";

    var defaultPageIndex = 1;

    var getOdataSearchShared = function (forecastResource, search, orderBy, $odata, utils, $stateParams) {
        var odata = forecastResource.odata();
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.forecast", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.forecast.list',
                        pageName: 'pageTitle.pesquisar'
                    },
                })
                .state("main.forecast.list", StateResolverProvider.configState("/forecast", "forecast", "List", {
                    pageTitle: 'forecastTranslation.Titulo',
                    pageName: 'pageTitle.pesquisar',
                }))
        }])
        .service('forecastListData', function ForecastListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    carteiras: ["AtendimentoTipoResource", function (AtendimentoTipoResource) {
                        return AtendimentoTipoResource.getCarteira().$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.GetGrupoPorCarteira({ carteira: 0 }).$promise;
                    }]
                }
            }
        })
        .controller("forecastListController", ["$scope", "$odata", "$http", "$state", "Config", "ForecastResource", "GrupoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "carteiras", "grupos", function ($scope, $odata, $http, $state, Config,
            ForecastResource, GrupoResource, utils, LocalStorageService, $stateParams, NotifyService, ModalService, carteiras, grupos) {

            $scope.carteiras = carteiras;
            $scope.grupos = grupos;
            $scope.lista = [];
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("Filtro") : {
                pageSize: 10
            };
            $scope.orderBy = {
                column: "Nome",
                order: "desc"
            };

            var updateList = function (list) {
                $scope.lista = list;
                $scope.lista.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.lista.pageSize = list.$pageSize || 10;
                $scope.searching = false;
                ModalService.hideLoading();
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(ForecastResource, $scope.search, $scope.orderBy, $odata, utils, $stateParams);
            };

            $scope.atualizarGrupo = function () {

                GrupoResource.GetGrupoPorCarteira({ carteira: $scope.search.CarteiraId || 0 }).$promise.then((data) => {
                    $scope.grupos = data;
                    $scope.search.GrupoId = null;
                }).catch((error) => {
                    NotifyService.showError;
                });

            }

            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {

                    defaultPageIndex = newPage;
                    $scope.searching = true;
                    ModalService.showLoading();

                    return getOdataSearch()
                        .page($scope.lista.pageSize, newPage)
                        .query({
                            Nome: $scope.search.Nome,
                            CarteiraId: $scope.search.CarteiraId,
                            GrupoId: $scope.search.GrupoId
                        }).then(updateList).catch((error) => {
                            NotifyService.showError;
                            ModalService.hideLoading();
                        });
                }
            };

            $scope.executeSearch = function () {

                LocalStorageService.setItem('Filtro', $scope.search);

                $scope.searching = true;
                defaultPageIndex = 1;
                ModalService.showLoading();

                getOdataSearch()
                    .page($scope.search.pageSize, 1)
                    .query({
                        Nome: $scope.search.Nome,
                        CarteiraId: $scope.search.CarteiraId,
                        GrupoId: $scope.search.GrupoId
                    }).then(updateList).catch((error) => {
                        NotifyService.showError;
                        ModalService.hideLoading();
                    });
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('Filtro');
                $scope.search = {
                    pageSize: 10
                };
                $scope.lista = [];
            };

            $scope.executeSearch();

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            var deleteRecord = function (data) {
                return ForecastResource
                    .Inativar({ id: data.ForecastId })
                    .$promise
                    .then((data) => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch((error) => {
                        NotifyService.showError;
                        ModalService.hideLoading();
                    });
            };
        }]);
})();
(function() {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ForecastResource", ["$odataresource", function($odataresource) {
            return $odataresource("Forecast/GetAll", null, {
                Inativar: {
                    method: "Delete",
                    url: "Forecast/Delete",
                },
                InativarArquivo: {
                    method: "Delete",
                    url: "Forecast/DeleteArquivo",
                },
                Editar: {
                    method: "Put",
                    url: "Forecast/Put",
                },
                Cadastrar: {
                    method: "Post",
                    url: "Forecast/Post",
                },
                GetId: {
                    method: "Get",
                    url: "Forecast/Get",
                },
                Arquivos: {
                    method: "GET",
                    url: "Forecast/Arquivos",
                    isArray: true
                }
            });
        }]);
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.franquia.edit", StateResolverProvider.configState("/franquia/{FornecedorFranquiaId:[0-9]+}", "Franquia", "Edit", {
                    pageTitle: 'pageTitle.franquia',
                    pageName: 'acoes.editar',
                    permissions: {
                        AllowAll: true
                    },
                    css: true
                }))
                .state("main.franquia.new", StateResolverProvider.configState("/franquia/new", "Franquia", "Edit", {
                    pageTitle: 'pageTitle.franquia',
                    pageName: 'acoes.cadastrar',
                    permissions: {
                        AllowAll: true
                    },
                    css: true
                }));
        }])

        .service('FranquiaEditData', function FranquiaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    franquia: ["FranquiaResource", "$stateParams", function (FranquiaResource, $stateParams) {
                        if ($stateParams.FornecedorFranquiaId) {
                            return FranquiaResource.get({
                                FornecedorFranquiaId: $stateParams.FornecedorFranquiaId
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    fornecedores: ["FornecedorResource", function (FornecedorResource) {
                        return FornecedorResource.query().$promise;
                    }],
                    rotas: ["RotaResource", function (RotaResource) {
                        return RotaResource.query().$promise;
                    }],
                }
            }
        })
        
        .controller("FranquiaEditController", ["$scope", "$state", "$filter", "FranquiaResource", "franquia", "fornecedores", "rotas", "NotifyService", "$translate", function ($scope, $state, $filter, FranquiaResource, franquia, fornecedores, rotas, NotifyService, $translate) {
            $scope.inserirOuEditar = franquia && franquia.FornecedorFranquiaId ? $translate.instant('telaEditFranquia.editandoFranquia') : $translate.instant('telaEditFranquia.cadastrandoFranquia');
            $scope.isEdit = franquia && franquia.FornecedorFranquiaId ? true : false;
            $scope.isNew = !franquia.FornecedorFranquiaId ? true : false;
            $scope.franquia = franquia;
            $scope.fornecedores = fornecedores;
            $scope.franquia.FranquiaRotas = $scope.isEdit ? $scope.franquia.FranquiaRotas : rotas;
            $scope.tipoFranquia = $scope.franquia.FranquiaPorRota ? 'franquiaRota' : 'franquiaFornecedor';

            var mensagemSucesso = function () {
                NotifyService.showRegistroSalvo();
                $state.go('main.franquia.list');
            };

            $scope.voltar = function () {
                $state.go('main.franquia.list');
            };

            $scope.salvar = function salvar(valid) {
                if (!valid) {
                    NotifyService.showInvalid();
                    return;
                }
                var promise;
                if ($scope.tipoFranquia == 'franquiaFornecedor') {
                    $scope.franquia.FranquiaPorRota = false;
                } else {
                    $scope.franquia.FranquiaPorRota = true;
                }
                if ($scope.isNew) {
                    $scope.franquia.FranquiaRotas = $filter('filter')($scope.franquia.FranquiaRotas, { FornecedorId: $scope.franquia.FornecedorId });
                }
                if ($scope.franquia.FornecedorFranquiaId > 0) {
                    promise = FranquiaResource.update($scope.franquia).$promise;
                }
                else {
                    promise = FranquiaResource.save($scope.franquia).$promise;
                }

                promise.then(mensagemSucesso).catch(NotifyService.showError);
            };
    
        }]);
})();

(function () {
	"use strict";

	var getOdataSearchShared = function (FranquiaResource, search, orderBy) {
		var odata = FranquiaResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.FornecedorId) {
			odata.filter('FornecedorId', parseInt(search.FornecedorId));
		}
		if (search.Ativo) {
			odata.filter('Ativo', true);
		}
		else {
			odata.filter('Ativo', false);
		}

		return odata;
	}

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.franquia", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.franquia.list',
						pageTitle: 'pageTitle.franquias',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.franquia.list", StateResolverProvider.configState("/franquia", "Franquia", "List", {
					pageTitle: 'pageTitle.franquias',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("FranquiaListData", function FranquiaListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					franquias: ["FranquiaResource", "LocalStorageService", "$odata", "$stateParams", function (FranquiaResource, LocalStorageService, $odata, $stateParams) {
						var filtro = { Ativo: true };

						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroFranquia");
						}

						var orderBy = {
							column: "Valor",
							order: "asc"
						}

						var odata = getOdataSearchShared(FranquiaResource, filtro, orderBy, $odata);
						return odata.page(10, 1).query();
					}],
					fornecedores: ["FornecedorResource", function (FornecedorResource) {
						return FornecedorResource.query().$promise;
					}],
				}
			}
		})

		.controller("FranquiaListController", ["$scope", "$odata", "$filter", "FranquiaResource", "LocalStorageService", "$stateParams", "franquias", "fornecedores", "NotifyService", "ModalService", "$state", function ($scope, $odata, $filter, FranquiaResource, LocalStorageService, $stateParams, franquias, fornecedores,
			NotifyService, ModalService, $state) {
			$scope.searching = false;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroFranquia") : { Ativo: true };
			$scope.franquias = franquias;
			$scope.franquiaSelecionada = [];
			$scope.historicoList = [];
			$scope.fornecedores = fornecedores;

			$scope.orderBy = {
				column: "Valor",
				order: "asc"
			};

			var updateList = function (list) {
				angular.forEach(list, (value) => {
					value.Check = value.FranquiaStatusId == 1 ? true : false;
				});
				$scope.franquias = list;
				$scope.franquias.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.franquias.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			var getOdataSearch = function () {
				return getOdataSearchShared(FranquiaResource, $scope.search, $scope.orderBy, $odata);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroFranquia', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			var deleteRecord = function (data) {
				return FranquiaResource.delete({ FornecedorFranquiaId: data.FornecedorFranquiaId }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				ModalService.showLoading();
				return getOdataSearch().page($scope.franquias.pageSize, newPage).query()
					.then((list) => {
						updateList(list);
						ModalService.hideLoading();
					})
					.catch((error) => {
						NotifyService.showError(error);
						ModalService.hideLoading();
					});
			};

			updateList(franquias);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroFranquia');
				$scope.search = { Ativo: true };
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, { 
						storage: true 
					});
				}
				else {
					$state.go('main.franquia.list', { 
						storage: true 
					});
				}
			};

			$scope.openModalRotas = function (franquiaFornecedorId) {
				ModalService.openModal('modal_rotas');
				$scope.franquiaSelecionada = $filter('filter')($scope.franquias, { FornecedorFranquiaId: franquiaFornecedorId })[0];
				$scope.$broadcast('carrega_franquia_selecionada', $scope.franquiaSelecionada);
			};

		}]);
	})
();
(function () {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("FranquiaResource", ["$odataresource", function ($odataresource) {
      return $odataresource(
        "FornecedorFranquia/:FornecedorFranquiaId",
        {
          "FornecedorFranquiaId": "@FornecedorFranquiaId"
        });
    }]);

})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")
		.controller("RotasListController", ["$scope", function ($scope) {
			$scope.$on("carrega_franquia_selecionada", function (event, franquiaSelecionada) {
				$scope.franquiaSelecionada = [];
				$scope.franquiaSelecionada = franquiaSelecionada;
			});

		}]);

})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.fornecedores.edit", StateResolverProvider.configState("/fornecedores/{FornecedorId:[0-9]+}", "Fornecedor", "Edit", {
					pageTitle: 'model.fornecedor',
					pageName: 'acoes.editar',
					css: true
				}))
				.state("main.fornecedores.new", StateResolverProvider.configState("/fornecedores/new", "Fornecedor", "Edit", {
					pageTitle: 'model.fornecedor',
					pageName: 'acoes.cadastrar',
					css: true
				}));
		}])

		.service('FornecedorEditData', function ForncedorEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_uiSelect',
							'lazy_dropify'
						]);
					}],
					fornecedor: ["FornecedorResource", "$stateParams", function (FornecedorResource, $stateParams) {
						if ($stateParams.FornecedorId) {
							return FornecedorResource.get({
								FornecedorId: $stateParams.FornecedorId
							}).$promise;
						} else {
							return {};
						}
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("FornecedorEditController", ["$scope", "$state", "fornecedor", "FornecedorResource", "NotifyService", "$translate", "ModalService", "carteiras", function ($scope, $state, fornecedor, FornecedorResource, NotifyService, $translate, ModalService,carteiras) {
			$scope.isNew = !(fornecedor && fornecedor.FornecedorId);
			$scope.inserirOuEditar = !$scope.isNew ? $translate.instant('telaCadastroFornecedor.editarFornecedor') :
				$translate.instant('telaCadastroFornecedor.RegistrarFornecedor');
			$scope.novoOuAlterar = !$scope.isNew ? $translate.instant('telaCadastroFornecedor.alterarLogo') :
				$translate.instant('telaCadastroFornecedor.adicionarLogo');
			$scope.fornecedor = fornecedor;
			$scope.imagem = fornecedor != null && fornecedor.Logo != null ? fornecedor.Logo.Imagem : '';
			var arquivoValido;
			$scope.salvando = false;
            $scope.carteiras = carteiras;

			$scope.uploadFile = function () {
				var file = event.target.files[0];

				if (file) {
					var isImage = file.type.startsWith('image');

					if (isImage) {
						arquivoValido = true;
						var reader = new FileReader();

						reader.onload = function (e) {
							convertImage(e.target.result);
						};
						reader.readAsDataURL(file);
					}
					else {
						NotifyService.showMessage('telaCadastroFornecedor.oArquivoNaoEImagem', 'warning')
						arquivoValido = false;
					}
				}
			};

			var convertImage = function (base64) {
				var img = new Image();
				img.src = base64;

				img.onload = function () {
					var tempW = img.width;
					var tempH = img.height;
					var scaleReduzida = Math.min((34 / tempW), (34 / tempH));
					var scaleNormal = Math.min((800 / tempW), (800 / tempH));
					var canvasReduzida = document.createElement("canvas");
					canvasReduzida.width = tempW * scaleReduzida;
					canvasReduzida.height = tempH * scaleReduzida;
					var ctxReduzida = canvasReduzida.getContext("2d");
					ctxReduzida.drawImage(this, 0, 0, tempW * scaleReduzida, tempH * scaleReduzida);
					ctxReduzida.clearRect(0, 0, img.width, img.height);
					var canvasNormal = document.createElement("canvas");
					canvasNormal.width = tempW * scaleNormal;
					canvasNormal.height = tempH * scaleNormal;
					var ctxNormal = canvasNormal.getContext("2d");
					ctxNormal.drawImage(this, 0, 0, tempW * scaleNormal, tempH * scaleNormal);
					$scope.imagemAnterior = $scope.imagem;
					$scope.imagem = canvasNormal.toDataURL("image/png", 8.0);
					$scope.$apply();
					ctxNormal.clearRect(0, 0, img.width, img.height);

					if ($scope.fornecedor) {
						$scope.fornecedor.Logo = {};
						$scope.fornecedor.Logo.Imagem = $scope.imagem;
						ModalService.hideLoading();
					} else {
						ModalService.hideLoading();
						NotifyService.showError();
					}
				}
			};

			$scope.exibirDetalhe = function (descricao) {
                ModalService.alert("<h3>Detalhe</h3>" + descricao);
            };
			
			var clearDropify = function () {
				var drEvent = $('#input-file-a').dropify();
				drEvent = drEvent.data('dropify');
				drEvent.resetPreview();
				drEvent.clearElement();
				arquivoValido = true;
			}

			$scope.cancelarImagem = function () {
				if ($scope.imagemAnterior) {
					$scope.imagem = $scope.imagemAnterior;
				}
				if ($scope.imagem) {
					$scope.imagem = $scope.imagem;
				}
			}

			$scope.salvar = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}

				var promise;
				if ($scope.imagem) {
					clearDropify();
					$scope.fornecedor.Logo = {
						Imagem: ''
					};
					$scope.fornecedor.Logo.Imagem = $scope.imagem;
				}

				if ($scope.fornecedor.FornecedorId > 0)
					promise = FornecedorResource.update($scope.fornecedor).$promise;
				else {
					promise = FornecedorResource.save($scope.fornecedor).$promise;
				}
				$scope.salvando = true;
				promise.then(function () {
					$scope.salvando = false;
					NotifyService.showRegistroSalvo();
					$state.go('main.fornecedores.list');
				}).catch(function(){
					$scope.salvando = false;
					NotifyService.showError();
				});
			};


			$scope.confirmarFoto = function (valid) {
				if (!arquivoValido) {
					return NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
				}

				if (!valid) {
					return NotifyService.showInvalid();
				}

				if ($scope.imagem) {
					$scope.fornecedor.Logo.Imagem = $scope.imagem;
				}

				ModalService.closeModal('modalEditarFoto');
			};

			$scope.editarFoto = function () {
				clearDropify();
				ModalService.openModal('modalEditarFoto', null, null, { center: true, bgclose: false });
			}

			$scope.voltar = function () {
				$state.go('main.fornecedores.list');
			};

		}]);
})();
(function () {
	"use strict";

	var getOdataSearchShared = function (FornecedorResource, search, orderBy, $odata) {
		var odata = FornecedorResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.Nome) {
			odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Nome"), search.Nome.toLowerCase()), true);
		}
        if (search.Id) {
			odata.filter("CarteiraId", "=", parseInt(search.Id));
		}

		return odata;
	};

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.fornecedores", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.fornecedores.list',
						pageTitle: 'model.fornecedor',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.fornecedores.list", StateResolverProvider.configState("/fornecedores", "Fornecedor", "List", {
					pageTitle: 'model.fornecedor',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("FornecedorListData", function ServicoListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					fornecedores: ["FornecedorResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (FornecedorResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroFornecedor");
						}
						var orderBy = {
							column: "Nome",
							order: "asc"
						};
						var odata = getOdataSearchShared(FornecedorResource, filtro, orderBy, $odata, utils);
						return odata.page(10, 1).query();
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("FornecedorListController", ["$scope", "$odata", "fornecedores", "FornecedorResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "$state", "carteiras", function ($scope, $odata, fornecedores, FornecedorResource, utils, LocalStorageService, $stateParams,
			NotifyService, ModalService, $state, carteiras) {
			$scope.fornecedores = [];
			$scope.fornecedores.Logo = [];
			$scope.searching = false;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroFornecedor") : {};
            $scope.carteiras = carteiras;

			$scope.orderBy = {
				column: "Nome",
				order: "asc"
			};

			var updateList = function (list) {
				$scope.fornecedores = list;
				$scope.fornecedores.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.fornecedores.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			var getOdataSearch = function () {
				return getOdataSearchShared(FornecedorResource, $scope.search, $scope.orderBy, $odata, utils);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroFornecedor', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			var deleteRecord = function (data) {
				return FornecedorResource.delete({ FornecedorId: data.FornecedorId }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.fornecedores.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			updateList(fornecedores);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroFornecedor');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, { storage: true });
				}
				else {
					$state.go('main.fornecedores.list', { storage: true });
				}
			};
		}]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("FornecedorResource", ["$odataresource", function ($odataresource) {
			return $odataresource("Fornecedor/:FornecedorId", {
				"FornecedorId": "@FornecedorId"
			});
		}]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('GrupoEditData', function GrupoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    grupo: ["GrupoResource", "$stateParams", function (GrupoResource, $stateParams) {
                        if ($stateParams.GrupoId) {
                            return GrupoResource.get({
                                GrupoId: $stateParams.GrupoId
                            }).$promise;
                        } else {
                            return { TabuladorLivre: 1, TabuladorNaoDisponivel: 3 };
                        }
                    }],
                    tipos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getTipos().$promise;
                    }],
                    jornadas: ["JornadaTrabalhoResource", function (JornadaTrabalhoResource) {
                        return JornadaTrabalhoResource.getJornadaTrabalhoPorGrupo({
                            grupoId: 0
                        }).$promise; //Traz todas as Jornadas do Sistema;
                    }],
                    intervalos: ["RamalStatusResourceDetalhe", "$stateParams", function (RamalStatusResourceDetalhe, $stateParams) {
                        if ($stateParams.GrupoId) {
                            return RamalStatusResourceDetalhe.getStatusDetalhePorGrupo({
                                grupoId: $stateParams.GrupoId
                            }).$promise;
                        }
                        else {
                            return RamalStatusResourceDetalhe.odata().filter('Ativo', true).filter('CategoriaIntervaloId', 1)
                                .orderBy("RamalStatusDetalheId", "asc").query();
                        }
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.odata().select("GrupoId", "Descricao", "Ramal").expand("Ramal").orderBy("Ramal/Numero", "asc").query();
                    }],
                    servicos: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.lookup().$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    maquinas: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }],
                    smsTemplate: ["SmsTemplateResource", function (SmsTemplateResource) {
                        return SmsTemplateResource.odata()
                            .orderBy("Descricao", "asc")
                            .query();
                    }],
                    FilaVirtualPorGrupoId: ["GrupoFilaVirtualResource", "$stateParams", function(GrupoFilaVirtualResource, $stateParams){
                        if($stateParams.GrupoId){
                            return GrupoFilaVirtualResource.GetFilaVirtualPorGrupoId({
                                grupoId: $stateParams.GrupoId
                            }).$promise
                        }else
                            return [];
                    }],
                    campanhas: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.odata()
                            .orderBy("Nome", "asc")
                            .filter("CampanhaTemplateId", "=", 2)
                            .query();
                    }],
                    grupoRamalStatusDetalhe: ["GrupoRamalStatusDetalheResource", "$stateParams", function(GrupoRamalStatusDetalheResource, $stateParams){
                        if ($stateParams.GrupoId)
                            return GrupoRamalStatusDetalheResource.GetIntervalosGrupo({
                                GrupoId: $stateParams.GrupoId
                            }).$promise;
                        else
                            return [];
                    }],
                    gruposOperacionalAssociado: ["GrupoResource", "$stateParams", function(GrupoResource, $stateParams){
                        if ($stateParams.GrupoId)
                            return GrupoResource.getGruposOperacionalAssociado({
                                grupoOperacionalId: $stateParams.GrupoId
                            }).$promise;
                        else
                            return [];
                    }],
                    gruposOperacionalNaoAssociado: ["GrupoResource", "$stateParams", function(GrupoResource, $stateParams){
                        var id = parseInt($stateParams.GrupoId);
                        if(!id) id = 0;
                        return GrupoResource.getGruposOperacionalNaoAssociado({
                            grupoOperacionalId: id
                        }).$promise;
                    }],
                }
            }
        })

        .filter('filtroRamal', function () {
            return function (filtered, items, search) {
                return _.filter(items, function (item) {
                    return item.Numero.toString().startsWith(search.NumeroRamal) && (item.UsuarioNome.toUpperCase().indexOf(search.Usuario.toUpperCase()) >= 0);
                });
            }
        })

        .controller("GrupoEditController", ["$scope", "$window", "$state", "$q", "$timeout", "grupo", "tipos", "intervalos", "jornadas", "WizardHandler", "GrupoResource", "TranslateService", "JornadaTrabalhoResource", "RamalStatusResourceDetalhe", "CategoriaIntervaloResource", "$stateParams", "RamalResource", "grupos", "servicos", "NotifyService", "$translate", "ModalService", "carteiras", "smsTemplate", "GrupoFilaVirtualResource", "FilaVirtualPorGrupoId", "campanhas", "grupoRamalStatusDetalhe", "GrupoRamalStatusDetalheResource", "UsuarioChatResource", "gruposOperacionalAssociado", "gruposOperacionalNaoAssociado", function ($scope, $window, $state, $q, $timeout, grupo, tipos, intervalos, jornadas, WizardHandler, GrupoResource, TranslateService,
            JornadaTrabalhoResource, RamalStatusResourceDetalhe, CategoriaIntervaloResource, $stateParams, RamalResource, grupos, servicos, NotifyService,
            $translate, ModalService, carteiras, smsTemplate, GrupoFilaVirtualResource, FilaVirtualPorGrupoId, campanhas, grupoRamalStatusDetalhe, GrupoRamalStatusDetalheResource, UsuarioChatResource,
            gruposOperacionalAssociado, gruposOperacionalNaoAssociado) {
            $scope.RAMAL_PA = 1;
            $scope.RAMAL_TALKBOT = 6;
            $scope.GRUPO_TALKBOT = 3;
            $scope.GRUPO_PADRAO = 1;
            $scope.GRUPO_OPERACIONAL = 4;
            grupo.GrupoId = (grupo.GrupoId > 0 ? grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 : parseInt($stateParams.GrupoId)));
            $scope.isNew = grupo.GrupoId > 0 ? false : true;

            if ($scope.isNew) {
                GrupoResource.validarLimiteGrupo().$promise.then(function (result) {
                    if (!result.PodeCriar) {
                        ModalService.alert('telaGrupoEdit.limiteGrupoAtingido', null, function () {
                            $scope.$apply(function () {
                                $state.go('main.grupos.list');
                            });
                        });
                    }
                });
            }
            $scope.grupoId = $scope.isNew ? 0 : grupo.GrupoId;
            grupo.desabilitarTipo = $stateParams.tipogrupo == null ? false : true;
            $scope.carteiras = carteiras;

            if (grupo.GrupoId == 0) {
                grupo.GrupoTipoId = $stateParams.tipogrupo == 6 ? 3 : $stateParams.tipogrupo == null ? 0 : 1
            }

            $scope.grupo = grupo;
            $scope.intervaloList = intervalos;
            $scope.jornadaList = jornadas;
            $scope.forms = {};
            $scope.submitted = false;
            $scope.grupoAlterado = false;
            $scope.jornadaPeriodoList = [];
            $scope.grupo.JornadaTrabalhoId = null;
            $scope.jornadaSelecionadaId = 0;
            $scope.tipos = tipos;
            $scope.transbordos = [];
            $scope.salvando = false;
            $scope.smsTemplate = smsTemplate || [];
            $scope.grupoFilaVirtual = FilaVirtualPorGrupoId[0] || {};
            $scope.campanhas = campanhas;
            $scope.grupoRamalStatusDetalhe = grupoRamalStatusDetalhe;
            $scope.gruposOperacionalAssociado = gruposOperacionalAssociado;
            $scope.gruposOperacionalNaoAssociado = gruposOperacionalNaoAssociado;
            $scope.descricoesColunasGruposOperacional = {
                GrupoId: 'telaGrupoEdit.codigoGrupo',
                Descricao: 'telaGrupoEdit.nomeGrupo'
            };
            
            var removerIntervaloEmligacao = function(){
                
                let removerEmligacao = $scope.intervaloList.find(l => l.RamalStatusDetalheId == 5);

                let indexCliente = $scope.intervaloList.indexOf(removerEmligacao);

                $scope.intervaloList.splice(indexCliente, 1);

            }
            removerIntervaloEmligacao();

            grupos.forEach(function (el) {
                if (el.Ramal && el.Ramal.Numero) {
                    var newObj = {};
                    newObj.Descricao = el.Ramal.Numero + ' - ' + el.Descricao;
                    newObj.Numero = el.Ramal.Numero;
                    $scope.transbordos.push(newObj);
                }
            });

            $scope.transbordos.unshift({ Numero: 2, Descricao: $translate.instant('telaGrupoEdit.transbordo') });
            $scope.transbordos.unshift({ Numero: 0, Descricao: $translate.instant('telaGrupoEdit.fila') });
            $scope.transbordos.unshift({ Numero: 1, Descricao: $translate.instant('telaGrupoEdit.desliga') });

            $scope.QtdsFila = [
                { descricao: $translate.instant('telaGrupoEdit.infinito'), valor: -1 },
                { descricao: $translate.instant('telaGrupoEdit.semFila'), valor: 0 },
                { descricao: '1', valor: 1 },
                { descricao: '2', valor: 2 },
                { descricao: '3', valor: 3 },
                { descricao: '6', valor: 6 },
                { descricao: '9', valor: 9 },
                { descricao: '12', valor: 12 },
                { descricao: '15', valor: 15 }
            ];

            $scope.GrupoStepData = {
                order: 1
            };

            $scope.IntervaloStepData = {
                order: 1,
                inside: 1,
                notVisible: true
            };

            $scope.IntervaloDetalheStepData = {
                order: 1,
                inside: 2,
                notVisible: true
            };

            $scope.RamalStepData = {
                order: 2
            };

            $scope.FilaVirtualStepData = {
                order: 3
            };

            $scope.ChatStepData = {
                order: 4,
                notVisible: true
            };

            $scope.ChatUsuarioStepData = {
                order: 4,
                inside: 1,
                notVisible: true
            };

            $scope.GrupoOperacionalStepData = {
                order: 2,
                notVisible: true
            };

            $scope.EstrategiaStepData = {
                order: 3,
                notVisible: true
            };

            var goToStepData = function (stepData) {
                var steps = WizardHandler.wizard().getEnabledSteps();
                for (var i = 0; i < steps.length; i++) {
                    if (steps[i].wzData === stepData) {
                        WizardHandler.wizard().goTo(i);
                        return;
                    }
                }
            };

            $scope.ESTRATEGIA_SKILL = 4;
            $scope.ESTRATEGIA_SKILL_TMA = 5;
            $scope.estrategias = [
                {
                    Id: $scope.ESTRATEGIA_SKILL,
                    Descricao: $translate.instant('telaGrupoEdit.estrategia4Label'),
                    DescricaoBox: $translate.instant('telaGrupoEdit.estrategia4DescricaoBox'),
                    ComoFunciona: $translate.instant('telaGrupoEdit.estrategia4ComoFunciona'),
                    Aplicacao: $translate.instant('telaGrupoEdit.estrategiaAplicacao')
                },
                {
                    Id: $scope.ESTRATEGIA_SKILL_TMA,
                    Descricao: $translate.instant('telaGrupoEdit.estrategia5Label'),
                    DescricaoBox: $translate.instant('telaGrupoEdit.estrategia5DescricaoBox'),
                    ComoFunciona: $translate.instant('telaGrupoEdit.estrategia5ComoFunciona'),
                    Aplicacao: $translate.instant('telaGrupoEdit.estrategiaAplicacao')
                }
            ];

            $scope.estrategiaSelecionada = null;
            $scope.$watch('grupo.Estrategia', function (newVal) {
                if (newVal) {
                    $scope.estrategiaSelecionada = _.findWhere($scope.estrategias, { Id: parseInt(newVal) });
                } else {
                    $scope.estrategiaSelecionada = null;
                }
            });

            $scope.servicos = servicos;

            if (grupo.Ramal && grupo.Ramal.Numero) {
                $scope.grupo.RamalNumero = grupo.Ramal.Numero;
            }

            var carregaIntervalos = function (newintervalos) {
                if (newintervalos) {
                    $scope.intervaloList = newintervalos;
                }
            };

            var jornadaSelecionada = function () {
                if ($scope.grupo.GrupoId) {
                    JornadaTrabalhoResource.getJornadaTrabalhoPorGrupo({
                        grupoId: $scope.grupo.GrupoId
                    }).$promise.then((result) => {
                        $scope.grupo.JornadaTrabalhoId = result.length ? result[0].JornadaId : 0;
                        $scope.jornadaSelecionadaId = $scope.grupo.JornadaTrabalhoId;
                    });
                }
                if ($scope.forms.formGrupo)
                    $scope.forms.formGrupo.$setPristine();
            }

            jornadaSelecionada();

            $scope.viewDetalheJornada = function () {
                var jornadaid = $scope.grupo.JornadaTrabalhoId

                if (jornadaid > 0) {
                    JornadaTrabalhoResource.getJornadaPeriodo({ JornadaId: jornadaid }).$promise
                        .then((data) => {
                            angular.copy(data, $scope.jornadaPeriodoList);
                            var format = TranslateService.getAngularTimeFormat();
                            $scope.jornadaPeriodoList.forEach((periodo) => {
                                periodo.Entrada = moment(periodo.Entrada, "HH:mm").format(format);
                                periodo.Saida = moment(periodo.Saida, "HH:mm").format(format);
                            });
                            ModalService.openModal('modalJornada');
                        }).catch(() => {
                            NotifyService.showError(null, 'telaGrupoEdit.erroAoCarregarJornada');
                        });
                } else {
                    NotifyService.showMessage('telaGrupoEdit.selecioneJornadaValida', "warning");
                }
            }

            var mensagemSucesso = function () {
                NotifyService.showRegistroSalvo();
                $scope.submitted = false;
                if ($stateParams.page)
                    $state.go($stateParams.page, {
                        storage: true,
                        grupo: grupo.GrupoId
                    });
            }

            $scope.salvar = function (form) {
                let stepIntervalo = form.$name == "forms.formIntervalo" ? true : false;
                var lastStep = form.$name == "forms.formFilaVirtual" ? true : false;
                if (!form.$valid) return form.$setSubmitted();

                if(form.$name =="forms.formIntervaloDetalhe"){
                    form.$setPristine();
                    WizardHandler.wizard().goTo(3);
                }

                if ((!form.$dirty && !lastStep) || ($scope.isNew && !lastStep && !stepIntervalo)) {
                    if (form.$name == "forms.formGrupo" && ($scope.grupo.GrupoTipoId == 1 || $scope.grupo.GrupoTipoId == 3)) {
                        WizardHandler.wizard().goTo(1);
                    }
                    else if (form.$name == "forms.formGrupo" && ($scope.grupo.GrupoTipoId == 2)) {
                        WizardHandler.wizard().goTo(3);
                    }
                    else if (form.$name == "forms.formGrupo" && $scope.grupo.GrupoTipoId == $scope.GRUPO_OPERACIONAL) {
                        goToStepData($scope.GrupoOperacionalStepData);
                    }
                    else if (form.$name == "forms.formIntervalo") {
                        if($scope.grupo.GrupoTipoId == 1)
                            WizardHandler.wizard().goTo(2);
                        else
                            WizardHandler.wizard().goTo(3);
                    }
                    else if (form.$name == "forms.formIntervaloDetalhe") {
                        WizardHandler.wizard().goTo(3);
                    } else {
                        WizardHandler.wizard().goTo(4);
                    }
                } else {
                    if (!form.$valid) return NotifyService.showInvalid();

                    if (!$scope.isNew) {
                        if (form.$name == "forms.formGrupo") {
                            $scope.submitted = true;
                            salvarGrupo().then((data) => {
                                angular.copy(data, $scope.grupo);
                                $stateParams.GrupoId = $scope.grupo.GrupoId;
                                mensagemSucesso();
                                form.$setPristine();
                                if ($scope.grupo.GrupoTipoId == $scope.GRUPO_OPERACIONAL) {
                                    goToStepData($scope.GrupoOperacionalStepData);
                                } else if ($scope.grupo.GrupoTipoId == 2) {
                                    WizardHandler.wizard().goTo(3);
                                } else {
                                    WizardHandler.wizard().goTo(1);
                                }
                            }).catch(NotifyService.showError);
                            form.$setPristine();
                        } else if (form.$name == "forms.formIntervalo") {
                            salvarIntervaloInicial().then(() => {
                                $q.all(salvarCategorias()).then(data => {
                                    GrupoRamalStatusDetalheResource.GetIntervalosGrupo({
                                        GrupoId: $stateParams.GrupoId
                                    }).$promise.then(data => {
                                        $scope.grupoRamalStatusDetalhe = data;
                                    }).catch(error => {NotifyService.showError(error)})

                                }).catch(NotifyService.showError);

                                form.$setPristine();
                            });
                            salvarGrupo().then((data) => {
                                angular.copy(data, $scope.grupo);
                                $stateParams.GrupoId = $scope.grupo.GrupoId;
                                mensagemSucesso();
                                form.$setPristine();
                            }).catch(NotifyService.showError);
                        } else if (form.$name == "forms.formRamal") {
                            if (form.$dirty) {
                                $q.all(salvarRamal()).then(() => {
                                    mensagemSucesso();
                                    form.$setPristine();
                                    $scope.getRamaisNaoAssociados();
                                    $scope.getRamaisAssociados();
                                }).catch(NotifyService.showError);
                            }

                        } else if (form.$name == "forms.formChat") {
                            if (form.$dirty) {
                                $q.all($scope.salvarChatGrupo()).then(() => {
                                    mensagemSucesso();
                                    form.$setPristine();
                                    $scope.getChatAssociado();
                                    $scope.getChatNaoAssociado();
                                }).catch(NotifyService.showError);
                            }

                        }else if (lastStep) {
                            if (form.$dirty) {

                                salvarGrupo().then((data) => {
                                    angular.copy(data, $scope.grupo);
                                    $stateParams.GrupoId = $scope.grupo.GrupoId;
                                    mensagemSucesso();
                                    form.$setPristine();
                                }).catch(NotifyService.showError);

                                var promises = [];
                                promises = promises.concat(salvarFilaVirtual());
                                promises = promises.concat($scope.salvarChatGrupo());
                                
                                $q.all(promises).then(() => {
                                    mensagemSucesso();
                                }).catch(NotifyService.showError);
                            }

                            if (!form.$dirty) {
                                $state.go('main.grupos.list', {
                                    storage: true
                                });
                            } else {
                                form.$setPristine();
                                $scope.grupoAlterado = false;
                            }
                        }
                    } else {
                        if (!$scope.validateGrupo()) return NotifyService.showInvalid();
                        if (!$scope.validateIntervalo()) return NotifyService.showInvalid();

                        $scope.salvando = true;
                        $scope.submitted = true;

                        if (stepIntervalo) {
                            salvarGrupo().then(data => {
                                angular.copy(data, $scope.grupo);

                                GrupoRamalStatusDetalheResource.GetIntervalosGrupo({
                                    GrupoId: $scope.grupo.GrupoId
                                }).$promise.then(data => {
                                    $scope.grupoRamalStatusDetalhe = data;
                                }).catch(error => {NotifyService.showError(error)});

                                $stateParams.GrupoId = $scope.grupo.GrupoId;
                                $q.all(salvarCategorias()).then(() => {

                                    if($scope.grupo.GrupoTipoId == 1)
                                        WizardHandler.wizard().goTo(2);
                                    else
                                        WizardHandler.wizard().goTo(3);

                                    mensagemSucesso();
                                });
                            }).catch(error => {
                                tratarErroGrupo(error);
                            }).finally(() => {
                                $scope.salvando = false;
                                $scope.submitted = false;
                            });
                        }
                        if (lastStep) {
                            let redirectPage = $stateParams.page != null ? $stateParams.page : 'main.grupos.list';

                            if ($scope.grupo.GrupoTipoId == 2) {
                                salvarGrupo().then(data => {
                                    angular.copy(data, $scope.grupo);
                                    $stateParams.GrupoId = $scope.grupo.GrupoId;
                                    $q.all(salvarRamal()).then(() => {
                                        mensagemSucesso();
                                        $state.go(redirectPage, {
                                            storage: true
                                        });
                                    });
                                }).catch(error => {
                                    tratarErroGrupo(error);
                                }).finally(() => {
                                    $scope.salvando = false;
                                    $scope.submitted = false;
                                });
                            }
                            else if (form.$name == "forms.formRamal") {
                                $q.all(salvarRamal()).then(() => {
                                    mensagemSucesso();
                                    $state.go(redirectPage, {
                                        storage: true
                                    });
                                }).catch(error => {
                                    $scope.salvando = false;
                                    NotifyService.showError(error);
                                });
                            }else{

                                salvarGrupo().then(data => {
                                    angular.copy(data, $scope.grupo);
                                    $stateParams.GrupoId = $scope.grupo.GrupoId;
                                    $q.all(salvarCategorias()).then(() => {
                                        if(!lastStep) WizardHandler.wizard().goTo(2);
                                        mensagemSucesso();
                                    });
                                });
                                
                                var promises = [];
                                promises = promises.concat(salvarFilaVirtual());
                                promises = promises.concat($scope.salvarChatGrupo());
                                
                                $q.all(promises).then(() => {
                                    mensagemSucesso();
                                    $state.go(redirectPage, {
                                        storage: true
                                    });
                                }).catch(error => {
                                    $scope.salvando = false;
                                    NotifyService.showError(error);
                                });

                            }
                        }
                    }
                }
            }

            var salvarFilaVirtual = function () {
                var promise;

                $scope.grupoFilaVirtual.GrupoId = $scope.grupo.GrupoId;

                if ($scope.grupoFilaVirtual.Id > 0) {
                    promise = GrupoFilaVirtualResource.update($scope.grupoFilaVirtual).$promise;
                } else {
                    promise = GrupoFilaVirtualResource.save($scope.grupoFilaVirtual).$promise;
                }

                return promise;
            };

            var tratarErroGrupo = function (error) {
                var mensagem = error && error.data ? (error.data.Message || error.data.message || '') : '';
                if (error && error.status === 400 && mensagem.indexOf('limite de quantidade') > -1) {
                    ModalService.alert('telaGrupoEdit.limiteGrupoAtingido');
                } else {
                    NotifyService.showError(error);
                }
            };

            var salvarGrupo = function () {
                var promise;

                if ($scope.grupo.GrupoId > 0) {
                    if (!$scope.grupo.RamalNumero) $scope.grupo.RamalNumero = null;

                    if($scope.isNew && $scope.grupo.StatusIntegracaoId == 1) $scope.grupo.StatusIntegracaoId = 2;

                    promise = GrupoResource.update($scope.grupo).$promise;
                } else {
                    promise = GrupoResource.save($scope.grupo).$promise;
                }

                return promise;
            };

            var salvarIntervaloInicial = function () {
                if ($scope.grupo.GrupoId > 0) {
                    var promise = GrupoResource.alterarIntervaloInicial({
                        GrupoId: $scope.grupo.GrupoId,
                        RamalStatusDetalheId: $scope.grupo.RamalStatusDetalheId

                    }).$promise;
                }
                return promise;
            }

            var salvarCategorias = function () {
                var allpromises = [];
                if ($scope.grupo.GrupoId > 0) {

                    if ($scope.categoriasAdicionados.length) {
                        var categoriasAdicionados = _.where($scope.categoriasAdicionados, {
                            Alterado: true
                        });

                        angular.forEach(categoriasAdicionados, (value) => {
                            value.Alterado = false;
                            allpromises.push(CategoriaIntervaloResource.adicionarGrupo({
                                CategoriaIntervaloId: value.CategoriaIntervaloId,
                                GrupoId: $scope.grupo.GrupoId,
                            }).$promise);
                        });
                    }

                    if ($scope.categorias.length) {
                        var categorias = _.where($scope.categorias, {
                            Alterado: true
                        });

                        angular.forEach(categorias, (value) => {
                            value.Alterado = false;
                            allpromises.push(CategoriaIntervaloResource.removerGrupo({
                                CategoriaIntervaloId: value.CategoriaIntervaloId,
                                GrupoId: $scope.grupo.GrupoId,
                            }).$promise);
                        });
                    }
                }

                return allpromises;
            }

            var salvarRamal = function () {
                var allpromises = [];
                if ($scope.grupoAlterado) {
                    //Ramais a serem adicionados
                    var ramaisStringAdd = _.pluck(_.where($scope.ramaisAdicionados, { Alterado: true }), 'RamalId').join(",");
                    var ordensStringAdd = _.pluck(_.where($scope.ramaisAdicionados, { Alterado: true }), 'Ordem').join(",");

                    var ramaisordensStringUpdate = _.pluck(_.where($scope.ramaisAdicionados, {
                        OrdemAlterado: true,
                        Alterado: false
                    }), 'RamalId').join(",");

                    var ordensStringUpdate = _.pluck(_.where($scope.ramaisAdicionados, {
                        OrdemAlterado: true,
                        Alterado: false
                    }), 'Ordem').join(",");

                    angular.forEach(_.where($scope.ramaisAdicionados, { Alterado: true }), (value) => { value.Alterado = false; });
                    angular.forEach(_.where($scope.ramaisAdicionados, { OrdemAlterado: true }), (value) => { value.OrdemAlterado = false; });

                    if (ramaisStringAdd && $scope.grupo.GrupoId > 0) {
                        allpromises.push(GrupoResource.adicionarRamal({
                            GrupoId: $scope.grupo.GrupoId,
                            Ramais: ramaisStringAdd,
                            Ordens: ordensStringAdd
                        }).$promise);
                    }

                    if (ramaisordensStringUpdate && $scope.grupo.GrupoId > 0) {
                        allpromises.push(GrupoResource.atualizarOrdem({
                            GrupoId: $scope.grupo.GrupoId,
                            Ramais: ramaisordensStringUpdate,
                            Ordens: ordensStringUpdate
                        }).$promise);
                    }

                    //Ramais a serem removidos
                    var ramaisStringRemove = _.pluck(_.where($scope.ramais, { Alterado: true }), 'RamalId').join(",");

                    angular.forEach(_.where($scope.ramais, { Alterado: true }), (value) => { value.Alterado = false; });

                    if (ramaisStringRemove && $scope.grupo.GrupoId > 0) {
                        allpromises.push(GrupoResource.removerRamal({
                            GrupoId: $scope.grupo.GrupoId,
                            Ramais: ramaisStringRemove
                        }).$promise);
                    }
                }

                return allpromises;
            }

            $scope.validateGrupo = function () {
                var alterado = $scope.isNew ? false : $scope.forms.formGrupo.$dirty;
                var proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formGrupo.$dirty = false;
                        $scope.forms.formGrupo.$setPristine();
                    })
                } else {
                    if ($scope.forms.formGrupo.$valid) {
                        proximoStep = true;
                    }
                }
                return proximoStep;
            };

            $scope.validateIntervalo = function () {
                var alterado = $scope.isNew ? false : $scope.forms.formIntervalo.$dirty;
                var proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formIntervalo.$dirty = false;
                        $scope.forms.formIntervalo.$setPristine();
                    });
                } else {
                    if ($scope.forms.formIntervalo.$valid) {
                        proximoStep = true;
                    }
                }
                return proximoStep;
            };

            $scope.validateIntervaloDetalhe = function () {
                var alterado = $scope.isNew ? false : $scope.forms.formIntervaloDetalhe.$dirty;
                var proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formIntervaloDetalhe.$dirty = false;
                        $scope.forms.formIntervaloDetalhe.$setPristine();
                    });
                } else {
                    if ($scope.forms.formIntervaloDetalhe.$valid) {
                        proximoStep = true;
                    }
                }
                return proximoStep;
            };

            $scope.validateForm = function (form) {
                if (!form.$valid) {
                    form.$setSubmitted();
                    return;
                }
            }

            //Pesquisa
            $scope.search = {
                StatusIntegracaoId: 2,
                NumeroRamal: '',
                Usuario: ''
            };
            $scope.ramaisAdicionados = [];
            $scope.ramais = [];
            $scope.tipoPesquisa = 0;
            $scope.limitRamais = 5;
            $scope.limitRamaisAdicionados = 5;

            //Ramais
            $scope.getRamaisNaoAssociados = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));

                var carteiraId = ($scope.grupo ? ($scope.grupo.CarteiraId > 0 ? $scope.grupo.CarteiraId : 0) : 0);

                var ramalTipoId = $scope.grupo.GrupoTipoId == $scope.GRUPO_TALKBOT ? $scope.RAMAL_TALKBOT : $scope.RAMAL_PA;
                GrupoResource.getRamaisNaoAssociados({
                    grupoId: grupoId,
                    numero: $scope.search.NumeroRamal,
                    usuario: $scope.search.Usuario,
                    carteiraId: carteiraId,
                    ramalTipoId: ramalTipoId
                }).$promise.then((data) => {
                    angular.copy(data, $scope.ramais);
                });
            };

            //Ramais Associados
            $scope.getRamaisAssociados = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));

                var carteiraId = ($scope.grupo ? ($scope.grupo.CarteiraId > 0 ? $scope.grupo.CarteiraId : 0) : 0);

                GrupoResource.getRamaisAssociados({
                    grupoId: grupoId,
                    carteiraId: carteiraId,
                    numero: $scope.search.NumeroRamal,
                    usuario: $scope.search.Usuario
                }).$promise.then((data) => {
                    angular.copy(data, $scope.ramaisAdicionados);
                });
            };

            $scope.changeTipo = function () {
                $scope.IntervaloStepData.notVisible = true;
                $scope.IntervaloDetalheStepData.notVisible = true;
                $scope.RamalStepData.notVisible = false;
                $scope.FilaVirtualStepData.notVisible = false;
                $scope.GrupoOperacionalStepData.notVisible = true;
                $scope.EstrategiaStepData.notVisible = true;
                if ($scope.grupo.GrupoTipoId == 1 || $scope.grupo.GrupoTipoId == 3) {
                    $scope.IntervaloStepData.notVisible = false;
                    if($scope.grupo.GrupoTipoId == 1)
                        $scope.IntervaloDetalheStepData.notVisible = false;
                }
                if ($scope.grupo.GrupoTipoId == $scope.GRUPO_OPERACIONAL) {
                    $scope.RamalStepData.notVisible = true;
                    $scope.FilaVirtualStepData.notVisible = true;
                    $scope.GrupoOperacionalStepData.notVisible = false;
                    $scope.EstrategiaStepData.notVisible = false;
                    if (!$scope.grupo.Estrategia) {
                        $scope.grupo.Estrategia = $scope.ESTRATEGIA_SKILL;
                    }
                }
                $scope.getRamaisAssociados();
                $scope.getRamaisNaoAssociados();
            }

            $scope.changeTipo();

            $scope.onChangeCarteira = function () {
                $scope.getRamaisAssociados();
                $scope.getRamaisNaoAssociados();
            }

            /* Adicionar e remover ramais */
            $scope.adicionar = function () {
                var ramaisSelecionados = _.where($scope.ramais, { Selecionado: true });
                angular.forEach(ramaisSelecionados, (value) => {
                    $scope.ramais.splice($scope.ramais.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Adicionado = true;

                    if (value.Removido && value.Alterado) {
                        value.Removido = false;
                        value.Alterado = false;
                        value.OrdemAlterado = true;
                    } else {
                        value.Alterado = true;
                        value.OrdemAlterado = false;
                    }

                    if ($scope.grupo.FilaLinear) {
                        if ($scope.ramaisAdicionados.length > 0) {

                            let ultimaOrdem = Math.max.apply(Math, $scope.ramaisAdicionados.map(function (o) { return o.Ordem; }))

                            if (ultimaOrdem) {
                                value.Ordem = ultimaOrdem + 1;
                            } else {
                                value.Ordem = 1;
                            }
                        } else {
                            value.Ordem = 1;
                        }
                    } else {
                        value.Ordem = 0;
                    }


                    $scope.ramaisAdicionados.push(value);
                });

                $scope.grupoAlterado = true;
            };

            $scope.remover = function () {
                var ramaisSelecionados = _.where($scope.ramaisAdicionados, {
                    Selecionado: true
                });
                angular.forEach(ramaisSelecionados, (value) => {
                    $scope.ramaisAdicionados.splice($scope.ramaisAdicionados.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Removido = true;

                    if (value.Adicionado && value.Alterado) {
                        value.Adicionado = false;
                        value.Alterado = false;
                    } else value.Alterado = true;

                    value.OrdemAlterado = false;
                    $scope.ramais.push(value);
                });

                $scope.grupoAlterado = true;
            };

            $scope.selectionarTodosAdicionados = function (selecionado) {
                angular.forEach($scope.ramaisAdicionados, (item) => {
                    if (selecionado && !item.GrupoPadrao) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.selectionarTodosNaoAdicionados = function (selecionado) {
                angular.forEach($scope.ramais, (item) => {
                    if (selecionado) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            //Ramais Adicionados
            $scope.maisRamaisAdicionados = function () {
                if ($scope.limitRamaisAdicionados < $scope.ramaisAdicionados.length) {
                    $scope.limitRamaisAdicionados += 5;
                    $("#ramaisAdicionados").animate({
                        scrollTop: $("#tabRamaisAdicionados").height()
                    }, 800);
                }
            };

            $("#ramaisAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitRamaisAdicionados < $scope.ramaisAdicionados.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitRamaisAdicionados += 5;
                            $("#ramaisAdicionados").animate({
                                scrollTop: $("#tabRamaisAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            //Ramais Não Adicionado
            $scope.maisRamaisNaoAdicionados = function () {
                if ($scope.limitRamais < $scope.ramais.length) {
                    $scope.limitRamais += 5;
                    $("#ramaisNaoAdicionados").animate({
                        scrollTop: $("#tabRamaisNaoAdicionados").height()
                    }, 800);
                }
            };

            $("#ramaisNaoAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitRamais < $scope.ramais.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitRamais += 5;
                            $("#ramaisNaoAdicionados").animate({
                                scrollTop: $("#tabRamaisNaoAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            $scope.getRamaisAssociados();
            $scope.getRamaisNaoAssociados();

            $scope.alteraGrupoDefault = function (ramal) {
                ramal.GrupoPadraoAtivo = ramal.GrupoPadrao;
                ramal.GrupoPadrao = ramal.GrupoPadraoAtual != undefined ? ramal.GrupoPadraoAtual : false;

                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));

                $window.UIkit.modal.confirm($translate.instant('telaGrupoEdit.confirmarAlteracaoGrupoPadrao'), () => {
                    ramal.GrupoPadrao = ramal.GrupoPadraoAtivo;
                    ramal.GrupoPadraoAtual = ramal.GrupoPadrao;
                    if (ramal.RamalId > 0) {
                        RamalResource.updateGrupoPadrao({ RamalId: ramal.RamalId, GrupoId: grupoId }).$promise
                            .then(mensagemSucesso)
                            .catch(NotifyService.showError);
                    }
                }, { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });

            }
            $scope.categoriasAdicionados = [];
            $scope.categorias = [];
            $scope.limitCategorias = 5;
            $scope.limitCategoriasAdicionados = 5;

            //Categorias
            $scope.getCategoriasNaoAssociados = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));
                CategoriaIntervaloResource.getCategoriaIntervaloPorGrupo({ grupoId: grupoId, contem: false }).$promise
                    .then((data) => {
                        if (!$scope.isNew) {
                            angular.copy(data, $scope.categorias);
                        } else {
                            angular.copy(data, $scope.categorias);
                            $scope.categorias.splice(_.findWhere($scope.categorias, {
                                Padrao: true
                            }), 1);
                        }
                        $scope.todosCategoriasNaoAdicionados = false;
                    });
            };

            //Categorias Associados
            $scope.getCategoriasAssociados = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));
                if (grupoId > 0)
                    CategoriaIntervaloResource.getCategoriaIntervaloPorGrupo({ grupoId: grupoId, contem: true }).$promise
                        .then((data) => {
                            angular.copy(data, $scope.categoriasAdicionados);
                            $scope.todosCategoriasAdicionados = false;
                        });

                //Insere a Categoria padrão como selecionada
                if ($scope.isNew) {
                    CategoriaIntervaloResource.odata().filter('Ativo', true).filter('Padrao', true).query()
                        .then((result) => {
                            angular.forEach(result, (value) => {
                                value.Padrao = true;
                                $scope.categoriasAdicionados.push(value);
                            });
                        });
                }
            };

            /* Adicionar e remover categorias */
            var reloadIntervalos = function (categorias) {
                var intervalosDisponiveis = [];
                var promises = [];

                if (categorias && categorias.length) {
                    var qtd = categorias.length;
                    angular.forEach(categorias, (value) => {
                        promises.push(RamalStatusResourceDetalhe.odata().filter('CategoriaIntervaloId', parseInt(value.CategoriaIntervaloId)).query()
                            .then((result) => {
                                if (result) {
                                    intervalosDisponiveis = intervalosDisponiveis.concat(result);
                                }
                                qtd -= 1;
                            }));
                    });

                    $q.all(promises).then(() => {
                        if (qtd == 0) {
                            carregaIntervalos(intervalosDisponiveis);
                        }
                    })
                }
            }

            $scope.adicionarCategoria = function () {
                var categoriaSelecionadas = _.where($scope.categorias, {
                    Selecionado: true
                });
                angular.forEach(categoriaSelecionadas, (value) => {
                    $scope.categorias.splice($scope.categorias.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Adicionado = true;
                    if (value.Removido && value.Alterado) {
                        value.Removido = false;
                        value.Alterado = false;
                    } else {
                        value.Alterado = true;
                    }
                    $scope.categoriasAdicionados.push(value);
                });

                $scope.categoriaAlterada = true;
                reloadIntervalos($scope.categoriasAdicionados);
            };

            $scope.removerCategoria = function () {
                var categoriaSelecionadas = _.where($scope.categoriasAdicionados, {
                    Selecionado: true
                });
                angular.forEach(categoriaSelecionadas, (value) => {
                    $scope.categoriasAdicionados.splice($scope.categoriasAdicionados.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Removido = true;

                    if (value.Adicionado && value.Alterado) {
                        value.Adicionado = false;
                        value.Alterado = false;
                    } else value.Alterado = true;

                    $scope.categorias.push(value);
                });

                $scope.categoriaAlterada = true;
                reloadIntervalos($scope.categoriasAdicionados);
            };

            $scope.selectionarTodosCategoriasAdicionados = function (selecionado) {
                angular.forEach($scope.categoriasAdicionados, (item) => {
                    if (selecionado && !item.Padrao) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.selectionarTodosCategoriasNaoAdicionados = function (selecionado) {
                angular.forEach($scope.categorias, (item) => {
                    if (selecionado) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            //Categorias Adicionados
            $scope.maisCategoriasAdicionados = function () {
                if ($scope.limitCategoriasAdicionados < $scope.categoriasAdicionados.length) {
                    $scope.limitCategoriasAdicionados += 5;
                    $("#categoriasAdicionados").animate({
                        scrollTop: $("#tabCategoriasAdicionados").height()
                    }, 800);
                }
            };

            $("#categoriasAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitCategoriasAdicionados < $scope.categoriasAdicionados.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitCategoriasAdicionados += 5;
                            $("#tabCategoriasAdicionados").animate({
                                scrollTop: $("#tabCategoriasAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            //Ramais Não Adicionado
            $scope.maisCategoriasNaoAdicionados = function () {
                if ($scope.limitCategorias < $scope.categorias.length) {
                    $scope.limitCategorias += 5;
                    $("#categoriasNaoAdicionados").animate({
                        scrollTop: $("#tabCategoriasNaoAdicionados").height()
                    }, 800);
                }
            };

            $("#categoriasNaoAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitCategorias < $scope.categorias.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitCategorias += 5;
                            $("#categoriasNaoAdicionados").animate({
                                scrollTop: $("#tabCategoriasNaoAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            $scope.getCategoriasNaoAssociados();
            $scope.getCategoriasAssociados();
            
            // Chat
            $scope.chatAssociado = [];
            $scope.chatNaoAssociado = [];
            $scope.temCanaisAssociados = false;
            $scope.descricoesColunasChat = {
                ChatCanalId : 'telaGrupoEdit.chatId',
                Descricao : 'telaGrupoEdit.canal'
            }

            $scope.getChatAssociado = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));
                
                if (grupoId > 0) {
                    GrupoResource.getChatAssociado({
                        grupoId: grupoId
                    }).$promise.then((data) => {
                        $scope.chatAssociado = data;
                    });
                }
            };

            $scope.getChatNaoAssociado = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));
                
                if (grupoId > 0) {
                    GrupoResource.getChatNaoAssociado({
                        grupoId: grupoId
                    }).$promise.then((data) => {
                        $scope.chatNaoAssociado = data;
                    });
                }
            };

            // Inicializar habilitação do chat - respeita o valor do objeto
            if ($scope.grupo.HabilitarChat === undefined || $scope.grupo.HabilitarChat === null) {
                $scope.grupo.HabilitarChat = false;
            }
            
            // Define visibilidade do step baseado no valor
            $scope.ChatStepData.notVisible = !$scope.grupo.HabilitarChat;
            $scope.ChatUsuarioStepData.notVisible = !$scope.grupo.HabilitarChat;
            
            // Carrega os dados se for edição
            if ($scope.grupo.GrupoId > 0) {
                $scope.getChatAssociado();
                $scope.getChatNaoAssociado();
            }

            $scope.onChangeHabilitarChat = function () {

                if ($scope.grupo.HabilitarChat === false) {
                    // Verifica se já existem canais associados no grupo
                    if ($scope.listaCanais && $scope.listaCanais.length > 0) {
                        NotifyService.showMessage('telaGrupoEdit.existeCanaisAssociados', "warning");
                        // Impede desmarcar
                        $scope.grupo.HabilitarChat = true;
                        $scope.desabilitarCheckboxChat = true;

                        // Reabilita o checkbox após breve intervalo
                        $timeout(function () {
                            $scope.desabilitarCheckboxChat = false;
                        }, 1000);
                    }
                }

                $scope.ChatStepData.notVisible = !$scope.grupo.HabilitarChat;
                // Chat Usuário só aparece se chat estiver habilitado E houver canais
                $scope.ChatUsuarioStepData.notVisible = !$scope.grupo.HabilitarChat || !$scope.listaCanais || $scope.listaCanais.length === 0;
                
                if (!$scope.grupo.HabilitarChat) {
                    // Se desabilitar, limpa as associações
                    $scope.chatAssociado = [];
                    $scope.chatSelecionado = null;
                    $scope.usuarioChatAssociado = [];
                    $scope.usuarioChatNaoAssociado = [];
                    $scope.listaCanais = [];
                    if ($scope.forms.formChat) {
                        $scope.forms.formChat.$setDirty();
                    }
                } else {
                    // Se habilitar, recarrega as listas
                    $scope.getChatAssociado();
                    $scope.getChatNaoAssociado();
                    $scope.carregarCanaisChat();
                }

                
            };

            $scope.onChatAdicionado = function (itens) {
                if ($scope.forms.formChat) {
                    $scope.forms.formChat.$setDirty();
                }
                // Atualiza flag para controlar o texto do botão
                $scope.temCanaisAssociados = $scope.chatAssociado && $scope.chatAssociado.length > 0;
            };

            $scope.onChatRemovido = function (itens) {
                if ($scope.forms.formChat) {
                    $scope.forms.formChat.$setDirty();
                }
                // Atualiza flag para controlar o texto do botão
                $scope.temCanaisAssociados = $scope.chatAssociado && $scope.chatAssociado.length > 0;
            };

            $scope.getChatAssociado = function () {
                var grupoId = ($scope.grupo ? ($scope.grupo.GrupoId > 0 ? $scope.grupo.GrupoId : (isNaN(parseInt($stateParams.GrupoId)) ? 0 :
                    parseInt($stateParams.GrupoId))) : parseInt($stateParams.GrupoId));
                
                if (grupoId > 0) {
                    GrupoResource.getChatAssociado({
                        grupoId: grupoId
                    }).$promise.then((data) => {
                        angular.copy(data, $scope.chatAssociado);
                        // Atualiza flag para controlar o texto do botão
                        $scope.temCanaisAssociados = $scope.chatAssociado && $scope.chatAssociado.length > 0;
                    });
                }
            };

            $scope.salvarChatGrupo = function () {
                var allpromises = [];
                if ($scope.grupo.GrupoId > 0) {
                    var chatIds = _.pluck($scope.chatAssociado, 'ChatCanalId');
                    
                    // Garante que seja um array válido
                    if (!chatIds) {
                        chatIds = [];
                    }
                    
                    allpromises.push(GrupoResource.salvarChatGrupo({
                        GrupoId: $scope.grupo.GrupoId,
                        ChatAssociado: chatIds
                    }).$promise);
                }
                return allpromises;
            };

            $scope.salvarEProximo = function (form) {
                if (!form.$valid) return form.$setSubmitted();
                
                if (form.$dirty) {
                    // Salva as mudanças da Fila Virtual
                    var promises = [];
                    promises = promises.concat(salvarFilaVirtual());
                    
                    $q.all(promises).then(() => {
                        NotifyService.showSuccess();
                        form.$setPristine();
                        // Vai para o próximo step (Chat)
                        WizardHandler.wizard().next();
                    }).catch(NotifyService.showError);
                } else {
                    // Se não há mudanças, apenas vai para o próximo step
                    WizardHandler.wizard().next();
                }
            };

            $scope.finalizarChatGrupo = function (form) {
                if (!form.$valid) return form.$setSubmitted();
                
                let redirectPage = $stateParams.page != null ? $stateParams.page : 'main.grupos.list';
                
                if (form.$dirty && $scope.grupo.GrupoId > 0) {
                    $scope.salvando = true;
                    
                    // Salva as associações de chat
                    var promises = $scope.salvarChatGrupo();
                    
                    if (promises && promises.length > 0) {
                        $q.all(promises).then(() => {
                            NotifyService.showSuccess();
                            form.$setPristine();
                            $scope.salvando = false;
                            
                            // Carrega a lista de canais e verifica se há canais
                            return GrupoResource.getChatAssociado({
                                grupoId: $scope.grupo.GrupoId
                            }).$promise;
                        }).then((data) => {
                            $scope.listaCanais = data.map(function(canal) {
                                return {
                                    ChatCanalId: canal.ChatCanalId,
                                    Nome: canal.Descricao
                                };
                            });
                            
                            // Se não houver canais, finaliza e redireciona
                            if ($scope.listaCanais.length === 0) {
                                $scope.ChatUsuarioStepData.notVisible = true;
                                $state.go(redirectPage, { storage: true });
                            } else {
                                // Se houver canais, vai para o próximo step
                                $scope.ChatUsuarioStepData.notVisible = false;
                                WizardHandler.wizard().next();
                            }
                        }).catch((error) => {
                            $scope.salvando = false;
                            NotifyService.showError(error);
                        });
                    } else {
                        $scope.salvando = false;
                        // Carrega a lista de canais para verificar
                        $scope.carregarCanaisChat();
                        
                        // Verifica se há canais depois de um pequeno delay
                        setTimeout(function() {
                            if ($scope.listaCanais.length === 0) {
                                $state.go(redirectPage, { storage: true });
                            } else {
                                WizardHandler.wizard().next();
                            }
                        }, 300);
                    }
                } else {
                    // Se não há mudanças, carrega a lista de canais e verifica
                    GrupoResource.getChatAssociado({
                        grupoId: $scope.grupo.GrupoId
                    }).$promise.then((data) => {
                        $scope.listaCanais = data.map(function(canal) {
                            return {
                                ChatCanalId: canal.ChatCanalId,
                                Nome: canal.Descricao
                            };
                        });
                        
                        // Se não houver canais, finaliza e redireciona
                        if ($scope.listaCanais.length === 0) {
                            $scope.ChatUsuarioStepData.notVisible = true;
                            $state.go(redirectPage, { storage: true });
                        } else {
                            // Se houver canais, vai para o próximo step
                            $scope.ChatUsuarioStepData.notVisible = false;
                            WizardHandler.wizard().next();
                        }
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $state.go(redirectPage, { storage: true });
                    });
                }
            };

            // Chat Usuário (Passo 4.1)
            $scope.chatSelecionado = null;
            $scope.usuarioChatAssociado = [];
            $scope.usuarioChatNaoAssociado = [];
            $scope.listaCanais = [];
            $scope.descricoesColunasUsuarioChat = {
                UsuarioId: 'telaGrupoEdit.codigoUsuario',
                Usuario: 'telaGrupoEdit.usuario'
            };

            // Carrega lista de canais de chat disponíveis (associados ao grupo)
            $scope.carregarCanaisChat = function() {
                if ($scope.grupo.GrupoId > 0) {
                    GrupoResource.getChatAssociado({
                        grupoId: $scope.grupo.GrupoId
                    }).$promise.then((data) => {
                        $scope.listaCanais = data.map(function(canal) {
                            return {
                                ChatCanalId: canal.ChatCanalId,
                                Nome: canal.Descricao
                            };
                        });
                        
                        // Controla a visibilidade do step Chat Usuário baseado na quantidade de canais
                        if ($scope.listaCanais.length === 0) {
                            // Se não houver canais, esconde o step Chat Usuário
                            $scope.ChatUsuarioStepData.notVisible = true;
                            $scope.chatSelecionado = null;
                            $scope.usuarioChatAssociado = [];
                            $scope.usuarioChatNaoAssociado = [];
                        } else {
                            // Se houver canais e o chat estiver habilitado, mostra o step
                            $scope.ChatUsuarioStepData.notVisible = !$scope.grupo.HabilitarChat;
                        }
                    }).catch(function(error) {
                        NotifyService.showError(error);
                        $scope.listaCanais = [];
                        $scope.ChatUsuarioStepData.notVisible = true;
                    });
                }
            };

            // Carrega usuários associados e não associados ao canal selecionado
            $scope.carregarUsuariosChat = function(chatSelecionado) {
                if (!chatSelecionado) {
                    $scope.usuarioChatAssociado = [];
                    $scope.usuarioChatNaoAssociado = [];
                    $scope.chatSelecionado = null;
                    return;
                }
                
                // Atualiza a variável de escopo com o canal selecionado
                $scope.chatSelecionado = chatSelecionado;
                
                // Extrai o ID do canal (pode ser um objeto ou um ID direto)
                var chatCanalId = chatSelecionado.ChatCanalId || chatSelecionado;
                var grupoId = $scope.grupo.GrupoId;
                                
                UsuarioChatResource.getUsuarioChatAssociado({
                    chatCanalId: chatCanalId,
                    grupoId: grupoId
                }).$promise.then((data) => {
                    $scope.usuarioChatAssociado = data;
                }).catch(NotifyService.showError);

                UsuarioChatResource.getUsuarioChatNaoAssociado({
                    chatCanalId: chatCanalId,
                    grupoId: grupoId
                }).$promise.then((data) => {
                    $scope.usuarioChatNaoAssociado = data;
                }).catch(NotifyService.showError);
            };

            // Carrega canais se for edição
            if ($scope.grupo.GrupoId > 0 && $scope.grupo.HabilitarChat) {
                $scope.carregarCanaisChat();
            }

            // Salva as associações de usuários ao chat
            $scope.salvarUsuarioChat = function () {
                var allpromises = [];
                
                if ($scope.chatSelecionado && $scope.chatSelecionado > 0) {
                    var usuarioIds = _.pluck($scope.usuarioChatAssociado, 'UsuarioId');
                    
                    // Garante que seja um array válido
                    if (!usuarioIds) {
                        usuarioIds = [];
                    }
                    
                    allpromises.push(UsuarioChatResource.salvarUsuarioChat({
                        ChatCanalId: $scope.chatSelecionado,
                        UsuarioAssociado: usuarioIds
                    }).$promise);
                }
                
                return allpromises;
            };

            // Evento quando usuários são adicionados
            $scope.onUsuarioChatAdicionado = function (itens) {
                if ($scope.forms.formChatUsuario) {
                    $scope.forms.formChatUsuario.$setDirty();
                }
            };

            // Evento quando usuários são removidos
            $scope.onUsuarioChatRemovido = function (itens) {
                if ($scope.forms.formChatUsuario) {
                    $scope.forms.formChatUsuario.$setDirty();
                }
            };

            $scope.finalizarChatUsuario = function (form) {
                if (!form.$valid) return form.$setSubmitted();
                
                let redirectPage = $stateParams.page != null ? $stateParams.page : 'main.grupos.list';
                
                // Verifica se há um canal selecionado e se o form está dirty
                var deveSalvar = form.$dirty && $scope.chatSelecionado;
                                
                if (deveSalvar) {
                    $scope.salvando = true;
                    
                    var promises = $scope.salvarUsuarioChat();
                    
                    if (promises && promises.length > 0) {
                        $q.all(promises).then(() => {
                            NotifyService.showSuccess();
                            form.$setPristine();
                            $scope.salvando = false;
                            // Redireciona para a lista
                            $state.go(redirectPage, {
                                storage: true
                            });
                        }).catch((error) => {
                            $scope.salvando = false;
                            NotifyService.showError(error);
                        });
                    } else {
                        $scope.salvando = false;
                        $state.go(redirectPage, {
                            storage: true
                        });
                    }
                } else {
                    // Se não há mudanças ou não há canal selecionado, apenas redireciona
                    $state.go(redirectPage, {
                        storage: true
                    });
                }
            };
            

            $scope.showOrdemModal = function () {
                ModalService.openModal('modal_grupo_ramal')
                var sortableElement = $('#ramais-sortable');
                if (sortableElement.length) {
                    var sortable = UIkit.sortable(sortableElement, { handleClass: 'uk-sortable-handle', dragCustomClass: 'dragging' });

                    sortable.on('change.uk.sortable', () => {
                        reordenaGrupoRamal();
                    });

                    $('body').on('click', '#ramais-sortable', () => {
                        if ($scope.ramaisAdicionados.length >= 2) {
                            if ($scope.ramaisAdicionados[0].Ordem == $scope.ramaisAdicionados[1].Ordem) {
                                var ordemIndex = 1;
                                $scope.ramaisAdicionados.forEach((el) => {
                                    el.Ordem = ordemIndex;
                                    ordemIndex++;
                                })
                            }
                        } else if ($scope.ramaisAdicionados.length == 1) {
                            $scope.ramaisAdicionados[0].Ordem = 1;
                        }
                    });
                }
            };

            var reordenaGrupoRamal = function () {
                var $nestable = $('#ramais-sortable');
                var listaIds = $nestable.data("sortable").serialize();
                $scope.ramaisAdicionados.forEach((el) => {
                    if (el.Alterado == null) {
                        el.Alterado = false;
                    }
                    var ordemAntiga = el.Ordem;
                    el.Ordem = _.findIndex(listaIds, (el2) => { return el2.id == el.RamalId }) + 1;
                    if (ordemAntiga != el.Ordem && !el.Alterado) {
                        el.OrdemAlterado = true;
                    }
                });
                $scope.$apply();
            }

            $scope.salvarOrdem = function (form) {
                form.$setDirty();
                $scope.grupoAlterado = true;
                $scope.salvar(form);
            }

            $scope.ultimoArquivoId = {};

            $scope.startGrupoUpload = function () {
                ModalService.showUploading();
            }
            $scope.loadRetencaoCompleted = function (result) {
                $scope.preview = result;
                $scope.ultimoArquivoId['retencao'] = null;
                $scope.grupo.RetencaoAudioId = result.GrupoAudioId;
                $scope.grupo.RetencaoAudio = result;
                $scope.forms.formGrupo.$setDirty();
                ModalService.hideUploading();
            };

            $scope.removeRetencao = function () {
                $scope.ultimoArquivoId['retencao'] = null;
                $scope.grupo.RetencaoAudioId = null;
                $scope.grupo.RetencaoAudio = null;
                $('#form-file-retencao').val('');
                $scope.forms.formGrupo.$setDirty();
            };

            $scope.loadRetencaoError = function (result) {
                $scope.preview = null;
                ModalService.showUploading();
                if (result == 'Bad Request') {
                    NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                }
            };

            $scope.showProgress = function (percentComplete) {
                $('#modalBlock').find('.uk-progress-bar').css({ width: percentComplete + '%' });
                $('#modalBlock').find('.uk-progress-bar').text(percentComplete + '%');
            }

            $scope.ouvirAudio = function (id, nome) {
                $scope.arquivoAudio = {
                    url: '/Grupo/Audio/' + id,
                    titulo: $translate.instant('diretivas.reproduzindo') + nome
                }
            }

            $scope.fecharAudio = function () {
                $scope.arquivoAudio = null;
            }

            $scope.onChangeTransbordoTipo = function () {
                if (grupo.Transbordo == 1) {
                    grupo.MaximoFila = 0;
                }
            };

            $scope.onFilaVirtual = function () {
                
                $scope.grupoFilaVirtual.FilaVirtualEnvioSMS = false;
                $scope.grupoFilaVirtual.Whatsapp = false;
                $scope.grupoFilaVirtual.Callback = false;

            };

            $scope.onFilaVirtualEnvioSMS = function () {
                
                $scope.grupoFilaVirtual.Whatsapp = false;
                $scope.grupoFilaVirtual.Callback = false;
                
            };

            $scope.onVisivel = function (item) {
                GrupoRamalStatusDetalheResource.AtualizarIntervalosGrupo(item).$promise.then(data => {
                    NotifyService.showSuccess();
                }).catch(error => {NotifyService.showError(error)})
            }

            $scope.salvarGruposOperacional = function (form) {
                if (!form.$valid) return form.$setSubmitted();

                var grupoIds = _.pluck($scope.gruposOperacionalAssociado, 'GrupoId');

                var salvarPromise = function () {
                    return GrupoResource.salvarGruposOperacional({
                        GrupoOperacionalId: $scope.grupo.GrupoId,
                        GrupoIds: grupoIds
                    }).$promise;
                };

                if ($scope.isNew) {
                    $scope.salvando = true;
                    salvarGrupo().then((data) => {
                        angular.copy(data, $scope.grupo);
                        $stateParams.GrupoId = $scope.grupo.GrupoId;
                        return salvarPromise();
                    }).then(() => {
                        NotifyService.showRegistroSalvo();
                        form.$setPristine();
                        goToStepData($scope.EstrategiaStepData);
                    }).catch(NotifyService.showError)
                      .finally(() => { $scope.salvando = false; });
                } else {
                    if (form.$dirty) {
                        $scope.salvando = true;
                        salvarPromise().then(() => {
                            NotifyService.showRegistroSalvo();
                            form.$setPristine();
                            goToStepData($scope.EstrategiaStepData);
                        }).catch(NotifyService.showError)
                          .finally(() => { $scope.salvando = false; });
                    } else {
                        goToStepData($scope.EstrategiaStepData);
                    }
                }
            };

            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3>${descricao}`);
            };

            $scope.salvarEstrategia = function (form) {
                if (!form.$valid) return form.$setSubmitted();

                let redirectPage = $stateParams.page != null ? $stateParams.page : 'main.grupos.list';

                $scope.salvando = true;
                GrupoResource.salvarEstrategia({
                    GrupoId: $scope.grupo.GrupoId,
                    Estrategia: parseInt($scope.grupo.Estrategia)
                }).$promise.then(() => {
                    NotifyService.showRegistroSalvo();
                    form.$setPristine();
                    $state.go(redirectPage, { storage: true });
                }).catch(NotifyService.showError)
                  .finally(() => { $scope.salvando = false; });
            };

        }]);
})
    ();
(function () {
	"use strict";

	var getOdataSearchShared = function (GrupoResource, search, orderBy, $odata, utils) {
		utils.resetFilters(search, ['GrupoTipoId']);
		var odata = GrupoResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.GrupoTipoId) {
			odata.filter("GrupoTipoId", "=", parseInt(search.GrupoTipoId));
		}

		if (search.Descricao) {
			odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Descricao"), search.Descricao.toLowerCase()), true);
		}

		if (search.Numero) {
			odata.filter('Ramal/Numero', parseInt(search.Numero));
		}

		if (search.Id) {
			odata.filter("CarteiraId", "=", parseInt(search.Id));
		}

		if (search.StatusIntegracaoId) {
			odata.filter("StatusIntegracaoId", "=", parseInt(search.StatusIntegracaoId));
		}

		return odata;
	}

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.grupos", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.grupos.list',
						pageTitle: 'model.grupo',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.grupos.list", StateResolverProvider.configState("/grupos?storage", "Grupo", "List", {
					pageTitle: 'model.grupo',
					pageName: 'pageTitle.pesquisar'
				}))
				.state("main.grupos.new", StateResolverProvider.configState("/grupos/new?page&tipogrupo", "Grupo", "Edit", {
					pageTitle: 'model.grupo',
					pageName: 'acoes.cadastrar',
					css: true
				}))
				.state("main.grupos.edit", StateResolverProvider.configState("/grupos/{GrupoId:[0-9]+}", "Grupo", "Edit", {
					pageTitle: 'model.grupo',
					pageName: 'acoes.editar',
					css: true
				}))
		}])

		.service("GrupoListData", function GrupoListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					grupos: ["GrupoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (GrupoResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = { GrupoTipoId: 1 };
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroGrupo");
						}
						var orderBy = {
							column: "DataAlteracao",
							order: "desc"
						};
						var odata = getOdataSearchShared(GrupoResource, filtro, orderBy, $odata, utils);
						return odata.page(10, 1).query();
					}],
					tipos: ["GrupoResource", function (GrupoResource) {
						return GrupoResource.getTipos().$promise;
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],					
                    ttsService : ["TtsService", function(TtsService){
                        TtsService.getVozes();
                        TtsService.setProvedores();
                        return;
                    }],
					statusIntegracao: ["StatusIntegracaoResource", function(StatusIntegracaoResource){
                        return StatusIntegracaoResource.getStatusIntegracao();
					}]
				}
			}
		})

		.controller("GrupoListController", ["$scope", "$odata", "$state", "grupos", "tipos", "carteiras", "statusIntegracao", "GrupoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "AgendaIntervaloResource", "$translate", function ($scope, $odata, $state, grupos, tipos, carteiras, statusIntegracao, GrupoResource, utils, LocalStorageService, $stateParams, NotifyService,
			ModalService, AgendaIntervaloResource, $translate) {
			$scope.submitted = false;
			$scope.grupos = grupos;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem('FiltroGrupo') : { GrupoTipoId: 1 };
			$scope.tipos = tipos;
			$scope.carteiras = carteiras;
			$scope.statusIntegracao = statusIntegracao;

			$scope.novoGrupo = function () {
				GrupoResource.validarLimiteGrupo().$promise.then(function (result) {
					if (result.PodeCriar) {
						$state.go('main.grupos.new');
					} else {
						ModalService.alert('telaGrupo.limiteGrupoAtingido');
					}
				}).catch(NotifyService.showError);
			};

			$scope.orderBy = {
				column: "DataAlteracao",
				order: "desc"
			};

			var updateList = function (list) {
				$scope.grupos = list;
				$scope.grupos.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.grupos.pageSize = list.$pageSize || 10;
				$scope.submitted = false;
			}

			var getOdataSearch = function () {
				return getOdataSearchShared(GrupoResource, $scope.search, $scope.orderBy, $odata, utils);
			};

			$scope.executeSearch = function () {
				$scope.submitted = true;
				LocalStorageService.setItem('FiltroGrupo', $scope.search);
				
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList).catch((error) => {
						NotifyService.showError(error);
						$scope.submitted = false;
					});
			}

			var deleteRecord = function (data) {
				return GrupoResource.delete({ GrupoId: data.GrupoId }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			}

			$scope.confirmDelete = function (data) {
				AgendaIntervaloResource.odata().filter('Grupo/GrupoId', data.GrupoId).query().then((response) => {
					if (response.length > 0) {
						ModalService.confirmMessage($translate.instant('telaGrupo.existeAgendamentoIntervalo'), null, () => deleteRecord(data))
					}
					else {
						ModalService.confirmDelete(() => deleteRecord(data))
					}
				});
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.grupos.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			updateList(grupos);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroGrupo');
				$scope.search = { pageSize: 10 };
				$scope.executeSearch();
			}

			$scope.duplicarGrupo = function (grupo) {
                if (grupo) {
                    ModalService.confirmMessage('telaGrupo.confirmarDuplicarGrupo', null, () => {
                        GrupoResource.duplicarGrupo({
                            GrupoId: grupo.GrupoId
                        }).$promise.then((res) => {
							$scope.executeSearch();
                        }).catch(NotifyService.showError);
                    });
                }
            }
		}]
		);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("GrupoRamalStatusDetalheResource", ["$odataresource", function ($odataresource) {
            return $odataresource("GrupoRamalStatusDetalhe/:Id", { "Id": "@Id" },
                {
                    GetIntervalosGrupo: {
                        url: "GrupoRamalStatusDetalhe/GetIntervalosGrupo",
                        method: "GET",
                        params: {
                            "GrupoId": "@GrupoId"
                        },
                        isArray: true
                    },
                    GetIntervalosGrupoAgrupado: {
                        url: "GrupoRamalStatusDetalhe/GetIntervalosGrupoAgrupado",
                        method: "GET",
                        params: {
                            "GrupoId": "@GrupoId"
                        },
                        isArray: true
                    },
                    AtualizarIntervalosGrupo: {
                        url: "GrupoRamalStatusDetalhe/AtualizarIntervalosGrupo",
                        method: "POST"
                    },
                    GetVisualizaIntervalo:{
                        url: "GrupoRamalStatusDetalhe/GetVisualizaIntervalo",
                        method: "GET",
                        params: {
                            "GrupoId": "@GrupoId",
                            "RamalStatusDetalheId": "@RamalStatusDetalheId"
                        },
                        isArray: false
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("GrupoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Grupo/:GrupoId", { "GrupoId": "@GrupoId" },
                {
                    duplicarGrupo: {
                        url: "Grupo/Duplicar",
                        method: "POST",
                        params: {
                            "GrupoId": "@GrupoId"
                        }
                    },
                    adicionarRamal: {
                        url: "Grupo/AdicionarRamal",
                        method: "POST"
                    },
                    moverRamal: {
                        url: "Grupo/MoverRamal",
                        method: "POST"
                    },
                    atualizarOrdem: {
                        url: "Grupo/AtualizarRamalOrdem",
                        method: "PUT"
                    },
                    removerRamal: {
                        url: "Grupo/RemoverRamal",
                        method: "POST"
                    },
                    getRamaisNaoAssociados: {
                        url: "Grupo/RamaisNaoAssociados",
                        method: "GET",
                        isArray: true
                    },
                    getRamaisAssociados: {
                        url: "Grupo/RamaisAssociados",
                        method: "GET",
                        isArray: true
                    },
                    alterarIntervaloInicial: {
                        url: "Grupo/AlterarIntervaloInicial",
                        method: "POST"
                    },
                    getGrupoSimples: {
                        url: "Grupo/GetSimples",
                        method: "GET",
                        isArray: true
                    },
                    GetGrupoPorCarteira: {
                        url: "Grupo/GetGrupoPorCarteira/:carteira",
                        method: "GET",
                        isArray: true
                    },
                    getGrupoFlutuante: {
                        url: "Grupo/Flutuante",
                        method: "GET",
                        isArray: true
                    },
                    getTodosGrupos: {
                        url: "Grupo/GetTodosGrupos",
                        method: "GET",
                        isArray: true
                    },
                    getGruposInfoRamais: {
                        url: "Grupo/GetGruposInfoRamais/:GrupoTipoId",
                        method: "GET",
                        isArray: true,
                        params: { 
                            "GrupoTipoId": "@GrupoTipoId"
                        }
                    },
                    getTipos: {
                        url: "Grupo/Tipos",
                        method: "GET",
                        isArray: true
                    },
                    lookup: {
                        url: "Grupo/Lookup",
                        method: "GET",
                        isArray: true
                    },
                    getCarteiras: {
                        url: "Carteira",
                        method: "GET",
                        isArray: true
                    },
                    getChatAssociado: {
                        url: "Grupo/ChatAssociado/:grupoId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "grupoId": "@grupoId"
                        }
                    },
                    getChatNaoAssociado: {
                        url: "Grupo/ChatNaoAssociado/:grupoId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "grupoId": "@grupoId"
                        }
                    },
                    salvarChatGrupo: {
                        url: "Grupo/SalvarChatGrupo",
                        method: "POST"
                    },
                    validarLimiteGrupo: {
                        url: "Grupo/ValidarLimiteGrupo",
                        method: "GET",
                        isArray: false
                    },
                    getGruposOperacionalAssociado: {
                        url: "Grupo/GruposOperacionalAssociado/:grupoOperacionalId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "grupoOperacionalId": "@grupoOperacionalId"
                        }
                    },
                    getGruposOperacionalNaoAssociado: {
                        url: "Grupo/GruposOperacionalNaoAssociado/:grupoOperacionalId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "grupoOperacionalId": "@grupoOperacionalId"
                        }
                    },
                    salvarGruposOperacional: {
                        url: "Grupo/SalvarGruposOperacional",
                        method: "POST"
                    },
                    salvarEstrategia: {
                        url: "Grupo/SalvarEstrategia",
                        method: "POST"
                    },
                });
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("GrupoFilaVirtualResource", ["$odataresource", function ($odataresource) {
            return $odataresource("GrupoFilaVirtual/:Id", { "Id": "@Id" },
                {
                    GetFilaVirtualPorGrupoId:{
                        url: "GrupoFilaVirtual/GetFilaVirtualPorGrupoId/:grupoId",
                        method: "GET",
                        isArray: true,
                        params: { 
                            "grupoId": "@grupoId"
                        }
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .service('IntegracaoEditData', function IntegracaoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_joint'
                        ]);
                    }],
                }
            }
        })

        .controller("IntegracaoEditController",
            ["$scope", "$window", "IntegracaoConfiguracaoResource", "IntegracaoAutenticacaoTipoResource", "IntegracaoTipoResource", "NotifyService", function ($scope, $window, IntegracaoConfiguracaoResource, IntegracaoAutenticacaoTipoResource, IntegracaoTipoResource, NotifyService) {
                IntegracaoTipoResource.query().$promise.then(function (res) {
                    $scope.tiposIntegracao = res;

                });
                IntegracaoAutenticacaoTipoResource.query().$promise.then(function (res) {
                    $scope.tiposAutenticacao = res;
                });

                $scope.fecharIntegracao = function () {
                    var modal = $.UIkit.modal('#modal_integracao');
                    if (modal)
                        modal.hide();
                }
                $scope.forms = {};
                $scope.limparNovaIntegracao = function () {
                    $scope.novaIntegracao = {
                        IntegracaoParametro: [{
                            Nome: null,
                            Valor: null
                        }],
                        IntegracaoCabecalho: [{
                            Nome: null,
                            Valor: null
                        }],
                        IntegracaoResposta: [{
                            Nome: null
                        }],
                        IntegracaoAutenticacao: [{
                            Servidor: null,
                            Catalogo: null,
                            Usuario: null,
                            Senha: null,
                        }],
                        Verbo: 'GET',
                        RequisicaoFormato: 'application/json',
                        Testada: false,
                        JsonTeste: null
                    };
                }
                $scope.limparNovaIntegracao();

                var modal = $.UIkit.modal('#modal_integracao');
                if (modal) {
                    modal.on('hide.uk.modal', function () {
                        $scope.limparNovaIntegracao();
                        $scope.forms.formIntegracao.$setPristine();
                        $scope.forms.formIntegracao.$setUntouched();
                    });
                    modal.on('show.uk.modal', function () {
                        $scope.limparNovaIntegracao();
                        $scope.forms.formIntegracao.$setPristine();
                        $scope.forms.formIntegracao.$setUntouched();
                    });
                }

                $scope.adicionarNovoParametro = function () {
                    $scope.novaIntegracao.IntegracaoParametro.push({
                        Nome: null,
                        Valor: null
                    });
                }

                $scope.adicionarNovoCabecalho = function () {
                    $scope.novaIntegracao.IntegracaoCabecalho.push({
                        Nome: null,
                        Valor: null
                    });
                }

                $scope.adicionarNovaResposta = function () {
                    $scope.novaIntegracao.IntegracaoResposta.push({
                        Nome: null
                    });
                }

                $scope.removerParametro = function (parametro) {
                    $scope.novaIntegracao.IntegracaoParametro = _.without($scope.novaIntegracao.IntegracaoParametro, parametro);
                }

                $scope.removerCabecalho = function (cabecalho) {
                    $scope.novaIntegracao.IntegracaoCabecalho = _.without($scope.novaIntegracao.IntegracaoCabecalho, cabecalho);
                }

                $scope.removerResposta = function (resposta) {
                    $scope.novaIntegracao.IntegracaoResposta = _.without($scope.novaIntegracao.IntegracaoResposta, resposta);
                }

                $scope.onIntegracaoTipoAlterado = function () {
                    if ($scope.novaIntegracao.IntegracaoTipoId > 0) {
                        $scope.tiposAutenticacaoFiltrado = _.filter($scope.tiposAutenticacao, function (el) {
                            return el.IntegracaoTipoId == $scope.novaIntegracao.IntegracaoTipoId;
                        });
                        if ($scope.novaIntegracao.IntegracaoTipoId == 2) {
                            $scope.novaIntegracao.Verbo = null;
                            $scope.novaIntegracao.RequisicaoFormato = null;
                            $scope.novaIntegracao.IntegracaoCabecalho = [];
                        } else {
                            $scope.novaIntegracao.Verbo = 'GET';
                            $scope.novaIntegracao.RequisicaoFormato = 'application/json';
                            $scope.novaIntegracao.IntegracaoCabecalho = [{
                                Nome: null,
                                Valor: null
                            }];
                        }
                    }
                    $scope.novaIntegracao.IntegracaoAutenticacao[0].IntegracaoAutenticacaoTipoId = null;
                }

                $scope.testarRequisicao = function () {
                    $scope.novaIntegracao.Testando = true;
                    IntegracaoConfiguracaoResource.testar($scope.novaIntegracao).$promise
                        .then(function (res) {
                            $scope.novaIntegracao.RespostaTeste = res.Resposta;
                            var respostas = [];
                            res.Propriedades.forEach(function (el) {
                                respostas.push({
                                    Nome: el
                                });
                            });
                            $scope.novaIntegracao.IntegracaoRespostaTeste = respostas;
                            $scope.novaIntegracao.Testada = true;
                            if ($scope.novaIntegracao.IntegracaoResposta.length <= 1) {
                                $scope.adicionarPropriedadesTeste();
                            }
                        })
                        .catch(function (er) {
                            NotifyService.showError(er);
                            $scope.novaIntegracao.RespostaTeste = null;
                            $scope.novaIntegracao.Testada = false;
                            $scope.novaIntegracao.IntegracaoRespostaTeste = [];
                            return;
                        })
                        .finally(function () {
                            $scope.novaIntegracao.Testando = false;
                        });
                }

                $scope.adicionarPropriedadesTeste = function () {
                    $scope.novaIntegracao.IntegracaoResposta = $scope.novaIntegracao.IntegracaoRespostaTeste.slice();
                }

                $scope.salvarIntegracao = function () {
                    if (!$scope.forms.formIntegracao.$valid) {
                        NotifyService.showInvalid();
                        return;
                    }
                    if ($scope.novaIntegracao.IntegracaoConfiguracaoId > 0) {
                        IntegracaoConfiguracaoResource.update($scope.novaIntegracao).$promise
                            .then(function () {
                                NotifyService.showRegistroSalvo();
                                $scope.fecharIntegracao();
                            })
                            .catch(NotifyService.showError);
                    } else {
                        IntegracaoConfiguracaoResource.save($scope.novaIntegracao).$promise
                            .then(function () {
                                NotifyService.showRegistroSalvo();
                                $scope.fecharIntegracao();
                            })
                            .catch(NotifyService.showError);
                    }
                }

                $scope.parametrosPadroes = [{
                    Descricao: 'RespostaUsuario',
                    Alias: '@Resposta do Usuário'
                }, {
                    Descricao: 'DDD',
                    Alias: '@DDD'
                }, {
                    Descricao: 'NA',
                    Alias: '@NA'
                }, {
                    Descricao: 'NB',
                    Alias: '@NB'
                }];

                $scope.verbosWebservice = [{
                    Descricao: 'GET',
                    Valor: 'GET'
                }, {
                    Descricao: 'POST',
                    Valor: 'POST'
                }, {
                    Descricao: 'PUT',
                    Valor: 'PUT'
                }];

                $scope.formatosRequisicao = [{
                    Descricao: 'Json',
                    Valor: 'application/json'
                }, {
                    Descricao: 'XML',
                    Valor: 'application/xml'
                }];

            }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("IntegracaoTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("IntegracaoTipo/:IntegracaoTipoId", {
                "IntegracaoTipoId": "@IntegracaoTipoId"
            });
        }])

        .factory("IntegracaoAutenticacaoTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("IntegracaoAutenticacaoTipo/:IntegracaoAutenticacaoTipoId", {
                "IntegracaoAutenticacaoTipoId": "@IntegracaoAutenticacaoTipoId"
            });
        }])

        .factory("IntegracaoConfiguracaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("IntegracaoConfiguracao/:IntegracaoConfiguracaoId", {
                "IntegracaoConfiguracaoId": "@IntegracaoConfiguracaoId"
            }, {
                testar: {
                    url: "IntegracaoConfiguracao/Testar",
                    method: "POST",
                    isArray: false
                }
            });
        }])

        .factory("OperadorLogicoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("OperadorLogico/:OperadorLogicoId", {
                "OperadorLogicoId": "@OperadorLogicoId"
            });
        }]);

})();
(function () {
    "use strict";
    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    var getOdataSearchShared = function (search, orderBy, $http, Config) {
        var searchObj = {
            RamalStatusDetalheId: search.RamalStatusDetalheId,
            UsuarioId: search.UsuarioId,
            DataInicio: search.DataInicio,
            DataTermino: search.DataTermino,
            DuracaoMenor: parseInt(search.DuracaoMenor),
            DuracaoMaior: parseInt(search.DuracaoMaior),
            OrderBy: orderBy.column + " " + orderBy.order,
            GrupoId: search.GrupoId,
            CarteiraId: search.Id
        };

        var url = Config.getUrl("UsuarioRamalHistorico/Paginado/") + defaultPageIndex + "/" + defaultPageSize
        return $http({
            method: 'GET',
            url: url,
            params: searchObj
        }).then(function (response) {
            return response.data;
        });
    }

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.intervalohistorico", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.intervalohistorico.list',
                        pageTitle: 'pageTitle.relatorioDeIntervalos',
                        pageName: 'campo.intervalos',
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("main.intervalohistorico.list", StateResolverProvider.configState("/intervalohistorico", "IntervaloHistorico", "List", {
                    pageTitle: 'pageTitle.relatorioDeIntervalos',
                    pageName: 'pageTitle.pesquisar'
                }))

        }])

        .service("IntervaloHistoricoListData", function ReportListData() {
            return function () {
                return {
                    ramaisList: ["UsuarioResource", function (UsuarioResource) {
                        return UsuarioResource.GetTodosUsuario().$promise;
                    }],
                    ramalstatusList: ["RamalStatusResourceDetalhe", function (RamalStatusResourceDetalhe) {
                        return RamalStatusResourceDetalhe.query().$promise;
                    }],
                    grupos: ["GrupoResource", function(GrupoResource) {
                        return GrupoResource.lookup().$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })

        .controller("IntervaloHistoricoListController", ["$scope", "$http", "$stateParams", "Config", "ramaisList", "ramalstatusList", "RamalStatusResourceDetalhe", "FileDownloadService", "NotifyService", "ModalService", "grupos", "RamalResource", "carteiras", "AuthService", function ($scope, $http, $stateParams, Config, ramaisList, ramalstatusList, 
            RamalStatusResourceDetalhe, FileDownloadService, NotifyService, ModalService, grupos, RamalResource, carteiras, AuthService) {
            $scope.searching = false;
            $scope.ramaisList = ramaisList;
            $scope.grupos = grupos;
            $scope.gruposCopia = grupos;
            $scope.ramalstatusList = ramalstatusList;
            $scope.historicos = [];
            $scope.carteiras = carteiras;
            

            $scope.ramaisListFilter = _.filter($scope.ramaisList, function (item) {
                return item.UsuarioStatusId == 1;
            });;

            var dataInicio = moment().subtract(60, 'minutes').seconds(0).milliseconds(0).toDate();
            var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();

            const grupoById = (grupoId) => grupos.find(grupo => grupo.GrupoId == grupoId);

            $scope.search = {
                DataInicio: dataInicio,
                DataTermino: $stateParams.DataTermino || dataFim,
                RamalId: $stateParams.RamalId || 0,
                DuracaoMenor: $stateParams.DuracaoMenor || 0,
                DuracaoMaior: $stateParams.DuracaoMaior || 0,
            };

            if ($stateParams.Tempo) {
                $scope.search.DataInicio = moment().subtract($stateParams.Tempo, 'minutes').seconds(0).milliseconds(0).toDate();
            }

            $scope.orderBy = {
                column: "DataInicio",
                order: "desc"
            };

            var updateList = function (pagination) {
                $scope.historicos = pagination.Data;
                $scope.historicos.recordCount = pagination.RecordCount;
                $scope.currentPage = pagination.PageIndex || 1;
                $scope.historicos.pageSize = pagination.PageSize || defaultPageSize;
                $scope.searching = false;
            };

            $scope.changeViewInativos = function (viewInativos) {
                $scope.viewInativos = viewInativos;

                if (!viewInativos) {
                    $scope.ramaisListFilter = _.filter($scope.ramaisList, function (item) {
                        return item.UsuarioStatusId == 1;
                    });
                } else {
                    $scope.ramaisListFilter = _.filter($scope.ramaisList, function (item) {
                        return item.UsuarioStatusId == 2;
                    });
                }
            }

            $scope.onChangeRamalStatusDetalhe = function () {
                $scope.search.RamalStatusDetalheId = 0;
                $scope.ramalstatusList = null;

                getRamalStatusDetalhe();

                // if ($scope.search.RamalId != null) {
                //     RamalStatusResourceDetalhe.getStatusDetalhePorUsuario({ usuarioId: $scope.search.UsuarioId }).$promise.then((resposta) => {
                //         $scope.ramalstatusList = resposta;
                //     });
                // }
            };

            $scope.onChangeGrupo = function () {
                let grupoId = $scope.search.GrupoId;
                if (grupoId > 0) {
                    let grupo = grupoById(grupoId);
                    let ramalTipoId = grupo.GrupoTipoId == 3 ? 6 : 1;
                    RamalResource.getSimplesPorGrupo({ TipoId: ramalTipoId, GruposId: grupoId.toString() }).$promise.then(r => {
                        $scope.ramaisList = r;
                    });
                } else {
                    $scope.ramaisList = ramaisList;
                }
                getRamalStatusDetalhe();
            }

            $scope.executeSearch = function () {
                $scope.searching = true;
                defaultPageIndex = 1;
                getOdataSearch()
                    .then(updateList)
                    .catch(showError);
            };

            $scope.pageChanged = function (newPage) {
                ModalService.showLoading();
                if (defaultPageIndex != newPage) {
                    defaultPageIndex = newPage;
                    return getOdataSearch()
                        .then((list) => {
                            updateList(list);
                            ModalService.hideLoading();
                        }).catch(showError);
                }
            };

            var getOdataSearch = function () {
                return getOdataSearchShared($scope.search, $scope.orderBy, $http, Config);
            };

            $scope.registroPorPaginaArray = [
                { label: 15, valor: 15 }, 
                { label: 30, valor: 30 }, 
                { label: 50, valor: 50 }, 
                { label: 100, valor: 100 }
            ];

            $scope.filterPageSize = { Size: 15 };

            $scope.changePageSize = function () {
                defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
            }

            var showError = function (error) {
                ModalService.hideLoading();
                NotifyService.showError(error);
                $scope.searching = false;
            };

            $scope.order = function (predicate) {
                ModalService.showLoading();
                $scope.predicate = predicate;
                $scope.reverse = $scope.predicate ? !$scope.reverse : false;
                $scope.orderBy = {
                    column: predicate,
                    order: !$scope.reverse ? "Desc" : "Asc",
                };

                return getOdataSearch()
                    .then((list) => {
                        updateList(list);
                        ModalService.hideLoading();
                    }).catch(showError);
            };

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }

            var exportarArquivo = function (filtro) {
                var url = Config.getUrl("UsuarioRamalHistorico/Exportar")
                return $http({
                    method: 'GET',
                    url: url,
                    params: filtro
                }).then(function (response) {
                    return response.data;
                });
            };

            $scope.confirma = function () {
                ModalService.confirmMessage('telaIntervaloHistorico.desejaExtrairOIntervaloEmCsv', null, () => $scope.download());
            };

            $scope.download = function () {
                var search = $scope.search;
                ModalService.showLoading();
                var fileName = generateUUID();
                var filtro = {
                    IntervaloHistoricoStatusId: search.IntervaloHistoricoStatusId,
                    IntervaloHistoricoStatusDetalheId: search.IntervaloHistoricoStatusDetalheId,
                    RamalId: search.RamalId,
                    RotaId: search.RotaId,
                    DataInicio: search.DataInicio,
                    DataTermino: search.DataTermino,
                    DuracaoMenor: search.DuracaoMenor,
                    DuracaoMaior: search.DuracaoMaior,
                    RamalStatusDetalheId: search.RamalStatusDetalheId,
                    FileName: fileName,
                    GrupoId : search.GrupoId,
                    UsuarioId: search.UsuarioId
                };
                exportarArquivo(filtro).then(() => {
                    FileDownloadService.downloadWebApiFile("UsuarioRamalHistorico/Download/" + fileName);
                    ModalService.hideLoading();
                }).catch((data) => {
                    ModalService.hideLoading();
                    showError(data.message);
                });
            }

            $scope.limparFiltro = function () {
                $scope.search = {
                    IntervaloHistoricoStatusId: 0,
                    IntervaloHistoricoStatusDetalheId: 0,
                    RamalId: 0,
                    DataInicio: dataInicio,
                    DataTermino: dataFim,
                    DuracaoMenor: 0,
                    DuracaoMaior: 0,
                    RamalStatusDetalheId: 0,
                }
                $scope.intervalohistoricoList = [];
                $scope.executeSearch();
            };

            $scope.onChangeCarteira = function () {
                if($scope.search.Id == 0 || $scope.search.Id == undefined)
                {
                    $scope.grupos = $scope.gruposCopia;
                }else{
                    $scope.grupos = $scope.gruposCopia;
                    $scope.grupos = _.filter($scope.grupos, function (el) {
                        return el.CarteiraId == $scope.search.Id;
                    });
                }

                getRamalStatusDetalhe();

            }

            function getRamalStatusDetalhe(){
                RamalStatusResourceDetalhe.getRamalStatusDetalheByCarteira({
                    UsuarioId:$scope.search.UsuarioId || AuthService.getUsuarioLogado().UsuarioId,
                    GrupoId: $scope.search.GrupoId || 0,
                    CarteiraId: $scope.search.Id || 0,
                    UsuarioLogado: AuthService.getUsuarioLogado().UsuarioId
                }).$promise.then(result =>{
                    $scope.ramalstatusList = result
                }).catch(error => {
                    NotifyService.showError(error);
                })
            }

        }]);



})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RamalIntervaloHistoricoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("RamalIntervaloHistorico/:Id", {
                "Id": "@Id"
            }, {
                getIntervaloHistorico: {
                    url: "RamalIntervaloHistorico/IntervaloHistorico",
                    method: "GET",
                    isArray: true
                },
                setIntervaloHistorico: {
                    url: "RamalIntervaloHistorico/SetIntervaloHistorico",
                    method: "POST",
                    isArray: false
                }
            });
        }])
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.jornadatrabalho.edit", StateResolverProvider.configState("/jornadatrabalho/{JornadaId:[0-9]+}", "JornadaTrabalho", "Edit", {
					pageTitle: 'model.jornadaDeTrabalho',
					pageName: 'acoes.editar'
				}))
				.state("main.jornadatrabalho.new", StateResolverProvider.configState("/jornadatrabalho/new", "JornadaTrabalho", "Edit", {
					pageTitle: 'model.jornadaDeTrabalho',
					pageName: 'acoes.cadastrar'
				}));
		}])

		.service("JornadaTrabalhoEditData", function JornadaTrabalhoEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_wizard',
							'lazy_uiSelect'
						]);
					}],
					jornadaTrabalho: ["JornadaTrabalhoResource", "$stateParams", function (JornadaTrabalhoResource, $stateParams) {
						if ($stateParams.JornadaId) {
							return JornadaTrabalhoResource.get({
								JornadaId: $stateParams.JornadaId
							}).$promise;
						} else {
							return {};
						}
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("JornadaTrabalhoEditController", ["$scope", "$state", "$stateParams", "$q", "JornadaTrabalhoResource", "jornadaTrabalho", "WizardHandler", "$location", "NotifyService", "$translate", "ModalService", "TranslateService", "$filter", "carteiras", function ($scope, $state, $stateParams, $q, JornadaTrabalhoResource, jornadaTrabalho,
			WizardHandler, $location, NotifyService, $translate, ModalService, TranslateService, $filter, carteiras) {
			jornadaTrabalho.JornadaId = (jornadaTrabalho.JornadaId > 0 ? jornadaTrabalho.JornadaId : (isNaN(parseInt($stateParams.JornadaId)) ? 0 :
				parseInt($stateParams.JornadaId)));
			$scope.jornadaTrabalho = jornadaTrabalho;
			$scope.isNew = jornadaTrabalho.JornadaId > 0 ? false : true;
			$scope.isSetup = $location.search().setup;
			var jornadaid = jornadaTrabalho.JornadaId;
			$scope.forms = {};
			$scope.validateJornada = true;
			$scope.validatePeriodo = true;
			$scope.validateGrupo = true;
			$scope.salvando = false;
			$scope.isJornadaPadrao = jornadaTrabalho ? jornadaTrabalho.Padrao : false;
			$scope.periodos = [];
			$scope.jornadaPeriodoList = [];
			$scope.search = {};
			$scope.validacoes = {
				todosItemsAdicionados: false,
				todosItemsNaoAdicionados: false	
			}
			$scope.carteiras = carteiras

			$scope.periodoExcecao = {
				Dia: 0,
				Entrada: '',
				Saida: '',
			};

			var formatoHora = TranslateService.getAngularTimeFormat();
			var horaEntradaDefault = moment('09:00', 'HH:mm').format(formatoHora);
			var horaSaidaDefault = moment('18:00', 'HH:mm').format(formatoHora);

			$scope.horarioConfiguracao = {
				Entrada: horaEntradaDefault,
				Saida: horaSaidaDefault
			};

			var periodoDefault = [{
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 1,
				"DiaSemana": $translate.instant('dias.domingo'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": false,
				"Excecao": false,
			}, {
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 2,
				"DiaSemana": $translate.instant('dias.segunda'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": true,
				"Excecao": false,
			}, {
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 3,
				"DiaSemana": $translate.instant('dias.terca'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": true,
				"Excecao": false,
			}, {
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 4,
				"DiaSemana": $translate.instant('dias.quarta'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": true,
				"Excecao": false,
			}, {
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 5,
				"DiaSemana": $translate.instant('dias.quinta'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": true,
				"Excecao": false,
			}, {
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 6,
				"DiaSemana": $translate.instant('dias.sexta'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": true,
				"Excecao": false,
			}, {
				"PeriodoId": 0,
				"JornadaId": 0,
				"Dia": 7,
				"DiaSemana": $translate.instant('dias.sabado'),
				"Entrada": horaEntradaDefault,
				"Saida": horaSaidaDefault,
				"Ativo": false,
				"Excecao": false,
			}];

			$scope.getPeriodo = function () {
				if (jornadaid > 0) {
					JornadaTrabalhoResource.getJornadaPeriodo({
						JornadaId: jornadaid
					}).$promise.then((data) => {
						data.forEach((periodo) => {
							periodo.Entrada = moment(periodo.Entrada, 'HH:mm').format(formatoHora);
							periodo.Saida = moment(periodo.Saida, 'HH:mm').format(formatoHora);
						})
						angular.copy(data, $scope.jornadaPeriodoList);
						if ($scope.jornadaPeriodoList.length <= 0) {
							$scope.jornadaPeriodoList = periodoDefault;
						}
						for (var i = 0; i < $scope.jornadaPeriodoList.length; i++) {
							if ($scope.jornadaPeriodoList[i].Ativo && !$scope.jornadaPeriodoList[i].Excecao) {
								$scope.horarioConfiguracao.Entrada = moment($scope.jornadaPeriodoList[i].Entrada, 'HH:mm').format(formatoHora);
								$scope.horarioConfiguracao.Saida = moment($scope.jornadaPeriodoList[i].Saida, 'HH:mm').format(formatoHora);
								break;
							}
						}
					}, function () { });
				} else $scope.jornadaPeriodoList = periodoDefault;
			};

			var mensagemSucesso = function () {
				NotifyService.showRegistroSalvo();
				if ($scope.novo) {
					$scope.ramalStatusEdit = {};
				}

				$scope.submitted = false;
			}

			$scope.adicionarExcecao = function () {
				var periodos = [];
				var periodosAtivos = [];

				angular.copy($scope.jornadaPeriodoList, periodos);
				angular.forEach(periodos, (item) => {
					if (item.Excecao && item.Ativo) {
						$scope.periodoExcecao.Entrada = item.Entrada;
						$scope.periodoExcecao.Saida = item.Saida;
					}
					if (item.Ativo) {
						periodosAtivos.push(item);
					}
				});
				$scope.periodos = periodosAtivos;
				ModalService.openModal('modalExcecao');
			}

			$scope.salvarExcecao = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}
				var excecao = $scope.periodoExcecao;
				//Periodo Normal
				var txtEntrada = $("#txtEntrada-" + excecao.Dia);
				var txtSaida = $("#txtSaida-" + excecao.Dia);
				txtEntrada.fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
				txtSaida.fadeIn(200).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);

				angular.forEach($scope.jornadaPeriodoList, (item) => {
					if (item.Dia != excecao.Dia) {
						item.Entrada = $scope.horarioConfiguracao.Entrada;
						item.Saida = $scope.horarioConfiguracao.Saida;
						item.Excecao = false;
					} else {
						item.Entrada = excecao.Entrada;
						item.Saida = excecao.Saida;
						item.Excecao = true;
					}
				});
				ModalService.closeModal('modalExcecao');
				$scope.atualizaJornada();
			}

			$scope.atualizaJornada = function () {
				var periodos = $scope.jornadaPeriodoList;

				angular.forEach(periodos, (item) => {
					if (!item.Excecao) {
						item.Entrada = $scope.horarioConfiguracao.Entrada;
						item.Saida = $scope.horarioConfiguracao.Saida;
					}
				});

				$scope.forms.formPeriodos.$dirty = true;
			}

			$scope.validateJornada = function () {
				var alterado = $scope.isNew ? false : $scope.forms.formJornada.$dirty;
				var proximoStep = false;

				if (alterado) {
					ModalService.confirmDescartar(() => {
						$scope.forms.formJornada.$dirty = false;
						$scope.forms.formJornada.$setPristine();
					});
				} else {
					if ($scope.forms.formJornada.$valid) {
						proximoStep = true;
					}
				}

				return proximoStep;
			};

			$scope.validatePeriodo = function () {
				var alterado = $scope.isNew ? false : $scope.forms.formPeriodos.$dirty;
				var proximoStep = false;

				if (alterado) {
					ModalService.confirmDescartar(function () {
						$scope.forms.formPeriodos.$dirty = false;
						$scope.forms.formPeriodos.$setPristine();
					});
				} else {
					if ($scope.forms.formPeriodos.$valid) {
						proximoStep = true;
					}
				}

				return proximoStep;
			};

			$scope.salvar = function (form) {
				var lastStep = form.$name == "forms.formGrupos" ? true : false;

				if (!form.$dirty && !lastStep) {
					WizardHandler.wizard().next();
				}
				else {
					if (!form.$valid) {
						return NotifyService.showInvalid();
					}

					if (!$scope.isNew) {
						if (form.$name == "forms.formJornada") {
							$scope.submitted = true;
							salvarJornada();
							form.$setPristine();
						} else if (form.$name == "forms.formPeriodos") {
							ModalService.showLoading();
							$scope.submitted = true;
							salvarPeriodo().then(() => {
								salvarJornada();
								mensagemSucesso();
								atualizaPeriodos();
								ModalService.hideLoading();								
							}).catch((error) => {
								NotifyService.showError(error);
								ModalService.hideLoading();
							});
							form.$setPristine();
						} else if (lastStep) {
							if (form.$dirty) {
								$q.all(salvarGrupos(form)).then(() => {
									salvarJornada();
									mensagemSucesso();
									$scope.getGruposNaoAssociados();
									$scope.getGruposAssociados();
								}).catch(NotifyService.showError);
							}

							if (!form.$dirty) {
								$state.go('main.jornadatrabalho.list', {
									storage: true
								});
							} else {
								form.$setPristine();
								$scope.grupoAlterado = false;
							}
						}
					}
					else if (lastStep) {
						$scope.salvando = true;

						salvarJornada().then((data) => {
							 angular.copy(data, $scope.jornadaTrabalho);
							 $stateParams.JornadaId = $scope.jornadaTrabalho.JornadaId;
							// jornadaid = $scope.jornadaTrabalho.JornadaId;
							salvarPeriodo().then(() => {
								$q.all(salvarGrupos(form)).then(() => {
									this.salvando = false;
									processaJornada();
									mensagemSucesso();
									$state.go('main.jornadatrabalho.list', {
										storage: true
									});
								}).catch((e) => {
									this.salvando = false;
									NotifyService.showError(e);
								});
							});
						}).catch((e) => {
							this.salvando = false;
							NotifyService.showError(e);
						});
					}
				}
			}

			var salvarJornada = function () {
				if (jornadaid > 0) {
					return JornadaTrabalhoResource.update($scope.jornadaTrabalho).$promise
					.then((data) => {
						angular.copy(data, $scope.jornadaTrabalho);
						$stateParams.JornadaId = $scope.jornadaTrabalho.JornadaId;
						jornadaid = $scope.jornadaTrabalho.JornadaId;
						processaJornada();
						mensagemSucesso();
					}).catch(NotifyService.showError);
				}
				else {
					return JornadaTrabalhoResource.save($scope.jornadaTrabalho).$promise
					.then((data) => {
						angular.copy(data, $scope.jornadaTrabalho);
						$stateParams.JornadaId = $scope.jornadaTrabalho.JornadaId;
						jornadaid = $scope.jornadaTrabalho.JornadaId;
						processaJornada();
						mensagemSucesso();
					}).catch(NotifyService.showError);
				}
			}

			var salvarPeriodo = function () {
				var promise;
				var entradaPadrao = $scope.horarioConfiguracao.Entrada;
				var saidaPadrao = $scope.horarioConfiguracao.Saida;

				if (entradaPadrao && saidaPadrao) {
					if (typeof $scope.jornadaPeriodoList !== 'undefined' && $scope.jornadaPeriodoList.length > 0) {
						var jornadasPendentes = [];
						var error = [];
						angular.forEach($scope.jornadaPeriodoList, (item) => {
							var periodo = validPeriodo(item);
							if (validHorario(periodo)) {
								jornadasPendentes.push(periodo);
							}
							else {
								error.push(periodo);
							}
						});

						if (error.length > 0) {
							atualizaPeriodos();
							throw ModalService.hideLoading();
						}

						if (jornadasPendentes.length > 0) {
							promise = JornadaTrabalhoResource.adicionarJornadaPeriodo(jornadasPendentes).$promise;
						}

					}
				} else {
					return NotifyService.showError(null, 'telaJornadaTrabalhoEdit.informeOHorarioPadrao');
				}

				return promise;
			}

			var validPeriodo = function (periodo) {
				if (periodo) {
					periodo.JornadaId = jornadaid;
					periodo.Entrada = periodo.Excecao ? periodo.Entrada : $scope.horarioConfiguracao.Entrada;
					periodo.Saida = periodo.Excecao ? periodo.Saida : $scope.horarioConfiguracao.Saida;

					if (periodo.Entrada && typeof periodo.Entrada != 'string') {
						periodo.Entrada = new moment(periodo.Entrada).format("HH:mm");
					}
					else {
						periodo.Entrada = moment(periodo.Entrada, formatoHora).format("HH:mm")
					}
					if (periodo.Saida && typeof periodo.Saida != 'string') {
						periodo.Saida = new moment(periodo.Saida).format("HH:mm");
					}
					else {
						periodo.Saida = moment(periodo.Saida, formatoHora).format("HH:mm")
					}

					return periodo;

				} else {
					return null
				}
			};

			var validHorario = function (periodo) {
				var valid = true;

				if (periodo.Entrada > (periodo.Saida)) {
					valid = false;
					NotifyService.showError(null, 'telaJornadaTrabalhoEdit.verifiqueOsHorarios', { 'Periodo': periodo.DiaSemana })
				}

				return valid;
			}

			var atualizaPeriodos = function () {
				$scope.jornadaPeriodoList.forEach((periodo) => {
					periodo.Entrada = moment(periodo.Entrada, 'HH:mm').format(formatoHora);
					periodo.Saida = moment(periodo.Saida, 'HH:mm').format(formatoHora);
				})
			}

			$scope.finalizarCadastro = function () {
				JornadaTrabalhoResource.processarJornada({
					JornadaId: jornadaid
				}).$promise.then(() => {
					$state.go("main.jornadatrabalho.list", {
						page: 'main.jornadatrabalho.list'
					})
				}).catch(NotifyService.showError);
			}

			var processaJornada = function () {
				JornadaTrabalhoResource.processarJornada({ JornadaId: jornadaid }).$promise;
			}

			//Grupos
			$scope.gruposAdicionados = [];
			$scope.grupos = [];

			$scope.limitGrupos = 5;
			$scope.limitGruposAdicionados = 5;

			//Grupos
			$scope.getGruposNaoAssociados = function () {
				JornadaTrabalhoResource.getGrupoLivre({ jornadaId: jornadaid }).$promise
					.then((data) => {
						angular.copy(data, $scope.grupos);
					});
			};

			//Grupos Associados
			$scope.getGruposAssociados = function () {
				JornadaTrabalhoResource.getGrupoReservado({ jornadaId: jornadaid }).$promise
					.then((data) => {
						angular.copy(data, $scope.gruposAdicionados);
					});
			};

			var salvarGrupos = function (form) {
				var allpromises = [];
				if (jornadaid > 0) {
					if (form.$dirty) {
						//insere os grupos
						if ($scope.gruposAdicionados.length) {
							var gruposAdicionados = _.where($scope.gruposAdicionados, { Alterado: true });
							angular.forEach(gruposAdicionados, (value) => {
								value.Alterado = false;
								allpromises.push(JornadaTrabalhoResource.adicionarGrupo({
									JornadaId: jornadaid,
									GrupoId: value.GrupoId,
								}).$promise);
							})
						}
						//remove os grupos
						if ($scope.grupos.length) {
							var grupos = _.where($scope.grupos, { Alterado: true });
							angular.forEach(grupos, (value) => {
								value.Alterado = false;
								allpromises.push(JornadaTrabalhoResource.removerGrupo({
									JornadaId: jornadaid,
									GrupoId: value.GrupoId,
								}).$promise);
							});
						}
					}
				}

				return allpromises;
			};


			$scope.adicionarGrupo = function () {
				var gruposSelecionados = _.where($scope.grupos, { Selecionado: true });

				if (gruposSelecionados.length > 0) {
					angular.forEach(gruposSelecionados, (value) => {
						value.Selecionado = false;
						value.Adicionado = true;

						if (value.Removido && value.Alterado) {
							value.Removido = false;
							value.Alterado = false;
						} else value.Alterado = true;

						$scope.gruposAdicionados.push(value);
						$scope.grupos.splice($scope.grupos.indexOf(value), 1);
					});

					$scope.grupoAlterado = true;
				} else {
					NotifyService.showError(null, 'telaJornadaTrabalhoEdit.selecioneUmGrupoASerAdicionado');
				}
			};

			$scope.removerGrupo = function () {
				if (!$scope.isJornadaPadrao) {
					var gruposSelecionados = _.where($scope.gruposAdicionados, {
						Selecionado: true
					});
					if (gruposSelecionados.length > 0) {
						angular.forEach(gruposSelecionados, (value) => {
							value.Selecionado = false;
							value.Removido = true;

							if (value.Adicionado && value.Alterado) {
								value.Adicionado = false;
								value.Alterado = false;
							} else value.Alterado = true;

							$scope.grupos.push(value);
							$scope.gruposAdicionados.splice($scope.gruposAdicionados.indexOf(value), 1);
						});

						$scope.grupoAlterado = true;
					} else {
						NotifyService.showError(null, 'telaJornadaTrabalhoEdit.selecioneUmGrupoASerRemovido');
					}
				}
				else {
					NotifyService.showError(null, 'telaJornadaTrabalhoEdit.oGrupoNaoPodeSerRemvidoDaJornadaPadrao');
				}
			};

			$scope.selecionarTodosAdicionados = function () {
				const grupos = $filter('filter')($scope.gruposAdicionados, $scope.search.grupo);

				angular.forEach(grupos, (item) => {
					if ($scope.validacoes.todosItemsAdicionados) {
						item.Selecionado = true;
					} else {
						item.Selecionado = false;
					}
				});

				if ($scope.validacoes.todosItemsAdicionados && grupos.length !== $scope.gruposAdicionados.length) {
					setTimeout(() => {
						$scope.validacoes.todosItemsAdicionados = false;
						$scope.$apply();
					}, 1);
				}
			};

			$scope.selectionarTodosNaoAdicionados = function () {
				const grupos = $filter('filter')($scope.grupos, $scope.search.grupo);

				angular.forEach(grupos, (item) => {
					if ($scope.validacoes.todosItemsNaoAdicionados) {
						item.Selecionado = true;
					} else {
						item.Selecionado = false;
					}
				});

				if ($scope.validacoes.todosItemsNaoAdicionados && grupos.length !== $scope.grupos.length) {
					setTimeout(() => {
						$scope.validacoes.todosItemsNaoAdicionados = false;
						$scope.$apply();
					}, 1);
				}
			};

			$scope.maisGruposAdicionados = function () {
				if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
					$scope.limitGruposAdicionados += 5;
					$("#gruposAdicionados").animate({
						scrollTop: $("#tabGruposAdicionados").height()
					}, 800);
				}
			};

			$scope.maisGruposNaoAdicionados = function () {
				if ($scope.limitGrupos < $scope.grupos.length) {
					$scope.limitGrupos += 5;
					$("#gruposNaoAdicionados").animate({
						scrollTop: $("#tabGruposNaoAdicionados").height()
					}, 800);
				}
			};

			$("#gruposAdicionados").bind("DOMMouseScroll mousewheel", function (e) {
				if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
					$scope.$apply(() => {
						if (e.originalEvent.wheelDelta / 120 < 0) {
							$scope.limitGruposAdicionados += 5;
							$("#gruposAdicionados").animate({
								scrollTop: $("#tabGruposAdicionados").height()
							}, 800);
						}
					});
				}
			});

			$("#gruposNaoAdicionados").bind("DOMMouseScroll mousewheel", function (e) {
				if ($scope.limitGrupos < $scope.grupos.length) {
					$scope.$apply(() => {
						if (e.originalEvent.wheelDelta / 120 < 0) {
							$scope.limitGrupos += 5;
							$("#gruposNaoAdicionados").animate({
								scrollTop: $("#tabGruposNaoAdicionados").height()
							}, 800);
						}
					});
				}
			});

			$scope.getGruposNaoAssociados();
			$scope.getGruposAssociados();
			$scope.getPeriodo();
		}])
})();


(function () {
	"use strict";

	var defaultPageSize = 15;

	var getOdataSearchShared = function (JornadaTrabalhoResource, search, orderBy) {
		var odata = JornadaTrabalhoResource.odata();

		if (search.GrupoId) {
			odata.whereIn('JornadaTrabalhoGrupo', 'GrupoId', parseInt(search.GrupoId));
		}

		if (search.Descricao) {
			odata.where('Nome', 'startswith', search.Descricao);
		}
		if (search.CarteiraId) {
            odata.filter("CarteiraId", "=", parseInt(search.CarteiraId));
        }

		odata.orderBy(orderBy.column, orderBy.order);

		return odata;
	};


	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.jornadatrabalho", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.jornadatrabalho.list',
						pageTitle: 'model.jornadaDeTrabalho',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.jornadatrabalho.list", StateResolverProvider.configState("/jornadatrabalho", "JornadaTrabalho", "List", {
					pageTitle: 'model.jornadaDeTrabalho',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("JornadaTrabalhoListData", function JornadaTrabalhoListData() {
			return function () {
				return {
					jornadaList: ["JornadaTrabalhoResource", "LocalStorageService", "$odata", "$stateParams", function (JornadaTrabalhoResource, LocalStorageService, $odata, $stateParams) {
						var filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroJornadaTrabalho");
						}

						var orderBy = {
							column: "JornadaId",
							order: "asc"
						};

						var odata = getOdataSearchShared(JornadaTrabalhoResource, filtro, orderBy, $odata);
						return odata.page(defaultPageSize, 1).query();
					}],
					grupoList: ["GrupoResource", function (GrupoResource) {
						return GrupoResource.getGrupoSimples().$promise;
					}],
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("JornadaTrabalhoListController", ["$scope", "$odata", "jornadaList", "grupoList", "LocalStorageService", "JornadaTrabalhoResource", "carteiras", "NotifyService", "ModalService", function ($scope, $odata, jornadaList, grupoList, LocalStorageService, JornadaTrabalhoResource, carteiras, 
			NotifyService, ModalService) {
			$scope.search = {};
			$scope.searching = false;
			$scope.jornadaList = jornadaList;
			$scope.grupoList = grupoList;
			$scope.carteiras = carteiras

			$scope.orderBy = {
				column: "JornadaId",
				order: "asc"
			};

			var updateList = function (list) {
				$scope.jornadaList = list;
				$scope.jornadaList.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.jornadaList.pageSize = list.$pageSize || defaultPageSize;
				$scope.searching = false;
			};

			$scope.pageChanged = function (newPage) {
				ModalService.showLoading();
				getOdataSearch().page($scope.jornadaList.pageSize, newPage).query()
					.then((list) => {
						updateList(list);
						ModalService.hideLoading();
					})
					.catch((error) => {
						NotifyService.showError(error);
						ModalService.hideLoading();
					});
			};

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroJornadaTrabalho');
				$scope.search = { pageSize: defaultPageSize };
				$scope.executeSearch();
			}

			var getOdataSearch = function () {
				return getOdataSearchShared(JornadaTrabalhoResource, $scope.search, $scope.orderBy, $odata);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroJornadaTrabalho', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			var deleteRecord = function (data) {
				JornadaTrabalhoResource.delete({ JornadaId: data.JornadaId }).$promise
					.then(() => {
						$scope.pageChanged($scope.currentPage);
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
			}

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			}

			updateList(jornadaList);

		}]);
	})
();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("JornadaTrabalhoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("JornadaTrabalho/:JornadaId",
                {
                    "JornadaId": "@JornadaId"
                },
                {
                    getJornadaPeriodo: {
                        url: "JornadaTrabalho/JornadaPeriodo",
                        method: "GET",
                        isArray: true
                    },
                    getGrupoLivre: {
                        url: "JornadaTrabalho/GrupoLivre",
                        method: "GET",
                        isArray: true
                    },
                    getGrupoReservado: {
                        url: "JornadaTrabalho/GrupoReservado",
                        method: "GET",
                        isArray: true
                    },
                    adicionarJornadaPeriodo: {
                        url: "JornadaTrabalho/AdicionarJornadaPeriodo",
                        method: "POST"
                    },
                    adicionarGrupo: {
                        url: "JornadaTrabalho/AdicionarGrupo",
                        method: "POST"
                    },
                    removerGrupo: {
                        url: "JornadaTrabalho/RemoverGrupo",
                        method: "POST"
                    },
                    processarJornada: {
                        url: "JornadaTrabalho/ProcessarJornada",
                        method: "POST"
                    },
                    getJornadaTrabalhoPorGrupo:
                    {
                        method: "GET",
                        url: "JornadaTrabalho/JornadaTrabalhoPorGrupo",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("login", StateResolverProvider.configState("/login", "Login", 'View'))
        }])
        .service("LoginViewData", function LoginData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_iCheck'
                        ]);
                    }],
                    usuarioLogado: ["AuthService", function (AuthService) {
                        return AuthService.restore().catch(function () {
                            return null;
                        });
                    }]
                }
            }
        })

        .controller('LoginViewController', ["$scope", "AuthService", "$state", "$location", "$translate", "NotifyService", "Config", "TranslateService", "usuarioLogado", "STATES", "LocalStorageService", "UsuarioResource", function ($scope, AuthService, $state, $location, $translate, NotifyService,
            Config, TranslateService, usuarioLogado, STATES, LocalStorageService, UsuarioResource) {
            $scope.credentials = {
                persist: true,
                platform: 'local'
            };
            $scope.idiomaConfig = {
                ativo: false
            };

            if ($location.search().logado == 'true') { 
                AuthService.loginOkta($location.search().hash)
                    .then(function(c){
                        gotoMainPage(c)
                    });
            }

            const exibirIdiomas = () => {
                $scope.idiomaConfig.ativo = TranslateService.getI18NAtivo();
                if ($scope.idiomaConfig.ativo) {
                    $scope.idiomaConfig.idiomaAtual = TranslateService.getIdiomaAtual();
                    $scope.idiomas = [
                        { id: 'pt', descricao: 'Português' },
                        { id: 'en', descricao: 'English' },
                        { id: 'es', descricao: 'Español' }
                    ];

                    $scope.alterarIdioma = function (idioma) {
                        $scope.idiomaConfig.idiomaAtual = idioma.id;
                        TranslateService.alterarIdioma(idioma.id);
                    }
                }
            };

            $scope.oktaHabilitado = TranslateService.getOktaHabilitado();
            
            $scope.isLGPD = TranslateService.getLGPDHabilitado();

            if (TranslateService.verificarConfiguracao()) {
                exibirIdiomas();
            } else {
                $scope.$on('idiomaConfigurado', exibirIdiomas);
            }

            $scope.hideForm = false;
            $scope.type = $location.search().type;
            var returnUrl = Config.getUrlService($location.search().ReturnUrl);
            $scope.returnUrl = returnUrl.contains("/Service//service") ? returnUrl.replace("/Service//service", "/service") : returnUrl;

            var gotoMainPage = function gotoMainPage(checkAuth) {
                if ($scope.type == 'code' || $scope.type == 'codeReauth') {
                    if (checkAuth == true && $scope.type == 'codeReauth') {
                        AuthService.logout();
                    } else {
                        window.location.href = $scope.returnUrl;
                    }
                } else {
                    $scope.hideForm = true;
                    var redirectUrl = LocalStorageService.getItem("redirLoginUrl");
                    if (typeof redirectUrl == 'string' && redirectUrl != null) {
                        window.location.href = redirectUrl;
                    } else {
                        $state.go(STATES.defaultState);
                    }
                }
            }

            if (usuarioLogado) {
                gotoMainPage(true);
            }

            var mensagemErro = function (error) {
                var mensagem = 'telaLogin.erroAoRealizarLogin';
                var descricao = (error && error.data && error.data.error_description) || '';
                if (error.status === 400 && descricao.contains("password expired")) {

                    localStorage.removeItem('alterar_senha');
                    localStorage.setItem('alterar_senha', $scope.credentials.username);

                    $state.go("alterarsenha");

                    mensagem = '';
                }else if(descricao.contains("first Login")){

                    localStorage.clear();

                    localStorage.setItem('alterar_senha', $scope.credentials.username);
                    localStorage.setItem('primeiro_login', true);

                    $state.go("alterarsenha");
                    mensagem = '';
                }
                else if (error.status === 400 && descricao.contains("host is invalid")) {
                    mensagem = 'telaLogin.hostUser';
                } else if (error.status === 400) {
                    mensagem = 'telaLogin.nomeDeUsuarioOuSenhaInvalido';
                }

                if (mensagem.length > 0)
                    NotifyService.showError(null, mensagem)
            }

            var clearFormAndShowError = function clearFormAndShowError(form) {
                return function clearFormAndShowErrorInner(response) {
                    form.$submitted = false;


                    mensagemErro(response);
                }
            }

            $scope.loginOkta = function () {
                window.location.href = window.location.origin + '/service/autenticacao/okta/authorize';
            }

            $scope.onEsqueciMinhaSenha = function () {

                if (!$scope.credentials.username) {
                    return NotifyService.showMessage('telaLogin.preenchaOCampoUsuario', "danger");
                }

                var absUrl = $location.absUrl();
                absUrl = absUrl.replace("login", "esqueciminhasenha/#id/#hash");
                var clique = $translate.instant('telaLogin.cliqueAqui');
                var url = '<div><a href="' + absUrl + '" style="text-decoration: none;">' + clique + '</a></div>';
                var mensagem = $translate.instant('telaLogin.mensagemEmail');
                mensagem = mensagem.replace("#url", url);
                var assunto = $translate.instant('telaLogin.assuntoEmail');
                UsuarioResource.EsqueciMinhaSenha({
                    login: $scope.credentials.username,
                    mensagem: mensagem,
                    assunto: assunto
                }).$promise
                    .then(() => {
                        NotifyService.showMessage('telaLogin.enviamosUmLink', "success");
                    }).catch(function (error) {
                        if (error && error.data) {
                            NotifyService.showMessage(error.data.Message, "danger");
                        }
                    });
            }

            $scope.login = function (form, credentials) {
                return AuthService.login(credentials.username, credentials.password, credentials.persist, credentials.platform)
                    .then(gotoMainPage)
                    .catch(clearFormAndShowError(form));
            };


        }]);
})();
(function () {
    "use strict";

    var defaultPageSize = 30;
    var defaultOrderBy = { column: 'Data', order: 'desc' };
    var getDefaultDataInicio = function () {
        return moment().subtract(30, 'minutes').seconds(0).milliseconds(0).toDate();
    }

    var getOdataSearchShared = function (LogSistemaResource, search, orderBy) {
        var odata = LogSistemaResource.odata();
        if (search.UsuarioId) {
            odata.filter('UsuarioId', parseInt(search.UsuarioId, 10));
        }
        if (search.DataInicio) {
            odata.filter('Data', '>=', search.DataInicio);
        }
        if (search.DataFim) {
            odata.filter('Data', '<=', search.DataFim);
        }
        if (search.Severidade) {
            odata.filter('Severidade', search.Severidade);
        }
        if (search.OrigemId) {
            odata.filter('OrigemId', parseInt(search.OrigemId));
        }
        if (search.LogContextoId) {
            odata.filter('LogContextoId', parseInt(search.LogContextoId));
        }
        if (search.Mensagem) {
            odata.where('Mensagem', 'contains', search.Mensagem);
        }

        orderBy = orderBy || defaultOrderBy;

        return odata.orderBy(orderBy.column, orderBy.order);
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.logsistema", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.logsistema.list',
                        pageTitle: 'pageTitle.logDeSistema',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.logsistema.list", StateResolverProvider.configState("/logsistema", "LogSistema", "List", {
                    pageTitle: 'pageTitle.logDeSistema',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("LogSistemaListData", function LogSistemaListData() {
            return function () {
                return {
                    logSistemaList: ["LogSistemaResource", function (LogSistemaResource) {
                        return getOdataSearchShared(LogSistemaResource, { DataInicio: getDefaultDataInicio() })
                            .page(defaultPageSize, 1)
                            .query();
                    }],
                    origemList: ["LogSistemaResource", function (LogSistemaResource) {
                        return LogSistemaResource.origem().$promise;
                    }],
                    severidadeList: ["LogSistemaResource", function (LogSistemaResource) {
                        return LogSistemaResource.severidade().$promise;
                    }],
                    contextoList: ["LogSistemaResource", function (LogSistemaResource) {
                        return LogSistemaResource.contexto().$promise;
                    }]
                }
            }
        })

        .controller("LogSistemaListController", ["$scope", "logSistemaList", "LogSistemaResource", "severidadeList", "origemList", "contextoList", "NotifyService", "ModalService", function ($scope, logSistemaList, LogSistemaResource, severidadeList, origemList, contextoList, NotifyService,
            ModalService) {
            $scope.searching = false;
            $scope.severidadeList = severidadeList;
            $scope.origemList = origemList;
            $scope.contextoList = contextoList;
            $scope.search = { pageSize: defaultPageSize, logDetalheAtivo: null, DataInicio: getDefaultDataInicio() };
            $scope.logDetalheAtivo = null;

            var updateList = function (list) {
                angular.forEach(list, (item) => {
                    if (item.Excecao != null && item.Excecao != "null") {
                        try {
                            item.Excecao = angular.fromJson(item.Excecao);
                            var stackTraceString = item.Excecao.StackTraceString || item.Excecao.StackTrace || "";
                            while (item.Excecao.InnerException) {
                                item.Excecao = item.Excecao.InnerException
                                stackTraceString += "\n" + (item.Excecao.StackTraceString || "");
                            }
                            item.Excecao.StackTraceString = stackTraceString;
                        } catch (e) {
                            $scope.searching = false;
                            NotifyService.showError(e)
                        }
                    }
                    if (item.Propriedades) {
                        try {
                            item.Propriedades = angular.fromJson(item.Propriedades);
                        } catch (e) {
                            $scope.searching = false;
                            NotifyService.showError(e)
                        }
                    }
                });
                $scope.logSistemaList = list;
                $scope.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.search.pageSize = list.$pageSize || defaultPageSize;
                $scope.searching = false;
            }

            $scope.limparFiltro = function () {
                $scope.search = { pageSize: defaultPageSize, logDetalheAtivo: null };
                $scope.search.DataInicio = getDefaultDataInicio();
            }

            $scope.showLogDetalhe = function (logSistema) {
                $scope.logDetalheAtivo = logSistema;
            }

            $scope.executeSearch = function (search) {
                $scope.searching = true;
                return getOdataSearchShared(LogSistemaResource, search).page(search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            }

            $scope.pageChanged = function (newPage, search) {
                ModalService.showLoading();
                return getOdataSearchShared(LogSistemaResource, search).page(search.pageSize, newPage).query()
                    .then((list) => {
                        updateList(list);
                        ModalService.hideLoading();
                    }).catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                    });
            };

            updateList(logSistemaList);

        }]);
    })
();

(function () {
  "use strict"
  angular.module('epbxManagerApp')
    .factory("LogSistemaResource", ["$odataresource", function ($odataresource) {
      return $odataresource("LogSistema/:LogSistemaId", { "LogSistemaId": "@LogSistemaId" },
        {
          origem: { method: "GET", url: "LogSistema/Origem", isArray: true },
          severidade: { method: "GET", url: "LogSistema/Severidade", isArray: true },
          contexto: { method: "GET", url: "LogSistema/Contexto", isArray: true }
        });
    }]);
})
();

angular.module('epbxManagerApp')

    .controller('mainHeaderCtrl', ["$timeout", "$scope", "$window", "TranslateService", "AuthService", "PerfilResource", "LocalStorageService", "$rootScope", "AUTH_EVENTS", "PermissaoService", function ($timeout, $scope, $window, TranslateService, AuthService, PerfilResource, LocalStorageService, $rootScope, AUTH_EVENTS, PermissaoService) {
        $scope.i18nAtivo = false;
        const exibirIdiomas = () => {
            $scope.i18nAtivo = TranslateService.getI18NAtivo();
            if ($scope.i18nAtivo) {
                $scope.idiomaAtual = TranslateService.getIdiomaAtual();
                $scope.idiomas = [
                    { id: 'pt', descricao: 'Português' },
                    { id: 'en', descricao: 'English' },
                    { id: 'es', descricao: 'Español' }
                ];

                $scope.alterarIdioma = function (idioma) {
                    $scope.idiomaAtual = idioma.id;
                    TranslateService.alterarIdioma(idioma.id);
                }
            }
        };

        $scope.transmissaoPermissao = PermissaoService.checkAccess("Transacao", "Visualizar");

        if (TranslateService.verificarConfiguracao()) {
            exibirIdiomas();
        } else {
            $scope.$on('idiomaConfigurado', exibirIdiomas);
        }

        $scope.logout = function logoutInHeader() {
            AuthService.logout();

            setTimeout(function () {         
                $window.location.reload();
            }, 500);
        }

        $scope.transacaoWidget = {
            errorCount: 0
        };

        $scope.mudo = LocalStorageService.getItem('SistemaMudo') === true;
        $scope.mutarSistema = function () {
            $scope.mudo = !$scope.mudo;
            LocalStorageService.setItem('SistemaMudo', $scope.mudo);
            if ($scope.mudo) {
                $('audio,video').each(function () {
                    this.muted = true;
                });
            } else {
                $('audio,video').each(function () {
                    this.muted = false;
                });
            }
        }

        $scope.usuario = AuthService.getUsuarioLogado();
        $scope.usuario.Avatar = {
            ImagemReduzida: ''
        };

        $scope.$on('atualizaImagem', function (event, args) {
            $scope.usuario.Avatar.ImagemReduzida = args.imagemReduzida;
        });

        PerfilResource.usuarioAvatar().$promise.then(function (result) {
            $scope.usuario.Avatar.ImagemReduzida = result.ImagemReduzida;
        });

        $('#menu_top').children('[data-uk-dropdown]').on('show.uk.dropdown', function () {
            $timeout(function () {
                $($window).resize();
            }, 280)
        });
    }]);
angular.module('epbxManagerApp')

    .controller('mainSidebarCtrl', ["$timeout", "$scope", "$state", "Config", "$http", "$rootScope", "SistemaMenuResource", function ($timeout, $scope, $state, Config, $http, $rootScope, SistemaMenuResource) {
        $scope.searchSubmenu = {};
        $rootScope.appVer;
        $scope.search = { text: '' };
        $scope.onFiltroChange = function () {
            $scope.searchSubmenu = {
                Descricao: $scope.search.text,
            }
        }

        $scope.onMenuChange = function (value) {

            var lista = _.filter(value.Submenus, function (menu) {
                return menu.Descricao.toUpperCase().indexOf($scope.search.text.toUpperCase()) !== -1;
            });
            value.filtroexpandido = lista.length > 0 || value.Descricao.toUpperCase().indexOf($scope.search.text.toUpperCase()) !== -1;

            return value.filtroexpandido;
        }

        $scope.onSubmenuChange = function (value) {
            var menuPai = _.find($scope.sections, function (pai) {
                return _.filter(pai.Submenus, function (el2) { return el2.Link == value.Link }).length > 0;
            });
            if (menuPai != null) {
                return menuPai.Descricao.toUpperCase().indexOf($scope.search.text.toUpperCase()) !== -1 ||
                    value.Descricao.toUpperCase().indexOf($scope.search.text.toUpperCase()) !== -1;
            }
            return false;
        }

        $scope.$on('onLastRepeat', function () {
            $timeout(function () {
                if (!$rootScope.miniSidebarActive) {
                    // activate current section
                    $('#sidebar_main').find('.current_section > a').trigger('click');
                } else {
                    // add tooltips to mini sidebar
                    var tooltip_elem = $('#sidebar_main').find('.menu_tooltip');
                    tooltip_elem.each(function () {
                        var $this = $(this);

                        $this.attr('title', $this.find('.menu_title').text());
                        UIkit.tooltip($this, {});
                    });
                }
            })
        });

        // language switcher
        $scope.langSwitcherModel = 'gb';

        $scope.langSwitcherConfig = {
            maxItems: 1,
            render: {
                option: function (langData, escape) {
                    return '<div class="option">' +
                        '<i class="item-icon flag-' + escape(langData.value).toUpperCase() + '"></i>' +
                        '<span>' + escape(langData.title) + '</span>' +
                        '</div>';
                },
                item: function (langData, escape) {
                    return '<div class="item"><i class="item-icon flag-' + escape(langData.value).toUpperCase() + '"></i></div>';
                }
            },
            valueField: 'value',
            labelField: 'title',
            searchField: 'title',
            create: false,
            onInitialize: function () {
                $('#lang_switcher').next().children('.selectize-input').find('input').attr('readonly', true);
            }
        };


        var sectionSuccess = function (response) {
            $scope.sections = response;
        }

        var sectionError = function (error) {
            console.log(error);
        }
        
        var promise = SistemaMenuResource.GetMenus().$promise;
        promise.then(sectionSuccess).catch(sectionError);

        $scope.checkDashboard = function (item) {
            if (item.Link && item.Link.indexOf('dashboard') >= 0) {
                var visaoId = item.Url.replace('/', '');
                return $state.params.VisaoId === visaoId;
            }
            return false;
        }

        $scope.checkAtendimento = function (item) {
            const atendimentoView = 'main.atendimento.view';
            const tabulacaoView = 'main.tabulacao.view';
            if (item.Link && item.Link == tabulacaoView) {
                return $state.current.name == atendimentoView || $state.current.name == tabulacaoView;
            }
            return false;
        }
    }]);
(function () {
    "use strict";

    var _promise = null;
    var _timeout = null;

    angular.module("epbxManagerApp")
        .service('MaquinaEditData', function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_masked_inputs',
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    maquina: ["MaquinaResource", "$stateParams", function (MaquinaResource, $stateParams) {
                        if ($stateParams.MaquinaId) {
                            return MaquinaResource.get({
                                MaquinaId: $stateParams.MaquinaId
                            }).$promise;
                        } else {
                            return { Porta: 44900 };
                        }
                    }],
                    plataformas: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.getPlataformas();
                    }],
                    localidades: ["RotaResource", function (RotaResource) {
                        return RotaResource.getLocalidades().$promise;
                    }],
                }
            }
        })
        .controller("MaquinaEditController", ["$scope", "$window", "$filter", "$state", "maquina", "plataformas", "localidades", "MaquinaResource", "WizardHandler", "$q", "$http", "NotifyService", "Config", "$stateParams", "$translate", "ModalService", function ($scope, $window, $filter, $state, maquina, plataformas, localidades, MaquinaResource, WizardHandler, $q, $http,
            NotifyService, Config, $stateParams, $translate, ModalService) {
            $scope.salvando = false;

            $scope.regex = [
                { id: 1, expression: /^([a-zA-Z]{1}:\\|\\)([a-zA-Z0-9\W]*\\)+$/ig },
                { id: 2, expression: /^\/([a-zA-Z0-9+-_.]+\/)+$/ig }
            ];

            $scope.isNovo = !(maquina && maquina.MaquinaId);
            $scope.maquina = maquina;
            $scope.plataformas = plataformas;
            $scope.localidades = localidades;
            $scope.municipios = [];
            $scope.forms = {};
            $scope.exitValidationMaquina = true;
            $scope.dialogos = [];
            $scope.configuracoes = [];
            $scope.paginaWizard = null;

            var dialogoDefault = [{ id: 0, Caminho: '', IsCaminhoPadrao: true, Ativo: true }];

            var getMunicipios = function (ddd) {
                $http.get(Config.getUrl("Rota/Municipios/") + ddd).then((response) => {
                    $scope.municipios = response.data;
                });
            }

            if (!$scope.isNovo) {
                getMunicipios($scope.maquina.DDD);
            }

            $scope.onChangeLocalidade = function () {
                getMunicipios($scope.maquina.DDD);
            };

            $scope.onChangeEnderecoSip = function () {
                if ($scope.maquina) {
                    if (!$scope.maquina.EnderecoSip) {
                        $scope.maquina.EnderecoSip = $scope.maquina.Ip;
                    }
                }
            };

            $scope.isUrl = function(value){ 
                return /[-a-zA-Z0-9@:%_\+.~#?&=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&=]*)?/gi.test(value);
            }
            $scope.salvarMaquina = function (form) {
                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                if($scope.maquina.EnderecoSipWebRTC && $scope.isUrl($scope.maquina.EnderecoSipWebRTC) === false){
                    console.log($scope.isUrl($scope.maquina.EnderecoSipWebRTC));
                    return NotifyService.showMessage("telaMaquinaEdit.enderecoUrl", 'info');
                }
                if (form.$dirty) {
                    var promise = ($scope.maquina.MaquinaId > 0) ? MaquinaResource.update($scope.maquina).$promise : MaquinaResource.save($scope.maquina).$promise;
                    promise.then(() => {
                        NotifyService.showRegistroSalvo();
                        form.$dirty = false;
                        WizardHandler.wizard().goTo(1);
                    }).catch(NotifyService.showError);
                } else {
                    WizardHandler.wizard().goTo(1);
                }
            }

            var selecionarTabCampoInvalido = function (form) {
                let campo = $filter('filter')($scope.configuracoes,
                    function (c) {
                        return (c.Alias == form.$error.required[0].$name);
                    }
                )[0];
                $window.UIkit.switcher('#tabCamposCTI').show("#" + campo.CampanhaCampoGrupo);
            }

            $scope.salvarConfiguracao = function (form) {
                if (!form.$valid) {
                    selecionarTabCampoInvalido(form);
                    return NotifyService.showInvalid();
                }

                var listaAlterados = $filter('filter')($scope.configuracoes, (c) => {
                    return (c.Valor != c.ValorInicial);
                });

                if (form.$dirty) {
                    if (listaAlterados.length == 0) {
                        form.$setPristine();
                        WizardHandler.wizard().goTo(2);
                    }
                    MaquinaResource.putConfiguracao({ MaquinaId: $scope.maquina.MaquinaId }, listaAlterados).$promise
                        .then(() => {
                            $scope.configuracoes.forEach(element => {
                                element.ValorInicial = element.Valor;
                            });
                            var necessitaReiniciarCti = listaAlterados.find((c) => { return c.NecessitaReiniciarCti })
                            if (necessitaReiniciarCti) {
                                NotifyService.showMessage('telaMaquinaEdit.avisoReiniciarCTI', "warning")
                            } else {
                                NotifyService.showRegistroSalvo();
                            }
                            form.$setPristine();
                            WizardHandler.wizard().goTo(2);
                        }).catch(NotifyService.showError);
                } else {
                    WizardHandler.wizard().goTo(2);
                }
            }

            $scope.salvarDialogos = function (form) {
                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                if (form.$dirty) {
                    $scope.salvando = true;
                    MaquinaResource.putDialogo({ MaquinaId: $scope.maquina.MaquinaId }, $scope.dialogos).$promise
                        .then(() => {
                            NotifyService.showRegistroSalvo();
                            form.$dirty = false;
                        }).catch(NotifyService.showError).finally(() => $scope.salvando = false);
                } else {
                    $state.go("main.maquinas.list", {
                        page: 'main.maquinas.list'
                    });
                }
            }

            $scope.onInitTipoCampoMaquina = function (configuracao) {
                if (configuracao.Valor == "1") {
                    configuracao.Checked = true;
                } else {
                    configuracao.Checked = false;
                }
            };

            $scope.onChangeTipoCampoMaquina = function (configuracao) {
                if (configuracao.Checked) {
                    configuracao.Valor = "1";
                }
                else {
                    configuracao.Valor = "0";
                }
            };

            $scope.voltar = function () {
                $state.go('main.maquinas.list');
            };

            $scope.detalhe = function (configuracoes) {
                var msg = `<h4>${$translate.instant('campo.detalhe')}</h4></br>${configuracoes.Descricao}`;
                ModalService.alert(msg);
            }

            $scope.adicionarItemDialogo = function () {
                $scope.dialogos.push({ Ativo: true });
            }

            $scope.removerItemDialogo = function (index) {
                if ($scope.maquina.MaquinaId && $scope.dialogos[index].MaquinaDialogoId) {
                    $scope.dialogos[index].Ativo = false;
                }
                else {
                    $scope.dialogos.splice(index, 1);
                }
                // "Força" o Estado do Formulário como "Alterado"
                $scope.forms.Dialogos.$setDirty();
            }

            $scope.getRegexPlataforma = function () {
                return $scope.regex[$scope.maquina.PlataformaId - 1].expression;
            }

            $scope.onCheckPath = function (index) {
                if (_timeout != null) {
                    clearTimeout(_timeout);
                }

                if (_promise != null) {
                    $scope.abortPromise(_promise);
                }

                // Oculta o ícone de "Caminho Válido"
                $scope.dialogos[index].IsCaminhoValido = null;
                // Bloqueia o Formulário
                $scope.blockLoading(index, false);
                _timeout = setTimeout(() => {
                    // Valida se o Path existe no Servidor
                    _promise = $scope.validarDiretorio($scope.forms.Dialogos['caminho' + index].$viewValue, index);
                    if (_promise) {
                        _promise.then((response) => {
                            $scope.blockLoading(index, true);
                            $scope.dialogos[index].IsCaminhoValido = response.directoryExists;
                        }).catch(() => {
                            $scope.blockLoading(index, true);
                            $scope.dialogos[index].IsCaminhoValido = false;
                        });
                    }
                }, 500);
            }

            $scope.validarDiretorio = function (path, index) {
                if (path.slice(-1) != '/') {
                    $scope.blockLoading(index, true);
                    $scope.dialogos[index].IsCaminhoValido = false;
                    return null;
                }

                let httpTimeout = $q.defer();
                let request = $http({
                    method: 'POST',
                    url: Config.getUrl("Maquina/ValidaDiretorio/") + '?path=' + path + '&plataforma=' + $scope.maquina.PlataformaId,
                    data: $scope.maquina,
                    timeout: httpTimeout.promise
                });
                let promise = request.then((response) => { return response.data; });
                promise._httpTimeout = httpTimeout;
                return promise;
            }

            $scope.abortPromise = function (promise) {
                if (promise && promise._httpTimeout && promise._httpTimeout.resolve) {
                    promise._httpTimeout.resolve();
                }
            }

            $scope.blockLoading = function (index, block) {
                $scope.forms.Dialogos['caminho' + index].$setValidity('loading', block);
            }

            var carregarDialogos = function () {
                var maquinaId = $scope.maquina ? $scope.maquina.MaquinaId : $stateParams.MaquinaId;
                if (maquinaId && maquinaId > 0) {
                    var promise = MaquinaResource.getDialogos({ maquinaId: maquinaId }).$promise;
                    if (promise) {
                        promise.then((data) => {
                            if (data.length > 0) {
                                $scope.dialogos = data;
                            } else {
                                $scope.dialogos = dialogoDefault;
                            }
                        });
                    }
                } else {
                    $scope.dialogos = dialogoDefault;
                }
            }

            var carregaConfiguracao = function () {
                var maquinaid = $scope.maquina ? $scope.maquina.MaquinaId : $stateParams.MaquinaId;
                var promise = MaquinaResource.getConfiguracao({ MaquinaId: maquinaid | 0 }).$promise;
                if (promise) {
                    promise.then((data) => {
                        $scope.configuracoes = data;
                        var tiposConfiguracao = _.uniq(_.map($scope.configuracoes, (el) => { return el.CampanhaCampoGrupo }));
                        $scope.tiposConfiguracao = [];
                        tiposConfiguracao.forEach((tipo) => { $scope.tiposConfiguracao.push({ "Descricao": tipo }) })
                        $scope.tabSelecionado = $scope.tiposConfiguracao[0].Descricao;
                        promise = MaquinaResource.getConfiguracaoItens().$promise;
                        if (promise) {
                            promise.then((data) => {
                                $scope.configuracoes.forEach(element => {
                                    element.OpcaoLista = $filter('filter')(data, { MaquinaCampoId: element.MaquinaCampoId });
                                });
                            });
                        }
                    });
                }
            }

            $scope.add_plus = function (maquina) {
                if (maquina) {
                    alert(maquina);
                }
            };

            $scope.onTabSelecionado = function (tipo) {
                $scope.tabSelecionado = tipo;
            }

            carregarDialogos();
            carregaConfiguracao();

            $scope.validaUltimoStep = function () {
                for (var i in $scope.tiposConfiguracao) {
                    var tipo = $scope.tiposConfiguracao[i];
                    var configuracoes = $scope.configuracoes.filter(x => x.CampanhaCampoGrupo == tipo.Descricao);

                    configuracoes.forEach((conf) => {
                        if (conf.Obrigatorio && conf.Valor == undefined) {
                            conf.TemErro = true;
                        } else {
                            conf.TemErro = false;
                        }
                    })

                    if (configuracoes.find(x => x.TemErro)) {
                        tipo.TemErro = true;
                    } else {
                        tipo.TemErro = false;
                    }
                }

                if (!$scope.forms.Maquina.$valid && $scope.forms.Configuracao.$valid) {
                    return false;
                } else {
                    return true;
                }
            }

            $scope.onPlataformaChange = function () {
                let plataforma = plataformas.find(p => p.PlataformaId == $scope.maquina.PlataformaId);
                $scope.maquina.PastaInstalacao = plataforma.DiretorioPadrao;
            }

        }]);

})();
(function () {
    "use strict";

    var getOdataSearchShared = function (MaquinaResource, search, orderBy, $odata) {
        var odata = MaquinaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.maquinas", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.maquinas.list',
                        pageTitle: 'model.maquina',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.maquinas.list", StateResolverProvider.configState("/maquinas", "Maquina", "List", {
                    pageTitle: 'model.maquina',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.maquinas.new", StateResolverProvider.configState("/maquinas/new", "Maquina", "Edit", {
                    pageTitle: 'model.maquina',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.maquinas.edit", StateResolverProvider.configState("/maquinas/{MaquinaId:[0-9]+}", "Maquina", "Edit", {
                    pageTitle: 'model.maquina',
                    pageName: 'acoes.editar',
                    css: true
                }));
        }])

        .service("MaquinaListData", function ServicoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    maquinas: ["MaquinaResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (MaquinaResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroMaquina");

                        var orderBy = {
                            column: "Descricao",
                            order: "asc"
                        };
                        var odata = getOdataSearchShared(MaquinaResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                }
            }
        })

        .controller("MaquinaListController", ["$scope", "$odata", "maquinas", "MaquinaResource", "utils", "LocalStorageService", "$stateParams", "$state", "NotifyService", "ModalService", function ($scope, $odata, maquinas, MaquinaResource, utils, LocalStorageService, $stateParams, $state, NotifyService,
            ModalService) {
            $scope.naoExisteMaquina = maquinas.length > 0 ? false : true;
            $scope.maquinas = maquinas;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroMaquina") : {};

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.maquinas = list;
                $scope.maquinas.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.maquinas.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(MaquinaResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroMaquina', $scope.search);
                $scope.searching = true;
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var deleteRecord = function (data) {
                return MaquinaResource.delete({ MaquinaId: data.MaquinaId }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.maquinas.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            updateList(maquinas);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroMaquina');
                $scope.search = {
                    pageSize: 10
                };
            };

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, {
                        storage: true
                    });
                } else {
                    $state.go('main.maquinas.list', {
                        storage: true
                    });
                }
            };
        }]);
    })
();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("MaquinaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Maquina/:MaquinaId", {
                "MaquinaId": "@MaquinaId"
            },
                {
                    getConfiguracao: {
                        url: "Maquina/Configuracao",
                        method: "GET",
                        isArray: true
                    },
                    getConfiguracaoItens: {
                        url: "Maquina/CampoItens",
                        method: "GET",
                        isArray: true
                    },
                    getDialogos: {
                        url: "Maquina/ListarPathDialogos",
                        method: "GET",
                        isArray: true
                    },
                    putConfiguracao: {
                        url: "Maquina/Configuracao",
                        method: "PUT",
                    },
                    putDialogo: {
                        url: "Maquina/AtualizarPathDialogos",
                        method: "PUT",
                    },
                    postConfiguracao: {
                        url: "Maquina/Configuracao",
                        method: "POST",
                    },
                    getPlataformas: {
                        url: "Maquina/GetPlataformas",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("MensagemSmsCampanhaResource", ["$odataresource", function ($odataresource) {
			return $odataresource("MensagemSmsCampanha/Get", null, {
				Exportar: {
					method: "GET",
					url: "MensagemSmsCampanha/Exportar"
				},
			});
		}]);
})();
(function () {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 10;

    var getOdataSearchShared = function (MensagemSmsCampanhaResource, search, orderBy, $odata, utils, $stateParams) {
        var odata = MensagemSmsCampanhaResource.odata();
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.MensagemSmsCampanha", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.MensagemSmsCampanha.list',
                    }
                })
                .state("main.MensagemSmsCampanha.list", StateResolverProvider.configState("/mensagemSmsCampanha", "MensagemSmsCampanha", "List", {
                    pageTitle: 'mensagemSmsCampanhaTranslation.tituloPesquisa',
                    pageName: 'pageTitle.pesquisar',
                }))
        }])
        .service('MensagemSmsCampanhaListData', function MensagemSmsCampanhaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    campanha: ["TabulacaoResource", "$stateParams", function (TabulacaoResource, $stateParams) {
                        return TabulacaoResource.GetCampanhas().$promise;
                    }],
                }
            }
        })
        .controller("MensagemSmsCampanhaListController", ["$scope", "$odata", "$http", "$state", "Config", "campanha", "MensagemSmsCampanhaResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", function ($scope, $odata, $http, $state, Config, campanha,
            MensagemSmsCampanhaResource, utils, LocalStorageService, $stateParams, NotifyService, ModalService) {

            $scope.lista = [];

            $scope.listCampanha = campanha;
            $scope.searching = false;

            $scope.search = $stateParams.storage ? LocalStorageService.getItem("Filtro") : {
                pageSize: 10
            };

            $scope.search.DataI = moment().subtract(90, 'days').format('DD/MM/YYYY');
            $scope.search.DataF = moment().format('DD/MM/YYYY');

            $scope.orderBy = {
                column: "DataEnvio",
                order: "desc"
            };

            var updateList = function (list) {                
                $scope.lista = list;
                $scope.lista.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.lista.pageSize = list.$pageSize || 10;
                $scope.searching = false;
                ModalService.hideLoading();
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(MensagemSmsCampanhaResource, $scope.search, $scope.orderBy, $odata, utils, $stateParams);
            };

            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {

                    defaultPageIndex = newPage;
                    $scope.searching = true;

                    return getOdataSearch()
                        .page($scope.lista.pageSize, newPage)
                        .query({
                            campanha: $scope.search.CampanhaId || 0,
                            nb: $scope.search.NB || '',
                            dataInicio: moment(dataI).format(),
                            dataFinal: moment(dataF).format()
                        }).then(updateList).catch(NotifyService.showError);
                }
            };

            $scope.executeSearch = function () {

                if (!validarForm()) return;

                ModalService.showLoading();

                LocalStorageService.setItem('Filtro', $scope.search);
                $scope.searching = true;
                defaultPageIndex = 1;
                getOdataSearch()
                    .page($scope.search.pageSize, 1)
                    .query({
                        campanha: $scope.search.CampanhaId || 0,
                        nb: $scope.search.NB || '',
                        dataInicio: moment(dataI).format(),
                        dataFinal: moment(dataF).format()
                    }).then(updateList)
                    .catch((e) => {
                        NotifyService.showError
                        ModalService.hideLoading();
                    });
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('Filtro');
                $scope.search = {
                    pageSize: 10
                };
                $scope.lista = [];
            };

            $scope.exportar = function () {
                if (!validarForm()) return;

                ModalService.showLoading();

                MensagemSmsCampanhaResource.Exportar({
                    campanha: $scope.search.CampanhaId || 0,
                    nb: $scope.search.NB || '',
                    dataInicio: moment(dataI).format(),
                    dataFinal: moment(dataF).format()
                })
                    .$promise.then((data) => {

                        const blob = new Blob([data.file], { type: 'application/csv' });
                        const blobUrl = URL.createObjectURL(blob);

                        var downloadLink = angular.element('<a></a>');
                        downloadLink.attr('href', blobUrl);
                        downloadLink.attr('download', 'Mensagens por Campanha.csv');
                        downloadLink[0].click();

                        //window.location = blobUrl;
                        ModalService.hideLoading();

                    })
                    .catch((e) => {
                        NotifyService.showError
                        ModalService.hideLoading();
                    });
            }

            var dataI;
            var dataF;

            function validarForm() {

                if (typeof $scope.search.DataF == 'string')
                    dataF = moment($scope.search.DataF, 'DD/MM/YYYY');
                else
                    dataF = $scope.search.DataF;

                if (typeof $scope.search.DataI == 'string')
                    dataI = moment($scope.search.DataI, 'DD/MM/YYYY');
                else
                    dataI = $scope.search.DataI;

                if (!dataI) {
                    NotifyService.showError(null, 'mensagemSmsCampanhaTranslation.validarDataInicioVazia');
                    return false;
                }

                if (!dataF) {
                    NotifyService.showError(null, 'mensagemSmsCampanhaTranslation.validarDataFinalVazia');
                    return false;
                }

                if (dataI > dataF) {
                    NotifyService.showError(null, 'mensagemSmsCampanhaTranslation.validarData');
                    return false;
                }

                var diff = moment(dataF).diff(moment(dataI), 'days');
                if (diff > 90) {
                    NotifyService.showError(null, 'mensagemSmsCampanhaTranslation.DiffDate');
                    return false;
                }

                return true;
            }

        }]);
})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.miniBigtalk", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.miniBigtalk.list',
						pageTitle: 'telaBigTalk.tituloMiniBigTalk',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.miniBigtalk.list", StateResolverProvider.configState("/miniBigtalk", "MiniBigTalk", "List", {
					pageTitle: 'telaBigTalk.tituloMiniBigTalk',
					pageName: 'pageTitle.pesquisar',
					css: true
				}));
		}])

		.service("MiniBigTalkListData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_masked_inputs'
                        ]);
					}],
					campanhas: ["CampanhaResource", function (CampanhaResource) {
						let odata = CampanhaResource.odata().orderBy('Descricao', 'asc');
						return odata.query();
					}]
				}
			}
		})

		.controller("MiniBigTalkListController", ["$scope", "campanhas", "MiniBigTalkResource", "NotifyService", "ModalService", "$translate", function ($scope, campanhas, MiniBigTalkResource, NotifyService, ModalService, $translate) {
			campanhas.forEach(campanha => {
				campanha.Nome = `${campanha.CampanhaId} - ${campanha.Nome}`
			});

			// Listas
			$scope.campanhas = campanhas;
						
			// Objetos
			$scope.resumoScore = {};
			$scope.search = {};
			$scope.forms = {};
			$scope.envioTeste = {};

			// Booleanos
			$scope.searching = false;
			$scope.atualizandoResumo = false;

			// Numerais
			$scope.retornoPesquisaCount = -1;
			
			$scope.executeSearch = function () {
				$scope.searching = true;

				getOdataSearch($scope.search).finally(() => {
                    $scope.searching = false;
                }).catch(NotifyService.showError)
			};

			$scope.limparFiltro = function () {
				$scope.search = {};
				$scope.executeSearch();
			};

			$scope.atualizarResumo = function () {
				$scope.atualizandoResumo = true;
				MiniBigTalkResource.getResumo().$promise.then((result) => {
					$scope.resumoScore = result;
				}).catch(NotifyService.showError).finally(() => { $scope.atualizandoResumo = false; })
			}

			$scope.abrirModalEnvioTeste = function () {
				ModalService.openModal('modal_envio_teste', null, () => {
					$scope.envioTeste = { CampanhaId: 316 };
					$scope.forms.formEnvioTeste.$setUntouched();
					$scope.forms.formEnvioTeste.$setPristine();
				});
			}

			$scope.enviarTeste = function (form) {
				if (form.$valid) {
					MiniBigTalkResource.envioTeste({
						CampanhaId: $scope.envioTeste.CampanhaId,
						CodigoCliente: $scope.envioTeste.CodigoCliente,
						DDD: $scope.envioTeste.DDD,
						Numero: $scope.envioTeste.Numero,
						Nome: $scope.envioTeste.NomeCliente,
						Detalhe: $scope.envioTeste.Detalhe,
						EnvioTeste: true
					}).$promise.then(() => {
						ModalService.alert('notificacoes.testeEnviadoComSucesso');
						ModalService.closeModal('modal_envio_teste');
					});
				}
			};

			$scope.verDescricaoPeriodos = function (periodo) {
				let descricao = '';
				switch (periodo) {
					case $translate.instant('telaBigTalk.manha'):
						descricao = $translate.instant('telaBigTalk.descricaoManha');
						break;
					case $translate.instant('telaBigTalk.tarde'):
						descricao = $translate.instant('telaBigTalk.descricaoTarde');
						break;
					case $translate.instant('telaBigTalk.noite'):
						descricao = $translate.instant('telaBigTalk.descricaoNoite');
						break;
				}

				let msg = `<h3>${$translate.instant('telaBigTalk.descricaoDoPeriodo')}</h3>${descricao}`

				ModalService.alert(msg);
			}

			var getOdataSearch = function (search) {
				$scope.retornoPesquisaCount = -1;

				if (search.Telefone) {
					return MiniBigTalkResource.consultarTelefone({ Telefone: search.Telefone}).$promise.then((result) => {
						if (result.DataUltimaDiscagem) {
							let periodo = result.DataUltimaDiscagem.substring(11) > '12:00:00' ? (result.DataUltimaDiscagem.substring(11) > '18:00:00' ? 'telaBigTalk.noite' : 'telaBigTalk.tarde') : 'telaBigTalk.manha';
							result.MelhorPeriodoDiscagem = $translate.instant(periodo);
						}
						$scope.scoreList = [];
						$scope.retornoPesquisaCount = result.Telefone ? 1 : 0;

						if (result.Telefone) {
							$scope.scoreList.push(result);
						}
					});
				} else {
					return MiniBigTalkResource.get().$promise.then((result) => {
						result.forEach(element => {
							if (element.DataUltimaDiscagem) {
								let periodo = element.DataUltimaDiscagem.substring(11) > '12:00:00' ? (element.DataUltimaDiscagem.substring(11) > '18:00:00' ? 'telaBigTalk.noite' : 'telaBigTalk.tarde') : 'telaBigTalk.manha';
								element.MelhorPeriodoDiscagem = $translate.instant(periodo);
							}
						})
						$scope.scoreList = result;
						MiniBigTalkResource.getCount().$promise.then((result) => {
							$scope.retornoPesquisaCount = result.Quantidade;
						});
					});
				}
			};

			$scope.executeSearch();
			$scope.atualizarResumo();

		}]);
		
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
        .factory("MiniBigTalkResource", ["$odataresource", function ($odataresource) {
            return $odataresource("BigTalk", { },
                {
                    get: {
                        url: "BigTalk",
                        method: "GET",
                        isArray: true
                    },
                    consultarTelefone: {
                        url: "BigTalk/ConsultarTelefone",
                        method: "GET",
                        isArray: false
                    },
                    getCount: {
                        url: "BigTalk/Count",
                        method: "GET",
                        isArray: false
                    },
                    getResumo: {
                        url: "BigTalk/GetResumo",
                        method: "GET",
                        isArray: false
                    },
                    envioTeste: {
                        url: "BigTalk/EnvioTeste",
                        method: "POST"
                    }
                });
        }]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.controller("AlarmeController", ["$scope", "$timeout", "NotifyService", "MonitoriaAlarmeResource", "RamalStatusResourceDetalhe", "$state", "$translate", "ModalService", function ($scope, $timeout, NotifyService, MonitoriaAlarmeResource, RamalStatusResourceDetalhe,
			$state, $translate, ModalService) {
			/* Propriedades */
			$scope.grupoSelecionadoId = 0;
			$scope.grupoSelecionado = {};
			$scope.grupos = [];
			$scope.statusDetalhes = [];
			$scope.alarmes = [];
			$scope.forms = {};
			$scope.carregando = false;
			$scope.estilos = [
				{ valor: 'primary', descricao: $translate.instant('telaMonitor.azul') },
				{ valor: 'danger', descricao: $translate.instant('telaMonitor.vermelho') },
				{ valor: 'warning', descricao: $translate.instant('telaMonitor.laranja') }
			];

			/* Event Listeners */
			$scope.$on("onLoadGrupos", function (event, grupos) {
				$scope.grupos = grupos;
			})

			/* Métodos */
			var convertKendoTimePickerToSeconds = function (value) {
				let seconds = 0;

				if (value) {
					const timeArray = value.toString().split(':');
					seconds = (+timeArray[0]) * 60 * 60 + (+timeArray[1]) * 60 + (+timeArray[2]);
				}

				return seconds;
			}

			var convertSecondsToKendoTimePicker = function (seconds) {
				if (!seconds) seconds = 0;
				var date = new Date(null);
				date.setSeconds(seconds);
				return date.toISOString().substr(11, 8);
			}

			var mensagemSucesso = function () {
				NotifyService.showRegistroSalvo();
				ModalService.closeModal('modal_alarme');
			};

			$scope.validateInput = function (e, alarme) {
				$scope.forms.formAlarme.$setDirty();
				alarme.dirty = true;
			};

			$scope.onChangeAlarme = function (alarme) {
				if (alarme.RamalStatusDetalheId) {
					alarme.dirty = true;
				} else {
					var obj = angular.element(alarme.sender.element).scope().alarme;
					obj.dirty = true;
				}
				$scope.forms.formAlarme.$setDirty();
			}

			$scope.gatilhoOptions = {
				decimals: 0,
				format: '#'
			};

			$scope.criarIntervalo = function () {
				$state.go("main.ramalstatus.new", {
					page: $state.current.name
				});
			};

			$scope.onChangeGrupoSelecionado = function (grupoId) {
				$scope.AuxAuditor = 0;
				const grupo = $scope.grupos.find(g => g.GrupoId === grupoId)
				if (grupo != $scope.grupoSelecionado) {
					$scope.carregando = true;
					$scope.grupoSelecionadoId = grupoId;
					$scope.grupoSelecionado = grupo;

					RamalStatusResourceDetalhe.getStatusDetalhePorGrupo({
						grupoId: parseInt($scope.grupoSelecionadoId)
					}).$promise.then(function (resultStatusDetalhe) {
						$scope.statusDetalhes = resultStatusDetalhe;

						var odata = MonitoriaAlarmeResource.odata();
						odata.filter('GrupoId', $scope.grupoSelecionadoId);

						odata.query().then(function (resultAlarme) {
							$scope.alarmes = resultAlarme;
							$scope.estiloOptions = [];

							var statusDetalhesNaoCriados = _.filter($scope.statusDetalhes, function (ev) {
								return !(_.some($scope.alarmes, function (al) {
									return ev.RamalStatusDetalheId == al.RamalStatusDetalheId;
								}));
							});
							statusDetalhesNaoCriados.forEach(function (el) {
								$scope.alarmes.push({
									RamalStatusDetalheId: el.RamalStatusDetalheId,
									Estilo: 'primary',
									GrupoId: $scope.grupoSelecionadoId,
									Grupo: $scope.grupoSelecionado,
									RamalStatusDetalhe: el
								});
							});
							$scope.alarmes.forEach(function (el) {
								el.TimeTempoGatilho = convertSecondsToKendoTimePicker(el.TempoGatilho)

								$scope.$watch(function () {
									return el.IntervaloMaximo;
								},
									function (newVal, oldVal) {
										if (newVal != oldVal) {
											$scope.validateInput(null, el);
										}
									}
								);

								$scope.$watch(function () {
									return el.IntervaloMinimo;
								},
									function (newVal, oldVal) {
										if (newVal != oldVal) {
											$scope.validateInput(null, el);
										}
									}
								);
							});
							$scope.carregando = false;
						});
					});
				}
			};

			$scope.onCloseModal = function (element) {
				var model = UIkit.modal("#" + element)
				model.hide();
			}

			$scope.onHideModal = function () {
				$scope.AuxAuditor = 0;
			}

			$scope.AuxAuditor = 0;
			$scope.onClickShowAuditor = function (item) {
				if (item.MonitoriaAlarmeId != undefined)
					$scope.AuxAuditor = item.MonitoriaAlarmeId;
			}

			$scope.salvar = function (form) {
				$scope.submitted = true;
				var alarmesPendentesSalvar = [];
				$scope.alarmes.forEach(function (alarme) {
					if (alarme.dirty) {
						alarme.TempoGatilho = convertKendoTimePickerToSeconds(alarme.TimeTempoGatilho);
						alarme.errorGatilho = (!alarme.TempoGatilho || alarme.TempoGatilho < 10) && alarme.Ativo == true;
						alarmesPendentesSalvar.push(alarme);
						if (alarme.IntervaloMinimo && alarme.IntervaloMaximo) {
							if (typeof alarme.IntervaloMinimo != 'string') {
								alarme.IntervaloMinimo = new moment(alarme.IntervaloMinimo).format("HH:mm");
							}
							if (typeof alarme.IntervaloMaximo != 'string') {
								alarme.IntervaloMaximo = new moment(alarme.IntervaloMaximo).format("HH:mm");
							}
							alarme.errorIntervalo = alarme.IntervaloMaximo <= alarme.IntervaloMinimo;
						} else {
							alarme.errorIntervalo = (alarme.IntervaloMinimo || alarme.IntervaloMaximo) && alarme.Ativo == true;
						}
					}
				});
				var possuiErroGatilho = _.filter(alarmesPendentesSalvar, function (el) {
					return el.errorGatilho;
				}).length > 0;
				var possuiErroIntervalo = _.filter(alarmesPendentesSalvar, function (el) {
					return el.errorIntervalo;
				}).length > 0;

				if (!form.$valid || possuiErroGatilho || possuiErroIntervalo) {
					if (possuiErroGatilho) {
						NotifyService.showError(null, 'telaMonitor.tempoMinimoDeIntervaloValidacao')
					}
					if (possuiErroIntervalo) {
						NotifyService.showError(null, 'telaMonitor.definaUmIntervaloValido')
						$scope.submitted = false;
						return;
					}
				}

				if (alarmesPendentesSalvar.length > 0) {
					MonitoriaAlarmeResource.AlarmeGrupo(alarmesPendentesSalvar).$promise
						.then(mensagemSucesso).catch(NotifyService.showError)
						.finally(function () {
							$scope.submitted = false;
						});
					$scope.forms.formAlarme.$setPristine();
				}
			};
		}]
		);
})();
(function () {
	"use strict";
	angular.module('epbxManagerApp')

		.factory("MonitoriaAlarmeResource", ["$odataresource", function ($odataresource) {
			return $odataresource(
				"MonitoriaAlarme/:MonitoriaAlarmeId", {
					"MonitoriaAlarmeId": "@MonitoriaAlarmeId"
				}, {
					AlarmeGrupo: {
						url: "MonitoriaAlarme/AlarmeGrupo",
						method: "POST"
					},
					GetFilaAlarme: {
						url: "MonitoriaAlarme/FilaAlarme",
						method: "GET"
					},
					SetFilaAlarme: {
						url: "MonitoriaAlarme/FilaAlarme",
						method: "PUT"
					}
				});
		}])

		.factory("AlarmeHistoricoResource", ["$odataresource", function ($odataresource) {
			return $odataresource(
				"MonitoriaAlarme/Historico/:ramalId", {
					"ramalId": "@ramalId"
				});
		}])

		.factory("AlarmeIntervaloResource", ["$odataresource", function ($odataresource) {
			return $odataresource(
				"AlarmeIntervalo/:AlarmeIntervaloId", {
					"AlarmeIntervaloId": "@AlarmeIntervaloId"
				});
		}])
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.controller("ConferenciaController", ["$scope", "$window", "ConferenciaService", "ModalService", "$translate", function ($scope, $window, ConferenciaService, ModalService, $translate) {
			$scope.ConferenciaService = ConferenciaService;
			$scope.titulo = $translate.instant('telaMonitor.criarConferencia');
			$scope.numero = '';

			$scope.iniciar = function () {
				$scope.ConferenciaService.isConferenciaEmAndamento = true;
			};

			$scope.encerrar = function () {
				ModalService.confirmMessage('telaMonitor.confirmEncerrarConferencia', null, function () {
					$scope.ConferenciaService.terminar();
					ModalService.closeModal('modal_conferencia')
				});
			};

			$scope.sair = function () {
				ModalService.confirmMessage('telaMonitor.confirmSairDaConferencia', null, function () {
					$scope.ConferenciaService.sair();
					ModalService.closeModal('modal_conferencia')
				});

			};

		}]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .controller("ControleIntervaloController", ["$rootScope", "$scope", "GrupoResource", "$odataresource", "$q", "$timeout", "$odata", "NotifyService", "$translate", "ModalService", "RamalDetalheService", "RamalStatusResourceDetalhe", "AuthService", "RamalIntervaloHistoricoResource", function ($rootScope, $scope, GrupoResource, $odataresource, $q, $timeout, $odata,
            NotifyService, $translate, ModalService, RamalDetalheService, RamalStatusResourceDetalhe, AuthService, RamalIntervaloHistoricoResource) {

            $scope.dadosEsquerda = {};
            $scope.usuariosEsquerda = [];

            $scope.limparListaEsquerda = function () {
                $scope.usuariosEsquerda = [];
                $scope.usuariosEsquerdaFiltrados = [];
            }

            $scope.limparListaDireita = function () {
                $scope.usuariosDireita = [];
                $scope.usuariosDireitaFiltrados = [];
            }

            $scope.limparHistorico = function () {
                $scope.historicoRamal = [];
                $scope.historicoRamal.recordCount = null;
                $scope.submitted = false;
                $scope.currentPage = null;
                $scope.search = {
                    pageSize: 10
                }
                $scope.orderBy = {
                    column: "DataCadastro",
                    order: "desc"
                };
            }

            $scope.limparTudo = function () {
                $scope.dadosCopia = {
                    ModoCopia: $translate.instant('acoes.copiar'),
                    Logado: false,
                    NaoPadrao: false
                };
                $scope.dadosDireita = {};
                $scope.dadosEsquerda = {};
                $scope.limparListaEsquerda();
                $scope.limparListaDireita();
                $scope.limparHistorico();
            }

            $scope.$on('onLimparControleIntervalo', function () {
                $scope.limparTudo();
            });

            GrupoResource.getGrupoSimples().$promise
                .then(function (grupos) {
                    $scope.grupos = grupos;
                    $scope.grupos = _.sortBy($scope.grupos, function (el) {
                        return el.Descricao;
                    });
                });


            RamalStatusResourceDetalhe.getRamalStatusDetalheByCarteira({
                UsuarioId: AuthService.getUsuarioLogado().UsuarioId,
                GrupoId: $scope.dadosEsquerda.GrupoId || 0,
                CarteiraId: 0,
                UsuarioLogado: AuthService.getUsuarioLogado().UsuarioId
            }).$promise
                .then(result => {
                    $scope.RamalStatusDetalheDireita = result;
                    $scope.RamalStatusDetalheEsquerda = result;
                })

            $scope.onRamalStatusDetalheEsquerda = function () {
                $scope.usuariosDireita = []
                GrupoResource.getRamaisAssociados({
                    GrupoId: $scope.dadosEsquerda.GrupoId,
                    CarteiraId: 0
                }).$promise
                    .then(function (usuarios) {

                        $scope.usuariosEsquerda = usuarios.filter(x => x.RamalStatusDetalheId != 0 && x.RamalStatusDetalheId == $scope.dadosEsquerda.RamalStatusDetalheId);

                    })
                    .catch(function () {
                        $scope.usuariosEsquerda = [];
                    });
            }

            $scope.onChecado = function () {
                return ($scope.usuariosEsquerda.filter(x => x.checked).length > 0 && $scope.dadosDireita.RamalStatusDetalheId) && !($scope.dadosEsquerda.RamalStatusDetalheId == $scope.dadosDireita.RamalStatusDetalheId);
            }

            $scope.moverRamais = function () {
                let listaChecado = _.filter($scope.usuariosEsquerda, function (r) {
                    return r.checked == true;
                });

                ModalService.confirmMessage('telaMonitor.desejaMover', {
                    Quantidade: listaChecado.length
                }, () => {
                    ModalService.showLoading();

                    for (let index = 0; index < listaChecado.length; index++) {
                        const element = listaChecado[index];

                        var evento = $scope
                            .RamalStatusDetalheDireita
                            .find(x => x.RamalStatusDetalheId == $scope.dadosDireita.RamalStatusDetalheId);

                        RamalDetalheService.adicionarIntervalo($scope.dadosDireita.RamalStatusDetalheId, element.Numero);

                        element.EventoDescricao = evento.Descricao;
                        element.EventoCor = evento.Cor;
                        $scope.usuariosDireita.push(element);

                        RamalIntervaloHistoricoResource.setIntervaloHistorico({
                            GrupoId: $scope.dadosEsquerda.GrupoId,
                            RamalId: element.RamalId,
                            RamalStatusDetalheOrigemId: $scope.dadosEsquerda.RamalStatusDetalheId,
                            RamalStatusDetalheDestinoId: $scope.dadosDireita.RamalStatusDetalheId,
                            UsuarioId: AuthService.getUsuarioLogado().UsuarioId
                        }).$promise
                            .then(data => {

                            })

                    }

                    $scope.dadosEsquerda.RamalStatusDetalheId = undefined;
                    $scope.usuariosEsquerda = []

                    ModalService.hideLoading();

                });
            }

            $scope.pesquisarHistorico = function () {
                $scope.executeSearch();
            }

            var getOdataSearchShared = function (search, orderBy, $odata, $odataresource) {
                var url = "RamalIntervaloHistorico/IntervaloHistorico";
                var resource = $odataresource(url);
                var odata = resource.odata();
                odata.orderBy(orderBy.column, orderBy.order);
                var predicateDataInicio = null;
                var predicateDataFim = null;

                if (search.DataInicio) {
                    predicateDataInicio = $odata.Predicate("DataCadastro", ">", search.DataInicio);
                }
                if (search.DataFim) {
                    predicateDataFim = $odata.Predicate("DataCadastro", "<", search.DataFim);
                }

                var predicateData = null;
                if (predicateDataInicio && predicateDataFim) {
                    predicateData = $odata.Predicate.and([predicateDataInicio, predicateDataFim])
                } else {
                    if (predicateDataInicio) {
                        predicateData = predicateDataInicio;
                    }
                    if (predicateDataFim) {
                        predicateData = predicateDataFim;
                    }
                }

                odata.filter(predicateData)

                return odata;
            }

            var getOdataSearch = function getOdataSearch() {
                return getOdataSearchShared($scope.search, $scope.orderBy, $odata, $odataresource);
            };

            var updateList = function (list) {
                $scope.historicoRamal = list;
                $scope.historicoRamal.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.search.pageSize = list.$pageSize || 10;
                $scope.submitted = false;
            }

            $scope.executeSearch = function executeSearch() {
                $scope.submitted = true;
                getOdataSearch().page($scope.search.pageSize, 1).query().then(updateList).catch(NotifyService.showError);
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.search.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
            }

            $scope.onDataKeyPress = function (event) {
                var keyCode = event.keyCode;
                if (!(keyCode >= 48 && keyCode <= 57)) {
                    event.preventDefault();
                }
            }

            $scope.limparTudo();
        }]);
})();
angular.module('epbxManagerApp')

    .directive('emIndicadorRamal', ["IndicadorService", function (IndicadorService) {
        return {
            restrict: 'EA',
            templateUrl: 'app/pages/monitor/emIndicadorRamal.html',
            scope: {
                grupoId: '=',
                ramalId: '=',
                ramalNumero: '=',
                ramalNome: '='
            },
            link: function (scope) {

                scope.grupos = {};
                scope.maxRatings = [];
                scope.ramalSelecionado = {};
                let verificarGrupo = function (grupos) {
                    for (let prop in grupos) {
                        if (grupos.hasOwnProperty(prop)) {
                            return true;
                        }
                    }
                    return false;
                }
                scope.grupos = IndicadorService.grupos;
                if (scope.grupos != null && verificarGrupo(scope.grupos)) {
                    const grupoSelecionado = scope.grupos[scope.grupoId];
                    if (grupoSelecionado) {
                        scope.ramalSelecionado = _.findWhere(grupoSelecionado.Ramais, { RamalId: scope.ramalId });
                    }
                }

                scope.$on("onGrupoNaoSelecionado", function () {
                    scope.ramalSelecionado = {};
                    scope.grupos = {};
                    scope.maxRatings = [];
                });

                scope.$on("onGrupoSelecionado", function (event, grupo) {
                    scope.grupos = IndicadorService.grupos;
                    let ramaId = scope.ramalId;
                    let grupoId = grupo.GrupoId;
                    if (grupoId) {
                        let grupoSelecionado = scope.grupos[grupoId];
                        if (grupoSelecionado) {
                            let rate = grupoSelecionado.Rate || 0;
                            if (ramaId) {
                                scope.ramalSelecionado = _.findWhere(grupoSelecionado.Ramais, { RamalId: ramaId });
                                if (scope.ramalSelecionado) {
                                    rate = scope.ramalSelecionado.Rate;
                                } else {
                                    rate = 0;
                                }
                            }

                            scope.maxRatings = [];
                            for (let i = 1; i <= rate; i++) {
                                if (i < rate) {
                                    scope.maxRatings.push({ Number: i, Type: 1 });
                                }
                                if (i == rate) {
                                    scope.maxRatings.push({ Number: i, Type: 1 });
                                    var decimalArray = rate.toString().split('.')
                                    var decimal = decimalArray[1];
                                    if (decimal > 10 && decimal < 60) {
                                        scope.maxRatings.push({ Number: i, Type: 2 });
                                    }
                                    if (decimal > 60) {
                                        scope.maxRatings.push({ Number: i, Type: 1 });
                                    }
                                }
                            }
                        }
                    }

                    scope.getClassIndicadorPercentual = function (percentual) {
                        if (percentual <= 20) {
                            return "uk-progress-danger";
                        }
                        if (percentual > 20 && percentual <= 60) {
                            return "uk-progress-warning";
                        }
                        if (percentual > 60) {
                            return "uk-progress-success";
                        }
                    };
                });
            }
        }
    }]);



angular.module('epbxManagerApp')

    .directive('emRating', function () {
        return {
            restrict: 'EA',
            template: ' <span ng-repeat="r in maxRatings">' +
                '<i ng-if="r.Type==1" class="material-icons">&#xE838;</i>' +
                '<i ng-if="r.Type==2" class="material-icons">&#xE839;</i>' +
                '</span>',
            scope: {
                emRating: '=',
            },
            link: function (scope) {
                scope.maxRatings = [];
                if (scope.emRating) {
                    for (var i = 1; i <= scope.emRating; i++) {
                        var rate = scope.emRating;
                        if (i < rate) {
                            scope.maxRatings.push({ Number: i, Type: 1 });
                        }
                        if (i == rate) {
                            scope.maxRatings.push({ Number: i, Type: 1 });
                            var decimalArray = rate.toString().split('.')
                            var decimal = decimalArray[1];

                            if (decimal > 10 && decimal < 60) {
                                scope.maxRatings.push({ Number: i, Type: 2 });
                            }
                            
                            if (decimal > 60) {
                                scope.maxRatings.push({ Number: i, Type: 1 });
                            }
                        }
                    }
                }
            }
        }
    });



angular.module('epbxManagerApp')

    .directive('emThermometer', ["$timeout", "$window", "$q", "$filter", "IndicadorService", function ($timeout, $window, $q, $filter, IndicadorService) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/pages/monitor/emThermometer.html',
            scope: {
                ramalId: '='
            },
            link: function (scope, attrs) {
                scope.grupoSelecionadoId = 0;
                function hideByElement(id) {
                    const element = '#' + id;
                    let el = $(element).find("[class^='thermometer']");
                    $(el).css("display", "none");
                }

                function showByElement(id, score) {
                    const elementoNome = '#' + id;
                    let el = $(elementoNome).find("[class^='thermometer']");
                    if (score <= 34) {
                        el.removeClass().addClass('thermometer--very-low');
                    }
                    if (score > 34 && score <= 67) {
                        el.removeClass().addClass('thermometer--low');
                    }
                    if (score > 67) {
                        el.removeClass().addClass('thermometer--very-high');
                    }
                    $(el).css("display", "block");
                }

                function showPeriodo(dataInicio, dataTermino) {
                    let dtInicio = $filter('date')(dataInicio, 'dd/MM/yyyy HH:mm');
                    let dtTermino = $filter('date')(dataTermino, 'dd/MM/yyyy HH:mm');
                    const msg = 'Ocorrências com início em: ' + dtInicio + ' Até: ' + dtTermino;
                    $('#periodo-thermometer').html(msg);
                }

                function hidePeriodo() {
                    $('#periodo-thermometer').html('');
                }

                scope.$on("onGrupoNaoSelecionado", function () {
                    scope.grupoSelecionadoId = 0;
                });

                scope.$on("onGrupoSelecionado", function (event, grupo) {
                    scope.grupoSelecionadoId = grupo.GrupoId || 0;
                    const ramaId = scope.ramalId || 0;
                    if (scope.grupoSelecionadoId > 0) {
                        let grupoIndicador = IndicadorService.grupos[scope.grupoSelecionadoId];
                        if (grupoIndicador) {
                            var score = parseInt(grupoIndicador.Score) || 0;
                            if (ramaId > 0) {
                                let ramalIndicador = _.findWhere(grupoIndicador.Ramais, { RamalId: ramaId });
                                if (ramalIndicador) {
                                    score = parseInt(ramalIndicador.Score);
                                    hidePeriodo();
                                    if (ramalIndicador.DataInicio != undefined) {
                                        showPeriodo(ramalIndicador.DataInicio, ramalIndicador.DataTermino);
                                    }
                                }
                                else {
                                    score = 0;
                                }

                                /* Exibir elemento do ramal */
                                showByElement(attrs[0].id, score);

                            } else {
                                /* Exibir elemento do grupo */
                                showByElement(attrs[0].id, score);
                            }
                        } else {

                            /* Ocultar elemento */
                            hideByElement(attrs[0].id);
                        }
                    }
                });
            }
        }
    }]);
angular.module('epbxManagerApp')


.directive('emTimerFila', ["$timeout", function ($timeout) {
    return {
        restrict: 'EA',
        replace: false,
        template: '<span ng-bind="tempo | humanizeCustom"></span>',
        scope: {
            data: '=',
            diferenca: '=' 
        },
        link: function (scope) {
            scope.tempo = 0;
            scope.timeoutId = null;
            var getDiferenca = function (dataAtual, dataInicio) {
                var atual = moment(dataAtual);
                var inicial = moment(dataInicio).toDate();
                return atual.diff(inicial, 'seconds');
            };
            scope.onTimeout = function () {
                var dataAtual = moment(new Date()).add(scope.diferenca, 'seconds').toDate();
                scope.tempo = getDiferenca(dataAtual, scope.data);
                if (scope.tempo < 0) {
                    scope.tempo = 1;
                }
                scope.timeoutId = $timeout(scope.onTimeout, 1000, true);
            };

            scope.timeoutId = $timeout(scope.onTimeout, 0, true);
            scope.$on('$destroy', function () {
                $timeout.cancel(scope.timeoutId);
            });
        }
    }
}]);
angular.module('epbxManagerApp')


    .directive('emTimerRamal', ["$timeout", "SUPERVISAO_EVENTS", function ($timeout, SUPERVISAO_EVENTS) {
        return {
            restrict: 'EA',
            replace: false,
            template: '<span ng-bind="tempo | humanizeCustom"></span>',
            scope: {
                ramal: '=',
                tempo: '=',
                status: '=',
                data: '=',
                diferenca: '='
            },
            link: function (scope) {
                scope.timeoutId = null;
                scope.logado = scope.status != 'NaoLogado' ? true : false;
                let getDiferenca = function (dataAtual, dataInicio) {
                    let atual = moment(dataAtual);
                    let inicial = moment(dataInicio).toDate();
                    return atual.diff(inicial, 'seconds');
                };
                scope.onTimeout = function () {
                    let dataAtual = moment(new Date()).add(scope.diferenca, 'seconds').toDate();
                    scope.tempo = getDiferenca(dataAtual, scope.data);
                    if (scope.tempo < 0) {
                        scope.tempo = 1;
                    }
                    scope.timeoutId = $timeout(scope.onTimeout, 1000, true);
                };

                if (scope.logado) {
                    scope.timeoutId = $timeout(scope.onTimeout, 0, true);
                }

                scope.$on('$destroy', function () {
                    $timeout.cancel(scope.timeoutId);
                });

                scope.$on(SUPERVISAO_EVENTS.onSupervisaoDesconectado, function () {
                    scope.conectado = false;
                    $timeout.cancel(scope.timeoutId);
                });

                scope.$on(SUPERVISAO_EVENTS.onSupervisaoConectado, function () {
                    setTimeout(function () {
                        scope.conectado = true;
                        $timeout.cancel(scope.timeoutId);
                        scope.timeoutId = $timeout(scope.onTimeout, 0, true);
                    }, 100);
                });

            }
        }
    }]);
angular.module('epbxManagerApp')

    .directive('emTimerSilencio', ["$timeout", function ($timeout) {
        return {
            restrict: 'EA',
            replace: false,
            template: '<span ng-bind="tempo | humanizeCustom"></span>',
            scope: {
                data: '=',
                diferenca: '='
            },
            link: function (scope) {
                scope.tempo = 0;
                scope.timeoutId = null;
                let getDiferenca = function (dataAtual, dataInicio) {
                    let atual = moment(dataAtual);
                    let inicial = moment(dataInicio).toDate();
                    return atual.diff(inicial, 'seconds');
                };
                scope.onTimeout = function () {
                    let dataAtual = moment(new Date()).add(scope.diferenca, 'seconds').toDate();
                    scope.tempo = getDiferenca(dataAtual, scope.data);
                    if (scope.tempo < 0) {
                        scope.tempo = 1;
                    }
                    scope.timeoutId = $timeout(scope.onTimeout, 1000, true);
                };

                scope.timeoutId = $timeout(scope.onTimeout, 0, true);
                scope.$on('$destroy', function () {
                    $timeout.cancel(scope.timeoutId);
                });
            }
        }
    }]);
(function () {

	angular.module("epbxManagerApp")

		.controller("GerenciaFilaController", ["$scope", "GerenciaFilaResource", "NotifyService", "ModalService", function ($scope, GerenciaFilaResource, NotifyService, ModalService) {
			/* Propriedades */
			$scope.grupoSelecionadoId = 0;
			$scope.grupoSelecionado = {};
			$scope.grupos = [];
			$scope.carregando = false;
			$scope.primeiroClick = true;
			$scope.GrupoFila = {};

			/* Event Listeners */
			$scope.$on("onLoadGrupos", function (event, grupos) {
				$scope.grupos = grupos;
			})
			
			$scope.$on("onLoadFilaAlarme", function (event, filaAlarme) {				
				$scope.configGeral = filaAlarme
			})

			/* Métodos */
			let mensagemSucesso = function () {
				NotifyService.showSuccess();
				ModalService.confirmMessage('telaMonitor.necessarioAtualizarPagina', null, () => window.location.reload());
			};

			$scope.getList = function () {
				GerenciaFilaResource.get({ grupoId: $scope.grupoSelecionado.GrupoId }).$promise.then(function (result) {
					$scope.GrupoFila = result;
					angular.element(document.querySelectorAll("#MaxFila")[0]).focus();
				});
			};

			$scope.onChangeGrupoSelecionado = function (grupoId) {
				const grupo = $scope.grupos.find(g => g.GrupoId === grupoId);
				if (grupo != $scope.grupoSelecionado) {
					$scope.grupoSelecionado = grupo;
					$scope.getList();
				}
			};

			$scope.salvarGrupo = function (grupoFila) {
				if (!grupoFila) {
					return NotifyService.showInvalid();
				}
				grupoFila.GrupoId = $scope.grupoSelecionado.GrupoId;
				GerenciaFilaResource.save(grupoFila).$promise.then(mensagemSucesso).catch(NotifyService.showError);
			};

			$scope.checarVazio = function (valor) {
				return valor !== null && valor !== undefined && valor !== '';
			}

			$scope.salvarGeral = function () {
				if (!$scope.configGeral) {
					return NotifyService.showInvalid();
				}
				GerenciaFilaResource.save($scope.configGeral).$promise.then(mensagemSucesso).catch(NotifyService.showError);
			};
		}]);
})();



(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("GerenciaFilaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("GrupoFila/:grupoId", {
                "grupoId": "@grupoId"
            });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .controller("GerenciaGrupoController", ["$rootScope", "$scope", "GrupoResource", "$odataresource", "$q", "$timeout", "$odata", "NotifyService", "$translate", "ModalService", function ($rootScope, $scope, GrupoResource, $odataresource, $q, $timeout, $odata,
            NotifyService, $translate, ModalService) {
            $scope.$on('onLimparGerenciaGrupo', function () {
                $scope.limparTudo();
            });

            $scope.limparListaEsquerda = function () {
                $scope.usuariosEsquerda = [];
                $scope.usuariosEsquerdaFiltrados = [];
                $scope.dadosEsquerda.quantidadeVisivel = 15;
                $scope.dadosEsquerda.quantidadeAtual = 0;
            }

            $scope.limparListaDireita = function () {
                $scope.usuariosDireita = [];
                $scope.usuariosDireitaFiltrados = [];
                $scope.dadosDireita.quantidadeVisivel = 15;
                $scope.dadosDireita.quantidadeAtual = 0;
            }

            $scope.limparTudo = function () {
                $scope.dadosCopia = {
                    ModoCopia: $translate.instant('acoes.copiar'),
                    Logado: false,
                    NaoPadrao: false
                };
                $scope.dadosDireita = {};
                $scope.dadosEsquerda = {};
                $scope.limparListaDireita();
                $scope.limparListaEsquerda();
                $scope.limparHistorico();
            }

            GrupoResource.getGrupoSimples().$promise
                .then(function (grupos) {
                    $scope.grupos = grupos;
                    $scope.grupos = _.sortBy($scope.grupos, function (el) {
                        return el.Descricao;
                    });
                    $scope.filtrarGrupos();
                });

            $scope.filtrarGrupos = function () {
                var grupoSelecionadoEsquerda = _.find($scope.grupos, function (g) {
                    return g.GrupoId == $scope.dadosEsquerda.GrupoId;
                });
                $scope.gruposDireita = _.reject($scope.grupos, function (g) {
                    if (grupoSelecionadoEsquerda == null) return false;
                    if (grupoSelecionadoEsquerda.GrupoTipoId == 3) {
                        return g.GrupoId == $scope.dadosEsquerda.GrupoId || g.GrupoTipoId != 3;
                    } else {
                        return g.GrupoId == $scope.dadosEsquerda.GrupoId || g.GrupoTipoId == 3;
                    }
                });

                var grupoSelecionadoDireita = _.find($scope.grupos, function (g) {
                    return g.GrupoId == $scope.dadosDireita.GrupoId;
                });
                $scope.gruposEsquerda = _.reject($scope.grupos, function (g) {
                    if (grupoSelecionadoDireita == null) return false;
                    if (grupoSelecionadoDireita.GrupoTipoId == 3) {
                        return g.GrupoId == $scope.dadosDireita.GrupoId || g.GrupoTipoId != 3;
                    } else {
                        return g.GrupoId == $scope.dadosDireita.GrupoId || g.GrupoTipoId == 3;
                    }
                });

                $scope.gruposDireita.unshift({
                    GrupoId: -1,
                    Descricao: $translate.instant('campo.todos')
                });
                $scope.gruposEsquerda.unshift({
                    GrupoId: -1,
                    Descricao: $translate.instant('campo.todos')
                });
            }

            $scope.onGrupoEsquerdaAlterado = function (reloadOnce) {
                $scope.filtrarGrupos();
                GrupoResource.getRamaisAssociados({
                    GrupoId: $scope.dadosEsquerda.GrupoId,
                    CarteiraId: 0
                }).$promise
                    .then(function (usuarios) {
                        if ($scope.dadosEsquerda.GrupoId == -1) {
                            usuarios = _.uniq(usuarios, false, function (el) {
                                return el.RamalId;
                            });

                            if ($scope.dadosDireita.GrupoId != null && $scope.dadosDireita.GrupoId != -1) {
                                var grupoSelecionadoDireita = _.find($scope.grupos, function (g) {
                                    return g.GrupoId == $scope.dadosDireita.GrupoId;
                                });
                                usuarios = _.filter(usuarios, function (el) {
                                    return grupoSelecionadoDireita.GrupoTipoId == 3 ? el.RamalTipoId == 6 : el.RamalTipoId != 6;
                                })
                            }

                            $scope.dadosCopia.ModoCopia = $translate.instant('acoes.copiar');
                            usuarios.forEach(function (el) {
                                el.GrupoPadrao = false
                            });
                        }
                        if ($scope.dadosDireita.GrupoId == -1 && !reloadOnce) {
                            $scope.onGrupoDireitaAlterado(true);
                        }
                        $scope.usuariosEsquerdaCompleto = usuarios;
                    })
                    .catch(function () {
                        $scope.usuariosEsquerdaCompleto = [];
                    })
                    .finally(function () {
                        $scope.reloadEsquerda();
                        $scope.onChecadoAlterado();
                    });
            }

            $scope.onGrupoDireitaAlterado = function (reloadOnce) {
                $scope.filtrarGrupos();
                GrupoResource.getRamaisAssociados({
                    GrupoId: $scope.dadosDireita.GrupoId,
                    CarteiraId: 0
                }).$promise
                    .then(function (usuarios) {
                        if ($scope.dadosDireita.GrupoId == -1) {
                            usuarios = _.uniq(usuarios, false, function (el) {
                                return el.RamalId;
                            });

                            if ($scope.dadosEsquerda.GrupoId != null && $scope.dadosEsquerda.GrupoId != -1) {
                                var grupoSelecionadoEsquerda = _.find($scope.grupos, function (g) {
                                    return g.GrupoId == $scope.dadosEsquerda.GrupoId;
                                });
                                usuarios = _.filter(usuarios, function (el) {
                                    return grupoSelecionadoEsquerda.GrupoTipoId == 3 ? el.RamalTipoId == 6 : el.RamalTipoId != 6;
                                })
                            }

                            $scope.dadosCopia.ModoCopia = $translate.instant('acoes.copiar');
                            usuarios.forEach(function (el) {
                                el.GrupoPadrao = false
                            });
                        }
                        if ($scope.dadosEsquerda.GrupoId == -1 && !reloadOnce) {
                            $scope.onGrupoEsquerdaAlterado(true);
                        }
                        $scope.usuariosDireitaCompleto = usuarios;
                    })
                    .catch(function () {
                        $scope.usuariosDireitaCompleto = [];
                    })
                    .finally(function () {
                        $scope.reloadDireita();
                        $scope.onChecadoAlterado();
                    });
            }

            $scope.onModoCopiaAlterado = function () {
                if (!$scope.dadosCopia.ModoCopia) {
                    $scope.dadosCopia.ModoCopia = $translate.instant('acoes.copiar');
                }
            }

            $scope.reloadAmbos = function () {
                $scope.reloadEsquerda();
                $scope.reloadDireita();
                $scope.onChecadoAlterado();
            }

            $scope.reloadEsquerda = function () {
                $scope.limparListaEsquerda();
                $scope.loadMoreEsquerda();
            }

            $scope.reloadDireita = function () {
                $scope.limparListaDireita();
                $scope.loadMoreDireita();
            }

            $scope.loadMoreEsquerda = function () {
                $scope.usuariosEsquerdaFiltrados = $scope.filtrarRamal($scope.usuariosEsquerdaCompleto, $scope.dadosEsquerda.RamalPesquisa);
                $scope.usuariosEsquerda = $scope.usuariosEsquerdaFiltrados; //$scope.usuariosEsquerda.concat($scope.usuariosEsquerdaFiltrados.slice($scope.dadosEsquerda.quantidadeAtual, $scope.dadosEsquerda.quantidadeAtual + $scope.dadosEsquerda.quantidadeVisivel));
                $scope.dadosEsquerda.quantidadeAtual += $scope.dadosEsquerda.quantidadeVisivel;
            };

            $scope.loadMoreDireita = function () {
                $scope.usuariosDireitaFiltrados = $scope.filtrarRamal($scope.usuariosDireitaCompleto, $scope.dadosDireita.RamalPesquisa);
                $scope.usuariosDireita = $scope.usuariosDireitaFiltrados; //$scope.usuariosDireita.concat($scope.usuariosDireitaFiltrados.slice($scope.dadosDireita.quantidadeAtual, $scope.dadosDireita.quantidadeAtual + $scope.dadosDireita.quantidadeVisivel));
                $scope.dadosDireita.quantidadeAtual += $scope.dadosDireita.quantidadeVisivel;
            };

            $scope.filtrarRamal = function (lista, ramalPesquisa) {
                if (ramalPesquisa)
                    ramalPesquisa = ramalPesquisa.toLowerCase();

                var filtrados = _.filter(lista, function (r) {
                    var possuiRamalPesquisa = (ramalPesquisa == null || (r.Numero.toString().indexOf(ramalPesquisa) >= 0 || r.UsuarioNome.toLowerCase().indexOf(ramalPesquisa) >= 0));
                    var possuiPadrao = $scope.dadosCopia.NaoPadrao == true ? !r.GrupoPadrao : true;
                    var possuiLogado = $scope.dadosCopia.Logado == true ? (r.EventoDescricao != 'Não Logado') : true;

                    return possuiLogado && possuiRamalPesquisa && possuiPadrao;
                });
                return filtrados;
            }

            $scope.onChecadoAlterado = function (atraso) {
                var checarAlteracao = function () {
                    $scope.onRamalEsquerdaChecado();
                    $scope.onRamalDireitaChecado();
                    $scope.atualizarHistoricoRamal();
                }
                if (atraso) {
                    $timeout(function () {
                        checarAlteracao();
                    });
                    return;
                }
                checarAlteracao();
            }

            $scope.onRamalEsquerdaChecado = function () {
                var listaChecado = _.filter($scope.usuariosEsquerdaFiltrados, function (r) {
                    return r.checked == true;
                });
                _.each($scope.usuariosDireita, function (r) {
                    r.disabled = false;
                    if (_.find(listaChecado, function (r2) { return r2.RamalId == r.RamalId; }))
                        r.disabled = true;
                })
                var listaComGrupoPadrao = _.filter(listaChecado, function (r) {
                    return r.GrupoPadrao == true;
                });

                $scope.dadosEsquerda.podeRemover = listaChecado.length > 0 && $scope.dadosEsquerda.GrupoId > 0;
                $scope.dadosEsquerda.padraoChecado = listaComGrupoPadrao.length > 0;
                $scope.dadosEsquerda.podeMover = listaChecado.length > 0 && ($scope.dadosEsquerda.GrupoId == -1 || $scope.dadosEsquerda.GrupoId > 0) && $scope.dadosDireita.GrupoId > 0;
            }

            $scope.onRamalDireitaChecado = function () {
                var listaChecado = _.filter($scope.usuariosDireitaFiltrados, function (r) {
                    return r.checked == true;
                });
                _.each($scope.usuariosEsquerda, function (r) {
                    r.disabled = false;
                    if (_.find(listaChecado, function (r2) { return r2.RamalId == r.RamalId; }))
                        r.disabled = true;
                })
                var listaComGrupoPadrao = _.filter(listaChecado, function (r) {
                    return r.GrupoPadrao == true;
                });
                $scope.dadosDireita.podeRemover = listaChecado.length > 0 && $scope.dadosDireita.GrupoId > 0;
                $scope.dadosDireita.padraoChecado = listaComGrupoPadrao.length > 0;
                $scope.dadosDireita.podeMover = listaChecado.length > 0 && ($scope.dadosDireita.GrupoId == -1 || $scope.dadosDireita.GrupoId > 0) && $scope.dadosEsquerda.GrupoId > 0;
            }

            $scope.moverRamais = function (lista, grupoId, grupoOrigem) {
                let listaChecado = _.filter(lista, function (r) {
                    return r.checked == true;
                });
                let ramais = _.pluck(listaChecado, 'RamalId').join(",");

                var moverRamalPost = function () {
                    ModalService.confirmMessage('telaMonitor.desejaMoverRamais', {
                        Quantidade: listaChecado.length
                    }, () => {
                        ModalService.showLoading();
                        GrupoResource.moverRamal({
                            GrupoId: grupoId,
                            Ramais: ramais,
                            Ordens: '',
                            GrupoOrigem: $scope.dadosCopia.ModoCopia == 'Mover' ? grupoOrigem : null
                        }).$promise
                            .then(function () {
                                ModalService.hideLoading();
                                NotifyService.showSuccess('telaMonitor.ramalMovido');
                                $scope.onGrupoEsquerdaAlterado();
                                $scope.onGrupoDireitaAlterado();
                                $rootScope.$broadcast('onGrupoRamalAlterado');
                            })
                            .catch(function (ex) {
                                ModalService.hideLoading();
                                NotifyService.showError(ex);
                            });
                    });
                }

                if (ramais && grupoId > 0) {
                    if ($scope.dadosCopia.ModoCopia == 'Mover') {
                        var listaComGrupoPadrao = _.filter(listaChecado, function (r) {
                            return r.GrupoPadrao == true;
                        });
                        if (listaComGrupoPadrao.length > 0) {
                            ModalService.confirmMessage('telaMonitor.existemRamaisQueTeraoGrupoPadraoAlterado', null, () => moverRamalPost());
                            return;
                        }
                    }
                    moverRamalPost();

                } else {
                    NotifyService.showError(null, 'telaMonitor.oRamalOuGrupoNaoFoiSelecionado')
                }
            }

            $scope.removerRamais = function () {
                var listaEsquerdaChecado = _.filter($scope.usuariosEsquerdaCompleto, function (r) {
                    return r.checked == true;
                });
                var listaDireitaChecado = _.filter($scope.usuariosDireitaCompleto, function (r) {
                    return r.checked == true;
                });
                var ramaisEsquerda = _.pluck(listaEsquerdaChecado, 'RamalId').join(",");
                var ramaisDireita = _.pluck(listaDireitaChecado, 'RamalId').join(",");

                var allpromises = [];
                if (ramaisEsquerda && $scope.dadosEsquerda.GrupoId > 0) {
                    allpromises.push(GrupoResource.removerRamal({
                        GrupoId: $scope.dadosEsquerda.GrupoId,
                        Ramais: ramaisEsquerda,
                    }).$promise);
                }
                if (ramaisDireita && $scope.dadosDireita.GrupoId > 0) {
                    allpromises.push(GrupoResource.removerRamal({
                        GrupoId: $scope.dadosDireita.GrupoId,
                        Ramais: ramaisDireita,
                    }).$promise);
                }
                ModalService.showLoading();
                $q.all(allpromises)
                    .then(function () {
                        ModalService.hideLoading();
                        NotifyService.showSuccess('telaMonior.ramalMovido');
                        $scope.onGrupoEsquerdaAlterado();
                        $scope.onGrupoDireitaAlterado();
                        $rootScope.$broadcast('onGrupoRamalAlterado');
                    })
                    .catch(function (ex) {
                        ModalService.hideLoading();
                        NotifyService.showError(ex);
                    });
            }

            //HISTÓRICO

            $scope.limparHistorico = function () {
                $scope.historicoRamal = [];
                $scope.historicoRamal.recordCount = null;
                $scope.submitted = false;
                $scope.currentPage = null;
                $scope.search = {
                    pageSize: 10
                }
                $scope.orderBy = {
                    column: "DataCadastro",
                    order: "desc"
                };
            }

            $scope.pesquisarHistorico = function () {
                $scope.atualizarHistoricoRamal(true);
            }

            $scope.atualizarHistoricoRamal = function (acaoPesquisar) {
                var listaDireitaChecado = _.filter($scope.usuariosDireitaFiltrados, function (r) {
                    return r.checked == true;
                });
                var listaEsquerdaChecado = _.filter($scope.usuariosEsquerdaFiltrados, function (r) {
                    return r.checked == true;
                });

                var listaTodosChecados = listaDireitaChecado.concat(listaEsquerdaChecado);
                $scope.search.Ramais = _.pluck(listaTodosChecados, 'RamalId');
                if ($scope.search.Ramais.length > 0 && $scope.search.Ramais.length <= 10) {
                    $scope.executeSearch();
                } else {
                    if (acaoPesquisar) {
                        NotifyService.showError(null, 'telaMonitor.selecioneUmRamalParaPesquisar')
                    }
                    $scope.limparHistorico();
                }
            }

            var getOdataSearchShared = function (search, orderBy, $odata, $odataresource) {
                var url = "Grupo/RamalHistorico";
                var resource = $odataresource(url);
                var odata = resource.odata();
                odata.orderBy(orderBy.column, orderBy.order);
                var predicateDataInicio = null;
                var predicateDataFim = null;

                if (search.DataInicio) {
                    predicateDataInicio = $odata.Predicate("DataCadastro", ">", search.DataInicio);
                }
                if (search.DataFim) {
                    predicateDataFim = $odata.Predicate("DataCadastro", "<", search.DataFim);
                }

                var predicateData = null;
                if (predicateDataInicio && predicateDataFim) {
                    predicateData = $odata.Predicate.and([predicateDataInicio, predicateDataFim])
                } else {
                    if (predicateDataInicio) {
                        predicateData = predicateDataInicio;
                    }
                    if (predicateDataFim) {
                        predicateData = predicateDataFim;
                    }
                }

                var combinacaoRamal = null;
                if (search.Ramais != null && search.Ramais.length > 0) {
                    search.Ramais.forEach(function (r) {
                        if (!combinacaoRamal) {
                            combinacaoRamal = new $odata.Predicate("RamalId", r);
                        }
                        else {
                            combinacaoRamal = $odata.Predicate.or([combinacaoRamal, new $odata.Predicate("RamalId", r)])
                        }
                    });
                }

                var combinacaoFinal = null;
                if (predicateData && combinacaoRamal) {
                    combinacaoFinal = $odata.Predicate.and([combinacaoRamal, predicateData]);
                } else {
                    if (predicateData) {
                        combinacaoFinal = predicateData;
                    }
                    if (combinacaoRamal) {
                        combinacaoFinal = combinacaoRamal;
                    }
                }
                if (combinacaoFinal) {
                    odata.filter(combinacaoFinal);
                }

                return odata;
            }

            var getOdataSearch = function getOdataSearch() {
                return getOdataSearchShared($scope.search, $scope.orderBy, $odata, $odataresource);
            };

            var updateList = function (list) {
                $scope.historicoRamal = list;
                $scope.historicoRamal.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.search.pageSize = list.$pageSize || 10;
                $scope.submitted = false;
            }

            $scope.executeSearch = function executeSearch() {
                $scope.submitted = true;
                getOdataSearch().page($scope.search.pageSize, 1).query().then(updateList).catch(NotifyService.showError);
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.search.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
            }

            $scope.onDataKeyPress = function (event) {
                var keyCode = event.keyCode;
                if (!(keyCode >= 48 && keyCode <= 57)) {
                    event.preventDefault();
                }
            }

            $scope.limparTudo();
        }]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')

		.factory("IndicadorResource", ["$odataresource", function ($odataresource) {
			var res = $odataresource("Indicador/:IndicadorId", {
				"IndicadorId": "@IndicadorId"
			});

			res.TipoIdCampanha = 5;
			res.TipoGrupoRamal = 'Monitor Ramal';
			res.TipoGrupoCampanha = 'Monitor Campanha';

			return res;
		}])

		.factory("IndicadorQualificacaoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("IndicadorQualificacao/:IndicadorQualificacaoId", {
				"IndicadorQualificacaoId": "@IndicadorQualificacaoId"
			});
		}])

		.factory("IndicadorMetricaResource", ["$odataresource", function ($odataresource) {
			return $odataresource("IndicadorMetrica/:IndicadorMetricaId", {
				"IndicadorMetricaId": "@IndicadorMetricaId"
			}, {
					MetricaGrupo: {
						url: "IndicadorMetrica/MetricaGrupo",
						method: "POST"
					}
				});
		}])

		.factory("MonitorCampanhaIndicadorResource", ["$odataresource", function ($odataresource) {
			return $odataresource("MonitorCampanhaIndicador/:MonitorCampanhaIndicadorId", {
				"MonitorCampanhaIndicadorId": "@MonitorCampanhaIndicadorId"
			}, {
					getMetricaCampanha: {
						url: "MonitorCampanhaIndicador/GetMonitorCampanhaIndicadorFavorito",
						method: "GET",
						isArray: true
					},

					postMetricaCampanha: {
						url: "MonitorCampanhaIndicador/PostMonitorCampanhaIndicador",
						method: "POST",
						isArray: true
					}
				});
		}]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('IndicadorService',
            function IndicadorService() {
                var service = {
                    grupos: {},
                };
                return service;
            });
})();


(function () {
	"use strict";
	angular.module('epbxManagerApp')

		.factory("LigacaoResource", ["$odataresource", function ($odataresource) {
			return $odataresource(
				"Ligacao/:GlobalId", {
					"GlobalId": "@GlobalId"
				}, {
					getDetalhe: {
						url: "Detalhe/:globalId/:ramalNumero",
						method: "GET"
					},
					download: {
						url: "Ligacao/Download/:globalId",
						method: "GET"
					},
					getHistorico: {
						url: "Ligacao/Historico/:ramalId",
						method: "GET",
						isArray: true
					},
					getTranscricao: {
						url: "Transcricao/:globalId/:arquivo",
						method: "GET",
						isArray: false
					}
				});
		}])
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.controller("MetricaController", ["$scope", "$timeout", "IndicadorResource", "IndicadorMetricaResource", "IndicadorQualificacaoResource", "NotifyService", function ($scope, $timeout, IndicadorResource, IndicadorMetricaResource, IndicadorQualificacaoResource,
			NotifyService) {
			/* Propriedades */
			$scope.grupoSelecionadoId = 0;
			$scope.grupoSelecionado = {};
			$scope.grupos = [];
			$scope.indicadores = [];
			$scope.metricas = [];
			$scope.tipos = [];
			$scope.carregando = false;
			$scope.primeiroClick = true;
			$scope.indicadorAssociadoAberto = [];
			$scope.periodo = {
				Hora: new Date(2000, 0, 1, 1, 0, 0)
			};

			/* Event Listeners */
			$scope.$on("onLoadGrupos", function (event, grupos) {
				$scope.grupos = grupos;
			})

			$('#modal_metrica').on({
				'show.uk.modal': function () {
					$scope.primeiroClick = true;
				}
			});

			/* Métodos */
			var convertTimeToMinutes = function (hms) {
				var a = hms.split(':'); // split it at the colons
				// minutes are worth 60 seconds. Hours are worth 60 minutes.
				var minutes = (+a[0]) * 60 + (+a[1]);
				return minutes;
			}

			var convertMinutesToTime = function (minutes) {
				if (!minutes) minutes = 0;
				var date = new Date(null);
				date.setMinutes(minutes); // specify value for SECONDS here
				date.toISOString().substr(11, 8);
				return date.toISOString().substr(11, 8);
			}

			var convertKendoTimePickerToMinutes = function (element) {
				var minutes = 0;
				if (element.length > 0) {
					var hms = element;
					minutes = convertTimeToMinutes(hms);
				}
				return minutes;
			}

			var createDateObjectFromTime = function (time) {
				var ValorData = new Date();
				var hours = Math.floor(time / 3600);
				var minutes = Math.floor((time / 60) - (hours * 60));
				var seconds = Math.floor((time) - (hours * 3600) - (minutes * 60));
				ValorData.setHours(hours);
				ValorData.setMinutes(minutes);
				ValorData.setSeconds(seconds);
				return ValorData;
			}

			var createDateObjectFromMinutes = function (time) {
				var ValorData = new Date();
				var hours = Math.floor(time / 60);
				var minutes = Math.floor((time) - (hours * 60));
				ValorData.setHours(hours);
				ValorData.setMinutes(minutes);
				ValorData.setSeconds(0);
				return ValorData;
			}
			var convertDateToTime = function (date) {
				// minutes are worth 60 seconds. Hours are worth 60 minutes.
				var time = date.getHours() * 3660 + date.getMinutes() * 60 + date.getSeconds();
				return time;
			}

			$scope.onAtivoAlterado = function (metrica) {
				if (metrica.Ativo == false) {
					metrica.Favorito = false;
				}
				var pai = _.find($scope.metricas, function (el) {
					return el.Indicador.IndicadorId == metrica.Indicador.IndicadorAssociado && el.Ativo == true;
				});
				if (pai != null) {
					$scope.onValorAlterado(pai, 0);
					$scope.onValorAlterado(pai, 1);
					$scope.onValorAlterado(pai, 2);
				}
			};

			$scope.onCloseModal = function (element) {
				var model = UIkit.modal("#" + element)
				model.hide();
			}

			$scope.onHideModal = function(){
				$scope.AuxAuditor = 0;
			}

			$scope.AuxAuditor = 0;
			$scope.onClickShowAuditor = function (item) {
				console.log(item)
				if (item.IndicadorMetricaId != undefined)
					$scope.AuxAuditor = item.IndicadorMetricaId;
			}

			$scope.getList = function () {
				var tabs = UIkit.tab("#tab-metrica");
				$scope.$parent.selectedTab = tabs.switcher.index;

				IndicadorResource.odata()
					.where('IndicadorTipo/IndicadorTipoGrupo_Descricao', IndicadorResource.TipoGrupoRamal) // apenas indicadores de Ramal
					.query().then(function (result) {
						$scope.indicadores = result;

						var odata = IndicadorMetricaResource.odata();
						odata.filter('GrupoId', $scope.grupoSelecionadoId);

						odata.query().then(function (resultMetrica) {
							$scope.metricas = resultMetrica;
							$scope.estiloOptions = [];

							var IndicadoresNaoCriados = _.filter($scope.indicadores, function (id) {
								return !(_.some($scope.metricas, function (me) {
									return id.IndicadorId == me.IndicadorId;
								}));
							});
							IndicadoresNaoCriados.forEach(function (el) {
								var metricaTmp = {
									IndicadorId: el.IndicadorId,
									GrupoId: $scope.grupoSelecionadoId,
									Grupo: $scope.grupoSelecionado,
									Periodo: convertTimeToMinutes($scope.periodo.Hora),
									Indicador: el,
									Ativo: false,
									IndicadorMetricaQualificacao: []
								};

								$scope.metricas.push(metricaTmp);
							});

							$scope.metricas.forEach(function (el) {
								if (el.Periodo != null && el.Periodo > 0 && convertTimeToMinutes($scope.periodo.Hora) != el.Periodo && el.Ativo) {
									$scope.periodo.Hora = createDateObjectFromMinutes(el.Periodo);
									el.Periodo.Hora = convertMinutesToTime(el.Periodo);
								}
								var temFilho = _.find($scope.metricas, function (m) {
									return m.Indicador.IndicadorAssociado == el.Indicador.IndicadorId
								}) != null;
								var temProporcao = _.find($scope.metricas, function (m) {
									return m.Indicador.IndicadorProporcao == el.Indicador.IndicadorId
								}) != null;
								if (temFilho) {
									el.Indicador.IndicadorAssociado = el.Indicador.IndicadorId;
								}
								if (temProporcao) {
									el.Indicador.IndicadorProporcao = el.Indicador.IndicadorId;
								}
								if (el.IndicadorMetricaQualificacao && el.IndicadorMetricaQualificacao.length == $scope.qualificacoes.length) {
									el.IndicadorMetricaQualificacao.forEach(function (mqel) {
										if (mqel.ValorInicial >= 0 || mqel.ValorFinal >= 0) {
											if (el.Indicador.Formatacao != 'Time') {
												mqel.Valor = mqel.ValorInicial > mqel.ValorFinal ? mqel.ValorInicial : mqel.ValorFinal;
											} else {
												if (mqel.ValorInicial > mqel.ValorFinal) {
													mqel.ValorData = createDateObjectFromTime(mqel.ValorInicial);
												} else {
													mqel.ValorData = createDateObjectFromTime(mqel.ValorFinal);
												}
											}
										}
									});
								} else {
									var indexQ = 0;
									$scope.qualificacoes.forEach(function (qel) {
										if (el.IndicadorMetricaQualificacao[indexQ] == null) {
											el.IndicadorMetricaQualificacao[indexQ] = {
												IndicadorQualificacaoId: qel.IndicadorQualificacaoId,
												Valor: 0
											};
										} else {
											var mqel = el.IndicadorMetricaQualificacao[indexQ];
											if (el.Indicador.Formatacao != 'Time') {
												mqel.Valor = mqel.ValorInicial > mqel.ValorFinal ? mqel.ValorInicial : mqel.ValorFinal;
											} else {
												if (mqel.ValorInicial > mqel.ValorFinal) {
													mqel.ValorData = createDateObjectFromTime(mqel.ValorInicial);
												} else {
													mqel.ValorData = createDateObjectFromTime(mqel.ValorFinal);
												}
											}
										}
										indexQ++;
									});
								}


							});

							$scope.metricas = _.sortBy($scope.metricas,
								function (m) {
									var fatorPrincipal = 0;
									if (m.Indicador.IndicadorId == m.Indicador.IndicadorAssociado) {
										fatorPrincipal = m.Indicador.IndicadorId;
									}
									m.Ordenacao = -(m.Indicador.IndicadorAssociado * 1000 - fatorPrincipal);
									return m.Ordenacao;
								});

							$scope.tipos = _.uniq(_.pluck(_.pluck($scope.metricas, 'Indicador'), 'IndicadorTipo'), false, function (el) {
								return el.Descricao
							});

							$scope.carregando = false;
							$timeout(function () {
								$scope.$parent.selectedTab = tabs.switcher.index;
							}, 0);

						});
					});
			}

			$scope.onValorAlterado = function (element, index, noRepeatProporcao, noRepeatAssociacao) {
				var metrica, indiceQualificacao;
				//recuperar a métrica do escopo do elemento onAtivoAlterado
				if (index != null) {
					metrica = element;
					indiceQualificacao = index;
				} else {
					indiceQualificacao = angular.element(element.sender)[0].$angular_scope.$parent.$index;
					metrica = angular.element(element.sender)[0].$angular_scope.$parent.$parent.metrica;
				}
				var indicador = metrica.Indicador;
				var tipo = '';
				var ehData = metrica.Indicador.Formatacao == 'Time';
				if (ehData) {
					tipo = 'ValorData';
					if (index == null) {

						if (element.sender._value == null) {
							element.sender._value = $scope.periodo.Hora;
							$(element.sender.element).val($scope.periodo.Hora + ':00');
							metrica.IndicadorMetricaQualificacao[indiceQualificacao][tipo] = $scope.periodo.Hora;
						}

						if (convertDateToTime(element.sender._value) > convertDateToTime($scope.periodo.Hora)) {
							element.sender._value = $scope.periodo.Hora;
							
							$(element.sender.element).val($scope.periodo.Hora + ':00');
							metrica.IndicadorMetricaQualificacao[indiceQualificacao][tipo] = $scope.periodo.Hora;
						}

						if (convertDateToTime(element.sender._value) == 0) {
							element.sender._value = new Date(2000, 0, 1, 0, 0, 1);
							$(element.sender.element).val('00:00:01');
							metrica.IndicadorMetricaQualificacao[indiceQualificacao][tipo] = element.sender._value;
						}
					}
				} else {
					tipo = 'Valor';
					if (index == null) {
						metrica.IndicadorMetricaQualificacao[indiceQualificacao][tipo] = element.sender._value;
					}
				}
				var valorTotal = null;

				//RELAÇÃO DE PROPORÇÃO
				if (indicador.IndicadorProporcao > 0 && !noRepeatProporcao) {
					var filhos = _.filter($scope.metricas, function (el) {
						return el.Indicador.IndicadorProporcao == indicador.IndicadorProporcao && el.Indicador.IndicadorId != indicador.IndicadorProporcao && el.Ativo == true;
					});
					var tma = _.find($scope.metricas, function (el) {
						return el.Indicador.IndicadorId == indicador.IndicadorProporcao && el.Ativo == true;
					});
					var qtdPai = tma != null ? 1 : 0;
					var duracao, duracaoValor, quantidade;
					if (filhos.length + qtdPai > 2) {
						if (indicador.IndicadorProporcao != indicador.IndicadorId) {
							//PAI
							duracao = _.find(filhos, function (el) {
								return el.Indicador.Formatacao == 'Time';
							});
							duracaoValor = duracao.IndicadorMetricaQualificacao[indiceQualificacao].ValorData;

							quantidade = _.find(filhos, function (el) {
								return el.Indicador.Formatacao != 'Time';
							});
							var quantidadeValor = Math.floor(quantidade.IndicadorMetricaQualificacao[indiceQualificacao].Valor);

							if (!duracaoValor && !quantidadeValor) {
								return;
							}

							if (!duracaoValor) {
								duracao.IndicadorMetricaQualificacao[indiceQualificacao].ValorData = $scope.periodo.Hora;
								duracaoValor = $scope.periodo.Hora;
								$scope.onValorAlterado(duracao, indiceQualificacao, true, false);
							}

							if (duracaoValor instanceof Date) {
								duracaoValor = duracaoValor.getHours() * 3600 + duracaoValor.getMinutes() * 60 + duracaoValor.getSeconds();
							} else {
								duracaoValor = convertTimeToMinutes(duracaoValor);
							}

							if (quantidadeValor == 0) {
								quantidade.IndicadorMetricaQualificacao[indiceQualificacao].Valor = 1;
								quantidadeValor = 1;
								$scope.onValorAlterado(quantidade, indiceQualificacao, true, false);
							}
							tma.IndicadorMetricaQualificacao[indiceQualificacao].ValorData = createDateObjectFromTime(duracaoValor / quantidadeValor);
							$scope.onValorAlterado(tma, indiceQualificacao, true, false);
						} else {
							//ALTERAR A QUANTIDADE
							duracao = _.find(filhos, function (el) {
								return el.Indicador.Formatacao == 'Time';
							});
							duracaoValor = duracao.IndicadorMetricaQualificacao[indiceQualificacao].ValorData;

							var tmaValor = tma.IndicadorMetricaQualificacao[indiceQualificacao].ValorData;
							quantidade = _.find(filhos, function (el) {
								return el.Indicador.Formatacao != 'Time';
							});

							if (!duracaoValor) {
								duracao.IndicadorMetricaQualificacao[indiceQualificacao].ValorData = $scope.periodo.Hora;
								duracaoValor = $scope.periodo.Hora;
								$scope.onValorAlterado(duracao, indiceQualificacao, true, false);
							}
							if (duracaoValor instanceof Date) {
								duracaoValor = duracaoValor.getHours() * 3600 + duracaoValor.getMinutes() * 60 + duracaoValor.getSeconds();
							} else {
								duracaoValor = convertTimeToMinutes(duracaoValor);
							}
							if (tmaValor instanceof Date) {
								tmaValor = tmaValor.getHours() * 3600 + tmaValor.getMinutes() * 60 + tmaValor.getSeconds();
							} else {
								tmaValor = convertTimeToMinutes(tmaValor);
							}


							quantidade.IndicadorMetricaQualificacao[indiceQualificacao].Valor = duracaoValor / tmaValor;
							$scope.onValorAlterado(quantidade, indiceQualificacao, true, false);
						}
					}
				}

				//RELAÇÃO DE TOTAL E FILHOS
				if (indicador.IndicadorAssociado > 0 && !noRepeatAssociacao) {
					filhos = _.filter($scope.metricas, function (el) {
						return el.Indicador.IndicadorAssociado == indicador.IndicadorAssociado && el.Indicador.IndicadorId != indicador.IndicadorAssociado && el.Ativo == true;
					});
					var pai = _.find($scope.metricas, function (el) {
						return el.Indicador.IndicadorId == indicador.IndicadorAssociado && el.Ativo == true;
					});
					if (indicador.IndicadorAssociado != indicador.IndicadorId) {
						//FILHO ALTERADO
						if (pai != null) {
							var valores = _.map(filhos, function (el) {
								return el.IndicadorMetricaQualificacao[indiceQualificacao][tipo];
							});

							valorTotal = $scope.calcularValorTotal(valores, ehData);
							pai.IndicadorMetricaQualificacao[indiceQualificacao][tipo] = valorTotal;
							$scope.onValorAlterado(pai, indiceQualificacao, false, true);
						}
					} else {
						if (filhos != null) {
							if (ehData) {
								valorTotal = pai.IndicadorMetricaQualificacao[indiceQualificacao][tipo];
							} else {
								if (element.sender == null) {
									valorTotal = pai.IndicadorMetricaQualificacao[indiceQualificacao][tipo];
								} else {
									valorTotal = element.sender._value;
								}
							}

							var valorParcial = $scope.calcularValorParcial(valorTotal, filhos.length, ehData);

							for (var i = 0; i < filhos.length; i++) {
								if (!ehData && i + 1 == filhos.length) {
									var resto = valorTotal - valorParcial * filhos.length;
									filhos[i].IndicadorMetricaQualificacao[indiceQualificacao][tipo] = valorParcial + resto;
								} else {
									filhos[i].IndicadorMetricaQualificacao[indiceQualificacao][tipo] = valorParcial;
								}
								$scope.onValorAlterado(filhos[i], indiceQualificacao, false, true);
							}
						}
					}
				}
			};

			$scope.alterarFavorito = function (metrica) {
				if (metrica.Ativo == true) {
					if (metrica.Favorito) {
						metrica.Favorito = false;
					} else {
						metrica.Favorito = true
					}
				}
			};

			$scope.calcularValorTotal = function (valores, ehData) {
				var valorTotal = 0, i;
				if (ehData) {
					for (i = 0; i < valores.length; i++) {
						if (valores[i] != null && !isNaN(valores[i])) {
							if (valores[i] instanceof Date) {
								valorTotal += valores[i].getHours() * 3600 + valores[i].getMinutes() * 60 + valores[i].getSeconds();
							} else {
								valorTotal += convertTimeToMinutes(valores[i]);
							}
						}
					}
					return createDateObjectFromTime(valorTotal);
				} else {
					for (i = 0; i < valores.length; i++) {
						if (valores[i] != null && !isNaN(valores[i]))
							valorTotal += parseInt(valores[i]);
					}
					return valorTotal;
				}
			};

			$scope.calcularValorParcial = function (valorTotal, quantidadeFilhos, ehData) {
				if (ehData) {
					if (valorTotal != null) {
						if (valorTotal instanceof Date) {
							valorTotal = valorTotal.getHours() * 3600 + valorTotal.getMinutes() * 60 + valorTotal.getSeconds();
						} else {
							valorTotal = convertTimeToMinutes(valorTotal);
						}
						return createDateObjectFromTime(valorTotal / quantidadeFilhos);
					}
				}
				return Math.floor(valorTotal / quantidadeFilhos);

			};

			$scope.clickGrupo = function (grupo) {
				if (grupo != $scope.grupoSelecionado) {
					$scope.grupoSelecionado = grupo;
					$scope.grupoSelecionadoId = grupo.GrupoId;
					$scope.primeiroClick = true;
					$scope.carregando = true;
					$scope.getList();
				}
			};

			$scope.onChangeGrupoSelecionado = function (grupoId) {
				const grupo = $scope.grupos.find(g => g.GrupoId === grupoId);
				$scope.grupoSelecionado = grupo;
				$scope.grupoSelecionadoId = grupoId;
				$scope.primeiroClick = true;
				$scope.carregando = true;
				$scope.getList();
			}

			$scope.changeTab = function () {
				$scope.primeiroClick = false;
			}

			IndicadorQualificacaoResource.odata().query().then(function (result) {
				$scope.qualificacoes = result;
			});

			$scope.salvar = function (form) {
				var metricasPendentesSalvar = [];
				$scope.metricas.forEach(function (metrica) {
					metrica.Periodo = convertKendoTimePickerToMinutes($scope.periodo.Hora);
					metricasPendentesSalvar.push(metrica);
				});
				if (metricasPendentesSalvar.length == 0) {
					metricasPendentesSalvar.push({});
				}
				if (!form.$valid) {
					return;
				}
				var metricasFavorito = _.filter(metricasPendentesSalvar, function (el) {
					return el.Favorito == true && el.Indicador.IndicadorTipoId == 2;
				});
				if (metricasFavorito.length > 6) {
					NotifyService.showError(null, 'telaMonitor.soPodemExistir6Indicadores');
					return;
				}

				_.forEach(metricasPendentesSalvar, function (metrica) {
					if (metrica.Indicador.Formatacao == 'Time') {
						_.forEach(metrica.IndicadorMetricaQualificacao, function (qual) {
							if (qual.ValorData) {
								const arrayDate = qual.ValorData.split(':');
								qual.Valor = parseInt(arrayDate[0]) * 3600 + parseInt(arrayDate[1]) * 60 + parseInt(arrayDate[2]);
							}
						});
					}
				});

				if (metricasPendentesSalvar.length > 0) {
					IndicadorMetricaResource.MetricaGrupo(metricasPendentesSalvar).$promise
						.then(function (data) {
							$scope.getList();
							NotifyService.showRegistroSalvo(data);
						})
						.catch(NotifyService.showError);
				}
			};

			$scope.mostrarMetrica = function (metrica) {
				if (!$scope.toggleClicked) {
					$scope.metricas.forEach(function (el) {
						if (metrica != el) {
							if (!el.persist || el.persist == false) {
								el.show = false;
							}
						}
					});

					if (!metrica.show) {
						metrica.show = true;
					}
				} else {
					$scope.toggleClicked = false;
				}
			};

			$scope.toggleMetrica = function (metrica) {
				metrica.show = !metrica.show;
				metrica.persist = metrica.show;
				$scope.toggleClicked = true
			}

			$scope.toggleClicked = false;

			$scope.valorOptions = {
				decimals: 0,
				format: '#',
				change: $scope.onValorAlterado,
				spin: $scope.onValorAlterado,
			};
		}]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .filter('SumFilter', function () {
            return function (list, campo) {
                if (campo == "DDD" || campo == "Classe" || campo == "Operadora" || campo == "Tipo" || campo == "Rota" || campo == "Campanha") {
                    return 'TOTAL';
                } else if (campo == "HoraIni") {
                    return '';
                } else if (campo == "HoraFim") {
                    return 'TOTAL';
                } else {
                    var total = 0

                    for (var i = 0; i < list.length; i++) {

                        var valor = list[i][campo];

                        if (angular.isNumber(valor)) {
                            total += list[i][campo]
                        }
                    }
                    return total
                }
            };
        })

        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                return $filter('number')(input, decimals) + '%';
            };
        }])


        .filter('ordenarFilaPorTempo', ['$filter', function () {
            return function (items) {
                return _.sortBy(items, function (chamada) { return new moment(chamada.DataInicio); });
            };
        }])

        .filter('filaAtendimento', function () {
            return function (listFila) {                
                return _.filter(listFila, function (fila) {                    
                    return fila.IsVirtual == false;
                });
            };
        })

        .filter('filaVirtual', function () {
            return function (listFila) {                
                return _.filter(listFila, function (fila) {                    
                    return fila.IsVirtual == true;
                });
            };
        })

        .filter('IndicadorRamaisLivre', function () {
            return function (ramais, grupoId, ramalId) {
                let ramaisLivre = [];

                let currentLang = (localStorage.getItem('idioma') || 'pt').replace(/"/g, '');
                                        
                let statusLivre = {
                    'pt': 'Livre',
                    'es': 'Libre',
                    'en': 'Available'
                }[currentLang] || 'Livre'; 

                if (grupoId != undefined && grupoId > 0) {
                    ramaisLivre = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(grupoId) > -1 && ramal.Status == statusLivre;
                        }
                    });
                } else if (ramalId != undefined && ramalId > 0) {
                    ramaisLivre = _.filter(ramais, function (ramal) {
                        return ramal.RamalId == ramalId && ramal.Status == statusLivre;
                    });
                } else {
                    ramaisLivre = _.filter(ramais, function (ramal) {
                        return ramal.Status && ramal.Status == statusLivre;
                    });
                }

                return ramaisLivre.length;
            };
        })

        .filter('IndicadorRamaisLivreList', function () {
            return function (ramais, grupoId, ramalId) {

                let ramaisLivre = [];

                let currentLang = (localStorage.getItem('idioma') || 'pt').replace(/"/g, '');
                                        
                let statusLivre = {
                    'pt': 'Livre',
                    'es': 'Libre',
                    'en': 'Available'
                }[currentLang] || 'Livre'; 

                if (grupoId != undefined && grupoId > 0) {
                    ramaisLivre = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(grupoId) > -1 && ramal.Status == statusLivre;
                        }
                    });
                } else if (ramalId != undefined && ramalId > 0) {
                    ramaisLivre = _.filter(ramais, function (ramal) {
                        return ramal.RamalId == ramalId && ramal.Status == statusLivre;
                    });
                } else {
                    ramaisLivre = _.filter(ramais, function (ramal) {
                        return ramal.Descricao && ramal.Descricao == statusLivre;
                    });
                }

                return ramaisLivre;
            };
        })


        .filter('IndicadorRamaisOnLine', function () {
            return function (ramais, search) {

                let ramaisOnLine = [];

                let currentLang = (localStorage.getItem('idioma') || 'pt').replace(/"/g, '');
                                        
                let statusNaoLogado = {
                    'pt': 'Não Logado',
                    'es': 'No Conectado',
                    'en': 'Not Logged'
                }[currentLang] || 'Não Logado'; 

                if (search.GrupoId) {
                    ramaisOnLine = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(parseInt(search.GrupoId)) > -1 && ramal.Status !== statusNaoLogado;
                        }
                    });
                } else {
                    ramaisOnLine = _.filter(ramais, function (ramal) {
                        return ramal.Status && ramal.Status !== statusNaoLogado;
                    });
                }

                if(search.CarteiraId) {
                    ramaisOnLine = _.filter(ramaisOnLine, function (ramal) {
                        if (ramal.Carteiras) {
                            return ramal.Carteiras.indexOf(parseInt(search.CarteiraId)) > -1;
                        }
                    });
                }

                ramaisOnLine = _.filter(ramaisOnLine, function (ramal) {                    
                    return ramal.RamalTipoId == 1;                    
                });

                return ramaisOnLine.length;
            };
        })
        .filter('IndicadorRamaisOnLineBot', function () {
            return function (ramais, search) {
                let ramaisOnLineBot = [];

                let currentLang = (localStorage.getItem('idioma') || 'pt').replace(/"/g, '');
                                        
                let statusNaoLogado = {
                    'pt': 'Não Logado',
                    'es': 'No Conectado',
                    'en': 'Not Logged'
                }[currentLang] || 'Não Logado'; 

                if (search.GrupoId) {
                    ramaisOnLineBot = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(parseInt(search.GrupoId)) > -1 && ramal.Status !== statusNaoLogado;
                        }
                    });
                } else {
                    ramaisOnLineBot = _.filter(ramais, function (ramal) {
                        return ramal.Status && ramal.Status !== statusNaoLogado;
                    });
                }

                if(search.CarteiraId) {
                    ramaisOnLineBot = _.filter(ramaisOnLineBot, function (ramal) {
                        if (ramal.Carteiras) {
                            return ramal.Carteiras.indexOf(parseInt(search.CarteiraId)) > -1;
                        }
                    });
                }

                ramaisOnLineBot = _.filter(ramaisOnLineBot, function (ramal) {                    
                    return ramal.RamalTipoId == 6;                    
                });

                return ramaisOnLineBot.length;
            };
        })

        .filter('IndicadorRecebendoChamada', function () {
            return function (ramais, search) {
                let ramaisRecebendoChamada = [];

                if (search.GrupoId) {
                    ramaisRecebendoChamada = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(parseInt(search.GrupoId)) > -1 && ramal.NomeIntegracao == 'AtendidoChamadaExternaEntrante';
                        }
                    });
                } else {
                    ramaisRecebendoChamada = _.filter(ramais, function (ramal) {
                        return (ramal.NomeIntegracao == 'AtendidoChamadaExternaEntrante');
                    });
                }

                if (search.CarteiraId) {
                    ramaisRecebendoChamada = _.filter(ramaisRecebendoChamada, function (ramal) {
                        if (ramal.Carteiras) {
                            return ramal.Carteiras.indexOf(parseInt(search.CarteiraId)) > -1;
                        }
                    });
                }

                return ramaisRecebendoChamada.length;
            };
        })

        .filter('IndicadorEfetuandoChamada', function () {
            return function (ramais, search) {
                let ramaisEfetuandoChamada = [];

                if (search.GrupoId) {
                    let ramaisFiltrados = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(parseInt(search.GrupoId)) > -1;
                        }
                    });

                    ramaisEfetuandoChamada = _.filter(ramaisFiltrados, function (ramal) {
                        return (ramal.NomeIntegracao == 'AtendidoChamadaDiscador' || ramal.NomeIntegracao == 'AtendidoChamadaExternaSainte');
                    });
                } else {
                    ramaisEfetuandoChamada = _.filter(ramais, function (ramal) {
                        return (ramal.NomeIntegracao == 'AtendidoChamadaDiscador' || ramal.NomeIntegracao == 'AtendidoChamadaExternaSainte');
                    });
                }

                if (search.CarteiraId) {
                    ramaisEfetuandoChamada = _.filter(ramaisEfetuandoChamada, function (ramal) {
                        if (ramal.Carteiras) {
                            return ramal.Carteiras.indexOf(parseInt(search.CarteiraId)) > -1;
                        }
                    });
                }

                return ramaisEfetuandoChamada.length;
            };
        })

        .filter('IndicadorTabulando', function () {
            return function (ramais, search) {
                let ramaisTabulando = [];

                if (search.GrupoId) {
                    ramaisTabulando = _.filter(ramais, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(parseInt(search.GrupoId)) > -1 && ramal.IsTabulacao;
                        }
                    });
                } else {
                    ramaisTabulando = _.filter(ramais, function (ramal) {
                        return ramal.IsTabulacao;
                    });
                }

                if (search.CarteiraId) {
                    ramaisTabulando = _.filter(ramaisTabulando, function (ramal) {
                        if (ramal.Carteiras) {
                            return ramal.Carteiras.indexOf(parseInt(search.CarteiraId)) > -1;
                        }
                    });
                }

                return ramaisTabulando.length;
            };
        })

        .filter('monitorFilterGrupo', function () {
            return function (grupos, filter) {
            let items = grupos;
            
            if (filter.CarteiraId) {
                items = _.filter(grupos, function (item) {
                    return item.CarteiraId == filter.CarteiraId;
                });
            }
            
            if (filter.filtroGrupo) {
                items = _.filter(items, function (item) {
                    if (item.DescricaoFormatada) {
                        return item.DescricaoFormatada.toLowerCase().includes(filter.filtroGrupo.toLowerCase());
                    }
                });
            }
            return items;
            };
        })
        
        .filter('calcularTotalRamais', function () {
            return function (grupos) {
            let total = 0;
            for(var propertyName in grupos) {
                total = total + grupos[propertyName].length;
             }

            return total;
            };
        })
            
        .filter('monitorFilter', ["$filter", "MonitorRamalService", function ($filter, MonitorRamalService) {
            return function (items, filter, orderBy, orderType, grupos, naoFiltraNaoLogado ) {
                
                if (Array.isArray(filter.Eventos) && filter.Eventos.length > 0 && !naoFiltraNaoLogado) {
                    items = _.filter(items, function (item) {
                        return item.Status && filter.Eventos.indexOf(item.Status) > -1;
                    });
                } else if (filter.Evento && !naoFiltraNaoLogado) {
                    items = _.where(items, {
                        Status: filter.Evento
                    });
                } else {
                    if(!naoFiltraNaoLogado){
                        items = _.filter(items, function (item) {
                            return item.Status !== 'Não Logado' && item.Status != null;
                        });
                    }
                }

                if (filter.Ramal) {
                    if (parseInt(filter.Ramal)) {
                        if (filter.Ramal.length == 4) {
                            items = _.where(items, {
                                Numero: parseInt(filter.Ramal)
                            });
                        }

                        if (filter.Ramal.length >= 8) {
                            items = _.where(items, {
                                NA: filter.Ramal
                            });
                        }

                    } else {
                        items = _.filter(items, function (item) {
                            if (item.UsuarioNome) {
                                return item.UsuarioNome.toLowerCase().startsWith(filter.Ramal.toLowerCase());
                            }
                        });
                    }
                }

                if (filter.GrupoId > 0) {
                    let ramaisFiltrados = _.filter(items, function (ramal) {
                        if (ramal.Grupos) {
                            return ramal.Grupos.indexOf(parseInt(filter.GrupoId)) > -1;
                        }
                    });
                    items = ramaisFiltrados;
                }

                if (filter.CarteiraId > 0) {
                    let ramaisFiltrados = _.filter(items, function (ramal) {
                        return ramal.Carteiras.indexOf(parseInt(filter.CarteiraId)) > -1;
                    });
                    items = ramaisFiltrados;
                }

                var reverse = orderType == 'Desc' ? true : false;

                items = $filter('orderBy')(items, orderBy, reverse);

                if(!naoFiltraNaoLogado){
                    MonitorRamalService.quantidadeRamalTotal = items.length;
                    MonitorRamalService.numberOfPages = Math.ceil(items.length / MonitorRamalService.pageSize);
    
                    if (items.length >= MonitorRamalService.pageSize) {
                        let begin = (MonitorRamalService.currentPage * MonitorRamalService.pageSize);
                        let end = begin + MonitorRamalService.pageSize;
                        items = items.slice(begin, end);
                    } else {
                        MonitorRamalService.currentPage = 0;
                    }
    
                    if (items.length > MonitorRamalService.pageSize) {
                        MonitorRamalService.quantidadeRamalExibida = MonitorRamalService.pageSize;
                    }
                    else {
                        MonitorRamalService.quantidadeRamalExibida = items.length;
                    }
                }else{
                    MonitorRamalService.quantidadeRamalExibida = items.length;
                    MonitorRamalService.quantidadeRamalTotal = items.length;
                }
                
                return items;
            };
        }])

        .filter('discandoCTIFilter', function () {
            return function (list, campanhaId) {

                let count = 0;
                if (campanhaId && campanhaId.length > 0) {

                    const listaTemp = list.filter(function (item) {
                        return item.Status == 'DiscandoDiscador';
                    })

                    if (listaTemp && listaTemp.length > 0) {

                        campanhaId.map(function (campanhaItem, index) {
                            const listaCampanha = listaTemp.filter(function (item) {
                                return item.CampanhaId == campanhaItem;
                            })

                            if (listaCampanha && listaCampanha.length > 0) {
                                count = count + listaCampanha[0].Total;
                            }
                        });
                    }
                }
                return count;
            };
        })

        .filter('falandoCTIFilter', function () {
            return function (list, campanhaId) {
                let count = 0;
                if (campanhaId && campanhaId.length > 0) {

                    const listaTemp = list.filter(function (item) {
                        return item.Status == 'AtendidoChamadaDiscador';
                    })

                    if (listaTemp && listaTemp.length > 0) {

                        campanhaId.map(function (campanhaItem, index) {
                            const listaCampanha = listaTemp.filter(function (item) {
                                return item.CampanhaId == campanhaItem;
                            })

                            if (listaCampanha && listaCampanha.length > 0) {
                                count = count + listaCampanha[0].Total;
                            }
                        });
                    }
                }

                return count;
            };
        })
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.monitor", {
                    url: "",
                    template: '<ui-view autoscroll="false"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.monitor.list',
                        pageTitle: 'pageTitle.monitor',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.monitor.list", StateResolverProvider.configState("/monitor", "Monitor", "List", {
                    pageTitle: 'pageTitle.monitor',
                    pageName: 'pageTitle.pesquisar',
                    css: true
                }));
        }])

        .service('MonitorListData', function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_charts_c3',
                            'lazy_charts_peity',
                            'lazy_countUp',
                            'lazy_uiSelect',
                            'lazy_ionRangeSlider',
                            'lazy_masked_inputs',
                            'lazy_word_cloud'
                        ]);
                    }],
                    ramais: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getRamais().$promise;
                    }],
                    grupos: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getGrupos({ carteiras: '' }).$promise;
                    }],
                    qualificacoes: ["IndicadorQualificacaoResource", function (IndicadorQualificacaoResource) {
                        return IndicadorQualificacaoResource.odata().query();
                    }],
                    dataServer: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getDataAtual().$promise;
                    }],
                    dataPagina: function () {
                        return new Date();
                    },
                    servicos: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.lookup().$promise;
                    }],
                    uras: ["UraResource", function (UraResource) {
                        return UraResource.getUraRaiz().$promise;
                    }],
                    rotasMonitoria: ["RotaResource", function (RotaResource) {
                        return RotaResource.getRotaMonitoria().$promise;
                    }],
                    // ramalStatusDetalhes: function (RamalStatusResourceDetalhe) {
                    //     return RamalStatusResourceDetalhe.odata().select('RamalStatusDetalheId', 'Descricao').orderBy('Descricao').query();
                    // },
                    filaAlarme: ["GerenciaFilaResource", function (GerenciaFilaResource) {
                        return GerenciaFilaResource.get({ grupoId: 0 }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    listFila: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getFila().$promise;
                    }],                    
                    fornecedores: ["FornecedorResource", function (FornecedorResource) {
                        return FornecedorResource.query().$promise;
                    }]
                }
            }
        })

        .controller("MonitorListController", ["$scope", "$window", "$interval", "$timeout", "$filter", "filaAlarme", "ramais", "grupos", "uras", "rotasMonitoria", "qualificacoes", "dataServer", "dataPagina", "servicos", "BlacklistCrmResource", "BlacklistTemporariaResource", "DashboardResource", "MonitorResource", "SupervisaoService", "fornecedores", "RamalDetalheService", "$rootScope", "SUPERVISAO_EVENTS", "$http", "Config", "IndicadorService", "MonitorCampanhaResource", "MonitorRamalService", "SIGNALR_EVENTS", "LocalStorageService", "$state", "NotifyService", "ModalService", "$translate", "TranslateService", "carteiras", "listFila", "RamalAtribuicoesResource", function ($scope, $window, $interval, $timeout, $filter, filaAlarme, ramais, grupos, uras, rotasMonitoria, qualificacoes,
            dataServer, dataPagina, servicos, BlacklistCrmResource, BlacklistTemporariaResource, DashboardResource, MonitorResource, SupervisaoService, fornecedores, 
            RamalDetalheService, $rootScope, SUPERVISAO_EVENTS, $http, Config, IndicadorService, MonitorCampanhaResource, MonitorRamalService, SIGNALR_EVENTS,
            LocalStorageService, $state, NotifyService, ModalService, $translate, TranslateService, carteiras, listFila, RamalAtribuicoesResource) {

            $scope.QuantidadeFilaGrupo = 0;
            $scope.QuantidadeFilaVirtual = 0;
            $scope.QuantidadeFila = 0
            $scope.pesquisaRamais = false;
            $scope.canais = [];
            $scope.FilaAlarme = filaAlarme;
            $scope.carteiras = carteiras;
            $scope.carteirasSelecionadas = null;
            $scope.exibirGrupoSemDados = false;
            $scope.filaGrupo = [];
            $scope.filaVirtual = [];
            $scope.listFila = listFila;            
            $scope.alermeRoboCall = {}
            $scope.QuantidadeRoboCall = 0;
            $scope.filtroRoboCall = {
                Periodo: 60
            };
            $scope.fornecedores = fornecedores;    
            $scope.predicate = '';
            $scope.reverse = false;
            $scope.orderByFila = {
                column: "Posicao",
                order: "Asc",
            };
            $scope.GrupoId = 0;

            $scope.periodoConsultaRoboCall = [
                { Descricao: $translate.instant('modalRoboCall.ultimaHora'), Valor: 60 },
                { Descricao: $translate.instant('modalRoboCall.hoje'), Valor: moment().hours() * 60 + moment().minutes() },
            ];

            let tempo = 10000;
            var scopeDestroyed = false;
            var timeoutSelecionarGrupo;

            $scope.AtualizaCanais = function () {
                MonitorCampanhaResource.GetMonitorCanaisAgrupadosCampanha().$promise
                    .then((data) => {
                        $scope.canais = data;
                    });
            };

            $scope.OnCarteiraSelecionada = function () {
                $scope.grupoSelecionado = {};
                $scope.grupoSelecionadoId = 0;
                $scope.search.GrupoId = '';
                const gruposFiltrados = $filter('monitorFilterGrupo')($scope.grupos, $scope.search);
                $scope.exibirGrupoSemDados = gruposFiltrados.length == 0;
                $scope.arranjarEventos($scope.ramais);
                AtualizaFilaGrupo();
            }

            $scope.GetGruposPorCarteira = function () {
                return MonitorResource.getGrupos().$promise;
            }

            $scope.tiposDestino = [
                { Id: 2, Descricao: $translate.instant('model.grupo') },
                { Id: 3, Descricao: $translate.instant('model.ramal') }
            ];

            $scope.mensagemAlerta = {
                DestinoTipo: 2,
                DestinoId: null,
                Mensagem: null
            };

            function getDiferenca(dataAtual, dataInicio) {
                let atual = moment(dataAtual);
                let inicial = moment(dataInicio).toDate();
                return atual.diff(inicial, 'seconds');
            };

            LocalStorageService.setItem('DataAtualHub', dataServer.Data);
            LocalStorageService.setItem('DataAtualPagina', dataPagina);

            $scope.diferencaEntreDatas = getDiferenca(dataServer.Data, dataPagina);

            let ramaisByRamalId = {},
                gruposById = {},
                servicosByNumero = {};

            window.moment.locale('pt-BR');

            SupervisaoService.iniciar();
            $scope.isMobile = false;
            $scope.transferenciaConfig = {};
            $scope.SupervisaoService = SupervisaoService;
            $scope.RamalDetalheService = RamalDetalheService;
            $scope.MonitorRamalService = MonitorRamalService;
            $scope.qualificacoes = qualificacoes;
            $scope.servicos = servicos;

            function updateUras(list) {
                for (let i = 0; i < list.length; i++) {
                    list[i].UraNome = (list[i].UraId + ' - ' + list[i].Descricao);
                }
            }

            updateUras(uras);

            $scope.uras = angular.copy(uras);

            function updateGrupos(list) {
                for (let i = 0; i < list.length; i++) {
                    list[i].GrupoNome = (list[i].GrupoId + ' - ' + list[i].Descricao);
                }
            }

            updateGrupos(grupos);

            $scope.grupos = grupos;

            $scope.ramais = ramais;

            _.each(ramais, function (value) {

                value.NomeCompletoFormatado = value.Numero + " - " + value.UsuarioNome;

            });

            MonitorRamalService.quantidadeRamalTotal = $scope.ramais.length;

            $scope.conectado = false;
            $scope.conexaoLenta = false;
            $scope.AlarmeFila = false;
            $scope.AlarmeFilaSonoro = false;
            //$scope.ramalStatusDetalhes = ramalStatusDetalhes;
            $scope.rotasDiscagem = [];

            _.each(rotasMonitoria, function (value) {
                if (value.RotaTipoId != 6) {
                    $scope.rotasDiscagem.push(value);
                }
            });

            /* Indicador Termometro */
            $scope.isFlipped = false;
            $scope.indicadoresGrupo = {};
            $scope.campanhas = [];
            $scope.rotas = [];
            $scope.rotasRoboCall = [];
            $scope.resumoPorClasse = [];
            $scope.resumoPorRota = [];
            $scope.resumoPorRotaPreco = [];
            $scope.resumoStatus = [];
            $scope.resumoInsuessoStatus = [];
            $scope.resumoInsuessoRelease = [];
            /* Graficos */
            $scope.graficoResumoPorClasse = undefined;
            $scope.graficoResumoPorRotaRelease = undefined;
            $scope.graficoResumoPorRotaPreco = undefined;
            /* PopUp Detalhe URA */
            $scope.tipoVisaoURA = 1;
            $scope.orderBy = ['-IsAlarme', 'Ordem', 'Status', 'UsuarioNome'];
            $scope.grupoSelecionado = {};
            $scope.grupoSelecionadoId = 0;

            $scope.GrupoFila = [];

            // criar um dicionario pelo RamalId, para facilitar a atualização dos status de ramal e grupo
            _.each(ramais, function (value) {
                ramaisByRamalId[value.RamalId] = value;
            });

            _.each($scope.grupos, function (value) {
                gruposById[value.RamalId] = value;
            });

            _.each(servicos, function (value) {
                servicosByNumero[value.Numero] = value;
            });       
    

            $scope.isMobile = $window.innerWidth < 480;

            $scope.abaSelecionada = 1;

            $scope.groupByEventos = _.groupBy($scope.ramais, 'Status');

            $scope.ordenacaoTipo = "Asc";
            $scope.ordenacaoAlias = "Status";

            $scope.setOrdenacaoPadrao = function (coluna) {
                if (coluna == 'Status') {
                    $scope.orderBy = ['-IsAlarme', 'Ordem', 'Status', 'UsuarioNome'];
                    $scope.ordenacaoAlias = $translate.instant('campo.status');
                }

                if (coluna == 'Numero') {
                    $scope.orderBy = ['-IsAlarme', 'Numero', 'Status'];
                    $scope.ordenacaoAlias = $translate.instant('model.ramal');
                }

                if (coluna == 'UsuarioNome') {
                    $scope.orderBy = ['-IsAlarme', 'UsuarioNome', 'Status'];
                    $scope.ordenacaoAlias = $translate.instant('campo.nome');
                }

                if (coluna == 'Diferenca') {
                    $scope.orderBy = ['-IsAlarme', 'Diferenca', 'Status', 'UsuarioNome'];
                    $scope.ordenacaoAlias = $translate.instant('campo.tempo');
                }
            };

            $scope.setOrdenacaoIndicador = function (coluna, alias) {
                $scope.ordenacaoTipo = "Desc";
                $scope.ordenacaoAlias = alias;
                $scope.orderBy = ['-IsAlarme', coluna];
            };

            $scope.search = {
                Evento: '',
                Eventos: [],
                Ramal: '',
                GrupoId: '',
                filtroGrupo: '',
                CarteiraId: 0,
                filtroCarteira: ''
            };


            // filtra por ramais que permitem receber chamada
            $scope.ramaisPermitemReceber = function () {
                return true;
                // TODO: StatusDetalhe não está mais vindo no objeto
                // return value && value.StatusDetalhe ? value.StatusDetalhe.RecebeInterno || value.StatusDetalhe.RecebeExterno : false;
            }

            $scope.isAtendimento = function (ramal) {
                if (ramal.NomeIntegracao == "AtendidoChamadaInterna" || ramal.NomeIntegracao == "AtendidoChamadaExterna" ||
                    ramal.NomeIntegracao == "AtendidoChamadaDiscador" || ramal.NomeIntegracao == "AtendidoChamadaExternaEntrante" ||
                    ramal.NomeIntegracao == "AtendidoChamadaExternaSainte" || ramal.NomeIntegracao == "AtendidoChamadaCallback" ||
                    ramal.NomeIntegracao == "AtendidoChamadaDiscadorLigacaoAgendada" || ramal.NomeIntegracao == "AtendidoChamadaInternaEntrante" ||
                    ramal.NomeIntegracao == "AtendidoChamadaInternaSainte") {
                    return true;
                }
                return false;
            }


            $scope.isLogado = function (ramal) {
                if (ramal.NomeIntegracao != "NaoLogado") {
                    return true;
                }
                return false;
            }


            $scope.deslogarRamal = function (ramal) {
                ModalService.confirmMessage('telaMonitor.desejaRealmenteDeslogarORamal', null, function () {
                    SupervisaoService.deslogarRamal(ramal).catch(function (err) {
                        let mensagem = `${$translate.instant('telaMonitor.naoFoiPossivelDesligarAChamada')}: ${(err && err.message ? err.message :
                            $translate.instant('telaMonitor.erroAoEnviarComandoParaOServidor'))}`;
                        NotifyService.showError(null, mensagem);
                    });
                });
            };


            var atualizarFlipCardRamais = function () {
                _.each($scope.ramais, function (item) {
                    item.isFlipped = false;
                });
            };

            var pausarAlarmeSonoro = function () {
                if ($("#alarmeSonoro")[0]) {
                    $("#alarmeSonoro")[0].pause();
                }
            };

            $scope.apenasGruposRelevantes = true;
            $scope.alternarVisaoGrupos = function () {
                $scope.apenasGruposRelevantes = !$scope.apenasGruposRelevantes;
                if (!$scope.apenasGruposRelevantes) {
                    $scope.limiteGrupo = null;
                } else {
                    $scope.limiteGrupo = $scope.limiteGrupoRelevante;
                }
            }

            $scope.apenasCarteirasRelevantes = true;
            $scope.limiteCarteira = 3;
            $scope.alternarVisaoCarteiras = function () {
                $scope.apenasCarteirasRelevantes = !$scope.apenasCarteirasRelevantes;
                if (!$scope.apenasCarteirasRelevantes) {
                    $scope.limiteCarteira = null;
                } else {
                    $scope.limiteCarteira = $scope.minimoCarteirasVisiveis;
                }
            }

            $scope.fixarGrupo = function ($event, grupo) {
                if (!grupo.Fixado) {
                    $scope.adicionarGrupoFixado(grupo.GrupoId);
                } else {
                    $scope.removerGrupoFixado(grupo.GrupoId);
                }
                $scope.setOrdenacaoGrupo();
                $event.stopPropagation();
            }

            $scope.adicionarGrupoFixado = function (grupoId) {
                let gruposFixados = LocalStorageService.getItem('MonitorGruposFixados');
                if (!Array.isArray(gruposFixados)) gruposFixados = [];
                let indexGrupo = gruposFixados.indexOf(grupoId);
                if (indexGrupo == -1) {
                    gruposFixados.push(grupoId);
                }
                LocalStorageService.setItem('MonitorGruposFixados', gruposFixados);
            }

            $scope.removerGrupoFixado = function (grupoId) {
                let gruposFixados = LocalStorageService.getItem('MonitorGruposFixados');
                if (!Array.isArray(gruposFixados)) gruposFixados = [];
                let indexGrupo = gruposFixados.indexOf(grupoId);
                if (indexGrupo != -1) {
                    gruposFixados.splice(indexGrupo, 1);
                }
                LocalStorageService.setItem('MonitorGruposFixados', gruposFixados);
            }

            $scope.minimoGruposVisiveis = 4;
            $scope.minimoCarteirasVisiveis = 3;

            $scope.setOrdenacaoGrupo = function () {
                let gruposFixados = LocalStorageService.getItem('MonitorGruposFixados');
                if (Array.isArray(gruposFixados)) {
                    $scope.grupos.forEach((el) => {
                        const index = gruposFixados.indexOf(el.GrupoId);
                        el.Fixado = index >= 0;
                    });
                    gruposFixados = _.filter(gruposFixados, (fxId) => {
                        return _.find($scope.grupos, (gr) => {
                            return gr.GrupoId == fxId;
                        }) != null;
                    });
                } else {
                    gruposFixados = [];
                }


                if (gruposFixados.length < 4) {
                    $scope.limiteGrupoRelevante = 3;
                } else {
                    $scope.limiteGrupoRelevante = gruposFixados.length;
                }

                if (!$scope.apenasGruposRelevantes) {
                    $scope.limiteGrupo = null;
                } else {
                    $scope.limiteGrupo = $scope.grupos.length > $scope.minimoGruposVisiveis ? $scope.limiteGrupoRelevante : $scope.grupos.length;
                }

                $scope.grupos.sort((a, b) => {
                    if (a.Fixado === b.Fixado) {
                        return a.DescricaoFormatada > b.DescricaoFormatada ? 1 : -1;
                    }
                    return a.Fixado == true ? -1 : 1;
                });
            }
            $scope.setOrdenacaoGrupo();

            $scope.arranjarEventos = function (ramais) {
                const listaRamais = $filter('monitorFilter')(ramais, $scope.search, $scope.orderBy, $scope.ordenacaoTipo, $scope.grupos, true);
                const eventosAgrupados = _.groupBy(listaRamais, 'Status');

                for (const key in $scope.groupByEventos) {
                    if ($scope.groupByEventos.hasOwnProperty(key)) {
                        if (eventosAgrupados[key] != null) {
                            $scope.groupByEventos[key] = eventosAgrupados[key];
                        } else {
                            $scope.groupByEventos[key] = [];
                        }
                    }
                }
                for (const key in eventosAgrupados) {
                    if (eventosAgrupados.hasOwnProperty(key)) {
                        if ($scope.groupByEventos[key] == null) {
                            $scope.groupByEventos[key] = eventosAgrupados[key];
                        }
                    }
                }
            }

            $scope.filtrarTodasCarteiras = function () {
                $scope.search.CarteiraId = 0;
                $scope.OnCarteiraSelecionada();
                AtualizaFilaGrupo();
            }

            $scope.filtrarTodosRamais = function () {
                LocalStorageService.setItem('MonitorGrupo', 0);

                $scope.search = {
                    Evento: '',
                    Eventos: [],
                    Ramal: '',
                    GrupoId: '',
                    filtroGrupo: '',
                    CarteiraId: $scope.search.CarteiraId,
                    filtroCarteira: ''
                };
                $scope.arranjarEventos($scope.ramais);


                $scope.grupoSelecionado = {};
                $scope.grupoSelecionadoId = 0;

                AtualizaFilaGrupo()
                $rootScope.$broadcast('onGrupoNaoSelecionado', {});
                atualizarFlipCardRamais();
                //listarRamais();
            };

            $scope.filtrarTodosRamaisDoGrupo = function () {
                $scope.search.Evento = '';
                $scope.search.Eventos = [];
                let ramais = filtrarRamaisPorGrupo();
                MonitorRamalService.quantidadeRamalTotal = ramais.length;
                if ($scope.grupoSelecionado) {
                    setTimeout(function () {
                        if (scopeDestroyed) return;
                        $rootScope.$broadcast('onGrupoSelecionado', $scope.grupoSelecionado);
                    }, 0)
                }
            };

            $scope.indicadoresFavoritos = [];

            var getIndicadoresFavoritos = function (grupoId) {
                $http.get(Config.getUrl('Monitor/Indicador/' + grupoId)).then(function (response) {
                    $scope.indicadoresFavoritos = response.data;
                });
            };

            $scope.filtroEvento = function (evento, $event) {
                // Ctrl para multi-seleção; sem Ctrl seleciona único
                if ($event && $event.ctrlKey) {
                    if (!Array.isArray($scope.search.Eventos)) $scope.search.Eventos = [];
                    const idx = $scope.search.Eventos.indexOf(evento);
                    if (idx === -1) {
                        $scope.search.Eventos.push(evento);
                    } else {
                        $scope.search.Eventos.splice(idx, 1);
                    }
                } else {
                    $scope.search.Eventos = [evento];
                }

                // Atualiza contagem
                if (Array.isArray($scope.search.Eventos) && $scope.search.Eventos.length > 0) {
                    let total = 0;
                    const vistos = {};
                    $scope.search.Eventos.forEach(function (ev) {
                        const lista = $scope.groupByEventos[ev] || [];
                        lista.forEach(function (r) { if (!vistos[r.RamalId]) { vistos[r.RamalId] = true; total++; } });
                    });
                    MonitorRamalService.quantidadeRamalTotal = total;
                } else {
                    MonitorRamalService.quantidadeRamalTotal = $scope.ramais.length;
                }
            };
            //$scope.filtroEvento("Não Logado");

            var filtrarRamaisPorGrupo = function () {
                //Filtrar ramais do grupo e atualizar os status
                let ramaisFiltrados = _.filter($scope.ramais, function (ramal) {
                    let result = true;
                    if (ramal.Grupos) {
                        result = ramal.Grupos.indexOf(parseInt($scope.search.GrupoId)) > -1;
                    }
                    return result;
                });

                return ramaisFiltrados;
            };

            $scope.filtrarPorCarteira = function (c) {
                $scope.search.CarteiraId = c.Id;
                $scope.OnCarteiraSelecionada();
                AtualizaFilaGrupo()
            }
            $scope.filtrarPorGrupo = function (g) {
                if (g == undefined) return;

                LocalStorageService.setItem('MonitorGrupo', g.GrupoId);
                $scope.search.GrupoId = g.GrupoId;
                $scope.search.Evento = '';
                $scope.search.Eventos = [];
                $scope.grupoSelecionado = g;
                $scope.grupoSelecionadoId = g.GrupoId;
                getIndicadoresFavoritos(g.GrupoId);
                AtualizaFilaGrupo();

                //Buscar indicadores do grupo para caso de nao receber o broadcast dos indicadores
                if (!IndicadorService.grupos[g.GrupoId] && (typeof IndicadorService.grupos[g.GrupoId] != 'undefined')) {
                    $http.get(Config.getUrl('Grupo/Indicador/' + g.GrupoId)).then(function (response) {
                        if (response.data) {
                            if (response.data.GrupoId > 0) {
                                IndicadorService.grupos[g.GrupoId] = response.data;
                                setTimeout(function () {
                                    if (scopeDestroyed) return;
                                    $rootScope.$broadcast('onGrupoSelecionado', g);
                                }, 0)
                            }
                        }
                    });
                } else {
                    setTimeout(function () {
                        if (scopeDestroyed) return;
                        $rootScope.$broadcast('onGrupoSelecionado', g);
                    }, 0)
                }
                let ramais = filtrarRamaisPorGrupo();
                $scope.arranjarEventos(ramais);
                MonitorRamalService.quantidadeRamalTotal = ramais.length;
            };

            $scope.alternarVisaoRamais = function (visaoId) {
                if (visaoId == 1) $scope.alterarVisaoRamais(2);
                else $scope.alterarVisaoRamais(1);
            }

            $scope.alterarVisaoRamais = function (visaoId) {
                LocalStorageService.setItem('VisaoRamais', visaoId);
                $scope.tipoVisualizacao = visaoId;
            }

            let visaoRamaisStorage = LocalStorageService.getItem('VisaoRamais');
            if (visaoRamaisStorage == null || isNaN(visaoRamaisStorage)) {
                visaoRamaisStorage = 1;
            }
            $scope.alterarVisaoRamais(visaoRamaisStorage);

            $scope.$on("onGrupoChanged", function () {
                $scope.GetGruposPorCarteira().then(function (grupos) {
                    _.each(grupos, function (grupo) {
                        let existeGrupo = gruposById[grupo.RamalId];
                        if (existeGrupo) {
                            existeGrupo.Descricao = grupo.Descricao;
                            existeGrupo.DescricaoFormatada = grupo.DescricaoFormatada;
                            existeGrupo.TotalRamais = grupo.TotalRamais;
                        }
                    });
                });

                MonitorResource.getRamais().$promise.then(function (ramais) {
                    _.each(ramais, function (ramal) {
                        let existeRamal = ramaisByRamalId[ramal.RamalId];
                        if (existeRamal) {
                            existeRamal.Grupos = ramal.Grupos;
                            existeRamal.UsuarioNome = ramal.UsuarioNome;
                            existeRamal.UsuarioNomeFormatado = ramal.UsuarioNomeFormatado;
                        }
                    });
                });
            });

            $scope.ativarPesquisaRamal = function () {
                $scope.pesquisaRamais = true;
                $timeout(function () {
                    $('#txtPesquisaRamal').focus();
                }, 100);
            }
            $scope.desativarPesquisaRamal = function (event) {
                if (event.target.value == null || event.target.value == '') {
                    $scope.pesquisaRamais = false;
                    $scope.search.Ramal = '';
                }
            }

            $scope.pesquisaGrupos = false;
            $scope.ativarPesquisaGrupo = function () {
                $scope.pesquisaGrupos = true;
                $timeout(function () {
                    $('#txtPesquisaGrupo').focus();
                }, 100);
            }
            $scope.desativarPesquisaGrupo = function (event) {
                if (event.target.value == null || event.target.value == '') {
                    $scope.pesquisaGrupos = false;
                    $scope.search.filtroGrupo = '';
                }
            }

            $scope.pesquisaCarteira = false;
            $scope.ativarPesquisaCarteira = function () {
                $scope.pesquisaCarteira = true;
                $timeout(function () {
                    $('#txtPesquisaCarteira').focus();
                }, 100);
            }
            $scope.desativarPesquisaCarteira = function (event) {
                if (event.target.value == null || event.target.value == '') {
                    $scope.pesquisaCarteira = false;
                    $scope.search.filtroCarteira = '';
                }
            }

            $scope.$on("onRamalEventoChanged", function (event, data) {
                $scope.conectado = true;
                if (!data) return;

                let ramal = ramaisByRamalId[data.RamalId];
                if (!ramal) return;

                /* Cancela alarme quando o ramal muda de status */
                if (ramal.Status != data.Status) {
                    ramal.IsAlarme = false;
                    ramal.AlarmeGrupoDescricao = null;
                }

                let isEvento = data.RamalEventoId > 0;

                if (isEvento) {
                    // eslint-disable-next-line no-console
                    // console.log('RamalEvento RamalId: ' + data.RamalId + ' Evento: ' + data.RamalEventoId);
                } else {
                    // eslint-disable-next-line no-console
                    // console.log('RamalEvento RamalId: ' + data.RamalId + ' Status: ' + data.RamalStatusDetalheId);
                }

                ramal.RamalEventoId = data.RamalEventoId;
                ramal.RamalStatusDetalheId = data.RamalStatusDetalheId;
                ramal.Status = data.Status;
                ramal.NomeIntegracao = data.Descricao;
                ramal.Cor = data.Cor;
                ramal.Ordem = data.Ordem;
                ramal.DataInicio = data.DataInicio;
                ramal.Diferenca = 0;
                ramal.NA = data.NA;
                ramal.NB = data.NB;
                ramal.CampanhaId = data.CampanhaId;
                ramal.CampanhaNome = data.CampanhaNome;
                ramal.StatusDetalhe = data.StatusDetalhe || {};
                ramal.IsTabulacao = data.IsTabulacao || false;
                ramal.IsSilencio = false;

                //Atualizar os status considerando o filtro
                if ($scope.search.GrupoId) {
                    let ramaisFiltrados = filtrarRamaisPorGrupo();

                    $scope.arranjarEventos(ramaisFiltrados);
                    MonitorRamalService.quantidadeRamalTotal = ramaisFiltrados.length;

                } else {
                    $scope.arranjarEventos($scope.ramais);
                    MonitorRamalService.quantidadeRamalTotal = $scope.ramais.length;
                }

                if (Array.isArray($scope.search.Eventos) && $scope.search.Eventos.length > 0) {
                    let total = 0; const vistos = {};
                    $scope.search.Eventos.forEach(function (ev) {
                        const lista = $scope.groupByEventos[ev] || [];
                        lista.forEach(function (r) { if (!vistos[r.RamalId]) { vistos[r.RamalId] = true; total++; } });
                    });
                    MonitorRamalService.quantidadeRamalTotal = total;
                }
            });


            var atualizarListaRamalStatus = function (listaRamais) {
                $scope.conectado = true;
                $scope.conexaoLenta = false;
                _.each(listaRamais, function (ramalStatus) {
                    if (ramalStatus.IsGrupo) {
                        // let grupo = gruposById[ramalStatus.RamalId];
                        // if (grupo) {
                        //     grupo.Fila = ramalStatus.ChamadaFila;
                        //     grupo.QuantidadeFila = ramalStatus.QuantidadeFila;
                        //     if (grupo.MaxFila > 0) {
                        //         grupo.AlarmeFila = ramalStatus.QuantidadeFila > grupo.MaxFila ? true : false;
                        //     }
                        // }
                        //totalChamadasEmFila();
                        AtualizaFilaGrupo();
                    } else {
                        let ramal = ramaisByRamalId[ramalStatus.RamalId];
                        if (ramal && ramalStatus.Status) {
                            ramal.Diferenca = getDiferenca(ramalStatus.DataAtual, ramalStatus.DataInicio);
                            ramal.DataInicio = ramalStatus.DataInicio;
                            ramal.RamalEventoId = ramalStatus.RamalEventoId;
                            ramal.RamalStatusDetalheId = ramalStatus.RamalStatusDetalheId;
                            ramal.Status = ramalStatus.Status;
                            ramal.NomeIntegracao = ramalStatus.Descricao;
                            ramal.Cor = ramalStatus.Cor;
                            ramal.Ordem = ramalStatus.Ordem;
                            ramal.NA = ramalStatus.NA;
                            ramal.NB = ramalStatus.NB;
                            ramal.CampanhaId = ramalStatus.CampanhaId;
                            ramal.CampanhaNome = ramalStatus.CampanhaNome;
                            ramal.StatusDetalhe = ramalStatus.StatusDetalhe || {};
                            ramal.IsTabulacao = ramalStatus.IsTabulacao || false;
                            ramal.IsAlarme = ramalStatus.IsAlarme || false;
                            ramal.AlarmeGrupoDescricao = ramalStatus.AlarmeGrupoDescricao || null;
                            ramal.IsSilencio = ramalStatus.IsSilencio || false;
                            ramal.TempoSilencio = ramalStatus.TempoSilencio || 0;
                            ramal.DataSilencio = ramalStatus.DataSilencio || null;
                        }
                    }
                });

                //Atualizar os status considerando o filtro
                if ($scope.search.GrupoId) {
                    let ramaisFiltrados = filtrarRamaisPorGrupo();
                    $scope.arranjarEventos(ramaisFiltrados);
                } else {
                    $scope.arranjarEventos($scope.ramais);
                }
            };

            SupervisaoService.listarRamalStatus().then(atualizarListaRamalStatus).catch(function (ex) {
                $scope.conectado = false;
                // eslint-disable-next-line no-console
                console.error("Não foi possivel usar o metodo listarRamalStatus", ex);
            });


            $scope.playAlarmeFila = function () {
                $scope.mudo = LocalStorageService.getItem('SistemaMudo') === true;
                let audioElem = $("#alarmeSonoroFila")[0];

                if(audioElem)
                {
                    if ($scope.mudo || $scope.forcedPauseFila)
                        audioElem.muted = true;

                    if (audioElem.paused)
                        audioElem.play();
                }
            };

            function pauseAlarmeFila() {
                let audioElem = $("#alarmeSonoroFila")[0];
                if (audioElem) audioElem.pause();
            }

            $scope.forcedPauseFila = false;
            $scope.forcePauseAlarmeFila = function () {
                $scope.AlarmeFila = false;
                $scope.forcedPauseFila = !$scope.forcedPauseFila;
                pauseAlarmeFila();
            }

            $scope.playAlarme = function () {
                $scope.mudo = LocalStorageService.getItem('SistemaMudo') === true;
                let audioElem = $("#alarmeSonoro")[0];

                if(audioElem){

                    if ($scope.mudo)
                        audioElem.muted = true;

                    if (audioElem.paused)
                        audioElem.play();
                }
            };

            function AtualizaFilaGrupo() {
                $scope.AlarmeFila = false;
                $scope.AlarmeFilaSonoro = false;
                pauseAlarmeFila();
                $scope.QuantidadeFila = 0;
                $scope.QuantidadeFilaGrupo = 0;
                $scope.QuantidadeFilaVirtual = 0;

                var filas = $scope.listFila;

                if ($scope.search.CarteiraId > 0) {
                    filas = _.filter($scope.listFila, function (gr) {
                        return gr.CarteiraId == $scope.search.CarteiraId;
                    });
                }

                _.each(filas, function (grupo) {
                    let possuiAlarmeGrupo = grupo.MaxFila > 0;
                    let maxFila = possuiAlarmeGrupo ? grupo.MaxFila : $scope.FilaAlarme.MaxFila;
                    let sonoro = possuiAlarmeGrupo ? grupo.AlarmeSonoro : $scope.FilaAlarme.AlarmeSonoro;

                    if (grupo.QuantidadeFila > 0) {
                        $scope.QuantidadeFila += grupo.QuantidadeFila;
                    }

                    if (grupo.QuantidadeFilaGrupo > 0) {
                        $scope.QuantidadeFilaGrupo += grupo.QuantidadeFilaGrupo;
                    }

                    if (grupo.QuantidadeFilaVirtual > 0) {
                        $scope.QuantidadeFilaVirtual += grupo.QuantidadeFilaVirtual;
                    }

                    if (grupo.QuantidadeFila >= maxFila) {
                        grupo.AlarmeFila = true;
                        $scope.AlarmeFila = true;
                        if (sonoro) {
                            grupo.AlarmeFilaSonoro = true;
                            $scope.AlarmeFilaSonoro = true;
                        }
                    } else {
                        grupo.AlarmeFila = false;
                        grupo.AlarmeFilaSonoro = false;
                    }
                });

                if ($scope.grupoSelecionado.GrupoId > 0) {
                    var g = _.filter($scope.listFila, function (gr) {
                        return gr.GrupoId == $scope.grupoSelecionado.GrupoId;
                    });

                    $scope.AlarmeFila = false;
                    $scope.AlarmeFilaSonoro = false;
                    $scope.QuantidadeFila = 0;
                    $scope.QuantidadeFilaGrupo = 0;
                    $scope.QuantidadeFilaVirtual = 0;

                    if (g.length > 0) {
                        $scope.QuantidadeFila = g[0].QuantidadeFila || 0;
                        $scope.AlarmeFila = g[0].AlarmeFila;
                        $scope.AlarmeFilaSonoro = g[0].AlarmeFilaSonoro;
                    }
                }

                if (!$scope.forcedPauseFila && $scope.AlarmeFila && $scope.AlarmeFilaSonoro) {
                    $scope.playAlarmeFila();
                }
            };


            // function adicionaQuantidadeFilaGrupo(event, chamada, ramalInfo) {
            //     let grupo = gruposById[ramalInfo.RamalId];
            //     if (grupo) {
            //         grupo.Fila = ramalInfo.ChamadaFila;
            //         grupo.QuantidadeFila = ramalInfo.Quantidade || 0;
            //         if (grupo.MaxFila > 0) {
            //             grupo.AlarmeFila = ramalInfo.Quantidade > grupo.MaxFila ? true : false;
            //         }
            //     }
            //     totalChamadasEmFila();
            // };

            // function removeQuantidadeFilaGrupo(event, chamada, ramalInfo) {
            //     let grupo = gruposById[ramalInfo.RamalId];
            //     if (grupo) {
            //         grupo.Fila = ramalInfo.ChamadaFila;
            //         grupo.QuantidadeFila = ramalInfo.Quantidade || 0;
            //         if (grupo.MaxFila > 0) {
            //             grupo.AlarmeFila = ramalInfo.Quantidade < grupo.MaxFila ? false : true;
            //         }
            //     }

            //     totalChamadasEmFila();
            // };

            function ramalEmSilencio(event, ramal) {
                let ramalSilencio = ramaisByRamalId[ramal.RamalId];
                if (ramalSilencio) {
                    ramalSilencio.IsSilencio = true;
                    ramalSilencio.TempoSilencio = ramal.Tempo;
                    ramalSilencio.DataSilencio = ramal.Data;
                }
            };

            // $scope.$on(SUPERVISAO_EVENTS.onChamadaEntrouNaFilaGrupo, adicionaQuantidadeFilaGrupo);
            // $scope.$on(SUPERVISAO_EVENTS.onChamadaSaiuDaFilaGrupo, removeQuantidadeFilaGrupo);
            $scope.$on(SUPERVISAO_EVENTS.onRamalEmSilencio, ramalEmSilencio);

            $scope.getClassAlarmeRamal = function (ramal) {
                if (ramal.IsAlarme) {
                    let estilo = 'md-card-danger';
                    return estilo + " flash animated infinite";
                } else {
                    return "md-card-success";
                }
            };

            $scope.getClassAlameGrid = function (ramal) {
                if (ramal.IsAlarme) {
                    let estilo = {
                        'border': 'solid 3px #b71c1c'
                    };
                    return estilo;
                }
            };

            /* Alarme */
            $scope.$on("onAlarmeCriadoChanged", function (event, data) {
                criarAlarmeParaRamal(data);
                // eslint-disable-next-line no-console
                // console.log('onAlarmeCriadoChanged RamalId: ' + data.RamalId);
            });

            $scope.$on("onAlarmeCanceladoChanged", function (event, data) {
                cancelarAlarmeDoRamal(data);
                // eslint-disable-next-line no-console
                // console.log('onAlarmeCanceladoChanged RamalId: ' + data.RamalId)
            });

            var cancelarAlarmeDoRamal = function (alarme) {
                let ramal = ramaisByRamalId[alarme.RamalId];
                if (ramal) {
                    ramal.IsAlarme = false;
                    ramal.AlarmeGrupoDescricao = null;
                }

                pausarAlarme();
            };

            var cancelarTodosAlarmesDoRamal = function (ramalId) {
                let ramal = ramaisByRamalId[ramalId];
                if (ramal) {
                    ramal.IsAlarme = false;
                    ramal.AlarmeGrupoDescricao = null;
                }

                pausarAlarme();
            };

            var pausarAlarme = function () {
                let ramais = Object.keys(ramaisByRamalId);
                let ramaisComAlarme = ramais.filter(ramalId => {
                    return ramaisByRamalId[ramalId].IsAlarme == true;
                });

                if (ramaisComAlarme.length == 0) {
                    pausarAlarmeSonoro();
                }
            }

            function criarAlarmeParaRamal(alarme) {
                let ramal = ramaisByRamalId[alarme.RamalId];
                if (ramal) {
                    ramal.IsAlarme = true;
                    ramal.AlarmeGrupoDescricao = alarme.GrupoDescricao;
                    setTimeout(() => {
                        if (scopeDestroyed) return;
                        if (ramal.IsAlarme && alarme.AlarmeSonoro) {
                            $scope.playAlarme();
                        }
                    }, 1);
                }
            }

            $scope.detalhe = function (r) {
                DashboardResource.filtrarGrafico({
                    chartId: 18,
                    filtros: {
                        RamalId: r.RamalId
                    }
                }).$promise.then(function (data) {
                    $scope.historioIntervalo = data;
                }).catch(error => {
                    NotifyService.showError();
                    $scope.historioIntervalo = [];                    
                });

                DashboardResource.filtrarGrafico({
                    chartId: 19,
                    filtros: {
                        RamalId: r.RamalId
                    }
                }).$promise.then(function (data) {
                    $scope.intervaloDia = data;
                }).catch(error => {
                    NotifyService.showError();
                    $scope.intervaloDia = [];                    
                });

                DashboardResource.filtrarGrafico({
                    chartId: 20,
                    filtros: {
                        RamalId: r.RamalId
                    }
                }).$promise.then(function (data) {
                    $scope.historicoBilhete = data;
                }).catch(error => {
                    NotifyService.showError();
                    $scope.historicoBilhete = [];                    
                });

                $scope.RamalDetalheService.openModal(r, $scope.grupoSelecionado, $scope.grupos);
            };

            $scope.cancelarAlarme = function (ramal) {
                SupervisaoService.cancelarAlarme(ramal.UsuarioId, ramal.Numero)
                    .then(() => {
                        NotifyService.showSuccess('telaMonitor.alarmeCancelado');
                    }).catch(function (error) {
                        NotifyService.showSuccess('telaMonitor.alarmeCancelado');
                        NotifyService.showError();
                        // eslint-disable-next-line no-console
                        // console.log("Erro ao Cancelar Alarme:" + error);
                    });
                cancelarTodosAlarmesDoRamal(ramal.RamalId);
            };



            $scope.conferencia = function (ramalNumero) {

                SupervisaoService.conferencia(ramalNumero);
            };

            $scope.ouvirChamada = function (ramalNumero) {

                SupervisaoService.ouvirChamada(ramalNumero);
            };

            $scope.sopro = function (ramalNumero) {

                SupervisaoService.sopro(ramalNumero);
            };

            $scope.$on('$destroy', function controllerMonitorDestroy() {

                pausarAlarmeSonoro();

                scopeDestroyed = true;

                if (intervalAtualizaFila) { $interval.cancel(intervalAtualizaFila); intervalAtualizaFila = null; }
                if (intervalAtualizaAlarmeRoboCall) { $interval.cancel(intervalAtualizaAlarmeRoboCall); intervalAtualizaAlarmeRoboCall = null; }
                if (token) { $interval.cancel(token); token = null; }
                if (timeoutListarRamais) { clearTimeout(timeoutListarRamais); timeoutListarRamais = null; }
                if (timeoutSelecionarGrupo) { clearTimeout(timeoutSelecionarGrupo); timeoutSelecionarGrupo = null; }

                if (SupervisaoService.isChamadaAtiva && SupervisaoService.ramalMonitoria > 0) {
                    SupervisaoService.encerrarMonitoracao(SupervisaoService.ramalMonitoria).then(function () {
                        SupervisaoService.isChamadaAtiva = false;
                    });
                }

                document.removeEventListener('visibilitychange', abaNavegadorAlterada);

                $('#modal_card_ligacao_entrante').off('show.uk.modal hide.uk.modal');
                $('#modal_card_ligacao_sainte').off('show.uk.modal hide.uk.modal');
                $('#modal_alarme').off('show.uk.modal');
                $('#modal_metrica').off('show.uk.modal');
                $('#modal_gerenciar_fila').off('show.uk.modal');
            });

            $scope.$on("RamalDetalheService-Intervalo", function (event, intervalo) {
                /* CardRamal */
                let buttonIntervalo = $("#buttonIntervalo-r" + intervalo.Ramal);
                let divIntervalo = $("#divIntervalo-r" + intervalo.Ramal);
                divIntervalo.removeClass("uk-dropdown-active");
                divIntervalo.removeClass("uk-dropdown-shown");
                divIntervalo.attr("style", "min-width: 200px; top: 35px; left: 0px;");
                setTimeout(function () {
                    if (scopeDestroyed) return;
                    buttonIntervalo.removeClass("uk-open");
                }, 1)

                /* Toolbar */
                let buttonIntervaloToolbar = $("#buttonIntervaloToolbar");
                let divIntervaloToolbar = $("#divIntervaloToolbar");
                divIntervaloToolbar.removeClass("uk-dropdown-active");
                divIntervaloToolbar.removeClass("uk-dropdown-shown");
                divIntervaloToolbar.attr("style", "min-width: 200px; top: 35px; left: 0px;");
                setTimeout(function () {
                    if (scopeDestroyed) return;
                    buttonIntervaloToolbar.removeClass("uk-open");
                }, 1)
                NotifyService.showSuccess('telaMonitor.intervaloAdicionadoComSucesso');
            });

            /* Desligar Chamada */
            $scope.desligarConfirm = function (r) {
                ModalService.confirmMessage('telaMonitor.desejaRealmenteDesligarAChamada', null, function () {
                    SupervisaoService.desligarChamada(r.Numero).catch(function (err) {
                        let mensagem = `${$translate.instant('telaMonitor.naoFoiPossivelDesligarAChamada')}: ${(err && err.message ? err.message :
                            $translate.instant('telaMonitor.erroAoEnviarComandoParaOServidor'))}`;
                        NotifyService.showError(null, mensagem);
                    });
                });
            };

            $scope.transferirChamadaFila = function (chamada) {
                $scope.transferenciaConfig.transferenciaAtiva = chamada;
            }

            $scope.transferirChamadaFilaConfirm = function (transferenciaAtiva, ramalDestino) {
                SupervisaoService.transferirChamadaEmFila(transferenciaAtiva.Canal, ramalDestino.Numero).catch(function (err) {
                    let mensagem = `${$translate.instant('telaMonitor.naoFoiPossivelRealizarATransferencia')}: ${(err && err.message ? err.message :
                        $translate.instant('telaMonitor.erroAoEnviarComandoParaOServidor'))}`;
                    NotifyService.showError(null, mensagem);
                });
            }

            $scope.$on("onIndicadorGrupoChanged", function (event, grupos) {
                _.each(grupos, function (value) {
                    IndicadorService.grupos[value.GrupoId] = value;
                });
                if ($scope.grupoSelecionadoId) {
                    let grupo = IndicadorService.grupos[$scope.grupoSelecionadoId];
                    if (grupo) {
                        $rootScope.$broadcast('onGrupoSelecionado', grupo);
                    }
                }
            });

            $scope.flippedAll = function () {
                let flip = !$scope.isFlipped;
                _.each($scope.ramais, function (item) {
                    item.isFlipped = flip;
                });
                $scope.isFlipped = flip;
            };

            $scope.simularMetrica = function (metrica) {
                var checkInvert, qualModel, ultimoMetrica, i, dataI, dataF;

                ModalService.isHidden('modal_simular_metrica', function () {
                    $scope.metricaSelecionada = angular.copy(metrica);
                    if ($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].Valor) {
                        checkInvert = (parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].Valor) > parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Valor));
                        for (i = 0; i <= $scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1; i++) {
                            qualModel = $scope.metricaSelecionada.IndicadorMetricaQualificacao[i];
                            if (checkInvert) {
                                qualModel.ValorInicial = qualModel.Valor < 0.01 ? 0.01 : qualModel.Valor;
                                qualModel.ValorFinal = (i + 1) >= $scope.metricaSelecionada.IndicadorMetricaQualificacao.length ? 0.01 : parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[i + 1].Valor) + 0.01;
                            } else {
                                qualModel.ValorInicial = (i - 1) < 0 ? 0.01 : parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[i - 1].Valor) + 0.01;
                                qualModel.ValorFinal = qualModel.Valor;
                            }

                            qualModel.IndicadorQualificacao = _.find($scope.qualificacoes, function (el) {
                                return el.IndicadorQualificacaoId == qualModel.IndicadorQualificacaoId;
                            });
                        }
                        ultimoMetrica = $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1];
                        if (ultimoMetrica.ValorInicial != -1 && ultimoMetrica.ValorFinal != -1) {
                            $scope.metricaSelecionada.IndicadorMetricaQualificacao.push({
                                IndicadorQualificacao: {
                                    Descricao: 'Péssimo',
                                    Peso: 0
                                }
                            });
                            if (checkInvert) {
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorInicial = parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].Valor) + 0.01;
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorFinal = 0;
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Inverte = true;
                            } else {
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorInicial = parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 2].Valor) + 0.01;
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorFinal = 0;
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Inverte = true;
                            }
                        }
                    } else {
                        checkInvert = ($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].ValorData > $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorData);
                        for (i = 0; i <= $scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1; i++) {
                            qualModel = $scope.metricaSelecionada.IndicadorMetricaQualificacao[i];
                            if (checkInvert) {
                                //ValorInicial
                                if (qualModel.ValorData.getHours() == 0 && qualModel.ValorData.getMinutes() == 0 && qualModel.ValorData.getSeconds() < 1) {
                                    qualModel.ValorInicial = new Date();
                                    qualModel.ValorInicial.setHours(0);
                                    qualModel.ValorInicial.setMinutes(0);
                                    qualModel.ValorInicial.setSeconds(1);
                                } else {
                                    qualModel.ValorInicial = angular.copy(qualModel.ValorData);
                                }
                                //ValorFinal
                                if ((i + 1) >= $scope.metricaSelecionada.IndicadorMetricaQualificacao.length) {
                                    qualModel.ValorFinal = new Date();
                                    qualModel.ValorFinal.setHours(0);
                                    qualModel.ValorFinal.setMinutes(0);
                                    qualModel.ValorFinal.setSeconds(1);
                                } else {
                                    qualModel.ValorFinal = angular.copy($scope.metricaSelecionada.IndicadorMetricaQualificacao[i + 1].ValorData);
                                    qualModel.ValorFinal.setSeconds(qualModel.ValorFinal.getSeconds() + 1);
                                }
                            } else {
                                //ValorInicial
                                if ((i - 1) < 0) {
                                    qualModel.ValorInicial = new Date();
                                    qualModel.ValorInicial.setHours(0);
                                    qualModel.ValorInicial.setMinutes(0);
                                    qualModel.ValorInicial.setSeconds(1);
                                } else {
                                    qualModel.ValorInicial = angular.copy($scope.metricaSelecionada.IndicadorMetricaQualificacao[i - 1].ValorData);
                                    qualModel.ValorInicial.setSeconds(qualModel.ValorInicial.getSeconds() + 1);
                                }
                                //ValorFinal
                                qualModel.ValorFinal = angular.copy(qualModel.ValorData);
                            }

                            qualModel.IndicadorQualificacao = _.find($scope.qualificacoes, function (el) {
                                return el.IndicadorQualificacaoId == qualModel.IndicadorQualificacaoId;
                            });
                        }
                        ultimoMetrica = $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1];
                        if (ultimoMetrica.ValorInicial != -1 && ultimoMetrica.ValorFinal != -1) {
                            $scope.metricaSelecionada.IndicadorMetricaQualificacao.push({
                                IndicadorQualificacao: {
                                    Descricao: 'Péssimo',
                                    Peso: 0
                                }
                            });
                            if ($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].Valor) {
                                if (checkInvert) {
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorInicial = parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].Valor) + 0.01;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorFinal = 0;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Inverte = true;
                                } else {
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorInicial = parseInt($scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 2].Valor) + 0.01;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorFinal = 0;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Inverte = true;
                                }
                            } else {
                                $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorData = new Date();
                                if (checkInvert) {
                                    dataI = angular.copy($scope.metricaSelecionada.IndicadorMetricaQualificacao[0].ValorData);
                                    dataI.setSeconds(dataI.getSeconds() + 1);
                                    dataF = new Date();
                                    dataF.setHours(0);
                                    dataF.setMinutes(0);
                                    dataF.setSeconds(0);

                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorInicial = dataI;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorFinal = dataF;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Inverte = true;
                                } else {
                                    dataI = angular.copy($scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 2].ValorData);
                                    dataI.setSeconds(dataI.getSeconds() + 1);
                                    dataF = new Date();
                                    dataF.setHours(0);
                                    dataF.setMinutes(0);
                                    dataF.setSeconds(0);
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorInicial = dataI;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].ValorFinal = dataF;
                                    $scope.metricaSelecionada.IndicadorMetricaQualificacao[$scope.metricaSelecionada.IndicadorMetricaQualificacao.length - 1].Inverte = true;
                                }
                            }
                        }
                    }
                    ModalService.openModal('modal_simular_metrica', null, function () {
                        ModalService.openModal('modal_metrica', null, function () {
                            var tabs = UIkit.tab("#tab-metrica");
                            $scope.selectedTab = tabs.switcher.index;
                        });
                    });
                }, null, false)
            };

            $scope.selectedTab = 0;

            /* Reconexão supervisão */
            var listarRamais, timeoutListarRamais;
            listarRamais = function () {
                // não executar se o scope já foi destruido, ou se já houver outra requisição em andamento
                if (scopeDestroyed || timeoutListarRamais) return;

                timeoutListarRamais = setTimeout(function () {
                    SupervisaoService.listarRamalStatus()
                        .then(function () { timeoutListarRamais = clearTimeout(timeoutListarRamais); })
                        .then(atualizarListaRamalStatus)
                        .catch(function (ex) {
                            $scope.conectado = false;
                            // eslint-disable-next-line no-console
                            console.error("Não foi possivel usar o metodo listarRamalStatus", ex);
                            timeoutListarRamais = setTimeout(function () {
                                timeoutListarRamais = clearTimeout(timeoutListarRamais);
                                listarRamais();
                            }, 10000);
                        });
                }, 100);
            };

            $scope.$on(SUPERVISAO_EVENTS.onSupervisaoDesconectado, function () {
                $scope.conectado = false;
            });

            $scope.$on(SUPERVISAO_EVENTS.onSupervisaoConectado, function () {
                listarRamais();
            });

            var recarregando = false;
            var recarregaPagina = function () {
                if (recarregando || scopeDestroyed) return;
                recarregando = true;
                window.location.reload();
            };


            /* Reconexão signalr */
            $scope.$on(SIGNALR_EVENTS.connected, function () {
                $scope.conectado = true;
                listarRamais();
            });

            $scope.$on(SIGNALR_EVENTS.reconnected, function () {
                $scope.conectado = true;
                listarRamais();
            });

            $scope.$on(SIGNALR_EVENTS.disconnected, function () {
                $scope.conectado = false;

                setTimeout(function () {
                    recarregaPagina();
                }, 100)
            });

            $scope.$on(SIGNALR_EVENTS.connectionSlow, function () {
                $scope.conexaoLenta = true;

                setTimeout(function () {
                    recarregaPagina();
                }, 100)
            });

            /* Indicador Ligação Entrante */

            $scope.visoesEntrante = [{
                Descricao: $translate.instant('model.grupo'),
                VisaoId: 1
            }, {
                Descricao: $translate.instant('model.ura'),
                VisaoId: 2
            }];

            $scope.indicadorLigacaoEntrante = {};

            $scope.filtroIndicadorLigacaoEntrante = {
                UraId: [],
                GrupoId: _.pluck(grupos, 'GrupoId'),
                Tempo: 3,
                VisaoId: 1
            };

            $scope.getIndicadorLigacaoEntrante = function () {
                var filtro = {
                    GrupoId: $scope.filtroIndicadorLigacaoEntrante.GrupoId ? $scope.filtroIndicadorLigacaoEntrante.GrupoId.join(",") : [],
                    UraId: $scope.filtroIndicadorLigacaoEntrante.UraId ? $scope.filtroIndicadorLigacaoEntrante.UraId.join(",") : [],
                    Tempo: calculaPeriodoSelecionado($scope.filtroIndicadorLigacaoEntrante.Tempo),
                    VisaoId: $scope.filtroIndicadorLigacaoEntrante.VisaoId
                };

                $http({
                    url: Config.getUrl('Monitor/IndicadorLigacaoEntrante'),
                    method: "GET",
                    params: filtro
                }).then(function (response) {
                    $scope.indicadorLigacaoEntrante = response.data;
                });

            };

            $('#modal_card_ligacao_entrante').on({
                'show.uk.modal': function () {
                    $scope.indicadorLigacaoEntrante = {};
                    $scope.filtroIndicadorLigacaoEntrante.GrupoId = [($scope.grupoSelecionadoId || 0)];
                    $scope.getIndicadorLigacaoEntrante();
                },
                'hide.uk.modal': function () {
                    $scope.indicadorLigacaoEntrante = {};
                }
            });

            /* Indicador Ligação Sainte */
            $scope.indicadorLigacaoSainte = {};

            $scope.filtroIndicadorLigacaoSainte = {
                GrupoId: undefined,
                CampanhaId: '',
                RotaId: '',
                Tempo: 3,
                Visao: 1
            };

            $scope.filtroSainte = {
                GrupoId: 0,
                CampanhaId: '',
                RotaId: '',
                Tempo: 60,
                Visao: 1
            }

            $scope.getIndicadorLigacaoSainte = function () {
                if ($scope.filtroIndicadorLigacaoSainte.GrupoId > 0) {
                    $http({
                        url: Config.getUrl('Monitor/IndicadorLigacaoSainte'),
                        method: "GET",
                        params: $scope.filtroSainte
                    }).then(function (response) {
                        // eslint-disable-next-line no-console
                        // console.warn(response.data);
                        $scope.indicadorLigacaoSainte = response.data;
                    });
                }
            };

            var getRotas = function () {
                $http.get(Config.getUrl('Rota')).then(function (response) {
                    $scope.rotas = $filter('filter')(response.data, { RotaTipoId: 6 }, function (rotaTipo, talkbot) {
                        return rotaTipo !== talkbot;
                    });

                    $scope.rotasRoboCall = $scope.rotas;
                });
            };

            getRotas();

            $scope.getCampanhasByGrupoId = function () {
                let grupo = $scope.filtroIndicadorLigacaoSainte.GrupoId || 0;

                if (grupo > 0) {
                    $http.get(Config.getUrl('Campanha/CampanhasPorGrupo/' + grupo)).then(function (response) {
                        $scope.campanhas = response.data;
                        $scope.filtroIndicadorLigacaoSainte.CampanhaId = _.pluck($scope.campanhas, 'CampanhaId');
                    });
                }
            };


            $scope.verificarHistorico = function (cliente) {
                $state.go('main.campanhahistorico.list', {
                    search: {
                        NB: cliente.Telefone
                    }
                });
            };


            $scope.dateFormatBlacklistOptions = {
                format: TranslateService.getAngularDateFormat()
            };

            $scope.adicionarBlacklistTemporaria = function (cliente) {
                $scope.blacklistTemporaria = angular.copy(cliente);
                ModalService.openModal('modal_blacklist_temporaria');
            };

            $scope.fecharBlacklistTemporaria = function () {
                $scope.blacklistTemporaria = null;
                ModalService.openModal('modal_blacklist_temporaria');
            };

            $scope.$on('onGrupoRamalAlterado', function () {
                $scope.GetGruposPorCarteira().then(function (grupos) {
                    _.each(grupos, function (grupo) {
                        let existeGrupo = gruposById[grupo.RamalId];
                        if (existeGrupo) {
                            existeGrupo.Descricao = grupo.Descricao;
                            existeGrupo.DescricaoFormatada = grupo.DescricaoFormatada;
                            existeGrupo.TotalRamais = grupo.TotalRamais;
                        }
                    });
                });
                MonitorResource.getRamais().$promise.then(function (ramais) {
                    _.each(ramais, function (ramal) {
                        let existeRamal = ramaisByRamalId[ramal.RamalId];
                        if (existeRamal) {
                            existeRamal.Grupos = ramal.Grupos;
                            existeRamal.UsuarioNome = ramal.UsuarioNome;
                            existeRamal.UsuarioNomeFormatado = ramal.UsuarioNomeFormatado;
                        }
                    });
                });
            });

            $scope.gerenciarGrupos = function () {
                ModalService.isHidden('modal_gerenciar_grupo', function () {
                    $rootScope.$broadcast('onLimparGerenciaGrupo');
                })
            };

            $scope.controleIntervalos = function () {
                ModalService.isHidden('modal_controle_intervalo', function () {
                    $rootScope.$broadcast('onLimparControleIntervalo');
                })
            };

            $scope.getFilaGrupo = function () {
                var filaGrupo = $scope.listFila;

                if ($scope.search.CarteiraId > 0) {
                    filaGrupo = _.filter($scope.listFila, function (g) {
                        return g.CarteiraId == $scope.search.CarteiraId;
                    });
                }

                if ($scope.grupoSelecionadoId > 0) {
                    filaGrupo = _.filter($scope.listFila, function (g) {
                        return g.GrupoId == $scope.search.GrupoId;
                    });
                }

                return filaGrupo;
            };


            $scope.salvarBlacklistTemporaria = function salvar() {
                if (!$scope.blacklistTemporaria || !$scope.blacklistTemporaria.Telefone || $scope.blacklistTemporaria.Telefone == '' ||
                    !$scope.blacklistTemporaria.DataInicio || !$scope.blacklistTemporaria.DataTermino) {
                    NotifyService.showInvalid();
                    return;
                }
                $scope.blacklistTemporaria.Numero = $scope.blacklistTemporaria.Telefone;
                BlacklistTemporariaResource.save($scope.blacklistTemporaria).$promise
                    .then((response) => {
                        let mensagem = response.Mensagem != null ? mensagem = response.Mensagem : mensagem = 'telaMonitor.bloqueioSalvo';
                        NotifyService.showSuccess(mensagem)
                        $scope.fecharBlacklistTemporaria();
                    }).catch((error) => NotifyService.showError(error, 'telaMonitor.bloqueioSalvo'));
            };

            $scope.pesquisarEfetuandoChamada = function () {
                $scope.filtroSainte = {
                    GrupoId: $scope.filtroIndicadorLigacaoSainte.GrupoId,
                    CampanhaId: $scope.filtroIndicadorLigacaoSainte.CampanhaId ? $scope.filtroIndicadorLigacaoSainte.CampanhaId.join() : '',
                    RotaId: $scope.filtroIndicadorLigacaoSainte.RotaId.length > 0 ? $scope.filtroIndicadorLigacaoSainte.RotaId.join() : '',
                    Tempo: calculaPeriodoSelecionado($scope.filtroIndicadorLigacaoSainte.Tempo)
                };

                $scope.getIndicadorLigacaoSainte();
            };

            $('#modal_card_ligacao_sainte').on({
                'show.uk.modal': function () {
                    $scope.intervalOnline = $interval(function () {
                        $scope.AtualizaCanais();
                    }, tempo);

                    if (Array.isArray($scope.grupoSelecionadoId) || $scope.grupoSelecionadoId == 0) {
                        $scope.filtroIndicadorLigacaoSainte.GrupoId = 0;
                        $scope.filtroIndicadorLigacaoSainte.CampanhaId = [];
                        $scope.filtroIndicadorLigacaoSainte.RotaId = '';
                        $scope.filtroIndicadorLigacaoSainte.Tempo = 3;
                        $scope.filtroIndicadorLigacaoSainte.Visao = 1;
                        $scope.campanhas = [];
                    } else {
                        $scope.filtroIndicadorLigacaoSainte.GrupoId = $scope.grupoSelecionadoId;
                        $scope.filtroSainte.GrupoId = $scope.grupoSelecionadoId;
                        $scope.getCampanhasByGrupoId();
                    }

                    let tempoTimeout = 2 * 60 * 1000;
                    $scope.setTimeoutLigacaoSainte = function () {

                        /* Indicador Geral */
                        $scope.getIndicadorLigacaoSainte();
                        $scope.timeoutIdLigacaoSainte = $timeout($scope.setTimeoutLigacaoSainte, tempoTimeout, true);
                    };
                    $scope.timeoutIdLigacaoSainte = $timeout($scope.setTimeoutLigacaoSainte, tempoTimeout, true);
                },

                'hide.uk.modal': function () {
                    $scope.indicadorLigacaoSainte = {};
                    $interval.cancel($scope.intervalOnline);
                    $timeout.cancel($scope.timeoutIdLigacaoSainte);
                }
            });

            $scope.periodoConsulta = [{
                Descricao: $translate.instant('telaMonitor.ultimaHora'),
                Valor: 1
            }, {
                Descricao: $translate.instant('telaMonitor.ultimas4Horas'),
                Valor: 2
            }, {
                Descricao: $translate.instant('telaMonitor.hoje'),
                Valor: 3
            }, {
                Descricao: $translate.instant('telaMonitor.umaSemana'),
                Valor: 4
            }, {
                Descricao: $translate.instant('telaMonitor.15Dias'),
                Valor: 5
            }, {
                Descricao: $translate.instant('telaMonitor.30Dias'),
                Valor: 6
            }];

            var calculaPeriodoSelecionado = function (periodoSelecionado) {
                const hoje = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
                let tempo = 60;
                let dataI = null;

                switch (periodoSelecionado) {
                    case 1: //1H
                        tempo = 60;
                        break;
                    case 2: //4h
                        tempo = 60 * 4;
                        break;
                    case 3: //Hoje
                        dataI = moment(hoje).toDate();
                        tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                        break;
                    case 4: //1 semana
                        dataI = moment(new Date(hoje.setDate(hoje.getDate() - 7))).toDate();
                        tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                        break;
                    case 5:
                        dataI = moment(new Date(hoje.setDate(hoje.getDate() - 15))).toDate();
                        tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                        break;
                    case 6:
                        dataI = moment(new Date(hoje.setDate(hoje.getDate() - 30))).toDate();
                        tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
                        break;
                    default:
                        tempo = 60;
                        break;
                }

                return tempo;
            }

            $scope.getServicoByNumero = function (numero) {
                if (!numero) return "";
                let descricao = numero;
                let servico = servicosByNumero[numero];
                if (servico) {
                    descricao = servico.Descricao;
                }

                if (descricao.length > 17) {
                    descricao = descricao.substring(0, 17) + '…';
                }

                return descricao;
            };

            /*Atualizar ramais ao abrir janela browser */
            var abaNavegadorAlterada = function () {
                if (!document.hidden) {
                    listarRamais();
                }
            }
            document.addEventListener('visibilitychange', abaNavegadorAlterada);

            $scope.onChangeVisaoEntrante = function () {
                $scope.indicadorLigacaoEntrante = [];
                $scope.filtroIndicadorLigacaoEntrante.GrupoId = [];
                $scope.filtroIndicadorLigacaoEntrante.UraId = [];
                switch (parseInt($scope.filtroIndicadorLigacaoEntrante.VisaoId)) {
                    case 1: // Grupo
                        $scope.filtroIndicadorLigacaoEntrante.GrupoId = _.pluck(grupos, 'GrupoId');
                        $scope.filtroIndicadorLigacaoEntrante.GrupoId = _.pluck(grupos, 'GrupoId');
                        break;
                    case 2: // Ura
                        $scope.filtroIndicadorLigacaoEntrante.UraId = _.pluck(uras, 'UraId');
                        break;
                }
            };

            $scope.discagem = { Numero: '', Rota: '' };

            $scope.discarExterno = function (form) {
                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                NotifyService.showMessage('telaMonitor.discando', "info");
                SupervisaoService.discarExterno($scope.discagem.Numero, $scope.discagem.Rota).catch(function (ex) {
                    NotifyService.showError(ex, 'telaMonitor.naoFoiPossivelDiscar')
                });

                ModalService.closeModal('modal_monitoria_remota')
            };

            var selecionarGrupoLocalStorage = function () {
                var grupoId = parseInt(localStorage.getItem('MonitorGrupo')) || 0;
                if (grupoId > 0) {
                    var grupo = _.findWhere($scope.grupos, { GrupoId: grupoId });
                    if (grupo) {
                        $scope.filtrarPorGrupo(grupo);
                    }
                }
            };

            timeoutSelecionarGrupo = setTimeout(function () { if (scopeDestroyed) return; selecionarGrupoLocalStorage(); }, 100);

            $scope.onTipoAlterado = function () {
                $scope.mensagemAlerta.DestinoId = null;
            }

            $scope.enviarMensagem = function (form) {
                if (($scope.mensagemAlerta.Mensagem == null || $scope.mensagemAlerta.Mensagem == '')
                    || ($scope.mensagemAlerta.DestinoTipo == 2 && $scope.mensagemAlerta.DestinoId == null)
                    || ($scope.mensagemAlerta.DestinoTipo == 3 && $scope.mensagemAlerta.DestinoId == null)) {
                    return NotifyService.showInvalid();
                }
                var grupoId = $scope.mensagemAlerta.DestinoTipo == 2 ? $scope.mensagemAlerta.DestinoId : 0;
                var ramalNumero = $scope.mensagemAlerta.DestinoTipo == 3 ? $scope.mensagemAlerta.DestinoId : 0;
                SupervisaoService.enviarMensagem(ramalNumero, grupoId, $scope.mensagemAlerta.Mensagem);
                NotifyService.showSuccess('telaMonitor.mensagemEnviada')

                form.$setPristine();
                $scope.mensagemAlerta = {};
            }

            $scope.selecionarAba = function (aba) {
                $scope.abaSelecionada = aba;
            };

            var intervalAtualizaFila = null;
            function AtualizaFila() {
                $scope.GrupoId = 0;

                intervalAtualizaFila = $interval(function () {
                    MonitorResource.getFila().$promise
                        .then((data) => {
                            $scope.listFila = data;
                            AtualizaFilaGrupo();
                        });
                }, 15000)
            };

            $scope.onchangeFornecedor  = function () {                                
                if ($scope.filtroRoboCall.FornecedorId > 0) {
                    $scope.rotasRoboCall = $scope.rotas
                    $scope.rotasRoboCall = _.filter($scope.rotasRoboCall, (item) => {
                        return item.FornecedorId == $scope.filtroRoboCall.FornecedorId;
                    })    
                }
                return $scope.rotasRoboCall;
            }

            var intervalAtualizaAlarmeRoboCall = null;
            function AtualizaAlarmeRoboCall() {
                intervalAtualizaAlarmeRoboCall = $interval(function () {
                    MonitorResource.getRoboCallAlarme().$promise
                        .then((data) => {
                            if(data != null)
                            {
                                $scope.alermeRoboCall = data;
                                $scope.QuantidadeRoboCall = data.Quantidade;
                            }
                        });
                }, 15000)
            };

            $scope.abrirModalRoboCall = function () {
                $scope.filtroRoboCall = { Periodo: 60}
                $scope.pesquisarRoboCall();                
                ModalService.openModal('modal_monitoriaRoboCall');
            }

            $scope.pesquisarRoboCall = function(){
                $http({
                    url: Config.getUrl('Monitor/RoboCall'),
                    method: "GET",
                    params: $scope.filtroRoboCall
                }).then(function (response) {
                    $scope.listRoboCall = response.data;
                });
            }

            /* Event Emmiters */
            $("#modal_alarme").on({
                'show.uk.modal': () => {
                    $rootScope.$broadcast("onLoadGrupos", $scope.grupos)
                }
            });

            $("#modal_metrica").on({
                'show.uk.modal': () => {
                    $rootScope.$broadcast("onLoadGrupos", $scope.grupos)
                }
            });

            $("#modal_gerenciar_fila").on({
                'show.uk.modal': () => {
                    $rootScope.$broadcast("onLoadGrupos", $scope.grupos)
                    $rootScope.$broadcast("onLoadFilaAlarme", $scope.FilaAlarme)
                }
            });

            AtualizaFila();
            AtualizaAlarmeRoboCall();

            $scope.AtualizarRamais = [];

            $scope.OnAtualizaAtribuicoes = function (item) {

                let ramal = {
                    RamalId: item.RamalId, 
                    Manual: item.Manual,
                    Receptivo: item.Receptivo,
                    Discador: item.Discador
                };
                
                let encontrado = false;
                
                for (let index = 0; index < $scope.AtualizarRamais.length; index++) {
                    
                    if($scope.AtualizarRamais[index].RamalId == ramal.RamalId)
                    {
                        $scope.AtualizarRamais[index] = ramal;
                        encontrado = true;
                        break;
                    }                       
                }

                if(!encontrado)
                    $scope.AtualizarRamais.push(ramal);                
            }

            $scope.onSalvar = function(){
                RamalAtribuicoesResource.save($scope.AtualizarRamais).$promise.then(result => {
                    NotifyService.showSuccess();
                }).catch(error => { NotifyService.showError(error) });
            }


            $scope.order = function(predicate) {
                if ($scope.predicate === predicate) {
                    $scope.reverse = !$scope.reverse;
                } else {
                    $scope.predicate = predicate;
                    $scope.reverse = false; // Começar com a ordem ascendente ao mudar de coluna
                }
                
                $scope.orderByFila = {
                    column: $scope.predicate,
                    order: $scope.reverse ? "Desc" : "Asc",
                };

                RetornaFilaGrupo();
               
            };            

            function RetornaFilaGrupo()
            {
                MonitorResource.getFilaGrupo({colunaOrdenacao: $scope.orderByFila.column, direcaoOrdenacao: $scope.orderByFila.order, grupoId: $scope.GrupoId}).$promise
                .then((data) => {
                    $scope.GrupoFila = data;    
                });
            }

            var token = 0;

            $scope.GetFilaGrupoSelecionado = function (grupoId)
            {
                if (token) $interval.cancel(token);
                
                $scope.GrupoId = grupoId;      
                RetornaFilaGrupo();

                token = $interval(() => {
                    RetornaFilaGrupo();
                }, 10000);
       
            }
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .service('MonitorRamalService',
            function MonitorRamalService() {
                var service = {
                    ramais: {},
                    numberOfPages: 0,
                    currentPage: 0,
                    pageSize: 20
                };
                return service;
            });
})();

(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("MonitorResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "Monitor/:MonitorId",
                {
                    "MonitorId": "@MonitorId"
                },
                {
                    getGrupos: {
                        url: "Monitor/Grupos",
                        method: "GET",
                        isArray: true
                    },
                    getRamais: {
                        url: "Monitor/Ramais",
                        method: "GET",
                        isArray: true
                    },
                    CancelarAlarme: {
                        url: "Monitor/CancelarAlarme",
                        method: "POST"
                    },
                    getDataAtual: {
                        url: "Monitor/DataAtual",
                        method: "GET",
                    },
                    getResultadosPesquisa: {
                        url: "RelatorioPesquisa/ResultadosPesquisas",
                        method: "GET",
                        isArray: false
                    },
                    getResultadosIndividuaisDetalhes: {
                        url: "RelatorioPesquisa/ResultadosIndividuaisDetalhes",
                        method: "GET",
                        isArray: false
                    },
                    EnviarMensagem: {
                        url: "Monitor/EnviarMensagem",
                        method: "POST"
                    },
                    getFila:{
                        url: "Monitor/Fila",
                        method: "GET",
                        isArray: true
                    },
                    getFilaGrupo:{
                        url: "Monitor/FilaGrupo/{colunaOrFiladenacao}/{direcaoOrdenacao}/{grupoId}",
                        method: "GET",
                        isArray: true
                    },
                    getRoboCallAlarme:{
                        url: "Monitor/GetRoboCallAlarme",
                        method: "GET",
                        isArray: false
                    }
                });
        }]);
})();
(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("RamalAtribuicoesResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "RamalAtribuicoes/:Id",
                {
                    "Id": "@Id"
                });
        }]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.controller("RamalDetalheController",
			["$scope", "$window", "$rootScope", "RamalDetalheService", "RamalResource", "Config", "FileDownloadService", "NotifyService", "$translate", "ModalService", "LigacaoResource", "GrupoRamalStatusDetalheResource", function ($scope, $window, $rootScope, RamalDetalheService, RamalResource, Config, FileDownloadService, NotifyService, $translate, ModalService, LigacaoResource, GrupoRamalStatusDetalheResource) {
				$scope.RamalDetalheService = RamalDetalheService;
				$scope.bilheteDialogoAtivo = {};

				//TRANSCRIÇÃO
				$scope.transcricaoAtiva = false;
				$scope.transcricao = {};
				$scope.height = 450;
				$scope.width = 700;
				$scope.rotate = function () { return 0; };
				$scope.transcricao.showGrid = false;
				$scope.ok = false;
				$scope.wordSelected = "";
				///FIM TRANSCRIÇÃO

				$scope.direcoes = [
					{ DirecaoId: 2, Descricao: $translate.instant('campo.entrante') },
					{ DirecaoId: 1, Descricao: $translate.instant('model.discador') },
					{ DirecaoId: 3, Descricao: $translate.instant('campo.integracao') },
				];

				$scope.direcaoOptions = {
					dataSource: {
						data: $scope.direcoes
					},
					dataTextField: "Descricao",
					dataValueField: "DirecaoId",
					optionLabel: $translate.instant('campo.todos'),
					index: $scope.direcoes.map((item) => {
						return item.DirecaoId;
					}).indexOf($scope.search.DirecaoId)
				};

				$scope.downloadFile = function (globalId, arquivoDialogo) {
					if (arquivoDialogo) {
						FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId + "/" + arquivoDialogo.replace(".vox", ""));
					} else {
						FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId);
					}
				};

				$scope.getPathDowload = function (globalId) {
					var path = Config.getUrl("Monitor/DownloadDialogo/" + globalId);
					return path;
				};

				$scope.filtrarIndice = function () {
					var tempo = calculaPeriodoSelecionado($scope.filtroIndiceRamal.Tempo || 3);
					var grupos = $scope.filtroIndiceRamal.Grupo;
					var ramalId = $scope.RamalDetalheService.ramal.RamalId;
					var tipos = $scope.filtroIndiceRamal.Tipo;
					var desconexaoTipos = $scope.filtroIndiceRamal.Desconexao;
					var grupoFiltro = "0";
					var tipoFiltro = "0";
					var desconexaoFiltro = "0";

					if (angular.isArray(grupos)) {
						grupoFiltro = "";
						angular.forEach(grupos, function (item, index) {
							grupoFiltro += grupos[index];

							if (index < grupos.length - 1)
								grupoFiltro += ",";
						});
					}
					else if (angular.isArray($scope.RamalDetalheService.grupos)) {
						grupoFiltro = "";
						angular.forEach($scope.RamalDetalheService.grupos, function (item, index) {
							grupoFiltro += $scope.RamalDetalheService.grupos[index].GrupoId;

							if (index < $scope.RamalDetalheService.grupos.length - 1)
								grupoFiltro += ",";
						});
					}

					if (angular.isArray(tipos)) {
						tipoFiltro = "";
						angular.forEach(tipos, function (item, index) {
							tipoFiltro += tipos[index];

							if (index < tipos.length - 1)
								tipoFiltro += ",";
						});
					}

					if (angular.isArray(desconexaoTipos)) {
						desconexaoFiltro = "";
						angular.forEach(desconexaoTipos, function (item, index) {
							desconexaoFiltro += desconexaoTipos[index];

							if (index < desconexaoTipos.length - 1)
								desconexaoFiltro += ",";
						});
					}

					$scope.RamalDetalheService.getIndicesRamal(ramalId, grupoFiltro, tempo, desconexaoFiltro, tipoFiltro);
				};

				//----------------------------------------LIGAÇÕES------------------------------------
				$scope.searchLigacao = {
					DataInicio: moment().hours(0).minutes(0).seconds(0).milliseconds(0).toDate(),
					DataFim: moment().add(1, 'days').hours(0).minutes(0).seconds(0).milliseconds(0).toDate(),
					Duracao: ''
				};

				$scope.buscarLigacoes = function () {
					$scope.pageChangedLigacao(1);
				};
				$scope.pageChangedLigacao = function (newPage) {
					var filtro = {
						RamalNumero: $scope.RamalDetalheService.ramal.Numero,
						DataI: $scope.searchLigacao.DataInicio,
						DataF: $scope.searchLigacao.DataFim,
						NB: $scope.searchLigacao.NB,
						BilheteDirecaoId: $scope.searchLigacao.BilheteDirecaoId,
						Duracao: $scope.searchLigacao.Duracao
					};
					$scope.ligacoesProcessando = true;
					RamalDetalheService.getLigacoes(newPage, $scope.RamalDetalheService.ligacoesLimit, filtro)
						.finally(function () {
							$scope.ligacoesProcessando = false;
						});
				};
				$scope.buscarLigacoes();

				$scope.verificaTranscricaoAtiva = function (ramalId) {
					var promise = RamalResource.getRamalCampos({ id: ramalId }).$promise;
					promise.then(function (data) {
						var camposTranscricao = _.filter(data, function (el) {
							return el.Descricao == 'Gravação';
						});

						if (camposTranscricao.length > 0) {

							var halibitaTranscricao = _.filter(camposTranscricao[0].Campos, function (el) {
								return el.Descricao == 'Transcrição' && el.Valor == "1";
							});

							$scope.transcricaoAtiva = halibitaTranscricao.length > 0;
						}
					});
				}

				$scope.verificaTranscricaoAtiva(RamalDetalheService.ramal.RamalId);

				$scope.mostrarTranscricao = function (ligacao) {
					ModalService.showLoading();
					$scope.transcricao.transcricaoAtivo = ligacao;
					var modalM = UIkit.modal("#modal_transcricao");
					var arquivo = ligacao.ArquivoDialogo.replace(".vox", "");
					var promise = LigacaoResource.getTranscricao({ globalId: ligacao.GlobalId, arquivo: arquivo }).$promise;
					promise.then(function (data) {
						if (data.ProcessStatus == undefined) {
							ModalService.hideLoading();
							modalM.hide();
							$window.UIkit.modal.alert('Transcrição não encontrada.');
							return;
						}
						else if (data.ProcessStatus != 1) {
							ModalService.hideLoading();
							modalM.hide();
							var texto = data.ProcessStatus == 0 ? "Em processamento." : "Erro.";
							$window.UIkit.modal.alert('Não foi possível obter a transcrição, motivo: ' + texto);
							return;
						}

						if (data.Palavras.length > 0) {
							var maxCount = data.Palavras[0].quantidade;
							var minCount = data.Palavras[data.Palavras.length - 1].quantidade;
							var maxWordSize = 500 * 0.15;
							var minWordSize = maxWordSize / 5;
							var spread = maxCount - minCount;

							if (spread <= 0) spread = 1;
							var step = (maxWordSize - minWordSize) / spread;

							var words = data.Palavras.map(function (word) {
								return {
									text: word.text,
									size: Math.round(maxWordSize - ((maxCount - word.quantidade) * step)),
									color: "#1976D2",
									quantidade: word.quantidade,
									tooltipText: "Quantidade: " + word.quantidade
								}
							})

							$scope.transcricao.palavras = words;
							$scope.transcricao.conversa = data.Conversa;
						}

						$scope.transcricao.detalhes = data.Detalhes;
						$scope.ok = true;
						ModalService.hideLoading();
					}).catch(function () {
						NotifyService.showError(null, "Ocorreu um erro ao obter a transcrição.", {
							status: "danger",
							pos: "top-center"
						});
						ModalService.hideLoading();
						modalM.hide();
					});
				}

				$scope.wordClicked = function (word) {
					$scope.wordSelected = 'Palavra: "' + word.text + '" ' + word.tooltipText;
				}

				$('body').on('hide.uk.modal', '#modal_transcricao', function () {
					$rootScope.$broadcast('audioPlayerInlineStop');
					$scope.transcricao.palavras = null;
					$scope.transcricao.conversa = null;
					$scope.transcricao.score = null;
					$scope.transcricao.detalhes = null;
					$scope.ok = false;
				});

				//----------------------------------------ALARMES------------------------------------
				$scope.searchAlarme = {
					DataInicio: moment().hours(0).minutes(0).seconds(0).milliseconds(0).toDate(),
					DataFim: moment().add(1, 'days').hours(0).minutes(0).seconds(0).milliseconds(0).toDate(),
				};

				$scope.buscarAlarmes = function () {
					$scope.pageChangedAlarme(1);
				};

				$scope.pageChangedAlarme = function (newPage) {
					var filtro = {
						RamalId: $scope.RamalDetalheService.ramal.RamalId,
						DataI: $scope.searchAlarme.DataInicio,
						DataF: $scope.searchAlarme.DataFim,
						RamalStatusDetalheId: $scope.searchAlarme.RamalStatusDetalheId,
					};

					$scope.alarmesProcessando = true;
					RamalDetalheService.getAlarmes(newPage, $scope.RamalDetalheService.alarmeLimit, filtro)
						.finally(function () {
							$scope.alarmesProcessando = false;
						});
				};
				$scope.buscarAlarmes();

				//----------------------------------------INTERVALO------------------------------------
				$scope.searchIntervalo = {
					DataInicio: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).subtract(1, 'days').seconds(0).milliseconds(0).toDate(),
					DataFim: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).add(1, 'days').seconds(0).milliseconds(0).toDate()
				};

				var carregarRamalStatusDetalhe = function(){
					if($scope.RamalDetalheService.ramal != null && $scope.RamalDetalheService.ramal.Grupos != null)
					{
						var gruposs = $scope.RamalDetalheService.ramal.Grupos.join(',');
						GrupoRamalStatusDetalheResource.GetIntervalosGrupoAgrupado({
							GrupoId: gruposs
						}).$promise.then( data =>{
							$scope.ramalStatusDetalhes = data;
						});
					}
				}

				carregarRamalStatusDetalhe();

				$scope.buscarIntervalos = function () {
					$scope.pageChangedIntervalo(1);
				};

				$scope.pageChangedIntervalo = function (newPage) {
					var filtro = {
						RamalId: $scope.RamalDetalheService.ramal.RamalId,
						DataI: $scope.searchIntervalo.DataInicio,
						DataF: $scope.searchIntervalo.DataFim,
						RamalStatusDetalheId: $scope.searchIntervalo.RamalStatusDetalhe != null ? $scope.searchIntervalo.RamalStatusDetalhe + '' : [],
						Duracao: $scope.searchIntervalo.Duracao
					};

					$scope.intervalosProcessando = true;
					RamalDetalheService.getIntervaloHistorico(newPage, $scope.RamalDetalheService.intervaloHistoricoLimit, filtro)
						.finally(function () {
							$scope.intervalosProcessando = false;
						});
				};
				$scope.buscarIntervalos();

				//----------------------------------------FIM PESQUISA---------------------------
				$scope.getClassIndicadorRamal = function (indicador) {

					if (indicador.Ordem == 1) {
						return 'md-bg-blue-500'
					}

					if (indicador.Ordem == 2) {
						return 'md-bg-red-500'
					}

					if (indicador.Ordem == 3) {
						return 'md-bg-green-500'
					}
				};

				$scope.filtroIndiceRamal = {
					Tempo: 3,
					Grupo: [],
					Tipo: [],
					Desconexao: [],
				};

				$scope.filtroIndicadorRamal = {
					Tempo: 1
				};

				$scope.indicadorTempos = [{
					Descricao: $translate.instant('telaMonitor.ultimaHora'),
					Valor: 1
				}, {
					Descricao: $translate.instant('telaMonitor.ultimas4Horas'),
					Valor: 2
				}, {
					Descricao: $translate.instant('telaMonitor.hoje'),
					Valor: 3
				}, {
					Descricao: $translate.instant('telaMonitor.umaSemana'),
					Valor: 4
				}, {
					Descricao: $translate.instant('telaMonitor.15Dias'),
					Valor: 5
				}, {
					Descricao: $translate.instant('telaMonitor.30Dias'),
					Valor: 6
				}];

				var calculaPeriodoSelecionado = function (periodoSelecionado) {
					var hoje = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
					var tempo = 60;
					var dataI = null;

					switch (periodoSelecionado) {
						case 1: //1H
							tempo = 60;
							break;
						case 2: //4h
							tempo = 60 * 4;
							break;
						case 3: //Hoje
							dataI = moment(hoje).toDate();
							tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
							break;
						case 4: //1 semana
							dataI = moment(new Date(hoje.setDate(hoje.getDate() - 7))).toDate();
							tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
							break;
						case 5:
							dataI = moment(new Date(hoje.setDate(hoje.getDate() - 15))).toDate();
							tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
							break;
						case 6:
							dataI = moment(new Date(hoje.setDate(hoje.getDate() - 30))).toDate();
							tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));
							break;
						default:
							tempo = 60;
							break;
					}

					return tempo;
				}

				$scope.onChangeIndicadorTempo = function () {
					if ($scope.RamalDetalheService.ramal.RamalId) {
						var tempo = calculaPeriodoSelecionado($scope.filtroIndicadorRamal.Tempo || 1);
						var ramaid = $scope.RamalDetalheService.ramal.RamalId;
						var grupoid = $scope.RamalDetalheService.grupo.GrupoId || 0;

						$scope.RamalDetalheService.getIndicadoresRamal(ramaid, grupoid, tempo);
					}
				};

				$scope.onChangeIndiceTempo = function () {
					if ($scope.RamalDetalheService.ramal.RamalId)
						$scope.filtrarIndice();
				};

				$scope.getClassIndicadorPercentual = function (percentual) {
					if (percentual <= 34) {
						return "uk-progress-danger";
					}
					if (percentual > 34 && percentual <= 67) {
						return "uk-progress-warning";
					}
					if (percentual > 67) {
						return "uk-progress-success";
					}
				};

				$scope.reproduzirDialogo = function (bilhete) {
					$scope.bilheteDialogoAtivo.bilhete = bilhete;
				};

				// $('body').on('hide.uk.modal', '#modal_ramal', function () {
				// 	$scope.$parent.intervaloDia = {};
				// 	$scope.$parent.historioIntervalo = {};
				// 	$scope.$parent.historicoBilhete = {};
				// });

				//// AVALIAÇÃO ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
				$scope.perguntasList = [];
				$scope.resultadosIndividuaisList = [];
				$scope.resultadosIndividuaisDetalhe = {};
				$scope.submitted = false;
				$scope.searchAvaliacao = {
					DataInicio: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
					DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
					Grupo: []
				};

				$scope.buscar = function () {
					if (!validarPesquisa()) {
						return;
					}
					RamalDetalheService.getAvaliacoes($scope.searchAvaliacao.DataInicio, $scope.searchAvaliacao.DataFim, $scope.searchAvaliacao.Grupo.join(), RamalDetalheService.ramal.UsuarioId);
				};

				$scope.chamarModal = function (data) {
					RamalDetalheService.getAvaliacaoDetalhe(data.PesquisaId, data.GlobalId);
					ModalService.openModal('modal_avaliacao');
					$('#modal_avaliacao').on({
						'hide.uk.modal': function () {
							var modalM = UIkit.modal("#modal_ramal");
							if (!modalM.isActive()) {
								$(".uk-tab LI, #tabs_anim1 LI").removeClass("uk-active");
								$("#tabAvaliacoes, #tabConteudoAvaliacoes").addClass("uk-active");
								modalM.show();
							}
						}
					});
				}

				$scope.limparFiltro = function () {
					$scope.searchAvaliacao = {
						DataInicio: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
						DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
						Grupo: [],
					}
					$scope.resultadosIndividuaisList = [];
					$scope.submitted = false;
				}

				var validarPesquisa = function () {
					var msg = [];

					if ($scope.searchAvaliacao.DataInicio == undefined) {
						msg.push($translate.instant('telaMonitor.campoDataIObrigatorio'));
					}

					if ($scope.searchAvaliacao.DataFim == undefined)
						msg.push($translate.instant('telaMonitor.campoDataFObrigatorio'));

					if (($scope.searchAvaliacao.DataInicio != undefined && $scope.searchAvaliacao.DataFim != undefined) && $scope.searchAvaliacao.DataInicio >= $scope.searchAvaliacao.DataFim)
						msg.push($translate.instant('telaMonitor.campoDataIMaiorQueDataF'));

					if (msg.length) {
						NotifyService.showError(null, `${$translate.instant('telaMonitor.verifiqueOsCampos')}: <br><br>${msg.join('<br>')}`);
						return false;
					}

					return true;
				};

				//// AVALIAÇÃO ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
			}]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.service('RamalDetalheService',
			["RamalResource", "RamalStatusResourceDetalhe", "$rootScope", "SupervisaoService", "MonitorResource", "$http", "Config", "$translate", function RamalDetalheService(RamalResource, RamalStatusResourceDetalhe, $rootScope, SupervisaoService, MonitorResource, $http, Config, $translate) {
				var service = {
					tempo: 60,
					intervaloHistoricoLimit: 10,
					alarmeLimit: 10,
					ligacoesLimit: 10,
					ramal: {},
					grupo: {},
					grupos: [],
					ligacoes: [],
					intervalos: [],
					alarmes: [],
					tipos: [],
					avaliacoes: [],
					avaliacoesPesoMedio: 0,
					avaliacaoDetalhe: {},
					desconexoes: [],
					intervaloHistoricos: [],
					indicadoresRamal: [],
					indicesRamal: [],
					indicesRamalTotal: [],
					getDiscagemTipo: getDiscagemTipo,
					getDesconexaoTipo: getDesconexaoTipo,
					getLigacoes: getLigacoes,
					getIntervalos: getIntervalos,
					getAlarmes: getAlarmes,
					getIntervaloHistorico: getIntervaloHistorico,
					getIndicadoresRamal: getIndicadoresRamal,
					getIndicesRamal: getIndicesRamal,
					getAvaliacoes: getAvaliacoes,
					getAvaliacaoDetalhe: getAvaliacaoDetalhe,
					adicionarIntervalo: adicionarIntervalo,
					openModal: openModal
				};

				function getDiscagemTipo() {
					var discagemTipos = [
						{
							DiscagemTipoId: 1,
							Descricao: $translate.instant('telaMonitor.manual')
						},
						{
							DiscagemTipoId: 2,
							Descricao: $translate.instant('model.discador')
						},
						{
							DiscagemTipoId: 3,
							Descricao: $translate.instant('campo.integracao')
						}];

					return discagemTipos;
				}

				function getDesconexaoTipo() {
					var desconexaoTipos = [
						{
							DesconexaoTipoId: 1,
							Descricao: $translate.instant('model.ramal')
						},
						{
							DesconexaoTipoId: 2,
							Descricao: $translate.instant('model.cliente')
						}];

					return desconexaoTipos;
				}

				function getIntervalos(grupoId) {
					service.intervalos = [];
					RamalStatusResourceDetalhe.getStatusDetalhePorGrupo({
						grupoId: grupoId
					}).$promise.then(function (data) {
						angular.copy(data, service.intervalos);
					});
				}

				function getGrupos(ramalId) {
					service.grupos = [];
					RamalResource.getGruposAssociados({
						ramalId: ramalId,
						nome: ''
					}).$promise.then(function (data) {
						angular.copy(data, service.grupos);
					});
				}

				function getLigacoes(page, limit, filtro) {
					var url = Config.getUrl("Ligacao/") + page + "/" + limit
					return $http({
						method: 'GET',
						url: url,
						params: filtro
					}).then(function (response) {
						angular.copy(response.data.Data, service.ligacoes);
						service.ligacoes.recordCount = response.data.RecordCount || service.ligacoes.length;
						service.ligacoes.currentPage = response.data.PageIndex || 1;
						service.ligacoes.pageSize = response.data.PageSize || 10;
						return response.data;
					});
				}

				function getAlarmes(page, limit, filtro) {
					return $http({
						url: Config.getUrl("MonitoriaAlarme/Historico"),
						method: "GET",
						params: {
							RamalId: filtro.RamalId,
							RamalStatusDetalheId: filtro.RamalStatusDetalheId,
							DataInicio: filtro.DataInicio,
							DataFim: filtro.DataFim,
							pageIndex: page,
							pageSize: limit
						}
					}).then(function (response) {
						angular.copy(response.data.Data, service.alarmes);
						service.alarmes.recordCount = response.data.RecordCount || service.alarmes.length;
						service.alarmes.currentPage = response.data.PageIndex || 1;
						service.alarmes.pageSize = response.data.PageSize || 10;
						return response.data;
					});
				}

				function getIntervaloHistorico(page, limit, filtro) {
					var url = Config.getUrl("RamalIntervaloHistorico/") + page + "/" + limit
					return $http({
						method: 'GET',
						url: url,
						params: filtro
					}).then(function (response) {
						angular.copy(response.data.Data, service.intervaloHistoricos);
						service.intervaloHistoricos.recordCount = response.data.RecordCount || service.intervaloHistoricos.length;
						service.intervaloHistoricos.currentPage = response.data.PageIndex || 1;
						service.intervaloHistoricos.pageSize = response.data.PageSize || 10;
						return response.data;
					});
				}

				function getIndicadoresRamal(ramalId, grupoId, tempo) {
					$http({
						url: Config.getUrl("Ramal/Indicador"),
						method: "GET",
						params: {
							RamalId: ramalId,
							GrupoId: grupoId,
							Tempo: tempo
						}
					}).then(function (response) {
						angular.copy(response.data, service.indicadoresRamal);
					});
				}

				function getIndicesRamal(ramalId, grupos, tempo, desconexaoTipos, discagemTipos) {
					
					$http({
						url: Config.getUrl("Ramal/Indice"),
						method: "GET",
						params: {
							RamalId: ramalId,
							Grupos: grupos,
							Tempo: tempo,
							DesconexaoTipos: desconexaoTipos,
							DiscagemTipos: discagemTipos
						}
					}).then(function (response) {
						angular.copy(response.data, service.indicesRamal);
						service.indicesRamalTotal = [];
						if (service.indicesRamal) {
							var totalEntrante = {
								IndiceDescricao: $translate.instant('telaMonitor.receptivoTotal'),
								Quantidade: 0,
								Duracao: 0,
								DirecaoId: 1
							};

							var totalSainte = {
								IndiceDescricao: $translate.instant('telaMonitor.ativoTotal'),
								Quantidade: 0,
								Duracao: 0,
								DirecaoId: 2
							};

							totalEntrante.Quantidade = _(_.where(service.indicesRamal, {
								DirecaoId: 1
							})).reduce(function (m, x) { return m + x.Quantidade; }, 0);

							totalEntrante.Duracao = _(_.where(service.indicesRamal, {
								DirecaoId: 1
							})).reduce(function (m, x) { return m + x.Duracao; }, 0);

							totalSainte.Quantidade = _(_.where(service.indicesRamal, {
								DirecaoId: 2
							})).reduce(function (m, x) { return m + x.Quantidade; }, 0);

							totalSainte.Duracao = _(_.where(service.indicesRamal, {
								DirecaoId: 2
							})).reduce(function (m, x) { return m + x.Duracao; }, 0);

							service.indicesRamalTotal.push(totalEntrante);
							service.indicesRamalTotal.push(totalSainte);
						}
					});
				}

				function adicionarIntervalo(statusDetalheId, ramalNumero) {
					var intervalo = {
						GrupoId: 0,
						Ramal: ramalNumero,
						RamalStatusDetalheId: statusDetalheId
					};

					// TODO: usar 'then' e 'catch' para informar o sucesso ou falha do comando
					SupervisaoService.iniciarIntervalo(statusDetalheId, ramalNumero)
					$rootScope.$broadcast("RamalDetalheService-Intervalo", intervalo);

				}

				function getAvaliacoes(dataInicial, dataFinal, grupo, usuarioId) {
					var filtro = {
						DataInicial: dataInicial,
						DataFinal: dataFinal,
						Grupo: grupo,
						UsuarioId: usuarioId
					};

					service.avaliacoes = [];
					MonitorResource.getResultadosPesquisa(filtro)
						.$promise.then(function (data) {
							var pesoMedio = data.ResultadosIndividuais.reduce(function (a, b) { return a + b.Peso; }, 0) / data.ResultadosIndividuais.length;
							angular.copy(data.ResultadosIndividuais, service.avaliacoes);
							service.avaliacoesPesoMedio = pesoMedio;
						});
				}

				function getAvaliacaoDetalhe(pesquisaId, globalId) {
					var filtro = {
						PesquisaId: pesquisaId,
						GlobalId: globalId
					};
					MonitorResource.getResultadosIndividuaisDetalhes(filtro).$promise.then(function (data) {
						angular.copy(data, service.avaliacaoDetalhe);
					});
				}

				function openModal(ramal, grupo) {
					var modal = UIkit.modal("#modal_ramal");
					service.modalRamalOpen = true;
					$('#modal_ramal').on({
						'hide.uk.modal': function (event) {
							if (event.target.id == 'modal_ramal') {
								service.modalRamalOpen = false;
							}
						}
					});

					service.grupos = [];
					service.ligacoes = [];
					service.intervaloHistoricos = [];
					service.alarmes = [];
					service.ramal = ramal;
					service.grupo = grupo;
					service.tipos = getDiscagemTipo();
					service.desconexoes = getDesconexaoTipo();
					getAvaliacoes(moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(), moment().add(1, 'days').seconds(0).milliseconds(0).toDate(), '', ramal.UsuarioId);
					getIntervalos(ramal.GrupoId);
					getGrupos(ramal.RamalId);

					var hoje = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
					let dataI = moment(hoje).toDate();
					let tempo = parseInt(Math.round(((new Date()).getTime() - dataI.getTime()) / 60000));

					if (grupo) {
						getIndicadoresRamal(ramal.RamalId, grupo.GrupoId || 0, 60);
					}

					getIndicesRamal(ramal.RamalId, grupo.GrupoId || 0, tempo, null, null);

					$rootScope.$broadcast("Monitor-RamalSelecionado", ramal);

					//Open Modal
					modal.show();
				}

				return service;

			}]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("RamalEventoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("RamalEvento/:RamalEventoId", {
				"RamalEventoId": "@RamalEventoId"
			});
		}]);

})();

(function () {

	angular.module("epbxManagerApp")

		.controller("RoboCallController", ["$scope", "RoboCallResource", "NotifyService", "ModalService", function ($scope, RoboCallResource, NotifyService, ModalService) {
			/* Propriedades */
			$scope.carregando = false;
			$scope.primeiroClick = true;
			$scope.configGeral = {}

			function roboCall() {
				RoboCallResource.get({ Id: 1 }).$promise.then(data => {
					$scope.configGeral = data;
				});
			}

			roboCall();

			/* Métodos */
			let mensagemSucesso = function () {
				NotifyService.showSuccess();
				ModalService.confirmMessage('telaMonitor.necessarioAtualizarPagina', null, () => window.location.reload());
			};

			$scope.checarVazio = function (valor) {
				return valor !== null && valor !== undefined && valor !== '';
			}

			$scope.salvarGeral = function () {
				RoboCallResource.save($scope.configGeral).$promise.then(mensagemSucesso).catch(NotifyService.showError);
			};
		}]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RoboCallResource", ["$odataresource", function ($odataresource) {
            return $odataresource("RoboCallAlarme/:Id", {
                "Id": "@Id"
            });
        }]);
})();

(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("UsuarioRamalHistoricoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("UsuarioRamalHistorico/:UsuarioRamalHistoricoId", {
				"UsuarioRamalHistoricoId": "@UsuarioRamalHistoricoId"
			});
		}]);
})();


(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("CanalEventoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("CanalEvento/:CanalEventoId", {
				"CanalEventoId": "@CanalEventoId"
			});
		}]);
	})
();

angular.module('epbxManagerApp')

    .directive('emTimerCanal', ["$timeout", "LocalStorageService", function ($timeout, LocalStorageService) {
        return {
            restrict: 'EA',
            replace: false,
            template: '<span ng-bind="diferenca | humanizeCustom"></span>',
            scope: {
                data: '=',
            },
            link: function (scope) {
                scope.diferenca = 0;
                scope.timeoutId = null;

                var getDiferenca = function (dataAtual, dataInicio) {
                    var atual = moment(dataAtual);
                    var inicial = moment(dataInicio).toDate();
                    return atual.diff(inicial, 'seconds');
                };

                scope.onTimeout = function () {
                    var dataAtualHub = LocalStorageService.getItem('DataAtualHub');
                    var dataAtualPagina = LocalStorageService.getItem('DataAtualPagina');
                    var diferencaEntreDatas = getDiferenca(dataAtualHub, dataAtualPagina);
                    var dataAtual = moment(new Date()).add(diferencaEntreDatas, 'seconds').toDate();
                    scope.diferenca = getDiferenca(dataAtual, scope.data);

                    if (scope.diferenca < 0) {
                        scope.diferenca = 1;
                    }

                    scope.timeoutId = $timeout(scope.onTimeout, 1000, true);
                };

                scope.timeoutId = $timeout(scope.onTimeout, 0, true);
                scope.$on('$destroy', function () {
                    $timeout.cancel(scope.timeoutId);
                });
            }
        }
    }]);

(function () {
    "use strict";
    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.monitorcanais", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.monitorcanais.list',
                        pageTitle: 'pageTitle.monitorDeCanais',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.monitorcanais.list", StateResolverProvider.configState("/monitorcanais", "MonitorCanal", "List", {
                    pageTitle: 'pageTitle.monitorDeCanais',
                    pageName: 'pageTitle.pesquisar',
                    css: true,
                    cssFiles: ['app/pages/monitorCanal/style/list.css', 'app/pages/monitor/style/list.css']
                }));
        }])
        .service('MonitorCanalListData', function MonitorCanalListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    totalCanais: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalCanais().$promise;
                    }],
                    totalCanaisDiscando: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalCanaisDiscando({ grupoId: 0 }).$promise;
                    }],
                    totalCanaisFalando: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalCanaisFalando({ grupoId: 0 }).$promise;
                    }],
                    totalCanaisFalandoManual: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalCanaisFalandoManual({ grupoId: 0 }).$promise;
                    }],
                    totalCanaisLigacaoRecebida: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalCanaisLigacaoRecebida({ grupoId: 0 }).$promise;
                    }],
                    totalCanaisLigacaoEmEspera: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalCanaisLigacaoEmEspera({ grupoId: 0 }).$promise;
                    }],
                    totalRamais: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getTotalRamais({ grupoId: 0 }).$promise;
                    }],
                    statusCanal: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getStatusCanais({ grupoId: 0 }).$promise;
                    }],
                    grupos: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getGrupos().$promise;
                    }],
                    canais: ["MonitorCanalResource", function (MonitorCanalResource) {
                        return MonitorCanalResource.getCanais({ canalI: 0, canalF: 30, grupoId: 0, status: '', pagina: 1, tipoFiltro: 0, nb: "", campanha: 0, ramalId: 0 }).$promise;
                    }],
                    ramais: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getRamais().$promise;
                    }]
                }
            }
        })
        .filter('formataNumeroServicoFilter', function () {
            return function (status, numA, numB) {
                let numero = '--'
                if (status == "DiscandoExterno" || status == "AtendidoChamadaExternaSainte" || status == "DiscandoInterno" || status == "AtendidoChamadaInternaSainte" ||
                    status == "AtendidoChamadaExternaEntrante" || status == "DiscandoDiscadorLigacaoAgendada" || status == "AtendidoChamadaDiscadorLigacaoAgendada" ||
                    status == "AtendidoChamadaDiscador" || status == "DiscandoDiscador") {
                    numero = numB;
                } else {
                    numero = numA;
                }
                return numero;
            };
        })
        .filter('formataNumeroTelefoneFilter', function () {
            return function (status, numA, numB) {
                let numero = '--'
                if (status == "DiscandoExterno" || status == "AtendidoChamadaExternaSainte" || status == "DiscandoInterno" || status == "AtendidoChamadaInternaSainte" ||
                    status == "AtendidoChamadaExternaEntrante" || status == "DiscandoDiscadorLigacaoAgendada" || status == "AtendidoChamadaDiscadorLigacaoAgendada" ||
                    status == "AtendidoChamadaDiscador" || status == "DiscandoDiscador") {
                    numero = numA;
                } else {
                    numero = numB;
                }
                return numero;
            };
        })
        .controller("MonitorCanalListController", ["$scope", "$interval", "$q", "$timeout", "totalCanais", "totalCanaisDiscando", "totalCanaisFalando", "grupos", "$translate", "totalCanaisFalandoManual", "totalCanaisLigacaoRecebida", "totalCanaisLigacaoEmEspera", "totalRamais", "statusCanal", "canais", "ramais", "MonitorCanalResource", "NotifyService", "ModalService", "LocalStorageService", function ($scope, $interval, $q, $timeout, totalCanais, totalCanaisDiscando,
            totalCanaisFalando, grupos, $translate, totalCanaisFalandoManual, totalCanaisLigacaoRecebida, totalCanaisLigacaoEmEspera,
            totalRamais, statusCanal, canais, ramais, MonitorCanalResource, NotifyService, ModalService, LocalStorageService) {
            let tempo = 5000;
            $scope.statusCanal = statusCanal;
            $scope.grupos = grupos;
            $scope.canais = canais;
            $scope.ramais = ramais;
            $scope.grupoSelecionado = 0;
            $scope.statusSelecionado = 0;
            $scope.PercentualEmUso = 0;
            $scope.filtro = {};
            $scope.filtroCanais = { canalI: 0, canalF: 0, grupoId: 0, status: '', pagina: 1, tipoFiltro: 0, nb: "", campanha: 0, ramalId: 0 };
            $scope.PaginaAtual = 1;
            $scope.RegistrosPorPagina = 10;
            $scope.RangePaginacao = [{ valor: 10, label: 10 }, { valor: 20, label: 20 }];
            $scope.ordenacaoAlias = "Status";
            $scope.ordenacaoCampo = "Status";
            $scope.ordenacaoTipo = "Asc";
            $scope.filtroAtivo = false;
            $scope.totalizador = {
                totalCanais: totalCanais.Quantidade,
                totalCanaisDiscando: totalCanaisDiscando.Quantidade,
                totalCanaisFalando: totalCanaisFalando.Quantidade,
                totalCanaisFalandoManual: totalCanaisFalandoManual.Quantidade,
                totalCanaisLigacaoRecebida: totalCanaisLigacaoRecebida.Quantidade,
                totalCanaisEmUso: totalCanaisDiscando.Quantidade + totalCanaisFalando.Quantidade + totalCanaisFalandoManual.Quantidade + totalCanaisLigacaoRecebida.Quantidade + totalCanaisLigacaoEmEspera.Quantidade,
                totalRamaisLogados: totalRamais.RamalLogados,
                totalRamaisTotal: totalRamais.RamalTotal
            }

            $scope.pesquisaGrupos = false;
            $scope.ativarPesquisaGrupo = function () {
                $scope.pesquisaGrupos = true;
                $timeout(function () {
                    $('#txtPesquisaGrupo').focus();
                }, 100);
            }
            $scope.desativarPesquisaGrupo = function (event) {
                if (event.target.value == null || event.target.value == '') {
                    $scope.pesquisaGrupos = false;
                    $scope.filtro.filtroGrupo = '';
                }
            }

            $scope.apenasGruposRelevantes = true;
            $scope.alternarVisaoGrupos = function () {
                $scope.apenasGruposRelevantes = !$scope.apenasGruposRelevantes;
                if (!$scope.apenasGruposRelevantes) {
                    $scope.limiteGrupo = null;
                } else {
                    $scope.limiteGrupo = $scope.limiteGrupoRelevante;
                }
            }

            $scope.fixarGrupo = function ($event, grupo) {
                if (!grupo.Fixado) {
                    $scope.adicionarGrupoFixado(grupo.GrupoId);
                } else {
                    $scope.removerGrupoFixado(grupo.GrupoId);
                }
                $scope.setOrdenacaoGrupo();
                $event.stopPropagation();
            }

            $scope.adicionarGrupoFixado = function (grupoId) {
                let gruposFixados = LocalStorageService.getItem('MonitorCanalGruposFixados');
                if (!Array.isArray(gruposFixados)) gruposFixados = [];
                let indexGrupo = gruposFixados.indexOf(grupoId);
                if (indexGrupo == -1) {
                    gruposFixados.push(grupoId);
                }
                LocalStorageService.setItem('MonitorCanalGruposFixados', gruposFixados);
            }

            $scope.removerGrupoFixado = function (grupoId) {
                let gruposFixados = LocalStorageService.getItem('MonitorCanalGruposFixados');
                if (!Array.isArray(gruposFixados)) gruposFixados = [];
                let indexGrupo = gruposFixados.indexOf(grupoId);
                if (indexGrupo != -1) {
                    gruposFixados.splice(indexGrupo, 1);
                }
                LocalStorageService.setItem('MonitorCanalGruposFixados', gruposFixados);
            }

            $scope.minimoGruposVisiveis = 4;
            $scope.setOrdenacaoGrupo = function () {
                let gruposFixados = LocalStorageService.getItem('MonitorCanalGruposFixados');
                if (Array.isArray(gruposFixados)) {
                    $scope.grupos.forEach((el) => {
                        const index = gruposFixados.indexOf(el.GrupoId);
                        el.Fixado = index >= 0;
                    });
                    gruposFixados = _.filter(gruposFixados, (fxId) => {
                        return _.find($scope.grupos, (gr) => {
                            return gr.GrupoId == fxId;
                        }) != null;
                    });
                } else {
                    gruposFixados = [];
                }

                if (gruposFixados.length < 4) {
                    $scope.limiteGrupoRelevante = 3;
                } else {
                    $scope.limiteGrupoRelevante = gruposFixados.length;
                }

                if (!$scope.apenasGruposRelevantes) {
                    $scope.limiteGrupo = null;
                } else {
                    $scope.limiteGrupo = $scope.grupos.length > $scope.minimoGruposVisiveis ? $scope.limiteGrupoRelevante : $scope.grupos.length;
                }

                $scope.grupos.sort((a, b) => {
                    if (a.Fixado === b.Fixado) {
                        return a.DescricaoFormatada > b.DescricaoFormatada ? 1 : -1;
                    }
                    return a.Fixado == true ? -1 : 1;
                });
            }
            $scope.setOrdenacaoGrupo();

            $scope.CalculaPercentualEmUso = function () {
                $scope.PercentualEmUso = ($scope.totalizador.totalCanaisEmUso / $scope.totalizador.totalCanais) * 100;
            }

            $scope.CalculaPercentualEmUso();

            $scope.filtrarCanalGrupo = function (grupoId) {
                $scope.grupoSelecionado = grupoId;
                $scope.filtroCanais.grupoId = grupoId;
                $scope.AtualizaTotalizador();
            }

            $scope.filtrarCanalStatus = function (status, total) {
                $scope.statusSelecionado = status;
                $scope.totalCanaisSelecionado = total;
                $scope.filtroCanais.status = $scope.statusSelecionado;
                $scope.AtualizaCanais();
            }

            $scope.AtualizaCanais = function () {
                let promise = MonitorCanalResource.getCanais($scope.filtroCanais).$promise;
                promise.then(function (data) {
                    $scope.canais = data;
                });
            }

            var atualizando = false;
            $scope.AtualizaTotalizador = function () {
                if (atualizando) return;
                atualizando = true;

                let filtro = {
                    grupoId: $scope.grupoSelecionado,
                }

                let totalCanaisPromise = MonitorCanalResource.getTotalCanais().$promise;
                let totalCanaisDiscandoPromise = MonitorCanalResource.getTotalCanaisDiscando(filtro).$promise;
                let totalCanaisFalandoPromise = MonitorCanalResource.getTotalCanaisFalando(filtro).$promise;
                let totalCanaisFalandoManualPromise = MonitorCanalResource.getTotalCanaisFalandoManual(filtro).$promise;
                let totalCanaisLigacaoEmEsperaPromise = MonitorCanalResource.getTotalCanaisLigacaoEmEspera(filtro).$promise;
                let totalCanaisLigacaoRecebidaPromise = MonitorCanalResource.getTotalCanaisLigacaoRecebida(filtro).$promise;
                let totalRamaisPromise = MonitorCanalResource.getTotalRamais(filtro).$promise;
                let getStatusCanaisPromise = MonitorCanalResource.getStatusCanais(filtro).$promise;
                let getCanaisPromise = MonitorCanalResource.getCanais($scope.filtroCanais).$promise;

                $q.all([totalCanaisPromise, totalCanaisDiscandoPromise, totalCanaisFalandoPromise, totalCanaisFalandoManualPromise,
                    totalCanaisLigacaoEmEsperaPromise, totalCanaisLigacaoRecebidaPromise, totalRamaisPromise,
                    getStatusCanaisPromise, getCanaisPromise]).then((data) => {
                        $scope.totalizador.totalCanaisEmUso = 0;
                        $scope.totalizador.totalCanais = data[0].Quantidade;
                        $scope.totalizador.totalCanaisDiscando = data[1].Quantidade;
                        $scope.totalizador.totalCanaisFalando = data[2].Quantidade;
                        $scope.totalizador.totalCanaisFalandoManual = data[3].Quantidade;
                        $scope.totalizador.totalCanaisLigacaoEmEspera = data[4].Quantidade;
                        $scope.totalizador.totalCanaisLigacaoRecebida = data[5].Quantidade;
                        $scope.totalizador.totalCanaisEmUso = data[1].Quantidade + data[2].Quantidade + data[3].Quantidade + data[4].Quantidade + data[5].Quantidade;
                        $scope.totalizador.totalRamaisLogados = data[6].RamalLogados;
                        $scope.totalizador.totalRamaisTotal = data[6].RamalTotal;
                        $scope.statusCanal = data[7];
                        $scope.canais = data[8];
                        $scope.CalculaPercentualEmUso();
                    }).catch(function (ex) {
                        NotifyService.showError(ex, 'telaMonitorCanal.naoFoiPossivelObterOsDados')
                    }).finally(function () {
                        atualizando = false;
                    });
            }

            $scope.calculaPaginacaoTotal = function () {
                let total = 0
                if ($scope.statusSelecionado == '') {
                    total = $scope.totalizador.totalCanais / $scope.RegistrosPorPagina;
                    if ($scope.totalizador.totalCanais % $scope.RegistrosPorPagina != 0) {
                        total += 1;
                    }
                }
                else {
                    total = $scope.totalCanaisSelecionado / $scope.RegistrosPorPagina;
                    if ($scope.totalCanaisSelecionado % $scope.RegistrosPorPagina != 0) {
                        total += 1;
                    }
                }
                return $scope.PaginaAtual + "/" + Math.floor(total);
            }

            $scope.intervalOnline = $interval(function () {
                $scope.AtualizaTotalizador();
            }, tempo);

            $scope.changeTotalPorPagina = function () {
                $scope.filtroCanais.pagina = 1;
                $scope.filtroCanais.pageSize = $scope.RegistrosPorPagina;
                $scope.AtualizaCanais();
            }

            var onVisibilityChange = function () {
                if (!document.hidden) {
                    $scope.AtualizaTotalizador();
                }
            };
            document.addEventListener('visibilitychange', onVisibilityChange);

            $scope.avancarPagina = function () {
                $scope.filtroCanais.pagina += 1;
                $scope.PaginaAtual = $scope.filtroCanais.pagina;
                $scope.AtualizaCanais();
            }

            $scope.retrocederPagina = function () {
                if ($scope.PaginaAtual > 1) {
                    $scope.filtroCanais.pagina -= 1;
                    $scope.PaginaAtual = $scope.filtroCanais.pagina;
                    $scope.AtualizaCanais();
                }
            }

            var callbackDesligarCanal = function () {
                NotifyService.showSuccess('telaMonitorCanal.canalDesligado');
            }

            var callbackLiberarOuBloquearCanal = function () {
                NotifyService.showSuccess();
            }

            $scope.desligarCanal = function (canal) {
                ModalService.confirmMessage('telaMonitorCanal.desejaRealmenteDesligarOCanal', null, function () {
                    var promise = MonitorCanalResource.getDesligarCanal(canal.Canal).$promise;
                    promise.then(function () {
                        callbackDesligarCanal();
                    }).catch(function (ex) {
                        NotifyService.showError(ex, 'telaMonitorCanal.naoFoiPossivelDesligarOCanal');
                    });
                });
            };

            $scope.popUpBoquearLiberar = function () {
                ModalService.openModal('modal_bloquear_liberar');
            };

            $scope.bloquear = { AcaoId: 1, TipoId: 1, CanalI: 1, CanalF: 5 };

            $scope.tipos = [
                { TipoId: 1, Descricao: $translate.instant('campo.entrante') },
                { TipoId: 2, Descricao: $translate.instant('campo.sainte') },
                { TipoId: 3, Descricao: $translate.instant('campo.todos') }
            ];

            $scope.acoes = [
                { AcaoId: 1, Descricao: $translate.instant('telaMonitorCanal.bloquear') },
                { AcaoId: 2, Descricao: $translate.instant('telaMonitorCanal.liberar') }
            ];

            $scope.bloquearOuLiberar = function (form) {
                if (!form.$valid) {
                    return;
                }

                ModalService.confirmMessage('telaMonitorCanal.confirmaAlteracao', null, function () {
                    var promise = MonitorCanalResource.getBloquearOuLiberar($scope.bloquear).$promise;
                    promise.then(function () {
                        callbackLiberarOuBloquearCanal();
                        ModalService.closeModal('modal_bloquear_liberar');
                    }).catch(function (ex) {
                        NotifyService.showError(ex, 'telaMonitorCanal.naoFoiPossivelBloquearSainte');
                    });
                });
            };

            $scope.setOrdenacao = function (campo) {
                $scope.orderBy = [campo];
                $scope.reverse = $scope.reverse ? false : true;
            };

            $scope.mostrarFiltros = function ($event) {
                $event.preventDefault();
                $scope.filtroAtivo = !$scope.filtroAtivo;
                $timeout(function () {
                    var card = angular.element('.md-card-grid');
                    if ($scope.filtroAtivo) {
                        card.addClass('md-card-overlay-active');
                    } else {
                        card.removeClass('md-card-overlay-active');
                    }
                }, 100);
                $scope.filtroCanais.pagina = 1;
                $scope.PaginaAtual = $scope.filtroCanais.pagina;
                $scope.AtualizaCanais();
            };

            $scope.onChangeTipoFiltro = function (tipo) {
                $scope.filtroCanais.tipoFiltro = tipo;
            }

            $scope.limparFiltros = function () {
                $scope.filtroCanais.tipoFiltro = 0;
                $scope.filtroCanais.ramalId = 0;
                $scope.filtroCanais.nb = "";
                $scope.filtroCanais.campanha = 0;
            };

            $scope.$on('$destroy', function controllerMonitorCanalDestroy() {
                $interval.cancel($scope.intervalOnline);
                document.removeEventListener('visibilitychange', onVisibilityChange);
            });
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("MonitorCanalResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MonitorCanal/:Id",
                {
                    "Id": "@Id"
                },
                {
                    getTotalCanais: {
                        url: "MonitorCanal/TotalCanais",
                        method: "GET",
                        isArray: false
                    },
                    getTotalCanaisDiscando: {
                        url: "MonitorCanal/TotalCanaisDiscando",
                        method: "GET",
                        isArray: false
                    },
                    getTotalCanaisFalando: {
                        url: "MonitorCanal/TotalCanaisFalando",
                        method: "GET",
                        isArray: false
                    },
                    getTotalCanaisFalandoManual: {
                        url: "MonitorCanal/TotalCanaisFalandoManual",
                        method: "GET",
                        isArray: false
                    },
                    getTotalCanaisLigacaoRecebida: {
                        url: "MonitorCanal/TotalCanaisLigacaoRecebida",
                        method: "GET",
                        isArray: false
                    },
                    getTotalCanaisLigacaoEmEspera: {
                        url: "MonitorCanal/TotalCanaisLigacaoEmEspera",
                        method: "GET",
                        isArray: false
                    },
                    getTotalRamais: {
                        url: "MonitorCanal/TotalRamais",
                        method: "GET",
                        isArray: false
                    },
                    getStatusCanais: {
                        url: "MonitorCanal/StatusCanais",
                        method: "GET",
                        isArray: true
                    },
                    getCanais: {
                        url: "MonitorCanal",
                        method: "GET",
                        isArray: true
                    },
                    getDesligarCanal: {
                        url: "MonitorCanal/DesligarCanal",
                        method: "POST"
                    },
                    getBloquearOuLiberar: {
                        url: "MonitorCanal/BloquearOuLiberar",
                        method: "POST",
                        isArray: false
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .controller("CampanhaAlarmeController",
            ["$scope", "IndicadorResource", "IndicadorCampanhaAlarmeResource", "GrupoResource", "NotifyService", "$translate", "ModalService", function ($scope, IndicadorResource, IndicadorCampanhaAlarmeResource, GrupoResource, NotifyService, $translate, ModalService) {
                $scope.getGrupos = function () {
                    var odata = GrupoResource.odata().orderBy('Descricao', 'asc');                    
                    return odata.query().then(function (data) {
                        $scope.grupos = data;
                    });
                }

                $scope.getGrupos();

                var getAlarmes = function (grupoId, indicadorTipoId) {
                    var odata = IndicadorCampanhaAlarmeResource.odata().orderBy('Indicador/Nome');

                    if (grupoId) {
                        odata = odata.where('GrupoId', grupoId);
                    }

                    if (indicadorTipoId) {
                        odata = odata.where('Indicador/IndicadorTipo/IndicadorTipoId', indicadorTipoId);
                    }

                    return odata.query().then(function (data) {
                        $scope.alarmes = data;
                    });
                };

                var getAlarmesSelecao = function () {
                    return getAlarmes($scope.filtro.GrupoId, $scope.filtro.IndicadorTipoId);
                }

                $scope.getAlarmeAlias = function (id) {
                    if (id > 0) {
                        var indicador = _.find($scope.indicadorList, function (el) {
                            return el.IndicadorId == id
                        });
                        if (indicador != null) return indicador.Nome;
                    }
                    return '';
                }

                $scope.alarmeEdit = {}
                $scope.filtro = {};
                $scope.indicadorList = [];
                $scope.indicadorListFiltrado = [];
                $scope.alarmes = [];

                IndicadorResource.odata().where('IndicadorTipoId', IndicadorResource.TipoIdCampanha).orderBy('Nome').query()
                    .then(function (data) {
                        $scope.indicadorList = _.filter(data, function (el) {
                            return el.Alarme == true;
                        });
                    });

                $scope.filtroOperador = function (item) {
                    return item.Operador == '>' || item.Operador == '<';
                }

                $scope.adicionarAlarme = function () {
                    $scope.filtro.mostrarEdit = true;
                    $scope.indicadorListFiltrado = _.filter($scope.indicadorList, function (indicador) {
                        return _.find($scope.alarmes, function (alarme) { return indicador.IndicadorId == alarme.IndicadorId; }) == null;
                    });
                }

                $scope.estilos = [{
                    valor: '#1976D2',
                    descricao: $translate.instant('telaMonitorCampanha.azul')
                },
                {
                    valor: '#e28327',
                    descricao: $translate.instant('telaMonitorCampanha.laranja')
                },
                {
                    valor: '#e53935',
                    descricao: $translate.instant('telaMonitorCampanha.vermelho')
                }];

                $scope.getEstilo = function (valor) {
                    return _.findWhere($scope.estilos, { valor: valor });
                }

                $scope.onGrupo = function () {
                    $scope.alarmeEdit = {};
                    $scope.filtro.mostrarEdit = false;
                    return getAlarmes($scope.filtro.GrupoId);
                }

                $scope.remove = function (grupo) {
                    ModalService.confirmDelete(function () {
                        return IndicadorCampanhaAlarmeResource.remove(grupo).$promise
                            .then(NotifyService.showSuccess(), getAlarmesSelecao)
                            .catch(NotifyService.showError);
                    });
                }

                $scope.salvar = function (form, dto) {
                    dto.GrupoId = $scope.filtro.GrupoId;
                    if (dto.ValorTMA != null) {
                        var unidadesTempo = dto.ValorTMA.split(':');
                        dto.Valor = (parseInt(unidadesTempo[0]) * 60 * 60) + (parseInt(unidadesTempo[1]) * 60) + (parseInt(unidadesTempo[2]));
                    }

                    return IndicadorCampanhaAlarmeResource.save(dto).$promise
                        .then(NotifyService.showSuccess(), getAlarmesSelecao)
                        .then(function () {
                            if (!dto.IndicadorCampanhaAlarmeId) {
                                $scope.alarmeEdit = {};
                                $scope.filtro.mostrarEdit = false;
                            }
                            form.$setPristine();
                            form.$submitted = false;
                        })
                        .catch(NotifyService.showError);
                }

                $('#modal_alarme_campanha').on({
                    'hide.uk.modal': function () {
                        $scope.alarmeEdit = {}
                        $scope.filtro = {};
                        $scope.alarmes = [];
                    }
                });
            }]
        );

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("IndicadorCampanhaAlarmeResource", ["$odataresource", function ($odataresource) {
            return $odataresource("IndicadorCampanhaAlarme/:IndicadorCampanhaAlarmeId", {
                "IndicadorCampanhaAlarmeId": "@IndicadorCampanhaAlarmeId"
            });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .controller("MetricaCampanhaController",
            ["$scope", "CampanhaResource", "MonitorCampanhaIndicadorResource", "NotifyService", "ModalService", function ($scope, CampanhaResource, MonitorCampanhaIndicadorResource, NotifyService, ModalService) {
                $scope.CampanhaSelecionadaId = 0;
                $scope.CampanhaSelecionada = {};
                $scope.campanhas = [];
                $scope.indicadores = [];
                $scope.carregando = false;
                $scope.primeiroClick = true;
                $scope.clickFavorito = 0

                let odata = CampanhaResource.odata();
                odata.filter('Visivel', true);

                odata.query().then(function (result) {
                    $scope.campanhas = result;
                });

                $scope.getList = function () {
                    MonitorCampanhaIndicadorResource.getMetricaCampanha({ campanhaId: $scope.CampanhaSelecionadaId }, function (result) {
                        $scope.indicadores = result;
                    });
                };

                $scope.onChangeCampanha = function () {
                    $scope.CampanhaSelecionadaId = $scope.CampanhaSelecionada.CampanhaSelecionadaId;
                    $scope.primeiroClick = true;
                    $scope.carregando = true;
                    $scope.getList();

                };

                $scope.salvar = function () {
                    let favoritos = _.where($scope.indicadores, { Favorito: true });
                    if (favoritos.length > 5) {
                        NotifyService.showError(null, "Selecionar somente 5 indicadores.");
                        return;
                    }
                    let obj = {
                        MonitorCampanhaIndicador: $scope.indicadores,
                        CampanhaId: $scope.CampanhaSelecionadaId
                    };
                    MonitorCampanhaIndicadorResource.postMetricaCampanha(obj).$promise.then(function () {
                        ModalService.closeModal('modal_metricaCampanha');
                        NotifyService.showSuccess();
                    }).catch(NotifyService.showError);
                };

            }]
        );
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")
        .filter('monitorCampanhaFilter', ["$filter", "MonitorCampanhaService", function ($filter, MonitorCampanhaService) {
            return function (items, search, grupos) {
                if (search.GrupoId) {
                    items = _.filter(items, function (campanha) {
                        if (campanha.Grupos) {
                            return campanha.Grupos.indexOf(parseInt(search.GrupoId)) > -1;
                        }
                    });
                }

                if (search.CarteiraId) {
                    items = _.filter(items, function (campanha) {
                        if (campanha.Carteiras) {
                            return campanha.Carteiras.indexOf(parseInt(search.CarteiraId)) > -1;
                        }
                    });
                }

                if (search.CampanhaStatusId) {
                    items = _.where(items, { CampanhaStatusId: search.CampanhaStatusId });
                }

                if (search.CampanhaTipoId) {
                    items = _.where(items, { CampanhaTipoId: search.CampanhaTipoId });
                }

                if (search.DiscagemVertical !== null) {
                    items = _.where(items, { DiscagemVertical: search.DiscagemVertical });
                }

                if (search.Flutuante !== null) {
                    items = _.where(items, { Flutuante: search.Flutuante });
                }

                if (search.PesquisarCampanha != null) {
                    var numero = parseInt(search.PesquisarCampanha);

                    if (numero) {
                        items = _.filter(items, function (el) {
                            const estaEmGrupo = _.any(grupos, (grupo) => {
                                // Verifica se o numero pesquisado é um ramal de grupo e se a campanha está no grupo
                                return grupo.RamalNumero == numero && el.Grupos != null && el.Grupos.indexOf(grupo.GrupoId) >= 0;
                            });
                            return el.CampanhaId == numero || estaEmGrupo;
                        });
                    } else {
                        items = _.filter(items, function (el) {
                            const estaEmGrupo = _.any(grupos, (grupo) => {
                                // Verifica se o texto pesquisado é a descrição de um grupo e se a campanha está no grupo
                                return grupo.Descricao.toLowerCase().startsWith(search.PesquisarCampanha.toLowerCase())
                                    && el.Grupos != null && el.Grupos.indexOf(grupo.GrupoId) >= 0;
                            });
                            return el.CampanhaDescricao.toLowerCase().startsWith(search.PesquisarCampanha.toLowerCase()) || estaEmGrupo;
                        });
                    }
                }

                MonitorCampanhaService.campanhas = items;
                MonitorCampanhaService.numberOfPages = Math.ceil(items.length / MonitorCampanhaService.pageSize);

                if (items.length >= MonitorCampanhaService.pageSize) {
                    let begin = (MonitorCampanhaService.currentPage * MonitorCampanhaService.pageSize);
                    let end = begin + MonitorCampanhaService.pageSize;
                    items = items.slice(begin, end);
                } else {
                    MonitorCampanhaService.currentPage = 0;
                }

                return items;
            };
        }])


        .filter('ramaisLivreFilterMonitorCampanha', ["$translate", function ($translate) {
            return function (grupos, grupoId) {
                let count = 0;
                if (grupoId) {
                    
                    let currentLang = (localStorage.getItem('idioma') || 'pt').replace(/"/g, '');
                                        
                    let statusLivre = {
                        'pt': 'Livre',
                        'es': 'Libre',
                        'en': 'Available'
                    }[currentLang] || 'Livre'; 

                    let livre = grupos.filter(item => item.GrupoId == grupoId && item.Status == statusLivre);
               
                    if (livre.length == 1) count += livre[0].Total;
                }
                return count;
            };
        }])


        .filter('ramaisOnLineFilterMonitorCampanha', function () {
            return function (grupos, grupoId) {
                let count = 0;
                if (grupoId) {                    
                    let currentLang = (localStorage.getItem('idioma') || 'pt').replace(/"/g, '');
                                        
                    let statusNaoLogado = {
                        'pt': 'Não Logado',
                        'es': 'No Conectado',
                        'en': 'Not Logged'
                    }[currentLang] || 'Não Logado'; 

                    let logados = grupos.filter(item => item.GrupoId == grupoId && item.Status != statusNaoLogado);

                    if (logados.length > 0) {
                        logados.forEach(item => {
                            count += item.Total;
                        });
                    }
                }
                return count;
            };
        })



        .filter('discandoCampanhaFilter', function () {
            return function (list, campanhaId) {
                let count = 0;
                if (campanhaId) {
                    let discando = _.where(list, { Status: 'DiscandoDiscador', CampanhaId: campanhaId });
                    let discandoAgendamento = _.where(list, { Status: 'DiscandoDiscadorLigacaoAgendada', CampanhaId: campanhaId});

                    if (discando.length == 1) count += discando[0].Total;
                    if (discandoAgendamento.length == 1) count += discandoAgendamento[0].Total;
                }
                return count;
            };
        })

        .filter('falandoCampanhaFilter', function () {
            return function (list, campanhaId) {
                let count = 0;
                if (campanhaId) {
                    let atendidas = _.where(list, { Status: 'AtendidoChamadaDiscador', CampanhaId: campanhaId });
                    let atendidasAgendadas = _.where(list, { Status: 'AtendidoChamadaDiscadorLigacaoAgendada', CampanhaId: campanhaId });

                    if (atendidas.length == 1) count += atendidas[0].Total;
                    if (atendidasAgendadas.length == 1) count += atendidasAgendadas[0].Total;
                }
                return count;
            };
        })

        .filter('falandoListCampanhaFilter', function () {
            return function (list, campanhaId) {
                let items = [];
                if (campanhaId) {
                    items = _.where(list, {
                        Estado: 'AtendidoChamadaDiscador',
                        Campanha: campanhaId
                    });
                }
                return items;
            };
        })

        .filter('discandoListCampanhaFilter', function () {
            return function (list, campanhaId) {
                let items = [];
                if (campanhaId) {
                    items = _.where(list, {
                        Estado: 'DiscandoDiscador',
                        Campanha: campanhaId
                    });
                }
                return items;
            };
        })

        .filter('monitorIndicadorPorCampanha', function () {
            return function (list, campanhaId) {
                let items = [];
                if (campanhaId) {
                    items = _.where(list, {
                        CampanhaId: campanhaId
                    });
                }
                return items;
            };
        })

        .filter('monitorGrupo', function () {
            return function (items, search, campanhas) {

                if (search.CampanhaStatusId) {
                    campanhas = _.where(campanhas, { CampanhaStatusId: search.CampanhaStatusId });
                }

                if (search.CampanhaTipoId) {
                    campanhas = _.where(campanhas, { CampanhaTipoId: search.CampanhaTipoId });
                }

                if (search.DiscagemVertical !== null) {
                    campanhas = _.where(campanhas, { DiscagemVertical: search.DiscagemVertical });
                }

                if (search.Flutuante !== null) {
                    campanhas = _.where(campanhas, { Flutuante: search.Flutuante });
                }

                if (search.CarteiraId > 0) {
                    items = _.where(items, { CarteiraId: search.CarteiraId });
                }

                items = _.filter(items, (grupo) => {
                    grupo.TotalCampanhas = _.filter(campanhas, (campanha) => campanha.Grupos != null && campanha.Grupos.indexOf(grupo.GrupoId) >= 0).length;
                    return grupo.GrupoId == 0 || grupo.TotalCampanhas > 0;
                });

                return items;
            };
        })
})();

(function () {
    "use strict";
    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.monitorcampanha", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.monitorcampanha.list',
                        pageTitle: 'pageTitle.monitorDeCampanha',
                        pageName: 'pageTitle.pesquisar',
                    }
                })
                .state("main.monitorcampanha.list", StateResolverProvider.configState("/monitorcampanha", "MonitorCampanha", "List", {
                    pageTitle: 'pageTitle.monitorDeCampanha',
                    pageName: 'pageTitle.pesquisar',
                    params: { grupoId: null },
                    css: true,
                    cssFiles: ['app/pages/monitorCampanha/style/list.css', 'app/pages/monitorCampanha/style/filtros.css']
                }));
        }])
        .service('MonitorCampanhaService', function MonitorCampanhaService() {
            var service = {
                campanhas: {},
                numberOfPages: 0,
                currentPage: 0,
                pageSize: 10
            };

            return service;
        })
        .service('MonitorCampanhaListData', function MonitorCampanhaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_countUp',
                            'lazy_ionRangeSlider',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    grupos: ["MonitorCampanhaResource", function (MonitorCampanhaResource) {
                        return MonitorCampanhaResource.GetGrupos().$promise;
                    }],
                    campanhas: ["MonitorCampanhaResource", function (MonitorCampanhaResource) {
                        return MonitorCampanhaResource.GetCampanhas({
                            Tempo: 60,
                            VisaoSelecionada: localStorage.getItem('campanha_monitor_visao') === null ? 1 : parseInt(localStorage.getItem('campanha_monitor_visao')),
                        }).$promise;
                    }],
                    indicadoresCliente: ["MonitorCampanhaResource", function (MonitorCampanhaResource) {
                        return MonitorCampanhaResource.GetIndicador({
                            Visao: 1,
                            Data: moment(new Date()).format('YYYY-MM-DD')
                        }).$promise;
                    }],
                    indicadoresMailing: ["MonitorCampanhaResource", function (MonitorCampanhaResource) {
                        return MonitorCampanhaResource.GetIndicador({
                            Visao: 2,
                            Tempo: localStorage.getItem('campanha_monitor_periodo') === null ? 60 : parseInt(localStorage.getItem('campanha_monitor_periodo'))
                        }).$promise;
                    }],
                    statuses: ["CampanhaStatusResource", function (CampanhaStatusResource) {
                        var odata = CampanhaStatusResource.odata();
                        odata.filter('Visivel', true);
                        return odata.query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })
        .controller("MonitorCampanhaListController", ["$interval", "$state", "$stateParams", "$scope", "$timeout", "$window", "$rootScope", "grupos", "statuses", "campanhas", "indicadoresMailing", "indicadoresCliente", "LocalStorageService", "MonitorCampanhaService", "MonitorCampanhaResource", "CampanhaResource", "NotifyService", "$translate", "CampanhaArquivoResource", "ModalService", "carteiras", function ($interval, $state, $stateParams, $scope, $timeout, $window, $rootScope,
            grupos, statuses, campanhas, indicadoresMailing, indicadoresCliente, LocalStorageService, MonitorCampanhaService,
            MonitorCampanhaResource, CampanhaResource, NotifyService, $translate, CampanhaArquivoResource, ModalService, carteiras) {
            $rootScope.page_full_height = true;
            $scope.pesquisaCampanha = false;


            let campanhasById = {};
            let indicadorTimerId;
            let indicadorTimerIndicadorId;
            let tempo = 5000;
            $scope.exibeCusto = true;
            $scope.resumoImportacaoScoreBigTalk = [];
            $scope.resumoImportacaoScoreBigTalkGrafico = [];
            $scope.campanhaGraficoBigTalk = 0;        
            $scope.campanhaComparacaoA = { CampanhaId: 0, Indicador: null, Campanha: null };
            $scope.campanhaComparacaoB = { CampanhaId: 0, Indicador: null, Campanha: null };
            $scope.grupoStatus = [];

            $scope.tipoDiscagem = [
                { Descricao: $translate.instant('campo.selecione'), Valor: null, Icone: '' },
                { Descricao: $translate.instant('telaMonitorCampanha.vertical'), Valor: true, Icone: 'V' },
                { Descricao: $translate.instant('telaMonitorCampanha.horizontal'), Valor: false, Icone: 'H' }
            ];

            $scope.tipoFlutuante = [
                { Descricao: $translate.instant('campo.selecione'), Valor: null, Icone: '' },
                { Descricao: $translate.instant('telaMonitorCampanha.naoFlutuante'), Valor: false, Icone: '' },
                { Descricao: $translate.instant('telaMonitorCampanha.flutuante'), Valor: true, Icone: 'F' }
            ];

            $scope.modoDiscagem = [
                { Descricao: $translate.instant('campo.selecione'), Valor: 0, Icone: '', Classe: '' },
                { Descricao: $translate.instant('telaMonitorCampanha.bigTalk'), Valor: 1, Icone: 'B', Classe: 'flutuante' }
            ];

            $scope.periodoConsulta = [{
                Descricao: $translate.instant('telaMonitorCampanha.todos'),
                Valor: null
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.ultimaHora'),
                Valor: 60
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.ultimas4Horas'),
                Valor: 240
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.ultimas8Horas'),
                Valor: 480
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.hoje'),
                Valor: moment().hours() * 60 + moment().minutes()
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.umaSemana'),
                Valor: 10080
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.15Dias'),
                Valor: 43200
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.30Dias'),
                Valor: 86400
            }];

            $scope.ordenacoes = [{
                Descricao: $translate.instant('telaMonitorCampanha.ordenacaoDiscados'),
                Valor: 1
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.ordenacaoMailinglivre'),
                Valor: 2
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.ordenacaoRediscagem'),
                Valor: 3
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.ordenacaoMailingimportado'),
                Valor: 4
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.agressividade'),
                Valor: 5
            }, {
                Descricao: $translate.instant('campo.nome'),
                Valor: 6
            }];

            $scope.tiposCampanha = [{
                Descricao: $translate.instant('campo.selecione'),
                CampanhaTipoId: 0,
                Icone: '',
                Classe: ''
            }, {
                Descricao: $translate.instant('model.discador'),
                CampanhaTipoId: 1,
                Icone: 'supervisor_account',
                Classe: 'tipoCampanhaPadrao'
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.callback'),
                CampanhaTipoId: 2,
                Icone: 'settings_backup_restore',
                Classe: 'tipoCampanhaCallback'
            }, {
                Descricao: $translate.instant('telaMonitorCampanha.higienizacao'),
                CampanhaTipoId: 3,
                Icone: 'delete_sweep',
                Classe: 'tipoCampanhaHigienizacao'
            }, {
                Descricao: $translate.instant('campo.talkbot'),
                CampanhaTipoId: 4,
                Icone: 'adb',
                Classe: 'tipoCampanhaTalkbot'
            }];

            
            $scope.campanhas = campanhas;
            $scope.campanhasComparacao = campanhas;
            $scope.campanhasBigTalk = {};
            $scope.searchComparacao = {
                CampanhaTipoId: 0,
                ModoId: 0,
            };

            $scope.campanhasComparacao.forEach(campanha => {
                campanha.descricaoCompleta = campanha.CampanhaId + ' - ' + campanha.CampanhaDescricao;
            });

            $scope.tipoVisualizacao = 2;
            $scope.tipoAvancado = false;
            $scope.canais = [];
            $scope.search = {
                GrupoId: localStorage.getItem('campanha_grupo_visao') === null ? 0 : parseInt(localStorage.getItem('campanha_grupo_visao')),
                CarteiraId: localStorage.getItem('campanha_carteira') === null ? 0 : parseInt(localStorage.getItem('campanha_carteira')),
                CampanhaTipoId: localStorage.getItem('campanha_tipo') === null || localStorage.getItem('campanha_tipo') === 'null' ? 1 : parseInt(localStorage.getItem('campanha_tipo')),
                DiscagemVertical: localStorage.getItem('campanha_discagem_tipo') == 'true' ? true : localStorage.getItem('campanha_discagem_tipo') == 'false' ? false : null,
                Flutuante: localStorage.getItem('campanha_flutuante') == 'true' ? true : localStorage.getItem('campanha_flutuante') == 'false' ? false : null,
                CampanhaStatusId: localStorage.getItem('campanha_status') === null ? 3 : parseInt(localStorage.getItem('campanha_status')),
                Tempo: localStorage.getItem('campanha_monitor_periodo') === null ? 60 : parseInt(localStorage.getItem('campanha_monitor_periodo')),
                ordenacao: localStorage.getItem('ordenacao') === null ? 1 : parseInt(localStorage.getItem('ordenacao'))
            };

            if ($stateParams.grupoId) {
                $scope.search.GrupoId = $stateParams.grupoId;
            }

            $scope.MonitorCampanhaService = MonitorCampanhaService;
            $scope.grupos = grupos;
            $scope.carteiras = carteiras;
            
            $scope.statuses = statuses;
            $scope.statuses.unshift({ CampanhaStatusId: 0, Descricao: $translate.instant('campo.selecione') });
            $scope.statusCampanhas = [];
            $scope.campanhaSelecionada = {};
            $scope.viewQuantidade = localStorage.getItem('campanha_monitor_visao_quantidade') == "true";
            $scope.visaoSelecionada = localStorage.getItem('campanha_monitor_visao') === null ? 1 : parseInt(localStorage.getItem('campanha_monitor_visao'));
            $scope.indicadoresMailing = indicadoresMailing;
            $scope.indicadoresCliente = indicadoresCliente;
            $scope.intervalOnline = $interval(function () {
                $scope.AtualizaCanais();
                $scope.AtualizaGruposStatus();
            }, tempo);

            $scope.fixarGrupo = function ($event, grupo) {
                if (!grupo.Fixado) {
                    $scope.adicionarGrupoFixado(grupo.GrupoId);
                } else {
                    $scope.removerGrupoFixado(grupo.GrupoId);
                }
                $scope.setOrdenacaoGrupo();
                $event.stopPropagation();
            }

            
            $scope.resetarCampanhasComparacao = function (fechouModal){
                $scope.campanhaComparacaoA = { CampanhaId: 0, Indicador: null, Campanha: null };
                $scope.campanhaComparacaoB = { CampanhaId: 0, Indicador: null, Campanha: null };
                if(fechouModal){
                    $scope.searchComparacao.CampanhaTipoId = 0;    
                    $scope.searchComparacao.ModoId = 0;
                }
            }

            $scope.filtroTipoComparacao = function (filtro) {
                $scope.resetarCampanhasComparacao(false);
                $scope.searchComparacao.CampanhaTipoId = filtro;
                $scope.filtrarCombosComparacao();
            };

            $scope.filtroBigTalk = function (filtro) {
                $scope.resetarCampanhasComparacao(false);
                $scope.searchComparacao.ModoId = filtro;
                $scope.filtrarCombosComparacao();
            };

            $scope.filtrarCombosComparacao = function (){
                var campanhasFiltradas = $scope.campanhas;

                //Filtro Tipo
                if($scope.searchComparacao.CampanhaTipoId != 0)
                    campanhasFiltradas = campanhasFiltradas.filter(campanha => campanha.CampanhaTipoId == $scope.searchComparacao.CampanhaTipoId);

                //Filtro Modo
                if($scope.searchComparacao.ModoId != 0)
                    campanhasFiltradas = campanhasFiltradas.filter(campanha => campanha.BigTalk == 1);

                $scope.campanhasComparacao = campanhasFiltradas;
            }

            $scope.alterouComparacao = function(campanha, indicador, combobox){
                if(indicador && campanha){
                    let qtdInsucesso = indicador.QtdDiscado - indicador.QtdAtendida;
                    indicador.PercentualAtendida  = indicador.QtdDiscado == 0 ? 0 : ((indicador.QtdAtendida * 100) / indicador.QtdDiscado);
                    indicador.PercentualInsucesso = indicador.QtdDiscado == 0 ? 0 : ((qtdInsucesso * 100) / indicador.QtdDiscado);
                    indicador.PercentualMaquina = indicador.QtdAteMaquina == 0 ? 0 : ((indicador.QtdAteMaquina * 100) / indicador.QtdDiscado);
                    indicador.PercentualCongest = indicador.QtdCongestionamento == 0 ? 0 : ((indicador.QtdCongestionamento * 100) / indicador.QtdDiscado);
                    
                    if(combobox == 1){
                        $scope.campanhaComparacaoA.Indicador = indicador;
                        $scope.campanhaComparacaoA.Campanha = campanha;
                    }else{
                        $scope.campanhaComparacaoB.Indicador = indicador;
                        $scope.campanhaComparacaoB.Campanha = campanha;
                    }
                }
            }

            $scope.alterouComparacaoA = function (){
                let indicador = $scope.indicadoresCliente.find(x => x.CampanhaId == $scope.campanhaComparacaoA.CampanhaId);
                let campanha = $scope.campanhas.find(x => x.CampanhaId == $scope.campanhaComparacaoA.CampanhaId);
                $scope.alterouComparacao(campanha, indicador, 1);
            }
            $scope.alterouComparacaoB = function (){
                let indicador = $scope.indicadoresCliente.find(x => x.CampanhaId == $scope.campanhaComparacaoB.CampanhaId);
                let campanha = $scope.campanhas.find(x => x.CampanhaId == $scope.campanhaComparacaoB.CampanhaId);
                $scope.alterouComparacao(campanha, indicador, 2);
            }

            $scope.getRankingCampanha = function (campanhaReferencia) {
                let pontosCampanhaA = 0;
                let pontosCampanhaB = 0;

                let indicadorA = $scope.campanhaComparacaoA.Indicador;
                let indicadorB = $scope.campanhaComparacaoB.Indicador;

                if(indicadorA.QtdDiscado > indicadorB.QtdDiscado)
                    pontosCampanhaA++;
                if(indicadorB.QtdDiscado > indicadorA.QtdDiscado)
                    pontosCampanhaB++;

                if(indicadorA.PercentualAtendida > indicadorB.PercentualAtendida)
                    pontosCampanhaA++;
                if(indicadorB.PercentualAtendida > indicadorA.PercentualAtendida)
                    pontosCampanhaB++;

                //Insucesso
                if(indicadorB.PercentualInsucesso > indicadorA.PercentualInsucesso)
                    pontosCampanhaA++;
                if(indicadorA.PercentualInsucesso > indicadorB.PercentualInsucesso)
                    pontosCampanhaB++;

                //Maquina
                if(indicadorB.PercentualMaquina > indicadorA.PercentualMaquina)
                    pontosCampanhaA++;
                if(indicadorA.PercentualMaquina > indicadorB.PercentualMaquina)
                    pontosCampanhaB++;

                //Congest
                if(indicadorB.PercentualCongest > indicadorA.PercentualCongest)
                    pontosCampanhaA++;
                if(indicadorA.PercentualCongest > indicadorB.PercentualCongest)
                    pontosCampanhaB++;

                if(pontosCampanhaA == pontosCampanhaB)
                    return 0;

                if(campanhaReferencia == 1){ // CampanhaA
                    if (pontosCampanhaA > pontosCampanhaB) 
                        return 1
                    else
                        return -1
                }else{
                    if (pontosCampanhaB > pontosCampanhaA)
                        return 1
                    else
                        return -1
                }
            }

            $scope.adicionarGrupoFixado = function (grupoId) {
                let gruposFixados = LocalStorageService.getItem('MonitorGruposFixados');
                if (!Array.isArray(gruposFixados)) gruposFixados = [];
                let indexGrupo = gruposFixados.indexOf(grupoId);
                if (indexGrupo == -1) {
                    gruposFixados.push(grupoId);
                }
                LocalStorageService.setItem('MonitorGruposFixados', gruposFixados);
            }

            $scope.removerGrupoFixado = function (grupoId) {
                let gruposFixados = LocalStorageService.getItem('MonitorGruposFixados');
                if (!Array.isArray(gruposFixados)) gruposFixados = [];
                let indexGrupo = gruposFixados.indexOf(grupoId);
                if (indexGrupo != -1) {
                    gruposFixados.splice(indexGrupo, 1);
                }
                LocalStorageService.setItem('MonitorGruposFixados', gruposFixados);
            }


            $scope.apenasGruposRelevantes = true;
            $scope.alternarVisaoGrupos = function () {
                $scope.apenasGruposRelevantes = !$scope.apenasGruposRelevantes;
                if (!$scope.apenasGruposRelevantes) {
                    $scope.limiteGrupo = null;
                } else {
                    $scope.limiteGrupo = $scope.limiteGrupoRelevante;
                }
            }

            $scope.minimoGruposVisiveis = 4;
            $scope.setOrdenacaoGrupo = function () {
                let gruposFixados = LocalStorageService.getItem('MonitorGruposFixados');
                if (Array.isArray(gruposFixados)) {
                    $scope.grupos.forEach((el) => {
                        const index = gruposFixados.indexOf(el.GrupoId);
                        el.Fixado = index >= 0;
                    });
                    gruposFixados = _.filter(gruposFixados, (fxId) => {
                        return _.find($scope.grupos, (gr) => {
                            return gr.GrupoId == fxId;
                        }) != null;
                    });
                } else {
                    gruposFixados = [];
                }

                if (gruposFixados.length < 4) {
                    $scope.limiteGrupoRelevante = 3;
                } else {
                    $scope.limiteGrupoRelevante = gruposFixados.length;
                }

                if (!$scope.apenasGruposRelevantes) {
                    $scope.limiteGrupo = null;
                } else {
                    $scope.limiteGrupo = $scope.grupos.length > $scope.minimoGruposVisiveis ? $scope.limiteGrupoRelevante : $scope.grupos.length;
                }

                $scope.grupos.sort((a, b) => {
                    if (a.Fixado === b.Fixado) {
                        return a.DescricaoFormatada > b.DescricaoFormatada ? 1 : -1;
                    }
                    return a.Fixado == true ? -1 : 1;
                });
            }
            $scope.setOrdenacaoGrupo();

            $scope.AtualizaCanais = function () {
                let promise = MonitorCampanhaResource.GetMonitorCanaisAgrupadosCampanha().$promise;
                promise.then(function (data) {
                    $scope.canais = data;
                });
            };

            $scope.AtualizaGruposStatus = function () {
                let promise = MonitorCampanhaResource.GetGruposStatusAgrupados().$promise;
                promise.then(function (data) {
                    $scope.grupoStatus = data;
                });
            };


            $scope.visaoConsulta = [
                {
                    Descricao: $translate.instant('telaMonitorCampanha.visaoCliente'),
                    Valor: 1
                },
                {
                    Descricao: $translate.instant('telaMonitorCampanha.visaoMailing'),
                    Valor: 2
                }
            ];

            _.each($scope.campanhas, function (value) {
                campanhasById[value.CampanhaId] = value;
            });

            $scope.progressBarClass = function (consumo) {
                if (consumo > 0 && consumo < 20) {
                    return 'uk-progress uk-progress-danger';
                } else if (consumo > 20 && consumo < 70) {
                    return 'uk-progress uk-progress-warning';
                } else {
                    return 'uk-progress uk-progress-success';
                }
            };

            $scope.minimoCarteirasVisiveis = 3;
            $scope.apenasCarteirasRelevantes = true;
            $scope.limiteCarteira = 3;
            $scope.alternarVisaoCarteiras = function () {
                $scope.apenasCarteirasRelevantes = !$scope.apenasCarteirasRelevantes;
                if (!$scope.apenasCarteirasRelevantes) {
                    $scope.limiteCarteira = null;
                } else {
                    $scope.limiteCarteira = $scope.minimoCarteirasVisiveis;
                }
            }

            $scope.atualizandoIndicadorContador = 0;
            $scope.atualizarIndicadores = function () {
                $scope.atualizandoIndicadorContador++;
                const indicadorAtualContador = $scope.atualizandoIndicadorContador;
                if (indicadorTimerIndicadorId) {
                    $timeout.cancel(indicadorTimerIndicadorId);
                }

                const filtro = { Visao: $scope.visaoSelecionada };
                if (filtro.Visao == 2) {
                    filtro.Tempo = $scope.search.Tempo;
                }

                MonitorCampanhaResource.GetIndicador(filtro).$promise
                    .then(function (data) {
                        //Atualiza os scores
                        data.forEach(campanhaIndicador => {
                           var campanha = $scope.campanhas.find(x => x.CampanhaId == campanhaIndicador.CampanhaId)
                           if(campanha && campanha.BigTalk){
                               campanha.ScoreBigTalk = campanhaIndicador.ScoreBigTalk; 
                            }                             
                        });

                        if (indicadorAtualContador == $scope.atualizandoIndicadorContador) {
                            if (filtro.Visao == 1) {
                                $scope.indicadoresCliente = data;
                            } else {
                                $scope.indicadoresMailing = data;
                            }

                            $scope.getIndicadoresPorVisao();
                            $scope.setOrdenacao();
                        }
                    })
                    .finally(function () {
                        $timeout.cancel(indicadorTimerIndicadorId);
                        if (!$scope.destroyed) {
                            indicadorTimerIndicadorId = $timeout($scope.atualizarIndicadores, 15000);
                        }
                    });
            };

            $scope.atualizarCampanhas = function () {
                MonitorCampanhaResource.GetCampanhas({
                    Tempo: $scope.search.Tempo,
                    VisaoSelecionada: $scope.visaoSelecionada
                }).$promise.then(function (data) {
                    _.each(data, function (item) {

                        let campanhaRef = campanhasById[item.CampanhaId];
                        if (campanhaRef) { //Atualiza campanha
                            campanhaRef.UltimoRetorno = item.UltimoRetorno;
                            campanhaRef.CampanhaStatusId = item.CampanhaStatusId;
                            campanhaRef.CampanhaStatusDescricao = item.CampanhaStatusDescricao;
                            campanhaRef.PendenteAcao = item.PendenteAcao;
                            campanhaRef.PercentualDiscado = item.PercentualDiscado;
                            campanhaRef.PercentualRediscagem = item.PercentualRediscagem;
                            campanhaRef.DiscagemVertical = item.DiscagemVertical;
                            campanhaRef.CicloQuantidade = item.CicloQuantidade;
                            campanhaRef.CicloDiscagem = item.CicloDiscagem;
                            campanhaRef.CustoHoje = item.CustoHoje;
                            campanhaRef.ScoreBigTalk = item.ScoreBigTalk;

                            if (item.PrevisaoMinutosFim > 0) {
                                var agora = moment();
                                var dataPrevisao = moment(item.DataPrevisao);
                                if (dataPrevisao.year() > 1900) {
                                    campanhaRef.PrevisaoMinutosFim = item.PrevisaoMinutosFim - agora.diff(dataPrevisao, 'minutes');
                                }
                            }
                        } else { //Adiciona campanha
                            $scope.campanhas.push(item);
                        }
                    });
                    _.each(campanhasById, function (item) { //Remove campanha
                        if (item) {
                            let itemExistente = _.find(data, function (el) {
                                return el.CampanhaId == item.CampanhaId;
                            });
                            if (itemExistente == null) {
                                let index = $scope.campanhas.indexOf(item);
                                if (index > -1) {
                                    $scope.campanhas.splice(index, 1);
                                }
                            }
                        }
                    });

                    //Atualiza campanhasById
                    campanhasById = [];
                    _.each($scope.campanhas, function (value) {
                        campanhasById[value.CampanhaId] = value;
                    });

                    $timeout.cancel(indicadorTimerId);
                    if (!$scope.destroyed) {
                        indicadorTimerId = $timeout($scope.atualizarCampanhas, 4000);
                    }

                    $scope.statusCampanhas = _.uniq(_.map($scope.campanhas, function (el) { return { CampanhaStatusId: el.CampanhaStatusId, CampanhaStatusDescricao: el.CampanhaStatusDescricao } }), function (el) { return el.CampanhaStatusId });
                    $scope.statusCampanhas.unshift({ CampanhaStatusId: 0, CampanhaStatusDescricao: $translate.instant('campo.selecione') });
                });
            };            

            $scope.destroyed = false;
            $scope.$on("$destroy", function () {
                $scope.destroyed = true;
                if (indicadorTimerId) {
                    $timeout.cancel(indicadorTimerId);
                }
                if (indicadorTimerIndicadorId) {
                    $timeout.cancel(indicadorTimerIndicadorId);
                }

                if ($scope.intervalOnline) {
                    $interval.cancel($scope.intervalOnline);
                }
                $scope.pauseAlarme();
            });

            $scope.playAlarme = function () {
                $scope.mudo = LocalStorageService.getItem('SistemaMudo') === true;
                let audioElem = $("#alarmeSonoro")[0];
                if ($scope.mudo)
                    audioElem.muted = true;

                if (audioElem.paused)
                    audioElem.play();
            };

            $scope.pauseAlarme = function () {
                if ($("#alarmeSonoro")[0]) {
                    $("#alarmeSonoro")[0].pause();
                }
            };

            var checarAlarmes = function (event, alarmes) {
                $scope.pauseAlarme();
                for (let key in campanhasById) {
                    if (campanhasById.hasOwnProperty(key)) {
                        campanhasById[key].Alarmes = [];
                    }
                }
                _.each(alarmes, function (alarme) {
                    let campanha = campanhasById[alarme.CampanhaId];
                    if (campanha) {
                        campanha.AlarmeAtivo = true;
                        campanha.Alarmes.push({ Coluna: alarme.Coluna, Estilo: alarme.Estilo });
                        if (alarme.AlarmeSonoro)
                            $scope.playAlarme();
                    }
                });
            };

            var cancelaAlarmeCampanha = function () {
                $scope.pauseAlarme();
                for (let key in campanhasById) {
                    if (campanhasById.hasOwnProperty(key)) {
                        campanhasById[key].Alarmes = [];
                    }
                }
            };

            $scope.VerificaAlarmeIndicador = function (campanhaId, coluna) {
                let style = { "color": "#757575" };

                if ($scope.visaoSelecionada == 2) {

                    let alarmes = campanhasById[campanhaId].Alarmes;
                    let alarme = _.findWhere(alarmes, { 'Coluna': coluna });

                    if (alarme) {
                        style = { "border-color": alarme.Estilo, "color": alarme.Estilo }
                    }
                }

                return style
            };

            $scope.$on("onAlarmeCampanhaChanged", checarAlarmes);

            $scope.$on("onAlarmeCampanhaCanceladaChanged", cancelaAlarmeCampanha);

            $scope.getIndicadoresPorVisao = function () {
                $scope.campanhas.forEach(campanha => {
                    if ($scope.visaoSelecionada == 1) {
                        campanha.indicadorTmp = _.find($scope.indicadoresCliente, { CampanhaId: campanha.CampanhaId });
                    } else {
                        campanha.indicadorTmp = _.find($scope.indicadoresMailing, { CampanhaId: campanha.CampanhaId });
                    }
                });
            }

            $scope.changeMaillingVisao = function (visao) {
                $scope.visaoSelecionada = visao;
                localStorage.removeItem('campanha_monitor_visao');
                localStorage.setItem('campanha_monitor_visao', $scope.visaoSelecionada);

                $scope.atualizarIndicadores();
                $scope.validaExibeCusto();
            }

            $scope.changeViewQuantidade = function () {
                $scope.viewQuantidade = !$scope.viewQuantidade;
                localStorage.removeItem('campanha_monitor_visao_quantidade');
                localStorage.setItem('campanha_monitor_visao_quantidade', $scope.viewQuantidade);
            }

            $scope.salvarFiltroGrupo = function () {
                localStorage.removeItem('campanha_grupo_visao');
                localStorage.setItem('campanha_grupo_visao', $scope.search.GrupoId);
            }

            $scope.salvarFiltroCarteira = function () {
                localStorage.removeItem('campanha_carteira');
                localStorage.setItem('campanha_carteira', $scope.search.CarteiraId);
            }

            $scope.salvarFiltroTipo = function () {
                localStorage.removeItem('campanha_tipo');
                localStorage.setItem('campanha_tipo', $scope.search.CampanhaTipoId);
            }

            $scope.salvarFiltroDiscagem = function () {
                localStorage.removeItem('campanha_discagem_tipo');
                localStorage.setItem('campanha_discagem_tipo', $scope.search.DiscagemVertical);
            }

            $scope.salvarFiltroFlutuante = function () {
                localStorage.removeItem('campanha_flutuante');
                localStorage.setItem('campanha_flutuante', $scope.search.Flutuante);
            }

            $scope.salvarPesquisaCampanha = function () {
                localStorage.removeItem('pesquisa_campanha');
                localStorage.setItem('pesquisa_campanha', $scope.search.PesquisaCampanha);
            }

            $scope.salvarPorStatus = function () {
                localStorage.removeItem('campanha_status');
                localStorage.setItem('campanha_status', $scope.search.CampanhaStatusId);
            }

            $scope.filtroTipo = function (filtro) {
                $scope.search.CampanhaTipoId = filtro;
                $scope.salvarFiltroTipo();
                $scope.filtroPorGrupo(0);
            };

            $scope.filtroDiscagem = function (filtro) {
                $scope.search.DiscagemVertical = filtro;
                $scope.salvarFiltroDiscagem();
                $scope.filtroPorGrupo(0);
            };

            $scope.filtroFlutuante = function (filtro) {
                $scope.search.Flutuante = filtro;
                $scope.salvarFiltroFlutuante();
                $scope.filtroPorGrupo(0);
            };

            $scope.filtroPorStatus = function (status) {

                if (status.CampanhaStatusId === undefined)
                    status.CampanhaStatusId = 0;

                $scope.search.CampanhaStatusId = status.CampanhaStatusId;
                $scope.salvarPorStatus();
                $scope.filtroPorGrupo(0);
            };

            $scope.filtroPorGrupo = function (grupoId) {
                $scope.search.GrupoId = grupoId;
                $scope.salvarFiltroGrupo();
            };

            $scope.filtroPorCarteira = function (carteiraId){
                $scope.search.CarteiraId = carteiraId;
                $scope.salvarFiltroCarteira();
                $scope.filtroPorGrupo(0);
            }

            $scope.filtroPorCampanha = function (filtroCampanha) {
                $scope.search.PesquisaCampanha = filtroCampanha;
                $scope.salvarPesquisaCampanha();
            };

            $scope.indicadores = [];

            $scope.campanhaConfiguracao = [];

            $scope.popUpPerfilDiscagem = function (campanha, $event) {
                $event.stopPropagation();
                let modal = UIkit.modal("#modal_campanha_perfil_discagem");
                $scope.campanhaConfiguracao.CampanhaId = campanha.CampanhaId
                $scope.campanhaConfiguracao.CampanhaCampoId = campanha.CampanhaCampoId
                $scope.campanhaConfiguracao.CampanhaConfiguracaoId = campanha.CampanhaConfiguracaoId
                $scope.campanhaConfiguracao.CampanhaPerfilDiscagem = campanha.PerfilDiscagem;
                $scope.campanhaConfiguracao.ConfiguracaoAvancada = campanha.ConfiguracaoAvancada;
                $scope.campanhaConfiguracao.Flutuante = campanha.Flutuante;
                $scope.campanhaConfiguracao.CampanhaTipoId = campanha.CampanhaTipoId;
                $scope.campanhaConfiguracao.Grupo = _.filter($scope.grupos, function (el) {
                    return el.GrupoId == campanha.GrupoId;
                })[0];

                //Buscar os dados sem recurso para exibir na tela
                MonitorCampanhaResource.GetIndicadorSemRecurso({                                          
                    CampanhaId: campanha.CampanhaId
                }).$promise
                    .then((data) => {
                        $scope.indicadorSemRecurso = data;
                        modal.show();
                    })
                
            };

            $scope.alterarCampanhaPerfilDiscagem = function (form) {
                if (!form.$valid) {
                    NotifyService.showInvalid();
                    return;
                }

                let data = {
                    CampanhaId: $scope.campanhaConfiguracao.CampanhaId,
                    CampanhaCampoId: $scope.campanhaConfiguracao.CampanhaCampoId,
                    CampanhaConfiguracaoId: $scope.campanhaConfiguracao.CampanhaConfiguracaoId,
                    Valor: $scope.campanhaConfiguracao.CampanhaPerfilDiscagem
                };

                let modal = UIkit.modal("#modal_campanha_perfil_discagem");

                ModalService.showLoading();

                modal.hide()

                CampanhaResource.PutPerfilDiscagem(data).$promise.then(function () {
                    let item = _.findWhere($scope.campanhas, { CampanhaId: data.CampanhaId });
                    item.PerfilDiscagem = data.Valor;
                    NotifyService.showSuccess();
                    ModalService.hideLoading();

                }).catch(function () {
                    ModalService.hideLoading();
                });
            };

            $scope.iniciarCampanha = function (campanha, $event) {
                $event.stopPropagation();
                $window.UIkit.modal.confirm($translate.instant('telaMonitorCampanha.desejaIniciarCampanha'), function () {
                    CampanhaResource.processaCampanhaConfiguracao({
                        CampanhaId: campanha.CampanhaId,
                        CampanhaAcaoId: 2
                    }).$promise.then(function () {
                        $scope.atualizarCampanhas();
                        NotifyService.showSuccess();
                    });
                });
            };

            $scope.pararCampanha = function (campanha, $event) {
                $event.stopPropagation();
                $window.UIkit.modal.confirm($translate.instant('telaMonitorCampanha.desejaPararCampanha'), function () {
                    CampanhaResource.processaCampanhaConfiguracao({
                        CampanhaId: campanha.CampanhaId,
                        CampanhaAcaoId: 3
                    }).$promise.then(function () {
                        $scope.atualizarCampanhas();
                        NotifyService.showSuccess();
                    });
                });
            };

            $scope.edicaoCampanhas = function (campanha) {
                if (campanha.CampanhaTipoId == 1) {
                    $state.go('main.campanha.padrao.edit', campanha);
                }
                if (campanha.CampanhaTipoId == 2) {
                    $state.go('main.campanha.callback.edit', campanha);
                }
                if (campanha.CampanhaTipoId == 3) {
                    $state.go('main.campanha.higienizacao.edit', campanha);
                }
                if (campanha.CampanhaTipoId == 4) {
                    $state.go('main.campanha.talkbot.edit', campanha);
                }
            }

            $scope.calculaPercentual = function (quantidadeDiscado, quantidadeStatus) {
                if (!$scope.viewQuantidade) {
                    return quantidadeStatus == 0 ? 0 : ((quantidadeStatus * 100) / quantidadeDiscado) > 100 ? (100) : ((quantidadeStatus * 100) / quantidadeDiscado);
                }
            }

            $scope.ativarPesquisaCampanha = function () {
                $scope.pesquisaCampanha = true;
                $timeout(function () {
                    $('#txtPesquisaCampanha').focus();
                }, 100);
            }
            $scope.desativarPesquisaCampanha = function (event) {
                if (event.target.value == null || event.target.value == '') {
                    $scope.pesquisaCampanha = false;
                    $scope.searchCampanha = '';
                }
            }

            $scope.validaExibeCusto = function () {
                if ($scope.visaoSelecionada == 2) {
                    if ($scope.search.Tempo == 3) {
                        $scope.exibeCusto = true;
                        return;
                    }
                }
                else {
                    $scope.exibeCusto = true;
                    return;
                }

                $scope.exibeCusto = false;
            }

            $scope.setOrdenacao = function () {
                switch (parseInt($scope.search.ordenacao)) {
                    case 1:
                        $scope.campanhas = _.sortBy($scope.campanhas, function (campanha) {
                            return campanha.indicadorTmp == null ? 0 : (campanha.indicadorTmp.QtdDiscado * -1);
                        });
                        break;
                    case 2:
                        $scope.campanhas = _.sortBy($scope.campanhas, function (campanha) {                            
                            return campanha.indicadorTmp == null ? 0 : (campanha.indicadorTmp.QtdLivre * -1);
                        });
                        break;
                    case 3:
                        $scope.campanhas = _.sortBy($scope.campanhas, function (campanha) {                            
                            return campanha.indicadorTmp == null ? 0 : (campanha.indicadorTmp.QtdRediscagem * -1);
                        });
                        break;
                    case 4:
                        $scope.campanhas = _.sortBy($scope.campanhas, function (campanha) {
                            return campanha.indicadorTmp == null ? 0 : (campanha.indicadorTmp.QtdImportado * -1);
                        });
                        break;
                    case 5:
                        $scope.campanhas = _.sortBy($scope.campanhas, function (campanha) {
                            return campanha.PerfilDiscagem * -1;
                        });
                        break;
                    case 6:
                        $scope.campanhas = _.sortBy($scope.campanhas, function (campanha) {
                            return campanha.CampanhaDescricao;
                        });
                        break;
                }

                localStorage.setItem('ordenacao', $scope.search.ordenacao);
            }

            $scope.resumoMailingBigTalk = function(campanhaId){
                
                CampanhaArquivoResource.resumoBigTalk({
                    campanhaArquivoId: 0,                        
                    CampanhaId: campanhaId
                }).$promise
                    .then((data) => {
                        $scope.resumoImportacaoScoreBigTalk = data;
                    })

                CampanhaArquivoResource.graficoBigTalk({
                    campanhaArquivoId: 0,                        
                    CampanhaId: campanhaId
                }).$promise
                    .then((data) => {
                        $scope.resumoImportacaoScoreBigTalkGrafico = data;
                    })

                $scope.campanhaGraficoBigTalk = campanhaId;
                ModalService.openModal('modal_resumo_mailing_bigtalk');
            }

            
            $scope.campararCampanhas = function(){
                
                ModalService.openModal('modal_comparar_campanha');
            }

            $scope.atualizarIndicadores();
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
      .factory("MonitorCampanhaResource", ["$odataresource", function ($odataresource) {
          return $odataresource("MonitorCampanha/:BilheteId",
            {
                "BilheteId": "@BilheteId"
            },
            {
                GetCampanhas: {
                    url: "MonitorCampanha/Campanhas",
                    method: "GET",
                    isArray: true
                },                
                GetGrupos: {
                    url: "MonitorCampanha/Grupos",
                    method: "GET",
                    isArray: true
                },
                GetIndicador: {
                    url: "MonitorCampanha/Indicador",
                    method: "GET",
                    isArray: true
                },
                GetMonitorCanaisAgrupadosCampanha: {
                    url: "MonitorCanal/CanaisAgrupadosCampanha",
                    method: "GET",
                    isArray: true
                },
                GetGruposStatusAgrupados: {
                    url: "MonitorCampanha/GruposStatusAgrupados",
                    method: "GET",
                    isArray: true
                },
                GetIndicadorSemRecurso:{
                    url: "MonitorCampanha/IndicadorSemRecurso",
                    method: "GET",
                    isArray: true
                }
            });
      }]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('MonitoriaMaquinaEditData', function ServicoEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_clipboard'
						]);
					}],
					maquina: ["MonitoriaMaquinaResource", "$stateParams", function (MonitoriaMaquinaResource, $stateParams) {
						if ($stateParams.Id) {
							return MonitoriaMaquinaResource.get({
								Id: $stateParams.Id
							}).$promise;
						} else {
							return {};
						}
					}],
				}
			}
		})

		.controller("MonitoriaMaquinaEditController", ["$scope", "$state", "maquina", "MonitoriaMaquinaResource", "NotifyService", "$translate", function ($scope, $state, maquina, MonitoriaMaquinaResource, NotifyService, $translate) {
			$scope.isNovo = !(maquina && maquina.Id);
			$scope.inserirOuEditar = maquina && maquina.Id ? $translate.instant('telaEditMonitoria.editarServidor') :
				$translate.instant('telaEditMonitoria.cadastrarServidor');
			$scope.maquina = maquina;

			var mensagemSucesso = function (maquina) {
				NotifyService.showRegistroSalvo();
				if ($scope.Novo) {
					$scope.maquina = {};
				} else {
					$scope.maquina = maquina;
				}
				$state.go('main.monitoriamaquina.list');
			};

			$scope.salvar = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}

				var promise;

				if ($scope.maquina.Id > 0) {
					promise = MonitoriaMaquinaResource.update($scope.maquina).$promise;
				} else {
					promise = MonitoriaMaquinaResource.save($scope.maquina).$promise;
				}

				promise.then(mensagemSucesso).catch(NotifyService.showError);
			};

			$scope.voltar = function () {
				$state.go('main.monitoriamaquina.list');
			};

		}]);
})();
(function () {
	"use strict";

	var getOdataSearchShared = function (MonitoriaMaquinaResource, search, orderBy, $odata) {
		var odata = MonitoriaMaquinaResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.Nome) {
			odata.filter(new $odata.Func("contains", "Nome", search.Nome), true);
		}

		return odata;
	};

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.monitoriamaquina", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.monitoriamaquina.list',
						pageTitle: 'pageTitle.servidorDeMonitoria',
						pageName: 'pageTitle.pesquisar'
					}
				})	
				.state("main.monitoriamaquina.list", StateResolverProvider.configState("/monitoriamaquina", "MonitoriaMaquina", "List", {
					pageTitle: 'pageTitle.servidorDeMonitoria',
					pageName: 'pageTitle.pesquisar',
					css: true,
					cssFiles: ['app/pages/monitoriaMaquina/style/monitoriaMaquina.css']
				}))
				.state("main.monitoriamaquina.new", StateResolverProvider.configState("/monitoriamaquina/new", "MonitoriaMaquina", "Edit", {
					pageTitle: 'pageTitle.servidorDeMonitoria',
					pageName: 'acoes.cadastrar',
					css: true,
					cssFiles: ['app/pages/monitoriaMaquina/style/monitoriaMaquina.css']
				}))
				.state("main.monitoriamaquina.edit", StateResolverProvider.configState("/monitoriamaquina/{Id:[0-9]+}", "MonitoriaMaquina", "Edit", {
					pageTitle: 'pageTitle.servidorDeMonitoria',
					pageName: 'acoes.editar',
					css: true,
					cssFiles: ['app/pages/monitoriaMaquina/style/monitoriaMaquina.css']
				}));

		}])

		.service("MonitoriaMaquinaListData", function ServicoListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_clipboard'
						]);
					}],
					maquinas: ["MonitoriaMaquinaResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (MonitoriaMaquinaResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};
						
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroMonitoriaMaquina");
						}

						var orderBy = {
							column: "Nome",
							order: "asc"
						};

						return getOdataSearchShared(MonitoriaMaquinaResource, filtro, orderBy, $odata, utils).page(10, 1).query();
					}],
				}
			}
		})

		.controller("MonitoriaMaquinaListController", ["$scope", "$odata", "maquinas", "MonitoriaMaquinaResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", function ($scope, $odata, maquinas, MonitoriaMaquinaResource, utils, LocalStorageService, 
			$stateParams, NotifyService, $state, ModalService) {
			$scope.searching = false;
			$scope.maquinas = maquinas;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroMonitoriaMaquina") : {};

			$scope.orderBy = {
				column: "Nome",
				order: "asc"
			};

			var updateList = function (list) {
				$scope.maquinas = list;
				$scope.maquinas.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.maquinas.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			var getOdataSearch = function () {
				return getOdataSearchShared(MonitoriaMaquinaResource, $scope.search, $scope.orderBy, $odata, utils);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroMonitoriaMaquina', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			var deleteRecord = function (data) {
				return MonitoriaMaquinaResource.delete({ Id: data.Id }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.maquinas.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			updateList(maquinas);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroMonitoriaMaquina');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, {
						storage: true
					});
				} else {
					$state.go('main.monitoriamaquina.list', {
						storage: true
					});
				}
			};

			$scope.copiarSelecao = function (selecao) {
				new Clipboard(selecao);
				NotifyService.showMessage('telaMonitoriaMaquina.chaveCopiada', "info")
			};

			$scope.mostrarChave = function (maquina) {
				$scope.maquinaChave = maquina;
				ModalService.openModal('modal_chave');
			}

			$scope.mostrarEmail = function () {
				ModalService.openModal('modal_email', null, null, { center: true, bgclose: false });
			}

		}]);
	})
();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("MonitoriaMaquinaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MonitoriaMaquina/:Id", { "Id": "@Id" }, {
                getErroAtualizacao: {
                    method: "GET",
                    url: "MonitoriaMaquina/GetErroAtualizacao",
                    isArray: true
                }
            });
        }])
        .factory("MonitoriaVersaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MonitoriaVersao/:MonitoriaVersaoId", { "MonitoriaVersaoId": "@MonitoriaVersaoId" });
        }]);

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .controller("MonitoriaServidorEditController", ["$scope", "MonitoriaServidorEmailResource", "NotifyService", "ModalService", function ($scope, MonitoriaServidorEmailResource, NotifyService, ModalService) {
            $scope.forms = {};
            MonitoriaServidorEmailResource.getAll().$promise.then(function (data) {
                $scope.email = _.where(data, { Visivel: true });
            });

            $scope.regex = {
                // eslint-disable-next-line no-useless-escape
                email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
            };

            $scope.validarEmailUnico = function (element) {
                var exists = _.where($scope.email, { Destinatario: element.$viewValue, Visivel: true }).length > 1;
                element.$setValidity('unique', !exists);
            }

            $scope.adicionarItemEmail = function () {
                $scope.email.push({ Ativo: true, Visivel: true });
            }

            $scope.removerItemEmail = function (index) {
                ModalService.confirmDelete(() => {
                    if ($scope.email[index].MonitoriaServidorEmailId && !$scope.email[index].Destinatario) {
                        return NotifyService.showError(null, 'telaMonitoriaMaquina.naoEPossivelRemoverEsteItem');
                    }

                    if ($scope.email[index].MonitoriaServidorEmailId) {
                        $scope.email[index].Visivel = false;
                    } else {
                        $scope.email.splice(index, 1);
                    }

                    // "Força" o estado do formulário como "alterado"
                    $scope.forms.frmMonitoriaServidor.$setDirty();

                    // Valida se existe e-mail duplicado
                    angular.forEach($scope.forms.frmMonitoriaServidor, (element, key) => {
                        if (key.startsWith('destinatario')) {
                            $scope.validarEmailUnico(element);
                        }
                    });
                })
                   
            }

            $scope.onChangeEmail = function (index) {
                var email = $scope.forms.frmMonitoriaServidor['destinatario' + index];
                $scope.validarEmailUnico(email);
            }

            $scope.onSubmit = function (formIsValid) {
                if (!formIsValid) {
                    return NotifyService.showInvalid();
                }

                MonitoriaServidorEmailResource.atualizarTodos($scope.email).$promise
                    .then((response) => {
                        NotifyService.showSuccess('telaMonitoriaMaquina.destinatariosAtualizadosComSucesso');
                        $scope.email = _.where(response, { Visivel: true });
                        $scope.forms.frmMonitoriaServidor.$setPristine();
                    }).catch(() => NotifyService.showError(null, 'telaMonitoriaMaquina.naoFoiPossivelAtualizarDestinatarios'));
            }

        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("MonitoriaServidorEmailResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MonitoriaServidorEmail/:MonitoriaServidorEmailId", { "MonitoriaServidorEmailId": "@MonitoriaServidorEmailId" },
                {
                    getAll: {
                        url: "MonitoriaServidorEmail/GetAll",
                        method: "GET",
                        isArray: true
                    },
                    atualizarTodos: {
                        url: "MonitoriaServidorEmail/AtualizarTodos",
                        method: "PUT",
                        isArray: true
                    }
                });
        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("MonitoriaServidorResource", ["$odataresource", function ($odataresource) {
            return $odataresource("MonitoriaServidor/:MonitoriaServidorId", { "MonitoriaServidorId": "@MonitoriaServidorId" });
        }]);

})();

(function () {
    "use strict"

    var defaultPageIndex = 1;
    var defaultPageSize = 10;

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.notificacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.notificacao.list',
                        pageTitle: 'pageTitle.notificacao',
                        pageName: 'model.notificacao'
                    }
                })
                .state("main.notificacao.list", StateResolverProvider.configState("/notificacao", "Notificacao", "List", {
                    pageTitle: 'pageTitle.notificacao',
                    pageName: 'pageTitle.pesquisar'
                }))
        }])

        .service("NotificacaoListData", function ReportListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_masked_inputs'
                        ]);
                    }],
                    codigosList: ["NotificacaoResource", function (NotificacaoResource) {
                        return NotificacaoResource.GetCodigo().$promise;
                    }]
                }
            }
        })

        .controller("NotificacaoListController", ["$scope", "$rootScope", "$http", "codigosList", "ModalService", "Config", "NotifyService", "NotificacaoResource", function ($scope, $rootScope, $http, codigosList, ModalService, Config, NotifyService, NotificacaoResource) {
            $scope.filtro = {};
            $scope.codigos = angular.forEach(codigosList, function (item) { item.Descricao = item.Codigo + ' - ' + item.Descricao });

            var dataFim = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            var dataInicio = moment().subtract(1, 'days').toDate();

            $scope.notificacoes = [];

            $scope.filterPageSize = { Size: 10 };

            $scope.registroPorPaginaArray = [
                { label: 15, valor: 15 },
                { label: 30, valor: 30 },
                { label: 50, valor: 50 },
                { label: 100, valor: 100 }
            ];

            $scope.search = {
                DataInicio: dataInicio,
                DataFim: dataFim,                
            };

            $scope.submitted = false;

            $scope.executeSearch = function () {
                ModalService.showLoading();

                $scope.getOdataSearch()
                    .then((data) =>
                    {
                        updateList(data);
                        ModalService.hideLoading();
                        $scope.submitted = false;
                    })
                    .catch((error) => {
                        $scope.notificacoes = [];
                        ModalService.hideLoading();
                        $scope.submitted = false;
                        NotifyService.showError(error);
                    });
            }; 

            $scope.limparFiltro = function () {
                $scope.search = {
                    Codigo: '',
                    DataInicio: dataInicio,
                    DataFim: dataFim
                }

                $rootScope.$broadcast('onLimpar');
                $scope.notificacoes = [];
                $scope.submitted = false;
                $scope.Quantidade = 0;
            }

            var updateList = function (pagination) {
                $scope.notificacoes = pagination.Data;                
                $scope.notificacoes.recordCount = pagination.RecordCount;
                $scope.notificacoes.currentPage = pagination.PageIndex || 1;
                $scope.notificacoes.pageSize = pagination.PageSize || defaultPageSize;
                $scope.submitted = false;
                ModalService.hideLoading();
            };

             $scope.changePageSize = function () {
                defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 10;
                $scope.executeSearch();
            };
          
            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {
                    ModalService.showLoading();
                    $scope.isPageChanged = true;
                    defaultPageIndex = newPage;
                    $scope.getOdataSearch()
                        .then((list) => {
                            updateList(list);
                            $scope.isPageChanged = false;
                        }).catch((error) => {
                            NotifyService.showError(error);
                            $scope.isPageChanged = false;
                            ModalService.hideLoading();
                        });
                }
            };


            $scope.getOdataSearch = function () {
                var url = Config.getUrl("Notificacao/GetNotificacao/") + defaultPageIndex + "/" + defaultPageSize;

                $scope.filtro = {
                    DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                    DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),                    
                    CTIErroId: ($scope.search.codigo == null || $scope.search.codigo == 0) ? [] : $scope.search.codigo.join()
                };

                if (!$scope.isPageChanged) {                    
                    $scope.countInternoFinalizado = false;
                    $scope.Quantidade = -1;

                    NotificacaoResource.GetNotificacaoCount($scope.filtro).$promise
                        .then((data) => {
                            if ($scope.countInternoFinalizado == false) {
                                $scope.Quantidade = data.Quantidade;
                                $scope.countInternoFinalizado = true;
                            }
                        });
                }

                return $http({ method: 'GET', url: url, params: $scope.filtro })
                    .then((response) => {
                        return response.data;
                    });
            }
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("NotificacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Notificacao/:Id", {
                "Id": "@Id"
            },
            {
                GetCodigo: {
                    url: "Notificacao/GetCodigo",
                    method: "GET",
                    isArray: true
                },

                GetNotificacao: {
                    url: "Notificacao/GetNotificacao",
                    method: "GET"
                },

                GetNotificacaoCount: {
                    url: "Notificacao/GetNotificacaoCount",
                    method: "GET"
                }
            });
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
      .factory("OperadoraResource", ["$odataresource", function ($odataresource) {
        return $odataresource("Operadora");
    }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.perfil", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.perfil.list',
                        pageTitle: 'header.perfil',
                        pageName: 'header.perfil'
                    }
                })
                .state("main.perfil.list", StateResolverProvider.configState("/perfil", "Perfil", "List", {
                    pageTitle: 'pageTitle.perfilDeUsuario',
                    pageName: 'header.perfil',
                    css: true,
                    permissions: {
                        AllowAll: true
                    }
                }));
        }])

        .service("PerfilListData", function PerfilListData() {
            return function () {
                return {
                    perfilList: ["PerfilResource", function (PerfilResource) {
                        return PerfilResource.usuarioLogado().$promise;
                    }],
                    avatarList: ["PerfilResource", function (PerfilResource) {
                        return PerfilResource.usuarioAvatar().$promise;
                    }],
                    lazy: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['lazy_dropify']);
                    }],
                }
            }
        })

        .controller("PerfilListController", ["$scope", "$rootScope", "perfilList", "avatarList", "PerfilResource", "AuthService", "NotifyService", "ModalService", function ($scope, $rootScope, perfilList, avatarList, PerfilResource, AuthService, NotifyService, ModalService) {
            if (perfilList) {
                $scope.imagem = '';
                $scope.imagemReduzida = '';
                $scope.RamalNumero = '--';
                var arquivoValido = true;
                var usuario = AuthService.getUsuarioLogado();

                if (usuario) {
                    if (usuario.Ramal) {
                        $scope.RamalNumero = usuario.Ramal.Numero;
                    }
                }
                    
                if (!perfilList.Celular) {
                    perfilList.Celular = '--';
                }

                if (perfilList.RamalNumero) {
                    $scope.RamalNumero = perfilList.RamalNumero;
                }

                if (!perfilList.Telefone) {
                    perfilList.Telefone = '--';
                }

                $scope.usuario = perfilList;
                $scope.usuario.Avatar = avatarList;

                $scope.usuarioEdit = {
                    Email: perfilList.Email,
                    Celular: perfilList.Celular,
                    Telefone: perfilList.Telefone,
                    Nome: perfilList.Nome,
                    Imagem: avatarList.Imagem,
                };
            }

            $scope.uploadFile = function () {
                var file = event.target.files[0];

                if (file) {
                    var isImage = file.type.startsWith('image');

                    if (isImage) {
                        arquivoValido = true;
                        var reader = new FileReader();

                        reader.onload = function (e) {
                            convertImage(e.target.result);
                        };

                        reader.readAsDataURL(file);

                        var dvUpload = $('#dvUploadImagem');
                        var dvImagem = $('#dvImagem');
                        if (dvImagem) {
                            dvUpload.hide();
                            dvImagem.show();
                        }
                    }
                    else {
                        NotifyService.showMessage('telaPerfil.oArquivoNaoEImagem', 'warning')
                        arquivoValido = false;
                    }
                }
            };

            $scope.savePerfil = function (valid) {
                if (!arquivoValido) {
                    return NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                }

                if (!valid) {
                    return NotifyService.showInvalid();
                }

                $scope.usuario.Email = $scope.usuarioEdit.Email;
                $scope.usuario.Celular = $scope.usuarioEdit.Celular;
                $scope.usuario.Telefone = $scope.usuarioEdit.Telefone;

                if ($scope.imagem) {
                    $scope.usuario.Avatar.ImagemReduzida = $scope.imagemReduzida;
                    $scope.usuario.Avatar.Imagem = $scope.imagem;
                }

                PerfilResource.update($scope.usuario).$promise
                    .then(() => {
                        NotifyService.showRegistroAlterado();
                        ModalService.closeModal('modalEditarFoto')
                        $scope.formPerfil.$setPristine();
                        if ($scope.imagemReduzida) {
                            $rootScope.$broadcast('atualizaImagem', {
                                imagemReduzida: $scope.imagemReduzida
                            });
                        }
                    }).catch(NotifyService.showError);
            };

            $scope.alteraImagem = function () {
                var dvUpload = $('#dvUploadImagem');
                var dvImagem = $('#dvImagem');
                if (dvUpload) {
                    dvImagem.hide();
                    dvUpload.show(300);
                }
            }

            var convertImage = function (base64) {
                var img = new Image();
                img.src = base64;
                img.onload = function () {
                    var tempW = img.width;
                    var tempH = img.height;
                    var scaleReduzida = Math.min((34 / tempW), (34 / tempH));
                    var scaleNormal = Math.min((82 / tempW), (82 / tempH));
                    var canvasReduzida = document.createElement("canvas");
                    canvasReduzida.width = tempW * scaleReduzida;
                    canvasReduzida.height = tempH * scaleReduzida;
                    var ctxReduzida = canvasReduzida.getContext("2d");
                    ctxReduzida.drawImage(this, 0, 0, tempW * scaleReduzida, tempH * scaleReduzida);
                    $scope.imagemReduzida = canvasReduzida.toDataURL("image/png", 1.0);
                    ctxReduzida.clearRect(0, 0, img.width, img.height);
                    var canvasNormal = document.createElement("canvas");
                    canvasNormal.width = tempW * scaleNormal;
                    canvasNormal.height = tempH * scaleNormal;
                    var ctxNormal = canvasNormal.getContext("2d");
                    ctxNormal.drawImage(this, 0, 0, tempW * scaleNormal, tempH * scaleNormal);
                    $scope.imagem = canvasNormal.toDataURL("image/png", 1.0);
                    ctxNormal.clearRect(0, 0, img.width, img.height);
                    if ($scope.usuarioEdit) {
                        $scope.usuarioEdit.Imagem = $scope.imagem;
                    }
                }
            }

            $scope.editarFoto = function () {
                clearDropify();
                ModalService.openModal('modalEditarFoto', null, null, { center: true, bgclose: false });
            }

            var clearDropify = function () {
                var drEvent = $('#input-file-a').dropify();
                drEvent = drEvent.data('dropify');
                drEvent.resetPreview();
                drEvent.clearElement();
                arquivoValido = true;
            }

        }])

        .directive('customOnChange', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var onChangeHandler = scope.$eval(attrs.customOnChange);
                    element.bind('change', onChangeHandler);
                }
            };
        })
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
      .factory("PerfilResource", ["$odataresource", function ($odataresource) {
          return $odataresource("Perfil/:UsuarioId", {"UsuarioId": "@UsuarioId"},
          {
              usuarioLogado: {
                  method: "GET",
                  url: "Perfil/UsuarioLogado",
                  isArray: false
              },
              usuarioAvatar: {
                  method: "GET",
                  url: "Perfil/UsuarioAvatar",
                  isArray: false
              }             
          });
      }]);

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('PesquisaEditData', function PesquisaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    pesquisa: ["PesquisaResource", "$stateParams", function (PesquisaResource, $stateParams) {
                        if ($stateParams.Id) {
                            return PesquisaResource.get({ Id: $stateParams.Id }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    tipos: ["PesquisaResource", function (PesquisaResource) {
                        return PesquisaResource.getTiposPerguntas().$promise
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    categorias: ["PesquisaCategoriaResource", function(PesquisaCategoriaResource){
                        return PesquisaCategoriaResource.GetPesquisaCategoria().$promise;
                    }],
                    pesquisaCategoriaItens: ["PesquisaCategoriaResource", "$stateParams", function(PesquisaCategoriaResource, $stateParams){
                        if($stateParams.Id) {
                            return PesquisaCategoriaResource.GetPesquisaCategoriaItemByPesquisaId({ pesquisaId: $stateParams.Id }).$promise;
                        } else {
                            return [];
                        }
                    }]
                }
            }
        })

        .filter('filtroGrupos', function () {
            return function (filtered, items, search) {
                return _.filter(items, function (item) {
                    return (item.Descricao.toUpperCase().indexOf(search.Grupo.toUpperCase()) >= 0);
                });
            }
        })

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.pesquisa.new", StateResolverProvider.configState("/pesquisa/new?page", "Pesquisa", "Edit", {
                    pageTitle: 'telaPesquisaEdit.TituloPagina',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.pesquisa.edit", StateResolverProvider.configState("/pesquisa/{Id:[0-9]+}", "Pesquisa", "Edit", {
                    pageTitle: 'telaPesquisaEdit.TituloPagina',
                    pageName: 'acoes.editar'
                }))
        }])

        .controller("PesquisaEditController", ["$scope", "$window", "$state", "$q", "$stateParams", "WizardHandler", "pesquisa", "tipos", "PesquisaResource", "NotifyService", "ModalService", "$translate", "carteiras", "categorias", "pesquisaCategoriaItens", "PesquisaCategoriaResource", function PesquisaEditController($scope, $window, $state, $q, $stateParams, WizardHandler, pesquisa, tipos, PesquisaResource,
            NotifyService, ModalService, $translate, carteiras, categorias, pesquisaCategoriaItens, PesquisaCategoriaResource) {
            $scope.color = {
                red: Math.floor(Math.random() * 255)
            };

            // #region Variaveis de inicialização

            $scope.isNew = pesquisa.Id > 0 ? false : true;
            pesquisa.Id = (pesquisa.Id > 0 ? pesquisa.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.PerguntasStepData = { order: 1 };
            $scope.GruposStepData = { order: 2 };
            $scope.tiposPerguntasList = tipos;
            
           
            $scope.carteiras = carteiras;
            $scope.pesquisa = pesquisa;
            $scope.perguntasList = (pesquisa.Perguntas == undefined || pesquisa.Perguntas.length == null) ? [] : _.sortBy(pesquisa.Perguntas, function (o) { return o.Ordem; });
            $scope.categorias = categorias;
            $scope.pesquisaCategoriaItens = pesquisaCategoriaItens;

           
            $scope.setListaBaseRespostasGeral = function () {

                $scope.perguntasList.forEach(pergunta => {
                    pergunta.listaBaseReposta = [];

                    pergunta.listaBaseReposta.push({ id: 1, value: 'Ir para a próxima pergunta' });

                    $scope.perguntasList.forEach(item => {
                        if (item.Ordem > pergunta.Ordem) {
                            pergunta.listaBaseReposta.push({ id: item.Ordem + 1, value: 'Ir para a pergunta ' + item.Ordem });
                        }
                    });
                });               
            }

            $scope.setListaBaseRespostasGeral();

            $scope.setListaBaseRespostas = function (pergunta) {

                pergunta.listaBaseReposta = [];

                pergunta.listaBaseReposta.push({ id: 1, value: 'Ir para a próxima pergunta' });

                $scope.perguntasList.forEach(item => {
                    if (item.Ordem > pergunta.Ordem) {
                        pergunta.listaBaseReposta.push({ id: item.Ordem + 1, value: 'Ir para a pergunta ' + item.Ordem });
                    }
                });
            }

            $scope.forms = {};
            $scope.gruposAssociadosList = []; //(pesquisa.Grupos == undefined || pesquisa.Grupos.length == null) ? [] : pesquisa.Grupos;
            $scope.gruposNaoAssociadosList = [];
            $scope.gruposAssociadosListCopia = [];
            $scope.gruposNaoAssociadosListCopia = [];
            

            $scope.getId = function () {
                return ($scope.pesquisa ? ($scope.pesquisa.Id > 0 ? $scope.pesquisa.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id))) : parseInt($stateParams.Id));
            }

            $scope.validacaoCampo = function (pergunta, alternativaSelecionada) {
                //Para os tipos multipla escolha e alternativa verificar se precisa desabilitar outras perguntas com base na resposta
                if(pergunta.TipoId == 2 || pergunta.TipoId == 1) {
                    if(alternativaSelecionada!= null) {
                        angular.forEach($scope.perguntasList, function (item) {                            
                            var perguntaSelecionada = $scope.perguntasList.filter(function(item) {
                                if(item.Id > 0)
                                    return item.Id == alternativaSelecionada.PesquisaPerguntaId;
                            })[0];
                            
                            if(perguntaSelecionada.BaseResposta) {
                                if (item.Ordem > perguntaSelecionada.Ordem) {
                                    item.desabilitar = false;
    
                                    /* if (item.TipoId == 1) {
                                        angular.forEach(item.Alternativas, function (alternativa) {                                                                        
                                             alternativa.RespostaCheck = false;                                   
                                        });
                                     }
     
                                     if (item.TipoId == 2) {
                                         angular.forEach(item.Alternativas, function (alternativa) {                                                                        
                                              alternativa.RespostaRadio   = false;                                   
                                         });
                                      }
    
                                      if (item.TipoId == 3) {
                                        item.RespostaText = '';
                                    } */
                                      
                                }
                            }
                            
                            if (alternativaSelecionada != null) {
                                if (alternativaSelecionada.Outros) {
                                    const indexPergunta = $scope.perguntasList.findIndex(i => i.Id === pergunta.Id);
                                    const alternativaOutros = _.findWhere($scope.perguntasList[indexPergunta].Alternativas, { Outros: true });
                                    alternativaOutros.HabilitarTexto = true;
                                }
                                else {
                                    const indexPergunta = $scope.perguntasList.findIndex(i => i.Id === pergunta.Id);
                                    const alternativaOutros = _.findWhere($scope.perguntasList[indexPergunta].Alternativas, { Outros: true });
                                    if (alternativaOutros != null)
                                        alternativaOutros.HabilitarTexto = false;
                                }
                            }

                            if (alternativaSelecionada.BaseRespostaId > 1 
                                && item.Ordem < (alternativaSelecionada.BaseRespostaId - 1) 
                                && item.Ordem > perguntaSelecionada.Ordem
                                && item.Id != alternativaSelecionada.PesquisaPerguntaId
                                ) {
                                item.desabilitar = true;
                               
                            }
                        });
                    }
                }   
            };

            // #region Dados iniciais perguntas e alternativas

            $scope.NovosDadosPergunta = function (idx) {
                var Id = $scope.getId();
                return {
                    PesquisaPerguntaId: 0,
                    PesquisaId: Id,
                    Titulo: '',
                    Alternativas: [$scope.NovosDadosAlternativa(1, 1)],
                    Peso: 100,
                    TipoId: 1,
                    Ordem: idx,
                    Ativo: true,
                    Outros: false
                };
            };

            $scope.NovosDadosAlternativa = function (idx, tipoId) {
                return {
                    Ordem: idx,
                    PesquisaAlternativaId: 0,
                    Descricao: '',
                    Peso: (tipoId == 3) ? null : 100,
                    Ativo: true
                };
            };

            // #endregion Dados iniciais perguntas e alternativas

            // #region Adicionar/Remover perguntas

            $scope.adicionarPergunta = function () {
                if (pesquisa.Perguntas == undefined || pesquisa.Perguntas.length == null) {
                    pesquisa.Perguntas = $scope.perguntasList;
                }
                var idx = $scope.perguntasList.length + 1;
                var dados = $scope.NovosDadosPergunta(idx);
                $scope.perguntasList.push(dados);
                $scope.distribuirPesoPerguntas();
                //$scope.atualizarBaseRespostas();

            };

            //$scope.atualizarBaseRespostas = function () {
                //$scope.baserespostas = null;
                //$scope.baserespostas = [{ id: 1, value: 'Ir para a próxima pergunta' }]
                //angular.forEach(pesquisa.Perguntas, function (item, key) {
                //    $scope.baserespostas.push({ id: item.Ordem + 1, value: 'Ir para a pergunta '+ item.Ordem })
                //});
            //};

            $scope.confirmaRemoverPergunta = function (data) {
                ModalService.confirmDelete(() => $scope.removerPergunta(data));
            };

            $scope.removerPergunta = function (data) {
                var index = $scope.perguntasList.indexOf(data);

                if (index != -1) {
                    $scope.perguntasList.splice(index, 1);
                }

                angular.forEach($scope.perguntasList, function (item, key) {
                    item.Ordem = key + 1;
                });

                $scope.distribuirPesoPerguntas();
            };

            $scope.distribuirPesoPerguntas = function () {
                var alternativasDestravadasComTipo3 = _.filter($scope.perguntasList, function (el) {
                    return !el.Travado;
                });
                var alternativasDestravadas = _.filter($scope.perguntasList, function (el) {
                    return !el.Travado && el.TipoId != 3;
                });
                var alternativasTravadas = _.filter($scope.perguntasList, function (el) {
                    return el.Travado && el.TipoId != 3;
                });
                var somatotal = 0;
                if (alternativasTravadas.length > 0) {
                    for (var i = 0; i < alternativasTravadas.length; i++) {
                        somatotal += alternativasTravadas[i].Peso;
                    }
                }

                var qtd = alternativasDestravadas.length;
                var peso = (qtd == 1) ? (100 - somatotal) : ((100 - somatotal) / qtd) | 0;
                var resto = 100 % qtd;
                var primeira = true;

                angular.forEach(alternativasDestravadasComTipo3, function (item) {
                    if (item.TipoId == 3) {
                        item.Peso = null;
                    }
                    else {
                        item.Peso = peso;
                        if (primeira) {
                            item.Peso += resto;
                            primeira = false;
                        }
                    }
                });
            };

            // #endregion Adicionar/Remover perguntas

            // #region Adicionar/Remover alternativas

            $scope.adicionarAlternativa = function (index) {
                var deferred = $q.defer();
                try {
                    var idxPergunta = index - 1;
                    var novoIdx = $scope.perguntasList[idxPergunta].Alternativas.length + 1;
                    const idxOutros = $scope.perguntasList[idxPergunta].Alternativas.findIndex( item => item.Outros === true);
                    const alternativaOutros = _.findWhere ($scope.perguntasList[idxPergunta].Alternativas, { Outros : true});
                    
                    var idx = novoIdx;
                    if(idxOutros > 0)
                    {
                        idx = alternativaOutros.Ordem;
                        $scope.perguntasList[idxPergunta].Alternativas[idxOutros].Ordem = novoIdx;
                    }
                    
                    $scope.getId();
                    var dados = $scope.NovosDadosAlternativa(idx);
    

                    $scope.perguntasList[idxPergunta].Alternativas.push(dados);
                    $scope.distribuirPesoAlternativas(idxPergunta);

                    setTimeout(function () {
                        deferred.resolve();
                    }, 200);

                }
                catch (err) {
                    deferred.reject();
                }

                return deferred.promise;
            };


            $scope.adicionarAlternativaOutros = function (item) {
                var idx = item.Alternativas.length + 1;

                var alternativaOutro =  {
                    Ordem: idx,
                    PesquisaAlternativaId: 0,
                    Descricao: 'Outros',
                    Peso: 0,
                    Ativo: true,
                    Outros: true
                };

                item.Alternativas.push(alternativaOutro);              
            };

            $scope.controleOutros = function(item, outros) {
                if(outros) {
                    $scope.adicionarAlternativaOutros(item);
                    const indexPergunta = $scope.perguntasList.findIndex( i => i.Id === item.Id);
                    $scope.distribuirPesoAlternativas(indexPergunta);
                } else {                    
                    const removeIndex = item.Alternativas.findIndex( item => item.Outros === true);
                    if(removeIndex > 0) {
                        item.Alternativas.splice( removeIndex, 1 );
                        const indexPergunta = $scope.perguntasList.findIndex( i => i.Id === item.Id);
                        $scope.distribuirPesoAlternativas(indexPergunta);
                    }
                }
            };

            $scope.confirmaRemoverAlternativa = function (perguntaIndex, data) {
                ModalService.confirmDelete(() => $scope.removerAlternativa(perguntaIndex, data));
            };

            $scope.removerAlternativa = function (perguntaIndex, data) {
                var index = $scope.perguntasList[perguntaIndex - 1].Alternativas.indexOf(data);
                if (index != -1) {
                    $scope.perguntasList[perguntaIndex - 1].Alternativas.splice(index, 1);
                }
                $scope.distribuirPesoAlternativas(perguntaIndex - 1);
                angular.forEach($scope.perguntasList[perguntaIndex - 1].Alternativas, function (item, key) {
                    item.Index = key + 1;
                    item.Ordem = key + 1;
                });
            };

            $scope.distribuirPesoAlternativas = function (idxPergunta) {
                var alternativasDestravadas = _.filter($scope.perguntasList[idxPergunta].Alternativas, function (el) {
                    return !el.Travado;
                });
                var alternativasTravadas = _.filter($scope.perguntasList[idxPergunta].Alternativas, function (el) {
                    return el.Travado;
                });
                var somatotal = 0;
                if (alternativasTravadas.length > 0) {
                    for (var i = 0; i < alternativasTravadas.length; i++) {
                        somatotal += alternativasTravadas[i].Peso;
                    }
                }
                var qtd = alternativasDestravadas.length;
                var peso = (qtd == 1) ? (100 - somatotal) : ((100 - somatotal) / qtd) | 0;
                var resto = (100 - somatotal) % qtd;

                angular.forEach(alternativasDestravadas, function (item, key) {
                    if ($scope.perguntasList[idxPergunta].TipoId == 3) {
                        item.Peso = null;
                    } else {
                        item.Peso = ((key + 1) == 1) ? peso + resto : peso;
                    }
                });
            };
            
            $scope.habilitarbaseresposta = function(item, checkedHabilitar) {

                $scope.setListaBaseRespostas(item);

                const idxPergunta = $scope.perguntasList.findIndex(i => i.Id === item.Id);
                
                let alternativasDestravadas = _.filter($scope.perguntasList[idxPergunta].Alternativas, function (el) {
                    return !el.Travado;
                });


                angular.forEach(alternativasDestravadas, function (item, key) {
                    item.BaseRespostaId = 1;
                    item.BaseResposta = checkedHabilitar;
                });
            };

            $scope.habilitarZerarAvaliacao = function(item) {
                
                for (let alternativa of item.Alternativas) {
                    alternativa.ZerarAvaliacao = false;
                }
            };

            $scope.onPesoAlterado = function (items, itemAlterado) {
                var perguntaId = itemAlterado.PesquisaPerguntaId == undefined ? items[0].PesquisaPerguntaId : itemAlterado.PesquisaPerguntaId;                
                var pergunta = _.findWhere($scope.perguntasList, { Id: perguntaId });
                if(pergunta != undefined)
                {
                    if(pergunta.TipoId == 2) return; //Alternativa
                }

                var i;
                var alternativas = _.without(items, itemAlterado);
                var alternativasDestravadas = _.filter(alternativas, function (el) {
                    if (el.TipoId === undefined || el.TipoId != 3) {
                        return !el.Travado;
                    }
                });
                var alternativasTravadas = _.filter(alternativas, function (el) {
                    if (el.TipoId === undefined || el.TipoId != 3) {
                        return el.Travado;
                    }
                });

                var somatotal;

                if (itemAlterado.Peso == undefined) {
                    somatotal = 0;
                    itemAlterado.Peso = 0;
                } else {
                    somatotal = itemAlterado.Peso;
                }

                if (alternativasTravadas.length > 0) {
                    for (i = 0; i < alternativasTravadas.length; i++) {
                        somatotal += alternativasTravadas[i].Peso;
                    }
                }
                if (somatotal > 100) {
                    itemAlterado.Peso -= (somatotal - 100);
                    for (i = 0; i < alternativasDestravadas.length; i++) {
                        alternativasDestravadas[i].Peso = 0;
                    }
                } else {
                    var pesoDestravados = Math.floor((100 - somatotal) / alternativasDestravadas.length);
                    var resto = (100 - somatotal) % alternativasDestravadas.length;
                    for (i = 0; i < alternativasDestravadas.length; i++) {
                        alternativasDestravadas[i].Peso = pesoDestravados;
                    }
                    if (alternativasDestravadas[0]) {
                        alternativasDestravadas[0].Peso += resto;
                    }
                }
            }

            $scope.tabAlternativa = function (event, perguntaOrdem, ultimaAlternativa) {
                if (ultimaAlternativa && event.keyCode == 9) {
                    $scope.adicionarAlternativa(perguntaOrdem).then(function () {
                        var fields = $(event.currentTarget).parents('form:eq(0),body').find('input.md-input-alternativa');
                        var index = fields.index(event.currentTarget);
                        if (index > -1 && (index + 1) < fields.length) {
                            fields.eq(index + 1)[0].focus();
                        }
                        event.preventDefault();
                    });
                }
            }

            $scope.verificaRange = function (event) {
                var value = event.currentTarget.value;
                if (value == '') {
                    event.currentTarget.value = "0";
                }
                else if (value < 0 || value > 100) {
                    event.currentTarget.value = "100";
                }
            }

            // #endregion Adicionar/Remover alternativas

            // #region Limpar as alternativas na seleção de um novo tipo

            $scope.limparAlternativasPergunta = function (perguntaIndex) {
                var tipoId = $scope.perguntasList[perguntaIndex - 1].TipoId;
                $scope.perguntasList[perguntaIndex - 1].Alternativas = [$scope.NovosDadosAlternativa(1, tipoId)];
                $scope.distribuirPesoPerguntas();
            };

            // #endregion Limpar as alternativas na seleção de um novo tipo

            // #region Ordenação de perguntas e alternativas

            $scope.ordenarPergunta = function (index, tipo) {
                var idx = index - 1
                if (tipo == 'asc') {
                    $scope.perguntasList = $scope.move($scope.perguntasList, idx, idx - 1);
                }
                else if (tipo == 'desc') {
                    $scope.perguntasList = $scope.move($scope.perguntasList, idx, idx + 1);
                }

                angular.forEach($scope.perguntasList, function (item, key) {
                    item.Ordem = key + 1;
                });
            };

            $scope.ordenarAlternativa = function (perguntaIndex, alternativaIndex, tipo) {
                var perguntaIdx = perguntaIndex - 1;
                var alternativaIdx = alternativaIndex - 1
                var alternativas = [];
                angular.copy($scope.perguntasList[perguntaIdx].Alternativas, alternativas);
                $scope.perguntasList[perguntaIdx].Alternativas = [];

                if (tipo == 'asc') {
                    $scope.perguntasList[perguntaIdx].Alternativas = $scope.move(alternativas, alternativaIdx, alternativaIdx - 1);
                }
                else if (tipo == 'desc') {
                    $scope.perguntasList[perguntaIdx].Alternativas = $scope.move(alternativas, alternativaIdx, alternativaIdx + 1);
                }

                angular.forEach($scope.perguntasList[perguntaIdx].Alternativas, function (item, key) { item.Ordem = key + 1; });
            };

            $scope.move = function (array, fromIndex, toIndex) {
                array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
                return array;
            };

            // #endregion Ordenação de perguntas e alternativas

            // #region Obter grupos 

            $scope.onChangeCarteira = function () {
                if($scope.pesquisa.CarteiraId == 0 || $scope.pesquisa.CarteiraId == undefined)
                {
                    $scope.gruposNaoAssociadosList = $scope.gruposNaoAssociadosListCopia;
                    $scope.gruposAssociadosList = $scope.gruposAssociadosListCopia;
                }else{
                    $scope.gruposNaoAssociadosList = _.filter($scope.gruposNaoAssociadosListCopia, function (el) {
                        return el.CarteiraId == $scope.pesquisa.CarteiraId;
                    });
                    $scope.gruposAssociadosList = _.filter($scope.gruposAssociadosListCopia, function (el) {
                        return el.CarteiraId == $scope.pesquisa.CarteiraId;
                    });
                }       
            };
            
            // Obter grupos não associados
            $scope.getGruposNaoAssociados = function () {
                var Id = ($scope.pesquisa ? ($scope.pesquisa.Id > 0 ? $scope.pesquisa.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id))) : parseInt($stateParams.Id));
                var data = { pesquisaId: Id };
                PesquisaResource.getGruposNaoAssociados(data).$promise.then(function (d) {
                    angular.copy(d, $scope.gruposNaoAssociadosListCopia);
                    angular.copy(d, $scope.gruposNaoAssociadosList);
                    $scope.onChangeCarteira();
                }, function () { });
            };

            // Obter grupos associados
            $scope.getGruposAssociados = function () {
                var Id = ($scope.pesquisa ? ($scope.pesquisa.Id > 0 ? $scope.pesquisa.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id))) : parseInt($stateParams.Id));
                var data = { pesquisaId: Id };
                PesquisaResource.getGruposAssociados(data).$promise.then(function (d) {
                    d = _.sortBy(d, function (el) { return el.Ordem; });
                    angular.copy(d, $scope.gruposAssociadosListCopia);
                    angular.copy(d, $scope.gruposAssociadosList);
                    $scope.onChangeCarteira();
                }, function () { });
            };
   
            $scope.getGruposNaoAssociados();
            $scope.getGruposAssociados();

            // #endregion Obter grupos 

            $scope.onGetPesquisaCategoriaItens = function(pesquisaCategoriaId) {
                if(parseInt(pesquisaCategoriaId) > 0) {
                    PesquisaCategoriaResource.GetPesquisaCategoriaItemByCategoriaId({ categoriaId: pesquisaCategoriaId }).$promise
                    .then(r => {
                        $scope.pesquisaCategoriaItens = r;
                    }).catch(NotifyService.showError);
                }
            }

            // #region Adicionar/remover/selecionar todos os grupos 

            $scope.adicionar = function () {
                var selecionados = _.where($scope.gruposNaoAssociadosList, { Selecionado: true });
                angular.forEach(selecionados, function (value) {
                    $scope.gruposNaoAssociadosList.splice($scope.gruposNaoAssociadosList.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Adicionado = true;
                    value.Ativo = true;

                    if (value.Removido && value.Alterado) {
                        value.Removido = false;
                        value.Alterado = false;
                        value.OrdemAlterado = true;
                    } else {
                        value.Alterado = true;
                        value.OrdemAlterado = false;
                    }

                    value.Ordem = 0;

                    $scope.gruposAssociadosList.push(value);                
                });
            };

            $scope.remover = function () {

                var selecionados = _.where($scope.gruposAssociadosList, { Selecionado: true });

                angular.forEach(selecionados, function (value) {
                    $scope.gruposAssociadosList.splice($scope.gruposAssociadosList.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Removido = true;

                    if (value.Adicionado && value.Alterado) {
                        value.Adicionado = false;
                        value.Alterado = false;
                    } else {
                        value.Alterado = true;
                    }

                    value.OrdemAlterado = false;

                    $scope.gruposNaoAssociadosList.push(value);
                });
            };

            $scope.selectionarTodosAssociados = function (selecionado) {
                angular.forEach($scope.gruposAssociadosList, function (item) {
                    item.Selecionado = selecionado;
                });
            };

            $scope.selectionarTodosNaoAssociados = function (selecionado) {
                angular.forEach($scope.gruposNaoAssociadosList, function (item) {
                    item.Selecionado = selecionado;
                });
            };

            // #endregion Adicionar/remover/selecionar todos os grupos 

            // #region Validar Pesquisa

            $scope.validarPesquisa = function (form) {
                var pesoPerguntas = 0;
                var erroPesoAlternativas = [];
                //$scope.formCadastroValidado = false;

                if ($scope.perguntasList.length <= 0 || $scope.perguntasList == undefined) {
                    NotifyService.showError(null, 'telaPesquisaEdit.aPesquisaPrecisaTerPeloMenosUmaPergunta');
                    return false;
                }

                $scope.perguntasList.forEach(function (item) {
                    if (item.TipoId != 3) {
                        var pesoAlternativas = 0;
                        pesoPerguntas += parseInt(item.Peso);

                        if (item.Alternativas.length <= 0 || item.Alternativas == undefined) {
                            NotifyService.showError(null, 'telaPesquisaEdit.aPerguntaPrecisaDeUmaAlternativa', {'Ordem': item.Ordem})
                            return false;
                        }

                        if(item.TipoId != 2)
                        {
                            item.Alternativas.forEach(function (alternativa) {
                                pesoAlternativas += parseInt(alternativa.Peso);
                            });

                            if (pesoAlternativas != 100) {
                                erroPesoAlternativas.push(item.Ordem);
                            }
                        }                        
                    }
                });

                if (pesoPerguntas != 100) {
                    NotifyService.showError(null, 'telaPesquisaEdit.oPesoTotalNaoPodeSerDiferenteDe100');
                    return false;
                }
                else if (erroPesoAlternativas.length > 0) {
                    if (erroPesoAlternativas.length == 1) {
                        NotifyService.showError(null, 'telaPesquisaEdit.oPesoDasAlternativasDaPergunta', {'Join': erroPesoAlternativas});
                    }
                    else {
                        var join = erroPesoAlternativas.slice(0, -1).join(', ') + $translate.instant('telaPesquisaEdit.e') + erroPesoAlternativas.slice(-1);
                        NotifyService.showError(null, 'telaPesquisaEdit.oPesoDasAlternativasDasPerguntas', {'Join': join});
                    }
                    return false;
                }
                else if (!form.$valid) {
                    return false;
                }

                //$scope.formCadastroValidado = true;
                return true;
            };

            $scope.validatePerguntas = function () {
                var proximoStep = false;
                var valid = $scope.validarPesquisa($scope.forms.formCadastro);

                if ($scope.forms.formCadastro.$valid && valid) {
                    proximoStep = true;
                }

                return proximoStep;
            };

            $scope.validarGrupo = function () {
                if ($scope.gruposAssociadosList.length <= 0 || $scope.gruposAssociadosList == undefined) {
                    NotifyService.showError(null, 'telaPesquisaEdit.aPesquisaPrecisaDePeloMenosUmGrupo');
                    return false;
                }
                return true;
            };

            $scope.validateGrupos = function () {
                var valid = $scope.validarGrupo($scope.forms.formCadastro);
                return valid;
            };

            // #endregion Validar Pesquisa

            // #region Salvar Pesquisa

            $scope.salvar = function (form) {
                var formCadastroValido = false;
                var formGruposValido = false;
                if (form.$name == "forms.formCadastro") {
                    formCadastroValido = $scope.validarPesquisa(form);
                    if (!formCadastroValido) {
                        form.$setSubmitted();
                        return;
                    } else {
                        WizardHandler.wizard().goTo(1);
                        return;
                    }
                }

                if (form.$name == "forms.formGrupos") {
                    formGruposValido = $scope.validarGrupo(form)
                    if (!formGruposValido) {
                        form.$setSubmitted();
                        return;
                    }
                    formCadastroValido = $scope.validarPesquisa($scope.forms.formCadastro);
                    if (formCadastroValido && formGruposValido) {
                        salvarPesquisa().then(function () {
                            NotifyService.showRegistroSalvo();
                            $scope.submitted = false;
                            if ($stateParams.page) {
                                $state.go($stateParams.page, {
                                    storage: true,
                                    grupo: undefined
                                });
                            }
                            $state.go('main.pesquisa.list', { storage: true });
                        }).catch(NotifyService.showError);
                    } else {
                        if (!formCadastroValido) {
                            $scope.forms.formCadastro.$setPristine()
                            WizardHandler.wizard().goTo(0);
                        }
                    }
                }
            };

            var salvarPesquisa = function () {
                $scope.pesquisa.Perguntas = $scope.perguntasList;
                $scope.pesquisa.Grupos = $scope.gruposAssociadosList;
                if ($scope.pesquisa.Id > 0) {
                    return PesquisaResource.update($scope.pesquisa).$promise;
                } else {
                    return PesquisaResource.save($scope.pesquisa).$promise;
                }
            };

            // #endregion 

            // #region Preview da Pesquisa

            $scope.showModalPreview = function() {
                angular.forEach($scope.perguntasList, function (item) {
                    item.desabilitar = false;
                });
                 ModalService.openModal('modal_avaliacao');
            }

            $scope.closeModalPreview = function () {
                _.each($scope.perguntasList, function (pergunta) {
                    if (pergunta.TipoId == 1)
                        _.each(pergunta.Alternativas, function (alt) { alt.RespostaCheck = false; });
                    else if (pergunta.TipoId == 2)
                        _.each(pergunta.Alternativas, function (alt) { alt.RespostaRadio = false; });
                    else
                        pergunta.RespostaText = '';
                });

                ModalService.closeModal('modal_avaliacao');
            };

            // #endregion 
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (PesquisaResource, search, orderBy, $odata) {
        var odata = PesquisaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Titulo) {
            odata.filter(new $odata.Func("contains", "Titulo", search.Titulo), true);
        }
        
        if(search.CarteiraId){
            odata.filter("CarteiraId", "=", parseInt(search.CarteiraId));
        }

        return odata;
    }

    angular.module("epbxManagerApp")
        .service("PesquisaListData", function PesquisaListData() {
            return function () {
                return {
                    pesquisas: ["PesquisaResource", "LocalStorageService", "$odata", "$stateParams", function (PesquisaResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = {};
                        var orderBy = { column: "Id", order: "desc" };

                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroPesquisa");
                        }

                        return getOdataSearchShared(PesquisaResource, filtro, orderBy, $odata).page(10, 1).query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.pesquisa", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.pesquisa.list',
                        pageTitle: 'telaPesquisa.TituloPagina',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.pesquisa.list", StateResolverProvider.configState("/pesquisa?storage", "Pesquisa", "List", {
                    pageTitle: 'telaPesquisa.TituloPagina',
                    pageName: 'acoes.cadastrar'
                }))
        }])

        .controller("PesquisaListController", ["$scope", "$odata", "$stateParams", "pesquisas", "PesquisaResource", "LocalStorageService", "NotifyService", "ModalService", "carteiras", function ($scope, $odata, $stateParams, pesquisas, PesquisaResource, LocalStorageService, NotifyService, ModalService, carteiras) {
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPesquisa") : { pageSize: 10 };
            $scope.pesquisas = pesquisas;
            $scope.carteiras = carteiras;
            $scope.searching = false;
            $scope.orderBy = { column: "Id", order: "desc" };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.pesquisaList.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            var updateList = function (list) {
                $scope.pesquisaList = list;
                $scope.pesquisaList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.pesquisaList.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(PesquisaResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroPesquisa', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            updateList(pesquisas);

            var deleteRecord = function (data) {
                return PesquisaResource.delete(data).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function confirmDelete(data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            $scope.limparFiltro = function () {
                $scope.search = { pageSize: 10 };
                $scope.reverse = false;
                $scope.orderBy = { column: "Id", order: "desc" };
                $scope.executeSearch();
            };
        }])
    })
();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("PesquisaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Pesquisa/:Id",
                {
                    "Id": "@Id"
                },
                {
                    bilheteStatus: {
                        url: "Pesquisa/BilheteStatus",
                        method: "GET",
                        isArray: true
                    },
                    bilheteDetalhe: {
                        url: "Bilhete/BilheteDetalhe",
                        method: "GET",
                        isArray: true
                    },
                    getGruposNaoAssociados: {
                        url: "Pesquisa/GruposNaoAssociados",
                        method: "GET",
                        isArray: true
                    },
                    getGruposAssociados: {
                        url: "Pesquisa/GruposAssociados",
                        method: "GET",
                        isArray: true
                    },
                    getTiposPerguntas: {
                        url: "Pesquisa/TiposPerguntas",
                        method: "GET",
                        isArray: true
                    },
                });
        }]);

    angular.module('epbxManagerApp')
        .factory("PesquisaGrupoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Pesquisa/Grupo/:PesquisaId", { "PesquisaId": "@PesquisaId" });
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("PesquisaAvaliacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Pesquisa/:PesquisaId", {
                "PesquisaId": "@PesquisaId"
            }, {
                pesquisaAvaliacao: {
                    url: "Pesquisa/ListaAvaliacoes/:pageIndex/:pageSize",
                    method: "GET",
                    isArray: false
                },
                pesquisaAvaliacaoCount: {
                    url: "Pesquisa/ListaAvaliacoesCount",
                    method: "GET",
                    isArray: false
                },
                pesquisaAvaliacaoOperador: {
                    url: "Pesquisa/ListaAvaliacoesOperadores/:pageIndex/:pageSize",
                    method: "GET",
                    isArray: false
                },
                pesquisaAvaliacaoOperadorCount: {
                    url: "Pesquisa/ListaAvaliacoesOperadoresCount",
                    method: "GET",
                    isArray: false
                },
                pesquisaAvaliacaoPesquisas: {
                    url: "Pesquisa/ListaPesquisas",
                    method: "GET",
                    isArray: true,
                },
                listarPerguntasPorPesquisaId: {
                    url: "Pesquisa/ListarPerguntasPorPesquisaId",
                    method: "GET",
                    isArray: true,
                },
                avaliarPesquisa: {
                    url: "Pesquisa/AvaliarPesquisa",
                    method: "POST",
                },
                enviarAvaliacaoPorEmail: {
                    url: "Pesquisa/EnviarAvaliacaoPorEmail",
                    method: "POST",
                },
                limparAvaliacoesUsuario: {
                    url: "Pesquisa/LimparAvaliacoesUsuario",
                    method: "GET",
                    isArray: false
                },
                listarDirecao: {
                    url: "Pesquisa/ListaDirecoes",
                    method: "GET",
                    isArray: true,
                },
                getResultadosIndividuaisDetalhes: {
                    url: "RelatorioPesquisa/ResultadosIndividuaisDetalhes",
                    method: "GET",
                    isArray: false
                },
                deletePesquisaAvaliacao: {
                    url: "Pesquisa/DeletePesquisaAvaliacao",
                    method: "POST",
                },
                Exportar: {
                    url: "Pesquisa/Exportar",
                    method: "GET"
                },
                ExportarOperadores: {
                    url: "Pesquisa/ExportarOperadores",
                    method: "GET"
                },
                PerguntasResposta:{
                    url: "Pesquisa/PerguntasResposta",
                    method: "GET",
                    isArray: true
                },
                deleteAvaliacaoByBilheteIdAndGlobalId: {
                    url: "Pesquisa/DeleteAvaliacaoByBilheteIdAndGlobalId",
                    method: "PUT",
                    params: {
                        "bilheteId": "@bilheteId",
                        "globalId": "@globalId"
                    }
                }
            });
        }]);
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.pesquisaAvaliacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.pesquisaAvaliacao.list',
                        pageTitle: 'pageTitle.relatorioDeBilhetes',
                        pageName: 'model.bilhetes'
                    }
                })
                .state("main.pesquisaAvaliacao.list", StateResolverProvider.configState("/pesquisaAvaliacao", "PesquisaAvaliacao", "List", {
                    pageTitle: 'pageTitle.avaliacoes',
                    pageName: 'pageTitle.pesquisar'
                }))
        }])

        .service("PesquisaAvaliacaoListData", function PesquisaAvaliacaoListData() {
            return function () {
                return {
                    grupoList: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getTodosGrupos();
                    }],
                    statusList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatus().$promise;
                    }],
                    rotaList: ["RotaResource", function (RotaResource) {
                        return RotaResource.odata().select(["RotaId", "Nome"]).query();
                    }],
                    servicoList: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.odata().select(["ServicoId", "Numero"]).query();
                    }],
                    statusDetalheList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatusDetalhe().$promise;
                    }],
                    cenariosList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.cenario().$promise;
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        var odata = CampanhaResource.odata();
                        odata.filter("CampanhaStatusId", "!=", 1);
                        return odata.select(["CampanhaId", "Nome"]).query();
                    }],
                    getPesquisasList: ["PesquisaAvaliacaoResource", function (PesquisaAvaliacaoResource) {
                        return PesquisaAvaliacaoResource.pesquisaAvaliacaoPesquisas({ grupoId: 0 }).$promise;
                    }],
                    direcaoList: ["PesquisaAvaliacaoResource", function (PesquisaAvaliacaoResource) {
                        return PesquisaAvaliacaoResource.listarDirecao().$promise;
                    }],
                    usuarioList: ["UsuarioResource", function (UsuarioResource) {
                        return UsuarioResource.GetTodosUsuario().$promise;
                    }],
                    carteiraList: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })

        .controller("PesquisaAvaliacaoListController", ["$scope", "$rootScope", "PesquisaAvaliacaoResource", "PesquisaCategoriaResource", "grupoList", "rotaList", "servicoList", "NotifyService", "statusDetalheList", "cenariosList", "getPesquisasList", "campanhasList", "direcaoList", "ModalService", "$translate", "usuarioList", "carteiraList", "AuthService", function ($scope, $rootScope, PesquisaAvaliacaoResource, PesquisaCategoriaResource, grupoList, rotaList, servicoList,
            NotifyService, statusDetalheList, cenariosList, getPesquisasList, campanhasList, direcaoList, ModalService, $translate, usuarioList, carteiraList, AuthService) {
            
            $scope.searching = false;
            $scope.forms = {};            
            $scope.carteiraList = carteiraList;

            $scope.grupoListAtivo = _.filter(grupoList, function (item) {
                return item.Ativo == 1;
            });

            $scope.grupoList = $scope.grupoListAtivo;

            $scope.rotaList = rotaList;
            $scope.servicoList = servicoList;
            $scope.statusDetalheList = statusDetalheList;
            $scope.usuarioList = usuarioList;
            $scope.cenariosList = cenariosList;
            $scope.campanhasList = campanhasList;
            $scope.validacao = {};
            $scope.pesquisaCount = 0;
            $scope.pesquisaOperadorCount = 0;
            $scope.pesquisasList = [];
            $scope.pesquisaCategoriaItens = [];
            $scope.pesquisasSearchList = getPesquisasList;
            $scope.bilhete = {};
            $scope.direcaoList = direcaoList;
            $scope.modalAvaliacao = false;
            $scope.modalRespondida = false;
            $scope.modalEditar = false;
            $scope.bilheteEmail = { EnviarAnexo: 'true' };
            $scope.pesquisaBilheteList = [];
            $scope.pesquisaBilheteOperadorList = [];
            const pageSize = 10
            let pageIndex = 1 
            $scope.primeiraAba = true;
            $scope.pesquisaCategoriaItem = {};
            $scope.usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;
            
            $scope.desconexaoList = [
                { Descricao: $translate.instant('model.cliente'), DesconexaoId: '1' },
                { Descricao: $translate.instant('campo.operador'), DesconexaoId: '0' }
            ];

            $scope.search = {
                DataInicio: moment().subtract(1, 'days').seconds(0).milliseconds(0).toDate(),
                DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                DuracaoMaiorQue: ''
            };

            $scope.searchOperador = {
                DataInicio: moment().subtract(1, 'days').seconds(0).milliseconds(0).toDate(),
                DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                ScoreMaiorQue: ''
            };

            $scope.orderByOperador = {
                column: "Usuario",
                order: "asc"
            };


            $scope.regex = {
                // eslint-disable-next-line no-useless-escape
                email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
            };

            $scope.executeSearch = function (search) {
                if (!$scope.forms.formBilhete.$valid) {
                    return;
                }

                $scope.searching = true;
                $scope.forms.formBilhete.$setDirty();

                var filtro = {
                    BilheteStatusId: search.Ativo,
                    BilheteStatusDetalheId: search.BilheteStatusDetalheId,
                    GrupoId: search.GrupoId,
                    PesquisaId: search.pesquisaId,
                    RotaId: search.RotaId,
                    NA: search.NA,
                    DirecaoId: search.BilheteDirecaoId,
                    UsuarioId: search.UsuarioId,
                    DataI: search.DataInicio,
                    DataF: search.DataFim,
                    GlobalId: search.GlobalId,
                    Duracao: search.DuracaoMaiorQue,
                    Direcao: search.DirecaoId,
                    NB: search.NB,
                    BilheteCenarioId: search.BilheteCenarioId,
                    CausaCodigo: search.CausaCodigo,
                    CampanhaId: (search.CampanhaId == null || search.CampanhaId == 0) ? [] : search.CampanhaId.join(),
                    DiscagemTipoId: search.DiscagemTipoId,
                    CodigoCliente: search.CodigoCliente,
                    OrderBy: "Titulo desc",
                    Status: search.Ativo,
                    DesconexaoId: search.DesconexaoId,
                    Avaliadas: search.Avaliadas,
                    NotaAvaliacao: search.NotaAvaliacao
                };

                getOdataSearch(filtro);
            };

            $scope.executeSearchOperadores = function (searchOperador) {
                if (!$scope.forms.formAvaliacaoOperador.$valid) {
                    return;
                }

                $scope.searching = true;
                $scope.forms.formAvaliacaoOperador.$setDirty();

                var filtro = {                    
                    GrupoId: searchOperador.GrupoId,
                    PesquisaId: searchOperador.pesquisaId,                    
                    DataI: searchOperador.DataInicio,
                    DataF: searchOperador.DataFim,
                    CarteiraId : searchOperador.CarteiraId,
                    UsuarioId : searchOperador.UsuarioId,                  
                    Score : searchOperador.ScoreMaiorQue,
                    AvaliadorId : searchOperador.AvaliadorId,
                    OrderBy: "Titulo desc",                    
                    SortColumn: $scope.orderByOperador.column,
                    SortDirection: $scope.orderByOperador.order
                };

                getOdataSearchOperador(filtro);
            };

            $scope.limparFiltro = function () {
                return PesquisaAvaliacaoResource.limparAvaliacoesUsuario().$promise
                    .then(() => {
                        $scope.search = {
                            pageSize: 15,
                            DataInicio: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
                            DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                            CampanhaId: [],
                            pesquisaId: null
                        };

                        $scope.pesquisaBilheteList = [];
                        $scope.reverse = false;
                        $scope.orderBy = { column: "Titulo", order: "desc" };
                        $rootScope.$broadcast('onLimparAvaliacoes');
                    }).catch(NotifyService.showError);
            };

            $scope.limparFiltroOperador = function () {
                $scope.searchOperador = {
                    pageSize: 15,
                    DataInicio: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
                    DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),                    
                    PesquisaId: null,
                    GrupoId: null,
                    CarteiraId : null,
                    UsuarioId: null,        
                    ScoreMaiorQue: '',
                    ScoreMenorQue: ''            
                };
            };

            $scope.limparCampanhas = function (direcaoId) {
                if (direcaoId == 1) {
                    $scope.search.CampanhaId = []
                    $rootScope.$broadcast('onLimparAvaliacoes');
                }
            };

            $scope.modalPesquisaAvaliada = function (bilhete) {                
                PesquisaAvaliacaoResource.getResultadosIndividuaisDetalhes({ PesquisaId: bilhete.PesquisaId, GlobalId: bilhete.GlobalId }).$promise
                    .then((data) => {
                        $scope.resultadosIndividuaisDetalhe = data;
                        $scope.btnShow = true;
                        $scope.modalAvaliacao = false;
                        $scope.modalEditar = false;
                        $scope.modalRespondida = true;
                        $scope.search.bilheteDialogoAtivo = bilhete;

                        $('#modal_avaliacao').on({
                            'hide.uk.modal': () => {
                                $scope.search.bilheteDialogoAtivo = null;
                                // Gerar evento para parar audios
                                $rootScope.$broadcast('onStopPlay');
                            }
                        })

                        ModalService.openModal('modal_avaliacao');
                    });
            };

            $scope.modalEditarPesquisa = function (bilhete) {  
                $scope.bilhete = bilhete;               
                PesquisaAvaliacaoResource.getResultadosIndividuaisDetalhes({ PesquisaId: bilhete.PesquisaId, GlobalId: bilhete.GlobalId }).$promise
                    .then((data) => {

                        $scope.pesquisaEdit = data;
                        $scope.btnShow = true;
                        $scope.modalAvaliacao = false;
                        $scope.modalRespondida = false;
                        $scope.modalEditar = true;
                        $scope.search.bilheteDialogoAtivo = bilhete;                        

                        for (let pergunta of $scope.pesquisaEdit.Perguntas) {
                            pergunta.desabilitar = false;

                            switch(pergunta.TipoId) {
                                case 1:
                                  for (let alternativa of pergunta.AlternativasRespostas) {
                                    if (alternativa.OpcaoSelecionada) {
                                        alternativa.RespostaCheck = true;
                                        alternativa.Selecionada = true;
                                    } else {
                                        alternativa.RespostaCheck = false;
                                        alternativa.Selecionada = false;
                                    }  
                                  }
                                  break;
                                case 2:
                                    for (let alternativa of pergunta.AlternativasRespostas) {
                                        if (alternativa.OpcaoSelecionada) {
                                            alternativa.RespostaRadio = true;
                                            alternativa.Selecionada = true;
                                        } else {
                                            alternativa.RespostaRadio = false;
                                            alternativa.Selecionada = false;
                                        }  
                                    }
                                  break;
                                case 3:
                                    pergunta.RespostaEscrita = pergunta.AlternativasRespostas[0].RespostaEscrita;
                                    break;
                            }
                        }

                        $scope.carregaPequisaCategoriaItens(bilhete.PesquisaId);

                        $('#modal_avaliacao').on({
                            'hide.uk.modal': () => {
                                $scope.search.bilheteDialogoAtivo = null;
                                // Gerar evento para parar audios
                                $rootScope.$broadcast('onStopPlay');
                            }
                        })

                        ModalService.openModal('modal_avaliacao');
                    });
            };

            $scope.modalAvaliacaoPorEmail = function (bilhete) {
                $scope.bilheteEmail = {
                    PesquisaId: bilhete.PesquisaId,
                    BilheteId: bilhete.BilheteId,
                    GlobalId: bilhete.GlobalId,
                    EnviarAnexo: true,
                    Destinatario: ''
                };

                ModalService.openModal('modal_avaliacao_por_email');
            };

            $scope.getTotalAvaliacao = function (perguntas) {
                var total = 0;
                if (perguntas != null && perguntas.length > 0) {
                    _.each(perguntas, function (el) {
                        total += el.PesoObtido;
                    });
                }
                return total;
            };

            $scope.enviarPorEmail = function (form) {
                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                PesquisaAvaliacaoResource.enviarAvaliacaoPorEmail($scope.bilheteEmail).$promise
                    .then(() => { NotifyService.showSuccess('telaPesquisaAvaliacao.emailDaAvaliacaoEnviado') })
                    .catch((error) => { NotifyService.showError(error, 'telaPesquisaAvaliacao.erroAoEnviarEmalDaAvaliacao') });

                ModalService.closeModal('modal_avaliacao_por_email');
                $scope.bilheteEmail = {};
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmMessage('telaPesquisaAvaliacao.confirmDeleteAvaliacao', null, () => deleteAvaliacao(data));
            };

            var deleteAvaliacao = function (data) {
                return PesquisaAvaliacaoResource.deleteAvaliacaoByBilheteIdAndGlobalId({ bilheteId: data.BilheteId, globalId: data.GlobalId }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch($scope.search);
                    })
                    .catch(NotifyService.showError);
            };

            $scope.modalAvaliar = function (bilhete) {
                $scope.bilhete = bilhete;
                // Carrega a lista de perguntas
                PesquisaAvaliacaoResource.listarPerguntasPorPesquisaId({ pesquisaId: bilhete.PesquisaId }).$promise
                    .then((data) => {
                        $scope.perguntasList = data;

                        angular.forEach($scope.perguntasList, function (item) {
                            item.desabilitar = false;
                        });
                        
                        $scope.carregaPequisaCategoriaItens(bilhete.PesquisaId);
                        
                        $scope.btnShow = true;
                        $scope.modalAvaliacao = true;
                        $scope.modalRespondida = false;
                        $scope.modalEditar = false;
                        $scope.search.bilheteDialogoAtivo = bilhete;
                        ModalService.openModal('modal_avaliacao', null, function () {
                            $rootScope.$broadcast('onStopPlay');
                        });
                    }).catch(NotifyService.showError);
            };

            $scope.carregaPequisaCategoriaItens = function (pesquisaId) {
                PesquisaCategoriaResource.GetPesquisaCategoriaItemByPesquisaId({ pesquisaId: pesquisaId }).$promise
                    .then((data) => {
                        $scope.pesquisaCategoriaItens = data;
                    }).catch(NotifyService.showError);

            }

            $scope.carregaPesquisas = function (grupoId) {
                if (grupoId == undefined) {
                    $scope.pesquisasSearchList = getPesquisasList;
                    $scope.search.pesquisaId = null;
                    $scope.btnShow = false;
                    return;
                }

                PesquisaAvaliacaoResource.pesquisaAvaliacaoPesquisas({ grupoId: grupoId }).$promise
                    .then((data) => $scope.pesquisasSearchList = data)
                    .catch(NotifyService.showError);
            };

            $scope.carregaPerguntas = function (pesquisaId) {
                if (pesquisaId == undefined) {
                    $scope.perguntasList = [];
                    $scope.btnShow = false;
                    return;
                }

                PesquisaAvaliacaoResource.listarPerguntasPorPesquisaId({ pesquisaId: pesquisaId }).$promise
                    .then((data) => {
                        $scope.perguntasList = data;
                        $scope.btnShow = true;
                    }).catch(NotifyService.showError);
            };

            $scope.validacaoCampo = function (pergunta, alternativaSelecionada) {
                
                $scope.validacao["Pergunta_" + pergunta.Id] = false;
               
                if(alternativaSelecionada != null){
                    if(alternativaSelecionada.Outros)
                    {
                        const indexPergunta = $scope.perguntasList.findIndex( i => i.Id === pergunta.Id);
                        const alternativaOutros = _.findWhere ($scope.perguntasList[indexPergunta].Alternativas, { Outros : true});
                        alternativaOutros.HabilitarTexto = true;
                    }
                    else    {
                        const indexPergunta = $scope.perguntasList.findIndex( i => i.Id === pergunta.Id);
                        const alternativaOutros = _.findWhere ($scope.perguntasList[indexPergunta].Alternativas, { Outros : true});
                        if (alternativaOutros != null )
                            alternativaOutros.HabilitarTexto = false;
                    }
                }
                               
                if (pergunta.TipoId == 1) {
                    _.each(pergunta.Alternativas, function (alternativa) {
                        if (alternativa.RespostaCheck) {
                            $scope.validacao["Pergunta_" + pergunta.Id] = true;
                        }
                    });
                }
                else if (pergunta.TipoId == 2) {
                    _.each(pergunta.Alternativas, function (alternativa) { 
                        if (parseInt(alternativa.RespostaRadio) == parseInt(alternativaSelecionada.RespostaRadio)) {
                            $scope.validacao["Pergunta_" + pergunta.Id] = true;
                            alternativa.Selecionada = true;                            
                        } else {
                            alternativa.Selecionada = false;
                        }
                    });
                } else {
                    $scope.validacao["Pergunta_" + pergunta.Id] = true;
                }

                //Para os tipos multipla escolha e alternativa verificar se precisa desabilitar outras perguntas com base na resposta
                if(pergunta.TipoId == 2 || pergunta.TipoId == 1) {
                    if(alternativaSelecionada!= null) {
                        angular.forEach($scope.perguntasList, function (item) {                            
                            var  perguntaSelecionada = $scope.perguntasList.filter(function(item) {
                                return item.Id == alternativaSelecionada.PesquisaPerguntaId;
                            })[0];

                            if(perguntaSelecionada.BaseResposta) {
                                if (item.Ordem > perguntaSelecionada.Ordem) {
                                    item.desabilitar = false;
    
                                    /* if (item.TipoId == 1) {
                                        angular.forEach(item.Alternativas, function (alternativa) {                                                                        
                                             alternativa.RespostaCheck = false;                                   
                                        });
                                     }
     
                                     if (item.TipoId == 2) {
                                         angular.forEach(item.Alternativas, function (alternativa) {                                                                        
                                              alternativa.RespostaRadio   = false;                                   
                                         });
                                      }
    
                                      if (item.TipoId == 3) {
                                        item.RespostaText = '';
                                     } */
                                      
                                }
                            }

                            if (alternativaSelecionada.BaseRespostaId > 1 
                                && item.Ordem < (alternativaSelecionada.BaseRespostaId - 1) 
                                && item.Ordem > perguntaSelecionada.Ordem
                                && item.Id != alternativaSelecionada.PesquisaPerguntaId
                                ) {
                                item.desabilitar = true;
                               
                            }
                        });
                    }
                }   
            };

            $scope.validacaoCampoEdit = function (pergunta, alternativaSelecionada) {
                
                $scope.validacao["Pergunta_" + pergunta.PerguntaId] = false;
               
                if(alternativaSelecionada != null){
                    if(alternativaSelecionada.Outros)
                    {
                        const indexPergunta = $scope.pesquisaEdit.Perguntas.findIndex( i => i.PerguntaId === pergunta.PerguntaId);
                        const alternativaOutros = _.findWhere ($scope.pesquisaEdit.Perguntas[indexPergunta].AlternativasRespostas, { Outros : true});
                        alternativaOutros.HabilitarTexto = true;
                    }
                    else    {
                        const indexPergunta = $scope.pesquisaEdit.Perguntas.findIndex( i => i.PerguntaId === pergunta.PerguntaId);
                        const alternativaOutros = _.findWhere ($scope.pesquisaEdit.Perguntas[indexPergunta].AlternativasRespostas, { Outros : true});
                        if (alternativaOutros != null )
                            alternativaOutros.HabilitarTexto = false;
                    }
                }
                               
                if (pergunta.TipoId == 1) {
                    _.each(pergunta.AlternativasRespostas, function (alternativa) {
                        if (alternativa.RespostaCheck) {
                            $scope.validacao["Pergunta_" + pergunta.PerguntaId] = true;
                        }
                    });
                }
                else if (pergunta.TipoId == 2) {
                    _.each(pergunta.AlternativasRespostas, function (alternativa) { 
                        if (parseInt(alternativa.RespostaRadio) == parseInt(alternativaSelecionada.RespostaRadio)) {
                            $scope.validacao["Pergunta_" + pergunta.PerguntaId] = true;
                            alternativa.Selecionada = true;                            
                            alternativa.RespostaRadio = true;
                            angular.element($('#radio_demo_inline_'+ pergunta.PerguntaId + "_" + alternativa.AlternativaId)).prop("checked",true);                       
                        } else {
                            alternativa.Selecionada = false;
                            alternativa.RespostaRadio = false;
                            angular.element($('#radio_demo_inline_'+ pergunta.PerguntaId + "_" + alternativa.AlternativaId)).prop("checked",false);
                        }
                    });
                } else {
                    $scope.validacao["Pergunta_" + pergunta.PerguntaId] = true;
                }

                //Para os tipos multipla escolha e alternativa verificar se precisa desabilitar outras perguntas com base na resposta
                if(pergunta.TipoId == 2 || pergunta.TipoId == 1) {
                    if(alternativaSelecionada!= null) {
                        angular.forEach($scope.pesquisaEdit.Perguntas, function (item) {                            
                            var  perguntaSelecionada = $scope.pesquisaEdit.Perguntas.filter(function(item) {
                                return item.PerguntaId == alternativaSelecionada.PerguntaId;
                            })[0];

                            if(perguntaSelecionada.BaseResposta) {
                                if (item.Ordem > perguntaSelecionada.Ordem) {
                                    item.desabilitar = false;                                      
                                }
                            }

                            if (alternativaSelecionada.BaseRespostaId > 1 
                                && item.Ordem < (alternativaSelecionada.BaseRespostaId - 1) 
                                && item.Ordem > perguntaSelecionada.Ordem
                                && item.Id != alternativaSelecionada.PerguntaId
                                ) {
                                item.desabilitar = true;
                               
                            }
                        });
                    }
                }   
            };

            $scope.salvarPesquisaResposta = function (form) {
                if ($scope.bilhete.BilheteId == 0) {
                    return NotifyService.showError(null, 'telaPesquisaAvaliacao.naoEPossivelFazerAAvaliacao');
                }
                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();
                }

                var avaliacoes = [];

                _.each($scope.perguntasList, function (pergunta) {
                    if (pergunta.desabilitar == false) {
                        //$scope.validacaoCampo(pergunta);
                        _.each(pergunta.Alternativas, function (alternativa) {
                            if (alternativa.RespostaCheck) {
                                if(pergunta.Observacao) {
                                    if (alternativa.Outros) {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Texto: pergunta.RespostaText,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    } else {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    }
                                } else {
                                    if (alternativa.Outros) {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Texto: pergunta.RespostaText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    } else {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    }
                                }
                            }
                            if (alternativa.RespostaRadio && alternativa.Selecionada) {
                                if(pergunta.Observacao) {
                                    if(alternativa.Outros) {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Texto: pergunta.RespostaText,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });                                    
                                    } else {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao                                  
                                        });                                    
                                    }
                                } else {
                                    if(alternativa.Outros) {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Texto: pergunta.RespostaText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });                                    
                                    } else {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao                                
                                        });                                    
                                    }
                                }
                            }
                        });
                    }

                    if (pergunta.TipoId == 3 && pergunta.RespostaText) {
                        avaliacoes.push({
                            BilheteId: $scope.BilheteId,
                            PerguntaId: pergunta.Id,
                            PesoAlternativa: 0, //pergunta.Peso,
                            Texto: pergunta.RespostaText
                        });
                    }
                });
                
                if (avaliacoes.some((x) => x.ZerarAvaliacao == true)) {
                    for (let avaliacao of avaliacoes) {
                        avaliacao.PesoAlternativa = 0;
                        avaliacao.PesoPergunta = 0;
                    }
                }

                var dados = {
                    BilheteId: $scope.bilhete.BilheteId,
                    UsuarioAvaliado: $scope.bilhete.UsuarioId,
                    Avaliacoes: avaliacoes,
                    GlobalId: $scope.bilhete.GlobalId,
                    PesquisaCategoriaItemId: $scope.pesquisaCategoriaItem.PesquisaCategoriaItemId
                };

                var valido = true;

                angular.forEach($scope.validacao, function (item) {
                    if (!item) {
                        valido = false;
                    }
                });

                if (!valido) {
                    return;
                }

                PesquisaAvaliacaoResource.avaliarPesquisa(dados).$promise
                    .then(() => {
                        NotifyService.showRegistroSalvo();
                        // Limpa a lista de perguntas
                        $scope.pesquisasList = [];
                        $scope.perguntasList = [];
                        ModalService.closeModal('modal_avaliacao');
                        $scope.modalAvaliacao = false;
                        $scope.modalRespondida = false;
                        $scope.modalEditar = false;
                        // Retira o item da grid
                        angular.forEach($scope.pesquisaBilheteList, (item) => {
                            if (item.BilheteId == dados.BilheteId) {
                                var index = $scope.pesquisaBilheteList.indexOf(item);
                                $scope.pesquisaBilheteList.splice(index, 1);
                            }
                        });

                        $scope.executeSearch($scope.search);
                    }).catch(NotifyService.showError);
            };

            $scope.editarPesquisaResposta = function (form) {
                if ($scope.bilhete.BilheteId == 0) {
                    return NotifyService.showError(null, 'telaPesquisaAvaliacao.naoEPossivelFazerAAvaliacao');
                }
                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();
                }

                var avaliacoes = [];

                _.each($scope.pesquisaEdit.Perguntas, function (pergunta) {
                    if (pergunta.desabilitar == false) {
                        _.each(pergunta.AlternativasRespostas, function (alternativa) {
                            if (alternativa.RespostaCheck) {
                                if(pergunta.Observacao) {
                                    if (alternativa.Outros) {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            Texto: pergunta.RespostaText,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    } else {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    }
                                } else {
                                    if (alternativa.Outros) {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            Texto: pergunta.RespostaText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    } else {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });
                                    }
                                }
                            }
                            if (alternativa.RespostaRadio && alternativa.Selecionada) {
                                if(pergunta.Observacao) {
                                    if(alternativa.Outros) {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            Texto: pergunta.RespostaText,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });                                    
                                    } else {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            Observacao: pergunta.ObservacaoText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao                                  
                                        });                                    
                                    }
                                } else {
                                    if(alternativa.Outros) {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            Texto: pergunta.RespostaText,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao  
                                        });                                    
                                    } else {
                                        avaliacoes.push({
                                            PerguntaId: pergunta.PerguntaId,
                                            AlternativaId: alternativa.AlternativaId,
                                            PesoAlternativa: alternativa.PesoAlternativa,
                                            PesoPergunta: pergunta.PesoPergunta,
                                            ZerarAvaliacao: alternativa.ZerarAvaliacao                                
                                        });                                    
                                    }
                                }
                            }
                        });
                    }

                    if (pergunta.TipoId == 3 && pergunta.RespostaText) {
                        avaliacoes.push({
                            PerguntaId: pergunta.PerguntaId,
                            PesoAlternativa: 0,
                            Texto: pergunta.RespostaText
                        });
                    }
                });
                
                if (avaliacoes.some((x) => x.ZerarAvaliacao == true)) {
                    for (let avaliacao of avaliacoes) {
                        avaliacao.PesoAlternativa = 0;
                        avaliacao.PesoPergunta = 0;
                    }
                }

                var dados = {
                    BilheteId: $scope.bilhete.BilheteId,
                    UsuarioAvaliado: $scope.bilhete.UsuarioId,
                    Avaliacoes: avaliacoes,
                    GlobalId: $scope.bilhete.GlobalId,
                    PesquisaCategoriaItemId: $scope.pesquisaEdit.PesquisaCategoriaItemId
                };

                var valido = true;

                angular.forEach($scope.validacao, function (item) {
                    if (!item) {
                        valido = false;
                    }
                });

                if (!valido) {
                    return;
                }

                PesquisaAvaliacaoResource.avaliarPesquisa(dados).$promise
                    .then(() => {
                        NotifyService.showRegistroSalvo();
                        // Limpa a lista de perguntas
                        $scope.pesquisasList = [];
                        $scope.perguntasList = [];
                        ModalService.closeModal('modal_avaliacao');
                        $scope.modalAvaliacao = false;
                        $scope.modalRespondida = false;
                        $scope.modalEditar = false;
                        // Retira o item da grid
                        angular.forEach($scope.pesquisaBilheteList, (item) => {
                            if (item.BilheteId == dados.BilheteId) {
                                var index = $scope.pesquisaBilheteList.indexOf(item);
                                $scope.pesquisaBilheteList.splice(index, 1);
                            }
                        });
                    }).catch(NotifyService.showError);
            }; 


            $scope.pararDialogo = function () {
                $scope.search.bilheteDialogoAtivo = null;
            };

            $('#modal_avaliacao').on({
                'hide.uk.modal': function () {
                    $rootScope.$broadcast('audioPlayerInlineStop');
                }
            });

            $scope.pageChanged = function (newPage) {
                if (pageIndex != newPage) {
                    pageIndex = newPage;
                    $scope.executeSearch($scope.search)
                }
            };

            $scope.pageChangedOperador = function (newPage) {
                if (pageIndex != newPage) {
                    pageIndex = newPage;
                    $scope.executeSearchOperadores($scope.searchOperador)
                }
            };

            var getOdataSearch = function (params) {
                $scope.searchingCount = true;
                $scope.pesquisaCount = 0;
                params.pageIndex = pageIndex;
                params.pageSize = pageSize;
                PesquisaAvaliacaoResource.pesquisaAvaliacao(params).$promise
                    .then(response => {
                        $scope.pesquisaBilheteList = response.Data;
                        $scope.pesquisaBilheteList.recordCount = response.RecordCount;
                        $scope.pesquisaBilheteList.currentPage = response.PageIndex || 1;
                        $scope.pesquisaBilheteList.pageSize = response.PageSize || 10;
                        $scope.searching = false;
                        getCount(params);
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var getOdataSearchOperador = function (params) {
                $scope.searchingCount = true;
                $scope.pesquisaOperadorCount = 0;
                params.pageIndex = pageIndex;
                params.pageSize = pageSize;
                PesquisaAvaliacaoResource.pesquisaAvaliacaoOperador(params).$promise
                    .then(response => {
                        $scope.pesquisaBilheteOperadoList = response.Data;
                        $scope.pesquisaBilheteOperadoList.recordCount = response.RecordCount;
                        $scope.pesquisaBilheteOperadoList.currentPage = response.PageIndex || 1;
                        $scope.pesquisaBilheteOperadoList.pageSize = response.PageSize || 10;
                        $scope.searching = false;
                        getCountOperador(params);
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.exportar = function (search, format) {
                if (!$scope.forms.formBilhete.$valid) {
                    return;
                }

                ModalService.showLoading();

                var filtro = {
                    BilheteStatusId: search.Ativo,
                    BilheteStatusDetalheId: search.BilheteStatusDetalheId,
                    GrupoId: search.GrupoId,
                    PesquisaId: search.pesquisaId,
                    RotaId: search.RotaId,
                    NA: search.NA,
                    DirecaoId: search.BilheteDirecaoId,
                    UsuarioId: search.UsuarioId,
                    DataI: search.DataInicio,
                    DataF: search.DataFim,
                    GlobalId: search.GlobalId,
                    Duracao: search.DuracaoMaiorQue,
                    Direcao: search.DirecaoId,
                    NB: search.NB,
                    BilheteCenarioId: search.BilheteCenarioId,
                    CausaCodigo: search.CausaCodigo,
                    CampanhaId: (search.CampanhaId == null || search.CampanhaId == 0) ? [] : search.CampanhaId.join(),
                    DiscagemTipoId: search.DiscagemTipoId,
                    CodigoCliente: search.CodigoCliente,
                    OrderBy: "Titulo desc",
                    Status: search.Ativo,
                    DesconexaoId: search.DesconexaoId,
                    Avaliadas: search.Avaliadas
                };

                PesquisaAvaliacaoResource.Exportar(filtro).$promise.then((data) => {

                    const blob = new Blob([data.file], { type: 'application/' + format });
                    const blobUrl = URL.createObjectURL(blob);

                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', blobUrl);
                    downloadLink.attr('download', 'Pesquisa Avaliação.' + format);
                    downloadLink[0].click();

                    //window.location = blobUrl;
                    ModalService.hideLoading();

                }).catch((e) => {
                    NotifyService.showError
                    ModalService.hideLoading();
                });
            }

            $scope.exportarOperador = function (searchOperador, format) {
                if (!$scope.forms.formAvaliacaoOperador.$valid) {
                    return;
                }

                ModalService.showLoading();

                var filtro = {                    
                    GrupoId: searchOperador.GrupoId,
                    PesquisaId: searchOperador.pesquisaId,
                    UsuarioId: searchOperador.UsuarioId,
                    DataI: searchOperador.DataInicio,
                    DataF: searchOperador.DataFim,
                    CarteiraId : searchOperador.CarteiraId,                    
                    Score : searchOperador.ScoreMaiorQue,         
                    AvaliadorId : searchOperador.AvaliadorId,      
                    OrderBy: "Titulo desc",                    
                };

                PesquisaAvaliacaoResource.ExportarOperadores(filtro).$promise.then((data) => {

                    const blob = new Blob([data.file], { type: 'application/' + format });
                    const blobUrl = URL.createObjectURL(blob);

                    var downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', blobUrl);
                    downloadLink.attr('download', 'Pesquisa Avaliação.' + format);
                    downloadLink[0].click();

                    //window.location = blobUrl;
                    ModalService.hideLoading();

                }).catch((e) => {
                    NotifyService.showError
                    ModalService.hideLoading();
                });
            }

            function getCount(params) {
                PesquisaAvaliacaoResource.pesquisaAvaliacaoCount(params).$promise
                    .then(count => {
                        $scope.pesquisaCount = count.Quantidade
                    })
                    .catch(() => { $scope.pesquisaCount = 0 })
                    .finally(() => { $scope.searchingCount = false });
            }

            function getCountOperador(params) {
                PesquisaAvaliacaoResource.pesquisaAvaliacaoOperadorCount(params).$promise
                    .then(count => {
                        $scope.pesquisaOperadorCount = count.Quantidade
                    })
                    .catch(() => { $scope.pesquisaOperadorCount = 0 })
                    .finally(() => { $scope.searchingCount = false });
            }

            $scope.$on('$destroy', function () {
                PesquisaAvaliacaoResource.deletePesquisaAvaliacao();
            });

            $scope.onChangeCarteira = function()
            {
                if($scope.search.CarteiraId != undefined)
                {
                    $scope.grupoList = _.filter($scope.grupoListAtivo, function (item) {
                        return item.CarteiraId == $scope.search.CarteiraId;
                    });
                }                
            };

            $scope.verificarChecked = function (perguntaId, alternativa) {
                if(alternativa != undefined)
                {
                    if(alternativa.Selecionada && alternativa.RespostaRadio)
                        var elemento = angular.element($('#radio_demo_inline_'+ perguntaId + "_" + alternativa.AlternativaId)).prop("checked",true);
                    else
                        angular.element($('#radio_demo_inline_'+ perguntaId + "_" + alternativa.AlternativaId)).prop("checked",false);
                }
            };
        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.pesquisaCategoria.edit", StateResolverProvider.configState("/pesquisaCategoria/{Id:[0-9]+}", "PesquisaCategoria", "Edit", {
                    pageTitle: 'pageTitle.pesquisaCategoria',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.pesquisaCategoria.new", StateResolverProvider.configState("/pesquisaCategoria/new", "PesquisaCategoria", "Edit", {
                    pageTitle: 'pageTitle.pesquisaCategoria',
                    pageName: 'acoes.cadastrar',
                    css: true
                }));
        }])

        .service("PesquisaCategoriaEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_angularTree'
                        ]);
                    }],
                    pesquisaCategoria: ["PesquisaCategoriaResource", "$stateParams", function (PesquisaCategoriaResource, $stateParams) {
                        if ($stateParams.Id) {
                            return PesquisaCategoriaResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return { Itens: [] };
                        }
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                };
            };
        })

        .controller("PesquisaCategoriaEditController", ["$filter", "$scope", "Config", "$http", "$stateParams", "$state", "$translate", "NotifyService", "ModalService", "PesquisaCategoriaResource", "pesquisaCategoria", "carteiras", function ($filter, $scope, Config, $http, $stateParams, $state, $translate, NotifyService, ModalService, PesquisaCategoriaResource, pesquisaCategoria, carteiras) {

            pesquisaCategoria.Id = (pesquisaCategoria.Id > 0 ? pesquisaCategoria.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.isNew = (pesquisaCategoria.Id > 0 ? false : true);
            $scope.pesquisaCategoria = pesquisaCategoria;  
            $scope.carteiras = carteiras;          
            $scope.forms = {};
            $scope.proximoStep = false;

            $scope.salvar = function salvar(form) {
                let lastStep = form.$name == "forms.formPesquisaCategoriaItens" ? true : false;
                if (form.$dirty) {
                    if ($scope.pesquisaCategoria.Id > 0) {
                        putItem();
                        NotifyService.showRegistroSalvo();
                    } else {
                        $http.post(Config.getUrl("PesquisaCategoria"), $scope.pesquisaCategoria).then(function (response) {
                            NotifyService.showRegistroSalvo();
                            $scope.pesquisaCategoria = response.data;
                        }).catch(NotifyService.showError);
                    }
                }

                if ((($scope.isNew && lastStep) || lastStep) && !form.$dirty)
                    $state.go("main.pesquisaCategoria.list", {
                        page: 'main.pesquisaCategoria.list'
                    });

                form.$setPristine();
                $scope.reordenarItem();

            };

            $scope.reverse = false;
            $scope.ordenarDescricao = function () {
                $scope.reverse = !$scope.reverse;
                $scope.reordenarItem();

            };

            $scope.reordenarItem = function () {
                let lista = $filter('orderBy')($scope.pesquisaCategoria.Itens, 'Descricao', $scope.reverse);
                $scope.pesquisaCategoria.Itens = lista;
            }

            $scope.adicionarItem = function () {
                $scope.pesquisaCategoria.Itens.push({ Ativo: true, Descricao: 'Texto Padrão', StatusId: 1 });
                putItem();
            };

            $scope.inativarItem = function (item) {
                ModalService.confirmMessage('telaEditPesquisaCategoria.confirmDeleteItem', null, () => confirmarInativarItem(item));
            };

            function confirmarInativarItem(item) {
                $scope.forms.formPesquisaCategoriaItens.$dirty = true;
                
                $scope.pesquisaCategoria.Itens.forEach(function (value, index) {
                    if (value.Id == item.Id) {
                        $scope.pesquisaCategoria.Itens[index].Ativo = false;
                        item.Ativo = false;
                    }
                });

                putItem();
            }

            $scope.validatePesquisaCategoria = function () {
                $scope.proximoStep = $scope.forms.formPesquisaCategoria.$valid ? true : false;
                return $scope.proximoStep;
            };

            $scope.salvarPesquisaCategoria = function (data) {
                var promise;
                if ($scope.pesquisaCategoria.Id > 0) {
                    promise = PesquisaCategoriaResource.update(data.Id, data).$promise;
                }
                else {
                    promise = PesquisaCategoriaResource.save(data).$promise;
                }

                promise.then(() => {
                    let message = $scope.isNew ? 'telaEditPesquisaCategoria.categoriaAdicionadoComSucesso' : 'telaEditPesquisaCategoria.categoriaAlteradoComSucesso';

                    NotifyService.showSuccess($translate.instant(message));
                    $state.go('main.pesquisaCategoria.list');
                })
                .catch(NotifyService.showError);
            };

            $scope.AdicionarItensCategoria = function (e) {
                $scope.forms.formPesquisaCategoriaItens.$dirty = true;
                $scope.pesquisaCategoria.Itens.push({ Id: 0, Ativo: true, Descricao: 'Texto Padrão', ParentId: e.Id });
                putItem();
            }

            $scope.onBlurText = function (item) {
                $scope.forms.formPesquisaCategoriaItens.$dirty = true;

                $scope.pesquisaCategoria.Itens.forEach(function (value, index) {
                    if (value.Id == item.Id) {
                        $scope.pesquisaCategoria.Itens[index].Descricao = item.title;
                    }
                }); 
            };

            function putItem() {
                $http.put(Config.getUrl("PesquisaCategoria") + '/' + $scope.pesquisaCategoria.Id, $scope.pesquisaCategoria)
                    .then(function (response) {
                        let pesquisaCategoria = response.data;
                        
                        $scope.pesquisaCategoria = pesquisaCategoria;
                        $("#tabTipo").removeClass("uk-active");
                        $("#tabCategorias").removeClass("uk-uk-disabled");
                        $("#tabCategorias").addClass("uk-active");
                        $("#tabConteudoTipo").removeClass("uk-active");
                        $("#tabConteudoCategorias").addClass("uk-active");

                        Gerar();
                    })
                    .catch(NotifyService.showError);
            }


            function Gerar() {
                $scope.list = [];
                $scope.pesquisaCategoria.Itens.forEach(function (values) {

                    if (!values.ParentId) {

                        let obj = {
                            "Id": values.Id,
                            "title": values.Descricao,
                            'StatusChecked': values.StatusChecked,
                            'StatusId': values.StatusId,
                            'Ativo': values.Ativo,
                            "nodes": []
                        }

                        GerarFilhos(values.Id, obj);
                        $scope.list.push(obj);
                    }
                });
            }

            function GerarFilhos(id, obj) {
                $scope.pesquisaCategoria.Itens.forEach(function (values) {

                    if (values.ParentId == id) {

                        let filhos = $scope.pesquisaCategoria.Itens.filter(x => x.ParentId == values.Id).length;

                        if (filhos > 0) {

                            let objFilho = {
                                "Id": values.Id,
                                "title": values.Descricao,
                                'StatusChecked': values.StatusChecked,
                                'StatusId': values.StatusId,
                                'Ativo': values.Ativo,
                                "nodes": []
                            }

                            GerarFilhos(values.Id, objFilho);
                            obj.nodes.push(objFilho);
                        }
                        else {
                            obj.nodes.push({
                                "Id": values.Id,
                                "title": values.Descricao,
                                'data': values,
                                'StatusChecked': values.StatusChecked,
                                'StatusId': values.StatusId,
                                'Ativo': values.Ativo,
                                "nodes": []
                            });
                        }
                    }
                });

            }

            Gerar();
        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (PesquisaCategoriaResource, search, orderBy, $odata) {
        var odata = PesquisaCategoriaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }

        if (search.CarteiraId) {
            odata.filter('CarteiraId', search.CarteiraId);
        }

        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.pesquisaCategoria", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.pesquisaCategoria.list',
                    pageTitle: 'pageTitle.cardTitle',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.pesquisaCategoria.list", StateResolverProvider.configState("/pesquisaCategoria", "PesquisaCategoria", "List", {
                pageTitle: 'pageTitle.pesquisaCategoria',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("PesquisaCategoriaListData", function PesquisaCategoriaListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                pesquisaCategoriaList: ["PesquisaCategoriaResource", "LocalStorageService", "$odata", "$stateParams", function (PesquisaCategoriaResource, LocalStorageService, $odata, $stateParams) {
                     var filtro = {};

                     if ($stateParams.storage) {
                         filtro = LocalStorageService.getItem("FiltroPesquisaCategoria");
                     }

                     var orderBy = {
                         column: "Descricao",
                         order: "asc"
                     };

                     return getOdataSearchShared(PesquisaCategoriaResource, filtro, orderBy, $odata).page(10, 1).query();
                }],
                carteiras: ["CarteiraResource", function (CarteiraResource) {
                    return CarteiraResource.query().$promise;
                }],
            }
        }
    })

    .controller("PesquisaCategoriaListController", ["$scope", "$odata", "PesquisaCategoriaResource", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "pesquisaCategoriaList", "carteiras", function ($scope, $odata, PesquisaCategoriaResource, LocalStorageService, $stateParams, NotifyService, ModalService, pesquisaCategoriaList, carteiras) {
            $scope.pesquisaCategoriaList = pesquisaCategoriaList;
            $scope.carteiras = carteiras; 
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPesquisaCategoria") : {
                Descricao: '',
                CarteiraId: 0
            };

            $scope.orderBy = {
                column: "Id",
                order: "desc"
            };

            $scope.errorObject = {};

            var updateList = function (list) {
                $scope.pesquisaCategoriaList = list;
                $scope.pesquisaCategoriaList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.pesquisaCategoriaList.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(PesquisaCategoriaResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.pesquisaCategoriaList.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroPesquisaCategoria', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroPesquisaCategoria');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deletePesquisaCategoria = function (data) {
                return PesquisaCategoriaResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmMessage('telaPesquisaCategoria.confirmDeletePesquisaCategoria', null, () => deletePesquisaCategoria(data));
            };

            $scope.exibirErro = function (data){
                $scope.errorObject = data.ErrorObject;
                ModalService.openModal('modalErrorMessage');
            }


        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("PesquisaCategoriaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("PesquisaCategoria/:Id", { "Id": "@Id" },
                {
                    GetPesquisaCategoria: {
                        url: "PesquisaCategoria/GetPesquisaCategoria",
                        method: "GET",
                        isArray: true
                    },
                    GetPesquisaCategoriaItemByPesquisaId: {
                        url: "PesquisaCategoria/GetPesquisaCategoriaItemByPesquisaId",
                        method: "GET",
                        params: {
                            "pesquisaId": "@pesquisaId"
                        },
                        isArray: true
                    },
                    GetPesquisaCategoriaItemByCategoriaId: {
                        url: "PesquisaCategoria/GetPesquisaCategoriaItemByCategoriaId",
                        method: "GET",
                        params: {
                            "categoriaId": "@categoriaId"
                        },
                        isArray: true
                    }
                });
        }]);
})();

(function() {
	"use strict";
	angular.module("epbxManagerApp")

	.config(["$stateProvider", "StateResolverProvider", function($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.planos.edit", StateResolverProvider.configState("/planos/{PlanoId:[0-9]+}", "Plano", "Edit", {
					pageTitle: 'pageTitle.configuracaoDoPlano',
					pageName: 'Editar Plano'
				}));
		}])
		.service('PlanoEditData', function PlanoEditData() {
			return function() {
				return {
					deps: ["$ocLazyLoad", function($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_wizard',
							'lazy_uiSelect'
						]);
					}],
					plano: ["PlanoResource", "$stateParams", function(PlanoResource, $stateParams) {
						if ($stateParams.PlanoId) {
							return PlanoResource.get({
								PlanoId: $stateParams.PlanoId
							}).$promise;
						} else {
							return {};
						}
					}],
					classes: ["RotaResource", function(RotaResource) {
						return RotaResource.getClasses().$promise;
					}],
					operadoras: ["RotaResource", function(RotaResource) {
						return RotaResource.getOperadoras().$promise;
					}],
					localidades: ["RotaResource", function(RotaResource) {
						return RotaResource.getLocalidades().$promise;
					}]
				}
			}
		})
		.controller("PlanoEditController",
			["$scope", "$window", "plano", "classes", "operadoras", "localidades", "PlanoResource", "NotifyService", function($scope, $window, plano, classes, operadoras, localidades, PlanoResource, NotifyService) {

				var modal;

				$scope.inserirOuEditar = plano && plano.PlanoId ? "Editando plano" : "Cadastrando plano";
				$scope.isEdit = plano && plano.PlanoId ? true : false;
				$scope.isNew = !plano.PlanoId ? true : false;
				$scope.plano = plano;
				$scope.classes = classes;
				$scope.operadoras = operadoras;
				$scope.localidades = localidades;

				$scope.classeConfig = {
					maxItems: 1,
					valueField: 'ClasseId',
					labelField: 'Descricao',
					placeholder: '--'
				};

				$scope.operadoraConfig = {
					maxItems: 1,
					valueField: 'OperadoraId',
					labelField: 'Nome',
					placeholder: '--'
				};

				$scope.localidadeConfig = {
					maxItems: 1,
					valueField: 'DDD',
					labelField: 'DDD',
					placeholder: '--'
				};

				var mensagemSucesso = function(response) {
					modal.hide();
					$scope.rota = response;
					NotifyService.showRegistroSalvo();
				};

				var mensagemErro = function(error) {
					modal.hide();
					NotifyService.showError(error)
				}

				$scope.salvar = function finish() {
					modal = UIkit.modal.blockUI('<div class=\'uk-text-center\'>Aguarde...<br/><img class=\'uk-margin-top\' src=\'assets/img/spinners/spinner.gif\' alt=\'\'>');
					var promise;
					if ($scope.plano.PlanoId > 0) {
						promise = PlanoResource.update($scope.plano).$promise;
					} else {
						promise = PlanoResource.save($scope.plano).$promise;
					}
					promise.then(mensagemSucesso).catch(mensagemErro);
				};

				$scope.closeModal = function() {

					var modal = UIkit.modal("#modalPlanoTarifa");
					modal.hide();
				};

				$scope.planoTarifa = {
					PlanoTarifaId: 0,
					ClasseId: 0,
					DDD: 0,
					OperadoraId: 0,
					Tempo: 30,
					Fracao: 6,
					TempoMinimo: 3
				};

				$scope.adicionar = function() {
					if (!$scope.planoTarifa.ClasseId) {
						NotifyService.showError(null, "Preencha o campo (Classe) corretamente");
						return;
					}

					if (!$scope.planoTarifa.OperadoraId || !$scope.planoTarifa.DDD) {
						NotifyService.showError(null, "Preencha os campos (Operadora e DDD) corretamente");
						return;
					}

					$scope.plano.PlanoTarifa.push($scope.planoTarifa);
					$scope.planoTarifa = {
						PlanoTarifaId: 0,
						ClasseId: 0,
						DDD: 0,
						OperadoraId: 0,
						Tempo: 30,
						Fracao: 6,
						TempoMinimo: 3
					};
					$scope.closeModal();
				};

				$scope.delete = function(data) {
					$window.UIkit.modal.confirm("Deseja realmente excluir?", function() {
						$scope.plano.PlanoTarifa.splice($scope.plano.PlanoTarifa.indexOf(data), 1);
					});
				};

				$scope.onBlurNome = function() {

					if ($scope.plano.Descricao == '' || $scope.plano.Descricao == undefined)
						$scope.plano.Descricao = $scope.plano.Nome;
				};

				$scope.permiteAlteracao = function(p) {
					if (!p.OperadoraId && !p.DDD)
						return false;
					else
						return true;
				};
			}]
		);

})();

(function () {
	"use strict";

	var getOdataSearchShared = function (PlanoResource, search, orderBy, $odata) {
		var odata = PlanoResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.Nome) {
			odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
		}

		return odata;
	}

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.planos", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.planos.list',
						pageTitle: 'pageTitle.gerenciamentoDeRotas',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.planos.list", StateResolverProvider.configState("/planos", "Plano", "List", {
					pageTitle: 'pageTitle.gerenciamentoDePlanos',
					pageName: 'pageTitle.pesquisar'
				}));
		}])
		.service("PlanoListData", function PlanoListData() {
			return function () {
				return {
					planos: ["PlanoResource", "$odata", function (PlanoResource, $odata) {
						var filtro = {};

						var orderBy = {
							column: "Nome",
							order: "asc"
						}
						var odata = getOdataSearchShared(PlanoResource, filtro, orderBy, $odata);
						return odata.page(10, 1).query();
					}]
				}
			}
		})
		.controller("PlanoListController",
			["$scope", "$window", "$odata", "PlanoResource", "LocalStorageService", "$stateParams", "planos", "$state", "NotifyService", function ($scope, $window, $odata, PlanoResource, LocalStorageService, $stateParams, planos, $state, NotifyService) {
				$scope.planos = planos;
				$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPlano") : {};
				$scope.orderBy = {
					column: "Nome",
					order: "asc"
				};

				var updateList = function (list) {
					$scope.planos = list;
					$scope.planos.recordCount = list.$recordCount || list.length;
					$scope.currentPage = list.$currentPage || 1;
					$scope.planos.pageSize = list.$pageSize || 10;
				};

				var getOdataSearch = function getOdataSearch() {
					return getOdataSearchShared(PlanoResource, $scope.search, $scope.orderBy, $odata);
				};

				$scope.executeSearch = function executeSearch() {
					LocalStorageService.setItem('FiltroRota', $scope.search);

					$scope.searching = true;
					getOdataSearch()
						.page($scope.search.pageSize, 1)
						.query().then(updateList).catch(NotifyService.showError);
				};

				var deleteRecord = function (data) {
					return PlanoResource.delete({
						RotaId: data.RotaId
					}).$promise
						.then(function () {
							NotifyService.showSuccess();
							$scope.pageChanged($scope.currentPage)
						})
						.catch(NotifyService.showError);
				};

				$scope.confirmDelete = function confirmDelete(data) {
					$window.UIkit.modal.confirm("Deseja realmente excluir? Esta alteração não poderá ser desfeita.", function () {
						deleteRecord(data);
					});
				};

				$scope.pageChanged = function (newPage) {
					return getOdataSearch()
						.page($scope.planos.pageSize, newPage)
						.query().then(updateList).catch(NotifyService.showError);
				};

				updateList(planos);

				$scope.limparFiltro = function () {
					LocalStorageService.removeItem('FiltroRota');
					$scope.search = { pageSize: 10 };
				};

				$scope.voltar = function () {
					if ($stateParams.page)
						$state.go($stateParams.page, { storage: true });
					else
						$state.go('main.planos.list', { storage: true });
				};
			}]
		);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
      .factory("PlanoResource", ["$odataresource", function ($odataresource) {
          return $odataresource("Plano/:PlanoId", { "PlanoId": "@PlanoId" });
      }]);

})();


(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.prioridadeatendimento", StateResolverProvider.configAbstract(null, null, {
                    proxy: 'main.prioridadeatendimento.edit',
                    pageTitle: 'pageTitle.filaDeAtendimento',
                    pageName: 'pageTitle.filaDeAtendimento'
                }))
                .state("main.prioridadeatendimento.edit", StateResolverProvider.configState("/prioridadeatendimento", "PrioridadeAtendimento", "Edit", {
                    pageTitle: 'pageTitle.filaDeAtendimento',
                    pageName: 'acoes.editar',
                    startPage: true
                }));
        }])

        .service("PrioridadeAtendimentoEditData", function PrioridadeatendimentoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    prioridadeAtendimento: ["PrioridadeAtendimentoResource", function (PrioridadeAtendimentoResource) {
                        return PrioridadeAtendimentoResource.get().$promise;
                    }],
                    localidades: ["PrioridadeAtendimentoResource", function (PrioridadeAtendimentoResource) {
                        return PrioridadeAtendimentoResource.getLocalidades().$promise;
                    }],
                }
            }
        })

        .controller("PrioridadeAtendimentoEditController", ["$scope", "PrioridadeAtendimentoResource", "localidades", "ModalService", "prioridadeAtendimento", "WizardHandler", "$location", "NotifyService", "$translate", function PrioridadeAtendimentoEditController($scope, PrioridadeAtendimentoResource, localidades, ModalService,
         prioridadeAtendimento, WizardHandler, $location, NotifyService, $translate) {
                if (prioridadeAtendimento.PrioridadeAtendimentoId != null) {
                    $scope.prioridadeAtendimento = prioridadeAtendimento;
                }
                else {
                    $scope.prioridadeAtendimento = {
                        PrioridadeAtendimentoNormal: [],
                        PrioridadeAtendimentoAlta: [],
                        PrioridadeAtendimentoMaxima: []
                    }
                }
                $scope.isNew = $scope.prioridadeAtendimento.PrioridadeAtendimentoId > 0 ? false : true;
                $scope.isSetup = $location.search().setup;
                $scope.forms = {};
                $scope.validateConfiguracao = true;
                $scope.localidades = _.sortBy(localidades, function (el) { return el.DDD });
                $scope.PrioridadeCelularList = [
                    { Id: 0, Alias: $translate.instant('telaFilaAtendimento.baixa') },
                    { Id: 1, Alias: $translate.instant('telaFilaAtendimento.media') },
                    { Id: 2, Alias: $translate.instant('telaFilaAtendimento.alta') },
                    { Id: 3, Alias: $translate.instant('telaFilaAtendimento.maxima') }
                ];

                var mensagemSucesso = function () {
                    NotifyService.showRegistroSalvo();
                    if ($scope.novo) {
                        $scope.ramalStatusEdit = {};
                    }
                    $scope.submitted = false;
                }

                $scope.validateConfiguracao = function () {
                    var proximoStep = false;
                    if ($scope.isNew) {
                        if ($scope.forms.formConfiguracoes.$valid) {
                            salvarPrioridadeAtendimento().then(function (data) {
                                angular.copy(data, $scope.prioridadeAtendimento);
                            }).catch(NotifyService.showError);
                            proximoStep = true;
                        } else {
                            proximoStep = false;
                        }
                    } else {
                        if ($scope.forms.formConfiguracoes.$dirty) {
                            ModalService.confirmDescartar(function () {
                                $scope.forms.formConfiguracoes.$dirty = false;
                                $scope.forms.formConfiguracoes.$setPristine();
                            });
                        } else {
                            if ($scope.forms.formConfiguracoes.$valid) {
                                proximoStep = true;
                            }
                        }
                    }
                    return proximoStep;
                };

                $scope.validateNormal = function () {
                    return !$scope.forms.formNormal.$dirty;
                };

                $scope.validateAlta = function () {
                    return !$scope.forms.formAlta.$dirty;
                };

                $scope.validateMaxima = function () {
                    return !$scope.forms.formMaxima.$dirty;
                };

                $scope.salvar = function (form) {
                    if (!form.$dirty) {
                        WizardHandler.wizard().next();
                    }
                    else {
                        if (!form.$valid) {
                            NotifyService.showInvalid();
                            return;
                        }

                        if (form.$name == "forms.formConfiguracoes") {
                            $scope.submitted = true;
                            salvarPrioridadeAtendimento();
                            form.$setPristine();
                        } else if (form.$name == "forms.formNormal") {
                            $scope.submitted = true;
                            PrioridadeAtendimentoResource.setPrioridadeNormal($scope.prioridadeAtendimento.PrioridadeAtendimentoNormal).$promise
                                .then(function () {
                                    salvarPrioridadeAtendimento();
                                    mensagemSucesso();
                                })
                                .catch(NotifyService.showError);                           
                            form.$setPristine();
                        } else if (form.$name == "forms.formAlta") {
                            $scope.submitted = true;
                            PrioridadeAtendimentoResource.setPrioridadeAlta($scope.prioridadeAtendimento.PrioridadeAtendimentoAlta).$promise
                                .then(function () {
                                    salvarPrioridadeAtendimento();
                                    mensagemSucesso();
                                })
                                .catch(NotifyService.showError);                            
                            form.$setPristine();
                        } else if (form.$name == "forms.formMaxima") {
                            $scope.submitted = true;
                            PrioridadeAtendimentoResource.setPrioridadeMaxima($scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima).$promise
                                .then(function () {
                                    salvarPrioridadeAtendimento();
                                    mensagemSucesso();
                                })
                                .catch(NotifyService.showError);                           
                            form.$setPristine();

                            
                        }
                    }
                }

                var salvarPrioridadeAtendimento = function () {
                    if ($scope.prioridadeAtendimento.PrioridadeAtendimentoId > 0) {
                        return PrioridadeAtendimentoResource.update($scope.prioridadeAtendimento).$promise
                        .then(function (data) {
                            angular.copy(data, $scope.prioridadeAtendimento);
                            mensagemSucesso();
                        })
                        .catch(NotifyService.showError);
                    }
                    else {
                        return PrioridadeAtendimentoResource.save($scope.prioridadeAtendimento).$promise
                        .then(function (data) {
                            angular.copy(data, $scope.prioridadeAtendimento);
                            mensagemSucesso();
                        })
                        .catch(NotifyService.showError);
                    }
                }

                $scope.$on('wizard:stepChanged', function (event, args) {
                    var list = $scope.prioridadeAtendimento.PrioridadeAtendimentoAlta.concat($scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima);
                    list = list.concat($scope.prioridadeAtendimento.PrioridadeAtendimentoNormal);

                    list = _.filter($scope.localidades, function (el1) {
                        return _.find(list, function (el2) { return el2.Ddd == el1.DDD }) == null;
                    });
                    list = _.map(list, function (el) {
                        return { Ddd: el.DDD, DescricaoLocalidade: el.Descricao };
                    });
                    if (args.index == 1) {
                        $scope.localidadesNormalList = list;

                        var listNormal = _.filter($scope.localidades, function (el1) {
                            return _.find($scope.prioridadeAtendimento.PrioridadeAtendimentoNormal, function (el2) { return el2.Ddd == el1.DDD });
                        });
                        $scope.prioridadeAtendimento.PrioridadeAtendimentoNormal = _.map(listNormal, function (el) {
                            return { Ddd: el.DDD, DescricaoLocalidade: el.Descricao };
                        });
                    } else if (args.index == 2) {
                        $scope.localidadesAltaList = list;

                        var listAlta = _.filter($scope.localidades, function (el1) {
                            return _.find($scope.prioridadeAtendimento.PrioridadeAtendimentoAlta, function (el2) { return el2.Ddd == el1.DDD });
                        });
                        $scope.prioridadeAtendimento.PrioridadeAtendimentoAlta = _.map(listAlta, function (el) {
                            return { Ddd: el.DDD, DescricaoLocalidade: el.Descricao };
                        });
                    } else if (args.index == 3) {
                        $scope.localidadesMaximaList = list;

                        var listMaxima = _.filter($scope.localidades, function (el1) {
                            return _.find($scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima, function (el2) { return el2.Ddd == el1.DDD });
                        });
                        $scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima = _.map(listMaxima, function (el) {
                            return { Ddd: el.DDD, DescricaoLocalidade: el.Descricao };
                        });
                    }
                });

                /**************************************
                    PRIORIDADE NORMAL
                **************************************/
                $scope.localidadesNormalList = [];
                $scope.limitLocalidadesNormal = 5;
                $scope.limitlocalidadesNormalAdicionadas = 5;

                // Localidades Associadas
                $scope.adicionarLocalidadeNormal = function () {
                    var localidadesSelecionadas = _.where($scope.localidadesNormalList, { Selecionado: true });
                    if (localidadesSelecionadas.length > 0) {
                        angular.forEach(localidadesSelecionadas, function (value) {
                            value.Selecionado = false;
                            value.Adicionado = true;
                            if (value.Removido && value.Alterado) {
                                value.Removido = false;
                                value.Alterado = false;
                            } else {
                                value.Alterado = true;
                            }

                            $scope.prioridadeAtendimento.PrioridadeAtendimentoNormal.push(value);
                            $scope.localidadesNormalList.splice($scope.localidadesNormalList.indexOf(value), 1);
                        });

                    } else {
                        NotifyService.showError(null, 'telaFilaAtendimento.selecioneUmaLocalidadeASerAdicionada');
                    }
                };

                $scope.removerLocalidadeNormal = function () {
                    var localidadesSelecionadas = _.where($scope.prioridadeAtendimento.PrioridadeAtendimentoNormal, {
                        Selecionado: true
                    });
                    if (localidadesSelecionadas.length > 0) {
                        angular.forEach(localidadesSelecionadas, function (value) {
                            value.Selecionado = false;
                            value.Removido = true;

                            if (value.Adicionado && value.Alterado) {
                                value.Adicionado = false;
                                value.Alterado = false;
                            } else value.Alterado = true;

                            $scope.localidadesNormalList.push(value);
                            $scope.prioridadeAtendimento.PrioridadeAtendimentoNormal.splice($scope.prioridadeAtendimento.PrioridadeAtendimentoNormal.indexOf(value), 1);
                        });

                    } else {
                        NotifyService.showError(null, 'telaFilaAtendimento.selecioneUmaLocalidadeASerRemovida');
                    }
                };

                $scope.selecionarTodosNormalAdicionadas = function (itensAdicionadas) {
                    angular.forEach($scope.prioridadeAtendimento.PrioridadeAtendimentoNormal, function (item) {
                        if (itensAdicionadas) {
                            item.Selecionado = true;
                        } else {
                            item.Selecionado = false;
                        }
                    });
                };

                $scope.selecionarTodosNormalNaoAdicionadas = function (itensNaoAdicionadas) {
                    angular.forEach($scope.localidadesNormalList, function (item) {
                        if (itensNaoAdicionadas) {
                            item.Selecionado = true;
                        } else {
                            item.Selecionado = false;
                        }
                    });
                };

                $scope.maisLocalidadesNormalAdicionadas = function () {
                    if ($scope.limitlocalidadesNormalAdicionadas < $scope.prioridadeAtendimento.PrioridadeAtendimentoNormal.length) {
                        $scope.limitlocalidadesNormalAdicionadas += 5;
                        $("#prioridadeAtendimento.PrioridadeAtendimentoNormal").animate({
                            scrollTop: $("#tabLocalidadesNormalAdicionadas").height()
                        }, 800);
                    }
                };

                $scope.maisLocalidadesNormalNaoAdicionadas = function () {
                    if ($scope.limitLocalidadesNormal < $scope.localidadesNormalList.length) {
                        $scope.limitLocalidadesNormal += 5;
                        $("#localidadesNormalNaoAdicionadas").animate({
                            scrollTop: $("#tablocalidadesNormalNaoAdicionadas").height()
                        }, 800);
                    }
                };

                $("#prioridadeAtendimento.PrioridadeAtendimentoNormal").bind("DOMMouseScroll mousewheel", function (e) {
                    if ($scope.limitlocalidadesNormalAdicionadas < $scope.prioridadeAtendimento.PrioridadeAtendimentoNormal.length) {
                        $scope.$apply(function () {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope.limitlocalidadesNormalAdicionadas += 5;
                                $("#prioridadeAtendimento.PrioridadeAtendimentoNormal").animate({
                                    scrollTop: $("#tabLocalidadesNormalAdicionadas").height()
                                }, 800);
                            }
                        });
                    }
                });

                $("#localidadesNormalNaoAdicionadas").bind("DOMMouseScroll mousewheel", function (e) {
                    if ($scope.limitLocalidadesNormal < $scope.localidadesNormalList.length) {
                        $scope.$apply(function () {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope.limitLocalidadesNormal += 5;
                                $("#localidadesNormalNaoAdicionadas").animate({
                                    scrollTop: $("#tablocalidadesNormalNaoAdicionadas").height()
                                }, 800);
                            }
                        });
                    }
                });

                /**************************************
                    PRIORIDADE ALTA
                **************************************/
                $scope.localidadesAltaList = [];
                $scope.limitLocalidadesAlta = 5;
                $scope.limitlocalidadesAltaAdicionadas = 5;

                $scope.adicionarLocalidadeAlta = function () {
                    var localidadesSelecionadas = _.where($scope.localidadesAltaList, { Selecionado: true });
                    if (localidadesSelecionadas.length > 0) {
                        angular.forEach(localidadesSelecionadas, function (value) {
                            value.Selecionado = false;
                            value.Adicionado = true;
                            if (value.Removido && value.Alterado) {
                                value.Removido = false;
                                value.Alterado = false;
                            } else value.Alterado = true;

                            $scope.prioridadeAtendimento.PrioridadeAtendimentoAlta.push(value);
                            $scope.localidadesAltaList.splice($scope.localidadesAltaList.indexOf(value), 1);
                        });

                    } else {
                        NotifyService.showError(null, 'telaFilaAtendimento.selecioneUmaLocalidadeASerAdicionada')
                    }
                };

                $scope.removerLocalidadeAlta = function () {
                    var localidadesSelecionadas = _.where($scope.prioridadeAtendimento.PrioridadeAtendimentoAlta, {
                        Selecionado: true
                    });
                    if (localidadesSelecionadas.length > 0) {
                        angular.forEach(localidadesSelecionadas, function (value) {
                            value.Selecionado = false;
                            value.Removido = true;

                            if (value.Adicionado && value.Alterado) {
                                value.Adicionado = false;
                                value.Alterado = false;
                            } else value.Alterado = true;

                            $scope.localidadesAltaList.push(value);
                            $scope.prioridadeAtendimento.PrioridadeAtendimentoAlta.splice($scope.prioridadeAtendimento.PrioridadeAtendimentoAlta.indexOf(value), 1);
                        });

                    } else {
                        NotifyService.showError(null, 'telaFilaAtendimento.selecioneUmaLocalidadeASerRemovida')
                    }
                };

                $scope.selecionarTodosAltaAdicionadas = function (itensAdicionadas) {
                    angular.forEach($scope.prioridadeAtendimento.PrioridadeAtendimentoAlta, function (item) {
                        if (itensAdicionadas) {
                            item.Selecionado = true;
                        } else {
                            item.Selecionado = false;
                        }
                    });
                };

                $scope.selecionarTodosAltaNaoAdicionadas = function (itensNaoAdicionadas) {
                    angular.forEach($scope.localidadesAltaList, function (item) {
                        if (itensNaoAdicionadas) {
                            item.Selecionado = true;
                        } else {
                            item.Selecionado = false;
                        }
                    });
                };

                $scope.maisLocalidadesAltaAdicionadas = function () {
                    if ($scope.limitlocalidadesAltaAdicionadas < $scope.prioridadeAtendimento.PrioridadeAtendimentoAlta.length) {
                        $scope.limitlocalidadesAltaAdicionadas += 5;
                        $("#prioridadeAtendimento.PrioridadeAtendimentoAlta").animate({
                            scrollTop: $("#tabLocalidadesAltaAdicionadas").height()
                        }, 800);
                    }
                };

                $scope.maisLocalidadesAltaNaoAdicionadas = function () {
                    if ($scope.limitLocalidadesAlta < $scope.localidadesAltaList.length) {
                        $scope.limitLocalidadesAlta += 5;
                        $("#localidadesAltaNaoAdicionadas").animate({
                            scrollTop: $("#tablocalidadesAltaNaoAdicionadas").height()
                        }, 800);
                    }
                };

                $("#prioridadeAtendimento.PrioridadeAtendimentoAlta").bind("DOMMouseScroll mousewheel", function (e) {
                    if ($scope.limitlocalidadesAltaAdicionadas < $scope.prioridadeAtendimento.PrioridadeAtendimentoAlta.length) {
                        $scope.$apply(function () {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope.limitlocalidadesAltaAdicionadas += 5;
                                $("#prioridadeAtendimento.PrioridadeAtendimentoAlta").animate({
                                    scrollTop: $("#tabLocalidadesAltaAdicionadas").height()
                                }, 800);
                            }
                        });
                    }
                });

                $("#localidadesAltaNaoAdicionadas").bind("DOMMouseScroll mousewheel", function (e) {
                    if ($scope.limitLocalidadesAlta < $scope.localidadesAltaList.length) {
                        $scope.$apply(function () {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope.limitLocalidadesAlta += 5;
                                $("#localidadesAltaNaoAdicionadas").animate({
                                    scrollTop: $("#tablocalidadesAltaNaoAdicionadas").height()
                                }, 800);
                            }
                        });
                    }
                });

                /**************************************
                    PRIORIDADE MAXIMA
                **************************************/
                $scope.localidadesMaximaList = [];
                $scope.limitLocalidadesMaxima = 5;
                $scope.limitlocalidadesMaximaAdicionadas = 5;

                $scope.adicionarLocalidadeMaxima = function () {
                    var localidadesSelecionadas = _.where($scope.localidadesMaximaList, { Selecionado: true });
                    if (localidadesSelecionadas.length > 0) {
                        angular.forEach(localidadesSelecionadas, function (value) {
                            value.Selecionado = false;
                            value.Adicionado = true;

                            if (value.Removido && value.Alterado) {
                                value.Removido = false;
                                value.Alterado = false;
                            } else value.Alterado = true;

                            $scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima.push(value);
                            $scope.localidadesMaximaList.splice($scope.localidadesMaximaList.indexOf(value), 1);
                        });

                    } else {
                        NotifyService.showError(null, 'telaFilaAtendimento.selecioneUmaLocalidadeASerAdicionada')
                    }
                };

                $scope.removerLocalidadeMaxima = function () {
                    var localidadesSelecionadas = _.where($scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima, {
                        Selecionado: true
                    });
                    if (localidadesSelecionadas.length > 0) {
                        angular.forEach(localidadesSelecionadas, function (value) {
                            value.Selecionado = false;
                            value.Removido = true;

                            if (value.Adicionado && value.Alterado) {
                                value.Adicionado = false;
                                value.Alterado = false;
                            } else value.Alterado = true;

                            $scope.localidadesMaximaList.push(value);
                            $scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima.splice($scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima.indexOf(value), 1);
                        });

                    } else {
                        NotifyService.showError(null, 'telaFilaAtendimento.selecioneUmaLocalidadeASerRemovida')
                    }
                };

                $scope.selecionarTodosMaximaAdicionadas = function (itensAdicionadas) {
                    angular.forEach($scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima, function (item) {
                        if (itensAdicionadas) {
                            item.Selecionado = true;
                        } else {
                            item.Selecionado = false;
                        }
                    });
                };

                $scope.selecionarTodosMaximaNaoAdicionadas = function (itensNaoAdicionadas) {
                    angular.forEach($scope.localidadesMaximaList, function (item) {
                        if (itensNaoAdicionadas) {
                            item.Selecionado = true;
                        } else {
                            item.Selecionado = false;
                        }
                    });
                };

                $scope.maisLocalidadesMaximaAdicionadas = function () {
                    if ($scope.limitlocalidadesMaximaAdicionadas < $scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima.length) {
                        $scope.limitlocalidadesMaximaAdicionadas += 5;
                        $("#prioridadeAtendimento.PrioridadeAtendimentoMaxima").animate({
                            scrollTop: $("#tabLocalidadesMaximaAdicionadas").height()
                        }, 800);
                    }
                };

                $scope.maisLocalidadesMaximaNaoAdicionadas = function () {
                    if ($scope.limitLocalidadesMaxima < $scope.localidadesMaximaList.length) {
                        $scope.limitLocalidadesMaxima += 5;
                        $("#localidadesMaximaNaoAdicionadas").animate({
                            scrollTop: $("#tablocalidadesMaximaNaoAdicionadas").height()
                        }, 800);
                    }
                };

                $("#prioridadeAtendimento.PrioridadeAtendimentoMaxima").bind("DOMMouseScroll mousewheel", function (e) {
                    if ($scope.limitlocalidadesMaximaAdicionadas < $scope.prioridadeAtendimento.PrioridadeAtendimentoMaxima.length) {
                        $scope.$apply(function () {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope.limitlocalidadesMaximaAdicionadas += 5;
                                $("#prioridadeAtendimento.PrioridadeAtendimentoMaxima").animate({
                                    scrollTop: $("#tabLocalidadesMaximaAdicionadas").height()
                                }, 800);
                            }
                        });
                    }
                });

                $("#localidadesMaximaNaoAdicionadas").bind("DOMMouseScroll mousewheel", function (e) {
                    if ($scope.limitLocalidadesMaxima < $scope.localidadesMaximaList.length) {
                        $scope.$apply(function () {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope.limitLocalidadesMaxima += 5;
                                $("#localidadesMaximaNaoAdicionadas").animate({
                                    scrollTop: $("#tablocalidadesMaximaNaoAdicionadas").height()
                                }, 800);
                            }
                        });
                    }
                });
            }])
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("PrioridadeAtendimentoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("PrioridadeAtendimento/:PrioridadeAtendimentoId",
                {
                    "PrioridadeAtendimentoId": "@PrioridadeAtendimentoId"
                },
                {
                    getLocalidades: {
                        url: "PrioridadeAtendimento/Localidades",
                        method: "GET",
                        isArray: true
                    },
                    setPrioridadeNormal: {
                        url: "PrioridadeAtendimento/PrioridadeNormal",
                        method: "POST"
                    },
                    setPrioridadeAlta: {
                        url: "PrioridadeAtendimento/PrioridadeAlta",
                        method: "POST"
                    },
                    setPrioridadeMaxima: {
                        url: "PrioridadeAtendimento/PrioridadeMaxima",
                        method: "POST"
                    },
                });
        }]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('RamalEditData', function RamalEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_ionRangeSlider',
							'lazy_uiSelect'
						]);
					}],
					ramal: ["RamalResource", "$stateParams", function (RamalResource, $stateParams) {
						if ($stateParams.RamalId) {
							return RamalResource.get({ RamalId: $stateParams.RamalId }).$promise;
						} else {
							return {};
						}
					}],
					configuracoes: ["RamalResource", "$stateParams", function (RamalResource, $stateParams) {
						if ($stateParams.RamalId) {
							return RamalResource.getRamalCampos({ Id: $stateParams.RamalId }).$promise;
						} else {
							return {};
						}
					}]
				}
			}
		})

		.controller("RamalEditController", ["$scope", "$http", "$filter", "ramal", "configuracoes", "Config", "$state", "TemplateCampoResource", "TemplateCampoItemResource", "RamalResource", "AuthService", "NotifyService", "$stateParams", "ModalService", "$translate", function ($scope, $http, $filter, ramal, configuracoes, Config, $state, TemplateCampoResource, TemplateCampoItemResource,
			RamalResource, AuthService, NotifyService, $stateParams, ModalService, $translate) {
			$scope.ramal = ramal
			$scope.configuracoes = configuracoes;
			$scope.ramal.alterarSenha = false;
			$scope.usuarioIsAdmin = AuthService.getUsuarioLogado() ? (AuthService.getUsuarioLogado().UsuarioTipoId == 1 ? true : false) : false;
			$scope.confSenha = $scope.usuarioIsAdmin ? ($scope.ramal.RamalTipoId == 3 || ramal.RamalTipoId == 4 ? false : true) : false;

			$scope.onCampoAlterado = function (campo) {
				campo.Alterado = true;
			};

			$scope.carregarItens = function (item) {
				item.Itens = [];
				if (!item.TemplateCampoId) return;

				TemplateCampoResource.get({
					TemplateCampoId: item.TemplateCampoId
				}).$promise.then(data => {
					item.TemplateCampoTipoId = data.TemplateCampoTipoId;
					if (data.Fonte) {
						$http.get(Config.getUrl(data.Fonte.Comando)).then(response => {
							item.Itens = [];
							angular.forEach(response.data, value => {
								item.Itens.push({
									Nome: value[data.Fonte.Nome],
									Valor: value[data.Fonte.Valor]
								});
							})
							item.Itens = $filter('orderBy')(item.Itens, item => {
								return parseInt(item.Valor);
							});
						});

					} else {
						TemplateCampoItemResource.odata().orderBy('Nome', 'asc')
							.filter("TemplateCampoId", "=", parseInt(item.TemplateCampoId))
							.query()
							.then(values => {
								item.Itens = [];
								angular.copy(values, item.Itens);
								item.Itens = $filter('orderBy')(item.Itens, item => {
									if (!isNaN(parseFloat(item.Valor)) && isFinite(item.Valor)) {
										return parseInt(item.Valor);
									} else {
										return item.Valor;
									}
								});
							});
					}
				});
			};

			$scope.salvar = function () {
				ModalService.confirmMessage($translate.instant('telaEditRamais.confirmaAlteracao'), null, () => {
					let data = {};
					angular.forEach($scope.configuracoes, grupo => {
						angular.forEach(grupo.Campos, campo => {
							if (campo.Alterado) {
								data[campo.TemplateCampoId] = campo.Valor || "";
							}
						});
					});

					ModalService.showLoading();

					$http.put(Config.getUrl("Ramal/Update?id=" + ramal.RamalId), data).then(() => {
						ModalService.hideLoading();
						NotifyService.showSuccess('telaEditRamais.ramalAlteradoComSucesso');
					}, function () {
						ModalService.hideLoading();
						NotifyService.showError();
					});
				});
			}

			$scope.detalhe = function (campo) {
				ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3><span style="font-size: 17px;"">${campo.Descricao}</span>`)
			}

			//Pesquisa
			$scope.search = {
				Nome: ''
			};

			$scope.gruposAdicionados = [];
			$scope.grupos = [];
			$scope.checkbox = [];
			$scope.limitGrupos = 5;
			$scope.limitGruposAdicionados = 5;

			//Grupos
			$scope.getGruposNaoAssociados = function () {
				let ramalId = ($scope.ramal.RamalId > 0 ? $scope.ramal.RamalId : (isNaN(parseInt($stateParams.RamalId)) ? 0 : parseInt($stateParams.RamalId)));
				RamalResource.getGruposNaoAssociados({
					ramalId: ramalId,
					nome: $scope.search.Nome
				}).$promise.then((data) => {
					angular.copy(data, $scope.grupos);
					if ($scope.ramal.RamalTipoId == 6) {
						$scope.grupos = _.where($scope.grupos, { GrupoTipoId: 3 });
					} else {
						$scope.grupos = _.where($scope.grupos, { GrupoTipoId: 1 });
					}
				});
			};

			//Grupos
			$scope.alterarSenha = function () {
				if ($scope.ramal.Senha != $scope.ramal.ConfirmaSenha) {
					return NotifyService.showError(null, "Senhas estão diferentes")
				}

				RamalResource.alterarSenha({
					RamalId: $scope.ramal.RamalId,
					Senha: $scope.ramal.Senha
				}).$promise.then(() => {
					mensagemSucesso();
					$state.go('main.ramais.list');
				}).catch(NotifyService.showError);
			}

			//Grupos Associados
			$scope.getGruposAssociados = function () {
				let ramalId = ($scope.ramal.RamalId > 0 ? $scope.ramal.RamalId : (isNaN(parseInt($stateParams.RamalId)) ? 0 : parseInt($stateParams.RamalId)));

				RamalResource.getGruposAssociados({
					ramalId: ramalId,
					nome: $scope.search.Nome
				}).$promise.then((data) => {
					angular.copy(data, $scope.gruposAdicionados);
				});
			};

			if ($scope.ramal.RamalId) {
				$scope.getGruposNaoAssociados();
				$scope.getGruposAssociados();
			}

			$scope.pesquisaGrupos = function (searchGrupos, length, lengthAdicionados) {
				let lengthTotal = $scope.grupos.length;
				let lengthAdicionadosTotal = $scope.gruposAdicionados.length;
				if (searchGrupos.length > 0) {
					if (lengthTotal != length) $scope.limitGrupos = lengthTotal;
					if (lengthAdicionadosTotal != lengthAdicionados) $scope.limitGruposAdicionados = lengthAdicionadosTotal;
				}
				else {
					$scope.limitGrupos = 5;
					$scope.limitGruposAdicionados = 5;
				}
			};

			$scope.alteraGrupoDefault = function (grupo) {
				let grupoPadrao = grupo.GrupoPadrao;

				ModalService.confirmMessage($translate.instant('telaEditRamais.confirmarAlteracaoGrupoPadrao'), null, () => {
					if (grupoPadrao) {
						let ramalId = ($scope.ramal.RamalId > 0 ? $scope.ramal.RamalId : (isNaN(parseInt($stateParams.RamalId)) ? 0 : parseInt($stateParams.RamalId)));
						if (ramalId > 0) {
							RamalResource.updateGrupoPadrao({
								RamalId: ramalId,
								GrupoId: grupo.GrupoId
							}).$promise.then(() => {
								mensagemSucesso();
								$scope.getGruposAssociados();
							}).catch(NotifyService.showError);
						}
					}
				}, { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });

				$scope.getGruposAssociados();
			}

			/* Adicionar e remover ramais */
			$scope.adicionar = function () {
				ModalService.showLoading();

				let gruposSelecionados = _.where($scope.grupos, {
					Selecionado: true
				});

				if (gruposSelecionados.length) {
					let gruposString = _.pluck(gruposSelecionados, 'GrupoId').join(",");
					RamalResource.adicionarGrupo({
						RamalId: $scope.ramal.RamalId,
						Grupos: gruposString
					}).$promise.then(() => {
						$scope.getGruposNaoAssociados();
						$scope.getGruposAssociados();
						ModalService.hideLoading();
						NotifyService.showRegistroSalvo();
					}).catch(e => {
						ModalService.hideLoading();
						NotifyService.showError(e);
					});
				}
				else {
					ModalService.hideLoading();
					NotifyService.showError(null, 'telaEditRamais.nenhumGrupoSelecionado');
				}
			};

			$scope.remover = function () {
				ModalService.showLoading();
				let gruposSelecionados = _.where($scope.gruposAdicionados, {
					Selecionado: true
				});

				if (gruposSelecionados.length) {
					let gruposString = _.pluck(gruposSelecionados, 'GrupoId').join(",");
					RamalResource.removerGrupo({
						RamalId: $scope.ramal.RamalId,
						Grupos: gruposString
					}).$promise.then(() => {
						$scope.getGruposNaoAssociados();
						$scope.getGruposAssociados();
						ModalService.hideLoading();
						NotifyService.showRegistroSalvo();
					});
				}
				else {
					ModalService.hideLoading();
					NotifyService.showError(null, 'telaEditRamais.nenhumGrupoSelecionado');
				}
			};

			$scope.selectionarTodosAdicionados = function () {
				angular.forEach($scope.gruposAdicionados, item => {
					if ($scope.checkbox.todosItemsAdicionados && !item.GrupoPadrao) item.Selecionado = true;
					else item.Selecionado = false;
				});
			};

			$scope.selectionarTodosNaoAdicionados = function () {
				angular.forEach($scope.grupos, item => {
					if ($scope.checkbox.todosOsGrupos) item.Selecionado = true;
					else item.Selecionado = false;
				});
			};

			$scope.maisGruposAdicionados = function () {
				if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
					$scope.limitGruposAdicionados += 5;
					$("#gruposAdicionados").animate({
						scrollTop: $("#tabGruposAdicionados").height()
					}, 800);
				}
			};

			$scope.maisGruposNaoAdicionados = function () {
				if ($scope.limitGrupos < $scope.grupos.length) {
					$scope.limitGrupos += 5;
					$("#gruposNaoAdicionados").animate({
						scrollTop: $("#tabGruposNaoAdicionados").height()
					}, 800);
				}
			};

			$("#gruposAdicionados").bind("DOMMouseScroll mousewheel", e => {
				if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
					$scope.$apply(() => {
						if (e.originalEvent.wheelDelta / 120 < 0) {
							$scope.limitGruposAdicionados += 5;
							$("#gruposAdicionados").animate({
								scrollTop: $("#tabGruposAdicionados").height()
							}, 800);
						}
					});
				}
			});

			$("#gruposNaoAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
				if ($scope.limitGrupos < $scope.grupos.length) {
					$scope.$apply(() => {
						if (e.originalEvent.wheelDelta / 120 < 0) {
							$scope.limitGrupos += 5;
							$("#gruposNaoAdicionados").animate({
								scrollTop: $("#tabGruposNaoAdicionados").height()
							}, 800);
						}
					});
				}
			});

			function mensagemSucesso() {
				NotifyService.showSuccess();
				if ($scope.novo) $scope.ramalStatusEdit = {};
				$scope.submitted = false;
			}
		}]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.ramais", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.ramais.list',
                        pageTitle: 'model.ramal',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.ramais.list", StateResolverProvider.configState("/ramais?storage", "Ramal", "List", {
                    pageTitle: 'model.ramal',
                    pageName: 'pageTitle.pesquisar',
                    css: true
                }))
                .state("main.ramais.new", StateResolverProvider.configState("/ramais/new?page&storage&grupo", "Ramal", "New", {
                    pageTitle: 'model.ramal',
                    pageName: 'acoes.cadastrar',
                    css: true
                }))
                .state("main.ramais.edit", StateResolverProvider.configState("/ramais/{RamalId:[0-9]+}", "Ramal", "Edit", {
                    pageTitle: 'model.ramal',
                    pageName: 'acoes.editar',
                    css: true
                }))
        }])

        .service('RamalListData', function RamalListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    templates: ["TemplateResource", function (TemplateResource) {
                        return TemplateResource.odata().orderBy('Descricao', 'asc').query();
                    }],
                    grupoList: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }],
                    templateGrupos: ["TemplateGrupoResource", function (TemplateGrupoResource) {
                        return TemplateGrupoResource.odata().orderBy('Descricao', 'asc').query();
                    }],
                    maquina: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }

        })

        .controller("RamalListController", ["$scope", "$filter", "templates", "templateGrupos", "grupoList", "$q", "$http", "Config", "NotifyService", "FileDownloadService", "RamalResource", "TemplateCampoResource", "TemplateCampoItemResource", "maquina", "$translate", "ModalService", "carteiras", function ($scope, $filter, templates, templateGrupos, grupoList, $q, $http, Config, NotifyService, FileDownloadService,
            RamalResource, TemplateCampoResource, TemplateCampoItemResource, maquina, $translate, ModalService, carteiras) {
            var RAMAL_PA = 1;
            var RAMAL_TALKBOT = 6;
            var GRUPO_TALKBOT = 3
            var GRUPOO_PADRAO = 1
            var RAMAL_FILAVIRTUAL = 7;
            var RAMAL_INTEGRACAO = 4;
            var RAMAL_URA = 3;
            var grupoListFiltro = _.where(grupoList, { GrupoTipoId: RAMAL_PA });
            var defaultPageSize = 10;

            $scope.carteiras = carteiras;
            $scope.grupoEditList = grupoListFiltro;
            $scope.filtros = [];
            $scope.grupoList = grupoList;
            $scope.templateGrupos = templateGrupos;
            $scope.templateCampos = [];
            $scope.alteracoes = [{ Campos: [] }];
            $scope.ramaisFull = [];
            $scope.totalRamais = 0;
            $scope.tipoPesquisa = 0;
            $scope.submitted = false;
            $scope.templates = templates;
            $scope.abaSelecionada = 1;
            $scope.flagsCti = [];
            $scope.ramalNumero = 0;
            $scope.maquina = maquina[0];
            $scope.predicate = '';
            $scope.reverse = false;
            $scope.visibleAlterarTodos = false;
            $scope.maxLengthRamal = 4;

            $scope.deleteEmLote = {
                DeleteUsuario: false
            };

            $scope.grupoRamal = {
                GrupoId: null
            };

            $scope.search = {
                NumeroInicial: '',
                NumeroFinal: '',
                RamalTipoId: RAMAL_PA,
                CarteiraId: 0
            };

            $scope.ramalTipoList = [
                { RamalTipoId: 1, Descricao: $translate.instant('telaRamais.ramalPa') },
                { RamalTipoId: 4, Descricao: $translate.instant('campo.integracao') },
                //Ignorando o filtro de RamalTipoId = 3
                // { RamalTipoId: 3, Descricao: $translate.instant('model.ura') },
                { RamalTipoId: 6, Descricao: $translate.instant('campo.talkbot') },
                { RamalTipoId: 7, Descricao: $translate.instant('telaRamais.ramalFilaVirtual') }

            ];

            if (maquina[0].PlataformaId == 2) {
                $scope.ramalTipoList.push({ RamalTipoId: 5, Descricao: $translate.instant('telaRamais.virtual') });
            }

            $scope.predicates = [
                { Label: $translate.instant('telaRamais.igual'), Value: '=' },
                { Label: $translate.instant('telaRamais.diferente'), Value: '!=' },
                { Label: $translate.instant('telaRamais.contem'), Value: 'contains' },
                { Label: $translate.instant('telaRamais.maiorQue'), Value: '>' },
                { Label: $translate.instant('telaRamais.menorQue'), Value: '<' },
                { Label: $translate.instant('telaRamais.maiorOuIgual'), Value: '>=' },
                { Label: $translate.instant('telaRamais.menorOuIgual'), Value: '<=' }
            ];

            $scope.templateCampoItens = [];
            $scope.templateCamposUpdate = [];

            $scope.ramal = {
                TemplateGrupoId: 0,
                TemplateCampoId: 0,
                TemplateCampoTipoId: 0
            };

            $scope.searchTemplateCampoItens = [];

            $scope.addFilter = function () {
                $scope.filtros.push({ Campos: [] });
            };

            $scope.addAlteracao = function () {
                $scope.alteracoes.push({ Campos: [] });
            };

            $scope.deleteFilter = function (item) {
                $scope.filtros.splice($scope.filtros.indexOf(item), 1);
            };

            $scope.deleteAlteracao = function (item) {
                $scope.alteracoes.splice($scope.alteracoes.indexOf(item), 1);
            };

            $scope.changeGrupo = function (item) {
                item.Campos = [];

                if (!item.TemplateGrupoId || !item.TemplateId) return;

                TemplateCampoResource.odata().orderBy('Alias', 'asc')
                    .filter("TemplateId", "=", parseInt(item.TemplateId))
                    .filter("TemplateGrupoId", "=", parseInt(item.TemplateGrupoId))
                    .filter("Editavel", "=", true)
                    .filter("Ativo", "=", true)
                    .query()
                    .then(values => { item.Campos = values; });
            }

            $scope.changeTemplateCampo = function (item) {
                item.Itens = [];

                if (!item.TemplateCampoId) return;

                TemplateCampoResource.get({ TemplateCampoId: item.TemplateCampoId }).$promise
                    .then(data => {
                        item.TemplateCampoTipoId = data.TemplateCampoTipoId;

                        if (data.Fonte) {
                            $http.get(Config.getUrl(data.Fonte.Comando))
                                .then(response => {
                                    angular.forEach(response.data, value => {
                                        item.Itens.push({
                                            Nome: value[data.Fonte.Nome],
                                            Valor: value[data.Fonte.Valor]
                                        });
                                    })
                                });
                        } else {
                            TemplateCampoItemResource
                                .odata()
                                .orderBy('Nome', 'asc')
                                .filter("TemplateCampoId", "=", parseInt(item.TemplateCampoId))
                                .query()
                                .then(values => { angular.copy(values, item.Itens); });
                        }
                    });
            };

            $scope.executeSearch = function (form) {
                if (form.$valid == false) {
                    for (var i = 0; i < $scope.filtros.length; i++) {
                        form['subform' + i].$setSubmitted();
                    }
                    return;
                }
                $scope.submitted = true;
                getOdataSearch();
            }

            $scope.confirmDelete = function confirmDelete(ramal) {
                const excluirRamal = (ramalId, excluirUsuario) => {
                    RamalResource.delete({
                        RamalId: ramalId,
                        excluirUsuario: excluirUsuario
                    }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            getOdataSearch().then(() => {
                                $scope.pageChanged($scope.currentPage);
                            });
                        }).catch(NotifyService.showError);
                }

                if (ramal.UsuarioId) {
                    ModalService.confirmDelete(() => {
                        ModalService.confirmMessage($translate.instant('telaRamais.confimaExcluirUsuarioAssociado'), null, () => {
                            excluirRamal(ramal.RamalId, true);
                        }, {
                            labels: {
                                'Ok': $translate.instant('campo.sim'),
                                'Cancel': $translate.instant('campo.nao')
                            }
                        }, () => {
                            excluirRamal(ramal.RamalId, false);
                        });
                    })
                } else {
                    ModalService.confirmDelete(() => {
                        excluirRamal(ramal.RamalId, false);
                    });
                }
            }

            $scope.mudarAba = function (abaId) {
                $scope.limparFiltro();
                $scope.abaSelecionada = abaId;
            }

            $scope.pageChanged = function (newPage) {
                $scope.currentPage = newPage;
                $scope.ramais.$currentPage = newPage;
                let itensPerPage = ($scope.ramaisFull.pageSize || defaultPageSize);
                let begin = ((newPage - 1) * itensPerPage)
                let end = begin + itensPerPage;
                let currentList = $scope.ramaisFull.slice(begin, end);
                currentList.$currentPage = newPage;

                updateList(currentList);
            };

            $scope.fazerUpdateEmLote = function (valid) {
                if (!valid) return NotifyService.showInvalid();

                let msg = `<h4>${$translate.instant('telaRamais.confirmaAlteracao')}</h4> </br>${$translate.instant('telaRamais.camposSelecionados')}:`;

                angular.forEach($scope.alteracoes, (item) => {
                    let campo = _.findWhere(item.Campos, {
                        TemplateCampoId: parseInt(item.TemplateCampoId)
                    });
                    msg += '</br> <strong>' + campo.Alias + '</strong>';
                });

                ModalService.confirmMessage(msg, null, () => {
                    let campos = {};
                    let ramais = $scope.ramaisFull;

                    angular.forEach($scope.alteracoes, item => {
                        campos[item.TemplateCampoId] = item.Valor;
                    });

                    ModalService.showLoading();

                    RamalResource.updateRamalLote({
                        Campos: campos,
                        RamalDto: ramais
                    }).$promise.then(() => {
                        NotifyService.showSuccess('telaRamais.ramaisAlteradosComSucesso')
                        ModalService.hideLoading();
                        ModalService.closeModal('modalAlterar');
                    }).catch(() => {
                        NotifyService.showError();
                        ModalService.hideLoading();
                    });
                });
            }

            $scope.addFilter();

            $scope.limparFiltro = function () {
                $scope.search = {
                    StatusIntegracaoId: 2,
                    NumeroInicial: '',
                    NumeroFinal: '',
                    Usuario: '',
                    GrupoId: 0,
                    CarteiraId: 0
                };
                $scope.filtros = [];
                $scope.visibleAlterarTodos = false;
                $scope.addFilter();
                $scope.ramais = [];
                $scope.totalRamais = 0;
            }

            $scope.alterarTodos = function () {
                $scope.isEditableItem = true;
                $scope.isEditRamal = false;
                $scope.isDeleteRamal = false;
                $scope.isGrupoRamal = false;
                $scope.alteracoes = [{ Campos: [] }];
                $scope.deleteEmLote = { DeleteUsuario: false };
                $scope.grupoRamal = { GrupoId: null };

                ModalService.openModal('modalAlterar');
            };

            $scope.viewEditRamalLote = function () {
                $scope.isEditableItem = false;
                $scope.isEditRamal = true;
            };

            $scope.backEditRamalLote = function () {
                $scope.isEditableItem = true;
                $scope.isEditRamal = false;
                $scope.alteracoes = [{ Campos: [] }];
            };

            $scope.getFlagsCti = function (ramalNumero) {
                $scope.ramalNumero = ramalNumero;
                RamalResource.getFlagsCti({ RamalNumero: ramalNumero }).$promise.then(response => {
                    $scope.flagsCti = response;
                    ModalService.openModal('modal_flags');
                });
            };

            $scope.viewDeleteRamalLote = function () {
                $scope.isEditableItem = false;
                $scope.isDeleteRamal = true;
            }

            $scope.backDeleteRamalLote = function () {
                $scope.isEditableItem = true;
                $scope.isDeleteRamal = false;
                $scope.deleteEmLote = {
                    DeleteUsuario: false
                };
            };

            $scope.viewGrupoRamalLote = function () {
                $scope.isEditableItem = false;
                $scope.isGrupoRamal = true;
            }

            $scope.backGrupoRamalLote = function () {
                $scope.isEditableItem = true;
                $scope.isGrupoRamal = false;
            };

            $scope.deleteRamalLote = function () {
                ModalService.confirmDelete(() => {
                    let ramais = _.pluck($scope.ramaisFull, 'RamalId').join(",");
                    if (ramais.length) {
                        ModalService.showLoading();

                        RamalResource.deleteRamalLote({
                            Ramais: ramais,
                            RemoveUsuario: $scope.deleteEmLote ? $scope.deleteEmLote.DeleteUsuario : false,
                        }).$promise.then(() => {
                            if ($scope.QuantidadeRamalAlteracao > 0) {
                                NotifyService.showSuccess('telaRamais.ramaisExcluidosComSucesso');
                            }
                            ModalService.hideLoading();
                            ModalService.closeModal('modalAlterar');
                            getOdataSearch();
                        }).catch(() => {
                            NotifyService.showError();
                            ModalService.hideLoading();
                            ModalService.closeModal('modalAlterar');
                        });
                    }
                });
            }

            $scope.updateGrupoPadraoLote = function () {
                ModalService.confirmMessage(`<h4>${$translate.instant('telaRamais.confirmaAlteracao')}</h4>`, null, () => {
                    let ramais = _.pluck(_.where($scope.ramaisFull, {}), 'RamalId').join(",");
                    if (ramais.length) {
                        ModalService.showLoading();

                        RamalResource.updateGrupoEmLote({
                            "RamalIds": ramais.toString(),
                            "GrupoId": $scope.grupoRamal ? $scope.grupoRamal.GrupoId : 0,
                        }).$promise.then(() => {
                            if ($scope.QuantidadeRamalAlteracao > 0) {
                                NotifyService.showSuccess('telaRamais.ramaisAlteradosComSucesso');
                            }
                            ModalService.hideLoading();
                            ModalService.closeModal('modalAlterar');
                            getOdataSearch();
                        }).catch(e => {
                            NotifyService.showError(e);
                            ModalService.hideLoading();
                            ModalService.closeModal('modalAlterar');
                        });
                    }

                });
            }

            $scope.order = function (predicate) {
                let itensPerPage = ($scope.ramais.pageSize || defaultPageSize),
                    page = $scope.ramais.$currentPage ? $scope.ramais.$currentPage : 1,
                    begin = ((page - 1) * itensPerPage),
                    end = begin + itensPerPage,
                    currentList = $scope.ramaisFull.slice(begin, end);

                $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
                $scope.predicate = predicate;
                $scope.ramaisFull = $filter('orderBy')($scope.ramaisFull, predicate, $scope.reverse);
                $scope.ramaisFull.$currentPage = page;
                currentList.$currentPage = page;
                updateList(currentList);
            };

            function updateList(list) {
                $scope.ramais = list;
                $scope.ramais.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.ramais.pageSize = list.$pageSize || defaultPageSize;
                $scope.submitted = false;
            }

            function getOdataSearch() {
                let promises = getOdataSearchShared($scope.search, $scope.filtros);
                return $q.all(promises.map((promise) => {
                    return promise.then((result) => {
                        return result;
                    });
                })).then(ramaisarray => {
                    let ramais = [];
                    angular.forEach(ramaisarray, item => {
                        ramais = ramais.concat(item);
                    });
                    $scope.totalRamais = ramais.length;
                    $scope.QuantidadeTotalRamais = ramais.length;
                    $scope.QuantidadeTotalTalkbots = ramais.filter((i) => { return i.RamalTipoId == 6; }).length;
                    $scope.QuantidadeRamalAlteracao = $scope.QuantidadeTotalRamais - $scope.QuantidadeTotalTalkbots;
                    $scope.QuantidadeGrupoAlteracao = ramais.length ? ramais[0].QuantidadeGrupo : 0;
                    $scope.QuantidadeUsuarioAlteracao = ramais.length ? ramais[0].QuantidadeUsuario : 0;
                    $scope.ramaisFull = ramais;
                    updateList(ramais);

                    $scope.visibleAlterarTodos = true;
                }).catch(() => { $scope.submitted = false; });
            }

            function getOdataSearchShared(search, filtros) {
                let promises = [];
                let ramalDetalhe = {
                    RamalId: 0,
                    NumeroInicial: 0,
                    NumeroFinal: 0,
                    RamalTipoId: 0,
                    GrupoId: 0,
                    TemplateCampoId: 0,
                    TemplateCampoValor: '',
                    TemplateParametro: '',
                    UsuarioNome: '',
                    CarteiraId: 0 
                };

                if (search.CarteiraId) ramalDetalhe.CarteiraId = search.CarteiraId;
                if (search.GrupoId) ramalDetalhe.GrupoId = search.GrupoId;
                if (search.Usuario) ramalDetalhe.UsuarioNome = search.Usuario;
                if (search.RamalTipoId) ramalDetalhe.RamalTipoId = search.RamalTipoId;
                if (search.NumeroInicial) ramalDetalhe.NumeroInicial = search.NumeroInicial;
                if (search.NumeroFinal) ramalDetalhe.NumeroFinal = search.NumeroFinal;

                if (filtros.length > 0) {
                    angular.forEach(filtros, item => {
                        if (item.Campos.length > 0) {
                            ramalDetalhe.TemplateCampoId = parseInt(item.TemplateCampoId);
                            ramalDetalhe.TemplateCampoValor = item.Search;
                            ramalDetalhe.TemplateParametro = item.Predicate;
                            promises.push(RamalResource.getRamalDetalhe({
                                param: angular.toJson(ramalDetalhe, false)
                            }).$promise);
                        } else {
                            promises.push(RamalResource.getRamalDetalhe({
                                param: angular.toJson(ramalDetalhe, false)
                            }).$promise);
                        }
                    });
                } else {
                    promises.push(RamalResource.getRamalDetalhe({
                        param: angular.toJson(ramalDetalhe, false)
                    }).$promise);
                }

                return promises;
            }

            function getRamalParams(search, filtros){
                let ramalParams = {
                    RamalId: 0,
                    NumeroInicial: 0,
                    NumeroFinal: 0,
                    RamalTipoId: 0,
                    GrupoId: 0,
                    TemplateCampoId: 0,
                    TemplateCampoValor: '',
                    TemplateParametro: '',
                    UsuarioNome: '',
                    CarteiraId: 0, 
                };

                if (search.CarteiraId) ramalParams.CarteiraId = search.CarteiraId;
                if (search.GrupoId) ramalParams.GrupoId = search.GrupoId;
                if (search.Usuario) ramalParams.UsuarioNome = search.Usuario;
                if (search.RamalTipoId) ramalParams.RamalTipoId = search.RamalTipoId;
                if (search.NumeroInicial) ramalParams.NumeroInicial = search.NumeroInicial;
                if (search.NumeroFinal) ramalParams.NumeroFinal = search.NumeroFinal;

                if (filtros.length > 0) {
                    angular.forEach(filtros, item => {
                        if (item.Campos.length > 0) {
                            ramalParams.TemplateCampoId = parseInt(item.TemplateCampoId);
                            ramalParams.TemplateCampoValor = item.Search;
                            ramalParams.TemplateParametro = item.Predicate;
                        }
                    });
                }

                return ramalParams;
            }

            $scope.exportarRamais = function () {
                try {
                    ModalService.showLoading();
                    var fileName = generateUUID();

                    let ramalParams = getRamalParams($scope.search, $scope.filtros);

                    RamalResource.exportarRamais({
                        NumeroInicial: ramalParams.NumeroInicial,
                        NumeroFinal: ramalParams.NumeroFinal,
                        RamalTipoId: ramalParams.RamalTipoId,       
                        CarteiraId: ramalParams.CarteiraId,
                        UsuarioNome: ramalParams.UsuarioNome,
                        TemplateCampoId: ramalParams.TemplateCampoId,
                        TemplateCampoValor: ramalParams.TemplateCampoValor,
                        TemplateParametro: ramalParams.TemplateParametro,                 
                        FileName: fileName
                    }).$promise.then(() => {
                        FileDownloadService.downloadWebApiFile("Ramal/Download/" + fileName);
                        ModalService.hideLoading();
                    }).catch((data) => {
                        ModalService.hideLoading();
                        NotifyService.showError(data.error);
                    });
                } catch (err) {
                    NotifyService.showError(err);
                }
            }

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }

            $scope.onChangePesquisaRange = function () {
                $scope.search.NumeroInicial = null;
                $scope.search.NumeroFinal = null;
            }

            $scope.onChangeGrupo = function () {
                if ($scope.search.GrupoId != undefined) {
                    let grupoid = $scope.search.GrupoId;
                    let grupo = _.findWhere($scope.grupoList, { GrupoId: grupoid });

                    if (grupo.GrupoTipoId == GRUPO_TALKBOT) $scope.search.RamalTipoId = RAMAL_TALKBOT;
                    else $scope.search.RamalTipoId = RAMAL_PA;

                    let grupoListFiltro = _.where(grupoList, { GrupoTipoId: grupo.GrupoTipoId });
                    $scope.grupoEditList = grupoListFiltro;
                    getOdataSearch();
                }
            };


            $scope.onchangeRamal = function () {

                $scope.maxLengthRamal = 4;

                if ($scope.search.RamalTipoId != undefined) {
                    let grupoid = null;
                    if ($scope.search.RamalTipoId == RAMAL_TALKBOT) {
                        grupoid = GRUPO_TALKBOT;
                    } else if($scope.search.RamalTipoId == RAMAL_FILAVIRTUAL || $scope.search.RamalTipoId == RAMAL_INTEGRACAO
                         ||$scope.search.RamalTipoId == RAMAL_URA){
                        $scope.maxLengthRamal = 11;
                    } else{
                        grupoid = GRUPOO_PADRAO;
                    }
                    let grupoListFiltro = _.where(grupoList, { GrupoTipoId: grupoid });
                    $scope.grupoEditList = grupoListFiltro;
                    getOdataSearch();
                }
            };

            $scope.onchangeRamalAvancado = function (item) {                

                if (item.RamalTipoId != undefined) {
                    $scope.search.RamalTipoId = item.RamalTipoId;
                    
                    //Garante a pesquisa pelo número do ramal com mais de 4 caracteres para os tipos FilaVirtual, Integracao e Ura.
                    if (item.RamalTipoId == 7 || item.RamalTipoId == 4 || item.RamalTipoId == 3){
                        $scope.maxLengthRamal = 11;
                    }else{
                        $scope.maxLengthRamal = 4;
                    }
                    let templatesFiltro = templates.filter((template) => template.RamalTipoId == item.RamalTipoId);
                    $scope.templates = templatesFiltro;
                }
                else {
                    $scope.templates = templates;
                }
            };
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('RamalNewData', function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    ramal: ["$stateParams", "LocalStorageService", function ($stateParams, LocalStorageService) {
                        let ramal = {
                            CriarUsuario: false,
                            Tipo: 1,
                            RamalTipoId: 1,
                            AtendimentoConfiguracaoId: null,
                            RamalSenha: 'TalkTelecom$@2017',
                            UsuarioSenha: ''
                        };

                        if ($stateParams.storage) ramal = LocalStorageService.getItem('Ramal');

                        if ($stateParams.grupo) ramal.GrupoId = $stateParams.grupo;

                        return ramal;
                    }],
                    tipos: ["RamalTipoResource", function (RamalTipoResource) {
                        return RamalTipoResource
                            .odata()
                            .orderBy('Descricao', 'asc')
                            .query();
                    }],
                    templates: ["TemplateResource", "ramal", function (TemplateResource, ramal) {
                        return TemplateResource
                            .odata()
                            .filter('RamalTipoId', 'eq', parseInt(ramal.RamalTipoId))
                            .orderBy('Descricao', 'asc')
                            .query();
                    }],
                    atendimentos: ["AtendimentoConfiguracaoResource", function (AtendimentoConfiguracaoResource) {
                        return AtendimentoConfiguracaoResource
                            .odata()
                            .orderBy('Descricao', 'asc')
                            .query();
                    }],
                    maquina: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }]
                }
            }
        })

        .controller("RamalNewController", ["$scope", "ramal", "templates", "atendimentos", "RamalResource", "TemplateResource", "GrupoResource", "RotaResource", "$state", "LocalStorageService", "$stateParams", "maquina", "NotifyService", "$translate", "ModalService", function ($scope, ramal, templates, atendimentos, RamalResource, TemplateResource, GrupoResource,
            RotaResource, $state, LocalStorageService, $stateParams, maquina, NotifyService, $translate, ModalService) {
            $scope.forms = {};
            $scope.ramal = ramal;
            $scope.alterarSenha = false;
            $scope.grupos = [];
            $scope.templates = templates;
            $scope.atendimentos = atendimentos;
            $scope.validaAtendimentoConfiguracao = false;
            $scope.rotas = [];
            $scope.ramalTipoIntegração = 4;
            $scope.ramalTipoCriacaoUnico = 2;
            $scope.ramalTipoFilaVirtual = 7;
            $scope.PossuiLicencaTalkbot = true;
            $scope.maquina = maquina[0];
            $scope.totalRamaisCriados = 0;
            $scope.qtdMaxGrupo = 0;
            $scope.gruposAdicionados = [];
            $scope.gruposNaoAdicionados = [];
            $scope.checkbox = [];
            $scope.limitGrupos = 5;
            $scope.limitGruposAdicionados = 5;
            $scope.currentPage = 1;
            $scope.idGrupoPadrao = 0;

            $scope.senhaForteLength = false;
            $scope.senhaForteCaractereMinusculo = false;
            $scope.senhaForteCaractereMaiusculo = false;
            $scope.senhaForteCaractereNumerico = false;
            $scope.senhaForteCaractereEspecial = false;
            $scope.senhaValida = false;

            if ($scope.maquina) {
                if ($scope.maquina.PlataformaId == 2) {
                    $scope.tiposRamal = [
                        { RamalTipoId: 1, Descricao: $translate.instant('telaCriacaoRamais.ramalPa') },
                        { RamalTipoId: 4, Descricao: $translate.instant('campo.integracao') },
                        { RamalTipoId: 5, Descricao: $translate.instant('telaCriacaoRamais.virtual') },
                        { RamalTipoId: 7, Descricao: $translate.instant('telaCriacaoRamais.filaVirtual') },
                        { RamalTipoId: 6, Descricao: $translate.instant('campo.talkbot') }
                    ];
                } else {
                    $scope.tiposRamal = [
                        { RamalTipoId: 1, Descricao: $translate.instant('campo.padrao') },
                        { RamalTipoId: 4, Descricao: $translate.instant('campo.integracao') }
                    ];
                }
            }

            let localStorage = LocalStorageService.getItem('Ramal');
            if (localStorage) $scope.ramal.RamalTipoId = localStorage.RamalTipoId;

            $scope.imagem = '';
            $scope.imagemReduzida = '';
            $scope.nomeImagemAvatar = '';
            $scope.licencasTalkbot = { total: 0, utilizadas: 0, disponiveis: 0 };

            RamalResource.quantidadeLicencasTalkbot().$promise.then(data => {
                $scope.licencasTalkbot = {
                    total: data.Total,
                    disponiveis: data.Disponiveis,
                    utilizadas: data.Utilizadas
                };
            });

            function uploadFile() {
                let request = new XMLHttpRequest();
                request.open('GET', './assets/img/avatars/AvatarTalkbot.png', true);
                request.responseType = 'blob';
                request.onload = function () {
                    let reader = new FileReader();
                    reader.readAsDataURL(request.response);
                    reader.onload = function (e) {
                        convertImage(e.target.result);
                        $scope.ramal.talkbotImagemReduzida = $scope.imagemReduzida;
                        $scope.ramal.talkbotImagem = $scope.imagem;
                    };
                };
                request.send();
            }

            function convertImage(base64) {
                let img = new Image();
                img.src = base64;
                img.onload = function () {
                    let tempW = img.width;
                    let tempH = img.height;
                    let scaleReduzida = Math.min((34 / tempW), (34 / tempH));
                    let scaleNormal = Math.min((82 / tempW), (82 / tempH));
                    let canvasReduzida = document.createElement("canvas");
                    canvasReduzida.width = tempW * scaleReduzida;
                    canvasReduzida.height = tempH * scaleReduzida;
                    let ctxReduzida = canvasReduzida.getContext("2d");
                    ctxReduzida.drawImage(this, 0, 0, tempW * scaleReduzida, tempH * scaleReduzida);
                    $scope.imagemReduzida = canvasReduzida.toDataURL("image/png", 1.0);
                    ctxReduzida.clearRect(0, 0, img.width, img.height);
                    let canvasNormal = document.createElement("canvas");
                    canvasNormal.width = tempW * scaleNormal;
                    canvasNormal.height = tempH * scaleNormal;
                    let ctxNormal = canvasNormal.getContext("2d");
                    ctxNormal.drawImage(this, 0, 0, tempW * scaleNormal, tempH * scaleNormal);
                    $scope.imagem = canvasNormal.toDataURL("image/png", 1.0);
                    ctxNormal.clearRect(0, 0, img.width, img.height);
                    if ($scope.ramal) {
                        $scope.ramal.talkbotImagem = $scope.imagem;
                    }
                }
            }

            uploadFile();

            $scope.validacaoValorMaximo = function () {
                $scope.PossuiLicencaTalkbot = true;
                if ($scope.ramal.RamalTipoId == 6) {
                    if ($scope.licencasTalkbot.total == 0) {
                        return $scope.PossuiLicencaTalkbot = false;
                    }
                }
            }

            $scope.changeRamalDestino = function (event) {
                let numeroRamal = document.getElementById("RamalDestino").value;
                $scope.ramal.FaixaInicial = numeroRamal;
            }

            function mensagemSucesso(data) {
                ModalService.hideLoading();
                $scope.totalRamaisCriados = data.Total;
                ModalService.openModal('modal-ramais-criados');
            }

            function mensagemErro(error) {
                ModalService.hideLoading();
                var msg = error && error.data ? (error.data.Message || error.data.message || '') : '';
                if (error && error.status === 400 && msg.indexOf('limite de quantidade') > -1) {
                    ModalService.alert('telaCriacaoRamais.limiteRamalAtingido');
                } else {
                    NotifyService.showError(error);
                }
            }

            function mensagemErroCriarRamal(error) {
                ModalService.hideLoading();
                let msgError = $scope.builderAlertError(error, $translate.instant('telaCriacaoRamais.criacaoDeRamal'), error.data.Message);
                ModalService.alert(msgError);
            }

            function saveRamais(ramal) {
                ModalService.showLoading();

                if ($scope.talkbotNome) ramal.talkbotNome = $scope.talkbotNome;

                if ($scope.imagem) {
                    ramal.talkbotImagemReduzida = $scope.imagemReduzida;
                    ramal.talkbotImagem = $scope.imagem;
                }

                if ($scope.gruposAdicionados.length > 0) {
                    ramal.GruposAdicionais = _.pluck($scope.gruposAdicionados, 'GrupoId').join(",");
                }

                RamalResource.save(ramal).$promise.then(mensagemSucesso).catch(mensagemErroCriarRamal);
            }

            $scope.onClickOk = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, {
                        storage: true
                    });
                } else {
                    $state.go('main.ramais.list');
                }
            }

            function carregaTemplateRamalTipo() {
                if (!$scope.ramal.RamalTipoId) return ModalService.hideLoading();

                TemplateResource
                    .odata()
                    .filter('RamalTipoId', 'eq', parseInt($scope.ramal.RamalTipoId))
                    .orderBy('Descricao', 'asc')
                    .query()
                    .then((response) => {
                        ModalService.hideLoading();
                        $scope.templates = response;
                        if ($scope.ramal.RamalTipoId == 6 && response.length == 1) {
                            $scope.ramal.TemplateId = response[0].TemplateId;
                        }
                    }).catch(mensagemErro);
            }

            function carregaGrupoRamalTipo() {
                if (!$scope.ramal.RamalTipoId) return ModalService.hideLoading();

                let grupoTipoId = $scope.ramal.RamalTipoId == 6 ? 3 : 1;

                return GrupoResource.getGruposInfoRamais({ GrupoTipoId: grupoTipoId }).$promise
                    .then((response) => {
                        ModalService.hideLoading();
                        $scope.grupos = response;
                        $scope.gruposNaoAdicionados = response;
                        $scope.gruposNaoAdicionados.forEach(grupo => {
                            grupo.GrupoPadrao = false;
                        });
                    }).catch(mensagemErro);
            }

            function carregaRotas() {
                if ($scope.ramal.RamalTipoId == 4 || $scope.ramal.RamalTipoId == 7) {
                    RotaResource
                        .odata()
                        .orderBy('Nome', 'asc')
                        .filter("RotaTipoId", "!=", 5)
                        .filter("RotaTipoId", "!=", 6)
                        .query()
                        .then((response) => {
                            ModalService.hideLoading();
                            $scope.rotas = response;
                        }).catch(mensagemErro);
                } else {
                    $scope.rotas = [];
                    ModalService.hideLoading()
                }
            }

            $scope.novoGrupo = function () {
                LocalStorageService.setItem('Ramal', $scope.ramal);
                $state.go("main.grupos.new", {
                    page: 'main.ramais.new',
                    tipogrupo: $scope.ramal.RamalTipoId
                });
            };

            $scope.validateSenhaForte = function () {
                let novaSenha = document.getElementById("input-chave-UsuarioSenha").value

                if (novaSenha.length >= 8 && novaSenha.length <= 16) {
                    $scope.senhaForteLength = true;
                } else {
                    $scope.senhaForteLength = false;
                }

                if (novaSenha.match(/[a-z]+/)) {
                    $scope.senhaForteCaractereMinusculo = true;
                } else {
                    $scope.senhaForteCaractereMinusculo = false;
                }

                if (novaSenha.match(/[A-Z]+/)) {
                    $scope.senhaForteCaractereMaiusculo = true;
                } else {
                    $scope.senhaForteCaractereMaiusculo = false;
                }

                if (novaSenha.match(/[0-9]+/)) {
                    $scope.senhaForteCaractereNumerico = true;
                } else {
                    $scope.senhaForteCaractereNumerico = false;
                }

                if (novaSenha.match(/[\W|_]+/)) {
                    $scope.senhaForteCaractereEspecial = true;
                } else {
                    $scope.senhaForteCaractereEspecial = false;
                }

                if ($scope.senhaForteLength && $scope.senhaForteCaractereMinusculo &&
                    $scope.senhaForteCaractereMaiusculo && $scope.senhaForteCaractereNumerico &&
                    $scope.senhaForteCaractereEspecial) {
                    $scope.senhaValida = true;
                }
            };

            $scope.salvar = function (valid) {
                if (!valid) return NotifyService.showInvalid();

                if (!$scope.ramal.RamalTipoId) {
                    return NotifyService.showError(null, 'telaCriacaoRamais.preenchaTipoDeRamalCorretamente');
                }

                if ($scope.ramal.Quantidade > 500) {
                    return NotifyService.showError(null, 'telaCriacaoRamais.quantidadeInvalida');
                }

                if ($scope.ramal.Tipo == 3) {
                    if ((parseInt($scope.ramal.FaixaFinal) - parseInt($scope.ramal.FaixaInicial)) > 500) {
                        return NotifyService.showError(null, 'telaCriacaoRamais.quantidadeInvalida');
                    }
                }

                if ($scope.ramal.Tipo == 2) {
                    let ramal = angular.copy($scope.ramal);

                    let range = {
                        RamalTipoId: ramal.RamalTipoId
                    };

                    if ($scope.ramal.RamalTipoId == 4) {
                        ramal.Tipo = 1;
                        ramal.Quantidade = 1;
                        ramal.CriarUsuario = true;
                        range.FaixaInicial = $scope.ramal.FaixaInicial;
                        range.FaixaFinal = $scope.ramal.FaixaInicial;
                    }
                    else if ($scope.ramal.RamalTipoId == 7) {
                        range.FaixaInicial = $scope.ramal.FaixaInicial;
                        range.FaixaFinal = $scope.ramal.FaixaInicial;
                        ramal.Quantidade = 1;
                        ramal.FaixaFinal = $scope.ramal.FaixaInicial;
                    }
                    else {
                        range.FaixaInicial = $scope.ramal.FaixaInicial;
                        range.FaixaFinal = $scope.ramal.FaixaFinal;
                    }

                    RamalResource.validaRange(range).$promise
                        .then(data => {
                            if (data.QtdDisponivel == 0) {
                                return ModalService.alert($translate.instant('telaCriacaoRamais.naoExistemRamaisDisponiveis'));
                            }
                            if (data.QtdNaoDisponivel > 0 && data.QtdDisponivel > 0) {
                                ModalService.confirmMessage($translate.instant('telaCriacaoRamais.existemRamaisQueNaoPodemSerCriados'),
                                    { 'QtdNaoDisponivel': data.QtdNaoDisponivel }, () => { saveRamais(ramal) });
                            }
                            if (data.QtdNaoDisponivel == 0 && data.QtdDisponivel > 0) {
                                saveRamais(ramal);
                            }
                        }).catch(mensagemErroCriarRamal);

                } else {
                    saveRamais($scope.ramal);
                }
            };

            $scope.changeTipoCadastro = function (valor) {
                $scope.ramal.FaixaInicial = "";
                $scope.ramal.FaixaFinal = "";
                $scope.ramal.Numero = "";
                $scope.ramal.RamalDestino = "";
                $scope.ramal.Quantidade = "";
                $scope.ramal.Tipo = valor;
                $scope.ramal.GrupoId = null;
                $scope.forms.formRamal.$setPristine();
                $scope.forms.formRamal.$setUntouched();
            };

            $scope.changePermiteUsuario = function () {
                let permite = ramal.CriarUsuario ? true : false;
                if (!permite) $scope.ramal.AtendimentoConfiguracaoId = null;
            }

            $scope.cancelar = function () {
                if ($stateParams.page) $state.go($stateParams.page, { storage: true });
                else $state.go('main.ramais.list', { storage: true });
            };

            $scope.onChangeRamalTipo = function (tipo) {
                try {
                    ModalService.showLoading();
                    $scope.templates = [];
                    $scope.ramal.TemplateId = 0;
                    $scope.ramal.RamalTipoId = tipo;

                    $scope.grupos = [];
                    $scope.gruposAdicionados = [];
                    $scope.gruposNaoAdicionados = [];
                    $scope.ramal.GrupoId = 0;
                    $scope.ramal.RamalTipoId = tipo;
                    $scope.ramal.RotaCtiId = 0;

                    if (tipo == $scope.ramalTipoIntegração) {
                        $scope.ramal.Numero = "";
                        $scope.ramal.Tipo = $scope.ramalTipoCriacaoUnico;
                        $scope.ramal.CriarUsuario = 1;
                    }
                    else
                        $scope.ramal.CriarUsuario = false;

                    carregaTemplateRamalTipo();
                    carregaGrupoRamalTipo();
                    carregaRotas();
                    $scope.ramal.Quantidade = '';
                    $scope.validacaoValorMaximo();

                    if (tipo == $scope.ramalTipoFilaVirtual) {
                        $scope.ramal.Quantidade = 1;
                        $scope.ramal.Tipo = $scope.ramalTipoCriacaoUnico;
                    }

                } catch (ex) {
                    mensagemErro(ex);
                }
            }

            $scope.associarGrupos = function () {
                ModalService.openModal("modal-grupos");
            }

            function validaQuantidadeRamais(grupoId, quantidade) {
                if (grupoId > 0) {
                    let grupoPadrao = $scope.grupos.find(grupo => grupo.GrupoId == grupoId);
                    if (grupoPadrao.QtdRamaisDisponiveis < quantidade) {
                        return grupoPadrao;
                    }
                }

                return true;
            }

            $scope.changeGrupoPadrao = function () {
                if ($scope.ramal.RamalTipoId == 1) {
                    let grupoId = $scope.ramal.GrupoId;
                    let oldValue = $scope.idGrupoPadrao;

                    if ($scope.ramal.Tipo == 1) {
                        let valido = validaQuantidadeRamais(grupoId, parseInt($scope.ramal.Quantidade))
                        if (valido !== true) {
                            $scope.ramal.GrupoId = null;
                            if (valido.QtdRamaisDisponiveis > 0) {
                                return NotifyService.showError(null, $translate.instant('telaCriacaoRamais.avisoQuantidadeExcedida', { Quantidade: valido.QtdRamaisDisponiveis }));
                            } else {
                                return NotifyService.showError(null, $translate.instant('telaCriacaoRamais.grupoExcedeuQuantidade'));
                            }
                        }
                    }

                    if ($scope.ramal.Tipo == 2 || $scope.ramal.Tipo == 3) {
                        let quantidade = ((parseInt($scope.ramal.FaixaFinal) + 1) - parseInt($scope.ramal.FaixaInicial));
                        let valido = validaQuantidadeRamais(grupoId, quantidade)
                        if (valido !== true) {
                            $scope.ramal.GrupoId = null;
                            if (valido.QtdRamaisDisponiveis > 0) {
                                return NotifyService.showError(null, $translate.instant('telaCriacaoRamais.avisoQuantidadeExcedida', { Quantidade: valido.QtdRamaisDisponiveis }));
                            } else {
                                return NotifyService.showError(null, $translate.instant('telaCriacaoRamais.grupoExcedeuQuantidade'));
                            }
                        }
                    }

                    if (oldValue > 0) {
                        let grupoNaoAdicionado = $scope.gruposNaoAdicionados.find(grupo => grupo.GrupoId == oldValue);
                        if (grupoNaoAdicionado !== undefined) {
                            grupoNaoAdicionado.GrupoPadrao = false;
                        }
                        else {
                            let grupo = $scope.gruposAdicionados.find(grupo => grupo.GrupoId == oldValue);
                            grupo.GrupoPadrao = false;
                        }
                    }
                    if (grupoId > 0) {
                        let naoAdicionado = $scope.gruposNaoAdicionados.find(grupo => grupo.GrupoId == grupoId);

                        if (naoAdicionado !== undefined) {
                            naoAdicionado.GrupoPadrao = true;
                            $scope.qtdMaxGrupo = naoAdicionado.QtdRamaisDisponiveis;
                        } else {
                            let grupo = $scope.gruposAdicionados.find(grupo => grupo.GrupoId == grupoId);
                            grupo.GrupoPadrao = true;
                            $scope.qtdMaxGrupo = grupo.QtdRamaisDisponiveis;
                        }
                    }

                    $scope.idGrupoPadrao = grupoId > 0 ? grupoId : 0;
                }
            }

            $scope.adicionar = function () {
                if ($scope.ramal.RamalTipoId == 1) {
                    let gruposSelecionados = _.where($scope.gruposNaoAdicionados, {
                        Selecionado: true
                    });
                    let erros = [];

                    if (gruposSelecionados.length > 0) {
                        gruposSelecionados.forEach(grupo => {
                            if ($scope.ramal.Tipo == 1) {
                                if (grupo.QtdRamaisDisponiveis > $scope.ramal.Quantidade) {
                                    let idx = $scope.gruposNaoAdicionados.indexOf(grupo);
                                    $scope.gruposNaoAdicionados.splice(idx, 1);
                                    grupo.Selecionado = false;
                                    $scope.gruposAdicionados.push(grupo);
                                }
                                else {
                                    let qtdDisponivel = grupo.QtdRamaisDisponiveis;

                                    if (qtdDisponivel > 0) {
                                        erros.push(`<li>"${grupo.Descricao}" - ${$translate.instant('telaCriacaoRamais.numeroRamaisDisponiveis', { Quantidade: grupo.QtdRamaisDisponiveis })}.</li>`);
                                    } else {
                                        erros.push(`<li>"${grupo.Descricao}" - ${$translate.instant('telaCriacaoRamais.grupoExcedeuQuantidade')}.</li>`);
                                    }
                                }
                            }
                            if ($scope.ramal.Tipo == 3 || $scope.ramal.Tipo == 2) {
                                let quantidade = ((parseInt($scope.ramal.FaixaFinal) + 1) - parseInt($scope.ramal.FaixaInicial));

                                if (grupo.QtdRamaisDisponiveis > quantidade) {
                                    let idx = $scope.gruposNaoAdicionados.indexOf(grupo);
                                    $scope.gruposNaoAdicionados.splice(idx, 1);
                                    grupo.Selecionado = false;
                                    $scope.gruposAdicionados.push(grupo);
                                }
                                else {
                                    let qtdDisponivel = grupo.QtdRamaisDisponiveis;

                                    if (qtdDisponivel > 0) {
                                        erros.push(`<li>"${grupo.Descricao}" - ${$translate.instant('telaCriacaoRamais.numeroRamaisDisponiveis', { Quantidade: grupo.QtdRamaisDisponiveis })}.</li>`);
                                    } else {
                                        erros.push(`<li>"${grupo.Descricao}" - ${$translate.instant('telaCriacaoRamais.grupoExcedeuQuantidade')}.</li>`);
                                    }
                                }
                            }

                        });
                        $scope.checkbox.todosOsGrupos = false;

                        if (erros.length > 0) {
                            let mensagem = `${$translate.instant('telaCriacaoRamais.gruposNaoAdicionados')}:<br/>` + erros.join("");

                            ModalService.alert(mensagem);
                        }
                    } else {
                        NotifyService.showError(null, 'telaCriacaoRamais.nenhumGrupoSelecionado');
                    }
                }
            };

            $scope.remover = function () {
                if ($scope.ramal.RamalTipoId == 1) {
                    let gruposSelecionados = _.where($scope.gruposAdicionados, {
                        Selecionado: true
                    });

                    if (gruposSelecionados.length > 0) {
                        gruposSelecionados.forEach(grupo => {
                            if (!grupo.GrupoPadrao) {
                                let idx = $scope.gruposAdicionados.indexOf(grupo);
                                $scope.gruposAdicionados.splice(idx, 1);
                                grupo.Selecionado = false;
                                $scope.gruposNaoAdicionados.push(grupo);
                            }
                        });
                        $scope.checkbox.todosItemsAdicionados = false
                    } else {
                        NotifyService.showError(null, 'telaCriacaoRamais.nenhumGrupoSelecionado');
                    }
                }
            };

            $scope.selectionarTodosAdicionados = function () {
                angular.forEach($scope.gruposAdicionados, item => {
                    if ($scope.checkbox.todosItemsAdicionados && !item.GrupoPadrao) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.selectionarTodosNaoAdicionados = function () {
                $scope.gruposNaoAdicionados.forEach(item => {
                    if ($scope.checkbox.todosOsGrupos) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.maisGruposAdicionados = function () {
                if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
                    $scope.limitGruposAdicionados += 5;
                    $("#gruposAdicionados").animate({
                        scrollTop: $("#tabGruposAdicionados").height()
                    }, 800);
                }
            };

            $scope.maisGruposNaoAdicionados = function () {
                if ($scope.limitGrupos < $scope.gruposNaoAdicionados.length) {
                    $scope.limitGrupos += 5;
                    $("#gruposNaoAdicionados").animate({
                        scrollTop: $("#tabGruposNaoAdicionados").height()
                    }, 800);
                }
            };

            $("#gruposAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitGruposAdicionados += 5;
                            $("#gruposAdicionados").animate({
                                scrollTop: $("#tabGruposAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            $("#gruposNaoAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitGrupos < $scope.gruposNaoAdicionados.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitGrupos += 5;
                            $("#gruposNaoAdicionados").animate({
                                scrollTop: $("#tabGruposNaoAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            $scope.detalhe = function () {
                ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3>
                <span style="font-size:17px">${$translate.instant('telaCriacaoRamais.descricaoGrupo')}</span>`)
            };

            $scope.detalheTipoRamal = function () {
                ModalService.alert(`<h3>${$translate.instant('campo.detalhe')}</h3>
                <span style="font-size:17px">${$translate.instant('telaCriacaoRamais.descricaoTipoRamal')}</span>`)
            };

            $scope.builderAlertError = function (error, titulo, messageDefault) {
                let possuiError = false;
                let msgError = `<h3>${titulo}</h3>`
                if (error &&
                    error.data &&
                    error.data.ModelState &&
                    error.data.ModelState.Ramal) {
                    let listRamal = error.data.ModelState.Ramal;
                    let limite = listRamal.length < 10 ? listRamal.length : 10;
                    for (var index = 0; index < limite; index++) {
                        msgError = msgError.concat('<br>', listRamal[index]);
                        possuiError = true;
                    }
                }
                if (!possuiError) {
                    msgError.concat('<br><br>', messageDefault);
                }
                return msgError;
            }

            $scope.onChangeRamalTipo(1);
        }])


        .directive('emQtdeTalkbot', function () {
            return {
                restrict: 'AE',
                require: 'ngModel',
                link: function (scope, element, attrs, ctrl) {
                    ctrl.$validators.emQtdeTalkbot = function (value) {
                        if (scope.ramal.RamalTipoId == 6) {
                            if (value > scope.licencasTalkbot.disponiveis)
                                return false;
                        }
                        return true;
                    };
                }
            };
        })
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RamalResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Ramal/:RamalId", { "RamalId": "@RamalId" },
                {
                    ramaisLivres: {
                        url: "Ramal/Livres",
                        method: "GET",
                        isArray: true
                    },
                    getRamalCampos: {
                        url: "Ramal/RamalCampos",
                        method: "GET",
                        isArray: true
                    },
                    adicionarGrupo: {
                        url: "Ramal/AdicionarGrupo",
                        method: "POST"
                    },
                    removerGrupo: {
                        url: "Ramal/RemoverGrupo",
                        method: "POST"
                    },
                    updateRamalLote: {
                        url: "Ramal/UpdateEmLote",
                        method: "POST"
                    },
                    getGruposNaoAssociados: {
                        url: "Ramal/GruposNaoAssociados",
                        method: "GET",
                        isArray: true
                    },
                    getGruposAssociados: {
                        url: "Ramal/GruposAssociados",
                        method: "GET",
                        isArray: true
                    },
                    getRamalDetalhe: {
                        url: "Ramal/RamalDetalhe",
                        method: "GET",
                        isArray: true,
                        params: {
                            "param": "@param"
                        }
                    },
                    getSimples: {
                        url: "Ramal/Simples",
                        method: "GET",
                        isArray: true
                    },
                    getSimplesPorGrupo: {
                        url: "Ramal/tipo/:TipoId/grupos/:GruposId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "TipoId": "@TipoId",
                            "GruposId": "@GruposId"
                        }
                    },
                    lookup: {
                        url: "Ramal/Lookup",
                        method: "GET",
                        isArray: true
                    },
                    updateGrupoPadrao: {
                        url: "Ramal/UpdateGrupoPadrao",
                        method: "POST"
                    },
                    deleteRamalLote: {
                        url: "Ramal/DeleteEmLote",
                        method: "POST"
                    },
                    updateGrupoEmLote: {
                        url: "Ramal/UpdateGrupoEmLote",
                        method: "POST"
                    },
                    validaRange: {
                        url: "Ramal/ValidaRange",
                        method: "POST"
                    },
                    alterarSenha: {
                        url: "Ramal/AlterarSenha",
                        method: "POST"
                    },
                    quantidadeLicencasTalkbot: {
                        url: "Ramal/QuantidadeLicencasTalkbot",
                        method: "GET",
                        isArray: false
                    },
                    getFlagsCti: {
                        url: "Ramal/FlagsCTI/:RamalNumero",
                        method: "GET",
                        isArray: true,
                        params: { 
                            "RamalNumero": "@RamalNumero"
                        }
                    },                   
                    exportarRamais: {
                        url: "Ramal/Exportar",
                        method: "POST"
                    },
                    download: {
                        url: "Ramal/Download",
                        method: "GET",  
                    },
                    getInfo :{
                        url: "Ramal/Info",
                        method: 'GET',
                        params: {
                            "RamalId": "@RamalId"
                        }
                    },
                    validarLimiteRamal: {
                        url: "Ramal/ValidarLimiteRamal",
                        method: "GET",
                        isArray: false
                    }
                });
        }])
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RamalStatusResource", ["$odataresource", function ($odataresource) {
            return $odataresource("RamalStatus/:RamalStatusId", { "RamalStatusId": "@RamalStatusId" });
        }]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RamalTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("RamalTipo/:RamalTipoId", { "RamalTipoId": "@RamalTipoId" });
        }]);

})();

(function () {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("TemplateCampoItemResource", ["$odataresource", function ($odataresource) {
      return $odataresource("TemplateCampoItem/:TemplateCampoItemId", { "TemplateCampoItemId": "@TemplateCampoItemId" });
    }]);

})();

(function() {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("TemplateGrupoResource", ["$odataresource", function($odataresource) {
      return $odataresource("TemplateGrupo/:TemplateGrupoId", { "TemplateGrupoId" : "@TemplateGrupoId" });
    }]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("CategoriaIntervaloResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CategoriaIntervalo/:CategoriaIntervaloId",
                {
                    "CategoriaIntervaloId": "@CategoriaIntervaloId"
                },
                {
                    getGrupoLivre: {
                        url: "CategoriaIntervalo/GrupoLivre",
                        method: "GET",
                        isArray: true
                    },
                    getGrupoReservado: {
                        url: "CategoriaIntervalo/GrupoReservado",
                        method: "GET",
                        isArray: true
                    },
                    getCategoriaTracking: {
                        url: "CategoriaIntervalo/CategoriaTracking",
                        method: "GET",
                        isArray: true
                    },
                    adicionarGrupo: {
                        url: "CategoriaIntervalo/AdicionarGrupo",
                        method: "POST"
                    },
                    removerGrupo: {
                        url: "CategoriaIntervalo/RemoverGrupo",
                        method: "POST"
                    },
                    processarCategoria: {
                        url: "CategoriaIntervalo/ProcessarCategoria",
                        method: "POST"
                    },
                    getCategoriaIntervaloPorGrupo: {
                        url: "CategoriaIntervalo/CategoriaIntervaloPorGrupo",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";


    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.ramalstatus.edit", StateResolverProvider.configState("/ramalstatus/{CategoriaIntervaloId:[0-9]+}", "RamalStatus", "Edit", {
                    pageTitle: 'pageTitle.intervaloDosRamais',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.ramalstatus.new", StateResolverProvider.configState("/ramalstatus/new?page", "RamalStatus", "Edit", {
                    pageTitle: 'pageTitle.intervaloDosRamais',
                    pageName: 'acoes.cadastrar',
                    css: true
                }));
        }])

        .service("RamalStatusEditData", function RamalStatusEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    categoriaIntervalo: ["CategoriaIntervaloResource", "$stateParams", function (CategoriaIntervaloResource, $stateParams) {
                        if ($stateParams.CategoriaIntervaloId) {
                            return CategoriaIntervaloResource.get({
                                CategoriaIntervaloId: $stateParams.CategoriaIntervaloId
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    ramalStatus: ["RamalStatusResourceDetalhe", "$stateParams", function (RamalStatusResourceDetalhe, $stateParams) {
                        if ($stateParams.CategoriaIntervaloId) {
                            return RamalStatusResourceDetalhe.odata().filter('CategoriaIntervaloId', parseInt($stateParams.CategoriaIntervaloId)).query();
                        }
                    }],
                }
            }
        })

        .controller("RamalStatusEditController", ["$scope", "$state", "$q", "$timeout", "categoriaIntervalo", "ramalStatus", "$stateParams", "RamalStatusResourceDetalhe", "CategoriaIntervaloResource", "WizardHandler", "NotifyService", "ModalService", "$translate", "$odata", function ($scope, $state, $q, $timeout, categoriaIntervalo, ramalStatus, $stateParams, RamalStatusResourceDetalhe,
            CategoriaIntervaloResource, WizardHandler, NotifyService, ModalService, $translate, $odata) {
            categoriaIntervalo.CategoriaIntervaloId = (categoriaIntervalo.CategoriaIntervaloId > 0 ? categoriaIntervalo.CategoriaIntervaloId :
                (isNaN(parseInt($stateParams.CategoriaIntervaloId)) ? 0 : parseInt($stateParams.CategoriaIntervaloId)));
            $scope.isNew = categoriaIntervalo.CategoriaIntervaloId > 0 ? false : true;
            $scope.ramalStatus = {};
            $scope.intervaloId = 0;
            $scope.ramalStatusList = [];
            $scope.ramalStatusDestino = [];
            $scope.forms = {};
            $scope.validateCategoria = true;
            $scope.validateIntervalo = true;
            $scope.statusList = [];
            $scope.tipoList = [];
            $scope.statusTipoList = [];

            $scope.ramalStatusEdit = {
                RamalStatusDetalheId: 0,
                RamalStatusId: 0,
                RamalStatusTipoId: 0,
                Descricao: '',
                RecebeExterno: false,
                RecebeInterno: false,
                DiscaExterno: false,
                DiscaInterno: false,
                RecebeDiscador: false,
                PermiteTabulacao: false,
                Bloqueado: false,
                Visivel: true,
                Bloqueado: false,
                Ativo: true,
                PermiteExclusao: true,
                CategoriaIntervaloId: categoriaIntervalo.CategoriaIntervaloId,
                RamalStatusDestinoId: null,
                BloqueiaRamal: false,
                TempoIntervalo: null,
                LimitarTempoIntervalo: false,
                IntervaloDestinoId: 0,
                LimiteIntervalo: 0,
                TempoMinAtendimento : null,
                PermiteTempoMinAtendimento: false,
                Cor: null,
                RamalStatus: {
                    Descricao: ''
                },
                RamalStatusTipo: {
                    Descricao: ''
                }
            };

            $scope.estilos = [
                { valor: 'md-bg-red-400', descricao: $translate.instant('telaRamalStatusEdit.vermelhoClaro') },
                { valor: 'md-bg-red-A700', descricao: $translate.instant('telaRamalStatusEdit.vermelhoEscuro') },
                { valor: 'md-bg-pink-300', descricao: $translate.instant('telaRamalStatusEdit.rosa') },
                { valor: 'md-bg-pink-A400', descricao: $translate.instant('telaRamalStatusEdit.rosaChoque') },
                { valor: 'md-bg-purple-700', descricao: $translate.instant('telaRamalStatusEdit.roxo') },
                { valor: 'md-bg-blue-200', descricao: $translate.instant('telaRamalStatusEdit.azulClaro') },
                { valor: 'md-bg-blue-900', descricao: $translate.instant('telaRamalStatusEdit.azulEscuro') },
                { valor: 'md-bg-cyan-200', descricao: $translate.instant('telaRamalStatusEdit.cianoClaro') },
                { valor: 'md-bg-cyan-700', descricao: $translate.instant('telaRamalStatusEdit.ciano') },
                { valor: 'md-bg-teal-500', descricao: $translate.instant('telaRamalStatusEdit.verdePetroleo') },
                { valor: 'md-bg-green-200', descricao: $translate.instant('telaRamalStatusEdit.verdeClaro') },
                { valor: 'md-bg-green-600', descricao: $translate.instant('telaRamalStatusEdit.verde') },
                { valor: 'md-bg-green-900', descricao: $translate.instant('telaRamalStatusEdit.verdeEscuro') },
                { valor: 'md-bg-yellow-300', descricao: $translate.instant('telaRamalStatusEdit.amareloClaro') },
                { valor: 'md-bg-yellow-A200', descricao: $translate.instant('telaRamalStatusEdit.amarelo') },
                { valor: 'md-bg-orange-300', descricao: $translate.instant('telaRamalStatusEdit.laranjaClaro') },
                { valor: 'md-bg-orange-900', descricao: $translate.instant('telaRamalStatusEdit.laranjaEscuro') },
                { valor: 'md-bg-brown-400', descricao: $translate.instant('telaRamalStatusEdit.marromClaro') },
                { valor: 'md-bg-brown-700', descricao: $translate.instant('telaRamalStatusEdit.marromEscuro') },
                { valor: 'md-bg-blue-grey-700', descricao: $translate.instant('telaRamalStatusEdit.cinzaEscuro') }
            ];

            if ($scope.isNew) {
                $scope.categoriaIntervalo = {
                    CategoriaIntervaloId: 0,
                    Nome: '',
                    Descricao: '',
                    Padrao: false,
                    Ativo: true,
                }
            } else {
                $scope.categoriaIntervalo = categoriaIntervalo;
                $scope.ramalStatusList = ramalStatus;
            }

            function limparIntervalo() {
                $scope.ramalStatusEdit = {
                    RamalStatusDetalheId: 0,
                    RamalStatusId: 0,
                    RamalStatusTipoId: 0,
                    Descricao: '',
                    RecebeExterno: false,
                    RecebeInterno: false,
                    DiscaExterno: false,
                    DiscaInterno: false,
                    RecebeDiscador: false,
                    PermiteTabulacao: false,
                    Visivel: true,
                    Bloqueado: false,
                    Ativo: true,
                    PermiteExclusao: true,
                    CategoriaIntervaloId: categoriaIntervalo.CategoriaIntervaloId,
                    RamalStatusDestinoId: null,
                    BloqueiaRamal: false,
                    TempoIntervalo: null,
                    LimitarTempoIntervalo: false,
                    IntervaloDestinoId: 0,
                    LimiteIntervalo: 0,
                    TempoMinAtendimento : null,
                    PermiteTempoMinAtendimento: false,
                    Cor: null,
                    RamalStatus: {
                        Descricao: ''
                    },
                    RamalStatusTipo: {
                        Descricao: ''
                    }
                };
            }

            function carregaStatus() {
                RamalStatusResourceDetalhe.status().$promise.then((response) => {
                    $scope.statusList = response;
                });
            }

            function carregaStatusTipo () {
                RamalStatusResourceDetalhe.tipo().$promise.then((response) => {
                    $scope.tipoList = response;
                });
            }

            function carregaStatusDestino(ramalStatusDetalhe) {
                const statusDetalheId = ramalStatusDetalhe.RamalStatusDetalheId;
                const categoriaId = categoriaIntervalo.CategoriaIntervaloId;
                const categoriaPadrao = 1;
                var filtroCategoria = new $odata.Predicate('CategoriaIntervaloId', categoriaId);
                if (categoriaId !== categoriaPadrao) {
                    filtroCategoria = $odata.Predicate.or([
                        filtroCategoria,
                        new $odata.Predicate('CategoriaIntervaloId', categoriaPadrao)
                    ]);
                }
                RamalStatusResourceDetalhe.odata().filter('RamalStatusTipoId', 1).filter(filtroCategoria).query().then(response => {
                    $scope.ramalStatusDestinoList = response.filter(item => {
                        return item.RamalStatusDetalheId != statusDetalheId
                    });
                });
            }

            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert("<h3>Detalhe</h3>" + descricao);
            };
            
            function mensagemSucesso () {
                NotifyService.showRegistroSalvo()
                if ($scope.novo) $scope.ramalStatusEdit = {};
            }

            function convertTimePickerToSeconds (time) {
                if (time !== null && time !== undefined) {
                    const timeArray = time.toString().split(':');
                    return (+timeArray[0]) * 60 * 60 + (+timeArray[1]) * 60 + (+timeArray[2]);
                } else return 0;
            }

            function convertSecondsToTimePicker (seconds) {
                if (seconds) {
                    const date = new Date(null);
                    date.setSeconds(seconds);
                    date.toISOString().substr(11, 8);
                    return date.toISOString().substr(11, 8);
                }
            }

            $scope.onChangeTipoIntervalo = function () {
                carregaStatusDestino($scope.ramalStatusEdit);
            };

            $scope.editarIntervalo = function (intervaloId) {
                $scope.ramalStatusEdit.TempoIntervalo = convertSecondsToTimePicker(1);
                $scope.ramalStatusEdit.TempoMinAtendimento = convertSecondsToTimePicker(1);
                $scope.intervaloId = intervaloId;
                $timeout(() => {
                    if ($scope.forms.formNovoIntervalo) {
                        $scope.forms.formNovoIntervalo.$setPristine();
                        $scope.forms.formNovoIntervalo.RamalStatusDestinoCor.$setUntouched();
                    }
                }, 100);

                // Filtra o Intervalo de Destino e Ordena pela Descrição(ASC)
                $scope.ramalStatusDestino = _.sortBy(_.filter($scope.ramalStatusList, (intervalo) => {
                    return intervalo.Visivel && intervalo.RamalStatusDetalheId != intervaloId;
                }), (o) => {
                    return o.Descricao;
                });

                if (intervaloId > 0) {
                    RamalStatusResourceDetalhe.get({
                        RamalStatusDetalheId: intervaloId
                    }).$promise.then((response) => {
                        angular.copy(response, $scope.ramalStatusEdit);
                        carregaStatus();
                        carregaStatusTipo();
                        carregaStatusDestino($scope.ramalStatusEdit);
                        if (isNaN(parseInt($scope.ramalStatusEdit.TempoIntervalo)) || parseInt($scope.ramalStatusEdit.TempoIntervalo) <= 0) {
                            $scope.ramalStatusEdit.TempoIntervalo = convertSecondsToTimePicker(1);
                        } else {
                            $scope.ramalStatusEdit.TempoIntervalo = convertSecondsToTimePicker(parseInt($scope.ramalStatusEdit.TempoIntervalo));
                        }
                        if (isNaN(parseInt($scope.ramalStatusEdit.TempoMinAtendimento)) || parseInt($scope.ramalStatusEdit.TempoMinAtendimento) <= 0) {
                            $scope.ramalStatusEdit.TempoMinAtendimento = convertSecondsToTimePicker(1);
                        } else {
                            $scope.ramalStatusEdit.TempoMinAtendimento = convertSecondsToTimePicker(parseInt($scope.ramalStatusEdit.TempoMinAtendimento));
                        }
                        ModalService.openModal('modalIntervalo');
                    });
                } else {
                    limparIntervalo();
                    $scope.ramalStatusEdit.IntervaloDestinoId = 0;
                    carregaStatus();
                    carregaStatusTipo();
                    carregaStatusDestino($scope.ramalStatusEdit);
                    ModalService.openModal('modalIntervalo');
                }
            }


            $scope.editarLimiteIntervalo = function (intervaloId) {
                limparIntervalo();
                $scope.intervaloId = intervaloId;
                $timeout(() => {
                    if ($scope.forms.formLimiteIntervalo) {
                        $scope.forms.formLimiteIntervalo.$setPristine();
                    }
                }, 100);

                // Filtra o Intervalo de Destino e Ordena pela Descrição(ASC)
                $scope.ramalStatusDestino = _.sortBy(_.filter($scope.ramalStatusList, function (intervalo) {
                    return intervalo.Visivel && intervalo.RamalStatusDetalheId != intervaloId;
                }), function (o) { return o.Descricao; });

                RamalStatusResourceDetalhe.get({
                    RamalStatusDetalheId: intervaloId
                }).$promise.then((data) => {
                    angular.copy(data, $scope.ramalStatusEdit);
                    carregaStatusDestino($scope.ramalStatusEdit);
                    $scope.ramalStatusEdit.TempoLimiteIntervalo = convertSecondsToTimePicker(parseInt($scope.ramalStatusEdit.TempoLimiteIntervalo || 0));
                    $scope.ramalStatusEdit.TempoMinAtendimento = convertSecondsToTimePicker(parseInt($scope.ramalStatusEdit.TempoMinAtendimento || 0));
                    $scope.ramalStatusEdit.TempoNotificacao = convertSecondsToTimePicker(parseInt($scope.ramalStatusEdit.TempoNotificacao || 0));
                    ModalService.openModal('modalTimeoutIntervalo');
                });
            }

            const carregaIntervalo = function () {
                const categoriaId = $scope.categoriaIntervalo.CategoriaIntervaloId;
                RamalStatusResourceDetalhe.odata().filter('CategoriaIntervaloId', categoriaId).query().then((result) => {
                    angular.copy(result, $scope.ramalStatusList);
                });
            }

            $scope.salvarNovoIntervalo = function (valid) {
                if (!valid) return NotifyService.showInvalid();

                const ramalStatus = Object.assign({}, $scope.ramalStatusEdit);

                // Valida a Duração da Pausa no Intervalo
                if (ramalStatus.BloqueiaRamal) {
                    const tempoIntervalo = convertTimePickerToSeconds(ramalStatus.TempoIntervalo);
                    if (tempoIntervalo == 0) {
                        return NotifyService.showError(null, 'telaRamalStatusEdit.informeADuracaoDaPausa');
                    }
                }

                const tempoMinAtendimento = convertTimePickerToSeconds(ramalStatus.TempoMinAtendimento);

                // Valida a Duração do Tempo Médio de Atendimento
                if (ramalStatus.PermiteTempoMinAtendimento) {                    
                    if (tempoMinAtendimento == 0) {
                        return NotifyService.showError(null, 'telaRamalStatusEdit.informeDuracaoMinAtendimento');
                    }
                }

                const categoriaId = ($scope.categoriaIntervalo.CategoriaIntervaloId > 0 ? $scope.categoriaIntervalo.CategoriaIntervaloId :
                    (isNaN(parseInt($stateParams.CategoriaIntervaloId)) ? 0 : parseInt($stateParams.CategoriaIntervaloId)));

                if (categoriaId > 0 && !$scope.isNew) {
                    
                    if(!ramalStatus.BloqueiaRamal) {
                        ramalStatus.TempoIntervalo = 0;
                    } else {
                        ramalStatus.TempoIntervalo = convertTimePickerToSeconds(ramalStatus.TempoIntervalo);
                    }
                    if(!ramalStatus.PermiteTempoMinAtendimento) {
                        ramalStatus.TempoMinAtendimento = null;
                    } else {
                        ramalStatus.TempoMinAtendimento = tempoMinAtendimento;
                    }
                    ramalStatus.CategoriaIntervaloId = categoriaId;
                    let promise;

                    if (!ramalStatus.Cor) {
                        ramalStatus.Cor = 'md-bg-grey-50';
                    }

                    if (ramalStatus.RamalStatusDetalheId > 0) 
                        promise = RamalStatusResourceDetalhe.update(ramalStatus).$promise;
                    else 
                        promise = RamalStatusResourceDetalhe.save(ramalStatus).$promise;

                    promise.then(() => {
                        carregaIntervalo();
                        mensagemSucesso();
                    }).catch(NotifyService.showError);

                    ModalService.closeModal('modalIntervalo');

                } else {
                    const status = $scope.statusList.find(s => s.RamalStatusId === ramalStatus.RamalStatusId);
                    const statusTipo = $scope.tipoList.find(s => s.RamalStatusTipoId === ramalStatus.RamalStatusTipoId);
                    ramalStatus.RamalStatus.Descricao = status.Descricao;
                    ramalStatus.RamalStatus.RamalStatusId = ramalStatus.RamalStatusId;
                    ramalStatus.RamalStatusTipo.Descricao = statusTipo.Descricao;
                    ramalStatus.RamalStatusTipo.RamalStatusTipoId = ramalStatus.RamalStatusTipoId;                    
                    ramalStatus.TempoMinAtendimento = tempoMinAtendimento;
                    $scope.ramalStatusList.push(ramalStatus);
                    $scope.forms.formIntervalos.$dirty = true;
                    ModalService.closeModal('modalIntervalo');
                }
            }

            $scope.salvarLimiteIntervalo = function (valid) {
                if (!valid) return NotifyService.showInvalid();
                
                const ramalStatus = {};
                angular.copy($scope.ramalStatusEdit, ramalStatus)
                // Valida o Limite de Tempo em Intervalo
                if (ramalStatus.LimitarTempoIntervalo) {
                    const tempoLimiteIntervalo = convertTimePickerToSeconds(ramalStatus.TempoLimiteIntervalo);
                    if (tempoLimiteIntervalo == 0) {
                        return NotifyService.showError(null, 'telaRamalStatusEdit.informeADuracaoDoIntervalo');
                    }
                }
                if (ramalStatus.TempoMinAtendimento) {
                    const tempoMinAtendimento = convertTimePickerToSeconds(ramalStatus.TempoMinAtendimento);
                    if (tempoMinAtendimento == 0) {
                        return NotifyService.showError(null, 'telaRamalStatusEdit.informeDuracaoMinAtendimento');
                    }
                }
                if (ramalStatus.Notificar) {
                    ramalStatus.TempoNotificacao = convertTimePickerToSeconds(ramalStatus.TempoNotificacao) || 0;
                } else {
                    ramalStatus.TempoNotificacao = null;
                    ramalStatus.MensagemNotificacao = null;
                }

                if (ramalStatus.LimitarTempoIntervalo) {
                    ramalStatus.TempoLimiteIntervalo = convertTimePickerToSeconds(ramalStatus.TempoLimiteIntervalo);
                } else {
                    ramalStatus.TempoLimiteIntervalo = null
                    ramalStatus.MensagemNotificacao = null;
                    ramalStatus.IntervaloDestinoId = null;
                }
                if (ramalStatus.TempoMinAtendimento) {
                    ramalStatus.TempoMinAtendimento = convertTimePickerToSeconds(ramalStatus.TempoMinAtendimento);
                } else {
                    ramalStatus.TempoMinAtendimento = null;
                }

                RamalStatusResourceDetalhe.updateIntervalo(ramalStatus).$promise
                    .then(() => {
                        carregaIntervalo();
                        mensagemSucesso();
                        ModalService.closeModal('modalTimeoutIntervalo');
                    }).catch(NotifyService.showError);

            }

            $scope.checkIntervaloVisivel = function () {
                const ramalStatusDestino = _.sortBy(_.filter($scope.ramalStatusList, (intervalo) => {
                    return intervalo.Visivel;
                }), (o) => {
                    return o.Descricao;
                });
                return ramalStatusDestino.length > 0;
            }

            $scope.voltar = function () {
                if ($stateParams.page) $state.go($stateParams.page, { storage: true });
                else $state.go('main.ramalstatus.list', { storage: true });
            }

            $scope.finalizarCadastro = function () {
                return CategoriaIntervaloResource.processarCategoria({
                    CategoriaIntervaloId: $scope.categoriaIntervalo.CategoriaIntervaloId
                }).$promise;
            }

            $scope.salvar = function (form) {
                const lastStep = form.$name == "forms.formGrupos" ? true : false;
                if (!form.$dirty && !lastStep) {
                    WizardHandler.wizard().next();
                }
                else {
                    if (!form.$valid) return NotifyService.showInvalid();

                    if (!$scope.isNew) {
                        if (form.$name == "forms.formCategoria") {
                            salvarCategoria(form).then((data) => {
                                angular.copy(data, $scope.categoriaIntervalo);
                                $stateParams.CategoriaIntervaloId = $scope.categoriaIntervalo.CategoriaIntervaloId;
                                mensagemSucesso();
                            }).catch(NotifyService.showError);
                            form.$setPristine();
                        } else if (form.$name == "forms.formIntervalos") {
                            salvarCategoria(form).then((data) => {
                                angular.copy(data, $scope.categoriaIntervalo);
                                $stateParams.CategoriaIntervaloId = $scope.categoriaIntervalo.CategoriaIntervaloId;
                                $q.all(salvarIntervalo(form)).then(mensagemSucesso).catch(NotifyService.showError);
                            }).catch(NotifyService.showError);
                            form.$setPristine();
                        } else if (lastStep) {
                            salvarCategoria(form).then((data) => {
                                angular.copy(data, $scope.categoriaIntervalo);
                                $stateParams.CategoriaIntervaloId = $scope.categoriaIntervalo.CategoriaIntervaloId;
                                $q.all(salvarGrupo(form)).then(() => {
                                    mensagemSucesso();
                                    if (!form.$dirty) {
                                        if ($stateParams.page) $state.go($stateParams.page, { storage: true });
                                        else $state.go('main.ramalstatus.list', { storage: true });
                                    }
                                    $scope.finalizarCadastro().then(() => {
                                        form.$setPristine();
                                    });
                                }).catch(NotifyService.showError);
                            }).catch(NotifyService.showError);
                        }
                    } else if (lastStep) {
                        ModalService.showLoading();
                        salvarCategoria($scope.forms.formCategoria).then((data) => {
                            angular.copy(data, $scope.categoriaIntervalo);
                            $stateParams.CategoriaIntervaloId = $scope.categoriaIntervalo.CategoriaIntervaloId;
                            if ($scope.categoriaIntervalo.CategoriaIntervaloId > 0) {
                                $q.all(salvarIntervalo($scope.forms.formIntervalos)).then(() => {
                                    if ($scope.forms.formGrupos.$dirty) {
                                        $q.all(salvarGrupo($scope.forms.formGrupos)).then(() => {
                                            //Finaliza e Processa os Intervalos
                                            $scope.finalizarCadastro().then(() => {
                                                if ($stateParams.page) {
                                                    $state.go($stateParams.page, {
                                                        storage: true
                                                    });
                                                }
                                                else {
                                                    ModalService.hideLoading();
                                                    $state.go('main.ramalstatus.list', {
                                                        storage: true
                                                    });
                                                }
                                                mensagemSucesso();
                                            }).catch(NotifyService.showError); //Processa Intervalo
                                        }).catch(NotifyService.showError); //salva os grupos
                                    } else {
                                        //Finaliza e Processa os Intervalos
                                        $scope.finalizarCadastro().then(() => {
                                            ModalService.hideLoading();
                                            $state.go('main.ramalstatus.list', {
                                                storage: true
                                            });
                                            mensagemSucesso();
                                        }).catch(NotifyService.showError); //Processa Intervalo
                                    }
                                }).catch(NotifyService.showError); //salva intervalo
                            }
                        }).catch(NotifyService.showError); //salva categoria
                    }
                }
            }

            function salvarCategoria () {
                if ($scope.categoriaIntervalo.CategoriaIntervaloId > 0) {
                    return CategoriaIntervaloResource.update($scope.categoriaIntervalo).$promise;
                }
                else {
                    return CategoriaIntervaloResource.save($scope.categoriaIntervalo).$promise;
                }
            }

            function salvarIntervalo () {
                const allpromises = [];
                if ($scope.ramalStatusList) {
                    angular.forEach($scope.ramalStatusList, (value) => {
                        value.CategoriaIntervaloId = ($scope.categoriaIntervalo.CategoriaIntervaloId > 0 ? $scope.categoriaIntervalo.CategoriaIntervaloId :
                            (isNaN(parseInt($stateParams.CategoriaIntervaloId)) ? 0 : parseInt($stateParams.CategoriaIntervaloId)));
                        if (value.CategoriaIntervaloId > 0 && $scope.isNew) {
                            allpromises.push(RamalStatusResourceDetalhe.save(value).$promise);
                        }
                    });
                }

                return allpromises;
            }

            $scope.validateCategoria = function () {
                const alterado = $scope.isNew ? false : $scope.forms.formCategoria.$dirty;
                let proximoStep = false;
                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formCategoria.$dirty = false;
                        $scope.forms.formCategoria.$setPristine();
                    });
                } else {
                    if ($scope.forms.formCategoria.$valid) {
                        proximoStep = true;
                    }
                }

                return proximoStep;
            };

            $scope.validateIntervalo = function () {
                const alterado = $scope.isNew ? false : $scope.forms.formIntervalos.$dirty;
                let proximoStep = false;
                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formIntervalos.$dirty = false;
                        $scope.forms.formIntervalos.$setPristine();
                    });
                } else {
                    if ($scope.forms.formIntervalos.$valid) {
                        proximoStep = true;
                    }
                }
                return proximoStep;
            };

            function deleteDetalhe(data) {
                if (!$scope.isNew) {
                    return RamalStatusResourceDetalhe.delete({
                        RamalStatusDetalheId: data.RamalStatusDetalheId
                    }).$promise
                        .then(() => {
                            carregaIntervalo();
                            mensagemSucesso();
                        }).catch(NotifyService.showError);
                } else {
                    if ($scope.ramalStatusList) {
                        $scope.ramalStatusList.splice($scope.ramalStatusList.indexOf(data), 1);
                    }
                }
            }

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteDetalhe(data));
            }

            $scope.disableIntervalo = function (ramalStatusDetalheId, ramalStatus) {
                if (ramalStatusDetalheId > 0) {
                    RamalStatusResourceDetalhe.get({ RamalStatusDetalheId: ramalStatusDetalheId }).$promise
                        .then((ramalStatusDetalhe) => {
                            if (!ramalStatus.Ativo) {
                                ramalStatusDetalhe.Ativo = false;
                            }
                            else {
                                ramalStatusDetalhe.Ativo = true;
                            }
                            RamalStatusResourceDetalhe.update(ramalStatusDetalhe).$promise
                                .then(mensagemSucesso)
                                .catch(NotifyService.showError);
                        }).catch(NotifyService.showError);
                }
            }

            //Grupos
            $scope.gruposAdicionados = [];
            $scope.grupos = [];
            $scope.limitGrupos = 5;
            $scope.limitGruposAdicionados = 5;
            $scope.searchGrupos = { disponivel: '', adicionado: '' };

            $scope.filtrarGrupoNaoAdicionado = function (item) {
                if (!$scope.searchGrupos.disponivel) return true;
                var termo = $scope.searchGrupos.disponivel.toLowerCase();
                return (item.Descricao && item.Descricao.toLowerCase().indexOf(termo) >= 0) ||
                       (item.GrupoId && item.GrupoId.toString() === $scope.searchGrupos.disponivel);
            };

            $scope.filtrarGrupoAdicionado = function (item) {
                if (!$scope.searchGrupos.adicionado) return true;
                var termo = $scope.searchGrupos.adicionado.toLowerCase();
                return (item.Descricao && item.Descricao.toLowerCase().indexOf(termo) >= 0) ||
                       (item.GrupoId && item.GrupoId.toString() === $scope.searchGrupos.adicionado);
            };

            function salvarGrupo (form) {
                const allpromises = [];
                if (form.$dirty) {
                    if ($scope.gruposAdicionados.length) {
                        const gruposAdicionados = _.where($scope.gruposAdicionados, { Alterado: true });

                        gruposAdicionados.forEach(value => {
                            allpromises.push(CategoriaIntervaloResource.adicionarGrupo({
                                CategoriaIntervaloId: $scope.categoriaIntervalo.CategoriaIntervaloId,
                                GrupoId: value.GrupoId,
                            }).$promise);
                        });
                    }

                    if ($scope.grupos.length) {
                        const grupos = _.where($scope.grupos, { Alterado: true });

                        grupos.forEach(value => {
                            allpromises.push(CategoriaIntervaloResource.removerGrupo({
                                CategoriaIntervaloId: $scope.categoriaIntervalo.CategoriaIntervaloId,
                                GrupoId: value.GrupoId,
                            }).$promise);
                        });
                    }
                }
                return allpromises;
            }

            //Grupos
            $scope.getGruposNaoAssociados = function () {
                const categoriaId = (categoriaIntervalo.CategoriaIntervaloId > 0 ? categoriaIntervalo.CategoriaIntervaloId :
                    (isNaN(parseInt($stateParams.CategoriaIntervaloId)) ? 0 : parseInt($stateParams.CategoriaIntervaloId)));

                CategoriaIntervaloResource.getGrupoLivre({ categoriaId: categoriaId }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.grupos);
                    });
            };

            //Grupos Associados
            $scope.getGruposAssociados = function () {
                const categoriaId = (categoriaIntervalo.CategoriaIntervaloId > 0 ? categoriaIntervalo.CategoriaIntervaloId :
                    (isNaN(parseInt($stateParams.CategoriaIntervaloId)) ? 0 : parseInt($stateParams.CategoriaIntervaloId)));
                CategoriaIntervaloResource.getGrupoReservado({ categoriaId: categoriaId }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.gruposAdicionados);
                    });
            };

            $scope.adicionarGrupo = function () {
                const gruposSelecionados = _.where($scope.grupos, { Selecionado: true });

                if (gruposSelecionados.length > 0) {
                    angular.forEach(gruposSelecionados, (item) => {
                        if ($scope.grupos) $scope.grupos.splice($scope.grupos.indexOf(item), 1);
                        item.Alterado = true;
                        $scope.gruposAdicionados.push(item);
                    });

                    if ($scope.forms.formGrupos)
                        $scope.forms.formGrupos.$dirty = true;
                } else {
                    NotifyService.showError(null, 'telaRamalStatusEdit.selecioneUmGrupoASerAdicionado')
                }
            };

            $scope.removerGrupo = function () {
                const gruposSelecionados = _.where($scope.gruposAdicionados, { Selecionado: true });

                if (gruposSelecionados.length > 0) {
                    angular.forEach(gruposSelecionados, (item) => {
                        item.Alterado = true;
                        if ($scope.gruposAdicionados) $scope.gruposAdicionados.splice($scope.gruposAdicionados.indexOf(item), 1);
                        $scope.grupos.push(item);
                    });
                    if ($scope.forms.formGrupos) {
                        $scope.forms.formGrupos.$dirty = true;
                    }
                }
                else {
                    NotifyService.showInvalid(null, 'telaRamalStatusEdit.selecioneUmGrupoASerRemovido');
                }
            };

            $scope.selectionarTodosAdicionados = function (itensAdicionados) {
                var lista = $scope.searchGrupos.adicionado
                    ? $scope.gruposAdicionados.filter($scope.filtrarGrupoAdicionado)
                    : $scope.gruposAdicionados;
                angular.forEach(lista, (item) => {
                    item.Selecionado = !!itensAdicionados;
                });
            };

            $scope.selectionarTodosNaoAdicionados = function (itensNaoAdicionados) {
                var lista = $scope.searchGrupos.disponivel
                    ? $scope.grupos.filter($scope.filtrarGrupoNaoAdicionado)
                    : $scope.grupos;
                angular.forEach(lista, (item) => {
                    item.Selecionado = !!itensNaoAdicionados;
                });
            };

            $scope.maisGruposAdicionados = function () {
                if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
                    $scope.limitGruposAdicionados += 5;
                    $("#gruposAdicionados").animate({
                        scrollTop: $("#tabGruposAdicionados").height()
                    }, 800);
                }
            };

            $scope.maisGruposNaoAdicionados = function () {
                if ($scope.limitGrupos < $scope.grupos.length) {
                    $scope.limitGrupos += 5;
                    $("#gruposNaoAdicionados").animate({
                        scrollTop: $("#tabGruposNaoAdicionados").height()
                    }, 800);
                }
            };

            $("#gruposAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitGruposAdicionados < $scope.gruposAdicionados.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitGruposAdicionados += 5;
                            $("#gruposAdicionados").animate({
                                scrollTop: $("#tabGruposAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            $("#gruposNaoAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
                if ($scope.limitGrupos < $scope.grupos.length) {
                    $scope.$apply(() => {
                        if (e.originalEvent.wheelDelta / 120 < 0) {
                            $scope.limitGrupos += 5;
                            $("#gruposNaoAdicionados").animate({
                                scrollTop: $("#tabGruposNaoAdicionados").height()
                            }, 800);
                        }
                    });
                }
            });

            $scope.getGruposNaoAssociados();
            $scope.getGruposAssociados();
        }])
})();

(function () {
	"use strict";

	var defaultPageSize = 15;

	var getOdataSearchShared = function (CategoriaIntervaloResource, search, orderBy, $odata) {
		var filtroGrupoId, odata = CategoriaIntervaloResource.odata();

		if (search.GrupoId) {
			filtroGrupoId = new $odata.Predicate("x:x/GrupoId", parseInt(search.GrupoId)).execute(false, true);
			odata.filter(new $odata.Func('CategoriaIntervaloGrupo/any', new $odata.Property(filtroGrupoId)));
		}
		if (search.Descricao) {
			odata.filter(new $odata.Func("startswith", "Nome", search.Descricao), true);
		}
		odata.orderBy(orderBy.column, orderBy.order);

		return odata;
	};

	angular.module("epbxManagerApp")
		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.ramalstatus", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.ramalstatus.list',
						pageTitle: 'pageTitle.intervaloDosRamais',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.ramalstatus.list", StateResolverProvider.configState("/ramalstatus", "RamalStatus", "List", {
					pageTitle: 'pageTitle.intervaloDosRamais',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("RamalStatusListData", function RamalStatusListData() {
			return function () {
				return {
					categoriaList: ["CategoriaIntervaloResource", "LocalStorageService", "$odata", "$stateParams", function (CategoriaIntervaloResource, LocalStorageService, $odata, $stateParams) {
						var filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroRamalStatus");
						}
						var orderBy = {
							column: "CategoriaIntervaloId",
							order: "asc"
						};
						var odata = getOdataSearchShared(CategoriaIntervaloResource, filtro, orderBy, $odata);
						return odata.page(defaultPageSize, 1).query();
					}],
					grupoList: ["GrupoResource", function (GrupoResource) {
						return GrupoResource.getGrupoSimples().$promise;
					}],
					lazy: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load(['lazy_uiSelect']);
					}],
				}
			}
		})

		.controller("RamalStatusListController", ["$scope", "$odata", "categoriaList", "grupoList", "LocalStorageService", "CategoriaIntervaloResource", "NotifyService", "ModalService", function ($scope, $odata, categoriaList, grupoList, LocalStorageService, CategoriaIntervaloResource,
			NotifyService, ModalService) {
			$scope.search = {};
			$scope.searching = false;
			$scope.categoriaList = categoriaList;
			$scope.grupoList = grupoList;
			$scope.categoriaTrackingList = [];
			$scope.categoriaTrackingListFull = $scope.categoriaTrackingList;

			$scope.paginationTracking = {
				current: 1,
				last: 1,
			};

			$scope.orderBy = {
				column: "CategoriaIntervaloId",
				order: "asc"
			};

			$scope.predicate = '';
			$scope.reverse = false;
			
			$scope.order = function (predicate) {
				$scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
				$scope.predicate = predicate;
			};

			var updateList = function (list) {
				$scope.categoriaList = list;
				$scope.categoriaList.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.categoriaList.pageSize = list.$pageSize || defaultPageSize;
				$scope.searching = false;
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.categoriaList.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			$scope.setCurrentPage = function (newPage) {
				var itensPerPage = ($scope.categoriaTrackingListFull.pageSize || defaultPageSize);
				var begin = ((newPage - 1) * itensPerPage), end = begin + itensPerPage;
				$scope.paginationTracking.current = newPage;
				$scope.categoriaTrackingList.recordCount = $scope.categoriaTrackingListFull.length;
				$scope.categoriaTrackingList.pageSize = $scope.categoriaTrackingListFull.pageSize;
				$scope.categoriaTrackingList.currentPage = newPage;
				$scope.categoriaTrackingList = $scope.categoriaTrackingListFull.slice(begin, end);
			};

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroRamalStatus');
				$scope.search = {
					pageSize: defaultPageSize
				};
			}

			var getOdataSearch = function () {
				return getOdataSearchShared(CategoriaIntervaloResource, $scope.search, $scope.orderBy, $odata);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroRamalStatus', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			$scope.viewTracking = function (categoria) {
				if (categoria.CategoriaIntervaloId > 0)
					CategoriaIntervaloResource.getCategoriaTracking({ categoriaId: categoria.CategoriaIntervaloId }).$promise
						.then((data) => {
							angular.copy(data, $scope.categoriaTrackingList);
							$scope.categoriaTrackingListFull = $scope.categoriaTrackingList;
							$scope.paginationTracking.current = 1;
							$scope.paginationTracking.last = Math.floor($scope.categoriaTrackingList.length / defaultPageSize) + 1;
							$scope.setCurrentPage(1);
							ModalService.openModal('modalTracking');
						}).catch(NotifyService.showError);
			};

			$scope.confirmExecute = function (data) {
				ModalService.confirmMessage('telaRamalStatus.confimaExecucaoProcessamento', null, () => executeIntegracao(data));
			};

			var executeIntegracao = function (categoria) {
				if (categoria.CategoriaIntervaloId > 0)
					CategoriaIntervaloResource.processarCategoria({
						CategoriaIntervaloId: categoria.CategoriaIntervaloId
					}).$promise.then((data) => {
						angular.copy(data, categoria);
						carregaIntervalo(categoria.CategoriaIntervaloId);
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
			};

			var carregaIntervalo = function () {
				CategoriaIntervaloResource.odata().filter('Ativo', true).query()
					.then((result) => {
						angular.copy(result, $scope.categoriaList);
					});
			}

			var deleteRecord = function (data) {
				CategoriaIntervaloResource.delete({ CategoriaIntervaloId: data.CategoriaIntervaloId }).$promise
					.then(() => {
						$scope.pageChanged($scope.currentPage);
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
			}

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			}

			updateList(categoriaList);
		}]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RamalStatusResourceDetalhe", ["$odataresource", function ($odataresource) {
            return $odataresource("RamalStatusDetalhe/:RamalStatusDetalheId",
                {
                    "RamalStatusDetalheId": "@RamalStatusDetalheId"
                },
                {
                    tipo: {
                        method: "GET",
                        url: "RamalStatusDetalhe/RamalStatusTipo",
                        isArray: true
                    },
                    status: {
                        method: "GET",
                        url: "RamalStatusDetalhe/RamalStatus",
                        isArray: true
                    },
                    getStatusDetalhePorGrupo:
                    {
                        method: "GET",
                        url: "RamalStatusDetalhe/StatusDetalhePorGrupo",
                        isArray: true
                    },
                    getStatusDetalhePorUsuario:
                    {
                        method: "GET",
                        url: "RamalStatusDetalhe/StatusDetalhePorUsuario",
                        isArray: true
                    },
                    getStatusDetalhePorRamal:
                    {
                        method: "GET",
                        url: "RamalStatusDetalhe/StatusDetalhePorRamal",
                        isArray: true
                    },
                    getRamalStatusDetalheByCarteira:
                    {
                        method: "GET",
                        url: "RamalStatusDetalhe/RamalStatusDetalheByCarteira",
                        isArray: true
                    },
                    updateStatus:
                    {
                        method: "POST",
                        url: "RamalStatusDetalhe/UpdateStatus"
                    },
                    updateIntervalo: {
                        method: "PUT",
                        url: "RamalStatusDetalhe/UpdateLimiteIntervalo"
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RamalSupervisaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("RamalSupervisao/:RamalId", { "RamalId": "@RamalId" },
                {
                    getSimples: {
                        method: "GET",
                        url: "RamalSupervisao/GetSimples",
                        isArray: true
                    }
                });
        }]);

})();
(function () {
    "use strict";

    let defaultPageSize = 30;

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.regraroteamento.edit", StateResolverProvider.configState("/regraroteamento/{RegraDiscagemId:[0-9]+}", "RegraRoteamento", "Edit", {
                pageTitle: 'pageTitle.regrasDeRoteamento',
                pageName: 'acoes.editar'
            }))
                .state("main.regraroteamento.new", StateResolverProvider.configState("/regraroteamento/new?page", "RegraRoteamento", "Edit", {
                    pageTitle: 'pageTitle.regrasDeRoteamento',
                    pageName: 'acoes.cadastrar'
                }));
        }])

        .service("RegraRoteamentoEditData", function RegraRoteamentoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_parsleyjs',
                            'lazy_masked_inputs',
                            'lazy_uiSelect'
                        ]);
                    }],
                    regraDiscagem: ["RegraRoteamentoResource", "$stateParams", function (RegraRoteamentoResource, $stateParams) {
                        if ($stateParams.RegraDiscagemId) {
                            return RegraRoteamentoResource.get({ RegraDiscagemId: parseInt($stateParams.RegraDiscagemId) }).$promise;
                        } else {
                            return { RegraDiscagemId: 0, Nome: '', Descricao: '', Ativo: true };
                        }
                    }],
                    regraRoteamentoList: ["RegraRoteamentoResource", "$stateParams", function (RegraRoteamentoResource, $stateParams) {
                        if ($stateParams.RegraDiscagemId) {
                            return RegraRoteamentoResource.getAllRegraRoteamento({ RegraDiscagemId: parseInt($stateParams.RegraDiscagemId) }).$promise;
                        } else {
                            return [];
                        }
                    }],
                    rotas: ["RotaResource", function (RotaResource) {
                        return RotaResource.getRotaByRotaTipoIds({ rotaTipoIds: "1,2,3,4" }).$promise;
                    }],
                    classes: ["RegraRoteamentoResource", function (RegraRoteamentoResource) {
                        return RegraRoteamentoResource.getClasse().$promise;
                    }],
                    tipos: ["RegraRoteamentoResource", function (RegraRoteamentoResource) {
                        return RegraRoteamentoResource.getClasseTipo().$promise;
                    }],
                    localidades: ["RegraRoteamentoResource", function (RegraRoteamentoResource) {
                        return RegraRoteamentoResource.getLocalidade().$promise;
                    }],
                    operadoras: ["RegraRoteamentoResource", function (RegraRoteamentoResource) {
                        return RegraRoteamentoResource.getOperadora().$promise;
                    }],
                    ramais: ["RamalResource", function (RamalResource) {
                        return RamalResource.odata().select("RamalId", "Numero", "Usuarios").expand("Usuarios").orderBy("Numero", "asc").query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                }
            }
        })

        .controller("RegraRoteamentoEditController", ["$scope", "$compile", "$state", "$timeout", "$window", "utils", "$stateParams", "regraDiscagem", "regraRoteamentoList", "rotas", "classes", "tipos", "localidades", "operadoras", "AuthService", "RegraRoteamentoResource", "ramais", "NotifyService", "RotaResource", "ModalService", "carteiras", "$translate", function ($scope, $compile, $state, $timeout, $window, utils, $stateParams, regraDiscagem,
            regraRoteamentoList, rotas, classes, tipos, localidades, operadoras, AuthService, RegraRoteamentoResource, ramais, NotifyService, RotaResource,
            ModalService,carteiras, $translate) {
            $scope.rotas = rotas;
            $scope.classes = classes;
            $scope.tipos = tipos;
            $scope.isNew = regraDiscagem.RegraDiscagemId > 0 ? false : true;
            $scope.localidades = localidades;
            $scope.operadoras = operadoras;
            $scope.forms = {};
            $scope.regraDiscagem = regraDiscagem;
            $scope.regraRoteamentoList = regraRoteamentoList;
            var pendingDeletes = [];
            var tempIdCounter = -1;
            $scope.carteiras = carteiras;
            $scope.searchSimulador = {
                Ramal: '',
                NumeroDestino: '',
            };
            
            $scope.ramais = ramais;
            $scope.ramais.forEach((el) => {
                el.RamalNome = (el.Usuarios.length > 0) ? el.Numero + ' - ' + el.Usuarios[0].Nome : el.Numero;
            });

            var usuario = AuthService.getUsuarioLogado();
            if (usuario && usuario.Ramal) {
                $scope.searchSimulador.Ramal = usuario.Ramal.Numero;
            }

            //Ordenar Grid
            $scope.predicate = '';
            $scope.reverse = false;
            $scope.order = function (predicate) {
                $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
                $scope.predicate = predicate;
            };

            function analiseRota(){
                setTimeout(() => {
                    $scope.regraRoteamentoList.filter(rota => rota.RegraRoteamentoId > 0).forEach(rota => {
                        RotaResource.AnalisaCanalRota({ canalI: rota.CanalI, canalF: rota.CanalF, id: rota.RotaId }).$promise
                        .then((data) => {
    
                            if (data.length > 0) {                
                                rota.Conflito = true;
                            }else{
                                rota.Conflito = false;
                            }
                            rota.ConflitoList = data;
                            rota.ConflitoTitle = $translate.instant('telaEditRegras.analiseCanaisRota',{ 'Inicio': rota.CanalI, 'Final': rota.CanalF, 'Canais': rota.ConflitoList.map(x => x.Nome).join(", ")})
                        });
                    })
                }, 100);
            }

            var limparRoteamento = function () {
                $scope.roteamentoNovo = {
                    RegraRoteamentoId: 0,
                    RegraDiscagemId: 0,
                    RotaId: null,
                    ClasseTipoId: null,
                    ClasseId: null,
                    OperadoraId: null,
                    DDD: 0,
                    Ddds: null,
                    Ativo: true,
                    Ordem: 0,
                    Contem: true, // false = nao completa as chamadas nesse cenário true = completa as ligações no cenário informado
                    ScoreBigTalkInicial: null,
                    ScoreBigTalkFinal: null
                };
            };

            var adicionaLocalStorage = function (nome, data) {
                if ((localStorage.length === 0) || (localStorage.getItem(nome) != JSON.stringify(data))) {
                    localStorage.setItem(nome, JSON.stringify(data));
                }
            };

            var retornaRoteamentoOrdenado = function (novoRoteamento) {
                let regraObj = novoRoteamento;
                let listaRoteamentoNovo = [];
                if (regraObj.length) {
                    angular.forEach(regraObj, (val, index) => {
                        let regraNova = _.findWhere($scope.regraRoteamentoList, {
                            RegraRoteamentoId: val.id
                        });
                        regraNova.Ordem = val.ordem ? val.ordem : index + 1;
                        listaRoteamentoNovo.push(regraNova);
                    });
                }

                return listaRoteamentoNovo;
            };

            var reordenaRoteamento = function () {
                let $nestable = $('#nestable');
                let regra_nova = $nestable.data("nestable").serialize();

                if (utils.lsTest()) {
                    localStorage.removeItem('regra_nova');
                    adicionaLocalStorage("regra_nova", regra_nova);
                    let listaRoteamentoNovo = retornaRoteamentoOrdenado(regra_nova);
                    $scope.regraRoteamentoList = listaRoteamentoNovo;
                    $scope.$apply();

                    if (!$('#restore_nestable').length) {
                        let buttons = `<a class="md-btn" id="restore_nestable">${$translate.instant('telaEditRegras.restaurar')}</a><a class="md-btn md-btn-primary" 
                        id="save_nestable" ng-click="salvarRegraRoteamento()">${$translate.instant('botao.salvar')}</a>`;
                        $nestable.after($compile(buttons)($scope));
                    }
                }
            };

            $scope.viewDetalheRegra = function (roteamento) {
                let msg = `<h2>${$translate.instant('campo.detalhe')}: ${roteamento.RotaNome}</h2></br>${
                    $translate.instant((roteamento.Contem ? 'telaEditRegras.todasAsChamadasQueObedeceremARegra' : 'telaEditRegras.todasAsChamadasQueNaoObedeceremARegra'))}
				${$translate.instant('telaEditRegras.seraoProcessadasPelaRota')}`;
                ModalService.alert(msg);
            };

            $scope.validateRegra = function () {
                let proximoStep = false;

                if ($scope.regraDiscagem) proximoStep = !(!$scope.regraDiscagem.Nome || 0 === $scope.regraDiscagem.Nome.length);

                // Inicializa o componente de drag and drop
                if (proximoStep) {
                    let $nestable = $('#nestable');
                    localStorage.removeItem('regra_nova')

                    if ($nestable.length) {
                        let regra_original = [];
                        angular.forEach($scope.regraRoteamentoList, (value) => {
                            regra_original.push({ id: value.RegraRoteamentoId, ordem: value.Ordem });
                        });

                        localStorage.removeItem('regra_original');
                        adicionaLocalStorage('regra_original', regra_original);

                        $nestable.on('change.uk.nestable', () => {
                            reordenaRoteamento();
                        });

                        $('body').on('click', '#restore_nestable', () => {
                            if ($('#restore_nestable').length) {
                                $("#restore_nestable").remove();
                            }
                            if ($('#save_nestable').length) {
                                $("#save_nestable").remove();
                            }
                            localStorage.removeItem('regra_nova');
                            carregaRegraRoteamento();
                        })
                    }
                }

                return proximoStep;
            };

            $scope.adicionarRota = function () {
                limparRoteamento();
                ModalService.openModal('modalRoteamento');
                $timeout(() => {
                    if ($scope.forms.formRoteamento) {
                        $scope.forms.formRoteamento.$setPristine();
                        $scope.forms.formRoteamento.Rota.$setUntouched();
                    }
                }, 100);
            };

            $scope.viewSimulador = function () {
                ModalService.openModal('modalSimulador');
                $scope.simuladorList = [];
                $scope.regraNome = $translate.instant('telaEditRegras.geral');
                $scope.searchSimulador.NumeroDestino = '';

                let $maskedInput = $('.masked_input');
                if ($maskedInput) {
                    $maskedInput.val('');
                    $maskedInput.inputmask();
                }
            };

            var updateListSimulador = function (list) {
                $scope.simuladorList = list;
                $scope.simuladorList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.simuladorList.pageSize = list.$pageSize || defaultPageSize;
            };

            $scope.executeSimulador = function (valid) {
                if (!valid) {
                    return NotifyService.showInvalid();
                }

                let numeroDestino = $scope.searchSimulador.NumeroDestino.replace(/[^\w]/gi, '');

                if (numeroDestino.length < 10 || numeroDestino.length > 11) {
                    return ModalService.alert('telaEditRegras.oNumeroDeDestinoNaoPodeSerMenorQue10');
                }

                $scope.simulando = true;
                RegraRoteamentoResource.getRoteamentoSimulador({
                    numeroRamal: parseInt($scope.searchSimulador.Ramal),
                    NumeroDestino: numeroDestino,
                }).$promise.then((result) => {
                    $scope.simulando = false;
                    updateListSimulador(result);
                })
            };

            $scope.salvarRoteamento = function (valid) {
                if (!valid) return NotifyService.showInvalid();

                if ($scope.roteamentoNovo.RotaId <= 0) {
                    return NotifyService.showError(null, 'telaEditRegras.selecioneUmaRotaASerConfigurada');
                }

                let rota = angular.copy($scope.roteamentoNovo);
                rota.RegraDiscagemId = regraDiscagem.RegraDiscagemId;

                // Popula nomes para exibição na grid
                let rotaSelecionada = _.findWhere($scope.rotas, { RotaId: parseInt(rota.RotaId) });
                if (rotaSelecionada) {
                    rota.RotaNome = rotaSelecionada.Nome;
                    rota.CanalI = rotaSelecionada.CanalI;
                    rota.CanalF = rotaSelecionada.CanalF;
                    rota.RotaBloqueada = rotaSelecionada.Bloqueada;
                }

                let operadora = _.findWhere(operadoras, { OperadoraId: parseInt(rota.OperadoraId) });
                rota.OperadoraNome = operadora ? operadora.Nome : null;

                let classeTipo = _.findWhere(tipos, { ClasseTipoId: parseInt(rota.ClasseTipoId) });
                rota.ClasseTipoDescricao = classeTipo ? classeTipo.Descricao : null;

                let classe = _.findWhere(classes, { ClasseId: parseInt(rota.ClasseId) });
                rota.ClasseDescricao = classe ? classe.Descricao : null;

                if (!rota.Ddds) rota.Ddds = [];

                if (rota.RegraRoteamentoId > 0 || rota.RegraRoteamentoId < 0) {
                    // Edição: atualiza o item existente na lista local
                    let index = _.findIndex($scope.regraRoteamentoList, function(r) {
                        return r.RegraRoteamentoId === rota.RegraRoteamentoId;
                    });
                    if (index >= 0) $scope.regraRoteamentoList[index] = rota;
                } else {
                    // Novo: gera ID temporário e adiciona à lista local
                    rota.RegraRoteamentoId = tempIdCounter--;
                    rota.Ordem = $scope.regraRoteamentoList.length + 1;
                    $scope.regraRoteamentoList.push(rota);
                }

                ModalService.closeModal('modalRoteamento');
                mensagemSucesso();
            };

            var validarCoberturaBigTalk = function () {
                let regrasComScore = $scope.regraRoteamentoList.filter(r =>
                    r.ScoreBigTalkInicial != null && r.ScoreBigTalkFinal != null);

                if (regrasComScore.length === 0) return true;

                // Ordena pelos valores iniciais para verificar cobertura sequencial
                let intervalos = regrasComScore
                    .map(r => ({ inicio: r.ScoreBigTalkInicial, fim: r.ScoreBigTalkFinal }))
                    .sort((a, b) => a.inicio - b.inicio);

                // O primeiro intervalo deve começar em 0
                if (intervalos[0].inicio !== 0) {
                    let msg = $translate.instant('telaEditRegras.scoreBigTalkCoberturaIncompleta');
                    ModalService.alert(msg);
                    return false;
                }

                // Percorre verificando que não há buracos entre intervalos consecutivos
                let cobertoAte = intervalos[0].fim;
                for (let i = 1; i < intervalos.length; i++) {
                    // O próximo intervalo deve começar no máximo em cobertoAte + 1
                    if (intervalos[i].inicio > cobertoAte + 1) {
                        let msg = $translate.instant('telaEditRegras.scoreBigTalkCoberturaIncompleta');
                        ModalService.alert(msg);
                        return false;
                    }
                    // Expande a cobertura se este intervalo vai além
                    if (intervalos[i].fim > cobertoAte) {
                        cobertoAte = intervalos[i].fim;
                    }
                }

                // O último valor coberto deve ser 100
                if (cobertoAte !== 100) {
                    let msg = $translate.instant('telaEditRegras.scoreBigTalkCoberturaIncompleta');
                    ModalService.alert(msg);
                    return false;
                }

                return true;
            };

            var persistirRoteamentos = function () {
                let promises = [];

                // Deletar rotas removidas do banco
                pendingDeletes.forEach(function(r) {
                    promises.push(RegraRoteamentoResource.deleteRegra(r).$promise);
                });

                // Inserir/atualizar cada rota da lista
                $scope.regraRoteamentoList.forEach(function(r) {
                    r.RegraDiscagemId = regraDiscagem.RegraDiscagemId;
                    if (r.RegraRoteamentoId < 0) {
                        // Rota nova (ID temporário) → inserir
                        r.RegraRoteamentoId = 0;
                        promises.push(RegraRoteamentoResource.inserirRegraRoteamento(r).$promise);
                    } else {
                        // Rota existente → atualizar
                        promises.push(RegraRoteamentoResource.alterarRegraRoteamento(r).$promise);
                    }
                });

                return Promise.all(promises).then(function() {
                    pendingDeletes = [];
                    carregaRegraRoteamento();
                }).catch(NotifyService.showError);
            };

            $scope.validateRoteamento = function () {
                if ($scope.regraRoteamentoList.length === 0) return false;
                return validarCoberturaBigTalk();
            };

            $scope.salvarRegraRoteamento = function () {
                if ($scope.regraRoteamentoList == 0)
                    return

                if (!validarCoberturaBigTalk()) return;

                persistirRoteamentos().then(function() {
                    mensagemSucesso();
                    if ($('#restore_nestable').length && $('#save_nestable').length) {
                        $("#restore_nestable").remove();
                        $("#save_nestable").remove();
                    } else {
                        $state.go('main.regraroteamento.list', { storage: true });
                    }
                });
            };

            var carregaRegraRoteamento = function () {
                let regraId = $stateParams.RegraDiscagemId ? parseInt($stateParams.RegraDiscagemId) : 0;

                RegraRoteamentoResource.getAllRegraRoteamento({ regraDiscagemId: regraId }).$promise
                    .then((response) => {
                        angular.copy(response, $scope.regraRoteamentoList);
                        pendingDeletes = [];
                        tempIdCounter = -1;
                        analiseRota();
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    })
            };

            $scope.adicionarRegra = function (valid) {
                $scope.submitted = true;
                if (!valid) return NotifyService.showInvalid();

                let promise;

                if ($scope.regraDiscagem.RegraDiscagemId > 0) {
                    promise = RegraRoteamentoResource.update($scope.regraDiscagem).$promise;
                }
                else {
                    promise = RegraRoteamentoResource.save($scope.regraDiscagem).$promise;
                }
                promise.then((data) => {
                    angular.copy(data, $scope.regraDiscagem);
                    $stateParams.RegraDiscagemId = data.RegraDiscagemId;
                    mensagemSucesso();
                }).catch(NotifyService.showError);
            };

            $scope.changeClasseTipo = function (classeTipoId) {
                if (classeTipoId) {
                    $scope.classes = _.where(classes, { ClasseTipoId: parseInt(classeTipoId) });
                }
            };

            $scope.editRoteamento = function (roteamento) {
                $scope.forms.formRoteamento.$setPristine();
                limparRoteamento();
                if (roteamento) {
                    angular.copy(roteamento, $scope.roteamentoNovo);
                    ModalService.openModal('modalRoteamento');
                }
            };

            $scope.deleteRoteamento = function (roteamento) {
                if ($scope.regraRoteamentoList.length < 3) {
                    $('#restore_nestable').remove();
                    $('#save_nestable').remove();
                }

                // Se existia no banco (ID positivo), marcar para deletar no flush
                if (roteamento.RegraRoteamentoId > 0) {
                    pendingDeletes.push(roteamento);
                }

                // Remove da lista local
                let index = $scope.regraRoteamentoList.indexOf(roteamento);
                if (index >= 0) $scope.regraRoteamentoList.splice(index, 1);
            };

            $scope.finalizarCadastro = function () {
                if (!validarCoberturaBigTalk()) return;

                persistirRoteamentos().then(function() {
                    if ($stateParams.page)
                        $state.go($stateParams.page, { storage: true });
                    else
                        $state.go('main.regraroteamento.list', { storage: true });
                });
            };

            // #region [ Grupos ] 

            $scope.gruposAdicionados = [];
            $scope.grupos = [];
            $scope.limitGrupos = 5;
            $scope.limitGruposAdicionados = 5;

            $scope.getGruposNaoAssociados = function () {
                RegraRoteamentoResource.getRegraGrupoNaoAssociada({ regraId: $scope.getRegraId() }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.grupos);
                    });
            };

            $scope.getGruposAssociados = function () {
                RegraRoteamentoResource.getRegraGrupoAssociada({ regraId: $scope.getRegraId() }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.gruposAdicionados);
                    });
            };

            $scope.adicionarGrupo = function () {
                let gruposSelecionados = _.where($scope.grupos, { Selecionado: true });

                if (gruposSelecionados.length > 0) {
                    ModalService.showLoading();

                    let list = gruposSelecionados.map((item) => {
                        return item.GrupoId;
                    });

                    RegraRoteamentoResource.adicionarGrupo({ RegraId: $scope.getRegraId(), Grupos: list.join(',') })
                        .$promise
                        .then(() => {
                            $scope.getGruposNaoAssociados();
                            $scope.getGruposAssociados();
                            ModalService.hideLoading();
                        }).catch((erro) => {
                            NotifyService.showError(erro);
                            ModalService.hideLoading();
                        });
                } else {
                    NotifyService.showError(null, 'telaEditRegras.selecioneUmGrupoASerAdicionado');
                }
            };

            $scope.removerGrupo = function () {
                let gruposSelecionados = _.where($scope.gruposAdicionados, { Selecionado: true });
                if (gruposSelecionados.length > 0) {
                    ModalService.showLoading();
                    let list = gruposSelecionados.map((item) => {
                        return item.GrupoId;
                    });

                    RegraRoteamentoResource.removerGrupo({ RegraId: $scope.getRegraId(), Grupos: list.join(',') })
                        .$promise
                        .then(() => {
                            $scope.getGruposNaoAssociados();
                            $scope.getGruposAssociados();
                            ModalService.hideLoading();
                        }).catch((erro) => {
                            NotifyService.showError(erro);
                            ModalService.hideLoading();
                        });
                } else {
                    NotifyService.showError(null, 'telaEditRegras.selecioneUmGrupoASerRemovido');
                }
            };

            // #endregion [ Grupos ] 
            // #region [ Campanhas ] 

            $scope.campanhasAdicionadas = [];
            $scope.campanhas = [];
            $scope.limitCampanhas = 5;
            $scope.limitCampanhasAdicionadas = 5;

            $scope.getCampanhasNaoAssociadas = function () {
                RegraRoteamentoResource.getRegraCampanhaNaoAssociada({ regraId: $scope.getRegraId() }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.campanhas);
                    });
            };

            $scope.getCampanhasAssociadas = function () {
                RegraRoteamentoResource.getRegraCampanhaAssociada({ regraId: $scope.getRegraId() }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.campanhasAdicionadas);
                    });
            };

            $scope.adicionarCampanha = function () {
                let campanhasSelecionadas = _.where($scope.campanhas, { Selecionado: true });
                if (campanhasSelecionadas.length > 0) {
                    ModalService.showLoading();
                    let list = campanhasSelecionadas.map((item) => {
                        return item.CampanhaId;
                    });
                    RegraRoteamentoResource.adicionarCampanha({ RegraId: $scope.getRegraId(), Campanhas: list.join(',') }).$promise
                        .then(() => {
                            $scope.getCampanhasNaoAssociadas();
                            $scope.getCampanhasAssociadas();
                            ModalService.hideLoading();
                        }).catch((erro) => {
                            NotifyService.showError(erro);
                            ModalService.hideLoading();
                        });
                } else {
                    NotifyService.showError(null, 'telaEditRegras.selecioneUmaCampanhaASerAdicionada');
                }
            };

            $scope.removerCampanha = function () {
                let campanhasSelecionadas = _.where($scope.campanhasAdicionadas, { Selecionado: true });
                if (campanhasSelecionadas.length > 0) {
                    ModalService.showLoading();
                    let list = campanhasSelecionadas.map((item) => {
                        return item.CampanhaId;
                    });

                    RegraRoteamentoResource.removerCampanha({ RegraId: $scope.getRegraId(), Campanhas: list.join(',') })
                        .$promise
                        .then(() => {
                            $scope.getCampanhasNaoAssociadas();
                            $scope.getCampanhasAssociadas();
                            ModalService.hideLoading();
                        }).catch((erro) => {
                            NotifyService.showError(erro);
                            ModalService.hideLoading();
                        });

                } else {
                    NotifyService.showError(null, 'telaEditRegras.selecioneUmaCampanhaASerRemovida');
                }
            };

            // #endregion [ Campanhas ] 

            // #region [ Úteis ] 

            $scope.getRegraId = function () {
                return ($scope.regraDiscagem.RegraDiscagemId > 0 ? $scope.regraDiscagem.RegraDiscagemId : (isNaN(parseInt($stateParams.RegraDiscagemId)) ? 0 : parseInt($stateParams.RegraDiscagemId)));
            };

            $scope.selecionarTodos = function (itens, campo) {
                angular.forEach($scope[campo], (item) => {
                    if (itens) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.mais = function (nome, limite, campo) {
                if ($scope[limite] < $scope[campo].length) {
                    $scope[limite] += 5;
                    $("#" + nome).animate({
                        scrollTop: $("#tab" + nome).height()
                    }, 800);
                }
            };

            $scope.BindDOMMouseScroll = function (nome, limite, campo) {
                $("#" + nome).bind("DOMMouseScroll mousewheel", (e) => {
                    if ($scope[limite] < $scope[campo].length) {
                        $scope.$apply(() => {
                            if (e.originalEvent.wheelDelta / 120 < 0) {
                                $scope[limite] += 5;
                                $("#gruposNaoAdicionados").animate({
                                    scrollTop: $("#tab" + nome).height()
                                }, 800);
                            }
                        });
                    }
                });
            };

            $scope.BindDOMMouseScroll('GruposAdicionados', 'limitGruposAdicionados', 'gruposAdicionados');
            $scope.BindDOMMouseScroll('GruposNaoAdicionados', 'limitGrupos', 'grupos');

            var mensagemSucesso = function () {
                NotifyService.showRegistroSalvo();
                if ($scope.novo) {
                    $scope.ramalStatusEdit = {};
                }
                $scope.submitted = false;
            };

            $scope.pesquisaGrupos = function (searchGrupos, length, lengthAdicionados) {
				let lengthTotal = $scope.grupos.length;
				let lengthAdicionadosTotal = $scope.gruposAdicionados.length;
				if (searchGrupos.length > 0) {
					if (lengthTotal != length) {
						$scope.limitGrupos = lengthTotal;
					}

					if (lengthAdicionadosTotal != lengthAdicionados) {
						$scope.limitGruposAdicionados = lengthAdicionadosTotal;
					}
				}
				else {
					$scope.limitGrupos = 5;
					$scope.limitGruposAdicionados = 5;
				}
            };
            
            $scope.pesquisaCampanhas = function (searchCampanhas, length, lengthAdicionadas) {
				let lengthTotal = $scope.campanhas.length;
				let lengthAdicionadasTotal = $scope.campanhasAdicionadas.length;
				if (searchCampanhas.length > 0) {
					if (lengthTotal != length) {
						$scope.limitCampanhas = lengthTotal;
					}

					if (lengthAdicionadasTotal != lengthAdicionadas) {
						$scope.limitCampanhasAdicionadas = lengthAdicionadasTotal;
					}
				}
				else {
					$scope.limitCampanhas = 5;
					$scope.limitCampanhasAdicionadas = 5;
				}
			};


            // #endregion [ Úteis ] 
            analiseRota();
            $scope.getGruposNaoAssociados();
            $scope.getGruposAssociados();
            $scope.getCampanhasNaoAssociadas();
            $scope.getCampanhasAssociadas();
        }])
})();
(function () {
	"use strict";

	var defaultPageSize = 15;

	var getOdataSearchShared = function (RegraRoteamentoResource, search, orderBy, $odata) {
		var filtroRegraId, odata = RegraRoteamentoResource.odata();

		if (search.RotaId) {
			filtroRegraId = new $odata.Predicate("x:x/RotaId", parseInt(search.RotaId)).execute(false, true);
			odata.filter(new $odata.Func('RegraRoteamento/any', new $odata.Property(filtroRegraId)));
		}

		if (search.Descricao) {
			odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
		}
		if (search.Id) {
			odata.filter("CarteiraId", "=", parseInt(search.Id));
		}

		odata.orderBy(orderBy.column, orderBy.order);

		return odata;
	};

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.regraroteamento", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.regraroteamento.list',
						pageTitle: 'pageTitle.regrasDeRoteamento',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.regraroteamento.list", StateResolverProvider.configState("/regraroteamento", "RegraRoteamento", "List", {
					pageTitle: 'pageTitle.regrasDeRoteamento',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("RegraRoteamentoListData", function RegraRoteamentoListData() {
			return function () {
				return {
					regraList: ["RegraRoteamentoResource", "LocalStorageService", "$odata", "$stateParams", function (RegraRoteamentoResource, LocalStorageService, $odata, $stateParams) {
						var filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroRegraRoteamento");
						}
						var orderBy = {
							column: "RegraDiscagemId",
							order: "asc"
						};
						var odata = getOdataSearchShared(RegraRoteamentoResource, filtro, orderBy, $odata);
						return odata.page(defaultPageSize, 1).query();
					}],
					rotaList: ["RotaResource", function (RotaResource) {
						return RotaResource.odata()
							.filter("RotaTipoId", "!=", 6)
							.query();
					}],
					lazy: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load(['lazy_masked_inputs', 'lazy_uiSelect']);
					}],
					ramais: ["RamalResource", function (RamalResource) {
						return RamalResource.odata().select("RamalId", "Numero", "Usuarios").expand("Usuarios").orderBy("Numero", "asc").query();
					}],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
				}
			}
		})

		.controller("RegraRoteamentoListController", ["$scope", "$odata", "regraList", "rotaList", "carteiras", "LocalStorageService", "AuthService", "RegraRoteamentoResource", "ramais", "NotifyService", "$translate", "ModalService", function ($scope, $odata, regraList, rotaList, carteiras, LocalStorageService, AuthService, RegraRoteamentoResource, ramais,
			NotifyService, $translate, ModalService) {
			$scope.search = {};
			$scope.forms = {};
			$scope.rotaList = rotaList;
			$scope.regraList = regraList;
			$scope.simulando = false;
			$scope.searching = false;
			$scope.ramais = ramais;			
			$scope.carteiras=carteiras;

			$scope.ramais.forEach((el) => {
				if (el.Usuarios.length > 0) {
					el.RamalNome = el.Numero + ' - ' + el.Usuarios[0].Nome;
				} else {
					el.RamalNome = el.Numero;
				}
			});

			$scope.orderBy = {
				column: "RegraDiscagemId",
				order: "asc"
			};

			$scope.searchSimulador = {
				Ramal: '',
				NumeroDestino: '',
			};

			var usuario = AuthService.getUsuarioLogado();

			if (usuario && usuario.Ramal) {
				$scope.searchSimulador.Ramal = usuario.Ramal.Numero;
			}

			var updateList = function (list) {
				$scope.regraList = list;
				$scope.regraList.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.regraList.pageSize = list.$pageSize || defaultPageSize;
				$scope.searching = false;
			};

			$scope.pageChanged = function (newPage) {
				ModalService.showLoading();
				return getOdataSearch().page($scope.regraList.pageSize, newPage).query()
					.then((list) => {
						updateList(list);
						ModalService.hideLoading();
					}).catch((error) => {
						NotifyService.showError(error);
						ModalService.hideLoading();
					});
			};

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroRegraRoteamento');
				$scope.search = {
					pageSize: defaultPageSize
				};
				$scope.executeSearch();
			}

			var getOdataSearch = function () {
				return getOdataSearchShared(RegraRoteamentoResource, $scope.search, $scope.orderBy, $odata);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroRegraRoteamento', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			var deleteRecord = function (data) {
				RegraRoteamentoResource.delete({ RegraDiscagemId: data.RegraDiscagemId }).$promise
					.then(() => {
						$scope.pageChanged($scope.currentPage);
						NotifyService.showSuccess();
					}).catch(NotifyService.showError);
			}

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			}

			updateList(regraList);

			$scope.viewSimulador = function () {
				ModalService.openModal('modalSimulador');
				$scope.simulando = false;
				$scope.simuladorList = [];
				$scope.bloqueioList = [];
				$scope.forms.formSimulador.$setPristine();
				$scope.regraNome = $translate.instant('telaRegraRoteamento.geral');
				$scope.searchSimulador.NumeroDestino = '';
				var $maskedInput = $('.masked_input');
				if ($maskedInput.length) {
					$maskedInput.val('');
					$maskedInput.inputmask();
				}
			};

			var updateListSimulador = function (list) {
				$scope.simuladorList = list;
				$scope.simuladorList.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.simuladorList.pageSize = list.$pageSize || defaultPageSize;
				$scope.simulando = false;
			};

			var updateListBloqueio = function (list) {
				$scope.bloqueioList = list;
				$scope.bloqueioList.recordCount = list.$recordCount || list.length;
				$scope.currentPageBloqueio = list.$currentPage || 1;
				$scope.bloqueioList.pageSize = list.$pageSize || defaultPageSize;
				$scope.simulando = false;
			};


			$scope.executeSimulador = function (valid) {
				if (!valid) {
					return NotifyService.showInvalid();
				}

				var numeroDestino = $scope.searchSimulador.NumeroDestino.replace(/[^\w]/gi, '');

				if (numeroDestino.length < 10 || numeroDestino.length > 11) {
					return ModalService.alert('telaRegraRoteamento.oNumeroDeDestinoNaoPodeSerMenorQue10')
				}

				$scope.simulando = true;

				RegraRoteamentoResource.getRoteamentoSimulador({
					numeroRamal: parseInt($scope.searchSimulador.Ramal),
					NumeroDestino: numeroDestino,
				}).$promise
					.then(updateListSimulador)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.simulando = false;
					});

				RegraRoteamentoResource.getBloqueioNumero({ Numero: numeroDestino }).$promise
					.then(updateListBloqueio)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.simulando = false;
					});
			}

		}]);
})
	();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RegraRoteamentoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("RegraDiscagem/:RegraDiscagemId",
                {
                    "RegraDiscagemId": "@RegraDiscagemId"
                },
                {
                    getOperadora: { url: "RegraDiscagem/Operadora", method: "GET", isArray: true },
                    getLocalidade: { url: "RegraDiscagem/Localidade", method: "GET", isArray: true },
                    getClasse: { url: "RegraDiscagem/Classe", method: "GET", isArray: true },
                    getClasseTipo: { url: "RegraDiscagem/ClasseTipo", method: "GET", isArray: true },
                    getRegraGrupoAssociada: { url: "RegraDiscagem/RegraGrupoAssociada", method: "GET", isArray: true },
                    getRegraGrupoNaoAssociada: { url: "RegraDiscagem/RegraGrupoNaoAssociada", method: "GET", isArray: true },
                    getRegraCampanhaAssociada: { url: "RegraDiscagem/RegraCampanhaAssociada", method: "GET", isArray: true },
                    getRegraCampanhaNaoAssociada: { url: "RegraDiscagem/RegraCampanhaNaoAssociada", method: "GET", isArray: true },
                    adicionarGrupo: { url: "RegraDiscagem/AdicionarGrupo", method: "POST" },
                    removerGrupo: { url: "RegraDiscagem/RemoverGrupo", method: "POST" },
                    adicionarCampanha: { url: "RegraDiscagem/AdicionarCampanha", method: "POST" },
                    removerCampanha: { url: "RegraDiscagem/RemoverCampanha", method: "POST" },
                    // RegraRoteamento
                    getAllRegraRoteamento: { url: "RegraDiscagem/Roteamento/GetAllRegraRoteamento", method: "GET", isArray: true },
                    getRoteamentoSimulador: { url: "RegraDiscagem/Roteamento/RoteamentoSimulador", method: "GET", isArray: true },
                    getBloqueioNumero: { url: "RegraDiscagem/Roteamento/BloqueioNumero", method: "GET", isArray: true },
                    updateRotaOrdem: { url: "RegraDiscagem/Roteamento/UpdateRotaOrdem", method: "POST" },
                    deleteRegra: { url: "RegraDiscagem/Roteamento/DeleteItem", method: "POST" },
                    inserirRegraRoteamento: { url: "RegraDiscagem/Roteamento/InserirRegraRoteamento", method: "POST" },
                    alterarRegraRoteamento: { url: "RegraDiscagem/Roteamento/AlterarRegraRoteamento/:id", method: "PUT", params: { "id": "@RegraRoteamentoId" } },
                    deleteRegraByRota: { url: "RegraDiscagem/Roteamento/DeleteRegraRoteamentoByRota", method: "POST" },
                    getRegraByRota: { url: "RegraDiscagem/Roteamento/RegraRoteamentoByRota", method: "GET", isArray: true }
                });
        }]);
})();

(function () {
    "use strict";
    var getOdataSearchShared = function (RelatorioDetalhadoResource, search, orderBy, $odata) {
        var odata = RelatorioDetalhadoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.DataInicio || search.DataFim)
            odata.between("DataEnvio", search.DataInicio, search.DataFim || moment().add(30, 'minutes').seconds(0).milliseconds(0).toDate());

        if (search.Telefone)
            odata.filter(new $odata.Func("startswith", "Telefone", search.Telefone), true);

        if (search.StatusId)
            odata.filter('StatusId', parseInt(search.StatusId));

        if (search.CampanhaId)
            odata.filter('CampanhaVisualSMSId', parseInt(search.CampanhaId));

        if (search.Convertido)
            odata.filter('Convertido', search.Convertido);

        if (search.Rejeitado)
            odata.filter('Rejeitado', search.Rejeitado);

        return odata;
    }

    angular.module("epbxManagerApp")
    
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.relatoriodetalhado", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.relatoriodetalhado.list',
                        pageTitle: 'pageTitle.relatorioVisualSms',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.relatoriodetalhado.list", StateResolverProvider.configState("/relatoriodetalhado", "RelatorioDetalhado", "List", {
                    pageTitle: 'pageTitle.relatorioVisualSms',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("RelatorioDetalhadoListData", function RotaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    mensagens: ["RelatorioDetalhadoResource", "$odata", function (RelatorioDetalhadoResource, $odata) {
                        var filtro = { Ativo: true };

                        var orderBy = {
                            column: "DataEnvio",
                            order: "asc"
                        }

                        var odata = getOdataSearchShared(RelatorioDetalhadoResource, filtro, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }],
                    status: ["RelatorioDetalhadoResource", function (RelatorioDetalhadoResource) {
                        return RelatorioDetalhadoResource.getStatus().$promise;
                    }],
                    campanhas: ["RelatorioDetalhadoResource", function (RelatorioDetalhadoResource) {
                        return RelatorioDetalhadoResource.getCampanhas().$promise;
                    }]
                }
            }
        })
        .controller("RelatorioDetalhadoListController",
        ["$scope", "$odata", "RelatorioDetalhadoResource", "mensagens", "status", "campanhas", "NotifyService", function ($scope, $odata, RelatorioDetalhadoResource, mensagens, status, campanhas, NotifyService) {
            $scope.mensagens = mensagens;
            $scope.statusList = status;
            $scope.campanhaList = campanhas;
            $scope.search = {};
            $scope.orderBy = {
                column: "DataEnvio",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.mensagens = list;
                $scope.mensagens.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.mensagens.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function getOdataSearch() {
                return getOdataSearchShared(RelatorioDetalhadoResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.executeSearch = function executeSearch() {
                $scope.searching = true;
                getOdataSearch().page($scope.search.pageSize, 1).query().then(updateList).catch(NotifyService.showError);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.mensagens.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
            };

            updateList(mensagens);

            $scope.limparFiltro = function () {
                $scope.search = { pageSize: 10 };
            };

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RelatorioDetalhadoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "RelatorioVisualSMS", {},
                {
                    getStatus: {
                        url: "IntegracaoMensagemStatus",
                        method: "GET",
                        isArray: true
                    },
                    getCampanhas: {
                        url: "RelatorioVisualSMS/Campanhas",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);

})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoSumarizado', ["$timeout", function ($timeout) {
            return {
                restrict: 'AE',
                //replace:true,
                scope: {
                    dados: '=',
                    nome: '='
                },
                template: '<div id="chart_{{nome}}" style="width: 100%; height: 400px; overflow: hidden; text-align: center; padding-bottom:20px; border-bottom: dashed 1px #DDD;"></div>',
                link: function (scope, element, attrs) {
                    var initChart = function () {

                        var chart = AmCharts.makeChart('chart_' + scope.nome, {
                            "type": "pie",
                            "theme": "light",
                            "language": "pt",
                            "dataProvider": scope.dados,
                            "valueField": "Quantidade",
                            "titleField": "Descricao",
                            "plotAreaBorderAlpha": 0,
                            "marginTop": 10,
                            "marginLeft": 20,
                            "zoomOutText": "",
                            "mouseWheelZoomEnabled": false,
                            "marginBottom": 0,
                            "balloon": { "fixedPosition": true },
                            "export": { "enabled": false },
                            "legend": {
                                "equalWidths": false,
                                "periodValueText": "Ativo: [[value.sum]]",
                                "position": "bottom",
                                "align": "center",
                                "valueAlign": "center",
                                "marginRight": 0,
                                "horizontalGap": 0,
                                "color": "#333",
                                "markerSize": 10,
                            },
                        });
                    };

                    $timeout(function () {
                        initChart();
                    }, 1000);

                }
            };
        }]);
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")
        .service("RelatorioPesquisaListData", function RelatorioPesquisaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_amCharts'
                        ]);
                    }],
                    grupos: ["RelatorioPesquisaResource", function (RelatorioPesquisaResource) {
                        return RelatorioPesquisaResource.getGruposFiltro().$promise
                    }],
                }
            }
        })
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.relatoriopesquisa", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.relatoriopesquisa.list',
                        pageTitle: 'Relatório Pesquisa Satisfação',
                        pageName: 'Pesquisa',
                        permissions: {
                            AllowAll: true
                        }
                    }
                })
                .state("main.relatoriopesquisa.list", StateResolverProvider.configState("/relatoriopesquisa", "RelatorioPesquisa", "List", {
                    pageTitle: 'Relatório Pesquisa Satisfação',
                    pageName: 'Pesquisa'
                }));
        }])
        .controller("RelatorioPesquisaListController", ["$scope", "$window", "RelatorioPesquisaResource", "NotifyService", "grupos", "ModalService", function RelatorioPesquisaListController($scope, $window, RelatorioPesquisaResource, NotifyService, grupos,
            ModalService) {
            $scope.data = [{
                "country": "Lithuania",
                "litres": 501.9
            }, {
                "country": "Czech Republic",
                "litres": 301.9
            }, {
                "country": "Ireland",
                "litres": 201.1
            }, {
                "country": "Germany",
                "litres": 165.8
            }, {
                "country": "Australia",
                "litres": 139.9
            }, {
                "country": "Austria",
                "litres": 128.3
            }, {
                "country": "UK",
                "litres": 99
            }, {
                "country": "Belgium",
                "litres": 60
            }, {
                "country": "The Netherlands",
                "litres": 50
            }];

            var modal = null;
            $scope.chart = null;
            $scope.gruposList = grupos;
            $scope.pesquisasList = [];
            $scope.perguntasList = [];
            $scope.resultadosSumarizados = {
                Perguntas: []
            },
            $scope.resultadosIndividuaisList = [];
            $scope.search = {
                DataInicio: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
                DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                GrupoId: undefined,
                PesquisaId: undefined,
                PerguntaId: undefined,
            };
            $scope.submitted = false;
            $scope.searchGrupoChange = function () {
                $scope.pesquisasList = [];
                $scope.perguntasList = [];
                $scope.search.PesquisaId = null;
                $scope.search.PerguntaId = null;
                
                var filtro = { grupoId: $scope.search.GrupoId };

                if ($scope.search.GrupoId > 0) {
                    RelatorioPesquisaResource.getPerquisasFiltro(filtro)
                        .$promise
                        .then(function (data) {
                            $scope.pesquisasList = data;

                            if (modal != null) {
                                modal.hide();
                            }

                        }).catch(showError);
                }
            };

            $scope.searchPesquisaChange = function () {
                $scope.perguntasList = [];
                $scope.search.PerguntaId = null;
                var filtro = { pesquisaId: $scope.search.PesquisaId };
                if ($scope.search.PesquisaId > 0) {
                    RelatorioPesquisaResource.getPerguntasFiltro(filtro)
                        .$promise
                        .then(function (data) {
                            $scope.perguntasList = data;
                        }).catch(showError);
                }
            };

            $scope.executeSearch = function () {
                ModalService.showLoading();
                $scope.submitted = true;

                if (!validarPesquisa()) {
                    ModalService.hideLoading();
                    $scope.submitted = false;
                    return;
                }

                var filtro = {
                    DataInicial: $scope.search.DataInicio,
                    DataFinal: $scope.search.DataFim,
                    PesquisaId: $scope.search.PesquisaId,
                    PerguntaId: $scope.search.PerguntaId
                };

                RelatorioPesquisaResource.getResultadosPesquisa(filtro).$promise.then(resultadosPesquisa).catch(showError);
            };

            $scope.chamarModal = function (data) {
                var filtro = {
                    PesquisaId: data.PesquisaId,
                    BilheteId: data.BilheteId
                };
                
                RelatorioPesquisaResource.getResultadosIndividuaisDetalhes(filtro).$promise.then(resultadosIndividuaisDetalhes).catch(showError);
            }

            $scope.limparFiltro = function () {
                $scope.search = {
                    DataInicio: moment().subtract(30, 'days').seconds(0).milliseconds(0).toDate(),
                    DataFim: moment().add(1, 'days').seconds(0).milliseconds(0).toDate(),
                    GrupoId: undefined,
                    PesquisaId: undefined,
                    PerguntaId: undefined,
                }
                $scope.resultadosSumarizados = {
                    Perguntas: []
                }
                $scope.resultadosIndividuaisList = [];
                $scope.submitted = false;
            }

            var resultadosPesquisa = function (data) {
                $scope.resultadosSumarizados = data.ResultadosSumarizados;
                $scope.resultadosIndividuaisList = data.ResultadosIndividuais;
                ModalService.hideLoading();
                $scope.submitted = false;
            };

            var resultadosIndividuaisDetalhes = function (data) {
                $scope.resultadosIndividuaisDetalhe = data;
                var modalAvaliacao = $window.UIkit.modal('#modal_avaliacao');
                modalAvaliacao.show();
            };

            var showError = function (error) {
                NotifyService.showError(error);
                ModalService.hideLoading();
            };

            var validarPesquisa = function () {

                var msg = [];

                if ($scope.search.DataInicio == undefined)
                    msg.push(' - O campo "Data Início" é obrigatório.');

                if ($scope.search.DataFim == undefined)
                    msg.push(' - O campo "Data Fim" é obrigatório.');

                if (($scope.search.DataInicio != undefined && $scope.search.DataFim != undefined) && $scope.search.DataInicio >= $scope.search.DataFim)
                    msg.push(' - O campo "Data Início" é maior que o campo "Data Fim".');

                if ($scope.search.GrupoId == undefined)
                    msg.push(' - O campo "Grupo" é obrigatório.');

                if ($scope.search.PesquisaId == undefined)
                    msg.push(' - O campo "Pesquisa" é obrigatório.');

                if (msg.length) {
                    NotifyService.showError(null, "Verifique se todos os campos foram preenchidos corretamente: <br><br>" + msg.join('<br>'));
                    return false;
                }

                return true;
            };
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
      .factory("RelatorioPesquisaResource", ["$odataresource", function ($odataresource) {
          return $odataresource("RelatorioPesquisa/:Id",
            {
                "Id": "@Id"
            },
            {
                getGruposFiltro: {
                    url: "RelatorioPesquisa/GruposFiltro",
                    method: "GET",
                    isArray: true
                },
                getPerquisasFiltro: {
                    url: "RelatorioPesquisa/PesquisasFiltro",
                    method: "GET",
                    isArray: true
                },
                getPerguntasFiltro: {
                    url: "RelatorioPesquisa/PerguntasFiltro",
                    method: "GET",
                    isArray: true
                },
                getResultadosPesquisa: {
                    url: "RelatorioPesquisa/ResultadosPesquisas",
                    method: "GET",
                    isArray: false
                },
                getResultadosIndividuaisDetalhes: {
                    url: "RelatorioPesquisa/ResultadosIndividuaisDetalhes",
                    method: "GET",
                    isArray: false
                }
            });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.releaseNotes", StateResolverProvider.configAbstractInnerPage({ 
                proxy: 'main.releaseNotes.list' 
            }));
            $stateProvider.state("main.releaseNotes.list", StateResolverProvider.configState("/releaseNotes", "ReleaseNotes", "List", {
                pageTitle: 'pageTitle.notasDeVersao',
                pageName: ''
            }));
        }])

        .service("ReleaseNotesListData", function ReleaseNotesListData() {
            return function () {
                return {
                    list: ["$http", "Config", function ($http, Config) {
                        return $http({
                            method: 'GET',
                            url: Config.getUrl("Versao/ReleaseNotes")
                        }).then(function (response) {
                            return response.data;
                        });
                    }],
                }
            }
        })

        // trocar o nome da categoria pelo nome do icone
        .filter("releaseCategoryIcon", function () {
            return function (input) {
                switch (input) {
                    case "Correções":
                        return "bug_report";
                    case "Melhorias":
                    default:
                        return "star";
                }
            }
        })

        .controller("ReleaseNotesListController", ["$scope", "list", "$rootScope", function ($scope, list, $rootScope) {
            $scope.list = [];
            $scope.versaoAtual = $rootScope.appVer;

            setTimeout(() => {
                _.each(list, (item) => {
                    item.DetalhesJson = JSON.parse(item.Detalhes.toString('utf8'));
                });
                $scope.list = list;
            }, 100);

        }]);
})();

(function () {
	"use strict";
	var defaultPageSizeAssinatura = 5;

	angular.module("epbxManagerApp")

		.controller("AssinaturaController",
			["$scope", "$window", "$odata", "ReportResource", "ReportParametroResource", "ReportAssinaturaResource", "WizardHandler", "AuthService", "NotifyService", "$translate", "ModalService", function ($scope, $window, $odata, ReportResource, ReportParametroResource, ReportAssinaturaResource, WizardHandler, AuthService, NotifyService, $translate,
			ModalService) {
				$scope.para = '';
				$scope.copia = '';
				$scope.copiaoculta = '';
				$scope.responderpara = '';
				$scope.viewList = true;
				$scope.viewEdit = false;
				$scope.sendToValidation = false;
				$scope.formatoList = [];
				$scope.parametroAssinaturaList = [];
				$scope.parametroServerList = [];
				var usuarioId = AuthService.getUsuarioLogado() ? AuthService.getUsuarioLogado().UsuarioId : 0;

				$scope.$on("carrega_assinatura", function (event, report) {
					$scope.limparAssinatura();
					WizardHandler.wizard().goTo(0);
					$scope.searchAssinatura = {};
					$scope.assinaturaList = [];
					$scope.isNew = false;
					$scope.viewList = true;
					$scope.viewEdit = false;
					$scope.sendToValidation = false;
					$scope.reportId = report.ReportId;
					$scope.submittedAssinatura = false;
					carregaAssinaturaList();
					$scope.reportName = report.Nome;
				});

				var carregaAssinaturaList = function () {
					ReportAssinaturaResource.odata().filter('Ativo', true).filter('ReportId', $scope.reportId).query()
						.then(updateList)
						.catch(mensagemErro);
					$scope.pageChangedAssinatura(0);
				}

				$scope.exitValidationAssinatura = function () {
					var alterado = $scope.isNew ? false : $scope.forms.formAssinatura.$dirty;
					var proximoStep = false;

					if (alterado) {
						ModalService.confirmDescartar(function () {
							$scope.forms.formAssinatura.$dirty = false;
							$scope.forms.formAssinatura.$setPristine();
						});
					} else {
						if (typeof $scope.forms.formAssinatura.$valid !== 'undefined')
							proximoStep = true;
					}

					if (!$scope.assinatura.Destinatarios.length) {
						$scope.sendToValidation = true;
						proximoStep = false;
					} else $scope.sendToValidation = false;

					return proximoStep;
				}

				var updateList = function (list) {
					$scope.assinaturaList = list;
					$scope.assinaturaList.recordCount = list.$recordCount || list.length;
					$scope.currentPageAssinatura = list.$currentPage || 0;
					$scope.assinaturaList.pageSize = list.$pageSize || defaultPageSizeAssinatura;
				};

				var carregaAssinaturaParametroEdit = function (assinatura) {
					return ReportAssinaturaResource.getParametroAssinatura({ reportAssinaturaId: assinatura.ReportAssinaturaId }).$promise;
				}

				var deleteAssinatura = function (data) {
					return ReportAssinaturaResource.delete({
						ReportAssinaturaId: data.ReportAssinaturaId
					}).$promise
						.then(function () {
							mensagemSucesso();
							$scope.pageChangedAssinatura($scope.currentPageAssinatura);
						})
						.catch(mensagemErro);
				}

				$scope.confirmDelete = function (data) {
					ModalService.confirmDelete(() => deleteAssinatura(data));
				}

				$scope.editAssinatura = function (assinatura) {
					ModalService.showLoading();
					$scope.limparAssinatura();
					WizardHandler.wizard().goTo(0);

					//carrega formato
					ReportResource.reportFormato().$promise.then(function (resultFormato) {
						angular.copy(resultFormato, $scope.formatoList);
						//pega os parametros da Tabela
						ReportResource.parametro({ ReportId: $scope.reportId }).$promise.then(function (parametroList) {
							//pega os parametros do Server
							ReportParametroResource.getParametroList({ ReportId: $scope.reportId }).$promise.then(function (parameters) {
								angular.forEach(parametroList, function (value) {
									var paramServer = _.findWhere(parameters, {
										ReportParametroId: value.ReportParametroId
									});

									if (value.Parametro == 'UsuarioId') {
										value.Valor = usuarioId;
										value.Visivel = false;
									}
									else value.Visivel = true;

									value.ValorPadrao = true;

									if (value.ReportParametroTipoId == 1 && value) {
										if (paramServer) {
											value.Itens = paramServer.Itens;
											value.ValorSelect = paramServer.ValorPadrao.split(',');
										}
										value.ValorPadrao = false;
									} else if (value.ReportParametroTipoId == 6 && value) {
										if (paramServer) {
											value.Itens = paramServer.Itens;
											value.ValorSelect = paramServer.ValorPadrao;
										}
										value.ValorPadrao = false;
									}

									$scope.parametroPadraoList.push(value);
								});
								//Traz os dados da assinatura a ser alterada
								var promise = ReportAssinaturaResource.get({
									ReportAssinaturaId: assinatura.ReportAssinaturaId
								}).$promise;

								if (promise) {
									promise.then(function (result) {
										angular.copy(result, $scope.assinatura);
										var promiseEdit = carregaAssinaturaParametroEdit($scope.assinatura);
										if (promiseEdit) {
											promiseEdit.then(function (params) {
												if (params) {
													angular.forEach($scope.parametroPadraoList, function (value) {
														var parametrotable = [];
														angular.forEach(params, function (valueP) {
															if (valueP.ReportParametroId == value.ReportParametroId)
																parametrotable.push(valueP);
														});

														if (parametrotable.length && value.ReportParametroTipoId != 1) {
															value.Valor = parametrotable[0].Valor;
															value.AssinaturaParametroId = parametrotable[0].AssinaturaParametroId;
															value.ValorPadrao = parametrotable[0].ValorPadrao;

															if (value.ReportParametroTipoId == 6)
																value.ValorSelect = value.Valor;
														}

														if (value.ReportParametroTipoId == 1) {
															value.ValorPadrao = false;

															if (parametrotable.length) {
																value.AssinaturaParametroId = parametrotable[0].AssinaturaParametroId;

																if (value.ValorSelect) {
																	var selectValorAtual = [];
																	angular.forEach(parametrotable, function (valueT) {
																		if (valueT.Valor)
																			selectValorAtual.push(valueT.Valor);
																	});
																	value.ValorSelect = selectValorAtual;
																}
															}
															else value.ValorSelect = [];
														}
													});
												}
												$scope.viewEdit = true;
												$scope.viewList = false;
												$scope.reportAssinaturaId = assinatura.ReportAssinaturaId;
												$scope.isNew = false;
												$scope.forms.formAssinatura.$setPristine();
												$scope.forms.formParametro.$setPristine();
												ModalService.hideLoading();
												carregaAssinaturaEdit($scope.assinatura);												
												$scope.assinatura.DataAgendamento = new moment($scope.assinatura.DataAgendamento).format("HH:mm");
											}).catch(mensagemErro);
										}
									});
								}

							});
						});
					});
				}

				var splitEmail = function (list) {
					var listEmail = [];
					angular.forEach(list, function (value) {
						listEmail.push({ Email: value });
					});
					return listEmail;
				}

				var splitDias = function (list) {
					angular.forEach(list, function (value) {
						if (value == 1)
							$scope.domingo = true;
						if (value == 2)
							$scope.segunda = true;
						if (value == 3)
							$scope.terca = true;
						if (value == 4)
							$scope.quarta = true;
						if (value == 5)
							$scope.quinta = true;
						if (value == 6)
							$scope.sexta = true;
						if (value == 7)
							$scope.sabado = true;
					});
				}

				var carregaAssinaturaEdit = function (assinatura) {
					if (assinatura.EnviarPara)
						$scope.assinatura.Destinatarios = splitEmail(assinatura.EnviarPara.split(';'));
					if (assinatura.EnviarCopia)
						$scope.assinatura.Copias = splitEmail(assinatura.EnviarCopia.split(';'));
					if (assinatura.EnviarCopiaOculta)
						$scope.assinatura.CopiasOcultas = splitEmail(assinatura.CopiasOcultas.split(';'));
					if (assinatura.ResponderPara)
						$scope.assinatura.Repostas = splitEmail(assinatura.ResponderPara.split(';'));
					if (assinatura.DiasDaSemana)
						splitDias(assinatura.DiasDaSemana.split(','));
				}

				var carregaParametro = function () {
					var promise = ReportResource.parametro({ ReportId: $scope.reportId }).$promise;

					if (promise) {
						promise.then(function (result) {
							angular.copy(result, $scope.parametroAssinaturaList);
							populateParameters($scope.parametroAssinaturaList);
						});
					}
				}

				var carregaParametroServer = function (id) {
					return ReportParametroResource.getParametroList({ ReportId: id }).$promise;
				}

				var carregaFormato = function () {
					var promise = ReportResource.reportFormato().$promise;
					if (promise) {
						promise.then(function (result) {
							angular.copy(result, $scope.formatoList);
						});
					}
				}

				var populateParameters = function (parametroList) {
					carregaParametroServer($scope.reportId).then(function (parameters) {
						angular.forEach(parametroList, function (value) {
							var paramServer = _.findWhere(parameters, {
								ReportParametroId: value.ReportParametroId
							});

							if (value.Parametro == 'UsuarioId') {
								value.Valor = usuarioId;
								value.Visivel = false;
								value.ValorPadrao = false;
							}
							else {
								value.Visivel = true;
								value.ValorPadrao = true;
							}

							if (value.ReportParametroTipoId == 1 && value) {
								if (paramServer) {
									value.Itens = paramServer.Itens;
									value.ValorSelect = paramServer.ValorPadrao.split(',');
								}
								value.ValorPadrao = false;
							} else if (value.ReportParametroTipoId == 6 && value) {
								if (paramServer) {
									value.Itens = paramServer.Itens;
									value.ValorSelect = paramServer.ValorPadrao;
								}
								value.ValorPadrao = false;
							}

							$scope.parametroPadraoList.push(value);
						});
					});
				}

				$scope.executeSearchAssinatura = function executeSearchAssinatura() {
					var odata = ReportAssinaturaResource.odata()
						.filter('Ativo', true)
						.filter('ReportId', $scope.reportId);

					if ($scope.searchAssinatura.Titulo)
						odata.filter(new $odata.Func("contains", "Titulo", $scope.searchAssinatura.Titulo), true);

					if ($scope.searchAssinatura.EnviarPara)
						odata.filter(new $odata.Func("contains", "EnviarPara", $scope.searchAssinatura.EnviarPara), true);

					odata.orderBy('ReportAssinaturaId', 'desc').query()
						.then(updateList)
						.catch(mensagemErro);
				};

				$scope.viewDetalheAssinatura = function (assinatura) {
					var msg = `<h2>${$translate.instant('campo.detalhe')}: ${assinatura.Titulo} </h2></br> ${$translate.instant('telaReport.dataUltimaExecucao')}: 
					${new moment(assinatura.UltimaExecucao).format("DD/MM/YYYY HH:mm")} <div class='uk-text-truncate'>
					${$translate.instant('telaReport.mensagemDeRetornoDoEnvio')}:</br>${assinatura.MensagemRetorno}</div>`
					$window.UIkit.modal.alert(msg);
				}

				$scope.limparAssinatura = function () {
					$scope.parametroPadraoList = [];
					$scope.reportAssinaturaId = 0;
					$scope.domingo = false;
					$scope.segunda = false;
					$scope.terca = false;
					$scope.quarta = false;
					$scope.quinta = false;
					$scope.sexta = false;
					$scope.sabado = false;
					limparDias();

					$scope.assinatura = {
						ReportAssinaturaId: 0,
						ReportId: 0,
						Titulo: '',
						EnviarPara: '',
						EnviarCopia: '',
						EnviarCopiaOculta: '',
						ResponderPara: '',
						Comentario: '',
						FormatoId: 0,
						DataAgendamento: '',
						DataProcessamento: '',
						DiasDaSemana: '',
						Processado: false,
						Ativo: true,
						Destinatarios: [],
						Respostas: [],
						Copias: [],
						CopiasOcultas: [],
					}
				}

				$scope.backAssinatura = function () {
					$scope.viewList = true;
					$scope.viewEdit = false;
					$scope.assinaturaList = [];
					carregaAssinaturaList();
				}

				$scope.addDestinatario = function (email) {
					if ($('#emailparaId').val()) {
						$scope.forms.formAssinatura.$dirty = true;
						$scope.assinatura.Destinatarios.push({ 'Email': email });
						$('#emailparaId').val('');
						$scope.para = '';
					}
				}

				$scope.addResponder = function (email) {
					if ($('#responderparaId').val()) {
						$scope.forms.formAssinatura.$dirty = true;
						$scope.assinatura.Respostas.push({ 'Email': email });
						$('#responderparaId').val('');
						$scope.responderpara = '';
					}
				}

				$scope.addCopia = function (email) {
					$scope.forms.formAssinatura.$dirty = true;
					$scope.assinatura.Copias.push({ 'Email': email });
					$('#copiaId').val('');
					$scope.copia = '';
				}

				$scope.addCopiaOculta = function (email) {
					$scope.forms.formAssinatura.$dirty = true;
					$scope.assinatura.CopiasOcultas.push({ 'Email': email });
					$('#copiaocultaId').val('');
					$scope.copiaoculta = '';
				}

				$scope.removeDestinatario = function (index) {
					$scope.forms.formAssinatura.$dirty = true;
					$scope.assinatura.Destinatarios.splice(index, 1);
				}

				$scope.removeResponder = function (index) {
					$scope.forms.formAssinatura.$dirty = true;
					$scope.assinatura.Respostas.splice(index, 1);
				}

				$scope.removeCopia = function (index) {
					$scope.forms.formAssinatura.$dirty = true;
					$scope.assinatura.Copias.splice(index, 1);
				}

				$scope.removeCopiaOculta = function (index) {
					$scope.forms.formAssinatura.$dirty = true;
					$scope.assinatura.CopiasOcultas.splice(index, 1);
				}

				$scope.adicionarAssinatura = function () {
					$scope.viewEdit = true;
					$scope.viewList = false;
					$scope.reportAssinaturaId = 0;
					$scope.isNew = true;
					$scope.limparAssinatura();
					carregaFormato();
					carregaParametro();
					WizardHandler.wizard().goTo(0);
					$scope.assinatura.Titulo = $scope.reportName;
				}

				var mensagemSucesso = function (mensagem) {
					NotifyService.showSuccess((mensagem == null? $translate.instant('notificacoes.registroSalvo'): mensagem))

					var cardFull = $('.uk-notify');
					if (cardFull.length)
						cardFull.css('z-index', 99999);

					$scope.submittedAssinatura = false;
				}

				var mensagemErro = function (error) {
					NotifyService.showError(error);

					var cardFull = $('.uk-notify');
					if (cardFull.length) {
						cardFull.css('z-index', 99999);
					}

					ModalService.hideLoading();
					$scope.submittedAssinatura = false;
				}

				$scope.pageChangedAssinatura = function (newPage) {
					var odata = ReportAssinaturaResource.odata()
						.filter('Ativo', true)
						.filter('ReportId', $scope.reportId);

					if ($scope.searchAssinatura.Titulo)
						odata.filter(new $odata.Func("contains", "Titulo", $scope.searchAssinatura.Titulo), true);

					if ($scope.searchAssinatura.EnviarPara)
						odata.filter(new $odata.Func("contains", "EnviarPara", $scope.searchAssinatura.EnviarPara), true);

					return odata.orderBy('ReportAssinaturaId', 'desc').page($scope.assinaturaList.pageSize, newPage).query().then(updateList).catch(mensagemErro);
				};

				$scope.salvar = function salvar(form) {
					var lastStep = form.$name == "forms.formParametro" ? true : false;
					var isNew = $scope.isNew;

					if ((!form.$dirty && !lastStep) || (isNew && !lastStep))
						WizardHandler.wizard().next();
					else {
						if (!form.$valid) {
							NotifyService.showInvalid();
							return;
						}

						if (!isNew) {
							if (form.$name == "forms.formAssinatura") {
								$scope.submittedAssinatura = true;
								salvarAssinatura().then(function (data) {
									angular.copy(data, $scope.assinatura);
									carregaAssinaturaEdit($scope.assinatura);
									$scope.forms.formAssinatura.$setPristine();
									mensagemSucesso();
								}).catch(mensagemErro);
							}
							else if (lastStep && form.$name == "forms.formParametro") {
								if (!$scope.forms.formParametro.$dirty) {
									$scope.backAssinatura();
									return;
								}

								salvarAssinatura().then(function (result) {
									$scope.submittedAssinatura = true;
									angular.copy(result, $scope.assinatura);
									carregaAssinaturaEdit($scope.assinatura);
									$scope.forms.formAssinatura.$setPristine();
									$scope.reportAssinaturaId = $scope.assinatura.ReportAssinaturaId;
									salvarAssinaturaParametro().then(function () {
										$scope.forms.formParametro.$setPristine();
										mensagemSucesso();
									}).catch(mensagemErro);
								}).catch(mensagemErro);
							}
						}
						else {
							salvarAssinatura().then(function (result) {
								$scope.submittedAssinatura = true;
								angular.copy(result, $scope.assinatura);
								$scope.reportAssinaturaId = $scope.assinatura.ReportAssinaturaId;
								salvarAssinaturaParametro().then(function () {
									carregaAssinaturaList();
									$scope.viewEdit = false;
									$scope.viewList = true;
									$scope.forms.formAssinatura.$setPristine();
									$scope.forms.formParametro.$setPristine();
									mensagemSucesso();
								}).catch(mensagemErro);
							}).catch(mensagemErro);
						}
					}
				}

				var limparDias = function () {
					$('#domingo').attr('checked', false);
					$('#segunda').attr('checked', false);
					$('#terca').attr('checked', false);
					$('#quarta').attr('checked', false);
					$('#quinta').attr('checked', false);
					$('#sexta').attr('checked', false);
					$('#sabado').attr('checked', false);
				}

				var retornaDias = function () {
					var dias = [];
					if ($('#domingo').is(':checked'))
						dias.push('1');
					if ($('#segunda').is(':checked'))
						dias.push('2');
					if ($('#terca').is(':checked'))
						dias.push('3');
					if ($('#quarta').is(':checked'))
						dias.push('4');
					if ($('#quinta').is(':checked'))
						dias.push('5');
					if ($('#sexta').is(':checked'))
						dias.push('6');
					if ($('#sabado').is(':checked'))
						dias.push('7');

					return dias.join(',');
				}

				var joinEmail = function (list) {
					var emails = [];
					angular.forEach(list, function (value) {
						emails.push(value.Email)
					});
					return emails.join(';');
				}

				var salvarAssinatura = function () {
					var promise;
					$scope.assinatura.DiasDaSemana = retornaDias();
					$scope.assinatura.EnviarPara = $scope.assinatura.Destinatarios ? joinEmail($scope.assinatura.Destinatarios) : $scope.assinatura.EnviarPara;
					$scope.assinatura.EnviarCopia = $scope.assinatura.Copias ? joinEmail($scope.assinatura.Copias) : $scope.assinatura.EnviarCopia;
					$scope.assinatura.EnviarCopiaOculta = $scope.assinatura.CopiasOcultas ? joinEmail($scope.assinatura.CopiasOcultas) : $scope.assinatura.EnviarCopiaOculta;
					$scope.assinatura.ResponderPara = $scope.assinatura.Respostas ? joinEmail($scope.assinatura.Respostas) : $scope.assinatura.ResponderPara;
					$scope.assinatura.ReportId = $scope.reportId;

					if ($scope.assinatura.ReportAssinaturaId > 0) {
						promise = ReportAssinaturaResource.update($scope.assinatura).$promise;
					} else
						promise = ReportAssinaturaResource.save($scope.assinatura).$promise;

					return promise;
				}

				var salvarAssinaturaParametro = function () {
					var promise;
					var assinaturaParametroList = [];
					if ($scope.reportAssinaturaId > 0) {
						angular.forEach($scope.parametroPadraoList, function (value) {
							var assinaturaParametro = {
								Valor: '',
								AssinaturaParametroId: 0,
								ReportAssinaturaId: 0,
								ReportParametroId: 0,
								ValorPadrao: false,
							};

							assinaturaParametro.AssinaturaParametroId = value.AssinaturaParametroId;
							assinaturaParametro.ReportAssinaturaId = $scope.reportAssinaturaId;
							assinaturaParametro.ReportParametroId = value.ReportParametroId;
							assinaturaParametro.ValorPadrao = value.ValorPadrao;

							if (value.ReportParametroTipoId == 3 && !value.ValorPadrao) {
								// var dataSelected = $("#txtdata_" + value.ReportParametroId);

								// if (dataSelected)
									assinaturaParametro.Valor = value.Valor
							}
							else if (value.ReportParametroTipoId == 1) assinaturaParametro.Valor = value.ValorPadrao ? null : (value.ValorSelect ? value.ValorSelect.join('|') : null);
							else if (value.ReportParametroTipoId == 6) assinaturaParametro.Valor = value.ValorPadrao ? null : (value.ValorSelect ? value.ValorSelect : null);
							else assinaturaParametro.Valor = value.ValorPadrao ? null : value.Valor;

							if (value.ReportParametroTipoId == 1 && !(assinaturaParametro.AssinaturaParametroId > 0)) assinaturaParametro.Valor = value.ValorPadrao ? null : (value.ValorSelect ? value.ValorSelect.join('|') : null);
							else if (value.ReportParametroTipoId == 6 && !(assinaturaParametro.AssinaturaParametroId > 0)) assinaturaParametro.Valor = value.ValorPadrao ? null : (value.ValorSelect ? value.ValorSelect : null);

							assinaturaParametroList.push(assinaturaParametro);
						});

						promise = ReportAssinaturaResource.setParametroAssinatura({ ReportAssinaturaParametro: assinaturaParametroList }).$promise;
					}

					return promise;
				}

				$scope.limparFiltroAssinatura = function () {
					$scope.searchAssinatura.Titulo = '';
					$scope.searchAssinatura.Email = '';
					$scope.assinaturaList = [];
					carregaAssinaturaList();
				}

				$scope.executeAssinatura = function (assinatura) {
					var promise = ReportAssinaturaResource.sendAssinatura({ ReportAssinaturaId: assinatura.ReportAssinaturaId }).$promise;

					if (promise) {
						promise.then(function () {
							mensagemSucesso('telaReport.assinaturaEnviadaComSucesso');
						}).catch(mensagemErro);
					}
				}
			}]);
})();


(function () {
	"use strict";
	angular.module("epbxManagerApp")

		.controller("DownloadController", ["$scope", "$window", "Config", "ReportResource", "ReportParametroResource", "NotifyService", "ModalService", function ($scope, $window, Config, ReportResource, ReportParametroResource, NotifyService, ModalService) {
			$scope.$on("carrega_download_report", function (event, report) {
				$scope.reportDownloadName = report.Nome;
				$scope.reportDownloadId = report.ReportId;
				$scope.parametroDownloadList = [];
				$scope.formatoDownloadList = [];
				$scope.formatoDownload = '';
				$scope.$$childHead.formatoDownload = '';
				carregaFormatoDownload();
				carregaParametroDownload()
			});

			var carregaFormatoDownload = function () {
				var promise = ReportResource.reportFormato().$promise;
				if (promise) {
					promise.then((result) => {
						angular.copy(result, $scope.formatoDownloadList);
					});
				}
			}

			var carregaParametroDownload = function () {
				var promise = ReportParametroResource.getParametroList({ ReportId: $scope.reportDownloadId }).$promise;

				if (promise) {
					promise.then((result) => {
						var parameters = [];
						angular.copy(result, parameters);
						populateParameterDownload(parameters);
					});
				}
			}

			var populateParameterDownload = function (parametroList) {
				angular.forEach(parametroList, (value) => {
					if (value.Parametro == 'UsuarioId') {
						value.Visivel = false;
					}
					else {
						value.Visivel = true;
					}

					if (value.ReportParametroTipoId == 3) { //Datetime
						var data = new Date(new moment(new Date(value.ValorPadrao)).format('DD/MM/YYYY')).getDate() ? new Date(new moment(new Date(value.ValorPadrao)).format('DD/MM/YYYY')) : new Date(value.ValorPadrao);
						value.ValorPadrao = new Date(data.getFullYear(), data.getMonth(), data.getDate());
					} else if (value.ReportParametroTipoId == 1) {
						value.ValorSelect = value.ValorPadrao.split(',');
					}

					$scope.parametroDownloadList.push(value);
				});

				ModalService.hideLoading();
			}

			var getParametersDownload = function () {
				var reportParameter = '', isValidParameters = true;
				angular.forEach($scope.parametroDownloadList, (obj, index) => {
					var valorPadrao;

					if (obj.ValorPadrao) {
						if (obj.ReportParametroTipoId == 3) {
							valorPadrao = new moment(obj.ValorPadrao).format("DD/MM/YYYY");
						}
						else if (obj.ReportParametroTipoId == 1) {
							valorPadrao = obj.ValorSelect.join('|');
						}
						else if (obj.ValorSelect) {
							valorPadrao = obj.ValorSelect;
						}
						else {
							valorPadrao = obj.ValorPadrao;
						}
					}

					if (!valorPadrao) {
						isValidParameters = false;
					}

					if (($scope.parametroDownloadList.length - 1) == index) {
						reportParameter = reportParameter + '{"Nome" : "' + obj.Parametro + '","Valor" :  "' + valorPadrao + '"}';
					}
					else {
						reportParameter = reportParameter + '{"Nome" : "' + obj.Parametro + '","Valor" :  "' + valorPadrao + '"},';
					}
				});

				if (isValidParameters) {
					reportParameter = '[' + reportParameter + ']';
				}
				else {
					return NotifyService.showError(null, 'telaReport.paramentroInvalido');
				}

				return reportParameter;
			}

			var generateUUID = function () {
				var d = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (d + Math.random() * 16) % 16 | 0;
					d = Math.floor(d / 16);
					return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			}

			var getToken = function () {
				return angular.fromJson($window.localStorage.getItem("Token") || "{}");
			};

			$scope.downloadReport = function () {
				var parameters = getParametersDownload();
				var formato = $scope.formatoDownload ? $scope.formatoDownload : $scope.$$childHead.formatoDownload;
				var fileName = generateUUID();

				if (formato) {
					ModalService.showLoading();
					var promise = ReportResource.generateReportDownload({
						Parametros: parameters,
						Formato: formato,
						ReportId: $scope.reportDownloadId,
						Nome: fileName,
					}).$promise;

					if (promise) {
						promise.then(function (generatedFile) {
							var path = Config.getUrl("Report/ReportDownload/" + generatedFile.FileName + "/" + generatedFile.Format);
							var token = getToken();

							var params = {
								access_token: token.access_token,
								token_type: 'bearer'
							};

							var url = [path, $.param(params)].join('?');

							var iframe = $("<iframe src='" + url + "' style='display:none;' />");
							iframe.appendTo("body");
							ModalService.hideLoading();
						}).catch(showError);
					}
				}
				else {
					NotifyService.showError(null, 'telaReport.informeOFormatoDoArquivo')
				}
			}

			var showError = function (error) {
				ModalService.hideLoading()
				NotifyService.showError(error)

				var alert = $('.uk-notify');
				if (alert.length) {
					alert.css('z-index', 99999);
				}	
			}
		}]);
})();


(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ReportAssinaturaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("ReportAssinatura/:ReportAssinaturaId",
                {
                    "ReportAssinaturaId": "@ReportAssinaturaId"
                },
                {
                    setParametroAssinatura: {
                        url: "ReportAssinatura/SetParametroAssinatura",
                        method: "POST"
                    },
                    getParametroAssinatura: {
                        url: "ReportAssinatura/GetParametroAssinatura",
                        method: "GET",
                        isArray: true,
                    },
                    sendAssinatura: {
                        method: "POST",
                        url: "ReportAssinatura/SendAssinatura",
                    },
                });
        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (ReportResource, filter, orderBy) {
        var odata = ReportResource.odata();

        if (orderBy)
            odata.orderBy(orderBy.column, orderBy.order);

        if (filter)
            odata.filter(filter.key, filter.value);

        odata.filter('ReportTipoId', 1);

        return odata;
    }

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

            $stateProvider
                .state("main.report", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.report.list',
                        pageTitle: 'pageTitle.relatorioSsrs',
                        pageName: 'pageTitle.reports'
                    }
                })
                .state("main.report.list", StateResolverProvider.configState("/report", "Report", "List", {
                    pageTitle: 'pageTitle.relatorioSsrs',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("ReportListData", function ReportListData() {
            return function () {
                return {
                    categoriaList: ["ReportResource", function (ReportResource) {
                        return ReportResource.getCategoria().$promise;
                    }],
                    reportList: ["ReportResource", "$odata", function (ReportResource, $odata) {
                        var filtro = null;
                        var orderBy = {
                            column: "Nome"                            
                        };

                        var odata = getOdataSearchShared(ReportResource, filtro, orderBy, $odata);
                        return odata.query();
                    }],
                    lazy: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['lazy_uiSelect', 'lazy_wizard']);
                    }],
                }
            }
        })

        .controller("ReportListController", ["$scope", "$filter", "categoriaList", "reportList", "Config", "ModalService", function ReportListController($scope, $filter, categoriaList, reportList, Config, ModalService) {
            $scope.search = {};
            $scope.forms = {};
            $scope.reportListFull = reportList;
            $scope.reportList = [];
            $scope.filteredItems = [];
            $scope.reportCategoriaId = 0;
            $scope.categoriaList = categoriaList;
            $scope.orderBy = {
                column: "ReportId",
                order: "asc"
            };
            $scope.reportListByCategoria = {};

            $scope.filter = {
                key: "ReportCategoriaId",
                value: $scope.reportCategoriaId
            };

       
            $scope.initCategoria = function()
            {
                _.forEach($scope.categoriaList, function (categoria) {

                    const reports = $scope.reportListFull.filter((item) => item.ReportCategoriaId == categoria.ReportCategoriaId);

                    $scope.reportListByCategoria[categoria.ReportCategoriaId] = reports;
                });
            }

            $scope.initCategoria();

            $scope.viewAssinatura = function (report) {
                $scope.$broadcast('carrega_assinatura', report);
                ModalService.openModal('modal_assinatura');
            };

            $scope.downloadReport = function (report) {
                $scope.$broadcast('carrega_download_report', report);
                ModalService.openModal('modal_download_report');
            };

            $scope.imagemPreview = "";

            $scope.previewReport = function (report) {
                // eslint-disable-next-line no-console
                console.log("Report:", report);
                $scope.reportSelecionado = report;

                if (report != null) {
                    $scope.imagemPreview = "../../../assets/img/report/" + report.Imagem;
                }

                ModalService.openModal('modal_preview');
            };
        }])

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ReportParametroResource", ["$odataresource", function ($odataresource) {
            return $odataresource("ReportParametro/:ReportId",
                {
                    "ReportId": "@ReportId"
                },
                {
                    getParametroList: {
                        method: "GET",
                        url: "ReportParametro/ParametroList",
                        isArray: true
                    },
                    getParametroListByCarteira: {
                        method: "GET",
                        url: "ReportParametro/ParametroListByCarteira",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("ReportResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Report/:ReportId",
                {
                    "ReportId": "@ReportId"
                },
                {
                    parametro: {
                        method: "GET",
                        url: "Report/ReportParametro",
                        isArray: true
                    },
                    parametroFonte: {
                        method: "GET",
                        url: "Report/ReportParametroFonte",
                        isArray: false
                    },
                    generateReportDownload: {
                        url: "Report/GenerateReportDownload",
                        method: "POST"
                    },
                    downloadCSV: {
                        url: "Report/DownloadCSV/:id",
                        method: "POST",
                        params: { "id": "@id" },
                        isArray: false
                    },
                    reportFormato: {
                        method: "GET",
                        url: "Report/ReportFormato",
                        isArray: true
                    },
                    reportAssinatura: {
                        method: "GET",
                        url: "Report/ReportAssinatura",
                        isArray: true
                    },
                    setReportAssinatura: {
                        method: "POST",
                        url: "Report/SetReportAssinatura",
                    },
                    setReportAssinaturaParametro: {
                        method: "POST",
                        url: "Report/SetReportAssinaturaParametro",
                    },
                    getCategoria: {
                        method: "GET",
                        url: "Report/ReportCategoria",
                        isArray: true
                    },
                    getMaxDiaGerarRelatorio: {
                        method: "GET",
                        url: "Report/MaxDiaGerarRelatorio"
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

            $stateProvider
                .state("main.report.view", StateResolverProvider.configState("/report/{ReportId:[0-9]+}", "Report", "View", {
                    pageTitle: 'pageTitle.relatorioSsrs',

                    pageName: 'pageTitle.verRelatorio',
                    permissions: {
                        AllowAll: true
                    }
                }));
        }])

        .service("ReportViewData", function ReportViewData() {
            return function () {
                return {
                    reportList: ["ReportResource", "$stateParams", function (ReportResource, $stateParams) {
                        if ($stateParams.ReportId) {
                            return ReportResource.get({
                                ReportId: $stateParams.ReportId
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    parametroServerList: ["ReportParametroResource", "$stateParams", function (ReportParametroResource, $stateParams) {
                        if ($stateParams.ReportId) {
                            return ReportParametroResource.getParametroList({
                                ReportId: $stateParams.ReportId
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    lazy: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['lazy_uiSelect']);
                    }],
                    formatosDownload :["ReportResource", function (ReportResource) {
                        return ReportResource.reportFormato().$promise;
                    }],
                    maxDias: ["ReportResource", function(ReportResource){
                        return ReportResource.getMaxDiaGerarRelatorio();
                    }]
                }
            }
        })

        .filter('trusted', ["$sce", function ($sce) {
            return function (url) {
                return $sce.trustAsResourceUrl(url);
            };
        }])

        .controller("ReportViewController", ["$scope", "$window", "$compile", "$stateParams", "$translate", "Config", "reportList", "AuthService", "parametroServerList", "ReportResource", "NotifyService", "ModalService", "ReportParametroResource", "formatosDownload", "maxDias", function ($scope, $window, $compile, $stateParams, $translate, Config, reportList, AuthService, parametroServerList, ReportResource,
        NotifyService, ModalService, ReportParametroResource , formatosDownload, maxDias) {
            if (reportList) {
                AuthService.getUsuarioLogado() ? AuthService.getUsuarioLogado().UsuarioId : 0;


                $scope.formatosDownload = formatosDownload;

                var limiteDatas = maxDias.Quantidade;

                if($scope.formatosDownload)
                {
                    if($scope.formatosDownload.length == 0)
                    {
                        $scope.formatosDownload = [{
                            Nome : 'EXCEL',
                            Descricao : 'EXCEL'
                        }];                        
                    }
                    $scope.formatoDownload = $scope.formatosDownload[0].Nome;
                }
                

                $('.md-card-fullscreen-activate').on('click', function () {
                    var ifReport = $('#ifReport');
                    if (ifReport) {
                        ifReport.height(calculateHeight(true));
                    }
                });

                var calculateHeight = function (isClickFulled) {
                    var content = $('#page_content_inner');
                    var isFullscreen = $('.md-card-fullscreen', content).length || isClickFulled ? true : false;
                    var navbar = $('.uk-navbar').length && !isFullscreen ? ($('.uk-navbar')[0].clientHeight + 140) : 40;
                    var windowHeight = $(window).height() - navbar;
                    var headerBar = $('.md-card-toolbar', content).length > 0 ? $('.md-card-toolbar', content)[0].clientHeight : 200;
                    var headerParameter = $('.uk-accordion', content).length ? ($('.uk-accordion', content)[0].clientHeight == 0 ? 200 : $('.uk-accordion', content)[0].clientHeight) : 0;

                    return windowHeight - (headerBar + headerParameter);
                };

                var resizeReport = function () {
                    var ifReport = $('#ifReport');
                    if (ifReport) {
                        ifReport.height(calculateHeight(false));
                    }
                }

                $(window).resize(function () {
                    var ifReport = $('#ifReport');
                    if (ifReport) {
                        ifReport.height(calculateHeight(false));
                    }
                });

                $(window).trigger('resize');

                $scope.report = reportList;
                $scope.parametros = [];

                var populateParameters = function (parametroList) {
                    $scope.parametros = [];
                    
                    angular.forEach(parametroList, function (value) {
                        if (value.Parametro == 'UsuarioId') {
                            value.Visivel = false;
                        }
                        else {
                            value.Visivel = true;
                        }

                        if (value.ReportParametroTipoId == 3) { //Datetime
                            var data = new Date(new moment(value.ValorPadrao)).getDate() ? new Date(new moment(value.ValorPadrao)) : new Date(value.ValorPadrao);
                            value.ValorPadrao = new Date(data.getFullYear(), data.getMonth(), data.getDate());
                        } 
                        else if (value.ReportParametroTipoId == 1) {
                            value.ValorSelect = value.ValorPadrao ? value.ValorPadrao.split(',') : '';
                        }
                        else if (value.ReportParametroTipoId == 6) {
                            value.ValorSelect = value.ValorPadrao;
                        }

                        $scope.parametros.push(value);
                    });
                }

                populateParameters(parametroServerList);

                // ALTERAR PARA PEGAR URL ABSOLUTA                
                var absolutURL = Config.getUrlReport();
                var reportURL = reportList.ReportServidor.URLReport;
                var reportDomain = reportList.ReportServidor.Dominio;
                var reportUser = reportList.ReportServidor.Usuario;
                var reportPwd = reportList.ReportServidor.Senha;
                var reportPath = reportList.ReportPath;
                var reportParameter = '';

                if (!reportList.PossuiParametro) {
                    var urlElse = absolutURL + 'Pages/RenderReport.aspx?reportURL=' + reportURL + '&reportDomain=' + reportDomain + '&reportUser=' + reportUser + '&reportPwd=' + reportPwd + '&reportPath=' + reportPath + '&reportParameters=' + reportParameter;
                    $scope.viewerURL = urlElse;
                }

                var getToken = function getToken() {
                    return angular.fromJson($window.localStorage.getItem("Token") || "{}");
                };

                var ocultaFiltro = function () {
                    var accordion = $('[data-wrapper="true"]'),
                        accordionTitle = $('.uk-accordion-title');

                    if (accordion) {
                        accordion.attr('style', 'height: 0px; position: relative; overflow: hidden;');
                        accordion.attr('aria-expanded', 'false');
                    }

                    if (accordionTitle) {
                        accordionTitle.attr('class', 'uk-accordion-title');
                    }
                }

                $scope.executeFilter = function executeFilter() {
                    var frameExists = $('#ifReport');
                    var isValidParameters = true;
                    var Datai = new Date();
                    if (frameExists.length) {
                        frameExists.remove();
                    }

                    var cardFull = $('.md-card-fullscreen');
                    if (cardFull.length) {
                        cardFull.css('z-index', 1300);   
                    }

                    if ($scope.report.PossuiParametro) {
                        reportParameter = '';

                        var dataIParam;
                        var dataFParam;
                        var param = $scope.parametros.filter(x => x.ReportParametroTipoId == 3);
                        angular.forEach(param, function (obj, index) {
                            if(obj.Parametro.toUpperCase() =="DATAI") {
                                dataIParam = new moment(obj.ValorPadrao).format("YYYY/MM/DD");
                            } else {
                                dataFParam = new moment(obj.ValorPadrao).format("YYYY/MM/DD");
                            }
                        });

                        var dataDiff = moment(dataFParam, "YYYY/MM/DD").diff(moment(dataIParam, "YYYY/MM/DD"));
                        var qtdDias = moment.duration(dataDiff).asDays();

                        if(qtdDias > limiteDatas){
                            return NotifyService.showError(null, $translate.instant('modalViewReport.intervaloInvalido', {maxData : limiteDatas }));        
                        } else {
                            angular.forEach($scope.parametros, function (obj, index) {
                                var valorPadrao;
    
                                if (obj.ValorPadrao) {
                                    if (obj.ReportParametroTipoId == 3){
                                        valorPadrao = new moment(obj.ValorPadrao).format("YYYY/MM/DD");                                    
                                        if(obj.Parametro.toUpperCase() =="DATAI") {
                                            Datai = valorPadrao;
                                        }
                                        else {
                                            isValidParameters = Datai <= valorPadrao;
                                        }
                                    }
                                    else if (obj.ReportParametroTipoId == 1) {
                                        valorPadrao = obj.ValorSelect.join('|');
                                    }
                                    else if (obj.ReportParametroTipoId == 6) {
                                        valorPadrao = obj.ValorSelect;
                                    }
                                    else {
                                        valorPadrao = obj.ValorPadrao;
                                    }
                                }
    
                                if (!valorPadrao) {
                                    isValidParameters = false;
                                }
    
                                if (($scope.parametros.length - 1) == index) {
                                    reportParameter = reportParameter + '{"Nome" : "' + obj.Parametro + '","Valor" :  "' + valorPadrao + '"}';
                                }
                                else {
                                    reportParameter = reportParameter + '{"Nome" : "' + obj.Parametro + '","Valor" :  "' + valorPadrao + '"},';
                                }
                            });
                        }
                        
                        if (isValidParameters) {
                            reportParameter = '[' + reportParameter + ']';
                        }
                        else {
                            return NotifyService.showError(null, 'modalViewReport.paramentroInvalido');
                        }
                    }

                    $scope.viewerURL = absolutURL + 'Pages/RenderReport.aspx?reportURL=' + reportURL + '&reportDomain=' + reportDomain + '&reportUser=' + reportUser + '&reportPwd=' + encodeURIComponent(reportPwd) + '&reportPath=' + reportPath + '&reportParameters=' + reportParameter;

                    ModalService.showLoading();

                    var iframe = ('<iframe ng-src="{{ viewerURL | trusted}}" style="width:100%;height:600px" id="ifReport"></iframe>');

                    if ($('#dvIframe').length) {
                        $('#dvIframe').html($compile(iframe)($scope));
                    }

                    document.getElementById('ifReport').onload = function () {
                        ModalService.hideLoading();
                    };

                    ocultaFiltro();
                    resizeReport();
                };

                var getParametersDownload = function () {
                    var reportParameter = '',
                    isValidParameters = true;
                    var Datai = new Date();

                    var dataIParam;
                    var dataFParam;
                    var param = $scope.parametros.filter(x => x.ReportParametroTipoId == 3);
                    angular.forEach(param, function (obj, index) {
                        if(obj.Parametro.toUpperCase() =="DATAI") {
                            dataIParam = new moment(obj.ValorPadrao).format("YYYY/MM/DD");
                        } else {
                            dataFParam = new moment(obj.ValorPadrao).format("YYYY/MM/DD");
                        }
                    });

                    var dataDiff = moment(dataFParam, "YYYY/MM/DD").diff(moment(dataIParam, "YYYY/MM/DD"));
                    var qtdDias = moment.duration(dataDiff).asDays();

                    if(qtdDias > limiteDatas){
                        return NotifyService.showError(null, $translate.instant('modalViewReport.intervaloInvalido', {maxData : limiteDatas }));        
                    } else {
                        angular.forEach($scope.parametros, function (obj, index) {
                            var valorPadrao;
                            if (obj.ValorPadrao) {
                                if (obj.ReportParametroTipoId == 3){
                                    valorPadrao = new moment(obj.ValorPadrao).format("YYYY/MM/DD");                                    
                                    if(obj.Parametro.toUpperCase() =="DATAI") {
                                        Datai = valorPadrao;
                                    }
                                    else{
                                        isValidParameters = Datai <= valorPadrao;
                                    }
                                }
                                else if (obj.ReportParametroTipoId == 1){
                                    valorPadrao = obj.ValorSelect.join(',');
                                }
                                else if (obj.ValorSelect){
                                    valorPadrao = obj.ValorSelect;
                                }
                                else {
                                    valorPadrao = obj.ValorPadrao;
                                }
                            }
    
                            if (!valorPadrao) {
                                isValidParameters = false;
                            }
    
                            if (($scope.parametros.length - 1) == index) {
                                reportParameter = reportParameter + '"' + obj.Parametro + '":"' + valorPadrao + '"';
                            }
                            else {
                                reportParameter = reportParameter + '"' + obj.Parametro + '":"' + valorPadrao + '",';
                            }
                        });
                    }
                    
                    if (isValidParameters)
                        reportParameter = '{' + reportParameter + '}';
                    else {
                        return NotifyService.showError(null, 'modalViewReport.paramentroInvalido');
                    }

                    return reportParameter;
                }

                var generateUUID = function () {
                    var d = new Date().getTime();
                    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                    });
                    return uuid;
                };

                $scope.downloadReport = function () {
                    var parameters = getParametersDownload();                    
                    if (parameters === undefined) {
                        return;
                    }

                    ModalService.showLoading();
                    var teste = JSON.parse(parameters)
                    teste.id= $stateParams.ReportId;
                    ReportResource.downloadCSV(teste).$promise.then(data => {
                        var path = Config.getUrl("Report/DownloadCSVFile");
                        var token = getToken();
                        var params = {
                            fileName: data.FileName,
                            access_token: token.access_token,
                            token_type: 'bearer'
                        };
                        var url = [path, $.param(params)].join('?');
                        var iframe = $("<iframe src='" + url + "' style='display:none;' />");
                        iframe.appendTo("body");
                        ModalService.hideLoading();
                    }).catch(error =>{
                        NotifyService.showError(error);
                    })



                    // var formato = $scope.formatoDownload ? $scope.formatoDownload : "EXCEL";
                    // var fileName = generateUUID();
                    // var promise = ReportResource.generateReportDownload({
                    //     Parametros: parameters,
                    //     Formato: formato,
                    //     ReportId: $stateParams.ReportId,
                    //     Nome: fileName,
                    // }).$promise;

                    // if (promise) {
                    //     promise.then((generatedFile) => {
                    //         var path = Config.getUrl("Report/ReportDownload/" + generatedFile.FileName + "/" + generatedFile.Format);
                    //         var token = getToken();
                    //         var params = {
                    //             access_token: token.access_token,
                    //             token_type: 'bearer'
                    //         };
                    //         var url = [path, $.param(params)].join('?');
                    //         var iframe = $("<iframe src='" + url + "' style='display:none;' />");
                    //         iframe.appendTo("body");
                    //         ModalService.hideLoading();
                    //     }).catch((error) => {
                    //         NotifyService.showError(error);

                    //         if ($('.uk-notify').length) {
                    //             $('.uk-notify').css('z-index', 99999);
                    //         }
        
                    //         ModalService.hideLoading();
                    //     });
                    // }
                    // else {
                    //     NotifyService.showError();
                    //     ModalService.hideLoading();
                    // } 
                }

                $scope.carregarDados = function (parametro) {
                    if(parametro.Parametro == "CarteiraId")
                    {
                        let report;
                        
                        ReportParametroResource.getParametroListByCarteira({
                            reportId: parametro.ReportId,
                            carteiraId: parametro.ValorSelect.join(',')
                        }).$promise.then(data => {
                            report = data;           
                            
                            populateParameters(report);
                        });
                            
                        
                    }
                }
            }
        }])
    })
();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('ReportServidorEditData', function ReportServidorEditData() {
			return function () {
				return {
					reportServidor: ["ReportServidorResource", "$stateParams", function (ReportServidorResource, $stateParams) {
						if ($stateParams.ReportServidorId) {
							return ReportServidorResource.get({
								ReportServidorId: $stateParams.ReportServidorId
							}).$promise;
						} else {
							return {};
						}
					}]
				}
			}
		})

		.controller("ReportServidorEditController",
			["$scope", "$state", "reportServidor", "ReportServidorResource", "NotifyService", function ($scope, $state, reportServidor, ReportServidorResource, NotifyService) {
				$scope.isNew = !(reportServidor && reportServidor.ReportServidorId);
				$scope.reportServidor = reportServidor;
				$scope.reportServidor.Senha = "";
				$scope.reportServidor.SenhaDashboard = "";

				var mensagemSucesso = function (reportServidor) {
					NotifyService.showRegistroSalvo();
					if ($scope.Novo) {
						$scope.reportServidor = {};
					} else {
						$scope.reportServidor = reportServidor;
					}

					$state.go('main.reportservidor.list');
				};


				$scope.salvar = function salvar(form) {
					if (!form.$valid) {
						NotifyService.showInvalid();
						return;
					}

					var promise;

					if ($scope.reportServidor.ReportServidorId > 0) {
						promise = ReportServidorResource.update($scope.reportServidor).$promise;
					}
					else {
						delete $scope.reportServidor.Ramal;
						promise = ReportServidorResource.save($scope.reportServidor).$promise;
					}

					promise.then(mensagemSucesso).catch(NotifyService.showError);
				};

				$scope.voltar = function () {
					$state.go('main.reportservidor.list');
				};

			}]
		);

})();

(function () {
	"use strict";

	var getOdataSearchShared = function (ReportServidorResource, search, orderBy, $odata) {
		var odata = ReportServidorResource.odata();
		odata.orderBy(orderBy.column, orderBy.order);

		if (search.Url) {
			var predicate1 = new $odata.Predicate(new $odata.Func('contains', 'URLReport', search.Url), true);
			var combination = $odata.Predicate.or([predicate1]);
			odata.filter(combination);
		}

		return odata;
	};


	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.reportservidor", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.reportservidor.list',
						pageTitle: 'pageTitle.servidorDeReport',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.reportservidor.list", StateResolverProvider.configState("/reportservidor", "ReportServidor", "List", {
					pageTitle: 'pageTitle.servidorDeReport',
					pageName: 'pageTitle.pesquisar'
				}))
				.state("main.reportservidor.edit", StateResolverProvider.configState("/reportservidor/{ReportServidorId:[0-9]+}", "ReportServidor", "Edit", {
					pageTitle: 'pageTitle.servidorDeReport',
					pageName: 'acoes.editar'
				}))
				.state("main.reportservidor.new", StateResolverProvider.configState("/reportservidor/new", "ReportServidor", "Edit", {
					pageTitle: 'pageTitle.servidorDeReport',
					pageName: 'acoes.cadastrar'
				}));
		}])

		.service("ReportServidorListData", function ReportServidorListData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
					reportServidors: ["ReportServidorResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (ReportServidorResource, LocalStorageService, $odata, utils, $stateParams) {
						var filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroReportServidor");
						}

						var orderBy = {
							column: "ReportServidorId",
							order: "asc"
						};

						var odata = getOdataSearchShared(ReportServidorResource, filtro, orderBy, $odata, utils);
						return odata.page(10, 1).query();
					}]
				}
			}
		})

		.controller("ReportServidorListController", ["$scope", "$odata", "reportServidors", "ReportServidorResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", function ($scope, $odata, reportServidors, ReportServidorResource, utils, LocalStorageService, $stateParams,
			NotifyService, $state, ModalService) {
			$scope.reportServidors = reportServidors;
			$scope.searching = false;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroReportServidor") : {};
			$scope.orderBy = {
				column: "ReportServidorId",
				order: "asc"
			};

			var updateList = function (list) {
				$scope.reportServidors = list;
				$scope.reportServidors.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.reportServidors.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			var getOdataSearch = function () {
				return getOdataSearchShared(ReportServidorResource, $scope.search, $scope.orderBy, $odata, utils);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroReportServidor', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			var deleteRecord = function (data) {
				return ReportServidorResource.delete({ ReportServidorId: data.ReportServidorId }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.reportServidors.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			updateList(reportServidors);

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroReportServidor');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, {
						storage: true
					});
				}
				else {
					$state.go('main.reportservidor.list', {
						storage: true
					});
				}
			};
		
		}]);
	})
();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("ReportServidorResource", ["$odataresource", function ($odataresource) {
			return $odataresource("ReportServidor/:ReportServidorId", {
				"ReportServidorId": "@ReportServidorId"
			});
		}]);

})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")
		.controller("HistoricoController", ["$scope", "$window", "$translate", "ModalService", function ($scope, $window, $translate, ModalService) {
				$scope.predicate = '';
				$scope.reverse = false;
				$scope.order = function (predicate) {
					$scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
					$scope.predicate = predicate;
				};

				$scope.$on("carrega_rota_historico", function (event, historicoList) {
					$scope.historicos = [];
					$scope.historicos = historicoList;
				});

				$scope.viewHistoricoDetalhe = function (historico) {
					var msg = `<h2>${$translate.instant('modalHistorico.detalheDoHistorico')}: ${historico.Nome}</h2>
					<h4 class="uk-margin-remove">${$translate.instant('modalHistorico.mensagem')}</h4>${(historico.Descricao ? historico.Descricao : '')}</br>
					<h4 class="uk-margin-remove">${$translate.instant('modalHistorico.tipoDeHistorico')}</h4>
					${(historico.Exclusao ? $translate.instant('modalHistorico.exclusao') : $translate.instant('modalHistorico.edicao'))}</br>
					<h4 class="uk-margin-remove">${$translate.instant('modalHistorico.statusDaRota')}</h4>${historico.RotaStatusDescricao}</br>`;
					ModalService.alert(msg);
				}
			}]);
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.rotas.edit", StateResolverProvider.configState("/rotas/{RotaId:[0-9]+}", "Rota", "Edit", {
                    pageTitle: 'model.rotas',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.rotas.new", StateResolverProvider.configState("/rotas/new", "Rota", "Edit", {
                    pageTitle: 'model.rotas',
                    pageName: 'acoes.editar',
                    css: true
                }));
        }])

        .service('RotaEditData', function RotaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    rota: ["RotaResource", "$stateParams", function (RotaResource, $stateParams) {
                        if ($stateParams.RotaId) {
                            return RotaResource.get({
                                RotaId: $stateParams.RotaId
                            }).$promise;
                        } else {
                            return {
                                RotaId: 0,
                                Plano: {
                                    PlanoTarifa: [
                                        { ClasseId: 5, Tempo: 30, TempoMinimo: 3, Fracao: 6, ValorFranquia: 0, Valor: 0, Ativo: true, Padrao: true },
                                        { ClasseId: 12, Tempo: 30, TempoMinimo: 3, Fracao: 6, ValorFranquia: 0, Valor: 0, Ativo: true, Padrao: true },
                                        { ClasseId: 13, Tempo: 30, TempoMinimo: 3, Fracao: 6, ValorFranquia: 0, Valor: 0, Ativo: true, Padrao: true },
                                        { ClasseId: 14, Tempo: 30, TempoMinimo: 3, Fracao: 6, ValorFranquia: 0, Valor: 0, Ativo: true, Padrao: true },
                                        { ClasseId: 16, Tempo: 30, TempoMinimo: 3, Fracao: 6, ValorFranquia: 0, Valor: 0, Ativo: true, Padrao: true }
                                    ]
                                },
                                RotaRegra: [
                                    { ClasseId: 1, Preservar: 8, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 2, Preservar: 8, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 3, Preservar: 9, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 4, Preservar: 10, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 5, Preservar: 10, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 6, Preservar: 11, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 7, Preservar: 0, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 8, Preservar: 0, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 9, Preservar: 0, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 10, Preservar: 0, Corte: 0, TechPrefix: '', Ativo: true },
                                    { ClasseId: 11, Preservar: 0, Corte: 0, TechPrefix: '', Ativo: true }
                                ],
                                RotaServico: [],
                                Sip: { TempoRegister: 60, RotaSipStatusId: 1 }
                            };
                        }
                    }],
                    rotaList: ["RotaResource", function (RotaResource) {
                        return RotaResource.odata().select(["RotaId", "Nome", "RotaTipoId", "Ativo"]).query();
                    }],
                    tipos: ["RotaResource", function (RotaResource) {
                        return RotaResource.getTipos().$promise;
                    }],
                    protocolos: ["RotaResource", function (RotaResource) {
                        return RotaResource.getProtocolos().$promise;
                    }],
                    classes: ["RotaResource", function (RotaResource) {
                        return RotaResource.getClasses().$promise;
                    }],
                    operadoras: ["RotaResource", function (RotaResource) {
                        return RotaResource.getOperadoras().$promise;
                    }],
                    localidades: ["RotaResource", function (RotaResource) {
                        return RotaResource.getLocalidades().$promise;
                    }],
                    servicos: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.query().$promise;
                    }],
                    tiposCanal: ["RotaResource", function (RotaResource) {
                        return RotaResource.getTiposCanal().$promise;
                    }],
                    fornecedores: ["FornecedorResource", function (FornecedorResource) {
                        return FornecedorResource.query().$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        var odata = GrupoResource.odata().orderBy('Descricao', 'asc');
                        odata.filter("GrupoTipoId", "=", 1);
                        return odata.query();
                    }],
                    contas: ["ContaSipResource", function (ContaSipResource) {
                        return ContaSipResource.query().$promise;
                    }],
                    rotaCodecs: ["RotaResource", function (RotaResource) {
                        return RotaResource.getRotaCodecs().$promise;
                    }],                    
                    campanhaDiscagemStatus: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.odata().filter('PermiteTarifacao', true).query();
                    }],
                    permiteTarifacaoStatusDiscagem: ["RotaResource", function(RotaResource){
                        return RotaResource.PermiteTarifacaoStatusDiscagem();
                    }],
                    carteiras: ["RotaResource", function (RotaResource) {                   
                        return RotaResource.getCarteiras().$promise;
                    }]
                }
            }
        })

        .controller("RotaEditController", ["$scope", "$state", "$http", "Config", "WizardHandler", "RotaResource", "PlanoResource", "rota", "rotaList", "tipos", "protocolos", "classes", "operadoras", "localidades", "servicos", "tiposCanal", "fornecedores", "grupos", "contas", "NotifyService", "$translate", "ModalService", "rotaCodecs", "campanhaDiscagemStatus", "permiteTarifacaoStatusDiscagem", "carteiras", function ($scope, $state, $http, Config, WizardHandler, RotaResource, PlanoResource, rota, rotaList, tipos, protocolos,
            classes, operadoras, localidades, servicos, tiposCanal, fornecedores, grupos, contas, NotifyService, $translate, ModalService, rotaCodecs, campanhaDiscagemStatus,
            permiteTarifacaoStatusDiscagem, carteiras) {
            var formSelecionado;
            $scope.forms = {};
            $scope.grupos = grupos;
            $scope.RotaStepData = {
                order: 1
            };
            $scope.search = { ServicoAdicionado: '', ServicoNaoAdicionado: '' };
            $scope.isEdit = rota && rota.RotaId ? true : false;
            $scope.isNew = !rota.RotaId ? true : false;
            $scope.rota = rota;
            $scope.servicos = servicos;
            $scope.classes = classes;
            $scope.operadoras = operadoras;
            $scope.localidades = localidades;
            $scope.tipos = tipos;
            $scope.protocolos = protocolos;
            $scope.tiposCanal = tiposCanal;
            $scope.fornecedores = fornecedores;
            $scope.rotasReprocessamento = rotaList;
            $scope.contas = contas;
            $scope.rotaCodecs = rotaCodecs;
            $scope.campanhaDiscagemStatus = campanhaDiscagemStatus;
            $scope.permiteTarifacaoStatusDiscagem = permiteTarifacaoStatusDiscagem;
            $scope.carteiras = carteiras;
            
            if(!$scope.isNew){
                if(rota != null){
                    if(rota.CnpjCliente != null && rota.CnpjCliente.length > 0){
                        rota.chkCnpjCliente = true;
                    }
                }
            }

            $scope.bloqueiaComboFornecedor = function (rota) {
                return rota.RotaId && rota.FornecedorId ? true : false;
            };

            $scope.classesRotas = [
                { ClasseId: 1, Descricao: $translate.instant('telaEditRota.localFixo'), Preserva: true, Corte: false },
                { ClasseId: 2, Descricao: $translate.instant('telaEditRota.localCelular8Digitos'), Preserva: true, Corte: false },
                { ClasseId: 3, Descricao: $translate.instant('telaEditRota.localCelular9Digitos'), Preserva: true, Corte: false },
                { ClasseId: 4, Descricao: $translate.instant('telaEditRota.longaDistanciaFixo'), Preserva: true, Corte: false },
                { ClasseId: 5, Descricao: $translate.instant('telaEditRota.longaDistanciaCelular8Digitos'), Preserva: true, Corte: false },
                { ClasseId: 6, Descricao: $translate.instant('telaEditRota.longaDistanciaCelular9Digitos'), Preserva: true, Corte: false },
                { ClasseId: 7, Descricao: $translate.instant('telaEditRota.longaDistanciaInternacional'), Preserva: false, Corte: true },
                { ClasseId: 8, Descricao: $translate.instant('telaEditRota.servicosEspeciais'), Preserva: false, Corte: false },
                { ClasseId: 9, Descricao: $translate.instant('telaEditRota.servico0800'), Preserva: false, Corte: false },
                { ClasseId: 10, Descricao: $translate.instant('telaEditRota.servico0900'), Preserva: false, Corte: false },
                { ClasseId: 11, Descricao: $translate.instant('telaEditRota.servico0300'), Preserva: false, Corte: false }
            ];

            $scope.classeRotaConfig = {
                maxItems: 1,
                valueField: 'ClasseId',
                labelField: 'Descricao',
                placeholder: '--'
            };

            $scope.tipoCanalConfig = {
                maxItems: 1,
                valueField: 'RotaCanalTipoId',
                labelField: 'Descricao',
                placeholder: '--'
            };

            $scope.podePreservar = function (classeid) {
                var classe = _.findWhere($scope.classesRotas, { ClasseId: parseInt(classeid) });
                return !classe.Preserva;
            };

            $scope.podeCortar = function (classeid) {
                var classe = _.findWhere($scope.classesRotas, { ClasseId: parseInt(classeid) });
                return !classe.Corte;
            };

            var isLastStep = function () {
                return formSelecionado.$name == "forms.formTarifa" ? true : false;
            };

            var mensagemSucesso = function (response) {
                angular.copy(response, $scope.rota);
                NotifyService.showRegistroSalvo();
                formSelecionado.$setPristine();
                ModalService.hideLoading();
                if (isLastStep()) {
                    $state.go("main.rotas.list");
                }
            };

            $scope.validarSip = function () {
                $scope.forms.formConfiguracaoAvancada.$setDirty();
                $scope.forms.formConfiguracaoAvancada.$setSubmitted();
                return $scope.forms.formConfiguracaoAvancada.$valid ? true : false;
            };

            $scope.setTarifaDirty = function () {
                $scope.forms.formTarifa.$setDirty();
            };

            $scope.rotasCadastradas = [];

            $scope.salvar = function (form) {
                formSelecionado = form;
                form.$setSubmitted();
                if (!form.$valid) return;

                var lastStep = (form.$name == "forms.formTarifa") || (form.$name == "forms.formConfiguracaoAvancada" && $scope.rota.RotaTipoId == 6) ? true : false;

                if (!form.$dirty && !lastStep) {
                    WizardHandler.wizard().next();
                }

                var outroFormAlterado = ($scope.forms.formTipo.$dirty || $scope.forms.formServico.$dirty || $scope.forms.formConfiguracaoAvancada.$dirty);
                
                if (form.$dirty || $scope.isNew || outroFormAlterado) {
                    ModalService.showLoading();

                    $scope.rota.RotaServico = _.where($scope.rota.RotaServico, { Ativo: true });

                    if (!$scope.isNew) {
                        if (form.$name == "forms.formTarifa") {
                            if (outroFormAlterado) {
                                RotaResource.update($scope.rota).$promise;
                            }

                            PlanoResource.update($scope.rota.Plano).$promise
                                .then((responsePlano) => {
                                    mensagemSucesso(responsePlano);
                                }).catch((error) => {
                                    ModalService.hideLoading();
                                    NotifyService.showError(error);
                                });
                        } else {
                            RotaResource.update($scope.rota).$promise
                                .then((responseRota) => {
                                    mensagemSucesso(responseRota);
                                }).catch((error) => {
                                    ModalService.hideLoading();
                                    NotifyService.showError(error);
                                });
                        }
                    } else {
                        RotaResource.save($scope.rota).$promise
                            .then((responseRota) => {
                                mensagemSucesso(responseRota);
                                $state.go("main.rotas.list");
                            }).catch((error) => {
                                ModalService.hideLoading();
                                NotifyService.showError(error);
                            });
                    }
                } else {
                    setTimeout(() => { form.$setPristine(); }, 100)

                    if (lastStep && !formSelecionado.$dirty) {
                        $state.go("main.rotas.list");
                    }
                }
            };

            $scope.validarCanais = function (rota) {
                
                RotaResource.permiteConfigurarCanaisRota({ canalI: rota.CanalI, canalF: rota.CanalF }).$promise
                    .then((data) => {
                        if (data.MaquinaId > 0) {
                            NotifyService.showError(null, "O range de canais " + data.CanalRamalInicial + "  ao " + data.CanalRamalFinal + " estão reservados para logar ramais.")
                            return;
                        }
                    });

                RotaResource.AnalisaCanalRota({ canalI: rota.CanalI, canalF: rota.CanalF, id: rota.RotaId }).$promise
                    .then((data) => {
                        if (data.length > 0) {                
                            ModalService.alert('telaEditRota.analiseCanaisRota',{ 'Inicio': rota.CanalI, 'Final': rota.CanalF, 'Canais': data.map(x => x.Nome).join(", ")});
                        }
                    });
            }

            $scope.planoTarifa = {
                PlanoTarifaId: 0,
                ClasseId: 0,
                DDD: null,
                OperadoraId: null,
                Valor: 0,
                ValorFranquia: 0,
                Tempo: 30,
                Fracao: 6,
                TempoMinimo: 3,
                Ativo: true
            };

            $scope.openModalNovaRegra = function () {
                ModalService.openModal('modalNovoPlano');
                $scope.forms.formPlano.$setPristine();
                $scope.forms.formPlano.$setUntouched();
            };

            $scope.adicionar = function () {
                $scope.forms.formPlano.$setSubmitted();
                if (!$scope.planoTarifa.ClasseId) {
                    return NotifyService.showError(null, 'telaEditRota.preenchaOCampoClasseCorretamente');
                }
                $scope.rota.Plano.PlanoTarifa.push($scope.planoTarifa);

                $scope.planoTarifa = {
                    PlanoTarifaId: 0,
                    ClasseId: 0,
                    DDD: null,
                    OperadoraId: null,
                    Valor: 0,
                    ValorFranquia: 0,
                    Tempo: 30,
                    Fracao: 6,
                    TempoMinimo: 3,
                    Ativo: true
                };

                ModalService.closeModal('modalNovoPlano');
                $scope.forms.formTarifa.$setDirty();
            };

            $scope.delete = function (data) {
                ModalService.confirmDelete(() => data.Ativo = false);
                $scope.forms.formTarifa.$setDirty();
            };

            $scope.onBlurNome = function () {
                if ($scope.rota.Descricao == '' || $scope.rota.Descricao == undefined) {
                    $scope.rota.Descricao = $scope.rota.Nome;
                }
            };

            $scope.permiteAlteracao = function (p) {
                return p.OperadoraId && !p.DDD ? true : false;
            };

            $scope.onInitNumeroServico = function () {
                var servico = getServico($scope.rota.ServicoId);
                $scope.rota.NumeroServico = servico.Numero;
            };

            /*Corte NA */

            var getServico = function (id) {
                return _.findWhere(servicos, { ServicoId: parseInt(id) });
            };

            $scope.onInitValorCortado = function (form, obj) {
                var na, techPrefix, numeroFinal;
                if ($scope.rota.NumeroServico) {
                    na = $scope.rota.NumeroServico;
                    techPrefix = obj.TechPrefix || '';
                    var numeroCompleto = techPrefix + ' ' + na;
                    obj.NumeroCompleto = numeroCompleto;
                } else {
                    obj.NumeroCompleto = '';
                }

                if ($scope.rota.NumeroServico) {
                    na = $scope.rota.NumeroServico;
                    techPrefix = obj.TechPrefix || '';
                    if (obj.Preservar > 0) {
                        var tamanhoNA = na.length;
                        var preservar = obj.Preservar;
                        var inicial = tamanhoNA - preservar;
                        var valorPreservado = na.substring(inicial, tamanhoNA);
                        numeroFinal = techPrefix + valorPreservado;
                        obj.NumeroCortado = numeroFinal;
                    } else if (obj.Corte > 0) {
                        var posicao = obj.Corte || 0;
                        var numero = techPrefix + ' ' + na;
                        var array = numero.split(' ');
                        var numeroCortado = array[1].substring(0, posicao);
                        numeroFinal = numero.replace(numeroCortado, '');
                        obj.NumeroCortado = numeroFinal;
                    } else {
                        obj.NumeroCortado = techPrefix + na;
                    }
                } else {
                    obj.NumeroCortado = '';
                }

                setTimeout(function () {
                    form.$setPristine();
                }, 100)

            };

            $scope.onChangeValorCortado = function (obj) {
                var na, techPrefix, numeroFinal;
                if ($scope.rota.NumeroServico) {
                    na = $scope.rota.NumeroServico;
                    techPrefix = obj.TechPrefix || '';
                    var numeroCompleto = techPrefix + ' ' + na;
                    obj.NumeroCompleto = numeroCompleto;
                } else {
                    obj.NumeroCompleto = '';
                }

                if ($scope.rota.NumeroServico) {
                    na = $scope.rota.NumeroServico;
                    techPrefix = obj.TechPrefix || '';
                    if (obj.Preservar && obj.Preservar > 0) {
                        var tamanhoNA = na.length;
                        var preservar = obj.Preservar;
                        var inicial = tamanhoNA - preservar;
                        var valorPreservado = na.substring(inicial, tamanhoNA);
                        numeroFinal = techPrefix + valorPreservado;
                        obj.NumeroCortado = numeroFinal;
                    } else if (obj.Corte && obj.Corte > 0) {
                        var posicao = obj.Corte || 0;
                        var numero = techPrefix + ' ' + na;
                        var array = numero.split(' ');
                        var numeroCortado = array[1].substring(0, posicao);
                        numeroFinal = numero.replace(numeroCortado, '');
                        obj.NumeroCortado = numeroFinal;
                    } else {
                        obj.NumeroCortado = techPrefix + na;
                    }
                } else {
                    obj.NumeroCortado = '';
                }
            };

            $scope.atualizarTechPrefix = function () {
                angular.forEach(rota.RotaRegra, function (obj) {
                    var na, techPrefix, numeroFinal;
                    if ($scope.rota.NumeroServico) {
                        na = $scope.rota.NumeroServico;
                        techPrefix = obj.TechPrefix || '';
                        var numeroCompleto = techPrefix + ' ' + na;
                        obj.NumeroCompleto = numeroCompleto;
                    } else {
                        obj.NumeroCompleto = '';
                    }

                    if ($scope.rota.NumeroServico) {
                        na = $scope.rota.NumeroServico;
                        techPrefix = obj.TechPrefix || '';
                        if (obj.Preservar && obj.Preservar > 0) {
                            var tamanhoNA = na.length;
                            var preservar = obj.Preservar;
                            var inicial = tamanhoNA - preservar;
                            var valorPreservado = na.substring(inicial, tamanhoNA);
                            numeroFinal = techPrefix + valorPreservado;
                            obj.NumeroCortado = numeroFinal;
                        } else if (obj.Corte && obj.Corte > 0) {
                            var posicao = obj.Corte || 0;
                            var numero = techPrefix + ' ' + na;
                            var array = numero.split(' ');
                            var numeroCortado = array[1].substring(0, posicao);
                            numeroFinal = numero.replace(numeroCortado, '');
                            obj.NumeroCortado = numeroFinal;
                        } else {
                            obj.NumeroCortado = techPrefix + na;
                        }
                    } else {
                        obj.NumeroCortado = '';
                    }

                });

            };

            $scope.onServicoSelected = function () {
                if ($scope.rota.ServicoId) {
                    var servico = getServico($scope.rota.ServicoId)
                    $scope.rota.NumeroServico = servico.Numero;
                    $scope.atualizarTechPrefix();
                } else {
                    $scope.rota.NumeroServico = ' ';
                }
            };

            $scope.onChangeNumeroServico = function () {
                $scope.atualizarTechPrefix();
            };

            $scope.rota.NumeroServico = ' ';

            if ($scope.rota.ServicoId) {
                var servico = getServico($scope.rota.ServicoId);
                if (servico) {
                    $scope.rota.NumeroServico = servico.Numero;
                }
            }

            /* Serviço */
            $scope.servicosDisponiveis = [];

            $scope.getServicosDisponiveis = function () {
                $scope.servicosDisponiveis = [];
                angular.forEach($scope.rota.RotaServico, function (item) {
                    if (item.Ativo) {
                        $scope.servicosDisponiveis.push({ ServicoId: item.ServicoId, Numero: item.Numero });
                    }
                });
            };

            $scope.getServicosDisponiveis();

            $scope.servicosNaoAdiconados = [];

            angular.forEach(servicos, function (item) {
                var rotaServico = _.findWhere($scope.rota.RotaServico, { ServicoId: item.ServicoId });
                if (!rotaServico) {
                    $scope.servicosNaoAdiconados.push({ ServicoId: item.ServicoId, Numero: item.Numero, Descricao: item.Descricao, Ativo: true });
                }
            });

            $scope.adicionarServico = function () {
                const servicosNaoAdicionados = $scope.servicosNaoAdiconados;

                const servicosSelecionados = servicosNaoAdicionados.filter(s => s.Selecionado);

                servicosSelecionados.map(servico => {
                    servico.Ativo = true;
                    servico.Selecionado = false;
                    const servicoJaAdicionado = $scope.rota.RotaServico.find(s => s.ServicoId === servico.ServicoId);
                    if (servicoJaAdicionado) {
                        const index = $scope.rota.RotaServico.indexOf(servicoJaAdicionado);
                        $scope.rota.RotaServico[index].Ativo = true;
                    } else {
                        $scope.rota.RotaServico.push(servico);
                    }

                    const index = $scope.servicosNaoAdiconados.indexOf(servico);
                    $scope.servicosNaoAdiconados.splice(index, 1);
                })

                $scope.getServicosDisponiveis();
            };

            $scope.removerServico = function () {

                angular.forEach($scope.rota.RotaServico, function (item) {
                    if (item.Selecionado && item.Ativo) {
                        $scope.servicosNaoAdiconados.push({ ServicoId: item.ServicoId, Numero: item.Numero, Descricao: item.Descricao });
                        item.Ativo = false;
                    }
                });

                $scope.getServicosDisponiveis();
            };

            $scope.todosServicosAdicionados = false;
            $scope.todosServicosNaoAdicionados = false;

            $scope.selectionarTodosAdicionados = function (selecionado) {
                angular.forEach($scope.rota.RotaServico, function (item) {
                    if (selecionado) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.selectionarTodosNaoAdicionados = function (selecionado) {
                angular.forEach($scope.servicosNaoAdiconados, function (item) {
                    if (selecionado) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.getTotalServicosAdicionados = function () {
                var servicos = _.where(rota.RotaServico, { Ativo: true });
                return servicos.length;
            };

            /* Reprocessa Tarifa */
            $scope.reprocessa = {
                DataI: '',
                DataF: '',
                RotaId: $scope.rota.RotaId,
                IsEdit: true
            };

            $scope.reprocessamentos = [];

            $scope.getHistoricoReprocessamento = function (rotaId) {
                $scope.reprocessamentos = [];
                $http.get(Config.getUrl("Rota/HistoricoReprocessamentoTarifa/") + rotaId).then((response) => $scope.reprocessamentos = response.data);
            };

            $scope.reprocessaTarifa = function (form) {
                try {
                    if (!form.$valid) return;
                    var dataI = moment($scope.reprocessa.DataI);
                    var dataF = moment($scope.reprocessa.DataF);
                    var dateDiff = dataI.diff(dataF, 'days');

                    if (dataI > dataF) {
                        return NotifyService.showError(null, 'telaEditRota.dataINaoPodeSerMaiorQueDataF');
                    }

                    if (dateDiff > 30) {
                        return NotifyService.showError(null, 'telaEditRota.periodoNaoPodeSerMaiorQue30Dias');
                    }

                    var processamento = _.findWhere($scope.reprocessamentos, { Processado: false });

                    if (processamento) {
                        return NotifyService.showError(null, 'telaEditRota.existeUmReprocessamentoEmAndamento');
                    }

                    RotaResource.reprocessaTarifa($scope.reprocessa).$promise
                        .then(() => {
                            $scope.getHistoricoReprocessamento($scope.reprocessa.RotaId);
                            $scope.reprocessa = { DataI: '', DataF: '', RotaId: 0, IsEdit: true };
                            NotifyService.showSuccess('telaEditRota.reprocessamentoCriadoComSucesso');
                            ModalService.closeModal('modal_reprocessa_tarifa_list');
                        });
                } catch (e) {
                    NotifyService.showError(e);
                }
            };

            $('#modal_reprocessa_tarifa').on({
                'show.uk.modal': function () {
                    if ($scope.isEdit) {
                        var rotaId = $scope.rota.RotaId || 0;
                        $scope.reprocessa.RotaId = rotaId;
                        $scope.getHistoricoReprocessamento(rotaId);
                    }
                }
            });

            $scope.exibirDetalhe = function (descricao) {
                ModalService.alert("<h3>Detalhe</h3>" + descricao);
            };

            $scope.getRotaPorRangeCanal = function (callbackSuccess, callbackError) {
                var data = {
                    CanalI: $scope.rota.CanalI,
                    CanalF: $scope.rota.CanalF
                }
                return $http({ method: 'GET', url: Config.getUrl("Rota/RangeCanais"), params: data }).then(callbackSuccess).catch(callbackError);
            };


            $scope.onChangeRotaTipo = function () {
                $scope.rota.RotaProtocoloId = null;

                if ($scope.rota.RotaTipoId == 4) {
                    $scope.rota.RotaCanalTipoId = 1;
                }

                if ($scope.rota.RotaTipoId == 6) {
                    $scope.rota.RotaProtocoloId = 4;
                    $scope.rota.RotaCanalTipoId = 1;
                }
            };

            $scope.onChangeEncaminhamento = function () {
                if ($scope.rota.Encaminhamento) {
                    $scope.rota.DiscagemRandomica = false;
                }
            };

            $scope.onChangeDiscagemRandomica = function () {
                if ($scope.rota.DiscagemRandomica) {
                    $scope.rota.Sobrescrever = false;
                }
            };

            $scope.onChangeProtocolo = function () {
                // Caso o protocolo for SIP o tipo de canal deverá, necessariamente, ser circular
                if ($scope.rota.RotaProtocoloId === 4) {
                    $scope.rota.RotaCanalTipoId = 1
                }
            }

        }]);

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .controller("RotaFallbackController", ["$scope", "ModalService", "NotifyService", "RotaResource", function ($scope, ModalService, NotifyService, RotaResource) {

            $scope.causas = [];
            $scope.CausasNaoAdicionadas = [];
            $scope.CausasAdicionadas = [];
            $scope.salvando = false;
            $scope.search = { causa: null, exibirSucessos: false };

            $scope.descricoesColunas = {
                CausaCodigo: 'campo.nome',
                Alias: 'campo.descricao'
            }

            $scope.$on("carrega_rota_fallback", function (event, causas) {
                $scope.causas = causas;
                $scope.CausasNaoAdicionadas = $scope.causas.filter((el) => !el.RealizaFallback);
                $scope.CausasAdicionadas = $scope.causas.filter((el) => el.RealizaFallback == true);
            });

            $scope.filtrarLista = function (causa) {
                const pesquisaVazia = $scope.search.causa == null || $scope.search.causa == '';
                let contemCodigo = false, contemDescricao = false;
                if (pesquisaVazia == false) {
                    contemCodigo = causa.CausaCodigo == $scope.search.causa;
                    contemDescricao = causa.Alias.toLowerCase().indexOf($scope.search.causa.toLowerCase()) >= 0;
                }
                return ($scope.search.exibirSucessos || causa.CausaCodigo >= 400) && (contemCodigo || contemDescricao || pesquisaVazia);
            }

            $scope.filtrarListaAdicionado = function (causa) {
                const pesquisaVazia = $scope.search.causa == null || $scope.search.causa == '';
                let contemCodigo = false, contemDescricao = false;
                if (pesquisaVazia == false) {
                    contemCodigo = causa.CausaCodigo == $scope.search.causa;
                    contemDescricao = causa.Alias.toLowerCase().indexOf($scope.search.causa.toLowerCase()) >= 0;
                }
                return contemCodigo || contemDescricao || pesquisaVazia;
            }

            $scope.alterarFallback = function (causa) {
                if (causa.CausaCodigo < 400) {
                    ModalService.confirmMessage('modalFallback.cuidadoCausaSucesso', null, () => {
                        causa.Selecionada = true;
                    });
                }
            }

            $scope.adicionarCausa = function () {
                const causasSelecionadas = _.where($scope.CausasNaoAdicionadas, {
                    Selecionada: true
                });

                const finalizarAdicionarCausas = (causasSelecionadas) => {
                    causasSelecionadas.forEach((item) => {
                        item.Selecionada = false;
                        $scope.CausasAdicionadas.push(item);
                        $scope.CausasNaoAdicionadas.splice($scope.CausasNaoAdicionadas.indexOf(item), 1);
                    });

                    if (causasSelecionadas.length > 0)
                        $scope.modalCausaAlterada = true;
                }

                if (causasSelecionadas.some(el => el.CausaCodigo < 400)) {
                    const causasFormatadas = causasSelecionadas.filter(el => el.CausaCodigo < 400).map(el => el.CausaCodigo).join(", ");
                    ModalService.confirmMessage('modalFallback.cuidadoCausaSucesso', { causas: causasFormatadas }, () => {
                        finalizarAdicionarCausas(causasSelecionadas);
                    });
                } else {
                    finalizarAdicionarCausas(causasSelecionadas);
                }
            };

            $scope.removerCausa = function () {
                const causasSelecionadas = _.where($scope.CausasAdicionadas, {
                    Selecionada: true
                });

                causasSelecionadas.forEach(function (item) {
                    item.Selecionada = false;
                    $scope.CausasNaoAdicionadas.push(item);
                    $scope.CausasAdicionadas.splice($scope.CausasAdicionadas.indexOf(item), 1);
                });

                if (causasSelecionadas.length > 0)
                    $scope.modalCausaAlterada = true;
            };

            $scope.onExibirSucessoAlterado = function () {
                if (!$scope.search.exibirSucessos) {
                    $scope.CausasNaoAdicionadas.forEach(item => {
                        if (item.CausaCodigo < 400) {
                            item.Selecionada = false;
                        }
                    })
                }
            }

            $scope.selecionarTodasAdicionadas = function (todosAdicionadas) {
                $scope.CausasAdicionadas.forEach((item) => {
                    if (todosAdicionadas) {
                        item.Selecionada = true;
                    } else {
                        item.Selecionada = false;
                    }
                });
            };

            $scope.selecionarTodasNaoAdicionadas = function (todosNaoAdicionadas) {
                $scope.CausasNaoAdicionadas.forEach((item) => {
                    if (todosNaoAdicionadas) {
                        if ($scope.search.exibirSucessos || item.CausaCodigo >= 400) {
                            item.Selecionada = true;
                        }
                    } else {
                        item.Selecionada = false;
                    }
                });
            };

            $scope.salvar = function () {
                ModalService.confirmMessage('modalFallback.avisoSalvarFallback', null, () => {
                    $scope.salvando = true;
                    const causasFallback = _.map($scope.CausasAdicionadas, (el) => el.CausaCodigo);
                    RotaResource.atualizarFallback(causasFallback).$promise
                        .then(() => {
                            $scope.salvando = false;
                            $scope.causas = [];
                            NotifyService.showSuccess();
                            ModalService.closeModal('modal_fallback');
                        });
                });
            }

            $scope.cancelar = function () {
                $scope.causas = [];
                $scope.salvando = false;
                ModalService.closeModal('modal_fallback');
            }
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (RotaResource, search, orderBy, $odata) {
        var odata = RotaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Nome"), search.Nome.toLowerCase()), true);
        }
        if (search.RotaTipoId) {
            odata.filter('RotaTipoId', parseInt(search.RotaTipoId));
        }
        if (search.RotaStatusId) {
            odata.filter('RotaStatusId', parseInt(search.RotaStatusId));
        }
        if (search.Id) {
            odata.filter('CarteiraId', parseInt(search.Id));
        }

        odata.filter('Ativo', search.Ativo);

        return odata;
    }

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.rotas", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.rotas.list',
                        pageTitle: 'model.rotas',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.rotas.list", StateResolverProvider.configState("/rotas", "Rota", "List", {
                    pageTitle: 'model.rotas',
                    pageName: 'pageTitle.pesquisar',
                    css: true
                }));
        }])

        .service("RotaListData", function RotaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_iCheck'
                        ]);
                    }],
                    rotas: ["RotaResource", "LocalStorageService", "$odata", "$stateParams", function (RotaResource, LocalStorageService, $odata, $stateParams) {

                        var filtro = { Ativo: true };

                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroRota");

                        var orderBy = {
                            column: "RotaId",
                            order: "asc"
                        }

                        var odata = getOdataSearchShared(RotaResource, filtro, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }],
                    tipos: ["RotaResource", function (RotaResource) {
                        return RotaResource.getTipos().$promise;
                    }],
                    status: ["RotaResource", function (RotaResource) {
                        return RotaResource.getStatus().$promise;
                    }],
                    carteiras: ["ServicoResource", function (ServicoResource) {                   
                        return ServicoResource.getCarteiras().$promise;
                    }]
                }
            }
        })

        .controller("RotaListController", ["$scope", "$odata", "$state", "$translate", "$stateParams", "$q", "RotaResource", "RegraRoteamentoResource", "BilheteCausaResource", "rotas", "tipos", "status", "NotifyService", "LocalStorageService", "ModalService", "carteiras", function ($scope, $odata, $state, $translate, $stateParams, $q,
            RotaResource, RegraRoteamentoResource, BilheteCausaResource, rotas, tipos, status,
            NotifyService, LocalStorageService, ModalService, carteiras) {
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroRota") : { Ativo: true };
            $scope.rotas = rotas;

            $scope.rotaTipoList = tipos;
            $scope.rotaStatusList = status;
            $scope.historicoList = [];
            $scope.carteiras = carteiras;

            $scope.orderBy = {
                column: "RotaId",
                order: "asc"
            };

            function analiseRota(){
                setTimeout(() => {
                    $scope.rotas.forEach(rota => {
                        RotaResource.AnalisaCanalRota({ canalI: rota.CanalI, canalF: rota.CanalF, id: rota.RotaId }).$promise
                        .then((data) => {
    
                            if (data.length > 0) {                
                                rota.Conflito = true;
                            }else{
                                rota.Conflito = false;
                            }
                            rota.ConflitoList = data;
                            rota.ConflitoTitle = $translate.instant('telaRotas.analiseCanaisRota',{ 'Inicio': rota.CanalI, 'Final': rota.CanalF, 'Canais': rota.ConflitoList.map(x => x.Nome).join(", ")})
                        });
                    })
                }, 100);
            }

            var updateList = function (list) {
            
                $scope.rotas = list.map(x => {

                    return {
                        Ativo: x.Ativo,
                        Canal: "[" + x.CanalI + ";" + x.CanalF + "]",
                        CanalF: x.CanalF,
                        CanalI: x.CanalI,
                        CarteiraId: x.CarteiraId,
                        CarteiraNome: x.CarteiraNome,
                        ContaSip: x.ContaSip,
                        ContaSipId: x.ContaSipId,
                        DataAlteracao: x.DataAlteracao,
                        DataCadastro: x.DataCadastro,
                        Dominio: x.Dominio,
                        Encaminhamento: x.Encaminhamento,
                        FornecedorId: x.FornecedorId,
                        IsContaSip: x.IsContaSip,
                        Nome: x.Nome,
                        PlanoId: x.PlanoId,
                        Porta: x.Porta,
                        RotaCanalTipoId: x.RotaCanalTipoId,
                        RotaCtiId: x.RotaCtiId,
                        RotaId: x.RotaId,
                        RotaProtocolo: x.RotaProtocolo,
                        RotaProtocoloId: x.RotaProtocoloId,
                        RotaStatus: x.RotaStatus,
                        RotaStatusId: x.RotaStatusId,
                        RotaTipo: x.RotaTipo,
                        RotaTipoId: x.RotaTipoId,
                        ServicoId: x.ServicoId,
                        Sobrescrever: x.Sobrescrever,
                        StatusIntegracaoId: x.StatusIntegracaoId,
                        UsuarioAlteracao: x.UsuarioAlteracao,
                        UsuarioCadastro: x.UsuarioCadastro,
                        Conflito: false
                    };
                });

                $scope.rotas.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.rotas.pageSize = list.$pageSize || 10;
                $scope.searching = false;

                analiseRota();
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(RotaResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroRota', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var deleteRecord = function (data) {
                return RotaResource.delete({ RotaId: data.RotaId }).$promise
                    .then(() => {
                        RegraRoteamentoResource.deleteRegraByRota({ RotaId: data.RotaId }).$promise;
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage);
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                var regras = [];
                RegraRoteamentoResource.getRegraByRota({ rotaId: data.RotaId }).$promise
                    .then((result) => {
                        angular.copy(result, regras);
                        if (regras.length > 0) {
                            var msg = `${$translate.instant('telaRotas.estaRotaEstaContidaNasRegras')}: <br/>`;
                            angular.forEach(regras, function (value) {
                                msg += "&#8594; <b>" + value.Nome + "</b><br/>";
                            });
                            msg += `<br/><br/>${$translate.instant('telaRotas.confirmDelete')}`;
                            ModalService.confirmMessage(msg, null, () => deleteRecord(data));
                        }
                        else {
                            ModalService.confirmDelete(() => deleteRecord(data));
                        }
                    });
            };

            $scope.pageChanged = function (newPage) {
                ModalService.showLoading();
                return getOdataSearch().page($scope.rotas.pageSize, newPage).query()
                    .then((list) => {
                        updateList(list);
                        ModalService.hideLoading();
                    }).catch((error) => {
                        NotifyService.showError(error);
                        ModalService.hideLoading();
                    });
            };

            updateList(rotas);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroRota');
                $scope.search = {
                    Ativo: true,
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            $scope.changeStatus = function (rota) {
                if (rota.RotaStatusId == 1) {
                    rota.RotaStatusId = 2;
                }
                else {
                    rota.RotaStatusId = 1;
                }
                RotaResource.alterarStatus(rota).$promise.then(() => NotifyService.showSuccess());
            };

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, { storage: true });
                }
                else {
                    $state.go('main.rotas.list', { storage: true });
                }
            };

            $scope.viewHistorico = function (rota) {
                $scope.rotaNome = rota.Nome;
                RotaResource.getHistorico({ RotaId: rota.RotaId }).$promise
                    .then((data) => {
                        angular.copy(data, $scope.historicoList);
                        ModalService.openModal('modal_historico');
                        $scope.$broadcast('carrega_rota_historico', $scope.historicoList);
                    });
            };
            $scope.editarFallback = function () {
                ModalService.showLoading();
                const promises = [];
                promises.push(BilheteCausaResource.getPorPlataforma().$promise);
                promises.push(RotaResource.getFallback().$promise);
                $q.all(promises)
                    .then((data) => {
                        const causas = data[0];
                        const fallbacks = data[1];
                        causas.forEach(causa => {
                            causa.RealizaFallback = _.any(fallbacks, (fallback) => fallback.CausaCodigo == causa.CausaCodigo)
                        });
                        ModalService.openModal('modal_fallback');
                        $scope.$broadcast('carrega_rota_fallback', causas);
                    })
                    .finally(ModalService.hideLoading);
            };
            
        }]);
})
    ();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("RotaResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "Rota/:RotaId",
                {
                    "RotaId": "@RotaId"
                },
                {
                    getTipos: {
                        url: "Rota/Tipo",
                        method: "GET",
                        isArray: true
                    },
                    getProtocolos: {
                        url: "Rota/Protocolo",
                        method: "GET",
                        isArray: true
                    },
                    getStatus: {
                        url: "Rota/Status",
                        method: "GET",
                        isArray: true
                    },
                    getClasses: {
                        url: "Rota/Classe",
                        method: "GET",
                        isArray: true
                    },
                    getLocalidades: {
                        url: "Rota/Localidade",
                        method: "GET",
                        isArray: true
                    },
                    getOperadoras: {
                        url: "Rota/Operadora",
                        method: "GET",
                        isArray: true
                    },
                    getTiposCanal: {
                        url: "Rota/CanalTipo",
                        method: "GET",
                        isArray: true
                    },
                    getHistorico: {
                        url: "Rota/Historico",
                        method: "GET",
                        isArray: true
                    },
                    getRotaMonitoria: {
                        url: "Rota/RotaMonitoria",
                        method: "GET",
                        isArray: true
                    },
                    getRotaByRotaTipoIds: {
                        url: "Rota",
                        method: "GET",
                        isArray: true
                    },
                    reprocessaTarifa: {
                        url: "Rota/ReprocessaTarifa",
                        method: "POST",
                    },
                    alterarStatus: {
                        url: "Rota/AlterarStatus",
                        method: "PUT",
                    },
                    getRotaByFornecedorId: {
                        url: "Rota/GetRotaByFornecedor",
                        method: "GET",
                        isArray: true
                    },
                    getHistoricoReprocessamento: {
                        url: "Rota/HistoricoReprocessamentoTarifa/:rotaId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "rotaId": "@rotaId"
                        }
                    },
                    getFallback: {
                        url: "Rota/Fallback",
                        method: "GET",
                        isArray: true
                    },
                    atualizarFallback: {
                        url: "Rota/Fallback",
                        method: "PUT"
                    },
                    permiteConfigurarCanaisRota: {
                        url: "Rota/PermiteConfigurarCanaisRota/:canalI/:canalF",
                        method: "GET",
                        params: {
                            "canalI": "@canalI",
                            "canalF": "@canalF",
                        }
                    },
                    AnalisaCanalRota: {
                        url: "Rota/AnalisaCanalRota/:canalI/:canalF/:id",
                        method: "GET",
                        params: {
                            "canalI": "@canalI",
                            "canalF": "@canalF",
                            "id": "@id",
                        },
                        isArray: true
                    },
                    getRotaCodecs: {
                        url: "Rota/RotaCodec",
                        method: "GET",
                        isArray: true
                    },
                    PermiteTarifacaoStatusDiscagem: {
                      url: "Rota/PermiteTarifacaoStatusDiscagem",
                      method: "GET",
                      isArray: false
                    },
                    getCarteiras: {
                        url: "Carteira",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);

})();
(function () {
    "use strict";

    angular
        .module("epbxManagerApp")

         // configuração da rota
         .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

             $stateProvider
                 .state("main.segurancachaveapilist.new", StateResolverProvider.configState("/chaveapi/new", "SegurancaChaveApi", "Edit", { pageTitle: 'Chaves Api - Novo' }))
                 .state("main.segurancachaveapilist.edit", StateResolverProvider.configState("/chaveapi/{SegurancaChaveApiId:[0-9]+}", "SegurancaChaveApi", "Edit", { pageTitle: 'Chaves Api - Editar' }))
         }])

        // dependencias para o controller
        .service('SegurancaChaveApiEditData', function SegurancaChaveApiEditData() {
            return function () {
                return {
                    segurancachaveapi: ["SegurancaChaveApiResource", "$stateParams", function (SegurancaChaveApiResource, $stateParams) {
                        if ($stateParams.SegurancaChaveApiId) {
                            return SegurancaChaveApiResource.get({ SegurancaChaveApiId: $stateParams.SegurancaChaveApiId }).$promise;
                        }
                        else {
                            return {};
                        }
                    }]
                }
            }
        })

        .controller("SegurancaChaveApiEditController",
            ["$scope", "segurancachaveapi", "SegurancaChaveApiResource", "NotifyService", function ($scope, segurancachaveapi, SegurancaChaveApiResource, NotifyService) {
                $scope.InserirOuEditar = segurancachaveapi && segurancachaveapi.SegurancaChaveApiId ? "Editar" : "Inserir";
                $scope.segurancachaveapi = segurancachaveapi;

                $scope.salvar = function salvar() {
                    var promise;
                    if ($scope.segurancachaveapi.SegurancaChaveApiId > 0)
                        promise = SegurancaChaveApiResource.update($scope.segurancachaveapi).$promise;
                    else
                        promise = SegurancaChaveApiResource.save($scope.segurancachaveapi).$promise;

                    promise.then(function () {
                        NotifyService.showRegistroSalvo();
                        $scope.segurancachaveapi = {};
                    }).catch(NotifyService.showError);
                };
            }]
        );

})();
(function () {
    "use strict";

    var pageSizeDefault = 30;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

            $stateProvider
              .state("main.segurancachaveapi", StateResolverProvider.configAbstract())
              .state("main.segurancachaveapi.list", StateResolverProvider.configState("/chaveapi", "SegurancaChaveApi", "List", { pageTitle: 'Chaves Api' })
            );
        }])

        .service("SegurancaChaveApiListData", function SegurancaChaveApiListData() {
            return function () {
                return {
                    segurancachaveapilist: ["SegurancaChaveApiResource", function (SegurancaChaveApiResource) {
                        return SegurancaChaveApiResource.odata().orderBy("SegurancaChaveApiId", "asc").page(pageSizeDefault, 1).query();
                    }]
                }
            }
        })

        .controller("SegurancaChaveApiListController",
        ["$scope", "$window", "$odata", "segurancachaveapilist", "SegurancaChaveApiResource", "NotifyService", function ($scope, $window, $odata, segurancachaveapilist, SegurancaChaveApiResource, NotifyService) {

            $scope.segurancachaveapilist = segurancachaveapilist;
            $scope.search = {};

            var updateList = function (list) {
                $scope.segurancachaveapilist = list;
                $scope.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.search.pageSize = list.$pageSize || pageSizeDefault;
            }

            var getOdataSearch = function () {
                var odata = SegurancaChaveApiResource.odata().orderBy("SegurancaChaveApiId", "asc");
                var search = $scope.search;

                if (search.Descricao) {
                    odata.filter(new $odata.Func("contains", "Descricao", search.Descricao), true);
                }

                return odata;
            }

            $scope.executeSearch = function executeSearch() {
                getOdataSearch()
                .page($scope.search.pageSize, 1)
                .query().then(updateList).catch(NotifyService.showError);
            }

            var deleteRecord = function (data) {
                return function () {
                    SegurancaChaveApiResource.delete(data).$promise
                    .then(function () { $scope.pageChanged($scope.currentPage) })
                    .catch(NotifyService.showError);
                }
            }

            $scope.confirmDelete = function confirmDelete(data) {
                $window.UIkit.modal.confirm("Deseja realmente excluir este registro? Esta alteração não poderá ser desfeita.", deleteRecord(data));
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                      .page($scope.search.pageSize, newPage)
                      .query().then(updateList).catch(NotifyService.showError);
            };

            updateList(segurancachaveapilist);

        }]);

})();

(function() {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("SegurancaChaveApiResource", ["$odataresource", function($odataresource) {
      return $odataresource("SegurancaChaveApi/:SegurancaChaveApiId", { "SegurancaChaveApiId" : "@SegurancaChaveApiId" });
    }]);

})();

(function () {
    "use strict";

    angular
        .module("epbxManagerApp")

        .service("ServicoEditData", function ServicoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_masked_inputs",
                            "lazy_uiSelect",
                            "lazy_wizard",
                        ]);
                    }],
                    servico: ["ServicoResource", "$stateParams", function (ServicoResource, $stateParams) {
                        if ($stateParams.ServicoId) {
                            return ServicoResource.get({
                                ServicoId: $stateParams.ServicoId,
                            }).$promise;
                        } else {
                            return {
                                Integrar: true,
                                ConsultaBlocklist: true,
                                ServicoId: 0,
                                ServicoTipoId: 1,
                                PeriodoAnaliseFila: 30,
                            };
                        }
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.odata()
                            .orderBy("Descricao", "asc")
                            .filter("GrupoTipoId", "!=", 2)
                            .query();
                    }],
                    ramaltipos: ["RamalTipoResource", function (RamalTipoResource) {
                        return RamalTipoResource.odata()
                            .orderBy("Descricao", "asc")
                            .query();
                    }],
                    ramais: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "1" })
                            .$promise;
                    }],
                    urasDisponiveisAssociarDdr: ["UraResource", function (UraResource) {
                        return UraResource.getUrasDisponiveisAssociarDdr().$promise;
                    }],
                    campanhas: ["CampanhaResource", function (CampanhaResource) {
                        return CampanhaResource.odata()
                            .orderBy("Nome", "asc")
                            .filter("CampanhaTemplateId", "=", 2)
                            .query();
                    }],
                    fornecedores: ["FornecedorResource", function (FornecedorResource) {
                        return FornecedorResource.query().$promise;
                    }],
                    maquinas: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.odata()
                            .filter("MaquinaStatusId", "=", 1)
                            .query();
                    }],
                    tiposCallback: ["UraCallbackTipoResource", function (UraCallbackTipoResource) {
                        return UraCallbackTipoResource.query().$promise;
                    }],
                    classes: ["RotaResource", function (RotaResource) {
                        return RotaResource.getClasses().$promise;
                    }],
                    operadoras: ["RotaResource", function (RotaResource) {
                        return RotaResource.getOperadoras().$promise;
                    }],
                    localidades: ["RotaResource", function (RotaResource) {
                        return RotaResource.getLocalidades().$promise;
                    }],
                    urasTalkbot: ["UraTalkbotResource", function (UraTalkbotResource) {
                        return UraTalkbotResource.query().$promise;
                    }],
                    carteiras: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.getCarteiras().$promise;
                    }],
                    urasPesquisaNaoAssociada: ["ServicoResource", "$stateParams", function (ServicoResource, $stateParams) {
                        var servicoId = $stateParams.ServicoId ? $stateParams.ServicoId : 0;
                        return ServicoResource.uraPesquisaNaoAssociada({
                            id: servicoId,
                        }).$promise;
                    }],
                    urasPesquisaAssociada: ["ServicoResource", "$stateParams", function (ServicoResource, $stateParams) {
                        var servicoId = $stateParams.ServicoId ? $stateParams.ServicoId : 0;
                        return ServicoResource.uraPesquisaAssociada({
                            id: servicoId,
                        }).$promise;
                    }],
                };
            };
        })

        .filter("propsFilter", function () {
            return function (items, props) {
                let out = [];
                if (angular.isArray(items)) {
                    items.forEach(function (item) {
                        let itemMatches = false;
                        let keys = Object.keys(props);
                        for (var i = 0; i < keys.length; i++) {
                            let prop = keys[i];
                            let text = props[prop].toLowerCase();
                            if (
                                item[prop]
                                    .toString()
                                    .toLowerCase()
                                    .indexOf(text) !== -1
                            ) {
                                itemMatches = true;
                                break;
                            }
                        }
                        if (itemMatches) {
                            out.push(item);
                        }
                    });
                } else {
                    out = items;
                }
                return out;
            };
        })

        .controller(
            "ServicoEditController",
            ["$scope", "$state", "servico", "grupos", "ServicoResource", "urasDisponiveisAssociarDdr", "ramais", "campanhas", "fornecedores", "RotaResource", "WizardHandler", "maquinas", "tiposCallback", "classes", "operadoras", "localidades", "PlanoResource", "NotifyService", "$translate", "ModalService", "urasTalkbot", "carteiras", "urasPesquisaNaoAssociada", "urasPesquisaAssociada", function ($scope,
                $state,
                servico,
                grupos,
                ServicoResource,
                urasDisponiveisAssociarDdr,
                ramais,
                campanhas,
                fornecedores,
                RotaResource,
                WizardHandler,
                maquinas,
                tiposCallback,
                classes,
                operadoras,
                localidades,
                PlanoResource,
                NotifyService,
                $translate,
                ModalService,
                urasTalkbot,
                carteiras,
                urasPesquisaNaoAssociada,
                urasPesquisaAssociada) {

                $scope.maquina =
                    maquinas != null && maquinas.length > 0 ? maquinas[0] : {};
                $scope.arquivoAudio = {};
                $scope.Novo = !(servico && servico.ServicoId);

                if ($scope.Novo) {
                    ServicoResource.validarLimiteServico().$promise.then(function (result) {
                        if (!result.PodeCriar) {
                            ModalService.alert('telaEditServicos.limiteServicoAtingido', null, function () {
                                $scope.$apply(function () {
                                    $state.go('main.servicos.list');
                                });
                            });
                        }
                    });
                }
                $scope.inserirOuEditar = servico && servico.ServicoId
                        ? $translate.instant("telaEditServicos.editarServico")
                        : $translate.instant("telaEditServicos.inserirServico");
                $scope.servico = servico;
                $scope.tipoImportacaoId =  3;
                $scope.AudioCallAnnounce = !servico.AudioCallAnnounce ? null : {Arquivo: servico.AudioCallAnnounce, Texto: null};
                $scope.AudioTransbordoDesliga = !servico.AudioTransbordoDesliga ? null : {Arquivo: servico.AudioTransbordoDesliga, Texto: null};                
                $scope.MensagemFilaVirtual = !servico.MensagemFilaVirtual ? null : {Arquivo: servico.MensagemFilaVirtual, Texto: null};
                $scope.ramal = {};
                $scope.ramaisTotal = [];
                $scope.forms = {};
                $scope.tiposCallback = tiposCallback;
                $scope.servico.Rotas = [];
                $scope.urasDisponiveisAssociarDdr = urasDisponiveisAssociarDdr;
                $scope.urasTalkbot = urasTalkbot;
                $scope.todasRotasSelecionadas = false;
                $scope.classes = classes;
                $scope.operadoras = operadoras;
                $scope.localidades = localidades;
                $scope.plano = {};
                $scope.carteiras = carteiras;
                $scope.urasPesquisaNaoAssociada = urasPesquisaNaoAssociada || [];
                $scope.urasPesquisaAssociada = urasPesquisaAssociada || [];
                $scope.quantidadeNumerosImportados = 0;
                $scope.fileServico;
                $scope.uraId = $scope.uraIdOrigin = servico.UraId ? servico.UraId : (servico.UraServicoAssociado && servico.UraServicoAssociado.length > 0 ? servico.UraServicoAssociado[0].UraId : null);

                $scope.idImportacaoPorRange = 1;
                $scope.idImportacaoPorLote = 2;
                $scope.idImportacaoUnico = 3;

                $scope.descricoesColunasUra = {
                    Descricao: "model.ura",
                };

                if (
                    $scope.servico.PlanoId === undefined ||
                    $scope.servico.PlanoId === null ||
                    $scope.servico.PlanoId === 0
                ) {
                    $scope.plano = {
                        PlanoTarifa: [
                            { ClasseId: 5, Tempo: 30, TempoMinimo: 3, Fracao: 6, ValorFranquia: 0, Valor: 0, Ativo: true, Padrao: true, },
                            {
                                ClasseId: 12,
                                Tempo: 30,
                                TempoMinimo: 3,
                                Fracao: 6,
                                ValorFranquia: 0,
                                Valor: 0,
                                Ativo: true,
                                Padrao: true,
                            },
                            {
                                ClasseId: 13,
                                Tempo: 30,
                                TempoMinimo: 3,
                                Fracao: 6,
                                ValorFranquia: 0,
                                Valor: 0,
                                Ativo: true,
                                Padrao: true,
                            },
                            {
                                ClasseId: 14,
                                Tempo: 30,
                                TempoMinimo: 3,
                                Fracao: 6,
                                ValorFranquia: 0,
                                Valor: 0,
                                Ativo: true,
                                Padrao: true,
                            },
                            {
                                ClasseId: 16,
                                Tempo: 30,
                                TempoMinimo: 3,
                                Fracao: 6,
                                ValorFranquia: 0,
                                Valor: 0,
                                Ativo: true,
                                Padrao: true,
                            },
                        ],
                    };
                    $scope.plano.PlanoId = 0;
                } else {
                    $scope.plano = $scope.servico.Plano;
                }

                grupos.forEach((el) => {
                    if (el.Ramal != null) {
                        el.Numero = el.Ramal.Numero;
                    }
                });

                var ramaisGrupos = grupos.concat(ramais);
                ramais.forEach((el) => {
                    if (el.UsuarioNome != null) {
                        el.Descricao = el.Numero + " - " + el.UsuarioNome;
                    } else {
                        el.Descricao = el.Numero;
                    }
                });

                $scope.ramaisGrupos = ramaisGrupos;
                $scope.ramais = ramais;
                $scope.grupos = grupos;
                $scope.fornecedores = fornecedores;
                $scope.campanhas = campanhas;

                $scope.DadosStepData = { order: 1 };
                $scope.ConfiguracoesStepData = { order: 2 };
                $scope.RotasStepData = { order: 3 };
                $scope.AudiosStepData =
                    servico.ServicoTipoId == 1 ? { order: 4 } : { order: 2 };
                $scope.ServicoUraPesquisaStepData =
                    servico.ServicoTipoId == 1 ? { order: 5 } : { order: 3 };
                $scope.TarifacaoStepData =
                    servico.ServicoTipoId == 1 ? { order: 6 } : { order: 4 };

                $scope.tipoTransferencias = [
                    {
                        TipoTransferenciaId: 1,
                        Descricao: $translate.instant("model.ramal"),
                    },
                    {
                        TipoTransferenciaId: 2,
                        Descricao: $translate.instant("model.grupo"),
                    },
                    {
                        TipoTransferenciaId: 3,
                        Descricao: $translate.instant("model.ura"),
                    },
                ];

                $scope.periodosAnaliseFila = [
                    {
                        Valor: 5,
                        Descricao: $translate.instant("periodo.5minutos"),
                    },
                    {
                        Valor: 10,
                        Descricao: $translate.instant("periodo.10minutos"),
                    },
                    {
                        Valor: 15,
                        Descricao: $translate.instant("periodo.15minutos"),
                    },
                    {
                        Valor: 30,
                        Descricao: $translate.instant("periodo.30minutos"),
                    },
                    {
                        Valor: 60,
                        Descricao: $translate.instant("periodo.1hora"),
                    },
                    {
                        Valor: 120,
                        Descricao: $translate.instant("periodo.2horas"),
                    },
                    {
                        Valor: 180,
                        Descricao: $translate.instant("periodo.3horas"),
                    },
                    {
                        Valor: 240,
                        Descricao: $translate.instant("periodo.4horas"),
                    },
                    {
                        Valor: 300,
                        Descricao: $translate.instant("periodo.5horas"),
                    },
                    {
                        Valor: 360,
                        Descricao: $translate.instant("periodo.6horas"),
                    },
                    {
                        Valor: 420,
                        Descricao: $translate.instant("periodo.7horas"),
                    },
                    {
                        Valor: 480,
                        Descricao: $translate.instant("periodo.8horas"),
                    },
                ];

                $scope.gruposTransferencia = angular.copy(grupos);

                if (!$scope.Novo) {
                    $scope.servico.UraCallback =
                        $scope.servico.RamalCallbackId > 0 ||
                        $scope.servico.CampanhaCallbackId > 0;

                    $scope.servico.Tarifacao = $scope.servico.PlanoId > 0;

                    $scope.servico.HabilitaTempoParaAtendimento =
                        $scope.servico.TempoParaAtendimento > 0;
                    $scope.servico.HabilitaTempoMaximoLigacao =
                        $scope.servico.TempoMaximoLigacao > 0;
                } else {
                    $scope.plano.PlanoId = 0;
                }

                $scope.onTipoChanged = function () {
                    $scope.servico.RamalId = undefined;
                    $scope.uraId = undefined;
                };

                if (!$scope.servico.Ramal)
                    $scope.servico.Ramal = { RamalTipoId: 0 };

                $scope.getClasseBotaoEspera = function () {
                    if (
                        $scope.forms.formAudios != null &&
                        $scope.forms.formAudios.$submitted &&
                        ($scope.servico.ServicoAudioEspera == null ||
                            $scope.servico.ServicoAudioEspera[0] == null)
                    ) {
                        return "md-btn-danger";
                    } else {
                        return "md-btn-primary";
                    }
                };

                if (
                    $scope.servico.ServicoAudioEspera != null &&
                    $scope.servico.ServicoAudioEspera.length > 0
                ) {
                    $scope.servico.PossuiEspera = true;
                    $scope.servico.ServicoAudioEspera = _.sortBy(
                        $scope.servico.ServicoAudioEspera,
                        (el) => {
                            return el.Ordem;
                        }
                    );
                } else {
                    $scope.servico.ServicoAudioEspera = [];
                }

                if ($scope.servico.RamalId && $scope.servico.Ramal != null) {
                    $scope.servico.TipoTransferenciaId =
                        $scope.servico.Ramal.RamalTipoId;
                } else if ($scope.uraId > 0) {
                    $scope.servico.TipoTransferenciaId = 3;
                }

                $scope.onUraChanged = function (uraId) {
                    $scope.uraId = uraId;
                    const uraSelecionada = _.find($scope.urasDisponiveisAssociarDdr, function (ura) {
                        return ura.UraId == uraId;
                    });
                    if (uraSelecionada != null) {
                        $scope.servico.CarteiraId = uraSelecionada.CarteiraId;
                        $scope.servico.DescricaoUra = uraSelecionada.Descricao;
                        $scope.servico.RamalId = uraSelecionada.RamalUraId;
                    }
                };

                $scope.onGrupoChanged = function () {
                    const grupoSelecionado = _.find(
                        $scope.grupos,
                        function (grupo) {
                            return grupo.RamalId == $scope.servico.RamalId;
                        }
                    );
                    if (grupoSelecionado != null)
                        $scope.servico.CarteiraId = grupoSelecionado.CarteiraId;
                };

                function mensagemSucesso(resposta) {
                    NotifyService.showRegistroSalvo();

                    if ($scope.Novo) $scope.resposta = {};
                    else $scope.servico = resposta;

                    $state.go("main.servicos.list");
                }

                $scope.exibirDetalhe = function (descricao) {
                    ModalService.alert("<h3>Detalhe</h3>" + descricao);
                };

                $scope.exibirDetalhe = function (titulo, descricao) {
                    ModalService.alert(`<h3>${titulo}</h3>${descricao}`);
                };

                $scope.onBloqueioCelularChange = function () {
                    if ($scope.servico.BloqueioCelular == true) {
                        $scope.servico.BloqueioFilaCelular = true;
                    }
                };

                function mensagemErroServico(error) {
                    var msg = error && error.data ? (error.data.Message || error.data.message || '') : '';
                    if (error && error.status === 400 && msg.indexOf('limite de quantidade') > -1) {
                        ModalService.alert('telaEditServicos.limiteServicoAtingido');
                        return;
                    }

                    let mensagem = $translate.instant(
                        "notificacoes.erroAoRealizarOperacao"
                    );
                    let status = "danger";
                    let modelState = error.data.ModelState;
                    if (error.status === 400 && modelState != null) {
                        mensagem = $translate.instant(
                            "telaEditServicos.jaExistemServicos"
                        );
                        let numeros = [];
                        for (const key in modelState) {
                            if (modelState.hasOwnProperty(key))
                                numeros.push(key);
                        }
                        mensagem += numeros.join(", ");
                        status = "warning";
                    } else if (error.status === 400)
                        mensagem = error.data.Message;
                    // eslint-disable-next-line no-console
                    console.error(error);
                    NotifyService.showMessage(mensagem, status);
                    if (status == "warning") $state.go("main.servicos.list");
                }

                $scope.valoresAntigos = null;
                $scope.onCallbackAlterado = function () {
                    if ($scope.valoresAntigos == null) {
                        $scope.valoresAntigos = {};
                        $scope.valoresAntigos.CampanhaCallbackId =
                            $scope.servico.CampanhaCallbackId;
                        $scope.valoresAntigos.RamalCallbackId =
                            $scope.servico.RamalCallbackId;
                        $scope.valoresAntigos.AgendamentoCallback =
                            $scope.servico.AgendamentoCallback;
                        $scope.valoresAntigos.InfoAdicionalCallback =
                            $scope.servico.InfoAdicionalCallback;
                        $scope.valoresAntigos.CallbackTipoId =
                            $scope.servico.CallbackTipoId;
                        $scope.servico.CampanhaCallbackId = null;
                        $scope.servico.CallbackTipoId = null;
                        $scope.servico.RamalCallbackId = null;
                        $scope.servico.AgendamentoCallback = null;
                        $scope.servico.InfoAdicionalCallback = null;
                    } else {
                        $scope.servico.CampanhaCallbackId =
                            $scope.valoresAntigos.CampanhaCallbackId;
                        $scope.servico.RamalCallbackId =
                            $scope.valoresAntigos.RamalCallbackId;
                        $scope.servico.CallbackTipoId =
                            $scope.valoresAntigos.CallbackTipoId;
                        $scope.servico.AgendamentoCallback =
                            $scope.valoresAntigos.AgendamentoCallback;
                        $scope.servico.InfoAdicionalCallback =
                            $scope.valoresAntigos.InfoAdicionalCallback;
                        $scope.valoresAntigos = null;
                    }
                    if (
                        servico.UraCallback == true &&
                        $scope.servico.CallbackTipoId == null
                    )
                        $scope.servico.CallbackTipoId = -1;
                };

                $scope.getRotas = function () {
                    if ($scope.todasRotasSelecionadas)
                        $scope.todasRotasSelecionadas = false;

                    if (servico.FornecedorId != null) {
                        let intSelecionadas = 0;
                        RotaResource.getRotaByFornecedorId({
                            fornecedorId: servico.FornecedorId,
                        }).$promise.then((data) => {
                            angular.forEach(data, function (item) {
                                if ($scope.servico.ServicoRotaReceptivo) {
                                    var rotaReceptiva =
                                        $scope.servico.ServicoRotaReceptivo.filter(
                                            (r) => r.RotaId == item.RotaId
                                        );
                                    if (
                                        rotaReceptiva != null &&
                                        rotaReceptiva.length > 0
                                    ) {
                                        item.checked = true;
                                        intSelecionadas++;
                                    } else {
                                        item.checked = false;
                                    }
                                }
                            });

                            angular.copy(data, $scope.servico.Rotas);

                            if (
                                $scope.servico.Rotas.length > 0 &&
                                $scope.servico.Rotas.length == intSelecionadas
                            )
                                $scope.todasRotasSelecionadas = true;
                        });
                    }
                };

                $scope.onChangeCheck = function (chech) {
                    angular.forEach($scope.servico.Rotas, function (item) {
                        if (chech) item.checked = true;
                        else item.checked = false;
                    });
                };

                $scope.validarStep = function (form, step) {
                    // Se for um serviço novo, validar a existencia do numero
                    if (step == 1 && $scope.servico.ServicoId == 0) {
                        if ($scope.tipoImportacaoId == 2) {
                            ServicoResource.existeNumerosLote({
                                numeroInicial: $scope.servico.Numero,
                                numeroFinal: $scope.servico.NumeroFinal,
                            }).$promise.then((result) => {
                                if (result.length > 0) {
                                    let mensagem;
                                    WizardHandler.wizard().previous();

                                    if (result.length > 1)
                                        mensagem = $translate.instant(
                                            "telaEditServicos.osNumerosJaEstaoCadastrados",
                                            { Numeros: result.toString() }
                                        );
                                    else
                                        mensagem = $translate.instant(
                                            "telaEditServicos.oNumeroJaEstaCadastrado",
                                            { Numero: result.toString() }
                                        );

                                    NotifyService.showError(null, mensagem);
                                }
                            });
                        } else {
                            ServicoResource.existeNumero({
                                numero: $scope.servico.Numero,
                            }).$promise.then((result) => {
                                if (result.Existe) {
                                    WizardHandler.wizard().previous();
                                    NotifyService.showError(
                                        null,
                                        "telaEditServicos.oNumeroJaEstaCadastrado",
                                        { Numero: $scope.servico.Numero }
                                    );
                                }
                            });
                        }
                    }

                    if (!form.$valid) {
                        form.$setSubmitted();
                        return NotifyService.showInvalid();
                    }
                };

                $scope.salvar = function (form) {
                    if (!form.$valid) return NotifyService.showInvalid();

                    let rotasSelecionadas = _.where($scope.servico.Rotas, {
                        checked: true,
                    });

                    $scope.servico.ServicoRotaReceptivo = rotasSelecionadas;
                    if ($scope.servico.PossuiEspera != true) {
                        $scope.servico.ServicoAudioEspera = [];
                    }

                    if ($scope.servico.RamalCallbackId)
                        $scope.servico.RamalCallbackId = null

                    // Criou tarifação
                    if (
                        $scope.servico.Tarifacao &&
                        $scope.plano.PlanoId === 0
                    ) {
                        PlanoResource.save($scope.plano)
                            .$promise.then((data) => {
                                if (data) $scope.servico.PlanoId = data.PlanoId;
                                let promise;
                                if ($scope.servico.ServicoId > 0)
                                    promise = ServicoResource.update(
                                        $scope.servico
                                    ).$promise;
                                else
                                    promise = ServicoResource.save(
                                        $scope.servico
                                    ).$promise;
                                promise
                                    .then(mensagemSucesso)
                                    .catch(mensagemErroServico);
                            })
                            .catch(NotifyService.showError);
                        return;
                    }
                    // Removeu a tarifação existente?
                    else if (
                        !$scope.servico.Tarifacao &&
                        $scope.plano.PlanoId > 0
                    ) {
                        $scope.servico.PlanoId = null;
                        PlanoResource.delete({
                            PlanoId: $scope.plano.PlanoId,
                        }).$promise.catch(NotifyService.showError);
                    }
                    // Atualiza a tarifação
                    else if ($scope.plano.PlanoId > 0) {
                        PlanoResource.update($scope.plano).$promise.catch(
                            NotifyService.showError
                        );
                    }

                    // Alterou a ura de destino 
                    // ou tipo de transferencia que era Ura
                    if ($scope.uraId &&
                        $scope.uraIdOrigin &&
                        ($scope.uraId != $scope.uraIdOrigin || $scope.servico.TipoTransferenciaId != 3)) {
                        $scope.servico.UraServicoDesssociadoId = $scope.uraIdOrigin;
                    }

                    // Transferencia para uma Ura
                    if ($scope.servico.TipoTransferenciaId == 3 &&
                        ($scope.uraId && $scope.uraIdOrigin == null) || // Alterou o tipo de transferencia para ura
                        ($scope.uraId && $scope.uraIdOrigin && $scope.uraId != $scope.uraIdOrigin)) { // Alterou a ura de transferencia
                        $scope.servico.UraServicoAssociadoId = $scope.uraId;
                    }

                    // Alterou o tipo de tarnsferencia, e antes era para ura
                    // removemos a associação da ura
                    if ($scope.uraIdOrigin && $scope.servico.TipoTransferenciaId != 3) {
                        $scope.servico.UraServicoDesssociadoId = $scope.uraIdOrigin;
                    }

                    // Editou ura de pesquisa do DDR
                    let listaUraAdicionar = $scope.urasPesquisaAssociada.map(
                        (x) => x.UraId
                    );

                    if (listaUraAdicionar && listaUraAdicionar.length > 0) {
                        $scope.servico.UraPesquisaAdicionar = angular.copy(listaUraAdicionar);
                    }

                    let listaUraRemover = $scope.urasPesquisaNaoAssociada.map(
                        (x) => x.UraId
                    );

                    if (listaUraRemover && listaUraRemover.length > 0) {
                        $scope.servico.UraPesquisaRemover = angular.copy(listaUraRemover);
                    }

                    let promise;
                    if ($scope.servico.ServicoId > 0)
                        promise = ServicoResource.update(
                            $scope.servico
                        ).$promise;
                    else
                        promise = ServicoResource.save($scope.servico).$promise;

                    promise.then(mensagemSucesso).catch(mensagemErroServico);
                };
                
                $scope.calcularIntervalo = function () {
                    let numI = $scope.servico.Numero;
                    let numF = $scope.servico.NumeroFinal;

                    if (numF != null) {
                        if (numI.length == numF.length) {
                            $scope.intervaloErro =
                                parseInt(numI) + 100 < parseInt(numF) &&
                                parseInt(numI) < parseInt(numF);
                            $scope.lengthErro = false;
                        } else {
                            $scope.lengthErro = true;
                            $scope.intervaloErro = null;
                        }
                    } else {
                        $scope.lengthErro = false;
                        $scope.intervaloErro = null;
                    }
                };

                $scope.voltar = function () {
                    $state.go("main.servicos.list");
                };

                $scope.onEsperaAlterado = function () {
                    if (
                        $scope.servico.PossuiEspera &&
                        ($scope.servico.ServicoAudioEspera == null ||
                            $scope.servico.ServicoAudioEspera[0] == null)
                    )
                        $scope.forms.formAudios.$setValidity(
                            "ServicoAudioEspera1",
                            false
                        );
                    else
                        $scope.forms.formAudios.$setValidity(
                            "ServicoAudioEspera1",
                            true
                        );
                };

                $scope.loadEspera1Completed = function (result) {
                    $scope.preview = result;

                    if ($scope.servico.ServicoAudioEspera.length < 1)
                        $scope.servico.ServicoAudioEspera.push({
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });
                    else
                        $scope.servico.ServicoAudioEspera.splice(0, 1, {
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });

                    $scope.forms.formAudios.$setDirty();
                    $scope.forms.formAudios.$setValidity(
                        "ServicoAudioEspera1",
                        true
                    );

                    ModalService.hideUploading();
                };

                $scope.removeEspera1 = function () {
                    $scope.servico.ServicoAudioEspera.splice(0, 1);

                    $("#form-file-espera1").val("");
                    $scope.forms.formAudios.$setDirty();
                    if ($scope.servico.ServicoAudioEspera.length == 0) {
                        $scope.forms.formAudios.$setValidity(
                            "ServicoAudioEspera1",
                            false
                        );
                    }
                };

                //ESPERA2
                $scope.loadEspera2Completed = function (result) {
                    $scope.preview = result;
                    if ($scope.servico.ServicoAudioEspera.length < 2)
                        $scope.servico.ServicoAudioEspera.push({
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });
                    else
                        $scope.servico.ServicoAudioEspera.splice(1, 1, {
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });

                    $scope.forms.formAudios.$setDirty();

                    ModalService.hideUploading();
                };

                $scope.removeEspera2 = function () {
                    $scope.servico.ServicoAudioEspera.splice(1, 1);
                    $("#form-file-espera2").val("");
                    $scope.forms.formAudios.$setDirty();
                };

                //ESPERA3
                $scope.loadEspera3Completed = function (result) {
                    $scope.preview = result;
                    if ($scope.servico.ServicoAudioEspera.length < 3)
                        $scope.servico.ServicoAudioEspera.push({
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });
                    else
                        $scope.servico.ServicoAudioEspera.splice(2, 1, {
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });

                    $scope.forms.formAudios.$setDirty();

                    ModalService.hideUploading();
                };

                $scope.removeEspera3 = function () {
                    $scope.servico.ServicoAudioEspera.splice(2, 1);
                    $("#form-file-espera3").val("");
                    $scope.forms.formAudios.$setDirty();
                };

                //ESPERA4
                $scope.loadEspera4Completed = function (result) {
                    $scope.preview = result;
                    if ($scope.servico.ServicoAudioEspera.length < 4)
                        $scope.servico.ServicoAudioEspera.push({
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });
                    else
                        $scope.servico.ServicoAudioEspera.splice(3, 1, {
                            Arquivo: result.Nome,
                            Texto: result.Texto,
                            VozId: result.VozId
                        });

                    $scope.forms.formAudios.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeEspera4 = function () {
                    $scope.servico.ServicoAudioEspera.splice(3, 1);
                    $("#form-file-espera4").val("");
                    $scope.forms.formAudios.$setDirty();
                };

                //CALL ANNOUNCE
                $scope.loadCallAnnounceCompleted = function (result) {
                    $scope.preview = result;
                    $scope.servico.AudioCallAnnounce = result.Nome
                    $scope.servico.TextoCallAnnounce = result.Texto;
                    
                    $scope.forms.formDados.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeCallAnnounce = function () {
                    $scope.servico.AudioCallAnnounce = null;
                    $("#form-file-callAnnounce").val("");
                    $scope.forms.formDados.$setDirty();
                };

                //CALL ANNOUNCE DISCADOR
                $scope.loadCallAnnounceDiscadorCompleted = function (result) {
                    $scope.preview = result;
                    $scope.servico.AudioAnnounceDiscador = result;
                    $scope.forms.formDados.$setDirty();
                    ModalService.hideUploading();
                };

                // $scope.removeCallAnnounceDiscador = function () {
                // 	$scope.servico.AudioAnnounceDiscador = null;
                // 	$('#form-file-callDiscador').val('');
                // 	$scope.forms.formDados.$setDirty();
                // };

                //TRANSBORDO DESLIGA
                $scope.loadTransbordoDesligaCompleted = function (result) {
                    $scope.preview = result;
                    $scope.servico.AudioTransbordoDesliga = result.Nome;
                    $scope.servico.TextoTransbordoDesliga = result.Texto;
                    $scope.forms.formDados.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeTransbordoDesliga = function () {
                    $scope.servico.AudioTransbordoDesliga = null;
                    $("#form-file-call").val("");
                    $scope.forms.formDados.$setDirty();
                };

                 //FILA VIRTUAL
                 $scope.loadAudioFilaCompleted = function (result) {
                    $scope.preview = result;
                    $scope.servico.AudioFilaVirtual = result;
                    $scope.forms.formConfiguracoes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeAudioFila = function () {
                    $scope.servico.AudioFilaVirtual = null;
                    $("#form-file-audioFila").val("");
                    $scope.forms.formConfiguracoes.$setDirty();
                };

                $scope.loadFilaVirtualCompleted = function (result) {
                    $scope.preview = result;
                    $scope.servico.MensagemFilaVirtual =  result.Nome;;
                    $scope.forms.formDados.$setDirty();
                    ModalService.hideUploading();
                };
                $scope.removeFilaVirtual = function () {
                    $scope.servico.MensagemFilaVirtual = null;
                    $("#form-file-callAnnounce").val("");
                    $scope.forms.formDados.$setDirty();
                };

                 //INTO FILA VIRTUAL
                 $scope.loadAudioIntoFilaCompleted = function (result) {
                    $scope.preview = result;
                    $scope.servico.AudioIntroPosicaoFila = result;
                    $scope.forms.formConfiguracoes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeAudioIntroFilaVirtual = function () {
                    $scope.servico.AudioIntroPosicaoFila = null;
                    $("#form-file-introFilaVirtual").val("");
                    $scope.forms.formConfiguracoes.$setDirty();
                };

                //Metodos de Audio

                $scope.ouvirAudio = function (nome) {
                    $scope.arquivoAudio = {
                        url:
                            "Servico/Audio/" +
                            encodeURI(nome.replace(".", "$dot")),
                        titulo:
                            $translate.instant("diretivas.reproduzindo") + nome,
                    };
                };

                $scope.fecharAudio = function () {
                    $scope.arquivoAudio = null;
                };

                $scope.showProgress = function (percentComplete) {
                    $("#modalBlock")
                        .find(".uk-progress-bar")
                        .css({ width: percentComplete + "%" });
                    $("#modalBlock")
                        .find(".uk-progress-bar")
                        .text(percentComplete + "%");
                };

                $scope.loadAudioError = function (result) {
                    $scope.preview = null;
                    ModalService.hideUploading();
                    if (result == "Bad Request")
                        NotifyService.showError(
                            null,
                            "notificacoes.erroAoFazerUpload"
                        );
                };

                $scope.startAudioUpload = function () {
                    ModalService.showUploading();
                };

                $scope.getRotas();

                //  TARIFACAO INICIO

                var formTarifa;
                $scope.planoTarifa = {
                    PlanoTarifaId: 0,
                    ClasseId: 0,
                    DDD: null,
                    OperadoraId: null,
                    Valor: 0,
                    ValorFranquia: 0,
                    Tempo: 30,
                    Fracao: 6,
                    TempoMinimo: 3,
                    Ativo: true,
                };

                $scope.reprocessamentos = [];

                $scope.reprocessa = {
                    DataI: "",
                    DataF: "",
                    ServicoId: 0,
                };

                $scope.openModalNovaRegra = function (form) {
                    formTarifa = form;
                    formTarifa.$setDirty();
                    ModalService.openModal("modalNovoPlano");
                };

                $scope.setTarifaDirty = function () {
                    $scope.forms.formTarifa.$setDirty();
                };

                $scope.adicionarPlano = function () {
                    $scope.forms.formPlano.$setSubmitted();
                    if (!$scope.planoTarifa.ClasseId) {
                        return NotifyService.showInvalid();
                    }

                    $scope.plano.PlanoTarifa.push($scope.planoTarifa);

                    $scope.planoTarifa = {
                        PlanoTarifaId: 0,
                        ClasseId: 0,
                        DDD: null,
                        OperadoraId: null,
                        Valor: 0,
                        ValorFranquia: 0,
                        Tempo: 30,
                        Fracao: 6,
                        TempoMinimo: 3,
                        Ativo: true,
                    };

                    $scope.closeModalNovoPlano();
                    $scope.forms.formTarifa.$setDirty();
                };

                $scope.closeModalNovoPlano = function () {
                    ModalService.closeModal("modalNovoPlano");
                };

                $scope.deletePlano = function (data, formTarifa) {
                    ModalService.confirmDelete(() => {
                        data.Ativo = false;
                    });

                    setTimeout(() => {
                        formTarifa.$setDirty();
                    }, 100);
                };

                $scope.reprocessaTarifa = function (form) {
                    if (!form.$valid) return NotifyService.showInvalid();

                    let data = moment().toDate();
                    let dataI = moment($scope.reprocessa.DataI);
                    let dataF = moment($scope.reprocessa.DataF);
                    let dateDiff = dataF.diff(dataI, "days");

                    if (dataI > data)
                        return NotifyService.showError(
                            null,
                            "telaEditServicos.dataINaoPodeSerMaiorQueHoje"
                        );
                    if (dataF > data)
                        return NotifyService.showError(
                            null,
                            "telaEditServicos.dataFNaoPodeSerMaiorQueHoje"
                        );
                    if (dataI > dataF)
                        return NotifyService.showError(
                            null,
                            "telaEditServicos.dataINaoPodeSerMaiorQueDataF"
                        );
                    if (dateDiff > 30)
                        return NotifyService.showError(
                            null,
                            "telaEditServicos.periodoNaoPodeSerMaiorQue30"
                        );

                    // Id do Servico
                    $scope.reprocessa.ServicoId = $scope.servico.ServicoId;
                    ServicoResource.reprocessaTarifa($scope.reprocessa)
                        .$promise.then(() => {
                            $scope.reprocessamentos = [];
                            ServicoResource.getHistoricoReprocessaTarifa(
                                $scope.servico.ServicoId
                            ).$promise.then((data) => {
                                if (data) $scope.reprocessamentos = data;
                            });

                            $scope.reprocessa = {
                                DataI: "",
                                DataF: "",
                                ServicoId: 0,
                            };
                            NotifyService.showSuccess(
                                "telaEditServicos.reprocessamentoCriadoComSucesso"
                            );
                            ModalService.closeModal("modal_reprocessa_tarifa");
                        })
                        .catch(NotifyService.showError);
                };

                $scope.onInformaPosicaoFila = function () {
                    if (!$scope.servico.InformaPosicaoFila) {
                        $scope.servico.InformaTempoFila = false;
                    }
                };

                $scope.onFilaVirtual = function () {
                    if (!$scope.servico.FilaVirtual) {
                        $scope.servico.FilaVirtual = false;
                    }
                };

                $scope.onServicoAlterado = function (index, item) {
                    index = $scope.layout.Permissoes.indexOf(item);
                    if (item) {
                        if (item.ServicoId > 0) {
                            if (item.LigacaoDiscador)
                                item.LigacaoDiscador = false;
                            if (item.LigacaoManual)
                                item.LigacaoManual = false;                           
                        }
                        else{
                            item.LigacaoDiscador = true;
                            item.LigacaoManual = true;
                        }
                    }
                };
                
                $scope.onChangePermiteInfoAdicionalRobo = function(){

                    if($scope.servico.PermiteInfoAdicionalRobo){
                        $scope.servico.InfoAdicionalRobo = "p1;p2;p3;p4;p5";
                    }
                    else{
                        $scope.servico.InfoAdicionalRobo = null;
                    }
                }

                function lerPrimeiraColunaCSV(file) {
                    return new Promise((resolve, reject) => {
                      const reader = new FileReader();
                  
                      reader.onload = function (event) {
                        const text = event.target.result;
                  
                        if (!text.includes(",") && !text.includes("\n")) {
                          reject("O arquivo não parece ser um .csv ou .txt válido.");
                          return;
                        }
                  
                        const linhas = text.split("\n");
                        const primeiraColuna = linhas
                          .map((linha) => linha.split(",")[0].replace(/["\n]/g, "").trim()) 
                          .filter((value) => value !== "")
                          .filter((value) => /^\d{1,11}$/.test(value));
                        resolve(primeiraColuna);
                      };
                  
                      reader.onerror = function (error) {
                        reject(error);
                      };
                  
                      reader.readAsText(file, "UTF-8");
                    });
                }

                $scope.uploadFile = function (event) {
                    $scope.quantidadeNumerosImportados = 0;
                    $scope.fileServico = null;
                    $scope.fileServico = event.target.files[0];
                  
                    if ($scope.fileServico) {
                      const validTypes = ["text/csv", "text/plain"];
                      const fileType = $scope.fileServico.type;
                      const fileName = $scope.fileServico.name.toLowerCase();
                  
                      if (
                        !validTypes.includes(fileType) &&
                        !(fileName.endsWith(".csv") || fileName.endsWith(".txt"))
                      ) {
                        NotifyService.showError(
                          null,
                          "Por favor, selecione um arquivo .csv ou .txt válido."
                        );
                        $scope.fileServico = null;
                        return;
                      }
                  
                      lerPrimeiraColunaCSV($scope.fileServico)
                        .then((numeros) => {
                          if (numeros.length === 0) {
                            NotifyService.showError(
                              null,
                              "Nenhuma linha válida foi encontrada no arquivo. Certifique-se de que as informações sejam numéricas e contenham até 11 dígitos."
                            );
                            $scope.fileServico = null;
                            return;
                          }
                  
                          $scope.servico.Numeros = numeros;
                          $scope.quantidadeNumerosImportados = $scope.servico.Numeros.length;
                          $scope.$apply(); // Atualiza o binding
                        })
                        .catch((error) => {
                          NotifyService.showError(
                            null,
                            "Ocorreu um erro ao processar o arquivo." + error
                          );
                          $scope.fileServico = null;
                        });
                    }
                };

                $scope.setTipoImportacao = function (id) {
                    $scope.tipoImportacaoId = id;
                    if (id == 3) {
                        $scope.servico.EmLote = false;
                    }
                    else {
                        $scope.servico.EmLote = true;
                    }
                  };
            }]
        );
})();

(function () {
    "use strict";

    function getOdataSearchShared(ServicoResource, search, orderBy) {
        let odata = ServicoResource.odata().orderBy(orderBy.column, orderBy.order);

        if (search.RamalNumero) odata.filter('Ramal/Numero', parseInt(search.RamalNumero));
        if (search.Numero) odata.filter('Numero', search.Numero);
        if (search.Descricao) odata.where('Descricao', 'contains', search.Descricao);
        if (search.ServicoTipoId) odata.filter('ServicoTipoId', search.ServicoTipoId);
        if (search.Id) odata.filter("CarteiraId", "=", parseInt(search.Id));

        return odata;
    }

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.servicos", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.servicos.list',
                    pageTitle: 'model.servico',
                    pageName: 'model.servico'
                }
            })
                .state("main.servicos.list", StateResolverProvider.configState("/servicos", "Servico", "List", {
                    pageTitle: 'model.servico',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.servicos.edit", StateResolverProvider.configState("/servicos/{ServicoId:[0-9]+}", "Servico", "Edit", {
                    pageTitle: 'model.servico',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.servicos.new", StateResolverProvider.configState("/servicos/new?page", "Servico", "Edit", {
                    pageTitle: 'model.servico',
                    pageName: 'acoes.cadastrar',
                    css: true
                }));

        }])
        .service("ServicoListData", function ServicoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    servicos: ["ServicoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (ServicoResource, LocalStorageService, $odata, utils, $stateParams) {
                        let filtro = $stateParams.storage ? LocalStorageService.getItem("FiltroServico") : { ServicoTipoId: 1 };
                        let orderBy = { column: "DataAlteracao", order: "desc" };

                        return getOdataSearchShared(ServicoResource, filtro, orderBy)
                            .page(10, 1)
                            .query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    ttsService: ["TtsService", function (TtsService) {
                        TtsService.getVozes();
                        TtsService.setProvedores();
                        return;
                    }]
                }
            }
        })

        .controller("ServicoListController",
            ["$scope", "$odata", "servicos", "ServicoResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", "carteiras", "$translate", function ($scope,
                $odata,
                servicos,
                ServicoResource,
                utils,
                LocalStorageService,
                $stateParams,
                NotifyService,
                $state,
                ModalService,
                carteiras,
                $translate) {
                $scope.servicos = servicos;
                $scope.searching = false;
                $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroServico") : { ServicoTipoId: 1 };
                $scope.orderBy = { column: "DataAlteracao", order: "desc" };

            $scope.novoServico = function () {
                ServicoResource.validarLimiteServico().$promise.then(function (result) {
                    if (result.PodeCriar) {
                        $state.go('main.servicos.new');
                    } else {
                        ModalService.alert('telaServicos.limiteServicoAtingido');
                    }
                }).catch(NotifyService.showError);
            };
                $scope.tiposServico = [
                    { ServicoTipoId: 1, Descricao: $translate.instant('model.ddr') },
                    { ServicoTipoId: 2, Descricao: $translate.instant('model.virtual') },
                    { ServicoTipoId: 3, Descricao: 'Ura IA' }
                ];
                $scope.carteiras = carteiras;
                $scope.ramalTipo = [
                    { Id: 1, Descricao: $translate.instant('model.ramal') },
                    { Id: 2, Descricao: $translate.instant('model.grupo') },
                    { Id: 3, Descricao: $translate.instant('model.ura') }
                ];

                function updateList(list) {
                    ModalService.hideLoading();
                    $scope.servicos = list;
                    $scope.servicos.recordCount = list.$recordCount || list.length;
                    $scope.currentPage = list.$currentPage || 1;
                    $scope.servicos.pageSize = list.$pageSize || 10;
                    $scope.searching = false;
                }

                function getOdataSearch() {
                    return getOdataSearchShared(ServicoResource, $scope.search, $scope.orderBy);
                }

                function deleteRecord(data) {
                    return ServicoResource.delete({ ServicoId: data.ServicoId }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage)
                        }).catch(NotifyService.showError);
                }

                $scope.executeSearch = function () {
                    $scope.searching = true;
                    ModalService.showLoading();
                    LocalStorageService.setItem('FiltroServico', $scope.search);
                    getOdataSearch().page($scope.search.pageSize, 1).query()
                        .then(updateList)
                        .catch(e => {
                            ModalService.hideLoading();
                            NotifyService.showError(e);
                            $scope.searching = false;
                        });
                };

                $scope.confirmDelete = function (data) {
                    ModalService.confirmDelete(() => {
                        deleteRecord(data);
                    });
                };

                $scope.pageChanged = function (newPage) {
                    ModalService.showLoading();
                    return getOdataSearch().page($scope.servicos.pageSize, newPage).query()
                        .then(updateList)
                        .catch(e => {
                            ModalService.hideLoading();
                            NotifyService.showError(e);
                        });
                };

                updateList(servicos);

                $scope.limparFiltro = function () {
                    LocalStorageService.removeItem('FiltroServico');
                    $scope.search = { pageSize: 10 };
                    $scope.executeSearch();
                };

                $scope.voltar = function () {
                    if ($stateParams.page) $state.go($stateParams.page, { storage: true });
                    else $state.go('main.servicos.list', { storage: true });
                };

                $scope.getTipoTransferencia = function (servico) {
                    let tipoTransferencia = '--';
                    if (servico.Ramal) {
                        switch (servico.Ramal.RamalTipoId) {
                            case 1:
                            case 2:
                                tipoTransferencia = servico.Ramal.RamalTipo.Descricao;
                                break;
                            case 3:
                                if (servico.UraServicoAssociado && servico.UraServicoAssociado.length == 1) {
                                    tipoTransferencia = $scope.ramalTipo[servico.Ramal.RamalTipoId - 1].Descricao;
                                }
                                else {
                                    tipoTransferencia = servico.Ramal.RamalTipo.Descricao;
                                }
                                break;
                        }
                    }
                    return tipoTransferencia;
                };

                $scope.getDescricaoRamal = function (servico) {
                    let descricaoRamal = '--';
                    if (servico.ServicoTipoId == 1 && servico.Ramal) {
                        switch (servico.Ramal.RamalTipoId) {
                            case 1:
                                descricaoRamal = servico.Ramal.UsuarioCadastroRamal.Nome ? servico.Ramal.UsuarioCadastroRamal.Nome : servico.Ramal.Numero;
                                break;
                            case 2:
                                descricaoRamal = servico.GrupoRamal.Descricao ? servico.GrupoRamal.Descricao : (servico.Ramal.Numero ? servico.Ramal.Numero : '--');
                                break;
                            case 3:
                                if (servico.UraServicoAssociado) {
                                    if (servico.UraServicoAssociado.length == 1) {
                                        descricaoRamal = servico.UraServicoAssociado[0].DescricaoUra ? servico.UraServicoAssociado[0].DescricaoUra : (servico.Ramal.Numero ? servico.Ramal.Numero : '--');
                                    }
                                }
                                break;
                        }
                    }
                    else if (servico.ServicoTipoId == 2 &&
                        servico.Ura &&
                        servico.Ura.Descricao) {
                        descricaoRamal = servico.Ura.Descricao;
                    }
                    return descricaoRamal;
                };
            }]);
})();
(function () {
    "use strict";

    angular
        .module("epbxManagerApp")
        .factory("ServicoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "Servico/:ServicoId",
                { ServicoId: "@ServicoId" },
                {
                    getServicoDisponivelAssociarUra: {
                        url: "Servico/GetServicoDisponivelAssociarUra",
                        method: "GET",
                        isArray: true,
                    },
                    reprocessaTarifa: {
                        url: "Servico/ReprocessaTarifa",
                        method: "POST",
                    },
                    getHistoricoReprocessaTarifa: {
                        url: "Servico/HistoricoReprocessaTarifa",
                        method: "GET",
                        isArray: true,
                    },
                    existeNumero: {
                        url: "Servico/ExisteNumero",
                        method: "GET",
                    },
                    existeNumerosLote: {
                        url: "Servico/ExisteNumerosLote",
                        method: "GET",
                        isArray: true,
                    },
                    lookup: {
                        url: "Servico/Lookup",
                        method: "GET",
                        isArray: true,
                    },
                    getServicos: {
                        url: "Servico",
                        method: "GET",
                        isArray: true,
                    },
                    GetServicoPadrao :{
                        url: "Servico/GetServicoPadrao",
                        method: "GET",
                        isArray: true
                    },
                    getCarteiras: {
                        url: "Carteira",
                        method: "GET",
                        isArray: true,
                    },
                    uraPesquisaNaoAssociada: {
                        method: "GET",
                        url: "Servico/UraPesquisaNaoAssociada/:id",
                        isArray: true,
                    },
                    uraPesquisaAssociada: {
                        method: "GET",
                        url: "Servico/UraPesquisaAssociada/:id",
                        isArray: true,
                    },
                    AtualizarUraServicoPesquisa: {
                        method: "POST",
                        url: "Servico/AtualizarUraServicoPesquisa"
                    },
                    validarLimiteServico: {
                        url: "Servico/ValidarLimiteServico",
                        method: "GET",
                        isArray: false
                    }
                }

            );
        }]);
})();
(function() {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("SistemaConfiguracaoResource", ["$odataresource", function($odataresource) {
			return $odataresource("SistemaConfiguracao/:SistemaConfiguracaoId", {
				"SistemaConfiguracaoId": "@SistemaConfiguracaoId"
			});
		}])
		.factory("SistemaValidacaoResource", ["$odataresource", function($odataresource) {
			return $odataresource("Validacao", {}, {
				getTodos: {
					url: "Validacao/Todos",
					method: "GET",
					isArray: true
				},
				getCheck: {
					url: "Validacao/CheckTodos",
					method: "GET",
					isArray: false
				},
				getConfiguracao: {
					url: "Validacao/Configuracao",
					method: "GET",
					isArray: false
				},
				setConfigurado: {
					url: "Validacao/Configurado",
					method: "PUT"
				}
			});
		}]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service("SistemaConfiguracaoViewData", function TabulacaoViewData() {
            return function () {
                return {
                    configuracoes: ["SistemaConfiguracaoResource", function (SistemaConfiguracaoResource) {
                        return SistemaConfiguracaoResource.odata().orderBy("Ordem", "asc").query();
                    }],
                    validacoes: ["SistemaValidacaoResource", function (SistemaValidacaoResource) {
                        return SistemaValidacaoResource.getCheck();
                    }]
                };
            };
        })

        /*
        STATUS GLOSSÁRIO
        Pendente - 0
        Integrando - 1
        Concluido - 2
        Erro - 3
        */

        .controller("SistemaConfiguracaoViewController",
        ["$scope", "$rootScope", "$window", "$interval", "$state", "$resource", "$location", "LocalStorageService", "SistemaValidacaoResource", "configuracoes", "validacoes", function ($scope, $rootScope, $window, $interval, $state, $resource, $location, LocalStorageService, SistemaValidacaoResource, configuracoes, validacoes) {
            $rootScope.topMenuActive = true;
            $scope.configuracoes = configuracoes;
            $scope.validacoes = validacoes;
            $scope.taskClicked = null;
            $scope.indiceValido = 0;
            $scope.constTrue = true;
            $scope.constFalse = false;

            $scope.reloadData = function () {
                _.forEach($scope.validacoes, function (val) {
                    var cEl = _.find($scope.configuracoes, function (conf) {
                        return conf.SistemaConfiguracaoId == val.Id
                    });
                    if (cEl) {
                        cEl.StatusId = val.StatusId;
                        cEl.Valido = val.StatusId == 2 ? true : false;
                    }
                });

                $scope.verificarIndiceValido();

                var confPendentes = _.filter($scope.configuracoes, function (conf) {
                    return conf.StatusId == 1;
                });

                var checkPendente = function (conf) {
                    // substituido $timeout por $interval para que seja possivel realizar testes com protractor
                    if (conf.intervalId) $interval.cancel(conf.intervalId);

                    conf.intervalId = $interval(function () {
                        var apiConf = $resource(conf.Api, {}, {
                            getData: {
                                method: 'GET',
                                isArray: false
                            }
                        });
                        apiConf.getData().$promise.then(function (data) {
                            if (data.StatusId == 1) {
                                checkPendente(conf);
                            } else {
                                conf.StatusId = data.StatusId;
                                conf.Valido = data.StatusId == 2 ? true : false;
                                
                                $scope.verificarIndiceValido();
                            }
                        });

                    }, 5000, true, conf);
                };

                confPendentes.forEach(function (el) {
                    checkPendente(el);
                });

            }

            $scope.acessarTarefas = function(){
                $location.url('tarefas?setup=true');
            }


            $scope.verificarIndiceValido = function(){                
                $scope.indiceValido = _.findIndex($scope.configuracoes, function (el) {
                    return el.StatusId !== 2;
                });

                if ($scope.indiceValido == -1) {
                    $scope.indiceValido = $scope.configuracoes.length;
                }

                $scope.validoPorcentagem = $scope.indiceValido * (100 / $scope.configuracoes.length);
            }

            $scope.reloadData();

            $scope.acessarConfiguracao = function (task, $event) {
                $event.stopPropagation();
                $scope.taskClicked = task;
                $location.url(task.Link + '?setup=true');
                //$state.go(task.Link);
            };

            $scope.$on("$destroy", function (event) {
                // remover timers que chamam Validate
                angular.forEach($scope.configuracoes, function (conf) {
                    if (conf.intervalId) $interval.cancel(conf.intervalId);
                });
            });

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                SistemaValidacaoResource.getTodos().$promise.then(function (data) {
                    $scope.validacoes = data;
                    $scope.reloadData();
                });
            });

            $scope.finalizar = function () {
                LocalStorageService.setItem('FazendoSetup', false);
                SistemaValidacaoResource.setConfigurado();
                $state.go('main.default.list');
            }

            $scope.mostrarDescricao = function (task) {
                var msg = "<h4>" + task.Nome + "</h4><p>" + task.Descricao + "</p>";
                $window.UIkit.modal.alert(msg);
            }

        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.skill", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.skill.list',
                        pageTitle: 'telaSkill.titulo',
                        pageName: 'telaSkill.titulo'
                    }
                })
                .state("main.skill.list", StateResolverProvider.configState("/skill", "Skill", "List", {
                    pageTitle: 'telaSkill.titulo',
                    pageName: 'telaSkill.titulo'
                }));
        }])

        .service('SkillListData', function SkillListData() {
            return function () {
                return {
                    skills: ["SkillResource", function (SkillResource) {
                        var odata = SkillResource.odata();
                        odata.orderBy('Descricao', 'asc');
                        return odata.query();
                    }]
                };
            };
        })

        .controller("SkillListController", ["$scope", "skills", "SkillResource", "NotifyService", "ModalService", "$http", "Config", function ($scope, skills, SkillResource, NotifyService, ModalService, $http, Config) {
            $scope.skills = skills;

            // Estado do modal — em "Nova", SkillId fica undefined para que o
            // $odataresource não anexe ":SkillId" no POST (geraria /api/Skill/0 -> 405).
            $scope.modalSkill = {
                Descricao: '',
                Valor: 0
            };
            $scope.modoEdicao = false;
            $scope.salvandoSkill = false;

            var carregarLista = function () {
                SkillResource.odata().orderBy('Descricao', 'asc').query()
                    .then(function (lista) { $scope.skills = lista; })
                    .catch(NotifyService.showError);
            };

            $scope.abrirModalNova = function () {
                $scope.modalSkill = { Descricao: '', Valor: 0 };
                $scope.modoEdicao = false;
                $scope.forms.formSkill && $scope.forms.formSkill.$setPristine();
                ModalService.openModal('modalSkill');
            };

            $scope.abrirModalEditar = function (skill) {
                $scope.modalSkill = {
                    SkillId: skill.SkillId,
                    Descricao: skill.Descricao,
                    Valor: skill.Valor
                };
                $scope.modoEdicao = true;
                $scope.forms.formSkill && $scope.forms.formSkill.$setPristine();
                ModalService.openModal('modalSkill');
            };

            $scope.forms = {};

            $scope.concluirSkill = function (form) {
                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }
                $scope.salvandoSkill = true;

                var promise;
                if ($scope.modoEdicao && $scope.modalSkill.SkillId > 0) {
                    promise = SkillResource.update($scope.modalSkill).$promise;
                } else {
                    promise = SkillResource.save($scope.modalSkill).$promise;
                }

                promise.then(function () {
                    $scope.salvandoSkill = false;
                    ModalService.closeModal('modalSkill');
                    NotifyService.showRegistroSalvo();
                    carregarLista();
                }).catch(function (error) {
                    $scope.salvandoSkill = false;
                    NotifyService.showError(error);
                });
            };

            $scope.confirmDelete = function (skill) {
                ModalService.confirmDelete(function () {
                    var url = Config.getUrl("Skill") + '/' + skill.SkillId;
                    $http.delete(url).then(function () {
                        carregarLista();
                    }).catch(NotifyService.showError);
                });
            };
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("SkillResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Skill/:SkillId",
                {
                    "SkillId": "@SkillId"
                });
        }]);
})();

(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('SmsCampanhaEditData', function SmsCampanhaEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_uiSelect',
							'lazy_wizard'
						]);
					}],
					associacao: ["SmsCampanhaResource", "$stateParams", function (SmsCampanhaResource, $stateParams) {
						if ($stateParams.SmsCampanhaId) {
							return SmsCampanhaResource.get({
								SmsCampanhaId: $stateParams.SmsCampanhaId
							}).$promise;
						} else {
							return {};
						}
					}],
					campanhasTalkSms: ["SmsCampanhaResource", function (SmsCampanhaResource) {
						return SmsCampanhaResource.GetCampanhasTalkSms().$promise;
					}],
					campanhas: ["CampanhaResource", function (CampanhaResource) {
						var odata = CampanhaResource.odata().orderBy('Descricao', 'asc');
						return odata.query();
					}],
					templates: ["SmsDicionarioTemplateResource", function (SmsDicionarioTemplateResource) {
						var odata = SmsDicionarioTemplateResource.odata().orderBy('Descricao', 'asc');
						return odata.query();
					}]
				}
			}
		})

		.controller("SmsCampanhaEditController", ["$scope", "$state", "associacao", "campanhas", "templates", "campanhasTalkSms", "SmsCampanhaResource", "NotifyService", "$translate", function ($scope, $state, associacao, campanhas, templates, campanhasTalkSms, SmsCampanhaResource,
			NotifyService, $translate) {
			campanhas.forEach(campanha => {
				campanha.Nome = `${campanha.CampanhaId} - ${campanha.Nome}`
			});
			$scope.campanhas = campanhas
			$scope.campanhasTalkSms = campanhasTalkSms;
			$scope.associacao = associacao;
			$scope.isNew = !(associacao && associacao.SmsCampanhaId);

			$scope.templates = templates;
			$scope.forms = {};

			$scope.pesos = [
				{ 'PesoId': '1', 'Nome': $translate.instant('telaSmsCampanhaEdit.baixa') },
				{ 'PesoId': '2', 'Nome': $translate.instant('telaSmsCampanhaEdit.media') },
				{ 'PesoId': '3', 'Nome': $translate.instant('telaSmsCampanhaEdit.alta') }
			];

			$scope.status = [
				{ 'SmsStatusId': '1', 'Nome': $translate.instant('status.sucesso') },
				{ 'SmsStatusId': '2', 'Nome': $translate.instant('status.neutro') },
				{ 'SmsStatusId': '3', 'Nome': $translate.instant('status.insucesso') }
			];

			$scope.onCampanhaTalkSmsChange = function () {
				var campanhaTalkSms = _.filter($scope.campanhasTalkSms, (camp) => {
					return camp.CampanhaId == $scope.associacao.TalkSmsCampanhaId;
				});

				if (campanhaTalkSms.length == 1) {
					$scope.associacao.TalkSmsCampanhaNome = campanhaTalkSms[0].Nome;
				}
			}

			$scope.salvar = function (form) {
				if (!form.$valid) {
					return form.$setSubmitted();
				}

				$('#page_preloader').show();

				$scope.submitted = true;
				var promise;

				if ($scope.associacao.SmsCampanhaId > 0) {
					promise = SmsCampanhaResource.update($scope.associacao).$promise;
				}
				else {
					promise = SmsCampanhaResource.save($scope.associacao).$promise;
				}

				promise.then(() => {
					$('#page_preloader').hide();
					mensagemSucesso();
					$state.go('main.smsCampanha.list', { storage: true });
				}).catch(mensagemErro);
			};

			var mensagemSucesso = function (result) {
				NotifyService.showRegistroSalvo();
				$scope.submitted = false;
				$scope.integracao = result;
			}

			var mensagemErro = function (error) {
				$('#page_preloader').hide();
				$scope.submitted = false;
				NotifyService.showError(error);
			}

		}]);
	})
();
(function () {
    "use strict";

    var getOdataSearchShared = function (SmsCampanhaResource, search, orderBy) {
        var odata = SmsCampanhaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Campanha) {
            odata.where('Campanha/Descricao', 'contains', search.Campanha);
        }

        if (search.Descricao) {
            odata.where('Nome', 'contains', search.Descricao);
        }

        if (search.Ativo != undefined) {
            odata.filter("Ativo", "=", search.Ativo);
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.smsCampanha", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.smsCampanha.list',
                        pageTitle: 'model.campanhaDeSms',
                        pageName: 'model.campanhaDeSms'
                    }
                })
                .state("main.smsCampanha.list", StateResolverProvider.configState("/smsCampanha", "SmsCampanha", "List", {
                    pageTitle: 'model.campanhaDeSms',
                    pageName: 'pageTitle.pesquisar',
                    css: true
                }))
                .state("main.smsCampanha.edit", StateResolverProvider.configState("/smsCampanha/{SmsCampanhaId:[0-9]+}", "SmsCampanha", "Edit", {
                    pageTitle: 'model.campanhaDeSms',
                    pageName: 'acoes.editar'
                }))
                .state("main.smsCampanha.new", StateResolverProvider.configState("/smsCampanha/new?page", "SmsCampanha", "Edit", {
                    pageTitle: 'model.campanhaDeSms',
                    pageName: 'acoes.cadastrar'
                }))
        }])

        .service("SmsCampanhaListData", function SmsCampanhaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhas: ["SmsCampanhaResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (SmsCampanhaResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = { 'Ativo': true };

                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroSmsCampanha");
                        }

                        var orderBy = {
                            column: "SmsCampanhaId",
                            order: "asc"
                        };

                        var odata = getOdataSearchShared(SmsCampanhaResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                }
            }
        })

        .controller("SmsCampanhaListController", ["$scope", "$odata", "SmsCampanhaResource", "campanhas", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "$translate", "ModalService", function ($scope, $odata, SmsCampanhaResource, campanhas, utils, LocalStorageService, $stateParams,
            NotifyService, $state, $translate, ModalService) {
            $scope.nomeCampanhaResumo = '';
            $scope.resumo = {};
            $scope.campanhas = campanhas;
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroSmsCampanha") : { Ativo: true };
            $scope.orderBy = {
                column: "SmsCampanhaId",
                order: "asc"
            };

            $scope.envioTeste = {
                telefonePara: "",
                mensagem: $translate.instant('modalEnvioTeste.mensagemEnvio') ,
                smsCampanhaId: 0
            };

            $scope.ativoList = [
                { 'Valor': true, 'Nome': $translate.instant('status.ativo') }, 
                { 'Valor': false, 'Nome': $translate.instant('status.inativo') }
            ];

            var updateList = function (list) {
                $scope.campanhas = list;
                $scope.campanhas.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.campanhas.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(SmsCampanhaResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroSmsCampanha', $scope.search);
                $scope.searching = true;
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.campanhas.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            updateList(campanhas);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroSmsCampanha');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            $scope.confirmDelete = function (id) {
                ModalService.confirmInativar(() => {
                    return SmsCampanhaResource.Inativar({ 'SmsCampanhaId': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage)
                        }).catch(NotifyService.showError);
                });
            };

            $scope.confirmReativar = function (id) {
                ModalService.confirmReativar(() => {
                    SmsCampanhaResource.Reativar({ 'SmsCampanhaId': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage);
                        }).catch(NotifyService.showError);
                });
            }

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, { storage: true });
                }
                else {
                    $state.go('main.servicos.list', { storage: true });
                }
            };

            $scope.abrirModalDetalhe = function (campanha) {
                SmsCampanhaResource.GetSmsCampanhaDetalhe({ SmsCampanhaId: campanha.SmsCampanhaId }).$promise
                    .then((data) => {
                        $scope.resumo = data;
                    }).catch(NotifyService.showError);
                $scope.nomeCampanhaResumo = campanha.Nome;
                ModalService.openModal("modal_detalhe_sms_campanha");
            }

            $scope.abrirModalEnvioTeste = function (campanha) {
                $scope.envioTeste.smsCampanhaId = campanha.SmsCampanhaId;
                $scope.nomeCampanhaResumo = campanha.Nome;
                ModalService.openModal("modal_envio_teste");
            }

            $scope.enviarTeste = function () {
                return SmsCampanhaResource.EnvioTeste($scope.envioTeste).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        ModalService.closeModal('modal_envio_teste');
                    })
                    .catch(NotifyService.showError);
            }
        }]);
})();
(function () {
    "use strict";


    var getOdataSearchShared = function (SmsCampanhaArquivoResource, search, orderBy, $odata, utils, $stateParams) {
        var odata = SmsCampanhaArquivoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if ($stateParams.SmsCampanhaId)
            odata.filter('SmsCampanhaId', '=', parseInt($stateParams.SmsCampanhaId));

        if (search.Nome)
            odata.filter(new $odata.Func("contains", "Nome", search.Nome), true);

        angular.forEach(search, function (value, key) {
            if (key !== "pageSize" && key !== "Nome" && value != null && value != '')
                odata.filter(key, value);
        });

        return odata;
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.smsCampanha.arquivos", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true
                })
                .state("main.smsCampanha.arquivos.list", StateResolverProvider.configState("/smsCampanha/{SmsCampanhaId:[0-9]+}/arquivos", "SmsCampanhaArquivo", "List", {
                    pageTitle: 'pageTitle.smsArquivo',
                    pageName: 'pageTitle.arquivos',
                    permissions: {
                        'SmsCampanha': 'Cadastrar' 
                    },
                    css: true
                }));
        }])

        .service('SmsCampanhaArquivoListData', function SmsCampanhaArquivoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_fileUpload',
                            'lazy_wizard'
                        ]);
                    }],
                    smsArquivos: ["SmsCampanhaArquivoResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (SmsCampanhaArquivoResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};

                        if ($stateParams.SmsCampanhaId) {
                            filtro = {
                                SmsCampanhaId: parseInt($stateParams.SmsCampanhaId)
                            };
                        } 

                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroSmsCampanhaArquivo");

                        var orderBy = {
                            column: "Id",
                            order: "desc"
                        };

                        var odata = getOdataSearchShared(SmsCampanhaArquivoResource, filtro, orderBy, $odata, utils, $stateParams);
                        return odata.page(10, 1).query();
                    }],
                    smsCampanha: ["SmsCampanhaResource", "$stateParams", function (SmsCampanhaResource, $stateParams) {
                        return SmsCampanhaResource.get({
                            SmsCampanhaId: $stateParams.SmsCampanhaId
                        }).$promise;
                    }],
                }
            }
        })

        .controller("SmsCampanhaArquivoListController",
            ["Config", "Upload", "$scope", "$odata", "smsArquivos", "SmsCampanhaArquivoResource", "utils", "LocalStorageService", "$stateParams", "smsCampanha", "NotifyService", "$translate", "ModalService", function (Config, Upload, $scope, $odata, smsArquivos, SmsCampanhaArquivoResource, utils, LocalStorageService, $stateParams, smsCampanha, NotifyService,
                $translate, ModalService) {
                $scope.SmsCampanhaArquivo = {
                    SmsCampanhaArquivoId: 0,
                    SmsCampanhaId: smsCampanha.SmsCampanhaId,
                    SmsLayoutId: smsCampanha.SmsLayoutId,
                    Nome: '',
                    Descricao: ''
                };

                var urlUpload = Config.getUrl("SmsCampanhaArquivo/Importar");

                $scope.Arquivos = [];
                $scope.files = [];
                $scope.forms = [];
                $scope.SmsLayoutId = null;
                $scope.ArquivoProgresso = [];
                $scope.filtros = [{}];
                $scope.arquivos = [];
                $scope.searching = false;
                $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroSmsCampanhaArquivo") : {};
                $scope.orderBy = {
                    column: "Id",
                    order: "desc"
                };
                $scope.StatusIntegracao = [
                    $translate.instant('status.pendenteCriacao'),
                    $translate.instant('status.integrado'),
                    $translate.instant('status.pendenteExclusao'),
                    $translate.instant('status.excluido'),
                    $translate.instant('status.pendenteAlteracao'),
                    $translate.instant('status.pendenteDesbloqueio'),
                    $translate.instant('status.pendenteBloqueio'),
                    $translate.instant('status.bloqueado'),
                    $translate.instant('status.livre'),
                    $translate.instant('status.erroDeIntegracao')
                ];

                var updateList = function (list) {
                    $scope.arquivos = list;
                    $scope.arquivos.recordCount = list.$recordCount || list.length;
                    $scope.currentPage = list.$currentPage || 1;
                    $scope.arquivos.pageSize = list.$pageSize || 10;
                    $scope.searching = false;
                };

                var getOdataSearch = function getOdataSearch() {
                    return getOdataSearchShared(SmsCampanhaArquivoResource, $scope.search, $scope.orderBy, $odata, utils, $stateParams);
                };

                $scope.executeSearch = function executeSearch() {
                    LocalStorageService.setItem('FiltroSmsCampanhaArquivo', $scope.search);

                    $scope.searching = true;
                    getOdataSearch()
                        .page($scope.search.pageSize, 1)
                        .query().then(updateList).catch(NotifyService.showError);
                };

                var deleteRecord = function (data) {
                    return SmsCampanhaArquivoResource.delete({
                        Id: data.Id
                    }).$promise
                        .then(function () {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage)
                        })
                        .catch(NotifyService.showError);
                };

                $scope.confirmDelete = function confirmDelete(data) {
                    ModalService.confirmDelete(() => deleteRecord(data));
                };

                $scope.pageChanged = function (newPage) {
                    return getOdataSearch()
                        .page($scope.arquivos.pageSize, newPage)
                        .query().then(updateList).catch(NotifyService.showError);
                };

                updateList(smsArquivos);

                $scope.limparFiltro = function () {
                    LocalStorageService.removeItem('FiltroSmsCampanhaArquivo');
                    $scope.search = {
                        pageSize: 10
                    };
                    $scope.executeSearch();
                };

                $scope.uploadFiles = function (files, errFiles) {
                    var smsLayoutId = smsCampanha.SmsLayoutId;

                    if (files.length == 0 && errFiles.length == 0) return;

                    $scope.errFiles = errFiles;

                    angular.forEach(files, function (f) {
                        $scope.files.push(f);
                    });

                    angular.forEach(files, function (file) {
                        file.upload = Upload.upload({
                            url: urlUpload,
                            data: {
                                file: file,
                                nome: file.name,
                                smsCampanhaId: $stateParams.SmsCampanhaId,
                                layoutId: smsLayoutId,
                                contentType: file.type
                            }
                        });

                        file.upload.then(function (response) {
                            var arquivo = {
                                SmsCampanhaArquivoId: response ? response.data : 0,
                                ArquivoNome: file.name
                            };

                            $scope.Arquivos.push(arquivo);
                            
                            $scope.pageChanged($scope.currentPage);

                            file.ArquivoId = arquivo.SmsCampanhaArquivoId;

                        }, function (response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': ' + response.data;
                        }, function (evt) {
                            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                        });
                    });

                    NotifyService.showSuccess('telaSmsCampanhaArquivo.arquivoImportadoComSucesso');
                }
            }]
        );
})();
(function () {
	"use strict";

	angular.module('epbxManagerApp')
		.factory("SmsCampanhaArquivoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("SmsCampanhaArquivo/:Id", {
				"Id": "@Id"
			}, {
					get: {
						url: "SmsCampanhaArquivo",
						method: "GET",
						isArray: true
					},
					Importar: {
						url: "SmsCampanhaArquivo/Importar",
						method: "POST"
					},
					GetLayoutsTalkSms: {
						url: "SmsCampanha/GetLayoutsTalkSms",
						method: "GET",
						isArray: true
					},
					GetCampanhasLayoutsTalkSms: {
						url: "SmsCampanha/GetCampanhasLayoutsTalkSms",
						method: "GET",
						isArray: true
					},
				})
		}])
		.factory("SmsCampanhaImportacaoMotivoResource", ["$odataresource", function ($odataresource) {
			return $odataresource("SmsCampanhaImportacaoMotivo");
		}])
})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('SmsDicionarioTemplateEditData', function SmsDicionarioTemplateEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_masked_inputs',
							'lazy_uiSelect',
							'lazy_wizard'
						]);
					}],
					dicionario: ["SmsDicionarioTemplateResource", "$stateParams", function (SmsDicionarioTemplateResource, $stateParams) {
						if ($stateParams.SmsDicionarioId) {
							return SmsDicionarioTemplateResource.get({
								SmsDicionarioId: $stateParams.SmsDicionarioId
							}).$promise;
						} else {
							return {};
						}
					}]
				}
			}
		})

		.controller("SmsDicionarioTemplateEditController",
			["$scope", "$state", "dicionario", "SmsDicionarioTemplateResource", "NotifyService", "$translate", "ModalService", function ($scope, $state, dicionario, SmsDicionarioTemplateResource, NotifyService, $translate, ModalService) {
				$scope.mostrarResultado = false;
				$scope.mensagemResposta = '';
				$scope.forms = {};
				$scope.dicionario = dicionario;
				var simularDicionario = {};

				if ($scope.dicionario.SmsDicionarioItems == undefined) {
					$scope.dicionario = {
						SmsDicionarioItems: []
					}
				}

				$scope.pesos = [
					{ 'PesoId': '1', 'Nome': $translate.instant('telaSmsDicionarioTemplateEdit.baixa') }, 
					{ 'PesoId': '2', 'Nome': $translate.instant('telaSmsDicionarioTemplateEdit.media') }, 
					{ 'PesoId': '3', 'Nome': $translate.instant('telaSmsDicionarioTemplateEdit.alta') }
				]
				$scope.status = [
					{ 'SmsStatusId': '1', 'Nome': $translate.instant('status.sucesso') }, 
					{ 'SmsStatusId': '3', 'Nome': $translate.instant('status.insucesso') }
				]

				var mensagemSucesso = function (result) {
					NotifyService.showRegistroSalvo();
					$scope.submitted = false;
					$scope.integracao = result;
				}

				var mensagemErro = function (error) {
					$('#page_preloader').hide();
					NotifyService.showError(error);
					$scope.submitted = false;
				}

				$scope.salvar = function () {
					if (!$scope.forms.formDescricao.$valid) {
						$scope.forms.formDescricao.$setSubmitted();
						return;
					}

					$('#page_preloader').show();

					$scope.submitted = true;
					var promise;

					if ($scope.dicionario.SmsDicionarioId > 0)
						promise = SmsDicionarioTemplateResource.update($scope.dicionario).$promise;
					else
						promise = SmsDicionarioTemplateResource.save($scope.dicionario).$promise;

					promise.then(function () {
						$('#page_preloader').hide();
						mensagemSucesso();
						$state.go('main.smsDicionarioTemplate.list', { storage: true });
					}).catch(mensagemErro);
				}

				$scope.cancelar = function () {
					$state.go('main.smsDicionarioTemplate.list');
				}

				$scope.openModal = function (idModal) {
					ModalService.openModal(idModal);
                };

				$scope.adicionarPalavra = function (palavra) {
					if ($scope.forms.formPalavra.$valid) {
						var palExiste = _.filter($scope.dicionario.SmsDicionarioItems, function (item) {
							return item.Palavra == palavra.Palavra;
						})

						if (palExiste.length > 0) {
							if (palExiste[0].SmsStatusId == palavra.SmsStatusId) {
								NotifyService.showError(null, $translate.instant('telaSmsDicionarioTemplateEdit.palavraJaCadastradaNaListagem'))
							}
							else {
								NotifyService.showError(null, $translate.instant('telaSmsDicionarioTemplateEdit.palavraJaCadastradaEmOutraListagem'))
							}
							return
						}
						var pal = angular.copy(palavra);
						$scope.dicionario.SmsDicionarioItems.push(pal);
					}
				}

				$scope.removerPalavra = function (palavra) {
					var pal = _.filter($scope.dicionario.SmsDicionarioItems, function (item) {
						return item.Palavra != palavra.Palavra;
					})

					$scope.dicionario.SmsDicionarioItems = pal;
				}

				$scope.getPesoDescricao = function (peso) {
					peso = _.filter($scope.pesos, function (item) {
						return item.PesoId == peso;
					})

					return peso[0].Nome
				}

				$scope.simularMensagem = function (form) {
                    if (!form.$valid) {
                        form.$setSubmitted();
                        return;
                    }
					simularDicionario.smsDicionarioId = dicionario.SmsDicionarioId;
					simularDicionario.mensagem = form.Mensagem;
					$scope.mensagemResposta = form.Mensagem;

                    SmsDicionarioTemplateResource.AnalisarTexto(simularDicionario).$promise.then(function(data){
						$scope.mostrarResultado = true;
                        $scope.respostaSimulacao = data.Palavras;
						$scope.statusSimulacao = data.Status;
                    }).catch(NotifyService.showError);
				}
				
				$scope.simularNovamente = function () {
					$scope.mostrarResultado = false;
				}
			}]
		);

})();
(function () {
    "use strict";

    var getOdataSearchShared = function (SmsDicionarioTemplateResource, search) {
        var odata = SmsDicionarioTemplateResource.odata();

        if (search.Descricao) {
            odata.where('Descricao', 'contains', search.Descricao);
        }

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.smsDicionarioTemplate", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.smsDicionarioTemplate.list',
                        pageTitle: 'model.dicionario',
                        pageName: 'model.dicionario'
                    }
                })
                .state("main.smsDicionarioTemplate.list", StateResolverProvider.configState("/smsDicionarioTemplate", "SmsDicionarioTemplate", "List", {
                    pageTitle: 'model.dicionario',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.smsDicionarioTemplate.edit", StateResolverProvider.configState("/smsDicionarioTemplate/{SmsDicionarioId:[0-9]+}", "SmsDicionarioTemplate", "Edit", {
                    pageTitle: 'model.dicionario',
                    pageName: 'acoes.editar',
                    css: true,
                    cssFiles: ['app/pages/smsDicionarioTemplate/style/simularMensagem.css', 'app/pages/smsDicionarioTemplate/style/edit.css']
                }))
                .state("main.smsDicionarioTemplate.new", StateResolverProvider.configState("/smsDicionarioTemplate/new?page", "SmsDicionarioTemplate", "Edit", {
                    pageTitle: 'model.dicionario',
                    pageName: 'acoes.cadastrar'
                }));
        }])
        .service("SmsDicionarioTemplateListData", function SmsDicionarioTemplateListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    templatesList: ["SmsDicionarioTemplateResource", function (SmsDicionarioTemplateResource) {
                        return SmsDicionarioTemplateResource.odata().query();
                    }]
                }
            }
        })

        .controller("SmsDicionarioTemplateListController", ["$scope", "$odata", "utils", "templatesList", "SmsDicionarioTemplateResource", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", function ($scope, $odata, utils, templatesList, SmsDicionarioTemplateResource, LocalStorageService,
            $stateParams, NotifyService, ModalService) {
            $scope.searching = false;
            $scope.templates = templatesList;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroSmsCampanha") : {};

            var updateList = function (list) {
                $scope.templates = list;
                $scope.templates.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.templates.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(SmsDicionarioTemplateResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroSmsDicionarioTemplate', $scope.search);
                $scope.searching = true;
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.templates.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            updateList($scope.templates);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroSmsDicionarioTemplate');
                $scope.executeSearch();
            };

            $scope.confirmDelete = function (id) {
                ModalService.confirmInativar(() => {
                    return SmsDicionarioTemplateResource.Inativar({ 'SmsDicionarioId': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage)
                        }).catch(NotifyService.showError);
                });
            };

            $scope.confirmReativar = function (id) {
                ModalService.confirmReativar(() => {
                    SmsDicionarioTemplateResource.Reativar({ 'SmsDicionarioId': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage);
                        }).catch(NotifyService.showError);
                });
            }
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("SmsDicionarioTemplateResource", ["$odataresource", function ($odataresource) {
            return $odataresource("SmsDicionario/:SmsDicionarioId", {
                "SmsDicionarioId": "@SmsDicionarioId"
            }, {
                Reativar: {
                    method: "PUT",
                    url: "SmsDicionario/:SmsDicionarioId/Ativar"
                },
                Inativar: {
                    method: "PUT",
                    url: "SmsDicionario/:SmsDicionarioId/Inativar"
                },
                GetAtivos: {
                    method: "GET",
                    url: "SmsDicionario/GetAtivos",
                    isArray: true
                },
                AdicionarItem: {
                    method: "POST",
                    url: "SmsDicionario/AdicionarItem",
                },
                AnalisarTexto: {
                    method: "GET",
                    url: "SmsDicionario/AnalisarTexto/:SmsDicionarioId"
                }
            });
        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {

        $stateProvider
            .state("main.smsTemplate.edit", StateResolverProvider.configState("/smsTemplate/{Id:[0-9]+}", "SmsTemplate", "Edit", {
                pageTitle: 'pageTitle.templateSMS',
                pageName: 'acoes.editar',
                css: true,
                cssFiles: ['app/pages/campanha/style/regra.css']
            }))
            .state("main.smsTemplate.new", StateResolverProvider.configState("/smsTemplate/new", "SmsTemplate", "Edit", {
                pageTitle: 'pageTitle.templateSMS',
                pageName: 'acoes.cadastrar',
                css: true,
                cssFiles: ['app/pages/campanha/style/regra.css']
            }));
    }])

    .service("SmsTemplateEditData", function GoogleAgentEditData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([                        
                        'lazy_parsleyjs',
                        'lazy_masked_inputs',
                        'lazy_uiSelect'
                    ]);
                }],
                smsTemplate: ["SmsTemplateResource", "$stateParams", function (SmsTemplateResource, $stateParams) {
                    if ($stateParams.Id) {
                        return SmsTemplateResource.get({
                            Id: parseInt($stateParams.Id)
                        }).$promise;
                    } else {
                        return {};
                    }
                }],
                grupos: ["GrupoResource", function (GrupoResource) {
                    let odata = GrupoResource.odata().orderBy("Descricao", "asc");
                    return odata.query();
                }],
                campanhasTalkSms: ["SmsCampanhaResource", function (SmsCampanhaResource) {
                    return SmsCampanhaResource.GetCampanhasTalkSms().$promise;
                }]
            }
        }
    })

    .controller("SmsTemplateEditController", ["$scope", "smsTemplate", "$state", "$stateParams", "SmsTemplateResource", "NotifyService", "$translate", "grupos", "campanhasTalkSms", function ($scope, smsTemplate, $state, $stateParams, SmsTemplateResource, NotifyService, $translate, grupos, campanhasTalkSms) {
            $scope.smsTemplate = smsTemplate;            
            $scope.smsTemplate.Id = (smsTemplate.Id > 0 ? smsTemplate.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.isNew = smsTemplate.Id > 0 ? false : true;
            $scope.inserirOuEditar = smsTemplate && smsTemplate.Id ? $translate.instant('ediTemplateSms.editandoTemplate') : $translate.instant('ediTemplateSms.cadastrandoTemplate');
            $scope.numberOfCharacters = 0;            
            $scope.excedeuMaxCaracteres = false;      
            $scope.grupos = grupos; 
            $scope.campanhas = campanhasTalkSms;     

            $scope.variaveis = [
                { Descricao: "#NomeDoCliente" },
                { Descricao: "#CodigoCampanha" },
                { Descricao: "#CodigoCliente" },
                { Descricao: "#GlobalId" },
                { Descricao: "#NomeCampanha" },
                { Descricao: "#Telefone" },
                { Descricao: "#Protocolo" }
            ];
            
            if($scope.smsTemplate.Mensagem)
                $scope.numberOfCharacters = $scope.smsTemplate.Mensagem.length;


            $scope.salvar = function (valid) {
                var promise;

                if (!valid) {
                    return NotifyService.showInvalid();
                }                

                var data = {
                    Id: $scope.smsTemplate.Id,
                    Descricao: $scope.smsTemplate.Descricao,                                            
                    Mensagem: $scope.smsTemplate.Mensagem,
                    GrupoId: $scope.smsTemplate.GrupoId,
                    CampanhaTalkSmsId: $scope.smsTemplate.CampanhaTalkSmsId
                };

                if ($scope.smsTemplate.Id > 0) {
                    promise = SmsTemplateResource.update(data.Id, data).$promise;
                }
                else {
                    promise = SmsTemplateResource.save(data).$promise;
                }

                promise.then((data) => {
                    $scope.templateSms = data;
                    NotifyService.showRegistroSalvo();                    
                    $state.go("main.smsTemplate.list", {
                        page: 'main.smsTemplate.list'
                    });

                }).catch(NotifyService.showError);
            
            };

            $scope.countCharacters = function(){
                if ($scope.smsTemplate.Mensagem.length == 0)
                    return
                
                $scope.numberOfCharacters = $scope.smsTemplate.Mensagem.length;

                $scope.excedeuMaxCaracteres = false;

                if($scope.numberOfCharacters > 147)
                    $scope.excedeuMaxCaracteres = true;
            }

            
            $scope.clickVariavel =  function(variavel){
                $scope.smsTemplate.Mensagem = $scope.smsTemplate.Mensagem + " " + variavel.Descricao + " ";
                $scope.numberOfCharacters = $scope.smsTemplate.Mensagem.length;

                $scope.excedeuMaxCaracteres = false;

                if($scope.numberOfCharacters > 147)
                    $scope.excedeuMaxCaracteres = true;

                var elemente = document.querySelector('#Mensagem');
                elemente.focus();                
            };
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (SmsTemplateResource, search, orderBy, $odata) {
        var odata = SmsTemplateResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true);
        }
        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.smsTemplate", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.smsTemplate.list',
                    pageTitle: 'pageTitle.templateSMS',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.smsTemplate.list", StateResolverProvider.configState("/smsTemplate", "SmsTemplate", "List", {
                pageTitle: 'pageTitle.templateSMS',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("SmsTemplateListData", function GoogleAgentListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                 smsTemplate: ["SmsTemplateResource", "LocalStorageService", "$odata", "$stateParams", function (SmsTemplateResource, LocalStorageService, $odata, $stateParams) {
                     var filtro = {};

                     if ($stateParams.storage) {
                         filtro = LocalStorageService.getItem("FiltroTemplateSMS");
                     }

                     var orderBy = {
                         column: "Descricao",
                         order: "asc"
                     };

                     return getOdataSearchShared(SmsTemplateResource, filtro, orderBy, $odata).page(10, 1).query();
                 }],
            }
        }
    })

    .controller("SmsTemplateListController", ["$scope", "$odata", "SmsTemplateResource", "utils", "LocalStorageService", "ModalService", "$stateParams", "NotifyService", "smsTemplate", function ($scope, $odata, SmsTemplateResource, utils, LocalStorageService, ModalService,
        $stateParams, NotifyService, smsTemplate) {
            $scope.smsTemplate = smsTemplate;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroTemplateSMS") : {};

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            var updateList = function (list) {
                $scope.smsTemplate = list;
                $scope.smsTemplate.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.smsTemplate.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(SmsTemplateResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.smsTemplate.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroTemplateSMS', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroTemplateSMS');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteSmsTemplate = function (data) {
                return SmsTemplateResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteSmsTemplate(data));
            };

            $scope.exibirErro = function (data){
                $scope.errorObject = data.ErrorObject;
                ModalService.openModal('modalErrorMessage');
            }

            updateList($scope.smsTemplate);

        }]);
})();
(function () {
    "use strict";
  
    angular.module('epbxManagerApp')
      .factory("SmsTemplateResource", ["$odataresource", function ($odataresource) {
        return $odataresource(
          "SmsTemplate/:Id",
          {
            "Id": "@Id"
          },
            {
            getAll: {
              url: "SmsTemplate",
              method: "GET",
              isArray: true
            },
            getTemplateSmsByGrupoPermissao: {
              url: "SmsTemplate/TemplateSmsByGrupoPermissao",
              method: "GET",
              isArray: true
            },
          
          });
      }]);  
  })();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.smsMensagemResposta", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.smsMensagemResposta.list',
                    pageTitle: 'pageTitle.mensagensDeResposta',
                    pageName: 'pageTitle.mensagensDeResposta'
                }
            })
                .state("main.smsMensagemResposta.list", StateResolverProvider.configState("/smsMensagemResposta", "SmsMensagemResposta", "List", {
                    pageTitle: 'pageTitle.mensagensDeResposta',
                    pageName: 'pageTitle.pesquisar',
                    css: true,
                    cssFiles: ['app/pages/smsDicionarioTemplate/style/simularMensagem.css', 'app/pages/smsMensagemResposta/style/list.css']
                }))
        }])

        .service("SmsMensagemRespostaListData", function SmsMensagemRespostaListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    campanhasList: ["SmsCampanhaResource", function (SmsCampanhaResource) {
                        return SmsCampanhaResource.GetAtivas().$promise;
                    }],
                    dicionariosAtivosList: ["SmsDicionarioTemplateResource", function (SmsDicionarioTemplateResource) {
                        return SmsDicionarioTemplateResource.GetAtivos().$promise;
                    }],
                    smsCampanhaAcoes: ["SmsMensagemRespostaResource", function (SmsMensagemRespostaResource) {
                        return SmsMensagemRespostaResource.GetSmsCampanhaAcao().$promise;
                    }],
                }
            }
        })

        .controller("SmsMensagemRespostaListController", ["$scope", "$http", "campanhasList", "dicionariosAtivosList", "NotifyService", "SmsMensagemRespostaResource", "SmsDicionarioTemplateResource", "smsCampanhaAcoes", "Config", "ConfiguracaoProvedorResource", "FileDownloadService", "$translate", "ModalService", function ($scope, $http, campanhasList, dicionariosAtivosList, NotifyService, SmsMensagemRespostaResource,
            SmsDicionarioTemplateResource, smsCampanhaAcoes, Config, ConfiguracaoProvedorResource, FileDownloadService, $translate, ModalService) {
            $scope.dicionariosAtivos = dicionariosAtivosList;
            $scope.forms = {};
            $scope.respostas = [];
            $scope.campanhas = campanhasList;
            $scope.smsCampanhaAcoes = smsCampanhaAcoes;
            $scope.countInternoFinalizado = false;
            $scope.quantidadeRegistros = 0;
            $scope.inserirResposta = [];
            $scope.mostrarResultado = true;
            $scope.mostrarBotaoVoltar = false;
            $scope.mensagemResposta = '';
            $scope.searching = false;

            $scope.pesos = [
                { 'PesoId': '1', 'Nome': $translate.instant('telaSmsDicionarioTemplateEdit.baixa') },
                { 'PesoId': '2', 'Nome': $translate.instant('telaSmsDicionarioTemplateEdit.media') },
                { 'PesoId': '3', 'Nome': $translate.instant('telaSmsDicionarioTemplateEdit.alta') }
            ];

            $scope.status = [
                { 'SmsStatusId': '1', 'Nome': $translate.instant('status.sucesso') },
                { 'SmsStatusId': '2', 'Nome': $translate.instant('status.neutro') },
                { 'SmsStatusId': '3', 'Nome': $translate.instant('status.insucesso') }
            ];

            $scope.novaRegraDicionario = {
                SmsDicionarioId: 0,
                SmsStatusId: 0,
                Palavra: '',
                Peso: 0
            };

            var simularDicionario = {};
            var defaultPageIndex = 1;
            var defaultPageSize = 10;
            var dataInicio = moment({ h: 0, m: 0, s: 0, ms: 0 }).toDate();
            var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();

            $scope.search = {
                DataInicio: dataInicio,
                DataFim: dataFim,
                SmsCampanhaId: null,
                SmsAcaoId: null,
                SmsStatusId: 0,
                NB: null
            };

            var updateList = function (pagination) {
                $scope.respostas = pagination.Data;
                $scope.respostas.recordCount = pagination.RecordCount;
                $scope.currentPage = pagination.PageIndex || 1;
                $scope.respostas.pageSize = pagination.PageSize || defaultPageSize;
                $scope.searching = false;
            };

            $scope.getOdataSearch = function () {
                $scope.searching = true;
                $scope.countFinalizado = false;
                $scope.countInternoFinalizado = false;
                $scope.bilheteQuantidade = -1;
                var url = Config.getUrl("SmsMensagemResposta/") + defaultPageIndex + "/" + defaultPageSize;

                var filtro = {
                    SmsCampanhaId: $scope.search.SmsCampanhaId,
                    SmsAcaoId: $scope.search.SmsAcaoId,
                    SmsStatusId: $scope.search.SmsStatusId,
                    DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                    DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                    NB: $scope.search.NB,
                };

                SmsMensagemRespostaResource.GetCount(filtro).$promise
                    .then((data) => {
                        if ($scope.countInternoFinalizado == false) {
                            $scope.quantidadeRegistros = data.Quantidade;
                            $scope.countInternoFinalizado = true;
                        }
                    });

                return $http({ method: 'GET', url: url, params: filtro })
                    .then((response) => {
                        return response.data;
                    });
            };

            $scope.executeSearch = function () {
                $scope.reverse = false;
                defaultPageIndex = 1;
                $scope.getOdataSearch()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            $scope.pageChanged = function (newPage) {
                if (defaultPageIndex != newPage) {
                    defaultPageIndex = newPage;
                    $scope.getOdataSearch()
                        .then(updateList)
                        .catch((error) => {
                            NotifyService.showError(error);
                            $scope.searching = false;
                        });
                }
            };

            $scope.limparFiltro = function () {
                $scope.search = {
                    DataInicio: dataInicio,
                    DataFim: dataFim,
                    SmsCampanhaId: null,
                    SmsAcaoId: null,
                    SmsStatusId: 0,
                    NB: 1
                };
                $scope.executeSearch();
                $scope.search.NB = null;
            };

            $scope.abrirModal = function (resposta) {
                $scope.mensagemResposta = resposta.MensagemResposta;
                $scope.dicionarioResposta = dicionariosAtivosList.find(x => x.SmsDicionarioId == resposta.SmsDicionarioId);
                $scope.novaRegraDicionario = {
                    SmsDicionarioId: 0,
                    SmsStatusId: 0,
                    Palavra: '',
                    Peso: 0
                };
                if ($scope.formNovaRegraDicionario) {
                    $scope.formNovaRegraDicionario.$setUntouched;
                }
                ModalService.openModal('modal_inserir')
            };

            $scope.adicionarPalavra = function (form) {
                if (!form.$valid) {
                    form.$setSubmitted();
                    return NotifyService.showInvalid();
                }

                $scope.novaRegraDicionario.SmsDicionarioId = $scope.dicionarioResposta.SmsDicionarioId;

                SmsDicionarioTemplateResource.AdicionarItem($scope.novaRegraDicionario).$promise.then(() => {
                    NotifyService.showSuccess();
                    $scope.searching = false;
                    ModalService.closeModal('modal_inserir')
                }).catch(NotifyService.showError);
            }

            $scope.abrirModalMensagem = function (titulo, mensagem) {
                $scope.tituloModal = titulo;
                $scope.mensagemModal = mensagem;
                ModalService.openModal('modal_mensagemTruncate');
            };

            var simularMensagem = function (simularDicionario) {
                SmsDicionarioTemplateResource.AnalisarTexto(simularDicionario).$promise.then((data) => {
                    $scope.respostaSimulacao = data.Palavras;
                    $scope.statusSimulacao = data.Status;
                }).catch(NotifyService.showError);
            }

            $scope.simularResposta = function (resposta) {
                simularDicionario.smsDicionarioId = resposta.SmsDicionarioId;
                simularDicionario.mensagem = resposta.MensagemResposta;
                $scope.mensagemResposta = resposta.MensagemResposta;
                simularMensagem(simularDicionario);
                ModalService.openModal('modal_simular');
            }

            var retornoValidarConexao = function (result) {
                $scope.discagemIntegracaoServico.ConexaoValida = result.Valido;
                if ($scope.discagemIntegracaoServico.ConexaoValida) {
                    NotifyService.showSuccess('telaSmsMensagemResposta.conexaoValida')
                }
                else {
                    NotifyService.showError(null, 'telaSmsMensagemResposta.conexaoInvalida')
                }
            }

            $scope.validarConexao = function () {
                if ($scope.discagemIntegracaoServico) {
                    var promise = ConfiguracaoProvedorResource.validarConexao($scope.discagemIntegracaoServico).$promise;
                    promise.then(retornoValidarConexao).catch(NotifyService.showError);
                }
            };

            var obterDadosTalkSMS = function () {
                var promise = ConfiguracaoProvedorResource.getByProduto({ "produtoId": 2 }).$promise;
                promise.then((data) => {
                    $scope.discagemIntegracaoServico = data;
                });
            };

            obterDadosTalkSMS();

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
                });
                return uuid;
            }

            $scope.export = function () {
                try {
                    var fileName = generateUUID();

                    var filter = {
                        SmsCampanhaId: $scope.search.SmsCampanhaId,
                        SmsAcaoId: $scope.search.SmsAcaoId,
                        SmsStatusId: $scope.search.SmsStatusId,
                        DataI: moment($scope.search.DataInicio).format('YYYY-MM-DDTHH:mm:ss'),
                        DataF: moment($scope.search.DataFim).format('YYYY-MM-DDTHH:mm:ss'),
                        NB: $scope.search.NB,
                        FileName: fileName,
                    };

                    var url = Config.getUrl('SmsMensagemResposta/Historico/Exportar');
                    return $http({
                        method: 'POST',
                        url: url,
                        contentType: 'application/json; charset=utf-8',
                        data: JSON.stringify(filter)
                    }).then(() => {
                        FileDownloadService.downloadWebApiFile('atendimento/historico/' + fileName + '/download/');
                    }, (response) => {
                        NotifyService.showError(response);
                    });

                } catch (e) {
                    NotifyService.showError(e);
                }
            };

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("SmsMensagemRespostaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("SmsMensagemResposta/:SmsCampanhaId", {
                "SmsCampanhaId": "@SmsCampanhaId"
            }, {
                    GetCampanhasTalkSms: {
                        url: "SmsCampanha/GetCampanhasTalkSms",
                        method: "GET",
                        isArray: true
                    },
                    Reativar: {
                        method: "PUT",
                        url: "SmsCampanha/:SmsCampanhaId/Ativar"
                    },
                    Inativar: {
                        method: "PUT",
                        url: "SmsCampanha/:SmsCampanhaId/Inativar"
                    },
                    GetSmsCampanhaAcao: {
                        method: "GET",
                        url: "SmsCampanha/GetSmsCampanhaAcao",
                        isArray: true
                    },
                    GetCount: {
                        method: "GET",
                        url: "SmsMensagemResposta/Count"
                    }
                });
        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.softphoneServico", StateResolverProvider.configAbstract());

            $stateProvider
                .state("main.softphoneServico.list", StateResolverProvider.configState("/softphone/logados", "SoftphoneServico", "List", {
                    pageTitle: 'Softphones Logados',
                    pageName: 'Listar',
                    permissions: {
                        AllowAll: true
                    }
                }));
        }])


        .service("SoftphoneServicoListData", function SoftphoneServicoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load(['lazy_uiSelect']);
                    }]
                    ,softphoneServicoList: ["SoftphoneServicoResource", function (SoftphoneServicoResource) {
                        return SoftphoneServicoResource.odata().orderBy("MaquinaUsuario", "asc").query();
                    }]
                }
            }
        })

      .controller("SoftphoneServicoListController", ["$scope", "softphoneServicoList", "SoftphoneServicoResource", "NotifyService", function ($scope, softphoneServicoList, SoftphoneServicoResource, NotifyService) {
          $scope.softphoneList = softphoneServicoList;
          $scope.statusSoftphoneList = [
              { Descricao: "Logado" },
              { Descricao: "Deslogado" },
              { Descricao: "Serviço Desconectado" }
          ];

          var updateList = function(list) {
              $scope.softphoneList = list;
          }

          $scope.executeSearch = function executeSearch(search) {
              var odata = SoftphoneServicoResource.odata();
              angular.forEach(search, function (value, key) {
                  if (value)
                  {
                      odata.filter(key, value);
                  }
              });

              odata.query().then(updateList).catch(NotifyService.showError)
          }

          $scope.$on("onSoftphoneServicoChanged", function (event, data) {
              if (data.MaquinaNome) {
                  // procura a maquina na lista 
                  var item = _.findWhere($scope.softphoneList, { MaquinaNome: data.MaquinaNome });
                  if (item)
                  {
                      // se achar, substitui os dados do objeto da lista
                      angular.copy(data, item);
                  }
                  else
                  {
                      // senão adiciona o novo item a lista
                      $scope.softphoneList.push(data);
                  }
              }
          });
      }]);
})();

(function() {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("SoftphoneServicoResource", ["$odataresource", function ($odataresource) {
        return $odataresource("SoftphoneServico/:SoftphoneServicoId", { "SoftphoneServicoId": "@SoftphoneServicoId" });
    }]);

})();

(function () {
	"use strict";
	angular.module('epbxManagerApp')
	.factory("StatusIntegracaoResource", ["$odataresource", function ($odataresource) {
			return $odataresource(
				"StatusIntegracao/:Id", {
					"Id": "@Id"
				},
				{
					getStatusIntegracao: {
                        url: "StatusIntegracao/GetStatusIntegracao",
                        method: "GET",
                        isArray: true
                    }
				}
			);
		}])
})();
(function () {
    "use strict";
    angular
        .module("epbxManagerApp")
        .factory("TabulacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "Atendimento/:Id",
                {
                    Id: "@Id",
                },
                {
                    ContatoNegativo: {
                        method: "POST",
                        url: "Atendimento/ContatoNegativo",
                    },
                    CaixaPostal: {
                        method: "POST",
                        url: "Atendimento/CaixaPostal",
                    },
                    Agendamento: {
                        method: "POST",
                        url: "Atendimento/Agendamento",
                    },
                    GetStatusDetalhePorUsuario: {
                        method: "GET",
                        url: "RamalStatusDetalhe/StatusDetalhePorUsuario",
                    },
                    UpdateStatus: {
                        method: "POST",
                        url: "RamalStatusDetalhe/UpdateStatus",
                    },
                    EnviarEmail: {
                        method: "POST",
                        url: "Atendimento/EnviarEmail",
                    },
                    SendEmail: {
                        method: "POST",
                        url: "Atendimento/SendEmail",
                    },
                    GetConfiguracao: {
                        method: "GET",
                        url: "Atendimento/Configuracao",
                    },
                    Exportar: {
                        method: "POST",
                        url: "Atendimento/Exportar",
                    },
                    DownloadHistorico: {
                        url: "Atendimento/DownloadHistorico",
                        method: "GET",
                    },
                    GetCampos: {
                        method: "GET",
                        url: "AtendimentoLayouts/Campos",
                        isArray: true,
                    },
                    GetCategorias: {
                        method: "GET",
                        url: "Atendimento/Categorias",
                        isArray: true,
                    },
                    GetCategoriasPorTipo: {
                        method: "GET",
                        url: "Atendimento/Categorias",
                        isArray: true,
                    },
                    GetTipos: {
                        method: "GET",
                        url: "Atendimento/Tipos",
                        isArray: true,
                    },
                    GetTabulacoes: {
                        method: "GET",
                        url: "Atendimento/TabulacoesPorTelefone",
                        isArray: true,
                    },
                    GetLigacoes: {
                        method: "GET",
                        url: "Atendimento/LigacoesPorTelefone",
                        isArray: true,
                    },
                    GetCampanhas: {
                        method: "GET",
                        url: "Atendimento/Campanhas",
                        isArray: true,
                    },
                    GetRotasDiscador: {
                        method: "GET",
                        url: "Rota/RotasDiscador",
                        isArray: true,
                    },
                    GetProtocolo: {
                        method: "GET",
                        url: "Atendimento/Protocolo",
                        isArray: false,
                        params: {
                            globalId: "@globalId",
                        },
                    },
                    GetTopLigacoesRecebidas: {
                        method: "GET",
                        url: "Atendimento/TopLigacoesRecebidas",
                        isArray: true,
                        params: {
                            telefone: "@telefone",
                        },
                    },
                    GetTabulacoesIncompletasPorUsuario: {
                        method: "GET",
                        url: "Atendimento/TabulacoesIncompletasPorUsuario",
                        isArray: true,
                    },
                    GetServicosTransferencia: {
                        method: "GET",
                        url: "Atendimento/ServicosTransferencia/:servicoNumero",
                        isArray: true,
                    },
                    GetAtendimentoContato: {
                        method: "GET",
                        url: "Atendimento/Contato",
                        isArray: false,
                        params: {
                            telefone: "@telefone",
                        },
                    },
                    EnvioSMS: {
                        method: "POST",
                        url: "Atendimento/EnvioSMS"
                    },
                    SetAtendimentoContato: {
                        method: "POST",
                        url: "Atendimento/Contato",
                    },
                    UpdateAtendimentoContato: {
                        method: "PUT",
                        url: "Atendimento/Contato",
                    },
                    GetStatus: {
                        method: "Get",
                        url: "Atendimento/Status",
                        isArray: true,
                    },
                    GetBilhetUraByGlobalId: {
                        method: "Get",
                        url: "BilheteUra/GetBilheteUraByGlobalId",
                        isArray: false,
                        params: {
                            globalId: "@globalId",
                            servico: "@servico",
                        },
                    },
                    GetCarteira: {
                        url: "Carteira/CarteiraPorUsuario",
                        method: "GET",
                        params: {
                            usuarioId: "@usuarioId",
                        },
                        isArray: true,
                    },
                    GetById: {
                        url: "Atendimento/GetById",
                        method: "GET",
                        params: {
                            id: "@id",
                        },
                        isArray: false,
                    },
                    GetTabulacaoPorRamal: {
                        url: "Atendimento/TabulacaoPorRamal",
                        method: "GET",
                        isArray: true,
                    },
                    GerarProtocolo: {
                        url: "Atendimento/GerarProtocolo",
                        method: "POST"
                    },
                    GetContatoMiner :{
                        url: "Atendimento/ContatoMiner",
                        method: "GET",
                        isArray: true,
                        params: {
                            campo: "@campo",
                            valor: "@valor"
                        }
                    },
                    getFiltroContatoMiner: {
                        url: "Atendimento/FiltroContatoMiner",
                        method: "GET",
                        isArray : true,
                        params: {
                            integracaoTemplateId: "@integracaoTemplateId"
                        }
                    },
                    GetAtendimentoIntegracaoTemplateByCarteira: {
                        url: "Atendimento/AtendimentoIntegracaoTemplateByCarteira",
                        method: "GET",
                        isArray : true
                    },
                    getTemplateMinerListas :{
                        url: "Atendimento/TemplateMinerListas",
                        method: "GET",
                        isArray: true,
                        params: {
                            templateMinerId: "@templateMinerId"
                        }
                    },
                    GetLigacaoTelefoneCodigoCliente: {
                        method: "GET",
                        url: "Atendimento/GetLigacaoTelefoneCodigoCliente",
                        isArray: true
                    },
                     GetTabulacaoTelefoneCodigoCliente: {
                        method: "GET",
                        url: "Atendimento/GetTabulacaoTelefoneCodigoCliente",
                        isArray: true
                    },
                    GetAgendaIntervaloPorRamal: {
                        method: "GET",
                        url: "Agenda/Intervalo",
                        isArray: true,
                        params: {
                            RamalId: "@RamalId"
                        }
                    }
                }
            );
        }])

        .factory("AtendimentoIntegracaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "AtendimentoIntegracao/:AtendimentoIntegracao",
                { Id: "@Id" },
                {
                    consultarByGlobalId: {
                        url: "AtendimentoIntegracao/Consultar",
                        method: "GET",
                        params: {
                            globalId: "@globalId",
                            teplateId: "@templateId",
                        },
                    },
                }
            );
        }])
        .factory("AtendimentoCategoriaStatusResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "AtendimentoCategoriaStatus/Get"
            );
        }])
        ;
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.tabulacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true
                })
                .state("main.tabulacao.view", StateResolverProvider.configState("/tabulacao", "Tabulacao", "View", {
                    pageTitle: 'pageTitle.atendimento',
                    pageName: 'campo.visualizacao',
                    permissions: {
                        Atendimento: "Visualizar"
                    },
                    css: true,
                    startPage: true
                }))
        }])

        .service("TabulacaoViewData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_clipboard'
                        ]);
                    }],
                    grupos: ["MonitorResource", function (MonitorResource) {
                        return MonitorResource.getGrupos().$promise;
                    }],
                    campanhas: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetCampanhas();
                    }],
                    perfil: ["AtendimentoConfiguracaoResource", "AuthService", function (AtendimentoConfiguracaoResource, AuthService) {
                        let usuario = AuthService.getUsuarioLogado();
                        return AtendimentoConfiguracaoResource.GetConfiguracaoAtendimento({
                            Id: usuario.AtendimentoConfiguracaoId
                        }).$promise;
                    }],
                    atendimentoConfiguracao: ["AtendimentoConfiguracaoResource", "AuthService", function (AtendimentoConfiguracaoResource, AuthService) {
                        let usuario = AuthService.getUsuarioLogado();
                        return AtendimentoConfiguracaoResource.GetConfiguracaoAtendimentoSimples({
                            Id: usuario.AtendimentoConfiguracaoId
                        }).$promise;
                    }],
                    configuracao: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetConfiguracao().$promise;
                    }],
                    rotasDiscadorList: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetRotasDiscador().$promise;
                    }],
                    sessao: ["SessaoUsuarioResource", function (SessaoUsuarioResource) {
                        return SessaoUsuarioResource.getIp().$promise;
                    }],
                    permissoesLayout: ["AtendimentoLayoutsResource", function (AtendimentoLayoutsResource) {
                        return AtendimentoLayoutsResource.permissoes().$promise;
                    }],
                    maquina: ["MaquinaResource", function (MaquinaResource) {
                        return MaquinaResource.query().$promise;
                    }],
                    smsTemplate: ["SmsTemplateResource", function (SmsTemplateResource) {
                        return SmsTemplateResource.getTemplateSmsByGrupoPermissao().$promise;
                    }],
                    tabulacoesIncompletas: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetTabulacoesIncompletasPorUsuario().$promise;
                    }],
                    servicos: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetServicosTransferencia({ servicoNumero: 0 }).$promise;
                    }],
                    carteiras: ["TabulacaoResource", "AuthService", function (TabulacaoResource, AuthService) {
                        let usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;
                        return TabulacaoResource.GetCarteira({
                            usuarioId: usuarioLogado
                        }).$promise;
                    }],
                    intervalosList: ["RamalStatusResourceDetalhe", function (RamalStatusResourceDetalhe) {
                        return RamalStatusResourceDetalhe.query().$promise;
                    }],
                    softphone: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getSoftphone().$promise;
                    }],
                    infoRamal: ["RamalResource", "AuthService", function (RamalResource, AuthService) {
                        let ramalId = AuthService.getUsuarioLogado().RamalId;
                        return RamalResource.getInfo(ramalId).$promise;
                    }],
                    atendimentoIntegracaoTemplate: ["TabulacaoResource", function (TabulacaoResource) {
                        return TabulacaoResource.GetAtendimentoIntegracaoTemplateByCarteira().$promise;
                    }]
                };
            };
        })

        .filter('filtroRamalTabulacao', function () {
            return function (items, search, carteiraId) {
                let ramais = items;
                if (carteiraId && carteiraId > 0) {
                    let ramaisFiltrados = _.filter(ramais, function (item) {
                        if (item.Carteiras) {
                            return item.Carteiras.indexOf(parseInt(carteiraId)) > -1;
                        }
                    });

                    ramais = ramaisFiltrados;
                }

                if (search) {
                    ramais = _.filter(ramais, item => {
                        return item.UsuarioNome.toLowerCase().indexOf(search.toLowerCase()) >= 0 || item.Numero.toString().indexOf(search) >= 0;
                    });
                }

                return ramais;
            }
        })
        .filter('orderObjectBy', function () {
            return function (items, field, reverse) {
                let filtered = [];
                angular.forEach(items, function (item) {
                    filtered.push(item);
                });
                filtered.sort(function (a, b) {
                    return (a[field] > b[field] ? 1 : -1);
                });
                if (reverse) filtered.reverse();
                return filtered;
            };
        })
        .filter('filtroGrupos', function () {
            return function (items, carteiraId) {
                let filtered = [];
                if (carteiraId > 0) {
                    filtered = items.filter(x => x.CarteiraId == carteiraId || x.GrupoId == 0);
                } else {
                    filtered = items;
                }
                return filtered;
            };
        })
        .filter('filtroServicos', function () {
            return function (items, carteiraId, tipoTrasferenciaId) {
                let filtered = [];
                if (carteiraId > 0) {
                    filtered = items.filter(x => x.CarteiraId == carteiraId);
                } else {
                    filtered = items;
                }

                filtered = filtered.filter(x => x.TipoTransferencia == tipoTrasferenciaId);
                return filtered;
            };
        })

        //Não remover dependencia "preloaders" e "$rootScope"
        .controller("TabulacaoViewController",
            ["BlacklistItemResource", "$state", "$sce", "campanhas", "grupos", "configuracao", "rotasDiscadorList", "perfil", "EventoAcaoService", "AtendimentoService", "ModalService", "ATENDIMENTO_EVENTS", "SIGNALR_EVENTS", "FileDownloadService", "maquina", "TabulacaoResource", "AuthService", "RamalSupervisaoResource", "$scope", "$rootScope", "$window", "$interval", "sessao", "NotifyService", "$translate", "TranslateService", "permissoesLayout", "AtendimentoLayoutsResource", "smsTemplate", "AUTH_EVENTS", "Config", "$http", "atendimentoConfiguracao", "tabulacoesIncompletas", "carteiras", "AtendimentoIntegracaoResource", "servicos", "PesquisaAvaliacaoResource", "intervalosList", "PesquisaCategoriaResource", "softphone", "SoftphoneService", "CampanhaDiscagemResource", "infoRamal", "CampanhaArquivoResource", "atendimentoIntegracaoTemplate", "IntegracaoResource", "GrupoRamalStatusDetalheResource", "UsuarioChatResource", "$timeout", function (
                BlacklistItemResource,
                $state,
                $sce,
                campanhas,
                grupos,
                configuracao,
                rotasDiscadorList,
                perfil,
                EventoAcaoService,
                AtendimentoService,
                ModalService,
                ATENDIMENTO_EVENTS,
                SIGNALR_EVENTS,
                FileDownloadService,
                maquina,
                TabulacaoResource,
                AuthService,
                RamalSupervisaoResource,
                $scope,
                $rootScope,
                $window,
                $interval,
                sessao,
                NotifyService,
                $translate,
                TranslateService,
                permissoesLayout,
                AtendimentoLayoutsResource,
                smsTemplate,
                AUTH_EVENTS,
                Config,
                $http,
                atendimentoConfiguracao,
                tabulacoesIncompletas,
                carteiras,
                AtendimentoIntegracaoResource,
                servicos,
                PesquisaAvaliacaoResource,
                intervalosList,
                PesquisaCategoriaResource,
                softphone,
                SoftphoneService,
                CampanhaDiscagemResource,
                infoRamal,
                CampanhaArquivoResource,
                atendimentoIntegracaoTemplate,
                IntegracaoResource,
                GrupoRamalStatusDetalheResource,
                UsuarioChatResource,
                $timeout) {

                let ramalDesconectado = false;
                let iniciouConexao = false;
                let dateFormat = TranslateService.getMomentDateFormat();
                let intervaloListDic = {};
                intervalosList.forEach(item => {
                    intervaloListDic[item.RamalStatusDetalheId] = item;
                });

                let permissoesDefault = {
                    AbaHistorico: true,
                    AbaInfoUra: true,
                    AbaLigacoes: true,
                    CodigoCampanha: true,
                    CodigoChamada: true,
                    CodigoCliente: true,
                    AbaInfoAdicional: true,
                    NomeCampanha: true,
                    NomeCliente: true,
                    Telefone: true,
                    FiltroTelefone: true,
                    FiltroCodigoCliente: true
                };
                $scope.today = new Date();
                $scope.campoConsultaApi = '';
                $scope.informacoesUraHabilitado = false;
                $scope.softphone = softphone;
                $scope.servicosList = servicos;
                $scope.servicos = servicos;
                $scope.servicoSelecionado = '';
                $scope.discagemCodigoCliente = {};
                $scope.consultarHistoricoLigacaoRecebida = false;
                $scope.qtdLigacoesEntrantesANotificar = 1;
                $scope.exibirNotificacaoLigacaoRecebida = false;
                $scope.exibirEnvioSMS = true;
                $scope.atendimentoLayoutId = 0;
                $scope.disableTimerSms = false;
                $scope.timerSMS = 30;
                $scope.atendimentoLayout = {};
                $scope.numberOfCharacters = 0;
                $scope.excedeuMaxCaracteres = false;
                $scope.smsTemplateSelecionado = 0;
                $scope.smsTemplate = smsTemplate;
                $scope.atendimentoConfiguracao = atendimentoConfiguracao;
                $scope.tabulacoesIncompletasBase = $scope.tabulacoesIncompletas = tabulacoesIncompletas;
                $scope.Tabular = false;
                $scope.carteiras = carteiras;
                $scope.ischamadaInterna = false;
                $scope.isCategoria = false;
                $scope.isRamal = false;
                $scope.orderBy = {
                    column: "Data",
                    order: "desc"
                };
                $scope.paginationCongif = {
                    pages: [],
                    paginaAtual: 1
                }
                $scope.editTabulacao = {};
                $scope.carteiraSelecionada = 0;
                $scope.ligacaoManual = false;
                $scope.urlChat = '';
                $scope.PermissaoChat = false;
                $scope.chatMinimized = false;
                $scope.chatMaximized = false;

                //Agenda Intervalo
                $scope.agendaIntervalosProximos = [];
                $scope.exibirAgendaIntervalos = false;

                //Conferencia
                $scope.participantes = [];
                $scope.isConferenciaEmAndamento = false;

                //Consulta Contato Miner

                $scope.modalConsultaContaoMiner = false;
                $scope.HabilitarconsultaContato = false;
                $scope.consultaContatoMinerList = [];
                $scope.isDiscagemContatoMiner = false;
                $scope.chamadaContatoMiner = {};
                $scope.discagemContatoMiner = [];
                $scope.chamadaContatoMinerAtiva = false;
                $scope.chamadaContatoMinerTabulacaoAtiva = false;
                $scope.filtroContatoMiner = [];
                $scope.atendimentoIntegracaoTemplate = atendimentoIntegracaoTemplate;
                $scope.templateMinerListas = [];
                $scope.templateMiner = { AtendimentoIntegracaoTemplateId: 0, ListaMinerId: 0 };

                //$scope.templateMinerId = 0;
                //$scope.listaMinerId = 0;

                //REDISCAGEM

                $scope.rediscagemCliente = false;

                //DISCAGEM PREVIEW

                $scope.isDiscagemPreview = false;
                $scope.isCarregarDiscagemPreview = false;
                $scope.discagemPreviewSemDados = false;
                $scope.chamadaPreviewAtiva = false;
                $scope.modalConsultaContaoPreview = false;
                $scope.chamadaPreviewTabulacaoAtiva = false;

                $scope.chamadaPreview = {};
                $scope.contatosDiscagemPreview = [];
                $scope.consultaContatosPreviewList = [];
                $scope.discagemPreview = [];
                $scope.discagemPreviewList = [];

                if (localStorage.getItem('discagem_Preview')) {
                    $scope.isDiscagemPreview = localStorage.getItem('discagem_Preview');
                }

                if (perfil.Properties.ConsultarHistoricoLigacaoRecebida) {
                    $scope.consultarHistoricoLigacaoRecebida = true;

                    if (perfil.Properties.QtdLigacaoRecebidaANotificar) {
                        $scope.qtdLigacoesEntrantesANotificar = perfil.Properties.QtdLigacaoRecebidaANotificar;
                    }
                }

                $scope.usuario = AuthService.getUsuarioLogado();
                $scope.infoRamal = infoRamal;

                if (perfil.Properties.System == 1) {
                    $state.go("main.atendimento.view");
                }

                if (configuracao.IntervaloLivre == null) {
                    return ModalService.alert('telaTabulador.esteUsuarioNaoPossuiRamalAssociado');
                }

                const INTERVALO_DISCAGEMPREVIEW = 6;

                const INTERVALO_EMLIGACAO = 5;
                const DIRECAO_TABULACAO_RECEBIDA = 1;
                const DIRECAO_TABULACAO_EFETUADA = 2;
                const DIRECAO_ATENDIMENTO_RECEBIDA = 2;

                // Ordena os Grupos pela Descrição
                grupos = _.sortBy(grupos, function (grupo) { return grupo.Descricao });

                // Adiciona o Item "TODOS"
                grupos.splice(0, 0, { GrupoId: 0, Descricao: $translate.instant('campo.todos') });

                EventoAcaoService.init($scope);
                $scope.bloquearBotaoAgendamento = false;
                $scope.configuracao = configuracao;
                $scope.campanhas = campanhas;
                $scope.ligacoes = [];
                $scope.aguardandoProcessamento = true;
                $scope.exibindoMensagem = false;
                $scope.exibindoDadosChamada = false;
                $scope.exibindoTabulacao = false;
                $scope.exibirBotoesTabulacao = false;
                $scope.emTabulacao = false;
                $scope.tabulacao = {};
                $scope.dadosRamal = {};
                $scope.AtendimentoInicio = 0;
                $scope.AtendimentoFim = 0;
                $scope.IntervaloAtual = undefined;
                $scope.transferenciaExterna = false;
                $scope.tipoTransferencia = 2;
                $scope.grupoSelecionado = 0;
                $scope.grupos = grupos;
                $scope.filtroTransferencia = '';
                $scope.isRamalLoading = false;
                $scope.ramais = [];
                $scope.ramalByGrupo = [];
                $scope.conexao = {
                    ValorTelefonia: ' '
                };
                $scope.conexaoEmAndamento = false;
                $scope.conexaoIniciada = false;
                $scope.tempoStatus = 0;
                $scope.intervaloOptions = {};
                $scope.transferencia = {
                    Telefone: '',
                    Ramal: ''
                };
                $scope.emEspera = false;
                $scope.foraEspera = true;
                $scope.emConsulta = false;
                $scope.agendamento = {
                    Telefone: ' ',
                    DDD: ''
                };
                $scope.forms = {};
                $scope.horaParcial = true;
                $scope.horaCompleta = false;
                $scope.intervaloSelecionado = 0
                $scope.GlobalId = '';
                $scope.Protocolo = '';
                $scope.CodigoCliente = '';
                $scope.Direcao = 0;
                $scope.chamadaAtiva = false;
                $scope.numeroDiscador = '';
                $scope.rotaDiscador = null;
                $scope.discadorInterno = false;
                $scope.mostrarDiscador = false;
                $scope.rotasDiscadorList = rotasDiscadorList;
                $scope.statusDiscagem = 0;
                $scope.statusDiscagemErro = '';
                $scope.msgBlacklist = false;
                $scope.permissoes = permissoesDefault;
                $scope.contatoReceptivo = {
                    Id: 0,
                    Email: ' ',
                    Endereco: ' ',
                    Codigo: ' ',
                };
                $scope.contatoReceptivoEditDisabled = false;
                $scope.salvandoContato = false;
                $scope.atendimentoLayout = {
                    Id: 0,
                    ConsultaAtendimentoContato: false
                };
                $scope.infoRing = {
                    ativo: false,
                    servico: null,
                    telefone: null,
                    atendido: false
                };
                $scope.selecaoTabReceptiva = 1;
                $scope.selecaoTabulacao = 1;
                $scope.selecaoTabulacaoContato = 2;

                $scope.pesquisaCategoriaItens = [];
                $scope.pesquisaCategoriaItem = {};

                $scope.RAMAIS_PA = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "ListarRamais") ? 0 : 1;
                $scope.permissaoTransferencia = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "Transferência") ? false : true;
                $scope.permissaoTransferenciaRamal = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "ListarRamaisTransferencia") ? true : false;
                $scope.permissaoEspera = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "Espera") ? false : true;
                $scope.permissaoTeclado = $scope.usuario.Permissoes.find(f => f.Recurso == "Atendimento" && f.Acao == "Teclado") ? false : true;
                $scope.habilitarConferenciaInicio = true;

                $scope.ListCamposIntegracao = [];

                /// Variáveis globais para 
                /// controle da reconexão TalkFone
                $scope.retryCount = 0;
                $scope.maxRetries = 1;
                $scope.currentDelay = 3000;
                $scope.registerTimeout = null;
                $scope.EnderecoSipWebRTC = null;
                $scope.conectandoSoftphone = false;
                // True: Primeira conexão ao carregar a página.
                // False: Tentativa de reconexão por falha durante o uso.
                // Utilizada filtrar as  mensagens de durante o processo de conexão
                $scope.isConexaoInicialSoftphone = true;

                let $dp_start = $('#date_agendamento'),
                    $time_1 = $('#time_agendamento1'),
                    $time_2 = $('#time_agendamento2');

                UIkit.datepicker($dp_start, {
                    format: dateFormat,
                    minDate: moment(new Date()).format(dateFormat),
                    maxDate: moment(new Date(2099, 11, 31)).format(dateFormat)
                });

                UIkit.timepicker($time_1, {
                    format: '24h',
                    start: 0,
                    end: 24
                });

                UIkit.timepicker($time_2, {
                    format: '24h',
                    start: new Date().getHours(),
                    end: 24
                });

                $dp_start.on('change', function () {
                    let dataEscolhida = $dp_start.val();
                    if (!dataEscolhida || dataEscolhida == moment(new Date()).format("DD/MM/YYYY")) {
                        $scope.horaParcial = true;
                        $scope.horaCompleta = false;
                    } else {
                        $scope.horaParcial = false;
                        $scope.horaCompleta = true;
                    }
                });

                $scope.mudarIntervaloMenu = function (intervalo) {
                    if ($scope.emTabulacao && intervalo.RamalStatusDetalheId == $scope.configuracao.IntervaloLivre) {
                        return $scope.exibirMensagem('telaTabulador.naoEPossivelMudarDeIntervalo', 'info');
                    }

                    if ($scope.intervaloSelecionado != intervalo.RamalStatusDetalheId) {
                        $scope.alterarIntervaloHub(intervalo.RamalStatusDetalheId);
                    }
                };

                $scope.alterarIntervaloHub = function (intervaloId) {
                    AtendimentoService.alterarIntervaloTipo(intervaloId).catch(() => {
                        $scope.exibirMensagem('telaTabulador.erroAoAlterarIntervalo', 'danger');
                    });
                };

                var verificarIntervalo = function (intervalo) {
                    if (intervalo != undefined) {
                        let intervaloAtual = _.find(intervalosList, function (inter) {
                            return inter.RamalStatusDetalheId == intervalo;
                        });

                        if (intervaloAtual.DiscaExterno == true && intervaloAtual.RecebeExterno == false && intervaloAtual.RecebeDiscador == false && intervaloAtual.RecebeInterno == false && intervaloAtual.RamalStatusDetalheId != 6)
                            $scope.HabilitarconsultaContato = true;
                        else
                            $scope.HabilitarconsultaContato = false;
                    }
                }


                $scope.onChangeFiltroServico = function () {
                    $scope.servicoTransferenciaTipoChange(null);
                    $scope.servicos = $scope.servicos.filter(x => x.Descricao.includes($scope.filtroTransferencia));
                }

                $scope.onCarteiraChange = function () {
                    $scope.transferencia.Telefone = '';

                }

                /*-----------------------------------------------------
                        Feedback de tela
                -------------------------------------------------------*/

                $scope.getIp = function () {
                    let isIp = $scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3 ? $scope.conexao.isRamal == 'true' ? false : true : false;
                    let isRamal = $scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3 ? $scope.conexao.isRamal == 'true' ? true : false : false;
                    if (isIp) {
                        $scope.conexao.ValorTelefonia = sessao.Ip;
                    } else if (isRamal) {
                        let user = AuthService.getUsuarioLogado();
                        $scope.conexao.ValorTelefonia = user.RamalNumero;
                    } else {
                        $scope.conexao.ValorTelefonia = '';
                    }
                };

                $scope.exibirContato = function () {
                    $scope.exibindoDadosChamada = true;
                };

                $scope.esconderContato = function () {
                    $scope.exibindoDadosChamada = false;
                    $scope.chamadaAtiva = false;
                };

                $scope.exibirTabulacao = function () {
                    $scope.exibindoTabulacao = true;
                };

                $scope.esconderTabulacao = function () {
                    $scope.exibindoTabulacao = false;
                };

                $scope.ativarBotoesTabulacao = function () {
                    $scope.exibirBotoesTabulacao = true;
                };

                $scope.desativarBotoesTabulacao = function () {
                    $scope.exibirBotoesTabulacao = false;
                };

                $scope.ativarDiscagemManual = function () {
                    $scope.emDiscagemManual = true;
                    $scope.desligarLigacao();
                };

                $scope.desativarDiscagemManual = function () {
                    $scope.emDiscagemManual = false;
                };

                $scope.podeRealizarTimeout = false;
                $scope.tempoStatusOrigem;

                $scope.iniciarTimerStatus = function () {
                    if ($scope.podeRealizarTimeout) {
                        $scope.tempoStatusOrigem = moment();
                        $scope.timer = $interval(function () {
                            $scope.tempoStatus += 1;
                        }, 1000);
                    }
                };

                $scope.pararTimerStatus = function () {
                    $interval.cancel($scope.timer);
                    $scope.podeRealizarTimeout = false;
                };

                $scope.setTimerStatus = function (dataDiffIntervalo) {
                    $scope.tempoStatusOrigem = moment();
                    if (dataDiffIntervalo == null || Number.isNaN(dataDiffIntervalo)) {
                        $scope.tempoStatus = 0;
                    } else {
                        $scope.tempoStatus = parseInt(dataDiffIntervalo);
                    }
                };

                $scope.reiniciarTimerStatus = function (dataDiffIntervalo) {
                    $scope.podeRealizarTimeout = false;
                    $interval.cancel($scope.timer);
                    $scope.setTimerStatus(dataDiffIntervalo);
                    $scope.podeRealizarTimeout = true;
                    $scope.iniciarTimerStatus();
                };

                // --- Agenda Intervalo ---
                var diasSemana = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];

                function carregarAgendaIntervalos() {
                    var ramalId = $scope.usuario.RamalId;
                    if (!ramalId) return;

                    TabulacaoResource.GetAgendaIntervaloPorRamal({ RamalId: ramalId })
                        .$promise
                        .then(function (agendamentos) {
                            if (!agendamentos || !agendamentos.length) {
                                $scope.exibirAgendaIntervalos = false;
                                return;
                            }
                            processarAgendaIntervalos(agendamentos);
                        })
                        .catch(function () {
                            $scope.exibirAgendaIntervalos = false;
                        });
                }

                function formatarDuracao(segundos) {
                    if (!segundos) return '--:--:--';
                    return moment().startOf('day').seconds(segundos).format('HH:mm:ss');
                }

                function processarAgendaIntervalos(agendamentos) {
                    var agora = moment();
                    var diaAtual = diasSemana[agora.day()];
                    var intervalos = [];

                    agendamentos.forEach(function (agenda) {
                        if (!agenda.AgendaIntervaloHorario || !agenda.AgendaIntervaloHorario.length) return;

                        var descricaoIntervalo = agenda.RamalStatusDetalhe
                            ? agenda.RamalStatusDetalhe.Descricao
                            : agenda.Descricao;

                        var duracao = agenda.RamalStatusDetalhe
                            ? formatarDuracao(agenda.RamalStatusDetalhe.TempoLimiteIntervalo)
                            : '--:--:--';

                        agenda.AgendaIntervaloHorario.forEach(function (horario) {
                            if (agenda.Recorrente) {
                                if (!horario[diaAtual]) return;
                                if (!horario.Horario) return;

                                var partes = horario.Horario.split(':');
                                var horas = partes[0].length < 2 ? '0' + partes[0] : partes[0];
                                var minutos = partes[1].length < 2 ? '0' + partes[1] : partes[1];
                                var horarioFormatado = horas + ':' + minutos;

                                if (horarioFormatado <= agora.format('HH:mm')) return;

                                intervalos.push({
                                    descricao: descricaoIntervalo,
                                    horario: horarioFormatado,
                                    duracao: duracao
                                });
                            } else {
                                if (!horario.Data) return;
                                var dataMoment = moment(horario.Data);
                                if (dataMoment.isBefore(agora)) return;

                                intervalos.push({
                                    descricao: descricaoIntervalo,
                                    horario: dataMoment.format('HH:mm'),
                                    duracao: duracao
                                });
                            }
                        });
                    });

                    intervalos.sort(function (a, b) { return a.horario.localeCompare(b.horario); });

                    agendaIntervalosCompleta = intervalos;
                    atualizarListaVisivelAgendaIntervalos();
                }

                var agendaIntervalosCompleta = [];

                function atualizarListaVisivelAgendaIntervalos() {
                    $scope.agendaIntervalosProximos = agendaIntervalosCompleta.slice(0, 2);
                    $scope.exibirAgendaIntervalos = agendaIntervalosCompleta.length > 0;
                }

                function limparIntervalosExpirados() {
                    if (!agendaIntervalosCompleta.length) return;

                    var horaAtual = moment().format('HH:mm');
                    agendaIntervalosCompleta = agendaIntervalosCompleta.filter(function (item) {
                        return item.horario > horaAtual;
                    });
                    atualizarListaVisivelAgendaIntervalos();
                }
                // --- Fim Agenda Intervalo ---

                $scope.aguardarProcessamento = function () {
                    $scope.aguardandoProcessamento = true;
                    // $rootScope.content_preloader_show();
                };

                $scope.finalizarProcessamento = function () {
                    $scope.aguardandoProcessamento = false;
                    //$rootScope.content_preloader_hide();
                };

                $scope.iniciarTabulacao = function () {
                    // eslint-disable-next-line no-console
                    $scope.consoleInfo('[TABULACAO] Iniciando tabulação...');
                    $scope.emTabulacao = true;
                };

                $scope.finalizarTabulacao = function () {
                    // eslint-disable-next-line no-console
                    $scope.consoleInfo('[TABULACAO] Finalizando tabulação...');
                    $scope.emTabulacao = false;
                };

                $scope.tentarConexao = function () {
                    $scope.conexaoEmAndamento = true;
                    $scope.conexaoIniciada = false;
                };

                $scope.iniciarConexaoComSucesso = function () {
                    $scope.conexaoEmAndamento = false;
                    $scope.conexaoIniciada = true;
                };

                $scope.iniciarConexaoComErro = function () {
                    $scope.conexaoEmAndamento = false;
                    $scope.conexaoIniciada = false;
                };

                $scope.exibirIntervaloMensagem = function () {
                    if ($scope.rediscagemCliente == false) {
                        if ($scope.emTabulacao == false) {
                            if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloLivre) {
                                $scope.exibirMensagem('telaTabulador.aguardandoLigacao', 'success');
                            } else if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloNaoDisponivel) {
                                $scope.exibirMensagem('telaTabulador.naoDisponivelParaLigacao', 'warning');
                            } else {
                                $scope.esconderMensagem();
                            }
                        } else {
                            $scope.esconderMensagem();
                        }
                    }
                };

                $scope.desligarLigacao = function () {
                    if ($scope.emConsulta) {
                        $scope.sairConsulta();
                    }
                    if ($scope.isConferenciaEmAndamento) {
                        $scope.participantes = [];
                        $scope.isConferenciaEmAndamento = false;
                        $scope.pararTimerStatusConferencia();
                        AtendimentoService.conferenciaTerminar();
                        ModalService.closeModal('modal_conferencia');
                        ModalService.closeModal('modal_conferencia_inicio');
                    }
                    if ($scope.chamadaAtiva) {
                        $scope.chamadaAtiva = false;
                        AtendimentoService.desligar();
                    }
                };

                $scope.copiarSelecao = function (selecao) {
                    new Clipboard(selecao);
                };

                $scope.exibirMensagem = function (mensagem, tipo, params) {
                    mensagem = $translate.instant(mensagem, params);
                    $scope.mensagemOperacao = mensagem;
                    $scope.mensagemTipo = tipo;
                    $scope.exibindoMensagem = true;

                    // Força atualização da UI
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                };

                $scope.esconderMensagem = function () {
                    $scope.exibindoMensagem = false;

                    // Força atualização da UI
                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }
                };

                $scope.enviarEmail = function () {
                    UIkit.modal.prompt($translate.instant('telaTabulador.digiteOEmailDoDestinatario'), '', val => {
                        if (val && val != '') {
                            let user = AuthService.getUsuarioLogado();
                            let emailObj = {
                                Email: val,
                                ClienteCodigo: "123",
                                CampanhaCodigo: 1,
                                Nome: $translate.instant('telaTabulador.discagemManual'),
                                Descricao: $translate.instant('telaTabulador.discagemManual'),
                                DataChamada: new Date(),
                                UsuarioCadastro: (user.RamalNumero ? user.RamalNumero + ' - ' : '') + user.Nome,
                                Processado: false,
                                TipoId: 0,
                                CanalId: 1,
                                Telefone: user.Telefone
                            };
                            // 666
                            TabulacaoResource.EnviarEmail(emailObj).$promise.then(() => {
                                NotifyService.showSuccess('telaTabulador.emailEnviadoComSucesso');
                            }).catch(() => {
                                NotifyService.showError(null, 'telaTabulador.erroAoEnviarEmail');
                            });
                        }
                    });
                };

                $scope.salvarContatoReceptivo = function (valid) {
                    if (!valid) {
                        NotifyService.showError(null, 'telaTabulador.erroAoEnviarEmail');
                        return;
                    }

                    $scope.salvandoContato = true;
                    $scope.contatoReceptivo.Telefone = $scope.chamada.Telefone;

                    if ($scope.contatoReceptivo.Id > 0) {
                        TabulacaoResource
                            .UpdateAtendimentoContato($scope.contatoReceptivo)
                            .$promise
                            .then(() => {
                                $scope.salvandoContato = false;
                                NotifyService.showSuccess('telaTabulador.sucessoAoSalvarContatoReceptivo');
                                $scope.contatoReceptivoEditDisabled = true;
                            }).catch(() => {
                                NotifyService.showError('telaTabulador.erroAoSalvarContatoReceptivo');
                                $scope.salvandoContato = false;
                            });
                    } else {
                        TabulacaoResource
                            .SetAtendimentoContato($scope.contatoReceptivo)
                            .$promise
                            .then((contato) => {
                                $scope.contatoReceptivo = contato;
                                $scope.salvandoContato = false;
                                $scope.contatoReceptivoEditDisabled = true;
                                NotifyService.showSuccess('telaTabulador.sucessoAoSalvarContatoReceptivo');
                            }).catch(() => {
                                NotifyService.showError('telaTabulador.erroAoSalvarContatoReceptivo');
                                $scope.salvandoContato = false;
                            });
                    }
                };

                $scope.editarContatoReceptivo = function () {
                    $scope.contatoReceptivoEditDisabled = false;
                }

                $scope.onChangeAbaReceptiva = function (abaId) {
                    $scope.selecaoTabReceptiva = abaId;
                }

                var ordenarTabulacoesIncompletas = function () {
                    let ultimoItem = $scope.paginationCongif.paginaAtual * 10;
                    let primeiroItem = ultimoItem - 10;
                    let listaOrdenada = $scope.tabulacoesIncompletasBase.sort((a, b) => {
                        var key1 = a[$scope.orderBy.column];
                        var key2 = b[$scope.orderBy.column];

                        if (key1 > key2) {
                            return $scope.orderBy.order == 'asc' ? 1 : -1;
                        } else if (key1 == key2) {
                            return 0;
                        } else {
                            return $scope.orderBy.order == 'asc' ? -1 : 1;
                        }
                    });
                    let listaSliced = listaOrdenada.slice(primeiroItem, ultimoItem);
                    $scope.tabulacoesIncompletas = listaSliced;
                }

                $scope.executeSearch = function () {
                    TabulacaoResource.GetTabulacoesIncompletasPorUsuario().$promise.then((result) => {
                        $scope.tabulacoesIncompletasBase = result;
                        ordenarTabulacoesIncompletas();
                        if (result.length == 0)
                            ModalService.closeModal('modalTabulacoesIncompletas')
                    }).catch(() => {
                        NotifyService.showError(error, 'telaTabulador.erroAoRecuperarTabulacoesIncompletas')
                    })
                };


                var calcularPaginasTabulacoesIncompletas = function () {
                    var qtdPages = Math.ceil($scope.tabulacoesIncompletasBase.length / 10)
                    for (let index = 1; index <= qtdPages; index++) {
                        $scope.paginationCongif.pages.push({ id: index })
                    }
                }
                calcularPaginasTabulacoesIncompletas();


                $scope.pageChanged = function (newPage) {
                    if (newPage < 1 || newPage > $scope.paginationCongif.pages.length)
                        return;
                    $scope.paginationCongif.paginaAtual = newPage;
                    ordenarTabulacoesIncompletas();
                };
                $scope.pageChanged(1);

                /*-----------------------------------------------------
                    Getters API
                -------------------------------------------------------*/

                $scope.historicoUra = {};
                $scope.detalhamentoUra = [];

                $scope.carregarDadosUraTalkBot = function () {
                    if ($scope.atendimentoLayout) {
                        if ($scope.chamada) {
                            if ($scope.atendimentoLayout.HabilitarInformacoesUraTalkBot) {

                                if ($scope.informacoesUraHabilitado == true)
                                    $scope.chamada.CodigoCliente = $scope.campoConsultaApi;


                                $scope.detalhamentoUra = [];

                                AtendimentoIntegracaoResource.consultarByGlobalId({
                                    globalId: $scope.chamada.GlobalId || '',
                                    Telefone: $scope.chamada.Telefone || '',
                                    Cliente: $scope.chamada.CodigoCliente || '',
                                    InfoAdicional1: $scope.chamada.InfoAdicional1 || '',
                                    InfoAdicional2: $scope.chamada.InfoAdicional2 || '',
                                    InfoAdicional3: $scope.chamada.InfoAdicional3 || '',
                                    InfoAdicional4: $scope.chamada.InfoAdicional4 || '',
                                    InfoAdicional5: $scope.chamada.InfoAdicional5 || '',
                                    templateId: $scope.atendimentoLayout.AtendimentoIntegracaoTemplateId
                                }).$promise.then(function (result) {
                                    if (result) {

                                        let seletor = $scope.ListCamposIntegracao[0].Seletor.split("[0].");

                                        if (seletor.length > 0)
                                            $scope.detalhamentoUra = result[seletor[0]]
                                        else
                                            $scope.detalhamentoUra = result

                                        let campoAgrupamento = '';
                                        let campo = $scope.ListCamposIntegracao.find(x => x.Identificador);

                                        if (campo) {
                                            campoAgrupamento = campo.Seletor.split("[0].")[1]
                                        } else {
                                            campoAgrupamento = seletor[1]
                                        }

                                        //Agrupamentos dos dados 
                                        var groupResult = _.groupBy($scope.detalhamentoUra, campoAgrupamento);
                                        $scope.detalhamentoUra = [];
                                        Object.entries(groupResult).forEach(x => { $scope.detalhamentoUra.push(x[1][0]); })

                                        $scope.detalhamentoUra.forEach(function (values) {
                                            if (values.hasOwnProperty(campoAgrupamento)) {
                                                var agrupamento = values[campoAgrupamento];

                                                if (agrupamento != undefined)
                                                    values.Agrupamento = agrupamento;
                                            }
                                        });

                                        if (!$scope.isDiscagemContatoMiner)
                                            $scope.selecaoTabReceptiva = 4;
                                    }
                                });
                            }
                        }
                    }
                };

                var carregarDadosUra = function () {
                    if ($scope.atendimentoLayout) {
                        if ($scope.chamada) {
                            if ($scope.atendimentoLayout.HabilitarConsultaNavegacaoUra && $scope.chamada.Direcao == DIRECAO_ATENDIMENTO_RECEBIDA) {
                                if ($scope.chamada.DDRLocal != null || $scope.chamada.DDRLocal != undefined) {
                                    TabulacaoResource.GetBilhetUraByGlobalId({ globalId: $scope.chamada.GlobalId, servico: $scope.chamada.DDRLocal }).$promise.then(function (result) {
                                        if (result) {
                                            $scope.historicoUra = result;
                                            $scope.selecaoTabReceptiva = 2;
                                        }
                                    });
                                }
                            }
                        }
                    }
                };

                $scope.getCampoNomes = function () {
                    let na = "";

                    if ($scope.chamada.Direcao == DIRECAO_ATENDIMENTO_RECEBIDA) {
                        na = $scope.chamada.DDRLocal;
                    }

                    return TabulacaoResource.GetCampos({
                        CampanhaId: $scope.chamada.CodigoCampanha || 0,
                        Direcao: $scope.chamada.Direcao,
                        NA: na
                    }).$promise;
                };

                $scope.GetAtendimentoContato = function (tel) {
                    return TabulacaoResource.GetAtendimentoContato({
                        telefone: tel
                    }).$promise;
                }

                $scope.GetServicosTransferencia = function (tipo) {
                    return TabulacaoResource.GetServicosTransferencia({
                        transferenciaTipo: tipo
                    }).$promise;
                }

                $scope.servicoTransferenciaTipos = [
                    { Id: 1, Descricao: 'Serviços Externos' },
                    { Id: 2, Descricao: 'Serviços de Ura Atendimento' },
                    { Id: 3, Descricao: 'Serviços de Ura Pesquisa' }
                ];
                $scope.servicoTransferenciaTipoId = 2;
                $scope.servicoTransferenciaTipoChange = function (tipo) {
                    $scope.servicoTransferenciaTipoId = tipo == null ? $scope.servicoTransferenciaTipoId : tipo;
                    $scope.transferencia.Telefone = '';
                }

                setTimeout(() => {
                    $scope.servicoTransferenciaTipoChange(2);
                }, 1000);



                $scope.countCharacters = function () {
                    if ($scope.smsMensagem.length == 0)
                        return

                    $scope.numberOfCharacters = $scope.smsMensagem.length;

                    $scope.excedeuMaxCaracteres = false;

                    if ($scope.numberOfCharacters > 147)
                        $scope.excedeuMaxCaracteres = true;

                }

                $scope.campanhaValores = {};

                $scope.filtrarCampoNomes = function (result) {
                    var camposContatoNaoOrdenado = result;
                    $scope.camposContato = [];
                    camposContatoNaoOrdenado.forEach(element => {
                        $scope.camposContato[element.Ordem - 1] = element;
                    });

                    $scope.camposContato.forEach(campo => {
                        campo.Categorias.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1);
                    });

                };

                // Busca campos do layout usando um contexto isolado (campanha/direcao da tabulacao incompleta),
                // sem ler nem mutar $scope.chamada — preserva a chamada ativa durante a edicao.
                var getCampoNomesPorContexto = function (contexto) {
                    let na = "";
                    if (contexto.Direcao == DIRECAO_ATENDIMENTO_RECEBIDA) {
                        na = contexto.DDRLocal || "";
                    }
                    return TabulacaoResource.GetCampos({
                        CampanhaId: contexto.CodigoCampanha || 0,
                        Direcao: contexto.Direcao,
                        NA: na
                    }).$promise;
                };

                // Ordena/normaliza o resultado retornando um array dedicado para a tabulacao incompleta,
                // sem tocar em $scope.camposContato (que pertence a chamada ativa).
                var filtrarCampoNomesIncompleta = function (result) {
                    var arr = [];
                    result.forEach(element => {
                        arr[element.Ordem - 1] = element;
                    });
                    arr.forEach(campo => {
                        campo.Categorias.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1);
                    });
                    return arr;
                };

                var getTabulacoes = function () {

                    if ($scope.camposContato && $scope.camposContato.length > 0) {
                        $scope.atendimentoLayoutId = $scope.camposContato[0].AtendimentoLayoutId;
                        $scope.permissoes = getPermissoesByLayouId($scope.camposContato[0].AtendimentoLayoutId);
                    }
                    let permissaoTelefone = $scope.permissoes.FiltroTelefone;
                    let permissaoCodigoCliente = $scope.permissoes.FiltroCodigoCliente;
                    if (permissaoTelefone && permissaoCodigoCliente) {
                        if ($scope.chamada.Telefone || $scope.chamada.CodigoCliente) {
                            //GetTabulacoesPorTelefoneCodigoCliente
                            TabulacaoResource.GetTabulacaoTelefoneCodigoCliente(
                                {
                                    telefone: $scope.chamada.Telefone || '',
                                    codigoCliente: $scope.chamada.CodigoCliente || ''
                                }).$promise.then(function (result) {
                                    $scope.atendimentoHistorico = result;
                                });
                        }
                    } else if (permissaoCodigoCliente) {
                        if ($scope.chamada.CodigoCliente) {
                            //GetTabulacoesPorTelefoneCodigoCliente
                            TabulacaoResource.GetTabulacaoTelefoneCodigoCliente(
                                {
                                    telefone: '',
                                    codigoCliente: $scope.chamada.CodigoCliente || ''
                                }).$promise.then(function (result) {
                                    $scope.atendimentoHistorico = result;
                                });
                        }
                    } else if ((permissaoTelefone)) {
                        if ($scope.chamada.Telefone) {
                            //GetTabulacoesPorTelefoneCodigoCliente
                            TabulacaoResource.GetTabulacaoTelefoneCodigoCliente(
                                {
                                    telefone: $scope.chamada.Telefone || '',
                                    codigoCliente: ''
                                }).$promise.then(function (result) {
                                    $scope.atendimentoHistorico = result;
                                });
                        }
                    }
                };

                var getLigacoes = function () {

                    if ($scope.camposContato && $scope.camposContato.length > 0) {
                        $scope.atendimentoLayoutId = $scope.camposContato[0].AtendimentoLayoutId;
                        $scope.permissoes = getPermissoesByLayouId($scope.camposContato[0].AtendimentoLayoutId);
                    }
                    let permissaoTelefone = $scope.permissoes.FiltroTelefone;
                    let permissaoCodigoCliente = $scope.permissoes.FiltroCodigoCliente;

                    if (permissaoTelefone && permissaoCodigoCliente) {
                        if ($scope.chamada.Telefone || $scope.chamada.CodigoCliente) {
                            //GetAtendimentosPorTelefoneCodigoCliente
                            TabulacaoResource.GetLigacaoTelefoneCodigoCliente(
                                {
                                    telefone: $scope.chamada.Telefone || '',
                                    codigoCliente: $scope.chamada.CodigoCliente || ''
                                }).$promise.then(updateList)
                                .catch((error) => NotifyService.showError(error, 'telaTabulador.erroAoRecuperarLigações'));
                        }
                    } else if (permissaoCodigoCliente) {
                        if ($scope.chamada.CodigoCliente) {
                            //GetAtendimentosPorTelefoneCodigoCliente
                            TabulacaoResource.GetLigacaoTelefoneCodigoCliente(
                                {
                                    telefone: '',
                                    codigoCliente: $scope.chamada.CodigoCliente || ''
                                }).$promise.then(updateList)
                                .catch((error) => NotifyService.showError(error, 'telaTabulador.erroAoRecuperarLigações'));
                        }
                    } else if (permissaoTelefone) {
                        if ($scope.chamada.Telefone) {
                            //GetAtendimentosPorTelefoneCodigoCliente
                            TabulacaoResource.GetLigacaoTelefoneCodigoCliente(
                                {
                                    telefone: $scope.chamada.Telefone || '',
                                    codigoCliente: ''
                                }).$promise.then(updateList)
                                .catch((error) => NotifyService.showError(error, 'telaTabulador.erroAoRecuperarLigações'));
                        }
                    }
                };

                var getCamposTabulacao = function (reenvio) {
                    $scope.getCampoNomes().then(result => {
                        $scope.filtrarCampoNomes(result);
                        if ($scope.camposContato && $scope.camposContato.length > 0) {
                            $scope.atendimentoLayoutId = $scope.camposContato[0].AtendimentoLayoutId;
                            $scope.permissoes = getPermissoesByLayouId($scope.camposContato[0].AtendimentoLayoutId);

                            getInfoLayoutById($scope.atendimentoLayoutId).then(atendimentoLayout => {
                                $scope.atendimentoLayout = atendimentoLayout;
                                $scope.habilitarConferenciaInicio = !!atendimentoLayout.HabilitarConferencia;
                                if ($scope.atendimentoLayout.ConsultaAtendimentoContato) {
                                    $scope.GetAtendimentoContato($scope.chamada.Telefone).then(contato => {
                                        if (contato.Id) {
                                            $scope.contatoReceptivo = contato;
                                            $scope.contatoReceptivoEditDisabled = true;
                                        }
                                    });
                                }
                                // if (!reenvio) {
                                //     VerificaTabulacaoIncompleta($scope.chamada);
                                // }
                                carregarDadosUra();
                                $scope.carregarDadosUraTalkBot();
                                getCamposIntegracao();
                            });
                        } else $scope.permissoes = permissoesDefault;

                        getTabulacoes();
                        getLigacoes();

                    });
                };

                function getCamposIntegracao() {
                    if ($scope.atendimentoLayout.AtendimentoIntegracaoTemplateId != null) {

                        IntegracaoResource.GetId({ Id: $scope.atendimentoLayout.AtendimentoIntegracaoTemplateId }).$promise.then(result => {
                            $scope.ListCamposIntegracao = result.AtendimentoIntegracaoTemplateCampo;
                        }).catch(error => {
                            NotifyService.showError(error);
                        });
                    }
                }

                $scope.editarTabulacaoIncompleta = function (tabulacao) {
                    var modal = UIkit.modal("#modal_edit");
                    modal.options.stack = true;

                    // Objeto isolado com o contexto da tabulacao incompleta sendo editada.
                    // Reinicializado a cada nova consulta para garantir os dados corretos
                    // quando o usuario edita tabulacoes diferentes em sequencia.
                    $scope.tabulacaoIncompletaChamada = {
                        CodigoCampanha: tabulacao.CampanhaId,
                        Direcao: tabulacao.DirecaoId == 1 ? 2 : 1
                    };
                    $scope.camposContatoIncompleta = [];

                    getCampoNomesPorContexto($scope.tabulacaoIncompletaChamada).then(result => {
                        $scope.camposContatoIncompleta = filtrarCampoNomesIncompleta(result);
                        if ($scope.camposContatoIncompleta.length > 0) {
                            $scope.Tabular = $scope.camposContatoIncompleta[0].Tabular;
                            $scope.ListaCategoria = $scope.camposContatoIncompleta[0].Categorias.filter(function (x) { return !x.ParentId });
                        }
                    });
                    ModalService.openModal('modal_edit');
                    $scope.editTabulacao = tabulacao;
                }

                $scope.salvarEditTabulacao = function (valid) {
                    if (!valid) return;

                    if (localStorage.getItem('tabulacao_categoriaId')) {
                        $scope.tabulacao.CategoriaId = localStorage.getItem('tabulacao_categoriaId');
                        localStorage.removeItem('tabulacao_categoriaId');
                    }

                    if (localStorage.getItem('tabulacao_subCategoriaId')) {
                        $scope.tabulacao.SubCategoriaId = localStorage.getItem('tabulacao_subCategoriaId');
                        localStorage.removeItem('tabulacao_subCategoriaId');
                    }

                    if (localStorage.getItem('tabulacao_categoriaFilhoId')) {
                        let categoriaFilhoId = localStorage.getItem('tabulacao_categoriaFilhoId');


                        if ($scope.atendimentoLayout.Tabular && categoriaFilhoId == '0') {
                            NotifyService.showMessage('telaTabulador.erroTabulacao', 'info')
                            return;
                        }

                        localStorage.removeItem('tabulacao_categoriaFilhoId');
                    }

                    if ($scope.atendimentoLayout.Tabular && $scope.tabulacao.CategoriaId == undefined) {
                        NotifyService.showMessage('telaTabulador.erroTabulacao', 'info')
                        return;
                    }

                    $scope.editTabulacao.CategoriaId = $scope.tabulacao.CategoriaId;
                    $scope.editTabulacao.SubCategoriaId = $scope.tabulacao.SubCategoriaId;
                    $scope.editTabulacao.Historico = $scope.tabulacao.Historico;
                    $scope.editTabulacao.CampoGenerico1 = $scope.tabulacao.CampoGenerico1;
                    $scope.editTabulacao.CampoGenerico2 = $scope.tabulacao.CampoGenerico2;
                    $scope.editTabulacao.AtendimentoId = $scope.editTabulacao.Id;
                    $scope.editTabulacao.AtendimentoStatusId = 1;

                    TabulacaoResource.save($scope.editTabulacao).$promise.then(() => {
                        $scope.tabulacao = {};
                        // Limpa apenas o contexto da tabulacao incompleta. NAO mexer em
                        // $scope.camposContato pois ele pertence a chamada ativa (se houver).
                        $scope.camposContatoIncompleta = [];
                        $scope.tabulacaoIncompletaChamada = null;
                        ModalService.closeModal('modal_edit');
                        NotifyService.showSuccess(null, $translate.instant('telaTabulacaoHistorico.sucessoEdit'));
                        $scope.executeSearch();
                    }).catch(() => {
                        NotifyService.showError(null, $translate.instant('telaTabulacaoHistorico.erroEdit'));
                    });

                };

                var getInfoLayoutById = function (id) {
                    return AtendimentoLayoutsResource.getLayoutById({ Id: id }).$promise;
                };


                function getProtocoloAtendimento(direcao, globalId) {
                    $scope.Protocolo = '';
                    if (direcao == 1) {
                        if ($scope.atendimentoConfiguracao.PermiteProtocolo == true) {
                            if ($scope.chamada != null) {
                                TabulacaoResource.GerarProtocolo({
                                    na: $scope.chamada.DDRLocal,
                                    nb: $scope.chamada.Telefone,
                                    globalId: globalId
                                }).$promise.then((data) => {
                                    $scope.Protocolo = data.Protocolo;
                                }).catch(() => {
                                    NotifyService.showError(null, $translate.instant('telaTabulador.erroProtocolo'));
                                });
                            }
                        }
                    }
                    else {
                        TabulacaoResource.GetProtocolo({ globalId: globalId }).$promise.then(response => {
                            $scope.Protocolo = response.NumeroProtocolo;
                            $scope.CodigoCliente = response.NumeroProtocolo;
                        });
                    }
                };


                /*-----------------------------------------------------
                        Eventos de Conexão
                -------------------------------------------------------*/
                $scope.TelefoniaTipos = [
                    { TelefoniaTipoId: 1, Descricao: $translate.instant('telaTabulador.analogico') },
                    { TelefoniaTipoId: 2, Descricao: $translate.instant('telaTabulador.telefoneIp') },
                    { TelefoniaTipoId: 3, Descricao: $translate.instant('telaTabulador.softphone') }
                ];

                $scope.conexao.TelefoniaTipoId = maquina[0].PlataformaId;

                if ($scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3) {
                    $scope.conexao.isRamal = 'false';
                    $scope.getIp();
                }

                $scope.showModalConexao = function () {
                    ModalService.openModal('modal_conectar', null, null, { center: true, bgclose: false, keyboard: false });
                };

                $scope.showModalRing = function () {
                    $scope.infoRing.ativo = true;
                    let modal = UIkit.modal("#modalLigacaoRing");
                    modal.options.bgclose = false;
                    modal.options.keyboard = false;
                    modal.show();
                    //ModalService.openModal('modalLigacaoRing');
                    let audioElem = $("#phoneRingAudio")[0];
                    audioElem.play();
                };

                $scope.hideModalRing = function () {
                    $scope.infoRing.ativo = false;
                    //ModalService.closeModal('modalLigacaoRing');
                    let modal = UIkit.modal("#modalLigacaoRing");
                    modal.hide()
                    let audioElem = $("#phoneRingAudio")[0];
                    audioElem.pause();
                };

                let tempoReconexao = 5000;
                let timerReconexao;
                let timerReconexaoSignalr;
                let conectadoSignalr = true;
                let valorTelefonia;

                function logarRamalReconexao() {

                    let tipoLogon = $scope.getTipoLogon();
                    $scope.consoleInfo("***** logarRamalReconexao *****");
                    $scope.consoleInfo("***** Parametro iniciouConexao: " + iniciouConexao);
                    $scope.consoleInfo("***** Parametro conectadoSignalr: " + conectadoSignalr);
                    $scope.consoleInfo('***** Parametro Logon - ValorTelefonia :' + valorTelefonia);
                    $scope.consoleInfo('***** Parametro Logon - TipoLogon :' + tipoLogon);

                    if (iniciouConexao && conectadoSignalr && tipoLogon && valorTelefonia) {

                        try {

                            timerReconexao = setTimeout(function () {
                                AtendimentoService.iniciar(valorTelefonia, tipoLogon, false).then(data => {
                                    ramalDesconectado = false;
                                }).catch(data => {
                                    conectadoSignalr = false;
                                    $scope.consoleInfo("***** erro ao tentar logar o ramal  ******")
                                });
                            }, tempoReconexao);


                        } catch (e) {
                            $scope.consoleInfo("***** Erro na execução da função logarRamalReconexao ******" + e.message)
                        }
                    }
                }

                function reconectarSignalr() {
                    if (iniciouConexao && !conectadoSignalr) {
                        $scope.consoleInfo("***** Iniciando processo de reconexão signalr ******");
                        try {

                            AtendimentoService.stop();

                            timerReconexaoSignalr = setTimeout(function () {
                                AtendimentoService.start().then(data => {
                                    $scope.consoleInfo("***** AtendimentoService.start().Then() ******")
                                    logarRamalReconexao();
                                });
                            }, tempoReconexao);

                        } catch (e) {
                            $scope.consoleInfo("***** Erro na execução da função reconectarSignalr ******" + e.message)
                        }
                    }
                }

                function abaNavegadorAlterada(e) {
                    if (!document.hidden) {
                        $scope.consoleInfo("***** aba do navegador alterada ******")
                        reconectarSignalr();

                        var diffTime = moment().diff(moment($scope.tempoStatusOrigem), "milliseconds");

                        var duration = moment.duration(moment({ hour: 0, minute: 0, seconds: 0, milliseconds: 0 }).add(diffTime, 'milliseconds'));
                        var s = duration.asSeconds();
                        $scope.tempoStatus = s;

                    }
                }

                document.addEventListener('visibilitychange', abaNavegadorAlterada);

                /* Reconexão signalr */
                $scope.$on(SIGNALR_EVENTS.connected, function () {
                    $scope.consoleInfo("SIGNALR_EVENTS.connected");
                    conectadoSignalr = true;

                    $scope.esconderMensagem();

                    // Precisa reconectar o ramal
                    $scope.showModalConexao();
                });

                $scope.$on(SIGNALR_EVENTS.reconnected, function () {
                    $scope.consoleInfo("SIGNALR_EVENTS.reconnected");
                });

                $scope.$on(SIGNALR_EVENTS.disconnected, function () {

                    $scope.consoleInfo("SIGNALR_EVENTS.disconnected")
                    $scope.iniciarConexaoComErro();
                    $scope.exibirMensagem('telaTabulador.erroAoLogarRamal', 'danger', { 'Detalhe': "Serviço de atendimento indisponível" });

                    conectadoSignalr = false;
                });


                $scope.$on(ATENDIMENTO_EVENTS.onLogadoErro, (event, data, erro) => {

                    ModalService.hideLoading();

                    $scope.iniciarConexaoComErro();
                    $scope.finalizarTabulacao();
                    $scope.aguardarProcessamento();
                    $scope.chamadaAtiva = false;

                    if (!erro) {

                        $scope.exibirMensagem('telaTabulador.statusLogonDesconhecido', 'danger');
                        return;
                    }

                    let mensagem = erro.Message;
                    let statusLogonRetorno = $scope.getStatusLogonRetornoObject(erro.StatusCode);
                    if (statusLogonRetorno) {
                        mensagem = statusLogonRetorno.Descricao;
                    }

                    $scope.exibirMensagem('telaTabulador.erroAoLogarRamal', 'danger', { 'Detalhe': mensagem });

                    setTimeout(function () {

                        if (typeof statusLogonRetorno.callback === 'function') {
                            statusLogonRetorno.callback();
                        }
                        else {
                            $scope.showModalConexao();
                        }
                    }, 3500);

                });

                $scope.$on(ATENDIMENTO_EVENTS.onConexaoErro, (event, data, error) => {
                    ramalDesconectado = true;

                    $scope.iniciarConexaoComErro();
                    $scope.finalizarTabulacao();
                    $scope.exibirMensagem('telaTabulador.erroDeConexao', 'danger', { 'Detalhe': error.Message });
                    $scope.aguardarProcessamento();
                    $scope.chamadaAtiva = false;

                    timerReconexao = setTimeout(logarRamalReconexao, tempoReconexao);
                });

                $scope.$on(ATENDIMENTO_EVENTS.onDiscaErro, (event, data, error) => {
                    $scope.exibirMensagem('telaTabulador.erroDeDiscagem', 'danger', { 'Detalhe': error.Message });
                    $scope.chamadaAtiva = false;
                });

                $scope.iniciarConexao = function (form) {
                    if (form && !form.$valid) return NotifyService.showInvalid();

                    if ($scope.conexao.ValorTelefonia && $scope.conexao.ValorTelefonia != '') {
                        ModalService.closeModal('modal_conectar')
                        $scope.aguardarProcessamento();
                        $scope.erroConexaoValor = false;

                        if (maquina[0] !== null) $scope.dddPadrao = maquina[0].DDD + '';
                        else $scope.dddPadrao = null;

                        iniciouConexao = true;
                        valorTelefonia = $scope.conexao.ValorTelefonia;

                        if ($scope.softphone != null && $scope.softphone.Ativo) {
                            if ($scope.infoRamal != null && $scope.infoRamal.IsWebRTC == true) {

                                let result = $scope.getEnderecoSipWebRTC();

                                if (!result || result.enderecoSipWebRTC == null || result.enderecoSipWebRTC == "") {

                                    if (result.errorMsg) {

                                        let timestamp = new Date().toLocaleTimeString();
                                        $scope.consoleInfo(`[${timestamp}] ${result.errorMsg}`);
                                    }
                                    $scope.exibirMensagem('telaTabulador.erroNaoExisteEnderecoSipWebRTC', 'danger');
                                }
                                else {
                                    $scope.EnderecoSipWebRTC = result.enderecoSipWebRTC;
                                    $scope.conectandoSoftphone = true;
                                    $scope.consoleInfo(`Iniciando conexão com o servidor Webrtc (Tentativa ${++$scope.retryCount}/${$scope.maxRetries})`);
                                    $scope.iniciaRegistroTalkfone();
                                }
                            }
                            else {
                                $scope.logarRamal();
                            }
                        }
                        else {
                            $scope.logarRamal();
                        }

                        $scope.tentarConexao();

                    } else {
                        $scope.erroConexaoValor = true;
                    }

                };

                if ($scope.atendimentoConfiguracao.ConexaoAutomatica) {
                    if ($scope.atendimentoConfiguracao.TipoConexao == 1) {
                        $scope.conexao.isRamal = 'true';
                    } else {
                        $scope.conexao.isRamal = 'false';
                    }
                    $scope.conexao.TelefoniaTipoId = $scope.atendimentoConfiguracao.TipoTelefonia;
                    $scope.getIp();
                }

                $scope.aguardarLigacao = function () {
                    $scope.tabulacao = {};
                    $scope.dadosRamal = {};
                    $scope.camposContato = [];
                    $scope.esconderTabulacao();
                    $scope.esconderContato();
                    $scope.desativarBotoesTabulacao();
                    $scope.desativarDiscagemManual();
                    $scope.aguardarProcessamento();
                    $scope.exibirEnvioSMS = true;
                };

                $scope.atenderLigacao = function () {
                    $scope.infoRing.atendido = true;
                    AtendimentoService.atendeChamada().then(function () {
                        $scope.hideModalRing();
                    });
                }

                $scope.informacoesUra = [];

                $scope.$on(ATENDIMENTO_EVENTS.onInfoCliente, (event, ramal, informacoes) => {
                    $scope.informacoesUra = informacoes;

                    if ($scope.informacoesUra != null) {
                        $scope.informacoesUraHabilitado = true;

                        angular.forEach($scope.informacoesUra, (item) => {
                            if ($scope.chamada == undefined)
                                $scope.chamada = {};

                            if (item.Campo == 'matric')
                                $scope.campoConsultaApi = item.Valor;
                        });

                        //$scope.carregarDadosUraTalkBot();
                    }
                });


                $scope.trataIntervaloAtualEmLigacao = function () {

                    $scope.reiniciarTimerStatus(null);

                    $scope.intervaloSelecionado = 5;

                    if ($scope.intervaloOptions && $scope.intervaloSelecionado > 0) {
                        var intervaloSelecionado = $scope.intervaloOptions[$scope.intervaloSelecionado];
                        if (intervaloSelecionado) {
                            $scope.IntervaloAtual = intervaloSelecionado;
                        }
                    }
                };

                $scope.trataIntervaloAtual = function () {
                    if ($scope.intervaloOptions && $scope.intervaloSelecionado > 0) {
                        var intervaloSelecionado = $scope.intervaloOptions[$scope.intervaloSelecionado];
                        if (intervaloSelecionado) {
                            $scope.IntervaloAtual = intervaloSelecionado;
                            $scope.exibirIntervaloMensagem();
                            verificarIntervalo($scope.IntervaloAtual.RamalStatusDetalheId);
                        }
                    }
                };

                $scope.$on(ATENDIMENTO_EVENTS.onLogado, (event, ramal) => {

                    ModalService.hideLoading();

                    ramalDesconectado = false;
                    if (ramal && ramal.Propriedades && ramal.Propriedades.RamalStatusDetalheId) {
                        $scope.intervaloSelecionado = parseInt(ramal.Propriedades.RamalStatusDetalheId);
                        $scope.trataIntervaloAtual();
                    }

                    $scope.iniciarConexaoComSucesso();

                    if ($scope.configuracao.ExibeIntervaloAgendado) {
                        carregarAgendaIntervalos();
                    }

                    if (ramal.Conferencia.ConferenciaIniciada) {
                        $scope.isConferenciaEmAndamento = true;
                        $scope.preencheParticipantes(ramal);
                        $scope.iniciarTimerStatusConferencia();
                        $scope.abrirModalConferencia();
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.onSetIntervaloRamal, (event, ramal, status) => {

                    if (status.Status == 1) return;

                    if ($scope.infoRing.ativo && !$scope.infoRing.atendido) {
                        $scope.hideModalRing();
                        $scope.emTabulacao = false;
                        $scope.aguardarLigacao();
                    }
                    $scope.intervaloSelecionado = parseInt(status.RamalStatusDetalheId);
                    $scope.trataIntervaloAtual();

                    limparIntervalosExpirados();

                    $scope.reiniciarTimerStatus(ramal.Propriedades.DataDiffIntervalo);


                    if ($scope.intervaloSelecionado == 1 && $scope.exibindoDadosChamada & $scope.statusDiscagem == 0) // Status Livre e Tabulação aberta
                    {
                        $scope.emTabulacao = false;
                        $scope.emDiscagemManual = false;
                        $scope.aguardarLigacao();
                        $scope.executeSearch();
                    }

                    $scope.statusDiscagem = 0;

                    if (status.RamalStatusDetalheId == INTERVALO_DISCAGEMPREVIEW) {
                        if ($scope.discagemPreviewList.length == 0 && $scope.discagemPreview.CampanhaId == undefined)
                            ativarDiscagemPreview();
                    }
                    else if (status.RamalStatusDetalheId == $scope.configuracao.IntervaloLivre || !$scope.isDiscagemPreview && status.RamalStatusDetalheId != INTERVALO_EMLIGACAO || !$scope.isDiscagemPreview && status.RamalStatusDetalheId == $scope.configuracao.IntervaloNaoDisponivel) {
                        desativarDiscagemPreview();
                        if ($scope.isDiscagemContatoMiner && status.RamalStatusDetalheId == $scope.configuracao.IntervaloLivre)
                            $scope.cancelarContatoMiner();
                    }
                    else if ($scope.isDiscagemPreview === true && status.RamalStatusDetalheId != (INTERVALO_EMLIGACAO, $scope.configuracao.IntervaloNaoDisponivel)) {
                        desativarDiscagemPreview();
                    }

                    if (status.RamalStatusDetalheId == $scope.configuracao.IntervaloLivre && !$scope.rediscagemCliente)
                        $scope.exibirMensagem('telaTabulador.aguardandoLigacao', 'success');
                });

                $scope.$on(ATENDIMENTO_EVENTS.onInfoIntervaloRamal, (event, ramal, infoIntervalo) => {

                    GrupoRamalStatusDetalheResource.GetVisualizaIntervalo({ GrupoId: $scope.usuario.Ramal.GrupoId, RamalStatusDetalheId: infoIntervalo.RamalStatusDetalheId })
                        .$promise.then(result => {

                            if (result.Visivel) {
                                let intervaloApi = intervaloListDic[infoIntervalo.RamalStatusDetalheId];

                                $scope.intervaloOptions[infoIntervalo.RamalStatusDetalheId] = {
                                    Descricao: infoIntervalo.Descricao,
                                    Produtivo: infoIntervalo.Produtivo,
                                    RamalStatusDetalheId: infoIntervalo.RamalStatusDetalheId,
                                    Bloqueado: intervaloApi != null ? intervaloApi.Bloqueado : false
                                };
                                $scope.trataIntervaloAtual();
                            }

                        });
                });

                $scope.$on(ATENDIMENTO_EVENTS.onParametrosRamal, (event, ramal, parametro) => {
                    $scope.tempoStatusOrigem = moment();
                    $scope.tempoStatus = parametro.Diferenca;
                });

                $scope.$on(ATENDIMENTO_EVENTS.onAlterarIntervaloTipoErro, () => {
                    if ($('.uk-notify-message.uk-notify-message-danger').length == 0) {
                        NotifyService.showError('telaTabulador.erroAoAlterarIntervalo');
                    }
                });


                $scope.topLigacoes = [];
                $scope.topLigacoesCount = 0;

                $scope.getTopLigacoesRecebidas = function (telefone) {
                    TabulacaoResource.GetTopLigacoesRecebidas({ telefone: telefone }).$promise.then(response => {
                        $scope.topLigacoes = response;
                        $scope.topLigacoesCount = response.length;
                        $scope.exibirNotificacaoLigacaoRecebida = $scope.topLigacoesCount > $scope.qtdLigacoesEntrantesANotificar ? true : false;
                    });
                };

                $scope.$on(ATENDIMENTO_EVENTS.onChamada, function (event, ramal, chamada) {
                    ModalService.closeModal('modalTabulacaoDiscador');
                    ModalService.closeModal('modalTabulacoesIncompletas');
                    ModalService.closeModal('modal_edit');

                    $scope.ischamadaInterna = chamada.Telefone.length == 4 && chamada.TipoDiscagem == 5 ? true : false;
                    if ($scope.ischamadaInterna) return;

                    if (chamada.CodigoCampanha && chamada.CodigoCampanha > 0) {
                        let campanha = _.find($scope.campanhas, (item) => { return item.CampanhaId == chamada.CodigoCampanha; });
                        if (campanha) {
                            chamada.NomeCampanha = campanha.Nome;
                        }
                    }

                    if (chamada.CodigoCampanha && chamada.CodigoCampanha > 0) {
                        $scope.Direcao = 1;
                    } else {
                        $scope.Direcao = chamada.Direcao;
                    }


                    $scope.finalizarProcessamento();
                    $scope.exibirContato();
                    $scope.chamada = chamada;
                    $scope.dadosRamal = ramal;
                    $scope.chamadaAtiva = true;
                    // $scope.esconderMensagem();
                    //getCamposTabulacao();
                });


                $scope.$on(ATENDIMENTO_EVENTS.onRingSip, function (event, ramal, chamada) {
                    if ($scope.configuracao.IsEmulaRing) {
                        $scope.showModalRing();
                    }
                });


                $scope.$on(ATENDIMENTO_EVENTS.onDisca, function (event, ramal, chamada) {
                    $scope.chamadaAtiva = true;
                    $scope.Direcao = chamada.Direcao;
                    $scope.chamada = chamada;
                    $scope.GlobalId = chamada.GlobalId;

                    if ($scope.chamadaPreviewAtiva || $scope.chamadaContatoMinerAtiva || $scope.rediscagemCliente) {
                        $scope.exibirMensagem('telaTabulador.chamandoStatus', 'info');
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.onDiscaStatus, function (event, ramal, chamada, status) {

                    $scope.statusDiscagem = 2;

                    switch (status.StatusDiscagem) {
                        case -2:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.desconhecido');
                            break;
                        case -1:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.naoAtende');
                            break;
                        case 0:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.ocupado');
                            break;
                        case 1:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.congestionamento');
                            break;
                        case 2:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.servico');
                            break;
                        case 3:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.ramalDesligou');
                            break;
                        case 4:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.canaisBloqueados');
                            break;
                        case 5:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.rotaInvalida');
                            break;
                        case 6:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.canaisOcupados');
                            break;
                        case 7:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.prefixoBloqueado');
                            break;
                    }

                    $scope.chamada = chamada;

                    if ($scope.isDiscagemPreview == true) {
                        $scope.esconderMensagem();
                        $scope.chamadaPreview.StatusChamada = $scope.statusDiscagemErro;
                        $scope.chamadaPreviewTabulacaoAtiva = true;
                        $scope.selecaoTabulacao = 1;
                    }

                    if ($scope.isDiscagemContatoMiner == true) {
                        $scope.esconderMensagem();
                        $scope.chamadaContatoMiner.StatusChamada = $scope.statusDiscagemErro;
                        $scope.chamadaContatoMinerTabulacaoAtiva = true;
                        $scope.selecaoTabulacao = 1;
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.onDiscaStatusInterno, function (event, ramal, chamada, status) {

                    if (status != 2) {
                        $scope.statusDiscagem = 3;
                        $scope.ischamadaInterna = true;
                    }

                    switch (status) {
                        case -1:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.desconhecido');
                            break;
                        case 3:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.erroDiscagem');
                            break;
                        case 4:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.ramalinvalido');
                            break;
                        case 5:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.ocupado');
                            break;
                        case 6:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.ramalNaoLogado');
                            break;
                        case 7:
                            $scope.statusDiscagemErro = $translate.instant('statusDiscagem.ramalEntrouFila');
                            $scope.chamadaAtiva = true;
                            break;
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.onChamadaGlobalId, function (event, ramal, chamada, globalId, reenvio) {
                    $scope.GlobalId = globalId;

                    if ($scope.isDiscagemPreview == true)
                        $scope.chamadaPreview.GlobalId = chamada.GlobalId

                    if (chamada.CodigoCampanha && chamada.CodigoCampanha > 0) {
                        $scope.Direcao = 1;
                    } else {

                        /* TODO: Corrigir na DLL */
                        if (chamada.Direcao == 0) {
                            $scope.Direcao = 2;
                        } else {
                            $scope.Direcao = chamada.Direcao;
                        }

                        if (reenvio) {
                            $scope.chamada = chamada;
                        }
                    }
                    getProtocoloAtendimento($scope.Direcao, $scope.GlobalId);
                });

                $scope.$on(ATENDIMENTO_EVENTS.onAtendidoDiscador, function (event, ramal, chamada, direcao) { });

                $scope.$on(ATENDIMENTO_EVENTS.onAtendido, function (event, ramal, chamada, direcao, reenvio) {

                    $scope.GlobalId = chamada.GlobalId;

                    if ($scope.isDiscagemPreview == true) {
                        $scope.esconderMensagem();
                        $scope.chamadaPreview.GlobalId = chamada.GlobalId
                        $scope.chamadaPreview.StatusChamada = 'Atendido';

                        if ($scope.chamadaPreview && $scope.chamadaPreview.CodigoCampanha == undefined) {
                            $scope.isCarregarDiscagemPreview = true;
                            $scope.discagemPreview = chamada;
                            $scope.chamadaPreviewAtiva = true;
                            carregarInformacoesCliente();
                        }
                    }

                    if ($scope.rediscagemCliente) {
                        $scope.esconderMensagem();
                    }

                    if ($scope.isDiscagemContatoMiner == true) {
                        $scope.esconderMensagem();
                        $scope.chamadaContatoMiner.GlobalId = chamada.GlobalId
                        $scope.chamadaContatoMiner.StatusChamada = 'Atendido';
                        $scope.chamadaContatoMinerAtiva = true;
                        $scope.selecaoTabulacaoContato = 1;
                    }

                    ModalService.closeModal('modalTabulacaoDiscador');
                    if ($scope.infoRing.ativo) {
                        $scope.hideModalRing();
                    }
                    $scope.trataIntervaloAtualEmLigacao();
                    $scope.ischamadaInterna = chamada.Telefone.length == 4 && (chamada.TipoDiscagem == 6 || chamada.TipoDiscagem == 2) ? true : false;

                    if ($scope.ischamadaInterna) {
                        $scope.esconderMensagem();
                    } else {
                        if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloLivre || $scope.intervaloSelecionado == INTERVALO_EMLIGACAO) {
                            $scope.alterarIntervaloHub($scope.configuracao.IntervaloNaoDisponivel);
                        }
                    }

                    if (chamada.CodigoCampanha && chamada.CodigoCampanha > 0) {
                        let campanha = _.find($scope.campanhas, function (item) { return item.CampanhaId == chamada.CodigoCampanha; });
                        if (campanha) {
                            chamada.NomeCampanha = campanha.Nome;
                        }

                        $scope.CodigoCliente = chamada.CodigoCliente
                    }


                    if (chamada.CodigoCampanha && chamada.CodigoCampanha > 0) {
                        $scope.Direcao = 1;
                    } else {
                        $scope.Direcao = chamada.Direcao;
                    }
                    //$scope.Direcao = chamada.Direcao;
                    $scope.finalizarProcessamento();

                    if (chamada.TipoDiscagem != 6) {
                        $scope.exibirContato();
                        $scope.chamada = chamada;
                        $scope.dadosRamal = ramal;
                        $scope.exibirTabulacao();
                        $scope.desativarBotoesTabulacao();
                        $scope.podeRealizarTimeout = true;
                        $scope.iniciarTabulacao();
                        $scope.chamadaAtiva = true;
                        $scope.exibirEnvioSMS = false;


                        getCamposTabulacao(reenvio);
                    } else {
                        $scope.chamadaAtiva = true;
                        ModalService.alert('telaTabulador.voceEstaSendoConsultadoPor', { 'Identificacao': (chamada.NomeRamal || chamada.Telefone) })
                    }

                    if ($scope.consultarHistoricoLigacaoRecebida && chamada.Direcao == DIRECAO_ATENDIMENTO_RECEBIDA) {
                        $scope.getTopLigacoesRecebidas(chamada.Telefone);
                    }

                    if ($scope.isDiscagemPreview == true)
                        $scope.selecaoTabulacao = 1;


                    if(!$scope.minimized && $scope.PermissaoChat){
                        NotifyService.showMessage('Chamada recebida. O chat será minimizado para atendimento do telefone.', 'info');
                        $timeout(function() {
                            NotifyService.closeCurrent();
                            $scope.minimizarChat(true);
                        }, 5000);  // 5 segundos
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.onRecebendoMensagem, function (event, ramal, dados) {
                    $window.UIkit.notify(dados.Mensagem, {
                        status: "info",
                        pos: "top-center",
                        timeout: 0
                    });
                });

                $scope.exibirIcone = function (AcaoId) {
                    if (AcaoId == 1) return '&#xE161;';
                    if (AcaoId == 2) return '&#xE15D;';
                    if (AcaoId == 3) return '&#xE89B;';
                    if (AcaoId == 4) return '&#xE02F;';
                    if (AcaoId == 5) return '&#xE8A8;';
                    if (AcaoId == 6) return '&#xE0B6;';
                };

                $scope.$on(ATENDIMENTO_EVENTS.onDesliga, function (ramal, chamada) {
                    if ($scope.emConsulta) {
                        NotifyService.showMessage('telaTabulador.clienteDesligou', 'warning')
                    }

                    if ($scope.ischamadaInterna) {
                        $scope.aguardarLigacao();
                        ModalService.closeModal('modalTabulacaoDiscador');
                        return;
                    }

                    $scope.ativarBotoesTabulacao();

                    $scope.AtendimentoInicio = new Date().getTime() / 1000;

                    ModalService.closeModal('modal_transferencia');

                    $scope.emEspera = false;
                    $scope.foraEspera = true;
                    $scope.chamadaAtiva = false;
                    //$scope.informacoesUra = [];
                    $scope.topLigacoes = [];
                    $scope.topLigacoesCount = 0;
                    $scope.infoRing.atendido = false;
                    $scope.informacoesUraHabilitado = false;
                    $scope.campoConsultaApi = '';

                    if ($scope.atendimentoConfiguracao.TabulacaoManual && !$scope.emTabulacao && $scope.emDiscagemManual || $scope.rediscagemCliente) {
                        if ($scope.rediscagemCliente) tabulacaoLigacaoManual(ramal, true);
                        else tabulacaoLigacaoManual(ramal, false);
                        //$scope.emDiscagemManual = false;
                        $scope.chamadaAtiva = false;
                        $scope.exibirBotoesTabulacao = true;
                    }

                    if ($scope.emTabulacao == false) $scope.aguardarLigacao();

                    $scope.finalizarConferencia();

                    if ($scope.isDiscagemPreview == true) {
                        $scope.chamadaPreviewTabulacaoAtiva = true;
                        $scope.selecaoTabulacao = 1;

                        if (!$scope.exibirBotoesTabulacao) {
                            tabulacaoLigacaoManual(ramal, false);
                            $scope.exibirBotoesTabulacao = true;
                            $scope.chamadaAtiva = false;
                        }
                    }

                    if ($scope.isDiscagemContatoMiner == true) {
                        $scope.chamadaContatoMinerTabulacaoAtiva = true;
                        $scope.selecaoTabulacaoContato = 1;

                        if (!$scope.exibirBotoesTabulacao) {
                            tabulacaoLigacaoManual(ramal, false);
                            $scope.exibirBotoesTabulacao = true;
                            $scope.chamadaAtiva = false;
                        }
                    }

                    if ($scope.rediscagemCliente) $scope.esconderMensagem();
                });

                $scope.$on(ATENDIMENTO_EVENTS.onInfoIntervaloRamalErro, () => {
                    $scope.ativarBotoesTabulacao();
                });

                $scope.retirarDDD = function (telefone) {
                    let ddd = $scope.dddPadrao;
                    if (!(telefone.length == 8 || telefone.length == 9)) {
                        if (telefone[0] != '0') {
                            ddd = telefone.substring(0, 2);
                        } else {
                            if (telefone[1] != '0') {
                                ddd = telefone.substring(1, 3);
                            } else {
                                ddd = telefone.substring(2, 4);
                            }
                        }
                    }
                    return ddd;
                }

                $scope.retirarNumero = function (telefoneComDDD) {
                    let telefone = telefoneComDDD;
                    if (!(telefoneComDDD.length == 8 || telefoneComDDD.length == 9)) {
                        if (telefoneComDDD[0] != '0') {
                            telefone = telefoneComDDD.substring(2, telefoneComDDD.length);
                        } else {
                            if (telefoneComDDD[1] != '0') {
                                telefone = telefone.substring(3, telefoneComDDD.length);
                            } else {
                                telefone = telefone.substring(4, telefoneComDDD.length);
                            }
                        }
                    }
                    return telefone;
                }

                let timerSmsIntervalo = [];

                $scope.startTimer = function () {
                    timerSmsIntervalo = setInterval(funcaoTimer, 1000);
                };

                var stopIntervalo = function () {
                    clearInterval(timerSmsIntervalo);
                };

                var funcaoTimer = function () {
                    $scope.timerSMS -= 1;
                    if ($scope.timerSMS <= 0) {
                        $scope.disableTimerSms = false;
                        $scope.timerSMS = 30;
                        stopIntervalo();
                    }
                };

                let consolidarTabulacao = function (acaoId, chamada) {
                    if ($scope.camposContato && $scope.camposContato.length > 0) {
                        $scope.tabulacao.LayoutId = $scope.camposContato[0].AtendimentoLayoutId;
                    } else {
                        $scope.tabulacao.LayoutId = $scope.atendimentoLayoutId;
                    }

                    if (chamada.CodigoCampanha > 0) {
                        $scope.tabulacao.DirecaoId = DIRECAO_TABULACAO_EFETUADA;
                    } else {
                        if (chamada.Direcao == DIRECAO_ATENDIMENTO_RECEBIDA) {
                            $scope.tabulacao.DirecaoId = DIRECAO_TABULACAO_RECEBIDA;
                        } else {
                            $scope.tabulacao.DirecaoId = DIRECAO_TABULACAO_EFETUADA;
                        }
                    }
                    $scope.tabulacao.ClienteId = chamada.CodigoCliente;
                    $scope.tabulacao.CampanhaId = chamada.CodigoCampanha;
                    $scope.tabulacao.NB = chamada.Telefone;
                    $scope.tabulacao.NA = chamada.DDRLocal || "999999999";
                    $scope.tabulacao.GlobalId = $scope.GlobalId;
                    $scope.tabulacao.Protocolo = $scope.Protocolo;
                    $scope.tabulacao.AcaoId = $scope.transferidoAcaoId == 6 ? 6 : acaoId;
                    $scope.tabulacao.Duracao = Math.floor($scope.AtendimentoFim - $scope.AtendimentoInicio);

                    let tabulacaoIncompleta = $scope.tabulacoesIncompletasBase.find(tab => tab.GlobalId == $scope.GlobalId);
                    if (tabulacaoIncompleta) {
                        $scope.tabulacao.Id = tabulacaoIncompleta.Id;
                    }
                }


                let VerificaTabulacaoIncompleta = function (chamada) {
                    let salvarTabulacao = false;
                    if (!$scope.ischamadaInterna) {
                        if ($scope.atendimentoLayout.TabulacaoAutomaticaManual || $scope.atendimentoLayout.TabulacaoAutomaticaDiscador || $scope.atendimentoLayout.TabulacaoAutomaticaReceptiva) {
                            if (chamada.CampanhaId == null && chamada.Direcao == 1 && $scope.atendimentoLayout.TabulacaoAutomaticaManual) {
                                salvarTabulacao = true;
                            } else if (chamada.CampanhaId != null && chamada.Direcao == 1 && $scope.atendimentoLayout.TabulacaoAutomaticaDiscador) {
                                salvarTabulacao = true;
                            } else if (chamada.Direcao == 2 && $scope.atendimentoLayout.TabulacaoAutomaticaReceptiva) {
                                salvarTabulacao = true;
                            }
                        }

                        if (salvarTabulacao) {
                            SalvarTabulacaoIncompleta(chamada)
                        }
                    }
                }

                let SalvarTabulacaoIncompleta = function (chamada) {
                    consolidarTabulacao(4, chamada);
                    $scope.tabulacao.Duracao = 0;
                    $scope.tabulacao.AtendimentoStatusId = 2;
                    $scope.tabulacao.Nome = chamada.NomeCliente;

                    TabulacaoResource.save($scope.tabulacao).$promise.then((tabulacao) => {
                        $scope.tabulacao.Id = tabulacao.Id;
                    });
                }

                let UpdateTabulacaoIncompletaTransferencia = function () {
                    if ($scope.tabulacao.id != 0) {
                        $scope.tabulacao.transferencia = true;
                        TabulacaoResource.save($scope.tabulacao).$promise.then(() => {
                            $scope.executeSearch();
                        });
                    }
                }

                $scope.enviarTabulacao = function (form, acaoId) {

                    if (localStorage.getItem('tabulacao_categoriaId')) {
                        $scope.tabulacao.CategoriaId = localStorage.getItem('tabulacao_categoriaId');
                        localStorage.removeItem('tabulacao_categoriaId');
                    }

                    if (localStorage.getItem('tabulacao_subCategoriaId')) {
                        $scope.tabulacao.SubCategoriaId = localStorage.getItem('tabulacao_subCategoriaId');
                        localStorage.removeItem('tabulacao_subCategoriaId');
                    }

                    if (localStorage.getItem('tabulacao_categoriaFilhoId')) {
                        let categoriaFilhoId = localStorage.getItem('tabulacao_categoriaFilhoId');


                        if ($scope.atendimentoLayout.Tabular && categoriaFilhoId == '0') {
                            NotifyService.showMessage('telaTabulador.erroTabulacao', 'info')
                            return;
                        }

                        localStorage.removeItem('tabulacao_categoriaFilhoId');
                    }

                    if ($scope.atendimentoLayout.Tabular && $scope.tabulacao.CategoriaId == undefined) {
                        NotifyService.showMessage('telaTabulador.erroTabulacao', 'info')
                        return;
                    }

                    $scope.infoRing.atendido = false;

                    stopIntervalo();
                    $scope.disableTimerSms = false;
                    $scope.timerSMS = 60;

                    $scope.sairConsulta(true);
                    $scope.AtendimentoFim = new Date().getTime() / 1000;

                    consolidarTabulacao(acaoId, $scope.chamada);
                    $scope.tabulacao.AtendimentoStatusId = 1;

                    if ($scope.tabulacao.DirecaoId == 1) {
                        $scope.tabulacao.Nome = $scope.contatoReceptivo.Nome;
                    } else if ($scope.tabulacao.DirecaoId == 2) {
                        if ($scope.tabulacao.Nome == undefined || $scope.tabulacao.Nome == '')
                            $scope.tabulacao.Nome = $scope.chamada.NomeCliente;
                    }

                    if ($scope.chamada.NumeroRamalGrupo != null)
                        $scope.tabulacao.NumeroGrupo = $scope.chamada.NumeroRamalGrupo;

                    if ($scope.tabulacao.ClienteId == '')
                        $scope.tabulacao.ClienteId = $scope.tabulacao.CodigoCliente;

                    if (!$scope.tabulacao.NB) $scope.tabulacao.NB = '99999999';

                    TabulacaoResource.save($scope.tabulacao).$promise.then(() => {
                        $scope.executeSearch();
                    });

                    $scope.transferidoAcaoId = 0;
                    $scope.AtendimentoInicio = 0;
                    $scope.AtendimentoFim = 0;
                    $scope.emDiscagemManual = false;

                    $scope.finalizarTabulacao();

                    if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloNaoDisponivel) {

                        if ($scope.isDiscagemPreview == true && $scope.chamadaPreviewAtiva == true)
                            $scope.alterarIntervaloHub(6);
                        else {
                            $scope.alterarIntervaloHub($scope.configuracao.IntervaloLivre);
                            $scope.exibirMensagem('telaTabulador.aguardandoLigacao', 'success');
                        }
                    }

                    $scope.aguardarLigacao();

                    if ($scope.isDiscagemPreview == true) {
                        if ($scope.chamadaPreviewTabulacaoAtiva) {
                            clearChamadaPreview();
                            $scope.nextCliente();
                        }
                    }

                    if ($scope.isDiscagemContatoMiner == true) {
                        if ($scope.chamadaContatoMinerTabulacaoAtiva) {
                            $scope.isDiscagemContatoMiner = false;
                            $scope.chamadaContatoMinerTabulacaoAtiva = false;
                            $scope.chamadaContatoMinerAtiva = false;
                        }
                    }

                    $scope.rediscagemCliente = false;

                    $scope.informacoesUra = [];
                };



                $scope.enviarContatoNegativo = function (form, acaoId) {
                    if (!form.$valid) {
                        form.$submitted = true;
                        return;
                    }

                    ModalService.confirmMessage('telaTabulador.confirmRemoverEsteNumeroDoMailing', null, () => {
                        $scope.contatoNegativo = {
                            Campanha: $scope.chamada.CodigoCampanha,
                            CodCliente: $scope.chamada.CodigoCliente,
                            DDD: $scope.retirarDDD($scope.chamada.Telefone),
                            Telefone: $scope.retirarNumero($scope.chamada.Telefone),
                            Prioridade: 1
                        };

                        TabulacaoResource
                            .ContatoNegativo($scope.contatoNegativo)
                            .$promise
                            .then(() => {
                                $scope.enviarTabulacao(form, acaoId);
                            }).catch(() => {
                                NotifyService.showError('telaTabulador.erroAoTabularContatoNegativo');
                            });
                    });
                };

                $scope.enviarCaixaPostal = function (form, acaoId) {
                    if (!form.$valid) {
                        form.$submitted = true;
                        return;
                    }

                    ModalService.confirmMessage('telaTabulador.confirmReinsercaoNoMailing', null, function () {
                        $scope.caixaPostal = {
                            Campanha: $scope.chamada.CodigoCampanha,
                            CodCliente: $scope.chamada.CodigoCliente,
                            DDD: $scope.retirarDDD($scope.chamada.Telefone),
                            Telefone: $scope.retirarNumero($scope.chamada.Telefone),
                            Ramal: $scope.dadosRamal.Ramal,
                            NomeCliente: $scope.chamada.NomeCliente,
                            DtHoraPrioridade: new Date()
                        };

                        TabulacaoResource
                            .CaixaPostal($scope.caixaPostal)
                            .$promise
                            .then(() => {
                                $scope.enviarTabulacao(form, acaoId);
                            }).catch(() => {
                                NotifyService.showError('telaTabulador.erroAoTabularCaixaPostal');
                            });
                    });
                };


                $scope.replateMesagemSms = function () {
                    let template = smsTemplate.find(t => t.Id == $scope.smsTemplateSelecionado);

                    if (template) {
                        let mensagem = template.Mensagem;

                        let nomeDoCliente = "";
                        let codigoCampanha = "";
                        let codigoCliente = "";
                        let globalId = "";
                        let nomeCampanha = "";
                        let telefone = "";
                        let protocolo = "";

                        if ($scope.chamada.Direcao == 1 && $scope.chamada.CodigoCampanha) {
                            if ($scope.chamada.NomeCliente)
                                nomeDoCliente = $scope.chamada.NomeCliente;

                            if ($scope.chamada.CodigoCliente)
                                codigoCliente = $scope.chamada.CodigoCliente;

                            if ($scope.chamada.CodigoCampanha)
                                codigoCampanha = $scope.chamada.CodigoCampanha;

                            if ($scope.chamada.NomeCampanha)
                                nomeCampanha = $scope.chamada.NomeCampanha;

                        } else {
                            if ($scope.contatoReceptivo.Nome)
                                nomeDoCliente = $scope.contatoReceptivo.Nome;

                            if ($scope.contatoReceptivo.Codigo)
                                codigoCliente = $scope.contatoReceptivo.Codigo;
                        }

                        if ($scope.chamada.GlobalId)
                            globalId = $scope.chamada.GlobalId;

                        if ($scope.chamada.Telefone)
                            telefone = $scope.chamada.Telefone;

                        if ($scope.Protocolo)
                            protocolo = $scope.Protocolo;

                        mensagem = mensagem.replace("#NomeDoCliente", nomeDoCliente);
                        mensagem = mensagem.replace("#CodigoCampanha", codigoCampanha);
                        mensagem = mensagem.replace("#CodigoCliente", codigoCliente);
                        mensagem = mensagem.replace("#GlobalId", globalId);
                        mensagem = mensagem.replace("#NomeCampanha", nomeCampanha);
                        mensagem = mensagem.replace("#Telefone", telefone);
                        mensagem = mensagem.replace("#Protocolo", protocolo);

                        $scope.smsMensagem = mensagem;
                        $scope.numberOfCharacters = $scope.smsMensagem.length;

                        if ($scope.numberOfCharacters > 147)
                            $scope.excedeuMaxCaracteres = true;
                    }
                }

                $scope.abrirEnviaSMS = function () {

                    if ($scope.smsTemplate.length > 0) {
                        ModalService.openModal('modal_envioSMS');
                        $scope.smsTemplateSelecionado = 0;
                        $scope.smsMensagem = '';
                        $scope.numberOfCharacters = 0;
                    } else {
                        NotifyService.showError(null, 'telaTabulador.naoExistsTemplateSms');
                    }
                };



                $scope.enviarSMS = function () {
                    TabulacaoResource.EnvioSMS({
                        telefone: $scope.chamada.Telefone,
                        mensagem: $scope.smsMensagem,
                        globalId: $scope.chamada.GlobalId,
                        direcaoId: $scope.tabulacao.DirecaoId,
                        campanhaManagerId: $scope.tabulacao.CampanhaId,
                        dDRLocal: $scope.chamada.DDRLocal,
                        smsTemplateId: $scope.smsTemplateSelecionado
                    }).$promise.then(() => {
                        NotifyService.showSuccess('telaTabulador.smsEnviado');
                        ModalService.closeModal('modal_envioSMS');
                        $scope.disableTimerSms = true;
                        $scope.smsTemplateSelecionado = 0;
                        //$scope.startTimer();
                    }).catch(() => {
                        NotifyService.showError(null, 'telaTabulador.smsErro');
                    });
                };

                $scope.enviar = {};
                $scope.sendEmail = function () {

                    if (!(/^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z]){2,}([.]){1}([a-z]){2,}([.]?){1}([a-z]?){2,}$/i.test($scope.enviar.Email))) {
                        NotifyService.showError(null, "telaTabulador.erroAoEnviarEmail");
                        return false;
                    }

                    TabulacaoResource.SendEmail({
                        Email: $scope.enviar.Email, Mesnsagem: $scope.smsMensagem, Assunto: $scope.enviar.Assunto,
                        Globalid: $scope.tabulacao.GlobalId, Nome: $scope.chamada.NomeCliente, ClientId: $scope.tabulacao.ClientId,
                        Telefone: $scope.chamada.Telefone, Processado: false
                    }).$promise.then(() => {
                        NotifyService.showSuccess('telaTabulador.emailEnviadoComSucesso');
                        ModalService.closeModal('modal_envioSMS');
                        $scope.disableTimerSms = true;
                        $scope.smsTemplateSelecionado = 0;
                    }).catch(() => {
                        NotifyService.showError();
                    });

                }

                $scope.abrirAgendamento = function (form) {
                    $scope.bloquearBotaoAgendamento = false;

                    if (form && !form.$valid) {
                        form.$submitted = true;
                        return;
                    }

                    ModalService.isHidden('modal_agendamento', function () {
                        $scope.agendamento = {
                            Telefone: $scope.retirarNumero($scope.chamada.Telefone),
                            DDD: $scope.retirarDDD($scope.chamada.Telefone)
                        };
                        $scope.erroTelefone = false;
                        $scope.erroData = false;
                        $scope.erroHora = false;

                        $time_1.val("")
                        $time_2.val("")
                        $dp_start.val("")
                    });
                };

                $scope.enviarAgendamento = function (form, acaoId) {
                    let dataFormatada;
                    $scope.bloquearBotaoAgendamento = true;
                    $scope.erroTelefone = !$scope.agendamento.Telefone || $scope.agendamento.Telefone.length < 7;
                    $scope.erroData = !$scope.agendamento.Data;
                    $scope.erroHora = !$scope.agendamento.HoraCompleta && !$scope.agendamento.HoraParcial;
                    $scope.erroDDD = !$scope.agendamento.DDD;

                    if ($scope.erroData || $scope.erroHora || $scope.erroTelefone || $scope.erroDDD) return;

                    if ($scope.horaCompleta) {
                        dataFormatada = moment($scope.agendamento.Data).format('YYYY-MM-DD')
                        $scope.agendamento.DataHora = moment.utc(dataFormatada + ' ' + $scope.agendamento.HoraCompleta).toDate();
                    } else if ($scope.horaParcial) {
                        dataFormatada = moment($scope.agendamento.Data).format('YYYY-MM-DD')
                        $scope.agendamento.DataHora = moment.utc(dataFormatada + ' ' + $scope.agendamento.HoraParcial).toDate();
                    }

                    if (moment(dataFormatada + ' ' + $scope.agendamento.HoraParcial).format() < moment().format()) {
                        $scope.bloquearBotaoAgendamento = false;
                        return NotifyService.showError(null, 'telaTabulador.agendamentoHoraErro')
                    }


                    $scope.agendamento.Campanha = $scope.chamada.CodigoCampanha;
                    $scope.agendamento.CodCliente = $scope.chamada.CodigoCliente;
                    $scope.agendamento.NomeCliente = $scope.chamada.NomeCliente;
                    $scope.agendamento.Ramal = $scope.dadosRamal.Ramal;

                    let detalhes = [];

                    if ($scope.chamada.InfoAdicional1)
                        detalhes.push({ InfoAdicional: $scope.chamada.InfoAdicional1 });
                    if ($scope.chamada.InfoAdicional2)
                        detalhes.push({ InfoAdicional: $scope.chamada.InfoAdicional2 });
                    if ($scope.chamada.InfoAdicional3)
                        detalhes.push({ InfoAdicional: $scope.chamada.InfoAdicional3 });
                    if ($scope.chamada.InfoAdicional4)
                        detalhes.push({ InfoAdicional: $scope.chamada.InfoAdicional4 });
                    if ($scope.chamada.InfoAdicional5)
                        detalhes.push({ InfoAdicional: $scope.chamada.InfoAdicional5 });
                    if (detalhes.length > 0)
                        $scope.agendamento.Detalhe = _.pluck(detalhes, 'InfoAdicional').join(",");

                    TabulacaoResource
                        .Agendamento($scope.agendamento)
                        .$promise
                        .then(() => {
                            $scope.enviarTabulacao($scope.forms.form, acaoId);
                        }).catch(() => {
                            NotifyService.showError('telaTabulador.erroAoTabularAgendamento');
                            $scope.bloquearBotaoAgendamento = false;
                        });

                    ModalService.closeModal('modal_agendamento');
                };

                $scope.enviarRediscagem = function (form, acaoId) {
                    if (!form.$valid) {
                        form.$submitted = true;
                        return;
                    }
                    UIkit.modal.prompt($translate.instant('campo.telefone') + ':', $scope.chamada.Telefone, val => {
                        if (val.length > 7) {
                            $scope.enviarTabulacao(form, acaoId);
                            AtendimentoService.discar(val, 1);
                        }
                    });
                };

                $scope.abrirTransferencia = function () {
                    ModalService.isHidden('modal_transferencia', () => {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;
                        $scope.transferencia = { Telefone: '', Ramal: '' };
                        $scope.tipoTransferencia = 2;
                        $scope.grupoSelecionado = 0;
                        $scope.erroTelefone = false;
                        $scope.listarRamais(false);
                        if ($scope.atendimentoConfiguracao.ListarPesquisasServico) {
                            if ($scope.chamada != null) {
                                $scope.getUraPesquisaSatisfacaoAssociada($scope.chamada.DDRLocal);
                            }
                        }
                    })
                };

                $scope.erroConsulta = false;
                $scope.enviarConsulta = function () {
                    try {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;

                        let telefone = ($scope.transferencia.Ramal == '' || $scope.transferencia.Ramal == undefined) ?
                            $scope.transferencia.Telefone : $scope.transferencia.Ramal;

                        let tipoTransf = ($scope.servicoTransferenciaTipoId != 1 && telefone.length < 7) ? 2 : $scope.tipoTransferencia;
                        $scope.erroTelefone = !telefone || (telefone.length < 7 && tipoTransf == 1);

                        if ($scope.erroTelefone) {
                            return;
                        }

                        AtendimentoService.consultar(telefone, tipoTransf)
                            .then(() => {
                                $scope.emConsulta = true;
                                NotifyService.showSuccess('telaTabulador.consultandoOutroRamal');
                            })
                            .catch(() => {
                                $scope.emConsulta = false;
                                var mensagem = tipoTransf == 2 ? 'telaTabulador.naoFoiPossivelConsultarORamal' : 'telaTabulador.naoFoiPossivelConsultarExterno';
                                $scope.mostrarErroConsulta(mensagem);
                            });

                    } catch (ex) {
                        var mensagem = $scope.tipoTransferencia == 2 ? 'telaTabulador.naoFoiPossivelConsultarORamal' : 'telaTabulador.naoFoiPossivelConsultarExterno';
                        $scope.mostrarErroConsulta(mensagem);
                    }
                };

                $scope.sairConsulta = function (esconderMensagem) {
                    try {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;
                        $scope.emConsulta = false;
                        AtendimentoService.liberarConsulta()
                            .then(() => {
                                if (esconderMensagem) $scope.esconderMensagem();
                            });
                    } catch (ex) {
                        $scope.emConsulta = true;
                        $scope.mostrarErroConsulta('telaTabulador.naoFoiPossivelSairDaConsulta');
                    }
                };

                $scope.enviarTransferencia = function () {
                    try {
                        $scope.mensagemErroConsulta = null;
                        $scope.erroConsulta = false;
                        let telefone = ($scope.transferencia.Ramal == '' || $scope.transferencia.Ramal == undefined) ? $scope.transferencia.Telefone : $scope.transferencia.Ramal;

                        $scope.transferidoAcaoId = 6;

                        let tipoTransf = ($scope.servicoTransferenciaTipoId != 1 && telefone.length < 7) ? 2 : $scope.tipoTransferencia;
                        $scope.erroTelefone = !telefone || (telefone.length < 7 && tipoTransf == 1);

                        if ($scope.erroTelefone) return;

                        AtendimentoService
                            .transferir(telefone, tipoTransf)
                            .then(() => {
                                $scope.emConsulta = false;
                                ModalService.closeModal('modal_transferencia');
                                $scope.ativarBotoesTabulacao();
                                $scope.AtendimentoInicio = new Date().getTime() / 1000;
                                UpdateTabulacaoIncompletaTransferencia();
                            })
                            .catch(() => {
                                $scope.mostrarErroConsulta('telaTabulador.naoFoiPossivelTransferirLigacao');
                            });
                    } catch (ex) {
                        $scope.mostrarErroConsulta('telaTabulador.naoFoiPossivelTransferirLigacao');
                    }
                };

                $scope.mostrarErroConsulta = function (mensagem) {
                    $scope.mensagemErroConsulta = $translate.instant(mensagem);
                    $scope.erroConsulta = true;
                }

                $scope.enviarEspera = function () {
                    $scope.emEspera = true;
                    $scope.foraEspera = false;
                    AtendimentoService.iniciarEspera();
                };

                $scope.sairEspera = function () {
                    $scope.emEspera = false;
                    $scope.foraEspera = true;
                    AtendimentoService.terminarEspera();
                };

                $scope.$on('$destroy', function () {
                    try {
                        if (timerReconexao) {
                            clearTimeout(timerReconexao)
                        }
                    } catch (err) {

                    }

                    try {
                        if ($scope.atendimentoConfiguracao.DeslogarRamal)
                            AtendimentoService.terminar();
                    } catch (err) {

                    }

                    document.removeEventListener("visibilitychange", function () { });
                });

                $rootScope.$on(AUTH_EVENTS.userLogoutRamal, function () {
                    AtendimentoService.terminar();
                });


                $scope.downloadAudio = function (ligacao) {
                    try {
                        FileDownloadService.downloadWebApiFile("Ligacao/Download/" + ligacao.GlobalId);
                    } catch (err) {
                        NotifyService.showError(err);
                    }
                };

                $scope.downloadAudioPorAtendimento = function (atendimento) {
                    try {
                        FileDownloadService.downloadWebApiFile("Ligacao/Download/" + atendimento.GlobalId);
                    } catch (err) {
                        NotifyService.showError(err);
                    }
                };

                function updateList(list) {
                    $scope.ligacoes = list;
                }

                $scope.listarRamais = function (isRefresh) {
                    $scope.isRamalLoading = true;
                    RamalSupervisaoResource.getSimples().$promise
                        .then(response => {
                            $scope.isRamalLoading = false;
                            $scope.ramais = response;

                            if (!isRefresh) {
                                $scope.transferencia.Telefone = '';
                                $scope.filtrarRamais({ GrupoId: 0 });
                            }
                        }).catch(() => {
                            $scope.isRamalLoading = false;
                        });
                }

                $scope.filtrarRamais = function (grupo) {
                    if ($scope.emConsulta || $scope.isRamalLoading) return;

                    $scope.grupoSelecionado = grupo.GrupoId;
                    $scope.transferencia.Ramal = grupo.RamalNumero;

                    if (!$scope.permissaoTransferenciaRamal) {
                        $scope.ramalByGrupo = [];
                    } else {
                        $scope.ramalByGrupo = (grupo.GrupoId == 0) ? $scope.ramais : _.filter($scope.ramais, item => item.Grupos.indexOf(grupo.GrupoId) >= 0);
                    }

                    grupo.RamalNumero ? $scope.transferencia.Telefone = grupo.RamalNumero : $scope.transferencia.Telefone = '';
                }

                $scope.filtrarServicos = function (grupo) {
                    if ($scope.emConsulta || $scope.isRamalLoading) return;

                    $scope.transferencia.Telefone = '';
                    $scope.grupoSelecionado = grupo.GrupoId;
                    //$scope.transferencia.Ramal = grupo.RamalNumero;
                    $scope.servicos = $scope.servicosBase.filter(servico => servico.GrupoRamal.GrupoId == grupo.GrupoId);
                }

                $scope.selecionarServico = function (servico) {
                    $scope.transferencia.Telefone = servico.NumeroTransferencia;
                    $scope.servicoSelecionado = servico.Descricao;
                }

                $scope.onChangeTipoTransferencia = function (tipo) {
                    try {
                        if ($scope.emConsulta) return;

                        $scope.tipoTransferencia = tipo;

                        switch (tipo) {
                            case 2: // Ramal
                                $scope.filtroTransferencia = '';
                                $scope.transferencia.Ramal = '';
                                $scope.filtrarRamais({ GrupoId: 0 });
                                $scope.servicoTransferenciaTipoId = 1;
                                break
                            case 1: // Externo
                                $scope.transferencia.Telefone = '';
                                $scope.transferencia.Ramal = '';
                                $scope.servicoTransferenciaTipoChange(2);
                                break;
                        }
                    } catch (ex) {
                        // eslint-disable-next-line no-console
                        $scope.consoleError(ex);
                    }
                }

                $scope.onSelectRamal = function (ramal) {
                    try {
                        if ($scope.emConsulta) return;

                        if ($scope.transferencia.Telefone == ramal) {
                            $scope.transferencia.Telefone = '';
                            return;
                        }

                        $scope.transferencia.Telefone = ramal;
                        $scope.transferencia.Ramal = '';
                    } catch (ex) {
                        // eslint-disable-next-line no-console
                        $scope.consoleError(ex);
                    }
                }

                $scope.onKeyUpDiscarNumero = function (event) {

                    if (event.keyCode === 13) {
                        $scope.onCallNumeroDiscador();
                        return true;
                    } else {
                        $scope.discadorInterno = ($scope.numeroDiscador.length <= 5);
                        return false;
                    }
                }

                $scope.listarTabulacoesIncompletas = function () {
                    let modal = UIkit.modal("#modalTabulacoesIncompletas");
                    modal.options.modal = false;
                    ModalService.openModal('modalTabulacoesIncompletas');
                }

                $scope.discarNumero = function () {
                    $scope.statusDiscagem = 0;
                    $scope.numeroDiscador = '';
                    $scope.codigoCliente = '';
                    $scope.rotaDiscador = null;
                    $scope.discadorInterno = false;
                    $scope.mostrarDiscador = false;
                    $scope.msgBlacklist = false;
                    ModalService.openModal('modalTabulacaoDiscador');
                    angular.element(document.querySelector("#modalTabulacaoDiscadorTop")).css("top", "200px")
                };

                $scope.onSelectNumeroDiscador = function (numero) {
                    let numDiscador = document.querySelector('#numeroDiscador');

                    if (numero != '') {
                        let str = ($scope.numeroDiscador !== undefined) ? $scope.numeroDiscador : numDiscador.val();
                        $scope.numeroDiscador = str.substring(0, numDiscador.selectionStart) + numero + str.substring(numDiscador.selectionEnd);
                        //var pos = numDiscador.selectionStart + 1;
                        //numDiscador.setSelectionRange(pos, pos);
                        numDiscador.focus();
                    }

                    $scope.discadorInterno = ($scope.numeroDiscador.length <= 5);
                }

                $scope.onSelectNumeroTeclado = function (numero) {
                    let num = document.querySelector('#numeroTeclado');
                    if (numero != '') {
                        let str = ($scope.numeroTeclado !== undefined) ? $scope.numeroTeclado : num.val();
                        $scope.numeroTeclado = str.substring(0, num.selectionStart) + numero + str.substring(num.selectionEnd);
                        num.focus();
                        if ($scope.chamadaAtiva) {
                            AtendimentoService.enviaDigitosDtmf(numero).catch(function (erro) {
                                $scope.exibirMensagem(erro.message, "danger");
                            });
                        }
                    }
                }


                $scope.onClearNumeroDiscador = function () {
                    $scope.numeroDiscador = '';
                    $scope.rotaDiscador = null;
                    $scope.discadorInterno = false;
                    $scope.codigoCliente = '';
                    //$scope.mostrarDiscador = false;
                    $scope.msgBlacklist = false;
                    document.querySelector('#numeroDiscador').focus();
                }

                $scope.onCallNumeroDiscador = function () {
                    $scope.msgBlacklist = false;
                    $scope.Direcao = 1; //Sainte 
                    if ($scope.numeroDiscador && $scope.numeroDiscador != '') {
                        BlacklistItemResource.VerificaNumeroExisteBlacklist({ 'numero': $scope.numeroDiscador, 'ramalId': $scope.usuario.RamalId }).$promise
                            .then(data => {
                                $scope.msgBlacklist = data.retorno;
                                if (!data.retorno) {
                                    $scope.statusDiscagem = 1;
                                    let tipo = $scope.discadorInterno ? 2 : 1;

                                    if ($scope.rotaDiscador) {
                                        AtendimentoService.discarRota($scope.numeroDiscador, $scope.rotaDiscador);
                                    } else {
                                        AtendimentoService.discar($scope.numeroDiscador, tipo);
                                    }

                                    $scope.ativarDiscagemManual();
                                }
                            });
                    }
                }
                $scope.listarRamais(false);

                if ($scope.usuario.AtendimentoConfiguracaoId != 1) {
                    $scope.showModalConexao();
                }

                $scope.copyToClipboard = function (element) {
                    let $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($(element).text()).select();
                    document.execCommand("copy");
                    $temp.remove();
                }

                function getPermissoesByLayouId(layoutId) {
                    if (layoutId > 0) {
                        let permissao = permissoesLayout.find(x => x.Id == layoutId);
                        if (permissao !== null) return permissao.PermissoesCampo
                        else return permissoesDefault
                    } else return permissoesDefault;
                }


                $scope.openModalLigacoesRecebidas = function () {
                    ModalService.openModal('modal_ligacoes_recebidas');
                }

                $scope.listTabulacao = [];

                $scope.showModalRelatorioTabulacao = function () {
                    buscarHistoricoTabulacao($scope.modelCliente, $scope.modelTelefone);
                    var model = UIkit.modal("#modalRelatorioTabulacao");
                    model.show();
                }

                function buscarHistoricoTabulacao(cliente, telefone) {

                    if (!cliente) {
                        cliente = '';
                    }

                    if (!telefone) {
                        telefone = '';
                    }

                    $scope.listTabulacao = [];
                    TabulacaoResource
                        .GetTabulacaoPorRamal({ 'cliente': cliente, 'telefone': telefone })
                        .$promise
                        .then((data) => {
                            $scope.listTabulacao = data;
                        }).catch((e) => {
                            $scope.consoleInfo(e);
                            NotifyService.showError('telaTabulador.erroAoSalvarContatoReceptivo');
                            $scope.salvandoContato = false;
                        });
                }

                $scope.buscarRelatorioTabulacao = function () {

                    buscarHistoricoTabulacao($scope.modelCliente, $scope.modelTelefone);
                }

                function tabulacaoLigacaoManual(ramal, reenvio) {

                    $scope.emTabulacao = true;

                    ModalService.closeModal('modalTabulacaoDiscador');
                    if ($scope.infoRing.ativo) {
                        $scope.hideModalRing();
                    }

                    if ($scope.intervaloSelecionado == $scope.configuracao.IntervaloLivre || $scope.intervaloSelecionado == INTERVALO_EMLIGACAO) {
                        $scope.intervaloSelecionado = $scope.configuracao.IntervaloNaoDisponivel;
                        $scope.alterarIntervaloHub($scope.configuracao.IntervaloNaoDisponivel);
                    }

                    $scope.finalizarProcessamento();

                    if ($scope.chamada.TipoDiscagem != 6) {
                        $scope.exibirContato();
                        $scope.dadosRamal = ramal;
                        $scope.exibirTabulacao();
                        $scope.desativarBotoesTabulacao();
                        $scope.podeRealizarTimeout = true;
                        $scope.iniciarTabulacao();
                        $scope.chamadaAtiva = true;
                        $scope.exibirEnvioSMS = false;

                        //getTabulacoes();
                        //getLigacoes();
                        getCamposTabulacao(reenvio);
                    } else {
                        $scope.chamadaAtiva = true;
                        ModalService.alert('telaTabulador.voceEstaSendoConsultadoPor', { 'Identificacao': (chamada.NomeRamal || chamada.Telefone) })
                    }
                }
                $scope.atualizarServicosTransferencia = function () {

                    if ($scope.atendimentoConfiguracao.ListarPesquisasServico) {
                        if ($scope.chamada != null) {
                            if ($scope.chamada.DDRLocal != null)
                                $scope.servicos = $scope.servicoListChamada;
                        } else
                            $scope.servicos = $scope.servicosList;
                    } else
                        $scope.servicos = $scope.servicosList;
                };


                $scope.getUraPesquisaSatisfacaoAssociada = function (servicoNumero) {
                    $scope.servicoListChamada = [];
                    TabulacaoResource.GetServicosTransferencia({ servicoNumero: servicoNumero }).$promise.then((data) => {
                        $scope.servicos = data;
                        $scope.servicoListChamada = data;
                    });
                };

                $scope.Pesquisa = {};
                $scope.validacao = {};
                $scope.MensagemPesquisa = false;
                $scope.loadAvaliacao = function () {

                    if ($scope.Pesquisa.Id)
                        PesquisaAvaliacaoResource.listarPerguntasPorPesquisaId({ pesquisaId: $scope.Pesquisa.Id }).$promise
                            .then((data) => {
                                MensagemPesquisaRespondida();
                                $scope.perguntasList = data;
                                angular.forEach($scope.perguntasList, function (item) {
                                    item.desabilitar = false;
                                });

                                $scope.carregaPequisaCategoriaItens($scope.Pesquisa.Id);
                                $scope.validacao = {};
                                $scope.isCategoria = true;
                            }).catch(NotifyService.showError);
                };


                $scope.carregaPequisaCategoriaItens = function (pesquisaId) {
                    PesquisaCategoriaResource.GetPesquisaCategoriaItemByPesquisaId({ pesquisaId: pesquisaId }).$promise
                        .then((data) => {
                            $scope.pesquisaCategoriaItens = data;
                        }).catch(NotifyService.showError);

                }

                function MensagemPesquisaRespondida() {
                    PesquisaAvaliacaoResource.PerguntasResposta({ pesquisaId: $scope.Pesquisa.Id, globalId: $scope.chamada.GlobalId }).$promise
                        .then((data) => {

                            if (data.length > 0)
                                $scope.MensagemPesquisa = true;
                            else
                                $scope.MensagemPesquisa = false;

                        }).catch(NotifyService.showError);;
                }

                function carregaPesquisas(grupoId) {
                    $scope.Pesquisa.Id = null;
                    $scope.pesquisasSearchList = [];
                    PesquisaAvaliacaoResource.pesquisaAvaliacaoPesquisas({ grupoId: grupoId }).$promise
                        .then((data) => $scope.pesquisasSearchList = data)
                        .catch(NotifyService.showError);
                };

                $scope.showModalAvaliacao = function () {
                    ModalService.openModal('modal_avaliacao', null, function () { carregaPesquisas($scope.usuario.Ramal.GrupoId); });
                };

                $scope.salvarPesquisaResposta = function (form) {

                    if (!form.$valid) {
                        form.$setSubmitted();
                        return NotifyService.showInvalid();
                    }

                    let avaliacoes = [];

                    var observacoes = [];

                    _.each($scope.perguntasList, function (pergunta) {
                        if (pergunta.desabilitar == false) {
                            //$scope.validacaoCampo(pergunta);
                            _.each(pergunta.Alternativas, function (alternativa) {
                                if (alternativa.RespostaCheck) {
                                    if (alternativa.Outros) {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Texto: pergunta.RespostaText
                                        });
                                    } else {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso
                                        });
                                    }
                                }
                                if (alternativa.RespostaRadio && alternativa.Selecionada) {
                                    if (alternativa.Outros) {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso,
                                            Texto: pergunta.RespostaText
                                        });
                                    } else {
                                        avaliacoes.push({
                                            BilheteId: $scope.BilheteId,
                                            PerguntaId: pergunta.Id,
                                            AlternativaId: alternativa.Id,
                                            PesoAlternativa: alternativa.Peso,
                                            PesoPergunta: pergunta.Peso
                                        });
                                    }
                                }
                            });
                        }

                        if (pergunta.TipoId == 3 && pergunta.RespostaText) {
                            avaliacoes.push({
                                BilheteId: $scope.BilheteId,
                                PerguntaId: pergunta.Id,
                                PesoAlternativa: 0, //pergunta.Peso,
                                Texto: pergunta.RespostaText
                            });
                        }

                        if (pergunta.Observacao) {
                            observacoes.push({
                                PesquisaPerguntaId: pergunta.Id,
                                GlobalId: $scope.chamada.GlobalId,
                                Descricao: pergunta.ObservacaoText
                            });
                        }
                    });

                    let dados = {
                        //BilheteId: $scope.bilhete.BilheteId,
                        UsuarioAvaliado: $scope.usuario.UsuarioId,
                        Avaliacoes: avaliacoes,
                        GlobalId: $scope.chamada.GlobalId,
                        Observacoes: observacoes,
                        PesquisaCategoriaItemId: $scope.pesquisaCategoriaItem.PesquisaCategoriaItemId
                    };

                    let valido = true;

                    angular.forEach($scope.validacao, function (item) {
                        if (!item) {
                            valido = false;
                        }
                    });

                    if (!valido) {
                        return;
                    }

                    PesquisaAvaliacaoResource.avaliarPesquisa(dados).$promise
                        .then(() => {
                            NotifyService.showRegistroSalvo();
                            $scope.MensagemPesquisa = false;
                            $scope.perguntasList = [];
                            ModalService.closeModal('modal_avaliacao');
                        }).catch(NotifyService.showError);
                }

                $scope.validacaoCampo = function (pergunta, alternativaSelecionada) {
                    $scope.validacao["Pergunta_" + pergunta.Id] = false;

                    if (alternativaSelecionada != null) {
                        if (alternativaSelecionada.Outros) {
                            const indexPergunta = $scope.perguntasList.findIndex(i => i.Id === pergunta.Id);
                            const alternativaOutros = _.findWhere($scope.perguntasList[indexPergunta].Alternativas, { Outros: true });
                            if (alternativaOutros != null)
                                alternativaOutros.HabilitarTexto = true;
                        }
                        else {
                            const indexPergunta = $scope.perguntasList.findIndex(i => i.Id === pergunta.Id);
                            const alternativaOutros = _.findWhere($scope.perguntasList[indexPergunta].Alternativas, { Outros: true });
                            if (alternativaOutros != null)
                                alternativaOutros.HabilitarTexto = false;
                        }
                    }

                    if (pergunta.TipoId == 1) {
                        _.each(pergunta.Alternativas, function (alternativa) {
                            if (alternativa.RespostaCheck) {
                                $scope.validacao["Pergunta_" + pergunta.Id] = true;
                            }
                        });
                    }
                    else if (pergunta.TipoId == 2) {
                        _.each(pergunta.Alternativas, function (alternativa) {
                            if (parseInt(alternativa.RespostaRadio) == parseInt(alternativaSelecionada.RespostaRadio)) {
                                $scope.validacao["Pergunta_" + pergunta.Id] = true;
                                alternativa.Selecionada = true;
                            } else {
                                alternativa.Selecionada = false;
                            }
                        });
                    } else {
                        $scope.validacao["Pergunta_" + pergunta.Id] = true;
                    }

                    //Para os tipos multipla escolha e alternativa verificar se precisa desabilitar outras perguntas com base na resposta
                    if (pergunta.TipoId == 2 || pergunta.TipoId == 1) {
                        if (alternativaSelecionada != null) {
                            angular.forEach($scope.perguntasList, function (item) {
                                var perguntaSelecionada = $scope.perguntasList.filter(function (item) {
                                    return item.Id == alternativaSelecionada.PesquisaPerguntaId;
                                })[0];

                                if (perguntaSelecionada.BaseResposta) {
                                    if (item.Ordem > perguntaSelecionada.Ordem) {
                                        item.desabilitar = false;

                                        /* if (item.TipoId == 1) {
                                            angular.forEach(item.Alternativas, function (alternativa) {
                                                alternativa.RespostaCheck = false;
                                            });
                                        }
        
                                        if (item.TipoId == 2) {
                                            angular.forEach(item.Alternativas, function (alternativa) {
                                                alternativa.RespostaRadio = false;
                                            });
                                        }
        
                                        if (item.TipoId == 3) {
                                            item.RespostaText = '';
                                        } */

                                    }
                                }


                                if (alternativaSelecionada.BaseRespostaId > 1
                                    && item.Ordem < (alternativaSelecionada.BaseRespostaId - 1)
                                    && item.Ordem > perguntaSelecionada.Ordem
                                    && item.Id != alternativaSelecionada.PesquisaPerguntaId
                                ) {
                                    item.desabilitar = true;

                                }
                            });
                        }
                    }
                };

                //Inicio Conferencia

                $scope.tipoConferencia = 2;
                $scope.filtroConferencia = '';
                $scope.ramaisConferencia = [];
                $scope.grupoConferenciaSelecionado = 0;
                $scope.isRamalConferenciaLoading = false;

                $scope.abrirModalConferencia = function () {
                    ModalService.isHidden('modal_conferencia', function () {
                        $scope.conferencia = { Telefone: '', Ramal: '' };
                        $scope.tipoConferencia = 2;
                        $scope.filtroConferencia = '';
                        $scope.grupoConferenciaSelecionado = 0;

                        if (!$scope.isConferenciaEmAndamento) {
                            $scope.participantes = [];

                            if ($scope.chamada && $scope.chamada.Telefone && $scope.chamadaAtiva) {
                                var telefoneChamada = $scope.chamada.Telefone;
                                $scope.participantes.push({
                                    Numero: String(telefoneChamada),
                                    Status: $translate.instant('telaTabulador.atendido'),
                                    TempoIniciado: 0,
                                    Virtual: true
                                });
                            }
                        }

                        $scope.listarRamaisConferencia();
                    });
                };

                $scope.onChangeTipoConferencia = function (tipo) {
                    $scope.tipoConferencia = tipo;
                    $scope.conferencia.Telefone = '';
                };

                $scope.listarRamaisConferencia = function () {
                    $scope.isRamalConferenciaLoading = true;
                    RamalSupervisaoResource.getSimples().$promise
                        .then(function (response) {
                            $scope.isRamalConferenciaLoading = false;
                            $scope.ramaisConferenciaBase = _.filter(response, function (ramal) {
                                return ramal.Status !== 'Não Logado';
                            });
                            $scope.filtrarRamaisConferencia({ GrupoId: 0 });
                        }).catch(function () {
                            $scope.isRamalConferenciaLoading = false;
                        });
                };

                $scope.filtrarRamaisConferencia = function (grupo) {
                    $scope.grupoConferenciaSelecionado = grupo.GrupoId;
                    $scope.ramaisConferencia = (grupo.GrupoId == 0)
                        ? $scope.ramaisConferenciaBase
                        : _.filter($scope.ramaisConferenciaBase, function (item) { return item.Grupos.indexOf(grupo.GrupoId) >= 0; });
                };

                $scope.onSelectRamalConferencia = function (numero) {
                    $scope.conferencia.Telefone = ($scope.conferencia.Telefone == numero) ? '' : numero;
                };

                $scope.onAdicionarParticipante = function () {
                    let telefone = $scope.conferencia.Telefone;

                    if (!telefone) return false;

                    const existe = _.filter($scope.participantes, function (el) {
                        return el.Numero == telefone;
                    });

                    if (existe.length == 1) {
                        $scope.exibirMensagem('telaTabulador.numeroJaAdicionadoNaConferencia', 'danger');
                        return;
                    }

                    const participante = { Numero: String(telefone), Status: $translate.instant('telaTabulador.aguardando'), TempoIniciado: $scope.tempoConferencia };

                    $scope.participantes.push(participante);

                    var tipoDiscagem = String(telefone).length <= 5 ? 2 : 1;

                    if (!$scope.isConferenciaEmAndamento) {
                        $scope.iniciarTimerStatusConferencia();
                        AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                        AtendimentoService.conferenciaIniciar();
                        $scope.isConferenciaEmAndamento = true;
                    } else {
                        AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                    }

                    $scope.conferencia.Telefone = '';
                }

                $scope.tempoConferencia = 0;

                $scope.iniciarTimerStatusConferencia = function () {
                    $scope.tempoConferencia = 0;
                    $scope.timerConferencia = $interval(function () {
                        $scope.tempoConferencia += 1;
                    }, 1000);
                };

                $scope.pararTimerStatusConferencia = function () {
                    $scope.tempoConferencia = 0;
                    $interval.cancel($scope.timerConferencia);
                };

                $scope.finalizarConferencia = function () {
                    $scope.participantes = [];
                    $scope.isConferenciaEmAndamento = false;
                    $scope.chamadaAtiva = false;
                    $scope.pararTimerStatusConferencia();
                    AtendimentoService.conferenciaTerminar();
                    ModalService.closeModal('modal_conferencia');
                    ModalService.closeModal('modal_conferencia_inicio');
                }

                // Conferência desde o início (fluxo Atendimento)
                $scope.tipoConferenciaInicio = 2;

                $scope.abrirModalConferenciaInicio = function () {
                    ModalService.closeModal('modalTabulacaoDiscador');
                    ModalService.isHidden('modal_conferencia_inicio', function () {
                        $scope.conferencia = { Telefone: '', Ramal: '' };
                        $scope.tipoConferenciaInicio = 2;
                        $scope.filtroConferencia = '';
                        $scope.grupoConferenciaSelecionado = 0;

                        if (!$scope.isConferenciaEmAndamento) {
                            $scope.participantes = [];
                        }

                        $scope.listarRamaisConferencia();
                    });
                };

                $scope.onAdicionarParticipanteInicio = function () {
                    var telefone = $scope.conferencia.Telefone;
                    if (!telefone) return;

                    var existe = _.filter($scope.participantes, function (el) {
                        return el.Numero == telefone;
                    });

                    if (existe.length == 1) {
                        $scope.exibirMensagem('telaTabulador.numeroJaAdicionadoNaConferencia', 'danger');
                        return;
                    }

                    var tipoDiscagem = String(telefone).length <= 5 ? 2 : 1;
                    var participante = { Numero: String(telefone), Status: $translate.instant('telaTabulador.aguardando'), TempoIniciado: $scope.tempoConferencia };

                    $scope.participantes.push(participante);
                    AtendimentoService.conferenciaAdicionar(participante.Numero, tipoDiscagem);
                    $scope.conferencia.Telefone = '';
                };

                $scope.iniciarConferenciaInicio = function () {
                    if ($scope.participantes.length === 0) return;

                    $scope.iniciarTimerStatusConferencia();
                    $scope.isConferenciaEmAndamento = true;
                    $scope.chamadaAtiva = true;
                    AtendimentoService.conferenciaIniciar();
                };

                $scope.finalizarConferenciaInicio = function () {
                    $scope.participantes = [];
                    $scope.isConferenciaEmAndamento = false;
                    $scope.chamadaAtiva = false;
                    $scope.pararTimerStatusConferencia();
                    AtendimentoService.conferenciaTerminar();
                    ModalService.closeModal('modal_conferencia_inicio');
                };

                $scope.preencheParticipantes = function preencheParticipantes(chamada) {
                    $scope.participantes = [];
                    var user = AuthService.getUsuarioLogado();

                    var telefoneChamadaInicial = chamada.ChamadaAtiva.Telefone;

                    // if($scope.dddPadrao == $scope.retirarDDD($scope.chamada.Telefone))
                    //     telefoneParticipante = $scope.retirarNumero($scope.chamada.Telefone);

                    var listaConferencia = chamada.Conferencia.Chamadas;

                    let removerRamal = listaConferencia.find(l => l.Telefone == user.RamalNumero);
                    let indexRamal = listaConferencia.indexOf(removerRamal);
                    listaConferencia.splice(indexRamal, 1);

                    let removerCliente = listaConferencia.find(l => l.Telefone.includes(telefoneChamadaInicial));
                    let indexCliente = listaConferencia.indexOf(removerCliente);
                    listaConferencia.splice(indexCliente, 1);

                    var chamadas = _.filter(listaConferencia, function (chamada) {
                        return chamada.Telefone != user.RamalNumero || telefoneChamadaInicial;
                    });

                    chamadas.forEach(function (chamada) {
                        var participante = { Numero: String(chamada.Telefone), Status: $translate.instant('telaTabulador.ligacao'), TempoIniciado: 0 };
                        $scope.participantes.push(participante);
                    });
                }

                $scope.onRemoverConferencia = function (numero) {
                    if (!numero) return;

                    var participante = _.findWhere($scope.participantes, { Numero: numero });
                    if (participante && participante.Virtual) return;

                    if ($scope.isConferenciaEmAndamento) {
                        AtendimentoService.conferenciaRemover(numero);
                    }

                    $scope.participantes = _.without($scope.participantes, participante);
                }

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaChamadaEncerrada, function (event, data, error) {
                    $scope.participantes.forEach(function (participante) {
                        if (participante.Numero.includes(error.Telefone) || error.Telefone.includes(participante.Numero)) {
                            participante.Status = $translate.instant('telaTabulador.encerrado');
                        }
                    });

                    $scope.participantes = _.filter($scope.participantes, function (participante) {
                        return participante.Status !== $translate.instant('telaTabulador.encerrado');
                    });

                    if ($scope.participantes.length === 0) {
                        $scope.finalizarConferencia();
                    }
                });

                $scope.$on(ATENDIMENTO_EVENTS.Conferencia_OnAtendido, function (event, data, error) {
                    var participante = _.filter($scope.participantes, function (chamada) {
                        return error.Telefone.includes(chamada.Numero);
                    });

                    if (participante.length == 1) {
                        participante[0].TempoIniciado = $scope.tempoConferencia;
                        participante[0].Status = $translate.instant('telaTabulador.atendido');
                    }

                });

                $scope.$on(ATENDIMENTO_EVENTS.Conferencia_OnDisca, function (event, data, error) {
                    var participante = _.filter($scope.participantes, function (chamada) {
                        return error.Telefone.includes(chamada.Numero);
                    });

                    if (participante.length == 1)
                        participante[0].Status = $translate.instant('telaTabulador.discando');
                });

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaTermino, function () {
                    $scope.isConferenciaEmAndamento = false;
                    $scope.chamadaAtiva = false;
                    $scope.pararTimerStatusConferencia();
                });

                $scope.$on(ATENDIMENTO_EVENTS.onConferenciaErro, function () {
                    $scope.exibirMensagem('telaTabulador.erroNaConferencia', "danger");
                });

                //Novo Contato           

                $scope.abrirModalNovoContato = function () {
                    ModalService.isHidden('modal_novoContato', function () {

                        let codigoCliente = $scope.chamada.CodigoCliente;
                        let nomeCliente = $scope.chamada.NomeCliente;

                        $scope.NovoCodigoCliente = { Nome: "CodigoCliente", Alias: "Cod. Cliente", Valor: codigoCliente }
                        $scope.NovoDDD = { Nome: "DDD", Alias: "DDD", Valor: undefined }
                        $scope.NovoTelefone = { Nome: "Telefone", Alias: "Telefone", Valor: undefined }
                        $scope.NovoNomeCliente = { Nome: "NomeCliente", Alias: "Cliente", Valor: nomeCliente }
                        $scope.NovoDetalhe = { Nome: "Detalhe", Alias: "Detalhe", Valor: undefined }

                        $scope.isMesmoCliente = true;
                    });
                };

                function generateUUID() {
                    let d = new Date().getTime();
                    let uuid = 'xxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        let r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                    });
                    return uuid;
                }


                $scope.changeNovoContato = function (value) {
                    $scope.isMesmoCliente = value;

                    if ($scope.isMesmoCliente)
                        $scope.NovoCodigoCliente.Valor = $scope.chamada.CodigoCliente;
                    else
                        $scope.NovoCodigoCliente.Valor = undefined;
                }

                $scope.postNovoContato = function (form) {
                    if (form.$valid) {
                        $scope.novoContato = [];
                        let codigoCliente = generateUUID();

                        if (!$scope.isMesmoCliente)
                            $scope.NovoCodigoCliente.Valor = codigoCliente + '_' + $scope.NovoCodigoCliente.Valor;

                        $scope.novoContato.push($scope.NovoCodigoCliente);
                        $scope.novoContato.push($scope.NovoDDD);
                        $scope.novoContato.push($scope.NovoTelefone);
                        $scope.novoContato.push($scope.NovoNomeCliente);
                        $scope.novoContato.push($scope.NovoDetalhe);

                        CampanhaArquivoResource.novoContato({ CampanhaId: $scope.chamada.CodigoCampanha, AtendimentoIntegracaoId: $scope.templateMiner.AtendimentoIntegracaoTemplateId, ListaMinerId: $scope.templateMiner.ListaMinerId }, $scope.novoContato).$promise
                            .then(() => {
                                NotifyService.showSuccess('telaTabulador.novoContatoSucesso');
                                ModalService.closeModal('modal_novoContato');
                                $scope.templateMiner = { AtendimentoIntegracaoTemplateId: 0, ListaMinerId: 0 };
                            });
                    }
                };

                //DISCAGEM PREVIEW

                $scope.carregarDadosUraTalkBotPreview = function () {
                    var atendimentoLayout = {};
                    TabulacaoResource.GetCampos({
                        CampanhaId: $scope.chamadaPreview.CodigoCampanha || 0,
                        Direcao: 1,
                        NA: ""
                    }).$promise
                        .then((dados) => {
                            if (dados && dados.length > 0) {
                                var atendimentoLayoutId = dados[0].AtendimentoLayoutId;

                                getInfoLayoutById(atendimentoLayoutId).then(atendimentoLayout => {
                                    atendimentoLayout = atendimentoLayout;

                                    if (atendimentoLayout) {
                                        if ($scope.chamadaPreview) {
                                            if (atendimentoLayout.HabilitarInformacoesUraTalkBot) {
                                                $scope.detalhamentoUra = [];
                                                AtendimentoIntegracaoResource.consultarByGlobalId({
                                                    globalId: $scope.chamadaPreview.GlobalId || '',
                                                    Telefone: $scope.chamadaPreview.Telefone || '',
                                                    Cliente: $scope.chamadaPreview.CodigoCliente || '',
                                                    InfoAdicional1: $scope.chamadaPreview.InfoAdicional1 || '',
                                                    InfoAdicional2: $scope.chamadaPreview.InfoAdicional2 || '',
                                                    InfoAdicional3: $scope.chamadaPreview.InfoAdicional3 || '',
                                                    InfoAdicional4: $scope.chamadaPreview.InfoAdicional4 || '',
                                                    InfoAdicional5: $scope.chamadaPreview.InfoAdicional5 || '',
                                                    templateId: atendimentoLayout.AtendimentoIntegracaoTemplateId
                                                }).$promise.then(function (result) {
                                                    if (result) {

                                                        if (atendimentoLayout.AtendimentoIntegracaoTemplateId != null) {
                                                            IntegracaoResource.GetId({ Id: atendimentoLayout.AtendimentoIntegracaoTemplateId }).$promise.then(camposIntegracao => {
                                                                $scope.ListCamposIntegracao = camposIntegracao.AtendimentoIntegracaoTemplateCampo;

                                                                let seletor = $scope.ListCamposIntegracao[0].Seletor.split("[0].");

                                                                if (seletor.length > 0)
                                                                    $scope.detalhamentoUra = result[seletor[0]]
                                                                else
                                                                    $scope.detalhamentoUra = result

                                                                let campoAgrupamento = '';
                                                                let campo = $scope.ListCamposIntegracao.find(x => x.Identificador);

                                                                if (campo) {
                                                                    campoAgrupamento = campo.Seletor.split("[0].")[1]
                                                                } else {
                                                                    campoAgrupamento = seletor[1]
                                                                }

                                                                //Agrupamentos dos dados 
                                                                var groupResult = _.groupBy($scope.detalhamentoUra, campoAgrupamento);
                                                                $scope.detalhamentoUra = [];
                                                                Object.entries(groupResult).forEach(x => { $scope.detalhamentoUra.push(x[1][0]); })

                                                                $scope.detalhamentoUra.forEach(function (values) {
                                                                    if (values.hasOwnProperty(campoAgrupamento)) {
                                                                        var agrupamento = values[campoAgrupamento];

                                                                        if (agrupamento != undefined)
                                                                            values.Agrupamento = agrupamento;
                                                                    }
                                                                });

                                                                $scope.selecaoTabReceptiva = 4;

                                                            }).catch(error => {
                                                                NotifyService.showError(error);
                                                            });
                                                        }


                                                    }
                                                });
                                            }
                                        }
                                    }
                                });
                            }


                        }).catch(() => {
                            NotifyService.showError();
                            ModalService.hideLoading();
                        });
                };

                var ativarDiscagemPreview = function () {
                    $scope.isDiscagemPreview = true;
                    localStorage.removeItem('discagem_Preview');
                    localStorage.setItem('discagem_Preview', $scope.isDiscagemPreview);
                    getCarregarDiscagemPreview();
                }

                var desativarDiscagemPreview = function () {
                    $scope.isDiscagemPreview = false;
                    $scope.isCarregarDiscagemPreview = false;
                    $scope.discagemPreviewSemDados = false;
                    $scope.chamadaPreviewAtiva = false;
                    $scope.chamadaPreviewTabulacaoAtiva = false;
                    $scope.modalConsultaContaoPreview = false;
                    $scope.chamadaPreview = {};
                    $scope.contatosDiscagemPreview = [];
                    $scope.consultaContatosPreviewList = [];
                    $scope.discagemPreview = [];
                    $scope.discagemPreviewList = [];
                    localStorage.removeItem('discagem_Preview');
                    localStorage.setItem('discagem_Preview', $scope.isDiscagemPreview);
                }

                var clearDiscagemPreviewSemDados = function () {
                    $scope.discagemPreviewSemDados = true;
                    $scope.isCarregarDiscagemPreview = false;
                    $scope.chamadaPreviewAtiva = false;
                    $scope.discagemPreview = {};
                    $scope.discagemPreviewList = [];
                    $scope.chamadaPreview = {};
                };

                var clearChamadaPreview = function () {
                    $scope.chamadaPreviewTabulacaoAtiva = false;
                    $scope.chamadaPreviewAtiva = false;
                    $scope.chamadaPreview = {};
                    $scope.detalhamentoUra = [];
                };

                var recarregarDiscagemPreview = function () {
                    if ($scope.isDiscagemPreview == true) {
                        if ($scope.discagemPreviewSemDados == true) {
                            if ($scope.discagemPreviewList.length == 0 && $scope.discagemPreview.CampanhaId == undefined) {
                                getCarregarDiscagemPreview();
                            }
                        }
                    }
                };

                var getCarregarDiscagemPreview = function () {
                    CampanhaDiscagemResource.getCampanhaDiscagemPreview()
                        .$promise
                        .then((dados) => {
                            if (dados != null && dados.length > 0) {
                                $scope.discagemPreviewList = dados;
                                $scope.discagemPreview = $scope.discagemPreviewList[0];
                                $scope.discagemPreviewList.shift();
                                $scope.discagemPreviewList = $scope.discagemPreviewList;
                                carregarInformacoesCliente();
                                $scope.isCarregarDiscagemPreview = true;
                                $scope.discagemPreviewSemDados = false;
                                $scope.esconderMensagem();
                            } else {
                                $scope.discagemPreviewSemDados = true;
                                $scope.exibirMensagem('telaTabulador.naoExistsContatosPreview', 'info');
                                clearDiscagemPreviewSemDados();
                            }
                        }).catch(() => {
                            NotifyService.showError();
                            ModalService.hideLoading();
                        });
                };

                var carregarChamadaPreview = function () {
                    $scope.chamadaPreview = {}

                    if ($scope.chamadaPreview != null) {
                        $scope.chamadaPreview.CodigoCampanha = $scope.discagemPreview.CampanhaId;
                        $scope.chamadaPreview.CodigoCliente = $scope.discagemPreview.CodigoCliente;
                        $scope.chamadaPreview.NomeCliente = $scope.discagemPreview.Nome;
                        $scope.chamadaPreview.Telefone = $scope.discagemPreview.Telefone;
                        $scope.chamadaPreview.NomeCampanha = $scope.discagemPreview.CampanhaNome;
                        $scope.chamadaPreview.InfoAdicional1 = $scope.discagemPreview.InfoAdicional1;
                        $scope.chamadaPreview.InfoAdicional2 = $scope.discagemPreview.InfoAdicional2;
                        $scope.chamadaPreview.InfoAdicional3 = $scope.discagemPreview.InfoAdicional3;
                        $scope.chamadaPreview.InfoAdicional4 = $scope.discagemPreview.InfoAdicional4;
                        $scope.chamadaPreview.InfoAdicional5 = $scope.discagemPreview.InfoAdicional5;
                    }

                    if ($scope.chamada == undefined) $scope.chamada = {};

                    if ($scope.chamada != null) {
                        $scope.chamada.CodigoCampanha = $scope.discagemPreview.CampanhaId;
                        $scope.chamada.CodigoCliente = $scope.discagemPreview.CodigoCliente;
                        $scope.chamada.NomeCliente = $scope.discagemPreview.Nome;
                        $scope.chamada.Telefone = $scope.discagemPreview.Telefone;
                        $scope.chamada.NomeCampanha = $scope.discagemPreview.CampanhaNome;
                        $scope.chamada.InfoAdicional1 = $scope.discagemPreview.InfoAdicional1;
                        $scope.chamada.InfoAdicional2 = $scope.discagemPreview.InfoAdicional2;
                        $scope.chamada.InfoAdicional3 = $scope.discagemPreview.InfoAdicional3;
                        $scope.chamada.InfoAdicional4 = $scope.discagemPreview.InfoAdicional4;
                        $scope.chamada.InfoAdicional5 = $scope.discagemPreview.InfoAdicional5;
                    }
                };

                var getContatoPreviewByCodCliente = function () {
                    $scope.contatosDiscagemPreview = [];
                    if ($scope.discagemPreview.CampanhaId != undefined && $scope.discagemPreview.CampanhaDiscagemId) {
                        CampanhaDiscagemResource.getContatoPreviewByCodCliente({ campanhaId: $scope.discagemPreview.CampanhaId, codigoCliente: $scope.discagemPreview.CodigoCliente, campanhaDiscagemId: $scope.discagemPreview.CampanhaDiscagemId })
                            .$promise
                            .then((dados) => {
                                if (dados != null && dados.length > 0)
                                    $scope.contatosDiscagemPreview = dados;
                                $scope.existsContatosPreview = true;
                                $scope.selecaoTabulacao = 4;
                            }).catch(() => {
                                NotifyService.showError();
                            });
                    }
                };

                $scope.nextCliente = function () {
                    if ($scope.discagemPreviewList != null && $scope.discagemPreviewList.length > 0) {
                        $scope.discagemPreview = $scope.discagemPreviewList[0];
                        $scope.discagemPreviewList.shift();
                        carregarInformacoesCliente();
                    } else {
                        getCarregarDiscagemPreview();
                    }
                };

                $scope.subirFichaPreview = function (contato) {

                    var index = $scope.contatosDiscagemPreview.indexOf(contato);
                    if (index > 0)
                        $scope.contatosDiscagemPreview.splice(index, 1);

                    $scope.discagemPreview = contato;

                    if ($scope.modalConsultaContaoPreview) {
                        ModalService.closeModal('modal_contatoPreview');
                        $scope.consultaContatosPreviewList = [];
                        $scope.modalConsultaContaoPreview = false;

                        $scope.consultaPreviewCliente = '';
                        $scope.consultaPreviewCodigoCliente = '';
                        $scope.consultaPreviewTelefone = '';
                    }
                    CampanhaDiscagemResource.setCampanhaDiscagemRetornoPreview($scope.discagemPreview)
                        .$promise
                        .then((dados) => {
                            $scope.discagemPreview.CampanhaImportacaoId = dados.CampanhaImportacaoId;
                            carregarChamadaPreview();
                        }).catch(() => {
                            NotifyService.showError();
                        });

                    carregarInformacoesCliente();
                };

                $scope.consultaContatosPreview = function () {
                    const nome = $scope.consultaPreviewCliente || '';
                    const codigoCliente = $scope.consultaPreviewCodigoCliente || '';
                    const telefone = $scope.consultaPreviewTelefone || '';

                    CampanhaDiscagemResource.getDiscagemPreviewContato({ nome: nome, codigoCliente: codigoCliente, telefone: telefone })
                        .$promise
                        .then((dados) => {
                            $scope.consultaContatosPreviewList = dados;
                        }).catch(() => {
                            NotifyService.showError();
                        });
                }

                $scope.showModalConsultaContatoPreview = function () {
                    $scope.modalConsultaContaoPreview = true;
                    ModalService.openModal('modal_contatoPreview');
                }
                setInterval(function () {
                    if ($scope.isDiscagemPreview == true)
                        recarregarDiscagemPreview();
                }, 2000);

                $scope.discarPreview = function () {
                    AtendimentoService.discarPreview($scope.discagemPreview);
                    $scope.chamadaPreviewAtiva = true;
                    $scope.exibirMensagem('telaTabulador.discandoStatus', 'info');
                };

                var carregarInformacoesCliente = function () {
                    carregarChamadaPreview();
                    getContatoPreviewByCodCliente();
                    $scope.carregarDadosUraTalkBotPreview();
                }

                $scope.editar = function (tabulacao) {
                    tabulacao.isEdit = false;
                    tabulacao.IsEdit = !tabulacao.IsEdit;
                };

                $scope.editarCodigoCliente = function (tabulacao) {
                    tabulacao.IsEditCodigoCliente = false;
                    tabulacao.IsEditCodigoCliente = !tabulacao.IsEditCodigoCliente;
                };

                //Consulta Contato Miner
                $scope.showModalConsultaContatoMiner = function () {
                    $scope.modalConsultaContaoMiner = true;
                    $scope.consultaMinerCampo = 0;
                    $scope.consultaMinerValor = '';
                    $scope.atendimentoIntegracao = 0;
                    $scope.consultaContatoMinerList = [];
                    ModalService.openModal('modal_contatoMiner');
                }

                $scope.consultaContatoMiner = function (form) {
                    if (form.$valid) {
                        const campo = $scope.consultaMinerCampo || '';
                        const valor = $scope.consultaMinerValor || '';
                        const templateId = $scope.atendimentoIntegracao || '';

                        ModalService.showLoading();

                        let url = Config.getUrl("Atendimento/ContatoMiner/") + campo + "/" + valor + "/" + templateId;

                        return $http({ method: 'GET', url: url })
                            .then((response) => {
                                $scope.consultaContatoMinerList = response.data;
                                ModalService.hideLoading();
                            }).catch((response) => {
                                ModalService.hideLoading();
                                NotifyService.showError(null, response.data.Message);
                            });
                    }
                }

                $scope.subirFichaContatoMiner = function (contato) {

                    $scope.isDiscagemContatoMiner = true;
                    $scope.discagemContatoMiner = contato;

                    if ($scope.modalConsultaContaoMiner) {
                        ModalService.closeModal('modal_contatoMiner');
                        $scope.consultaContatoMinerList = [];
                        $scope.modalConsultaContaoMiner = false;

                        $scope.consultaMinerCampo = '';
                        $scope.consultaMinerValor = '';
                        $scope.atendimentoIntegracao = '';
                    }

                    carregarChamadaContatoMiner(contato);
                    // CampanhaDiscagemResource.setCampanhaDiscagemRetornoPreview($scope.discagemContatoMiner)
                    // .$promise
                    // .then((dados) => {
                    //     $scope.discagemPreview.CampanhaImportacaoId = dados.CampanhaImportacaoId;

                    // }).catch(() => {
                    //     NotifyService.showError();               
                    // });
                };

                var carregarChamadaContatoMiner = function (contato) {
                    $scope.esconderMensagem();
                    $scope.chamadaContatoMiner = {}

                    if ($scope.chamadaContatoMiner != null) {
                        $scope.chamadaContatoMiner.CodigoCliente = contato.CodigoCliente;
                        $scope.chamadaContatoMiner.NomeCliente = contato.Nome;
                        $scope.chamadaContatoMiner.Telefone = contato.Telefone;
                    }

                    if ($scope.chamada == undefined) $scope.chamada = {};

                    if ($scope.chamada != null) {
                        $scope.chamada.CodigoCliente = contato.CodigoCliente;
                        $scope.chamada.NomeCliente = contato.Nome;
                        $scope.chamada.Telefone = contato.Telefone;
                    }

                    getTabulacoes();
                    getLigacoes();
                    $scope.carregarDadosUraTalkBotContato();
                };

                $scope.carregarDadosUraTalkBotContato = function () {
                    var atendimentoLayout = {};
                    TabulacaoResource.GetCampos({
                        CampanhaId: $scope.chamadaPreview.CodigoCampanha || 0,
                        Direcao: 1,
                        NA: ""
                    }).$promise
                        .then((dados) => {
                            if (dados && dados.length > 0) {
                                var atendimentoLayoutId = dados[0].AtendimentoLayoutId;

                                getInfoLayoutById(atendimentoLayoutId).then(atendimentoLayout => {
                                    atendimentoLayout = atendimentoLayout;

                                    if (atendimentoLayout) {
                                        if ($scope.chamada) {
                                            if (atendimentoLayout.HabilitarInformacoesUraTalkBot) {
                                                $scope.detalhamentoUra = [];
                                                AtendimentoIntegracaoResource.consultarByGlobalId({
                                                    globalId: $scope.chamada.GlobalId || '',
                                                    Telefone: $scope.chamada.Telefone || '',
                                                    Cliente: $scope.chamada.CodigoCliente || '',
                                                    InfoAdicional1: $scope.chamada.InfoAdicional1 || '',
                                                    InfoAdicional2: $scope.chamada.InfoAdicional2 || '',
                                                    InfoAdicional3: $scope.chamada.InfoAdicional3 || '',
                                                    InfoAdicional4: $scope.chamada.InfoAdicional4 || '',
                                                    InfoAdicional5: $scope.chamada.InfoAdicional5 || '',
                                                    templateId: atendimentoLayout.AtendimentoIntegracaoTemplateId
                                                }).$promise.then(function (result) {
                                                    if (result) {

                                                        if (atendimentoLayout.AtendimentoIntegracaoTemplateId != null) {
                                                            IntegracaoResource.GetId({ Id: atendimentoLayout.AtendimentoIntegracaoTemplateId }).$promise.then(camposIntegracao => {
                                                                $scope.ListCamposIntegracao = camposIntegracao.AtendimentoIntegracaoTemplateCampo;

                                                                let seletor = $scope.ListCamposIntegracao[0].Seletor.split("[0].");

                                                                if (seletor.length > 0)
                                                                    $scope.detalhamentoUra = result[seletor[0]]
                                                                else
                                                                    $scope.detalhamentoUra = result

                                                                let campoAgrupamento = '';
                                                                let campo = $scope.ListCamposIntegracao.find(x => x.Identificador);

                                                                if (campo) {
                                                                    campoAgrupamento = campo.Seletor.split("[0].")[1]
                                                                } else {
                                                                    campoAgrupamento = seletor[1]
                                                                }

                                                                //Agrupamentos dos dados 
                                                                var groupResult = _.groupBy($scope.detalhamentoUra, campoAgrupamento);
                                                                $scope.detalhamentoUra = [];
                                                                Object.entries(groupResult).forEach(x => { $scope.detalhamentoUra.push(x[1][0]); })

                                                                $scope.detalhamentoUra.forEach(function (values) {
                                                                    if (values.hasOwnProperty(campoAgrupamento)) {
                                                                        var agrupamento = values[campoAgrupamento];

                                                                        if (agrupamento != undefined)
                                                                            values.Agrupamento = agrupamento;
                                                                    }
                                                                });

                                                                $scope.selecaoTabReceptiva = 2;

                                                            }).catch(error => {
                                                                NotifyService.showError(error);
                                                            });
                                                        }


                                                    }
                                                });
                                            }
                                        }
                                    }
                                });
                            }


                        }).catch(() => {
                            NotifyService.showError();
                            ModalService.hideLoading();
                        });
                };

                $scope.discarContatoMiner = function () {
                    $scope.HabilitarconsultaContato = false;
                    $scope.msgBlacklist = false;
                    $scope.Direcao = 1; //Sainte 
                    if ($scope.chamadaContatoMiner.Telefone && $scope.chamadaContatoMiner.Telefone != '') {
                        BlacklistItemResource.VerificaNumeroExisteBlacklist({ 'numero': $scope.chamadaContatoMiner.Telefone, 'ramalId': $scope.usuario.RamalId })
                            .$promise
                            .then(data => {
                                $scope.msgBlacklist = data.retorno;
                                if (!data.retorno) {

                                    $scope.chamadaContatoMiner.Nome = $scope.chamadaContatoMiner.NomeCliente;
                                    $scope.chamadaContatoMiner.Rota = -1;
                                    AtendimentoService.discarPreview($scope.chamadaContatoMiner);
                                    $scope.chamadaContatoMinerAtiva = true;
                                    $scope.exibirMensagem('telaTabulador.discandoStatus', 'info');

                                    $scope.ativarDiscagemManual();
                                }
                            });
                    }
                };

                $scope.cancelarContatoMiner = function () {
                    $scope.aguardarLigacao();
                    $scope.isDiscagemContatoMiner = false;
                    $scope.HabilitarconsultaContato = true;
                    $scope.trataIntervaloAtual();
                }

                $scope.onChangeAtendimentoIntegracao = function (atendimentoIntegracao) {
                    if (atendimentoIntegracao) {
                        filtroContatoMiner(atendimentoIntegracao)
                    } else {
                        $scope.filtroContatoMiner = [];
                    }

                }

                var filtroContatoMiner = function (integracaoTemplateId) {
                    TabulacaoResource.getFiltroContatoMiner({ integracaoTemplateId: integracaoTemplateId })
                        .$promise
                        .then((dados) => {
                            if (dados != null && dados.length > 0) {
                                $scope.filtroContatoMiner = dados;
                            }

                        }).catch(() => {
                            NotifyService.showError();
                        });
                }

                $scope.onGetMinerListas = function (id) {
                    if (id) {
                        let templateMinerId = $scope.atendimentoIntegracaoTemplate.find(x => x.AtendimentoIntegracaoTemplateId == id).TemplateMinerId;
                        getTemplateMinerListas(templateMinerId);
                    } else {
                        $scope.templateMinerListas = [];
                    }
                }

                var getTemplateMinerListas = function (templateMinerId) {
                    TabulacaoResource.getTemplateMinerListas({ templateMinerId: templateMinerId })
                        .$promise
                        .then((dados) => {
                            if (dados != null && dados.length > 0) {
                                $scope.templateMinerListas = dados;
                            }

                        }).catch(() => {
                            NotifyService.showError();
                        });
                }

                //REDISCAGEM
                $scope.rediscagem = function (form, acaoId) {
                    $scope.rediscagemCliente = true;
                    //salvarTabuçacao

                    if (localStorage.getItem('tabulacao_categoriaId')) {
                        $scope.tabulacao.CategoriaId = localStorage.getItem('tabulacao_categoriaId');
                        localStorage.removeItem('tabulacao_categoriaId');
                    }

                    if (localStorage.getItem('tabulacao_subCategoriaId')) {
                        $scope.tabulacao.SubCategoriaId = localStorage.getItem('tabulacao_subCategoriaId');
                        localStorage.removeItem('tabulacao_subCategoriaId');
                    }

                    if (localStorage.getItem('tabulacao_categoriaFilhoId')) {
                        let categoriaFilhoId = localStorage.getItem('tabulacao_categoriaFilhoId');


                        if ($scope.atendimentoLayout.Tabular && categoriaFilhoId == '0') {
                            NotifyService.showMessage('telaTabulador.erroTabulacao', 'info')
                            return;
                        }

                        localStorage.removeItem('tabulacao_categoriaFilhoId');
                    }

                    if ($scope.atendimentoLayout.Tabular && $scope.tabulacao.CategoriaId == undefined) {
                        NotifyService.showMessage('telaTabulador.erroTabulacao', 'info')
                        return;
                    }

                    $scope.infoRing.atendido = false;

                    stopIntervalo();
                    $scope.disableTimerSms = false;
                    $scope.timerSMS = 60;

                    //$scope.sairConsulta(true);
                    $scope.AtendimentoFim = new Date().getTime() / 1000;

                    consolidarTabulacao(acaoId, $scope.chamada);
                    $scope.tabulacao.AtendimentoStatusId = 1;

                    if ($scope.tabulacao.DirecaoId == 1) {
                        $scope.tabulacao.Nome = $scope.contatoReceptivo.Nome;
                    } else if ($scope.tabulacao.DirecaoId == 2) {
                        if ($scope.tabulacao.Nome == undefined || $scope.tabulacao.Nome == '')
                            $scope.tabulacao.Nome = $scope.chamada.NomeCliente;
                    }

                    if (!$scope.tabulacao.NB) $scope.tabulacao.NB = '99999999';

                    TabulacaoResource.save($scope.tabulacao).$promise.then(() => {
                        $scope.executeSearch();
                    });

                    let info = $scope.chamada.InfoAdicional1 + "," + $scope.chamada.InfoAdicional2 + "," + $scope.chamada.InfoAdicional3 + "," + $scope.chamada.InfoAdicional4 + "," + $scope.chamada.InfoAdicional5;
                    let campanhaDiscagem = {
                        CampanhaId: $scope.chamada.CodigoCampanha,
                        CodigoCliente: $scope.chamada.CodigoCliente,
                        Nome: $scope.chamada.NomeCliente,
                        DDD: $scope.chamada.ddd,
                        Telefone: $scope.chamada.Telefone,
                        Detalhe: info
                    };

                    CampanhaDiscagemResource.setCampanhaDiscagemRediscagem(campanhaDiscagem)
                        .$promise
                        .then((dados) => {
                            let discagem = {
                                CampanhaId: $scope.chamada.CodigoCampanha,
                                CampanhaImportacaoId: dados.CampanhaDiscagemRetornoId,
                                Detalhe: info,
                                Nome: $scope.chamada.NomeCliente,
                                CodigoCliente: $scope.chamada.CodigoCliente,
                                Telefone: $scope.chamada.Telefone,
                                Rota: dados.RotaId
                            };

                            $scope.alterarIntervaloHub($scope.configuracao.IntervaloLivre);
                            AtendimentoService.discarPreview(discagem);
                            $scope.exibirMensagem();
                            $scope.exibirMensagem('telaTabulador.discandoStatus', 'info');
                        }).catch(() => {
                            NotifyService.showError();
                        });
                }

                $scope.abrirTeclado = function () {
                    $scope.numeroTeclado = '';
                    document.querySelector('#numeroTeclado').focus();
                    ModalService.openModal('modalTeclado');
                }
                $scope.fecharTeclado = function () {
                    ModalService.closeModal('modalTeclado');
                }

                //  $rootScope.$broadcast(AUTH_EVENTS.userLogout, {});

                // $scope.filtroCategoriaChildren = function (item) {
                //     return $scope.tipo.Categorias.filter(function(value){ return value.ParentId && value.ParentId == item.Id }) ;

                // }

                // $scope.filtroCategoria = function () {
                //     return $scope.camposContato[0].Categorias.filter(function(x){ return x.ParentId});

                // }   
                $scope.getSeletor = function (item, seletor) {

                    if (seletor == undefined || item == undefined)
                        return "";

                    var filtro = seletor.split('.');
                    var result = '';
                    var aux = 0

                    filtro.forEach(x => {
                        if (aux == 0) {

                            if (x.includes('[0]')) {
                                result = item[x.replace('[0]', '')];
                                if (result == undefined)
                                    return;
                                else
                                    result = result[0];
                            }
                            else
                                result = item[x] || '0';
                        }
                        else {
                            if (x.includes('[0]')) {
                                result = result[x.replace('[0]', '')];
                                if (result == undefined)
                                    return;
                                else
                                    result = result[0];
                            }
                            else
                                result = result[x] || '0';
                        }

                        aux += 1;
                    });

                    return result;

                }
                if ($scope.usuario != undefined && $scope.usuario.Permissoes != undefined) {
                    $scope.PermissaoChat = $scope.usuario.Permissoes.some(p => p.Recurso === "Atendimento" && p.Acao === "Chat");
                }
                $scope.abrirChat = function () {
                    if ($scope.urlChat) {
                        return;
                    }

                    UsuarioChatResource.get()
                        .$promise.then((dados) => {
                            if (dados != null && dados.Url != null && dados.Url.trim() !== "") {
                                $scope.urlChat = $sce.trustAsResourceUrl(dados.Url);
                                $scope.PermissaoChat = true; // Ativar quando tiver URL válida
                            } else {
                                 $scope.urlChat = null; // Limpar URL se não for válida
                                 $scope.PermissaoChat = false; // Desativar se não tiver URL
                            }
                        })
                        .catch(() => {
                            $scope.PermissaoChat = false;
                            NotifyService.showError();
                        });
                }
                
                //Inicio Controle visual entre tabulação e chat
                function atualizarEstadoChat() {
                    const container = document.getElementById("chat-container");
                    const tab = document.getElementById("tabulador-container");

                    // Reset total (remove todas as classes antes de aplicar)
                    container.classList.remove("chat-minimized", "chat-maximized");
                    tab.classList.remove("chat-maximized");

                    // Se minimizado → tem prioridade absoluta
                    if ($scope.chatMinimized) {
                        container.classList.add("chat-minimized");
                        return; // nada mais deve ser aplicado
                    }

                    // Se maximizado
                    if ($scope.chatMaximized) {
                        container.classList.add("chat-maximized");
                        tab.classList.add("chat-maximized");
                    }
                }

                $scope.minimizarChat = function (minimized) {
                    $scope.chatMinimized = minimized;
                    atualizarEstadoChat();
                }

                $scope.maximizarChat = function (maximized) {
                    $scope.chatMaximized = maximized;
                    atualizarEstadoChat();
                }
                //Fim Controle visual entre tabulação e chat
                
                $scope.getTipoLogon = function () {
                    let tpLogon = 0;

                    if ($scope.conexao.TelefoniaTipoId == 2 || $scope.conexao.TelefoniaTipoId == 3) {
                        if ($scope.conexao.isRamal == 'true') {
                            tpLogon = 3;
                        } else {
                            tpLogon = 2;
                        }
                    } else {
                        tpLogon = 1;
                    }
                    return tpLogon;
                }

                $scope.logarRamal = function () {

                    $scope.exibirMensagem('telaTabulador.realizandoLogin', 'success');
                    let tipoLogon = $scope.getTipoLogon();
                    AtendimentoService.iniciar(valorTelefonia, tipoLogon, false).catch(data => {

                        ModalService.hideLoading();
                        $scope.showModalConexao();

                        $scope.iniciarConexaoComErro();
                        let user = AuthService.getUsuarioLogado();

                        if (!user.RamalNumero || user.RamalNumero == '') {
                            $scope.exibirMensagem('telaTabulador.usuarioNaoPossuiRamal', 'danger');
                        } else {
                            $scope.exibirMensagem('telaTabulador.erroAoConectarComOAtendimento', 'danger', { 'Detalhe': data.message });
                        }

                        $scope.finalizarTabulacao();
                        $scope.aguardarProcessamento();
                    });
                }

                // Função auxiliar para criar os itens
                $scope.createStatus = function (id, nome, descricao, callback) {
                    return {
                        id: id,
                        callback: callback || $scope.finalizaLogon,
                        nome: nome,
                        Descricao: $translate.instant(descricao)
                    };
                }

                // #region [Status Logon]

                // Array completo com callback para tratar os erros
                // e descrições para tradução
                // Apenas uma nova tentativa em caso de ramal em uso
                $scope.callbacklogonRamalEmUso = true;
                $scope.tentativaRamalEmUsoLogon = function () {

                    if ($scope.callbacklogonRamalEmUso) {
                        // Apenas uma nova tentativa
                        $scope.callbacklogonRamalEmUso = false;
                        $scope.logarRamal();
                    }
                    else {
                        $scope.showModalConexao();
                    }
                }
                $scope.RamalStatusLogonArray = [
                    $scope.createStatus(3, 'IdEmUso', 'telaTabulador.idEmUso'),
                    $scope.createStatus(4, 'RamalInvalido', 'telaTabulador.ramalInvalido'),
                    $scope.createStatus(5, 'RamalEmUso', 'telaTabulador.ramalEmUso', $scope.tentativaRamalEmUsoLogon),
                    $scope.createStatus(6, 'SenhaInvalida', 'telaTabulador.senhaInvalida'),
                    $scope.createStatus(7, 'ParametroInvalido', 'telaTabulador.parametroInvalido'),
                    $scope.createStatus(8, 'RamalNaoCadastrado', 'telaTabulador.ramalNaoCadastrado'),
                    $scope.createStatus(9, 'ContaSipNaoLogadaNoTelefone', 'telaTabulador.contaSipNaoLogadaNoTelefone'),
                    $scope.createStatus(10, 'SemRecursoVozDisponivel', 'telaTabulador.semRecursoVozDisponivel'),
                    $scope.createStatus(11, 'ForaDaJornadaTrabalho', 'telaTabulador.foraDaJornadaTrabalho'),
                    $scope.createStatus(12, 'NotDocumented', 'telaTabulador.notDocumented'),
                    $scope.createStatus(13, 'ErroSistema', 'telaTabulador.erroSistema'),
                    $scope.createStatus(14, 'IntervaloInvalido', 'telaTabulador.intervaloInvalido'),
                    $scope.createStatus(15, 'ParametrosIncompletos', 'telaTabulador.parametrosIncompletos'),
                    $scope.createStatus(16, 'RamalGrupoInvalido', 'telaTabulador.ramalGrupoInvalido'),
                    $scope.createStatus(17, 'StatusGrupoInvalido', 'telaTabulador.GrupoInvalido')
                ];

                $scope.getStatusLogonRetornoObject = function (value) {
                    let status = $scope.RamalStatusLogonArray.find(item => item.id === value);
                    return status;
                }

                $scope.finalizaLogon = function () {
                    $scope.showModalConexao();
                }

                // #endregion

                // #region [Conexão Talkfone]


                /**
                 * Valida se a variável maquina é valida
                 */
                $scope.getEnderecoSipWebRTC = function () {

                    let enderecoSipWebRTC = null;
                    let errorMsg = null;
                    let result = {};

                    // Verificação simplificada mas eficaz
                    if (!maquina || !Array.isArray(maquina) || maquina.length === 0 ||
                        !maquina[0] || !maquina[0].EnderecoSipWebRTC) {

                        errorMsg = !maquina ? 'maquina é null/undefined' :
                            !Array.isArray(maquina) ? 'maquina não é array' :
                                maquina.length === 0 ? 'maquina está vazio' :
                                    !maquina[0] ? 'primeiro elemento inválido' :
                                        'EnderecoSipWebRTC não configurado';
                    }
                    else {
                        enderecoSipWebRTC = maquina[0].EnderecoSipWebRTC;
                    }
                    result.errorMsg = errorMsg;
                    result.enderecoSipWebRTC = enderecoSipWebRTC;
                    return result;
                }

                /**
                 * Gerencia timeouts no registro do softphone com integração com SoftphoneService
                 * @description Notifica o usuário sobre falha na conexão e attempt reconexão automática
                 */
                $scope.timeoutRegisterSoftphone = function () {

                    // Reseta registerTimeout
                    $scope.registerTimeout = null;

                    // Realiza a tentativa de reconexão
                    $scope.attemptSoftphoneReconnection();
                }

                /**
                 * Função interna para realizar a reconexão do softphone
                 */
                $scope.attemptSoftphoneReconnection = function () {

                    ModalService.hideLoading();

                    // Agenda próxima tentativa se não houver sucesso
                    $scope.retryCount = $scope.retryCount + 1;
                    if ($scope.retryCount <= $scope.maxRetries) {
                        $scope.consoleInfo(`Iniciando reconexão automática (Tentativa ${$scope.retryCount}/${$scope.maxRetries})`);
                        $scope.exibirMensagem('talkFone.tentativaRegistroTalkfone', 'info', { 'retryCount': $scope.retryCount });
                        $scope.iniciaRegistroTalkfone();
                    } else {
                        // Esgotou as tentativas
                        $scope.handleFinalFailure();
                    }
                }

                /**
                 * Manipula a falha definitiva após todas as tentativas
                 */
                $scope.handleFinalFailure = function () {

                    ModalService.hideLoading();
                    $scope.esconderMensagem();

                    NotifyService.showMessageExt(
                        'talkFone.excedeuTentativaRegistroTalkfone',
                        'danger',
                        { 'maxRetries': $scope.maxRetries },
                        5000
                    ).then(function () {
                        $scope.showModalConexao();
                    });

                    // Reseta contadores para futuras tentativas
                    $scope.resetReconnectionCounters();
                }

                /**
                 * Reseta os contadores de reconexão
                 */
                $scope.resetReconnectionCounters = function () {
                    $scope.retryCount = 0;
                    $scope.currentDelay = 3000;
                }

                /**
                 * Evento disparado quando o status do Register do softphone muda
                 */
                $scope.$on('softphone:RegistererState', function (event, infoRegister) {

                    // Cancela as tentativas de reconexão
                    if ($scope.registerTimeout) {
                        clearTimeout($scope.registerTimeout);
                        $scope.registerTimeout = null;  
                    }

                    $scope.resetReconnectionCounters();

                    /// Initial:
                    /// Registered:
                    /// Unregistered:
                    /// Terminated:
                    switch (infoRegister.state) {

                        case 'Initial':
                            break;

                        // Se registrou com sucesso, cancela as tentativas de reconexão
                        case 'Registered':
                            if (!$scope.conectandoSoftphone) {
                                return;
                            }
                            $scope.conectandoSoftphone = false;

                            if ($scope.registerTimeout) {
                                clearTimeout($scope.registerTimeout);
                                $scope.registerTimeout = null;
                            }

                            $scope.resetReconnectionCounters();

                            $scope.logarRamal();
                            break;

                        /// TODO: Tratar Unregistered e Terminated
                        default:
                            //ModalService.hideLoading();
                            //$scope.showModalConexao();
                            break;
                    }
                })

                $scope.$on('softphone:WebrtcState', function (event, infoConnectWss) {

                    /// Connecting
                    /// Connected
                    /// Failed
                    /// AllServersFailed
                    /// Disconnected
                    /// Abortted
                    /// LastServersFailed
                    switch (infoConnectWss.state) {

                        case 'Abortted':
                            NotifyService.showMessageExt(
                                'talkFone.conexaoWssAbortada',
                                'danger',
                                { 'Detalhe': infoConnectWss.reason },
                                5000
                            ).then(function () {
                                $scope.showModalConexao();
                            });
                            break;

                        case 'Failed':
                            if ($scope.isConexaoInicialSoftphone) break;
                        case 'LastServersFailed':
                            NotifyService.showMessage(
                                'talkFone.conexaoWssFalha',
                                'danger',
                                { 'Detalhe': infoConnectWss.reason });
                            break;

                    }
                })

                $scope.iniciaRegistroTalkfone = function () {

                    ModalService.showLoading();
                    let message = $translate.instant('talkFone.conectandoTalkfone', { retryCount: $scope.retryCount, maxRetries: $scope.maxRetries });
                    $scope.exibirMensagem(message, 'success');
                    SoftphoneService.registrar(
                        $scope.softphone.UrlBase,
                        $scope.softphone.WebsocketUrl,
                        $scope.EnderecoSipWebRTC,
                        $scope.usuario.Ramal.Numero,
                        $scope.usuario.Ramal.Senha,
                        $scope.softphone.Debug);

                    // Aguarda 7 segundos para verificar se houve resposta do registro ou erro
                    $scope.registerTimeout = setTimeout($scope.timeoutRegisterSoftphone, 7000);
                }

                // #endregion

                if ($scope.PermissaoChat) {
                    $scope.abrirChat();
                }

                $scope.onOpenRamalModal = function () {
                    $scope.isRamal = true;
                    $scope.abrirTransferencia();
                }
                $scope.onLigarRamal = function () {
                    var telefone = $scope.transferencia.Telefone == '' ? $scope.transferencia.Ramal : $scope.transferencia.Telefone;
                    ModalService.closeModal('modal_transferencia');
                    $scope.isRamal = false;
                    $scope.numeroDiscador = telefone;
                    $scope.discadorInterno = true;
                    $scope.onCallNumeroDiscador();
                }
                $('#modal_transferencia').on({
                    'show.uk.modal': function () { },
                    'hide.uk.modal': function () {
                        $scope.isRamal = false;               
                    }
                });

                $scope.consoleInfo = function (message) {

                    let now = new Date();
                    let timestamp = `${now.toLocaleTimeString()}`;
                    console.info(`[${timestamp}] ${message}`);
                }

                $scope.consoleError = function (message) {

                    let now = new Date();
                    let timestamp = `${now.toLocaleTimeString()}`;
                    console.error(`[${timestamp}] ${message}`);
                }

            }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UsuarioChatResource", ["$odataresource", function ($odataresource) {
            return $odataresource("UsuarioChat/:Id", {
                "Id": "@Id"
            },
            {
                    getUsuarioChatAssociado: {
                        url: "UsuarioChat/UsuarioChatAssociado/:chatCanalId/:grupoId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "chatCanalId": "@chatCanalId",
                            "grupoId": "@grupoId"
                        }
                    },
                    getUsuarioChatNaoAssociado: {
                        url: "UsuarioChat/UsuarioChatNaoAssociado/:chatCanalId/:grupoId",
                        method: "GET",
                        isArray: true,
                        params: {
                            "chatCanalId": "@chatCanalId",
                            "grupoId": "@grupoId"
                        }
                    },
                    salvarUsuarioChat: {
                        url: "UsuarioChat/SalvarUsuarioChat",
                        method: "POST"
                    }
                });
        }]);
})();
(function() {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 15;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.tabulacaoHistorico", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.tabulacaoHistorico.list',
                        pageTitle: 'pageTitle.historicoDeTabulacoes',
                        pageName: 'pageTitle.historicoDeTabulacoes',
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("main.tabulacaoHistorico.list", StateResolverProvider.configState("/tabulacaoHistorico", "TabulacaoHistorico", "List", {
                    pageTitle: 'pageTitle.historicoDeTabulacoes',
                    pageName: 'pageTitle.pesquisar'
                }));

        }])

    .service("TabulacaoHistoricoListData", function TabulacaoHistoricoListData() {
        return function() {
            return {
                grupos: ["GrupoResource", function(GrupoResource) {
                    return GrupoResource.getTodosGrupos();
                }],
                categorias: ["TabulacaoResource", function(TabulacaoResource) {
                    return TabulacaoResource.GetCategorias().$promise;
                }],
                subCategorias: ["TabulacaoResource", function(TabulacaoResource) {
                    return [];
                }],
                status: ["TabulacaoResource", function(TabulacaoResource) {
                    return TabulacaoResource.GetStatus().$promise;
                }],
                tipos: ["TabulacaoResource", function(TabulacaoResource) {
                    return TabulacaoResource.GetTipos().$promise;
                }],
                usuarios: ["UsuarioResource", function(UsuarioResource) {
                    return UsuarioResource.GetTodosUsuario().$promise;
                }],
                CategoriaStatus: ["AtendimentoCategoriaStatusResource", function(AtendimentoCategoriaStatusResource) {
                    return AtendimentoCategoriaStatusResource.query().$promise;
                }],
                maxFiltroBilhete: ["ConfiguracaoResource", function(ConfiguracaoResource) {
                    return ConfiguracaoResource.getConfiguracaoMaxFiltroBilhete();
                }],
                campanhasList: ["CampanhaResource", function(CampanhaResource) {
                    return CampanhaResource.GetTodasCampanhas();
                }],
                carteiraList: ["CarteiraResource", function(CarteiraResource) {
                    return CarteiraResource.query().$promise;
                }],
            };
        };
    })

    .controller("TabulacaoHistoricoListController", ["$scope", "ModalService", "$odata", "$stateParams", "$http", "Config", "grupos", "categorias", "subCategorias", "status", "tipos", "usuarios", "AuthService", "FileDownloadService", "LocalStorageService", "NotifyService", "$translate", "TabulacaoResource", "CategoriaStatus", "maxFiltroBilhete", "campanhasList", "carteiraList", function($scope, ModalService, $odata, $stateParams, $http, Config, grupos, categorias, subCategorias, status, tipos, usuarios,
        AuthService, FileDownloadService, LocalStorageService, NotifyService, $translate, TabulacaoResource, CategoriaStatus, maxFiltroBilhete, campanhasList,
        carteiraList) {

        var dataInicio = moment().hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
        var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();
        $scope.usuarioIsAdmin = AuthService.getUsuarioLogado() ? AuthService.getUsuarioLogado().UsuarioTipoId === 1 ? true : false : false;
        $scope.filterPageSize = { Size: 15 };
        $scope.grupos = grupos;
        $scope.gruposSemFiltro = grupos;
        $scope.tipos = tipos;
        $scope.tiposSemFiltro = $scope.tipos;
        categorias.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1);
        subCategorias.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1);
        $scope.categorias = categorias;
        $scope.subCategorias = subCategorias;
        $scope.status = status;
        $scope.CategoriaStatus = CategoriaStatus;
        $scope.campanhasAtivas = _.filter(campanhasList, function(item) {
            return item.CampanhaStatusId !== 1;
        });
        $scope.campanhas = $scope.campanhasAtivas;
        $scope.campanhasSemFiltro = $scope.campanhas;
        $scope.usuarios = $scope.usuariosbase = _.filter(usuarios, function(usuario) {
            return usuario.UsuarioStatusId == 1
        });;
        $scope.usuariosSemFiltro = $scope.usuarios;
        $scope.tabulacoes = [];
        $scope.historico = '';
        $scope.globalId = '';
        $scope.searching = false;
        $scope.countPesquisa = 0;
        $scope.layout = {};
        $scope.tabulacao = [];
        $scope.maxFiltroBilhete = maxFiltroBilhete.Quantidade;
        $scope.filtroCategoriaId = [];
        $scope.filtroGrupoId = [];
        $scope.filtroUsuarioId = [];
        $scope.filtroTipoId = [];
        $scope.carteiraList = carteiraList;

        $scope.direcao = [
            { DirecaoId: 2, Descricao: $translate.instant('campo.efetuada') },
            { DirecaoId: 1, Descricao: $translate.instant('campo.recebida') }
        ];

        $scope.registroPorPaginaArray = [
            { label: 15, valor: 15 },
            { label: 30, valor: 30 },
            { label: 50, valor: 50 },
            { label: 100, valor: 100 }
        ];

        $scope.orderBy = {
            column: "Data",
            order: "Desc"
        };

        $scope.search = {
            DataInicio: dataInicio,
            DataFim: $stateParams.DataFim || dataFim,
            DirecaoId: 0,
            GrupoId: [],
            NB: '',
            NA: '',
            GlobalId: '',
            CampanhaId: '',
            Duracao: '',
            DuracaoDialogo: '',
            Transferencia: true,
            AtendimentoCategoriaStatusId: 0,
        };

        $scope.executeSearch = function() {
            var dataI = moment($scope.search.DataInicio);
            var dataF = moment($scope.search.DataFim);
            var dateDiff = dataF.diff(dataI, 'days');
            if (dateDiff > $scope.maxFiltroBilhete) {
                $scope.tabulacoes = [];
                NotifyService.showMessage('telaTabulacaoHistorico.limitePesquisarExportar', "warning");
                return;
            }
            $scope.searching = true;
            $scope.countPesquisa = -1;
            var grupoUsuario = getGruposId();
            var usuarios = getUsuariosId();
            var tipoCategoria = getTiposId();
            var categorias = getCategoriasId();
            var subCategorias = getSubCategoriasId();
            var status = getStatusId();

            $scope.search.GrupoUsuarios = grupoUsuario;
            $scope.search.Usuarios = usuarios;
            $scope.search.Direcao = $scope.search.DirecaoId;
            $scope.search.GrupoTipos = tipoCategoria;
            $scope.search.Categorias = categorias;
            $scope.search.SubCategorias = subCategorias;
            $scope.search.Campanha = $scope.search.CampanhaId;
            $scope.search.NB = $scope.search.NB === '' ? null : $scope.search.NB;
            $scope.search.NA = $scope.search.NA === '' ? null : $scope.search.NA;
            $scope.search.GlobalId = $scope.search.GlobalId === '' ? null : $scope.search.GlobalId;
            $scope.search.SortColumn = $scope.orderBy.column;
            $scope.search.SortDirection = $scope.orderBy.order.toUpperCase();
            $scope.search.Status = status;

            LocalStorageService.setItem('FiltroTabulacoes', $scope.search);

            getOdataSearch().catch(() => {
                $scope.searching = false;
                $scope.countPesquisa = 0;
            });
        };

        $scope.order = function(predicate) {
            ModalService.showLoading();
            $scope.predicate = predicate;
            $scope.reverse = $scope.predicate ? !$scope.reverse : false;

            $scope.orderBy = {
                column: predicate,
                order: !$scope.reverse ? "desc" : "asc"
            };

            getOdataSearch()
        };

        var mudarTipoCategoria = function() {
            if (!$scope.filtroTipoId) {
                $scope.categorias = $scope.dataCopia;
            }
        }

        $scope.onChangeGrupoUsuario = function() {
            getUsuarioPorGrupo();
        };

        $scope.onChangeTipoCategoria = function() {
            getCategoriasPorTipo();
            mudarTipoCategoria();
            //getSubCategoriasPorTipo();
        };

        $scope.changePageSize = function() {
            defaultPageSize = $scope.filterPageSize.Size ? $scope.filterPageSize.Size : 15;
            $scope.executeSearch();
        };

        $scope.pageChanged = function(newPage) {
            if (defaultPageIndex != newPage) {
                defaultPageIndex = newPage;
                ModalService.showLoading();
                getOdataSearch();
            }
        };

        $scope.viewHistoricoTabulacao = function(tabulacao) {
            $scope.historico = tabulacao.Historico;
            $scope.globalId = tabulacao.GlobalId;
        };

        $scope.reproduzirDialogo = function(tabulacao) {
            $scope.search.bilheteDialogoAtivo = tabulacao;
        };

        $scope.downloadFile = function(globalId, arquivoDialogo) {
            try {
                FileDownloadService.downloadWebApiFile("Ligacao/Download/" + globalId + "/" + arquivoDialogo.replace('.vox', '').replace('.mp3', ''));
            } catch (err) {
                NotifyService.showError();
            }
        };


        if (!$scope.configuracoes) {
            $scope.configuracoes = [];
        }

        $scope.editTabulacao = [];

        $scope.editarTabulacao = function(tabulacao) {
            $scope.editTabulacao = [];
            TabulacaoResource.GetById({ id: tabulacao.AtendimentoId }).$promise.then((tab) => {
                $scope.editTabulacao = tab;
            });

            TabulacaoResource.GetCampos({
                CampanhaId: tabulacao.CampanhaId || 0,
                Direcao: tabulacao.DirecaoId == 1 ? 2 : 1,
                UsuarioId: tabulacao.UsuarioId
            }).$promise.then(function(result) {
                var camposContatoNaoOrdenado = result;
                $scope.camposContato = [];
                camposContatoNaoOrdenado.forEach(element => {
                    $scope.camposContato[element.Ordem - 1] = element;
                });
            });
        };

        $scope.salvaTabulacao = function(valid) {
            if (!valid) {
                return;
            }

            if (localStorage.getItem('tabulacao_categoriaId')) {
                $scope.tabulacao.CategoriaId = localStorage.getItem('tabulacao_categoriaId');
                localStorage.removeItem('tabulacao_categoriaId');
            }

            if (localStorage.getItem('tabulacao_subCategoriaId')) {
                $scope.tabulacao.SubCategoriaId = localStorage.getItem('tabulacao_subCategoriaId');
                localStorage.removeItem('tabulacao_subCategoriaId');
            }

            $scope.editTabulacao.CategoriaId = $scope.tabulacao.CategoriaId;
            $scope.editTabulacao.SubCategoriaId = $scope.tabulacao.SubCategoriaId;
            $scope.editTabulacao.Historico = $scope.tabulacao.Historico;
            $scope.editTabulacao.CampoGenerico1 = $scope.tabulacao.CampoGenerico1;
            $scope.editTabulacao.CampoGenerico2 = $scope.tabulacao.CampoGenerico2;
            $scope.editTabulacao.AtendimentoStatusId = 1;
            $scope.editTabulacao.Editado = true;

            TabulacaoResource.save($scope.editTabulacao).$promise.then(() => {
                $scope.tabulacao = [];
                ModalService.closeModal('modal_edit');
                NotifyService.showSuccess(null, $translate.instant('telaTabulacaoHistorico.sucessoEdit'));
                $scope.executeSearch();
            }).catch(() => {
                NotifyService.showError(null, $translate.instant('telaTabulacaoHistorico.erroEdit'));
            });

        };

        $scope.export = function() {
            ModalService.showLoading();


            var dataI = moment($scope.search.DataInicio);
            var dataF = moment($scope.search.DataFim);
            var dateDiff = dataF.diff(dataI, 'days');
            if (dateDiff > $scope.maxFiltroBilhete) {
                $scope.tabulacoes = [];
                NotifyService.showMessage('telaTabulacaoHistorico.limitePesquisarExportar', "warning");
                return;
            }
            
            var grupoUsuario = getGruposId();
            var usuarios = getUsuariosId();
            var tipoCategoria = getTiposId();
            var categorias = getCategoriasId();
            var subCategorias = getSubCategoriasId();
            var status = getStatusId();
            var fileName = generateUUID();

            $scope.search.GrupoUsuarios = grupoUsuario;
            $scope.search.Usuarios = usuarios;
            $scope.search.Direcao = $scope.search.DirecaoId;
            $scope.search.GrupoTipos = tipoCategoria;
            $scope.search.Categorias = categorias;
            $scope.search.SubCategorias = subCategorias;
            $scope.search.Campanha = $scope.search.CampanhaId;
            $scope.search.NB = $scope.search.NB === '' ? null : $scope.search.NB;
            $scope.search.NA = $scope.search.NA === '' ? null : $scope.search.NA;
            $scope.search.GlobalId = $scope.search.GlobalId === '' ? null : $scope.search.GlobalId;
            $scope.search.SortColumn = $scope.orderBy.column;
            $scope.search.SortDirection = $scope.orderBy.order.toUpperCase();
            $scope.search.Status = status;
            $scope.search.FileName = fileName;

            let filtro = Object.assign({}, $scope.search);;
            filtro.DataInicio = moment(filtro.DataInicio).format('YYYY-MM-DDTHH:mm:ss')
            
            //Garante que se a data fim for maior que a data atual (comportamento normal default no carregamento da tela),
            //seja enviado a data atual para garantir que o relatório processe apenas registro desse intervalo, evitando processamento prolongado indesejadamente.
            var dataFimTratada = moment() < filtro.DataFim ? moment() : moment(filtro.DataFim);
            filtro.DataFim = dataFimTratada.format('YYYY-MM-DDTHH:mm:ss')

            exportarArquivoCDR(filtro)
                .then(() => {
                    if ($scope.search.AbrirPaginaDetalhe) {
                        window.open('/#/bilheteCdr/detalheExportar', '_blank');
                    }
                    $scope.search.AbrirPaginaDetalhe = false;
                    ModalService.hideLoading();
                    ModalService.closeModal('modal_cdr_Historico')
                }).catch((error) => {
                    ModalService.hideLoading();
                    NotifyService.showError(error);
                });

        };

        function exportarArquivoCDR(filtro) {
            var url = Config.getUrl("Atendimento/Historico/Exportar")
            return $http({
                method: 'POST',
                url: url,
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(filtro)
            }).then((response) => { return response.data; });
        };

        var limparColecao = function(colecao) {
            colecao.forEach((item) => {
                if (item.checked) {
                    item.checked = false;
                }
            })
        }

        $scope.limparFiltro = function() {
            limparColecao($scope.grupos);
            limparColecao($scope.usuarios);
            limparColecao($scope.tipos);
            limparColecao($scope.categorias);

            $scope.search = {
                DataInicio: dataInicio,
                DataFim: $stateParams.DataFim || dataFim,
                DirecaoId: 0,
                NB: null,
                NA: null,
                GlobalId: null,
                CampanhaId: '',
                Duracao: '',
                filtroCategoriaId: [],
                filtroGrupoId: [],
                filtroUsuarioId: [],
                filtroTipoId: []
            };

            $scope.tabulacoes = [];
            $scope.reverse = false;
            $scope.orderBy = {
                column: "Data",
                order: "Desc"
            };

            $scope.executeSearch();
        };

        var generateUUID = function() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
            });
            return uuid;
        }

        var getCategoriasPorTipo = function() {
            if (!$scope.filtroTipoId || $scope.filtroTipoId.length <= 0) {
                return $scope.categorias = categorias;
            }

            $http({ url: Config.getUrl('Atendimento/CategoriasPorTipo?tipoId=' + $scope.filtroTipoId.join(',')), method: 'GET' })
                .then(updateCategoriaList)
                .catch(NotifyService.showError);
        }

        var getSubCategoriasPorTipo = function() {
            if (!$scope.filtroTipoId || $scope.filtroTipoId.length <= 0) {
                return $scope.subCategorias = subCategorias;
            }

            $http({ url: Config.getUrl('Atendimento/CategoriasPorTipo?tipoId=' + $scope.filtroTipoId.join(',')), method: 'GET' })
                .then(updateSubCategoriaList)
                .catch(NotifyService.showError);
        }


        var getUsuarioPorGrupo = function() {
            // Se não for Informado um Grupo exibe Todos os Ramais
            if (!$scope.filtroGrupoId || $scope.filtroGrupoId.length <= 0) {
                return $scope.usuarios = $scope.usuariosbase;
            }
            let usuariosFiltrados = _.filter($scope.usuariosbase, function(usuario) {
                if (usuario.Grupos) {
                    return $scope.filtroGrupoId.some(grupoid => usuario.Grupos.includes(grupoid));
                }
            });
            $scope.usuarios = usuariosFiltrados;
        }

        var getGruposId = function() {
            if ($scope.filtroUsuarioId && $scope.filtroUsuarioId.length > 0) {
                return null;
            } else if (!$scope.filtroGrupoId || $scope.filtroGrupoId.length <= 0) {
                return null; //_.pluck(_.where(grupos, {}), 'GrupoId').join(",");
            } else {
                return $scope.filtroGrupoId.join(',');
            }
        }

        var getUsuariosId = function() {
            if (!$scope.filtroUsuarioId || $scope.filtroUsuarioId.length <= 0) {
                return null;
            } else {
                return $scope.filtroUsuarioId.join(',');
            }
        }

        var getTiposId = function() {
            if ($scope.filtroCategoriaId && $scope.filtroCategoriaId.length > 0) {
                return null;
            } else if (!$scope.filtroTipoId || $scope.filtroTipoId.length <= 0) {
                //return _.pluck(_.where(tipos, {}), 'Id').join(",");
                return null;
            } else {
                return $scope.filtroTipoId.join(',');
            }
        }

        var getCategoriasId = function() {
            if (!$scope.filtroCategoriaId || $scope.filtroCategoriaId.length <= 0) {
                return null;
            } else {
                return $scope.filtroCategoriaId.map(x => x.id).join(',');
            }
        }

        var getSubCategoriasId = function() {
            if (!$scope.search.SubCategoriaId || $scope.search.SubCategoriaId.length <= 0) {
                return null;
            } else {
                return $scope.search.SubCategoriaId.join(',');
            }
        }

        var getStatusId = function() {
            if (!$scope.search.AtendimentoStatusId || $scope.search.AtendimentoStatusId.length <= 0) {
                return null;
            } else {
                return $scope.search.AtendimentoStatusId.join(',');
            }
        }

        var updateUsuarioList = function(response) {
            if (!response.data || response.data.length <= 0) {
                return $scope.usuarios = [];
            }

            let users = [];
            response.data.forEach(function(item) {

                const newItem = {
                    UsuarioId: item.UsuarioId,
                    Nome: item.Descricao
                }

                users.push(newItem)
            });


            $scope.usuarios = users;
        };

        var updateCategoriaList = function(response) {
            if (!response.data || response.data.length <= 0) {
                return $scope.categorias = [];
            }
            $scope.categorias = response.data;
            Gerar();
        };

        var updateSubCategoriaList = function(response) {
            if (!response.data || response.data.length <= 0) {
                return $scope.subCategorias = [];
            }
            $scope.subCategorias = response.data;
        };

        var updateList = function(response) {
            $scope.tabulacoes = response.Data;
            $scope.tabulacoes.recordCount = response.RecordCount || response.Data.length;
            $scope.currentPage = response.PageIndex || defaultPageIndex;
            $scope.tabulacoes.pageSize = response.PageSize || defaultPageSize;
            $scope.searching = false;
        };

        var getOdataSearch = function() {
            $scope.search.SortColumn = $scope.orderBy.column;
            $scope.search.SortDirection = $scope.orderBy.order;
            var url = Config.getUrl('Atendimento/') + defaultPageIndex + '/' + defaultPageSize + '/Pagination';
            return $http({
                method: 'GET',
                url: url,
                params: $scope.search
            }).then((response) => {
                updateList(response.data);
                ModalService.hideLoading();
                if ($scope.countPesquisa == -1) {
                    getCount();
                }
            }).catch((error) => {
                NotifyService.showError(error);
                ModalService.hideLoading();
            });
        };

        var getCount = function() {
            var url = Config.getUrl('Atendimento/') + 'Count';
            return $http({
                method: 'GET',
                url: url,
                params: $scope.search
            }).then((retorno) => {
                $scope.countPesquisa = retorno.data.Quantidade;
            });
        }

        $scope.data = [];
        $scope.dataCopia = [];

        function Gerar() {
            $scope.data = [];
            $scope.dataCopia = [];
            $scope.categorias.forEach(function(values) {

                if (!values.ParentId) {
                    var obj = {
                        id: values.Id,
                        name: values.Descricao,
                        children: []
                    }

                    GerarFilhos(values.Id, obj);
                    $scope.data.push(obj);
                    $scope.dataCopia.push(obj);
                }
            });
        }

        function GerarFilhos(id, obj) {
            $scope.categorias.forEach(function(values) {

                if (values.ParentId == id) {

                    var filhos = $scope.categorias.filter(x => x.ParentId == values.Id).length;
                    if (filhos > 0) {

                        var objFilho = {
                            id: values.Id,
                            name: values.Descricao,
                            children: []
                        }

                        GerarFilhos(values.Id, objFilho);
                        obj.children.push(objFilho);
                    } else
                        obj.children.push({
                            id: values.Id,
                            name: values.Descricao,
                            children: []
                        });
                }
            });

        }

        Gerar();

        $scope.selectOnly1Or2 = function(item, selectedItems) {
            if (!selectedItems || selectedItems.length === 0) {
                return true;
            }
            
            var uniqueItems = selectedItems.filter(function(item, index, self) {
                return self.findIndex(function(x) { return x.id === item.id; }) === index;
            });
            
            if (uniqueItems.length !== selectedItems.length) {
                $scope.filtroCategoriaId = uniqueItems;
            }
            
            return true;
        };

        $scope.onChangeCarteira = function() {

            if ($scope.search.CarteiraId) {
                $scope.grupos = $scope.gruposSemFiltro.filter(x => x.CarteiraId == $scope.search.CarteiraId);
                $scope.usuarios = $scope.usuariosSemFiltro.filter(x => x.CarteiraId == $scope.search.CarteiraId);
                $scope.tipos = $scope.tiposSemFiltro.filter(x => x.CarteiraId == $scope.search.CarteiraId);
                $scope.campanhas = $scope.campanhasSemFiltro.filter(x => x.CarteiraId == $scope.search.CarteiraId);
            } else {
                $scope.grupos = $scope.gruposSemFiltro;
                $scope.usuarios = $scope.usuariosSemFiltro;
                $scope.tipos = $scope.tiposSemFiltro;
                $scope.campanhas = $scope.campanhasSemFiltro
            }
        }

    }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.tarefas.new", StateResolverProvider.configState("/tarefas/new", "Tarefa", "Edit", {
                    pageTitle: 'pageTitle.tarefas',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.tarefas.edit", StateResolverProvider.configState("/tarefas/{TarefaId:[0-9]+}", "Tarefa", "Edit", {
                    pageTitle: 'pageTitle.tarefas',
                    pageName: 'acoes.editar'
                }));
        }])

        .service('TarefaEditData', function TarefaEditData() {
            return function () {
                return {
                    tarefa: ["TarefaResource", "$stateParams", function (TarefaResource, $stateParams) {
                        if ($stateParams.TarefaId) {
                            return TarefaResource.get({
                                TarefaId: $stateParams.TarefaId
                            }).$promise;
                        } else {
                            return {
                                Ativo: true
                            };
                        }
                    }],
                    geradores: ["TarefaResource", function (TarefaResource) {
                        return TarefaResource.geradores().$promise;
                    }],
                    executores: ["TarefaResource", function (TarefaResource) {
                        return TarefaResource.executores().$promise;
                    }],
                    grupos: ["TarefaResource", function (TarefaResource) {
                        return TarefaResource.grupos().$promise;
                    }],
                    recursos: ["TarefaResource", function (TarefaResource) {
                        return TarefaResource.recursos().$promise;
                    }],
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }]
                }
            }
        })

        .controller("TarefaEditController",
            ["$scope", "tarefa", "geradores", "executores", "grupos", "recursos", "TarefaResource", "$state", "NotifyService", function ($scope, tarefa, geradores, executores, grupos, recursos, TarefaResource, $state, NotifyService) {
                var tiposSuportados = ["Fila", "Agendada", "Recorrente", "Procedure", "Metodo"];
                $scope.isNew = !!(tarefa && tarefa.TarefaId) === false;

                if (!$scope.isNew) {
                    tarefa.TarefaGrupoId = tarefa.TarefaGrupo.TarefaGrupoId;
                    tarefa.TarefaOrigemTipoId = tarefa.TarefaOrigemTipo.TarefaOrigemTipoId;
                    tarefa.TarefaExecutaTipoId = tarefa.TarefaExecutaTipo.TarefaExecutaTipoId;
                }

                tarefa.Argumentos = tarefa.Argumentos || {};
                $scope.tarefa = tarefa;
                $scope.forms = {};
                $scope.tarefaOrigemTipoList = geradores
                $scope.tarefaExecutaTipoList = executores
                $scope.tarefaRecursoList = recursos
                $scope.tarefaGrupoList = grupos;
                tarefa.PropriedadesGerador = tarefa.PropriedadesGerador || {};
                $scope.tarefaHelpers = {
                    StepTarefaData: {
                        order: 1
                    },
                    StepTipoOrigemData: {
                        order: 2
                    },
                    StepExecutaTipo: {
                        order: 3
                    },
                    TarefaOrigemTipoNome: null,
                    TarefaExecutaTipoNome: null,

                    TarefaOrigemTipoRecorrente: {},
                    TarefaOrigemTipoFila: {
                        ThreadCount: tarefa.PropriedadesGerador.ThreadCount || 1
                    },
                    TarefaOrigemTipoAgendada: {},

                    TarefaExecutaTipoProcedure: {},
                    TarefaExecutaTipoMetodo: {},

                    CronType: "Hora",
                    DiasSemana: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                    CronPorHora: {
                        Every: 1,
                        LimitaHora: false,
                        LimitaDiaSemana: false,
                        DiaSemana: {}
                    },
                    CronPorDia: {
                        Every: 1,
                        HoraInicio: "00:00",
                        LimitaDiaSemana: false,
                        DiaSemana: {}
                    },
                    CronPorSemana: {
                        HoraInicio: "00:00",
                        LimitaDiaSemana: true,
                        DiaSemana: {}
                    }
                }

                angular.forEach($scope.tarefaHelpers.DiasSemana, function (value, index) {
                    $scope.tarefaHelpers.CronPorHora.DiaSemana[index + 1] = true;
                    $scope.tarefaHelpers.CronPorDia.DiaSemana[index + 1] = true;
                    $scope.tarefaHelpers.CronPorSemana.DiaSemana[index + 1] = false;
                });

                $scope.toggle = function (value, list) {
                    if (!list || !list.indexOf) {
                        // eslint-disable-next-line no-console
                        console.error("Lista invalida");
                        return;
                    }

                    var index = list.indexOf(value);
                    if (index > -1) list.splice(index, 1);
                    else list.push(value);
                }

                $scope.changeTipoOrigem = function changeTipoOrigem(id) {
                    $scope.tarefaHelpers.TarefaOrigemTipoNome = null;

                    var tarefaOrigemTipo = _.findWhere($scope.tarefaOrigemTipoList, { TarefaOrigemTipoId: id });

                    if (tiposSuportados.indexOf(tarefaOrigemTipo.Nome) > -1) {
                        $scope.tarefaHelpers.TarefaOrigemTipoNome = tarefaOrigemTipo.Nome
                    }
                }

                $scope.changeTipoExecuta = function changeTipoExecuta(id) {
                    $scope.tarefaHelpers.TarefaExecutaTipoNome = null;

                    var tarefaExecutaTipo = _.findWhere($scope.tarefaExecutaTipoList, { TarefaExecutaTipoId: id });

                    if (tiposSuportados.indexOf(tarefaExecutaTipo.Nome) > -1) {
                        $scope.tarefaHelpers.TarefaExecutaTipoNome = tarefaExecutaTipo.Nome
                    }
                }

                var extractDiasSemana = function (diasDictionary) {
                    var dias = [];
                    var allSelected = true

                    angular.forEach(diasDictionary, function (value, key) {
                        allSelected = allSelected && value
                        if (value) dias.push(key);
                    });

                    if (allSelected) return "*"

                    return dias.sort().join(",") || "*";
                }

                var extractPorHora = function () {
                    var result = "0 ", // segundos
                        horaIni, horaFim;
                    var helper = $scope.tarefaHelpers.CronPorHora;
                    if (!helper.Every) helper.Every = 1;

                    if (helper.LimitaHora) {
                        if (!helper.HoraInicio) helper.HoraInicio = "00:00:00";
                        if (!helper.HoraFim) helper.HoraFim = "23:00:00";

                        horaIni = moment(helper.HoraInicio, "HH:mm");
                        horaFim = moment(helper.HoraFim, "HH:mm");

                        result += horaIni.minute() + " ";

                        if (horaIni.hour() < horaFim.hour()) {
                            result += horaIni.hour() + "-" + horaFim.hour() + "/" + helper.Every;
                        } else {
                            // hora fim menor que inicio, então o job executara entre a hora inicial ate a hora final do dia seguinte 
                            // (jobs que rodam de hora em hora durante a madrugada por exemplo)
                            result += "0-" + horaFim.hour() + "/" + helper.Every + "," + horaIni.hour() + "-23/" + helper.Every;
                        }

                    } else {
                        // executar toda hora
                        result += "0 */" + helper.Every
                    }

                    // qualquer dia do mes, de todos os meses
                    result += " ? * ";

                    result += extractDiasSemana(helper.DiaSemana);
                    //if (helper.LimitaDiaSemana) {

                    //} else {
                    //    // qualquer dia da semana
                    //    result += "*";
                    //}

                    return result + " *"; //qualquer ano
                }

                var extractPorDiaOuSemana = function (isDiario, helper) {
                    var result = "0 ",
                        horaIni;
                    //var helper = $scope.tarefaHelpers.CronPorDia;
                    if (!helper.Every) helper.Every = 1;

                    if (!helper.HoraInicio) helper.HoraInicio = "00:00";
                    horaIni = moment(helper.HoraInicio, "HH:mm");

                    // especificar hora e minuto da execucao
                    result += horaIni.minute() + " " + horaIni.hour() + " ";

                    // especifica a cada quantos dias o job roda (todo dia, a cada 2 dias, etc)
                    result += "?";
                    if (isDiario) {
                        //result += "/" + helper.Every;
                    }

                    // executar todos os meses
                    result += " * ";

                    result += extractDiasSemana(helper.DiaSemana);
                    //if (helper.LimitaDiaSemana) {
                    //    result += extractDiasSemana(helper.DiaSemana);
                    //} else {
                    //    // qualquer dia da semana
                    //    result += "*";
                    //}

                    return result;
                }

                $scope.extractCronExpression = function () {

                    // expressoes suportadas:
                    // http://www.quartz-scheduler.net/documentation/quartz-2.x/tutorial/crontrigger.html
                    // http://crontab.guru/

                    if ($scope.tarefaHelpers.CronType === 'Hora') {
                        return extractPorHora();
                    } else if ($scope.tarefaHelpers.CronType === 'Diario') {
                        return extractPorDiaOuSemana(true, $scope.tarefaHelpers.CronPorDia);
                    }
                    // else if ($scope.tarefaHelpers.CronType === 'Semanal') {
                    //  return extractPorDiaOuSemana(false, $scope.tarefaHelpers.CronPorSemana);
                    //}
                }

                $scope.salvar = function salvar(form) {
                    if (!$scope.isValid(form)) {
                        NotifyService.showInvalid();
                        return;
                    }

                    var isLastStep = (form.$name == 'forms.Execucao');
                    var helpers = $scope.tarefaHelpers;
                    var promise;

                    if (isLastStep && !form.$dirty)
                        $state.go("main.tarefas.list", { page: 'main.tarefas.list' });

                    // montar propriedades do gerador/origem da tarefa
                    if (helpers.TarefaOrigemTipoNome) {
                        tarefa.PropriedadesGerador = helpers["TarefaOrigemTipo" + helpers.TarefaOrigemTipoNome];
                        tarefa.Origem = tarefa.Origem || helpers.TarefaOrigemTipoNome;

                        if (helpers.TarefaOrigemTipoNome === "Agendada") {
                            tarefa.PropriedadesGerador.CronShedule = $scope.extractCronExpression();
                        }
                    }

                    // montar propriedades do executor da tarefa
                    if (helpers.TarefaExecutaTipoNome) {
                        tarefa.PropriedadesExecutor = helpers["TarefaExecutaTipo" + helpers.TarefaExecutaTipoNome];
                        tarefa.Comando = helpers.TarefaExecutaTipoNome;
                    }

                    if ($scope.tarefa.TarefaId > 0)
                        promise = TarefaResource.update($scope.tarefa).$promise;
                    else
                        promise = TarefaResource.save($scope.tarefa).$promise;

                    promise
                        .then(function () {
                            NotifyService.showRegistroSalvo();
                            if (isLastStep && $scope.isNew)
                                $state.go("main.tarefas.list", { page: 'main.tarefas.list' });
                            else
                                form.$dirty = false;
                        })
                        .catch(NotifyService.showError);

                    return promise;
                };

                $scope.isValid = function (form) {
                    if ($scope.isNew)
                        return $scope.forms.Tarefa.$valid && $scope.forms.Tipo.$valid && $scope.forms.Execucao.$valid;
                    else
                        return form.$valid;
                }

                var parseCronHour = function (value) {
                    var re = /([0-9]+)/ig;
                    var matches = value.match(re)

                    // TODO: fazer parser de verdade

                    if (matches.length === 1) {
                        if (value.indexOf("*") === 0) {
                            return {
                                Every: matches[0]
                            }
                        }

                        return {
                            Inicio: matches[0]
                        }
                    }

                    if (matches.length === 3) {
                        return {
                            Inicio: matches[0],
                            Fim: matches[1],
                            Every: matches[2]
                        }
                    }

                    if (matches.length === 6) {
                        return {
                            Inicio: matches[3],
                            Fim: matches[1],
                            Every: matches[2]
                        }
                    }

                    return null;
                }

                var leadingZero = function (text) {
                    return ("00" + (text || "").toString()).substr(-2)
                }

                var parseCronString = function (cronString) {
                    if (!cronString) return;

                    // exemplos: 
                    //    "0 30 10 */1 ? * *"   => todo dia as 10:30 
                    //    "0 0 18-23/1,0-6/1 ? * * *"  => a cada uma hora, entre às 18 da noite e 6 da manhã, todo dia.
                    //    "0 30 23 ? * 2,3,4 *"  => toda segunda, terca e quarta as 23:30

                    var settings = cronString.split(" ");
                    var minute, hour, daySplit;
                    var horaInicio = undefined, horaFim = undefined, every, diasSelecionados, diaSemana, limitaDiaSemana;
                    var isPorHora;

                    $scope.tarefaHelpers.CronType = "Diario";

                    if (settings.length > 1) {
                        // parser dos minutos (segundo campo)
                        minute = settings[1];
                    }

                    if (settings.length > 2) {
                        // parser da hora 
                        hour = parseCronHour(settings[2]);
                        if (hour) {
                            if (hour.Inicio) horaInicio = leadingZero(hour.Inicio) + ":" + leadingZero(minute);
                            if (hour.Fim) horaFim = leadingZero(hour.Fim) + ":" + leadingZero(minute);
                            if (hour.Every) {
                                every = parseInt(hour.Every);
                                isPorHora = true;
                                $scope.tarefaHelpers.CronType = "Hora";
                            }
                        }
                    }

                    if (settings.length > 3) {
                        // parser do dia
                        daySplit = settings[3].split("/");
                        if (daySplit.length > 1) {
                            every = parseInt(daySplit[1]);
                            $scope.tarefaHelpers.CronType = "Diario";
                        }
                    }

                    if (settings.length > 5) {
                        // parser do dia da semana
                        diaSemana = {};
                        if (settings[5] != "*") {
                            limitaDiaSemana = true;
                            diasSelecionados = _.map(settings[5].split(","), function (v) {
                                return parseInt(v)
                            });
                            angular.forEach($scope.tarefaHelpers.DiasSemana, function (value, index) {
                                diaSemana[index + 1] = diasSelecionados.indexOf(index + 1) > -1;
                            });
                        } else {
                            angular.forEach($scope.tarefaHelpers.DiasSemana, function (value, index) {
                                diaSemana[index + 1] = true;
                            });
                        }
                    }

                    var parsed = {
                        HoraInicio: horaInicio || undefined,
                        HoraFim: horaFim || undefined,
                        Every: every || undefined,
                        LimitaHora: !!(horaInicio),
                        LimitaDiaSemana: limitaDiaSemana || undefined,
                        DiaSemana: diaSemana || undefined
                    };

                    if (isPorHora) angular.merge($scope.tarefaHelpers.CronPorHora, parsed);
                    else angular.merge($scope.tarefaHelpers.CronPorDia, parsed);
                    //else angular.merge($scope.tarefaHelpers.CronPorSemana, parsed);
                }

                // se for edit, recuperar propriedades dos geradores
                if (!$scope.isNew) {
                    $scope.changeTipoOrigem(tarefa.TarefaOrigemTipoId);
                    $scope.changeTipoExecuta(tarefa.TarefaExecutaTipoId);
                    $scope.tarefaHelpers["TarefaOrigemTipo" + $scope.tarefaHelpers.TarefaOrigemTipoNome] = tarefa.PropriedadesGerador;
                    $scope.tarefaHelpers["TarefaExecutaTipo" + $scope.tarefaHelpers.TarefaExecutaTipoNome] = tarefa.PropriedadesExecutor;
                    if ($scope.tarefaHelpers.TarefaOrigemTipoNome === "Agendada") parseCronString(tarefa.PropriedadesGerador.CronShedule);
                }

            }]
        );

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("TarefaExecutadaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Tarefa/:TarefaId/Historico/:TarefaExecutadaId",
                { "TarefaId": "@TarefaId", "TarefaExecutadaId": "@TarefaExecutadaId" },
                {
                    reexecutarTarefa: { method: "PUT", url: "Tarefa/:TarefaId/Historico/:TarefaExecutadaId/Executar" },
                    reexecutarTarefasBatch: { method: "PUT", url: "Tarefa/:TarefaId/Historico/Executar" },
                    reexecutarTarefasAll: { method: "PUT", url: "Tarefa/:TarefaId/Historico/Executar/Erros" },
                    excluirErros: { method: "DELETE", url: "Tarefa/:TarefaId/Historico/Erros" }
                });
        }]);

})();

(function () {
    "use strict";

    var pageSizeDefault = 30;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.tarefas.history", StateResolverProvider.configState("/tarefas/{TarefaId:[0-9]+}/history?Erro", "Tarefa", "History",
                    {
                        pageTitle: 'pageTitle.tarefas',
                        pageName: 'campo.historico',
                        permissions: {
                            Tarefas: 'Visualizar'
                        }
                    }));
        }])
        .config(["$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("main.tarefas.historyByName",
                    {
                        url: "/tarefas/history?Nome&Erro",
                        data: { permissions: { Tarefas: 'Visualizar' } },
                        controller: ["$state", "$stateParams", "TarefaResource", function ($state, $stateParams, TarefaResource) {
                            "ngInject";
                            TarefaResource.odata().filter('Nome', $stateParams.Nome).select('TarefaId').query().then(function (tarefa) {
                                var mostrarErro = $state.Erro !== undefined ? $state.Erro : true;
                                if (!tarefa || tarefa.length === 0) {
                                    $state.go("main.tarefas.list");
                                }
                                else {
                                    $state.go("main.tarefas.history", { TarefaId: tarefa[0].TarefaId, Erro: mostrarErro }, {
                                        location: 'replace'
                                    })
                                }
                            });
                        }]
                    })
        }])

        .service("TarefaHistoryData", function TarefaListData() {
            return function () {
                return {
                    tarefa: ["TarefaResource", "$stateParams", function (TarefaResource, $stateParams) {
                        return TarefaResource.get({ TarefaId: $stateParams.TarefaId }).$promise;
                    }],
                    tarefaExecutadaList: ["TarefaExecutadaResource", "$stateParams", function (TarefaExecutadaResource, $stateParams) {
                        var odata = TarefaExecutadaResource.odata().orderBy("TarefaExecutadaId", "desc");
                        if ($stateParams.Erro) odata.filter('Sucesso', false);
                        return odata.page(pageSizeDefault).query({ TarefaId: $stateParams.TarefaId });
                    }]
                }
            }
        })

        .controller("TarefaHistoryController", ["$scope", "tarefaExecutadaList", "TarefaExecutadaResource", "$stateParams", "tarefa", "NotifyService", "ModalService", function ($scope, tarefaExecutadaList, TarefaExecutadaResource, $stateParams, tarefa, NotifyService, ModalService) {
            var tarefaId = $stateParams.TarefaId;
            $scope.search = {};
            if ($stateParams.Erro) {
                $scope.search.Erro = true;
            }

            $scope.tarefasSelected = [];
            $scope.isFila = tarefa.TarefaOrigemTipo.Nome === "Fila";
            $scope.quantidadeErro = tarefa.QuantidadeErros;
            $scope.naoPermiteReprocessamento = tarefa.NaoPermiteReprocessamento ? true : false;

            var updateList = function (list) {
                $scope.tarefaExecutadaList = list;
                $scope.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.search.pageSize = list.$pageSize || pageSizeDefault;
            }

            var getOdataSearch = function () {
                var odata = TarefaExecutadaResource.odata().orderBy("TarefaExecutadaId", "desc");
                var search = $scope.search;

                if (search.DataInicio)
                    odata.filter('Inicio', '>=', search.DataInicio);

                if (search.DataFim)
                    odata.filter('Inicio', '<=', search.DataFim);

                if (search.Erro)
                    odata.filter('Sucesso', false);

                return odata;
            }

            $scope.executeSearch = function () {
                return getOdataSearch()
                    .page($scope.search.pageSize, 1)
                    .query({ TarefaId: tarefaId }).then(updateList).catch(NotifyService.showError);
            }

            var deleteRecord = function (data) {
                return TarefaExecutadaResource.delete(data).$promise
                    .then(function () { $scope.pageChanged($scope.currentPage) })
                    .catch(NotifyService.showError);
            }

            $scope.removeComErro = function () {
                ModalService.confirmMessage('telaHistory.confirmarExclusaoDeRegistrosComErro', null, function () {
                    $scope.quantidadeErro = 0;
                    return TarefaExecutadaResource.excluirErros({ TarefaId: tarefaId }).$promise
                        .then(() => {
                            $scope.pageChanged($scope.currentPage)
                        })
                        .catch(NotifyService.showError);
                });
            }

            $scope.reexecute = function (tarefaExecutada) {
                return TarefaExecutadaResource.reexecutarTarefa({ TarefaId: tarefaId, TarefaExecutadaId: tarefaExecutada.TarefaExecutadaId })
                    .$promise.then($scope.executeSearch);
            }

            $scope.reexecuteBatch = function () {
                var selected = _.where($scope.tarefaExecutadaList, { checked: true, Sucesso: false });

                if (!selected || selected.length === 0) {
                    NotifyService.showMessage('telaHistory.nenhumRegistroSelecionado', 'warning')
                    return;
                }

                var ids = _.pluck(selected, 'TarefaExecutadaId');

                TarefaExecutadaResource.reexecutarTarefasBatch({ TarefaId: tarefaId, TarefaExecutadaIdList: ids }).$promise.then($scope.executeSearch);
            }

            $scope.reexecuteAll = function () {
                var exists = $scope.tarefaExecutadaList.some(x => x.Sucesso == false)
                if (!exists) {
                    NotifyService.showMessage('telaHistory.nenhumRegistroComErro', 'warning')   
                }
                else {
                    TarefaExecutadaResource.reexecutarTarefasAll({ TarefaId: tarefaId }).$promise
                        .then(() => {
                            $scope.executeSearch();
                            NotifyService.showSuccess();
                        }).catch(NotifyService.showError);
                }
            }

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            }

            $scope.openModal = function (tarefaexecutada) {
                $scope.tarefaSelecionada = tarefaexecutada;
                ModalService.openModal('modalTarefaExecutada');
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.search.pageSize, newPage).query({ TarefaId: tarefaId }).then(updateList).catch(NotifyService.showError);
            };

            updateList(tarefaExecutadaList);

        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.tarefas", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.tarefas.list',
                        pageTitle: 'pageTitle.tarefas',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.tarefas.list", StateResolverProvider.configState("/tarefas", "Tarefa", "List", {
                    pageTitle: 'pageTitle.tarefas',
                    pageName: 'pageTitle.pesquisar',

                    css: true,
                }));
        }])

        .service("TarefaListData", function TarefaListData() {
            return function () {
                return {
                    tarefaList: ["TarefaResource", function (TarefaResource) {
                        return TarefaResource.odata().orderBy("TarefaId", "asc").query();
                    }]
                }
            }
        })

        .controller("TarefaListController", ["$scope", "$window", "$filter", "tarefaList", "TarefaResource", "$timeout", "$interval", "$http", "Config", "$rootScope", "$translate", "NotifyService", function ($scope, $window, $filter, tarefaList, TarefaResource, $timeout, $interval, $http, Config,
            $rootScope, $translate, NotifyService) {
            let promiseServicoBackground;
            $scope.versaoAplicacao = $rootScope.appVer;
            $scope.tarefaList = tarefaList;
            $scope.search = {};
            $scope.servicosList = [
                { Nome: "EPBXMANAGER_ATENDIMENTO", Descricao: $translate.instant('telaTarefas.atendimento'), Visivel: true },
                { Nome: "EPBXMANAGER_SUPERVISAO", Descricao: $translate.instant('telaTarefas.supervisao'), Visivel: true },
                { Nome: "EPBXMANAGER_DISCADOR", Descricao: $translate.instant('telaTarefas.discador'), Visivel: true },
                { Nome: "EPBXMANAGER_TALKBOT", Descricao: $translate.instant('telaTarefas.talkbot'), Visivel: true },
                { Nome: "EPBXMANAGER_INDEXACAO", Descricao: $translate.instant('telaTarefas.indexacao'), Visivel: true },
                { Nome: "EPBXMANAGER_INDICADOR", Descricao: $translate.instant('telaTarefas.indicador'), Visivel: true },
                { Nome: "EPBXMANAGER_URA", Descricao: $translate.instant('model.ura'), Visivel: true },
                { Nome: "EPBXMANAGER_BACKGROUND", Descricao: $translate.instant('telaTarefas.background'), Visivel: false },
                { Nome: "EPBXMANAGER_BACKGROUND_1", Descricao: $translate.instant('telaTarefas.configuraTelefonia'), Visivel: true },
                { Nome: "EPBXMANAGER_BACKGROUND_2", Descricao: $translate.instant('telaTarefas.manutencao'), Visivel: true },
                { Nome: "EPBXMANAGER_BACKGROUND_3", Descricao: $translate.instant('telaTarefas.monitoria'), Visivel: true },                
                { Nome: "EPBXMANAGER_BACKGROUND_6", Descricao: $translate.instant('telaTarefas.fila'), Visivel: true },
                { Nome: "EPBXMANAGER_BACKGROUND_7", Descricao: $translate.instant('telaTarefas.bi'), Visivel: true },
                { Nome: "EPBXMANAGER_BILHETE", Descricao: $translate.instant('telaTarefas.bilhete'), Visivel: true },
                { Nome: "EPBXMANAGER_WEBHOOK", Descricao: $translate.instant('telaTarefas.webhook'), Visivel: true }
            ];

            var updateServicosEmExecucao = function () {
                if (promiseServicoBackground) {
                    $interval.cancel(promiseServicoBackground);
                }

                return $http.get(Config.getUrl("ServicoBackground")).then((response) => {
                    let servicosList = response.data;

                    angular.forEach($scope.servicosList, (servico) => {
                        let servicoStatusOk = _.findWhere(servicosList, { Nome: servico.Nome });
                        if (servicoStatusOk) {
                            servico.Status = true;
                            servico.Erro = false;
                            servico.Servidor = servicoStatusOk.Servidor;
                            if (servico.Nome.startsWith("EPBXMANAGER_BACKGROUND_")) {
                                _.findWhere($scope.servicosList, { Nome: "EPBXMANAGER_BACKGROUND" }).Visivel = false;
                            }
                            else if (servico.Nome === "EPBXMANAGER_BACKGROUND") {
                                servico.Visivel = true;
                                _.each($scope.servicosList, function (s) { if (s.Nome.startsWith("EPBXMANAGER_BACKGROUND_")) s.Visivel = false; });
                            }
                        }
                    });

                    promiseServicoBackground = $interval(updateServicosEmExecucao, 15000);
                }).catch(() => {
                    angular.forEach($scope.servicosList, (servico) => {
                        servico.Erro = true;
                    });

                    promiseServicoBackground = $interval(updateServicosEmExecucao, 15000);
                });
            }

            $scope.$on("$destroy", () => {
                $interval.cancel(promiseServicoBackground)
            });

            var filterList = function () {
                var list = $filter('filter')($scope.tarefaList, { Nome: $scope.search.Nome });
                list = $filter('orderBy')(list, 'TarefaGrupo.Descricao');
                list = $filter('groupBy')(list, 'TarefaGrupo.Descricao');
                $scope.tarefaListFiltered = list;
            }

            $scope.onNomeChanged = function () {
                filterList();
            }

            $scope.changeGerador = function (tarefa) {
                let propriedade, label;

                if (angular.isDefined(tarefa.PropriedadesGerador.ThreadCount)) {
                    propriedade = "ThreadCount";
                    label = $translate.instant('telaTarefas.quantidadeDeThreads');
                }
                else if (angular.isDefined(tarefa.PropriedadesGerador.RecurrenceSeconds)) {
                    propriedade = "RecurrenceSeconds";
                    label = $translate.instant('telaTarefas.recorrenciaEmSegundos');
                }

                $window.UIkit.modal.prompt(label || propriedade, tarefa.PropriedadesGerador[propriedade], function (novoValor) {
                    if (!/^[0-9]{1,3}$/g.test(novoValor)) {
                        NotifyService.showError(null, 'telaTarefas.valorInvalido')
                        return;
                    }
                    tarefa.PropriedadesGerador[propriedade] = novoValor;
                    TarefaResource.update(tarefa);
                });
            }

            $scope.toggleTarefaAtiva = function (tarefa) {
                // TODO: Necessario alterar diretiva do switchery, pois o mesmo não reconhece o ng-click do angular
                if (tarefa.Ativo) {
                    return TarefaResource.ativar(tarefa);
                }
                else {
                    return TarefaResource.desativar(tarefa);
                }
            }

            $scope.executeTarefa = function (tarefa) {
                TarefaResource.executeTarefa(tarefa);
                NotifyService.showMessage('telaTarefas.tarefaSendoExecutada', "success");
            }

            function updateTarefaScope(tarefa) {
                if (tarefa.pendingHttp) return;
                tarefa.pendingHttp = true;
                $timeout(() => {
                    TarefaResource.get({ TarefaId: tarefa.TarefaId }).$promise.then((newData) => {
                        var qtdePendente = tarefa.QuantidadePendente;
                        var progresso = tarefa.Progresso;
                        angular.copy(newData, tarefa);
                        tarefa.pendingHttp = false;
                        tarefa.QuantidadePendente = qtdePendente;
                        tarefa.Progresso = progresso;
                    });
                }, 1500);
            }

            $scope.$on("onTarefaChanged", function (event, data) {
                if (data && data.TarefaId) {
                    // se a tarefa esitve na listagem, mostrar barra de progresso
                    for (var i = 0; i < $scope.tarefaList.length; i++) {
                        var tarefa = $scope.tarefaList[i];
                        if (tarefa.TarefaId == data.TarefaId) {
                            updateTarefaScope(tarefa);
                            return;
                        }
                    }
                }
            });

            $scope.$on("onTarefaPendenteChanged", function (event, data) {
                if (data.TarefaId) {
                    // se a tarefa esitve na listagem, mostrar quantidade de mensagens pendentes
                    for (var i = 0; i < $scope.tarefaList.length; i++) {
                        var tarefa = $scope.tarefaList[i];
                        if (tarefa.TarefaId == data.TarefaId) {
                            tarefa.QuantidadePendente = data.QuantidadePendente;
                            return;
                        }
                    }
                }
            });

            $scope.$on("onTarefaProgressoChanged", function (event, data) {
                if (data.TarefaId) {
                    // se a tarefa esitve na listagem, mostrar barra de progresso
                    for (var i = 0; i < $scope.tarefaList.length; i++) {
                        var tarefa = $scope.tarefaList[i];
                        if (tarefa.TarefaId == data.TarefaId) {
                            tarefa.Progresso = data.Progresso < 100 ? data.Progresso : 0;
                            return;
                        }
                    }
                }
            });

            updateServicosEmExecucao();
            filterList();

            $scope.RetornarMensagemTipoOrigem = function (tarefa) {
                if (tarefa.TarefaOrigemTipo.TarefaOrigemTipoId == 2 || tarefa.TarefaOrigemTipo.TarefaOrigemTipoId == 7)
                    if (tarefa.PropriedadesGerador.RecurrenceSeconds != undefined)
                        return $translate.instant('telaTarefas.ExecucaoTipoTarefa').replace('@tempo',tarefa.PropriedadesGerador.RecurrenceSeconds);
                    else
                        return $translate.instant('telaTarefas.TarefaProvida') + ' ' +(tarefa.PropriedadesGerador.ProviderName);
                else
                    return $translate.instant('telaTarefas.TarefaTipoFila');

            }

        }]);
})();
(function () {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("TarefaResource", ["$odataresource", function ($odataresource) {
      return $odataresource("Tarefa/:TarefaId", { "TarefaId": "@TarefaId" },
        {
          geradores: {
            method: "GET",
            url: "Tarefa/GeradorTipo",
            isArray: true
          },
          executores: {
            method: "GET",
            url: "Tarefa/ExecutorTipo",
            isArray: true
          },
          grupos: {
            method: "GET",
            url: "Tarefa/Grupo",
            isArray: true
          },
          recursos: {
            method: "GET",
            url: "Tarefa/Dependencia",
            isArray: true
          },
          executeTarefa: {
            method: "PUT",
            url: "Tarefa/:TarefaId/Executar"
          },
          ativar: {
            method: "PUT",
            url: "Tarefa/:TarefaId/Ativar"
          },
          desativar: {
            method: "PUT",
            url: "Tarefa/:TarefaId/Desativar"
          }
        });
    }]);

})();

(function () {
    "use strict";

    var getOdataSearchShared = function (TelefoneTipoResource, search) {
        var odata = TelefoneTipoResource.odata();
        odata.orderBy("Codigo", "asc");

        angular.forEach(search, function (value, key) {
            if (key !== "pageSize" && value != null && value != '')
                odata.filter(key, value);
        });

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.telefonetipo.edit", StateResolverProvider.configState("/telefonetipo/{Id:[0-9]+}", "TelefoneTipo", "Edit", {
                    pageTitle: 'model.telefoneTipo',
                    pageName: 'acoes.editar'
                }))
                .state("main.telefonetipo.new", StateResolverProvider.configState("/telefonetipo/new", "TelefoneTipo", "Edit", {
                    pageTitle: 'model.telefoneTipo',
                    pageName: 'acoes.cadastrar'
                }));
        }])
        .service('TelefoneTipoEditData', function TelefoneTipoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_masked_inputs',
                            'lazy_uiSelect',
                            'lazy_dropify'
                        ]);
                    }],
                    templateTipo: ["TelefoneTipoTemplateResource", "$stateParams", function (TelefoneTipoTemplateResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TelefoneTipoTemplateResource.get({
                                Id: $stateParams.Id
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    tipos: ["TelefoneTipoResource", "$odata", "$stateParams", "LocalStorageService", function (TelefoneTipoResource, $odata, $stateParams, LocalStorageService) {
                        if ($stateParams.Id) {
                            var filtro = {
                                TelefoneTipoTemplateId: parseInt($stateParams.Id)
                            };

                            if ($stateParams.storage)
                                filtro = LocalStorageService.getItem("FiltroTelefoneTipoTemplate");

                            var orderBy = {
                                column: "Codigo",
                                order: "asc"
                            };

                            var odata = getOdataSearchShared(TelefoneTipoResource, filtro, orderBy, $odata);
                            return odata.query();
                        }
                        return {}
                    }]
                }
            }
        })

        .controller("TelefoneTipoEditController", ["$scope", "$state", "templateTipo", "tipos", "TelefoneTipoTemplateResource", "TelefoneTipoResource", "Config", "$http", "NotifyService", "ModalService", "$translate", function ($scope, $state, templateTipo, tipos, TelefoneTipoTemplateResource, TelefoneTipoResource, Config, $http,
            NotifyService, ModalService, $translate) {
            $scope.Novo = !(templateTipo && templateTipo.Id);
            $scope.tipos = tipos;
            $scope.tiposAtivos = tipos;
            $scope.templateTipo = templateTipo;
            $scope.telefoneTipo = {};
            $scope.forms = {};
            $scope.PreviewStepData = {};

            $scope.filterTipoTelefoneAtivo = function () {
                return _.filter($scope.tipos, function (item) {
                    if (item == null) return null;
                    if (item.Ativo)
                        return item;
                    else
                        return null;
                })
            }

            var updateList = function (list) {
                $scope.tipos = list;
                $scope.permitirExclusao = true;
                $scope.tiposAtivos = $scope.filterTipoTelefoneAtivo();
            };

            $scope.removerTodosTipos = false;
            $scope.permitirExclusao = false;
            $scope.onTodosSelecionados = function () {
                $scope.tipos.forEach(function (el) {
                    el.removerEste = ($scope.removerTodosTipos == true);
                });
                $scope.permitirExclusao = ($scope.removerTodosTipos == true);
                $scope.tiposAtivos = $scope.filterTipoTelefoneAtivo();
            };

            $scope.onTipoSelecionado = function () {
                if ($scope.removerTodosTipos == true) {
                    $scope.removerTodosTipos = false;
                }
                $scope.permitirExclusao = _.find($scope.tipos, function (el) {
                    return el.removerEste == true;
                }) != null;
            }

            updateList(tipos);

            var mensagemSucesso = function (resposta) {
                NotifyService.showRegistroSalvo();

                if ($scope.Novo) {
                    $scope.resposta = {};
                } else {
                    $scope.templateTipo = resposta;
                }

                $state.go('main.telefonetipo.list');
            };

            $scope.modalImportar = function () {
                $('.dropify-wrapper').css('border-color', '#e0e0e0');
                ModalService.openModal('modalTelefoneTipoImportar')
                $scope.needDisable = false;
                $scope.preview = null;
                $('.dropify-wrapper').show();
                $('input-file-a').val('');
                $scope.forms.formImportar.$setPristine();
            };
            
            $scope.salvar = function salvar(valid) {
                if (!valid) {
                    NotifyService.showInvalid();
                    return;
                }

                if ($scope.tipos == undefined || $scope.tipos.length == 0 || $scope.tipos.length == undefined) {
                    NotifyService(null, $translate.instant('telaTelefoneTipoEdit.favorAdicionarUmTipoDeTelefone'));
                    return;
                }
                var promise;
                if ($scope.Novo) {
                    promise = TelefoneTipoTemplateResource.save($scope.templateTipo).$promise;
                    promise.then(function (response) {
                        $scope.telefoneTipo.TelefoneTipoTemplateId = response.Id;
                        angular.forEach($scope.tipos, function (item) {
                            item.TelefoneTipoTemplateId = response.Id;
                        });

                        var newItens = _.filter($scope.tipos, function (item) {
                            return (item.Ativo) ? item : null;
                        });

                        var promiseItens = TelefoneTipoResource.save(newItens).$promise;
                        promiseItens.then(function () {
                            mensagemSucesso();
                        }).catch(NotifyService.showError);
                    }).catch(NotifyService.showError);
                }
                else {
                    promise = TelefoneTipoTemplateResource.update($scope.templateTipo).$promise;
                    promise.then(function (response) {
                        angular.forEach($scope.tipos, function (item) {
                            if (item.Id == undefined && item.Ativo) {
                                item.TelefoneTipoTemplateId = response.Id;
                                var lista = [];
                                lista.push(item);
                                var promiseItens = TelefoneTipoResource.save(lista).$promise;
                                promiseItens.then(function () {
                                }).catch(NotifyService.showError);
                            }
                            else {
                                if (item.Ativo) {
                                    TelefoneTipoResource.update(item).$promise.then(function () {
                                    }).catch(NotifyService.showError);
                                }
                            }
                        });
                        mensagemSucesso();
                    }).catch(NotifyService.showError);
                }

                var IdsDelete = "";
                angular.forEach($scope.tipos, function (item) {

                    if (!item.Ativo)
                        IdsDelete += item.Id + ","
                });

                IdsDelete = IdsDelete.substring(0, IdsDelete.length - 1);
                var url = Config.getUrl('TelefoneTipo/DeletarTelefoneTipos');

                if (IdsDelete.length > 0) {
                    $http({
                        method: 'DELETE',
                        url: url,
                        data: {
                            TemplateId: $scope.tipos[0].TelefoneTipoTemplateId,
                            TelefoneTipoList: IdsDelete
                        },
                        headers: {
                            'Content-type': 'application/json;charset=utf-8'
                        }
                    }).then().catch();
                }
            };

            $scope.editTipoTelefone = function (tipoTelefone) {
                var indexOf = $scope.tipos.indexOf(tipoTelefone);
                $scope.telefoneTipo = Object.assign({}, $scope.tipos[indexOf]);
                $scope.EditTelefoneTipo = indexOf;
                ModalService.openModal('modal_adicionar_tipo');
            }

            $scope.adicionarTipo = function salvar(valid) {
                if (!valid) {
                    NotifyService.showInvalid();
                    return;
                }

                if ($scope.tipos.length == undefined) {
                    $scope.tipos = [];
                }

                if ($scope.EditTelefoneTipo != undefined) {
                    $scope.tipos[$scope.EditTelefoneTipo] = Object.assign({}, $scope.telefoneTipo);
                }
                else {
                    var HasItem = _.filter($scope.tipos, function (item) {
                        return (item.Ativo) ? item.Codigo == $scope.telefoneTipo.Codigo : false;
                    });
                    if (HasItem.length > 0) {
                        NotifyService.showError(null, 'telaTelefoneTipoEdit.codigoJaAdicionado');
                        return;
                    }

                    $scope.tipos.push({
                        Codigo: $scope.telefoneTipo.Codigo,
                        Descricao: $scope.telefoneTipo.Descricao,
                        Ativo: true
                    });
                }
                $scope.tiposAtivos = $scope.filterTipoTelefoneAtivo();
                ModalService.closeModal('modal_adicionar_tipo');
            };

            $scope.voltar = function () {
                $state.go('main.telefonetipo.list');
            };

            $scope.abrirModalAdicionarTipo = function () {
                $scope.telefoneTipo = {};
                $scope.EditTelefoneTipo = undefined;
                $scope.forms.formAdicionarTipo.$setUntouched();
                ModalService.openModal('modal_adicionar_tipo');
                document.getElementById('tbCodigo').focus();
            };

            $scope.confirmDelete = function (tipoTelefone) {
                tipoTelefone.Ativo = false;
                updateList($scope.tipos);
            }

            $scope.startFileUpload = function () {
                ModalService.showLoading();
            }

            $scope.loadFileCompleted = function (result) {
                if (result.length > 0) {
                    $scope.preview = result;
                    $scope.needDisable = true;
                    $('.dropify-wrapper').hide();
                }
                else {
                    NotifyService.showError(null, 'modalTelefoneTipoImportar.naoHaNenhumRegistroNestaPlanilha')
                }
                ModalService.hideLoading();
            };

            $scope.loadFileError = function (error) {
                $scope.preview = null;
                ModalService.hideLoading();
                NotifyService.showError(error, 'notificacoes.erroAoFazerUpload');
            };

            $scope.iniciarProgresso = function (form) {
                if (!form.$valid || !$scope.preview || !$scope.preview.length == 0) {
                    form.$submitted = true;

                    if (!$scope.preview || !$scope.preview.length == 0) {
                        $('.dropify-wrapper').css('border-color', '#e53935');
                    }

                    if ($scope.tipos == undefined || $scope.tipos.length == undefined) {
                        $scope.tipos = [];
                    }
                    $scope.tipos = $scope.tipos.concat($scope.preview);
                    $scope.tiposAtivos = $scope.filterTipoTelefoneAtivo();
                
                    ModalService.closeModal('modalTelefoneTipoImportar');

                    return;
                }

                ModalService.hideLoading();
            }

            $scope.checkExit = function () {
                return ($scope.bloqueioLista && $scope.preview && $scope.canExit);
            };
        }]);
    })
();
(function () {
    "use strict";

    var getOdataSearchShared = function (TelefoneTipoTemplateResource, search, orderBy, $odata) {
        var odata = TelefoneTipoTemplateResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("contains", "Nome", search.Nome), true);
        }

        if (search.Codigo) {
            var filtroRegraId = new $odata.Predicate("x:x/Codigo", search.Codigo).execute(false, true);
            odata.filter(new $odata.Func('TelefoneTipo/any', new $odata.Property(filtroRegraId)));
        }

        angular.forEach(search, function (value, key) {
            if (key !== "pageSize" && value != null && value != '' && key !== 'Nome' && key !== 'Codigo') {
                odata.filter(key, value);
            }
        });

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.telefonetipo", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.telefonetipo.list',
                        pageTitle: 'model.templates',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.telefonetipo.list", StateResolverProvider.configState("/telefonetipo", "TelefoneTipo", "List", {
                    pageTitle: 'model.templates',
                    pageName: 'pageTitle.pesquisar'
                }))
        }])
        .service("TelefoneTipoListData", function TelefoneTipoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_masked_inputs'
                        ]);
                    }],
                    tipoTemplates: ["TelefoneTipoTemplateResource", "$odata", function (TelefoneTipoTemplateResource, $odata) {
                        var orderBy = {
                            column: "Id",
                            order: "desc"
                        };
                        var filtro = {};

                        var odata = getOdataSearchShared(TelefoneTipoTemplateResource, filtro, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }]
                };
            };
        })

        .controller("TelefoneTipoListController", ["$scope", "$odata", "tipoTemplates", "TelefoneTipoTemplateResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", function ($scope, $odata, tipoTemplates, TelefoneTipoTemplateResource, utils, LocalStorageService, $stateParams,
            NotifyService, $state, ModalService) {
            $scope.tipoTemplates = tipoTemplates;
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroTelefoneTipo") : {};
            $scope.orderBy = {
                column: "Id",
                order: "desc"
            };

            var updateList = function (list) {
                $scope.tipoTemplates = list;
                $scope.tipoTemplates.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.tipoTemplates.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(TelefoneTipoTemplateResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroTelefoneTipo', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var deleteRecord = function (data) {
                return TelefoneTipoTemplateResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage);
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.tipoTemplates.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            updateList(tipoTemplates);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroTelefoneTipo');
                $scope.search = {
                    pageSize: 10,
                };
                $scope.executeSearch();
            };

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, { storage: true });
                }
                else {
                    $state.go('main.telefonetipo.list', { storage: true });
                }
            };

            $scope.obterTotal = function (template) {
                var ativo = _.filter(template.TelefoneTipo, (item) => {
                    return item.Ativo == true;
                });
                return ativo.length;
            }

        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("TelefoneTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("TelefoneTipo/:Id", { "Id": "@Id" });
        }])

        .factory("TelefoneTipoTemplateResource", ["$odataresource", function ($odataresource) {
            return $odataresource("TelefoneTipoTemplate/:Id", {
                "Id": "@Id"
            });
        }]);
})();
(function () {
    "use strict";

    angular
        .module("epbxManagerApp")

        // dependencias para o controller
        .service('TemplateEditData', function TemplateEditData() {
            return function () {
                return {
					deps: ["$ocLazyLoad", function($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
                    configuracoes: ["TemplateResource", "$stateParams", function (TemplateResource, $stateParams) {
                        if ($stateParams.TemplateId) {
                            return TemplateResource.query({ TemplateId: $stateParams.TemplateId }).$promise;
                        }
                        else {
                            return {};
                        }
                    }]
                }
            }
        })

        .controller("TemplateEditController",
            ["$scope", "$window", "$http", "Config", "configuracoes", "TemplateResource", "TemplateCampoResource", "TemplateCampoItemResource", function ($scope, $window, $http, Config, configuracoes, TemplateResource, TemplateCampoResource, TemplateCampoItemResource) {

                $scope.configuracoes = configuracoes;


                $scope.TemplateCampoConfig = {
                    maxItems: 1,
                    valueField: 'Valor',
                    labelField: 'Nome',
                    placeholder: 'Selecione o item do ramal'
                };


                $scope.carregarItens = function (item) {

                    item.Itens = [];

                    if (!item.TemplateCampoId) return;

                    TemplateCampoResource.get({ TemplateCampoId: item.TemplateCampoId }).$promise.then(function (data) {
                        item.TemplateCampoTipoId = data.TemplateCampoTipoId;

                        if (data.Fonte) {

                            $http.get(Config.getUrl(data.Fonte.Comando)).then(function (response) {
                                item.Itens = [];
                                angular.forEach(response.data, function (value, index) {
                                    item.Itens.push({ Nome: value[data.Fonte.Nome], Valor: value[data.Fonte.Valor] });
                                })
                            });

                        } else {

                            var odata = TemplateCampoItemResource.odata().orderBy('Nome', 'asc');
                            odata.filter("TemplateCampoId", "=", parseInt(item.TemplateCampoId));
                            odata.query().then(function (values) {
                                item.Itens = [];
                                angular.copy(values, item.Itens);
                            });

                        }
                    });
                };


                $scope.detalhe = function (campo) {

                    var msg = "<h4>Detalhe</h4> </br>" + campo.Descricao;

                    $window.UIkit.modal.alert(msg);
                }

            }]
        );

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templates", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.templates.list',
                        pageTitle: 'model.template',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.templates.list", StateResolverProvider.configState("/templates", "Template", "List", {
                    pageTitle: 'model.template',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.templates.edit", StateResolverProvider.configState("/Template/{TemplateId:[0-9]+}", "Template", "Edit", {
                    pageTitle: 'model.template',
                    pageName: 'acoes.editar'
                }))
        }])

        .service("TemplateListData", function TemplateListData() {
            return function () {
                return {
                    templates: ["TemplateResource", function (TemplateResource) {
                        return TemplateResource.odata().orderBy("TemplateId", "asc").page(10, 1).query();
                    }]
                }
            }
        })

        .controller("TemplateListController",
            ["$scope", "$window", "$odata", "templates", "TemplateResource", "NotifyService", function ($scope, $window, $odata, templates, TemplateResource, NotifyService) {

                $scope.templates = templates;
                $scope.search = {};

                var updateList = function (list) {
                    $scope.templates = list;
                    $scope.recordCount = list.$recordCount || list.length;
                    $scope.currentPage = list.$currentPage || 1;
                    $scope.search.pageSize = list.$pageSize || 10;
                }

                var getOdataSearch = function () {
                    var odata = TemplateResource.odata().orderBy("TemplateId", "asc");
                    var search = $scope.search;

                    odata.filter(new $odata.Func("startswith", "Descricao", search.Descricao), true)

                    return odata;
                }

                $scope.executeSearch = function executeSearch() {
                    getOdataSearch()
                        .page($scope.search.pageSize, 1)
                        .query().then(updateList).catch(NotifyService.showError);
                }

                var deleteRecord = function () {
                    return TemplateResource.delete().$promise
                        .then(function () { $scope.pageChanged($scope.currentPage) })
                        .catch(NotifyService.showError);
                }

                $scope.confirmDelete = function confirmDelete() {
                    $window.UIkit.modal.confirm("Deseja realmente excluir este registro? Esta alteração não poderá ser desfeita.", deleteRecord);
                }

                $scope.pageChanged = function (newPage) {
                    return getOdataSearch()
                        .page($scope.search.pageSize, newPage)
                        .query().then(updateList).catch(NotifyService.showError);
                };

                updateList(templates);

            }]
        );

})();

(function() {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("TemplateResource", ["$odataresource", function($odataresource) {
      return $odataresource("Template/:TemplateId", { "TemplateId" : "@TemplateId" });
    }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateCampanhaPeriodo.edit", StateResolverProvider.configState("/TemplateCampanhaPeriodo/{Id:[0-9]+}", "TemplateCampanhaPeriodo", "Edit", {
                    pageTitle: 'model.templateCampanhaPeriodo',
                    pageName: 'acoes.editar',
                }))
                .state("main.templateCampanhaPeriodo.new", StateResolverProvider.configState("/TemplateCampanhaPeriodo/new", "TemplateCampanhaPeriodo", "Edit", {
                    pageTitle: 'model.templateCampanhaPeriodo',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("TemplateCampanhaPeriodoEditData", function TemplateCampanhaPeriodoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    templateCampanhaPeriodo: ["TemplateCampanhaPeriodoResource", "$stateParams", function (TemplateCampanhaPeriodoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TemplateCampanhaPeriodoResource.get({ Id: parseInt($stateParams.Id) }).$promise;
                        } else {
                            let templateCampanhaPeriodo = {};
                            return templateCampanhaPeriodo;
                        }
                    }],
                    diaSemana: ["$translate", function ($translate) {
                        return {
                            0: $translate.instant('dias.domingo'),
                            1: $translate.instant('dias.segunda'),
                            2: $translate.instant('dias.terca'),
                            3: $translate.instant('dias.quarta'),
                            4: $translate.instant('dias.quinta'),
                            5: $translate.instant('dias.sexta'),
                            6: $translate.instant('dias.sabado')
                        };
                    }]
                };
            };
        })

        .controller("TemplateCampanhaPeriodoEditController", ["$scope", "ModalService", "NotifyService", "templateCampanhaPeriodo", "$state", "$translate", "$stateParams", "diaSemana", "TemplateCampanhaPeriodoResource", function ($scope, ModalService, NotifyService, templateCampanhaPeriodo,
            $state, $translate, $stateParams, diaSemana, TemplateCampanhaPeriodoResource) {
            $scope.isNew = (templateCampanhaPeriodo.Id > 0 ? false : true);
            $scope.templateCampanhaPeriodo = templateCampanhaPeriodo;

            $scope.forms = {};
            templateCampanhaPeriodo.Id = (templateCampanhaPeriodo.Id > 0 ? templateCampanhaPeriodo.Id
                : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.campanhasAssociadasList = [];
            $scope.campanhasNaoAssociadasList = [];
            $scope.cloneCampanhaId = null;

            $scope.descricoesColunas = {
                CampanhaId: 'campo.codigoDaCampanha',
                Nome: 'telaTemplateRegraEdit.nomeDaCampanha'
            }

            $scope.isHorariosInvalidos = false;

            if ($scope.isNew) {
                $scope.templateCampanhaPeriodo.Periodos = [];

                for (let name in diaSemana) {
                    $scope.templateCampanhaPeriodo.Periodos.push({
                        Dia: name,
                        DiaSemana: diaSemana[name],
                        CampanhaId: 0,
                        HoraInicio: new Date(16, 1, 1, 9, 0, 0, 0),
                        HoraTermino: new Date(16, 1, 1, 18, 0, 0, 0),
                        Ativo: true
                    });
                }
            } else {
                $scope.templateCampanhaPeriodo.Periodos.forEach(periodo => {
                    periodo.DiaSemana = diaSemana[periodo.Dia];
                });
            }

            $scope.adicionarPeriodo = function (dia) {
                $scope.templateCampanhaPeriodo.Periodos.push({
                    Dia: dia,
                    DiaSemana: diaSemana[dia],
                    Ativo: true
                });

                $scope.forms.formHorarios.$setDirty();
            }

            $scope.removerPeriodo = function (index) {
                ModalService.confirmDelete(() => {
                    delete $scope.templateCampanhaPeriodo.Periodos[index];
                    $scope.templateCampanhaPeriodo.Periodos.splice(index, 1);
                });

                $scope.forms.formHorarios.$setDirty();
            }

            $scope.onChangeAtivo = function (item) {

                if (item.Dia == 0 && item.Ativo) {
                    ModalService.alert($translate.instant('telaEditTemplateCampanhaPeriodo.alertDomingo'));
                }

            }

            $scope.existeHorarioInvalido = function () {
                let invalid = $scope.templateCampanhaPeriodo.Periodos.find(horario => horario.Valido == false);
                $scope.isHorariosInvalidos = (invalid != null ? true : false);
            }

            $scope.getCampanhaNaoAssociadas = function () {
                TemplateCampanhaPeriodoResource.getCampanhaNaoAssociadas({ 'Id': templateCampanhaPeriodo.Id }).$promise
                    .then((data) => {
                        $scope.campanhasNaoAssociadasList = data;
                        if ($scope.cloneCampanhaId != undefined && $scope.cloneCampanhaId != null) {
                            $scope.cloneCampanha = _.findWhere($scope.campanhasNaoAssociadasList, { CampanhaId: $scope.cloneCampanhaId });
                            $scope.campanhasNaoAssociadasList = _.without($scope.campanhasNaoAssociadasList, $scope.cloneCampanha);
                        }
                        $scope.getCampanhaAssociadas();
                    });
            };

            $scope.getCampanhaAssociadas = function () {
                TemplateCampanhaPeriodoResource.getCampanhaAssociadas({ 'Id': templateCampanhaPeriodo.Id }).$promise
                    .then((data) => {
                        $scope.campanhasAssociadasList = data;
                        if ($scope.cloneCampanhaId != undefined && $scope.cloneCampanhaId != null) {
                            $scope.campanhasAssociadasList.push({
                                'Adicionado': true,
                                'Alterado': false,
                                'CampanhaId': $scope.cloneCampanhaId,
                                'CampanhaNome': $scope.cloneCampanha.CampanhaNome,
                                'Removido': false,
                                'Selecionado': false
                            });
                        }
                    });
            };

            $scope.getCampanhaNaoAssociadas();

            $scope.salvar = function () {
                let promise;
                let quantidadeInvalidos = $scope.templateCampanhaPeriodo.Periodos.filter((element) => (!element.HoraInicio || !element.HoraTermino)).length;

                let list = [];

                $scope.templateCampanhaPeriodo.Periodos.forEach(y => {
                    $scope.campanhasAssociadasList.forEach(x => {
                        list.push({ TemplateCampanhaPeriodoId: $stateParams.Id, CampanhaId: x.CampanhaId, Dia: y.Dia, HoraInicio: y.HoraInicio, HoraTermino: y.HoraTermino, Ativo: y.Ativo });
                    });
                });

                if (quantidadeInvalidos > 0) {
                    return NotifyService.showError(null, 'validacao.existemHorariosInvalidos', { Quantidade: quantidadeInvalidos })
                }

                if ($scope.campanhasAssociadasList.length == 0) {
                    return NotifyService.showError(null, 'telaEditTemplateCampanhaPeriodo.validarCampanha')
                }

                if (list.length == 0) {
                    return NotifyService.showError(null, 'telaEditTemplateCampanhaPeriodo.validarJornada')
                }

                $scope.templateCampanhaPeriodo.Periodos = list;

                if ($scope.isNew) {
                    promise = TemplateCampanhaPeriodoResource.save($scope.templateCampanhaPeriodo).$promise;
                } else {
                    promise = TemplateCampanhaPeriodoResource.update($scope.templateCampanhaPeriodo).$promise;
                }

                $scope.saving = true;
                promise
                    .then(() => {
                        $scope.saving = false;
                        let message = $scope.isNew ? 'telaEditTemplateCampanhaPeriodo.templateAdicionadoComSucesso' : 'telaEditTemplateCampanhaPeriodo.templateAlteradoComSucesso';
                        NotifyService.showSuccess($translate.instant(message));
                        $state.go('main.templateCampanhaPeriodo.list');
                    })
                    .catch(() => {
                        $scope.saving = false;
                        NotifyService.showError
                    });
            }

            $scope.validateNome = function () {
                let alterado = $scope.isNew ? false : $scope.forms.formNome.$dirty;
                let proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formNome.$dirty = false;
                        $scope.forms.formNome.$setPristine();
                    });
                } else {
                    proximoStep = $scope.forms.formNome.$valid ? true : false;
                }

                return proximoStep;
            };

            $scope.validateHorario = function () {
                let alterado = $scope.isNew ? false : $scope.forms.formHorarios.$dirty;
                let proximoStep = false;

                if (alterado) {
                    ModalService.confirmSalvar(() => {
                        $scope.forms.formHorarios.$dirty = false;
                        $scope.forms.formHorarios.$setPristine();
                    });
                } else {
                    proximoStep = $scope.forms.formHorarios.$valid ? true : false;
                }

                return proximoStep;
            };
        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (TemplateCampanhaPeriodoResource, search, orderBy, $odata) {
        var odata = TemplateCampanhaPeriodoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }
        return odata;
    };

    angular.module("epbxManagerApp")
    
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateCampanhaPeriodo", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.templateCampanhaPeriodo.list',
                        pageTitle: 'pageTitle.templateCampanhaPeriodo',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.templateCampanhaPeriodo.list", StateResolverProvider.configState("/TemplateCampanhaPeriodo", "TemplateCampanhaPeriodo", "List", {
                    pageTitle: 'pageTitle.templateCampanhaPeriodo',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])

        .service("TemplateCampanhaPeriodoListData", function TemplateCampanhaPeriodoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    templateCampanhaPeriodo: ["TemplateCampanhaPeriodoResource", "LocalStorageService", "$odata", "$stateParams", function (TemplateCampanhaPeriodoResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = { 'Ativo': 1 };
                        var orderBy = { column: "Id", order: "desc" }
                        if ($stateParams.storage) {s
                            filtro = LocalStorageService.getItem("FiltroTemplateCampanhaPeriodo");
                        }
                        return getOdataSearchShared(TemplateCampanhaPeriodoResource, filtro, orderBy, $odata).page(10, 1).query();
                    }]
                }
            }
        })

        .controller("TemplateCampanhaPeriodoListController", ["$scope", "$odata", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "templateCampanhaPeriodo", "TemplateCampanhaPeriodoResource", function ($scope, $odata, utils, LocalStorageService, 
            $stateParams, NotifyService, ModalService, templateCampanhaPeriodo, TemplateCampanhaPeriodoResource) {
            $scope.templateCampanhaPeriodo = templateCampanhaPeriodo;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroTemplateCampanhaPeriodo") : {};

            $scope.orderBy = {
                column: "Id",
                order: "desc"
            };

            $scope.errorObject = {};

            let updateList = function (list) {
                $scope.templateCampanhaPeriodo = list;
                $scope.templateCampanhaPeriodo.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.templateCampanhaPeriodo.pageSize = list.$pageSize || 10;
            };

            let getOdataSearch = function () {
                return getOdataSearchShared(TemplateCampanhaPeriodoResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.templateCampanhaPeriodo.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroTemplateCampanhaPeriodo', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroTemplateCampanhaPeriodo');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            let deleteTemplateCampanhaPeriodo = function (data) {
                return TemplateCampanhaPeriodoResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteTemplateCampanhaPeriodo(data));
            };

            $scope.exibirErro = function (data) {
                $scope.errorObject = data.ErrorObject;
                ModalService.openModal('modalErrorMessage');
            }

            updateList($scope.templateCampanhaPeriodo);
        }]);
})();

(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("TemplateCampanhaPeriodoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("TemplateCampanhaPeriodo/:Id", { "Id": "@Id" },
                {
                    getCampanhaNaoAssociadas: {
                        method: "GET",
                        url: "TemplateCampanhaPeriodo/CampanhaNaoAssociadas",
                        isArray: true
                    },
                    getCampanhaAssociadas: {
                        method: "GET",
                        url: "TemplateCampanhaPeriodo/CampanhaAssociadas",
                        isArray: true
                    },
                    getPeriodoHorario: {
                        method: "GET",
                        url: "TemplateCampanhaPeriodo/GetHorarioById",
                        isArray: true
                    }
                });
        }]);
})();
(function() {
  "use strict";

  angular.module("epbxManagerApp")

      .service("TemplateCampoListData", function TemplateCampoListData() {
          return function () {
            return {
              templatecampos : ["TemplateCampoResource", function(TemplateCampoResource) {
                return TemplateCampoResource.odata().orderBy("TemplateCampoId", "asc").page(10, 1).query();
              }]
            }
          }
      })

    .controller("TemplateCampoListController",
      ["$scope", "$window", "templatecampos", "TemplateCampoResource", "NotifyService", function($scope, $window, templatecampos, TemplateCampoResource, NotifyService) {
        
        $scope.templatecampos = templatecampos;
        $scope.search = {};
        
        var updateList = function(list) {
          $scope.templatecampos = list;
          $scope.recordCount = list.$recordCount || list.length;
          $scope.currentPage = list.$currentPage || 1;
          $scope.search.pageSize = list.$pageSize || 10;
        }
        
        var getOdataSearch = function () {
          var odata = TemplateCampoResource.odata().orderBy("TemplateCampoId", "asc");
          angular.forEach($scope.search, function (value, key) {
            if(key !== "pageSize")
                odata.filter(key, value);
          });

          return odata;
        }

        $scope.executeSearch = function executeSearch() {
          getOdataSearch()
          .page($scope.search.pageSize, 1)
          .query().then(updateList).catch(NotifyService.showError);
        }
        
        var deleteRecord = function() {
            return TemplateCampoResource.delete(data).$promise
                .then(function () { $scope.pageChanged($scope.currentPage) })
                .catch(NotifyService.showError);
        }
        
        $scope.confirmDelete = function confirmDelete(data) {
          $window.UIkit.modal.confirm("Deseja realmente excluir este registro? Esta alteração não poderá ser desfeita.", deleteRecord);
        }

        $scope.pageChanged = function(newPage) {
          return getOdataSearch()
                .page($scope.search.pageSize, newPage)
                .query().then(updateList).catch(NotifyService.showError);
        };

        updateList(templatecampos);
        
      }]
    );

})();

(function () {
    "use strict";

    angular
        .module("epbxManagerApp")

        // dependencias para o controller
        .service('TemplateCampoEditData', function TemplateCampoEditData() {
            return function () {
                return {
					deps: ["$ocLazyLoad", function($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_uiSelect'
						]);
					}],
                    templatecampo: ["TemplateCampoResource", "$stateParams", function (TemplateCampoResource, $stateParams) {
                        if ($stateParams.TemplateCampoId) {
                            return TemplateCampoResource.get({ TemplateCampoId: $stateParams.TemplateCampoId }).$promise;
                        }
                        else {
                            return {};
                        }
                    }]
                }
            }
        })

        .controller("TemplateCampoEditController",
            ["$scope", "templatecampo", "NotifyService", "TemplateCampoResource", function ($scope, templatecampo, NotifyService, TemplateCampoResource) {

                $scope.InserirOuEditar = templatecampo && templatecampo.TemplateCampoId ? "Editar" : "Inserir";
                $scope.templatecampo = templatecampo;

                $scope.templateConfig = {
                    maxItems: 1,
                    valueField: 'TemplateId',
                    labelField: 'Descricao',
                    create: false,
                    placeholder: 'Selecione o template'
                };

                $scope.salvar = function salvar() {
                    var promise;
                    if ($scope.templatecampo.TemplateCampoId > 0)
                        promise = TemplateCampoResource.update($scope.templatecampo).$promise;
                    else
                        promise = TemplateCampoResource.save($scope.templatecampo).$promise;

                    promise.then(function () {
                        NotifyService.showRegistroSalvo();
                        $scope.templatecampo = {};
                    }).catch(NotifyService.showError);
                };
            }]
        );

})();

(function() {
  "use strict";

  angular.module('epbxManagerApp')
    .factory("TemplateCampoResource", ["$odataresource", function($odataresource) {
      return $odataresource("TemplateCampo/:TemplateCampoId", { "TemplateCampoId" : "@TemplateCampoId" });
    }]);

})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateFeriado.edit", StateResolverProvider.configState("/templateFeriado/{Id:[0-9]+}", "TemplateFeriado", "Edit", {
                    pageTitle: 'model.templateFeriado',
                    pageName: 'acoes.editar',
                }))
                .state("main.templateFeriado.new", StateResolverProvider.configState("/templateFeriado/new", "TemplateFeriado", "Edit", {
                    pageTitle: 'model.templateFeriado',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("TemplateFeriadoEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    templateFeriado: ["TemplateFeriadoResource", "$stateParams", function (TemplateFeriadoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TemplateFeriadoResource.get({ Id: parseInt($stateParams.Id) }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    meses: ["$translate", function ($translate) {
                        return [
                            { id: 0, mes: $translate.instant('form.placeholderSelect'), dias: 0 },
                            { id: 1, mes: $translate.instant('meses.janeiro'), dias: 31 },
                            { id: 2, mes: $translate.instant('meses.fevereiro'), dias: 29 },
                            { id: 3, mes: $translate.instant('meses.marco'), dias: 31 },
                            { id: 4, mes: $translate.instant('meses.abril'), dias: 30 },
                            { id: 5, mes: $translate.instant('meses.maio'), dias: 31 },
                            { id: 6, mes: $translate.instant('meses.junho'), dias: 30 },
                            { id: 7, mes: $translate.instant('meses.julho'), dias: 31 },
                            { id: 8, mes: $translate.instant('meses.agosto'), dias: 31 },
                            { id: 9, mes: $translate.instant('meses.setembro'), dias: 30 },
                            { id: 10, mes: $translate.instant('meses.outubro'), dias: 31 },
                            { id: 11, mes: $translate.instant('meses.novembro'), dias: 30 },
                            { id: 12, mes: $translate.instant('meses.dezembro'), dias: 31 }
                        ]
                    }],
                    anos: ["$translate", function ($translate) {
                        let years = [{ id: null, descricao: $translate.instant('campo.todos') }];
                        let anoAtual = moment().year();
                        let anoFim = moment().add(10, 'years').year();

                        for (let i = anoAtual; i <= anoFim; i++) {
                            years.push({ id: i, descricao: i });
                        }

                        return years;
                    }],
                    estados: ["$translate", function ($translate) {
                        return [
                            { nome: $translate.instant('campo.todos'), uf: null },
                            { nome: "Acre", uf: "AC" },
                            { nome: "Alagoas", uf: "AL" },
                            { nome: "Amapá", uf: "AP" },
                            { nome: "Amazonas", uf: "AM" },
                            { nome: "Bahia", uf: "BA" },
                            { nome: "Ceará", uf: "CE" },
                            { nome: "Distrito Federal", uf: "DF" },
                            { nome: "Espírito Santo", uf: "ES" },
                            { nome: "Goiás", uf: "GO" },
                            { nome: "Maranhão", uf: "MA" },
                            { nome: "Mato Grosso", uf: "MT" },
                            { nome: "Mato Grosso do Sul", uf: "MS" },
                            { nome: "Minas Gerais", uf: "MG" },
                            { nome: "Pará", uf: "PA" },
                            { nome: "Paraíba", uf: "PB" },
                            { nome: "Paraná", uf: "PR" },
                            { nome: "Pernambuco", uf: "PE" },
                            { nome: "Piauí", uf: "PI" },
                            { nome: "Rio de Janeiro", uf: "RJ" },
                            { nome: "Rio Grande do Norte", uf: "RN" },
                            { nome: "Rio Grande do Sul", uf: "RS" },
                            { nome: "Rondônia", uf: "RO" },
                            { nome: "Roraima", uf: "RR" },
                            { nome: "Santa Catarina", uf: "SC" },
                            { nome: "São Paulo", uf: "SP" },
                            { nome: "Sergipe", uf: "SE" },
                            { nome: "Tocantins", uf: "TO" }
                        ]
                    }],
                    campanhasAssociadas: ["TemplateFeriadoResource", "$stateParams", function (TemplateFeriadoResource, $stateParams) {
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;             
                        return TemplateFeriadoResource.GetCampanhasAssociadas({
                            TemplateFeriadoId: id
                        }).$promise;
                    }],
                    campanhasNaoAssociadas: ["TemplateFeriadoResource", "$stateParams", function (TemplateFeriadoResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return TemplateFeriadoResource.GetCampanhasNaoAssociadas({
                            TemplateFeriadoId: id
                        }).$promise;
                    }]
                };
            };
        })

        .controller("TemplateFeriadoEditController", ["$scope", "ModalService", "NotifyService", "templateFeriado", "meses", "anos", "estados", "TemplateFeriadoResource", "campanhasNaoAssociadas", "campanhasAssociadas", "$stateParams", "$state", "$translate", function ($scope, ModalService, NotifyService, templateFeriado,
            meses, anos, estados, TemplateFeriadoResource, campanhasNaoAssociadas, campanhasAssociadas, $stateParams, $state, $translate) {
            $scope.isNew = (isNaN(parseInt($stateParams.Id)) ? true : false);
            $scope.currentPage = 1;
            $scope.templateFeriado = templateFeriado;
            $scope.feriados = [];
            $scope.feriado = {};
            $scope.forms = {};
            $scope.search = {};
            $scope.meses = meses;
            $scope.anos = anos;
            $scope.estados = estados;
            $scope.campanhasAssociadas = campanhasAssociadas;
            $scope.campanhasNaoAssociadas = campanhasNaoAssociadas;

            $scope.descricoesColunas = {
                CampanhaId: 'campo.codigoDaCampanha',
                Nome: 'model.nomeCampanha'
            }

            $scope.salvar = function () {
                let promise;
                $scope.templateFeriado.Feriados = $scope.feriados;
                $scope.templateFeriado.CampanhaIds = $scope.campanhasAssociadas.map(x => x.CampanhaId).join(',');

                if ($scope.isNew) {
                    promise = TemplateFeriadoResource.save($scope.templateFeriado).$promise;
                } else {
                    promise = TemplateFeriadoResource.update($scope.templateFeriado).$promise;
                }
                promise
                    .then(() => {
                        let message = $scope.isNew ? 'telaEditFeriado.templateAdicionadoComSucesso' : 'telaEditFeriado.templateAlteradoComSucesso';

                        NotifyService.showSuccess($translate.instant(message));
                        $state.go('main.templateFeriado.list');
                    })
                    .catch(NotifyService.showError);
            }

            /* Início dos métodos de feriado */

            if (!$scope.isNew) {
                if (templateFeriado.Feriados) {
                    templateFeriado.Feriados.forEach((feriado) => {
                        feriado.Data = `${minTwoDigits(feriado.Dia)}/${minTwoDigits(feriado.Mes)}` + (feriado.Ano ? `/${feriado.Ano}` : '');
                    });
                }

                $scope.feriados = templateFeriado.Feriados;
            }

            function minTwoDigits(n) {
                return (n < 10 ? '0' : '') + n;
            }

            function validarFeriado(feriado) {
                if (!feriado.Mes) {
                    return NotifyService.showError(null, $translate.instant('modalFeriado.informeOMes'));
                }

                if (!feriado.Dia) {
                    return NotifyService.showError(null, $translate.instant('modalFeriado.informeODia'));
                }

                let feriadoExistente = $scope.feriados.find(x =>
                    (x.UF == feriado.UF || x.UF == null || feriado.Nacional == null) &&
                    x.Dia == feriado.Dia &&
                    x.Mes == feriado.Mes &&
                    (x.Ano == feriado.Ano || !x.Ano || x.Ano == null || !feriado.Ano || feriado.Ano == null));

                if (feriadoExistente !== undefined) {
                    return NotifyService.showError(null, $translate.instant('modalFeriado.jaExisteFeriadoComEstaData'));
                }

                return true;
            }

            $scope.adicionarFeriado = function () {
                let feriado = $scope.feriado;

                if (!$scope.isNew) {
                    feriado.TemplateId = parseInt($stateParams.Id);
                }

                if (!validarFeriado(feriado)) {
                    return false;
                }

                feriado.Data = `${minTwoDigits(feriado.Dia)}/${minTwoDigits(feriado.Mes)}` + (feriado.Ano ? `/${feriado.Ano}` : '');
                feriado.Nacional = (feriado.UF == null);
                $scope.feriados.push(feriado);
                NotifyService.showSuccess($translate.instant('modalFeriado.feriadoAdicionadoComSucesso'));
                ModalService.closeModal('modal_feriado');
            };

            $scope.deleteFeriado = function (idx, currentPage) {
                idx = idx + ((currentPage - 1) * 10)

                ModalService.confirmDelete(() => {
                    $scope.feriados.splice(idx, 1);
                    NotifyService.showSuccess($translate.instant('modalFeriado.feriadoExcluidoComSucesso'));
                });
            };

            $scope.abrirModalFeriado = function () {
                ModalService.openModal('modal_feriado', function () {
                    $scope.feriado = {};
                });
            }

            $scope.onChangeMes = function (idMes) {
                if (idMes != null) {
                    let dias = [];
                    let qtdDias = meses.find(x => x.id == idMes).dias;

                    for (let i = 1; i <= qtdDias; i++) {
                        dias.push({ id: i });
                    }

                    $scope.dias = dias;
                } else {
                    $scope.dias = [];
                }
            }

            $scope.pesquisarFeriados = function () {
                let descricao = $scope.search.descricao;
                let mes = $scope.search.mes;

                if ((descricao == null || descricao == '' || descricao == undefined) &&
                    (mes == null || mes == '' || mes == undefined)) {
                    $scope.feriados = $scope.templateFeriado.Feriados;
                } else {
                    if (descricao !== null && descricao !== '' && descricao !== undefined) {
                        $scope.feriados = _.filter($scope.templateFeriado.Feriados, feriado => {
                            return feriado.Descricao.toLowerCase().startsWith(descricao.toLowerCase());
                        });
                    }

                    if (mes !== null && mes > 0) {
                        $scope.feriados = _.filter($scope.templateFeriado.Feriados, feriado => {
                            return feriado.Mes == mes;
                        });
                    }
                }
            }

            $scope.limparPesquisa = function () {
                $scope.search = {
                    mes: 0
                };
                $scope.pesquisarFeriados();
            }

            /* Fim dos métodos de feriado */
        }]);
})();

(function () {
	"use strict";

	let defaultPageSize = 15;

	let getOdataSearchShared = function (TemplateFeriadoResource, search, $odata) {
		let filtroId, odata = TemplateFeriadoResource.odata();

		if (search.Id) {
			filtroId = new $odata.Predicate("x:x/Id", parseInt(search.Id)).execute(false, true);
			odata.filter(new $odata.Func('TemplateFeriado/any', new $odata.Property(filtroId)));
		}

		
        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }

		odata.orderBy("Id", "asc");

		return odata;
	};

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.templateFeriado", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.templateFeriado.list',
						pageTitle: 'model.templateFeriado',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.templateFeriado.list", StateResolverProvider.configState("/templateFeriado", "TemplateFeriado", "List", {
					pageTitle: 'model.templateFeriado',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("TemplateFeriadoListData", function () {
			return function () {
				return {
					templateFeriados: ["TemplateFeriadoResource", "LocalStorageService", "$odata", "$stateParams", function (TemplateFeriadoResource, LocalStorageService, $odata, $stateParams) {
						let filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroTemplateFeriado");
						}
						let odata = getOdataSearchShared(TemplateFeriadoResource, filtro, $odata);
						return odata.page(defaultPageSize, 1).query();
					}]
				}
			}
		})

		.controller("TemplateFeriadoListController", ["$scope", "templateFeriados", "LocalStorageService", "$stateParams", "ModalService", "$state", "TemplateFeriadoResource", "NotifyService", "$odata", function ($scope, templateFeriados, LocalStorageService, $stateParams,
			ModalService, $state, TemplateFeriadoResource, NotifyService, $odata) {
			$scope.templateFeriados = templateFeriados;
			$scope.searching = false;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroTemplateFeriado") : {};

			let updateList = function (list) {
				$scope.templateFeriados = list;
				$scope.templateFeriados.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.templateFeriados.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			let getOdataSearch = function () {
				return getOdataSearchShared(TemplateFeriadoResource, $scope.search, $odata);
			};

			let deleteRecord = function (trashObject) {
				return TemplateFeriadoResource.delete({ Id: trashObject.Id }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroTemplateFeriado', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.templateFeriados.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroTemplateFeriado');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, { storage: true });
				}
				else {
					$state.go('main.templateFeriado.list', { storage: true });
				}
			};

			updateList(templateFeriados);
		}]);
})();

(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("TemplateFeriadoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("TemplateFeriado/:Id", { "Id": "@Id" },
                {
                    deleteFeriado: {
                        method: "DELETE",
                        url: "TemplateFeriado/DeleteFeriado/:FeriadoId",
                        params: { "feriadoId": "@FeriadoId" }
                    },
                    GetCampanhasAssociadas: {
                        url: "TemplateFeriado/CampanhasAssociadas/:TemplateFeriadoId",
                        method: "GET",
                        isArray: true
                    },
                    GetCampanhasNaoAssociadas: {
                        url: "TemplateFeriado/CampanhasNaoAssociadas/:TemplateFeriadoId",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .service('TemplateImportacaoEditData', function TemplateImportacaoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    template: ["TemplateImportacaoResource", "$stateParams", function (TemplateImportacaoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TemplateImportacaoResource.get({ Id: $stateParams.Id }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    formatosList: ["TemplateImportacaoResource", function (TemplateImportacaoResource) {
                        return TemplateImportacaoResource.getFormatos().$promise
                    }]
                }
            }
        })

        .controller("TemplateImportacaoEditController", ["$scope", "$window", "$state", "$stateParams", "template", "TemplateImportacaoResource", "FileDownloadService", "NotifyService", "$translate", "ModalService", function TemplateImportacaoEditController($scope, $window, $state, $stateParams, template,
            TemplateImportacaoResource, FileDownloadService, NotifyService, $translate, ModalService) {
            $scope.forms = {};
            $scope.ordem = {};
            $scope.camposList = [];
            $scope.camposObrigatoriosList = [
                { 'Filtro': false, 'ApenasIgualdade': true, 'Valor': 'CampanhaId', 'Descricao': $translate.instant('campo.codigoDaCampanha') },
                { 'Filtro': true, 'ApenasIgualdade': true, 'Valor': 'CodigoCliente', 'Descricao': $translate.instant('campo.codigoDoCliente') },
                { 'Filtro': true, 'ApenasIgualdade': true, 'Valor': 'DDD', 'Descricao': $translate.instant('campo.ddd') },
                { 'Filtro': true, 'ApenasIgualdade': true, 'Valor': 'Numero', 'Descricao': $translate.instant('telaTemplateImportacaoEdit.numeroTelefone') }
            ];
            $scope.camposOpcionaisList = [
                { 'Filtro': false, 'ApenasIgualdade': false,'Valor': 'Nome', 'Descricao': $translate.instant('telaTemplateImportacaoEdit.nomeCliente') },
                { 'Filtro': false, 'ApenasIgualdade': false,'Valor': 'NumeroTipo', 'Descricao': $translate.instant('model.telefoneTipo') },
                { 'Filtro': false, 'ApenasIgualdade': false,'Valor': 'InfoAdicional', 'Descricao': $translate.instant('telaTemplateImportacaoEdit.infoAdicional') },
                { 'Filtro': false, 'ApenasIgualdade': false, 'Valor': 'DataAgendamento', 'Descricao': $translate.instant('telaTemplateImportacaoEdit.dataAgendamento') },
                { 'Filtro': false, 'ApenasIgualdade': false, 'Valor': 'RamalAgendamento', 'Descricao': $translate.instant('telaTemplateImportacaoEdit.ramalAgendamento') },
                { 'Filtro': true, 'ApenasIgualdade': true, 'Valor': 'UF', 'Descricao': 'UF' }
            ];

            $scope.todosCamposList = $scope.camposObrigatoriosList.concat($scope.camposOpcionaisList);

            $scope.Campo = {};
            // Template
            $scope.template = template;
            $scope.template.CampanhaLayoutFormatoId = ($scope.template.CampanhaLayoutFormatoId != undefined) ? $scope.template.CampanhaLayoutFormatoId : '1';
            $scope.template.PossuiHeader = ($scope.template.PossuiHeader != undefined) ? $scope.template.PossuiHeader.toString() : 'true';
            $scope.template.PermiteAlteracao = ($scope.template.PermiteAlteracao != undefined) ? $scope.template.PermiteAlteracao : true;

            //Tipos de ordenação
            $scope.ordenacaoTipos = [{ CampanhaOrdemTipoId: 1, Descricao: $translate.instant('telaTemplateImportacaoEdit.crescente') },
            { CampanhaOrdemTipoId: 2, Descricao: $translate.instant('telaTemplateImportacaoEdit.decrescente') }];

            // Verifica se é um cadastro novo ou uma edição
            $scope.isNew = template.Id > 0 ? false : true;

            // Obtendo o ID do template
            template.Id = (template.Id > 0 ? template.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));

            $scope.disabledCampoPara = false;

            // Setanto o foco inicial no campo nome
            setTimeout(function () { $('[name=TemplateNome]').focus(); }, 1000);

            $scope.setCamposObrigatorios = function () {
                if (!$scope.template.PermiteAlteracao) {
                    return;
                }
                if ($scope.template.CampanhaLayoutItem == undefined) {
                    $scope.template.CampanhaLayoutItem = [];
                }

                angular.forEach($scope.camposObrigatoriosList, function (item) {
                    var existe = $scope.template.CampanhaLayoutItem.some(function (cti) {
                        return cti.Nome.toLowerCase() == item.Valor.toLowerCase();
                    })

                    if (!existe) {
                        $scope.template.CampanhaLayoutItem.push({
                            'Id': 0,
                            'CampanhaLayoutId': 0,
                            'ApenasIgualdade': true,
                            'Ativo': true,
                            'SentidoOrdenacao': null,
                            'Filtro': item.Filtro,
                            'Fonte': null,
                            'FonteId': null,
                            'CampanhaLayoutTipoId': 1,
                            'Mascara': null,
                            'Alias': '',
                            'Nome': item.Valor,
                            'Tamanho': null,
                            'Ordem': ($scope.template.CampanhaLayoutItem.length + 1)
                        });
                    }
                });
            };

            $scope.verificaCampoObrigatorio = function (campo) {
                var obrigatorio = $scope.camposObrigatoriosList.some(function (item) {
                    return item.Valor.toLowerCase() == campo.toLowerCase();
                })
                return !obrigatorio;
            };

            $scope.setCamposObrigatorios();

            $scope.getDescricaoCampo = function (valor) {
                var join = $scope.camposObrigatoriosList.concat($scope.camposOpcionaisList);
                var campo = join.find(function (item) {
                    return item.Valor.toLowerCase() == valor.toLowerCase();
                });

                return (campo != undefined) ? campo.Descricao : valor;
            };

            $scope.modalAdicionarCampo = function () {
                $scope.camposList = $scope.camposOpcionaisList;
                $scope.disabledCampoPara = false;
                ModalService.openModal('modalAdicionarCampo');
                $scope.limparCampos();
            };

            $scope.salvarCampo = function (form) {
                var formCamposValido = false;
                if (form.$name == "forms.formCampos") {
                    formCamposValido = form.$valid;
                    if (!formCamposValido) {
                        form.$setSubmitted();
                        return;
                    }
                }

                if ($scope.Campo.Edit) {
                    $scope.editar(form);
                } else {
                    $scope.adicionar(form);
                }
            };

            $scope.adicionar = function (form) {


                if ($scope.template.CampanhaLayoutItem == undefined) {
                    $scope.template.CampanhaLayoutItem = [];
                }
                if (!$scope.validacaoCamposAdicionar()) {
                    form.$setSubmitted();
                    return;
                }

                var campoConfig = _.findWhere($scope.todosCamposList, { Valor: $scope.Campo.Para });
          
                var campo = {
                    'Id': 0,
                    'CampanhaLayoutId': 0,
                    'ApenasIgualdade': campoConfig.ApenasIgualdade,
                    'Ativo': true,
                    'SentidoOrdenacao': null,
                    'Filtro': campoConfig.Filtro,
                    'Fonte': null,
                    'FonteId': null,
                    'CampanhaLayoutTipoId': 1,
                    'Mascara': null,
                    'Alias': $scope.Campo.De,
                    'Nome': $scope.Campo.Para,
                    'Tamanho': $scope.Campo.Tamanho,
                    'Ordem': ($scope.template.CampanhaLayoutItem.length + 1)
                };

                $scope.template.CampanhaLayoutItem.push(campo);

                ModalService.closeModal('modalAdicionarCampo');
            };

            $scope.editar = function (form) {
                if (!$scope.validacaoCamposEditar()) {
                    form.$setSubmitted();
                    return;
                }

                angular.forEach($scope.template.CampanhaLayoutItem, function (item) {
                    if (item.Ordem == $scope.Campo.Ordem) {
                        item.Alias = $scope.Campo.De;
                        item.Nome = $scope.Campo.Para;
                        item.Tamanho = $scope.Campo.Tamanho;
                    }
                });

                ModalService.closeModal('modalAdicionarCampo');
            };

            $scope.editarCampo = function (item) {
                if (!$scope.verificaCampoObrigatorio(item.Nome)) {
                    $scope.camposList = $scope.camposObrigatoriosList;
                    $scope.disabledCampoPara = true;
                } else {
                    $scope.camposList = $scope.camposOpcionaisList;
                    $scope.disabledCampoPara = false;
                }

                $scope.Campo.De = item.Alias;
                $scope.Campo.Para = item.Nome;
                $scope.Campo.Tamanho = item.Tamanho;
                $scope.Campo.Edit = true;
                $scope.Campo.Ordem = item.Ordem;

                ModalService.openModal('modalAdicionarCampo');
            };

            $scope.removerCampo = function (data) {
                var index = $scope.template.CampanhaLayoutItem.indexOf(data);

                if (index != -1) {
                    $scope.template.CampanhaLayoutItem.splice(index, 1);
                }

                angular.forEach($scope.template.CampanhaLayoutItem, function (item, key) {
                    item.Ordem = key + 1;
                });
            };

            $scope.validacaoCamposAdicionar = function () {
                var campoDeExiste = $scope.template.CampanhaLayoutItem.some(function (item) {
                    return item.Alias.toLowerCase() == $scope.Campo.De.toLowerCase();
                });

                if (campoDeExiste) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.campoDeOrigemJaExistente');
                    return false;
                }

                var campoParaExiste = $scope.template.CampanhaLayoutItem.some(function (item) {
                    return item.Nome.toLowerCase() == $scope.Campo.Para.toLowerCase();
                });

                if (campoParaExiste) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.campoDeDestinoJaExistente');
                    return false;
                }

                return true;
            };

            $scope.validacaoCamposEditar = function () {
                var campoDeExiste = $scope.template.CampanhaLayoutItem.some(function (item) {
                    return item.Ordem != $scope.Campo.Ordem && item.Alias.toLowerCase() == $scope.Campo.De.toLowerCase();
                });

                if (campoDeExiste) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.campoDeOrigemJaExistente');
                    return false;
                }

                var campoParaExiste = $scope.template.CampanhaLayoutItem.some(function (item) {
                    return item.Ordem != $scope.Campo.Ordem && item.Nome.toLowerCase() == $scope.Campo.Para.toLowerCase();
                });

                if (campoParaExiste) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.campoDeDestinoJaExistente');
                    return false;
                }

                return true;
            };

            $scope.limparCampos = function () {
                $scope.Campo = {};
                $scope.forms.formCampos.$setPristine();
                $scope.forms.formCampos.$setUntouched();
            };

            $scope.ordenarCampo = function (index, tipo) {
                var idx = index - 1
                if (tipo == 'asc') {
                    $scope.template.CampanhaLayoutItem = $scope.move($scope.template.CampanhaLayoutItem, idx, idx - 1);
                }
                else if (tipo == 'desc') {
                    $scope.template.CampanhaLayoutItem = $scope.move($scope.template.CampanhaLayoutItem, idx, idx + 1);
                }
                angular.forEach($scope.template.CampanhaLayoutItem, function (item, key) {
                    item.Ordem = key + 1;
                });
            };

            $scope.move = function (array, fromIndex, toIndex) {
                array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
                return array;
            };

            // #endregion [ Métodos de adição e edição de campos ]

            // #region [ Métodos de salvamento do template  ] 

            $scope.salvarTemplate = function (form) {
                var formTemplateValido = false;
                if (form.$name == "forms.formTemplate") {
                    formTemplateValido = form.$valid;
                    if (!formTemplateValido) {
                        form.$setSubmitted();
                        return;
                    }
                    if (!$scope.validacaoTemplate()) {
                        form.$setSubmitted();
                        return;
                    }

                    $('#page_preloader').show();

                    $scope.salvarTemplateApi()
                        .then(function () {
                            $('#page_preloader').hide();
                            NotifyService.showRegistroSalvo();
                            $scope.submitted = false;
                            if ($stateParams.page)
                                $state.go($stateParams.page, { storage: true });
                            $state.go('main.templateImportacao.list', { storage: true });
                        })
                        .catch(function (error) {
                            $('#page_preloader').hide();
                            NotifyService.showError(error);
                            $scope.submitted = false;
                        });
                }
            };

            $scope.salvarTemplateApi = function () {
                var promise;
                var dados = {
                    'Id': 0,
                    'CampanhaLayoutFormatoId': $scope.template.CampanhaLayoutFormatoId,
                    'Nome': $scope.template.Nome,
                    'Descricao': $scope.template.Descricao,
                    'Delimitador': $scope.template.Delimitador,
                    'PossuiHeader': $scope.template.PossuiHeader,
                    'Ativo': $scope.template.Ativo,
                    'CampanhaLayoutItem': $scope.template.CampanhaLayoutItem
                };

                if (!$scope.isNew) {
                    dados.Id = template.Id
                    promise = TemplateImportacaoResource.update(dados).$promise;
                } else {
                    promise = TemplateImportacaoResource.save(dados).$promise;
                }

                return promise;
            };

            $scope.validacaoTemplate = function () {
                if ($scope.template.CampanhaLayoutItem.length <= 0) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.informeAoMenosUmCampo');
                    return false;
                }

                var itensSemAlias = $scope.template.CampanhaLayoutItem.some(function (item) {
                    return item.Alias == undefined || item.Alias == null || item.Alias == '';
                });

                if (itensSemAlias) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.existemCamposSemOrigemDefinida');
                    return false;
                }

                if ($scope.template.CampanhaLayoutFormatoId == 2) {
                    var itensSemTamanho = $scope.template.CampanhaLayoutItem.some(function (item) {
                        return item.Tamanho == undefined || item.Tamanho == null || item.Tamanho == 0;
                    });

                    if (itensSemTamanho) {
                        NotifyService.showError(null, 'telaTemplateImportacaoEdit.existemCamposSemTamanhoDefinido');
                        return false;
                    }
                }
                return true;
            };

            // #endregion [ Métodos de comuns  ] 

            $scope.baixarArquivo = function () {
                try {
                    FileDownloadService.downloadWebApiFile("CampanhaLayout/DownloadModelo/" + 6);
                } catch (ex) {
                    NotifyService.showError(null, 'telaTemplateImportacaoEdit.houveUmErroAoFazerDownload');
                }
            };
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (TemplateImportacaoResource, search, orderBy, $odata) {
        var odata = TemplateImportacaoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("contains", "Nome", search.Nome), true);
        }

        if (search.CampanhaLayoutFormatoId) {
            odata.filter("CampanhaLayoutFormatoId", "=", parseInt(search.CampanhaLayoutFormatoId));
        }

        if (search.Ativo) {
            odata.filter("Ativo", "=", (search.Ativo == '1'));
        }

        return odata;
    }

    angular.module("epbxManagerApp")
        .service("TemplateImportacaoListData", function TemplateImportacaoListData() {
            return function () {
                return {
                    templates: ["TemplateImportacaoResource", "LocalStorageService", "$odata", "$stateParams", function (TemplateImportacaoResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = { 'Ativo': 1 };
                        var orderBy = { column: "Id", order: "desc" }
                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroPesquisa");
                        }
                        return getOdataSearchShared(TemplateImportacaoResource, filtro, orderBy, $odata).page(10, 1).query();
                    }],
                    formatosList: ["TemplateImportacaoResource", function (TemplateImportacaoResource) {
                        return TemplateImportacaoResource.getFormatos().$promise;
                    }],
                }
            }
        })
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateImportacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.templateImportacao.list',
                        pageTitle: 'pageTitle.templateImportacao',
                        pageName: 'pageTitle.templateImportacao'
                    }
                })
                .state("main.templateImportacao.list", StateResolverProvider.configState("/templateImportacao", "TemplateImportacao", "List", {
                    pageTitle: 'pageTitle.templateImportacao',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.templateImportacao.edit", StateResolverProvider.configState("/templateImportacao/{Id:[0-9]+}", "TemplateImportacao", "Edit", {
                    pageTitle: 'pageTitle.templateImportacao',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.templateImportacao.new", StateResolverProvider.configState("/templateImportacao/new", "TemplateImportacao", "Edit", {
                    pageTitle: 'pageTitle.templateImportacao',
                    pageName: 'acoes.cadastrar',
                    css: true
                }));
        }])
        .controller("TemplateImportacaoListController", ["$scope", "$odata", "$stateParams", "templates", "formatosList", "TemplateImportacaoResource", "LocalStorageService", "NotifyService", "ModalService", "$translate", function ($scope, $odata, $stateParams, templates, formatosList, TemplateImportacaoResource,
            LocalStorageService, NotifyService, ModalService, $translate) {
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPesquisa") : { Ativo: 1, pageSize: 10 };
            $scope.formatosList = formatosList;
            $scope.templates = templates;
            $scope.searching = false;
            $scope.orderBy = { column: "Id", order: "desc" };
            $scope.ativoList = [
                { 'Valor': '1', 'Nome': $translate.instant('status.ativo') },
                { 'Valor': '0', 'Nome': $translate.instant('status.inativo') }
            ];

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroPesquisa', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.templatesList.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                $scope.search = { pageSize: 10 };
                $scope.templatesList = [];
                $scope.searching = false;
                $scope.reverse = false;
                $scope.orderBy = { column: "Id", order: "desc" };
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(TemplateImportacaoResource, $scope.search, $scope.orderBy, $odata);
            };

            var updateList = function (list) {
                $scope.templatesList = list;
                $scope.templatesList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.templatesList.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            updateList(templates);

            $scope.confirmDelete = function (id) {
                ModalService.confirmDelete(() => TemplateImportacaoResource.inativar({ 'Id': id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    }).catch(NotifyService.showError));
            };

            $scope.confirmReativar = function (id) {
                ModalService.confirmReativar(() => {
                    TemplateImportacaoResource.reativar({ 'Id': id }).$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage);
                        }).catch(NotifyService.showError);
                });
            }
        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("TemplateImportacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaLayout/:CampanhaLayoutId", { "Id": "@Id" },
                {
                    getFormatos: { 
                        method: "GET", 
                        url: "CampanhaLayout/Formatos", 
                        isArray: true 
                    },
                    reativar: { 
                        method: "PUT", 
                        url: "CampanhaLayout/:Id/Ativar" 
                    },
                    inativar: { 
                        method: "PUT", 
                        url: "CampanhaLayout/:Id/Inativar"
                    },
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateLimpezaCampanha.edit", StateResolverProvider.configState("/templateLimpezaCampanha/{Id:[0-9]+}", "TemplateLimpezaCampanha", "Edit", {
                    pageTitle: 'pageTitle.templateLimpezaCampanha',
                    pageName: 'acoes.editar',
                }))
                .state("main.templateLimpezaCampanha.new", StateResolverProvider.configState("/templateLimpezaCampanha/new", "TemplateLimpezaCampanha", "Edit", {
                    pageTitle: 'pageTitle.templateLimpezaCampanha',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("TemplateLimpezaCampanhaEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    templateLimpezaCampanha: ["TemplateLimpezaResource", "$stateParams", function (TemplateLimpezaResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TemplateLimpezaResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    diaSemana: ["$translate", function ($translate) {
                        return {
                            0: $translate.instant('dias.domingo'),
                            1: $translate.instant('dias.segunda'),
                            2: $translate.instant('dias.terca'),
                            3: $translate.instant('dias.quarta'),
                            4: $translate.instant('dias.quinta'),
                            5: $translate.instant('dias.sexta'),
                            6: $translate.instant('dias.sabado')
                        };
                    }],
                    campanhasAssociadas: ["TemplateLimpezaResource", "$stateParams", function (TemplateLimpezaResource, $stateParams) {
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;             
                        return TemplateLimpezaResource.GetCampanhaAssociadas({
                            templateLimpezaId: id
                        }).$promise;
                    }],
                    campanhasNaoAssociadas: ["TemplateLimpezaResource", "$stateParams", function (TemplateLimpezaResource, $stateParams) { 
                        var id = parseInt($stateParams.Id);
                        if(!id)
                            id = 0;                   
                        return TemplateLimpezaResource.GetCampanhaNaoAssociadas({
                            templateLimpezaId: id
                        }).$promise;
                    }]
                };
            };
        })

        .controller("TemplateLimpezaCampanhaEditController", ["$scope", "ModalService", "NotifyService", "TemplateLimpezaResource", "$state", "$translate", "templateLimpezaCampanha", "diaSemana", "campanhasAssociadas", "campanhasNaoAssociadas", function ($scope, ModalService, NotifyService,
            TemplateLimpezaResource, $state, $translate, templateLimpezaCampanha, diaSemana,
            campanhasAssociadas, campanhasNaoAssociadas) {
            $scope.isNew = (templateLimpezaCampanha.Id > 0 ? false : true);
            $scope.templateLimpezaCampanha = templateLimpezaCampanha;            
            $scope.forms = {};
            $scope.diaSemana = diaSemana;
            $scope.campanhasAssociadas = campanhasAssociadas;
            $scope.campanhasNaoAssociadas = campanhasNaoAssociadas;
            
            

            

            $scope.descricoesColunas = {
                CampanhaId: 'campo.codigoDaCampanha',
                Nome: 'telaTemplateRegraEdit.nomeDaCampanha'
            }

            $scope.onHorarioAlterado = function () {
                $scope.forms.formHorarios.$setDirty();
            };

            $scope.verificaDias = function () {
                if (!$scope.templateLimpezaCampanha.Segunda && !$scope.templateLimpezaCampanha.Terca && !$scope.templateLimpezaCampanha.Quarta && !$scope.templateLimpezaCampanha.Quinta &&
                    !$scope.templateLimpezaCampanha.Sexta && !$scope.templateLimpezaCampanha.Sabado && !$scope.templateLimpezaCampanha.Domingo) {
                    return ($scope.exibirMensagemDiaSemana = true);
                }
            };

            $scope.selecionarTodos = function (itens, campo) {
                angular.forEach($scope.templateLimpezaCampanha[campo], (item) => {
                    if (itens) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.salvar = function (form) {
                var lastStep = form.$name == "forms.formCampanha" ? true : false;
                var promise;

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }

                if (lastStep) {

                    $scope.templateLimpezaCampanha.CampanhaTemplateLimpezaCampanha = $scope.campanhasAssociadas;

                    if ($scope.isNew) {
                        promise = TemplateLimpezaResource.save($scope.templateLimpezaCampanha).$promise;
                    } else {
                        promise = TemplateLimpezaResource.update($scope.templateLimpezaCampanha).$promise;
                    }

                    promise
                        .then(() => {
                            let message = $scope.isNew ? 'telaEditTemplateLimpezaCampanha.templateAdicionadoComSucesso' : 'telaEditTemplateLimpezaCampanha.templateAlteradoComSucesso';

                            NotifyService.showSuccess($translate.instant(message));
                            $state.go('main.templateLimpezaCampanha.list');
                        })
                        .catch(NotifyService.showError);
                }
            }
        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (TemplateLimpezaResource, search, orderBy, $odata) {
        var odata = TemplateLimpezaResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Nome"), search.Nome.toLowerCase()), true);
        }
        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.templateLimpezaCampanha", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.templateLimpezaCampanha.list',
                    pageTitle: 'pageTitle.cardTitle',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.templateLimpezaCampanha.list", StateResolverProvider.configState("/templateLimpezaCampanha", "TemplateLimpezaCampanha", "List", {
                pageTitle: 'pageTitle.templateLimpezaCampanha',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("TemplateLimpezaCampanhaListData", function TemplateLimpezaCampanhaListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                templateLimpezaCampanha: ["TemplateLimpezaResource", "LocalStorageService", "$odata", "$stateParams", function (TemplateLimpezaResource, LocalStorageService, $odata, $stateParams) {
                     var filtro = {};

                     if ($stateParams.storage) {
                         filtro = LocalStorageService.getItem("FiltroTemplateLimpezaCampanha");
                     }

                     var orderBy = {
                         column: "Nome",
                         order: "asc"
                     };

                     return getOdataSearchShared(TemplateLimpezaResource, filtro, orderBy, $odata).page(10, 1).query();
                 }],
            }
        }
    })

    .controller("TemplateLimpezaCampanhaListController", ["$scope", "$odata", "TemplateLimpezaResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "templateLimpezaCampanha", function ($scope, $odata, TemplateLimpezaResource, utils, LocalStorageService,
        $stateParams, NotifyService, ModalService, templateLimpezaCampanha) {
            $scope.templateLimpezaCampanha = templateLimpezaCampanha;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroTemplateLimpezaCampanha") : {};

            $scope.orderBy = {
                column: "Nome",
                order: "asc"
            };

            $scope.errorObject = {};

            var updateList = function (list) {
                $scope.templateLimpezaCampanha = list;
                $scope.templateLimpezaCampanha.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.templateLimpezaCampanha.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(TemplateLimpezaResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.templateLimpezaCampanha.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroTemplateLimpezaCampanha', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroTemplateLimpezaCampanha');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            var deleteTemplateLimpeza = function (data) {
                return TemplateLimpezaResource.delete({ Id: data.Id }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.executeSearch();
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteTemplateLimpeza(data));
            };

            $scope.exibirErro = function (data){
                $scope.errorObject = data.ErrorObject;
                ModalService.openModal('modalErrorMessage');
            }

            updateList($scope.templateLimpezaCampanha);

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("TemplateLimpezaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaTemplateLimpeza/:Id", { "Id": "@Id" },
                {
                    GetLimpezaTipo: {
                        url: "Campanha/LimpezaTipo",
                        method: "GET",
                        isArray: true
                    },
                    GetCampanhaAssociadas: {
                        url: "CampanhaTemplateLimpeza/CampanhaAssociadas",
                        method: "GET",
                        isArray: true
                    },
                    GetCampanhaNaoAssociadas: {
                        url: "CampanhaTemplateLimpeza/CampanhaNaoAssociadas",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('TemplateOrdenacaoEditData', function PesquisaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider'
                        ]);
                    }],
                    template: ["TemplateOrdenacaoResource", "$stateParams", function (TemplateOrdenacaoResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TemplateOrdenacaoResource.get({ Id: $stateParams.Id }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    layoutItems: ["TemplateOrdenacaoResource", function (TemplateOrdenacaoResource) {
                        return TemplateOrdenacaoResource.getLayoutItens().$promise
                    }]
                }
            }
        })

        .controller("TemplateOrdenacaoEditController", ["$scope", "$window", "$timeout", "$state", "$http", "$stateParams", "WizardHandler", "Config", "template", "layoutItems", "TemplateOrdenacaoResource", "NotifyService", "ModalService", "$translate", function ($scope, $window, $timeout, $state, $http, $stateParams, WizardHandler, Config, template, layoutItems,
            TemplateOrdenacaoResource, NotifyService, ModalService, $translate) {
            $scope.color = {
                red: Math.floor(Math.random() * 255)
            };
            $scope.TemplateOrdenacaoStepData = { order: 1 };
            $scope.CampanhaStepData = { order: 2 };
            $scope.forms = {};
            $scope.LayoutItemIdError = false;
            $scope.OrdemFonteDadosItensError = false;
            $scope.OrdemValorError = false;
            $scope.isNew = template.Id > 0 ? false : true;
            template.Id = (template.Id > 0 ? template.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id)));
            $scope.ordem = {};

            $scope.ordenacaoTipos = [
                { CampanhaOrdemTipoId: 1, Descricao: $translate.instant('telaTemplateOrdenacaoEdit.crescente') },
                { CampanhaOrdemTipoId: 2, Descricao: $translate.instant('telaTemplateOrdenacaoEdit.decrescente') }
            ];

            $scope.template = template;
            $scope.layoutItemsList = layoutItems;
            $scope.fonteItensList = [];
            $scope.cloneCampanhaId = null;
            $scope.campanhasAssociadasList = [];
            $scope.campanhasNaoAssociadasList = [];
            $scope.TemplateTelefoneTipoList = [];
            $scope.layoutItemSelecionado = { ApenasIgualdade: false };

            $scope.getId = function () {
                return ($scope.template ? ($scope.template.Id > 0 ? $scope.template.Id : (isNaN(parseInt($stateParams.Id)) ? 0 : parseInt($stateParams.Id))) :
                    parseInt($stateParams.Id));
            }

            $scope.isFonteDados = function (layoutItem) {
                layoutItem = getTemplateCampoItem(layoutItem);
                var isFonteDados = (layoutItem && layoutItem.FonteId);
                return isFonteDados;
            };

            $scope.isNumericos = function (layoutItemId) {
                if (layoutItemId == 4) {
                    return true;
                } else if (layoutItemId == 5) {
                    return true;
                } else if (layoutItemId == 15) {
                    return true;
                } else {
                    return false;
                }
            }

            $scope.isTelefoneTipo = function (layoutItem) {
                layoutItem = getTemplateCampoItem(layoutItem);
                var isTelefoneTipo = (layoutItem && layoutItem.FonteId && layoutItem.Nome == "CampanhaTelefoneTipoId");
                return isTelefoneTipo;
            }

            $scope.isExibirValor = function (layoutItem) {
                layoutItem = getTemplateCampoItem(layoutItem);
                var isExibirValor = true;
                if (layoutItem && layoutItem.FonteId) {
                    if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                        if ($scope.ordem.TemplateTelefoneTipo == null || $scope.ordem.TemplateTelefoneTipo == undefined)
                            return false;
                    } else {
                        return true;
                    }
                }
                return isExibirValor;
            }

            var adicionarOrdem = function (form) {
                if (validacaoAdicionarOrdem()) {
                    var layoutItem = getTemplateCampoItem($scope.ordem.LayoutItemId);
                    var ordenacaoTipo = _.findWhere($scope.ordenacaoTipos, { CampanhaOrdemTipoId: 1 });
                    var valorSelecionado = { 'Valor': '', 'ValorAlias': '', 'ValorCodigo': '' };
                    var v;

                    $scope.template.Alterado = true;

                    if (layoutItem.Fonte != null) {
                        for (var i = 0; i < $scope.ordem.Valor.length; i++) {
                            if (!$scope.isFonteDados($scope.ordem.LayoutItemId) && $scope.ordem.LayoutItemId) {
                                valorSelecionado.Valor = $scope.ordem.Valor[i];
                                valorSelecionado.ValorAlias = $scope.ordem.Valor[i];
                                valorSelecionado.ValorNome = '';
                            } else {
                                v = _.findWhere($scope.fonteItensList, { Valor: $scope.ordem.Valor[i] });
                                valorSelecionado.Valor = v.Valor;
                                valorSelecionado.ValorAlias = v.Nome;

                                if (layoutItem && layoutItem.FonteId) {
                                    if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                                        atualizarTelTipo(v.Valor);
                                        valorSelecionado.ValorAlias = v.Codigo;
                                        valorSelecionado.ValorCodigo = ' - ' + v.Descricao;
                                    }
                                }
                            }

                            if ($scope.template.Itens == null || $scope.template.Itens == undefined)
                                $scope.template.Itens = [];

                            $scope.template.Itens.push({
                                'CampanhaOrdemTemplateItemId': 0,
                                'CampanhaOrdemTemplateId': ($scope.isNew ? 0 : template.Id),
                                'CampanhaLayoutItemId': $scope.ordem.LayoutItemId,
                                'CampanhaLayoutItem': { 'Alias': layoutItem.Alias },
                                'CampanhaOrdemTipoId': 1,
                                'CampanhaOrdemTipo': { 'Descricao': ordenacaoTipo.Descricao },
                                'Valor': valorSelecionado.Valor,							     // QUANDO FOR CampanhaLayoutItem = CampanhaTelefoneTipo Busca da Tabela TelefoneTipo(Abaixo)		
                                'ValorAlias': valorSelecionado.ValorAlias,					     // E insere o TelefoneTipoId na Coluna Valor
                                'ValorCodigo': valorSelecionado.ValorCodigo,
                                'Peso': ($scope.template.Itens.length + 1),
                                'CampanhaOrdemId': ($scope.template.Itens.length + 1),
                                'Ativo': true
                            });
                        }
                    }
                    else {
                        if (!$scope.isFonteDados($scope.ordem.LayoutItemId) && $scope.ordem.LayoutItemId) {
                            valorSelecionado.Valor = $scope.ordem.Valor;
                            valorSelecionado.ValorAlias = $scope.ordem.Valor;
                            valorSelecionado.ValorNome = '';
                        } else {
                            v = _.findWhere($scope.fonteItensList, { Valor: $scope.ordem.Valor });
                            valorSelecionado.Valor = v.Valor;
                            valorSelecionado.ValorAlias = v.Nome;

                            if (layoutItem && layoutItem.FonteId) {
                                if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                                    valorSelecionado.ValorAlias = v.Codigo;
                                    valorSelecionado.ValorCodigo = ' - ' + v.Descricao;
                                }
                            }
                        }

                        if ($scope.template.Itens == null || $scope.template.Itens == undefined)
                            $scope.template.Itens = [];

                        $scope.template.Itens.push({
                            'CampanhaOrdemTemplateItemId': 0,
                            'CampanhaOrdemTemplateId': ($scope.isNew ? 0 : template.Id),
                            'CampanhaLayoutItemId': $scope.ordem.LayoutItemId,
                            'CampanhaLayoutItem': { 'Alias': layoutItem.Alias },
                            'CampanhaOrdemTipoId': 1,
                            'CampanhaOrdemTipo': { 'Descricao': ordenacaoTipo.Descricao },
                            'Valor': valorSelecionado.Valor,
                            'ValorAlias': valorSelecionado.ValorAlias,
                            'ValorCodigo': valorSelecionado.ValorCodigo,
                            'Peso': ($scope.template.Itens.length + 1),
                            'CampanhaOrdemId': ($scope.template.Itens.length + 1),
                            'Ativo': true
                        });
                    }
                    $scope.ordem = {};
                    $scope.initNestableOrdem();
                }
                form.$dirty = false;
                form.$pristine = true;
                $scope.LayoutItemIdError = false
                $scope.OrdemFonteDadosItensError = false;
                $scope.OrdemValorError = false;
            };

            $scope.deleteOrdem = function (item) {
                var dado = item;
                ModalService.confirmDelete(() => {
                    var itens = [], c = 1;

                    angular.forEach($scope.template.Itens, (i) => {
                        if (i.Peso != dado.Peso) {
                            i.Peso = c;
                            i.CampanhaOrdemId = c;
                            itens.push(i);
                            c++;
                        }
                    });
                    $scope.template.Alterado = true;
                    $scope.template.Itens = itens;
                });
            };

            $scope.ordensSelecionadas = function () {
                var itens = _.filter($scope.template.Itens, (item) => { return item.Selecionado; });
                if (itens.length > 0) {
                    return true;
                }
                else {
                    return false;
                }
            };

            $scope.deleteOrdemList = function () {
                var itens = _.filter($scope.template.Itens, (item) => { return item.Selecionado; });
                if (itens.length > 0) {
                    ModalService.confirmDelete(() => {
                        angular.forEach(itens, (item) => {
                            $scope.template.Itens = _.without($scope.template.Itens, _.findWhere($scope.template.Itens, {
                                Peso: item.Peso
                            }));
                        })
                        angular.forEach($scope.template.Itens, (item, key) => {
                            item.Peso = key + 1;
                        });
                    }
                    );
                    $scope.template.Alterado = true;
                } else {
                    NotifyService.showMessage('telaTemplateOrdenacaoEdit.selecioneUmTemplateParaExcluir', 'warning')
                }
            };

            $scope.modalConfirmaExclusao = function () {
                ModalService.openModal('modalConfirmaExclusao');
            };

            $scope.salvar = function (form) {
                var formCadastroValido = false;
                if (form.$name == "formOrdem") {
                    formCadastroValido = form.$valid;
                    if ($scope.template.Itens.length <= 0 || $scope.template.Itens == undefined) {
                        NotifyService.showError(null, 'telaTemplateOrdenacaoEdit.oTemplatePrecisaDeOrdenacaoAdicionada');
                        formCadastroValido = false;
                    }
                    if (!formCadastroValido) {
                        form.$setSubmitted();
                        return;
                    } else {
                        WizardHandler.wizard().goTo(1);
                        return;
                    }
                }

                var campanhas = [], desassociados = $scope.campanhasNaoAssociadasList.filter(function (item) { return item.Removido; });

                angular.forEach($scope.campanhasAssociadasList, function (item) {
                    campanhas.push({
                        'CampanhaId': item.CampanhaId,
                        'CampanhaNome': item.CampanhaNome,
                        'Selecionado': item.Selecionado,
                        'Removido': item.Removido,
                        'Adicionado': item.Adicionado,
                        'Alterado': item.Alterado
                    });
                });

                angular.forEach(desassociados, (item) => {
                    campanhas.push({
                        'CampanhaId': item.CampanhaId,
                        'CampanhaNome': item.CampanhaNome,
                        'Selecionado': item.Selecionado,
                        'Removido': item.Removido,
                        'Adicionado': item.Adicionado,
                        'Alterado': item.Alterado
                    });
                });

                ModalService.confirmMessage('telaTemplateOrdenacaoEdit.desejaSalvarEsteTemplate', null, () => {
                    $('#page_preloader').show();
                    salvarTemplate(campanhas, false)
                        .then(() => {
                            NotifyService.showRegistroSalvo();
                            $scope.submitted = false;
                            if ($stateParams.page) {
                                $state.go($stateParams.page, { storage: true });
                            }
                            $state.go('main.templateOrdenacao.list', { storage: true });
                            $('#page_preloader').hide();
                        }).catch((error) => {
                            $('#page_preloader').hide();
                            mensagemErro(error);
                        });
                });
            }

            $scope.getCampanhasNaoAssociadas = function () {
                TemplateOrdenacaoResource.getCampanhasNaoAssociadas({ 'Id': template.Id }).$promise
                    .then((data) => {
                        $scope.campanhasNaoAssociadasList = data;
                        if ($scope.cloneCampanhaId != undefined && $scope.cloneCampanhaId != null) {
                            $scope.cloneCampanha = _.findWhere($scope.campanhasNaoAssociadasList, { CampanhaId: $scope.cloneCampanhaId });
                            $scope.campanhasNaoAssociadasList = _.without($scope.campanhasNaoAssociadasList, $scope.cloneCampanha);
                        }
                        $scope.getCampanhasAssociadas();
                    }).catch(mensagemErro);
            };

            $scope.getCampanhasAssociadas = function () {
                TemplateOrdenacaoResource.getCampanhasAssociadas({ 'Id': template.Id }).$promise
                    .then((data) => {
                        $scope.campanhasAssociadasList = data;
                        if ($scope.cloneCampanhaId != undefined && $scope.cloneCampanhaId != null) {
                            $scope.campanhasAssociadasList.push({
                                'Adicionado': true,
                                'Alterado': false,
                                'CampanhaId': $scope.cloneCampanhaId,
                                'CampanhaNome': $scope.cloneCampanha.CampanhaNome,
                                'Removido': false,
                                'Selecionado': false
                            });
                        }
                    }).catch(mensagemErro);
            };

            $scope.adicionarCampanha = function () {
                var selecionados = _.where($scope.campanhasNaoAssociadasList, { Selecionado: true });

                angular.forEach(selecionados, (value) => {
                    $scope.campanhasNaoAssociadasList.splice($scope.campanhasNaoAssociadasList.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Adicionado = true;
                    value.Ativo = true;

                    if (value.Removido && value.Alterado) {
                        value.Removido = false;
                        value.Alterado = false;
                        value.OrdemAlterado = true;
                    } else {
                        value.Alterado = true;
                        value.OrdemAlterado = false;
                    }

                    value.Ordem = 0;
                    $scope.campanhasAssociadasList.push(value);
                });
            };

            $scope.removerCampanha = function () {
                var selecionados = _.where($scope.campanhasAssociadasList, { Selecionado: true });

                angular.forEach(selecionados, (value) => {
                    $scope.campanhasAssociadasList.splice($scope.campanhasAssociadasList.indexOf(value), 1);
                    value.Selecionado = false;
                    value.Removido = true;

                    if (value.Adicionado && value.Alterado) {
                        value.Adicionado = false;
                        value.Alterado = false;
                    } else {
                        value.Alterado = true;
                    }

                    value.OrdemAlterado = false;
                    $scope.campanhasNaoAssociadasList.push(value);
                });
            };

            $scope.selectionarTodosAssociados = function (selecionado) {
                angular.forEach($scope.campanhasAssociadasList, (item) => {
                    item.Selecionado = selecionado;
                });
            };

            $scope.selectionarTodosNaoAssociados = function (selecionado) {
                angular.forEach($scope.campanhasNaoAssociadasList, (item) => { item.Selecionado = selecionado; });
            };

            $scope.getCampanhasNaoAssociadas();

            $scope.initNestableOrdem = function () {
                $timeout(() => {
                    var $nestable = $('#nestableOrdem');

                    $nestable.on('change.uk.nestable', () => {
                        var $nestable = $('#nestableOrdem');
                        var itensOrdenados = $nestable.data("nestable").serialize();
                        $scope.template.Alterado = true;

                        if (itensOrdenados) {
                            angular.forEach(itensOrdenados, (val, index) => {
                                var campanhaOrdem = _.findWhere($scope.template.Itens, { CampanhaOrdemId: val.id });
                                campanhaOrdem.Peso = index + 1;
                            });

                            $scope.$apply();
                            var ordered = _.sortBy($scope.template.Itens, (i) => { return i.Peso; });
                            $scope.template.Itens = ordered;
                        }
                    });
                }, 150);
            };

            $scope.initNestableOrdem();

            // #region [ Métodos auxiliares  ] 

            var getFonteDados = function (comando, callbackSuccess, callbackError) {
                $http.get(Config.getUrl(comando)).then(callbackSuccess).catch(callbackError);
            };

            var getTemplateCampoItem = function (layoutItemId) {
                return _.findWhere($scope.layoutItemsList, { Id: layoutItemId });
            };

            var salvarTemplate = function (campanhas, manterConfiguracaoCampanha) {
                var promise;
                var dados = {
                    'Id': 0,
                    'Nome': $scope.template.Nome,
                    'Itens': $scope.template.Itens,
                    'Campanhas': campanhas,
                    'ManterConfiguracaoCampanha': manterConfiguracaoCampanha,
                    'Alterado': $scope.template.Alterado
                };

                if (!$scope.isNew) {
                    dados.Id = template.Id
                    promise = TemplateOrdenacaoResource.update(dados).$promise;
                } else {
                    promise = TemplateOrdenacaoResource.save(dados).$promise;
                }

                return promise;
            };

            var mensagemErro = function (error) {
                NotifyService.showError(error)
                $scope.submitted = false;
            };

            // #endregion [ Métodos auxiliares  ] 

            // #region [ Métodos de validação  ] 

            $scope.layoutItemChange = function () {
                delete $scope.ordem.Valor;
                if ($scope.ordem) {
                    validacaoLayoutItemId(true);
                    var layoutItem = getTemplateCampoItem($scope.ordem.LayoutItemId);
                    $scope.layoutItemSelecionado = layoutItem;
                    if (layoutItem && layoutItem.FonteId) {
                        fonteDados(layoutItem);
                    } else {
                        $scope.ordem.CampanhaOperadorId = 3;
                    }
                }
            };

            var fonteDados = function (layoutItem) {
                getFonteDados(layoutItem.Fonte.Comando, (response) => {
                    if (layoutItem.Fonte.Comando == "TelefoneTipo/TelefoneTipo") {
                        $scope.TemplateTelefoneTipoList = response.data.filter(x => x.TelefoneTipo.length > 0);
                    } else {
                        $scope.fonteItensList = [];
                        $scope.ordem.CampanhaOperadorId = 4;
                        angular.forEach(response.data, (item) => {
                            var i = {
                                Nome: item[layoutItem.Fonte.Nome],
                                Valor: (layoutItem.Fonte.Valor == 'CampanhaTelefoneTipoId') ? item['Id'] : item[layoutItem.Fonte.Valor]
                            };

                            if (layoutItem.Fonte.Valor == 'CampanhaTelefoneTipoId') {
                                i['Nome'] = item['Codigo'] + ' - ' + item['Descricao'];
                                i['Descricao'] = item['Descricao'];
                                i['Codigo'] = item['Codigo'];
                            }

                            $scope.fonteItensList.push(i);

                            if ($scope.template.Itens != undefined) {
                                for (i = 0; i < $scope.template.Itens.length; i++) {
                                    if ($scope.template.Itens[i].CampanhaLayoutItemId == 12 || $scope.template.Itens[i].CampanhaLayoutItemId == 10) {
                                        $scope.fonteItensList = _.reject($scope.fonteItensList, x => x.Nome == $scope.template.Itens[i].ValorAlias);
                                    }
                                    else {
                                        var nome = $scope.template.Itens[i].ValorAlias + $scope.template.Itens[i].ValorCodigo
                                        $scope.fonteItensList = _.reject($scope.fonteItensList, x => x.Nome == nome);
                                    }
                                }
                            }
                        });
                    }
                });
            };

            $scope.ordemFonteDadosItensChange = function () {
                validacaoOrdemFonteDadosItens(true);
            };

            $scope.templateTelefoneTipoItensChange = function () {
                delete $scope.ordem.Valor;
                validacaoTemplateTelefoneTipoItens(true);

                if ($scope.ordem.TemplateTelefoneTipo != null && $scope.ordem.TemplateTelefoneTipo != undefined) {
                    var layoutItem = $scope.layoutItemSelecionado;
                    layoutItem.Fonte.Comando = 'TelefoneTipo/GetByTemplateId?telefoneTipoTemplateId=' + $scope.ordem.TemplateTelefoneTipo;
                    fonteDados(layoutItem);
                }
            };

            $scope.ordemValorChange = function () {
                validacaoOrdemValor(true);
            };

            $scope.validaExistente = function (form) {
                if ($scope.template.Itens && !$scope.isFonteDados($scope.ordem.LayoutItemId) && $scope.ordem.LayoutItemId) {
                    var valor = $scope.ordem.Valor;
                    var itemExistente = $scope.template.Itens.find(x => x.ValorAlias == valor || x.Valor == valor);
                    if (itemExistente) {
                        var campo = itemExistente.CampanhaLayoutItem.Nome || itemExistente.CampanhaLayoutItem.Alias;
                        var mensagem = $translate.instant('telaTemplateOrdenacaoEdit.jaExisteItem', { 'Campo': campo, 'Valor': valor });
                        ModalService.confirmMessage(mensagem, null, () => adicionarOrdem(form));
                    } else {
                        adicionarOrdem(form)
                    }
                } else {
                    adicionarOrdem(form)
                }
            }

            $scope.validateTemplateOrdenacao = function () {
                var proximoStep = true;
                var template = angular.copy($scope.template);

                if (template.Itens == null || template.Itens == undefined) {
                    template.Itens = [];
                }

                if (template.Nome == null || template.Nome == undefined || template.Nome == '') {
                    NotifyService.showError(null, 'telaTemplateOrdenacaoEdit.informeONomeDoTemplate');
                    proximoStep = false;
                }

                if (template.Itens != null && template.Itens.length <= 0) {
                    NotifyService.showError(null, 'telaTemplateOrdenacaoEdit.oTemplatePrecisaDeOrdenacaoAdicionada');
                    proximoStep = false;
                }

                return proximoStep;
            };

            var validacaoAdicionarOrdem = function () {
                var retorno = true;
                var layoutItem = getTemplateCampoItem($scope.ordem.LayoutItemId);

                retorno = validacaoLayoutItemId(retorno);

                if (layoutItem && layoutItem.FonteId && layoutItem.Nome == "CampanhaTelefoneTipoId") {
                    retorno = validacaoTemplateTelefoneTipoItens(retorno);
                }

                retorno = validacaoOrdemFonteDadosItens(retorno);
                retorno = validacaoOrdemValor(retorno);
                return retorno;
            };

            var validacaoLayoutItemId = function (retorno) {
                if ($scope.ordem.LayoutItemId == null || $scope.ordem.LayoutItemId == undefined) {
                    $scope.LayoutItemIdError = true;
                    retorno = false;
                } else {
                    $scope.LayoutItemIdError = false;
                }
                return retorno;
            };

            var validacaoOrdemFonteDadosItens = function (retorno) {
                if ($scope.ordem.Valor == null || $scope.ordem.Valor == undefined) {
                    $scope.OrdemFonteDadosItensError = true;
                    retorno = false;
                } else {
                    $scope.OrdemFonteDadosItensError = false;
                }
                return retorno;
            };

            var validacaoTemplateTelefoneTipoItens = function (retorno) {
                if ($scope.ordem.TemplateTelefoneTipo == null || $scope.ordem.TemplateTelefoneTipo == undefined) {
                    $scope.TemplateTelefoneTipoItensError = true;
                    retorno = false;
                } else {
                    $scope.TemplateTelefoneTipoItensError = false;
                }
                return retorno;
            };

            var validacaoOrdemValor = function (retorno) {
                if ($scope.ordem.Valor == null || $scope.ordem.Valor == undefined || $scope.ordem.Valor == '') {
                    $scope.OrdemValorError = true;
                    retorno = false;
                } else {
                    $scope.OrdemValorError = false;
                }
                return retorno;
            };

            // #endregion [ Métodos de validação  ] 

            // #region [ Métodos de clonagem da campanha  ] 

            var getCampanhaOrdem = function (callbackSuccess, callbackError) {
                var url = Config.getUrl('Campanha/' + $scope.cloneCampanhaId + '/Ordem');
                $http.get(url).then(callbackSuccess).catch(callbackError);
            };

            $scope.clonarCampanha = function () {
                var fncItens = function (dados, campanhaTelefoneTipo) {
                    var ctt = campanhaTelefoneTipo;
                    angular.forEach(dados, (data) => {
                        var valorCodigo = '';
                        if ($scope.isFonteDados(data.CampanhaLayoutItemId) && data.CampanhaLayoutItemId) {
                            var layoutItem = getTemplateCampoItem(data.CampanhaLayoutItemId);
                            if (layoutItem && layoutItem.FonteId) {
                                if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                                    var v = _.findWhere(ctt, { CampanhaTelefoneTipoId: parseInt(data.Valor) });
                                    if (v != undefined) valorCodigo = v.Codigo + ' - ';
                                }
                            }
                        }

                        $scope.template.Itens.push({
                            'CampanhaOrdemTemplateItemId': 0,
                            'CampanhaOrdemTemplateId': 0,
                            'CampanhaLayoutItemId': data.CampanhaLayoutItem.Id,
                            'CampanhaLayoutItem': { 'Alias': data.CampanhaLayoutItem.Alias },
                            'CampanhaOrdemTipoId': data.CampanhaOrdemTipo.CampanhaOrdemTipoId,
                            'CampanhaOrdemTipo': { 'Descricao': data.CampanhaOrdemTipo.Descricao },
                            'Valor': data.Valor,							     // QUANDO FOR CampanhaLayoutItem = CampanhaTelefoneTipo Busca da Tabela TelefoneTipo(Abaixo)		
                            'ValorAlias': data.ValorAlias,
                            'ValorCodigo': valorCodigo,					         // E insere o TelefoneTipoId na Coluna Valor
                            'Peso': data.Peso,
                            'CampanhaOrdemId': data.Peso,
                            'Ativo': true
                        });
                    });
                };

                var campanhaId = $stateParams.CampanhaId;

                if (campanhaId != undefined && campanhaId != null) {
                    $scope.cloneCampanhaId = parseInt(campanhaId);

                    getCampanhaOrdem(function (response) {
                        if ($scope.template.Itens == null || $scope.template.Itens == undefined) {
                            $scope.template.Itens = [];
                        }

                        var campanhaLayoutItemId = _.where(response.data, { CampanhaLayoutItemId: 13 });

                        if (campanhaLayoutItemId.length > 0) {
                            TemplateOrdenacaoResource.telefoneTipos({
                                'Ids': campanhaLayoutItemId.map(function (i) { return i.Valor; }).join()
                            }).$promise.then((data) => fncItens(response.data, data)).catch(mensagemErro);
                        } else {
                            fncItens(response.data, []);
                        }
                    });
                }
            };

            $scope.clonarCampanha();

            //Fix para corrigir a ordenação
            $scope.fixItens = function () {
                var fncItens = function (campanhaTelefoneTipo) {
                    var ctt = campanhaTelefoneTipo;
                    angular.forEach($scope.template.Itens, (item) => {
                        item.CampanhaOrdemId = item.Peso;
                        if ($scope.isFonteDados(item.CampanhaLayoutItemId) && item.CampanhaLayoutItemId) {
                            var layoutItem = getTemplateCampoItem(item.CampanhaLayoutItemId);
                            if (layoutItem && layoutItem.FonteId) {
                                if (layoutItem.Nome == "CampanhaTelefoneTipoId") {
                                    var v = _.findWhere(ctt, { Id: parseInt(item.Valor) });
                                    if (v != undefined) item.ValorCodigo = ' - ' + v.Descricao;
                                }
                            }
                        }
                    });
                }

                var campanhaLayoutItemId = _.where($scope.template.Itens, { CampanhaLayoutItemId: 13 });

                if (campanhaLayoutItemId.length > 0) {
                    TemplateOrdenacaoResource.telefoneTipos({
                        'Ids': campanhaLayoutItemId.map(function (i) { return i.Valor; }).join()
                    }).$promise.then((data) => fncItens(data)).catch(mensagemErro);
                } else {
                    fncItens([]);
                }

            };

            $scope.fixItens();

            var atualizarTelTipo = function (codigo) {
                for (var i = 0; i < $scope.TemplateTelefoneTipoList.length; i++) {
                    var telefoneTipo = $scope.TemplateTelefoneTipoList[i].TelefoneTipo;
                    if (telefoneTipo.length != undefined && telefoneTipo.length > 0) {
                        $scope.TemplateTelefoneTipoList[i].TelefoneTipo = _.reject(telefoneTipo, x => x.Id == codigo);
                    }
                }

                $scope.TemplateTelefoneTipoList = $scope.TemplateTelefoneTipoList.filter(x => x.TelefoneTipo.length > 0);

            };

            // #endregion [ Métodos auxiliares  ] 

        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (TemplateOrdenacaoResource, search, orderBy, $odata) {
        var odata = TemplateOrdenacaoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("contains", "Nome", search.Nome), true);
        }

        return odata;
    }

    angular.module("epbxManagerApp")
        .service("TemplateOrdenacaoListData", function TemplateOrdenacaoListData() {
            return function () {
                return {
                    templates: ["TemplateOrdenacaoResource", "LocalStorageService", "$odata", "$stateParams", function (TemplateOrdenacaoResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroPesquisa");
                        }
                        var orderBy = { column: "Id", order: "desc" }
                        var odata = getOdataSearchShared(TemplateOrdenacaoResource, filtro, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }]
                }
            }
        })

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateOrdenacao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.templateOrdenacao.list',
                        pageTitle: 'campo.configuracao',
                        pageName: 'campo.configuracao'
                    }
                })
                .state("main.templateOrdenacao.list", StateResolverProvider.configState("/templateOrdenacao", "TemplateOrdenacao", "List", {
                    pageTitle: 'model.templateOrdenacao',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.templateOrdenacao.edit", StateResolverProvider.configState("/templateOrdenacao/{Id:[0-9]+}", "TemplateOrdenacao", "Edit", {
                    pageTitle: 'model.templateOrdenacao',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.templateOrdenacao.new", StateResolverProvider.configState("/templateOrdenacao/new?CampanhaId", "TemplateOrdenacao", "Edit", {
                    pageTitle: 'model.templateOrdenacao',
                    pageName: 'acoes.cadastrar',
                    css: true
                }));
        }])

        .controller("TemplateOrdenacaoListController", ["$scope", "$state", "$odata", "$stateParams", "templates", "TemplateOrdenacaoResource", "LocalStorageService", "NotifyService", "ModalService", function ($scope, $state, $odata, $stateParams, templates,TemplateOrdenacaoResource, LocalStorageService,
            NotifyService, ModalService) {
            $scope.templates = templates;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroPesquisa") : { pageSize: 10 };
            $scope.searching = false;
            $scope.orderBy = { column: "Id", order: "desc" };
            $scope.campanhaDelete = {};

            $scope.executeSearch = function () {
                $scope.searching = true;
                LocalStorageService.setItem('FiltroPesquisa', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.templatesList.pageSize, newPage).query().then(updateList).catch(NotifyService.showError);
            };

            $scope.confirmDuplicar = function (data) {
                ModalService.confirmMessage('telaTemplateOrdenacao.confirmarDuplicacaoRegistro', null, () => duplicarTemplate(data.Id));
            }

            $scope.modalConfirmaExclusao = function (data) {
                $scope.campanhaDelete = data;
                TemplateOrdenacaoResource.getCampanhasAssociadas({ 'Id': data.Id }).$promise
                    .then((data) => {
                        if (data.length > 0) {
                            ModalService.openModal('modalConfirmaExclusao');
                        } else {
                            $scope.confirmDelete();
                        }
                    }).catch(NotifyService.showError);
            }

            $scope.excluirTemplate = function () {
                deletarTemplate($scope.campanhaDelete.Id, true);
            };

            $scope.confirmDelete = function () {
                ModalService.confirmDelete(() => deletarTemplate($scope.campanhaDelete.Id, false));
            };

            $scope.limparFiltro = function () {
                $scope.search = { pageSize: 10 };
                $scope.templatesList = [];
                $scope.searching = false;
                $scope.reverse = false;
                $scope.orderBy = { column: "Id", order: "desc" };
                $scope.executeSearch();
            }

            var getOdataSearch = function () {
                return getOdataSearchShared(TemplateOrdenacaoResource, $scope.search, $scope.orderBy, $odata);
            };

            var updateList = function (list) {
                $scope.templatesList = list;
                $scope.templatesList.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.templatesList.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            }

            updateList(templates);

            var duplicarTemplate = function (id) {
                return TemplateOrdenacaoResource.duplicarTemplate({ 'id': id }).$promise
                    .then((data) => {
                        NotifyService.showSuccess();
                        $state.go('main.templateOrdenacao.edit', { Id: data.Id, storage: true });
                    }).catch(NotifyService.showError);
            }

            var deletarTemplate = function (id, manterConfiguracaoCampanha) {
                return TemplateOrdenacaoResource.delete({ 'id': id, 'manterConfiguracaoCampanha': manterConfiguracaoCampanha }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        ModalService.closeModal('modalConfirmaExclusao');
                        $scope.pageChanged($scope.currentPage)
                    })
                    .catch((error) => {
                        NotifyService.showError(error);
                        ModalService.closeModal('modalConfirmaExclusao');
                    });
            }

        }])
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("TemplateOrdenacaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("CampanhaOrdemTemplate/:Id", { "Id": "@Id" },
                {
                    getLayoutItens: {
                        url: "CampanhaOrdemTemplate/LayoutItens",
                        method: "GET",
                        isArray: true
                    },
                    duplicarTemplate: {
                        url: "CampanhaOrdemTemplate/DuplicarTemplate",
                        method: "GET",
                        isArray: false
                    },
                    getCampanhasNaoAssociadas: {
                        url: "CampanhaOrdemTemplate/CampanhasNaoAssociadas",
                        method: "GET",
                        isArray: true
                    },
                    getCampanhasAssociadas: {
                        url: "CampanhaOrdemTemplate/CampanhasAssociadas",
                        method: "GET",
                        isArray: true
                    },
                    associarCampanhas: {
                        url: "CampanhaOrdemTemplate/AssociarCampanhas",
                        method: "POST",
                    },
                    telefoneTipos: {
                        url: "TelefoneTipo/GetByIds",
                        method: "GET",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.templateUraJornada.edit", StateResolverProvider.configState("/templateUraJornada/{Id:[0-9]+}", "TemplateUraJornada", "Edit", {
                    pageTitle: 'model.templateUraJornada',
                    pageName: 'acoes.editar',
                }))
                .state("main.templateUraJornada.new", StateResolverProvider.configState("/templateUraJornada/new", "TemplateUraJornada", "Edit", {
                    pageTitle: 'model.templateUraJornada',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("TemplateUraJornadaEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    templateUraJornada: ["TemplateUraJornadaResource", "$stateParams", function (TemplateUraJornadaResource, $stateParams) {
                        if ($stateParams.Id) {
                            return TemplateUraJornadaResource.get({ Id: parseInt($stateParams.Id) }).$promise;
                        } else {
                            let templateUraJornada = {};

                            TemplateUraJornadaResource.getTemplatesFeriado().$promise
                                .then(r => {
                                    templateUraJornada.TemplatesFeriadoNaoAdicionados = r;
                                    templateUraJornada.TemplatesFeriadoAdicionados = [];
                                });

                            TemplateUraJornadaResource.getUras().$promise
                                .then(r => {
                                    templateUraJornada.UrasNaoAdicionadas = r;
                                    templateUraJornada.UrasAdicionadas = [];
                                });

                            return templateUraJornada;
                        }
                    }],
                    diaSemana: ["$translate", function ($translate) {
                        return {
                            0: $translate.instant('dias.domingo'),
                            1: $translate.instant('dias.segunda'),
                            2: $translate.instant('dias.terca'),
                            3: $translate.instant('dias.quarta'),
                            4: $translate.instant('dias.quinta'),
                            5: $translate.instant('dias.sexta'),
                            6: $translate.instant('dias.sabado')
                        };
                    }]
                };
            };
        })

        .controller("TemplateUraJornadaEditController", ["$scope", "ModalService", "NotifyService", "templateUraJornada", "TemplateUraJornadaResource", "$state", "$translate", "diaSemana", function ($scope, ModalService, NotifyService, templateUraJornada,
            TemplateUraJornadaResource, $state, $translate, diaSemana) {
            $scope.isNew = (templateUraJornada.Id > 0 ? false : true);
            $scope.templateUraJornada = templateUraJornada;
            $scope.feriado = {};
            $scope.forms = {};
            $scope.search = {};
            $scope.saving = false;


            /* Início dos métodos de período */

            $scope.isHorariosInvalidos = false;
            
            if ($scope.isNew) {
                $scope.templateUraJornada.Periodos = [];

                for (let name in diaSemana) {
                    $scope.templateUraJornada.Periodos.push({
                        Dia: name,
                        DiaSemana: diaSemana[name],
                        HoraInicio: new Date(16, 1, 1, 9, 0, 0, 0),
                        HoraTermino: new Date(16, 1, 1, 18, 0, 0, 0),
                        Ativo: true
                    });
                }
            } else {
                $scope.templateUraJornada.Periodos.forEach(periodo => {
                    periodo.DiaSemana = diaSemana[periodo.Dia];
                });
            }

            $scope.adicionarPeriodo = function (dia) {
                $scope.templateUraJornada.Periodos.push({
                    Dia: dia,
                    DiaSemana: diaSemana[dia],
                    Ativo: true
                });

                $scope.forms.formHorarios.$setDirty();
            }

            $scope.removerPeriodo = function (index) {
                ModalService.confirmDelete(() => {
                    delete $scope.templateUraJornada.Periodos[index];
                    $scope.templateUraJornada.Periodos.splice(index, 1);
                });

                $scope.forms.formHorarios.$setDirty();
            }

            $scope.existeHorarioInvalido = function () {
                let invalid = $scope.templateUraJornada.Periodos.find(horario => horario.Valido == false);
                $scope.isHorariosInvalidos = (invalid != null ? true : false);
            }

            /* Fim dos métodos de período */

            /* Início dos métodos de TemplateFeriado */

            $scope.templatesFeriadoAdicionados = [];
            $scope.templatesFeriado = [];
            $scope.limitTemplatesFeriado = 5;
            $scope.limitTemplatesFeriadoAdicionados = 5;

            if ($scope.isNew || !$scope.templateUraJornada.UrasRemovidas) {

                $scope.templateUraJornada.UrasRemovidas = [];
            }

            $scope.pesquisaTemplatesFeriado = function (searchTemplatesFeriado, length, lengthAdicionados) {
                let lengthTotal = $scope.templateUraJornada.TemplatesFeriadoNaoAdicionados.length;
                let lengthAdicionadosTotal = $scope.templateUraJornada.TemplatesFeriadoAdicionados.length;
                if (searchTemplatesFeriado.length > 0) {
                    if (lengthTotal != length) {
                        $scope.limitTemplatesFeriado = lengthTotal;
                    }

                    if (lengthAdicionadosTotal != lengthAdicionados) {
                        $scope.limitTemplatesFeriadoAdicionados = lengthAdicionadosTotal;
                    }
                }
                else {
                    $scope.limitTemplatesFeriado = 5;
                    $scope.limitTemplatesFeriadoAdicionados = 5;
                }
            };

            $scope.adicionarTemplatesFeriado = function () {
                let templatesFeriadoSelecionados = _.where($scope.templateUraJornada.TemplatesFeriadoNaoAdicionados, {
                    Selecionado: true 
                });
                    if (templatesFeriadoSelecionados.length > 0) {
                        templatesFeriadoSelecionados.forEach(item => {
                            item.Selecionado = false;
                            $scope.templateUraJornada.TemplatesFeriadoAdicionados.push(item);
                            $scope.templateUraJornada.TemplatesFeriadoNaoAdicionados.splice($scope.templateUraJornada.TemplatesFeriadoNaoAdicionados.indexOf(item), 1);
                        });
                    } 
                    else{
                        NotifyService.showError(null, 'telaEditTemplateUraJornada.selecioneUmTemplateFeriadoASerAdicionado')
                        }
                
            };

            $scope.removerTemplatesFeriado = function () {
                let templatesFeriadoSelecionadas = _.where($scope.templateUraJornada.TemplatesFeriadoAdicionados, {
                    Selecionado: true
                });

                if (templatesFeriadoSelecionadas.length > 0) {
                    templatesFeriadoSelecionadas.forEach(item => {
                        item.Selecionado = false;
                        $scope.templateUraJornada.TemplatesFeriadoNaoAdicionados.push(item);
                        $scope.templateUraJornada.TemplatesFeriadoAdicionados.splice($scope.templateUraJornada.TemplatesFeriadoAdicionados.indexOf(item), 1);
                    });
                } else {
                    NotifyService.showError(null, 'telaEditTemplateUraJornada.selecioneUmTemplatesFeriadoASerRemovido')
                }
            };

            /* Fim dos métodos de TemplateFeriado */

            /* Início dos métodos de URA */

            $scope.urasAdicionadas = [];
            $scope.uras = [];
            $scope.limitUras = 5;
            $scope.limitUrasAdicionadas = 5;
            
            $scope.pesquisaUras = function (searchUras, length, lengthAdicionadas) {
                let lengthTotal = $scope.templateUraJornada.UrasNaoAdicionadas.length;
                let lengthAdicionadasTotal = $scope.templateFeriad.UrasAdicionadas.length;
                if (searchUras.length > 0) {
                    if (lengthTotal != length) {
                        $scope.limitUras = lengthTotal;
                    }

                    if (lengthAdicionadasTotal != lengthAdicionadas) {
                        $scope.limitUrasAdicionadas = lengthAdicionadasTotal;
                    }
                }
                else {
                    $scope.limitUras = 5;
                    $scope.limitUrasAdicionadas = 5;
                }
            };

            $scope.adicionarUra = function () {
                let urasSelecionadas = _.where($scope.templateUraJornada.UrasNaoAdicionadas, {
                    Selecionado: true
                });

                if (urasSelecionadas.length > 0) {
                    if (urasSelecionadas.find(item => item.TemplateUraJornadaId > 0)) {
                        let urasAssociadas = [];

                        urasSelecionadas.forEach(item => {
                            if (item.TemplateUraJornadaId > 0) {
                                let message = `<li><b>${item.UraId} - ${item.Descricao}</b> <i>(TemplateId: ${item.TemplateUraJornadaId})</i></li>`
                                urasAssociadas.push(message);
                            }
                        });

                        let message = `
                            <h3>${$translate.instant('telaEditTemplateUraJornada.adicionarUra')}</h3>
                            <div>${$translate.instant('telaEditTemplateUraJornada.asSeguintesUrasPossuemAssociacao')}:
                                <ul style="margin:0">
                                    ${urasAssociadas.join('')}
                                </ul>
                            </div>
                            <div>
                                ${$translate.instant('telaEditTemplateUraJornada.soEPossivelAssociarUmTemplatePorUra')}.
                                <b>${$translate.instant('telaEditTemplateUraJornada.desejaDescartarAssociacoes')}</b>
                                ${$translate.instant('telaEditTemplateUraJornada.estaAlteracaoNaoPoderaSerDesfeira')}
                            </div>`

                        ModalService.confirmMessage(message, null, () => {
                            urasSelecionadas.forEach(item => {
                                item.Selecionado = false;
                                $scope.templateUraJornada.UrasAdicionadas.push(item);
                                $scope.templateUraJornada.UrasNaoAdicionadas.splice($scope.templateUraJornada.UrasNaoAdicionadas.indexOf(item), 1);

                                // urasRemovidas
                                var index = $scope.templateUraJornada.UrasRemovidas.indexOf(item.UraId);
                                if (index !== -1) {
                                    $scope.templateUraJornada.UrasRemovidas.splice(index, 1);
                                }
                            });
                        }, { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });
                    } else {
                        urasSelecionadas.forEach(item => {
                            item.Selecionado = false;
                            $scope.templateUraJornada.UrasAdicionadas.push(item);
                            $scope.templateUraJornada.UrasNaoAdicionadas.splice($scope.templateUraJornada.UrasNaoAdicionadas.indexOf(item), 1);

                            var index = $scope.templateUraJornada.UrasRemovidas.indexOf(item.UraId);
                            if (index !== -1) {
                                $scope.templateUraJornada.UrasRemovidas.splice(index, 1);
                            }
                        });
                    }
                } else {
                    NotifyService.showError(null, 'telaEditTemplateUraJornada.selecioneUmaUraASerAdicionada')
                }
            };

            $scope.removerUra = function () {
                let urasSelecionadas = _.where($scope.templateUraJornada.UrasAdicionadas, {
                    Selecionado: true
                });

                if (urasSelecionadas.length > 0) {
                    urasSelecionadas.forEach(item => {
                        item.Selecionado = false;
                        $scope.templateUraJornada.UrasNaoAdicionadas.push(item);
                        $scope.templateUraJornada.UrasAdicionadas.splice($scope.templateUraJornada.UrasAdicionadas.indexOf(item), 1);

                        // urasRemovidas
                        if ($scope.templateUraJornada.UrasRemovidas.indexOf(item.UraId) === -1) {
                            $scope.templateUraJornada.UrasRemovidas.push(item.UraId);
                        }
                    });
                } else {
                    NotifyService.showError(null, 'telaEditTemplateUraJornada.selecioneUmaUraASerRemovida')
                }
            };

            /* Fim dos métodos de URA */

            /* Início dos métodos de áuido */

            //Metodos de Audio

            $scope.ouvirAudio = function (id, nome) {
                $scope.arquivoAudio = {
                    url: "/Ura/Audio/" + id,
                    titulo: $translate.instant('diretivas.reproduzindo') + nome
                };
            };

            $scope.fecharAudio = function () {
                $scope.arquivoAudio = null;
            };

            $scope.showProgress = function (percentComplete) {
                $("#modalBlock").find(".uk-progress-bar").css({width: percentComplete + "%"});
                $("#modalBlock").find(".uk-progress-bar").text(percentComplete + "%");
            };

            $scope.loadUraError = function (error) {
                $scope.preview = null;
                ModalService.hideUploading();
                NotifyService.showError(error, 'notificacoes.erroAoFazerUpload');
            };
 
            $scope.startUraUpload = function () {
                ModalService.showUploading();
            }

            $scope.loadForaJornadaCompleted = function (result) {
                $scope.preview = result;
                $scope.templateUraJornada.ForaJornadaArquivoId = result.UraArquivoId;
                $scope.templateUraJornada.ForaJornadaUraArquivo = result;
                ModalService.hideUploading();
            };

            $scope.removeForaJornadaUra = function () {
                $scope.templateUraJornada.ForaJornadaArquivoId = null;
                $scope.templateUraJornada.ForaJornadaUraArquivo = null;
                $("#form-file-forajornada").val("");
            };

            $scope.loadFeriadoCompleted = function (result) {
                $scope.preview = result;
                $scope.templateUraJornada.FeriadoArquivoId = result.UraArquivoId;
                $scope.templateUraJornada.FeriadoUraArquivo = result;
                ModalService.hideUploading();
            };

            $scope.removeFeriadoUra = function () {
                $scope.templateUraJornada.FeriadoArquivoId = null;
                $scope.templateUraJornada.FeriadoUraArquivo = null;
                $("#form-file-feriado").val("");
            };

            /* Início dos métodos genéricos */

            $scope.selecionarTodos = function (itens, campo) {
                angular.forEach($scope.templateUraJornada[campo], (item) => {
                    if (itens) {
                        item.Selecionado = true;
                    } else {
                        item.Selecionado = false;
                    }
                });
            };

            $scope.mais = function (nome, limite, campo) {
                if ($scope[limite] < $scope.templateUraJornada[campo].length) {
                    $scope[limite] += 5;
                    $("#" + nome).animate({
                        scrollTop: $("#tab" + nome).height()
                    }, 800);
                }
            };

            /* Fim dos métodos genéricos */

            $scope.salvar = function () {                   
                let promise;
                let quantidadeInvalidos = $scope.templateUraJornada.Periodos.filter((element) => (!element.HoraInicio || !element.HoraTermino)).length;

                if (quantidadeInvalidos > 0) {
                    return NotifyService.showError(null, 'validacao.existemHorariosInvalidos', { Quantidade: quantidadeInvalidos })
                }

                if ($scope.templateUraJornada.Periodos.length == 0) {
                    return NotifyService.showError(null, 'É necessário configurar ao menos um período para o template de jornada')
                }

                if ($scope.isNew) {
                    promise = TemplateUraJornadaResource.save($scope.templateUraJornada).$promise;
                } else {
                    promise = TemplateUraJornadaResource.update($scope.templateUraJornada).$promise;
                }

                $scope.saving = true;
                promise
                    .then(() => {
                        $scope.saving = false;
                        let message = $scope.isNew ? 'telaEditTemplateUraJornada.templateAdicionadoComSucesso' : 'telaEditTemplateUraJornada.templateAlteradoComSucesso';
                        NotifyService.showSuccess($translate.instant(message));
                        $state.go('main.templateUraJornada.list');
                    })
                    .catch(() => {
                        $scope.saving = false;  
                        NotifyService.showError
                    });
                
            }

            $scope.validateNome = function () {
                let alterado = $scope.isNew ? false : $scope.forms.formNome.$dirty;
                let proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formNome.$dirty = false;
                        $scope.forms.formNome.$setPristine();
                    });
                } else {
                    proximoStep = $scope.forms.formNome.$valid ? true : false;
                }

                if(!templateUraJornada.ForaJornadaArquivoId)
                {
                    proximoStep = false;
                    NotifyService.showError(null, 'telaEditTemplateUraJornada.validaImportacaoAudioForaHorario')
                }

                return proximoStep;
            };

            $scope.validateHorario = function () {
                let alterado = $scope.isNew ? false : $scope.forms.formHorarios.$dirty;
                let proximoStep = false;

                if (alterado) {
                    ModalService.confirmSalvar(() => {
                        $scope.forms.formHorarios.$dirty = false;
                        $scope.forms.formHorarios.$setPristine();
                    });
                } else {
                    proximoStep = $scope.forms.formHorarios.$valid ? true : false;
                }

                return proximoStep;
            };

            $scope.validateFeriado = function () {
                let alterado = $scope.isNew ? false : $scope.forms.formFeriado.$dirty;
                let proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formFeriado.$dirty = false;
                        $scope.forms.formFeriado.$setPristine();
                    });
                } else {
                    proximoStep = $scope.forms.formFeriado.$valid ? true : false;
                }
            
                if(templateUraJornada.TemplatesFeriadoAdicionados != null)
                {
                    if(templateUraJornada.TemplatesFeriadoAdicionados.length > 0)
                    {
                        if(!templateUraJornada.FeriadoArquivoId)
                        {
                            proximoStep = false;
                            NotifyService.showError(null, 'telaEditTemplateUraJornada.validaImportacaoAudioForaHorario')
                        }
                    }
                }

                return proximoStep;
            };

            $scope.validateUra = function () {
                let alterado = $scope.isNew ? false : $scope.forms.formUras.$dirty;
                let proximoStep = false;

                if (alterado) {
                    ModalService.confirmDescartar(() => {
                        $scope.forms.formUras.$dirty = false;
                        $scope.forms.formUras.$setPristine();
                    });
                } else {
                    proximoStep = $scope.forms.formUras.$valid ? true : false;
                }

                return proximoStep;
            };
        }]);
})();

(function () {
	"use strict";

	let defaultPageSize = 15;

	let getOdataSearchShared = function (TemplateUraJornadaResource, search, $odata) {
		let filtroId, odata = TemplateUraJornadaResource.odata();

		if (search.Id) {
			filtroId = new $odata.Predicate("x:x/Id", parseInt(search.Id)).execute(false, true);
			odata.filter(new $odata.Func('TemplateUraJornada/any', new $odata.Property(filtroId)));
		}

		odata.orderBy("Id", "asc");

		return odata;
	};

	angular.module("epbxManagerApp")

		.config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
			$stateProvider
				.state("main.templateUraJornada", {
					url: "",
					template: '<ui-view autoscroll="true"/>',
					abstract: true,
					data: {
						proxy: 'main.templateUraJornada.list',
						pageTitle: 'model.templateUraJornada',
						pageName: 'pageTitle.pesquisar'
					}
				})
				.state("main.templateUraJornada.list", StateResolverProvider.configState("/templateUraJornada", "TemplateUraJornada", "List", {
					pageTitle: 'model.templateUraJornada',
					pageName: 'pageTitle.pesquisar'
				}));
		}])

		.service("TemplateUraJornadaListData", function () {
			return function () {
				return {
					templatesUraJornada: ["TemplateUraJornadaResource", "LocalStorageService", "$odata", "$stateParams", function (TemplateUraJornadaResource, LocalStorageService, $odata, $stateParams) {
						let filtro = {};
						if ($stateParams.storage) {
							filtro = LocalStorageService.getItem("FiltroTemplateUraJornada");
						}
						let odata = getOdataSearchShared(TemplateUraJornadaResource, filtro, $odata);
						return odata.page(defaultPageSize, 1).query();
					}],
					ttsService : ["TtsService", function(TtsService){
                        TtsService.getVozes();
                        TtsService.setProvedores();
                        return;
                    }]
				}
			}
		})

		.controller("TemplateUraJornadaListController", ["$scope", "templatesUraJornada", "LocalStorageService", "$stateParams", "ModalService", "$state", "TemplateUraJornadaResource", "NotifyService", "$odata", function ($scope, templatesUraJornada, LocalStorageService, $stateParams,
			ModalService, $state, TemplateUraJornadaResource, NotifyService, $odata) {
			$scope.templatesUraJornada = templatesUraJornada;
			$scope.searching = false;
			$scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroTemplateUraJornada") : {};

			let updateList = function (list) {
				$scope.templatesUraJornada = list;
				$scope.templatesUraJornada.recordCount = list.$recordCount || list.length;
				$scope.currentPage = list.$currentPage || 1;
				$scope.templatesUraJornada.pageSize = list.$pageSize || 10;
				$scope.searching = false;
			};

			let getOdataSearch = function () {
				return getOdataSearchShared(TemplateUraJornadaResource, $scope.search, $odata);
			};

			let deleteRecord = function (trashObject) {
				return TemplateUraJornadaResource.delete({ Id: trashObject.Id }).$promise
					.then(() => {
						NotifyService.showSuccess();
						$scope.pageChanged($scope.currentPage)
					}).catch(NotifyService.showError);
			};

			$scope.executeSearch = function () {
				$scope.searching = true;
				LocalStorageService.setItem('FiltroTemplateUraJornada', $scope.search);
				getOdataSearch().page($scope.search.pageSize, 1).query()
					.then(updateList)
					.catch((error) => {
						NotifyService.showError(error);
						$scope.searching = false;
					});
			};

			$scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteRecord(data));
			};

			$scope.pageChanged = function (newPage) {
				return getOdataSearch().page($scope.templatesUraJornada.pageSize, newPage).query()
					.then(updateList)
					.catch(NotifyService.showError);
			};

			$scope.limparFiltro = function () {
				LocalStorageService.removeItem('FiltroTemplateUraJornada');
				$scope.search = {
					pageSize: 10
				};
				$scope.executeSearch();
			};

			$scope.voltar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, { storage: true });
				}
				else {
					$state.go('main.templateUraJornada.list', { storage: true });
				}
			};

			updateList(templatesUraJornada);
		}]);
})();

(function () {
    "use strict";
    angular.module('epbxManagerApp')
        .factory("TemplateUraJornadaResource", ["$odataresource", function ($odataresource) {
            return $odataresource("TemplateUraJornada/:Id", { "Id": "@Id" },
                {
                    getTemplatesFeriado: {
                        method: "GET",
                        url: "TemplateUraJornada/GetTemplatesFeriado",
                        isArray: true
                    },
                    getUras: {
                        method: "GET",
                        url: "TemplateUraJornada/GetUras",
                        isArray: true
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .controller("ConsultaApiEditController", ["$scope", "ModalService", function ($scope, ModalService) {

            //#region inicializacao

            $scope.builderListProvedorCampos = function () {
                if ($scope.provedores) {
                    $scope.provedores.forEach(provedor => {
                        if (provedor.UraProvedorCampo) {
                            provedor.UraProvedorCampo.forEach(item => $scope.setListCamposProvedor(item));
                        }
                    });
                }
            }

            $scope.setListCamposProvedor = function (item) {
                let campo = {
                    uraProvedorCampoId: item.UraProvedorCampoId,
                    nome: item.Nome,
                    obrigatorio: item.Obrigatorio,
                    utilizado: false
                };
                if (item.DirecaoCampoId == $scope.constantes.campoEnvio) {
                    $scope.listCamposEnvio.push(campo);
                }
                else if (item.DirecaoCampoId == $scope.constantes.campoRetorno) {
                    $scope.listCamposRetorno.push(campo);
                }
            }

            //#region Constantes

            // Gerais
            $scope.constantes = {
                campoEnvio: 1,
                campoRetorno: 2,
                adicionar: 1,
                atualizar: 2,
            }

            //#endregion Constantes

            //#region listas

            $scope.listCamposEnvio = [];
            $scope.listCamposRetorno = [];

            //// sharing data to its parent(s)
            //$scope.$watch('listCamposEnvio', function (newValue) {
            //    $scope.$emit('listCamposEnvioChanged', newValue);
            //});

            //// sharing data to its parent(s)
            //$scope.$watch('listCamposRetorno', function (newValue) {
            //    $scope.$emit('listCamposRetornoChanged', newValue);
            //});

            //#endregion listas

            //#region variaveis

            $scope.campoProvedorId = undefined;
            $scope.condicaoId = undefined;
            $scope.valorCampo = undefined;

            $scope.condicaoTempEdit = [];

            //#endregion variaveis

            //#endregion inicializacao

            //#region ações

            $scope.onCampoProvedorAlterado = function () {
                if ($scope.campoProvedorId) {



                }
                else {
                    $scope.condicaoId = undefined;
                }
            }

            $scope.editarCondicaoCampo = function (condicao) {

                $('#modal_condicao_uraProvedor').on();
                ModalService.openModal('modal_condicao_uraProvedor', null, null, { center: false, bgclose: false, keyboard: false });
            }

            $scope.testeController = function () {
                console.log("testeController");
                console.log($scope);

                console.log("ConsultaApiEditController => uraSelecionada");
                console.log($scope.uraSelecionada);
            }

            //#endregion ações

            //#region verificações

            $scope.hasCondicoes = function () {
                return $scope.condicaoTempEdit.length > 0;
            }

            $scope.hasCamposEnvio = function () {
                return $scope.listCamposEnvio.length > 0;
            }

            $scope.hasCamposRetorno = function () {
                return $scope.listCamposRetorno.length > 0;
            }

            //#endregion verificações

            /// Chamada das funções de inicialização
            /// INICIO

            $scope.builderListProvedorCampos();

            /// Chamada das funções de inicialização
            /// FIM
        }])
})();
/*
 * 
 * global angular, moment, svgPanZoom 
 * 
 * https://github.com/bumbu/svg-pan-zoom
 * 
 */
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .service("UraEditData", function UraEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_uiSelect",
                            "lazy_wizard",
                            "lazy_dropify",
                            "lazy_masked_inputs",
                            "lazy_joint"
                        ]);
                    }],
                    ura: ["UraResource", "$stateParams", function (UraResource, $stateParams) {
                        if ($stateParams.UraId) {
                            return UraResource.get({ UraId: $stateParams.UraId }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    uraTipoIntegracaoId: ["$stateParams", function ($stateParams) {
                        if ($stateParams.UraTipoIntegracaoId) {
                            return $stateParams.UraTipoIntegracaoId;
                        }
                    }],
                    servicosDisponiveis: ["ServicoResource", "$stateParams", function (ServicoResource, $stateParams) {
                        return ServicoResource.getServicoDisponivelAssociarUra({ uraId: $stateParams.UraId || 0 }).$promise;
                    }],
                    servicos: ["ServicoResource", function (ServicoResource) {
                        return ServicoResource.query();
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        let odata = GrupoResource.odata().orderBy("Descricao", "asc");
                        odata.filter("GrupoTipoId", "=", 1);
                        return odata.query();
                    }],
                    tiposGrupo: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getTipos().$promise;
                    }],
                    ramais: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "1" }).$promise;
                    }],
                    ramaisPabx: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "4" }).$promise;
                    }],
                    uras: ["UraResource", function (UraResource) {
                        return UraResource.query().$promise;
                    }],
                    integracoes: ["IntegracaoConfiguracaoResource", function (IntegracaoConfiguracaoResource) {
                        return IntegracaoConfiguracaoResource.query().$promise;
                    }],
                    operadores: ["OperadorLogicoResource", function (OperadorLogicoResource) {
                        return OperadorLogicoResource.query().$promise;
                    }],
                    campanhas: ["CampanhaResource", function (CampanhaResource) {
                        let odata = CampanhaResource.odata();
                        odata.filter("CampanhaTemplateId", 2);
                        return odata.query();
                    }],
                    tiposCallback: ["UraCallbackTipoResource", function (UraCallbackTipoResource) {
                        return UraCallbackTipoResource.query().$promise;
                    }],
                    urasSatisfacao: ["UraResource", function (UraResource) {
                        return UraResource.getSatisfacao().$promise;
                    }],
                    urasTipoIntegracao: ["UraResource", function (UraResource) {
                        return UraResource.getUraTipoIntegracao().$promise;
                    }],
                    templatesUraJornada: ["TemplateUraJornadaResource", function (TemplateUraJornadaResource) {
                        return TemplateUraJornadaResource.query().$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    uraTranscription: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getUraTranscription().$promise;
                    }],
                    operadoresLogico: ["OperadorLogicoResource", function (OperadorLogicoResource) {
                        return OperadorLogicoResource.query().$promise;
                    }],
                    direcaoCampoProvedor: ["UraProvedorResource", function (UraProvedorResource) {
                        return UraProvedorResource.getDirecaoCampo().$promise;
                    }],
                    variaveisUraAtendimento: ["UraProvedorResource", function (UraProvedorResource) {
                        return UraProvedorResource.getVariavelUraAtendimento().$promise;
                    }],
                    acoesUra: ["UraProvedorResource", function (UraProvedorResource) {
                        return UraProvedorResource.getAcoesUra().$promise;
                    }]
                };
            };
        })

        .controller("UraEditController",
            ["$scope", "$window", "$state", "ura", "UraResource", "$timeout", "servicosDisponiveis", "servicos", "grupos", "ramais", "ramaisPabx", "uras", "integracoes", "IntegracaoConfiguracaoResource", "operadores", "campanhas", "tiposCallback", "urasSatisfacao", "urasTipoIntegracao", "NotifyService", "$translate", "ModalService", "TranslateService", "templatesUraJornada", "tiposGrupo", "GrupoResource", "carteiras", "uraTranscription", "UraHelper", "operadoresLogico", "direcaoCampoProvedor", "variaveisUraAtendimento", "acoesUra", "UraProvedorResource", "uraTipoIntegracaoId", "UraIntencaoResource", function ($scope,
                $window,
                $state,
                ura,
                UraResource,
                $timeout,
                servicosDisponiveis,
                servicos,
                grupos,
                ramais,
                ramaisPabx,
                uras,
                integracoes,
                IntegracaoConfiguracaoResource,
                operadores,
                campanhas,
                tiposCallback,
                urasSatisfacao,
                urasTipoIntegracao,
                NotifyService,
                $translate,
                ModalService,
                TranslateService,
                templatesUraJornada,
                tiposGrupo,
                GrupoResource,
                carteiras,
                uraTranscription,
                UraHelper,
                operadoresLogico,
                direcaoCampoProvedor,
                variaveisUraAtendimento,
                acoesUra,
                UraProvedorResource,
                uraTipoIntegracaoId,
                UraIntencaoResource) {

                //*************************
                //		INICIALIZAÇÃO
                //*************************

                $scope.carteiras = carteiras;
                $scope.tiposGrupo = tiposGrupo;
                $scope.isNew = ura.UraId > 0 ? false : true;
                $scope.isStatisfacao = $state.current.name == "main.ura.satisfacao";
                $scope.ura = angular.copy(ura);
                $scope.preview = null;
                $scope.previewMenu = [];
                $scope.botaoSelecionado = 1;
                $scope.filtroGrupoTipoId = 1;
                $scope.ultimoArquivoId = {};
                $scope.ultimoArquivoMenuId = [];
                $scope.editandoJornadaMenu = [];
                $scope.jornadasAnteriores = [];
                $scope.jornadaMenuEditadaId = [];
                $scope.editandoJornada = false;
                $scope.ura.PossuiMenu = true;
                $scope.jornadaEditadaId = -1;
                $scope.feriadoEditadoId = -1;
                $scope.limparMenuFile = false;
                $scope.validateHorarios = true;
                $scope.validateDetalhes = true;
                $scope.diasDisabled = [];
                $scope.diasDisabledMenu = [];
                $scope.arquivoAudio = {};
                $scope.arquivoAudioMenu = {};
                $scope.forms = {};
                $scope.nomeDoArquivoIntro = $translate.instant('form.nenhumArquivo');
                $scope.iconeCor = "#444444";
                // https://github.com/punker76/MahApps.Metro.IconPacks.UWP.Prototype/blob/master/src/MahApps.Metro.IconPacks.UWP/PackIconMaterialDataFactory.cs
                $scope.iconeTransferencia = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"/></svg>';
                $scope.iconeRamal = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>';
                $scope.iconeGrupo = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z" /></svg>';
                $scope.iconeServico = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" /></svg>';
                $scope.iconeMenu = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z"/></svg>';
                $scope.iconeUra = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M18,22H6A2,2 0 0,1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22M13,15A2,2 0 0,0 11,17A2,2 0 0,0 13,19A2,2 0 0,0 15,17V12H18V10H14V15.27C13.71,15.1 13.36,15 13,15Z" /></svg>';
                $scope.iconeDesliga = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13" /></svg>';
                $scope.iconeIntegracao = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"/></svg>';
                $scope.iconeConsultaApi = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/>  <path d="M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14A6,6 0 0,0 6,20H19A5,5 0 0,0 24,15C24,12.36 21.95,10.22 19.35,10.03Z"/></svg>';
                $scope.iconeWhatsapp = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/>  <path d="M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z"/></svg>';
                $scope.iconeSolicitaDigitos = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/>  <path d="M12,19A2,2 0 0,0 10,21A2,2 0 0,0 12,23A2,2 0 0,0 14,21A2,2 0 0,0 12,19M6,1A2,2 0 0,0 4,3A2,2 0 0,0 6,5A2,2 0 0,0 8,3A2,2 0 0,0 6,1M6,7A2,2 0 0,0 4,9A2,2 0 0,0 6,11A2,2 0 0,0 8,9A2,2 0 0,0 6,7M6,13A2,2 0 0,0 4,15A2,2 0 0,0 6,17A2,2 0 0,0 8,15A2,2 0 0,0 6,13M18,5A2,2 0 0,0 20,3A2,2 0 0,0 18,1A2,2 0 0,0 16,3A2,2 0 0,0 18,5M12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13M18,13A2,2 0 0,0 16,15A2,2 0 0,0 18,17A2,2 0 0,0 20,15A2,2 0 0,0 18,13M18,7A2,2 0 0,0 16,9A2,2 0 0,0 18,11A2,2 0 0,0 20,9A2,2 0 0,0 18,7M12,7A2,2 0 0,0 10,9A2,2 0 0,0 12,11A2,2 0 0,0 14,9A2,2 0 0,0 12,7M12,1A2,2 0 0,0 10,3A2,2 0 0,0 12,5A2,2 0 0,0 14,3A2,2 0 0,0 12,1Z"/></svg>';
                $scope.campanhas = campanhas;
                $scope.menuDescricao;
                $scope.listMenus = [];
                $scope.showVariaveisUraAvi = ura.UraTipoIntegracaoId ? ura.UraTipoIntegracaoId == 2 : uraTipoIntegracaoId == "2";
                $scope.nomeIntencaoSelecionada = '---';
                $scope.vozIdDefault = ura.VozId;

                $scope.variaveisGlobais = {
                    uraIntencaoId: null,
                    windowUraIntencao: null,
                    chkServicosAdicionados: false,
                    chkServicosNaoAdicionados: false
                }

                // Se possui serviço de Transcrição
                $scope.uraTranscription = false;
                if (uraTranscription && uraTranscription.Valor) {
                    $scope.uraTranscription = uraTranscription.Valor;
                }

                servicos.forEach((el) => {
                    el.Descricao = el.Descricao + " - " + el.Numero;
                });

                servicosDisponiveis.forEach((el) => {
                    el.Descricao = el.Descricao + " - " + el.Numero;
                });

                $scope.servicos = servicos;
                $scope.servicosDisponiveis = servicosDisponiveis;
                $scope.servicosDisponiveisCopia = servicosDisponiveis;
                $scope.uras = uras;
                $scope.templatesUraJornada = templatesUraJornada

                grupos.forEach((el) => {
                    el.Numero = el.Ramal != null ? el.Ramal.Numero : null;
                    el.GrupoFormatado = el.RamalNumero + " - " + el.Descricao;
                });

                $scope.grupos = [];
                $scope.todosGrupos = grupos;

                ramais.forEach((el) => {
                    if (el.UsuarioNome != null) {
                        el.Descricao = el.Numero + " - " + el.UsuarioNome;
                    }
                    else {
                        el.Descricao = el.Numero;
                    }
                });

                $scope.ramais = ramais;

                ramaisPabx.forEach((el) => {
                    if (el.UsuarioNome != null) {
                        el.Descricao = el.Numero + " - " + el.UsuarioNome;
                    }
                    else {
                        el.Descricao = el.Numero;
                    }
                });

                $scope.ramaisPabx = ramaisPabx;
                $scope.integracoes = integracoes;
                $scope.operadores = operadores;
                $scope.urasSatisfacao = urasSatisfacao;
                $scope.urasTipoIntegracao = urasTipoIntegracao;
                $scope.intencoes = [];
                $scope.intencoesBkp = [];

                const timeFormat = TranslateService.getMomentTimeFormat();
                const dateFormat = TranslateService.getMomentDateFormat();

                $scope.searchServico = {
                    numero: '',
                    descricao: ''
                };

                $scope.jornadaAtual = {
                    Periodos: [],
                    Horarios: [{ Inicio: new Date(16, 1, 1, 9, 0, 0, 0), Termino: new Date(16, 1, 1, 18, 0, 0, 0) }]
                };

                $scope.jornadaMenuAtual = [];
                for (let i = 1; i <= 10; i++) {
                    $scope.jornadaMenuAtual[i] = {
                        Periodos: [],
                        Horarios: [{ Inicio: new Date(16, 1, 1, 9, 0, 0, 0), Termino: new Date(16, 1, 1, 18, 0, 0, 0) }]
                    };
                }

                $scope.GambiId = undefined;
                $scope.onGrupoTipoAlterado = function (value) {
                    $scope.GambiId = value;
                    $scope.uraSelecionada.GrupoId = null;
                    let odata = GrupoResource.odata().orderBy("Descricao", "asc");
                    odata.filter("GrupoTipoId", "=", value);
                    odata.query().then(result => {
                        if ($scope.GambiId == 1) {
                            $scope.todosGrupos = result;
                            $scope.todosGrupos.forEach((el) => {
                                el.Numero = el.Ramal != null ? el.Ramal.Numero : null;
                                el.GrupoFormatado = el.RamalNumero + " - " + el.Descricao;
                            });
                            $scope.grupos = $scope.todosGrupos.filter(item => item.CarteiraId == $scope.ura.CarteiraId);
                        }
                        else {
                            $scope.grupos = result;
                        }
                    });
                }

                $scope.abrirModalInput = function () {
                    UIkit.modal.prompt('Escolha uma descrição para o audio:', $scope.uraSelecionada.AudioLabel, (input) => {
                        $scope.uraSelecionada.AudioLabel = (input) ? input : null;
                    });
                }

                $scope.onConfigurarGrupoPorHorario = function () {
                    $scope.uraSelecionada.GrupoId = null;
                    if ($scope.uraSelecionada.ConfigurarGrupoPorHorario) {
                        $scope.uraSelecionada.TemplateUraJornadaId = null;
                        $scope.uraSelecionada.JornadaPersonalizada = true;
                        $scope.onPossuiJornadaMenuChange();
                    }
                    $scope.mudarDescricaoNo($scope.uraSelecionada);
                }

                $scope.diaSemana = {
                    0: $translate.instant('dias.domingo'),
                    1: $translate.instant('dias.segunda'),
                    2: $translate.instant('dias.terca'),
                    3: $translate.instant('dias.quarta'),
                    4: $translate.instant('dias.quinta'),
                    5: $translate.instant('dias.sexta'),
                    6: $translate.instant('dias.sabado')
                };

                $scope.tiposUra = [
                    { TipoId: 1, Descricao: "grupo", Alias: $translate.instant('model.grupo') },
                    { TipoId: 2, Descricao: "ramal", Alias: $translate.instant('model.ramal') },
                    { TipoId: 3, Descricao: "ura", Alias: $translate.instant('model.ura') },
                    { TipoId: 4, Descricao: "servico", Alias: $translate.instant('model.servico') },
                    { TipoId: 5, Descricao: "menu", Alias: $translate.instant('controller.menu') },
                    { TipoId: 6, Descricao: "desliga", Alias: $translate.instant('controller.desligar') },
                    { TipoId: 7, Descricao: "avancado", Alias: $translate.instant('campo.avancado') },
                    { TipoId: 8, Descricao: "integracao", Alias: $translate.instant('campo.integracao') },
                    { TipoId: 12, Descricao: "ramalPabx", Alias: $translate.instant('telaUraEdit.ramalIntegracao') },
                    { TipoId: 13, Descricao: "transfereMenu", Alias: $translate.instant('telaUraEdit.transfereMenu') },
                    { TipoId: 23, Descricao: "consultaApi", Alias: $translate.instant('telaUraEdit.noConsultarApi') },
                    { TipoId: 24, Descricao: "transferencia", Alias: $translate.instant('campo.transferencia') },
                    { TipoId: 25, Descricao: "whatsapp", Alias: $translate.instant('telaUraEdit.noWhatsapp') },
                    { TipoId: 26, Descricao: "descricaoResposta", Alias: null }, // Não aplicado a menu, apenas para criar o registro da descriçao da resposta da NPS
                    { TipoId: 27, Descricao: "solicitaDigitos", Alias: $translate.instant('telaUraEdit.noSolicitarDigitos') }


                ];

                $scope.tiposTransferencia = [
                    { TipoId: 1, Descricao: "grupo", Alias: $translate.instant('model.grupo') },
                    { TipoId: 2, Descricao: "ramal", Alias: $translate.instant('model.ramal') },
                    { TipoId: 3, Descricao: "ura", Alias: $translate.instant('model.ura') },
                    { TipoId: 4, Descricao: "servico", Alias: $translate.instant('model.servico') },
                    { TipoId: 12, Descricao: "ramalPabx", Alias: $translate.instant('telaUraEdit.ramalIntegracao') },
                    { TipoId: 13, Descricao: "transfereMenu", Alias: $translate.instant('controller.menu') }
                ];

                $scope.tiposTransferenciaSolicitaDigitos = [
                    { TipoId: 1, Descricao: "grupo", Alias: $translate.instant('model.grupo') },
                    { TipoId: 2, Descricao: "ramal", Alias: $translate.instant('model.ramal') }
                ];

                $scope.tiposCallback = tiposCallback;

                // São Aquelas que podemos alterar no TAB <URA>
                $scope.tiposUraAlteraveisComCarteira = [
                    { TipoId: 6, Descricao: "desliga", Alias: $translate.instant('controller.desligar') },
                    { TipoId: 23, Descricao: "consultaApi", Alias: $translate.instant('telaUraEdit.noConsultarApi') },
                    { TipoId: 24, Descricao: "transferencia", Alias: $translate.instant('campo.transferencia') },
                    { TipoId: 25, Descricao: "whatsapp", Alias: $translate.instant('telaUraEdit.noWhatsapp') }
                ];
                $scope.tiposUraAlteraveisSemCarteira = [
                    { TipoId: 6, Descricao: "desliga", Alias: $translate.instant('controller.desligar') },
                    { TipoId: 24, Descricao: "transferencia", Alias: $translate.instant('campo.transferencia') },
                    { TipoId: 25, Descricao: "whatsapp", Alias: $translate.instant('telaUraEdit.noWhatsapp') }
                ];

                $scope.tiposUraRedireciona = [
                    { TipoId: 24, Descricao: "transferencia", Alias: $translate.instant('campo.transferencia') },
                    { TipoId: 8, Descricao: "integracao", Alias: $translate.instant('campo.integracao') },
                    { TipoId: 6, Descricao: "desliga", Alias: $translate.instant('controller.desligar') },
                    { TipoId: 5, Descricao: "menu", Alias: $translate.instant('controller.menu') },
                    { TipoId: 98, Descricao: "repetir", Alias: $translate.instant('controller.repetirMenu') }
                ];

                $scope.tipoConsultarApi = [
                    { TipoId: 23, Descricao: "consultaApi", Alias: $translate.instant('telaUraEdit.noConsultarApi') }
                ];

                $scope.MaxTemposIntencoes = [
                    { MaxTempoIntencaoId: 1, Descricao: "2" },
                    { MaxTempoIntencaoId: 2, Descricao: "3" },
                    { MaxTempoIntencaoId: 3, Descricao: "4" },
                    { MaxTempoIntencaoId: 4, Descricao: "5" },
                    { MaxTempoIntencaoId: 5, Descricao: "6" },
                    { MaxTempoIntencaoId: 6, Descricao: "7" },
                    { MaxTempoIntencaoId: 7, Descricao: "8" },
                    { MaxTempoIntencaoId: 8, Descricao: "9" }
                ];

                $scope.ValidacoesUra = [
                    { ValidacaoDigitosUraId: 1, Alias: $translate.instant('ValidacoesDigitosUra.Celular') },
                    { ValidacaoDigitosUraId: 2, Alias: $translate.instant('ValidacoesDigitosUra.Cpf') },
                    { ValidacaoDigitosUraId: 3, Alias: $translate.instant('ValidacoesDigitosUra.Cnpj') }
                ];

                $scope.TipoUraEpbxManagerId = {
                    UraAvi: 1,
                    UraFilaVirtual: 2
                };

                $scope.HttpStatusRecebido = [
                    { HttpStatusRecebidoId: 1, Alias: $translate.instant('status.naoAplicado') },
                    { HttpStatusRecebidoId: 2, Alias: $translate.instant('status.sucesso') },
                    { HttpStatusRecebidoId: 3, Alias: $translate.instant('status.insucesso') }
                ];

                window.addEventListener(
                    "message",
                    (event) => {
                        if (event.origin !== window.origin || 
                            !$scope.variaveisGlobais.windowUraIntencao ||
                            event.data !== 'atualizarIntencoes'
                        ) 
                        {
                            return;
                        }
                        $scope.getIntecoesAdicionadas();
                        $scope.variaveisGlobais.windowUraIntencao.close();
                        $scope.variaveisGlobais.windowUraIntencao = null;
                        window.focus();
                    },
                    false
                );

                $scope.getIntencoesByCarteira = function (inicializacao) {

                    if (!$scope.ura.CarteiraId) {

                        if (inicializacao) {
                            $scope.changeCarteira(null);
                            $scope.BuildDiagramaUra();
                        }
                        return;
                    }

                    UraIntencaoResource
                        .getIntencoesByCarteira({ CarteiraId: $scope.ura.CarteiraId })
                        .$promise
                        .then((result) => {
                            $scope.changeCarteira(result);
                            if (inicializacao) {
                                $scope.BuildDiagramaUra();
                            }
                        }).catch(() => {
                            NotifyService.showError;
                        });
                }

                $scope.onChangeCarteira = function () {

                    $scope.getIntencoesByCarteira();
                }

                $scope.changeCarteira = function (intencoes, inicializacao) {

                    if ($scope.ura.CarteiraId == 0 || $scope.ura.CarteiraId == undefined) {
                        $scope.servicosDisponiveis = $scope.servicosDisponiveisCopia;
                    } else {
                        $scope.servicosDisponiveis = _.filter($scope.servicosDisponiveisCopia, function (el) {
                            return el.CarteiraId == $scope.ura.CarteiraId;
                        });
                        // Exclui os servicos associados
                        if ($scope.servicosDisponiveis &&
                            $scope.uraSelecionada.UraServicoAssociado) {
                            let servicosDisponiveisCopia = angular.copy($scope.servicosDisponiveis);
                            $scope.servicosDisponiveis.forEach(item => {
                                let associado = $scope.uraSelecionada.UraServicoAssociado.find(x => x.ServicoId == item.ServicoId);
                                if (associado) {
                                    let remover = servicosDisponiveisCopia.find(x => x.ServicoId == item.ServicoId)
                                    if (remover) {
                                        let index = servicosDisponiveisCopia.indexOf(remover);
                                        if (index > -1) {
                                            servicosDisponiveisCopia.splice(index, 1);
                                        }
                                    }
                                }
                            });
                            if ($scope.servicosDisponiveis.length != servicosDisponiveisCopia.length) {
                                $scope.servicosDisponiveis = angular.copy(servicosDisponiveisCopia);
                            }
                        }
                    }
                    if ($scope.uraSelecionada) {
                        $scope.grupos = $scope.todosGrupos.filter(item => item.CarteiraId == $scope.uraSelecionada.CarteiraId);
                    }

                    $scope.tiposMenu = [];

                    if ($scope.grupos && $scope.grupos.length > 0) {
                        $scope.tiposMenu.push({ TipoId: 1, Descricao: $translate.instant('model.grupo') });
                    }
                    if ($scope.ramais && $scope.ramais.length > 0) {
                        $scope.tiposMenu.push({ TipoId: 2, Descricao: $translate.instant('model.ramal') });
                    }
                    if ($scope.ramais && $scope.ramaisPabx.length > 0) {
                        $scope.tiposMenu.push({ TipoId: 12, Descricao: $translate.instant('telaUraEdit.ramalIntegracao') });
                    }
                    //if ($scope.uras && $scope.uras.length > 0) {
                    //    $scope.tiposMenu.push({ TipoId: 3, Descricao: $translate.instant('model.ura') });
                    //}

                    $scope.tiposMenu.push({ TipoId: 13, Descricao: $translate.instant('telaUraEdit.transfereMenu') });

                    $scope.tiposMenu.push({ TipoId: 6, Descricao: $translate.instant('controller.desligar') });

                    $scope.updateIntencoes(intencoes);
                }

                $scope.getIntecoesAdicionadas = function () {

                    if (!$scope.ura.CarteiraId) {
                        return;
                    }

                    // Atualiza a lista das intencoes
                    UraIntencaoResource
                        .getIntencoesByCarteira({ CarteiraId: $scope.ura.CarteiraId })
                        .$promise
                        .then($scope.updateIntencoes).catch(() => {
                            NotifyService.showError;
                        });
                }

                $scope.criarIntecao = function () {

                    $scope.variaveisGlobais.windowUraIntencao = $scope.variaveisGlobais.windowUraIntencao || window.open('/#/UraIntencao/new', '_blank');
                    $scope.variaveisGlobais.windowUraIntencao.focus();
                    $scope.variaveisGlobais.windowUraIntencao.onbeforeunload = function () {
                        $scope.variaveisGlobais.windowUraIntencao = null;
                    };
                }

                $scope.IniciaEscopoUra = function () {

                    // Configurações comuns
                    $scope.ura.uraServicoDesssociado = [];

                    // Backup dos DDRs associados 
                    // para possível remoção em banco de dados
                    $scope.ura.UraServicoAssociadoBkp = angular.copy($scope.ura.UraServicoAssociado);

                    if ($scope.isNew) {
                        $scope.ura.ChildUra = [];
                        $scope.ura.UraServicoAssociado = [];
                        $scope.ura.CarteiraId = 1;
                        $scope.ura.TipoUraEpbxManagerId = $scope.TipoUraEpbxManagerId.UraAvi;
                    } else {
                        let formatJornada = function (element) {
                            if (!element.Excecao) {
                                let periodosUsados = _.uniq(
                                    _.map(element.UraPeriodo, el => {
                                        return el.Dia;
                                    })
                                );
                                periodosUsados.forEach(elementP => {
                                    if (!element.Descricao || element.Descricao == "") {
                                        element.Descricao = $scope.diaSemana[elementP];
                                    } else {
                                        element.Descricao = element.Descricao + "/" + $scope.diaSemana[elementP];
                                    }
                                });
                                let horaInicio = null;
                                let horaTermino = null;
                                element.UraPeriodo.forEach(elementP => {
                                    if (moment(elementP.Inicio, "HH:mm").isBefore(moment(horaInicio, "HH:mm")) || !horaInicio) {
                                        horaInicio = elementP.Inicio;
                                    }
                                    if (moment(elementP.Termino, "HH:mm").isAfter(moment(horaTermino, "HH:mm")) || !horaTermino) {
                                        horaTermino = elementP.Termino;
                                    }
                                });
                                element.HorarioDescricao = moment(horaInicio, "HH:mm").format(timeFormat) + " - " + moment(horaTermino, "HH:mm").format(timeFormat);
                            } else {
                                element.DataInicio = moment(element.DataInicio).toDate();
                                element.DataTermino = moment(element.DataTermino).toDate();
                                element.Descricao = element.DataTermino.getTime() != element.DataInicio.getTime() ?
                                    moment(element.DataInicio).format(dateFormat) + " - " + moment(element.DataTermino).format(dateFormat) :
                                    moment(element.DataInicio).format(dateFormat);
                            }
                        };

                        let formatJornadaCallbackRecursivo = function (ura) {
                            ura.UraJornada.forEach(element => {
                                formatJornada(element);
                            });
                            ura.JornadaPersonalizada = ura.UraJornada.length > 0 && ura.TemplateUraJornadaId == null;
                            ura.PossuiCallback = ura.CallbackCampanhaId != null && ura.CallbackCampanhaId > 0;

                            for (let i = 0; i < ura.ChildUra.length; i++) {
                                formatJornadaCallbackRecursivo(ura.ChildUra[i]);
                            }
                        };

                        formatJornadaCallbackRecursivo($scope.ura);

                        $scope.ura.PossuiMenu = $scope.ura.ChildUra.length > 0;

                        $scope.ura.UraJornada.forEach(jornada => {
                            jornada.UraPeriodo.forEach(periodo => {
                                periodo.Inicio = moment(periodo.Inicio, "HH:mm").format(timeFormat);
                                periodo.Termino = moment(periodo.Termino, "HH:mm").format(timeFormat);
                            })
                        })

                        // Init listMenus
                        let iniciaMenusTransferencia = function (ura) {
                            $scope.listMenus = [];
                            if ($scope.ura.Descricao != undefined) {
                                // Menu inicial
                                // Se o MenuGuid == undefined
                                // ura de versão anterior a
                                // opcao com transferencia para menu
                                if ($scope.ura.MenuGuid == undefined) {
                                    $scope.ura.MenuGuid = UraHelper.uuidv4();
                                }
                                $scope.listMenus.push({ MenuGuid: $scope.ura.MenuGuid, Descricao: $scope.ura.Descricao });
                            }
                            setMenusTransferencia(ura);
                        };

                        let setMenusTransferencia = function (ura) {
                            if (ura == null || ura == undefined) return;
                            if (ura.ChildUra) {
                                for (let i = 0; i < ura.ChildUra.length; i++) {
                                    let child = ura.ChildUra[i];
                                    if ((child.TipoUra != undefined && child.TipoUra == "menu") ||
                                        (child.UraTipoId != undefined && child.UraTipoId == 5)) {
                                        if (child.Descricao != undefined) {
                                            // Se o MenuGuid == undefined
                                            // ura de versão anterior a
                                            // opcao com transferencia para menu
                                            if ($scope.ura.MenuGuid == undefined) {
                                                $scope.ura.MenuGuid = UraHelper.uuidv4();
                                            }
                                            $scope.listMenus.push({ MenuGuid: child.MenuGuid, Descricao: child.Descricao });
                                        }
                                    }
                                    setMenusTransferencia(child);
                                }
                            }
                        };

                        if ($scope.ura.UraTipoId == 5 &&
                            $scope.ura.MenuGuid == undefined) {
                            $scope.ura.MenuGuid = UraHelper.uuidv4();
                        }

                        var setUraIdAudios = function (ura) {
                            if (ura != null) {

                                ura.UraIdDiretiva = ura.UraId;

                                if (ura.MenuUraArquivo)
                                    ura.MenuUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.NaoDigitaUraArquivo)
                                    ura.NaoDigitaUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.MaxErroUraArquivo)
                                    ura.MaxErroUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.DigitoInvalidoUraArquivo)
                                    ura.DigitoInvalidoUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.FeriadoUraArquivo)
                                    ura.FeriadoUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.ForaJornadaUraArquivo)
                                    ura.ForaJornadaUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.TerminoUraArquivo)
                                    ura.TerminoUraArquivo.UrUraIdDiretivaId = ura.UraId;
                                if (ura.AvisoManutencaoUraArquivo)
                                    ura.AvisoManutencaoUraArquivo.UraIdDiretiva = ura.UraId;
                                if (ura.MaxParticipantesUraArquivo)
                                    ura.MaxParticipantesUraArquivo.UraIdDiretiva = ura.UraId;

                                if (ura.ChildUra) {
                                    for (var i = 0; i < ura.ChildUra.length; i++) {
                                        setUraIdAudios(ura.ChildUra[i]);
                                    }
                                }
                            }
                        }

                        iniciaMenusTransferencia($scope.ura);
                        setUraIdAudios($scope.ura);

                        //#region Envia Dados CRM 

                        let SetShowVariaveis = function (ura) {

                            if (ura.ChildUra && ura.ChildUra.length > 0) {
                                ura.ChildUra.forEach(el => {
                                    SetShowVariaveis(el);
                                });
                            }

                            if (ura.UraEnviarDadosCrm) {

                                ura.UraEnviarDadosCrm.forEach(el => {
                                    el.showVariaveis = false;
                                    if (el.VariavelUraAtendimentoId) {
                                        el.showVariaveis = true;
                                    }
                                });
                            }
                        }

                        SetShowVariaveis($scope.ura);

                        $scope.adicionarDadosCrm($scope.ura);

                        $scope.ura.ChildUra.forEach(u => { $scope.adicionarDadosCrm(u); });

                        //#endregion Envia Dados CRM 

                    }
                    $scope.getIntencoesByCarteira(true);
                }

                //*************************
                //	FIM DE INICIALIZAÇÃO
                //*************************

                //*************************
                //  MÉTODOS DE DIAGRAMA
                //
                //    if (typeof joint !== 'undefined') {
                //        console.log('JointJS version:', joint.version);
                //    }
                //    VM1135: 3 JointJS version: 1.0.3
                //
                // https://www.npmjs.com/package/jointjs/v/1.0.3
                //
                //
                //  https://resources.jointjs.com/tutorials/joint/tutorials/intermediate.html
                //  https://resources.jointjs.com/tutorial/custom-elements
                //*************************

                $scope.plotNo = function (x, y, width, height, tipo, descricao, digito, tipoUra, podeExcluir, podeAdicionar) {
                    let tipoSVG = "", svgExcluir = "", svgAdicionar = "", posicaoXAdicionar, posicaoXDeletar;

                    //SVG TIPO DE URA
                    if (tipoUra == "ramal" || tipoUra == "ramalPabx") {
                        tipoSVG = $scope.iconeRamal;
                    } else if (tipoUra == "grupo") {
                        tipoSVG = $scope.iconeGrupo;
                    } else if (tipoUra == "servico") {
                        tipoSVG = $scope.iconeServico;
                    } else if (tipoUra == "menu" || tipoUra == "avancado" || tipoUra == "transfereMenu") {
                        tipoSVG = $scope.iconeMenu;
                    } else if (tipoUra == "ura") {
                        tipoSVG = $scope.iconeUra;
                    } else if (tipoUra == "desliga") {
                        tipoSVG = $scope.iconeDesliga;
                    } else if (tipoUra == "transferencia") {
                        tipoSVG = $scope.iconeTransferencia;
                    } else if (tipoUra == "integracao") {
                        tipoSVG = $scope.iconeIntegracao;
                    } else if (tipoUra == "consultaApi") {
                        tipoSVG = $scope.iconeConsultaApi;
                    } else if (tipoUra == "whatsapp") {
                        tipoSVG = $scope.iconeWhatsapp;
                    }
                    else if (tipoUra == "solicitaDigitos") {
                        tipoSVG = $scope.iconeSolicitaDigitos;
                    }

                    // Inicia menu com descricao default
                    if (tipoUra == "menu" && descricao == undefined) {
                        descricao = "Menu " + x.toString() + "." + y.toString();
                    }

                    //SVG ADICIONAR
                    if (podeAdicionar == true) {
                        svgAdicionar = '<g class="btn add"><circle class="add"/><text class="add">+</text></g>';
                    }
                    //SVG EXCLUSÃO
                    if (podeExcluir == true) {
                        svgExcluir = '<g class="btn del"><circle class="del"/><text class="del">-</text></g>';
                    }

                    if (podeAdicionar == false) {
                        posicaoXDeletar = -15;
                        posicaoXAdicionar = 0;
                    } else {
                        posicaoXDeletar = -40;
                        posicaoXAdicionar = -15;
                    }

                    joint.shapes.org.Member.prototype.markup = [
                        '<g class="rotatable" >',
                        '<g class="scalable">',
                        '<rect class="card"/>',
                        "</g>",
                        '<g class="icon">' + tipoSVG + "</g>",
                        '<g class="erro invisivel"><circle/><text>!</text></g>',
                        '<text class="tipo" /><text class="descricao"/><text class="digito"/>',
                        svgAdicionar,
                        svgExcluir,
                        "</g>"
                    ].join("");

                    let cell = new joint.shapes.org.Member({
                        size: {
                            width: width,
                            height: height
                        },
                        position: {
                            x: x,
                            y: y
                        },
                        attrs: {
                            ".card": {
                                rx: 0,
                                ry: 0,
                                stroke: "none",
                                fill: "#f2f2f2"
                            },
                            ".tipo": {
                                text: tipo != null && tipo.length > 14 ? tipo.substr(0, 11) + "." : tipo,
                                "font-family": "Roboto,sans-serif",
                                "font-size": 14,
                                "font-weight": 500,
                                "y-alignment": "middle",
                                "word-spacing": "-1px",
                                "letter-spacing": "0.1px",
                                "text-decoration": "none",
                                "ref-x": 0.05,
                                "ref-y": 0.5
                            },
                            ".descricao": {
                                text: descricao != null && descricao.length > 17 ? descricao.substr(0, 13) + "..." : descricao,
                                "font-family": "Roboto,sans-serif",
                                "font-size": 12,
                                "font-weight": 300,
                                "y-alignment": "middle",
                                "word-spacing": "-1px",
                                "letter-spacing": 0,
                                "text-decoration": "none",
                                "ref-y": 0.7,
                                "ref-x": 0.05
                            },
                            ".digito": {
                                text: digito != null && digito.length >= 16 ? digito.substr(0, 15) + "..." : digito,
                                "font-family": "Roboto,sans-serif",
                                "font-size": 12,
                                "font-weight": 300,
                                "y-alignment": "middle",
                                "word-spacing": "-1px",
                                "letter-spacing": 0,
                                "text-decoration": "none",
                                "text-alignment": "right",
                                "font-style": "italic",
                                "ref-y": 0.9,
                                "ref-x": 0.05
                            },
                            ".erro": {
                                "ref-x": 40,
                                "ref-y": 15
                            },
                            ".erro>circle": {
                                r: 10,
                                fill: "#e53935",
                                stroke: "#444444",
                                "stroke-width": 2
                            },
                            ".erro>text": {
                                text: "!",
                                "font-size": 20,
                                "font-weight": 800,
                                fill: "#ffffff",
                                "font-family": "Roboto,sans-serif",
                                x: -3,
                                y: 7
                            },
                            ".icon": {
                                "ref-x": 3,
                                "ref-y": 3
                            },
                            ".btn.add": {
                                "ref-dx": posicaoXAdicionar,
                                "ref-y": 15,
                                ref: ".card"
                            },
                            ".btn.del": {
                                "ref-dx": posicaoXDeletar,
                                "ref-y": 15,
                                ref: ".card"
                            },
                            ".btn>circle": {
                                r: 10,
                                fill: "transparent",
                                stroke: $scope.iconeCor,
                                "stroke-width": 1
                            },
                            ".btn>rect": {
                                height: 20,
                                width: 45,
                                rx: 2,
                                ry: 2,
                                fill: "transparent",
                                "stroke-width": 1
                            },
                            ".btn.add>text": {
                                "font-size": 23,
                                "font-weight": 800,
                                stroke: $scope.iconeCor,
                                x: -6.5,
                                y: 8,
                                "font-family": "Times New Roman"
                            },
                            ".btn.del>text": {
                                "font-size": 28,
                                "font-weight": 500,
                                stroke: $scope.iconeCor,
                                x: -4.5,
                                y: 6,
                                "font-family": "Times New Roman"
                            }
                        }
                    });
                    graph.addCell(cell);

                    return cell;
                };

                $scope.plotLink = function (source, target) {
                    let link = new joint.dia.Link({
                        source: {
                            id: source.id
                        },
                        target: {
                            id: target.id
                        },
                        router: {
                            name: "manhattan"
                        },
                        connector: {
                            name: "normal"
                        },
                        attrs: {
                            ".connection": {
                                fill: "none",
                                "stroke-width": "2",
                                stroke: "#4b4a67"
                            },
                            ".marker-target": {
                                fill: "#333333",
                                d: "M 10 0 L 0 5 L 10 10 z"
                            }
                        }
                    });
                    graph.addCell(link);
                    return link;
                };

                $scope.removeLink = function (source) {
                    var links = graph.getConnectedLinks(source, { outbound: true });
                    if (links != null && links != undefined) {
                        links.forEach(item => item.remove());
                    }

                    //    let cell = graph.getCell(source.id);
                    //    if (cell != null && cell != undefined) {
                    //        graph.disconnectLinks(cell);
                    //    }

                    //    //cell.remove();
                    //    //graph.addCell(cell);
                };

                $scope.transformarJsonEmDadosPlot = function (ura) {
                    ura.DadosNo = JSON.parse(ura.DadosNo);
                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        $scope.transformarJsonEmDadosPlot(ura.ChildUra[i]);
                    }
                };

                $scope.plotArvoreExistente = function (ura) {
                    if (ura.ParentUra == null) {
                        //Plot No Principal
                        let noPrincipal = $scope.plotNo(
                            ura.DadosNo.x,
                            ura.DadosNo.y,
                            tamanhoNoX,
                            tamanhoNoY,
                            $translate.instant('controller.inicioUra'),
                            "",
                            "",
                            "menu",
                            false,
                            true);
                        $("g[model-id='" + noPrincipal.id + "']").addClass("menu no-selecionado");

                        $scope.noSelecionado = noPrincipal;
                        $scope.arvoreUra.push(noPrincipal);
                        ura.DadosPlot = noPrincipal;
                        if (ura.UraTipoId != 10) ura.TipoUra = "menu";
                        else ura.TipoUra = "satisfacao";
                        $scope.uraSelecionada = $scope.ura;
                        paper.setOrigin(ura.DadosNo.x, ura.DadosNo.y);
                        $scope.mudarDescricaoNo(ura);
                    } else {
                        let tipoUra = _.find($scope.tiposUra, el => {
                            return el.TipoId == ura.UraTipoId;
                        }).Descricao;

                        let nomeNo, descricaoNo, podeAdicionar, digitoTexto = "";

                        if (tipoUra == "ramal") {
                            nomeNo = $translate.instant('model.ramal');
                            podeAdicionar = false;
                            descricaoNo = ura.DadosNo.descricao;
                        } else if (tipoUra == "ramalPabx") {
                            nomeNo = $translate.instant('telaUraEdit.ramalIntegracao');
                            podeAdicionar = false;
                            descricaoNo = ura.DadosNo.descricao;
                        } else if (tipoUra == "ura") {
                            nomeNo = $translate.instant('controller.uraExistente');
                            podeAdicionar = false;
                            descricaoNo = ura.DadosNo.descricao;
                        } else if (tipoUra == "grupo") {
                            nomeNo = $translate.instant('model.grupo');
                            podeAdicionar = false;
                            descricaoNo = ura.DadosNo.descricao;
                        } else if (tipoUra == "servico") {
                            nomeNo = $translate.instant('model.servico');
                            podeAdicionar = false;
                            descricaoNo = ura.DadosNo.descricao;
                        } else if (tipoUra == "menu") {
                            nomeNo = $translate.instant('controller.menu');
                            podeAdicionar = true;
                            descricaoNo = $translate.instant('controller.escolhaDeDigito');
                        } else if (tipoUra == "desliga") {
                            nomeNo = $translate.instant('controller.desligar');
                            podeAdicionar = false;
                            descricaoNo = $translate.instant('controller.desligarUra');
                        } else if (tipoUra == "integracao") {
                            nomeNo = $translate.instant('campo.integracao');
                            podeAdicionar = true;
                            descricaoNo = ura.DadosNo.descricao;
                            ura.UraCondicao.forEach(condicao => {
                                let integracaoSelecionada = _.find($scope.integracoes, el => {
                                    return (ura.UraIntegracaoId == el.IntegracaoConfiguracaoId);
                                });
                                condicao.RespostaNome = _.find(integracaoSelecionada.IntegracaoResposta, el => {
                                    return (condicao.IntegracaoRespostaId == el.IntegracaoRespostaId);
                                }).Nome;
                                condicao.OperadorNome = _.find($scope.operadores, el => {
                                    return (condicao.OperadorId == el.OperadorLogicoId);
                                }).Alias;
                                let condicaoUraTipo = condicao.RedirecionaUra.UraTipo.Descricao;
                                if (condicaoUraTipo == "Grupo" || condicaoUraTipo == "Ramal" || condicaoUraTipo == "Ura" || condicaoUraTipo == "Serviço") {
                                    condicaoUraTipo = $translate.instant('campo.transferencia');
                                }

                                condicao.UraDescricao = _.find(
                                    $scope.tiposUraRedireciona, el => {
                                        return condicaoUraTipo == el.Alias;
                                    }
                                ).Alias;

                                if (condicao.RedirecionaUra.UraId != ura.UraId) {
                                    condicao.RedirecionaUra = _.find(
                                        ura.ChildUra, el => {
                                            return (el.UraId == condicao.RedirecionaUra.UraId);
                                        }
                                    );
                                    if (condicao.RedirecionaUra != null) {
                                        condicao.RedirecionaUra.DigitoTexto = condicao.RespostaNome + " " + condicao.OperadorNome + " " + condicao.ValorComparacao;
                                    }
                                }
                            });
                        } else if (tipoUra == "transfereMenu") {
                            nomeNo = $translate.instant('controller.noTransfereMenu');
                            podeAdicionar = false;
                            descricaoNo = $translate.instant('telaUraEdit.transfereMenu');
                        } else if (tipoUra == "consultaApi") {
                            nomeNo = $translate.instant('telaUraEdit.noConsultarApi');
                            podeAdicionar = false;
                        } else if (tipoUra == "whatsapp") {
                            nomeNo = $translate.instant('telaUraEdit.noWhatsapp');
                            podeAdicionar = false;
                        } else if (tipoUra == "solicitaDigitos") {
                            nomeNo = $translate.instant('telaUraEdit.noSolicitarDigitos');
                            podeAdicionar = false;
                        }

                        $scope.noSelecionado = $scope.buscarIdemUra($scope.ura, ura.ParentUra.UraId).DadosPlot;
                        // Se é edição da ura, buscamos a intenção no bkp
                        let intencao = $scope.intencoesBkp.find(item => item.Id == ura.UraIntencaoId);
                        $scope.adicionarNovoNo(
                            ura.DadosNo.x,
                            ura.DadosNo.y,
                            nomeNo,
                            descricaoNo,
                            ura.Botao,
                            tipoUra,
                            podeAdicionar,
                            ura,
                            null,
                            intencao);
                        $scope.mudarDescricaoNo(ura);
                    }

                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        $scope.plotArvoreExistente(ura.ChildUra[i]);
                    }
                };

                $scope.controlarSidebar = function () {
                    $scope.sidebarAtiva = !$scope.sidebarAtiva;
                };

                $scope.adicionarNovoNo = function (posicaoX, posicaoY, nomeNo, descricaoNo, digito, tipoUra, podeAdicionar, uraExistente, descricaoDigito, intencao) {
                    let uraPai = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                    let digitoTexto = "";
                    let uraIdDiretiva = Math.random();

                    // se for menu, a descrição é preenchida
                    // ao selecionar o digito do menu
                    descricaoNo = $scope.menuDescricao;

                    if (digito && !descricaoDigito) {
                        digitoTexto = $scope.getdescricaoDigito(digito, intencao);
                    } else if (descricaoDigito) {
                        digitoTexto = descricaoDigito;
                    }

                    let uraTipoId = _.find($scope.tiposUra, el => {
                        return el.Descricao == tipoUra;
                    }).TipoId;

                    // Inicia menu com descricao default
                    if (tipoUra == "menu" && descricaoNo == undefined) {
                        descricaoNo = "Menu " + posicaoX.toString() + "." + posicaoY.toString();
                    }

                    let novoNo = $scope.plotNo(posicaoX, posicaoY, tamanhoNoX, tamanhoNoY, nomeNo, descricaoNo, digitoTexto, tipoUra, true, podeAdicionar);

                    $("g[model-id='" + novoNo.id + "']").addClass(tipoUra);

                    let tipoTransferencia = null;
                    if (tipoUra == "servico" || tipoUra == "ramal" || tipoUra == "ramalPabx" || tipoUra == "grupo" || tipoUra == "ura" || tipoUra == "transfereMenu") {
                        tipoTransferencia = tipoUra;
                        tipoUra = "transferencia";
                    }

                    $scope.plotLink($scope.noSelecionado, novoNo);
                    if (uraExistente == null) {
                        let novaUra = {
                            DadosPlot: novoNo,
                            Descricao: descricaoNo != undefined ? descricaoNo : undefined,
                            ChildUra: [],
                            ParentUra: uraPai,
                            Botao: digito,
                            TipoUra: tipoUra,
                            UraTipoId: uraTipoId,
                            TipoTransferencia: tipoTransferencia,
                            RedirecionaForaJornadaUraTipoId: 6,
                            JornadaPersonalizada: false,
                            UraIdDiretiva: uraIdDiretiva
                        };

                        if (tipoUra == "menu" ||
                            tipoUra == "consultaApi") {
                            
                            novaUra.MenuGuid = UraHelper.uuidv4();
                            novaUra.RedirecionaTipoId = 6;
                        }

                        if (!uraPai.ChildUra) {
                            uraPai.ChildUra = [];
                        }
                        uraPai.ChildUra.push(novaUra);
                        if (uraPai.TipoUra == "integracao") {
                            let index = _.indexOf(uraPai.UraCondicao, $scope.condicaoEditada);
                            uraPai.UraCondicao[index].RedirecionaUra = novaUra;
                        }
                        if (tipoUra == "integracao") {
                            $scope.ura.TipoUra = "avancado";
                            $scope.ura.UraTipoId = 7;
                        }
                    } else {
                        uraExistente.TipoUra = tipoUra;
                        uraExistente.DadosPlot = novoNo;
                        uraExistente.ParentUra = uraPai;
                        uraExistente.TipoTransferencia = tipoTransferencia;

                        // Add link em caso de transferencia para menu
                        $scope.plotLinkTransfMenu(uraExistente, null);
                    }

                    $scope.ativarZoom();
                    return novoNo;
                };

                $scope.clicarNovoNo = function (tipoUra, adicionarCondicao) {
                    let uraPai = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                    let posicaoXFilhoUra = $scope.receberPosicaoADireita(uraPai);
                    let novaPosicaoX = uraPai.ChildUra.length == 0 ? posicaoXFilhoUra : posicaoXFilhoUra + tamanhoNoX + 30;
                    let novaPosicaoY = $scope.noSelecionado.attributes.position.y + tamanhoNoY + 40;
                    let nomeNo = "";
                    let descricaoNo = '---';
                    let descricaoDigito;
                    let podeAdicionar;

                    if (tipoUra == "ramal") {
                        nomeNo = $translate.instant('model.ramal');
                        podeAdicionar = false;
                    } else if (tipoUra == "ura") {
                        nomeNo = $translate.instant('controller.uraExistente');
                        podeAdicionar = false;
                    } else if (tipoUra == "grupo") {
                        nomeNo = $translate.instant('model.grupo');
                        podeAdicionar = false;
                    } else if (tipoUra == "menu") {
                        nomeNo = $translate.instant('controller.menu');
                        descricaoNo = $translate.instant('controller.escolhaDeDigito');
                        podeAdicionar = true;
                    } else if (tipoUra == "servico") {
                        nomeNo = $translate.instant('model.servico');
                        podeAdicionar = false;
                    } else if (tipoUra == "desliga") {
                        nomeNo = $translate.instant('controller.desligar');
                        descricaoNo = $translate.instant('controller.desligarUra');
                        podeAdicionar = false;
                    } else if (tipoUra == "transferencia") {
                        nomeNo = $translate.instant('campo.transferencia');
                        podeAdicionar = false;
                    } else if (tipoUra == "integracao") {
                        nomeNo = $translate.instant('campo.integracao');
                        podeAdicionar = false;
                    } else if (tipoUra == "repetir") {
                        podeAdicionar = false;
                    } else if (tipoUra == "consultaApi") {
                        nomeNo = $translate.instant('telaUraEdit.noConsultarApi');
                        podeAdicionar = false;
                    } else if (tipoUra == "whatsapp") {
                        nomeNo = $translate.instant('telaUraEdit.noWhatsapp');
                        podeAdicionar = false;
                    } else if (tipoUra == "capturaDigitos") {
                        nomeNo = $translate.instant('telaUraEdit.noSolicitarDigitos');
                        podeAdicionar = false;
                    }

                    if (uraPai.TipoUra == "menu" || uraPai.TipoUra == "satisfacao") {

                        $('#modal_digito').on({
                            'hide.uk.modal': () => {
                                $scope.infoUraModal.tipoUra = undefined;
                            }
                        });

                        ModalService.isHidden('modal_digito', () => {
                            $scope.infoUraModal = {
                                novaPosicaoX: novaPosicaoX,
                                novaPosicaoY: novaPosicaoY,
                                nomeNo: nomeNo,
                                descricaoNo: descricaoNo,
                                tipoUra: tipoUra,
                                podeAdicionar: podeAdicionar
                            };
                            $scope.digitosLivres = $scope.receberDigitosLivres(
                                uraPai
                            );
                            $scope.trocarDigito = false;
                        })
                    } else if (uraPai.TipoUra == "integracao" && !adicionarCondicao) {
                        ModalService.isHidden('modal_condicao', () => {
                            $scope.condicaoEditada = {
                                TipoUra: tipoUra
                            };
                            $scope.editandoCondicao = false;
                        }, { bgclose: false })
                    } else if (uraPai.TipoUra == "integracao" && adicionarCondicao == true) {
                        descricaoDigito = $scope.condicaoEditada.RespostaNome + " " + $scope.condicaoEditada.OperadorNome + " " + $scope.condicaoEditada.ValorComparacao;
                        $scope.adicionarNovoNo(novaPosicaoX, novaPosicaoY, nomeNo, descricaoNo, digitoEscolhido, tipoUra, podeAdicionar, null, descricaoDigito);
                    } else {
                        $scope.adicionarNovoNo(novaPosicaoX, novaPosicaoY, nomeNo, descricaoNo, null, tipoUra, podeAdicionar);
                    }

                    $("#add-new-ura .md-fab-primary:not(.md-fab-small) i:not(.md-fab-action-close)").css("display", "block");
                    $("#add-new-ura .md-fab-primary:not(.md-fab-small) i.md-fab-action-close").css("display", "none");
                };

                $scope.onBotaoAlterado = function () {
                    let uraPai = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                    $scope.digitosLivres = $scope.receberDigitosLivres(uraPai);
                    $scope.digitosLivresColecao = $scope.receberDigitosLivresColecao($scope.digitosLivres);
                };

                $scope.buscarNoEmUra = function (ura, no) {
                    if (ura == null || ura.DadosPlot == no) {
                        return ura;
                    } else {
                        if (ura.ChildUra) {
                            for (let i = 0; i < ura.ChildUra.length; i++) {
                                let retornoBusca = $scope.buscarNoEmUra(ura.ChildUra[i], no);
                                if (retornoBusca != null) return retornoBusca;
                            }
                        }
                        return null;
                    }
                };

                $scope.buscarIdemUra = function (ura, id) {
                    if (ura == null || ura.UraId == id) {
                        return ura;
                    } else {
                        if (ura.ChildUra) {
                            for (let i = 0; i < ura.ChildUra.length; i++) {
                                let retornoBusca = $scope.buscarIdemUra(ura.ChildUra[i], id);
                                if (retornoBusca != null) return retornoBusca;
                            }
                        }
                        return null;
                    }
                };

                $scope.buscarUraByMenuGuid = function (ura, menuGuid) {
                    if (ura == null || ura.MenuGuid == menuGuid) {
                        return ura;
                    } else {
                        if (ura.ChildUra) {
                            for (let i = 0; i < ura.ChildUra.length; i++) {
                                let retornoBusca = $scope.buscarUraByMenuGuid(ura.ChildUra[i], menuGuid);
                                if (retornoBusca != null) return retornoBusca;
                            }
                        }
                        return null;
                    }
                };

                $scope.limparValidacaoUra = function (ura) {
                    if (ura.ChildUra && ura.ChildUra.length > 0) {
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            $scope.limparValidacaoUra(ura.ChildUra[i]);
                        }
                    }
                    ura.TemErro = false;
                    ura.FilhoTemErro = false;
                    ura.temErroCallback = false;
                    ura.temErroExcecao = false;
                    ura.temErroJornada = false;
                    ura.temErroUra = false;
                    ura.temErroServicos = false;
                    if (ura.ParentUra) {
                        ura.ParentUra.TemErro = false;
                        ura.ParentUra.FilhoTemErro = false;
                    }
                    if (ura.UraJornada != null && ura.UraJornada.length > 0) {
                        ura.UraJornada.forEach(jornada => {
                            jornada.temErro = false;
                        });
                    }
                    return ura;
                };

                $scope.exibirValidacaoUra = function (ura) {
                    if (ura.ChildUra && ura.ChildUra.length > 0) {
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            $scope.exibirValidacaoUra(ura.ChildUra[i]);
                        }
                    }
                    ura.TemErro = $scope.validarUra(ura);

                    //tem pai e o pai não foi informado de erro no filho
                    if (ura.ParentUra && (ura.ParentUra.FilhoTemErro == false || ura.ParentUra.FilhoTemErro == null)) {
                        ura.ParentUra.FilhoTemErro = ura.TemErro || ura.FilhoTemErro; //é a raiz e não foi informado de erro no filho
                    } else if (!ura.ParentUra && (ura.FilhoTemErro == false || ura.FilhoTemErro == null)) {
                        ura.FilhoTemErro = ura.TemErro;
                    }

                    if (ura.TemErro == true) {
                        $("g[model-id='" + ura.DadosPlot.id + "'] .erro").removeClass("invisivel");
                    } else {
                        $("g[model-id='" + ura.DadosPlot.id + "'] .erro").addClass("invisivel");
                    }
                    return ura;
                };

                $scope.validarUra = function (ura) {
                    let temErro = false;
                    if (ura.TipoUra == "menu" || ura.TipoUra == "avancado" || ura.TipoUra == "solicitaDigitos") {
                        if (ura.ParentUra == null && (!ura.Descricao || ura.Descricao == "" || ura.Descricao.length == 0)) {
                            temErro = true;
                            ura.temErroUra = true;
                        } else if (ura.ParentUra == null && (ura.AvisoManutencao == true && (!ura.AvisoManutencaoArquivoId || ura.AvisoManutencaoArquivoId == 0))) {
                            temErro = true;
                            ura.temErroUra = true;
                        } else if (ura.ParentUra == null && (!ura.AvisoManutencao || ura.AvisoManutencao == 0) && (!ura.UraTipoIntegracaoId ||
                            ura.UraTipoIntegracaoId == 0)) {
                            temErro = true;
                            ura.temErroUra = true;
                        } else if (((!ura.MenuArquivoId || ura.MenuArquivoId == 0) && ura.TipoUra != "solicitaDigitos" && !(ura.ChildUra && ura.ChildUra.length > 0 && ura.ChildUra[0].TipoUra == "consultaApi")) ||
                            (((ura.UraTipoIntegracaoId == 1 || ura.UraTipoIntegracaoId == 2) &&
                                (!ura.AvisoManutencao || ura.AvisoManutencao == 0) &&
                                (!ura.IntroArquivoId || ura.IntroArquivoId == 0)) &&
                                ura.ParentUra == null)) {
                            temErro = true;
                            ura.temErroUra = true;
                        } else if ($scope.showExcecao() && (!ura.RedirecionaTipoId || ura.RedirecionaTipoId == 0)) {
                            temErro = true;
                            ura.temErroExcecao = true;
                        }
                    } else if (ura.TipoUra == "transferencia") {
                        if (ura.TipoTransferencia == "ramal") {
                            if (!ura.RamalId || ura.RamalId == 0) {
                                temErro = true;
                                ura.temErroUra = true;
                            }
                        } else if (ura.TipoTransferencia == "ramalPabx") {
                            if (!ura.RamalId || ura.RamalId == 0) {
                                temErro = true;
                                ura.temErroUra = true;
                            }
                        } else if (ura.TipoTransferencia == "grupo") {
                            if (ura.ConfigurarGrupoPorHorario) {
                                ura.UraJornada.forEach(jornada => {
                                    if (!jornada.Excecao)
                                        jornada.UraPeriodo.forEach(p => {
                                            if (p.GrupoId == null || p.GrupoId == undefined) {
                                                temErro = true;
                                                ura.temErroJornada = true;
                                                jornada.temErro = true;
                                            }
                                        })
                                });
                                ura.GrupoId = null;
                            }
                            else if (!ura.GrupoId || ura.GrupoId == 0) {
                                if (ura.UraJornada) {
                                    ura.UraJornada.forEach(element => {
                                        element.UraPeriodo.forEach(p => {
                                            p.GrupoId = null;
                                        })
                                    });
                                }
                                temErro = true;
                                ura.temErroUra = true;
                            }
                        } else if (ura.TipoTransferencia == "ura") {
                            if (!ura.RedirecionaUraId || ura.RedirecionaUraId == 0) {
                                temErro = true;
                                ura.temErroUra = true;
                            }
                        } else if (ura.TipoTransferencia == "servico") {
                            if (!ura.ServicoId || ura.ServicoId == 0) {
                                temErro = true;
                                ura.temErroUra = true;
                            }
                        } else if (ura.TipoTransferencia == "transfereMenu") {
                            if (ura.MenuGuidTransferir == null || ura.MenuGuidTransferir == undefined) {
                                temErro = true;
                                ura.temErroUra = true;
                            }
                        } else if (ura.TipoTransferencia == null || ura.TipoTransferencia == undefined) {
                            temErro = true;
                            ura.temErroUra = true;
                        }
                    }

                    if (ura.JornadaPersonalizada == true && ura.UraJornada.length > 0 && ura.ForaJornadaArquivoId == null) {
                        temErro = true;
                        ura.temErroJornada = true;
                    }

                    if (ura.JornadaPersonalizada == true && ura.UraJornada.filter(x => x.Excecao).length > 0 && ura.FeriadoArquivoId == null) {
                        temErro = true;
                        ura.temErroJornada = true;
                    }

                    if (ura.PossuiCallback == true && ura.CallbackCampanhaId == null) {
                        temErro = true;
                        ura.temErroCallback = true;
                    }
                    if ($scope.isStatisfacao && (!ura.Descricao || ura.Descricao == "" || ura.Descricao.length == 0)) {
                        temErro = true;
                        ura.temErroUra = true;
                    }

                    return temErro;
                };

                $scope.receberDigitosLivres = function (ura) {
                    //                                                                         10    11    12    13
                    //             0     1     2     3     4     5     6     7     8     9     *     #     redir ?
                    let digitos = [true, true, true, true, true, true, true, true, true, true, true, true, true, true];

                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        let ind = $scope.getIndexDigitosLivres(ura.ChildUra[i].Botao);
                        // Em caso de ura Solicita Digitos, deixamos os demais digitos habilitados
                        if (ind != -1 && ura.ChildUra[i].TipoUra != 'solicitaDigitos') {
                            digitos[ind] = false;
                        }
                    }
                    // ? => Todos os dígitos foi selecionado,
                    // retiramos o demais digitos 0~#
                    if (!digitos[13]) {
                        for (let i = 0; i < 12; i++) {
                            digitos[i] = false;
                        }
                    }
                    return digitos;
                };

                $scope.getIndexDigitosLivres = function (digito) {
                    let index = -1;
                    switch (digito) {
                        case '*':
                            index = 10;
                            break;
                        case '#':
                            index = 11;
                            break;
                        case '?':
                            index = 12;
                            break;
                        default:
                            if (!isNaN(digito)) {
                                index = Number(digito);
                            }
                            break;
                    }
                    return index;
                }

                $scope.receberDigitosLivresColecao = function (digitos) {
                    let list = [];
                    for (let i = 0; i < digitos.length; i++) {
                        if (digitos[i]) list.push({ Valor: i, Alias: i });
                    }
                    return list;
                };

                $scope.mudarDigito = function () {
                    ModalService.isHidden('modal_digito', () => {

                        $scope.variaveisGlobais.uraIntencaoId = undefined;
                        if ($scope.uraSelecionada.Botao == 'I') {

                            // Digitos
                            $scope.digitosLivres[13] = false;
                            for (let i = 0; i < 12; i++) {
                                $scope.digitosLivres[i] = true;
                            }

                            // Add a intenção da uraSelecionada nas intencoes
                            let intencao = $scope.intencoesBkp.find(item => item.Id == $scope.uraSelecionada.UraIntencaoId);
                            if (intencao) {
                                intencao.NomeAlias = intencao.Nome + (intencao.Alias ? ' - ' + intencao.Alias : '');
                                $scope.intencoes.push(intencao);
                                $scope.variaveisGlobais.uraIntencaoId = $scope.uraSelecionada.UraIntencaoId;
                            }
                        }
                        else {
                            let uraPai = $scope.buscarIdemUra($scope.ura, $scope.uraSelecionada.ParentUra.UraId);
                            $scope.digitosLivres = $scope.receberDigitosLivres(uraPai);
                        }
                        $scope.trocarDigito = true;
                    })
                };

                $scope.receberPosicaoADireita = function (ura) {
                    let maisDireita = ura.DadosPlot.attributes.position.x;
                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        if (maisDireita < ura.ChildUra[i].DadosPlot.attributes.position.x) {
                            maisDireita = ura.ChildUra[i].DadosPlot.attributes.position.x;
                        }
                    }
                    return maisDireita;
                };

                $scope.removerUraArvore = function (uraRemovida, removerDoPai) {
                    let index;
                    if (removerDoPai == true) {
                        index = uraRemovida.ParentUra.ChildUra.indexOf(uraRemovida);
                        if (index > -1) {
                            uraRemovida.ParentUra.ChildUra.splice(index, 1);
                        }
                        if (uraRemovida.ParentUra.UraCondicao && uraRemovida.ParentUra.UraCondicao.length > 0) {
                            index = _.pluck(uraRemovida.ParentUra.UraCondicao, "RedirecionaUra").indexOf(uraRemovida);
                            if (index > -1) {
                                uraRemovida.ParentUra.UraCondicao.splice(index, 1);
                            }
                        }
                    }
                    delete uraRemovida.ParentUra;
                    if (uraRemovida.ChildUra && uraRemovida.ChildUra.length > 0) {
                        for (let i = 0; i <= uraRemovida.ChildUra.length - 1; i++) {
                            $scope.removerUraArvore(uraRemovida.ChildUra[i], false);
                        }
                    }
                    uraRemovida.DadosPlot.remove();
                };

                $scope.transformarDadosPlotJson = function (ura) {
                    let novoDadosNo = ura.DadosPlot.attributes.position;
                    novoDadosNo.descricao = ura.DadosPlot.attributes.attrs[".descricao"].text;
                    ura.DadosNo = JSON.stringify(novoDadosNo);
                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        $scope.transformarDadosPlotJson(ura.ChildUra[i]);
                    }
                };

                $scope.limparUra = function (ura) {
                    delete ura.ParentUra;
                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        $scope.limparUra(ura.ChildUra[i]);
                    }

                    // Reseta a carteira dos filhos, a referencia 
                    // é a carteira da ura pai
                    if (ura.UraRaizId) {
                        ura.CarteiraId = null;
                    }

                    // Remove os dados iniciais de envio CRM
                    if (ura.UraEnviarDadosCrm &&
                        ((ura.UraEnviarDadosCrm.length == 0) ||
                            (ura.UraEnviarDadosCrm.length == 1))) {
                        let invalido = ura.UraEnviarDadosCrm.filter(item => { !item.Valor && !item.VariavelUraAtendimentoId });
                        if (invalido.length > 0) {
                            ura.UraEnviarDadosCrm = null;
                        }
                    }
                };

                $scope.recriarReferenciaPai = function (ura) {
                    if (ura.ParentUra != null) {
                        let uraPai = $scope.buscarIdemUra($scope.ura, ura.ParentUra.UraId);
                        if (uraPai != null) {
                            ura.ParentUra = uraPai;
                        }
                    }
                    for (let i = 0; i < ura.ChildUra.length; i++) {
                        $scope.recriarReferenciaPai(ura.ChildUra[i]);
                    }
                };

                $scope.initListMenus = function () {
                    $scope.listMenus = [];
                    if ($scope.ura.Descricao != undefined) {
                        // Menu inicial
                        $scope.listMenus.push({ MenuGuid: $scope.ura.MenuGuid, Descricao: $scope.ura.Descricao });
                    }
                    $scope.setListMenus($scope.ura);
                }

                $scope.setListMenus = function (ura) {
                    if (ura == null || ura == undefined) return;
                    if (ura.ChildUra) {
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            let child = ura.ChildUra[i];
                            if ((child.TipoUra != undefined && child.TipoUra == "menu") ||
                                (child.UraTipoId != undefined && child.UraTipoId == 5)) {
                                if (child.Descricao != undefined) {
                                    $scope.listMenus.push({ MenuGuid: child.MenuGuid, Descricao: child.Descricao });
                                }
                            }
                            $scope.setListMenus(child);
                        }
                    }
                };

                $scope.redirecionar = function () {
                    return $scope.uraSelecionada.ParentUra == null &&
                        $scope.infoUraModal.tipoUra != 'menu' &&
                        $scope.infoUraModal.tipoUra != 'satisfacao' &&
                        //$scope.infoUraModal.tipoUra != 'consultaApi' &&
                        $scope.uraSelecionada.ChildUra.length == 0;
                }

                let hasNodeRequireCarteira = function (ura) {
                    let ret = false;
                    if (!ura || ura.length == 0) {
                        return ret;
                    }

                    ura.every(item => {
                        if (ret || item.UraTipoId == 23 || item.UraTipoId == 25 || item.UraIntencaoId) {
                            ret = true;
                            return false;
                        }
                        else {
                            ret = hasNodeRequireCarteira(item.ChildUra);
                            return true;
                        }

                    });

                    if (!ret) {
                        ret = hasNodeRequireCarteira(ura.ChildUra);
                    }
                    return ret;
                }

                $scope.nodeRequireCarteira = function () {
                    let ret = false;
                    ret = hasNodeRequireCarteira($scope.ura.ChildUra);
                    return ret;
                }

                $scope.disableDigitoUra = function (digito) {
                    return $scope.digitosLivres && !$scope.digitosLivres[digito];
                }

                $scope.showComboConectorAsr = function () {
                    let ret = false;
                    ret = $scope.hasIntencao($scope.ura);
                    return ret;
                }

                //*************************
                //	  MÉTODOS DE DETALHE
                //*************************

                $scope.exibirDetalhe = function (titulo, descricao) {
                    ModalService.alert(`<h3>${titulo}</h3>${descricao}`);
                };

                $scope.salvar = function (form) {

                    $scope.ura.FilhoTemErro = null;
                    $scope.ura = $scope.limparValidacaoUra($scope.ura);
                    $scope.ura = $scope.exibirValidacaoUra($scope.ura);
                    form.$setSubmitted();

                    if ($scope.ura.FilhoTemErro == true || !form.$valid) {

                        return NotifyService.showInvalid();
                    }

                    $scope.transformarDadosPlotJson($scope.ura);
                    let copiaUra = angular.copy($scope.ura);
                    $scope.limparUra(copiaUra);

                    if (copiaUra.UraJornada) {
                        copiaUra.UraJornada.forEach(jornada => {
                            if (jornada.UraPeriodo) {
                                jornada.UraPeriodo.forEach(periodo => {
                                    periodo.Inicio = moment(periodo.Inicio, timeFormat).format("HH:mm");
                                    periodo.Termino = moment(periodo.Termino, timeFormat).format("HH:mm");
                                })
                            }
                        })
                    }

                    ModalService.showLoading();

                    if ($scope.isNew) {

                        UraResource.save(copiaUra).$promise
                            .then(() => {
                                ModalService.hideLoading();
                                NotifyService.showRegistroSalvo();
                                $state.go("main.ura.list");
                            }).catch((ex) => {
                                ModalService.hideLoading();
                                NotifyService.showError(ex);
                            });
                    } else {

                        UraResource.update(copiaUra).$promise
                            .then(() => {
                                ModalService.hideLoading();
                                NotifyService.showRegistroSalvo();
                                form.$setPristine();
                                $state.go("main.ura.list");
                            }).catch((ex) => {
                                ModalService.hideLoading();
                                NotifyService.showError(ex);
                            });
                    }
                };

                $scope.onChangeIntencao = function () {

                    if ($scope.intencoes) {
                        let intencao = $scope.intencoes.find(item => item.Id == $scope.variaveisGlobais.uraIntencaoId);
                        if (intencao) {

                            $scope.uraSelecionada.UraIntencaoId = $scope.variaveisGlobais.uraIntencaoId;
                            $scope.setNomeIntencao();
                            $scope.ativarBotao('I', intencao);
                            $scope.variaveisGlobais.uraIntencaoId = undefined;

                            // Remove da lista das intencoes
                            let index = $scope.intencoes.findIndex(elem => elem.Id == $scope.uraSelecionada.UraIntencaoId);
                            if (index > -1) {
                                $scope.intencoes.splice(index, 1);
                            }
                        }
                    }
                }

                $scope.setNomeIntencao = function () {
                    $scope.nomeIntencaoSelecionada = '---';
                    if ($scope.uraSelecionada && $scope.uraSelecionada.UraIntencaoId
                    ) {
                        let intencao = $scope.intencoesBkp.find(item => item.Id == $scope.uraSelecionada.UraIntencaoId);
                        if (intencao) {
                            $scope.nomeIntencaoSelecionada = intencao.Nome + (intencao.Alias ? ' - ' + intencao.Alias : '');
                        }
                    }
                }

                $scope.ativarBotao = function (digito, intencao) {
                    if (digito == 'apenasRedirecionar') {
                        digito = null;
                        ModalService.alert($translate.instant('telaUraEdit.msgApenasRedirecionar'));
                    }

                    if ($scope.trocarDigito == false) {

                        let descricaoDigito = null;
                        if ($scope.variaveisGlobais.uraIntencaoId) {
                            descricaoDigito = (intencao != undefined ? intencao.Nome : '---');
                        }
                        let novoNo = $scope.adicionarNovoNo(
                            $scope.infoUraModal.novaPosicaoX,
                            $scope.infoUraModal.novaPosicaoY,
                            $scope.infoUraModal.nomeNo,
                            $scope.infoUraModal.descricaoNo,
                            digito,
                            $scope.infoUraModal.tipoUra,
                            $scope.infoUraModal.podeAdicionar,
                            null,
                            descricaoDigito,
                            intencao
                        );

                        let ura = $scope.buscarNoEmUra($scope.ura, novoNo);

                        if (ura && $scope.variaveisGlobais.uraIntencaoId) {

                            ura.UraIntencaoId = $scope.variaveisGlobais.uraIntencaoId;
                            $scope.variaveisGlobais.uraIntencaoId = null;
                            $scope.setNomeIntencao();
                        }
                    } else {

                        $scope.uraSelecionada.Botao = digito;
                        $scope.mudarDigitoNo($scope.uraSelecionada);
                    }
                    $scope.trocarDigito = false;
                    ModalService.closeModal('modal_digito');
                };

                $scope.abrirJornadaPopup = function () {
                    $('#modal_periodo').on({
                        'hide.uk.modal': () => {
                            $scope.editandoJornada = false;
                            $scope.jornadaEditadaId = -1;
                            $scope.atualizarDiaDisabled();
                            $scope.cancelarEdicao();
                        }
                    });

                    ModalService.openModal('modal_periodo', null, null, { center: false, bgclose: false });

                    $scope.atualizarDiaDisabled();
                };

                $scope.abrirFeriadoPopup = function () {
                    $('#modal_feriado').on({
                        'hide.uk.modal': () => {
                            $scope.editandoFeriado = false;
                            $scope.feriadoEditadoId = -1;
                            $scope.cancelarEdicao();
                        }
                    });

                    ModalService.openModal('modal_feriado')
                };

                $scope.esconderPeriodoModal = function () {
                    ModalService.closeModal('modal_periodo');
                };

                $scope.esconderFeriadoModal = function () {
                    ModalService.closeModal('modal_feriado');
                };

                $scope.adicionarHorario = function () {
                    $scope.jornadaAtual.Horarios.push({});
                };

                $scope.removerHorario = function (index) {
                    $scope.jornadaAtual.Horarios.splice(index, 1);
                };

                $scope.chkDiaValido = false;

                $scope.atualizarDiaDisabled = function () {
                    let diasDisabledTmp = [];
                    $scope.uraSelecionada.UraJornada.forEach(jornada => {
                        let diasUsados = _.uniq(
                            _.map(jornada.UraPeriodo, el => {
                                return el.Dia;
                            })
                        );
                        diasDisabledTmp = diasDisabledTmp.concat(diasUsados);
                    });

                    diasDisabledTmp = _.uniq(diasDisabledTmp);
                    $scope.diasDisabled = [];
                    diasDisabledTmp.forEach(element => {
                        if ($scope.jornadaAtual.Periodos[element] != true) {
                            $scope.diasDisabled[element] = true;
                        }
                    });
                    $scope.chkDiaValido = false;
                };

                $scope.onDiaChange = function () {
                    $scope.validarDiaJornada();
                };

                $scope.validarDiaJornada = function () {
                    $scope.chkDiaValido = false;
                    $scope.jornadaAtual.Periodos.forEach(function (el) {
                        if (el) $scope.chkDiaValido = true;
                    });
                };

                $scope.inserirJornada = function () {
                    let isValid = true;

                    $scope.jornadaAtual.Horarios.forEach(elementH => {
                        if (elementH.Inicio > elementH.Termino)
                            isValid = false

                        if (elementH.Inicio == null || elementH.Termino == null)
                            isValid = false;

                        if (elementH.Inicio == elementH.Termino)
                            isValid = false;
                    });

                    if (!isValid)
                        return NotifyService.showError(null, 'controller.preenchaHorarioCorretamente');

                    if (!$scope.uraSelecionada.UraJornada)
                        $scope.uraSelecionada.UraJornada = [];

                    let newJornada = {
                        UraId: $scope.uraSelecionada.UraId,
                        UraPeriodo: [],
                        Excecao: false,
                        Descricao: ""
                    };

                    let horaInicio = null;
                    let horaTermino = null;
                    $scope.jornadaAtual.Periodos.forEach((element, index) => {
                        if (element) {

                            newJornada.Descricao == "" ? newJornada.Descricao = $scope.diaSemana[index]
                                : newJornada.Descricao = newJornada.Descricao + "/" + $scope.diaSemana[index];

                            $scope.jornadaAtual.Horarios.forEach(elementH => {
                                let newPeriodo = {
                                    Dia: index,
                                    GrupoId: elementH.HorarioGrupo
                                };

                                if (typeof elementH.Inicio == "string")
                                    newPeriodo.Inicio = elementH.Inicio;
                                else
                                    newPeriodo.Inicio = moment(elementH.Inicio).format(timeFormat);

                                if (typeof elementH.Termino == "string")
                                    newPeriodo.Termino = elementH.Termino;
                                else
                                    newPeriodo.Termino = moment(elementH.Termino).format(timeFormat);

                                if (moment(newPeriodo.Inicio, "HH:mm").isBefore(moment(horaInicio, "HH:mm")) || !horaInicio)
                                    horaInicio = newPeriodo.Inicio;

                                if (moment(newPeriodo.Termino, "HH:mm").isAfter(moment(horaTermino, "HH:mm")) || !horaTermino)
                                    horaTermino = newPeriodo.Termino;

                                newJornada.UraPeriodo.push(newPeriodo);
                            });
                        }
                    });

                    newJornada.HorarioDescricao = horaInicio + " - " + horaTermino;

                    if (!$scope.editandoJornada) {
                        $scope.uraSelecionada.UraJornada.push(newJornada);
                    } else {
                        newJornada.UraJornadaId = $scope.uraSelecionada.UraJornada[$scope.jornadaEditadaId].UraJornadaId;
                        $scope.uraSelecionada.UraJornada[$scope.jornadaEditadaId] = newJornada;
                    }

                    $scope.cancelarEdicao();
                    $scope.forms.formDetalhes.$setDirty();
                    $scope.esconderPeriodoModal();
                };

                $scope.inserirFeriado = function () {
                    if ($scope.jornadaAtual.isFeriadoPeriodo) {
                        if (!$scope.jornadaAtual.FeriadoInicio || !$scope.jornadaAtual.FeriadoFinal) return NotifyService.showInvalid();
                        if (moment($scope.jornadaAtual.FeriadoInicio) > moment($scope.jornadaAtual.FeriadoFinal)) return NotifyService.showError(null, 'controller.dataINaoPodeSerMaiorQueDataF')
                    }
                    else {
                        if (!$scope.jornadaAtual.FeriadoInicio) return NotifyService.showInvalid();
                    }

                    let newJornada = {
                        UraId: $scope.uraSelecionada.UraId,
                        Excecao: true
                    };

                    newJornada.DataInicio = typeof $scope.jornadaAtual.FeriadoInicio == "string" ? $scope.jornadaAtual.FeriadoInicio :
                        moment($scope.jornadaAtual.FeriadoInicio).toDate();
                    if ($scope.jornadaAtual.isFeriadoPeriodo) {
                        newJornada.DataTermino = typeof $scope.jornadaAtual.FeriadoFinal == "string" ? $scope.jornadaAtual.FeriadoFinal :
                            moment($scope.jornadaAtual.FeriadoFinal).toDate();
                    } else {
                        newJornada.DataTermino = typeof $scope.jornadaAtual.FeriadoInicio == "string" ? $scope.jornadaAtual.FeriadoInicio :
                            moment($scope.jornadaAtual.FeriadoInicio).toDate();
                    }

                    newJornada.Descricao = $scope.jornadaAtual.isFeriadoPeriodo ?
                        moment($scope.jornadaAtual.FeriadoInicio).format(dateFormat) + " - " + moment($scope.jornadaAtual.FeriadoFinal).format(dateFormat) :
                        moment($scope.jornadaAtual.FeriadoInicio).format(dateFormat);

                    if (!$scope.editandoFeriado) {
                        $scope.uraSelecionada.UraJornada.push(newJornada);
                    } else {
                        newJornada.UraJornadaId = $scope.uraSelecionada.UraJornada[$scope.feriadoEditadoId].UraJornadaId;
                        $scope.uraSelecionada.UraJornada[$scope.feriadoEditadoId] = newJornada;
                    }

                    $scope.editandoFeriado = false;
                    $scope.forms.formDetalhes.$setDirty();
                    $scope.cancelarEdicao();
                    $scope.esconderFeriadoModal();
                };

                $scope.editarJornada = function (jornada, index) {
                    $scope.editandoJornada = true;
                    $scope.editandoFeriado = false;
                    $scope.jornadaEditadaId = index;
                    let periodosUsados = _.uniq(
                        _.map(jornada.UraPeriodo, el => {
                            return el.Dia;
                        })
                    );

                    let periodos = [];
                    periodosUsados.forEach(el => {
                        periodos[el] = true;
                    });

                    let horarios = _.map(
                        _.filter(jornada.UraPeriodo, el2 => {
                            return el2.Dia == periodosUsados[0];
                        }), el => {
                            return {
                                HorarioGrupo: el.GrupoId,
                                Inicio: el.Inicio,
                                Termino: el.Termino
                            };
                        }
                    );

                    $scope.jornadaAtual = {
                        Periodos: periodos,
                        Horarios: horarios
                    };

                    $scope.abrirJornadaPopup();
                    $scope.validarDiaJornada();
                };

                $scope.editarFeriado = function (jornada, index) {
                    $scope.editandoFeriado = true;
                    $scope.editandoJornada = false;
                    $scope.feriadoEditadoId = index;
                    $scope.jornadaAtual = {
                        Periodos: [],
                        Horarios: [{ Inicio: new Date(16, 1, 1, 9, 0, 0, 0), Termino: new Date(16, 1, 1, 18, 0, 0, 0) }],
                        Excecao: true,
                        FeriadoInicio: jornada.DataInicio,
                        FeriadoFinal: jornada.DataTermino
                    };
                    if (typeof jornada.DataTermino == "string") {
                        $scope.jornadaAtual.isFeriadoPeriodo = !(!jornada.DataTermino || jornada.DataTermino == "" || jornada.DataTermino == jornada.DataInicio);
                    } else {
                        $scope.jornadaAtual.isFeriadoPeriodo = !(!jornada.DataTermino || jornada.DataTermino == "" || jornada.DataTermino.getTime() ==
                            jornada.DataInicio.getTime());
                    }
                    $scope.abrirFeriadoPopup();
                };

                $scope.cancelarEdicao = function () {
                    $scope.editandoJornada = false;
                    $scope.editandoFeriado = false;
                    $scope.jornadaEditadaId = -1;
                    $scope.feriadoEditadoId = -1;
                    $scope.jornadaAtual = {
                        Periodos: [],
                        Horarios: [{ Inicio: new Date(16, 1, 1, 9, 0, 0, 0), Termino: new Date(16, 1, 1, 18, 0, 0, 0) }],
                        FeriadoInicio: null,
                        FeriadoFinal: null
                    };
                };

                $scope.deletarJornada = function (index) {
                    $scope.uraSelecionada.UraJornada.splice(index, 1);
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.voltar = function () {
                    $state.go("main.ura.list");
                };

                $scope.onChangeTemplateJornada = function () {
                    if ($scope.uraSelecionada.TemplateUraJornadaId > 0) {
                        $scope.jornadasAnteriores = $scope.uraSelecionada.UraJornada;
                        $scope.uraSelecionada.UraJornada = null;
                    }
                    else {
                        $scope.uraSelecionada.RedirecionaForaJornadaUraTipoId = 6;
                        $scope.uraSelecionada.RedirecionaNumeroForaJornada = null;
                        $scope.uraSelecionada.MenuGuidTransferirForaJornada = null;
                    }
                }

                $scope.onPossuiJornadaMenuChange = function () {
                    if ($scope.uraSelecionada.JornadaPersonalizada) {
                        if ($scope.jornadasAnteriores && $scope.jornadasAnteriores.length > 0) {
                            $scope.uraSelecionada.UraJornada = angular.copy($scope.jornadasAnteriores);
                            $scope.jornadasAnteriores = null;
                            return;
                        }
                        else if (!$scope.uraSelecionada.UraRaizId &&
                            $scope.uraSelecionada.UraConfigHistorico &&
                            $scope.uraSelecionada.UraConfigHistorico.length == 2) {

                            let objHist = JSON.parse($scope.uraSelecionada.UraConfigHistorico[0].JsonConfigHistorico);
                            if (objHist.UraJornada &&
                                objHist.UraJornada.length >= 1 &&
                                objHist.UraJornada[0].Excecao != undefined) {

                                objHist.UraJornada.forEach(jornada => {

                                    let Descricao = null;
                                    let horaInicio = null;
                                    let horaTermino = null;
                                    if (jornada.UraPeriodo) {

                                        jornada.UraPeriodo.forEach(elementP => {
                                            if (!Descricao) {
                                                Descricao = $scope.diaSemana[elementP.Dia];
                                            } else {
                                                Descricao = Descricao + "/" + $scope.diaSemana[elementP.Dia];
                                            }
                                        });

                                        jornada.UraPeriodo.forEach(elementP => {
                                            if (moment(elementP.Inicio, "HH:mm").isBefore(moment(horaInicio, "HH:mm")) || !horaInicio) {
                                                horaInicio = elementP.Inicio;
                                            }
                                            if (moment(elementP.Termino, "HH:mm").isAfter(moment(horaTermino, "HH:mm")) || !horaTermino) {
                                                horaTermino = elementP.Termino;
                                            }
                                        });
                                    }

                                    if (Descricao) jornada.Descricao = Descricao;
                                    else jornada.Descricao = $translate.instant('controller.diasUteisDescricao');

                                    if (horaInicio && horaTermino) jornada.HorarioDescricao = moment(horaInicio, "HH:mm").format(timeFormat) + " - " + moment(horaTermino, "HH:mm").format(timeFormat);
                                    else jornada.HorarioDescricao = $translate.instant('controller.horarioDescricao');

                                    jornada.UraId = null;
                                });

                                $scope.uraSelecionada.UraJornada = angular.copy(objHist.UraJornada);
                                return;
                            }
                        }
                        let horaInicio = moment('09:00', 'HH:mm').format(timeFormat);
                        let horaFinal = moment('18:00', 'HH:mm').format(timeFormat);
                        $scope.uraSelecionada.UraJornada = [
                            {
                                Descricao: $translate.instant('controller.diasUteisDescricao'),
                                Excecao: false,
                                HorarioDescricao: $translate.instant('controller.horarioDescricao'),
                                UraId: null,
                                // primero dia da semana = 0 -> domingo
                                UraPeriodo: [
                                    { Dia: 1, Inicio: horaInicio, Termino: horaFinal },
                                    { Dia: 2, Inicio: horaInicio, Termino: horaFinal },
                                    { Dia: 3, Inicio: horaInicio, Termino: horaFinal },
                                    { Dia: 4, Inicio: horaInicio, Termino: horaFinal },
                                    { Dia: 5, Inicio: horaInicio, Termino: horaFinal }
                                ]
                            }
                        ];
                        
                    } else {
                        if (!$scope.uraSelecionada.UraRaizId &&
                            $scope.uraSelecionada.UraConfigHistorico &&
                            $scope.uraSelecionada.UraConfigHistorico.length == 2) {

                            let objHist = JSON.parse($scope.uraSelecionada.UraConfigHistorico[0].JsonConfigHistorico);

                            if (objHist.TemplateUraJornadaId != undefined) {

                                $scope.jornadasAnteriores = angular.copy($scope.uraSelecionada.UraJornada);
                                $scope.uraSelecionada.UraJornada = null;
                                $scope.uraSelecionada.TemplateUraJornadaId = objHist.TemplateUraJornadaId;
                                return;
                            }
                            else {

                                objHist = JSON.parse($scope.uraSelecionada.UraConfigHistorico[1].JsonConfigHistorico);

                                if (objHist.TemplateUraJornadaId != undefined) {

                                    $scope.jornadasAnteriores = angular.copy($scope.uraSelecionada.UraJornada);
                                    $scope.uraSelecionada.UraJornada = null;
                                    $scope.uraSelecionada.TemplateUraJornadaId = objHist.TemplateUraJornadaId;
                                    return;
                                }
                            }
                        }
                        $scope.jornadasAnteriores = $scope.uraSelecionada.UraJornada;
                        $scope.uraSelecionada.UraJornada = null;
                        $scope.uraSelecionada.ConfigurarGrupoPorHorario = false;
                        $scope.uraSelecionada.TemplateUraJornadaId = null;
                        $scope.uraSelecionada.RedirecionaForaJornadaUraTipoId = 6;
                        $scope.uraSelecionada.RedirecionaNumeroForaJornada = null;
                        $scope.uraSelecionada.MenuGuidTransferirForaJornada = null;
                    }
                };

                $scope.onPossuiCallbackChange = function () {
                    if (!$scope.uraSelecionada.PossuiCallback) $scope.uraSelecionada.CallbackCampanhaId = null;
                };

                $scope.mudarDigitoNo = function (uraAtual) {
                    let intencao;
                    if ($scope.intencoes) {
                        intencao = $scope.intencoes.find(item => item.Id == uraAtual.UraIntencaoId);
                    }
                    uraAtual.DadosPlot.attr(".digito/text", $scope.getdescricaoDigito(uraAtual.Botao, intencao));
                };

                $scope.mudarDescricaoNo = function (uraAtual) {
                    let tipoUra = uraAtual.TipoUra;
                    let ramal;
                    if (tipoUra == "transferencia" && uraAtual.TipoTransferencia != null) {
                        tipoUra = uraAtual.TipoTransferencia;
                    }
                    if (tipoUra == "ramal") {
                        ramal = _.find($scope.ramais, el => {
                            return el.RamalId == uraAtual.RamalId;
                        });
                        if (ramal) {
                            uraAtual.DadosPlot.attr(".descricao/text", ramal.Numero.length > 17 ? ramal.Numero.substr(0, 14) + "..." : ramal.Numero);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                        }
                    } else if (tipoUra == "ramalPabx") {
                        ramal = _.find($scope.ramaisPabx, el => {
                            return el.RamalId == uraAtual.RamalId;
                        });
                        if (ramal) {
                            uraAtual.DadosPlot.attr(".descricao/text", ramal.Numero.length > 17 ? ramal.Numero.substr(0, 14) + "..." : ramal.Numero);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                        }
                    } else if (tipoUra == "grupo") {
                        if (uraAtual.ConfigurarGrupoPorHorario == true) {
                            uraAtual.DadosPlot.attr(".descricao/text", "Por jornada");
                        } else {
                            $scope.grupos = $scope.todosGrupos.filter(item => item.CarteiraId == $scope.ura.CarteiraId);
                            let grupo = _.find($scope.grupos, el => {
                                return el.GrupoId == uraAtual.GrupoId;
                            });
                            if (grupo) {
                                uraAtual.DadosPlot.attr(".descricao/text", grupo.Descricao.length > 17 ? grupo.Descricao.substr(0, 14) + "..." : grupo.Descricao);
                            } else {
                                uraAtual.DadosPlot.attr(".descricao/text", '---');
                            }
                        }
                    } else if (tipoUra == "ura") {
                        let ura = _.find($scope.uras, el => {
                            return el.UraId == uraAtual.RedirecionaUraId;
                        });
                        if (ura) {
                            uraAtual.DadosPlot.attr(".descricao/text", ura.Descricao && ura.Descricao.length > 17 ? ura.Descricao.substr(0, 14) + "..." : ura.Descricao);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                        }
                    } else if (tipoUra == "servico") {
                        let servico = _.find($scope.servicos, el => {
                            return el.ServicoId == uraAtual.ServicoId;
                        });
                        if (servico) {
                            uraAtual.DadosPlot.attr(".descricao/text", servico.Numero.length > 17 ? servico.Numero.substr(0, 14) + "..." : servico.Numero);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                        }
                    } else if (tipoUra == "desliga") {
                        if (uraAtual.Descricao) {
                            uraAtual.DadosPlot.attr(".descricao/text", uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + "..." : uraAtual.Descricao);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", $translate.instant('controller.desligarUra'));
                        }
                    } else if (tipoUra == "menu" || tipoUra == "avancado" || tipoUra == "satisfacao" || tipoUra == "consultaApi") {
                        if (uraAtual.Descricao)
                            uraAtual.DadosPlot.attr(".descricao/text", uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + "..." : uraAtual.Descricao);
                        else
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                    } else if (tipoUra == "transferencia") {
                        uraAtual.DadosPlot.attr(".descricao/text", '---');
                    } else if (tipoUra == "integracao") {
                        let integracao = _.find($scope.integracoes, el => {
                            return (el.IntegracaoConfiguracaoId == uraAtual.UraIntegracaoId);
                        });
                        if (integracao) {
                            uraAtual.DadosPlot.attr(".descricao/text", integracao.Nome.length > 17 ? integracao.Nome.substr(0, 14) + "..." : integracao.Nome);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                        }
                    } else if (tipoUra == "transfereMenu") {
                        let menu = _.find($scope.listMenus, el => {
                            return el.MenuGuid == uraAtual.MenuGuidTransferir;
                        });
                        if (menu)
                            uraAtual.DadosPlot.attr(".descricao/text", menu.Descricao.length > 17 ? menu.Descricao.substr(0, 14) + "..." : menu.Descricao);
                        else if (uraAtual.Descricao != undefined)
                            uraAtual.DadosPlot.attr(".descricao/text", uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + "..." : uraAtual.Descricao);
                        else
                            uraAtual.DadosPlot.attr(".descricao/text", '---');
                    } else if (tipoUra == "whatsapp") {
                        if (uraAtual.Descricao) {
                            uraAtual.DadosPlot.attr(".descricao/text", uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + "..." : uraAtual.Descricao);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", $translate.instant('telaUraEdit.noWhatsapp'));
                        }
                    } else if (tipoUra == "solicitaDigitos") {
                        if (uraAtual.Descricao) {
                            uraAtual.DadosPlot.attr(".descricao/text", uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + "..." : uraAtual.Descricao);
                        } else {
                            uraAtual.DadosPlot.attr(".descricao/text", $translate.instant('telaUraEdit.noSolicitarDigitos'));
                        }
                    }
                    $scope.initListMenus();
                };

                $scope.mudarCardNo = function (uraAtual) {
                    let elementoNo = $("g[model-id='" + uraAtual.DadosPlot.id + "']");
                    elementoNo.removeClass("ramal");
                    elementoNo.removeClass("ramalPabx");
                    elementoNo.removeClass("grupo");
                    elementoNo.removeClass("ura");
                    elementoNo.removeClass("servico");
                    elementoNo.removeClass("desliga");
                    elementoNo.removeClass("transferencia");
                    elementoNo.removeClass("integracao");
                    elementoNo.removeClass("transfereMenu");

                    let tipoSVG = "";
                    let svgAntigo = elementoNo.find(".icon svg");
                    let tipoUra = uraAtual.TipoUra;

                    if (tipoUra == "transferencia" && uraAtual.TipoTransferencia != null) {
                        tipoUra = uraAtual.TipoTransferencia;
                    }
                    elementoNo.addClass(tipoUra);

                    //SVG TIPO DE URA
                    if (tipoUra == "ramal") {
                        tipoSVG = $scope.iconeRamal;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('model.ramal'));
                    } else if (tipoUra == "ramalPabx") {
                        tipoSVG = $scope.iconeRamal;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('controller.ramalInteg'));
                    } else if (tipoUra == "grupo") {
                        tipoSVG = $scope.iconeGrupo;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('model.grupo'));
                    } else if (tipoUra == "servico") {
                        tipoSVG = $scope.iconeServico;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('model.servico'));
                    } else if (tipoUra == "ura") {
                        tipoSVG = $scope.iconeUra;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('model.ura'));
                    } else if (tipoUra == "desliga") {
                        tipoSVG = $scope.iconeDesliga;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('controller.desligar'));
                        uraAtual.DadosPlot.attr(".descricao/text", $translate.instant('controller.desligarUra'));
                    } else if (tipoUra == "transferencia") {
                        tipoSVG = $scope.iconeTransferencia;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('campo.transferencia'));
                    } else if (tipoUra == "integracao") {
                        tipoSVG = $scope.iconeIntegracao;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('campo.integracao'));
                    } else if (tipoUra == "transfereMenu") {
                        tipoSVG = $scope.iconeMenu;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('telaUraEdit.transfereMenu'));
                    } else if (tipoUra == "consultaApi") {
                        tipoSVG = $scope.iconeConsultaApi;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('telaUraEdit.noConsultarApi'));
                    } else if (tipoUra == "whatsapp") {
                        tipoSVG = $scope.iconeWhatsapp;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('telaUraEdit.noWhatsapp'));
                    } else if (tipoUra == "solicitaDigitos") {
                        tipoSVG = $scope.iconeSolicitaDigitos;
                        uraAtual.DadosPlot.attr(".tipo/text", $translate.instant('telaUraEdit.noSolicitarDigitos'));
                    }

                    svgAntigo.replaceWith(tipoSVG);
                };

                $scope.onMenuAlterado = function () {
                    $scope.mudarDescricaoNo($scope.uraSelecionada);
                    // Add link em caso de transferencia para menu
                    $scope.plotLinkTransfMenu($scope.uraSelecionada, $scope.noSelecionado);
                };

                $scope.plotLinkTransfMenu = function (ura, noSelecionado) {
                    if (ura.TipoTransferencia == "transfereMenu" &&
                        ura.MenuGuidTransferir) {
                        let uraMenuguid = $scope.buscarUraByMenuGuid($scope.ura, ura.MenuGuidTransferir);
                        if (uraMenuguid != null) {
                            if (!noSelecionado) {
                                noSelecionado = $scope.buscarIdemUra($scope.ura, ura.UraId).DadosPlot;
                            }
                            $scope.removeLink(noSelecionado);
                            $scope.plotLink(noSelecionado, uraMenuguid.DadosPlot);
                        }
                    }
                }

                $scope.onTipoUraAlterado = function () {
                    let uraTipoId = _.find($scope.tiposUra, el => {
                        return el.Descricao == $scope.uraSelecionada.TipoUra;
                    }).TipoId;
                    if (uraTipoId == 24 && $scope.uraSelecionada.TipoTransferencia != null) {
                        uraTipoId = _.find($scope.tiposTransferencia, el => {
                            return (el.Descricao == $scope.uraSelecionada.TipoTransferencia);
                        }).TipoId;
                    }
                    $scope.uraSelecionada.UraTipoId = uraTipoId;
                    $scope.uraSelecionada.GrupoId = null;
                    $scope.uraSelecionada.RamalId = null;
                    $scope.uraSelecionada.ServicoId = null;
                    $scope.uraSelecionada.RedirecionaUraId = null;
                    $scope.uraSelecionada.CampanhaId = null;
                    if ($scope.uraSelecionada.TipoUra != "menu") $scope.uraSelecionada.ChildUra = [];
                    $scope.verificarTipoRaiz();
                    $scope.mudarCardNo($scope.uraSelecionada);
                    $scope.mudarDescricaoNo($scope.uraSelecionada);
                };

                $scope.selecionarTipo = function (tipoUra) {
                    $scope.condicaoEditada.TipoUra = tipoUra;
                };

                $scope.checarAvancado = function (ura) {
                    let result = false;
                    if (ura.TipoUra == "integracao") {
                        result = true;
                    }
                    if (ura.ChildUra && ura.ChildUra.length > 0) {
                        ura.ChildUra.forEach(el => {
                            if ($scope.checarAvancado(el) == true) result = true;
                        });
                    }
                    return result;
                };

                $scope.showJornada = function () {
                    return $scope.uraSelecionada != null &&
                        ($scope.uraSelecionada.TipoUra == 'menu' ||
                            $scope.uraSelecionada.TipoUra == 'transferencia' ||
                            $scope.uraSelecionada.TipoUra == 'solicitaDigitos');
                }

                $scope.showServicos = function () {
                    return $scope.uraSelecionada != null && ($scope.uraSelecionada.ParentUra == null);
                }

                $scope.showCallBack = function () {
                    return $scope.uraSelecionada.ParentUra == null ||
                        $scope.uraSelecionada.TipoUra == 'integracao' ||
                        $scope.uraSelecionada.TipoUra == 'menu' ||
                        $scope.uraSelecionada.TipoUra == 'transferencia';
                };

                $scope.showExcecao = function () {
                    return $scope.uraSelecionada.ParentUra == null ||
                        $scope.uraSelecionada.TipoUra == 'integracao' ||
                        $scope.uraSelecionada.TipoUra == 'menu';
                }

                $scope.tipoUra = function () {
                    let titulo = $translate.instant('campo.uraAVI');
                    if ($scope.ura.UraTipoIntegracaoId == 1) {
                        titulo = $translate.instant('campo.uraDTMF');
                    }
                    return titulo;
                }

                $scope.getdescricaoDigito = function (digito, intencao) {
                    let descricaoDigito;
                    switch (digito) {
                        case 'I':
                            descricaoDigito = (intencao != undefined ? intencao.Nome : '---');;
                            break;
                        default:
                            if (digito) {
                                descricaoDigito = $translate.instant('campo.digito') + " " + digito;
                            }
                            break;
                    }
                    return descricaoDigito;
                }

                //#region Metodos de Audio

                $scope.setVozTts = function (vozId, vozProvedorId) {
                    $scope.ura.VozId = vozId;
                    $scope.ura.VozProvedorId = vozProvedorId;
                    $scope.vozIdDefault = vozId;
                }

                $scope.alterarArquivo = function (nome) {
                    let upperCase = nome.charAt(0).toUpperCase() + nome.slice(1);
                    $scope.ultimoArquivoId = {};
                    $scope.ultimoArquivoId[nome] = $scope.ura[upperCase + "ArquivoId"];
                    $scope.ura[upperCase + "ArquivoId"] = null;
                };

                $scope.cancelarAlterarArquivo = function (nome) {
                    let upperCase = nome.charAt(0).toUpperCase() + nome.slice(1);
                    $scope.ura[upperCase + "ArquivoId"] = $scope.ultimoArquivoId[nome];
                    $scope.ultimoArquivoId[nome] = null;
                };

                $scope.ouvirAudio = function (id, nome) {
                    $scope.arquivoAudio = {
                        url: "/Ura/Audio/" + id,
                        titulo: $translate.instant('diretivas.reproduzindo') + nome
                    };
                };

                $scope.fecharAudio = function () {
                    $scope.arquivoAudio = null;
                };

                $scope.loadUraError = function (error) {
                    $scope.preview = null;
                    ModalService.hideUploading();
                    NotifyService.showError(error, 'notificacoes.erroAoFazerUpload');
                };

                $scope.loadAvisoManutencaoCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["avisomanutencao"] = null;
                    $scope.uraSelecionada.AvisoManutencaoArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.AvisoManutencaoUraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    $scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeAvisoManutencaoArquivo = function () {
                    $scope.ultimoArquivoId["avisomanutencao"] = null;
                    $scope.uraSelecionada.AvisoManutencaoArquivoId = null;
                    $scope.uraSelecionada.AvisoManutencaoUraArquivo = null;
                    $("#form-file-aviso-manutencao").val("");
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadIntroCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["intro"] = null;
                    $scope.uraSelecionada.IntroArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.IntroUraArquivo = result;
                    $scope.uraSelecionada.InterrompeAudioIntroDigito = true;
                    $scope.nomeDoArquivoIntro = result.Nome;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    //$scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeIntroUra = function () {
                    $scope.ultimoArquivoId["intro"] = null;
                    $scope.uraSelecionada.IntroArquivoId = null;
                    $scope.uraSelecionada.IntroUraArquivo = null;
                    $scope.nomeDoArquivoIntro = $translate.instant('form.nenhumArquivo');
                    $("#form-file-intro").val("");
                    //$scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadMenuCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["menu"] = null;
                    $scope.uraSelecionada.MenuArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.MenuUraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    $scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeMenuUra = function () {
                    $scope.ultimoArquivoId["menu"] = null;
                    $scope.uraSelecionada.MenuArquivoId = null;
                    $scope.uraSelecionada.MenuUraArquivo = null;
                    $("#form-file-menu").val("");
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadMaxErroCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["maxErro"] = null;
                    $scope.uraSelecionada.MaxErroArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.MaxErroUraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    $scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeMaxErroUra = function () {
                    $scope.ultimoArquivoId["maxErro"] = null;
                    $scope.uraSelecionada.MaxErroArquivoId = null;
                    $scope.uraSelecionada.MaxErroUraArquivo = null;
                    $("#form-file-maxerro").val("");
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadDigitoInvalidoCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["digitoInvalido"] = null;
                    $scope.uraSelecionada.DigitoInvalidoArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.DigitoInvalidoUraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    $scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeDigitoInvalidoUra = function () {
                    $scope.ultimoArquivoId["digitoInvalido"] = null;
                    $scope.uraSelecionada.DigitoInvalidoArquivoId = null;
                    $scope.uraSelecionada.DigitoInvalidoUraArquivo = null;
                    $("#form-file-digitoinvalido").val("");
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadForaJornadaCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["foraJornada"] = null;
                    $scope.uraSelecionada.ForaJornadaArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.ForaJornadaUraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    $scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeForaJornadaUra = function () {
                    $scope.ultimoArquivoId["foraJornada"] = null;
                    $scope.uraSelecionada.ForaJornadaArquivoId = null;
                    $scope.uraSelecionada.ForaJornadaUraArquivo = null;
                    $("#form-file-forajornada").val("");
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadFeriadoCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["feriado"] = null;
                    $scope.uraSelecionada.FeriadoArquivoId = result.UraArquivoId;
                    $scope.uraSelecionada.FeriadoUraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    $scope.forms.formDetalhes.$setDirty();
                    ModalService.hideUploading();
                };

                $scope.removeFeriadoUra = function () {
                    $scope.ultimoArquivoId["feriado"] = null;
                    $scope.uraSelecionada.FeriadoArquivoId = null;
                    $scope.uraSelecionada.FeriadoUraArquivo = null;
                    $("#form-file-feriado").val("");
                    $scope.forms.formDetalhes.$setDirty();
                };

                $scope.loadRedirecionaCondicaoCompleted = function (result) {
                    $scope.preview = result;
                    $scope.ultimoArquivoId["condicao"] = null;
                    $scope.condicaoEditada.UraArquivoId = result.UraArquivoId;
                    $scope.condicaoEditada.UraArquivo = result;
                    $scope.setVozTts(result.VozId, result.VozProvedorId);
                    ModalService.hideUploading();
                };

                $scope.removeRedirecionaCondicao = function () {
                    $scope.ultimoArquivoId["condicao"] = null;
                    $scope.condicaoEditada.UraArquivoId = null;
                    $scope.condicaoEditada.UraArquivo = null;

                    $("#form-file-condicao").val("");
                };

                //#endregion Metodos de Audio

                $scope.adicionarNovaIntegracao = function () {
                    $('#modal_integracao').on({
                        'hide.uk.modal': () => {
                            IntegracaoConfiguracaoResource.query().$promise
                                .then(res => {
                                    $scope.integracoes = res;
                                });
                        }
                    });

                    ModalService.openModal('modal_integracao');
                };

                $scope.onIntegracaoAlterado = function (limpar) {
                    if ($scope.uraSelecionada.UraIntegracaoId > 0) {
                        $scope.integracaoSelecionada = _.find(
                            $scope.integracoes, el => {
                                return (el.IntegracaoConfiguracaoId == $scope.uraSelecionada.UraIntegracaoId);
                            }
                        );
                        if (limpar) {
                            $scope.uraSelecionada.UraCondicao = [];
                        }
                    } else {
                        $scope.integracaoSelecionada = null;
                    }
                    $scope.mudarDescricaoNo($scope.uraSelecionada);
                    $scope.noPodeAdicionar = $scope.uraSelecionada.TipoUra == "menu" || $scope.uraSelecionada.TipoUra == "satisfacao" ||
                        $scope.uraSelecionada.TipoUra == "avancado" || ($scope.uraSelecionada.TipoUra == "integracao" && $scope.uraSelecionada.UraIntegracaoId > 0);
                };

                $('#modal_condicao').on({
                    'hide.uk.modal': () => {
                        $scope.condicaoEditada = {};
                        $scope.editandoCondicao = false;
                        $scope.indexCondicaoEditada = null;
                        $scope.forms.formNovaCondicao.$setPristine();
                        $scope.forms.formNovaCondicao.$setUntouched();
                    },
                    'show.uk.modal': () => {
                        $scope.forms.formNovaCondicao.$setPristine();
                        $scope.forms.formNovaCondicao.$setUntouched();
                    }
                });

                $scope.abrirCondicaoPopup = function () {
                    ModalService.isHidden('modal_condicao', () => {
                        $scope.condicaoEditada = {};
                        $scope.editandoCondicao = false;
                    }, { bgclose: false })
                };

                $scope.editarCondicao = function (condicao) {
                    ModalService.isHidden('modal_condicao', () => {
                        $scope.indexCondicaoEditada = $scope.uraSelecionada.UraCondicao.indexOf(condicao);
                        $scope.condicaoEditada = angular.copy(condicao);
                        if ($scope.condicaoEditada.RedirecionaUra && $scope.condicaoEditada.RedirecionaUra.UraTipoId) {
                            let uraTipoId = $scope.condicaoEditada.RedirecionaUra.UraTipoId;
                            if (uraTipoId == 1 || uraTipoId == 2 || uraTipoId == 3 || uraTipoId == 4) {
                                uraTipoId = 24;
                            }
                            $scope.condicaoEditada.TipoUra = _.find($scope.tiposUraRedireciona, el => { return el.TipoId == uraTipoId; }).Descricao;
                        }
                        $scope.editandoCondicao = true;
                    }, { bgclose: false })
                };

                $scope.esconderCondicaoModal = function () {
                    ModalService.closeModal('modal_condicao');
                };

                $scope.removerCondicao = function (condicao) {
                    $scope.deletarMenu(condicao.RedirecionaUra);
                };

                $scope.inserirCondicao = function () {
                    $scope.condicaoEditada.RespostaNome = _.find($scope.integracaoSelecionada.IntegracaoResposta, el => {
                        return ($scope.condicaoEditada.IntegracaoRespostaId == el.IntegracaoRespostaId);
                    }).Nome;
                    $scope.condicaoEditada.OperadorNome = _.find($scope.operadores, el => {
                        return ($scope.condicaoEditada.OperadorId == el.OperadorLogicoId);
                    }).Alias;
                    $scope.condicaoEditada.UraDescricao = _.find($scope.tiposUraRedireciona, el => {
                        return $scope.condicaoEditada.TipoUra == el.Descricao;
                    }).Alias;
                    let condicao = angular.copy($scope.condicaoEditada);
                    if ($scope.editandoCondicao == false) {
                        $scope.uraSelecionada.UraCondicao.push($scope.condicaoEditada);
                        if ($scope.condicaoEditada.TipoUra != "repetir") {
                            $scope.clicarNovoNo($scope.condicaoEditada.TipoTransferencia != null ? $scope.condicaoEditada.TipoTransferencia :
                                $scope.condicaoEditada.TipoUra, true);
                        }
                    } else {
                        $scope.uraSelecionada.UraCondicao[$scope.indexCondicaoEditada] = condicao;
                        $scope.mudarDescricaoNo(condicao.RedirecionaUra);
                    }
                    $scope.esconderCondicaoModal();
                    $scope.condicaoEditada = {};
                };

                $scope.hasOnlyMenusDigitos = function () {
                    var simples = !$scope.hasIntencao($scope.ura);
                    return simples;
                }

                $scope.hasIntencao = function (ura) {
                    if (!ura || !ura.ChildUra) {
                        return false;
                    }
                    let result = false;
                    ura.ChildUra.forEach((item) => {
                        if (!result) {
                            result = $scope.uraHasIntencao(item);
                        }
                        if (!result && item.ChildUra.length > 0) {
                            result = $scope.hasIntencao(item.ChildUra);
                        }
                    });
                    return result;
                }

                $scope.uraHasIntencao = function (ura) {
                    let result = false;
                    result = ura && ura.UraIntencaoId;
                    return result;
                }

                $scope.adicionarServico = function () {
                    var servicosSelecionados = _.where($scope.servicosDisponiveis, { Selecionado: true });
                    angular.forEach(servicosSelecionados, (servico) => {
                        $scope.servicosDisponiveis.splice($scope.servicosDisponiveis.indexOf(servico), 1);
                        servico.Selecionado = false;

                        if (!servico.ServicoTipoId) {
                            servico.ServicoTipoId = 1;
                        }

                        if ($scope.uraSelecionada.UraId > 0) {
                            servico.UraId = $scope.uraSelecionada.UraId;
                        }
                        servico.DescricaoUra = $scope.uraSelecionada.Descricao;

                        $scope.uraSelecionada.UraServicoAssociado.push(servico);

                        // Remove do list para ser alterado o seu ramal no cti
                        if (servico.UraServicoAssociadoId > 0) {
                            $scope.servicosDisponiveis.splice($scope.ura.uraServicoDesssociado.indexOf(servico), 1);
                        }
                    });

                    if ($scope.servicosDisponiveis.length == 0) {
                        $scope.variaveisGlobais.chkServicosNaoAdicionados = false;
                    }
                }

                $scope.disableAdicionarServico = function () {
                    var servicosSelecionados = _.where($scope.servicosDisponiveis, { Selecionado: true });
                    return servicosSelecionados.length == 0;
                }

                $scope.removerServico = function () {
                    var servicosSelecionados = _.where($scope.uraSelecionada.UraServicoAssociado, { Selecionado: true });
                    angular.forEach(servicosSelecionados, (servico) => {
                        $scope.uraSelecionada.UraServicoAssociado.splice($scope.uraSelecionada.UraServicoAssociado.indexOf(servico), 1);
                        servico.Selecionado = false;
                        $scope.servicosDisponiveis.push(servico);

                        // Adicona no list para ser alterado o seu ramal no cti
                        if (servico.UraServicoAssociadoId > 0) {
                            $scope.ura.uraServicoDesssociado.push(servico);
                        }
                    });

                    servicosSelecionados = _.where($scope.uraSelecionada.UraServicoAssociado, { ServicoTipoId: 1 });
                    if (servicosSelecionados.length == 0) {
                        $scope.variaveisGlobais.chkServicosAdicionados = false;
                    }
                }

                $scope.disableRemoverServico = function () {
                    var servicosSelecionados = _.where($scope.uraSelecionada.UraServicoAssociado, { Selecionado: true });
                    return servicosSelecionados.length == 0;
                }

                $scope.setServicosNaoAdicionados = function () {
                    angular.forEach($scope.servicosDisponiveis, (item) => {
                        item.Selecionado = $scope.variaveisGlobais.chkServicosNaoAdicionados;
                    });
                };

                $scope.setServicosAdicionados = function () {
                    angular.forEach($scope.uraSelecionada.UraServicoAssociado, (item) => {
                        item.Selecionado = $scope.variaveisGlobais.chkServicosAdicionados;
                    });
                };

                //#region Solicita Digitos

                $scope.isSolicitaDigitos = function () {
                    return $scope.uraSelecionada.TipoUra == 'solicitaDigitos';
                }

                $scope.solicitaDigitosDisponivel = function () {

                    let disponivel = $scope.uraSelecionada.ChildUra.every(el => {
                        if (el.TipoUra == 'solicitaDigitos')
                            return false;
                        else
                            return true;
                    });

                    return disponivel;
                }

                $scope.adicionarDadosCrm = function (ura) {

                    if (ura.UraTipoId == 27 && !ura.UraEnviarDadosCrm) {

                        ura.UraEnviarDadosCrm = [];
                        ura.UraEnviarDadosCrm.push(
                            {
                                Chave: null,
                                Valor: null,
                                VariavelUraAtendimentoId: null,
                                showVariaveis: false
                            }
                        );
                    }
                }

                $scope.removerDadosCrm = function (index, ura) {

                    if (ura.UraEnviarDadosCrm.length > 0) {
                        ura.UraEnviarDadosCrm.splice(index, 1);
                    }
                }

                $scope.disableDadosCrm = function (index, ura) {

                    let disabled = true;

                    let enviarDadosCrm = ura.UraEnviarDadosCrm[index];
                    if (!enviarDadosCrm) {
                        return disabled;
                    }
                    disabled = !(UraHelper.isPropValid(enviarDadosCrm.Chave) &&
                        (enviarDadosCrm.Valor || enviarDadosCrm.VariavelUraAtendimentoId));
                    return disabled;
                };

                $scope.criaOpcaoSolicitaDigitos = function () {
                    let uraPai = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                    let posicaoXFilhoUra = $scope.receberPosicaoADireita(uraPai);
                    let novaPosicaoX = uraPai.ChildUra.length == 0 ? posicaoXFilhoUra : posicaoXFilhoUra + tamanhoNoX + 30;
                    let novaPosicaoY = $scope.noSelecionado.attributes.position.y + tamanhoNoY + 40;
                    let nomeNo = $translate.instant('telaUraEdit.noSolicitarDigitos');
                    let descricaoNo = '---';
                    let digito = '?';
                    let tipoUra = "solicitaDigitos";
                    let podeAdicionar = false;

                    let novoNo = $scope.adicionarNovoNo(
                        novaPosicaoX,
                        novaPosicaoY,
                        nomeNo,
                        descricaoNo,
                        digito,
                        tipoUra,
                        podeAdicionar
                    );

                    $("#ura-builder g").removeClass("no-selecionado");

                    $scope.noSelecionado = novoNo;

                    $("g[model-id='" + $scope.noSelecionado.id + "']").addClass("no-selecionado");

                    let ura = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                    $scope.uraSelecionada = ura;

                    // Valores default
                    $scope.uraSelecionada.RedirecionaTipoId = 6;
                    $scope.uraSelecionada.UraTipoId = 27;
                    $scope.uraSelecionada.SolicitaDigitosGrupoId = 0;

                    $scope.noPodeAdicionar = false;

                    $scope.adicionarDadosCrm($scope.uraSelecionada);
                }

                $scope.disableValidacaoUra = function () {

                    let permitido = $translate.instant('ValidacoesDigitosUra.PERMITIDO');
                    return permitido != '1';
                }

                //#endregion Solicita Digitos

                //*************************
                //	INICIALIZAÇÃO DE DIAGRAMA
                //*************************

                let tamanhoNoX = 110;
                let tamanhoNoY = 90;
                $scope.arvoreUra = [];
                $scope.noSelecionado = {};
                $scope.uraSelecionada = {};
                $scope.noPodeAdicionar = true;
                $scope.sidebarAtiva = true;
                $scope.infoUraModal = {};
                $scope.zoomAtual = 0;

                let graph = new joint.dia.Graph();
                let paper = new joint.dia.Paper({
                    el: $("#ura-builder"),
                    model: graph,
                    gridSize: 1,
                    width: 3000,
                    height: 3000,
                    perpendicularLinks: true,
                    restrictTranslate: true
                });

                paper.on("element:pointerup", (elementView, evt) => {
                    $("#ura-builder g").removeClass("no-selecionado");
                    if (V(evt.target).hasClass("add")) {

                        elementView.$el.addClass("no-selecionado");
                        $scope.noSelecionado = elementView.model;
                        let novoSelecionado = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                        if (novoSelecionado != $scope.uraSelecionada) {
                            $scope.uraSelecionada = novoSelecionado;
                            if ($scope.forms.formDetalhes.$submitted) {
                                $scope.forms.formDetalhes.$setSubmitted();
                            }
                        }
                        $scope.onIntegracaoAlterado();
                        $scope.noPodeAdicionar = true;
                        $scope.$apply();
                        $("#add-new-ura .md-fab-primary:not(.md-fab-small)").click();
                        $timeout(() => { }, 3000);
                    } else if (V(evt.target).hasClass("del")) {
                        $window.UIkit.modal.confirm($translate.instant('controller.desejaExcluirEsseMenu'), () => {
                            let uraRemovida = $scope.buscarNoEmUra($scope.ura, elementView.model);
                            $scope.deletarMenu(uraRemovida);

                            if ($scope.uraSelecionada.TipoUra == "menu") {
                                $scope.BuilderIntencoes();
                            }

                            $scope.variaveisGlobais.uraIntencaoId = undefined;
                            $scope.noPodeAdicionar = $scope.uraSelecionada.TipoUra == "menu" ||
                                $scope.uraSelecionada.TipoUra == "satisfacao" ||
                                $scope.uraSelecionada.TipoUra == "avancado" ||
                                ($scope.uraSelecionada.TipoUra == "integracao" && $scope.uraSelecionada.UraIntegracaoId > 0);
                            $scope.onIntegracaoAlterado();
                            UIkit.switcher('#tabsUraAtendimento').show(0);
                            $scope.$apply();
                        });
                    } else {
                        elementView.$el.addClass("no-selecionado");
                        $scope.noSelecionado = elementView.model;
                        let ura = $scope.buscarNoEmUra($scope.ura, $scope.noSelecionado);
                        if (ura != $scope.uraSelecionada) {

                            $scope.digitosLivres = $scope.receberDigitosLivres(ura);
                            $scope.digitosLivresColecao = $scope.receberDigitosLivresColecao($scope.digitosLivres);
                            $scope.uraSelecionada = ura;

                            if ($scope.uraSelecionada.TipoUra == "menu") {
                                $scope.BuilderIntencoes();
                            }

                            $scope.setNomeIntencao();
                            $scope.onIntegracaoAlterado();
                            $scope.noPodeAdicionar =
                                $scope.uraSelecionada.TipoUra == "menu" ||
                                $scope.uraSelecionada.TipoUra == "satisfacao" ||
                                $scope.uraSelecionada.TipoUra == "avancado" ||
                                ($scope.uraSelecionada.TipoUra == "integracao" && $scope.uraSelecionada.UraIntegracaoId > 0);

                            if ($scope.uraSelecionada.TipoUra == "consultaApi" ||
                                $scope.uraSelecionada.TipoUra == "whatsapp") {
                                $scope.getProvedoresResource();
                            }

                            UIkit.switcher('#tabsUraAtendimento').show(0);
                            if ($scope.forms.formDetalhes.$submitted) {
                                $scope.forms.formDetalhes.$setSubmitted();
                            }

                            $scope.$apply();
                        }
                    }
                });

                $scope.deletarMenu = function (uraRemovida) {
                    $scope.noSelecionado = uraRemovida.ParentUra.DadosPlot;
                    $scope.uraSelecionada = uraRemovida.ParentUra;
                    $("g[model-id='" + $scope.noSelecionado.id + "']").addClass("no-selecionado");
                    $scope.removerUraArvore(uraRemovida, true);
                    $scope.forms.formDetalhes.$setDirty();
                    $scope.verificarTipoRaiz();
                };

                $scope.verificarTipoRaiz = function () {
                    if ($scope.isStatisfacao) {
                        $scope.ura.TipoUra = "satisfacao";
                        $scope.ura.UraTipoId = 10;
                    } else if ($scope.checarAvancado($scope.ura)) {
                        $scope.ura.TipoUra = "avancado";
                        $scope.ura.UraTipoId = 7;
                    } else {
                        $scope.ura.TipoUra = "menu";
                        $scope.ura.UraTipoId = 5;
                    }
                };
                $scope.paperContainer = null;
                $scope.ativarZoom = function () {
                    if ($scope.paperContainer == null) {
                        $scope.paperContainer = $("#ura-builder")[0];
                        let panAndZoom = svgPanZoom(
                            $scope.paperContainer.childNodes[0],
                            {
                                viewportSelector: $scope.paperContainer.childNodes[0].childNodes[0],
                                fit: false,
                                zoomScaleSensitivity: 0.4,
                                panEnabled: false,
                                center: false,
                                mouseWheelZoomEnabled: false
                            }
                        );

                        paper.on("blank:pointerdown", () => panAndZoom.enablePan());

                        paper.on("cell:pointerup blank:pointerup", () => panAndZoom.disablePan());

                        $scope.zoomIn = function () {
                            panAndZoom.zoomAtPointBy(1.25, {
                                x: $scope.uraSelecionada.DadosPlot.attributes.position.x,
                                y: $scope.uraSelecionada.DadosPlot.attributes.position.y
                            });
                        };

                        $scope.zoomOut = function () {
                            panAndZoom.zoomAtPointBy(0.75, {
                                x: $scope.uraSelecionada.DadosPlot.attributes.position.x,
                                y: $scope.uraSelecionada.DadosPlot.attributes.position.y
                            });
                        };
                    }
                };

                // INICIA A VARIAVEL $scope.uraSelecionada
                if ($scope.isNew) {
                    //Plot No Principal
                    let noPrincipal = $scope.plotNo(
                        10,
                        10,
                        tamanhoNoX,
                        tamanhoNoY,
                        $translate.instant('controller.inicioUra'),
                        "",
                        "",
                        "menu",
                        false,
                        true);
                    $("g[model-id='" + noPrincipal.id + "']").addClass(
                        "menu no-selecionado"
                    );

                    $scope.noSelecionado = noPrincipal;
                    $scope.arvoreUra.push(noPrincipal);
                    //Comum
                    $scope.ura = {
                        DadosPlot: noPrincipal,
                        Descricao: null,
                        ChildUra: [],
                        ParentUra: null,
                        TipoUra: "menu",
                        UraTipoId: 5,
                        RedirecionaTipoId: 6,
                        UraTipoIntegracaoId: uraTipoIntegracaoId,
                        RedirecionaForaJornadaUraTipoId: 6,
                        JornadaPersonalizada: false,
                        MenuGuid: UraHelper.uuidv4(),
                        UraEnviarDadosCrm: []
                    };
                    $scope.uraSelecionada = $scope.ura;
                } else {
                    if ($scope.ura.UraSatisfacaoId > 0) {
                        let satisfacao = _.find($scope.urasSatisfacao, el => {
                            return el.UraId == $scope.ura.UraSatisfacaoId;
                        });
                        if (satisfacao == null) $scope.ura.UraSatisfacaoId = null;
                    }
                    $scope.uraSelecionada = $scope.ura;
                }
                $scope.BuildDiagramaUra = function () {
                    if (!$scope.isNew) {
                        $scope.recriarReferenciaPai($scope.ura);
                        $scope.transformarJsonEmDadosPlot($scope.ura);
                        $scope.plotArvoreExistente($scope.uraSelecionada);
                        $scope.noSelecionado = $scope.ura.DadosPlot;
                        $scope.digitosLivres = $scope.receberDigitosLivres($scope.uraSelecionada);
                        $scope.digitosLivresColecao = $scope.receberDigitosLivresColecao($scope.digitosLivres);
                        $scope.ativarZoom();
                    }
                }

                //*************************
                //	EDITANDO UMA URA
                //  ATUALIZA A LISTA DAS INTENCOES
                //  INICIO
                //*************************

                // Builder a lista por nó, eliminando as intenções já utilizadas
                $scope.BuilderIntencoes = function () {

                    if ($scope.intencoesBkp) {
                        $scope.intencoes = [];
                        $scope.intencoesBkp.forEach(intencao => {
                            let emUso = $scope.uraSelecionada.ChildUra.find(ura => ura.UraIntencaoId == intencao.Id);
                            if (!emUso) {
                                intencao.NomeAlias = intencao.Nome + (intencao.Alias ? ' - ' + intencao.Alias : '');
                                $scope.intencoes.push(intencao);
                            }
                        });
                    }
                }

                $scope.updateIntencoes = function (intencoes) {

                    if (!intencoes) {
                        return;
                    }

                    // Lista as intencoes
                    $scope.intencoes = [];
                    $scope.intencoesBkp = angular.copy(intencoes);

                    // Builder a lista por nó, eliminando as intenções já utilizadas
                    $scope.BuilderIntencoes();
                }

                //*************************
                //	EDITANDO UMA URA
                //  ATUALIZA A LISTA DAS INTENCOES
                //  FIM
                //*************************

                //*************************
                //	FIM DE INICIALIZAÇÃO DE DIAGRAMA
                //*************************

                //#region UraConsultaApi

                //*************************
                //  ConsultaApi
                //  INICIO
                //*************************

                //#region variaveis

                // Armazena a configuração 
                // do campo quando o modal
                // está sendo utilizado
                $scope.consultaApiEdit = {};
                // Utilizado para comparar se houve
                // Alterações na resposta em caso
                // de edição
                $scope.consultaApiEditBkp = {};

                // Gerais
                $scope.desconhecido = -1;
                $scope.campoEnvio = $scope.desconhecido;
                $scope.campoRetorno = $scope.desconhecido;

                // Qde máxima de dígitos inicia-se em com 2 digitos
                $scope.listQdeMaximaDigitos = [];
                for (var i = 2; i <= 32; i++) {
                    $scope.listQdeMaximaDigitos.push({ QuantidadeId: i, Quantidade: i });
                }

                $scope.consultaApiconstantes = {
                    adicionar: 1,
                    atualizar: 2,
                    visaoList: 3,
                    visaoEdit: 4,
                    tipoUraProvedorCampo: 5,
                    tipoVariavelUraAtendimento: 6
                };

                // Utils
                $scope.consultaApiUtils = {
                    editandoCampo: false,
                    editAcao: $scope.desconhecido,
                    indexCondicao: $scope.desconhecido,
                    direcaoCampoProvedorId: $scope.desconhecido,
                    transfereDestinoId: $scope.desconhecido,
                    transfereChamadaUraArquivo: null
                };

                // Acoes
                $scope.acaoUra = {
                    repeteMenu: $scope.desconhecido,
                    finalizaChamada: $scope.desconhecido,
                    consultaApi: $scope.desconhecido,
                    transfereChamada: $scope.desconhecido
                }

                // Tipo de Transferencia 
                $scope.transferenciaGrupo = 1;
                $scope.transferenciaRamal = 2;
                $scope.transferenciaUra = 3;
                $scope.transferenciaServico = 4;
                $scope.transferenciaRamalPabx = 12;
                $scope.transferenciaMenu = 13;

                // Tipos de dados do campo
                $scope.TpCampoDadoData = 1;
                $scope.TpCampoDadoDecimal = 2;
                $scope.TpCampoDadoNumerico = 3;
                $scope.TpCampoDadoBooleano = 4;
                $scope.TpCampoDadoTexto = 5;

                //#region listas

                // Lista das variaveis e campos de 
                // retorno do provedfor
                // a ser utilizado na configuração
                // dos dados do CRM
                $scope.listValoresCrm = [];

                // Campos configurados na consulta
                // * SEPARADO EM LISTA DEVIDO A 
                // PROBLEMAS COM A RENBDERIZAÇÃO DO
                // ANGULAR AO UTILIZAR NO <ng-repeat>
                $scope.listUraConsultaApiEnvio = [];
                $scope.listUraConsultaApiRetorno = [];
                $scope.listCamposEnvio = [];
                $scope.listCamposRetorno = [];
                $scope.listDirecaoCampoProvedor = [];
                $scope.listVariavelUraAtendimento = [];
                $scope.listAcaoUra = [];

                $scope.listTranslateOperadorLogico = [
                    { OperadorLogicoId: 1, translate: $translate.instant('modalEditCampo.maior') },
                    { OperadorLogicoId: 2, translate: $translate.instant('modalEditCampo.menor') },
                    { OperadorLogicoId: 3, translate: $translate.instant('modalEditCampo.igual') },
                    { OperadorLogicoId: 4, translate: $translate.instant('modalEditCampo.contem') },
                    { OperadorLogicoId: 5, translate: $translate.instant('modalEditCampo.diferente') },
                    { OperadorLogicoId: 6, translate: $translate.instant('modalEditCampo.nao_contem') },
                    { OperadorLogicoId: 7, translate: $translate.instant('modalEditCampo.entre') },
                    { OperadorLogicoId: 8, translate: $translate.instant('modalEditCampo.menor_igual') },
                    { OperadorLogicoId: 9, translate: $translate.instant('modalEditCampo.maior_igual') },
                    { OperadorLogicoId: 10, translate: $translate.instant('modalEditCampo.tamanhoMenor') },
                    { OperadorLogicoId: 11, translate: $translate.instant('modalEditCampo.tamanhoMenorIgual') },
                    { OperadorLogicoId: 12, translate: $translate.instant('modalEditCampo.tamanhoIgual') },
                    { OperadorLogicoId: 13, translate: $translate.instant('modalEditCampo.tamanhoMaiorIgual') },
                    { OperadorLogicoId: 14, translate: $translate.instant('modalEditCampo.tamanhoMaior') },
                    { OperadorLogicoId: 15, translate: $translate.instant('modalEditCampo.temValor') },
                    { OperadorLogicoId: 16, translate: $translate.instant('modalEditCampo.semValor') }
                ];

                // Operadores unários: avaliam só presença/ausência de valor no campo (sem ValorCondicao)
                $scope.operadoresUnarios = [15, 16];
                $scope.isOperadorUnario = function (operadorLogicoId) {
                    return $scope.operadoresUnarios.indexOf(operadorLogicoId) > -1;
                };
                $scope.onChangeOperadorLogico = function (condicao) {
                    if ($scope.isOperadorUnario(condicao.OperadorLogicoId)) {
                        condicao.ValorCondicao = null;
                    }
                };

                $scope.listValorBooleano = [
                    { BooleanoId: 1, Alias: $translate.instant('campo.sim') },
                    { BooleanoId: 2, Alias: $translate.instant('campo.nao') }
                ];

                $scope.cteTipoCampoProvedor = {
                    form: 1,
                    raw: 2
                }

                $scope.builderListOperadoresLogicoEnvio = function () {

                    let isOperadorEnvio = function (op) {
                        // Apenas os operadores válidos para envio dos campos
                        let filtered = [1, 2, 3, 4, 5, 8, 9, 10, 11, 12, 13, 14];
                        return filtered.find(id => op.OperadorLogicoId == id);
                    }
                    $scope.listOperadoresLogicoEnvio = $scope.operadoresLogico.filter(isOperadorEnvio);

                    $scope.listOperadoresLogicoEnvio.forEach(item => {
                        let translate = $scope.listTranslateOperadorLogico.find(t => t.OperadorLogicoId == item.OperadorLogicoId);
                        if (translate) {
                            item.Alias = translate.translate;
                        }
                    });
                }

                $scope.builderListOperadoresLogicoRetorno = function () {

                    let isOperadorRetorno = function (op) {
                        // Apenas os operadores válidos para envio dos campos
                        let filtered = [1, 2, 3, 4, 5, 8, 9, 15, 16];
                        return filtered.find(id => op.OperadorLogicoId == id);
                    }
                    $scope.listOperadoresLogicoRetorno = $scope.operadoresLogico.filter(isOperadorRetorno);

                    let isOperadorDataRetorno = function (op) {
                        // Apenas os operadores válidos para envio dos campos
                        let filtered = [1, 2, 3, 5, 8, 9, 15, 16];
                        return filtered.find(id => op.OperadorLogicoId == id);
                    }
                    $scope.listOperadoresLogicoDataRetorno = $scope.operadoresLogico.filter(isOperadorDataRetorno);

                    $scope.listOperadoresLogicoRetorno.forEach(item => {
                        let translate = $scope.listTranslateOperadorLogico.find(t => t.OperadorLogicoId == item.OperadorLogicoId);
                        if (translate) {
                            item.Alias = translate.translate;
                        }
                    });
                }

                $scope.builderListDirecaoCampoProvedor = function () {
                    if ($scope.direcaoCampoProvedor) {
                        $scope.listDirecaoCampoProvedor = [];
                        $scope.direcaoCampoProvedor.forEach(item => {
                            let direcao = {
                                DirecaoCampoProvedorId: item.Id,
                                Descricao: item.Descricao,
                                Alias: $translate.instant(item.Translation)
                            };
                            $scope.listDirecaoCampoProvedor.push(direcao);

                            switch (item.Descricao) {
                                case 'Envio':
                                    $scope.campoEnvio = item.Id;
                                    break;
                                case 'Retorno':
                                    $scope.campoRetorno = item.Id;
                                    break;
                            }
                        });
                    }
                }

                $scope.builderListVariavelUraAtendimento = function () {
                    if ($scope.variaveisUraAtendimento) {
                        $scope.listVariavelUraAtendimento = [];
                        $scope.variaveisUraAtendimento.forEach(item => {
                            let variavel = {
                                VariavelUraAtendimentoId: item.Id,
                                Descricao: $translate.instant(item.Descricao),
                                Alias: item.Alias
                            };
                            $scope.listVariavelUraAtendimento.push(variavel);
                        });
                    }
                }

                $scope.builderListAcaoUra = function () {
                    if ($scope.acoesUra) {
                        $scope.listAcaoUra = [];
                        $scope.acoesUra.forEach(item => {
                            if (item.Descricao != 'editAcoesUra.consultaApi') {
                                let acaoUra = {
                                    AcaoUraId: item.Id,
                                    Descricao: $translate.instant(item.Descricao)
                                };
                                $scope.listAcaoUra.push(acaoUra);

                                switch (item.Descricao) {
                                    case 'editAcoesUra.repeteMenu':
                                        $scope.acaoUra.repeteMenu = item.Id;
                                        break;
                                    case 'editAcoesUra.finalizarChamada':
                                        $scope.acaoUra.finalizaChamada = item.Id;
                                        break;
                                    case 'editAcoesUra.consultaApi':
                                        $scope.acaoUra.consultaApi = item.Id;
                                        break;
                                    case 'editAcoesUra.transferirChamada':
                                        $scope.acaoUra.transfereChamada = item.Id;
                                        break;
                                }
                            }
                        });
                    }
                }

                //#endregion listas

                //#endregion variaveis

                //#region inicializacao

                $scope.operadoresLogico = operadoresLogico;
                $scope.direcaoCampoProvedor = direcaoCampoProvedor;
                $scope.variaveisUraAtendimento = variaveisUraAtendimento;
                $scope.acoesUra = acoesUra;
                $scope.ListProvedorCampo = [];

                $scope.getProvedoresResource = function () {

                    $scope.listUraConsultaApiEnvio = [];
                    $scope.listUraConsultaApiRetorno = [];

                    // Seleciona os provedores por carteira da URA
                    UraProvedorResource.getProvedores({
                        Ativo: true,
                        CarteiraId: $scope.ura.CarteiraId
                    }).$promise
                        .then(provedores => {
                            if (provedores) {
                                $scope.provedores = provedores;
                                let provedor = $scope.provedores.find(item => item.Id == $scope.uraSelecionada.UraProvedorId);
                                if (provedor) {
                                    $scope.ListProvedorCampo = provedor.UraProvedorCampo;
                                }
                                if ($scope.uraSelecionada.UraProvedorId) {
                                    $scope.builderListProvedorCampos($scope.uraSelecionada.UraProvedorId);
                                    $scope.builderConsultaApiLists();
                                }
                            }
                        }).
                        catch(() => {
                            NotifyService.showError;
                        });
                }

                $scope.builderConsultaApiLists = function () {

                    if ($scope.uraSelecionada.UraConsultaApi) {
                        // Criamos as propriedades necessárias
                        // para funcionar no front <DirecaoCampoProvedorId>
                        $scope.uraSelecionada.UraConsultaApi.forEach(item => {

                            // Linhas do "Resultado da Requisição" não têm UraProvedorCampoId — o lookup
                            // abaixo falha e DirecaoCampoProvedorId fica indefinido. Aqui o discriminador
                            // é o próprio HttpStatusRecebidoId: pertencem sempre ao Retorno.
                            if (item.HttpStatusRecebidoId != null) {
                                item.DirecaoCampoProvedorId = $scope.campoRetorno;
                                return;
                            }

                            //if (!UraHelper.isPropValid(item.DirecaoCampoProvedorId)) {

                            if ($scope.ListProvedorCampo) {
                                let uraProvedorCampo = $scope.ListProvedorCampo.find(campo => campo.Id == item.UraProvedorCampoId);
                                if (uraProvedorCampo) {
                                    item.showVariaveis = item.VariavelUraAtendimentoId != null ? true : false;
                                    item.DirecaoCampoProvedorId = uraProvedorCampo.DirecaoCampoProvedorId;
                                    item.TipoDadosCampoProvedorId = uraProvedorCampo.TipoDadosCampoProvedorId;
                                    //    // Cria a lista de condicoes 
                                    //    // de acordo com o tipo de dados
                                    //    // TipoDadosCampoProvedorId
                                    //    switch (uraProvedorCampo.TipoDadosCampoProvedorId) {
                                    //        case 4:
                                    //            item.listCondicaoOperador = $scope.listValorBooleano;
                                    //            break;
                                    //        default:
                                    //            item.listCondicaoOperador = $scope.listOperadoresLogicoRetorno;
                                    //            break;
                                    //    }
                                }
                            }
                            //}
                        });

                        $scope.builderListUraConsultaApi();
                    }

                    //    if ($scope.uraSelecionada.UraConsultaApi) {
                    //        let uraProvedorId = $scope.uraSelecionada.UraProvedorId;
                    //        if (uraProvedorId) {
                    //            $scope.builderListProvedorCampos(uraProvedorId);
                    //            $scope.builderListUraConsultaApi();
                    //        }
                    //    }
                }

                $scope.builderListProvedorCampos = function (uraProvedorId) {
                    if ($scope.provedores) {
                        let provedor = $scope.provedores.find(e => e.Id == uraProvedorId);
                        if (provedor) {
                            $scope.listCamposEnvio = [];
                            $scope.listCamposRetorno = [];
                            if (provedor.UraProvedorCampo) {
                                provedor.UraProvedorCampo.forEach(item => $scope.setListProvedorCampos(item));
                            }
                        }
                        // Atualizamos a lista de dados
                        // a ser enviado para o CRM
                        $scope.builderListValoresCrm();
                    }
                }

                $scope.builderListUraConsultaApi = function () {
                    $scope.listUraConsultaApiEnvio = $scope.uraSelecionada.UraConsultaApi.filter(item => item.DirecaoCampoProvedorId == $scope.campoEnvio);
                    $scope.listUraConsultaApiRetorno = $scope.uraSelecionada.UraConsultaApi.filter(item => item.DirecaoCampoProvedorId == $scope.campoRetorno);
                }

                $scope.builderListValoresCrm = function () {

                    let indice = 0;
                    if ($scope.listVariavelUraAtendimento) {
                        $scope.listValoresCrm = [];
                        $scope.listVariavelUraAtendimento.forEach(item => {
                            let valor = {
                                Indice: indice,
                                Id: item.VariavelUraAtendimentoId,
                                TipoId: $scope.consultaApiconstantes.tipoVariavelUraAtendimento,
                                Nome: item.Alias
                            };
                            $scope.listValoresCrm.push(valor);
                            indice++;
                        });
                    }

                    if ($scope.listCamposRetorno) {
                        $scope.listCamposRetorno.forEach(item => {
                            let valor = {
                                Indice: indice,
                                Id: item.UraProvedorCampoId,
                                TipoId: $scope.consultaApiconstantes.tipoUraProvedorCampo,
                                Nome: item.Nome
                            };
                            $scope.listValoresCrm.push(valor);
                            indice++;
                        });
                    }
                }

                $scope.setListProvedorCampos = function (item) {

                    // Seleciona o nome de acordo com o tipo de campo
                    switch (item.TipoCampoProvedorId) {
                        case $scope.cteTipoCampoProvedor.form:
                            let campo = {
                                UraProvedorCampoId: item.Id,
                                DirecaoCampoProvedorId: item.DirecaoCampoProvedorId,
                                TipoDadosCampoProvedorId: item.TipoDadosCampoProvedorId,
                                Nome: item.Nome,
                                Obrigatorio: item.Obrigatorio
                            };
                            if (item.DirecaoCampoProvedorId == $scope.campoEnvio) {
                                $scope.listCamposEnvio.push(campo);
                            }
                            else if (item.DirecaoCampoProvedorId == $scope.campoRetorno) {
                                $scope.listCamposRetorno.push(campo);
                            }
                            break;

                        case $scope.cteTipoCampoProvedor.raw:

                            if (item.JsonObj) {
                                let jsonObj = JSON.parse(item.JsonObj);
                                if (jsonObj) {
                                    let idFake = 1;
                                    for (var nome in jsonObj) {

                                        let campo = {
                                            UraProvedorCampoId: idFake,
                                            DirecaoCampoProvedorId: item.DirecaoCampoProvedorId,
                                            TipoDadosCampoProvedorId: item.TipoDadosCampoProvedorId,
                                            Nome: `${item.Nome}.${nome}`,
                                            Obrigatorio: item.Obrigatorio
                                        };
                                        idFake = idFake + 1;
                                        if (item.DirecaoCampoProvedorId == $scope.campoEnvio) {
                                            $scope.listCamposEnvio.push(campo);
                                        }
                                        else if (item.DirecaoCampoProvedorId == $scope.campoRetorno) {
                                            $scope.listCamposRetorno.push(campo);
                                        }
                                    }
                                }
                            }
                            break;
                    }
                }

                //#endregion inicializacao

                //#region get e set

                $scope.getStyleModal = function (direcaoCampoProvedorId) {
                    return direcaoCampoProvedorId == $scope.campoEnvio ? 'width: 1200px' : 'width: 1000px';
                }

                $scope.getDescricaoBotaoCampo = function () {
                    let descricao = $translate.instant('modalEditCampo.salvarCampo');
                    if ($scope.consultaApiUtils.editandoCampo) {
                        descricao = $translate.instant('modalEditCampo.atualizarCampo');
                    }
                    return descricao;
                }

                $scope.getDescricaoCampo = function (condicao, direcaoCampoProvedorId) {
                    let descricaoCampo = '---';
                    let listCampos = $scope.getListCamposProvedor(direcaoCampoProvedorId);
                    if (listCampos) {
                        let item = listCampos.find(elem => elem.UraProvedorCampoId == condicao.UraProvedorCampoId);
                        if (item) {
                            descricaoCampo = item.Nome;
                        }
                    }
                    return descricaoCampo;
                }

                $scope.getValorCampo = function (condicao) {
                    // Linha com variável selecionada => mostra o alias dela
                    if (condicao.VariavelUraAtendimentoId) {
                        let item = $scope.listVariavelUraAtendimento.find(elem => elem.VariavelUraAtendimentoId == condicao.VariavelUraAtendimentoId);
                        if (item) {
                            return $translate.instant(item.Descricao);
                        }
                    }
                    // Sem variável: mostra o valor textual, ocultando a sentinela '$'
                    if (condicao.ValorCampo == null || condicao.ValorCampo === '$') {
                        return '---';
                    }
                    return condicao.ValorCampo;
                }

                $scope.getAliasCondicaoEnvio = function (condicao) {
                    let condicaoCampo = _.find($scope.listOperadoresLogicoEnvio, el => {
                        return el.OperadorLogicoId == condicao.OperadorLogicoId;
                    });
                    return condicaoCampo ? condicaoCampo.Alias : '---';
                }

                $scope.getAliasStatusRecebido = function (condicao) {
                    let item = _.find($scope.HttpStatusRecebido, el => el.HttpStatusRecebidoId == condicao.HttpStatusRecebidoId);
                    return item ? item.Alias : '---';
                }

                $scope.getValorCondicao = function (condicao) {
                    let valorCondicao = condicao.ValorCondicao;
                    //var descricao = _.find($scope.listTranslateOperadorLogico, el => {
                    //    return el.OperadorLogicoId == condicao.OperadorLogicoId;
                    //});
                    //if (descricao) {
                    //    valorCondicao = `${descricao.translate} ${valorCondicao}`;
                    //}
                    return valorCondicao ? valorCondicao : '---';
                }

                $scope.getAliasCondicaoRetorno = function (condicao) {
                    let condicaoCampo = _.find($scope.listOperadoresLogicoRetorno, el => {
                        return el.OperadorLogicoId == condicao.OperadorLogicoId;
                    });
                    return condicaoCampo ? condicaoCampo.Alias : '---';
                }

                $scope.getAliasValorCondicaoRetorno = function (condicao) {

                    let valorCondicao = condicao.ValorCondicao;
                    if (condicao.TipoDadosCampoProvedorId == $scope.TpCampoDadoBooleano) {
                        let booleanoId = Number(condicao.ValorCondicao);
                        let valorBooleano = $scope.listValorBooleano.find(item => item.BooleanoId == booleanoId);
                        if (valorBooleano) {
                            valorCondicao = valorBooleano.Alias;
                        }
                    }
                    return valorCondicao ? valorCondicao : '---';
                }

                $scope.getListCamposProvedor = function (direcaoCampoProvedorId) {
                    return direcaoCampoProvedorId == $scope.campoEnvio ? $scope.listCamposEnvio : $scope.listCamposRetorno;
                }

                $scope.getDigitoMenu = function () {
                    return $scope.uraSelecionada.Botao;
                };

                $scope.getDescricaoDigitoMenu = function () {
                    let digito = $scope.getDigitoMenu();
                    if (digito == '?') {
                        digito = $translate.instant('modalEditCampo.digitos');
                    }
                    return digito;
                };

                $scope.getUraProvedorId = function () {
                    return $scope.uraSelecionada.UraProvedorId;
                };

                $scope.getDescricaoAcao = function (condicao) {
                    let descricao = '---';
                    let item = $scope.listAcaoUra.find(e => e.AcaoUraId == condicao.AcaoUraId);
                    if (item) {
                        descricao = item.Descricao;
                    }
                    return descricao;
                };

                $scope.getProvedores = function () {
                    return $scope.provedores;
                }

                $scope.getTituloCamposEnvio = function () {
                    let titulo = $translate.instant('editProvedor.camposEnvio');
                    let digito = $scope.getDigitoMenu();
                    if (digito == '?') {
                        titulo = `${titulo} [${$translate.instant('editUra.qqerSeqDigitos')}]`;
                    }
                    else if (digito) {
                        titulo = `${titulo} ${$translate.instant('campo.digito')} [${digito}]`;
                    }
                    return titulo;
                }

                $scope.setAcaoCampoRetorno = function () {
                    if (!$scope.consultaApiEdit.UraConsultaApi) {
                        return;
                    }

                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1) {
                        switch ($scope.consultaApiEdit.UraConsultaApi[indexCondicao].AcaoUraId) {
                            //case $scope.acaoUra.repeteMenu:
                            //case $scope.acaoUra.finalizaChamada:
                            //$scope.consultaApiEdit.UraConsultaApi[indexCondicao].AcaoUraId = $scope.consultaApiUtils.editAcao;
                            //break;
                            case $scope.acaoUra.transfereChamada:
                                // Destino a ser transferido
                                //$scope.consultaApiEdit.UraConsultaApi[indexCondicao].AcaoUraId = $scope.consultaApiUtils.editAcao;
                                //$scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraTipoId = $scope.consultaApiUtils.uraTipoId;

                                switch ($scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraTipoId) {
                                    case $scope.transferenciaGrupo:
                                    case $scope.transferenciaRamal:
                                    case $scope.transferenciaRamalPabx:
                                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfRamalId = $scope.consultaApiUtils.transfereDestinoId;
                                        break;
                                    case $scope.transferenciaUra:
                                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfUraId = $scope.consultaApiUtils.transfereDestinoId;
                                        break;
                                    case $scope.transferenciaServico:
                                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfServicoId = $scope.consultaApiUtils.transfereDestinoId;
                                        break;
                                    case $scope.transferenciaMenu:
                                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfMenuGuid = $scope.consultaApiUtils.transfereDestinoId;
                                        break;
                                }
                                break;
                        }
                    }
                }

                $scope.getResumoAcao = function (condicao, direcaoCampoProvedorId) {
                    let resumo = $translate.instant('modalEditCampo.acaoNaoConfigurada');
                    if (!condicao) {
                        return resumo;
                    }

                    switch (direcaoCampoProvedorId) {
                        case $scope.campoEnvio:
                            let valorCondicao = condicao.ValorCondicao;
                            var descricao = _.find($scope.listTranslateOperadorLogico, el => {
                                return el.OperadorLogicoId == condicao.OperadorLogicoId;
                            });
                            if (descricao) {
                                resumo = `${descricao.translate} ${valorCondicao}`;
                            }
                            break;

                        case $scope.campoRetorno:
                            switch (condicao.AcaoUraId) {
                                case $scope.acaoUra.repeteMenu:
                                    resumo = $translate.instant('editAcoesUra.repeteMenu');
                                    break;
                                case $scope.acaoUra.finalizaChamada:
                                    resumo = $translate.instant('modalEditCampo.finalizaChamada');
                                    break;
                                case $scope.acaoUra.transfereChamada:
                                    let ret = $scope.getResumoTransfereRamal(condicao);
                                    if (ret) {
                                        resumo = ret;
                                    }
                                    break;
                            }
                            break;
                    }
                    return resumo;
                }

                $scope.getResumoTransfereRamal = function (condicao) {
                    if (!condicao) {
                        return null;
                    }
                    let item = null;
                    let descricao = "";
                    switch (condicao.UraTipoId) {
                        case $scope.transferenciaGrupo:
                            item = $scope.grupos.find(r => r.RamalId == condicao.TransfRamalId);
                            break;
                        case $scope.transferenciaRamal:
                            item = $scope.ramais.find(r => r.RamalId == condicao.TransfRamalId);
                            break;
                        case $scope.transferenciaUra:
                            item = $scope.uras.find(r => r.UraId == condicao.TransfUraId);
                            break;
                        case $scope.transferenciaServico:
                            item = $scope.servicos.find(r => r.ServicoId == condicao.TransfServicoId);
                            break;
                        case $scope.transferenciaRamalPabx:
                            item = $scope.ramaisPabx.find(r => r.RamalId == condicao.TransfRamalId);
                            break;
                        case $scope.transferenciaMenu:
                            item = $scope.listMenus.find(r => r.MenuGuid == condicao.TransfMenuGuid);
                            break;
                    }
                    if (item) {
                        descricao = item.Descricao;
                    }
                    let uraTipo = $scope.tiposTransferencia.find(e => e.TipoId == condicao.UraTipoId);
                    if (!uraTipo) {
                        return null;
                    }
                    let resumo = `${$translate.instant('campo.transferencia')} : ${uraTipo.Alias}<br>${descricao}`;
                    return resumo;
                }

                $scope.getDicaCondicao = function () {
                    return `...`;
                }

                //#endregion get e set

                //#region audios

                $scope.startUraUpload = function () {
                    ModalService.showUploading();
                }

                $scope.loadTransfereChamadaConsultaApiCompleted = function (result) {
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1) {
                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfereChamadaArquivoId = result.UraArquivoId;
                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfereChamadaUraArquivo = result;
                        $scope.consultaApiUtils.transfereChamadaUraArquivo = result;
                    }
                    ModalService.hideUploading();
                };

                $scope.removeAudioTransfereChamadaConsultaApi = function () {
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > 0) {
                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfereChamadaArquivoId = null;
                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfereChamadaUraArquivo = null;
                    }
                };

                //#region audio util

                $scope.showProgress = function (percentComplete) {
                    $('#modalBlock').find('.uk-progress-bar').css({ width: percentComplete + '%' });
                    $('#modalBlock').find('.uk-progress-bar').text(percentComplete + '%');
                }

                $scope.errorLoadAudio = function (result) {
                    $scope.preview = null;

                    var modal = $.UIkit.modal('#modalBlock');
                    if (modal)
                        modal.hide(true);

                    if (result == 'Bad Request') {
                        NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                    }
                };

                //#endregion audio util

                //#endregion audios

                //#region editar campos

                $scope.isConsultaApi = function () {
                    return $scope.uraSelecionada.TipoUra == 'consultaApi' || $scope.infoUraModal.tipoUra == 'consultaApi';
                }

                $scope.filtroCondicao = function (item) {
                    // HttpStatusRecebidoId null => linha pertence à tabela "Condições para o valor do campo"
                    return item.HttpStatusRecebidoId == null;
                };

                $scope.filtroStatusRecebido = function (item) {
                    // HttpStatusRecebidoId definido => linha pertence à tabela "Resultado da Requisição"
                    return item.HttpStatusRecebidoId != null;
                };

                // Calcula a lista de status disponíveis para a linha, aplicando:
                //  (b) "Não aplicado" some quando alguma outra linha já tem sucesso/insucesso (e vice-versa)
                //  (c) status já usado em outra linha não aparece (unicidade — vale para os 3 valores)
                // Função pura — não chamar direto em colecao da view (o em-select observa por referência
                // e uma nova array a cada digest causaria loop). Usar via _listStatusDisponivel.
                $scope.getListHttpStatusRecebido = function (condicao) {
                    var todas = $scope.consultaApiEdit && $scope.consultaApiEdit.UraConsultaApi
                        ? $scope.consultaApiEdit.UraConsultaApi
                        : [];
                    var outrasResultado = todas.filter(function (c) {
                        return c !== condicao &&
                            (c.HttpStatusRecebidoId === 1 || c.HttpStatusRecebidoId === 2 || c.HttpStatusRecebidoId === 3);
                    });
                    var usados = outrasResultado.map(function (c) { return c.HttpStatusRecebidoId; });
                    var temNaoAplicadoEmOutra = usados.indexOf(1) >= 0;
                    var temSucessoOuInsucessoEmOutra = usados.indexOf(2) >= 0 || usados.indexOf(3) >= 0;

                    return $scope.HttpStatusRecebido.filter(function (opt) {
                        if (condicao.HttpStatusRecebidoId === opt.HttpStatusRecebidoId) return true;
                        if (usados.indexOf(opt.HttpStatusRecebidoId) >= 0) return false;
                        if (opt.HttpStatusRecebidoId === 1 && temSucessoOuInsucessoEmOutra) return false;
                        if ((opt.HttpStatusRecebidoId === 2 || opt.HttpStatusRecebidoId === 3) && temNaoAplicadoEmOutra) return false;
                        return true;
                    });
                };

                // Atualiza condicao._listStatusDisponivel para cada linha do "Resultado da Requisição".
                // Chamar após add/remove de linha ou troca de status — assim a referência fica estável
                // entre digests e o em-select não entra em loop.
                $scope.atualizarListasStatusDisponivel = function () {
                    var todas = $scope.consultaApiEdit && $scope.consultaApiEdit.UraConsultaApi
                        ? $scope.consultaApiEdit.UraConsultaApi
                        : [];
                    todas.forEach(function (c) {
                        if (c.HttpStatusRecebidoId != null) {
                            c._listStatusDisponivel = $scope.getListHttpStatusRecebido(c);
                        }
                    });
                };

                // Próximo status livre para um novo registro do "Resultado da Requisição".
                $scope.proximoStatusDisponivelResultado = function () {
                    var todas = $scope.consultaApiEdit && $scope.consultaApiEdit.UraConsultaApi
                        ? $scope.consultaApiEdit.UraConsultaApi
                        : [];
                    var usados = todas
                        .filter(function (c) { return c.HttpStatusRecebidoId === 1 || c.HttpStatusRecebidoId === 2 || c.HttpStatusRecebidoId === 3; })
                        .map(function (c) { return c.HttpStatusRecebidoId; });
                    if (usados.indexOf(1) >= 0) return null;
                    if (usados.indexOf(2) >= 0 || usados.indexOf(3) >= 0) {
                        if (usados.indexOf(2) < 0) return 2;
                        if (usados.indexOf(3) < 0) return 3;
                        return null;
                    }
                    return 2;
                };

                $scope.podeAdicionarStatusRecebido = function () {
                    return $scope.proximoStatusDisponivelResultado() !== null;
                };

                // (a) "Não aplicado" não tem ação possível: limpa o que estiver selecionado.
                $scope.onChangeStatusRecebido = function (condicao) {
                    if (condicao && condicao.HttpStatusRecebidoId === 1) {
                        condicao.AcaoUraId = null;
                    }
                    // A troca afeta o que está disponível nas outras linhas.
                    $scope.atualizarListasStatusDisponivel();
                };

                // Linha ativa pertence à tabela "Condições para o valor do campo"
                $scope.isEditandoCondicao = function () {
                    let idx = $scope.consultaApiUtils.indexCondicao;
                    if (idx == null || idx < 0 || !$scope.consultaApiEdit.UraConsultaApi) return false;
                    let cond = $scope.consultaApiEdit.UraConsultaApi[idx];
                    return !!cond && cond.HttpStatusRecebidoId == null;
                };

                // Linha ativa pertence à tabela "Resultado da Requisição"
                $scope.isEditandoStatusRecebido = function () {
                    let idx = $scope.consultaApiUtils.indexCondicao;
                    if (idx == null || idx < 0 || !$scope.consultaApiEdit.UraConsultaApi) return false;
                    let cond = $scope.consultaApiEdit.UraConsultaApi[idx];
                    return !!cond && cond.HttpStatusRecebidoId != null;
                };

                $scope.adicionarCondicaoEdit = function (index, direcaoCampoProvedorId, httpStatusRecebidoId) {
                    var novaCondicao = {
                        UraProvedorCampoId: null,
                        ValorCampo: null,
                        OperadorLogicoId: null,
                        ValorCondicao: null,
                        AcaoUraId: null,
                        UraTipoId: null,
                        TransfRamalId: null,
                        TransfUraId: null,
                        TransfServicoId: null,
                        TransfMenuGuid: null,
                        VariavelUraAtendimentoId: null,
                        TransfereChamadaArquivoId: null,
                        DirecaoCampoProvedorId: direcaoCampoProvedorId,
                        showVariaveis: false,
                        TipoDadosCampoProvedorId: null
                    };
                    // HttpStatusRecebidoId só existe nas linhas de retorno
                    if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        novaCondicao.HttpStatusRecebidoId = httpStatusRecebidoId || null;
                    }
                    $scope.consultaApiEdit.UraConsultaApi.push(novaCondicao);
                    $scope.consultaApiUtils.indexCondicao = $scope.consultaApiEdit.UraConsultaApi.length - 1;
                    if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        $scope.atualizarListasStatusDisponivel();
                    }
                    $scope.resetadicionarCondicao();
                };

                $scope.resetadicionarCondicao = function () {

                    $scope.consultaApiUtils.editAcao = $scope.desconhecido;

                    // Propriedades [transfereChamada]
                    //$scope.consultaApiUtils.uraTipoId = null;
                    $scope.consultaApiUtils.transfereDestinoId = null;
                }

                $scope.removerCondicaoEdit = function (index, direcaoCampoProvedorId, httpStatusRecebidoId) {
                    var list = $scope.consultaApiEdit.UraConsultaApi.filter(el => el.HttpStatusRecebidoId == httpStatusRecebidoId);

                    if (list && list.length > index) {
                        // $index vem da view filtrada; precisamos do índice real no array completo
                        var realIndex = $scope.consultaApiEdit.UraConsultaApi.indexOf(list[index]);
                        if (realIndex > -1) {
                            $scope.consultaApiEdit.UraConsultaApi.splice(realIndex, 1);
                        }
                    }

                    list = $scope.consultaApiEdit.UraConsultaApi.filter(el => el.HttpStatusRecebidoId == httpStatusRecebidoId);
                    // Ajustamos o indexCondicao para o último elemento do MESMO grupo
                    if (list && list.length > 0){
                        $scope.consultaApiUtils.indexCondicao = $scope.consultaApiEdit.UraConsultaApi.indexOf(list[list.length - 1]);
                    }
                    else {
                        $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId, httpStatusRecebidoId);
                    }
                    $scope.atualizarListasStatusDisponivel();
                };

                $scope.removerCondicaoList = function (index, condicao, direcaoCampoProvedorId) {
                    // $index pode vir de uma view filtrada; resolvemos a posição real pelo próprio objeto
                    let lista = direcaoCampoProvedorId == $scope.campoEnvio
                        ? $scope.listUraConsultaApiEnvio
                        : $scope.listUraConsultaApiRetorno;
                    let realIndex = lista.indexOf(condicao);
                    if (realIndex > -1) {
                        lista.splice(realIndex, 1);
                    }
                    // Remove da lista da ura. Linhas recém-criadas podem não ter Id ainda,
                    // então comparamos sempre dentro da mesma direção e, sem Id, pelo conteúdo.
                    let indexUraConsultaApi = $scope.uraSelecionada.UraConsultaApi.findIndex(elem => {
                        if (elem.DirecaoCampoProvedorId != direcaoCampoProvedorId) return false;
                        if (condicao.Id) return elem.Id == condicao.Id;
                        return angular.equals(elem, condicao);
                    });
                    if (indexUraConsultaApi > -1) {
                        $scope.uraSelecionada.UraConsultaApi.splice(indexUraConsultaApi, 1);
                    }
                }

                $scope.alterarCondicaoEdit = function (index, condicao, direcaoCampoProvedorId) {
                    // $index vem da view filtrada; resolvemos para o índice real no array completo
                    $scope.consultaApiUtils.indexCondicao = $scope.consultaApiEdit.UraConsultaApi.indexOf(condicao);

                    $scope.onChangeTransfereDestinoId(null);

                    switch (direcaoCampoProvedorId) {
                        case $scope.campoEnvio:
                            break;

                        case $scope.campoRetorno:
                            switch (condicao.AcaoUraId) {
                                case $scope.acaoUra.repeteMenu:
                                    $scope.consultaApiUtils.editAcao = null;
                                    break;
                                case $scope.acaoUra.finalizaChamada:
                                    $scope.consultaApiUtils.editAcao = null;
                                    break;
                                case $scope.acaoUra.transfereChamada:
                                    $scope.consultaApiUtils.editAcao = $scope.acaoUra.transfereChamada;
                                    $scope.consultaApiUtils.transfereChamadaUraArquivo = condicao.TransfereChamadaUraArquivo;
                                    break;
                            }
                            break;
                    }
                }

                $scope.disableAdicionaAtualizaCampo = function (direcaoCampoProvedorId) {
                    let disabled = true;
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1 &&
                        $scope.consultaApiEdit.UraConsultaApi) {
                        if ($scope.consultaApiUtils.editandoCampo) {
                            let campo = $scope.consultaApiEdit.UraConsultaApi[indexCondicao];
                            if (direcaoCampoProvedorId == $scope.campoEnvio) {
                                disabled = UraHelper.isPropValid(campo.UraProvedorCampoId);
                                if (disabled) {
                                    disabled = UraHelper.compareObjFull($scope.consultaApiEdit, $scope.consultaApiEditBkp);
                                }
                            }
                            else if (direcaoCampoProvedorId == $scope.campoRetorno) {
                                // Sem campos adicionados
                                if ($scope.consultaApiEdit.UraConsultaApi.length == 1 && !$scope.consultaApiEdit.UraConsultaApi[0].UraProvedorCampoId) {
                                    disabled = false;
                                }
                                else {
                                    disabled = $scope.checkAcaoCampoRetorno();
                                    if (!disabled) {
                                        disabled = UraHelper.compareObjFull($scope.consultaApiEdit, $scope.consultaApiEditBkp);
                                    }
                                }
                            }
                        }
                        else if ($scope.consultaApiEdit.UraConsultaApi) {
                            let condAtual = $scope.consultaApiEdit.UraConsultaApi[indexCondicao];
                            if (direcaoCampoProvedorId == $scope.campoEnvio) {
                                disabled = !condAtual.UraProvedorCampoId;
                            }
                            else if (direcaoCampoProvedorId == $scope.campoRetorno && condAtual.HttpStatusRecebidoId != null) {
                                // Linha da tabela "Resultado da Requisição"
                                disabled = !(condAtual.HttpStatusRecebidoId &&
                                    condAtual.AcaoUraId &&
                                    !$scope.checkAcaoCampoRetorno());
                            }
                            else if (direcaoCampoProvedorId == $scope.campoRetorno &&
                                condAtual.TipoDadosCampoProvedorId != $scope.TpCampoDadoBooleano) {
                                // Operador unário (ex.: contém valor / não contém valor) não exige ValorCondicao
                                let valorOk = $scope.isOperadorUnario(condAtual.OperadorLogicoId) || !!condAtual.ValorCondicao;
                                disabled = !(condAtual.UraProvedorCampoId &&
                                    condAtual.OperadorLogicoId &&
                                    valorOk &&
                                    !$scope.checkAcaoCampoRetorno());
                            }
                            else if (direcaoCampoProvedorId == $scope.campoRetorno) {
                                let valorOk = $scope.isOperadorUnario(condAtual.OperadorLogicoId) || !!condAtual.ValorCondicao;
                                disabled = !(condAtual.UraProvedorCampoId &&
                                    valorOk &&
                                    !$scope.checkAcaoCampoRetorno());
                            }
                        }
                    }
                    return disabled;
                };

                $scope.disableAdicionarCondicao = function (direcaoCampoProvedorId) {
                    let disabled = true;

                    if (direcaoCampoProvedorId == $scope.campoEnvio) {
                        disabled = $scope.checkAcaoCampoEnvio();
                    }
                    else if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        disabled = $scope.checkAcaoCampoRetorno();
                    }
                    return disabled;
                };

                $scope.cancelarEditCampos = function (direcaoCampoProvedorId) {
                    $scope.consultaApiUtils.editAcao = $scope.desconhecido;
                    $scope.consultaApiEdit = {};
                    $scope.consultaApiEditBkp = {};
                    if (direcaoCampoProvedorId == $scope.campoEnvio) {
                        ModalService.closeModal('modal_campos_envio_consultaApi');
                    }
                    else if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        ModalService.closeModal('modal_campos_retorno_consultaApi');
                    }
                };

                $scope.onChangeCampoProvedor = function (condicao) {

                    let campo = $scope.ListProvedorCampo.find(item => item.Id == condicao.UraProvedorCampoId);
                    if (campo) {
                        condicao.TipoDadosCampoProvedorId = campo.TipoDadosCampoProvedorId;
                    }
                }

                $scope.onChangeValorCampo = function (condicao) {
                    condicao.ValorCampo = condicao.ValorCampo ? condicao.ValorCampo : null;
                };

                // Quando o usuário alterna o switch "Variáveis Internas"
                $scope.onToggleShowVariaveis = function (condicao) {
                    if (condicao.showVariaveis) {
                        // Modo variável: marca ValorCampo como sentinela e descarta texto anterior
                        condicao.ValorCampo = '$';
                    } else {
                        // Modo texto: zera variável e sentinela
                        condicao.VariavelUraAtendimentoId = null;
                        condicao.ValorCampo = null;
                    }
                };

                // Quando o usuário seleciona/limpa uma variável interna
                $scope.onChangeVariavelUraAtendimento = function (condicao) {
                    condicao.ValorCampo = condicao.VariavelUraAtendimentoId ? '$' : null;
                };

                $scope.onChangeUraProvedor = function (direcaoCampoProvedorId) {
                    $scope.consultaApiEdit.UraConsultaApi = [];
                    $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId);
                    // Em retorno também semeia uma linha para "Resultado da Requisição"
                    if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId, 1);
                    }
                    let provedor = $scope.provedores.find(item => item.Id == $scope.consultaApiEdit.UraProvedorId);
                    if (provedor) {
                        $scope.ListProvedorCampo = provedor.UraProvedorCampo;
                    }
                    $scope.builderListProvedorCampos($scope.consultaApiEdit.UraProvedorId);
                };

                $scope.onChangeAcaoUra = function (acaoUraId, condicao) {
                    $scope.consultaApiUtils.editAcao = acaoUraId;
                    // Sincroniza indexCondicao com a linha cuja ação acabou de mudar,
                    // para que o include de transferência de chamada amarre na linha certa.
                    if (condicao && $scope.consultaApiEdit.UraConsultaApi) {
                        let idx = $scope.consultaApiEdit.UraConsultaApi.indexOf(condicao);
                        if (idx > -1) {
                            $scope.consultaApiUtils.indexCondicao = idx;
                        }
                    }
                };

                $scope.novoCampo = function (direcaoCampoProvedorId, editar) {

                    $scope.consultaApiUtils.editandoCampo = editar;
                    $scope.consultaApiUtils.direcaoCampoProvedorId = direcaoCampoProvedorId;
                    if ($scope.consultaApiUtils.editandoCampo) {

                        let toNumberIsNecessary = function (elem) {
                            var ret = elem.DirecaoCampoProvedorId == direcaoCampoProvedorId;

                            // To Number....
                            if (ret && ((elem.OperadorLogicoId >= 10 && elem.OperadorLogicoId <= 14) || elem.TipoDadosCampoProvedorId == 4)) {
                                elem.ValorCondicao = Number(elem.ValorCondicao);
                            }
                            return ret;
                        }

                        // Converte o ValorCondicao de string para Number
                        let uraConsultaApi = $scope.uraSelecionada.UraConsultaApi.filter(elem => toNumberIsNecessary(elem));

                        if (uraConsultaApi &&
                            uraConsultaApi.length > 0) {

                            // Seta as variáveis da lista UraEnviarDadosCrm
                            uraConsultaApi.forEach(item => {
                                if (item.UraEnviarDadosCrm) {
                                    item.UraEnviarDadosCrm.forEach(dadoCrm => {

                                        // Variaveis da Ura
                                        if (dadoCrm.VariavelUraAtendimentoId) {
                                            let valorCrm = $scope.listValoresCrm.find(
                                                valorCrm => valorCrm.TipoId == $scope.consultaApiconstantes.tipoVariavelUraAtendimento &&
                                                    valorCrm.Id == dadoCrm.VariavelUraAtendimentoId);
                                            if (valorCrm) {
                                                dadoCrm.Indice = valorCrm.Indice;
                                                dadoCrm.showVariaveis = true;
                                            }
                                            dadoCrm.TipoId = $scope.consultaApiconstantes.tipoVariavelUraAtendimento;
                                        }

                                        // Variaveis dos campos de retorno
                                        if (dadoCrm.UraProvedorCampoId) {
                                            let valorCrm = $scope.listValoresCrm.find(
                                                valorCrm => valorCrm.TipoId == $scope.consultaApiconstantes.tipoUraProvedorCampo &&
                                                    valorCrm.Id == dadoCrm.UraProvedorCampoId);
                                            if (valorCrm) {
                                                dadoCrm.Indice = valorCrm.Indice;
                                                dadoCrm.showVariaveis = true;
                                            }
                                            dadoCrm.TipoId = $scope.consultaApiconstantes.tipoUraProvedorCampo;
                                        }
                                    });
                                }
                            });

                            $scope.consultaApiEdit.UraProvedorId = $scope.getUraProvedorId();
                            $scope.consultaApiUtils.DirecaoCampoProvedorId = direcaoCampoProvedorId;
                            $scope.consultaApiEdit.UraConsultaApi = angular.copy(uraConsultaApi);

                            // Envio: restaura flag showVariaveis quando há variável persistida
                            if (direcaoCampoProvedorId == $scope.campoEnvio) {
                                $scope.consultaApiEdit.UraConsultaApi.forEach(item => {
                                    if (item.VariavelUraAtendimentoId) {
                                        item.showVariaveis = true;
                                    }
                                });
                            }

                            // Retorno: garantir que ambas as tabelas (Condições e Resultado da Requisição)
                            // tenham pelo menos uma linha seed mesmo quando só uma das duas vier do backend.
                            if (direcaoCampoProvedorId == $scope.campoRetorno) {
                                let temCondicao = $scope.consultaApiEdit.UraConsultaApi.some(item => item.HttpStatusRecebidoId == null);
                                let temStatusRecebido = $scope.consultaApiEdit.UraConsultaApi.some(item => item.HttpStatusRecebidoId != null);
                                if (!temCondicao) {
                                    $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId);
                                }
                                if (!temStatusRecebido) {
                                    $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId, 1);
                                }
                                // Popula _listStatusDisponivel das linhas carregadas do backend
                                // (adicionarCondicaoEdit já cobre as linhas semeadas acima).
                                $scope.atualizarListasStatusDisponivel();
                            }

                            $scope.consultaApiEditBkp = angular.copy($scope.consultaApiEdit);
                            // Ajustamos o indexCondicao para o último elemento
                            $scope.consultaApiUtils.indexCondicao = $scope.consultaApiEdit.UraConsultaApi.length - 1;
                        }
                    }
                    // Provedor já foi definido na configuração
                    // dos campos de envio, devemos usar o mesmo!
                    else if ($scope.listUraConsultaApiEnvio.length > 0 && direcaoCampoProvedorId == $scope.campoRetorno) {
                        $scope.consultaApiEdit.UraProvedorId = $scope.getUraProvedorId();
                        $scope.consultaApiEdit.UraConsultaApi = [];
                        $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId);
                        $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId, 1);
                    }
                    // Provedor já foi definido na configuração
                    // dos campos de retorno, devemos usar o mesmo!
                    else if ($scope.listUraConsultaApiRetorno.length > 0 && direcaoCampoProvedorId == $scope.campoEnvio) {
                        $scope.consultaApiEdit.UraProvedorId = $scope.getUraProvedorId();
                        $scope.consultaApiEdit.UraConsultaApi = [];
                        $scope.adicionarCondicaoEdit(0, direcaoCampoProvedorId);
                    }

                    $scope.forms.camposConsultaApi.$dirty = false;
                    $scope.forms.camposConsultaApi.$pristine = true;

                    if (direcaoCampoProvedorId == $scope.campoEnvio) {
                        ModalService.openModal('modal_campos_envio_consultaApi', null, null, { center: false, bgclose: false, keyboard: false });
                    }
                    else if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        ModalService.openModal('modal_campos_retorno_consultaApi', null, null, { center: false, bgclose: false, keyboard: false });
                    }
                }

                $scope.salvarCampo = function (direcaoCampoProvedorId) {
                    $scope.uraSelecionada.UraProvedorId = $scope.consultaApiEdit.UraProvedorId;

                    // Mantém apenas linhas com conteúdo (descarta seeds vazios)
                    let linhasComConteudo = $scope.consultaApiEdit.UraConsultaApi.filter(item => {
                        if (item.HttpStatusRecebidoId != null) {
                            // Linha "Resultado da Requisição": precisa de ação
                            return !!item.AcaoUraId;
                        }
                        // Linha de envio ou "Condições para o valor do campo": precisa do campo
                        return !!item.UraProvedorCampoId;
                    });

                    if ($scope.uraSelecionada.UraConsultaApi) {
                        // Removemos as configurações existentes
                        // de acordo com o direcaoCampoProvedorId
                        let uraConsultaApi = $scope.uraSelecionada.UraConsultaApi.filter(item => {
                            return item.DirecaoCampoProvedorId != direcaoCampoProvedorId;
                        });
                        $scope.uraSelecionada.UraConsultaApi = angular.copy(uraConsultaApi);

                        if (linhasComConteudo.length > 0) {
                            $scope.uraSelecionada.UraConsultaApi = $scope.uraSelecionada.UraConsultaApi.concat(angular.copy(linhasComConteudo));
                        }
                    }
                    else {
                        $scope.uraSelecionada.UraConsultaApi = angular.copy(linhasComConteudo);
                    }

                    // Atualiza a lista da view
                    if (direcaoCampoProvedorId == $scope.campoEnvio) {
                        $scope.listUraConsultaApiEnvio = angular.copy(linhasComConteudo);
                    }
                    else if (direcaoCampoProvedorId == $scope.campoRetorno) {
                        $scope.listUraConsultaApiRetorno = angular.copy(linhasComConteudo);
                    }
                    $scope.cancelarEditCampos(direcaoCampoProvedorId);
                }

                $scope.isTamanhoDigitos = function (operadorLogicoId) {
                    return operadorLogicoId >= 11 && operadorLogicoId <= 14;
                }

                $scope.checkAcaoCampoEnvio = function () {
                    let disabled = true;
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;

                    if (indexCondicao > -1 &&
                        $scope.consultaApiEdit.UraConsultaApi) {
                        let condicao = $scope.consultaApiEdit.UraConsultaApi[indexCondicao];
                        if (!condicao) {
                            return disabled;
                        }
                        disabled = condicao.UraProvedorCampoId ? false : true;
                    }
                    return disabled;
                }

                $scope.checkAcaoCampoRetorno = function () {
                    let disabled = true;
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;

                    if (indexCondicao > -1 &&
                        $scope.consultaApiEdit.UraConsultaApi) {
                        let condicao = $scope.consultaApiEdit.UraConsultaApi[indexCondicao];
                        if (!condicao) {
                            return disabled;
                        }
                        switch (condicao.AcaoUraId) {
                            case $scope.acaoUra.repeteMenu:
                            case $scope.acaoUra.finalizaChamada:
                                disabled = false;
                                break;
                            case $scope.acaoUra.transfereChamada:
                                switch (condicao.UraTipoId) {
                                    case $scope.transferenciaGrupo:
                                    case $scope.transferenciaRamal:
                                    case $scope.transferenciaRamalPabx:
                                        disabled = !(condicao.TransfRamalId);
                                        break;
                                    case $scope.transferenciaUra:
                                        disabled = !(condicao.TransfUraId);
                                        break;
                                    case $scope.transferenciaServico:
                                        disabled = !(condicao.TransfServicoId);
                                        break;
                                    case $scope.transferenciaMenu:
                                        disabled = !(condicao.TransfMenuGuid);
                                        break;
                                }
                                break;
                        }
                    }
                    return disabled;
                }

                $scope.adicionarDadosCrmConsultaApi = function () {
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1) {
                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm.push(
                            {
                                Chave: null,
                                Valor: null,
                                VariavelUraAtendimentoId: null,
                                showVariaveis: false
                            }
                        );
                    }
                }

                $scope.removerDadosCrmConsultaApi = function (index) {
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1) {
                        if ($scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm &&
                            $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm.length > 0) {
                            $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm.splice(index, 1);
                        }
                    }
                }

                $scope.onChangeVariavelUraAtendimentoDadosCrmConsultaApi = function (dado) {

                    if (!dado || dado.Indice == null || dado.Indice == undefined) {
                        return;
                    }

                    let tipoId = $scope.listValoresCrm[dado.Indice].TipoId;
                    let id = $scope.listValoresCrm[dado.Indice].Id;
                    switch (tipoId) {
                        case $scope.consultaApiconstantes.tipoUraProvedorCampo:
                            dado.UraProvedorCampoId = id;
                            dado.VariavelUraAtendimentoId = null;
                            break;
                        case $scope.consultaApiconstantes.tipoVariavelUraAtendimento:
                            dado.UraProvedorCampoId = null;
                            dado.VariavelUraAtendimentoId = id;
                            break;
                    }
                };

                $scope.onChangeTransfereDestinoId = function (tipoTransferencia) {
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;

                    if (indexCondicao > -1) {
                        switch ($scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraTipoId) {
                            case $scope.transferenciaGrupo:
                            case $scope.transferenciaRamal:
                                let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                                if (indexCondicao > -1) {
                                    // Inicia a lista apenas uma vez!
                                    if (!$scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm ||
                                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm.length == 0) {
                                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm = [];
                                        $scope.adicionarDadosCrmConsultaApi();
                                    }
                                }
                                break;
                            default:
                                break;
                        }

                        // Resetamos as variavies de ramal e grupo
                        // para manter a lógica da funcao showDadosCrmConsultaApi()
                        switch (tipoTransferencia) {
                            case 1:
                            case 2:
                            case null:
                                break;
                            default:
                                $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfRamalId = null;
                                break;
                        }
                    }
                };

                $scope.disableAdicionarDadosCrmConsultaApi = function (index) {

                    let disabled = true;

                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1 &&
                        index > -1) {
                        if ($scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm) {
                            let enviarDadosCrm = $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraEnviarDadosCrm[index];
                            if (!enviarDadosCrm) {
                                return disabled;
                            }
                            disabled = !(UraHelper.isPropValid(enviarDadosCrm.Chave) && (enviarDadosCrm.Valor || enviarDadosCrm.UraProvedorCampoId || enviarDadosCrm.VariavelUraAtendimentoId));
                        }
                    }
                    return disabled;
                };

                $scope.showIconEditCampo = function (condicao, direcaoCampoProvedorId) {
                    let show = false;

                    switch (direcaoCampoProvedorId) {
                        case $scope.campoEnvio:
                            break;

                        case $scope.campoRetorno:
                            switch (condicao.AcaoUraId) {
                                case $scope.acaoUra.transfereChamada:
                                    show = true;
                                    break;
                            }
                            break;
                    }
                    return show;
                }

                $scope.enableTransfereChamada = function (tipo) {
                    let enable = false;
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1 &&
                        $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraTipoId) {
                        enable = $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraTipoId == tipo;
                    }
                    return enable;
                }

                $scope.showDadosCrmConsultaApi = function () {
                    let show = false;
                    let indexCondicao = $scope.consultaApiUtils.indexCondicao;
                    if (indexCondicao > -1) {
                        show = $scope.consultaApiEdit.UraConsultaApi[indexCondicao].UraTipoId &&
                            $scope.consultaApiEdit.UraConsultaApi[indexCondicao].TransfRamalId;
                    }
                    return show;
                }

                //#endregion editar campos

                //#region Inicia Variaveis

                $scope.builderListDirecaoCampoProvedor();
                $scope.builderListVariavelUraAtendimento();
                $scope.builderListOperadoresLogicoEnvio();
                $scope.builderListOperadoresLogicoRetorno();
                $scope.builderListAcaoUra();

                //#endregion Inicia Variaveis

                //*************************
                //  ConsultaApi
                //  FIM
                //*************************

                //#endregion UraConsultaApi

                //#region INICIA URA

                $scope.IniciaEscopoUra();

                //#endregion INICIA URA

            }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (UraResource, search, orderBy, $odata) {
        var odata = UraResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Numero)
            odata.filter(new $odata.Func('startswith', 'Servico/Numero', search.Numero), true);

        if (search.CarteiraId) {
            odata.filter("CarteiraId", "=", parseInt(search.CarteiraId));
        }

        if (search.Descricao)
            odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Descricao"), search.Descricao.toLowerCase()), true);

        odata.where('UraTipo/UraTipoId', 5);

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider.state("main.ura", StateResolverProvider.configAbstract(null, null, {
                proxy: 'main.ura.list',
                pageTitle: 'model.ura',
                pageName: 'model.ura'
            }))
                .state("main.ura.list", StateResolverProvider.configState("/ura", "Ura", "List", {
                    pageTitle: 'model.ura',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.ura.edit", StateResolverProvider.configState("/ura/{UraId}", "Ura", "Edit", {
                    pageTitle: 'model.ura',
                    pageName: 'acoes.editar',
                    css: true
                }))
                .state("main.ura.atendimento", StateResolverProvider.configState("/ura/TipoIntegracaoAtendimento/{UraTipoIntegracaoId}", "Ura", "Edit", {
                    pageTitle: 'model.ura',
                    pageName: 'acoes.editar',
                    css: true,
                    permissions: { AllowAnonymous: true }
                }))
                .state("main.ura.atendimentoavancado", StateResolverProvider.configState("/ura/TipoIntegracaoAvancado/{UraTipoIntegracaoId}", "Ura", "Edit", {
                    pageTitle: 'model.ura',
                    pageName: 'acoes.editar',
                    css: true,
                    permissions: { AllowAnonymous: true }
                }));
        }])

        .service("UraListData", function UraListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    uras: ["UraResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (UraResource, LocalStorageService, $odata, utils, $stateParams) {

                        var filtro = {};
                        if ($stateParams.storage)
                            filtro = LocalStorageService.getItem("FiltroUra");

                        var orderBy = {
                            column: "DataAlteracao",
                            order: "desc"
                        };

                        var odata = getOdataSearchShared(UraResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    ttsService: ["TtsService", function (TtsService) {
                        TtsService.getVozes();
                        TtsService.setProvedores();
                        return;
                    }],
                    uraTranscription: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getUraTranscription().$promise;
                    }]
                }
            }
        })

        .controller("UraListController",
            ["$scope", "$odata", "uras", "UraResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", "carteiras", "uraTranscription", "$translate", function ($scope,
                $odata,
                uras,
                UraResource,
                utils,
                LocalStorageService,
                $stateParams,
                NotifyService,
                $state,
                ModalService,
                carteiras,
                uraTranscription,
                $translate
            ) {
                $scope.uras = uras;

                $scope.carteiras = carteiras;
                $scope.searching = false;
                $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroUra") : {};
                $scope.orderBy = {
                    column: "DataAlteracao",
                    order: "desc"
                };
                $scope.uraTranscription = uraTranscription;

                var updateList = function (list) {

                    ModalService.hideLoading();
                    $scope.uras = list;
                    $scope.uras.recordCount = list.$recordCount || list.length;
                    $scope.currentPage = list.$currentPage || 1;
                    $scope.uras.pageSize = list.$pageSize || 10;
                    $scope.searching = false;
                };

                var getOdataSearch = function getOdataSearch() {
                    return getOdataSearchShared(UraResource, $scope.search, $scope.orderBy, $odata, utils);
                };

                $scope.executeSearch = function executeSearch() {
                    LocalStorageService.setItem('FiltroUra', $scope.search);
                    $scope.searching = true;
                    ModalService.showLoading();
                    getOdataSearch()
                        .page($scope.search.pageSize, 1)
                        .query().then(updateList).catch(function (error) {
                            ModalService.hideLoading();
                            NotifyService.showError(error);
                            $scope.searching = false
                        });
                };

                var deleteRecord = function (data) {
                    ModalService.showLoading();
                    return UraResource.delete({
                        UraId: data.UraId
                    }).$promise
                        .then(function () {
                            ModalService.hideLoading();
                            NotifyService.showSuccess();
                            $scope.pageChanged($scope.currentPage)
                        })
                        .catch((error) =>  {
                            ModalService.hideLoading();
                            let msgError = $scope.builderAlertError(error, $translate.instant('telaUra.erroExluir'), $translate.instant('telaUra.falhaExluir'));
                            ModalService.alert(msgError);
                        });
                };

                $scope.confirmDelete = function (data) {
                    ModalService.confirmDelete(() => deleteRecord(data))
                };

                $scope.pageChanged = function (newPage) {
                    ModalService.showLoading();
                    return getOdataSearch()
                        .page($scope.uras.pageSize, newPage)
                        .query().then(updateList).catch((error) => {
                            ModalService.hideLoading();
                            NotifyService.showError;
                        });
                };

                updateList(uras);

                $scope.limparFiltro = function () {
                    LocalStorageService.removeItem('FiltroUra');
                    $scope.search = {
                        pageSize: 10
                    };
                    $scope.executeSearch();
                };

                $scope.voltar = function () {
                    if ($stateParams.page) {
                        $state.go($stateParams.page, {
                            storage: true
                        });
                    }
                    else {
                        $state.go('main.ura.list', {
                            storage: true
                        });
                    }
                };

                $scope.duplicarUra = function (ura) {
                    if (ura) {
                        ModalService.confirmMessage('telaUra.confirmarDuplicarUra', null, () => {
                            UraResource.duplicarUra({
                                UraId: ura.UraId
                            }).$promise.then((res) => {
                                $scope.executeSearch();
                            }).catch(NotifyService.showError);
                        });
                    }
                }

                $scope.exibirDetalhe = function (titulo, descricao) {
                    ModalService.alert(`<h3>${titulo}</h3>${descricao}`);
                };

                $scope.builderAlertError = function (error, titulo, messageDefault) {
                    let possuiError = false;
                    let msgError = `<h3>${titulo}</h3>`
                    if (error &&
                        error.data &&
                        error.data.ModelState &&
                        error.data.ModelState.Ura) {
                        let listUra = error.data.ModelState.Ura;
                        let limite = listUra.length < 10 ? listUra.length : 10;
                        for (var index = 0; index < limite; index++) {
                            msgError = msgError.concat('<br>', listUra[index]);
                            possuiError = true;
                        }
                    }
                    if (!possuiError) {
                        msgError.concat('<br><br>', messageDefault);
                    }
                    return msgError;
                }

                $scope.getDescricaoServico = function (ura) {
                    let descricao = $translate.instant('telaUra.semDdrs');
                    if (ura.UraServicoAssociado) {
                        if (ura.UraServicoAssociado.length == 1) {
                            descricao = ura.UraServicoAssociado[0].Numero ? ura.UraServicoAssociado[0].Numero : '--';
                        }
                        else if (ura.UraServicoAssociado.length > 1) {
                            descricao = $translate.instant('telaUra.multiplosDdrs')
                        }
                    }
                    return descricao;
                }
            }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UraResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Ura/:UraId", { "UraId": "@UraId" },
                {
                    duplicarUra: {
                        url: "Ura/Duplicar",
                        method: "POST",
                        params: {
                            "UraId": "@UraId"
                        }
                    },
                    getUraRaiz: {
                        url: "Ura/Raiz",
                        method: "GET",
                        isArray: true
                    },
                    getSemServico: {
                        url: "Ura/SemServico",
                        method: "GET",
                        isArray: true
                    },
                    getComRamalUra: {
                        url: "Ura/ComRamalUra",
                        method: "GET",
                        isArray: true
                    },
                    getComRamalUraPesquisa: {
                        url: "Ura/ComRamalUraPesquisa",
                        method: "GET",
                        isArray: true
                    },
                    getSatisfacao: {
                        url: "Ura/Satisfacao",
                        method: "GET",
                        isArray: true
                    },
                    getPerguntas: {
                        url: "Ura/Perguntas/:id",
                        method: "GET",
                        isArray: true
                    },
                    getUraTipoIntegracao: {
                        url: "Ura/UraTipoIntegracao",
                        method: "GET",
                        isArray: true
                    },
                    getUrasDisponiveisAssociarDdr: {
                        url: "Ura/UrasDisponiveisAssociarDdr",
                        method: "GET",
                        isArray: true
                    }
                }
            );
        }])

        .factory("UraCallbackTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("UraCallbackTipo", {});
        }])

        .factory("UraTalkbotResource", ["$odataresource", function ($odataresource) {
            return $odataresource("UraTalkbot", {}, {
                GetScripts: {
                    url: "UraTalkbot/GetScripts",
                    method: "GET",
                    isArray: true,
                },
                GetCampanhaScripts: {
                    url: "UraTalkbot/GetCampanhaScripts/:ura",
                    method: "GET",
                    isArray: true,
                    params: {
                        "ura": "@ura" 
                    }
                }
            });
        }])

        .factory("GeraAudioTtsResource", ["$odataresource", function ($odataresource) {
            return $odataresource("GeraAudioTts/:Id", { "Id": "@Id" }, {
                gerarTTS: {
                    url: "GeraAudioTts/GerarTTS",
                    method: "POST"
                },
                getVozes: {
                    url: "GeraAudioTts/GetVozes/:idioma/Provedor/:provedor",
                    method: "GET",
                    isArray: true,
                    params: {
                        "idioma": "@idioma",
                        "provedor": "@provedor"
                    }
                },
                getAllVozes: {
                    url: "GeraAudioTts/GetVozes/:idioma/Idioma",
                    method: "GET",
                    isArray: true,
                    params: {
                        "idioma": "@idioma"
                    }
                },
                getProvedores: {
                    url: "GeraAudioTts/GetProvedores",
                    method: "GET",
                    isArray: true
                }
            });
        }])
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.uraIntencao.new", StateResolverProvider.configState("/UraIntencao/new?page", "UraIntencao", "Edit", {
                    pageTitle: 'telaUraIntencao.titulo',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.uraIntencao.edit", StateResolverProvider.configState("/UraIntencao/{Id:[0-9]+}", "UraIntencao", "Edit", {
                    pageTitle: 'telaUraIntencao.titulo',
                    pageName: 'acoes.editar'
                }))
        }])
        .service('UraIntencaoEditData', function PesquisaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider',
                            'lazy_jsoneditor',
                            'lazy_fileUpload'
                        ]);
                    }],
                    intencao: ["UraIntencaoResource", "$stateParams", function (UraIntencaoResource, $stateParams) {
                        // Iniciamos o objeto com o DTO da API
                        if (!$stateParams.Id) {
                            $stateParams.Id = 0;
                        }
                        return UraIntencaoResource.getById({ Id: $stateParams.Id }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }]
                }
            }
        })
        .controller("UraIntencaoEditController",
            ["$scope", "$translate", "$state", "intencao", "carteiras", "UraHelper", "ModalService", "UraIntencaoResource", "NotifyService", "Upload", "Config", function (
                $scope,
                $translate,
                $state,
                intencao,
                carteiras,
                UraHelper,
                ModalService,
                UraIntencaoResource,
                NotifyService,
                Upload,
                Config
            ) {

                //#region Variaveis

                // UraIntencaoId
                $scope.uraIntencaoId = intencao.Id;

                // Dados da intencao atual
                $scope.intencao = angular.copy(intencao)

                // Dados a editar
                $scope.intencaoEdit = angular.copy(intencao);

                // Indice da frase atual
                $scope.indexUraIntencaoFrase = -1;

                // url da api para upload do arquivo
                $scope.urlUpload = Config.getUrl("UraIntencao/Importar");

                // Se está importando as frases por arquivo
                $scope.importandoArquivo = false;

                //#endregion Variaveis

                //#region Metodos de inicializacao

                $scope.adicionarUraIntencaoFraseEdit = function (index, frase) {

                    // Em caso de importação por arquivo, analisar de vai fazer splice do item em branco
                    if ($scope.importandoArquivo &&
                        $scope.indexUraIntencaoFrase > -1) {

                        if (!$scope.intencaoEdit.UraIntencaoFrase[$scope.indexUraIntencaoFrase].Frase) {
                            $scope.intencaoEdit.UraIntencaoFrase.splice($scope.indexUraIntencaoFrase, 1);
                            index = index - 1;
                        }
                    }

                    $scope.indexUraIntencaoFrase = index;
                    if ($scope.intencaoEdit.UraIntencaoFrase == undefined) {
                        $scope.intencaoEdit.UraIntencaoFrase = [];
                    }
                    $scope.intencaoEdit.UraIntencaoFrase.push(
                        {
                            UraIntencaoId: $scope.uraIntencaoId,
                            UraIntencaoFraseId: null,
                            Frase: frase ? frase : null
                        }
                    );
                };

                //#endregion Metodos de inicializacao

                //#region inicializacao

                $scope.isNew = intencao.Id > 0 ? false : true;
                if ($scope.isNew) {
                    $scope.adicionarUraIntencaoFraseEdit(0);
                }

                // Carteiras disponiveis
                $scope.carteiras = angular.copy(carteiras);

                // Frase já utilizada na mesma intencao
                $scope.FraseRepetida = false;

                //#endregion inicializacao

                //#region get set

                $scope.getTituloEdicao = function () {
                    let acao;
                    if (!$scope.isNew) {
                        acao = $translate.instant('acoes.editar');
                    }
                    else {
                        acao = $translate.instant('acoes.cadastrar');
                    }
                    return acao;
                };

                $scope.getUraIntencaoFraseId = function (uraIntencaoFrase) {
                    return uraIntencaoFrase.Id ? uraIntencaoFrase.Id : '---';
                }

                $scope.getDescricaoBotaoEditarIntencao = function () {
                    let descricao = $translate.instant('botao.salvar');
                    if (!$scope.isNew) {
                        descricao = $translate.instant('botao.atualizar');
                    }
                    return descricao;
                }

                //#endregion get set

                //#region Editar Frase

                $scope.disableAdicionarUraIntencaoFrase = function (uraIntencaoFrase) {
                    let disabled = true;
                    disabled = uraIntencaoFrase.Frase == undefined || uraIntencaoFrase.Frase == null && uraIntencaoFrase.Frase.length == 0;
                    return disabled;
                };

                $scope.removerUraIntencaoFraseEdit = function (index) {
                    if ($scope.intencaoEdit.UraIntencaoFrase && $scope.intencaoEdit.UraIntencaoFrase.length > 0) {
                        $scope.indexUraIntencaoFrase = -1;
                        $scope.intencaoEdit.UraIntencaoFrase.splice(index, 1);
                        if ($scope.intencaoEdit.UraIntencaoFrase.length == 0) {
                            $scope.adicionarUraIntencaoFraseEdit(0);
                        }
                    }
                };

                $scope.onChangeUraIntencaoFrase = function (index, uraIntencaoFrase) {

                    if ($scope.intencaoEdit.UraIntencaoFrase) {
                        let itens = $scope.intencaoEdit.UraIntencaoFrase.filter(item => item.Frase == uraIntencaoFrase.Frase);
                        uraIntencaoFrase.fraseRepetida = itens.length > 1 ? true : false;
                        $scope.FraseRepetida = uraIntencaoFrase.fraseRepetida;
                    }

                    if (uraIntencaoFrase.Frase.length == 0 &&
                        $scope.intencaoEdit.UraIntencaoFrase.length > 1 &&
                        $scope.intencaoEdit.UraIntencaoFrase.length != index + 1) {
                        $scope.removerUraIntencaoFraseEdit(index);
                    }
                }

                //#endregion Editar Frase

                //#region Editar intencao

                $scope.salvarIntencao = function () {

                    $scope.formUraIntencaoEdit.$setSubmitted();

                    if (!$scope.formUraIntencaoEdit.$valid) {
                        return NotifyService.showInvalid();
                    }

                    ModalService.showLoading();

                    if ($scope.isNew) {
                        UraIntencaoResource.cadastrarIntencao($scope.intencaoEdit).$promise
                            .then(() => {
                                ModalService.hideLoading();
                                NotifyService.showRegistroSalvo();
                                $scope.goListIntencoes();
                                if (window.opener) {
                                    window.opener.postMessage('atualizarIntencoes', window.opener.document.URL);
                                }
                            }).catch((error) => {
                                ModalService.hideLoading();
                                let msgError = $scope.builderAlertError(error, $translate.instant('telaUraIntencaoEdit.erroAtualizar'), $translate.instant('telaUraIntencaoEdit.falhaAtualizar'));
                                ModalService.alert(msgError);
                            });
                    }
                    else {
                        UraIntencaoResource.editarIntencao($scope.intencaoEdit).$promise
                            .then(() => {
                                ModalService.hideLoading();
                                NotifyService.showRegistroSalvo();
                                $scope.goListIntencoes();
                            }).catch((error) => {
                                ModalService.hideLoading();
                                let msgError = $scope.builderAlertError(error, $translate.instant('telaUraIntencaoEdit.erroSalvar'), $translate.instant('telaUraIntencaoEdit.falhaSalvar'));
                                ModalService.alert(msgError);
                            });
                    }
                }

                $scope.disableAdicionaAtualizaIntencao = function () {
                    let disabled = true;

                    if (!$scope.FraseRepetida) {
                        // Novo registro
                        if ($scope.isNew) {
                            disabled = !UraHelper.isPropValid($scope.intencaoEdit.Nome) ||
                                !UraHelper.isPropValid($scope.intencaoEdit.CarteiraId) ||
                                !UraHelper.isPropValid($scope.intencaoEdit.UraIntencaoFrase[$scope.indexUraIntencaoFrase].Frase) ||
                                $scope.intencaoEdit.UraIntencaoFrase[$scope.indexUraIntencaoFrase].Frase.length == 0 ||
                                $scope.intencaoEdit.CarteiraId == 0;
                        }
                        // Editando Intencao
                        else {

                            // Está adicionado uma nova frase?
                            if ($scope.indexUraIntencaoFrase > 0 &&
                                $scope.intencaoEdit.UraIntencaoFrase.length == ($scope.indexUraIntencaoFrase + 1)) {
                                disabled = $scope.intencaoEdit.UraIntencaoFrase[$scope.indexUraIntencaoFrase].Frase == null ||
                                    $scope.intencaoEdit.UraIntencaoFrase[$scope.indexUraIntencaoFrase].Frase.length == 0;
                            }
                            else if ($scope.intencaoEdit.UraIntencaoFrase.length > 0 && $scope.intencaoEdit.UraIntencaoFrase[0].Frase) {
                                disabled = UraHelper.objectsIsEqual($scope.intencao, $scope.intencaoEdit, 0);
                            }
                        }
                    }

                    return disabled;
                }

                $scope.cancelarEditIntencao = function () {
                    $scope.goListIntencoes();
                }

                $scope.goListIntencoes = function () {
                    $state.go('main.uraIntencao.list');
                }

                $scope.builderAlertError = function (error, titulo, messageDefault) {
                    let possuiError = false;
                    let msgError = `<h3>${titulo}</h3>`
                    if (error &&
                        error.data &&
                        error.data.ModelState &&
                        error.data.ModelState.Intencao) {
                        let listIntencao = error.data.ModelState.Intencao;
                        let limite = listIntencao.length < 10 ? listIntencao.length : 10;
                        for (var index = 0; index < limite; index++) {
                            msgError = msgError.concat('<br>', listIntencao[index]);
                            possuiError = true;
                        }
                    }
                    if (!possuiError) {
                        msgError.concat('<br><br>', messageDefault);
                    }
                    return msgError;
                }


                //#endregion Editar intencao

                //#region Importar Arquivo

                $scope.uploadFiles = function (files, errFiles) {

                    if (files.length == 0 && errFiles.length == 0) return;
                    ModalService.showLoading();
                    angular.forEach(files, function (file) {
                        file.upload = Upload.upload({
                            url: $scope.urlUpload,
                            data: {
                                file: file,
                                nome: file.name
                            }
                        });

                        file.upload
                            .then((response) => {

                                let lenData = response.data.length;
                                let indexProxIntencaoFrase = $scope.intencaoEdit.UraIntencaoFrase.length;
                                $scope.importandoArquivo = true;
                                response.data.forEach((frase, index) => {

                                    if (frase && frase.length > 0) {

                                        let itens = $scope.intencaoEdit.UraIntencaoFrase.filter(item => item.Frase == frase);
                                        if (itens.length == 0) {
                                            $scope.adicionarUraIntencaoFraseEdit(indexProxIntencaoFrase, frase);
                                            indexProxIntencaoFrase = $scope.intencaoEdit.UraIntencaoFrase.length;
                                        }
                                    }

                                    // é o último elemento
                                    if (index == lenData - 1) {
                                        $scope.importandoArquivo = false;
                                        ModalService.hideLoading();

                                        let drEvent = $('.dropify').dropify();
                                        drEvent = drEvent.data('dropify');
                                        drEvent.resetPreview();
                                        drEvent.clearElement();
                                    }
                                });
                            })
                            .catch((error) => {
                                ModalService.hideLoading();

                                let drEvent = $('.dropify').dropify();
                                drEvent = drEvent.data('dropify');
                                drEvent.resetPreview();
                                drEvent.clearElement();

                                let msgError = $scope.builderAlertError(error, $translate.instant('telaUraIntencaoEdit.erroImportarArquivo'), $translate.instant('telaUraIntencaoEdit.falhaImportarArquivo'));
                                ModalService.alert(msgError);
                            });
                    });
                }

                //#endregion Importar Arquivo

            }])
})();
(function () {
    "use strict";

    var defaultPageIndex = 1;

    var getOdataSearchShared = function (UraIntencaoResource) {
        var odata = UraIntencaoResource.odata();
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.uraIntencao", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.uraIntencao.list',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.uraIntencao.list", StateResolverProvider.configState("/UraIntencao", "UraIntencao", "List", {
                    pageTitle: 'telaUraIntencao.titulo',
                    pageName: 'pageTitle.pesquisar',
                    //css: true,
                    //cssFiles: ['app/pages/uraIntencao/style/edit.css']
                }))
        }])
        .service("UraIntencaoListData", function UraIntencaoListData() {
            return function () {
                return {
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }]
                };
            };
        })
        .controller("UraIntencaoListController",
            ["$scope", "$translate", "$window", "UraIntencaoResource", "ModalService", "NotifyService", "carteiras", function (
                $scope,
                $translate,
                $window,
                UraIntencaoResource,
                ModalService,
                NotifyService,
                carteiras
            ) {

                //#region inicializacao

                $scope.intencoes = [];
                $scope.forms = [];
                $scope.carteiras = carteiras;

                $scope.searching = false;

                let filtro = JSON.parse($window.sessionStorage.getItem("FiltroUraIntencao"));
                $scope.search = filtro ? filtro : {};

                $scope.orderBy = {
                    column: "UraIntencaoId",
                    order: "asc"
                };

                $scope.ativoList = [
                    { 'Valor': true, 'Nome': $translate.instant('status.ativo') },
                    { 'Valor': false, 'Nome': $translate.instant('status.inativo') }
                ];

                var updateIntencoes = function (intencoes) {
                    $scope.intencoes = angular.copy(intencoes);
                    $scope.intencoes.forEach(intencao => {
                        let nomeCarteira = '---';
                        let carteira = $scope.carteiras.find(cart => cart.Id == $scope.search.CarteiraId );
                        if (carteira) {
                            nomeCarteira = carteira.Nome;
                        }
                        else {
                            nomeCarteira = '---';
                        }
                        intencao.NomeCarteira = nomeCarteira;
                    });

                    // Paginação
                    $scope.intencoes.recordCount = intencoes.$recordCount || intencoes.length;
                    $scope.currentPage = intencoes.$currentPage || 1;
                    $scope.intencoes.pageSize = intencoes.$pageSize || 10;

                    $scope.searching = false;
                    $window.sessionStorage.setItem('FiltroUraIntencao', JSON.stringify($scope.search));
                    ModalService.hideLoading();
                };

                //#endregion inicializacao

                //#region paginação

                var getOdataSearch = function () {
                    return getOdataSearchShared(UraIntencaoResource);
                };

                $scope.pageChanged = function (newPage) {

                    if (defaultPageIndex != newPage) {

                        defaultPageIndex = newPage;
                        $scope.searching = true;
                        ModalService.showLoading();

                        return getOdataSearch()
                            .page($scope.intencoes.pageSize, 1)
                            .query({
                                StatusId: $scope.search.StatusId,
                                Nome: $scope.search.Nome,
                                CarteiraId: $scope.search.CarteiraId
                            }).
                            then(updateIntencoes).catch(() => {
                                NotifyService.showError;
                                ModalService.hideLoading();
                            });
                    }
                };

                //#endregion paginação

                //#region pesquisa

                $scope.executeSearch = function () {

                    $scope.searching = true;
                    defaultPageIndex = 1;

                    // Default pesquisar carteira Padrão
                    if ($scope.search.CarteiraId == undefined) {
                        $scope.search.CarteiraId = 1;
                    }
                    // e as intenções integradas
                    if ($scope.search.StatusId == undefined) {
                        $scope.search.StatusId = 2;
                    }

                    // Nome em branco, consideramos null
                    if ($scope.search.Nome != null &&
                        $scope.search.Nome != undefined &&
                        $scope.search.Nome.length == 0) {
                        $scope.search.Nome = null;
                    }

                    ModalService.showLoading();
                    getOdataSearch()
                        .page($scope.search.pageSize, 1)
                        .query({
                            StatusId: $scope.search.StatusId,
                            Nome: $scope.search.Nome,
                            CarteiraId: $scope.search.CarteiraId
                        }).
                        then(updateIntencoes).catch(() => {
                            NotifyService.showError;
                            ModalService.hideLoading();
                        });
                };

                $scope.limparFiltro = function () {
                    $window.sessionStorage.removeItem('FiltroUraIntencao');
                    $scope.search = {
                        pageSize: 10
                    };
                    $scope.intencoes = [];
                    $scope.search.CarteiraId = undefined;
                    $scope.search.StatusId = undefined;
                };

                //#endregion pesquisa

                //#region ações

                $scope.confirmExclusaoIntencao = function (intencao) {
                    ModalService.confirmDelete(() => excluirIntencao(intencao));
                }

                var excluirIntencao = function (intencao) {
                    ModalService.showLoading();
                    return UraIntencaoResource
                        .excluirIntencao({ id: intencao.Id })
                        .$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            ModalService.hideLoading();
                            $scope.executeSearch();
                        })
                        .catch((error) => {
                            ModalService.hideLoading();
                            let msgError = $scope.builderAlertError(error, $translate.instant('telaUraIntencao.erroExcluir'), $translate.instant('telaUraIntencao.falhaExcluir'));
                            ModalService.alert(msgError);
                        });
                };

                //#endregion ações

                //#region utils

                $scope.builderAlertError = function (error, titulo, messageDefault) {
                    let possuiError = false;
                    let msgError = `<h3>${titulo}</h3>`
                    if (error &&
                        error.data &&
                        error.data.ModelState &&
                        error.data.ModelState.Intencao) {
                        let listIntencao = error.data.ModelState.Intencao;
                        let limite = listIntencao.length < 10 ? listIntencao.length : 10;
                        for (var index = 0; index < limite; index++) {
                            msgError = msgError.concat('<br>', listIntencao[index]);
                            possuiError = true;
                        }
                    }
                    if (!possuiError) {
                        msgError.concat('<br><br>', messageDefault);
                    }
                    return msgError;
                }

                //#endregion utils

                //#region startup pagina

                // Inicia a pesquisa assim que carregar a página!
                $scope.executeSearch();

                //#endregion startup pagina
            }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UraIntencaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "UraIntencao/GetIntencoes",
                {
                    "UraIntencaoId": "@UraIntencaoId"
                },
                {
                    getById: {
                        url: "UraIntencao/GetById",
                        method: "Get",
                    },
                    getIntencoes: {
                        url: "UraIntencao/GetIntencoes",
                        method: "Get",
                        isArray: true
                    },
                    editarIntencao: {
                        url: "UraIntencao/Put",
                        method: "Put",
                    },
                    cadastrarIntencao: {
                        url: "UraIntencao/Post",
                        method: "Post",
                    },
                    excluirIntencao: {
                        url: "UraIntencao/Excluir",
                        method: "Get",
                    },
                    getIntencoesByCarteira: {
                        url: "UraIntencao/GetIntencoesByCarteira",
                        method: "Get",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.uraProvedor.new", StateResolverProvider.configState("/UraProvedor/new?page", "UraProvedor", "Edit", {
                    pageTitle: 'telaUraProvedor.titulo',
                    pageName: 'acoes.cadastrar'
                }))
                .state("main.uraProvedor.edit", StateResolverProvider.configState("/UraProvedor/{Id:[0-9]+}", "UraProvedor", "Edit", {
                    pageTitle: 'telaUraProvedor.titulo',
                    pageName: 'acoes.editar'
                }))
        }])
        .service('UraProvedorEditData', function PesquisaEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_ionRangeSlider',
                            'lazy_jsoneditor'
                        ]);
                    }],
                    provedor: ["UraProvedorResource", "$stateParams", function (UraProvedorResource, $stateParams) {
                        // Iniciamos o objeto com o DTO da API
                        if (!$stateParams.Id) {
                            $stateParams.Id = 0;
                        }
                        return UraProvedorResource.getById({ Id: $stateParams.Id }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }]
                }
            }
        })
        .controller("UraProvedorEditController",
            ["$scope", "$translate", "$state", "provedor", "NotifyService", "UraProvedorResource", "ModalService", "UraHelper", "carteiras", function (
                $scope,
                $translate,
                $state,
                provedor,
                NotifyService,
                UraProvedorResource,
                ModalService,
                UraHelper,
                carteiras) {

                //#region inicializacao
                
                // Dados do provedor
                $scope.provedor = angular.copy(provedor);
                $scope.isNew = provedor.Id > 0 ? false : true;
                
                // Formulário da página
                $scope.forms = {};

                // Carteiras disponiveis
                $scope.carteiras = carteiras;

                // Armazenamento temporário
                // do campo provedor em
                // edição
                $scope.campoProvedorEdit = {};

                // Utilizado para comparar se houve
                // Alterações ao editar o campo do
                // provedor
                $scope.campoProvedorEditBackup = {};

                // Se botão de cancelar 
                // está visivel ou não
                // em casode edição do
                // campo do provedor
                $scope.showBtnCancelar = true;

                // Flags para uso geral
                $scope.utils = {
                    duplicateNomeCampoProvedor: false,
                    direcaoCampoProvedorId: null,
                    editCampoProvedor: false,
                    tipoCampoProvedorId: null
                };

                // Constantes

                // Gerais
                $scope.constantes = {
                    campoEnvio: 1,
                    campoRetorno: 2,
                    adicionar: 1,
                    atualizar: 2,
                }

                // TipoProvedor
                $scope.cteTipoProvedor = {
                    api: 1
                }

                // Metodo Envio
                $scope.cteMetodoEnvio = {
                    get: 1,
                    post: 2
                }

                // Metodo Login
                $scope.cteMetodoLogin = {
                    get: 1,
                    post: 2,
                    put: 3,
                    patch: 4
                }

                // Grant Type
                $scope.cteGrantType = {
                    clienteCredentials: 1,
                    password: 2
                }

                // Tipo Autenticacao Provedor
                $scope.cteTipoAutenticacaoProvedor = {
                    allowAnonymous: 1,
                    basic: 2,
                    corpoMensagem: 3,
                    apiKey: 4,
                    oauth: 5,
                    token: 6
                }

                // Tipo Dados Campo
                $scope.cteTipoDadosCampoProvedor = {
                    data: 1,
                    decimal: 2,
                    numerico: 3,
                    simnao: 4,
                    texto: 5
                }

                // Tipo de Campo
                $scope.cteTipoCampoProvedor = {
                    form: 1,
                    raw: 2
                }

                $scope.newjsonObjCampo = function () {

                    return {
                        nome: null,
                        campoGuid: null,
                        data: {},
                        options: {
                            mode: 'code',
                            modes: ['code', 'text', 'tree', 'view']
                        }
                    };
                };

                //#region listas

                $scope.listTipoProvedor = [
                    { tipoProvedorId: $scope.cteTipoProvedor.api, Descricao: $translate.instant('tipoProvedor.api') }
                ];

                $scope.listMetodoEnvioProvedor = [
                    { metodoEnvioProvedorId: $scope.cteMetodoEnvio.get, Descricao: 'GET' },
                    { metodoEnvioProvedorId: $scope.cteMetodoEnvio.post, Descricao: 'POST' }
                ];

                $scope.listMetodoLogin = [
                    { metodoLoginId: $scope.cteMetodoLogin.get, Descricao: 'GET' },
                    { metodoLoginId: $scope.cteMetodoLogin.post, Descricao: 'POST' },
                    { metodoLoginId: $scope.cteMetodoLogin.put, Descricao: 'PUT' },
                    { metodoLoginId: $scope.cteMetodoLogin.patch, Descricao: 'PATCH' }
                ];

                $scope.listGrantType = [
                    { grantTypeId: $scope.cteGrantType.clienteCredentials, Descricao: 'Cliente Credentials' },
                    { grantTypeId: $scope.cteGrantType.password, Descricao: 'Password' }
                ];

                $scope.listTipoAutenticacaoProvedor = [
                    { tipoAutenticacaoProvedorId: $scope.cteTipoAutenticacaoProvedor.allowAnonymous, Descricao: $translate.instant('tipoAutenticacaoProvedor.allowAnonymous') },
                    //    { tipoAutenticacaoProvedorId: $scope.cteTipoAutenticacaoProvedor.basic, Descricao: $translate.instant('tipoAutenticacaoProvedor.basic') },
                    //    { tipoAutenticacaoProvedorId: $scope.cteTipoAutenticacaoProvedor.corpoMensagem, Descricao: $translate.instant('tipoAutenticacaoProvedor.corpoMensagem') },
                        { tipoAutenticacaoProvedorId: $scope.cteTipoAutenticacaoProvedor.apiKey, Descricao: $translate.instant('tipoAutenticacaoProvedor.apiKey') },
                    //    { tipoAutenticacaoProvedorId: $scope.cteTipoAutenticacaoProvedor.oauth, Descricao: $translate.instant('tipoAutenticacaoProvedor.oauth') },
                    //    { tipoAutenticacaoProvedorId: $scope.cteTipoAutenticacaoProvedor.token, Descricao: $translate.instant('tipoAutenticacaoProvedor.token') }
                ];

                $scope.listTipoDadosCampoProvedor = [
                    { tipoDadosCampoProvedorId: $scope.cteTipoDadosCampoProvedor.data, Descricao: $translate.instant('tipoDeDados.data') },
                    { tipoDadosCampoProvedorId: $scope.cteTipoDadosCampoProvedor.decimal, Descricao: $translate.instant('tipoDeDados.decimal') },
                    { tipoDadosCampoProvedorId: $scope.cteTipoDadosCampoProvedor.numerico, Descricao: $translate.instant('tipoDeDados.numerico') },
                    { tipoDadosCampoProvedorId: $scope.cteTipoDadosCampoProvedor.simnao, Descricao: $translate.instant('tipoDeDados.simnao') },
                    { tipoDadosCampoProvedorId: $scope.cteTipoDadosCampoProvedor.texto, Descricao: $translate.instant('tipoDeDados.texto') }
                ];

                //#endregion listas

                // Autenticação padrão
                if ($scope.isNew) {
                    $scope.provedor.TipoProvedorId = $scope.cteTipoProvedor.api;
                    $scope.provedor.TipoAutenticacaoProvedorId = $scope.cteTipoAutenticacaoProvedor.allowAnonymous;
                }

                // Default são os campos de envio no list
                $scope.utils.direcaoCampoProvedorId = $scope.constantes.campoEnvio;

                // Default campo do tipo form
                $scope.utils.tipoCampoProvedorId = $scope.cteTipoCampoProvedor.form;

                // Editando o json
                $scope.jsonEditData = null;
                // Inicia o template json envio e retorno
                // json dados envio
                $scope.jsonEnvio = $scope.newjsonObjCampo();
                // json dados retorno
                $scope.jsonRetorno = $scope.newjsonObjCampo();
                let setTipoCampoProvedor = function (jsonObj, direcaoCampoProvedorId, tipoCampoProvedorId) {
                    let campo = $scope.provedor.UraProvedorCampo.find(item => item.DirecaoCampoProvedorId == direcaoCampoProvedorId && item.TipoCampoProvedorId == tipoCampoProvedorId);
                    if (campo) {
                        jsonObj.data = JSON.parse(campo.JsonObj);
                        jsonObj.campoGuid = campo.CampoGuid;
                        jsonObj.nome = campo.Nome;
                        jsonObj.options = { mode: 'view', modes: [] };
                        $scope.utils.tipoCampoProvedorId = campo.TipoCampoProvedorId;
                    }
                    else {
                        jsonObj = $scope.newjsonObjCampo();
                    }
                }
                setTipoCampoProvedor($scope.jsonEnvio, $scope.constantes.campoEnvio, $scope.cteTipoCampoProvedor.raw);
                //setTipoCampoProvedor($scope.jsonRetorno, $scope.constantes.campoRetorno, $scope.cteTipoCampoProvedor.raw);

                //#endregion inicializacao

                //#region get Titulo

                $scope.getTituloProvedor = function (tipo) {
                    let titulo = $translate.instant('pageTitle.provedor');
                    if ($scope.provedor) {
                        switch ($scope.provedor.TipoProvedorId) {
                            // Envio API
                            case $scope.cteTipoProvedor:
                                titulo = $scope.constantes.campoEnvio == tipo ?
                                    $translate.instant('telaUraProvedorEdit.provedorEnvioApi') :
                                    $translate.instant('telaUraProvedorEdit.provedorRetornoApi');
                                break;
                        }
                    }
                    return titulo;
                };

                $scope.getTituloEdicao = function () {
                    let acao;
                    if ($scope.utils.editCampoProvedor) {
                        acao = $translate.instant('acoes.editar');
                    }
                    else {
                        acao = $translate.instant('acoes.cadastrar');
                    }
                    return acao;
                };

                //#endregion  get Titulo

                //#region ações

                //#region teste url

                $scope.testarUrl = function () {
                    if ($scope.provedor) {
                        switch ($scope.provedor.TipoProvedorId) {
                            // Envio API
                            case $scope.cteTipoProvedor:
                                $scope.testarApi();
                                break;
                            default:

                                break;
                        }
                    }
                };

                //#endregion teste url

                //#region get set

                $scope.getTituloModalCampo = function () {
                    let titulo = '';
                    if ($scope.utils.direcaoCampoProvedorId == $scope.constantes.campoEnvio) {
                        titulo = $translate.instant('modalCampoProvedor.tituloAddEnvio');
                        if ($scope.utils.editCampoProvedor) {
                            titulo = $translate.instant('modalCampoProvedor.tituloEditEnvio');
                        }
                    }
                    else if ($scope.utils.direcaoCampoProvedorId == $scope.constantes.campoRetorno) {
                        titulo = $translate.instant('modalCampoProvedor.tituloAddRetorno');
                        if ($scope.utils.editCampoProvedor) {
                            titulo = $translate.instant('modalCampoProvedor.tituloEditRetorno');
                        }
                    }
                    return titulo;
                }

                $scope.getSubTituloModalCampo = function () {
                    let titulo = $translate.instant('modalCampoProvedor.subtituloEnvio');
                    if (!$scope.campoProvedorEdit.DirecaoCampoProvedorId == $scope.constantes.campoRetorno) {
                        titulo = $translate.instant('modalCampoProvedor.subtituloRetorno');
                    }
                    return titulo;
                }

                $scope.getUraProvedorCampoId = function (campo) {
                    return campo.Id ? campo.Id : '---';
                }

                $scope.getDescricaoBotaoProvedorCampo = function (campo) {
                    return $scope.utils.editCampoProvedor ? $translate.instant('botao.atualizar') : $translate.instant('botao.adicionar');
                }

                $scope.setNewCampoProvedor = function (campo) {
                    campo.CampoGuid = UraHelper.uuidv4();
                    campo.UraProvedorId = $scope.provedor.Id;
                    campo.DirecaoCampoProvedorId = $scope.utils.direcaoCampoProvedorId;
                    campo.TipoCampoProvedorId = $scope.utils.tipoCampoProvedorId;
                }

                $scope.setCampoProvedor = function (tipoAcao) {
                    if ($scope.campoProvedorEdit.Nome) {
                        // To LowerCase
                        $scope.campoProvedorEdit.Nome = $scope.campoProvedorEdit.Nome.toLowerCase();
                        let campo = angular.copy($scope.campoProvedorEdit);
                        // Editando campo
                        if ($scope.utils.editCampoProvedor) {
                            let index = $scope.provedor.UraProvedorCampo.map(item => item.Id).indexOf(campo.Id);
                            if (index > -1) {
                                $scope.provedor.UraProvedorCampo.splice(index, 1);
                                $scope.provedor.UraProvedorCampo.push(campo);
                            }
                            else {
                                $scope.exibirDetalhe($translate.instant('modalCampoProvedor.atualizarCampo'), $translate.instant('modalCampoProvedor.erroAtualizarCampo'));
                                return;
                            }
                        }
                        // Novo campo
                        else {
                            $scope.setNewCampoProvedor(campo);
                            $scope.provedor.UraProvedorCampo.push(campo);
                        }
                    }
                    switch (tipoAcao) {
                        case $scope.constantes.adicionar:
                            $scope.resetCampoProvedor();
                            break;
                        case $scope.constantes.atualizar:
                            $scope.fecharCampoProvedor();
                            break;
                    }
                }

                $scope.getListCampos = function (direcaoCampoProvedorId, tipoCampoProvedorId) {
                    let result = [];
                    if ($scope.provedor.UraProvedorCampo &&
                        $scope.provedor.UraProvedorCampo.length > 0) {
                        result = $scope.provedor.UraProvedorCampo.filter(item => item.DirecaoCampoProvedorId == direcaoCampoProvedorId && item.TipoCampoProvedorId == tipoCampoProvedorId);
                    }
                    return result;
                }

                $scope.getTipoDadoCampoProvedor = function (campo) {
                    let descricao = '---';
                    let item = $scope.listTipoDadosCampoProvedor.find(item => item.tipoDadosCampoProvedorId == campo.TipoDadosCampoProvedorId);
                    if (item != undefined) {
                        descricao = item.Descricao;
                    }
                    return descricao;
                }

                $scope.setDirecaoCampo = function (direcaoCampoProvedorId) {
                    $scope.utils.direcaoCampoProvedorId = direcaoCampoProvedorId;
                }

                $scope.setTipoCampoProvedor = function (jsonObj, direcaoCampoProvedorId, tipoCampoProvedorId) {

                    // Editação
                    if (!$scope.isNew &&
                        $scope.provedor.UraProvedorCampo) {

                        let campo = $scope.provedor.UraProvedorCampo.find(item => item.DirecaoCampoProvedorId == direcaoCampoProvedorId && item.TipoCampoProvedorId == tipoCampoProvedorId);
                        if (campo) {
                            jsonObj.data = JSON.parse(campo.JsonObj);
                            jsonObj.campoGuid = campo.CampoGuid;
                            jsonObj.nome = campo.Nome;
                        }
                        else {
                            jsonObj = $scope.newjsonObjCampo();
                        }
                    }
                    $scope.utils.tipoCampoProvedorId = tipoCampoProvedorId;
                }

                //#endregion get set

                //#region campo provedor

                $scope.editCampoProvedor = function (campo, direcaoCampoProvedorId) {
                    $scope.utils.direcaoCampoProvedorId = null;
                    $scope.utils.duplicateNomeCampoProvedor = false;
                    if (direcaoCampoProvedorId) {
                        $scope.utils.direcaoCampoProvedorId = direcaoCampoProvedorId;
                    }

                    // Editando um campo especifico
                    if (campo != null) {
                        $scope.utils.editCampoProvedor = true;
                        // Armazena os dados em nova area de memória!
                        $scope.campoProvedorEdit = angular.copy(campo);
                        $scope.campoProvedorEditBackup = angular.copy(campo);
                    }
                    else {
                        $scope.utils.editCampoProvedor = false;
                        $scope.campoProvedorEdit = {};
                        $scope.campoProvedorEditBackup = {};
                    }
                    $('#modal_campo_provedor').on();
                    ModalService.openModal('modal_campo_provedor', null, null, { center: false, bgclose: false, keyboard: false });
                };

                $scope.fecharCampoProvedor = function () {
                    $scope.campoProvedorEdit = {};
                    ModalService.closeModal('modal_campo_provedor');
                };

                $scope.resetCampoProvedor = function () {
                    $scope.campoProvedorEdit.Nome = null;
                    $scope.campoProvedorEdit.TipoDadosCampoProvedorId = null;
                };

                $scope.confirmDeleteCampoProvedor = function (campo) {
                    ModalService.confirmDelete(() => $scope.deleteCampoProvedor(campo));
                };

                $scope.deleteCampoProvedor = function (campo) {
                    if (campo && campo.Nome) {
                        let index = $scope.provedor.UraProvedorCampo.findIndex(item => item.Nome == campo.Nome && item.DirecaoCampoProvedorId == $scope.utils.direcaoCampoProvedorId);
                        if (index > -1) {
                            $scope.provedor.UraProvedorCampo.splice(index, 1);
                        }
                    }
                };

                $scope.disableAdicionarCampoProvedor = function () {
                    return !$scope.campoProvedorEdit.Nome ||
                        $scope.utils.duplicateNomeCampoProvedor ||
                        ($scope.utils.editCampoProvedor && UraHelper.compareObjExt($scope.campoProvedorEditBackup, $scope.campoProvedorEdit)) ||
                        ($scope.utils.direcaoCampoProvedorId == $scope.constantes.campoRetorno && $scope.campoProvedorEdit.TipoDadosCampoProvedorId == undefined);
                }

                $scope.isDuplicateNomeCampoProvedor = function (campo, tipoCampoProvedorId) {
                    let isObjectPresent = [];
                    $scope.utils.duplicateNomeCampoProvedor = false;
                    if (campo && campo.Nome) {
                        let list = $scope.getListCampos($scope.utils.direcaoCampoProvedorId, tipoCampoProvedorId);
                        if (list) {
                            // NOVO CAMPO
                            if (!$scope.utils.editCampoProvedor) {
                                isObjectPresent = list.find(item => item.Nome == campo.Nome);
                                $scope.utils.duplicateNomeCampoProvedor = isObjectPresent ? true : false;
                            }
                            // EDITANDO UM CAMPO
                            else {
                                isObjectPresent = list.find(item => item.Nome == campo.Nome && item.Id != campo.Id);
                                $scope.utils.duplicateNomeCampoProvedor = isObjectPresent ? true : false;
                            }
                        }
                    }
                    return $scope.utils.duplicateNomeCampoProvedor;
                }

                $scope.saveCampoProvedorRaw = function (jsonObj) {

                    let jsonData = null;
                    // Remove se existir e depois atualiza
                    let campo = $scope.removeCampoRawProvedor(jsonObj.campoGuid);
                    // novo campo
                    if (!campo) {
                        campo = angular.copy($scope.campoProvedorEdit);
                        $scope.setNewCampoProvedor(campo);
                    }
                    // Atualiza o campo atual
                    jsonData = JSON.stringify(jsonObj.data);
                    campo.Nome = jsonObj.nome;
                    campo.JsonObj = jsonData;
                    $scope.provedor.UraProvedorCampo.push(campo);
                    jsonObj.campoGuid = campo.CampoGuid;
                    jsonObj.options = { mode: 'view', modes: [] };
                    $scope.jsonEditData = null;
                }

                $scope.updateNomeCampoRaw = function (jsonObj) {

                    if (jsonObj.campoGuid) {
                        let campo = $scope.provedor.UraProvedorCampo.find(elem => elem.CampoGuid == jsonObj.campoGuid);
                        if (campo) {
                            campo.Nome = jsonObj.nome;
                            let index = $scope.provedor.UraProvedorCampo.map(item => item.Id).indexOf(campo.Id);
                            if (index > -1) {
                                $scope.provedor.UraProvedorCampo.splice(index, 1);
                                $scope.provedor.UraProvedorCampo.push(campo);
                            }
                        }
                    }
                }

                $scope.editarCampoProvedorRaw = function (jsonObj) {

                    if (jsonObj) {
                        $scope.jsonEditData = angular.copy(jsonObj.data);
                        jsonObj.options = { mode: 'code', modes: ['code', 'text', 'tree', 'view'] };
                    }
                }

                $scope.cancelarEditCampoProvedorRaw = function (jsonObj) {

                    if (jsonObj) {
                        jsonObj.options = { mode: 'view', modes: [] };
                        $scope.jsonEditData = null;
                    }
                }

                $scope.removeCampoRawProvedor = function (campoGuid) {

                    let campo = $scope.provedor.UraProvedorCampo.find(elem => elem.CampoGuid == campoGuid);
                    if (!campo) {
                        $scope.exibirDetalhe($translate.instant('modalCampoProvedor.atualizarCampo'), $translate.instant('modalCampoProvedor.erroAtualizarCampo'));
                        return null;
                    }
                    campo.JsonObj = null;
                    let index = $scope.provedor.UraProvedorCampo.map(item => item.Id).indexOf(campo.Id);
                    if (index > -1) {
                        $scope.provedor.UraProvedorCampo.splice(index, 1);
                    }
                    else {
                        $scope.exibirDetalhe($translate.instant('modalCampoProvedor.atualizarCampo'), $translate.instant('modalCampoProvedor.erroAtualizarCampo'));
                        return null;
                    }
                    return campo;
                }

                $scope.hasjsonData = function (jsonObj) {

                    let jsonData = JSON.stringify(jsonObj.data);
                    let jsonEditData = JSON.stringify($scope.jsonEditData);
                    return jsonData != jsonEditData;
                }

                $scope.IsjsonSave = function (jsonObj) {

                    let ret = false;
                    //let campo = $scope.provedor.UraProvedorCampo.find(elem => elem.CampoGuid == jsonObj.campoGuid);
                    //if (campo) {
                    //    ret = true;
                    //}
                    ret = jsonObj.options.mode == 'view';
                    return ret;
                }

                $scope.onChangeProvedorId = function ($event) {
                    switch ($scope.provedor.MetodoEnvioProvedorId) {
                        case 1:
                            $scope.provedor.MetodoEnvioProvedorIdChange = 1;
                            break;
                        case 2:
                            $scope.provedor.MetodoEnvioProvedorIdChange = 2;
                            break;
                        default:
                            $scope.provedor.MetodoEnvioProvedorIdChange = 1;
                            break;
                    }
                    //$scope.provedor.MetodoEnvioProvedorIdChange = $scope.provedor.MetodoEnvioProvedorId;
                    //let index = 0;
                    //let element;
                    //$scope.provedor.MetodoEnvioProvedorId = $scope.cteMetodoEnvio.post;
                    //switch ($scope.provedor.MetodoEnvioProvedorId) {
                    //    case $scope.cteMetodoEnvio.get:
                    //        element = 'tabCamposFormEnvio';
                    //        break;
                    //    case $scope.cteMetodoEnvio.post:
                    //        element = 'tabCamposRawEnvio';
                    //        break;
                    //    default:
                    //        return;
                    //}


                   // UIkit.tab(element).show(index);
                }

                //#endregion campo provedor

                //#region provedor

                $scope.salvarProvedor = function () {
                    if (!$scope.isValidForm()) {
                        return NotifyService.showInvalid();
                    }

                    ModalService.showLoading();

                    // Salva apenas o tipo de campo get / post
                    let uraProvedorCampo = $scope.provedor.UraProvedorCampo.filter(item => item.TipoCampoProvedorId == $scope.utils.tipoCampoProvedorId);
                    if (uraProvedorCampo && uraProvedorCampo.length > 0) {
                        $scope.provedor.UraProvedorCampo = angular.copy(uraProvedorCampo);
                    }

                    if ($scope.isNew) {
                        UraProvedorResource.cadastrarProvedor($scope.provedor).$promise
                            .then(() => {
                                ModalService.hideLoading();
                                NotifyService.showRegistroSalvo();
                                $scope.goListProvedores();
                            }).catch((ex) => {
                                ModalService.hideLoading();
                                NotifyService.showError(ex);
                            });
                    }
                    else {
                        UraProvedorResource.editarProvedor($scope.provedor).$promise
                            .then(() => {
                                ModalService.hideLoading();
                                NotifyService.showRegistroSalvo();
                                $scope.goListProvedores();
                            }).catch((ex) => {
                                ModalService.hideLoading();
                                NotifyService.showError(ex);
                            });
                    }
                };

                $scope.cancelarProvedor = function () {
                    $scope.goListProvedores();
                };

                $scope.goListProvedores = function () {
                    $state.go('main.uraProvedor.list');
                }

                //#endregion provedor

                //#endregion ações

                //#region show compenent

                $scope.showTestarUrl = function () {
                    let show = false;

                    let isValidUrl = $scope.isValidUrl($scope.provedor.UrlEnvioProvedor);

                    show = $scope.provedor &&
                        $scope.provedor.TipoProvedorId &&
                        $scope.provedor.MetodoEnvioProvedorId &&
                        isValidUrl;
                    return show;
                };

                $scope.showAutenticacao = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.basic ||
                            $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.apiKey ||
                            $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth ||
                            $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.token;
                    }
                    return show;
                };

                $scope.showApiKey = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.apiKey;
                    }
                    return show;
                };

                $scope.showUsuario = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.basic ||
                            $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showSenha = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.basic ||
                            $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showUrlLogin = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showToken = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth ||
                            $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.token;
                    }
                    return show;
                };

                $scope.showMetodoLogin = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showGrantType = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showUsuarioOauth = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showSenhaOauth = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showClientId = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showClientSecret = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showScope = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.oauth;
                    }
                    return show;
                };

                $scope.showPropriedadeUrlToken = function () {
                    let show = false;
                    if ($scope.provedor) {
                        show = $scope.provedor.TipoAutenticacaoProvedorId == $scope.cteTipoAutenticacaoProvedor.token;
                    }
                    return show;
                };

                $scope.showListCampoProvedor = function (direcaoCampoProvedorId) {
                    let show = false;
                    let list = $scope.getListCampos(direcaoCampoProvedorId, $scope.utils.tipoCampoProvedorId);
                    show = list && list.length > 0;
                    return show;
                };

                //#endregion show compenent

                //#region teste url

                $scope.testarApi = function () {
                    try {

                        let isValidUrl = $scope.isValidUrl($scope.provedor.UrlEnvioProvedor);
                        if (!$scope.provedor.MetodoEnvioProvedorId || !isValidUrl) {
                            ModalService.alert($translate.instant('telaUraProvedorEdit.testeApiConfigErro'));
                            return;
                        }

                        ModalService.showLoading();

                        UraProvedorResource.testarApi({
                            MetodoEnvioProvedorId: $scope.provedor.MetodoEnvioProvedorId,
                            UrlEnvioProvedor: provedor.UrlEnvioProvedor
                        }).$promise.then(() => {
                            ModalService.alert($translate.instant('telaUraProvedorEdit.testeApiOk'));
                            ModalService.hideLoading();
                        }).catch((erro) => {
                            let msg = "";
                            if (erro.data && erro.data.Message) {
                                msg = erro.data.Message;
                            }
                            ModalService.alert($translate.instant('telaUraProvedorEdit.testeApiErro') + ' ' + msg);
                            ModalService.hideLoading();
                        });

                    } catch (error) {
                        ModalService.hideLoading();
                        NotifyService.showError(error, $translate.instant('telaUraProvedorEdit.testeApiErro'));
                    }
                }

                //#endregion teste url

                //#region utils

                $scope.isValidForm = function () {
                    let valid = true;
                    if (!$scope.forms.formDetalhes.$valid) {
                        valid = false;
                    }
                    return valid;
                }

                $scope.isValidUrl = function (urlString) {
                    let urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
                        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
                        '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
                        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
                        '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
                        '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator

                    return !!urlPattern.test(urlString);
                }

                $scope.exibirDetalhe = function (titulo, descricao) {
                    ModalService.alert(`<h3>${titulo}</h3>${descricao}`);
                };

                //#endregion utils

            }])
})();
(function () {
    "use strict";

    var defaultPageIndex = 1;

    var getOdataSearchShared = function (UraProvedorResource) {
        var odata = UraProvedorResource.odata();
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.uraProvedor", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.uraProvedor.list',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.uraProvedor.list", StateResolverProvider.configState("/UraProvedor", "UraProvedor", "List", {
                    pageTitle: 'telaUraProvedor.titulo',
                    pageName: 'pageTitle.pesquisar',
                    css: true,
                    cssFiles: ['app/pages/uraProvedor/style/edit.css']
                }))
        }])
        .service("UraProvedorListData", function UraProvedorListData() {
            return function () {
                return {
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }]
                };
            };
        })
        .controller("UraProvedorListController",
            ["$scope", "$translate", "$window", "UraProvedorResource", "ModalService", "LocalStorageService", "NotifyService", "carteiras", function (
                $scope,
                $translate,
                $window,
                UraProvedorResource,
                ModalService,
                LocalStorageService,
                NotifyService,
                carteiras
            ) {

                //#region inicializacao

                $scope.provedores = [];
                $scope.forms = [];
                $scope.carteiras = carteiras;

                $scope.searching = false;

                let filtro = JSON.parse($window.sessionStorage.getItem("FiltroUraProvedor"));
                $scope.search = filtro ? filtro : {};
                
                $scope.orderBy = {
                    column: "UraProvedorId",
                    order: "asc"
                };

                $scope.ativoList = [
                    { 'Valor': true, 'Nome': $translate.instant('status.ativo') },
                    { 'Valor': false, 'Nome': $translate.instant('status.inativo') }
                ];

                var updateProvedores = function (provedores) {
                    $scope.provedores = provedores;
                    $scope.provedores.recordCount = provedores.$recordCount || provedores.length;
                    $scope.currentPage = provedores.$currentPage || 1;
                    $scope.provedores.pageSize = provedores.$pageSize || 10;
                    $scope.searching = false;
                    $window.sessionStorage.setItem('FiltroUraProvedor', JSON.stringify($scope.search));
                    ModalService.hideLoading();
                };

                //#endregion inicializacao

                //#region titulos

                $scope.getTitleAtivarInativar = function (provedor) {
                    let title = $translate.instant('acoes.inativar');
                    if (!provedor.Ativo) {
                        title = $translate.instant('acoes.ativar');
                    }
                    return title;
                };

                //#endregion titulos

                //#region paginação

                var getOdataSearch = function () {
                    return getOdataSearchShared(UraProvedorResource);
                };

                $scope.pageChanged = function (newPage) {

                    if (defaultPageIndex != newPage) {

                        defaultPageIndex = newPage;
                        $scope.searching = true;
                        ModalService.showLoading();

                        return getOdataSearch()
                            .page($scope.provedores.pageSize, 1)
                            .query({
                                Nome: $scope.search.Nome,
                                Ativo: $scope.search.Ativo,
                                CarteiraId: $scope.search.CarteiraId
                            }).
                            then(updateProvedores).catch(() => {
                                NotifyService.showError;
                                ModalService.hideLoading();
                            });
                    }
                };

                //#endregion paginação

                //#region pesquisa

                $scope.executeSearch = function () {

                    $scope.searching = true;
                    defaultPageIndex = 1;

                    // Default pesquisar os ativos
                    if ($scope.search.Ativo == undefined) {
                        $scope.search.Ativo = true;
                    }

                    // Default pesquisar os ativos
                    if ($scope.search.CarteiraId == undefined) {
                        $scope.search.CarteiraId = 1;
                    }

                    // Nome em branco, consideramos null
                    if ($scope.search.Nome != null &&
                        $scope.search.Nome != undefined &&
                        $scope.search.Nome.length == 0) {
                        $scope.search.Nome = null;
                    }

                    ModalService.showLoading();
                    getOdataSearch()
                        .page($scope.search.pageSize, 1)
                        .query({
                            Nome: $scope.search.Nome,
                            Ativo: $scope.search.Ativo,
                            CarteiraId: $scope.search.CarteiraId
                        }).
                        then(updateProvedores).catch(() => {
                            NotifyService.showError;
                            ModalService.hideLoading();
                        });
                };

                $scope.limparFiltro = function () {
                    $window.sessionStorage.removeItem('FiltroUraProvedor');
                    $scope.search = {
                        pageSize: 10
                    };
                    $scope.provedores = [];
                    $scope.search.Ativo = undefined;
                    $scope.search.CarteiraId = undefined;
                };

                //#endregion pesquisa

                //#region ações

                $scope.confirmAtivarInativarProvedor = function (provedor) {
                    if (provedor.Ativo) {
                        ModalService.confirmInativar(() => inativarProvedor(provedor));
                    }
                    else {
                        ModalService.confirmReativar(() => ativarProvedor(provedor));
                    }
                };

                var inativarProvedor = function (provedor) {
                    ModalService.showLoading();
                    return UraProvedorResource
                        .inativarProvedor({ id: provedor.Id })
                        .$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            ModalService.hideLoading();
                            $scope.executeSearch();
                        })
                        .catch((error) => {
                            ModalService.hideLoading();
                            let msgError = $scope.builderAlertError(error, $translate.instant('telaUraProvedor.erroInativarProvedor'), $translate.instant('telaUraProvedor.falhaInativarProvedor'));
                            ModalService.alert(msgError);
                        });
                };

                var ativarProvedor = function (provedor) {
                    ModalService.showLoading();
                    return UraProvedorResource
                        .ativarProvedor({ id: provedor.Id })
                        .$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            ModalService.hideLoading();
                            $scope.executeSearch();
                        })
                        .catch((error) => {
                            NotifyService.showError(error);
                            ModalService.hideLoading();
                        });
                };

                $scope.confirmExclusaoProvedor = function (provedor) {
                    ModalService.confirmDelete(() => excluirProvedor(provedor));
                }

                var excluirProvedor = function (provedor) {
                    ModalService.showLoading();
                    return UraProvedorResource
                        .excluirProvedor({ id: provedor.Id })
                        .$promise
                        .then(() => {
                            NotifyService.showSuccess();
                            ModalService.hideLoading();
                            $scope.executeSearch();
                        })
                        .catch((error) => {
                            ModalService.hideLoading();
                            let msgError = $scope.builderAlertError(error, $translate.instant('telaUraProvedor.erroExcluirProvedor'), $translate.instant('telaUraProvedor.falhaExcluirProvedor'));
                            ModalService.alert(msgError);
                        });
                };

                //#endregion ações

                //#region utils

                $scope.builderAlertError = function (error, titulo, messageDefault) {
                    let possuiError = false;
                    let msgError = `<h3>${titulo}</h3>`
                    if (error &&
                        error.data &&
                        error.data.ModelState &&
                        error.data.ModelState.Provedor) {
                        let listProvedor = error.data.ModelState.Provedor;
                        let limite = listProvedor.length < 10 ? listProvedor.length : 10;
                        for (var index = 0; index < limite; index++) {
                            msgError = msgError.concat('<br>', listProvedor[index]);
                            possuiError = true;
                        }
                    }
                    if (!possuiError) {
                        msgError.concat('<br><br>', messageDefault);
                    }
                    return msgError;
                }

                //#endregion utils

                //#region startup pagina

                // Inicia a pesquisa assim que carregar a página!
                $scope.executeSearch();

                //#endregion startup pagina
            }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UraProvedorResource", ["$odataresource", function ($odataresource) {
            return $odataresource(
                "UraProvedor/GetProvedores",
                {
                    "UraProvedorId": "@UraProvedorId"
                },
                {
                    getById: {
                        url: "UraProvedor/GetById",
                        method: "Get",
                    },
                    testarApi: {
                        url: "UraProvedor/TestarApi",
                        method: "Post"
                    },
                    editarProvedor: {
                        url: "UraProvedor/Put",
                        method: "Put",
                    },
                    cadastrarProvedor: {
                        url: "UraProvedor/Post",
                        method: "Post",
                    },
                    inativarProvedor: {
                        url: "UraProvedor/Inativar",
                        method: "Get",
                    },
                    ativarProvedor: {
                        url: "UraProvedor/Ativar",
                        method: "Get",
                    },
                    getProvedores: {
                        url: "UraProvedor/GetProvedores",
                        method: "Get",
                        isArray: true
                    },
                    getDirecaoCampo: {
                        url: "UraProvedor/GetDirecaoCampo",
                        method: "Get",
                        isArray: true
                    },
                    getVariavelUraAtendimento: {
                        url: "UraProvedor/VariaveisUraAtendimento",
                        method: "GET",
                        isArray: true
                    },
                    getAcoesUra: {
                        url: "UraProvedor/AcoesUra",
                        method: "GET",
                        isArray: true
                    },
                    excluirProvedor: {
                        url: "UraProvedor/Excluir",
                        method: "Get",
                    },
                    getUraProvedorCampo: {
                        url: "UraProvedor/GetUraProvedorCampo",
                        method: "Get",
                        isArray: true
                    },
                    getUraProvedorCampoAtivo: {
                        url: "UraProvedor/GetUraProvedorCampoAtivo",
                        method: "Get",
                        isArray: true
                    }
                });
        }]);
})();

(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .controller("ConfigAudioController", ["$scope", "$translate", "UraResource", "ModalService", "NotifyService", function ($scope, $translate, UraResource, ModalService, NotifyService) {

            $scope.gerarTTSDiretiva = function () {
                ModalService.showLoading();
                UraResource.geraTTS({ Texto: $scope.configAudio.Fraseologia })
                    .$promise
                    .then((data) => {
                        ModalService.hideLoading();

                        $scope.configAudio.ArquivoId = data.UraArquivoId;
                        $scope.configAudio.Arquivo = data;

                        //enviar eventos 
                        $scope.modal = $.UIkit.modal('#modal-tts');
                        $scope.modal.hide();
                        $scope.configAudio = {};
                        //onSuccess(data);

                        $timeout(function () {
                        if ($scope.onSuccess)
                            $scope.$apply(scope.onSuccess(data));
                        })

                    }).catch((ex) => {
                        ModalService.hideLoading();
                        $scope.configAudio = {};
                    });

            }

        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .service('UraSatisfacaoEditData', function UraEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect',
                            'lazy_wizard',
                            'lazy_dropify',
                            'lazy_masked_inputs',
                            'lazy_joint'
                        ]);
                    }],
                    ura: ["UraResource", "$stateParams", function (UraResource, $stateParams) {
                        if ($stateParams.UraId) {
                            return UraResource.get({
                                UraId: $stateParams.UraId
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        var odata = GrupoResource.odata().orderBy("Descricao", "asc");
                        odata.filter("GrupoTipoId", "=", 1);
                        return odata.query();
                    }],
                    servicosNaoAssociados: ["ServicoResource", "$stateParams", function (ServicoResource, $stateParams) {
                        return ServicoResource.getServicoDisponivelAssociarUra({ uraId: $stateParams.UraId || 0 }).$promise;
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    ramais: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "1" }).$promise;
                    }],
                    ramaisPabx: ["RamalResource", function (RamalResource) {
                        return RamalResource.getSimples({ RamalTipoId: "4" }).$promise;
                    }],
                    uras: ["UraResource", function (UraResource) {
                        return UraResource.query().$promise;
                    }],
                    rotaList: ["RotaResource", function (RotaResource) {
                        return RotaResource.query().$promise;
                    }],
                    smsTemplateList: ["SmsTemplateResource", function (SmsTemplateResource) {
                        return SmsTemplateResource.getAll().$promise;
                    }],
                    provedor: ["ConfiguracaoProvedorResource", function (ConfiguracaoProvedorResource) {
                        return ConfiguracaoProvedorResource.getProvedorUraNPS().$promise;
                    }],
                    uraTranscription: ["ConfiguracaoResource", function (ConfiguracaoResource) {
                        return ConfiguracaoResource.getUraTranscription().$promise;
                    }]
                }
            }
        })

        .controller("UraSatisfacaoEditController", ["$scope", "$window", "$state", "ura", "UraResource", "$timeout", "NotifyService", "$translate", "grupos", "ModalService", "servicosNaoAssociados", "carteiras", "ramais", "ramaisPabx", "uras", "rotaList", "smsTemplateList", "provedor", "uraTranscription", "UraHelper", function ($scope, $window, $state, ura, UraResource,
            $timeout, NotifyService, $translate, grupos, ModalService, servicosNaoAssociados, carteiras, ramais,
            ramaisPabx, uras, rotaList, smsTemplateList, provedor, uraTranscription, UraHelper) {
            //*************************
            //		INICIALIZAÇÃO
            //*************************

            $scope.listProvedores = provedor;
            $scope.carteiras = carteiras;
            $scope.isNew = ura.UraId > 0 ? false : true;
            $scope.ura = angular.copy(ura);
            $scope.preview = null;
            $scope.previewMenu = [];
            $scope.ura.PossuiMenu = true;
            $scope.limparMenuFile = false;
            $scope.arquivoAudio = {};
            $scope.arquivoAudioMenu = {};
            $scope.forms = {};
            $scope.iconeCor = '#444444'
            $scope.iconeSatisfacao = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z"/></svg>'
            $scope.iconePergunta = '<svg fill="' + $scope.iconeCor + '" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"/></svg>';
            $scope.uraTranscription = uraTranscription;

            /// Definir o número máximo de 
            /// intenções existentes
            /// Atualmente SIM e NÃO
            $scope.maxRespostaIntencao = 2;

            /// Status de cada registro da resposta
            $scope.Novo = 1;
            $scope.Adicionado = 2;
            $scope.Concluido = 3;

            $scope.tiposUra = [
                { TipoId: 10, Descricao: 'satisfacao', Alias: $translate.instant('telaUraSatisfacaoEdit.satisfacao') },
                { TipoId: 11, Descricao: 'pergunta', Alias: $translate.instant('editPergunta.pergunta') }
            ];

            $scope.tiposIntegracao = [
                { UraTipoIntegracaoId: 1, Descricao: "Local Ini" },
                { UraTipoIntegracaoId: 2, Descricao: "Remota TcpIp" },
            ];

            servicosNaoAssociados.forEach((el) => {
                el.Descricao = el.Descricao + " - " + el.Numero;
            });

            $scope.digitoZero = '0';
            $scope.digitoUm = '1';
            $scope.digitoDois = '2';
            $scope.digitoTres = '3';
            $scope.digitoQuatro = '4';
            $scope.digitoCinco = '5';
            $scope.digitoSeis = '6';
            $scope.digitoSete = '7';
            $scope.digitoOito = '8';
            $scope.digitoNove = '9';
            $scope.digitoAsterisco = '*';
            $scope.digitoSustenido = '#';
            $scope.qqerSeqDigitos = '?';
            $scope.listDigitoResposta = [];
            $scope.listIntencaoResposta = [];

            $scope.intencaoSim = 'S';
            $scope.intencaoNao = 'N';

            $scope.vozIdDefault = ura.VozId;

            // Acoes da ura
            $scope.enviarSms = 16;
            $scope.finalizarChamada = 17;
            $scope.proximaPergunta = 18;
            $scope.tocarAudio = 19;
            $scope.transferirRamal = 20;
            $scope.transferirTelefone = 21;
            $scope.proximaPerguntaCondicional = 22;
            $scope.listAcoes = [
                //{ AcaoId: $scope.enviarSms, Descricao: $translate.instant('editAcoesUra.enviarSms') },
                { AcaoId: $scope.finalizarChamada, Descricao: $translate.instant('editAcoesUra.finalizarChamada') },
                { AcaoId: $scope.proximaPergunta, Descricao: $translate.instant('editAcoesUra.proximaPergunta') },
                { AcaoId: $scope.tocarAudio, Descricao: $translate.instant('editAcoesUra.tocarAudio') },
                { AcaoId: $scope.transferirRamal, Descricao: $translate.instant('editAcoesUra.transferirRamal') },
                { AcaoId: $scope.transferirTelefone, Descricao: $translate.instant('editAcoesUra.transferirTelefone') },
                { AcaoId: $scope.proximaPerguntaCondicional, Descricao: $translate.instant('editAcoesUra.proximaPerguntaCondicional') },
            ];

            $scope.transferenciaRamal = 1;
            $scope.transferenciaGrupo = 2;
            $scope.transferenciaUra = 3;
            $scope.transferenciaRamalPabx = 4;
            $scope.tiposTransferencia = [
                { TipoId: $scope.transferenciaGrupo, Descricao: "grupo", Alias: $translate.instant('model.grupo') },
                { TipoId: $scope.transferenciaRamal, Descricao: "ramal", Alias: $translate.instant('model.ramal') },
                { TipoId: $scope.transferenciaUra, Descricao: "ura", Alias: $translate.instant('model.ura') },
                { TipoId: $scope.transferenciaRamalPabx, Descricao: "ramalPabx", Alias: $translate.instant('tiposTransferencias.ramalIntegracao') },
            ];

            // Rotas disponíveis
            $scope.rotas = rotaList;

            // Templates SMS
            $scope.smsTemplateList = smsTemplateList;

            $scope.servicosNaoAssociados = servicosNaoAssociados;
            $scope.servicosNaoAssociadosCopia = angular.copy(servicosNaoAssociados);

            // Armazena a resposta temporária
            $scope.uraRespostaEdit = {};
            // Utilizado para comparar se houve
            // Alterações na resposta em caso
            // de edição
            $scope.uraRespostaEditBackup = {};

            // Armazena todas as respostas,
            // após o usuário concluir.
            // atrubuimos para a uraSelecionada.UraResposta
            // $scope.uraSelecionada.UraResposta.push(resposta);
            $scope.uraRespostaTemp = [];
            $scope.uraRespostaTempEdit = [];

            // Perguntas desta ura
            $scope.listPerguntas = [];

            // Qde máxima de dígitos inicia-se em com 2 digitos
            $scope.listQdeMaximaDigitos = [];
            for (var i = 2; i <= 32; i++) {
                $scope.listQdeMaximaDigitos.push({ QuantidadeId: i, Quantidade: i });
            }
            $scope.listMinMaxDigito = [];

            $scope.showBtnCancelar = true;

            $scope.percentualCondicional = false;

            $scope.listPercentual = [];

            $scope.percentualMaximo = 100;

            // Para se utilizado nas listas
            // 
            $scope.utils = {
                percentualSelecionado: 0,
                editandoResposta: false
            };

            ramais.forEach((el) => {
                if (el.UsuarioNome != null) {
                    el.Descricao = el.Numero + " - " + el.UsuarioNome;
                }
                else {
                    el.Descricao = el.Numero;
                }
            });

            // Ramais para transferencia.
            $scope.ramais = ramais;
            $scope.ramaisPabx = ramaisPabx;
            $scope.uras = uras;
            $scope.grupos = grupos;

            $scope.MaxTemposIntencoes = [
                { MaxTempoIntencaoId: 1, Descricao: "2" },
                { MaxTempoIntencaoId: 2, Descricao: "3" },
                { MaxTempoIntencaoId: 3, Descricao: "4" },
                { MaxTempoIntencaoId: 4, Descricao: "5" },
                { MaxTempoIntencaoId: 5, Descricao: "6" },
                { MaxTempoIntencaoId: 6, Descricao: "7" },
                { MaxTempoIntencaoId: 7, Descricao: "8" },
                { MaxTempoIntencaoId: 8, Descricao: "9" }
            ];

            $scope.onChangeCarteira = function () {
                if ($scope.ura.CarteiraId == 0 || $scope.ura.CarteiraId == undefined) {
                    $scope.servicosNaoAssociados = $scope.servicosNaoAssociadosCopia;
                } else {
                    $scope.servicosNaoAssociados = _.filter($scope.servicosNaoAssociadosCopia, function (el) {
                        return el.CarteiraId == $scope.ura.CarteiraId;
                    });
                }
            }

            if ($scope.isNew) {
                $scope.ura.ChildUra = [];
                $scope.ura.RepeteErro = true;
            } else {
                $scope.onChangeCarteira();
                $scope.ura.PossuiMenu = $scope.ura.ChildUra.length > 0;
                $scope.ura.RepeteErro = true;

                if ($scope.ura.ServicoId != null && $scope.ura.ServicoId > 0 && $scope.ura.Servico != null && $scope.ura.Servico.ServicoTipoId == 1) {
                    $scope.ura.AssociaExterno = true;
                } else {
                    $scope.ura.AssociaExterno = false;
                }
            }

            //*************************
            //	FIM DE INICIALIZAÇÃO
            //*************************

            //*************************
            //			MÉTODOS DE DIAGRAMA
            //*************************

            $scope.plotNo = function (x, y, width, height, tipo, descricao, tipoUra, podeExcluir) {
                var tipoSVG = '',
                    svgExcluir = '',
                    svgAdicionar = '',
                    posicaoXAdicionar,
                    posicaoXDeletar;

                //SVG TIPO DE URA
                if (tipoUra == 'satisfacao') {
                    tipoSVG = $scope.iconeSatisfacao;
                } else if (tipoUra == 'pergunta') {
                    tipoSVG = $scope.iconePergunta;
                }

                //SVG EXCLUSÃO
                if (podeExcluir == true) {
                    svgExcluir = '<g class="btn del"><circle class="del"/><text class="del">-</text></g>';
                }

                posicaoXDeletar = -15;
                posicaoXAdicionar = 0;

                joint.shapes.org.Member.prototype.markup = [
                    '<g class="rotatable" >',
                    '<g class="scalable">',
                    '<rect class="card"/>',
                    '</g>',
                    '<g class="icon">' + tipoSVG + '</g>',
                    '<g class="erro invisivel"><circle/><text>!</text></g>',
                    '<text class="tipo" /><text class="descricao"/>',
                    svgAdicionar,
                    svgExcluir,
                    '</g>'
                ].join('');

                var cell = new joint.shapes.org.Member({
                    size: {
                        width: width,
                        height: height
                    },
                    position: {
                        x: x,
                        y: y
                    },
                    attrs: {
                        '.card': {
                            'rx': 0,
                            'ry': 0,
                            'stroke': 'none',
                            fill: '#f2f2f2'
                        },
                        '.tipo': {
                            text: tipo,
                            'font-family': 'Roboto,sans-serif',
                            'font-size': 15,
                            'font-weight': 500,
                            'y-alignment': 'middle',
                            'word-spacing': '-1px',
                            'letter-spacing': '0.1px',
                            'text-decoration': 'none',
                            'ref-x': 0.05,
                            'ref-y': 0.5
                        },
                        '.descricao': {
                            text: (descricao != null && descricao.length > 17) ? descricao.substr(0, 13) + '...' : descricao,
                            'font-family': 'Roboto,sans-serif',
                            'font-size': 12,
                            'font-weight': 300,
                            'y-alignment': 'middle',
                            'word-spacing': '-1px',
                            'letter-spacing': 0,
                            'text-decoration': 'none',
                            'ref-y': 0.7,
                            'ref-x': 0.05,
                        },
                        '.erro': {
                            'ref-x': 40,
                            'ref-y': 15,
                        },
                        '.erro>circle': {
                            r: 10,
                            fill: '#e53935',
                            stroke: '#444444',
                            'stroke-width': 2
                        },
                        '.erro>text': {
                            text: '!',
                            'font-size': 20,
                            'font-weight': 800,
                            fill: '#ffffff',
                            'font-family': 'Roboto,sans-serif',
                            x: -3,
                            y: 7,
                        },
                        '.icon': {
                            'ref-x': 3,
                            'ref-y': 3,
                        },
                        '.btn.add': {
                            'ref-dx': posicaoXAdicionar,
                            'ref-y': 15,
                            'ref': '.card'
                        },
                        '.btn.del': {
                            'ref-dx': posicaoXDeletar,
                            'ref-y': 15,
                            'ref': '.card'
                        },
                        '.btn>circle': {
                            r: 10,
                            fill: 'transparent',
                            stroke: $scope.iconeCor,
                            'stroke-width': 1
                        },
                        '.btn>rect': {
                            height: 20,
                            width: 45,
                            rx: 2,
                            ry: 2,
                            fill: 'transparent',
                            'stroke-width': 1
                        },
                        '.btn.add>text': {
                            'font-size': 23,
                            'font-weight': 800,
                            stroke: $scope.iconeCor,
                            x: -6.5,
                            y: 8,
                            'font-family': 'Times New Roman'
                        },
                        '.btn.del>text': {
                            'font-size': 28,
                            'font-weight': 500,
                            stroke: $scope.iconeCor,
                            x: -4.5,
                            y: 6,
                            'font-family': 'Times New Roman'
                        },
                    }
                });
                graph.addCell(cell);

                return cell;
            };

            $scope.plotLink = function (source, target) {
                var link = new joint.dia.Link({
                    source: {
                        id: source.id
                    },
                    target: {
                        id: target.id
                    },
                    router: {
                        name: 'manhattan',
                    },
                    connector: {
                        name: 'normal'
                    },
                    attrs: {
                        '.connection': {
                            'fill': 'none',
                            'stroke-width': '2',
                            'stroke': '#4b4a67'
                        },
                        '.marker-target': {
                            fill: '#333333',
                            d: 'M 10 0 L 0 5 L 10 10 z'
                        }
                    }
                });
                graph.addCell(link);
                return link;
            }

            $scope.transformarJsonEmDadosPlot = function (ura) {
                ura.DadosNo = JSON.parse(ura.DadosNo);
                for (var i = 0; i < ura.ChildUra.length; i++) {
                    $scope.transformarJsonEmDadosPlot(ura.ChildUra[i]);
                }
            }

            $scope.plotArvoreExistente = function (ura) {
                if (ura.ParentUra == null) {
                    // Set new Descricao
                    if ($scope.ura.Descricao == null ||
                        $scope.ura.Descricao == undefined) {
                        $scope.ura.Descricao = $translate.instant('editSatisfacao.introducao');
                    }

                    //Plot No Principal
                    var noPrincipal = $scope.plotNo(
                        ura.DadosNo.x,
                        ura.DadosNo.y,
                        tamanhoNoX,
                        tamanhoNoY,
                        $translate.instant('telaUraSatisfacaoEdit.inicioDaUra'),
                        $translate.instant('editSatisfacao.introducao'),
                        'satisfacao',
                        false);
                    $('g[model-id=\'' + noPrincipal.id + '\']').addClass('satisfacao no-selecionado');

                    $scope.noSelecionado = noPrincipal;
                    $scope.arvoreUra.push(noPrincipal);
                    ura.DadosPlot = noPrincipal;
                    ura.TipoUra = 'satisfacao';
                    $scope.uraSelecionada = $scope.ura;
                    paper.setOrigin(ura.DadosNo.x, ura.DadosNo.y);
                    $scope.mudarDescricaoNo(ura);
                } else {
                    $scope.noSelecionado = $scope.buscarIdemUra($scope.ura, ura.ParentUra.UraId).DadosPlot;
                    $scope.adicionarNovoNo(ura.DadosNo.x, ura.DadosNo.y, $translate.instant('editPergunta.pergunta'), ura.DadosNo.descricao, ura);
                    $scope.mudarDescricaoNo(ura);
                }

                for (var i = 0; i < ura.ChildUra.length; i++) {
                    $scope.plotArvoreExistente(ura.ChildUra[i]);
                }
            }

            $scope.onDescricaoAlterado = function () {
                $scope.mudarDescricaoNo($scope.uraSelecionada);
            }

            $scope.controlarSidebar = function () {
                $scope.sidebarAtiva = !$scope.sidebarAtiva;
            }

            $scope.adicionarNovoNo = function (posicaoX, posicaoY, nomeNo, descricaoNo, uraExistente) {
                let uraIdDiretiva = Math.random();

                let uraPai = $scope.buscarNoemUra($scope.ura, $scope.noSelecionado);

                let uraTipoId = _.find($scope.tiposUra, el => {
                    return el.Descricao == 'pergunta';
                }).TipoId;

                let novoNo = $scope.plotNo(posicaoX, posicaoY, tamanhoNoX, tamanhoNoY, nomeNo, descricaoNo, 'pergunta', true);
                $scope.plotLink($scope.noSelecionado, novoNo);
                $('#ura-builder g').removeClass('no-selecionado');
                $scope.noSelecionado = novoNo;
                $('g[model-id=\'' + $scope.noSelecionado.id + '\']').addClass('pergunta no-selecionado ');

                if (uraExistente == null) {

                    var novaUra = {
                        DadosPlot: novoNo,
                        ChildUra: [],
                        ParentUra: uraPai,
                        Botao: null,
                        TipoUra: 'pergunta',
                        UraTipoId: uraTipoId,
                        UraResposta: [],
                        UraIdDiretiva: uraIdDiretiva
                    };

                    if (!uraPai.ChildUra) {
                        uraPai.ChildUra = [];
                    }
                    uraPai.ChildUra.push(novaUra);
                    $scope.uraSelecionada = novaUra;

                } else {
                    uraExistente.TipoUra = 'pergunta';
                    uraExistente.DadosPlot = novoNo;
                    uraExistente.ParentUra = uraPai;
                }
                $scope.ativarZoom();
                return novoNo;
            };

            $scope.novaPergunta = function () {

                var uraPai = $scope.buscarNoemUra($scope.ura, $scope.noSelecionado);
                var posicaoXFilhoUra = $scope.receberPosicaoADireita(uraPai);
                var novaPosicaoX = uraPai.ChildUra.length == 0 ? posicaoXFilhoUra : posicaoXFilhoUra + tamanhoNoX + 30;
                var novaPosicaoY = $scope.noSelecionado.attributes.position.y + tamanhoNoY + 40;
                var descricaoNo = '--';
                $scope.adicionarNovoNo(novaPosicaoX, novaPosicaoY, $translate.instant('editPergunta.pergunta'), descricaoNo, null);
                $('#add-new-ura .md-fab-primary:not(.md-fab-small) i:not(.md-fab-action-close)').css('display', 'block');
                $('#add-new-ura .md-fab-primary:not(.md-fab-small) i.md-fab-action-close').css('display', 'none');
            };

            $scope.buscarNoemUra = function (ura, no) {
                if (ura == null || ura.DadosPlot == no) {
                    return ura;
                } else {
                    if (ura.ChildUra) {
                        for (var i = 0; i < ura.ChildUra.length; i++) {
                            var retornoBusca = $scope.buscarNoemUra(ura.ChildUra[i], no);
                            if (retornoBusca != null) {
                                return retornoBusca;
                            }
                        }
                    }
                    return null;
                }
            }

            $scope.buscarIdemUra = function (ura, id) {
                if (ura == null || ura.UraId == id) {
                    return ura;
                } else {
                    if (ura.ChildUra) {
                        for (var i = 0; i < ura.ChildUra.length; i++) {
                            var retornoBusca = $scope.buscarIdemUra(ura.ChildUra[i], id);
                            if (retornoBusca != null) {
                                return retornoBusca;
                            }
                        }
                    }
                    return null;
                }
            }

            var setUraIdAudios = function (ura) {
                if (ura != null) {

                    ura.UraIdDiretiva = ura.UraId;

                    if (ura.MenuUraArquivo)
                        ura.MenuUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.NaoDigitaUraArquivo)
                        ura.NaoDigitaUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.MaxErroUraArquivo)
                        ura.MaxErroUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.DigitoInvalidoUraArquivo)
                        ura.DigitoInvalidoUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.FeriadoUraArquivo)
                        ura.FeriadoUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.ForaJornadaUraArquivo)
                        ura.ForaJornadaUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.TerminoUraArquivo)
                        ura.TerminoUraArquivo.UrUraIdDiretivaId = ura.UraId;
                    if (ura.AvisoManutencaoUraArquivo)
                        ura.AvisoManutencaoUraArquivo.UraIdDiretiva = ura.UraId;
                    if (ura.MaxParticipantesUraArquivo)
                        ura.MaxParticipantesUraArquivo.UraIdDiretiva = ura.UraId;

                    if (ura.ChildUra) {
                        for (var i = 0; i < ura.ChildUra.length; i++) {
                            setUraIdAudios(ura.ChildUra[i]);
                        }
                    }
                }
            }

            setUraIdAudios($scope.ura);


            $scope.limparValidacaoUra = function (ura) {
                if (ura.ChildUra && ura.ChildUra.length > 0) {
                    for (var i = 0; i < ura.ChildUra.length; i++) {
                        $scope.limparValidacaoUra(ura.ChildUra[i]);
                    }
                }
                ura.TemErro = false;
                ura.temErroUra = false;
                ura.FilhoTemErro = false;
                if (ura.ParentUra) {
                    ura.ParentUra.TemErro = false;
                    ura.ParentUra.FilhoTemErro = false;
                }
                if (ura.UraResposta) {
                    ura.UraResposta.forEach(el => {
                        el.temErro = false;
                        el.temErroProximaPergunta = false;
                    });
                }
                return ura;
            };

            $scope.exibirValidacaoUra = function (ura) {
                if (ura.ChildUra && ura.ChildUra.length > 0) {
                    for (var i = 0; i < ura.ChildUra.length; i++) {
                        $scope.exibirValidacaoUra(ura.ChildUra[i]);
                    }
                }
                ura.TemErro = $scope.validarUra(ura);

                //tem pai e o pai não foi informado de erro no filho
                if (ura.ParentUra && (ura.ParentUra.FilhoTemErro == false || ura.ParentUra.FilhoTemErro == null)) {
                    ura.ParentUra.FilhoTemErro = ura.TemErro || ura.FilhoTemErro;
                    //é a raiz e não foi informado de erro no filho
                } else if (!ura.ParentUra && (ura.FilhoTemErro == false || ura.FilhoTemErro == null)) {
                    ura.FilhoTemErro = ura.TemErro;
                }

                if (ura.TemErro == true) {
                    $('g[model-id=\'' + ura.DadosPlot.id + '\'] .erro').removeClass('invisivel');
                } else {
                    $('g[model-id=\'' + ura.DadosPlot.id + '\'] .erro').addClass('invisivel');
                }
                return ura;
            };

            $scope.validarUra = function (ura) {
                var temErro = false;

                if (!ura.MenuArquivoId || ura.MenuArquivoId == 0) {
                    temErro = true;
                    ura.temErroUra = true;
                }

                if (!ura.Descricao || ura.Descricao == '' || ura.Descricao.length == 0) {
                    temErro = true;
                    ura.temErroUra = true;
                }

                if (ura.UraResposta != null && ura.UraResposta.length > 0) {
                    ura.UraResposta.forEach(function (el) {
                        if (el.Descricao == null || el.Descricao == '' || el.Descricao.length == 0) {
                            temErro = true;
                            ura.temErroUra = true;
                        }
                        // Proxima pergunta nao definida, se for a ultima
                        // a ura irá finalizar a chamada
                        if (ura.ChildUra.length &&
                            (el.UraTipoId == $scope.proximaPergunta || el.UraTipoId == $scope.proximaPerguntaCondicional) &&
                            (el.ProxPerguntaGuid == '-1' || el.ProxPerguntaGuid == undefined)) {
                            temErro = true;
                            ura.temErroUra = true;
                            el.temErro = true;
                            el.temErroProximaPergunta = true;
                        }
                    });
                }

                if (ura.TipoUra == 'pergunta') {
                    var respostas = ura.UraResposta.length > 0;
                    if (!respostas) {
                        temErro = true;
                        ura.temErroUra = true;
                        ura.TemResposta = true;
                    }
                    else {
                        ura.TemResposta = false;
                    }
                }

                return temErro;
            }

            $scope.receberPosicaoADireita = function (ura) {
                var maisDireita = ura.DadosPlot.attributes.position.x;
                for (var i = 0; i < ura.ChildUra.length; i++) {
                    if (maisDireita < ura.ChildUra[i].DadosPlot.attributes.position.x) {
                        maisDireita = ura.ChildUra[i].DadosPlot.attributes.position.x;
                    }
                }
                return maisDireita;
            }

            $scope.removerUraArvore = function (uraRemovida, removerDoPai) {
                var index;
                if (removerDoPai == true) {
                    index = uraRemovida.ParentUra.ChildUra.indexOf(uraRemovida);
                    if (index > -1) {
                        uraRemovida.ParentUra.ChildUra.splice(index, 1);
                    }
                    if (uraRemovida.ParentUra.UraCondicao && uraRemovida.ParentUra.UraCondicao.length > 0) {
                        index = _.pluck(uraRemovida.ParentUra.UraCondicao, 'RedirecionaUra').indexOf(uraRemovida);
                        if (index > -1) {
                            uraRemovida.ParentUra.UraCondicao.splice(index, 1);
                        }
                    }
                }
                delete uraRemovida.ParentUra;
                if (uraRemovida.ChildUra && uraRemovida.ChildUra.length > 0) {
                    for (var i = 0; i <= uraRemovida.ChildUra.length - 1; i++) {
                        $scope.removerUraArvore(uraRemovida.ChildUra[i], false);
                    }
                }
                uraRemovida.DadosPlot.remove();
            }

            $scope.transformarDadosPlotJson = function (ura) {
                var novoDadosNo = ura.DadosPlot.attributes.position;
                novoDadosNo.descricao = ura.DadosPlot.attributes.attrs['.descricao'].text;
                ura.DadosNo = JSON.stringify(novoDadosNo);
                for (var i = 0; i < ura.ChildUra.length; i++) {
                    $scope.transformarDadosPlotJson(ura.ChildUra[i]);
                }
            }

            $scope.limparUra = function (ura) {
                delete ura.ParentUra;
                if (ura.UraResposta != null && ura.UraResposta.length > 0) {
                    ura.UraResposta = _.filter(ura.UraResposta, function (el) { return el.Descricao });
                }
                for (var i = 0; i < ura.ChildUra.length; i++) {
                    $scope.limparUra(ura.ChildUra[i]);
                }
            }

            $scope.recriarReferenciaPai = function (ura) {
                if (ura.ParentUra != null) {
                    var uraPai = $scope.buscarIdemUra($scope.ura, ura.ParentUra.UraId);
                    if (uraPai != null) {
                        ura.ParentUra = uraPai;
                    }
                }
                for (var i = 0; i < ura.ChildUra.length; i++) {
                    $scope.recriarReferenciaPai(ura.ChildUra[i]);
                }
            }

            //*************************
            //	  MÉTODOS DE DETALHE
            //*************************			

            $scope.tituloUra = function () {
                let servico = $scope.ura.Servico != undefined ? " - " + $scope.ura.Servico.Descricao : "";
                return servico;
            }

            $scope.salvar = function (form) {
                $scope.ura.UraTipoIntegracaoId = 2;
                $scope.ura.FilhoTemErro = null;
                $scope.ura = $scope.limparValidacaoUra($scope.ura);
                $scope.ura = $scope.exibirValidacaoUra($scope.ura);
                form.$setSubmitted();
                if ($scope.ura.FilhoTemErro == true || !form.$valid) {
                    return NotifyService.showInvalid();
                }
                ModalService.showLoading()

                $scope.transformarDadosPlotJson($scope.ura);
                var copiaUra = angular.copy($scope.ura);
                $scope.limparUra(copiaUra);

                var promise = null;
                if ($scope.isNew) {
                    promise = UraResource.save(copiaUra).$promise;
                } else {
                    promise = UraResource.update(copiaUra).$promise;
                }
                promise.then(function () {
                    ModalService.hideLoading()
                    NotifyService.showRegistroSalvo();
                    $state.go('main.urasatisfacao.list');
                }).catch(function (ex) {
                    ModalService.hideLoading()
                    NotifyService.showError(ex);
                });
            };

            $scope.voltar = function () {
                $state.go('main.urasatisfacao.list');
            };

            $scope.mudarDescricaoNo = function (uraAtual) {
                if (uraAtual.Descricao) {
                    uraAtual.DadosPlot.attr('.descricao/text', uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + '...' : uraAtual.Descricao);
                }
                else {
                    uraAtual.DadosPlot.attr('.descricao/text', '--');
                }
            }

            //Metodos de Audio
            $scope.ouvirAudio = function (id, nome) {
                $scope.arquivoAudio = {
                    url: '/Ura/Audio/' + id,
                    titulo: $translate.instant('diretivas.reproduzindo') + nome
                }
            }

            $scope.fecharAudio = function () {
                $scope.arquivoAudio = null;
            }

            $scope.showProgress = function (percentComplete) {
                $('#modalBlock').find('.uk-progress-bar').css({
                    width: percentComplete + '%'
                });
                $('#modalBlock').find('.uk-progress-bar').text(percentComplete + '%');
            }

            $scope.loadUraError = function (result) {
                $scope.preview = null;

                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);

                if (result == 'Bad Request') {
                    NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                }
            };

            $scope.startUraUpload = function () {
                UIkit.modal.blockUI(`<div id="modalBlock" class='uk-text-center'>${$translate.instant('telaUraSatisfacaoEdit.fazendoUpload')}...<br/><div class="uk-progress uk-progress-striped uk-active"><div class="uk-progress-bar" style="width: 0%;"></div></div></div>`);
            }


            //*************************
            //	SELECAO AUDIOS
            //*************************

            $scope.setVozTts = function (vozId, vozProvedorId) {
                $scope.ura.VozId = vozId;
                $scope.ura.VozProvedorId = vozProvedorId;
                $scope.vozIdDefault = vozId;
            }

            $scope.loadMenuCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.MenuArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.MenuUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removeMenuUra = function () {
                $scope.uraSelecionada.MenuArquivoId = null;
                $scope.uraSelecionada.MenuUraArquivo = null;
                $('#form-file-menu').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // Dígito Inválido
            $scope.loadInvalidoCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.DigitoInvalidoArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.DigitoInvalidoUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removeInvalido = function () {
                $scope.uraSelecionada.DigitoInvalidoArquivoId = null;
                $scope.uraSelecionada.DigitoInvalidoUraArquivo = null;
                $('#form-file-invalido').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // Dígito Válido
            $scope.loadValidoCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.TerminoArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.TerminoUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removeValido = function () {
                $scope.uraSelecionada.TerminoArquivoId = null;
                $scope.uraSelecionada.TerminoUraArquivo = null;
                $('#form-file-valido').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // INTRO FILE
            $scope.loadIntroCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.IntroArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.IntroArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            }

            $scope.removeIntroUra = function () {
                $scope.uraSelecionada.IntroArquivoId = null;
                $scope.uraSelecionada.IntroArquivo = null;
                $('#form-file-termino').val('');
                $scope.forms.formDetalhes.$setDirty();
            }

            //TERMINO MENU FILE
            $scope.loadTerminoCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.TerminoArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.TerminoUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removeTerminoUra = function () {
                $scope.uraSelecionada.TerminoArquivoId = null;
                $scope.uraSelecionada.TerminoUraArquivo = null;
                $('#form-file-termino').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            //MAX ERRO FILE
            $scope.loadMaxErroCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.MaxErroArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.MaxErroUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removeMaxErroUra = function () {
                $scope.uraSelecionada.MaxErroArquivoId = null;
                $scope.uraSelecionada.MaxErroUraArquivo = null;
                $('#form-file-maxerro').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // Pesquisa audio de pré ação
            $scope.loadPesqAudioAcaoCompleted = function (result) {
                $scope.preview = result;
                $scope.uraRespostaEdit.AcaoArquivoId = result.UraArquivoId;
                $scope.uraRespostaEdit.AcaoUraArquivo = result;

                $scope.uraSelecionada.VozId = result.VozId;
                $scope.vozIdDefault = result.VozId;

                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removePesqAudioAcao = function () {
                $scope.uraRespostaEdit.AcaoArquivoId = null;
                $scope.uraRespostaEdit.AcaoUraArquivo = null;
                $('#form-file-acao').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // Pesquisa toca audio
            $scope.loadPesqAudioTocarCompleted = function (result) {
                $scope.preview = result;
                $scope.uraRespostaEdit.TocaAudioArquivoId = result.UraArquivoId;
                $scope.uraRespostaEdit.TocaAudioUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removePesqAudioTocar = function () {
                $scope.uraRespostaEdit.TocaAudioArquivoId = null;
                $scope.uraRespostaEdit.TocaAudioUraArquivo = null;
                $('#form-file-tocar-audio').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // Pergunta condicional
            $scope.loadPesqAudioPerguntaCondicionalFinalizacaoCompleted = function (result) {
                $scope.preview = result;
                $scope.uraRespostaEdit.PerguntaCondicionalFinalizacaoArquivoId = result.UraArquivoId;
                $scope.uraRespostaEdit.PerguntaCondicionalFinalizacaoUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removePesqAudioPerguntaCondicionalFinalizacao = function () {
                $scope.uraRespostaEdit.PerguntaCondicionalFinalizacaoArquivoId = null;
                $scope.uraRespostaEdit.PerguntaCondicionalFinalizacaoUraArquivo = null;
                $('#form-file-pergunta-condicional-finalizacao').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            // Qde Participantes da Pesquisa
            $scope.loadQdeParticipantesCompleted = function (result) {
                $scope.preview = result;
                $scope.uraSelecionada.MaxParticipantesArquivoId = result.UraArquivoId;
                $scope.uraSelecionada.MaxParticipantesUraArquivo = result;
                $scope.setVozTts(result.VozId, result.VozProvedorId);
                $scope.forms.formDetalhes.$setDirty();
                var modal = $.UIkit.modal('#modalBlock');
                if (modal)
                    modal.hide(true);
            };

            $scope.removeQdeParticipantes = function () {
                $scope.uraSelecionada.MaxParticipantesArquivoId = null;
                $scope.uraSelecionada.MaxParticipantesUraArquivo = null;
                $('#form-file-qdeParticipantes').val('');
                $scope.forms.formDetalhes.$setDirty();
            };

            /////////// SELECAO AUDIOS FIM

            $scope.exibirDetalhe = function (titulo, descricao) {
                ModalService.alert(`<h3>${titulo}</h3>${descricao}`);
            };

            $scope.builderListMinMaxDigito = function () {
                if ($scope.uraRespostaEdit) {
                    $scope.listMinMaxDigito = [];
                    let valorMaxDigito = 0;
                    let res = 10;
                    let qdeDigitos = $scope.uraRespostaEdit.QdeDigitos ? $scope.uraRespostaEdit.QdeDigitos : 1;
                    // Limita apenas em 3 casas
                    if (qdeDigitos > 3) {
                        qdeDigitos = 3;
                    }
                    for (var i = 1; i < qdeDigitos; i++) {
                        res *= 10;
                    }
                    valorMaxDigito = res - 1;
                    for (var i = 0; i <= valorMaxDigito; i++) {
                        $scope.listMinMaxDigito.push({ ValorId: i, Valor: i });
                    }
                }
            }

            $scope.checkQdeDigitos = function () {
                // Desable filtro de digitos
                if ($scope.uraRespostaEdit.QdeDigitos == null) {
                    $scope.listMinMaxDigito = [];
                    $scope.uraRespostaEdit.FiltroDigitos = false;
                    $scope.uraRespostaEdit.ValorMinDigito = null;
                    $scope.uraRespostaEdit.ValorMaxDigito = null;
                    return;
                }
                // Builder o ranger minimo e máximo de digitos
                $scope.builderListMinMaxDigito();
            };

            $scope.abrirModalInput = function () {
                UIkit.modal.prompt('Escolha uma descrição para o audio:', $scope.uraSelecionada.AudioLabel, (input) => {
                    $scope.uraSelecionada.AudioLabel = (input) ? input : null;
                });
            }

            $scope.ouvirAudio = function (id, nome) {
                $scope.arquivoAudio = {
                    url: "/Ura/Audio/" + id,
                    titulo: $translate.instant('diretivas.reproduzindo') + nome
                };
            };

            $scope.avisoCancelarRespostas = function () {
                if (!$scope.utils.editandoResposta && !$scope.disableconcluirResposta()) {
                    $scope.showBtnCancelar = false;
                    return;
                }
                $scope.cancelarRespostas();
            };

            $scope.closeAviso = function () {
                $scope.showBtnCancelar = true;
            }

            $scope.cancelarRespostas = function () {
                $scope.uraRespostaEdit = {};
                $scope.uraRespostaTemp = [];
                $scope.uraRespostaTempEdit = [];
                ModalService.closeModal('modal_resposta');
            };

            $scope.concluirResposta = function () {

                // Ajustamos o status
                $scope.uraRespostaTempEdit.forEach(el => {
                    el.statusRegistro = $scope.Concluido;
                });
                $scope.uraSelecionada.UraResposta = angular.copy($scope.uraRespostaTempEdit);
                $scope.cancelarRespostas();
            }

            $scope.onChangeDigito = function () {
                if ($scope.uraRespostaEdit.Digito == null &&
                    $scope.uraRespostaEdit.Intencao == null) {
                    $scope.resetaUraResposta(false);
                }
                else if ($scope.uraRespostaEdit.Digito &&
                    $scope.uraRespostaEdit.Digito != $scope.qqerSeqDigitos) {
                    $scope.uraRespostaEdit.QdeDigitos = 1;
                }
            };

            // Ao editar as perguntas, temos uma cópia da
            // UraResposta na uraRespostaTempEdit, as alterações
            // ficaram salvas na uraRespostaTempEdit.
            // Se o usuário ATUALIZAR a edição, as
            // informações da uraRespostaTempEdit serão
            // salvas na UraResposta

            // A variavel uraRespostaTemp serve apenas 
            // para verificar se houve mudanças na edição
            // para habilitar ou não o botão concluir
            // Evitar renderização em loop!!!
            // $scope.disableconcluirResposta = function ()

            // Ao criar as respotas, as mesmas serão
            // salvas apenas após selecionar
            // o botao de CONCLUIR

            // O Botao de Cancelar, cancela as 
            // alterações em ambos os cenários
            $scope.adicionarResposta = function () {
                let resposta = angular.copy($scope.uraRespostaEdit);
                if ($scope.utils.editandoResposta) {
                    let index = $scope.uraRespostaTempEdit.map(item => item.id ? item.id : item.UraRespostaId).indexOf(resposta.id ? resposta.id : resposta.UraRespostaId);
                    if (index > -1) {
                        $scope.uraRespostaTempEdit.splice(index, 1);
                        $scope.uraRespostaTempEdit.push(resposta);
                        $scope.concluirResposta();
                    }
                    else {
                        $scope.exibirDetalhe($translate.instant('modalResposta.atualizarResposta'), $translate.instant('modalResposta.erroAtualizarResposta'));
                        return;
                    }
                }
                else {
                    resposta.id = UraHelper.uuidv4();
                    $scope.uraSelecionada.MenuGuid = UraHelper.uuidv4();
                    $scope.uraRespostaTempEdit.push(resposta);
                    $scope.removeDigitoList($scope.uraRespostaEdit.Digito);
                    $scope.removeIntencaoList($scope.uraRespostaEdit.Intencao);
                    $scope.resetaUraResposta(false);
                }

                // Ajustamos o status para adionado
                $scope.uraRespostaTempEdit.forEach(el => {
                    el.statusRegistro = $scope.Adicionado;
                });

                $scope.uraRespostaEdit = {};
            }

            $scope.removeDigitoList = function (digito) {
                if (digito == null || digito == undefined) return;
                if (digito == '?') {
                    digito = $translate.instant('editUra.qqerSeqDigitos');
                    $scope.listDigitoResposta = [];
                }
                else {
                    // Removemos o qqerSeqDigitos, pois é mutuamente exclusivo!
                    var qqerdigito = $translate.instant('editUra.qqerSeqDigitos');
                    let index = $scope.listDigitoResposta.map(item => item.Digito).indexOf(qqerdigito);
                    if (index > -1) {
                        $scope.listDigitoResposta.splice(index, 1);
                    }
                }
                let index = $scope.listDigitoResposta.map(item => item.Digito).indexOf(digito);
                if (index > -1) {
                    $scope.listDigitoResposta.splice(index, 1);
                }
            }

            $scope.removeIntencaoList = function (intencao) {
                if (intencao == null || intencao == undefined) return;
                let index = $scope.listIntencaoResposta.map(item => item.IntencaoId).indexOf(intencao);
                if (index > -1) {
                    $scope.listIntencaoResposta.splice(index, 1);
                }
            }

            $scope.resetaUraResposta = function (mantemDigito) {
                $scope.resetaRespostaEdit();
                if (!mantemDigito) {
                    $scope.uraRespostaEdit.Digito = null;
                    $scope.uraRespostaEdit.QdeDigitos = undefined;
                }
                $scope.uraRespostaEdit.Descricao = null;
                $scope.uraRespostaEdit.UraTipoId = null;
            }

            $scope.resetaRespostaEdit = function () {

                // ENVIAR SMS
                $scope.uraRespostaEdit.SmsTemplateId = null;

                // FINALIZAR CHAMADA

                // PROXIMA PERGUNTA

                // TOCAR AUDIO

                // TRANSFERIR RAMAL
                $scope.uraRespostaEdit.RamalTipoId = null;
                $scope.uraRespostaEdit.Ramal = null;
                $scope.uraRespostaEdit.RamalId = null;

                // TRANSFERIR TELEFONE
                $scope.uraRespostaEdit.RotaCtiId = null;
                $scope.uraRespostaEdit.RedirecionaNumero = null;

                // AUDIO DE PRÉ AÇÃO
                $scope.uraRespostaEdit.AcaoArquivoId = null;
                $scope.uraRespostaEdit.AcaoUraArquivo = null;

                // DIVERSOS
                $scope.uraRespostaEdit.PerguntaCondicional = null;
                $scope.uraRespostaEdit.QuantidadeCondicional = null;
                $scope.uraRespostaEdit.PerguntaCondicionalFinalizacaoArquivoId = null;
            }

            $scope.disableAdicionaAtualizaResposta = function () {
                let disabled = true;

                if ($scope.utils.editandoResposta) {

                    disabled = UraHelper.compareObjExt($scope.uraRespostaEdit, $scope.uraRespostaEditBackup);
                }
                else {
                    switch ($scope.uraRespostaEdit.UraTipoId) {
                        case $scope.enviarSms:
                            disabled = !($scope.uraRespostaEdit.SmsTemplateId > 0);
                            break;
                        case $scope.finalizarChamada:
                            disabled = false;
                            break;
                        case $scope.proximaPergunta:
                            disabled = !($scope.uraRespostaEdit.ProxPerguntaGuid);
                            break;

                        case $scope.proximaPerguntaCondicional:
                            disabled = !($scope.uraRespostaEdit.ProxPerguntaGuid != null &&
                                $scope.uraRespostaEdit.ProxPerguntaGuid != undefined &&
                                $scope.uraRespostaEdit.QuantidadeCondicional != null &&
                                $scope.uraRespostaEdit.QuantidadeCondicional != undefined &&
                                $scope.uraRespostaEdit.QuantidadeCondicional > 0);
                            break;

                        case $scope.tocarAudio:
                            disabled = !($scope.uraRespostaEdit.TocaAudioArquivoId > 0 && ($scope.uraRespostaEdit.ProxPerguntaGuid != null && $scope.uraRespostaEdit.ProxPerguntaGuid != undefined))
                            break;
                        case $scope.transferirRamal:
                            disabled = !($scope.uraRespostaEdit.RamalId > 0 ? true : $scope.uraRespostaEdit.RedirecionaUraId > 0);
                            break;
                        case $scope.transferirTelefone:
                            disabled = !($scope.uraRespostaEdit.RotaCtiId > 0);
                            break;
                    }
                }
                return disabled;
            };

            $scope.disableconcluirResposta = function () {

                if ($scope.utils.editandoResposta) {
                    if (!$scope.uraRespostaEdit.descricaoPorResposta) {
                        return UraHelper.compareObjExt($scope.uraSelecionada.UraResposta, $scope.uraRespostaTempEdit);
                    }
                    else {
                        let t = 0;
                    }
                }

                let disable = true;

                // Todos com status $scope.Adicionado
                let cont = -1;
                $scope.uraRespostaTempEdit.forEach(el => {
                    if (cont == -1) {
                        cont = 0;
                    }
                    if (el.statusRegistro == $scope.Adicionado) {
                        cont = cont + 1;
                    }
                });

                disable = !(cont == $scope.uraRespostaTempEdit.length);
                return disable;
            }

            $scope.getDigitosDisponiveis = function () {
                return $scope.listDigitoResposta;
            }

            $scope.getIntencoesDisponiveis = function () {
                return $scope.listIntencaoResposta;
            }

            $scope.builderListDigitoResposta = function () {
                $scope.listDigitoResposta = [
                    { DigitoId: $scope.digitoZero, Digito: '0' },
                    { DigitoId: $scope.digitoUm, Digito: '1' },
                    { DigitoId: $scope.digitoDois, Digito: '2' },
                    { DigitoId: $scope.digitoTres, Digito: '3' },
                    { DigitoId: $scope.digitoQuatro, Digito: '4' },
                    { DigitoId: $scope.digitoCinco, Digito: '5' },
                    { DigitoId: $scope.digitoSeis, Digito: '6' },
                    { DigitoId: $scope.digitoSete, Digito: '7' },
                    { DigitoId: $scope.digitoOito, Digito: '8' },
                    { DigitoId: $scope.digitoNove, Digito: '9' },
                    { DigitoId: $scope.digitoAsterisco, Digito: '*' },
                    { DigitoId: $scope.digitoSustenido, Digito: '#' },
                    // Mutuamente exclusivos, ou seja, não pode ocorrer ao mesmo tempo com os demais digitos!
                    { DigitoId: $scope.qqerSeqDigitos, Digito: $translate.instant('editUra.qqerSeqDigitos') },
                ];
            }

            $scope.builderListIntencaoResposta = function () {
                $scope.listIntencaoResposta = [
                    { IntencaoId: $scope.intencaoSim, Intencao: $translate.instant('intencoes.sim') },
                    { IntencaoId: $scope.intencaoNao, Intencao: $translate.instant('intencoes.nao') }
                ];
            }

            $scope.getRespostas = function () {
                let respostas = $scope.hasRespostas();
                if (respostas == null) {
                    return null;
                }
                // Digitos
                let digitos = _.filter(respostas, function (el) { return el.UraTipoId != 26 }).sort((a, b) => a.Digito > b.Digito ? 1 : -1);
                // Intenções
                let intencoes = _.filter(respostas, function (el) { return el.Intencao }).sort((a, b) => a.Intencao > b.Intencao ? 1 : -1);

                return digitos.concat(intencoes);
                //return respostas.sort((a, b) => $scope.sortRespostasByDigito(a, b));
            }

            $scope.hasRespostas = function () {

                if ($scope.uraRespostaTempEdit.length > 0) {
                    // Todos com status Adicionado ou Concluido
                    let cont = -1;
                    $scope.uraRespostaTempEdit.forEach(el => {
                        if (cont == -1) {
                            cont = 0;
                        }
                        if (el.statusRegistro == $scope.Adicionado ||
                            el.statusRegistro == $scope.Concluido) {
                            cont = cont + 1;
                        }
                    });
                    if (cont == $scope.uraRespostaTempEdit.length) {
                        return $scope.uraRespostaTempEdit;
                    }
                }
                else if ($scope.uraSelecionada.UraResposta.length > 0) {
                    return $scope.uraSelecionada.UraResposta;
                }
                return null;
            }

            $scope.sortRespostasByDigito = function (a, b) {
                let ret = 0;
                if (a.Digito != null && a.Digito != undefined && a.Digito != "---") {
                    ret = a.Digito > b.Digito ? 1 : -1;
                }
                /*else if (a.Intencao != null && a.Intencao != undefined && a.Intencao != "---") {
                    ret = a.Intencao > b.Intencao ? 1 : -1;
                }*/
                return ret;
            }

            $scope.getRespostasCanceladas = function () {

                let cancelar = $scope.uraRespostaTempEdit.filter(x => $scope.uraSelecionada.UraResposta.map(d => d.Digito).indexOf(x.Digito) === -1);
                return cancelar;
            }

            $scope.deletarResposta = function (index) {
                $scope.uraSelecionada.UraResposta.splice(index, 1);
            };

            $scope.setListPerguntas = function (ura) {
                if (ura == null || ura.length == 0) return;
                // Não insere a pergunta em edição e as
                // perguntas sem descrição
                ura.forEach(el => {
                    if ($scope.uraSelecionada.Descricao != el.Descricao &&
                        el.Descricao != null &&
                        el.Descricao != undefined) {
                        $scope.updateListPerguntas(el.MenuGuid, el.Descricao);
                    }
                    $scope.setListPerguntas(el.ChildUra);
                });
            }

            $scope.editarRespostas = function (resposta) {

                if ($scope.ura.DiscagemIntegracaoServicoId > 0) {
                    $scope.listAcoes = [
                        //{ AcaoId: $scope.enviarSms, Descricao: $translate.instant('editAcoesUra.enviarSms') },
                        { AcaoId: $scope.finalizarChamada, Descricao: $translate.instant('editAcoesUra.finalizarChamada') },
                        { AcaoId: $scope.proximaPergunta, Descricao: $translate.instant('editAcoesUra.proximaPergunta') },
                        { AcaoId: $scope.tocarAudio, Descricao: $translate.instant('editAcoesUra.tocarAudio') },
                        { AcaoId: $scope.transferirRamal, Descricao: $translate.instant('editAcoesUra.transferirRamal') },
                        { AcaoId: $scope.transferirTelefone, Descricao: $translate.instant('editAcoesUra.transferirTelefone') },
                        { AcaoId: $scope.proximaPerguntaCondicional, Descricao: $translate.instant('editAcoesUra.proximaPerguntaCondicional') },
                    ];
                }
                else {
                    $scope.listAcoes = [
                        //{ AcaoId: $scope.enviarSms, Descricao: $translate.instant('editAcoesUra.enviarSms') },
                        { AcaoId: $scope.finalizarChamada, Descricao: $translate.instant('editAcoesUra.finalizarChamada') },
                        { AcaoId: $scope.proximaPergunta, Descricao: $translate.instant('editAcoesUra.proximaPergunta') },
                        { AcaoId: $scope.tocarAudio, Descricao: $translate.instant('editAcoesUra.tocarAudio') },
                        { AcaoId: $scope.transferirRamal, Descricao: $translate.instant('editAcoesUra.transferirRamal') },
                        { AcaoId: $scope.transferirTelefone, Descricao: $translate.instant('editAcoesUra.transferirTelefone') },
                    ];
                }

                $scope.forms.formDetalhes.$setDirty();

                $scope.showBtnCancelar = true;

                // Builder digitos
                $scope.builderListDigitoResposta();

                // Builder as intenções
                $scope.builderListIntencaoResposta();

                // Remove os digitos caso qqerSeqDigitos está ativo
                if (resposta != null && resposta.Digito != null && resposta.Digito != '?') {
                    let digito = $translate.instant('editUra.qqerSeqDigitos');
                    let index = $scope.listDigitoResposta.map(item => item.Digito).indexOf(digito);
                    if (index > -1) {
                        $scope.listDigitoResposta.splice(index, 1);
                    }
                }

                // Builder a listas de perguntas disponíveis
                $scope.listPerguntas = [
                    { MenuGuid: '-1', Descricao: $translate.instant('editPergunta.pendenteConfig') },
                    { MenuGuid: '-2', Descricao: $translate.instant('editAcoesUra.finalizarChamada') }
                ];

                $scope.setListPerguntas($scope.ura.ChildUra);

                // Remove os digitos/intencoes utilizados
                let respostasTemp = $scope.getRespostas();
                if (respostasTemp != null && respostasTemp != null) {
                    respostasTemp.forEach(el => {
                        if (resposta == null || resposta.Digito != el.Digito) {
                            $scope.removeDigitoList(el.Digito);
                            $scope.removeIntencaoList(el.Intencao);
                        }
                    });
                }

                // Editando um resposta especifica
                if (resposta != null) {
                    // Reseta alerta de erro se necessário
                    resposta.temErro = false;

                    // Armazena os dados em nova area de memória!
                    $scope.uraRespostaEdit = angular.copy(resposta);
                    $scope.uraRespostaEditBackup = angular.copy(resposta);
                    $scope.utils.editandoResposta = true;

                    // Descricao por resposta
                    let listDescricaoPorDigito = $scope.uraSelecionada.UraResposta.filter((el) => el.UraTipoId == 26);
                    if (listDescricaoPorDigito.length > 0) {
                        $scope.uraRespostaEdit.descricaoPorResposta = true;
                    }
                }
                else {
                    $scope.uraRespostaEdit = {};
                    $scope.uraRespostaEditBackup = {};
                    $scope.utils.editandoResposta = false;
                }

                // Cópia da $scope.uraSelecionada.UraResposta
                // para a $scope.uraRespostaTemp
                // USADA NA COMPARAÇÃO PARA VERIFICAR MUDANÇAS
                $scope.uraRespostaTemp = angular.copy($scope.uraSelecionada.UraResposta);

                // USADA PARA EDIÇÃO DAS RESPOSTAS
                $scope.uraRespostaTempEdit = angular.copy($scope.uraSelecionada.UraResposta);

                // Builder o ranger minimo e máximo de digitos
                $scope.builderListMinMaxDigito();

                // Builder a lista de percentual restante
                // para pergunta condicional
                $scope.setListPercentual();

                // Ajusta o percentual se for o caso
                if ($scope.uraRespostaEdit.QuantidadeCondicional > 0) {
                    $scope.utils.percentualSelecionado = (100 * $scope.uraRespostaEdit.QuantidadeCondicional) / $scope.ura.QdeParticipantes;
                }

                ModalService.openModal('modal_resposta', null, null, { center: false, bgclose: false, keyboard: false });
            }

            $scope.updateListPerguntas = function (menuGuid, descricao) {
                let index = $scope.listPerguntas.map(item => item.MenuGuid).indexOf(menuGuid);
                if (index > -1) {
                    $scope.listPerguntas.splice(index, 1);
                }
                $scope.listPerguntas.push({ MenuGuid: menuGuid, Descricao: descricao });
            }

            $scope.getDescricaoBotaoResposta = function () {
                let descricao = $translate.instant('modalResposta.adicionarResposta');
                if ($scope.utils.editandoResposta) {
                    descricao = $translate.instant('modalResposta.atualizarResposta');
                }
                return descricao;
            }

            $scope.onDescricaoRespostaAlterado = function () {

                if ($scope.utils.editandoResposta == false && (
                    $scope.uraRespostaEdit.Descricao == null ||
                    $scope.uraRespostaEdit.Descricao.length == 0)) {
                    $scope.resetaUraResposta(true);
                }
            }

            $scope.onAssociaExternoAlterado = function () {
                if (!$scope.ura.AssociaExterno) {
                    $scope.ura.ServicoId = null;
                }
            }

            $scope.getDescricaoFiltroDigitos = function () {
                let descricao = $translate.instant('editPergunta.labelNaoConfigurar');
                if ($scope.uraRespostaEdit.FiltroDigitos) {
                    descricao = $translate.instant('editPergunta.labelConfigurar');
                }
                return descricao;
            }

            $scope.setListPercentual = function () {
                $scope.listPercentual = [];
                for (var i = 1; i <= $scope.percentualMaximo; i++) {
                    $scope.listPercentual.push({ PercentualId: i, Valor: i + ' %' });
                }
            }

            $scope.setQdebyPercentual = function () {
                if ($scope.utils.percentualSelecionado > 0) {
                    $scope.uraRespostaEdit.QuantidadeCondicional = ($scope.ura.QdeParticipantes * $scope.utils.percentualSelecionado) / 100;
                }
            }

            $scope.hasIntencoesDisponiveis = function () {
                /// TODO: adicionar as intenções na pesquisa???
                return false;
                //return $scope.listIntencaoResposta.length > 0;
            }

            $scope.showDescricaoResposta = function () {
                return $scope.uraRespostaEdit.Intencao ||
                    ($scope.uraRespostaEdit.Digito && $scope.uraRespostaEdit.Digito != $scope.qqerSeqDigitos) ||
                    ($scope.uraRespostaEdit.QdeDigitos && $scope.uraRespostaEdit.Digito == $scope.qqerSeqDigitos);
            }

            $scope.showDescricoesRespostas = function () {
                return ($scope.uraRespostaEdit.QdeDigitos &&
                    $scope.uraRespostaEdit.QdeDigitos <= 2 &&
                    $scope.uraRespostaEdit.Digito == $scope.qqerSeqDigitos);
            }

            $scope.showAdicionarResposta = function () {
                let todasResposta = false;
                let todasIntencoes = false;
                let respostas = $scope.getRespostas();

                if (respostas) {
                    // Atingiu todos os digitos possíveis
                    let digitos = _.filter(respostas, r => (r.Digito == '?'));
                    if (digitos.length > 0) {
                        todasResposta = true;
                    }
                    else {
                        digitos = _.filter(respostas, r => (r.digito));
                        if (digitos && digitos.length >= 12) {
                            todasResposta = true;
                        }
                    }
                    // Atingiu todas as Intenções
                    let intencoes = _.filter(respostas, r => (r.Intencao));
                    if (intencoes && intencoes.length >= $scope.maxRespostaIntencao) {
                        todasIntencoes = true;
                    }
                }
                return $scope.uraSelecionada.MenuArquivoId &&
                    $scope.uraSelecionada.Descricao &&
                    (!todasResposta || !todasIntencoes);
            }

            $scope.showComboAcoes = function () {
                let show = undefined;

                if (!$scope.uraRespostaEdit.descricaoPorResposta) {
                    show = ($scope.uraRespostaEdit.Digito || $scope.uraRespostaEdit.Intencao) && ($scope.uraRespostaEdit.Descricao || $scope.utils.editandoResposta);
                }
                else {
                    // Todos com status $scope.Novo
                    let cont = -1;
                    $scope.uraRespostaTempEdit.forEach(el => {
                        if (cont == -1) {
                            cont = 0;
                        }
                        if (el.statusRegistro == $scope.Novo) {
                            cont = cont + 1;
                        }
                    });
                    show = (cont == $scope.uraRespostaTempEdit.length);
                }
                return show ? true : false;
            }

            $scope.addDescricoesRespostas = function () {

                $scope.uraRespostaTempEdit.push(
                    {
                        id: UraHelper.uuidv4(),
                        Digito: null,
                        Descricao: null,
                        UraTipoId: 26
                    }
                );
            }

            $scope.disableAddDescricoesRespostas = function (index) {

                let disabled = true;

                let descricao = $scope.uraRespostaTempEdit[index];
                if (!descricao) {
                    return disabled;
                }
                disabled = !(UraHelper.isPropValid(descricao.Digito) && UraHelper.isPropValid(descricao.Descricao));
                return disabled;
            };

            $scope.removerDescricoesRespostas = function (descricaoPorDigito) {

                // Remove da lista uraRespostaTempEdit
                // mas atraves do seu "id"
                let index = $scope.uraRespostaTempEdit.map(item => item.id).indexOf(descricaoPorDigito.id);
                if (index > -1) {
                    $scope.uraRespostaTempEdit.splice(index, 1);
                }
            }

            $scope.onChangeDescricaoPorResposta = function (index) {

                // Inicia a descricao por resposta
                if ($scope.uraRespostaEdit.QdeDigitos <= 2) {

                    // Iniciando a lista de descrição por respostas
                    if ($scope.uraRespostaTempEdit.length == 0) {

                        $scope.addDescricoesRespostas();
                    }
                }
            }

            $scope.onChangeParamDescDigito = function (descricaoPorDigito, isDigito) {

                if (isDigito) {

                    let digitoEmUso = $scope.uraRespostaTempEdit.filter(el => el.Digito == descricaoPorDigito.Digito);
                    if (digitoEmUso && digitoEmUso.length > 1) {

                        NotifyService.showError(null, 'modalDescricaoPorResposta.digitoEmUso', { Digito: descricaoPorDigito.Digito })
                        descricaoPorDigito.DigitoDuplicado = true;
                        return;
                    }
                    else {
                        descricaoPorDigito.DigitoDuplicado = false;
                    }
                }

                let index = $scope.uraRespostaTempEdit.map(item => item.id).indexOf(descricaoPorDigito.id);
                if ((descricaoPorDigito.Digito != null &&
                    descricaoPorDigito.Digito != undefined) &&
                    descricaoPorDigito.Descricao) {

                    if (descricaoPorDigito.statusRegistro != $scope.Novo) {
                        descricaoPorDigito.statusRegistro = $scope.Novo;
                        if (index > -1) {
                            $scope.uraRespostaTempEdit[index].statusRegistro = $scope.Novo;
                        }
                    }
                }
                else if (descricaoPorDigito.statusRegistro != null) {
                    descricaoPorDigito.statusRegistro = null;
                    if (index > -1) {
                        $scope.uraRespostaTempEdit[index].statusRegistro = null;
                    }
                }
            }

            $scope.getDescricaoPorDigito = function () {

                let listDescricaoPorDigito = null;
                if ($scope.uraRespostaTempEdit &&
                    $scope.uraRespostaTempEdit.length > 0) {
                    listDescricaoPorDigito = $scope.uraRespostaTempEdit.filter((el) => el.UraTipoId == 26);
                }
                return listDescricaoPorDigito;
            }

            $scope.showDigitoLivre = function (descricaoPorDigito) {

                let digitoEmUso = $scope.uraRespostaTempEdit.filter(el => el.Digito == descricaoPorDigito.Digito);
                if (digitoEmUso && digitoEmUso.length > 1) {
                    return false;
                }
                return true;
            }

            //*************************
            //	INICIALIZAÇÃO DE DIAGRAMA
            //*************************

            var tamanhoNoX = 110;
            var tamanhoNoY = 90;
            $scope.arvoreUra = [];
            $scope.noSelecionado = {};
            $scope.uraSelecionada = {};
            $scope.noPodeAdicionar = false;
            $scope.sidebarAtiva = true;
            $scope.infoUraModal = {};
            $scope.zoomAtual = 0;

            var graph = new joint.dia.Graph;
            var paper = new joint.dia.Paper({
                el: $('#ura-builder'),
                model: graph,
                gridSize: 1,
                width: 3000,
                height: 3000,
                perpendicularLinks: true,
                restrictTranslate: true,
            });

            paper.on('element:pointerup', function (elementView, evt) {
                $('#ura-builder g').removeClass('no-selecionado');
                if (V(evt.target).hasClass('add')) {
                    elementView.$el.addClass('no-selecionado');
                    $scope.noSelecionado = elementView.model;
                    var novoSelecionado = $scope.buscarNoemUra($scope.ura, $scope.noSelecionado);
                    if (novoSelecionado != $scope.uraSelecionada) {
                        $scope.uraSelecionada = novoSelecionado;
                        if ($scope.forms.formDetalhes.$submitted) {
                            $scope.forms.formDetalhes.$setSubmitted();
                        }
                    }
                    $scope.noPodeAdicionar = $scope.uraSelecionada.ChildUra.length == 0;
                    $scope.$apply();
                    $('#add-new-ura .md-fab-primary:not(.md-fab-small)').click();
                    $timeout(function () { }, 3000)
                } else if (V(evt.target).hasClass('del')) {
                    $window.UIkit.modal.confirm($translate.instant('telaUraSatisfacaoEdit.confirmarExclusaoMenu'), function () {
                        var uraRemovida = $scope.buscarNoemUra($scope.ura, elementView.model);
                        $scope.deletarMenu(uraRemovida);
                        $scope.noPodeAdicionar = $scope.uraSelecionada.ChildUra.length == 0;
                        $scope.$apply();
                    });
                } else {
                    elementView.$el.addClass('no-selecionado');
                    $scope.noSelecionado = elementView.model;
                    var ura = $scope.buscarNoemUra($scope.ura, $scope.noSelecionado);
                    if (ura != $scope.uraSelecionada) {
                        $scope.uraSelecionada = ura;
                        $scope.noPodeAdicionar = $scope.uraSelecionada.ChildUra.length == 0;
                        if ($scope.forms.formDetalhes.$submitted) {
                            $scope.forms.formDetalhes.$setSubmitted();
                        }
                    }
                    $scope.noPodeAdicionar = $scope.uraSelecionada.ChildUra.length == 0;
                    $scope.$apply();
                }
            });

            $scope.deletarMenu = function (uraRemovida) {
                $scope.noSelecionado = uraRemovida.ParentUra.DadosPlot;
                $scope.uraSelecionada = uraRemovida.ParentUra;
                $('g[model-id=\'' + $scope.noSelecionado.id + '\']').addClass('no-selecionado');
                $scope.removerUraArvore(uraRemovida, true);
                $scope.forms.formDetalhes.$setDirty();
                $scope.verificarTipoRaiz();
                $scope.resetProxPerguntaGuid($scope.ura, uraRemovida.MenuGuid);
            }

            $scope.verificarTipoRaiz = function () {
                $scope.ura.TipoUra = 'satisfacao';
                $scope.ura.UraTipoId = 10;
            }

            $scope.paperContainer = null;
            $scope.ativarZoom = function () {
                if ($scope.paperContainer == null) {
                    $scope.paperContainer = $('#ura-builder')[0];
                    var panAndZoom = svgPanZoom($scope.paperContainer.childNodes[0], {
                        viewportSelector: $scope.paperContainer.childNodes[0].childNodes[0],
                        fit: false,
                        zoomScaleSensitivity: 0.4,
                        panEnabled: false,
                        center: false
                    });

                    paper.on('blank:pointerdown', function () {
                        panAndZoom.enablePan();
                    });

                    paper.on('cell:pointerup blank:pointerup', function () {
                        panAndZoom.disablePan();
                    });

                    $scope.zoomIn = function () {
                        panAndZoom.zoomAtPointBy(1.25, {
                            x: $scope.uraSelecionada.DadosPlot.attributes.position.x,
                            y: $scope.uraSelecionada.DadosPlot.attributes.position.y
                        });
                    };

                    $scope.zoomOut = function () {
                        panAndZoom.zoomAtPointBy(0.75, {
                            x: $scope.uraSelecionada.DadosPlot.attributes.position.x,
                            y: $scope.uraSelecionada.DadosPlot.attributes.position.y
                        });
                    };
                }
            }

            $scope.setMenuGuid = function (ura) {
                // *Se não existir a referência, criamos e 
                // associamos a pergunta anterior
                // pois o default é sempre executar a
                // proxima pergunta.
                if (ura.UraResposta != null && ura.UraResposta.length > 0 &&
                    (ura.MenuGuid == null || ura.MenuGuid == undefined)) {
                    ura.MenuGuid = UraHelper.uuidv4();
                }
                if (ura.ChildUra) {
                    ura.ChildUra.forEach(u => {
                        $scope.setMenuGuid(u);
                    });
                }
            }

            $scope.setProxPerguntaGuid = function (ura) {
                if (ura.UraResposta) {
                    ura.UraResposta.forEach(function (res) {
                        if (res.ProxPerguntaGuid == null ||
                            res.ProxPerguntaGuid == undefined) {
                            if (ura.ChildUra.length > 0) {
                                res.ProxPerguntaGuid = ura.ChildUra[0].MenuGuid;
                            }
                            // Finaliza a pesquisa
                            else {
                                res.ProxPerguntaGuid = '-2';
                            }
                        }
                    });
                }
                if (ura.ChildUra) {
                    ura.ChildUra.forEach(child => {
                        $scope.setProxPerguntaGuid(child);
                    });
                }
            }

            $scope.resetProxPerguntaGuid = function (ura, menuGuid) {
                if (ura == null || ura.UraResposta == null) return;
                ura.UraResposta.forEach(function (res) {
                    if (res.ProxPerguntaGuid == menuGuid) {
                        res.ProxPerguntaGuid = '-1';
                    }
                });
                if (ura.ChildUra) {
                    ura.ChildUra.forEach(child => {
                        $scope.resetProxPerguntaGuid(child, menuGuid);
                    });
                }
            }

            if ($scope.isNew) {
                //Plot No Principal
                var noPrincipal = $scope.plotNo(
                    10,
                    10,
                    tamanhoNoX,
                    tamanhoNoY,
                    $translate.instant('telaUraSatisfacaoEdit.inicioDaUra'),
                    $translate.instant('editSatisfacao.introducao'), 'satisfacao', false
                );
                $('g[model-id=\'' + noPrincipal.id + '\']').addClass('satisfacao no-selecionado');
                $scope.noSelecionado = noPrincipal;
                $scope.arvoreUra.push(noPrincipal);
                //Satisfação
                $scope.ura = {
                    DadosPlot: noPrincipal,
                    ChildUra: [],
                    ParentUra: null,
                    TipoUra: 'satisfacao',
                    UraTipoId: 10,
                    AssociaExterno: false
                };
                $scope.uraSelecionada = $scope.ura;
                if ($scope.uraSelecionada.Descricao == null ||
                    $scope.uraSelecionada.Descricao == undefined) {
                    $scope.uraSelecionada.Descricao = $translate.instant('editSatisfacao.introducao');
                }
                $scope.noPodeAdicionar = true;
            } else {
                $scope.setMenuGuid($scope.ura);
                $scope.setProxPerguntaGuid($scope.ura);
                $scope.recriarReferenciaPai($scope.ura);
                $scope.transformarJsonEmDadosPlot($scope.ura);
                $scope.uraSelecionada = $scope.ura;
                $scope.plotArvoreExistente($scope.uraSelecionada);
                $scope.noSelecionado = $scope.ura.DadosPlot;
                $('#ura-builder g').removeClass('no-selecionado');
                $('g[model-id=\'' + $scope.noSelecionado.id + '\']').addClass('satisfacao no-selecionado');
                $scope.noPodeAdicionar = $scope.uraSelecionada.ChildUra.length == 0;
                $scope.ativarZoom();
            }

            //*************************
            //	FIM DE INICIALIZAÇÃO DE DIAGRAMA
            //*************************

            //INICIO TTS//

            $scope.nomeMetodoTts = "";
            $scope.configAudio = {
                Fraseologia: ''
            };

            $scope.openModalTts = function (metodo) {
                $scope.nomeMetodoTts = metodo;
                ModalService.openModal("modal_tts", null, null, null);
            };

            $scope.gerarTTS = function () {
                ModalService.showLoading();
                UraResource.geraTTS({ Texto: $scope.configAudio.Fraseologia })
                    .$promise
                    .then((data) => {
                        ModalService.hideLoading();

                        //enviar eventos 
                        ModalService.closeModal("modal_tts");
                        $scope.configAudio = {};

                        if ($scope.nomeMetodoTts == 'loadTts')
                            $scope.loadMenuCompleted(data);

                        if ($scope.nomeMetodoTts == 'loadTtsTermino')
                            $scope.loadTerminoCompleted(data);

                        if ($scope.nomeMetodoTts == 'loadTtsInvalido')
                            $scope.loadInvalidoCompleted(data);

                        if ($scope.nomeMetodoTts == 'loadTtsMaxErro')
                            $scope.loadMaxErroCompleted(data);

                        if ($scope.nomeMetodoTts == 'loadTtsPesqAudioAcao')
                            $scope.loadPesqAudioAcaoCompleted(data);

                        if ($scope.nomeMetodoTts == 'loadTtsPesqAudioTocar')
                            $scope.loadPesqAudioTocarCompleted(data);


                    }).catch((ex) => {
                        ModalService.hideLoading();
                        $scope.configAudio = {};
                    });
            }
        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (UraResource, search, orderBy, $odata) {
        var odata = UraResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.ServicoNumero) {
            odata.filter(new $odata.Func('startswith', 'Servico/Numero', search.ServicoNumero), true);
        }

        if (search.CarteiraId) {
            odata.filter("CarteiraId", "=", parseInt(search.CarteiraId));
        }

        if (search.Descricao) {
            odata.filter(new $odata.Func("contains", new $odata.Func("tolower", "Descricao"), search.Descricao.toLowerCase()), true);
        }
        /// Filtra apenas as uras de pesquisa
        odata.where('UraTipo/UraTipoId', 10);

        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.urasatisfacao", StateResolverProvider.configAbstract(null, null, {
                    proxy: 'main.urasatisfacao.list',
                    pageTitle: 'pageTitle.uraSatisfacao',
                    pageName: 'pageTitle.uraSatisfacao'
                }))
                .state("main.urasatisfacao.list", StateResolverProvider.configState("/urasatisfacao", "UraSatisfacao", "List", {
                    pageTitle: 'pageTitle.uraSatisfacao',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.urasatisfacao.edit", StateResolverProvider.configState("/urasatisfacao/{UraId}", "UraSatisfacao", "Edit", {
                    pageTitle: 'pageTitle.uraSatisfacao',
                    pageName: 'acoes.editar',
                    css: true
                }));
        }])

        .service("UraSatisfacaoListData", function UraListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_uiSelect'
                        ]);
                    }],
                    uras: ["UraResource", "LocalStorageService", "$odata", "utils", "$stateParams", function (UraResource, LocalStorageService, $odata, utils, $stateParams) {
                        var filtro = {};
                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroUra");
                        }
                        var orderBy = {
                            column: "DataAlteracao",
                            order: "desc"
                        };
                        var odata = getOdataSearchShared(UraResource, filtro, orderBy, $odata, utils);
                        return odata.page(10, 1).query();
                    }],
                    carteiras: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    ttsService : ["TtsService", function(TtsService){
                        TtsService.getVozes();
                        TtsService.setProvedores();
                        return;
                    }]
                }
            }
        })

        .controller("UraSatisfacaoListController", ["$scope", "$odata", "uras", "UraResource", "utils", "LocalStorageService", "$stateParams", "NotifyService", "$state", "ModalService", "carteiras", function ($scope, $odata, uras, UraResource, utils, LocalStorageService, $stateParams, NotifyService,
            $state, ModalService, carteiras) {
            $scope.uras = uras;
            $scope.carteiras = carteiras;
            $scope.searching = false;
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroUra") : {};
            $scope.orderBy = {
                column: "DataAlteracao",
                order: "desc"
            };

            var updateList = function (list) {
                $scope.uras = list;
                $scope.uras.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.uras.pageSize = list.$pageSize || 10;
                $scope.searching = false;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(UraResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroUra', $scope.search);
                $scope.searching = true;
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.searching = false;
                    });
            };

            var deleteRecord = function (data) {
                return UraResource.delete({ UraId: data.UraId }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    }).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data))
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.uras.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            updateList(uras);

            
            $scope.duplicarUra = function (ura) {
                if (ura) {
                    ModalService.confirmMessage('telaUraSatisfacao.confirmarDuplicarUra', null, () => {
                        UraResource.duplicarUra({
                            UraId: ura.UraId
                        }).$promise.then((res) => {
							$scope.executeSearch();
                        }).catch(NotifyService.showError);
                    });
                }
            }

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroUra');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            $scope.voltar = function () {
                if ($stateParams.page) {
                    $state.go($stateParams.page, { storage: true });
                }
                else {
                    $state.go('main.ura.list', { storage: true });
                }
            };

        }]);
})();
(function () {
    "use strict";
    angular.module("epbxManagerApp")

        .service('UsuarioArquivoEditData', function UsuarioArquivoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_fileUpload',
                            'lazy_dropify',
                            'lazy_wizard'
                        ]);
                    }]
                }
            }
        })

        .filter('cut', function () {
            return function (value, wordwise, max, tail) {
                if (!value) return '';

                max = parseInt(max, 10);
                if (!max) return value;
                if (value.length <= max) return value;

                value = value.substr(0, max);
                if (wordwise) {
                    let lastspace = value.lastIndexOf(' ');
                    if (lastspace != -1) {
                        //Also remove . and , so its gives a cleaner result.
                        if (value.charAt(lastspace - 1) == '.' || value.charAt(lastspace - 1) == ',') {
                            lastspace = lastspace - 1;
                        }
                        value = value.substr(0, lastspace);
                    }
                }
                return value + (tail || ' …');
            };
        })

        // Não remover dependencia "preloaders"
        .controller("UsuarioArquivoEditController", ["preloaders", "$rootScope", "$scope", "$state", "Upload", "$timeout", "$window", "$http", "Config", "UsuarioArquivoResource", "FileDownloadService", "NotifyService", "ModalService", "WizardHandler", function (preloaders, $rootScope, $scope, $state, Upload, $timeout, $window, $http, Config, UsuarioArquivoResource, FileDownloadService, NotifyService, ModalService, WizardHandler) {
            let urlUpload = Config.getUrl("UsuarioArquivo/Importar");

            $scope.ImportacaoStepData = {
                order: 1
            };
            $scope.ResumoStepData = {
                order: 2,
                notVisible: true
            };
            $scope.ResultadoStepData = {
                order: 3,
                notVisible: true
            };
            $scope.Arquivos = [];
            $scope.files = [];
            $scope.arquivosProcessados = 0;
            $scope.uploadFiles = function (files, errFiles) {
                if (files.length == 0 && errFiles.length == 0) return;
                $scope.errFiles = errFiles;
                angular.forEach(files, function (f) {
                    $scope.files.push(f);
                });

                angular.forEach(files, function (file) {
                    file.upload = Upload.upload({
                        url: urlUpload,
                        data: {
                            file: file,
                            nome: file.name
                        }
                    });

                    file.upload.then(function (response) {
                        let arquivo = {
                            Id: response ? response.data : 0,
                            UsuarioArquivoStatusId: 1,
                            Nome: file.name
                        };

                        $scope.Arquivos.push(arquivo);

                        file.Id = arquivo.Id;
                        
                        let drEvent = $('.dropify').dropify();
                        drEvent = drEvent.data('dropify');
                        drEvent.resetPreview();
                        drEvent.clearElement();

                    }, function (response) {
                        if (response.status > 0)
                            $scope.errorMsg = response.status + ': ' + response.data;
                    });
                });
            }

            $scope.isUploadConcluido = function () {
                return $scope.files.length > 0 ? true : false;
            };

            $scope.formatSizeUnits = function (bytes) {
                if (bytes >= 1000000000) {
                    bytes = (bytes / 1000000000).toFixed(2) + ' GB';
                } else if (bytes >= 1000000) {
                    bytes = (bytes / 1000000).toFixed(2) + ' MB';
                } else if (bytes >= 1000) {
                    bytes = (bytes / 1000).toFixed(2) + ' KB';
                } else if (bytes > 1) {
                    bytes = bytes + ' bytes';
                } else if (bytes == 1) {
                    bytes = bytes + ' byte';
                } else {
                    bytes = '0 byte';
                }
                return bytes;
            };

            $scope.quantidadeArquivo = 10;

            $scope.concluir = function() {
                $state.go('main.usuarios.arquivos.list');
            }

        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (UsuarioArquivoResource, search, orderBy, $odata) {
        var odata = UsuarioArquivoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }

        if (search.UsuarioArquivoStatusId) {            
            odata.filter('UsuarioArquivoStatusId', search.UsuarioArquivoStatusId);
        }
        
        return odata;
    };

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.usuarios.arquivos", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    permissions: {
                        'Usuarios': 'Arquivo'
                    }
                })
                .state("main.usuarios.arquivos.list", StateResolverProvider.configState("/usuarios/arquivos", "UsuarioArquivo", "List", {
                    pageTitle: 'model.usuario',
                    pageName: 'campo.arquivo',
                    permissions: {
                        'Usuarios': 'Arquivo'
                    }
                }))
                .state("main.usuarios.arquivos.importar", StateResolverProvider.configState("/usuarios/arquivos/importar", "UsuarioArquivo", "Edit", {
                    pageTitle: 'acoes.importar',
                    pageName: 'acoes.importar',
                    permissions: {
                        'Usuarios': 'Arquivo'
                    }
                }))
        }])

        .service('UsuarioArquivoListData', function UsuarioArquivoListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_wizard',
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    usuarioArquivos: ["UsuarioArquivoResource", "LocalStorageService", "$odata", "$stateParams", function (UsuarioArquivoResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = {};
   
                        if ($stateParams.storage) {
                            filtro = LocalStorageService.getItem("FiltroUsuarioArquivo");
                        }
   
                        var orderBy = {
                            column: "Id",
                            order: "desc"
                        };
   
                        var odata =  getOdataSearchShared(UsuarioArquivoResource, filtro, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }],
                    usuarioArquivoStatus: ["UsuarioArquivoResource", function (UsuarioArquivoResource) {
                        return UsuarioArquivoResource.GetUsuarioArquivoStatus().$promise;
                    }]
                }
            }
        })

        .controller("UsuarioArquivoListController", ["$scope", "$odata", "$http", "$state", "Config", "utils", "LocalStorageService", "$stateParams", "FileDownloadService", "NotifyService", "ModalService", "UsuarioArquivoResource", "usuarioArquivos", "usuarioArquivoStatus", function ($scope, $odata, $http, $state, Config, utils, LocalStorageService, $stateParams, 
            FileDownloadService, NotifyService, ModalService, UsuarioArquivoResource, usuarioArquivos, usuarioArquivoStatus) {
            $scope.forms = [];
            $scope.searching = false;

            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroUsuarioArquivo") : {};

            $scope.orderBy = {
                column: "Id",
                order: "desc"
            };

            $scope.usuarioArquivos = usuarioArquivos;
            $scope.usuarioArquivoStatus = usuarioArquivoStatus;



            var updateList = function (list) {
                $scope.usuarioArquivos = list;
                $scope.usuarioArquivos.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.usuarioArquivos.pageSize = list.$pageSize || 10;
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(UsuarioArquivoResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.pageChanged = function (newPage) {
                return getOdataSearch()
                    .page($scope.usuarioArquivos.pageSize, newPage)
                    .query().then(updateList).catch(NotifyService.showError);
            };


            $scope.executeSearch = function () {
                LocalStorageService.setItem('FiltroUsuarioArquivo', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroUsuarioArquivo');
                $scope.search = {
                    pageSize: 10
                };
                $scope.executeSearch();
            };

            $scope.processarArquivo = function (arquivo) {
				UsuarioArquivoResource.ProcessarArquivo(arquivo).$promise
					.then(() => {
						NotifyService.showSuccess();
                        $scope.executeSearch();
					}).catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
				ModalService.confirmDelete(() => deleteArquivo(data));
			};

            var deleteArquivo = function (data) {
				return UsuarioArquivoResource.delete({ id: data.Id }).$promise
					.then(() => {
						NotifyService.showSuccess();
                        $scope.executeSearch();
					}).catch(NotifyService.showError);
			};

            updateList(usuarioArquivos);

        }]
        );
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UsuarioArquivoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("UsuarioArquivo/:Id", { "Id": "@Id" },
                {
                    GetUsuarioArquivoStatus: {
                        url: "UsuarioArquivo/UsuarioArquivoStatus",
                        method: "GET",
                        isArray: true
                    },
                    Importar: {
                        url: "UsuarioArquivo/Importar",
                        method: "POST"
                    },
                    ProcessarArquivo: {
                        url: "UsuarioArquivo/ProcessarArquivo/:Id",
                        method: "PUT"
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.usuario", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.perfil.list',
                        pageTitle: 'pageTitle.alterarSenha',
                        pageName: 'header.perfil',
                        permissions: {
                            AllowAnonymous: true
                        }
                    }
                })
                .state("main.usuario.alterarsenha", StateResolverProvider.configState("/usuario/alterarsenha", "Usuario", "AlterarSenha", {
                    pageTitle: 'pageTitle.alterarSenha',
                    pageName: 'pageTitle.alterarSenha'
                }));

        }])

        .service("UsuarioAlterarSenhaData", function UsuarioAlterarSenhaData() {
            return function () {
                return {
                    avatarList: ["PerfilResource", function (PerfilResource) {
                        return PerfilResource.usuarioAvatar().$promise;
                    }]
                }
            }
        })

        .controller("UsuarioAlterarSenhaController", ["$scope", "$translate", "UsuarioResource", "AuthService", "NotifyService", "avatarList", "$state", function ($scope, $translate, UsuarioResource, AuthService, NotifyService, avatarList, $state) {
            $scope.Form = {
                SenhaAtual: '',
                NovaSenha: '',
                ConfirmarNovaSenha: ''
            }
            $scope.Usuario = AuthService.getUsuarioLogado();

            $scope.usuarioEdit = {
                Imagem: avatarList.Imagem,
            };

            $scope.erroSenhaForte = '';
            $scope.senhaForte = false;

            $scope.onAlterarSenha = function (event) {
                event.preventDefault();
                if (!$scope.Form.SenhaAtual || !$scope.Form.NovaSenha) {
                    return NotifyService.showMessage('alterarSenhaUsuario.naoFoiPossivelAtualizarASenha', "danger");
                }
                if ($scope.Form.SenhaAtual === $scope.Form.NovaSenha) {
                    return NotifyService.showMessage('alterarSenhaUsuario.aNovaSenhaDeveSerDiferenteDaAtual', "danger");
                }
                if ($scope.Form.NovaSenha != $scope.Form.ConfirmarNovaSenha) {
                    return NotifyService.showMessage('alterarSenhaUsuario.osCamposDevemSerIguais', "danger");
                }

                UsuarioResource.AlterarSenha($scope.Form).$promise
                    .then(() => {
                        NotifyService.showMessage('alterarSenhaUsuario.senhaAtualizadaComSucesso', "success");
                        $state.go('main.perfil.list');
                    }).catch(function (error) {
                        if (error && error.data) {
                            NotifyService.showMessage(error.data.Message, "danger");
                        }
                    });

            };

            $scope.validateSenhaForte = function () {
                let senha = document.getElementById("input-chave-NovaSenha").value;
				if (senha.length >= 8 && senha.length <= 16) {
					if(!senha.match(/[a-z]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('alterarSenhaUsuario.senhaForteCaractereMinusculo');
					} else if(!senha.match(/[A-Z]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('alterarSenhaUsuario.senhaForteCaractereMaiusculo');
					} else if(!senha.match(/[0-9]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('alterarSenhaUsuario.senhaForteCaractereNumerico');
					} else if(!senha.match(/[\W|_]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('alterarSenhaUsuario.senhaForteCaractereEspecial');
					} else {
						$scope.senhaForte = false;
						$scope.erroSenhaForte = '';
					}
				} else {
					$scope.senhaForte = true;
                    $scope.erroSenhaForte = $translate.instant('alterarSenhaUsuario.senhaForteLength');
				}
			};

        }]);

})();
(function () {
	"use strict";

	angular.module("epbxManagerApp")

		.service('UsuarioEditData', function UsuarioEditData() {
			return function () {
				return {
					deps: ["$ocLazyLoad", function ($ocLazyLoad) {
						return $ocLazyLoad.load([
							'lazy_wizard',
							'lazy_uiSelect'
						]);
					}],
					usuario: ["UsuarioResource", "$stateParams", "LocalStorageService", function (UsuarioResource, $stateParams, LocalStorageService) {
						if ($stateParams.UsuarioId) {
							return UsuarioResource.get({ UsuarioId: $stateParams.UsuarioId }).$promise;
						} else {
							return $stateParams.storage ? LocalStorageService.getItem('Usuario') : {};
						}
					}],
					tipos: ["UsuarioTipoResource", "$filter", function (UsuarioTipoResource, $filter) {
						return UsuarioTipoResource.ObterTiposComPermissao().$promise.then((data) => { 
							return $filter('orderBy')(data, "Descricao") 
						});
					}],
					ramaisLivres: ["RamalResource", "$stateParams", function (RamalResource, $stateParams) {
						return RamalResource.ramaisLivres({
							UsuarioId: $stateParams.UsuarioId || 0
						}).$promise;
					}],
					perfis: ["AtendimentoConfiguracaoResource", function (AtendimentoConfiguracaoResource) {
						return AtendimentoConfiguracaoResource.odata().orderBy("Descricao", "asc").query();
					}],
					usuarioCarteiraAssociado: ["UsuarioResource", "$stateParams", function (UsuarioResource, $stateParams) { 
						let id = 0;
						if($stateParams.UsuarioId){ 
							id = parseInt($stateParams.UsuarioId)
						}                 
                        return UsuarioResource.GetUsuarioCarteiraAssociado({
                            usuarioId: id
                        }).$promise;
                    }],
					usuarioCarteiraNaoAssociado: ["UsuarioResource", "$stateParams", function (UsuarioResource, $stateParams) { 
						let id = 0;
						if($stateParams.UsuarioId){ 
							id = parseInt($stateParams.UsuarioId)
						}                  
                        return UsuarioResource.GetUsuarioCarteiraNaoAssociado({
                            usuarioId: id
                        }).$promise;
                    }],
					autenticacaoTipo: ["UsuarioResource", function (UsuarioResource) {
                        return UsuarioResource.GetAutenticacaoTipo().$promise;
                    }],
                    chaveApi: ["UsuarioResource", function(UsuarioResource) {
                        return UsuarioResource.GetApiKey().$promise;
                    }],
					cliente: ["ClienteResource", function (ClienteResource) {
						return ClienteResource.get({
							ClienteId: 1
						}).$promise;
					}]
				}
			}
		})

		.controller("UsuarioEditController", ["$scope", "$translate", "usuario", "tipos", "ramaisLivres", "perfis", "UsuarioResource", "LocalStorageService", "$state", "$stateParams", "AuthService", "NotifyService", "ModalService", "WizardHandler", "usuarioCarteiraAssociado", "usuarioCarteiraNaoAssociado", "autenticacaoTipo", "chaveApi", "cliente", function ($scope, $translate, usuario, tipos, ramaisLivres, perfis, UsuarioResource, LocalStorageService, $state, $stateParams,
			AuthService, NotifyService, ModalService, WizardHandler, usuarioCarteiraAssociado, usuarioCarteiraNaoAssociado, autenticacaoTipo, chaveApi, cliente) {
			usuario.UsuarioId = (usuario.UsuarioId > 0 ? usuario.UsuarioId : (isNaN(parseInt($stateParams.UsuarioId)) ? 0 : parseInt($stateParams.UsuarioId)));
			$scope.isEdit = usuario && usuario.UsuarioId ? true : false;
			$scope.isNew = usuario.UsuarioId > 0 ? false : true;
			$scope.usuario = usuario;
			$scope.usuario.AlterarSenhaPrimeiroLogin = ($scope.isNew ? true : usuario.AlterarSenhaPrimeiroLogin);
			$scope.usuario.ExpirarSenha = ($scope.isNew ? true : usuario.ExpirarSenha);
			$scope.usuario.alterarSenha = false;
			$scope.forms = {};
			$scope.exitValidationUsuario = true;
			$scope.exitValidationPermissao = true;
			$scope.exitValidationGrupo = true;
			$scope.exitValidationCarteira = true;
			$scope.tipos = tipos;
			$scope.ramaisLivres = ramaisLivres;
			$scope.perfis = perfis;
			$scope.salvando = false;
			$scope.usuarioCarteiraAssociado = usuarioCarteiraAssociado;
			$scope.usuarioCarteiraNaoAssociado = usuarioCarteiraNaoAssociado;
			$scope.autenticacaoTipo = autenticacaoTipo;
            $scope.usuario.gerarApiKey = false;
            $scope.chaveApi = chaveApi.find(f => f.Descricao == usuario.Nome);
			$scope.senhaForte = false;			
			$scope.erroSenhaForte = '';		
			$scope.cliente = cliente;	

 			$scope.messageExpirouSenha = $translate.instant('telaEditUsuarios.expirarSenha', {dias : cliente.QuantidadeDias });

			$scope.usuario.GruposNaoAdicionados = _.filter($scope.usuario.GruposNaoAdicionados, function (el) {
				return el.GrupoTipoId != 6;
			});
			$scope.usuario.GruposAdicionados = _.filter($scope.usuario.GruposAdicionados, function (el) {
				return el.GrupoTipoId != 6;
			});

			$scope.usuario.SkillsAdicionadas = $scope.usuario.SkillsAdicionadas || [];
			$scope.usuario.SkillsNaoAdicionadas = $scope.usuario.SkillsNaoAdicionadas || [];

			// Snapshot do estado original das Skills para detectar mudança ao salvar
			$scope.skillsOriginais = {
				considerar: $scope.usuario.ConsiderarSkills === true,
				ids: _.pluck($scope.usuario.SkillsAdicionadas, 'SkillId').sort()
			};

			// Soma "lógica" das skills associadas, exibida na aba 5.
			// É independente do valor efetivamente enviado ao CTI (que é truncado
			// no backend para caber em um byte). Atualizado APENAS nos eventos que
			// mudam o estado (adicionar/remover skill, checkbox, ramal) — sem $watch
			// deep nem recálculo a cada digest, mantendo zero impacto em performance.
			$scope.valorTotalSkillExibicao = 0;
			$scope.recalcularValorTotalSkillExibicao = function () {
				if (!$scope.usuario.ConsiderarSkills || !$scope.usuario.RamalId) {
					$scope.valorTotalSkillExibicao = 0;
					return;
				}
				$scope.valorTotalSkillExibicao = ($scope.usuario.SkillsAdicionadas || []).reduce(function (acc, s) {
					return acc + (parseInt(s.Valor, 10) || 0);
				}, 0);
			};
			$scope.recalcularValorTotalSkillExibicao();

			$scope.descricoesColunasCarteira = {
                CarteiraId: 'telaEditUsuarios.codigoCarteira',
                Nome: 'telaEditUsuarios.nomeCarteira'
            }

			$scope.exitValidationUsuario = function () {
				var alterado = $scope.isNew ? false : $scope.forms.formUsuario.$dirty;
				var proximoStep = false;

				if (alterado) {
					ModalService.confirmDescartar(() => {
						$scope.forms.formUsuario.$dirty = false;
						$scope.forms.formUsuario.$setPristine();
					});
				} else {
					if ($scope.forms.formUsuario.$valid) {
						proximoStep = true;
					}
				}
				return proximoStep;
			}

			$scope.exitValidationPermissao = function () {
				var alterado = $scope.isNew ? false : $scope.forms.formPermissoes.$dirty;
				var proximoStep = false;

				if (alterado) {
					ModalService.confirmDescartar(() => {
						$scope.forms.formPermissoes.$dirty = false;
						$scope.forms.formPermissoes.$setPristine();
					});
				} else {
					if ($scope.forms.formPermissoes.$valid) {
						proximoStep = true;
					}
				}

				return proximoStep;
			}

			$scope.exitValidationCarteira = function () {
				var alterado = $scope.isNew ? false : $scope.forms.formCarteira.$dirty;
				var proximoStep = false;

				if (alterado) {
					ModalService.confirmDescartar(() => {
						$scope.forms.formCarteira.$dirty = false;
						$scope.forms.formCarteira.$setPristine();
					});
				} else {
					if ($scope.forms.formCarteira.$valid) {
						proximoStep = true;
					}
				}

				return proximoStep;
			}

			$scope.exitValidationGrupo = function () {
				var alterado = $scope.isNew ? false : $scope.forms.formGrupos.$dirty;
				var proximoStep = false;

				if (alterado) {
					ModalService.confirmDescartar(() => {
						$scope.forms.formGrupos.$dirty = false;
						$scope.forms.formGrupos.$setPristine();
					});
				} else {
					if ($scope.forms.formGrupos.$valid) {
						proximoStep = true;
					}
				}

				return proximoStep;
			}


			$scope.validateSenhaForte = function (senha) {
                
				if (senha.length >= 8 && senha.length <= 16) {
					if(!senha.match(/[a-z]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('telaEditUsuarios.senhaForteCaractereMinusculo');
					} else if(!senha.match(/[A-Z]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('telaEditUsuarios.senhaForteCaractereMaiusculo');
					} else if(!senha.match(/[0-9]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('telaEditUsuarios.senhaForteCaractereNumerico');
					} else if(!senha.match(/[\W|_]+/)) {
						$scope.senhaForte = true;
						$scope.erroSenhaForte = $translate.instant('telaEditUsuarios.senhaForteCaractereEspecial');
					} else {
						$scope.senhaForte = false;
						$scope.erroSenhaForte = '';
					}
				} else {
					$scope.senhaForte = true;
                    $scope.erroSenhaForte = $translate.instant('telaEditUsuarios.senhaForteLength');
				}
			};

			$scope.senhaForteCadastro = function () {
				let senha = document.getElementById("Senha").value;

				$scope.validateSenhaForte(senha)
			};

			$scope.senhaForteAtualizar = function () {
				let senha = document.getElementById("NovaSenha").value;

				$scope.validateSenhaForte(senha)
			};

			$scope.salvar = function (form) {
				var lastStep = form.$name == "forms.formSkills" ? true : false;

				if (!form.$valid) {
					return NotifyService.showInvalid();
				}

				if (!form.$dirty && lastStep) {
					$state.go("main.usuarios.list", {
						page: 'main.usuarios.list'
					});
				}

				if(usuario.alterarSenha && $scope.senhaForte == true)
					return NotifyService.showError(null, 'notificacoes.preenchaCorretamente');

				$scope.salvando = true;

				var promise;

				if ($scope.usuario.Senha && $scope.usuario.ConfirmaSenha) {
					if ($scope.usuario.Senha != $scope.usuario.ConfirmaSenha) {
						$scope.salvando = false;
						return NotifyService.showError(null, 'telaEditUsuarios.senhaIncorreta');
					}
				}

				$scope.usuario.UsuarioCarteira = $scope.usuarioCarteiraAssociado;
				$scope.usuario.UsuarioCarteiraNaoAssociado = $scope.usuarioCarteiraNaoAssociado;

				if (form.$dirty) {
					if ($scope.usuario.UsuarioId > 0) {
						promise = UsuarioResource.update($scope.usuario).$promise;
					}
					else {
						promise = UsuarioResource.save($scope.usuario).$promise;
					}

					promise.then((res) => {
						if ($scope.usuario.UsuarioId == 0) {
							$scope.usuario.Menus = res.Menus;
						}
						var userLogado = AuthService.getUsuarioLogado();
						if ($scope.usuario.UsuarioId == userLogado.UsuarioId) {
							AuthService.refreshUsuario();
						}
						if ($scope.usuario.Senha && $scope.usuario.ConfirmaSenha) {
							if ($scope.usuario.Senha == $scope.usuario.ConfirmaSenha) {
								$scope.usuario.alterarSenha = false;
							}
						}
						$scope.usuario = res;
						
						$scope.usuarioCarteiraAssociado = $scope.usuario.UsuarioCarteira;
						$scope.usuarioCarteiraNaoAssociado = $scope.usuario.UsuarioCarteiraNaoAssociado;

						$scope.usuario.alterarSenha = false;
						NotifyService.showRegistroSalvo();
						$scope.salvando = false;
						if ($scope.isNew && form.$name == "forms.formUsuario") {
							WizardHandler.wizard().next();
						}
						form.$setPristine();
					}).catch((error) => {
						NotifyService.showError(error);
						$scope.salvando = false
					});
				}
				else {
					WizardHandler.wizard().next();
					$scope.salvando = false;
				}

				if ((($scope.isNew && lastStep) || lastStep) && !form.$dirty) {
					$state.go("main.usuarios.list", {
						page: 'main.usuarios.list'
					});
				}
			};

			$scope.novoRamal = function () {
				LocalStorageService.setItem('Usuario', $scope.usuario);
				$state.go("main.ramais.new", {
					page: 'main.usuarios.new'
				});
			};

			$scope.cancelar = function () {
				if ($stateParams.page) {
					$state.go($stateParams.page, {
						storage: true
					});
				}
				else {
					$state.go('main.usuarios.list', {
						storage: true
					});
				}
			};

			$scope.getMenusByParent = function (sistemaMenuId) {
				return _.where(usuario.Menus, {
					ParentId: sistemaMenuId
				});
			};

			$scope.getMenus = function () {
				return _.where(usuario.Menus, {
					ParentId: null
				});
			};

			$scope.limitGrupos = 5;
			$scope.limitGruposAdicionados = 5;

			$scope.adicionarGrupo = function () {
				var gruposSelecionados = _.where($scope.usuario.GruposNaoAdicionados, {
					Selecionado: true
				});

				angular.forEach(gruposSelecionados, (item) => {
					item.Selecionado = false;
					$scope.usuario.GruposAdicionados.push(item);
					$scope.usuario.GruposNaoAdicionados.splice($scope.usuario.GruposNaoAdicionados.indexOf(item), 1);
				});

				if ($scope.forms.formGrupos) {
					$scope.forms.formGrupos.$dirty = true;
				}
			};

			$scope.removerGrupo = function () {
				var gruposSelecionados = _.where($scope.usuario.GruposAdicionados, {
					Selecionado: true
				});

				angular.forEach(gruposSelecionados, function (item) {
					item.Selecionado = false;
					$scope.usuario.GruposNaoAdicionados.push(item);
					$scope.usuario.GruposAdicionados.splice($scope.usuario.GruposAdicionados.indexOf(item), 1);
				});

				if ($scope.forms.formGrupos)
					$scope.forms.formGrupos.$dirty = true;
			};

			$scope.selectionarTodosAdicionados = function (todosAdicionados) {
				angular.forEach($scope.usuario.GruposAdicionados, (item) => {
					if (todosAdicionados) {
						item.Selecionado = true;
					} else {
						item.Selecionado = false;
					}
				});
			};

			$scope.selectionarTodosNaoAdicionados = function (todosNaoAdicionados) {
				angular.forEach($scope.usuario.GruposNaoAdicionados, (item) => {
					if (todosNaoAdicionados) {
						item.Selecionado = true;
					} else {
						item.Selecionado = false;
					}
				});
			};

			$scope.maisGruposAdicionados = function () {
				if ($scope.limitGruposAdicionados < $scope.usuario.GruposAdicionados.length) {
					$scope.limitGruposAdicionados += 5;
					$("#gruposAdicionados").animate({
						scrollTop: $("#tabGruposAdicionados").height()
					}, 800);
				}
			};

			$scope.maisGruposNaoAdicionados = function () {
				if ($scope.limitGrupos < $scope.usuario.GruposNaoAdicionados.length) {
					$scope.limitGrupos += 5;
					$("#gruposNaoAdicionados").animate({
						scrollTop: $("#tabGruposNaoAdicionados").height()
					}, 800);
				}
			};

			$scope.pesquisaGrupos = function (searchGrupos, length, lengthAdicionados) {
				var lengthTotal = $scope.usuario.GruposNaoAdicionados.length;
				var lengthAdicionadosTotal = $scope.usuario.GruposAdicionados.length;
				if (searchGrupos.length > 0) {
					if (lengthTotal != length) {
						$scope.limitGrupos = lengthTotal;
					}

					if (lengthAdicionadosTotal != lengthAdicionados) {
						$scope.limitGruposAdicionados = lengthAdicionadosTotal;
					}
				}
				else {
					$scope.limitGrupos = 5;
					$scope.limitGruposAdicionados = 5;
				}
			};

			$scope.selecionarPermissoesGeral = function(Menus, $event) {
				Menus.forEach((menu) => {
					$scope.selecionarTodasPermissoes(menu, $event)
					$scope.forms.formPermissoes.$setDirty();
				});
			}

			$scope.selecionarTodasPermissoes = function (menu, $event) {
				menu.Submenus.forEach((sub) => {
					sub.Recursos.forEach((el) => {
						if (el.PossuiAcesso != true) {
							el.PossuiAcesso = true;
							$scope.forms.formPermissoes.$setDirty();
						}
					})
				});

				$scope.usuario.Menus.forEach(menuFilho => {
					if (menuFilho.ParentId == menu.SistemaMenuId) {
						menuFilho.Recursos.forEach((el) => {
							if (el.PossuiAcesso != true) {
								el.PossuiAcesso = true;
								$scope.forms.formPermissoes.$setDirty();
							}
						});
					}
				});

				$event.preventDefault();
				$event.stopPropagation();
			}

			$scope.removerTodasPermissoes = function (menu, $event) {
				menu.Submenus.forEach(sub => {
					sub.Recursos.forEach(el => {
						if (el.PossuiAcesso == true) {
							el.PossuiAcesso = false;
							$scope.forms.formPermissoes.$setDirty();
						}
					});
				});

				$scope.usuario.Menus.forEach(menuFilho => {
					if (menuFilho.ParentId == menu.SistemaMenuId) {
						menuFilho.Recursos.forEach(el => {
							if (el.PossuiAcesso == true) {
								el.PossuiAcesso = false;
								$scope.forms.formPermissoes.$setDirty();
							}
						});
					}
				});
				$event.preventDefault();
				$event.stopPropagation();
			}

            $scope.GerarApiKey = function () {
                if($scope.chaveApi == null){
                    UsuarioResource.PostGerarApiKey({ Descricao: usuario.Nome, UsuarioId: $stateParams.UsuarioId }).$promise
                    .then((res) => {
                        UsuarioResource.GetApiKeyId({ UsuarioId: res.id }).$promise.then((res) => {
                            $scope.chaveApi = res;
                        });
                    }).catch((error) => {
                        NotifyService.showError(error);
                        $scope.salvando = false
                    });
                }
            }

            $scope.GerarNovaApikey = function () {
                UsuarioResource.PutGerarNovaApiKey({ UsuarioId: $scope.chaveApi.SegurancaChaveApiId }).$promise
                .then((res) => {
                    $scope.chaveApi.Chave = res.Chave;
                }).catch((error) => {
                    NotifyService.showError(error);
                    $scope.salvando = false
                });
            }

            $scope.copyToClipboard = function(element) {
                let $temp = $("<input>");
                $("body").append($temp);
                $temp.val($(element).text()).select();
                document.execCommand("copy");
                $temp.remove();
            };

			$("#gruposAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
				if ($scope.limitGruposAdicionados < $scope.usuario.GruposAdicionados.length) {
					$scope.$apply(() => {
						if (e.originalEvent.wheelDelta / 120 < 0) {
							$scope.limitGruposAdicionados += 5;
							$("#gruposAdicionados").animate({
								scrollTop: $("#tabGruposAdicionados").height()
							}, 800);
						}
					});
				}
			});

			$("#gruposNaoAdicionados").bind("DOMMouseScroll mousewheel", (e) => {
				if ($scope.limitGrupos < $scope.usuario.GruposNaoAdicionados.length) {
					$scope.$apply(() => {
						if (e.originalEvent.wheelDelta / 120 < 0) {
							$scope.limitGrupos += 5;
							$("#gruposNaoAdicionados").animate({
								scrollTop: $("#tabGruposNaoAdicionados").height()
							}, 800);
						}
					});
				}
			});
			
			$scope.ramalObrigatorio = function () {
                if (!$scope.usuario || !$scope.usuario.UsuarioTipoId) return false;
                var tipo = _.findWhere($scope.tipos, { UsuarioTipoId: $scope.usuario.UsuarioTipoId });
                if (!tipo) return false;
                var idUsuario = (tipo.UsuarioTipoId);
                return idUsuario != 1 && idUsuario !== 2;
            };

			// ===== Aba 5 - Skills =====

			$scope.exitValidationSkills = function () {
				var alterado = $scope.isNew ? false : ($scope.forms.formSkills && $scope.forms.formSkills.$dirty);
				var proximoStep = false;
				if (alterado) {
					ModalService.confirmDescartar(function () {
						$scope.forms.formSkills.$dirty = false;
						$scope.forms.formSkills.$setPristine();
					});
				} else if (!$scope.forms.formSkills || $scope.forms.formSkills.$valid) {
					proximoStep = true;
				}
				return proximoStep;
			};

			// Quando o RamalId muda, se foi desassociado e o checkbox estava true,
			// força para false (regra: não considerar skills sem ramal).
			$scope.$watch('usuario.RamalId', function (newVal, oldVal) {
				if (newVal === oldVal) return;
				if ((!newVal || newVal <= 0) && $scope.usuario.ConsiderarSkills === true) {
					$scope.usuario.ConsiderarSkills = false;
					if ($scope.forms.formSkills) $scope.forms.formSkills.$dirty = true;
				}
				$scope.recalcularValorTotalSkillExibicao();
			});

			$scope.onConsiderarSkillsChange = function () {
				if ($scope.usuario.ConsiderarSkills === true && !$scope.usuario.RamalId) {
					// Salvaguarda - não pode marcar sem ramal
					$scope.usuario.ConsiderarSkills = false;
					return;
				}
				if ($scope.forms.formSkills) $scope.forms.formSkills.$dirty = true;
				$scope.recalcularValorTotalSkillExibicao();
			};

			$scope.adicionarSkill = function () {
				var selecionadas = _.where($scope.usuario.SkillsNaoAdicionadas, { Selecionado: true });
				angular.forEach(selecionadas, function (item) {
					item.Selecionado = false;
					$scope.usuario.SkillsAdicionadas.push(item);
					$scope.usuario.SkillsNaoAdicionadas.splice($scope.usuario.SkillsNaoAdicionadas.indexOf(item), 1);
				});
				if ($scope.forms.formSkills) $scope.forms.formSkills.$dirty = true;
				$scope.recalcularValorTotalSkillExibicao();
			};

			$scope.removerSkill = function () {
				var selecionadas = _.where($scope.usuario.SkillsAdicionadas, { Selecionado: true });
				angular.forEach(selecionadas, function (item) {
					item.Selecionado = false;
					$scope.usuario.SkillsNaoAdicionadas.push(item);
					$scope.usuario.SkillsAdicionadas.splice($scope.usuario.SkillsAdicionadas.indexOf(item), 1);
				});
				if ($scope.forms.formSkills) $scope.forms.formSkills.$dirty = true;
				$scope.recalcularValorTotalSkillExibicao();
			};

			$scope.selecionarTodasSkillsAdicionadas = function (todos) {
				angular.forEach($scope.usuario.SkillsAdicionadas, function (item) { item.Selecionado = !!todos; });
			};

			$scope.selecionarTodasSkillsNaoAdicionadas = function (todos) {
				angular.forEach($scope.usuario.SkillsNaoAdicionadas, function (item) { item.Selecionado = !!todos; });
			};
		}]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (UsuarioResource, search, orderBy, $odata) {
        var filtroGrupoId, odata = UsuarioResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }
        if (search.Login) {
            odata.filter(new $odata.Func("startswith", "Login", search.Login), true);
        }
        if (search.Ramal) {
            odata.filter("RamalNumero", "=", parseInt(search.Ramal));
        }
        if (search.UsuarioStatusId) {
            odata.filter("UsuarioStatusId", "=", parseInt(search.UsuarioStatusId));
        }
        if (search.UsuarioTipoId) {
            odata.filter("UsuarioTipoId", "=", parseInt(search.UsuarioTipoId));
        }
        if (search.AutenticacaoTipoId) {
            odata.filter("AutenticacaoTipoId", "=", parseInt(search.AutenticacaoTipoId));
        }
        if (search.GrupoId) {
            filtroGrupoId = new $odata.Predicate("x:x/GrupoId", parseInt(search.GrupoId)).execute(false, true);
            odata.filter(new $odata.Func('GrupoUsuario/any', new $odata.Property(filtroGrupoId)));
        }

        return odata;
    }

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.usuarios", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.usuarios.list',
                        pageTitle: 'model.usuario',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.usuarios.list", StateResolverProvider.configState("/usuarios?storage", "Usuario", "List", {
                    pageTitle: 'model.usuario',
                    pageName: 'pageTitle.pesquisar'
                }))
                .state("main.usuarios.new", StateResolverProvider.configState("/usuarios/new?page&storage&ramal", "Usuario", "Edit", {
                    pageTitle: 'model.usuario',
                    pageName: 'acoes.cadastrar',
                    css: true
                }))
                .state("main.usuarios.edit", StateResolverProvider.configState("/usuarios/{UsuarioId:[0-9]+}", "Usuario", "Edit", {
                    pageTitle: 'model.usuario',
                    pageName: 'acoes.editar',
                    css: true
                }))
        }])

        .service('UsuarioListData', function UsuarioListData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_dropify',
                            'lazy_uiSelect'
                        ]);
                    }],
                    usuarios: ["UsuarioResource", "LocalStorageService", "$odata", "$stateParams", function (UsuarioResource, LocalStorageService, $odata, $stateParams) {
                        var filtro = $stateParams.storage? LocalStorageService.getItem("FiltroUsuario") :  { UsuarioStatusId: 1 };

                        var orderBy = {
                            column: "UsuarioId",
                            order: "asc"
                        }

                        var odata = getOdataSearchShared(UsuarioResource, filtro, orderBy, $odata);
                        return odata.page(10, 1).query();
                    }],
                    grupoList: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.getGrupoSimples().$promise;
                    }],
                    tipos: ["UsuarioTipoResource", "$filter", function (UsuarioTipoResource, $filter) {
                        return UsuarioTipoResource.ObterTiposComPermissao().$promise.then((data) => {
                            return $filter('orderBy')(data, "Descricao")
                        });
                    }],
                    perfilList: ["PerfilResource", function (PerfilResource) {
                        return PerfilResource.usuarioLogado().$promise;
                    }],
                    autenticacaoTipo: ["UsuarioResource", function (UsuarioResource) {
                        return UsuarioResource.GetAutenticacaoTipo().$promise;
                    }],
                }
            }
        })

        .controller("UsuarioListController", ["$scope", "$state", "usuarios", "UsuarioResource", "$http", "$window", "$odata", "$rootScope", "LocalStorageService", "$stateParams", "grupoList", "tipos", "AuthService", "PerfilResource", "Config", "NotifyService", "ModalService", "$translate", "autenticacaoTipo", "FileDownloadService", function ($scope, $state, usuarios, UsuarioResource, $http, $window, $odata, $rootScope, LocalStorageService, $stateParams,
            grupoList, tipos, AuthService, PerfilResource, Config, NotifyService, ModalService, $translate, autenticacaoTipo, FileDownloadService) {
            $scope.usuarioLogado = AuthService.getUsuarioLogado();
            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroUsuario") : { UsuarioStatusId: 1 };
            $scope.grupoList = grupoList;
            $scope.tipos = tipos;
            $scope.submitted = false;
            $scope.autenticacaoTipo = autenticacaoTipo;

            $scope.orderBy = {
                column: "UsuarioId",
                order: "asc"
            };

            $scope.status = [
                { UsuarioStatusId: 1, Descricao: $translate.instant('status.ativo') },
                { UsuarioStatusId: 2, Descricao: $translate.instant('status.inativo') }
            ];

            var arquivoValido = false;

            $scope.editPerfil = function (usuario) {
                clearDropify();
                $scope.imagem = '';
                $scope.imagemReduzida = '';
                var progressbar = $("#file_upload-progressbar");
                if (progressbar) {
                    var bar = progressbar.find('.uk-progress-bar');
                    if (bar) {
                        var settings = {
                            action: '/', // upload url
                            allow: '*.(jpg|jpeg|gif|png)', // allow only images

                            loadstart: function () {
                                bar.css("width", "0%").text("0%");
                                progressbar.removeClass("uk-hidden");
                            },

                            progress: function (percent) {
                                percent = Math.ceil(percent);
                                bar.css("width", percent + "%").text(percent + "%");
                            },

                            allcomplete: function () {
                                bar.css("width", "100%").text("100%");
                                setTimeout(function () {
                                    progressbar.addClass("uk-hidden");
                                }, 250);

                                $scope.$apply(function () {
                                    $scope.usuarioEdit.Avatar.Imagem = $scope.imagem;
                                });
                            }
                        }
                    }
                    $window.UIkit.uploadSelect($("#file_upload-select"), settings);
                    $window.UIkit.uploadDrop($("#file_upload-drop"), settings);
                }

                $scope.usuarioEdit = usuario;
                var dvUpload = $('#dvUploadImagem');
                var dvImagem = $('#dvImagem');
                if (dvImagem) {
                    dvUpload.hide();
                    dvImagem.show();
                }

                $http({
                    method: 'GET',
                    url: Config.getUrl("Perfil/Avatar/" + usuario.UsuarioId)
                }).then(function (response) {
                    var avatarList = response.data;
                    $scope.usuarioEdit = usuario;
                    $scope.usuarioEdit.Avatar = avatarList;
                    if ($scope.usuarioEdit.Avatar) {
                        $scope.imagem = $scope.usuarioEdit.Avatar.imagem
                    }
                });

                ModalService.openModal('modalPerfil');

            };

            $scope.savePerfil = function (valid) {
                if (!arquivoValido) {
                    return NotifyService.showError(null, 'notificacoes.erroAoFazerUpload');
                }

                if (!valid) {
                    return NotifyService.showInvalid();
                }

                if ($scope.imagem) {
                    $scope.usuarioEdit.Avatar.ImagemReduzida = $scope.imagemReduzida;
                    $scope.usuarioEdit.Avatar.Imagem = $scope.imagem;
                }

                var promise = PerfilResource.update($scope.usuarioEdit).$promise;

                promise.then(() => {
                    ModalService.closeModal('modalPerfil');
                    NotifyService.showRegistroAlterado();
                    if ($scope.usuarioEdit.UsuarioId == $scope.usuarioLogado.UsuarioId) {
                        $rootScope.$broadcast('atualizaImagem', {
                            imagemReduzida: $scope.imagemReduzida
                        });
                    }
                }).catch(NotifyService.showError);
            };

            $scope.alteraImagem = function () {
                var dvUpload = $('#dvUploadImagem');
                var dvImagem = $('#dvImagem');
                if (dvUpload) {
                    dvImagem.hide();
                    dvUpload.show(300);
                }
            }

            $scope.uploadFile = function () {
                var file = event.target.files[0];

                if (file) {
                    var isImage = file.type.startsWith('image');

                    if (isImage) {
                        arquivoValido = true;
                        var reader = new FileReader();

                        reader.onload = function (e) {
                            convertImage(e.target.result);
                        };

                        reader.readAsDataURL(file);

                        var dvUpload = $('#dvUploadImagem');
                        var dvImagem = $('#dvImagem');
                        if (dvImagem) {
                            dvUpload.hide();
                            dvImagem.show();
                        }
                    }
                    else {
                        NotifyService.showMessage('telaUsuario.oArquivoNaoEImagem', 'warning')
                        arquivoValido = false;
                    }
                }
            };

            var convertImage = function (base64) {
                var img = new Image();
                img.src = base64;

                img.onload = function () {
                    var tempW = img.width;
                    var tempH = img.height;
                    var scaleReduzida = Math.min((34 / tempW), (34 / tempH));
                    var scaleNormal = Math.min((82 / tempW), (82 / tempH));
                    var canvasReduzida = document.createElement("canvas");
                    canvasReduzida.width = tempW * scaleReduzida;
                    canvasReduzida.height = tempH * scaleReduzida;
                    var ctxReduzida = canvasReduzida.getContext("2d");
                    ctxReduzida.drawImage(this, 0, 0, tempW * scaleReduzida, tempH * scaleReduzida);
                    $scope.imagemReduzida = canvasReduzida.toDataURL("image/png", 1.0);
                    ctxReduzida.clearRect(0, 0, img.width, img.height);
                    var canvasNormal = document.createElement("canvas");
                    canvasNormal.width = tempW * scaleNormal;
                    canvasNormal.height = tempH * scaleNormal;
                    var ctxNormal = canvasNormal.getContext("2d");
                    ctxNormal.drawImage(this, 0, 0, tempW * scaleNormal, tempH * scaleNormal);
                    $scope.imagem = canvasNormal.toDataURL("image/png", 1.0);
                    ctxNormal.clearRect(0, 0, img.width, img.height);
                    if ($scope.usuarioEdit) {
                        $scope.usuarioEdit.Avatar = { Imagem: $scope.imagem };
                    }
                }
            }

            var updateList = function (list) {
                $scope.usuarios = list;
                $scope.usuarios.recordCount = list.$recordCount || list.length;
                $scope.currentPage = list.$currentPage || 1;
                $scope.usuarios.pageSize = list.$pageSize || 10;
                $scope.submitted = false;
            }

            var getOdataSearch = function () {
                return getOdataSearchShared(UsuarioResource, $scope.search, $scope.orderBy, $odata);
            };

            $scope.executeSearch = function () {
                $scope.submitted = true;
                LocalStorageService.setItem('FiltroUsuario', $scope.search);
                getOdataSearch().page($scope.search.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error);
                        $scope.submitted = false;
                    });
            }

            $scope.confirmDelete = function (usuario) {
                ModalService.confirmDelete(() => {
                    UsuarioResource.Inativar({ UsuarioId: usuario.UsuarioId }).$promise
                        .then(() => {
                            $scope.pageChanged($scope.currentPage);
                            NotifyService.showRegistroSalvo();
                        }).catch(NotifyService.showError);
                });
            }

            $scope.ativarNovamente = function (usuario) {
                ModalService.confirmMessage($translate.instant('telaUsuario.desejaReativarUsuario'), null, () => {
                    UsuarioResource.Reativar({ UsuarioId: usuario.UsuarioId }).$promise
                        .then(() => {
                            $scope.pageChanged($scope.currentPage);
                            NotifyService.showRegistroSalvo();
                        }).catch(NotifyService.showError);
                });
            }

            $scope.expirarSenha = function (usuario) {
                ModalService.confirmMessage($translate.instant('telaUsuario.desejaExpirarSenha'), null, () => {
                    UsuarioResource.ExpirarSenha({ UsuarioId: usuario.UsuarioId }).$promise
                        .then(() => {
                            $scope.pageChanged($scope.currentPage);
                            NotifyService.showRegistroSalvo();
                        }).catch(NotifyService.showError);
                });
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.usuarios.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            $scope.exportarUsuarios = function () {
                try {
                    ModalService.showLoading();
                    var fileName = generateUUID();
                    UsuarioResource.exportarUsuarios({
                        Nome: $scope.search.Nome,
                        Login: $scope.search.Login,
                        Ramal: $scope.search.Ramal,       
                        UsuarioStatusId: $scope.search.UsuarioStatusId,                 
                        UsuarioTipoId: $scope.search.UsuarioTipoId,                        
                        AutenticacaoTipoId: $scope.search.AutenticacaoTipoId,
                        FileName: fileName
                    }).$promise.then(() => {
                        FileDownloadService.downloadWebApiFile("Usuario/Download/" + fileName);
                        ModalService.hideLoading();
                    }).catch((data) => {
                        ModalService.hideLoading();
                        NotifyService.showError(data.error);
                    });
                } catch (err) {
                    NotifyService.showError(err);
                }
            }

            function generateUUID() {
                var d = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid;
            }

            $scope.ImportarArquivos = function () {
                $state.go('main.usuarios.arquivos.list');
            };

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroUsuario');
                $scope.search = {};
                $scope.search.GrupoId = 0;
                $scope.executeSearch();
            }

            updateList(usuarios);

            var clearDropify = function () {
                var drEvent = $('#input-file-a').dropify();
                drEvent = drEvent.data('dropify');
                drEvent.resetPreview();
                drEvent.clearElement();
            }

        }]);

})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UsuarioResource", ["$odataresource", function ($odataresource) {
            return $odataresource("Usuario/:UsuarioId", { "UsuarioId": "@UsuarioId" },
                {
                    Reativar: { 
                        method: "PUT", 
                        url: "Usuario/:UsuarioId/Reativar" 
                    },
                    Inativar: { 
                        method: "PUT", 
                        url: "Usuario/:UsuarioId/Inativar" 
                    },
                    AlterarSenha: { 
                        method: "PUT", 
                        url: "Usuario/AlterarSenha" 
                    },
                    GetTodosUsuario: { 
                        method: "GET", 
                        url: "Usuario/GetTodosUsuario", 
                        isArray: true 
                    },
                    GetUsuarioCarteiraNaoAssociado: { 
                        method: "GET", 
                        url: "Usuario/UsuarioCarteiraNaoAssociado", 
                        isArray: true 
                    },
                    GetUsuarioCarteiraAssociado: { 
                        method: "GET",
                        url: "Usuario/UsuarioCarteiraAssociado", 
                        isArray: true 
                    },
                    GetAutenticacaoTipo: {
                        method: "GET",
                        url: "Usuario/AutenticacaoTipo", 
                        isArray: true
                    },
                    PostGerarApiKey: {
                        method: "POST",
                        url: "Usuario/GerarApiKey"
                    },
                    PutGerarNovaApiKey: {
                        method: "PUT",
                        url: "Usuario/:UsuarioId/GerarNovaApiKey"
                    },
                    GetApiKey: {
                        method: "GET",
                        url: "SegurancaChaveApi",
                        isArray: true
                    },
                    GetApiKeyId: {
                        method: "GET",
                        url: "SegurancaChaveApi/:UsuarioId"
                    },
                    GetUsuarioPorCarteira: {
                        url: "Usuario/UsuariosPorCarteira",
                        method: "GET",
                        isArray: true,
                        params: {
                            "carteiraId": "@carteiraId"
                        }
                    },
                    GetTodosUsuarioAtivo: {
                        url: "Usuario/GetTodosUsuarioAtivo",
                        method: "GET",
                        isArray: true,
                        params: {
                            "carteiraId": "@carteiraId",
                            "ramalTipoId": "@ramalTipoId"
                        }
                    },
                    AlterarSenhaExpirada: { 
                        method: "PUT", 
                        url: "Usuario/AlterarSenhaExpirada" 
                    },
                    AlterarSenhaPrimeiroLogin: { 
                        method: "PUT", 
                        url: "Usuario/AlterarSenhaPrimeiroLogin" 
                    },
                    ExpirarSenha: { 
                        method: "PUT", 
                        url: "Usuario/:UsuarioId/ExpirarSenha" 
                    },
                    EsqueciMinhaSenha: {
                        url: "Usuario/EsqueciMinhaSenha",
                        method: "PUT",
                        params: {
                            "login": "@login",
                            "mensagem": "@mensagem",
                            "assunto": "@assunto"
                        }
                    },
                    AlterarEsqueciSenha: {
                        method: "Put", 
                        url: "Usuario/AlterarEsqueciSenha/:UsuarioId" 
                    },
                    ValidaDataLink: {
                        url: "Usuario/ValidaDataLink",
                        method: "GET",
                        params: {
                            "hashCode": "@hashCode"
                        }
                    },                    
                    exportarUsuarios: {
                        url: "Usuario/Exportar",
                        method: "POST"
                    },
                    download: {
                        url: "Usuario/Download",
                        method: "GET",  
                    }
                });
        }]);

})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.webhook.edit", StateResolverProvider.configState("/webhook/{Id:[0-9]+}", "Webhook", "Edit", {
                    pageTitle: 'pageTitle.webhook',
                    pageName: 'acoes.editar',
                }))
                .state("main.webhook.new", StateResolverProvider.configState("/webhook/new", "Webhook", "Edit", {
                    pageTitle: 'pageTitle.webhook',
                    pageName: 'acoes.cadastrar',
                }));
        }])

        .service("WebhookEditData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            "lazy_wizard",
                        ]);
                    }],
                    webhook: ["WebhookResource", "$stateParams", function (WebhookResource, $stateParams) {
                        if ($stateParams.Id) {
                            return WebhookResource.get({
                                Id: parseInt($stateParams.Id)
                            }).$promise;
                        } else {
                            return {};
                        }
                    }],
                    webhookProvedorTipoList: ["WebhookResource", function (WebhookResource) {                    
                        return WebhookResource.getWebhookProvedorTipo().$promise;
                    }],
                    webhookAutenticacaoTipoList: ["WebhookResource", function (WebhookResource) {                    
                        return WebhookResource.getWebhookAutenticacaoTipo().$promise;
                    }],
                    carteiraList: ["CarteiraResource", function (CarteiraResource) {
                        return CarteiraResource.query().$promise;
                    }],
                    campanhasList: ["CampanhaResource", function (CampanhaResource) {
                        var odata = CampanhaResource.odata();
                        return odata.select(["CampanhaId", "Nome","CarteiraId"]).query();
                    }],
                    statusList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatus().$promise;
                    }],
                    campanhaDiscagemStatusList: ["CampanhaDiscagemStatusResource", function (CampanhaDiscagemStatusResource) {
                        return CampanhaDiscagemStatusResource.query().$promise;
                    }],
                    bilheteStatusDetalheList: ["BilheteResource", function (BilheteResource) {
                        return BilheteResource.bilheteStatusDetalhe().$promise;
                    }],
                    templateMiner: ["IntegracaoResource", function (IntegracaoResource) {                   
                        return IntegracaoResource.GetTemplateMiner().$promise;
                    }],
                    grupoList: ["GrupoResource", function(GrupoResource) {
                        return GrupoResource.getTodosGrupos();
                    }],
                    categorias: ["AtendimentoTipoResource", function(AtendimentoTipoResource){
                        return AtendimentoTipoResource.getCategorias();
                    }]
                };
            };
        })

        .controller("WebhookEditController", ["$scope", "ModalService", "NotifyService", "WebhookResource", "$state", "$translate", "webhook", "webhookProvedorTipoList", "webhookAutenticacaoTipoList", "carteiraList", "campanhasList", "statusList", "campanhaDiscagemStatusList", "bilheteStatusDetalheList", "templateMiner", "grupoList", "categorias", function ($scope, ModalService, NotifyService, WebhookResource, $state, $translate, webhook, webhookProvedorTipoList, webhookAutenticacaoTipoList,
            carteiraList, campanhasList, statusList, campanhaDiscagemStatusList, bilheteStatusDetalheList, templateMiner, grupoList, categorias) {

            $scope.isNew = (webhook.Id > 0 ? false : true);
            $scope.webhook = webhook;
            $scope.campanhas = campanhasList;
            $scope.grupos = _.filter(grupoList, function(item) {return item.Ativo == 1 });
            $scope.webhookProvedorTipoList = _.sortBy(webhookProvedorTipoList, function (x) { return x.Descricao });
            $scope.webhookAutenticacaoTipoList = _.sortBy(webhookAutenticacaoTipoList, function (x) { return x.Descricao });
            $scope.carteiraList = _.sortBy(carteiraList, function (x) { return x.Nome });  
            $scope.campanhasList = _.sortBy(campanhasList, function (x) { return x.Nome });
            $scope.gruposList = _.sortBy($scope.grupos, function (x) { return x.GrupoFormatado });
            $scope.statusList = _.sortBy(statusList, function (x) { return x.Descricao });
            $scope.campanhaDiscagemStatusList = _.sortBy(campanhaDiscagemStatusList, function (x) { return x.Descricao }); 
            $scope.bilheteStatusDetalheList = _.sortBy(bilheteStatusDetalheList, function (x) { return x.Descricao });
            $scope.categoriasList = categorias;
            $scope.categorias = categorias;
            $scope.forms = {};
            $scope.proximoStep = false;
            $scope.webhookJson = '';
            $scope.templateMiner = templateMiner;

            $scope.direcaoList = [
                { DirecaoId: 2, Descricao: $translate.instant('campo.efetuada') },
                { DirecaoId: 1, Descricao: $translate.instant('campo.recebida') }
            ];

            if ($scope.webhook.WebhookProvedorFiltro) {
                $scope.webhook.WebhookProvedorFiltro.Carteiras = $scope.webhook.WebhookProvedorFiltro.Carteiras != null ? $scope.webhook.WebhookProvedorFiltro.Carteiras.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.Campanhas = $scope.webhook.WebhookProvedorFiltro.Campanhas != null ? $scope.webhook.WebhookProvedorFiltro.Campanhas.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.BilheteStatus = $scope.webhook.WebhookProvedorFiltro.BilheteStatus != null ? $scope.webhook.WebhookProvedorFiltro.BilheteStatus.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.Direcoes = $scope.webhook.WebhookProvedorFiltro.Direcoes != null ? $scope.webhook.WebhookProvedorFiltro.Direcoes.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.CampanhaDiscagemStatus = $scope.webhook.WebhookProvedorFiltro.CampanhaDiscagemStatus != null ? $scope.webhook.WebhookProvedorFiltro.CampanhaDiscagemStatus.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.BilheteStatusDetalhe = $scope.webhook.WebhookProvedorFiltro.BilheteStatusDetalhe != null ? $scope.webhook.WebhookProvedorFiltro.BilheteStatusDetalhe.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.Grupos = $scope.webhook.WebhookProvedorFiltro.Grupos != null ? $scope.webhook.WebhookProvedorFiltro.Grupos.split(',') : null;
                $scope.webhook.WebhookProvedorFiltro.Categorias = $scope.webhook.WebhookProvedorFiltro.Categorias != null ? $scope.webhook.WebhookProvedorFiltro.Categorias.split(',') : null;
            }
            $scope.webhookFiltros = $scope.webhook.WebhookProvedorFiltro != null ? $scope.webhook.WebhookProvedorFiltro : {};

          

            $scope.validateWebhook = function () {
                $scope.proximoStep = $scope.forms.formWebhook.$valid ? true : false;
                return $scope.proximoStep;
            };

            $scope.onChangeAutenticacaoTipo = function () {
                switch($scope.webhook.WebhookAutenticacaoTipoId) {
                    case 1:
                        $scope.webhook.Usuario = null;
                        $scope.webhook.Senha = null;
                        $scope.webhook.UrlAutenticacao = null;
                        break;
                    case 2:
                        $scope.webhook.ApiKey = null;
                        break;
                    case 3:
                        $scope.webhook.Usuario = null;
                        $scope.webhook.Senha = null;
                        $scope.webhook.ApiKey = null;
                        $scope.webhook.UrlAutenticacao = null;
                        break;
                }
            };

            $scope.onChangeEnvioLote = function () {
                if ($scope.webhook.EnvioLote) {
                    $scope.webhook.QtdLote = null;
                }
            };

            $scope.salvar = function (form) {
                var lastStep = form.$name == "forms.formFiltros" ? true : false;

                if (!form.$valid) {
                    return NotifyService.showInvalid();
                }  

                if(typeof $scope.webhookFiltros.Carteiras != "string") {
                    $scope.webhookFiltros.Carteiras = ($scope.webhookFiltros.Carteiras == null || $scope.webhookFiltros.Carteiras == 0) ? null : $scope.webhookFiltros.Carteiras.join();
                }

                if(typeof $scope.webhookFiltros.Campanhas != "string") {
                    $scope.webhookFiltros.Campanhas = ($scope.webhookFiltros.Campanhas == null || $scope.webhookFiltros.Campanhas == 0) ? null : $scope.webhookFiltros.Campanhas.join();
                }

                if(typeof $scope.webhookFiltros.Grupos != "string") {
                    $scope.webhookFiltros.Grupos = ($scope.webhookFiltros.Grupos == null || $scope.webhookFiltros.Grupos == 0) ? null : $scope.webhookFiltros.Grupos.join();
                }

                if(typeof $scope.webhookFiltros.BilheteStatus != "string") {
                    $scope.webhookFiltros.BilheteStatus = ($scope.webhookFiltros.BilheteStatus == null || $scope.webhookFiltros.BilheteStatus == 0) ? null : $scope.webhookFiltros.BilheteStatus.join();
                }

                if(typeof $scope.webhookFiltros.Direcoes != "string") {
                    $scope.webhookFiltros.Direcoes = ($scope.webhookFiltros.Direcoes == null || $scope.webhookFiltros.Direcoes == 0) ? null : $scope.webhookFiltros.Direcoes.join();
                }

                if(typeof $scope.webhookFiltros.CampanhaDiscagemStatus != "string") {
                    $scope.webhookFiltros.CampanhaDiscagemStatus = ($scope.webhookFiltros.CampanhaDiscagemStatus == null || $scope.webhookFiltros.CampanhaDiscagemStatus == 0) ? null : $scope.webhookFiltros.CampanhaDiscagemStatus.join();
                }

                if(typeof $scope.webhookFiltros.BilheteStatusDetalhe != "string") {
                    $scope.webhookFiltros.BilheteStatusDetalhe = ($scope.webhookFiltros.BilheteStatusDetalhe == null || $scope.webhookFiltros.BilheteStatusDetalhe == 0) ? null : $scope.webhookFiltros.BilheteStatusDetalhe.join();
                }

                if(typeof $scope.webhookFiltros.BilheteStatusDetalhe != "string") {
                    $scope.webhookFiltros.Categorias = ($scope.webhookFiltros.Categorias == null || $scope.webhookFiltros.Categorias == 0) ? null : $scope.webhookFiltros.Categorias.join();
                }
                
                var data = {
                    Id: $scope.webhook.Id,
                    WebhookProvedorTipoId: $scope.webhook.WebhookProvedorTipoId,
                    WebhookAutenticacaoTipoId: $scope.webhook.WebhookAutenticacaoTipoId,   
                    WebhookProvedorStatusId: $scope.isNew ? 1 : $scope.webhook.WebhookProvedorStatusId,
                    Nome: $scope.webhook.Nome,
                    Url: $scope.webhook.Url,
                    ApiKey: $scope.webhook.ApiKey,
                    Usuario: $scope.webhook.Usuario,
                    Senha: $scope.webhook.Senha,
                    UrlAutenticacao: $scope.webhook.UrlAutenticacao,
                    EnvioLote: $scope.webhook.EnvioLote,
                    QtdLote: $scope.webhook.QtdLote,
                    Filtro: $scope.webhookFiltros,
                    TemplateMinerId: $scope.webhook.TemplateMinerId,
                    HabilitaLog: $scope.webhook.HabilitaLog,
                    EnviaBilheteDialogo: $scope.webhook.WebhookProvedorTipoId == 1 ? !!$scope.webhook.EnviaBilheteDialogo : false,
                    IdentificadorMiner: $scope.webhook.TemplateMinerId ? $scope.templateMiner.find(x => x.TemplateMinerId == $scope.webhook.TemplateMinerId).IdentificadorAlias : null
                };

                if(lastStep) {
                    $scope.salvarWebhook(data);
                }
            };

            $scope.salvarWebhook = function (data) {
                var promise;
                if ($scope.webhook.Id > 0) {
                    promise = WebhookResource.update(data.Id, data).$promise;
                }
                else {
                    promise = WebhookResource.save(data).$promise;
                }

                promise.then(() => {
                    let message = $scope.isNew ? 'telaEditWebhook.webhookAdicionadoComSucesso' : 'telaEditWebhook.webhookAlteradoComSucesso';

                    NotifyService.showSuccess($translate.instant(message));
                    $state.go('main.webhook.list');
                })
                .catch(NotifyService.showError);
            };

            $scope.carregarJson = function()
            {
                var tipo = $scope.webhookProvedorTipoList.find(el => el.WebhookProvedorTipoId == webhook.WebhookProvedorTipoId);

                if(tipo != undefined)
                    $scope.webhookJson = tipo.Json
            }

            $scope.parJson = function (json) {
                if (json == null || json == '') return json;
                return JSON ? JSON.parse(json, null) : json;
            }

            if(!$scope.isNew)
            {
                $scope.carregarJson();
            }

              

            let getCarteiraPorGrupo = function(ids) {
                $scope.gruposList = $scope.grupos.filter(item => ids.includes(item.CarteiraId));
            };
            let getCarteiraPorCampanha = function(ids) {
                $scope.campanhasList = $scope.campanhas.filter(item => ids.includes(item.CarteiraId));
            };
            let getCategoriasPorCarteira = function(ids) {
                $scope.categoriasList = $scope.categorias.filter(item => ids.includes(item.CarteiraId));
            };

            $scope.onChangeCarteira = function(ids) {
                if(ids != undefined)
                {
                    getCarteiraPorGrupo(ids);
                    getCarteiraPorCampanha(ids);
                    getCategoriasPorCarteira(ids);
                }
                else
                {
                    $scope.gruposList = $scope.grupos;
                    $scope.campanhasList = $scope.campanhas;
                    $scope.categoriasList = $scope.categorias;
                }
            };

            if(!$scope.isNew)
            {
                if($scope.webhook != undefined && $scope.webhook.WebhookProvedorFiltro != undefined)
                {
                    if($scope.webhook.WebhookProvedorFiltro.Carteiras != undefined && $scope.webhook.WebhookProvedorFiltro.Carteiras.length > 0)
                    {
                        const intArray = $scope.webhook.WebhookProvedorFiltro.Carteiras.map(str => {
                            const num = parseInt(str, 10);
                            return isNaN(num) ? null : num;
                        });

                        $scope.onChangeCarteira(intArray);
                    }
                }            
            }

        }]);
})();

(function () {
    "use strict";

    var getOdataSearchShared = function (WebhookResource, search, orderBy, $odata) {
        var odata = WebhookResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Nome) {
            odata.filter(new $odata.Func("startswith", "Nome", search.Nome), true);
        }

        if (search.WebhookProvedorTipoId) {
            odata.filter('WebhookProvedorTipoId', search.WebhookProvedorTipoId);
        }

        if (search.WebhookAutenticacaoTipoId) {
            odata.filter('WebhookAutenticacaoTipoId', search.WebhookAutenticacaoTipoId);
        }

        return odata;
    };

    angular.module("epbxManagerApp")    
    
    .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
        $stateProvider
            .state("main.webhook", {
                url: "",
                template: '<ui-view autoscroll="true"/>',
                abstract: true,
                data: {
                    proxy: 'main.webhook.list',
                    pageTitle: 'pageTitle.cardTitle',
                    pageName: 'pageTitle.pesquisar'
                }
            })
            .state("main.webhook.list", StateResolverProvider.configState("/webhook", "Webhook", "List", {
                pageTitle: 'pageTitle.webhook',
                pageName: 'pageTitle.pesquisar'
            }));
    }])

    .service("WebhookListData", function WebhookListData() {
        return function () {
            return {
                deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    return $ocLazyLoad.load([
                        'lazy_uiSelect'
                    ]);
                }],
                webhookProvedorList: ["WebhookResource", "LocalStorageService", "$odata", "$stateParams", function (WebhookResource, LocalStorageService, $odata, $stateParams) {
                    var filtro = {};

                    if ($stateParams.storage) {
                        filtro = LocalStorageService.getItem("FiltroWebhook");
                    }

                    var orderBy = {
                        column: "Id",
                        order: "desc"
                    };

                    return getOdataSearchShared(WebhookResource, filtro, orderBy, $odata).page(10, 1).query();
                }],
                webhookProvedorTipoList: ["WebhookResource", function (WebhookResource) {                    
                    return WebhookResource.getWebhookProvedorTipo().$promise;
                }],
                webhookAutenticacaoTipoList: ["WebhookResource", function (WebhookResource) {                    
                    return WebhookResource.getWebhookAutenticacaoTipo().$promise;
                }]
            }
        }
    })

    .controller("WebhookListController", ["$scope", "$odata", "WebhookResource", "LocalStorageService", "$stateParams", "NotifyService", "ModalService", "webhookProvedorList", "webhookProvedorTipoList", "webhookAutenticacaoTipoList", "$translate", function ($scope, $odata, WebhookResource, LocalStorageService, $stateParams, NotifyService, ModalService, webhookProvedorList,
        webhookProvedorTipoList, webhookAutenticacaoTipoList,$translate) {

        $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroWebhook") : {
            Nome: '',
            WebhookProvedorTipoId: 0,
            WebhookAutenticacaoTipoId: 0
        };

        $scope.orderBy = {
            column: "Id",
            order: "desc"
        };

        $scope.errorObject = {};


        $scope.webhookProvedorTipoList = webhookProvedorTipoList;
        $scope.webhookAutenticacaoTipoList = webhookAutenticacaoTipoList;

        var updateList = function (list) {
            $scope.webhookProvedorList = list;
            $scope.webhookProvedorList.recordCount = list.$recordCount || list.length;
            $scope.currentPage = list.$currentPage || 1;
            $scope.webhookProvedorList.pageSize = list.$pageSize || 10;
        };

        updateList(webhookProvedorList);

        var getOdataSearch = function () {
            return getOdataSearchShared(WebhookResource, $scope.search, $scope.orderBy, $odata);
        };

        $scope.pageChanged = function (newPage) {
            return getOdataSearch()
                .page($scope.webhookProvedorList.pageSize, newPage)
                .query().then(updateList).catch(NotifyService.showError);
        };

        $scope.executeSearch = function () {
            LocalStorageService.setItem('FiltroWebhook', $scope.search);
            getOdataSearch().page($scope.search.pageSize, 1).query()
                .then(updateList)
                .catch(NotifyService.showError);
        };

        $scope.limparFiltro = function () {
            LocalStorageService.removeItem('FiltroWebhook');
            $scope.search = {
                pageSize: 10
            };
            $scope.executeSearch();
        };

        var deleteWebhook = function (data) {
            return WebhookResource.delete({ Id: data.Id }).$promise
                .then(() => {
                    NotifyService.showSuccess();
                    $scope.executeSearch();
                })
                .catch(NotifyService.showError);
        };

        $scope.confirmDelete = function (data) {
            ModalService.confirmMessage('telaWebhook.confirmDeleteWebhook', null, () => deleteWebhook(data));
        };
        
        $scope.alterarStatus = function (data, status){
                data.WebhookProvedorStatusId = status;
                WebhookResource.putAtualizaStatus(data.Id, data).$promise.then(() => {                
                NotifyService.showSuccess($translate.instant(status == 2 ? 'telaWebhook.webhookpausadoTemporariamente': 'telaWebhook.iniciaWebhook'));
            })
            .catch(NotifyService.showError);   
        }
    }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("WebhookResource", ["$odataresource", function ($odataresource) {
            return $odataresource("WebhookProvedor/:Id", { "Id": "@Id" },
                {
                    getWebhookProvedorTipo: {
                        url: "WebhookProvedor/WebhookProvedorTipo",
                        method: "GET",
                        isArray: true
                    },
                    getWebhookAutenticacaoTipo: {
                        url: "WebhookProvedor/WebhookAutenticacaoTipo",
                        method: "GET",
                        isArray: true
                    },
                    putAtualizaStatus:{
                        url: "WebhookProvedor/WebhookAtualizarStatus",
                        method: "PUT",
                    }
                });
        }]);
})();
(function () {
    "use strict";

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.usuariotiporecurso.new", StateResolverProvider.configState("/usuariotiporecurso/new", "UsuarioTipoRecurso", "Edit", {
                    pageTitle: 'pageTitle.usuarioTipo',
                    pageName: 'acoes.cadastrar',
                    css: true,
                    cssFiles: ['app/pages/usuario/style/edit.css', 'app/pages/usuarioTipoRecurso/style/edit.css']
                }))
                .state("main.usuariotiporecurso.edit", StateResolverProvider.configState("/usuariotiporecurso/{UsuarioTipoId:[0-9]+}", "UsuarioTipoRecurso", "Edit", {
                    pageTitle: 'pageTitle.usuarioTipo',
                    pageName: 'acoes.editar',
                    css: true,
                    cssFiles: ['app/pages/usuario/style/edit.css', 'app/pages/usuarioTipoRecurso/style/edit.css']
                }));
        }])

        .service('UsuarioTipoRecursoEditData', function UsuarioTipoEditData() {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_masked_inputs',
                            'lazy_wizard',
                            'lazy_uiSelect'
                        ]);
                    }],
                    usuariotipo: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        return $stateParams.UsuarioTipoId ? UsuarioTipoResource.GetPorIdioma({ TipoId: $stateParams.UsuarioTipoId }).$promise : {};
                    }],
                    usuarioTipoPermitidos: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        if ($stateParams.UsuarioTipoId) {
                            return UsuarioTipoResource.GetUsuarioTipoPermitidos({ id: $stateParams.UsuarioTipoId }).$promise
                        } else { return [] }
                    }],
                    usuarioTipoNaoPermitidos: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        if ($stateParams.UsuarioTipoId) {
                            return UsuarioTipoResource.GetUsuarioTipoNaoPermitidos({ id: $stateParams.UsuarioTipoId }).$promise;
                        } else {
                            return UsuarioTipoResource.GetUsuarioTipoNaoPermitidos({ id: 0 }).$promise;
                        }
                    }],
                    gruposPermitidos: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        if ($stateParams.UsuarioTipoId) {
                            return UsuarioTipoResource.GetGruposPermitidos({ id: $stateParams.UsuarioTipoId }).$promise
                        } else { return [] }
                    }],
                    gruposNaoPermitidos: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        if ($stateParams.UsuarioTipoId) {
                            return UsuarioTipoResource.GetGruposNaoPermitidos({ id: $stateParams.UsuarioTipoId }).$promise;
                        } else {
                            return UsuarioTipoResource.GetGruposNaoPermitidos({ id: 0 }).$promise;
                        }
                    }],
                    usuarioTipoCarteiraNaoAssociado: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        if ($stateParams.UsuarioTipoId) {
                            return UsuarioTipoResource.GetUsuarioTipoCarteiraNaoAssociado({ id: $stateParams.UsuarioTipoId }).$promise;
                        } else {
                            return [];
                        }
                    }],
                    usuarioTipoCarteiraAssociado: ["UsuarioTipoResource", "$stateParams", function (UsuarioTipoResource, $stateParams) {
                        if ($stateParams.UsuarioTipoId)
                            return UsuarioTipoResource.GetUsuarioTipoCarteiraAssociado({ id: $stateParams.UsuarioTipoId }).$promise;
                        else
                            return [];
                    }]
                }
            }
        })

        .controller("UsuarioTipoRecursoEditController", ["$scope", "usuariotipo", "UsuarioTipoResource", "$state", "NotifyService", "WizardHandler", "$translate", "ModalService", "usuarioTipoPermitidos", "usuarioTipoNaoPermitidos", "gruposPermitidos", "gruposNaoPermitidos", "usuarioTipoCarteiraNaoAssociado", "usuarioTipoCarteiraAssociado", function ($scope, usuariotipo, UsuarioTipoResource, $state, NotifyService, WizardHandler, $translate,
            ModalService, usuarioTipoPermitidos, usuarioTipoNaoPermitidos, gruposPermitidos, gruposNaoPermitidos, usuarioTipoCarteiraNaoAssociado, usuarioTipoCarteiraAssociado) {
            $scope.salvando = false;
            $scope.forms = [];
            $scope.checkbox = [];

            $scope.isNew = usuariotipo.UsuarioTipoId > 0 ? false : true;

            $scope.usuarioTipoNaoPermitidosAntigo = usuarioTipoNaoPermitidos.slice();
            $scope.usuarioTipoPermitidosAntigo = usuarioTipoPermitidos.slice();
            $scope.usuarioTipoNaoPermitidos = usuarioTipoNaoPermitidos || [];
            $scope.usuarioTipoPermitidos = usuarioTipoPermitidos || [];

            $scope.gruposNaoPermitidosAntigo = gruposNaoPermitidos.slice();
            $scope.gruposPermitidosAntigo = gruposPermitidos.slice();
            $scope.gruposNaoPermitidos = gruposNaoPermitidos || [];
            $scope.gruposPermitidos = gruposPermitidos || [];

            $scope.usuarioTipoCarteiraNaoAssociado = usuarioTipoCarteiraNaoAssociado || [];
            $scope.usuarioTipoCarteiraAssociado = usuarioTipoCarteiraAssociado || [];
            $scope.usuarioTipoCarteiraNaoAssociadoAntigo = usuarioTipoCarteiraNaoAssociado.slice();;
            $scope.usuarioTipoCarteiraAssociadoAntigo = usuarioTipoCarteiraAssociado.slice();

            $scope.isNovo = !(usuariotipo && usuariotipo.UsuarioTipoId);
            $scope.usuariotipo = usuariotipo;
            $scope.hideSteps = $scope.isNovo ? true : false;
            var formSelecionado;

            $scope.descricoesColunasUsuarioTipo = {
                Descricao: 'telaEditPermissoes.tipoDeUsuario'
            }
            $scope.descricoesColunasGrupo = {
                Descricao: 'model.grupo'
            }
            $scope.descricoesColunasCarteira = {
                Nome: 'model.carteira'
            }   

            var mensagemSucesso = function (resposta) {
                NotifyService.showSuccess($translate.instant('notificacoes.registroSalvo'))
                $scope.usuariotipo = resposta;
                $scope.isNew = $scope.usuariotipo.UsuarioTipoId > 0 ? false : true;
                setTimeout(() => {
                    formSelecionado.$setPristine();
                }, 100)

                if (isLastStep()) {
                    $state.go('main.usuariotiporecurso.list');
                }
            };

            var isLastStep = function () {
                return formSelecionado.$name === "forms.PermissoesUsuarioTipo" ? true : false;
            };

            $scope.salvar = function (form) {
                formSelecionado = form;
                if (form.$dirty) {
                    $scope.salvando = true;
                    if (!$scope.isNovo) {

                        if(form.$name != "forms.UsuarioTipo")
                            ModalService.confirmMessage('telaEditPermissoes.aplicarAlteracao', null,
                                () => { $scope.atualizar(true); },
                                { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } }, () => {
                                    
                        $scope.salvando = false;
                        formSelecionado.$setPristine();
                                  });
                        else
                            $scope.atualizar(true);
                        

                    }
                    else {
                        if ($scope.usuariotipo.UsuarioTipoId > 0) {

                            ModalService.showLoading();

                            $scope.usuariotipo.AtualizarUsuarios = false;
                            UsuarioTipoResource.update($scope.usuariotipo).$promise
                                .then(r => {
                                    mensagemSucesso(r);
                                    $scope.salvando = false;
                                    ModalService.hideLoading();
                                })
                                .catch(e => {
                                    ModalService.hideLoading();
                                    NotifyService.showError(e);
                                    $scope.salvando = false;
                                });
                        } else {

                            ModalService.showLoading();

                            UsuarioTipoResource.save($scope.usuariotipo).$promise
                                .then(r => {
                                    mensagemSucesso(r);
                                    $scope.hideSteps = false;
                                    $scope.salvando = false;
                                    ModalService.hideLoading();
                                })
                                .catch(e => {
                                    ModalService.hideLoading();
                                    NotifyService.showError(e);
                                    $scope.salvando = false;
                                });
                        }                        
                    }
                } else {
                    if (isLastStep()) {
                        $state.go('main.usuariotiporecurso.list');
                    } else {
                        WizardHandler.wizard().next();
                        $scope.salvando = false;
                    }
                }
            };

            $scope.atualizar = function (atualizarUsuarios) {
                // Define se irá atualizar as permissões dos usuários associados
                $scope.usuariotipo.AtualizarUsuarios = atualizarUsuarios;
                
                // Atualiza as permissões do tipo de usuário

                ModalService.showLoading();

                UsuarioTipoResource.update($scope.usuariotipo).$promise
                    .then(r => {
                        mensagemSucesso(r);
                        $scope.salvando = false;
                        ModalService.hideLoading();
                    })
                    .catch(e => {
                        NotifyService.showError(e);
                        $scope.salvando = false;
                        ModalService.hideLoading();
                    });
            }

            $scope.salvarPermissoes = function (form) {
                if (form.$dirty) {

                    ModalService.confirmMessage('telaEditPermissoes.aplicarAlteracao', null,
                        () => { 

                            const listaAdicionar = $scope.usuarioTipoPermitidos
                                .filter(x => !$scope.usuarioTipoPermitidosAntigo.some(y => y.UsuarioTipoId == x.UsuarioTipoId))
                                .map(x => x.UsuarioTipoId);

                            const listaRemover = $scope.usuarioTipoNaoPermitidos
                                .filter(x => !$scope.usuarioTipoNaoPermitidosAntigo.some(y => y.UsuarioTipoId == x.UsuarioTipoId))
                                .map(x => x.UsuarioTipoId);

                            ModalService.showLoading();

                            var promise = UsuarioTipoResource.AtualizarPermissoesDeUsuario({
                                'Id': $scope.usuariotipo.UsuarioTipoId,
                                'ListaAdicionar': listaAdicionar,
                                'ListaRemover': listaRemover
                            }).$promise

                            promise.then(() => {
                                NotifyService.showSuccess();
                                $scope.forms.PermissoesUsuarioTipo.$setPristine();
                                ModalService.hideLoading();
                            }).catch(e => {
                                ModalService.hideLoading();
                            });

                         }, { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });
                    
                    
                } else {
                    WizardHandler.wizard().next();
                }
            }

            $scope.salvarCarteiras = function (form) {
                if (form.$dirty) {

                    const listaAdicionar = $scope.usuarioTipoCarteiraAssociado
                        .filter(x => !$scope.usuarioTipoCarteiraAssociadoAntigo.some(y => y.Id == x.Id))
                        .map(x => x.Id);

                    const listaRemover = $scope.usuarioTipoCarteiraNaoAssociado
                        .filter(x => !$scope.usuarioTipoCarteiraNaoAssociadoAntigo.some(y => y.Id == x.Id))
                        .map(x => x.Id);

                    const atualizarCarteiraUsuarioTipo = (atualizarUsuarios) => {
                        var promise = UsuarioTipoResource.AtualizarCarteiraUsuarioTipo({
                            'Id': $scope.usuariotipo.UsuarioTipoId,
                            'ListaAdicionar': listaAdicionar,
                            'ListaRemover': listaRemover,
                            'AtualizarUsuarios': atualizarUsuarios
                        }).$promise;

                        promise.then(() => {
                            NotifyService.showSuccess();
                            $state.go('main.usuariotiporecurso.list');
                        })
                    }

                    ModalService.confirmMessage('telaEditPermissoes.aplicarAlteracao', null,
                        () => { atualizarCarteiraUsuarioTipo(true); },
                        { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });

                } else {
                    $state.go('main.usuariotiporecurso.list');
                }
            }

            $scope.salvarGrupos = function (form) {
                if (form.$dirty) {
                    const listaAdicionar = $scope.gruposPermitidos
                        .filter(x => !$scope.gruposPermitidosAntigo.some(y => y.GrupoId == x.GrupoId))
                        .map(x => x.GrupoId);

                    const listaRemover = $scope.gruposNaoPermitidos
                        .filter(x => !$scope.gruposNaoPermitidosAntigo.some(y => y.GrupoId == x.GrupoId))
                        .map(x => x.GrupoId);


                    const atualizarGrupos = (atualizarUsuarios) => {

                        ModalService.showLoading();

                        var promise = UsuarioTipoResource.AtualizarPermissoesDeGrupo({
                            'Id': $scope.usuariotipo.UsuarioTipoId,
                            'ListaAdicionar': listaAdicionar,
                            'ListaRemover': listaRemover,
                            'AtualizarUsuarios': atualizarUsuarios
                        }).$promise;

                        promise.then(() => {
                            NotifyService.showSuccess();                             
                            ModalService.hideLoading();                            
                            $scope.forms.PermissoesGrupo.$setPristine();
                        })
                        .catch(e => {
                                ModalService.hideLoading();
                         });
                    }

                    ModalService.confirmMessage('telaEditPermissoes.aplicarAlteracao', null,
                        () => { atualizarGrupos(true); },
                        { labels: { 'Ok': $translate.instant('campo.sim'), 'Cancel': $translate.instant('campo.nao') } });
                } else {
                    WizardHandler.wizard().next();
                }
            }

            $scope.selecionarTodasPermissoes = function (menu, $event) {
                menu.Recursos.forEach(el => {
                    if (el.PossuiAcesso != true) {
                        el.PossuiAcesso = true;
                        $scope.forms.Permissoes.$setDirty();
                    }
                });

                $scope.usuariotipo.Menus.forEach(menuFilho => {
                    if (menuFilho.ParentId == menu.SistemaMenuId) {
                        menuFilho.Recursos.forEach(el => {
                            if (el.PossuiAcesso != true) {
                                el.PossuiAcesso = true;
                                $scope.forms.Permissoes.$setDirty();
                            }
                        });
                    }
                });
                $event.preventDefault();
                $event.stopPropagation();
            }

            $scope.removerTodasPermissoes = function (menu, $event) {
                menu.Recursos.forEach(el => {
                    if (el.PossuiAcesso == true) {
                        el.PossuiAcesso = false;
                        $scope.forms.Permissoes.$setPristine();
                    }
                });

                $scope.usuariotipo.Menus.forEach(menuFilho => {
                    if (menuFilho.ParentId == menu.SistemaMenuId) {
                        menuFilho.Recursos.forEach(el => {
                            if (el.PossuiAcesso == true) {
                                $scope.forms.Permissoes.$setDirty();
                                el.PossuiAcesso = false;
                            }
                        });
                    }
                });
                $event.preventDefault();
                $event.stopPropagation();
            }

        }]);
})();
(function () {
    "use strict";

    var getOdataSearchShared = function (ServicoResource, search, orderBy, $odata) {
        var odata = ServicoResource.odata();
        odata.orderBy(orderBy.column, orderBy.order);

        if (search.Descricao) {
            odata.filter(new $odata.Func("contains", "Descricao", search.Descricao), true);
        }

        return odata;
    };

    angular.module("epbxManagerApp")

        .config(["$stateProvider", "StateResolverProvider", function ($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.usuariotiporecurso", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.usuariotiporecurso.list',
                        pageTitle: 'pageTitle.tipoDeUsuario',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.usuariotiporecurso.list", StateResolverProvider.configState("/usuariotiporecurso", "UsuarioTipoRecurso", "List", {
                    pageTitle: 'pageTitle.usuarioTipo',
                    pageName: 'pageTitle.pesquisar'
                }))
        }])

        .service("UsuarioTipoRecursoListData", function UsuarioTipoRecursoListData() {
            return function () {
                return {
                    usuarioTipos: ["UsuarioTipoResource", function (UsuarioTipoResource) {
                        return UsuarioTipoResource.odata().orderBy("Descricao", "asc").page(10, 1).query();
                    }]
                }
            }
        })

        .controller("UsuarioTipoRecursoListController", ["$stateParams", "$scope", "$odata", "usuarioTipos", "UsuarioTipoResource", "utils", "LocalStorageService", "NotifyService", "ModalService", function ($stateParams, $scope, $odata, usuarioTipos, UsuarioTipoResource, utils, LocalStorageService,
            NotifyService, ModalService) {
            $scope.searching = false;
            $scope.usuarioTipos = usuarioTipos;
            $scope.search = {};

            var updateList = function (list) {
                $scope.usuarioTipos = list;
                $scope.usuarioTipos.recordCount = list.$recordCount || list.length;
                $scope.usuarioTipos.pageSize = list.$pageSize || 10;
                $scope.currentPage = list.$currentPage || 1;
                $scope.searching = false;
            }

            $scope.search = $stateParams.storage ? LocalStorageService.getItem("FiltroUsuarioTipoRecurso") : {};

            $scope.orderBy = {
                column: "Descricao",
                order: "asc"
            };

            var getOdataSearch = function () {
                return getOdataSearchShared(UsuarioTipoResource, $scope.search, $scope.orderBy, $odata, utils);
            };

            var deleteRecord = function (data) {
                return UsuarioTipoResource.delete({ UsuarioTipoId: data.UsuarioTipoId }).$promise
                    .then(() => {
                        NotifyService.showSuccess();
                        $scope.pageChanged($scope.currentPage)
                    })
                    .catch(NotifyService.showError);
            };

            $scope.confirmDelete = function (data) {
                ModalService.confirmDelete(() => deleteRecord(data));
            };

            $scope.executeSearch = function () {
                $scope.searching = true;
                getOdataSearch().page($scope.usuarioTipos.pageSize, 1).query()
                    .then(updateList)
                    .catch((error) => {
                        NotifyService.showError(error)
                        $scope.searching = false;
                    });
            }

            $scope.pageChanged = function (newPage) {
                return getOdataSearch().page($scope.usuarioTipos.pageSize, newPage).query()
                    .then(updateList)
                    .catch(NotifyService.showError);
            };

            updateList(usuarioTipos);

            $scope.limparFiltro = function () {
                LocalStorageService.removeItem('FiltroUsuarioTipoRecurso');
                $scope.search = {};
                $scope.executeSearch();
            };

        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("UsuarioTipoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("UsuarioTipo/:UsuarioTipoId", { "UsuarioTipoId": "@UsuarioTipoId" },
                {
                    ObterTiposComPermissao: {
                        url: "UsuarioTipo/ObterTiposComPermissao",
                        method: "GET",
                        isArray: true
                    },
                    GetUsuarioTipoPermitidos: {
                        url: "UsuarioTipo/UsuarioTipoPermitidos/:id",
                        method: "GET",
                        isArray: true
                    },
                    GetUsuarioTipoNaoPermitidos: {
                        url: "UsuarioTipo/UsuarioTipoNaoPermitidos/:id",
                        method: "GET",
                        isArray: true
                    },
                    AtualizarPermissoesDeUsuario: {
                        url: "UsuarioTipo/UsuarioTipoPermissao",
                        method: "PUT"
                    },
                    GetGruposPermitidos: {
                        url: "UsuarioTipo/GruposPermitidos/:id",
                        method: "GET",
                        isArray: true
                    },
                    GetGruposNaoPermitidos: {
                        url: "UsuarioTipo/GruposNaoPermitidos/:id",
                        method: "GET",
                        isArray: true
                    },
                    AtualizarPermissoesDeGrupo: {
                        url: "UsuarioTipo/GrupoPermissao",
                        method: "PUT"
                    },
                    GetPorIdioma: {
                        url: "UsuarioTipo/TiposPorIdioma",
                        method: "GET"
                    },
                    RetornaCarteiras: {
                        url: "UsuarioTipo/GruposNaoPermitidos/:id",
                        method: "GET",
                        isArray: true
                    },
                    GetUsuarioTipoCarteiraNaoAssociado: { 
                        method: "GET", 
                        url: "UsuarioTipo/CarteiraNaoAssociado/:id", 
                        isArray: true 
                    },
                    GetUsuarioTipoCarteiraAssociado: { 
                        method: "GET",
                        url: "UsuarioTipo/CarteiraAssociado/:id", 
                        isArray: true 
                    },
                    AtualizarCarteiraUsuarioTipo: {
                        url: "UsuarioTipo/AtualizarUsuarioTipoCarteira",
                        method: "PUT"
                    }
                });
        }])

})();
(function() {
    "use strict";

    var defaultPageIndex = 1;
    var defaultPageSize = 10;

    angular.module("epbxManagerApp")
        .config(["$stateProvider", "StateResolverProvider", function($stateProvider, StateResolverProvider) {
            $stateProvider
                .state("main.webhooklog", {
                    url: "",
                    template: '<ui-view autoscroll="true"/>',
                    abstract: true,
                    data: {
                        proxy: 'main.webhooklog.list',
                        pageTitle: 'pageTitle.webhookLog',
                        pageName: 'pageTitle.pesquisar'
                    }
                })
                .state("main.webhooklog.list", StateResolverProvider.configState("/webhookLog", "WebhookLog", "List", {
                    pageTitle: 'pageTitle.webhookLog',
                    pageName: 'pageTitle.pesquisar'
                }));
        }])
        .service("WebhookLogListData", function WebhooklogListData() {
            return function() {
                return {
                    webhookProvedor: ["WebhookResource", function(WebhookResource) {
                        return WebhookResource.query().$promise;
                    }],
                };
            };
        })
        .controller("WebhookLogListController", ["$scope", "ModalService", "Config", "$http", "NotifyService", "$translate", "webhookProvedor", "WebhookLogResource", function($scope, ModalService, Config, $http, NotifyService, $translate, webhookProvedor, WebhookLogResource) {

            var dataInicio = moment().hour(0).minutes(0).seconds(0).milliseconds(0).toDate();
            var dataFim = moment().add(1, 'days').seconds(0).milliseconds(0).toDate();
            
            $scope.webhookProvedor = webhookProvedor.map(item =>{ 
                return{ 
                    Nome: item.Nome, 
                    Id: item.Id,
                    HabilitaLog: item.HabilitaLog,
                    provedorWebhookLog: item.Nome + (item.HabilitaLog  ? " - (Log Ativo)" : " - (Log Inativo)")
                };
             });

            
            $scope.HttpStatusArray = [
                { label: 200, valor: 200 },
                { label: 500, valor: 500 },
                { label: 404, valor: 404 },
                { label: 503, valor: 503 }
            ];

            $scope.orderBy = {
                column: "DataEnvio",
                order: "Desc"
            };

            $scope.search = {
                DataI: dataInicio,
                DataF: dataFim,
                HttpStatus: null,
                Duracao: null,
                WebhookProvedorId: null,
            };

            $scope.limparFiltro = function() {

                $scope.search = {
                    DataInicio: dataInicio,
                    DataFim: dataFim,
                    HttpStatus: null,
                    Duracao: null,
                    WebhookProvedorId: null,
                };

                $scope.webhook = [];
                $scope.orderBy = {
                    column: "DataEnvio",
                    order: "Desc"
                };

            };

            $scope.pageChanged = function(newPage) {
                if (defaultPageIndex != newPage) {
                    defaultPageIndex = newPage;
                    $scope.executeSearch();
                }
            };

            var validaLog = function() {
                var webhook = _.find($scope.webhookProvedor, function(item) {
                    return item.Id == $scope.search.WebhookProvedorId;
                });
                if(webhook != undefined){
                    if(!webhook.HabilitaLog){
                        // response.data
                        //NotifyService.showMessage($translate.instant('telaWebhookLog.webhookHabilitaLog'), "warning");
                        return;
                    }
                }        
            };

            $scope.executeSearch = function(formSimples) {
                validaLog();
                formSimples = formSimples || {};
                if (formSimples.$valid == false) {
                    return;
                }
                ModalService.showLoading();
                $scope.search.SortColumn = $scope.orderBy.column;
                $scope.search.SortDirection = $scope.orderBy.order;
                var url = Config.getUrl('WebhookLogRequest/') + defaultPageIndex + '/' + defaultPageSize;
                return $http({
                    method: 'GET',
                    url: url,
                    params: $scope.search
                }).then((response) => {
                    updateList(response.data);
                    getCount();
                    ModalService.hideLoading();
                }).catch((error) => {
                    NotifyService.showError(error);
                    ModalService.hideLoading();
                });

            };

            var getCount = function() {
                WebhookLogResource.getCount($scope.search).$promise
                    .then((data) => { $scope.webhookQuantidade = data.Quantidade; })
                    .catch(() => { $scope.webhookQuantidade = 0; });
            }

            function updateList(response) {
                $scope.webhook = response.Data;
                $scope.webhook.recordCount = response.RecordCount || response.Data.length;
                $scope.currentPage = response.PageIndex || defaultPageIndex;
                $scope.webhook.pageSize = response.PageSize || defaultPageSize;
            };

            $scope.order = function(predicate) {

                $scope.predicate = predicate;
                $scope.reverse = $scope.predicate ? !$scope.reverse : false;

                $scope.orderBy = {
                    column: predicate,
                    order: !$scope.reverse ? "desc" : "asc"
                };

                $scope.executeSearch()
            };
        }]);
})();
(function() {
    "use strict"

    angular.module('epbxManagerApp')
        .factory("WebhookLogResource", ["$odataresource", function($odataresource) {
            return $odataresource("WebhookLogRequest/:Id", { "Id": "@Id" }, {
                getWebhookLog: {
                    url: "WebhookLogRequest",
                    method: "GET",
                    isArray: true
                },
                getCount: {
                    url: "WebhookLogRequest/Count",
                    method: "GET"
                }
            });
        }]);
})
();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .controller('DashIndexController', ["$scope", "$rootScope", function ($scope, $rootScope) {
        }])

    })();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("DashboardReceptivoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("DashboardReceptivo/", {}, {
                getIndicadoresArvore: {
                    method: "GET",
                    params: {
                        "id": "@id",
                        "isUra": "@isUra"
                    },
                    url: "DashboardReceptivo/GetIndicadoresArvore",
                    isArray: true
                },         
                getIndicadoresConfiguracao: {
                    method: "GET",
                    url: "IndicadorDashboardConfiguracao",
                    isArray: true
                },        
                getIndicadorNvs: {
                    method: "GET",
                    url: "IndicadorDashboardConfiguracao/Nvs",
                    isArray: false
                },
                getConfiguracaoIndividual: {
                    method: "GET",
                    url: "IndicadorDashboardConfiguracao/ConfiguracaoIndividual",
                    isArray: false
                },    
                atualizarIndicadoresConfiguracao: {
                    method: "POST",
                    url: "IndicadorDashboardConfiguracao"
                },
                removerIndicadorNvs: {
                    method: "DELETE",
                    url: "IndicadorDashboardConfiguracao/Nvs"
                },
                atualizarIndicadorNvs: {
                    method: "POST",
                    url: "IndicadorDashboardConfiguracao/Nvs"
                },
                atualizarConfiguracaoIndividual: {
                    method: "POST",
                    url: "IndicadorDashboardConfiguracao/ConfiguracaoIndividual"
                },
                getUra: {
                    method: "GET",
                    params: {
                        "tipo": "@tipo",
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "grupo": "@grupo",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoUras",
                    isArray: true
                },
                getArvoreDetalhe: {
                    method: "GET",
                    params: {
                        "tipo": "@tipo",
                        "menuId": "@menuId",
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteira": "@carteira",
                        "grupo": "@grupo",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoArvoreDetalhe",
                    isArray: true
                },
                getOcupacaoPeriodos: {
                    method: "GET",
                    params: {
                        "uraId": "@uraId",
                        "tipo": "@tipo",
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoOcupacao",
                    isArray: true
                },
                getRegiao: {
                    method: "GET",
                    params: {
                        "idUraServico": "@idUraServico",
                        "tipo": "@tipo",
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteira": "@carteira",
                        "grupo": "@grupo",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoRegiao",
                    isArray: true
                },
                getRegiaoFull: {
                    method: "GET",
                    params: {
                        "id": "@id",
                        "tipo": "@tipo",
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteira": "@carteira",
                        "grupo": "@grupo",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoRegiaoFull",
                    isArray: true
                },
                getPainelIndicadores: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "uraId": "@uraId",
                        "tipo": "@tipo",
                        "carteira": "@carteira",
                        "grupo": "@grupo",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoPainelIndicadores",
                    isArray: true
                },   
                getDashboardReceptivoRechamada: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "uraId": "@uraId",
                        "tipo": "@tipo",
                        "tipoIndicador": "@tipoIndicador",
                        "hora":"@hora",
                        "carteira": "@carteira"
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoRechamada",
                    isArray: true
                },              
                getDashboardReceptivoIndicador: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "id": "@id",
                        "tipo": "@tipo",
                        "carteira": "@carteira",
                        "grupo": "@grupo"
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoIndicador",
                    isArray: true
                },
                getIndicadores: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "uraId": "@uraId",
                        "tipo": "@tipo",
                        "full": "@full",
                        "carteira": "@carteira",
                        "grupo": "@grupo"
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoIndicadores",
                    isArray: true
                },
                GetFilaUra: {
                    method: "GET",
                    params: {
                        "uraId": "@uraId",
                        "globalIds": "@globalIds",
                        "canais": "@canais",
                        "carteira": "@carteira"
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoFilaUra",
                    isArray: true
                },
                getCarteiras: {
                    url: "Carteira/CarteiraPorUsuario",
                    method: "GET",
                    params: {
                        "usuarioId": "@usuarioId"
                    },
                    isArray: true
                },
                getPainelIndicador: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "id": "@id",
                        "tipo": "@tipo",
                        "tipoIndicador": "@tipoIndicador",
                        "carteira": "@carteira",
                        "grupo": "@grupo",
                    },
                    url: "DashboardReceptivo/GetDashboardReceptivoPainelIndicador",
                    isArray: true
                },
                getIndicadorDashboardNVSTipo : {
                    method: "GET",
                    url: "DashboardReceptivo/GetIndicadorDashboardNVSTipo",
                    isArray: true
                }
            });
        }]);
})();
angular.module('epbxManagerApp')
    .service('DashboardReceptivoService', ["DashboardReceptivoResource", function (DashboardReceptivoResource) {
        var service = {};

        service.getUra = function (tipo, dataI, dataF, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            if(carteira == null) {
                var carteira = 0;
            }
            return DashboardReceptivoResource.getUra({
                tipo: tipo,
                dataInicio: dataI,
                dataFim: dataF,
                carteira: carteira,
                grupo: grupo || ''
            }).$promise;
        }

        service.getArvoreDetalhe = function (tipo, menuId, dataI, dataF, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getArvoreDetalhe({
                tipo: tipo,
                menuId: menuId,
                dataInicio: dataI,
                dataFim: dataF,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        service.getIndicadoresArvore = function (id, tipo) {
            return DashboardReceptivoResource.getIndicadoresArvore({
                id: id,
                isUra: tipo == 1 ? true : false
            }).$promise;
        }

        service.getPainelIndicadores = function (uraID, dataI, dataF, tipo, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getPainelIndicadores({
                uraId: uraID,
                dataInicio: dataI,
                dataFim: dataF,
                tipo: tipo,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        service.getDashboardReceptivoRechamada = function (uraID, tipo, tipoIndicador,dataI, dataF, hora, carteira) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getDashboardReceptivoRechamada({
                uraId: uraID,
                tipo: tipo,
                tipoIndicador: tipoIndicador,
                dataInicio: dataI,
                dataFim: dataF,
                hora:hora,
                carteira: carteira || 0
            }).$promise;
        }

        service.getIndicadoresConfiguracao = function () {
            return DashboardReceptivoResource.getIndicadoresConfiguracao().$promise;
        }

        service.getIndicadorNvs = function (id, tipo) {
            return DashboardReceptivoResource.getIndicadorNvs({ id: id, tipo: tipo }).$promise;
        }

        service.getConfiguracaoIndividual = function (id, tipo) {
            return DashboardReceptivoResource.getConfiguracaoIndividual({ id: id, tipo: tipo }).$promise;
        }

        service.atualizarIndicadoresConfiguracao = function (configuracoes) {
            return DashboardReceptivoResource.atualizarIndicadoresConfiguracao(configuracoes).$promise;
        }

        service.removerIndicadorNvs = function (id, tipo) {
            return DashboardReceptivoResource.removerIndicadorNvs({ id: id, tipo: tipo }).$promise;
        }

        service.atualizarIndicadorNvs = function (configuracao) {
            return DashboardReceptivoResource.atualizarIndicadoresConfiguracao(configuracao).$promise;
        }

        service.atualizarConfiguracaoIndividual = function (configuracoes) {
            return DashboardReceptivoResource.atualizarConfiguracaoIndividual(configuracoes).$promise;
        }

        service.getIndicadorDashboardNVSTipo = function () {
            return DashboardReceptivoResource.getIndicadorDashboardNVSTipo().$promise;
        }

        service.getRegiao = function (idUraServico, tipo, dataI, dataF, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getRegiao({
                idUraServico: idUraServico,
                tipo: tipo,
                dataInicio: dataI,
                dataFim: dataF,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        service.getRegiaoFull = function (id, tipo, dataI, dataF, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getRegiaoFull({
                id: id,
                tipo: tipo,
                dataInicio: dataI,
                dataFim: dataF,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        service.getDashboardReceptivoIndicador = function (dataI, dataF, id, tipo, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getDashboardReceptivoIndicador({
                dataInicio: dataI,
                dataFim: dataF,
                id: id,
                tipo: tipo,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        service.getOcupacaoPeriodos = function (dataI, dataF, uraId, tipo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getOcupacaoPeriodos({
                dataInicio: dataI,
                dataFim: dataF,
                uraId: uraId,
                tipo: tipo
            }).$promise;
        }

        service.getIndicadores = function (dataI, dataF, uraId, tipo, full, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getIndicadores({
                dataInicio: dataI,
                dataFim: dataF,
                uraId: uraId,
                tipo: tipo,
                full: full,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        service.GetFilaUra = function (uraId, globalIdsArr, canaisArr, carteira) {
            var globalIds = globalIdsArr.join();
            var canais = canaisArr.join();
            return DashboardReceptivoResource.GetFilaUra({
                uraId: uraId,
                globalIds: globalIds,
                canais: canais,
                carteira: carteira || 0
            }).$promise;
        }

        service.getPainelIndicador = function (id, tipo, tipoIndicador, dataI, dataF, carteira, grupo) {
            if (dataF == null) {
                var dataF = new Date();
            }
            if (dataI == null) {
                var dataI = new Date();
                dataI.setDate(dataF.getDate() - 7);
            }
            return DashboardReceptivoResource.getPainelIndicador({
                id: id,
                dataInicio: dataI,
                dataFim: dataF,
                tipo: tipo,
                tipoIndicador: tipoIndicador,
                carteira: carteira || 0,
                grupo: grupo || ''
            }).$promise;
        }

        return service;
    }]);
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('datetimez', function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attrs, ngModelCtrl) {
                    // O datepicker('update', e.date) dentro de changeDate reentrava no
                    // proprio handler (o componente ja esta em e.date), multiplicando
                    // disparos de ng-change. Combinado com setaDataInicial/Final que
                    // tambem chamam datepicker('update'), causava cascata de 8 chamadas
                    // a getDashboardReceptivoUras a cada troca de data.
                    $.fn.datepicker.defaults.format = "dd/mm/yyyy";
                    $(element).datepicker({
                        dateFormat: 'dd/mm/yyyy',
                        language: 'pt',
                        pickTime: false,
                        autoclose: true,
                        forceParse: false,
                        allowInputToggle: true,
                        todayHighlight: false,
                    }).on('changeDate', function (e) {
                        ngModelCtrl.$setViewValue(e.date);
                        scope.$apply();
                    });
                }
            }
        })

        .service("DashReceptivoViewData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    carteiras: ["DashboardReceptivoResource", "AuthService", function (DashboardReceptivoResource, AuthService) {
                        let usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;
                        return DashboardReceptivoResource.getCarteiras({
                            usuarioId: usuarioLogado
                        }).$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.GetGrupoPorCarteira({ carteira: 0 }).$promise;
                    }]
                }
            }
        })

        .controller('DashReceptivoViewController', ["$scope", "$rootScope", "$timeout", "$stateParams", "carteiras", "grupos", "GrupoResource", "DashReceptivoStorage", function ($scope, $rootScope, $timeout, $stateParams, carteiras, grupos, GrupoResource, DashReceptivoStorage) {
            $scope.periodoSelecionado = 6;
            $scope.pesquisaAberta = false;
            $scope.ultimaAtualizacao = '';
            $scope.pesquisa = {
                nome: ''
            };
            $scope.carteiras = carteiras;
            $scope.carteiraId = 0;
            $scope.carteiraNome = '';
            // Filtro de grupos multi-selecao. gruposSelecionados guarda os GrupoId
            // marcados; grupoId mantem a lista CSV (consumida pelos broadcasts
            // onDataSelecionada/onDataSelecionadaArvore/onAtualizacaoOnline e enviada
            // como parametro 'grupo' as APIs); gruposLabel e o texto do botao.
            $scope.grupos = grupos;
            $scope.gruposSelecionados = [];
            $scope.grupoId = '';
            $scope.gruposLabel = 'Grupos';

            let intervalOnline = null;
            const tempo = 120000

            /* ---------------------------------------------------------
                                    Gravar Filtro
            -------------------------------------------------------------*/
            $scope.guardarFiltroData = function (event, filtro) {

                let filtroCache = DashReceptivoStorage.getFiltro();
                if (filtroCache != null) {
                    filtroCache.dataInicio = $scope.dataInicio;
                    filtroCache.dataFim = $scope.dataFim;
                    filtroCache.periodo = $scope.periodoSelecionado;
                } else {
                    filtroCache = {
                        dataInicio: $scope.dataInicio,
                        dataFim: $scope.dataFim,
                        periodo: $scope.periodoSelecionado
                    }
                }
                DashReceptivoStorage.setFiltro(filtroCache);
            }

            $scope.guardarFiltroServico = function (event, filtro) {

                if ($scope.showServicos) {
                    let filtroCache = DashReceptivoStorage.getFiltro();
                    if (filtroCache != null) {
                        filtroCache.servico = filtro.servico;
                        filtroCache.ura = null;
                    } else {
                        filtroCache = {
                            servico: filtro.servico,
                            ura: null
                        }
                    }

                    $rootScope.$broadcast('onUraLimpo');
                    DashReceptivoStorage.setFiltro(filtroCache);
                }
            }

            $scope.guardarFiltroUra = function (event, filtro) {

                if ($scope.showURA) {
                    let filtroCache = DashReceptivoStorage.getFiltro();
                    if (filtroCache != null) {
                        filtroCache.ura = filtro.ura;
                        filtroCache.servico = null;
                    } else {
                        filtroCache = {
                            ura: filtro.ura,
                            servico: null
                        }
                    }

                    $rootScope.$broadcast('onServicoLimpo');
                    DashReceptivoStorage.setFiltro(filtroCache);
                }
            }

            $scope.guardarFiltroOnline = function () {
                let filtroCache = DashReceptivoStorage.getFiltro();
                if (filtroCache != null) {
                    filtroCache.online = $scope.online;
                } else {
                    filtroCache = {
                        online: $scope.online
                    }
                }
                DashReceptivoStorage.setFiltro(filtroCache);
            }

            /* ---------------------------------------------------------
                                   Fim de Gravar Filtro
            -------------------------------------------------------------*/

            $scope.controlarPesquisa = function () {
                $scope.pesquisaAberta = !$scope.pesquisaAberta;
                if (!$scope.pesquisaAberta) {
                    $scope.pesquisa = {
                        nome: ''
                    };
                }
            }

            $scope.carregaURA = function () {
                $scope.showURA = true;
                $scope.showServicos = false;
                $rootScope.$broadcast('onAbaSelecionada', 'ura');
            }

            $scope.carregaServicos = function () {
                $scope.showURA = false;
                $scope.showServicos = true;
                $rootScope.$broadcast('onAbaSelecionada', 'servico');
            }

            $scope.selecionarCarteira = function(id, nome) {
                $scope.carteiraId = id;
                $scope.carteiraNome = nome;
                // Troca de carteira reseta a selecao de grupos e recarrega a lista.
                $scope.gruposSelecionados = [];
                $scope.atualizarGrupoFiltro();
                // Aguarda a lista de grupos chegar antes de notificar — antes corria o risco
                // de outras directives reagirem ao broadcast com $scope.grupos ainda obsoleto.
                GrupoResource.GetGrupoPorCarteira({ carteira: id || 0 }).$promise
                    .then(function (data) { $scope.grupos = data; })
                    .catch(function () { $scope.grupos = []; })
                    .finally(function () { $scope.notificarData(); });
            }

            // Sincroniza a string CSV $scope.grupoId e o rotulo a partir do array
            // de grupos selecionados.
            $scope.atualizarGrupoFiltro = function () {
                $scope.grupoId = $scope.gruposSelecionados.join(',');
                const qtd = $scope.gruposSelecionados.length;
                if (qtd === 0) {
                    $scope.gruposLabel = 'Grupos';
                } else if (qtd === 1) {
                    $scope.gruposLabel = '1 grupo';
                } else {
                    $scope.gruposLabel = qtd + ' grupos';
                }
            }

            $scope.grupoSelecionado = function (grupo) {
                return $scope.gruposSelecionados.indexOf(grupo.GrupoId) !== -1;
            }

            $scope.alternarGrupo = function (grupo) {
                const idx = $scope.gruposSelecionados.indexOf(grupo.GrupoId);
                if (idx === -1) {
                    $scope.gruposSelecionados.push(grupo.GrupoId);
                } else {
                    $scope.gruposSelecionados.splice(idx, 1);
                }
                $scope.atualizarGrupoFiltro();
                $scope.notificarData();
            }

            $scope.limparGrupos = function () {
                if ($scope.gruposSelecionados.length === 0) return;
                $scope.gruposSelecionados = [];
                $scope.atualizarGrupoFiltro();
                $scope.notificarData();
            }

            $scope.selecionarPeriodo = function (periodo, esperarInicializacao) {
                $scope.periodoSelecionado = periodo;
                $scope.calcularDatas();
                if (!esperarInicializacao) {
                    if ($scope.fullStyle != 'side') {
                        $scope.notificarData();
                    } else {
                        $scope.notificarDataArvore();
                    }
                }
                if ($scope.periodoSelecionado != 7) {
                    $scope.tornarOnline();
                } else {
                    $scope.online = false;
                    $scope.guardarFiltroOnline();
                    if (intervalOnline != null) {
                        clearTimeout(intervalOnline)
                        intervalOnline = null;
                    }
                }
            }

            $scope.calcularDatas = function () {
                let dataF = new Date();
                let dataI = new Date();
                if ($scope.periodoSelecionado == 1) {
                    dataI = moment(dataF).subtract(15, 'm').toDate();
                } else if ($scope.periodoSelecionado == 2) {
                    dataI = moment(dataF).subtract(30, 'm').toDate();
                } else if ($scope.periodoSelecionado == 3) {
                    dataI = moment(dataF).subtract(1, 'h').toDate();
                } else if ($scope.periodoSelecionado == 4) {
                    dataI = moment(dataF).subtract(2, 'h').toDate();
                } else if ($scope.periodoSelecionado == 5) {
                    dataI = moment(dataF).subtract(3, 'h').toDate();
                } else if ($scope.periodoSelecionado == 6) {
                    dataI = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
                } else if ($scope.periodoSelecionado == 7) {
                    $scope.setaDataInicial();
                    $scope.setaDataFinal();
                    dataI = moment($scope.dataInicioFormatado, "DD/MM/YYYY").toDate();
                    dataF = moment($scope.dataFimFormatado, "DD/MM/YYYY").toDate();
                }
                $scope.dataInicio = dataI;
                $scope.dataFim = dataF;
            }

            $scope.tornarOnline = function () {
                $scope.online = true;
                $scope.guardarFiltroOnline();

                if (intervalOnline != null) {
                    clearTimeout(intervalOnline);
                    intervalOnline = null;
                }

                intervalOnline = setTimeout(function () {
                    $scope.ultimaAtualizacao = 'Atualizado em ' + moment().format('DD/MM/YYYY HH:mm:ss');
                    $scope.calcularDatas();
                    // Refresh seletivo: dispara apenas o evento que recarrega indicadores/regiao
                    // sem reconstruir a arvore e relistar servicos/uras (dados de cadastro nao mudam
                    // em escala de minutos). Quando a side esta aberta, ainda usa o fluxo original.
                    if ($scope.fullStyle != 'side') {
                        $scope.notificarAtualizacaoOnline();
                    } else {
                        $scope.notificarDataArvore();
                    }
                    // Reencadeia o proximo tick
                    if ($scope.online) {
                        $scope.tornarOnline();
                    }
                }, tempo);
            }

            let atualizandoDatas = false;

            $scope.alterarDataInicio = function () {
                if (atualizandoDatas) return;
                atualizandoDatas = true;
                try {
                    let dataInicio = angular.isString($scope.dataInicioFormatado) ? moment($scope.dataInicioFormatado, "DD/MM/YYYY").toDate() : $scope.dataInicioFormatado;
                    let dataFim = angular.isString($scope.dataFimFormatado) ? moment($scope.dataFimFormatado, "DD/MM/YYYY").toDate() : $scope.dataFimFormatado;

                    if (dataInicio > dataFim) {
                        dataFim = dataInicio;
                    }

                    let difference = moment(dataFim).diff(moment(dataInicio), 'days');
                    if (difference > 31) {
                        dataFim = moment(dataInicio).add(31, 'days').toDate();
                    }

                    $scope.dataInicio = dataInicio;
                    $scope.dataFim = dataFim;
                    $scope.setaDataInicial($scope.dataInicio);
                    $scope.setaDataFinal($scope.dataFim);
                    if ($scope.fullStyle != 'side') {
                        $scope.notificarData();
                    } else {
                        $scope.notificarDataArvore();
                    }
                } finally {
                    atualizandoDatas = false;
                }
            }

            $scope.alterarDataFim = function () {
                if (atualizandoDatas) return;
                atualizandoDatas = true;
                try {
                    let dataInicio = angular.isString($scope.dataInicioFormatado) ? moment($scope.dataInicioFormatado, "DD/MM/YYYY").toDate() : $scope.dataInicioFormatado;
                    let dataFim = angular.isString($scope.dataFimFormatado) ? moment($scope.dataFimFormatado, "DD/MM/YYYY").toDate() : $scope.dataFimFormatado;

                    if (dataFim < dataInicio) {
                        dataInicio = dataFim;
                    }

                    let difference = moment(dataFim).diff(moment(dataInicio), 'days');
                    if (difference > 31) {
                        dataInicio = moment(dataFim).subtract(31, 'days').toDate();
                    }

                    $scope.dataInicio = dataInicio;
                    $scope.dataFim = dataFim;
                    $scope.setaDataInicial($scope.dataInicio);
                    $scope.setaDataFinal($scope.dataFim);
                    if ($scope.fullStyle != 'side') {
                        $scope.notificarData();
                    } else {
                        $scope.notificarDataArvore();
                    }
                } finally {
                    atualizandoDatas = false;
                }
            }

            $scope.showConfig = function () {
                let modal = UIkit.modal("#configurar-modal");
                if (!modal.isActive()) {
                    modal.show();
                }
            }

            $scope.exibirDadosSelecionado = function (event, filtro) {
                $scope.filtroAtual = filtro;
            }

            $scope.fullStyle = 'main';
            $scope.checkFull = function (event, data) {
                $scope.fullStyle = data;
            }

            // Guardar refs dos listeners para limpeza no $destroy
            // ($rootScope.$on sobrevive ao destroy do escopo local — vaza memoria sem cleanup explicito)
            const offUraSelecionado = $rootScope.$on('onUraSelecionado', $scope.guardarFiltroUra);
            const offServicoSelecionado = $rootScope.$on('onServicoSelecionado', $scope.guardarFiltroServico);
            const offNoSelecionado = $rootScope.$on('onNoSelecionado', $scope.exibirDadosSelecionado);
            const offCheckFull = $rootScope.$on('onCheckFull', $scope.checkFull);

            $scope.setaDataInicial = function (data) {
                $scope.dataInicioFormatado = moment(data).format("DD/MM/YYYY");
                const element = $("#dataInicio");
                if (element) {
                    element.datepicker('update', $scope.dataInicioFormatado);
                }
            }
            $scope.setaDataFinal = function (data) {
                $scope.dataFimFormatado = moment(data).format("DD/MM/YYYY");
                const element = $("#dataFim");
                if (element) {
                    element.datepicker('update', moment(data).format("DD/MM/YYYY"));
                }
            }

            // Inicializacao do ESTADO ($scope.dataInicio/dataFim, periodoSelecionado)
            // roda sincrono, ANTES das diretivas filhas serem compiladas.
            // Motivo: <ura>/<servico> emitem 'onAbaPronto' em $timeout proprio durante
            // seu link, e o handler 'onAbaPronto' do controller dispara notificarData
            // (debounced 250ms). Se as datas nao tiverem sido calculadas aqui, o
            // primeiro broadcast 'onDataSelecionada' sai com dataInicio undefined,
            // a request volta com filtro vazio e a tela fica sem servicos ate o
            // usuario interagir (ex: trocar carteira).
            intervalOnline = null;
            (function inicializarEstadoDatas() {
                $scope.periodoSelecionado = 6;
                $scope.selecionarPeriodo(6, true);
            })();

            // Inicializacao do DOM (datepicker, click handlers) roda apos render.
            // $timeout em vez de jQuery(document).ready() para funcionar em
            // re-entradas SPA — ready so dispara no load inicial da pagina.
            const initTimer = $timeout(function () {
                $('.open-datetimepicker').click(function (event) {
                    event.preventDefault();
                    const input = $(this).prev("input")[0];
                    if (input) input.focus();
                });
                if ($scope.periodoSelecionado == 7 && $scope.dataInicio != null) {
                    $scope.setaDataInicial($scope.dataInicio);
                    $scope.setaDataFinal($scope.dataFim);
                }
            });

            if ($stateParams.retorno) {
                $scope.selecionarPeriodo(6, true);
            }

            // Debounce: colapsa disparos repetidos em uma unica emissao por janela
            // de 250ms. Necessario porque trocar uma data manualmente dispara o ng-change
            // varias vezes (datepicker -> $setViewValue -> setaDataInicial -> datepicker
            // update -> changeDate ...), e sem o debounce cada disparo emitia
            // onDataSelecionada e gerava requisicoes duplicadas.
            //
            // O parametro `scope` ('ura'/'servico') vinha do onAbaPronto e era propagado
            // no payload pra cada directive filtrar quem responde. Mas, com o debounce,
            // dois onAbaPronto consecutivos (um de cada directive) colapsavam num so
            // broadcast carregando APENAS o ultimo scope — fazendo a directive contraria
            // nao disparar, e impedindo o onEsconderAbaUra/Servico de chavear a aba quando
            // o resultado vinha vazio. Forcamos scope=undefined: ambas directives reagem,
            // e cada uma ja se protege contra requests duplos via $scope.requestId.
            let notificarDataTimer = null;
            $scope.notificarData = function () {
                if (notificarDataTimer) $timeout.cancel(notificarDataTimer);
                notificarDataTimer = $timeout(function () {
                    notificarDataTimer = null;
                    $scope.guardarFiltroData();
                    $rootScope.$broadcast('onDataSelecionada', {
                        dataInicio: $scope.dataInicio,
                        dataFim: $scope.dataFim,
                        carteiraId: $scope.carteiraId,
                        grupoId: $scope.grupoId,
                        show: $scope.showURA ? 'ura' : 'servico'
                    });
                }, 250);
            }

            let notificarDataArvoreTimer = null;
            $scope.notificarDataArvore = function (event, scope) {
                if (notificarDataArvoreTimer) $timeout.cancel(notificarDataArvoreTimer);
                notificarDataArvoreTimer = $timeout(function () {
                    notificarDataArvoreTimer = null;
                    $scope.guardarFiltroData();
                    $rootScope.$broadcast('onDataSelecionadaArvore', {
                        dataInicio: $scope.dataInicio,
                        dataFim: $scope.dataFim,
                        grupoId: $scope.grupoId
                    });
                }, 250);
            }

            // Notifica as diretivas filhas para atualizarem APENAS os indicadores,
            // sem disparar o fluxo que recarrega arvore + lookups + lista de servicos/uras.
            $scope.notificarAtualizacaoOnline = function () {
                $scope.guardarFiltroData();
                $rootScope.$broadcast('onAtualizacaoOnline', {
                    dataInicio: $scope.dataInicio,
                    dataFim: $scope.dataFim,
                    carteiraId: $scope.carteiraId,
                    grupoId: $scope.grupoId
                });
            }


            let filtroCache = DashReceptivoStorage.getFiltro();
            if (filtroCache != null) {
                if (filtroCache.servico != null) {
                    $scope.showURA = false;
                    $scope.showServicos = true;
                } else if (filtroCache.ura != null) {
                    $scope.showURA = true;
                    $scope.showServicos = false;
                } else {
                    $scope.showURA = true;
                    $scope.showServicos = false;
                    $scope.guardarFiltroUra(null, {
                        ura: null
                    });
                }
            } else {
                $scope.showURA = false;
                $scope.showServicos = true;
                $scope.guardarFiltroUra(null, {
                    ura: null
                });
            }
            const offAbaPronto = $rootScope.$on('onAbaPronto', $scope.notificarData);

            $scope.esconderUra = false;
            $scope.esconderAbaUra = function (event, scope) {
                $scope.esconderUra = scope;
                if ($scope.esconderUra) {
                    $scope.carregaServicos();
                }
            }

            $scope.esconderServico = false;
            $scope.esconderAbaServico = function (event, scope) {
                $scope.esconderServico = scope;
                if ($scope.esconderServico) {
                    $scope.carregaURA();
                }
            }

            const offEsconderAbaServico = $rootScope.$on('onEsconderAbaServico', $scope.esconderAbaServico);
            const offEsconderAbaUra = $rootScope.$on('onEsconderAbaUra', $scope.esconderAbaUra);

            $scope.$on('showConfigNvs', function (event, data) {
                $scope.configurarNvsId = data.id;
                $scope.tipoNvs = data.tipo;
                var modal = UIkit.modal("#configurar-modal-nvs");
                if (!modal.isActive()) {
                    modal.show();
                }
            });

            $scope.$on('$destroy', function () {
                offUraSelecionado();
                offServicoSelecionado();
                offNoSelecionado();
                offCheckFull();
                offAbaPronto();
                offEsconderAbaServico();
                offEsconderAbaUra();
                if (intervalOnline != null) {
                    clearTimeout(intervalOnline);
                    intervalOnline = null;
                }
                if (notificarDataTimer) { $timeout.cancel(notificarDataTimer); notificarDataTimer = null; }
                if (notificarDataArvoreTimer) { $timeout.cancel(notificarDataArvoreTimer); notificarDataArvoreTimer = null; }
                if (initTimer) $timeout.cancel(initTimer);
            });
        }]);
})();
(function () {
    "use strict";

    // Helper centralizado para acesso seguro ao localStorage da dashboard receptiva.
    // Motivo: JSON.parse direto quebra a tela toda se o conteudo estiver corrompido,
    // e IDs orfaos (servico/ura sem permissao) podem travar a renderizacao.
    angular.module('epbxManagerApp')
        .factory('DashReceptivoStorage', function () {
            const KEY_FILTRO = 'filtro_receptivo';
            const KEY_TOP3 = 'top3Estados';

            function safeGet(key) {
                try {
                    const raw = localStorage.getItem(key);
                    if (raw == null || raw === 'undefined' || raw === 'null') return null;
                    return JSON.parse(raw);
                } catch (e) {
                    // Conteudo corrompido — descarta para nao propagar erro
                    try { localStorage.removeItem(key); } catch (e2) { /* noop */ }
                    return null;
                }
            }

            function safeSet(key, value) {
                try {
                    localStorage.setItem(key, JSON.stringify(value));
                } catch (e) { /* quota/private mode */ }
            }

            return {
                getFiltro: function () {
                    const f = safeGet(KEY_FILTRO);
                    if (f == null || typeof f !== 'object') return null;
                    // Sanitiza campos numericos
                    if (f.servico != null && typeof f.servico === 'object' && f.servico.CampoId != null) {
                        // formato antigo: servico era objeto — converte pra ID
                        f.servico = f.servico.CampoId;
                    }
                    if (f.ura != null && typeof f.ura === 'object' && f.ura.CampoId != null) {
                        f.ura = f.ura.CampoId;
                    }
                    if (f.periodo != null) {
                        const p = parseInt(f.periodo, 10);
                        f.periodo = (isNaN(p) || p < 1 || p > 7) ? null : p;
                    }
                    return f;
                },
                setFiltro: function (filtro) {
                    safeSet(KEY_FILTRO, filtro);
                },
                limparItem: function (chave) {
                    // chave: 'servico' | 'ura' | 'periodo' | 'dataInicio' | 'dataFim' | 'online'
                    const f = safeGet(KEY_FILTRO);
                    if (f == null) return;
                    f[chave] = null;
                    safeSet(KEY_FILTRO, f);
                },
                getTop3Estados: function () {
                    const v = safeGet(KEY_TOP3);
                    // Backwards-compat: antigamente era armazenado como string 'true'/'false'
                    if (v === 'true' || v === true) return true;
                    if (v === 'false' || v === false) return false;
                    return null;
                },
                setTop3Estados: function (valor) {
                    safeSet(KEY_TOP3, !!valor);
                }
            };
        });
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("DashboardSupervisaoResource", ["$odataresource", function ($odataresource) {
            return $odataresource("DashboardSupervisao/", {}, {
                getServicos: {
                    method: "GET",
                    params: {
                        "carteiraId": "@carteiraId",
                        "operacaoId": "@operacaoId",
                        "servicosIds": "@servicosIds",
                        "gruposIds": "@gruposIds"
                    },
                    url: "DashboardSupervisao/GetServicos",
                    isArray: true
                },
                getGeral: {
                    method: "GET",
                    params: {
                        "carteiraId": "@carteiraId",
                        "operacaoId": "@operacaoId",
                        "servicosIds": "@servicosIds",
                        "gruposIds": "@gruposIds"
                    },
                    url: "DashboardSupervisao/GetGeral"
                },
                getGrupos: {
                    method: "GET",
                    params: {
                        "carteiraId": "@carteiraId",
                        "operacaoId": "@operacaoId",
                        "gruposIds": "@gruposIds"
                    },
                    url: "DashboardSupervisao/GetGrupos",
                    isArray: true
                },
                getQuantidadeFilaServico: {
                    method: "GET",
                    params: {
                        "servicos": "@servicos",
                        "gruposIds": "@gruposIds"
                    },
                    url: "DashboardSupervisao/QuantidadeFilaPorServico"
                },
                getQuantidadeFilaGrupo: {
                    method: "GET",
                    params: {
                        "ramais": "@ramais"
                    },
                    url: "DashboardSupervisao/QuantidadeFilaPorGrupo"
                },
                getRamaisLivresGrupos: {
                    method: 'GET',
                    params: {
                        "ramaisIds": "@ramaisIds"
                    },
                    url: "DashboardSupervisao/GetRamaisLivresGrupos"
                },
                getSupervisaoRamalDetalhe: {
                    method: 'GET',
                    params: {
                        "statusSupervisao": "@statusSupervisao",
                        "carteiraId": "@carteiraId",
                        "operacaoId": "@operacaoId",
                        "servicosIds": "@servicosIds",
                        "gruposIds": "@gruposIds"
                    },
                    url: "DashboardSupervisao/DetalheStatus",
                    isArray: true
                },
                getCarteiras: {
                    url: "Carteira/CarteiraPorUsuario",
                    method: "GET",
                    params: {
                        "usuarioId": "@usuarioId"
                    },
                    isArray: true
                }
            });
        }]);
})();
angular.module('epbxManagerApp')
    .service('DashboardSupervisaoService', ["DashboardSupervisaoResource", function (DashboardSupervisaoResource) {
        let service = {};

        service.getServicos = function (servicosIds, carteiraId, operacaoId, gruposIds) {

            if (carteiraId == null) {
                carteiraId = 0;
            }

            if (operacaoId == null) {
                operacaoId = 0;
            }

            if (gruposIds == null) {
                gruposIds = '';
            }

            return DashboardSupervisaoResource.getServicos({ servicosIds, carteiraId, operacaoId, gruposIds }).$promise;
        }

        service.getGeral = function (servicosIds, carteiraId, operacaoId, gruposIds) {

            if (carteiraId == null) {
                carteiraId = 0;
            }

            if (operacaoId == null) {
                operacaoId = 0;
            }

            if (gruposIds == null) {
                gruposIds = '';
            }

            return DashboardSupervisaoResource.getGeral({ servicosIds, carteiraId, operacaoId, gruposIds }).$promise;
        }

        service.getGrupos = function (carteiraId, operacaoId, gruposIds) {

            if (carteiraId == null) {
                carteiraId = 0;
            }

            if (operacaoId == null) {
                operacaoId = 0;
            }

            if (gruposIds == null) {
                gruposIds = '';
            }

            return DashboardSupervisaoResource.getGrupos({ carteiraId, operacaoId, gruposIds }).$promise;
        }

        service.getQuantidadeFilaServico = function (servicos, carteiraId, operacaoId, gruposIds) {
            if (gruposIds == null) {
                gruposIds = '';
            }
            return DashboardSupervisaoResource.getQuantidadeFilaServico({ servicos, carteiraId, operacaoId, gruposIds });
        }

        service.getQuantidadeFilaGrupo = function (ramais) {
            return DashboardSupervisaoResource.getQuantidadeFilaGrupo({ ramais })
        }

        service.getRamaisLivresGrupos = function (ramaisIds) {
            return DashboardSupervisaoResource.getRamaisLivresGrupos({ ramaisIds })
        }

        service.getSupervisaoRamalDetalhe = function (statusSupervisao, carteiraId, operacaoId, servicosIds, gruposIds) {

            if (carteiraId == null) {
                carteiraId = 0;
            }

            if (operacaoId == null) {
                operacaoId = 0;
            }

            if (gruposIds == null) {
                gruposIds = '';
            }
            return DashboardSupervisaoResource.getSupervisaoRamalDetalhe({ statusSupervisao: statusSupervisao, carteiraId: carteiraId, operacaoId: operacaoId, servicosIds: servicosIds, gruposIds: gruposIds });
        }

        return service;
    }]);
(function () {
    "use strict";

    // Snapshot dos filtros atuais da toolbar (carteira / operacao / grupos).
    // Mantido fora dos engines para que, ao ALTERNAR a visao (servico <-> grupo),
    // o engine recem-montado inicie com os filtros corretos — sem precisar ter
    // ouvido os eventos anteriores e sem disparar o reset de grupos que o evento
    // de troca de carteira provoca.
    angular.module('epbxManagerApp')
        .factory('DashSupervisaoFiltro', function () {
            const f = { carteiraId: 0, operacaoId: 0, gruposIds: '' };
            return {
                get: function () { return f; },
                setCarteira: function (id) { f.carteiraId = id || 0; },
                setOperacao: function (id) { f.operacaoId = id || 0; },
                setGrupos: function (ids) { f.gruposIds = ids || ''; }
            };
        });
})();

(function () {
    "use strict";

    // Helper centralizado para acesso seguro ao localStorage da dashboard compacta (supervisao).
    // Substitui JSON.parse/setItem espalhados, com try/catch e validacao basica.
    // 3 chaves gerenciadas:
    //   servicos_selecionados        -> array de IDs (numero)
    //   servicos_numeros_selecionados -> array de Numeros (string)
    //   servicos_carteira            -> array de todos os Numeros da carteira atual
    angular.module('epbxManagerApp')
        .factory('DashSupervisaoStorage', function () {
            const KEY_IDS = 'servicos_selecionados';
            const KEY_NUMEROS = 'servicos_numeros_selecionados';
            const KEY_CARTEIRA = 'servicos_carteira';

            function safeGetArray(key) {
                try {
                    const raw = localStorage.getItem(key);
                    if (raw == null || raw === 'undefined' || raw === 'null') return [];
                    const parsed = JSON.parse(raw);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    try { localStorage.removeItem(key); } catch (e2) { /* noop */ }
                    return [];
                }
            }

            function safeSet(key, value) {
                try {
                    localStorage.setItem(key, JSON.stringify(value));
                } catch (e) { /* quota/private mode */ }
            }

            function safeRemove(key) {
                try { localStorage.removeItem(key); } catch (e) { /* noop */ }
            }

            return {
                getIdsSelecionados: () => safeGetArray(KEY_IDS),
                getNumerosSelecionados: () => safeGetArray(KEY_NUMEROS),
                getNumerosCarteira: () => safeGetArray(KEY_CARTEIRA),

                setSelecionados: function (ids, numeros) {
                    safeSet(KEY_IDS, ids || []);
                    safeSet(KEY_NUMEROS, numeros || []);
                },
                setNumerosCarteira: function (numeros) {
                    safeSet(KEY_CARTEIRA, numeros || []);
                },
                limparSelecionados: function () {
                    safeRemove(KEY_IDS);
                    safeRemove(KEY_NUMEROS);
                }
            };
        });
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .service("DashSupervisaoViewData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_amChartWithMap',
                            'lazy_joint',
                        ]);
                    }],
                    carteiras: ["DashboardSupervisaoResource", "AuthService", function (DashboardSupervisaoResource, AuthService) {
                        let usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;
                        return DashboardSupervisaoResource.getCarteiras({
                            usuarioId: usuarioLogado
                        }).$promise;
                    }],
                    grupos: ["GrupoResource", function (GrupoResource) {
                        return GrupoResource.GetGrupoPorCarteira({ carteira: 0 }).$promise;
                    }]
                }
            }
        })

        .controller('DashSupervisaoViewController', ["$scope", "$rootScope", "carteiras", "grupos", "GrupoResource", "AuthService", "DashSupervisaoVisao", "DashSupervisaoFiltro", function ($scope, $rootScope, carteiras, grupos, GrupoResource, AuthService, DashSupervisaoVisao, DashSupervisaoFiltro) {
            // Visao da tela: 'servico' ou 'grupo' (default 'grupo' p/ DashModoEPS).
            // O toggle na toolbar alterna; o ng-if do painel lateral / engine de grupos
            // (view-supervisao.html) e o rotulo da coluna reagem a visaoState.atual.
            $scope.visaoState = DashSupervisaoVisao.state;
            $scope.selecionarVisao = function (v) {
                DashSupervisaoVisao.set(v);
            };

            $scope.pesquisaAberta = false;
            $scope.pesquisa = {
                nome: ''
            };

            $scope.carteiras = carteiras;
            $scope.carteiraId = 0;
            $scope.carteiraNome = '';

            // Filtro de grupos (multi-selecao). gruposSelecionados guarda os GrupoId
            // marcados; gruposLabel e o texto exibido no botao da toolbar.
            $scope.grupos = grupos || [];
            $scope.gruposSelecionados = [];
            $scope.gruposLabel = 'Grupos';

            $scope.operacoes = [
                { OperacaoId: 1, OperacaoNome: 'Humano' },
                { OperacaoId: 2, OperacaoNome: 'TalkBot' }
            ];
            $scope.operacaoId = 0;
            $scope.operacaoNome = '';
         
            $scope.controlarPesquisa = function () {
                $scope.pesquisaAberta = !$scope.pesquisaAberta;
                if (!$scope.pesquisaAberta) {
                    $scope.pesquisa = {
                        nome: ''
                    };
                }
            }

            $scope.limparServico = function(){
                $rootScope.$emit('limparServicos',{});
            }
            

            $scope.selecionarCarteira = function(id, nome) {
                $scope.carteiraId = id;
                $scope.carteiraNome = nome;

                // Troca de carteira reseta a selecao de grupos e recarrega a lista
                // de grupos da nova carteira. Notifica a carteira apenas depois que
                // a lista chega, para as directives reagirem com gruposIds ja zerado.
                $scope.gruposSelecionados = [];
                $scope.atualizarGruposLabel();
                GrupoResource.GetGrupoPorCarteira({ carteira: id || 0 }).$promise
                    .then(function (data) { $scope.grupos = data || []; })
                    .catch(function () { $scope.grupos = []; })
                    .finally(function () { $scope.notificarCarteira(); });
            }

            $scope.notificarCarteira = function (event) {
                // Troca de carteira zera os grupos (os engines fazem o mesmo no handler).
                DashSupervisaoFiltro.setCarteira($scope.carteiraId);
                DashSupervisaoFiltro.setGrupos('');
                $rootScope.$broadcast('onCarteiraSelecionada', $scope.carteiraId);
            }

            /* ---------------------------------------------------------
                                    Filtro de Grupos
            -------------------------------------------------------------*/
            $scope.atualizarGruposLabel = function () {
                const qtd = $scope.gruposSelecionados.length;
                if (qtd === 0) {
                    $scope.gruposLabel = 'Grupos';
                } else if (qtd === 1) {
                    $scope.gruposLabel = '1 grupo';
                } else {
                    $scope.gruposLabel = qtd + ' grupos';
                }
            }

            $scope.grupoSelecionado = function (grupo) {
                return $scope.gruposSelecionados.indexOf(grupo.GrupoId) !== -1;
            }

            // Marca/desmarca um grupo sem fechar o dropdown (stopPropagation na view).
            $scope.alternarGrupo = function (grupo) {
                const idx = $scope.gruposSelecionados.indexOf(grupo.GrupoId);
                if (idx === -1) {
                    $scope.gruposSelecionados.push(grupo.GrupoId);
                } else {
                    $scope.gruposSelecionados.splice(idx, 1);
                }
                $scope.atualizarGruposLabel();
                $scope.notificarGrupos();
            }

            $scope.limparGrupos = function () {
                if ($scope.gruposSelecionados.length === 0) return;
                $scope.gruposSelecionados = [];
                $scope.atualizarGruposLabel();
                $scope.notificarGrupos();
            }

            $scope.notificarGrupos = function () {
                const ids = $scope.gruposSelecionados.join(',');
                DashSupervisaoFiltro.setGrupos(ids);
                $rootScope.$broadcast('onGrupoSelecionada', ids);
            }

            // A "Operacao" e, na pratica, o tipo do grupo: Humano (1) = GrupoTipoId 1,
            // TalkBot (2) = GrupoTipoId 3, Ambos (0) = tipos 1 e 3 (mesma traducao das procs).
            // Usado para filtrar o combo de Grupos pelo tipo selecionado.
            $scope.filtroPorOperacao = function (grupo) {
                if ($scope.operacaoId === 1) return grupo.GrupoTipoId === 1;
                if ($scope.operacaoId === 2) return grupo.GrupoTipoId === 3;
                return grupo.GrupoTipoId === 1 || grupo.GrupoTipoId === 3;
            }

            $scope.selecionarOperacao = function(id, nome) {
                $scope.operacaoId = id;
                $scope.operacaoNome = nome;

                // Remove da selecao os grupos que nao sao do tipo da operacao escolhida,
                // e re-notifica os grupos se a selecao mudou (para os dados refiltrarem).
                const idsValidos = ($scope.grupos || []).filter($scope.filtroPorOperacao).map(g => g.GrupoId);
                const qtdAntes = $scope.gruposSelecionados.length;
                $scope.gruposSelecionados = $scope.gruposSelecionados.filter(gid => idsValidos.indexOf(gid) !== -1);
                if ($scope.gruposSelecionados.length !== qtdAntes) {
                    $scope.atualizarGruposLabel();
                    $scope.notificarGrupos();
                }

                $scope.notificarOperacao();
            }

            $scope.notificarOperacao = function (event) {
                DashSupervisaoFiltro.setOperacao($scope.operacaoId);
                $rootScope.$broadcast('onOperacaoSelecionada', $scope.operacaoId);
            }
        }]);
})();
(function () {
    "use strict";

    // Estado da visao do dashboard operacional (compacto): 'servico' ou 'grupo'.
    // - Default: 'grupo' quando o usuario e DashModoEPS; senao 'servico'.
    // - Persiste a ultima escolha do usuario em localStorage (o tipo so define o
    //   default na 1a vez / quando nao ha valor salvo).
    angular.module('epbxManagerApp')
        .factory('DashSupervisaoVisao', ["AuthService", function (AuthService) {
            const KEY = 'dash_supervisao_visao';
            const SERVICO = 'servico', GRUPO = 'grupo';

            function carregarInicial() {
                try {
                    const salvo = localStorage.getItem(KEY);
                    if (salvo === SERVICO || salvo === GRUPO) return salvo;
                } catch (e) { /* private mode / quota */ }
                return AuthService.isDashModoEps() ? GRUPO : SERVICO;
            }

            // Objeto com referencia estavel para binding reativo em directives de
            // escopo isolado (todos leem `state.atual`; `set` muta o mesmo objeto).
            const state = { atual: carregarInicial() };

            return {
                state: state,
                get: function () { return state.atual; },
                isGrupo: function () { return state.atual === GRUPO; },
                set: function (v) {
                    if (v !== SERVICO && v !== GRUPO) return;
                    state.atual = v;
                    try { localStorage.setItem(KEY, v); } catch (e) { /* noop */ }
                }
            };
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("DashboardTalkbotResource", ["$odataresource", function ($odataresource) {
            return $odataresource("DashTalkbot/", {}, {
                getCarteiras: {
                    method: "GET",
                    url: "DashTalkbot/Fluxo/Carteiras",
                    isArray: true
                },
                getGrupos: {
                    method: "GET",
                    params: { "carteiraId": "@carteiraId" },
                    url: "DashTalkbot/Fluxo/Grupos",
                    isArray: true
                },
                getServicos: {
                    method: "GET",
                    params: { "carteiraId": "@carteiraId", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/Servicos",
                    isArray: true
                },
                getFluxos: {
                    method: "GET",
                    url: "DashTalkbot/Fluxo/Listar",
                    isArray: true
                },
                getFluxoCompleto: {
                    method: "GET",
                    params: { "servicosIds": "@servicosIds", "campanhasIds": "@campanhasIds", "dataInicio": "@dataInicio", "dataFim": "@dataFim", "carteiraId": "@carteiraId", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/Completo",
                    isArray: true
                },
                getFluxoOutHorario: {
                    method: "GET",
                    params: { "servicosIds": "@servicosIds", "campanhasIds": "@campanhasIds", "dataInicio": "@dataInicio", "dataFim": "@dataFim", "carteiraId": "@carteiraId", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/FluxoOutHorario",
                    isArray: true
                },
                getFluxoIndicadores: {
                    method: "GET",
                    params: { "servicosIds": "@servicosIds", "campanhasIds": "@campanhasIds", "dataInicio": "@dataInicio", "dataFim": "@dataFim", "carteiraId": "@carteiraId", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/Indicadores",
                    isArray: true
                },
                getFluxoIndicadoresCampanha: {
                    method: "GET",
                    params: { "servicosIds": "@servicosIds", "campanhasIds": "@campanhasIds", "dataInicio": "@dataInicio", "dataFim": "@dataFim", "carteiraId": "@carteiraId", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/IndicadoresCampanha",
                    isArray: true
                },
                getFluxoTotais: {
                    method: "GET",
                    params: { "servicosIds": "@servicosIds", "campanhasIds": "@campanhasIds", "dataInicio": "@dataInicio", "dataFim": "@dataFim", "carteiraId": "@carteiraId", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/Totais",
                    isArray: true
                },
                getFluxoCampanhas: {
                    method: "GET",
                    params: { "carteirasIds": "@carteirasIds", "servicosIds": "@servicosIds", "dataInicio": "@dataInicio", "dataFim": "@dataFim", "gruposIds": "@gruposIds" },
                    url: "DashTalkbot/Fluxo/Campanhas",
                    isArray: true
                }
            });
        }]);
})();

angular.module('epbxManagerApp')
    .service('DashboardTalkbotService', ["DashboardTalkbotResource", function (DashboardTalkbotResource) {
        var service = {};

        service.getServicos = function (servicosIds, carteiraId, gruposIds) {
            return DashboardTalkbotResource.getServicos({ carteiraId: carteiraId || 0, gruposIds: gruposIds || '' }).$promise;
        };

        service.getCarteiras = function () {
            return DashboardTalkbotResource.getCarteiras().$promise;
        };

        service.getGrupos = function (carteiraId) {
            return DashboardTalkbotResource.getGrupos({ carteiraId: carteiraId || 0 }).$promise;
        };

        return service;
    }]);

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .service("DashTalkbotViewData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_amCharts',
                        ], { serie: true });
                    }],
                    carteiras: ["DashboardTalkbotService", function (DashboardTalkbotService) {
                        return DashboardTalkbotService.getCarteiras();
                    }],
                    grupos: ["DashboardTalkbotService", function (DashboardTalkbotService) {
                        return DashboardTalkbotService.getGrupos(0);
                    }]
                }
            }
        })

        .controller('DashTalkbotViewController', ["$scope", "$rootScope", "carteiras", "grupos", "DashboardTalkbotService", function ($scope, $rootScope, carteiras, grupos, DashboardTalkbotService) {
            $scope.fluxoDataInicio = moment().format('DD/MM/YYYY');
            $scope.fluxoDataFim = moment().format('DD/MM/YYYY');
            $scope.periodoSelecionado = 6;

            // Filtros de carteira (single) e grupos (multi).
            $scope.carteiras = carteiras || [];
            $scope.carteiraId = 0;
            $scope.carteiraNome = '';
            $scope.grupos = grupos || [];
            $scope.gruposSelecionados = [];
            $scope.gruposLabel = 'Grupos';

            var dataInicio = moment().startOf('day').toDate();
            var dataFim = moment().endOf('day').toDate();

            $scope.selecionarPeriodo = function (tipo) {
                $scope.periodoSelecionado = tipo;
                switch (tipo) {
                    case 1:
                        dataInicio = moment().subtract(15, 'minutes').toDate();
                        dataFim = moment().toDate();
                        break;
                    case 2:
                        dataInicio = moment().subtract(30, 'minutes').toDate();
                        dataFim = moment().toDate();
                        break;
                    case 3:
                        dataInicio = moment().subtract(1, 'hour').toDate();
                        dataFim = moment().toDate();
                        break;
                    case 4:
                        dataInicio = moment().subtract(2, 'hours').toDate();
                        dataFim = moment().toDate();
                        break;
                    case 5:
                        dataInicio = moment().subtract(3, 'hours').toDate();
                        dataFim = moment().toDate();
                        break;
                    case 6:
                        dataInicio = moment().startOf('day').toDate();
                        dataFim = moment().endOf('day').toDate();
                        break;
                    case 7:
                        $scope.fluxoDataInicio = moment(dataInicio).format('DD/MM/YYYY');
                        $scope.fluxoDataFim = moment(dataFim).format('DD/MM/YYYY');
                        return;
                }
                $scope.filtrarFluxo();
            };

            $scope.alterarDataInicio = function () {
                dataInicio = moment($scope.fluxoDataInicio, 'DD/MM/YYYY').toDate();
                $scope.filtrarFluxo();
            };

            $scope.alterarDataFim = function () {
                dataFim = moment($scope.fluxoDataFim, 'DD/MM/YYYY').toDate();
                $scope.filtrarFluxo();
            };

            $scope.filtrarFluxo = function () {
                $rootScope.$broadcast('onTalkbotFluxoFiltrar', {
                    dataInicio: dataInicio,
                    dataFim: dataFim,
                    carteiraId: $scope.carteiraId,
                    gruposIds: $scope.gruposSelecionados.join(',')
                });
            };

            /* ---------------------------------------------------------
                                  Filtro de Carteira
            -------------------------------------------------------------*/
            $scope.selecionarCarteira = function (id, nome) {
                $scope.carteiraId = id;
                $scope.carteiraNome = nome;

                // Troca de carteira reseta os grupos e recarrega a lista da nova carteira.
                $scope.gruposSelecionados = [];
                $scope.atualizarGruposLabel();
                DashboardTalkbotService.getGrupos(id || 0)
                    .then(function (data) { $scope.grupos = data || []; })
                    .catch(function () { $scope.grupos = []; })
                    .finally(function () { $scope.filtrarFluxo(); });
            };

            /* ---------------------------------------------------------
                                   Filtro de Grupos
            -------------------------------------------------------------*/
            $scope.atualizarGruposLabel = function () {
                var qtd = $scope.gruposSelecionados.length;
                if (qtd === 0) {
                    $scope.gruposLabel = 'Grupos';
                } else if (qtd === 1) {
                    $scope.gruposLabel = '1 grupo';
                } else {
                    $scope.gruposLabel = qtd + ' grupos';
                }
            };

            $scope.grupoSelecionado = function (grupo) {
                return $scope.gruposSelecionados.indexOf(grupo.GrupoId) !== -1;
            };

            $scope.alternarGrupo = function (grupo) {
                var idx = $scope.gruposSelecionados.indexOf(grupo.GrupoId);
                if (idx === -1) {
                    $scope.gruposSelecionados.push(grupo.GrupoId);
                } else {
                    $scope.gruposSelecionados.splice(idx, 1);
                }
                $scope.atualizarGruposLabel();
                $scope.filtrarFluxo();
            };

            $scope.limparGrupos = function () {
                if ($scope.gruposSelecionados.length === 0) return;
                $scope.gruposSelecionados = [];
                $scope.atualizarGruposLabel();
                $scope.filtrarFluxo();
            };

            $scope.selecionarPeriodo($scope.periodoSelecionado);
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .factory("DashboardTelecomResource", ["$odataresource", function ($odataresource) {
            return $odataresource("DashboardTelecom/", {}, {
                getFornecedores: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                    },
                    url: "DashboardTelecom/GetDashboardFornecedores",
                    isArray: true
                },
                getFornecedoresStatus: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "rotas": "@rotas"
                    },
                    url: "DashboardTelecom/GetDashboardFornecedoresStatus",
                    isArray: true
                },
                getFornecedoresOcupacao: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId"
                    },
                    url: "DashboardTelecom/GetDashboardFornecedoresOcupacao",
                    isArray: true
                },
                getDDDStatus: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores",
                        "rotas": "@rotas",
                        "mostrarTodos": "@mostrarTodos"
                    },
                    url: "DashboardTelecom/GetDashboardStatusDDD",
                    isArray: true
                },
                getClasseStatus: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores",
                        "rotas": "@rotas",
                        "mostrarTodos": "@mostrarTodos"
                    },
                    url: "DashboardTelecom/GetDashboardStatusClasse",
                    isArray: true
                },
                getReleasesStatus: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores",
                        "rotas": "@rotas",
                        "mostrarTodos": "@mostrarTodos"
                    },
                    url: "DashboardTelecom/GetDashboardStatusReleases",
                    isArray: true
                },
                getDatas: {
                    method: "GET",
                    url: "DashboardTelecom/GetDashboardDatas",
                    isArray: true
                },
                getClasses: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedorId": "@fornecedorId",
                        "rotaId": "@rotaId",
                        "classeId": "@classeId"
                    },
                    url: "DashboardTelecom/GetFinanceiroClasse",
                    isArray: true
                },
                getFinanceiroPeriodos: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores",
                        "rotaId": "@rotaId",
                        "classeId": "@classeId",
                        "tipo": "@tipo"
                    },
                    url: "DashboardTelecom/GetFinanceiroPeriodo",
                    isArray: true
                },
                getStatusPeriodos: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores"
                    },
                    url: "DashboardTelecom/GetStatusPeriodo",
                    isArray: true
                },
                getOcupacaoPeriodos: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores",
                        "rotas": "@rotas"
                    },
                    url: "DashboardTelecom/GetDashboardOcupacao",
                    isArray: true
                },
                getTronco: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores"
                    },
                    url: "DashboardTelecom/GetDashboardTronco",
                    isArray: true
                },
                getOcupacaoSinalizacao: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "fornecedores": "@fornecedores",
                        "rotas": "@rotas"
                    },
                    url: "DashboardTelecom/GetDashboardOcupacaoSinalizacao",
                    isArray: true
                },
                getCampanhas: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                    },
                    url: "DashboardTelecom/GetDashboardCampanha",
                    isArray: true
                },
                getCampanhaClasses: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "campanhas": "@campanhas"
                    },
                    url: "DashboardTelecom/GetFinanceiroCampanhaClasse",
                    isArray: true
                },
                getCampanhaPeriodos: {
                    method: "GET",
                    params: {
                        "dataInicio": "@dataInicio",
                        "dataFim": "@dataFim",
                        "carteiraId": "@carteiraId",
                        "campanhas": "@campanhas",
                        "tipo": "@tipo"
                    },
                    url: "DashboardTelecom/GetFinanceiroCampanhaPeriodo",
                    isArray: true
                },
                getCarteiras: {
                    url: "Carteira/CarteiraPorUsuario",
                    method: "GET",
                    params: {
                        "usuarioId": "@usuarioId"
                    },
                    isArray: true
                }
            });
        }]);
})();
angular.module('epbxManagerApp')
    .service('DashTelecomService', ["DashboardTelecomResource", function (DashboardTelecomResource) {
        const service = {};

        // Defaults compartilhados pelos 16+ metodos. Antes, cada metodo repetia
        // o mesmo bloco "if (dataF == null) dataF = new Date(); if (dataI == null) ...".
        // Centralizando, qualquer ajuste futuro (ex: novo default de carteira)
        // se aplica de uma vez.
        function withDefaults(params) {
            const p = Object.assign({}, params);
            if (p.dataFim == null) p.dataFim = new Date();
            if (p.dataInicio == null) {
                p.dataInicio = new Date();
                p.dataInicio.setDate(p.dataFim.getDate() - 1);
            }
            if (p.carteiraId == null) p.carteiraId = 0;
            return p;
        }

        // Normaliza arrays para string CSV usada pelas chamadas. Tolera null/undefined/array vazio.
        // Antes: codigo espalhava `fornecedores.join()` sem guard, ou tinha bugs tipo
        // `rotas.join([','])` (passando array para join, que coage via toString).
        function toCsv(arr) {
            if (!Array.isArray(arr) || arr.length === 0) return '';
            return arr.join(',');
        }

        service.getFinanceiroPeriodos = function (dataI, dataF, carteiraId, fornecedores, tipoVisao) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getFinanceiroPeriodos({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores),
                tipo: tipoVisao
            }).$promise;
        }

        service.getStatusPeriodos = function (dataI, dataF, carteiraId, fornecedores) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getStatusPeriodos({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores)
            }).$promise;
        }

        service.getClasses = function (dataI, dataF, carteiraId, fornecedores) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            let fornecedorId = 0;
            if (Array.isArray(fornecedores) && fornecedores.length == 1) {
                fornecedorId = fornecedores[0];
            }
            return DashboardTelecomResource.getClasses({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedorId: fornecedorId
            }).$promise;
        }

        service.getTroncos = function (dataI, dataF, carteiraId, fornecedores) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getTronco({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores)
            }).$promise;
        }

        service.getFornecedores = function (dataI, dataF, carteiraId) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getFornecedores({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId
            }).$promise;
        }

        service.getFornecedoresStatus = function (dataI, dataF, carteiraId, rotas) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getFornecedoresStatus({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                rotas: toCsv(rotas)
            }).$promise;
        }

        service.getFornecedoresOcupacao = function (dataI, dataF, carteiraId) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getFornecedoresOcupacao({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId
            }).$promise;
        }

        service.getDDDStatus = function (dataI, dataF, carteiraId, fornecedores, rotas, mostrarTodos) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getDDDStatus({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores),
                rotas: toCsv(rotas),
                mostrarTodos: mostrarTodos == null ? false : mostrarTodos
            }).$promise;
        }

        service.getClasseStatus = function (dataI, dataF, carteiraId, fornecedores, rotas, mostrarTodos) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getClasseStatus({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores),
                rotas: toCsv(rotas),
                mostrarTodos: mostrarTodos == null ? false : mostrarTodos
            }).$promise;
        }

        service.getReleasesStatus = function (dataI, dataF, carteiraId, fornecedores, rotas, mostrarTodos) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getReleasesStatus({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores),
                rotas: toCsv(rotas),
                mostrarTodos: mostrarTodos == null ? false : mostrarTodos
            }).$promise;
        }

        service.getOcupacaoPeriodos = function (dataI, dataF, carteiraId, fornecedores, rotas) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getOcupacaoPeriodos({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores),
                rotas: toCsv(rotas)
            }).$promise;
        }

        service.getOcupacaoSinalizacao = function (dataI, dataF, carteiraId, fornecedores, rotas) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getOcupacaoSinalizacao({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                fornecedores: toCsv(fornecedores),
                rotas: toCsv(rotas)
            }).$promise;
        }

        service.getCampanhas = function (dataI, dataF, carteiraId) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getCampanhas({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId
            }).$promise;
        }

        service.getCampanhaClasses = function (dataI, dataF, carteiraId, campanhas) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getCampanhaClasses({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                campanhas: campanhas
            }).$promise;
        }

        service.getCampanhaPeriodos = function (dataI, dataF, carteiraId, campanhas, tipoVisao) {
            const p = withDefaults({ dataInicio: dataI, dataFim: dataF, carteiraId: carteiraId });
            return DashboardTelecomResource.getCampanhaPeriodos({
                dataInicio: p.dataInicio,
                dataFim: p.dataFim,
                carteiraId: p.carteiraId,
                campanhas: toCsv(campanhas),
                tipo: tipoVisao
            }).$promise;
        }

        return service;
    }]);

(function () {
    "use strict";

    // Helper centralizado para acesso seguro ao localStorage da dashboard telecom.
    // Substitui 13+ chamadas JSON.parse(localStorage.getItem(...)) espalhadas
    // pelo controller e directives, com try/catch e fallback consistente.
    // Chave gerenciada: filtro_dash (contem dataInicio, dataFim, carteiraId,
    // fornecedores, campanhas, online, visao).
    angular.module('epbxManagerApp')
        .factory('DashTelecomStorage', function () {
            const KEY = 'filtro_dash';

            function safeGet() {
                try {
                    const raw = localStorage.getItem(KEY);
                    if (raw == null || raw === 'undefined' || raw === 'null') return null;
                    const parsed = JSON.parse(raw);
                    return (parsed != null && typeof parsed === 'object') ? parsed : null;
                } catch (e) {
                    try { localStorage.removeItem(KEY); } catch (e2) { /* noop */ }
                    return null;
                }
            }

            function safeSet(filtro) {
                try {
                    localStorage.setItem(KEY, JSON.stringify(filtro || {}));
                } catch (e) { /* quota/private mode */ }
            }

            // Merge parcial — evita o pattern "se cache existe atualiza, senao cria"
            // espalhado em 5 lugares no controller.
            function merge(parcial) {
                const atual = safeGet() || {};
                safeSet(Object.assign(atual, parcial || {}));
            }

            return {
                get: safeGet,
                set: safeSet,
                merge: merge,
                limpar: function () {
                    try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
                }
            };
        });
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .service("DashTelecomViewData", function () {
            return function () {
                return {
                    deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                        return $ocLazyLoad.load([
                            'lazy_amCharts'
                        ]);
                    }],
                    carteiras: ["DashboardTelecomResource", "AuthService", function (DashboardTelecomResource, AuthService) {
                        let usuarioLogado = AuthService.getUsuarioLogado().UsuarioId;
                        return DashboardTelecomResource.getCarteiras({
                            usuarioId: usuarioLogado
                        }).$promise;
                    }]
                }
            }
        })

        .controller('DashTelecomViewController', ["$scope", "$rootScope", "$state", "$interval", "$timeout", "carteiras", "DashTelecomStorage", function ($scope, $rootScope, $state, $interval, $timeout, carteiras, DashTelecomStorage) {
            $scope.visaoSelecionada = 'servico';
            $scope.online = false;
            $scope.periodoSelecionado = 6;
            let intervalOnline = null;
            let limitDate = null;
            let dataInicial = null;
            let dataFinal = null;
            $scope.carteiras = carteiras;
            $scope.carteiraId = 0;
            $scope.carteiraNome = '';
            const TIMEOUT_ONLINE = 120000;

            /* ---------- Funcoes locais ---------- */

            function setaDataInicial(filtro) {
                const element = $("#dataInicio");
                if (element && element.length > 0) {
                    if (filtro) element.datepicker('update', moment(filtro).format("DD/MM/YYYY"));
                    else element.datepicker('update', moment(new Date().setDate(new Date().getDate() - 1)).format("DD/MM/YYYY"));
                }
            }

            function cancelaIntervalo() {
                if (intervalOnline != null) {
                    $interval.cancel(intervalOnline);
                    intervalOnline = null;
                }
            }

            $scope.selecionarCarteira = function (id, nome) {
                $scope.carteiraId = id;
                $scope.carteiraNome = nome;
                // Antes: filtroCache = JSON.parse(localStorage.getItem("filtro_dash"))
                // sem null check — crash quando cache nao existia.
                const filtroCache = DashTelecomStorage.get() || {};
                onDataAlterada({
                    dataInicio: filtroCache.dataInicio ? new Date(filtroCache.dataInicio) : new Date(),
                    dataFim: filtroCache.dataFim ? new Date(filtroCache.dataFim) : new Date(),
                    carteiraId: $scope.carteiraId
                });
            }

            function onDataAlterada(filtro) {
                if (!filtro) return;

                $scope.dataInicio = moment(filtro.dataInicio).format("DD/MM/YYYY");
                $scope.dataFim = moment(filtro.dataFim).format("DD/MM/YYYY");
                $scope.carteiraId = filtro.carteiraId;
                setaDataInicial(filtro.dataInicio);

                // Antes: tinha branch else que tentava acessar filtroCache.dataInicio
                // mesmo com filtroCache=null → TypeError no 1o carregamento sem cache.
                // O helper merge() trata corretamente o caso sem cache.
                DashTelecomStorage.merge({
                    dataInicio: filtro.dataInicio,
                    dataFim: filtro.dataFim,
                    carteiraId: filtro.carteiraId
                });

                AmCharts.handleLoad();
                $rootScope.$broadcast('onDataSelecionada', {
                    start: filtro.dataInicio,
                    end: filtro.dataFim,
                    carteiraId: filtro.carteiraId
                });
            }

            function onLoadDirectives(params) {
                limitDate = params.limit ? params.limit : null;
                $scope.selecionarPeriodo($scope.periodoSelecionado);
            }

            // Tick do modo online — recalcula datas para o momento ATUAL.
            // Antes lia dataInicio/Fim do localStorage (sempre as mesmas) → modo "online"
            // nao avancava a janela de tempo, era um bug funcional.
            function tickOnline() {
                const agora = new Date();
                $scope.dataInicio = agora;
                $scope.dataFim = agora;
                onDataAlterada({
                    dataInicio: $scope.dataInicio,
                    dataFim: $scope.dataFim,
                    carteiraId: $scope.carteiraId
                });
            }

            function guardarFiltroFornecedor(event, filtro) {
                DashTelecomStorage.merge({ fornecedores: filtro.fornecedores });
            }

            function guardarFiltroCampanha(event, filtro) {
                DashTelecomStorage.merge({ campanhas: filtro.campanhas });
            }

            function guardarFiltroOnline() {
                DashTelecomStorage.merge({ online: $scope.online });
            }

            function guardarFiltroVisao() {
                DashTelecomStorage.merge({ visao: $scope.visao });
            }

            function onChangeAba() {
                // $timeout(0) substitui setTimeout(0) — integra com $digest e e cancelavel.
                $timeout(function () {
                    cancelaIntervalo();
                    onLoadDirectives({ limit: null });
                }, 0);
            }

            /* ---------- Funcoes de escopo ---------- */

            $scope.carregaFornecedores = function () {
                $scope.showCampanhas = false;
                $scope.showFornecedores = true;
                onChangeAba();
            }

            $scope.carregaCampanhas = function () {
                $scope.showFornecedores = false;
                $scope.showCampanhas = true;
                onChangeAba();
            }

            $scope.trocarVisao = function (nomeVisao) {
                $scope.visao = nomeVisao;
                $state.transitionTo(`dash.telecom.${nomeVisao}`);
                guardarFiltroVisao();
            }

            $scope.tornarOnline = function () {
                $scope.online = true;
                guardarFiltroOnline();
                $scope.dataInicio = new Date();
                $scope.dataFim = new Date();
                // Antes: $scope.carteiraId = 0 — descartava o filtro do usuario ao
                // entrar online. Removido — preserva a carteira selecionada.
                onDataAlterada({
                    dataInicio: $scope.dataInicio,
                    dataFim: $scope.dataFim,
                    carteiraId: $scope.carteiraId
                });
                cancelaIntervalo();
                // $interval (Angular) em vez de setInterval (nativo) — integra com $digest
                // e cleanup automatico se o $scope for destruido.
                intervalOnline = $interval(tickOnline, TIMEOUT_ONLINE);
            }

            $scope.alterarDataInicio = function () {
                if (dataInicial !== $scope.dataInicio) {
                    dataInicial = $scope.dataInicio;

                    let dataInicio = angular.isString($scope.dataInicio) ? moment($scope.dataInicio, "DD/MM/YYYY").toDate() : $scope.dataInicio;
                    let dataFim = angular.isString($scope.dataFim) ? moment($scope.dataFim, "DD/MM/YYYY").toDate() : $scope.dataFim;

                    if (dataInicio > dataFim) {
                        dataFim = new Date(dataInicio);
                        dataFim.setDate(dataFim.getDate() + 1);
                    }

                    const maxDias = limitDate ? parseInt(limitDate) : 31;
                    const diferenca = moment(dataFim).diff(moment(dataInicio), 'days');
                    if (diferenca > maxDias) {
                        dataFim = moment(dataInicio).add(maxDias, 'days').toDate();
                    }
                    onDataAlterada({ dataInicio: dataInicio, dataFim: dataFim, carteiraId: $scope.carteiraId });
                }
            }

            $scope.alterarDataFim = function () {
                if (dataFinal !== $scope.dataFim) {
                    dataFinal = $scope.dataFim;

                    let dataInicio = angular.isString($scope.dataInicio) ? moment($scope.dataInicio, "DD/MM/YYYY").toDate() : $scope.dataInicio;
                    let dataFim = angular.isString($scope.dataFim) ? moment($scope.dataFim, "DD/MM/YYYY").toDate() : $scope.dataFim;

                    if (dataFim < dataInicio) {
                        dataInicio = new Date(dataFim);
                        dataInicio.setDate(dataInicio.getDate() - 1);
                    }

                    const maxDias = limitDate ? parseInt(limitDate) : 31;
                    const diferenca = moment(dataFim).diff(moment(dataInicio), 'days');
                    if (diferenca > maxDias) {
                        dataInicio = moment(dataFim).subtract(maxDias, 'days').toDate();
                    }
                    onDataAlterada({ dataInicio: dataInicio, dataFim: dataFim, carteiraId: $scope.carteiraId });
                }
            }

            $scope.selecionarPeriodo = function (tipo) {
                $scope.periodoSelecionado = tipo;
                cancelaIntervalo();
                $scope.online = false;
                switch (tipo) {
                    case 1:
                        $scope.dataInicio = moment().subtract(15, 'minutes').toDate();
                        $scope.dataFim = moment().toDate();
                        break;
                    case 2:
                        $scope.dataInicio = moment().subtract(30, 'minutes').toDate();
                        $scope.dataFim = moment().toDate();
                        break;
                    case 3:
                        $scope.dataInicio = moment().subtract(1, 'hour').toDate();
                        $scope.dataFim = moment().toDate();
                        break;
                    case 4:
                        $scope.dataInicio = moment().subtract(2, 'hours').toDate();
                        $scope.dataFim = moment().toDate();
                        break;
                    case 5:
                        $scope.dataInicio = moment().subtract(3, 'hours').toDate();
                        $scope.dataFim = moment().toDate();
                        break;
                    case 6:
                        $scope.dataInicio = moment().startOf('day').toDate();
                        $scope.dataFim = moment().endOf('day').toDate();
                        break;
                    case 7:
                        return;
                }
                DashTelecomStorage.merge({ periodoSelecionado: tipo });
                onDataAlterada({ dataInicio: $scope.dataInicio, dataFim: $scope.dataFim, carteiraId: $scope.carteiraId });
            }

            $scope.filtrar = function () {
                $scope.online = false;
                guardarFiltroOnline();
                cancelaIntervalo();
                $scope.limparFiltros();
            }

            $scope.limparFiltros = function () {
                $scope.selecionarPeriodo(6);
            }

            /* ---------- Inicializacao ---------- */

            const filtroCache = DashTelecomStorage.get();
            if (filtroCache != null && filtroCache.visao != null) {
                $scope.trocarVisao(filtroCache.visao);
            } else {
                $scope.trocarVisao('status');
            }

            var periodoInicial = (filtroCache && filtroCache.periodoSelecionado) ? filtroCache.periodoSelecionado : 6;
            $scope.selecionarPeriodo(periodoInicial);

            $scope.carregaFornecedores();

            const offFiltroFornecedor = $scope.$on('onFiltroAlteradoFornecedor', guardarFiltroFornecedor);
            const offFiltroCampanha = $scope.$on('onFiltroAlteradoCampanha', guardarFiltroCampanha);
            const offStateChange = $scope.$on('$stateChangeSuccess', function () {
                cancelaIntervalo();
                $timeout(function () { onLoadDirectives({ limit: null }); }, 500);
            });

            $scope.$on('$destroy', function () {
                offFiltroFornecedor();
                offFiltroCampanha();
                offStateChange();
                cancelaIntervalo();
            });

            // $timeout (Angular) em vez de jQuery(document).ready — funciona em re-entradas
            // SPA. Antes, ao voltar para a tela via navegacao, o ready ja tinha passado
            // e o binding do .open-datetimepicker era pulado.
            const initTimer = $timeout(function () {
                $('.open-datetimepicker').click(function (event) {
                    event.preventDefault();
                    const input = $(this).prev("input")[0];
                    if (input) input.focus();
                });
                setaDataInicial();
            });
            $scope.$on('$destroy', function () {
                if (initTimer) $timeout.cancel(initTimer);
            });
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('arvore', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ["$q", "$timeout", "UraHelper", "RamalResource", "ServicoResource", "GrupoResource", "IntegracaoConfiguracaoResource", "$scope", "$rootScope", "UraResource", "DashboardReceptivoService", "DashReceptivoStorage", function ArvoreController($q, $timeout, UraHelper, RamalResource, ServicoResource, GrupoResource,
                    IntegracaoConfiguracaoResource, $scope, $rootScope, UraResource, DashboardReceptivoService, DashReceptivoStorage) {
                    let getsPromises = [];
                    let alertasGlobal = [];
                    let alertasPorNo = [];
                    let nosExpands = [];
                    let requestId = 0;
                    let requestArvoreId = 0;
                    let tamanhoNoX = 140;
                    let tamanhoNoY = 30;
                    let yAtual = 10;
                    let xAtual = 16;
                    let xIncremento = 20;
                    let yIncremento = 40;
                    let noSelecionado = {};
                    let uraSelecionada = {};
                    let widthTotal = 0;
                    let heightTotal = 0;
                    $scope.dataFull = {};
                    $scope.graph = new joint.dia.Graph;

                    // Lookups iniciais — se algum falhar, segue com array vazio
                    // para nao bloquear a inicializacao da arvore inteira
                    getsPromises.push(ServicoResource.lookup().$promise
                        .then(data => $scope.servicos = data)
                        .catch(() => $scope.servicos = []));
                    getsPromises.push(RamalResource.getSimples({ RamalTipoId: "1" }).$promise
                        .then(data => $scope.ramais = data)
                        .catch(() => $scope.ramais = []));
                    getsPromises.push(UraResource.query().$promise
                        .then(data => $scope.uras = data)
                        .catch(() => $scope.uras = []));
                    getsPromises.push(IntegracaoConfiguracaoResource.query().$promise
                        .then(data => $scope.integracoes = data)
                        .catch(() => $scope.integracoes = []));
                    getsPromises.push(GrupoResource.lookup().$promise
                        .then(data => $scope.grupos = data.filter(g => g.GrupoTipoId == 1))
                        .catch(() => $scope.grupos = []));

                    function recriarArvore() {
                        let altura = calcularAltura($scope.ura)
                        let profundidade = calcularProfundidade($scope.ura);
                        heightTotal = altura;
                        widthTotal = profundidade * 20 + (xAtual + tamanhoNoX);
                        inicializarPaper();
                        nosExpands = [];
                        plotArvoreExistente($scope.ura, 0);
                        plotExpands();
                    }

                    function getArvore() {
                        requestId++;
                        let requestAtual = requestId;
                        $q.all(getsPromises).then(() => {
                            if (requestAtual != requestId) return;

                            let arvorePromises = [];
                            if ($scope.filtro.tipo == 1) {
                                arvorePromises.push(UraResource.get({ UraId: $scope.filtro.id }).$promise);
                            } else {
                                // Servico: NAO chamar /api/Servico/{id} (DTO pesado + 404 fatal quando
                                // sem permissao na carteira). Usar o lookup local que ja foi carregado em
                                // $scope.servicos (ServicoResource.lookup retorna ServicoId/Numero/Descricao).
                                const servicoLocal = ($scope.servicos || []).find(s => s.ServicoId == $scope.filtro.id);
                                arvorePromises.push($q.resolve(servicoLocal || null));
                            }
                            arvorePromises.push(DashboardReceptivoService.getIndicadoresArvore($scope.filtro.id, $scope.filtro.tipo));
                            $scope.arvoreInicializada = false;
                            $scope.erroArvore = null;
                            requestArvoreId++;
                            let requestArvoreAtual = requestArvoreId;
                            $q.all(arvorePromises).then(results => {
                                if (requestArvoreAtual != requestArvoreId) return;
                                alertasGlobal = results[1];
                                if ($scope.filtro.tipo == 1) {
                                    $scope.ura = results[0];
                                    recriarReferenciaPai($scope.ura);
                                    transformarJsonEmDadosPlot($scope.ura);
                                    uraSelecionada = $scope.ura;
                                    $scope.dataArvore = $scope.ura;
                                    $scope.servicoSelecionada = null;
                                    recriarArvore();
                                    notificarNoUra();
                                } else {
                                    let servico = results[0];
                                    if (servico == null) {
                                        // Servico nao encontrado no lookup local — sem permissao ou removido
                                        tratarErroCarregamento({ status: 404 });
                                        return;
                                    }
                                    $scope.servicoSelecionada = servico;
                                    $scope.dataArvore = $scope.servicoSelecionada;
                                    uraSelecionada = null;
                                    $scope.ura = null;
                                    heightTotal = yIncremento * 2;
                                    widthTotal = 2 * 20 + (xAtual + tamanhoNoX);
                                    inicializarPaper();
                                    plotArvoreServico(servico);
                                    notificarNoServico();
                                }
                                $scope.arvoreInicializada = true;
                            }).catch(function (error) {
                                if (requestArvoreAtual == requestArvoreId) {
                                    tratarErroCarregamento(error);
                                }
                            });
                        })
                    }

                    function tratarErroCarregamento(error) {
                        DashReceptivoStorage.limparItem($scope.filtro.tipo == 1 ? 'ura' : 'servico');

                        alertasGlobal = [];
                        alertasPorNo = [];
                        nosExpands = [];
                        noSelecionado = null;
                        uraSelecionada = null;
                        $scope.ura = null;
                        $scope.servicoSelecionada = null;
                        $scope.dataArvore = null;
                        heightTotal = yIncremento * 2;
                        widthTotal = 2 * 20 + (xAtual + tamanhoNoX);
                        inicializarPaper();

                        $scope.erroArvore = (error && error.status === 404)
                            ? 'Sem acesso ao item selecionado. Selecione outro na lista.'
                            : 'Erro ao carregar a arvore.';

                        // NAO disparar onNoSelecionado com id=null: as 4 diretivas filhas
                        // (indicadores, painel, lista, regiao) ja podem ter dados validos do
                        // clique anterior; zerar tudo aqui causava o sintoma de "mapa aparece
                        // e depois some" sempre que esta funcao era invocada apos um sucesso.
                        // A arvore mostra o erro somente nela mesma.

                        $scope.arvoreInicializada = true;
                    }

                    function notificarNoServico() {
                        let novoFiltro = $scope.filtro;
                        novoFiltro.menuNome = noSelecionado.attributes.attrs['.descricao'].text;
                        novoFiltro.servicoNome = noSelecionado.attributes.attrs['.descricao'].text;
                        $rootScope.$broadcast('onNoSelecionado', novoFiltro);
                    }

                    function notificarNoUra() {
                        let novoFiltro = $scope.filtro;
                        novoFiltro.menuNome = noSelecionado.attributes.attrs['.descricao'].text;
                        novoFiltro.uraNome = noSelecionado.attributes.attrs['.descricao'].text;
                        $rootScope.$broadcast('onNoSelecionado', novoFiltro);
                    }

                    function calcularAltura(ura) {
                        let alturaTotal = 0;
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            alturaTotal += calcularAltura(ura.ChildUra[i]);
                        }
                        return alturaTotal + yIncremento;
                    }

                    function calcularProfundidade(ura) {
                        let level = 1;
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            let depth = calcularProfundidade(ura.ChildUra[i]) + 1;
                            level = Math.max(depth, level);
                        }
                        return level;
                    }

                    function addClass(el, className) {
                        $(el).attr("class", el.classList.value + ' ' + className);
                    }

                    function removeClass(el, className) {
                        $(el).attr("class", el.classList.value.replace(className, ''));
                    }

                    function inicializarPaper() {
                        yAtual = 10;
                        xAtual = 16;
                        $scope.mensagemAlertas = '';
                        $scope.graph = new joint.dia.Graph;
                        $('#ura-builder').html('');
                        $scope.paper = new joint.dia.Paper({
                            el: $('#ura-builder'),
                            model: $scope.graph,
                            gridSize: 1,
                            width: widthTotal,
                            height: heightTotal,
                            perpendicularLinks: true,
                            restrictTranslate: false,
                            interactive: false
                        });
                        $scope.paper.on('element:pointerup', (elementView, evt) => {
                            let novoFiltro;
                            if (V(evt.target).hasClass('erro')) {
                                let alertas = _.filter(alertasPorNo, el => {
                                    return el.no == elementView.attributes()['model-id']
                                })
                                if (alertas != null && alertas.length > 0) {
                                    $scope.mensagemAlertas = ''
                                    for (let i = 0; i < alertas.length; i++) {
                                        $scope.mensagemAlertas += '<tr>';
                                        $scope.mensagemAlertas += '<td class="td-principal">' + alertas[i].IndicadorNome + '</td>';
                                        $scope.mensagemAlertas += '<td class="danger">' + alertas[i].ValorAtual + '</td>';
                                        $scope.mensagemAlertas += '<td>' + alertas[i].Condicao + '</td>';
                                        $scope.mensagemAlertas += '</tr>';
                                    }
                                    $('#table-alertas').html($scope.mensagemAlertas);
                                    let modal = UIkit.modal("#alertas-modal");
                                    if (!modal.isActive()) modal.show();
                                }
                            } else if (V(evt.target).hasClass('card')) {
                                if (uraSelecionada != null) {
                                    limparSelecionado();
                                    addClass(elementView.$el[0], 'no-selecionado');
                                    noSelecionado = elementView.model;
                                    let ura = UraHelper.buscarNoemUra($scope.ura, noSelecionado);
                                    if (ura != uraSelecionada) uraSelecionada = ura;
                                    $scope.$apply();
                                    novoFiltro = {
                                        dataInicio: $scope.filtro.dataInicio,
                                        dataFim: $scope.filtro.dataFim,
                                        id: ura.UraId,
                                        tipo: ura.ParentUraId == null ? 1 : 3,
                                        carteiraId: $scope.filtro.carteiraId,
                                        menuNome: noSelecionado.attributes.attrs['.descricao'].text,
                                        uraNome: ura.ParentUraId == null ? noSelecionado.attributes.attrs['.descricao'].text : ura.UraRaiz.Descricao
                                    }
                                } else {
                                    let servico = $scope.servicoSelecionada;
                                    limparSelecionado();
                                    $scope.servicoSelecionada = servico;
                                    addClass(elementView.$el[0], 'no-selecionado');
                                    noSelecionado = elementView.model;
                                    novoFiltro = {
                                        dataInicio: $scope.filtro.dataInicio,
                                        dataFim: $scope.filtro.dataFim,
                                        id: $scope.servicoSelecionada.ServicoId,
                                        tipo: 2,
                                        carteiraId: $scope.filtro.carteiraId,
                                        menuNome: noSelecionado.attributes.attrs['.descricao'].text,
                                        servicoNome: noSelecionado.attributes.attrs['.descricao'].text
                                    }
                                }
                                $scope.filtro = novoFiltro;
                                $rootScope.$broadcast('onNoSelecionado', novoFiltro);
                            } else if (V(evt.target).hasClass('expand-card')) {
                                $timeout(function () {
                                    let noUra = null;
                                    for (let i = 0; i < nosExpands.length; i++) {
                                        if (nosExpands[i].expandoNo.id == elementView.model.id) noUra = nosExpands[i].no;
                                    }
                                    if (noUra != null) {
                                        let ura = UraHelper.buscarNoemUra($scope.ura, noUra);
                                        esconderFilhos($scope.ura, ura);
                                        recriarArvore();
                                    }
                                }, 200)
                            }
                        });
                    }

                    function esconderFilhos(pai, ura) {
                        if (pai == ura) ura.esconder = !ura.esconder;
                        if (!pai.esconder) {
                            for (let i = 0; i < pai.ChildUra.length; i++) {
                                esconderFilhos(pai.ChildUra[i], ura);
                            }
                        }
                    }

                    function plotNo(x, width, height, descricao, tipoUra, alertas) {
                        let tipoSVG = '';

                        if (alertas == null) alertas = [];
                        if (tipoUra == 'ramal' || tipoUra == 'pabx') tipoSVG = UraHelper.iconeRamal;
                        else if (tipoUra == 'grupo') tipoSVG = UraHelper.iconeGrupo;
                        else if (tipoUra == 'servico') tipoSVG = UraHelper.iconeServico;
                        else if (tipoUra == 'menu' || tipoUra == 'avancado') tipoSVG = UraHelper.iconeMenu;
                        else if (tipoUra == 'ura') tipoSVG = UraHelper.iconeUra;
                        else if (tipoUra == 'desliga') tipoSVG = UraHelper.iconeDesliga;
                        else if (tipoUra == 'transferencia') tipoSVG = UraHelper.iconeTransferencia;
                        else if (tipoUra == 'integracao') tipoSVG = UraHelper.iconeIntegracao;
                        else if (tipoUra == 'pergunta') tipoSVG = UraHelper.iconePergunta;

                        joint.shapes.org.Member.prototype.markup = [
                            '<g class="rotatable" >',
                            '<g class="scalable">',
                            '<rect class="card view"/>',
                            '</g>',
                            '<g class="icon">' + tipoSVG + '</g>',
                            '<g class="erro ' + (alertas.length > 0 ? '' : 'escondido') + '"><circle class="erro"/><text class="erro">' + alertas.length + '</text></g>',
                            '<text class="tipo" /><text class="descricao"/>',
                            '</g>'
                        ].join('');

                        let cellObj = {
                            size: {
                                width: width,
                                height: height
                            },
                            position: {
                                x: x,
                                y: yAtual
                            },
                            attrs: {
                                '.card': {
                                    'rx': 0,
                                    'ry': 0,
                                    'stroke': 'none',
                                    fill: '#f2f2f2'
                                },
                                '.descricao': {
                                    text: (descricao != null && descricao.length > 20) ? descricao.substr(0, 14) + '...' : descricao,
                                    'font-family': 'Roboto,sans-serif',
                                    'font-size': 11,
                                    'font-weight': 700,
                                    'y-alignment': 'middle',
                                    'word-spacing': '-1px',
                                    'letter-spacing': 0,
                                    'text-decoration': 'none',
                                    'ref-y': 0.5,
                                    'ref-x': 30,
                                },
                                'g.erro': {
                                    'ref-x': width - 5,
                                    'ref-y': 5,
                                    cursor: 'pointer'
                                },
                                'g.erro>circle': {
                                    r: 10,
                                    'stroke-width': 2,
                                    fill: '#e53935',
                                    stroke: '#ffffff',
                                },
                                'g.erro>text': {
                                    'font-size': 16,
                                    'font-weight': 800,
                                    fill: '#ffffff',
                                    'font-family': 'Roboto,sans-serif',
                                    x: -4,
                                    y: 6,
                                },
                                '.icon': {
                                    'ref-x': 3,
                                    'ref-y': 3,
                                },
                            }
                        };
                        yAtual += yIncremento;
                        let cell = new joint.shapes.org.Member(cellObj);
                        $scope.graph.addCell(cell);

                        if (alertas.length > 0) {
                            for (let i = 0; i < alertas.length; i++) {
                                alertas[i].no = cell.id;
                                alertasPorNo.push(alertas[i]);
                            }
                            addClass($('g[model-id=\'' + cell.id + '\']')[0], 'danger');
                        }

                        return cell;
                    }

                    function plotLink(source, target) {
                        let link = new joint.dia.Link({
                            source: {
                                id: source.id
                            },
                            target: {
                                id: target.id
                            },
                            router: {
                                name: 'oneSide',
                                args: {
                                    side: 'left',
                                    padding: 10
                                }
                            },
                            connector: {
                                name: 'normal'
                            },
                            attrs: {
                                '.connection': {
                                    'fill': 'none',
                                    'stroke-width': '2',
                                    'stroke': '#595697'
                                },
                                '.marker-target': {
                                    fill: 'none',
                                }
                            }
                        });
                        $scope.graph.addCell(link);
                        return link;
                    }

                    function transformarJsonEmDadosPlot(ura) {
                        ura.DadosNo = JSON.parse(ura.DadosNo);
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            transformarJsonEmDadosPlot(ura.ChildUra[i]);
                        }
                    }

                    function plotArvoreServico(servico) {
                        // Descricao pode vir do lookup (ServicoLookupDto: ServicoId/Numero/Descricao).
                        // Fallback para Numero se Descricao estiver vazia.
                        const titulo = (servico.Descricao || servico.Numero || '') + ' (Raiz)';
                        let noPrincipal = plotNo(xAtual, tamanhoNoX, tamanhoNoY, titulo, 'menu');
                        noSelecionado = noPrincipal;
                        $scope.servicoSelecionada = servico;
                        addClass($('g[model-id=\'' + noPrincipal.id + '\']')[0], 'no-selecionado');
                        xAtual += xIncremento;
                        // Nota: o no filho de GrupoRamal/Ramal foi removido porque exigia chamar
                        // /api/Servico/{id}, que retorna DTO obeso e 404a quando o usuario nao tem
                        // acesso a carteira. O lookup nao traz GrupoRamal/Ramal.
                    }

                    function plotExpands() {
                        for (let i = 0; i < nosExpands.length; i++) {
                            joint.shapes.org.Member.prototype.markup = [
                                '<g class="expand">',
                                '<rect class="expand-card"/>',
                                '<text/>',
                                '</g>'
                            ].join('');
                            let cellExpandObj = {
                                size: {
                                    width: 12,
                                    height: 12
                                },
                                position: {
                                    x: nosExpands[i].x - 36,
                                    y: nosExpands[i].y + 9
                                },
                                attrs: {
                                    '.expand-card': {
                                        'stroke-width': 2,
                                        width: 12,
                                        height: 12
                                    },
                                    'g.expand>text': {
                                        text: nosExpands[i].collapse ? '+' : '-',
                                        x: nosExpands[i].collapse ? 2 : 3,
                                        'font-size': nosExpands[i].collapse ? 13 : 16,
                                        y: 10
                                    }
                                }
                            };
                            let expandCell = new joint.shapes.org.Member(cellExpandObj);
                            $scope.graph.addCell(expandCell);
                            if (nosExpands[i].ura.filhoTemErro) {
                                addClass($('g[model-id=\'' + expandCell.id + '\']')[0], 'expand-erro');
                                removeClass($('g[model-id=\'' + nosExpands[i].no.id + '\'] g.erro')[0], 'escondido');
                                addClass($('g[model-id=\'' + nosExpands[i].no.id + '\'] g.erro>text')[0], 'erro-filho');
                                $('g[model-id=\'' + nosExpands[i].no.id + '\'] g.erro>text')[0].setAttributeNS(null, 'x', -3);
                                $('g[model-id=\'' + nosExpands[i].no.id + '\'] g.erro>text')[0].setAttributeNS(null, 'y', 3);
                                $('g[model-id=\'' + nosExpands[i].no.id + '\'] g.erro>text').text('↓');
                            }
                            nosExpands[i].expandoNo = expandCell;
                        }
                    }

                    function plotArvoreExistente(ura, nivel) {
                        let novoNo, noPrincipal = null;
                        if (ura.ParentUra == null) {
                            noPrincipal = plotNo(xAtual, tamanhoNoX, tamanhoNoY, `${ura.Descricao} (Raiz)`, 'menu');
                            ura.DadosPlot = noPrincipal;
                            ura.TipoUra = 'menu';

                            addClass($('g[model-id=\'' + noPrincipal.id + '\']')[0], 'no-selecionado');
                            noSelecionado = noPrincipal;
                            uraSelecionada = ura;
                        } else {
                            let tipoUra = _.find(UraHelper.tiposUra, el => { return el.TipoId == ura.UraTipoId }).Descricao;
                            let descricaoNo, digitoTexto = '';

                            if (tipoUra == 'ramal') {
                                descricaoNo = ura.DadosNo.descricao;
                            } else if (tipoUra == 'pabx') {
                                descricaoNo = ura.DadosNo.descricao;
                            } else if (tipoUra == 'ura') {
                                descricaoNo = ura.DadosNo.descricao;
                            } else if (tipoUra == 'grupo') {
                                descricaoNo = ura.DadosNo.descricao;
                            } else if (tipoUra == 'servico') {
                                descricaoNo = ura.DadosNo.descricao;
                            } else if (tipoUra == 'menu') {
                                descricaoNo = 'Escolha de Dígito';
                            } else if (tipoUra == 'desliga') {
                                descricaoNo = 'Desliga a URA';
                            } else if (tipoUra == 'integracao') {
                                descricaoNo = ura.DadosNo.descricao;
                                ura.UraCondicao.forEach(condicao => {
                                    let integracaoSelecionada = _.find($scope.integracoes, el => {
                                        return ura.UraIntegracaoId == el.IntegracaoConfiguracaoId;
                                    });
                                    condicao.RespostaNome = _.find(integracaoSelecionada.IntegracaoResposta, el => {
                                        return condicao.IntegracaoRespostaId == el.IntegracaoRespostaId;
                                    }).Nome;
                                    condicao.OperadorNome = _.find($scope.operadores, el => {
                                        return condicao.OperadorId == el.OperadorLogicoId;
                                    }).Alias;
                                    let condicaoUraTipo = condicao.RedirecionaUra.UraTipo.Descricao;
                                    if (condicaoUraTipo == 'Grupo' || condicaoUraTipo == 'Ramal' || condicaoUraTipo == 'Ura' || condicaoUraTipo == 'Serviço')
                                        condicaoUraTipo = 'Transferência';

                                    condicao.UraDescricao = _.find(UraHelper.tiposUraRedireciona, el => {
                                        return condicaoUraTipo == el.Alias;
                                    }).Alias;

                                    if (condicao.RedirecionaUra.UraId != ura.UraId) {
                                        condicao.RedirecionaUra = _.find(ura.ChildUra, el => {
                                            return el.UraId == condicao.RedirecionaUra.UraId;
                                        });
                                        if (condicao.RedirecionaUra != null) {
                                            condicao.RedirecionaUra.DigitoTexto = condicao.RespostaNome + ' ' + condicao.OperadorNome + ' ' + condicao.ValorComparacao;
                                        }
                                    }
                                });
                            }

                            if (ura.Botao) digitoTexto = 'Dígito ' + ura.Botao;
                            else digitoTexto = ura.DigitoTexto || ura.Botao;

                            noSelecionado = UraHelper.buscarIdemUra($scope.ura, ura.ParentUra.UraId).DadosPlot;

                            let alertas = [];
                            if (alertasGlobal != null) alertas = _.filter(alertasGlobal, el => { return el.MenuNo == ura.UraId; });

                            novoNo = adicionarNovoNo(xAtual, descricaoNo, digitoTexto, tipoUra, alertas, ura);

                            mudarDescricaoNo(ura);
                        }
                        xAtual += xIncremento;
                        if (ura.ChildUra != null && ura.ChildUra.length > 0) {
                            nosExpands.push({
                                ura: ura,
                                no: noPrincipal || novoNo,
                                x: xAtual,
                                y: yAtual - yIncremento,
                                collapse: (ura.esconder) || (!$scope.arvoreInicializada && nivel >= 3)
                            });
                        }
                        if ((!ura.esconder && $scope.arvoreInicializada) || (!$scope.arvoreInicializada && nivel < 3)) {
                            ura.filhoTemErro = false;
                            for (let i = 0; i < ura.ChildUra.length; i++) {
                                plotArvoreExistente(ura.ChildUra[i], nivel + 1);
                            }
                        } else {
                            ura.esconder = true;
                            ura.filhoTemErro = verificarFilhosAlerta(ura);
                        }
                        xAtual -= xIncremento;
                        return novoNo;
                    }

                    function verificarFilhosAlerta(ura, filho) {
                        if (filho == true) {
                            let alertas = [];
                            if (alertasGlobal != null) alertas = _.filter(alertasGlobal, el => { return el.MenuNo == ura.UraId });
                            if (alertas.length > 0) return true;
                        }
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            if (verificarFilhosAlerta(ura.ChildUra[i], true)) return true;
                        }
                        return false;
                    }

                    function limparSelecionado() {
                        uraSelecionada = null;
                        $scope.servicoSelecionada = null;
                        noSelecionado = null;
                        for (let i = 0; i < $('#ura-builder g').length; i++) {
                            removeClass($('#ura-builder g')[i], 'no-selecionado');
                        }
                    }

                    function adicionarNovoNo(posicaoX, descricaoNo, digito, tipoUra, alertas, uraExistente) {
                        let uraPai = UraHelper.buscarNoemUra($scope.ura, noSelecionado);

                        if (digito && isNaN(digito)) digito = null;

                        let uraTipoId = _.find(UraHelper.tiposUra, el => { return el.Descricao == tipoUra }).TipoId;
                        let novoNo = plotNo(posicaoX, tamanhoNoX, tamanhoNoY, descricaoNo, tipoUra, alertas);
                        let tipoTransferencia = null;
                        if (tipoUra == 'servico' || tipoUra == 'ramal' || tipoUra == 'grupo' || tipoUra == 'ura') {
                            tipoTransferencia = tipoUra;
                            tipoUra = 'transferencia';
                        }
                        plotLink(noSelecionado, novoNo);
                        if (uraExistente == null) {
                            let novaUra = {
                                DadosPlot: novoNo,
                                ChildUra: [],
                                ParentUra: uraPai,
                                Botao: digito,
                                TipoUra: tipoUra,
                                UraTipoId: uraTipoId,
                                TipoTransferencia: tipoTransferencia
                            }
                            if (!uraPai.ChildUra) uraPai.ChildUra = [];
                            uraPai.ChildUra.push(novaUra);
                            if (uraPai.TipoUra == 'integracao') {
                                let index = _.indexOf(uraPai.UraCondicao, $scope.condicaoEditada);
                                uraPai.UraCondicao[index].RedirecionaUra = novaUra;
                            }
                            if (tipoUra == 'integracao') {
                                $scope.ura.TipoUra = 'avancado';
                                $scope.ura.UraTipoId = 7;
                            }
                        } else {
                            uraExistente.TipoUra = tipoUra;
                            uraExistente.DadosPlot = novoNo;
                            uraExistente.ParentUra = uraPai;
                            uraExistente.TipoTransferencia = tipoTransferencia;
                        }
                        return novoNo;
                    }

                    function recriarReferenciaPai(ura) {
                        if (ura.ParentUra != null) {
                            let uraPai = UraHelper.buscarIdemUra($scope.ura, ura.ParentUraId);
                            if (uraPai != null) ura.ParentUra = uraPai;
                        }
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            recriarReferenciaPai(ura.ChildUra[i]);
                        }
                    }

                    function mudarDescricaoNo(uraAtual) {
                        let tipoUra = uraAtual.TipoUra;
                        if (uraAtual.Descricao)
                            uraAtual.DadosPlot.attr('.descricao/text', uraAtual.Descricao.length > 17 ? uraAtual.Descricao.substr(0, 14) + '...' : uraAtual.Descricao);
                        else {
                            if (tipoUra == 'transferencia' && uraAtual.TipoTransferencia != null)
                                tipoUra = uraAtual.TipoTransferencia;
                            if (tipoUra == 'ramal') {
                                let ramal = _.find($scope.ramais, el => { return el.RamalId == uraAtual.RamalId });
                                if (ramal)
                                    uraAtual.DadosPlot.attr('.descricao/text', ramal.Numero.length > 17 ? ramal.Numero.substr(0, 14) + '...' : ramal.Numero);
                                else
                                    uraAtual.DadosPlot.attr('.descricao/text', 'Ramal');
                            } else if (tipoUra == 'grupo') {
                                let grupo = _.find($scope.grupos, el => { return el.GrupoId == uraAtual.GrupoId });
                                if (grupo)
                                    uraAtual.DadosPlot.attr('.descricao/text', grupo.Descricao.length > 17 ? grupo.Descricao.substr(0, 14) + '...' : grupo.Descricao);
                                else
                                    uraAtual.DadosPlot.attr('.descricao/text', 'Grupo');
                            } else if (tipoUra == 'ura') {
                                let ura = _.find($scope.uras, el => { return el.UraId == uraAtual.RedirecionaUraId });
                                if (ura)
                                    uraAtual.DadosPlot.attr('.descricao/text', ura.Descricao && ura.Descricao.length > 17 ? ura.Descricao.substr(0, 14) + '...' : ura.Descricao);
                                else
                                    uraAtual.DadosPlot.attr('.descricao/text', 'URA');
                            } else if (tipoUra == 'servico') {
                                let servico = _.find($scope.servicos, el => { return el.ServicoId == uraAtual.ServicoId });
                                if (servico)
                                    uraAtual.DadosPlot.attr('.descricao/text', servico.Numero.length > 17 ? servico.Numero.substr(0, 14) + '...' : servico.Numero);
                                else
                                    uraAtual.DadosPlot.attr('.descricao/text', 'Serviço');
                            } else if (tipoUra == 'desliga') {
                                uraAtual.DadosPlot.attr('.descricao/text', 'Desliga a URA');
                            } else if (tipoUra == 'transferencia') {
                                uraAtual.DadosPlot.attr('.descricao/text', 'Desligar Ura');
                            } else if (tipoUra == 'integracao') {
                                let integracao = _.find($scope.integracoes, el => {
                                    return el.IntegracaoConfiguracaoId == uraAtual.UraIntegracaoId;
                                });
                                if (integracao)
                                    uraAtual.DadosPlot.attr('.descricao/text', integracao.Nome.length > 17 ? integracao.Nome.substr(0, 14) + '...' : integracao.Nome);
                                else
                                    uraAtual.DadosPlot.attr('.descricao/text', 'Integração');
                            }
                        }
                    }

                    $scope.showFull = function () {
                        $scope.dataFull.filtro = angular.copy($scope.filtro);
                        $scope.dataFull.arvore = angular.copy($scope.dataArvore);
                        $scope.dataFull.filtro.id = $scope.ura.UraId;
                        $scope.dataFull.filtro.tipo = 1;
                        $scope.exibirFull = true;
                        $rootScope.$broadcast('onCheckFull', 'side');
                    };

                    $scope.hideFull = function () {
                        $scope.dataFull.filtro = null;
                        $scope.dataFull.arvore = null;
                        $scope.exibirFull = false;
                        $rootScope.$broadcast('onCheckFull', 'main');
                    };

                    $scope.$on('onServicoSelecionado', function (event, filtro) {
                        $scope.filtro = {
                            dataInicio: filtro.dataInicio,
                            dataFim: filtro.dataFim,
                            id: filtro.servico,
                            tipo: 2,
                            carteiraId: filtro.carteiraId,
                            grupoId: filtro.grupoId
                        };
                        getArvore();
                    });

                    $scope.$on('onUraSelecionado', function (event, filtro) {
                        $scope.filtro = {
                            dataInicio: filtro.dataInicio,
                            dataFim: filtro.dataFim,
                            id: filtro.ura,
                            tipo: 1,
                            carteiraId: filtro.carteiraId,
                            grupoId: filtro.grupoId
                        };
                        getArvore();
                    });
                }],

                templateUrl: '../app_dash/pages/dashReceptivo/arvore/arvore.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('convertToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (val) {
                        return val == '' ? null : parseInt(val, 10);
                    });
                    ngModel.$formatters.push(function (val) {
                        return val == null ? '' : '' + val;
                    });
                }
            };
        })
        .directive('configuracaoIndicadores', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ["$scope", "$timeout", "DashboardReceptivoResource", "OperadorLogicoResource", "DashboardReceptivoService", function configuracaoIndicadores($scope, $timeout, DashboardReceptivoResource, OperadorLogicoResource,
                    DashboardReceptivoService) {
                    $('[data-toggle="tooltip"]').tooltip();
                    $scope.indicadores = [];
                    $scope.operadores = [];
                    $scope.promises = [];
                    $scope.tempos = [
                        { tempo: '10', alias: '10 s' },
                        { tempo: '20', alias: '20 s' },
                        { tempo: '30', alias: '30 s' },
                        { tempo: '40', alias: '40 s' },
                        { tempo: '50', alias: '50 s' },
                        { tempo: '60', alias: '60 s' },
                        { tempo: '70', alias: '70 s' }
                    ];

                    OperadorLogicoResource.odata().filter("OperadorDashboard", "=", true).query().then(data => {
                        $scope.operadores = data;
                    });

                    $scope.quantidadeCard = 0;
                    $scope.possuiFavorito = false;
                    $scope.requestId = 0;
                    $scope.calculosNVS = [];

                    $scope.carregarIndicadores = function () {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        DashboardReceptivoResource.getIndicadoresConfiguracao().$promise.then(data => {
                            DashboardReceptivoService.getIndicadorDashboardNVSTipo().then(function (result) {
                                if (result) {
                                    $scope.calculosNVS = result;
                                    $scope.IndicadorDashboardNVSTipoId = result[0].IndicadorDashboardNVSTipoId;
                                }

                                if (requestAtual == $scope.requestId) {
                                    $scope.indicadores = data;
                                    $scope.periodoSelecionado = data[0].Intervalo;

                                    if(data[0].IndicadorDashboardNVSTipoId > 0)
                                        $scope.IndicadorDashboardNVSTipoId = data[0].IndicadorDashboardNVSTipoId;

                                    let nvs = _.find($scope.indicadores, el => el.Indicador.Alias == 'NVS');

                                    if (nvs && nvs.ValorBomMin) {
                                        let bom = nvs.ValorBomMin.split("/");
                                        if (bom.length == 2) {
                                            nvs.ValorBomPorcentagem = bom[0];
                                            nvs.ValorBomTempo = bom[1];
                                        }
                                    }

                                    let qafl = _.find($scope.indicadores, el => el.Indicador.Alias == 'QAFL');

                                    if (qafl && qafl.ValorBomMin) {
                                        qafl.ValorBomTempo = qafl.ValorBomMin;
                                    }

                                    $scope.quantidadeCard = _.filter($scope.indicadores, el => { return el.ExibirCard == true; }).length;
                                    $scope.possuiFavorito = (_.find($scope.indicadores, el => { return el.Favorito == true; })) != null;

                                    $timeout(() => {
                                        $('.timepicker-input').timepicker({ 'timeFormat': 'H:i:s' });
                                        $scope.indicadores.forEach($scope.initializeTimepicker);
                                    })
                                }
                            });
                        })
                    }

                    $scope.dataFormatada = function (secs) {
                        if (!secs) return;
                        let minutes = Math.floor(secs / 60);
                        secs = secs % 60;
                        let hours = Math.floor(minutes / 60)
                        minutes = minutes % 60;
                        let newDate = new Date();
                        newDate.setHours(hours);
                        newDate.setMinutes(minutes);
                        newDate.setSeconds(secs);
                        return newDate;
                    }

                    $scope.initializeTimepicker = function (indicador) {
                        if ($('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            $('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorRuimMin));
                        }
                        if ($('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            $('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorRuimMax));
                        }
                        if ($('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            $('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorBomMin));
                        }
                        if ($('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            $('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorBomMax));
                        }
                    }

                    $scope.initializeTimepickerUnico = function (indicador, apenasBom, apenasRuim) {
                        $timeout(() => {
                            if ($('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).length > 0 && apenasRuim) {
                                $('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker({ 'timeFormat': 'H:i:s' });
                                $('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorRuimMin));
                            }
                            if ($('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).length > 0 && apenasRuim) {
                                $('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker({ 'timeFormat': 'H:i:s' });
                                $('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorRuimMax));
                            }
                            if ($('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).length > 0 && apenasBom) {
                                $('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker({ 'timeFormat': 'H:i:s' });
                                $('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorBomMin));
                            }
                            if ($('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).length > 0 && apenasBom) {
                                $('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker({ 'timeFormat': 'H:i:s' });
                                $('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('setTime', $scope.dataFormatada(indicador.ValorBomMax));
                            }
                        });
                    }

                    $scope.onOperadorBomChange = function (indicador) {
                        if (indicador.OperadorBom == 7) {
                            indicador.OperadorRuim = null;
                            indicador.ValorRuimMin = null;
                            indicador.ValorRuimMax = null;
                        } else {
                            indicador.ValorBomMax = null;
                        }
                        $('.timepicker-input').timepicker({ 'timeFormat': 'H:i:s' });
                        $scope.initializeTimepickerUnico(indicador, true);
                    }

                    $scope.onOperadorRuimChange = function (indicador) {
                        if (indicador.OperadorRuim == 7) {
                            indicador.OperadorBom = null;
                            indicador.ValorBomMin = null;
                            indicador.ValorBomMax = null;
                        } else {
                            indicador.ValorRuimMax = null;
                        }
                        $scope.initializeTimepickerUnico(indicador, false, true);
                    }

                    $scope.onCardChange = function (indicador) {
                        $scope.quantidadeCard = _.filter($scope.indicadores, el => {
                            return el.ExibirCard == true;
                        }).length;
                        if (!indicador.ExibirCard && indicador.Favorito) {
                            indicador.Favorito = false;
                            $scope.possuiFavorito = false;
                        }
                    }

                    $scope.onFavoritoChange = function (indicador) {
                        for (let i = 0; i < $scope.indicadores.length; i++) {
                            if ($scope.indicadores[i].IndicadorId != indicador.IndicadorId) {
                                $scope.indicadores[i].Favorito = false;
                            }
                        }
                        $scope.possuiFavorito = indicador.Favorito;
                    }

                    $scope.selecionarPeriodo = function (periodo) {
                        $scope.periodoSelecionado = periodo;
                    }

                    $scope.cancelar = function () {
                        let modal = UIkit.modal("#configurar-modal");
                        if (modal.isActive()) modal.hide();
                    }

                    $scope.calcularSegundos = function (time) {
                        if (!time || (time.length > 0 && time[0].value === '')) return null;
                        return parseInt(time.getHours() * 3600) + parseInt(time.getMinutes() * 60) + parseInt(time.getSeconds());
                    }

                    $scope.calcularTempo = function (indicador) {
                        if ($('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            let ruimin = $('#timepicker-ruimmin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('getTime');
                            indicador.ValorRuimMin = $scope.calcularSegundos(ruimin);
                        }
                        if ($('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            let ruimax = $('#timepicker-ruimmax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('getTime');
                            indicador.ValorRuimMax = $scope.calcularSegundos(ruimax);
                        }
                        if ($('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            let bommin = $('#timepicker-bommin-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('getTime');
                            indicador.ValorBomMin = $scope.calcularSegundos(bommin);
                        }
                        if ($('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).length > 0) {
                            let bommax = $('#timepicker-bommax-' + indicador.IndicadorDashboardConfiguracaoId).timepicker('getTime');
                            indicador.ValorBomMax = $scope.calcularSegundos(bommax);
                        }
                        return indicador;
                    }

                    $scope.salvar = function () {
                        if ($scope.quantidadeCard != 6) {
                            return UIkit.modal.alert("São necessários 6 indicadores para exibir no card!");
                        }
                        if (!$scope.possuiFavorito) {
                            return UIkit.modal.alert("É necessário um favorito!");
                        }

                        let nvs = _.find($scope.indicadores, el => el.Indicador.Alias == 'NVS');

                        if (nvs != null && nvs.ValorBomPorcentagem != null && nvs.ValorBomTempo != null)
                            nvs.ValorBomMin = nvs.ValorBomPorcentagem + '/' + nvs.ValorBomTempo;

                        let qafl = _.find($scope.indicadores, el => el.Indicador.Alias == 'QAFL');

                        if (qafl != null && qafl.ValorBomTempo != null)
                            qafl.ValorBomMin = qafl.ValorBomTempo;

                        $scope.indicadores.forEach(el => {
                            if (el.Indicador.Alias == 'DRT' || el.Indicador.Alias == 'TME' || el.Indicador.Alias == 'TMA' || el.Indicador.Alias == 'TMEF' || el.Indicador.Alias == 'TMER') {
                                $scope.calcularTempo(el);
                            }
                        });
                        let temErro = false;
                        for (let i = 0; i < $scope.indicadores.length; i++) {
                            if ($scope.indicadores[i].Indicador.Alias != 'NVS') {
                                if ($scope.indicadores[i].OperadorBom != 7 && $scope.indicadores[i].OperadorRuim != 7) {
                                    if ((($scope.indicadores[i].ValorBomMin == null || $scope.indicadores[i].ValorBomMin == '') && ($scope.indicadores[i].OperadorBom != null && $scope.indicadores[i].OperadorBom != '')) || (($scope.indicadores[i].ValorBom != null && $scope.indicadores[i].ValorBom != '') && ($scope.indicadores[i].OperadorBom == null || $scope.indicadores[i].OperadorBom == ''))) {
                                        $scope.indicadores[i].erroBom = true;
                                        temErro = true;
                                    } else {
                                        $scope.indicadores[i].erroBom = false;
                                    }
                                    if ((($scope.indicadores[i].ValorRuimMin == null || $scope.indicadores[i].ValorRuimMin == '') && ($scope.indicadores[i].OperadorRuim != null && $scope.indicadores[i].OperadorRuim != '')) || (($scope.indicadores[i].ValorRuim != null && $scope.indicadores[i].ValorRuim != '') && ($scope.indicadores[i].OperadorRuim == null || $scope.indicadores[i].OperadorRuim == ''))) {
                                        $scope.indicadores[i].erroRuim = true;
                                        temErro = true;
                                    } else {
                                        $scope.indicadores[i].erroRuim = false;
                                    }
                                } else {
                                    if ($scope.indicadores[i].OperadorBom == 7) {
                                        if ($scope.indicadores[i].ValorBomMin == null || $scope.indicadores[i].ValorBomMin === '' || $scope.indicadores[i].ValorBomMax === null || $scope.indicadores[i].ValorBomMiax === '') {
                                            $scope.indicadores[i].erroBom = true;
                                            temErro = true;
                                        } else {
                                            $scope.indicadores[i].erroBom = false;
                                        }
                                    } else {
                                        if ($scope.indicadores[i].ValorRuimMin === null || $scope.indicadores[i].ValorRuimMin === '' || $scope.indicadores[i].ValorRuimMax === null || $scope.indicadores[i].ValorRuimMax === '') {
                                            $scope.indicadores[i].erroRuim = true;
                                            temErro = true;
                                        } else {
                                            $scope.indicadores[i].erroRuim = false;
                                        }
                                    }
                                }
                            } else {
                                if ((($scope.indicadores[i].ValorBomTempo == null || $scope.indicadores[i].ValorBomTempo == '') && ($scope.indicadores[i].ValorBomPorcentagem != null && $scope.indicadores[i].ValorBomPorcentagem != '')) || (($scope.indicadores[i].ValorBomTempo != null && $scope.indicadores[i].ValorBomTempo != '') && ($scope.indicadores[i].ValorBomPorcentagem == null || $scope.indicadores[i].ValorBomPorcentagem == ''))) {
                                    $scope.indicadores[i].erroBom = true;
                                    temErro = true;
                                } else {
                                    $scope.indicadores[i].erroBom = false;
                                }
                            }
                            $scope.indicadores[i].Intervalo = $scope.periodoSelecionado;
                            $scope.indicadores[i].IndicadorDashboardNVSTipoId = $scope.IndicadorDashboardNVSTipoId;
                        }
                        if (temErro == true) return;


                        DashboardReceptivoService.atualizarIndicadoresConfiguracao($scope.indicadores).then(() => {
                            let modal = UIkit.modal("#configurar-modal");
                            if (modal.isActive()) modal.hide();
                            UIkit.notify('Configurações salvas. Recerregando...', 'success');
                            $timeout(() => { location.reload() }, 3000);
                        });
                    }

                    $scope.carregarIndicadores();

                    UIkit.modal("#configurar-modal").on({
                        'show.uk.modal': () => {
                            $scope.carregarIndicadores();
                        }
                    });
                }],
                templateUrl: '../app_dash/pages/dashReceptivo/configuracaoIndicadores/configuracaoIndicadores.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('configuracaoNvs', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {
                    configurarId: '=',
                    tipo: '='
                },
                controller: ["$scope", "$timeout", "DashboardReceptivoService", function configuracaoIndicadores($scope, $timeout, DashboardReceptivoService) {
                    $scope.configuracao = {};
                    $scope.requestId = 0;
                    $scope.tempos = [];

                    $scope.tempos = [{
                        tempo: 0,
                        alias: '--'
                    }, {
                        tempo: 10,
                        alias: '10 s'
                    }, {
                        tempo: 20,
                        alias: '20 s'
                    }, {
                        tempo: 30,
                        alias: '30 s'
                    }, {
                        tempo: 40,
                        alias: '40 s'
                    }, {
                        tempo: 50,
                        alias: '50 s'
                    }, {
                        tempo: 60,
                        alias: '60 s'
                    }, {
                        tempo: 70,
                        alias: '70 s'
                    }];

                    $scope.cancelar = function () {
                        let modal = UIkit.modal("#configurar-modal-nvs");
                        if (modal.isActive()) {
                            modal.hide();
                        }
                    }

                    $scope.remover = function () {
                        DashboardReceptivoService.removerIndicadorNvs($scope.configurarId, $scope.tipo).then(function (data) {
                            let modal = UIkit.modal("#configurar-modal-nvs");
                            if (modal.isActive()) {
                                modal.hide();
                            }
                            UIkit.notify('Configurações salvas. Recarregando...', 'success');
                            $timeout(function () { location.reload() }, 3000);
                        });
                    }

                    $scope.salvar = function () {
                        if (isNaN(parseInt($scope.configuracao.NvsValorBomPorcentagem)) || parseInt($scope.configuracao.NvsValorBomPorcentagem) <= 0) {
                            UIkit.modal.alert("A porcentagem do nível de serviço é necessária!");
                            return;
                        }
                        if (isNaN(parseInt($scope.configuracao.NvsValorBomTempo)) || parseInt($scope.configuracao.NvsValorBomTempo) <= 0) {
                            UIkit.modal.alert("O tempo do nível de serviço é necessário!");
                            return;
                        }

                        $scope.configuracao.Nvs = $scope.configuracao.NvsValorBomPorcentagem + '/' + $scope.configuracao.NvsValorBomTempo;

                        DashboardReceptivoService.atualizarConfiguracaoIndividual($scope.configuracao).then(function (data) {
                            let modal = UIkit.modal("#configurar-modal-nvs");
                            if (modal.isActive()) {
                                modal.hide();
                            }
                            UIkit.notify('Configurações salvas. Recarregando...', 'success');
                            $timeout(function () { location.reload() }, 3000);
                        });
                    }

                    $scope.carregarIndicadores = function () {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        $scope.calculosNVS = [];                        
                        
                        DashboardReceptivoService.getConfiguracaoIndividual($scope.configurarId, $scope.tipo).then(function (data) {
                            DashboardReceptivoService.getIndicadorDashboardNVSTipo().then(function (result) {
                                if (result) {
                                    $scope.calculosNVS = result;
                                    $scope.IndicadorDashboardNVSTipoId = result[0];

                                    if (requestAtual == $scope.requestId) {
                                        $scope.configuracao = data;
                                    }
                                }
                            });
                        });
                    }

                    let modal = UIkit.modal("#configurar-modal-nvs");
                    modal.on({
                        'show.uk.modal': function () {
                            $scope.nvsConf = {};
                            $timeout($scope.carregarIndicadores);
                        }
                    });
                }],
                templateUrl: '../app_dash/pages/dashReceptivo/configuracaoNvs/configuracaoNvs.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoOcupacaoUra', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ['$scope', '$timeout', 'DashboardReceptivoService', function GraficoPrincipalController($scope, $timeout, DashboardReceptivoService) {
                    $scope.chartPrincipal = [];
                    $scope.periodos = [];
                    $scope.showGraph = true;
                    $scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        fornecedores: []
                    };
                    $scope.corErro = '#d9534f';
                    $scope.corSucesso = '#90ee90';
                    $scope.corTotal = '#2196F3';
                    $scope.requestId = 0;

                    $scope.noSelecionado = function ($event, dados) {
                        //blockUI($('.chartprincipal-ocupacao-container'));
                        $scope.getPeriodos(dados);
                    }

                    $scope.eventListener = $scope.$on('onNoSelecionado', $scope.noSelecionado);

                    $scope.zoomAtivo = false;

                    $scope.updateQueue = [];
                    $scope.queueDataUpdate = function (chart, data) {
                        for (let i = 0; i < $scope.updateQueue; i++) {
                            if ($scope.updateQueue[i].chart == chart) {
                                $scope.updateQueue[i].data = data
                                return;
                            }
                        }

                        $scope.updateQueue.push({
                            "chart": chart,
                            "data": data
                        });

                        $scope.processUpdateQueue();
                    };

                    $scope.processUpdateQueue = function () {
                        if ($scope.updateQueue.length) {
                            let item = $scope.updateQueue.shift();
                            item.chart.dataProvider = item.data;
                            item.chart.validateData();
                        }
                    };

                    AmCharts.addInitHandler(function (chart) {
                        chart.addListener("dataUpdated", function () {
                            $scope.processUpdateQueue();
                        })
                    }, ["serial"]);
                    $scope.chartsExistentes = {};
                    $scope.configChartPrincipal = function () {
                        $timeout(function () {
                            for (let id in $scope.chartsExistentes) {
                                $scope.chartsExistentes[id].atualizado = false;
                            }
                            if ($scope.periodos != null) {
                                for (let i = 0; i < $scope.periodos.length; i++) {
                                    let balloonDateFormat = "DD/MM JJ:NN";
                                    $scope.zoomAtivo = true;
                                    if ($scope.chartsExistentes != null) {
                                        if ($scope.chartsExistentes[$scope.periodos[i].Dados[0].RotaId] != null) {
                                            //chart já existe: update
                                            $scope.queueDataUpdate(
                                                $scope.chartsExistentes[$scope.periodos[i].Dados[0].RotaId],
                                                $scope.periodos[i].Dados
                                            );
                                            $scope.chartsExistentes[$scope.periodos[i].Dados[0].RotaId].atualizado = true;
                                        } else {
                                            //chart não existe: create
                                            let chartCriado = AmCharts.makeChart("chartprincipal-ocupacao-" + i, { //666
                                                "type": "serial",
                                                "theme": "light",
                                                "marginRight": 5,
                                                "language": "pt",
                                                // "dataDateFormat": "YYYY-MM-DDTHH:mm:SS",
                                                "autoMarginOffset": 0,
                                                "numberFormatter": {
                                                    precision: -1,
                                                    decimalSeparator: ",",
                                                    thousandsSeparator: "."
                                                },
                                                "legend": {
                                                    "equalWidths": false,
                                                    "periodValueText": "Ativo: [[value.sum]]",
                                                    "position": "right",
                                                    "valueAlign": "left",
                                                    "marginRight": 0,
                                                    "horizontalGap": 0,
                                                    "color": "#fff",
                                                    "markerSize": 10,
                                                    "data": [{
                                                        title: "Ativo",
                                                        color: $scope.corTotal
                                                    }, {
                                                        title: "Receptivo",
                                                        color: $scope.corErro
                                                    }]
                                                },
                                                "dataProvider": $scope.periodos[i].Dados,
                                                "graphs": [{
                                                    "balloonText": "Ativo: <b>[[value]]</b>",
                                                    "fillAlphas": 1,
                                                    "lineAlpha": 0.4,
                                                    "title": "Ativo",
                                                    "valueField": "QuantidadeTotal",
                                                    "fillColors": $scope.corTotal,
                                                    "lineColor": $scope.corTotal
                                                }, {
                                                    "balloonText": "Receptivo: <b>[[value]]</b>",
                                                    "fillAlphas": 1,
                                                    "lineAlpha": 0.4,
                                                    "title": "Receptivo",
                                                    "valueField": "Receptivo",
                                                    "fillColors": $scope.corErro,
                                                    "lineColor": $scope.corErro
                                                }],
                                                "valueAxes": [{
                                                    "stackType": "regular",
                                                    "gridAlpha": 0.5,
                                                    "gridColor": "#fff",
                                                    "position": "left",
                                                    "title": "Canais",
                                                    "axisColor": "#fff",
                                                    "color": "#fff",
                                                    "titleColor": "#fff",
                                                    "titleBold": false,
                                                    "maximum": $scope.periodos[i].Dados[0].QuantidadeCanal,
                                                }],
                                                "plotAreaBorderAlpha": 0,
                                                "marginTop": 10,
                                                "marginLeft": 20,
                                                "zoomOutText": "",
                                                "mouseWheelZoomEnabled": true,
                                                "marginBottom": 0,
                                                "chartCursor": {
                                                    "valueLineEnabled": true,
                                                    "valueLineBalloonEnabled": true,
                                                    "cursorAlpha": 1,
                                                    "cursorColor": "#258cbb",
                                                    "valueLineAlpha": 0.2,
                                                    "selectWithoutZooming": false,
                                                    "categoryBalloonDateFormat": balloonDateFormat,
                                                    "zoomed": false
                                                },
                                                "categoryField": "DataHora",
                                                "categoryAxis": {
                                                    "parseDates": true,
                                                    "gridAlpha": 0.07,
                                                    "axisColor": "#fff",
                                                    "color": "#fff",
                                                    "minPeriod": 'mm',
                                                },
                                                "export": {
                                                    "enabled": false
                                                }
                                            });
                                            $scope.chartPrincipal.push(chartCriado);
                                            if ($scope.periodos[i].Dados != null && $scope.periodos[i].Dados.length >= 0) {
                                                $scope.chartsExistentes[$scope.periodos[i].Dados[0].RotaId] = chartCriado;
                                                $scope.chartsExistentes[$scope.periodos[i].Dados[0].RotaId].atualizado = true;
                                                $scope.periodos[i].RotaId = $scope.periodos[i].Dados[0].RotaId;
                                            }
                                        }
                                    }
                                }
                            }
                            for (let id in $scope.chartsExistentes) {
                                if ($scope.chartsExistentes[id].atualizado == false) {
                                    $scope.chartsExistentes[id].clear();
                                    delete $scope.chartsExistentes[id];
                                }
                            }
                        });
                    }

                    $scope.maisZoom = function (chart) {
                        chart.zoomToIndexes(chart.startIndex + 20, chart.endIndex - 20);
                    }

                    $scope.menosZoom = function (chart) {
                        chart.zoomToIndexes(chart.startIndex - 20, chart.endIndex + 20);
                    }

                    $scope.limparZoom = function (chart) {
                        chart.zoomOut();
                    }

                    $scope.getPeriodos = function (filtro) {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        filtro.dataInicio = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        filtro.dataFim = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        DashboardReceptivoService.getOcupacaoPeriodos(filtro.dataInicio, filtro.dataFim, filtro.id, filtro.tipo).then(function (data) {
                            if (data.length) {
                                if (data[0].Rota != null && data[0].Rota != "") {
                                    if (requestAtual == $scope.requestId) {
                                        $scope.periodos = data;
                                        for (let i = 0; i < $scope.periodos.length; i++) {                                            
                                            if ($scope.periodos[i].Dados != null && $scope.periodos[i].Dados.length >= 0) {
                                                $scope.periodos[i].RotaId = $scope.periodos[i].Dados[0].RotaId;
                                            }
                                        }
                                        $scope.showGraph = data.length != 0;
                                        $scope.recarregarChartPrincipal();
                                    }
                                }
                                else {
                                    $scope.periodos = null;
                                    $scope.chartPrincipal = [];
                                    $scope.showGraph = false;
                                    $scope.recarregarChartPrincipal();
                                }
                            }
                            else {
                                $scope.periodos = null;
                                $scope.chartPrincipal = [];
                                $scope.showGraph = false;
                                $scope.recarregarChartPrincipal();
                            }
                        });
                    }

                    $scope.recarregarChartPrincipal = function () {
                        $scope.configChartPrincipal();
                    }

                    $scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        $scope.chartPrincipal = [];
                        }catch(e){}
                        $scope.eventListener();
                    });
                }],
                templateUrl: '../app_dash/pages/dashReceptivo/graficoOcupacaoUra/graficoOcupacaoUra.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('indicadores', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ['$scope', 'DashboardReceptivoService', function IndicadoresController($scope, DashboardReceptivoService) {
                    $scope.showGraph = true;
                    $scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        fornecedores: []
                    };
                    $scope.rawData = [];
                    $scope.dados = [];
                    $scope.dadosFull = { lista: [] };
                    $scope.graphs = [];
                    $scope.exibirFull = false;

                    $scope.noSelecionado = function ($event, dados) {
                        $scope.filtro = dados;
                        $scope.getIndicadores(dados);
                    }

                    $scope.eventListener = $scope.$on('onNoSelecionado', $scope.noSelecionado);

                    $scope.$on('onAtualizacaoOnline', function ($event, dados) {
                        if ($scope.filtro && $scope.filtro.id != null) {
                            $scope.filtro.dataInicio = dados.dataInicio;
                            $scope.filtro.dataFim = dados.dataFim;
                            $scope.getIndicadores($scope.filtro);
                        }
                    });

                    $scope.requestId = 0;
                    $scope.getIndicadores = function (filtro) {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        // id=null = broadcast espurio (arvore em erro etc). Preserva os
                        // dados ja carregados em vez de zerar e limpar o grafico.
                        if (filtro.id == null) {
                            $scope.loading = false;
                            return;
                        }
                        filtro.dataInicio = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        filtro.dataFim = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        $scope.loading = true;
                        $scope.erroCarregamento = null;
                        DashboardReceptivoService.getIndicadores(filtro.dataInicio, filtro.dataFim, filtro.id, filtro.tipo, false, filtro.carteiraId, filtro.grupoId).then(function (data) {
                            if (requestAtual == $scope.requestId) {
                                $('#chartIndicadores').html('');
                                $scope.rawData = data;
                                $scope.dados = [];
                                $scope.graphs = [];
                                if (data && data.length > 0) {
                                    data.forEach(function (row) {
                                        let dt = {};
                                        dt['nome'] = row.Dados[0].Nome;
                                        dt['hora'] = row.Hora != null ? row.Hora : row.Data;
                                        row.Dados.forEach(function (dados) {
                                            dt[dados.Indicador] = dados.Valor;
                                        });

                                        $scope.dados.push(dt);
                                    });

                                    data[0].Dados.forEach(function (row) {
                                        let gh = {};
                                        gh.balloonText = "<span style='font-size:14px'>" + row.Nome + ": <b>[[value]] ([[percents]]%)</b></span>";
                                        gh.fillAlphas = 0.8;
                                        gh.toolTip = row.Nome;
                                        gh.lineAlpha = 0.3;
                                        gh.title = row.Alias;
                                        gh.type = 'column';
                                        gh.color = '#000000';
                                        gh.valueField = row.Indicador;
                                        gh.labelText = "[[value]]";
                                        $scope.graphs.push(gh);
                                    });

                                    $scope.configChartPrincipal();
                                }
                                $scope.loading = false;
                            }
                        }).catch(function (error) {
                            if (requestAtual == $scope.requestId) {
                                $scope.loading = false;
                                $scope.erroCarregamento = (error && error.status === 404)
                                    ? 'Sem dados disponiveis.'
                                    : 'Erro ao carregar indicadores.';
                                $scope.rawData = [];
                                $scope.dados = [];
                                $scope.graphs = [];
                            }
                        });
                    }

                    $scope.getIndicadoresFull = function (filtro) {
                        DashboardReceptivoService.getIndicadores(filtro.dataInicio, filtro.dataFim, filtro.id, filtro.tipo, true, filtro.carteiraId, filtro.grupoId).then(function (data) {
                            $scope.dadosFull = { lista: [] };

                            data.forEach(function (row) {
                                let dt = {};
                                dt['nome'] = row.Dados[0].Nome;
                                dt['hora'] = row.Hora != null ? row.Hora : row.Data;
                                row.Dados.forEach(function (dados) {
                                    dt[dados.Indicador] = dados.Valor;
                                });
                                for (let key in dt) {
                                    if (dt.hasOwnProperty(key) && key != 'nome' && key != 'hora') {
                                        if (!$scope.dadosFull[key]) $scope.dadosFull[key] = dt[key]
                                        else $scope.dadosFull[key] += dt[key];
                                    }
                                }
                                $scope.dadosFull.lista.push(dt);
                            });
                        });
                    }

                    $scope.chartConfig = {
                        "type": "serial",
                        "theme": "light",
                        "marginRight": 1,
                        "legend": {
                            "horizontalGap": 0.1,
                            "verticalGap": 0.1,
                            //"maxColumns": 2,
                            "position": "right",
                            // "useGraphSettings": true,
                            // "markerSize": 10
                            "color": "#fff",
                            //"marginRight": 1
                            "useGraphSettings": true,
                        },
                        //  "dataProvider": $scope.dados,
                        "valueAxes": [{
                            "stackType": "regular",
                            "axisAlpha": 0.3,
                            "gridAlpha": 0,
                            "color": "#fff",
                            "totalText": "[[total]]",
                            "totalTextColor": "#fff"
                        }],
                        // "graphs": $scope.graphs,
                        "categoryField": "hora",
                        "categoryAxis": {
                            "gridPosition": "start",
                            "axisAlpha": 0,
                            "gridAlpha": 0,
                            "position": "left",
                            "color": "#fff",
                            "labelFunction": function (valueText) {
                                if (valueText.length > 2)
                                    return moment(valueText).format("DD/MM")
                                else
                                    return valueText < 10 ? "0" + valueText + ":00" : valueText + ":00";
                            }
                        },
                    }

                    $scope.configChartPrincipal = function () {
                        let chartIndicadores = clone($scope.chartConfig);
                        chartIndicadores.dataProvider = clone($scope.dados);
                        chartIndicadores.graphs = clone($scope.graphs);
                        $scope.chartPrincipal = AmCharts.makeChart("chartIndicadores", chartIndicadores);
                    }

                    $scope.configChartFull = function () {
                        let chartIndicadoresFull = clone($scope.chartConfig);
                        chartIndicadoresFull.dataProvider = clone($scope.dados);
                        chartIndicadoresFull.graphs = clone($scope.graphs);
                        $scope.chartFull = AmCharts.makeChart("chartIndicadoresFull", chartIndicadoresFull);
                    }

                    function clone(obj) {
                        let copy;

                        // Handle the 3 simple types, and null or undefined
                        if (null == obj || "object" != typeof obj) return obj;

                        // Handle Date
                        if (obj instanceof Date) {
                            copy = new Date();
                            copy.setTime(obj.getTime());
                            return copy;
                        }

                        // Handle Array
                        if (obj instanceof Array) {
                            copy = [];
                            for (let i = 0, len = obj.length; i < len; i++) {
                                copy[i] = clone(obj[i]);
                            }
                            return copy;
                        }

                        // Handle Object
                        if (obj instanceof Object) {
                            copy = {};
                            for (let attr in obj) {
                                if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
                            }
                            return copy;
                        }

                        throw new Error("Unable to copy obj! Its type isn't supported.");
                    }

                    $scope.showFull = function () {
                        $scope.exibirFull = true;
                        setTimeout(function () {
                            $scope.configChartFull();
                            $scope.getIndicadoresFull($scope.filtro);
                        }, 0);
                    }

                    $scope.hideFull = function () {
                        $scope.exibirFull = false;
                        $scope.dadosFull = { lista: [] };
                    }

                    $scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        $scope.chartPrincipal = [];
                        $scope.chartFull = [];
                        }catch(e) {}
                    });
                }],
                templateUrl: '../app_dash/pages/dashReceptivo/indicadores/indicadores.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('indicadoresPrincipal', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ["$scope", "$timeout", "DashboardReceptivoService", function ListaIndicadoresController($scope, $timeout, DashboardReceptivoService) {
                    $scope.exibirFull = false;
                    $scope.indicadores = [];
                    $scope.indicadorSelecionado = {};
                    $scope.filtro = {};

                    $scope.noSelecionado = function ($event, dados) {
                        $scope.filtro = dados;
                        $scope.GetPainelIndicadores(dados);
                    }

                    $scope.eventListener = $scope.$on('onNoSelecionado', $scope.noSelecionado);

                    // Ao trocar de aba (Servico <-> URA) limpa os cards da aba anterior na hora.
                    // Sem isso, a lista antiga (com contagem diferente) fica na tela durante todo o
                    // getArvore da nova aba e depois "ajusta" — o pisca visual no topo. O requestId++
                    // invalida qualquer resposta em voo da aba anterior para nao repopular apos limpar.
                    $scope.$on('onAbaSelecionada', function () {
                        $scope.requestId++;
                        $scope.indicadores = [];
                        $scope.erroCarregamento = null;
                    });

                    $scope.$on('onAtualizacaoOnline', function ($event, dados) {
                        if ($scope.filtro && $scope.filtro.id != null) {
                            $scope.filtro.dataInicio = dados.dataInicio;
                            $scope.filtro.dataFim = dados.dataFim;
                            $scope.GetPainelIndicadores($scope.filtro);
                        }
                    });

                    $scope.requestId = 0;
                    $scope.GetPainelIndicadores = function (dados) {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        // id=null = broadcast espurio. Preserva indicadores ja carregados.
                        if (dados.id == null) {
                            $scope.loading = false;
                            return;
                        }
                        dados.dataInicio = moment(dados.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        dados.dataFim = moment(dados.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        $scope.loading = true;
                        $scope.erroCarregamento = null;
                        DashboardReceptivoService.getPainelIndicadores(dados.id, dados.dataInicio, dados.dataFim, dados.tipo, dados.carteiraId, dados.grupoId).then(function (data) {
                            if (requestAtual == $scope.requestId) {
                                $scope.indicadores = data || [];
                                $timeout(function () {
                                    if (Array.isArray($scope.indicadores)) {
                                        $scope.indicadores.forEach(function (el) {
                                            $scope.plotGauge(el);
                                        });
                                    }
                                });
                                $scope.loading = false;
                            }
                        }).catch(function (error) {
                            if (requestAtual == $scope.requestId) {
                                $scope.loading = false;
                                $scope.indicadores = [];
                                $scope.erroCarregamento = (error && error.status === 404)
                                    ? 'Sem dados disponiveis.'
                                    : 'Erro ao carregar painel.';
                            }
                        });
                    }

                    $scope.plotGauge = function (indicador) {
                        // NAO chamar AmCharts.clear() aqui: a funcao e GLOBAL e destroi
                        // TODOS os charts da pagina (mapa, indicadores, outros gauges).
                        // O codigo original tinha o typo "AmCharts.claer()" que falhava
                        // silenciosamente — corrigir o typo destruia o mapa/graficos a cada
                        // re-render do gauge. Limpeza correta fica no $destroy.
                        if (indicador.Alias == 'NVS' || indicador.ValorBomMin != null || indicador.ValorRuimMin != null) {
                            let bands = [];
                            let valor = 0;
                            if (indicador.Alias == 'NVS') {
                                if (indicador.ValorBomMin != null) {
                                    let limite = indicador.ValorBomMin.split('/')[0];
                                    bands = [{
                                        "color": "#f35958",
                                        "startValue": 0,
                                        "endValue": limite,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }, {
                                        "color": "#90ee90",
                                        "startValue": limite,
                                        "endValue": 100,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }]
                                    valor = indicador.Valor.split('/')[0];
                                    if (!isNaN(parseInt(valor)) && !isNaN(parseInt(limite))) {
                                        if (parseInt(valor) >= parseInt(limite)) indicador.Classe = 'success'
                                        else indicador.Classe = 'danger'
                                    }
                                }
                            } else {
                                if (indicador.ValorRuimMin != null && indicador.ValorBomMin != null) {
                                    bands = [{
                                        "color": "#f35958",
                                        "startValue": 0,
                                        "endValue": 33,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }, {
                                        "color": "#f0ad4e",
                                        "startValue": 33,
                                        "endValue": 66,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }, {
                                        "color": "#90ee90",
                                        "startValue": 66,
                                        "endValue": 100,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }]
                                    if (indicador.Classe == 'danger') valor = 0;
                                    else if (indicador.Classe == 'success') valor = 100;
                                    else { valor = 50; indicador.Classe = 'warning' }
                                } else {
                                    bands = [{
                                        "color": "#f35958",
                                        "startValue": 0,
                                        "endValue": 50,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }, {
                                        "color": "#90ee90",
                                        "startValue": 50,
                                        "endValue": 100,
                                        "innerRadius": "105%",
                                        "radius": "170%",
                                        "gradientRatio": [0.5, 0, -0.5],
                                    }]
                                    if (indicador.Classe == 'danger') valor = 25;
                                    else if (indicador.Classe == 'success') valor = 75
                                    else if (indicador.ValorRuimMin != null) { valor = 75; indicador.Classe = 'success'; }
                                    else if (indicador.ValorBomMin != null) { valor = 25; indicador.Classe = 'danger'; }
                                }
                            }
                            if (bands.length > 0) {
                                AmCharts.makeChart("gauge-" + indicador.Alias, {
                                    "theme": "light",
                                    "type": "gauge",
                                    "axes": [{
                                        "axisAlpha": 0,
                                        "tickAlpha": 0,
                                        "endValue": 100,
                                        "radius": "50%",
                                        "startAngle": -90,
                                        "endAngle": 90,
                                        "unit": "%",
                                        "labelsEnabled": false,
                                        "bands": bands
                                    }],
                                    "arrows": [{
                                        "alpha": 1,
                                        "innerRadius": "30%",
                                        "nailRadius": 0,
                                        "radius": "180%",
                                        "color": "#ffffff",
                                        "startWidth": 3,
                                        "value": valor,
                                    }]
                                });
                            }
                        } else {
                            indicador.Classe = '';
                        }
                    }
                    $scope.GetPainelIndicador = function (dados) {
                        dados.dataInicio = moment(dados.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        dados.dataFim = moment(dados.dataFim).format('YYYY-MM-DDTHH:mm:ss');

                        DashboardReceptivoService.getPainelIndicador(dados.id, dados.tipo, $scope.indicadorSelecionado.Alias, dados.dataInicio, dados.dataFim, dados.carteiraId, dados.grupoId).then(function (data) {
                            $scope.dadosFull = data;
                            $scope.configChartPrincipal();
                        });

                        if($scope.indicadorSelecionado.Alias == "QLP" || $scope.indicadorSelecionado.Alias == "QRA")
                        {
                            DashboardReceptivoService.getDashboardReceptivoRechamada(dados.id, dados.tipo, $scope.indicadorSelecionado.Alias, dados.dataInicio, dados.dataFim, 0, dados.carteiraId).then(function (data) {
                                $scope.dadosRechamadas = data;
                            });
                        }
                    }

                    $scope.carregarRechamadasHora = function(periodo)
                    {
                        if($scope.indicadorSelecionado.Alias == "QLP" || $scope.indicadorSelecionado.Alias == "QRA")
                        {                            
                            var data = new Date(periodo);
                            var hora = data.getHours();
                            DashboardReceptivoService.getDashboardReceptivoRechamada($scope.filtro.id, $scope.filtro.tipo, $scope.indicadorSelecionado.Alias, $scope.filtro.dataInicio, $scope.filtro.dataFim, hora, $scope.filtro.carteiraId).then(function (data) {
                                $scope.dadosRechamadas = data;
                            });
                        }
                    }

                    $scope.configChartPrincipal = function () {
                        // NAO chamar AmCharts.clear() aqui: destruiria o mapa e outros graficos
                        // da pagina inteira. Veja comentario em plotGauge.
                        $scope.chartPrincipal = AmCharts.makeChart("chartFulldivIndicadores", {
                            "type": "serial",
                            "theme": "light",
                            "marginTop": 20,
                            "marginRight": 30,
                            "marginLeft": 30,
                            "dataProvider": $scope.dadosFull,
                            "valueAxes": [{
                                "axisAlpha": 0,
                                "position": "left",
                                "gridColor": "#fff",
                                "axisColor": "#fff",
                                "color": "#fff",
                                "titleColor": "#fff",
                            }],
                            "graphs": [{
                                "id": "g1",
                                "balloonText": "[[category]]<br><b><span style='font-size:14px;'>[[value]]</span></b>",
                                "bullet": "round",
                                "bulletSize": 8,
                                // "lineColor": "#d1655d",
                                // "lineThickness": 2,
                                // "type": "line",
                                "valueField": "Valor"
                            }],
                            "chartCursor": {
                                "categoryBalloonDateFormat": "YYYY",
                                "cursorAlpha": 0,
                                "valueLineEnabled": true,
                                "valueLineBalloonEnabled": true,
                                "valueLineAlpha": 0.5,
                                "fullWidth": true
                            },
                            "dataDateFormat": "",
                            "categoryField": "Periodo",
                            "categoryAxis": {
                                // "minPeriod": "mm",
                                // "parseDates": true,
                                "minorGridAlpha": 0.1,
                                "minorGridEnabled": true,
                                "axisColor": "#fff",
                                "color": "#fff",
                                "labelFunction": function (valueText, date) {
                                    var inicio = moment($scope.filtro.dataInicio);
                                    var fim = moment($scope.filtro.dataFim);
                                    var diff = fim.diff(inicio, 'hours')
                                    if (diff <= 3)
                                        return moment(date.category).format('HH:mm').toString();
                                    else if (diff > 3 && diff <= 24)
                                        return moment(date.category).format('HH:mm').toString();
                                    else
                                        return moment(date.category).format('DD/MM').toString();
                                },
                                "labelRotation": 45
                            }
                        });
                    }

                    $scope.showFull = function (indicador) {
                        $scope.exibirFull = true;
                        $scope.dadosFull = [];
                        $scope.dadosRechamadas = [];
                        $scope.indicadorSelecionado = indicador;
                        setTimeout(function () {
                            $scope.GetPainelIndicador($scope.filtro);
                        }, 0);
                    }

                    $scope.hideFull = function () {
                        $scope.exibirFull = false;
                    }

                    $scope.FormataData = function (data) {
                        let inicio = moment($scope.filtro.dataInicio);
                        let fim = moment($scope.filtro.dataFim);
                        let diff = fim.diff(inicio, 'hours')
                        if (diff <= 3)
                            return moment(data).format('HH:mm').toString();
                        else if (diff > 3 && diff <= 24)
                            return moment(data).format('HH:mm').toString();
                        else
                            return moment(data).format('DD/MM').toString();
                    }

                    $scope.$on('$destroy', () => {
                        try{
                        AmCharts.clear();
                        $scope.chartPrincipal = [];
                        }catch(e){}
                    });

                }],
                templateUrl: '../app_dash/pages/dashReceptivo/indicadoresPrincipal/indicadoresPrincipal.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('listaindicadores', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ["$scope", "DashboardReceptivoService", function ListaIndicadoresController($scope, DashboardReceptivoService) {
                    $scope.dataAtual = new Date();
                    let weekday = new Array(7);
                    weekday[0] = {
                        dia: "Domingo",
                        vogal: 'o'
                    };
                    weekday[1] = {
                        dia: "Segunda",
                        vogal: 'a'
                    };
                    weekday[2] = {
                        dia: "Terça",
                        vogal: 'a'
                    };
                    weekday[3] = {
                        dia: "Quarta",
                        vogal: 'a'
                    };
                    weekday[4] = {
                        dia: "Quinta",
                        vogal: 'a'
                    };
                    weekday[5] = {
                        dia: "Sexta",
                        vogal: 'a'
                    };
                    weekday[6] = {
                        dia: "Sábado",
                        vogal: 'o'
                    };
                    $scope.diaSemana = weekday[$scope.dataAtual.getDay()];

                    $scope.filtroAtual = null;
                    $scope.noSelecionado = function ($event, dados) {
                        $scope.filtroAtual = dados;
                        $scope.getIndicadores(dados);
                    }

                    $scope.eventListener = $scope.$on('onNoSelecionado', $scope.noSelecionado);

                    $scope.$on('onAtualizacaoOnline', function ($event, dados) {
                        if ($scope.filtroAtual && $scope.filtroAtual.id != null) {
                            $scope.filtroAtual.dataInicio = dados.dataInicio;
                            $scope.filtroAtual.dataFim = dados.dataFim;
                            $scope.getIndicadores($scope.filtroAtual);
                        }
                    });

                    $scope.requestId = 0;
                    $scope.getIndicadores = function (dados) {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        // id=null = broadcast espurio. Preserva a lista ja carregada.
                        if (dados.id == null) {
                            $scope.loading = false;
                            return;
                        }
                        dados.dataInicio = moment(dados.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        dados.dataFim = moment(dados.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        $scope.loading = true;
                        $scope.erroCarregamento = null;
                        DashboardReceptivoService.getDashboardReceptivoIndicador(dados.dataInicio, dados.dataFim, dados.id, dados.tipo, dados.carteiraId, dados.grupoId).then(function (data) {
                            if (requestAtual == $scope.requestId) {
                                $scope.indicadores = data;
                                setTimeout(function () {
                                    $('[data-toggle="tooltip"]').tooltip();
                                }, 0);
                                $scope.loading = false;
                            }
                        }).catch(function (error) {
                            if (requestAtual == $scope.requestId) {
                                $scope.loading = false;
                                $scope.indicadores = [];
                                $scope.erroCarregamento = (error && error.status === 404)
                                    ? 'Sem dados disponiveis.'
                                    : 'Erro ao carregar lista.';
                            }
                        });
                    }
                }],
                templateUrl: '../app_dash/pages/dashReceptivo/listaIndicadores/listaIndicadores.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('regiao', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ['$scope', 'DashboardReceptivoService', 'DashReceptivoStorage', function RegiaoController($scope, DashboardReceptivoService, DashReceptivoStorage) {
                    $scope.rawData = [];
                    $scope.rawDataFull = [];
                    $scope.mapData = [];
                    $scope.mapDataFull = [];
                    $scope.totalFull = 0;
                    $scope.totalUFFull = 0;
                    $scope.totalUF = 0;
                    $scope.exibirFull = false;
                    $scope.showTimerMapa = true;
                    $scope.showFullMap = true;
                    $scope.showFullMapFull = true;
                    $scope.selectedAreaLastIndex = 0;
                    $scope.tableData = [];
                    $scope.tableDataFull = [];
                    $scope.filtro = [];
                    $scope.ordenado = {
                        key: '',
                        direcao: ''
                    }

                    let intervalOnline = null;
                    const tempo = 120000;

                    let top3EstadosCache = DashReceptivoStorage.getTop3Estados();
                    if (top3EstadosCache != null) {
                        $scope.showTimerMapa = top3EstadosCache;
                    }

                    $scope.noSelecionado = function ($event, dados) {
                        clearTimeout(intervalOnline);
                        $scope.selectedAreaLastIndex = 0;

                        //blockUI($('#regiao-container'));
                        $scope.filtro = dados;
                        $scope.GetRegiao(dados);
                    }

                    $scope.eventListener = $scope.$on('onNoSelecionado', $scope.noSelecionado);

                    $scope.$on('onAtualizacaoOnline', function ($event, dados) {
                        if ($scope.filtro && $scope.filtro.id != null) {
                            $scope.filtro.dataInicio = dados.dataInicio;
                            $scope.filtro.dataFim = dados.dataFim;
                            $scope.GetRegiao($scope.filtro);
                        }
                    });

                    $scope.requestId = 0;
                    $scope.GetRegiao = function (dados) {
                        $scope.requestId++;
                        let requestAtual = $scope.requestId;
                        // id=null = broadcast espurio (ex: arvore em erro). Preserva o
                        // estado atual do mapa em vez de zerar — antes essa branch zerava
                        // mapData/tableData e o usuario via o mapa "desaparecer".
                        if (dados.id == null) {
                            $scope.loading = false;
                            return;
                        }
                        dados.dataInicio = moment(dados.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        dados.dataFim = moment(dados.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        $scope.loading = true;
                        $scope.erroCarregamento = null;
                        DashboardReceptivoService.getRegiao(dados.id, dados.tipo, dados.dataInicio, dados.dataFim, dados.carteiraId, dados.grupoId).then(function (data) {
                            if (requestAtual == $scope.requestId) {
                                $scope.rawData = data;
                                $scope.tableData = $scope.GetTableData();
                                $scope.mapData = $scope.GetFullMap(data);
                                $scope.mapDataFull = $scope.GetFullMap(data);
                                $scope.configChartPrincipal();
                                $scope.loading = false;
                            }
                        }).catch(function (error) {
                            if (requestAtual == $scope.requestId) {
                                $scope.loading = false;
                                $scope.rawData = [];
                                $scope.tableData = [];
                                $scope.mapData = [];
                                $scope.mapDataFull = [];
                                $scope.erroCarregamento = (error && error.status === 404)
                                    ? 'Sem dados disponiveis.'
                                    : 'Erro ao carregar regiao.';
                            }
                        });
                    }

                    $scope.GetRegiaoFull = function (dados) {
                        DashboardReceptivoService.getRegiaoFull(dados.id, dados.tipo, dados.dataInicio, dados.dataFim, dados.carteiraId, dados.grupoId).then(function (data) {
                            $scope.rawDataFull = data;
                            $scope.tableDataFull = $scope.GetTableDataFull();
                            $scope.configChartFull();
                            setTimeout(function () {
                                animateProgress();
                            }, 0);
                        }).catch(function () {
                            $scope.rawDataFull = [];
                            $scope.tableDataFull = [];
                        });
                    }

                    $scope.GetFullMap = function (data) {
                        $scope.totalFull = 0;
                        let arr = []
                        data.forEach(function (element) {
                            let total = element.Dados.reduce(function (s, f) {
                                return f.Valor + s;
                            }, 0);
                            $scope.totalFull += total;
                            arr.push({
                                "id": element.Id,
                                "title": element.Dados[0].Estado,
                                "value": total
                            });
                        });

                        return arr;
                    }

                    $scope.GetTableData = function (uf) {
                        let arr = [];
                        let dados = [];

                        if (uf !== undefined) {
                            dados = $scope.rawData.filter(function (subject) {
                                return subject.Id === uf
                            });
                        }
                        else
                            dados = $scope.rawData;

                        dados.forEach(function (uf) {
                            $scope.totalUF = 0;
                            uf.Dados.forEach(function (ddd) {
                                $scope.totalUF += ddd.Valor;
                                arr.push({
                                    "ddd": ddd.DDD,
                                    "quantidade": ddd.Valor
                                });
                            });
                        });

                        return _.sortBy(arr, function (o) {
                            return o.quantidade * -1;
                        })
                    }

                    $scope.GetTableDataFull = function (uf) {
                        let arr = [];
                        let dados = [];

                        if (uf !== undefined) {
                            dados = $scope.rawDataFull.filter(function (subject) {
                                return subject.Id === uf
                            });
                        }
                        else
                            dados = $scope.rawDataFull;

                        dados.forEach(function (uf) {
                            $scope.totalUFFull = 0;
                            uf.Dados.forEach(function (ddd) {
                                $scope.totalUFFull += ddd.Valor;
                                arr.push({
                                    "ddd": ddd.DDD,
                                    "quantidade": ddd.Valor,
                                    "tma": ddd.TMA,
                                    "tme": ddd.TME,
                                    "desligaEspera": ddd.DesligaEspera,
                                    "atendidoAgente": ddd.AtendidoAgente
                                });
                            });
                        });

                        return _.sortBy(arr, function (o) {
                            return o.quantidade * -1;
                        })
                    }

                    $scope.configChartPrincipal = function () {
                        $scope.chartPrincipal = AmCharts.makeChart("chartdiv-regiao", {
                            "type": "map",
                            "theme": "light",
                            "colorSteps": 10,
                            "dragMap": false,
                            "zoomControl": {
                                "buttonFillColor": "#fff",
                                "buttonIconColor": "#000"
                            },
                            "valueLegend": {
                                "right": 10,
                                "minValue": "Menos",
                                "maxValue": "Mais",
                                "color": "#fff"
                            },
                            "dataProvider": {
                                //"images": images,
                                "map": "brazilLow",
                                "areas": $scope.mapData
                            },
                            "areasSettings": {
                                "autoZoom": true,
                                "balloonText": "[[title]] : [[value]]"
                            },
                            "listeners": [{
                                "event": "init",
                                "method": function (event) {
                                    event.chart.dataProvider.images = [];
                                    event.chart.dataProvider.areas.forEach(function (area) {
                                        let image = new AmCharts.MapImage();
                                        image.latitude = event.chart.getAreaCenterLatitude(area);
                                        image.longitude = event.chart.getAreaCenterLongitude(area);
                                        image.label = area.id.substr(3);
                                        image.title = area.title + " : " + area.value;
                                        image.linkToObject = area;
                                        event.chart.dataProvider.images.push(image);
                                    });

                                    event.chart.validateData();

                                    if ($scope.showTimerMapa == true)
                                        $scope.StartTop3Estado();
                                }
                            }, {
                                "event": "selectedObjectChanged",
                                "method": function (event) {
                                    if (event.chart.selectedObject.map == 'brazilLow') {
                                        $scope.tableData = $scope.GetTableData();
                                    } else {
                                        $scope.tableData = $scope.GetTableData(event.chart.selectedObject.id);
                                        setTimeout(function () {
                                            $scope.$apply();
                                        }, 0)
                                    }
                                }
                            }, {
                                "event": "rendered",
                                "method": function (event) {
                                    let map = event.chart;
                                    map.initialZoomLevel = map.zoomLevel();
                                    map.initialZoomLatitude = map.zoomLatitude();
                                    map.initialZoomLongitude = map.zoomLongitude();
                                }
                            }]
                        });
                    }

                    $scope.configChartFull = function () {
                        $scope.chartFull = AmCharts.makeChart("chartFulldiv", {
                            "type": "map",
                            "theme": "light",
                            "colorSteps": 10,
                            "dragMap": false,
                            "zoomControl": {
                                "buttonFillColor": "#fff",
                                "buttonIconColor": "#000"
                            },
                            "valueLegend": {
                                "right": 10,
                                "minValue": "Menos",
                                "maxValue": "Mais",
                                "color": "#fff"
                            },
                            "dataProvider": {
                                //"images": images,
                                "map": "brazilLow",
                                "areas": $scope.mapDataFull
                            },
                            "areasSettings": {
                                "autoZoom": true,
                                "balloonText": "[[title]] : [[value]]"
                            },
                            "listeners": [{
                                "event": "init",
                                "method": function (event) {
                                    event.chart.dataProvider.images = [];
                                    event.chart.dataProvider.areas.forEach(function (area) {
                                        let image = new AmCharts.MapImage();
                                        image.latitude = event.chart.getAreaCenterLatitude(area);
                                        image.longitude = event.chart.getAreaCenterLongitude(area);
                                        image.label = area.id.substr(3);
                                        image.title = area.title + " : " + area.value;
                                        image.linkToObject = area;
                                        event.chart.dataProvider.images.push(image);
                                    });

                                    event.chart.validateData();
                                    // $scope.StartTop3Estado();
                                }
                            }, {
                                "event": "selectedObjectChanged",
                                "method": function (event) {
                                    if (event.chart.selectedObject.map == 'brazilLow') {
                                        $scope.tableDataFull = $scope.GetTableDataFull();
                                    } else {
                                        $scope.tableDataFull = $scope.GetTableDataFull(event.chart.selectedObject.id);
                                        setTimeout(function () {
                                            $scope.$apply();
                                        }, 0)
                                    }
                                }
                            }, {
                                "event": "rendered",
                                "method": function (event) {
                                    // let map = event.chart;
                                    // map.initialZoomLevel = map.zoomLevel();
                                    // map.initialZoomLatitude = map.zoomLatitude();
                                    // map.initialZoomLongitude = map.zoomLongitude();
                                }
                            }]
                        });
                    }

                    $scope.showFull = function () {
                        $scope.exibirFull = true;
                        setTimeout(function () {
                            $scope.GetRegiaoFull($scope.filtro);
                        }, 0);
                    }

                    $scope.hideFull = function () {
                        $scope.exibirFull = false;
                    }

                    function showTop3Estados() {
                        if ($scope.showFullMap) {
                            $scope.showFullMap = false;
                            $scope.selectedAreaLastIndex = $scope.selectedAreaLastIndex + 1;

                            if ($scope.selectedAreaLastIndex == 4) {
                                $scope.selectedAreaLastIndex = 1;
                            }

                            let area = $scope.chartPrincipal.getObjectById($scope.mapData[$scope.selectedAreaLastIndex - 1].id);
                            $scope.chartPrincipal.clickMapObject(area);
                        } else {
                            $scope.CenterMap();
                        }

                        // setTimeout(function () {
                        //     animateProgress();
                        // }, 0);
                    }

                    $scope.CenterMap = function () {
                        $scope.chartPrincipal.selectObject();
                        $scope.chartPrincipal.zoomToLongLat($scope.chartPrincipal.initialZoomLevel, $scope.chartPrincipal.initialZoomLongitude, $scope.chartPrincipal.initialZoomLatitude);
                        $scope.showFullMap = true;
                    }

                    $scope.StopTop3Estados = function () {
                        if (intervalOnline !== undefined) {
                            clearTimeout(intervalOnline);
                            $scope.CenterMap();
                            $scope.selectedAreaLastIndex = 0;
                        }
                    };

                    $scope.StartTop3Estado = function () {
                        if (intervalOnline !== undefined && !$scope.showTimerMapa)
                            return;
                        intervalOnline = setTimeout(showTop3Estados, tempo);
                    }

                    $scope.executeTimerMapa = function () {
                        DashReceptivoStorage.setTop3Estados($scope.showTimerMapa);
                        if ($scope.showTimerMapa) {
                            $scope.StartTop3Estado();
                        } else {
                            $scope.StopTop3Estados();
                        }
                    }

                    $scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        $scope.chartPrincipal = [];
                        $scope.chartFull = [];
                        }catch(e) {}    
                        clearTimeout(intervalOnline);
                    });

                    $scope.ordenarPor = function (key, direcao) {
                        let funcaoOrdenacao = function (el) {
                            if (key == 'geral')
                                return direcao == 'asc' ? el['quantidade'] : -el['quantidade'];

                            return direcao == 'asc' ? el[key] : -el[key];
                        };


                        $scope.tableDataFull = _.sortBy($scope.tableDataFull, funcaoOrdenacao);
                        $scope.ordenado.key = key;
                        $scope.ordenado.direcao = direcao;
                    }
                }],
                templateUrl: '../app_dash/pages/dashReceptivo/regiao/regiao.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp').directive('servico', function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                pesquisa: '='
            },
            controller: ["$scope", "$locale", "$rootScope", "DashboardReceptivoService", "$timeout", "DashReceptivoStorage", function ServicoController($scope, $locale, $rootScope, DashboardReceptivoService, $timeout, DashReceptivoStorage) {
                $locale.NUMBER_FORMATS.GROUP_SEP = " ";
                $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";
                $scope.inicializado = false;
                $scope.total = {};
                $scope.servicos = [];
                $scope.servicoSelecionado = {};
                $scope.abaSelecionada = false;
                $scope.filtro = {
                    tipo: 2,
                    dataFim: new Date(),
                    dataInicio: new Date(),
                    carteiraId: null,
                    operacaoId: null,
                    grupoId: 0,
                    servico: null
                };

                $scope.requestId = 0;
                $scope.GetServicos = function () {
                    $scope.requestId++;
                    let requestAtual = $scope.requestId;
                    $scope.filtro.dataInicio = moment($scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                    $scope.filtro.dataFim = moment($scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                    DashboardReceptivoService.getUra(2, $scope.filtro.dataInicio, $scope.filtro.dataFim, $scope.filtro.carteiraId, $scope.filtro.grupoId).then(function (data) {
                        if (requestAtual == $scope.requestId) {
                            $scope.servicos = data;
                            $rootScope.$broadcast('onEsconderAbaServico', $scope.servicos == null || $scope.servicos.length == 0);
                            $scope.servicos.forEach(function (element) {
                                element.Nome = element.Dados[0].Nome;
                            });
                            if ($scope.abaSelecionada) {
                                let objSelecionado = null;
                                if ($scope.servicoSelecionada != null) {
                                    objSelecionado = _.find($scope.servicos, function (el) {
                                        return el.CampoId == $scope.servicoSelecionada
                                    })
                                }
                                if (objSelecionado == null) {
                                    objSelecionado = data[0];
                                }
                                $scope.selecionarServico(null, objSelecionado);
                            }
                            //unblockUI($('#servicos-container'));
                        }
                    });
                }

                $scope.selecionarServico = function ($event, servico) {
                    $scope.abaSelecionada = true;
                    if ($event != null)
                        $event.stopPropagation();

                    //    if ($event == null || $event.target.type != 'radio')                    
                    if (servico.CampoId != null)
                        $scope.servicoSelecionada = servico.CampoId;
                    else 
                        $scope.servicoSelecionada = servico;

                    $scope.notificarFiltro();
                }

                $scope.notificarFiltro = function () {                    
                    if ($scope.abaSelecionada) {
                        $scope.filtro.tipo = 2;
                        $scope.filtro.servico = $scope.servicoSelecionada;
                        $rootScope.$broadcast('onServicoSelecionado', $scope.filtro);
                    }
                }

                $scope.dataSelecionada = function ($event, dados) {
                    if (dados.scope == 'servico' || dados.scope === undefined) {
                        $scope.abaSelecionada = (dados.show == 'servico')
                        //blockUI($('#servicos-container'));
                        $scope.filtro.dataInicio = dados.dataInicio;
                        $scope.filtro.dataFim = dados.dataFim;
                        $scope.filtro.carteiraId = dados.carteiraId;
                        $scope.filtro.operacaoId = dados.operacaoId;
                        $scope.filtro.grupoId = dados.grupoId;
                        $scope.GetServicos();
                    }
                }

                $scope.eventListener = $scope.$on('onDataSelecionada', $scope.dataSelecionada);

                if ($scope.inicializado == false) {
                    $scope.inicializado = true;
                    let filtroCache = DashReceptivoStorage.getFiltro();

                    if (filtroCache != null) {
                        $scope.servicoSelecionada = filtroCache.servico;
                    } else {
                        $scope.servicoSelecionada = null;
                    }
                }

                $scope.servicoLimpo = function () {
                    $scope.servicoSelecionada = null;
                    $scope.abaSelecionada = false;
                }

                $scope.$on('onServicoLimpo', $scope.servicoLimpo);

                $timeout(function () {
                    $rootScope.$broadcast('onAbaPronto', 'servico')
                });

                $scope.GetFavorito = function (servico) {
                    return servico.Dados.filter(function (value) {
                        return (value.Favorito == true);
                    });
                }

                $scope.configurarServicoId = null;
                $scope.showConfigNvs = function (servicoId) {
                    $scope.$emit('showConfigNvs', { id: servicoId, tipo: 2 });
                }

                $scope.onAbaSelecionada = function (event, tipo) {                    
                    if (tipo == 'servico') {
                        let servico = {}
                        if ($scope.filtro.servico == null) {
                            if ($scope.servicos.length > 0) {
                                servico.CampoId = $scope.servicos[0].CampoId;
                                $scope.selecionarServico(null, servico);
                            }
                        } else                            
                            $scope.selecionarServico(null, $scope.filtro.servico);

                    } else {
                        $scope.servicoLimpo();
                    }
                }
                const offAbaSelecionada = $rootScope.$on('onAbaSelecionada', $scope.onAbaSelecionada);
                $scope.$on('$destroy', function () {
                    offAbaSelecionada();
                });
            }],
            templateUrl: '../app_dash/pages/dashReceptivo/ura/servico.html'
        };
    });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp').directive('ura', function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                pesquisa: '='
            },
            controller: ["$scope", "$timeout", "$locale", "$rootScope", "DashboardReceptivoService", "DashReceptivoStorage", function UraController($scope, $timeout, $locale, $rootScope, DashboardReceptivoService, DashReceptivoStorage) {
                $locale.NUMBER_FORMATS.GROUP_SEP = " ";
                $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";

                $scope.uras = [];
                $scope.uraSelecionada = [];
                $scope.inicializado = false;
                $scope.abaSelecionada = false;
                $scope.filtro = {
                    ura: null,
                    tipo: 1,
                    dataFim: new Date(),
                    dataInicio: new Date(),
                    carteiraId: null,
                    grupoId: 0
                };

                $scope.requestId = 0;
                $scope.GetUra = function () {
                    $scope.requestId++;
                    let requestAtual = $scope.requestId;
                    $scope.filtro.dataInicio = moment($scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                    $scope.filtro.dataFim = moment($scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                    DashboardReceptivoService.getUra($scope.filtro.tipo, $scope.filtro.dataInicio, $scope.filtro.dataFim, $scope.filtro.carteiraId, $scope.filtro.grupoId).then(function (data) {
                        if (requestAtual == $scope.requestId) {
                            $scope.uras = data;
                            $rootScope.$broadcast('onEsconderAbaUra', $scope.uras == null || $scope.uras.length == 0);
                            $scope.uras.forEach(function (element) {
                                element.Nome = element.Dados[0].Nome;
                            });
                            if ($scope.abaSelecionada) {
                                let uraObjSelecionado = null;
                                if ($scope.uraSelecionada != null) {
                                    uraObjSelecionado = _.find($scope.uras, function (el) {
                                        return el.CampoId == $scope.uraSelecionada
                                    })
                                }
                                if (uraObjSelecionado == null) {
                                    uraObjSelecionado = data[0];
                                }
                                if (uraObjSelecionado != null) {
                                    $scope.selecionarUra(null, uraObjSelecionado);
                                }
                            }

                            //unblockUI($('#uras-container'));
                        }
                    });
                }

                $scope.updateUra = function () {
                    DashboardReceptivoService.getUra($scope.filtro.tipo, $scope.filtro.dataInicio, $scope.filtro.dataFim, $scope.filtro.carteiraId, $scope.filtro.grupoId).then(function (data) {
                        $scope.uras = data;
                        $scope.uras.forEach(function (element) {
                            element.Nome = element.Dados[0].Nome;
                        });
                        if ($scope.abaSelecionada) {
                            let uraObjSelecionado = null;
                            if ($scope.uraSelecionada != null) {
                                uraObjSelecionado = _.find($scope.uras, function (el) {
                                    return el.CampoId == $scope.uraSelecionada
                                })
                            }
                            if (uraObjSelecionado == null) {
                                uraObjSelecionado = data[0];
                            }
                        }
                    });
                }

                $scope.selecionarUra = function ($event, ura) {
                    $scope.abaSelecionada = true;
                    if ($event != null)
                        $event.stopPropagation();

                    if (ura) {
                        $scope.uraSelecionada = ura.CampoId;
                        $scope.updateUra();
                        $scope.notificarFiltro();
                    }
                }

                $scope.notificarFiltro = function () {
                    if ($scope.abaSelecionada) {
                        $scope.filtro.tipo = 1;
                        $scope.filtro.ura = $scope.uraSelecionada;
                        $rootScope.$broadcast('onUraSelecionado', $scope.filtro);
                    }
                }

                $scope.dataSelecionada = function ($event, dados) {
                    if (dados.scope == 'ura' || dados.scope === undefined) {
                        $scope.abaSelecionada = (dados.show == 'ura');
                        //blockUI($('#uras-container'));
                        $scope.filtro.dataInicio = dados.dataInicio;
                        $scope.filtro.dataFim = dados.dataFim;
                        $scope.filtro.carteiraId = dados.carteiraId;
                        $scope.filtro.grupoId = dados.grupoId;
                        $scope.GetUra();
                    }
                }

                $scope.eventListener = $scope.$on('onDataSelecionada', $scope.dataSelecionada);

                if ($scope.inicializado == false) {
                    $scope.inicializado = true;
                    let filtroCache = DashReceptivoStorage.getFiltro();
                    if (filtroCache != null) {
                        $scope.uraSelecionada = filtroCache.ura;
                    } else {
                        $scope.uraSelecionada = null;
                    }
                }

                $scope.uraLimpo = function () {
                    $scope.uraSelecionada = null;
                    $scope.abaSelecionada = false;
                }
                $scope.$on('onUraLimpo', $scope.uraLimpo);

                $timeout(function () {
                    $rootScope.$broadcast('onAbaPronto', 'ura')
                });

                $scope.GetFavorito = function (ura) {
                    return ura.Dados.filter(function (value) {
                        return (value.Favorito == true);
                    });
                }

                $scope.configurarUraId = null;
                $scope.showConfigNvs = function (uraId) {
                    $scope.$emit('showConfigNvs', { id: uraId, tipo: 1 });
                }

                $scope.onAbaSelecionada = function (event, tipo) {
                    if (tipo == 'ura') {
                        $scope.selecionarUra(null, $scope.uras[0]);
                    } else {
                        $scope.uraLimpo();
                    }
                }
                const offAbaSelecionada = $rootScope.$on('onAbaSelecionada', $scope.onAbaSelecionada);
                $scope.$on('$destroy', function () {
                    offAbaSelecionada();
                });
            }],
            templateUrl: '../app_dash/pages/dashReceptivo/ura/ura.html'
        };
    });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('dados', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ["$scope", "DashSupervisaoVisao", function DadosController($scope, DashSupervisaoVisao) {

                    let dadosFila = {};

                    // Na visao de Grupos as linhas sao grupos; ajusta o rotulo da 1a coluna.
                    // Referencia estavel -> reage ao toggle sem precisar de evento.
                    $scope.visaoState = DashSupervisaoVisao.state;

                    $scope.servicos = [];

                    $scope.getServicos = function ($event, dados) {
                        $scope.servicos = dados;
                    }

                    $scope.$on('onSelecionarServico', $scope.getServicos);

                    $scope.formatSeconds = function(seconds) {
                        let date = new Date(1970, 0, 1);
                        date.setSeconds(seconds);
                        return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
                    }

                    // A fila vem chaveada por GrupoId na visao de grupo (o numero da linha
                    // e o ramal do grupo, nao casa com a fila) e por Numero/ServicoNumero na
                    // visao de servico. Recebe a linha (servico ou grupo) e escolhe a chave.
                    function chaveFila(linha){
                        return DashSupervisaoVisao.isGrupo() ? linha.GrupoId : linha.Numero;
                    }

                    $scope.listarLigacoesEmFila = function(linha){
                        const fila = dadosFila[chaveFila(linha)];
                        if (fila === undefined){
                            return [];
                        }

                        return fila;
                     };

                    $scope.listarLigacoesEmFilaQtd = function(linha){
                        const fila = dadosFila[chaveFila(linha)];
                        if (fila === undefined){
                            return 0;
                        }

                        return fila.length;
                     };

                    $scope.$on('onDashSupervisaoFila', function(event,data){
                         dadosFila = data;
                     });

                }],
                templateUrl: '../app_dash/pages/dashSupervisao/dados/dados.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .filter('secondsToDateTime', [function () {
            return function (seconds) {
                if (Number.isNaN(seconds)) return "00:00:00";
                return new Date(1970, 0, 1).setSeconds(seconds);
            };
        }])
        .directive('geral', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                controller: ['$scope', '$rootScope', 'DashboardSupervisaoService', 'DashSupervisaoStorage', 'DashSupervisaoVisao',
                function IndicadoresController($scope, $rootScope, DashboardSupervisaoService, DashSupervisaoStorage, DashSupervisaoVisao) {
                    // Polling a cada 15s (antes era 5s — agressivo demais para algo que
                    // muda em escala de segundos no backend mas nao a cada segundo).
                    const TEMPO_POLLING_FILA = 15000;

                    $scope.geral = {};
                    $scope.totalFila = 0;
                    $scope.ramaisDetalhados = [];
                    $scope.ramaisDetalhadosFilter = [];
                    $scope.qtdPaginas = [];
                    $scope.qtdElementosMax = 10;
                    $scope.paginaAtual = 0;
                    $scope.showStatusRamal = false;
                    $scope.carteiraId = 0;
                    $scope.operacaoId = 0;
                    $scope.servicosIds = "";
                    $scope.gruposIds = "";
                    $scope.loadingGeral = false;
                    $scope.loadingDetalhe = false;

                    // Polling com handle unico — antes registrava um listener $destroy
                    // a cada tick, vazando 720 listeners/hora.
                    let timerFila = null;

                    function getDadosGeral($event, filtro) {
                        const carteiraId = filtro.carteiraId;
                        const operacaoId = filtro.operacaoId;
                        const servicosIds = filtro.servicosIds;
                        const gruposIds = filtro.gruposIds || "";
                        $scope.servicosIds = servicosIds;
                        $scope.gruposIds = gruposIds;

                        $scope.loadingGeral = true;
                        DashboardSupervisaoService.getGeral(servicosIds, carteiraId, operacaoId, gruposIds)
                            .then(data => { $scope.geral = data || {}; })
                            .catch(() => { /* mantem dados anteriores */ })
                            .finally(() => { $scope.loadingGeral = false; });
                    }

                    function getFila() {
                        // Na visao de GRUPOS a fila vai filtrada por gruposIds (parametro proprio);
                        // o campo "servicos" vai VAZIO (nunca numero de grupo). A API continua
                        // sendo chamada normalmente.
                        const ehGrupo = DashSupervisaoVisao.get() === 'grupo';

                        // Prioridade: numeros explicitamente selecionados → senao todos da carteira
                        const selecionados = DashSupervisaoStorage.getNumerosSelecionados();
                        const carteira = DashSupervisaoStorage.getNumerosCarteira();
                        const filtro = ehGrupo ? '' : (selecionados.length > 0 ? selecionados : carteira).join(',');

                        // Sem visao de grupos, sem numeros de servico = nada a consultar.
                        if (!ehGrupo && !filtro) {
                            agendarProximoTickFila();
                            return;
                        }

                        DashboardSupervisaoService.getQuantidadeFilaServico(filtro, $scope.carteiraId, $scope.operacaoId, $scope.gruposIds).$promise
                            .then(data => {
                                let totalFila = 0;
                                _.each(data && data.Ligacoes, function (item) {
                                    totalFila += item.length;
                                });
                                $scope.totalFila = totalFila;
                                $rootScope.$broadcast("onDashSupervisaoFila", (data && data.Ligacoes) || {});
                            })
                            .catch(() => { /* mantem totalFila anterior */ })
                            // Reagenda SEMPRE — antes, um erro quebrava a cadeia recursiva
                            // e o contador de fila congelava ate o usuario recarregar.
                            .finally(() => { agendarProximoTickFila(); });
                    }

                    function agendarProximoTickFila() {
                        if (timerFila != null) clearTimeout(timerFila);
                        timerFila = setTimeout(getFila, TEMPO_POLLING_FILA);
                    }

                    function getRamalDetalhe(statusSupervisao, carteiraId, operacaoId, servicosId, gruposIds) {
                        $scope.loadingDetalhe = true;
                        DashboardSupervisaoService.getSupervisaoRamalDetalhe(statusSupervisao, carteiraId, operacaoId, servicosId, gruposIds).$promise
                            .then(data => {
                                $scope.ramaisDetalhados = data || [];
                                AtualizarQtdPaginas();
                                $scope.paginaRamaisFilter(1);
                            })
                            .catch(() => { $scope.ramaisDetalhados = []; })
                            .finally(() => { $scope.loadingDetalhe = false; });
                    }

                    $scope.paginaRamaisFilter = function paginaRamaisFilter(pagina) {
                        $scope.ramaisDetalhadosFilter = [];
                        $scope.paginaAtual = pagina;
                        $scope.ramaisPaginados = [];

                        const ultimoElemento = pagina * $scope.qtdElementosMax;
                        const primeiroElemento = ultimoElemento - $scope.qtdElementosMax;
                        const ramaisTotal = $scope.ramaisDetalhados.length;

                        if (ramaisTotal >= 10) {
                            for (let index = primeiroElemento; index < ultimoElemento; index++) {
                                const ramal = $scope.ramaisDetalhados[index];
                                if (ramal != null) {
                                    $scope.ramaisDetalhadosFilter.push(ramal);
                                }
                            }
                        } else {
                            $scope.ramaisDetalhadosFilter = $scope.ramaisDetalhados;
                        }
                    }

                    function AtualizarQtdPaginas() {
                        $scope.qtdPaginas = [];
                        const qtdRamais = $scope.ramaisDetalhados.length;
                        const qtdPaginas = Math.ceil(qtdRamais / $scope.qtdElementosMax);

                        for (let index = 1; index <= qtdPaginas; index++) {
                            $scope.qtdPaginas.push({ id: index });
                        }
                    }

                    $scope.showDetalheRamal = function (status) {
                        $scope.showStatusRamal = status == 'RamaisEmPausa';
                        $scope.statusSupervisao = status;
                        getRamalDetalhe($scope.statusSupervisao, $scope.carteiraId, $scope.operacaoId, $scope.servicosIds, $scope.gruposIds);

                        const modal = UIkit.modal("#modal-ramal");
                        if (!modal.isActive()) {
                            modal.show();
                        }
                    }

                    $scope.selecionarCarteira = function (event, carteiraId) {
                        $scope.carteiraId = carteiraId;
                        // Troca de carteira zera o filtro de grupos (a toolbar tambem reseta).
                        $scope.gruposIds = "";
                    }

                    $scope.selecionarOperacao = function (event, operacaoId) {
                        $scope.operacaoId = operacaoId;
                    }

                    $scope.selecionarGrupo = function (event, gruposIds) {
                        $scope.gruposIds = gruposIds || "";
                    }

                    // Listeners — guardar refs para cleanup no $destroy
                    $scope.eventListener = $scope.$on('onSelecionarServicoGeral', getDadosGeral);
                    const offCarteira = $rootScope.$on('onCarteiraSelecionada', $scope.selecionarCarteira);
                    const offOperacao = $rootScope.$on('onOperacaoSelecionada', $scope.selecionarOperacao);
                    const offGrupo = $rootScope.$on('onGrupoSelecionada', $scope.selecionarGrupo);

                    $scope.$on('$destroy', function () {
                        offCarteira();
                        offOperacao();
                        offGrupo();
                        if (timerFila != null) {
                            clearTimeout(timerFila);
                            timerFila = null;
                        }
                    });

                    getFila();
                }],
                templateUrl: '../app_dash/pages/dashSupervisao/geral/geral.html'
            };
        });
})();

(function () {
    "use strict";

    // Engine de dados do modo EPS (sem UI visivel). Substitui o papel de "bomba de
    // dados" que o painel lateral <supervisao-servico> exerce fora do EPS: como naquele
    // modo o painel lateral e removido, esta directive assume a busca por GRUPO e emite
    // os MESMOS eventos que <dados> e <geral> ja escutam, sem alterar essas directives.
    //   - onSelecionarServico       -> alimenta a tabela <dados> (linhas = grupos)
    //   - onSelecionarServicoGeral  -> faz <geral> buscar o painel agregado (getGeral)
    // Os campos do DTO de grupo (Descricao, Numero, EmFila, TME, SLA, Niveis*, Chamadas*,
    // TempoAtendimentoMedio, RamaisDisponiveis...) espelham os de servico, entao a tabela
    // renderiza sem mudancas.
    angular.module('epbxManagerApp').directive('supervisaoGrupo', function () {
        return {
            restrict: 'E',
            scope: {},
            controller: ["$scope", "$rootScope", "$interval", "DashboardSupervisaoService", "DashSupervisaoFiltro", function SupervisaoGrupoController($scope, $rootScope, $interval,
                DashboardSupervisaoService, DashSupervisaoFiltro) {

                // Inicia com os filtros atuais da toolbar (snapshot), para o caso de o
                // engine montar tardiamente ao alternar a visao servico -> grupo.
                const filtroAtual = DashSupervisaoFiltro.get();
                $scope.carteiraId = filtroAtual.carteiraId;
                $scope.operacaoId = filtroAtual.operacaoId;
                $scope.gruposIds = filtroAtual.gruposIds;
                $scope.intervalOnline = null;

                const TEMPO_POLLING_INDICADORES = 15000;

                // Busca os grupos e propaga para tabela (<dados>) e painel (<geral>).
                $scope.GetGrupos = function () {
                    const carteiraId = $scope.carteiraId;
                    const operacaoId = $scope.operacaoId;
                    const gruposIds = $scope.gruposIds;

                    // <geral> precisa do filtro atual para buscar getGeral (sem servicos no EPS).
                    $rootScope.$broadcast('onSelecionarServicoGeral', {
                        servicosIds: "",
                        carteiraId: carteiraId,
                        operacaoId: operacaoId,
                        gruposIds: gruposIds
                    });

                    console.log('[supervisaoGrupo] GetGrupos →', { carteiraId, operacaoId, gruposIds });
                    DashboardSupervisaoService.getGrupos(carteiraId, operacaoId, gruposIds)
                        .then((grupoData) => {
                            const lista = grupoData || [];
                            console.log('[supervisaoGrupo] GetGrupos OK, qtd =', lista.length, lista);

                            // NAO populamos DashSupervisaoStorage com Numeros aqui: senao o
                            // <geral>.getFila repassaria numero de GRUPO no parametro "servicos"
                            // de QuantidadeFilaPorServico, o que e incorreto. Sem isso, na visao
                            // de grupos o storage de servico fica vazio e a fila por servico nao
                            // recebe numeros de grupo.
                            $rootScope.$broadcast('onSelecionarServico', lista);
                        })
                        .catch((err) => {
                            console.error('[supervisaoGrupo] GetGrupos ERRO:', err);
                        });
                }

                $scope.carteiraSelecionada = function (event, carteira) {
                    $scope.carteiraId = carteira;
                    // Troca de carteira zera o filtro de grupos (a toolbar tambem reseta).
                    $scope.gruposIds = "";
                    $scope.GetGrupos();
                }

                $scope.operacaoSelecionada = function (event, operacao) {
                    $scope.operacaoId = operacao;
                    $scope.GetGrupos();
                }

                $scope.grupoSelecionado = function (event, gruposIds) {
                    $scope.gruposIds = gruposIds || "";
                    $scope.GetGrupos();
                }

                $scope.tornarOnline = function () {
                    if ($scope.intervalOnline != null) {
                        $interval.cancel($scope.intervalOnline);
                    }
                    $scope.intervalOnline = $interval($scope.GetGrupos, TEMPO_POLLING_INDICADORES);
                }

                // Listeners — guardar refs para cleanup no $destroy
                const offCarteira = $rootScope.$on('onCarteiraSelecionada', $scope.carteiraSelecionada);
                const offOperacao = $rootScope.$on('onOperacaoSelecionada', $scope.operacaoSelecionada);
                const offGrupo = $rootScope.$on('onGrupoSelecionada', $scope.grupoSelecionado);

                $scope.$on('$destroy', function supervisaoGrupoControllerDestroy() {
                    offCarteira();
                    offOperacao();
                    offGrupo();
                    if ($scope.intervalOnline != null) {
                        $interval.cancel($scope.intervalOnline);
                        $scope.intervalOnline = null;
                    }
                });

                $scope.GetGrupos();
                $scope.tornarOnline();
            }],
            template: ''
        };
    });
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp').directive('supervisaoServico', function () {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                pesquisa: '='
            },
            controller: ["$scope", "$rootScope", "$interval", "DashboardReceptivoService", "DashboardSupervisaoService", "DashSupervisaoStorage", "DashSupervisaoFiltro", function SupervisaoServicoController($scope, $rootScope, $interval,
                DashboardReceptivoService, DashboardSupervisaoService, DashSupervisaoStorage, DashSupervisaoFiltro) {

                // Polling agora separa cadastro (raro) de indicadores (frequente).
                // Antes, a cada 5s recarregava lista de servicos do cadastro + indicadores —
                // desperdicio porque cadastro nao muda em segundos.
                const TEMPO_POLLING_INDICADORES = 15000;

                // Inicia com os filtros atuais da toolbar (snapshot), para o caso de o
                // engine montar tardiamente ao alternar a visao grupo -> servico.
                const filtroAtual = DashSupervisaoFiltro.get();

                $scope.total = {};
                $scope.servicos = [];
                $scope.servicosSelecionados = [];
                $scope.intervalOnline = null;
                $scope.numeroServicosSelecionados = [];
                $scope.carteiraId = filtroAtual.carteiraId;
                $scope.operacaoId = filtroAtual.operacaoId;
                $scope.gruposIds = filtroAtual.gruposIds;
                $scope.loading = false;

                function guardarServicosSelecionados() {
                    DashSupervisaoStorage.setSelecionados($scope.servicosSelecionados, $scope.numeroServicosSelecionados);
                }

                $scope.GetServicos = function (servicosIds, carteiraId, operacaoId) {
                    const gruposIds = $scope.gruposIds;
                    $rootScope.$broadcast('onSelecionarServicoGeral', {
                        servicosIds: servicosIds,
                        carteiraId: carteiraId,
                        operacaoId: operacaoId,
                        gruposIds: gruposIds
                    });
                    DashboardSupervisaoService.getServicos(servicosIds, carteiraId, operacaoId, gruposIds)
                        .then((servicoData) => {
                            mesclarServicos(servicoData || []);
                            $rootScope.$broadcast('onSelecionarServico', servicoData);
                        })
                        .catch(() => { /* mantem dados anteriores */ });
                }

                // Atualiza Dados (indicadores) dos servicos existentes sem reatribuir a lista.
                // A lista do cadastro vem do getUra em GetServicosInicial e nao deve ser
                // descartada aqui: getServicos pode retornar menos itens (ou vazio quando
                // servicosSelecionados=="") e a versao anterior fazia $scope.servicos = merged,
                // zerando a tela apos o primeiro polling. Agora so atualizamos in-place.
                function mesclarServicos(novosDados) {
                    if (!Array.isArray(novosDados)) novosDados = [];

                    const idsSelecionados = DashSupervisaoStorage.getIdsSelecionados();

                    // Indexa novos por CampoId
                    const novosPorId = {};
                    novosDados.forEach(novo => {
                        if (novo.Dados != undefined) {
                            novo.Nome = novo.Dados[0].Nome;
                        }
                        novosPorId[novo.CampoId] = novo;
                    });

                    // Atualiza in-place os existentes (preserva referencias do ng-repeat)
                    const existentesPorId = {};
                    $scope.servicos.forEach(s => {
                        existentesPorId[s.CampoId] = true;
                        const novo = novosPorId[s.CampoId];
                        if (novo) {
                            s.Dados = novo.Dados;
                            s.Nome = novo.Nome;
                        }
                        if (s.checked == null) {
                            s.checked = idsSelecionados.indexOf(s.CampoId) !== -1;
                        }
                    });

                    // Adiciona novos que ainda nao estavam na lista (caso raro)
                    novosDados.forEach(novo => {
                        if (!existentesPorId[novo.CampoId]) {
                            novo.checked = idsSelecionados.indexOf(novo.CampoId) !== -1;
                            $scope.servicos.push(novo);
                        }
                    });
                }

                $scope.selecionarServico = function (servico) {
                    servico.checked = !servico.checked;
                    if (servico.checked) {
                        $scope.servicosSelecionados.push(servico.CampoId);
                        $scope.numeroServicosSelecionados.push(servico.Numero);
                    } else {
                        $scope.servicosSelecionados = _.filter($scope.servicosSelecionados, item => item != servico.CampoId);
                        $scope.numeroServicosSelecionados = _.filter($scope.numeroServicosSelecionados, item => item != servico.Numero);
                    }
                    guardarServicosSelecionados();
                    $scope.GetServicos($scope.servicosSelecionados.join(), $scope.carteiraId, $scope.operacaoId);
                }

                $scope.carteiraSelecionada = function (event, carteira) {
                    $scope.servicosSelecionados = [];
                    $scope.numeroServicosSelecionados = [];
                    DashSupervisaoStorage.limparSelecionados();
                    // Troca de carteira zera o filtro de grupos (a toolbar tambem reseta).
                    $scope.gruposIds = "";
                    $scope.carteiraId = carteira;
                    $scope.GetServicosInicial($scope.carteiraId, $scope.operacaoId);
                }

                $scope.grupoSelecionado = function (event, gruposIds) {
                    $scope.gruposIds = gruposIds || "";
                    // Recarrega os indicadores dos servicos com o novo filtro de grupos.
                    $scope.GetServicos($scope.servicosSelecionados.join(), $scope.carteiraId, $scope.operacaoId);
                }

                $scope.operacaoSelecionada = function (event, operacao) {
                    $scope.servicosSelecionados = [];
                    $scope.numeroServicosSelecionados = [];
                    DashSupervisaoStorage.limparSelecionados();
                    $scope.operacaoId = operacao;
                    $scope.GetServicosInicial($scope.carteiraId, $scope.operacaoId);
                }

                $scope.limparSelecao = function () {
                    $scope.servicosSelecionados = [];
                    $scope.numeroServicosSelecionados = [];
                    DashSupervisaoStorage.limparSelecionados();
                    $scope.GetServicosInicial($scope.carteiraId, $scope.operacaoId);
                }

                // Carrega lista de servicos do cadastro (getUra) UMA VEZ aqui — o polling
                // continuo so atualiza indicadores (getServicos) via RefreshIndicadores.
                $scope.GetServicosInicial = function (carteira, operacao) {
                    const dataInicial = moment(new Date()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss');
                    const dataTermino = moment(new Date()).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss');

                    $scope.loading = true;
                    DashboardReceptivoService.getUra(2, dataInicial, dataTermino, carteira)
                        .then(function (data) {
                            const idsSelecionados = DashSupervisaoStorage.getIdsSelecionados();
                            $scope.servicosSelecionados = idsSelecionados;

                            const lista = data || [];
                            lista.forEach(function (element) {
                                if (element.Dados != undefined) {
                                    element.Nome = element.Dados[0].Nome;
                                }
                                element.checked = idsSelecionados.indexOf(element.CampoId) !== -1;
                            });
                            $scope.servicos = lista;

                            // Indexa todos os numeros da carteira atual (usado pelo getFila quando
                            // nao ha selecao explicita do usuario).
                            const numerosCarteira = lista.map(elem => elem.Numero);
                            DashSupervisaoStorage.setNumerosCarteira(numerosCarteira);

                            // Carrega indicadores para a selecao atual
                            $scope.GetServicos($scope.servicosSelecionados.join(), carteira, operacao);
                        })
                        .catch(() => { /* mantem lista anterior */ })
                        .finally(() => { $scope.loading = false; });
                }

                // Refresh apenas dos indicadores (chamado pelo polling).
                // Antes, o polling re-executava GetServicosInicial → getUra + getServicos.
                // Agora so atualiza indicadores via getServicos.
                $scope.RefreshIndicadores = function () {
                    $scope.GetServicos($scope.servicosSelecionados.join(), $scope.carteiraId, $scope.operacaoId);
                }

                $scope.GetFavorito = function (servico) {
                    if (servico.Dados != undefined) {
                        return servico.Dados.filter(value => value.Favorito == true);
                    }
                    return [];
                }

                $scope.tornarOnline = function () {
                    if ($scope.intervalOnline != null) {
                        $interval.cancel($scope.intervalOnline);
                    }
                    $scope.intervalOnline = $interval($scope.RefreshIndicadores, TEMPO_POLLING_INDICADORES);
                }

                // Listeners — guardar refs para cleanup no $destroy
                const offLimpar = $rootScope.$on("limparServicos", function () {
                    $scope.limparSelecao();
                });
                const offCarteira = $rootScope.$on('onCarteiraSelecionada', $scope.carteiraSelecionada);
                const offOperacao = $rootScope.$on('onOperacaoSelecionada', $scope.operacaoSelecionada);
                const offGrupo = $rootScope.$on('onGrupoSelecionada', $scope.grupoSelecionado);

                $scope.$on('$destroy', function supervisaoServicoControllerDestroy() {
                    offLimpar();
                    offCarteira();
                    offOperacao();
                    offGrupo();
                    if ($scope.intervalOnline != null) {
                        $interval.cancel($scope.intervalOnline);
                        $scope.intervalOnline = null;
                    }
                });

                $scope.GetServicosInicial($scope.carteiraId, $scope.operacaoId);
                $scope.tornarOnline();
            }],
            templateUrl: '../app_dash/pages/dashSupervisao/servico/supervisao-servico.html'
        };
    });
})();

angular.module('epbxManagerApp')
    .service('DashboardTalkbotFluxoService', ["DashboardTalkbotResource", function (DashboardTalkbotResource) {
        var service = {};

        service.getFluxos = function () {
            return DashboardTalkbotResource.getFluxos().$promise;
        };

        service.getCompleto = function (servicosIds, campanhasIds, dataInicio, dataFim, carteiraId, gruposIds) {
            return DashboardTalkbotResource.getFluxoCompleto({
                servicosIds: servicosIds, campanhasIds: campanhasIds,
                dataInicio: dataInicio, dataFim: dataFim,
                carteiraId: carteiraId || 0, gruposIds: gruposIds || ''
            }).$promise;
        };

        service.getOutHorario = function (servicosIds, campanhasIds, dataInicio, dataFim, carteiraId, gruposIds) {
            return DashboardTalkbotResource.getFluxoOutHorario({
                servicosIds: servicosIds, campanhasIds: campanhasIds,
                dataInicio: dataInicio, dataFim: dataFim,
                carteiraId: carteiraId || 0, gruposIds: gruposIds || ''
            }).$promise;
        };

        service.getIndicadores = function (servicosIds, campanhasIds, dataInicio, dataFim, carteiraId, gruposIds) {
            return DashboardTalkbotResource.getFluxoIndicadores({
                servicosIds: servicosIds, campanhasIds: campanhasIds,
                dataInicio: dataInicio, dataFim: dataFim,
                carteiraId: carteiraId || 0, gruposIds: gruposIds || ''
            }).$promise;
        };

        service.getIndicadoresCampanha = function (servicosIds, campanhasIds, dataInicio, dataFim, carteiraId, gruposIds) {
            return DashboardTalkbotResource.getFluxoIndicadoresCampanha({
                servicosIds: servicosIds, campanhasIds: campanhasIds,
                dataInicio: dataInicio, dataFim: dataFim,
                carteiraId: carteiraId || 0, gruposIds: gruposIds || ''
            }).$promise;
        };

        service.getTotais = function (servicosIds, campanhasIds, dataInicio, dataFim, carteiraId, gruposIds) {
            return DashboardTalkbotResource.getFluxoTotais({
                servicosIds: servicosIds, campanhasIds: campanhasIds,
                dataInicio: dataInicio, dataFim: dataFim,
                carteiraId: carteiraId || 0, gruposIds: gruposIds || ''
            }).$promise;
        };

        service.getCampanhas = function (carteirasIds, servicosIds, dataInicio, dataFim, gruposIds) {
            return DashboardTalkbotResource.getFluxoCampanhas({
                carteirasIds: carteirasIds, servicosIds: servicosIds,
                dataInicio: dataInicio, dataFim: dataFim,
                gruposIds: gruposIds || ''
            }).$promise;
        };

        return service;
    }]);

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('talkbotFluxo', function () {
            return {
                restrict: 'E',
                scope: {},
                controller: ['$scope', '$rootScope', 'DashboardTalkbotFluxoService', 'DashboardTalkbotService',
                function TalkbotFluxoController($scope, $rootScope, FluxoService, TalkbotService) {

                    $scope.dataInicio = moment().startOf('day').toDate();
                    $scope.dataFim = moment().endOf('day').toDate();
                    $scope.loading = false;

                    $scope.fluxos = [];
                    $scope.indicadores = [];
                    $scope.indicadoresCampanha = [];
                    $scope.totais = {};
                    $scope.fluxoCompleto = [];
                    $scope.servicos = [];
                    $scope.campanhas = [];

                    $scope.servicosIds = '';
                    $scope.campanhasIds = '';
                    $scope.carteiraId = 0;
                    $scope.gruposIds = '';
                    $scope.selecionarTodos = false;
                    $scope.selecionarTodasCampanhas = false;
                    $scope.tabSidebar = 'servicos';
                    $scope.fluxoComparativoTab = '';
                    $scope.comparativoGrupos = [];

                    function carregarFluxos() {
                        FluxoService.getFluxos().then(function (data) {
                            $scope.fluxos = data || [];
                        });
                    }

                    function carregarServicos() {
                        TalkbotService.getServicos('', $scope.carteiraId, $scope.gruposIds)
                            .then(function (data) {
                                $scope.servicos = data || [];
                            });
                    }

                    function carregarCampanhas() {
                        var carteirasParam = $scope.carteiraId ? String($scope.carteiraId) : '';
                        FluxoService.getCampanhas(carteirasParam, $scope.servicosIds, $scope.dataInicio, $scope.dataFim, $scope.gruposIds)
                            .then(function (data) {
                                $scope.campanhas = data || [];
                            });
                    }

                    function carregarDados() {
                        $scope.loading = true;
                        var di = $scope.dataInicio;
                        var df = $scope.dataFim;
                        var si = $scope.servicosIds;
                        var ci = $scope.campanhasIds;

                        var cId = $scope.carteiraId;
                        var gi = $scope.gruposIds;

                        var promises = [
                            FluxoService.getIndicadores(si, ci, di, df, cId, gi).then(function (d) { $scope.indicadores = d || []; }),
                            FluxoService.getIndicadoresCampanha(si, ci, di, df, cId, gi).then(function (d) { $scope.indicadoresCampanha = d || []; }),
                            FluxoService.getTotais(si, ci, di, df, cId, gi).then(function (d) {
                                $scope.totais = (d && d.length > 0) ? d[0] : {};
                            }),
                            FluxoService.getCompleto(si, ci, di, df, cId, gi).then(function (d) {
                                $scope.fluxoCompleto = d || [];
                                agruparComparativo();
                            })
                        ];

                        Promise.all(promises)
                            .catch(function () { })
                            .then(function () {
                                $scope.loading = false;
                                $scope.$applyAsync();
                            });
                    }

                    function agruparComparativo() {
                        var grupos = {};
                        ($scope.fluxoCompleto || []).forEach(function (item) {
                            var key = item.Fluxo;
                            if (item.FluxoOut) key += ' - ' + item.FluxoOut;
                            if (!grupos[key]) {
                                grupos[key] = { nome: key, cor: item.FluxoCor, items: [] };
                            }
                            grupos[key].items.push(item);
                        });
                        $scope.comparativoGrupos = Object.keys(grupos).map(function (k) { return grupos[k]; });
                        if ($scope.comparativoGrupos.length > 0 && !$scope.fluxoComparativoTab) {
                            $scope.fluxoComparativoTab = $scope.comparativoGrupos[0].nome;
                        }
                        $scope.paginaAtual = 1;
                    }

                    $scope.paginaAtual = 1;
                    $scope.itensPorPagina = 15;

                    $scope.selecionarComparativoTab = function (nome) {
                        $scope.fluxoComparativoTab = nome;
                        $scope.paginaAtual = 1;
                    };

                    $scope.getComparativoAtivo = function () {
                        if (!$scope.comparativoGrupos) return [];
                        var grupo = $scope.comparativoGrupos.filter(function (g) { return g.nome === $scope.fluxoComparativoTab; })[0];
                        return grupo ? grupo.items : [];
                    };

                    $scope.getComparativoPaginado = function () {
                        var todos = $scope.getComparativoAtivo();
                        var inicio = ($scope.paginaAtual - 1) * $scope.itensPorPagina;
                        return todos.slice(inicio, inicio + $scope.itensPorPagina);
                    };

                    $scope.getTotalPaginas = function () {
                        var total = $scope.getComparativoAtivo().length;
                        return Math.ceil(total / $scope.itensPorPagina) || 1;
                    };

                    $scope.getPaginas = function () {
                        var total = $scope.getTotalPaginas();
                        var paginas = [];
                        for (var i = 1; i <= total; i++) { paginas.push(i); }
                        return paginas;
                    };

                    $scope.irParaPagina = function (p) {
                        if (p >= 1 && p <= $scope.getTotalPaginas()) {
                            $scope.paginaAtual = p;
                        }
                    };

                    $scope.getTotalComparativo = function () {
                        var items = $scope.getComparativoAtivo();
                        if (!items || items.length === 0) return {};
                        var total = { ValorD0: 0, TotalFixo: 0, TotalMovel: 0, ValorD1: 0, ValorD7: 0, ValorD14: 0 };
                        items.forEach(function (item) {
                            total.ValorD0 += (item.ValorD0 || 0);
                            total.TotalFixo += (item.TotalFixo || 0);
                            total.TotalMovel += (item.TotalMovel || 0);
                            total.ValorD1 += (item.ValorD1 || 0);
                            total.ValorD7 += (item.ValorD7 || 0);
                            total.ValorD14 += (item.ValorD14 || 0);
                        });
                        return total;
                    };

                    $scope.selecionarServico = function (servico) {
                        servico._selecionado = !servico._selecionado;
                        atualizarFiltroServicos();
                        carregarCampanhas();
                        carregarDados();
                    };

                    $scope.toggleSelecionarTodos = function () {
                        $scope.selecionarTodos = !$scope.selecionarTodos;
                        $scope.servicos.forEach(function (s) { s._selecionado = $scope.selecionarTodos; });
                        atualizarFiltroServicos();
                        carregarCampanhas();
                        carregarDados();
                    };

                    function atualizarFiltroServicos() {
                        var selecionados = $scope.servicos.filter(function (s) { return s._selecionado; });
                        $scope.servicosIds = selecionados.map(function (s) { return s.ServicoId; }).join(',');
                    }

                    $scope.selecionarCampanha = function (campanha) {
                        campanha._selecionada = !campanha._selecionada;
                        atualizarFiltroCampanhas();
                        carregarDados();
                    };

                    $scope.toggleSelecionarTodasCampanhas = function () {
                        $scope.selecionarTodasCampanhas = !$scope.selecionarTodasCampanhas;
                        $scope.campanhas.forEach(function (c) { c._selecionada = $scope.selecionarTodasCampanhas; });
                        atualizarFiltroCampanhas();
                        carregarDados();
                    };

                    function atualizarFiltroCampanhas() {
                        var selecionadas = $scope.campanhas.filter(function (c) { return c._selecionada; });
                        $scope.campanhasIds = selecionadas.map(function (c) { return c.CampanhaId; }).join(',');
                    }

                    $scope.formatK = function (val) {
                        if (val == null) return '0';
                        if (val >= 1000) return (val / 1000).toFixed(1) + 'k';
                        return val.toString();
                    };

                    var offFiltrar = $rootScope.$on('onTalkbotFluxoFiltrar', function (e, filtro) {
                        $scope.dataInicio = filtro.dataInicio;
                        $scope.dataFim = filtro.dataFim;

                        var novaCarteira = filtro.carteiraId || 0;
                        var novosGrupos = filtro.gruposIds || '';
                        // Mudanca de carteira/grupo altera a lista de servicos; zera selecoes
                        // para nao manter servicos/campanhas que saíram do escopo. Mudanca
                        // apenas de periodo/data preserva a selecao.
                        var escopoMudou = (novaCarteira !== $scope.carteiraId) || (novosGrupos !== $scope.gruposIds);

                        $scope.carteiraId = novaCarteira;
                        $scope.gruposIds = novosGrupos;

                        if (escopoMudou) {
                            $scope.servicosIds = '';
                            $scope.campanhasIds = '';
                            $scope.selecionarTodos = false;
                            $scope.selecionarTodasCampanhas = false;
                        }

                        carregarServicos();
                        carregarCampanhas();
                        carregarDados();
                    });

                    $scope.$on('$destroy', function () {
                        offFiltrar();
                    });

                    carregarFluxos();
                    carregarServicos();
                    carregarCampanhas();
                    carregarDados();
                }],
                templateUrl: '../app_dash/pages/dashTalkbot/fluxo/fluxo.html'
            };
        });
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp').directive('campanha', ["$locale", "$rootScope", "DashTelecomService", function ($locale, $rootScope, DashTelecomService) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {},
            link: function (scope) {
                $locale.NUMBER_FORMATS.GROUP_SEP = " ";
                $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";
                scope.total = {};
                scope.campanhas = [];
                scope.campanhasSelecionadas = [];
                scope.filtro = {
                    dataFim: new Date(),
                    dataInicio: new Date(),
                    carteiraId: null,
                    campanhas: []
                };

                scope.getCampanhas = function () {
                    const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                    const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                    const carteiraId = scope.filtro.carteiraId;

                    DashTelecomService.getCampanhas(dataI, dataF, carteiraId)
                        .then((data) => {
                            if (!data || data.length === 0) {
                                scope.total = {};
                                scope.campanhas = [];
                                return;
                            }
                            scope.total = data[0];
                            scope.campanhas = data.slice(1);
                            scope.mudarFiltroCampanha(scope.campanhas);
                        })
                        .catch(() => { /* mantem dados anteriores */ });
                }

                scope.mudarFiltroCampanha = function (data) {
                    if (scope.filtro.campanhas != null && scope.filtro.campanhas.length > 0) {
                        const removidos = [];
                        scope.filtro.campanhas.forEach(function (id) {
                            const selecionado = data.find((el) => el.CampanhaId == id);
                            if (selecionado != null) {
                                selecionado.checked = true;
                            } else {
                                removidos.push(id);
                            }
                        });
                        scope.filtro.campanhas = _.difference(scope.filtro.campanhas, removidos);
                    }
                    scope.notificarFiltro();
                }

                scope.selecionarTodasCampanhas = function (campanha) {
                    scope.filtro.campanhas = [];

                    scope.campanhas.forEach(function (selecionado) {
                        if (selecionado.Campanha != 'Total') {
                            selecionado.checked = campanha.checked;
                            if (selecionado.checked) {
                                scope.filtro.campanhas.push(selecionado.CampanhaId);
                            }
                        }
                    });
                    scope.notificarFiltro();
                }

                scope.selecionarCampanha = function ($event, campanha) {
                    $event.stopPropagation();
                    if (scope.filtro.campanhas == null)
                        scope.filtro.campanhas = [];

                    if ($event.target.type != 'checkbox')
                        campanha.checked = !campanha.checked;
                    if (campanha.Campanha == 'Total') {
                        scope.selecionarTodasCampanhas(campanha);
                        return;
                    }
                    if (campanha.checked) {
                        scope.filtro.campanhas.push(campanha.CampanhaId);
                    } else {
                        scope.filtro.campanhas = scope.filtro.campanhas.filter(function (value) {
                            return (value != campanha.CampanhaId);
                        });
                    }
                    scope.notificarFiltro();
                }

                scope.notificarFiltro = function () {
                    $rootScope.$broadcast('onCampanhaSelecionada', scope.filtro);
                    $rootScope.$broadcast('onFiltroAlteradoCampanha', scope.filtro);
                }

                scope.dataSelecionada = function ($event, dados) {
                    scope.filtro.dataInicio = dados.start;
                    scope.filtro.dataFim = dados.end;
                    scope.filtro.carteiraId = dados.carteiraId;
                    scope.filtro.campanhaId = dados.campanhaId;
                    scope.getCampanhas();
                }

                const eventOnDataSelecionada = scope.$on('onDataSelecionada', scope.dataSelecionada);

                // Ao navegar entre as abas da dash, os arquivos da aba precisam ser recarregados, para isso,
                // a diretiva emite esse evento, que fará com que a controller verifique o filtro que está 
                // sendo usado e emita o evento 'onDataSelecionada', que será tratado no método 'dataSelecionada'
                $rootScope.$broadcast('onChangeAba');

                scope.$on('$destroy', () => eventOnDataSelecionada());
            },
            templateUrl: '../app_dash/pages/dashTelecom/campanha/campanha.html'
        };
    }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('campanhaClasses', ["DashTelecomService", function (DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        campanhas: []
                    };

                    function campanhaSelecionada($event, filtro) {
                        scope.filtro.campanhas = filtro.campanhas.toString();
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        scope.classes = [];
                        getCampanhaClasses(scope.filtro);
                    }

                    function getCampanhaClasses(filtro) {
                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = filtro.carteiraId;

                        DashTelecomService.getCampanhaClasses(dataI, dataF, carteiraId, filtro.campanhas)
                            .then(function (data) {
                                data = data || [];
                                scope.showGraph = data.length != 0;
                                formatarClasses(data);
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    function formatarClasses(data) {
                        if (scope.filtro.campanhas == null || (scope.filtro.campanhas.length != 1 || (scope.filtro.campanhas.length == 1 && scope.filtro.campanhas[0] == 0))) {
                            scope.classes = data;
                            scope.classes = _.sortBy(scope.classes, (el) => {
                                return el.Classe;
                            });
                        } else {
                            scope.classes = [];
                            data.forEach((classe) => {
                                const classeExistente = scope.classes.find((el) => el.Campanha == classe.Campanha);
                                if (classeExistente == null) {
                                    scope.classes.push({
                                        CampanhaId: classe.CampanhaId,
                                        Campanha: classe.Campanha,
                                        ClasseGrupos: [{
                                            ClasseId: classe.ClasseId,
                                            Classe: classe.Classe,
                                            Quantidade: classe.Quantidade,
                                            Custo: classe.Custo,
                                            Duracao: classe.Duracao
                                        }]
                                    });
                                } else {
                                    classeExistente.ClasseGrupos.push({
                                        ClasseId: classe.ClasseId,
                                        Classe: classe.Classe,
                                        Quantidade: classe.Quantidade,
                                        Custo: classe.Custo,
                                        Duracao: classe.Duracao
                                    });
                                }
                            }, this);
                            scope.classes.forEach((campanha) => {
                                campanha.ClasseGrupos = _.sortBy(campanha.ClasseGrupos, (el) => el.Classe);
                            });
                        }

                        $('.animate-progress-bar').each(function () {
                            $(this).css('width', $(this).attr("data-percentage"));
                        });

                    }

                    const eventOnCampanhaSelecionada = scope.$on('onCampanhaSelecionada', campanhaSelecionada);

                    scope.$on('$destroy', () => eventOnCampanhaSelecionada());
                },
                templateUrl: '../app_dash/pages/dashTelecom/classes/campanhaClasses.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('classes', ["DashTelecomService", function (DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: []
                    };

                    function fornecedorSelecionado ($event, filtro) {
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        scope.classes = [];
                        getClasses(scope.filtro);
                    }

                    function getClasses (filtro) {
                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = scope.filtro.carteiraId;

                        DashTelecomService.getClasses(dataI, dataF, carteiraId, filtro.fornecedores)
                            .then(function (data) {
                                data = data || [];
                                scope.showGraph = data.length != 0;
                                formatarClasses(data);
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    function formatarClasses(data) {
                        if (scope.filtro.fornecedores == null || (scope.filtro.fornecedores.length != 1 || (scope.filtro.fornecedores.length == 1 && scope.filtro.fornecedores[0] == 0))) {
                            scope.classes = data;
                            scope.classes = _.sortBy(scope.classes, (el) => el.Classe);
                        } else {
                            scope.classes = [];
                            data.forEach((classe) => {
                                const classeExistente = scope.classes.find((el) => {
                                    return el.Rota == classe.Rota;
                                });
                                if (classeExistente == null) {
                                    scope.classes.push({
                                        RotaId: classe.RotaId,
                                        Rota: classe.Rota,
                                        TotalFranquia: classe.TotalFranquia,
                                        FranquiaP: classe.FranquiaP,
                                        Franquia: classe.Franquia,
                                        ClasseGrupos: [{
                                            ClasseId: classe.ClasseId,
                                            Classe: classe.Classe,
                                            Quantidade: classe.Quantidade,
                                            Custo: classe.Custo,
                                            Duracao: classe.Duracao
                                        }]
                                    });
                                } else {
                                    classeExistente.ClasseGrupos.push({
                                        ClasseId: classe.ClasseId,
                                        Classe: classe.Classe,
                                        Quantidade: classe.Quantidade,
                                        Custo: classe.Custo,
                                        Duracao: classe.Duracao
                                    });
                                }
                            }, this);
                            scope.classes.forEach((rota) => {
                                rota.ClasseGrupos = _.sortBy(rota.ClasseGrupos, (el) => el.Classe);
                            });
                        }

                        $('.animate-progress-bar').each(function () {
                            $(this).css('width', $(this).attr("data-percentage"));
                        });
                    }

                    const eventOnFornecedorSelecionado = scope.$on('onFornecedorSelecionado', fornecedorSelecionado);

                    scope.$on('$destroy', () => eventOnFornecedorSelecionado())
                },
                templateUrl: '../app_dash/pages/dashTelecom/classes/classes.html'
            };
        }]);
})();
(function () {
    "use strict";

    // Factory que encapsula a logica compartilhada pelos 3 directives de fornecedor
    // (fornecedores, fornecedoresStatus, fornecedoresOcupacao). Antes, os 3 arquivos
    // duplicavam ~70% do codigo (selecao, notificacao, init, listeners) — qualquer
    // bugfix tinha que ser replicado 3x e propenso a divergencia.
    //
    // Uso: cada directive injeta esta factory e chama
    //   FornecedoresControllerFactory.criar(scope, { fetcher, onAposCarregar, resetarFiltros })
    angular.module('epbxManagerApp')
        .factory('FornecedoresControllerFactory', ["$rootScope", "DashTelecomStorage", function ($rootScope, DashTelecomStorage) {

            // opcoes:
            //   fetcher(scope)        → Promise<data> com a lista de fornecedores (1o item = total)
            //   onAposCarregar(scope) → callback opcional executado depois de aplicar a lista
            //   resetarFiltros(scope) → callback opcional para limpar filtros derivados (ex: rotas)
            function criar(scope, opcoes) {
                opcoes = opcoes || {};
                let trocandoRota = false;

                scope.total = scope.total || {};
                scope.fornecedores = [];
                scope.filtro = {
                    dataFim: new Date(),
                    dataInicio: new Date(),
                    carteiraId: null,
                    fornecedores: []
                };

                // Hidrata filtro a partir do localStorage (mesmo que outras directives da pagina)
                const filtroCache = DashTelecomStorage.get();
                scope.filtro.fornecedores = (filtroCache != null && Array.isArray(filtroCache.fornecedores))
                    ? filtroCache.fornecedores
                    : [];

                scope.selecionarTodosFornecedores = function (fornecedor) {
                    scope.filtro.fornecedores = [];
                    scope.fornecedores.forEach(function (selecionado) {
                        if (selecionado.Fornecedor == 'Total') return;
                        selecionado.checked = fornecedor.checked;
                        if (selecionado.checked) {
                            // Evita duplicacao caso o backend retorne 2 entradas com mesmo Id
                            if (scope.filtro.fornecedores.indexOf(selecionado.FornecedorId) === -1) {
                                scope.filtro.fornecedores.push(selecionado.FornecedorId);
                            }
                        }
                    });
                    notificarFiltro();
                };

                scope.selecionarFornecedor = function (fornecedor) {
                    fornecedor.checked = !fornecedor.checked;
                    if (scope.filtro.fornecedores == null) scope.filtro.fornecedores = [];
                    if (fornecedor.Fornecedor == 'Total') return scope.selecionarTodosFornecedores(fornecedor);
                    if (fornecedor.checked) {
                        if (scope.filtro.fornecedores.indexOf(fornecedor.FornecedorId) === -1) {
                            scope.filtro.fornecedores.push(fornecedor.FornecedorId);
                        }
                    } else {
                        scope.filtro.fornecedores = scope.filtro.fornecedores.filter(function (value) {
                            return value != fornecedor.FornecedorId;
                        });
                    }
                    notificarFiltro();
                };

                function notificarFiltro() {
                    if (trocandoRota) return;
                    $rootScope.$broadcast('onFornecedorSelecionado', scope.filtro);
                    $rootScope.$broadcast('onFiltroAlteradoFornecedor', scope.filtro);
                }

                // Reconcilia o filtro local com os dados recebidos: marca como checked
                // os fornecedores ainda presentes e remove IDs orfaos.
                function mudarFiltroFornecedor(data) {
                    if (typeof opcoes.resetarFiltros === 'function') {
                        opcoes.resetarFiltros(scope);
                    }
                    if (scope.filtro.fornecedores != null && scope.filtro.fornecedores.length > 0) {
                        const removidos = [];
                        scope.filtro.fornecedores.forEach(function (id) {
                            const selecionado = data.find(function (el) { return el.FornecedorId == id; });
                            if (selecionado != null) selecionado.checked = true;
                            else removidos.push(id);
                        });
                        scope.filtro.fornecedores = _.difference(scope.filtro.fornecedores, removidos);
                    }
                    notificarFiltro();
                }

                // requestId protege contra race conditions quando o usuario muda filtro
                // varias vezes rapidamente — apenas o resultado do request mais recente vence.
                let requestId = 0;

                function carregar() {
                    if (typeof opcoes.fetcher !== 'function') return;
                    scope.loading = true;
                    scope.erroCarregamento = null;
                    requestId++;
                    const reqAtual = requestId;

                    opcoes.fetcher(scope)
                        .then(function (data) {
                            if (reqAtual != requestId) return;
                            if (!data || data.length === 0) {
                                scope.total = {};
                                scope.fornecedores = [];
                                return;
                            }
                            scope.total = data[0];
                            scope.fornecedores = data.slice(1);
                            mudarFiltroFornecedor(scope.fornecedores);
                            if (typeof opcoes.onAposCarregar === 'function') {
                                opcoes.onAposCarregar(scope);
                            }
                        })
                        .catch(function () {
                            if (reqAtual != requestId) return;
                            scope.erroCarregamento = 'Erro ao carregar fornecedores.';
                        })
                        .finally(function () {
                            if (reqAtual == requestId) scope.loading = false;
                        });
                }

                function dataSelecionada($event, dados) {
                    scope.filtro.dataInicio = dados.start;
                    scope.filtro.dataFim = dados.end;
                    scope.filtro.carteiraId = dados.carteiraId;
                    carregar();
                }

                const eventOnDataSelecionada = scope.$on('onDataSelecionada', dataSelecionada);
                const listenersExtras = [];

                function destroy() {
                    eventOnDataSelecionada();
                    listenersExtras.forEach(function (off) {
                        if (typeof off === 'function') off();
                    });
                }

                scope.$on('$destroy', destroy);
                scope.$on('$stateChangeStart', function () {
                    trocandoRota = true;
                    destroy();
                });

                // API publica que o directive pode usar para registrar listeners extras
                // (ex: onRotaSelecionada no fornecedoresStatus) e disparar refresh.
                return {
                    carregar: carregar,
                    registrarListener: function (eventoNome, handler) {
                        listenersExtras.push(scope.$on(eventoNome, handler));
                    }
                };
            }

            return { criar: criar };
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('fornecedores', ["$locale", "DashTelecomService", "FornecedoresControllerFactory", function ($locale, DashTelecomService, FornecedoresControllerFactory) {
            return {
                restrict: 'E',
                scope: {},
                link: function (scope) {
                    // Formato numerico local (so esta directive precisa)
                    $locale.NUMBER_FORMATS.GROUP_SEP = " ";
                    $locale.NUMBER_FORMATS.DECIMAL_SEP = ",";

                    FornecedoresControllerFactory.criar(scope, {
                        fetcher: function (scope) {
                            const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                            const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                            return DashTelecomService.getFornecedores(dataI, dataF, scope.filtro.carteiraId);
                        }
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/fornecedores/fornecedores.html'
            };
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('fornecedoresOcupacao', ["DashTelecomService", "FornecedoresControllerFactory", function (DashTelecomService, FornecedoresControllerFactory) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    FornecedoresControllerFactory.criar(scope, {
                        fetcher: function (scope) {
                            const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                            const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                            return DashTelecomService.getFornecedoresOcupacao(dataI, dataF, scope.filtro.carteiraId);
                        },
                        // Aba de ocupacao zera filtro de rotas a cada novo carregamento
                        resetarFiltros: function (scope) {
                            scope.filtro.rotas = [];
                        }
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/fornecedores/fornecedoresOcupacao.html'
            };
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')
        .directive('fornecedoresStatus', ["DashTelecomService", "FornecedoresControllerFactory", function (DashTelecomService, FornecedoresControllerFactory) {
            return {
                restrict: 'E',
                scope: {},
                link: function (scope) {
                    scope.rotasSelecionadas = [];

                    const controller = FornecedoresControllerFactory.criar(scope, {
                        fetcher: function (scope) {
                            const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                            const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                            return DashTelecomService.getFornecedoresStatus(dataI, dataF, scope.filtro.carteiraId, scope.rotasSelecionadas);
                        },
                        onAposCarregar: function () {
                            // Tooltip do Bootstrap precisa ser re-inicializado quando os
                            // nodos sao re-renderizados pelo ng-repeat.
                            $('[data-toggle="tooltip"]').tooltip();
                        }
                    });

                    // Listener especifico desta aba: rotas filtradas pelo grafico de periodos
                    controller.registrarListener('onRotaSelecionada', function ($event, rota) {
                        if (rota.checked) {
                            if (scope.rotasSelecionadas.indexOf(rota.Id) === -1) {
                                scope.rotasSelecionadas.push(rota.Id);
                            }
                        } else {
                            scope.rotasSelecionadas = _.filter(scope.rotasSelecionadas, function (el) {
                                return el != rota.Id;
                            });
                        }
                        // Re-busca os fornecedores usando o fetcher centralizado
                        controller.carregar();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/fornecedores/fornecedoresStatus.html'
            };
        }]);
})();

(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoCampanhaPeriodo', ["DashTelecomService", function (DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraphCampanha = true;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        campanhas: [],
                        tipoVisao: 'Custo'
                    };
                    scope.periodos = [];
                    scope.periodosAgrupado = [];

                    scope.mudarVisaoValor = function () {
                        getPeriodos(scope.filtro);
                    };

                    function campanhaSelecionada($event, filtro) {
                        scope.filtro.campanhas = filtro.campanhas;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        getPeriodos(scope.filtro);
                    }

                    function getPeriodos(filtro) {
                        scope.periodos = null;
                        scope.periodosAgrupado = null;
                        let tipo = 0;
                        if (filtro.tipoVisao == 'Custo') tipo = 1
                        else if (filtro.tipoVisao == 'Quantidade') tipo = 2
                        else if (filtro.tipoVisao == 'Duracao') tipo = 3

                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = filtro.carteiraId;

                        DashTelecomService.getCampanhaPeriodos(dataI, dataF, carteiraId, filtro.campanhas, tipo)
                            .then(function (data) {
                                data = data || [];
                                scope.showGraphCampanha = false;
                                for (var i = 0; i < data.length; i++) {
                                    if (Object.keys(data[i]).length > 1) scope.showGraphCampanha = true;
                                }
                                scope.periodos = JSON.parse(JSON.stringify(data));
                                recarregarChartPrincipal();
                            })
                            .catch(() => { scope.showGraphCampanha = false; });
                    }

                    function configurarVisaoValor() {
                        if (scope.chartPrincipal) {
                            scope.chartPrincipal.valueAxes[0].title = scope.filtro.tipoVisao;
                            if (scope.filtro.tipoVisao == 'Custo') {
                                scope.chartPrincipal.marginLeft = 90;
                                scope.chartPrincipal.graphs.forEach(function (graph) {
                                    graph.balloonText = "<span style='font-size:11px;'>R$[[value]]</span>";
                                });
                                scope.chartPrincipal.numberFormatter = {
                                    precision: 2,
                                    decimalSeparator: ",",
                                    thousandsSeparator: ""
                                }
                                scope.chartPrincipal.valueAxes[0].labelFunction = function (value, valueText) {
                                    return 'R$' + valueText;
                                }
                            } else if (scope.filtro.tipoVisao == 'Quantidade') {
                                scope.chartPrincipal.marginLeft = 90;
                                scope.chartPrincipal.graphs.forEach(function (graph) {
                                    graph.balloonText = "<span style='font-size:11px;'>[[value]] ligações</span>";
                                });
                                scope.chartPrincipal.numberFormatter = {
                                    precision: -1,
                                    decimalSeparator: ",",
                                    thousandsSeparator: "."
                                }
                                scope.chartPrincipal.valueAxes[0].labelFunction = function (value, valueText) {
                                    return valueText;
                                }
                            } else {
                                scope.chartPrincipal.marginLeft = 90;
                                scope.chartPrincipal.graphs.forEach(function (graph) {
                                    graph.balloonText = "<span style='font-size:11px;'>[[value]] mins</span>";
                                });
                                scope.chartPrincipal.numberFormatter = {
                                    precision: -1,
                                    decimalSeparator: ",",
                                    thousandsSeparator: "."
                                }
                                scope.chartPrincipal.valueAxes[0].labelFunction = function (value, valueText) {
                                    return valueText;
                                }
                            }
                            let dataIm = moment(scope.filtro.dataInicio);
                            let dataFm = moment(scope.filtro.dataFim);
                            const difference = dataFm.diff(dataIm, 'days');
                            if (difference > 90) {
                                scope.chartPrincipal.chartCursor.categoryBalloonDateFormat = "MMMM YY";
                            } else if (difference > 3) {
                                scope.chartPrincipal.chartCursor.categoryBalloonDateFormat = "DD/MM, EEEE";
                            } else {
                                scope.chartPrincipal.chartCursor.categoryBalloonDateFormat = "DD/MM JJ:NN";
                            }
                            scope.chartPrincipal.dataProvider = scope.periodos;
                            scope.chartPrincipal.validateData();
                        }
                    }

                    function recarregarChartPrincipal() {
                        configChartPrincipal();
                        configureGraphs();
                        configurarVisaoValor();
                    }

                    function configureGraphs() {
                        scope.chartPrincipal.graphs = [];
                        if (scope.filtro.campanhas == null || scope.filtro.campanhas.length == 0) {
                            scope.chartPrincipal.graphs.push({
                                "id": "geral",
                                "balloon": {
                                    "drop": true,
                                    "adjustBorderColor": false,
                                    "color": "#ffffff"
                                },
                                "bullet": "round",
                                "bulletBorderAlpha": 1,
                                "bulletColor": "#FFFFFF",
                                "bulletSize": 5,
                                "hideBulletsCount": 50,
                                "lineThickness": 2,
                                "title": "Geral",
                                "useLineColorForBulletBorder": true,
                                "valueField": "Geral"
                            });
                        } else {
                            let campanhas = [];
                            let campanhasFiltro = scope.filtro.campanhas.slice();
                            campanhasFiltro = _.without(campanhasFiltro, 0);
                            if (campanhasFiltro.length == 1) {
                                for (let prop in scope.periodos[0]) {
                                    if (prop != 'Data') {
                                        if (!_.contains(campanhas, prop)) {
                                            campanhas.push(prop);
                                        }
                                    }
                                }
                                campanhas.forEach(function (el) {
                                    scope.chartPrincipal.graphs.push({
                                        "balloon": {
                                            "drop": true,
                                            "adjustBorderColor": false,
                                            "color": "#ffffff"
                                        },
                                        "bullet": "round",
                                        "bulletBorderAlpha": 1,
                                        "bulletColor": "#FFFFFF",
                                        "bulletSize": 5,
                                        "hideBulletsCount": 50,
                                        "lineThickness": 2,
                                        "title": el,
                                        "useLineColorForBulletBorder": true,
                                        "valueField": el
                                    });

                                }, this);
                            } else if (campanhasFiltro.length > 1) {
                                for (let prop in scope.periodos[0]) {
                                    if (prop != 'Data') {
                                        if (!_.contains(campanhas, prop)) {
                                            campanhas.push(prop);
                                        }
                                    }
                                }
                                campanhas.forEach(function (el) {
                                    scope.chartPrincipal.graphs.push({
                                        "balloon": {
                                            "drop": true,
                                            "adjustBorderColor": false,
                                            "color": "#ffffff"
                                        },
                                        "bullet": "round",
                                        "bulletBorderAlpha": 1,
                                        "bulletColor": "#FFFFFF",
                                        "bulletSize": 5,
                                        "hideBulletsCount": 50,
                                        "lineThickness": 2,
                                        "title": el,
                                        "useLineColorForBulletBorder": true,
                                        "valueField": el
                                    });
                                }, this);
                            }
                        }
                    }

                    function configChartPrincipal() {
                        // AmCharts.clear() removido — destruia outros charts da pagina.
                        scope.chartPrincipal = AmCharts.makeChart("chartprincipal-campanha", {
                            "language": "pt",
                            "type": "serial",
                            "theme": "light",
                            "marginRight": 50,
                            "autoMarginOffset": 0,
                            "mouseWheelZoomEnabled": true,
                            "dataDateFormat": "YYYY-MM-DDTHH:mm:SS",
                            "valueAxes": [{
                                "axisColor": "#fff",
                                "color": "#fff",
                                "id": "v1",
                                "axisAlpha": 0,
                                "position": "left",
                                "ignoreAxisWidth": true,
                                "gridColor": "#dcdcdc",
                                "gridAlpha": 0.2,
                                "titleColor": "#fff",
                                "titleBold": false
                            }],
                            "balloon": {
                                "borderThickness": 1,
                                "shadowAlpha": 0
                            },
                            "graphs": [{
                                "id": "g1",
                                "balloon": {
                                    "drop": true,
                                    "adjustBorderColor": false,
                                    "color": "#ffffff"
                                },
                                "bullet": "round",
                                "bulletBorderAlpha": 1,
                                "bulletColor": "#FFFFFF",
                                "bulletSize": 5,
                                "hideBulletsCount": 50,
                                "lineThickness": 2,
                                "title": "red line",
                                "useLineColorForBulletBorder": true,
                            }],
                            "chartCursor": {
                                "pan": true,
                                "valueLineEnabled": true,
                                "valueLineBalloonEnabled": true,
                                "cursorAlpha": 1,
                                "cursorColor": "#258cbb",
                                "limitToGraph": "g1",
                                "valueLineAlpha": 0.2,
                                "valueZoomable": true,
                                "categoryBalloonDateFormat": "DD/MM JJ:NN"
                            },
                            "valueScrollbar": {
                                "oppositeAxis": false,
                                "offset": 50,
                                "scrollbarHeight": 10
                            },
                            "categoryField": "Data",
                            "categoryAxis": {
                                "minPeriod": "hh",
                                "axisColor": "#fff",
                                "color": "#fff",
                                "parseDates": true,
                                "dashLength": 1,
                                "minorGridEnabled": true,
                            },
                            "legend": {
                                "color": "#fff"
                            },
                            "export": {
                                "enabled": false
                            }
                        });
                    }

                    const eventOnCampanhaSelecionada = scope.$on('onCampanhaSelecionada', campanhaSelecionada);

                    scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnCampanhaSelecionada();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoFinanceiroPeriodo/graficoCampanhaPeriodo.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoFinanceiroPeriodo', ["DashTelecomService", function (DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: [],
                        tipoVisao: 'Custo'
                    };
                    scope.periodos = [];
                    scope.periodosAgrupado = [];

                    scope.mudarVisaoValor = function () {
                        getPeriodos(scope.filtro);
                    };

                    function fornecedorSelecionado($event, filtro) {
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        getPeriodos(scope.filtro);
                    }

                    function getPeriodos(filtro) {
                        scope.periodos = null;
                        scope.periodosAgrupado = null;
                        let tipo = 0;
                        if (filtro.tipoVisao == 'Custo') tipo = 1
                        else if (filtro.tipoVisao == 'Quantidade') tipo = 2
                        else if (filtro.tipoVisao == 'Duracao') tipo = 3

                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = scope.filtro.carteiraId;

                        DashTelecomService.getFinanceiroPeriodos(dataI, dataF, carteiraId, filtro.fornecedores, tipo)
                            .then(function (data) {
                                data = data || [];
                                scope.showGraph = false;
                                for (var i = 0; i < data.length; i++) {
                                    if (Object.keys(data[i]).length > 1) scope.showGraph = true;
                                }
                                scope.periodos = JSON.parse(JSON.stringify(data));
                                recarregarChartPrincipal();
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    function configurarVisaoValor() {
                        if(scope.periodos.length > 0) {
                            if (scope.chartPrincipal) {
                                scope.chartPrincipal.valueAxes[0].title = scope.filtro.tipoVisao;
                                if (scope.filtro.tipoVisao == 'Custo') {
                                    scope.chartPrincipal.marginLeft = 90;
                                    scope.chartPrincipal.graphs.forEach((graph) => {
                                        graph.balloonText = "<span style='font-size:11px;'>R$[[value]]</span>";
                                    });
                                    scope.chartPrincipal.numberFormatter = {
                                        precision: 2,
                                        decimalSeparator: ",",
                                        thousandsSeparator: ""
                                    }
                                    scope.chartPrincipal.valueAxes[0].labelFunction = (value, valueText) => {
                                        return 'R$' + valueText;
                                    }
                                } else if (scope.filtro.tipoVisao == 'Quantidade') {
                                    scope.chartPrincipal.marginLeft = 90;
                                    scope.chartPrincipal.graphs.forEach((graph) => {
                                        graph.balloonText = "<span style='font-size:11px;'>[[value]] ligações</span>";
                                    });
                                    scope.chartPrincipal.numberFormatter = {
                                        precision: -1,
                                        decimalSeparator: ",",
                                        thousandsSeparator: "."
                                    }
                                    scope.chartPrincipal.valueAxes[0].labelFunction = (value, valueText) => {
                                        return valueText;
                                    }
                                } else {
                                    scope.chartPrincipal.marginLeft = 90;
                                    scope.chartPrincipal.graphs.forEach((graph) => {
                                        graph.balloonText = "<span style='font-size:11px;'>[[value]] mins</span>";
                                    });
                                    scope.chartPrincipal.numberFormatter = {
                                        precision: -1,
                                        decimalSeparator: ",",
                                        thousandsSeparator: "."
                                    }
                                    scope.chartPrincipal.valueAxes[0].labelFunction = (value, valueText) => {
                                        return valueText;
                                    }
                                }
                                const dataIm = moment(scope.filtro.dataInicio);
                                const dataFm = moment(scope.filtro.dataFim);
                                const difference = dataFm.diff(dataIm, 'days');
                                if (difference > 90) {
                                    scope.chartPrincipal.chartCursor.categoryBalloonDateFormat = "MMMM YY";
                                } else if (difference > 3) {
                                    scope.chartPrincipal.chartCursor.categoryBalloonDateFormat = "DD/MM, EEEE";
                                } else {
                                    scope.chartPrincipal.chartCursor.categoryBalloonDateFormat = "DD/MM JJ:NN";
                                }
                                scope.chartPrincipal.dataProvider = scope.periodos;
                                scope.chartPrincipal.validateData();
                            }
                        }
                    }

                    function recarregarChartPrincipal() {
                        configChartPrincipal();
                        configureGraphs();
                        configurarVisaoValor();
                    }

                    function configureGraphs() {
                        scope.chartPrincipal.graphs = [];
                        if (scope.filtro.fornecedores == null || scope.filtro.fornecedores.length == 0) {
                            scope.chartPrincipal.graphs.push({
                                "id": "geral",
                                "balloon": {
                                    "drop": true,
                                    "adjustBorderColor": false,
                                    "color": "#ffffff"
                                },
                                "bullet": "round",
                                "bulletBorderAlpha": 1,
                                "bulletColor": "#FFFFFF",
                                "bulletSize": 5,
                                "hideBulletsCount": 50,
                                "lineThickness": 2,
                                "title": "Geral",
                                "useLineColorForBulletBorder": true,
                                "valueField": "Geral"
                            });
                        } else {
                            let fornecedoresFiltro = scope.filtro.fornecedores.slice();
                            fornecedoresFiltro = _.without(fornecedoresFiltro, 0);
                            if (fornecedoresFiltro.length == 1) {
                                let rotas = [];
                                for (let prop in scope.periodos[0]) {
                                    if (prop != 'Data') {
                                        if (!_.contains(rotas, prop)) {
                                            rotas.push(prop);
                                        }
                                    }
                                }
                                rotas.forEach((el) => {
                                    scope.chartPrincipal.graphs.push({
                                        "balloon": {
                                            "drop": true,
                                            "adjustBorderColor": false,
                                            "color": "#ffffff"
                                        },
                                        "bullet": "round",
                                        "bulletBorderAlpha": 1,
                                        "bulletColor": "#FFFFFF",
                                        "bulletSize": 5,
                                        "hideBulletsCount": 50,
                                        "lineThickness": 2,
                                        "title": el,
                                        "useLineColorForBulletBorder": true,
                                        "valueField": el
                                    });

                                }, this);
                            } else if (fornecedoresFiltro.length > 1) {
                                let fornecedores = [];
                                for (let prop in scope.periodos[0]) {
                                    if (prop != 'Data') {
                                        if (!_.contains(fornecedores, prop)) {
                                            fornecedores.push(prop);
                                        }
                                    }
                                }
                                fornecedores.forEach((el) => {
                                    scope.chartPrincipal.graphs.push({
                                        "balloon": {
                                            "drop": true,
                                            "adjustBorderColor": false,
                                            "color": "#ffffff"
                                        },
                                        "bullet": "round",
                                        "bulletBorderAlpha": 1,
                                        "bulletColor": "#FFFFFF",
                                        "bulletSize": 5,
                                        "hideBulletsCount": 50,
                                        "lineThickness": 2,
                                        "title": el,
                                        "useLineColorForBulletBorder": true,
                                        "valueField": el
                                    });
                                }, this);
                            }
                        }
                    }

                    function configChartPrincipal() {
                        // AmCharts.clear() removido — destruia outros charts da pagina.
                        scope.chartPrincipal = AmCharts.makeChart("chartprincipal-financeiro", {
                            "language": "pt",
                            "type": "serial",
                            "theme": "light",
                            "marginRight": 50,
                            "autoMarginOffset": 0,
                            "mouseWheelZoomEnabled": true,
                            "dataDateFormat": "YYYY-MM-DDTHH:mm:SS",
                            "valueAxes": [{
                                "axisColor": "#fff",
                                "color": "#fff",
                                "id": "v1",
                                "axisAlpha": 0,
                                "position": "left",
                                "ignoreAxisWidth": true,
                                "gridColor": "#dcdcdc",
                                "gridAlpha": 0.2,
                                "titleColor": "#fff",
                                "titleBold": false
                            }],
                            "balloon": {
                                "borderThickness": 1,
                                "shadowAlpha": 0
                            },
                            "graphs": [{
                                "id": "g1",
                                "balloon": {
                                    "drop": true,
                                    "adjustBorderColor": false,
                                    "color": "#ffffff"
                                },
                                "bullet": "round",
                                "bulletBorderAlpha": 1,
                                "bulletColor": "#FFFFFF",
                                "bulletSize": 5,
                                "hideBulletsCount": 50,
                                "lineThickness": 2,
                                "title": "red line",
                                "useLineColorForBulletBorder": true,
                            }],
                            "chartCursor": {
                                "pan": true,
                                "valueLineEnabled": true,
                                "valueLineBalloonEnabled": true,
                                "cursorAlpha": 1,
                                "cursorColor": "#258cbb",
                                "limitToGraph": "g1",
                                "valueLineAlpha": 0.2,
                                "valueZoomable": true,
                                "categoryBalloonDateFormat": "DD/MM JJ:NN"
                            },
                            "valueScrollbar": {
                                "oppositeAxis": false,
                                "offset": 50,
                                "scrollbarHeight": 10
                            },
                            "categoryField": "Data",
                            "categoryAxis": {
                                "minPeriod": "hh",
                                "axisColor": "#fff",
                                "color": "#fff",
                                "parseDates": true,
                                "dashLength": 1,
                                "minorGridEnabled": true,
                            },
                            "legend": {
                                "color": "#fff"
                            },
                            "export": {
                                "enabled": false
                            }
                        });
                    }

                    const eventOnFornecedorSelecionado = scope.$on('onFornecedorSelecionado', fornecedorSelecionado);

                    scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnFornecedorSelecionado();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoFinanceiroPeriodo/graficoFinanceiroPeriodo.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoOcupacaoPeriodo', ["$rootScope", "DashTelecomService", function ($rootScope, DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.chartPrincipal = [];
                    scope.periodos = [];
                    scope.showGraph = true;
                    scope.zoomAtivo = false;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: []
                    };
                    scope.corErro = '#d9534f';
                    scope.corSucesso = '#90ee90';
                    scope.corTotal = '#2196F3';

                    scope.filtroFilhos = {
                        fornecedores: [],
                        rotas: []
                    }

                    scope.selecionarPeriodo = function ($event, periodo) {
                        if (scope.filtroFilhos.fornecedores == null)
                            scope.filtroFilhos.fornecedores = [];
                        if (scope.filtroFilhos.rotas == null)
                            scope.filtroFilhos.rotas = [];

                        if ($event.target.type != 'checkbox')
                            periodo.checked = !periodo.checked;

                        if (periodo.checked) {
                            scope.filtroFilhos.fornecedores = scope.filtro.fornecedores;
                            scope.filtroFilhos.rotas.push(periodo.Dados[0].RotaId);
                        } else {
                            scope.filtroFilhos.rotas = scope.filtroFilhos.rotas.filter(function (value) {
                                return (value != periodo.Dados[0].RotaId);
                            });
                        }
                        scope.filtroFilhos.dataInicio = scope.filtro.dataInicio;
                        scope.filtroFilhos.dataFim = scope.filtro.dataFim;
                        scope.filtroFilhos.carteiraId = scope.filtro.carteiraId;
                        notificarFiltro();
                    }

                    scope.maisZoom = function (chart) {
                        chart.zoomToIndexes(chart.startIndex + 20, chart.endIndex - 20);
                    }

                    scope.menosZoom = function (chart) {
                        chart.zoomToIndexes(chart.startIndex - 20, chart.endIndex + 20);
                    }

                    scope.limparZoom = function (chart) {
                        chart.zoomOut();
                    }

                    function notificarFiltro() {
                        $rootScope.$broadcast('onOcupacaoFornecedorRotaSelecionado', scope.filtroFilhos);
                        $rootScope.$broadcast('onFiltroAlteradoFornecedor', scope.filtro);
                    }

                    function configChartPrincipal() {
                        // AmCharts.clear() removido — destruia outros charts da pagina.
                        setTimeout(() => {
                            scope.chartPrincipal = [];
                            if (scope.periodos != null) {
                                for (let i = 0; i < scope.periodos.length; i++) {
                                    scope.zoomAtivo = true;
                                    scope.chartPrincipal.push(AmCharts.makeChart("chartprincipal-ocupacao-" + i, {
                                        "type": "serial",
                                        "theme": "light",
                                        "marginRight": 5,
                                        "language": "pt",
                                        // "dataDateFormat": "YYYY-MM-DDTHH:mm:SS",
                                        "autoMarginOffset": 0,
                                        "numberFormatter": {
                                            precision: -1,
                                            decimalSeparator: ",",
                                            thousandsSeparator: "."
                                        },
                                        "legend": {
                                            "equalWidths": false,
                                            "periodValueText": "Ativo: [[value.sum]]",
                                            "position": "right",
                                            "valueAlign": "left",
                                            "marginRight": 0,
                                            "horizontalGap": 0,
                                            "color": "#fff",
                                            "markerSize": 10,
                                            "data": [
                                                { title: "Ativo", color: scope.corTotal },
                                                { title: "Receptivo", color: scope.corErro }
                                            ]
                                        },
                                        "dataProvider": scope.periodos[i].Dados,
                                        "graphs": [{
                                            "balloonText": "Ativo: <b>[[value]]</b>",
                                            "fillAlphas": 1,
                                            "lineAlpha": 0.4,
                                            "title": "Ativo",
                                            "valueField": "QuantidadeTotal",
                                            "fillColors": scope.corTotal,
                                            "lineColor": scope.corTotal
                                        }, {
                                            "balloonText": "Receptivo: <b>[[value]]</b>",
                                            "fillAlphas": 1,
                                            "lineAlpha": 0.4,
                                            "title": "Receptivo",
                                            "valueField": "Receptivo",
                                            "fillColors": scope.corErro,
                                            "lineColor": scope.corErro
                                        }],
                                        "valueAxes": [{
                                            "stackType": "regular",
                                            "gridAlpha": 0.5,
                                            "gridColor": "#fff",
                                            "position": "left",
                                            "title": "Canais",
                                            "axisColor": "#fff",
                                            "color": "#fff",
                                            "titleColor": "#fff",
                                            "titleBold": false,
                                            "maximum": scope.periodos[i].Dados[0].QuantidadeCanal,
                                        }],
                                        "plotAreaBorderAlpha": 0,
                                        "marginTop": 10,
                                        "marginLeft": 20,
                                        "zoomOutText": "",
                                        "mouseWheelZoomEnabled": true,
                                        "marginBottom": 0,
                                        "chartCursor": {
                                            "valueLineEnabled": true,
                                            "valueLineBalloonEnabled": true,
                                            "cursorAlpha": 1,
                                            "cursorColor": "#258cbb",
                                            "valueLineAlpha": 0.2,
                                            "selectWithoutZooming": false,
                                            "categoryBalloonDateFormat": "DD/MM JJ:NN",
                                            "zoomed": false
                                        },
                                        "categoryField": "DataHora",
                                        "categoryAxis": {
                                            "parseDates": true,
                                            "gridAlpha": 0.07,
                                            "axisColor": "#fff",
                                            "color": "#fff",
                                            "minPeriod": 'mm'
                                        },
                                        "export": {
                                            "enabled": false
                                        }
                                    }));
                                }
                            }
                        }, 1);
                    }

                    let requestId = 0;

                    function getPeriodos(filtro) {
                        scope.periodos = null;
                        scope.loading = true;
                        scope.erroCarregamento = null;
                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = filtro.carteiraId;
                        requestId++;
                        const reqAtual = requestId;

                        DashTelecomService.getOcupacaoPeriodos(dataI, dataF, carteiraId, filtro.fornecedores, filtro.rotas)
                            .then((data) => {
                                if (reqAtual != requestId) return;
                                scope.periodos = data || [];
                                scope.showGraph = scope.periodos.length != 0;
                                configChartPrincipal();
                            })
                            .catch(() => {
                                if (reqAtual != requestId) return;
                                scope.erroCarregamento = 'Erro ao carregar periodos.';
                            })
                            .finally(() => {
                                if (reqAtual == requestId) scope.loading = false;
                            });
                    }

                    function fornecedorSelecionado($event, filtro) {
                        scope.filtro.rotas = [];
                        scope.filtroFilhos.rotas = [];
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        getPeriodos(scope.filtro);
                    }

                    const eventOnFornecedorSelecionado = scope.$on('onFornecedorSelecionado', fornecedorSelecionado);

                    scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnFornecedorSelecionado();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoOcupacaoPeriodo/graficoOcupacaoPeriodo.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoStatusClasse', ["$filter", "DashTelecomService", function ($filter, DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.exibirFull = false;
                    scope.showGraph = true;
                    scope.chartPrincipal = [];
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: [],
                        rotas: []
                    };
                    scope.corErro = '#d9534f';
                    scope.corSucesso = '#90ee90';
                    scope.corTotal = '#2196F3';

                    scope.showFull = function () {
                        scope.exibirFull = true;
                        getClasseStatus(true);
                    }

                    scope.hideFull = function () {
                        scope.exibirFull = false;
                    }

                    /* Busca as informações de classe que serão exibidas no gráfico da aba de Status,
                    como VC3, LDN, VC1, etc. */
                    function getClasseStatus(showFull) {
                        if (showFull == null) showFull = false;
                        const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = scope.filtro.carteiraId;

                        DashTelecomService.getClasseStatus(dataI, dataF, carteiraId, scope.filtro.fornecedores, scope.filtro.rotas, showFull)
                            .then((data) => {
                                scope.dados = data || [];
                                scope.showGraph = scope.dados.length != 0;
                                configChartPrincipal(showFull);
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    /* Método que altera o filtro do escopo da diretiva para corresponder
                    aos filtros selecionados pelo usuário. Esse método é chamado pelo evento
                    'onChangeFiltro' */
                    function onChangeFiltro($event, filtro) {
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.rotas = filtro.rotas;
                        getClasseStatus();
                    }

                    /* Método que configura o gráfico que é aberto ao expandir as classes */
                    function configChartPrincipal(showFull) {
                        // try{
                        // AmCharts.clear();
                        // }catch(e){}

                        setTimeout(() => {

                            if (showFull == null) showFull = false;
                            let chart = showFull ? "chartprincipal-status-classe-full" : "chartprincipal-status-classe";
                            scope.chartPrincipal = AmCharts.makeChart(chart, {
                                "language": "pt",
                                "type": "serial",
                                "theme": "light",
                                "numberFormatter": {
                                    precision: -1,
                                    decimalSeparator: ",",
                                    thousandsSeparator: "."
                                },
                                "chartCursor": {
                                    "enabled": true,
                                    "fullWidth": true,
                                    "oneBalloonOnly": true
                                },
                                "legend": {
                                    "position": "bottom",
                                    "color": "#ffffff",
                                    "marginLeft": 20,
                                    "marginTop": 0,
                                    "marginRight": 0,
                                    "markerSize": 10,
                                    "autoMargins": false,
                                    "equalWidths": false,
                                    "spacing": 1,
                                    "verticalGap": 0,
                                    "data": [
                                        { title: "Sucesso", color: scope.corSucesso },
                                        { title: "Insucesso", color: scope.corErro }
                                    ]
                                },
                                "valueAxes": [{
                                    "stackType": "regular",
                                    "axisAlpha": 0.3,
                                    "gridAlpha": 0,
                                    "axisColor": "#fff",
                                    "color": "#ffffff"
                                }],
                                "dataProvider": scope.dados,
                                "usePrefixes": true,
                                "graphs": [{
                                    "balloonFunction": function (item) {
                                        let texto = "<b>" + item.category + "</b><br>";
                                        texto += "<span style='font-size:14px'>Total: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Total) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Sucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Sucesso) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Insucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Insucesso) + "</b></span><br>";
                                        return texto;
                                    },
                                    "fillAlphas": 1,
                                    "labelText": "[[percents]]%",
                                    "lineAlpha": 0.3,
                                    "title": "Sucesso",
                                    "type": "column",
                                    "color": "#fff",
                                    "valueField": "Sucesso",
                                    "fontSize": 10,
                                    "fillColors": scope.corSucesso,
                                    "lineColor": scope.corSucesso
                                }, {
                                    "balloonFunction": function (item) {
                                        let texto = "<b>" + item.category + "</b><br>";
                                        texto += "<span style='font-size:14px'>Total: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Total) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Sucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Sucesso) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Insucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Insucesso) + "</b></span><br>";
                                        return texto;
                                    },
                                    "fillAlphas": 1,
                                    "labelText": "[[percents]]%",
                                    "lineAlpha": 0.3,
                                    "title": "Insucesso",
                                    "type": "column",
                                    "color": "#fff",
                                    "fontSize": 10,
                                    "valueField": "Insucesso",
                                    "fillColors": scope.corErro,
                                    "lineColor": scope.corErro
                                }, {
                                    "showBalloon": false,
                                    "valueField": "Total",
                                    "color": "#ffffff",
                                    "labelText": "[[value]]",
                                    "visibleInLegend": false,
                                    "lineAlpha": 0,
                                    "fontSize": 10,
                                    "labelRotation": 0,
                                    "labelOffset": 10
                                }],
                                "categoryField": "Classe",
                                "categoryAxis": {
                                    "gridPosition": "start",
                                    "axisAlpha": 0,
                                    "gridAlpha": 0,
                                    "position": "left",
                                    "color": "#ffffff",
                                    "axisColor": "#fff",
                                    "labelRotation": 0
                                },
                                "export": {
                                    "enabled": false
                                }
                            });

                        }, 1000);


                    }

                    const eventOnChangeFiltro = scope.$on('onChangeFiltro', onChangeFiltro);

                    scope.$on('$destroy', function () {
                        // try{
                        // AmCharts.clear();
                        // }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnChangeFiltro();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoStatusClasse/graficoStatusClasse.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoStatusLocalidade', ["$filter", "DashTelecomService", function ($filter, DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.exibirFull = false;
                    scope.showGraph = true;
                    scope.chartPrincipal = [];
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: [],
                        rotas: []
                    };
                    scope.corErro = '#d9534f';
                    scope.corSucesso = '#90ee90';
                    scope.corTotal = '#2196F3';

                    scope.showFull = function () {
                        scope.exibirFull = true;
                        getDDDStatus(true);
                    }

                    scope.hideFull = function () {
                        scope.exibirFull = false;
                    }

                    scope.mostrarDetalhes = function () {
                        $('#myModal').modal('show');
                    }

                    /* Busca as informações de localidade que serão exibidas no gráfico da aba
                    de Status. */
                    function getDDDStatus(showFull) {
                        if (showFull == null) showFull = false;
                        const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = scope.filtro.carteiraId;

                        DashTelecomService.getDDDStatus(dataI, dataF, carteiraId, scope.filtro.fornecedores, scope.filtro.rotas, showFull)
                            .then((data) => {
                                scope.dados = data || [];
                                scope.showGraph = scope.dados.length != 0;
                                configChartPrincipal(showFull);
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    /* Método que altera o filtro do escopo da diretiva para corresponder
                    aos filtros selecionados pelo usuário. Esse método é chamado pelo evento
                    'onChangeFiltro' */
                    function onChangeFiltro($event, filtro) {
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.rotas = filtro.rotas;
                        getDDDStatus();
                    }

                    /* Método que configura o gráfico que é aberto ao expandir as informações
                    de localidade */
                    function configChartPrincipal(showFull) {
                        // try{
                        // AmCharts.clear();
                        // }catch(e){}

                        setTimeout(() => {
                            if (showFull == null) showFull = false;
                            let chart = showFull ? "chartprincipal-status-localidade-full" : "chartprincipal-status-localidade";
                            scope.chartPrincipal = AmCharts.makeChart(chart, {
                                "language": "pt",
                                "type": "serial",
                                "theme": "light",
                                "numberFormatter": {
                                    precision: -1,
                                    decimalSeparator: ",",
                                    thousandsSeparator: "."
                                },
                                "chartCursor": {
                                    "enabled": true,
                                    "fullWidth": true,
                                    "oneBalloonOnly": true
                                },
                                "usePrefixes": true,
                                "legend": {
                                    "position": "bottom",
                                    "color": "#ffffff",
                                    "marginLeft": 20,
                                    "marginTop": 0,
                                    "marginRight": 0,
                                    "markerSize": 10,
                                    "autoMargins": false,
                                    "equalWidths": false,
                                    "spacing": 1,
                                    "verticalGap": 0,
                                    "data": [
                                        { title: "Sucesso", color: scope.corSucesso },
                                        { title: "Insucesso", color: scope.corErro }
                                    ]
                                },
                                "valueAxes": [{
                                    "stackType": "regular",
                                    "axisAlpha": 0.3,
                                    "gridAlpha": 0,
                                    "axisColor": "#fff",
                                    "color": "#ffffff"
                                }],
                                "dataProvider": scope.dados,
                                "graphs": [{
                                    "balloonFunction": function (item) {
                                        let texto = "<b>DDD " + (item.category < 10 ? "0" + item.category : item.category) + "</b><br>";
                                        texto += "<span style='font-size:14px'>Total: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Total) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Sucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Sucesso) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Insucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Insucesso) + "</b></span><br>";
                                        return texto;
                                    },
                                    "fillAlphas": 1,
                                    "labelText": "[[percents]]%",
                                    "lineAlpha": 0.3,
                                    "fontSize": scope.exibirFull ? 7 : 10,
                                    "title": "Sucesso",
                                    "type": "column",
                                    "color": "#000",
                                    "valueField": "Sucesso",
                                    "fillColors": scope.corSucesso,
                                    "lineColor": scope.corSucesso,
                                }, {
                                    "balloonFunction": function (item) {
                                        let texto = "<b>DDD " + (item.category < 10 ? "0" + item.category : item.category) + "</b><br>";
                                        texto += "<span style='font-size:14px'>Total: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Total) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Sucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Sucesso) + "</b></span><br>";
                                        texto += "<span style='font-size:14px'>Insucesso: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Insucesso) + "</b></span><br>";
                                        return texto;
                                    },
                                    "fillAlphas": 1,
                                    "labelText": "[[percents]]%",
                                    "lineAlpha": 0.3,
                                    "fontSize": scope.exibirFull ? 7 : 10,
                                    "title": "Insucesso",
                                    "type": "column",
                                    "color": "#fff",
                                    "valueField": "Insucesso",
                                    "labelRotation": 0,
                                    "fillColors": scope.corErro,
                                    "lineColor": scope.corErro,
                                    "labelPosition": scope.exibirFull == true ? "middle" : "top"
                                }, {
                                    "showBalloon": false,
                                    "valueField": "Total",
                                    "color": "#ffffff",
                                    "labelText": "[[value]]",
                                    "visibleInLegend": false,
                                    "lineAlpha": 0,
                                    "fontSize": 10,
                                    "labelRotation": 315,
                                    "labelOffset": scope.exibirFull ? 10 : 30
                                }],
                                "categoryField": "DDD",
                                "categoryAxis": {
                                    "gridPosition": "start",
                                    "axisAlpha": 0,
                                    "gridAlpha": 0,
                                    "position": "left",
                                    "color": "#ffffff",
                                    "axisColor": "#fff",
                                    "labelFunction": (valueText) => valueText < 10 ? "0" + valueText : valueText,
                                    "labelRotation": 45,
                                    "autoGridCount": false,
                                    "gridCount": scope.dados.length
                                },
                                "export": {
                                    "enabled": false
                                }
                            });
                        }, 1000)


                    }

                    const eventOnChangeFiltro = scope.$on('onChangeFiltro', onChangeFiltro);

                    scope.$on('$destroy', function () {
                        // try{
                        // AmCharts.clear();
                        // }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnChangeFiltro();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoStatusLocalidade/graficoStatusLocalidade.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoStatusPeriodo', ["$rootScope", "DashTelecomService", function ($rootScope, DashTelecomService) {
            return {
                restrict: 'E',
                scope: {},
                link: function (scope) {
                    let filtroFilhos = {
                        fornecedores: [],
                        rotas: []
                    }
                    scope.chartPrincipal = [];
                    scope.showGraph = true;
                    scope.zoomAtivo = false;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: []
                    };
                    scope.corErro = '#d9534f';
                    scope.corSucesso = '#90ee90';
                    scope.corTotal = '#2196F3';

                    scope.selecionarPeriodo = function ($event, periodo) {
                        if (filtroFilhos.fornecedores == null)
                            filtroFilhos.fornecedores = [];
                        if (filtroFilhos.rotas == null)
                            filtroFilhos.rotas = [];
                        if ($event.target.type != 'checkbox')
                            periodo.checked = !periodo.checked;
                        if (periodo.checked) {
                            filtroFilhos.rotas.push(periodo.Id);
                        } else {
                            filtroFilhos.rotas = filtroFilhos.rotas.filter(value => {
                                return (value != periodo.Id);
                            });
                        }
                        filtroFilhos.dataInicio = scope.filtro.dataInicio;
                        filtroFilhos.dataFim = scope.filtro.dataFim;

                        $rootScope.$broadcast('onRotaSelecionada', periodo);
                        notificarFiltro();
                    }

                    scope.maisZoom = function (chart) {
                        chart.zoomToIndexes(chart.startIndex + 20, chart.endIndex - 20);
                    }

                    scope.menosZoom = function (chart) {
                        chart.zoomToIndexes(chart.startIndex - 20, chart.endIndex + 20);
                    }

                    scope.limparZoom = function (chart) {
                        chart.zoomOut();
                    }

                    /* Método que emite um evento para notificar as demais diretivas da dash sobre 
                    mudanças no filtro de rota */
                    function notificarFiltro() {
                        $rootScope.$broadcast('onChangeFiltro', filtroFilhos);
                    }

                    /* Método que configura o gráfico que exibido no início da dash, com informações
                    gerais dos períodos */
                    function configChartPrincipal() {
                        // NAO chamar AmCharts.clear() aqui: a funcao e GLOBAL e destroi
                        // TODOS os charts da pagina (mapa de localidade, outros graficos).
                        // Limpeza correta fica apenas no $destroy.
                        scope.chartPrincipal = [];
                        setTimeout(() => {
                            for (var i = 0; i < scope.periodos.length; i++) {
                                let dataIm = moment(scope.filtro.dataInicio);
                                let dataFm = moment(scope.filtro.dataFim);
                                let difference = dataFm.diff(dataIm, 'days');
                                let balloonDateFormat = "DD/MM JJ:NN";
                                let minPeriod = '';
                                let periodos = [];
                                if (difference > 90) {
                                    balloonDateFormat = "MMMM YY";
                                    minPeriod = '1MM';
                                    scope.zoomAtivo = false;
                                } else if (difference > 3) {
                                    balloonDateFormat = "DD/MM, EEEE";
                                    minPeriod = '1DD';
                                    scope.zoomAtivo = false;
                                } else {
                                    balloonDateFormat = "DD/MM JJ:NN";
                                    minPeriod = '5mm';
                                    scope.zoomAtivo = true;
                                }

                                scope.periodos.forEach(periodo => {
                                    if (periodo.Lista.length > 0) {
                                        periodos.push(periodo);
                                    }
                                });

                                scope.chartPrincipal.push(AmCharts.makeChart("chartprincipal-status-" + i, {
                                    "type": "serial",
                                    "theme": "light",
                                    "marginRight": 0,
                                    "language": "pt",
                                    "autoMarginOffset": 0,
                                    "numberFormatter": {
                                        precision: -1,
                                        decimalSeparator: ",",
                                        thousandsSeparator: "."
                                    },
                                    "legend": {
                                        "equalWidths": false,
                                        "periodValueText": "Sucesso: [[value.sum]]",
                                        "position": "right",
                                        "valueAlign": "left",
                                        "marginRight": 0,
                                        "horizontalGap": 0,
                                        "color": "#fff",
                                        "markerSize": 10,
                                        "data": [
                                            { title: "Sucesso", color: scope.corTotal },
                                            { title: "Insucesso", color: scope.corErro }
                                        ]
                                    },
                                    "dataProvider": scope.periodos[i].Lista,
                                    "graphs": [{
                                        "balloonText": "Sucesso: <b>[[value]]</b>",
                                        "fillAlphas": 1,
                                        "lineAlpha": 0.4,
                                        "title": "Sucesso",
                                        "valueField": "Total",
                                        "fillColors": scope.corTotal,
                                        "lineColor": scope.corTotal
                                    }, {
                                        "balloonText": "Insucesso: <b>[[value]]</b>",
                                        "fillAlphas": 1,
                                        "lineAlpha": 0.4,
                                        "title": "Insucesso",
                                        "valueField": "Insucesso",
                                        "fillColors": scope.corErro,
                                        "lineColor": scope.corErro
                                    }],
                                    "valueAxes": [{
                                        "stackType": "regular",
                                        "gridAlpha": 0.07,
                                        "position": "left",
                                        "title": "Ligações",
                                        "axisColor": "#fff",
                                        "color": "#fff",
                                        "titleColor": "#fff",
                                        "titleBold": false
                                    }],
                                    "plotAreaBorderAlpha": 0,
                                    "marginTop": 10,
                                    "marginLeft": 20,
                                    "zoomOutText": "",
                                    "marginBottom": 0,
                                    "chartCursor": {
                                        "valueLineEnabled": true,
                                        "valueLineBalloonEnabled": true,
                                        "cursorAlpha": 1,
                                        "cursorColor": "#258cbb",
                                        "valueLineAlpha": 0.2,
                                        "selectWithoutZooming": false,
                                        "categoryBalloonDateFormat": balloonDateFormat,
                                        "zoomed": false
                                    },
                                    "categoryField": "Data",
                                    "categoryAxis": {
                                        "parseDates": true,
                                        "gridAlpha": 0.07,
                                        "axisColor": "#fff",
                                        "color": "#fff",
                                        "minPeriod": minPeriod,
                                    },
                                    "export": {
                                        "enabled": false
                                    }
                                }));
                            }

                        }, 1000);
                    }

                    /* Restaura os filtros que são usados para lógica interna do controller para os
                    valores que estão configurados no escopo da diretiva */
                    function limparFiltroFilhos() {
                        filtroFilhos = {
                            fornecedores: [],
                            rotas: []
                        }
                        filtroFilhos.dataInicio = scope.filtro.dataInicio;
                        filtroFilhos.dataFim = scope.filtro.dataFim;
                        filtroFilhos.carteiraId = scope.filtro.carteiraId;
                        if (scope.filtro.fornecedores != null)
                            filtroFilhos.fornecedores = scope.filtro.fornecedores;

                        notificarFiltro();
                    }

                    // requestId protege contra race conditions: se o usuario muda o filtro
                    // varias vezes rapidamente, apenas o resultado do request mais recente
                    // e renderizado, descartando os anteriores.
                    let requestId = 0;

                    /* Busca as informações de períodos que serão usados para popular o primeiro
                    gráfico da aba de Status */
                    function getPeriodos(filtro) {
                        scope.periodos = null;
                        scope.periodosAgrupado = null;
                        scope.loading = true;
                        scope.erroCarregamento = null;
                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = scope.filtro.carteiraId;
                        requestId++;
                        const reqAtual = requestId;

                        DashTelecomService.getStatusPeriodos(dataI, dataF, carteiraId, filtro.fornecedores)
                            .then((data) => {
                                if (reqAtual != requestId) return;
                                limparFiltroFilhos();
                                scope.periodos = JSON.parse(JSON.stringify(data || []));
                                scope.showGraph = scope.periodos.length != 0;
                                configChartPrincipal();
                            })
                            .catch(() => {
                                if (reqAtual != requestId) return;
                                scope.erroCarregamento = 'Erro ao carregar periodos.';
                            })
                            .finally(() => {
                                if (reqAtual == requestId) scope.loading = false;
                            });
                    }

                    /* Método que é chamado pelo evento 'onFornecedorSelecionado' para alterar o 
                    filtro de fornecedores do escopo local quando um fornecedor for selecionado */
                    function fornecedorSelecionado($event, filtro) {
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        getPeriodos(scope.filtro);
                    }

                    const eventOnFornecedorSelecionado = scope.$on('onFornecedorSelecionado', fornecedorSelecionado);

                    scope.$on('$destroy', function () {
                        try{
                        AmCharts.clear();
                        }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnFornecedorSelecionado();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoStatusPeriodo/graficoStatusPeriodo.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('graficoStatusRelease', ["$filter", "DashTelecomService", function ($filter, DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.exibirFull = false;
                    scope.showGraph = true;
                    scope.chartPrincipal = [];
                    scope.corErro = '#d9534f';
                    scope.corSucesso = '#90ee90';
                    scope.corTotal = '#2196F3';
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: [],
                        rotas: []
                    };

                    scope.showFull = function () {
                        scope.exibirFull = true;
                        getReleasesStatus(true);
                    }

                    scope.hideFull = function () {
                        scope.exibirFull = false;
                    }

                    /* Busca as informações de release que serão exibidas no gráfico da aba de Status,
                    como: service unavailable, normal call clearing, etc. */
                    function getReleasesStatus(showFull) {
                        if (showFull == null) showFull = false;
                        const dataI = moment(scope.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(scope.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = scope.filtro.carteiraId;

                        DashTelecomService.getReleasesStatus(dataI, dataF, carteiraId, scope.filtro.fornecedores, scope.filtro.rotas, showFull)
                            .then((data) => {
                                scope.dados = data || [];
                                scope.showGraph = scope.dados.length != 0;
                                configChartPrincipal(showFull);
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    /* Método que altera o filtro do escopo da diretiva para corresponder
                    aos filtros selecionados pelo usuário. Esse método é chamado pelo evento
                    'onChangeFiltro' */
                    function onChangeFiltro($event, filtro) {
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.rotas = filtro.rotas;
                        getReleasesStatus();
                    }

                    /* Método que configura o gráfico que é aberto ao expandir as informações
                    de release */
                    function configChartPrincipal(showFull) {
                        // try{
                        // AmCharts.clear();
                        // }catch(e){}

                        setTimeout(() => {

                            if (showFull == null) showFull = false;
                            let chart = showFull ? "chartprincipal-status-release-full" : "chartprincipal-status-release";
                            scope.total = $filter('thousandSeparator')(scope.dados.reduce((inicial, currentValue) => inicial + currentValue.Total, 0));
                            scope.chartPrincipal = AmCharts.makeChart(chart, {
                                "language": "pt",
                                "type": "serial",
                                "theme": "light",
                                "marginBottom": 50,
                                "numberFormatter": {
                                    precision: -1,
                                    decimalSeparator: ",",
                                    thousandsSeparator: "."
                                },
                                "valueAxes": [{
                                    "stackType": "regular",
                                    "axisAlpha": 0.3,
                                    "gridAlpha": 0,
                                    "axisColor": "#fff",
                                    "color": "#ffffff"
                                }],
                                "usePrefixes": true,
                                "dataProvider": scope.dados,
                                "graphs": [{
                                    "balloonFunction": function (item) {
                                        return "<b>" + item.dataContext.Release + "</b><br><span style='font-size:14px'>Total: <b>" + $filter('thousandSeparator')(item.serialDataItem.dataContext.Total) + "</b></span><br>";
                                    },
                                    "fillAlphas": 1,
                                    "lineAlpha": 0.3,
                                    "title": "Total",
                                    "type": "column",
                                    "color": "#000000",
                                    "fontSize": 10,
                                    "valueField": "Total",
                                    "fillColors": scope.corTotal,
                                    "lineColor": scope.corTotal
                                }, {
                                    "showBalloon": false,
                                    "valueField": "Total",
                                    "color": "#ffffff",
                                    "labelText": "[[value]]",
                                    "visibleInLegend": false,
                                    "lineAlpha": 0,
                                    "fontSize": 10,
                                    "labelRotation": 315,
                                    "labelOffset": 10
                                }],
                                "chartCursor": {
                                    enabled: true,
                                    fullWidth: true,
                                },
                                "categoryField": "Codigo",
                                "categoryAxis": {
                                    "gridPosition": "start",
                                    "axisAlpha": 0,
                                    "gridAlpha": 0,
                                    "position": "left",
                                    "color": "#ffffff",
                                    "axisColor": "#fff",
                                },
                                "export": {
                                    "enabled": false
                                }
                            });

                        }, 1000)

                    }

                    const eventOnChangeFiltro = scope.$on('onChangeFiltro', onChangeFiltro);

                    scope.$on('$destroy', function () {
                        // try{
                        // AmCharts.clear();
                        // }catch(e){}
                        scope.chartPrincipal = [];
                        eventOnChangeFiltro();
                    });
                },
                templateUrl: '../app_dash/pages/dashTelecom/graficoStatusRelease/graficoStatusRelease.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('chamadas', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.sinalizacao = {};
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        fornecedores: []
                    };

                    function sinalizacaoProtocolo($event, dados) {
                        scope.chamadas = dados;
                    }

                    const eventOnChamadas = scope.$on('onChamadas', sinalizacaoProtocolo);

                    scope.$on('$destroy', () => eventOnChamadas());
                },
                templateUrl: '../app_dash/pages/dashTelecom/sinalizacao/chamadas.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('qualidade', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.sinalizacao = {};
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        fornecedores: []
                    };

                    function sinalizacaoProtocolo($event, dados) {
                        scope.chamadas = dados;
                    }

                    const eventOnQualidade = scope.$on('onQualidade', sinalizacaoProtocolo);

                    scope.$on('$destroy', () => eventOnQualidade());
                },
                templateUrl: '../app_dash/pages/dashTelecom/sinalizacao/qualidade.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('sinalizacao', ["$rootScope", "DashTelecomService", function ($rootScope, DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.sinalizacao = [];
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: []
                    };

                    function fornecedorSelecionado($event, filtro) {
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.rotas = filtro.rotas;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        getOcupacaoSinalizacao(scope.filtro);
                    }

                    function getOcupacaoSinalizacao(filtro) {
                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = filtro.carteiraId;

                        DashTelecomService.getOcupacaoSinalizacao(dataI, dataF, carteiraId, filtro.fornecedores, filtro.rotas)
                            .then((data) => {
                                scope.sinalizacao = data || [];
                                if (scope.sinalizacao.length > 1) $rootScope.$broadcast('onQualidade', scope.sinalizacao[1]);
                                if (scope.sinalizacao.length > 2) $rootScope.$broadcast('onChamadas', scope.sinalizacao[2]);

                                $('.animate-progress-bar').each(function () {
                                    $(this).css('width', $(this).attr("data-percentage"));
                                });
                            })
                            .catch(() => { /* mantem dados anteriores */ });
                    }

                    const eventOnFornecedorSelecionado = scope.$on('onFornecedorSelecionado', fornecedorSelecionado);
                    const eventOnOcupacaoFornecedorRotaSelecionado = scope.$on('onOcupacaoFornecedorRotaSelecionado', function ($event, filtro) {
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.rotas = filtro.rotas;
                        getOcupacaoSinalizacao(scope.filtro);
                    });

                    function destroyEventListeners() {
                        eventOnFornecedorSelecionado();
                        eventOnOcupacaoFornecedorRotaSelecionado();
                    }

                    scope.$on('$destroy', () => destroyEventListeners())
                },
                templateUrl: '../app_dash/pages/dashTelecom/sinalizacao/sinalizacao.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('sinalizacaoprotocolo', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.sinalizacao = {};
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        fornecedores: []
                    };

                    function sinalizacaoProtocolo($event, dados) {
                        scope.sinalizacao = dados;
                    }

                    const eventOnSinalizacaoProtocolo = scope.$on('onSinalizacaoProtocolo', sinalizacaoProtocolo);

                    scope.$on('$destroy', () => eventOnSinalizacaoProtocolo());
                },
                templateUrl: '../app_dash/pages/dashTelecom/sinalizacao/sinalizacaoprotocolo.html'
            };
        });
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('tronco', ["DashTelecomService", function (DashTelecomService) {
            return {
                restrict: 'E',
                transclude: true,
                scope: {},
                link: function (scope) {
                    scope.showGraph = true;
                    scope.filtro = {
                        dataFim: new Date(),
                        dataInicio: new Date(),
                        carteiraId: null,
                        fornecedores: []
                    };
                    scope.ordenado = {
                        key: '',
                        direcao: ''
                    }

                    scope.ordenarPor = function (key, direcao) {
                        function ordernar(el) {
                            return direcao == 'asc' ? el[key] : -el[key];
                        };

                        if (scope.servicos.length > 0) {
                            scope.servicos.forEach((servico) => {
                                servico.Classes = _.sortBy(servico.Classes, ordernar);
                                servico.Rotas = _.sortBy(servico.Rotas, ordernar);
                                servico.DDDs = _.sortBy(servico.DDDs, ordernar);
                            });
                        } else if (scope.fornecedores.length > 0) {
                            scope.fornecedores.forEach((fornecedor) => {
                                fornecedor.Classes = _.sortBy(fornecedor.Classes, ordernar);
                                fornecedor.Rotas = _.sortBy(fornecedor.Rotas, ordernar);
                                fornecedor.Servicos = _.sortBy(fornecedor.Servicos, ordernar);
                                fornecedor.Campanhas = _.sortBy(fornecedor.Campanhas, ordernar);
                            });
                        }
                        scope.ordenado.key = key;
                        scope.ordenado.direcao = direcao;
                    }

                    function fornecedorSelecionado($event, filtro) {
                        scope.filtro.fornecedores = filtro.fornecedores;
                        scope.filtro.dataInicio = filtro.dataInicio;
                        scope.filtro.dataFim = filtro.dataFim;
                        scope.filtro.carteiraId = filtro.carteiraId;
                        getTroncos(scope.filtro);
                    }

                    function getTroncos(filtro) {
                        const dataI = moment(filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                        const dataF = moment(filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                        const carteiraId = filtro.carteiraId;

                        DashTelecomService.getTroncos(dataI, dataF, carteiraId, filtro.fornecedores)
                            .then((data) => {
                                data = data || [];
                                scope.showGraph = data.length > 0;
                                if (filtro.fornecedores != null && filtro.fornecedores.length == 1) {
                                    scope.servicos = data;
                                    scope.fornecedores = [];
                                    obterTotaisServicos();
                                } else {
                                    scope.fornecedores = data;
                                    scope.servicos = [];
                                    obterTotaisFornecedores(scope.fornecedores.filter((fornecedor) => {
                                        return fornecedor.Servicos.length > 0
                                    }));
                                }
                                scope.ordenarPor('Insucesso', 'desc');

                                $('.animate-progress-bar').each(function () {
                                    $(this).css('width', $(this).attr("data-percentage"));
                                });
                                $('[data-toggle="tooltip"]').tooltip();
                            })
                            .catch(() => { scope.showGraph = false; });
                    }

                    function sumSuccessAndFail(initialValue, current) {
                        return {
                            Sucesso: current.Sucesso + initialValue.Sucesso,
                            Insucesso: current.Insucesso + initialValue.Insucesso
                        };
                    }

                    function obterTotaisFornecedores(fornecedores) {
                        scope.totalDDDs = fornecedores
                            .map((collection) => {
                                return collection.DDDs.reduce(sumSuccessAndFail, {
                                    Sucesso: 0,
                                    Insucesso: 0
                                });
                            }).reduce(sumSuccessAndFail, { Sucesso: 0, Insucesso: 0 });


                        scope.totalRota = fornecedores
                            .map((collection) => {
                                return collection.Rotas.reduce(sumSuccessAndFail, {
                                    Sucesso: 0,
                                    Insucesso: 0
                                });
                            }).reduce(sumSuccessAndFail, { Sucesso: 0, Insucesso: 0 });

                        scope.totalServico = fornecedores
                            .map((collection) => {
                                return collection.Servicos.reduce(sumSuccessAndFail, {
                                    Sucesso: 0,
                                    Insucesso: 0
                                });
                            }).reduce(sumSuccessAndFail, { Sucesso: 0, Insucesso: 0 });

                        scope.totalClasses = fornecedores
                            .map((collection) => {
                                return collection.Classes.reduce(sumSuccessAndFail, {
                                    Sucesso: 0,
                                    Insucesso: 0
                                });
                            }).reduce(sumSuccessAndFail, { Sucesso: 0, Insucesso: 0 });

                        scope.totalCampanhas = fornecedores
                            .map((collection) => {
                                return collection.Campanhas.reduce(sumSuccessAndFail, {
                                    Sucesso: 0,
                                    Insucesso: 0
                                });
                            }).reduce(sumSuccessAndFail, { Sucesso: 0, Insucesso: 0 });
                    }

                    function obterTotaisServicos() {
                        scope.servicos.forEach(servico => {
                            servico.TotalRotas = servico.Rotas.reduce(sumSuccessAndFail, {
                                Sucesso: 0,
                                Insucesso: 0
                            });

                            servico.TotalDDDs = servico.DDDs.reduce(sumSuccessAndFail, {
                                Sucesso: 0,
                                Insucesso: 0
                            });

                            servico.TotalClasses = servico.Classes.reduce(sumSuccessAndFail, {
                                Sucesso: 0,
                                Insucesso: 0
                            });
                        });
                    }

                    const eventOnFornecedorSelecionado = scope.$on('onFornecedorSelecionado', fornecedorSelecionado);

                    scope.$on('$destroy', () => eventOnFornecedorSelecionado());
                },
                templateUrl: '../app_dash/pages/dashTelecom/tronco/tronco.html'
            };
        }]);
})();
(function () {
    "use strict";

    angular.module('epbxManagerApp')

        .directive('arvoreFull', function () {
            return {
                restrict: 'E',
                transclude: true,
                scope: {
                    data: '='
                },
                templateUrl: '../app_dash/pages/dashReceptivo/arvore/arvore-full/arvore-full.html',
                controller: ["$q", "UraHelper", "DashboardSupervisaoService", "GrupoResource", "$scope", "$rootScope", "$filter", "DashboardReceptivoService", function ArvoreController($q, UraHelper, DashboardSupervisaoService,
                    GrupoResource, $scope, $rootScope, $filter, DashboardReceptivoService) {
                    let requestId = 0;
                    let grupos = [];
                    let gruposById = {};
                    let promiseIndicadores = [];
                    let alertasPorNo = [];
                    let alertasGlobal = null;
                    let indicadoresGlobal = null;
                    let gruposUra = [];
                    let ramaisUra = [];
                    let ramaisGrupoUra = [];
                    let tamanhoNoX = 170;
                    let tamanhoNoY = 110;
                    let noPorUra = {};
                    let noSelecionado = {};
                    let uraSelecionada = {};
                    let qtdFilaPorRamal = {};
                    let qtdLivrePorRamal = {};
                    let servicoSelecionado = {};
                    // Polling de supervisao (fila/ramais livres). Mantido em 2 min para nao
                    // sobrecarregar o backend; pode ser reduzido se houver demanda real-time.
                    const tempo = 120000;
                    let timerSupervisao = null;
                    $scope.graph = new joint.dia.Graph;
                    $scope.legendaMinimizada = false;
                    $scope.indicadoresLegenda = [];
                    $scope.erroArvoreFull = null;

                    promiseIndicadores.push(DashboardReceptivoService.getIndicadoresArvore($scope.data.filtro.id, $scope.data.filtro.tipo));
                    $scope.data.filtro.dataInicio = moment($scope.data.filtro.dataInicio).format('YYYY-MM-DDTHH:mm:ss');
                    $scope.data.filtro.dataFim = moment($scope.data.filtro.dataFim).format('YYYY-MM-DDTHH:mm:ss');
                    promiseIndicadores.push(DashboardReceptivoService.getArvoreDetalhe($scope.data.filtro.tipo, $scope.data.filtro.id, $scope.data.filtro.dataInicio, $scope.data.filtro.dataFim, $scope.data.filtro.carteiraId, $scope.data.filtro.grupoId));
                    promiseIndicadores.push(GrupoResource.odata().orderBy('Descricao', 'asc').filter("GrupoTipoId", "=", 1).query()
                        .then(data => {
                            grupos = data;
                            _.each(grupos, value => gruposById[value.RamalId] = value);
                        })
                        .catch(() => { grupos = []; gruposById = {}; }));

                    $scope.minimizarLegenda = () => $scope.legendaMinimizada = !$scope.legendaMinimizada;

                    let addClass = (el, className) => $(el).attr("class", el.classList.value + ' ' + className);
                    let removeClass = (el, className) => $(el).attr("class", el.classList.value.replace(className, ''));

                    function recriarArvore() {
                        inicializarPaper();

                        plotArvoreExistente($scope.ura);
                        let widthScreen = $('arvore-full').width() / 2;
                        if ($('#ura-builder-full svg>g')[0].transform.baseVal[0] && $('#ura-builder-full svg g.no-selecionado')[0].transform.baseVal[0]) {
                            let diffx = ($('#ura-builder-full svg>g')[0].transform.baseVal[0].matrix.e + ($('#ura-builder-full svg>g')[0].getBoundingClientRect().width / 2));
                            let xInicio = null;
                            if (diffx > widthScreen) {
                                xInicio = widthScreen - diffx;
                            } else {
                                xInicio = diffx - widthScreen;
                            }
                            let yInicio = $('#ura-builder-full svg g.no-selecionado')[0].transform.baseVal[0].matrix.f - 10;
                            $scope.panAndZoom.pan({ x: -xInicio, y: -yInicio });
                        }
                    }

                    /* Função de retorno das informações de fila e de ramais livres */
                    function atualizarDadosSupervisao(recriaArvore) {
                        if (!recriaArvore) recriaArvore= false;
                        let promisesSupervisao = [];
                        let ramaisIds = [];

                        /* Busca dos ramais de grupo (são usados na requisição de fila e de ramais livres) */
                        gruposUra.forEach(grupoId => {
                            let grupo = grupos.find(g => g.GrupoId == grupoId);
                            if (grupo && !ramaisIds.find(x => x == grupo.RamalId)) ramaisIds.push(grupo.RamalId);
                        });

                        promisesSupervisao.push(DashboardSupervisaoService.getRamaisLivresGrupos(ramaisIds.join(',')).$promise
                            .then(data => qtdLivrePorRamal = data)
                            .catch(() => qtdLivrePorRamal = {}));

                        /* Busca os dados de ramais individuais e ramais de ura (apenas para a requisição de fila) */
                        ramaisUra.forEach(ramalId => {
                            if (ramalId && !ramaisIds.find(x => x == ramalId)) ramaisIds.push(ramalId)
                        });

                        promisesSupervisao.push(DashboardSupervisaoService.getQuantidadeFilaGrupo(ramaisIds.join(',')).$promise
                            .then(data => qtdFilaPorRamal = data)
                            .catch(() => qtdFilaPorRamal = {}));

                        if (recriaArvore === true) {
                            $q.all(promisesSupervisao).then(() => recriarArvore()).catch(() => recriarArvore());
                        }
                    }

                    /* Função inicial para criação do diagrama de árvore, aqui serão feitas as primeiras requisições que são
                    necessárias no processo de população dos indicadores de nós de ura */
                    function getArvore() {
                        requestId++;
                        let requestAtual = requestId;
                        $q.all(promiseIndicadores).then(results => {
                            if (requestAtual != requestId) return;

                            alertasGlobal = results[0]; // Resposta da requisição 'DashboardReceptivoService.getIndicadoresArvore'
                            indicadoresGlobal = results[1]; // Resposta da requisição 'DashboardReceptivoService.getArvoreDetalhe'

                            if ($scope.data.filtro.tipo == 1) {
                                $scope.ura = $scope.data.arvore;
                                recriarReferenciaPai($scope.ura);
                                uraSelecionada = $scope.ura;
                                servicoSelecionado = null;

                                /* Realiza as requisições de filas e ramais livres dos grupos e recria a árvore */
                                atualizarDadosSupervisao(true);

                                /* Agenda atualizacao periodica da supervisao */
                                agendarProximoTickSupervisao();
                            } else if ($scope.data.filtro.tipo == 2) {
                                /* Modo servico: desenha apenas o no raiz com a descricao */
                                $scope.ura = null;
                                uraSelecionada = null;
                                servicoSelecionado = $scope.data.arvore;
                                inicializarPaper();
                                if (servicoSelecionado) {
                                    plotNo(0, 0, tamanhoNoX, tamanhoNoY,
                                        (servicoSelecionado.Descricao || '') + ' (Raiz)', 'servico', null, null);
                                }
                            }
                        }).catch(function (error) {
                            if (requestAtual != requestId) return;
                            $scope.erroArvoreFull = (error && error.status === 404)
                                ? 'Sem acesso ao item selecionado.'
                                : 'Erro ao carregar a arvore.';
                        });
                    }

                    function agendarProximoTickSupervisao() {
                        if (timerSupervisao != null) clearTimeout(timerSupervisao);
                        timerSupervisao = setTimeout(getDadosSupervisao, tempo);
                    }

                    function setTextoSeguro(seletor, valor) {
                        // Atualiza innerHTML de elemento SVG com guard — o no pode ter sido
                        // removido entre o tick anterior e este (troca de URA, destroy, etc).
                        const elementos = $(seletor);
                        if (elementos.length > 0 && elementos[0]) {
                            elementos[0].innerHTML = valor;
                        }
                    }

                    function getDadosSupervisao() {
                        atualizarDadosSupervisao();

                        /* Atualização dos balões dos indicadores de quantidade de ramais livres */
                        for (let key in qtdLivrePorRamal) {
                            let ramalId = parseInt(key);
                            let qtdLivre = parseInt(qtdLivrePorRamal[key]);
                            if (Number.isInteger(ramalId)) {
                                let ramalGrupoUra = ramaisGrupoUra.find(x => x.RamalId == ramalId);
                                if (ramalGrupoUra && ramalGrupoUra.UraId > 0) {
                                    let no = noPorUra[ramalGrupoUra.UraId];
                                    if (no) {
                                        let qtd = isNaN(qtdLivre) ? 0 : qtdLivre;
                                        setTextoSeguro('g[model-id="' + no.id + '"] .livre text', qtd);
                                    }
                                }
                            }
                        }

                        /* Atualização dos balões dos indicadores de quantidade de fila */
                        for (let key in qtdFilaPorRamal) {
                            let ramalId = parseInt(key);
                            let qtdFila = parseInt(qtdFilaPorRamal[key]);
                            if (Number.isInteger(ramalId)) {
                                let ramalGrupoUra = ramaisGrupoUra.find(x => x.RamalId == ramalId);
                                if (ramalGrupoUra && ramalGrupoUra.UraId > 0) {
                                    let no = noPorUra[ramalGrupoUra.UraId];
                                    if (no) {
                                        let qtd = isNaN(qtdFila) ? 0 : qtdFila;
                                        setTextoSeguro('g[model-id="' + no.id + '"] .fila text', qtd);
                                    }
                                }
                            }
                        }

                        agendarProximoTickSupervisao();
                    }

                    /* Inicialização do diagrama de árvore */
                    function inicializarPaper() {
                        $scope.graph = new joint.dia.Graph;
                        $('#ura-builder-full').html('');
                        $scope.paper = new joint.dia.Paper({
                            el: $('#ura-builder-full'),
                            model: $scope.graph,
                            gridSize: 1,
                            width: 3000,
                            height: 3000,
                            perpendicularLinks: true,
                            restrictTranslate: true,
                        });
                        $scope.mensagemAlertas = '';
                        $scope.paper.on('element:pointerup', (elementView, evt) => {
                            if (V(evt.target).hasClass('erro')) {
                                let alertas = _.filter(alertasPorNo, el => el.no == elementView.attributes()['model-id']);
                                if (alertas != null && alertas.length > 0) {
                                    $scope.mensagemAlertas = ''
                                    for (let i = 0; i < alertas.length; i++) {
                                        $scope.mensagemAlertas += '<tr>';
                                        $scope.mensagemAlertas += '<td class="td-principal">' + alertas[i].IndicadorNome + '</td>';
                                        $scope.mensagemAlertas += '<td class="danger">' + alertas[i].ValorAtual + '</td>';
                                        $scope.mensagemAlertas += '<td>' + alertas[i].Condicao + '</td>';
                                        $scope.mensagemAlertas += '</tr>';
                                    }
                                    $('#table-alertas').html($scope.mensagemAlertas);
                                    let modal = UIkit.modal("#alertas-modal");
                                    if (!modal.isActive()) modal.show();
                                }
                            } else if (V(evt.target).hasClass('card')) {
                                if (uraSelecionada != null) {
                                    limparSelecionado();
                                    addClass(elementView.$el[0], 'no-selecionado');
                                    noSelecionado = elementView.model;
                                    let ura = UraHelper.buscarNoemUra($scope.ura, $scope.noSelecionado);
                                    if (ura != uraSelecionada) uraSelecionada = ura;
                                    $scope.$apply();
                                } else {
                                    let servico = servicoSelecionado;
                                    limparSelecionado();
                                    servicoSelecionado = servico;
                                    addClass(elementView.$el[0], 'no-selecionado');
                                    noSelecionado = elementView.model;
                                }
                            }
                        });

                        let paperContainer = $('#ura-builder-full')[0];

                        $scope.panAndZoom = svgPanZoom(paperContainer.childNodes[0], {
                            viewportSelector: paperContainer.childNodes[0].childNodes[0],
                            fit: false,
                            zoomScaleSensitivity: 0.4,
                            panEnabled: false,
                            center: false
                        });

                        $scope.paper.on('blank:pointerdown', () => $scope.panAndZoom.enablePan());
                        $scope.paper.on('cell:pointerup blank:pointerup', () => $scope.panAndZoom.disablePan());
                    }

                    /* Construção dos nós no diagrama de árvore */
                    function plotNo(x, y, width, height, descricao, tipoUra, alertas, indicadores, qtdFila, qtdLivre) {
                        let tipoSVG = '';
                        let indicadoresText = '';
                        /* Configurações básicas de todas as células que serão usadas nas construções de nós no diagrama */
                        let cellObj = {
                            size: {
                                width: width,
                                height: height
                            },
                            position: {
                                x: x * 1.4,
                                y: y
                            },
                            attrs: {
                                '.card': {
                                    'rx': 0,
                                    'ry': 0,
                                    'stroke': 'none',
                                    fill: '#f2f2f2'
                                },
                                '.descricao': {
                                    text: (descricao != null && descricao.length > 20) ? descricao.substr(0, 14) + '...' : descricao,
                                    'font-family': 'Roboto,sans-serif',
                                    'font-size': 11,
                                    'font-weight': 700,
                                    'word-spacing': '-1px',
                                    'letter-spacing': 0,
                                    'text-decoration': 'none',
                                    'ref-y': 10,
                                    'ref-x': 30,
                                },
                                'g.erro': {
                                    'ref-x': width + 10,
                                    'ref-y': 5,
                                    cursor: 'pointer'
                                },
                                'g.erro>circle': {
                                    r: 20,
                                    'stroke-width': 2,
                                    fill: '#0ea72c',
                                    stroke: '#ffffff',
                                },
                                'g.erro>text': {
                                    'font-size': 18,
                                    'font-weight': 800,
                                    fill: '#ffffff',
                                    'font-family': 'Roboto,sans-serif',
                                    'text-anchor': 'middle',
                                    x: 0,
                                    y: 15,
                                },
                                'g.erro>.icon-erro': {
                                    'ref-x': -9,
                                    'ref-y': -17,
                                },
                                '.icon': {
                                    'ref-x': 3,
                                    'ref-y': 3,
                                },
                                'g.fila': {
                                    'ref-x': width + 10,
                                    'ref-y': 57,
                                    cursor: 'pointer'
                                },
                                'g.fila>circle': {
                                    r: 20,
                                    'stroke-width': 2,
                                    fill: '#e67000',
                                    stroke: '#ffffff',
                                },
                                'g.fila>text': {
                                    'font-size': 18,
                                    'font-weight': 800,
                                    fill: '#ffffff',
                                    'font-family': 'Roboto,sans-serif',
                                    'text-anchor': 'middle',
                                    x: 0,
                                    y: 15,
                                },
                                'g.fila>.icon-fila': {
                                    'ref-x': -7,
                                    'ref-y': -15,
                                },
                                'g.livre': {
                                    'ref-x': width + 10,
                                    'ref-y': 110,
                                    cursor: 'pointer'
                                },
                                'g.livre>circle': {
                                    r: 20,
                                    'stroke-width': 2,
                                    fill: '#0ea72c',
                                    stroke: '#ffffff',
                                },
                                'g.livre>text': {
                                    'font-size': 18,
                                    'font-weight': 800,
                                    fill: '#ffffff',
                                    'font-family': 'Roboto,sans-serif',
                                    'text-anchor': 'middle',
                                    x: 0,
                                    y: 15,
                                },
                                'g.livre>.icon-livre': {
                                    'ref-x': -9,
                                    'ref-y': -17,
                                }
                            }
                        };

                        /* Coloca valores padrões nas variáveis para não quebrar a lógica do restante do código */
                        if (!alertas) alertas = [];
                        if (!qtdFila) qtdFila = 0;
                        if (!qtdLivre) qtdLivre = 0;

                        /* Modifica o svg para corresponder ao ícone de acordo com o tipo de ura */
                        if (tipoUra == 'ramal') tipoSVG = UraHelper.iconeRamal;
                        else if (tipoUra == 'grupo') tipoSVG = UraHelper.iconeGrupo;
                        else if (tipoUra == 'servico') tipoSVG = UraHelper.iconeServico;
                        else if (tipoUra == 'menu' || tipoUra == 'avancado') tipoSVG = UraHelper.iconeMenu;
                        else if (tipoUra == 'ura') tipoSVG = UraHelper.iconeUra;
                        else if (tipoUra == 'desliga') tipoSVG = UraHelper.iconeDesliga;
                        else if (tipoUra == 'transferencia') tipoSVG = UraHelper.iconeTransferencia;
                        else if (tipoUra == 'integracao') tipoSVG = UraHelper.iconeIntegracao;

                        /* Popula os indicadores para o nó da ura */
                        if (indicadores != null) {
                            for (let i = 0; i < indicadores.Dados.length; i++) {
                                indicadoresText += '<text class="indicador-alias-' + (i + 1) + '">' + indicadores.Dados[i].Alias + '</text>'
                                indicadoresText += '<text class="indicador-value indicador-value-' + (i + 1) + '">' + $filter('formatByType')(indicadores.Dados[i].Valor, indicadores.Dados[i].TipoFormatacao) + '</text>'

                                cellObj.attrs['.indicador-alias-' + (i + 1)] = {
                                    'font-family': 'Roboto,sans-serif',
                                    'font-size': 11,
                                    'font-weight': 700,
                                    'word-spacing': '-1px',
                                    'letter-spacing': 0,
                                    'text-decoration': 'none',
                                    'ref-y': (Math.floor((i / 3) + 1)) * 40,
                                    'ref-x': ((i % 3) * 50) + 10,
                                };
                                cellObj.attrs['.indicador-value-' + (i + 1)] = {
                                    'font-family': 'Roboto,sans-serif',
                                    'font-size': 11,
                                    'font-weight': 700,
                                    'word-spacing': '-1px',
                                    'letter-spacing': 0,
                                    'text-decoration': 'none',
                                    'ref-y': ((Math.floor((i / 3)) + 1) * 40) + 15,
                                    'ref-x': ((i % 3) * 50) + 10,
                                };
                            }
                        }

                        /* Popula as informações do nó que serão exibidas */
                        joint.shapes.org.Member.prototype.markup = [
                            '<g class="rotatable" >',
                            '<g class="scalable">',
                            '<rect class="card view"/>',
                            '</g>',
                            `<g class="icon">${tipoSVG}</g>`,
                            `<g class="erro ${alertas.length > 0 ? '' : 'escondido'}"><circle class="erro"/><g class="icon-erro">${UraHelper.iconeErro}</g><text class="erro">${alertas.length}</text></g>`,
                            `<g class="fila ${(tipoUra == 'grupo' || tipoUra == 'menu' || tipoUra == 'ramal') ? '' : 'escondido'}"><circle class="fila"/><g class="icon-fila">${UraHelper.iconeFila}</g><text class="fila">${qtdFila || 0}</text></g>`,
                            `<g class="livre ${(tipoUra == 'grupo') ? '' : 'escondido'}"><circle class="livre"/><g class="icon-livre">${UraHelper.iconeLivre}</g><text class="livre">${qtdLivre || 0}</text></g>`,
                            '<text class="descricao"/>',
                            indicadoresText,
                            '</g>'
                        ].join('');

                        /* Adiciona a célula (que corresponde ao nó) ao diagrama de árvore */
                        let cell = new joint.shapes.org.Member(cellObj);
                        $scope.graph.addCell(cell);

                        /* Se possuir alertas para o nó muda a cor de fundo para vermelho */
                        if (alertas.length > 0) {
                            for (let i = 0; i < alertas.length; i++) {
                                alertas[i].no = cell.id;
                                alertasPorNo.push(alertas[i]);
                            }
                            addClass($('g[model-id=\'' + cell.id + '\']')[0], 'danger');
                        }

                        return cell;
                    }

                    /* Configuração de links entre os nós do diagrama de árvoce */
                    function plotLink(source, target) {
                        let link = new joint.dia.Link({
                            source: {
                                id: source.id
                            },
                            target: {
                                id: target.id
                            },
                            router: {
                                name: 'manhattan',
                            },
                            connector: {
                                name: 'normal'
                            },
                            attrs: {
                                '.connection': {
                                    'fill': 'none',
                                    'stroke-width': '2',
                                    'stroke': '#595697'
                                },
                                '.marker-target': {
                                    fill: '#cdcdcd',
                                    d: 'M 10 0 L 0 5 L 10 10 z'
                                }
                            }
                        });
                        $scope.graph.addCell(link);
                        return link;
                    }

                    /* Função que retorna o id do ramal com base no id do grupo */
                    function getRamalByGrupoId(grupoId) {
                        let grupo = grupos.find(g => g.GrupoId == grupoId);
                        return grupo ? grupo.RamalId : 0;
                    }

                    /* Verifica se o nó é a raiz da ura ou não para aplicar lógicas diferentes em sua criação */
                    function plotArvoreExistente(ura) {
                        let novoNo = null;

                        if (ura.ParentUra == null) {
                            /* Criação da ura raiz */
                            $scope.paper.setOrigin(ura.DadosNo.x, ura.DadosNo.y);

                            let indicadores = [];
                            if (indicadoresGlobal != null) {
                                indicadores = _.find(indicadoresGlobal, el => el.CampoId == ura.UraId);
                                $scope.indicadoresLegenda = indicadores.Dados;
                            }

                            /* Cria efetivamente o menu raiz da ura */
                            let noPrincipal = plotNo(ura.DadosNo.x, ura.DadosNo.y, tamanhoNoX, tamanhoNoY, ura.Descricao + ' (Raiz)', 'menu', null, indicadores);
                            noPorUra[ura.UraId] = noPrincipal;
                            ramaisGrupoUra.push({ RamalId: ura.Servico.RamalId, UraId: ura.UraId });
                            ura.DadosPlot = noPrincipal;
                            ura.TipoUra = 'menu';

                            /* Configura inicialmente como o nó selecionado */
                            addClass($('g[model-id=\'' + noPrincipal.id + '\']')[0], 'no-selecionado');
                            noSelecionado = noPrincipal;
                            uraSelecionada = ura;
                        } else {
                             /* Criação de nós da ura */
                            let descricaoNo, digitoTexto = '', qtdLivre = null, qtdFila = null, alertas = [], indicadores = [];
                            let tipoUra = _.find(UraHelper.tiposUra, el => el.TipoId == ura.UraTipoId).Descricao;

                            if (tipoUra == 'ramal' || tipoUra == 'servico' || tipoUra == 'integracao' || tipoUra == 'ura') {
                                descricaoNo = ura.DadosNo.descricao;
                            } else if (tipoUra == 'grupo') {
                                descricaoNo = ura.DadosNo.descricao;
                                let ramalIdGrupo = getRamalByGrupoId(ura.GrupoId);
                                if (ramalIdGrupo > 0) {
                                    qtdFila = qtdFilaPorRamal[ramalIdGrupo] ? qtdFilaPorRamal[ramalIdGrupo] : 0;
                                    qtdLivre = qtdLivrePorRamal[ramalIdGrupo] ? qtdLivrePorRamal[ramalIdGrupo] : 0;

                                    if (!(ramaisGrupoUra.find(x => x.RamalId == ramalIdGrupo))) {
                                        ramaisGrupoUra.push({ RamalId: ramalIdGrupo, UraId: ura.UraId });
                                    }
                                }
                            } else if (tipoUra == 'menu') {
                                descricaoNo = 'Escolha de Dígito';
                            } else if (tipoUra == 'desliga') {
                                descricaoNo = 'Desliga a URA';
                            }

                            if (ura.Botao) digitoTexto = 'Dígito ' + ura.Botao;
                            else digitoTexto = ura.DigitoTexto || ura.Botao;

                            /* Verifica se existem alertas e quais são os indicadores deste nó */
                            if (alertasGlobal != null) alertas = _.filter(alertasGlobal, el => el.MenuNo == ura.UraId);
                            if (indicadoresGlobal != null) indicadores = _.find(indicadoresGlobal, el => el.CampoId == ura.UraId);

                            /* Criação do nó no diagra de árvore */
                            noSelecionado = UraHelper.buscarIdemUra($scope.ura, ura.ParentUra.UraId).DadosPlot;
                            novoNo = adicionarNovoNo(ura.DadosNo.x, ura.DadosNo.y, descricaoNo, digitoTexto, tipoUra, alertas, indicadores, qtdFila, qtdLivre, ura);
                            noPorUra[ura.UraId] = novoNo;
                        }

                        /* Cria os nós filhos do nó que foi criado acima, caso existam */
                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            plotArvoreExistente(ura.ChildUra[i]);
                        }

                        return novoNo;
                    }

                    /* Método para remover estilo do nó que indica que ele está selecionado */
                    function limparSelecionado() {
                        uraSelecionada = null;
                        servicoSelecionado = null;
                        noSelecionado = null;
                        for (let i = 0; i < $('#ura-builder-full g').length; i++) {
                            removeClass($('#ura-builder-full g')[i], 'no-selecionado');
                        }
                    }

                    /* Criação de nós relacionados à ura raiz ou a submenus de ura */
                    function adicionarNovoNo(posicaoX, posicaoY, descricaoNo, digito, tipoUra, alertas, indicadores, qtdFila, qtdLivre, uraExistente) {
                        let uraPai = UraHelper.buscarNoemUra($scope.ura, noSelecionado);
                        let tipoTransferencia = null;

                        if (digito && isNaN(digito)) digito = null;

                        let uraTipoId = _.find(UraHelper.tiposUra, el => { return el.Descricao == tipoUra }).TipoId;
                        let novoNo = plotNo(posicaoX, posicaoY, tamanhoNoX, tamanhoNoY, descricaoNo, tipoUra, alertas, indicadores, qtdFila, qtdLivre);

                        if (tipoUra == 'servico' || tipoUra == 'ramal' || tipoUra == 'grupo' || tipoUra == 'ura') {
                            tipoTransferencia = tipoUra;
                            tipoUra = 'transferencia';
                        }

                        plotLink(noSelecionado, novoNo);

                        if (uraExistente == null) {
                            let novaUra = {
                                DadosPlot: novoNo,
                                ChildUra: [],
                                ParentUra: uraPai,
                                Botao: digito,
                                TipoUra: tipoUra,
                                UraTipoId: uraTipoId,
                                TipoTransferencia: tipoTransferencia
                            }
                            if (!uraPai.ChildUra) uraPai.ChildUra = [];

                            uraPai.ChildUra.push(novaUra);
                            if (uraPai.TipoUra == 'integracao') {
                                let index = _.indexOf(uraPai.UraCondicao, $scope.condicaoEditada);
                                uraPai.UraCondicao[index].RedirecionaUra = novaUra;
                            }
                            if (tipoUra == 'integracao') {
                                $scope.ura.TipoUra = 'avancado';
                                $scope.ura.UraTipoId = 7;
                            }
                        } else {
                            uraExistente.TipoUra = tipoUra;
                            uraExistente.DadosPlot = novoNo;
                            uraExistente.ParentUra = uraPai;
                            uraExistente.TipoTransferencia = tipoTransferencia;
                        }
                        return novoNo;
                    }

                    function recriarReferenciaPai(ura) {
                        if (ura.ParentUra != null) {
                            let uraPai = UraHelper.buscarIdemUra($scope.ura, ura.ParentUraId);
                            if (uraPai != null) ura.ParentUra = uraPai;
                        }

                        /* População dos dicionários com informações dos ramais */
                        if (ura.GrupoId != null) gruposUra.push(ura.GrupoId);
                        if (ura.RamalId != null) ramaisUra.push(ura.RamalId);
                        if (ura.Servico.RamalId != null) ramaisUra.push(ura.Servico.RamalId);

                        for (let i = 0; i < ura.ChildUra.length; i++) {
                            recriarReferenciaPai(ura.ChildUra[i]);
                        }
                    }

                    /* Recarrega os dados da árvore ao modificar o filtro de data em tela */
                    function reloadArvore($event, dados) {
                        $scope.data.filtro.dataInicio = dados.dataInicio;
                        $scope.data.filtro.dataFim = dados.dataFim;
                        promiseIndicadores = [];
                        promiseIndicadores.push(DashboardReceptivoService.getIndicadoresArvore($scope.data.filtro.id, $scope.data.filtro.tipo));
                        promiseIndicadores.push(DashboardReceptivoService.getArvoreDetalhe($scope.data.filtro.tipo, $scope.data.filtro.id, $scope.data.filtro.dataInicio, $scope.data.filtro.dataFim, $scope.data.filtro.carteiraId, $scope.data.filtro.grupoId));
                        getArvore();
                    }

                    getArvore();

                    const offDataSelecionadaArvore = $rootScope.$on('onDataSelecionadaArvore', reloadArvore);
                    $scope.$on('$destroy', function () {
                        offDataSelecionadaArvore();
                        if (timerSupervisao != null) {
                            clearTimeout(timerSupervisao);
                            timerSupervisao = null;
                        }
                    });
                }]
            };
        });
})();